(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function FrameCompatibility() {}
var cloudflowVersionInfo = null;
var frameOSVersionInfo = null;
var frameHostVersionInfo = null;
FrameCompatibility.prototype = {
  constructor: FrameCompatibility,
  isFrameOSCompatibleWithCloudflow: function isFrameOSCompatibleWithCloudflow(pCallback) {
    var that = this;
    var checkCallback = pCallback;
    this._getVersions(function () {
      if (cloudflowVersionInfo !== null && cloudflowVersionInfo.trueMinor !== undefined && frameOSVersionInfo !== null && frameOSVersionInfo.compatibility !== undefined && frameOSVersionInfo.compatibility.cloudflow !== undefined) {
        checkCallback(true, cloudflowVersionInfo.trueMinor >= frameOSVersionInfo.compatibility.cloudflow.trueMinor);
      } else {
        checkCallback(false, false);
      }
    });
  },
  isFrameHostCompatibleWithCloudflow: function isFrameHostCompatibleWithCloudflow(pCallback) {
    var that = this;
    var checkCallback = pCallback;
    this._getVersions(function () {
      if (cloudflowVersionInfo !== null && cloudflowVersionInfo.trueMinor !== undefined && frameHostVersionInfo !== null && frameHostVersionInfo.compatibility !== undefined && frameHostVersionInfo.compatibility.cloudflow !== undefined) {
        checkCallback(true, cloudflowVersionInfo.trueMinor >= frameHostVersionInfo.compatibility.cloudflow.trueMinor);
      } else {
        checkCallback(false, false);
      }
    });
  },
  isCloudflowCompatibleWithFrameOS: function isCloudflowCompatibleWithFrameOS(pCallback) {
    var that = this;
    var checkCallback = pCallback;
    this._getVersions(function () {
      if (frameOSVersionInfo !== null && frameOSVersionInfo.version !== undefined && cloudflowVersionInfo !== null && cloudflowVersionInfo.compatibility !== undefined && cloudflowVersionInfo.compatibility.frame !== undefined) {
        checkCallback(true, that._compareMajorAndMinor(frameOSVersionInfo.version.major, frameOSVersionInfo.version.minor, cloudflowVersionInfo.compatibility.frame.major, cloudflowVersionInfo.compatibility.frame.minor));
      } else {
        checkCallback(false, false);
      }
    });
  },
  isCloudflowCompatibleWithFrameHost: function isCloudflowCompatibleWithFrameHost(pCallback) {
    var that = this;
    var checkCallback = pCallback;
    this._getVersions(function () {
      if (frameHostVersionInfo !== null && frameHostVersionInfo.version !== undefined && cloudflowVersionInfo !== null && cloudflowVersionInfo.compatibility !== undefined && cloudflowVersionInfo.compatibility.frame !== undefined) {
        checkCallback(true, that._compareMajorAndMinor(frameHostVersionInfo.version.major, frameHostVersionInfo.version.minor, cloudflowVersionInfo.compatibility.frame.major, cloudflowVersionInfo.compatibility.frame.minor));
      } else {
        checkCallback(false, false);
      }
    });
  },
  _getVersions: function _getVersions(pCallBack) {
    var that = this;
    if (cloudflowVersionInfo === null) {
      api_async.portal.version(function (pResult) {
        cloudflowVersionInfo = pResult;
        if (cloudflowVersionInfo.major !== undefined) {
          cloudflowVersionInfo.trueMinor = cloudflowVersionInfo.major * 100 + cloudflowVersionInfo.minor;
        }
        // try again after loading
        that._getVersions(pCallBack);
      });
      return;
    }
    if (frameOSVersionInfo === null) {
      api_async.frame.os.get().done(function () {
        api_async.frame.os.get_version(function (pResult) {
          frameOSVersionInfo = pResult;
          if (frameOSVersionInfo.compatibility !== undefined && frameOSVersionInfo.compatibility.cloudflow !== undefined) {
            frameOSVersionInfo.compatibility.cloudflow.trueMinor = frameOSVersionInfo.compatibility.cloudflow.major * 100 + frameOSVersionInfo.compatibility.cloudflow.minor;
          }
          // try again after loading
          that._getVersions(pCallBack);
        });
        return;
      });
    }
    if (frameHostVersionInfo === null) {
      api_async.frame.host.get().done(function () {
        api_async.frame.host.get_version(function (pResult) {
          frameHostVersionInfo = pResult;
          if (frameHostVersionInfo.compatibility !== undefined && frameHostVersionInfo.compatibility.cloudflow !== undefined) {
            frameHostVersionInfo.compatibility.cloudflow.trueMinor = frameHostVersionInfo.compatibility.cloudflow.major * 100 + frameHostVersionInfo.compatibility.cloudflow.minor;
          }
          // try again after loading
          that._getVersions(pCallBack);
        });
        return;
      });
    }

    // if we come here we have loaded whatever we can load (or we simply have
    // all the versions
    pCallBack();
  },
  _compareMajorAndMinor: function _compareMajorAndMinor(pLeftMajor, pLeftMinor, pRightMajor, pRightMinor) {
    if (pLeftMajor === pRightMajor) {
      if (pLeftMinor >= pRightMinor) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
};
FrameCompatibility.clear = function () {
  cloudflowVersionInfo = null;
  frameOSVersionInfo = null;
  frameHostVersionInfo = null;
};
module.exports = FrameCompatibility;

},{}],2:[function(require,module,exports){
"use strict";

/**
 * known events
 * - hostAPILoaded
 *   - when : after the host api has been succesfully loaded into the api objects.
 *   - data: none
 * - loadedFilesChanged
 *   - when : after a document has been opened/closed/saved etc. That is, each time the result
 *            of calling list_loaded_files() will return different results
 *   - data: none
 * - setCloudflowSession
 *   - when : after a session expired, and a new session could be created automatically
 *   - data:
 *     - session: the new session string
 **/
function FrameHostEventManager() {}
var eventRegistry = {};
var entryCount = 1;
var hostCallback = undefined;
FrameHostEventManager.prototype = {
  constructor: FrameHostEventManager,
  on: function on(pEvent, pCallback) {
    var eventEntry = [];
    if (pEvent in eventRegistry === false) {
      eventRegistry[pEvent] = [];
    }
    eventEntry = eventRegistry[pEvent];
    var entryID = entryCount++;
    eventEntry.push({
      id: entryID,
      callback: pCallback
    });
    return function () {
      api.frame.host.eventManager.remove(entryID);
    };
  },
  fire: function fire(pEvent, pData) {
    if (pEvent === "setCloudflowSession") {
      api.set_session(pData.session);
    }
    if (pEvent in eventRegistry === true) {
      var eventEntry = eventRegistry[pEvent];
      for (var countEntrys = 0; countEntrys < eventEntry.length; ++countEntrys) {
        eventEntry[countEntrys].callback(pData);
      }
    }
    if (hostCallback !== undefined) {
      hostCallback(pEvent, pData);
    }
  },
  remove: function remove(pEntryID) {
    for (var keyName in eventRegistry) {
      var eventEntry = eventRegistry[keyName];
      for (var countEntrys = 0; countEntrys < eventEntry.length; ++countEntrys) {
        if (eventEntry[countEntrys].id === pEntryID) {
          eventEntry.splice(countEntrys, 1);
          return;
        }
      }
    }
  },
  registerHostCallback: function registerHostCallback(pCallback) {
    hostCallback = pCallback;
  }
};
module.exports = FrameHostEventManager;

},{}],3:[function(require,module,exports){
"use strict";

/**
 * Returns a promise that resolves in case that the Cloudflow version is compatible with Frame
 * @private
 */
function isCompatible(pCompatibleCloudflowVersion) {
  return new Promise(function (pResolve, pReject) {
    api_async.portal.version(function (pResult) {
      var cloudflowMajor = pResult.major;
      var cloudflowMinor = pResult.minor;
      var cloudflowVersion = cloudflowMajor * 100 + cloudflowMinor;
      if (cloudflowVersion >= pCompatibleCloudflowVersion) {
        pResolve();
      } else {
        var code = "Cloudflow not compatible";
        var description = "The running Cloudflow is not compatible with Frame, need at least " + pCompatibleCloudflowVersion;
        pReject({
          error_code: code,
          error: description,
          messages: [{
            type: code,
            severity: "error",
            description: description
          }]
        });
      }
    }, pReject);
  });
}
function FrameHostLoader() {
  this.m_promise = {};
}
FrameHostLoader.prototype = {
  constructor: FrameHostLoader,
  /**
   * Resolves the promise in case the page is running inside a host
   * @param {*} pHost name of the host the page is running in ("illustrator", "packz", "ic3d")
   * @param {*} pParent parent api that to which the promise will resolve (eg api, api_async)
   * @param {*} pForceVersion set to true if you want to override the compatibility check
   */
  get: function get(pHost, pParent, pForceVersion) {
    var that = this;
    if (this.m_promise[pHost] === undefined) {
      if (pHost === "illustrator") {
        this.m_promise["illustrator"] = new Promise(function (pResolve, pReject) {
          that._loadIllustrator(function () {
            pResolve(pParent);
          }, function (pError) {
            pReject(pError || {
              error_code: "load_illustrator_failed"
            });
          }, pForceVersion);
        });
      } else if (pHost === "packz") {
        this.m_promise["packz"] = new Promise(function (pResolve, pReject) {
          that._loadPackz(function () {
            pResolve(pParent);
          }, function (pError) {
            pReject(pError || {
              error_code: "load_packz_failed"
            });
          }, pForceVersion);
        });
      } else if (pHost === "ic3d") {
        this.m_promise["ic3d"] = new Promise(function (pResolve, pReject) {
          that._loadiC3D(function () {
            pResolve(pParent);
          }, function (pError) {
            pReject(pError || {
              error_code: "load_ic3d_failed"
            });
          }, pForceVersion);
        });
      } else {
        console.error("unknown host", pHost);
        return Promise.reject("no such host: " + pHost);
      }
    }
    if (window.$ !== undefined) {
      return $.when(this.m_promise[pHost]);
    }
    return this.m_promise[pHost];
  },
  load: function load(pHost, pCallback, pCallbackError) {
    if (pHost === "illustrator") {
      this._loadIllustrator(pCallback, pCallbackError);
    } else if (pHost === "packz") {
      this._loadPackz(pCallback, pCallbackError);
    } else if (pHost === "ic3d") {
      this._loadiC3D(pCallback, pCallbackError);
    } else {
      console.error("unknown host " + pHost + " to load");
    }
  },
  _loadIllustrator: function _loadIllustrator(pCallback, pCallbackError, pForceVersion) {
    try {
      // add the listener to react on the bootstrap string (and install the API)
      window.__adobe_cep__.addEventListener("com.nixps.csxs.events.callAPIFunctionResult", function (pEvent) {
        if (pEvent.appId === "frame.host.get_api_bootstrap") {
          if (pEvent.data.javascript !== undefined) {
            var install = new Function(pEvent.data.javascript);
            // Always install the api calls as we need to report an error eventually with show_status_messages
            install();

            // #29894: Redefine "get" as it gets lost after the install
            window.api_defer.frame.host.get = function (pHost, pOptions) {
              var parent = this.m_parent;
              var outputPromise = new Promise(function (pResolve, pReject) {
                window.frameHostLoader.get(pHost, parent, pForceVersion).then(pResolve, pReject);
              }).then(function (pApi) {
                return pApi;
              });
              if (window.$ !== undefined) {
                return $.when(outputPromise);
              }
              return outputPromise;
            };
            if (pForceVersion === true) {
              api.frame.host.eventManager.fire("hostAPILoaded", {});
              if (pCallback !== undefined) {
                pCallback();
              }
              return;
            }
            var compatibleCloudflowVersion = pEvent.data.compatibleCloudflowVersion;
            if (compatibleCloudflowVersion !== undefined) {
              isCompatible(compatibleCloudflowVersion).then(function () {
                api.frame.host.eventManager.fire("hostAPILoaded", {});
                if (pCallback !== undefined) {
                  pCallback();
                }
              })["catch"](function (pError) {
                try {
                  api_defer.frame.host.show_status_messages(pError.messages);
                } catch (error) {
                  console.error(error);
                }
                if (pCallbackError !== undefined) {
                  pCallbackError(pError);
                }
                return Promise.reject(pError);
              });
            } else {
              api.frame.host.eventManager.fire("hostAPILoaded", {});
              if (pCallback !== undefined) {
                pCallback();
              }
            }
          }
        }
      }, this);
      window.__adobe_cep__.addEventListener("com.nixps.csxs.events.frameHostEvent", function (pEvent) {
        if (pEvent.appId === "Illustrator-Frame" && (pEvent.extensionId === null || pEvent.extensionId === "")) {
          api.frame.host.eventManager.fire(pEvent.data.event, pEvent.data.data);
        }
      }, this);

      // and now trigger the event that should return us the bootstrap string
      var getAPIBootstrap = {
        type: "com.nixps.csxs.events.callAPIFunction",
        scope: "APPLICATION",
        appId: "ILST",
        extensionID: "com.nixps.illustrator.HybridFrameClient.api"
      };
      getAPIBootstrap.data = JSON.stringify({
        method: "frame.host.get_api_bootstrap"
      });
      window.__adobe_cep__.dispatchEvent(getAPIBootstrap);
      api.frame.host.eventManager.registerHostCallback(this._illustratorEventManagerCallback);
    } catch (err) {
      // not running inside illustrator...
      pCallbackError(err);
    }
  },
  _illustratorEventManagerCallback: function _illustratorEventManagerCallback(pEvent, pData) {
    var frameHostEvent = {
      type: "com.nixps.csxs.events.frameHostedPageEvent",
      scope: "APPLICATION",
      appId: "ILST",
      extensionID: "com.nixps.illustrator.frame.hostEvents"
    };
    frameHostEvent.data = JSON.stringify({
      event: pEvent,
      data: pData
    });
    window.__adobe_cep__.dispatchEvent(frameHostEvent);
  },
  _loadPackz: function _loadPackz(pCallback, pCallbackError, pForceVersion) {
    try {
      var doInstall = function doInstall() {
        window.packz_init.install(function (bootstrapCode) {
          var install = new Function(bootstrapCode);
          install();

          // #29894: Redefine "get" as it gets lost after the install
          window.api_defer.frame.host.get = function (pHost, pOptions) {
            var parent = this.m_parent;
            var outputPromise = new Promise(function (pResolve, pReject) {
              window.frameHostLoader.get(pHost, parent, pForceVersion).then(pResolve, pReject);
            }).then(function (pApi) {
              return pApi;
            });
            if (window.$ !== undefined) {
              return $.when(outputPromise);
            }
            return outputPromise;
          };
          api.frame.host.eventManager.fire("hostAPILoaded", {});
          if (pCallback !== undefined) {
            pCallback();
          }
        });
      };
      if (pForceVersion === true) {
        doInstall();
      } else {
        window.packz_init.getCompatibleCloudflowVersion(function (compatibleCloudflowVersion) {
          if (compatibleCloudflowVersion !== undefined) {
            isCompatible(compatibleCloudflowVersion).then(function () {
              doInstall();
            })["catch"](function (error) {
              if (pCallbackError !== undefined) {
                pCallbackError(error);
              }
              return Promise.reject(error);
            });
          } else {
            doInstall();
          }
        });
      }
      api.frame.host.eventManager.registerHostCallback(this._packzEventManagerCallback);
    } catch (err) {
      // not running inside packz...
      pCallbackError(err);
    }
  },
  _packzEventManagerCallback: function _packzEventManagerCallback(pEvent, pData) {
    var frameHostEventdata = JSON.stringify({
      event: pEvent,
      data: pData
    });
    window.packz_init.dispatchEvent(frameHostEventdata);
  },
  _ic3dEventManagerCallback: function _ic3dEventManagerCallback(pEvent, pData) {
    var frameHostEventdata = JSON.stringify({
      event: pEvent,
      data: pData
    });
    window.ic3diface.dispatchEvent(frameHostEventdata);
  },
  _loadiC3D: function _loadiC3D(pCallback, pCallbackError, pForceVersion) {
    try {
      var doInstall = function doInstall() {
        window.ic3diface.install(function (bootstrapCode) {
          var install = new Function(bootstrapCode);
          install();

          // #29894: Redefine "get" as it gets lost after the install
          window.api_defer.frame.host.get = function (pHost, pOptions) {
            var parent = this.m_parent;
            var outputPromise = new Promise(function (pResolve, pReject) {
              window.frameHostLoader.get(pHost, parent, pForceVersion).then(pResolve, pReject);
            }).then(function (pApi) {
              return pApi;
            });
            if (window.$ !== undefined) {
              return $.when(outputPromise);
            }
            return outputPromise;
          };
          api.frame.host.eventManager.fire("hostAPILoaded", {});
          if (pCallback !== undefined) {
            pCallback();
          }
        });
      };
      new QWebChannel(qt.webChannelTransport, function (channel) {
        window.ic3diface = channel.objects.ic3diface;
        window.ic3diface.getCompatibleCloudflowVersion(function (compatibleCloudflowVersion) {
          if (compatibleCloudflowVersion !== undefined) {
            isCompatible(compatibleCloudflowVersion).then(function () {
              // Start install of bootstrap
              doInstall();
            })["catch"](function (error) {
              if (pCallbackError !== undefined) {
                pCallbackError(error);
              }
              return Promise.reject(error);
            });
          }
        });
      });

      // Register event manager
      api.frame.host.eventManager.registerHostCallback(this._ic3dEventManagerCallback);
    } catch (err) {
      // not running inside ic3d...
      pCallbackError(err);
    }
  }
};
module.exports = FrameHostLoader;

},{}],4:[function(require,module,exports){
"use strict";

var FrameHostEventManager = require("./FrameHostEventManager.js");
var FrameHostLoader = require("./FrameHostLoader.js");
var FrameCompatibility = require("./FrameCompatibility.js");
if (window.frameHostLoader !== undefined) {
  console.error("frame.js is already loaded");
}
window.FrameHostLoader = FrameHostLoader;
window.FrameHostEventManager = FrameHostEventManager;
window.FrameCompatibility = FrameCompatibility;
window.frameHostLoader = new FrameHostLoader();
function runSetFeatures() {
  var setFrameFeatures = require("./setFrameFeatures.js");
  setFrameFeatures();
}
if (window.api === undefined || window.api.frame === undefined) {
  console.error("frame.js: cloudflow api should be included first");
} else {
  api.frame.host.eventManager = new FrameHostEventManager();

  // Check the frame features
  if (window.jQuery === undefined) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", runSetFeatures);
    } else {
      runSetFeatures();
    }
  } else {
    $(function () {
      runSetFeatures();
    });
  }
}

},{"./FrameCompatibility.js":1,"./FrameHostEventManager.js":2,"./FrameHostLoader.js":3,"./setFrameFeatures.js":5}],5:[function(require,module,exports){
"use strict";

/**
 * @private
 */
function _hasMappings(filestoreSetups) {
  return Array.isArray(filestoreSetups) === true && filestoreSetups.length > 0;
}

/**
 * @private
 */
function _hasPackz(apps) {
  if (Array.isArray(apps) === false) {
    return false;
  }
  for (var i = 0; i < apps.length; i++) {
    var current = apps[i];
    if (current.name === "PACKZ" && current.path_is_valid === true) {
      return true;
    }
  }
  return false;
}

/**
 * Sets the frame features when frame is installed
 */
function setFrameFeatures() {
  var installPromise, enablePromise, hostEnablePromise;
  installPromise = api_defer.frame.os.get().then(function () {
    document.body.classList.add("frame-os-installed");
  })["catch"](function (pError) {
    document.body.classList.remove("frame-os-installed");
    // swallow errors, otherwise the macro's and automatic testings will fail...
    if (window.jQuery && jQuery.fn.jquery === "1.8.3") {
      // in case of older jquery the deferred process is different, enforce to be good and swallowed
      return $.Deferred().resolve("force_to_be_good");
    }
  });
  enablePromise = api_defer.frame.os.get().then(function () {
    return api_defer.frame.os.is_active_cloudflow_server(window.location.href);
  }).then(function (matches) {
    if (matches.match === false) {
      if (window.jQuery && jQuery.fn.jquery === "1.8.3") {
        return $.Deferred().reject("Frame server does not match");
      } else {
        return Promise.reject("Frame server does not match");
      }
    }
    return api_defer.frame.os.get_workstation_setup();
  }).then(function (setup) {
    if (setup && setup.setup && _hasPackz(setup.setup.applications)) {
      document.body.classList.add("frame-packz-app-enabled");
    } else {
      document.body.classList.remove("frame-packz-app-enabled");
    }
    if (setup && setup.setup && _hasMappings(setup.setup.filestore_setups)) {
      document.body.classList.add("frame-os-enabled");
    } else {
      document.body.classList.remove("frame-os-enabled");
    }
  })["catch"](function (pError) {
    document.body.classList.remove("frame-os-enabled");
    // swallow errors, otherwise the macro's and automatic testings will fail...
    if (window.jQuery && jQuery.fn.jquery === "1.8.3") {
      // in case of older jquery the deferred process is different, enforce to be good and swallowed
      return $.Deferred().resolve("force_to_be_good");
    }
    // return Promise.reject(pError);
  });

  hostEnablePromise = {};
  var matches = window.location.href.match(/host=([^&]*)/);
  if (Array.isArray(matches) && matches.length >= 2) {
    var matchGroup = matches[1];
    hostEnablePromise = api_defer.frame.host.get(matchGroup).then(function () {
      document.body.classList.add("frame-host-enabled");

      // Show a relevant error message when in Illustrator and frame os did not initialize correctly
      return api_defer.frame.os.get().then(function () {
        return api_defer.frame.os.is_active_cloudflow_server(window.location.href).then(function (matches) {
          if (matches.match === false) {
            return Promise.reject({
              messages: [{
                type: "frame configuration server does not match",
                description: "This page is not served from the Frame-Cloudflow server in the settings",
                severity: "error"
              }]
            });
          }
        });
      })["catch"](function (pError) {
        if (pError && pError.messages) {
          try {
            api_defer.frame.host.show_status_messages(pError.messages);
          } catch (e) {
            console.error(pError);
          }
        } else {
          console.error(pError);
        }
        if (window.jQuery && jQuery.fn.jquery === "1.8.3") {
          return $.Deferred().reject(pError);
        } else {
          return Promise.reject(pError);
        }
      });
    })["catch"](function (pError) {
      document.body.classList.remove("frame-host-enabled");
    });
  }
  return Promise.all([installPromise, enablePromise, hostEnablePromise]);
}
module.exports = setFrameFeatures;

},{}],6:[function(require,module,exports){
"use strict";

/**
 * Detect Element Resize Plugin for jQuery
 *
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * sdecima/javascript-detect-element-resize is licensed under the MIT License
 * version: 0.5.3
 **/

(function ($) {
  var attachEvent = document.attachEvent,
    stylesCreated = false;
  var jQuery_onresize = $.fn.onresize;
  $.fn.onresize = function (callback) {
    return this.each(function () {
      if (this == window) jQuery_onresize.call(jQuery(this), callback);else addResizeListener(this, callback);
    });
  };
  $.fn.removeOnResize = function (callback) {
    return this.each(function () {
      removeResizeListener(this, callback);
    });
  };
  if (!attachEvent) {
    var _resetTriggers = function _resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
        expand = triggers.firstElementChild,
        contract = triggers.lastElementChild,
        expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };
    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };
    var _scrollListener = function _scrollListener(e) {
      var element = this;
      _resetTriggers(this);
      if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    var requestFrame = function () {
      var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
        return window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();
    var cancelFrame = function () {
      var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();
    ;
    ;

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
      animationstring = 'animation',
      keyframeprefix = '',
      animationstartevent = 'animationstart',
      domPrefixes = 'Webkit Moz O ms'.split(' '),
      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
      pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }
      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            animationstring = pfx + 'Animation';
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }
  function createStyles() {
    if (!stylesCreated) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');
      style.type = 'text/css';
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
      head.appendChild(style);
      stylesCreated = true;
    }
  }
  window.addResizeListener = function (element, fn) {
    if (attachEvent) element.attachEvent('onresize', fn);else {
      if (!element.__resizeTriggers__) {
        if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
        createStyles();
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
          if (e.animationName == animationName) resetTriggers(element);
        });
      }
      element.__resizeListeners__.push(fn);
    }
  };
  window.removeResizeListener = function (element, fn) {
    if (attachEvent) element.detachEvent('onresize', fn);else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener);
        element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
      }
    }
  };
})(jQuery);

},{}],7:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* Port of strftime() by T. H. Doan (https://thdoan.github.io/strftime/)
 *
 * Day of year (%j) code based on Joe Orost's answer:
 * http://stackoverflow.com/questions/8619879/javascript-calculate-the-day-of-the-year-1-366
 *
 * Week number (%V) code based on Taco van den Broek's prototype:
 * http://techblog.procurios.nl/k/news/view/33796/14863/calculate-iso-8601-week-and-year-in-javascript.html
 */
(function () {
  function strftime(sFormat, date) {
    if (!(date instanceof Date)) date = new Date();
    var nDay = date.getDay(),
      nDate = date.getDate(),
      nMonth = date.getMonth(),
      nYear = date.getFullYear(),
      nHour = date.getHours(),
      aDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      aMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      aDayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
      isLeapYear = function isLeapYear() {
        return nYear % 4 === 0 && nYear % 100 !== 0 || nYear % 400 === 0;
      },
      getThursday = function getThursday() {
        var target = new Date(date);
        target.setDate(nDate - (nDay + 6) % 7 + 3);
        return target;
      },
      zeroPad = function zeroPad(nNum, nPad) {
        return (Math.pow(10, nPad) + nNum + '').slice(1);
      };
    return sFormat.replace(/%[a-z]/gi, function (sMatch) {
      return ({
        '%a': aDays[nDay].slice(0, 3),
        '%A': aDays[nDay],
        '%b': aMonths[nMonth].slice(0, 3),
        '%B': aMonths[nMonth],
        '%c': date.toUTCString(),
        '%C': Math.floor(nYear / 100),
        '%d': zeroPad(nDate, 2),
        '%e': nDate,
        '%F': date.toISOString().slice(0, 10),
        '%G': getThursday().getFullYear(),
        '%g': (getThursday().getFullYear() + '').slice(2),
        '%H': zeroPad(nHour, 2),
        '%I': zeroPad((nHour + 11) % 12 + 1, 2),
        '%j': zeroPad(aDayCount[nMonth] + nDate + (nMonth > 1 && isLeapYear() ? 1 : 0), 3),
        '%k': nHour,
        '%l': (nHour + 11) % 12 + 1,
        '%m': zeroPad(nMonth + 1, 2),
        '%n': nMonth + 1,
        '%M': zeroPad(date.getMinutes(), 2),
        '%p': nHour < 12 ? 'AM' : 'PM',
        '%P': nHour < 12 ? 'am' : 'pm',
        '%s': Math.round(date.getTime() / 1000),
        '%S': zeroPad(date.getSeconds(), 2),
        '%u': nDay || 7,
        '%V': function () {
          var target = getThursday(),
            n1stThu = target.valueOf();
          target.setMonth(0, 1);
          var nJan1 = target.getDay();
          if (nJan1 !== 4) target.setMonth(0, 1 + (4 - nJan1 + 7) % 7);
          return zeroPad(1 + Math.ceil((n1stThu - target) / 604800000), 2);
        }(),
        '%w': nDay,
        '%x': date.toLocaleDateString(),
        '%X': date.toLocaleTimeString(),
        '%y': (nYear + '').slice(2),
        '%Y': nYear,
        '%z': date.toTimeString().replace(/.+GMT([+-]\d+).+/, '$1'),
        '%Z': date.toTimeString().replace(/.+\((.+?)\)$/, '$1')
      }[sMatch] || '') + '' || sMatch;
    });
  }
  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module && _typeof(module.exports) === "object") {
    //loaders that implement the Node module pattern (including browserify)
    module.exports = strftime;
  } else {
    // Otherwise expose juration
    window.strftime = strftime;
  }
})();

},{}],8:[function(require,module,exports){
"use strict";

/**
 * @file timeline.js
 *
 * @brief
 * The Timeline is an interactive visualization chart to visualize events in
 * time, having a start and end date.
 * You can freely move and zoom in the timeline by dragging
 * and scrolling in the Timeline. Items are optionally dragable. The time
 * scale on the axis is adjusted automatically, and supports scales ranging
 * from milliseconds to years.
 *
 * Timeline is part of the CHAP Links library.
 *
 * Timeline is tested on Firefox 3.6, Safari 5.0, Chrome 6.0, Opera 10.6, and
 * Internet Explorer 6+.
 *
 * @license
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy
 * of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 *
 * Copyright (c) 2011-2015 Almende B.V.
 *
 * @author  Jos de Jong, <jos@almende.org>
 * @date    2015-03-04
 * @version 2.9.1
 */

/*
 * i18n mods by github user iktuz (https://gist.github.com/iktuz/3749287/)
 * added to v2.4.1 with da_DK language by @bjarkebech
 */

/*
 * TODO
 *
 * Add zooming with pinching on Android
 *
 * Bug: when an item contains a javascript onclick or a link, this does not work
 *      when the item is not selected (when the item is being selected,
 *      it is redrawn, which cancels any onclick or link action)
 * Bug: when an item contains an image without size, or a css max-width, it is not sized correctly
 * Bug: neglect items when they have no valid start/end, instead of throwing an error
 * Bug: Pinching on ipad does not work very well, sometimes the page will zoom when pinching vertically
 * Bug: cannot set max width for an item, like div.timeline-event-content {white-space: normal; max-width: 100px;}
 * Bug on IE in Quirks mode. When you have groups, and delete an item, the groups become invisible
 */

/**
 * Declare a unique namespace for CHAP's Common Hybrid Visualisation Library,
 * "links"
 */
if (typeof links === 'undefined') {
  window.links = {};
  // important: do not use var, as "var links = {};" will overwrite
  //            the existing links variable value with undefined in IE8, IE7.
}

/**
 * Ensure the variable google exists
 */
if (typeof google === 'undefined') {
  window.google = undefined;
  // important: do not use var, as "var google = undefined;" will overwrite
  //            the existing google variable value with undefined in IE8, IE7.
}

// Internet Explorer 8 and older does not support Array.indexOf,
// so we define it here in that case
// http://soledadpenades.com/2007/05/17/arrayindexof-in-internet-explorer/
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (obj) {
    for (var i = 0; i < this.length; i++) {
      if (this[i] == obj) {
        return i;
      }
    }
    return -1;
  };
}

// Internet Explorer 8 and older does not support Array.forEach,
// so we define it here in that case
// https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/forEach
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (fn, scope) {
    for (var i = 0, len = this.length; i < len; ++i) {
      fn.call(scope || this, this[i], i, this);
    }
  };
}

/**
 * @constructor links.Timeline
 * The timeline is a visualization chart to visualize events in time.
 *
 * The timeline is developed in javascript as a Google Visualization Chart.
 *
 * @param {Element} container   The DOM element in which the Timeline will
 *                              be created. Normally a div element.
 * @param {Object} options      A name/value map containing settings for the
 *                              timeline. Optional.
 */
links.Timeline = function (container, options) {
  if (!container) {
    // this call was probably only for inheritance, no constructor-code is required
    return;
  }

  // create variables and set default values
  this.dom = {};
  this.conversion = {};
  this.eventParams = {}; // stores parameters for mouse events
  this.groups = [];
  this.groupIndexes = {};
  this.items = [];
  this.renderQueue = {
    show: [],
    // Items made visible but not yet added to DOM
    hide: [],
    // Items currently visible but not yet removed from DOM
    update: [] // Items with changed data but not yet adjusted DOM
  };

  this.renderedItems = []; // Items currently rendered in the DOM
  this.clusterGenerator = new links.Timeline.ClusterGenerator(this);
  this.currentClusters = [];
  this.selection = undefined; // stores index and item which is currently selected

  this.listeners = {}; // event listener callbacks

  // Initialize sizes.
  // Needed for IE (which gives an error when you try to set an undefined
  // value in a style)
  this.size = {
    'actualHeight': 0,
    'axis': {
      'characterMajorHeight': 0,
      'characterMajorWidth': 0,
      'characterMinorHeight': 0,
      'characterMinorWidth': 0,
      'height': 0,
      'labelMajorTop': 0,
      'labelMinorTop': 0,
      'line': 0,
      'lineMajorWidth': 0,
      'lineMinorHeight': 0,
      'lineMinorTop': 0,
      'lineMinorWidth': 0,
      'top': 0
    },
    'contentHeight': 0,
    'contentLeft': 0,
    'contentWidth': 0,
    'frameHeight': 0,
    'frameWidth': 0,
    'groupsLeft': 0,
    'groupsWidth': 0,
    'items': {
      'top': 0
    }
  };
  this.dom.container = container;

  //
  // Let's set the default options first
  //
  this.options = {
    'width': "100%",
    'height': "auto",
    'minHeight': 0,
    // minimal height in pixels
    'groupMinHeight': 0,
    'autoHeight': true,
    'eventMargin': 10,
    // minimal margin between events
    'eventMarginAxis': 20,
    // minimal margin between events and the axis
    'dragAreaWidth': 10,
    // pixels

    'min': undefined,
    'max': undefined,
    'zoomMin': 10,
    // milliseconds
    'zoomMax': 1000 * 60 * 60 * 24 * 365 * 10000,
    // milliseconds

    'moveable': true,
    'zoomable': true,
    'selectable': true,
    'unselectable': true,
    'editable': false,
    'snapEvents': true,
    'groupsChangeable': true,
    'timeChangeable': true,
    'showCurrentTime': true,
    // show a red bar displaying the current time
    'showCustomTime': false,
    // show a blue, draggable bar displaying a custom time
    'showMajorLabels': true,
    'showMinorLabels': true,
    'showNavigation': false,
    'showButtonNew': false,
    'groupsOnRight': false,
    'groupsOrder': true,
    'axisOnTop': false,
    'stackEvents': true,
    'animate': true,
    'animateZoom': true,
    'cluster': false,
    'clusterMaxItems': 5,
    'style': 'box',
    'customStackOrder': false,
    //a function(a,b) for determining stackorder amongst a group of items. Essentially a comparator, -ve value for "a before b" and vice versa

    // i18n: Timeline only has built-in English text per default. Include timeline-locales.js to support more localized text.
    'locale': 'en',
    'MONTHS': ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    'MONTHS_SHORT': ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    'DAYS': ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    'DAYS_SHORT': ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    'ZOOM_IN': "Zoom in",
    'ZOOM_OUT': "Zoom out",
    'MOVE_LEFT': "Move left",
    'MOVE_RIGHT': "Move right",
    'NEW': "New",
    'CREATE_NEW_EVENT': "Create new event"
  };

  //
  // Now we can set the givenproperties
  //
  this.setOptions(options);
  this.clientTimeOffset = 0; // difference between client time and the time
  // set via Timeline.setCurrentTime()
  var dom = this.dom;

  // remove all elements from the container element.
  while (dom.container.hasChildNodes()) {
    dom.container.removeChild(dom.container.firstChild);
  }

  // create a step for drawing the axis
  this.step = new links.Timeline.StepDate();

  // add standard item types
  this.itemTypes = {
    box: links.Timeline.ItemBox,
    range: links.Timeline.ItemRange,
    floatingRange: links.Timeline.ItemFloatingRange,
    dot: links.Timeline.ItemDot
  };

  // initialize data
  this.data = [];
  this.firstDraw = true;

  // date interval must be initialized
  this.setVisibleChartRange(undefined, undefined, false);

  // render for the first time
  this.render();

  // fire the ready event
  var me = this;
  setTimeout(function () {
    me.trigger('ready');
  }, 0);
};

/**
 * Main drawing logic. This is the function that needs to be called
 * in the html page, to draw the timeline.
 *
 * A data table with the events must be provided, and an options table.
 *
 * @param {google.visualization.DataTable}      data
 *                                 The data containing the events for the timeline.
 *                                 Object DataTable is defined in
 *                                 google.visualization.DataTable
 * @param {Object} options         A name/value map containing settings for the
 *                                 timeline. Optional. The use of options here
 *                                 is deprecated. Pass timeline options in the
 *                                 constructor or use setOptions()
 */
links.Timeline.prototype.draw = function (data, options) {
  if (options) {
    console.log("WARNING: Passing options in draw() is deprecated. Pass options to the constructur or use setOptions() instead!");
    this.setOptions(options);
  }
  if (this.options.selectable) {
    links.Timeline.addClassName(this.dom.frame, "timeline-selectable");
  }

  // read the data
  this.setData(data);
  if (this.firstDraw) {
    this.setVisibleChartRangeAuto();
  }
  this.firstDraw = false;
};

/**
 * Set options for the timeline.
 * Timeline must be redrawn afterwards
 * @param {Object} options A name/value map containing settings for the
 *                                 timeline. Optional.
 */
links.Timeline.prototype.setOptions = function (options) {
  if (options) {
    // retrieve parameter values
    for (var i in options) {
      if (options.hasOwnProperty(i)) {
        this.options[i] = options[i];
      }
    }

    // prepare i18n dependent on set locale
    if (typeof links.locales !== 'undefined' && this.options.locale !== 'en') {
      var localeOpts = links.locales[this.options.locale];
      if (localeOpts) {
        for (var l in localeOpts) {
          if (localeOpts.hasOwnProperty(l)) {
            this.options[l] = localeOpts[l];
          }
        }
      }
    }

    // check for deprecated options
    if (options.showButtonAdd != undefined) {
      this.options.showButtonNew = options.showButtonAdd;
      console.log('WARNING: Option showButtonAdd is deprecated. Use showButtonNew instead');
    }
    if (options.intervalMin != undefined) {
      this.options.zoomMin = options.intervalMin;
      console.log('WARNING: Option intervalMin is deprecated. Use zoomMin instead');
    }
    if (options.intervalMax != undefined) {
      this.options.zoomMax = options.intervalMax;
      console.log('WARNING: Option intervalMax is deprecated. Use zoomMax instead');
    }
    if (options.scale && options.step) {
      this.step.setScale(options.scale, options.step);
    }
  }

  // validate options
  this.options.autoHeight = this.options.height === "auto";
};

/**
 * Get options for the timeline.
 *
 * @return the options object
 */
links.Timeline.prototype.getOptions = function () {
  return this.options;
};

/**
 * Add new type of items
 * @param {String} typeName  Name of new type
 * @param {links.Timeline.Item} typeFactory Constructor of items
 */
links.Timeline.prototype.addItemType = function (typeName, typeFactory) {
  this.itemTypes[typeName] = typeFactory;
};

/**
 * Retrieve a map with the column indexes of the columns by column name.
 * For example, the method returns the map
 *     {
 *         start: 0,
 *         end: 1,
 *         content: 2,
 *         group: undefined,
 *         className: undefined
 *         editable: undefined
 *         type: undefined
 *     }
 * @param {google.visualization.DataTable} dataTable
 * @type {Object} map
 */
links.Timeline.mapColumnIds = function (dataTable) {
  var cols = {},
    colCount = dataTable.getNumberOfColumns(),
    allUndefined = true;

  // loop over the columns, and map the column id's to the column indexes
  for (var col = 0; col < colCount; col++) {
    var id = dataTable.getColumnId(col) || dataTable.getColumnLabel(col);
    cols[id] = col;
    if (id == 'start' || id == 'end' || id == 'content' || id == 'group' || id == 'className' || id == 'editable' || id == 'type') {
      allUndefined = false;
    }
  }

  // if no labels or ids are defined, use the default mapping
  // for start, end, content, group, className, editable, type
  if (allUndefined) {
    cols.start = 0;
    cols.end = 1;
    cols.content = 2;
    if (colCount > 3) {
      cols.group = 3;
    }
    if (colCount > 4) {
      cols.className = 4;
    }
    if (colCount > 5) {
      cols.editable = 5;
    }
    if (colCount > 6) {
      cols.type = 6;
    }
  }
  return cols;
};

/**
 * Set data for the timeline
 * @param {google.visualization.DataTable | Array} data
 */
links.Timeline.prototype.setData = function (data) {
  // unselect any previously selected item
  this.unselectItem();
  if (!data) {
    data = [];
  }

  // clear all data
  this.stackCancelAnimation();
  this.clearItems();
  this.data = data;
  var items = this.items;
  this.deleteGroups();
  if (google && google.visualization && data instanceof google.visualization.DataTable) {
    // map the datatable columns
    var cols = links.Timeline.mapColumnIds(data);

    // read DataTable
    for (var row = 0, rows = data.getNumberOfRows(); row < rows; row++) {
      items.push(this.createItem({
        'start': cols.start != undefined ? data.getValue(row, cols.start) : undefined,
        'end': cols.end != undefined ? data.getValue(row, cols.end) : undefined,
        'content': cols.content != undefined ? data.getValue(row, cols.content) : undefined,
        'group': cols.group != undefined ? data.getValue(row, cols.group) : undefined,
        'className': cols.className != undefined ? data.getValue(row, cols.className) : undefined,
        'editable': cols.editable != undefined ? data.getValue(row, cols.editable) : undefined,
        'type': cols.type != undefined ? data.getValue(row, cols.type) : undefined
      }));
    }
  } else if (links.Timeline.isArray(data)) {
    // read JSON array
    for (var row = 0, rows = data.length; row < rows; row++) {
      var itemData = data[row];
      var item = this.createItem(itemData);
      items.push(item);
    }
  } else {
    throw "Unknown data type. DataTable or Array expected.";
  }

  // prepare data for clustering, by filtering and sorting by type
  if (this.options.cluster) {
    this.clusterGenerator.setData(this.items);
  }
  this.render({
    animate: false
  });
};

/**
 * Return the original data table.
 * @return {google.visualization.DataTable | Array} data
 */
links.Timeline.prototype.getData = function () {
  return this.data;
};

/**
 * Update the original data with changed start, end or group.
 *
 * @param {Number} index
 * @param {Object} values   An object containing some of the following parameters:
 *                          {Date} start,
 *                          {Date} end,
 *                          {String} content,
 *                          {String} group
 */
links.Timeline.prototype.updateData = function (index, values) {
  var data = this.data,
    prop;
  if (google && google.visualization && data instanceof google.visualization.DataTable) {
    // update the original google DataTable
    var missingRows = index + 1 - data.getNumberOfRows();
    if (missingRows > 0) {
      data.addRows(missingRows);
    }

    // map the column id's by name
    var cols = links.Timeline.mapColumnIds(data);

    // merge all fields from the provided data into the current data
    for (prop in values) {
      if (values.hasOwnProperty(prop)) {
        var col = cols[prop];
        if (col == undefined) {
          // create new column
          var value = values[prop];
          var valueType = 'string';
          if (typeof value == 'number') {
            valueType = 'number';
          } else if (typeof value == 'boolean') {
            valueType = 'boolean';
          } else if (value instanceof Date) {
            valueType = 'datetime';
          }
          col = data.addColumn(valueType, prop);
        }
        data.setValue(index, col, values[prop]);

        // TODO: correctly serialize the start and end Date to the desired type (Date, String, or Number)
      }
    }
  } else if (links.Timeline.isArray(data)) {
    // update the original JSON table
    var row = data[index];
    if (row == undefined) {
      row = {};
      data[index] = row;
    }

    // merge all fields from the provided data into the current data
    for (prop in values) {
      if (values.hasOwnProperty(prop)) {
        row[prop] = values[prop];

        // TODO: correctly serialize the start and end Date to the desired type (Date, String, or Number)
      }
    }
  } else {
    throw "Cannot update data, unknown type of data";
  }
};

/**
 * Find the item index from a given HTML element
 * If no item index is found, undefined is returned
 * @param {Element} element
 * @return {Number | undefined} index
 */
links.Timeline.prototype.getItemIndex = function (element) {
  var e = element,
    dom = this.dom,
    frame = dom.items.frame,
    items = this.items,
    index = undefined;

  // try to find the frame where the items are located in
  while (e.parentNode && e.parentNode !== frame) {
    e = e.parentNode;
  }
  if (e.parentNode === frame) {
    // yes! we have found the parent element of all items
    // retrieve its id from the array with items
    for (var i = 0, iMax = items.length; i < iMax; i++) {
      if (items[i].dom === e) {
        index = i;
        break;
      }
    }
  }
  return index;
};

/**
 * Find the cluster index from a given HTML element
 * If no cluster index is found, undefined is returned
 * @param {Element} element
 * @return {Number | undefined} index
 */
links.Timeline.prototype.getClusterIndex = function (element) {
  var e = element,
    dom = this.dom,
    frame = dom.items.frame,
    clusters = this.clusters,
    index = undefined;
  if (this.clusters) {
    // try to find the frame where the clusters are located in
    while (e.parentNode && e.parentNode !== frame) {
      e = e.parentNode;
    }
    if (e.parentNode === frame) {
      // yes! we have found the parent element of all clusters
      // retrieve its id from the array with clusters
      for (var i = 0, iMax = clusters.length; i < iMax; i++) {
        if (clusters[i].dom === e) {
          index = i;
          break;
        }
      }
    }
  }
  return index;
};

/**
 * Find all elements within the start and end range
 * If no element is found, returns an empty array
 * @param start time
 * @param end time
 * @return Array itemsInRange
 */
links.Timeline.prototype.getVisibleItems = function (start, end) {
  var items = this.items;
  var itemsInRange = [];
  if (items) {
    for (var i = 0, iMax = items.length; i < iMax; i++) {
      var item = items[i];
      if (item.end) {
        // Time range object // NH use getLeft and getRight here
        if (start <= item.start && item.end <= end) {
          itemsInRange.push({
            "row": i
          });
        }
      } else {
        // Point object
        if (start <= item.start && item.start <= end) {
          itemsInRange.push({
            "row": i
          });
        }
      }
    }
  }

  //     var sel = [];
  // if (this.selection) {
  //     sel.push({"row": this.selection.index});
  // }
  // return sel;

  return itemsInRange;
};

/**
 * Set a new size for the timeline
 * @param {string} width   Width in pixels or percentage (for example "800px"
 *                         or "50%")
 * @param {string} height  Height in pixels or percentage  (for example "400px"
 *                         or "30%")
 */
links.Timeline.prototype.setSize = function (width, height) {
  if (width) {
    this.options.width = width;
    this.dom.frame.style.width = width;
  }
  if (height) {
    this.options.height = height;
    this.options.autoHeight = this.options.height === "auto";
    if (height !== "auto") {
      this.dom.frame.style.height = height;
    }
  }
  this.render({
    animate: false
  });
};

/**
 * Set a new value for the visible range int the timeline.
 * Set start undefined to include everything from the earliest date to end.
 * Set end undefined to include everything from start to the last date.
 * Example usage:
 *    myTimeline.setVisibleChartRange(new Date("2010-08-22"),
 *                                    new Date("2010-09-13"));
 * @param {Date}   start     The start date for the timeline. optional
 * @param {Date}   end       The end date for the timeline. optional
 * @param {boolean} redraw   Optional. If true (default) the Timeline is
 *                           directly redrawn
 */
links.Timeline.prototype.setVisibleChartRange = function (start, end, redraw) {
  var range = {};
  if (!start || !end) {
    // retrieve the date range of the items
    range = this.getDataRange(true);
  }
  if (!start) {
    if (end) {
      if (range.min && range.min.valueOf() < end.valueOf()) {
        // start of the data
        start = range.min;
      } else {
        // 7 days before the end
        start = new Date(end.valueOf());
        start.setDate(start.getDate() - 7);
      }
    } else {
      // default of 3 days ago
      start = new Date();
      start.setDate(start.getDate() - 3);
    }
  }
  if (!end) {
    if (range.max) {
      // end of the data
      end = range.max;
    } else {
      // 7 days after start
      end = new Date(start.valueOf());
      end.setDate(end.getDate() + 7);
    }
  }

  // prevent start Date <= end Date
  if (end <= start) {
    end = new Date(start.valueOf());
    end.setDate(end.getDate() + 7);
  }

  // limit to the allowed range (don't let this do by applyRange,
  // because that method will try to maintain the interval (end-start)
  var min = this.options.min ? this.options.min : undefined; // date
  if (min != undefined && start.valueOf() < min.valueOf()) {
    start = new Date(min.valueOf()); // date
  }

  var max = this.options.max ? this.options.max : undefined; // date
  if (max != undefined && end.valueOf() > max.valueOf()) {
    end = new Date(max.valueOf()); // date
  }

  this.applyRange(start, end);
  if (redraw == undefined || redraw == true) {
    this.render({
      animate: false
    }); // TODO: optimize, no reflow needed
  } else {
    this.recalcConversion();
  }
};

/**
 * Change the visible chart range such that all items become visible
 */
links.Timeline.prototype.setVisibleChartRangeAuto = function () {
  var range = this.getDataRange(true);
  this.setVisibleChartRange(range.min, range.max);
};

/**
 * Adjust the visible range such that the current time is located in the center
 * of the timeline
 */
links.Timeline.prototype.setVisibleChartRangeNow = function () {
  var now = new Date();
  var diff = this.end.valueOf() - this.start.valueOf();
  var startNew = new Date(now.valueOf() - diff / 2);
  var endNew = new Date(startNew.valueOf() + diff);
  this.setVisibleChartRange(startNew, endNew);
};

/**
 * Retrieve the current visible range in the timeline.
 * @return {Object} An object with start and end properties
 */
links.Timeline.prototype.getVisibleChartRange = function () {
  return {
    'start': new Date(this.start.valueOf()),
    'end': new Date(this.end.valueOf())
  };
};

/**
 * Get the date range of the items.
 * @param {boolean} [withMargin]  If true, 5% of whitespace is added to the
 *                                left and right of the range. Default is false.
 * @return {Object} range    An object with parameters min and max.
 *                           - {Date} min is the lowest start date of the items
 *                           - {Date} max is the highest start or end date of the items
 *                           If no data is available, the values of min and max
 *                           will be undefined
 */
links.Timeline.prototype.getDataRange = function (withMargin) {
  var items = this.items,
    min = undefined,
    // number
    max = undefined; // number

  if (items) {
    for (var i = 0, iMax = items.length; i < iMax; i++) {
      var item = items[i],
        start = item.start != undefined ? item.start.valueOf() : undefined,
        end = item.end != undefined ? item.end.valueOf() : start;
      if (start != undefined) {
        min = min != undefined ? Math.min(min.valueOf(), start.valueOf()) : start;
      }
      if (end != undefined) {
        max = max != undefined ? Math.max(max.valueOf(), end.valueOf()) : end;
      }
    }
  }
  if (min && max && withMargin) {
    // zoom out 5% such that you have a little white space on the left and right
    var diff = max - min;
    min = min - diff * 0.05;
    max = max + diff * 0.05;
  }
  return {
    'min': min != undefined ? new Date(min) : undefined,
    'max': max != undefined ? new Date(max) : undefined
  };
};

/**
 * Re-render (reflow and repaint) all components of the Timeline: frame, axis,
 * items, ...
 * @param {Object} [options]  Available options:
 *                            {boolean} renderTimesLeft   Number of times the
 *                                                        render may be repeated
 *                                                        5 times by default.
 *                            {boolean} animate           takes options.animate
 *                                                        as default value
 */
links.Timeline.prototype.render = function (options) {
  var frameResized = this.reflowFrame();
  var axisResized = this.reflowAxis();
  var groupsResized = this.reflowGroups();
  var itemsResized = this.reflowItems();
  var resized = frameResized || axisResized || groupsResized || itemsResized;

  // TODO: only stackEvents/filterItems when resized or changed. (gives a bootstrap issue).
  // if (resized) {
  var animate = this.options.animate;
  if (options && options.animate != undefined) {
    animate = options.animate;
  }
  this.recalcConversion();
  this.clusterItems();
  this.filterItems();
  this.stackItems(animate);
  this.recalcItems();

  // TODO: only repaint when resized or when filterItems or stackItems gave a change?
  var needsReflow = this.repaint();

  // re-render once when needed (prevent endless re-render loop)
  if (needsReflow) {
    var renderTimesLeft = options ? options.renderTimesLeft : undefined;
    if (renderTimesLeft == undefined) {
      renderTimesLeft = 5;
    }
    if (renderTimesLeft > 0) {
      this.render({
        'animate': options ? options.animate : undefined,
        'renderTimesLeft': renderTimesLeft - 1
      });
    }
  }
};

/**
 * Repaint all components of the Timeline
 * @return {boolean} needsReflow   Returns true if the DOM is changed such that
 *                                 a reflow is needed.
 */
links.Timeline.prototype.repaint = function () {
  var frameNeedsReflow = this.repaintFrame();
  var axisNeedsReflow = this.repaintAxis();
  var groupsNeedsReflow = this.repaintGroups();
  var itemsNeedsReflow = this.repaintItems();
  this.repaintCurrentTime();
  this.repaintCustomTime();
  return frameNeedsReflow || axisNeedsReflow || groupsNeedsReflow || itemsNeedsReflow;
};

/**
 * Reflow the timeline frame
 * @return {boolean} resized    Returns true if any of the frame elements
 *                              have been resized.
 */
links.Timeline.prototype.reflowFrame = function () {
  var dom = this.dom,
    options = this.options,
    size = this.size,
    resized = false;

  // Note: IE7 has issues with giving frame.clientWidth, therefore I use offsetWidth instead
  var frameWidth = dom.frame ? dom.frame.offsetWidth : 0,
    frameHeight = dom.frame ? dom.frame.clientHeight : 0;
  resized = resized || size.frameWidth !== frameWidth;
  resized = resized || size.frameHeight !== frameHeight;
  size.frameWidth = frameWidth;
  size.frameHeight = frameHeight;
  return resized;
};

/**
 * repaint the Timeline frame
 * @return {boolean} needsReflow   Returns true if the DOM is changed such that
 *                                 a reflow is needed.
 */
links.Timeline.prototype.repaintFrame = function () {
  var needsReflow = false,
    dom = this.dom,
    options = this.options,
    size = this.size;

  // main frame
  if (!dom.frame) {
    dom.frame = document.createElement("DIV");
    dom.frame.className = "timeline-frame ui-widget ui-widget-content ui-corner-all";
    dom.container.appendChild(dom.frame);
    needsReflow = true;
  }
  var height = options.autoHeight ? size.actualHeight + "px" : options.height || "100%";
  var width = options.width || "100%";
  needsReflow = needsReflow || dom.frame.style.height != height;
  needsReflow = needsReflow || dom.frame.style.width != width;
  dom.frame.style.height = height;
  dom.frame.style.width = width;

  // contents
  if (!dom.content) {
    // create content box where the axis and items will be created
    dom.content = document.createElement("DIV");
    dom.content.className = "timeline-content";
    dom.frame.appendChild(dom.content);
    var timelines = document.createElement("DIV");
    timelines.style.position = "absolute";
    timelines.style.left = "0px";
    timelines.style.top = "0px";
    timelines.style.height = "100%";
    timelines.style.width = "0px";
    dom.content.appendChild(timelines);
    dom.contentTimelines = timelines;
    var params = this.eventParams,
      me = this;
    if (!params.onMouseDown) {
      params.onMouseDown = function (event) {
        me.onMouseDown(event);
      };
      links.Timeline.addEventListener(dom.content, "mousedown", params.onMouseDown);
    }
    if (!params.onTouchStart) {
      params.onTouchStart = function (event) {
        me.onTouchStart(event);
      };
      links.Timeline.addEventListener(dom.content, "touchstart", params.onTouchStart);
    }
    if (!params.onMouseWheel) {
      params.onMouseWheel = function (event) {
        me.onMouseWheel(event);
      };
      links.Timeline.addEventListener(dom.content, "mousewheel", params.onMouseWheel);
    }
    if (!params.onDblClick) {
      params.onDblClick = function (event) {
        me.onDblClick(event);
      };
      links.Timeline.addEventListener(dom.content, "dblclick", params.onDblClick);
    }
    needsReflow = true;
  }
  dom.content.style.left = size.contentLeft + "px";
  dom.content.style.top = "0px";
  dom.content.style.width = size.contentWidth + "px";
  dom.content.style.height = size.frameHeight + "px";
  this.repaintNavigation();
  return needsReflow;
};

/**
 * Reflow the timeline axis. Calculate its height, width, positioning, etc...
 * @return {boolean} resized    returns true if the axis is resized
 */
links.Timeline.prototype.reflowAxis = function () {
  var resized = false,
    dom = this.dom,
    options = this.options,
    size = this.size,
    axisDom = dom.axis;
  var characterMinorWidth = axisDom && axisDom.characterMinor ? axisDom.characterMinor.clientWidth : 0,
    characterMinorHeight = axisDom && axisDom.characterMinor ? axisDom.characterMinor.clientHeight : 0,
    characterMajorWidth = axisDom && axisDom.characterMajor ? axisDom.characterMajor.clientWidth : 0,
    characterMajorHeight = axisDom && axisDom.characterMajor ? axisDom.characterMajor.clientHeight : 0,
    axisHeight = (options.showMinorLabels ? characterMinorHeight : 0) + (options.showMajorLabels ? characterMajorHeight : 0);
  var axisTop = options.axisOnTop ? 0 : size.frameHeight - axisHeight,
    axisLine = options.axisOnTop ? axisHeight : axisTop;
  resized = resized || size.axis.top !== axisTop;
  resized = resized || size.axis.line !== axisLine;
  resized = resized || size.axis.height !== axisHeight;
  size.axis.top = axisTop;
  size.axis.line = axisLine;
  size.axis.height = axisHeight;
  size.axis.labelMajorTop = options.axisOnTop ? 0 : axisLine + (options.showMinorLabels ? characterMinorHeight : 0);
  size.axis.labelMinorTop = options.axisOnTop ? options.showMajorLabels ? characterMajorHeight : 0 : axisLine;
  size.axis.lineMinorTop = options.axisOnTop ? size.axis.labelMinorTop : 0;
  size.axis.lineMinorHeight = options.showMajorLabels ? size.frameHeight - characterMajorHeight : size.frameHeight;
  if (axisDom && axisDom.minorLines && axisDom.minorLines.length) {
    size.axis.lineMinorWidth = axisDom.minorLines[0].offsetWidth;
  } else {
    size.axis.lineMinorWidth = 1;
  }
  if (axisDom && axisDom.majorLines && axisDom.majorLines.length) {
    size.axis.lineMajorWidth = axisDom.majorLines[0].offsetWidth;
  } else {
    size.axis.lineMajorWidth = 1;
  }
  resized = resized || size.axis.characterMinorWidth !== characterMinorWidth;
  resized = resized || size.axis.characterMinorHeight !== characterMinorHeight;
  resized = resized || size.axis.characterMajorWidth !== characterMajorWidth;
  resized = resized || size.axis.characterMajorHeight !== characterMajorHeight;
  size.axis.characterMinorWidth = characterMinorWidth;
  size.axis.characterMinorHeight = characterMinorHeight;
  size.axis.characterMajorWidth = characterMajorWidth;
  size.axis.characterMajorHeight = characterMajorHeight;
  var contentHeight = Math.max(size.frameHeight - axisHeight, 0);
  size.contentLeft = options.groupsOnRight ? 0 : size.groupsWidth;
  size.contentWidth = Math.max(size.frameWidth - size.groupsWidth, 0);
  size.contentHeight = contentHeight;
  return resized;
};

/**
 * Redraw the timeline axis with minor and major labels
 * @return {boolean} needsReflow     Returns true if the DOM is changed such
 *                                   that a reflow is needed.
 */
links.Timeline.prototype.repaintAxis = function () {
  var needsReflow = false,
    dom = this.dom,
    options = this.options,
    size = this.size,
    step = this.step;
  var axis = dom.axis;
  if (!axis) {
    axis = {};
    dom.axis = axis;
  }
  if (!size.axis.properties) {
    size.axis.properties = {};
  }
  if (!axis.minorTexts) {
    axis.minorTexts = [];
  }
  if (!axis.minorLines) {
    axis.minorLines = [];
  }
  if (!axis.majorTexts) {
    axis.majorTexts = [];
  }
  if (!axis.majorLines) {
    axis.majorLines = [];
  }
  if (!axis.frame) {
    axis.frame = document.createElement("DIV");
    axis.frame.style.position = "absolute";
    axis.frame.style.left = "0px";
    axis.frame.style.top = "0px";
    dom.content.appendChild(axis.frame);
  }

  // take axis offline
  dom.content.removeChild(axis.frame);
  axis.frame.style.width = size.contentWidth + "px";
  axis.frame.style.height = size.axis.height + "px";

  // the drawn axis is more wide than the actual visual part, such that
  // the axis can be dragged without having to redraw it each time again.
  var start = this.screenToTime(0);
  var end = this.screenToTime(size.contentWidth);

  // calculate minimum step (in milliseconds) based on character size
  if (size.axis.characterMinorWidth) {
    this.minimumStep = this.screenToTime(size.axis.characterMinorWidth * 6) - this.screenToTime(0);
    step.setRange(start, end, this.minimumStep);
  }
  var charsNeedsReflow = this.repaintAxisCharacters();
  needsReflow = needsReflow || charsNeedsReflow;

  // The current labels on the axis will be re-used (much better performance),
  // therefore, the repaintAxis method uses the mechanism with
  // repaintAxisStartOverwriting, repaintAxisEndOverwriting, and
  // this.size.axis.properties is used.
  this.repaintAxisStartOverwriting();
  step.start();
  var xFirstMajorLabel = undefined;
  var max = 0;
  while (!step.end() && max < 1000) {
    max++;
    var cur = step.getCurrent(),
      x = this.timeToScreen(cur),
      isMajor = step.isMajor();
    if (options.showMinorLabels) {
      this.repaintAxisMinorText(x, step.getLabelMinor(options));
    }
    if (isMajor && options.showMajorLabels) {
      if (x > 0) {
        if (xFirstMajorLabel == undefined) {
          xFirstMajorLabel = x;
        }
        this.repaintAxisMajorText(x, step.getLabelMajor(options));
      }
      this.repaintAxisMajorLine(x);
    } else {
      this.repaintAxisMinorLine(x);
    }
    step.next();
  }

  // create a major label on the left when needed
  if (options.showMajorLabels) {
    var leftTime = this.screenToTime(0),
      leftText = this.step.getLabelMajor(options, leftTime),
      width = leftText.length * size.axis.characterMajorWidth + 10; // upper bound estimation

    if (xFirstMajorLabel == undefined || width < xFirstMajorLabel) {
      this.repaintAxisMajorText(0, leftText, leftTime);
    }
  }

  // cleanup left over labels
  this.repaintAxisEndOverwriting();
  this.repaintAxisHorizontal();

  // put axis online
  dom.content.insertBefore(axis.frame, dom.content.firstChild);
  return needsReflow;
};

/**
 * Create characters used to determine the size of text on the axis
 * @return {boolean} needsReflow   Returns true if the DOM is changed such that
 *                                 a reflow is needed.
 */
links.Timeline.prototype.repaintAxisCharacters = function () {
  // calculate the width and height of a single character
  // this is used to calculate the step size, and also the positioning of the
  // axis
  var needsReflow = false,
    dom = this.dom,
    axis = dom.axis,
    text;
  if (!axis.characterMinor) {
    text = document.createTextNode("0");
    var characterMinor = document.createElement("DIV");
    characterMinor.className = "timeline-axis-text timeline-axis-text-minor";
    characterMinor.appendChild(text);
    characterMinor.style.position = "absolute";
    characterMinor.style.visibility = "hidden";
    characterMinor.style.paddingLeft = "0px";
    characterMinor.style.paddingRight = "0px";
    axis.frame.appendChild(characterMinor);
    axis.characterMinor = characterMinor;
    needsReflow = true;
  }
  if (!axis.characterMajor) {
    text = document.createTextNode("0");
    var characterMajor = document.createElement("DIV");
    characterMajor.className = "timeline-axis-text timeline-axis-text-major";
    characterMajor.appendChild(text);
    characterMajor.style.position = "absolute";
    characterMajor.style.visibility = "hidden";
    characterMajor.style.paddingLeft = "0px";
    characterMajor.style.paddingRight = "0px";
    axis.frame.appendChild(characterMajor);
    axis.characterMajor = characterMajor;
    needsReflow = true;
  }
  return needsReflow;
};

/**
 * Initialize redraw of the axis. All existing labels and lines will be
 * overwritten and reused.
 */
links.Timeline.prototype.repaintAxisStartOverwriting = function () {
  var properties = this.size.axis.properties;
  properties.minorTextNum = 0;
  properties.minorLineNum = 0;
  properties.majorTextNum = 0;
  properties.majorLineNum = 0;
};

/**
 * End of overwriting HTML DOM elements of the axis.
 * remaining elements will be removed
 */
links.Timeline.prototype.repaintAxisEndOverwriting = function () {
  var dom = this.dom,
    props = this.size.axis.properties,
    frame = this.dom.axis.frame,
    num;

  // remove leftovers
  var minorTexts = dom.axis.minorTexts;
  num = props.minorTextNum;
  while (minorTexts.length > num) {
    var minorText = minorTexts[num];
    frame.removeChild(minorText);
    minorTexts.splice(num, 1);
  }
  var minorLines = dom.axis.minorLines;
  num = props.minorLineNum;
  while (minorLines.length > num) {
    var minorLine = minorLines[num];
    frame.removeChild(minorLine);
    minorLines.splice(num, 1);
  }
  var majorTexts = dom.axis.majorTexts;
  num = props.majorTextNum;
  while (majorTexts.length > num) {
    var majorText = majorTexts[num];
    frame.removeChild(majorText);
    majorTexts.splice(num, 1);
  }
  var majorLines = dom.axis.majorLines;
  num = props.majorLineNum;
  while (majorLines.length > num) {
    var majorLine = majorLines[num];
    frame.removeChild(majorLine);
    majorLines.splice(num, 1);
  }
};

/**
 * Repaint the horizontal line and background of the axis
 */
links.Timeline.prototype.repaintAxisHorizontal = function () {
  var axis = this.dom.axis,
    size = this.size,
    options = this.options;

  // line behind all axis elements (possibly having a background color)
  var hasAxis = options.showMinorLabels || options.showMajorLabels;
  if (hasAxis) {
    if (!axis.backgroundLine) {
      // create the axis line background (for a background color or so)
      var backgroundLine = document.createElement("DIV");
      backgroundLine.className = "timeline-axis";
      backgroundLine.style.position = "absolute";
      backgroundLine.style.left = "0px";
      backgroundLine.style.width = "100%";
      backgroundLine.style.border = "none";
      axis.frame.insertBefore(backgroundLine, axis.frame.firstChild);
      axis.backgroundLine = backgroundLine;
    }
    if (axis.backgroundLine) {
      axis.backgroundLine.style.top = size.axis.top + "px";
      axis.backgroundLine.style.height = size.axis.height + "px";
    }
  } else {
    if (axis.backgroundLine) {
      axis.frame.removeChild(axis.backgroundLine);
      delete axis.backgroundLine;
    }
  }

  // line before all axis elements
  if (hasAxis) {
    if (axis.line) {
      // put this line at the end of all childs
      var line = axis.frame.removeChild(axis.line);
      axis.frame.appendChild(line);
    } else {
      // make the axis line
      var line = document.createElement("DIV");
      line.className = "timeline-axis";
      line.style.position = "absolute";
      line.style.left = "0px";
      line.style.width = "100%";
      line.style.height = "0px";
      axis.frame.appendChild(line);
      axis.line = line;
    }
    axis.line.style.top = size.axis.line + "px";
  } else {
    if (axis.line && axis.line.parentElement) {
      axis.frame.removeChild(axis.line);
      delete axis.line;
    }
  }
};

/**
 * Create a minor label for the axis at position x
 * @param {Number} x
 * @param {String} text
 */
links.Timeline.prototype.repaintAxisMinorText = function (x, text) {
  var size = this.size,
    dom = this.dom,
    props = size.axis.properties,
    frame = dom.axis.frame,
    minorTexts = dom.axis.minorTexts,
    index = props.minorTextNum,
    label;
  if (index < minorTexts.length) {
    label = minorTexts[index];
  } else {
    // create new label
    var content = document.createTextNode("");
    label = document.createElement("DIV");
    label.appendChild(content);
    label.className = "timeline-axis-text timeline-axis-text-minor";
    label.style.position = "absolute";
    frame.appendChild(label);
    minorTexts.push(label);
  }
  label.childNodes[0].nodeValue = text;
  label.style.left = x + "px";
  label.style.top = size.axis.labelMinorTop + "px";
  //label.title = title;  // TODO: this is a heavy operation

  props.minorTextNum++;
};

/**
 * Create a minor line for the axis at position x
 * @param {Number} x
 */
links.Timeline.prototype.repaintAxisMinorLine = function (x) {
  var axis = this.size.axis,
    dom = this.dom,
    props = axis.properties,
    frame = dom.axis.frame,
    minorLines = dom.axis.minorLines,
    index = props.minorLineNum,
    line;
  if (index < minorLines.length) {
    line = minorLines[index];
  } else {
    // create vertical line
    line = document.createElement("DIV");
    line.className = "timeline-axis-grid timeline-axis-grid-minor";
    line.style.position = "absolute";
    line.style.width = "0px";
    frame.appendChild(line);
    minorLines.push(line);
  }
  line.style.top = axis.lineMinorTop + "px";
  line.style.height = axis.lineMinorHeight + "px";
  line.style.left = x - axis.lineMinorWidth / 2 + "px";
  props.minorLineNum++;
};

/**
 * Create a Major label for the axis at position x
 * @param {Number} x
 * @param {String} text
 */
links.Timeline.prototype.repaintAxisMajorText = function (x, text) {
  var size = this.size,
    props = size.axis.properties,
    frame = this.dom.axis.frame,
    majorTexts = this.dom.axis.majorTexts,
    index = props.majorTextNum,
    label;
  if (index < majorTexts.length) {
    label = majorTexts[index];
  } else {
    // create label
    var content = document.createTextNode(text);
    label = document.createElement("DIV");
    label.className = "timeline-axis-text timeline-axis-text-major";
    label.appendChild(content);
    label.style.position = "absolute";
    label.style.top = "0px";
    frame.appendChild(label);
    majorTexts.push(label);
  }
  label.childNodes[0].nodeValue = text;
  label.style.top = size.axis.labelMajorTop + "px";
  label.style.left = x + "px";
  //label.title = title; // TODO: this is a heavy operation

  props.majorTextNum++;
};

/**
 * Create a Major line for the axis at position x
 * @param {Number} x
 */
links.Timeline.prototype.repaintAxisMajorLine = function (x) {
  var size = this.size,
    props = size.axis.properties,
    axis = this.size.axis,
    frame = this.dom.axis.frame,
    majorLines = this.dom.axis.majorLines,
    index = props.majorLineNum,
    line;
  if (index < majorLines.length) {
    line = majorLines[index];
  } else {
    // create vertical line
    line = document.createElement("DIV");
    line.className = "timeline-axis-grid timeline-axis-grid-major";
    line.style.position = "absolute";
    line.style.top = "0px";
    line.style.width = "0px";
    frame.appendChild(line);
    majorLines.push(line);
  }
  line.style.left = x - axis.lineMajorWidth / 2 + "px";
  line.style.height = size.frameHeight + "px";
  props.majorLineNum++;
};

/**
 * Reflow all items, retrieve their actual size
 * @return {boolean} resized    returns true if any of the items is resized
 */
links.Timeline.prototype.reflowItems = function () {
  var resized = false,
    i,
    iMax,
    group,
    groups = this.groups,
    renderedItems = this.renderedItems;
  if (groups) {
    // TODO: need to check if labels exists?
    // loop through all groups to reset the items height
    groups.forEach(function (group) {
      group.itemsHeight = group.labelHeight || 0;
    });
  }

  // loop through the width and height of all visible items
  for (i = 0, iMax = renderedItems.length; i < iMax; i++) {
    var item = renderedItems[i],
      domItem = item.dom;
    group = item.group;
    if (domItem) {
      // TODO: move updating width and height into item.reflow
      var width = domItem ? domItem.clientWidth : 0;
      var height = domItem ? domItem.clientHeight : 0;
      resized = resized || item.width != width;
      resized = resized || item.height != height;
      item.width = width;
      item.height = height;
      //item.borderWidth = (domItem.offsetWidth - domItem.clientWidth - 2) / 2; // TODO: borderWidth
      item.reflow();
    }
    if (group) {
      group.itemsHeight = Math.max(this.options.groupMinHeight, group.itemsHeight ? Math.max(group.itemsHeight, item.height) : item.height);
    }
  }
  return resized;
};

/**
 * Recalculate item properties:
 * - the height of each group.
 * - the actualHeight, from the stacked items or the sum of the group heights
 * @return {boolean} resized    returns true if any of the items properties is
 *                              changed
 */
links.Timeline.prototype.recalcItems = function () {
  var resized = false,
    i,
    iMax,
    item,
    finalItem,
    finalItems,
    group,
    groups = this.groups,
    size = this.size,
    options = this.options,
    renderedItems = this.renderedItems;
  var actualHeight = 0;
  if (groups.length == 0) {
    // calculate actual height of the timeline when there are no groups
    // but stacked items
    if (options.autoHeight || options.cluster) {
      var min = 0,
        max = 0;
      if (this.stack && this.stack.finalItems) {
        // adjust the offset of all finalItems when the actualHeight has been changed
        finalItems = this.stack.finalItems;
        finalItem = finalItems[0];
        if (finalItem && finalItem.top) {
          min = finalItem.top;
          max = finalItem.top + finalItem.height;
        }
        for (i = 1, iMax = finalItems.length; i < iMax; i++) {
          finalItem = finalItems[i];
          min = Math.min(min, finalItem.top);
          max = Math.max(max, finalItem.top + finalItem.height);
        }
      } else {
        item = renderedItems[0];
        if (item && item.top) {
          min = item.top;
          max = item.top + item.height;
        }
        for (i = 1, iMax = renderedItems.length; i < iMax; i++) {
          item = renderedItems[i];
          if (item.top) {
            min = Math.min(min, item.top);
            max = Math.max(max, item.top + item.height);
          }
        }
      }
      actualHeight = max - min + 2 * options.eventMarginAxis + size.axis.height;
      if (actualHeight < options.minHeight) {
        actualHeight = options.minHeight;
      }
      if (size.actualHeight != actualHeight && options.autoHeight && !options.axisOnTop) {
        // adjust the offset of all items when the actualHeight has been changed
        var diff = actualHeight - size.actualHeight;
        if (this.stack && this.stack.finalItems) {
          finalItems = this.stack.finalItems;
          for (i = 0, iMax = finalItems.length; i < iMax; i++) {
            finalItems[i].top += diff;
            finalItems[i].item.top += diff;
          }
        } else {
          for (i = 0, iMax = renderedItems.length; i < iMax; i++) {
            renderedItems[i].top += diff;
          }
        }
      }
    }
  } else {
    // loop through all groups to get the height of each group, and the
    // total height
    actualHeight = size.axis.height + 2 * options.eventMarginAxis;
    for (i = 0, iMax = groups.length; i < iMax; i++) {
      group = groups[i];

      //
      // TODO: Do we want to apply a max height? how ?
      //
      var groupHeight = group.itemsHeight;
      resized = resized || groupHeight != group.height;
      group.height = Math.max(groupHeight, options.groupMinHeight);
      actualHeight += groups[i].height + options.eventMargin;
    }

    // calculate top positions of the group labels and lines
    var eventMargin = options.eventMargin,
      top = options.axisOnTop ? options.eventMarginAxis + eventMargin / 2 : size.contentHeight - options.eventMarginAxis + eventMargin / 2,
      axisHeight = size.axis.height;
    for (i = 0, iMax = groups.length; i < iMax; i++) {
      group = groups[i];
      if (options.axisOnTop) {
        group.top = top + axisHeight;
        group.labelTop = top + axisHeight + (group.height - group.labelHeight) / 2;
        group.lineTop = top + axisHeight + group.height + eventMargin / 2;
        top += group.height + eventMargin;
      } else {
        top -= group.height + eventMargin;
        group.top = top;
        group.labelTop = top + (group.height - group.labelHeight) / 2;
        group.lineTop = top - eventMargin / 2;
      }
    }
    resized = true;
  }
  if (actualHeight < options.minHeight) {
    actualHeight = options.minHeight;
  }
  resized = resized || actualHeight != size.actualHeight;
  size.actualHeight = actualHeight;
  return resized;
};

/**
 * This method clears the (internal) array this.items in a safe way: neatly
 * cleaning up the DOM, and accompanying arrays this.renderedItems and
 * the created clusters.
 */
links.Timeline.prototype.clearItems = function () {
  // add all visible items to the list to be hidden
  var hideItems = this.renderQueue.hide;
  this.renderedItems.forEach(function (item) {
    hideItems.push(item);
  });

  // clear the cluster generator
  this.clusterGenerator.clear();

  // actually clear the items
  this.items = [];
};

/**
 * Repaint all items
 * @return {boolean} needsReflow   Returns true if the DOM is changed such that
 *                                 a reflow is needed.
 */
links.Timeline.prototype.repaintItems = function () {
  var i, iMax, item, index;
  var needsReflow = false,
    dom = this.dom,
    size = this.size,
    timeline = this,
    renderedItems = this.renderedItems;
  if (!dom.items) {
    dom.items = {};
  }

  // draw the frame containing the items
  var frame = dom.items.frame;
  if (!frame) {
    frame = document.createElement("DIV");
    frame.style.position = "relative";
    dom.content.appendChild(frame);
    dom.items.frame = frame;
  }
  frame.style.left = "0px";
  frame.style.top = size.items.top + "px";
  frame.style.height = "0px";

  // Take frame offline (for faster manipulation of the DOM)
  dom.content.removeChild(frame);

  // process the render queue with changes
  var queue = this.renderQueue;
  var newImageUrls = [];
  needsReflow = needsReflow || queue.show.length > 0 || queue.update.length > 0 || queue.hide.length > 0; // TODO: reflow needed on hide of items?

  while (item = queue.show.shift()) {
    item.showDOM(frame);
    item.getImageUrls(newImageUrls);
    renderedItems.push(item);
  }
  while (item = queue.update.shift()) {
    item.updateDOM(frame);
    item.getImageUrls(newImageUrls);
    index = this.renderedItems.indexOf(item);
    if (index == -1) {
      renderedItems.push(item);
    }
  }
  while (item = queue.hide.shift()) {
    item.hideDOM(frame);
    index = this.renderedItems.indexOf(item);
    if (index != -1) {
      renderedItems.splice(index, 1);
    }
  }

  // reposition all visible items
  renderedItems.forEach(function (item) {
    item.updatePosition(timeline);
  });

  // redraw the delete button and dragareas of the selected item (if any)
  this.repaintDeleteButton();
  this.repaintDragAreas();

  // put frame online again
  dom.content.appendChild(frame);
  if (newImageUrls.length) {
    // retrieve all image sources from the items, and set a callback once
    // all images are retrieved
    var callback = function callback() {
      timeline.render();
    };
    var sendCallbackWhenAlreadyLoaded = false;
    links.imageloader.loadAll(newImageUrls, callback, sendCallbackWhenAlreadyLoaded);
  }
  return needsReflow;
};

/**
 * Reflow the size of the groups
 * @return {boolean} resized    Returns true if any of the frame elements
 *                              have been resized.
 */
links.Timeline.prototype.reflowGroups = function () {
  var resized = false,
    options = this.options,
    size = this.size,
    dom = this.dom;

  // calculate the groups width and height
  // TODO: only update when data is changed! -> use an updateSeq
  var groupsWidth = 0;

  // loop through all groups to get the labels width and height
  var groups = this.groups;
  var labels = this.dom.groups ? this.dom.groups.labels : [];
  for (var i = 0, iMax = groups.length; i < iMax; i++) {
    var group = groups[i];
    var label = labels[i];
    group.labelWidth = label ? label.clientWidth : 0;
    group.labelHeight = label ? label.clientHeight : 0;
    group.width = group.labelWidth; // TODO: group.width is redundant with labelWidth

    groupsWidth = Math.max(groupsWidth, group.width);
  }

  // limit groupsWidth to the groups width in the options
  if (options.groupsWidth !== undefined) {
    groupsWidth = dom.groups && dom.groups.frame ? dom.groups.frame.clientWidth : 0;
  }

  // compensate for the border width. TODO: calculate the real border width
  groupsWidth += 1;
  var groupsLeft = options.groupsOnRight ? size.frameWidth - groupsWidth : 0;
  resized = resized || size.groupsWidth !== groupsWidth;
  resized = resized || size.groupsLeft !== groupsLeft;
  size.groupsWidth = groupsWidth;
  size.groupsLeft = groupsLeft;
  return resized;
};

/**
 * Redraw the group labels
 */
links.Timeline.prototype.repaintGroups = function () {
  var dom = this.dom,
    timeline = this,
    options = this.options,
    size = this.size,
    groups = this.groups;
  if (dom.groups === undefined) {
    dom.groups = {};
  }
  var labels = dom.groups.labels;
  if (!labels) {
    labels = [];
    dom.groups.labels = labels;
  }
  var labelLines = dom.groups.labelLines;
  if (!labelLines) {
    labelLines = [];
    dom.groups.labelLines = labelLines;
  }
  var itemLines = dom.groups.itemLines;
  if (!itemLines) {
    itemLines = [];
    dom.groups.itemLines = itemLines;
  }

  // create the frame for holding the groups
  var frame = dom.groups.frame;
  if (!frame) {
    frame = document.createElement("DIV");
    frame.className = "timeline-groups-axis";
    frame.style.position = "absolute";
    frame.style.overflow = "hidden";
    frame.style.top = "0px";
    frame.style.height = "100%";
    dom.frame.appendChild(frame);
    dom.groups.frame = frame;
  }
  frame.style.left = size.groupsLeft + "px";
  frame.style.width = options.groupsWidth !== undefined ? options.groupsWidth : size.groupsWidth + "px";

  // hide groups axis when there are no groups
  if (groups.length == 0) {
    frame.style.display = 'none';
  } else {
    frame.style.display = '';
  }

  // TODO: only create/update groups when data is changed.

  // create the items
  var current = labels.length,
    needed = groups.length;

  // overwrite existing group labels
  for (var i = 0, iMax = Math.min(current, needed); i < iMax; i++) {
    var group = groups[i];
    var label = labels[i];
    label.innerHTML = this.getGroupName(group);
    label.style.display = '';
  }

  // append new items when needed
  for (var i = current; i < needed; i++) {
    var group = groups[i];

    // create text label
    var label = document.createElement("DIV");
    label.className = "timeline-groups-text";
    label.style.position = "absolute";
    if (options.groupsWidth === undefined) {
      label.style.whiteSpace = "nowrap";
    }
    label.innerHTML = this.getGroupName(group);
    frame.appendChild(label);
    labels[i] = label;

    // create the grid line between the group labels
    var labelLine = document.createElement("DIV");
    labelLine.className = "timeline-axis-grid timeline-axis-grid-minor";
    labelLine.style.position = "absolute";
    labelLine.style.left = "0px";
    labelLine.style.width = "100%";
    labelLine.style.height = "0px";
    labelLine.style.borderTopStyle = "solid";
    frame.appendChild(labelLine);
    labelLines[i] = labelLine;

    // create the grid line between the items
    var itemLine = document.createElement("DIV");
    itemLine.className = "timeline-axis-grid timeline-axis-grid-minor";
    itemLine.style.position = "absolute";
    itemLine.style.left = "0px";
    itemLine.style.width = "100%";
    itemLine.style.height = "0px";
    itemLine.style.borderTopStyle = "solid";
    dom.content.insertBefore(itemLine, dom.content.firstChild);
    itemLines[i] = itemLine;
  }

  // remove redundant items from the DOM when needed
  for (var i = needed; i < current; i++) {
    var label = labels[i],
      labelLine = labelLines[i],
      itemLine = itemLines[i];
    frame.removeChild(label);
    frame.removeChild(labelLine);
    dom.content.removeChild(itemLine);
  }
  labels.splice(needed, current - needed);
  labelLines.splice(needed, current - needed);
  itemLines.splice(needed, current - needed);
  links.Timeline.addClassName(frame, options.groupsOnRight ? 'timeline-groups-axis-onright' : 'timeline-groups-axis-onleft');

  // position the groups
  for (var i = 0, iMax = groups.length; i < iMax; i++) {
    var group = groups[i],
      label = labels[i],
      labelLine = labelLines[i],
      itemLine = itemLines[i];
    label.style.top = group.labelTop + "px";
    labelLine.style.top = group.lineTop + "px";
    itemLine.style.top = group.lineTop + "px";
    itemLine.style.width = size.contentWidth + "px";
  }
  if (!dom.groups.background) {
    // create the axis grid line background
    var background = document.createElement("DIV");
    background.className = "timeline-axis";
    background.style.position = "absolute";
    background.style.left = "0px";
    background.style.width = "100%";
    background.style.border = "none";
    frame.appendChild(background);
    dom.groups.background = background;
  }
  dom.groups.background.style.top = size.axis.top + 'px';
  dom.groups.background.style.height = size.axis.height + 'px';
  if (!dom.groups.line) {
    // create the axis grid line
    var line = document.createElement("DIV");
    line.className = "timeline-axis";
    line.style.position = "absolute";
    line.style.left = "0px";
    line.style.width = "100%";
    line.style.height = "0px";
    frame.appendChild(line);
    dom.groups.line = line;
  }
  dom.groups.line.style.top = size.axis.line + 'px';

  // create a callback when there are images which are not yet loaded
  // TODO: more efficiently load images in the groups
  if (dom.groups.frame && groups.length) {
    var imageUrls = [];
    links.imageloader.filterImageUrls(dom.groups.frame, imageUrls);
    if (imageUrls.length) {
      // retrieve all image sources from the items, and set a callback once
      // all images are retrieved
      var callback = function callback() {
        timeline.render();
      };
      var sendCallbackWhenAlreadyLoaded = false;
      links.imageloader.loadAll(imageUrls, callback, sendCallbackWhenAlreadyLoaded);
    }
  }
};

/**
 * Redraw the current time bar
 */
links.Timeline.prototype.repaintCurrentTime = function () {
  var options = this.options,
    dom = this.dom,
    size = this.size;
  if (!options.showCurrentTime) {
    if (dom.currentTime) {
      dom.contentTimelines.removeChild(dom.currentTime);
      delete dom.currentTime;
    }
    return;
  }
  if (!dom.currentTime) {
    // create the current time bar
    var currentTime = document.createElement("DIV");
    currentTime.className = "timeline-currenttime";
    currentTime.style.position = "absolute";
    currentTime.style.top = "0px";
    currentTime.style.height = "100%";
    dom.contentTimelines.appendChild(currentTime);
    dom.currentTime = currentTime;
  }
  var now = new Date();
  var nowOffset = new Date(now.valueOf() + this.clientTimeOffset);
  var x = this.timeToScreen(nowOffset);
  var visible = x > -size.contentWidth && x < 2 * size.contentWidth;
  dom.currentTime.style.display = visible ? '' : 'none';
  dom.currentTime.style.left = x + "px";
  dom.currentTime.title = "Current time: " + nowOffset;

  // start a timer to adjust for the new time
  if (this.currentTimeTimer != undefined) {
    clearTimeout(this.currentTimeTimer);
    delete this.currentTimeTimer;
  }
  var timeline = this;
  var onTimeout = function onTimeout() {
    timeline.repaintCurrentTime();
  };
  // the time equal to the width of one pixel, divided by 2 for more smoothness
  var interval = 1 / this.conversion.factor / 2;
  if (interval < 30) interval = 30;
  this.currentTimeTimer = setTimeout(onTimeout, interval);
};

/**
 * Redraw the custom time bar
 */
links.Timeline.prototype.repaintCustomTime = function () {
  var options = this.options,
    dom = this.dom,
    size = this.size;
  if (!options.showCustomTime) {
    if (dom.customTime) {
      dom.contentTimelines.removeChild(dom.customTime);
      delete dom.customTime;
    }
    return;
  }
  if (!dom.customTime) {
    var customTime = document.createElement("DIV");
    customTime.className = "timeline-customtime";
    customTime.style.position = "absolute";
    customTime.style.top = "0px";
    customTime.style.height = "100%";
    var drag = document.createElement("DIV");
    drag.style.position = "relative";
    drag.style.top = "0px";
    drag.style.left = "-10px";
    drag.style.height = "100%";
    drag.style.width = "20px";
    customTime.appendChild(drag);
    dom.contentTimelines.appendChild(customTime);
    dom.customTime = customTime;

    // initialize parameter
    this.customTime = new Date();
  }
  var x = this.timeToScreen(this.customTime),
    visible = x > -size.contentWidth && x < 2 * size.contentWidth;
  dom.customTime.style.display = visible ? '' : 'none';
  dom.customTime.style.left = x + "px";
  dom.customTime.title = "Time: " + this.customTime;
};

/**
 * Redraw the delete button, on the top right of the currently selected item
 * if there is no item selected, the button is hidden.
 */
links.Timeline.prototype.repaintDeleteButton = function () {
  var timeline = this,
    dom = this.dom,
    frame = dom.items.frame;
  var deleteButton = dom.items.deleteButton;
  if (!deleteButton) {
    // create a delete button
    deleteButton = document.createElement("DIV");
    deleteButton.className = "timeline-navigation-delete";
    deleteButton.style.position = "absolute";
    frame.appendChild(deleteButton);
    dom.items.deleteButton = deleteButton;
  }
  var index = this.selection && this.selection.index !== undefined ? this.selection.index : -1,
    item = this.selection && this.selection.index !== undefined ? this.items[index] : undefined;
  if (item && item.rendered && this.isEditable(item)) {
    var right = item.getRight(this),
      top = item.top;
    deleteButton.style.left = right + 'px';
    deleteButton.style.top = top + 'px';
    deleteButton.style.display = '';
    frame.removeChild(deleteButton);
    frame.appendChild(deleteButton);
  } else {
    deleteButton.style.display = 'none';
  }
};

/**
 * Redraw the drag areas. When an item (ranges only) is selected,
 * it gets a drag area on the left and right side, to change its width
 */
links.Timeline.prototype.repaintDragAreas = function () {
  var timeline = this,
    options = this.options,
    dom = this.dom,
    frame = this.dom.items.frame;

  // create left drag area
  var dragLeft = dom.items.dragLeft;
  if (!dragLeft) {
    dragLeft = document.createElement("DIV");
    dragLeft.className = "timeline-event-range-drag-left";
    dragLeft.style.position = "absolute";
    frame.appendChild(dragLeft);
    dom.items.dragLeft = dragLeft;
  }

  // create right drag area
  var dragRight = dom.items.dragRight;
  if (!dragRight) {
    dragRight = document.createElement("DIV");
    dragRight.className = "timeline-event-range-drag-right";
    dragRight.style.position = "absolute";
    frame.appendChild(dragRight);
    dom.items.dragRight = dragRight;
  }

  // reposition left and right drag area
  var index = this.selection && this.selection.index !== undefined ? this.selection.index : -1,
    item = this.selection && this.selection.index !== undefined ? this.items[index] : undefined;
  if (item && item.rendered && this.isEditable(item) && (item instanceof links.Timeline.ItemRange || item instanceof links.Timeline.ItemFloatingRange)) {
    var left = item.getLeft(this),
      // NH change to getLeft
      right = item.getRight(this),
      // NH change to getRight
      top = item.top,
      height = item.height;
    dragLeft.style.left = left + 'px';
    dragLeft.style.top = top + 'px';
    dragLeft.style.width = options.dragAreaWidth + "px";
    dragLeft.style.height = height + 'px';
    dragLeft.style.display = '';
    frame.removeChild(dragLeft);
    frame.appendChild(dragLeft);
    dragRight.style.left = right - options.dragAreaWidth + 'px';
    dragRight.style.top = top + 'px';
    dragRight.style.width = options.dragAreaWidth + "px";
    dragRight.style.height = height + 'px';
    dragRight.style.display = '';
    frame.removeChild(dragRight);
    frame.appendChild(dragRight);
  } else {
    dragLeft.style.display = 'none';
    dragRight.style.display = 'none';
  }
};

/**
 * Create the navigation buttons for zooming and moving
 */
links.Timeline.prototype.repaintNavigation = function () {
  var timeline = this,
    options = this.options,
    dom = this.dom,
    frame = dom.frame,
    navBar = dom.navBar;
  if (!navBar) {
    var showButtonNew = options.showButtonNew && options.editable;
    var showNavigation = options.showNavigation && (options.zoomable || options.moveable);
    if (showNavigation || showButtonNew) {
      // create a navigation bar containing the navigation buttons
      navBar = document.createElement("DIV");
      navBar.style.position = "absolute";
      navBar.className = "timeline-navigation ui-widget ui-state-highlight ui-corner-all";
      if (options.groupsOnRight) {
        navBar.style.left = '10px';
      } else {
        navBar.style.right = '10px';
      }
      if (options.axisOnTop) {
        navBar.style.bottom = '10px';
      } else {
        navBar.style.top = '10px';
      }
      dom.navBar = navBar;
      frame.appendChild(navBar);
    }
    if (showButtonNew) {
      // create a new in button
      navBar.addButton = document.createElement("DIV");
      navBar.addButton.className = "timeline-navigation-new";
      navBar.addButton.title = options.CREATE_NEW_EVENT;
      var addIconSpan = document.createElement("SPAN");
      addIconSpan.className = "ui-icon ui-icon-circle-plus";
      navBar.addButton.appendChild(addIconSpan);
      var onAdd = function onAdd(event) {
        links.Timeline.preventDefault(event);
        links.Timeline.stopPropagation(event);

        // create a new event at the center of the frame
        var w = timeline.size.contentWidth;
        var x = w / 2;
        var xstart = timeline.screenToTime(x);
        if (options.snapEvents) {
          timeline.step.snap(xstart);
        }
        var content = options.NEW;
        var group = timeline.groups.length ? timeline.groups[0].content : undefined;
        var preventRender = true;
        timeline.addItem({
          'start': xstart,
          'content': content,
          'group': group
        }, preventRender);
        var index = timeline.items.length - 1;
        timeline.selectItem(index);
        timeline.applyAdd = true;

        // fire an add event.
        // Note that the change can be canceled from within an event listener if
        // this listener calls the method cancelAdd().
        timeline.trigger('add');
        if (timeline.applyAdd) {
          // render and select the item
          timeline.render({
            animate: false
          });
          timeline.selectItem(index);
        } else {
          // undo an add
          timeline.deleteItem(index);
        }
      };
      links.Timeline.addEventListener(navBar.addButton, "mousedown", onAdd);
      navBar.appendChild(navBar.addButton);
    }
    if (showButtonNew && showNavigation) {
      // create a separator line
      links.Timeline.addClassName(navBar.addButton, 'timeline-navigation-new-line');
    }
    if (showNavigation) {
      if (options.zoomable) {
        // create a zoom in button
        navBar.zoomInButton = document.createElement("DIV");
        navBar.zoomInButton.className = "timeline-navigation-zoom-in";
        navBar.zoomInButton.title = this.options.ZOOM_IN;
        var ziIconSpan = document.createElement("SPAN");
        ziIconSpan.className = "ui-icon ui-icon-circle-zoomin";
        navBar.zoomInButton.appendChild(ziIconSpan);
        var onZoomIn = function onZoomIn(event) {
          links.Timeline.preventDefault(event);
          links.Timeline.stopPropagation(event);
          timeline.zoom(0.4);
          timeline.trigger("rangechange");
          timeline.trigger("rangechanged");
        };
        links.Timeline.addEventListener(navBar.zoomInButton, "mousedown", onZoomIn);
        navBar.appendChild(navBar.zoomInButton);

        // create a zoom out button
        navBar.zoomOutButton = document.createElement("DIV");
        navBar.zoomOutButton.className = "timeline-navigation-zoom-out";
        navBar.zoomOutButton.title = this.options.ZOOM_OUT;
        var zoIconSpan = document.createElement("SPAN");
        zoIconSpan.className = "ui-icon ui-icon-circle-zoomout";
        navBar.zoomOutButton.appendChild(zoIconSpan);
        var onZoomOut = function onZoomOut(event) {
          links.Timeline.preventDefault(event);
          links.Timeline.stopPropagation(event);
          timeline.zoom(-0.4);
          timeline.trigger("rangechange");
          timeline.trigger("rangechanged");
        };
        links.Timeline.addEventListener(navBar.zoomOutButton, "mousedown", onZoomOut);
        navBar.appendChild(navBar.zoomOutButton);
      }
      if (options.moveable) {
        // create a move left button
        navBar.moveLeftButton = document.createElement("DIV");
        navBar.moveLeftButton.className = "timeline-navigation-move-left";
        navBar.moveLeftButton.title = this.options.MOVE_LEFT;
        var mlIconSpan = document.createElement("SPAN");
        mlIconSpan.className = "ui-icon ui-icon-circle-arrow-w";
        navBar.moveLeftButton.appendChild(mlIconSpan);
        var onMoveLeft = function onMoveLeft(event) {
          links.Timeline.preventDefault(event);
          links.Timeline.stopPropagation(event);
          timeline.move(-0.2);
          timeline.trigger("rangechange");
          timeline.trigger("rangechanged");
        };
        links.Timeline.addEventListener(navBar.moveLeftButton, "mousedown", onMoveLeft);
        navBar.appendChild(navBar.moveLeftButton);

        // create a move right button
        navBar.moveRightButton = document.createElement("DIV");
        navBar.moveRightButton.className = "timeline-navigation-move-right";
        navBar.moveRightButton.title = this.options.MOVE_RIGHT;
        var mrIconSpan = document.createElement("SPAN");
        mrIconSpan.className = "ui-icon ui-icon-circle-arrow-e";
        navBar.moveRightButton.appendChild(mrIconSpan);
        var onMoveRight = function onMoveRight(event) {
          links.Timeline.preventDefault(event);
          links.Timeline.stopPropagation(event);
          timeline.move(0.2);
          timeline.trigger("rangechange");
          timeline.trigger("rangechanged");
        };
        links.Timeline.addEventListener(navBar.moveRightButton, "mousedown", onMoveRight);
        navBar.appendChild(navBar.moveRightButton);
      }
    }
  }
};

/**
 * Set current time. This function can be used to set the time in the client
 * timeline equal with the time on a server.
 * @param {Date} time
 */
links.Timeline.prototype.setCurrentTime = function (time) {
  var now = new Date();
  this.clientTimeOffset = time.valueOf() - now.valueOf();
  this.repaintCurrentTime();
};

/**
 * Get current time. The time can have an offset from the real time, when
 * the current time has been changed via the method setCurrentTime.
 * @return {Date} time
 */
links.Timeline.prototype.getCurrentTime = function () {
  var now = new Date();
  return new Date(now.valueOf() + this.clientTimeOffset);
};

/**
 * Set custom time.
 * The custom time bar can be used to display events in past or future.
 * @param {Date} time
 */
links.Timeline.prototype.setCustomTime = function (time) {
  this.customTime = new Date(time.valueOf());
  this.repaintCustomTime();
};

/**
 * Retrieve the current custom time.
 * @return {Date} customTime
 */
links.Timeline.prototype.getCustomTime = function () {
  return new Date(this.customTime.valueOf());
};

/**
 * Set a custom scale. Autoscaling will be disabled.
 * For example setScale(SCALE.MINUTES, 5) will result
 * in minor steps of 5 minutes, and major steps of an hour.
 *
 * @param {links.Timeline.StepDate.SCALE} scale
 *                               A scale. Choose from SCALE.MILLISECOND,
 *                               SCALE.SECOND, SCALE.MINUTE, SCALE.HOUR,
 *                               SCALE.WEEKDAY, SCALE.DAY, SCALE.MONTH,
 *                               SCALE.YEAR.
 * @param {int}        step   A step size, by default 1. Choose for
 *                               example 1, 2, 5, or 10.
 */
links.Timeline.prototype.setScale = function (scale, step) {
  this.step.setScale(scale, step);
  this.render(); // TODO: optimize: only reflow/repaint axis
};

/**
 * Enable or disable autoscaling
 * @param {boolean} enable  If true or not defined, autoscaling is enabled.
 *                          If false, autoscaling is disabled.
 */
links.Timeline.prototype.setAutoScale = function (enable) {
  this.step.setAutoScale(enable);
  this.render(); // TODO: optimize: only reflow/repaint axis
};

/**
 * Redraw the timeline
 * Reloads the (linked) data table and redraws the timeline when resized.
 * See also the method checkResize
 */
links.Timeline.prototype.redraw = function () {
  this.setData(this.data);
};

/**
 * Check if the timeline is resized, and if so, redraw the timeline.
 * Useful when the webpage is resized.
 */
links.Timeline.prototype.checkResize = function () {
  // TODO: re-implement the method checkResize, or better, make it redundant as this.render will be smarter
  this.render();
};

/**
 * Check whether a given item is editable
 * @param {links.Timeline.Item} item
 * @return {boolean} editable
 */
links.Timeline.prototype.isEditable = function (item) {
  if (item) {
    if (item.editable != undefined) {
      return item.editable;
    } else {
      return this.options.editable;
    }
  }
  return false;
};

/**
 * Calculate the factor and offset to convert a position on screen to the
 * corresponding date and vice versa.
 * After the method calcConversionFactor is executed once, the methods screenToTime and
 * timeToScreen can be used.
 */
links.Timeline.prototype.recalcConversion = function () {
  this.conversion.offset = this.start.valueOf();
  this.conversion.factor = this.size.contentWidth / (this.end.valueOf() - this.start.valueOf());
};

/**
 * Convert a position on screen (pixels) to a datetime
 * Before this method can be used, the method calcConversionFactor must be
 * executed once.
 * @param {int}     x    Position on the screen in pixels
 * @return {Date}   time The datetime the corresponds with given position x
 */
links.Timeline.prototype.screenToTime = function (x) {
  var conversion = this.conversion;
  return new Date(x / conversion.factor + conversion.offset);
};

/**
 * Convert a datetime (Date object) into a position on the screen
 * Before this method can be used, the method calcConversionFactor must be
 * executed once.
 * @param {Date}   time A date
 * @return {int}   x    The position on the screen in pixels which corresponds
 *                      with the given date.
 */
links.Timeline.prototype.timeToScreen = function (time) {
  var conversion = this.conversion;
  return (time.valueOf() - conversion.offset) * conversion.factor;
};

/**
 * Event handler for touchstart event on mobile devices
 */
links.Timeline.prototype.onTouchStart = function (event) {
  var params = this.eventParams,
    me = this;
  if (params.touchDown) {
    // if already moving, return
    return;
  }
  params.touchDown = true;
  params.zoomed = false;
  this.onMouseDown(event);
  if (!params.onTouchMove) {
    params.onTouchMove = function (event) {
      me.onTouchMove(event);
    };
    links.Timeline.addEventListener(document, "touchmove", params.onTouchMove);
  }
  if (!params.onTouchEnd) {
    params.onTouchEnd = function (event) {
      me.onTouchEnd(event);
    };
    links.Timeline.addEventListener(document, "touchend", params.onTouchEnd);
  }

  /* TODO
   // check for double tap event
   var delta = 500; // ms
   var doubleTapStart = (new Date()).valueOf();
   var target = links.Timeline.getTarget(event);
   var doubleTapItem = this.getItemIndex(target);
   if (params.doubleTapStart &&
   (doubleTapStart - params.doubleTapStart) < delta &&
   doubleTapItem == params.doubleTapItem) {
   delete params.doubleTapStart;
   delete params.doubleTapItem;
   me.onDblClick(event);
   params.touchDown = false;
   }
   params.doubleTapStart = doubleTapStart;
   params.doubleTapItem = doubleTapItem;
   */
  // store timing for double taps
  var target = links.Timeline.getTarget(event);
  var item = this.getItemIndex(target);
  params.doubleTapStartPrev = params.doubleTapStart;
  params.doubleTapStart = new Date().valueOf();
  params.doubleTapItemPrev = params.doubleTapItem;
  params.doubleTapItem = item;
  links.Timeline.preventDefault(event);
};

/**
 * Event handler for touchmove event on mobile devices
 */
links.Timeline.prototype.onTouchMove = function (event) {
  var params = this.eventParams;
  if (event.scale && event.scale !== 1) {
    params.zoomed = true;
  }
  if (!params.zoomed) {
    // move
    this.onMouseMove(event);
  } else {
    if (this.options.zoomable) {
      // pinch
      // TODO: pinch only supported on iPhone/iPad. Create something manually for Android?
      params.zoomed = true;
      var scale = event.scale,
        oldWidth = params.end.valueOf() - params.start.valueOf(),
        newWidth = oldWidth / scale,
        diff = newWidth - oldWidth,
        start = new Date(parseInt(params.start.valueOf() - diff / 2)),
        end = new Date(parseInt(params.end.valueOf() + diff / 2));

      // TODO: determine zoom-around-date from touch positions?

      this.setVisibleChartRange(start, end);
      this.trigger("rangechange");
    }
  }
  links.Timeline.preventDefault(event);
};

/**
 * Event handler for touchend event on mobile devices
 */
links.Timeline.prototype.onTouchEnd = function (event) {
  var params = this.eventParams;
  var me = this;
  params.touchDown = false;
  if (params.zoomed) {
    this.trigger("rangechanged");
  }
  if (params.onTouchMove) {
    links.Timeline.removeEventListener(document, "touchmove", params.onTouchMove);
    delete params.onTouchMove;
  }
  if (params.onTouchEnd) {
    links.Timeline.removeEventListener(document, "touchend", params.onTouchEnd);
    delete params.onTouchEnd;
  }
  this.onMouseUp(event);

  // check for double tap event
  var delta = 500; // ms
  var doubleTapEnd = new Date().valueOf();
  var target = links.Timeline.getTarget(event);
  var doubleTapItem = this.getItemIndex(target);
  if (params.doubleTapStartPrev && doubleTapEnd - params.doubleTapStartPrev < delta && params.doubleTapItem == params.doubleTapItemPrev) {
    params.touchDown = true;
    me.onDblClick(event);
    params.touchDown = false;
  }
  links.Timeline.preventDefault(event);
};

/**
 * Start a moving operation inside the provided parent element
 * @param {Event} event       The event that occurred (required for
 *                             retrieving the  mouse position)
 */
links.Timeline.prototype.onMouseDown = function (event) {
  event = event || window.event;
  var params = this.eventParams,
    options = this.options,
    dom = this.dom;

  // only react on left mouse button down
  var leftButtonDown = event.which ? event.which == 1 : event.button == 1;
  if (!leftButtonDown && !params.touchDown) {
    return;
  }

  // get mouse position
  params.mouseX = links.Timeline.getPageX(event);
  params.mouseY = links.Timeline.getPageY(event);
  params.frameLeft = links.Timeline.getAbsoluteLeft(this.dom.content);
  params.frameTop = links.Timeline.getAbsoluteTop(this.dom.content);
  params.previousLeft = 0;
  params.previousOffset = 0;
  params.moved = false;
  params.start = new Date(this.start.valueOf());
  params.end = new Date(this.end.valueOf());
  params.target = links.Timeline.getTarget(event);
  var dragLeft = dom.items && dom.items.dragLeft ? dom.items.dragLeft : undefined;
  var dragRight = dom.items && dom.items.dragRight ? dom.items.dragRight : undefined;
  params.itemDragLeft = params.target === dragLeft;
  params.itemDragRight = params.target === dragRight;
  if (params.itemDragLeft || params.itemDragRight) {
    params.itemIndex = this.selection && this.selection.index !== undefined ? this.selection.index : undefined;
    delete params.clusterIndex;
  } else {
    params.itemIndex = this.getItemIndex(params.target);
    params.clusterIndex = this.getClusterIndex(params.target);
  }
  params.customTime = params.target === dom.customTime || params.target.parentNode === dom.customTime ? this.customTime : undefined;
  params.addItem = options.editable && event.ctrlKey;
  if (params.addItem) {
    // create a new event at the current mouse position
    var x = params.mouseX - params.frameLeft;
    var y = params.mouseY - params.frameTop;
    var xstart = this.screenToTime(x);
    if (options.snapEvents) {
      this.step.snap(xstart);
    }
    var xend = new Date(xstart.valueOf());
    var content = options.NEW;
    var group = this.getGroupFromHeight(y);
    this.addItem({
      'start': xstart,
      'end': xend,
      'content': content,
      'group': this.getGroupName(group)
    });
    params.itemIndex = this.items.length - 1;
    delete params.clusterIndex;
    this.selectItem(params.itemIndex);
    params.itemDragRight = true;
  }
  var item = this.items[params.itemIndex];
  var isSelected = this.isSelected(params.itemIndex);
  params.editItem = isSelected && this.isEditable(item);
  if (params.editItem) {
    params.itemStart = item.start;
    params.itemEnd = item.end;
    params.itemGroup = item.group;
    params.itemLeft = item.getLeft(this); // NH Use item.getLeft here
    params.itemRight = item.getRight(this); // NH Use item.getRight here
  } else {
    this.dom.frame.style.cursor = 'move';
  }
  if (!params.touchDown) {
    // add event listeners to handle moving the contents
    // we store the function onmousemove and onmouseup in the timeline, so we can
    // remove the eventlisteners lateron in the function mouseUp()
    var me = this;
    if (!params.onMouseMove) {
      params.onMouseMove = function (event) {
        me.onMouseMove(event);
      };
      links.Timeline.addEventListener(document, "mousemove", params.onMouseMove);
    }
    if (!params.onMouseUp) {
      params.onMouseUp = function (event) {
        me.onMouseUp(event);
      };
      links.Timeline.addEventListener(document, "mouseup", params.onMouseUp);
    }
    links.Timeline.preventDefault(event);
  }
};

/**
 * Perform moving operating.
 * This function activated from within the funcion links.Timeline.onMouseDown().
 * @param {Event}   event  Well, eehh, the event
 */
links.Timeline.prototype.onMouseMove = function (event) {
  event = event || window.event;
  var params = this.eventParams,
    size = this.size,
    dom = this.dom,
    options = this.options;

  // calculate change in mouse position
  var mouseX = links.Timeline.getPageX(event);
  var mouseY = links.Timeline.getPageY(event);
  if (params.mouseX == undefined) {
    params.mouseX = mouseX;
  }
  if (params.mouseY == undefined) {
    params.mouseY = mouseY;
  }
  var diffX = mouseX - params.mouseX;
  var diffY = mouseY - params.mouseY;

  // if mouse movement is big enough, register it as a "moved" event
  if (Math.abs(diffX) >= 1) {
    params.moved = true;
  }
  if (params.customTime) {
    var x = this.timeToScreen(params.customTime);
    var xnew = x + diffX;
    this.customTime = this.screenToTime(xnew);
    this.repaintCustomTime();

    // fire a timechange event
    this.trigger('timechange');
  } else if (params.editItem) {
    var item = this.items[params.itemIndex],
      left,
      right;
    if (params.itemDragLeft && options.timeChangeable) {
      // move the start of the item
      left = params.itemLeft + diffX;
      right = params.itemRight;
      item.start = this.screenToTime(left);
      if (options.snapEvents) {
        this.step.snap(item.start);
        left = this.timeToScreen(item.start);
      }
      if (left > right) {
        left = right;
        item.start = this.screenToTime(left);
      }
      this.trigger('change');
    } else if (params.itemDragRight && options.timeChangeable) {
      // move the end of the item
      left = params.itemLeft;
      right = params.itemRight + diffX;
      item.end = this.screenToTime(right);
      if (options.snapEvents) {
        this.step.snap(item.end);
        right = this.timeToScreen(item.end);
      }
      if (right < left) {
        right = left;
        item.end = this.screenToTime(right);
      }
      this.trigger('change');
    } else if (options.timeChangeable) {
      // move the item
      left = params.itemLeft + diffX;
      item.start = this.screenToTime(left);
      if (options.snapEvents) {
        this.step.snap(item.start);
        left = this.timeToScreen(item.start);
      }
      if (item.end) {
        right = left + (params.itemRight - params.itemLeft);
        item.end = this.screenToTime(right);
      }
      this.trigger('change');
    }
    item.setPosition(left, right);
    var dragging = params.itemDragLeft || params.itemDragRight;
    if (this.groups.length && !dragging) {
      // move item from one group to another when needed
      var y = mouseY - params.frameTop;
      var group = this.getGroupFromHeight(y);
      if (options.groupsChangeable && item.group !== group) {
        // move item to the other group
        var index = this.items.indexOf(item);
        this.changeItem(index, {
          'group': this.getGroupName(group)
        });
      } else {
        this.repaintDeleteButton();
        this.repaintDragAreas();
      }
    } else {
      // TODO: does not work well in FF, forces redraw with every mouse move it seems
      this.render(); // TODO: optimize, only redraw the items?
      // Note: when animate==true, no redraw is needed here, its done by stackItems animation
    }
  } else if (options.moveable) {
    var interval = params.end.valueOf() - params.start.valueOf();
    var diffMillisecs = Math.round(-diffX / size.contentWidth * interval);
    var newStart = new Date(params.start.valueOf() + diffMillisecs);
    var newEnd = new Date(params.end.valueOf() + diffMillisecs);
    this.applyRange(newStart, newEnd);
    // if the applied range is moved due to a fixed min or max,
    // change the diffMillisecs accordingly
    var appliedDiff = this.start.valueOf() - newStart.valueOf();
    if (appliedDiff) {
      diffMillisecs += appliedDiff;
    }
    this.recalcConversion();

    // move the items by changing the left position of their frame.
    // this is much faster than repositioning all elements individually via the
    // repaintFrame() function (which is done once at mouseup)
    // note that we round diffX to prevent wrong positioning on millisecond scale
    var previousLeft = params.previousLeft || 0;
    var currentLeft = parseFloat(dom.items.frame.style.left) || 0;
    var previousOffset = params.previousOffset || 0;
    var frameOffset = previousOffset + (currentLeft - previousLeft);
    var frameLeft = -diffMillisecs / interval * size.contentWidth + frameOffset;
    dom.items.frame.style.left = frameLeft + "px";

    // read the left again from DOM (IE8- rounds the value)
    params.previousOffset = frameOffset;
    params.previousLeft = parseFloat(dom.items.frame.style.left) || frameLeft;
    this.repaintCurrentTime();
    this.repaintCustomTime();
    this.repaintAxis();

    // fire a rangechange event
    this.trigger('rangechange');
  }
  links.Timeline.preventDefault(event);
};

/**
 * Stop moving operating.
 * This function activated from within the funcion links.Timeline.onMouseDown().
 * @param {event}  event   The event
 */
links.Timeline.prototype.onMouseUp = function (event) {
  var params = this.eventParams,
    options = this.options;
  event = event || window.event;
  this.dom.frame.style.cursor = 'auto';

  // remove event listeners here, important for Safari
  if (params.onMouseMove) {
    links.Timeline.removeEventListener(document, "mousemove", params.onMouseMove);
    delete params.onMouseMove;
  }
  if (params.onMouseUp) {
    links.Timeline.removeEventListener(document, "mouseup", params.onMouseUp);
    delete params.onMouseUp;
  }
  //links.Timeline.preventDefault(event);

  if (params.customTime) {
    // fire a timechanged event
    this.trigger('timechanged');
  } else if (params.editItem) {
    var item = this.items[params.itemIndex];
    if (params.moved || params.addItem) {
      this.applyChange = true;
      this.applyAdd = true;
      this.updateData(params.itemIndex, {
        'start': item.start,
        'end': item.end
      });

      // fire an add or changed event.
      // Note that the change can be canceled from within an event listener if
      // this listener calls the method cancelChange().
      this.trigger(params.addItem ? 'add' : 'changed');

      //retrieve item data again to include changes made to it in the triggered event handlers
      item = this.items[params.itemIndex];
      if (params.addItem) {
        if (this.applyAdd) {
          this.updateData(params.itemIndex, {
            'start': item.start,
            'end': item.end,
            'content': item.content,
            'group': this.getGroupName(item.group)
          });
        } else {
          // undo an add
          this.deleteItem(params.itemIndex);
        }
      } else {
        if (this.applyChange) {
          this.updateData(params.itemIndex, {
            'start': item.start,
            'end': item.end
          });
        } else {
          // undo a change
          delete this.applyChange;
          delete this.applyAdd;
          var item = this.items[params.itemIndex],
            domItem = item.dom;
          item.start = params.itemStart;
          item.end = params.itemEnd;
          item.group = params.itemGroup;
          // TODO: original group should be restored too
          item.setPosition(params.itemLeft, params.itemRight);
          this.updateData(params.itemIndex, {
            'start': params.itemStart,
            'end': params.itemEnd
          });
        }
      }

      // prepare data for clustering, by filtering and sorting by type
      if (this.options.cluster) {
        this.clusterGenerator.updateData();
      }
      this.render();
    }
  } else {
    if (!params.moved && !params.zoomed) {
      // mouse did not move -> user has selected an item

      if (params.target === this.dom.items.deleteButton) {
        // delete item
        if (this.selection && this.selection.index !== undefined) {
          this.confirmDeleteItem(this.selection.index);
        }
      } else if (options.selectable) {
        // select/unselect item
        if (params.itemIndex != undefined) {
          if (!this.isSelected(params.itemIndex)) {
            this.selectItem(params.itemIndex);
            this.trigger('select');
          }
        } else if (params.clusterIndex != undefined) {
          this.selectCluster(params.clusterIndex);
          this.trigger('select');
        } else {
          if (options.unselectable) {
            this.unselectItem();
            this.trigger('select');
          }
        }
      }
    } else {
      // timeline is moved
      // TODO: optimize: no need to reflow and cluster again?
      this.render();
      if (params.moved && options.moveable || params.zoomed && options.zoomable) {
        // fire a rangechanged event
        this.trigger('rangechanged');
      }
    }
  }
};

/**
 * Double click event occurred for an item
 * @param {Event}  event
 */
links.Timeline.prototype.onDblClick = function (event) {
  var params = this.eventParams,
    options = this.options,
    dom = this.dom,
    size = this.size;
  event = event || window.event;
  if (params.itemIndex != undefined) {
    var item = this.items[params.itemIndex];
    if (item && this.isEditable(item)) {
      // fire the edit event
      this.trigger('edit');
    }
  } else {
    if (options.editable) {
      // create a new item

      // get mouse position
      params.mouseX = links.Timeline.getPageX(event);
      params.mouseY = links.Timeline.getPageY(event);
      var x = params.mouseX - links.Timeline.getAbsoluteLeft(dom.content);
      var y = params.mouseY - links.Timeline.getAbsoluteTop(dom.content);

      // create a new event at the current mouse position
      var xstart = this.screenToTime(x);
      if (options.snapEvents) {
        this.step.snap(xstart);
      }
      var content = options.NEW;
      var group = this.getGroupFromHeight(y); // (group may be undefined)
      var preventRender = true;
      this.addItem({
        'start': xstart,
        'content': content,
        'group': this.getGroupName(group)
      }, preventRender);
      params.itemIndex = this.items.length - 1;
      this.selectItem(params.itemIndex);
      this.applyAdd = true;

      // fire an add event.
      // Note that the change can be canceled from within an event listener if
      // this listener calls the method cancelAdd().
      this.trigger('add');
      if (this.applyAdd) {
        // render and select the item
        this.render({
          animate: false
        });
        this.selectItem(params.itemIndex);
      } else {
        // undo an add
        this.deleteItem(params.itemIndex);
      }
    }
  }
  links.Timeline.preventDefault(event);
};

/**
 * Event handler for mouse wheel event, used to zoom the timeline
 * Code from http://adomas.org/javascript-mouse-wheel/
 * @param {Event}  event   The event
 */
links.Timeline.prototype.onMouseWheel = function (event) {
  if (!this.options.zoomable) return;
  if (!event) {
    /* For IE. */
    event = window.event;
  }

  // retrieve delta
  var delta = 0;
  if (event.wheelDelta) {
    /* IE/Opera. */
    delta = event.wheelDelta / 120;
  } else if (event.detail) {
    /* Mozilla case. */
    // In Mozilla, sign of delta is different than in IE.
    // Also, delta is multiple of 3.
    delta = -event.detail / 3;
  }

  // If delta is nonzero, handle it.
  // Basically, delta is now positive if wheel was scrolled up,
  // and negative, if wheel was scrolled down.
  if (delta) {
    // TODO: on FireFox, the window is not redrawn within repeated scroll-events
    // -> use a delayed redraw? Make a zoom queue?

    var timeline = this;
    var zoom = function zoom() {
      // perform the zoom action. Delta is normally 1 or -1
      var zoomFactor = delta / 5.0;
      var frameLeft = links.Timeline.getAbsoluteLeft(timeline.dom.content);
      var mouseX = links.Timeline.getPageX(event);
      var zoomAroundDate = mouseX != undefined && frameLeft != undefined ? timeline.screenToTime(mouseX - frameLeft) : undefined;
      timeline.zoom(zoomFactor, zoomAroundDate);

      // fire a rangechange and a rangechanged event
      timeline.trigger("rangechange");
      timeline.trigger("rangechanged");
    };
    var scroll = function scroll() {
      // Scroll the timeline
      timeline.move(delta * -0.2);
      timeline.trigger("rangechange");
      timeline.trigger("rangechanged");
    };
    if (event.shiftKey) {
      scroll();
    } else {
      zoom();
    }
  }

  // Prevent default actions caused by mouse wheel.
  // That might be ugly, but we handle scrolls somehow
  // anyway, so don't bother here...
  links.Timeline.preventDefault(event);
};

/**
 * Zoom the timeline the given zoomfactor in or out. Start and end date will
 * be adjusted, and the timeline will be redrawn. You can optionally give a
 * date around which to zoom.
 * For example, try zoomfactor = 0.1 or -0.1
 * @param {Number} zoomFactor      Zooming amount. Positive value will zoom in,
 *                                 negative value will zoom out
 * @param {Date}   zoomAroundDate  Date around which will be zoomed. Optional
 */
links.Timeline.prototype.zoom = function (zoomFactor, zoomAroundDate) {
  // if zoomAroundDate is not provided, take it half between start Date and end Date
  if (zoomAroundDate == undefined) {
    zoomAroundDate = new Date((this.start.valueOf() + this.end.valueOf()) / 2);
  }

  // prevent zoom factor larger than 1 or smaller than -1 (larger than 1 will
  // result in a start>=end )
  if (zoomFactor >= 1) {
    zoomFactor = 0.9;
  }
  if (zoomFactor <= -1) {
    zoomFactor = -0.9;
  }

  // adjust a negative factor such that zooming in with 0.1 equals zooming
  // out with a factor -0.1
  if (zoomFactor < 0) {
    zoomFactor = zoomFactor / (1 + zoomFactor);
  }

  // zoom start Date and end Date relative to the zoomAroundDate
  var startDiff = this.start.valueOf() - zoomAroundDate;
  var endDiff = this.end.valueOf() - zoomAroundDate;

  // calculate new dates
  var newStart = new Date(this.start.valueOf() - startDiff * zoomFactor);
  var newEnd = new Date(this.end.valueOf() - endDiff * zoomFactor);

  // only zoom in when interval is larger than minimum interval (to prevent
  // sliding to left/right when having reached the minimum zoom level)
  var interval = newEnd.valueOf() - newStart.valueOf();
  var zoomMin = Number(this.options.zoomMin) || 10;
  if (zoomMin < 10) {
    zoomMin = 10;
  }
  if (interval >= zoomMin) {
    this.applyRange(newStart, newEnd, zoomAroundDate);
    this.render({
      animate: this.options.animate && this.options.animateZoom
    });
  }
};

/**
 * Move the timeline the given movefactor to the left or right. Start and end
 * date will be adjusted, and the timeline will be redrawn.
 * For example, try moveFactor = 0.1 or -0.1
 * @param {Number}  moveFactor      Moving amount. Positive value will move right,
 *                                 negative value will move left
 */
links.Timeline.prototype.move = function (moveFactor) {
  // zoom start Date and end Date relative to the zoomAroundDate
  var diff = this.end.valueOf() - this.start.valueOf();

  // apply new dates
  var newStart = new Date(this.start.valueOf() + diff * moveFactor);
  var newEnd = new Date(this.end.valueOf() + diff * moveFactor);
  this.applyRange(newStart, newEnd);
  this.render(); // TODO: optimize, no need to reflow, only to recalc conversion and repaint
};

/**
 * Apply a visible range. The range is limited to feasible maximum and minimum
 * range.
 * @param {Date} start
 * @param {Date} end
 * @param {Date}   zoomAroundDate  Optional. Date around which will be zoomed.
 */
links.Timeline.prototype.applyRange = function (start, end, zoomAroundDate) {
  // calculate new start and end value
  var startValue = start.valueOf(); // number
  var endValue = end.valueOf(); // number
  var interval = endValue - startValue;

  // determine maximum and minimum interval
  var options = this.options;
  var year = 1000 * 60 * 60 * 24 * 365;
  var zoomMin = Number(options.zoomMin) || 10;
  if (zoomMin < 10) {
    zoomMin = 10;
  }
  var zoomMax = Number(options.zoomMax) || 10000 * year;
  if (zoomMax > 10000 * year) {
    zoomMax = 10000 * year;
  }
  if (zoomMax < zoomMin) {
    zoomMax = zoomMin;
  }

  // determine min and max date value
  var min = options.min ? options.min.valueOf() : undefined; // number
  var max = options.max ? options.max.valueOf() : undefined; // number
  if (min != undefined && max != undefined) {
    if (min >= max) {
      // empty range
      var day = 1000 * 60 * 60 * 24;
      max = min + day;
    }
    if (zoomMax > max - min) {
      zoomMax = max - min;
    }
    if (zoomMin > max - min) {
      zoomMin = max - min;
    }
  }

  // prevent empty interval
  if (startValue >= endValue) {
    endValue += 1000 * 60 * 60 * 24;
  }

  // prevent too small scale
  // TODO: IE has problems with milliseconds
  if (interval < zoomMin) {
    var diff = zoomMin - interval;
    var f = zoomAroundDate ? (zoomAroundDate.valueOf() - startValue) / interval : 0.5;
    startValue -= Math.round(diff * f);
    endValue += Math.round(diff * (1 - f));
  }

  // prevent too large scale
  if (interval > zoomMax) {
    var diff = interval - zoomMax;
    var f = zoomAroundDate ? (zoomAroundDate.valueOf() - startValue) / interval : 0.5;
    startValue += Math.round(diff * f);
    endValue -= Math.round(diff * (1 - f));
  }

  // prevent to small start date
  if (min != undefined) {
    var diff = startValue - min;
    if (diff < 0) {
      startValue -= diff;
      endValue -= diff;
    }
  }

  // prevent to large end date
  if (max != undefined) {
    var diff = max - endValue;
    if (diff < 0) {
      startValue += diff;
      endValue += diff;
    }
  }

  // apply new dates
  this.start = new Date(startValue);
  this.end = new Date(endValue);
};

/**
 * Delete an item after a confirmation.
 * The deletion can be cancelled by executing .cancelDelete() during the
 * triggered event 'delete'.
 * @param {int} index   Index of the item to be deleted
 */
links.Timeline.prototype.confirmDeleteItem = function (index) {
  this.applyDelete = true;

  // select the event to be deleted
  if (!this.isSelected(index)) {
    this.selectItem(index);
  }

  // fire a delete event trigger.
  // Note that the delete event can be canceled from within an event listener if
  // this listener calls the method cancelChange().
  this.trigger('delete');
  if (this.applyDelete) {
    this.deleteItem(index);
  }
  delete this.applyDelete;
};

/**
 * Delete an item
 * @param {int} index   Index of the item to be deleted
 * @param {boolean} [preventRender=false]   Do not re-render timeline if true
 *                                          (optimization for multiple delete)
 */
links.Timeline.prototype.deleteItem = function (index, preventRender) {
  if (index >= this.items.length) {
    throw "Cannot delete row, index out of range";
  }
  if (this.selection && this.selection.index !== undefined) {
    // adjust the selection
    if (this.selection.index == index) {
      // item to be deleted is selected
      this.unselectItem();
    } else if (this.selection.index > index) {
      // update selection index
      this.selection.index--;
    }
  }

  // actually delete the item and remove it from the DOM
  var item = this.items.splice(index, 1)[0];
  this.renderQueue.hide.push(item);

  // delete the row in the original data table
  if (this.data) {
    if (google && google.visualization && this.data instanceof google.visualization.DataTable) {
      this.data.removeRow(index);
    } else if (links.Timeline.isArray(this.data)) {
      this.data.splice(index, 1);
    } else {
      throw "Cannot delete row from data, unknown data type";
    }
  }

  // prepare data for clustering, by filtering and sorting by type
  if (this.options.cluster) {
    this.clusterGenerator.updateData();
  }
  if (!preventRender) {
    this.render();
  }
};

/**
 * Delete all items
 */
links.Timeline.prototype.deleteAllItems = function () {
  this.unselectItem();

  // delete the loaded items
  this.clearItems();

  // delete the groups
  this.deleteGroups();

  // empty original data table
  if (this.data) {
    if (google && google.visualization && this.data instanceof google.visualization.DataTable) {
      this.data.removeRows(0, this.data.getNumberOfRows());
    } else if (links.Timeline.isArray(this.data)) {
      this.data.splice(0, this.data.length);
    } else {
      throw "Cannot delete row from data, unknown data type";
    }
  }

  // prepare data for clustering, by filtering and sorting by type
  if (this.options.cluster) {
    this.clusterGenerator.updateData();
  }
  this.render();
};

/**
 * Find the group from a given height in the timeline
 * @param {Number} height   Height in the timeline
 * @return {Object | undefined} group   The group object, or undefined if out
 *                                      of range
 */
links.Timeline.prototype.getGroupFromHeight = function (height) {
  var i,
    group,
    groups = this.groups;
  if (groups.length) {
    if (this.options.axisOnTop) {
      for (i = groups.length - 1; i >= 0; i--) {
        group = groups[i];
        if (height > group.top) {
          return group;
        }
      }
    } else {
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        if (height > group.top) {
          return group;
        }
      }
    }
    return group; // return the last group
  }

  return undefined;
};

/**
 * @constructor links.Timeline.Item
 * @param {Object} data       Object containing parameters start, end
 *                            content, group, type, editable.
 * @param {Object} [options]  Options to set initial property values
 *                                {Number} top
 *                                {Number} left
 *                                {Number} width
 *                                {Number} height
 */
links.Timeline.Item = function (data, options) {
  if (data) {
    /* TODO: use parseJSONDate as soon as it is tested and working (in two directions)
     this.start = links.Timeline.parseJSONDate(data.start);
     this.end = links.Timeline.parseJSONDate(data.end);
     */
    this.start = data.start;
    this.end = data.end;
    this.content = data.content;
    this.className = data.className;
    this.editable = data.editable;
    this.group = data.group;
    this.type = data.type;
  }
  this.top = 0;
  this.left = 0;
  this.width = 0;
  this.height = 0;
  this.lineWidth = 0;
  this.dotWidth = 0;
  this.dotHeight = 0;
  this.rendered = false; // true when the item is draw in the Timeline DOM

  if (options) {
    // override the default properties
    for (var option in options) {
      if (options.hasOwnProperty(option)) {
        this[option] = options[option];
      }
    }
  }
};

/**
 * Reflow the Item: retrieve its actual size from the DOM
 * @return {boolean} resized    returns true if the axis is resized
 */
links.Timeline.Item.prototype.reflow = function () {
  // Should be implemented by sub-prototype
  return false;
};

/**
 * Append all image urls present in the items DOM to the provided array
 * @param {String[]} imageUrls
 */
links.Timeline.Item.prototype.getImageUrls = function (imageUrls) {
  if (this.dom) {
    links.imageloader.filterImageUrls(this.dom, imageUrls);
  }
};

/**
 * Select the item
 */
links.Timeline.Item.prototype.select = function () {
  // Should be implemented by sub-prototype
};

/**
 * Unselect the item
 */
links.Timeline.Item.prototype.unselect = function () {
  // Should be implemented by sub-prototype
};

/**
 * Creates the DOM for the item, depending on its type
 * @return {Element | undefined}
 */
links.Timeline.Item.prototype.createDOM = function () {
  // Should be implemented by sub-prototype
};

/**
 * Append the items DOM to the given HTML container. If items DOM does not yet
 * exist, it will be created first.
 * @param {Element} container
 */
links.Timeline.Item.prototype.showDOM = function (container) {
  // Should be implemented by sub-prototype
};

/**
 * Remove the items DOM from the current HTML container
 * @param {Element} container
 */
links.Timeline.Item.prototype.hideDOM = function (container) {
  // Should be implemented by sub-prototype
};

/**
 * Update the DOM of the item. This will update the content and the classes
 * of the item
 */
links.Timeline.Item.prototype.updateDOM = function () {
  // Should be implemented by sub-prototype
};

/**
 * Reposition the item, recalculate its left, top, and width, using the current
 * range of the timeline and the timeline options.
 * @param {links.Timeline} timeline
 */
links.Timeline.Item.prototype.updatePosition = function (timeline) {
  // Should be implemented by sub-prototype
};

/**
 * Check if the item is drawn in the timeline (i.e. the DOM of the item is
 * attached to the frame. You may also just request the parameter item.rendered
 * @return {boolean} rendered
 */
links.Timeline.Item.prototype.isRendered = function () {
  return this.rendered;
};

/**
 * Check if the item is located in the visible area of the timeline, and
 * not part of a cluster
 * @param {Date} start
 * @param {Date} end
 * @return {boolean} visible
 */
links.Timeline.Item.prototype.isVisible = function (start, end) {
  // Should be implemented by sub-prototype
  return false;
};

/**
 * Reposition the item
 * @param {Number} left
 * @param {Number} right
 */
links.Timeline.Item.prototype.setPosition = function (left, right) {
  // Should be implemented by sub-prototype
};

/**
 * Calculate the left position of the item
 * @param {links.Timeline} timeline
 * @return {Number} left
 */
links.Timeline.Item.prototype.getLeft = function (timeline) {
  // Should be implemented by sub-prototype
  return 0;
};

/**
 * Calculate the right position of the item
 * @param {links.Timeline} timeline
 * @return {Number} right
 */
links.Timeline.Item.prototype.getRight = function (timeline) {
  // Should be implemented by sub-prototype
  return 0;
};

/**
 * Calculate the width of the item
 * @param {links.Timeline} timeline
 * @return {Number} width
 */
links.Timeline.Item.prototype.getWidth = function (timeline) {
  // Should be implemented by sub-prototype
  return this.width || 0; // last rendered width
};

/**
 * @constructor links.Timeline.ItemBox
 * @extends links.Timeline.Item
 * @param {Object} data       Object containing parameters start, end
 *                            content, group, type, className, editable.
 * @param {Object} [options]  Options to set initial property values
 *                                {Number} top
 *                                {Number} left
 *                                {Number} width
 *                                {Number} height
 */
links.Timeline.ItemBox = function (data, options) {
  links.Timeline.Item.call(this, data, options);
};
links.Timeline.ItemBox.prototype = new links.Timeline.Item();

/**
 * Reflow the Item: retrieve its actual size from the DOM
 * @return {boolean} resized    returns true if the axis is resized
 * @override
 */
links.Timeline.ItemBox.prototype.reflow = function () {
  var dom = this.dom,
    dotHeight = dom.dot.offsetHeight,
    dotWidth = dom.dot.offsetWidth,
    lineWidth = dom.line.offsetWidth,
    resized = this.dotHeight != dotHeight || this.dotWidth != dotWidth || this.lineWidth != lineWidth;
  this.dotHeight = dotHeight;
  this.dotWidth = dotWidth;
  this.lineWidth = lineWidth;
  return resized;
};

/**
 * Select the item
 * @override
 */
links.Timeline.ItemBox.prototype.select = function () {
  var dom = this.dom;
  links.Timeline.addClassName(dom, 'timeline-event-selected ui-state-active');
  links.Timeline.addClassName(dom.line, 'timeline-event-selected ui-state-active');
  links.Timeline.addClassName(dom.dot, 'timeline-event-selected ui-state-active');
};

/**
 * Unselect the item
 * @override
 */
links.Timeline.ItemBox.prototype.unselect = function () {
  var dom = this.dom;
  links.Timeline.removeClassName(dom, 'timeline-event-selected ui-state-active');
  links.Timeline.removeClassName(dom.line, 'timeline-event-selected ui-state-active');
  links.Timeline.removeClassName(dom.dot, 'timeline-event-selected ui-state-active');
};

/**
 * Creates the DOM for the item, depending on its type
 * @return {Element | undefined}
 * @override
 */
links.Timeline.ItemBox.prototype.createDOM = function () {
  // background box
  var divBox = document.createElement("DIV");
  divBox.style.position = "absolute";
  divBox.style.left = this.left + "px";
  divBox.style.top = this.top + "px";

  // contents box (inside the background box). used for making margins
  var divContent = document.createElement("DIV");
  divContent.className = "timeline-event-content";
  divContent.innerHTML = this.content;
  divBox.appendChild(divContent);

  // line to axis
  var divLine = document.createElement("DIV");
  divLine.style.position = "absolute";
  divLine.style.width = "0px";
  // important: the vertical line is added at the front of the list of elements,
  // so it will be drawn behind all boxes and ranges
  divBox.line = divLine;

  // dot on axis
  var divDot = document.createElement("DIV");
  divDot.style.position = "absolute";
  divDot.style.width = "0px";
  divDot.style.height = "0px";
  divBox.dot = divDot;
  this.dom = divBox;
  this.updateDOM();
  return divBox;
};

/**
 * Append the items DOM to the given HTML container. If items DOM does not yet
 * exist, it will be created first.
 * @param {Element} container
 * @override
 */
links.Timeline.ItemBox.prototype.showDOM = function (container) {
  var dom = this.dom;
  if (!dom) {
    dom = this.createDOM();
  }
  if (dom.parentNode != container) {
    if (dom.parentNode) {
      // container is changed. remove from old container
      this.hideDOM();
    }

    // append to this container
    container.appendChild(dom);
    container.insertBefore(dom.line, container.firstChild);
    // Note: line must be added in front of the this,
    //       such that it stays below all this
    container.appendChild(dom.dot);
    this.rendered = true;
  }
};

/**
 * Remove the items DOM from the current HTML container, but keep the DOM in
 * memory
 * @override
 */
links.Timeline.ItemBox.prototype.hideDOM = function () {
  var dom = this.dom;
  if (dom) {
    if (dom.parentNode) {
      dom.parentNode.removeChild(dom);
    }
    if (dom.line && dom.line.parentNode) {
      dom.line.parentNode.removeChild(dom.line);
    }
    if (dom.dot && dom.dot.parentNode) {
      dom.dot.parentNode.removeChild(dom.dot);
    }
    this.rendered = false;
  }
};

/**
 * Update the DOM of the item. This will update the content and the classes
 * of the item
 * @override
 */
links.Timeline.ItemBox.prototype.updateDOM = function () {
  var divBox = this.dom;
  if (divBox) {
    var divLine = divBox.line;
    var divDot = divBox.dot;

    // update contents
    divBox.firstChild.innerHTML = this.content;

    // update class
    divBox.className = "timeline-event timeline-event-box ui-widget ui-state-default";
    divLine.className = "timeline-event timeline-event-line ui-widget ui-state-default";
    divDot.className = "timeline-event timeline-event-dot ui-widget ui-state-default";
    if (this.isCluster) {
      links.Timeline.addClassName(divBox, 'timeline-event-cluster ui-widget-header');
      links.Timeline.addClassName(divLine, 'timeline-event-cluster ui-widget-header');
      links.Timeline.addClassName(divDot, 'timeline-event-cluster ui-widget-header');
    }

    // add item specific class name when provided
    if (this.className) {
      links.Timeline.addClassName(divBox, this.className);
      links.Timeline.addClassName(divLine, this.className);
      links.Timeline.addClassName(divDot, this.className);
    }

    // TODO: apply selected className?
  }
};

/**
 * Reposition the item, recalculate its left, top, and width, using the current
 * range of the timeline and the timeline options.
 * @param {links.Timeline} timeline
 * @override
 */
links.Timeline.ItemBox.prototype.updatePosition = function (timeline) {
  var dom = this.dom;
  if (dom) {
    var left = timeline.timeToScreen(this.start),
      axisOnTop = timeline.options.axisOnTop,
      axisTop = timeline.size.axis.top,
      axisHeight = timeline.size.axis.height,
      boxAlign = timeline.options.box && timeline.options.box.align ? timeline.options.box.align : undefined;
    dom.style.top = this.top + "px";
    if (boxAlign == 'right') {
      dom.style.left = left - this.width + "px";
    } else if (boxAlign == 'left') {
      dom.style.left = left + "px";
    } else {
      // default or 'center'
      dom.style.left = left - this.width / 2 + "px";
    }
    var line = dom.line;
    var dot = dom.dot;
    line.style.left = left - this.lineWidth / 2 + "px";
    dot.style.left = left - this.dotWidth / 2 + "px";
    if (axisOnTop) {
      line.style.top = axisHeight + "px";
      line.style.height = Math.max(this.top - axisHeight, 0) + "px";
      dot.style.top = axisHeight - this.dotHeight / 2 + "px";
    } else {
      line.style.top = this.top + this.height + "px";
      line.style.height = Math.max(axisTop - this.top - this.height, 0) + "px";
      dot.style.top = axisTop - this.dotHeight / 2 + "px";
    }
  }
};

/**
 * Check if the item is visible in the timeline, and not part of a cluster
 * @param {Date} start
 * @param {Date} end
 * @return {Boolean} visible
 * @override
 */
links.Timeline.ItemBox.prototype.isVisible = function (start, end) {
  if (this.cluster) {
    return false;
  }
  return this.start > start && this.start < end;
};

/**
 * Reposition the item
 * @param {Number} left
 * @param {Number} right
 * @override
 */
links.Timeline.ItemBox.prototype.setPosition = function (left, right) {
  var dom = this.dom;
  dom.style.left = left - this.width / 2 + "px";
  dom.line.style.left = left - this.lineWidth / 2 + "px";
  dom.dot.style.left = left - this.dotWidth / 2 + "px";
  if (this.group) {
    this.top = this.group.top;
    dom.style.top = this.top + 'px';
  }
};

/**
 * Calculate the left position of the item
 * @param {links.Timeline} timeline
 * @return {Number} left
 * @override
 */
links.Timeline.ItemBox.prototype.getLeft = function (timeline) {
  var boxAlign = timeline.options.box && timeline.options.box.align ? timeline.options.box.align : undefined;
  var left = timeline.timeToScreen(this.start);
  if (boxAlign == 'right') {
    left = left - width;
  } else {
    // default or 'center'
    left = left - this.width / 2;
  }
  return left;
};

/**
 * Calculate the right position of the item
 * @param {links.Timeline} timeline
 * @return {Number} right
 * @override
 */
links.Timeline.ItemBox.prototype.getRight = function (timeline) {
  var boxAlign = timeline.options.box && timeline.options.box.align ? timeline.options.box.align : undefined;
  var left = timeline.timeToScreen(this.start);
  var right;
  if (boxAlign == 'right') {
    right = left;
  } else if (boxAlign == 'left') {
    right = left + this.width;
  } else {
    // default or 'center'
    right = left + this.width / 2;
  }
  return right;
};

/**
 * @constructor links.Timeline.ItemRange
 * @extends links.Timeline.Item
 * @param {Object} data       Object containing parameters start, end
 *                            content, group, type, className, editable.
 * @param {Object} [options]  Options to set initial property values
 *                                {Number} top
 *                                {Number} left
 *                                {Number} width
 *                                {Number} height
 */
links.Timeline.ItemRange = function (data, options) {
  links.Timeline.Item.call(this, data, options);
};
links.Timeline.ItemRange.prototype = new links.Timeline.Item();

/**
 * Select the item
 * @override
 */
links.Timeline.ItemRange.prototype.select = function () {
  var dom = this.dom;
  links.Timeline.addClassName(dom, 'timeline-event-selected ui-state-active');
};

/**
 * Unselect the item
 * @override
 */
links.Timeline.ItemRange.prototype.unselect = function () {
  var dom = this.dom;
  links.Timeline.removeClassName(dom, 'timeline-event-selected ui-state-active');
};

/**
 * Creates the DOM for the item, depending on its type
 * @return {Element | undefined}
 * @override
 */
links.Timeline.ItemRange.prototype.createDOM = function () {
  // background box
  var divBox = document.createElement("DIV");
  divBox.style.position = "absolute";

  // contents box
  var divContent = document.createElement("DIV");
  divContent.className = "timeline-event-content";
  divBox.appendChild(divContent);
  this.dom = divBox;
  this.updateDOM();
  return divBox;
};

/**
 * Append the items DOM to the given HTML container. If items DOM does not yet
 * exist, it will be created first.
 * @param {Element} container
 * @override
 */
links.Timeline.ItemRange.prototype.showDOM = function (container) {
  var dom = this.dom;
  if (!dom) {
    dom = this.createDOM();
  }
  if (dom.parentNode != container) {
    if (dom.parentNode) {
      // container changed. remove the item from the old container
      this.hideDOM();
    }

    // append to the new container
    container.appendChild(dom);
    this.rendered = true;
  }
};

/**
 * Remove the items DOM from the current HTML container
 * The DOM will be kept in memory
 * @override
 */
links.Timeline.ItemRange.prototype.hideDOM = function () {
  var dom = this.dom;
  if (dom) {
    if (dom.parentNode) {
      dom.parentNode.removeChild(dom);
    }
    this.rendered = false;
  }
};

/**
 * Update the DOM of the item. This will update the content and the classes
 * of the item
 * @override
 */
links.Timeline.ItemRange.prototype.updateDOM = function () {
  var divBox = this.dom;
  if (divBox) {
    // update contents
    divBox.firstChild.innerHTML = this.content;

    // update class
    divBox.className = "timeline-event timeline-event-range ui-widget ui-state-default";
    if (this.isCluster) {
      links.Timeline.addClassName(divBox, 'timeline-event-cluster ui-widget-header');
    }

    // add item specific class name when provided
    if (this.className) {
      links.Timeline.addClassName(divBox, this.className);
    }

    // TODO: apply selected className?
  }
};

/**
 * Reposition the item, recalculate its left, top, and width, using the current
 * range of the timeline and the timeline options. *
 * @param {links.Timeline} timeline
 * @override
 */
links.Timeline.ItemRange.prototype.updatePosition = function (timeline) {
  var dom = this.dom;
  if (dom) {
    var contentWidth = timeline.size.contentWidth,
      left = timeline.timeToScreen(this.start),
      right = timeline.timeToScreen(this.end);

    // limit the width of the this, as browsers cannot draw very wide divs
    if (left < -contentWidth) {
      left = -contentWidth;
    }
    if (right > 2 * contentWidth) {
      right = 2 * contentWidth;
    }
    dom.style.top = this.top + "px";
    dom.style.left = left + "px";
    //dom.style.width = Math.max(right - left - 2 * this.borderWidth, 1) + "px"; // TODO: borderWidth
    dom.style.width = Math.max(right - left, 1) + "px";
  }
};

/**
 * Check if the item is visible in the timeline, and not part of a cluster
 * @param {Number} start
 * @param {Number} end
 * @return {boolean} visible
 * @override
 */
links.Timeline.ItemRange.prototype.isVisible = function (start, end) {
  if (this.cluster) {
    return false;
  }
  return this.end > start && this.start < end;
};

/**
 * Reposition the item
 * @param {Number} left
 * @param {Number} right
 * @override
 */
links.Timeline.ItemRange.prototype.setPosition = function (left, right) {
  var dom = this.dom;
  dom.style.left = left + 'px';
  dom.style.width = right - left + 'px';
  if (this.group) {
    this.top = this.group.top;
    dom.style.top = this.top + 'px';
  }
};

/**
 * Calculate the left position of the item
 * @param {links.Timeline} timeline
 * @return {Number} left
 * @override
 */
links.Timeline.ItemRange.prototype.getLeft = function (timeline) {
  return timeline.timeToScreen(this.start);
};

/**
 * Calculate the right position of the item
 * @param {links.Timeline} timeline
 * @return {Number} right
 * @override
 */
links.Timeline.ItemRange.prototype.getRight = function (timeline) {
  return timeline.timeToScreen(this.end);
};

/**
 * Calculate the width of the item
 * @param {links.Timeline} timeline
 * @return {Number} width
 * @override
 */
links.Timeline.ItemRange.prototype.getWidth = function (timeline) {
  return timeline.timeToScreen(this.end) - timeline.timeToScreen(this.start);
};

/**
 * @constructor links.Timeline.ItemFloatingRange
 * @extends links.Timeline.Item
 * @param {Object} data       Object containing parameters start, end
 *                            content, group, type, className, editable.
 * @param {Object} [options]  Options to set initial property values
 *                                {Number} top
 *                                {Number} left
 *                                {Number} width
 *                                {Number} height
 */
links.Timeline.ItemFloatingRange = function (data, options) {
  links.Timeline.Item.call(this, data, options);
};
links.Timeline.ItemFloatingRange.prototype = new links.Timeline.Item();

/**
 * Select the item
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.select = function () {
  var dom = this.dom;
  links.Timeline.addClassName(dom, 'timeline-event-selected ui-state-active');
};

/**
 * Unselect the item
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.unselect = function () {
  var dom = this.dom;
  links.Timeline.removeClassName(dom, 'timeline-event-selected ui-state-active');
};

/**
 * Creates the DOM for the item, depending on its type
 * @return {Element | undefined}
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.createDOM = function () {
  // background box
  var divBox = document.createElement("DIV");
  divBox.style.position = "absolute";

  // contents box
  var divContent = document.createElement("DIV");
  divContent.className = "timeline-event-content";
  divBox.appendChild(divContent);
  this.dom = divBox;
  this.updateDOM();
  return divBox;
};

/**
 * Append the items DOM to the given HTML container. If items DOM does not yet
 * exist, it will be created first.
 * @param {Element} container
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.showDOM = function (container) {
  var dom = this.dom;
  if (!dom) {
    dom = this.createDOM();
  }
  if (dom.parentNode != container) {
    if (dom.parentNode) {
      // container changed. remove the item from the old container
      this.hideDOM();
    }

    // append to the new container
    container.appendChild(dom);
    this.rendered = true;
  }
};

/**
 * Remove the items DOM from the current HTML container
 * The DOM will be kept in memory
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.hideDOM = function () {
  var dom = this.dom;
  if (dom) {
    if (dom.parentNode) {
      dom.parentNode.removeChild(dom);
    }
    this.rendered = false;
  }
};

/**
 * Update the DOM of the item. This will update the content and the classes
 * of the item
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.updateDOM = function () {
  var divBox = this.dom;
  if (divBox) {
    // update contents
    divBox.firstChild.innerHTML = this.content;

    // update class
    divBox.className = "timeline-event timeline-event-range ui-widget ui-state-default";
    if (this.isCluster) {
      links.Timeline.addClassName(divBox, 'timeline-event-cluster ui-widget-header');
    }

    // add item specific class name when provided
    if (this.className) {
      links.Timeline.addClassName(divBox, this.className);
    }

    // TODO: apply selected className?
  }
};

/**
 * Reposition the item, recalculate its left, top, and width, using the current
 * range of the timeline and the timeline options. *
 * @param {links.Timeline} timeline
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.updatePosition = function (timeline) {
  var dom = this.dom;
  if (dom) {
    var contentWidth = timeline.size.contentWidth,
      left = this.getLeft(timeline),
      // NH use getLeft
      right = this.getRight(timeline); // NH use getRight;

    // limit the width of the this, as browsers cannot draw very wide divs
    if (left < -contentWidth) {
      left = -contentWidth;
    }
    if (right > 2 * contentWidth) {
      right = 2 * contentWidth;
    }
    dom.style.top = this.top + "px";
    dom.style.left = left + "px";
    //dom.style.width = Math.max(right - left - 2 * this.borderWidth, 1) + "px"; // TODO: borderWidth
    dom.style.width = Math.max(right - left, 1) + "px";
  }
};

/**
 * Check if the item is visible in the timeline, and not part of a cluster
 * @param {Number} start
 * @param {Number} end
 * @return {boolean} visible
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.isVisible = function (start, end) {
  if (this.cluster) {
    return false;
  }

  // NH check for no end value
  if (this.end && this.start) {
    return this.end > start && this.start < end;
  } else if (this.start) {
    return this.start < end;
  } else if (this.end) {
    return this.end > start;
  } else {
    return true;
  }
};

/**
 * Reposition the item
 * @param {Number} left
 * @param {Number} right
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.setPosition = function (left, right) {
  var dom = this.dom;
  dom.style.left = left + 'px';
  dom.style.width = right - left + 'px';
  if (this.group) {
    this.top = this.group.top;
    dom.style.top = this.top + 'px';
  }
};

/**
 * Calculate the left position of the item
 * @param {links.Timeline} timeline
 * @return {Number} left
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.getLeft = function (timeline) {
  // NH check for no start value
  if (this.start) {
    return timeline.timeToScreen(this.start);
  } else {
    return 0;
  }
};

/**
 * Calculate the right position of the item
 * @param {links.Timeline} timeline
 * @return {Number} right
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.getRight = function (timeline) {
  // NH check for no end value
  if (this.end) {
    return timeline.timeToScreen(this.end);
  } else {
    return timeline.size.contentWidth;
  }
};

/**
 * Calculate the width of the item
 * @param {links.Timeline} timeline
 * @return {Number} width
 * @override
 */
links.Timeline.ItemFloatingRange.prototype.getWidth = function (timeline) {
  return this.getRight(timeline) - this.getLeft(timeline);
};

/**
 * @constructor links.Timeline.ItemDot
 * @extends links.Timeline.Item
 * @param {Object} data       Object containing parameters start, end
 *                            content, group, type, className, editable.
 * @param {Object} [options]  Options to set initial property values
 *                                {Number} top
 *                                {Number} left
 *                                {Number} width
 *                                {Number} height
 */
links.Timeline.ItemDot = function (data, options) {
  links.Timeline.Item.call(this, data, options);
};
links.Timeline.ItemDot.prototype = new links.Timeline.Item();

/**
 * Reflow the Item: retrieve its actual size from the DOM
 * @return {boolean} resized    returns true if the axis is resized
 * @override
 */
links.Timeline.ItemDot.prototype.reflow = function () {
  var dom = this.dom,
    dotHeight = dom.dot.offsetHeight,
    dotWidth = dom.dot.offsetWidth,
    contentHeight = dom.content.offsetHeight,
    resized = this.dotHeight != dotHeight || this.dotWidth != dotWidth || this.contentHeight != contentHeight;
  this.dotHeight = dotHeight;
  this.dotWidth = dotWidth;
  this.contentHeight = contentHeight;
  return resized;
};

/**
 * Select the item
 * @override
 */
links.Timeline.ItemDot.prototype.select = function () {
  var dom = this.dom;
  links.Timeline.addClassName(dom, 'timeline-event-selected ui-state-active');
};

/**
 * Unselect the item
 * @override
 */
links.Timeline.ItemDot.prototype.unselect = function () {
  var dom = this.dom;
  links.Timeline.removeClassName(dom, 'timeline-event-selected ui-state-active');
};

/**
 * Creates the DOM for the item, depending on its type
 * @return {Element | undefined}
 * @override
 */
links.Timeline.ItemDot.prototype.createDOM = function () {
  // background box
  var divBox = document.createElement("DIV");
  divBox.style.position = "absolute";

  // contents box, right from the dot
  var divContent = document.createElement("DIV");
  divContent.className = "timeline-event-content";
  divBox.appendChild(divContent);

  // dot at start
  var divDot = document.createElement("DIV");
  divDot.style.position = "absolute";
  divDot.style.width = "0px";
  divDot.style.height = "0px";
  divBox.appendChild(divDot);
  divBox.content = divContent;
  divBox.dot = divDot;
  this.dom = divBox;
  this.updateDOM();
  return divBox;
};

/**
 * Append the items DOM to the given HTML container. If items DOM does not yet
 * exist, it will be created first.
 * @param {Element} container
 * @override
 */
links.Timeline.ItemDot.prototype.showDOM = function (container) {
  var dom = this.dom;
  if (!dom) {
    dom = this.createDOM();
  }
  if (dom.parentNode != container) {
    if (dom.parentNode) {
      // container changed. remove it from old container first
      this.hideDOM();
    }

    // append to container
    container.appendChild(dom);
    this.rendered = true;
  }
};

/**
 * Remove the items DOM from the current HTML container
 * @override
 */
links.Timeline.ItemDot.prototype.hideDOM = function () {
  var dom = this.dom;
  if (dom) {
    if (dom.parentNode) {
      dom.parentNode.removeChild(dom);
    }
    this.rendered = false;
  }
};

/**
 * Update the DOM of the item. This will update the content and the classes
 * of the item
 * @override
 */
links.Timeline.ItemDot.prototype.updateDOM = function () {
  if (this.dom) {
    var divBox = this.dom;
    var divDot = divBox.dot;

    // update contents
    divBox.firstChild.innerHTML = this.content;

    // update classes
    divBox.className = "timeline-event-dot-container";
    divDot.className = "timeline-event timeline-event-dot ui-widget ui-state-default";
    if (this.isCluster) {
      links.Timeline.addClassName(divBox, 'timeline-event-cluster ui-widget-header');
      links.Timeline.addClassName(divDot, 'timeline-event-cluster ui-widget-header');
    }

    // add item specific class name when provided
    if (this.className) {
      links.Timeline.addClassName(divBox, this.className);
      links.Timeline.addClassName(divDot, this.className);
    }

    // TODO: apply selected className?
  }
};

/**
 * Reposition the item, recalculate its left, top, and width, using the current
 * range of the timeline and the timeline options. *
 * @param {links.Timeline} timeline
 * @override
 */
links.Timeline.ItemDot.prototype.updatePosition = function (timeline) {
  var dom = this.dom;
  if (dom) {
    var left = timeline.timeToScreen(this.start);
    dom.style.top = this.top + "px";
    dom.style.left = left - this.dotWidth / 2 + "px";
    dom.content.style.marginLeft = 1.5 * this.dotWidth + "px";
    //dom.content.style.marginRight = (0.5 * this.dotWidth) + "px"; // TODO
    dom.dot.style.top = (this.height - this.dotHeight) / 2 + "px";
  }
};

/**
 * Check if the item is visible in the timeline, and not part of a cluster.
 * @param {Date} start
 * @param {Date} end
 * @return {boolean} visible
 * @override
 */
links.Timeline.ItemDot.prototype.isVisible = function (start, end) {
  if (this.cluster) {
    return false;
  }
  return this.start > start && this.start < end;
};

/**
 * Reposition the item
 * @param {Number} left
 * @param {Number} right
 * @override
 */
links.Timeline.ItemDot.prototype.setPosition = function (left, right) {
  var dom = this.dom;
  dom.style.left = left - this.dotWidth / 2 + "px";
  if (this.group) {
    this.top = this.group.top;
    dom.style.top = this.top + 'px';
  }
};

/**
 * Calculate the left position of the item
 * @param {links.Timeline} timeline
 * @return {Number} left
 * @override
 */
links.Timeline.ItemDot.prototype.getLeft = function (timeline) {
  return timeline.timeToScreen(this.start);
};

/**
 * Calculate the right position of the item
 * @param {links.Timeline} timeline
 * @return {Number} right
 * @override
 */
links.Timeline.ItemDot.prototype.getRight = function (timeline) {
  return timeline.timeToScreen(this.start) + this.width;
};

/**
 * Retrieve the properties of an item.
 * @param {Number} index
 * @return {Object} itemData    Object containing item properties:<br>
 *                              {Date} start (required),
 *                              {Date} end (optional),
 *                              {String} content (required),
 *                              {String} group (optional),
 *                              {String} className (optional)
 *                              {boolean} editable (optional)
 *                              {String} type (optional)
 */
links.Timeline.prototype.getItem = function (index) {
  if (index >= this.items.length) {
    throw "Cannot get item, index out of range";
  }

  // take the original data as start, includes foreign fields
  var data = this.data,
    itemData;
  if (google && google.visualization && data instanceof google.visualization.DataTable) {
    // map the datatable columns
    var cols = links.Timeline.mapColumnIds(data);
    itemData = {};
    for (var col in cols) {
      if (cols.hasOwnProperty(col)) {
        itemData[col] = this.data.getValue(index, cols[col]);
      }
    }
  } else if (links.Timeline.isArray(this.data)) {
    // read JSON array
    itemData = links.Timeline.clone(this.data[index]);
  } else {
    throw "Unknown data type. DataTable or Array expected.";
  }

  // override the data with current settings of the item (should be the same)
  var item = this.items[index];
  itemData.start = new Date(item.start.valueOf());
  if (item.end) {
    itemData.end = new Date(item.end.valueOf());
  }
  itemData.content = item.content;
  if (item.group) {
    itemData.group = this.getGroupName(item.group);
  }
  if (item.className) {
    itemData.className = item.className;
  }
  if (typeof item.editable !== 'undefined') {
    itemData.editable = item.editable;
  }
  if (item.type) {
    itemData.type = item.type;
  }
  return itemData;
};

/**
 * Retrieve the properties of a cluster.
 * @param {Number} index
 * @return {Object} clusterdata    Object containing cluster properties:<br>
 *                              {Date} start (required),
 *                              {String} type (optional)
 *                              {Array} array with item data as is in getItem()
 */
links.Timeline.prototype.getCluster = function (index) {
  if (index >= this.clusters.length) {
    throw "Cannot get cluster, index out of range";
  }
  var clusterData = {},
    cluster = this.clusters[index],
    clusterItems = cluster.items;
  clusterData.start = new Date(cluster.start.valueOf());
  if (cluster.type) {
    clusterData.type = cluster.type;
  }

  // push cluster item data
  clusterData.items = [];
  for (var i = 0; i < clusterItems.length; i++) {
    for (var j = 0; j < this.items.length; j++) {
      // TODO could be nicer to be able to have the item index into the cluster
      if (this.items[j] == clusterItems[i]) {
        clusterData.items.push(this.getItem(j));
        break;
      }
    }
  }
  return clusterData;
};

/**
 * Add a new item.
 * @param {Object} itemData     Object containing item properties:<br>
 *                              {Date} start (required),
 *                              {Date} end (optional),
 *                              {String} content (required),
 *                              {String} group (optional)
 *                              {String} className (optional)
 *                              {Boolean} editable (optional)
 *                              {String} type (optional)
 * @param {boolean} [preventRender=false]   Do not re-render timeline if true
 */
links.Timeline.prototype.addItem = function (itemData, preventRender) {
  var itemsData = [itemData];
  this.addItems(itemsData, preventRender);
};

/**
 * Add new items.
 * @param {Array} itemsData An array containing Objects.
 *                          The objects must have the following parameters:
 *                            {Date} start,
 *                            {Date} end,
 *                            {String} content with text or HTML code,
 *                            {String} group (optional)
 *                            {String} className (optional)
 *                            {String} editable (optional)
 *                            {String} type (optional)
 * @param {boolean} [preventRender=false]   Do not re-render timeline if true
 */
links.Timeline.prototype.addItems = function (itemsData, preventRender) {
  var timeline = this,
    items = this.items;

  // append the items
  itemsData.forEach(function (itemData) {
    var index = items.length;
    items.push(timeline.createItem(itemData));
    timeline.updateData(index, itemData);

    // note: there is no need to add the item to the renderQueue, that
    // will be done when this.render() is executed and all items are
    // filtered again.
  });

  // prepare data for clustering, by filtering and sorting by type
  if (this.options.cluster) {
    this.clusterGenerator.updateData();
  }
  if (!preventRender) {
    this.render({
      animate: false
    });
  }
};

/**
 * Create an item object, containing all needed parameters
 * @param {Object} itemData  Object containing parameters start, end
 *                           content, group.
 * @return {Object} item
 */
links.Timeline.prototype.createItem = function (itemData) {
  var type = itemData.type || (itemData.end ? 'range' : this.options.style);
  var data = links.Timeline.clone(itemData);
  data.type = type;
  data.group = this.getGroup(itemData.group);
  // TODO: optimize this, when creating an item, all data is copied twice...

  // TODO: is initialTop needed?
  var initialTop,
    options = this.options;
  if (options.axisOnTop) {
    initialTop = this.size.axis.height + options.eventMarginAxis + options.eventMargin / 2;
  } else {
    initialTop = this.size.contentHeight - options.eventMarginAxis - options.eventMargin / 2;
  }
  if (type in this.itemTypes) {
    return new this.itemTypes[type](data, {
      'top': initialTop
    });
  }
  console.log('ERROR: Unknown event type "' + type + '"');
  return new links.Timeline.Item(data, {
    'top': initialTop
  });
};

/**
 * Edit an item
 * @param {Number} index
 * @param {Object} itemData     Object containing item properties:<br>
 *                              {Date} start (required),
 *                              {Date} end (optional),
 *                              {String} content (required),
 *                              {String} group (optional)
 * @param {boolean} [preventRender=false]   Do not re-render timeline if true
 */
links.Timeline.prototype.changeItem = function (index, itemData, preventRender) {
  var oldItem = this.items[index];
  if (!oldItem) {
    throw "Cannot change item, index out of range";
  }

  // replace item, merge the changes
  var newItem = this.createItem({
    'start': itemData.hasOwnProperty('start') ? itemData.start : oldItem.start,
    'end': itemData.hasOwnProperty('end') ? itemData.end : oldItem.end,
    'content': itemData.hasOwnProperty('content') ? itemData.content : oldItem.content,
    'group': itemData.hasOwnProperty('group') ? itemData.group : this.getGroupName(oldItem.group),
    'className': itemData.hasOwnProperty('className') ? itemData.className : oldItem.className,
    'editable': itemData.hasOwnProperty('editable') ? itemData.editable : oldItem.editable,
    'type': itemData.hasOwnProperty('type') ? itemData.type : oldItem.type
  });
  this.items[index] = newItem;

  // append the changes to the render queue
  this.renderQueue.hide.push(oldItem);
  this.renderQueue.show.push(newItem);

  // update the original data table
  this.updateData(index, itemData);

  // prepare data for clustering, by filtering and sorting by type
  if (this.options.cluster) {
    this.clusterGenerator.updateData();
  }
  if (!preventRender) {
    // redraw timeline
    this.render({
      animate: false
    });
    if (this.selection && this.selection.index == index) {
      newItem.select();
    }
  }
};

/**
 * Delete all groups
 */
links.Timeline.prototype.deleteGroups = function () {
  this.groups = [];
  this.groupIndexes = {};
};

/**
 * Get a group by the group name. When the group does not exist,
 * it will be created.
 * @param {String} groupName   the name of the group
 * @return {Object} groupObject
 */
links.Timeline.prototype.getGroup = function (groupName) {
  var groups = this.groups,
    groupIndexes = this.groupIndexes,
    groupObj = undefined;
  var groupIndex = groupIndexes[groupName];
  if (groupIndex == undefined && groupName != undefined) {
    // not null or undefined
    groupObj = {
      'content': groupName,
      'labelTop': 0,
      'lineTop': 0
      // note: this object will lateron get addition information,
      //       such as height and width of the group
    };

    groups.push(groupObj);
    // sort the groups
    if (this.options.groupsOrder == true) {
      groups = groups.sort(function (a, b) {
        if (a.content > b.content) {
          return 1;
        }
        if (a.content < b.content) {
          return -1;
        }
        return 0;
      });
    } else if (typeof this.options.groupsOrder == "function") {
      groups = groups.sort(this.options.groupsOrder);
    }

    // rebuilt the groupIndexes
    for (var i = 0, iMax = groups.length; i < iMax; i++) {
      groupIndexes[groups[i].content] = i;
    }
  } else {
    groupObj = groups[groupIndex];
  }
  return groupObj;
};

/**
 * Get the group name from a group object.
 * @param {Object} groupObj
 * @return {String} groupName   the name of the group, or undefined when group
 *                              was not provided
 */
links.Timeline.prototype.getGroupName = function (groupObj) {
  return groupObj ? groupObj.content : undefined;
};

/**
 * Cancel a change item
 * This method can be called insed an event listener which catches the "change"
 * event. The changed event position will be undone.
 */
links.Timeline.prototype.cancelChange = function () {
  this.applyChange = false;
};

/**
 * Cancel deletion of an item
 * This method can be called insed an event listener which catches the "delete"
 * event. Deletion of the event will be undone.
 */
links.Timeline.prototype.cancelDelete = function () {
  this.applyDelete = false;
};

/**
 * Cancel creation of a new item
 * This method can be called insed an event listener which catches the "new"
 * event. Creation of the new the event will be undone.
 */
links.Timeline.prototype.cancelAdd = function () {
  this.applyAdd = false;
};

/**
 * Select an event. The visible chart range will be moved such that the selected
 * event is placed in the middle.
 * For example selection = [{row: 5}];
 * @param {Array} selection   An array with a column row, containing the row
 *                           number (the id) of the event to be selected.
 * @return {boolean}         true if selection is succesfully set, else false.
 */
links.Timeline.prototype.setSelection = function (selection) {
  if (selection != undefined && selection.length > 0) {
    if (selection[0].row != undefined) {
      var index = selection[0].row;
      if (this.items[index]) {
        var item = this.items[index];
        this.selectItem(index);

        // move the visible chart range to the selected event.
        var start = item.start;
        var end = item.end;
        var middle; // number
        if (end != undefined) {
          middle = (end.valueOf() + start.valueOf()) / 2;
        } else {
          middle = start.valueOf();
        }
        var diff = this.end.valueOf() - this.start.valueOf(),
          newStart = new Date(middle - diff / 2),
          newEnd = new Date(middle + diff / 2);
        this.setVisibleChartRange(newStart, newEnd);
        return true;
      }
    }
  } else {
    // unselect current selection
    this.unselectItem();
  }
  return false;
};

/**
 * Retrieve the currently selected event
 * @return {Array} sel  An array with a column row, containing the row number
 *                      of the selected event. If there is no selection, an
 *                      empty array is returned.
 */
links.Timeline.prototype.getSelection = function () {
  var sel = [];
  if (this.selection) {
    if (this.selection.index !== undefined) {
      sel.push({
        "row": this.selection.index
      });
    } else {
      sel.push({
        "cluster": this.selection.cluster
      });
    }
  }
  return sel;
};

/**
 * Select an item by its index
 * @param {Number} index
 */
links.Timeline.prototype.selectItem = function (index) {
  this.unselectItem();
  this.selection = undefined;
  if (this.items[index] != undefined) {
    var item = this.items[index],
      domItem = item.dom;
    this.selection = {
      'index': index
    };
    if (item && item.dom) {
      // TODO: move adjusting the domItem to the item itself
      if (this.isEditable(item)) {
        item.dom.style.cursor = 'move';
      }
      item.select();
    }
    this.repaintDeleteButton();
    this.repaintDragAreas();
  }
};

/**
 * Select an cluster by its index
 * @param {Number} index
 */
links.Timeline.prototype.selectCluster = function (index) {
  this.unselectItem();
  this.selection = undefined;
  if (this.clusters[index] != undefined) {
    this.selection = {
      'cluster': index
    };
    this.repaintDeleteButton();
    this.repaintDragAreas();
  }
};

/**
 * Check if an item is currently selected
 * @param {Number} index
 * @return {boolean} true if row is selected, else false
 */
links.Timeline.prototype.isSelected = function (index) {
  return this.selection && this.selection.index == index;
};

/**
 * Unselect the currently selected event (if any)
 */
links.Timeline.prototype.unselectItem = function () {
  if (this.selection && this.selection.index !== undefined) {
    var item = this.items[this.selection.index];
    if (item && item.dom) {
      var domItem = item.dom;
      domItem.style.cursor = '';
      item.unselect();
    }
    this.selection = undefined;
    this.repaintDeleteButton();
    this.repaintDragAreas();
  }
};

/**
 * Stack the items such that they don't overlap. The items will have a minimal
 * distance equal to options.eventMargin.
 * @param {boolean | undefined} animate    if animate is true, the items are
 *                                         moved to their new position animated
 *                                         defaults to false.
 */
links.Timeline.prototype.stackItems = function (animate) {
  if (animate == undefined) {
    animate = false;
  }

  // calculate the order and final stack position of the items
  var stack = this.stack;
  if (!stack) {
    stack = {};
    this.stack = stack;
  }
  stack.sortedItems = this.stackOrder(this.renderedItems);
  stack.finalItems = this.stackCalculateFinal(stack.sortedItems);
  if (animate || stack.timer) {
    // move animated to the final positions
    var timeline = this;
    var step = function step() {
      var arrived = timeline.stackMoveOneStep(stack.sortedItems, stack.finalItems);
      timeline.repaint();
      if (!arrived) {
        stack.timer = setTimeout(step, 30);
      } else {
        delete stack.timer;
      }
    };
    if (!stack.timer) {
      stack.timer = setTimeout(step, 30);
    }
  } else {
    // move immediately to the final positions
    this.stackMoveToFinal(stack.sortedItems, stack.finalItems);
  }
};

/**
 * Cancel any running animation
 */
links.Timeline.prototype.stackCancelAnimation = function () {
  if (this.stack && this.stack.timer) {
    clearTimeout(this.stack.timer);
    delete this.stack.timer;
  }
};
links.Timeline.prototype.getItemsByGroup = function (items) {
  var itemsByGroup = {};
  for (var i = 0; i < items.length; ++i) {
    var item = items[i];
    var group = "undefined";
    if (item.group) {
      if (item.group.content) {
        group = item.group.content;
      } else {
        group = item.group;
      }
    }
    if (!itemsByGroup[group]) {
      itemsByGroup[group] = [];
    }
    itemsByGroup[group].push(item);
  }
  return itemsByGroup;
};

/**
 * Order the items in the array this.items. The default order is determined via:
 * - Ranges go before boxes and dots.
 * - The item with the oldest start time goes first
 * If a custom function has been provided via the stackorder option, then this will be used.
 * @param {Array} items        Array with items
 * @return {Array} sortedItems Array with sorted items
 */
links.Timeline.prototype.stackOrder = function (items) {
  // TODO: store the sorted items, to have less work later on
  var sortedItems = items.concat([]);

  //if a customer stack order function exists, use it.
  var f = this.options.customStackOrder && typeof this.options.customStackOrder === 'function' ? this.options.customStackOrder : function (a, b) {
    if ((a instanceof links.Timeline.ItemRange || a instanceof links.Timeline.ItemFloatingRange) && !(b instanceof links.Timeline.ItemRange || b instanceof links.Timeline.ItemFloatingRange)) {
      return -1;
    }
    if (!(a instanceof links.Timeline.ItemRange || a instanceof links.Timeline.ItemFloatingRange) && (b instanceof links.Timeline.ItemRange || b instanceof links.Timeline.ItemFloatingRange)) {
      return 1;
    }
    return a.left - b.left;
  };
  sortedItems.sort(f);
  return sortedItems;
};

/**
 * Adjust vertical positions of the events such that they don't overlap each
 * other.
 * @param {timeline.Item[]} items
 * @return {Object[]} finalItems
 */
links.Timeline.prototype.stackCalculateFinal = function (items) {
  var size = this.size,
    options = this.options,
    axisOnTop = options.axisOnTop,
    eventMargin = options.eventMargin,
    eventMarginAxis = options.eventMarginAxis,
    groupBase = axisOnTop ? size.axis.height + eventMarginAxis + eventMargin / 2 : size.contentHeight - eventMarginAxis - eventMargin / 2,
    groupedItems,
    groupFinalItems,
    finalItems = [];
  groupedItems = this.getItemsByGroup(items);

  //
  // groupedItems contains all items by group, plus it may contain an
  // additional "undefined" group which contains all items with no group. We
  // first process the grouped items, and then the ungrouped
  //
  for (var j = 0; j < this.groups.length; ++j) {
    var group = this.groups[j];
    if (!groupedItems[group.content]) {
      if (axisOnTop) {
        groupBase += options.groupMinHeight + eventMargin;
      } else {
        groupBase -= options.groupMinHeight + eventMargin;
      }
      continue;
    }

    // initialize final positions and fill finalItems
    groupFinalItems = this.finalItemsPosition(groupedItems[group.content], groupBase, group);
    groupFinalItems.forEach(function (item) {
      finalItems.push(item);
    });
    if (axisOnTop) {
      groupBase += group.itemsHeight + eventMargin;
    } else {
      groupBase -= group.itemsHeight + eventMargin;
    }
  }

  //
  // Ungrouped items' turn now!
  //
  if (groupedItems["undefined"]) {
    // initialize final positions and fill finalItems
    groupFinalItems = this.finalItemsPosition(groupedItems["undefined"], groupBase);
    groupFinalItems.forEach(function (item) {
      finalItems.push(item);
    });
  }
  return finalItems;
};
links.Timeline.prototype.finalItemsPosition = function (items, groupBase, group) {
  var i,
    iMax,
    options = this.options,
    axisOnTop = options.axisOnTop,
    eventMargin = options.eventMargin,
    groupFinalItems;

  // initialize final positions and fill finalItems
  groupFinalItems = this.initialItemsPosition(items, groupBase);

  // calculate new, non-overlapping positions
  for (i = 0, iMax = groupFinalItems.length; i < iMax; i++) {
    var finalItem = groupFinalItems[i];
    var collidingItem = null;
    if (this.options.stackEvents) {
      do {
        // TODO: optimize checking for overlap. when there is a gap without items,
        //  you only need to check for items from the next item on, not from zero
        collidingItem = this.stackItemsCheckOverlap(groupFinalItems, i, 0, i - 1);
        if (collidingItem != null) {
          // There is a collision. Reposition the event above the colliding element
          if (axisOnTop) {
            finalItem.top = collidingItem.top + collidingItem.height + eventMargin;
          } else {
            finalItem.top = collidingItem.top - finalItem.height - eventMargin;
          }
          finalItem.bottom = finalItem.top + finalItem.height;
        }
      } while (collidingItem);
    }
    if (group) {
      if (axisOnTop) {
        group.itemsHeight = group.itemsHeight ? Math.max(group.itemsHeight, finalItem.bottom - groupBase) : finalItem.height + eventMargin;
      } else {
        group.itemsHeight = group.itemsHeight ? Math.max(group.itemsHeight, groupBase - finalItem.top) : finalItem.height + eventMargin;
      }
    }
  }
  return groupFinalItems;
};
links.Timeline.prototype.initialItemsPosition = function (items, groupBase) {
  var options = this.options,
    axisOnTop = options.axisOnTop,
    finalItems = [];
  for (var i = 0, iMax = items.length; i < iMax; ++i) {
    var item = items[i],
      top,
      bottom,
      height = item.height,
      width = item.getWidth(this),
      right = item.getRight(this),
      left = right - width;
    top = axisOnTop ? groupBase : groupBase - height;
    bottom = top + height;
    finalItems.push({
      'left': left,
      'top': top,
      'right': right,
      'bottom': bottom,
      'height': height,
      'item': item
    });
  }
  return finalItems;
};

/**
 * Move the events one step in the direction of their final positions
 * @param {Array} currentItems   Array with the real items and their current
 *                               positions
 * @param {Array} finalItems     Array with objects containing the final
 *                               positions of the items
 * @return {boolean} arrived     True if all items have reached their final
 *                               location, else false
 */
links.Timeline.prototype.stackMoveOneStep = function (currentItems, finalItems) {
  var arrived = true;

  // apply new positions animated
  for (var i = 0, iMax = finalItems.length; i < iMax; i++) {
    var finalItem = finalItems[i],
      item = finalItem.item;
    var topNow = parseInt(item.top);
    var topFinal = parseInt(finalItem.top);
    var diff = topFinal - topNow;
    if (diff) {
      var step = topFinal == topNow ? 0 : topFinal > topNow ? 1 : -1;
      if (Math.abs(diff) > 4) step = diff / 4;
      var topNew = parseInt(topNow + step);
      if (topNew != topFinal) {
        arrived = false;
      }
      item.top = topNew;
      item.bottom = item.top + item.height;
    } else {
      item.top = finalItem.top;
      item.bottom = finalItem.bottom;
    }
    item.left = finalItem.left;
    item.right = finalItem.right;
  }
  return arrived;
};

/**
 * Move the events from their current position to the final position
 * @param {Array} currentItems   Array with the real items and their current
 *                               positions
 * @param {Array} finalItems     Array with objects containing the final
 *                               positions of the items
 */
links.Timeline.prototype.stackMoveToFinal = function (currentItems, finalItems) {
  // Put the events directly at there final position
  for (var i = 0, iMax = finalItems.length; i < iMax; i++) {
    var finalItem = finalItems[i],
      current = finalItem.item;
    current.left = finalItem.left;
    current.top = finalItem.top;
    current.right = finalItem.right;
    current.bottom = finalItem.bottom;
  }
};

/**
 * Check if the destiny position of given item overlaps with any
 * of the other items from index itemStart to itemEnd.
 * @param {Array} items      Array with items
 * @param {int}  itemIndex   Number of the item to be checked for overlap
 * @param {int}  itemStart   First item to be checked.
 * @param {int}  itemEnd     Last item to be checked.
 * @return {Object}          colliding item, or undefined when no collisions
 */
links.Timeline.prototype.stackItemsCheckOverlap = function (items, itemIndex, itemStart, itemEnd) {
  var eventMargin = this.options.eventMargin,
    collision = this.collision;

  // we loop from end to start, as we suppose that the chance of a
  // collision is larger for items at the end, so check these first.
  var item1 = items[itemIndex];
  for (var i = itemEnd; i >= itemStart; i--) {
    var item2 = items[i];
    if (collision(item1, item2, eventMargin)) {
      if (i != itemIndex) {
        return item2;
      }
    }
  }
  return undefined;
};

/**
 * Test if the two provided items collide
 * The items must have parameters left, right, top, and bottom.
 * @param {Element} item1       The first item
 * @param {Element} item2       The second item
 * @param {Number}              margin  A minimum required margin. Optional.
 *                              If margin is provided, the two items will be
 *                              marked colliding when they overlap or
 *                              when the margin between the two is smaller than
 *                              the requested margin.
 * @return {boolean}            true if item1 and item2 collide, else false
 */
links.Timeline.prototype.collision = function (item1, item2, margin) {
  // set margin if not specified
  if (margin == undefined) {
    margin = 0;
  }

  // calculate if there is overlap (collision)
  return item1.left - margin < item2.right && item1.right + margin > item2.left && item1.top - margin < item2.bottom && item1.bottom + margin > item2.top;
};

/**
 * fire an event
 * @param {String} event   The name of an event, for example "rangechange" or "edit"
 */
links.Timeline.prototype.trigger = function (event) {
  // built up properties
  var properties = null;
  switch (event) {
    case 'rangechange':
    case 'rangechanged':
      properties = {
        'start': new Date(this.start.valueOf()),
        'end': new Date(this.end.valueOf())
      };
      break;
    case 'timechange':
    case 'timechanged':
      properties = {
        'time': new Date(this.customTime.valueOf())
      };
      break;
  }

  // trigger the links event bus
  links.events.trigger(this, event, properties);

  // trigger the google event bus
  if (google && google.visualization) {
    google.visualization.events.trigger(this, event, properties);
  }
};

/**
 * Cluster the events
 */
links.Timeline.prototype.clusterItems = function () {
  if (!this.options.cluster) {
    return;
  }
  var clusters = this.clusterGenerator.getClusters(this.conversion.factor, this.options.clusterMaxItems);
  if (this.clusters != clusters) {
    // cluster level changed
    var queue = this.renderQueue;

    // remove the old clusters from the scene
    if (this.clusters) {
      this.clusters.forEach(function (cluster) {
        queue.hide.push(cluster);

        // unlink the items
        cluster.items.forEach(function (item) {
          item.cluster = undefined;
        });
      });
    }

    // append the new clusters
    clusters.forEach(function (cluster) {
      // don't add to the queue.show here, will be done in .filterItems()

      // link all items to the cluster
      cluster.items.forEach(function (item) {
        item.cluster = cluster;
      });
    });
    this.clusters = clusters;
  }
};

/**
 * Filter the visible events
 */
links.Timeline.prototype.filterItems = function () {
  var queue = this.renderQueue,
    window = this.end - this.start,
    start = new Date(this.start.valueOf() - window),
    end = new Date(this.end.valueOf() + window);
  function filter(arr) {
    arr.forEach(function (item) {
      var rendered = item.rendered;
      var visible = item.isVisible(start, end);
      if (rendered != visible) {
        if (rendered) {
          queue.hide.push(item); // item is rendered but no longer visible
        }

        if (visible && queue.show.indexOf(item) == -1) {
          queue.show.push(item); // item is visible but neither rendered nor queued up to be rendered
        }
      }
    });
  }

  // filter all items and all clusters
  filter(this.items);
  if (this.clusters) {
    filter(this.clusters);
  }
};

/** ------------------------------------------------------------------------ **/

/**
 * @constructor links.Timeline.ClusterGenerator
 * Generator which creates clusters of items, based on the visible range in
 * the Timeline. There is a set of cluster levels which is cached.
 * @param {links.Timeline} timeline
 */
links.Timeline.ClusterGenerator = function (timeline) {
  this.timeline = timeline;
  this.clear();
};

/**
 * Clear all cached clusters and data, and initialize all variables
 */
links.Timeline.ClusterGenerator.prototype.clear = function () {
  // cache containing created clusters for each cluster level
  this.items = [];
  this.groups = {};
  this.clearCache();
};

/**
 * Clear the cached clusters
 */
links.Timeline.ClusterGenerator.prototype.clearCache = function () {
  // cache containing created clusters for each cluster level
  this.cache = {};
  this.cacheLevel = -1;
  this.cache[this.cacheLevel] = [];
};

/**
 * Set the items to be clustered.
 * This will clear cached clusters.
 * @param {Item[]} items
 * @param {Object} [options]  Available options:
 *                            {boolean} applyOnChangedLevel
 *                                If true (default), the changed data is applied
 *                                as soon the cluster level changes. If false,
 *                                The changed data is applied immediately
 */
links.Timeline.ClusterGenerator.prototype.setData = function (items, options) {
  this.items = items || [];
  this.dataChanged = true;
  this.applyOnChangedLevel = true;
  if (options && options.applyOnChangedLevel) {
    this.applyOnChangedLevel = options.applyOnChangedLevel;
  }
  // console.log('clustergenerator setData applyOnChangedLevel=' + this.applyOnChangedLevel); // TODO: cleanup
};

/**
 * Update the current data set: clear cache, and recalculate the clustering for
 * the current level
 */
links.Timeline.ClusterGenerator.prototype.updateData = function () {
  this.dataChanged = true;
  this.applyOnChangedLevel = false;
};

/**
 * Filter the items per group.
 * @private
 */
links.Timeline.ClusterGenerator.prototype.filterData = function () {
  // filter per group
  var items = this.items || [];
  var groups = {};
  this.groups = groups;

  // split the items per group
  items.forEach(function (item) {
    // put the item in the correct group
    var groupName = item.group ? item.group.content : '';
    var group = groups[groupName];
    if (!group) {
      group = [];
      groups[groupName] = group;
    }
    group.push(item);

    // calculate the center of the item
    if (item.start) {
      if (item.end) {
        // range
        item.center = (item.start.valueOf() + item.end.valueOf()) / 2;
      } else {
        // box, dot
        item.center = item.start.valueOf();
      }
    }
  });

  // sort the items per group
  for (var groupName in groups) {
    if (groups.hasOwnProperty(groupName)) {
      groups[groupName].sort(function (a, b) {
        return a.center - b.center;
      });
    }
  }
  this.dataChanged = false;
};

/**
 * Cluster the events which are too close together
 * @param {Number} scale     The scale of the current window,
 *                           defined as (windowWidth / (endDate - startDate))
 * @return {Item[]} clusters
 */
links.Timeline.ClusterGenerator.prototype.getClusters = function (scale, maxItems) {
  var level = -1,
    granularity = 2,
    // TODO: what granularity is needed for the cluster levels?
    timeWindow = 0; // milliseconds

  if (scale > 0) {
    level = Math.round(Math.log(100 / scale) / Math.log(granularity));
    timeWindow = Math.pow(granularity, level);
  }

  // clear the cache when and re-filter the data when needed.
  if (this.dataChanged) {
    var levelChanged = level != this.cacheLevel;
    var applyDataNow = this.applyOnChangedLevel ? levelChanged : true;
    if (applyDataNow) {
      // TODO: currently drawn clusters should be removed! mark them as invisible?
      this.clearCache();
      this.filterData();
      // console.log('clustergenerator: cache cleared...'); // TODO: cleanup
    }
  }

  this.cacheLevel = level;
  var clusters = this.cache[level];
  if (!clusters) {
    // console.log('clustergenerator: create cluster level ' + level); // TODO: cleanup
    clusters = [];

    // TODO: spit this method, it is too large
    for (var groupName in this.groups) {
      if (this.groups.hasOwnProperty(groupName)) {
        var items = this.groups[groupName];
        var iMax = items.length;
        var i = 0;
        while (i < iMax) {
          // find all items around current item, within the timeWindow
          var item = items[i];
          var neighbors = 1; // start at 1, to include itself)

          // loop through items left from the current item
          var j = i - 1;
          while (j >= 0 && item.center - items[j].center < timeWindow / 2) {
            if (!items[j].cluster) {
              neighbors++;
            }
            j--;
          }

          // loop through items right from the current item
          var k = i + 1;
          while (k < items.length && items[k].center - item.center < timeWindow / 2) {
            neighbors++;
            k++;
          }

          // loop through the created clusters
          var l = clusters.length - 1;
          while (l >= 0 && item.center - clusters[l].center < timeWindow / 2) {
            if (item.group == clusters[l].group) {
              neighbors++;
            }
            l--;
          }

          // aggregate until the number of items is within maxItems
          if (neighbors > maxItems) {
            // too busy in this window.
            var num = neighbors - maxItems + 1;
            var clusterItems = [];

            // append the items to the cluster,
            // and calculate the average start for the cluster
            var avg = undefined; // number. average of all start dates
            var min = undefined; // number. minimum of all start dates
            var max = undefined; // number. maximum of all start and end dates
            var containsRanges = false;
            var count = 0;
            var m = i;
            while (clusterItems.length < num && m < items.length) {
              var p = items[m];
              var start = p.start.valueOf();
              var end = p.end ? p.end.valueOf() : p.start.valueOf();
              clusterItems.push(p);
              if (count) {
                // calculate new average (use fractions to prevent overflow)
                avg = count / (count + 1) * avg + 1 / (count + 1) * p.center;
              } else {
                avg = p.center;
              }
              min = min != undefined ? Math.min(min, start) : start;
              max = max != undefined ? Math.max(max, end) : end;
              containsRanges = containsRanges || p instanceof links.Timeline.ItemRange || p instanceof links.Timeline.ItemFloatingRange;
              count++;
              m++;
            }
            var cluster;
            var title = 'Cluster containing ' + count + ' events. Zoom in to see the individual events.';
            var content = '<div title="' + title + '">' + count + ' events</div>';
            var group = item.group ? item.group.content : undefined;
            if (containsRanges) {
              // boxes and/or ranges
              cluster = this.timeline.createItem({
                'start': new Date(min),
                'end': new Date(max),
                'content': content,
                'group': group
              });
            } else {
              // boxes only
              cluster = this.timeline.createItem({
                'start': new Date(avg),
                'content': content,
                'group': group
              });
            }
            cluster.isCluster = true;
            cluster.items = clusterItems;
            cluster.items.forEach(function (item) {
              item.cluster = cluster;
            });
            clusters.push(cluster);
            i += num;
          } else {
            delete item.cluster;
            i += 1;
          }
        }
      }
    }
    this.cache[level] = clusters;
  }
  return clusters;
};

/** ------------------------------------------------------------------------ **/

/**
 * Event listener (singleton)
 */
links.events = links.events || {
  'listeners': [],
  /**
   * Find a single listener by its object
   * @param {Object} object
   * @return {Number} index  -1 when not found
   */
  'indexOf': function indexOf(object) {
    var listeners = this.listeners;
    for (var i = 0, iMax = this.listeners.length; i < iMax; i++) {
      var listener = listeners[i];
      if (listener && listener.object == object) {
        return i;
      }
    }
    return -1;
  },
  /**
   * Add an event listener
   * @param {Object} object
   * @param {String} event       The name of an event, for example 'select'
   * @param {function} callback  The callback method, called when the
   *                             event takes place
   */
  'addListener': function addListener(object, event, callback) {
    var index = this.indexOf(object);
    var listener = this.listeners[index];
    if (!listener) {
      listener = {
        'object': object,
        'events': {}
      };
      this.listeners.push(listener);
    }
    var callbacks = listener.events[event];
    if (!callbacks) {
      callbacks = [];
      listener.events[event] = callbacks;
    }

    // add the callback if it does not yet exist
    if (callbacks.indexOf(callback) == -1) {
      callbacks.push(callback);
    }
  },
  /**
   * Remove an event listener
   * @param {Object} object
   * @param {String} event       The name of an event, for example 'select'
   * @param {function} callback  The registered callback method
   */
  'removeListener': function removeListener(object, event, callback) {
    var index = this.indexOf(object);
    var listener = this.listeners[index];
    if (listener) {
      var callbacks = listener.events[event];
      if (callbacks) {
        var index = callbacks.indexOf(callback);
        if (index != -1) {
          callbacks.splice(index, 1);
        }

        // remove the array when empty
        if (callbacks.length == 0) {
          delete listener.events[event];
        }
      }

      // count the number of registered events. remove listener when empty
      var count = 0;
      var events = listener.events;
      for (var e in events) {
        if (events.hasOwnProperty(e)) {
          count++;
        }
      }
      if (count == 0) {
        delete this.listeners[index];
      }
    }
  },
  /**
   * Remove all registered event listeners
   */
  'removeAllListeners': function removeAllListeners() {
    this.listeners = [];
  },
  /**
   * Trigger an event. All registered event handlers will be called
   * @param {Object} object
   * @param {String} event
   * @param {Object} properties (optional)
   */
  'trigger': function trigger(object, event, properties) {
    var index = this.indexOf(object);
    var listener = this.listeners[index];
    if (listener) {
      var callbacks = listener.events[event];
      if (callbacks) {
        for (var i = 0, iMax = callbacks.length; i < iMax; i++) {
          callbacks[i](properties);
        }
      }
    }
  }
};

/** ------------------------------------------------------------------------ **/

/**
 * @constructor  links.Timeline.StepDate
 * The class StepDate is an iterator for dates. You provide a start date and an
 * end date. The class itself determines the best scale (step size) based on the
 * provided start Date, end Date, and minimumStep.
 *
 * If minimumStep is provided, the step size is chosen as close as possible
 * to the minimumStep but larger than minimumStep. If minimumStep is not
 * provided, the scale is set to 1 DAY.
 * The minimumStep should correspond with the onscreen size of about 6 characters
 *
 * Alternatively, you can set a scale by hand.
 * After creation, you can initialize the class by executing start(). Then you
 * can iterate from the start date to the end date via next(). You can check if
 * the end date is reached with the function end(). After each step, you can
 * retrieve the current date via get().
 * The class step has scales ranging from milliseconds, seconds, minutes, hours,
 * days, to years.
 *
 * Version: 1.2
 *
 * @param {Date} start          The start date, for example new Date(2010, 9, 21)
 *                              or new Date(2010, 9, 21, 23, 45, 00)
 * @param {Date} end            The end date
 * @param {Number}  minimumStep Optional. Minimum step size in milliseconds
 */
links.Timeline.StepDate = function (start, end, minimumStep) {
  // variables
  this.current = new Date();
  this._start = new Date();
  this._end = new Date();
  this.autoScale = true;
  this.scale = links.Timeline.StepDate.SCALE.DAY;
  this.step = 1;

  // initialize the range
  this.setRange(start, end, minimumStep);
};

/// enum scale
links.Timeline.StepDate.SCALE = {
  MILLISECOND: 1,
  SECOND: 2,
  MINUTE: 3,
  HOUR: 4,
  DAY: 5,
  WEEKDAY: 6,
  MONTH: 7,
  YEAR: 8
};

/**
 * Set a new range
 * If minimumStep is provided, the step size is chosen as close as possible
 * to the minimumStep but larger than minimumStep. If minimumStep is not
 * provided, the scale is set to 1 DAY.
 * The minimumStep should correspond with the onscreen size of about 6 characters
 * @param {Date} start        The start date and time.
 * @param {Date} end          The end date and time.
 * @param {int}  minimumStep  Optional. Minimum step size in milliseconds
 */
links.Timeline.StepDate.prototype.setRange = function (start, end, minimumStep) {
  if (!(start instanceof Date) || !(end instanceof Date)) {
    //throw  "No legal start or end date in method setRange";
    return;
  }
  this._start = start != undefined ? new Date(start.valueOf()) : new Date();
  this._end = end != undefined ? new Date(end.valueOf()) : new Date();
  if (this.autoScale) {
    this.setMinimumStep(minimumStep);
  }
};

/**
 * Set the step iterator to the start date.
 */
links.Timeline.StepDate.prototype.start = function () {
  this.current = new Date(this._start.valueOf());
  this.roundToMinor();
};

/**
 * Round the current date to the first minor date value
 * This must be executed once when the current date is set to start Date
 */
links.Timeline.StepDate.prototype.roundToMinor = function () {
  // round to floor
  // IMPORTANT: we have no breaks in this switch! (this is no bug)
  //noinspection FallthroughInSwitchStatementJS
  switch (this.scale) {
    case links.Timeline.StepDate.SCALE.YEAR:
      this.current.setFullYear(this.step * Math.floor(this.current.getFullYear() / this.step));
      this.current.setMonth(0);
    case links.Timeline.StepDate.SCALE.MONTH:
      this.current.setDate(1);
    case links.Timeline.StepDate.SCALE.DAY: // intentional fall through
    case links.Timeline.StepDate.SCALE.WEEKDAY:
      this.current.setHours(0);
    case links.Timeline.StepDate.SCALE.HOUR:
      this.current.setMinutes(0);
    case links.Timeline.StepDate.SCALE.MINUTE:
      this.current.setSeconds(0);
    case links.Timeline.StepDate.SCALE.SECOND:
      this.current.setMilliseconds(0);
    //case links.Timeline.StepDate.SCALE.MILLISECOND: // nothing to do for milliseconds
  }

  if (this.step != 1) {
    // round down to the first minor value that is a multiple of the current step size
    switch (this.scale) {
      case links.Timeline.StepDate.SCALE.MILLISECOND:
        this.current.setMilliseconds(this.current.getMilliseconds() - this.current.getMilliseconds() % this.step);
        break;
      case links.Timeline.StepDate.SCALE.SECOND:
        this.current.setSeconds(this.current.getSeconds() - this.current.getSeconds() % this.step);
        break;
      case links.Timeline.StepDate.SCALE.MINUTE:
        this.current.setMinutes(this.current.getMinutes() - this.current.getMinutes() % this.step);
        break;
      case links.Timeline.StepDate.SCALE.HOUR:
        this.current.setHours(this.current.getHours() - this.current.getHours() % this.step);
        break;
      case links.Timeline.StepDate.SCALE.WEEKDAY: // intentional fall through
      case links.Timeline.StepDate.SCALE.DAY:
        this.current.setDate(this.current.getDate() - 1 - (this.current.getDate() - 1) % this.step + 1);
        break;
      case links.Timeline.StepDate.SCALE.MONTH:
        this.current.setMonth(this.current.getMonth() - this.current.getMonth() % this.step);
        break;
      case links.Timeline.StepDate.SCALE.YEAR:
        this.current.setFullYear(this.current.getFullYear() - this.current.getFullYear() % this.step);
        break;
      default:
        break;
    }
  }
};

/**
 * Check if the end date is reached
 * @return {boolean}  true if the current date has passed the end date
 */
links.Timeline.StepDate.prototype.end = function () {
  return this.current.valueOf() > this._end.valueOf();
};

/**
 * Do the next step
 */
links.Timeline.StepDate.prototype.next = function () {
  var prev = this.current.valueOf();

  // Two cases, needed to prevent issues with switching daylight savings
  // (end of March and end of October)
  if (this.current.getMonth() < 6) {
    switch (this.scale) {
      case links.Timeline.StepDate.SCALE.MILLISECOND:
        this.current = new Date(this.current.valueOf() + this.step);
        break;
      case links.Timeline.StepDate.SCALE.SECOND:
        this.current = new Date(this.current.valueOf() + this.step * 1000);
        break;
      case links.Timeline.StepDate.SCALE.MINUTE:
        this.current = new Date(this.current.valueOf() + this.step * 1000 * 60);
        break;
      case links.Timeline.StepDate.SCALE.HOUR:
        this.current = new Date(this.current.valueOf() + this.step * 1000 * 60 * 60);
        // in case of skipping an hour for daylight savings, adjust the hour again (else you get: 0h 5h 9h ... instead of 0h 4h 8h ...)
        var h = this.current.getHours();
        this.current.setHours(h - h % this.step);
        break;
      case links.Timeline.StepDate.SCALE.WEEKDAY: // intentional fall through
      case links.Timeline.StepDate.SCALE.DAY:
        this.current.setDate(this.current.getDate() + this.step);
        break;
      case links.Timeline.StepDate.SCALE.MONTH:
        this.current.setMonth(this.current.getMonth() + this.step);
        break;
      case links.Timeline.StepDate.SCALE.YEAR:
        this.current.setFullYear(this.current.getFullYear() + this.step);
        break;
      default:
        break;
    }
  } else {
    switch (this.scale) {
      case links.Timeline.StepDate.SCALE.MILLISECOND:
        this.current = new Date(this.current.valueOf() + this.step);
        break;
      case links.Timeline.StepDate.SCALE.SECOND:
        this.current.setSeconds(this.current.getSeconds() + this.step);
        break;
      case links.Timeline.StepDate.SCALE.MINUTE:
        this.current.setMinutes(this.current.getMinutes() + this.step);
        break;
      case links.Timeline.StepDate.SCALE.HOUR:
        this.current.setHours(this.current.getHours() + this.step);
        break;
      case links.Timeline.StepDate.SCALE.WEEKDAY: // intentional fall through
      case links.Timeline.StepDate.SCALE.DAY:
        this.current.setDate(this.current.getDate() + this.step);
        break;
      case links.Timeline.StepDate.SCALE.MONTH:
        this.current.setMonth(this.current.getMonth() + this.step);
        break;
      case links.Timeline.StepDate.SCALE.YEAR:
        this.current.setFullYear(this.current.getFullYear() + this.step);
        break;
      default:
        break;
    }
  }
  if (this.step != 1) {
    // round down to the correct major value
    switch (this.scale) {
      case links.Timeline.StepDate.SCALE.MILLISECOND:
        if (this.current.getMilliseconds() < this.step) this.current.setMilliseconds(0);
        break;
      case links.Timeline.StepDate.SCALE.SECOND:
        if (this.current.getSeconds() < this.step) this.current.setSeconds(0);
        break;
      case links.Timeline.StepDate.SCALE.MINUTE:
        if (this.current.getMinutes() < this.step) this.current.setMinutes(0);
        break;
      case links.Timeline.StepDate.SCALE.HOUR:
        if (this.current.getHours() < this.step) this.current.setHours(0);
        break;
      case links.Timeline.StepDate.SCALE.WEEKDAY: // intentional fall through
      case links.Timeline.StepDate.SCALE.DAY:
        if (this.current.getDate() < this.step + 1) this.current.setDate(1);
        break;
      case links.Timeline.StepDate.SCALE.MONTH:
        if (this.current.getMonth() < this.step) this.current.setMonth(0);
        break;
      case links.Timeline.StepDate.SCALE.YEAR:
        break;
      // nothing to do for year
      default:
        break;
    }
  }

  // safety mechanism: if current time is still unchanged, move to the end
  if (this.current.valueOf() == prev) {
    this.current = new Date(this._end.valueOf());
  }
};

/**
 * Get the current datetime
 * @return {Date}  current The current date
 */
links.Timeline.StepDate.prototype.getCurrent = function () {
  return this.current;
};

/**
 * Set a custom scale. Autoscaling will be disabled.
 * For example setScale(SCALE.MINUTES, 5) will result
 * in minor steps of 5 minutes, and major steps of an hour.
 *
 * @param {links.Timeline.StepDate.SCALE} newScale
 *                               A scale. Choose from SCALE.MILLISECOND,
 *                               SCALE.SECOND, SCALE.MINUTE, SCALE.HOUR,
 *                               SCALE.WEEKDAY, SCALE.DAY, SCALE.MONTH,
 *                               SCALE.YEAR.
 * @param {Number}     newStep   A step size, by default 1. Choose for
 *                               example 1, 2, 5, or 10.
 */
links.Timeline.StepDate.prototype.setScale = function (newScale, newStep) {
  this.scale = newScale;
  if (newStep > 0) {
    this.step = newStep;
  }
  this.autoScale = false;
};

/**
 * Enable or disable autoscaling
 * @param {boolean} enable  If true, autoascaling is set true
 */
links.Timeline.StepDate.prototype.setAutoScale = function (enable) {
  this.autoScale = enable;
};

/**
 * Automatically determine the scale that bests fits the provided minimum step
 * @param {Number} minimumStep  The minimum step size in milliseconds
 */
links.Timeline.StepDate.prototype.setMinimumStep = function (minimumStep) {
  if (minimumStep == undefined) {
    return;
  }
  var stepYear = 1000 * 60 * 60 * 24 * 30 * 12;
  var stepMonth = 1000 * 60 * 60 * 24 * 30;
  var stepDay = 1000 * 60 * 60 * 24;
  var stepHour = 1000 * 60 * 60;
  var stepMinute = 1000 * 60;
  var stepSecond = 1000;
  var stepMillisecond = 1;

  // find the smallest step that is larger than the provided minimumStep
  if (stepYear * 1000 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.YEAR;
    this.step = 1000;
  }
  if (stepYear * 500 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.YEAR;
    this.step = 500;
  }
  if (stepYear * 100 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.YEAR;
    this.step = 100;
  }
  if (stepYear * 50 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.YEAR;
    this.step = 50;
  }
  if (stepYear * 10 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.YEAR;
    this.step = 10;
  }
  if (stepYear * 5 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.YEAR;
    this.step = 5;
  }
  if (stepYear > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.YEAR;
    this.step = 1;
  }
  if (stepMonth * 3 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MONTH;
    this.step = 3;
  }
  if (stepMonth > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MONTH;
    this.step = 1;
  }
  if (stepDay * 5 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.DAY;
    this.step = 5;
  }
  if (stepDay * 2 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.DAY;
    this.step = 2;
  }
  if (stepDay > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.DAY;
    this.step = 1;
  }
  if (stepDay / 2 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.WEEKDAY;
    this.step = 1;
  }
  if (stepHour * 4 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.HOUR;
    this.step = 4;
  }
  if (stepHour > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.HOUR;
    this.step = 1;
  }
  if (stepMinute * 15 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MINUTE;
    this.step = 15;
  }
  if (stepMinute * 10 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MINUTE;
    this.step = 10;
  }
  if (stepMinute * 5 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MINUTE;
    this.step = 5;
  }
  if (stepMinute > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MINUTE;
    this.step = 1;
  }
  if (stepSecond * 15 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.SECOND;
    this.step = 15;
  }
  if (stepSecond * 10 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.SECOND;
    this.step = 10;
  }
  if (stepSecond * 5 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.SECOND;
    this.step = 5;
  }
  if (stepSecond > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.SECOND;
    this.step = 1;
  }
  if (stepMillisecond * 200 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MILLISECOND;
    this.step = 200;
  }
  if (stepMillisecond * 100 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MILLISECOND;
    this.step = 100;
  }
  if (stepMillisecond * 50 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MILLISECOND;
    this.step = 50;
  }
  if (stepMillisecond * 10 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MILLISECOND;
    this.step = 10;
  }
  if (stepMillisecond * 5 > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MILLISECOND;
    this.step = 5;
  }
  if (stepMillisecond > minimumStep) {
    this.scale = links.Timeline.StepDate.SCALE.MILLISECOND;
    this.step = 1;
  }
};

/**
 * Snap a date to a rounded value. The snap intervals are dependent on the
 * current scale and step.
 * @param {Date} date   the date to be snapped
 */
links.Timeline.StepDate.prototype.snap = function (date) {
  if (this.scale == links.Timeline.StepDate.SCALE.YEAR) {
    var year = date.getFullYear() + Math.round(date.getMonth() / 12);
    date.setFullYear(Math.round(year / this.step) * this.step);
    date.setMonth(0);
    date.setDate(0);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
  } else if (this.scale == links.Timeline.StepDate.SCALE.MONTH) {
    if (date.getDate() > 15) {
      date.setDate(1);
      date.setMonth(date.getMonth() + 1);
      // important: first set Date to 1, after that change the month.
    } else {
      date.setDate(1);
    }
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
  } else if (this.scale == links.Timeline.StepDate.SCALE.DAY || this.scale == links.Timeline.StepDate.SCALE.WEEKDAY) {
    switch (this.step) {
      case 5:
      case 2:
        date.setHours(Math.round(date.getHours() / 24) * 24);
        break;
      default:
        date.setHours(Math.round(date.getHours() / 12) * 12);
        break;
    }
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
  } else if (this.scale == links.Timeline.StepDate.SCALE.HOUR) {
    switch (this.step) {
      case 4:
        date.setMinutes(Math.round(date.getMinutes() / 60) * 60);
        break;
      default:
        date.setMinutes(Math.round(date.getMinutes() / 30) * 30);
        break;
    }
    date.setSeconds(0);
    date.setMilliseconds(0);
  } else if (this.scale == links.Timeline.StepDate.SCALE.MINUTE) {
    switch (this.step) {
      case 15:
      case 10:
        date.setMinutes(Math.round(date.getMinutes() / 5) * 5);
        date.setSeconds(0);
        break;
      case 5:
        date.setSeconds(Math.round(date.getSeconds() / 60) * 60);
        break;
      default:
        date.setSeconds(Math.round(date.getSeconds() / 30) * 30);
        break;
    }
    date.setMilliseconds(0);
  } else if (this.scale == links.Timeline.StepDate.SCALE.SECOND) {
    switch (this.step) {
      case 15:
      case 10:
        date.setSeconds(Math.round(date.getSeconds() / 5) * 5);
        date.setMilliseconds(0);
        break;
      case 5:
        date.setMilliseconds(Math.round(date.getMilliseconds() / 1000) * 1000);
        break;
      default:
        date.setMilliseconds(Math.round(date.getMilliseconds() / 500) * 500);
        break;
    }
  } else if (this.scale == links.Timeline.StepDate.SCALE.MILLISECOND) {
    var step = this.step > 5 ? this.step / 2 : 1;
    date.setMilliseconds(Math.round(date.getMilliseconds() / step) * step);
  }
};

/**
 * Check if the current step is a major step (for example when the step
 * is DAY, a major step is each first day of the MONTH)
 * @return {boolean} true if current date is major, else false.
 */
links.Timeline.StepDate.prototype.isMajor = function () {
  switch (this.scale) {
    case links.Timeline.StepDate.SCALE.MILLISECOND:
      return this.current.getMilliseconds() == 0;
    case links.Timeline.StepDate.SCALE.SECOND:
      return this.current.getSeconds() == 0;
    case links.Timeline.StepDate.SCALE.MINUTE:
      return this.current.getHours() == 0 && this.current.getMinutes() == 0;
    // Note: this is no bug. Major label is equal for both minute and hour scale
    case links.Timeline.StepDate.SCALE.HOUR:
      return this.current.getHours() == 0;
    case links.Timeline.StepDate.SCALE.WEEKDAY: // intentional fall through
    case links.Timeline.StepDate.SCALE.DAY:
      return this.current.getDate() == 1;
    case links.Timeline.StepDate.SCALE.MONTH:
      return this.current.getMonth() == 0;
    case links.Timeline.StepDate.SCALE.YEAR:
      return false;
    default:
      return false;
  }
};

/**
 * Returns formatted text for the minor axislabel, depending on the current
 * date and the scale. For example when scale is MINUTE, the current time is
 * formatted as "hh:mm".
 * @param {Object} options
 * @param {Date} [date] custom date. if not provided, current date is taken
 */
links.Timeline.StepDate.prototype.getLabelMinor = function (options, date) {
  if (date == undefined) {
    date = this.current;
  }
  switch (this.scale) {
    case links.Timeline.StepDate.SCALE.MILLISECOND:
      return String(date.getMilliseconds());
    case links.Timeline.StepDate.SCALE.SECOND:
      return String(date.getSeconds());
    case links.Timeline.StepDate.SCALE.MINUTE:
      return this.addZeros(date.getHours(), 2) + ":" + this.addZeros(date.getMinutes(), 2);
    case links.Timeline.StepDate.SCALE.HOUR:
      return this.addZeros(date.getHours(), 2) + ":" + this.addZeros(date.getMinutes(), 2);
    case links.Timeline.StepDate.SCALE.WEEKDAY:
      return options.DAYS_SHORT[date.getDay()] + ' ' + date.getDate();
    case links.Timeline.StepDate.SCALE.DAY:
      return String(date.getDate());
    case links.Timeline.StepDate.SCALE.MONTH:
      return options.MONTHS_SHORT[date.getMonth()];
    // month is zero based
    case links.Timeline.StepDate.SCALE.YEAR:
      return String(date.getFullYear());
    default:
      return "";
  }
};

/**
 * Returns formatted text for the major axislabel, depending on the current
 * date and the scale. For example when scale is MINUTE, the major scale is
 * hours, and the hour will be formatted as "hh".
 * @param {Object} options
 * @param {Date} [date] custom date. if not provided, current date is taken
 */
links.Timeline.StepDate.prototype.getLabelMajor = function (options, date) {
  if (date == undefined) {
    date = this.current;
  }
  switch (this.scale) {
    case links.Timeline.StepDate.SCALE.MILLISECOND:
      return this.addZeros(date.getHours(), 2) + ":" + this.addZeros(date.getMinutes(), 2) + ":" + this.addZeros(date.getSeconds(), 2);
    case links.Timeline.StepDate.SCALE.SECOND:
      return date.getDate() + " " + options.MONTHS[date.getMonth()] + " " + this.addZeros(date.getHours(), 2) + ":" + this.addZeros(date.getMinutes(), 2);
    case links.Timeline.StepDate.SCALE.MINUTE:
      return options.DAYS[date.getDay()] + " " + date.getDate() + " " + options.MONTHS[date.getMonth()] + " " + date.getFullYear();
    case links.Timeline.StepDate.SCALE.HOUR:
      return options.DAYS[date.getDay()] + " " + date.getDate() + " " + options.MONTHS[date.getMonth()] + " " + date.getFullYear();
    case links.Timeline.StepDate.SCALE.WEEKDAY:
    case links.Timeline.StepDate.SCALE.DAY:
      return options.MONTHS[date.getMonth()] + " " + date.getFullYear();
    case links.Timeline.StepDate.SCALE.MONTH:
      return String(date.getFullYear());
    default:
      return "";
  }
};

/**
 * Add leading zeros to the given value to match the desired length.
 * For example addZeros(123, 5) returns "00123"
 * @param {int} value   A value
 * @param {int} len     Desired final length
 * @return {string}     value with leading zeros
 */
links.Timeline.StepDate.prototype.addZeros = function (value, len) {
  var str = "" + value;
  while (str.length < len) {
    str = "0" + str;
  }
  return str;
};

/** ------------------------------------------------------------------------ **/

/**
 * Image Loader service.
 * can be used to get a callback when a certain image is loaded
 *
 */
links.imageloader = function () {
  var urls = {}; // the loaded urls
  var callbacks = {}; // the urls currently being loaded. Each key contains
  // an array with callbacks

  /**
   * Check if an image url is loaded
   * @param {String} url
   * @return {boolean} loaded   True when loaded, false when not loaded
   *                            or when being loaded
   */
  function isLoaded(url) {
    if (urls[url] == true) {
      return true;
    }
    var image = new Image();
    image.src = url;
    if (image.complete) {
      return true;
    }
    return false;
  }

  /**
   * Check if an image url is being loaded
   * @param {String} url
   * @return {boolean} loading   True when being loaded, false when not loading
   *                             or when already loaded
   */
  function isLoading(url) {
    return callbacks[url] != undefined;
  }

  /**
   * Load given image url
   * @param {String} url
   * @param {function} callback
   * @param {boolean} sendCallbackWhenAlreadyLoaded  optional
   */
  function load(url, callback, sendCallbackWhenAlreadyLoaded) {
    if (sendCallbackWhenAlreadyLoaded == undefined) {
      sendCallbackWhenAlreadyLoaded = true;
    }
    if (isLoaded(url)) {
      if (sendCallbackWhenAlreadyLoaded) {
        callback(url);
      }
      return;
    }
    if (isLoading(url) && !sendCallbackWhenAlreadyLoaded) {
      return;
    }
    var c = callbacks[url];
    if (!c) {
      var image = new Image();
      image.src = url;
      c = [];
      callbacks[url] = c;
      image.onload = function (event) {
        urls[url] = true;
        delete callbacks[url];
        for (var i = 0; i < c.length; i++) {
          c[i](url);
        }
      };
    }
    if (c.indexOf(callback) == -1) {
      c.push(callback);
    }
  }

  /**
   * Load a set of images, and send a callback as soon as all images are
   * loaded
   * @param {String[]} urls
   * @param {function } callback
   * @param {boolean} sendCallbackWhenAlreadyLoaded
   */
  function loadAll(urls, callback, sendCallbackWhenAlreadyLoaded) {
    // list all urls which are not yet loaded
    var urlsLeft = [];
    urls.forEach(function (url) {
      if (!isLoaded(url)) {
        urlsLeft.push(url);
      }
    });
    if (urlsLeft.length) {
      // there are unloaded images
      var countLeft = urlsLeft.length;
      urlsLeft.forEach(function (url) {
        load(url, function () {
          countLeft--;
          if (countLeft == 0) {
            // done!
            callback();
          }
        }, sendCallbackWhenAlreadyLoaded);
      });
    } else {
      // we are already done!
      if (sendCallbackWhenAlreadyLoaded) {
        callback();
      }
    }
  }

  /**
   * Recursively retrieve all image urls from the images located inside a given
   * HTML element
   * @param {Node} elem
   * @param {String[]} urls   Urls will be added here (no duplicates)
   */
  function filterImageUrls(elem, urls) {
    var child = elem.firstChild;
    while (child) {
      if (child.tagName == 'IMG') {
        var url = child.src;
        if (urls.indexOf(url) == -1) {
          urls.push(url);
        }
      }
      filterImageUrls(child, urls);
      child = child.nextSibling;
    }
  }
  return {
    'isLoaded': isLoaded,
    'isLoading': isLoading,
    'load': load,
    'loadAll': loadAll,
    'filterImageUrls': filterImageUrls
  };
}();

/** ------------------------------------------------------------------------ **/

/**
 * Add and event listener. Works for all browsers
 * @param {Element} element    An html element
 * @param {string}      action     The action, for example "click",
 *                                 without the prefix "on"
 * @param {function}    listener   The callback function to be executed
 * @param {boolean}     useCapture
 */
links.Timeline.addEventListener = function (element, action, listener, useCapture) {
  if (element.addEventListener) {
    if (useCapture === undefined) useCapture = false;
    if (action === "mousewheel" && navigator.userAgent.indexOf("Firefox") >= 0) {
      action = "DOMMouseScroll"; // For Firefox
    }

    element.addEventListener(action, listener, useCapture);
  } else {
    element.attachEvent("on" + action, listener); // IE browsers
  }
};

/**
 * Remove an event listener from an element
 * @param {Element}  element   An html dom element
 * @param {string}       action    The name of the event, for example "mousedown"
 * @param {function}     listener  The listener function
 * @param {boolean}      useCapture
 */
links.Timeline.removeEventListener = function (element, action, listener, useCapture) {
  if (element.removeEventListener) {
    // non-IE browsers
    if (useCapture === undefined) useCapture = false;
    if (action === "mousewheel" && navigator.userAgent.indexOf("Firefox") >= 0) {
      action = "DOMMouseScroll"; // For Firefox
    }

    element.removeEventListener(action, listener, useCapture);
  } else {
    // IE browsers
    element.detachEvent("on" + action, listener);
  }
};

/**
 * Get HTML element which is the target of the event
 * @param {Event} event
 * @return {Element} target element
 */
links.Timeline.getTarget = function (event) {
  // code from http://www.quirksmode.org/js/events_properties.html
  if (!event) {
    event = window.event;
  }
  var target;
  if (event.target) {
    target = event.target;
  } else if (event.srcElement) {
    target = event.srcElement;
  }
  if (target.nodeType != undefined && target.nodeType == 3) {
    // defeat Safari bug
    target = target.parentNode;
  }
  return target;
};

/**
 * Stop event propagation
 */
links.Timeline.stopPropagation = function (event) {
  if (!event) event = window.event;
  if (event.stopPropagation) {
    event.stopPropagation(); // non-IE browsers
  } else {
    event.cancelBubble = true; // IE browsers
  }
};

/**
 * Cancels the event if it is cancelable, without stopping further propagation of the event.
 */
links.Timeline.preventDefault = function (event) {
  if (!event) event = window.event;
  if (event.preventDefault) {
    event.preventDefault(); // non-IE browsers
  } else {
    event.returnValue = false; // IE browsers
  }
};

/**
 * Retrieve the absolute left value of a DOM element
 * @param {Element} elem        A dom element, for example a div
 * @return {number} left        The absolute left position of this element
 *                              in the browser page.
 */
links.Timeline.getAbsoluteLeft = function (elem) {
  var doc = document.documentElement;
  var body = document.body;
  var left = elem.offsetLeft;
  var e = elem.offsetParent;
  while (e != null && e != body && e != doc) {
    left += e.offsetLeft;
    left -= e.scrollLeft;
    e = e.offsetParent;
  }
  return left;
};

/**
 * Retrieve the absolute top value of a DOM element
 * @param {Element} elem        A dom element, for example a div
 * @return {number} top        The absolute top position of this element
 *                              in the browser page.
 */
links.Timeline.getAbsoluteTop = function (elem) {
  var doc = document.documentElement;
  var body = document.body;
  var top = elem.offsetTop;
  var e = elem.offsetParent;
  while (e != null && e != body && e != doc) {
    top += e.offsetTop;
    top -= e.scrollTop;
    e = e.offsetParent;
  }
  return top;
};

/**
 * Get the absolute, vertical mouse position from an event.
 * @param {Event} event
 * @return {Number} pageY
 */
links.Timeline.getPageY = function (event) {
  if ('targetTouches' in event && event.targetTouches.length) {
    event = event.targetTouches[0];
  }
  if ('pageY' in event) {
    return event.pageY;
  }

  // calculate pageY from clientY
  var clientY = event.clientY;
  var doc = document.documentElement;
  var body = document.body;
  return clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
};

/**
 * Get the absolute, horizontal mouse position from an event.
 * @param {Event} event
 * @return {Number} pageX
 */
links.Timeline.getPageX = function (event) {
  if ('targetTouches' in event && event.targetTouches.length) {
    event = event.targetTouches[0];
  }
  if ('pageX' in event) {
    return event.pageX;
  }

  // calculate pageX from clientX
  var clientX = event.clientX;
  var doc = document.documentElement;
  var body = document.body;
  return clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
};

/**
 * Adds one or more className's to the given elements style
 * @param {Element} elem
 * @param {String} className
 */
links.Timeline.addClassName = function (elem, className) {
  var classes = elem.className.split(' ');
  var classesToAdd = className.split(' ');
  var added = false;
  for (var i = 0; i < classesToAdd.length; i++) {
    if (classes.indexOf(classesToAdd[i]) == -1) {
      classes.push(classesToAdd[i]); // add the class to the array
      added = true;
    }
  }
  if (added) {
    elem.className = classes.join(' ');
  }
};

/**
 * Removes one or more className's from the given elements style
 * @param {Element} elem
 * @param {String} className
 */
links.Timeline.removeClassName = function (elem, className) {
  var classes = elem.className.split(' ');
  var classesToRemove = className.split(' ');
  var removed = false;
  for (var i = 0; i < classesToRemove.length; i++) {
    var index = classes.indexOf(classesToRemove[i]);
    if (index != -1) {
      classes.splice(index, 1); // remove the class from the array
      removed = true;
    }
  }
  if (removed) {
    elem.className = classes.join(' ');
  }
};

/**
 * Check if given object is a Javascript Array
 * @param {*} obj
 * @return {Boolean} isArray    true if the given object is an array
 */
// See http://stackoverflow.com/questions/2943805/javascript-instanceof-typeof-in-gwt-jsni
links.Timeline.isArray = function (obj) {
  if (obj instanceof Array) {
    return true;
  }
  return Object.prototype.toString.call(obj) === '[object Array]';
};

/**
 * Shallow clone an object
 * @param {Object} object
 * @return {Object} clone
 */
links.Timeline.clone = function (object) {
  var clone = {};
  for (var prop in object) {
    if (object.hasOwnProperty(prop)) {
      clone[prop] = object[prop];
    }
  }
  return clone;
};

/**
 * parse a JSON date
 * @param {Date | String | Number} date    Date object to be parsed. Can be:
 *                                         - a Date object like new Date(),
 *                                         - a long like 1356970529389,
 *                                         an ISO String like "2012-12-31T16:16:07.213Z",
 *                                         or a .Net Date string like
 *                                         "\/Date(1356970529389)\/"
 * @return {Date} parsedDate
 */
links.Timeline.parseJSONDate = function (date) {
  if (date == undefined) {
    return undefined;
  }

  //test for date
  if (date instanceof Date) {
    return date;
  }

  // test for MS format.
  // FIXME: will fail on a Number
  var m = date.match(/\/Date\((-?\d+)([-\+]?\d{2})?(\d{2})?\)\//i);
  if (m) {
    var offset = m[2] ? 3600000 * m[2] // hrs offset
    + 60000 * m[3] * (m[2] / Math.abs(m[2])) // mins offset
    : 0;
    return new Date(1 * m[1] // ticks
    + offset);
  }

  // failing that, try to parse whatever we've got.
  return Date.parse(date);
};

},{}],9:[function(require,module,exports){
"use strict";

/* eslint-disable no-undef */
/**
 * Webpack will replace the __[]__ variables inline
 * So, for gulp we need to check if the variable is defined.
 * We need to check the type as the variable was never defined as undefined either.
 */
var ENV = {
  DEBUG: typeof __DEBUG__ !== "undefined" ? __DEBUG__ : false,
  DEBUG__DISABLE_MEMOIZE: typeof __DEBUG__DISABLE_MEMOIZE__ !== "undefined" ? __DEBUG__DISABLE_MEMOIZE__ : false,
  DEBUG__PRINT_SHALLOW_COMPARE_FAILS: false
};
window.Environment = ENV;
module.exports = ENV;

},{}],10:[function(require,module,exports){
"use strict";

//require("./../css/nixps-container-Collapse.css");

var Component = require("../../../General/Component/js/nixps-Component.js");
require("./nixps-container-Panel.js");
require("../../Form/js/nixps-form-Button.js");
require("../../Widget/js/nixps-widget-NiXPSWidget.js");
require("../../../General/Component/js/nixps-Component.js");
$.widget("nixps-container.Collapse", $["nixps-widget"]["NiXPSWidget"], {
  options: {
    /**
     * @description The title of the collapse
     * @name nixps-form.Collapse#title
     * @type string
     * @default ""
     */
    title: "",
    /**
     * @description Whether to add bootstrap classes or not
     * @name nixps-cloudflow.Collapse#useBootstrap
     * @type {boolean}
     * @default "true"
     */
    useBootstrap: true,
    /**
     * @description Whether the initial state of the panel is collapsed or not
     * @name nixps-cloudflow.Collapse#collapsed
     * @type {boolean}
     * @default "false"
     */
    collapsed: false,
    /**
     * @description An object with the icons to be displayed. Contains 2 members: "open" and "closed" which are iconClasses for buttons.
     * @name nixps-cloudflow.Collapse#iconClasses
     * @type {object}
     * @default "{ open: "fa fa-chevron-down", closed: "fa fa-chevron-right" }"
     */
    iconClasses: {
      open: "fa fa-chevron-down",
      closed: "fa fa-chevron-right"
    }
  },
  _create: function _create() {
    this._super();
    this._validateOptions();
    this.skipCollapse = [];
    this.element.addClass(this.widgetFullName);
    this._draw();
    this._on(this.element, {
      "click .collapse-header": this._clickCollapseHandler
    });
  },
  /**
   * @brief redraws list
   */
  redraw: function redraw() {
    this._draw();
  },
  /**
   * @brief draws the list according to the current state
   */
  _draw: function _draw() {
    this.element.empty();
    var header = $("<div>").addClass("collapse-header").appendTo(this.element);
    var downButton = $("<button>").Button({
      iconClass: this.options.collapsed === true ? this.options.iconClasses.closed : this.options.iconClasses.open,
      tooltip: $.i18n._(this.options.collapsed ? "nixps-container-Collapse.open-panel" : "nixps-container-Collapse.close-panel"),
      useBootstrap: this.options.useBootstrap,
      class_prefix: "collapse-button"
    }).appendTo(header);
    var titleLabel = $("<label>").addClass("collapse-header__label").text(this.options.title).appendTo(header);
    var panel = $("<div>").Panel().appendTo(this.element);
    if (this.options.collapsed === true) {
      panel.css({
        "height": "0",
        "border-bottom-width": "0",
        "overflow": "hidden"
      });
    }
  },
  /**
   * @brief get content from the panel
   */
  getContent: function getContent(element) {
    if (element === "collapse-header") {
      return this.element.children(".collapse-header");
    } else {
      return this.element.children(".nixps-container-Panel").Panel("getContent", element);
    }
  },
  /**
   * @brief adds content to the panel
   */
  emptyContent: function emptyContent(element) {
    this.element.children(".nixps-container-Panel").Panel("emptyContent", element);
  },
  /**
   * @brief adds content to the panel
   */
  addContent: function addContent(content, element, action, index) {
    if (element === "collapse-header") {
      this.skipCollapse.push($(content));
      var element = this.element.children(".collapse-header");
      Component.addContent(content, element, action, index);
    } else {
      this.element.children(".nixps-container-Panel").Panel("addContent", content, element, action, index);
    }
  },
  /**
   * @brief handles the clicks on the collapse button
   */
  _clickCollapseHandler: function _clickCollapseHandler(event, data) {
    if (this.skipCollapse.some(function (pItem) {
      return pItem[0] === event.target || $.contains(pItem[0], event.target);
    }) === false) {
      var that = this,
        button = this.element.children(".collapse-header").children("button:nth-child(1)");
      if (button.Button("option", "iconClass") === this.options.iconClasses.open) {
        this.element.children(".nixps-container-Panel").animate({
          height: 0
        }, "slow", function () {
          button.Button("option", {
            "iconClass": that.options.iconClasses.closed,
            tooltip: $.i18n._("nixps-container-Collapse.open-panel")
          });
          that.element.children(".nixps-container-Panel").css("border-bottom-width", "0");
          that.element.children(".nixps-container-Panel").css("overflow", "hidden");
        });
      } else {
        this.element.children(".nixps-container-Panel").css("border-bottom-width", "1px");
        button.Button("option", {
          "iconClass": that.options.iconClasses.open,
          tooltip: $.i18n._("nixps-container-Collapse.close-panel")
        });
        this.element.children(".nixps-container-Panel").css("overflow", "inherit");
        this.element.children(".nixps-container-Panel").animate({
          height: this.element.children(".nixps-container-Panel").children(".panel-content").height()
        }, "slow", function () {
          that.element.children(".nixps-container-Panel").css("height", "auto");
        });
      }
    }
  },
  /**
   * @brief validates the options
   */
  _validateOptions: function _validateOptions() {
    if (typeof this.options.title !== "string") {
      throw new Error("Collapse: the title option must be a string!");
    }
    if (typeof this.options.useBootstrap !== "boolean") {
      throw new Error("Collapse: the useBootstrap option must be a boolean!");
    }
    if (typeof this.options.collapsed !== "boolean") {
      throw new Error("Collapse: the collapsed option must be a boolean!");
    }
  },
  getProperties: function getProperties() {
    return {
      collapsed: this.element.children(".collapse-header").children("button:nth-child(1)").Button("option", "iconClass") === this.options.iconClasses.closed
    };
  },
  setProperties: function setProperties(properties) {
    var button = this.element.children(".collapse-header").children("button:nth-child(1)");
    if (properties.collapsed === true) {
      button.Button("option", "iconClass", this.options.iconClasses.closed);
      this.element.children(".nixps-container-Panel").css({
        "height": "0",
        "border-bottom-width": "0",
        "overflow": "hidden"
      });
    } else {
      button.Button("option", "iconClass", this.options.iconClasses.open);
      this.element.children(".nixps-container-Panel").css({
        "height": "auto",
        "border-bottom-width": "1px",
        "overflow": "inherit"
      });
    }
  },
  getState: function getState() {
    return this.getProperties();
  },
  setState: function setState(pState) {
    if (pState !== undefined && $.isEmptyObject(pState) === false) {
      this.setProperties(pState);
    } else {
      this.setProperties({
        collapsed: false
      });
    }
  }
});

},{"../../../General/Component/js/nixps-Component.js":21,"../../Form/js/nixps-form-Button.js":13,"../../Widget/js/nixps-widget-NiXPSWidget.js":17,"./nixps-container-Panel.js":11}],11:[function(require,module,exports){
"use strict";

var Component = require("../../../General/Component/js/nixps-Component.js");
$.widget("nixps-container.Panel", $.Widget, {
  options: {
    /**
     * @description Extra classes to add to div's corresponding to the elements: header, menu, body and footer.
     * @name nixps-container.Panel#extraClasses
     * @type {object}
     * @default {}
     * @example { header: "modal-header", body: "modal-body", footer: "modal-footer" }
     */
    extraClasses: {}
  },
  _create: function _create() {
    this._validateOptions();
    this.element.addClass(this.widgetFullName);
    this._draw();
  },
  /**
   * @brief redraws list
   */
  redraw: function redraw() {
    this._draw();
  },
  /**
   * @brief draws the list according to the current state
   */
  _draw: function _draw() {
    this.element.empty();
    var panelContent = $("<div>").addClass("panel-content").appendTo(this.element);
    if (this.options.extraClasses.content !== undefined) {
      panelContent.addClass(this.options.extraClasses.content);
    }
    var panelHeader = $("<div>").addClass("panel-header").appendTo(panelContent).hide();
    if (this.options.extraClasses.header !== undefined) {
      panelHeader.addClass(this.options.extraClasses.header);
    }
    var panelMenu = $("<div>").addClass("panel-menu").appendTo(panelContent).hide();
    if (this.options.extraClasses.menu !== undefined) {
      panelMenu.addClass(this.options.extraClasses.menu);
    }
    var panelBody = $("<div>").addClass("panel-body").appendTo(panelContent).hide();
    if (this.options.extraClasses.body !== undefined) {
      panelBody.addClass(this.options.extraClasses.body);
    }
    var panelFooter = $("<div>").addClass("panel-footer").appendTo(panelContent).hide();
    if (this.options.extraClasses.footer !== undefined) {
      panelFooter.addClass(this.options.extraClasses.footer);
    }
  },
  /**
   * @brief adds content to the body
   */
  emptyContent: function emptyContent(element) {
    this.element.children(".panel-content").children(this._getSelector(element)).empty();
  },
  /**
   * @brief adds content to the body
   */
  addContent: function addContent(content, element, action, index) {
    var element = this.element.children(".panel-content").children(this._getSelector(element));
    Component.addContent(content, element, action, index);
    element.show();
  },
  /**
   * @brief gets the content of the element
   */
  getContent: function getContent(element) {
    return this.element.children(".panel-content").children(this._getSelector(element));
  },
  /**
   * @brief gets the correct selector for the correct element
   */
  _getSelector: function _getSelector(element) {
    switch (element) {
      case "header":
        return ".panel-header";
        break;
      case "menu":
        return ".panel-menu";
        break;
      case "body":
        return ".panel-body";
        break;
      case "footer":
        return ".panel-footer";
        break;
      default:
        throw new Error("Panel: unrecognized element value for the method addContent. This can either be: header, menu, body or footer.");
    }
  },
  /**
   * @brief validates the options
   */
  _validateOptions: function _validateOptions() {
    if ($.isPlainObject(this.options.extraClasses) === false) {
      throw new Error("Panel: extraClasses should be an object");
    } else {
      for (var prop in this.options.extraClasses) {
        if ($.inArray(prop, ["header", "menu", "body", "footer", "content"]) === -1) {
          throw new Error('Panel: extraClasses keys must be either "header", "menu", "body", "footer" or "content"');
        }
      }
    }
  }
});

},{"../../../General/Component/js/nixps-Component.js":21}],12:[function(require,module,exports){
"use strict";

var EventDispatcher = require("../../../General/Event/js/nixps-EventDispatcher.js");
var FileTreeActions = function FileTreeActions() {
  /**
   * @brief getDefaultActions should return a list of menu item objects
   * Each object in the array should have following properties:
   * name (the name of the action), icon (the icon in html relating to the action), label (the label for the action)   
   */
  if (this.getDefaultActions === undefined || typeof this.getDefaultActions !== "function") {
    throw new Error("Classes that use the FileTreeActions interface should implement the getDefaultActions method!");
  }
  /**
   * @brief executeAction will be triggered when the menu item is selected with the necessary data of the file
   * this method should return true if the action was handled within this class or false if the FileTree should trigger an event and let it be handled by something else 
   */
  if (this.executeAction === undefined || typeof this.executeAction !== "function") {
    throw new Error("Classes that use the FileTreeActions interface should implement the executeAction method!");
  }
  this.eventDispatcher();
  this.fileTree;
};
FileTreeActions.prototype = Object.assign({}, EventDispatcher.prototype, {
  constructor: FileTreeActions,
  eventDispatcher: EventDispatcher,
  isFileTreeActionsInterface: function isFileTreeActionsInterface() {
    return true;
  },
  setFileTree: function setFileTree(pFileTree) {
    this.fileTree = pFileTree;
  },
  getFileTree: function getFileTree() {
    return this.fileTree;
  }
});
module.exports = FileTreeActions;

},{"../../../General/Event/js/nixps-EventDispatcher.js":24}],13:[function(require,module,exports){
"use strict";

var NiXPSButton_VALIDTYPES = ["submit", "create", "save", "add", "edit", "cancel", "remove", "delete", "reset", "search", "upload"];
function disabledButton(event) {
  event.stopPropagation();
  event.stopImmediatePropagation();
}
function NiXPSButton_hasValidType(pOptions) {
  return typeof pOptions.type === "string" && pOptions.type.length >= 0 && $.inArray(pOptions.type, NiXPSButton_VALIDTYPES) !== -1;
}
function NiXPSButton_Icon(pElement, pOptions) {
  var class_prefix = "nixps-button";
  if (pOptions.class_prefix !== undefined) {
    class_prefix = pOptions.class_prefix;
  }
  var icon;
  if (pElement.NiXPSButton._Icon == null) {
    icon = document.createElement("span");
    pElement.NiXPSButton._Self.insertBefore(icon, pElement.NiXPSButton._Self.firstChild);
    pElement.NiXPSButton._Icon = icon;
  } else {
    icon = pElement.NiXPSButton._Icon;
  }
  icon.className = pOptions.iconClass;
  if (pOptions.bigIcon === true) {
    icon.classList.remove(class_prefix + "__icon--icon");
    icon.classList.add(class_prefix + "__icon--icon-only");
    pElement.NiXPSButton._Self.classList.add(class_prefix + "--icon-only");
  } else {
    icon.classList.remove(class_prefix + "__icon--icon-only");
    icon.classList.add(class_prefix + "__icon");
    pElement.NiXPSButton._Self.classList.remove(class_prefix + "--icon-only");
  }
}
function NiXPSButton(pElement, pOptions) {
  var class_prefix = "nixps-button";
  if (pOptions.class_prefix !== undefined) {
    class_prefix = pOptions.class_prefix;
  }
  if (pElement.NiXPSButton == null) {
    var button = pElement;
    if (pElement.tagName.toLowerCase() !== "button") {
      button = document.createElement("button");
      pElement.appendChild(button);
    }
    var label = document.createElement("label");
    pElement.NiXPSButton = {
      _Self: button,
      _Label: label,
      _Icon: null,
      _Click_Listener: null
    };
  } else {
    var button = pElement.NiXPSButton._Self;
    var label = pElement.NiXPSButton._Label;
  }
  if (pOptions.buttonClass) {
    button.className = pOptions.buttonClass;
  }
  button.classList.add(class_prefix);
  if (pOptions.tooltip) {
    button.setAttribute("title", pOptions.tooltip);
  }
  if (pOptions.iconClass) {
    NiXPSButton_Icon(pElement, pOptions);
  } else if (button.NiXPSButton_Icon != null) {
    button.removeChild(button.NiXPSButton_Icon);
    button.NiXPSButton_Icon = null;
  }
  label.className = class_prefix + "__label";
  if (pOptions.iconPlacement === "left" && button.lastChild !== label) {
    button.appendChild(label);
  } else if (pOptions.iconPlacement !== "left" && button.firstChild !== label) {
    button.insertBefore(label, button.firstChild);
  }
  if (NiXPSButton_hasValidType(pOptions)) {
    switch (pOptions.type) {
      case "create":
        label.textContent = $.i18n._("nixps-form-Button.create");
        break;
      case "add":
        label.textContent = $.i18n._("nixps-form-Button.add");
        break;
      case "save":
        label.textContent = $.i18n._("nixps-form-Button.save");
        break;
      case "edit":
        label.textContent = $.i18n._("nixps-form-Button.edit");
        break;
      case "submit":
        label.textContent = $.i18n._("nixps-form-Button.submit");
        break;
      case "cancel":
        label.textContent = $.i18n._("nixps-form-Button.cancel");
        break;
      case "remove":
        label.textContent = $.i18n._("nixps-form-Button.remove");
        break;
      case "delete":
        label.textContent = $.i18n._("nixps-form-Button.delete");
        break;
      case "reset":
        label.textContent = $.i18n._("nixps-form-Button.reset");
        break;
      case "search":
        label.textContent = $.i18n._("nixps-form-Button.search");
        break;
      case "upload":
        label.textContent = $.i18n._("nixps-form-Button.upload");
        break;
    }
  } else {
    label.textContent = pOptions.label;
  }
  if (pOptions.disabled === true) {
    button.classList.add(class_prefix + "--disabled");
    button.addEventListener('click', disabledButton);
  } else {
    button.classList.remove(class_prefix + "--disabled");
    button.removeEventListener('click', disabledButton);
  }
  return pElement;
}
$.widget("nixps-form.Button", $.Widget, {
  options: {
    /**
     * @description The button type. This overrides the label option. If not defined the label option are used.
     * @name nixps-form.Button#type
     * @type {string}
     * @default ""
     * @required
     * @example "save"
     */
    type: "",
    /**
     * @description The icon class shown on the button
     * @name nixps-form.Button#iconClass
     * @type {string}
     * @default ""
     * @example "ui-icon ui-icon-arrowthick-1-n"
     */
    iconClass: "",
    /**
     * @description The label shown on the button
     * @name nixps-form.Button#label
     * @type {string}
     * @default ""
     * @required
     * @example "save"
     */
    label: "",
    /**
     * @description The tooltop shown on the button
     * @name nixps-form.Button#tooltip
     * @type {string}
     * @default ""
     * @required
     * @example "save"
     */
    tooltip: "",
    /**
     * @description When using bootstrap, indication whether or not the button is the primary button
     * @name nixps-form.Button#isPrimary
     * @type {boolean}
     * @default "false"
     */
    isPrimary: false,
    /**
     * @description The class to add to the button
     * @name nixps-form.Button#buttonClass
     * @type {string}
     * @default ""
     */
    buttonClass: "",
    /**
     * @description Is the button disabled?
     * @name nixps-form.Button#disabled
     * @type {boolean}
     * @default false
     */
    disabled: false,
    /**
     * @description Where to place the icon: "left, "right"
     * @name nixps-form.Button#iconPlacement
     * @type {string}
     * @default "left"
     */
    iconPlacement: "left",
    /**
     * @description Should we show a big icon?
     * @name nixps-form.Button#bigIcon
     * @type {boolean}
     * @default false
     */
    bigIcon: false
  },
  _create: function _create() {
    this._validateOptions();
    this.loading_container;
    this.isMinLoading = false;
    this.waitingOnMinLoading = false;
    this.element.addClass(this.widgetFullName);
    this._draw();
    this._on(this.element, {
      "click": this._clickHandler
    });
  },
  /**
   * @brief redraws list
   */
  redraw: function redraw() {
    NiXPSButton(this.element[0], this.options);
    this._disable();
  },
  /**
   * @brief draws the list according to the current state
   */
  _draw: function _draw() {
    this.redraw();
  },
  _disable: function _disable() {
    if (this.options.disabled === true) {
      this.element[0].NiXPSButton._Self.setAttribute("disabled", "disabled");
    } else {
      this.element[0].NiXPSButton._Self.removeAttribute("disabled");
    }
  },
  /**
   * @brief places or removes a loading icon in the button
   */
  loading: function loading(pLoading) {
    if (pLoading === true) {
      this.isMinLoading = true;
      this.loading_container = document.createElement("div");
      this.loading_container.className = "nixps-button__loading";
      this.element[0].NiXPSButton._Self.appendChild(this.loading_container);
      this.loading_container.style.width = this.element[0].NiXPSButton._Icon.offsetWidth + this.element[0].NiXPSButton._Label.offsetWidth + "px";
      this.loading_container.style.height = Math.max(this.element[0].NiXPSButton._Icon.offsetHeight, this.element[0].NiXPSButton._Label.offsetHeight) + "px";
      if (this.element[0].NiXPSButton._Label !== undefined) {
        this.element[0].NiXPSButton._Label.style.display = "none";
      }
      if (this.element[0].NiXPSButton._Icon !== undefined) {
        this.element[0].NiXPSButton._Icon.style.display = "none";
      }
      this.element[0].NiXPSButton._Self.setAttribute("disabled", true);

      // show loading for at least 2 sec.
      var that = this;
      setTimeout(function () {
        that.isMinLoading = false;
        if (that.waitingOnMinLoading) {
          that.waitingOnMinLoading = false;
          that.loading(false);
        }
      }, 2000);
    } else {
      if (this.isMinLoading === false) {
        if (this.loading_container !== undefined) {
          this.element[0].NiXPSButton._Self.removeChild(this.loading_container);
          this.loading_container = undefined;
        }
        if (this.element[0].NiXPSButton._Label !== undefined) {
          this.element[0].NiXPSButton._Label.style.display = "";
        }
        if (this.element[0].NiXPSButton._Icon !== undefined) {
          this.element[0].NiXPSButton._Icon.style.display = "";
        }
        this.element[0].NiXPSButton._Self.removeAttribute("disabled");
      } else {
        this.waitingOnMinLoading = true;
      }
    }
  },
  _clickHandler: function _clickHandler(event) {
    if (this.element[0].NiXPSButton._Self !== event.target) {
      event.stopPropagation();
      event.stopImmediatePropagation();
      $(this.element[0].NiXPSButton._Self).trigger("click");
    }
  },
  /**
   * @brief validates the options
   */
  _validateOptions: function _validateOptions() {
    if (NiXPSButton_hasValidType(this.options) === false) {
      if ((typeof this.options.label !== "string" || this.options.label.length <= 0) && (typeof this.options.iconClass !== "string" || this.options.iconClass.length <= 0)) {
        throw new Error("nixps-button: either the label or iconClass option must be a string and not be empty!");
      }
    }
    if (typeof this.options.tooltip !== "string") {
      throw new Error("nixps-button: the tooltip option must be a string!");
    }
    if (typeof this.options.iconClass !== "string") {
      throw new Error("nixps-button: the iconClass option must be a string!");
    }
    if (typeof this.options.buttonClass !== "string") {
      throw new Error("nixps-button: the buttonClass option must be a string!");
    }
    if (typeof this.options.isPrimary !== "boolean") {
      throw new Error("nixps-button: the isPrimary option must be a boolean!");
    }
    if (typeof this.options.disabled !== "boolean") {
      throw new Error("nixps-button: the disabled option must be a boolean!");
    }
  },
  _setOptions: function _setOptions(options) {
    this._super(options);
    var that = this;
    var needsToRedraw = false;
    if (options.label !== undefined && options.label !== undefined && options.type === undefined) {
      options["type"] = "";
    }
    this._validateOptions();
    this.redraw();
  }
});
module.exports = NiXPSButton;

},{}],14:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("../../Container/js/nixps-container-Collapse.js");
require("../../Widget/js/nixps-widget-NiXPSWidget.js");
(function ($) {
  $.widget("nixps-form.OrderedArrayInput", $["nixps-widget"]["NiXPSWidget"], {
    options: {
      /**
       * @description The form used for the array items
       * @name nixps-form.OrderedArrayInput#formOptions
       * @type {string}
       * @default ""
       * @required
       */
      formOptions: null,
      /**
       * @name nixps-form.OrderedArrayInput#sortable
       * @description This specifies whether the list can be sorted
       * @type {boolean}
       * @default false
       */
      sortable: false,
      /**
       * @name nixps-form.OrderedArrayInput#collapsable
       * @description Whether the form can be collapsed
       * Either false, or a function that renders a value object and returns an Element for the header of the collapse
       * @type {boolean|function}
       * @default false
       */
      collapsable: false,
      /**
       * @name nixps-form.OrderedArrayInput#valueWhenEmpty
       * @description The value used when a form is added
       * @type {object}
       * @default {}
       */
      valueWhenEmpty: {},
      /**
       * @name nixps-form.OrderedArrayInput#allowEmpty
       * @description Can the array be empty?
       * @type {boolean}
       * @default false
       */
      allowEmpty: false,
      buttonType: undefined
    },
    _create: function _create() {
      this._super();
      this._validateOptions();
      this.startIndex;
      this.items = this.options.allowEmpty ? [] : [this.options.valueWhenEmpty];
      this.element.addClass(this.widgetFullName + " orderedarrayinput");
      this._draw();
      this._onOptionChange(["formOptions", "collapsable"], this.redrawList);
      this._onOptionChange(["sortable"], this.redrawSortable);
      this._on(this.list, {
        'sortstart': this._sortStartHandler,
        'sortupdate': this._sortUpdateHandler,
        'click .orderedarrayinput__item': this._updateItems,
        'formrendererchange .orderedarrayinput__item': this._updateItems
      });
    },
    /**
     * @brief draws the list according to the current state
     */
    _draw: function _draw() {
      var that = this;
      this.list = document.createElement("div");
      this.element[0].appendChild(this.list);
      $(this.list).sortable({
        axis: "y",
        cancel: "button",
        placeholder: "orderedarrayinput__placeholder",
        handle: ".collapse-header",
        forceHelperSize: false,
        helper: function helper(event, element) {
          if (that.options.collapsable !== false) {
            var clone = $("<div class='orderedarrayinput__item'></div>").append($("<div class='nixps-container-Collapse'></div>").append($(element[0].children[0]).Collapse("getContent", "collapse-header").clone()));
          } else {
            var clone = element.clone();
          }
          clone[0].classList.add("orderedarrayinput__helper");
          clone[0].style.height = clone[0].offsetHeight + "px";
          return clone;
        },
        tolerance: "pointer",
        disabled: this.options.disabled
      });
      this.redraw();
    },
    redraw: function redraw() {
      this.redrawList();
      this.redrawSortable();
    },
    redrawList: function redrawList() {
      var that = this;
      this._drawList([], this.items, this.list, this.list.children, "div", "orderedarrayinput__item", function (pElement, pItem, pIndex) {
        that._redrawFormRenderer(pElement, pItem, pIndex !== 0);
      }, function (pPreviousItem, pCurrentItem, pIndex) {
        return false;
      }, function (pElement) {});
      if (this.list.children.length === 0) {
        this.addPlaceHolder();
      }
      this.redrawListClasses();
      this._updateFirstItemButton();
    },
    addPlaceHolder: function addPlaceHolder() {
      var placeholder = document.createElement("div");
      placeholder.className = "orderedarrayinput__item flex-row";
      var formrenderer = document.createElement("div");
      formrenderer.className = "flex-grow-1";
      placeholder.appendChild(formrenderer);
      var buttons = this._drawButtons();
      placeholder.appendChild(buttons);
      this.list.appendChild(placeholder);
    },
    redrawListClasses: function redrawListClasses() {
      for (var i = 0, len = this.list.children.length; i < len; i++) {
        if (i % 2 === 0) {
          this.list.children[i].classList.remove("orderedarrayinput__item--even");
        } else {
          this.list.children[i].classList.add("orderedarrayinput__item--even");
        }
      }
    },
    redrawSortable: function redrawSortable() {
      $(this.list).sortable(this.options.sortable ? "enable" : "disable");
    },
    _redrawFormRenderer: function _redrawFormRenderer(pElement, pOptions, pCollapsed) {
      var initiated = pElement.children.length > 0;
      var isCollapsable = initiated && pElement.children[0].className.indexOf("nixps-container-Collapse") !== -1;
      if ((isCollapsable === false && this.options.collapsable !== false || isCollapsable === true && this.options.collapsable === false) && initiated === true) {
        for (var i = pElement.children.length - 1; i >= 0; i--) {
          pElement.removeChild(pElement.children[i]);
        }
        initiated = false;
      }
      if (this.options.collapsable !== false) {
        if (initiated === false) {
          var collapse = document.createElement("div");
          $(collapse).Collapse({
            collapsed: pCollapsed,
            useBootstrap: false
          });
          var formRenderer = document.createElement("div");
          pElement.appendChild(collapse);
          $(pElement.children[0]).Collapse("addContent", $(formRenderer), "body");
          var collapseHeader = $(pElement.children[0]).Collapse("getContent", "collapse-header")[0];
          collapseHeader.classList.add("flex-row");
          var collapseHeaderContent = document.createElement("div");
          collapseHeaderContent.classList.add("flex-row");
          var content = this.options.collapsable(pOptions);
          content.classList.add("flex-grow-1");
          collapseHeaderContent.appendChild(content);
          collapseHeaderContent.appendChild(this._drawButtons());
          $(pElement.children[0]).Collapse("addContent", collapseHeaderContent, "collapse-header");
        } else {
          var collapseHeader = $(pElement.children[0]).Collapse("getContent", "collapse-header")[0];
          var content = this.options.collapsable(pOptions);
          content.classList.add("flex-grow-1");
          collapseHeader.lastChild.replaceChild(content, collapseHeader.lastChild.firstChild);
          var formRenderer = $(pElement.children[0]).Collapse("getContent", "body")[0].firstChild;
        }
        pElement.classList.remove("flex-row");
        $(formRenderer).FormRenderer(Object.assign({}, this.options.formOptions, {
          disabled: this.options.disabled
        })).FormRenderer("setValues", pOptions);
      } else {
        if (initiated === false) {
          var formRenderer = document.createElement("div");
          formRenderer.classList.add("flex-grow-1");
          pElement.appendChild(formRenderer);
          pElement.appendChild(this._drawButtons());
        } else {
          formRenderer = pElement.children[0];
        }
        pElement.classList.add("flex-row");
        $(formRenderer).FormRenderer(Object.assign({}, this.options.formOptions, {
          disabled: this.options.disabled
        })).FormRenderer("setValues", pOptions);
      }
    },
    _drawButtons: function _drawButtons() {
      var buttonContainer = document.createElement("div");
      buttonContainer.className = "buttongroup";
      buttonContainer.appendChild(this._drawButton("minus"));
      buttonContainer.appendChild(this._drawButton("plus"));
      return buttonContainer;
    },
    _drawButton: function _drawButton(pType) {
      var button = document.createElement("button");
      button.className = pType + "Button";
      $(button).Button({
        iconClass: "cf-icon cf-icon-" + pType + "-circle",
        action: pType,
        bigIcon: true,
        disabled: this.options.disabled
      });
      if (this.options.buttonType !== undefined) {
        $(button).attr("type", "button");
      }
      return button;
    },
    _sortStartHandler: function _sortStartHandler(event, ui) {
      for (var i = 0, len = this.list.children.length; i < len; i++) {
        if (this.list.children[i] === ui.item[0]) {
          this.startIndex = i;
        }
      }
      $(this.list).sortable("refreshPositions");
    },
    _sortUpdateHandler: function _sortUpdateHandler(event, ui) {
      var endIndex = -1;
      for (var i = 0, len = this.list.children.length; i < len; i++) {
        if (this.list.children[i] === ui.item[0]) {
          endIndex = i;
        }
      }
      var value = this.items[this.startIndex];
      this.items = [].concat(this.items.slice(0, this.startIndex)).concat(this.items.slice(this.startIndex + 1));
      this.items = [].concat(this.items.slice(0, endIndex)).concat(value[0]).concat(this.items.slice(endIndex));
      this.redrawListClasses();
    },
    enable: function enable() {
      this.options.disabled = false;
      for (var i = 0, len = this.list.children.length; i < len; i++) {
        var formRenderer = $(this._getFormRenderer(this.list.children[i]));
        formRenderer.filter(".nixps-cloudflow-FormRenderer").FormRenderer("option", "disabled", false);
        var buttons = $(this._getButtons(this.list.children[i]));
        buttons.find(".nixps-form-Button").Button("option", "disabled", false);
      }
      $(this.list).sortable("option", "disabled", false);
    },
    disable: function disable() {
      this.options.disabled = true;
      for (var i = 0, len = this.list.children.length; i < len; i++) {
        var formRenderer = $(this._getFormRenderer(this.list.children[i]));
        formRenderer.filter(".nixps-cloudflow-FormRenderer").FormRenderer("option", "disabled", true);
        var buttons = $(this._getButtons(this.list.children[i]));
        buttons.find(".nixps-form-Button").Button("option", "disabled", true);
      }
      $(this.list).sortable("option", "disabled", true);
    },
    getValue: function getValue(pWithValidation) {
      if (pWithValidation === undefined) {
        pWithValidation = true;
      }
      if (pWithValidation) {
        var valid = true;
        for (var i = 0, len = this.list.children.length; i < len; i++) {
          var formRenderer = $(this._getFormRenderer(this.list.children[i]));
          if (formRenderer.hasClass("nixps-cloudflow-FormRenderer")) {
            valid = valid && formRenderer.FormRenderer("isValid", false, true) === true;
          }
        }
        if (valid === true) {
          return this.items;
        } else {
          return null;
        }
      } else {
        return this.items;
      }
    },
    isValid: function isValid(pReturnErrorMessage, pHighlightError) {
      for (var i = 0, len = this.list.children.length; i < len; i++) {
        var formRenderer = $(this._getFormRenderer(this.list.children[i]));
        if (formRenderer.hasClass("nixps-cloudflow-FormRenderer")) {
          var valid = formRenderer.FormRenderer("isValid", pReturnErrorMessage, pHighlightError);
          if (valid !== true) {
            return valid;
          }
        }
      }
      return true;
    },
    setValue: function setValue(pValues) {
      this.items = pValues;
      this.redrawList();
    },
    getState: function getState() {},
    setState: function setState(pState) {},
    _updateFirstItemButton: function _updateFirstItemButton() {
      var buttons = this._getButtons(this.list.firstChild);
      if (this.items.length === 0 || this.items.length === 1 && this.options.allowEmpty === false) {
        buttons.firstChild.style.visibility = "hidden";
      } else {
        buttons.firstChild.style.visibility = "";
      }
    },
    _updateItems: function _updateItems(event) {
      var index = -1;
      for (var i = 0, len = this.list.children.length; i < len; i++) {
        if (this.list.children[i] === event.currentTarget) {
          index = i;
        }
      }
      if (index !== -1 && typeof event.target.className === "string" && event.type === "click") {
        event.stopPropagation();
        if (event.target.className.indexOf("minusButton") !== -1) {
          this.list.removeChild(event.currentTarget);
          this.items = [].concat(this.items.slice(0, index)).concat(this.items.slice(index + 1));
          if (this.items.length === 0) {
            this.addPlaceHolder();
          }
          this.element.trigger("change", event);
        } else if (event.target.className.indexOf("plusButton") !== -1) {
          var listItem = document.createElement("div");
          listItem.className = "orderedarrayinput__item";
          if (this._isPlaceholder(this.list.firstChild) === true) {
            this.items = [this.options.valueWhenEmpty];
            this.list.replaceChild(listItem, this.list.firstChild);
            this._redrawFormRenderer(listItem, this.items[0], false);
          } else {
            this.items = [].concat(this.items.slice(0, index + 1)).concat(this.options.valueWhenEmpty).concat(this.items.slice(index + 1));
            this._redrawFormRenderer(this.list.insertBefore(listItem, this.list.children[index].nextSibling), this.items[index + 1], false);
          }
          this.element.trigger("change", event);
        }
        this._updateFirstItemButton();
        this.redrawListClasses();
      } else if (index !== -1 && event.type === "formrendererchange") {
        var values = $(this._getFormRenderer(this.list.children[index])).FormRenderer("getValues");
        if (this.list.children[index].firstChild.className.indexOf("nixps-container-Collapse") !== -1) {
          var collapseHeader = $(this.list.children[index].firstChild).Collapse("getContent", "collapse-header")[0];
          $;
          var content = this.options.collapsable(values);
          content.classList.add("flex-grow-1");
          collapseHeader.lastChild.replaceChild(content, collapseHeader.lastChild.firstChild);
        }
        this.items = [].concat(this.items.slice(0, index)).concat(values).concat(this.items.slice(index + 1));
      }
    },
    _isPlaceholder: function _isPlaceholder(pElement) {
      if (pElement.children[0].className.indexOf("nixps-container-Collapse") !== -1) {
        return $(pElement.children[0]).Collapse("getContent", "collapse-header")[0].firstChild.children.length === 0;
      } else {
        return pElement.firstChild.children.length === 0;
      }
    },
    _getButtons: function _getButtons(pElement) {
      if (pElement.children[0].className.indexOf("nixps-container-Collapse") !== -1) {
        return $(pElement.children[0]).Collapse("getContent", "collapse-header")[0].lastChild.lastChild;
      } else {
        return pElement.lastChild;
      }
    },
    _getFormRenderer: function _getFormRenderer(pElement) {
      if (pElement.children[0].className.indexOf("nixps-container-Collapse") !== -1) {
        return $(pElement.children[0]).Collapse("getContent", "body")[0].firstChild;
      } else {
        return pElement.firstChild;
      }
    },
    /**
     * @brief validates the options
     */
    _validateOptions: function _validateOptions() {
      if (_typeof(this.options.formOptions) !== "object" || Array.isArray(this.options.formOptions) === true || this.options.formOptions === null) {
        throw new Error("OrderedArrayInput: the OrderedArrayInput option must be an object!");
      }
    }
  });
})(jQuery);

},{"../../Container/js/nixps-container-Collapse.js":10,"../../Widget/js/nixps-widget-NiXPSWidget.js":17}],15:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function ($) {
  require("../../../../../cloudflow/AssetTreeView/js/nixps-cloudflow-AssetTreeView.js");
  require("../../../../../common/DropdownList/js/nixps-DropdownList.js");
  var QueryApplier = require("../../../../../cloudflow/CloudflowUtil/js/QueryApplier.js");
  var ProjectFormFileTreeActions = require("./nixps-cloudflow-ProjectFormFileTreeActions.js");
  var File = require("../../../Model/Asset/js/nixps-File.js");
  var Job = require("../../../Model/Job/js/nixps-Job.js");
  var GUID = require("../../../../../cloudflow/CloudflowUtil/js/GUID.js");
  var LogListener = require("../../../../../pagebuilder/js/inspect/LogListener.js");
  var kViewableFileRegExp = new RegExp(".*(\.pdf|\.ai|\.art|\.tif|\.tiff|\.ic3|\.ic3d|\.len|\.cf2|\.png|\.jpg|\.jpeg)$", "i");
  $.widget("nixps-cloudflow.ProjectFormAssets", $.Widget, {
    version: "1.0.0",
    options: {
      /**
       * @name nixps-cloudflow.ProjectFormAssets#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.ProjectFormAssets#rootFolder
       * @description The rootfolder for the asset tree
       * @type {Object}
       * @default {}
       */
      rootFolder: {},
      /**
       * @name nixps-cloudflow.ProjectFormAssets#project
       * @description The project of which the files/folders need to be shown
       * @type {Object}
       * @default {}
       */
      project: {},
      /**
       * @name nixps-cloudflow.ProjectFormAssets#projectFormFileTreeActions
       * @description The class containing the filetree actions, needed for the right click
       * @type {Object}
       * @default undefined
       */
      projectFormFileTreeActions: undefined,
      /**
       * @description The whitepaper to which to upload files
       * @name nixps-cloudflow.ProjectFormAssets#whitepaper
       * @type {string}
       * @default undefined
       */
      whitepaper: undefined,
      /**
       * @description The whitepaper input to which to upload files
       * @name nixps-cloudflow.ProjectFormAssets#whitepaperInput
       * @type {string}
       * @default undefined
       */
      whitepaperInput: undefined,
      /**
       * @description The root tag name for the project's assets
       * @name nixps-cloudflow.ProjectFormAssets#rootTag
       * @type {string}
       * @default ""
       */
      rootTag: "",
      /**
       * @description Should we allow uploading by drag and dropping files
       * @name nixps-cloudflow.ProjectFormAssets#enableUpload
       * @type {boolean}
       * @default true
       */
      enableUpload: true,
      /**
       * @description If uploading is enabled, this whitepaper will be used instead of the whitepaper option. 
       * Leaving this undefined, means the whitepaper option will handle uploads.
       * @name nixps-cloudflow.ProjectFormAssets#enableUpload
       * @type {string}
       * @default undefined
       */
      uploadWhitepaper: undefined,
      /**
       * @description The input for the uploadWhitepaper. This input should be a "start from kiosk", with the following parameters expected:
       * mode, parent_url, file_name, tag.
       * If uploadWhitepaper isn't defined, this won't be used.
       * @name nixps-cloudflow.ProjectFormAssets#enableUpload
       * @type {string}
       * @default undefined
       */
      uploadWhitepaperInput: undefined,
      /**
       * @description An array of context menu buttons. Empty array means no context menu, 
       * undefined means we'll use the buttons from projectFormFileTreeActions.
       * @name nixps-cloudflow.ProjectFormAssets#enableUpload
       * @type {array}
       * @default undefined
       */
      customContextItems: undefined,
      /**
       * @name nixps-cloudflow.ProjectFormAssets#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    _create: function _create() {
      var that = this;
      this._controlOptions();
      this._addClass(this.widgetFullName);

      // variables
      this.alive = true;
      this.calledCreated = false;
      this.thumbsCache = {};
      this.orphanFolderURL = "cloudflow://PP_FILE_STORE/" + GUID.generate() + "/";
      this.menuGuid = GUID.generate();
      this.updateCallingID = 0;
      this.drawCallingID = 0;
      this.zIndex = undefined;
      if (this.options.projectFormFileTreeActions === undefined || this.options.projectFormFileTreeActions === null) {
        this.projectFormFileTreeActions = new ProjectFormFileTreeActions(this.options.whitepaper, this.options.whitepaperInput, undefined, this.options.uploadWhitepaper, this.options.uploadWhitepaperInput);
        this.projectFormFileTreeActions.setFileTree(this);
        this.projectFormFileTreeActions.setProject(this.options.project);
        this.projectFormFileTreeActions.on({
          "renamedfile": this._redirectHandler.bind(this),
          "renamedfolder": this._redirectHandler.bind(this),
          "removedfile": this._redirectHandler.bind(this),
          "removedfolder": this._redirectHandler.bind(this),
          "addedfile": this._redirectHandler.bind(this),
          "movedfile": this._redirectHandler.bind(this),
          "movedfolder": this._redirectHandler.bind(this)
        });
      } else {
        this.projectFormFileTreeActions = this.options.projectFormFileTreeActions;
      }
      this._draw();
      this.projectFormFileTreeActions.on("uploadprogress", function (e, data) {
        that.element.find(".projectformassets-files").AssetTreeView("updateProgress", e, data);
      });
      this.projectFormFileTreeActions.on("uploaddone", function (e, data) {
        that.element.find(".projectformassets-files").AssetTreeView("updateDone", e, data);
      });
      this._on(this.element, {
        "assettreeviewcontextmenu": this._handleTreeviewContextmenu,
        "assettreeviewclick": this._handleTreeviewClick,
        "assettreeviewfileupload": this._handleFileDropUpload,
        "assettreeviewmovenode": this._handleFileMove,
        "assettreeviewisdraggable": this._isNodeDraggable,
        "assettreeviewisdroppable": this._isNodeDroppable,
        "assettreeviewloaded": this._handleTreeViewLoaded,
        "assettreeviewerror": this._handleTreeViewError
      });
    },
    _redirectHandler: function _redirectHandler(pEvent, pData) {
      var that = this;
      if (pData === undefined || _typeof(pData) !== "object") {
        pData = {};
      }
      pData.type = pEvent.type;
      //if refresh is handled by another component, we won't continue after
      var mustContinue = this._trigger("redirect", null, pData);
      if (mustContinue !== false) {
        //update yourself
        var projectDef;
        var projectReference;
        if (pData.updated_job !== undefined) {
          projectReference = pData.updated_job;
        } else {
          //just update usign existing data - try to get the job id
          if (this.options.project.project_id !== undefined) {
            projectReference = this.options.project.project_id;
          } else {
            //give up - "update" with whatever data we have
            projectReference = this.options.project;
          }
        }
        if (typeof projectReference === "string") {
          if (projectReference.indexOf("-") === -1) {
            projectDef = api_defer.job.get(projectReference);
          } else {
            projectDef = api_defer.job.get_by_project_id(projectReference);
          }
        } else if (_typeof(projectReference) === "object" && Array.isArray(projectReference) === false) {
          projectDef = projectReference;
        } else {
          throw new Error("ProjectFormAssets: got wrong interface after file/folder action - ID or object is expected");
        }
        $.when(projectDef, ++this.updateCallingID).then(function (pJob, pCallingID) {
          if (pCallingID < that.updateCallingID || that.alive === false) {
            return;
          }
          that.options.rootFolder = {};
          that.options.project = pJob;
          that.redraw();
        }).fail(function (pFail) {
          console.error("ProjectFormAssets: couldn't update the tree after an asset action");
          console.error(pFail);
        });
      }
    },
    _draw: function _draw() {
      var that = this;
      var projectDef = this.options.project;
      this.folders = [];
      this.files = [];
      this.knownFolderURLs = [];
      this.rootFolders = [];
      this.orphanFiles = [];
      this.rootFolderURLs = [];
      if (typeof this.options.project === "string") {
        //got an ID for project, fetch first!
        if (this.options.project.indexOf("-") === -1) {
          projectDef = api_defer.job.get(this.options.project);
        } else {
          projectDef = api_defer.job.get_by_project_id(this.options.project);
        }
      }
      return $.Deferred(function (pDrawDefer) {
        $.when(projectDef, ++this.drawCallingID).then(function (pJob, pCallingID) {
          if (pCallingID < that.drawCallingID || that.alive === false) {
            return; // kill the zombies
          }

          that.options.project = pJob;
          that.projectFormFileTreeActions.setProject(that.options.project);
          if (that.options.rootFolder === undefined || $.isEmptyObject(that.options.rootFolder) === true) {
            if (that.element.find(".projectformassets-files").length === 0) {
              //means there's data from the previously selected job, empty the tree
              that.element.empty();
            }
            //lets try and find the rootfolder!
            var rootFolder = that._findRootFolder(that.options.project, that.options.rootTag);
            if (rootFolder !== undefined) {
              that.options.rootFolder = rootFolder;
              rootFolder = new File(rootFolder);
              var folderURL = rootFolder.url;
              var enclosingFolder;
              if (folderURL.endsWith("/")) {
                enclosingFolder = folderURL.substring(0, folderURL.slice(0, -1).lastIndexOf("/") + 1);
              } else {
                enclosingFolder = folderURL.substring(0, folderURL.lastIndexOf("/") + 1);
              }
              var folderObject = {
                cloudflow: {
                  folder: rootFolder.url,
                  enclosing_folder: enclosingFolder
                },
                name: decodeURIComponent(rootFolder.path[rootFolder.path.length - 1]),
                project_id: that.options.project.project_id
              };
              that.rootFolders.push(folderObject);
              that.rootFolderURLs.push(rootFolder.url);
            } else {
              //if it's still not found, we give up!
              if (that.calledCreated === false) {
                that.calledCreated = true;
                that.options.created();
              }
              that.element.empty();
              return;
            }
          } else {
            var _rootFolder = that.options.rootFolder;
            if (_rootFolder instanceof File === false) {
              _rootFolder = new File(_rootFolder);
            }
            var folderURL = _rootFolder.url;
            if (folderURL.endsWith("/")) {
              enclosingFolder = folderURL.substring(0, folderURL.slice(0, -1).lastIndexOf("/") + 1);
            } else {
              enclosingFolder = folderURL.substring(0, folderURL.lastIndexOf("/") + 1);
            }
            var folderObject = {
              cloudflow: {
                folder: _rootFolder.url,
                enclosing_folder: enclosingFolder
              },
              name: decodeURIComponent(_rootFolder.path[_rootFolder.path.length - 1]),
              project_id: that.options.project.project_id
            };
            that.rootFolders.push(folderObject);
            that.rootFolderURLs.push(folderURL);
          }
          if (Array.isArray(that.options.project.folders)) {
            that.options.project.folders.forEach(function (folder) {
              if (folder instanceof File === false) {
                folder = new File(folder);
              }
              var folderURL = folder.url;
              var enclosingFolder;
              if (folderURL.endsWith("/")) {
                enclosingFolder = folderURL.substring(0, folderURL.slice(0, -1).lastIndexOf("/") + 1);
              } else {
                enclosingFolder = folderURL.substring(0, folderURL.lastIndexOf("/") + 1);
              }
              var folderObject = {
                cloudflow: {
                  folder: folder.url,
                  enclosing_folder: enclosingFolder
                },
                name: decodeURIComponent(folder.path[folder.path.length - 1]),
                project_id: that.options.project.project_id
              };
              that.folders.push(folderObject);
              if (that.options.rootFolder.url === folder.url) {
                that.rootFolderURLs.push(folder.url);
                that.rootFolders.push(folderObject);
              }
              that.knownFolderURLs.push(folder.url.endsWith("/") ? folder.url : folder.url + "/");
              that._checkEnclosingFolderKnown(enclosingFolder, that.options.project);
            });
          }
          if (Array.isArray(that.options.project.files)) {
            that.options.project.files.forEach(function (file) {
              var fileUrl = file.url;
              if (file instanceof File === false) {
                file = new File(file);
              }
              if (Array.isArray(fileUrl) === false) {
                fileUrl = [file.url];
              }
              fileUrl.forEach(function (pFileUrl) {
                var fileExistsInRoot = false;
                var folderURL = pFileUrl.substring(0, pFileUrl.lastIndexOf("/") + 1);
                that.rootFolderURLs.forEach(function (rootFolderURL) {
                  if (pFileUrl.indexOf(rootFolderURL) !== -1) {
                    //the rootfolder url exists in the file url, meaning the file is inside the rootfolder
                    fileExistsInRoot = true;
                    return;
                  }
                });
                if (fileExistsInRoot === true) {
                  that.files.push({
                    cloudflow: {
                      file: pFileUrl,
                      enclosing_folder: folderURL
                    },
                    file_name: file.path[file.path.length - 1],
                    approvals: file.approvals ? file.approvals : undefined,
                    project_id: that.options.project.project_id,
                    tag: file.tag
                  });
                } else {
                  var returnObject = {
                    cloudflow: {
                      file: pFileUrl,
                      enclosing_folder: folderURL
                    },
                    file_name: pFileUrl,
                    approvals: file.approvals ? file.approvals : undefined,
                    project_id: that.options.project.project_id,
                    tag: file.tag
                  };
                  that.orphanFiles.push(returnObject);
                }
                if (that.knownFolderURLs.includes(pFileUrl.substring(0, pFileUrl.lastIndexOf("/") + 1)) === false) {
                  var enclosingFolder;
                  var folderPath = pFileUrl.substring(0, pFileUrl.lastIndexOf("/")).split("/");
                  if (folderURL.endsWith("/")) {
                    enclosingFolder = folderURL.substring(0, folderURL.slice(0, -1).lastIndexOf("/") + 1);
                  } else {
                    enclosingFolder = folderURL.substring(0, folderURL.lastIndexOf("/") + 1);
                  }
                  that.folders.push({
                    cloudflow: {
                      folder: folderURL,
                      enclosing_folder: enclosingFolder
                    },
                    name: decodeURIComponent(folderPath[folderPath.length - 1])
                  });
                  that.knownFolderURLs.push(pFileUrl.substring(0, pFileUrl.lastIndexOf("/") + 1));
                  that._checkEnclosingFolderKnown(enclosingFolder, that.options.project);
                }
              });
            });
          }
          if (that.options.project.projects !== undefined && Array.isArray(that.options.project.projects)) {
            that._extendWithChildProjects(that.options.project, that.options.rootFolder);
          }
          var rootFolders = [];
          if (Array.isArray(that.rootFolders) && that.rootFolders.length > 0) {
            that.rootFolders[0].name = decodeURIComponent(that.rootFolders[0].cloudflow.folder);
            rootFolders = [that.rootFolders[0]];
          }
          var orphanThumbsDef = {};
          if (that.orphanFiles.length > 0) {
            orphanThumbsDef = $.Deferred(function (pDefer) {
              var fetchThumbUrls = [];
              that.orphanFiles.forEach(function (pFile) {
                if (pFile.thumb === undefined) {
                  if (that.thumbsCache[pFile.cloudflow.file] !== undefined) {
                    pFile.thumb = that.thumbsCache[pFile.cloudflow.file];
                  } else if (kViewableFileRegExp.test(pFile.cloudflow.file) === true) {
                    fetchThumbUrls.push(pFile.cloudflow.file);
                  }
                }
              });
              if (fetchThumbUrls.length > 0) {
                api_async.asset.list_with_options(["cloudflow.file", "in", fetchThumbUrls], "", ["cloudflow.file", "thumb"], {}, function (pResult) {
                  pResult.results.forEach(function (pThumbURLData) {
                    for (var i = 0; i < that.orphanFiles.length; i++) {
                      if (that.orphanFiles[i].cloudflow.file === pThumbURLData.cloudflow.file && that.thumbsCache[pThumbURLData.cloudflow.file] === undefined) {
                        //only set the thumb if the cache is still undefined, 
                        //otherwise a result before current iteration already handled the file
                        //for example: multipage
                        that.orphanFiles[i].thumb = pThumbURLData.thumb;
                        that.thumbsCache[pThumbURLData.cloudflow.file] = pThumbURLData.thumb;
                        break;
                      }
                    }
                  });
                  pDefer.resolve();
                }, function (pFail) {
                  //resolve without thumbs
                  console.error(pFail);
                  pDefer.resolve();
                });
              } else {
                pDefer.resolve();
              }
            });
          }
          $.when(orphanThumbsDef).done(function () {
            if (that.alive === false) {
              return; // kill the zombies
            }

            if (that.orphanFiles.length > 0) {
              rootFolders.push({
                cloudflow: {
                  "folder": that.orphanFolderURL,
                  "enclosing_folder": "cloudflow://PP_FILE_STORE/"
                },
                "name": $.i18n._("nixps-cloudflow-ProjectFormProperties.external_files")
              });
            }
            if (that.element.find(".projectformassets-files").length === 0) {
              var files = document.createElement("div");
              $(files).addClass("projectformassets-files");
              $(files).AssetTreeView({
                folders: rootFolders,
                // files: that.orphanFiles,
                enableContextMenu: true,
                enableSelecting: true,
                enableMultipleSelection: false,
                enableDropZone: that.options.enableUpload,
                enableApprovalInfo: true,
                showCanceledApprovalInfo: true,
                enableSaveState: true,
                folderProvider: that._getFoldersForTree.bind(that),
                fileProvider: that._getFilesForTree.bind(that),
                context: "nixps_joda_assettreeview",
                uploadProgressType: "progressbar",
                sortCallBack: function sortCallBack(nodeA, nodeB) {
                  if (nodeA.id === that.orphanFolderURL) {
                    return 1;
                  }
                  return -1;
                },
                mayDrop: function mayDrop(cloudflowfolder, node) {
                  var droppable = false;
                  var projectId = null;
                  that.folders.forEach(function (pFolder) {
                    if (pFolder.cloudflow.folder === node.id) {
                      projectId = pFolder.project_id;
                    }
                    if (projectId !== null && projectId !== undefined) {
                      if (droppable === false) {
                        droppable = true;
                      }
                      return;
                    }
                  });
                  return droppable;
                }
              });
              that.element.append(files);
            } else {
              $(that.element.find(".projectformassets-files")).AssetTreeView({
                folders: rootFolders,
                enableDropZone: that.options.enableUpload,
                // files: that.orphanFiles,
                context: "nixps_joda_assettreeview"
              });
            }
            pDrawDefer.resolve({});
          });
        }).fail(function (pFail) {
          that.element.empty();
          console.error(pFail);
          if (that.calledCreated === false) {
            that.calledCreated = true;
            that.options.created();
          }
          pDrawDefer.reject(pFail);
        });
      });
    },
    _findCommonRootFolder: function _findCommonRootFolder(pRootFolders) {
      var arr = pRootFolders.sort();
      var str1 = arr[0].substring(0, arr[0].lastIndexOf("/") + 1);
      var str2 = arr[arr.length - 1].substring(0, arr[arr.length - 1].lastIndexOf("/") + 1);
      var shortest = str1.length;
      var i = 0;
      while (i < shortest && str1.charAt(i) === str2.charAt(i)) {
        i++;
      }
      var foundUrl = str1.substring(0, i);
      return foundUrl.substring(0, foundUrl.lastIndexOf("/") + 1);
    },
    _findRootFolder: function _findRootFolder(pProject, pRootTag) {
      var projectFilesAndFolders = Job.getAllFilesAndFolders(pProject);
      var rootFolder;
      if (projectFilesAndFolders.folders.length > 0 || projectFilesAndFolders.files.length > 0) {
        if (pRootTag.length > 0) {
          var found = false;
          var rootFolders = [];
          for (var i = 0, len = projectFilesAndFolders.folders.length; i < len; i++) {
            if (File.getTag(projectFilesAndFolders.folders[i]) === pRootTag && projectFilesAndFolders.folders[i].project_id === pProject.project_id) {
              rootFolders.push(projectFilesAndFolders.folders[i].url);
              found = true;
            }
          }
          for (var i = 0, len = projectFilesAndFolders.files.length; i < len; i++) {
            if (File.getTag(projectFilesAndFolders.files[i]) === pRootTag && projectFilesAndFolders.files[i].project_id === pProject.project_id) {
              var url = projectFilesAndFolders.files[i].url;
              if (Array.isArray(url)) {
                url = url[0]; //assume all urls exist in the same folder
              }

              rootFolders.push(url.substring(0, url.lastIndexOf("/") + 1));
              found = true;
            }
          }
          if (found === false) {
            //try with all folders/files, not just the currently selected job's files/folders
            for (var i = 0, len = projectFilesAndFolders.folders.length; i < len; i++) {
              if (File.getTag(projectFilesAndFolders.folders[i]) === pRootTag) {
                rootFolders.push(projectFilesAndFolders.folders[i].url);
                found = true;
              }
            }
            for (var i = 0, len = projectFilesAndFolders.files.length; i < len; i++) {
              if (File.getTag(projectFilesAndFolders.files[i]) === pRootTag) {
                var url = projectFilesAndFolders.files[i].url;
                if (Array.isArray(url)) {
                  url = url[0]; //assume all urls exist in the same folder
                }

                rootFolders.push(url.substring(0, url.lastIndexOf("/") + 1));
                found = true;
              }
            }
          }
          if (found == true) {
            //find the common root folder for the found rootfolders
            var rootFolderUrl = this._findCommonRootFolder(rootFolders);
            rootFolder = _.find(projectFilesAndFolders.folders, function (pFolder) {
              return pFolder.url === rootFolderUrl;
            });
            if (rootFolder === undefined) {
              rootFolder = _.find(projectFilesAndFolders.files, function (pFile) {
                var url = pFile.url;
                return url.substring(0, url.lastIndexOf("/") + 1) === rootFolderUrl;
              });
              if (rootFolder) {
                var newFolder = structuredClone(rootFolder);
                newFolder.url = rootFolderUrl;
                newFolder.type = "folder";
                if (newFolder.path === undefined) {
                  newFolder.path = newFolder.url.split("/");
                }
                newFolder.path.pop();
                pProject.folders.unshift(newFolder);
                rootFolder = newFolder;
              } else {
                rootFolder = {
                  url: rootFolderUrl,
                  type: "folder",
                  path: rootFolderUrl.split("/")
                };
                pProject.folders.unshift(rootFolder);
              }
            }
          } else {
            //a roottag was given, but we couldn't find the rootfolder, so do nothing
          }
        } else {
          //no roottag given, need to find the common folder
          var filesAndFolders = projectFilesAndFolders.folders.concat(projectFilesAndFolders.files);
          filesAndFolders = filesAndFolders.map(function (pFileOrFolder) {
            return pFileOrFolder.url;
          });
          var _rootFolderUrl = this._findCommonRootFolder(filesAndFolders);
          rootFolder = {
            url: _rootFolderUrl,
            type: "folder",
            path: _rootFolderUrl.split("/")
          };
        }
      }
      return rootFolder;
    },
    _checkEnclosingFolderKnown: function _checkEnclosingFolderKnown(pEnclosingFolder, pProject) {
      if (this.knownFolderURLs.includes(pEnclosingFolder)) {
        return true;
      }
      var newEnclosingFolder;
      var folderPath = pEnclosingFolder.substring(0, pEnclosingFolder.lastIndexOf("/")).split("/");
      if (pEnclosingFolder.endsWith("/")) {
        newEnclosingFolder = pEnclosingFolder.substring(0, pEnclosingFolder.slice(0, -1).lastIndexOf("/") + 1);
      } else {
        newEnclosingFolder = pEnclosingFolder.substring(0, pEnclosingFolder.lastIndexOf("/") + 1);
      }
      this.folders.push({
        cloudflow: {
          folder: pEnclosingFolder,
          enclosing_folder: newEnclosingFolder
        },
        name: decodeURIComponent(folderPath[folderPath.length - 1]),
        project_id: pProject.project_id
      });
      this.knownFolderURLs.push(pEnclosingFolder.substring(0, pEnclosingFolder.lastIndexOf("/") + 1));
      this._checkEnclosingFolderKnown(newEnclosingFolder, pProject);
    },
    _extendWithChildProjects: function _extendWithChildProjects(pProject, pRootFolder) {
      var that = this;
      pProject.projects.forEach(function (pChildProject) {
        if (Array.isArray(pChildProject.folders)) {
          pChildProject.folders.forEach(function (folder) {
            var folderURL = folder.url;
            var enclosingFolder;
            if (folderURL.endsWith("/")) {
              enclosingFolder = folderURL.substring(0, folderURL.slice(0, -1).lastIndexOf("/") + 1);
            } else {
              enclosingFolder = folderURL.substring(0, folderURL.lastIndexOf("/") + 1);
            }
            if (folder.path === undefined) {
              folder.path = folder.url.split("/");
            }
            var folderObject = {
              cloudflow: {
                folder: folder.url,
                enclosing_folder: enclosingFolder
              },
              name: decodeURIComponent(folder.path[folder.path.length - 1]),
              project_id: pChildProject.project_id
            };
            if (that.knownFolderURLs.includes(folder.url)) {
              //extend when it's a known folder
              for (var i = 0; i < that.folders.length; i++) {
                if (that.folders[i].cloudflow.folder === folderObject.cloudflow.folder) {
                  that.folders[i].project_id = pChildProject.project_id;
                }
              }
            } else {
              that.folders.push(folderObject);
              that.knownFolderURLs.push(folder.url.endsWith("/") ? folder.url : folder.url + "/");
            }
            if (pRootFolder.url === folder.url) {
              that.rootFolderURLs.push(folder.url);
              that.rootFolders.push(folderObject);
            }
            that._checkEnclosingFolderKnown(enclosingFolder, pChildProject);
          });
        }
        if (pChildProject.files !== undefined && Array.isArray(pChildProject.files)) {
          pChildProject.files.forEach(function (file) {
            var fileUrl = file.url;
            if (Array.isArray(fileUrl) === false) {
              fileUrl = [file.url];
            }
            fileUrl.forEach(function (pFileUrl) {
              var fileExistsInRoot = false;
              var folderURL = pFileUrl.substring(0, pFileUrl.lastIndexOf("/") + 1);
              that.rootFolderURLs.forEach(function (rootFolderURL) {
                if (pFileUrl.indexOf(rootFolderURL) !== -1) {
                  //the rootfolder url exists in the file url, meaning the file is inside the rootfolder
                  fileExistsInRoot = true;
                  return;
                }
              });
              if (fileExistsInRoot === true) {
                that.files.push({
                  cloudflow: {
                    file: pFileUrl,
                    enclosing_folder: folderURL
                  },
                  file_name: file.path[file.path.length - 1],
                  approvals: file.approvals ? file.approvals : undefined,
                  tag: file.tag,
                  project_id: pChildProject.project_id
                });
              } else {
                var returnObject = {
                  cloudflow: {
                    file: pFileUrl,
                    enclosing_folder: folderURL
                  },
                  file_name: pFileUrl,
                  approvals: file.approvals ? file.approvals : undefined,
                  tag: file.tag,
                  project_id: pChildProject.project_id
                };
                that.orphanFiles.push(returnObject);
              }
              if (that.knownFolderURLs.includes(pFileUrl.substring(0, pFileUrl.lastIndexOf("/") + 1)) === false) {
                var enclosingFolder;
                var folderPath = pFileUrl.substring(0, pFileUrl.lastIndexOf("/")).split("/");
                if (folderURL.endsWith("/")) {
                  enclosingFolder = folderURL.substring(0, folderURL.slice(0, -1).lastIndexOf("/") + 1);
                } else {
                  enclosingFolder = folderURL.substring(0, folderURL.lastIndexOf("/") + 1);
                }
                that.folders.push({
                  cloudflow: {
                    folder: folderURL,
                    enclosing_folder: enclosingFolder
                  },
                  name: decodeURIComponent(folderPath[folderPath.length - 1]),
                  project_id: pChildProject.project_id
                });
                that.knownFolderURLs.push(pFileUrl.substring(0, pFileUrl.lastIndexOf("/") + 1));
                that._checkEnclosingFolderKnown(enclosingFolder, pChildProject);
              }
            });
          });
        }
      });
    },
    _getFoldersForTree: function _getFoldersForTree(pEnclosingFolder) {
      var folders = [];
      var foundFolderURLs = [];
      this.folders.forEach(function (folder) {
        if (pEnclosingFolder === folder.cloudflow.enclosing_folder && foundFolderURLs.includes(folder.cloudflow.folder) === false) {
          folders.push(folder);
          foundFolderURLs.push(folder.cloudflow.folder);
        }
      });
      return folders;
    },
    _getFilesForTree: function _getFilesForTree(pEnclosingFolder) {
      var that = this;
      if (pEnclosingFolder.endsWith("/") === false) {
        pEnclosingFolder = pEnclosingFolder + "/";
      }
      if (this.orphanFolderURL === pEnclosingFolder) {
        return this.orphanFiles;
      }
      var foundFileURLs = [];
      return $.Deferred(function (pDefer) {
        var files = [];
        that.files.forEach(function (file) {
          var fileUrl = file.cloudflow.file;
          if (Array.isArray(fileUrl) === false) {
            fileUrl = [file.cloudflow.file];
          }
          fileUrl.forEach(function (pFileUrl) {
            if (pEnclosingFolder !== file.cloudflow.enclosing_folder || foundFileURLs.includes(pFileUrl)) {
              return;
            }
            var returnObject = {
              cloudflow: {
                file: pFileUrl
              },
              file_name: decodeURIComponent(pFileUrl.split("/")[pFileUrl.split("/").length - 1]),
              approvals: file.approvals ? file.approvals : undefined,
              thumb: file.thumb ? file.thumb : undefined
            };
            files.push(returnObject);
            foundFileURLs.push(returnObject.cloudflow.file);
          });
        });
        var fetchThumbUrls = [];
        files.forEach(function (pFile) {
          if (pFile.thumb === undefined) {
            if (that.thumbsCache[pFile.cloudflow.file] !== undefined) {
              pFile.thumb = that.thumbsCache[pFile.cloudflow.file];
            } else if (kViewableFileRegExp.test(pFile.cloudflow.file) === true) {
              fetchThumbUrls.push(pFile.cloudflow.file);
            }
          }
        });
        if (fetchThumbUrls.length > 0) {
          api_async.asset.list_with_options(["cloudflow.file", "in", fetchThumbUrls], "", ["cloudflow.file", "thumb"], {}, function (pResult) {
            pResult.results.forEach(function (pThumbURLData) {
              for (var i = 0; i < files.length; i++) {
                if (files[i].cloudflow.file === pThumbURLData.cloudflow.file && that.thumbsCache[pThumbURLData.cloudflow.file] === undefined) {
                  //only set the thumb if the cache is still undefined, 
                  //otherwise a result before current iteration already handled the file
                  //for example: multipage
                  files[i].thumb = pThumbURLData.thumb;
                  that.thumbsCache[pThumbURLData.cloudflow.file] = pThumbURLData.thumb;
                  break;
                }
              }
            });
            pDefer.resolve(files);
          }, function (pFail) {
            ///reolve without the thumbs
            console.error(pFail);
            pDefer.resolve(files);
          });
        } else {
          pDefer.resolve(files);
        }
      });
    },
    _findFileByURL: function _findFileByURL(pUrl) {
      var files = (this.files || []).concat(this.orphanFiles || []);
      return files.find(function (pFile) {
        if (pFile.cloudflow === undefined || pFile.cloudflow.file === undefined) {
          return false;
        }
        var fileURLs = Array.isArray(pFile.cloudflow.file) ? pFile.cloudflow.file : [pFile.cloudflow.file];
        return fileURLs.indexOf(pUrl) !== -1;
      });
    },
    getFileTag: function getFileTag(pUrl) {
      var file = this._findFileByURL(pUrl);
      if (file !== undefined && file.tag !== undefined) {
        return file.tag;
      }
      return "";
    },
    getFolderTag: function getFolderTag(pUrl) {
      var that = this;
      this.tag = "";
      var found = false;
      if (this.options.project.folders !== undefined && Array.isArray(this.options.project.folders) === true) {
        this.options.project.folders.forEach(function (folder) {
          if (found) {
            return;
          }
          var checkUrl = folder.url;
          if (checkUrl.endsWith("/") === false) {
            checkUrl += "/";
          }
          if (checkUrl === pUrl) {
            that.tag = folder.tag ? folder.tag : "";
            found = true;
          }
        });
      }
      if (!found && this.options.project.projects !== undefined && Array.isArray(this.options.project.projects)) {
        this._searchChildrenForFolderTag(this.options.project, pUrl);
      }
      return this.tag;
    },
    _searchChildrenForFolderTag: function _searchChildrenForFolderTag(pProject, pUrl) {
      var that = this;
      return pProject.projects.forEach(function (pChildProject) {
        for (var i = 0; i < pChildProject.folders.length; i++) {
          var folder = pChildProject.folders[i];
          var checkUrl = folder.url;
          if (checkUrl.endsWith("/") === false) {
            checkUrl += "/";
          }
          if (checkUrl === pUrl) {
            that.tag = folder.tag ? folder.tag : "";
          }
        }
        if (pChildProject.projects !== undefined && Array.isArray(pChildProject.projects)) {
          that._searchChildrenForFolderTag(pChildProject, pUrl);
        }
      });
    },
    setSelectedFile: function setSelectedFile(pFileUrl) {
      this.selectedFile = pFileUrl;
      if (this.selectedFile !== undefined && this.selectedFile !== null) {
        this._drawSelectedFile();
      } else {
        this.element.find(".nixps-cloudflow-AssetTreeView").AssetTreeView("setSelectedNode", null);
        this.selectedNode = undefined;
      }
    },
    _drawSelectedFile: function _drawSelectedFile() {
      var tree = this.element.find(".nixps-cloudflow-AssetTreeView");
      var node = tree.AssetTreeView("getNode", this.selectedFile);
      if (node !== null && node !== false) {
        var projectId = null;
        if (node.type === "file") {
          node["leaf"] = true;
          var file = this._findFileByURL(node.id);
          if (file !== undefined) {
            projectId = file.project_id;
          }
        } else if (node.type === "folder") {
          node["leaf"] = false;
          node.droppable = false;
          this.folders.forEach(function (pFolder) {
            if (pFolder.cloudflow.folder === node.id) {
              projectId = pFolder.project_id;
            }
            if (projectId !== null && projectId !== undefined) {
              if (node.droppable === false) {
                node.droppable = true;
              }
              return;
            }
          });
        }
        var path = [];
        var splitPath = node.id.split("/");
        splitPath.forEach(function (string) {
          if (string.length > 0) {
            path.push(string);
          }
        });
        node["file"] = {
          url: node.id,
          path: path,
          project_id: projectId,
          type: node.type,
          tag: node.li_attr["data-isfolder"] ? this.getFolderTag(node.id) : this.getFileTag(node.id)
        };
        this.selectedNode = node;
        tree.AssetTreeView("setSelectedNode", node);
      }
    },
    setSelectedNode: function setSelectedNode(pFile) {
      this.selectedNode = pFile;
    },
    getSelectedNode: function getSelectedNode() {
      if (this.selectedNode === undefined || this.selectedNode === null) {
        return null;
      } else {
        return this.selectedNode;
      }
    },
    _handleTreeviewContextmenu: function _handleTreeviewContextmenu(pEvent, pData) {
      if (pData.url === this.orphanFolderURL) {
        return false;
      }
      pEvent.stopPropagation();
      pEvent.preventDefault();
      this.setSelectedFile(pData.url);
      this._showDropdownList(pEvent);
      return false;
    },
    _showDropdownList: function _showDropdownList(pEvent) {
      var zIndex = undefined;
      if (typeof this.zIndex === "number") {
        zIndex = this.zIndex;
      } else {
        var currentZIndex = getComputedStyle(this.element[0]).zIndex;
        if (!isNaN(parseInt(currentZIndex))) {
          this.zIndex = parseInt(currentZIndex);
          zIndex = this.zIndex;
        } else {
          var parents = this.element.parents(".ui-front");
          if (parents.length > 0) {
            currentZIndex = getComputedStyle(parents[0]).zIndex;
            if (!isNaN(parseInt(currentZIndex))) {
              this.zIndex = parseInt(currentZIndex);
              zIndex = this.zIndex;
            }
          }
        }
      }
      this._drawDropdownList(this.getSelectedNode());
      var dropdownList = $(document.body).children("#" + this.menuGuid);
      dropdownList.show().css({
        'position': 'absolute',
        'top': pEvent.pageY,
        'left': pEvent.pageX,
        'zIndex': typeof zIndex === "number" && zIndex > 0 ? zIndex + 1 : "auto"
      }).DropdownList('openListWithoutButton', pEvent, true);
    },
    _drawDropdownList: function _drawDropdownList(isFile) {
      var that = this;
      var dropdownList = $("body").children("#" + this.menuGuid);
      var itemsDef;
      if (Array.isArray(this.options.customContextItems)) {
        itemsDef = this.options.customContextItems;
      } else {
        itemsDef = this.projectFormFileTreeActions.getDefaultActions(isFile);
      }
      $.when(itemsDef).done(function (pDefaultActions) {
        if (that.alive === false) {
          return;
        }
        if (dropdownList.length > 0) {
          dropdownList.remove();
        }
        var menuItems = pDefaultActions;
        menuItems = menuItems.filter(function (pItem) {
          return pItem.show !== false || pItem.type === "separator";
        });
        if (menuItems.length === 0) {
          return;
        }
        dropdownList = $("<div>").attr("id", that.menuGuid).addClass("filetree-dropdownlist").appendTo(document.body).DropdownList().hide();
        $.each(menuItems, function (index, item) {
          var asset = that.getSelectedNode();
          if (item.type === "separator") {
            dropdownList.DropdownList("addSeparator");
            return;
          } else if (["rename", "remove", "upload"].includes(item.type) === true) {
            item.action = item.type;
            if (item.type === "upload") {
              item.action += "file";
            } else {
              if (asset.leaf === true) {
                item.action += "file";
              } else {
                item.action += "folder";
              }
            }
          }
          if (typeof item.icon === "string" && item.icon.length > 0) {
            item.icon = $("<span>").addClass(item.icon);
          }
          var isEnabled = true;
          var foundAsset;
          if (asset.leaf === true) {
            foundAsset = that.files.find(function (pFile) {
              if (pFile.cloudflow.file === asset.id) {
                return true;
              }
              return false;
            });
            if (foundAsset === undefined) {
              foundAsset = that.orphanFiles.find(function (pOrphan) {
                if (pOrphan.cloudflow.file === asset.id) {
                  return true;
                }
                return false;
              });
            }
            if (foundAsset.file_name !== undefined) {
              foundAsset.name = foundAsset.file_name;
            }
          } else {
            foundAsset = that.folders.find(function (pFolder) {
              if (pFolder.cloudflow.folder === asset.id) {
                return true;
              }
              return false;
            });
          }
          foundAsset.is_folder = asset.leaf === false;
          if (item.activation_type !== undefined) {
            if (item.activation_type === "isFile") {
              isEnabled = isFile.leaf === true;
            } else if (item.activation_type === "isFolder") {
              isEnabled = isFile.leaf === false;
            } else if (item.activation_type === "dynamic" && item.activation_query !== undefined) {
              var query = new QueryApplier(item.activation_query);
              isEnabled = query.validate(foundAsset);
            }
          }
          dropdownList.DropdownList("addListItem", item.css ? item.css : "", item.icon, item.label, isEnabled, function () {
            that._beforeEvent(item.action, item.type);
          }, undefined, item.type);
        });
      });
    },
    _beforeEvent: function _beforeEvent(eventName, eventType) {
      var that = this;
      var data = {};
      if (eventType === "custom") {
        var asset = this.getSelectedNode();
        var foundAsset = {};
        if (asset.leaf === true) {
          foundAsset = this.files.find(function (pFile) {
            if (pFile.cloudflow.file === asset.id) {
              return true;
            }
            return false;
          });
          if (foundAsset === undefined) {
            foundAsset = this.orphanFiles.find(function (pOrphan) {
              if (pOrphan.cloudflow.file === asset.id) {
                return true;
              }
              return false;
            });
          }
        } else {
          foundAsset = this.folders.find(function (pFolder) {
            if (pFolder.cloudflow.folder === asset.id) {
              return true;
            }
            return false;
          });
        }
        foundAsset.is_folder = !asset.leaf;
        this._trigger("action" + eventName, null, {
          asset: foundAsset
        });
      } else if (eventName === "uploadfile") {
        var form = document.createElement("form");
        this.uploadFileInput = document.createElement("input");
        this.uploadFileInput.setAttribute("name", "file");
        this.uploadFileInput.setAttribute("type", "file");
        this.uploadFileInput.setAttribute("multiple", "multiple");
        form.appendChild(this.uploadFileInput);
        this.uploadFileInput.onchange = function (event) {
          data.form = new FormData(form);
          that._triggerEvent(eventName, data, function () {});
        };
        this.uploadFileInput.click();
      } else {
        this._triggerEvent(eventName, data, function () {});
      }
    },
    _handleTreeviewClick: function _handleTreeviewClick(pEvent, pData) {
      this.setSelectedFile(pData.url);
      var asset;
      if (pData.is_folder === true) {
        asset = this.folders.find(function (pFolder) {
          if (pFolder.cloudflow.folder === pData.url) {
            return true;
          }
          return false;
        });
      } else {
        asset = this.files.find(function (pFile) {
          if (pFile.cloudflow.file === pData.url) {
            return true;
          }
          return false;
        });
      }
      if (asset === undefined) {
        asset = this.orphanFiles.find(function (pOrphan) {
          if (pOrphan.cloudflow.file === pData.url) {
            return true;
          }
          return false;
        });
      }
      if (asset === undefined) {
        this._trigger("select", pEvent, {
          urls: [],
          rowObjects: [],
          amountSelected: 0
        });
      } else {
        asset.is_folder = pData.is_folder;
        this._trigger("select", pEvent, {
          urls: [asset.cloudflow.file ? asset.cloudflow.file : asset.cloudflow.folder],
          rowObjects: [asset],
          amountSelected: 1
        });
      }
    },
    _handleFileDropUpload: function _handleFileDropUpload(pEvent, pData, pNode) {
      pEvent.stopPropagation();
      pEvent.preventDefault();
      var path = [];
      var splitPath = pNode.id.split("/");
      splitPath.forEach(function (string) {
        if (string.length > 0) {
          path.push(string);
        }
      });
      var tag = pNode.li_attr["data-isfolder"] ? this.getFolderTag(pNode.id) : this.getFileTag(pNode.id);
      var fileObject = {
        url: pNode.id,
        path: path,
        project_id: this._findProjectID(pNode.id),
        type: pNode.type,
        tag: tag
      };
      if (fileObject.project_id === undefined) {
        //not allowed to drop here
        return false;
      }
      pNode.file = fileObject;
      this.setSelectedFile(pNode.id);
      var formData = new FormData();
      for (var i = 0, len = pEvent.originalEvent.dataTransfer.files.length; i < len; i++) {
        var file = pEvent.originalEvent.dataTransfer.files[i];
        formData.append("file", file);
      }
      this._triggerEvent("uploadfile", {
        form: formData,
        mode: "NewFileWithFolder"
      }, function () {});
      return false;
    },
    _handleFileMove: function _handleFileMove(pEvent, pData) {
      pEvent.stopPropagation();
      pEvent.preventDefault();
      var node = pData.data.node;
      var path = [];
      var splitPath = node.id.split("/");
      splitPath.forEach(function (string) {
        if (string.length > 0) {
          path.push(string);
        }
      });
      var isFolder = node.li_attr["data-isfolder"] === true;
      var tag = isFolder ? this.getFolderTag(node.id) : this.getFileTag(node.id);
      var fileObject = {
        url: node.id,
        path: path,
        project_id: isFolder ? this._findProjectID(node.id) : this._findProjectID(splitPath.slice(0, -1).join("/") + "/"),
        type: node.type,
        tag: tag
      };
      node.file = fileObject;
      node.toUrl = pData.toUrl;
      node.isFolder = isFolder;
      this.setSelectedFile(node.id);
      var mode = "MoveFile";
      if (isFolder === true) {
        mode = "MoveFolder";
      }
      this._triggerEvent(mode.toLowerCase(), {
        toUrl: pData.toUrl,
        mode: mode
      }, function () {});
      return false;
    },
    _findProjectID: function _findProjectID(pFolderURL) {
      for (var i = 0; i < this.folders.length; i++) {
        if (pFolderURL === this.folders[i].cloudflow.folder) {
          return this.folders[i].project_id;
        }
      }
      console.error("could not find projectID for " + pFolderURL + " - falling back on parent project");
      return this.options.project.project_id;
    },
    _handleTreeViewLoaded: function _handleTreeViewLoaded(pEvent, pData) {
      var tree = this.element.find(".nixps-cloudflow-AssetTreeView");
      tree.AssetTreeView("collapseAll");
      //close the orphan folder again
      // this.element.find(".nixps-cloudflow-AssetTreeView").AssetTreeView("getNode", this.orphanFolderURL);
      if (this.calledCreated === false) {
        this.calledCreated = true;
        this.options.created();
      }
    },
    _handleTreeViewError: function _handleTreeViewError(pEvent, pData) {
      if (this.calledCreated === false) {
        this.calledCreated = true;
        this.options.created();
      }
    },
    _isNodeDraggable: function _isNodeDraggable(pEvent, pData) {
      if (pData.id === this.orphanFolderURL) {
        return false;
      }
      var foundOrphanFile = this.orphanFiles.find(function (pNode) {
        if (pNode.file_name === pData.id) {
          return pNode;
        }
      });
      if (foundOrphanFile !== undefined) {
        return false;
      }
      return true;
    },
    _isNodeDroppable: function _isNodeDroppable(pEvent, pData) {
      var registeredFolders = Job.getAllFilesAndFolders(this.options.project).folders;
      var registeredFoldersURLs = [];
      if (Array.isArray(registeredFolders)) {
        registeredFoldersURLs = registeredFolders.map(function (pFolder) {
          return pFolder.url;
        });
      }
      if (registeredFoldersURLs.includes(pData.node_parent.id) === false || pData.node_parent.id === this.orphanFolderURL || pData.node_parent.id === "#") {
        return false;
      }
      return true;
    },
    _triggerEvent: function _triggerEvent(eventName, data, callback) {
      var that = this;
      var selectedNode = this.getSelectedNode();
      api_async.file.does_exist(File.getFile(selectedNode.file), function (pResult) {
        if (pResult.exists === true) {
          var actionResult = that.projectFormFileTreeActions.executeAction(eventName, selectedNode, data);
          if (actionResult === false) {
            that.element.trigger(eventName, selectedNode.file);
          } else if (_typeof(actionResult) === "object" && actionResult.event !== undefined) {
            that.element.trigger(actionResult.event, actionResult.data);
          }
        } else {
          that.element.trigger("log", ["error", $.i18n._("nixps-cloudflow-ProjectFormProperties.does-not-exist")]);
          LogListener.addLog({
            event_type: "error",
            details_data: {
              error_code: "asset_not_found",
              error: "file or folder not found"
            },
            component_name: this.widgetFullName
          }, this.element);
          console.error("ProjectFormAssets: file or folder not found");
        }
        if (callback !== undefined) {
          callback();
        }
      }, function (pError) {
        if (pError.error) {
          that.element.trigger("log", ["error", pError.error]);
        }
        LogListener.addLog({
          event_type: "error",
          details_data: pError,
          component_name: this.widgetFullName
        }, this.element);
        console.error(pError);
        if (callback !== undefined) {
          callback();
        }
      });
    },
    getState: function getState() {
      return this.element.find(".nixps-cloudflow-AssetTreeView").AssetTreeView("getState");
    },
    setState: function setState(pState) {
      return this.element.find(".nixps-cloudflow-AssetTreeView").AssetTreeView("setState", pState);
    },
    drawSelectedNode: function drawSelectedNode(pNode) {
      this.element.find(".nixps-cloudflow-AssetTreeView").AssetTreeView("setSelectedNode", pNode);
    },
    redraw: function redraw() {
      this._draw();
    },
    refresh: function refresh() {
      this._draw();
    },
    update: function update(pJob) {
      this.options.rootFolder = {};
      if (_typeof(pJob) === "object" && Array.isArray(pJob) === false || typeof pJob === "string" && pJob.length > 0) {
        this.options.project = pJob;
      }
      var drawnDefer = this._draw();
      return drawnDefer;
    },
    _setOptions: function _setOptions(options) {
      var redrawNeeded = false;
      if (options.rootTag !== undefined && options.rootTag !== this.options.rootTag) {
        this.options.rootFolder = {};
        redrawNeeded = true;
      }
      if (options.enableUpload !== undefined && options.enableUpload !== this.options.enableUpload) {
        this.options.enableUpload = options.enableUpload;
        if (this.element.find(".projectformassets-files").length === 0) {
          redrawNeeded = true;
        } else {
          this.element.find(".projectformassets-files").AssetTreeView({
            enableDropZone: options.enableUpload
          });
        }
      }
      if (options.project !== undefined && options.project !== this.options.project) {
        this.options.project = options.project;
        redrawNeeded = true;
      }
      this._superApply(arguments);
      this._controlOptions();
      if (redrawNeeded === true) {
        this._draw();
      }
    },
    _controlOptions: function _controlOptions() {
      var _this = this;
      // language should be a non-empty string
      if (typeof this.options.language !== "string") {
        throw new Error("ProjectFormAssets: option language must be a string");
      }

      // project must be a string (ID) or a plain object
      if (typeof this.options.project !== "string" && (this.options.project === null || _typeof(this.options.project) !== "object" || Array.isArray(this.options.project))) {
        throw new Error("ProjectFormAssets: option project must be a non-empty object or a job ID");
      }

      // rootFolder must be an object
      if (_typeof(this.options.rootFolder) !== "object" || this.options.rootFolder === null || Array.isArray(this.options.rootFolder)) {
        throw new Error("ProjectFormAssets: option rootFolder must be an object");
      }

      // projectFormFileTreeActions must be an object if defined
      if (this.options.projectFormFileTreeActions !== undefined && (_typeof(this.options.projectFormFileTreeActions) !== "object" || this.options.projectFormFileTreeActions === null || Array.isArray(this.options.projectFormFileTreeActions))) {
        throw new Error("ProjectFormAssets: option projectFormFileTreeActions must be an object if defined");
      }

      // whitepaper, whitepaperInput, uploadWhitepaper, uploadWhitepaperInput must be strings if defined
      ["whitepaper", "whitepaperInput", "uploadWhitepaper", "uploadWhitepaperInput"].forEach(function (key) {
        if (_this.options[key] !== undefined && typeof _this.options[key] !== "string") {
          throw new Error("ProjectFormAssets: option ".concat(key, " must be a string if defined"));
        }
      });

      // rootTag must be a string
      if (typeof this.options.rootTag !== "string") {
        throw new Error("ProjectFormAssets: option rootTag must be a string");
      }

      // enableUpload must be a boolean
      if (typeof this.options.enableUpload !== "boolean") {
        throw new Error("ProjectFormAssets: option enableUpload must be a boolean");
      }

      // customContextItems must be an array if defined
      if (this.options.customContextItems !== undefined && !Array.isArray(this.options.customContextItems)) {
        throw new Error("ProjectFormAssets: option customContextItems must be an array if defined");
      }

      // created must be a function
      if (typeof this.options.created !== "function") {
        throw new Error("ProjectFormAssets: option created must be a function");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      $("body").find("#" + this.menuGuid).remove();
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../../../cloudflow/AssetTreeView/js/nixps-cloudflow-AssetTreeView.js":52,"../../../../../cloudflow/CloudflowUtil/js/GUID.js":89,"../../../../../cloudflow/CloudflowUtil/js/QueryApplier.js":91,"../../../../../common/DropdownList/js/nixps-DropdownList.js":288,"../../../../../pagebuilder/js/inspect/LogListener.js":431,"../../../Model/Asset/js/nixps-File.js":39,"../../../Model/Job/js/nixps-Job.js":40,"./nixps-cloudflow-ProjectFormFileTreeActions.js":16}],16:[function(require,module,exports){
"use strict";

var FileTreeActions = require("../../File/js/nixps-file-FileTreeActions.js");
var IO = require("../../../General/IO/js/nixps-IO.js");
var Job = require("../../../Model/Job/js/nixps-Job.js");
var WhitepaperService = require("../../../Model/Whitepaper/js/nixps-WhitepaperService.js");

// require("./nixps-cloudflow-ProjectFormRenameDialogBox.js");

var uploadID = 0;
var clipboard = [];
var frameSession;
var kViewableFileRegExp = new RegExp(".*(\.pdf|\.ai|\.art|\.tif|\.tiff|\.ic3|\.ic3d|\.len|\.cf2|\.png|\.jpg|\.jpeg)$", "i");
function getFileTag(pFile) {
  if (typeof pFile.tag === "string") {
    return pFile.tag;
  } else {
    return "";
  }
}
function ProjectFormFileTreeActions(pWhitepaper, pWhitepaperInput, pProject, pUploadWhitepaper, pUploadWhitepaperInput) {
  this.fileTreeActions();
  this.whitepaperService = new WhitepaperService(pWhitepaper, pWhitepaperInput, 1);
  if (pUploadWhitepaper !== undefined && pUploadWhitepaperInput !== undefined) {
    this.whitepaperUploadService = new WhitepaperService(pUploadWhitepaper, pUploadWhitepaperInput, 1);
  }
  this.project;
  /*
  this.whitepaperService = {
      _callbacksOnce: {},
      _callbacksSubscribe: {},
      _callingIndex: 0,
      once: function(pType, pCBFunction){
          this._callbacksOnce[pType].push(pCBFunction);
          return () => {
              if (Array.isArray(this._callbacksOnce[pType])) {
                  for(var i=0; i<this._callbacksOnce[pType].length; i++) {
                      if (this._callbacksOnce[pType][i] === pCBFunction) {
                          this._callbacksOnce[pType].splice(i, 1);
                          break;
                      }
                  }
              }
          }
      },
      subscribe: function(pType, pCBFunction){
          this._callbacksSubscribe[pType].push(pCBFunction);
      },
      processWithFilesAndVariables: function(pFiles, pVariables){
          var that = this;
          this._callingIndex++;
          var connection = new WhitepaperConnection(pWhitepaper, pWhitepaperInput, pVariables, undefined, true, pFiles);
          connection.setStartPollingTime(3);
          connection.setPollingTime(3);
          return connection.start().then(function(pResult){
              if (Array.isArray(that._callbacksOnce["finished"]) && that._callbacksOnce["finished"].length > 0) {
                  var cbSuccess = that._callbacksOnce["finished"].pop();
                  cbSuccess(pResult);
                  that._callingIndex--;
              }
          }, function(pError){
              if (Array.isArray(that._callbacksOnce["error"]) && that._callbacksOnce["error"].length > 0) {
                  var cbError = that._callbacksOnce["error"].pop();
                  cbError(pError);
                  that._callingIndex--;
              }
          })
      },
      uploadFile: function(pForm, pHeaders) {}
  }*/
}

ProjectFormFileTreeActions.prototype = Object.assign({}, FileTreeActions.prototype, {
  constructor: ProjectFormFileTreeActions,
  fileTreeActions: FileTreeActions,
  // Todo: filter out registered folders from renaming
  getDefaultActions: function getDefaultActions(node) {
    var isFile = node ? node.leaf === true : false;
    var isCombined = isFile && Array.isArray(node.file.url);
    var canRemoveFolder = node ? Job.getAllFilesAndFolders(this.project).files.some(function (pFolder) {
      return pFolder.url.indexOf(node.file.url) === 0;
    }) === false : false;
    var actions = [];
    if (isFile === true && !isCombined) {
      actions.push({
        action: "copytoclipboard",
        css: clipboard.length > 0 ? "" : "spacer",
        icon: $('<i class="fa fa-copy"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.copy-to-clipboard")
      });
      if (clipboard.length > 0) {
        actions.push({
          action: "comparewithclipboard",
          css: "spacer",
          icon: $('<div>').load('/portal/icons/non-active/main-icon-proofscope1.svg'),
          label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.compare-with-clipboard")
        });
      }
    }
    if (isFile === false) {
      if (node.droppable) {
        actions.push({
          action: "uploadfile",
          css: "spacer",
          icon: $('<i class="cf-icon cf-icon-upload"></i>'),
          label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.upload-file")
        });
      }
      actions.push({
        action: "openinfinder",
        css: "frame-os-feature-block",
        icon: $('<i class="fa fa-folder-open"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.open-folder")
      });
      actions.push({
        action: "renamefolder",
        css: canRemoveFolder === true ? "" : "spacer",
        icon: $('<i class="cf-icon cf-icon-pencil"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.rename-folder")
      });
      if (canRemoveFolder === true) {
        actions.push({
          action: "removefolder",
          css: "spacer",
          icon: $('<i class="cf-icon cf-icon-trash"></i>'),
          label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.remove-folder")
        });
      }
    }
    if (isFile === true && !isCombined) {
      actions.push({
        action: "downloadfile",
        css: "",
        icon: $('<i class="cf-icon cf-icon-download"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.download-file")
      });
      actions.push({
        action: "openinfinder",
        css: "frame-os-feature-block",
        icon: $('<i class="fa fa-folder-open"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.reveal-file")
      });
      actions.push({
        action: "renamefile",
        css: "",
        icon: $('<i class="cf-icon cf-icon-pencil"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.rename-file")
      });
      actions.push({
        action: "removefile",
        css: "spacer",
        icon: $('<i class="cf-icon cf-icon-trash"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.remove-file")
      });
    }
    if (isFile === false || isCombined === false) {
      actions.push({
        action: "openinportal",
        css: isFile === true ? "" : "spacer",
        icon: $('<i class="cf-icon cf-icon-assets"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.open-in-portal")
      });
    }
    if (isFile === true && isCombined === false) {
      actions.push({
        action: "openinapplication",
        css: "frame-os-feature-block",
        icon: $('<i class="fa fa-external-link-square"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.open-in-application")
      });
    }
    if (isFile === true && kViewableFileRegExp.test(node.id) === true) {
      actions.push({
        action: "viewinproofscope",
        css: "spacer",
        icon: $('<i class="cf-icon cf-icon-proofscope"></i>'),
        label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.view-in-proofscope")
      });
    }
    actions.push({
      action: "submittoworkflow",
      css: "",
      icon: $('<i class="cf-icon cf-icon-flows"></i>'),
      label: $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.submit-to-workflow")
    });
    return actions;
  },
  /**
   * @brief executeAction will be triggered when the menu item is selected with the necessary data of the file
   * this method should return true if the action was handled within this class or false if the FileTree should trigger an event and let it be handled by something else 
   */
  executeAction: function executeAction(name, node, data) {
    switch (name) {
      case "viewinproofscope":
        this._viewInProofscope(node.file.url, data);
        return true;
      case "openinfinder":
        api_defer.frame.os.get().then(function () {
          if (node.leaf === true) {
            api_async.frame.os.open_folder_in_os(IO.getDir(node.file.url));
          } else {
            api_async.frame.os.open_folder_in_os(node.file.url);
          }
        });
        return true;
      case "openinapplication":
        api_defer.frame.os.get().then(function () {
          return api_defer.frame.os.open_file_in_application(node.file.url, "PACKZ");
        });
        return true;
      case "openinportal":
        this._openInPortal(node.file.url, data);
        return true;
      case "uploadfile":
        this._uploadFile(node.file, data);
        return true;
      case "movefolder":
        this._moveFolder(node.file, data);
        return true;
      case "movefile":
        this._moveFile(node.file, data);
        return true;
      case "renamefolder":
        this._renameFolder(node.file, data);
        return true;
      case "renamefile":
        this._renameFile(node.file, data);
        return true;
      case "removefile":
        this._removeFile(node.file, data);
        return true;
      case "downloadfile":
        this._downloadFile(node.file, data);
        return true;
      case "removefolder":
        this._removeFolder(node.file, data);
        return true;
      case "copytoclipboard":
        clipboard = [node.file.url];
        break;
      case "comparewithclipboard":
        var prevFile = clipboard.shift();
        return {
          event: "compare",
          data: {
            files: [prevFile, node.file.url]
          }
        };
    }
    return false;
  },
  getClipboard: function getClipboard() {
    return clipboard;
  },
  setProject: function setProject(pProject) {
    this.project = pProject;
  },
  _viewInProofscope: function _viewInProofscope(url) {
    var base_url;
    var viewer_parameters;
    var viewer;
    var total = 0;
    function resolve(pCB) {
      total++;
      return function () {
        total--;
        if (pCB !== undefined) {
          pCB.apply(null, arguments);
        }
        if (total === 0) {
          api_async.proofscope.create_view_file_url_with_options("", base_url, {
            viewer: viewer,
            viewer_parameters: viewer_parameters
          }, function (pUrl) {
            window.open(pUrl.url);
          }, function (pError) {
            console.log(pError);
          });
        }
      };
    }
    if (Array.isArray(url)) {
      base_url = url[0];
      viewer_parameters = {
        'items': []
      };
      viewer = "Stack";
      for (var i = 0, len = url.length; i < len; i++) {
        api_async.asset.list(['cloudflow.part', 'equal to', url[i]], ['_id', 'metadata'], resolve(function (pResult) {
          if (pResult.results.length > 0) {
            var channels = [];
            for (var j = 0, jlen = pResult.results[0].metadata.output_color_space.colorants.length; j < jlen; j++) {
              channels.push(pResult.results[0].metadata.output_color_space.colorants[j].name);
            }
            viewer_parameters.items.push({
              assetID: pResult.results[0]._id,
              channels: channels
            });
          }
        }));
      }
    } else {
      base_url = url;
      viewer_parameters = {};
      viewer = "MultiPage";
      resolve()();
    }
  },
  _openInPortal: function _openInPortal(url) {
    window.open("/?asset=" + encodeURIComponent(url));
  },
  _loginToFrame: function _loginToFrame(callback) {
    if (frameSession === undefined) {
      api_async.frame.os.create_cloudflow_session("", function (pResult) {
        frameSession = pResult.session;
        callback();
      }, function (pError) {
        console.log(pError);
      });
    } else {
      callback();
    }
  },
  _renameFile: function _renameFile(file, data) {
    var that = this;
    $("body").not(".nixps-Dialog").Dialog();
    $("body").Dialog("prompt", $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.rename-file"), $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.rename-file-inputlabel"), decodeURIComponent(IO.getFileName(file.url, true)), true, undefined, undefined, [{
      "classes": "cf-button cf-button-secondary",
      "type": "cancel",
      "label": "nixps-cloudflow-dialog.cancel"
    }, {
      "classes": "cf-button cf-button-main",
      "type": "ok",
      "label": "nixps-cloudflow-ProjectFormFileTreeActions.rename"
    }]).then(function (pData) {
      if (pData.type === "ok") {
        var offFinished;
        var offError = that.whitepaperService.once("error", function (pEvent, pError) {
          offFinished();
          pError["url"] = file.url;
          that.trigger("error", pError);
        });
        offFinished = that.whitepaperService.once("finished", function (pResult, pFlowData) {
          offError();
          that.getFileTree().setSelectedFile(IO.changeFileName(file.url, pData.newValue, true));
          var data = Object.assign(pResult, pFlowData);
          that.trigger("renamedfile", data);
        });
        that.whitepaperService.processWithFilesAndVariables([file.url], {
          "mode": "RenameFile",
          "tag": getFileTag(file),
          "quantum_project_project_id": file.project_id,
          "file_name": pData.newValue,
          "parent_url": ""
        });
      }
    });
    return;
  },
  _renameFolder: function _renameFolder(file, data) {
    var that = this;
    $("body").not(".nixps-Dialog").Dialog();
    $("body").Dialog("prompt", $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.rename-folder"), $.i18n._("nixps-cloudflow-ProjectFormFileTreeActions.rename-folder-inputlabel"), decodeURIComponent(file.path[file.path.length - 1]), true, undefined, undefined, [{
      "classes": "cf-button cf-button-secondary",
      "type": "cancel",
      "label": "nixps-cloudflow-dialog.cancel"
    }, {
      "classes": "cf-button cf-button-main",
      "type": "ok",
      "label": "nixps-cloudflow-ProjectFormFileTreeActions.rename"
    }]).then(function (pData) {
      if (pData.type === "ok") {
        var offFinished;
        var offError = that.whitepaperService.once("error", function (pEvent, pError) {
          offFinished();
          pError["url"] = file.url;
          that.trigger("error", pError);
        });
        offFinished = that.whitepaperService.once("finished", function (pResult, pFlowData) {
          offError();
          that.getFileTree().setSelectedFile(IO.joinDirectories(file.path.slice(0, file.path.length - 1).concat(pData.newValue)));
          var data = Object.assign(pResult, pFlowData);
          that.trigger("renamedfolder", data);
        });
        that.whitepaperService.processWithFilesAndVariables([file.url], {
          "mode": "RenameFolder",
          "tag": getFileTag(file),
          "quantum_project_project_id": file.project_id,
          "file_name": pData.newValue,
          "parent_url": ""
        });
      }
    });
    return;
  },
  _removeFile: function _removeFile(file, data) {
    var that = this;
    $("body").not(".nixps-Dialog").Dialog();
    $("body").Dialog("show_delete_no", $.i18n._('nixps-cloudflow-ProjectFormFileTreeActions.remove-file'), $.i18n._('nixps-cloudflow-ProjectFormFileTreeActions.remove-file-msg'), function () {
      var offFinished;
      var offError = that.whitepaperService.once("error", function (pEvent, pError) {
        offFinished();
        pError["url"] = file.url;
        that.trigger("error", pError);
      });
      offFinished = that.whitepaperService.once("finished", function (pEvent, pData) {
        offError();
        that.getFileTree().setSelectedFile(null);
        var data = Object.assign(pEvent, pData);
        that.trigger("removedfile", data);
      });
      that.whitepaperService.processWithFilesAndVariables([file.url], {
        "mode": "RemoveFile",
        "tag": getFileTag(file),
        "quantum_project_project_id": file.project_id,
        "file_name": "",
        "parent_url": ""
      });
    });
  },
  _removeFolder: function _removeFolder(file, data) {
    var that = this;
    $("body").not(".nixps-Dialog").Dialog();
    $("body").Dialog("show_delete_no", $.i18n._('nixps-cloudflow-ProjectFormFileTreeActions.remove-folder'), $.i18n._('nixps-cloudflow-ProjectFormFileTreeActions.remove-folder-msg'), function () {
      var offFinished;
      var offError = that.whitepaperService.once("error", function (pEvent, pError) {
        offFinished();
        pError["url"] = file.url;
        that.trigger("error", pError);
      });
      offFinished = that.whitepaperService.once("finished", function (pEvent, pData) {
        offError();
        that.getFileTree().setSelectedFile(null);
        var data = Object.assign(pEvent, pData);
        that.trigger("removedfolder", data);
      });
      that.whitepaperService.processWithFilesAndVariables([file.url], {
        "mode": "RemoveFolder",
        "tag": getFileTag(file),
        "quantum_project_project_id": file.project_id,
        "file_name": "",
        "parent_url": ""
      });
    });
  },
  // file is not the file being uploaded, but the folder in which the files are targeted to
  _uploadFile: function _uploadFile(file, data) {
    var that = this;
    var whitepaperService = this.whitepaperService;
    if (this.whitepaperUploadService !== undefined) {
      whitepaperService = this.whitepaperUploadService;
    }
    var unsub = [whitepaperService.subscribe("error", function (pError) {
      unsub.forEach(function (pItem) {
        pItem();
      });
      pError["url"] = file.url;
      that.trigger("error", pError);
    }), whitepaperService.subscribe("uploadstart", function (pData) {
      pData["url"] = file.url;
      that.trigger("uploadstart", pData);
    }), whitepaperService.subscribe("uploadprogress", function (pData) {
      pData["url"] = file.url;
      //normalize files to be like vanilla progress interface
      pData.files = pData.files.map(function (pFileName) {
        return {
          name: pFileName
        };
      });
      that.trigger("uploadprogress", pData);
    }), whitepaperService.subscribe("uploaddone", function (pData) {
      unsub.forEach(function (pItem) {
        pItem();
      });
      pData["url"] = file.url;
      pData["result"] = {
        files: [file.url]
      };
      that.trigger("uploaddone", pData);
      var offFinished;
      var offError = whitepaperService.once("error", function (pEvent, pError) {
        offFinished();
        pError["url"] = file.url;
        that.trigger("error", pError);
      });
      offFinished = whitepaperService.once("finished", function (pResult, pData) {
        offError();
        var data = Object.assign(pResult, pData);
        that.trigger("addedfile", data);
      });
      whitepaperService.processWithFilesAndVariables(pData.files, {
        "mode": "NewFileInFolder",
        "parent_url": file.url,
        "tag": getFileTag(file),
        "quantum_project_project_id": file.project_id,
        "file_name": ""
      });
    })];
    whitepaperService.uploadFile(data.form, data.headers);
  },
  _moveFile: function _moveFile(file, pData) {
    var that = this;
    var offFinished;
    var offError = this.whitepaperService.once("error", function (pEvent, pError) {
      offFinished();
      pError["url"] = file.url;
      that.trigger("error", pError);
    });
    offFinished = this.whitepaperService.once("finished", function (pResult, pData) {
      offError();
      that.getFileTree().setSelectedFile(file.url);
      var data = Object.assign(pResult, pData);
      that.trigger("movedfile", data);
    });
    that.whitepaperService.processWithFilesAndVariables([file.url], {
      "mode": "MoveFile",
      "tag": getFileTag(file),
      "quantum_project_project_id": file.project_id,
      "file_name": file.path[file.path.length - 1],
      "parent_url": pData.toUrl
    });
  },
  _moveFolder: function _moveFolder(file, pData) {
    var that = this;
    var offFinished;
    var offError = this.whitepaperService.once("error", function (pEvent, pError) {
      offFinished();
      pError["url"] = file.url;
      that.trigger("error", pError);
    });
    offFinished = this.whitepaperService.once("finished", function (pResult, pData) {
      offError();
      that.getFileTree().setSelectedFile(file.url);
      var data = Object.assign(pResult, pData);
      that.trigger("movedfolder", data);
    });
    that.whitepaperService.processWithFilesAndVariables([file.url], {
      "mode": "MoveFolder",
      "tag": getFileTag(file),
      "quantum_project_project_id": file.project_id,
      "file_name": file.path[file.path.length - 1],
      "parent_url": pData.toUrl
    });
  },
  _downloadFile: function _downloadFile(file, data) {
    window.location.href = window.location.origin + "/portal.cgi?asset=download_file&url=" + encodeURIComponent(file.url);
  }
});
module.exports = ProjectFormFileTreeActions;

},{"../../../General/IO/js/nixps-IO.js":26,"../../../Model/Job/js/nixps-Job.js":40,"../../../Model/Whitepaper/js/nixps-WhitepaperService.js":44,"../../File/js/nixps-file-FileTreeActions.js":12}],17:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/** @module nixps/widget */

/**
 * @namespace {module:nixps/widget} NiXPSWidget
 * @description The component to rule all components.
 * @example
 * $.widget("wigdet-name-that-extends-NiXPSWidget", $["nixps-widget"]["NiXPSWidget"], { ... });
 */
$.widget("nixps-widget.NiXPSWidget", $.Widget, {
  options: {
    /**
     * Whether to perform a shallow compare on the options for a redraw
     * @name module:nixps/widget~NiXPSWidget#shallowCompare
     * @type {boolean}
     * @default false
     */
    shallowCompare: false,
    /**
     * An array of objects to compare objects for redraws.
     * @name module:nixps/widget~NiXPSWidget#compare
     * @type {Array<module:nixps/widget~NiXPSWidget~Compare>}
     * @default null
     */
    /**
     * @typedef module:nixps/widget~NiXPSWidget~Compare
     * @property {string} option - the option on which it has effect
     * @property {string[]} identifiers - an array of properties that make the object unique
     * @property {module:nixps/widget~NiXPSWidget~CompareCallback} callback - if the identifiers property isn't enough you can use this which will receive the previous object and the current, and which must return a boolean: "true" if the objects are the same and "false" if not
     */
    /**
     * @callback module:nixps/widget~NiXPSWidget~CompareCallback
     * @param {object} prevObject
     * @param {object} currentObject
     * @return {boolean}
     */
    compare: null
  },
  _create: function _create() {
    if (typeof this.getState !== "function") {
      throw new Error("Extension of NiXPSWidget should have a 'getState' function!");
    }
    if (typeof this.setState !== "function") {
      throw new Error("Extension of NiXPSWidget should have a 'setState' function!");
    }
    this.ineffectiveOptions = [];
    this.previousOptions = {};
    this.optionListeners = [];
    this.componentsRendering = 0;
    this.disabled = false;
    this.optionsToRedraw = false;
    var that = this;
    this.element.on("rendered", function (pEvent) {
      if (pEvent.currentTarget !== that.element[0] || --that.componentsRendering !== 0) {
        pEvent.stopPropagation();
        pEvent.stopImmediatePropagation();
      }
    });
  },
  _ineffectiveOptions: function _ineffectiveOptions(pKeys) {
    this.ineffectiveOptions = pKeys;
  },
  _drawComponentList: function _drawComponentList(pPreviousOptions, pNewOptions, pParent, pItems, pClasses, pComponent) {
    this._drawList(pPreviousOptions, pNewOptions, pParent, pItems, "div", pClasses, function (pItem, pOption, pIndex) {
      $(pItem)[pComponent](pOption);
    });
  },
  _drawList: function _drawList(pPreviousObjects, pNewObjects, pParent, pElements, pTag, pClasses, pRenderFunction, pCompareFunction, pFalseFunction) {
    if (pPreviousObjects === undefined) {
      pPreviousObjects = [];
    }
    var that = this;
    var renderLogic = [];
    if (Array.isArray(pParent) === true) {
      for (var i = 2, len = arguments.length; i < len; i++) {
        if (Array.isArray(arguments[i])) {
          if (arguments[i].length === 5) {
            arguments[i].push(function (pObjA, pObjB) {
              return that._compare(undefined, pObjA, pObjB);
            });
          }
          renderLogic.push(arguments[i]);
        } else {
          throw new Error("NiXPSWidget: the method _drawList has an invalid argument!");
        }
      }
    } else {
      if (pCompareFunction === undefined) {
        pCompareFunction = function pCompareFunction(pObjA, pObjB) {
          return that._compare(undefined, pObjA, pObjB);
        };
      }
      renderLogic.push([pParent, pElements, pTag, pClasses, pRenderFunction, pCompareFunction, pFalseFunction]);
    }
    var i = 0;
    for (var len = pNewObjects.length; i < len; i++) {
      for (var j = 0, jLen = renderLogic.length; j < jLen; j++) {
        var render = true;
        if (pPreviousObjects.length > i && renderLogic[j][5](pPreviousObjects[i], pNewObjects[i], i)) {
          render = false;
        }
        var element = renderLogic[j][1][i];
        if (render) {
          if (element == null || element.length === 0) {
            if (renderLogic[j][0] instanceof $) {
              element = $("<" + renderLogic[j][2] + ">").addClass(renderLogic[j][3]).appendTo(renderLogic[j][0]);
            } else {
              element = document.createElement(renderLogic[j][2]);
              element.className = renderLogic[j][3];
              renderLogic[j][0].appendChild(element);
            }
          }
          renderLogic[j][4].call(this, element, pNewObjects[i], i);
        } else if (render === false && renderLogic[j][6] !== undefined && typeof renderLogic[j][6] === "function") {
          renderLogic[j][6].call(this, element);
        }
      }
    }
    for (var j = 0, jLen = renderLogic.length; j < jLen; j++) {
      for (var k = renderLogic[j][1].length - 1; k >= i; k--) {
        renderLogic[j][1][k].parentElement.removeChild(renderLogic[j][1][k]);
      }
    }
  },
  _shallowCompare: function _shallowCompare(objA, objB) {
    if (Object.is(objA, objB)) {
      return true;
    }
    if (_typeof(objA) === "object" && _typeof(objB) === "object") {
      var keysA = Object.keys(objA);
      var keysB = Object.keys(objB);
      if (keysA.length !== keysB.length) {
        return false;
      }
      for (var i = 0, len = keysA.length; i < len; i++) {
        if (objA.hasOwnProperty(keysA[i]) === true && objB.hasOwnProperty(keysA[i])) {
          if (Object.is(objA[keysA[i]], objB[keysB[i]]) === false) {
            return false;
          }
        }
      }
      return true;
    } else {
      return false;
    }
  },
  _compare: function _compare(key, objA, objB) {
    if (_typeof(objA) === "object" && objA !== null && typeof objA.compare === "function") {
      return objA.compare(objA, objB);
    } else if (this.options.compare != null && this.options.compare.option === key) {
      var that = this;
      var compare = function compare(pObjA, pObjB) {
        if (that.options.compare.callback != null) {
          return that.options.compare.callback(pObjA, pObjB);
        } else {
          for (var i = 0, len = that.options.compare.identifiers.length; i < len; i++) {
            if (!that._shallowCompare(pObjA[that.options.compare.identifiers[i]], pObjB[that.options.compare.identifiers[i]])) {
              return false;
            }
          }
          return true;
        }
      };
      if (objA === undefined && objB === undefined) {
        return true;
      }
      if (objA === undefined || objB === undefined) {
        return false;
      }
      if (Array.isArray(objA) && Array.isArray(objB)) {
        if (objA.length !== objB.length) {
          return false;
        }
        for (var i = 0, len = objA.length; i < len; i++) {
          if (!compare(objA[i], objB[i])) {
            return false;
          }
        }
        return true;
      } else {
        return compare(objA, objB);
      }
    } else if (this.options.shallowCompare === true) {
      return this._shallowCompare(objA, objB);
    } else {
      return Object.is(objA, objB);
    }
  },
  _setPreviousOption: function _setPreviousOption(key) {
    if (this.previousOptions === undefined) {
      this.previousOptions = {};
    }
    if (this.options[key] == null) {
      this.previousOptions[key] = this.options[key];
    } else if (Array.isArray(this.options[key]) === true) {
      this.previousOptions[key] = $.extend(this.options.shallowCompare === false, [], this.options[key]);
    } else if (_typeof(this.options[key]) === "object") {
      this.previousOptions[key] = $.extend(this.options.shallowCompare === false, {}, this.options[key]);
    } else {
      this.previousOptions[key] = this.options[key];
    }
  },
  _redraw: function _redraw(options) {
    if (this.disabled === false) {
      var calledListeners = [];
      for (var i = 0, len = this.optionListeners.length; i < len; i++) {
        if (calledListeners.some(function (pListener) {
          this.optionListeners[i][0] === pListener;
        }) === false && this.optionListeners[i][1].some(function (pListenerOption) {
          return options.some(function (pOption) {
            return pOption.toLowerCase() === pListenerOption;
          });
        })) {
          this.componentsRendering++;
          this.optionListeners[i][0].call(this);
        }
      }
    } else {
      if (this.optionsToRedraw === false) {
        this.optionsToRedraw = options;
      } else {
        for (var i = 0, len = options.length; i < len; i++) {
          if (this.optionsToRedraw.some(function (pOption) {
            return pOption === options[i];
          }) === false) {
            this.optionsToRedraw.push(options[i]);
          }
        }
      }
    }
  },
  disableComponent: function disableComponent() {
    this.disabled = true;
  },
  enableComponent: function enableComponent() {
    this.disabled = false;
    if (this.optionsToRedraw !== false) {
      var optionsToRedraw = this.optionsToRedraw;
      this.optionsToRedraw = false;
      this._redraw(optionsToRedraw);
    }
  },
  _onOptionChange: function _onOptionChange(pOptions, pCallback) {
    if (Array.isArray(pOptions) === false) {
      pOptions = [pOptions];
    }
    var found = false;
    var that = this;
    for (var i = 0, len = this.optionListeners.length; i < len; i++) {
      if (this.optionListeners[i][0] === pCallback) {
        for (var j = 0, jLen = pOptions.length; j < jLen; j++) {
          if (this.optionListeners[i][1].indexOf(pOptions[j].toLowerCase()) === -1) {
            this.optionListeners[i][1].push(pOptions[j].toLowerCase());
          }
        }
      }
    }
    if (found === false) {
      this.optionListeners.push([pCallback, pOptions.map(function (pOption) {
        return pOption.toLowerCase();
      })]);
    }
  },
  _setOption: function _setOption(key, value) {
    if (key === "shallowCompare" || key === "compare" || this.ineffectiveOptions !== undefined && this.ineffectiveOptions.indexOf(key) !== -1) {
      this._setPreviousOption(key);
      this._super(key, value);
      return false;
    }
    var redraw = this._compare(key, this.options[key], value) === false;
    if (redraw) {
      this._setPreviousOption(key);
      this._super(key, value);
    }
    return redraw;
  },
  _setOptions: function _setOptions(options) {
    var that = this;
    var optionsToRedraw = [];
    $.each(options, function (key, value) {
      if (that._setOption(key, value) === true) {
        optionsToRedraw.push(key);
      }
      ;
    });
    if (optionsToRedraw.length > 0) {
      if (typeof this._validateOptions === "function") {
        this._validateOptions();
      }
      this._trigger("renderering");
      this.element.trigger("renderering");
      this._redraw(optionsToRedraw);
      return true;
    } else {
      this._trigger("rendered");
      this.element.trigger("rendered");
      return false;
    }
  }
});

},{}],18:[function(require,module,exports){
"use strict";

require("../../../Polyfill/js/nixps-polyfill-WeakMap.js");
module.exports = new WeakMap();

},{"../../../Polyfill/js/nixps-polyfill-WeakMap.js":33}],19:[function(require,module,exports){
"use strict";

var ComponentWeakMap = require("./nixps-ComponentWeakMap.js");
function getComponent(pElement, pName) {
  if (ComponentWeakMap.has(pElement)) {
    if (ComponentWeakMap.get(pElement)[pName] != null) {
      return ComponentWeakMap.get(pElement)[pName];
    } else {
      return null;
    }
  }
  return null;
}
module.exports = getComponent;

},{"./nixps-ComponentWeakMap.js":18}],20:[function(require,module,exports){
"use strict";

var ComponentWeakMap = require("./nixps-ComponentWeakMap.js");
function setComponent(pElement, pName, pValue) {
  var components = ComponentWeakMap.get(pElement);
  if (components === undefined) {
    components = {};
    ComponentWeakMap.set(pElement, components);
  }
  components[pName] = pValue;
  return pValue;
}
module.exports = setComponent;

},{"./nixps-ComponentWeakMap.js":18}],21:[function(require,module,exports){
"use strict";

var Component = function Component() {};
Component.addContent = function (content, element, action, index) {
  if (action === undefined) {
    action = "append";
  }
  switch (action) {
    case "append":
      element.append(content);
      break;
    case "prepend":
      element.prepend(content);
      break;
    case "before":
      if (typeof index !== "number") {
        throw new Error("Component: the index parameter for the method addContent must be a number!");
      }
      element.children(":nth-child(" + index + ")").before(content);
      break;
    case "after":
      if (typeof index !== "number") {
        throw new Error("Component: the index parameter for the method addContent must be a number!");
      }
      element.children(":nth-child(" + index + ")").after(content);
      break;
    case "html":
      element.html(content);
      break;
    default:
      throw new Error("Component: unrecognized action value for the method addContentToBody. This can either be: append, prepend, before, after or html.");
  }
};
module.exports = Component;

},{}],22:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var EventDispatcher = require("../../Event/js/nixps-EventDispatcher.js");
var NJSON = require("../../JSON/js/nixps-JSON.js");
var Utilities = require("../../Utilities/js/nixps-Utilities.js");
var Device = require("../../../../../cloudflow/PWA/js/Device.js");
require("../../Object/js/nixps-Object.js");
var FORCE_DELAY = 0;
var REFRESH_INTERVAL = 700;
var retrievedData = {};
var relations = {};
var dataServices = [];
var intervalID;
function startRefreshInterval() {
  if (intervalID === undefined) {
    intervalID = setInterval(function () {
      var now = Date.now();
      for (var i = 0, len = dataServices.length; i < len; i++) {
        for (var j = 0, jlen = dataServices[i].refresh.length; j < jlen; j++) {
          var refresh = dataServices[i].refresh[j];
          var data = dataServices[i]._getData(refresh.name, true);
          if (refresh.enabled && data.latest_call + refresh.milliseconds < now) {
            data["latest_call"] = Number.MAX_SAFE_INTEGER;
            dataServices[i]._callRefresh(refresh, DataService.RETRIEVE.FORCE);
          }
        }
      }
    }, REFRESH_INTERVAL);
  }
}
var DataService = function DataService() {
  this.eventDispatcher();
  this.uid = Utilities.generateUID();
  this.refresh = [];
  dataServices.push(this);
};
DataService.RETRIEVE = {
  FORCE: 0,
  NORMAL: 1,
  LATER: 2
};
DataService.prototype = Object.assign({}, EventDispatcher.prototype, {
  constructor: DataService,
  eventDispatcher: EventDispatcher,
  updateData: function updateData(field, value, conditions, name, extend) {
    if (extend === undefined) {
      extend = false;
    }
    if (name === undefined) {
      throw new Error("DataService: add an argument for the name parameter!");
    }
    var data = this._getData(name, false);
    if (data === undefined) {
      return;
    } else if (data["result"] === undefined && data["deferred"] === undefined) {
      throw new Error("No results found to update");
    } else if (data["result"] === undefined && data["deferred"] !== undefined) {
      data["deferred"].done(function () {
        data["result"] = NJSON.setValue(data["result"], field, value, conditions, extend);
      });
    } else {
      data["result"] = NJSON.setValue(data["result"], field, value, conditions, extend);
    }
    return data["result"];
  },
  getData: function getData(field, conditions, name) {
    if (name === undefined) {
      throw new Error("DataService: add an argument for the name parameter!");
    }
    var data = this._getData(name, false);
    if (data === undefined) {
      throw new Error("No results found to update");
    } else if (data["result"] === undefined && data["deferred"] === undefined) {
      throw new Error("No results found to update");
    } else if (data["result"] === undefined && data["deferred"] !== undefined) {
      return $.Deferred(function (pDefer) {
        data["deferred"].done(function () {
          pDefer.resolve(NJSON.getValue(data["result"], field, conditions));
        });
      });
    } else {
      return NJSON.getValue(data["result"], field, conditions);
    }
  },
  retrieveDirtyData: function retrieveDirtyData(path, args, pMilliseconds, name, _abstract, action, parentNames, async) {
    if (action === undefined) {
      action = DataService.RETRIEVE.NORMAL;
    }
    if (async === undefined) {
      async = false;
    }
    if (name === undefined) {
      throw new Error("DataService: add an argument for the name parameter!");
    }
    var refresh = false;
    var milliseconds = -1;
    var first = true;
    if (typeof pMilliseconds === "number" && pMilliseconds > 0) {
      refresh = true;
      milliseconds = pMilliseconds;
    }
    var resultFunc = this._getCallbackFunction(args, "result");
    args = this._replaceCallbackFunction(args, "result", function (pResult, pDirty) {
      if (first || pDirty === true) {
        first = false;
        resultFunc.apply(null, [pResult]);
      }
    });
    this.retrieveData(path, args, refresh, milliseconds, name, _abstract, action, parentNames, async);
  },
  /**
   * @namespace DataManager#retrieveData
   * @description Retrieves data and stores it in case another call also want this data and multiple calls are avoided.
   * The purpose of this is to easily manage refreshes. Only use this to retrieve data and not to create or update it.
   * Any call through here will return stored data and not be up-to-data, unless you use action.
   * Certain arguments can be set so the data will be periodically synced with the database.
   * If this is the case then the success callback function for async calls will also have a dirty parameter
   * which indicates that the data retrieved from the database differs from the data stored locally.
   * @param {string} path - the path to call
   * @param {array} args - the arguments given with the call
   * @param {boolean} refresh - whether to update this information during a refresh
   * @param {number} milliseconds - how long will the intervals take for a refresh
   * @param {string} name - a unique name given to the call so it doesn't override another (when working with the same path but different arguments)
   * @param {string} abstract - a unique name given to the call so it doesn't override another (when working with the same path but different arguments)
   * @param {boolean} action - an object that specifies the structure of the objects: can have following props:
   * id: the object identifier
   * children: the prop for the nested children if they exist
   * isEqual: function to check equality
   * @param {array<string>} parentNames - the names of the parent calls when parents are dirty this call will be actiond on the next call
   * @param {boolean} [async=false] - set this to true this when the call doesn't start with "api_async" but is an async function
   */
  retrieveData: function retrieveData(path, args, refresh, milliseconds, name, _abstract2, action, parentNames, async) {
    if (refresh === undefined) {
      refresh = false;
    }
    if (milliseconds === undefined) {
      milliseconds = -1;
    }
    if (action === undefined) {
      action = DataService.RETRIEVE.NORMAL;
    }
    if (async === undefined) {
      async = false;
    }
    if (name === undefined) {
      throw new Error("DataService: add an argument for the name parameter!");
    }
    var call_vars = this._getCallVariablesFromPath(path);
    var call = call_vars.call;
    var context = call_vars.context;
    var callers = call_vars.callers;

    //Strip the arguments of callback functions
    var essentialArgs = $.extend(true, [], args);
    if (callers[0] === "api_async" || async === true) {
      essentialArgs = this._stripCallbackFunctions(essentialArgs);
    }
    var data = this._getData(name, true);
    action = action === DataService.RETRIEVE.FORCE || !_.isEqual(data.args, essentialArgs) && DataService.RETRIEVE.NORMAL ? DataService.RETRIEVE.FORCE : action;
    data.args = essentialArgs;

    //Setup refresh if necessary
    var refreshObj = this._getRefresh(name);
    if (refresh === true && refreshObj === null) {
      refreshObj = {
        id: Utilities.generateUID(),
        path: path,
        name: name,
        args: args,
        "abstract": _abstract2,
        async: callers[0] === "api_async" || async === true,
        milliseconds: milliseconds,
        enabled: true
      };
      this._addRefresh(refreshObj);
    } else if (refresh === true) {
      refreshObj.args = args;
      refreshObj.milliseconds = milliseconds;
      refreshObj.enabled = true;
    } else if (refreshObj !== null) {
      this._removeRefresh(refreshObj.id);
    }

    //add the parent name when necessary
    if (parentNames !== undefined && Array.isArray(parentNames) === true) {
      for (var i = 0, len = parentNames.length; i < len; i++) {
        if (relations[parentNames[i]] === undefined) {
          relations[parentNames[i]] = [];
        }
        if (relations[parentNames[i]].indexOf(data) === -1) {
          relations[parentNames[i]].push(data);
        }
      }
    }
    if (action !== DataService.RETRIEVE.LATER) {
      return this._call(call, context, args, data, callers, _abstract2, action, async);
    }
  },
  forceRefresh: function forceRefresh(name) {
    var refresh = this._getRefresh(name);
    if (refresh !== null) {
      this._callRefresh(refresh, DataService.RETRIEVE.FORCE);
    }
  },
  callRefresh: function callRefresh(name, resultCallback) {
    var refresh = this._getRefresh(name);
    if (refresh !== null) {
      this._callRefresh(refresh, DataService.RETRIEVE.NORMAL, resultCallback);
    }
  },
  poll: function poll(name, milliseconds, difference) {
    var refresh = this._getRefresh(name);
    var data = this._getData(name);
    if (refresh !== null) {
      var call_vars = this._getCallVariablesFromPath(refresh.path);
      var args = [].concat(refresh.args);
      var that = this;
      var prevResult = data["result"];
      args = this._replaceCallbackFunction(args, "result", function (pResult, pDirty) {
        var endPoll = pDirty;
        if (difference !== undefined && typeof difference === "function") {
          endPoll = difference(prevResult, pResult);
        }
        if (!endPoll) {
          setTimeout(function () {
            that._call(call_vars.call, call_vars.context, args, data, call_vars.callers, refresh["abstract"], DataService.RETRIEVE.FORCE, refresh.async);
          }, Device.getPollingFactor() * milliseconds);
        } else {
          that._getCallbackFunction(refresh.args, "result")(pResult, true);
        }
      });
      this._call(call_vars.call, call_vars.context, args, data, call_vars.callers, refresh["abstract"], DataService.RETRIEVE.FORCE, refresh.async);
    }
  },
  enableRefresh: function enableRefresh(name) {
    var refresh = this._getRefresh(name);
    if (refresh !== null) {
      refresh.enabled = true;
    }
  },
  enableAllRefreshes: function enableAllRefreshes() {
    for (var i = 0, len = this.refresh.length; i < len; i++) {
      this.refresh[i].enabled = true;
    }
  },
  enable: function enable() {
    this.enableAllRefreshes();
  },
  disableRefresh: function disableRefresh(name) {
    var refresh = this._getRefresh(name);
    if (refresh !== null) {
      refresh.enabled = false;
    }
  },
  disableAllRefreshes: function disableAllRefreshes() {
    for (var i = 0, len = this.refresh.length; i < len; i++) {
      this.refresh[i].enabled = false;
    }
  },
  disable: function disable() {
    this.disableAllRefreshes();
  },
  removeRefresh: function removeRefresh(name) {
    var refreshObj = this._getRefresh(name);
    if (refreshObj !== null) {
      this._removeRefresh(refreshObj.id);
    }
  },
  _removeRefresh: function _removeRefresh(id) {
    for (var i = 0, len = this.refresh.length; i < len; i++) {
      if (this.refresh[i].id === id) {
        this.refresh.splice(i, 1);
        break;
      }
    }
  },
  _getRefresh: function _getRefresh(name) {
    for (var i = 0, len = this.refresh.length; i < len; i++) {
      if (this.refresh[i].name === name) {
        return this.refresh[i];
      }
    }
    return null;
  },
  _addRefresh: function _addRefresh(pRefresh) {
    this.refresh.push(pRefresh);
    startRefreshInterval();
  },
  _getData: function _getData(name, create) {
    if (retrievedData[name + "_" + this.uid] === undefined) {
      if (create === true) {
        retrievedData[name + "_" + this.uid] = {
          args: null,
          name: name,
          uids: [],
          latest_call: Number.MAX_SAFE_INTEGER
        };
      } else {
        return;
      }
    }
    if (create === true) {
      if (retrievedData[name + "_" + this.uid].uids.indexOf(this.uid) === -1) {
        retrievedData[name + "_" + this.uid].uids.push(this.uid);
      }
    }
    return retrievedData[name + "_" + this.uid];
  },
  _call: function _call(call, context, args, data, callers, _abstract3, action, async) {
    if (action === undefined) {
      action = DataService.RETRIEVE.NORMAL;
    }
    if (async === undefined) {
      async = false;
    }
    if (callers[0] === "api_async" || async === true) {
      var resultFunc = this._getCallbackFunction(args, "result");
      var errorFunc = this._getCallbackFunction(args, "error");
      if (Array.isArray(data["done"]) === false) {
        data["done"] = [];
        data["fail"] = [];
      }
      if (data["result"] === undefined && data["defer"] === undefined || (data["action"] !== undefined && data["action"] === DataService.RETRIEVE.FORCE || action === DataService.RETRIEVE.FORCE) && (data["last_call"] === undefined || data["last_call"] < Date.now() - FORCE_DELAY)) {
        var that = this;
        data["last_call"] = Date.now();
        data["defer"] = $.Deferred(function (pDefer) {
          var defer = this;
          args = that._replaceCallbackFunction(args, "result", function (pResult) {
            if (_.isEqual(data["defer"], defer) === false) {
              return;
            } else {
              for (var i = 0, len = data["done"].length; i < len; i++) {
                data["defer"].done(data["done"][i]);
              }
              data["done"] = [];
              data["fail"] = [];
            }
            var dirty = false;
            if (pResult !== null && data["result"] !== null && _typeof(pResult) === "object" && _typeof(data["result"]) === "object") {
              if (Array.isArray(pResult.results) && Array.isArray(data["result"].results)) {
                if (pResult.results.length !== data["result"].results.length) {
                  dirty = true;
                } else {
                  for (var i = 0, len = pResult.results.length; i < len; i++) {
                    dirty = that.checkForSaveId(pResult.results[i], data["result"].results[i], _abstract3, pResult);
                    if (dirty === true) {
                      break;
                    }
                  }
                }
              } else if (pResult.save_id != null) {
                dirty = that.checkForSaveId(pResult, data["result"], _abstract3, pResult);
              } else {
                dirty = _.isEqual(data["result"], pResult) === false;
              }
            } else {
              dirty = _.isEqual(data["result"], pResult) === false;
            }
            data["previous_result"] = data["result"];
            data["result"] = $.extend(true, {}, pResult);
            data["defer"] = undefined;
            data["action"] = DataService.RETRIEVE.NORMAL;
            data["latest_call"] = Date.now();
            if (dirty === true) {
              if (data["name"] !== undefined && relations[data["name"]] !== undefined) {
                for (var i = 0, len = relations[data["name"]].length; i < len; i++) {
                  relations[data["name"]][i]["action"] = DataService.RETRIEVE.FORCE;
                }
              }
            }
            pDefer.resolve(pResult, dirty);
          });
          args = that._replaceCallbackFunction(args, "error", function (pError) {
            for (var i = 0, len = data["fail"].length; i < len; i++) {
              data["defer"].fail(data["fail"][i]);
            }
            data["done"] = [];
            data["fail"] = [];
            data["result"] = undefined;
            data["defer"] = undefined;
            data["latest_call"] = Number.MAX_SAFE_INTEGER;
            pDefer.reject(pError);
          });
          call.apply(context, args);
        });
        data["done"].push(resultFunc);
        data["fail"].push(errorFunc);
      } else if (data["defer"] !== undefined) {
        data["done"].push(resultFunc);
        data["fail"].push(errorFunc);
      } else {
        resultFunc.apply(null, [$.extend(true, {}, data["result"]), false]);
      }
    } else {
      if (data["result"] === undefined) {
        var result = call.apply(context, args);
        if (result.error === undefined) {
          data["result"] = $.extend(true, {}, result);
        }
        return result;
      } else {
        return $.extend(true, {}, data["result"]);
      }
    }
  },
  checkSaveId: function checkSaveId(pObject, data, _abstract4) {
    var dirty = pObject.save_id !== data.save_id;
    if (dirty === true) {
      return true;
    }
    if (_abstract4 != null && _typeof(_abstract4) === "object" && typeof _abstract4.children === "string") {
      var prop = _abstract4.children;
      if (Array.isArray(pObject[prop]) && Array.isArray(data[prop])) {
        if (pObject[prop].length !== data[prop].length) {
          return true;
        }
        for (var i = 0, len = pObject[prop].length; i < len; i++) {
          dirty = this.checkSaveId(pObject[prop][i], data[prop][i]);
          if (dirty === true) {
            return true;
          }
        }
      } else if (!Array.isArray(pObject[prop]) && !Array.isArray(data[prop]) && pObject[prop] !== null && data[prop] !== null && _typeof(pObject[prop]) === "object" && _typeof(data[prop]) === "object") {
        dirty = this.checkSaveId(pObject[prop], data[prop]);
        if (dirty === true) {
          return true;
        }
      }
    }
    return false;
  },
  checkForSaveId: function checkForSaveId(pObject, data, _abstract5, pResult) {
    if (pResult.save_id != null) {
      return this.checkSaveId(pObject, data, _abstract5);
    } else {
      return _.isEqual(data, pObject) === false;
    }
  },
  //Replace the result and error functions so they're appropriate to be used for refreshing
  //Although nothing is done with the results in the resolve, the defer needs to be resolved so refreshing continues otherwise the data is only refreshed once.
  _callRefresh: function _callRefresh(refresh, action, resultCallback) {
    var call_vars = this._getCallVariablesFromPath(refresh.path);
    var data = this._getData(refresh.name, true);
    var args = refresh.args;
    if (typeof resultCallback === "function") {
      args = this._replaceCallbackFunction(args, "result", resultCallback);
    }
    this._call(call_vars.call, call_vars.context, args, data, call_vars.callers, refresh["abstract"], action, refresh.async);
  },
  _getCallVariablesFromPath: function _getCallVariablesFromPath(path) {
    var call = window;
    var context = call;
    var callers = path.split(".");

    //find the api call and store it as a data variable
    for (var i = 0, len = callers.length; i < len; i++) {
      call = call[callers[i]];
      if (i + 1 !== len) {
        context = call;
      }
    }
    return {
      call: call,
      context: context,
      callers: callers
    };
  },
  _stripCallbackFunctions: function _stripCallbackFunctions(args) {
    if (typeof args[args.length - 2] === "function") {
      return args.slice(0, -2);
    } else if (typeof args[args.length - 1] === "function") {
      return args.slice(0, -1);
    } else {
      return args;
    }
  },
  _getCallbackFunction: function _getCallbackFunction(args, name) {
    if (name === "result" && typeof args[args.length - 2] === "function") {
      return args[args.length - 2];
    } else if (name === "result" && typeof args[args.length - 2] !== "function" && typeof args[args.length - 1] === "function" || name === "error" && typeof args[args.length - 2] === "function" && typeof args[args.length - 1] === "function") {
      return args[args.length - 1];
    } else if (name === "error") {
      return function (pError) {
        console.log(pError);
      };
    } else {
      throw new Error("Async api call's arguments doesn't include a function for the results!");
    }
  },
  _replaceCallbackFunction: function _replaceCallbackFunction(args, name, replaceFnc) {
    if (name === "result" && typeof args[args.length - 2] === "function") {
      args = [].concat(args);
      args[args.length - 2] = replaceFnc;
    } else if (name === "result" && typeof args[args.length - 2] !== "function" && typeof args[args.length - 1] === "function" || name === "error" && typeof args[args.length - 2] === "function" && typeof args[args.length - 1] === "function") {
      args = [].concat(args);
      args[args.length - 1] = replaceFnc;
    } else if (name === "result") {
      throw new Error("Async api call's arguments doesn't include a function for the results!");
    }
    return args;
  }
});
module.exports = DataService;

},{"../../../../../cloudflow/PWA/js/Device.js":198,"../../Event/js/nixps-EventDispatcher.js":24,"../../JSON/js/nixps-JSON.js":27,"../../Object/js/nixps-Object.js":31,"../../Utilities/js/nixps-Utilities.js":38}],23:[function(require,module,exports){
"use strict";

var Defer = function Defer(defer, process, cleanup) {
  if (cleanup === undefined) {
    cleanup = function cleanup() {};
  }
  this.defer = defer;
  this.process = process;
  this.cleanup = cleanup;
};
module.exports = Defer;

},{}],24:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var dispatcherWeakmap = new WeakMap();
var mEventDispatcherInstance;

/** @module nixps/event */

/**
 * An event dispatcher to mixin
 * @class EventDispatcher
 * @memberof module:nixps/event
 * @example
 * var SomeClass = function() {
 *     this.evenDispatcher();
 * }
 *
 * SomeClass.prototype = Object.assign({}, EventDispatcher.prototype, {
 *     constructor: SomeClass;
 *     eventDispatcher: EventDispatcher;
 * }
 *
 * var newInstance = new SomeClass();
 * newInstance.on("log", function(event, data) {
 *     console.log(data);
 * }
 * newInstance.trigger("log", "message");
 * // Fires event "log" and logs "message" in the console
 */
var EventDispatcher = function EventDispatcher() {
  this.listeners = {};
  this.locks = {};
  this.lockID = 0;
  this.throttleTriggers = -1;
  this.throttledEvents = [];
  this.throttleTimeout;
};
EventDispatcher.getInstance = function () {
  if (mEventDispatcherInstance === undefined) {
    mEventDispatcherInstance = new EventDispatcher();
  }
  return mEventDispatcherInstance;
};
EventDispatcher.create = function (pDispatcher) {
  if (!dispatcherWeakmap.has(pDispatcher)) {
    dispatcherWeakmap.set(pDispatcher, new EventDispatcher());
  }
};
EventDispatcher.on = function (pDispatcher, pEventName, pCB) {
  EventDispatcher.create(pDispatcher);
  return dispatcherWeakmap.get(pDispatcher).on(pEventName, pCB);
};
EventDispatcher.once = function (pDispatcher, pEventName, pCB) {
  EventDispatcher.create(pDispatcher);
  return dispatcherWeakmap.get(pDispatcher).once(pEventName, pCB);
};
EventDispatcher.subscribe = function (pDispatcher, pEventName, pCB) {
  EventDispatcher.create(pDispatcher);
  return dispatcherWeakmap.get(pDispatcher).subscribe(pEventName, pCB);
};
EventDispatcher.trigger = function (pDispatcher, pEventName, pData) {
  if (dispatcherWeakmap.has(pDispatcher)) {
    dispatcherWeakmap.get(pDispatcher).trigger(pEventName, pData);
  }
};
EventDispatcher.hydrateFrom = function (pDispatcherTarget, pDispatcherSource) {
  if (dispatcherWeakmap.has(pDispatcherSource)) {
    dispatcherWeakmap.set(pDispatcherTarget, dispatcherWeakmap.get(pDispatcherSource));
  } else {
    EventDispatcher.create(pDispatcherTarget);
  }
};
EventDispatcher.lock = function (pDispatcher) {
  EventDispatcher.create(pDispatcher);
  if (dispatcherWeakmap.has(pDispatcher)) {
    return dispatcherWeakmap.get(pDispatcher).lock();
  }
};
EventDispatcher.unlock = function (pDispatcher, pLockID) {
  if (dispatcherWeakmap.has(pDispatcher)) {
    dispatcherWeakmap.get(pDispatcher).unlock(pLockID);
  }
};
EventDispatcher.prototype = {
  constructor: EventDispatcher,
  on: function on(eventName, callback, context) {
    this._addEvent("on", eventName, callback, context);
    return function () {
      this.off(eventName, callback);
    }.bind(this);
  },
  once: function once(eventName, callback, context) {
    this._addEvent("once", eventName, callback, context);
    return function () {
      this.off(eventName, callback);
    }.bind(this);
  },
  off: function off(eventName, callback) {
    this._removeEvent("on", eventName, callback);
    this._removeEvent("once", eventName, callback);
  },
  //subscriptions only get data and no event object passed
  subscribe: function subscribe(eventName, callback, context) {
    this._addEvent("subscribe", eventName, callback, context);
    return function () {
      this.unsubscribe(eventName, callback);
    }.bind(this);
  },
  unsubscribe: function unsubscribe(eventName, callback) {
    this._removeEvent("subscribe", eventName, callback);
  },
  //TODO: write something that checks if events are removed during trigger phase
  trigger: function trigger(eventName, data) {
    if (this._canTrigger() === true) {
      if (this.throttleTriggers >= 0) {
        var that = this;
        var throttledFunc = function throttledFunc() {
          for (var i = 0, len = that.throttledEvents.length; i < len; i++) {
            that._triggerEvent(that.throttledEvents[i].eventName, that.throttledEvents[i].data);
          }
          that.throttledEvents = [];
          that.throttleTimeout = undefined;
        };
        if (this.throttleTimeout === undefined) {
          this.throttleTimeout = setTimeout(throttledFunc, this.throttleTriggers);
        }
        for (var i = 0, len = this.throttledEvents.length; i < len; i++) {
          if (this.throttledEvents[i].eventName === eventName && _.isEqual(this.throttledEvents[i].data, data)) {
            return;
          }
        }
        this.throttledEvents.push({
          eventName: eventName,
          data: data
        });
      } else {
        this._triggerEvent(eventName, data);
      }
    }
  },
  lock: function lock() {
    var lockID = ++this.lockID;
    this.locks[lockID] = true;
    return lockID;
  },
  unlock: function unlock(lockID) {
    delete this.locks[lockID];
  },
  _triggerEvent: function _triggerEvent(eventName, data) {
    var listeners = this._getListeners(eventName);
    for (var i = listeners.subscribe.length - 1; i >= 0; i--) {
      listeners.subscribe[i].callback.call(listeners.subscribe[i].context, data);
    }
    for (var i = listeners.on.length - 1; i >= 0; i--) {
      listeners.on[i].callback.call(listeners.on[i].context, {
        type: eventName
      }, data);
    }
    for (var i = listeners.once.length - 1; i >= 0; i--) {
      listeners.once[i].callback.call(listeners.once[i].context, {
        type: eventName
      }, data);
    }
    listeners.once = [];
  },
  _addEvent: function _addEvent(pType, pEventName, pCallback, pContext) {
    if (_typeof(pEventName) === "object") {
      pContext = pCallback;
      for (var prop in pEventName) {
        this._addEvent(pType, prop, pEventName[prop], pContext);
      }
    } else {
      var listeners = this._getListeners(pEventName);
      listeners[pType].push({
        callback: pCallback,
        context: pContext
      });
    }
  },
  _removeEvent: function _removeEvent(pType, pEventName, pCallback) {
    if (_typeof(pEventName) === "object") {
      for (var prop in pEventName) {
        this._removeEvent(prop, pEventName[prop]);
      }
    } else {
      var listeners = this._getListeners(pEventName);
      for (var i = listeners[pType].length - 1; i >= 0; i--) {
        if (listeners[pType][i].callback === pCallback) {
          listeners[pType].splice(i, 1);
        }
      }
    }
  },
  _getListeners: function _getListeners(eventName) {
    this.listeners[eventName] = this.listeners[eventName] || {
      on: [],
      once: [],
      subscribe: []
    };
    return this.listeners[eventName];
  },
  _canTrigger: function _canTrigger() {
    for (var lock in this.locks) {
      if (this.locks[lock] === true) {
        return false;
      }
    }
    return true;
  }
};
module.exports = EventDispatcher;

},{}],25:[function(require,module,exports){
"use strict";

var NJSON = require("../../JSON/js/nixps-JSON.js");
var JSONPatch = require("../../../General/JSON/js/nixps-JSONPatch.js");
var Form = require("../../../../../cloudflow/UIProfiles/js/Form.js");
function getValueOfField(pField, pComponent) {
  var type = pField.getComponent().getType();
  var value;
  switch (type) {
    default:
      value = pComponent[type]('getValue');
      break;
  }
  return value;
}
;
function addKey(pFrom, pTo, pKey) {
  if (pKey == ".") {
    $.extend(true, pFrom, pTo);
    return;
  }
  var subKeys = pKey.split('.');
  var subFrom = pFrom;
  var subTo = pTo;
  for (var i = 0; i < subKeys.length - 1; i++) {
    var subKey = subKeys[i];
    if (subFrom[subKey] === undefined) {
      return;
    }
    // container exists or is just made
    if (Array.isArray(subFrom[subKey]) === true && parseInt(subKeys[i + 1]) == subKeys[i + 1] && subTo[subKey] === undefined) {
      subTo[subKey] = [];
    } else if (subTo[subKey] === undefined) {
      subTo[subKey] = {};
    }
    subFrom = subFrom[subKey];
    subTo = subTo[subKey];
  }
  if (subFrom[subKeys[subKeys.length - 1]] !== undefined) {
    subTo[subKeys[subKeys.length - 1]] = subFrom[subKeys[subKeys.length - 1]];
  }
}
var FormRendererUtilities = function FormRendererUtilities() {};
FormRendererUtilities.onchange = function (pFormRenderer$, pCallback) {
  var instance = pFormRenderer$.data("nixps-cloudflow-FormRenderer");
  if (instance.change_handlers === undefined) {
    instance.change_handlers = [];
    FormRendererUtilities._on(pFormRenderer$, function (pEvent, pData) {
      var changeObject = {};
      instance._getFieldElements().each(function (index, elem) {
        var parent = pEvent.target;
        while (parent !== elem && parent !== null) {
          parent = parent.parentElement;
        }
        if (parent !== null) {
          var field = $(elem).data('inputFieldOptions');
          var component = $(this).children('.component');
          var key = field.getKey();
          if (field.isGroup() === true) {
            changeObject = $.extend(true, changeObject, getValueOfField(field, component));
          } else if (instance._needToSkip($(elem)) === false) {
            changeObject = NJSON.setValue(changeObject, key, getValueOfField(field, component));
          } else {
            if (instance.options.returnActionHiddenFields === "current") {
              changeObject = NJSON.setValue(changeObject, key, getValueOfField(field, component));
            } else if (instance.options.returnActionHiddenFields === "null") {
              changeObject = NJSON.setValue(changeObject, key, null);
            }
          }
        }
      });
      for (var i = 0, len = instance.change_handlers.length; i < len; i++) {
        instance.change_handlers[i](pEvent, changeObject);
      }
    });
  }
  instance.change_handlers.push(pCallback);
};
FormRendererUtilities.onpatch = function (pFormRenderer$, pCallback, pValues, pListenToFormChangesEvents) {
  var instance = pFormRenderer$.data("nixps-cloudflow-FormRenderer");
  instance.prev_values = {};
  var fields = instance.form.getElements();
  for (var i = 0, len = fields.length; i < len; i++) {
    if (fields[i].getType() === "field") {
      addKey(pValues, instance.prev_values, fields[i].getElement().getKey());
    }
  }
  if (instance.patch_handlers === undefined) {
    instance.patch_handlers = [];
    FormRendererUtilities._on(pFormRenderer$, function (pEvent, pData) {
      if (instance.patch_handlers.length > 0) {
        var new_values = pFormRenderer$.FormRenderer("getValues");
        var patch = JSONPatch.diff(instance.prev_values, new_values);
        if (Array.isArray(patch) && patch.length > 0) {
          instance.prev_values = new_values;
          for (var i = 0, len = instance.patch_handlers.length; i < len; i++) {
            instance.patch_handlers[i](pEvent, patch);
          }
        }
      }
    }, pListenToFormChangesEvents);
  }
  instance.patch_handlers.push(pCallback);
};
FormRendererUtilities._on = function (pFormRenderer$, pHandler, pListenToFormChangesEvents) {
  var instance = pFormRenderer$.data("nixps-cloudflow-FormRenderer");
  var handler = function handler(event, data) {
    if (pFormRenderer$.children(".nixps-cloudflow-LayoutRenderer").data("nixps-cloudflow-LayoutRenderer")) {
      var handleChangeEvent = function handleChangeEvent() {
        pHandler(event, data);
        instance.element.off("formrendererchange", handleChangeEvent);
      };
      if (event.type === "autofillextendprefillfields") {
        instance.element.on("formrendererchange", handleChangeEvent);
      } else {
        pHandler(event, data);
      }
    }
  };
  if (pListenToFormChangesEvents === true) {
    /**
     * sadly that somebody can write comments out of fustration, but was not able not communicate ...
     * with a clear and understandable architecture )-;, that blocks the UI input typing due to js calculation, because throttleing function is bad design ...
     * ho i forgot, the system is allowed to change the input fields, while you type 
     */
    instance._on({
      "formrendererchange": handler
    });
  } else {
    /**
     * Don't change this!!!
     * '"formrendererchange": handler' does not work!!!
     * The throttle in the formrenderer breaks the code and throttleTime = 0 doesn't work either
     * If you want to change this first fix formrenderer to work better.
     * Remove throttle or add an option that skips the throttle entirely.
     * Throttling events is bad design.
     * If I could rely on the 'formrendererchange' event, I wouldn't need to create this function in the first place.
     * The 'arrayinputchange' event doesn't get captured by 'formrendererchange' either #50729
     */
    instance._on({
      "change .formGroup.fieldElement": handler,
      "input .formGroup.fieldElement [contenteditable='true']": handler,
      "input .formGroup.fieldElement [contenteditable='plaintext-only']": handler,
      "input .formGroup.fieldElement input[type!=checkbox][type!=radio]": handler,
      "input .formGroup.fieldElement textarea": handler,
      "arrayinputchange .formGroup.fieldElement": handler,
      "fieldcustomchange .formGroup.fieldElement": handler,
      "datetimeselectorchange .formGroup.fieldElement": handler,
      "autofillchange .formGroup.fieldElement": handler,
      "autofillselect .formGroup.fieldElement": handler,
      "autofillextendprefillfields .formGroup.fieldElement": handler
    });
  }
};
FormRendererUtilities.offchange = function (pFormRenderer$, pCallback) {
  FormRendererUtilities._off(pFormRenderer$, pCallback, "change_handlers");
};
FormRendererUtilities.offpatch = function (pFormRenderer$, pCallback) {
  FormRendererUtilities._off(pFormRenderer$, pCallback, "patch_handlers");
};
FormRendererUtilities._off = function (pFormRenderer$, pCallback, prop) {
  var instance = pFormRenderer$.data("nixps-cloudflow-FormRenderer");
  if (instance && Array.isArray(instance[prop])) {
    for (var i = 0, len = instance[prop].length; i < len; i++) {
      if (instance[prop][i] === pCallback) {
        instance[prop].splice(i, 1);
      }
    }
  }
};
module.exports = FormRendererUtilities;

},{"../../../../../cloudflow/UIProfiles/js/Form.js":249,"../../../General/JSON/js/nixps-JSONPatch.js":29,"../../JSON/js/nixps-JSON.js":27}],26:[function(require,module,exports){
"use strict";

var RESERVED_WINDOWS_NAMES = ['CON', 'PRN', 'AUX', 'NUL', 'COM1', 'COM2', 'COM3', 'COM4', 'COM5', 'COM6', 'COM7', 'COM8', 'COM9', 'LPT1', 'LPT2', 'LPT3', 'LPT4', 'LPT5', 'LPT6', 'LPT7', 'LPT8', 'LPT9'];
var INVALID_CHARACTERS = ['>', '<', ':', '"', '/', '\\', '|', '?', '*', '.'];
function IO() {}
IO.splitPath = function (path) {
  var dirs = path.split("/");
  for (var i = dirs.length; i >= 0; i--) {
    if (dirs[i] === "") {
      dirs.splice(i, 1);
    }
  }
  return dirs;
};
IO.joinDirectories = function (dirs) {
  var authority;
  if (dirs[0].length !== 0 && dirs[0].indexOf(":") !== -1) {
    authority = dirs[0];
    if (authority.indexOf(":") === authority.length - 1) {
      authority += "//";
    } else if (authority.indexOf(":/") === authority.length - 2) {
      authority += "/";
    } else if (authority[authority.length - 1] !== "/") {
      authority += "/";
    }
    dirs = dirs.slice(1);
  }
  var path = dirs.join("/").replace(/\/\//g, "/");
  if (path[0] === "/") {
    path = path.substring(1);
  }
  if (dirs.length > 0 && dirs[dirs.length - 1].indexOf(".") === -1 && path.lastIndexOf("/") !== path.length - 1) {
    path += "/";
  }
  if (authority !== undefined) {
    path = authority + path;
  }
  return path;
};
IO.getDir = function (path) {
  if (path[path.length - 1] === '/') {
    path = path.substring(0, path.length - 1);
  }
  return path.substring(0, path.lastIndexOf("/")) + "/";
};
IO.isValidDirectoryName = function (name) {
  if (RESERVED_WINDOWS_NAMES.indexOf(name.toUpperCase()) !== -1) {
    return false;
  }
  for (var i = 0, len = INVALID_CHARACTERS.length; i < len; i++) {
    if (name.indexOf(INVALID_CHARACTERS[i]) !== -1) {
      return false;
    }
  }
  if (name.charAt(name.length - 1) === "." || name.charAt(name.length - 1) === " ") {
    return false;
  }
  return true;
};
IO.getFileName = function (path, withExtension) {
  if (withExtension === undefined) {
    withExtension = false;
  }
  var lastIndexOfDot = path.lastIndexOf(".");
  if (lastIndexOfDot === -1) {
    lastIndexOfDot = path.length;
  }
  return path.substring(path.lastIndexOf("/") + 1, withExtension === false ? lastIndexOfDot : path.length);
};
IO.changeFileName = function (path, file_name, withExtension) {
  if (withExtension === undefined) {
    withExtension = false;
  }
  var lastIndexOfDot = path.lastIndexOf(".");
  if (lastIndexOfDot === -1) {
    lastIndexOfDot = path.length;
  }
  var lastIndexOfDash = path.lastIndexOf("/");
  if (withExtension === true) {
    return path.substring(0, lastIndexOfDash + 1) + file_name;
  } else {
    return path.substring(0, lastIndexOfDash + 1) + file_name + path.substring(lastIndexOfDot, path.length);
  }
};
IO.getRelativePath = function (folders, path) {
  if (Array.isArray(folders) === false) {
    folders = [folders];
  }
  for (var i = 0, len = folders.length; i < len; i++) {
    if (path.indexOf(folders[i]) === 0) {
      return path.slice(folders[i].length);
    }
  }
  return path;
};
IO.isRelativePath = function (path) {
  return path.indexOf("://") === -1;
};
IO.extractCloudflowURI = function (path) {
  var path = decodeURIComponent(path);
  var indexCloudflow = path.indexOf("cloudflow:");
  if (indexCloudflow === -1) {
    return;
  }
  var nextParamIndex = path.indexOf("&", indexCloudflow);
  if (nextParamIndex === -1) {
    nextParamIndex = path.length;
  }
  return path.substring(indexCloudflow, nextParamIndex);
};
module.exports = IO;

},{}],27:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var NJSON = function NJSON() {};
NJSON.sort = function (pObjects, pSort) {
  return pObjects.sort(function (a, b) {
    for (var i = 0, len = pSort.length; i < len; i = i + 2) {
      if (a[pSort[i]] == b[pSort[i]]) {
        continue;
      } else if (a[pSort[i]] > b[pSort[i]]) {
        return pSort[i + 1] === "ascending" ? 1 : -1;
      } else if (a[pSort[i]] < b[pSort[i]]) {
        return pSort[i + 1] === "ascending" ? -1 : 1;
      }
    }
    return 0;
  });
};
NJSON.query = function (pObjects, pQuery) {
  if (Array.isArray(pObjects) === false) {
    pObjects = [pObjects];
  }
  var getSubQuery = function getSubQuery(pIndex) {
    var openParentheses = 0;
    var subQuery = [];
    for (var i = pIndex + 1; i < len; i++) {
      if (pQuery[i] === "(") {
        openParentheses++;
      } else if (pQuery[i] === ")") {
        if (openParentheses === 0) {
          break;
        }
        openParentheses--;
      }
      subQuery.push(pQuery[i]);
    }
    return {
      index: i,
      query: subQuery
    };
  };
  var castValue = function castValue(pLeadingValue, pTrailingValue) {
    if (typeof pLeadingValue === "number") {
      return parseInt(pTrailingValue);
    } else if (typeof pLeadingValue === "boolean") {
      if (pTrailingValue === "true") {
        return true;
      } else if (pTrailingValue === "false") {
        return false;
      }
    }
    return pTrailingValue;
  };
  var validate = function validate(pObject, pExpression) {
    var validation;
    if (pExpression.query !== undefined) {
      validation = NJSON.query(pObject, pExpression.query).length > 0;
    } else {
      validation = pExpression.func(NJSON.getValue(pObject, pExpression.key));
    }
    return pExpression.not ? !validation : validation;
  };
  var expressions = [];
  var currentSubQuery;
  var leading = true;
  var hasNot = false;
  for (var i = 0, len = pQuery.length; i < len; i++) {
    var conditionWithTrailing = undefined;
    var expression = pQuery[i];
    switch (expression) {
      case "(":
        var subQuery = getSubQuery(i, pQuery);
        i = subQuery.index;
        expressions.push({
          query: subQuery.query,
          not: hasNot
        });
        leading = false;
        hasNot = false;
        break;
      case "and":
      case "or":
        leading = true;
        expressions.push(expression);
        break;
      case "not":
        if (leading === true) {
          hasNot = true;
        } else {
          expressions[expressions.length - 1].not = true;
        }
        break;
      case "equal to":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue === castValue(pValue, pTrailingValue);
          };
        };
        break;
      case "not equal to":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue !== castValue(pValue, pTrailingValue);
          };
        };
        break;
      case "less than":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue < castValue(pValue, pTrailingValue);
          };
        };
        break;
      case "less than or equal to":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue <= castValue(pValue, pTrailingValue);
          };
        };
        break;
      case "greater than":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue > castValue(pValue, pTrailingValue);
          };
        };
        break;
      case "greater than or equal to":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue >= castValue(pValue, pTrailingValue);
          };
        };
        break;
      case "begins with":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue.indexOf(pTrailingValue) === 0;
          };
        };
        break;
      case "ends with":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue.indexOf(pTrailingValue) === pValue.length - pTrailingValue.length;
          };
        };
        break;
      case "contains":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue.indexOf(pTrailingValue) !== -1;
          };
        };
        break;
      case "contains text like":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue.toLowerCase().indexOf(pTrailingValue.toLowerCase()) !== -1;
          };
        };
        break;
      case "is like":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue.toLowerCase() === pTrailingValue.toLowerCase();
          };
        };
        break;
      case "begins like":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue.toLowerCase().indexOf(pTrailingValue.toLowerCase()) === 0;
          };
        };
        break;
      case "ends like":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pValue.toLowerCase().indexOf(pTrailingValue.toLowerCase()) === pValue.length - pTrailingValue.length;
          };
        };
        break;
      case "in":
        conditionWithTrailing = function conditionWithTrailing(pTrailingValue) {
          return function (pValue) {
            return pTrailingValue.map(function (pItem) {
              return castValue(pValue, pItem);
            }).includes(pValue);
          };
        };
        break;
      case "contains element matching":
        if (i + 1 < len && pQuery[i + 1] === "(") {
          var subQuery = getSubQuery(i, pQuery);
          i = subQuery.index;
          currentSubQuery.func = function (pQuery) {
            return function (pValue) {
              return NJSON.query(pValue, pQuery).length > 0;
            };
          }(subQuery.query);
        } else {
          throw new Error("Invalid query! 'contains element matching' doesn't precede open parenthesis.");
        }
        break;
      case "exists":
        currentSubQuery.func = function (pValue) {
          return pValue !== undefined;
        };
        break;
      case "does not exist":
        currentSubQuery.func = function (pValue) {
          return pValue === undefined;
        };
        break;
      default:
        if (currentSubQuery !== undefined && currentSubQuery.func === undefined) {
          throw new Error("Invalid query! Unknown operator: '" + expression + "'");
        }
        currentSubQuery = {
          key: expression,
          not: hasNot
        };
        leading = false;
        hasNot = false;
        expressions.push(currentSubQuery);
        break;
    }
    if (conditionWithTrailing !== undefined) {
      if (i + 1 < len) {
        if (pQuery[i + 1] === "[") {
          var trailingValue = [];
          for (i = i + 2; i < len; i++) {
            if (expression === "]") {
              break;
            }
            trailingValue.push(expression);
          }
          if (i === len) {
            throw new Error("Invalid query! No closing bracket found for array.");
          }
        } else {
          var trailingValue = pQuery[++i];
        }
        currentSubQuery.func = function (pTrailingValue) {
          return conditionWithTrailing(pTrailingValue);
        }(trailingValue);
      } else {
        throw new Error("Invalid query! Condition doesn't have trailing parameter.");
      }
    }
  }
  return pObjects.reduce(function (pAcc, pObject) {
    if (_typeof(pObject) === "object") {
      var validation = true;
      for (var i = 0, len = expressions.length; i < len; i++) {
        if (i === 0) {
          validation = validate(pObject, expressions[i]);
        } else if ((expressions[i] === "and" || expressions[i] === "or") && i + 1 < len && _typeof(expressions[i + 1]) === "object" && (expressions[i + 1].key !== undefined && expressions[i + 1].func !== undefined || expressions[i + 1].query !== undefined)) {
          if (expressions[i] === "and") {
            if (validation === false) {
              break;
            }
            validation = validation && validate(pObject, expressions[i + 1]);
          } else {
            if (validation === true) {
              break;
            }
            validation = validation || validate(pObject, expressions[i + 1]);
          }
          i++;
        } else {
          throw new Error("Invalid query! Incorrect logical!");
        }
      }
      if (validation) {
        pAcc.push(pObject);
      }
    }
    return pAcc;
  }, []);
};
NJSON.bindJSON = function (json, data) {
  for (var key in json) {
    if (Array.isArray(json[key]) === true) {
      for (var i = 0, len = json[key].length; i < len; i++) {
        NJSON.bindJSON(json[key][i], data);
      }
    } else if ($.isPlainObject(json[key]) === true) {
      NJSON.bindJSON(json[key], data);
    } else if (typeof json[key] === "string" && json[key].indexOf("{localization|") !== -1) {
      var indexStart = json[key].indexOf("{localization|");
      var indexStop = json[key].indexOf("}", indexStart);
      json[key] = json[key].substring(0, indexStart) + $.i18n._(json[key].substring(indexStart + 14, indexStop)) + json[key].substring(indexStop + 1);
    } else if (typeof json[key] === "string" && json[key].indexOf("${") !== -1) {
      var indexStart = json[key].indexOf("${");
      var indexStop = json[key].indexOf("}", indexStart);
      json[key] = json[key].substring(0, indexStart) + $.i18n._(json[key].substring(indexStart + 2, indexStop)) + json[key].substring(indexStop + 1);
    } else if (data !== undefined && typeof json[key] === "string" && json[key].indexOf("{data-key|") === 0 && json[key][json[key].length - 1] === "}") {
      var indexDefault = json[key].indexOf("|", 10);
      var endPos = indexDefault === -1 ? json[key].length - 1 : indexDefault;
      var value = NJSON.getValue(data, json[key].substring(10, endPos));
      if ((value === undefined || value === null) && indexDefault !== -1) {
        value = JSON.parse(json[key].substring(indexDefault + 1, json[key].length - 1));
      }
      json[key] = value;
    }
  }
  return json;
};

/**
 * @description Adaptation of CloudflowObject.setParameter
 * Get the value of in the object tree, given an path with dot notation
 * ToDo: when object is not found make sure that it's added according to a certain sort? Now it's pushed at the end of an array.
 * @function
 * @name CloudflowObject.setValue
 * @param {object} pObject the object tree where to search
 * @param {string} pField The path with dot notation; "." means the root object
 * @return {object} The value to be set
 * @param {Array<function>} pCompareCondition the condition to compare the element found at the path to when its an array
 * @return {object} The object manipulated
 */
NJSON.setValue = function (pObject, pField, pNewValue, pCompareConditions, pExtend) {
  if (pCompareConditions === undefined) {
    pCompareConditions = [];
  }
  if (pExtend === undefined || $.isPlainObject(pNewValue) === false) {
    pExtend = false;
  }
  if (pField === ".") {
    return pNewValue;
  }
  var secondToLast = this._getSecondToLastValue(pObject, pField, pCompareConditions, true);
  if (secondToLast === undefined) {
    return undefined;
  } else {
    var subKeys = secondToLast.subKeys;
    var subObject = secondToLast.subObject;
  }
  var compareCondition = NJSON._getCompareCondition(pField, pCompareConditions);
  if (compareCondition !== null && Array.isArray(subObject[subKeys[subKeys.length - 1]]) === true && parseInt(subKeys[subKeys.length - 1]) != subKeys[subKeys.length - 1]) {
    var found = false;
    for (var i = 0, len = subObject[subKeys[subKeys.length - 1]].length; i < len; i++) {
      if (compareCondition.call(null, subObject[subKeys[subKeys.length - 1]][i])) {
        if (pNewValue !== undefined) {
          if (pExtend === true) {
            subObject[subKeys[subKeys.length - 1]][i] = $.extend(true, subObject[subKeys[subKeys.length - 1]][i], pNewValue);
          } else {
            subObject[subKeys[subKeys.length - 1]][i] = pNewValue;
          }
        } else {
          subObject[subKeys[subKeys.length - 1]].splice(i, 1);
        }
        found = true;
        break;
      }
    }
    if (found === false && pNewValue !== undefined) {
      subObject[subKeys[subKeys.length - 1]].push(pNewValue);
    }
  } else if (compareCondition !== null && parseInt(subKeys[subKeys.length - 1]) != subKeys[subKeys.length - 1]) {
    if (pNewValue !== undefined) {
      subObject[subKeys[subKeys.length - 1]] = [pNewValue];
    }
  } else {
    if (pNewValue !== undefined) {
      if (pExtend === true) {
        subObject[subKeys[subKeys.length - 1]] = $.extend(true, subObject[subKeys[subKeys.length - 1]], pNewValue);
      } else {
        subObject[subKeys[subKeys.length - 1]] = pNewValue;
      }
    } else {
      if (Array.isArray(subObject) === true) {
        subObject.splice(subKeys[subKeys.length - 1], 1);
      } else {
        delete subObject[subKeys[subKeys.length - 1]];
      }
    }
  }
  return pObject;
};

/**
 * @description Adaptation of CloudflowObject.setParameter
 * Get the value of in the object tree, given an path with dot notation
 * ToDo: when object is not found make sure that it's added according to a certain sort? Now it's pushed at the end of an array.
 * @function
 * @name CloudflowObject.getValue
 * @param {object} pObject the object tree where to search
 * @param {string} pField The path with dot notation; "." means the root object
 * @param {function} pCompareCondition the condition to compare the element found at the path to when its an array
 * @return {object} The value situated ot that possition or undefined if not found
 */
NJSON.getValue = function (pObject, pField, pCompareConditions) {
  if (pCompareConditions === undefined) {
    pCompareConditions = [];
  }
  if (pField === ".") {
    return pObject;
  }
  var secondToLast = this._getSecondToLastValue(pObject, pField, pCompareConditions);
  if (secondToLast === undefined) {
    return undefined;
  } else {
    var subKeys = secondToLast.subKeys;
    var subObject = secondToLast.subObject;
  }
  if (Array.isArray(subObject[subKeys[subKeys.length - 1]]) === true && parseInt(subKeys[subKeys.length - 1]) != subKeys[subKeys.length - 1]) {
    var compareCondition = NJSON._getCompareCondition(pField, pCompareConditions);
    if (compareCondition !== null) {
      for (var i = 0, len = subObject[subKeys[subKeys.length - 1]].length; i < len; i++) {
        if (compareCondition.call(null, subObject[subKeys[subKeys.length - 1]][i])) {
          return subObject[subKeys[subKeys.length - 1]][i];
        }
      }
      return undefined;
    } else {
      return subObject[subKeys[subKeys.length - 1]];
    }
  } else {
    return subObject[subKeys[subKeys.length - 1]];
  }
};
NJSON._getSecondToLastValue = function (pObject, pField, pCompareConditions, pCreatePath) {
  if (pCompareConditions === undefined) {
    pCompareConditions = [];
  }
  if (pCreatePath === undefined) {
    pCreatePath = false;
  }
  var subKeys = pField.split('.');
  var subObject = pObject;
  var arraySearchCorrection = 0;
  for (var i = 0; i < subKeys.length - 1; i++) {
    var subKey = subKeys[i - arraySearchCorrection];
    if (subObject[subKey] === undefined) {
      if (pCreatePath === false) {
        return undefined;
      } else {
        subObject[subKey] = {};
      }
    }
    // container exists or is just made
    if (Array.isArray(subObject[subKey]) === true && parseInt(subKeys[i + 1]) != subKeys[i + 1]) {
      var arrayPath = subKeys.slice(0, i + 1).join(".");
      var compareCondition = NJSON._getCompareCondition(arrayPath, pCompareConditions);
      if (compareCondition === null) {
        return undefined;
      }
      var found = false;
      for (var j = 0, jLen = subObject[subKey].length; j < jLen; j++) {
        if (compareCondition.call(null, subObject[subKey][j])) {
          subObject = subObject[subKey][j];
          found = true;
          break;
        }
      }
      if (found === false) {
        return undefined;
      }
    } else {
      subObject = subObject[subKey];
    }
  }
  return {
    subKeys: subKeys,
    subObject: subObject
  };
};
NJSON._getCompareCondition = function (key, conditions) {
  for (var i = 0, len = conditions.length; i < len; i++) {
    if (conditions[i].key === key) {
      return conditions[i].func;
    }
  }
  return null;
};
module.exports = NJSON;

},{}],28:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var NJSON = require("./nixps-JSON.js");

// Deprecated
var JSONObject = function JSONObject(pObject) {
  this.isJSONObject = true;
  if (pObject === undefined) {
    pObject = {};
  }
  if (pObject instanceof this.constructor === false) {
    this.create(pObject);
  } else {
    this.create(pObject.json);
  }
};
JSONObject.toJSON = function (pObject) {
  if (pObject.isJSONObject === true && pObject.json !== undefined) {
    return JSONObject.copyProperties(pObject.json);
  } else {
    return JSONObject.copyProperties(pObject);
  }
};
JSONObject.copyProperties = function (pObject) {
  if (Array.isArray(pObject)) {
    var obj = [];
    for (var i = 0, len = pObject.length; i < len; i++) {
      obj[i] = JSONObject.copyProperties(pObject[i]);
    }
    return obj;
  } else if (pObject !== null && _typeof(pObject) === "object") {
    var obj = {};
    for (var prop in pObject) {
      obj[prop] = JSONObject.copyProperties(pObject[prop]);
    }
    return obj;
  }
  return pObject;
};
JSONObject.convertToJSON = function (pProperty, pToRemove, pToRename) {
  if (pToRemove === undefined) {
    pToRemove = [];
  }
  if (pToRename === undefined) {
    pToRename = [];
  }
  if (Array.isArray(pProperty)) {
    var arr = [];
    for (var i = 0, len = pProperty.length; i < len; i++) {
      var json = JSONObject.toJSON(pProperty[i]);
      for (var j = 0, jLen = pToRemove.length; j < jLen; j++) {
        delete json[pToRemove[j]];
      }
      for (var j = 0, jLen = pToRename.length; j < jLen; j++) {
        json[pToRename[j][1]] = json[pToRename[j][0]];
        delete json[pToRename[j][0]];
      }
      arr.push(json);
    }
    return arr;
  } else if (pProperty != null && _typeof(pProperty) === "object") {
    var json = JSONObject.toJSON(pProperty);
    for (var i = 0, len = pToRemove.length; i < len; i++) {
      delete json[pToRemove[i]];
    }
    for (var i = 0, len = pToRename.length; i < len; i++) {
      json[pToRename[i][1]] = json[pToRename[i][0]];
      delete json[pToRename[i][0]];
    }
    return json;
  } else {
    return pProperty;
  }
};
JSONObject.convertToInstance = function (pProperty, pInstance, pExtend) {
  if (pExtend === undefined) {
    pExtend = {};
  }
  if (Array.isArray(pProperty)) {
    for (var i = 0, len = pProperty.length; i < len; i++) {
      if (pProperty[i] instanceof pInstance === false) {
        pProperty[i] = new pInstance($.extend(pProperty[i], pExtend));
      }
    }
  } else if (pProperty != null && _typeof(pProperty) === "object" && pProperty instanceof pInstance === false) {
    pProperty = new pInstance($.extend(pProperty, pExtend));
  }
  return pProperty;
};
JSONObject.prototype = {
  constructor: JSONObject,
  create: function create(pJSON) {
    this.json = pJSON;
    for (var prop in pJSON) {
      this.addProperty(prop, pJSON[prop]);
    }
  },
  extend: function extend(pJSON) {
    $.extend(this.json, pJSON);
  },
  addProperty: function addProperty(pName, pValue) {
    Object.defineProperty(this, pName, {
      get: function get() {
        return this.json[pName];
      },
      set: function set(pValue) {
        this.json[pName] = pValue;
      },
      configurable: true,
      enumerable: true
    });
  },
  isPropertyValid: function isPropertyValid(pField) {
    return NJSON.getValue(this, pField) !== undefined;
  }
};
module.exports = JSONObject;

},{"./nixps-JSON.js":27}],29:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// TODO: write tests for shallow_copy && create
// Add remove to undo when create has created new paths
// Split so that it integrates better with Store (shallow copy is only option) and _add, _remove aren't "private

var JSONPointer = require("./nixps-JSONPointer.js");
var GUID = require("../../../../../cloudflow/CloudflowUtil/js/GUID.js");

/**
 * http://jsonpatch.com/
 * @class JSONPatch
 * @memberof module:nixps/JSON
 */
var JSONPatch = function JSONPatch() {};
JSONPatch.add = function (patch, pointer, value) {
  patch.push(JSONPatch._add(pointer, value));
};
JSONPatch._add = function (pointer, value) {
  return {
    id: GUID.generate(),
    op: "add",
    path: pointer,
    value: value
  };
};
JSONPatch._applyAdd = function (document, operation, shallow_copy) {
  var original = document;
  if (document === null) {
    document = {};
  } else if (shallow_copy === true && Array.isArray(document)) {
    document = [].concat[document];
  } else if (shallow_copy === true && document !== null && _typeof(document) === "object") {
    document = Object.assign({}, document);
  }
  return JSONPatch._applyPatch(document, operation, shallow_copy, true, function () {
    // Context the root
    if (Array.isArray(operation.value) || operation.value === null || _typeof(operation.value) !== "object") {
      return {
        result: operation.value,
        undo: [JSONPatch._replace(operation.path, original)]
      };
    } else {
      return {
        result: shallow_copy === true ? Object.assign(document, operation.value) : Object.assign({}, document, operation.value),
        undo: [JSONPatch._replace(operation.path, original)]
      };
    }
  }, function (context, token, path) {
    // Context is an array and path after last element
    context.push(operation.value);
    return {
      result: document,
      undo: [JSONPatch._remove(path)]
    };
  }, function (context, index) {
    // Context is an array and index is known
    context.splice(index, 0, operation.value);
    return {
      result: document,
      undo: [JSONPatch._remove(operation.path)]
    };
  }, function (context, token) {
    // Context is an object
    var value = context[token];
    context[token] = operation.value;
    return {
      result: document,
      undo: [value === undefined ? JSONPatch._remove(operation.path) : JSONPatch._replace(operation.path, value)]
    };
  }, function () {
    // No context was found.
    // This happens when the 
    throw new Error("This should never throw! Something is seriously wrong!");
  });
};
JSONPatch.remove = function (patch, pointer) {
  patch.push(JSONPatch._remove(pointer));
};
JSONPatch._remove = function (pointer) {
  return {
    id: GUID.generate(),
    op: "remove",
    path: pointer
  };
};
JSONPatch._applyRemove = function (document, operation, shallow_copy) {
  var original = document;
  if (document === null) {
    document = {};
  } else if (shallow_copy === true && Array.isArray(document)) {
    document = [].concat[document];
  } else if (shallow_copy === true && document !== null && _typeof(document) === "object") {
    document = Object.assign({}, document);
  }
  return JSONPatch._applyPatch(document, operation, shallow_copy, false, function () {
    // Context the root
    return {
      result: undefined,
      undo: [JSONPatch._replace(operation.path, document)]
    };
  }, function (context, token, path) {
    // Context is an array and path after last element
    return {
      result: original,
      undo: []
    };
  }, function (context, index) {
    // Context is an array and index is known
    var item = context.splice(index, 1)[0];
    return {
      result: document,
      undo: [JSONPatch._add(operation.path, item)]
    };
  }, function (context, token) {
    // Context is an object
    var value = context[token];
    delete context[token];
    return {
      result: document,
      undo: [JSONPatch._add(operation.path, value)]
    };
  }, function () {
    // No context was found, return unchanged document
    return {
      result: original,
      undo: []
    };
  });
};
JSONPatch.replace = function (patch, pointer, value) {
  patch.push(JSONPatch._replace(pointer, value));
};
JSONPatch._replace = function (pointer, value) {
  return {
    id: GUID.generate(),
    op: "replace",
    path: pointer,
    value: value
  };
};
JSONPatch._applyReplace = function (document, operation, shallow_copy) {
  var original = document;
  if (document === null) {
    document = {};
  } else if (shallow_copy === true && Array.isArray(document)) {
    document = [].concat[document];
  } else if (shallow_copy === true && document !== null && _typeof(document) === "object") {
    document = Object.assign({}, document);
  }
  return JSONPatch._applyPatch(document, operation, shallow_copy, true, function () {
    // Context the root
    return {
      result: operation.value,
      undo: [JSONPatch._replace(operation.path, document)]
    };
  }, function (context, token, path) {
    // Context is an array and path after last element
    return {
      result: original,
      undo: []
    };
  }, function (context, index) {
    // Context is an array and index is known
    var item = context[index];
    context[index] = operation.value;
    return {
      result: document,
      undo: [JSONPatch._replace(operation.path, item)]
    };
  }, function (context, token) {
    // Context is an object
    var value = context[token];
    context[token] = operation.value;
    return {
      result: document,
      undo: [JSONPatch._replace(operation.path, value)]
    };
  }, function () {
    // No context was found, throw error.
    // This shouldn't happen though as missing path is created.
    throw new Error("This should never throw! Something is seriously wrong!");
  });
};
JSONPatch.move = function (patch, pointer, from) {
  patch.push(JSONPatch._move(pointer, from));
};
JSONPatch._move = function (pointer, from) {
  return {
    id: GUID.generate(),
    op: "move",
    path: pointer,
    from: from
  };
};
JSONPatch._applyMove = function (document, operation, shallow_copy) {
  var valueToMove = JSONPointer.find(document, operation.from);
  if (valueToMove !== undefined) {
    var remove = JSONPatch._applyRemove(document, JSONPatch._remove(operation.from), shallow_copy);
    var add = JSONPatch._applyAdd(remove.result, JSONPatch._add(operation.path, valueToMove), shallow_copy);
    return {
      result: add.result,
      undo: add.undo.concat(remove.undo)
    };
  } else {
    return {
      result: document,
      undo: []
    };
  }
};
JSONPatch.copy = function (patch, pointer, from) {
  patch.push(JSONPatch._copy(pointer, from));
};
JSONPatch._copy = function (pointer, from) {
  return {
    id: GUID.generate(),
    op: "copy",
    path: pointer,
    from: from
  };
};
JSONPatch._applyCopy = function (document, operation, shallow_copy) {
  var valueToMove = JSONPointer.find(document, operation.from);
  if (valueToMove !== undefined) {
    var add = JSONPatch._applyAdd(document, JSONPatch._add(operation.path, valueToMove), shallow_copy);
    return {
      result: add.result,
      undo: add.undo
    };
  } else {
    return {
      result: document,
      undo: []
    };
  }
};
JSONPatch.test = function (patch, pointer, value) {
  patch.push(JSONPatch._test(pointer, value));
};
JSONPatch._test = function (pointer, value) {
  return {
    id: GUID.generate(),
    op: "test",
    path: pointer,
    value: value
  };
};
JSONPatch._applyTest = function (document, operation) {
  return JSONPatch._compare(JSONPointer.find(document, operation.path), operation.value);
};
JSONPatch.patch = function (document, patch, shallow_copy) {
  if (shallow_copy === undefined) {
    shallow_copy = false;
  }
  var undo = [];
  if (Array.isArray(patch)) {
    for (var i = 0, len = patch.length; i < len; i++) {
      try {
        var operation;
        switch (patch[i].op) {
          case "add":
            {
              operation = JSONPatch._applyAdd(document, patch[i], shallow_copy);
              break;
            }
          case "remove":
            {
              operation = JSONPatch._applyRemove(document, patch[i], shallow_copy);
              break;
            }
          case "replace":
            {
              operation = JSONPatch._applyReplace(document, patch[i], shallow_copy);
              break;
            }
          case "move":
            {
              operation = JSONPatch._applyMove(document, patch[i], shallow_copy);
              break;
            }
          case "copy":
            {
              operation = JSONPatch._applyCopy(document, patch[i], shallow_copy);
              break;
            }
          case "test":
            {
              operation = JSONPatch._applyTest(document, patch[i]);
              break;
            }
        }
        if (_typeof(operation) !== "object") {
          throw new Error();
        }
        document = operation.result;
        undo = operation.undo.concat(undo);
      } catch (e) {
        console.error(e);
        document = JSONPatch.patch(document, undo);
        break;
      }
    }
  }
  return document;
};
JSONPatch._applyPatch = function (document, operation, shallow_copy, create, onRoot, onContextArrayTop, onContextArrayIndex, onContextObject, onNoContext) {
  var tokens = JSONPointer.decode(operation.path);
  if (tokens.length === 0) {
    return onRoot();
  } else {
    var context = JSONPointer.context(document, tokens, undefined, shallow_copy, create);
    var token = tokens[tokens.length - 1];
    if (Array.isArray(context)) {
      if (token === "-") {
        tokens[tokens.length - 1] = context.length.toString();
        return onContextArrayTop(context, token, JSONPointer.encode(tokens));
      } else {
        return onContextArrayIndex(context, parseInt(token));
      }
    } else if (context !== null && _typeof(context) === "object") {
      return onContextObject(context, token);
    } else {
      return onNoContext();
    }
  }
};

// Finds first difference
JSONPatch.diff = function (document, target, path, patch) {
  if (path === undefined) {
    path = "";
  }
  if (patch === undefined) {
    patch = [];
  }
  var isObjDoc = _typeof(document) === "object" && document !== null;
  var isObjTarget = _typeof(target) === "object" && target !== null;
  var isArrDoc = Array.isArray(document);
  var isArrTarget = Array.isArray(target);
  if (isArrDoc || isArrTarget) {
    if (!isArrDoc || !isArrTarget) {
      JSONPatch.replace(patch, path, target);
      return;
    }
    var diff = 0;
    var i = 0;
    for (var len = document.length; i < len; i++) {
      if (i + diff < target.length && !JSONPatch._compare(document[i], target[i + diff])) {
        if (document.length + diff < target.length) {
          JSONPatch.add(patch, path + "/" + (i + diff), target[i + diff]);
          diff++;
        } else if (document.length + diff > target.length) {
          JSONPatch.remove(patch, path + "/" + (i + diff));
          diff--;
        } else {
          JSONPatch.diff(document[i], target[i + diff], path + "/" + (i + diff), patch);
        }
      } else if (i + diff >= target.length) {
        JSONPatch.remove(patch, path + "/" + (i + diff));
      }
    }
    for (var len = target.length; i + diff < len; i++) {
      JSONPatch.add(patch, path + "/-", target[i + diff]);
    }
  } else if (isObjDoc || isObjTarget) {
    if (!isObjDoc || !isObjTarget) {
      JSONPatch.replace(patch, path, target);
      return;
    }
    var keys = Object.keys(document).concat(Object.keys(target)).reduce(function (pAcc, pItem) {
      if (!pAcc.some(function (pAccItem) {
        return pAccItem === pItem;
      })) {
        pAcc.push(pItem);
      }
      return pAcc;
    }, []);
    for (var i = 0, len = keys.length; i < len; i++) {
      var prop = keys[i];
      if (!JSONPatch._compare(document[prop], target[prop])) {
        if (document[prop] === undefined) {
          JSONPatch.add(patch, path + "/" + prop, target[prop]);
        } else if (target[prop] === undefined) {
          JSONPatch.remove(patch, path + "/" + prop);
        } else {
          JSONPatch.diff(document[prop], target[prop], path + "/" + prop, patch);
        }
      }
    }
  } else if (!JSONPatch._compare(document, target)) {
    JSONPatch.replace(patch, path, target);
  }
  return patch;
};
JSONPatch._find = function (document, value, path) {
  if (path === undefined) {
    path = "";
  }
  if (JSONPatch._compare(document, value)) {
    return path;
  } else if (Array.isArray(document)) {
    for (var i = 0, len = document.length; i < len; i++) {
      var path = JSONPatch._find(document[i], value, path + "/" + i);
      if (typeof path === "string") {
        return path;
      }
    }
  } else if (document !== null && _typeof(document) === "object") {
    for (var prop in document) {
      var path = JSONPatch._find(document[prop], value, path + "/" + prop);
      if (typeof path === "string") {
        return path;
      }
    }
  }
  return false;
};
JSONPatch._compare = function (a, b) {
  var isObjA = _typeof(a) === "object" && a !== null;
  var isObjB = _typeof(b) === "object" && b !== null;
  var isArrA = Array.isArray(a);
  var isArrB = Array.isArray(b);
  if (isArrA || isArrB) {
    if (!isArrA || !isArrB || a.length !== b.length) {
      return false;
    }
    for (var i = 0, len = a.length; i < len; i++) {
      if (!JSONPatch._compare(a[i], b[i])) {
        return false;
      }
    }
  } else if (isObjA || isObjB) {
    if (!isObjA || !isObjB || Object.keys(a).length != Object.keys(b).length) {
      return false;
    }
    for (var prop in a) {
      if (a.hasOwnProperty(prop) && !JSONPatch._compare(a[prop], b[prop])) {
        return false;
      }
    }
  } else {
    return a === b;
  }
  return true;
};
JSONPatch._clone = function (pObject) {
  if (Array.isArray(pObject)) {
    var obj = [];
    for (var i = 0, len = pObject.length; i < len; i++) {
      obj[i] = JSONPatch._clone(pObject[i]);
    }
    return obj;
  } else if (pObject !== null && _typeof(pObject) === "object") {
    var obj = {};
    for (var prop in pObject) {
      obj[prop] = JSONPatch._clone(pObject[prop]);
    }
    return obj;
  }
  return pObject;
};
module.exports = JSONPatch;

},{"../../../../../cloudflow/CloudflowUtil/js/GUID.js":89,"./nixps-JSONPointer.js":30}],30:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * http://jsonpatch.com/
 * @class JSONPointer
 * @memberof module:nixps/JSON
 */
var JSONPointer = function JSONPointer() {};
JSONPointer.find = function (document, pointer, separator) {
  var tokens = JSONPointer.decode(pointer, separator);
  if (tokens.length === 0) {
    return document;
  }
  var context = JSONPointer.context(document, tokens, separator);
  if (context === undefined) {
    return;
  } else {
    return context[tokens[tokens.length - 1]];
  }
};
JSONPointer.parse = function () {
  return JSONPointer.decode.apply(JSONPointer, arguments);
};
JSONPointer.decode = function (pointer, separator) {
  separator = JSONPointer._separator(separator);
  var split = pointer.split(separator).slice(1);
  for (var i = 0, len = split.length; i < len; i++) {
    split[i] = split[i].replace(/~1/g, separator).replace(/~0/g, "~");
  }
  return split;
};
JSONPointer.encode = function (tokens, separator) {
  if (tokens.length === 0) {
    return "";
  }
  separator = JSONPointer._separator(separator);
  for (var i = 0, len = tokens.length; i < len; i++) {
    tokens[i] = tokens[i].replace(/~/g, "~0").replace(new RegExp("\\" + separator, "g"), "~1");
  }
  return separator + tokens.join(separator);
};

/**
 * When using { shallow_copy } = true make sure to already have made a shallow copy of { document }
 */
JSONPointer.context = function (document, pointer, separator, shallow_copy, create) {
  var tokens = JSONPointer._tokens(pointer, separator);
  var target = document;
  for (var i = 0, len = tokens.length - 1; i < len; i++) {
    var token = tokens[i];
    var object = target[token];
    if (shallow_copy === true && Array.isArray(object)) {
      target[token] = [].concat(object);
    } else if (shallow_copy === true && object !== null && _typeof(object) === "object") {
      target[token] = Object.assign({}, object);
    }
    if (Array.isArray(target) && JSONPointer._isArrayToken(token, target.length) || target !== null && _typeof(target) === "object") {
      if (target[token] === undefined && create) {
        if (!isNaN(tokens[i + 1]) || tokens[i + 1] === "-") {
          target[token] = [];
        } else {
          target[token] = {};
        }
      }
      target = target[token];
    } else {
      return undefined;
    }
  }
  return target;
};
JSONPointer._isArrayToken = function (token, arrLength) {
  if (token === "-") {
    return true;
  }
  if (token.length === 0 || token[0] === "0") {
    return false;
  }
  var index = parseInt(token);
  if (isNaN(index) || index < 0 || index >= arrLength) {
    return false;
  }
  return true;
};
JSONPointer._separator = function (separator) {
  if (separator === undefined) {
    return "/";
  } else {
    return separator;
  }
};
JSONPointer._tokens = function (pointer, separator) {
  if (Array.isArray(pointer)) {
    return pointer;
  } else {
    return JSONPointer.decode(pointer, separator);
  }
};
module.exports = JSONPointer;

},{}],31:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("../../Polyfill/js/nixps-polyfill-Object.js");
if (typeof Object.copy !== "function") {
  var OBJECTS_NOT_TO_COPY = [];
  if (typeof HTMLDocument !== "undefined") {
    OBJECTS_NOT_TO_COPY.push(HTMLDocument);
  }
  if (typeof DocumentType !== "undefined") {
    OBJECTS_NOT_TO_COPY.push(DocumentType);
  }
  if (typeof HTMLElement !== "undefined") {
    OBJECTS_NOT_TO_COPY.push(HTMLElement);
  }
  if (typeof jQuery !== "undefined") {
    OBJECTS_NOT_TO_COPY.push(jQuery);
  }
  Object.copy = function (object) {
    function copyObject(object, depth, copiedObjects) {
      var pointer;
      if (Array.isArray(object) === true) {
        var copy = [];
        for (var i = 0, len = object.length; i < len; i++) {
          copy[i] = copyObject(object[i], depth + 1, copiedObjects);
        }
        return copy;
      } else if ((pointer = isCircular(object, copiedObjects)) !== null) {
        return pointer;
      } else if (isValidObject(object, copiedObjects) === true) {
        var proto = Object.getPrototypeOf(object);
        if (proto === null) {
          var copy = Object.assign({}, object);
        } else {
          var copy = Object.assign(Object.create(proto), object);
        }
        copiedObjects.push({
          original: object,
          copy: copy
        });
        for (var prop in object) {
          try {
            if (proto[prop] === undefined) {
              copy[prop] = copyObject(object[prop], depth + 1, copiedObjects);
            }
          } catch (e) {
            throw new Error(e);
          }
        }
        return copy;
      } else {
        return object;
      }
    }
    function isCircular(pObject, pCopiedObjects) {
      for (var i = 0, len = pCopiedObjects.length; i < len; i++) {
        if (pCopiedObjects[i].original === pObject) {
          return pCopiedObjects[i].copy;
        }
      }
      return null;
    }
    function isValidObject(pObject) {
      if (pObject === null || _typeof(pObject) !== "object" || Array.isArray(pObject) === true) {
        return false;
      }
      for (var i = 0, len = OBJECTS_NOT_TO_COPY.length; i < len; i++) {
        if (pObject instanceof OBJECTS_NOT_TO_COPY[i]) {
          return false;
        }
      }
      return true;
    }
    return copyObject(object, 0, []);
  };
}

},{"../../Polyfill/js/nixps-polyfill-Object.js":32}],32:[function(require,module,exports){
"use strict";

if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      // .length of function is 2
      'use strict';

      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }
      var to = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
if (!Object.is) {
  Object.is = function (x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  };
}

},{}],33:[function(require,module,exports){
"use strict";

if (typeof WeakMap !== 'function') {
  var generateUID = function generateUID() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    do {
      var guid = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    } while (mUIDs.indexOf(guid) !== -1);
    mUIDs.push(guid);
    return guid;
  };
  var mUIDs = [];
  WeakMap = function WeakMap() {
    this.map = {};
    this.length = 0;
  };
  WeakMap.prototype = {
    constructor: WeakMap,
    set: function set(key, value) {
      if (key.__WeakMapKey === undefined) {
        key.__WeakMapKey = generateUID();
      }
      if (this.map[key.__WeakMapKey] === undefined) {
        this.length++;
        if (this.length > 100000) {
          throw new Error("WeakMap overload! Get a better browser!");
        }
      }
      this.map[key.__WeakMapKey] = value;
      return this;
    },
    get: function get(key) {
      if (key.__WeakMapKey === undefined) {
        return undefined;
      }
      return this.map[key.__WeakMapKey];
    },
    "delete": function _delete(key) {
      if (key.__WeakMapKey === undefined || this.map[key.__WeakMapKey] === undefined) {
        return false;
      }
      this.length--;
      delete this.map[key.__WeakMapKey];
      return true;
    },
    has: function has(key) {
      return key.__WeakMapKey !== undefined && this.map[key.__WeakMapKey] !== undefined;
    }
  };
}

},{}],34:[function(require,module,exports){
"use strict";

var Timeout = require("./nixps-Timeout.js");
var Defer = require("../../Defer/js/nixps-Defer.js");

/*
 * ToDO: research whether polling should stop interval processes. It should stop the intervl timeout, but processes are running should it stop these? and if so, should it restart them?
 * At the moment it doesn't. Which should be the case I feel.
 * Implement a beter way to start the interval immediately, do not confuse this with the argument "startImmediately", which doesn't start the timeout at all and where the interval will be started with a runIntervalProcess call, in the "interval" method,
 * but this is whether "interval" should start right away or do a timeout first.
 * Research a better way to set the "Timeout" object. Should this be done when "_setTimeout" is called or earlier, for example when a public function is called like "poll" or "interval"
 */
var DEFAULT_REFRESHRATE = 10000;
var DEFAULT_POLLMAXCALLS = 10;
var DEFAULT_POLLRATE = 300;

/**
 * @namespace nixps.refresh.RefreshService
 * @description Manager for refreshing data. This manager will make sure that no conflict occur with async calls.
 * @param {boolean} Is the refresh on or off? Every interval called will only be run once
 */
var RefreshService = function RefreshService(isOn) {
  if (isOn === undefined) {
    isOn = true;
  }
  this.isOn = isOn;
  this.path = {
    retrievalID: -1,
    interval: new Timeout(),
    intervalProcesses: {},
    intervalInitialCall: true,
    other: new Timeout()
  };
  this.defaultRefreshServiceRate = DEFAULT_REFRESHRATE;
  this.defaultPollRate = DEFAULT_POLLRATE;
};
RefreshService.pollWorkable = function (workable_id, interval, success, error) {
  var refresh = new RefreshService();
  var count = 0;
  refresh.poll(function () {
    return $.Deferred(function (pDefer) {
      api_async.hub.poll_for_workable_result(workable_id, interval, function (pPollResult) {
        pDefer.resolve(pPollResult);
      }, function (pPollError) {
        error(pPollError);
      });
    });
  }, function (pPollResult, pPollRefreshService) {
    if (pPollResult.timed_out === undefined) {
      if (pPollResult.result !== undefined && pPollResult.result.error !== undefined) {
        error(pPollResult.result);
      } else {
        success(pPollResult);
      }
      return true;
    }
    return false;
  });
};
RefreshService.prototype = {
  constructor: RefreshService,
  /**
   * @namespace nixps.refresh.RefreshService#setDefaultRefreshServiceRate
   * @description Sets the current default refresh rate the next called intervals will use
   * @param {number} the time in milliseconds
   */
  setDefaultRefreshServiceRate: function setDefaultRefreshServiceRate(milliseconds) {
    if (milliseconds === undefined || typeof milliseconds !== "number") {
      this.defaultRefreshServiceRate = DEFAULT_REFRESHRATE;
    } else {
      this.defaultRefreshServiceRate = milliseconds;
    }
  },
  /**
   * @namespace nixps.refresh.RefreshService#setDefaultPollRate
   * @description Sets the current default poll rate the next called polls will use
   * @param {number} the time in milliseconds
   */
  setDefaultPollRate: function setDefaultPollRate(milliseconds) {
    if (milliseconds === undefined || typeof milliseconds !== "number") {
      this.defaultPollRate = DEFAULT_POLLRATE;
    } else {
      this.defaultPollRate = milliseconds;
    }
  },
  /**
   * @namespace nixps.refresh.RefreshService#turnOn
   * @description Turns on the running interval
   */
  turnOn: function turnOn(skipFirst) {
    if (skipFirst === undefined) {
      skipFirst = false;
    }
    if (this.isOn === false) {
      this.isOn = true;
      this.forceInterval(skipFirst);
    }
  },
  /**
   * @namespace nixps.refresh.RefreshService#turnOff
   * @description Turns off the running interval
   */
  turnOff: function turnOff() {
    this.isOn = false;
    this._clearWaitingTimeout();
  },
  /**
   * @namespace nixps.refresh.RefreshService#getPathRetrievalID
   * @ the retrievalID of the path
   */
  getRetrievalID: function getRetrievalID() {
    return this.path.retrievalID;
  },
  /**
   * @namespace nixps.refresh.RefreshService#interval
   * @description runs a certain process chain starting with <b>defer</b> going through the list of <b>processes</b> every <b>milliseconds</b>
   * After each process the refresh waits until runIntervalProcess is called indicating which process is to be run next
   * or enIntervalProcess is called after which it's start the counter to start the process again starting with <b>defer</b>
   * @param defer {Defer} The start of the process chain. This will be called first.
   * @param processes {Array<Defer>} A collection of processes which can be called with runIntervalProcess
   * @param milliseconds {number} The wait time between the end of processes and the beginning, if "undefined" it's set to defaultIntervalRate which can be set with setDefaultIntervalRate and is 10000 by default
   * @param startImmediately {boolean} Whether it should start immediately
   */
  interval: function interval(defer, processes, milliseconds, startImmediately, skipFirst) {
    milliseconds = this._checkNumberArgument(milliseconds, this.defaultRefreshServiceRate);
    if (processes === undefined) {
      processes = [];
    }
    if (startImmediately === undefined) {
      startImmediately = true;
    }
    if (skipFirst === undefined) {
      skipFirst = false;
    }
    this.isOn = true;
    this.path.intervalProcesses = processes;
    this.path.intervalInitialCall = true;
    this._startTimeout(defer, milliseconds, "interval", startImmediately, skipFirst);
  },
  runIntervalProcess: function runIntervalProcess(processName, args) {
    this._clearWaitingTimeout();
    this.path.intervalInitialCall = false;
    if (this.path.intervalProcesses[processName] !== undefined) {
      this._callDeferAndProcess(this.path.intervalProcesses[processName], "interval", args);
    }
  },
  endIntervalProcess: function endIntervalProcess() {
    this._clearWaitingTimeout();
    this.path.intervalInitialCall = false;
    if (this.isOn === true && this.path.interval.func !== undefined && this.path.interval.milliseconds >= 0) {
      this._setTimeout(this.path.interval.func, "interval", this.path.interval.milliseconds, true, true, this.path.interval.defer);
    }
  },
  forceInterval: function forceInterval(skipFirst) {
    if (skipFirst === undefined) {
      skipFirst = false;
    }
    this._clearWaitingTimeout();
    this.path.intervalInitialCall = true;
    if (this.path.interval.func !== undefined && this.path.interval.milliseconds >= 0) {
      this._setTimeout(this.path.interval.func, "interval", this.path.interval.milliseconds, true, skipFirst, this.path.interval.defer);
    }
  },
  /**
   * @namespace nixps.refresh.RefreshService#poll
   * @description polls for the <b>defer</b> function of which the result is passed to the <b>process</b>.
   * The <b>process</b> function checks whether the result from the <b>defer</b> function is what's expected and should return true or false accordingly.
   * The <b>defer</b> functions keeps being called every <b>milliseconds</b> until the <b>process</b> returns true or if it has been polled 10 times.
   * If the polling didn't succeed the <b>cleanup</b> function is called.
   * @param {function} The function being polled
   * @param {function} The function to check the results of the poll and return true or false accordingly
   * @param {function} The function to execute when the polling fails
   * @param {number} The min wait time between polls, if "undefined" it's set to defaultPollRate which can be set with setDefaultPollRate and is 300 by default
   * Each time polling fail the wait time is increased times 2 untill it goes above 3s: 200, 400, 800, 1600, 3200, 3200, 3200
   */
  poll: function poll(defer, process, cleanup, milliseconds, indefinite_calls) {
    if (indefinite_calls === undefined) {
      indefinite_calls = false;
    }
    milliseconds = this._checkNumberArgument(milliseconds, this.defaultPollRate);
    if (cleanup === undefined) {
      cleanup = function cleanup() {};
    }
    var that = this;
    var timeout = 0;
    var defer;
    var processDefer = function processDefer(result, dirty) {
      var dataRefreshed = process.apply(null, [result, dirty, that]);
      if (dataRefreshed === true || indefinite_calls === false && ++timeout >= DEFAULT_POLLMAXCALLS) {
        if (that.isOn === true && that.path.interval.waiting === false && that.path.interval.func !== undefined && that.path.interval.milliseconds >= 0) {
          that._setTimeout(that.path.interval.func, "interval", that.path.interval.milliseconds, true, true, defer);
        }
        cleanup.apply(null, dataRefreshed === false ? new Error("RefreshService: polling timed out!") : [result, that]);
      } else {
        if (milliseconds < 3000) {
          milliseconds += milliseconds;
        }
        that._setTimeout(that.path.other.func, "other", milliseconds, true, true, defer);
      }
    };
    defer = new Defer(defer, processDefer, cleanup);
    this.path.intervalInitialCall = true;
    this._startTimeout(defer, milliseconds, "other");
  },
  /**
   * @namespace nixps.refresh.RefreshService#clearPoll
   * @description clears the poll
   */
  clearPoll: function clearPoll() {
    if (this.path.other.waiting === true) {
      this._clearWaitingTimeout();
    }
    this.path.other = new Timeout();
  },
  _startTimeout: function _startTimeout(nixpsDefer, milliseconds, timeoutName, startImmediately, skipFirst) {
    if (startImmediately === undefined) {
      startImmediately = true;
    }
    if (skipFirst === undefined) {
      skipFirst = false;
    }
    var that = this;
    this._clearWaitingTimeout();
    this._setTimeout(function () {
      that._callDeferAndProcess(nixpsDefer, timeoutName);
    }, timeoutName, milliseconds, startImmediately, skipFirst, nixpsDefer);
  },
  _callDeferAndProcess: function _callDeferAndProcess(nixpsDefer, timeoutName, args) {
    if (args === undefined) {
      args = [];
    }
    var that = this;
    var scopeRetrievalID = ++that.path.retrievalID;
    $.when(nixpsDefer.defer.apply(null, args)).done(function (result, dirty) {
      var applyArgs = [[], true, that];
      if (result !== undefined) {
        applyArgs = [result, dirty, that];
      }
      that._clearWaitingTimeout();
      if (scopeRetrievalID === that.path.retrievalID) {
        nixpsDefer.process.apply(null, $.merge(applyArgs, args));
      }
    }).fail(function (pError) {
      console.error(pError);
      nixpsDefer.cleanup();
    });
  },
  /**
   * @namespace nixps.refresh.RefreshService#getRunningIntervalID
   * @description Returns the intervalID for the timeout that's currently waiting
   * @return {number} The id of the waiting timeout
   */
  _getWaitingTimeout: function _getWaitingTimeout() {
    if (this.path.interval.waiting === true && this.path.other.waiting === false) {
      return this.path.interval;
    } else if (this.path.interval.waiting === false && this.path.other.waiting === true) {
      return this.path.other;
    } else if (this.path.interval.waiting === true && this.path.other.waiting === true) {
      throw new Error("RefreshService: both the standard and other setTimeout are running! This should not be possible!");
    }
  },
  /**
   * @namespace nixps.refresh.RefreshService#clearWaitingTimeout
   * @description Clears the timeout that's waiting
   */
  _clearWaitingTimeout: function _clearWaitingTimeout() {
    var waitingTimeout = this._getWaitingTimeout();
    if (waitingTimeout !== undefined) {
      clearTimeout(waitingTimeout.timeoutID);
      waitingTimeout.waiting = false;
    }
  },
  /**
   * @namespace nixps.refresh.RefreshService#setTimeout
   * @description executes setTimeout for the specified timeout
   */
  _setTimeout: function _setTimeout(func, timeoutName, milliseconds, startImmediately, skipFirst, defer) {
    if (startImmediately === undefined) {
      startImmediately = true;
    }
    if (this.path.interval.waiting === false && this.path.other.waiting === false) {
      this.path[timeoutName].waiting = true;
      this.path[timeoutName].func = func;
      this.path[timeoutName].defer = defer;
      this.path[timeoutName].milliseconds = milliseconds;
      if (startImmediately === true && (timeoutName === "other" || timeoutName === "interval" && this.path.intervalInitialCall === false || timeoutName === "interval" && this.path.intervalInitialCall === true && skipFirst === true)) {
        this.path[timeoutName].timeoutID = setTimeout(func, milliseconds);
      } else if (startImmediately === true && timeoutName === "interval" && this.path.intervalInitialCall === true) {
        this.path.intervalInitialCall = false;
        func.call();
      }
    } else {
      throw new Error("RefreshService: trying to call setTimeout where a function is already waiting! This should not be possible!");
    }
  },
  _checkNumberArgument: function _checkNumberArgument(number, defaultNumber) {
    if (number === undefined || typeof number !== "number") {
      return defaultNumber;
    } else {
      return number;
    }
  },
  _checkStringArgument: function _checkStringArgument(string, defaultString) {
    if (string === undefined || typeof string !== "string") {
      return defaultString;
    } else {
      return string;
    }
  }
};
module.exports = RefreshService;

},{"../../Defer/js/nixps-Defer.js":23,"./nixps-Timeout.js":35}],35:[function(require,module,exports){
"use strict";

var Timeout = function Timeout() {
  this.timeoutID = -1;
  this.func = undefined;
  this.defer = undefined;
  this.waiting = false;
  this.milliseconds = -1;
};
module.exports = Timeout;

},{}],36:[function(require,module,exports){
"use strict";

require("../../../General/Object/js/nixps-Object.js");
var TreeNode = function TreeNode(pJSON) {
  if (pJSON === undefined) {
    pJSON = {};
  }
  this.file = pJSON.file;
  this.parent = pJSON.parent;
  this.leaf = pJSON.leaf;
  this.expanded = pJSON.expanded;
  if (pJSON.children === undefined) {
    this.children = [];
  } else {
    this.children = pJSON.children;
  }
  if (pJSON.type === undefined) {
    this.type = TreeNode.HIERARCHY;
  } else {
    this.type = pJSON.type;
  }
};
TreeNode.HIERARCHY = "hierarchy";
TreeNode.ORPHAN = "orphan";
TreeNode.mergeTrees = function (pTreeA, pTreeB, isSame) {
  if (isSame(pTreeA, pTreeB)) {
    for (var j = 0, jLen = pTreeB.children.length; j < jLen; j++) {
      var merged = false;
      for (var i = 0, len = pTreeA.children.length; i < len; i++) {
        if (TreeNode.mergeTrees(pTreeA.children[i], pTreeB.children[j], isSame)) {
          merged = true;
          break;
        }
      }
      if (merged === false) {
        pTreeA.children.push(pTreeB.children[j]);
      }
    }
    return true;
  }
  return false;
};
TreeNode.inTree = function (pTreeNode, pCondition) {
  if (pCondition(pTreeNode)) {
    return true;
  }
  for (var i = 0, len = pTreeNode.children.length; i < len; i++) {
    if (TreeNode.inTree(pTreeNode.children[i], pCondition) === true) {
      return true;
    }
  }
  return false;
};
TreeNode.iterateTree = function (pTreeNode, pCallback) {
  if (pCallback !== undefined) {
    pCallback(pTreeNode);
  }
  for (var i = 0, len = pTreeNode.children.length; i < len; i++) {
    TreeNode.iterateTree(pTreeNode.children[i], pCallback);
  }
};
module.exports = TreeNode;

},{"../../../General/Object/js/nixps-Object.js":31}],37:[function(require,module,exports){
"use strict";

var FormUtilities = function FormUtilities() {};
FormUtilities.translateJSON = function (pJSON, pStartUpOptions) {
  if (pJSON == null || $.isPlainObject(pJSON) === true) {
    return pJSON;
  } else if (Array.isArray(pJSON) === false) {
    throw new Error("FormUtilities: Unknown form format!");
  }
  var elements = [];
  for (var i = 0; i < pJSON.length; i++) {
    if (pJSON[i].dummy === true) {
      // do nothing, those are elements that may not see daylight !!!
    } else if (typeof pJSON[i].variable === "string" && pJSON[i].variable.length > 0) {
      // know field
      elements.push(translateFieldJSON(pJSON[i], pStartUpOptions));
    } else if (!$.isEmptyObject(pJSON[i].element)) {
      // component not field. This component has no value
      elements.push({
        type: "component",
        element: pJSON[i].element,
        style: pJSON[i].style,
        actionList: pJSON[i].actionList
      });
    } else {
      throw new Error("FormUtilities: Unknown element in old format!");
    }
  }
  return {
    elements: elements
  };
};
function translateFieldJSON(pJSON, pStartUpOptions) {
  if (pJSON.edit_type === "rip_setting" || pJSON.edit_type === "interaction_select") {
    pJSON.name = "";
  }
  var component = translateComponent(pJSON, pStartUpOptions);
  var required = false;
  var helptext, group;
  if (!$.isEmptyObject(pJSON.component)) {
    component = pJSON.component;
  }
  if (typeof pJSON.required === "boolean") {
    required = pJSON.required;
  }
  if (typeof pJSON.helptext === "string" && pJSON.helptext.length > 0) {
    helptext = pJSON.helptext;
  }
  if (typeof pJSON.group === "boolean") {
    group = pJSON.group;
  }
  return {
    type: "field",
    element: {
      key: pJSON.variable,
      label: pJSON.name,
      component: component,
      required: required,
      helptext: helptext,
      group: group
    },
    style: pJSON.style,
    actionList: pJSON.actionList
  };
}
function translateComponent(pJSON, pStartUpOptions) {
  var component;

  // a unit (valueInput)
  var matches = /_unit$/.exec(pJSON.edit_type);
  var endsWithUnit = Array.isArray(matches) && matches.length > 0;
  if (endsWithUnit) {
    return {
      id: "id",
      type: "ValueInput",
      options: {
        name: pJSON.variable,
        displayDefinition: pJSON.edit_type.slice(0, -5),
        storageUnit: pJSON.storage_unit,
        minValue: pJSON.min_value,
        maxValue: pJSON.min_value
      }
    };
  }

  // rip setting
  if (pJSON.edit_type === "rip_setting") {
    component = {
      id: "id",
      type: "RIPEditorPresets",
      options: {
        default_preset: pJSON["default"]
      }
    };
    if (!$.isEmptyObject(pStartUpOptions) && typeof pStartUpOptions.whitepaper === "string") {
      component.options["whitepaper"] = pStartUpOptions.whitepaper;
    }
    if (!$.isEmptyObject(pStartUpOptions) && typeof pStartUpOptions.whitepaperInputName === "string") {
      component.options["whitepaper_input_name"] = pStartUpOptions.whitepaperInputName;
    }
    if (!$.isEmptyObject(pJSON.component) && !$.isEmptyObject(pStartUpOptions) && typeof pStartUpOptions.whitepaper === "string" && typeof pStartUpOptions.whitepaperInputName === "string") {
      pJSON.component.options.whitepaper = pStartUpOptions.whitepaper;
      pJSON.component.options.whitepaper_input_name = pStartUpOptions.whitepaperInputName;
    }
    return component;
  }

  // a select
  if (Array.isArray(pJSON.select_values) && pJSON.select_values.length > 0) {
    return {
      id: "id",
      type: "Select",
      options: {
        defaul: pJSON["default"],
        keyValues: pJSON.select_values,
        outputFormat: pJSON.edit_type
      }
    };
  } else if (typeof pJSON.select_values === "string" && pJSON.select_values.length > 0) {
    return {
      id: "id",
      type: "Select",
      options: {
        defaul: pJSON["default"],
        keyValues: parseSelectValues(pJSON.select_values),
        outputFormat: pJSON.edit_type
      }
    };
  }
  var component = {
    id: "id",
    type: "Input",
    options: {
      value: pJSON["default"]
    }
  };
  // others
  switch (pJSON.edit_type) {
    case "string":
      component.options["type"] = "text";
      break;
    case "number":
      component.options["type'"] = "decimal";
      component.options["max"] = pJSON.max_value;
      component.options["min"] = pJSON.min_value;
      break;
    case "integer":
      component.options["type'"] = "number";
      component.options["max"] = pJSON.max_value;
      component.options["min"] = pJSON.min_value;
      break;
    case "boolean":
      component.options["type'"] = "checkbox";
      break;
    case "array":
    case "date":
    case "interaction_select":
      component = undefined;
      break;
    default:
      // every component has a least a type string
      throw new Error('unknown edit_type old form format');
  }
  return component;
}
;
function parseSelectValues(pSelectValueString) {
  if (typeof pSelectValueString !== "string" || pSelectValueString.length === 0) {
    return [];
  }
  if (pSelectValueString[0] !== pSelectValueString[pSelectValueString.length - 1]) {
    return [];
  }
  var options = pSelectValueString.split(pSelectValueString[0]);
  return _.filter(options, function (pValue) {
    return pValue.length > 0;
  });
}
;
module.exports = FormUtilities;

},{}],38:[function(require,module,exports){
"use strict";

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

/**
 * @class Utilities
 * @memberof module:nixps/JODA
 */
function Utilities() {}
Utilities.htmlEscape = function (pText) {
  return pText.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
};

/**
 * @deprecated use cloudflowUtils/js/GUID.generate
 */
Utilities.generateUID = function () {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

/**
 * @deprecated use cloudflowUtils/js/GUID.generate
 */
Utilities.generateGUID = function (elem) {
  if (elem === undefined) {
    elem = $(document.body);
  }
  do {
    var guid = "guid-" + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  } while (elem.find("#" + guid).length > 0);
  return guid;
};
Utilities.convertToBytes = function (size) {
  if (parseInt(size) != size) {
    var metric = size.substr(-2);
    var value = parseInt(size.substr(0, size.length - 2));
    if (isNaN(value) === true) {
      throw new Error("Size is malformatted!");
    }
    switch (metric.toUpperCase()) {
      case "PB":
        value = value * 1024;
      case "TB":
        value = value * 1024;
      case "GB":
        value = value * 1024;
      case "MB":
        value = value * 1024;
      case "KB":
        value = value * 1024;
        break;
      default:
        throw new Error("Size is malformatted!");
    }
    return value;
  } else {
    return parseInt(size);
  }
};
Utilities.convertBytesToMetric = function (bytes, metric, fixed) {
  if (fixed === undefined) {
    fixed = 2;
  }
  if (parseInt(bytes) == bytes) {
    var value = parseInt(bytes);
    if (typeof metric === "string") {
      switch (metric.toUpperCase()) {
        case "PB":
          value = value / 1024;
        case "TB":
          value = value / 1024;
        case "GB":
          value = value / 1024;
        case "MB":
          value = value / 1024;
        case "KB":
          value = value / 1024;
          break;
        default:
          {}
      }
      metric = metric.toUpperCase();
      if (metric === "KB") {
        metric = "kB";
      }
    } else {
      var count = 0;
      while (value >= 100) {
        value = value / 1024;
        count++;
      }
      switch (count) {
        case 0:
          metric = "B";
          break;
        case 1:
          metric = "kB";
          break;
        case 2:
          metric = "MB";
          break;
        case 3:
          metric = "GB";
          break;
        case 4:
          metric = "TB";
          break;
        case 5:
          metric = "PB";
          break;
      }
    }
    return value.toFixed(fixed) + " " + metric;
  } else {
    throw new Error("bytes should be an integer");
  }
};
Utilities.clamp = function (pValue, pMin, pMax) {
  if (pValue < pMin) {
    pValue = pMin;
  } else if (pValue > pMax) {
    pValue = pMax;
  }
  return pValue;
};
Utilities.localize = function (string, args) {
  if (typeof string === "string" && string.indexOf("${") === 0 && string[string.length - 1] === "}") {
    return $.i18n._(string.substring(2, string.length - 1), args);
  }
  return string;
};
Utilities.roundFixed = function (value, fixed) {
  var pow = Math.pow(10, fixed);
  return (Math.round(value * pow) / pow).toFixed(fixed);
};
module.exports = Utilities;

},{}],39:[function(require,module,exports){
"use strict";

var TreeNode = require("../../../General/Tree/js/nixps-TreeNode.js");
var IO = require("../../../General/IO/js/nixps-IO.js");
function File(pJSON) {
  if (!pJSON.url) {
    throw new Error("File object must have an url!");
  } else {
    this.url = pJSON.url;
  }
  for (var prop in pJSON) {
    this[prop] = pJSON[prop];
  }
  if (this.path === undefined) {
    this.path = IO.splitPath(File.getFile(this));
  }
  if (this.type === undefined) {
    this.type = File.FILE;
  }
}
File.FILE = "file";
File.DIR = "dir";
File.TAG = "tag";
File.getFile = function (pFile) {
  if (Array.isArray(pFile.url)) {
    return pFile.url[0];
  } else {
    return pFile.url;
  }
};
File.getTag = function (pFile) {
  if (typeof pFile.tag === "string") {
    return pFile.tag;
  } else {
    return "";
  }
};
File.sortByTag = function (a, b) {
  var aTag = File.getTag(a);
  var bTag = File.getTag(b);
  if (aTag === bTag) {
    return 0;
  }
  return aTag < bTag ? -1 : 1;
};
File.sortByPath = function (a, b) {
  if (a.path.length !== b.path.length) {
    return a.path.length - b.path.length;
  }
  return File.sortByUrl(a.path[a.path.length - 1], b.path[b.path.length - 1]);
};
File.sortByUrl = function (a, b) {
  if (File.getFile(a) === File.getFile(b)) {
    return 0;
  }
  return decodeURIComponent(File.getFile(a)) < decodeURIComponent(File.getFile(b)) ? -1 : 1;
};
File.seperateOrphans = function (pFiles, pRootTag) {
  var roots = pFiles.filter(function (pItem) {
    return File.getTag(pItem) === pRootTag;
  });
  var files = [];
  var orphans = [];
  for (var i = 0, len = pFiles.length; i < len; i++) {
    if (roots.find(function (pRoot) {
      return File.getFile(pFiles[i]).indexOf(File.getFile(pRoot)) === 0;
    })) {
      files.push(pFiles[i]);
    } else {
      orphans.push(pFiles[i]);
    }
  }
  return {
    files: files,
    orphans: orphans
  };
};
File.addToFileTree = function (pTree, pFile, pDepth, pExtraProps) {
  if (pDepth === undefined) {
    pDepth = 0;
  }
  if (pFile.path.length === pDepth + 1) {
    pTree.children.push(new TreeNode(Object.assign({}, pExtraProps, {
      file: pFile,
      parent: pTree
    })));
  } else {
    var found = false;
    for (var i = 0, len = pTree.children.length; i < len; i++) {
      if (pTree.children[i].file.path[pDepth] === pFile.path[pDepth]) {
        File.addToFileTree(pTree.children[i], pFile, pDepth + 1, pExtraProps);
        found = true;
        break;
      }
    }
    if (!found) {
      for (var i = pDepth, len = pFile.path.length - 1; i < len; i++) {
        var treePath = [];
        if (pTree.file !== undefined) {
          treePath = pTree.file.path;
        }
        pTree = new TreeNode(Object.assign({}, pExtraProps, {
          file: new File({
            url: IO.joinDirectories(treePath.concat(pFile.path[i])),
            type: File.DIR
          }),
          parent: pTree
        }));
        pTree.parent.children.push(pTree);
      }
      pTree.children.push(new TreeNode(Object.assign({}, pExtraProps, {
        file: pFile,
        parent: pTree
      })));
    }
  }
};
File.inFileTree = function (pTree, pUrl) {
  return TreeNode.inTree(pTree, function (pTreeNode) {
    return pTreeNode.file !== undefined && decodeURIComponent(File.getFile(pTreeNode.file)) === decodeURIComponent(pUrl);
  });
};
File.mergeFileTrees = function (pTreeA, pTreeB) {
  return TreeNode.mergeTrees(pTreeA, pTreeB, function (pNodeA, pNodeB) {
    if (pNodeA.file === undefined && pNodeB.file === undefined) {
      return true;
    }
    if (pNodeA.file === undefined || pNodeB.file === undefined) {
      return false;
    }
    return pNodeA.file.path.length === pNodeB.file.path.length && pNodeA.file.path.map(function (pItem, pIndex) {
      return pNodeB.file.path[pIndex] === pItem;
    }).some(function (pItem) {
      return pItem === false;
    }) === false;
  });
};
File.buildFileTree = function (pFiles, pFolders, pType, pRootFolder, pRootTag, pExtraProps) {
  switch (pType) {
    case TreeNode.HIERARCHY:
      return File._buildHierachyTree(pFiles, pFolders, pRootFolder, pRootTag, pExtraProps);
    case File.TAG:
      return File._buildTagTree(pFiles, pFolders, pExtraProps);
  }
};
File._buildHierachyTree = function (pFiles, pFolders, pRootFolder, pRootTag, pExtraProps) {
  if (pRootTag !== undefined) {
    var root_folders = pRootFolder ? [pRootFolder] : [];
    for (var i = 0, len = pFolders.length; i < len; i++) {
      if (File.getTag(pFolders[i]) === pRootTag && root_folders.indexOf(pFolders[i]) === -1) {
        root_folders.push(pFolders[i]);
      }
    }
    for (var i = 0, len = pFolders.length; i < len; i++) {
      if (root_folders.indexOf(pFolders[i]) === -1 && root_folders.some(function (pItem) {
        return File.getFile(pFolders[i]).indexOf(File.getFile(pItem)) === 0;
      }) === true) {
        root_folders.push(pFolders[i]);
      }
    }
    var files = pFiles.concat(root_folders);
  } else {
    var files = pFiles;
  }
  var tree = this._buildTree(files, pRootTag, pExtraProps);
  tree.root_tag = pRootTag;
  return tree;
};
File._buildTagTree = function (pFiles, pFolders, pExtraProps) {
  function addToTag(arr, obj) {
    var found = false;
    for (var i = 0, len = arr.length; i < len; i++) {
      if (File.getTag(arr[i]) === File.getTag(obj)) {
        found = true;
        arr[i].files.push(obj);
      }
    }
    if (found === false) {
      arr.push({
        tag: File.getTag(obj),
        files: [obj]
      });
    }
  }
  var tags = [];
  for (var i = 0, len = pFolders.length; i < len; i++) {
    addToTag(tags, pFolders[i]);
  }
  for (var i = 0, len = pFiles.length; i < len; i++) {
    addToTag(tags, pFiles[i]);
  }
  tags.sort(File.sortByTag);
  var root = new TreeNode(Object.assign({}, pExtraProps, {
    type: File.TAG
  }));
  for (var i = 0, len = tags.length; i < len; i++) {
    root.children.push(File._buildTree(tags[i].files, File.getTag(tags[i]), pExtraProps));
  }
  return root;
};
File._buildTree = function (pFiles, pRootTag, pExtraProps) {
  var filesAndOrphans = File.seperateOrphans(pFiles, pRootTag);
  var filesToBuild = filesAndOrphans.files;
  filesToBuild.sort(File.sortByUrl);
  var root = new TreeNode();
  for (var i = 0, len = filesToBuild.length; i < len; i++) {
    File.addToFileTree(root, filesToBuild[i], 0, pExtraProps);
  }
  if (filesAndOrphans.orphans.length > 0) {
    var orphanRoot = new TreeNode(Object.assign({}, pExtraProps, {
      type: TreeNode.ORPHAN
    }));
    for (var i = 0, len = filesAndOrphans.orphans.length; i < len; i++) {
      if (File.isDirectory(filesAndOrphans.orphans[i]) === false) {
        orphanRoot.children.push(new TreeNode(Object.assign({}, pExtraProps, {
          file: filesAndOrphans.orphans[i]
        })));
      }
    }
    root.children.push(orphanRoot);
  }
  return root;
};
File.isCloudflowURI = function (pFile) {
  var url = File.getFile(pFile);
  return url.indexOf("cloudflow:") === 0;
};
File.isHttpURI = function (pFile) {
  var url = File.getFile(pFile);
  return url.indexOf("http:") === 0 || url.indexOf("https:") === 0 || IO.isRelativePath(url);
};
File.isDirectory = function (pFile) {
  return pFile.type === File.DIR;
};
File.indexDiff = function (pFileA, pFileB) {
  for (var i = 0, len = pFileA.path.length; i < len; i++) {
    if (i >= pFileB.length) {
      return -1;
    }
    if (pFileA.path[i] !== pFileB.path[i]) {
      return i;
    }
  }
  return -1;
};
module.exports = File;

},{"../../../General/IO/js/nixps-IO.js":26,"../../../General/Tree/js/nixps-TreeNode.js":36}],40:[function(require,module,exports){
"use strict";

var JSONObject = require("../../../General/JSON/js/nixps-JSONObject.js");
var File = require("../../Asset/js/nixps-File.js");
var Task = require("../../../../../cloudflow/TaskList/js/model/Task.js");
var Job = function Job(pJSON) {
  for (var prop in pJSON) {
    this[prop] = pJSON[prop];
  }
  this.projects = JSONObject.convertToInstance(this.projects, Job);
  this.files = JSONObject.convertToInstance(this.files, File, {
    type: File.FILE
  });
  this.folders = JSONObject.convertToInstance(this.folders, File, {
    type: File.DIR
  });
  this.task_list = JSONObject.convertToInstance(this.task_list, Task);
};
Job.getFileTree = function (pJob, pType, pRootFolder, pRootTag, pExpanded) {
  var filesAndFolders = Job.getFilesAndFolders(pJob);
  var fileTree = File.buildFileTree(filesAndFolders.files, filesAndFolders.folders, pType, pRootFolder, pRootTag, {
    expanded: pExpanded
  });
  if (pJob.projects !== undefined && Array.isArray(pJob.projects) === true) {
    for (var i = 0, len = pJob.projects.length; i < len; i++) {
      var childTree = Job.getFileTree(pJob.projects[i], pType, pRootFolder, pRootTag, false);
      File.mergeFileTrees(fileTree, childTree);
    }
  }
  Job.completeFileTree(fileTree);
  return fileTree;
};
Job.completeFileTree = function (pFileTree, pProjectId) {
  if (pFileTree.file && pFileTree.file.project_id !== undefined) {
    pProjectId = pFileTree.file.project_id;
    pFileTree.droppable = true;
  } else if (pFileTree.file) {
    pFileTree.file.project_id = pProjectId;
    pFileTree.droppable = false;
  } else {
    pFileTree.droppable = false;
  }
  for (var i = 0, len = pFileTree.children.length; i < len; i++) {
    Job.completeFileTree(pFileTree.children[i], pProjectId);
  }
};
Job.getAllFilesAndFolders = function (pJob, pParents) {
  var filesAndFolders = Job.getFilesAndFolders(pJob);
  var files = filesAndFolders.files;
  var folders = filesAndFolders.folders;
  var i = 0;
  if (Array.isArray(pParents)) {
    for (i = pParents.length - 1; i >= 0; i--) {
      filesAndFolders = Job.getFilesAndFolders(pParents[i]);
      files = files.concat(filesAndFolders.files);
      folders = folders.concat(filesAndFolders.folders);
    }
  }
  if (pJob.projects !== undefined && Array.isArray(pJob.projects) === true) {
    for (i = 0; i < pJob.projects.length; i++) {
      filesAndFolders = Job.getAllFilesAndFolders(pJob.projects[i]);
      files = files.concat(filesAndFolders.files);
      folders = folders.concat(filesAndFolders.folders);
    }
  }
  return {
    files: files,
    folders: folders
  };
};
Job.getFilesAndFolders = function (pJob) {
  var files = Array.isArray(pJob.files) === true ? $.extend(true, [], pJob.files) : [];
  var folders = Array.isArray(pJob.folders) === true ? $.extend(true, [], pJob.folders) : [];
  for (var i = 0, len = files.length; i < len; i++) {
    files[i]["project_id"] = pJob.project_id;
  }
  for (var i = 0, len = folders.length; i < len; i++) {
    folders[i]["project_id"] = pJob.project_id;
  }
  return {
    files: files,
    folders: folders
  };
};
Job.getChildProjectByID = function (pJob, pSearchProjectID) {
  return Job._getProjectsChildByCondition(pJob, function (pChild) {
    return pSearchProjectID == null || pChild._id === pSearchProjectID;
  });
};
Job.getProjectsToChildId = function (pJob, pSearchProjectID) {
  return Job._getProjectsChildByCondition(pJob, function (pChild) {
    return pSearchProjectID == null || pChild._id === pSearchProjectID;
  }, true);
};
Job.getChildProjectByProjectId = function (pJob, pSearchProjectID) {
  return Job._getProjectsChildByCondition(pJob, function (pChild) {
    return pSearchProjectID == null || pChild.project_id === pSearchProjectID;
  });
};
Job.getProjectsToChildProjectId = function (pJob, pSearchProjectID) {
  return Job._getProjectsChildByCondition(pJob, function (pChild) {
    return pSearchProjectID == null || pChild.project_id === pSearchProjectID;
  }, true);
};
Job._getProjectsChildByCondition = function (pProject, pCondition, pConcat) {
  if (pConcat === undefined) {
    pConcat = false;
  }
  if (pCondition(pProject) === true) {
    return pConcat ? [pProject] : pProject;
  }
  if (pProject.projects !== undefined) {
    for (var i = 0, len = pProject.projects.length; i < len; i++) {
      var val = Job._getProjectsChildByCondition(pProject.projects[i], pCondition, pConcat);
      if (val !== null) {
        return pConcat ? [pProject].concat(val) : val;
      }
    }
  }
  return null;
};
Job.toJSON = function (pJob) {
  var json = $.extend(true, {}, pJob);
  for (var prop in json.forms) {
    delete json.forms[prop].contents;
    delete json.forms[prop].layout;
    if (Object.keys(json.forms[prop]).length === 0) {
      delete json.forms[prop];
      if (Object.keys(json.forms).length === 0) {
        delete json.forms;
      }
    }
  }
  json.projects = JSONObject.convertToJSON(json.projects);
  json.files = JSONObject.convertToJSON(json.files, ["type", "path", "project_id"], [["file_tag", "tag"]]);
  json.folders = JSONObject.convertToJSON(json.folders, ["type", "path", "project_id"], [["file_tag", "tag"]]);
  json.task_list = JSONObject.convertToJSON(json.task_list);
  return json;
};
Job.extend = function (pJob, pValues) {
  pJob = Job.toJSON(pJob);
  pValues = Job.toJSON(pValues);
  $.extend(true, pJob, pValues);
  return new Job(pJob);
};
module.exports = Job;

},{"../../../../../cloudflow/TaskList/js/model/Task.js":219,"../../../General/JSON/js/nixps-JSONObject.js":28,"../../Asset/js/nixps-File.js":39}],41:[function(require,module,exports){
"use strict";

var JSONObject = require("../../../General/JSON/js/nixps-JSONObject.js");
var Jacket = function Jacket(pJSON) {
  this.jsonObject(pJSON);
};
Jacket.prototype = Object.assign({}, JSONObject.prototype, {
  constructor: Jacket,
  jsonObject: JSONObject
});
module.exports = Jacket;

},{"../../../General/JSON/js/nixps-JSONObject.js":28}],42:[function(require,module,exports){
"use strict";

var DataService = require("../../../General/Data/js/nixps-DataService.js");
var Jacket = require("./nixps-Jacket.js");
var WorkableService = require("./nixps-WorkableService.js");
var JacketService = function JacketService(pID, pName) {
  this.dataService();
  this.jacket = new Jacket({
    id: pID,
    name: pName
  });
  this.polling = false;
  this.workableServices = [];
};
JacketService.prototype = Object.assign({}, DataService.prototype, {
  constructor: JacketService,
  dataService: DataService,
  addWorkable: function addWorkable(pWorkable) {
    if (pWorkable instanceof WorkableService === false) {
      throw new Error("Not instance of Workable!");
    }
    if (this.workableServices.some(function (pItem) {
      pItem.workable.id === pWorkable.workable.id;
    }) === false) {
      this.workableServices.push(pWorkable);
    }
  },
  getOverview: function getOverview() {
    var that = this;
    this.retrieveData("api_async.hub.get_overview", [["_id", "equal to", this.jacket_id], "", function (pResult) {
      if (pResult.entries.length > 0) {
        that.jacket = new Jacket(pResult.entries[0]);
        that.trigger("overview", that.json);
      } else {
        that.trigger("error", {
          error: "No jacket found!"
        });
      }
    }], false, -1, "hubgetoverviewjackets");
  }
});
module.exports = JacketService;

},{"../../../General/Data/js/nixps-DataService.js":22,"./nixps-Jacket.js":41,"./nixps-WorkableService.js":46}],43:[function(require,module,exports){
"use strict";

var JSONObject = require("../../../General/JSON/js/nixps-JSONObject.js");
var Whitepaper = function Whitepaper(pJSON) {
  this.jsonObject(pJSON);
};
Whitepaper.prototype = Object.assign({}, JSONObject.prototype, {
  constructor: Whitepaper,
  jsonObject: JSONObject
});
module.exports = Whitepaper;

},{"../../../General/JSON/js/nixps-JSONObject.js":28}],44:[function(require,module,exports){
"use strict";

var RefreshService = require("../../../General/Refresh/js/nixps-RefreshService.js");
var FormUtilities = require("../../../General/Utilities/js/nixps-FormUtilities.js");
var DataService = require("../../../General/Data/js/nixps-DataService.js");
var JacketService = require("./nixps-JacketService.js");
var WorkableService = require("./nixps-WorkableService.js");
var Jacket = require("./nixps-Jacket.js");
var Whitepaper = require("./nixps-Whitepaper.js");
var mUploadID = 0;
var WhitepaperService = function WhitepaperService(pWhitepaperName, pWhitepaperInputName, pTimeout) {
  this.dataService();
  if (pTimeout === undefined) {
    pTimeout = 15;
  }
  this.whitepaper = new Whitepaper({
    name: pWhitepaperName,
    inputName: pWhitepaperInputName
  });
  this.timeout = pTimeout;
  this.finishedWhen = WhitepaperService.ON_DONE;
  this.jacketService = new JacketService();
  this.form;
  this.alive = true;
  this.first = true;
  this.running = false;
};
WhitepaperService.ON_DONE = 0;
WhitepaperService.ON_WIZARD_END = 1;
WhitepaperService.ON_PROGRESS_END = 2;
WhitepaperService.prototype = Object.assign({}, DataService.prototype, {
  constructor: WhitepaperService,
  dataService: DataService,
  validateArgumentPoll: function validateArgumentPoll(pPoll) {
    if (pPoll === undefined) {
      return "overview";
    }
    return pPoll;
  },
  "new": function _new() {
    this.jacketService = new JacketService();
    this.form = undefined;
    this.alive = true;
    this.running = false;
  },
  getForm: function getForm() {
    var that = this;
    if (this.form === undefined) {
      this.retrieveData("api_async.hub.get_whitepaper_input_options", [this.whitepaper.name, this.whitepaper.inputName, function (pOptions) {
        that._triggerForm(pOptions);
      }, function (pError) {
        that.alive = false;
        that.trigger("error", pError);
      }], false, -1, "getwhitepaperinputoptions");
    } else {
      this._trigger("form", this.form);
    }
  },
  uploadFile: function uploadFile(pFormData, pHeaders) {
    var that = this;
    var uploadId = ++mUploadID;
    var files = pFormData.getAll("file");
    var fileNames = files.map(function (pFile) {
      return pFile.name;
    });
    var totalLength = files.reduce(function (pAcc, pFile) {
      pAcc += pFile.length | pFile.size | 0;
      return pAcc;
    }, 0);
    var uploadXhr;
    var session = '';
    if (api_util.get_session() !== undefined) {
      session = "&session=" + api_util.get_session();
    }
    var request = {
      url: "/portal.cgi?hub=upload_file&whitepaper_name=" + this.whitepaper.name + "&input_name=" + this.whitepaper.inputName + session,
      type: "POST",
      data: pFormData,
      processData: false,
      contentType: false,
      success: function success(pResponse) {
        var response = JSON.parse(pResponse);
        that.trigger("uploaddone", {
          id: uploadId,
          files: response.files,
          xhr: uploadXhr
        });
      },
      error: function error(pError) {
        if (pError.statusText === "abort") {
          that.trigger("uploadabort", {
            id: uploadId,
            files: fileNames,
            xhr: uploadXhr
          });
        }
      },
      xhr: function xhr() {
        var xhr = $.ajaxSettings.xhr();
        xhr.upload.onprogress = function (event) {
          that.trigger("uploadprogress", {
            id: uploadId,
            files: fileNames,
            lengthComputable: event.lengthComputable,
            loaded: event.loaded,
            total: event.total,
            xhr: uploadXhr
          });
        };
        return xhr;
      }
    };
    if (pHeaders !== undefined) {
      request.beforeSend = function (xhr) {
        for (var i = 0, len = pHeaders.length; i < len; i++) {
          xhr.setRequestHeader(pHeaders[i].header, pHeaders[i].value);
        }
      };
    }
    uploadXhr = $.ajax(request);
    this.trigger("uploadstart", {
      id: uploadId,
      files: fileNames,
      total: totalLength,
      xhr: uploadXhr
    });
  },
  wait: function wait(pOptions, pFiles, pInterval) {
    var that = this;
    var refresh = new RefreshService();
    var wait = true;
    var result;
    this.running = true;
    refresh.poll(function () {
      return $.Deferred(function (pDefer) {
        api_async.hub.get_whitepaper_input_options_data(that.whitepaper.name, that.whitepaper.inputName, pOptions, pFiles, function (pResult) {
          result = pResult;
          pDefer.resolve(pResult);
        }, function (pError) {
          pDefer.reject(pError);
        });
      });
    }, function (pPollResult, pPollRefresh) {
      wait = pPollResult.do_wait;
      return !wait;
    }, function (pError) {
      that.running = false;
      if (pError !== undefined && pError.error !== undefined) {
        that.trigger("error", pError);
      } else {
        if (wait === false) {
          that.trigger("done_waiting", result);
        } else {
          that.trigger("error", {
            error: "error",
            error_code: "unknown",
            messages: []
          });
        }
      }
    }, pInterval * 1000, true);
  },
  start: function start(pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this.running = true;
    this.first = true;
    this._send("api_async.hub.start_from_whitepaper", [], "", pPoll);
  },
  startWithVariables: function startWithVariables(pVariables, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this.running = true;
    this.first = true;
    this._send("api_async.hub.start_from_whitepaper_with_variables", [pVariables], "", pPoll);
  },
  startWithFilesAndVariables: function startWithFilesAndVariables(pFiles, pVariables, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this.running = true;
    this.first = true;
    this._send("api_async.hub.start_from_whitepaper_with_files_and_variables", [pFiles, pVariables], "", pPoll);
  },
  startWithOptions: function startWithOptions(pOptions, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this.running = true;
    this.first = true;
    this._send("api_async.hub.start_from_whitepaper_with_options", [pOptions], "", pPoll);
  },
  process: function process(pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this.running = true;
    this.first = true;
    this._send("api_async.hub.process_from_whitepaper", [this.timeout], "process", pPoll);
  },
  processWithVariables: function processWithVariables(pVariables, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this.running = true;
    this.first = true;
    this._send("api_async.hub.process_from_whitepaper_with_variables", [pVariables, this.timeout], "process", pPoll);
  },
  processWithFilesAndVariables: function processWithFilesAndVariables(pFiles, pVariables, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this.running = true;
    this.first = true;
    this._send("api_async.hub.process_from_whitepaper_with_files_and_variables", [pFiles, pVariables, this.timeout], "process", pPoll);
  },
  processWithOptions: function processWithOptions(pOptions, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this.running = true;
    this.first = true;
    this._send("api_async.hub.process_from_whitepaper_with_options", [pOptions], "process", pPoll);
  },
  "continue": function _continue(pConnector, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this._checkPolling();
    this._send("api_async.hub.continue_workable_from_kiosk", [pConnector, [], {}], "workable", pPoll);
  },
  continueWithVariables: function continueWithVariables(pConnector, pVariables, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this._checkPolling();
    this._send("api_async.hub.continue_workable_from_kiosk", [pConnector, [], pVariables], "workable", pPoll);
  },
  continueWithFilesAndVariables: function continueWithFilesAndVariables(pConnector, pFiles, pVariables, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this._checkPolling();
    this._send("api_async.hub.continue_workable_from_kiosk", [pConnector, pFiles, pVariables], "workable", pPoll);
  },
  continueWithOptions: function continueWithOptions(pConnector, pOptions, pPoll) {
    pPoll = this.validateArgumentPoll(pPoll);
    this._checkPolling();
    this._send("api_async.hub.continue_workable_from_kiosk_with_options", [pConnector, pOptions], "workable", pPoll);
  },
  _checkPolling: function _checkPolling() {
    if (this.polling === true || this.jacketService.polling === true) {
      throw new Error("WhitepaperService: cannot send variables because Service is still polling for jacket results!");
    }
  },
  _getBaseVariables: function _getBaseVariables(pCall, pType) {
    if (pType === "workable") {
      return [this.jacketService.jacket.workables[0].id, this.jacketService.jacket.workables[0].node_id];
    }
    return [this.whitepaper.name, this.whitepaper.inputName];
  },
  _send: function _send(pCall, pArgs, pType, pPoll) {
    var that = this;
    this.polling = true;
    this.retrieveData(pCall, this._getBaseVariables(pCall, pType).concat(pArgs).concat(function (pResult) {
      if (pType !== "process" || pResult.timed_out === true) {
        if (pType !== "workable") {
          that.jacketService = new JacketService(pResult.jacket_id, pResult.jacket_name);
          that.jacketService.addWorkable(new WorkableService(pResult.workable_id, pResult.workable_name));
        }
        switch (pPoll) {
          case "overview":
            that._pollOverview();
            break;
          case "httpreply":
            that._pollHttpReply();
            break;
          default:
            that.polling = false;
            that.first = false;
        }
      } else {
        that.alive = false;
        that.running = false;
        that.polling = false;
        that.first = false;
        that.trigger("finished", pResult == "null" ? null : pResult);
      }
    }, function (pError) {
      that.alive = false;
      that.trigger("error", pError);
    }), false, -1, "whitepapersend", {}, DataService.RETRIEVE.FORCE);
  },
  _pollHttpReply: function _pollHttpReply() {
    var that = this;
    var error;
    var refresh = new RefreshService();
    this.polling = true;
    refresh.poll(function () {
      return $.Deferred(function (pDefer) {
        api_async.hub.poll_for_workable_result(that.jacketService.workableServices[0].workable.id, 1, function (pResult) {
          pDefer.resolve(pResult);
        }, function (pError) {
          pDefer.reject(pError);
        });
      });
    }, function (pPollResult, pPollRefresh) {
      if (pPollResult.no_results || pPollResult.result !== undefined) {
        if (pPollResult.no_results === undefined) {
          var reply = pPollResult.result;
          if (reply.error !== undefined) {
            that.trigger("error", reply);
          } else {
            that.first = false;
            that.trigger("finished", reply == "null" ? null : reply);
          }
        } else {
          that.first = false;
          that.trigger("finished", null);
        }
        that.polling = false;
        return true;
      }
      return false;
    }, function () {
      if (error !== undefined && error.error !== undefined) {
        that.trigger("error", error);
      }
      that.polling = false;
    }, this.timeout * 1000, true);
  },
  _pollOverview: function _pollOverview() {
    var that = this;
    var refresh = new RefreshService();
    this.polling = true;
    refresh.poll(function () {
      return $.Deferred(function (pDefer) {
        api_async.hub.get_overview_with_options(["_id", "equal to", that.jacketService.jacket.id], {
          use_index: "_id_"
        }, function (pResult) {
          pDefer.resolve(pResult.entries[0]);
        }, function (pError) {
          pDefer.reject(pError);
        });
      });
    }, function (pPollResult, pPollRefresh) {
      that.jacketService.jacket = new Jacket(pPollResult);
      if (Array.isArray(that.jacketService.jacket.workables) === false || that.jacketService.jacket.workables.length === 0) {
        that._finished();
        return true;
      } else if (that.jacketService.jacket.hold_in_kiosk === true || that.jacketService.jacket.done === true) {
        if (that.jacketService.jacket.hold_in_kiosk === true) {
          if (that.jacketService.jacket.workables[0].is_wizard === true) {
            that.retrieveData("api_async.hub.get_workable_hold_options", [that.jacketService.jacket.workables[0].id, that.jacketService.jacket.workables[0].node_id, function (pOptions) {
              that.first = false;
              that.polling = false;
              that._triggerForm(pOptions);
            }, function (pError) {
              that.alive = false;
              that.polling = false;
              that.trigger("error", pError);
            }], false, -1, "whitepaperpolloverview", {}, DataService.RETRIEVE.FORCE);
          } else {
            that._finished();
          }
        } else if (that.jacketService.jacket.aborted === false && that.jacketService.jacket.state !== "error") {
          that._finished();
        } else {
          that.alive = false;
          that.polling = false;
          that.trigger("error", {
            error: "error",
            error_code: "unknown",
            messages: that.jacketService.jacket.workables[0].messages.concat("<br>")
          });
        }
        return true;
      } else if (that.jacketService.jacket.workables[0].progress != null) {
        var progress = that.jacketService.jacket.workables[0].progress;
        that.trigger("progress", progress);
        if (progress.value == 1 && this.finishedWhen === WhitepaperService.ON_PROGRESS_END) {
          that._finished();
          return true;
        }
      } else if (that.jacketService.jacket.workables[0].is_wizard === false && this.finishedWhen === WhitepaperService.ON_WIZARD_END) {
        that._finished();
        return true;
      }
      return false;
    }, function (pError) {
      if (pError !== undefined && pError.error !== undefined) {
        that.trigger("error", pError);
      }
      that.polling = false;
    }, this.timeout * 1000, 30);
  },
  _finished: function _finished() {
    this.alive = false;
    this.running = false;
    this.first = false;
    this.polling = false;
    this.trigger("finished");
  },
  _triggerForm: function _triggerForm(pOptions) {
    var upload = {
      enable_upload: pOptions.enable_upload,
      enable_file_browser: pOptions.enable_file_browser,
      upload_files_mode: pOptions.upload_files_mode,
      use_file_store_access: pOptions.use_file_store_access,
      viewable_files: pOptions.viewable_files ? pOptions.viewable_files : [],
      editable_files: pOptions.editable_files ? pOptions.editable_files : []
    };
    this.form = {
      form: {
        contents: FormUtilities.translateJSON(pOptions.options, {
          whitepaper: this.whitepaper.name,
          whitepaperInputName: this.whitepaper.inputName
        }),
        layout: pOptions.options_layout,
        localization: pOptions.options_localization,
        upload: upload
      },
      decisions: pOptions.decisions
    };
    if (pOptions.project_form !== undefined) {
      this.form["project_form"] = {
        contents: FormUtilities.translateJSON(pOptions.project_form.contents, {
          whitepaper: this.whitepaper.name,
          whitepaperInputName: this.whitepaper.inputName
        }),
        layout: pOptions.project_form.layout,
        localization: pOptions.project_form.localization,
        upload: upload
      };
    }
    this.trigger("form", this.form);
  }
});
module.exports = WhitepaperService;

},{"../../../General/Data/js/nixps-DataService.js":22,"../../../General/Refresh/js/nixps-RefreshService.js":34,"../../../General/Utilities/js/nixps-FormUtilities.js":37,"./nixps-Jacket.js":41,"./nixps-JacketService.js":42,"./nixps-Whitepaper.js":43,"./nixps-WorkableService.js":46}],45:[function(require,module,exports){
"use strict";

var JSONObject = require("../../../General/JSON/js/nixps-JSONObject.js");
var Workable = function Workable(pJSON) {
  this.jsonObject(pJSON);
};
Workable.prototype = Object.assign({}, JSONObject.prototype, {
  constructor: Workable,
  jsonObject: JSONObject
});
module.exports = Workable;

},{"../../../General/JSON/js/nixps-JSONObject.js":28}],46:[function(require,module,exports){
"use strict";

var DataService = require("../../../General/Data/js/nixps-DataService.js");
var Workable = require("./nixps-Workable.js");
var WorkableService = function WorkableService(pID, pName) {
  this.dataService();
  this.workable = new Workable({
    id: pID,
    name: pName
  });
};
WorkableService.prototype = Object.assign({}, DataService.prototype, {
  constructor: WorkableService,
  dataService: DataService
});
module.exports = WorkableService;

},{"../../../General/Data/js/nixps-DataService.js":22,"./nixps-Workable.js":45}],47:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// static hulp variables
// some not -, followed by -, some not - some not -, - and then th root name followed
// get all characters after the second "-"
var rootNameRegExp = /^[^-]*-[^-]*-(.*)$/;
var versionRegExp = new RegExp("^[0-9]+[.][0-9]+[.][0-9]+$");
var CloudflowURL = require("../../cloudflow/CloudflowUtil/js/CloudflowURL.js");
var PWAIcon = require("../../cloudflow/PWA/js/PWAIcon.js");

/**
 * @constructor CFAPP
 * @description An object representing the registry.cfapp, MARS app
 * @param {Object} pJSON configuration of the cfapp
 */
var CFApp = function CFApp(pJSON) {
  if (typeof pJSON._id === "string" && pJSON._id.length > 0) {
    this._id = pJSON._id;
  } else {
    this._id = null;
  }
  this.setName(pJSON.name);
  this.setPublicName(pJSON.public_name);
  this.setNameSpace(pJSON.namespace);
  this.setLicence(pJSON.license);
  this.setLicenseKey(pJSON.license_key);
  this.setEnvironments(pJSON.environments);
  this.setFiles(pJSON.files);
  this.setWorkflows(pJSON.workflows);
  this.setForms(pJSON.forms);
  this.setTemplates(pJSON.templates);
  this.setResources(pJSON.resources);
  this.setHooks(pJSON.hooks);
  this.setVersion(pJSON.version);
  this.setOwner(pJSON.owner);
  this.setDescription(pJSON.description);
  this.setIsOwner(pJSON.you_are_owner);
  this.setDocumentation(pJSON.documentation);
  this.setIcon(pJSON.icon);
  this.setChangeset(pJSON.changeset);
  this.setLandingPage(pJSON.landingPage);
  this.setMinCloudflowVersion(pJSON.minCloudflowVersion);
  this.setMainMenuButtons(pJSON.main_menu_buttons);
  this.setBadgeNumber(pJSON.badge_number);
  this.setPublicParameters(pJSON["public"]);
  this.setPostInstallScript(pJSON.postInstallScript);
  this.setPreRemoveScript(pJSON.preRemoveScript);
};
CFApp.fromJSON = function (json) {
  return new CFApp(json);
};
CFApp.getDefaultIcon = function () {
  return "/appsnebula/images/mars_app.svg";
};
CFApp.fromName = function (pName) {
  return api_defer.registry.cfapp.list(["name", "equal to", pName], []).then(function (pResults) {
    if (pResults !== undefined && Array.isArray(pResults.results) && pResults.results.length > 0) {
      return CFApp.fromJSON(pResults.results[0]);
    } else {
      console.error("no cfapp found");
      return Promise.reject({
        error: $.i18n._("nixps-cloudflow-appnavigator.errormessage_couldnotfoundapp", [pName]),
        error_code: "no_cfapp_found",
        message: "no cfapp found"
      });
    }
  }, function (pError) {
    console.error(pError);
    return Promise.reject(pError);
  });
};
CFApp.getNamesContaining = function (pFileName) {
  var query = [];
  if (typeof pFileName === "string" && pFileName.length > 0) {
    // remove cloudflow://
    var filename = pFileName;
    if (filename.indexOf("cloudflow://") === 0) {
      filename = filename.slice(12);
    }
    // get file store name without "/"
    var firstIndex = filename.indexOf('/');
    var fileStoreName = filename.substring(0, firstIndex);
    // remove file store
    var folderName = filename.slice(filename.indexOf('/') + 1);
    // get first rootFolderName
    var rootFolderName = folderName.substring(0, folderName.indexOf('/') + 1);
    query = ["files", "begins with", "cloudflow://" + fileStoreName + "/" + rootFolderName];
  }
  return api_defer.registry.cfapp.list(query, []).then(function (pResults) {
    var cfappNames = [];
    if (pResults !== undefined && Array.isArray(pResults.results) && pResults.results.length > 0) {
      for (var i = 0; i < pResults.results.length; i++) {
        if (Array.isArray(pResults.results[i].files) && pResults.results[i].files.length > 0) {
          var files = pResults.results[i].files;
          for (var f = 0; f < files.length; f++) {
            if (pFileName.indexOf(files[f]) === 0) {
              cfappNames.push(pResults.results[i].name);
              break;
            }
          }
        }
      }
    }
    return cfappNames;
  }, function (pError) {
    console.error(pError);
    this.reject(pError);
  });
};
CFApp.getContainingWorkflow = function (pWorkflow) {
  var query = [];
  if (typeof pWorkflow === "string" && pWorkflow.length > 0) {
    query.push("(");
    query = query.concat(["workflows", "in", [pWorkflow]]);
    query.push(")");
  }
  return api_defer.registry.cfapp.list(query, []).then(function (pResults) {
    var cfappNames = [];
    if (pResults !== undefined && Array.isArray(pResults.results) && pResults.results.length > 0) {
      for (var i = 0; i < pResults.results.length; i++) {
        cfappNames.push(new CFApp(pResults.results[i]));
      }
    }
    return cfappNames;
  }, function (pError) {
    console.error(pError);
    this.reject(pError);
  });
};

/**
 * @description Check if two jsons of two cfapps are equal or not
 * @function
 * @name CFApp.isEqual
 * @returns {Boolean} false if two apps are different
 */
CFApp.isEqual = function (pCFAppJSON_a, pCFAppJSON_b) {
  if (pCFAppJSON_a.version !== pCFAppJSON_b.version) {
    return false;
  }
  if (pCFAppJSON_a.name !== pCFAppJSON_b.name) {
    return false;
  }
  if (pCFAppJSON_a.files.length !== pCFAppJSON_b.files.length) {
    return false;
  }
  if (_.isEqual(pCFAppJSON_a.files, pCFAppJSON_b.files) === false) {
    return false;
  }
  if (pCFAppJSON_a.workflows.length !== pCFAppJSON_b.workflows.length) {
    return false;
  }
  if (_.isEqual(pCFAppJSON_a.workflows, pCFAppJSON_b.workflows) === false) {
    return false;
  }
  return true;
};
CFApp.prototype = {
  constructor: CFApp,
  getID: function getID() {
    return this._id;
  },
  _getTranslatedString: function _getTranslatedString(pValue, pLanguage) {
    if (typeof pValue === "string" && pValue.length > 0) {
      return $.i18n._(pValue);
    } else if (pValue && _typeof(pValue) === "object" && pValue.constructor && pValue.constructor.name === "Object" && Object.keys(pValue).length > 0) {
      if (typeof pValue[pLanguage] === "string") {
        return pValue[pLanguage];
      } else if (typeof pValue["en"] === "string") {
        return pValue["en"];
      }
    }
    return "";
  },
  setName: function setName(pName) {
    if (typeof pName !== "string" || pName.length <= 0) {
      throw new Error("pName must be a not empty string");
    }
    this.name = pName;
  },
  getName: function getName() {
    return this.name;
  },
  getRootName: function getRootName() {
    return this.name.replace(rootNameRegExp, "$1");
  },
  setPublicName: function setPublicName(pPublicName) {
    if (typeof pPublicName === "string" && pPublicName.length > 0) {
      this.public_name = pPublicName;
    } else {
      this.public_name = this.getRootName();
    }
  },
  getPublicName: function getPublicName() {
    return this.public_name;
  },
  setNameSpace: function setNameSpace(pNameSpace) {
    if (typeof pNameSpace === "string" && pNameSpace.length > 0) {
      this.namespace = pNameSpace;
    } else {
      this.namespace = undefined;
    }
  },
  getNameSpace: function getNameSpace() {
    return this.namespace;
  },
  setLicence: function setLicence(pLicense) {
    if (typeof pLicense === "string" && pLicense.length > 0) {
      this.license = pLicense;
    } else {
      this.license = "";
    }
  },
  getLicense: function getLicense() {
    return this.license;
  },
  setLicenseKey: function setLicenseKey(pLicenseKey) {
    if (typeof pLicenseKey === "string" && pLicenseKey.length > 0) {
      this.license_key = pLicenseKey;
    } else {
      this.license_key = undefined;
    }
  },
  getLicenseKey: function getLicenseKey() {
    return this.license_key;
  },
  setEnvironments: function setEnvironments(pEnvironments) {
    this.environments = undefined;
    if (Array.isArray(pEnvironments) && pEnvironments.length > 0) {
      this.environments = structuredClone(pEnvironments);
    }
  },
  getEnvironments: function getEnvironments() {
    return this.environments;
  },
  /**
   * @description check if generic objects are present in the CFAPP
   * @function
   * @name CFAPP.hasDocuments
   * @param {String} pName technical name of the documents
   * @returns {Boolean} true if there are object of type, false otherwise
   */
  hasDocuments: function hasDocuments(pName) {
    switch (pName) {
      case "workflow":
      case "whitepaper":
        return this.hasWorkflows();
      case "form":
        return this.hasForms();
      case "template":
        return this.hasTemplates();
    }
    throw new Error("unkown document type " + pName);
  },
  /**
   * @description Add a generic object to the CFAPP
   * @function
   * @name CFAPP.addDocument
   * @param {String} pName technical name of the documents
   * @param {Mixed} pObject the JSON object to add 
   * @returns {undefined}
   */
  addDocument: function addDocument(pName, pData) {
    switch (pName) {
      case "workflow":
      case "whitepaper":
        return this.addWorkflow(pData);
      case "form":
        return this.addForm(pData);
      case "template":
        return this.addTemplate(pData);
    }
    throw new Error("unkown document type " + pName);
  },
  /**
   * @description Delete a generic object of the CFAPP
   * @function
   * @name CFAPP.addDocument
   * @param {String} pName technical name of the documents
   * @param {Mixed} identifier of an object to remove 
   * @returns {undefined}
   */
  removeDocument: function removeDocument(pName, pIdentifier) {
    switch (pName) {
      case "workflow":
      case "whitepaper":
        return this.removeWorkflow(pIdentifier);
      case "form":
        return this.removeForm(pIdentifier);
      case "template":
        return this.removeTemplate(pIdentifier);
    }
    throw new Error("unkown document type " + pName);
  },
  /**
   * @description Get an array of all specific documents
   * @function
   * @name CFAPP.getDocuments
   * @param {String} pName technical name of the documents
   * @returns {Array} data
   */
  getDocuments: function getDocuments(pName) {
    switch (pName) {
      case "workflow":
      case "whitepaper":
        return this.getWorkflows();
      case "form":
        return this.getForms();
      case "template":
        return this.getTemplates();
    }
    throw new Error("unkown document type " + pName);
  },
  hasWorkflows: function hasWorkflows() {
    return Array.isArray(this.workflows) && this.workflows.length > 0;
  },
  setWorkflows: function setWorkflows(pWorkflows) {
    if (Array.isArray(pWorkflows) === false) {
      this.workflows = [];
    } else {
      this.workflows = pWorkflows.slice();
      if (window._ !== undefined) {
        this.workflows = _.uniq(this.workflows);
      }
    }
  },
  getWorkflows: function getWorkflows() {
    return this.workflows;
  },
  hasForms: function hasForms() {
    return Array.isArray(this.forms) && this.forms.length > 0;
  },
  setForms: function setForms(pForms) {
    if (Array.isArray(pForms) === false) {
      this.forms = [];
    } else {
      this.forms = pForms.slice();
      if (window._ !== undefined) {
        this.forms = _.uniq(this.forms);
      }
    }
  },
  getForms: function getForms() {
    return this.forms;
  },
  /**
   * @description add a form with a specific name
   * @function
   * @name CFApp.addForm
   * @param {String} pFormName The form to add   
   * @returns undefined 
   */
  addForm: function addForm(pFormName) {
    if (typeof pFormName !== "string" || pFormName.length <= 0) {
      throw new Error("CFApp.addForm: parameter formname must be a not empty string");
    }
    if (this.forms.includes(pFormName) === false) {
      this.forms.push(pFormName);
    }
  },
  /**
   * @description remove the form with that name out of the app list
   * @function
   * @name CFApp.removeForm
   * @param {String} pFormName the name of the form
   * @returns The name of the form or null if no form has been found with that name       
   */
  removeForm: function removeForm(pFormName) {
    if (typeof pFormName !== "string" || pFormName.length <= 0) {
      throw new Error("CFApp.removeForm: parameter formname must be a not empty string");
    }
    for (var i = 0; i < this.forms.length; i++) {
      if (this.forms[i] === pFormName) {
        return this.forms.splice(i, 1)[0];
      }
    }
    return null;
  },
  hasTemplates: function hasTemplates() {
    return Array.isArray(this.templates) && this.templates.length > 0;
  },
  setTemplates: function setTemplates(pTemplates) {
    if (Array.isArray(pTemplates) === false) {
      this.templates = [];
    } else {
      this.templates = pTemplates.slice();
      if (window._ !== undefined) {
        //3rd param is a function that defines to get unique emailtemplate objects by name
        this.templates = _.uniq(this.templates, false, function (template) {
          return template.name + template.language;
        });
      }
    }
  },
  getTemplates: function getTemplates() {
    return this.templates;
  },
  /**
   * @description add a template
   * @function
   * @name CFApp.addTemplate
   * @param {Object} pTemplateToAdd 
   * @returns undefined
   */
  addTemplate: function addTemplate(pTemplateToAdd) {
    if (this.templates.some(function (pTemplate) {
      return pTemplate.name === pTemplateToAdd.name && pTemplate.language === pTemplateToAdd.language;
    }) === false) {
      this.templates.push(pTemplateToAdd);
    }
  },
  /**
   * @description Remove all templates who has the same name
   * @function
   * @name CFapp.removeTemplate
   * @param {String} pTemplate the name of the template or the complete template object
   * @returns The removed templates, or null if no matched templates has beenfound
   */
  removeTemplate: function removeTemplate(pTemplate) {
    var nameToRemove = undefined;
    if (typeof pTemplate === "string" && pTemplate.length > 0) {
      nameToRemove = pTemplate;
    } else if (pTemplate && typeof pTemplate.name === "string" && pTemplate.name.length > 0) {
      nameToRemove = pTemplate.name;
    }
    if (typeof nameToRemove === "string" && nameToRemove.length > 0) {
      var matches = [];
      for (var i = this.templates.length - 1; i >= 0; i--) {
        if (this.templates[i].name === nameToRemove) {
          matches.push(this.templates.splice(i, 1)[0]);
        }
      }
      if (matches.length > 0) {
        return matches;
      }
    }
    return null;
  },
  containsWorkflow: function containsWorkflow(pWorkflow) {
    if (typeof pWorkflow !== "string" || pWorkflow.length <= 0) {
      throw new Error("CFApp.containsWorkflow: parameter workflow must be a not empty string");
    }
    return this.workflows.includes(pWorkflow);
  },
  addWorkflow: function addWorkflow(pWorkflow) {
    if (typeof pWorkflow !== "string" || pWorkflow.length <= 0) {
      throw new Error("CFApp.addWorkflow: parameter workflow must be a not empty string");
    }
    if (this.containsWorkflow(pWorkflow) === false) {
      this.workflows.push(pWorkflow);
    }
  },
  /**
   * @description Remove the workflow with the specific workflow name of the linked list, out of the app
   * @function
   * @name CFApp.removeWorkflow
   * @param {String} pWorkflowName 
   * @returns The returned removed workflowname, null if no form has been found to delete
   */
  removeWorkflow: function removeWorkflow(pWorkflowName) {
    if (typeof pWorkflowName !== "string" || pWorkflowName.length <= 0) {
      throw new Error("CFApp.removeWorkflow: parameter pWorkflowName must be a not empty string");
    }
    for (var i = 0; i < this.workflows.length; i++) {
      if (this.workflows[i] === pWorkflowName) {
        return this.workflows.splice(i, 1)[0];
      }
    }
    return null;
  },
  setFiles: function setFiles(pFiles) {
    if (Array.isArray(pFiles) === false) {
      this.files = [];
    } else {
      this.files = pFiles.slice();
    }
  },
  getFiles: function getFiles() {
    return this.files;
  },
  addFile: function addFile(pFile) {
    if (typeof pFile !== "string" || pFile.length <= 0) {
      throw new Error("CFApp.addFile: pFile must be a not empty string");
    }
    if (this.containsFile(pFile) === false) {
      this.files.push(pFile);
    }
  },
  /**
   * @description Remove a specific file from the cfapp model
   * @function
   * @name CFApp.removeFile
   * @param {String} pFile The file url to remove
   */
  removeFile: function removeFile(pFile) {
    if (typeof pFile !== "string" || pFile.length <= 0) {
      throw new Error("CFApp.removeFile: pFile must be a not empty string");
    }
    for (var i = 0; i < this.files.length; i++) {
      if (this.files[i] === pFile) {
        return this.files.splice(i, 1)[0];
      }
    }
    return null;
  },
  /**
   * @description Rename a specific file from the cfapp model
   * @function
   * @name CFApp.renamefile
   * @param {String} pOld The old filepath
   * @param {String} pNew The new filepath
   */
  renamefile: function renamefile(pOld, pNew) {
    if (typeof pOld !== "string" || pOld.length <= 0) {
      throw new Error("CFApp.removeFile: pOld must be a not empty string");
    }
    if (typeof pNew !== "string" || pNew.length <= 0) {
      throw new Error("CFApp.removeFile: pNew must be a not empty string");
    }
    var changed = false;
    for (var i = 0; i < this.files.length; i++) {
      if (this.files[i] === pNew) {
        changed = true;
      }
    }
    if (changed) {
      this.removeFile(pOld);
      this.addFile(pNew);
    }
    return changed;
  },
  /**
   * @description Check if a file or folder is checked inside the cfapp
   * @function
   * @name CFApp.containsFile
   * @param {String} pAssetName 
   * @returns true if the file or folder is in the cfapp, false otherwise
   */
  containsFile: function containsFile(pAssetName) {
    if (typeof pAssetName !== "string" || pAssetName.length <= 0) {
      throw new Error("CFApp.containsFile: pAssetName must be a not empty string");
    }
    // first check if file already is included?
    for (var i = 0; i < this.files.length; i++) {
      if (pAssetName.indexOf(this.files[i]) === 0) {
        return true;
      }
    }
    return false;
  },
  /**
   * @description Check if a form is included in the app
   * @function
   * @name CFApp.containsForm
   * @param {String} pFormName the name of the form
   * @returns {Boolean} true if the form is included, false otherwise
   */
  containsForm: function containsForm(pFormName) {
    if (typeof pFormName !== "string" || pFormName.length <= 0) {
      throw new Error("CFApp.containsForm: parameter pFormName must be a not empty string");
    }
    return this.forms.includes(pFormName);
  },
  /**
   * @description Are there resources or not?
   * @function
   * @name CFApp.hasResources
   * @returns {Boolean} true if there are resources
   */
  hasResources: function hasResources() {
    return Array.isArray(this.resources) && this.resources.length > 0;
  },
  /**
   * @description Set Resources
   * @function
   * @name CFApp.setResources
   * @returns {undefined} 
   */
  setResources: function setResources(pResources) {
    if (Array.isArray(pResources) === false) {
      this.resources = [];
    } else {
      this.resources = pResources.slice();
      if (window._ !== undefined) {
        this.resources = _.uniq(this.resources);
      }
    }
  },
  /**
   * @description Get Resources
   * @function
   * @name CFApp.getResources
   * @returns {Array.<string>} 
   */
  getResources: function getResources() {
    return this.resources;
  },
  /**
   * @description Are there hooks or not?
   * @function
   * @name CFApp.hasHooks
   * @returns {Boolean} true if there are hooks
   */
  hasHooks: function hasHooks() {
    return Array.isArray(this.hooks) && this.hooks.length > 0;
  },
  /**
   * @description Set hooks
   * @function
   * @name CFApp.setHooks
   * @returns {undefined} 
   */
  setHooks: function setHooks(pHooks) {
    if (Array.isArray(pHooks) === false) {
      this.hooks = [];
    } else {
      this.hooks = pHooks.slice();
      if (window._ !== undefined) {
        this.hooks = _.uniq(this.hooks);
      }
    }
  },
  /**
   * @description Get Hooks
   * @function
   * @name CFApp.getHooks
   * @returns {Array.<string>} 
   */
  getHooks: function getHooks() {
    return this.hooks;
  },
  setVersion: function setVersion(pVersion) {
    if (pVersion === undefined || pVersion === null || pVersion === "") {
      this.version = "0.0.1";
    } else if (typeof pVersion === "string" && pVersion.length >= 5) {
      this.version = pVersion;
    } else {
      throw new Error("CFApp.setVersion version has wrong interface");
    }
  },
  getVersion: function getVersion() {
    return this.version;
  },
  setMinCloudflowVersion: function setMinCloudflowVersion(pMinCloudflowVersion) {
    if (typeof pMinCloudflowVersion === "string" && pMinCloudflowVersion.length > 0) {
      if (versionRegExp.test(pMinCloudflowVersion) === false) {
        throw new Error("CFAPP: invalid minimal Cloudflow Version");
      }
      this.minCloudflowVersion = pMinCloudflowVersion;
    } else {
      this.minCloudflowVersion = null;
    }
  },
  getMinCloudflowVersion: function getMinCloudflowVersion() {
    return this.minCloudflowVersion;
  },
  hasMinCloudflowVersion: function hasMinCloudflowVersion() {
    return typeof this.minCloudflowVersion === "string" && this.minCloudflowVersion.length > 0;
  },
  setOwner: function setOwner(pOwner) {
    this.owner = pOwner;
  },
  getOwner: function getOwner() {
    return this.owner;
  },
  setDescription: function setDescription(pDescription) {
    if (typeof pDescription === "string") {
      this.description = pDescription;
    } else if (pDescription && _typeof(pDescription) === "object" && pDescription.constructor && pDescription.constructor.name === "Object" && Object.keys(pDescription).length > 0) {
      this.description = pDescription;
    } else {
      this.description = "";
    }
  },
  getDescription: function getDescription() {
    return this.description;
  },
  getTranslatedDescription: function getTranslatedDescription(pLanguage) {
    return this._getTranslatedString(this.getDescription(), pLanguage);
  },
  setIsOwner: function setIsOwner(pIsOwner) {
    if (pIsOwner === undefined || pIsOwner === null) {
      this.you_are_owner = true;
    } else if (typeof pIsOwner === "boolean") {
      this.you_are_owner = pIsOwner;
    } else {
      throw new Error("CFApp.setIsOwner you_are_owner has wrong interface");
    }
  },
  areYouOwner: function areYouOwner() {
    return this.you_are_owner === true;
  },
  setDocumentation: function setDocumentation(pDocumentation) {
    if (pDocumentation === undefined || pDocumentation === null || pDocumentation === "") {
      this.documentation = null;
    } else if (typeof pDocumentation === "string") {
      this.documentation = pDocumentation;
    } else {
      throw new Error("CFApp.setDocumentation documentation has wrong interface");
    }
  },
  getDocumentation: function getDocumentation() {
    return this.documentation;
  },
  hasDocumentation: function hasDocumentation() {
    return typeof this.documentation === "string" && this.documentation.length > 0;
  },
  setChangeset: function setChangeset(pChangeset) {
    if (pChangeset === undefined || pChangeset === null || pChangeset === "") {
      this.changeset = null;
    } else if (typeof pChangeset === "string") {
      this.changeset = pChangeset;
    } else {
      throw new Error("CFApp.setChangeset changeset has wrong interface");
    }
  },
  getChangeset: function getChangeset() {
    return this.changeset;
  },
  setIcon: function setIcon(pIcon) {
    if (pIcon === undefined || pIcon === null || pIcon === "") {
      this.icon = null;
    } else {
      this.icon = pIcon;
    }
  },
  getIcon: function getIcon() {
    return this.icon;
  },
  hasIcon: function hasIcon() {
    return typeof this.icon === "string" && this.icon.length > 0;
  },
  hasLandingPage: function hasLandingPage() {
    return typeof this.landingPage === "string" && this.landingPage.length > 0;
  },
  setLandingPage: function setLandingPage(pLandingPage) {
    if (typeof pLandingPage === "string" && pLandingPage.length > 0) {
      this.landingPage = pLandingPage;
    } else {
      this.landingPage = null;
    }
  },
  getLandingPage: function getLandingPage() {
    return this.landingPage;
  },
  getMenuButtonJSON: function getMenuButtonJSON() {
    var pWithTranslations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var link = "/";
    if (this.hasLandingPage()) {
      link = this.getLandingPage();
    }
    var text = undefined;
    if (pWithTranslations === true) {
      text = {};
      if (this.hasPublicParameters()) {
        var translations = this.getPublicParameters();
        for (var lang in translations) {
          text[lang] = translations[lang].name || translations[lang].description;
        }
      }
      if (text["en"] === undefined) {
        text["en"] = this.getDescription() || this.getRootName();
      }
    } else {
      text = this.getDescription();
      if (text === "") {
        text = this.getRootName();
      }
    }
    var image_type, icon, image_path;
    if (this.hasIcon() === true) {
      image_type = "image";
      icon = "";
      image_path = this.getIcon();
    } else {
      image_type = "classes";
      icon = "cf-icon cf-icon-mars";
      image_path = "";
    }
    var badgeNumber;
    if (this.hasBadgeNumber()) {
      badgeNumber = this.getBadgeNumber();
    }
    return {
      id: "cfapp-" + this.getName(),
      link: link,
      icon: icon,
      icon_type: image_type,
      image_path: image_path,
      selected_image_path: image_path,
      tooltip: text,
      text: text,
      classes: "",
      badge_number: badgeNumber,
      admin_only: undefined,
      license: undefined,
      user_permission: undefined
    };
  },
  getPWAManifestJSON: function getPWAManifestJSON() {
    var name = this.getRootName();
    var short_name = this.getRootName();
    var start_url;
    var description = this.getTranslatedDescription("en");
    if (this.hasLandingPage()) {
      if (CloudflowURL.isRelativePath(this.getLandingPage())) {
        start_url = this.getLandingPage();
      } else {
        var cloudflowURL = new CloudflowURL("cloudflow://PP_FILE_STORE/" + this.getRootName() + "/", this.getLandingPage(), false);
        start_url = cloudflowURL.getRelativeUploadPath();
      }
    }
    var icons;
    if (this.hasIcon() && this.icon.indexOf("cloudflow://") === 0) {
      var iconExtension = this.getIcon().substring(this.getIcon().lastIndexOf("."));
      if (PWAIcon.getSupportedExtensions().includes("." + iconExtension)) {
        icons = [{
          src: this.getIcon(),
          type: "image/" + iconExtension,
          sizes: iconExtension === "svg" ? "128x128" : undefined
        }];
      }
    }
    return {
      name: name,
      short_name: short_name,
      description: description,
      start_url: start_url,
      icons: icons
    };
  },
  hasBadgeNumber: function hasBadgeNumber() {
    return this.badge_number !== null;
  },
  hasMainMenuButtons: function hasMainMenuButtons() {
    return Array.isArray(this.main_menu_buttons) && this.main_menu_buttons.length > 0;
  },
  setMainMenuButtons: function setMainMenuButtons(pMainMenuButtons) {
    if (Array.isArray(pMainMenuButtons) && pMainMenuButtons.length > 0) {
      this.main_menu_buttons = [];
      for (var m = 0; m < pMainMenuButtons.length; m++) {
        if (pMainMenuButtons[m] && _typeof(pMainMenuButtons[m]) === "object" && Object.keys(pMainMenuButtons[m]).length > 0) {
          this.main_menu_buttons.push(pMainMenuButtons[m]);
        }
      }
    } else {
      this.main_menu_buttons = null;
    }
  },
  getMainMenuButtons: function getMainMenuButtons() {
    return this.main_menu_buttons;
  },
  setBadgeNumber: function setBadgeNumber(pBadgeNumber) {
    if (["string", "number"].includes(_typeof(pBadgeNumber))) {
      this.badge_number = pBadgeNumber;
    } else if (_typeof(pBadgeNumber) === "object" && !Array.isArray(pBadgeNumber)) {
      this.badge_number = structuredClone(pBadgeNumber);
    } else {
      this.badge_number = null;
    }
  },
  getBadgeNumber: function getBadgeNumber() {
    return this.badge_number;
  },
  setPublicParameters: function setPublicParameters(pPublic) {
    if (pPublic && _typeof(pPublic) === "object") {
      this["public"] = structuredClone(pPublic);
    } else {
      this["public"] = null;
    }
  },
  getPublicParameters: function getPublicParameters() {
    return this["public"];
  },
  hasPublicParameters: function hasPublicParameters() {
    return this["public"] !== null && _typeof(this["public"]) === "object";
  },
  setPostInstallScript: function setPostInstallScript(pInstallScript) {
    if (typeof pInstallScript === "string" && pInstallScript.length > 0) {
      this.postInstallScript = pInstallScript;
    } else {
      this.postInstallScript = null;
    }
  },
  getPostInstallScript: function getPostInstallScript() {
    return this.postInstallScript;
  },
  hasPostInstallScript: function hasPostInstallScript() {
    return typeof this.postInstallScript === "string" && this.postInstallScript.length > 0;
  },
  setPreRemoveScript: function setPreRemoveScript(pRemoveScript) {
    if (typeof pRemoveScript === "string" && pRemoveScript.length > 0) {
      this.preRemoveScript = pRemoveScript;
    } else {
      this.preRemoveScript = null;
    }
  },
  getPreRemoveScript: function getPreRemoveScript() {
    return this.preRemoveScript;
  },
  hasPreRemoveScript: function hasPreRemoveScript() {
    return typeof this.preRemoveScript === "string" && this.preRemoveScript.length > 0;
  },
  updateToBackend: function updateToBackend() {
    if (this._id === null) {
      throw new Error("Could not save because we missing an _id");
    }
    return api_defer.registry.cfapp.update(this.toJSON())["catch"](function (pError) {
      console.error(pError);
      return Promise.reject(pError);
    });
  },
  updateFromBackend: function updateFromBackend() {
    if (this._id !== null) {
      var that = this;
      return api_defer.registry.cfapp.get(this._id).then(function (pJSON) {
        that = CFApp.fromJSON(pJSON);
      });
    } else {
      return CFApp.fromName(this.getName());
    }
    /** 
     * @todo 
     * **/
  },

  clone: function clone() {
    return CFApp.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var output = {
      _id: this._id,
      name: this.name,
      files: this.files,
      workflows: this.workflows,
      forms: this.forms,
      templates: this.templates,
      resources: this.resources,
      hooks: this.hooks,
      version: this.version,
      owner: this.owner,
      description: this.description,
      you_are_owner: this.you_are_owner,
      icon: ""
    };
    if (this.documentation !== null) {
      output.documentation = this.documentation;
    }
    if (typeof this.namespace === "string") {
      output.namespace = this.namespace;
    }
    if (typeof this.license === "string") {
      output.license = this.license;
    }
    if (typeof this.license_key === "string") {
      output.license_key = this.license_key;
    }
    if (Array.isArray(this.environments)) {
      output.environments = this.environments.slice();
    }
    if (this.icon !== null) {
      output.icon = this.icon;
    }
    if (this.changeset !== null) {
      output.changeset = this.changeset;
    }
    if (this.hasLandingPage()) {
      output.landingPage = this.getLandingPage();
    }
    if (this.hasMinCloudflowVersion()) {
      output.minCloudflowVersion = this.getMinCloudflowVersion();
    }
    if (this.hasBadgeNumber()) {
      if (_typeof(this.getBadgeNumber()) === "object" && this.getBadgeNumber() !== null) {
        output.badge_number = structuredClone(this.getBadgeNumber());
      } else {
        output.badge_number = this.getBadgeNumber();
      }
    }
    if (this.main_menu_buttons !== null) {
      output.main_menu_buttons = this.main_menu_buttons;
    }
    if (typeof this.public_name === "string" && this.public_name !== this.getRootName()) {
      output.public_name = this.public_name;
    }
    if (this.hasPublicParameters()) {
      output["public"] = this.getPublicParameters();
    }
    if (this.hasPostInstallScript()) {
      output.postInstallScript = this.getPostInstallScript();
    }
    if (this.hasPreRemoveScript()) {
      output.preRemoveScript = this.getPreRemoveScript();
    }
    return output;
  }
};

/*****************
 * more generic 
 ****************/

CFApp.changeNameWorkflow = function (pOldName, pNewName) {
  if (typeof pOldName === "string" && typeof pNewName === "string" && pOldName.length > 0 && pNewName.length > 0) {
    // get all workflows where the workflow is listed
    api_async.registry.cfapp.list(["workflows", "in", [pOldName]], [], function (pResults) {
      if (pResults !== undefined && Array.isArray(pResults.results)) {
        // loop over all workflows, change and update to backend
        // in most cases the results.length === 1
        for (var i = 0; i < pResults.results.length; i++) {
          var workflowIndex = -1;
          if (Array.isArray(pResults.results[i].workflows)) {
            workflowIndex = pResults.results[i].workflows.indexOf(pOldName);
          }
          if (typeof workflowIndex === "number" && workflowIndex >= 0) {
            pResults.results[i].workflows[workflowIndex] = pNewName;
            api_async.registry.cfapp.update(pResults.results[i]);
          }
        }
      }
    }, function (pError) {
      console.error(pError);
    });
  }
};
module.exports = CFApp;

},{"../../cloudflow/CloudflowUtil/js/CloudflowURL.js":80,"../../cloudflow/PWA/js/PWAIcon.js":199}],48:[function(require,module,exports){
"use strict";

var CloudflowURL = require("../../cloudflow/CloudflowUtil/js/CloudflowURL.js");
var ValueComposerUtil = require("../../cloudflow/ExpressionBuilder/js/ValueComposerUtil.js");
var resourceTypes = require("./resourceTypes.js");
var kFullURLRegExp = new RegExp("[:][0-9]+[/]portal[.]cgi[/](.*)");
var kFroozenExpressionRegExp = new RegExp('^<expression>.+</expression>$');
var ResourceProcessUtil = {
  process: function process(pResources, pRelativeBasePath, pAcceptInternals) {
    var outputResources = [];
    for (var i = 0; i < pResources.length; i++) {
      if (pResources[i] && typeof pResources[i].resource_type === "string") {
        var resource = $.extend(true, {}, pResources[i]);
        if (resource.resource_type === resourceTypes.PAGE) {
          var standardURL = this._checkFileURL(resource.url, pRelativeBasePath, pAcceptInternals);
          if (typeof standardURL === "string") {
            resource.url = standardURL;
            outputResources.push(resource);
          }
        } else if (resource.resource_type === resourceTypes.WORKFLOW) {
          var standardWorkflowName = this._checkWhitepaperName(resource.workflow_name);
          var standardWorkflowInputName = this._checkWhitepaperName(resource.workflow_input_name);
          if (typeof standardWorkflowName === "string" && typeof standardWorkflowInputName === "string") {
            resource.workflow_name = standardWorkflowName;
            resource.workflow_input_name = standardWorkflowInputName;
            outputResources.push(resource);
          }
        }
      } else {
        console.error("_postHandleResources: resource found with missing resource_type", pResources[i]);
      }
    }
    return outputResources;
  },
  _checkFileURL: function _checkFileURL(pFile, pRelativeBasePath, pAcceptInternals) {
    if (typeof pFile === "string" && kFroozenExpressionRegExp.test(pFile)) {
      try {
        pFile = JSON.parse(pFile.substring(12).slice(0, -13));
      } catch (e) {}
    }
    if (typeof pFile === "string" && pFile.length > 0) {
      if (pAcceptInternals === false) {
        if (pFile.indexOf('/portal.cgi?') >= 0) {
          // do not process own private links
          return;
        }
        if (pFile.indexOf("https://localhost:") === 0 || pFile.indexOf("http://localhost:") === 0 || pFile.indexOf("https://127.0.0.1:") === 0 || pFile.indexOf("http://127.0.0.1:") === 0) {
          // try to filter out the real pb pages
          var result = kFullURLRegExp.exec(pFile);
          if (Array.isArray(result) && result.length === 2) {
            if (typeof result[1] === "string" && result[1].indexOf("__CloudflowApps/") === 0) {
              // do not process own private links
              return;
            }
            // the url is a real pp_file_store file
            pFile = "cloudflow://" + result[1];
          } else {
            // do not process own private links
            return;
          }
        }
      } else {
        if (pFile.indexOf("https://localhost:") === 0 || pFile.indexOf("http://localhost:") === 0 || pFile.indexOf("https://127.0.0.1:") === 0 || pFile.indexOf("http://127.0.0.1:") === 0) {
          // try to filter out the real pb pages
          var result = kFullURLRegExp.exec(pFile);
          if (Array.isArray(result) && result.length === 2) {
            // the url is a real pp_file_store file
            pFile = "cloudflow://" + result[1];
          }
        }
      }
      if (pFile === "?") {
        return pFile;
      }
      if (pFile[pFile.length - 1] !== "/") {
        // if not a folder, check filename
        var filename = pFile.substring(pFile.lastIndexOf("/") + 1);
        if (typeof filename === "string" && filename.length > 0 && filename.indexOf('.') === -1) {
          console.warn("file " + pFile + " found without extention");
          return;
        }
      }
      // cut of all arguments of urls
      var argumIndex = pFile.indexOf(".html?");
      if (argumIndex > 0) {
        pFile = pFile.substring(0, argumIndex + 5 /*length of .html*/);
      }
      // cut of all hash of urls
      var hashIndex = pFile.indexOf("#");
      if (hashIndex > 0) {
        pFile = pFile.substring(0, hashIndex);
      }
      var cloudflowURL = new CloudflowURL(pRelativeBasePath, pFile);
      return cloudflowURL.getCloudflowPath();
    } else if (Array.isArray(pFile) && pFile.length > 0) {
      var valueComposerStringify = this.transformValueComposerToString(pFile);
      if (typeof valueComposerStringify === "string" && valueComposerStringify.length > 0) {
        return this._checkFileURL(valueComposerStringify, pRelativeBasePath, pAcceptInternals);
      } else {
        return this._getValeComposerRepresentation(pFile);
      }
    }
  },
  _checkWhitepaperName: function _checkWhitepaperName(pWhitepaperName) {
    if (typeof pWhitepaperName === "string" && kFroozenExpressionRegExp.test(pWhitepaperName)) {
      try {
        pWhitepaperName = JSON.parse(pWhitepaperName.substring(12).slice(0, -13));
      } catch (e) {}
    }
    if (typeof pWhitepaperName === "string" && pWhitepaperName.length > 0) {
      return pWhitepaperName;
    } else if (Array.isArray(pWhitepaperName) && pWhitepaperName.length > 0) {
      var valueComposerStringify = this.transformValueComposerToString(pWhitepaperName);
      if (typeof valueComposerStringify === "string" && valueComposerStringify.length > 0) {
        return this._checkWhitepaperName(valueComposerStringify);
      } else {
        return this._getValeComposerRepresentation(pWhitepaperName);
      }
    }
  },
  /**
   * @description Get the string where the value composer is equal to, otherwise return null
   * @function
   * @name ResourceProcessUtil.transformValueComposerToString
   * @param {Array.<Object>} pValueComposer The value composer to evaluate
   * @returns a string if the equal, otherwise null
   */
  transformValueComposerToString: function transformValueComposerToString(pValueComposer) {
    return ValueComposerUtil.convertToString(pValueComposer);
  },
  _getValeComposerRepresentation: function _getValeComposerRepresentation(pValueComposer) {
    return "?";
  }
};
module.exports = ResourceProcessUtil;

},{"../../cloudflow/CloudflowUtil/js/CloudflowURL.js":80,"../../cloudflow/ExpressionBuilder/js/ValueComposerUtil.js":114,"./resourceTypes.js":49}],49:[function(require,module,exports){
"use strict";

/**
 * Enum for resource types
 * @readonly
 * @enum {String}
 */
module.exports = Object.freeze({
  /** an (html) page, possible a pagebuilder page */
  "PAGE": "page",
  /** a workflow */
  "WORKFLOW": "workflow"
});

},{}],50:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/
/*globals $, _, jsPlumb, console, api_sync, window, api_async */

/**
 * @namespace nixps-cloudflow.ActivityBar
 * @description This is the activitybar, that should be possition unther the CloudflowBar. <br />
 * This bar contains a go back arrow and some activity buttons. You must add the buttons yourself.<br /> 
 * To layout your buttons add the class "activityIcon" to this button
 * @example $('#ActivityBar').ActivityBar({
 *  "title": "custom page application"
 * });
 * @version 1.2.0
 * @deprecated Since 20.04 we will not support this component. In Nebula we use the {@link nixps-cloudflow.TopBar} as replacement of this.
 */
$.widget('nixps-cloudflow.ActivityBar', {
  version: "1.2.0",
  options: {
    /**
     * @desc True if you want to see the go back button
     * @name nixps-cloudflow.ActivityBar#enableGoBackButton
     * @type {Boolean}
     * @default true
     */
    enableGoBackButton: true,
    /**
     * @desc The title to show
     * @name nixps-cloudflow.ActivityBar#title
     * @type {string}
     * @default "Flows" 
     */
    title: 'Flows',
    /**
     * @description The icon that must be shown.
     * @name nixps-cloudflow.ActivityBar#icon
     * @type HTML
     * @default null
     */
    icon: null,
    /**
     * @description Must we enable and see the minimise button
     * @name nixps.cloudflow.ActivityBar#enableCollapsable
     * @type {boolean}
     * @default false
     */
    enableCollapsable: false,
    /**
     * @desc The function runs when user press goBack button.
     * @name nixps-cloudflow.ActivityBar#goBack
     * @type {function}
     * @default function() {
        window.history.back();
    }
     */
    goBack: function goBack() {
      window.history.back();
    },
    /**
     * @name nixps-cloudflow.ActivityBar#style_type
     * @description The type of style you want
     * @type {String}
     * @private
     * @since 1.1.1
     */
    style_type: "default",
    /**
     * @name nixps-cloudflow.ActivityBar#buttons
     * @description The buttons who will be added from the right to the left on the bar
     * @type {Array}
     * @default []
     * @since 1.2.0
     */
    buttons: [],
    created: function created() {}
  },
  _create: function _create() {
    this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type);

    // add goback button
    if (this.options.enableGoBackButton === true) {
      var goBackButton = $('<div>').addClass('goBackButton leftDarkButton').append($('<span>').addClass('goBackArrow').html('&#x2190;'));
      this.element.append(goBackButton);
    }
    if (this.options.enableCollapsable === true) {
      var closeButton = $('<div>').addClass('closeButton').append($('<div>').addClass('closeIcon').load('/cloudflow/ActivityBar/css/mini.svg'));
      this.element.append(closeButton);
      var openButton = $('<div>').addClass('openButton leftDarkButton').append($('<div>').addClass('openIcon').load('/cloudflow/ActivityBar/css/mini.svg'));
      this.element.append(openButton);
    }
    // add icon
    this.element.append(this._makeIcon());

    // add activity title
    var activityTitle = $('<span>').addClass('activityTitle').text(this.options.title);
    this.element.append(activityTitle);
    this._drawButtons();
    this._on(this.element, {
      'click .goBackButton': this._goBackClickHandler,
      'click .openButton': this._openBarClickHandler,
      'click .closeButton': this._closeBarClickHandler
    });
    var img = this.element.find("img");
    if (img.length === 1) {
      var that = this;
      img.one("error", function () {
        that.options.created();
      }).one("load", function () {
        that.options.created();
      });
    } else {
      this.options.created();
    }
  },
  /**
   * @desc function runs when user click on the go back button
   * @function 
   * @private
   * @name nixps-cloudflow.ActivityBar#_goBackClickHandler
   * @param {type} pEvent
   * @param {type} pData
   * @returns {undefined}
   */
  _goBackClickHandler: function _goBackClickHandler(pEvent, pData) {
    this._trigger('goBack', pEvent, {});
  },
  /**
   * @description this function runs when user press on the go open button
   * @private
   * @name nixps-cloudflow.ActivityBar#_openBarClickHandler
   * @param {object} pEvent
   * @param {object} pData
   * @returns {undefined}
   */
  _openBarClickHandler: function _openBarClickHandler(pEvent, pData) {
    this._trigger('open', null, {});
    this.open();
  },
  /**
   * @description this function runs when user press hte close button
   * @private
   * @name nixps-cloudflow.ActivityBar#_closeBarClickHandler
   * @param {object} pEvent
   * @param {object} pData
   * @returns {undefined}
   */
  _closeBarClickHandler: function _closeBarClickHandler(pEvent, pData) {
    this._trigger('close', null, {});
    this.close();
  },
  _draw: function _draw() {
    if (this.options.enableGoBackButton === true) {
      this.element.find('.goBackButton').show();
    } else {
      this.element.find('.goBackButton').hide();
    }
    if (typeof this.options.title === "string") {
      this.element.find('.activityTitle').text(this.options.title);
    }
  },
  /**
   * @description draw buttons on the bar, from right to left.
   * @function
   * @private
   * @name nixps-cloudflow.ActivityBar#_drawButtons
   * @return {undefined}
   */
  _drawButtons: function _drawButtons() {
    this.element.find(".activityOptionsButton").remove(); // remove only those buttons added by the options
    if (Array.isArray(this.options.buttons) && this.options.buttons.length > 0) {
      var onclick;
      var classes = "";
      var content = "";
      var action = "";
      var tooltip = "";
      for (var i = 0; i < this.options.buttons.length; i++) {
        onclick = undefined;
        classes = "activityOptionsButton ";
        content = "";
        action = "";
        tooltip = undefined;
        if (typeof this.options.buttons[i].classes === "string") {
          classes += this.options.buttons[i].classes;
        }
        if (typeof this.options.buttons[i].action === "string" && this.options.buttons[i].action.length > 0) {
          action = this.options.buttons[i].action;
        }
        if (typeof this.options.buttons[i].tooltip === "string" && this.options.buttons[i].tooltip.length > 0) {
          tooltip = this.options.buttons[i].tooltip;
        }
        if (typeof this.options.buttons[i].onclick === "function") {
          onclick = this.options.buttons[i].onclick;
        } else if (typeof this.options.buttons[i].onclick === "string" && this.options.buttons[i].onclick.length > 0) {
          onclick = this.options.buttons[i].onclick;
        }
        if (this.options.buttons[i].content !== undefined) {
          content = this.options.buttons[i].content;
        } else {
          content = $('<span>');
          if (typeof this.options.buttons[i].icon === "string") {
            content.append($('<span>').addClass(this.options.buttons[i].icon));
          }
          if (typeof this.options.buttons[i].label === "string") {
            content.append($('<span>').text(this.options.buttons[i].label));
          }
        }
        this.addButton(content, classes, onclick, action, tooltip);
      }
    }
  },
  _makeIcon: function _makeIcon() {
    var icon = $('<div>').addClass('activityIcon');
    if (this.options.icon !== null && this.options.icon !== "") {
      if (typeof this.options.icon === "string" && this.options.icon.length > 2) {
        this.options.icon = this.options.icon.trim();
        if (this.options.icon[0] === "<" && this.options.icon[this.options.icon.length - 1] === ">") {
          // option decide which type
          icon = $(this.options.icon).addClass('activityIcon');
        } else {
          // option has no type, we suppose it is a url
          icon = $("<img>").attr("src", this.options.icon).addClass('activityIcon');
        }
      } else {
        icon = $(this.options.icon).addClass('activityIcon');
      }
    }
    return icon;
  },
  open: function open() {
    this.element.removeClass('collapsed');
  },
  close: function close() {
    this.element.addClass('collapsed');
  },
  isOpen: function isOpen() {
    return !this.element.hasClass('collapsed');
  },
  /**
   * @description Add a button to the right corner of the bar. If multiple buttons are there it will add to the left side of the other buttons.
   * <br /> Feel free to modify the button by the classes you give.
   * @function
   * @name nixps-cloudflow.ActivityBar#addButton
   * @param {HTML} pButtonContent The text (and icon) to be show in the button
   * @param {String} pButtonClasses The class names separated by space that will be added at the top level of the button
   * @param {function} pOnClickFunction This function will be called when user click on the button
   * @param {String} pActionAttribute The attribute to be added to the data-action attribute
   * @param {String} pTooltip The tooltip, text to be show when the mouse go hover it.
   * @example $("#activityBar").ActivityBar("addButton", "view", "", function(pEvent, pData) {
                      console.log("clicked");
                  })
   * @return {undefined}
   * @since 1.1.0
   */
  addButton: function addButton(pButtonContent, pButtonClasses, pOnClickFunction, pActionAttribute, pToolTip) {
    if (typeof pButtonClasses !== "string") {
      throw new Error("parameter pButtonClasses must be a string");
    }
    var button = $('<span>').addClass("activityButton").addClass(pButtonClasses).append(pButtonContent);
    if (typeof pOnClickFunction === "function") {
      button.click(pOnClickFunction);
    } else if (typeof pOnClickFunction === "string" && pOnClickFunction.length > 0) {
      button.click({
        url: pOnClickFunction
      }, function (pEvent) {
        if (pEvent !== undefined && pEvent.data !== undefined && typeof pEvent.data.url === "string") {
          window.location = pEvent.data.url;
        }
      });
    }
    if (typeof pActionAttribute === "string" && pActionAttribute.length > 0) {
      button.attr("data-action", pActionAttribute);
    }
    if (typeof pToolTip === "string" && pToolTip.length > 0) {
      button.attr("title", pToolTip);
    }
    this.element.append(button);
  },
  _setOption: function _setOption(key, value) {
    if (key === "icon" && value !== this.options.icon) {
      this._super(key, value);
      this.element.children('.activityIcon').replaceWith(this._makeIcon());
    } else if (key === "buttons") {
      this._super(key, value);
      this._drawButtons();
    } else {
      this._super(key, value);
      this._draw();
    }
  },
  _destroy: function _destroy() {
    this._super();
  }
});

},{}],51:[function(require,module,exports){
"use strict";

/* .
 * 
 *   created by guillaume on May 31, 2019
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  require("../../../cloudflow/IconView/js/nixps-cloudflow-IconView.js");
  var Device = require("../../PWA/js/Device.js");

  /**
   * @namespace nixps-asset.MyApprovals
   * @description Draw all my approvals
   * @version 1.0.0
   */
  $.widget("nixps-asset.MyApprovals", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "myapprovals",
    options: {
      /**
       * @name nixps-asset.MyApprovals#user
       * @description The email of the user we want to see
       * @type {String}
       * @default null
       */
      email: null,
      /**
       * @name nixps-asset.MyApprovals#classes
       * @description customise classes to be append to main panel
       * @type {Object}
       * @default ""
       */
      classes: {},
      /**
       * @name nixps-asset.MyApprovals#clickActionName
       * @description The name of the action runs when user clicked on a icon, set null to use default redirect action
       * @type {String}
       * @default null
       */
      clickActionName: null,
      /**
       * @name nixps-asset.MyApprovals#refreshRate 
       * @description The refresh delay between two draws in milliseconds
       * @type {Number}
       * @default 10000
       */
      refreshRate: 10000,
      /**
       * @name nixps-asset.MyApprovals#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       */
      style_type: "default",
      /**
       * @name nixps-asset.MyApprovals#created
       * @private
       * @description function runned when component is done created
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description create the component
     * @name nixps-asset.MyApprovals#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      // variables
      this.refreshTimerID;
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type);

      // draw skeleton
      var iconPanel = $('<div>');
      this.element.append(iconPanel);
      if (typeof this._addClass === "function") {
        this._addClass(iconPanel, "myapprovals_iconpanel");
      } else {
        // for jquery UI < 1.12
        iconPanel.addClass("myapprovals_iconpanel");
        if (this.options.classes !== undefined && typeof this.options.classes["myapprovals_iconpanel"] === "string") {
          iconPanel.addClass(this.options.classes["myapprovals_iconpanel"]);
        }
      }
      this.element.children(".myapprovals_iconpanel").IconView({
        enableSelecting: false,
        enableMultipleSelection: true,
        showDownloadIcon: false,
        iconWidth: Device.hasMobileWidth() ? 96 : 150,
        stepSize: 200
      });
      var that = this;
      $.when(this._draw()).always(function () {
        that.options.created();
      });
      this._on(this.element, {
        "iconviewopen": this._iconClickHandler
      });
    },
    /**
     * @description function runs when user clicked on a icon
     * @function
     * @name nixps-asset.MyApprovals#_iconClickHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _iconClickHandler: function _iconClickHandler(pEvent, pData) {
      if (pData && pData.cloudflow && typeof pData.cloudflow.file === "string" && pData.cloudflow.file.length > 0) {
        if (typeof this.options.clickActionName === "string" && this.options.clickActionName.length > 0) {
          // let the parent decide what to do, in pagebuilder context
          var eventData = {
            "id": pData._id,
            "file_url": pData.cloudflow.file
          };
          this._trigger(this.options.clickActionName, pEvent, eventData);
        } else {
          // default behavior
          window.location = "/portal.cgi?asset=" + encodeURIComponent(pData.cloudflow.file) + "&sub=";
        }
      }
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps-asset.MyApprovals#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-asset.MyApprovals#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      var query = ["iterations.assessment", "equal to", "pending", "and", "iterations.participants.email_address", "equal to", this.options.email];
      return $.Deferred(function (pDefer) {
        api_async.approval.list_with_options(query, [], ["iterations", "references"], {
          maximum: 350
        }, function (pResults) {
          var assetURLs = [];
          if (Array.isArray(pResults.results) && pResults.results.length > 0) {
            for (var countEntries = 0; countEntries < pResults.results.length; ++countEntries) {
              var approvalEntry = pResults.results[countEntries];
              var approvalIteration = approvalEntry.iterations[approvalEntry.iterations.length - 1];
              if (approvalIteration.assessment === "pending") {
                // the last entry is pending indeed
                for (var countParticipants = 0; countParticipants < approvalIteration.participants.length; ++countParticipants) {
                  var participant = approvalIteration.participants[countParticipants];
                  if (participant.email_address === that.options.email) {
                    for (var countReferences = 0; countReferences < approvalEntry.references.length; ++countReferences) {
                      if (assetURLs.indexOf(approvalEntry.references[countReferences]) === -1) {
                        assetURLs.push(approvalEntry.references[countReferences]);
                      }
                    }
                  }
                }
              }
            }
          }
          if (assetURLs.length !== 0) {
            api_async.asset.list_with_options(["cloudflow.part", "in", assetURLs], [], ["url", "sub", "cloudflow", "thumb", "approvals", "modtime", "filetype"], {
              "maximum": 200
            }, function (pResults) {
              that.element.children(".myapprovals_iconpanel").IconView("option", "files", pResults.results);
              that._tiggerTimer();
              pDefer.resolve(pResults.results);
            }, pDefer.reject);
          } else {
            that._tiggerTimer();
            pDefer.resolve([]);
          }
        }, function (pError) {
          pDefer.reject(pError);
        });
      });
    },
    _tiggerTimer: function _tiggerTimer() {
      clearTimeout(this.refreshTimerID);
      if (this.options.refreshRate > 3000) {
        this.refreshTimerID = this._delay(function () {
          if (Device.continuePolling(this.uuid) && this.element.is(":visible")) {
            this._draw();
          } else {
            this._tiggerTimer();
          }
        }, Device.getPollingFactor(this.uuid) * this.options.refreshRate);
      }
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-asset.MyApprovals#_setOptions
     */
    _setOptions: function _setOptions(pOptions) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.refreshRate !== "number") {
        throw new Error("MyApprovals: input option refreshRate must be a number");
      }
      if (this.options.refreshRate > 0 && this.options.refreshRate < 3000) {
        console.warn("MyApproval refresh rates smaller then 3000ms will be ignored");
      }
      if (typeof this.options.style_type !== "string" || this.options.style_type.length <= 0) {
        throw new Error("MyApprovals: input option style_type must be a not empty string");
      }
      if (typeof this.options.email !== "string") {
        throw new Error(this.widgetName + " input option email must be a string");
      }
    },
    _destroy: function _destroy() {
      clearTimeout(this.refreshTimerID);
      this.element.removeClass(this.widgetFullName).removeClass("CloudflowStyle_" + this.options.style_type);
      this._super();
    }
  });
})(jQuery);

},{"../../../cloudflow/IconView/js/nixps-cloudflow-IconView.js":171,"../../PWA/js/Device.js":198}],52:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 9-nov-2018 15:40:36
 */
(function ($) {
  "use strict";

  if (typeof require !== "undefined") {
    var Asset = require("../../../nebulaportal/js/assetview/Asset.js");
    var FileOperations = require("../../CloudflowUtil/js/FileOperations.js");
    require("../../../common/FileDropUpload/js/nixps-FileDropUpload.js");
    require("../../CloudflowProgressBar/js/nixps-cloudflow-CloudflowProgressBar.js");
  }
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  ;
  function generateUUID() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }
  ;
  var foldersInMakingDict = {};
  var filesInMakingDict = {};
  function getDedicatedFileIcon(pFileType, pURL) {
    if (typeof pURL !== "string") {
      // should not come here, but joda code comes here...
      return "cf-icon cf-icon-clipboard-list";
    }
    if (typeof pFileType === "string" && pFileType.length > 0) {
      var icon = Asset.getDedicatedFileIcon(pFileType, 1, null);
      if (icon !== null) {
        return icon;
      }
    }
    var extention = pURL.substring(pURL.lastIndexOf(".") + 1);
    switch (extention) {
      case "pdf":
        return "cf-icon cf-icon-file-pdf";
      case "jpg":
      case "jpeg":
        return "cf-icon cf-icon-file-jpg";
      case "png":
        return "cf-icon cf-icon-file-png";
      case "tif":
      case "tiff":
        return "cf-icon cf-icon-file-tiff";
      case "xml":
      case "xliff":
        return "cf-icon cf-icon-file-metadata";
      case "html":
        return "cf-icon cf-icon-file-html";
      case "ai":
        return "cf-icon cf-icon-file-ai";
      case "dlcfg":
      case "sicfg":
        return "cf-icon cf-icon-color-gamut";
      case "tcb":
        return "cf-icon cf-icon-color-book";
      default:
        return "cf-icon cf-icon-clipboard-list";
    }
  }

  /**
   * @namespace nixps-cloudflow.AssetTreeView
   * @description Draw a tree of assets
   * @example $("<div>").AssetTreeView({});
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.AssetTreeView", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "assettreeview",
    options: {
      rootURL: "cloudflow://PP_FILE_STORE/",
      files: undefined,
      folders: undefined,
      /**
       * @name nixps-cloudflow.AssetTreeView#disableFiles
       * @description The files to disable
       * @type {mixed}
       * @default /.*\/_sw.js$/,
       */
      disableFiles: /.*\/_sw.js$/,
      /**
       * @name nixps-cloudflow.AssetTreeView#enableAssetDragging
       * @description Is the user allowed to drag assets to folders
       * @type {boolean}
       * @default false
       */
      enableAssetDragging: false,
      /**
       * @name nixps-cloudflow.AssetTreeView#enableSelecting
       * @description enable file and folder selection
       * @type {boolean}
       * @default false
       */
      enableSelecting: false,
      /**
       * @name nixps-cloudflow.AssetTreeView#enableMultipleSelection
       * @description If enableSelection is set on true, are we allowed to select multiple files or can we only select one a time
       * @type {boolean}
       * @default true
       */
      enableMultipleSelection: true,
      orderBy: [],
      skip: 0,
      limit: 200,
      /**
       * @name nixps-cloudflow.AssetTreeView#stepSize
       * @description the amount of rows we must load for each time
       * @type {number}
       * @default 200
       */
      stepSize: 200,
      /**
       * @name nixps-cloudflow.AssetTreeView#urlProvider
       * @description which url must we set on a file? This function will calculate this for us
       * @type {Function}
       * @default undefined
       */
      urlProvider: undefined,
      /**
       * @description define if something may be copied or moved to that folder
       * @type {funtion}
       * @param {object} pFolder
       * @returns {Boolean}
       */
      mayDrop: function mayDrop(pFolder) {
        return pFolder !== undefined && pFolder.cloudflow !== undefined && pFolder.cloudflow.folder !== "cloudflow://";
      },
      /**
       * @name nixps-cloudflow.AssetTreeView#folderIconURL
       * @description The url of the folder icon
       * @type {String}
       * @default "/portal/images/asset/20170307_icon_Folder.svg"
       */
      folderIconURL: "/portal/images/asset/20170307_icon_Folder.svg",
      /**
       * @name nixps-cloudflow.AssetTreeView#enableContextMenu
       * @description Must we enable the contextmenu
       * @type {boolean}
       * @default false
       */
      enableContextMenu: false,
      /**
       * @name nixps-cloudflow.AssetTreeView#context
       * @description The key to be used to save the current view of the tree
       * @type {String}
       * @default "nixps_cloudflow_assettreeview"
       */
      context: "nixps_cloudflow_assettreeview",
      /**
       * @name nixps-cloudflow.AssetTreeView#enableSaveState
       * @description Must we save the state for later or not?
       * @type {Boolean}
       * @default false
       */
      enableSaveState: false,
      /**
       * @name nixps-cloudflow.AssetTreeView#storageUtil
       * @description the object that will handle and do the storage
       * @private
       * @type {Object}
       * @default undefined
       */
      storageUtil: undefined,
      /**
       * @name nixps-cloudflow.AssetTreeView#refreshDelay
       * @description  The delay in milliseconds to refresh the tree
       * @type {Number}
       * @default 10000
       */
      refreshDelay: 10000,
      /**
      * @name nixps-cloudflow.AssetTreeView#processing
      * @description  The files or folder being processed for drag and drop
      * @type {Number}
      * @default []
      */
      processing: [],
      /**
       * @name nixps-cloudflow.AssetTreeView#overwrite_rule
       * @description  Move overwrite rule
       * @type {String}
       * @default "skip"
       */
      overwrite_rule: "skip",
      enableDropZone: false,
      /**
       * @name nixps-cloudflow.AssetTreeView#enableApprovalInfo
       * @description  do we want approval bubbles next to file name
       * @type {Boolean}
       * @default false
       */
      enableApprovalInfo: false,
      /**
       * @name nixps-cloudflow.AssetTreeView#showCanceledApprovalInfo
       * @description  should we show a canceled approval bubble if approvalInfo is enabled
       * @type {Boolean}
       * @default false
       */
      showCanceledApprovalInfo: false,
      /**
       * @name nixps-cloudflow.AssetTreeView#folderProvider
       * @description when provided, function will be used to request subfolders when collapsing a folder, 
       * otherwise API will be used
       * @type {function}
       * @default undefined
       */
      folderProvider: undefined,
      /**
       * @name nixps-cloudflow.AssetTreeView#fileProvider
       * @description when provided, function will be used to request files when collapsing a folder, 
       * otherwise API will be used
       * @type {function}
       * @default undefined
       */
      fileProvider: undefined,
      /**
       * @name nixps-cloudflow.AssetTreeView#uploadProgressType
       * @description if we show upload progress, should we show a progressbar, the percentage, or nothing (undefined)
       * possible values are "progressbar", "number" or undefined
       * @type {string}
       * @default undefined
       */
      uploadProgressType: undefined
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.AssetTreeView#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.dialog = $("body");
      if (this.dialog.hasClass("nixps-Dialog") === false) {
        this.dialog.Dialog();
      }

      // variables
      this.loadmore = {};
      this.isLoading = true;
      this.isDead = false;
      this.state = {};
      this.updateTimerID;
      this.uploadInProgressIDs = [];
      this.busyUploadingURLs = {};
      if (this.options.storageUtil !== undefined && typeof this.options.storageUtil.get === "function") {
        if ($.vakata !== undefined && $.vakata.storage !== undefined) {
          $.vakata.storage.set = this.options.storageUtil.set;
          $.vakata.storage.get = this.options.storageUtil.get;
          $.vakata.storage.del = this.options.storageUtil.del;
        }
      }
      this._draw();
      this._on(this.element, {
        "click.jstree": this._clickHandler,
        "dblclick.jstree": this._doubleClickHandler,
        "click li[data-loadmore]": this._loadMoreHandler,
        "contextmenu li.jstree-node": this._contextMenuHandler,
        "dragenter.jstree": this._dragFileOverTreeHandler
        // "drop .jstree-node": this._uploadFileHandler
      });
    },

    /**
     * @description function runs when tree is read / done to draw all nodes
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _treeReadyHandler: function _treeReadyHandler(pEvent, pData) {
      // the rootnode has been loaded,
      // the child nodes still need to be loaded
      if (this.options.enableSaveState === false) {
        this.isLoading = false;
        this._updateTrigger();
      }
      if (Object.keys(this.state).length > 0) {
        this.setState(this.state);
      }
      this._trigger("ready", null, {});
    },
    /**
     * @description function runs when initial nodes has been loaded
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _setStateHandler: function _setStateHandler(pEvent, pData) {
      this.element.children(".treeview_tree").off("set_state.jstree").jstree("deselect_all");
      this.isLoading = false;
      this._updateTrigger();
    },
    /**
     * @description function runs when user click on the item
     * @name nixps-cloudflow.AssetTreeView#_clickHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _clickHandler: function _clickHandler(pEvent, pData) {
      var li = $(pEvent.target).closest("li");
      var alink = $(pEvent.target).closest("a");
      if (li.length === 1 && alink.length === 1) {
        if (alink.hasClass("jstree-disabled")) {
          // do not continue if node is disabled
          return;
        }
        var isFolder = li.attr("data-isfolder");
        var url = li.attr("data-url");
        var filetype = li.attr("data-filetype");
        var originalURL = alink.attr("href");
        if (typeof url === "string" && url.length > 0) {
          this._trigger("click", null, {
            is_folder: isFolder == "true",
            filetype: filetype,
            url: url,
            originalURL: originalURL
          });
        }
      }
    },
    /**
     * @description function runs when user double clicked on a item
     * @name nixps-cloudflow.AssetTreeView#_doubleClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     * @function
     * @private
     */
    _doubleClickHandler: function _doubleClickHandler(pEvent, pData) {
      var li = $(pEvent.target).closest("li");
      if (li.length === 1) {
        var alink = $(pEvent.target).closest("a");
        if (alink && alink.hasClass("jstree-disabled")) {
          // do not continue if node is disabled
          return false;
        }
        var isFolder = li.attr("data-isfolder");
        var url = li.attr("data-url");
        if (typeof url === "string" && url.length > 0) {
          this._trigger("dblclick", null, {
            is_folder: isFolder == "true",
            url: url
          });
        }
      }
    },
    /**
     * @description function runs when user want to load more files or folders
     * @name nixps-cloudflow.AssetTreeView#_loadMoreHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _loadMoreHandler: function _loadMoreHandler(pEvent, pData) {
      var data = this.element.children(".treeview_tree").jstree("get_node", $(pEvent.target));
      if (data !== undefined && typeof data.parent === "string") {
        var limit = true;
        var moreFiles = $(pEvent.target).closest("li").attr("data-morefiles");
        var moreFolders = $(pEvent.target).closest("li").attr("data-morefolders");
        var nodeDOM = this.element.children(".treeview_tree").jstree("get_node", data.parent, true);
        if (nodeDOM !== false && nodeDOM.length === 1) {
          if (moreFiles == "true") {
            limit = nodeDOM.children("ul").children("li[data-isfolder=false]:not([data-loadmore])").length + this.options.stepSize;
          } else if (moreFolders == "true") {
            limit = nodeDOM.children("ul").children("li[data-isfolder=true]:not([data-loadmore])").length + this.options.stepSize;
          } else {
            console.error("could not find if we need files or folders");
            return;
          }
        } else {
          console.error("could not find tree");
          return;
        }
        if (data.parent === "#") {
          this.loadmore[this.options.rootURL] = limit;
          this.element.children(".treeview_tree").jstree("refresh");
        } else {
          this.loadmore[data.parent] = limit;
          this.element.children(".treeview_tree").jstree("refresh_node", data.parent);
        }
      }
    },
    /**
     * @description function runs when user clicked via the context menu
     * @function
     * @private
     * @name nixps-cloudflow.AssetTreeView#_contextMenuHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _contextMenuHandler: function _contextMenuHandler(pEvent, pData) {
      var li = $(pEvent.target).closest("li");
      if (li.length === 1) {
        var alink = $(pEvent.target).closest("a");
        if (alink && alink.hasClass("jstree-disabled")) {
          // do not continue if node is disabled
          return false;
        }
        var isFolder = li.attr("data-isfolder");
        var url = li.attr("data-url");
        var data = {
          parent_folder: FileOperations.getPath(url),
          is_folder: isFolder == "true",
          url: url
        };
        this._trigger("contextmenu", pEvent, data);
      }
    },
    _checkNodeHandler: function _checkNodeHandler(pEvent, pData) {
      console.log(JSON.stringify(pData));
    },
    _dropHandler: function _dropHandler(pEvent, pData) {
      var that = this;
      var urls = [];
      var toUrl = "";
      if (!Array.isArray(pData)) {
        urls = [pData.node.id];
        toUrl = pData.parent.id;
        this.options.processing = [pData.node.id];
      } else {
        for (var i = 0; pData.length > i; i++) {
          urls.push(pData[i].node.id);
        }
        var toUrl = pData[0].parent.id;
        this.options.processing = urls;
      }
      $.when(FileOperations.move(urls, toUrl, undefined, that.options.overwrite_rule), urls).done(function (pResult, pData) {
        var foldersToUpdate = [];
        var from_enclosing_folders = [];
        for (var i = 0; urls.length > i; i++) {
          var enclosing_folder = FileOperations.getEnclosingFolder(urls[i]);
          if (from_enclosing_folders.indexOf(enclosing_folder === -1)) {
            from_enclosing_folders.push(enclosing_folder);
            that.updateFolder(enclosing_folder);
          }
        }
        if (Array.isArray(pResult[0]) && Array.isArray(pResult[1])) {
          for (var i = 0; that.options.processing.length > i; i++) {
            if (pData.indexOf(that.options.processing[i]) !== -1) {
              that.element.find($("a[id='" + that.options.processing[i] + "']")).removeClass("warning");
              var enclosingFolder = FileOperations.getEnclosingFolder(that.options.processing[i]);
              if (foldersToUpdate.indexOf(enclosingFolder === -1)) {
                foldersToUpdate.push(enclosingFolder);
              }
              that.options.processing.splice(i);
            }
          }
          that.updateFolder(toUrl);
          that._checkAndUpdateExpandedSubnodes(toUrl);
          for (var i = 0; foldersToUpdate.length > i; i++) {
            that.updateFolder(foldersToUpdate[i]);
          }
          that.options.refreshDelay = 10000;
          //NEED TO CHECK IF THERE IS A PASTE IN CLIPBOARD WITH ASSETS/FOLDERS THAT WERE MOVED AND DELETE IT IF THERE
          that._trigger("droppedasset", pEvent, {
            "from": pResult[0],
            "to": {
              "files": pResult[1],
              "folders": pResult[2]
            },
            "toUrl": toUrl
          });
        }
      }).fail(function (pError) {
        var foldersToUpdate = [];
        var from_enclosing_folders = [];
        for (var i = 0; urls.length > i; i++) {
          var enclosing_folder = FileOperations.getEnclosingFolder(urls[i]);
          if (from_enclosing_folders.indexOf(enclosing_folder === -1)) {
            from_enclosing_folders.push(enclosing_folder);
            that.updateFolder(enclosing_folder);
          }
        }
        that.updateFolder(toUrl);
        that._checkAndUpdateExpandedSubnodes(toUrl);
        for (var i = 0; foldersToUpdate.length > i; i++) {
          that.updateFolder(foldersToUpdate[i]);
        }
        that.options.processing = [];
        that.options.refreshDelay = 10000;
      });
      that.options.overwrite_rule = "skip";
    },
    _checkAndUpdateExpandedSubnodes: function _checkAndUpdateExpandedSubnodes(pUrl) {
      var that = this;
      var node = that.element.find(".treeview_tree").jstree("get_node", pUrl);
      if (node === false) {
        return;
      }
      for (var i = 0; node.children.length > i; i++) {
        var open = false;
        if (FileOperations.isFolder(node.children[i])) {
          open = that.element.find(".treeview_tree").jstree("is_open", node.children[i]);
          if (open) {
            that.updateFolder(node.children[i]);
            that._checkAndUpdateExpandedSubnodes(node.children[i]);
          }
        }
      }
    },
    _isDraggable: function _isDraggable() {
      // console.log("isdrag");
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.AssetTreeView#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.AssetTreeView#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      // reset 
      var that = this;
      this.isLoading = true;
      clearTimeout(this.updateTimerID);
      this.element.css("min-height", this.element.height());
      this.element.empty();
      var stateObs = {};
      var plugins = ["wholerow", "types", "conditionalselect", "dnd", "crrm"];
      if (this.options.enableSaveState === true) {
        stateObs = {
          "key": this.options.context
        };
        plugins.push("state");
      }

      // draw tree
      var tree = $("<div>").addClass("treeview_tree");
      this.element.append(tree);
      tree.on("ready.jstree", this._treeReadyHandler.bind(this)).on("state_ready.jstree", this._jstreeLoaded.bind(this)).on("set_state.jstree", this._setStateHandler.bind(this))
      //   .on("move_node.jstree", this._dropHandler.bind(this))
      .on("is_draggable.jstree", this._isDraggable.bind(this)).jstree({
        "root": this.options.rootURL,
        "state": stateObs,
        "core": {
          "animation": 0,
          "themes": {
            "dots": false
          },
          "multiple": this.options.enableMultipleSelection,
          "force_text": !this.options.enableApprovalInfo,
          //we add html tags for the approvals so no force_text when approvalInfo enabled
          "check_callback": function check_callback(operation, node, node_parent, node_position, more) {
            // if(more && (more.pos === "b" || more.pos === "a")) {
            // console.log(operation);
            var result = true;
            if ((operation === "move_node" || operation === "create_node") && that._trigger("isdroppable", null, {
              node: node,
              node_parent: node_parent
            }) === false) {
              return false;
            }
            if (operation === "move_node" && more && more.core) {
              result = that._moveNodeCheck(node, node_parent, node_position, more);
            } else if (operation === "move_node" && more && more.core === undefined && node_parent.children.indexOf(node.id) !== -1) {
              return false;
            }
            // if(operation === "create_node") {
            //     result = that._moveNodeCheck(node, node_parent, node_position, more);
            // }
            //     return false;
            // } else if(more && more.pos === "i") {
            //     return true;
            // } else {
            //     return true;
            // }
            return result;
          },
          "data": this._retrieve.bind(this),
          "error": this._errorHandler.bind(this)
        },
        "types": {
          "#": {},
          "folder": {
            "icon": "cf-icon cf-icon-folder-filled"
          },
          "file": {
            "max_children": 0
          }
        },
        "conditionalselect": this._mayBeSelected.bind(this),
        "plugins": plugins,
        "dnd": {
          "is_draggable": function is_draggable(node, pEvent) {
            // if($(pEvent.currenTarget).hasClass('processing_drop')) {
            if (that._trigger("isdraggable", pEvent, node) === false) {
              return false;
            } else if (that.options.processing.indexOf(node[0].id) !== -1) {
              that.element.find($("a[id='" + node[0].id + "']")).addClass("warning");
              pEvent.preventDefault();
              return false;
            } else {
              return true;
            }
          }
        }
      });
      var dropZoneInput = $("<input>").addClass("asset-files").hide();
      this.element.append(dropZoneInput);
      if (this.options.enableDropZone === true) {
        this._initFileUpload();
      }
    },
    _moveNodeCheck: function _moveNodeCheck(node, node_parent, position, more) {
      var that = this;
      this.options.refreshDelay = 0;
      if (node_parent.id === "#") {
        console.error("Trying to move to a location not included in the app");
        $("#notify-area").notify("create", "closeable-error", {
          title: $.i18n._("nixps-cloudflow-assets.drop_error"),
          text: $.i18n._("nixps-cloudflow-assets.drop_error_message")
        });
        return false;
      } else if (node_parent.children.indexOf(node.id) !== -1) {
        return false;
      } else if (Array.isArray(node_parent.children)) {
        // console.error("Folder already exists");
        // return false;
        var already_exists = false;
        var existing_urls = [];
        for (var i = 0; node_parent.children.length > i; i++) {
          var targetName = FileOperations.getName(node_parent.children[i]);
          var moveName = FileOperations.getName(node.id);
          if (targetName === moveName) {
            already_exists = true;
            existing_urls.push(node_parent.children[i]);
          }
        }
        if (already_exists === true) {
          $.when($("body").Dialog("showDialog", $.i18n._("nixps-cloudflow-assets.overwrite"), $.i18n._("nixps-cloudflow-assets.overwrite_message") + existing_urls.join(), {}, [{
            classes: "dialog_skip_button",
            type: "skip",
            label: "nixps-cloudflow-assets.button_skip",
            cbFunction: function cbFunction() {
              return "skip";
            }
          }, {
            classes: "dialog_overwrite_button",
            type: "overwrite",
            label: "nixps-cloudflow-assets.button_overwrite",
            cbFunction: function cbFunction() {
              return "overwrite";
            }
          }, {
            classes: "dialog_duplicate_button",
            type: "duplicate",
            label: "nixps-cloudflow-assets.button_duplicate",
            cbFunction: function cbFunction() {
              return "duplicate";
            }
          }, {
            classes: "dialog_cancel_button",
            type: "cancel",
            label: "nixps-cloudflow-assets.button_cancel",
            cbFunction: function cbFunction() {
              return "cancel";
            }
          }])).done(function (pResult) {
            if (pResult !== undefined && (pResult.type === "ovewrite" || pResult.type === "duplicate" || pResult.type === "skip")) {
              that.options.overwrite_rule = pResult.type;
              var mustContinue = that._trigger("movenode", null, {
                toUrl: node_parent.id,
                data: {
                  "node": node,
                  "parent": node_parent,
                  "position": position,
                  "more": more
                }
              });
              if (mustContinue === false) {
                //the filehandling happened elsewhere
                return false;
              }
              that._dropHandler(undefined, [{
                "node": node,
                "parent": node_parent,
                "position": position,
                "more": more
              }]);
              return true;
            } else {
              //that.redraw();
              that.updateFolder(node_parent.id);
              that.updateFolder(FileOperations.getEnclosingFolder(node.id));
              return false;
            }
          });
        } else {
          var mustContinue = this._trigger("movenode", null, {
            toUrl: node_parent.id,
            data: {
              "node": node,
              "parent": node_parent,
              "position": position,
              "more": more
            }
          });
          if (mustContinue === false) {
            //the filehandling happened elsewhere
            return false;
          }
          that._dropHandler(undefined, [{
            "node": node,
            "parent": node_parent,
            "position": position,
            "more": more
          }]);
          return true;
        }
      } else {
        return false;
      }
    },
    _retrieve: function _retrieve(pNode, pCallBack) {
      var enclosingFolder;
      if (pNode.id === "#") {
        if (Array.isArray(this.options.files) || Array.isArray(this.options.folders)) {
          this._getPredefinedChildren(pCallBack);
          return;
        } else {
          enclosingFolder = this.options.rootURL;
        }
      } else {
        enclosingFolder = pNode.id;
      }
      var limit = this.options.limit;
      if (typeof this.loadmore[enclosingFolder] === "number") {
        limit = this.loadmore[enclosingFolder];
      }
      var that = this;
      var files = null;
      var folders = null;
      this._getFiles(enclosingFolder, limit, function (nodes) {
        files = nodes;
        if (Array.isArray(folders)) {
          pCallBack(that._postHandlingNodes(files, folders, enclosingFolder, limit));
        }
      });
      this._getFolders(enclosingFolder, limit, function (nodes) {
        folders = nodes;
        if (Array.isArray(files)) {
          pCallBack(that._postHandlingNodes(files, folders, enclosingFolder, limit));
        }
      });
    },
    _errorHandler: function _errorHandler(pEvent) {
      console.error(pEvent);
      this._trigger("error", null, {
        error: pEvent
      });
    },
    _getFolders: function _getFolders(pEnclosingFolder, pLimit, pCallBack) {
      var that = this;
      var options = {
        first: this.options.skip,
        maximum: pLimit + 1
      };
      if (this.options.folderProvider !== undefined && typeof this.options.folderProvider === "function") {
        var folders = this.options.folderProvider(pEnclosingFolder);
        var nodes = [];
        for (var i = 0; i < folders.length; i++) {
          nodes.push(this._makeFolder(folders[i]));
        }
        pCallBack(nodes);
      } else {
        api_async.folder.list_with_options(["cloudflow.enclosing_folder", "equal to", pEnclosingFolder], ["name", "ascending"], ["cloudflow", "name"], options, function (pResults) {
          var nodes = [];
          for (var i = 0; i < pResults.results.length; i++) {
            nodes.push(that._makeFolder(pResults.results[i]));
          }
          if (Array.isArray(foldersInMakingDict[pEnclosingFolder])) {
            nodes = nodes.concat(foldersInMakingDict[pEnclosingFolder].slice());
          }
          pCallBack(nodes);
        }, function (pError) {
          console.error(pError);
          pCallBack([]);
        });
      }
    },
    _makeFolder: function _makeFolder(pFolder) {
      var folder = {
        id: pFolder.cloudflow.folder,
        text: pFolder.name,
        type: "folder",
        state: {},
        children: true,
        li_attr: {
          "data-isfolder": true,
          "data-url": pFolder.cloudflow.folder
        },
        a_attr: {
          "href": "/portal.cgi?asset=" + encodeURIComponent(pFolder.cloudflow.folder)
        }
      };
      return folder;
    },
    _getFiles: function _getFiles(pEnclosingFolder, pLimit, pCallBack) {
      var that = this;
      var options = {
        first: this.options.skip,
        maximum: pLimit + 1
      };
      if (this.options.fileProvider !== undefined && typeof this.options.fileProvider === "function") {
        $.when(this.options.fileProvider(pEnclosingFolder)).done(function (files) {
          var nodes = [];
          for (var i = 0; i < files.length; i++) {
            nodes.push(that._makeFile(files[i]));
          }
          if (Array.isArray(filesInMakingDict[pEnclosingFolder])) {
            nodes = nodes.concat(filesInMakingDict[pEnclosingFolder].slice());
          }
          pCallBack(nodes);
        });
      } else {
        var query = ["cloudflow.enclosing_folder", "equal to", pEnclosingFolder, "and", "sub", "equal to", ""];
        if (this.options.uploadProgressType !== false) {
          //files that are uploading will already show up in the call - but we're already showing a dummy
          query.push("and", "not", "cloudflow.file", "in", Object.keys(this.busyUploadingURLs));
        }
        api_async.asset.list_with_options(query, ["file_name", "ascending"], ["url", /*"sub",*/"cloudflow", "thumb", "approvals", /*"modtime",*/"filetype", "proofscope", "proofscope3d", "metadata.page_limit", /*"sync_status",*/"file_name" /*,"file_time"*/], options, function (pData) {
          var nodes = [];
          for (var i = 0; i < pData.results.length; i++) {
            nodes.push(that._makeFile(pData.results[i]));
          }
          if (Array.isArray(filesInMakingDict[pEnclosingFolder])) {
            nodes = nodes.concat(filesInMakingDict[pEnclosingFolder].slice());
          }
          pCallBack(nodes);
        }, function (pError) {
          console.error(pError);
          pCallBack([]);
        });
      }
    },
    /**
     * @description Transform an asset object to a jstree leave object
     * @function
     * @private
     * @param {Object} pFile the file object to transform
     */
    _makeFile: function _makeFile(pFile) {
      var file = {
        id: pFile.cloudflow.file,
        text: this.options.enableApprovalInfo ? pFile.file_name + this._getApprovalInfo(pFile.approvals, this.options.showCanceledApprovalInfo) : pFile.file_name,
        icon: pFile.thumb,
        state: {
          disabled: this.options.disableFiles.test(pFile.cloudflow.file)
        },
        type: "file",
        li_attr: {
          "data-isfolder": false,
          "data-url": pFile.cloudflow.file,
          "data-filetype": pFile.filetype,
          "data-assesment": this._getAssesment(pFile.approvals)
        },
        a_attr: {
          "href": "/portal.cgi?asset=" + encodeURIComponent(pFile.cloudflow.file),
          "data-thumb": typeof pFile.thumb === "string" ? "true" : "false"
        }
      };
      if (typeof pFile.thumb !== "string" || pFile.thumb.length <= 0) {
        file.icon = getDedicatedFileIcon(pFile.filetype, pFile.cloudflow.file);
      }
      if (typeof this.options.urlProvider === "function") {
        file.a_attr.href = this.options.urlProvider(pFile.cloudflow.file, pFile);
      }
      return file;
    },
    _getAssesment: function _getAssesment(pApprovalStatus) {
      if (pApprovalStatus === undefined || pApprovalStatus.length === 0) {
        return "";
      }
      var status = "";
      if (Array.isArray(pApprovalStatus) && pApprovalStatus.length > 0) {
        var currentStatusIndex;
        var assessmentStack = [];
        for (var assesmentIndex = 0; assesmentIndex < pApprovalStatus.length; ++assesmentIndex) {
          var checkAssessment = pApprovalStatus[pApprovalStatus.length - 1 - assesmentIndex].assessment;
          assessmentStack.unshift(checkAssessment); // save for later to show previous approvals
          if (status === "" && checkAssessment !== "cancel" || checkAssessment === "pending" || this.options.showCanceledApprovalInfo === true && checkAssessment === "cancel" && status === "") {
            currentStatusIndex = assesmentIndex; // save to know the current position
            status = checkAssessment;
          }
        }
      }
      return status;
    },
    _getApprovalInfo: function _getApprovalInfo(pApprovalStatus, pShowCanceled) {
      if (pApprovalStatus === undefined || pApprovalStatus.length === 0) {
        return "";
      }
      var status = "";
      var previousApprovalBubbles = "";
      if (Array.isArray(pApprovalStatus) && pApprovalStatus.length > 0) {
        var currentStatusIndex;
        var assessmentStack = [];
        for (var assesmentIndex = 0; assesmentIndex < pApprovalStatus.length; ++assesmentIndex) {
          var checkAssessment = pApprovalStatus[pApprovalStatus.length - 1 - assesmentIndex].assessment;
          assessmentStack.unshift(checkAssessment); // save for later to show previous approvals
          if (status === "" && checkAssessment !== "cancel" || checkAssessment === "pending" || pShowCanceled === true && checkAssessment === "cancel" && status === "") {
            currentStatusIndex = assesmentIndex; // save to know the current position
            status = checkAssessment;
          }
        }
        // show the last ten approval statess
        if (pApprovalStatus.length > 1) {
          // remove current state, this will be showed anyway
          assessmentStack.splice(assessmentStack.length - 1 - currentStatusIndex, 1);
          // cut off, so we will only show the ten most recent approvals
          assessmentStack = assessmentStack.slice(-10);
          for (var i = 0; i < assessmentStack.length; i++) {
            previousApprovalBubbles += "<span class='previousbubble asset-" + assessmentStack[i] + "' ></span>";
          }
        }
      }
      if (status === "") {
        // nothing ...
      } else if (status === "reject") {
        return "<div class='approval-container'>" + previousApprovalBubbles + "<div class='approval asset-rejected bubble' data-status='reject' style='cursor: pointer;'>" + $.i18n._('nixps-cloudflow-assets.status_rejected') + "</div></div>";
      } else if (status === "accept") {
        return "<div class='approval-container'>" + previousApprovalBubbles + "<div class='approval asset-accepted bubble' data-status='accept' style='cursor: pointer;'>" + $.i18n._('nixps-cloudflow-assets.status_approved') + "</div></div>";
      } else if (status === "cancel") {
        return "<div class='approval-container'>" + previousApprovalBubbles + "<div class='approval asset-cancel bubble' data-status='cancel' style='cursor: pointer;'>" + $.i18n._('nixps-cloudflow-approval_view.state-canceled') + "</div></div>";
      } else {
        return "<div class='approval-container'>" + previousApprovalBubbles + "<div class='approval asset-waiting bubble' data-status='waiting' style='cursor: pointer;'>" + $.i18n._('nixps-cloudflow-assets.status_waiting_approval') + "</div></div>";
      }
    },
    _getPredefinedChildren: function _getPredefinedChildren(pCallback) {
      var fileNodes = [];
      var folderNodes = [];
      if (Array.isArray(this.options.files)) {
        for (var i = 0; i < this.options.files.length; i++) {
          fileNodes.push(this._makeFile(this.options.files[i]));
        }
      }
      if (Array.isArray(this.options.folders)) {
        for (var i = 0; i < this.options.folders.length; i++) {
          folderNodes.push(this._makeFolder(this.options.folders[i]));
        }
      }
      pCallback(fileNodes.concat(folderNodes));
    },
    _postHandlingNodes: function _postHandlingNodes(pFiles, pFolders, pEnclosingFolder, pLimit) {
      //console.log("give input " + pEnclosingFolder);
      var loadMoreFiles = false;
      var loadMoreFolders = false;
      if (pFiles.length > pLimit) {
        pFiles.pop();
        loadMoreFiles = true;
      }
      if (pFolders.length > pLimit) {
        pFolders.pop();
        loadMoreFolders = true;
      }
      var nodes = pFiles.concat(pFolders);
      if (loadMoreFiles === true || loadMoreFolders === true) {
        nodes.push({
          id: "load_more_for" + pEnclosingFolder,
          text: $.i18n._("nixps-cloudflow-assets.load_more_text"),
          icon: false,
          state: {},
          li_attr: {
            "data-loadmore": false,
            "data-morefiles": loadMoreFiles,
            "data-morefolders": loadMoreFolders
          },
          children: []
        });
      }
      return nodes;
    },
    _mayBeSelected: function _mayBeSelected(pNode, pEvent) {
      if (this.options.enableSelecting === false) {
        return false;
      }
      return true;
    },
    _updateTrigger: function _updateTrigger() {
      if (typeof this.options.refreshDelay === "number" && this.options.refreshDelay > 0) {
        clearTimeout(this.updateTimerID);
        this.updateTimerID = this._delay(function () {
          if (this.isDead === true) {
            return; // is zombie
          }

          if (this.element.is(":visible") && document.hidden !== true && this.isLoading === false) {
            var that = this;
            this._update().done(function () {
              that._updateTrigger();
            });
          } else {
            // is hidden
            this._updateTrigger();
          }
        }, this.options.refreshDelay);
      }
    },
    _update: function _update() {
      this.isLoading = true;
      var defers = [];
      // update root
      defers.push(this.updateFolder("#"));
      // get all opening fodlers and update them
      var openFolderIDs = this._getOpenFolders();
      for (var i = 0; i < openFolderIDs.length; i++) {
        defers.push(this.updateFolder(openFolderIDs[i]));
      }
      var that = this;
      return $.when.apply($, defers).always(function () {
        that.isLoading = false;
      });
    },
    _getOpenFolders: function _getOpenFolders() {
      var openFolderIDs = [];
      var tree = this.element.children(".treeview_tree");
      this.element.find("[data-isfolder=true]").each(function () {
        var id = $(this).attr("id");
        if (tree.jstree("is_open", id) === true && tree.jstree("is_loading", id) === false) {
          openFolderIDs.push(id);
        }
      });
      return openFolderIDs;
    },
    updateFolder: function updateFolder(pParentID) {
      var that = this;
      return $.Deferred(function (pDefer) {
        that._retrieve({
          id: pParentID
        }, function (pNodeJSONs) {
          that._updateFolderUI(pParentID, pNodeJSONs);
          pDefer.resolve();
        });
      });
    },
    _updateFolderUI: function _updateFolderUI(pParentID, pNodes) {
      var node = this.element.children(".treeview_tree").jstree("get_node", pParentID);
      if (node === false || $.isPlainObject(node) === false) {
        return; // parent node does not exist (anymore)
      }

      if (node.state !== undefined && node.state.loading === true) {
        return; // current node is waiting to get fetched?  strange ???
      }

      var children = node.children;
      var newIDs = $.map(pNodes, function (elem) {
        return elem.id;
      });
      var newNodeDict = [];
      for (var i = 0; i < pNodes.length; i++) {
        newNodeDict[pNodes[i].id] = pNodes[i];
      }
      // remove old
      var removedOnes = _.difference(children, newIDs);
      if (Array.isArray(removedOnes) && removedOnes.length > 0) {
        this.element.children(".treeview_tree").jstree("delete_node", removedOnes);
      }
      // insert new ones
      var newOnes = _.difference(newIDs, children);
      for (var i = 0; i < newOnes.length; i++) {
        this.element.children(".treeview_tree").jstree("create_node", pParentID, newNodeDict[newOnes[i]], $.inArray(newOnes[i], newIDs), function () {});
      }
      // update
      var newFileIDs = $.map(pNodes, function (elem) {
        return elem.id;
      });
      //var newFileIDs = $.map(pNodes, function(elem) { if (elem.li_attr["data-isfolder"] === false) return elem.id;});
      //if we only need to update files and not folders, children should be checked wether they are files or folders.
      var fileIDsToUpdate = _.union(children, newFileIDs);
      var needsToRedraw = false;
      for (var i = 0; i < fileIDsToUpdate.length; i++) {
        var fileJSON = newNodeDict[fileIDsToUpdate[i]];
        if (fileJSON) {
          if (fileJSON.icon && typeof fileJSON.icon === "string" && fileJSON.icon.length > 0) {
            var currentIcon = this.element.children(".treeview_tree").jstree("get_icon", fileJSON.id);
            if (currentIcon !== fileJSON.icon) {
              this.element.children(".treeview_tree").jstree("set_icon", fileJSON.id, fileJSON.icon);
              $(this.element.children(".treeview_tree").jstree("get_node", fileJSON.id, true)).children("a").attr("data-thumb", "true");
            }
          }
          if (this.options.enableApprovalInfo && fileJSON.li_attr && fileJSON.li_attr["data-assesment"] !== undefined && fileJSON.li_attr["data-assesment"].length > 0) {
            var currentAssesment = this.element.children(".treeview_tree").jstree("get_node", fileJSON.id, true).find(".approval-container .approval").attr("data-status");
            switch (fileJSON.li_attr["data-assesment"]) {
              case "pending":
                if (currentAssesment !== fileJSON.li_attr["data-assesment"] && currentAssesment !== "waiting") {
                  needsToRedraw = true;
                }
                break;
              case "accept":
                if (currentAssesment !== fileJSON.li_attr["data-assesment"] && currentAssesment !== "accepted") {
                  needsToRedraw = true;
                }
                break;
              case "cancel":
              case "reject":
                if (currentAssesment !== fileJSON.li_attr["data-assesment"] && currentAssesment !== "rejected" && currentAssesment !== "cancel") {
                  needsToRedraw = true;
                }
                break;
              default:
                console.error("AssetTreeView: assesment case not covered");
            }
          }
        } else if (fileJSON === undefined) {
          // this.element.children(".treeview_tree").jstree("create_node", pParentID, fileIDsToUpdate[i], $.inArray(fileIDsToUpdate[i], children), function(){
          // });
          this.redraw();
          needsToRedraw = false;
        }
      }
      if (needsToRedraw === true) {
        this.redraw();
      }
    },
    _uploadFileHandler: function _uploadFileHandler(pEvent, pData) {
      // console.log(pData);
      var url = $(pEvent.currentTarget).attr("data-url");
      var uploadToUrl = "";
      if (FileOperations.isFolder(url)) {
        uploadToUrl = url;
      } else {
        uploadToUrl = FileOperations.getEnclosingFolder(url);
      }
      //this.element.find(".asset-files").fileupload("option", "url", '/portal.cgi?asset=upload_file&url=' + encodeURIComponent(uploadToUrl));
    },

    _jstreeLoaded: function _jstreeLoaded(pEvent, pData) {
      this.element.css("min-height", "");
      if (this.options.enableDropZone === true) {
        this._initFileUpload();
      }
      this._trigger("loaded", null, {});
    },
    _initFileUpload: function _initFileUpload() {
      var that = this;
      // this.element.find('.jstree-node').on('dragover', function (e) {
      //    console.log(this);
      // });

      // $(document).on('drop dragover', function (e) {
      //     e.preventDefault();
      // });
      // this.element.FileDropUpload({useDropZone:true});
      this.element.find(".asset-files").fileupload({
        dropZone: this.element,
        pasteZone: null,
        add: function add(e, data) {
          e.stopPropagation();
          // function called before uploading file
          if (Array.isArray(data.files) && data.files.length > 0) {
            if (!data.headers) {
              data.headers = {};
            }
            if (data.files.length === 1 && typeof data.files[0].lastModified === "number" && new Date() - data.files[0].lastModified > 1000) {
              data.headers["X-Hybrid-Last-Modified"] = new Date(data.files[0].lastModified).toISOString();
            }
            var csrfToken = api_util.get_cookie("csrf-token");
            if (typeof csrfToken === "string" && csrfToken.length > 0) {
              data.headers["X-Csrf-Token"] = csrfToken;
            }
            // check if there are files with the same name
            var folder = '';
            var url = $(e.originalEvent.target).closest('[data-isfolder=true]').data('url');
            if (url !== undefined && url.length > 0 && FileOperations.isFolder(url)) {
              folder = $(e.originalEvent.target).closest('[data-isfolder=true]').data('url');
            } else if (url !== undefined) {
              folder = FileOperations.getEnclosingFolder(url);
            } else {
              console.warning('could not find url');
              return;
            }
            var node = that.element.children(".treeview_tree").jstree("get_node", folder);
            var mustContinue = that._trigger("fileupload", e, [data, node]);
            if (mustContinue === false) {
              //fileupload was handled somewhere else, we want the current state before redraw
              that.state = that.getState();
            } else {
              var children = [];
              for (var i = 0; node.children.length > i; i++) {
                children.push(node.children[i]);
              }
              var _loop = function _loop() {
                var fileURL = folder + data.files[i].name;
                if (children.indexOf(fileURL) !== -1) {
                  //save the url here - i will be one higher on fileupload line for some reason
                  $('body').Dialog("show_yes_no", $.i18n._('nixps-cloudflow-assets.messagetitle_overwrite', [FileOperations.getFileName(fileURL)]), $.i18n._("nixps-cloudflow-assets.messagetitle_message", [fileURL]), "", function () {
                    that.element.find(".asset-files").fileupload("option", "url", '/portal.cgi?asset=upload_file&url=' + encodeURIComponent(fileURL) + '&overwrite=true');
                    data.submit();
                  }, function () {
                    // no call submit
                  });
                } else {
                  that.element.find(".asset-files").fileupload("option", "url", '/portal.cgi?asset=upload_file&url=' + encodeURIComponent(fileURL));
                  data.submit();
                }
                that.busyUploadingURLs[fileURL] = true;
              };
              for (var i = 0; data.files.length > i; i++) {
                _loop();
              }
            }
          }
        },
        send: function send(e, data) {
          // console.log(data);
        },
        done: function done(e, data) {
          if (data && data.result && typeof data.result.error === "string" && data.result.error.length > 0) {
            // failed
            console.error(data.result);
          }
          var result;
          if (_typeof(data.result) === "object") {
            result = data.result.files;
          } else {
            //we assume the upload was done by fileupload
            result = JSON.parse(data.result).files;
          }
          for (var i = 0; result.length > i; i++) {
            delete that.busyUploadingURLs[result[i]];
            var folder = void 0;
            if (result[i].endsWith("/")) {
              folder = result[i];
            } else {
              folder = FileOperations.getEnclosingFolder(result[i]);
            }
            if (that.options.uploadProgressType !== false) {
              for (var _i = 0; _i < that.uploadInProgressIDs[data.id].length; _i++) {
                that.removeFileInMaking(that.uploadInProgressIDs[data.id][_i], false);
              }
              delete that.uploadInProgressIDs[data.id];
            }
            that.updateFolder(folder);
          }
        },
        progress: function progress(e, data) {
          if (that.options.uploadProgressType !== false) {
            var progress = parseInt(data.loaded / data.total * 100, 10);
            if (progress < 3) {
              progress = 3;
            }
            if (data.id === undefined) {
              data.id = generateUUID();
            }
            if (data.url.startsWith("cloudflow") === false) {
              //need to normalize url
              if (data.url.indexOf("url=") !== -1) {
                //get the url parameter from the string
                var parameters = data.url.split("?")[1];
                var _iterator = _createForOfIteratorHelper(new URLSearchParams(parameters).entries()),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var searchParam = _step.value;
                    if (searchParam[0] === "url") {
                      if (searchParam[1].endsWith("/")) {
                        data.url = searchParam[1];
                      } else {
                        data.url = FileOperations.getEnclosingFolder(searchParam[1]);
                      }
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              } else {
                console.error("Assettreeview: Unknown interface for progress upload url");
                console.error(data);
              }
            }
            if (that.uploadInProgressIDs[data.id] === undefined) {
              that.uploadInProgressIDs[data.id] = [];
              for (var i = 0; i < data.files.length; i++) {
                var normalizedFilename = data.files[i].name.replaceAll(" ", "").replaceAll(".", "");
                that.uploadInProgressIDs[data.id].push(normalizedFilename);
                that.addFileInMaking(data.files[i].name, normalizedFilename, data.url);
              }
              //in case the folder that we're uploading to was empty - need to open to see the temp file
              that.element.children(".treeview_tree").jstree("open_node", {
                "id": data.url
              });
            }
            if (that.options.uploadProgressType !== false) {
              for (var _i2 = 0; _i2 < data.files.length; _i2++) {
                var _normalizedFilename = data.files[_i2].name.replaceAll(" ", "").replaceAll(".", "");
                var tempNode = that.element.find("#inmakingid_" + _normalizedFilename);
                if (that.options.uploadProgressType === "progressbar") {
                  //NOTE:could show a circle filling up progressively?
                  //experimented with background image / polygon, but we can't animate those
                  //https://github.com/kottenator/jquery-circle-progress/blob/master/dist/circle-progress.js
                  if (tempNode.find(".nixps-cloudflow-CloudflowProgressBar").length === 0) {
                    var progressBar = $("<div>").CloudflowProgressBar({
                      height: "15px"
                    });
                    tempNode.append(progressBar);
                  } else {
                    tempNode.find(".nixps-cloudflow-CloudflowProgressBar").CloudflowProgressBar("setValue", progress);
                  }
                } else if (that.options.uploadProgressType === "number") {
                  if (tempNode.find(".atv_progresspercentage").length === 0) {
                    var progressEl = $("<span>").addClass("atv_progresspercentage").text(progress + "%");
                    tempNode.append(progressEl);
                  } else {
                    tempNode.find(".atv_progresspercentage").text(progress + "%");
                  }
                } else {
                  throw new Error("AssetTreeView: uploadProgressType has invalid interface");
                }
              }
            }
          }
        },
        fail: function fail(e, data) {
          console.error(data);
          $("#notify-area").notify("create", "closeable-error", {
            title: $.i18n._("nixps-cloudflow-assets.errorupload_title"),
            text: $.i18n._("nixps-cloudflow-assets.errorupload_message")
          });
        }
      });
    },
    updateProgress: function updateProgress(e, data) {
      this.element.find(".asset-files").fileupload("option").progress(e, data);
    },
    updateDone: function updateDone(e, data) {
      this.element.find(".asset-files").fileupload("option").done(e, data);
    },
    _dragFileOverTreeHandler: function _dragFileOverTreeHandler(pEvent) {
      if (this.options.enableDropZone === false) {
        //no dropping
        return;
      }
      var folder = "";
      var url = $(pEvent.originalEvent.target).closest("[data-isfolder=true]").data("url");
      if (url !== undefined && url.length > 0 && FileOperations.isFolder(url)) {
        folder = $(pEvent.originalEvent.target).closest("[data-isfolder=true]").data("url");
      } else if (url !== undefined) {
        folder = FileOperations.getEnclosingFolder(url);
      } else {
        console.warn("could not find url");
        return;
      }
      var node = this.element.children(".treeview_tree").jstree("get_node", folder);
      var cloudflowFolder = {
        cloudflow: {
          folder: node.id,
          enclosing_folder: node.parent
        },
        path: node.id.startsWith("cloudflow://") ? node.id.slice(12, -1).split("/") : node.id.split("/")
      };
      if (this.options.mayDrop(cloudflowFolder, node) === false) {
        this.element.children(".treeview_tree").jstree("deselect_all");
        return;
      }
      node["file"] = {
        url: node.id,
        type: node.type
      };
      this.setSelectedNode(node);
    },
    /**
     * @description Ask to add a dummy folder, who is in a process of makeing. So it does not exists but will be
     * @function
     * @name nixps-cloudflow.AssetTreeView#addFolderInMaking
     * @param {String} pFolderName 
     * @param {String} pInMakingID 
     * @param {String} pParentUrl 
     * @rturns {undefined}
     */
    addFolderInMaking: function addFolderInMaking(pFolderName, pInMakingID, pParentUrl) {
      if (typeof pFolderName === "string" && pFolderName.length > 0) {
        if (foldersInMakingDict[pParentUrl] === undefined) {
          foldersInMakingDict[pParentUrl] = [];
        }
        var folderDataItem = {
          id: "inmakingid_" + pInMakingID,
          text: decodeURI(pFolderName),
          name: decodeURI(pFolderName),
          state: {
            disabled: true
          },
          type: "folder",
          li_attr: {
            "data-isfolder": true
          }
        };
        foldersInMakingDict[pParentUrl].push(folderDataItem);
        // temp
        this.updateFolder(pParentUrl);
      }
    },
    /**
     * @description Ask to add a dummy File, who is in a process of makeing. So it does not exists but will be
     * @function
     * @name nixps-cloudflow.AssetTreeView#addFolderInMaking
     * @param {String} pFileName 
     * @param {String} pInMakingID 
     * @param {String} pParentUrl 
     * @returns {undefined}
     */
    addFileInMaking: function addFileInMaking(pFileName, pInMakingID, pParentUrl) {
      if (typeof pFileName === "string" && pFileName.length > 0) {
        if (filesInMakingDict[pParentUrl] === undefined) {
          filesInMakingDict[pParentUrl] = [];
        }
        var fileDataItem = {
          id: "inmakingid_" + pInMakingID,
          text: decodeURI(pFileName),
          file_name: decodeURI(pFileName),
          icon: getDedicatedFileIcon(null, pFileName),
          //should we have an icon indicating it's an upload in progress?
          state: {
            disabled: true
          },
          type: "file",
          li_attr: {
            "data-isfolder": false
          }
        };
        filesInMakingDict[pParentUrl].push(fileDataItem);
        // temp
        this.updateFolder(pParentUrl);
      }
    },
    /**
     * @description Remove the dummy folder
     * @function
     * @name nixps-cloudflow.AssetTreeView#removeFolderInMaking
     * @param {String} pInMakingID 
     * @param {Boolean} pReload 
     * @param {String} pActualFolder 
     * @returns {undefined}
     */
    removeFolderInMaking: function removeFolderInMaking(pInMakingID, pReload) {
      var that = this;
      var pFolderUrl;
      $.each(foldersInMakingDict, function (key, value) {
        for (var i = 0; i < value.length; i++) {
          if (value[i].id === "inmakingid_" + pInMakingID) {
            that.element.children(".treeview_tree").jstree("delete_node", "inmakingid_" + pInMakingID);
            pFolderUrl = key;
            foldersInMakingDict[key].splice(i, 1);
            return false;
          }
        }
      });
      if (typeof pFolderUrl === "string" && pReload === true) {
        this.updateFolder(pFolderUrl);
      }
    },
    /**
     * @description Remove the dummy file
     * @function
     * @name nixps-cloudflow.AssetTreeView#removeFileInMaking
     * @param {String} pInMakingID 
     * @param {Boolean} pReload 
     * @returns {undefined}
     */
    removeFileInMaking: function removeFileInMaking(pInMakingID, pReload) {
      var that = this;
      var pFolderParentUrl;
      $.each(filesInMakingDict, function (key, value) {
        for (var i = 0; i < value.length; i++) {
          if (value[i].id === "inmakingid_" + pInMakingID) {
            that.element.children(".treeview_tree").jstree("delete_node", "inmakingid_" + pInMakingID);
            pFolderParentUrl = key;
            filesInMakingDict[key].splice(i, 1);
            return false;
          }
        }
      });
      if (typeof pFolderParentUrl === "string" && pReload === true) {
        this.updateFolder(pFolderParentUrl);
      }
    },
    getSelectedItems: function getSelectedItems() {
      return this.element.children(".treeview_tree").jstree("get_selected");
    },
    getState: function getState() {
      return this.element.children(".treeview_tree").jstree("get_state");
    },
    setState: function setState(pState) {
      this.element.children(".treeview_tree").jstree("set_state", pState);
    },
    getNode: function getNode(pUrl) {
      return this.element.children(".treeview_tree").jstree("get_node", pUrl);
    },
    setSelectedNode: function setSelectedNode(pNode) {
      var tree = this.element.children(".treeview_tree");
      if (this.options.enableMultipleSelection === false) {
        tree.jstree("deselect_all");
      }
      if (pNode === undefined || pNode === null) {
        tree.jstree("deselect_all");
      } else {
        tree.jstree("select_node", pNode.file.url);
      }
    },
    collapseAll: function collapseAll() {
      this.element.children(".treeview_tree").jstree("open_all");
    },
    openNode: function openNode(pUrl) {
      var node = this.getNode(pUrl);
      if (node === false) {
        return;
      }
      this.element.children(".treeview_tree").jstree("open_node", node);
    },
    closeNode: function closeNode(pUrl) {
      var node = this.getNode(pUrl);
      if (node === false) {
        return;
      }
      this.element.children(".treeview_tree").jstree("close_node", node);
    },
    startContextmenuLayer: function startContextmenuLayer() {
      clearTimeout(this.updateTimerID);
    },
    cleanContextmenuLayer: function cleanContextmenuLayer() {
      this._updateTrigger();
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.AssetTreeView#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.AssetTreeView#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (this.options.urlProvider !== undefined && typeof this.options.urlProvider !== "function") {
        throw new Error("AssetTreeView: option urlProvider must be a function or undefined");
      }
      if (typeof this.options.enableApprovalInfo !== "boolean") {
        throw new Error("AssetTreeView: option enableApprovalInfo must be a boolean");
      }
      if (["progressbar", "number"].includes(this.options.uploadProgressType) === false && this.options.uploadProgressType !== undefined) {
        throw new Error("AssetTreeView: option uploadProgressType should be either undefined, 'progressbar' or 'number'");
      }
      if (this.options.uploadProgressType === undefined) {
        this.options.uploadProgressType = false;
      }
    },
    clear: function clear() {
      foldersInMakingDict = {};
      filesInMakingDict = {};
    },
    _destroy: function _destroy() {
      this.isDead = true;
      clearTimeout(this.updateTimerID);
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../common/FileDropUpload/js/nixps-FileDropUpload.js":291,"../../../nebulaportal/js/assetview/Asset.js":402,"../../CloudflowProgressBar/js/nixps-cloudflow-CloudflowProgressBar.js":70,"../../CloudflowUtil/js/FileOperations.js":87}],53:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var Query = require("../../Table/js/Query.js");
var kMinSec = 5;
var kMaxSec = 2147483.600;

/**
 * @description Create a bucket object, the corresponds with the backend bucket
 * @namespace Bucket
 * @param {Object} pOptions 
 */
function Bucket(pOptions) {
  if (pOptions === undefined || pOptions === null || Array.isArray(pOptions) || _typeof(pOptions) !== "object") {
    throw new Error("Bucket options must be an plain object");
  }
  this.data = structuredClone(pOptions);
  if (typeof this.data.identifier !== "string" || this.data.identifier.length <= 0) {
    throw new Error("Bucket options must contain an identifier");
  }
}

/**
 * @description Create a bucket from a json 
 * @function
 * @static
 * @name Bucket#fromJSON
 * @param {Object} pJSON 
 * @returns Bucket
 */
Bucket.fromJSON = function (pJSON) {
  return new Bucket(pJSON);
};

/**
 * @description Get the first found bucket with corresponds to the specific identification
 * @function
 * @static
 * @name Bucket#fromIdentifier
 * @param {String} pIdentifier The bucket identifier
 * @returns Bucket
 */
Bucket.fromIdentifier = function (pIdentifier) {
  if (typeof pIdentifier !== "string" || pIdentifier.length <= 0) {
    throw new Error("parameter pIdentifier must be a not empty string");
  }
  return new Promise(function (pResolve, pReject) {
    api_async.bucket.list_with_options(["identifier", "equal to", pIdentifier], [], [], {
      skip: 0,
      maximum: 1
    }, function (pResults) {
      if (!Array.isArray(pResults.results)) {
        var error = {
          "error_code": "invalid_response",
          "error": "invalid response " + pIdentifier
        };
        console.error(error);
        pReject(error);
        return;
      }
      if (pResults.results.length === 0) {
        var error = {
          "error_code": "nothing_found",
          "error": "nothing found " + pIdentifier
        };
        console.error(error);
        pReject(error);
        return;
      }
      if (pResults.results.length > 1) {
        var error = {
          "error_code": "too_many_found",
          "error": "too many found, it not unique " + pIdentifier
        };
        console.error(error);
        pReject(error);
        return;
      }
      pResolve(new Bucket(pResults.results[0]));
    }, function (pError) {
      console.error(pError);
      pReject(pError);
    });
  });
};
function getGroupsFromPolicy(pPolicy) {
  switch (pPolicy) {
    case Bucket.policy.LOAD:
      return ["average", "maximum"];
  }
  return null;
}

/**
 * @description Get all the data needed to display a graph
 * @function
 * @static
 * @name Bucket#getVisualisationData
 * @param {String} pIdentifier the identifier of the bucket to visualise
 * @param {Object} pOptions the options to define the start and end-time range
 * @returns Object containing values, groups, policy
 */
Bucket.getVisualisationData = function (pIdentifier, pOptions) {
  if (!pOptions) {
    pOptions = {};
  }
  // calc the toDate
  var today = new Date();
  var toDate = today.toISOString();
  if (typeof pOptions.end === "string" && pOptions.end.length > 0) {
    toDate = pOptions.end;
  }
  // calc the fromDate
  var fromDate;
  if (typeof pOptions.start === "string" && pOptions.start.length > 0) {
    if (pOptions.start[0] === "$") {
      // dynamic range found, calc it
      var transformedQuery = Query.prepare([pOptions.start]);
      if (Array.isArray(transformedQuery) && transformedQuery.length === 1 && typeof transformedQuery[0] === "string") {
        fromDate = transformedQuery[0];
      }
    } else {
      // static start
      fromDate = pOptions.start;
    }
  } else {
    // fallback and default
    // 6 hours later
    today.setHours(today.getHours() - 6);
    fromDate = today.toISOString();
  }
  return new Promise(function (pResolve, pReject) {
    api_async.bucket.get_visualization_data(pIdentifier, fromDate, toDate, {}, function (pResult) {
      if (Array.isArray(pResult.values)) {
        var options = {
          stacked: false
        };
        // filter out the same "whens", use only the last one
        var seen = new Set();
        //we could take the average, but seems like same whens have the same values anyway...
        pResult.values = pResult.values.reverse().filter(function (pValue) {
          if (seen.has(pValue.when)) {
            return false;
          } else {
            seen.add(pValue.when);
            return true;
          }
        }).reverse();
        if (pResult.values > 300) {
          pResult.values = pResult.values.slice(pResult.values.length - 300);
        }
        // make values of value
        if (pResult.values.length > 0) {
          if (pResult.multiple) {
            options.stacked = _typeof(pResult.values[0].values.total) === "object" && Array.isArray(pResult.values[0].values.total) === false;
          }
        }
        pResult.groups = getGroupsFromPolicy(pResult.policy);
        pResult.options = options;
        pResolve(pResult);
      } else {
        var error = {
          "error_code": "wrong_return_interface",
          "error": "wrong returning interface"
        };
        console.error(error);
        pReject(error);
      }
    }, function (pError) {
      console.error(pError);
      pReject(pError);
    });
  });
};
Bucket.prototype = {
  constructor: Bucket,
  /**
   * @description returns the identiefier of the bucket, the unique id for the backend
   * @function
   * @name Bucket.getIdentifier
   * @returns identifier
   */
  getIdentifier: function getIdentifier() {
    return this.data.identifier;
  },
  /**
   * @description returns the policy of the bucket
   * @function
   * @name Bucket.getPolicy
   * @returns policy
   */
  getPolicy: function getPolicy() {
    return this.data.policy;
  },
  getMaximumAge: function getMaximumAge() {
    if (this.data.history !== undefined && typeof this.data.history.maximum_age === "number" && this.data.history.maximum_age > 0) {
      return this.data.history.maximum_age;
    }
    return null;
  },
  /**
   * @description returns the refresh rate the ui can use. If returns zero, do not refresh
   * @function
   * @name Bucket.getRefreshDelay
   * @returns {Number} the refresh rate
   */
  getRefreshDelay: function getRefreshDelay() {
    if (this.data.history !== undefined) {
      if (this.data.history.enabled !== true) {
        // the refresh is disabled
        return 0;
      } else if (this.data.history.interval < kMinSec) {
        // the interval is too small, use the minimum interval
        return kMinSec * 1000;
      } else if (this.data.history.interval > kMaxSec) {
        // this interval let crashes the setTimeout in js,
        // since it is a big number of multiple days, do not refresh 
        return 0;
      } else {
        // the interval is in sec, transform to milliseconds
        return this.data.history.interval * 1000;
      }
    } else {
      // if no history, the refresh is disabled
      return 0;
    }
  },
  clone: function clone() {
    return Bucket.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    if (this.data === undefined || this.data === null) {
      return {};
    }
    return structuredClone(this.data);
  }
};

/**
 * @enum
 * @type {String}
 */
Bucket.policy = Object.freeze({
  "KPI": "kpi",
  "PREPAID": "prepaid",
  "QUOTA": "quota",
  "LOAD": "load"
});
module.exports = Bucket;

},{"../../Table/js/Query.js":211}],54:[function(require,module,exports){
"use strict";

/* 
 * Chech the version numbers of the 3rd-parties we rely on. 
 * If by accident an other version is installed, inform the use by adding a web consle message
 * @author Guillaume Desmet
 */
(function () {
  // go and check the jQuerys
  check();
  function check() {
    // check jQuery core
    checkjQuery();
    // check jQuery UI
    checkjQueryUI();
    // checkown plugins
    checkOwnStuff();
    // check if doctype if include ... has influance on css!
    checkDoctype();
    // check underscore plugin 
    checkUnderscore();
  }
  function checkjQuery() {
    if (window.$ === undefined) {
      console.error("jQuery is required and not found");
    } else if ($.fn === undefined) {
      console.error("jQuery fn is required and not found");
    } else if (typeof $.fn.jquery !== "string" || $.fn.jquery.length <= 0) {
      console.error("jQuery version is missing");
    } else {
      var versionArray = $.fn.jquery.split(".");
      if (versionArray.length !== 3) {
        console.error("jQuery version has wrong format");
      }
      var currentVersion = [3, 6, 3];
      if (versionArray[0] < currentVersion[0]) {
        console.error("your jQuery is too old, use a " + currentVersion.join(".") + " version");
      } else if (versionArray[0] > currentVersion[0]) {
        console.warn("your jQuery is too recent, use a " + currentVersion.join(".") + " version");
      } else if (versionArray[1] < currentVersion[1]) {
        console.error("your jQuery is too old, use a " + currentVersion.join(".") + " version");
      }
    }
  }
  function checkjQueryUI() {
    if (window.$ === undefined) {
      console.error("jQuery is required and not found");
    } else if ($.ui === undefined) {
      console.error("jQuery UI is required and not found");
    } else if (typeof $.ui.version !== "string" || $.ui.version.length <= 0) {
      console.error("jQuery UI version is missing");
    } else {
      var versionArray = $.ui.version.split(".");
      if (versionArray.length !== 3) {
        console.error("jQuery UI version has wrong format");
      }
      var currentVersion = [1, 13, 2];
      if (versionArray[0] < currentVersion[0]) {
        console.error("your jQuery UI is too old, use " + currentVersion.join(".") + " version");
      } else if (versionArray[0] > currentVersion[0]) {
        console.error("your jQuery UI is too recent, use a " + currentVersion.join(".") + " version");
      } else if (versionArray[1] < currentVersion[1]) {
        console.error("your jQuery UI is too old, use a " + currentVersion.join(".") + " version");
      }
    }
  }
  function checkUnderscore() {
    if (typeof _ !== "function") {
      console.error("please include undercore plugin");
    } else {
      var version = _.VERSION;
      if (typeof version !== "string" || version.length <= 0) {
        console.error("undercore plugin has wrong version number");
      } else {
        var versionArray = version.split(".");
        if (versionArray.length !== 3) {
          console.error("undercore plugin has wrong version number");
        } else {
          var currentVersion = [1, 13, 8];
          if (versionArray[0] < currentVersion[0]) {
            console.error("your underscore is too old, use " + currentVersion.join(".") + " version");
          } else if (versionArray[0] > currentVersion[0]) {
            console.error("your underscore is too recent, use a " + currentVersion.join(".") + " version");
          } else if (versionArray[1] < currentVersion[1]) {
            console.error("your underscore is too old, use a " + currentVersion.join(".") + " version");
          }
        }
      }
    }
  }
  function checkDoctype() {
    if (document.doctype === null) {
      console.error("please include <!DOCTYPE html> at the beginning of your webpage.");
    }
  }
  function checkOwnStuff() {
    if (window.$ === undefined || $.i18n === undefined) {
      console.error("translation plugin i18n is missing");
    }
  }
})();

},{}],55:[function(require,module,exports){
"use strict";

(function ($) {
  require('../../DropDownMenu/js/nixps-cloudflow-DropDownMenu.js');
  require('../../LicenseBanner/js/nixps-cloudflow-LicenseBanner.js');
  require('../../FormElements/js/nixps-cloudflow-Image.js');
  var User = require('../../User/js/User.js');
  var Sites = require('../../Sites/js/Sites.js');
  var Version = require('../../Version/js/Version.js');
  var scopesFactory = require('../../Scopes/js/Scopes.js');
  var redirectToLogin = require("../../CloudflowInit/js/redirectToLogin.js");

  // Cached scopes
  var kScopes;
  var loginScopes;
  function getUserLanguage() {
    console.warn("Provide the CloudflowBar with a valid option language");
    return $.Deferred(function (pDefer) {
      api_async.preferences.get_for_current_user("", "", function (pResults) {
        pDefer.resolve(pResults.preferences.language);
      }, pDefer.reject);
    });
  }

  // Returns the list of scopes
  function getScopes() {
    return $.Deferred(function (defer) {
      // if the scopes are in cache, use the cache then
      if (Array.isArray(kScopes) && kScopes.length > 0) {
        defer.resolve(kScopes);
        return;
      }
      // default behavior
      // if user component is not found or if user has no specific scope, (he/she has all scopes)
      $.when(new scopesFactory()).done(function (pResult) {
        // make a array
        kScopes = $.map(pResult.scopes, function (object, key) {
          return $.extend({}, {
            _id: key
          }, object);
        });
        // sort array
        kScopes = kScopes.sort(function (scopeA, scopeB) {
          if (scopeA.name === scopeB.name) {
            return 0;
          } else if (scopeA.name < scopeB.name) {
            return -1;
          }
          return 1;
        });
        defer.resolve(kScopes);
      }).fail(defer.reject);
    });
  }

  /**
   * @namespace nixps-cloudflow.CloudflowBar
   * @description This is a top bar containing the cloudflow icon, scopes selection
   * and show some information about the user. Also a logout functionality must be aviable.
   * @version 1.4.0
   * @deprecated Since 20.04 we will not support this component. This component has been removed in the Nebula style.
   */
  $.widget('nixps-cloudflow.CloudflowBar', {
    version: "1.5.0",
    options: {
      /**
       * @description The language of the user
       * @name nixps-cloudflow.CloudflowBar#language
       * @type {String}
       * @default "en"
       * @since 1.5.0
       */
      language: "en",
      /**
       * @name nixps-cloudflow.CloudflowBar#user
       * @description The user object, if this is null the component itself will retrieve its information.
       * Provide this only if you can limit the api-calls
       * @type {Object.<User>}
       * @default null
       */
      user: null,
      /**
       * @description Set on true if the username should be shown in the navigation bar
       * @name nixps-cloudflow.CloudflowBar#showUserMenu
       * @type {Boolean}
       * @default true
       */
      showUserMenu: true,
      /**
       * @description Items of the dropDownMenu.
       * This is a array containing the items, links that will the show in the order of the array.
       * Each element is a object containing information about the link action.
       * <ul>
       * <li>the parameter "text" will be the text we show to the user. If you use the translation key. The translated text will be show.
       * We encourage the programmer to use a translation key.</li>
       * <li>the parameter "action": is the action that will be taken:
       *  <ul>
       *      <li> logout: you will be loged out (remove cookies) and redirection to the login page will follow </li>
       *      <li> logout_and_keep: you will be loged out (remove cookies) and redirection to the login page will follow with a orig paramam</li>
       *      <li> logout_and_redirect: you will be logd out (remove cookies) and redirected to the parameter url </li>
       *  </ul>
       * </li>
       * <li>the parameter "url": the url that will be followed (only if there is no action filled in or in action(logout and redirect))</li>
       * <li>the parameter "new_url": the url that will be followed (only if there is no action filled in or in action(logout and redirect))
       * and this will open in a new window</li>
       * <li>the parameter "admin_only": the item will only be show when user is a admin</li>
       * </ul>
       * @name nixps-cloudflow.CloudflowBar#userMenu
       * @type {Array.<Object>}
       * @example [{
          text: 'nixps-cloudflow-CloudflowBar.preferences',
          url: '/?user_preferences=1'
          },
          {
          text: 'nixps-cloudflow-CloudflowBar.logout',
          action: {
              type: 'logout'
          },
          {
          text: 'Logout and redirect',
          action: {
              type: 'logout_and_redirect'
          },
          url: 'http://www.deredactie.be'
      }]
       */
      userMenu: [{
        text: 'nixps-cloudflow-CloudflowBar.preferences',
        url: '/?user_preferences=1'
      }, {
        text: 'nixps-cloudflow-CloudflowBar.manual',
        translated_url: '/manual/<lang>/webhelp/index.html',
        new_url: '/manual/en/webhelp/index.html',
        admin_only: true
      }, {
        text: 'nixps-cloudflow-CloudflowBar.api_manual',
        new_url: '/portal.cgi?api',
        admin_only: true
      }, {
        text: 'nixps-cloudflow-CloudflowBar.inspect_tabels',
        new_url: '/mongoCloud/mongoCloud.html',
        admin_admin_only: true
      }, {
        text: 'nixps-cloudflow-CloudflowBar.frame_settings',
        new_url: 'http://127.0.0.1:9091/frameCGI/Resource/Web/Frame/preferences.html',
        classes: 'frame-os-setup-feature-block'
      }, {
        text: 'nixps-cloudflow-CloudflowBar.logout',
        action: {
          type: 'logout_and_keep'
        }
      }],
      /**
       * @description the versionobject, this can be used to speed up the pages
       * @name nixps-cloudflow.CloudflowBar#versionObject
       * @type {Object}
       * @default null
       * @private
       */
      versionObject: null,
      /**
       * @desc True if the scope selector must be shown in the navigation bar.
       *       In case the user is not admin, it won't show the scope selector: if put on false
       * @name nixps-cloudflow.CloudflowBar#showScopeSelector
       * @type {Boolean}
       * @default false
       */
      showScopeSelector: false,
      /**
       * @description Must we show the loging scopes or not?
       * @type {Boolean}
       * @default false
       * @private 
       */
      enableLoginScopes: false,
      /**
       * @description Show the selector for other sites, even if set on true, it can be hidden if just one site is known
       * @name nixps-cloudflow.CloudflowBar#showSitesSelector
       * @type {Boolean}
       * @default false
       */
      showSitesSelector: false,
      /**
       * @description Must we show the license banners or not?
       * @name nixps-cloudflow.CloudflowBar#showLicenseBanner
       * @type {Boolean}
       * @default true
       * @since 1.1.0
       */
      showLicenseBanner: true,
      /**
       * @desc The username to display
       * @name nixps-cloudflow.CloudflowBar#username
       * @type {String}
       * @default 'username'
       */
      username: 'username',
      /**
       * @description The title visible in the header, at the left side of the bar
       * @name nixps-cloudflow.CloudflowBar#title
       * @type {String}
       * @default Cloudflow
       */
      title: 'Cloudflow',
      /**
       * @description The url of the icon to show on the topbar at the left side.
       * @name nixps-cloudflow.CloudflowBar#iconLogo
       * @type {String}
       * @default ''
       */
      iconLogo: '',
      /**
       * @description The url to go when user click on the icon logo
       * @name nixps-cloudflow.CloudflowBar#linkIconClick
       * @type {String}
       * @default "/portal.cgi"
       * @since 1.2.0
       */
      linkIconClick: "/portal.cgi",
      /**
       * @description If the url is a relative path and if this options is given, add this as relative path to make it a static one
       * @name nixps-cloudflow.CloudflowBar#relativeBasePath
       * @type {String}
       * @default ""
      */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.CloudflowBar#logout
       * @description Define here your own logout function. This will replace the redirections.
       * @type {Function}
       * @default null
       */
      logout: null,
      /**
       * @name nixps-cloudflow.CloudflowBar#style_type
       * @description The type of style you want to apply
       * @type {String}
       * @private
       */
      style_type: "default",
      created: function created() {}
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type);
      this.element.css('transition', 'none');

      // variables
      this.isAdmin = false;
      this.isAdminAdmin = false;
      this.language = typeof this.options.language !== "string" ? "en" : this.options.language;
      this.userDef;
      var title = $('<div>').addClass('title').append($('<span>').addClass('text')._t(this.options.title));
      var iconURL;
      var relativeBasePath;
      if (this.options.iconLogo.length === 0) {
        iconURL = "/cloudflow/CloudflowBar/css/images/logo.svg";
        relativeBasePath = "";
      } else {
        iconURL = this.options.iconLogo;
        relativeBasePath = this.options.relativeBasePath;
      }
      title.prepend($('<div>').addClass('logoIcon').Image({
        'url': iconURL,
        'width': null,
        'height': null,
        'relativeBasePath': relativeBasePath,
        'precalculatedOnly': false
      }));
      title.appendTo(this.element);
      var arrowDownIcon;
      if (this.options.style_type === "default") {
        arrowDownIcon = $('<img>').addClass('arrowDown').attr('src', '/cloudflow/CloudflowBar/css/images/arrowDown.png');
      } else {
        arrowDownIcon = $('<span>').addClass('arrowDownIcon fa fa-angle-down');
      }
      $('<div>').addClass("licensebanner").hide().appendTo(this.element);
      $('<div>').addClass('user button').hide().append($('<span>').addClass('helloText')._t('nixps-cloudflow-CloudflowBar.hello_text')).append($('<span>').addClass('username').attr('title', this.options.username).text(this.options.username)).append($('<img>').addClass('profilePicture').attr('src', '/cloudflow/CloudflowBar/css/images/user.svg')).append(arrowDownIcon.clone().hide()).appendTo(this.element);
      $('<div>').addClass('scopes button').hide().append($('<span>').addClass('text')._t('nixps-cloudflow-CloudflowBar.all_scopes')).append(arrowDownIcon.clone()).appendTo(this.element);
      $('<div>').addClass('sites button').hide().append($('<span>').addClass('text')._t('nixps-cloudflow-CloudflowBar.all_sites')).append(arrowDownIcon.clone()).appendTo(this.element);
      var that = this;
      this.userDropDownMenu = $();
      this.scopesDropDownMenu = $();
      this.sitesDropDownMenu = $();
      var usermenuDef = {};
      var siteDef = {};
      var scopeDef = {};
      var versionDef = {};

      // add user menu logic
      if (this.options.showUserMenu === true && Array.isArray(this.options.userMenu) && this.options.userMenu.length > 0 || this.options.enableLoginScopes === true) {
        var userLanguage;
        if (this.options.user === null) {
          this.userDef = User.get();
        } else {
          this.userDef = this.options.user;
        }
        if (typeof this.options.language !== "string") {
          userLanguage = getUserLanguage().done(function (pLanguage) {
            that.options.langauge = pLanguage;
            that.options.language = pLanguage;
          });
        } else {
          userLanguage = this.options.language;
        }
        usermenuDef = $.when(this.userDef, userLanguage).done(function (user, language) {
          that.isAdmin = user.hasAdminPermissions(); // all user with admin rights
          that.isAdminAdmin = user.hasPermission('ADMIN'); // the only user who installed the all system
          that.language = language;
          that._filterUserItems();
          // show downlist arrow
          that.element.find(".user.button .arrowDown, .user.button .arrowDownIcon").css("display", "");
          // activate event listeneres
          that._on(that.element, {
            'click .user.button': that._userButtonClickHandler
          });
        });
      }

      // add site menu logic
      if (this.options.showSitesSelector === true) {
        this.sitesUtilObject;
        siteDef = Sites.get().then(function (pSitesUtilObj) {
          that.sitesUtilObject = pSitesUtilObj;
          if (pSitesUtilObj !== undefined && pSitesUtilObj.areMultipleSites() === true) {
            that.element.find('.sites.button').show();
            that.element.find('.sites.button .text').text(pSitesUtilObj.getCurrentSite().name);
          }
        });
      }
      this._delay(function () {
        this._draw();
        if (this.options.showScopeSelector === true) {
          scopeDef = getScopes().then(function (scopes) {
            // fallback if we get just one scope/ there is nothing to choose of,
            // hide it.
            if (scopes.length <= 1) {
              that.element.find('.scopes').hide();
              return true;
            }
            for (var i = 0; i < scopes.length; i++) {
              if (scopes[i]._id === $.cookie('scope')) {
                that.element.find('.scopes.button .text').text(scopes[i].name);
                break;
              }
            }
          }, function (pError) {
            // if error hide scopes
            that.element.find('.scopes').hide();
          });
        } else if (this.options.enableLoginScopes === true) {
          scopeDef = $.when(this.userDef).then(function (pUser) {
            return $.when(scopesFactory.getLoginScopes(pUser)).then(function (pLoginScopes) {
              if (Array.isArray(pLoginScopes)) {
                loginScopes = pLoginScopes;
                if (loginScopes.length <= 1) {
                  that.element.find('.scopes').hide();
                  return true;
                }
                for (var i = 0; i < loginScopes.length; i++) {
                  if (loginScopes[i]._id === $.cookie('scope')) {
                    that.element.find('.scopes.button .text').text(loginScopes[i].name);
                    break;
                  }
                }
              } else {
                that.element.find('.scopes').hide();
              }
            });
          }, function (pError) {
            // if error hide scopes
            that.element.find('.scopes').hide();
          });
        }
        if (this.options.showLicenseBanner === true) {
          this.element.children(".licensebanner").LicenseBanner({
            "user": this.options.user
          });
        }
      }, 50);
      versionDef = this._getAndAddVersionToolTip();
      this._on(this.element, {
        'click .user.button': this._userButtonClickHandler,
        'click .scopes.button': this._scopesButtonClickHandler,
        'click .sites.button': this._sitesButtonClickHandler,
        'click .logoIcon img': this._mainIconClickHandler
      });
      this._on(document, {
        'click :not(.nixps-cloudflow-CloudflowBar > .scopes.button)': this._clickOnDocumentClickHandler,
        'click :not(.nixps-cloudflow-CloudflowBar > .sites.button)': this._clickOnDocumentClickHandler
      });
      $.when(usermenuDef, siteDef, scopeDef, versionDef).always(function () {
        that.options.created();
      });
    },
    /**
     * @description function runs when user press a button of the dropdown menu.
     * This handle both the scopes and user menu
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowBar#_dropDownMenuItemClickedHandler
     * @param {type} event
     * @param {type} data
     * @returns {undefined}
     */
    _dropDownMenuItemClickedHandler: function _dropDownMenuItemClickedHandler(event, data) {
      if ($.isPlainObject(data.action) === false) {
        return;
      }
      var that = this;
      var type = data.action.type;
      if (type === 'logout_and_keep') {
        api_defer.auth.logout().always(function () {
          $.cookie('user_id', null, {
            path: '/'
          });
          $.cookie('user_hash', null, {
            path: '/'
          });
          $.cookie('expiration_date', null, {
            path: '/'
          });
          if (typeof that.options.logout === "function") {
            that.options.logout();
          } else {
            redirectToLogin(true);
          }
        });
      } else if (type === 'logout') {
        api_defer.auth.logout().always(function () {
          $.cookie('user_id', null, {
            path: '/'
          });
          $.cookie('user_hash', null, {
            path: '/'
          });
          $.cookie('expiration_date', null, {
            path: '/'
          });
          if (typeof that.options.logout === "function") {
            that.options.logout();
          } else {
            redirectToLogin();
          }
        });
      } else if (type === 'logout_and_redirect') {
        api_defer.auth.logout().always(function () {
          $.cookie('user_id', null, {
            path: '/'
          });
          $.cookie('user_hash', null, {
            path: '/'
          });
          $.cookie('expiration_date', null, {
            path: '/'
          });
          if (typeof that.options.logout === "function") {
            that.options.logout();
          }
        });
      } else if (type === 'all_scopes') {
        this.element.find('.scopes.button .text')._t('nixps-cloudflow-CloudflowBar.all_scopes');
        $.cookie("scope", "", {
          path: '/'
        });
        window.location.reload();
      } else if (type === 'scope') {
        this.element.find('.scopes.button .text').text(data.action.name);
        $.cookie("scope", data.action.id, {
          path: '/'
        });
        window.location.reload();
      } else if (type === 'goToOtherSite') {
        // only go further if you ready go to other site
        if (this.sitesUtilObject.getCurrentSite().name !== data.action.name) {
          this.element.find('.sites.button .text').text(data.action.name);
          var username = new User().getUserName();
          var currentLocation = window.location.href;
          var goToUrl = currentLocation.replace(/.*\?([^&]+).*/g, "$1");
          if (goToUrl === window.location.href) {
            goToUrl = "home=1";
          }
          // go to the other site ...
          this.sitesUtilObject.redirectTo(data.action.name, username, goToUrl).done(function (pUrl) {
            window.location = pUrl;
          });
        }
      }
    },
    /**
     * @description function runs when user clcik on scopes selection
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowBar#_scopesButtonClickHandler
     * @param {object} event
     * @returns {undefined}
     */
    _scopesButtonClickHandler: function _scopesButtonClickHandler(event) {
      this._hideAllDropDownMenus();
      event.stopPropagation();
      if (Array.isArray(loginScopes) && loginScopes.length > 0) {
        this._drawScopesDowndown(loginScopes);
      } else {
        getScopes().then(this._drawScopesDowndown.bind(this));
      }
    },
    _drawScopesDowndown: function _drawScopesDowndown(pScopes) {
      var items = $.map(pScopes, function (scope) {
        return {
          text: scope.name,
          action: {
            type: 'scope',
            id: scope._id,
            name: scope.name
          }
        };
      });
      this.scopesDropDownMenu = $('<div>').DropDownMenu({
        items: items,
        style_type: this.options.style_type
      }).addClass('scopesDropDown').css({
        width: this.element.find('.scopes.button').width(),
        display: 'none' //same as .hide()
      }).appendTo('body');
      this.scopesDropDownMenu.position({
        my: 'left top',
        at: 'left bottom',
        of: this.element.find('.scopes.button'),
        collision: 'none'
      }).css({
        zIndex: 100000
      }).show();
      this._on(this.scopesDropDownMenu, {
        'dropdownmenuitemclicked': this._dropDownMenuItemClickedHandler
      });
    },
    /**
     * @brief hides all the dropdown menus
     * @private
     * @name nixps-cloudflow.CloudflowBar#_hideAllDropDownMenus
     */
    _hideAllDropDownMenus: function _hideAllDropDownMenus() {
      // Hide the dropdown menus
      this.userDropDownMenu.remove();
      this.userDropDownMenu = $();
      this.scopesDropDownMenu.remove();
      this.scopesDropDownMenu = $();
      this.sitesDropDownMenu.remove();
      this.sitesDropDownMenu = $();
    },
    /**
     * @brief handles clicks on document
     * @private
     * @name nixps-cloudflow.CloudflowBar#_clickOnDocumentClickHandler
     */
    _clickOnDocumentClickHandler: function _clickOnDocumentClickHandler(event) {
      this._hideAllDropDownMenus();
    },
    /**
     * @brief handles clicks on the user button
     * @private
     * @name nixps-cloudflow.CloudflowBar#_userButtonClickHandler
     */
    _userButtonClickHandler: function _userButtonClickHandler(event) {
      this._hideAllDropDownMenus();
      event.preventDefault();
      event.stopPropagation();
      // hide, append and show after,
      // so we do not trigger tempory overflow that causes a scrollbar to shift the menu
      this.userDropDownMenu = $('<div>').DropDownMenu({
        items: this.options.userMenu,
        style_type: this.options.style_type
      }).hide().appendTo('body');
      this.userDropDownMenu.position({
        my: 'right top',
        at: 'right bottom',
        of: this.element.find('.user.button'),
        collision: 'none'
      }).css({
        zIndex: 100000
      }).show();
      this._on(this.userDropDownMenu, {
        'dropdownmenuitemclicked': this._dropDownMenuItemClickedHandler
      });
    },
    _sitesButtonClickHandler: function _sitesButtonClickHandler(pEvent, pData) {
      this._hideAllDropDownMenus();
      pEvent.preventDefault();
      pEvent.stopPropagation();
      if (this.sitesUtilObject !== undefined) {
        var sites = this.sitesUtilObject.getSites();
        var sitesMenu = [];
        for (var i = 0; i < sites.length; i++) {
          sitesMenu.push({
            text: sites[i].name,
            action: {
              type: 'goToOtherSite',
              name: sites[i].name
            }
          });
        }
        this.sitesDropDownMenu = $('<div>').DropDownMenu({
          items: sitesMenu,
          style_type: this.options.style_type
        }).hide().appendTo('body');
        this.sitesDropDownMenu.position({
          my: 'right top',
          at: 'right bottom',
          of: this.element.find('.sites.button'),
          collision: 'none'
        }).css({
          zIndex: 100000
        }).show();
        this._on(this.sitesDropDownMenu, {
          'dropdownmenuitemclicked': this._dropDownMenuItemClickedHandler
        });
      }
    },
    /**
     * @description functio runs when user clicked on the icon
     * @name nixps-cloudflow.CloudflowBar#_mainIconClickHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _mainIconClickHandler: function _mainIconClickHandler(pEvent, pData) {
      if (typeof this.options.linkIconClick === "string" && this.options.linkIconClick.length > 0) {
        window.location = this.options.linkIconClick;
      }
    },
    _draw: function _draw() {
      if (this.options.showUserMenu === true) {
        this.element.find('.user.button').show();
      } else {
        this.element.find('.user.button').hide();
      }
      if (this.options.showScopeSelector === true || this.options.enableLoginScopes === true) {
        this.element.find('.scopes.button').css('display', '');
      } else {
        this.element.find('.scopes.button').hide();
      }
      if (this.options.showSitesSelector === false) {
        this.element.find('.sites.button').hide();
      } else {}
      this.element.css('transition', '');
    },
    _scopeChangedHandler: function _scopeChangedHandler(event) {
      var selector = $(event.target);
      $.cookie("scope", selector.val(), {
        path: '/'
      });
      window.location.reload();
    },
    _getAndAddVersionToolTip: function _getAndAddVersionToolTip() {
      if ($.isPlainObject(this.options.versionObject) && $.isEmptyObject(this.options.versionObject) === false) {
        var version = new Version(this.options.versionObject);
        this.element.find('.title .text').attr('title', version.toString());
        return version;
      } else {
        var that = this;
        return Version.get().then(function (version) {
          that.element.find('.title .text').attr('title', version.toString());
        });
      }
    },
    /**
     * @description remove all "admin_only" items if user is not a admin
     * @private
     * @name nixps-cloudflow.CloudflowBar#_filterUserItems
     * @returns {undefined}
     */
    _filterUserItems: function _filterUserItems() {
      if (this.isAdmin === false) {
        for (var i = 0; i < this.options.userMenu.length; i++) {
          // if parameter admin_only in on true in a not admin user, replace item by undefined
          if ($.isPlainObject(this.options.userMenu[i]) && (this.options.userMenu[i].admin_only === true || this.options.userMenu[i].admin_admin_only === true)) {
            delete this.options.userMenu[i];
          }
        }
        // remove undefineds from array
        this.options.userMenu = $.map(this.options.userMenu, function (elem) {
          return elem;
        });
      } else if (this.isAdminAdmin === false) {
        for (var i = 0; i < this.options.userMenu.length; i++) {
          // if parameter admin_only in on true in a not admin user, replace item by undefined
          if ($.isPlainObject(this.options.userMenu[i]) && this.options.userMenu[i].admin_admin_only === true) {
            delete this.options.userMenu[i];
          }
        }
        // remove undefineds from array
        this.options.userMenu = $.map(this.options.userMenu, function (elem) {
          return elem;
        });
      }

      // search for the correct language url, and replace the dedicated url, if nothing found, leave the old url
      for (var i = 0; i < this.options.userMenu.length; i++) {
        if ($.isPlainObject(this.options.userMenu[i]) && typeof this.options.userMenu[i].translated_url === "string" && this.options.userMenu[i].translated_url.length > 0) {
          this.options.userMenu[i].new_url = this.options.userMenu[i].translated_url.replace("<lang>", this.language);
        }
      }
    },
    /**
     * @description If bar is collapsed, open it, make it bigger
     * @function
     * @name nixps-cloudflow.CloudflowBar#open
     * @returns {undefined}
     */
    open: function open() {
      this.element.removeClass('collapsed');
    },
    /**
     * @description Close the bar, collapse it. Let it dissapear
     * @function
     * @name nixps-cloudflow.CloudflowBar#close
     * @returns {undefined}
     */
    close: function close() {
      this.element.addClass('collapsed');
    },
    /**
     * @description Return the collapse status of the bar. Is the bar open or not?
     * @function
     * @name nixps-cloudflow.CloudflowBar#isOpen
     * @returns {Boolean} return true if the bar is open, or is not collapsed. False if the bar is closed.
     */
    isOpen: function isOpen() {
      return !this.element.hasClass('collapsed');
    },
    _setOption: function _setOption(key, value) {
      if (key === "username") {
        this._super(key, value);
        this._controlOptions();
        this.element.find('.username').attr('title', this.options.username).text(this.options.username);
      } else if (key === "title") {
        this._super(key, value);
        this._controlOptions();
        this.element.children(".title").find('.text')._t(this.options.title);
      } else if (key === "iconLogo") {
        if (this.options.iconLogo !== value) {
          this._super(key, value);
          this._controlOptions();
          if (this.options.iconLogo.length === 0) {
            this.element.children(".title").find('.logoIcon').hide();
          } else {
            var logoIcon = this.element.children(".title").find('.logoIcon');
            if (logoIcon.length === 0) {
              this.element.children(".title").prepend($('<div>').addClass('logoIcon').Image({
                'url': this.options.iconLogo,
                'width': null,
                'height': null,
                'relativeBasePath': this.options.relativeBasePath,
                'precalculatedOnly': false
              }));
            } else {
              logoIcon.css("display", "").Image("option", "url", this.options.iconLogo);
            }
          }
        }
      } else if (key === "relativeBasePath") {
        if (this.options.relativeBasePath !== value) {
          this._super(key, value);
          this._controlOptions();
          this.element.children(".title").find('.logoIcon').Image("option", "relativeBasePath", this.options.relativeBasePath);
        }
      } else if (key === "showScopeSelector") {
        if (this.options.showScopeSelector !== value) {
          this._super(key, value);
          this._controlOptions();
          this._draw();
        }
      } else if (key === "showUserMenu") {
        if (this.options.showUserMenu !== value) {
          this._super(key, value);
          this._controlOptions();
          this._draw();
        }
      } else if (key === "userMenu") {
        this._super(key, value);
        this._controlOptions();
        if (this.options.showUserMenu === true && Array.isArray(value) && value.length > 0) {
          this._filterUserItems();
          this._draw();
        }
      } else if (key === "style_type") {
        if (this.options.style_type !== value) {
          this.element.removeClass("CloudflowStyle_" + this.options.style_type).addClass("CloudflowStyle_" + value);
          if (value === "default") {
            // go back to default
            this.element.find(".arrowDownIcon").replaceWith($('<img>').addClass('arrowDown').attr('src', '/cloudflow/CloudflowBar/css/images/arrowDown.png'));
          } else {
            // go to special case
            this.element.find(".arrowDown").replaceWith($('<span>').addClass('arrowDownIcon fa fa-angle-down'));
          }
        }
        this._super(key, value);
        this._controlOptions();
      } else {
        this._super(key, value);
        this._controlOptions();
      }
    },
    _destroy: function _destroy() {
      this.userDropDownMenu.remove();
      this.scopesDropDownMenu.remove();
      this.sitesDropDownMenu.remove();
      this._super();
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.style_type !== "string") {
        throw new Error('CloudflowBar: invalid input option style_type, it must be a string');
      }
      if (typeof this.options.title !== "string") {
        throw new Error('invalid input option title, it must be a string');
      }
      if (typeof this.options.iconLogo !== "string") {
        throw new Error('input option iconLogo must be a  string');
      }
      if (typeof this.options.showSitesSelector !== "boolean") {
        throw new Error('input option showSitesSelector must be a boolean');
      }
    }
  });
})(jQuery);

},{"../../CloudflowInit/js/redirectToLogin.js":69,"../../DropDownMenu/js/nixps-cloudflow-DropDownMenu.js":105,"../../FormElements/js/nixps-cloudflow-Image.js":149,"../../LicenseBanner/js/nixps-cloudflow-LicenseBanner.js":176,"../../Scopes/js/Scopes.js":204,"../../Sites/js/Sites.js":207,"../../User/js/User.js":268,"../../Version/js/Version.js":269}],56:[function(require,module,exports){
"use strict";

function isValidDate(pDate) {
  if (Object.prototype.toString.call(pDate) === "[object Date]") {
    // it is a date
    if (isNaN(pDate)) {
      // d.getTime() or d.valueOf() will also work
      // date object is not valid
      return false;
    } else {
      // date object is valid
      return true;
    }
  } else {
    return false;
  }
}
var Calendar = function Calendar() {};
Calendar.months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
Calendar.days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
Calendar.visualizationMode = {
  APPOINTMENTS: "Appointments",
  THISAVAILABILITY: "ThisAvailability",
  ALLAVAILABILITY: "AllAvailability"
};
Calendar.empty = function () {
  return {
    name: "",
    description: ""
  };
};
Calendar.getRange = function (pCalendar) {
  var minDateBound;
  var maxDateBound;
  if (pCalendar.valid !== undefined) {
    if (typeof pCalendar.valid.from === "string" && pCalendar.valid.from.length > 0) {
      minDateBound = moment(pCalendar.valid.from).toDate();
    }
    if (typeof pCalendar.valid.until === "string" && pCalendar.valid.until.length > 0) {
      maxDateBound = moment(pCalendar.valid.until).toDate();
    }
  }
  return {
    min: minDateBound,
    max: maxDateBound
  };
};
Calendar.isInRange = function (pCalendar, pDate) {
  var date = pDate;
  if (!moment.isMoment(date)) {
    if (!isValidDate(date)) {
      throw new Error('Invalid date argument! First argument must be a moment object!');
    }
    date = moment(date);
  }
  var range = Calendar.getRange(pCalendar);
  if (range.min !== undefined && date.isBefore(range.min)) {
    return false;
  }
  if (range.max !== undefined && date.isAfter(range.max)) {
    return false;
  }
  return true;
};
Calendar.clampDate = function (pCalendar, pDate) {
  var date = pDate;
  if (!moment.isMoment(date)) {
    if (!isValidDate(date)) {
      throw new Error('Invalid date argument! First argument must be a moment object!');
    }
    date = moment(date);
  }
  var range = Calendar.getRange(pCalendar);
  if (range.min !== undefined && date.isBefore(range.min)) {
    return range.min;
  }
  if (range.max !== undefined && date.isAfter(range.max)) {
    return range.max;
  }
  return date.toDate();
};
Calendar.getFirstAvailableDate = function (pCalendar, pOffset, pFrom) {
  if (pFrom === undefined) {
    pFrom = Date.now();
  }
  for (var i = 0; i < 1000; i++) {
    if (Calendar.isAvailableDate(pCalendar, pFrom, pOffset)) {
      return pFrom;
    }
    pFrom += 24 * 60 * 60 * 1000;
  }
  return pFrom;
};
Calendar.isAvailableDate = function (pCalendar, pTimestamp, pOffset) {
  var date = Calendar.toClosestDay(pTimestamp);
  var min_date = Calendar.toClosestHalfDay(Date.now() + pOffset * 24 * 60 * 60 * 1000);
  var min_date_day = Calendar.toClosestDay(min_date.getTime());
  if (date.getTime() >= min_date_day.getTime() && pCalendar != null) {
    for (var i = 0, len = pCalendar.items.length; i < len; i++) {
      var item = pCalendar.items[i];
      if (item.mode === "unavailable" || item.enabled === undefined || item.valid && (date.getTime() < Calendar.toClosestDay(Date.parse(item.valid.from)).getTime() || date.getTime() > Calendar.toClosestDay(Date.parse(item.valid.until)).getTime()) || item.enabled.months && item.enabled.months[Calendar.months[date.getMonth()]] !== true || item.enabled.days_of_week && item.enabled.days_of_week[Calendar.days[date.getDay()]] !== true || min_date_day.getTime() === date.getTime() && min_date_day.getTime() + item.time_of_day.end * 1000 < min_date.getTime()) {
        continue;
      } else {
        return true;
        break;
      }
    }
  }
  return false;
};
Calendar.toClosestHalfDay = function (pTimestamp) {
  var day = new Date(pTimestamp);
  day.setHours(day.getHours() > 12 ? 12 : 0);
  day.setMinutes(0);
  day.setSeconds(0);
  day.setMilliseconds(0);
  return day;
}, Calendar.toClosestDay = function (pTimestamp) {
  var day = new Date(pTimestamp);
  day.setHours(0);
  day.setMinutes(0);
  day.setSeconds(0);
  day.setMilliseconds(0);
  return day;
};
if (typeof module !== "undefined") {
  module.exports = Calendar;
}

},{}],57:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Nov 7, 2016 10:39:42 AM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @description number of seconds a day has
   * @private
   * @static
   */
  var kOneDaySeconds = 86400;
  function parseSecondsMoment(pDate) {
    return pDate.seconds() + pDate.minutes() * 60 + pDate.hours() * 60 * 60;
  }
  function parseDateString(pMoment) {
    return pMoment.format('YYYY-MM-DD');
  }
  /**
   * @namespace nixps-cloudflow.AddCalendarDialog
   * @description The dialog to change/add new periods or events in a calendar
   * @private
   */
  $.widget("nixps-cloudflow.AddCalendarDialog", $.Widget, {
    options: {
      /**
       * @name nixps-cloudflow.AddCalendarDialog#language
       * @description The language of the user
       * @type {string | language_moment_code}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.AddCalendarDialog#itemID
       * @description The id of the data model. We do nothing with this id, we just give it back when you want to remove or update the item
       * @type {string}
       * @default null
       */
      itemID: null,
      /**
       * @name nixps-cloudflow.AddCalendarDialog#description
       * @description The description of the date event
       * @type {string}
       * @default null
       */
      description: null,
      /**
       * @name nixps-cloudflow.AddCalendarDialog#startTime
       * @description The seconds until the first moment of the day event
       * @type {seconds}
       * @default null
       */
      startTime: null,
      /**
       * @name nixps-cloudflow.AddCalendarDialog#endTime
       * @description The seonds until the end of the day event
       * @type {seconds}
       * @default null
       */
      endTime: null,
      /**
       * @name nixps-cloudflow.AddCalendarDialog#startDate
       * @description Start date of dialog
       * @type {moment}
       * @default null
       */
      startDate: null,
      /**
       * @name nixps-cloudflow.AddCalendarDialog#endDate
       * @description End date of dialog
       * @type {moment}
       * @default null
       */
      endDate: null,
      /**
       * @name nixps-cloudflow.AddCalendarDialog#daysOfWeek
       * @description The days of the week when it needs to repeat
       * @type {object}
       * @default {}
       */
      daysOfWeek: {},
      /**
       * @name nixps-cloudflow.AddCalendarDialog#mode
       * @description the mode of the event, can be "available" or "unavailable"
       * @type {string}
       * @default null
       */
      mode: null,
      /**
       * @name nixps-cloudflow.AddCalendarDialog#minDate
       * @description the minimum date possible to select
       * @type {moment}
       * @default false
       */
      minDate: false,
      /**
       * @name nixps-cloudflow.AddCalendarDialog#maxDate
       * @description the maximum date possible to select
       * @type {moment}
       * @default false
       */
      maxDate: false,
      /**
       * @name nixps-cloudflow.AddCalendarDialog#bottomButtons
       * @description The buttons on the bottom of the panel
       * @type {array}
       * @default ['cancel', 'save']
       */
      bottomButtons: ['cancel', 'save'],
      /**
       * @name nixps-cloudflow.AddCalendarDialog#classes
       * @description The classes to be added to this element
       * @type {String}
       * @default "bootstrap"
       */
      classes: "bootstrap"
    },
    /**
     * @description create the component
     * @name nixps-cloudflow.AddCalendarDialog#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass(this.options.classes);
      this._draw();
      this._on(this.element, {
        'keydown': this._keyDownHandler,
        'change .descriptionInput input': this._descriptionChangeHandler,
        'datetimeselectorchange': this._dateChangeHandler,
        'change input.daysOfWeekInput': this._daysofweekChangeHandler,
        'change select.modeSelector': this._modeChangeHandler,
        'click .startDateEnable': this._enableStartDateClickHandler,
        'click .endDateEnable': this._enableEndDateClickHandler,
        'click button.save': this._saveClickHandler,
        'click button.cancel': this._cancelClickHandler,
        'click .closeIcon': this._cancelClickHandler,
        'click button.remove': this._removeClickHandler,
        'click': this._closeDateTimePickerDialog
      });

      // make it dragable only if mouse clicks on topBar
      this.element.draggable({
        handle: ".topBar"
      });
    },
    /**
     * @description function runs when keydown is detected, when user press a key
     * @function
     * @private 
     * @name nixps-cloudflow.AddCalendarDialog#_keyDownHandler
     * @param {type} event
     * @return {undefined}
     */
    _keyDownHandler: function _keyDownHandler(event) {
      if (!event.isDefaultPrevented() && event.keyCode !== undefined && event.keyCode === $.ui.keyCode.ESCAPE) {
        this._trigger('cancel', null, {});
        this.element.remove();
        event.preventDefault();
      }
    },
    _descriptionChangeHandler: function _descriptionChangeHandler(pEvent, pData) {
      var input = $(pEvent.target).closest('.descriptionInput');
      var inputValue = input.Input('getValue');
      if (typeof inputValue === "string" && inputValue !== this.options.description) {
        this.options.description = inputValue;
        this._trigger('change', null, {});
      }
    },
    /**
     * @description Function runs when user change a date
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_dateChangeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _dateChangeHandler: function _dateChangeHandler(pEvent, pData) {
      if ($.isEmptyObject(pData.date)) {
        if ($(pEvent.target).hasClass('startDateSelector')) {
          // remove startDate
          this.options.startDate = null;
          this.element.find(".startDateDialogField .startDateSelector").hide(); // hide date time selector
          this.element.find(".startDateDialogField .startDateEnable").show(); // show enable text panel
        } else if ($(pEvent.target).hasClass('endDateSelector')) {
          // remove endDate
          this.options.endDate = null;
          this.element.find(".endDateDialogField .endDateSelector").hide(); // hide date time selector
          this.element.find(".endDateDialogField .endDateEnable").show(); // show enable text panel
        } else if ($.isEmptyObject(pData.oldDate) === false) {
          // reset with old value
          $(pEvent.target).DatetimeSelector('setValue', pData.oldDate);
        } else {
          throw new Error('invalid pData date parameter');
        }
      } else {
        var date = pData.date;
        if ($(pEvent.target).hasClass('startDateSelector')) {
          var delta = moment.duration(date.diff(this.options.startDate));
          this.options.startDate = date;
          // set min bould
          this.element.find('.endDateSelector').DatetimeSelector('option', 'minDate', date);
          // add difference to current value 
          var oldValue = this.element.find('.endDateSelector').DatetimeSelector('getValue');
          this.element.find('.endDateSelector').DatetimeSelector('setValue', moment(oldValue).add(delta));
        } else if ($(pEvent.target).hasClass('endDateSelector')) {
          this.options.endDate = date;
        } else if ($(pEvent.target).hasClass('startTimeSelector')) {
          var newStartTime = parseSecondsMoment(date);
          var delta = newStartTime - this.options.startTime;
          this.options.startTime = newStartTime;
          // set minimum bound
          this.element.find('.endTimeSelector').DatetimeSelector('option', 'minDate', date);
          // set new value
          var newEndTime;
          if (this.options.endTime + delta < kOneDaySeconds) {
            newEndTime = moment().hours(0).minutes(0).milliseconds(0).seconds(this.options.endTime + delta);
          } else {
            newEndTime = moment().hours(0).minutes(0).milliseconds(0).seconds(kOneDaySeconds - 1);
          }
          this.element.find('.endTimeSelector').DatetimeSelector('setValue', newEndTime);
        } else if ($(pEvent.target).hasClass('endTimeSelector')) {
          this.options.endTime = parseSecondsMoment(date);
        } else {
          throw new Error('unknown datechange event target');
        }
      }
    },
    /**
     * @description Function runs when user change some days of week settings
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_daysofweekChangeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _daysofweekChangeHandler: function _daysofweekChangeHandler(pEvent, pData) {
      var dayName = $(pEvent.currentTarget).attr('data-dayOfWeek');
      if (typeof dayName === "string" && dayName.length > 0) {
        this.options.daysOfWeek[dayName] = $(pEvent.currentTarget).is(':checked');
        this._trigger('change', null, {});
      }
    },
    /**
     * @description This function runs when user change the mode selector
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_modeChangeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _modeChangeHandler: function _modeChangeHandler(pEvent, pData) {
      this.options.mode = this.element.find('select.modeSelector').val();
      this._trigger('change', null, {});
    },
    /**
     * @description fucntion runs when user click on the start date enable pabel
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_enableStartDateClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _enableStartDateClickHandler: function _enableStartDateClickHandler(pEvent, pData) {
      $(pEvent.currentTarget).hide();
      var defaultValue = this.element.find(".startDateDialogField .startDateSelector").show().DatetimeSelector('getValue');
      if (defaultValue === null) {
        var newValue = this.options.minDate === false ? moment() : this.options.minDate;
        this.element.find(".startDateDialogField .startDateSelector").DatetimeSelector('setValue', newValue);
        this.options.startDate = newValue;
      } else {
        this.options.startDate = defaultValue;
      }
    },
    /**
     * @description function runs when user click on the end enable panel
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_enableEndDateClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _enableEndDateClickHandler: function _enableEndDateClickHandler(pEvent, pData) {
      $(pEvent.currentTarget).hide();
      var defaultValue = this.element.find(".endDateDialogField .endDateSelector").show().DatetimeSelector('getValue');
      if (defaultValue === null) {
        var newValue = this.options.maxDate === false ? moment() : this.options.maxDate;
        this.element.find(".endDateDialogField .endDateSelector").DatetimeSelector('setValue', newValue);
        this.options.endDate = newValue;
      } else {
        this.options.endDate = defaultValue;
      }
    },
    /**
     * @description function runs when user click on the save button
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_saveClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _saveClickHandler: function _saveClickHandler(pEvent, pData) {
      var dataItem = {
        description: "",
        enabled: {
          days_of_week: this.options.daysOfWeek
        },
        mode: this.options.mode
      };
      if (this.options.itemID !== null) {
        dataItem.id = this.options.itemID;
      }
      // description
      if (typeof this.options.description === "string" && this.options.description.length > 0) {
        dataItem.description = this.options.description;
      }
      // timings
      if (typeof this.options.startTime === "number" || typeof this.options.endTime === "number") {
        dataItem.time_of_day = {};
      }
      if (typeof this.options.startTime === "number") {
        dataItem.time_of_day.begin = this.options.startTime;
      }
      if (typeof this.options.endTime === "number") {
        dataItem.time_of_day.end = this.options.endTime;
      }
      // dates
      if (this.options.startDate !== null || this.options.endDate !== null) {
        dataItem.valid = {};
      }
      if (this.options.startDate !== null) {
        dataItem.valid.from = parseDateString(this.options.startDate);
      }
      if (this.options.endDate !== null) {
        dataItem.valid.until = parseDateString(this.options.endDate);
      }
      this._trigger('save', null, dataItem);
      this.element.remove();
    },
    /**
     * @description Function runs when user click on the cancel button
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_cancelClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _cancelClickHandler: function _cancelClickHandler(pEvent, pData) {
      this._trigger('cancel', null, {});
      this.element.remove();
    },
    /**
     * @description This function runs when user click on the remove button
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_removeClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _removeClickHandler: function _removeClickHandler(pEvent, pData) {
      this._trigger('remove', null, {
        id: this.options.itemID
      });
      this.element.remove();
    },
    /**
     * @description function runs when user click on the dialog, this is for closing the dialog 
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_closeDateTimePickerDialog
     * @param {type} pEvent
     * @returns {Boolean}
     */
    _closeDateTimePickerDialog: function _closeDateTimePickerDialog(pEvent) {
      if ($(pEvent.target).closest('.nixps-cloudflow-DatetimeSelector').length > 0) {
        // click on component to show the datetimepicker dialog, do not close it afterwards
        return true;
      }
      // close datetimepicker dialog
      this.element.find('.bootstrap-datetimepicker-widget').next('.input-group-addon').trigger("click");
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps-cloudflow.AddCalendarDialog#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      var topBar = $('<div>').addClass('topBar').each(function () {
        if (that.options.itemID === null) {
          $(this)._t('nixps-cloudflow-addcalendardialog.title');
        } else {
          $(this)._t('nixps-cloudflow-addcalendardialog.title_update');
        }
      });
      var closeIcon = $('<span>').addClass('closeIcon').html('&times').attr('title', $.i18n._('nixps-cloudflow-addcalendardialog.close_title'));
      topBar.append(closeIcon);
      this.element.append(topBar);
      var body = $('<div>').addClass('dialogBody');
      this.element.append(body);

      // the description
      if (typeof this.options.description === "string") {
        var label = $('<label>').addClass("calendar_label_single")._t('nixps-cloudflow-addcalendardialog.label_description_1');
        var input = $('<div>').addClass('descriptionInput').Input({
          //maxLength: 10,
          placeHolder: 'event name',
          type: 'text',
          value: this.options.description,
          classes: "form-control cf-form-control"
        });
        body.append($('<div>').addClass('dialogField').append(label).append(input));
      }

      // the mode
      if (typeof this.options.mode === "string") {
        var select = $('<select>').addClass('modeSelector');
        select.append($('<option>').attr('value', "available")._t('nixps-cloudflow-addcalendardialog.available'))
        //.append($('<option>').attr('value', "appointment")._t('nixps-cloudflow-addcalendardialog.appointment'))
        .append($('<option>').attr('value', "unavailable")._t('nixps-cloudflow-addcalendardialog.unavailable'));
        select.val(this.options.mode);
        var label = $('<label>')._t('nixps-cloudflow-addcalendardialog.label_mode');
        body.append($('<div>').addClass('dialogField').append(label).append(select));
      }

      // start date, should be enabled every time
      var startDateLabel = $('<label>')._t('nixps-cloudflow-addcalendardialog.label_startdate');
      var startDateEnableText = $('<div>').addClass('startDateEnable')._t('nixps-cloudflow-addcalendardialog.enable_startdate');
      var startDate;
      if (this.options.startDate !== null) {
        startDate = this.options.startDate;
      } else {
        startDate = this.options.minDate === false ? moment() : this.options.minDate;
      }
      var startDateSelector = $('<div>').addClass('startDateSelector').DatetimeSelector({
        language: this.options.language,
        format: 'L',
        outputFormat: null,
        /* we want moments */
        startDate: startDate,
        minDate: this.options.minDate,
        // stays static
        maxDate: this.options.maxDate // stays static
      });

      body.append($('<div>').addClass('dialogField startDateDialogField').append(startDateLabel).append(startDateSelector).append(startDateEnableText));
      if (this.options.startDate !== null) {
        startDateSelector.show();
        startDateEnableText.hide();
      } else {
        startDateSelector.hide();
        startDateEnableText.show();
      }

      // end date, should be enabled every time
      var endDateLabel = $('<label>')._t('nixps-cloudflow-addcalendardialog.label_enddate');
      var endDateEnableText = $('<div>').addClass('endDateEnable')._t('nixps-cloudflow-addcalendardialog.enable_enddate');
      var endDate;
      if (this.options.endDate !== null) {
        endDate = this.options.endDate;
      } else {
        startDate = this.options.maxDate === false ? moment() : this.options.maxDate;
      }
      var endDateSelector = $('<div>').addClass('endDateSelector').DatetimeSelector({
        language: this.options.language,
        format: 'L',
        outputFormat: null,
        /* we want moments */
        startDate: endDate,
        minDate: this.options.startDate === null ? false : this.options.startDate,
        maxDate: this.options.maxDate // stays static
      });

      body.append($('<div>').addClass('dialogField endDateDialogField').append(endDateLabel).append(endDateSelector).append(endDateEnableText));
      if (this.options.endDate !== null) {
        endDateSelector.show();
        endDateEnableText.hide();
      } else {
        endDateSelector.hide();
        endDateEnableText.show();
      }
      var startTime;
      if (typeof this.options.startTime === "number") {
        var startTimeLabel = $('<label>')._t('nixps-cloudflow-addcalendardialog.label_starttime');
        startTime = moment().hours(0).minutes(0).milliseconds(0).seconds(this.options.startTime);
        var startTimeSelector = $('<div>').addClass('startTimeSelector').DatetimeSelector({
          language: this.options.language,
          format: 'LT',
          outputFormat: null,
          /* we want moments */
          startDate: startTime,
          calendarIcon: "glyphicon glyphicon-time"
        });
        body.append($('<div>').addClass('dialogField').append(startTimeLabel).append(startTimeSelector));
      }
      if (typeof this.options.endTime === "number") {
        var endTimeLabel = $('<label>')._t('nixps-cloudflow-addcalendardialog.label_endtime');
        var endTimeSelector = $('<div>').addClass('endTimeSelector').DatetimeSelector({
          language: this.options.language,
          format: 'LT',
          outputFormat: null,
          /* we want moments */
          minDate: startTime !== undefined ? startTime : false,
          startDate: moment().hours(0).minutes(0).milliseconds(0).seconds(this.options.endTime),
          calendarIcon: "glyphicon glyphicon-time"
        });
        body.append($('<div>').addClass('dialogField').append(endTimeLabel).append(endTimeSelector));
      }

      // the days of the week
      if ($.isPlainObject(this.options.daysOfWeek) && !$.isEmptyObject(this.options.daysOfWeek)) {
        var weekDays = moment.weekdays();
        weekDays.push(weekDays.shift()); // put sunday at the end if the array
        var field = $('<div>').addClass('dialogField daysOfWeek');
        body.append(field);
        field.append($('<label>')._t('nixps-cloudflow-addcalendardialog.label_daysofweek').addClass('daysOfWeekLabel'));
        field.append($('<label>').append($('<input type="checkbox" class="daysOfWeekInput">').attr('data-dayOfWeek', 'monday').prop('checked', this.options.daysOfWeek['monday'] === true)).append(weekDays[0]));
        field.append($('<label>').append($('<input type="checkbox" class="daysOfWeekInput">').attr('data-dayOfWeek', 'tuesday').prop('checked', this.options.daysOfWeek['tuesday'] === true)).append(weekDays[1]));
        field.append($('<label>').append($('<input type="checkbox" class="daysOfWeekInput">').attr('data-dayOfWeek', 'wednesday').prop('checked', this.options.daysOfWeek['wednesday'] === true)).append(weekDays[2]));
        field.append($('<label>').append($('<input type="checkbox" class="daysOfWeekInput">').attr('data-dayOfWeek', 'thursday').prop('checked', this.options.daysOfWeek['thursday'] === true)).append(weekDays[3]));
        field.append($('<label>').append($('<input type="checkbox" class="daysOfWeekInput">').attr('data-dayOfWeek', 'friday').prop('checked', this.options.daysOfWeek['friday'] === true)).append(weekDays[4]));
        field.append($('<label>').append($('<input type="checkbox" class="daysOfWeekInput">').attr('data-dayOfWeek', 'saturday').prop('checked', this.options.daysOfWeek['saturday'] === true)).append(weekDays[5]));
        field.append($('<label>').append($('<input type="checkbox" class="daysOfWeekInput">').attr('data-dayOfWeek', 'sunday').prop('checked', this.options.daysOfWeek['sunday'] === true)).append(weekDays[6]));
      }
      if (Array.isArray(this.options.bottomButtons) && this.options.bottomButtons.length > 0) {
        var buttonIcons = {
          "remove": "<span class='fa fa-trash-o'></span>"
        };
        var bottomBar = $('<div>').addClass('bottomBar');
        this.element.append(bottomBar);
        for (var i = 0; i < this.options.bottomButtons.length; i++) {
          bottomBar.append($('<button>').addClass('button').addClass(this.options.bottomButtons[i])._t('nixps-cloudflow-addcalendardialog.' + this.options.bottomButtons[i]).attr('title', $.i18n._('nixps-cloudflow-addcalendardialog.' + this.options.bottomButtons[i])).prepend(buttonIcons[this.options.bottomButtons[i]]));
        }
      }
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-cloudflow.AddCalendarDialog#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps-cloudflow.AddCalendarDialog#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error('input option language must be a not empty string');
      }
      if (this.options.startTime !== null && typeof this.options.startTime !== "number") {
        throw new Error('input option startTime must be null or a number');
      }
      if (this.options.endTime !== null && typeof this.options.endTime !== "number") {
        throw new Error('input option endTime must be null or a number');
      }
      if (typeof this.options.startTime === "number" && typeof this.options.endTime === "number" && this.options.startTime > this.options.endTime) {
        throw new Error('input option startTime must become before input option endTime');
      }
      if ($.inArray(this.options.mode, [null, 'available', 'unavailable', 'appointment']) < 0) {
        throw new Error('input option mode is unknown');
      }
      if (Array.isArray(this.options.bottomButtons) && this.options.bottomButtons.length > 0) {
        // contoll input of array
        for (var i = 0; i < this.options.bottomButtons.length; i++) {
          if ($.inArray(this.options.bottomButtons[i], ['remove', 'save', 'cancel']) < 0) {
            throw new Error('input opion bottomButtons contains unknow button: ' + this.options.bottomButtons[i] + ", check the spelling");
          }
        }
      }
      // compare min and max date
      if (moment.isMoment(this.options.minDate) && moment.isMoment(this.options.maxDate) && this.options.minDate.isAfter(this.options.maxDate)) {
        throw new Error('maxDate should come after the minDate');
      }
      // compare start and endtime
      if (moment.isMoment(this.options.startDate) && moment.isMoment(this.options.endDate) && this.options.startDate.isAfter(this.options.endDate)) {
        throw new Error('endDate should come after the startDate');
      }
      // compare mindate and dates
      if (moment.isMoment(this.options.minDate) && moment.isMoment(this.options.startDate) && this.options.minDate.isAfter(this.options.startDate)) {
        throw new Error('startDate should come after the minDate');
      }
      if (moment.isMoment(this.options.minDate) && moment.isMoment(this.options.endDate) && this.options.minDate.isAfter(this.options.endDate)) {
        throw new Error('endDate should come after the minDate');
      }
      // compare maxdate and dates
      if (moment.isMoment(this.options.maxDate) && moment.isMoment(this.options.startDate) && this.options.maxDate.isBefore(this.options.startDate)) {
        throw new Error('startDate should come abefore the maxDate');
      }
      if (moment.isMoment(this.options.maxDate) && moment.isMoment(this.options.endDate) && this.options.maxDate.isBefore(this.options.endDate)) {
        throw new Error('endDate should come before the maxDate');
      }
    }
  });
})(jQuery);

},{}],58:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Oct 12, 2016 5:27:06 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */
(function ($) {
  require('../../../common/Calendar/js/nixps-Calendar.js');
  require('./nixps-cloudflow-AddCalendarDialog.js');

  /**
   * @description number of seconds a day has
   * @static
   * @type Number
   */
  var kOneDaySeconds = 86400;
  function parseSecondsMoment(pDate) {
    return pDate.seconds() + pDate.minutes() * 60 + pDate.hours() * 60 * 60;
  }

  /**
   * @description transform a moment to a date string compatible with the backend
   * @function
   * @static
   * @private
   * @param {moment} pMoment the moment we must transform
   * @returns {string} the moment in format yyyy-mm-dd
   */
  function parseDateString(pMoment) {
    if (window.moment !== undefined && window.moment.isMoment(pMoment) && typeof pMoment.format === "function") {
      return pMoment.format('YYYY-MM-DD');
    } else if (typeof pMoment.toJSON === "function") {
      return pMoment.toJSON().substring(0, 10);
    }
  }
  /**
   * @description The differend posibilities of visualisationMode
   * @static
   * @private
   * @type object
   */
  var visualizationMode = {
    APPOINTMENTS: "Appointments",
    // view mode
    THISAVAILABILITY: "ThisAvailability",
    // editable mode
    ALLAVAILABILITY: "AllAvailability"
  };

  /**
   * @description Control if a object is a valid moment,
   * @function
   * @private
   * @static 
   * @param {object} pMoment - The object to be evaluation
   * @returns {Boolean} true is the obejct is a moment and if the moment is valid, False otherwise
   */
  function isValidMoment(pMoment) {
    return moment.isMoment(pMoment) && pMoment.isValid();
  }

  /**
   * @namespace nixps-cloudflow.CloudflowCalendar
   * @description The Calendar component able to tack with a cloudflow backend
   * @requires moment.js
   * @requires fullcalendar.js
   * @requires nixps-Calendar.js
   */
  $.widget("nixps-cloudflow.CloudflowCalendar", $.Widget, {
    widgetEventPrefix: "cloudflowcalendar",
    options: {
      /**
       * @name nixps-cloudflow.CloudflowCalendar#language
       * @description The language of the user. This must be a moment valid language string.
       * @type {string}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.CloudflowCalendar#id
       * @description The id of the calendar, the calendar_id
       * @type {String}
       * @default ""
       */
      id: "",
      /**
       * @name nixps-cloudflow.CloudflowCalendar#defaultDate
       * @description The start or begin date of the calendar
       * @type {moment}
       * @default now
       */
      defaultDate: undefined,
      /**
       * @name nixps-cloudflow.CloudflowCalendar#visualizationMode
       * @description Whith mode must we use to display?
       * @type {String}
       * @default APPOINTMENTS
       * @example "ALLAVAILABILITY"
       * @example "THISAVAILABILITY"
       */
      visualizationMode: "APPOINTMENTS",
      /**
       * @description Define the possible views for the calendar. This will also define the order of the view buttons of the calendar.
       * The only possible values are: "dayGridMonth","timeGridWeek","timeGridDay". The interfase of the option is the same as the interfase of
       * the header option of fullcalendar
       * @name nixps-cloudflow.CloudflowCalendar#possibleViews
       * @type {string}
       * @default 'dayGridMonth,timeGridWeek,timeGridDay'
       * @example 'dayGridMonth,timeGridWeek,timeGridDay'
       */
      possibleViews: 'dayGridMonth,timeGridWeek,timeGridDay',
      /**
       * @description Define the default view of the calendar. This must be the same interfase as the fullCalendar component option.
       * @name nixps-cloudflow.CloudflowCalendar#defaultView
       * @type {string}
       * @default "dayGridMonth"
       * @example "dayGridMonth"
       */
      defaultView: "dayGridMonth",
      /**
       * @description Which weekdays must we hide? use 0 for Sunday and 6 for Saterday. it mus be a array only containing integer from 0 till 6.
       * use [0,6] to disable weekends.
       * @name nixps-cloudflow.CloudflowCalendar#hiddenDays
       * @type {array}
       * @default []
       * @example [0, 6]
       */
      hiddenDays: [],
      /**
       * @name nixps-cloudflow.CloudflowCalendar#addPeriodsEnable
       * @description Must we be able to add events or not?
       * @type {boolean}
       * @default false
       */
      addPeriodsEnable: false,
      /**
       * @name nixps-cloudflow.CloudflowCalendar#showAddPeriodButton
       * @description Must we be show the button to add a period?
       * @type {boolean}
       * @default true
       */
      showAddPeriodButton: true,
      /**
       * @name nixps-cloudflow.CloudflowCalendar#editPeriodsEnable
       * @description Must it be able to edit and change the current time events?
       * @type {boolean}
       * @default true
       */
      editPeriodsEnable: true,
      calendarData: {}
    },
    /**
     * @description create the component
     * @name nixps-cloudflow.CloudflowCalendar#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      //TODO: add options
      this.minDateBound = this.options.minDate !== undefined ? this.options.minDate : undefined; // the minimnum date the calendar is allowed
      this.maxDateBound = this.options.maxDate !== undefined ? this.options.maxDate : undefined; // the maximum date the calendar is allowed

      // init the language
      if (this.options.language === "en") {
        var browserlanguage = navigator.language || navigator.userLanguage;
        if (typeof browserlanguage === "string" && browserlanguage.length > 0) {
          moment.locale(browserlanguage);
        } else {
          moment.locale("en");
        }
      } else {
        moment.locale(this.options.language);
      }
      var calendar = $('<div>').addClass('cloudflowcalendar_calendar');
      this.element.append(calendar);

      // dates may be on bound itselfs !!
      var that = this;
      this._initDateRange().always(function () {
        that._draw();
      });
      this._on(this.element, {
        'calendarclickadd': this._newPeriodClickHandler,
        'calendardblclickfree': this._calendarDBLClickFreeHandler,
        'calendardblclickperiod': this._calendarDBLClickPeriodHandler,
        'calendarchange': this._calendarChangeHandler
      });
    },
    /**
     * @description function runs when user click on the add new event click button
     * @function
     * @name nixps-cloudflow.CloudflowCalendar#_newPeriodClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _newPeriodClickHandler: function _newPeriodClickHandler(pEvent, pData) {
      if (this._trigger("newperiod", pEvent, pData) !== false) {
        if (!$.isEmptyObject(pData.view)) {
          this._addItemDialog(pData.view.start, pData.view);
        }
      }
    },
    /**
     * @description function runs when user double click on a free time range
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_calendarDBLClickFreeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {Boolean}
     */
    _calendarDBLClickFreeHandler: function _calendarDBLClickFreeHandler(pEvent, pData) {
      if (this.options.addPeriodsEnable === false) {
        // skip adding event is not allowed
        return true;
      }
      var moment = pData.date;
      if (window.moment !== undefined) {
        moment = window.moment(pData.date);
      }
      if (isValidMoment(moment) && this._isInRange(moment) && !$.isEmptyObject(pData.view)) {
        if (this._trigger("dblclickfree", pEvent, pData) !== false) {
          this._addItemDialog(moment, pData.view, pEvent);
        }
      }
    },
    /**
     * @description function runs when user double click on a item/period
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_calendarDBLClickPeriodHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _calendarDBLClickPeriodHandler: function _calendarDBLClickPeriodHandler(pEvent, pData) {
      if (this.options.editPeriodsEnable === true && !$.isEmptyObject(pData.period) && typeof pData.period.id === "string") {
        var that = this;
        this._getItemFromBackend(pData.period.id).done(function (pDataItem) {
          if (that._trigger("dblclickperiod", pEvent, pDataItem) !== false) {
            that._showItemDialog(pDataItem, pEvent, true);
          }
        });
      }
    },
    /**
     * @description function runs when a change event comes from the plugin, when user draged the events
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_calendarChangeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _calendarChangeHandler: function _calendarChangeHandler(pEvent, pData) {
      if ($.isEmptyObject(pData.changedPeriod)) {
        throw new Error('invalid event data, pData.changedPeriod is required');
      }
      var start = moment(pData.changedPeriod.start);
      var end = moment(pData.changedPeriod.end);
      var deltaStart = pData.deltaStart;
      var deltaEnd = pData.deltaEnd;
      if (isValidMoment(start) && isValidMoment(end) && typeof pData.changedPeriod.id === "string") {
        if (this._isInRange(start) === false || this._isInRange(end) === false) {
          // if not in range, do no updating
          if (typeof pData.errorCB === "function") {
            pData.errorCB();
          }
          return false;
        }
        // we are in range, do the updating
        var that = this;
        this._getItemFromBackend(pData.changedPeriod.id).done(function (pDataItem) {
          if ($.isPlainObject(pDataItem.valid) && typeof pDataItem.valid.from === "string" && typeof pDataItem.valid.until === "string") {
            pDataItem.valid.from = parseDateString(moment(pDataItem.valid.from).add(deltaStart.days(), 'days'));
            pDataItem.valid.until = parseDateString(moment(pDataItem.valid.until).add(deltaStart.days(), 'days'));
          }
          var beginTimeOfDay = parseSecondsMoment(start),
            endTimeOfDay = parseSecondsMoment(end);
          if (endTimeOfDay >= kOneDaySeconds || beginTimeOfDay > endTimeOfDay) {
            // overflow detected, bound to max;
            endTimeOfDay = kOneDaySeconds - 1;
          }
          pDataItem.time_of_day = {
            begin: beginTimeOfDay,
            end: endTimeOfDay
          };
          return that._updateItemToBackend(pDataItem, true);
        }).fail(function (pError) {
          console.error(pError);
          if (typeof pData.errorCB === "function") {
            pData.errorCB();
          }
        });
      } else {
        throw new Error('invalid moments');
      }
    },
    /**
     * @description Function runs when user click on the save button of the add item calendar dialog
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_calendarDialogSaveHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _calendarDialogSaveHandler: function _calendarDialogSaveHandler(pEvent, pData) {
      if ($.isPlainObject(pData) && !$.isEmptyObject(pData)) {
        if (typeof pData.id === "string" && pData.id.length > 0) {
          // updating mode
          this._updateItemToBackend(pData, true).fail(function (pError) {
            console.error(pError);
          });
        } else {
          // create new
          this._addNewItemToBackend(pData).fail(function (pError) {
            console.error(pError);
          });
        }
      } else {
        throw new Error('invalid input pData parameter');
      }
    },
    /**
     * @description Function runs when user click on the remove button of the add item calendar dialog
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_calendarDialogRemoveHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _calendarDialogRemoveHandler: function _calendarDialogRemoveHandler(pEvent, pData) {
      if (!$.isEmptyObject(pData) && typeof pData.id === "string" && pData.id.length > 0) {
        this._removeItemFromBackend(pData.id).fail(function (pError) {
          console.error(pError);
        });
      } else {
        throw new Error('invalid input pData parameter');
      }
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps-cloudflow.CloudflowCalendar#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the calendar according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.find('.cloudflowcalendar_calendar').Calendar({
        businessHours: {
          daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
          startTime: '00:00',
          endTime: '24:00'
        },
        header: this._makeHeaderStruncture(),
        defaultDate: this._forceInRange(moment(this.options.defaultDate)),
        defaultView: this.options.defaultView,
        hiddenDays: this.options.hiddenDays,
        language: this.options.language,
        eventStartEditable: this.options.editPeriodsEnable,
        eventDurationEditable: this.options.editPeriodsEnable,
        periodeProvider: this._periodsProvider.bind(this),
        selectable: true,
        enableMultipleDayPeriods: false,
        minDate: this.minDateBound !== undefined ? this.minDateBound : null,
        maxDate: this.maxDateBound !== undefined ? this.maxDateBound : null
      });
    },
    /**
     * @description create the header option object for the child plugin
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_makeHeaderStruncture
     * @returns {object}
     */
    _makeHeaderStruncture: function _makeHeaderStruncture() {
      // the stucture of the header, topbar
      var left = 'prev,next';
      var center = 'title';
      var right = this.options.possibleViews;
      if (this._isInRange(moment()) === true) {
        // add button today, if today is in range
        left += ' today';
      }
      if (this.options.addPeriodsEnable === true && this.options.showAddPeriodButton === true) {
        // add button create new, if options allowed it.
        left += " addPeriodButton";
      }
      return {
        left: left,
        center: center,
        right: right
      };
    },
    /**
     * @description make and shoa the period dialog for a new period
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_addItemDialog
     * @param {type} pDate
     * @param {type} pView
     * @param {jQueryEvent} pEvent
     * @returns {undefined}
     */
    _addItemDialog: function _addItemDialog(pDate, pView, pEvent) {
      if (!$.isEmptyObject(pView) && pView.type === "month") {
        var period = {
          mode: "available",
          time_of_day: {
            begin: 0,
            end: kOneDaySeconds - 1 /* end of day*/
          },

          valid: {
            from: this._forceInRange(moment(pDate)),
            until: this._forceInRange(moment(pDate))
          },
          enabled: {
            days_of_week: {
              monday: true,
              tuesday: true,
              wednesday: true,
              thursday: true,
              friday: true,
              saturday: true,
              sunday: true
            }
          }
        };
        this._showItemDialog(period, pEvent);
      } else {
        var startDate = moment(pDate);
        var period = {
          mode: "available",
          time_of_day: {
            begin: parseSecondsMoment(startDate),
            end: startDate.seconds() + (startDate.minutes() + 30) * 60 + startDate.hours() * 60 * 60
          },
          valid: {
            from: moment(pDate),
            until: moment(pDate).add(30, 'minutes')
          },
          enabled: {
            days_of_week: {
              monday: true,
              tuesday: true,
              wednesday: true,
              thursday: true,
              friday: true,
              saturday: true,
              sunday: true
            }
          }
        };
        this._showItemDialog(period, pEvent);
      }
    },
    /**
     * @description show a dialog to update or add a period
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_showItemDialog
     * @param {type} pEvent
     * @param {object} pDataItem
     * @param {boolean} pEnableRemoveButton
     * @returns {undefined}
     */
    _showItemDialog: function _showItemDialog(pDataItem, pEvent, pEnableRemoveButton) {
      this.element.find('.addEventDialog.nixps-cloudflow-AddCalendarDialog').remove();
      var dialog = $('<div>').addClass('addEventDialog').css('position', 'absolute');
      this.element.append(dialog);
      // set en init position options
      var positionOptions = {
        my: 'left+15 center',
        at: 'right center',
        collision: 'fit fit',
        of: 'table'
      };
      if (pEvent === undefined) {
        positionOptions.within = this.element;
      } else {
        positionOptions.of = $(pEvent.originalEvent.target).closest('.fc-event');
        if (positionOptions.of.length <= 0) {
          positionOptions.of = $(pEvent.originalEvent.target);
        }
      }
      dialog.AddCalendarDialog({
        language: this.options.language,
        itemID: typeof pDataItem.id === "string" ? pDataItem.id : null,
        description: typeof pDataItem.description === "string" ? pDataItem.description : "",
        startTime: !$.isEmptyObject(pDataItem.time_of_day) && typeof pDataItem.time_of_day.begin === "number" ? pDataItem.time_of_day.begin : null,
        endTime: !$.isEmptyObject(pDataItem.time_of_day) && typeof pDataItem.time_of_day.end === "number" ? pDataItem.time_of_day.end : null,
        startDate: !$.isEmptyObject(pDataItem.valid) && pDataItem.valid.from !== undefined ? moment(pDataItem.valid.from) : null,
        endDate: !$.isEmptyObject(pDataItem.valid) && pDataItem.valid.until !== undefined ? moment(pDataItem.valid.until) : null,
        mode: typeof pDataItem.mode === "string" ? pDataItem.mode : null,
        daysOfWeek: pDataItem.enabled === undefined || pDataItem.enabled.days_of_week === undefined ? {} : pDataItem.enabled.days_of_week,
        save: this._calendarDialogSaveHandler.bind(this),
        remove: this._calendarDialogRemoveHandler.bind(this),
        bottomButtons: pEnableRemoveButton === true ? ['remove', 'cancel', 'save'] : ['cancel', 'save'],
        minDate: this.minDateBound === undefined ? false : this.minDateBound,
        maxDate: this.maxDateBound === undefined ? false : this.maxDateBound
      }).position(positionOptions);
    },
    /**
     * @description Ask the calendar to update his data
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_update
     * @returns {undefined}
     */
    _update: function _update() {
      this.element.find('.cloudflowcalendar_calendar').Calendar('refresh');
    },
    refresh: function refresh() {
      this._update();
    },
    /**
     * @description function is called when plugin want information, draw the periods
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_periodsProvider
     * @param {moment} pStart The start bound of the requested periods
     * @param {moment} pEnd The end bound of the requested periods
     * @returns {Deferred}
     */
    _periodsProvider: function _periodsProvider(pStart, pEnd) {
      var that = this;
      var query = ["calendar_id", 'equal to', this.options.id];
      return $.Deferred(function (pDefer) {
        api_async.calendar.get_visualization_data(query, parseDateString(pStart), parseDateString(pEnd), {
          visualization_mode: visualizationMode[that.options.visualizationMode]
        }, function (pResults) {
          //the calendar requested new dates
          that.element.find('.cloudflowcalendar_calendar').Calendar("updateNextAndPrevButtons");
          pDefer.resolve(that._translatePeriods(pResults));
        }, function (pError) {
          console.error(pError);
          that._trigger("error", null, {
            "error_code": "calendar_load_error",
            "error": "Could not retrieve data for the calendar"
          });
          pDefer.reject(pError);
        });
      });
    },
    /**
     * @desc translate every period, and adapt the content
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_translatePeriods
     * @param {type} pResults
     * @returns {arrray} pResults
     */
    _translatePeriods: function _translatePeriods(pResults) {
      // only if array exists
      if (pResults !== undefined && Array.isArray(pResults.periods)) {
        // loop over array periods 
        for (var i = 0; i < pResults.periods.length; i++) {
          // only if there is a mode
          if (typeof pResults.periods[i].mode === "string" && pResults.periods[i].mode.length > 0) {
            // add the mode to the className, the className can still exists, so add to it if exsists
            var extraClassName = "cloudflowcalendar_mode_" + pResults.periods[i].mode;
            if (typeof pResults.periods[i].className === "string") {
              pResults.periods[i].className += " " + extraClassName;
            } else {
              pResults.periods[i].className = extraClassName;
            }
          }
        }
      }
      return pResults;
    },
    _getItemFromBackend: function _getItemFromBackend(pID) {
      if (typeof pID !== "string" || pID.length <= 0) {
        throw new Error('invalid parameter pID');
      }
      var that = this;
      return $.Deferred(function (pDefer) {
        api_async.calendar.get_item(that.options.id, pID, function (pResults) {
          if ($.isPlainObject(pResults.item)) {
            pDefer.resolve(pResults.item);
          } else {
            pDefer.reject('invalid return result, must contain object item');
          }
        }, function (pError) {
          console.error(pError);
          pDefer.reject(pError);
        });
      });
    },
    _addNewItemToBackend: function _addNewItemToBackend(pData) {
      var that = this;
      return $.Deferred(function (pDefer) {
        api_async.calendar.add_item(that.options.id, pData, {/*insert_before_item_id*/}, function (pResults) {
          that._update();
          pDefer.resolve(pResults);
        }, pDefer.reject);
      });
    },
    _updateItemToBackend: function _updateItemToBackend(pData, pRefresh) {
      var that = this;
      return $.Deferred(function (pDefer) {
        api_async.calendar.update_item(that.options.id, pData, {/*insert_before_item_id*/}, function (pResults) {
          if (pRefresh === true) {
            that._update();
          }
          pDefer.resolve(pResults);
        }, pDefer.reject);
      });
    },
    _removeItemFromBackend: function _removeItemFromBackend(pItemID) {
      if (typeof pItemID !== "string" || pItemID.length <= 0) {
        throw new Error('input parameter pItemID must be a not empty string');
      }
      var that = this;
      return $.Deferred(function (pDefer) {
        api_async.calendar.remove_item(that.options.id, pItemID, function (pResults) {
          that.element.find('.cloudflowcalendar_calendar').Calendar('removePeriod', pItemID);
          pDefer.resolve(pResults);
        }, pDefer.reject);
      });
    },
    /**
     * @description control if a date is in the range of the calendar. If caledar has no ranges, this function will return true;
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_isInRange
     * @param {moment} pDate the date to be controlled
     * @returns {Boolean} true if date is in range, false if date is not in range
     */
    _isInRange: function _isInRange(pDate) {
      if (isValidMoment(pDate)) {
        if (this.minDateBound !== undefined && pDate.isBefore(this.minDateBound)) {
          return false;
        }
        if (this.maxDateBound !== undefined && pDate.isAfter(this.maxDateBound)) {
          return false;
        }
        return true;
      }
      throw new Error('invalid date argument, argument must be a moment');
      return false;
    },
    /**
     * @description Force a moment to fall in a range, if range exists.
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_forceInRange
     * @param {momnent} pDate - The date to be forced in a range
     * @returns {undefined}
     */
    _forceInRange: function _forceInRange(pDate) {
      if (isValidMoment(pDate)) {
        if (this.minDateBound !== undefined && pDate.isBefore(this.minDateBound)) {
          return this.minDateBound;
        }
        if (this.maxDateBound !== undefined && pDate.isAfter(this.maxDateBound)) {
          return this.maxDateBound;
        }
        return pDate;
      }
      throw new Error('invalid date argument, argument must be a moment');
      return false;
    },
    /**
     * @description Get and set the minimum and maximum bound of the calendar. Some calendar has minimum and maximum bounds
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_initDateRange
     * @returns {Deferred} 
     */
    _initDateRange: function _initDateRange() {
      var that = this;
      return $.Deferred(function (pDefer) {
        api_async.calendar.list(["calendar_id", 'equal to', that.options.id], ['valid'], function (pResults) {
          if (Array.isArray(pResults.results) && pResults.results.length === 1 && $.isEmptyObject(pResults.results[0].valid) === false) {
            if (typeof pResults.results[0].valid.from === "string" && pResults.results[0].valid.from.length > 0) {
              var fromDate = moment(pResults.results[0].valid.from);
              if (isValidMoment(fromDate)) {
                that.minDateBound = fromDate;
              }
            }
            if (typeof pResults.results[0].valid.until === "string" && pResults.results[0].valid.until.length > 0) {
              var untilDate = moment(pResults.results[0].valid.until);
              if (isValidMoment(untilDate)) {
                that.maxDateBound = untilDate;
              }
            }
            pDefer.resolve(pResults.results[0].valid);
          } else {
            pDefer.reject("pRange not found");
          }
        }, function (pError) {
          console.error(pError);
          pDefer.reject(pError);
        });
      });
    },
    renderCalendar: function renderCalendar() {
      this.element.find('.cloudflowcalendar_calendar').Calendar("renderCalendar");
    },
    getView: function getView() {
      return this.element.find('.cloudflowcalendar_calendar').Calendar("getView");
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowCalendar#_setOption
     */
    _setOptions: function _setOptions(options) {
      this._controlOptions();
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
      });
      if (needRedraw === true) {
        this._draw();
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "addPeriodsEnable") {
        if (pValue !== this.options.addPeriodsEnable) {
          this._superApply(arguments);
          this.element.find('.cloudflowcalendar_calendar').Calendar("option", "header", this._makeHeaderStruncture());
        }
        return false;
      }
      if (pKey === "possibleViews") {
        if (pValue !== this.options.possibleViews) {
          this._superApply(arguments);
          this.element.find('.cloudflowcalendar_calendar').Calendar("option", "header", this._makeHeaderStruncture());
        }
        return false;
      }
      if (pKey === "editPeriodsEnable") {
        if (pValue !== this.options.editPeriodsEnable) {
          this._superApply(arguments);
          this.element.find('.cloudflowcalendar_calendar').Calendar("option", {
            eventStartEditable: this.options.editPeriodsEnable,
            eventDurationEditable: this.options.editPeriodsEnable
          });
        }
        return false;
      }
      if (pKey === "defaultView") {
        if (pValue !== this.options.defaultView) {
          this._superApply(arguments);
          this.element.find('.cloudflowcalendar_calendar').Calendar("option", {
            defaultView: this.options.defaultView
          });
        }
        return false;
      }
      if (pKey === "minDate") {
        if (this.minDateBound !== pValue) {
          this.minDateBound = pValue;
        }
        return true;
      }
      if (pKey === "maxDate") {
        if (this.maxDateBound !== pValue) {
          this.maxDateBound = pValue;
        }
        return true;
      }
      this._superApply(arguments);
      return true;
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps-cloudflow.CloudflowCalendar#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof window.moment !== "function") {
        throw new Error('Please include moment.js');
      }
      if (typeof this.options.language !== "string" || this.options.language.length < 2) {
        throw new Error('input option language must be a valid string');
      }
      if (typeof this.options.id !== "string" || this.options.id.length <= 0) {
        throw new Error('input option id must be a not empty string');
      }
      if (this.options.defaultDate === undefined || this.options.defaultDate === null || this.options.defaultDate === "") {
        this.options.defaultDate = moment();
      } else if (!isValidMoment(moment(this.options.defaultDate))) {
        throw new Error('input option defaultDate must be a valid moment parameter');
      }
      if (typeof this.options.visualizationMode !== "string" || this.options.visualizationMode.length <= 0) {
        throw new Error('input option visualizationMode must be a not empty string');
      }
      this.options.visualizationMode = this.options.visualizationMode.toUpperCase();
      if (visualizationMode[this.options.visualizationMode] === undefined) {
        throw new Error('input option visualizationMode is not a correct and known mode, please check your spelling');
      }
      if (typeof this.options.possibleViews !== "string" || this.options.possibleViews.length <= 0) {
        throw new Error('input option possibleViews must be a not empty string');
      }
      if (typeof this.options.defaultView !== "string" || this.options.defaultView.length <= 0) {
        throw new Error('input option defaultView must be a not empty string');
      }
      if (!Array.isArray(this.options.hiddenDays)) {
        throw new Error('input option hiddenDays must be an array');
      }
      for (var i = 0; i < this.options.hiddenDays.length; i++) {
        if ([0, 1, 2, 3, 4, 5, 6].includes(this.options.hiddenDays[i]) === false) {
          throw new Error('input option hiddenDays has invalid item:' + this.options.hiddenDays[i]);
        }
      }
      if (typeof this.options.addPeriodsEnable !== "boolean") {
        throw new Error('input option addPeriodsEnable must be a boolean');
      }
      if (typeof this.options.editPeriodsEnable !== "boolean") {
        throw new Error('input option editPeriodsEnable must be a boolean');
      }
      if (typeof this.options.showAddPeriodButton !== "boolean") {
        throw new Error('input option showAddPeriodButton must be a boolean');
      }
    }
  });
})(jQuery);

},{"../../../common/Calendar/js/nixps-Calendar.js":283,"./nixps-cloudflow-AddCalendarDialog.js":57}],59:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by Guillaume Desmet on 11/28/2018, 10:14:01 AM
 */
(function ($) {
  // external includes
  require("../../../common/Charts/js/nixps-BasicChart.js");
  var Duration = require("../../../common/Duration/js/Duration.js");
  var Bucket = require("../../Bucket/js/Bucket.js");
  var FileSizeUtils = require("../../../cloudflow/CloudflowUtil/js/FileSizeUtils.js");
  var DateFunctions = require("../../../cloudflow/CloudflowUtil/js/DateFunctions.js");
  var Device = require("../../PWA/js/Device.js");
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");
  var kBaloonRenderDict = {
    milliseconds: function milliseconds(value, context) {
      var duration = new Duration(value);
      return duration.getDuration(2, false);
    }
  };
  var kToolTipsLabelRenderDict = {
    milliseconds: function milliseconds(tooltipItem, data) {
      var label = data.datasets[tooltipItem.datasetIndex].label || "";
      if (label) {
        label += ": ";
      }
      var duration = new Duration(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]).getDuration(2, false);
      label += duration;
      return label;
    },
    filesize: function filesize(tooltipItem, data) {
      var label = data.datasets[tooltipItem.datasetIndex].label || "";
      if (label) {
        label += ": ";
      }
      label += FileSizeUtils.toString(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
      return label;
    }
  };
  var kTooltipsTitleRenderDict = {
    date: function date(tooltipItem, data) {
      return DateFunctions.toLocaleString(new Date(tooltipItem[0].label));
    }
  };
  var kAxesRenderDict = {
    milliseconds: function milliseconds(value) {
      //normalize to not show seconds
      if (value > 999) {
        var totalSeconds = new Duration(value).getSeconds(0, false);
        var secondsOverMinute = totalSeconds % 60;
        value = value - secondsOverMinute * 1000;
      } else {
        return 0;
      }
      return new Duration(value).getDuration(0, false);
    },
    filesize: function filesize(value) {
      return FileSizeUtils.toString(value);
    }
  };

  /**
   * @namespace nixps-cloudflow.CloudflowBucketChart
   * @description Draw a CloudflowBucketChart component
   * @example $("<div>").CloudflowBucketChart({});
   * @version 1.1.0
   */
  $.widget("nixps-cloudflow.CloudflowBucketChart", $.Widget, {
    widgetEventPrefix: "cloudflowbucketchart",
    version: "1.1.0",
    options: {
      /**
       * @name nixps-cloudflow.CloudflowBucketChart#identifier
       * @description The bucket identifier, the string known by the backend
       * @type {String}
       * @default ""
       */
      identifier: "",
      /**
       * @description Option passed through the nixps.BasicChart#type 
       * @name nixps-cloudflow.CloudflowBucketChart#type
       * @type {String}
       * @default undefined
       */
      type: undefined,
      /**
       * @description Option passed through the nixps.BasicChart#legend 
       * @name nixps-cloudflow.CloudflowBucketChart#legend
       * @type {Object}
       * @default undefined
       */
      legend: undefined,
      /**
       * @description The width of the chart in px
       * @name nixps-cloudflow.CloudflowBucketChart#width
       * @type {Number}
       * @default 400
       */
      width: 400,
      /**
       * @description The height of the chart in px
       * @name nixps-cloudflow.CloudflowBucketChart#height
       * @type {Number}
       * @default 200
       */
      height: 200,
      /**
       * @description The delay between refresh cycles in milliseconds
       * @name nixps-cloudflow.CloudflowBucketChart#refreshDelay
       * @type {Number}
       * @default 0
       */
      refreshDelay: 0,
      /**
       * @description color option for number and percentage charts
       * @name nixps-cloudflow.CloudflowBucketChart#color
       * @type {String}
       * @default "#2273B9"
       */
      color: "#2273B9",
      /**
       * @description the options to give to the visualisation data range
       * @type {Object}
       * @name nixps-cloudflow.CloudflowBucketChart#visualisationOptions
       */
      visualisationOptions: {
        "start": "$_ISO_NOW-6H"
      },
      renderType: "none",
      /**
       * @description Customise the title of the tooltip, support ["date"]
       * @type {(Function | "date")}
       * @name nixps-cloudflow.CloudflowBucketChart#titleRenderType
       * @default undefined
       */
      titleRenderType: undefined,
      /**
       * @description Customise the labels of the tooltip, support ["milliseconds" | "filesize"]
       * @type {(Function | "milliseconds" | "filesize")}
       * @name nixps-cloudflow.CloudflowBucketChart#labelRenderType
       * @default undefined
       */
      labelRenderType: undefined,
      /**
       * @description The title for the x-axis.
       * @name nixps-cloudflow.CloudflowBucketChart#XAxisTitle
       * @private
       * @type {String}
       * @default ""
       */
      XAxisTitle: "",
      /**
       * @description The title for the y-axis.
       * @name nixps-cloudflow.CloudflowBucketChart#YAxisTitle
       * @private
       * @type {String}
       * @default ""
       */
      YAxisTitle: "",
      YAxisTicksOverride: undefined,
      XAxisTicksOverride: undefined,
      /**
       * @description Disables the initial animation, option passing through nixps.BasicChart#disableAnimation
       * @name nixps-cloudflow.CloudflowBucketChart#disableAnimation
       * @type {Boolean}
       * @default undefined
       */
      disableAnimation: undefined,
      /**
       * @description An option of the nixps.BasicGrid#disableGrid component. Disable grid in chart.
       * @name nixps-cloudflow.CloudflowBucketChart#disableGrid
       * @type {Boolean}
       * @default undefined
       */
      disableGrid: undefined,
      /**
       * @description An option of the nixps.BasicGrid#responsive component. Set on true, to take the full length
       * @name nixps-cloudflow.CloudflowBucketChart#responsive
       * @type {Boolean}
       * @default undefined
       * @since 1.1.0
       */
      responsive: undefined,
      /**
       * @description is the data inside the bucket spread over time?
       * @name nixps-cloudflow.CloudflowBucketChart#dataOverTime
       * @type {Boolean}
       * @default false
       */
      dataOverTime: false,
      /**
       * @description must we have a background unther the line or not?
       * @name nixps-cloudflow.CloudflowBucketChart#fillInBackground
       * @type {Boolean}
       * @default true
       **/
      fillInBackground: true,
      /**
       * @description Define the lineTension, border of points when it is a line
       * @name nixps.BasicChart#lineTension
       * @type {Number}
       * @default undefined
       */
      lineTension: undefined,
      /**
       * @description callback function when groups are not detected inside the bucket, 
       * will be required to provide them from outside, or can't show anything
       * @name nixps-cloudflow.CloudflowBucketChart#getGroups
       * @type {Function}
       * @default null
       */
      getGroups: null,
      /**
       * @description an object containing all the translations for the bucket specific groups
       * @name nixps-cloudflow.CloudflowBucketChart#groupTranslationDictionary
       * @type {Object}
       * @default {}
       * @since 1.1.0
       */
      groupTranslationDictionary: {},
      /**
       * @description an object containing all the translations for the bucket items
       * @name nixps-cloudflow.CloudflowBucketChart#subGroupTranslationDictionary
       * @type {Object}
       * @default {}
       * @since 1.1.0
       */
      subGroupTranslationDictionary: {},
      /**
       * @description function runs when the component is done rendering
       * @name nixps-cloudflow.CloudflowBucketChart#created
       * @private
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Calc default options
     * @name nixps-cloudflow.CloudflowBucketChart#_getCreateOptions
     * @function
     * @private
     * @returns {Object}
     */
    _getCreateOptions: function _getCreateOptions() {
      return {};
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.CloudflowBucketChart#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      var that = this;
      this._controlOptions();
      this._addClass(this.widgetFullName);

      // variables
      this.alive = true;
      this.updateTimerid = -1;
      this.bucket;

      // translate the time units
      Duration.setTimeUnits([$.i18n._("nixps-cloudflow-duration.sec"), $.i18n._("nixps-cloudflow-duration.min"), $.i18n._("nixps-cloudflow-duration.hours"), $.i18n._("nixps-cloudflow-duration.days_1")]);

      // skeleton
      this.element.append($("<div>").addClass("cloudflowchart_chart"));
      this.element.children(".cloudflowchart_chart").BasicChart({
        type: this.options.type,
        width: this.options.width,
        height: this.options.height,
        legend: this.options.legend,
        responsive: this.options.responsive,
        dataOverTime: this.options.dataOverTime,
        showLabels: false,
        stacked: false,
        keyUniqID: "_id",
        lineTension: this.options.lineTension,
        undefinedGroupLabel: "",
        data: [],
        disableAnimation: this.options.disableAnimation,
        disableGrid: this.options.disableGrid,
        overrideDatalabels: kBaloonRenderDict[this.options.renderType],
        tooltipsOptions: {
          callbacks: {
            label: typeof this.options.labelRenderType === "function" ? this.options.labelRenderType : kToolTipsLabelRenderDict[this.options.labelRenderType],
            title: typeof this.options.titleRenderType === "function" ? this.options.titleRenderType : kTooltipsTitleRenderDict[this.options.titleRenderType]
          }
        },
        XAxisTitle: this.options.XAxisTitle,
        YAxisTitle: this.options.YAxisTitle,
        YAxisTicksOverride: typeof this.options.YAxisTicksOverride === "function" ? this.options.YAxisTicksOverride : kAxesRenderDict[this.options.YAxisTicksOverride],
        XAxisTicksOverride: typeof this.options.XAxisTicksOverride === "function" ? this.options.XAxisTicksOverride : kAxesRenderDict[this.options.XAxisTicksOverride]
      });
      var initDef = Bucket.fromIdentifier(this.options.identifier).then(function (pBucket) {
        if (that.alive === false) {
          return;
        }
        that.bucket = pBucket;
        var bucketRefresh = pBucket.getRefreshDelay();
        // do not decrease or reduce the requested refresh rate
        if (bucketRefresh === 0 || that.options.refreshDelay < bucketRefresh) {
          that.options.refreshDelay = bucketRefresh;
        }
        if (that.options.dataOverTime !== false) {
          that.element.children(".cloudflowchart_chart").BasicChart({
            "XAxisTitle": $.i18n._("nixps-cloudflow-cloudflowbucketchart.refresh-label", [new Duration(pBucket.getRefreshDelay()).getDuration(0, false)])
          });
        }
        // console.log("BucketChart: set refreshdelay for " + that.options.identifier + " on " + that.options.refreshDelay + " ms");
      })["catch"](function (pError) {
        console.error(pError);
        that.bucket = null;
        that.element.children(".cloudflowchart_chart").BasicChart("destroy").remove();
        that.element.append($("<div>").css({
          "height": that.options.height,
          "width": that.options.width
        }).addClass(" cloudflowchart_error").append($("<div>").addClass("cf-message-error").text($.i18n._("nixps-cloudflow-cloudflowchart.nodata"))));
      });
      Promise.all([this._draw(), initDef]).then(function () {
        that._update();
        that.options.created();
      }, function (pError) {
        LogListener.addLog({
          event_type: "error",
          details_data: pError
        });
        that.options.created();
      });
      this._on(this.element, {});
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.CloudflowBucketChart#redraw
     */
    redraw: function redraw() {
      var that = this;
      // stop current updating cycle
      clearTimeout(this.updateTimerid);
      this._draw().then(function () {
        that._update();
      });
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowBucketChart#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      return this._loadDrawChart();
    },
    /**
     * @description ask for new data and draw the chart
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowBucketChart#_loadDrawChart
     * @returns {$.Deferred}
     */
    _loadDrawChart: function _loadDrawChart() {
      var that = this;
      return Bucket.getVisualisationData(this.options.identifier, this.options.visualisationOptions).then(function (pResult) {
        var values = pResult.values;
        var groups = pResult.groups;
        var data = [];
        var index = 0;
        var names, resetGroupsAfterData, color, colorGroup, nameIndex;
        var needBackgroundColor = ["scatter", "line"].includes(that.options.type);
        if (pResult.multiple === true) {
          for (var i = 0; i < values.length; i++) {
            names = Object.keys(values[i].values);
            for (var name in values[i].values) {
              resetGroupsAfterData = groups === null;
              if (resetGroupsAfterData) {
                if (typeof that.options.getGroups === "function") {
                  groups = that.options.getGroups(name);
                } else {
                  throw new Error("CloudflowBucketChart: could not find any groups in data, none were provided");
                }
              }
              nameIndex = names.indexOf(name);
              for (var k = 0; k < groups.length; k++) {
                color = that._getColor(groups[k], name, nameIndex);
                data.push({
                  _id: "" + index,
                  group: that._getGroupLabel(groups[k], name),
                  background_color: needBackgroundColor ? color : "transparent",
                  fill: that.options.fillInBackground,
                  border_color: color,
                  label: values[i].when,
                  value: values[i].values[name][groups[k]]
                });
                index++;
              }
              if (resetGroupsAfterData) {
                groups = null;
              }
            }
          }
        } else {
          color = that._getColor();
          for (var i = 0; i < values.length; i++) {
            if (typeof values[i].value === "number") {
              data.push({
                _id: "" + index,
                label: values[i].when,
                value: values[i].value,
                border_color: color,
                background_color: color
              });
              index++;
            } else if ($.isPlainObject(values[i].value)) {
              if (Array.isArray(groups) && groups.length > 0) {
                for (var k = 0; k < groups.length; k++) {
                  colorGroup = that._getColor(groups[k]);
                  data.push({
                    _id: "" + index,
                    group: that._getGroupLabel(groups[k]),
                    background_color: colorGroup,
                    border_color: colorGroup,
                    label: values[i].when,
                    value: values[i].value[groups[k]]
                  });
                  index++;
                }
              } else {
                for (var name in values[i].value) {
                  if (typeof values[i].value[name] === "number" && name === "maximum") {
                    data.push({
                      _id: "" + index,
                      background_color: color,
                      group: that._getGroupLabel(name),
                      border_color: color,
                      label: values[i].when,
                      value: values[i].value[name]
                    });
                    index++;
                  }
                }
              }
            }
          }
        }
        that.element.children(".cloudflowchart_chart").BasicChart("option", {
          "data": data,
          "stacked": pResult.options && pResult.options.stacked
        });
      })["catch"](function (pError) {
        console.error(pError);
        return Promise.reject(pError);
      });
    },
    _getColor: function _getColor(pGroup, pSubGroup, pIndex) {
      if (pGroup === undefined) {
        return "#81A8BB";
      }
      var mainColor;
      switch (pGroup) {
        case "average":
          mainColor = "#81A8BB";
          break;
        case "maximum":
          mainColor = "#FFAB4F";
          break;
      }
      if (pSubGroup === undefined) {
        return mainColor;
      } else {
        return "#" + tinycolor(mainColor).brighten(pIndex * 5).toHex();
      }
    },
    _getGroupLabel: function _getGroupLabel(pGroup, pSubGroup) {
      // group transaltions
      var groupTranslation = "";
      groupTranslation = this.options.groupTranslationDictionary[pGroup];
      if (groupTranslation === undefined) {
        // fallback in case of the dict is not provided
        groupTranslation = $.i18n._("nixps-cloudflow-cloudflowbucketchart." + pGroup);
      }
      if (groupTranslation === "nixps-cloudflow-cloudflowbucketchart." + pGroup) {
        // fallback in case the item name is not translated
        groupTranslation = pGroup;
      }
      // subgroup transaltions
      var subGroupTranslation = "";
      if (typeof pSubGroup === "string" && pSubGroup.length > 0) {
        subGroupTranslation = this.options.subGroupTranslationDictionary[pSubGroup];
        if (subGroupTranslation === undefined) {
          // fallback in case of the dict is not provided
          subGroupTranslation = $.i18n._("nixps-cloudflow-cloudflowbucketchart." + pSubGroup);
        }
        if (subGroupTranslation === "nixps-cloudflow-cloudflowbucketchart." + pSubGroup) {
          subGroupTranslation = pSubGroup;
        }
      }
      return subGroupTranslation + " " + groupTranslation;
    },
    /**
     * @description Manual update action to update the chart with possible new data
     * @function
     * @name nixps-cloudflow.CloudflowBucketChart#update
     * @returns {$.Deferred}
     */
    update: function update() {
      if (this.alive === false) {
        return; // zombie
      }
      // stop current updating cycle
      clearTimeout(this.updateTimerid);
      var that = this;
      return this._loadDrawChart()["finally"](function () {
        if (that.alive === false) {
          return; // zombie
        }
        // restart updating cycle
        that._update();
      });
    },
    /**
     * @description Redraw the chart with new data
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowBucketChart#_update
     */
    _update: function _update() {
      if (this.alive === false) {
        return; // zombie
      }

      var that = this;
      clearTimeout(this.updateTimerid);
      if (this.options.refreshDelay > 100 && this.options.refreshDelay < 2147483600 / Device.getPollingFactor(this.uuid)) {
        this.updateTimerid = this._delay(function () {
          if (this.alive === false) {
            return;
          }
          if (this.element.is(":visible") && document.hidden !== true) {
            this._loadDrawChart().then(function (pResult) {
              that._update();
              return pResult;
            }, function (pError) {
              LogListener.addLog({
                event_type: "error",
                details_data: pError
              });
              that._update();
              return Promise.reject(pError);
            });
          } else {
            that._update();
          }
        }, Device.getPollingFactor(this.uuid) * this.options.refreshDelay);
      }
    },
    /**
    * @description Show or hide the groups
    * @function
    * @name nixps-cloudflow.CloudflowBucketChart#toggleGroups
    * @param {String | Number | RegExp } pSelector with labels should we activate or desactivet
    * @param {Boolean} pMode true to show, false to hide
    */
    toggleGroups: function toggleGroups(pSelector, pMode) {
      return this.element.children(".cloudflowchart_chart").BasicChart("toggleGroups", pSelector, pMode);
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowBucketChart#_setOptions
     */
    _setOptions: function _setOptions(options) {
      // updates the basic chart
      var chartOptions = {};
      var hasChartOption = false;
      var optionNames = ["type", "legend", "width", "height", "responsive", "dataOverTime", "disableAnimation", "disableGrid", "XAxisTitle", "YAxisTitle", "lineTension"];
      for (var i = 0; i < optionNames.length; i++) {
        if (options[optionNames[i]] !== undefined && this.options[optionNames[i]] !== options[optionNames[i]]) {
          chartOptions[optionNames[i]] = options[optionNames[i]];
          hasChartOption = true;
        }
      }
      this._superApply(arguments);
      this._controlOptions();
      if (hasChartOption) {
        this.element.children(".cloudflowchart_chart").BasicChart("option", chartOptions);
      }
      this.redraw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.CloudflowBucketChart#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.identifier !== "string" || this.options.identifier.length <= 0) {
        throw new Error("CloudflowBucketChart input option identifier must be a not empty string");
      }
      if (typeof this.options.refreshDelay !== "number" || this.options.refreshDelay < 0) {
        throw new Error("CloudflowBucketChart input option refreshDelay should be a positieve number");
      }
      if (this.options.groupTranslationDictionary === null || _typeof(this.options.groupTranslationDictionary) !== "object") {
        throw new Error("CloudflowBucketChart input option groupTranslationDictionary must be an object");
      }
      if (this.options.subGroupTranslationDictionary === null || _typeof(this.options.subGroupTranslationDictionary) !== "object") {
        throw new Error("CloudflowBucketChart input option subGroupTranslationDictionary must be an object");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      clearTimeout(this.updateTimerid);
      this._superApply();
    }
  });
})(jQuery);

},{"../../../cloudflow/CloudflowUtil/js/DateFunctions.js":83,"../../../cloudflow/CloudflowUtil/js/FileSizeUtils.js":88,"../../../common/Charts/js/nixps-BasicChart.js":284,"../../../common/Duration/js/Duration.js":289,"../../../pagebuilder/js/inspect/LogListener.js":431,"../../Bucket/js/Bucket.js":53,"../../PWA/js/Device.js":198}],60:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by Guillaume Desmet on 11/28/2018, 10:14:01 AM
 */
(function ($) {
  // external includes
  require("../../../common/Charts/js/nixps-BasicChart.js");
  require("../../../common/Charts/js/nixps-CircularPercentageChart.js");
  var CloudflowConnection = require("../../CloudflowUtil/js/CloudflowConnection.js");
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");
  var Device = require("../../PWA/js/Device.js");

  /**
   * @namespace nixps-cloudflow.CloudflowChart
   * @description Draw a CloudflowChart component
   * @example $('<div>').CloudflowChart({});
   * @version 1.1.0
   */
  $.widget("nixps-cloudflow.CloudflowChart", $.Widget, {
    widgetEventPrefix: "cloudflowchart",
    version: "1.1.0",
    options: {
      /**
       * @description The type of the chart
       * @type {String}
       * @name nixps-cloudflow.CloudflowChart#chartType
       * @default "bar"
       */
      chartType: "bar",
      /**
       * @description The with of the chart in px
       * @name nixps-cloudflow.CloudflowChart#width
       * @type {Number}
       * @default 400
       */
      width: 400,
      /**
       * @description The height of the chart in px
       * @name nixps-cloudflow.CloudflowChart#height
       * @type {Number}
       * @default 200
       */
      height: 200,
      /**
       * @description Must we show a legend or not?
       * @name nixps-cloudflow.CloudflowChart#showLegend
       * @type {Boolean}
       * @default false
       */
      showLegend: false,
      /**
      * @description Must we show a legend or not?
      * @name nixps-cloudflow.CloudflowChart#legendPosition
      * @type {String}
      * @default "top"
      */
      legendPosition: "top",
      /**
       * @description Must we show labels or not?
       * @name nixps-cloudflow.CloudflowChart#showLabels
       * @type {Boolean}
       * @default false
       */
      showLabels: false,
      /**
      * @description Stack data or not?
      * @name nixps-cloudflow.CloudflowChart#stacked
      * @type {Boolean}
      * @default false
      */
      stacked: false,
      /**
       * @description Where can we find the data to display?
       * @name nixps-cloudflow.CloudflowChart#collection
       * @type {String}
       * @default ""
       */
      collection: "",
      /**
       * @description The extra filter query asked to the backend
       * @name nixps-cloudflow.CloudflowChart#extraQuery
       * @type {Array.<String>}
       * @default []
       * @since 1.1.0
       */
      extraQuery: [],
      data: [],
      /**
       * @description The input name of the http service
       * @name nixps-cloudflow.CloudflowChart#httpserviceInputName
       * @type {String}
       * @default ""
       */
      httpserviceInputName: "",
      /**
       * @description The whitepaper name of the http service
       * @name nixps-cloudflow.CloudflowChart#httpserviceWhitepaperName
       * @type {String}
       * @default ""
       */
      httpserviceWhitepaperName: "",
      /**
       * @name nixps-cloudflow.CloudflowChart#keyUniqID
       * @description The parameter name of the id of the objects
       * @type {String}
       * @default "_id"
       * @since 1.1.0
       */
      keyUniqID: "_id",
      /**
       * @description The file url to search for data
       * @name nixps-cloudflow.CloudflowChart#dataFileURL
       * @type {String}
       * @default ""
       */
      dataFileURL: "",
      /**
       * @description The relative base path of the data file
       * @name nixps-cloudflow.CloudflowChart#relativeBasePath
       * @type {String}
       * @default ""
      */
      relativeBasePath: "",
      /**
       * @description Get the text to be show when loading on start up
       * @name nixps-cloudlfow.CloudflowChart#loadingText
       * @type {String}
       * @default "$.i18n._("nixps-cloudflow-cloudflowchart.loadingtext")"
       */
      loadingText: "",
      /**
       * @description The text of the group if no groups are defined
       * @name nixps-cloudlfow.CloudflowChart#undefinedGroupLabel
       * @type {String}
       * @default "$.i18n._("nixps-cloudflow-cloudflowchart.nogroup_label")"
       */
      undefinedGroupLabel: "",
      /**
       * @description The delay between refresh cycles in milliseconds
       * @name nixps-cloudlfow.CloudflowChart#refreshDelay
       * @type {Number}
       * @default 0
       */
      refreshDelay: 0,
      /**
      * @description color option for number and percentage charts
      * @name nixps-cloudlfow.CloudflowChart#color
      * @type {String}
      * @default "#0080bf"
      */
      color: "#0080bf",
      /**
       * @description colorOutlineCircle option for number and percentage charts
       * @name nixps-cloudlfow.CloudflowChart#colorOutlineCircle
       * @type {String}
       * @default "#eee"
       */
      colorOutlineCircle: "#eee",
      /**
      * @description circelWidth option for number and percentage charts
      * @name nixps-cloudlfow.CloudflowChart#circelWidth
      * @type {Number}
      * @default 2.8
      */
      circelWidth: 2.8,
      /**
       * @description The starting point defined in degrees
       * @name nixps-cloudlfow.CloudflowChart#startDegrees
       * @type {Number}
       * @default 0
       */
      startDegrees: 0,
      /**
      * @description maxValue option for number and percentage charts
      * @name nixps-cloudlfow.CloudflowChart#maxValue
      * @type {Number}
      * @default 100
      */
      maxValue: 100,
      /**
      * @description the max amount of records to process
      * @name nixps-cloudlfow.CloudflowChart#maxValue
      * @type {Number}
      * @default undefined
      */
      maxAmount: undefined,
      /**
       * @description function runs when the component is done rendering
       * @name nixps-cloudlfow.CloudflowChart#created
       * @private
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Calc default options
     * @name nixps-cloudflow.CloudflowChart#_getCreateOptions
     * @function
     * @private
     * @returns {Object}
     */
    _getCreateOptions: function _getCreateOptions() {
      return {
        loadingText: $.i18n._("nixps-cloudflow-cloudflowchart.loadingtext"),
        undefinedGroupLabel: $.i18n._("nixps-cloudflow-cloudflowchart.nogroup_label")
      };
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.CloudflowChart#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);

      // variables
      this.connection = null;
      this.alive = true;
      this.updateTimerid = -1;

      // skeleton
      this.element.append($('<div>').addClass("cloudflowchart_chart"));
      var that = this;
      $.when(this._draw(true)).done(function (pResult) {
        that._update();
        if (pResult === true) {
          that.options.created();
        }
      }).fail(function () {
        that.options.created();
      });
      this._on(this.element, {
        'basicchartclick': this._clickHandler
      });
    },
    /**
     * @description function runs when use select a point
     * @function
     * @name nixps-cloudflow.CloudflowChart#_clickHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _clickHandler: function _clickHandler(pEvent, pData) {
      // parameter id is added in child component
      this._trigger("click", pEvent, pData);
    },
    /**
     * @description function runs when api calls erors and we need to inform others
     * @function
     * @name nixps-cloudflow.CloudflowChart#_errorHandler
     * @private
     * @param {String} pCodeSection an string indication where the error occured
     * @param {Object} pError 
     */
    _errorHandler: function _errorHandler(pCodeSection, pError) {
      this._trigger("error", null, pError);
      LogListener.addLog({
        event_type: "error",
        details_data: pError,
        component_name: this.widgetFullName
      }, this.element);
    },
    /**
     * @description function runs when source triggers changes
     * @function
     * @name nixps-cloudflow.CloudflowChart#_sourceChangeHandler
     * @private
     */
    _sourceChangeHandler: function _sourceChangeHandler() {
      this.update();
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.CloudflowChart#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowChart#_draw
     * @return {undefined} 
     */
    _draw: function _draw(pShowLoadingPanel) {
      if (this.connection !== null) {
        this.connection.stop();
      }
      // check if we have at least some data
      if (this.options.collection === undefined || this.options.collection === null || this.options.collection === "" || this.options.collection === "object" && typeof this.options.data === 'string' && this.options.data.length <= 0) {
        this.element.children(".cloudflowchart_chart.nixps-BasicChart").BasicChart("destroy").empty();
        this.element.children(".cloudflowchart_chart.nixps-CircularPercentageChart").CircularPercentageChart("destroy").empty();
        this.element.children(".cloudflowchart_infopanel").empty();
        this.element.css({
          width: this.options.width,
          height: this.options.height
        }).append($('<div>').addClass("cloudflowchart_infopanel").append($('<div>')._t("nixps-cloudflow-cloudflowchart.nodata")));
        return true;
      }
      if (typeof this.options.data === "string" && this.options.data.length > 0 && this.options.collection === "object") {
        // Parse custom data
        try {
          this.options.data = JSON.parse(decodeURI(this.options.data));
        } catch (error) {
          // Show warning on chart when parse fails
          this.element.children(".cloudflowchart_chart.nixps-BasicChart").BasicChart("destroy").empty();
          this.element.children(".cloudflowchart_chart.nixps-CircularPercentageChart").CircularPercentageChart("destroy").empty();
          this.element.children(".cloudflowchart_infopanel").empty();
          this.element.css({
            width: this.options.width,
            height: this.options.height
          }).append($('<div>').addClass("cloudflowchart_infopanel").append($('<div>')._t("nixps-cloudflow-cloudflowchart.wrongdata")));
          return true;
        }
      }
      // do the request for data
      this.connection = new CloudflowConnection({
        collection: this.options.collection,
        data: this.options.data,
        dataFileURL: this.options.dataFileURL,
        relativeBasePath: this.options.relativeBasePath,
        httpserviceInputName: this.options.httpserviceInputName,
        httpserviceWhitepaperName: this.options.httpserviceWhitepaperName,
        error_cb: this._errorHandler.bind(this),
        change_cb: this._sourceChangeHandler.bind(this)
      });
      if (pShowLoadingPanel === true) {
        this.element.css({
          width: this.options.width,
          height: this.options.height
        }).append($('<div>').addClass("cloudflowchart_loadingpanel").append($('<div>').text(this.options.loadingText)));
      }
      var that = this;
      return this._loadDrawChart().done(function () {
        // clear ui
        that.element.css({
          height: "",
          width: ""
        }).children(".cloudflowchart_loadingpanel, .cloudflowchart_infopanel").remove();
      }).fail(function () {
        // error occured
        // show the no data text
        that.element.css({
          width: that.options.width,
          height: that.options.height
        }).children(".cloudflowchart_loadingpanel, .cloudflowchart_infopanel").remove();
        that.element.children(".cloudflowchart_chart.nixps-BasicChart").BasicChart("destroy").empty();
        that.element.children(".cloudflowchart_chart.nixps-CircularPercentageChart").CircularPercentageChart("destroy").empty();
        that.element.append($('<div>').addClass("cloudflowchart_infopanel").append($('<div>')._t("nixps-cloudflow-cloudflowchart.nodata")));
      });
    },
    /**
     * @description ask for new data and draw the chart
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowChart#_loadDrawChart
     * @returns {$.Deferred}
     */
    _loadDrawChart: function _loadDrawChart() {
      var that = this;
      var filter = this.options.extraQuery;
      var orderBy = ["_id", "descending"];
      var amount = undefined;
      // user have set 0 to visualise all records ...
      if (typeof this.options.maxAmount === "number" && this.options.maxAmount > 0) {
        amount = this.options.maxAmount;
      }
      return $.when(this.connection.list_with_options(filter, orderBy, [], 0, amount)).done(function (pResults) {
        if (that.alive === false) {
          return; // zombie
        }

        var list = [];
        if (pResults !== undefined && Array.isArray(pResults.results)) {
          list = pResults.results.reverse();
          that._updateChart(list);
        } else if (pResults !== undefined && (typeof pResults === "string" || typeof pResults === "number")) {
          that._updateChart(pResults);
        } else {
          console.error("no good returning array interface");
          that._errorHandler("load", {
            "error_code": "wrong_interface",
            "error": "wrong returning interface"
          });
          that._updateChart([]);
        }
      }).fail(function (pError) {
        console.error(pError);
      });
    },
    /**
     * @description Draw the chart
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowChart#_updateChart
     * @param {Array} pData The data to be displayed
     */
    _updateChart: function _updateChart(pData) {
      if (this.options.chartType === "percentage" || this.options.chartType === "number") {
        var data = pData;
        var color = this.options.color;
        var colorOutlineCircle = this.options.colorOutlineCircle;
        // transform an array to an number
        if (Array.isArray(pData)) {
          if (pData.length > 0) {
            var lastItem = pData[pData.length - 1];
            if ($.isPlainObject(lastItem)) {
              if (lastItem.value !== undefined) {
                data = lastItem.value;
              } else {
                data = 0;
                this._errorHandler("update", {
                  "error_code": "missing_key_value",
                  "error": "no key with name equal to value found in the provided data"
                });
              }
              if (typeof lastItem.color === "string" && lastItem.color.length > 0) {
                color = lastItem.color;
              }
              if (typeof lastItem.progress_color === "string" && lastItem.progress_color.length > 0) {
                color = lastItem.progress_color;
              }
              if (typeof lastItem.background_color === "string" && lastItem.background_color.length > 0) {
                colorOutlineCircle = lastItem.background_color;
              }
            } else {
              // can be a number or string
              data = lastItem;
            }
          } else {
            // empty array
            data = 0;
            this._errorHandler("update", {
              "error_code": "empty_array",
              "error": "the array is empty"
            });
          }
        }
        var chartValue = 0;
        if (typeof data === 'number') {
          chartValue = data;
        } else if (typeof data === 'string') {
          if (data.indexOf('%') > 0) {
            chartValue = data;
          } else {
            chartValue = parseFloat(data);
          }
        } else {
          chartValue = 0;
          this._errorHandler("update", {
            "error_code": "no_valid_interface",
            "error": "data given was no number, string or array with data"
          });
        }
        if (!this.options.maxValue) {
          this.options.maxValue = 100;
        }
        if (!this.options.circelWidth) {
          this.options.circelWidth = 2.8;
        }
        var options = {
          kind: this.options.chartType,
          width: this.options.width,
          height: this.options.height,
          color: color,
          colorOutlineCircle: colorOutlineCircle,
          circelWidth: this.options.circelWidth,
          maxValue: this.options.maxValue,
          startDegrees: this.options.startDegrees,
          value: chartValue,
          created: this.options.created
        };
        this.element.children(".cloudflowchart_chart").CircularPercentageChart(options);
      } else {
        var options = {
          type: this.options.chartType,
          width: this.options.width,
          height: this.options.height,
          legend: {
            display: this.options.showLegend,
            position: this.options.legendPosition
          },
          showLabels: this.options.showLabels,
          stacked: this.options.stacked,
          keyUniqID: this.options.keyUniqID,
          undefinedGroupLabel: this.options.undefinedGroupLabel,
          created: this.options.created
        };
        if (Array.isArray(pData)) {
          if (pData.length === 0) {
            this._errorHandler("update", {
              "error_code": "no_data",
              "error": "no data found"
            });
          }
          options.data = pData;
        }
        this.element.children(".cloudflowchart_chart").BasicChart(options);
      }
    },
    _updateWithNoDataChange: function _updateWithNoDataChange(pData) {
      var options = {
        kind: this.options.chartType,
        width: this.options.width,
        height: this.options.height,
        color: this.options.color,
        colorOutlineCircle: this.options.colorOutlineCircle,
        circelWidth: this.options.circelWidth,
        maxValue: this.options.maxValue,
        startDegrees: this.options.startDegrees,
        created: this.options.created
      };
      this.element.children(".cloudflowchart_chart").CircularPercentageChart(options);
    },
    /**
     * @description Manual update action to update the chart with possible new data
     * @function
     * @name nixps-cloudflow.CloudflowChart#update
     * @returns {$.Deferred}
     */
    update: function update() {
      // first check if we can update something
      if (this.options.collection === undefined || this.options.collection === null || this.options.collection === "") {
        return $.Deferred().resolve({});
      }
      // stop current updating cycle
      clearTimeout(this.updateTimerid);
      var that = this;
      return this._loadDrawChart().always(function () {
        // restart updating cycle
        that._update();
      });
    },
    /**
     * @description Redraw the chart with new data
     * @function
     * @private
     * @name nixps-cloudlfow.CloudflowChart#_update
     */
    _update: function _update() {
      if (this.alive === false) {
        return; // zombie
      }

      var that = this;
      clearTimeout(this.updateTimerid);
      if (this.options.refreshDelay > 100 && this.options.collection !== "object") {
        this.updateTimerid = this._delay(function () {
          if (this.alive === false) {
            return;
          }
          if (this.element.is(":visible") && document.hidden !== true) {
            this._loadDrawChart().always(function () {
              that._update();
            });
          } else {
            that._update();
          }
        }, Device.getPollingFactor(this.uuid) * this.options.refreshDelay);
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowChart#_setOptions
     */
    _setOptions: function _setOptions(options) {
      if (options.collection !== undefined && options.collection !== this.options.collection || options.data !== undefined && _.isEqual(options.data, this.options.data) === false || options.httpserviceInputName !== undefined && options.httpserviceInputName !== this.options.httpserviceInputName || options.httpserviceWhitepaperName !== undefined && options.httpserviceWhitepaperName !== this.options.httpserviceWhitepaperName) {
        this._superApply(arguments);
        this._controlOptions();
        this.element.children(".cloudflowchart_chart.nixps-BasicChart").BasicChart("destroy").empty();
        this.element.children(".cloudflowchart_chart.nixps-CircularPercentageChart").CircularPercentageChart("destroy").empty();
        this._draw();
      } else if (options.chartType !== undefined && ['percentage', 'number'].includes(options.chartType) !== ['percentage', 'number'].includes(this.options.chartType)) {
        // different chart types redraw
        this._superApply(arguments);
        this._controlOptions();
        this.element.children(".cloudflowchart_chart.nixps-BasicChart").BasicChart("destroy").empty();
        this.element.children(".cloudflowchart_chart.nixps-CircularPercentageChart").CircularPercentageChart("destroy").empty();
        this._draw();
      } else if (options.chartType !== undefined && options.chartType !== this.options.chartType || options.width !== undefined && options.width !== this.options.width || options.height !== undefined && options.height !== this.options.height || options.showLegend !== undefined && options.showLegend !== this.options.showLegend || options.legendPosition !== undefined && options.legendPosition !== this.options.legendPosition || options.showLabels !== undefined && options.showLabels !== this.options.showLabels || options.stacked !== undefined && options.stacked !== this.options.stacked || options.undefinedGroupLabel !== undefined && options.undefinedGroupLabel !== this.options.undefinedGroupLabel) {
        this._superApply(arguments);
        this._controlOptions();
        if (this.options.collection === undefined || this.options.collection === null || this.options.collection === "") {
          // do not update if no chart is there
          return;
        }
        this._updateChart([0]);
        this.update();
      } else if (options.extraQuery !== undefined && _.isEqual(options.extraQuery, this.options.extraQuery) === false) {
        this._superApply(arguments);
        this._controlOptions();
        this._loadDrawChart();
      } else if (options.circelWidth !== undefined && options.circelWidth !== this.options.circelWidth || options.color !== undefined && options.color !== this.options.color || options.colorOutlineCircle !== undefined && options.colorOutlineCircle !== this.options.colorOutlineCircle || options.startDegrees !== undefined && options.startDegrees !== this.options.startDegrees || options.maxValue !== undefined && options.maxValue !== this.options.maxValue) {
        this._superApply(arguments);
        this._updateWithNoDataChange();
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.CloudflowChart#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.chartType !== "string" || this.options.chartType.length <= 0) {
        throw new Error("CloudflowChart: input option chartType must be a not empty string");
      }
      if ((typeof this.options.width !== "number" || this.options.width <= 0) && (typeof this.options.width !== "string" || this.options.width.length <= 0)) {
        throw new Error("CloudflowChart: input option width must be positieve number");
      }
      if (typeof this.options.height !== "number" || this.options.height <= 0) {
        throw new Error("CloudflowChart: input option width must be positieve number");
      }
      if (typeof this.options.refreshDelay !== "number" || this.options.refreshDelay < 0) {
        throw new Error("CloudflowChart: input option refreshDelay must be positieve number");
      }
      if (typeof this.options.httpserviceWhitepaperName !== "string") {
        throw new Error("CloudflowChart: input option httpserviceWhitepaperName must be a string");
      }
      if (typeof this.options.httpserviceInputName !== "string") {
        throw new Error("CloudflowChart: input option httpserviceInputName must be a string");
      }
      if (typeof this.options.collection === "string" && this.options.collection.indexOf("nucleus.") === 0) {
        this.options.keyUniqID = "_id";
      }
      if (typeof this.options.keyUniqID !== "string" || this.options.keyUniqID.length <= 0) {
        throw new Error("CloudflowChart: input option keyUniqID must be a not empty string");
      }
      if (Array.isArray(this.options.extraQuery) === false) {
        throw new Error("CloudflowChart: input option extraQuery must be an array");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      clearTimeout(this.updateTimerid);
      if (this.connection !== undefined && this.connection !== null) {
        this.connection.stop();
      }
    }
  });
})(jQuery);

},{"../../../common/Charts/js/nixps-BasicChart.js":284,"../../../common/Charts/js/nixps-CircularPercentageChart.js":285,"../../../pagebuilder/js/inspect/LogListener.js":431,"../../CloudflowUtil/js/CloudflowConnection.js":78,"../../PWA/js/Device.js":198}],61:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/
/*globals $, _, jsPlumb, console, api_sync, window */
(function ($) {
  "use strict";

  require("../../../cloudflow/FormElements/js/nixps-cloudflow-Image.js");
  var CloudflowURL = require("../../CloudflowUtil/js/CloudflowURL.js");
  var kFileExtensions = [".ico", ".webp"];
  var kFileMimetypes = ["image/jpeg", "image/png", "image/tiff", "image/svg+xml", "application/pdf", "application/vnd.adobe.illustrator", "image/x-jg", "image/webp", "image/gif", "application/ic3d-ic3", "application/x-cad-cff2", "image/x-icon"];
  $.widget("nixps-cloudflow.CloudflowImageSlider", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "cloudflowimageslider",
    options: {
      language: "en",
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#folderURL
       * @description the URL to the folder containing the assets to include in the imageslider
       * @type {string}
       * @default ""
       */
      folderURL: "",
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#refreshDelay
       * @description How long it should take before the next image is shown, in ms.
       * Can be 0 to turn off the automatic sliding.
       * @type {Number}
       * @default 5000
       */
      refreshDelay: 5000,
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#fadeDuration
       * @description How long it should take for the next image to fade in, in ms.
       * Can be 0 to turn off the fading.
       * @type {Number}
       * @default 1000
       */
      fadeDuration: 1000,
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#imageOptions
       * @description An array of objects containing the options for each image that should
       * be added to the slider. Following options get overridden by defaults defined by
       * the ImageSlider: ["width", "height", "maxWidth", "maxHeight"].
       * Can take an extra option: ["label"], text that will be shown under the image.
       * @type {Array.<Object>}
       * @default []
       */
      imageOptions: [],
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#height
       * @description What the height for the image slider should be. Will be passed to
       * jQuery css function.
       * @type {Number|String}
       * @default 500
       */
      height: 500,
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#enableControls
       * @description Whether there should be controls to switch the images around
       * @type {Boolean}
       * @default true
       */
      enableControls: true,
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#objectFit
       * @description The value for the property objectFit on each image
       * @type {Boolean}
       * @default "contain"
       */
      objectFit: "contain",
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#backgroundColor
       * @description What color the background of the slider should have. Will be passed to
       * jQuery css function.
       * @type {String}
       * @default "transparent"
       */
      backgroundColor: "transparent",
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#classes
       * @description Customize classes to be append to the buttons their container. 
       * Possible keys are ["imageslider"]
       * @type {Object}
       * @default {}
       */
      classes: {},
      /**
       * @name nixps-cloudflow.CloudflowImageSlider#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).attr("tabindex", 0);
      this.imageIndex = 0;
      this.refreshTimeout;
      this.imageURLs = [];
      this._draw();
      this._on(this.element, {
        "click .imageslider-direction-button": this._clickDirectionHandler,
        "click .imageslider-dots-container > .imageslider-dot": this._clickDotHandler,
        "focus": this._focusHandler,
        "focus button": this._focusHandler,
        "blur": this._blurHandler,
        "blur button": this._blurHandler
      });
      this.options.created();
    },
    _draw: function _draw() {
      var that = this;
      this.element.empty();
      clearTimeout(this.refreshTimeout);
      if (this.options.refreshDelay < 1000 && this.options.refreshDelay !== 0) {
        this.options.refreshDelay *= 1000;
      }
      var slide = $("<div>").addClass("imageslider");
      this._addClass(slide, "imageslider");
      var imagecontainer = $("<div>").addClass("image-container").css({
        "height": this.options.height
      });
      imagecontainer.css({
        "background-color": this.options.backgroundColor
      });
      var labelcontainer = $("<div>").addClass("imageslider-label-container");
      var dotscontainer = $("<div>").addClass("imageslider-dots-container");
      labelcontainer.css("display", "none");
      for (var i = 0; i < this.options.imageOptions.length; i++) {
        if (this.options.imageOptions[i]["label"] !== undefined) {
          labelcontainer.css("display", "");
          break;
        }
      }

      //default options that'll override the options given in this.options.imageOptions
      var defaultImageOptions = {
        width: "100%",
        height: this.options.height,
        objectFit: this.options.objectFit
      };
      var folderURL = "";
      if (this.options.folderURL.length > 0) {
        folderURL = new CloudflowURL(this.options.relativeBasePath, this.options.folderURL, true).getCloudflowPath();
      }
      api_async.asset.list_with_options(["cloudflow.enclosing_folder", "equal to", folderURL, "and", "sub", "equal to", ""], ["file_name", "ascending"], ["cloudflow", "file_extension", "mime_types"], {}, function (pResult) {
        for (var pIndex in pResult.results) {
          if (kFileMimetypes.includes(pResult.results[pIndex].mime_types[0]) === true) {
            that.imageURLs.push(pResult.results[pIndex].cloudflow.file);
            //these extensions do not have a mimetype (yet), but can stil be rendered by the image component
          } else if (kFileExtensions.includes(pResult.results[pIndex].file_extension)) {
            that.imageURLs.push(pResult.results[pIndex].cloudflow.file);
          }
        }
        if (that.imageURLs.length > 0) {
          that.imageURLs.forEach(function (pUrl, pIndex) {
            defaultImageOptions["url"] = pUrl;
            dotscontainer.append($("<div>").addClass("imageslider-dot imageslider-dot" + (pIndex + 1)));
            if (that.options.imageOptions[pIndex] !== undefined) {
              var image = $("<div>").addClass("image" + (pIndex + 1)).Image(Object.assign(that.options.imageOptions[pIndex], defaultImageOptions));
              if (pIndex !== 0) {
                image.css("display", "none");
              }
              imagecontainer.append(image);
            } else {
              var image = $("<div>").addClass("image" + (pIndex + 1)).Image(defaultImageOptions);
              if (pIndex !== 0) {
                image.css("display", "none");
              }
              imagecontainer.append(image);
            }
          });
          that.element.find(".imageslider-dot").first().addClass("imageslider-dot-selected");
        } else {
          imagecontainer.append($("<div>").Image(defaultImageOptions));
          dotscontainer.append($("<div>").addClass("imageslider-dot1 imageslider-dot imageslider-dot-selected"));
        }
      }, function (pFail) {});
      if (this.options.enableControls === true) {
        //unicode code point to represent an abstract character: https://graphemica.com/%E3%80%8A
        var previousButton = $("<button>").addClass("imageslider-direction-button prev").append("&#10094;");
        var nextButton = $("<button>").addClass("imageslider-direction-button next").append("&#10095;");
        imagecontainer.append(previousButton);
        imagecontainer.append(nextButton);
      } else {
        dotscontainer.css("display", "none");
        imagecontainer.css("padding-bottom", "0");
      }
      this.element.append(slide);
      imagecontainer.append(dotscontainer);
      slide.append(imagecontainer);
      slide.append(labelcontainer);
      that._setLabelOrAlt(0);

      //start automatic scrolling
      if (typeof this.options.refreshDelay !== "number") {
        this.options.refreshDelay = 0;
      }
      if (this.options.refreshDelay > 0) {
        this._rotationTimeout();
      }
    },
    /**
     * @description Starts the timeout for the rotation through the images
     * @function
     * @private
     * @name nixps-cloudflow.ImageSlider#_rotationTimeout
     * @returns {undefined}
     */
    _rotationTimeout: function _rotationTimeout() {
      var that = this;
      this.refreshTimeout = setTimeout(function () {
        that.changeImageByDirection("next");
        that._rotationTimeout();
      }, that.options.refreshDelay);
    },
    /**
     * @description Handler for when an arrowbutton of the slider has been clicked
     * @function
     * @private
     * @name nixps-cloudflow.ImageSlider#_clickDirectionHandler
     * @param {Event} pEvent
     * @returns {undefined}
     */
    _clickDirectionHandler: function _clickDirectionHandler(pEvent) {
      var direction = "next";
      if ($(pEvent.target).hasClass("prev")) {
        direction = "prev";
      }
      this.changeImageByDirection(direction);
    },
    /**
     * @description Handler for when a dot at the bottom of the slider has been clicked
     * @function
     * @private
     * @name nixps-cloudflow.ImageSlider#_clickDotHandler
     * @param {Event} pEvent
     * @returns {undefined}
     */
    _clickDotHandler: function _clickDotHandler(pEvent) {
      var imageIndex = 0;
      this.element.find(".imageslider-dots-container").children().each(function (pIndex, pChildElement) {
        if (pChildElement === pEvent.target) {
          imageIndex = pIndex;
        }
      });
      this.changeImageByIndex(imageIndex);
    },
    _focusHandler: function _focusHandler(pEvent) {
      var that = this;
      if (this.options.enableControls === true) {
        Mousetrap.bind(["left"], function () {
          pEvent.preventDefault();
          that.changeImageByDirection("prev");
        }, "keyup");
        Mousetrap.bind(["right"], function () {
          pEvent.preventDefault();
          that.changeImageByDirection("next");
        }, "keyup");
      }
    },
    _blurHandler: function _blurHandler(pEvent) {
      Mousetrap.unbind(["left"], "keyup");
      Mousetrap.unbind(["right"], "keyup");
    },
    /**
     * @description Sets the label or alt for a specific image that's being shown
     * @function
     * @private
     * @name nixps-cloudflow.ImageSlider#_setLabelOrAlt
     * @param {Integer} pImageIndex
     * @returns {undefined}
     */
    _setLabelOrAlt: function _setLabelOrAlt(pImageIndex) {
      var labelcontainer = this.element.find(".imageslider-label-container");
      if (this.options.imageOptions[pImageIndex] !== undefined) {
        if (this.options.imageOptions.length > 0 && this.options.imageOptions[pImageIndex].label !== undefined && this.options.imageOptions[pImageIndex].label.length >= 0) {
          labelcontainer.empty().text(this.options.imageOptions[pImageIndex].label);
        } else if (this.options.imageOptions.length > 0 && this.options.imageOptions[pImageIndex].alt !== undefined && this.options.imageOptions[pImageIndex].alt.length >= 0) {
          labelcontainer.empty().text(this.options.imageOptions[pImageIndex].alt);
        } else {
          labelcontainer.empty().text("");
        }
      } else {
        labelcontainer.empty();
      }
    },
    /**
     * @description Change the image that's shown by direction
     * @function
     * @private
     * @name nixps-cloudflow.ImageSlider#changeImageByDirection
     * @param {String} pDirection can either be "next" or "prev"
     * @returns {Object}
     */
    changeImageByDirection: function changeImageByDirection(pDirection) {
      var maxNoImages = this.imageURLs.length;
      this.element.find(".image" + (this.imageIndex + 1)).css("display", "none");
      this.element.find(".imageslider-dot" + (this.imageIndex + 1)).removeClass("imageslider-dot-selected");
      if (pDirection === "next") {
        this.imageIndex++;
        if (this.imageIndex >= maxNoImages) {
          this.imageIndex = 0;
        }
      } else if (pDirection === "prev") {
        this.imageIndex--;
        if (this.imageIndex < 0) {
          this.imageIndex = maxNoImages - 1;
        }
      } else {
        throw new Error("ImageSlider: can't change image by direction, direction must be either next or prev, got " + pDirection);
      }
      this.element.find(".image" + (this.imageIndex + 1)).css({
        "opacity": "0.4",
        "display": ""
      }).fadeTo(this.options.fadeDuration, 1);
      this._setLabelOrAlt(this.imageIndex);
      this.element.find(".imageslider-dot" + (this.imageIndex + 1)).addClass("imageslider-dot-selected");
      return {
        imageIndex: this.imageIndex
      };
    },
    /**
     * @description Change the image that's shown by the index of the image
     * @function
     * @private
     * @name nixps-cloudflow.ImageSlider#changeImageByIndex
     * @param {Number} pIndex
     * @returns {Object}
     */
    changeImageByIndex: function changeImageByIndex(pIndex) {
      if (typeof pIndex !== "number") {
        throw new Error("ImageSlider: can't change image by index, index must be a number, got " + pIndex);
      }
      if (this.imageURLs.length !== 0 && (pIndex < 0 || pIndex > this.imageURLs.length - 1)) {
        throw new Error("ImageSlider: can't change image by index, index must be in range of the amount of images, got " + pIndex);
      }
      this.element.find(".image" + (this.imageIndex + 1)).css("display", "none");
      this.element.find(".imageslider-dot" + (this.imageIndex + 1)).removeClass("imageslider-dot-selected");
      this.element.find(".image" + (pIndex + 1)).css({
        "opacity": "0.4",
        "display": ""
      }).fadeTo(this.options.fadeDuration, 1);
      this._setLabelOrAlt(pIndex);
      this.element.find(".imageslider-dot" + (pIndex + 1)).addClass("imageslider-dot-selected");
      this.imageIndex = pIndex;
      return {
        imageIndex: this.imageIndex
      };
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps-cloudflow.ImageSlider#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ImageSlider#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this.imageIndex = 0;
      this.imageURLs = [];
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.fadeDuration !== "number") {
        throw new Error("ImageSlider: input option fadeDuration must be a number");
      }
      if (Array.isArray(this.options.imageOptions) === false) {
        throw new Error("ImageSlider: input option imageOptions must be an array");
      }
      this.options.imageOptions.forEach(function (pButtonOption) {
        if ($.isPlainObject(pButtonOption) === false) {
          throw new Error("ImageSlider: input option imageOptions has to be an array of objects");
        }
        if (pButtonOption.label !== undefined && typeof pButtonOption.label !== "string") {
          throw new Error("Imageslider: input option label inside imageOptions must be a string");
        }
      });
      if (typeof this.options.height !== "number" && typeof this.options.height !== "string") {
        throw new Error("ImageSlider: input option height must be either a number or a string");
      }
      if (typeof this.options.enableControls !== "boolean") {
        throw new Error("ImageSlider: input option enableControls must be a boolean");
      }
      if (typeof this.options.objectFit !== "string") {
        throw new Error("ImageSlider: input option objectFit must be a string");
      }
      if (typeof this.options.backgroundColor !== "string") {
        throw new Error("ImageSlider: input option backgroundColor must be a string");
      }
      if ($.isPlainObject(this.options.classes) === false) {
        throw new Error("ImageSlider: input option classes must be an object");
      }
    },
    _destroy: function _destroy() {
      clearTimeout(this.refreshTimeout);
      this._superApply(arguments);
    }

    /************************* LIST OF CLICKABLE IMAGES IN PROGRESS *************************/

    //I thought of making the list of clickable images at the bottom of the ImageSlider for convenience.
    //We could have clicked directly on the image we want to display.
    //I made a list of buttons where each button is an image.
    //In css, I put the list horizontally.And to have this clean list, it still lacks a bit of css.
    //The link between the small images and the display in the central image remains to be done.

    // var imageButtons = $("<ul>").addClass("ul1");

    // for (var counter = 0; counter < this.options.imageOptions.length; counter++) {
    //   imageButtons.append(
    //     $("<li>")
    //       .addClass("li" + (counter + 1))
    //       .append(
    //         $("<button>").Image({
    //           url: this.options.imageOptions[counter].url,
    //           fallbackURL: null,
    //           width: null,
    //           height: null,
    //           maxWidth: 50,
    //           maxHeight: 50,
    //           alt: "Image" + (counter + 1),
    //         })
    //       )
    //   );
    // }
    // slide.append(imageButtons);
  });
})(jQuery);

},{"../../../cloudflow/FormElements/js/nixps-cloudflow-Image.js":149,"../../CloudflowUtil/js/CloudflowURL.js":80}],62:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var UserPreferences = require("../../Preferences/js/UserPreferences.js");
var License = require("../../License/js/License.js");
var User = require("../../User/js/User.js");
var Sites = require("../../Sites/js/Sites.js");
var Context = require("../../../pagebuilder/js/Context.js");
var Consent = require("../../Consent/js/Consent.js");
var UnitPreferences = require("../../Units/js/UnitPreferences.js");
var ApplicationPreferences = require("../../Preferences/js/ApplicationPreferences.js");
var clearCaches = require("./clearCaches.js");
var Scopes = require("../../Scopes/js/Scopes.js");
var redirectToLogin = require("./redirectToLogin.js");
var logoutHandler = require("./logout.js");
var documentTitle = require("./documentTitle.js");
var KeyMappingHandler = require("../../KeyMapping/js/KeyMappingHandler.js");
var BadgeNumberUtil = require("../../PWA/js/BadgeNumberUtil.js");
var Device = require("../../PWA/js/Device.js");
var TouchEventGenerator = require("../../../common/Touch/js/TouchEventGenerator.js");
var matchBrowserLanguage = require("../../../common/BrowserLanguage/js/matchBrowserLanguage.js");
var nixpsBroadcast = require("./nixpsBroadcast.js");
var ContextStorage = require("../../CloudflowUtil/js/ContextStorage.js");
if (window.$ && $.widget) {
  require("../../Consent/js/nixps-cloudflow-ConsentDialog.js");
}
var kResourceDict = {
  "unitpreferences": UnitPreferences,
  "consent": Consent
};
var touchGenerators = [];

/**
 * @class nixps.cloudflow.Init
 * @constructor Init
 * @description This function will do all the preparations, including good initalisation of the translations for a cloudflow web page. <br />
 * The default options are: 
 * <ul>
 *  <li>output: [] (Array) default empty, can contain: "sites", "user", "context" or "license". If given, this function will give those util objects back</li>
 *  <li>translations: {} (Object) options for translations</li>
 * </ul>
 * More information about the util objects can be find here: {@link Sites},  {@link User}, {@link License} 
 * @example nixps.cloudflow.Init({output: ["user"]}).then(function(pUserPref, pUser) { }, function(pError){ console.error(pError);});
 * @example nixps.cloudflow.Init({output: ["user"]}, function(pUserPref, pUser) { }, function(pError){ console.error(pError);});
 * @param {object} pOptions The options given as object.
 * @param {function} pGoodCallbackFunction - Function called when every call is done correctly.
 * @param {function} pErrorCallbackFunction - Function called when a call returned an error message.
 * @return {Promise} The first argument is the {@link UserPreferences} object, followed by the utils objects given by the ouput option
 * @version 1.6.0
 */
var Init = function Init(pOptions, pGoodCallbackFunction, pErrorCallbackFunction) {
  var that = this;
  // control input parameters
  if (pOptions === undefined) {
    pOptions = {};
  } else if (_typeof(pOptions) !== "object" || Array.isArray(pOptions)) {
    throw new Error("pOptions must be a plain object");
  }
  // Default options
  var options = {
    /**
     * @description The extra utility objects to ask, must be a limited array of known names
     * @type {Array}
     * @default []
     * @example ["user", "license"]
     */
    output: [],
    /**
     * @description External defs to be tails after the output, to have a cleaner code
     * @type {Array}
     * @default undefined
     * @since 1.1.0
     */
    externalTailOutput: undefined,
    /**
     * @description The extra translation options
     * @type {Array<object>}
     * @example [{ path: "/portal.cgi/PP_FILE_STORE/Hybrid/Framework/Translations", templateFileName: "language_" }]
     */
    translations: {},
    /**
     * @description The path of the main translation file, keep undefined
     * @private
     * @type {String}
     * @default undefined
     * @since 1.6.0
     */
    mainTranslationPath: undefined,
    /**
     * @description The file name template of the main translation file, keep undefined
     * @private
     * @type {String}
     * @default undefined
     * @since 1.6.0
     */
    mainTranslationTemplateFileName: undefined,
    /**
     * @description if we know in advance that the user a contact is?
     * @private
     * @type {Boolean}
     * @default undefined
     * @since 1.6.0
     */
    isContact: undefined,
    /**
     * @description The options to create the context object
     * @type {String}
     * @default "url"
     */
    context: "url",
    /**
     * @description The context to be used if nothing is defined
     * @type {JSON}
     * @default undefined
     */
    contextIfNothingDefined: undefined,
    /**
    * @description The url that contains all the JSON of the short cuts
    * @type {String}
    * @default undefined
    */
    shortCutsDefinitionsURL: undefined,
    /**
     * @description Must we apply the consent according to the settings, Set this option on false to disable it completely
     * for example on pages to configure the consent itself
     * @type {Boolean}
     * @default true,
     */
    askConsent: true,
    /**
     * @description Disacivation BFCaching, this can effect issues when coing back in history in the browser
     * @type {Boolean}
     * @default true
     */
    disablingFBCaching: true,
    /**
     * @description Callback function to warn that the session will expire, with first arugment the amount of resting milliseconds
     * @type {Function}
     * @default undefined
     * @since 1.1.0
     */
    sessionExpireWarningCB: undefined,
    /**
     * @description The application name to be used to apply the browser tab title
     * @type {String}
     * @default undefined
     * @since 1.3.0
     */
    documentTitleApplication: undefined,
    /**
     * @description The selected item that needs to be displayed in the browser tab title.
     * works only if option documentTitleApplication is set up correctly
     * @type {String}
     * @default undefined
     * @since 1.3.0
     */
    documentTitleItem: undefined,
    /**
     * @description Must we skip the user cache and always reassk the browser?
     * @private
     * @type {Boolean}
     * @default undefined
     * @since 1.6.0
     */
    skipUserCache: undefined,
    /**
     * @description The arguments to be passed to the ApplicationPreferences Class
     * @type {Array}
     * @default []
     * @since 1.5.0
     */
    applicationpreferencesArguments: [],
    /**
     * @description The main color name for the pwa and browser
     * @type {String}
     * @default undefined
     * @since 1.6.0
     */
    mainColorVariableName: undefined,
    /**
     * @description The url of the service worker
     * @type {String}
     * @default undefined
     * @since 1.4.0
     */
    serviceWorkerURL: undefined,
    /**
     * @description The badge Number
     * @type {Object}
     * @default undefined
     * @since 1.4.0
     */
    badgeNumberConfiguration: undefined,
    /**
     * @description Must we listen and generate develop friendly touch events
     * @type {Boolean}
     * @default true
     * @since 1.6.0
     */
    generateTouchEvents: true
  };

  // apply defaults in parameter options
  options = $.extend(true, options, pOptions);
  if (options.disablingFBCaching === true && typeof window.addEventListener === "function") {
    // Nebula can for the moment not handle the fbCaching of safari,
    // for the moment only Safari can have a persistency key on true
    window.addEventListener("pageshow", function (event) {
      if (event.persisted === true || event.originalEvent && event.originalEvent.persisted === true) {
        window.location.reload();
      }
    });
  }
  if (document && document.addEventListener) {
    document.addEventListener("drop", function (e) {
      e.preventDefault();
    });
    document.addEventListener("dragover", function (e) {
      e.preventDefault();
    });
  }
  Device.init({
    mainColorVariableName: options.mainColorVariableName,
    serviceWorkerURL: options.serviceWorkerURL,
    appBadgeNumber: options.badgeNumberConfiguration !== undefined ? BadgeNumberUtil.parse(options.badgeNumberConfiguration) : undefined
  });
  if (options.generateTouchEvents === true) {
    touchGenerators.push(new TouchEventGenerator(undefined, {}));
  }
  //
  var lastTimeStampOverloadCookie = api_util.get_cookie("com.nixps.server-overload");
  if (typeof lastTimeStampOverloadCookie === "string" && lastTimeStampOverloadCookie.length > 0) {
    if (new Date() - new Date(lastTimeStampOverloadCookie) < 10 * 60000 + Math.random() * 30000) {
      Device.bringInError({
        "error_code": "http_errorcode_503",
        "error": "restart in overload mode"
      });
    } else {
      // stop panic mode
      api_util.set_cookie("com.nixps.server-overload", null);
      if (nixpsBroadcast) {
        nixpsBroadcast.postMessage({
          type: "nixps.error.server_overload_reset",
          data: {}
        });
      }
      var data = {
        missing_data: true,
        error_details_length: 0,
        ending_url: window.location.href,
        error_details: []
      };
      if (ContextStorage.isSupport()) {
        var errordata = ContextStorage.read(undefined, false, "com.nixps.server-overload");
        if (Array.isArray(errordata) && errordata.length > 0) {
          data.missing_data = false;
          data.error_details_length = errordata.length;
          data.start_url = errordata[0].url;
          data.error_details = errordata.slice(0, 5);
        }
      }
      api_defer.logging.trace.log("com.nixps.ui", "error", "Panic mode:" + JSON.stringify(data)).then(function (pResult) {
        if (pResult && pResult.enabled === true) {
          return {};
        } else {
          // should not come here ...
          return api_defer.portal.log("error", "Panic mode", undefined, data);
        }
      }, function () {
        // should not come here ...
        return api_defer.portal.log("error", "Panic mode", undefined, data);
      }).then(function () {
        // send correctly, so we can clean it properly
        ContextStorage.read(undefined, true, "com.nixps.server-overload");
      });
    }
  }
  if (typeof options.sessionExpireWarningCB === "function") {
    this.sessionTimeoutID = setSessionExpireWarningNotification(options.sessionExpireWarningCB);
  }
  if (typeof window.BroadcastChannel === "function") {
    nixpsBroadcast.onmessage = function (pEvent) {
      if (pEvent !== undefined && pEvent.data !== undefined) {
        if (pEvent.data.type === "nixps.logout" || pEvent.data.type === "nixps.session_expired") {
          clearCaches();
          if (portal_api_base !== undefined && typeof portal_api_base.prototype.session_expired === "function") {
            portal_api_base.prototype.session_expired();
          } else {
            redirectToLogin();
          }
        } else if (pEvent.data.type === "nixps.user_configuration.language_changed") {
          if (portal_api_base !== undefined && typeof portal_api_base.prototype.config_changed === "function") {
            portal_api_base.prototype.config_changed("user_language", {});
          }
        } else if (pEvent.data.type === "nixps.logout.oauth2") {
          // what to do for oauth2
        } else if (pEvent.data.type === "nixps.login") {
          if (typeof that.sessionTimeoutID === "number") {
            clearTimeout(that.sessionTimeoutID);
          }
          if (typeof options.sessionExpireWarningCB === "function") {
            that.sessionTimeoutID = setSessionExpireWarningNotification(options.sessionExpireWarningCB);
          }
        } else if (pEvent.data.type === "nixps.error.server_overload") {
          Device.bringInError(pEvent.data.data || {
            "error_code": "unknown_error"
          });
        }
      }
    };
  }
  var mayAccessCookies;
  try {
    _typeof(document.cookie);
    mayAccessCookies = true;
  } catch (e) {
    mayAccessCookies = false;
  }
  // if no cookies and in a host and a session is provided, then we need are in a huge need of cookies!! COOOKIIEES
  if (mayAccessCookies === true && typeof document.cookie.trim === "function" && document.cookie.trim() === "" && window.location.search.toLocaleLowerCase().indexOf("&host=") > 0) {
    var sessionIndex = window.location.search.toLocaleLowerCase().indexOf("&session=");
    if (sessionIndex > 0 && api_util.get_session() !== undefined) {
      /** @todo call api to retrieve cookies */
    }
  }
  setTimeout(function () {
    var customStyle = document.head.querySelectorAll('[href="/portal.cgi?resource=download&url=cfresource%3A%2F%2FStyleSheet%2FCloudflow%2520Light.css&override=true&inline=true"]');
    try {
      if (customStyle && customStyle[0] && customStyle[0].sheet && customStyle[0].sheet.cssRules) {
        var errorFound = false;
        for (var ruleIndex = customStyle[0].sheet.cssRules.length - 1; ruleIndex >= 0; ruleIndex--) {
          if (/[^-]{2}display\s*:|[^-]{2}position\s*:|[^-]{2}margin\s*:|[^-]{2}padding\s*:|[^-]{2}content\s*:/i.test(customStyle[0].sheet.cssRules[ruleIndex].cssText)) {
            if (errorFound === false) {
              errorFound = true;
              console.error("CSS attack detected");
              api_defer.logging.trace.log("com.nixps.ui", "error", "CSS attack detected");
              api_defer.preferences.save_for_realm("cfresource://StyleSheet/__no_custom_style__", "system", "", "com.nixps.server", "styling.cfresource://StyleSheet/Cloudflow%20Light_css");
            }
            customStyle[0].sheet.deleteRule(ruleIndex);
          }
        }
      }
    } catch (error) {
      if (error && typeof error.message === "string" && error.message.indexOf("Cannot access rules") >= 0) {
        return; // ingore security error
      }

      console.error(error);
    }
  });

  // add and apply the extra utility classes
  var outputDefs = [];
  var sitesDef = null;
  // make sure ApplicationPreferences will get everything we need
  var userApplicationKeys = [];
  var systemApplicationKeys = [];
  var requiresSet = {};

  // userpreferences 
  var userResources = UserPreferences.getResources();
  if (Array.isArray(userResources) && userResources.length > 0) {
    for (var r = 0; r < userResources.length; r++) {
      if (userResources[r].apiCall === "get_for_current_user") {
        userApplicationKeys.push(userResources[r].apiAppKey);
      } else if (userResources.apiCall === "get_for_realm") {
        systemApplicationKeys.push(userResources[r].apiAppKey);
      }
    }
  }
  for (var i = 0; i < options.output.length; i++) {
    if (options.output[i] === "shortcuts" && options.shortCutsDefinitionsURL === undefined) {
      //adapt the applicationpreferencesArguments to include keyshortcuts - ONLY when not reading from file
      var keyMappingResource = KeyMappingHandler.getResources()[0];
      if (keyMappingResource.apiCall === "get_for_current_user") {
        userApplicationKeys.push(keyMappingResource.apiAppKey);
      } else if (keyMappingResource.apiCall === "get_for_realm") {
        systemApplicationKeys.push(keyMappingResource.apiAppKey);
      }
      requiresSet["shortcuts"] = {
        handler: KeyMappingHandler,
        outputIndex: i
      };
    } else if (kResourceDict[options.output[i]] !== undefined && typeof kResourceDict[options.output[i]].getResources === "function") {
      // adapt the applicationpreferencesArguments to include units
      var resources = kResourceDict[options.output[i]].getResources();
      if (Array.isArray(resources) && resources.length > 0) {
        for (var r = 0; r < resources.length; r++) {
          if (resources[r].apiCall === "get_for_current_user") {
            userApplicationKeys.push(resources[r].apiAppKey);
          } else if (resources[r].apiCall === "get_for_realm") {
            systemApplicationKeys.push(resources[r].apiAppKey);
          }
        }
      }
      requiresSet[options.output[i]] = {
        handler: kResourceDict[options.output[i]],
        outputIndex: i
      };
    }
  }
  if (userApplicationKeys.length > 0) {
    if (Array.isArray(options.applicationpreferencesArguments[0]) === false) {
      options.applicationpreferencesArguments[0] = [];
    }
    options.applicationpreferencesArguments[0] = options.applicationpreferencesArguments[0].concat(userApplicationKeys);
  }
  if (systemApplicationKeys.length > 0) {
    if (Array.isArray(options.applicationpreferencesArguments[1]) === false) {
      options.applicationpreferencesArguments[1] = [];
    }
    options.applicationpreferencesArguments[1] = options.applicationpreferencesArguments[1].concat(systemApplicationKeys);
  }
  var extraApplicationPreferences = ApplicationPreferences.get.apply(ApplicationPreferences, options.applicationpreferencesArguments);
  for (var i = 0; i < options.output.length; i++) {
    if (options.output[i] === "license") {
      // the license util object
      outputDefs.push(License.get());
    } else if (options.output[i] === "user") {
      // the users util object
      outputDefs.push(User.get(options.skipUserCache));
    } else if (options.output[i] === "sites") {
      // the sites util object
      sitesDef = Sites.get();
      outputDefs.push(sitesDef);
    } else if (options.output[i] === "context") {
      var context;
      if (options.context === "url") {
        try {
          context = Context.fromURL(options.contextIfNothingDefined);
        } catch (pError) {
          if (typeof pErrorCallbackFunction === "function") {
            pErrorCallbackFunction(pError);
          }
          return Promise.reject(pError);
        }
      } else {
        context = new Context();
      }
      outputDefs.push(context.loadDataAndReturnsMe({
        use_cache: true
      }));
    } else if (options.output[i] === "consent") {
      // will be set later, grouped with applicationpref
      outputDefs.push({});
    } else if (options.output[i] === "scopes") {
      outputDefs.push(new Scopes());
    } else if (options.output[i] === "host") {
      var host = null;
      var urlParameters = new URI().query(true); // object containing the url parameters
      if (typeof urlParameters.host === "string" && urlParameters.host.length > 0) {
        host = {
          identifier: urlParameters.host
        };
      }
      outputDefs.push(host);
    } else if (options.output[i] === "shortcuts") {
      if (options.shortCutsDefinitionsURL !== undefined) {
        var keyMappingHandler = new KeyMappingHandler(options.shortCutsDefinitionsURL);
        var shortcutsDef = keyMappingHandler.get(typeof options.shortCutsDefinitionsURL === "string" && options.shortCutsDefinitionsURL.length > 0);
        outputDefs.push(shortcutsDef);
      } else {
        // will be set later!
        outputDefs.push({});
      }
    } else if (options.output[i] === "applicationpreferences") {
      outputDefs.push(extraApplicationPreferences);
    } else if (options.output[i] === "unitpreferences") {
      // will be set later, grouped with applicationpref
      outputDefs.push({});
    } else {
      console.error("unsupported ouput item: " + options.output[i]);
    }
  }
  // add aditional outputs
  if (Array.isArray !== undefined && Array.isArray(options.externalTailOutput) && options.externalTailOutput.length > 0) {
    // just append
    outputDefs = outputDefs.concat(options.externalTailOutput);
  }
  // if no sites are called and we need sites
  if (typeof options.documentTitleApplication === "string" && sitesDef === null) {
    sitesDef = Sites.get();
  }

  // do first the call to the user Preferences, afterwards all the demanding calls
  return $.when(extraApplicationPreferences).then(function (applicationPreferences) {
    // get good userprefs
    var userPreferResults = [];
    if (Array.isArray(userResources) && userResources.length > 0) {
      for (var r = 0; r < userResources.length; r++) {
        if (userResources[r].apiCall === "get_for_current_user") {
          userPreferResults.push(applicationPreferences.getUserValue(userResources[r].apiAppKey, userResources[r].apiSubKey));
        } else if (userResources[r].apiCall === "get_for_realm") {
          userPreferResults.push(applicationPreferences.getSystemValue(userResources[r].apiAppKey, userResources[r].apiSubKey));
        }
      }
    }
    UserPreferences.set(userPreferResults[0], userPreferResults[1]);
    var userPreferences = new UserPreferences(userPreferResults[0], userPreferResults[1]);
    if (options.isContact === true && userPreferences.isLanguageKnown() === false) {
      var newLanguage = matchBrowserLanguage();
      userPreferences.setLanguage(newLanguage);
      ApplicationPreferences.saveUserValue("", "language", newLanguage);
    }
    // insert other data
    if (Object.keys(requiresSet).length > 0) {
      //lets grab the proper preferences for the specific outputs
      for (var outputPreference in requiresSet) {
        //grab the correct preferences
        var resources = requiresSet[outputPreference].handler.getResources();
        var prefs = [];
        if (Array.isArray(resources) && resources.length > 0) {
          for (var r = 0; r < resources.length; r++) {
            if (resources[r].apiCall === "get_for_current_user") {
              prefs.push(applicationPreferences.getUserValue(resources[r].apiAppKey, resources[r].apiSubKey));
            } else if (resources[r].apiCall === "get_for_realm") {
              prefs.push(applicationPreferences.getSystemValue(resources[r].apiAppKey, resources[r].apiSubKey));
            } else {
              throw new Error("Init: trying to request a grouped preference that's not supported right now");
            }
          }
        }
        requiresSet[outputPreference].handler.set.apply(requiresSet[outputPreference].handler, prefs);
        if (typeof requiresSet[outputPreference].handler.getWithInstance === "function") {
          //first check if with instance is present -> means we want this instead of regular get
          outputDefs[requiresSet[outputPreference].outputIndex] = requiresSet[outputPreference].handler.getWithInstance();
        } else if (typeof requiresSet[outputPreference].handler.get === "function") {
          outputDefs[requiresSet[outputPreference].outputIndex] = requiresSet[outputPreference].handler.get();
        }
      }
    }
    outputDefs.unshift(userPreferences);
    outputDefs.unshift(userPreferences.getTranslations(options.mainTranslationPath, options.mainTranslationTemplateFileName, options.translations));
    return $.when.apply($, outputDefs);
  }).then(function (pTranslations, pUserPref) {
    // set the translations
    $.i18n.setDictionary(pTranslations);
    var translateFn = $.i18n._.bind($.i18n);
    // set up for accessibility, spellcheckers and autowordbreaks
    // DO NOT USE that lang attribute to retrieve the language,
    // ALWAYS use the UserPreference object or the parent option, because they can differ in the future!!
    document.documentElement.setAttribute("lang", pUserPref.getLanguage());

    // set browser tab title
    if (typeof options.documentTitleApplication === "string") {
      if (sitesDef === null) {
        documentTitle("", translateFn(options.documentTitleApplication), options.documentTitleItem);
      } else {
        sitesDef.then(function (pSites) {
          documentTitle(pSites.getShortSiteName(), translateFn(options.documentTitleApplication), options.documentTitleItem);
        }, function () {
          documentTitle("", translateFn(options.documentTitleApplication), options.documentTitleItem);
        });
      }
    }

    // set consent
    if (options.askConsent === true && window.$ && $.fn && $.fn.ConsentDialog) {
      Consent.get().then(function (consent) {
        if (consent.needToAsk()) {
          // if we know in advance that we dont need to ask, do not draw empty component
          $("body").append($("<div>").ConsentDialog({
            consent: consent
          }));
        }
      });
    }

    // if user is logged via an external party, the plugin suite needs to recieve the cloudflow session
    // when redirection we recieve a cookie
    var isExternalRedirect = api_util.get_cookie("externalLogin");
    if (isExternalRedirect === "T") {
      api_defer.frame.os.get().then(function () {
        // only when plugin suite is present
        return User.get().then(function (pUser) {
          // to retrieve username
          return api_defer.auth.create_session(pUser.getUserName()).then(function (pResults) {
            return api_defer.frame.os.set_cloudflow_session(pResults.session, {
              "force": true,
              "expiry_time": pResults.expiry_time
            });
          });
        });
      }, function () {
        return; /* no plug suite, so transform an error to an resolve() */
      }).then(function () {
        // remove cookie, to prevent resetting session
        api_util.set_cookie("externalLogin", null);
      });
    }

    // set the outputs
    var outputArguments = Array.from(arguments).slice(1);
    // call goodback function
    if (typeof pGoodCallbackFunction === "function") {
      pGoodCallbackFunction.apply(this, outputArguments);
    }
    if (window.$) {
      return $.when.apply($, outputArguments);
    } else {
      Promise.all(outputArguments).then(function (pOutputArg) {
        return Promise.resolve.apply(Promise, pOutputArg);
      });
    }
  }, function (pError) {
    // errors of both when will pass by this function
    // throw error on console!
    console.error(pError);
    // call error callback function
    if (typeof pErrorCallbackFunction === "function") {
      pErrorCallbackFunction(pError);
    }
    return Promise.reject(pError);
  });
};
function setSessionExpireWarningNotification(pGlobalCallbackFunction) {
  var expiration_date = parseInt(api_util.get_cookie("expiration_date"));
  if (typeof expiration_date === "number" && expiration_date > 0 && isFinite(expiration_date)) {
    var resting = expiration_date * 1000 - new Date().getTime();
    var warningTime = 1000 * 60 * 10;
    var callbackFunc = function callbackFunc(pRestingMilliSec, pOriginalExpirationDate) {
      if (pOriginalExpirationDate !== parseInt(api_util.get_cookie("expiration_date"))) {
        // cookie has changed
        return;
      }
      if (window.$ && $.fn && $.fn.notify) {
        $("#notify-area").notify("create", "closeable-error", {
          title: $.i18n._("nixps-cloudflow-login.sessionswillexpire_title"),
          text: $.i18n._("nixps-cloudflow-login.sessionswillexpire_message", [parseInt(pRestingMilliSec / 60000)])
        }, {
          expires: false,
          click: function click(e, instance) {
            window.open("/portal.cgi?login=%2a&closeafterlogin=true", "login", "scrollbars=yes,toolbar=no,height=500,width=590");
            instance.close();
          }
        });
      }
      pGlobalCallbackFunction(pRestingMilliSec);
    };
    if (resting > 0) {
      if (resting < warningTime) {
        return setTimeout(callbackFunc, 1000, resting, expiration_date);
      } else if (resting < 2147483647) {
        return setTimeout(callbackFunc, resting - warningTime, warningTime, expiration_date);
      }
    } else {
      console.warn("error in expiration date calculations");
    }
  }
  return null;
}
Init.clearCaches = function () {
  UserPreferences.clearCaches();
  User.prototype.reset();
  User.clear();
  Sites.reset();
  ApplicationPreferences.clear();
  touchGenerators.forEach(function (pGenerator) {
    pGenerator.destroy();
  });
};
Init.redirectToLogin = redirectToLogin;
Init.logout = logoutHandler;
Init.documentTitle = documentTitle;
module.exports = Init;

// add init on global enviroment to handle the use of init on global scope in HTML page
if (window.nixps === undefined) {
  window.nixps = {};
}
if (window.nixps.cloudflow === undefined) {
  window.nixps.cloudflow = {};
}
window.nixps.cloudflow.Init = Init;

},{"../../../common/BrowserLanguage/js/matchBrowserLanguage.js":276,"../../../common/Touch/js/TouchEventGenerator.js":381,"../../../pagebuilder/js/Context.js":413,"../../CloudflowUtil/js/ContextStorage.js":82,"../../Consent/js/Consent.js":96,"../../Consent/js/nixps-cloudflow-ConsentDialog.js":97,"../../KeyMapping/js/KeyMappingHandler.js":174,"../../License/js/License.js":175,"../../PWA/js/BadgeNumberUtil.js":197,"../../PWA/js/Device.js":198,"../../Preferences/js/ApplicationPreferences.js":201,"../../Preferences/js/UserPreferences.js":202,"../../Scopes/js/Scopes.js":204,"../../Sites/js/Sites.js":207,"../../Units/js/UnitPreferences.js":265,"../../User/js/User.js":268,"./clearCaches.js":63,"./documentTitle.js":64,"./logout.js":66,"./nixpsBroadcast.js":67,"./redirectToLogin.js":69}],63:[function(require,module,exports){
"use strict";

var IndexedStorage = require("../../../common/BrowserStorage/js/IndexedStorage.js");

/**
 * @description This will clear all the browser cache that could be funerable
 * @function
 */
function clearCaches() {
  if (window.sessionStorage !== undefined) {
    sessionStorage.clear();
  }
  if (IndexedStorage.isSupported() === true) {
    IndexedStorage.deleteDB("nixps.Pagebuilder.Debug");
  }
}
module.exports = clearCaches;

},{"../../../common/BrowserStorage/js/IndexedStorage.js":278}],64:[function(require,module,exports){
"use strict";

/**
 * @description set up the browser tab title, this is the document.title
 * @function
 * @param {Site} pSite the Site object or the site name
 * @param {String} pApplicationName The application name
 * @param {String} pPageSpecificSubject the name of the selected item       
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function setDocumentTitle(pSite, pApplicationName, pPageSpecificSubject) {
  var title = "";
  if (typeof pPageSpecificSubject === "string") {
    title = pPageSpecificSubject + " - ";
  }
  if (typeof pApplicationName === "string") {
    title += pApplicationName;
  }
  if (typeof pSite === "string") {
    title += " " + pSite;
  } else if (_typeof(pSite) === "object" && typeof pSite.getShortSiteName === "function") {
    title += " " + pSite.getShortSiteName();
  }
  document.title = title;
}
module.exports = setDocumentTitle;

},{}],65:[function(require,module,exports){
"use strict";

var Device = require("../../PWA/js/Device.js");
var nixpsBroadcast = require("./nixpsBroadcast.js");
var ContextStorage = require("../../CloudflowUtil/js/ContextStorage.js");
portal_api_base.prototype.http_error = function (xhr, pCommand) {
  function showMessage(pTitle, pMessage, pType, pExpires) {
    if (window.jQuery !== undefined && $(".nixps-NotifyArea").length > 0) {
      $(".nixps-NotifyArea").NotifyArea("createMessage", pType, pTitle, pMessage, pExpires);
    } else {
      portal_api_base.prototype.message(pTitle, pMessage, pType, !pExpires);
    }
  }
  if (xhr !== undefined) {
    if (xhr.status === 504 || xhr.status == 503 || xhr.status === 429) {
      // specific error status for sever overload
      showMessage(xhr.statusText, $.i18n._("nixps-cloudflow-manage.httperror_serveroverload"), "closeable-error", false);
      Device.bringInError({
        error_code: "http_errorcode_" + xhr.status,
        error: $.i18n._("nixps-cloudflow-manage.httperror_serveroverload")
      });
      if (nixpsBroadcast && typeof nixpsBroadcast.postMessage === "function") {
        nixpsBroadcast.postMessage({
          type: "nixps.error.server_overload",
          data: {
            error_code: "http_errorcode_" + xhr.status
          }
        });
      }
      var timestampID = new Date().toISOString();
      api_util.set_cookie("com.nixps.server-overload", timestampID, {
        expires: 1,
        path: "/",
        samesite: "Strict"
      });
      var serverOverloadDetails = {
        timestampID: timestampID,
        url: window.location.href,
        referrer: document.referrer,
        status: xhr.status,
        command: JSON.stringify(pCommand)
      };
      if (ContextStorage.isSupport()) {
        ContextStorage.write(serverOverloadDetails, timestampID, "com.nixps.server-overload");
      }
    } else if (xhr.status > 500) {
      showMessage(xhr.statusText, $.i18n._("nixps-cloudflow-manage.httperror_generic", [xhr.status]), "closeable-error", false);
    }
  }
};

},{"../../CloudflowUtil/js/ContextStorage.js":82,"../../PWA/js/Device.js":198,"./nixpsBroadcast.js":67}],66:[function(require,module,exports){
"use strict";

var redirectToLogin = require("./redirectToLogin.js");
var clearCaches = require("./clearCaches.js");
var nixpsBroadcast = require("./nixpsBroadcast.js");
function clearCookies() {
  api_util.set_cookie("user_id", null, {
    path: "/"
  });
  api_util.set_cookie("user_hash", null, {
    path: "/"
  });
  api_util.set_cookie("expiration_date", null, {
    path: "/"
  });
  api_util.set_cookie("csrf-token", null, {
    path: "/"
  });
  api_util.set_cookie("scope", null, {
    path: "/"
  });
}

/**
 * @description This function will logout the users
 * @function
 * @param {Boolean} pRedirectToLogin must we redirect to the login page?
 * @param {Array} pRedirectToLoginArguments parameters of the redirecttoLogin page
 */
function logout(pRedirectToLogin, pRedirectToLoginArguments) {
  /* reset sessions */
  clearCaches();
  return api_defer.auth.logout().then(function (pResult) {
    clearCookies();
    if (pResult && pResult.result && typeof pResult.result.redirect_url === "string" && pResult.result.redirect_url.length > 0) {
      //maybe only clear cookies when we get back from redirect? 
      logout._broadCastMessage("nixps.logout.oauth2");
      window.location = pResult.result.redirect_url;
      return {
        "redirect": false
      };
    } else if (pRedirectToLogin === true) {
      logout._broadCastMessage("nixps.logout");
      redirectToLogin.apply(this, pRedirectToLoginArguments);
    } else {
      logout._broadCastMessage("nixps.logout");
    }
  }, function (pError) {
    // logout failed, 
    // still clear cookies and other stuff as fallback
    console.error(pError);
    clearCookies();
    if (pRedirectToLogin === true) {
      redirectToLogin.apply(this, pRedirectToLoginArguments);
    }
  });
}
logout._broadCastMessage = function (pMessage) {
  if (typeof window.BroadcastChannel === "function") {
    nixpsBroadcast.postMessage({
      type: pMessage,
      data: {}
    });
  }
};
module.exports = logout;

},{"./clearCaches.js":63,"./nixpsBroadcast.js":67,"./redirectToLogin.js":69}],67:[function(require,module,exports){
"use strict";

/**
 * @description separated, because we want the exact same channel js object...
 * @private
 */
var nixpsBroadcast = undefined;
if (typeof window.BroadcastChannel === "function") {
  nixpsBroadcast = new BroadcastChannel("nixps");
}
module.exports = nixpsBroadcast;

},{}],68:[function(require,module,exports){
"use strict";

var redirectToLogin = require("./redirectToLogin.js");
var User = require("../../User/js/User.js");
if (typeof portal_api_base === "undefined") {
  window.portal_api_base = function () {};
}

/*
 * Redirect to the license expired page in case Cloudflow is not licensed
 */
portal_api_base.prototype.not_licensed = function () {
  // stop redirecting if in license
  if (window.location.href.indexOf("/portal.cgi?config=1#license") >= 0) {
    return;
  }
  if (window.$ !== undefined) {
    $(window).off("beforeunload"); // disable warning when redirecting
  }

  User.get().then(function (pUser) {
    if (pUser.isAdminAdmin()) {
      window.location = "/nebulaportal/portal_no_license_admin.html";
    } else {
      window.location = "/nebulaportal/portal_no_license_user.html";
    }
  }, function () {
    // fallback in case of error
    window.location = "/nebulaportal/portal_no_license_user.html";
  });
};

/*
 * Redirect to the login page in case the session is expired
 */
portal_api_base.prototype.session_expired = function () {
  if (window.$ !== undefined) {
    $(window).off("beforeunload"); // disable warning when redirecting
  }

  redirectToLogin();
};

},{"../../User/js/User.js":268,"./redirectToLogin.js":69}],69:[function(require,module,exports){
"use strict";

/**
 * @description This function will redirect the browser to the login page
 * @function
 * @param {Boolean} pUseOrig if true, it will also add the orig parameter, default false
 * @param {String} pFallbackURL the url to go to after re login
 */
var redirectToLogin = function redirectToLogin(pUseOrig, pFallbackURL) {
  var url = "/";
  if (pUseOrig === false) {
    redirectToLogin._redirect(url);
    return;
  } else if (typeof pFallbackURL === "string" && pFallbackURL.length > 0) {
    url = "/?orig=" + encodeURIComponent(pFallbackURL);
  } else {
    url = "/?orig=" + encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
  }
  redirectToLogin._redirect(url);
};
// dedicated function, to be able to make unit tests
redirectToLogin._redirect = function (pURL) {
  window.location = pURL;
};
module.exports = redirectToLogin;

},{}],70:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 24-feb-2020 11:59:36
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var CloudflowConnection = require("../../CloudflowUtil/js/CloudflowConnection.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  var Device = require("../../PWA/js/Device.js");

  /**
   * @namespace nixps-cloudflow-CloudflowProgressBar
   * @description Draw a pagebuilder progressbar
   * @example $('<div>').CloudflowProgressBar({});
   */
  $.widget("nixps-cloudflow.CloudflowProgressBar", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "cloudflowprogressbar",
    options: {
      /**
       * @desc The init value of the progressbar
       * @name nixps-cloudflow.CloudflowProgressBar#value
       * @default 3
       * @type {Number}
       */
      value: 3,
      /**
       * @description The maximum value of the progressbar
       * @name nixps-cloudflow.CloudflowProgressBar#max
       * @type {Number}
       * @default 100
       */
      max: 100,
      /**
      * @description Show an activity bar instead of loading bar.
      * @name nixps-cloudflow.CloudflowProgressBar#activityBar
      * @type {Boolean}
      * @default false
      */
      activityBar: false,
      /**
       * @description The color of the progressBar
       * @name nixps-cloudflow.CloudflowProgressBar#color
       * @type {String}
       * @default null
       */
      progressColor: null,
      /**
       * @description The backgroundColor of the progressBar
       * @name nixps-cloudflow.CloudflowProgressBar#backgroundColor
       * @type {String}
       * @default null
       */
      backgroundColor: null,
      /**
       * @description The class for progress bar
       * @name nixps-cloudflow.CloudflowProgressBar#styleClassProgress
       * @type {String}
       * @default null
       */
      styleClassProgress: null,
      /**
       * @description The class for progress bar background
       * @name nixps-cloudflow.CloudflowProgressBar#styleClassBackground
       * @type {String}
       * @default null
       */
      styleClassBackground: null,
      /**
       * @name nixps-cloudflow.CloudflowProgressBar#height
       * @description The height of the progressbar
       * @type {mixed}
       * @default null
       */
      height: null,
      /**
       * @name nixps-cloudflow.CloudflowProgressBar#tooltip
       * @description The tooltip in the progressbar
       * @type {String}
       * @default undefined
       */
      tooltip: undefined,
      /**
       * @description The value path where to look in the object to retrieve the value
       * @name nixps-cloudflow.CloudflowProgressBar#valuePath
       * @type {String}
       * @default null
       */
      valuePath: null,
      /**
       * @description stop refreshing if the progressbar has been completed
       * @name nixps-cloudflow.CloudflowProgressBar#stopOnComplete
       * @type {Boolean}
       * @default true
       */
      stopOnComplete: true,
      /**
       * @description All the data needed to retrieve the information
       * @name nixps-cloudflow.CloudflowProgressBar#dataSource
       * @type {Object}
       */
      dataSource: {
        collection: "",
        data: [],
        dataFileURL: "",
        httpserviceInputName: "",
        httpserviceWhitepaperName: ""
      },
      /**
       * @description The extra filter query asked to the backend
       * @name nixps-cloudflow.CloudflowProgressBar#extraQuery
       * @type {Array.<String>}
       * @default []
       */
      extraQuery: [],
      /**
       * @name nixps-cloudflow.CloudflowProgressBar#keyUniqID
       * @description The parameter name of the id of the objects
       * @type {String}
       * @default "_id"
       */
      keyUniqID: "_id",
      /**
       * @description The relative base path of the data file
       * @name nixps-cloudflow.CloudflowProgressBar#relativeBasePath
       * @type {String}
       * @default ""
      */
      relativeBasePath: "",
      /**
       * @description The delay between refresh cycles in milliseconds
       * @name nixps-cloudlfow.CloudflowProgressBar#refreshDelay
       * @type {Number}
       * @default 0
       */
      refreshDelay: 0,
      /**
       * @description function to be run when component is done 
       * @name nixps-cloudlfow.CloudflowProgressBar#created
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.CloudflowProgressBar#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);

      // variabels
      this.connection = null;
      this.alive = true;
      this.updateTimerid;
      this.errorTime = 0;
      this.complete = false;
      this.creating = true;
      var progressBarElement = $("<div>").addClass("cpb_progressbar").progressbar({
        value: this.options.value,
        max: this.options.max
      });
      if (typeof this.options.styleClassBackground === "string" && this.options.styleClassBackground.length > 0) {
        progressBarElement.addClass("nixps_styling_class_" + this.options.styleClassBackground);
      } else {
        progressBarElement.addClass("defaultBackgroundColor");
      }
      if (typeof this.options.styleClassProgress === "string" && this.options.styleClassProgress.length > 0) {
        progressBarElement.children().addClass("nixps_styling_class_" + this.options.styleClassProgress);
      } else {
        progressBarElement.children().addClass("defaultProgressColor");
      }
      if (typeof this.options.tooltip === "string" && this.options.tooltip.length > 0) {
        progressBarElement.attr("title", this.options.tooltip);
      }
      this.element.append(progressBarElement);
      this._setStyle();
      if (typeof this.options.value === "number" && this.options.value >= this.options.max) {
        this.complete = true;
      }
      this._draw();
      this._on(this.element, {
        "progressbarcomplete": this._completeHandler
      });
    },
    /**
     * @description function runs when the progress has been completed
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowProgressBar#_completeHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _completeHandler: function _completeHandler(pEvent, pData) {
      this.complete = true;
      this._trigger("complete", null, {});
      if (this.options.stopOnComplete === true && this.options.refreshDelay > 0) {
        clearTimeout(this.updateTimerid);
        this.options.refreshDelay = 0;
      }
    },
    /**
     * @description function runs when api calls erors and we need to inform others
     * @function
     * @name nixps-cloudflow.CloudflowProgressBar#_errorHandler
     * @private
     * @param {Object} pError 
     */
    _errorHandler: function _errorHandler(pError) {
      this._trigger("error", null, pError);
    },
    /**
     * @description function runs when changes are detected by the sources
     * @function
     * @name nixps-cloudflow.CloudflowProgressBar#_sourceChangeHandler
     * @private
     * @param {Object} pError 
     */
    _sourceChangeHandler: function _sourceChangeHandler() {
      if (this.alive === true) {
        clearTimeout(this.updateTimerid);
        this._loadData();
        // triggerTimer is called in the loadData function
      }
    },

    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.CloudflowProgressBar#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowProgressBar#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      if (this.options.activityBar === true) {
        this.element.addClass("barberpole");
        this.options.value === false;
      }
      if (this.connection !== null) {
        this.connection.stop();
      }
      clearTimeout(this.updateTimerid);
      // check if we have at least some data
      if (this.options.dataSource.collection === undefined || this.options.dataSource.collection === null || this.options.dataSource.collection === "") {
        if (this.creating === true) {
          this.options.created();
          this.creating = false;
        }
        return true;
      }
      // do the request for data
      var dataSource = this.options.dataSource;
      dataSource.relativeBasePath = this.options.relativeBasePath;
      dataSource.error_cb = this._errorHandler.bind(this);
      dataSource.change_cb = this._sourceChangeHandler.bind(this);
      this.connection = new CloudflowConnection(dataSource);
      var that = this;
      $.when(this._loadData()).always(function () {
        if (that.creating === true) {
          that.options.created();
          that.creating = false;
        }
      });
    },
    /**
     * @description Checks if the progress has been completed or not
     * @function
     * @name nixps-cloudflow.CloudflowProgressBar#isComplete
     * @returns {Boolean} true if complete, value has reached 100%, false otherwise 
     */
    isComplete: function isComplete() {
      return this.complete;
    },
    /**
     * @description Get the current numeric value of the progressbar
     * @function
     * @name nixps-cloudflow.CloudflowProgressBar#getValue
     * @returns The current value
     */
    getValue: function getValue() {
      return this.element.children(".cpb_progressbar").progressbar("value");
    },
    /**
     * @description Set the progressbar to a specific value
     * @function
     * @name nixps-cloudflow.CloudflowProgressBar#setValue
     * @param pValue {mixed} strings will be converted to numbers and if an object, it will look to the valuePath (default "value")
     * @returns {undefined}
     */
    setValue: function setValue(pValue) {
      if ($.isPlainObject(pValue)) {
        var path = "value";
        if (typeof this.options.valuePath === "string" && this.options.valuePath.length > 0) {
          path = this.options.valuePath;
        }
        pValue = CloudflowObject.getParameter(pValue, path);
      }
      if (typeof pValue === "string") {
        pValue = parseFloat(pValue);
      }
      this.options.value = pValue;
      this.element.children(".cpb_progressbar").progressbar("value", pValue);
    },
    /**
     * @description set up the styles
     * @name nixps-cloudflow.CloudflowChart#_setStyle
     * @function
     * @private
     * @param {String} pProgressColor the color of the progress bar
     * @param {String} pBackgroundColor the color of the resting part
     * @returns {undefined}
     */
    _setStyle: function _setStyle(pProgressColor, pBackgroundColor) {
      //  progress color
      var progressColor = pProgressColor || this.options.progressColor;
      if (typeof progressColor === "string") {
        this.element.children(".cpb_progressbar").find(".ui-progressbar-value").css("backgroundColor", progressColor);
      }
      // background color
      var backgroundColor = pBackgroundColor || this.options.backgroundColor;
      if (typeof backgroundColor === "string") {
        this.element.children(".cpb_progressbar").css("backgroundColor", backgroundColor);
      }
      // height
      this.element.children(".cpb_progressbar").css("height", this.options.height);
    },
    _triggerTimer: function _triggerTimer() {
      clearTimeout(this.updateTimerid);
      if (this.options.refreshDelay > 0) {
        this.updateTimerid = this._delay(function () {
          if (this.element.is(":visible") && document.hidden !== true) {
            this._loadData();
          } else {
            this._triggerTimer();
          }
        }, Device.getPollingFactor(this.uuid) * this.options.refreshDelay + this.errorTime);
      }
      this.errorTime = 0;
    },
    /**
     * @description ask for new data and draw the chart
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowProgressBar#_loadDrawChart
     * @returns {$.Deferred}
     */
    _loadData: function _loadData() {
      var that = this;
      var filter = this.options.extraQuery;
      var fields = [];
      if (typeof this.options.valuePath === "string" && this.options.valuePath.length > 0) {
        fields.push(this.options.valuePath);
      }
      var orderBy = [];
      if (this.options.keyUniqID === "_id") {
        orderBy = ["_id", "descending"];
      }
      return $.when(this.connection.list_with_options(filter, orderBy, fields, 0, 1)).then(function (pResults) {
        if (that.alive === false) {
          return; // zombie
        }

        if (pResults !== undefined && Array.isArray(pResults.results)) {
          if (pResults.results.length >= 1) {
            var input = pResults.results[pResults.results.length - 1];
            that.setValue(input);
            if ($.isPlainObject(input)) {
              var progressColor = undefined;
              var backgroundColor = undefined;
              if (typeof input.color === "string") {
                progressColor = input.color;
              }
              if (typeof input.progress_color === "string") {
                progressColor = input.progress_color;
              }
              if (typeof input.background_color === "string") {
                backgroundColor = input.background_color;
              }
              if (progressColor !== undefined || backgroundColor !== undefined) {
                that._setStyle(progressColor, backgroundColor);
              }
            }
          } else {
            console.error("CloudflowProgressBar: empty results");
            that.errorTime = 5000;
            that.setValue(0);
          }
        } else {
          console.error("CloudflowProgressBar: bad returning array interface ", pResults);
          that._errorHandler({
            "error_code": "wrong_data_interface",
            "error": "wrong returning interface"
          });
          that.errorTime = 60000;
          that.setValue(0);
        }
        that._triggerTimer();
      }, function (pError) {
        if (pError !== undefined && pError.expected === true) {
          console.error(pError);
          that._triggerTimer();
          return true;
        }
        console.error(pError);
        that.errorTime = 60000;
        that.setValue(0);
        that._triggerTimer();
      });
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowProgressBar#_setOption
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
      if (options.max !== undefined) {
        this.element.find(".cpb_progressbar.ui-progressbar").progressbar("option", "max", this.options.max);
        // force a _refreshVaue function
        this.element.find(".cpb_progressbar.ui-progressbar").progressbar("option", "value", this.options.value);
      }
      if (options.progressColor !== undefined || options.backgroundColor !== undefined || options.height !== undefined) {
        this._setStyle();
      }
      if (options.tooltip !== undefined) {
        if (typeof options.tooltip === "string" && options.tooltip.length > 0) {
          this.element.find(".cpb_progressbar.ui-progressbar").attr("title", options.tooltip);
        } else {
          this.element.find(".cpb_progressbar.ui-progressbar").removeAttr("title");
        }
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.CloudflowProgressBar#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.max === "string") {
        this.options.max = parseFloat(this.options.max);
      }
      if (typeof this.options.max !== "number" || isFinite(this.options.max) === false || this.options.max < 0) {
        throw new Error("CloudflowProgressBar: input option max must be number");
      }
      if (typeof this.options.valuePath !== "string" && this.options.valuePath !== null) {
        throw new Error("CloudflowProgressBar: input option valuePath must be a string");
      }
      if (typeof this.options.refreshDelay !== "number" || this.options.refreshDelay < 0) {
        throw new Error("CloudflowProgressBar: input option refreshDelay must be positieve number");
      }
      if (this.options.dataSource !== undefined && typeof this.options.dataSource.collection === "string" && this.options.dataSource.collection.indexOf("nucleus.") === 0) {
        this.options.keyUniqID = "_id";
      }
      if (typeof this.options.keyUniqID !== "string" || this.options.keyUniqID.length <= 0) {
        throw new Error("CloudflowProgressBar: input option keyUniqID must be a not empty string");
      }
      if (Array.isArray(this.options.extraQuery) === false) {
        throw new Error("CloudflowProgressBar: input option extraQuery must be an array");
      }
    },
    _destroy: function _destroy() {
      if (this.connection !== null && this.connection !== undefined) {
        this.connection.stop();
      }
      clearTimeout(this.updateTimerid);
      this.alive = false;
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowConnection.js":78,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../PWA/js/Device.js":198}],71:[function(require,module,exports){
"use strict";

module.exports = Object.freeze({
  VIEW: "view",
  SEARCH_AND_VIEW: "search_and_view"
});

},{}],72:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jan 18, 2018 11:12:05 AM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */
(function ($) {
  require("../../../common/js/nixps-common-ServerQueryEditor.js");
  var CloudflowConnection = require("../../CloudflowUtil/js/CloudflowConnection.js");
  function isOperatorAlone(pOperator) {
    return pOperator === "exists" || pOperator === "does not exist";
  }
  function isOperatorNumeric(pOperator) {
    return pOperator === "less than" || pOperator === "less than or equal to" || pOperator === "greater than" || pOperator === "greater than or equal to";
  }
  var collectionFieldsDict = {};

  /**
   * @namespace nixps-cloudflow.CloudflowQueryBuilder
   * @description draw a component
   * @example $('<div>').CloudflowQueryBuilder({});
   */
  $.widget("nixps-cloudflow.CloudflowQueryBuilder", $.Widget, {
    widgetEventPrefix: "cloudflowquerybuilder",
    options: {
      /**
       * @name nixps-cloudflow.CloudflowQueryBuilder#collection
       * @description From which collection do you want to create a query for. 
       * @type {String}
       * @default ""
       * @example "nucleus.job"
       */
      collection: "",
      /**
       * @description the url of the file to retrieve some information of the data
       * @name nixps-cloudflow.CloudflowQueryBuilder#dataFileURL
       * @type {String}
       * @default null
       */
      dataFileURL: null,
      /**
       * @description The name of the input of the http service
       * @name nixps-cloudflow.CloudflowQueryBuilder#httpserviceInputName
       * @type {String}
       * @default ""
       */
      httpserviceInputName: "",
      /**
       * @description The name of the workflow of the http service
       * @name nixps-cloudflow.CloudflowQueryBuilder#httpserviceWhitepaperName
       * @type {String}
       * @default ""
       */
      httpserviceWhitepaperName: "",
      /**
       * @description The array data of the collection "object"
       * @name nixps-cloudflow.CloudflowQueryBuilder#collectionData
       * @type {Array}
       * @default []
       */
      collectionData: [],
      /**
       * @description If the url is a relative path and if this options is given, add this as relative path to make it a static one
       * @name nixps-cloudflow.CloudflowQueryBuilder#relativeBasePath
       * @type {String}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.CloudflowQueryBuilder#defaultQuery
       * @description The default query to show
       * @type {Array}
       * @default null
       */
      defaultQuery: null,
      /**
       * @name nixps-cloudflow.CloudflowQueryBuilder#allow_groups
       * @description must we allow subgroups or not. Will be given through to the plugin
       * @default true
       * @type {Boolean}
       */
      allow_groups: true,
      /**
       * @name nixps-cloudflow.CloudflowQueryBuilder#conditions
       * @description The possible conditions
       * @type {Array}
       * @default ['AND', 'OR']
       * @example ['AND']
       */
      conditions: ['AND', 'OR'],
      /**
       * @name nixps-cloudflow.CloudflowQueryBuilder#allowNotOperator
       * @description Must we allow the not opperator?
       * @type {Boolean}
       * @default false
       */
      allowNotOperator: false,
      /**
       * @name nixps-cloudflow.CloudflowQueryBuilder#customFieldSettings
       * @description The settings for a custom field
       * @type {Object}
       * @default null
       */
      customFieldSettings: null,
      fieldInput: undefined,
      fieldValueSetter: undefined,
      fieldValueGetter: undefined,
      fieldValidation: undefined,
      fieldEvents: "change",
      /**
       * @name nixps-cloudflow.CloudflowQueryBuilder#allowValueComposers
       * @description Must we allow Value Composers?
       * @type {Boolean}
       * @default false
       */
      allowValueComposers: false,
      value_separator: ";",
      /**
       * @name nixps-cloudflow.CloudflowQueryBuilder#enableCaches
       * @description Must we use caches to fill in the fields of this component or not. 
       * @type {Boolean}
       * @default false
       */
      enableCaches: false
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.CloudflowQueryBuilder#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._addClass(this.widgetFullName);
      this.element.attr("role", "search");

      // variables
      this.retrieveData = null; // deffered object to wait until we get all possible fields           
      this.dead = false;
      this._draw();
      this._on(this.element, {
        "change select.cqb_custom_select": this._customSelectChangeHandler,
        "serverqueryeditorchange": this._queryChangeHandler
      });
    },
    /**
     * @description function runs when user change the custom selector operator
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowQueryBuilder#_customSelectChangeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _customSelectChangeHandler: function _customSelectChangeHandler(pEvent, pData) {
      var currentValue = $(pEvent.target).closest("select").val();
      if (typeof currentValue !== "string" || currentValue.length <= 0) {
        throw new Error(this.widgetName + " unknown operator selected");
      }
      if (isOperatorAlone(currentValue) === true) {
        $(pEvent.target).closest(".rule-value-container").find(".cqb_custom_input_2").hide();
      } else {
        $(pEvent.target).closest(".rule-value-container").find(".cqb_custom_input_2").css("display", "");
      }
    },
    /**
     * @description function runs when changes are detected
     * @function
     * @name nixps-cloudflow.CloudflowQueryBuilder#_queryChangeHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _queryChangeHandler: function _queryChangeHandler(pEvent, pData) {
      this._trigger("change", pEvent, pData);
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.CloudflowQueryBuilder#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowQueryBuilder#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      this.element.empty();
      var queryEditor = $("<div>").addClass("cqb_queryeditor");
      this.element.append(queryEditor);
      queryEditor.ServerQueryEditor({
        allow_groups: this.options.allow_groups,
        conditions: this.options.conditions,
        allowNotOperator: this.options.allowNotOperator,
        fieldInput: this.options.fieldInput,
        fieldValueSetter: this.options.fieldValueSetter,
        fieldValueGetter: this.options.fieldValueGetter,
        fieldValidation: this.options.fieldValidation,
        fieldEvents: this.options.fieldEvents,
        allowValueComposers: this.options.allowValueComposers
      });
      this.retrieveData = $.when(this._retieveFields());
      this.element.append($("<span>").addClass("cqb_loadpanel")._t("nixps-cloudflow-ServerQueryEditor.generic_loading"));
      // separate on other line, so this.retrieveData exists in the then fucntion, needed for function setValue ... 
      this.retrieveData.done(function (pFields) {
        if (that.dead === true) {
          // zombie
          return;
        }
        that.element.children(".cqb_loadpanel").remove();
        that.element.children(".cqb_queryeditor").ServerQueryEditor("setFields", pFields);
        if (Array.isArray(that.options.defaultQuery)) {
          that.setValue(that.options.defaultQuery).then(function () {
            var getSettedValue = that.getValue();
            var different = Array.isArray(getSettedValue) && Array.isArray(that.options.defaultQuery) && getSettedValue.length !== that.options.defaultQuery.length;
            that._trigger("drawed", null, {
              different: different
            });
          });
        } else {
          that._trigger("drawed", null, {
            different: false
          });
        }
      }).fail(function (pError) {
        that.element.children(".cqb_loadpanel").remove();
        var errorMessage = $("<div>").addClass("cqb_errormessage")._t("nixps-cloudflow-ServerQueryEditor.errormessage_noelements");
        that.element.children(".cqb_queryeditor").append(errorMessage);
        that._trigger("error", null, pError);
      });
    },
    /**
     * @name nixps-cloudflow.CloudflowQueryBuilder#setValue
     * @description Set to a specific query
     * @function
     * @param {Array} pQuery The query to be applied to. What we want to edit 
     */
    setValue: function setValue(pQuery, pTrigger) {
      if (Array.isArray(pQuery) === false) {
        throw new Error("parameter pQuery must be an array");
      }
      pQuery = pQuery.slice(); // copy
      if (this.retrieveData === null) {
        throw new Error("can not apply function setValue before initialisation");
      }
      var that = this;
      return this.retrieveData.then(function () {
        try {
          that.element.children(".cqb_queryeditor").ServerQueryEditor("setQuery", pQuery);
          if (pTrigger !== false) {
            that._trigger("change", null, {
              trigger: "setvalue",
              query: pQuery
            });
          }
        } catch (e) {
          // cath the error to prevent that the this.retrieveData will not work afterwards
          console.error(e);
          return {
            error: e.message
          };
        }
      }, function (pError) {
        console.error(pError);
      });
    },
    /**
     * @name nixps-cloudflow.CloudflowQueryBuilder#getValue
     * @description Get the current query
     * @function
     * @return {Array.<string>}
     */
    getValue: function getValue() {
      var query = this.element.children(".cqb_queryeditor").ServerQueryEditor("getQuery");
      if (Array.isArray(query) && query.includes("__custom__") === false) {
        return query.slice();
      } else {
        // remove all the __custom__ fields
        var outputQuery = [];
        for (var i = 0; i < query.length; i++) {
          if (query[i] === "__custom__") {
            // do not add query[i] and query[i+1]
            // append query[i+2]
            outputQuery = outputQuery.concat(query[i + 2]);
            i = i + 2;
          } else {
            outputQuery.push(query[i]);
          }
        }
        return outputQuery;
      }
    },
    validate: function validate() {
      return this.element.children(".cqb_queryeditor").ServerQueryEditor("validate");
    },
    _retieveFields: function _retieveFields() {
      if (Array.isArray(this.options.collection)) {
        if (this.options.collection.length > 0 && typeof this.options.collection[0].type === "string" && this.options.collection[0].type.indexOf("com.nixps.") === 0) {
          // collection is a value composer
          var fields = this._getFields("", [{
            "name": "_id",
            "data_type": "string"
          }]);
          fields.push(this._getCustomField());
          return fields;
        } else {
          // input is a array of fields, with the good fields interfase
          return this.options.collection;
        }
      } else if ($.isPlainObject(this.options.collection) && $.isEmptyObject(this.options.collection) === false) {
        // input is an object, this is an object what we will examin to retrieve the fields
        var cloudflowConnection = new CloudflowConnection({
          collection: "object",
          data: this.options.collection
        });
        var fields = this._getFields(cloudflowConnection.translateObjectToFields("", this.options.collection));
        fields.push(this._getCustomField());
        return fields;
      } else if (typeof this.options.collection !== "string" || this.options.collection.length <= 0) {
        throw new Error("CloudflowQueryBuilder._retrieveFields input option collection must be at least a string");
      }
      // else it should be a string so we can retieve everything
      if (this.options.enableCaches === true && collectionFieldsDict[this.options.collection] !== undefined) {
        return collectionFieldsDict[this.options.collection];
      }
      var that = this;
      var cloudflowConnection = new CloudflowConnection({
        collection: this.options.collection,
        data: this.options.collectionData,
        relativeBasePath: this.options.relativeBasePath,
        dataFileURL: this.options.dataFileURL,
        httpserviceInputName: this.options.httpserviceInputName,
        httpserviceWhitepaperName: this.options.httpserviceWhitepaperName
      });
      return $.Deferred(function (pDefer) {
        cloudflowConnection.get_columns().then(function (pResult) {
          if (pResult !== undefined && Array.isArray(pResult.columns) && pResult.columns.length > 0) {
            var fields = that._getFields(pResult.columns);
            fields.push(that._getCustomField());
            pDefer.resolve(fields);
          } else {
            pDefer.reject("wrong returning interface");
          }
        }, function (pError) {
          console.error(pError);
          pDefer.reject(pError);
        });
      });
    },
    /**
     * @description We get an array from the backend Start from DBIO, which we will translate the object to field interface
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowQueryBuilder#_getFields
     * @param {Array.<Object>} pColumns 
     */
    _getFields: function _getFields(pColumns) {
      var fields = [],
        fieldsIDsDict = {};
      for (var i = 0; i < pColumns.length && i < 200; i++) {
        if (["object", "binary data", "regular expression", "symbol"].includes(pColumns[i].data_type)) {
          console.warn("unsupported type: " + pColumns[i].data_type + " for a column");
          continue;
        }
        if (["date", "date_iso", "array", "null"].includes(pColumns[i].data_type)) {
          // not supported for the moment
          continue;
        }
        var type;
        switch (pColumns[i].data_type) {
          case "number":
          case "float":
            type = "double";
            break;
          case "integer":
          case 'double':
          case 'boolean':
            type = pColumns[i].data_type;
            break;
          case "string":
          case "text":
            type = "string";
            break;
          default:
            continue;
        }
        var input = this.options.fieldInput;
        var values = undefined;
        if (type === "boolean" && input === undefined) {
          input = "select";
          values = {
            "true": $.i18n._("nixps-cloudflow-FormBuilder.checkboxOnStart_true"),
            "false": $.i18n._("nixps-cloudflow-FormBuilder.checkboxOnStart_false")
          };
        }
        if (fieldsIDsDict[pColumns[i].name] === undefined) {
          fieldsIDsDict[pColumns[i].name] = 1;
          fields.push({
            id: pColumns[i].name,
            field: pColumns[i].name,
            label: typeof pColumns[i].label === "string" ? pColumns[i].label : pColumns[i].name,
            type: type,
            input: input,
            values: values,
            valueSetter: this.options.fieldValueSetter,
            valueGetter: this.options.fieldValueGetter,
            validation: this.options.fieldValidation,
            input_event: this.options.fieldEvents
          });
        }
      }
      // add to cache memory
      collectionFieldsDict[this.options.collection] = fields;
      // return fields
      return fields;
    },
    _getCustomField: function _getCustomField() {
      if ($.isPlainObject(this.options.customFieldSettings) && $.isEmptyObject(this.options.customFieldSettings) === false) {
        return this.options.customFieldSettings;
      }
      var that = this;
      return {
        id: "__custom__",
        label: "(custom)",
        type: "string",
        operators: ["equal"],
        input: function input(rule, input_name) {
          var selector = '<select class="cqb_custom_select">';
          selector += "<option value='equal to' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.equal") + "</option>";
          selector += "<option value='not equal to' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.not_equal") + "</option>";
          selector += "<option value='contains' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.contains") + "</option>";
          selector += "<option value='begins with' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.begins_with") + "</option>";
          selector += "<option value='ends with' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.ends_with") + "</option>";
          selector += "<option value='is like' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.is_like") + "</option>";
          selector += "<option value='contains text like' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.contains_text_like") + "</option>";
          selector += "<option value='begins like' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.begins_like") + "</option>";
          selector += "<option value='ends like' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.ends_like") + "</option>";
          selector += "<option value='exists'>" + $.i18n._("nixps-cloudflow-ServerQueryEditor.exists") + "</option>";
          selector += "<option value='does not exist'>" + $.i18n._("nixps-cloudflow-ServerQueryEditor.does_not_exists") + "</option>";
          selector += "<option value='less than' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.less") + "</option>";
          selector += "<option value='less than or equal to' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.less_or_equal") + "</option>";
          selector += "<option value='greater than' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.greater") + "</option>";
          selector += "<option value='greater than or equal to' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.greater_or_equal") + "</option>";
          selector += "<option value='in' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.in") + "</option>";
          selector += "</select>";
          return $('<span>').append('<input name="' + input_name + '_1" class="form-control cf-form-control cqb_custom_input_1" type="text">' + selector + '<input name="' + input_name + '_2" class="form-control cf-form-control cqb_custom_input_2" type="text">');
        },
        validation: {
          callback: function callback(pValue, rule) {
            var path = rule.$el.find('.rule-value-container [name$=_1]').val();
            if (typeof path !== "string" || path.length <= 0) {
              return "Path must not be empty";
            }
            if (rule.$el.find('.rule-value-container [name$=_2]').is(":visible")) {
              var value = rule.$el.find('.rule-value-container [name$=_2]').val();
              if (typeof value !== "string" || value.length <= 0) {
                return "Value must not be empty";
              }
            }
            return true;
          }
        },
        valueGetter: function valueGetter(rule) {
          var operator = rule.$el.find('.rule-value-container select.cqb_custom_select').val();
          if (isOperatorAlone(operator) === true) {
            return [rule.$el.find('.rule-value-container [name$=_1]').val(), operator];
          }
          var value = rule.$el.find('.rule-value-container [name$=_2]').val();
          if (isOperatorNumeric(operator) === true) {
            value = parseFloat(value);
          }
          if (operator === "in") {
            if (that.options.allowValueComposers === true && Array.isArray(value)) {
              // use query value
            } else {
              value = "" + value;
              if (value[0] === that.options.value_separator) {
                value = value.slice(1);
              }
              if (value[value.length - 1] === that.options.value_separator) {
                value = value.slice(0, -1);
              }
              value = value.split(that.options.value_separator);
            }
          }
          return [rule.$el.find('.rule-value-container [name$=_1]').val(), operator, value];
        },
        valueSetter: function valueSetter(rule, value) {}
      };
    },
    /**
     * @description Clear all fields caches
     * @function
     * @name nixps-cloudflow.CloudflowQueryBuilder#clearCaches
     * @returns {undefined}
     */
    clearCaches: function clearCaches() {
      collectionFieldsDict = {};
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowQueryBuilder#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      if (this.retrieveData === null) {
        this._draw();
      } else {
        var that = this;
        $.when(this.retrieveData).always(function () {
          that._draw();
        });
      }
    },
    /**
     * @description function runs when component is removed from DOM
     * @function
     * @name nixps-cloudflow.CloudflowQueryBuilder#_destroy
     * @private
     */
    _destroy: function _destroy() {
      this.dead = true;
      this.element.removeAttr("role");
      this._superApply(arguments);
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.CloudflowQueryBuilder#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.collection !== "string" || this.options.collection.length <= 0) {
        if (Array.isArray(this.options.collection) === false || this.options.collection.length <= 0) {
          if ($.isPlainObject(this.options.collection) === false || $.isEmptyObject(this.options.collection)) {
            throw new Error("input option collection must be a not empty string or a not empty array");
          }
        }
      }
      if (typeof $.fn.ServerQueryEditor !== "function") {
        throw new Error(this.widgetFullName + " needs ServerQueryEditor as plugin");
      }
      if (this.options.defaultQuery !== null && Array.isArray(this.options.defaultQuery) === false) {
        throw new Error("input option defaultQuery must be null or an array");
      }
      if (Array.isArray(this.options.defaultQuery)) {
        this.options.defaultQuery = this.options.defaultQuery.slice();
      }
    }
  });
})(jQuery);

},{"../../../common/js/nixps-common-ServerQueryEditor.js":392,"../../CloudflowUtil/js/CloudflowConnection.js":78}],73:[function(require,module,exports){
"use strict";

var CloudflowQueryMode = require("./CloudflowQueryMode.js");
require("./nixps-cloudflow-CloudflowSaveQueryDialog.js");
var IndexedStorage = require("../../../common/BrowserStorage/js/IndexedStorage.js");

/**
 * @namespace nixps-cloudflow.CloudflowQueryManager
 * @description A component to manage all saved queries
 * @example $("<div>").CloudflowQueryManager({});
 */
$.widget("nixps-cloudflow.CloudflowQueryManager", $.Widget, {
  widgetEventPrefix: "cloudflowquerymanager",
  options: {
    /**
     * @name nixps-cloudflow.CloudflowQueryManager#collection
     * @description option to be given back to internal plugin {@link CloudflowQueryBuilder#collection}
     * @type {String}
     * @default ""
     */
    collection: "",
    /**
     * @name nixps-cloudflow.CloudflowQueryManager#currentQuery
     * @description The querry to be shown on start up, so users can them save them directly
     * @type {Array}
     * @default null
     */
    currentQuery: null,
    /**
     * @name nixps-cloudflow.CloudflowQueryManager#applicationContext
     * @description The string to specify the saved queries application id
     * @default "com.nixps.cloudflow.querybuilder"
     * @type {String}
     */
    applicationContext: "com.nixps.cloudflow.querybuilder",
    /**
     * @name nixps-cloudflow.CloudflowQueryManager#groupContext
     * @description the group context. this is a sub group
     * @default ""
     * @type {String}
     */
    groupContext: "",
    /**
     * @name nixps-cloudflow.CloudflowQueryManager#saveContext
     * @description The key to refer to specific queries
     * @type {String}
     * @default ""
     */
    saveContext: "",
    mode: CloudflowQueryMode.VIEW,
    /**
     * @name nixps-cloudflow.CloudflowQueryManager#querysProvider
     * @description The way how to save and retrieve the queries
     * @type {String}
     * @default "backend"
     */
    querysProvider: "backend"
  },
  /**
   * @description Create the component
   * @name nixps-cloudflow.CloudflowQueryManager#_create
   * @function
   * @private
   * @returns {undefined}
   */
  _create: function _create() {
    // check static underlining plugins
    if ($.fn.Dialog === undefined) {
      throw new Error("please include the common/Dialog plugin in the web page");
    }
    if ($.fn.DynamicList === undefined) {
      throw new Error("please include the common/DynamicList plugin in the web page");
    }
    this._controlOptions();
    this.element.addClass(this.widgetFullName);
    if ($("body").hasClass("nixps-Dialog")) {
      this.dialog = $("body");
    } else {
      this.dialog = $("body").Dialog({});
    }
    this.queries = []; // model: the queries
    this.save_dialog = null;
    if (this.options.querysProvider === "indexdb") {
      if (IndexedStorage.isSupported()) {
        this.indexDB = new IndexedStorage("nixps.cloudflowQueryManager");
        this.deferIndexDB = this.indexDB.open({
          expire: 15778800000 * 2
        });
      } else {
        console.warn("no support for indexdb, switch to backend api call");
        this.options.querysProvider = "backend";
      }
    }

    // make selecton
    var that = this;
    var list = $("<div>").addClass("cqm_list");
    this.element.append(list);
    list.DynamicList({
      dataProvider: this._loadAllQuerys.bind(this),
      makeItem: this._makeItem.bind(this),
      updateItem: this._updateItem.bind(this),
      hasItemChanged: this._hasItemChanged.bind(this),
      keyUniqID: "name",
      editNameSelector: ".cqm_item_name",
      nameChange: this._renameHandler.bind(this),
      selectingOptions: {
        multiple: false,
        deselectable: false,
        selectClass: "cf-select"
      },
      updateDelay: 0,
      emptyRowsPanel: $("<div>").addClass("noselect")._t("nixps-cloudflow-cloudflowquerymanager.message_noquerys")
    }).one("dynamiclistdrawed", function () {
      // this should be runned just one time
      if (that.element.find(".cqm_item").length > 0) {
        if (that.options.currentQuery === null) {
          // select first item
          that.element.find(".cqm_item").first().trigger("click");
        } else if (typeof that.options.currentQuery === "string" && that.options.currentQuery.length > 0) {
          // select item with correstonding id
          that.element.children(".cqm_list").DynamicList("select", that.options.currentQuery, true);
        }
      }
    });
    var queryContainer = $("<div>").addClass("cqm_queryContainer");
    this.element.append(queryContainer);
    var queryEditor = $("<div>").addClass("cqm_queryEditor");
    queryContainer.append(queryEditor);
    queryContainer.append($("<div>").addClass("cqm_queryBottombar cf-buttonbar").append($("<button>").attr("type", "button").addClass("noselect cqm_createnew_query cf-button-main")._t("nixps-cloudflow-cloudflowquerymanager.buttontext_createnew").prepend('<span class="fa fa-plus"></span>')).append($("<button>").attr("type", "button").addClass("noselect cqm_save_query cf-button-main")._t("nixps-cloudflow-cloudflowquerymanager.buttontext_save").prop("disabled", true)).append($("<button>").attr("type", "button").addClass("noselect cqm_cancel_query cf-button-secondary")._t("nixps-cloudflow-cloudflowquerymanager.buttontext_cancel").prop("disabled", true)).append($("<button>").attr("type", "button").addClass("noselect cqm_add_query cf-button-main")._t("nixps-cloudflow-cloudflowquerymanager.buttontext_add").prepend("<span class='fa fa-plus'></span>")));
    queryEditor.CloudflowQueryBuilder({
      collection: this.options.collection,
      defaultQuery: Array.isArray(this.options.currentQuery) ? this.options.currentQuery : null
    });
    if (Array.isArray(this.options.currentQuery)) {
      this.element.find(".cqm_save_query, .cqm_cancel_query, .cqm_createnew_query").hide();
    } else {
      this.element.find(".cqm_add_query").hide();
    }
    this._draw();
    this._on(this.element, {
      "dynamiclistupdate": this._listUpdateHandler,
      "click .cqm_item_delete": this._itemDeleteHandler,
      "dynamiclistselect": this._itemSelectHandler,
      "click .cqm_save_query": this._saveClickHandler,
      "click .cqm_cancel_query": this._cancelClickHandler,
      "click .cqm_add_query": this._addClickHander,
      "click .cqm_createnew_query": this._createNewClickHander,
      "cloudflowquerybuilderchange": this._queryeditorChangeHandler
    });
  },
  /**
   * @description function runs when list has been updateded
   * @function
   * @name nixps-cloudflow.CloudflowQueryManager#_listUpdateHandler
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _listUpdateHandler: function _listUpdateHandler(pEvent, pData) {
    if (pData !== undefined && pData.size === 0) {
      // if there are no items 
      if (this.element.is(":visible") && this.element.find(".cqm_add_query").is(":hidden")) {
        // go back to create default state
        if (Array.isArray(this.options.currentQuery) && this.options.currentQuery.length > 0) {
          this.element.find(".cqm_queryEditor").CloudflowQueryBuilder('setValue', this.options.currentQuery);
          this.element.find(".cqm_save_query, .cqm_cancel_query, .cqm_createnew_query").hide();
          this.element.find(".cqm_add_query").show();
        }
      }
    }
  },
  /**
   * @description function runs when user click on a item
   * @function
   * @name nixps-cloudflow.CloudflowQueryManager#_itemSelectHandler
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _itemSelectHandler: function _itemSelectHandler(pEvent, pData) {
    this.element.children(".cqm_queryContainer").children(".cqm_queryEditor").CloudflowQueryBuilder("setValue", pData.data.query);
    this.element.find('.cqm_add_query').hide();
    this.element.find('.cqm_save_query, .cqm_cancel_query, .cqm_createnew_query').show();
    this.element.find(".cqm_save_query, .cqm_cancel_query").prop("disabled", true);
    this.element.find(".cqm_need_to_save").removeClass("cqm_need_to_save");
  },
  /**
   * @description Function runs when user want to delete te query
   * @function
   * @private
   * @name nixps-cloudflow.CloudflowQueryManager#_itemDeleteHandler
   * @param {Object} pEvent 
   * @param {Object} pData 
   */
  _itemDeleteHandler: function _itemDeleteHandler(pEvent, pData) {
    var that = this;
    var removeButton = $(pEvent.currentTarget);
    var name = removeButton.data('name');
    if (typeof name === "string" && name.length > 0) {
      this.dialog.Dialog("show_delete_no", $.i18n._("nixps-cloudflow-cloudflowquerymanager.messagetitle_remove"), $.i18n._("nixps-cloudflow-cloudflowquerymanager.messagetext_remove", [name]), function () {
        // yes
        that._removeQuery(name);
      }, function () {});
    }
  },
  /**
   * @description function runs when user changed the input field of the new name
   * @function
   * @name nixps-cloudflow.CloudflowQueryManager#_renameHandler
   * @private
   * @param {type} pData
   * @return {Boolean}
   */
  _renameHandler: function _renameHandler(pData) {
    if ($.isPlainObject(pData) === false || typeof pData.newName !== "string" || typeof pData.oldName !== "string") {
      throw new Error("wrong data interface");
    }
    // change model
    var queryObject = this._getQueryByName(pData.oldName);
    if (queryObject === null) {
      throw new Error("could not find query in internal model");
    }
    queryObject.name = pData.newName;
    return this._saveQuery(false).then(function () {
      return queryObject; // return new object
    });
  },

  /**
   * @description function runs when user want to save the changes he made in the query
   * @function
   * @name nixps-cloudflow.CloudflowQueryManager#_saveClickHandler
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _saveClickHandler: function _saveClickHandler(pEvent, pData) {
    if (this.element.children(".cqm_queryContainer").children(".cqm_queryEditor").CloudflowQueryBuilder("validate") === true) {
      var that = this;
      var name = this.element.find(".list_item.cf-select").attr('data-id');
      if (typeof name !== "string" || name.length <= 0) {
        throw new Error("could not retrieve the name of the query");
      }
      var queryObject = this._getQueryByName(name);
      if (queryObject === null) {
        throw new Error("could not find query in internal model");
      }
      queryObject.query = this.element.children(".cqm_queryContainer").children(".cqm_queryEditor").CloudflowQueryBuilder("getValue");
      this.element.find(".cqm_save_query, .cqm_cancel_query").prop("disabled", true);
      this._saveQuery().then(function () {
        that.element.find(".cqm_need_to_save").removeClass("cqm_need_to_save");
      });
    }
  },
  /**
   * @description function runs when user want to cancel his changes he did
   * @function
   * @name nixps-cloudflow.CloudflowQueryManager#_cancelClickHandler
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _cancelClickHandler: function _cancelClickHandler(pEvent, pData) {
    var name = this.element.find(".list_item.cf-select").attr("data-id");
    if (typeof name !== "string" || name.length <= 0) {
      throw new Error("could not retrieve the name of the query");
    }
    var queryObject = this._getQueryByName(name);
    if (queryObject === null) {
      throw new Error("could not find query in internal model");
    }
    this.element.children(".cqm_queryContainer").children(".cqm_queryEditor").CloudflowQueryBuilder("setValue", queryObject.query);
    this.element.find(".cqm_save_query, .cqm_cancel_query").prop("disabled", true);
    this.element.find(".cqm_need_to_save").removeClass("cqm_need_to_save");
  },
  /**
   * @description function runs when user want to add the current query to the backend
   * @function
   * @name nixps-cloudflow.CloudflowQueryManager#_addClickHander
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _addClickHander: function _addClickHander(pEvent, pData) {
    if (this.element.children(".cqm_queryContainer").children(".cqm_queryEditor").CloudflowQueryBuilder("validate") === true) {
      var that = this;
      this.save_dialog = $("<div>").appendTo(this.element).CloudflowSaveQueryDialog({
        title: $.i18n._("nixps-cloudflow-cloudflowquerymanager.messagetitle_addnew"),
        close: function close() {
          that.save_dialog.remove();
          that.save_dialog = null;
        },
        mode: that.options.mode
      });
      this.save_dialog.on("cloudflowsavequerydialogsave", function (event, data) {
        if (that._checkQueryValues(that.save_dialog, data)) {
          data.query = that.element.children(".cqm_queryContainer").children(".cqm_queryEditor").CloudflowQueryBuilder("getValue");
          that.queries.push(data);
          that._saveQuery().done(function () {
            that.element.find(".cqm_add_query").hide();
            that.element.find(".cqm_save_query, .cqm_cancel_query, .cqm_createnew_query").show();
            that.element.find(".list_item.cf-select").removeClass("cf-select");
            that.element.find('.list_item[data-id="' + data.name + '"]').addClass("cf-select");
          });
          that.save_dialog.remove();
          that.save_dialog = null;
        }
      });
    }
  },
  /**
   * @description function runs when user want to create a new query
   * @function
   * @name nixps-cloudflow.CloudflowQueryManager#_createNewClickHander
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _createNewClickHander: function _createNewClickHander(pEvent, pData) {
    var that = this;
    this.save_dialog = $("<div>").appendTo(this.element).CloudflowSaveQueryDialog({
      title: $.i18n._("nixps-cloudflow-cloudflowquerymanager.messagetitle_addnew"),
      close: function close() {
        that.save_dialog.remove();
        that.save_dialog = null;
      },
      mode: that.options.mode
    });
    this.save_dialog.on("cloudflowsavequerydialogsave", function (event, data) {
      if (that._checkQueryValues(that.save_dialog, data)) {
        data.query = [];
        that.element.children(".cqm_queryContainer").children(".cqm_queryEditor").CloudflowQueryBuilder("setValue", data.query);
        that.queries.unshift(data);
        that._saveQuery().done(function () {
          that.element.find(".list_item.cf-select").removeClass("cf-select").removeClass("cqm_need_to_save");
          that.element.find('.list_item[data-id="' + data.name + '"]').addClass("cf-select");
        });
        that.save_dialog.remove();
        that.save_dialog = null;
      }
    });
  },
  _checkQueryValues: function _checkQueryValues(pDialog, pValues) {
    if (typeof pValues.name !== "string" || pValues.name.length <= 0) {
      console.error("new name is empty");
      this._trigger("error", null, {
        error_code: "empty_name",
        error: "new name is empty"
      });
      pDialog.CloudflowSaveQueryDialog("showErrorMessage", $.i18n._("nixps-cloudflow-cloudflowquerymanager.errormessage_nameisempty"));
      return false;
    } else if (this._getQueryByName(pValues.name) !== null) {
      console.error("name already exists");
      this._trigger("error", null, {
        error_code: "name_already_exists",
        error: "name already exists"
      });
      pDialog.CloudflowSaveQueryDialog("showErrorMessage", $.i18n._("nixps-cloudflow-cloudflowquerymanager.errormessage_namealreadyexists"));
      return false;
    }
    return true;
  },
  /**
   * @description function runs when there are changes detected in the query editor
   * @function
   * @name nixps-cloudflow.CloudflowQueryManager#_queryeditorChangeHandler
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _queryeditorChangeHandler: function _queryeditorChangeHandler(pEvent, pData) {
    this.element.find(".list_item.cf-select").addClass("cqm_need_to_save");
    this.element.find(".cqm_save_query, .cqm_cancel_query").prop("disabled", false);
  },
  /**
   * @description Draws the dialog according to the current state
   * @function
   * @private
   * @name nixps-cloudflow.CloudflowQueryManager#_draw
   * @return {undefined} 
   */
  _draw: function _draw() {},
  /**
   * @description Make a item of the list
   * @param {type} pObject
   * @return {undefined}
   * @function
   * @private
   * @return {DOMElement}
   */
  _makeItem: function _makeItem(pObject) {
    var item = $("<div>").addClass("cqm_item");
    var name = "";
    if (pObject !== undefined && typeof pObject.name === "string") {
      name = pObject.name;
    }
    item.append($("<span>").text(name).addClass("cqm_item_name noselect"));
    item.append($("<span>").data("name", pObject.name).addClass("cf-icon cf-icon-trash cqm_item_delete").attr("title", $.i18n._("nixps-cloudflow-cloudflowquerymanager.tooltip_remove")));
    return item;
  },
  _updateItem: function _updateItem(pObject) {},
  _hasItemChanged: function _hasItemChanged(pOldData, pNewData) {
    return true;
  },
  _getQueriesFromBackend: function _getQueriesFromBackend(pApplicationContext, pGroupContext, pSaveContext) {
    if (this.options.querysProvider === "backend") {
      return api_defer.preferences.get_for_current_user(pApplicationContext, pSaveContext);
    } else if (this.options.querysProvider === "backend_readtimestamp") {
      return $.Deferred(function (pDefer) {
        api_async.preferences.get_for_current_user(pApplicationContext, pGroupContext, function (pResult) {
          if ($.isPlainObject(pResult.preferences)) {
            var dataChanged = false;
            var savedQueries = [];
            for (var context in pResult.preferences) {
              if (context === pSaveContext) {
                if (Array.isArray(pResult.preferences[pSaveContext].queries) && pResult.preferences[pSaveContext].queries.length > 0) {
                  if (pResult.preferences[pSaveContext].read_timestamp !== null && +new Date() - pResult.preferences[pSaveContext].read_timestamp > 600000) {
                    pResult.preferences[pSaveContext].read_timestamp = +new Date();
                    dataChanged = true;
                  }
                  savedQueries = pResult.preferences[pSaveContext].queries.slice();
                } else {
                  delete pResult.preferences[context];
                  dataChanged = true;
                }
              } else {
                if (typeof pResult.preferences[context].read_timestamp === "number" && pResult.preferences[context].read_timestamp < +new Date() - 31557600000) {
                  delete pResult.preferences[context];
                  dataChanged = true;
                }
              }
            }
            if (dataChanged === true) {
              api_async.preferences.save_for_current_user(pResult.preferences, pApplicationContext, pGroupContext, function () {
                pDefer.resolve({
                  preferences: savedQueries
                });
              }, pDefer.reject);
            } else {
              pDefer.resolve({
                preferences: savedQueries
              });
            }
          } else {
            pDefer.resolve({
              preferences: []
            });
          }
        }, pDefer.reject);
      });
    } else if (this.options.querysProvider === "indexdb") {
      var that = this;
      return this.deferIndexDB.then(function () {
        return that.indexDB.list_with_options(["savecontext", "equal to", pSaveContext]).then(function (pResults) {
          var output = [];
          if (Array.isArray(pResults.results) && pResults.results.length > 0) {
            output = output.concat(pResults.results[0].queries);
          }
          return {
            "preferences": output
          };
        });
      });
    }
  },
  _saveQueriesToBackend: function _saveQueriesToBackend(pQueries, pApplicationContext, pGroupContext, pSaveContext) {
    if (this.options.querysProvider === "backend") {
      return api_defer.preferences.save_for_current_user(pQueries, pApplicationContext, pSaveContext);
    } else if (this.options.querysProvider === "backend_readtimestamp") {
      return api_defer.preferences.save_for_current_user({
        queries: pQueries,
        read_timestamp: +new Date()
      }, pApplicationContext, pGroupContext + "." + pSaveContext);
    } else if (this.options.querysProvider === "indexdb") {
      var newData = {
        "savecontext": pSaveContext,
        "queries": pQueries.slice()
      };
      var that = this;
      return this.deferIndexDB.then(function () {
        var found = false;
        return that.indexDB.update_with_filter(function (pData) {
          if (pData !== undefined && pData.savecontext === pSaveContext) {
            found = true;
            return true;
          }
        }, newData).then(function () {
          if (found === false) {
            return that.indexDB.add(newData);
          }
        });
      });
    }
  },
  /**
   * @description retieve all saved queries from backend
   * @function
   * @private
   * @return {Deferred}
   */
  _loadAllQuerys: function _loadAllQuerys() {
    var that = this;
    return this._getQueriesFromBackend(that.options.applicationContext, that.options.groupContext, that.options.saveContext).then(function (pResult) {
      if (Array.isArray(pResult.preferences)) {
        that.queries = pResult.preferences;
        return pResult.preferences;
      } else {
        that.queries = [];
        return [];
      }
    })["catch"](function (pError) {
      that.queries = [];
      console.error(pError);
      return Promise.reject(pError);
    });
  },
  /**
   * @description save the current model to the backend and update the list afterwards
   * @function
   * @private
   * @return {Deferred}
   */
  _saveQuery: function _saveQuery(pUpdateList) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that._saveQueriesToBackend(that.queries, that.options.applicationContext, that.options.groupContext, that.options.saveContext).then(function (pResult) {
        if (pUpdateList !== false) {
          // update ui
          that.element.children(".cqm_list").DynamicList("update").always(function () {
            pDefer.resolve(pResult);
          });
        } else {
          pDefer.resolve(pResult);
        }
      }, function (pError) {
        console.error(pError);
        pDefer.reject(pError);
      });
    });
  },
  /**
   * @description The user want to remove a item from the list
   * @function
   * @private
   * @param {type} pQueryName
   * @return {Deferred}
   */
  _removeQuery: function _removeQuery(pQueryName) {
    if (typeof pQueryName !== "string" || pQueryName.length <= 0) {
      throw new Error("parameter queryname must be a not empty string");
    }
    for (var i = 0; i < this.queries.length; i++) {
      if (this.queries[i] !== undefined && this.queries[i].name === pQueryName) {
        this.queries.splice(i, 1); // remove item
        break;
      }
    }
    var that = this;
    return $.Deferred(function (pDefer) {
      that._saveQueriesToBackend(that.queries, that.options.applicationContext, that.options.groupContext, that.options.saveContext).then(function () {
        // update ui
        that.element.children(".cqm_list").DynamicList("removeItem", pQueryName);
        pDefer.resolve();
      })["catch"](function (pError) {
        console.error(pError);
        pDefer.reject(pError);
      });
    });
  },
  /**
   * @description Get the query saved in the model with corresponding name
   * @function
   * @private
   * @param {String} pQueryName
   * @return {QueryObject}
   */
  _getQueryByName: function _getQueryByName(pQueryName) {
    for (var i = 0; i < this.queries.length; i++) {
      if (this.queries[i] !== undefined && this.queries[i].name === pQueryName) {
        return this.queries[i];
      }
    }
    return null;
  },
  /**
   * @description Sets the option
   * @function
   * @private
   * @name nixps-cloudflow.CloudflowQueryManager#_setOption
   */
  _setOptions: function _setOptions(options) {
    this._superApply(arguments);
    this._controlOptions();
    this._draw();
  },
  /**
   * @description Control the input options and throw a error if needed
   * @name nixps-cloudflow.CloudflowQueryManager#_controlOptions
   * @function
   * @private
   * @returns {undefined}
   */
  _controlOptions: function _controlOptions() {
    if (Array.isArray(this.options.currentQuery) === false && this.options.currentQuery !== null && typeof this.options.currentQuery !== "string") {
      throw new Error("input option currentQuery must be an array or null or a string");
    }
    if (typeof this.options.groupContext !== "string") {
      throw new Error("input option groupContext must be a string");
    }
    if (typeof this.options.saveContext !== "string" || this.options.saveContext.length <= 0) {
      throw new Error("input option saveContext must be an not empty string");
    }
  },
  _destroy: function _destroy() {
    this.element.removeClass(this.widgetFullName);
    if (this.save_dialog !== null) {
      this.save_dialog.remove();
    }
    this._super();
  }
});

},{"../../../common/BrowserStorage/js/IndexedStorage.js":278,"./CloudflowQueryMode.js":71,"./nixps-cloudflow-CloudflowSaveQueryDialog.js":75}],74:[function(require,module,exports){
"use strict";

var CloudflowQueryMode = require("./CloudflowQueryMode.js");
require('./nixps-cloudflow-CloudflowQueryManager.js');
require("./nixps-cloudflow-CloudflowQueryBuilder.js");
var IndexedStorage = require("../../../common/BrowserStorage/js/IndexedStorage.js");

/**
 * @namespace nixps-cloudflow.CloudflowQueryPanel
 * @description draw a query builder and a selector of the saved querys
 * @example $('<div>').CloudflowQueryPanel({});
 */
$.widget("nixps-cloudflow.CloudflowQueryPanel", $.Widget, {
  widgetEventPrefix: "cloudflowquerypanel",
  options: {
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#collection
     * @description Option for the internal builder component, see {@link nixps.cloudflow.CloudflowQueryBuilder#collection}
     * @type {String}
     * @default ""
     */
    collection: "",
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#defaultQuery
     * @description Option for the internal builder component, see {@link nixps.cloudflow.CloudflowQueryBuilder#defaultQuery}
     * @default null
     */
    defaultQuery: null,
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#allow_groups
     * @description Option for the internal builder component, see {@link nixps.cloudflow.CloudflowQueryBuilder#defaultQuery}
     * @type {Boolean}
     * @default true
     */
    allow_groups: true,
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#conditions
     * @description The possible conditions
     * @type {Array}
     * @default undefined
     */
    conditions: undefined,
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#allowNotOperator
     * @description Must we allow the not opperator?
     * @type {Boolean}
     * @default undefined
     */
    allowNotOperator: undefined,
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#applicationContext
     * @description The string to specify the saved querys application id
     * @default "com.nixps.cloudflow.querybuilder"
     * @type {String}
     */
    applicationContext: "com.nixps.cloudflow.querybuilder",
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#groupContext
     * @description the group context. this is a sub group
     * @default ""
     * @type {String}
     */
    groupContext: "",
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#saveContext
     * @description The string to specify the saved querys
     * @default null
     * @type {String}
     */
    saveContext: "",
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#showQueryPresets
     * @description Must we show a view options
     * @type {Boolean}
     * @default true
     */
    showQueryPresets: true,
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#showConfigurationButton
     * @description Must we show a configuration button
     * @type {Boolean}
     * @default true
     */
    showConfigurationButton: true,
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#showCollapseButton
     * @description Must we show a collapse button
     * @type {Boolean}
     * @default true
     */
    showCollapseButton: true,
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#showCloseButton
     * @description Will we show the close button at the right topbar or not ?
     * @type {Boolean}
     * @default false
     */
    showCloseButton: false,
    showSaveButton: false,
    mode: CloudflowQueryMode.VIEW,
    /**
     * @name nixps-cloudflow.CloudflowQueryPanel#querysProvider
     * @description The way how to save and retrieve the queries
     * @type {String}
     * @default "backend"
     */
    querysProvider: "backend",
    activeQuery: ""
  },
  /**
   * @description Create the component
   * @name nixps-cloudflow.CloudflowQueryPanel#_create
   * @function
   * @private
   * @returns {undefined}
   */
  _create: function _create() {
    this._controlOptions();
    this.element.addClass(this.widgetFullName);
    this.savedQueries; // array containing all the querys who are saved
    this.previousCustomQuery = []; // containing the query when user changed to a saved query
    this.isCustomQuery = true; // flag indicating that the user is being working on the custom query
    this.customLabel = $.i18n._("nixps-cloudflow-ServerQueryEditor.customquery_textlabel");
    this.viewsSelectOption = $.i18n._("nixps-query-QueryManager.views");
    this.searchesSelectOption = $.i18n._("nixps-query-QueryManager.searches");
    this._draw();
    this._on(this.element, {
      "change .cqb_savedqueryselector": this._changeSavedQueryHandler,
      "click .cqb_savequery": this._savedQueryHandler,
      "click .cqb_savedqueryConfig": this._clickConfigHandler,
      "cloudflowquerybuilderchange": this._querybuilderChangeHandler,
      "click .cqb_closebutton": this._closeButtonClickHandler,
      "click .cqb_collapse": this._collapseClickHandler
    });
  },
  /**
   * @description function runs when user select a saved query, or go back
   * @name nixps-cloudflow.CloudflowQueryPanel#_changeSavedQueryHandler
   * @function
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _changeSavedQueryHandler: function _changeSavedQueryHandler(pEvent, pData) {
    var value = $(pEvent.currentTarget).Select('getValue');
    if (value === this.customLabel) {
      // user want to build his own query
      if (Array.isArray(this.previousCustomQuery)) {
        this.setValue(this.previousCustomQuery);
      } else {
        this.setValue([]);
      }
      this.isCustomQuery = true;
    } else {
      // save the query to reappear when go back to custom
      if (this.isCustomQuery === true) {
        this.previousCustomQuery = this.getValue();
        this.isCustomQuery = false;
      }
      var that = this;
      // set the asked query
      for (var i = 0; i < this.savedQueries.length; i++) {
        if (this.savedQueries[i] !== undefined && this.savedQueries[i].name === value) {
          if (Array.isArray(this.savedQueries[i].query)) {
            this.setValue(this.savedQueries[i].query, this.options.mode === CloudflowQueryMode.VIEW || this.savedQueries[i].restore !== "search").then(function (pResult) {
              if (that.options.mode === CloudflowQueryMode.SEARCH_AND_VIEW && that.savedQueries[i].restore === "search") {
                that.element.find(".rule-value-container input").val("");
              }
              if ($.isPlainObject(pResult) && typeof pResult.error === "string") {
                // if error occurred, disable that specific option
                $(pEvent.currentTarget).find("option[value='" + value + "']").prop("disabled", true);
                $(pEvent.currentTarget).Select('setValue', that.customLabel);
              }
            });
          }
          return true;
        }
      }
      // a error occured if code comes here
      console.error("selected saved query not found!");
    }
  },
  /**
   * @description The user want to edit the querys
   * @function
   * @name nixps-cloudflow.CloudflowQueryPanel#_clickConfigHandler
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _clickConfigHandler: function _clickConfigHandler(pEvent, pData) {
    var that = this;
    var selectedQueryName = this.element.find(".cqb_savedqueryselector").Select("getValue");
    var currentQuery = null;
    if (typeof selectedQueryName === "string" && selectedQueryName.length > 0 && selectedQueryName !== this.customLabel) {
      currentQuery = selectedQueryName;
    } else {
      currentQuery = this.getValue();
    }
    var dialogContent = $('<div>').addClass("cloudflowQueryManagerDialogContent");
    dialogContent.append($('<div>').CloudflowQueryManager({
      collection: this.options.collection,
      currentQuery: currentQuery,
      applicationContext: this.options.applicationContext,
      groupContext: this.options.groupContext,
      saveContext: this.options.saveContext,
      mode: this.options.mode,
      querysProvider: this.options.querysProvider
    }));
    dialogContent.dialog({
      title: $.i18n._("nixps-cloudflow-cloudflowquerymanager.dialog_title"),
      closeOnEscape: true,
      closeText: "",
      resizable: true,
      minHeight: 550,
      minWidth: Math.min(970, window.innerWidth - 10),
      modal: true,
      autoOpen: true,
      dialogClass: 'cf-dialog CloudflowQueryManagerDialog',
      classes: {
        "ui-dialog": 'cf-dialog CloudflowQueryManagerDialog'
      },
      buttons: [],
      close: function close() {
        // after a close we need to refresh the selector
        that._drawSelect();
        $(this).remove();
      },
      open: function open() {
        // replace height "auto" by xx px -> child has height: 100% to work
        $(this).css("height", $(this).css("height"));
      }
    });
  },
  _savedQueryHandler: function _savedQueryHandler() {
    if (this.element.children(".cqp_builder").CloudflowQueryBuilder("validate") === true) {
      var that = this;
      var save_dialog = $("<div>").appendTo(this.element).CloudflowSaveQueryDialog({
        title: $.i18n._("nixps-cloudflow-cloudflowquerymanager.messagetitle_addnew"),
        close: function close() {
          save_dialog.remove();
        },
        mode: that.options.mode
      });
      save_dialog.on("cloudflowsavequerydialogsave", function (event, data) {
        if (that._checkQueryValues(save_dialog, data)) {
          data.query = that.element.children(".cqp_builder").CloudflowQueryBuilder("getValue");
          that.savedQueries.push(data);
          that._saveQuery().then(function () {
            that._drawSelect().then(function () {
              that.element.children(".cqb_savedquerypanel").children(".cqb_savedqueryselector").Select("setValue", data.name);
            });
          });
          save_dialog.remove();
        }
      });
    }
  },
  /**
   * @description function runws when the builder itself throws a change
   * @function
   * @name nixps-cloudflow.CloudflowQueryPanel#_querybuilderChangeHandler
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @return {undefined}
   */
  _querybuilderChangeHandler: function _querybuilderChangeHandler(pEvent, pData) {
    if (pData !== null && pData !== undefined && ["user", "delete_rule", "add_rule"].includes(pData.action)) {
      var currentQuery = this.getValue();
      this.element.find(".cqb_savedqueryselector").Select("setValue", this.customLabel);
      this.previousCustomQuery = currentQuery;
      this._trigger("change", pEvent, Object.assign(pData, {
        trigger: "user",
        query: currentQuery
      }));
    } else {
      this._trigger("change", pEvent, pData); // pass events
    }
  },

  /**
   * @description Function runs when user want to close the dialog
   * @function
   * @name nixps-cloudflow.CloudflowQueryPanel#_closeButtonClickHandler
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @returns {undefined}
   */
  _closeButtonClickHandler: function _closeButtonClickHandler(pEvent, pData) {
    this._trigger("close", pEvent, {});
  },
  /**
   * @description Function runs when user want to collapse the querypanel
   * @function
   * @name nixps-cloudflow.CloudflowQueryPanel#_collapseClickHandler
   * @private
   * @param {type} pEvent
   * @param {type} pData
   * @returns {undefined}
   */
  _collapseClickHandler: function _collapseClickHandler(pEvent) {
    if ($(pEvent.currentTarget).hasClass("cf-rotate-270")) {
      $(this.element).children(".nixps-cloudflow-CloudflowQueryBuilder").show();
      $(pEvent.currentTarget).removeClass("cf-rotate-270");
    } else {
      $(this.element).children(".nixps-cloudflow-CloudflowQueryBuilder").hide();
      $(pEvent.currentTarget).addClass("cf-rotate-270");
    }
  },
  /**
   * @description Draws the dialog according to the current state
   * @function
   * @private
   * @name nixps-cloudflow.CloudflowQueryPanel#_draw
   * @return {undefined} 
   */

  _draw: function _draw() {
    this.element.empty();
    // draw skeleton
    var querySelector = $("<div>").addClass("cqb_savedquerypanel");
    if (this.options.showQueryPresets === true) {
      querySelector.show();
      querySelector.append($("<label>").addClass("noselect")._t("nixps-cloudflow-ServerQueryEditor.customquery_chooselabel"));
      querySelector.append($("<div>").addClass("cqb_savedqueryselector"));
      this.element.append(querySelector);
      // get data
      this._drawSelect();
    }
    if (this.options.showConfigurationButton === true) {
      querySelector.append($('<span>').addClass("cqb_savedqueryConfig fa fa-cog").attr("title", $.i18n._("nixps-cloudflow-cloudflowquerymanager.dialog_title")));
    }
    if (this.options.showSaveButton === true) {
      querySelector.append($('<button>').addClass("cqb_savequery cf-button-main")._t("nixps-cloudflow-cloudflowquerymanager.buttontext_save"));
    }
    if (this.options.showCloseButton === true) {
      querySelector.append($('<span>').addClass("cf-icon cf-icon-x cf-iconbutton cqb_closebutton").attr("aria-label", $.i18n._("nixps-cloudflow-dialog.close")));
    }
    if (this.options.showCollapseButton === true) {
      querySelector.prepend($("<span>").addClass("cqb_collapse cf-icon cf-icon-chevron-down cf-iconbutton").attr("title", $.i18n._("nixps-cloudflow-cloudflowquerymanager.collapse")));
    }
    var builder = $('<div>').addClass("cqp_builder");
    this.element.append(builder);
    builder.CloudflowQueryBuilder({
      "collection": this.options.collection,
      "defaultQuery": this.options.defaultQuery,
      "allow_groups": this.options.allow_groups,
      "conditions": this.options.conditions,
      "allowNotOperator": this.options.allowNotOperator
    });
  },
  /**
   * @description (re)draw the selector to select a saved query
   * @function
   * @private
   * @return {Deferred}
   */
  _drawSelect: function _drawSelect() {
    var that = this;
    return this._getSavedQueries().then(function (pSavedQueries) {
      if (that.options.mode === CloudflowQueryMode.VIEW) {
        var names = [];
        // if data draw selector
        if (Array.isArray(pSavedQueries) && pSavedQueries.length > 0) {
          for (var i = 0; i < pSavedQueries.length; i++) {
            if (pSavedQueries[i] !== undefined && typeof pSavedQueries[i].name === "string" && pSavedQueries[i].name.length > 0) {
              names.push(pSavedQueries[i].name);
              if (Array.isArray(pSavedQueries[i].query) === false) {
                console.error("query: " + pSavedQueries[i].name + " must have a query as array");
                pSavedQueries[i].query = []; // add empty array as default 
              }
            }
          }
        }

        names.unshift(that.customLabel);
      } else {
        var names = {};
        names[that.customLabel] = that.customLabel;
        names[that.viewsSelectOption] = {};
        names[that.searchesSelectOption] = {};
        var keyValues = pSavedQueries.reduce(function (accumulator, item) {
          var name = item.name;
          if (item.restore === "view") {
            accumulator[that.viewsSelectOption][item.name] = name;
          } else if (item.restore === "search") {
            accumulator[that.searchesSelectOption][item.name] = name;
          }
          return accumulator;
        }, names);
      }
      var currectSelectedQueryName = that.element.children(".cqb_savedquerypanel").children(".cqb_savedqueryselector.nixps-cloudflow-Select").Select("getValue");
      if (typeof currectSelectedQueryName !== "string" && that.options.activeQuery !== false && that.options.activeQuery.length > 0) {
        currectSelectedQueryName = that._getActiveQueryName(that.options.activeQuery);
      }
      that.element.children(".cqb_savedquerypanel").css("display", "").children(".cqb_savedqueryselector").Select({
        keyValues: names
      });
      if (typeof currectSelectedQueryName === "string" && currectSelectedQueryName.length > 0) {
        that.element.children(".cqb_savedquerypanel").children(".cqb_savedqueryselector.nixps-cloudflow-Select").Select("setValue", currectSelectedQueryName);
        if (currectSelectedQueryName !== that.customLabel) {
          // set the asked query if not *custom*
          for (var i = 0; i < that.savedQueries.length; i++) {
            if (that.savedQueries[i] !== undefined && that.savedQueries[i].name === currectSelectedQueryName) {
              if (Array.isArray(that.savedQueries[i].query)) {
                that.setValue(that.savedQueries[i].query);
              }
            }
            break;
          }
        }
      }
    });
  },
  getValue: function getValue() {
    return this.element.children('.cqp_builder').CloudflowQueryBuilder('getValue');
  },
  setValue: function setValue(pQuery, pTrigger) {
    return this.element.children('.cqp_builder').CloudflowQueryBuilder('setValue', pQuery, pTrigger);
  },
  validate: function validate() {
    return this.element.children(".cqp_builder").CloudflowQueryBuilder("validate");
  },
  _getActiveQueryName: function _getActiveQueryName(pQuery) {
    var queryName = "";
    this.savedQueries.forEach(function (savedQuery) {
      var isEqual = false;
      if (savedQuery.query.length === pQuery.length) {
        for (var i = 0; i < savedQuery.query.length; i++) {
          if (savedQuery.query[i] === pQuery[i]) {
            isEqual = true;
          } else {
            isEqual = false;
            break;
          }
        }
      }
      if (isEqual === true) {
        queryName = savedQuery.name;
      }
      ;
    });
    return queryName;
  },
  _checkQueryValues: function _checkQueryValues(pDialog, pValues) {
    if (typeof pValues.name !== "string" || pValues.name.length <= 0) {
      console.error("new name is empty");
      this._trigger("error", null, {
        error_code: "empty_name",
        error: "new name is empty"
      });
      pDialog.CloudflowSaveQueryDialog("showErrorMessage", $.i18n._("nixps-cloudflow-cloudflowquerymanager.errormessage_nameisempty"));
      return false;
    } else if (this._getQueryByName(pValues.name) !== null) {
      console.error("name already exists");
      this._trigger("error", null, {
        error_code: "name_already_exists",
        error: "name already exists"
      });
      pDialog.CloudflowSaveQueryDialog("showErrorMessage", $.i18n._("nixps-cloudflow-cloudflowquerymanager.errormessage_namealreadyexists"));
      return false;
    }
    return true;
  },
  _saveQuery: function _saveQuery() {
    var that = this;
    if (this.options.querysProvider === "backend_readtimestamp") {
      return $.Deferred(function (pDefer) {
        var preferences = {
          queries: that.savedQueries,
          read_timestamp: +new Date()
        };
        api_async.preferences.save_for_current_user(preferences, that.options.applicationContext, that.options.groupContext + "." + that.options.saveContext, function (pResult) {
          pDefer.resolve(pResult);
        }, function (pError) {
          console.error(pError);
          pDefer.reject(pError);
        });
      });
    } else if (this.options.querysProvider === "backend" || IndexedStorage.isSupported() === false) {
      return $.Deferred(function (pDefer) {
        api_async.preferences.save_for_current_user(that.savedQueries, that.options.applicationContext, that.options.saveContext, function (pResult) {
          pDefer.resolve(pResult);
        }, function (pError) {
          console.error(pError);
          pDefer.reject(pError);
        });
      });
    } else if (this.options.querysProvider === "indexdb") {
      var newData = {
        "savecontext": this.options.saveContext,
        "queries": this.savedQueries.slice()
      };
      var that = this;
      var found = false;
      return IndexedStorage.update_with_filter("nixps.cloudflowQueryManager", function (pData) {
        if (pData !== undefined && pData.savecontext === that.options.saveContext) {
          found = true;
          return true;
        }
      }, newData).then(function () {
        if (found === false) {
          return IndexedStorage.add("nixps.cloudflowQueryManager", newData);
        }
      });
    }
  },
  _getQueryByName: function _getQueryByName(pQueryName) {
    for (var i = 0; i < this.savedQueries.length; i++) {
      if (this.savedQueries[i] !== undefined && this.savedQueries[i].name === pQueryName) {
        return this.savedQueries[i];
      }
    }
    return null;
  },
  /**
   * @description retieve all the saved querys
   * @function
   * @private
   * @return {Deferred}
   */
  _getSavedQueries: function _getSavedQueries() {
    var that = this;
    this.savedQueries = [];
    if (this.options.querysProvider === "backend_readtimestamp") {
      return $.Deferred(function (pDefer) {
        api_async.preferences.get_for_current_user(that.options.applicationContext, that.options.groupContext, function (pResult) {
          if ($.isPlainObject(pResult.preferences)) {
            var dataChanged = false;
            that.savedQueries = [];
            for (var context in pResult.preferences) {
              if (context === that.options.saveContext) {
                if (Array.isArray(pResult.preferences[that.options.saveContext].queries) && pResult.preferences[that.options.saveContext].queries.length > 0) {
                  if (pResult.preferences[that.options.saveContext].read_timestamp !== null) {
                    pResult.preferences[that.options.saveContext].read_timestamp = +new Date();
                    dataChanged = true;
                  }
                  that.savedQueries = pResult.preferences[that.options.saveContext].queries.slice();
                } else {
                  delete pResult.preferences[context];
                  dataChanged = true;
                }
              } else {
                if (typeof pResult.preferences[context].read_timestamp === "number" && pResult.preferences[context].read_timestamp < +new Date() - 31557600000) {
                  delete pResult.preferences[context];
                  dataChanged = true;
                }
              }
            }
            if (dataChanged === true) {
              api_async.preferences.save_for_current_user(pResult.preferences, that.options.applicationContext, that.options.groupContext, function () {
                pDefer.resolve(that.savedQueries);
              }, pDefer.reject);
            } else {
              pDefer.resolve(that.savedQueries);
            }
          } else {
            pDefer.resolve([]);
          }
        }, pDefer.reject);
      });
    } else if (this.options.querysProvider === "backend" || IndexedStorage.isSupported() === false) {
      return $.Deferred(function (pDefer) {
        api_async.preferences.get_for_current_user(that.options.applicationContext, that.options.saveContext, function (pResult) {
          if (Array.isArray(pResult.preferences)) {
            that.savedQueries = pResult.preferences;
            pDefer.resolve(that.savedQueries);
          } else {
            pDefer.resolve([]);
          }
        }, pDefer.reject);
      });
    } else if (this.options.querysProvider === "indexdb") {
      return IndexedStorage.list_with_options("nixps.cloudflowQueryManager", ["savecontext", "equal to", this.options.saveContext]).then(function (pResults) {
        if (Array.isArray(pResults.results) && pResults.results.length > 0) {
          that.savedQueries = pResults.results[0].queries;
        }
        return that.savedQueries;
      });
    }
  },
  /**
   * @description Sets the option
   * @function
   * @private
   * @name nixps-cloudflow.CloudflowQueryPanel#_setOption
   */
  _setOption: function _setOption(pKey, pValue) {
    this._superApply(arguments);
    this._controlOptions();
    if (pKey === "collection" || pKey === "defaultQuery" || pKey === "allow_groups") {
      this.element.children(".cqp_builder").CloudflowQueryBuilder("option", pKey, pValue);
    } else {
      this._draw();
    }
  },
  /**
   * @description Control the input options and throw a error if needed
   * @name nixps-cloudflow.CloudflowQueryPanel#_controlOptions
   * @function
   * @private
   * @returns {undefined}
   */
  _controlOptions: function _controlOptions() {
    if (typeof this.options.groupContext !== "string") {
      throw new Error(this.widgetName + " input option groupContext must be a string");
    }
    if (typeof this.options.saveContext !== "string" || this.options.saveContext.length <= 0) {
      throw new Error(this.widgetName + " input option saveContext must be a not empty string");
    }
  },
  _destroy: function _destroy() {
    this.element.removeClass(this.widgetFullName);
    this._superApply(arguments);
  }
});

},{"../../../common/BrowserStorage/js/IndexedStorage.js":278,"./CloudflowQueryMode.js":71,"./nixps-cloudflow-CloudflowQueryBuilder.js":72,"./nixps-cloudflow-CloudflowQueryManager.js":73}],75:[function(require,module,exports){
"use strict";

var CloudflowQueryMode = require("./CloudflowQueryMode.js");
var mFormJSON = {
  "layout": {
    "type": "bootstrapGrid",
    "parameters": [[{
      "content": "errorMessage",
      "width": 12
    }], [{
      "content": "nameInput",
      "width": 12
    }], [{
      "content": "restoreInput",
      "width": 12
    }]]
  },
  "form": {
    "elements": [{
      "type": "component",
      "element": {
        "id": "errorMessage",
        "type": "ErrorMessage"
      }
    }, {
      "type": "field",
      "element": {
        "key": "name",
        "label": "${nixps-query-SaveQueryDialog.name}",
        "component": {
          "id": "nameInput",
          "type": "Input",
          "options": {
            "type": "text"
          }
        }
      }
    }, {
      "type": "field",
      "element": {
        "key": "restore",
        "label": "${nixps-query-SaveQueryDialog.restore}",
        "component": {
          "id": "restoreInput",
          "type": "RadioInputs",
          "options": {
            "name": "restore",
            "defaultValue": "view",
            "radioInputs": [{
              "value": "view",
              "text": "${nixps-query-SaveQueryDialog.view}"
            }, {
              "value": "search",
              "text": "${nixps-query-SaveQueryDialog.search}"
            }]
          }
        }
      }
    }]
  }
};
var mEmptyValues = {
  name: "",
  restore: false
};
$.widget("nixps-cloudflow.CloudflowSaveQueryDialog", $.ui.dialog, {
  widgetEventPrefix: "cloudflowsavequerydialog",
  options: {
    width: 400,
    dialogClass: "cf-dialog",
    classes: {
      "ui-dialog": "cf-dialog"
    },
    closeText: "",
    mode: CloudflowQueryMode.VIEW
  },
  _create: function _create() {
    this._super();
    this.element.parent().addClass(this.widgetFullName);
    this._draw();
    this._on({
      "click .csqd_save": this._clickSaveHandler.bind(this),
      "click .csqd_cancel": this._clickCancelHandler.bind(this)
    });
  },
  /**
   * @brief draws the add project modal
   */
  _draw: function _draw() {
    this.element.append(this.options.message);
    var form = mFormJSON.form;
    if (this.options.mode === CloudflowQueryMode.VIEW) {
      form.elements.splice(2, 1);
    }
    var that = this;
    var formRenderer = $("<div>").FormRenderer({
      formJSON: mFormJSON.form,
      layoutJSON: mFormJSON.layout,
      variableDictionary: Object.assign({}, $.i18n.dict),
      formClasses: "cf-form",
      makeDeepCopy: false,
      submitCallBackFunction: function submitCallBackFunction() {
        that._clickSaveHandler();
        return false;
      }
    });
    this.element.append(formRenderer);
    var buttonGroup = $("<div>").addClass("bottombar cf-buttonbar");
    var cancelButton = $("<button>").attr("type", "button").appendTo(this.element).addClass("noselect cf-button-secondary csqd_cancel")._t("nixps-cloudflow-cloudflowquerymanager.buttontext_cancel");
    buttonGroup.append(cancelButton);
    var saveButton = $("<button>").attr("type", "button").appendTo(this.element).addClass("noselect cf-button-main csqd_save")._t("nixps-cloudflow-cloudflowquerymanager.buttontext_save");
    buttonGroup.append(saveButton);
    this.element.parent().append(buttonGroup);
  },
  setValues: function setValues(data) {
    this.element.children(".nixps-cloudflow-FormRenderer").FormRenderer("setValues", data.values);
  },
  showErrorMessage: function showErrorMessage(pMessage) {
    this.element.find(".nixps-cloudflow-ErrorMessage").ErrorMessage("showErrorMessage", pMessage);
  },
  hideErrorMessage: function hideErrorMessage() {
    this.element.find(".nixps-cloudflow-ErrorMessage").ErrorMessage("hideErrorMessages");
  },
  _clickSaveHandler: function _clickSaveHandler(event) {
    var valid = this.element.children(".nixps-cloudflow-FormRenderer").FormRenderer("isValid", true);
    if (valid === true) {
      var data = {
        values: this.element.children(".nixps-cloudflow-FormRenderer").FormRenderer("getValues")
      };
      this._trigger("save", null, data.values);
    }
  },
  _clickCancelHandler: function _clickCancelHandler(event, data) {
    this.close();
  },
  /**
   * @brief validates the options
   */
  _validateOptions: function _validateOptions() {}
});

},{"./CloudflowQueryMode.js":71}],76:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Dec 8, 2017 5:51:06 PM
 */

(function ($) {
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");

  /**
   * content types
   * @enum {String}
   * @readonly
   */
  var contentType = Object.freeze({
    /** a custom page component */
    CUSTOM_PAGE_COMPONENT: "CustomPageComponent",
    /** a form */
    STATIC_FORM: "staticForm"
  });

  /**
   * @namespace nixps-cloudflow.CloudflowTabs
   * @description Draw tabs
   * @private
   * @example $("<div>").CloudflowTabs({});
   * @version 1.2.0
   */
  $.widget("nixps-cloudflow.CloudflowTabs", $.Widget, {
    version: "1.2.0",
    widgetEventPrefix: "cloudflowtabs",
    options: {
      /**
       * @name nixps-cloudflow.CloudflowTabs#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.CloudflowTabs#relativeBasePath
       * @description The path to be used if the url is relative
       * @type {string}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.CloudflowTabs#height
       * @description The height of the component, Of "auto" the default height of the content will be taken
       * @type {String}
       * @default "auto"
       */
      height: "auto",
      /**
       * @name nixps-cloudflow.CloudflowTabs#tabs
       * @description The Tabs content and title
       * @type {Array.<Object>}
       * @default []
       */
      tabs: [],
      /**
       * @name nixps-cloudflow.CloudflowTabs#active
       * @description the index of tab to be active
       * @default 0
       * @type {Number}
       */
      active: 0,
      /**
       * @name nixps-cloudflow.CloudflowTabs#classes
       * @description The class names sepearated with spaces, added tot the component
       * @type {String}
       * @default ""
       */
      classes: "",
      /**
       * @name nixps-cloudflow.CloudflowTabs#tabClasses
       * @description The class name of the tabs
       * @type {String}
       * @default "cf-tab cf-tab-blueborder"
       */
      tabClasses: "cf-tab cf-tab-blueborder",
      pagebuilderStyleClass: null,
      pagebuilderStyleClassActive: null,
      /**
       * @description The class name for all non active tabs
       * @name nixps-cloudflow.CloudflowTabs#tabItemClasses
       * @default ""
       * @type {String}
       */
      tabItemClasses: "",
      /**
       * @description The class name for all active tabs
       * @name nixps-cloudflow.CloudflowTabs#tabItemActiveClasses
       * @default ""
       * @type {String}
       */
      tabItemActiveClasses: "",
      /**
       * @description Must the tabs must have a fixed header, that stays visible when scrolling down? 
       * @name nixps-cloudflow.CloudflowTabs#enableStickyHeader
       * @type {Boolean}
       * @default false
       * @since 1.2.0
       */
      enableStickyHeader: false,
      /**
       * @name nixps-cloudflow.CloudflowTabs#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       */
      style_type: "default",
      /**
       * @description Whether the component is inside the pagebuilder editor or not.
       * @name nixps-cloudflow.CloudflowTabs#isInEditor
       * @type {Boolean}
       * @default false
       */
      isInEditor: false,
      /**
       * @name nixps-cloudflow.CloudflowTabs#created
       * @description called when component is drawed and ready
       * @type {Function}
       * @private
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.CloudflowTabs#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass(this.options.classes).addClass("CloudflowStyle_" + this.options.style_type);
      this.creating = true;
      this.isBasePresent = false;
      // trac #48810
      // if a bas tag is present on the HTML page
      // the ui.tags thinks the tabs are not local, and will start loading wrongly data 
      if ($("base").length > 0) {
        console.warn(this.widgetFullName + ": tag <base> and jQuery.ui.tabs can conflict with each other");
        this.isBasePresent = true;
      }
      this._on(this.element, {
        "tabsbeforeactivate": this._beforeActivatingTabHandler,
        "tabsshow": this._showHandler,
        "tabsactivate": this._activateTabsHandler,
        "tabsbeforeload": function tabsbeforeload(p, d) {}
      });
      this._draw();
    },
    /**
     * @description function runs when user want to see a tab
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     * @function
     * @name nixps-cloudflow.CloudflowTabs#_beforeActivatingTabHandler
     * @private
     */
    _beforeActivatingTabHandler: function _beforeActivatingTabHandler(pEvent, pData) {
      if (pData !== undefined && pData.newPanel !== undefined) {
        var waitingPanel = pData.newPanel.children(".cloudflowtabs_notYetLoadedTab");
        if (waitingPanel.length === 1) {
          if (this.options.height === "auto") {
            var diff = pData.oldPanel.height() - pData.newPanel.height();
            if (diff > 0) {
              pData.newPanel.css("minHeight", pData.oldPanel.height());
            }
          }
          var tabcontent = waitingPanel.data("tabcontent");
          var publicIndex = waitingPanel.data("tabpublicindex");
          var contentpanel = waitingPanel.parent().empty();
          this._drawLazzyContent(contentpanel, tabcontent, parseInt(publicIndex));
        } else if (pData.newPanel.children(".tabs_item_needrefresh").length > 0) {
          // in case of custom page components
          if (pData.newPanel.children(".tabs_item_needrefresh").first().hasClass("nixps-pagebuilder-CustomPageComponent")) {
            pData.newPanel.children(".nixps-pagebuilder-CustomPageComponent").CustomPageComponent("refreshMaintainContext");
          }
        }
      }
    },
    /**
     * @function
     * @description function runs when a tab shows up
     * @private
     * @deprecated
     * @name nixps-cloudflow.CloudflowTabs#_showHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _showHandler: function _showHandler(pEvent, pData) {
      // trigger is not runned in jQuery UI 13.
      if (this.options.height === "auto") {
        // small bug, somebody add fixed height, prevent this
        this.element.children(".tabs_container").children(".tab_content").css("height", "");
      } else {
        this.element.children(".tabs_container").children(".tab_content").css("height", this.options.height);
      }
    },
    /**
     * @description function runs when a tab becoms visible
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowTabs#_activateTabsHandler
     * @param {*} pEvent 
     * @param {*} pData 
     */
    _activateTabsHandler: function _activateTabsHandler(pEvent, pData) {
      if (pData !== undefined && pData.newPanel !== undefined) {
        var panelID = pData.newPanel.attr("id").replace(/.*_([0-9]*)$/, "$1");
        var iPanelID = parseInt(panelID);
        this._trigger("showtab", null, {
          active: iPanelID
        });
      }
      if (pData !== undefined && pData.newTab !== undefined) {
        if (this.options.tabItemClasses !== this.options.tabItemActiveClasses && pData.newTab.hasClass(this.options.tabItemClasses) === true) {
          pData.newTab.removeClass(this.options.tabItemClasses);
        }
      }
      if (pData !== undefined && pData.oldTab !== undefined) {
        if (pData.oldTab.hasClass(this.options.tabItemClasses) === false) {
          pData.oldTab.addClass(this.options.tabItemClasses);
        }
      }
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.CloudflowTabs#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowTabs#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      var container = $("<div>").addClass("tabs_container");
      if (this.options.pagebuilderStyleClass !== null) {
        if (["cf-tab cf-tab-blueborder", "cf-tab cf-tab-lightpastel"].includes(this.options.pagebuilderStyleClass) === false) {
          //custom pagebuilderstyle class
          this.options.tabItemClasses = "nixps_styling_class_" + this.options.pagebuilderStyleClass;
          if (this.options.pagebuilderStyleClassActive !== null) {
            this.options.tabItemActiveClasses = "nixps_styling_class_" + this.options.pagebuilderStyleClassActive;
          }
          container.addClass("cf-tab");
        } else {
          //predefined - no need to add to each tab a class
          this.options.tabItemClasses = "";
          this.options.tabItemActiveClasses = "";
          container.addClass(this.options.pagebuilderStyleClass);
        }
      } else {
        container.addClass(this.options.tabClasses);
      }
      this.element.append(container);
      var tabsTitles = $("<ul>");
      container.append(tabsTitles);
      if (this.options.height !== "auto") {
        container.css("height", this.options.height);
      }
      if (this.options.active >= this.options.tabs.length) {
        this.options.active = this.options.tabs.length - 1;
      }
      var disabledTabIndexes = [];
      var removedTabs = 0;
      var activeTabIndex = this.options.active;
      for (var i = 0; i < this.options.tabs.length; i++) {
        if (this.options.tabs[i].show === false) {
          removedTabs++;
          continue;
        }
        var tabID = this._calcTabID(i);
        var title = this._drawTabTitle(tabID, this.options.tabs[i].title, this.options.tabs[i].icon, this.options.tabs[i].tooltip);
        var list = $("<li>").append(title);
        tabsTitles.append(list);
        if (this.options.tabs[i].disabled === true) {
          disabledTabIndexes.push(i - removedTabs);
        }
        // content
        var tabContent = $("<div>").attr("id", tabID).addClass("tab_content");
        container.append(tabContent);
        if (this.options.active === i) {
          // some tabs are removed, so calc the actual index
          activeTabIndex = i - removedTabs;
        }
        this._drawContent(tabContent, this.options.tabs[i].content, i, this.options.active === i);
      }
      if (this.options.tabs.length - removedTabs <= 0) {
        // there are no tabs to show
        if (this.creating === true) {
          this.creating = false;
          this.options.created();
        }
      }
      var tabsDisabledOption;
      if (this.options.disabled === true) {
        tabsDisabledOption = true;
      } else if (disabledTabIndexes.length > 0) {
        tabsDisabledOption = disabledTabIndexes;
      } else {
        tabsDisabledOption = false;
      }
      container.tabs({
        "active": activeTabIndex,
        "classes": {
          "ui-tabs-nav": this.options.enableStickyHeader ? "cf-sticky-top nixps_styling_constants_bodybackground" : "nixps_styling_constants_bodybackground",
          "ui-tab": this.options.tabItemClasses,
          "ui-tabs-active": this.options.tabItemActiveClasses
        },
        "hide": false,
        "show": false,
        "heightStyle": this.options.height === "auto" ? "content" : "fill",
        "event": "click",
        // use "mouseover when hovering,
        "disabled": tabsDisabledOption
      });

      //jQuery will give all items the itemclasses -> not desirable for active class (merging styles)
      if (this.options.tabItemClasses !== null && this.options.tabItemClasses !== this.options.tabItemActiveClasses && this.element.find(".ui-tabs-active").hasClass(this.options.tabItemClasses)) {
        //the active tab has general style tab -> remove it
        this.element.find(".ui-tabs-active").removeClass(this.options.tabItemClasses);
      }
    },
    _calcTabID: function _calcTabID(pPublicIndex) {
      return "nixps_cloudflow_" + this.widgetName + "_" + this.uuid + "_" + pPublicIndex;
    },
    /**
     * @description return the tab title DOMElement
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowTabs#_drawTabTitle
     * @param {String} pTabID
     * @param {String} pTitle the title of the tab
     * @param {String} pIcon the icon classes name
     * @return {unresolved}
     */
    _drawTabTitle: function _drawTabTitle(pTabID, pTitle, pIcon, pTooltip) {
      var currentLocation = "";
      if (this.isBasePresent === true) {
        currentLocation = window.location.href.replace(/#.*$/, "");
      }
      var link = $("<a>").addClass("cloudflowtabs_tablink noselect").attr("href", currentLocation + "#" + pTabID);
      if (typeof pIcon === "string" && pIcon.length > 0) {
        link.prepend($("<span>").addClass("cloudflowtabs_tablinkicon").addClass(pIcon));
      }
      if (typeof pTooltip === "string" && pTooltip.length > 0) {
        link.attr("title", pTooltip);
        link.tooltip({
          content: function content() {
            var title = $(this).attr("title");

            // Escape title, since we're going from an attribute to raw HTML
            return $("<a>").text(title).html();
          },
          tooltipClass: "cf-tooltip cf-tooltip-secondary",
          classes: {
            "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
          },
          position: {
            my: "center bottom-15px",
            at: "center center",
            collision: "flipfit flip"
          }
        });
      }
      if (typeof pTitle === "string") {
        return link.text(pTitle);
      }
      // default
      return link;
    },
    /**
     * @description Draw the content, this can also be a proxy to be filled in later
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowTabs#_drawContent
     * @param {DOM} pParent The DOM of the parent
     * @param {Object} pContent The object containing data to draw
     * @param {Number} pPublicIndex the public index of the tab
     * @param {Boolean} pIsActiveTab is the tab, the visible one
     * @return {String}
     */
    _drawContent: function _drawContent(pParent, pContent, pPublicIndex, pIsActiveTab) {
      if ($.isPlainObject(pContent) && $.isEmptyObject(pContent) === false) {
        if (pContent.contentType === contentType.CUSTOM_PAGE_COMPONENT && $.isPlainObject(pContent.options)) {
          if (pIsActiveTab === true) {
            // tab is visible, show or draw direclty
            this._drawLazzyContent(pParent, pContent, pPublicIndex, this._callCreated.bind(this));
          } else {
            // tab is not active, load only want asked
            pParent.append(this._drawWaitingContent(pContent, pPublicIndex));
          }
        } else if (pContent.contentType === contentType.STATIC_FORM && $.isPlainObject(pContent.options)) {
          var form = $("<div>");
          pParent.append(form);
          form.FormRenderer(Object.assign({
            language: this.options.language
          }, pContent.options));
          if (pIsActiveTab) {
            this._callCreated();
          }
        } else {
          throw new Error("unknown tab content type");
        }
      } else if (pContent !== undefined) {
        // something else, just add it like that
        pParent.append(pContent);
        if (pIsActiveTab === true) {
          this._callCreated();
        }
      } else {
        pParent.text($.i18n._("nixps-cloudflow-cloudflowtabs.no_content_defined"));
        if (pIsActiveTab === true) {
          this._callCreated();
        }
      }
    },
    /**
     * @description generate a general proxy, a waiting container to be filled in when asked
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowTabs#_drawWaitingContent
     * @param {type} pContent
     * @return {unresolved}
     */
    _drawWaitingContent: function _drawWaitingContent(pContent, pPublicIndex) {
      return $("<div>").addClass("cloudflowtabs_notYetLoadedTab").data("tabcontent", pContent).data("tabpublicindex", pPublicIndex).text($.i18n._("nixps-cloudflow-cloudflowtabs.loading"));
    },
    /**
     * @description fill in ht proxy, fill in the content because the use asked for it
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowTabs#_drawLazzyContent
     * @param {Object} pContent
     * @param {Number} pPublicIndex the public tabindex of the tab
     * @return {unresolved}
     */
    _drawLazzyContent: function _drawLazzyContent(pParent, pContent, pPublicIndex, pCreatedCB) {
      if ($.isPlainObject(pContent) && $.isEmptyObject(pContent) === false) {
        if (pContent.contentType === contentType.CUSTOM_PAGE_COMPONENT && $.isPlainObject(pContent.options)) {
          var pageCSSSelector = null;
          if (this.element.attr("id")) {
            pageCSSSelector = "#" + this.element.attr("id");
            if (pParent.attr("id")) {
              pageCSSSelector += " #" + pParent.attr("id");
            }
          }
          var defaultOptions = {
            language: this.options.language,
            relativeBasePath: this.options.relativeBasePath,
            pageCSSSelector: pageCSSSelector,
            publicParentWidgetName: this.widgetFullName,
            customchangeTriggerIdentifier: pPublicIndex
          };
          var customPageComponentOptions = Object.assign({}, defaultOptions, pContent.options);
          customPageComponentOptions.isInEditor = this.options.isInEditor;
          if (typeof pCreatedCB === "function") {
            customPageComponentOptions.created = pCreatedCB;
          }
          var custompagecomponent = $("<div>").toggleClass("tabs_item_needrefresh", pContent.refreshOnShow === true);
          pParent.append(custompagecomponent);
          custompagecomponent.CustomPageComponent(customPageComponentOptions);
        } else {
          throw new Error("unknown tab content type");
        }
      } else if (pContent !== undefined) {
        pParent.append(pContent);
      }
    },
    _callCreated: function _callCreated() {
      if (this.creating === true) {
        this.creating = false;
        this.options.created.apply(this, arguments);
      }
    },
    /**
     * @description Refresh the specific tab  
     * @function
     * @name nixps-cloudflow.CloudflowTabs#refreshTabIndex
     * @param {Number} pPublicIndex 
     * @param {Boolean} pForce 
     * @param {Boolean} pUseOriginalURL use the original url
     * @returns Deferred
     */
    refreshTabIndex: function refreshTabIndex(pPublicIndex, pForce, pUseOriginalURL) {
      if (typeof pPublicIndex === "number" && pPublicIndex >= 0 && pPublicIndex < this.options.tabs.length) {
        if (this._isTabHidden(pPublicIndex) === true) {
          // ignore hidden tabs
          return $.Deferred().resolve({});
        }
        if (this.options.tabs[pPublicIndex].content !== undefined && this.options.tabs[pPublicIndex].content.contentType === contentType.CUSTOM_PAGE_COMPONENT) {
          var contentDOM = this.element.find("#" + this._calcTabID(pPublicIndex)).children().first();
          if (contentDOM.hasClass("cloudflowtabs_notYetLoadedTab")) {
            var tabcontent = contentDOM.data("tabcontent");
            var contentpanel = contentDOM.parent().empty();
            var drawedDef = $.Deferred();
            var drawedCallBack = function drawedCallBack() {
              contentpanel.off("custompagecomponenterror", errorCallBack);
              drawedDef.resolve({});
            };
            var errorCallBack = function errorCallBack(pError) {
              contentpanel.off("custompagecomponentdrawed", drawedCallBack);
              drawedDef.reject(pError);
            };
            contentpanel.one("custompagecomponentdrawed", drawedCallBack).one("custompagecomponenterror", errorCallBack);
            this._drawLazzyContent(contentpanel, tabcontent, pPublicIndex);
            return drawedDef;
          } else if (contentDOM.hasClass("nixps-pagebuilder-CustomPageComponent")) {
            return contentDOM.CustomPageComponent("refreshMaintainContext", pForce, pUseOriginalURL);
          }
        }
        return $.Deferred().resolve({});
      } else {
        this._errorHandling("refreshTabIndex", "wrong_index", "The index is wrong");
        return $.Deferred().reject({
          "error_code": "wrong_index",
          "error": "The index is wrong"
        });
      }
    },
    // AI Codex
    /**
     * @description Run a public sub action on the custom page component in a tab
     * @function
     * @name nixps-cloudflow.CloudflowTabs#runSubPageActionOnTabIndex
     * @param {Number} pPublicIndex the public index of the tab
     * @param {String} pID the id of the sub action
     * @param {String} pName the name of the sub action
     * @param {Object} pInputParameters
     * @param {Object} pEvent the event object of the parent function
     * @param {Object} pData the event data
     * @param {Object} pPreviousResults previous results of the previous action
     * @returns {Promise}
     */
    runSubPageActionOnTabIndex: function runSubPageActionOnTabIndex(pPublicIndex, pID, pName, pInputParameters, pEvent, pData, pPreviousResults) {
      if (typeof pPublicIndex !== "number" || pPublicIndex < 0 || pPublicIndex >= this.options.tabs.length) {
        this._errorHandling("runSubPageAction", "wrong_index", "The index is wrong");
        return $.Deferred().reject({
          error_code: "wrong_index",
          error: "The index is wrong"
        });
      }
      if (this._isTabHidden(pPublicIndex) === true || this.options.tabs[pPublicIndex].content === undefined || this.options.tabs[pPublicIndex].content.contentType !== contentType.CUSTOM_PAGE_COMPONENT) {
        this._errorHandling("runSubPageAction", "wrong_content_type", "The tab does not contain a custom page component");
        return $.Deferred().reject({
          error_code: "wrong_content_type",
          error: "The tab does not contain a custom page component"
        });
      }
      var contentDOM = this.element.find("#" + this._calcTabID(pPublicIndex)).children().first();
      if (contentDOM.hasClass("cloudflowtabs_notYetLoadedTab")) {
        var tabcontent = contentDOM.data("tabcontent");
        var contentpanel = contentDOM.parent().empty();
        var drawedDef = $.Deferred();
        var errorCallBack = function errorCallBack(pError) {
          drawedDef.reject(pError);
        };
        contentpanel.one("custompagecomponenterror", errorCallBack);
        this._drawLazzyContent(contentpanel, tabcontent, pPublicIndex, function () {
          contentpanel.off("custompagecomponenterror", errorCallBack);
          drawedDef.resolve({});
        });
        return drawedDef.then(function () {
          return contentpanel.children(".nixps-pagebuilder-CustomPageComponent").CustomPageComponent("runSubPageAction", pID, pName, pInputParameters, pEvent, pData, pPreviousResults);
        });
      }
      if (contentDOM.hasClass("nixps-pagebuilder-CustomPageComponent")) {
        return contentDOM.CustomPageComponent("runSubPageAction", pID, pName, pInputParameters, pEvent, pData, pPreviousResults);
      }
      this._errorHandling("runSubPageAction", "missing_custom_page_component", "The custom page component is not loaded");
      return $.Deferred().reject({
        error_code: "missing_custom_page_component",
        error: "The custom page component is not loaded"
      });
    },
    // IA

    /**
     * @description Disable a specific tab
     * @function
     * @name nixps-cloudflow.CloudflowTabs#disableTabIndex
     * @param {Number} pPublicIndex The tab to be disabled, counting from zero
     */
    disableTabIndex: function disableTabIndex(pPublicIndex) {
      if (typeof pPublicIndex === "number" && pPublicIndex >= 0 && pPublicIndex < this.options.tabs.length) {
        if (this._isTabHidden(pPublicIndex) === true) {
          // ignore hidden tabs
          return true;
        }
        var disabledIndexes = [];
        var disabledOption = this.element.children(".tabs_container").tabs("option", "disabled");
        if (disabledOption === true) {
          // is already disabled
          return true;
        }
        var internalIndex = this._getTabIndex(pPublicIndex);
        if (Array.isArray(disabledOption) && disabledOption.length > 0) {
          var tabIndexIndex = disabledOption.indexOf(internalIndex);
          if (tabIndexIndex >= 0) {
            // is already disabled
            return true;
          }
          disabledIndexes = disabledOption;
        }
        disabledIndexes.push(internalIndex);
        this.element.children(".tabs_container").tabs("option", "disabled", disabledIndexes);
      } else {
        this._errorHandling("disableTabIndex", "invalid_index", "wrong tab index");
      }
      return true;
    },
    /**
     * @description Enable a specific tab
     * @function
     * @name nixps-cloudflow.CloudflowTabs#enableTabIndex
     * @param {Number} pPublicIndex The tab index to reenable, counting from zero
     */
    enableTabIndex: function enableTabIndex(pPublicIndex) {
      if (typeof pPublicIndex === "number" && pPublicIndex >= 0 && pPublicIndex < this.options.tabs.length) {
        if (this._isTabHidden(pPublicIndex) === true) {
          // ignore hidden tabs
          return true;
        }
        var disabledOption = this.element.children(".tabs_container").tabs("option", "disabled");
        if (disabledOption === false) {
          // is already enabled
          return true;
        } else if (disabledOption === true) {
          disabledOption = [];
          var removedTabs = 0;
          for (var i = 0; i < this.options.tabs.length; i++) {
            if (this._isTabHidden(i)) {
              removedTabs++;
              continue;
            }
            disabledOption.push(i - removedTabs);
          }
        }
        if (Array.isArray(disabledOption) && disabledOption.length > 0) {
          var internalIndex = this._getTabIndex(pPublicIndex);
          var tabIndexIndex = disabledOption.indexOf(internalIndex);
          if (tabIndexIndex < 0) {
            // is already enabled
            return true;
          } else {
            disabledOption.splice(tabIndexIndex, 1);
            this.element.children(".tabs_container").tabs("option", "disabled", disabledOption);
          }
        }
      } else {
        this._errorHandling("enableTabIndex", "invalid_index", "wrong tab index");
      }
      return true;
    },
    /**
     * @description Activate a specific tab and if needed enables it
     * @function
     * @name nixps-cloudflow.CloudflowTabs#changeActiveTab
     * @param {Number} pActivePublicIndex the index the tab should be active
     * @param {Boolean} pIsRelative true if the index is relative, jumb one forwards or backwards, false if the index is absolute
     * @since 1.1.0
     * @returns {Object} activate if we could activate a tab or not, and the tabs that has been activated
     */
    changeActiveTab: function changeActiveTab(pActivePublicIndex, pIsRelative) {
      var activePublicIndex = parseInt(pActivePublicIndex);
      if (typeof activePublicIndex === "number" && isNaN(activePublicIndex) === false) {
        if (pIsRelative === true) {
          activePublicIndex = this.options.active + activePublicIndex;
        }
        if (activePublicIndex < 0) {
          // too small
          // do nothing 
          return {
            activated: false,
            tabIndex: null
          };
        } else if (activePublicIndex >= this.options.tabs.length) {
          // too big
          // do nothing 
          return {
            activated: false,
            tabIndex: null
          };
        }
        if (this._isTabHidden(activePublicIndex)) {
          // do nothing
          return {
            activated: false,
            tabIndex: null
          };
        }
        // adapt model
        this.options.active = activePublicIndex;
        // enable the tab
        this.enableTabIndex(this.options.active);
        // active the tab
        this.element.children(".tabs_container").tabs("option", "active", this._getTabIndex(this.options.active));
        return {
          activated: true,
          tabIndex: this.options.active
        };
      } else {
        throw new Error("changeActiveTab: input parameter is not a number");
      }
    },
    /**
     * @description Is the tab hidden or not?
     * @function
     * @private
     * @name nixps-clouflow.CloudflowTabs#_isTabHidden
     * @param {Number} pPublicIndex Public tab index
     */
    _isTabHidden: function _isTabHidden(pPublicIndex) {
      return this.options.tabs[pPublicIndex].show === false;
    },
    /**
     * @description translate the public number to a tab number
     * @function
     * @private
     * @name nixps-clouflow.CloudflowTabs#_getTabIndex
     * @param {Number} pPublicIndex 
     */
    _getTabIndex: function _getTabIndex(pPublicIndex) {
      var internalIndex = 0;
      for (var i = 0; i < pPublicIndex; i++) {
        if (this._isTabHidden(i)) {
          continue;
        }
        internalIndex++;
      }
      return internalIndex;
    },
    /**
     * @description handle the error, show and log and inform others about the error
     * @function
     * @private
     * @name nixps-clouflow.CloudflowTabs#_errorHandling
     * @param {String} pErrorTitle 
     * @param {String} pErrorCode 
     * @param {String} pErrorMessage 
     */
    _errorHandling: function _errorHandling(pErrorTitle, pErrorCode, pErrorMessage) {
      console.error(pErrorTitle, pErrorMessage);
      this._trigger("error", null, {
        "error_code": pErrorCode,
        "error": pErrorMessage
      });
      LogListener.addLog({
        event_type: "error",
        details_data: {
          "error_code": pErrorCode,
          "error": pErrorMessage
        },
        component_name: this.widgetFullName
      }, this.element);
    },
    /**
     * @description function that gets all the values
     * @function
     * @name nixps-clouflow.CloudflowTabs#getValue
     * @returns Object containing all the values
     */
    getValue: function getValue() {
      return {
        active: this.options.active,
        tabs: this.element.children(".tabs_container").children(".tab_content").map(function () {
          if ($(this).children(".nixps-cloudflow-FormRenderer").length > 0) {
            return $(this).children(".nixps-cloudflow-FormRenderer").FormRenderer("getValues");
          } else if ($(this).children(".nixps-pagebuilder-CustomPageComponent").length > 0) {
            return {}; // to be developed
          } else {
            return {};
          }
        }).get()
      };
    },
    /**
     * @description set specific values to the tabs
     * @function
     * @name nixps-clouflow.CloudflowTabs#setValue
     * @param {Object} pValue the values to give
     */
    setValue: function setValue(pValue) {
      if (_typeof(pValue) === "object") {
        for (var publicIndex = 0; publicIndex < pValue.tabs.length; publicIndex++) {
          if (this.options.tabs[publicIndex].content !== undefined) {
            if (this.options.tabs[publicIndex].content.contentType === contentType.STATIC_FORM) {
              this.element.children(".tabs_container").children(".tab_content").eq(this._getTabIndex(publicIndex)).children(".nixps-cloudflow-FormRenderer").FormRenderer("setValues", pValue.tabs[publicIndex]);
            } else if (this.options.tabs[publicIndex].content.contentType === contentType.CUSTOM_PAGE_COMPONENT) {
              // not developed yet
            }
          }
        }
        if (typeof pValue.active === "number" && pValue.active >= 0) {
          this.changeActiveTab(pValue.active);
        }
      }
    },
    /**
     * @description Sets options
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowTabs#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.CloudflowTabs#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "enableStickyHeader" && pValue !== this.options.enableStickyHeader) {
        this._superApply(arguments);
        this.element.children(".tabs_container.ui-tabs").tabs("option", "classes.ui-tabs-nav", pValue ? "cf-sticky-top nixps_styling_constants_bodybackground" : "nixps_styling_constants_bodybackground");
        return false;
      }
      this._superApply(arguments);
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.CloudflowTabs#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.active === "string" && isNaN(parseInt(this.options.active)) === false) {
        this.options.active = parseInt(this.options.active);
      }
      if (typeof this.options.active !== "number") {
        throw new Error("CloudflowTabs: input option must be a number");
      }
      if (this.options.active < 0) {
        this.options.active = 0;
      }
      if (typeof this.options.classes !== "string") {
        throw new Error("CloudflowTabs: input option classes must be a string");
      }
      if (Array.isArray(this.options.tabs) === false) {
        throw new Error("CloudflowTabs: input option tabs must be an array");
      }
      if (typeof this.options.enableStickyHeader !== "boolean") {
        throw new Error("CloudflowTabs: input option enableStickyHeader must be a boolean");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass(this.options.classes).removeClass("CloudflowStyle_" + this.options.style_type);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../pagebuilder/js/inspect/LogListener.js":431}],77:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var CloudflowObject = require("./CloudflowObject.js");
var SpotColorManager = require("../../../colorspace/js/SpotColorManager.js");
var OldConfigurationManager = require("../../../colorspace/js/OldColorspaceConfigurationManager.js");
var QueryUtil = require("../../FolderView/js/QueryUtil.js");
var kAssetTypeDict = Object.freeze({
  "colorspace_configurations": {
    "default_enclosing_folder": "cloudflow://PP_FILE_STORE/Resources/ColorspaceAllResources/Configurations/",
    "resources_enclosing_folder": "/ColorspaceAllResources/Configurations/",
    "mime_type": ["application/vnd.colorlogic-configuration+json"],
    "file_extension": [".zprjcfg"],
    "fields": ["cloudflow", "file_name", "mime_types", "document_name", "save_id", "file_time.modification_utc", "need_metadata", "file_extension"]
  },
  "colorspace_configurations_include_olds": {
    "private": true,
    "default_enclosing_folder": "cloudflow://PP_FILE_STORE/Resources/ColorspaceAllResources/Configurations/",
    "resources_enclosing_folder": "/ColorspaceAllResources/Configurations/",
    "mime_type": ["application/vnd.colorlogic-configuration+json"],
    "file_extension": [".zprjcfg"],
    "fields": ["cloudflow", "file_name", "mime_types", "document_name", "save_id", "file_time.modification_utc", "need_metadata", "file_extension"]
  },
  "colorspace_smartlink": {
    "default_enclosing_folder": "cloudflow://PP_FILE_STORE/Resources/ColorspaceAllResources/SmartLinks/",
    "resources_enclosing_folder": "/ColorspaceAllResources/SmartLinks/",
    "mime_type": ["application/vnd.colorlogic-dlcfg+json", "application/vnd.colorlogic-sicfg+json"],
    // ["application/vnd.colorlogic-dlcfg", "application/vnd.colorlogic-sicfg", "application/vnd.colorlogic-dlcfg+json", "application/vnd.colorlogic-sicfg+json"],
    "file_extension": [".dljcfg", ".sijcfg"],
    //  [".dlcfg", ".sicfg", ".dljcfg", ".sijcfg"]
    "fields": ["cloudflow", "file_name", "mime_types", "save_id", "file_time.modification_utc", "need_metadata", "file_extension"],
    "external_references": {
      "connector": "assetmetadata",
      "collection": "colorspace_configurations",
      "query": ["data.Configuration.Options.SmartLinkMethod", "exists", "and", "(", "data.Configuration.Options.SmartLinkPresetCMYK", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.SmartLinkPresetGRAY", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.SmartLinkPresetMC", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.SmartLinkPresetMC1-3", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.SmartLinkPresetRGB", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.CMYKImage.SmartCMMMethod", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.CMYKVector.SmartCMMMethod", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.GrayImage.SmartCMMMethod", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.GrayVector.SmartCMMMethod", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.RGBImage.SmartCMMMethod", "in", "${nameWithoutExtensionURLs}", "or", "data.Configuration.Options.RGBVector.SmartCMMMethod", "in", "${nameWithoutExtensionURLs}", ")"],
      "fields": ["_id", "cloudflow.file", "data.Configuration.Options"],
      "extract_urls": function extract_urls(pConfig) {
        var names = [];
        ["SmartLinkPresetCMYK", "SmartLinkPresetGRAY", "SmartLinkPresetMC", "SmartLinkPresetMC1-3", "SmartLinkPresetRGB"].forEach(function (pPart) {
          if (typeof pConfig.data.Configuration.Options[pPart] === "string") {
            names.push(pConfig.data.Configuration.Options[pPart]);
          }
        });
        ["CMYKImage", "CMYKVector", "GrayImage", "GrayVector", "RGBImage", "RGBVector"].forEach(function (pSubPart) {
          if (typeof pConfig.data.Configuration.Options[pSubPart]["SmartCMMMethod"] === "string") {
            names.push(pConfig.data.Configuration.Options[pSubPart]["SmartCMMMethod"]);
          }
        });
        return names;
      }
    }
  },
  "colorspace_icc": {
    "default_enclosing_folder": "cloudflow://PP_FILE_STORE/Resources/ColorspaceAllResources/ICC/",
    "resources_enclosing_folder": "/ColorspaceAllResources/ICC/",
    "mime_type": ["application/vnd.iccprofile"],
    "file_extension": [".icc"],
    "fields": ["cloudflow", "file_name", "mime_types", "save_id", "file_time.modification_utc", "need_metadata", "metadata.color_profile.input_cs.colorants", "metadata.color_profile.output_cs.colorants"],
    "get_columns": [{
      "label": "nixps-color-iccprofiles.column_description",
      "name": "data.description.en-gb",
      "data_type": "string"
    }, {
      "label": "nixps-color-iccprofiles.column_colorspace",
      "name": "data.colorSpace",
      "data_type": "string"
    }, {
      "label": "nixps-color-iccprofiles.column_deviceclass",
      "name": "data.deviceClass",
      "data_type": "string"
    }, {
      "label": "nixps-color-iccprofiles.column_coloranttable",
      "name": "data.colorantTable",
      "data_type": "array"
    }],
    "external_references": {
      "connector": "assetmetadata",
      "collection": "colorspace_configurations",
      "query": ["(", "data.Configuration.Options.DocumentColorSpace", "in", "${cloudflowURLs}", ")", "or", "(", "data.Configuration.Options.DstProfile", "in", "${cloudflowURLs}", ")", "or", "(", "data.Configuration.Options.DLProfile", "in", "${cloudflowURLs}", ")", "or", "(", "data.Configuration.Options.CMYKImage.SrcProfile", "in", "${cloudflowURLs}", ")", "or", "(", "data.Configuration.Options.CMYKVector.SrcProfile", "in", "${cloudflowURLs}", ")", "or", "(", "data.Configuration.Options.GrayImage.SrcProfile", "in", "${cloudflowURLs}", ")", "or", "(", "data.Configuration.Options.GrayVector.SrcProfile", "in", "${cloudflowURLs}", ")", "or", "(", "data.Configuration.Options.RGBImage.SrcProfile", "in", "${cloudflowURLs}", ")", "or", "(", "data.Configuration.Options.RGBVector.SrcProfile", "in", "${cloudflowURLs}", ")"],
      "fields": ["_id", "cloudflow.file", "data.Configuration.Options.DocumentColorSpace", "data.Configuration.Options.DstProfile", "data.Configuration.Options.DLProfile"],
      "extract_urls": function extract_urls(pConfig) {
        var configOptions = pConfig.data.Configuration.Options;
        var cloudflowURLs = [];
        ["DocumentColorSpace", "DstProfile", "DLProfile"].forEach(function (pName) {
          if (configOptions && typeof configOptions[pName] === "string" && configOptions[pName].indexOf("cloudflow://") === 0) {
            cloudflowURLs.push(configOptions[pName]);
          }
        });
        ["CMYKImage", "CMYKVector", "GrayImage", "GrayVector", "RGBImage", "RGBVector"].forEach(function (pName) {
          if (configOptions && configOptions[pName] && typeof configOptions[pName]["SrcProfile"] === "string" && configOptions[pName]["SrcProfile"].indexOf("cloudflow://") === 0) {
            cloudflowURLs.push(configOptions[pName]["SrcProfile"]);
          }
        });
        return cloudflowURLs;
      }
    }
  },
  "colorspace_colorbook": {
    "default_enclosing_folder": "cloudflow://PP_FILE_STORE/Resources/ColorspaceAllResources/ColorBooks/",
    "resources_enclosing_folder": "/ColorspaceAllResources/ColorBooks/",
    "mime_type": ["application/vnd.iso-tec130-cxf+xml", "application/vnd.packz-colorbook"],
    "file_extension": [".cxf", ".tcb"],
    "fields": ["cloudflow", "file_name", "mime_types", "save_id", "file_time.modification_utc", "need_metadata"],
    "external_references": {
      "connector": "assetmetadata",
      "collection": "colorspace_configurations",
      "query": ["(", "data.Configuration.Options.PreferedSpotColorsLibs", "in", "${nameWithoutExtensionURLs}", ")", "or", "(", "data.Configuration.Options.PreferedSpotColorsLibs", "in", "${cfresourceURLs}", ")"],
      "fields": ["_id", "cloudflow.file", "data.Configuration.Options.PreferedSpotColorsLibs"],
      "extract_urls": function extract_urls(pConfig) {
        return pConfig.data.Configuration.Options.PreferedSpotColorsLibs.filter(function (c) {
          return !["$SpectralData", "$Alternate"].includes(c);
        });
      }
    },
    "cfresource_prefix": "cfresource://ColorBook/"
  },
  "colorspace_spots": {
    "default_enclosing_folder": "cloudflow://PP_FILE_STORE/Resources/ColorspaceAllResources/Spots/",
    "resources_enclosing_folder": "/ColorspaceAllResources/Spots/",
    "mime_type": ["text/plain"],
    "file_extension": [".txt"],
    "fields": ["cloudflow", "file_name", "mime_types", "save_id", "file_time.modification_utc", "need_metadata"]
  }
});

/**
 * @description A connection object to all specific assets on disc who has a specific type and who has "data" parameter on his metadata
 * @constructor AssetMetadataConnection
 * @param {String} pFiletype The type of file to retrieve
 * @param {String} pEnclosingFolder the folder, the scope of all the files
 */
var AssetMetadataConnection = function AssetMetadataConnection(pFiletype, pEnclosingFolder) {
  this.extra_connection = null;
  this.setFileType(pFiletype);
  this.setEnclosingFolder(pEnclosingFolder);
  this.excludeFieldsFromQuery = function (pQuery) {
    return pQuery;
  };
  if (this.getFileType() === "colorspace_colorbook") {
    this.setExtraConnection(new SpotColorManager("cloudflow://PP_FILE_STORE/Resources/ColorspaceAllResources/Worker/Settings/SpotColors/SpotColorsMgr.txt"));
    this.list_with_options = this._spotlibrary_list_with_options;
    this.count = this._extraconnection_count;
    this.excludeFieldsFromQuery = function (pQuery) {
      if (pQuery.includes("data.location")) {
        if (pQuery[pQuery.indexOf("data.location") + 2] === "external") {
          //this does not exist anymore in the DB!
          return new QueryUtil().removeQuery(pQuery, function (pFieldToCompare) {
            return ["data.location"].includes(pFieldToCompare);
          });
        }
      }
      return pQuery;
    };
  } else if (this.getFileType() === "colorspace_configurations_include_olds") {
    this.setExtraConnection(new OldConfigurationManager());
    this.list_with_options = this._extraconnection_list_with_options;
    this.count = this._extraconnection_count;
  } else {
    this.list_with_options = this._list_with_options;
    this.count = this._count;
  }
};

/**
 * @description Create a AssetMetadataConnection via a JSON object
 * @name AssetMetadataConnection#fromJSON
 * @static
 * @param {Object} pJSON 
 * @returns {AssetMetadataConnection}
 */
AssetMetadataConnection.fromJSON = function (pJSON) {
  return new AssetMetadataConnection(pJSON.file_type, pJSON.enclosing_folder);
};

/**
 * @description Get all the predefiend metadata of a specific file type
 * @name AssetMetadataConnection#getMetadataByFiletype
 * @static
 * @param {String} pFiletype 
 * @returns {Object} all the predefined metadata of a specific asset type
 */
AssetMetadataConnection.getMetadataByFiletype = function (pFiletype) {
  if (typeof pFiletype !== "string" || pFiletype.length <= 0) {
    throw new Error("parameter Filetype must be a not empty string");
  }
  if (kAssetTypeDict[pFiletype] === undefined) {
    throw new Error("unknown Filetype: " + pFiletype);
  }
  return CloudflowObject.merge([{}, kAssetTypeDict[pFiletype]]);
};
AssetMetadataConnection.guessFileType = function (pMimeTypes, pExtension) {
  var candidates = [];
  if (Array.isArray(pMimeTypes) && pMimeTypes.length > 0) {
    for (var i = 0; i < pMimeTypes.length; i++) {
      for (var fileType in kAssetTypeDict) {
        if (kAssetTypeDict[fileType]["private"] === true) {
          continue;
        }
        if (Array.isArray(kAssetTypeDict[fileType].mime_type) && kAssetTypeDict[fileType].mime_type.includes(pMimeTypes[i])) {
          candidates.push(fileType);
        }
      }
    }
    if (candidates.length === 1) {
      return candidates[0];
    }
  }
  if (typeof pExtension === "string" && pExtension.length > 1) {
    for (var fileType in kAssetTypeDict) {
      if (kAssetTypeDict[fileType]["private"] === true) {
        continue;
      }
      if (Array.isArray(kAssetTypeDict[fileType].file_extension) && kAssetTypeDict[fileType].file_extension.includes(pExtension)) {
        return fileType;
      }
    }
  }
  if (candidates.length > 1) {
    console.error("guessFileType: could not determin exact filetype for ", pMimeTypes, pExtension);
  }
  return null;
}, AssetMetadataConnection.prototype = {
  constructor: AssetMetadataConnection,
  setFileType: function setFileType(pFiletype) {
    if (typeof pFiletype !== "string" || pFiletype.length <= 0) {
      throw new Error("Type must be a not emtpy string");
    }
    if (kAssetTypeDict[pFiletype] === undefined) {
      console.error("unknown Filetype: " + pFiletype);
    }
    this.file_type = pFiletype;
  },
  getFileType: function getFileType() {
    return this.file_type;
  },
  setEnclosingFolder: function setEnclosingFolder(pEnclosingFolder) {
    this.enclosing_folder = null;
    if (typeof pEnclosingFolder === "string" && pEnclosingFolder.length > 0) {
      if (pEnclosingFolder.indexOf("/portal.cgi/") === 0) {
        this.enclosing_folder = "cloudflow://" + pEnclosingFolder.substring(11);
      } else {
        this.enclosing_folder = pEnclosingFolder;
      }
    }
  },
  getEnclosingFolder: function getEnclosingFolder() {
    return this.enclosing_folder;
  },
  setExtraConnection: function setExtraConnection(pConnection) {
    this.extra_connection = pConnection;
  },
  _getEnclosingFolder: function _getEnclosingFolder() {
    if (typeof this.enclosing_folder === "string" && this.enclosing_folder.length > 0) {
      return this.enclosing_folder;
    } else {
      if (kAssetTypeDict[this.file_type] === undefined) {
        console.error("unknown assetmetdata type:", this.file_type);
        return "cloudflow://PP_FILE_STORE/";
      }
      if (kAssetTypeDict[this.file_type]["default_enclosing_folder"]) {
        return kAssetTypeDict[this.file_type]["default_enclosing_folder"];
      }
      return "cloudflow://PP_FILE_STORE/";
    }
  },
  _getMimeType: function _getMimeType() {
    if (kAssetTypeDict[this.file_type] === undefined) {
      console.error("unknown assetmetdata type:", this.file_type);
      return null;
    }
    if (Array.isArray(kAssetTypeDict[this.file_type]["mime_type"])) {
      return kAssetTypeDict[this.file_type]["mime_type"].slice(); // clone
    }

    return null;
  },
  _getExtensions: function _getExtensions() {
    if (kAssetTypeDict[this.file_type] === undefined) {
      console.error("unknown assetmetdata type:", this.file_type);
      return null;
    }
    if (Array.isArray(kAssetTypeDict[this.file_type]["file_extension"])) {
      return kAssetTypeDict[this.file_type]["file_extension"].slice(); // clone
    }

    return null;
  },
  _getQuery: function _getQuery() {
    var pQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var query = ["cloudflow.enclosing_folder", "begins with", this._getEnclosingFolder()];
    var mimeType = this._getMimeType();
    if (mimeType !== null) {
      if (Array.isArray(mimeType)) {
        if (mimeType.length === 1) {
          query = query.concat(["and", "mime_types", "equal to", mimeType[0]]);
        } else {
          query = query.concat(["and", "mime_types", "in", mimeType]);
        }
      }
    } else {
      var fileExtensions = this._getExtensions();
      if (Array.isArray(fileExtensions) && fileExtensions.length > 0) {
        query = query.concat(["and", "file_extension", "in", fileExtensions]);
      }
    }
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      query.push("and");
      query.push("(");
      query = query.concat(pQuery);
      query.push(")");
    }
    return query;
  },
  _getFields: function _getFields() {
    var pFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var predefinedFields = [];
    if (kAssetTypeDict[this.file_type] !== undefined && Array.isArray([kAssetTypeDict[this.file_type].fields])) {
      predefinedFields = kAssetTypeDict[this.file_type].fields.slice(); // clone
    }

    var fields;
    if (Array.isArray(pFields) && pFields.length > 0) {
      fields = pFields.slice(); // clone
      // add fields if there are not added already
      predefinedFields.forEach(function (pNeededField) {
        if (!fields.includes(pNeededField)) {
          fields.push(pNeededField);
        }
      });
    } else {
      fields = predefinedFields;
    }
    // if no specific data is asked, ask all blob
    if (!fields.some(function (f) {
      return f.startsWith("data.");
    })) {
      fields.push("data");
    }
    return fields;
  },
  _list_with_options: function _list_with_options(pQuery, pOrderby, pFields, pOptions) {
    return api_defer.asset.list_with_options(this._getQuery(pQuery), pOrderby, this._getFields(pFields), pOptions);
  },
  _extraconnection_list_with_options: function _extraconnection_list_with_options(pQuery, pOrderby, pFields, pOptions) {
    var that = this;
    return Promise.all([this.extra_connection.list_with_options(pQuery, pOrderby, pFields, pOptions), api_defer.asset.list_with_options(this._getQuery(pQuery), pOrderby, this._getFields(pFields), pOptions)]).then(function (pResult) {
      return that.extra_connection.merge(pResult[0].results, pResult[1].results, pQuery, pOrderby, pFields, pOptions);
    });
  },
  _spotlibrary_list_with_options: function _spotlibrary_list_with_options(pQuery, pOrderby, pFields, pOptions) {
    var that = this;
    if (Array.isArray(pQuery)) {
      var index = pQuery.indexOf("data.location");
      if (index >= 0 && pQuery[index + 1] === "equal to" && pQuery[index + 2] !== undefined) {
        if (pQuery[index + 2] === "internal") {
          var newQuery = this.excludeFieldsFromQuery(pQuery);
          return this.extra_connection.list_with_options(newQuery, pOrderby, pFields, pOptions);
        } else if (pQuery[index + 2] === "external") {
          var _newQuery = this.excludeFieldsFromQuery(pQuery);
          return api_defer.asset.list_with_options(this._getQuery(_newQuery), pOrderby, this._getFields(pFields), pOptions).then(function (pResults) {
            //add the location ourselves
            var colorBooks = [];
            if (Array.isArray(pResults.results) && pResults.results.length > 0) {
              colorBooks = pResults.results.map(function (pColorBook) {
                if (pColorBook.data !== undefined) {
                  pColorBook.data.location = "external";
                } else {
                  //??
                }
                return pColorBook;
              });
            }
            return {
              results: colorBooks
            };
          });
        }
      }
    }
    var fixedPagingOptions = {
      count: false,
      first: 0,
      maximum: pOptions.first + pOptions.maximum
    };
    return Promise.all([this.extra_connection.list_with_options(pQuery, pOrderby, pFields, fixedPagingOptions), api_defer.asset.list_with_options(this._getQuery(pQuery), pOrderby, this._getFields(pFields), fixedPagingOptions)]).then(function (pResult) {
      return that.extra_connection.merge(pResult[1].results, pResult[0].results, pQuery, pOrderby, pFields, pOptions);
    });
  },
  list_with_options: function list_with_options() {},
  _count: function _count(pQuery, pOptions) {
    var newQuery = this.excludeFieldsFromQuery(pQuery);
    return api_defer.asset.count(this._getQuery(newQuery), pOptions);
  },
  _extraconnection_count: function _extraconnection_count(pQuery, pOptions) {
    var newQuery = this.excludeFieldsFromQuery(pQuery);
    return Promise.all([this.extra_connection.count(pQuery), api_defer.asset.count(this._getQuery(newQuery), pOptions)]).then(function (pResult) {
      return {
        count: pResult[0].count + pResult[1].count
      };
    });
  },
  count: function count() {},
  "delete": function _delete(pID) {
    return api_defer.list_with_options(["_id", "equal to", pID], [], ["cloudflow.file"], {}).then(function (pResults) {
      if (Array.isArray(pResults.results) && pResults.results.length > 0) {
        return api_defer.file.delete_file(pResults.results[0].cloudflow.file, {
          ignore_missing_file: true
        });
      }
    });
  },
  delete_by_query: function delete_by_query(pQuery) {
    var pOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (pResolve, pReject) {
      api_defer.asset.list_with_options(pQuery, [], ["cloudflow.file"], pOptions).then(function (pResults) {
        if (Array.isArray(pResults.results) && pResults.results.length > 0) {
          Promise.allSettled(pResults.results.map(function (pFile) {
            return api_defer.file.delete_file_with_options(pFile.cloudflow.file, {
              ignore_missing_file: true
            });
          })).then(function (pDeleteResults) {
            //check each to see if it failed?
            pDeleteResults.forEach(function (pResult) {
              if (pResult.status === "rejected") {
                console.error(pResult.reason);
              }
            });
            pResolve({});
          });
        } else {
          //not found??
          pResolve({});
        }
      })["catch"](function (pFail) {
        pReject(pFail);
      });
    });
  },
  getDownloadURL: function getDownloadURL(pID) {
    return "/portal.cgi?asset=download_file&asset_id=" + pID;
  },
  getLinkedAssetsQuery: function getLinkedAssetsQuery(pURLs) {
    // make the query and apply all the url templates
    var query = [];
    var cfresourcesURLDict = {}; // cfresource:// -> cloudflow://
    var nameWithoutExtensionURLDict = {}; // name -> cloudflow://
    var cloudflowURLDict = {}; // cloudflow:// => cloudflow://

    if (kAssetTypeDict[this.file_type]["external_references"] && _typeof(kAssetTypeDict[this.file_type]["external_references"]) === "object") {
      var cfresourcePrefix = kAssetTypeDict[this.file_type]["cfresource_prefix"];
      var externalReferences = kAssetTypeDict[this.file_type]["external_references"];
      for (var i = 0; i < externalReferences.query.length; i++) {
        if (externalReferences.query[i] === "${cfresourceURLs}") {
          if (typeof cfresourcePrefix !== "string" || cfresourcePrefix.length <= 0) {
            throw new Error("missing definition for cfresource prefix");
          }
          query.push(pURLs.map(function (pPath) {
            var cfResourcePath = cfresourcePrefix + pPath.substring(pPath.lastIndexOf("/") + 1);
            cfresourcesURLDict[cfResourcePath] = pPath;
            return cfResourcePath;
          }));
        } else if (externalReferences.query[i] === "${nameWithoutExtensionURLs}") {
          query.push(pURLs.map(function (pPath) {
            var name;
            var dotPossition = pPath.lastIndexOf(".");
            if (dotPossition >= 0) {
              name = pPath.substring(pPath.lastIndexOf("/") + 1, dotPossition);
            } else {
              name = pPath.substring(pPath.lastIndexOf("/") + 1);
            }
            try {
              name = decodeURIComponent(name);
            } catch (e) {}
            nameWithoutExtensionURLDict[name] = pPath;
            return name;
          }));
        } else if (externalReferences.query[i] === "${cloudflowURLs}") {
          pURLs.forEach(function (u) {
            return cloudflowURLDict[u] = u;
          });
          query.push(pURLs.slice());
        } else {
          query.push(externalReferences.query[i]);
        }
      }
    }
    return {
      query: query,
      dict: {
        cfresourcesURLDict: cfresourcesURLDict,
        nameWithoutExtensionURLDict: nameWithoutExtensionURLDict,
        cloudflowURLDict: cloudflowURLDict
      }
    };
  },
  getLinkedAssets: function getLinkedAssets(pURLs) {
    if (!Array.isArray(pURLs)) {
      throw new Error("input parameter must be an array");
    }
    if (pURLs.length <= 0) {
      return Promise.resolve({});
    }
    if (pURLs.some(function (u) {
      return typeof u !== "string" || u.length <= 0;
    })) {
      throw new Error("each item of the url must be a not empty string");
    }
    if (kAssetTypeDict[this.file_type] === undefined) {
      console.error("unknown assetmetdata type:", this.file_type);
      return Promise.reject({
        error_code: "unknown_assetmetadata_type",
        error: "unknown assetmetdata type:" + this.file_type
      });
    }
    // init the output 
    var linkedAssetsDict = {};
    for (var i = 0; i < pURLs.length; i++) {
      linkedAssetsDict[pURLs[i]] = {
        url: pURLs[i],
        linked_assets: []
      };
    }
    if (kAssetTypeDict[this.file_type]["external_references"] && _typeof(kAssetTypeDict[this.file_type]["external_references"]) === "object") {
      // options to search for external references
      var externalReferences = Object.assign({
        connector: undefined,
        collection: undefined,
        query: [],
        fields: []
      }, kAssetTypeDict[this.file_type]["external_references"]);

      // init cfresource urls
      var cfresourcePrefix = kAssetTypeDict[this.file_type]["cfresource_prefix"];
      var cfresourcesURLDict = {}; // cfresource:// -> cloudflow://
      var nameWithoutExtensionURLDict = {}; // name -> cloudflow://
      var cloudflowURLDict = {}; // cloudflow:// => cloudflow://

      // make the connection
      var connection;
      if (externalReferences.connector === "assetmetadata") {
        // use enclosing folder of config and not of linked resource
        var enclosingFolder = undefined;
        var otherEnclosingFolder = this.getEnclosingFolder();
        var enclosingFolderPostFix = kAssetTypeDict[externalReferences.collection].resources_enclosing_folder;
        var colorspaceRootFolderIndex = otherEnclosingFolder.indexOf("/ColorspaceAllResources");
        if (colorspaceRootFolderIndex >= 0) {
          enclosingFolder = otherEnclosingFolder.substring(0, colorspaceRootFolderIndex) + enclosingFolderPostFix;
        }
        connection = new AssetMetadataConnection(externalReferences.collection, enclosingFolder);
      } else {
        throw new Error("unsupported connector " + externalReferences.connector);
      }
      var metadata = this.getLinkedAssetsQuery(pURLs);
      cfresourcesURLDict = metadata.dict.cfresourcesURLDict;
      nameWithoutExtensionURLDict = metadata.dict.nameWithoutExtensionURLDict;
      cloudflowURLDict = metadata.dict.cloudflowURLDict;
      return connection.list_with_options(metadata.query, [], externalReferences.fields, {}).then(function (pResult) {
        if (pResult && Array.isArray(pResult.results) && pResult.results.length > 0) {
          for (var _i = 0; _i < pResult.results.length; _i++) {
            var urls = [];
            if (typeof externalReferences.extract_urls === "function") {
              urls = externalReferences.extract_urls(pResult.results[_i]);
            }
            if (Array.isArray(urls)) {
              for (var u = 0; u < urls.length; u++) {
                if (typeof urls[u] !== "string" || urls[u].length <= 0) {
                  console.error("empty url recieved from extract_url function");
                  continue;
                }
                if (urls[u].indexOf("cfresource://") === 0) {
                  // from ${cfresourceURLs}
                  if (cfresourcesURLDict[urls[u]] === undefined) {
                    // unknown cfresource path (can be totaly normal to recieve too much not matter urls)
                    continue;
                  }
                  urls[u] = cfresourcesURLDict[urls[u]];
                } else if (urls[u].indexOf("cloudflow://") === 0) {
                  // cloudflow urls
                  if (cloudflowURLDict[urls[u]] === undefined) {
                    // unknown url
                    continue;
                  }
                  // is already in good format
                } else if (urls[u].indexOf(".") === -1 && urls[u].indexOf("/") === -1) {
                  // from ${nameWithoutExtensionURLs}
                  if (nameWithoutExtensionURLDict[urls[u]] === undefined) {
                    // unknown name (can be totaly normal to recieve too much not matter urls)
                    continue;
                  }
                  urls[u] = nameWithoutExtensionURLDict[urls[u]];
                }
                linkedAssetsDict[urls[u]].linked_assets.push({
                  url: pResult.results[_i].cloudflow.file,
                  asset_id: pResult.results[_i]._id,
                  assetmetadata_type: externalReferences.collection
                });
              }
            }
          }
        }
        return linkedAssetsDict;
      });
    } else {
      // nothing is defined, assume there are no linked references, for that type
      return Promise.resolve(linkedAssetsDict);
    }
  },
  clone: function clone() {
    return AssetMetadataConnection.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {
      file_type: this.file_type,
      enclosing_folder: this.enclosing_folder
    };
  }
};
module.exports = AssetMetadataConnection;

},{"../../../colorspace/js/OldColorspaceConfigurationManager.js":272,"../../../colorspace/js/SpotColorManager.js":273,"../../FolderView/js/QueryUtil.js":135,"./CloudflowObject.js":79}],78:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var DatabaseConnection = require("../../Table/js/DatabaseConnection.js");
var Query = require("../../Table/js/Query.js");
var WhitepaperCRUD = require("../../Table/js/WhitepaperCRUD.js");
var FileConnection = require("./FileConnection.js");
var AssetMetadataConnection = require("./AssetMetadataConnection.js");
var CloudflowObject = require("./CloudflowObject.js");

/**
 * @constructor CloudflowConnection
 * @description A generic overcapping module that can provide one interface for most CRUD commands to a divercity of datasources.
 * Like files, workflows, mongodb
 * @param {Object} options the object containing all options
 */
function CloudflowConnection(options) {
  this.informError = function () {};
  this.informChange = function () {};
  this.collection;
  // object
  this.data = undefined;
  // file
  this.fileConnection = undefined;
  // mongo
  //   -- nothing --
  // whitepaperCRUD
  this.collectionCRUDconnection = undefined;
  // assetmetadata
  this.assetmetadataConnector = undefined;
  this.callingID = 0;
  this.getcolumnsOptions = undefined;
  // should we protect agains race condition for whitepapers
  // backwads compability is yes, but with the options we can disable
  this.protectRaceConditions = typeof options.protectRaceConditions === "boolean" ? options.protectRaceConditions : true;
  this._init(options);
}
;
CloudflowConnection.fromContext = function (pContext, pOptions) {
  var options = {};
  options = Object.assign(options, pOptions);
  switch (pContext.getConnector()) {
    case "object":
      options.collection = "object";
      options.data = [pContext.getKey()];
      break;
    case "file":
      options.collection = "file";
      options.dataFileURL = pContext.getCollection();
      break;
    case "nucleus":
    case "dataconnector":
      options.collection = pContext.getConnector() + "." + pContext.getCollection();
      break;
    case "httpservice":
      options.collection = "whitepaperHTTPService";
      options.httpserviceWhitepaperName = pContext.getCollection();
      options.httpserviceInputName = pContext.getKey().inputname;
      break;
    case "startFromDBIO":
    case "whitepaper":
      options.collection = "whitepaperCRUD." + pContext.getCollection() + "/" + pContext.getKey().inputname;
      break;
    case "resource":
      options.collection = pContext.getConnector() + "." + pContext.getCollection();
      break;
    case "assetmetadata":
      options.collection = pContext.getConnector() + "." + pContext.getCollection();
      break;
    default:
      options.collection = "nucleus." + pContext.getCollection();
  }
  return new CloudflowConnection(options);
};
CloudflowConnection.prototype = {
  constructor: CloudflowConnection,
  _init: function _init(options) {
    if (typeof options.error_cb === "function") {
      this.informError = options.error_cb;
    }
    if (typeof options.change_cb === "function") {
      this.informChange = options.change_cb;
    }
    if (typeof options.collection !== "string" || options.collection.length <= 0) {
      this._informError("init", {
        "error_code": "init_invalid_collection",
        "error": "collection must be a not empty string"
      });
      return;
    }
    if (options.collection === "object") {
      this.collection = "object";
      this.data = options.data;
      this.list_with_options = this.list_with_options_object;
      this.count = this.count_object;
      this.create = function () {}; // do not create if array is static
      this["delete"] = function () {}; // do not remove if array is static
      this.delete_by_query = function () {}; // do not remove if array is static
      this.update = function () {}; // could not update resource
      this.set_keys = function () {}; // could not update resource
      this.set_keys_by_query = function () {}; // could not update resource
      this.get_download_url = this.get_download_url_object;
    } else if (options.collection === "file") {
      this.collection = "file";
      if (typeof options.dataFileURL !== "string" || options.dataFileURL.length <= 0) {
        this._informError("init", {
          "error_code": "init_empty_url",
          "error": "url option must be not empty"
        });
        this.create = function () {};
        this.list_with_options = function () {};
        this["delete"] = function () {};
        this.delete_by_query = function () {};
        this.update = function () {};
        this.set_keys = function () {};
        this.set_keys_by_query = function () {};
        this.count = function () {};
        this.get_download_url = function () {};
        return;
      }
      this.fileConnection = new FileConnection(options.dataFileURL, options.relativeBasePath, "json");
      this.create = this.create_file;
      this.update = this.update_file;
      this.list_with_options = this.list_with_options_file;
      this.count = this.count_file;
      this["delete"] = this.delete_file;
      this.delete_by_query = this.delete_by_query_file;
      this.set_keys = this.set_keys_file;
      this.set_keys_by_query = this.set_keys_by_query_file;
      this.get_download_url = this.get_download_url_file;
    } else if (options.collection.indexOf("nucleus.") === 0 || options.collection.indexOf("dataconnector.") === 0) {
      // there is a prefix found.
      this.collection = options.collection;
      this.create = this.create_database;
      this.update = this.update_database;
      this.list_with_options = this.list_with_options_database;
      this.count = this.count_database;
      this["delete"] = this.delete_database;
      this.delete_by_query = this.delete_by_query_database;
      this.set_keys = this.set_keys_database;
      this.set_keys_by_query = this.set_keys_by_query_database;
      this.get_download_url = this.get_download_url_database;
    } else if (options.collection.indexOf("whitepaperCRUD.") === 0) {
      this.collection = "whitepaperCRUD";
      var whitepaperDetails = options.collection.substring(15).split("/");
      if (Array.isArray(whitepaperDetails) && whitepaperDetails.length === 2) {
        this.collectionCRUDconnection = new WhitepaperCRUD(whitepaperDetails[0], whitepaperDetails[1], "startFrom");
        this.whitepaperCRUDOptions = {
          whitepaper_name: whitepaperDetails[0],
          input_name: whitepaperDetails[1],
          type: "startFrom"
        };
        this.create = this.create_whitepaperCRUD;
        this.update = this.update_whitepaperCRUD;
        this.list_with_options = this.list_with_options_whitepaperCRUD;
        this.count = this.count_whitepaperCRUD;
        this["delete"] = this.delete_whitepaperCRUD;
        this.delete_by_query = this.delete_by_query_whitepaperCRUD;
        this.set_keys = this.set_keys_whitepaperCRUD;
        this.set_keys_by_query = this.set_keys_by_query_whitepaperCRUD;
        this.get_download_url = this.get_download_url_whitepaperCRUD;
        this.getcolumnsOptions = {
          "whitepaper_name": whitepaperDetails[0],
          "input_name": whitepaperDetails[1]
        };
      } else {
        this._informError("init", {
          "error_code": "invalid_whitepaper_options",
          "error": "invalid whitepaperCRUD input options"
        });
      }
    } else if (options.collection === "whitepaperHTTPService") {
      this.collection = "whitepaperCRUD";
      if (typeof options.httpserviceInputName === "string" && options.httpserviceInputName.length > 0 && typeof options.httpserviceWhitepaperName === "string" && options.httpserviceWhitepaperName.length > 0) {
        this.collectionCRUDconnection = new WhitepaperCRUD(options.httpserviceWhitepaperName, options.httpserviceInputName, "httpService");
        this.whitepaperCRUDOptions = {
          whitepaper_name: options.httpserviceWhitepaperName,
          input_name: options.httpserviceInputName,
          type: "httpService"
        };
        this.create = this.create_whitepaperCRUD;
        this.update = this.update_whitepaperCRUD;
        this.list_with_options = this.list_with_options_whitepaperCRUD;
        this.count = this.count_whitepaperCRUD;
        this["delete"] = this.delete_whitepaperCRUD;
        this.delete_by_query = this.delete_by_query_whitepaperCRUD;
        this.set_keys = this.set_keys_whitepaperCRUD;
        this.set_keys_by_query = this.set_keys_by_query_whitepaperCRUD;
        this.get_download_url = this.get_download_url_whitepaperCRUD;
      } else {
        this._informError("init", {
          "error_code": "invalid_whitepaper_options",
          "error": "invalid whitepaperHTTPService input options"
        });
      }
    } else if (options.collection.indexOf("resource.") === 0) {
      this.collection = options.collection;
      this.create = this.create_resource;
      this.update = this.update_resource;
      this.list_with_options = this.list_with_options_resource;
      this.count = this.count_resource;
      this["delete"] = this.delete_by_query_resource;
      this.delete_by_query = this.delete_by_query_resource;
      this.set_keys = this.set_keys_resource;
      this.set_keys_by_query = this.set_keys_by_query_resource;
      this.get_download_url = this.get_download_url_resource;
    } else if (options.collection.indexOf("assetmetadata.") === 0) {
      this.collection = options.collection;
      this.create = this.create_assetmetadata;
      this.update = this.update_assetmetadata;
      this.list_with_options = this.list_with_options_assetmetadata;
      this.count = this.count_assetmetadata;
      this["delete"] = this.delete_by_query_assetmetadata;
      this.delete_by_query = this.delete_by_query_assetmetadata;
      this.set_keys = this.set_keys_assetmetadata;
      this.set_keys_by_query = this.set_keys_by_query_assetmetadata;
      this.get_download_url = this.get_download_url_assetmetadata;
      this.assetmetadataConnector = new AssetMetadataConnection(options.collection.substring(14), options.assetmetadataEnclosingFolder);
    } else {
      // append prefix if no prefix is defined
      this.collection = "nucleus." + options.collection;
      this.create = this.create_database;
      this.update = this.update_database;
      this.list_with_options = this.list_with_options_database;
      this.count = this.count_database;
      this["delete"] = this.delete_database;
      this.delete_by_query = this.delete_by_query_database;
      this.set_keys = this.set_keys_database;
      this.set_keys_by_query = this.set_keys_by_query_database;
      this.get_download_url = this.get_download_url_database;
    }
  },
  /**
   * @description Get the preparation for the context of one item
   * @function
   * @private
   * @returns partial context JSON object
   */
  getItemContextPreparation: function getItemContextPreparation() {
    if (this.collection === undefined) {
      // an error occured no data could be retrieved
      return null;
    }
    if (this.collection.indexOf("nucleus.") === 0) {
      return {
        "connector": "nucleus",
        "collection": this.collection.substring(8)
      };
    }
    if (this.collection.indexOf("dataconnector.") === 0) {
      return {
        "connector": "dataconnector",
        "collection": this.collection.substring(14)
      };
    }
    switch (this.collection) {
      case "object":
      case "file":
      case "whitepaperCRUD":
      default:
        return {
          "connector": "object",
          "collection": "dummy"
        };
    }
  },
  stop: function stop(pReason) {
    if (this.collectionCRUDconnection !== undefined) {
      this.collectionCRUDconnection.stop(pReason);
    } else if (this.fileConnection !== undefined) {
      this.fileConnection.stop(pReason);
    }
  },
  create: function create() {},
  create_whitepaperCRUD: function create_whitepaperCRUD(pObject) {
    var that = this;
    return $.Deferred(function (pDefer) {
      WhitepaperCRUD.fromJSON(that.whitepaperCRUDOptions).create(pObject, pDefer.resolve, function (pError) {
        that._informError("create", pError);
        pDefer.reject(pError);
      });
    });
  },
  create_database: function create_database(pObject) {
    var that = this;
    return $.Deferred(function (pDefer) {
      DatabaseConnection.create(that.collection, pObject, pDefer.resolve, function (pError) {
        that._informError("create", pError);
        pDefer.reject(pError);
      });
    });
  },
  create_file: function create_file(pObject) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.fileConnection.create(pObject, {}, pDefer.resolve, function (pError) {
        that._informError("create", pError);
        pDefer.reject(pError);
      });
    });
  },
  create_resource: function create_resource(pObject) {
    this._informError("create_resource", {
      error_code: "not_supported",
      error: "creating is not supported"
    });
  },
  create_assetmetadata: function create_assetmetadata(pObject) {
    this._informError("create_assetmetadata", {
      error_code: "not_supported",
      error: "creating is not supported"
    });
  },
  update: function update() {},
  update_whitepaperCRUD: function update_whitepaperCRUD(pObject) {
    var that = this;
    return $.Deferred(function (pDefer) {
      WhitepaperCRUD.fromJSON(that.whitepaperCRUDOptions).update(pObject, pDefer.resolve, function (pError) {
        that._informError("update", pError);
        pDefer.reject(pError);
      });
    });
  },
  update_database: function update_database(pObject) {
    var that = this;
    return $.Deferred(function (pDefer) {
      DatabaseConnection.update(that.collection, pObject, pDefer.resolve, function (pError) {
        that._informError("update", pError);
        pDefer.reject(pError);
      });
    });
  },
  update_file: function update_file(pObject) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.fileConnection.update(pObject, [], pDefer.resolve, function (pError) {
        that._informError("update", pError);
        pDefer.reject(pError);
      });
    });
  },
  update_resource: function update_resource(pObject) {
    this._informError("update_resource", {
      error_code: "not_supported",
      error: "updating is not supported"
    });
  },
  update_assetmetadata: function update_assetmetadata(pObject) {
    this._informError("update_assetmetadata", {
      error_code: "not_supported",
      error: "updating is not supported"
    });
  },
  /**
   * @description List the object content of the collection
   * @function
   * @name CloudflowCollection.list_with_options
   * @returns {Deferred.<Array>} containing object requested by parameters
   * @param {Array} query
   * @param {Array} orderBy
   * @param {Array} fields
   */
  list_with_options: function list_with_options() {},
  list_with_options_object: function list_with_options_object(pQuery, pOrderby, pFields, pSkip, pLimit) {
    if (Array.isArray(this.data) === false) {
      this._informError("list_with_options", {
        "error_code": "invalid_content",
        "error": "data must be an array"
      });
      return;
    }
    return {
      "results": Query.apply(this.data, pQuery, pOrderby, pSkip, pLimit)
    };
  },
  list_with_options_whitepaperCRUD: function list_with_options_whitepaperCRUD(pQuery, pOrderby, pFields, pSkip, pLimit) {
    if (this.protectRaceConditions === true) {
      this.collectionCRUDconnection.stop("start_next_call");
    }
    var that = this;
    var dataProviderDef;
    (function (pCallingID) {
      dataProviderDef = $.Deferred(function (pDefer) {
        that.collectionCRUDconnection.list_with_options(pQuery, pOrderby, pFields, {
          first: pSkip,
          maximum: pLimit
        }, function (pResults) {
          if (that.protectRaceConditions === true && pCallingID < that.callingID) {
            pDefer.reject({
              expected: true,
              error_code: "wrong_callingid",
              result: pResults
            });
          } else {
            pDefer.resolve(pResults);
          }
        }, function (pError, pErrorData) {
          // ignore next errors
          if (pError !== undefined && pError.error === "stop_called") {
            pDefer.reject({
              expected: true,
              error_code: pError.error,
              error_reason: pError.error_reason
            });
            return;
          }
          if (pError === "ajax call failed" && pErrorData !== undefined) {
            pError = pErrorData;
          }
          that._informError("list_with_options", pError);
          pDefer.reject(pError);
        });
      });
    })(++this.callingID);
    return dataProviderDef;
  },
  list_with_options_database: function list_with_options_database(pQuery, pOrderby, pFields, pSkip, pLimit) {
    var that = this;
    return $.Deferred(function (pDefer) {
      DatabaseConnection.list_with_options(that.collection, pQuery, pOrderby, pFields, {
        first: pSkip,
        maximum: pLimit
      }, function (pResults) {
        pDefer.resolve(pResults);
      }, function (pError, pErrorData) {
        if (pError === "ajax call failed" && pErrorData !== undefined) {
          pError = pErrorData;
        }
        that._informError("list_with_options", pError);
        pDefer.reject(pError);
      });
    });
  },
  list_with_options_file: function list_with_options_file(pQuery, pOrderby, pFields, pSkip, pLimit) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.fileConnection.list_with_options(pQuery, pOrderby, pFields, {
        first: pSkip,
        maximum: pLimit
      }, pDefer.resolve, function (pError) {
        that._informError("list_with_options", pError);
        pDefer.reject(pError);
      });
    });
  },
  list_with_options_resource: function list_with_options_resource(pQuery, pOrderby, pFields, pSkip, pLimit, pCount) {
    /** @todo to be tested */
    var type = this.collection.substring(9);
    return $.Deferred(function (pDefer) {
      api_async.resource.enumerate(type, function (pResults) {
        if (pResults && Array.isArray(pResults.resource_locators)) {
          var rows = Query.apply(pResults.resource_locators, pQuery, pOrderby, pSkip, pLimit);
          var output = {
            results: rows
          };
          if (pCount === true) {
            output.count = rows.length;
          }
          pDefer.resolve(output);
        } else {
          pDefer.reject({
            error_code: "invalid_return_interface"
          });
        }
      }, pDefer.reject);
    });
  },
  list_with_options_assetmetadata: function list_with_options_assetmetadata(pQuery, pOrderby, pFields, pSkip, pLimit, pCount) {
    var that = this;
    return this.assetmetadataConnector.list_with_options(pQuery, pOrderby, pFields, {
      first: pSkip,
      maximum: pLimit,
      count: pCount
    })["catch"](function (pError) {
      that._informError("list_with_options", pError);
      return $.Deferred().reject(pError);
    });
  },
  count: function count(pQuery, pOptions) {},
  count_object: function count_object(pQuery, pOptions) {},
  count_whitepaperCRUD: function count_whitepaperCRUD(pQuery, pOptions) {},
  count_database: function count_database(pQuery, pOptions) {},
  count_file: function count_file(pQuery, pOptions) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.fileConnection.count(pQuery, pDefer.resolve, function (pError) {
        that._informError("count", pError);
        pDefer.reject(pError);
      });
    });
  },
  count_resource: function count_resource(pQuery, pOptions) {
    var that = this;
    var type = this.collection.substring(9);
    return api_defer.resource.enumerate(type).then(function (pResults) {
      if (pResults && Array.isArray(pResults.resource_locators)) {
        return {
          count: Query.apply(pResults.resource_locators, pQuery, []).length
        };
      } else {
        return Promise.reject({
          error_code: "invalid_return_interface"
        });
      }
    }, function (pError) {
      that._informError("count", pError);
      return $.Deferred().reject(pError);
    });
  },
  count_assetmetadata: function count_assetmetadata(pQuery, pOptions) {
    var that = this;
    return this.assetmetadataConnector.count(pQuery, pOptions)["catch"](function (pError) {
      that._informError("count", pError);
      return $.Deferred().reject(pError);
    });
  },
  get_download_url: function get_download_url(pID) {},
  get_download_url_object: function get_download_url_object(pID) {
    this._informError("get_download_url", {
      error_code: "not_supported",
      error: "downloading is not supported"
    });
  },
  get_download_url_whitepaperCRUD: function get_download_url_whitepaperCRUD(pID) {
    this._informError("get_download_url", {
      error_code: "not_supported",
      error: "downloading is not supported"
    });
  },
  get_download_url_database: function get_download_url_database(pID) {
    if (this.collection.indexOf("nucleus.") === 0) {
      return "/portal.cgi?" + this.collection.substring(8) + "=download&id=" + pID;
    } else {
      this._informError("get_download_url", {
        error_code: "not_supported",
        error: "downloading is not supported"
      });
    }
  },
  get_download_url_file: function get_download_url_file(pID) {
    this._informError("get_download_url", {
      error_code: "not_supported",
      error: "downloading is not supported"
    });
  },
  get_download_url_resource: function get_download_url_resource(pID) {
    var type = this.collection.substring(9);
    this._informError("get_download_url_resource", {
      error_code: "not_supported",
      error: "downloading is not supported"
    });
  },
  get_download_url_metadata: function get_download_url_metadata(pID) {
    return this.assetmetadataConnector.getDownloadURL(pID);
  },
  /**
   * @description function to set specific keys of objects
   * @function
   * @name CloudflowConnection.set_keys
   * @param {String} pID the id of the object
   * @param {Object} pKeyData the keys object that must be used to overwrite
   */
  set_keys: function set_keys(pID, pKeyData, pOptions) {},
  set_keys_whitepaperCRUD: function set_keys_whitepaperCRUD(pID, pKeyData, pOptions) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.collectionCRUDconnection.set_keys(pID, pKeyData, pOptions, pDefer.resolve, function (pError, pErrorData) {
        that._informError("set_keys_by", pError);
        pDefer.reject(pError);
      });
    });
  },
  set_keys_database: function set_keys_database(pID, pKeyData, pOptions) {
    var that = this;
    return $.Deferred(function (pDefer) {
      DatabaseConnection.set_keys(that.collection, pID, pKeyData, pDefer.resolve, function (pError) {
        that._informError("set_keys", pError);
        pDefer.reject(pError);
      });
    });
  },
  set_keys_file: function set_keys_file(pID, pKeyData, pOptions) {
    var that = this;
    return $.Deferred(function (pDefer) {
      if (pOptions !== undefined && typeof pOptions.keyUniqID === "string" && pOptions.keyUniqID.length > 0) {
        that.set_keys_by_query_file([pOptions.keyUniqID, "equal to", pID], pKeyData, {}).done(pDefer.resolve).fail(function (pError) {
          that._informError("set_keys", pError);
          pDefer.reject(pError);
        });
      } else {
        that.fileConnection.set_keys(pID, pKeyData, pDefer.resolve, function (pError) {
          that._informError("set_keys", pError);
          pDefer.reject(pError);
        });
      }
    });
  },
  set_keys_resource: function set_keys_resource(pID, pKeyData, pOptions) {
    this._informError("set_keys_resource", {
      error_code: "not_supported",
      error: "set_keys is not supported"
    });
  },
  set_keys_assetmetadata: function set_keys_assetmetadata(pID, pKeyData, pOptions) {
    this._informError("set_keys_resource", {
      error_code: "not_supported",
      error: "set_keys is not supported"
    });
  },
  /**
   * @description function to set specific keys of objects
   * @function
   * @name CloudflowConnection.set_keys_by_query
   * @param {Array} pQuery the filter to specify which objects we must change
   * @param {Object} pKeyData the keys object that must be used to overwrite
   * @param {Object} pOptions the options of the api call set_keys_by_query
   */
  set_keys_by_query: function set_keys_by_query(pQuery, pKeyData, pOptions) {},
  set_keys_by_query_whitepaperCRUD: function set_keys_by_query_whitepaperCRUD(pQuery, pKeyData, pOptions) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.collectionCRUDconnection.set_keys_by_query(pQuery, pKeyData, pOptions, pDefer.resolve, function (pError, pErrorData) {
        if (pError === "ajax call failed" && pErrorData !== undefined) {
          pError = pErrorData;
        }
        that._informError("set_keys_by_query", pError);
        pDefer.reject(pError);
      });
    });
  },
  set_keys_by_query_database: function set_keys_by_query_database(pQuery, pKeyData, pOptions) {
    var that = this;
    return $.Deferred(function (pDefer) {
      DatabaseConnection.set_keys_by_query(that.collection, pQuery, pKeyData, pOptions, function (pResults) {
        pDefer.resolve(pResults);
      }, function (pError, pErrorData) {
        if (pError === "ajax call failed" && pErrorData !== undefined) {
          pError = pErrorData;
        }
        that._informError("set_keys_by_query", pError);
        pDefer.reject(pError);
      });
    });
  },
  set_keys_by_query_file: function set_keys_by_query_file(pQuery, pKeyData, pOptions) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.fileConnection.set_keys_by_query(pQuery, pKeyData, pOptions, pDefer.resolve, function (pError) {
        that._informError("set_keys_by_query", pError);
        pDefer.reject(pError);
      });
    });
  },
  set_keys_by_query_resource: function set_keys_by_query_resource(pQuery, pKeyData, pOptions) {
    this._informError("set_keys_by_query_resource", {
      error_code: "not_supported",
      error: "set_keys is not supported"
    });
  },
  set_keys_by_query_assetmetadata: function set_keys_by_query_assetmetadata(pQuery, pKeyData, pOptions) {
    this._informError("set_keys_by_query_assetmetadata", {
      error_code: "not_supported",
      error: "set_keys is not supported"
    });
  },
  "delete": function _delete() {},
  delete_whitepaperCRUD: function delete_whitepaperCRUD(pID) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.collectionCRUDconnection["delete"](pID, pDefer.resolve, function (pError, pErrorData) {
        if (pError === "ajax call failed" && pErrorData !== undefined) {
          pError = pErrorData;
        }
        that._informError("delete", pError);
        pDefer.reject(pError);
      });
    });
  },
  delete_database: function delete_database(pQuery) {
    var that = this;
    return $.Deferred(function (pDefer) {
      DatabaseConnection["delete"](that.collection, pQuery, {}, pDefer.resolve, function (pError, pErrorData) {
        if (pError === "ajax call failed" && pErrorData !== undefined) {
          pError = pErrorData;
        }
        that._informError("delete", pError);
        pDefer.reject(pError);
      });
    });
  },
  delete_file: function delete_file(pID) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.fileConnection["delete"](pID, pDefer.resolve, function (pError) {
        that._informError("delete", pError);
        pDefer.reject(pError);
      });
    });
  },
  delete_resource: function delete_resource(pID) {
    if (typeof pID !== "string") {
      throw new Error("pID must be a string");
    }
    var that = this;
    if (pID.indexOf("cfresource://") === 0 || pID.indexOf("cloudflow://") === 0) {
      return api_defer.file.delete_file(pID)["catch"](function (pError) {
        that._informError("delete", pError);
        return $.Deferred().reject(pError);
      });
    } else {
      this._informError("delete_resource", {
        error_code: "not_supported",
        error: "delete is not supported"
      });
    }
  },
  delete_assetmetadata: function delete_assetmetadata(pID) {
    var that = this;
    return this.assetmetadataConnector["delete"](pID)["catch"](function (pError) {
      that._informError("delete", pError);
      return $.Deferred().reject(pError);
    });
  },
  delete_by_query: function delete_by_query() {},
  delete_by_query_whitepaperCRUD: function delete_by_query_whitepaperCRUD(pQuery) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.collectionCRUDconnection.delete_by_query(pQuery, pDefer.resolve, function (pError, pErrorData) {
        if (pError === "ajax call failed" && pErrorData !== undefined) {
          pError = pErrorData;
        }
        that._informError("delete_by_query", pError);
        pDefer.reject(pError);
      });
    });
  },
  delete_by_query_database: function delete_by_query_database(pQuery) {
    var that = this;
    return $.Deferred(function (pDefer) {
      DatabaseConnection.delete_by_query(that.collection, pQuery, {}, function (pResults) {
        pDefer.resolve(pResults);
      }, function (pError, pErrorData) {
        if (pError === "ajax call failed" && pErrorData !== undefined) {
          pError = pErrorData;
        }
        that._informError("delete_by_query", pError);
        pDefer.reject(pError);
      });
    });
  },
  delete_by_query_file: function delete_by_query_file(pQuery) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.fileConnection.delete_by_query(pQuery, pDefer.resolve, function (pError) {
        that._informError("delete_by_query", pError);
        pDefer.reject(pError);
      });
    });
  },
  delete_by_query_resource: function delete_by_query_resource(pQuery) {
    // this._informError("delete_by_query_resource", {error_code: "not_supported", error: "delete is not supported"});
    var that = this;
    return api_defer.asset.list_with_options(pQuery, [], ["_id"]).then(function (pResults) {
      if (pResults && Array.isArray(pResults.results)) {
        return Promise.allSettled(pResults.results.map(function (pFile) {
          return api_defer.asset["delete"](pFile._id);
        }));
      }
    })["catch"](function (pError) {
      that._informError("delete_by_query", pError);
      return $.Deferred().reject(pError);
    });
  },
  delete_by_query_assetmetadata: function delete_by_query_assetmetadata(pQuery, pOptions) {
    var that = this;
    return this.assetmetadataConnector.delete_by_query(pQuery, pOptions)["catch"](function (pError) {
      that._informError("delete_by_query", pError);
      return $.Deferred().reject(pError);
    });
  },
  /**
   * @description get all fields of the collection
   * @function
   * @name CloudflowConnection.get_columns
   * @returns {Promise.<Array>} The fields array
   */
  get_columns: function get_columns(pQuery) {
    if (!Array.isArray(pQuery)) {
      pQuery = [];
    }
    var that = this;
    if (this.getcolumnsOptions !== undefined) {
      var getColumns = new Promise(function (pResolve, pReject) {
        api_async.database_proxy.get_columns(that.getcolumnsOptions, {}, function (pResults) {
          if (Array.isArray(pResults.columns) && pResults.columns.length > 0) {
            var fields = [];
            for (var i = 0; i < pResults.columns.length && i < 200; i++) {
              var column = pResults.columns[i];
              if (typeof column.name !== "string" || column.name.length <= 0) {
                continue;
              }
              column.data_type = column.data_type || "string";
              column.data_type = column.data_type.toLowerCase();
              fields.push(column);
            }
            if (fields.length === 0) {
              pReject({
                error_code: "no_valid_columns_found",
                error: "could not retrieve valid columns"
              });
            } else {
              pResolve({
                columns: fields,
                direct: true
              });
            }
          } else {
            pReject({
              error_code: "no_columns_found",
              error: "no columns"
            });
          }
        }, function (pError) {
          pReject(pError);
        });
      });
      return getColumns.then(function (arg) {
        return arg;
      }, function (pError) {
        // error occured try to find it by sniffing of the listing
        that.getcolumnsOptions = undefined;
        return that.get_columns(pQuery);
      });
    }
    return new Promise(function (pResolve, pReject) {
      var query = pQuery;
      var orderBy = [];
      var staticColumns = [];
      // try to recover the latest or more recent items of the collection
      // do we have a _id field in the collection ?
      if (typeof that.collection === "string") {
        if (that.collection.indexOf("nucleus.") === 0) {
          orderBy = ["_id", "descending"];
        } else if (that.collection.indexOf("assetmetadata.") === 0) {
          orderBy = ["_id", "descending"];
          var metadata = AssetMetadataConnection.getMetadataByFiletype(that.collection.substring(14));
          if (metadata && Array.isArray(metadata.get_columns)) {
            staticColumns = metadata.get_columns;
          }
        }
      }
      Promise.resolve(that.list_with_options(query, orderBy, [], 0, 300)).then(function (pResults) {
        if (pResults !== undefined && Array.isArray(pResults.results)) {
          if (pResults.results.length > 0) {
            var list = pResults.results.slice();
            // make example object
            var modelObject = structuredClone(pResults.results[0]);
            for (var i = 1; i < pResults.results.length; i++) {
              modelObject = $.extend(true, modelObject, pResults.results[i]);
            }
            // retrieve fields
            var columns = that.translateObjectToFields("", modelObject);
            pResolve({
              columns: columns,
              direct: false,
              list: list
            });
          } else if (pResults.results.length === 0 && query.length > 0) {
            // retry without query
            that.get_columns([]).then(pResolve, pReject);
          } else {
            pResolve({
              columns: staticColumns,
              direct: false,
              list: []
            });
          }
        } else {
          pResolve({
            columns: staticColumns,
            direct: false,
            error: {
              error_code: "wrong_return_interface"
            }
          });
        }
      }, function (pError) {
        that._informError("get_columns", pError);
        pResolve({
          columns: staticColumns,
          direct: false,
          error: pError
        });
      });
    });
  },
  /**
   * @description translate a complete object to an array of fields
   * @function
   * @name CloudflowConnection.translateObjectToFields
   * @param {Object} preFix The prefix, use empty string
   * @param {Object} pObject The object to be translated
   * @returns {Array} fields array
   */
  translateObjectToFields: function translateObjectToFields(preFix, pObject) {
    var fields = [],
      type,
      fieldsIDsDict = {};
    var keys = Object.keys(pObject);
    for (var i = 0; i < keys.length && i < 200; i++) {
      type = this._getType(pObject[keys[i]]);
      if (type === "object") {
        var subFields = this.translateObjectToFields(preFix + keys[i] + ".", pObject[keys[i]]);
        fields = fields.concat(subFields);
        continue;
      } /*else if (type === "array" && pObject[keys[i]].length > 0) {
          var subFields = this.translateObjectToFields(preFix + keys[i] + ".0.", pObject[keys[i]][0]);
          fields = fields.concat(subFields);
          continue;
        }*/
      var keyField = preFix + keys[i];
      if (fieldsIDsDict[keyField] === undefined) {
        fieldsIDsDict[keyField] = 1;
        fields.push({
          "name": keyField,
          "data_type": type
        });
      }
    }
    return fields;
  },
  _informError: function _informError(pMain, pError) {
    console.error(pMain, pError);
    this.informError(pMain, pError);
  },
  _getType: function _getType(pItem) {
    if (Array.isArray(pItem)) {
      return "array";
    }
    if (typeof pItem === "string") {
      return "string";
    }
    if (typeof pItem === "number") {
      return "number";
    }
    if (typeof pItem === "boolean") {
      return "boolean";
    }
    if (pItem === undefined || pItem === null || _typeof(pItem) === "object" && Object.keys(pItem).length === 0) {
      return "null";
    }
    if (_typeof(pItem) === "object" && pItem.constructor && pItem.constructor.name === "Object") {
      return "object";
    }
    if (typeof pItem === "bigint") {
      return "bigint";
    }
  }
};

/**
 * @description Checkes if a user is allowed to delete items from a specific collection
 * @function
 * @name CloudflowConnection.isAllowedToDelete
 * @static
 * @param {String} pCollection About which collaction?
 * @param {User} pUser The user object
 * @returns {Boolean} true if the user is allowed to delete, false otherwise
 */
CloudflowConnection.isAllowedToDelete = function (pCollection, pUser) {
  // "MANAGE_SHARE", "MANAGE_CHAINS"
  switch (pCollection) {
    case "nucleus.job":
    case "nucleus.project":
    case "nucleus.calendar":
    case "nucleus.task_list":
      return pUser.hasPermission("MANAGE_JOBS");
    case "object":
      // we can technically not delete static copied data
      console.error("trying to delete elements of a static array");
      return false;
    case "nucleus.users":
      return pUser.hasPermission("MANAGE_USERS");
    case "nucleus.files":
    case "nucleus.folders":
      return pUser.hasPermission("MANAGE_ASSETS");
    case "nucleus.template":
    case "nucleus.templates":
      return pUser.hasPermission("MANAGE_TEMPLATES");
    case "nucleus.scopes":
      return pUser.hasPermission("MANAGE_SCOPES");
    case "nucleus.whitepapers":
    case "nucleus.data":
      return pUser.hasPermission("MANAGE_WHITEPAPERS");
    default:
      return pUser.hasPermission("ADMIN_USER");
  }
};

/**
 * @description Checkes if a user is allowed to update items from a specific collection
 * @function
 * @name CloudflowConnection.isAllowedToUpdate
 * @static
 * @param {String} pCollection About which collaction?
 * @param {User} pUser The user object
 * @returns {Boolean} true if the user is allowed to delete, false otherwise
 */
CloudflowConnection.isAllowedToUpdate = function (pCollection, pUser) {
  return CloudflowConnection.isAllowedToDelete(pCollection, pUser);
};

/**
 * @description Retrieve the appropriated translated delete confirmation messages
 * @function
 * @static
 * @name CloudflowConnection.getDeleteConfimationTitles
 * @param {String} pCollection from with collection
 * @param {Array.<Object>} pRowObjects The objects who will be deleted
 * @param {String} pCustomTitle text for tht title
 * @param {String} pCustomMessage The text for the message
 * @param {String} pCustomRowObjectParameter Extra string as appendix for translations
 * @returns {Object} containing two string parameters, the title and the message
 */
CloudflowConnection.getDeleteConfimationTitles = function (pCollection, pRowObjects, pCustomTitle, pCustomMessage, pCustomRowObjectParameter) {
  // defaults
  var title = $.i18n._("nixps-cloudflow-manage.generic-delete");
  var message = $.i18n._("nixps-cloudflow-manage.generic-areyousure");
  // add default comparing to collection
  switch (pCollection) {
    case "nucleus.job":
    case "nucleus.project":
      title = $.i18n._("nixps-cloudflow-manageprojects.delete_title");
      message = $.i18n._("nixps-cloudflow-manageprojects.delete_confirmation_text", [pRowObjects[0].name]);
      break;
    case "nucleus.users":
      title = $.i18n._("nixps-cloudflow-manage.generic-areyousure");
      message = $.i18n._("nixps-cloudflow-manage.users-remove-message");
      break;
    case "object":
      // we can technically not delete static copied data
      console.error("trying to delete elements of a static array");
      return {
        "title": "** error **",
        "message": "Removing not possible"
      };
    case "nucleus.scopes":
      title = $.i18n._("nixps-cloudflow-manage.generic-areyousure");
      message = $.i18n._("nixps-cloudflow-manage.scopes-remove-message");
      break;
    case "nucleus.team":
      title = $.i18n._("nixps-team-dashboard.delete-team");
      message = $.i18n._("nixps-team-dashboard.delete-team-message", [pRowObjects[0].name]);
      break;
    case "nucleus.form":
      title = $.i18n._("nixps-cloudflow-formmanager.removemessage_title");
      message = $.i18n._("nixps-cloudflow-formmanager.removemessage_content", [pRowObjects[0].name]);
      break;
    case "nucleus.template":
      title = $.i18n._("nixps-cloudflow-manage.removedialog_title");
      message = $.i18n._("nixps-cloudflow-manage.removedialog_message", [pRowObjects[0].name]);
      break;
  }
  // overwrite if specified
  if (typeof pCustomTitle === "string" && pCustomTitle.length > 0) {
    title = $.i18n._(pCustomTitle);
  }
  if (Array.isArray(pRowObjects) && pRowObjects.length > 1) {
    message = $.i18n._("nixps-cloudflow-manage.removemultipledialog_message", [pRowObjects.length]);
  } else {
    if (typeof pCustomMessage === "string" && pCustomMessage.length > 0) {
      if (typeof pCustomRowObjectParameter === "string" && pCustomRowObjectParameter.length > 0) {
        message = $.i18n._(pCustomMessage, [CloudflowObject.getParameter(pRowObjects[0], pCustomRowObjectParameter)]);
      } else {
        message = $.i18n._(pCustomMessage);
      }
    }
  }
  return {
    "title": title,
    "message": message
  };
};
module.exports = CloudflowConnection;

},{"../../Table/js/DatabaseConnection.js":209,"../../Table/js/Query.js":211,"../../Table/js/WhitepaperCRUD.js":213,"./AssetMetadataConnection.js":77,"./CloudflowObject.js":79,"./FileConnection.js":86}],79:[function(require,module,exports){
"use strict";

/**
 * @constructor CloudflowObject
 * @description Some hulp functions to handle with objects. <br />
 * To use this object you need to require it, when browserify 
 * @static
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var CloudflowObject = function CloudflowObject() {};

/**
 * @description Get the value of in the object tree, given an path with dot notation
 * @function
 * @name CloudflowObject.getParameter
 * @param {Object} pObject the object tree where to search
 * @param {String} pField The path with dot notation
 * @return {object} The value situated ot that possition or undefined if not found
 */
CloudflowObject.getParameter = function (pObject, pField) {
  if (Array.isArray(pObject) && parseInt(pField) > -1) {
    // skip if parameters is valid array
  } else if (_typeof(pObject) !== "object" || pObject === null || CloudflowObject.isEmptyObject(pObject) && pField !== ".") {
    return undefined;
  }
  if (typeof pField !== "string" || pField.length <= 0) {
    return pObject;
  }
  var objectPath = pField.split(".");
  var last = pObject;
  for (var i = 0; i < objectPath.length; i++) {
    // control if subkey is string, if two points are placed the split retuns a empty string, remove those cases
    if (typeof objectPath[i] === "string" && objectPath[i].length > 0) {
      if (last === null || last[objectPath[i]] === undefined || ["number", "boolean", "bigint"].includes(_typeof(last)) || typeof last === "string" && isNaN(+objectPath[i])) {
        // prevent errors, just stop loop
        return undefined;
      } else {
        last = last[objectPath[i]];
      }
    }
    // in other cases do nothing, ingore the error case 
  }

  return last;
};

/**
 * @description Change a parameter in the object tree, given a path "pField" with dot notation
 * @function
 * @name CloudflowObject.setParameter
 * @param {Object} pObject
 * @param {String} pField path with dot notation
 * @param {Mixed} pNewValue the new value for that parameter
 * @return {Object} The updated object
 */
CloudflowObject.setParameter = function (pObject, pField, pNewValue) {
  if (typeof pField !== "string" || pField.length <= 0) {
    // if field unknown, make newvalue the new object
    return pNewValue;
  }
  var subKeys = pField.split(".");
  if (!Array.isArray(subKeys)) {
    throw new Error("could not parse key of object " + pField);
  }
  var subObject = pObject;
  for (var i = 0; i < subKeys.length - 1; i++) {
    // control if subkey is string, if two points are placed the split retuns a empty string, remove those cases
    if (typeof subKeys[i] === "string" && subKeys[i].length > 0) {
      // prevent errors, make array or object
      if (subObject[subKeys[i]] === undefined) {
        // to control if input is a real number and not a number concat with string parse it to number
        // and do a weak compare with the real string, than we are sur to have a real number
        if (parseInt(subKeys[i + 1]) == subKeys[i + 1]) {
          // subkey is number use a array
          // make it for at least the index can fit
          subObject[subKeys[i]] = new Array(parseInt(subKeys[i + 1]) + 1);
        } else {
          subObject[subKeys[i]] = {};
        }
      }
      // container exsists or is just made
      subObject = subObject[subKeys[i]];
    }
    // in other cases do nothing, ingore the error case 
  }

  subObject[subKeys[subKeys.length - 1]] = pNewValue;
  return pObject;
};

/**
 * @description Deletes a field from an object given a path
 * @function
 * @name CloudflowObject.deleteParameter
 * @param {Object} pObject
 * @param {String} pField path with dot notation
 * @return {Object} The updated object
 */
CloudflowObject.deleteParameter = function (pObject, pField) {
  if (Array.isArray(pObject) && parseInt(pField) > -1) {
    // skip if parameters is valid array
  } else if (_typeof(pObject) !== "object" || pObject === null || CloudflowObject.isEmptyObject(pObject)) {
    return pObject;
  }
  if (typeof pField !== "string" || pField.length <= 0) {
    return pObject;
  }
  var objectPath = pField.split(".");
  var last = pObject;
  // Loop till one before the last part
  for (var i = 0; i < objectPath.length - 1; i++) {
    // control if subkey is string, if two points are placed the split retuns a empty string, remove those cases
    if (typeof objectPath[i] === "string" && objectPath[i].length > 0) {
      if (last === null || last[objectPath[i]] === undefined || ["number", "boolean", "bigint"].includes(_typeof(last))) {
        // prevent errors, just stop loop
        return pObject;
      } else {
        last = last[objectPath[i]];
      }
    }
    // in other cases do nothing, ingore the error case 
  }

  // Delete the last part
  if (Array.isArray(last)) {
    // use splice so length and other indexes are updated
    last.splice(objectPath[objectPath.length - 1], 1);
  } else {
    delete last[objectPath[objectPath.length - 1]];
  }
  return pObject;
};

/**
 * @description Replace value of JSON object
 * @function
 * @name CloudflowObject.travers
 * @param {Object} pObject
 * @param {Function} pReplaceFunction function that is called for each string value, with parameters ("value, "key")
 * @return {Object} The updated object 
 */

CloudflowObject.travers = function (pObject, replaceFunction, pParentKeyPath, pParents) {
  if (pParentKeyPath === undefined) {
    pParentKeyPath = "";
  } else {
    pParentKeyPath += ".";
  }
  if (pParents === undefined) {
    pParents = new Set();
  }
  var child,
    replacement,
    newParents = null;
  for (var key in pObject) {
    child = pObject[key];
    // if element is a array or object go insite it.
    if (child && _typeof(child) === "object") {
      if (child === pObject) {
        continue;
      }
      if (pParents.has(child)) {
        continue;
      }
      if (newParents === null) {
        newParents = new Set(pParents);
        newParents.add(pObject);
      }
      CloudflowObject.travers(child, replaceFunction, pParentKeyPath + key, newParents);
      // if element is a string replace variables    
    } else if (typeof child === "string") {
      replacement = replaceFunction(child, pParentKeyPath + key);
      if (pObject[key] !== replacement) {
        // seems silly, but to prevent erroring while assigning same value on frooze objects
        pObject[key] = replacement;
      }
    }
    // if no array/object or string
    // this can be a number, boolean of function
    // on this moment do nothing
  }
  ;
  return pObject;
};
function contains(pParentKeyPath, pObject, pCallBack) {
  var found = false;
  if (pParentKeyPath.length > 0) {
    pParentKeyPath += ".";
  }
  var child, ret;
  for (var key in pObject) {
    child = pObject[key];
    ret = pCallBack(pParentKeyPath + key, child);
    if (ret === true) {
      found = true;
      break;
    } else if (ret === null) {
      continue;
    }
    // if element is a array or object go insite it.
    if (child && _typeof(child) === "object" || Array.isArray(child)) {
      ret = contains(pParentKeyPath + key, child, pCallBack);
      if (ret === true) {
        found = true;
        break;
      } else if (ret === null) {
        continue;
      }
    }
  }
  ;
  return found;
}
;

/**
 * @description Checks if a specific key or value is present in the object
 * @function
 * @name CloudflowObject.contains
 * @param {Object} pObject The object to travers
 * @param {Function} pCallBack The evaluatie itinerate function with parameters key and value, return true if you found it, return null to stop the current run path
 * @example CloudflowObject.contains( {a:"car"}, function(k,v){ return k === "a"; }) 
 * @returns Boolean true if the callback function returns true, false if no return fals has been found      
 */
CloudflowObject.contains = function (pObject, pCallBack) {
  return contains("", pObject, pCallBack);
};

/**
 * @description Get a single difference object from A to B containing all the added and change values and all the deleted keys
 * @function
 * @name CloudflowObject.difference
 * @param {Object} pObjectA flat object of beginning
 * @param {Object} pObjectB flat object of end point            
 * @returns {Object} containing key array deleted with the keys who are removed, an object added with theire values, and an object changed with the new keys
 */
CloudflowObject.difference = function (pObjectA, pObjectB) {
  var differs = {
    added: {},
    deleted: [],
    changed: {}
  };
  var keysA = Object.keys(pObjectA);
  var keysB = Object.keys(pObjectB);
  differs.deleted = _.difference(keysA, keysB);
  var addedKeys = _.difference(keysB, keysA);
  for (var i = 0; i < addedKeys.length; i++) {
    differs.added[addedKeys[i]] = pObjectB[addedKeys[i]];
  }
  var sameKeys = _.intersection(keysA, keysB);
  for (var i = 0; i < sameKeys.length; i++) {
    if (pObjectA[sameKeys[i]] !== pObjectB[sameKeys[i]]) {
      differs.changed[sameKeys[i]] = pObjectB[sameKeys[i]];
    }
  }
  return differs;
};

/**
 * @description Apply the difference object to an object, please use only difference object from {@link CloudflowObject.difference} and in a correct order.
 * Changes wins over adding, delete wins over changes, delete wins over adding, changes only possible if exists.
 * @function
 * @name CloudflowObject.applyDifference
 * @param {Object} pDifference the object containing the differences
 * @param {Object} pObject The old objet where to apply on
 * @returns {Object} the new object containing all the changes
 */
CloudflowObject.applyDifference = function (pDifference, pObject) {
  var newObject = Object.assign({}, pObject);
  if (pDifference && _typeof(pDifference) === "object" && !Array.isArray(pDifference)) {
    if (pDifference.added && _typeof(pDifference.added) === "object" && !Array.isArray(pDifference.added) && CloudflowObject.isEmptyObject(pDifference.added) === false) {
      for (var key in pDifference.added) {
        newObject[key] = pDifference.added[key];
      }
    }
    if (pDifference.changed && _typeof(pDifference.changed) === "object" && !Array.isArray(pDifference.changed) && CloudflowObject.isEmptyObject(pDifference.changed) === false) {
      for (var key in pDifference.changed) {
        if (key in newObject) {
          newObject[key] = pDifference.changed[key];
        }
      }
    }
    if (Array.isArray(pDifference.deleted) && pDifference.deleted.length > 0) {
      for (var i = 0; i < pDifference.deleted.length; i++) {
        delete newObject[pDifference.deleted[i]];
      }
    }
  }
  return newObject;
};
var flattenRow = function flattenRow(pKey, pValue, pSkipFn) {
  var result = {};
  if (_typeof(pValue) !== "object" || typeof pSkipFn === "function" && pSkipFn(pValue) === true) {
    result[pKey] = pValue;
    return result;
  } else {
    if (Array.isArray(pValue)) {
      for (var i = 0; i < pValue.length; i++) {
        Object.assign(result, flattenRow(pKey + "." + i, pValue[i], pSkipFn));
      }
    } else {
      for (var key in pValue) {
        Object.assign(result, flattenRow(pKey + "." + key, pValue[key], pSkipFn));
      }
    }
    return result;
  }
};

/**
 * @description Flatten object with nested object into 1-level object. The keys will use the dot notation. eg. {a: {b: c}} becomes {a.b: c}
 * @function
 * @name CloudflowObject.flatten
 * @param {Object} pObject the object to flatten
 * @param {Object} pSkipFn This function is ran in every step, the first attribute is the current value being processed. If this function returns true that value is kept and no futher flattening is done on that value and possible nested values.
 * @returns {Object} the new flattened object
 */
CloudflowObject.flatten = function (pObject, pSkipFn) {
  var result = {};
  if (typeof pSkipFn === "function" && pSkipFn(pObject) === true) {
    return pObject;
  }
  if (Array.isArray(pObject)) {
    for (var i = 0; i < pObject.length; i++) {
      Object.assign(result, flattenRow("" + i, pObject[i], pSkipFn));
    }
  } else {
    for (var key in pObject) {
      Object.assign(result, flattenRow(key, pObject[key], pSkipFn));
    }
  }
  return result;
};

/**
 * @description This function fills the empty indexes in an array between the first and last item with desired value.
 *              Sometimes the value can be "empty" and this function can fill those values with undefined.
 * @function
 * @name CloudflowObject.replaceEmptyArrayRows
 * @param {Object} obj the object to fill
 * @param {Object} replaceWith value to fill the empty positions with
 * @returns {Object} the object with replaced values
 */
CloudflowObject.replaceEmptyArrayRows = function (obj, replaceWith) {
  var objCopy;
  if (obj && _typeof(obj) === "object" && !Array.isArray(obj)) {
    objCopy = Object.assign({}, obj);
    Object.keys(obj).forEach(function (key) {
      if (_typeof(objCopy[key]) === "object" && objCopy[key] !== null) {
        objCopy[key] = CloudflowObject.replaceEmptyArrayRows(objCopy[key], replaceWith);
      }
    });
  } else {
    objCopy = obj.slice(0);
    for (var i = 0; i < obj.length; i++) {
      if (objCopy[i] === undefined || objCopy[i] === null) {
        objCopy[i] = replaceWith;
      } else if (_typeof(objCopy[i]) === "object" && objCopy[i] !== null) {
        objCopy[i] = CloudflowObject.replaceEmptyArrayRows(objCopy[i], replaceWith);
      }
    }
  }
  return objCopy;
};

/**
 * @description Check if an object is empty or not, there is currently no single line function that is faster then this function check, 
 * so sadly we should use a util function if most cases are falsy and speed is important
 * @function
 * @name CloudflowObject.isEmptyObject
 * @param {Object} pObject the object to test if it is empty or not
 * @returns {Boolean} true if object is empty, false otherwise
 */
CloudflowObject.isEmptyObject = function (pObject) {
  var key;
  for (key in pObject) {
    return false;
  }
  return true;
};
function merge(pTarget, pFrom, pParents) {
  var newParents = null;
  for (var key in pFrom) {
    if (pFrom === pFrom[key] || pParents.has(pFrom[key])) {
      // prevent infinity loop, so just add reference
      pTarget[key] = pFrom[key];
      continue;
    }
    // go recursive if plain object or array, otherwise just add reference
    if (pFrom[key] && (Object.getPrototypeOf(pFrom[key]) === Object.prototype || Array.isArray(pFrom[key]))) {
      if (!Array.isArray(pFrom[key]) && (_typeof(pTarget[key]) !== "object" || pTarget[key] === null)) {
        pTarget[key] = {};
      } else if (Array.isArray(pFrom[key]) && (_typeof(pTarget[key]) !== "object" || pTarget[key] === null)) {
        pTarget[key] = [];
      }
      if (newParents === null) {
        newParents = new Set(pParents);
        newParents.add(pFrom);
      }
      merge(pTarget[key], pFrom[key], newParents);
    } else {
      pTarget[key] = pFrom[key];
    }
  }
  return pTarget;
}

/**
 * @description Deep merge one iterable object to another and follow the Object.assign philosophy,
 * @function
 * @name CloudflowObject.merge
 * @param {Array} pArrays the objects to merge
 * @param {Object} pOptions how should we merge
 * @returns Merged object
 */
CloudflowObject.merge = function (pArrays) {
  var pOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!Array.isArray(pArrays)) {
    throw new Error("first argument pArray should be an array");
  }
  if (pArrays.length < 2) {
    throw new Error("first argument pArray should be an array of at least length 2");
  }
  var output = pArrays[0];
  for (var i = 1; i < pArrays.length; i++) {
    output = merge(output, pArrays[i], new Set());
  }
  return output;
};
if (typeof module !== "undefined") {
  module.exports = CloudflowObject;
}

},{}],80:[function(require,module,exports){
"use strict";

/**
 * @constructor CloudflowURL
 * @description Create an URL util object that handles dynamic relative paths. The asset must be situated in a file store
 * @param {String} relativeBasePath The relative path
 * @param {String} pPath The path of the asset, if undefined the relativeBasePath becomes the main path
 * @param {Boolean} pFallbackLocation Must we use fallbacks?
 */
function CloudflowURL(relativeBasePath, pPath, pFallbackLocation) {
  this.cloudflowBasePath = "";
  this.uploadBasePath = "";
  this.fallbackLocation = pFallbackLocation;
  if (pPath === undefined) {
    this.setPath(relativeBasePath);
    this._mergePaths();
  } else {
    this.setPath(pPath);
    this._setRelativeBasePath(relativeBasePath);
    this._mergePaths();
    this._normalise();
  }
}
;

/**
 * @description Create a CloudflowURL from a JSON
 * @function
 * @name CloudflowURL.fromJSON
 * @static
 * @param {Object} json 
 * @returns {CloudflowURL}
 */
CloudflowURL.fromJSON = function (json) {
  return new CloudflowURL(json.cloudflowRelativeBasePath, json.path);
};
CloudflowURL.getFolderURL = function (pURL) {
  if (typeof pURL === "string") {
    return pURL.substring(0, pURL.lastIndexOf('/') + 1);
  }
  return pURL;
};

/**
 * @description IS the URL a relative path or not
 * @function
 * @name CloudflowURL#isRelativePath
 * @static
 * @param {String} pURL The RUL to check
 * @returns {Boolean} true if url is relative, false otherwise
 */
CloudflowURL.isRelativePath = function (pURL) {
  if (typeof pURL !== "string" || pURL.length <= 0) {
    throw new Error("parameter URL must be a not empty string");
  }
  if (pURL[0] === ".") {
    if (pURL.length === 1) {
      return true; // url is "."
    } else if (pURL[1] === "/") {
      return true; // url is "./"
    } else if (pURL[1] === ".") {
      if (pURL.length === 2) {
        return true; // url is ".."
      } else if (pURL[2] === "/") {
        return true; // url is "../"
      }
    }
  }

  return false;
};
CloudflowURL.prototype = {
  constructor: CloudflowURL,
  _setRelativeBasePath: function _setRelativeBasePath(pRelativeBasePath) {
    if (typeof pRelativeBasePath !== "string" || pRelativeBasePath.length === 0) {
      this.cloudflowBasePath = "";
      this.uploadBasePath = "";
      return;
    }
    // make folder of it
    if (pRelativeBasePath[pRelativeBasePath.length - 1] !== "/") {
      pRelativeBasePath += "/";
    }
    if (pRelativeBasePath.indexOf("cloudflow://") === 0) {
      this.cloudflowBasePath = pRelativeBasePath;
      this.uploadBasePath = "/portal.cgi/" + pRelativeBasePath.slice(12);
    } else if (pRelativeBasePath.indexOf("/portal.cgi/") === 0) {
      this.cloudflowBasePath = "cloudflow://" + pRelativeBasePath.slice(12);
      this.uploadBasePath = pRelativeBasePath;
    } else {
      // fallback
      this.cloudflowBasePath = pRelativeBasePath;
      this.uploadBasePath = pRelativeBasePath;
    }
  },
  setPath: function setPath(pPath) {
    if (typeof pPath !== "string" || pPath.length <= 0) {
      throw new Error("parameter path must be a not empty string");
    }
    this.path = pPath;
  },
  _mergePaths: function _mergePaths() {
    if (this.path.indexOf("cloudflow://") === 0) {
      this.path = this.path.slice(12);
      this.cloudflowBasePath = "cloudflow://";
      this.uploadBasePath = "/portal.cgi/";
    } else if (this.path.indexOf("/portal.cgi/") === 0) {
      this.path = this.path.slice(12);
      this.cloudflowBasePath = "cloudflow://";
      this.uploadBasePath = "/portal.cgi/";
    } else if (this.path.indexOf("/portal.cgi?") === 0 || this.path.indexOf("/?") === 0 || this.path.indexOf("http:") === 0 || this.path.indexOf("https:") === 0 || this.path.indexOf("mailto:") === 0) {
      // special case do not use relative base paths at all
      this.cloudflowBasePath = "";
      this.uploadBasePath = "";
    } else if (this.path[0] === "/" && this.cloudflowBasePath.length > 0) {
      // prevent double /
      this.path = this.path.slice(1);
    } else if (this.fallbackLocation === true && this.cloudflowBasePath === "" && this._getWindowLocation() !== undefined) {
      // get currect path
      var currentPath = this._getWindowLocation().pathname.substring(0, this._getWindowLocation().pathname.lastIndexOf('/') + 1);
      // check if we are in cloudflow
      if (currentPath.indexOf("/portal.cgi/") === 0) {
        this.cloudflowBasePath = "cloudflow://" + currentPath.slice(12);
        this.uploadBasePath = currentPath;
        if (this.path[0] === "/") {
          // prevent double /
          this.path = this.path.slice(1);
        }
      }
    }
  },
  _getWindowLocation: function _getWindowLocation() {
    return window.location; // put in different function to be able to overwrite this function for tests
  },

  _normalise: function _normalise() {
    if (this.path[0] === "." && this.path[1] === "/") {
      this.path = this.path.substring(2);
    }
    // for each ../ found in the beginning, remove a end part but not the first end part
    // make arrays, handle them, join them afterwards
    var folders = this.cloudflowBasePath.split('/');
    var folders_upload = this.uploadBasePath.split('/');
    var path_parts = this.path.split("../");
    var found;
    for (var i = 0; i < path_parts.length; i++) {
      if (path_parts[i] !== "") {
        break; // if we encounter a not empty path, we are done, all starting "../" are handled
      }

      found = false;
      // from end to second element, prevent removing first part "cloudflow://"
      // only found remove both ../ and ending folder part of relative path
      for (var f = folders.length - 1; f >= 1; f--) {
        if (folders[f] !== "") {
          folders.splice(f, 1);
          folders_upload.splice(f, 1);
          path_parts.shift();
          i--; // first loop should start at good point, may be negative 
          found = true;
          break;
        }
      } // break if relative path is not big enouph
      if (found === false) {
        break;
      }
    }
    this.cloudflowBasePath = folders.join("/");
    this.uploadBasePath = folders_upload.join("/");
    this.path = path_parts.join("../");
  },
  /**
   * @description Get a url starting with cloudflow:// and if needed encounter the relative path with it
   * @function
   * @name CloudflowURL#getCloudflowPath
   * @returns {String} The url strating with cloudflow://
   */
  getCloudflowPath: function getCloudflowPath() {
    return this.cloudflowBasePath + this.path;
  },
  /**
   * @description Get a url starting with /portal.cgi/ and if needed encounter the relative path with it. Use this if you want to use this
   * url direclty in a custom HTML page
   * @function
   * @name CloudflowURL#getUploadPath
   * @returns {String} The url strating with /portal.cgi/
   */
  getUploadPath: function getUploadPath() {
    return this.uploadBasePath + this.path;
  },
  /**
   * @description Get the relative path of it
   * @function
   * @name CloudflowURL#getRelativeUploadPath
   * @param {String} pURL the url of the starting point
   * @returns {String} The relative path or the complete upload path if it is not inside the scope
   */
  getRelativeUploadPath: function getRelativeUploadPath(pURL) {
    var rootPoint;
    if (typeof pURL === "string" && pURL.length > 0) {
      rootPoint = new CloudflowURL(pURL).getUploadPath();
    } else if (pURL instanceof CloudflowURL) {
      rootPoint = pURL.getUploadPath();
    } else {
      return this.getUploadPath();
    }
    var currentPath = this.getUploadPath();
    if (CloudflowURL.isRelativePath(currentPath)) {
      return currentPath;
    }
    var sameFolderIndex = -1;
    for (var i = 0; i < rootPoint.length; i++) {
      if (rootPoint[i] === "/") {
        sameFolderIndex = i;
      }
      if (rootPoint[i] !== currentPath[i]) {
        break;
      }
    }
    if (sameFolderIndex === -1) {
      return this.getUploadPath();
    }
    var relativePath = currentPath.substring(sameFolderIndex + 1);
    var folderFound = false;
    for (var i = sameFolderIndex + 1; i < rootPoint.length; i++) {
      if (rootPoint[i] === "/") {
        folderFound = true;
        relativePath = "../" + relativePath;
      }
    }
    if (folderFound === false) {
      return "./" + relativePath;
    } else {
      return relativePath;
    }
  },
  toJSON: function toJSON() {
    return {
      cloudflowRelativeBasePath: this.cloudflowBasePath,
      path: this.path
    };
  }
};
module.exports = CloudflowURL;

},{}],81:[function(require,module,exports){
"use strict";

var cleanColorRegExp = new RegExp("[^0-9,]", "g");
/**
 * @constructor ColorUtils
 * @description Util class for color converting
 */
var ColorUtils = {
  _defaultColor: "#808080",
  /**
   * @description Convert A color to a value that can be displayed in HTML
   * @function
   * @name ColorUtils.getWebColor
   * @param {Mixed} pColor the color to display
   * @param {Mixed} pDefault The default value to return in case of wrong color
   * @returns {String} color value that can be visualised in HTML
   */
  getWebColor: function getWebColor(pColor, pDefault) {
    if (typeof pColor === "string") {
      return ColorUtils.stringToWebRGB(pColor, pDefault);
    }
    if (Array.isArray(pColor)) {
      if (pColor.length === 3) {
        return ColorUtils.rgb_array_to_web_rgb(pColor);
      } else if (pColor.length === 4) {
        return ColorUtils.cmyk_array_to_web_rgb(pColor);
      } else {
        console.error("unknown array to parse");
      }
    }
    if (pDefault === undefined) {
      return ColorUtils._defaultColor;
    } else {
      return pDefault;
    }
  },
  /**
   * @description Transform a cmyk color format to hex rgb format like #FF00FF
   * @function
   * @name ColorUtils.cmyk_array_to_web_rgb
   * @param {Array.<Number>} pCMYK The color in cmyk format
   * @returns {String} the transformed color	
   */
  cmyk_array_to_web_rgb: function cmyk_array_to_web_rgb(pCMYK) {
    var lC = Math.round(pCMYK[0] * 255);
    var lM = Math.round(pCMYK[1] * 255);
    var lY = Math.round(pCMYK[2] * 255);
    var lK = Math.round(pCMYK[3] * 255);
    if (lC < 0) {
      lC += 256;
    }
    var lR = 255 - (lC + lK);
    var lG = 255 - (lM + lK);
    var lB = 255 - (lY + lK);
    if (lR < 0) {
      lR = 0;
    }
    if (lG < 0) {
      lG = 0;
    }
    if (lB < 0) {
      lB = 0;
    }
    var lResult = (lR << 16) + (lG << 8) + lB;
    var lString = lResult.toString(16);
    while (lString.length < 6) {
      lString = "0" + lString;
    }
    return "#" + lString;
  },
  /**
   * @description Transform the color of rgb array format to hex decimal format like #FF00FF
   * @function
   * @name ColorUtils.rgb_array_to_web_rgb
   * @param {Array.<Number>} pRGB The color in array rgb format
   * @returns {String} the hex format of the color
   */
  rgb_array_to_web_rgb: function rgb_array_to_web_rgb(pRGB) {
    var lR = Math.round(pRGB[0] * 255);
    var lG = Math.round(pRGB[1] * 255);
    var lB = Math.round(pRGB[2] * 255);
    var lResult = (lR << 16) + (lG << 8) + lB;
    var lString = lResult.toString(16);
    while (lString.length < 6) {
      lString = "0" + lString;
    }
    return "#" + lString;
  },
  /**
   * @description Transform the rgb color format th hex format
   * @function
   * @name ColorUtils.RGBToHex
   * @param {Array.<Number>} pRGB The RGB array containing the color values like [200,17,56]
   * @returns <String> The hex color
   */
  RGBToHex: function RGBToHex(pRGB) {
    if (!Array.isArray(pRGB) || pRGB.length !== 3) {
      throw new Error("parameter is an invalid web color");
    }
    return "#" + (+pRGB[0]).toString(16).padStart(2, "0") + (+pRGB[1]).toString(16).padStart(2, "0") + (+pRGB[2]).toString(16).padStart(2, "0");
  },
  /**
   * @description Transform a hex color format to rgb format
   * @function
   * @name ColorUtils.hexToRGB
   * @param {String} pHexamal hexamal color format like #FF22AA
   * @returns {Array} the rgb format in array, like [200,17,56]
   */
  hexToRGB: function hexToRGB(pHexamal) {
    if (typeof pHexamal !== "string" || pHexamal.length !== 7 || pHexamal[0] !== "#") {
      throw new Error("parameter is an invalid web color");
    }
    return [parseInt(pHexamal.substring(1, 3), 16), parseInt(pHexamal.substring(3, 5), 16), parseInt(pHexamal.substring(5, 7), 16)];
  },
  /**
   * @description Transform a collor to a valid CSS color format
   * @function
   * @name ColorUtils.stringToWebRGB
   * @param {String} pColor 
   * @param {Mixed} pDefault default value in case of error
   * @returns {String} a css valid color
   */
  stringToWebRGB: function stringToWebRGB(pColor, pDefault) {
    if (window.tinycolor === undefined) {
      return pColor;
    }
    var color = tinycolor(pColor);
    if (color.isValid()) {
      return color.toRgbString();
    } else {
      // invalid, try to parse further
      var cleanedColorString = ("" + pColor).replace(cleanColorRegExp, "");
      if (typeof cleanedColorString !== "string" || cleanedColorString.length === 0) {
        if (pDefault === undefined) {
          return ColorUtils._defaultColor;
        } else {
          return pDefault;
        }
      }
      return "rgb(" + cleanedColorString + ")";
    }
  }
};
module.exports = ColorUtils;

},{}],82:[function(require,module,exports){
"use strict";

function ContextStorage() {}
;
ContextStorage.isSupport = function () {
  return storageAvailable('localStorage');
};
ContextStorage.updateOrWrite = function (pObjectToSave, pUUID, pContextID, pRemoveOldMilleSec, pRemoveLastReadMilleSec) {
  if (ContextStorage.update(pObjectToSave, pUUID, pContextID, pRemoveOldMilleSec, pRemoveLastReadMilleSec) === null) {
    ContextStorage.write(pObjectToSave, pUUID, pContextID, pRemoveOldMilleSec, pRemoveLastReadMilleSec);
  }
};
ContextStorage.write = function (pObjectToSave, pUUID, pContextID, pRemoveOldMilleSec, pRemoveLastReadMilleSec) {
  if (pContextID === undefined) {
    pContextID = "nixps.PageBuilder.ContextStorage";
  }
  if (pRemoveOldMilleSec === undefined) {
    pRemoveOldMilleSec = 365 * 24 * 3600 * 1000;
  }
  var storage = localStorage.getItem(pContextID);
  var storageArray;
  if (typeof storage !== "string" || storage.length <= 0) {
    storageArray = [];
  } else {
    try {
      storageArray = JSON.parse(storage);
    } catch (e) {
      console.error(e);
      storageArray = [];
    }
  }
  if (Array.isArray(storageArray) && storageArray.length > 0) {
    if (typeof pRemoveOldMilleSec === "number" && pRemoveOldMilleSec > 0) {
      var limitTimePoint = Date.now() - pRemoveOldMilleSec;
      storageArray = storageArray.filter(function (elem, index) {
        return elem !== undefined && typeof elem.timestamp === "number" && limitTimePoint < elem.timestamp;
      });
    }
    if (typeof pRemoveLastReadMilleSec === "number" && pRemoveLastReadMilleSec > 0) {
      var limitTimePoint = Date.now() - pRemoveLastReadMilleSec;
      storageArray = storageArray.filter(function (elem, index) {
        if (elem !== undefined) {
          if (typeof elem.last_read === "number" && limitTimePoint < elem.last_read) {
            return true;
          } else if (typeof elem.timestamp === "number" && limitTimePoint < elem.timestamp) {
            return true;
          }
        }
        return false;
      });
    }
  }
  var uuid;
  if (pUUID === undefined) {
    uuid = generateGUID();
  } else {
    uuid = pUUID;
  }
  storageArray.push({
    timestamp: Date.now(),
    uuid: uuid,
    value: pObjectToSave
  });
  // always surrender by try / catch
  // storage can be full
  try {
    localStorage.setItem(pContextID, JSON.stringify(storageArray));
  } catch (e) {
    console.error(e);
    if (typeof e.message === "string" && e.message.endsWith("exceeded the quota.")) {
      api_async.logging.trace.log("com.nixps.generic", "warn", "reached maximum storage quota on browser");
    }
    return null;
  }
  return uuid;
};
ContextStorage.update = function (pObjectToSave, pObjectUUID, pContextID, pRemoveOldMilleSec, pRemoveLastReadMilleSec) {
  if (pContextID === undefined) {
    pContextID = "nixps.PageBuilder.ContextStorage";
  }
  var storage = localStorage.getItem(pContextID);
  var storageArray;
  if (typeof storage !== "string" || storage.length <= 0) {
    storageArray = [];
  } else {
    try {
      storageArray = JSON.parse(storage);
    } catch (e) {
      console.error(e);
      storageArray = [];
    }
  }
  if (storageArray.length === 0) {
    return null;
  }
  var found = false;
  for (var i = 0; i < storageArray.length; i++) {
    if (storageArray[i].uuid === pObjectUUID) {
      storageArray[i].timestamp = Date.now();
      storageArray[i].value = pObjectToSave;
      found = true;
      break;
    }
  }
  if (found === false) {
    return null;
  }
  if (Array.isArray(storageArray) && storageArray.length > 0) {
    if (typeof pRemoveOldMilleSec === "number" && pRemoveOldMilleSec > 0) {
      var limitTimePoint = Date.now() - pRemoveOldMilleSec;
      storageArray = storageArray.filter(function (elem, index) {
        return elem !== undefined && typeof elem.timestamp === "number" && limitTimePoint < elem.timestamp;
      });
    }
    if (typeof pRemoveLastReadMilleSec === "number" && pRemoveLastReadMilleSec > 0) {
      var limitTimePoint = Date.now() - pRemoveLastReadMilleSec;
      storageArray = storageArray.filter(function (elem, index) {
        if (elem !== undefined) {
          if (typeof elem.last_read === "number" && limitTimePoint < elem.last_read) {
            return true;
          } else if (typeof elem.timestamp === "number" && limitTimePoint < elem.timestamp) {
            return true;
          }
        }
        return false;
      });
    }
  }
  // always surrender by try / catch
  // storage can be full
  try {
    localStorage.setItem(pContextID, JSON.stringify(storageArray));
    return pObjectToSave;
  } catch (e) {
    console.error(e);
    if (typeof e.message === "string" && e.message.endsWith("exceeded the quota.")) {
      api_async.logging.trace.log("com.nixps.generic", "warn", "reached maximum storage quota on browser");
    }
    return null;
  }
};
ContextStorage.read = function (pUUID, pRemove, pContextID) {
  if (pContextID === undefined) {
    pContextID = "nixps.PageBuilder.ContextStorage";
  }
  if (pRemove === undefined) {
    pRemove = true;
  }
  var storage = localStorage.getItem(pContextID);
  // returns null is not exists
  if (storage === null || storage === undefined) {
    return undefined;
  }
  var storageArray;
  try {
    storageArray = JSON.parse(storage);
  } catch (e) {
    console.error(e);
    return undefined;
  }
  if (Array.isArray(storageArray) === false || storageArray.length <= 0) {
    return undefined;
  }
  var valueFound;
  if (pUUID === undefined) {
    valueFound = [];
    for (var i = 0; i < storageArray.length; i++) {
      valueFound.push(storageArray[i].value);
      if (pRemove !== true) {
        storageArray[i].last_read = Date.now();
      }
    }
    if (pRemove === true) {
      storageArray = [];
    }
  } else {
    for (var i = 0; i < storageArray.length; i++) {
      if (storageArray[i].uuid === pUUID) {
        valueFound = storageArray[i].value;
        if (pRemove === true) {
          storageArray.splice(i, 1);
        } else {
          storageArray[i].last_read = Date.now();
        }
        break;
      }
    }
  }
  try {
    localStorage.setItem(pContextID, JSON.stringify(storageArray));
  } catch (e) {
    // failed to update....
    console.error(e);
  }
  return valueFound;
};
ContextStorage.remove = function (ID, pContextID) {
  try {
    return ContextStorage.read(ID, true, pContextID);
  } catch (e) {
    console.error(e);
  }
  return null;
};
ContextStorage.clear = function (pContextID) {
  try {
    localStorage.removeItem(pContextID);
  } catch (e) {
    console.error(e);
  }
};
ContextStorage.prototype = {
  constructor: ContextStorage
};
module.exports = ContextStorage;
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
function generateGUID() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
;
function storageAvailable(type) {
  try {
    var storage = window[type],
      x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return e instanceof DOMException && (
    // everything except Firefox
    e.code === 22 ||
    // Firefox
    e.code === 1014 ||
    // test name field too, because code might not be present
    // everything except Firefox
    e.name === 'QuotaExceededError' ||
    // Firefox
    e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
    // acknowledge QuotaExceededError only if there's something already stored
    storage.length !== 0;
  }
}

},{}],83:[function(require,module,exports){
"use strict";

/**
 * @constructor DateFunctions
 * @description Util class for Date
 */
var DateFunctions = {
  /**
      * @description create a standardised string format of a date and time
      * @function
      * @name DateFunction.toLocaleString
      * @param {Date} pDate 
      * @returns {String}
      */
  toLocaleString: function toLocaleString(pDate) {
    var pOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = Object.assign({
      language: undefined,
      timeOffset: true
    }, pOptions);
    var out = pDate.toLocaleString(options.language, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    });
    if (options.timeOffset === true) {
      out += " " + this.createOffset(pDate);
    }
    return out;
  },
  /**
   * @description create a standardised string format of a date
   * @function
   * @name DateFunction.toLocaleDateString
   * @param {Date} pDate 
   * @returns {String}
   */
  toLocaleDateString: function toLocaleDateString(pDate) {
    var pOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = Object.assign({
      language: undefined,
      timeOffset: false
    }, pOptions);
    return pDate.toLocaleDateString(options.language, {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  },
  /**
   * @description Create a string representation of the date offset
   * @function
   * @name DateFunction.createOffset
   * @param {Date} date 
   * @returns {String} the offset of the date lke +01:00
   */
  createOffset: function createOffset(pDate) {
    var sign = pDate.getTimezoneOffset() > 0 ? "-" : "+";
    var offset = Math.abs(pDate.getTimezoneOffset());
    var hours = this._pad(Math.floor(offset / 60));
    var minutes = this._pad(offset % 60);
    return sign + hours + ":" + minutes;
  },
  _pad: function _pad(value) {
    return value < 10 ? "0" + value : value;
  }
};
module.exports = DateFunctions;

},{}],84:[function(require,module,exports){
"use strict";

/**
 * @description All the characters that are encoded by the backend, but are not by the broser endcodeURI
 * @type {Object}
 * @private
 * @static
 */
var kExtraEncodingDict = Object.freeze({
  "&": "%26",
  "#": "%23",
  "=": "%3d",
  "(": "%28",
  ")": "%29",
  "!": "%21",
  "*": "%2a",
  "'": "%27"
});

/**
 * @constructor Decoding
 * @description Util functions used during encoding / decoding
 */
module.exports = {
  /**
   * @description Encode a string to the backend encoding type, which is different then the browser encoding.
   * Do only use this while you don't have the real url, like user typing an url.
   * For other input interfaces it cast to string, like the browser encodeURI() function.
   * @param {String} pString an url you want to encode 
   * @function
   * @name Decoding.encodeBackend
   * @returns the backend encoded format of pString
   */
  encodeBackend: function encodeBackend(pString) {
    if (typeof pString !== "string") {
      pString = "" + pString; // make a string of it, same behavior as encodeURI()
    }

    var encodedString = "";
    for (var i = 0; i < pString.length; i++) {
      if (kExtraEncodingDict[pString[i]]) {
        encodedString += kExtraEncodingDict[pString[i]];
      } else {
        encodedString += encodeURI(pString[i]).replace(/[%]([0-9a-zA-Z][0-9a-zA-Z])/g, function (pMatch, p1) {
          return "%" + p1.toLowerCase();
        });
      }
    }
    return encodedString;
  },
  /**
   * @description Try to determin if a string is decoded. We can not determin 100% correctly,
   * it is still possible that decoded strings are detected as "non-decoded" 
   * @param {String} pString the string to test
   * @function
   * @name Decoding.isDecoded
   * @returns {Boolean} true if we are 100% sure it is decoded, false if it could be encoded
   */
  isDecoded: function isDecoded(pString) {
    if (typeof pString !== "string") {
      return false;
    }
    if (pString.indexOf(" ") >= 0) {
      // short cut, and also catch examples like "test %25f"
      return true;
    }
    try {
      return decodeURI(pString) === pString;
    } catch (e) {
      // can not be decoded, so string is possible decoded already
      return true;
    }
  },
  /**
   * @description Check if a String is neutral, if the encoded text is equal as his original
   * @function
   * @name Decoding.isNeutral
   * @param {String} pString 
   * @returns true if the text is encoded and decoded at the same time (like fully English texts)
   */
  isNeutral: function isNeutral(pString) {
    return encodeURI(pString) === pString;
  }
};

},{}],85:[function(require,module,exports){
"use strict";

/**
 * @constructor EditorUtil
 * @description Util class for CLOUDFLOW file bases editors
 */
var EditorUtil = {
  getEditorType: function getEditorType(pURL, pAssetData) {
    if (typeof pURL === "string" && pURL.length > 0) {
      if (pAssetData.filetype === "text/html" || pAssetData.filetype === "image/svg+xml" || pURL.endsWith(".html") || pURL.endsWith(".js") || pURL.endsWith(".xml") || pURL.endsWith(".txt") || pURL.endsWith(".csv") || pURL.endsWith(".xliff") || pURL.endsWith(".xlf") || pURL.endsWith(".page") || pURL.endsWith(".cfsnapshot")) {
        return "pagebuilder";
      } else if (pAssetData.filetype === "application/json" && pURL.endsWith("/manifest.json")) {
        // manifest is special json, so handle this before the json
        return "manifest";
      } else if (pURL.endsWith(".json")) {
        return "pagebuilder";
      } else if (pURL.endsWith(".md") || pAssetData.filetype === "text/markdown") {
        return "markdowneditor";
      } else if (pURL.endsWith(".css") || pAssetData.filetype === "text/css") {
        return "stylebuilder";
      } else if (pURL.endsWith(".icc")) {
        return "icc";
      } else if (pURL.endsWith(".cfcurve")) {
        return "cfcurve";
      } else if (pURL.endsWith(".dlcfg") || pURL.endsWith(".sicfg") || pURL.endsWith(".dljcfg") || pURL.endsWith(".sijcfg") || ["application/vnd.colorlogic-sicfg", "application/vnd.colorlogic-dlcfg", "application/vnd.colorlogic-dlcfg+json", "application/vnd.colorlogic-sicfg+json"].includes(pAssetData.filetype)) {
        return "smartlink";
      } else if (pURL.endsWith(".tec") === false && (pURL.endsWith(".tcb") || pAssetData.filetype === "application/vnd.packz-colorbook")) {
        return "colorbook";
      } else if (pURL.endsWith(".cflay") || pAssetData.filetype === "application/vnd.nixps-layout+json") {
        return "layout";
      }
    }
    return null;
  },
  /**
   * @description what is the URL of the editor
   * @function
   * @name EditorUtil.getEditorURL
   * @param {String} pApplicationID the editor
   * @param {String} pURL the url or resource to edit
   * @param {String} UIMode the name fo the UImode
   * @param {Object} pParameters the parameters to pass through
   * @returns {String} The url of the editor
   */
  getEditorURL: function getEditorURL(pApplicationID, pURL, UIMode, pParameters) {
    var urlPostFix = "_nebula";
    var additionalParameters = "";
    for (var name in pParameters) {
      additionalParameters += "&" + name + "=" + encodeURIComponent(pParameters[name]);
    }
    switch (pApplicationID) {
      case "pagebuilder":
        return "/pagebuilder/pagebuilder" + urlPostFix + ".html?url=" + encodeURIComponent(encodeURI(pURL)) + additionalParameters;
      case "whitepaper":
        return "/portal.cgi?quantum&whitepaperName=" + encodeURIComponent(pURL) + additionalParameters;
      case "markdown":
      case "markdowneditor":
        return "/markdowneditor/index" + urlPostFix + ".html?url=" + encodeURIComponent(encodeURI(pURL)) + additionalParameters;
      case "stylebuilder":
        return "/pagebuilder/stylebuilder" + urlPostFix + ".html?url=" + encodeURIComponent(encodeURI(pURL)) + additionalParameters;
      case "form":
        return "/portal.cgi?form=editor&formname=" + encodeURIComponent(pURL) + additionalParameters;
      case "template":
        return "/portal.cgi?chains=1&template=" + encodeURIComponent(pURL) + additionalParameters + "#emailtemplates";
      case "manifest":
        return "/manifest/editor.html?url=" + encodeURIComponent(encodeURI(pURL)) + additionalParameters;
      case "icc":
        return "/ripnebula/editors/ICCprofile.html?url=" + encodeURIComponent(encodeURI(pURL)) + additionalParameters;
      case "curve":
      case "cfcurve":
        return "/ripnebula/editors/Curves.html?url=" + encodeURIComponent(encodeURI(pURL)) + additionalParameters;
      case "colorbook":
        return "/colorspace/colorbook.html?url=" + encodeURIComponent(encodeURI(pURL)) + additionalParameters;
    }
    return null;
  }
};
module.exports = EditorUtil;

},{}],86:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var CloudflowURL = require("./CloudflowURL.js");
var Query = require("../../Table/js/Query.js");
var QueryApplier = require("./QueryApplier.js");
var CloudflowObject = require("./CloudflowObject.js");
var GUID = require("./GUID.js");
function timeStamp() {
  return new Date().toISOString().substring(0, 19) + "Z";
}

/**
 * @constructor FileConnection
 * @description Class to apply all CRUD api-alive methodes on a JSON-file
 * @param {String} pURL The cloudflow url of the file
 * @param {String} pRelativeBasePath The relative path
 * @param {String} pContentType The type of the file, we now only support "json"
 */
function FileConnection(pURL, pRelativeBasePath, pContentType) {
  this.loadingDef; // promise of loading content
  this.rootParameter; // the root of the file content, "" or "documents"
  this.content; // rows content
  this.fileEtag; // value of etag 
  this.fileModification; // value of last modification time stamp 
  this.error; // object of error
  this.autoAdaptedURL; // log to trace url change
  this.dirty = false;
  this.reasonToStop = null; // abort message
  this.setURL(pRelativeBasePath, pURL);
  this.setContentType(pContentType);
}
FileConnection.fromJSON = function (json) {
  return new FileConnection(json.url, json.relativeBasePath, json.contentType);
};
FileConnection.prototype = {
  constructor: FileConnection,
  /**
   * @description Set the URL of the file
   * @name FileConnection#setURL
   * @function
   * @param {String} pRelativeBasePath 
   * @param {String} pURL 
   */
  setURL: function setURL(pRelativeBasePath, pURL) {
    if (typeof pURL !== "string" || pURL.length <= 0) {
      throw new Error("parameter url must be a not empty string");
    }
    this.url = pURL;
    this.relativeBasePath = pRelativeBasePath;
    this.cloudflowURL = new CloudflowURL(this.relativeBasePath, this.url, true);
  },
  /**
   * @description Get the URL of the file
   * @function
   * @name FileConnection#getURL
   * @returns The url of the file
   */
  getURL: function getURL() {
    return this.url;
  },
  getRelativeBasePath: function getRelativeBasePath() {
    return this.relativeBasePath;
  },
  setContentType: function setContentType(pContentType) {
    if (pContentType === undefined || pContentType === "json") {
      this.contentType = "json";
    } else {
      throw new Error("unsupported contentType " + pContentType);
    }
  },
  getContentType: function getContentType() {
    return this.contentType;
  },
  getError: function getError() {
    return this.error;
  },
  _setError: function _setError(pErrorCode, pError, pXHR) {
    var returnErrorObj;
    if (pXHR && typeof pXHR.responseText === "string") {
      try {
        returnErrorObj = JSON.parse(pXHR.responseText);
      } catch (e) {}
    }
    if (pErrorCode === "error" && pError === "Not Found") {
      this.error = {
        "error_code": "file_not_found",
        "error": "File not found"
      };
      if (returnErrorObj !== undefined && returnErrorObj.messages !== undefined && Array.isArray(returnErrorObj.messages.messages) && returnErrorObj.messages.messages.length > 0) {
        this.error.error = returnErrorObj.messages.messages[0].description;
      }
    } else if (returnErrorObj !== undefined) {
      this.error = returnErrorObj;
    } else {
      this.error = {
        "error_code": pErrorCode,
        "error": pError
      };
    }
  },
  /**
   * @function
   * @description Read the content of the file
   * @name FileConnection#load
   */
  load: function load() {
    var that = this;
    var promiseDict = Promise.withResolvers();
    this.loadingDef = promiseDict.promise;
    var getUrl = "/portal.cgi?asset=download_file&url=" + encodeURIComponent(this.cloudflowURL.getCloudflowPath());
    if (typeof api_util.get_session() === "string" && api_util.get_session().length > 0) {
      getUrl += "&session=" + api_util.get_session();
    }
    var xhttp = new XMLHttpRequest();
    xhttp.onload = function (pEvent) {
      if (xhttp.status < 200 || xhttp.status > 299) {
        that.rootParameter = "";
        that.content = null;
        var errorObject = {
          error_code: "http",
          error: xhttp.statusText
        };
        if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
          try {
            errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
          } catch (e) {}
        }
        that._setError(errorObject.error_code, errorObject.error, xhttp);
        console.error(errorObject);
        promiseDict.reject({
          xhr: xhttp,
          error_code: errorObject.error_code,
          error: errorObject.error
        });
      } else {
        var data = null;
        if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
          if (that.getContentType() === "json") {
            try {
              data = JSON.parse(xhttp.responseText);
            } catch (e) {
              that.content = null;
              that.rootParameter = "";
              promiseDict.reject({
                xhr: xhttp,
                error_code: "content_not_json",
                error: e.message
              });
              return;
            }
          } else {
            console.error("unsupported content type", that.getContentType());
            promiseDict.reject({
              xhr: xhttp,
              error_code: "unuspported_contenttype",
              error: "unuspported contenttype"
            });
            return;
          }
        }
        if (data && !Array.isArray(data) && _typeof(data) === "object" && Object.keys(data).length === 1 && Array.isArray(data.documents)) {
          // special frankied styled xml's
          that.rootParameter = "documents";
          that.content = data.documents;
        } else {
          that.rootParameter = "";
          if (data === null || data === undefined || data === "") {
            // empty file
            that.content = [];
          } else {
            that.content = data;
          }
        }
        var etagFormat = xhttp.getResponseHeader("x-nixps-sourcetag");
        if (typeof etagFormat === "string" && etagFormat.length > 0) {
          if (etagFormat[0] === '"') {
            that.fileEtag = etagFormat.slice(1, -1);
          } else {
            that.fileEtag = etagFormat;
          }
          if (etagFormat.indexOf("mod=") === 0) {
            that.fileModification = etagFormat.slice(4);
          }
        }
        promiseDict.resolve(that.content);
      }
    };
    xhttp.onerror = function (pEvent) {
      if (xhttp.statusText === "OK" && xhttp.status === 200 && xhttp.responseText === "") {
        // empty file
        that.rootParameter = "";
        that.content = [];
        promiseDict.resolve([]); // reset to solved
      } else {
        that.rootParameter = "";
        that.content = null;
        var errorObject = {
          error_code: "http_error_load",
          error: xhttp.statusText
        };
        if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
          try {
            errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
          } catch (e) {}
        }
        that._setError(errorObject.error_code, errorObject.error, xhttp);
        console.error(errorObject);
        promiseDict.reject({
          xhr: xhttp,
          error_code: errorObject.error_code,
          error: errorObject.error
        });
      }
    };
    xhttp.onabort = function (pEvent) {
      promiseDict.reject({
        xhr: xhttp,
        error_code: "abort",
        error: "file connection has been aborted"
      });
    };
    xhttp.open("get", getUrl, true);
    xhttp.setRequestHeader("Content-Type", "text/plain; charset=UTF-8");
    xhttp.send();
    return this.loadingDef;
  },
  getData: function getData() {
    return this.content;
  },
  getDataObject: function getDataObject() {
    if (Array.isArray(this.content) && this.content.length > 0 && this.content[0] && _typeof(this.content[0]) === "object" && !Array.isArray(this.content[0])) {
      return structuredClone(this.content[0]);
    } else if (this.content && _typeof(this.content) === "object" && !Array.isArray(this.content)) {
      return structuredClone(this.content);
    } else {
      return null;
    }
  },
  _guessIdentifierKey: function _guessIdentifierKey(pObject) {
    if (pObject["_id"] !== undefined) {
      return "_id";
    } else if (pObject["id"] !== undefined) {
      return "id";
    } else if (pObject["ID"] !== undefined) {
      return "ID";
    } else {
      return null;
    }
  },
  /**
   * @description Add a new object the the collection
   * @function
   * @name FileConnection#create
   * @param {Object} pObject The object to add to the collection
   * @param {Object} pOptions 
   * @param {Function} pGoodCB Function called when the object has been created correctly
   * @param {Function} pErrorCB Function called when an error occured
   * @returns Deferred
   */
  create: function create(pObject, pOptions, pGoodCB, pErrorCB) {
    var that = this;
    // get options and apply defaults
    var options = Object.assign({
      "uniqKeyName": "_id",
      "addBirth": true
    }, pOptions);
    // deep copy of object to create
    var objectToCreate = Object.assign({}, pObject);
    this.loadingDef = this.load();
    return Promise.all([this.loadingDef]).then(function () {
      var indentifierKey = options.uniqKeyName;
      if (Array.isArray(that.content)) {
        // guess the id to be used
        if (that.content.length > 0) {
          indentifierKey = that._guessIdentifierKey(that.content[that.content.length - 1]);
          if (indentifierKey === null) {
            indentifierKey = options.uniqKeyName;
          }
        }
      } else {
        // make new content
        that.content = [];
      }
      // generate and add id
      objectToCreate[indentifierKey] = GUID.generate();
      // add birth key
      if (options.addBirth === true) {
        objectToCreate["birth"] = timeStamp();
      }
      // append to other rows
      that.content.push(objectToCreate);
      // save
      return that.update_all(that.content).then(function () {
        // good callback
        if (typeof pGoodCB === "function") {
          pGoodCB(objectToCreate);
        }
        return objectToCreate;
      })["catch"](function (pError) {
        if (typeof pErrorCB === "function") {
          pErrorCB(pError);
        }
        return Promise.reject(pError);
      });
    }, function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB(pError);
      }
      return Promise.reject(pError);
    });
  },
  /**
   * @description Get an filter certain objects from the collection. Same interface as the list_with_options api calls
   * @function
   * @name FileConnection#list_with_options
   * @param {Array.<String>} pQuery The query to filter. Same interface as portal api querys
   * @param {Array.<String>} pOrderby The order by. Same interface as portal api
   * @param {Array.<String>} pFields the fields to retrieve. Same interface as portal api
   * @param {Object} pOptions Same interface as portal api
   * @param {Function} pGoodCB Function called then we could retrieve the objects
   * @param {Fucntion} pErrorCB Function called when an error occured
   * @returns {Array.<Object>} The filtered object 
   */
  list_with_options: function list_with_options(pQuery, pOrderby, pFields, pOptions, pGoodCB, pErrorCB) {
    var that = this;
    var skip = 0;
    var limit = undefined;
    var last = undefined;
    if (pOptions) {
      //  {first: pSkip, maximum: pLimit}
      if (pOptions.first !== undefined) {
        skip = parseInt(pOptions.first);
      }
      if (pOptions.maximum !== undefined) {
        limit = parseInt(pOptions.maximum);
      }
      if (pOptions.last !== undefined) {
        last = parseInt(pOptions.last);
      }
    }
    this.loadingDef = this.load();
    return Promise.all([this.loadingDef])["catch"](function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB(pError);
      }
      return Promise.reject(pError);
    }).then(function () {
      var contentRows;
      if (Array.isArray(that.content)) {
        contentRows = that.content;
      } else if (that.content === undefined) {
        contentRows = [];
      } else {
        contentRows = [that.content];
      }
      var rows = [];
      var returnObject = {};
      if (Array.isArray(pQuery) && pQuery.length > 0) {
        var queryApplier;
        var filteredData;
        try {
          queryApplier = new QueryApplier(pQuery);
          filteredData = queryApplier.apply(contentRows);
        } catch (e) {
          if (typeof pErrorCB === "function") {
            pErrorCB({
              error_code: "invalid_query",
              error: e
            });
          }
          return Promise.reject(e);
        }
        rows = Query.apply(filteredData, [], pOrderby, skip, limit, last);
        returnObject = {
          results: rows
        };
        if (pOptions.count === true) {
          returnObject.count = filteredData.length;
        }
      } else {
        rows = Query.apply(contentRows, [], pOrderby, skip, limit, last);
        returnObject = {
          results: rows
        };
        if (pOptions.count === true) {
          returnObject.count = contentRows.length;
        }
      }
      if (typeof pGoodCB === "function") {
        pGoodCB(returnObject);
      }
      return returnObject;
    });
  },
  _update: function _update(pQuery, pUpdateObject, pMerge, pOneLevelMerge, pFirstOnly) {
    var queryApplier = new QueryApplier(pQuery);
    var count_updated = 0;
    var error = undefined;
    for (var i = 0; i < this.content.length; i++) {
      if (queryApplier.validate(this.content[i]) === true) {
        if (this.content[i] !== undefined && pMerge === false) {
          if (this.content[i].save_id !== undefined) {
            if (this.content[i].save_id !== pUpdateObject.save_id) {
              this._setError("save_id_not_equal", "the save_id is not equal");
              error = this.getError();
              if (pFirstOnly === true) {
                return {
                  success: false,
                  count_updated: count_updated,
                  error: error
                };
              } else {
                continue;
              }
            } else {
              pUpdateObject.save_id = GUID.generate();
            }
          }
          if (typeof this.content[i].modification === "string" && this.content[i].modification.length > 17 && isNaN(new Date(this.content[i].modification)) === false) {
            // update modification key 
            pUpdateObject.modification = timeStamp();
          }
        }
        if (pMerge === true) {
          if (this.content[i].save_id !== undefined && this.content[i].save_id !== pUpdateObject.save_id) {
            this._setError("save_id_not_equal", "the save_id is not equal");
            error = this.getError();
            if (pFirstOnly === true) {
              return {
                success: false,
                count_updated: count_updated,
                error: error
              };
            } else {
              continue;
            }
          }
          // merge with existing 
          if (pOneLevelMerge === false) {
            this.content[i] = $.extend(true, {}, this.content[i], pUpdateObject);
          } else {
            // keys can contain dots notations
            for (var key in pUpdateObject) {
              if (pUpdateObject.hasOwnProperty(key)) {
                this.content[i] = CloudflowObject.setParameter(this.content[i], key, pUpdateObject[key]);
              }
            }
          }
          if (this.content[i].save_id !== undefined) {
            // no check for the moment
            this.content[i].save_id = GUID.generate();
          }
          if (typeof this.content[i].modification === "string" && this.content[i].modification.length > 17 && isNaN(new Date(this.content[i].modification)) === false) {
            // update modification key 
            this.content[i].modification = timeStamp();
          }
        } else {
          // replace with existing
          this.content[i] = pUpdateObject;
        }
        count_updated++;
        if (pFirstOnly === true) {
          break;
        }
      }
    }
    return {
      success: count_updated > 0,
      count_updated: count_updated,
      error: error
    };
  },
  /**
   * @description Tries to update an object. It will retrieve the unic indentifier (_id, id or ID) retrieve the old object
   * and replace it with the new object. it will also adapt the save_id and the modifier if present in old object
   * @function
   * @name FileConnection#update
   * @param {Object} pUpdateObject the new date of the object
   * @param {Array.<String>} pFindQuery the query to retrieve the object   
   * @param {Function} pGoodCB Function called when the update is done and constains the updatd object
   * @param {Function} pErrorCB Function called when an error occured
   * @returns Deferred
   */
  update: function update(pUpdateObject, pFindQuery, pGoodCB, pErrorCB) {
    // make object and a deep copy of it
    var updateObject = structuredClone(Object.assign({}, pUpdateObject));
    if (this.content === null) {
      this.content = [updateObject];
      if (typeof pGoodCB === "function") {
        pGoodCB(updateObject);
      }
      return Promise.resolve(updateObject);
    }
    var searchQuery;
    if (Array.isArray(pFindQuery) && pFindQuery.length > 2) {
      searchQuery = pFindQuery;
    } else {
      var key = this._guessIdentifierKey(updateObject);
      if (typeof key === "string" && key.length > 0) {
        searchQuery = [key, "equal to", updateObject[key]];
      } else {
        this._setError("identification_not_found", "no identification has not been found");
        if (typeof pErrorCB === "function") {
          pErrorCB(this.getError());
        }
        return Promise.reject(this.getError());
      }
    }
    if (Array.isArray(searchQuery) && searchQuery.length > 2) {
      var result = this._update(searchQuery, updateObject, false, false, true);
      if (result.error !== undefined) {
        if (typeof pErrorCB === "function") {
          pErrorCB(result.error);
        }
        return Promise.reject(result.error);
      }
      if (result.success === false) {
        this._setError("object_not_found", "the updated object has not been found");
        if (typeof pErrorCB === "function") {
          pErrorCB(this.getError());
        }
        return Promise.reject(this.getError());
      } else {
        return this.update_all(this.content).then(function () {
          if (typeof pGoodCB === "function") {
            pGoodCB(updateObject);
          }
          return Promise.resolve(updateObject);
        }, function (pError) {
          if (typeof pErrorCB === "function") {
            pErrorCB(pError);
          }
          return Promise.reject(pError);
        });
      }
    } else {
      this._setError("object_not_found", "the updated object has not been found");
      if (typeof pErrorCB === "function") {
        pErrorCB(this.getError());
      }
      return Promise.reject(this.getError());
    }
  },
  update_all: function update_all(pRows, pGoodCB, pErrorCB) {
    if (Array.isArray(pRows)) {
      var that = this;
      var content = JSON.stringify(pRows, null, 3);
      return this._save(content).then(function () {
        if (typeof pGoodCB === "function") {
          pGoodCB(content);
        }
        return content;
      }, function (pError) {
        if (pError && pError.error_code !== undefined) {
          that._setError(pError.error_code, pError.error);
        }
        if (typeof pErrorCB === "function") {
          pErrorCB(pError);
        }
        return Promise.reject(that.getError());
      });
    } else {
      this._setError("wrong_parameter", "content must be an array");
      if (typeof pErrorCB === "function") {
        pErrorCB(this.getError());
      }
      return Promise.reject(this.getError());
    }
  },
  /**
   * @description Calculates the amount of objects matching a certain filter
   * @function
   * @name FileConnection#count
   * @param {Array} pQuery The filter query. Same interface as portal apis
   * @param {Function} pGoodCB Function called with parameter "count", the amount of matched objects 
   * @param {Function} pErrorCB Function called when an error occured
   * @returns Deferred
   */
  count: function count(pQuery, pGoodCB, pErrorCB) {
    var that = this;
    this.loadingDef = this.load();
    return Promise.all([this.loadingDef]).then(function () {
      var contentRows;
      if (Array.isArray(that.content)) {
        contentRows = that.content;
      } else if (that.content === undefined) {
        contentRows = [];
      } else {
        contentRows = [that.content];
      }
      var count;
      if (Array.isArray(pQuery) && pQuery.length > 0) {
        var queryApplier = new QueryApplier(pQuery);
        count = queryApplier.apply(contentRows).length;
      } else {
        count = contentRows.length;
      }
      if (typeof pGoodCB === "function") {
        pGoodCB({
          count: count
        });
      }
      return {
        count: count
      };
    }, function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB(pErrorCB);
      }
      return Promise.reject(that.getError());
    });
  },
  /**
   * @description Update partially an object of the collection
   * @function
   * @name FileConnection#set_keys
   * @param {String} pID The id of the object
   * @param {Object} pKeyData the object containing the new key values to update. Same interface as portal api calls 
   * @param {Function} pGoodCB Function called when object has been updated 
   * @param {Function} pErrorCB Function called when an error occured
   * @returns Deferred
   */
  set_keys: function set_keys(pID, pKeyData, pGoodCB, pErrorCB) {
    var that = this;
    this.loadingDef = this.load();
    return Promise.all([this.loadingDef]).then(function () {
      var contentRows;
      if (Array.isArray(that.content)) {
        contentRows = that.content;
      } else if (that.content === undefined) {
        contentRows = [];
      } else {
        contentRows = [that.content];
      }
      if (Array.isArray(contentRows) && contentRows.length > 0) {
        var key = that._guessIdentifierKey(contentRows[0]);
        if (key === null) {
          that._setError("identification_not_found", "no identification has not been found");
          if (typeof pErrorCB === "function") {
            pErrorCB(that.getError());
          }
          return Promise.reject(that.getError());
        } else {
          var result = that._update([key, "equal to", pID], pKeyData, true, true, true);
          if (result.count_updated > 0) {
            // only update if some data changed
            return that.update_all(that.content).then(function () {
              if (result.error !== undefined) {
                if (typeof pErrorCB === "function") {
                  pErrorCB(result.error);
                }
                return Promise.reject(result.error);
              } else {
                if (typeof pGoodCB === "function") {
                  pGoodCB({});
                }
                return Promise.resolve({});
              }
            })["catch"](function (pError) {
              if (typeof pErrorCB === "function") {
                pErrorCB(pError);
              }
              return Promise.reject(pError);
            });
          } else if (result.error !== undefined) {
            if (typeof pErrorCB === "function") {
              pErrorCB(result.error);
            }
            return Promise.reject(result.error);
          } else {
            that._setError("object_not_found", "no object found with id " + pID);
            if (typeof pErrorCB === "function") {
              pErrorCB(that.getError());
            }
            return Promise.reject(that.getError());
          }
        }
      } else {
        that._setError("object_not_found", "no object found with id " + pID);
        if (typeof pErrorCB === "function") {
          pErrorCB(that.getError());
        }
        return Promise.reject(that.getError());
      }
    }, function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB(pError);
      }
      return Promise.reject(that.getError());
    });
  },
  /**
   * @description Update all objects partial who match the filter query. Same interface as portal api calls
   * @function
   * @name FileConnection#set_keys_by_query
   * @param {Array} pQuery 
   * @param {Object} pKeyData 
   * @param {Object} pOptions 
   * @param {Function} pGoodCB 
   * @param {Function} pErrorCB 
   * @returns Deferred
   */
  set_keys_by_query: function set_keys_by_query(pQuery, pKeyData, pOptions, pGoodCB, pErrorCB) {
    var that = this;
    this.loadingDef = this.load();
    return Promise.all([this.loadingDef]).then(function () {
      if (that.content === null) {
        // success even if no items are found
        if (typeof pGoodCB === "function") {
          pGoodCB({});
        }
        return Promise.resolve({});
      }
      var result = that._update(pQuery, pKeyData, true, true, false);
      if (result.count_updated > 0) {
        // only update if some data changed
        return that.update_all(that.content).then(function () {
          if (result.error !== undefined) {
            if (typeof pErrorCB === "function") {
              pErrorCB(result.error);
            }
            return Promise.reject(result.error);
          } else {
            if (typeof pGoodCB === "function") {
              pGoodCB({});
            }
            return Promise.resolve({});
          }
        })["catch"](function (pError) {
          if (typeof pErrorCB === "function") {
            pErrorCB(pError);
          }
          return Promise.reject(pError);
        });
      } else if (result.error !== undefined) {
        if (typeof pErrorCB === "function") {
          pErrorCB(result.error);
        }
        return Promise.reject(result.error);
      } else {
        // success even if no items are found
        if (typeof pGoodCB === "function") {
          pGoodCB({});
        }
        return Promise.resolve({});
      }
    }, function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB(pError);
      }
      return Promise.reject(that.getError());
    });
  },
  /**
   * @description Delete an object from the collection. 
   * @function
   * @name FileConnection#delete
   * @param {String} pID The identifier of the object you want to delete out of the collection
   * @param {Function} pGoodCB function called when the object is deleted out of the collection, with a parameter array delete_ids
   * @param {Function} pErrorCB Function called when an error occured
   * @returns Deferred
   */
  "delete": function _delete(pID, pGoodCB, pErrorCB) {
    var that = this;
    this.loadingDef = this.load();
    return Promise.all([this.loadingDef]).then(function () {
      var contentRows;
      if (Array.isArray(that.content)) {
        contentRows = that.content;
      } else if (that.content === undefined) {
        contentRows = [];
      } else {
        contentRows = [that.content];
      }
      if (Array.isArray(contentRows) && contentRows.length > 0) {
        var key = that._guessIdentifierKey(contentRows[0]);
        if (key === null) {
          that._setError("identification_not_found", "no identification has not been found");
          if (typeof pErrorCB === "function") {
            pErrorCB(that.getError());
          }
          return Promise.reject(that.getError());
        } else {
          return that._delete_by_query([key, "equal to", pID], pGoodCB, pErrorCB);
        }
      }
    }, function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB(pError);
      }
      return Promise.reject(that.getError());
    });
  },
  /**
   * @description Delete all matching objects from the collection 
   * @function
   * @name FileConnection#delete_by_query
   * @param {Array.<String>} pQuery The query to match all objects you want to delete
   * @param {Function} pGoodCB function called when all objects are deleted out of the collection, with a parameter array delete_ids
   * @param {Function} pErrorCB Function called when an error occured
   * @returns Deferred
   */
  delete_by_query: function delete_by_query(pQuery, pGoodCB, pErrorCB) {
    var that = this;
    this.loadingDef = this.load();
    return Promise.all([this.loadingDef]).then(function () {
      return that._delete_by_query(pQuery, pGoodCB, pErrorCB);
    }, function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB({
          error: pError.error_code,
          error_message: pError.error
        });
      }
      return Promise.reject(that.getError());
    });
  },
  _delete_by_query: function _delete_by_query(pQuery, pGoodCB, pErrorCB) {
    var contentRows;
    if (Array.isArray(this.content)) {
      contentRows = this.content;
    } else if (this.content === undefined) {
      contentRows = [];
    } else {
      contentRows = [this.content];
    }
    var deleted_ids = [];
    var removedItem, removedKey;
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var queryApplier = new QueryApplier(pQuery);
      for (var i = contentRows.length; i >= 0; i--) {
        if (queryApplier.validate(contentRows[i])) {
          // item to remove found
          removedItem = contentRows.splice(i, 1);
          removedKey = this._guessIdentifierKey(removedItem[0]);
          if (typeof removedKey === "string" && removedKey.length > 0) {
            deleted_ids.push(removedItem[0][removedKey]);
          } else {
            console.error("remove key path not found");
          }
        }
      }
    }
    return this.update_all(contentRows).then(function () {
      if (typeof pGoodCB === "function") {
        pGoodCB({
          deleted_ids: deleted_ids
        });
      }
      return {
        deleted_ids: deleted_ids
      };
    }, function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB(pError);
      }
      return Promise.reject(pError);
    });
  },
  touch: function touch() {
    var that = this;
    return new Promise(function (pResolve, pReject) {
      api_async.file.does_exist(that.cloudflowURL.getCloudflowPath(), function (pResult) {
        /*
            exists: false
            is_folder: false
            url: "cloudflow://PP_FILE_STORE/Menu/sitemap%20met%20%c3%a8.json"
            valid: true
        */
        if (pResult !== undefined) {
          if (pResult.valid === false) {
            // folders does not exists, so create them....
            FileConnection.createParentFolders(pResult.url).then(function () {
              that.update_all([], function () {
                that.cloudflowURL = new CloudflowURL(pResult.url);
                that.autoAdaptedURL = "after_touch";
                pResolve({
                  exists: false,
                  url: pResult.url,
                  valid: pResult.valid
                });
              }, pReject);
            }, pReject);
          } else if (pResult.exists === false) {
            that.update_all([], function () {
              that.cloudflowURL = new CloudflowURL(pResult.url);
              that.autoAdaptedURL = "after_touch";
              pResolve({
                exists: false,
                url: pResult.url,
                valid: pResult.valid
              });
            }, pReject);
          } else if (pResult.exists === true) {
            pResolve(pResult);
          } else {
            pReject("wrong returning result");
          }
        } else {
          pReject("wrong returning result");
        }
      }, pReject);
    });
  },
  _save: function _save(pContent) {
    var that = this;
    var content = pContent;
    if (that.rootParameter === "documents") {
      content = {
        documents: pContent
      };
    }
    var session = "";
    if (api_util.get_session() !== undefined) {
      session = "&session=" + api_util.get_session();
    }
    var checks = "";
    if (typeof that.fileEtag === "string" && that.fileEtag.length > 0) {
      if (that.fileEtag.indexOf("mod=") === 0) {
        checks = "&check_modification=" + that.fileEtag.slice(4);
      } else {
        checks = "&check_etag=" + that.fileEtag;
      }
    } else if (typeof that.fileModification === "number") {
      checks = "&check_modification=" + that.fileModification;
    }
    var boundary = "----cloudflowfileconnection" + Date.now();
    // attention keep this header clean,
    // header need to use \r\n for new lines
    // header may not have spaces before or after header keys
    var sendContent = "--" + boundary + '\r\nContent-Type: text/json\r\nContent-Disposition: form-data;filename="dumyblabla.json"\r\n\r\n' + content;
    sendContent = sendContent + "\r\n--" + boundary + "--\r\n";
    var upload_url = "/portal.cgi?asset=upload_file&url=" + encodeURIComponent(that.cloudflowURL.getCloudflowPath()) + "&overwrite=true" + session + checks;
    var promiseDict = Promise.withResolvers();
    var xhttp = new XMLHttpRequest();
    xhttp.onload = function (pEvent) {
      if (xhttp.status < 200 || xhttp.status > 299) {
        var errorMessage = {
          "error": "Could not save",
          "error_code": "faild_saving"
        };
        if (typeof xhttp.responseText === "string") {
          try {
            // try to retrieve error message
            errorMessage = JSON.parse(xhttp.responseText);
          } catch (e) {}
        }
        promiseDict.reject(errorMessage);
      } else {
        var data = null;
        if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
          try {
            data = JSON.parse(xhttp.responseText);
          } catch (e) {
            return promiseDict.reject({
              "error_code": "return_interface_not_json",
              "error": e.message
            });
          }
        } else {
          return promiseDict.reject({
            "error_code": "empty_response",
            "error": "The returning response is empty"
          });
        }
        if (Array.isArray(data.files) && data.files.length === 1) {
          // etag has been changed, but what is the new value??
          that.fileEtag = "";
          if (Array.isArray(data.file_info) && data.file_info.length === 1) {
            if (typeof data.file_info[0].etag === "string") {
              that.fileEtag = data.file_info[0].etag;
            }
            if (typeof data.file_info[0].modification === "number") {
              that.fileModification = data.file_info[0].modification;
            }
          }
          promiseDict.resolve({
            "url": data.files[0],
            "content": pContent
          });
        } else if (Array.isArray(data.files) && data.files.length === 0) {
          // file has been ignored!!!
          promiseDict.reject({
            "error_code": "Document not saved",
            "error": "saving conflict, the file has been modified by somebody else"
          });
        } else {
          // realy strange thing
          promiseDict.reject({
            "error_code": "unknown_error",
            "error": "return data has no files parameter"
          });
        }
      }
    };
    xhttp.onerror = function (pEvent) {
      var errorMessage = {
        "error": "Could not save",
        "error_code": "faild_saving"
      };
      if (typeof xhttp.responseText === "string") {
        try {
          // try to retrieve error message
          errorMessage = JSON.parse(xhttp.responseText);
        } catch (e) {}
      }
      promiseDict.reject(errorMessage);
    };
    xhttp.onabort = function (pEvent) {
      promiseDict.reject({
        xhr: xhttp,
        error_code: "abort",
        error: "file connection has been aborted"
      });
    };
    xhttp.open("POST", upload_url);
    xhttp.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + boundary);
    var csrfToken = api_util.get_cookie("csrf-token");
    if (typeof csrfToken === "string" && csrfToken.length > 0) {
      xhttp.setRequestHeader("X-Csrf-Token", csrfToken);
    }
    xhttp.send(sendContent);
    return promiseDict.promise;
  },
  stop: function stop(pReason) {
    if (this.loadingDef !== undefined && this.loadingDef.readyState > 0 && this.loadingDef.readyState < 4) {
      this.loadingDef.abort("deprecated_results");
    }
    if (typeof pReason === "string") {
      this.reasonToStop = pReason;
    } else {
      this.reasonToStop = "???";
    }
  },
  clone: function clone() {
    return FileConnection.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {
      url: this.url,
      relativeBasePath: this.relativeBasePath,
      contentType: this.contentType
    };
  }
};
FileConnection.createParentFolders = function (pURL) {
  if (pURL.indexOf("cloudflow://") === 0) {
    pURL = pURL.slice(12);
  }
  if (pURL.endsWith(".json")) {
    // make folder
    pURL = pURL.slice(0, pURL.lastIndexOf("/") + 1);
  }
  var firstSlashIndex = pURL.indexOf('/') + 1;
  var rootFolder = "cloudflow://" + pURL.substring(0, firstSlashIndex);
  return api_defer.file.create_folder_with_options(rootFolder, pURL.slice(firstSlashIndex), {
    unique_name_mode: "None",
    create_folders: true
  }).then(function (result) {
    if (result && typeof result.created_folder === "string" && result.created_folder.length > 0) {
      return {
        "url": result.created_folder
      };
    } else {
      return Promise.reject({
        "error_code": "wrong_return_interface",
        "error": "wrong return value api.file.create_folder"
      });
    }
  }, function (pError) {
    console.error(pError);
    return Promise.reject(pError);
  });
};
module.exports = FileConnection;

},{"../../Table/js/Query.js":211,"./CloudflowObject.js":79,"./CloudflowURL.js":80,"./GUID.js":89,"./QueryApplier.js":91}],87:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * @constructor FileOperations
 * @description general FileOperations & functionality for cloudlfow
 */

var WhitepaperConnection = require("../../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js");
var kSystemFolders = ["cloudflow://PP_FILE_STORE/CloudflowAddons/", "cloudflow://PP_FILE_STORE/Fonts/", "cloudflow://PP_FILE_STORE/Incomming/", "cloudflow://PP_FILE_STORE/Mars/", "cloudflow://PP_FILE_STORE/marsclient/", "cloudflow://PP_FILE_STORE/Menu/", "cloudflow://PP_FILE_STORE/PageBuilder/", "cloudflow://PP_FILE_STORE/Public/", "cloudflow://PP_FILE_STORE/Resources/", "cloudflow://PP_FILE_STORE/RIP_JOBS/", "cloudflow://PP_FILE_STORE/VDP_JOBS/"];
var inMakingCallID = 0;
var FileOPerations = {
  /**
   * @description Move a an array of files and folders to target location
   * @function
   * @name FileOperations.name
   * @param {Object} pUrls the array of files and folders (Cloudflow paths)
   * @param {String} pToUrl The target location to move the files and folders to (cloudflow path)
   * @return {object} returns an object with a list of moved files and a list of moved folders
   */
  move: function move(pUrls, pToUrl, pSiteName, pOverwriteRule) {
    var that = this;
    var separation = this.separateFilesFromFolders(pUrls);
    return Promise.allSettled([that._moveFiles(separation.files, pToUrl, pOverwriteRule), that._moveFolders(separation.folders, pToUrl, pOverwriteRule)]);
  },
  /**
   * @description Separate an array of cloudflow urls in files and folders
   * @function
   * @name FileOperations.separateFilesFromFolders
   * @param {Object} pUrls the array of files and folders (Cloudflow paths)
   * @return {object} returns an object with a list of moved files and a list of moved folders
   */
  separateFilesFromFolders: function separateFilesFromFolders(pUrls) {
    var items = {
      files: [],
      folders: []
    };
    if (Array.isArray(pUrls)) {
      for (var i = 0; i < pUrls.length; i++) {
        if (this.isFolder(pUrls[i])) {
          items.folders.push(pUrls[i]);
        } else {
          items.files.push(pUrls[i]);
        }
      }
    } else if (typeof pUrls === "string") {
      if (this.isFolder(pUrls)) {
        items.folders.push(pUrls);
      } else {
        items.files.push(pUrls);
      }
    }
    return items;
  },
  /**
   * @description Private function to move a list of cloudflow file urls. Should only be file urls and used internally, use FileOperations.move!
   * @function
   * @name FileOperations.moveFiles
   * @param {Object} pFiles the array of files (Cloudflow paths)
   * @param {String} pNewFolderUrl the target location for the move
   * @param {String} pOverwriteRule Rule on what to do when an asset already exists on target location. Currently accepts "skip", "overwrite", "duplicate"
   * @return {object} returns an object with a list of moved files
   */
  _moveFiles: function _moveFiles(pFiles, pNewFolderUrl, pOverwriteRule) {
    var promises = [];
    var that = this;
    var idMapping = [];
    var overwrite = false;
    var unique_name_mode = "None";
    if (typeof pOverwriteRule === "string") {
      switch (pOverwriteRule) {
        case "skip":
          overwrite = false;
          unique_name_mode = "None";
        case "overwrite":
          overwrite = true;
          unique_name_mode = "None";
        case "duplicate":
          overwrite = false;
          unique_name_mode = "Sequential";
      }
    }
    if (typeof pNewFolderUrl !== "string" || pNewFolderUrl.length <= 0) {
      throw new Error("parameter pNewUrl must be a not empty string");
    }
    if (!Array.isArray(pFiles)) {
      throw new Error("parameter pFiles must be an array");
    }
    if (pFiles.length > 0) {
      for (var i = 0; i < pFiles.length; i++) {
        inMakingCallID++;
        if (typeof pFiles[i] !== "string" || pFiles[i].length <= 0) {
          throw new Error("index " + i + " of filelist must be a not empty string");
        } else {
          promises.push($.when(pFiles[i], api_defer.file.move_file_with_options(pFiles[i], pNewFolderUrl, {
            overwrite: overwrite,
            create_folders: true,
            unique_name_mode: unique_name_mode
          }), inMakingCallID));
        }
      }
      return $.when.apply($, promises).then(function (pOld, pResult) {
        var moved_files = [];
        var args = Array.prototype.slice.call(arguments);
        if (Array.isArray(args) && Array.isArray(args[1])) {
          for (var i = 0; args.length > i; i++) {
            moved_files.push({
              pOld: args[i][1].moved_file
            });
          }
        } else if (Array.isArray(args) && _typeof(args[1]) === "object" && args[1].moved_file !== undefined && typeof args[1].moved_file === "string") {
          moved_files.push({
            pOld: args[1].moved_file
          });
        } else {
          console.error("strange data " + args);
        }
        return moved_files;
      });
    } else {
      return [];
    }
  },
  /**
   * @description Private function to move a list of cloudflow folder urls. Should only be folder urls and used internally, use FileOperations.move!
   * @function
   * @name FileOperations.moveFolders
   * @param {Object} pFolders the array of folders (Cloudflow paths)
   * @param {String} pNewFolderUrl the target location for the move
   * @param {String} pOverwriteRule Rule on what to do when an asset already exists on target location. Currently accepts "skip", "overwrite", "duplicate"
   * @return {object} returns an object with a list of moved folders
   */
  _moveFolders: function _moveFolders(pFolders, pNewFolderUrl, pOverwriteRule) {
    var that = this;
    if (!Array.isArray(pFolders)) {
      throw new Error("parameter pFiles must be an array");
    }
    if (pFolders.length > 0) {
      return new Promise(function (pResolve, pReject) {
        var connection = new WhitepaperConnection("Asset Actions Flow", "Input", {
          "action": "move",
          "sourceFolderUrl": pFolders,
          "targetFolderUrl": pNewFolderUrl,
          "overwrite_rule": pOverwriteRule
        }, undefined, true);
        connection.setStartPollingTime(1);
        connection.start().then(function (pResult) {
          pResolve(pResult);
        })["catch"](function (pError) {
          pReject(pError);
        });
      });
    } else {
      return [];
    }
  },
  /**
   * @description Check if cloudflow path is a folder
   * @function 
   * @name FileOperations.isFolder
   * @param {String} pUrl Cloudflow path to check
   * @return {Boolean} returns true or false when path is folder or not
   */
  isFolder: function isFolder(pUrl) {
    if (typeof pUrl !== "string" || pUrl.length <= 0) {
      throw new Error("url parameter must be a not empty string");
    }
    return pUrl[pUrl.length - 1] === "/";
  },
  /**
   * @description Check if cloudflow path is a filestore
   * @function
   * @name FileOperations.isFileStore
   * @param {String} pUrl Cloudflow path to check
   * @return {Boolean} returns true or false when path is filestore or not
   */
  isFileStore: function isFileStore(pUrl) {
    if (this.isFolder(pUrl) === true && pUrl.indexOf("cloudflow://") === 0) {
      // remove "cloudflow://" and last char "/",
      // if we found no "/" in the rest, this means we are in a file store
      return pUrl.substring(12).slice(0, -1).indexOf("/") === -1;
    }
    return false;
  },
  /**
   * @description Extracts the enclosing folder path(!) from a cloudflow path
   * @function 
   * @name FileOperations.getEnclosingFolder
   * @param {String} pUrl Cloudflow path to extract enclosing folder path from
   * @return {String} returns the cloudflow path of the enclosing folder
   */
  getEnclosingFolder: function getEnclosingFolder(pUrl) {
    if (pUrl[pUrl.length - 1] === "/") {
      pUrl = pUrl.substring(0, pUrl.lastIndexOf("/"));
    }
    return pUrl.substring(0, pUrl.lastIndexOf("/") + 1);
  },
  /**
   * @description Extracts the filename from a cloudflow asset path
   * @function 
   * @name FileOperations.getFilename
   * @param {String} pUrl Cloudflow path to extract filename from
   * @return {String} returns the filename of the cloudflow asset path
   */
  getFileName: function getFileName(pUrl) {
    if (typeof pUrl !== "string" || pUrl.length <= 0) {
      throw new Error("url parameter must be a not empty string");
    }
    return pUrl.substring(pUrl.lastIndexOf("/") + 1);
  },
  /**
   * @description Extracts the enclosing folder path(!) from a cloudflow path
   * @function 
   * @name FileOperations.getPath
   * @param {String} pUrl Cloudflow path to extract from
   * @return {String} returns the cloudflow path of the enclosing folder
   */
  getPath: function getPath(pUrl) {
    return pUrl.substring(0, pUrl.lastIndexOf("/", pUrl.length - 2) + 1);
  },
  /**
   * @description Extracts the folder name from a cloudflow folder path
   * @function 
   * @name FileOperations.getFolderName
   * @param {String} pUrl Cloudflow folder path to extract the name from
   * @return {String} returns the name of the folder
   */
  getFolderName: function getFolderName(pUrl) {
    if (this.isFolder(pUrl)) {
      // search beginning from element before last, 
      // last element has index pUrl.length - 1
      // element before has index  pUrl.length - 1 - 1 = pUrl.length - 2
      return pUrl.substring(pUrl.lastIndexOf("/", pUrl.length - 2) + 1, pUrl.lastIndexOf("/"));
    }
    return pUrl;
  },
  /**
   * @description Extracts the name of either a folder or a file
   * @function 
   * @name FileOperations.getName
   * @param {String} pUrl Cloudflow path to extract name from
   * @return {String} returns the name of the file or folder
   */
  getName: function getName(pUrl) {
    if (this.isFolder(pUrl)) {
      return this.getFolderName(pUrl);
    } else {
      return this.getFileName(pUrl);
    }
  },
  /**
   * @description check if the folder is a system folder or a subfolder?
   * @function
   * @name FileOperations.isInSystemFolder
   * @param {String} pURL the url of the file or folder to check
   * @returns {Boolean} true if folder of file is inside a system folder, it also return true if it is a system folder
   */
  isInSystemFolder: function isInSystemFolder(pURL) {
    return kSystemFolders.some(function (pFolderURL) {
      return pURL.indexOf(pFolderURL) === 0;
    });
  }
};
module.exports = FileOPerations;

},{"../../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js":93}],88:[function(require,module,exports){
"use strict";

/**  
 * @constructor FileSizeUtils
 * @description You can huminisaze computer memory amounts 
 */
var FileSizeUtils = {
  _round_number: function _round_number(num, dec) {
    return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
  },
  /**
   * @name FileSizeUtil.toString
   * @description Huminisaze computer memory amounts
   * @function
   * @param {Number} pValue
   * @param {String} pWrongeReprecentation
   * @returns {String}
   */
  toString: function toString(pValue, pWrongeReprecentation, pSeparator) {
    if (pWrongeReprecentation === undefined) {
      pWrongeReprecentation = "--";
    }
    var fs = pValue;
    if (fs === undefined || fs === null) {
      return pWrongeReprecentation;
    }
    if (typeof fs === "string") {
      fs = parseFloat(fs);
    }
    if (isFinite(fs) === false) {
      return pWrongeReprecentation;
    }
    if (pSeparator === undefined) {
      pSeparator = " ";
    }
    if (fs >= 1000000000) {
      return this._round_number(fs / 1000000000, 2) + pSeparator + 'GB';
    }
    if (fs >= 1000000) {
      return this._round_number(fs / 1000000, 2) + pSeparator + 'MB';
    }
    if (fs >= 1000) {
      return this._round_number(fs / 1000, 0) + pSeparator + 'KB';
    }
    return fs + pSeparator + 'B';
  }
};
module.exports = FileSizeUtils;

},{}],89:[function(require,module,exports){
"use strict";

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
;
var GUID = {
  /**
   * @description generate a UUID
   * @function
   * @name GUID.generate
   * @returns a string containing an uuid 
   */
  generate: function generate() {
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
  }
};
module.exports = GUID;

},{}],90:[function(require,module,exports){
"use strict";

var Location = {
  /**
   * @description Get the current window.location, usefull for testing mocking
   * @function
   * @name Location#getLocation
   */
  getLocation: function getLocation() {
    return window.location;
  },
  /**
   * @description force an URL to be the same origin as the current one, throw an error if it is of strange origin
   * @function
   * @name Location#forceSameOrigin
   * @param {String} pURL the url to be force
   * @returns {String} url with same origin 
   */
  forceSameOrigin: function forceSameOrigin(pURL) {
    if (typeof pURL !== "string" || pURL.length <= 0) {
      throw new Error("url parameter should be a not empty string");
    }
    if (pURL[0] === "/") {
      // force same origin, is pointing to root
      return window.location.origin + pURL;
    } else if (this.hasSameOrigin(pURL)) {
      // contains already same origin, leave it
      return pURL;
    } else {
      // could do nothing, probably wrong origin!!
      throw new Error("redirection to other origin blocked");
    }
  },
  hasSameOrigin: function hasSameOrigin(pInputUrl) {
    if (typeof URL === "function") {
      try {
        var url = new URL(pInputUrl, window.location.href);
        return url.origin === window.location.origin;
      } catch (e) {
        return false;
      }
    } else {
      // fallback old browsers
      return hasDifferentOrigin(pInputUrl) === false;
    }
  }
};

// AI Codex
function normalizedPort(pProtocol, pPort) {
  if (pPort) {
    return pPort;
  }
  if (pProtocol === "http:") {
    return "80";
  }
  if (pProtocol === "https:") {
    return "443";
  }
  return "";
}
function hasDifferentOrigin(inputUrl) {
  var link = document.createElement("a");
  link.href = inputUrl;
  var targetProtocol = link.protocol;
  var targetHost = link.hostname;
  var targetPort = normalizedPort(targetProtocol, link.port);
  var currentProtocol = window.location.protocol;
  var currentHost = window.location.hostname;
  var currentPort = normalizedPort(currentProtocol, window.location.port);
  return targetProtocol !== currentProtocol || targetHost !== currentHost || targetPort !== currentPort;
}
// IA

module.exports = Location;

},{}],91:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// help functions
var CloudflowObject = require("./CloudflowObject.js");
var EmptyStringObject = {
  // object simulation a string who provides false for each check
  startsWith: function startsWith() {
    return false;
  },
  endsWith: function endsWith() {
    return false;
  },
  indexOf: function indexOf() {
    return -1;
  },
  toUpperCase: function toUpperCase() {
    return this;
  }
};
var zeroRegExp = new RegExp("%0", "g");
var oneRegExp = new RegExp("%1", "g");
// 
var translationDict = Object.freeze({
  "and": " && ",
  "or": " || ",
  "not": " true !== ",
  "(": "(",
  ")": ")",
  "equal to": " == %1 ",
  "strict equal to": " === %1 ",
  "not equal to": " !== %1 ",
  "exists": " !== undefined ",
  "does not exist": " === undefined ",
  "ends with": " makeString(%0).endsWith(''+%1) ",
  "ends like": " makeString(%0).toUpperCase().endsWith((''+%1).toUpperCase()) ",
  "begins with": " makeString(%0).startsWith(''+%1) ",
  "begins like": " makeString(%0).toUpperCase().startsWith((''+%1).toUpperCase()) ",
  "contains": " makeString(%0).indexOf(''+%1) >= 0 ",
  "contains text like": " makeString(%0).toUpperCase().indexOf((''+%1).toUpperCase()) >= 0 ",
  "is like": "(''+%0).toUpperCase() == (''+%1).toUpperCase() ",
  "less than": " (%0 === null ? NaN : %0) < (%1 === null ? NaN : %1) ",
  "less than or equal to": " (%0 === null ? NaN : %0) <= (%1 === null ? NaN : %1) ",
  "greater than": " (%0 === null ? NaN : %0) > (%1 === null ? NaN : %1) ",
  "greater than or equal to": " (%0 === null ? NaN : %0) >= (%1 === null ? NaN : %1) ",
  "in": "_.contains(%1, %0) ",
  "in like": " %1.map(function(e){return makeString(e).toUpperCase()}).includes((''+%0).toUpperCase())",
  "contains element matching": " makeArray(%0).some(function(e){return "
});
var makeArrayArg = {
  "in": true
};
var isInnerQueryArg = {
  "contains element matching": true
};

/**
 * @constructor QueryApplier
 * @description A hulp class that evaluates a query (in api style) on objects and rows in javascript
 * @private
 * @param {Array.<String>} pQuery the query in api style
 */
var QueryApplier = function QueryApplier(pQuery) {
  if (Array.isArray(pQuery) === false) {
    throw new Error("The query must be an array");
  }
  this.validateFunction = this._createFunction(this._createJSFunctionString(pQuery));
};
QueryApplier.prototype = {
  constructor: QueryApplier,
  _createJSFunctionString: function _createJSFunctionString(pQuery) {
    if (pQuery.length === 0) {
      return " true;"; // pass all if query is empty, everything is valid!
    }

    var functionStrings = [];
    var isInnerQuery = false,
      innerQueryCounter = 0;
    for (var i = 0; i < pQuery.length; i++) {
      var translation = translationDict[pQuery[i]];
      if (translation === undefined) {
        // specific keys to be compared with
        // use JSON.stringify, so it correctly makes arguments for booleans, null, undefined, arrays, object and even strings
        if (isInnerQuery === false) {
          functionStrings.push(" translate(" + JSON.stringify(pQuery[i]) + ")");
        } else {
          functionStrings.push(" translate_inner(e," + JSON.stringify(pQuery[i]) + ")");
        }
      } else if (translation.indexOf("%0") >= 0) {
        if (isInnerQueryArg[pQuery[i]] === true) {
          isInnerQuery = true;
          innerQueryCounter = 1;
        }
        var inArray;
        if (makeArrayArg[pQuery[i]] === true) {
          if (Array.isArray(pQuery[i + 1])) {
            inArray = JSON.stringify(pQuery[i + 1]);
          } else if (pQuery[i + 1] === "(") {
            inArray = "[";
            for (var a = i + 2; a < pQuery.length; a++) {
              if (pQuery[a] === ")") {
                i++;
                break;
              }
              inArray += JSON.stringify(pQuery[a]) + ",";
              i++;
            }
            inArray = inArray.slice(0, -1);
            inArray += "]";
          } else {
            inArray = JSON.stringify([pQuery[i + 1]]);
          }
        } else {
          inArray = JSON.stringify(pQuery[i + 1]);
        }
        functionStrings[functionStrings.length - 1] = translation.replace(oneRegExp, inArray).replace(zeroRegExp, functionStrings[functionStrings.length - 1]);
        i++;
      } else if (translation.indexOf("%1") >= 0) {
        // some compare equations
        var replacer = pQuery[i + 1];
        if (typeof replacer === "string") {
          replacer = '"' + replacer + '"';
        }
        functionStrings.push(translation.replace(oneRegExp, replacer));
        i++;
      } else {
        if (isInnerQuery) {
          if (pQuery[i] === ")") {
            innerQueryCounter--;
            if (innerQueryCounter <= 0) {
              innerQueryCounter = 0;
              functionStrings.push("}");
              isInnerQuery = false;
            }
          } else if (pQuery[i] === "(") {
            innerQueryCounter++;
          }
        }

        // connected symbols
        functionStrings.push(translation);
      }
    }
    return functionStrings.join("");
  },
  _createFunction: function _createFunction(pString) {
    if (typeof pString !== "string") {
      throw new Error("pString must be a string");
    }
    var argum = ["translate", "translate_inner", "makeString", "makeArray", "$", "window", "document", "jQuery", "Function"];
    return new Function(argum, "'use strict';return " + pString);
  },
  /**
   * @description Evaluate the object. Is the object valid compared to the query?
   * @function
   * @name QueryApplier#validate
   * @param {Object} pObject The tobject to be valuated
   * @returns {Boolean} true if the object is valid
   */
  validate: function validate(pObject) {
    return this.validateFunction(function (pObjectPath) {
      return CloudflowObject.getParameter(pObject, pObjectPath);
    }, function (pObj, pObjectPath) {
      return CloudflowObject.getParameter(pObj, pObjectPath);
    }, function (s) {
      if (["string", "number", "boolean"].includes(_typeof(s))) {
        return "" + s;
      }
      return EmptyStringObject;
    }, function (a) {
      if (Array.isArray(a)) {
        return a;
      } else {
        return [];
      }
    });
  },
  /**
   * @description Evaluate the condition as condition, there are no objects present
   * @function
   * @name QueryApplier#validateNaked
   * @returns {Boolean} true if the condition is true, false otherwise
   */
  validateNaked: function validateNaked() {
    return this.validateFunction(function (pObjectPath) {
      return pObjectPath;
    }, function (pObj, pObjectPath) {
      return CloudflowObject.getParameter(pObj, pObjectPath);
    }, function (s) {
      if (["string", "number", "boolean"].includes(_typeof(s))) {
        return "" + s;
      }
      return EmptyStringObject;
    }, function (a) {
      if (Array.isArray(a)) {
        return a;
      } else {
        return [];
      }
    });
  },
  /**
   * @description Evaluate all the rows and filter out those who are valid agains the query
   * @function
   * @name QueryApplier#apply
   * @param {Array.<Object>} pRows The rows to be evaluated
   * @returns {Array.<Object>} the rows who are valid agains the query
   */
  apply: function apply(pRows) {
    var validRows = [];
    if (Array.isArray(pRows)) {
      for (var i = 0; i < pRows.length; i++) {
        if (this.validate(pRows[i])) {
          validRows.push(pRows[i]);
        }
      }
    }
    return validRows;
  }
};
module.exports = QueryApplier;

},{"./CloudflowObject.js":79}],92:[function(require,module,exports){
"use strict";

module.exports = Object.freeze({
  /** string iso format */
  "ISO_TODAY": "$_ISO_TODAY",
  /** strong iso format, but today */
  "ISO_NOW": "$_ISO_NOW",
  /** number unix today */
  "UNIX_TODAY": "$_UNIX_TODAY",
  /** number unix now */
  "UNIX_NOW": "$_UNIX_NOW",
  /** number unix but miliseconds today */
  "UNIXMILLISEC_TODAY": "$_UNIXMILLISEC_TODAY",
  /** number unix but miliseconds now */
  "UNIXMILLISEC_NOW": "$_UNIXMILLISEC_NOW"
});

},{}],93:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// idees
// return log lengths
// calc time to sleep and return > need historical data
// detect overload if logs length === 0 > increase priority
// jumb to short polling > slower times 2
var connections = [];
var _serverIsOverloaded = false;
if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && window.api_util) {
  var lastTimeStampOverloadCookie = api_util.get_cookie("com.nixps.server-overload");
  if (typeof lastTimeStampOverloadCookie === "string" && lastTimeStampOverloadCookie.length > 0) {
    _serverIsOverloaded = true;
  }
}

/**
 * @constructor WhitepaperConnection
 * @description An object containing a connection to a whitepaper. With this you have an api like call to workflows. Create the object with the settings.
 * Call the start function and wait for the results, via a $.Deferred. This handles the polling itself.
 * @param {String} pWhitepaperName The name of the workflow
 * @param {String} pWhitepaperInputName The input name of the "Start from Kiosk" or the "Start from Web request"
 * @param {Object} pInputParameters The input parameters to be given to the "Start from ..." node
 * @param {Object} pConnection settings for the Start with DBIO, leave undefined for "Start from Kiosk and Start from Web Request"
 * @param {Boolean} pLongLive prevent stopping if leaving page, this connection may not be automaticaly aborted. Default is false 
 * @example var connection = new WhitepaperConnection("WhitepaperTest", "Input Name", {"type": "test", "value": 42})
 * @return {nm$_WhitepaperConnection.WhitepaperConnection}
 */
function WhitepaperConnection(pWhitepaperName, pWhitepaperInputName, pInputParameters, pConnection, pLongLive, pFiles) {
  this._setWhitepaper(pWhitepaperName);
  this._setWhitepaperInput(pWhitepaperInputName);
  this._setConnection(pConnection);
  this._setInputParameters(pInputParameters);
  this._setFiles(pFiles);
  if (window.nixps !== undefined && nixps.cloudflow !== undefined && nixps.cloudflow.LogListener !== undefined) {
    this._setForceFirstPolling(nixps.cloudflow.LogListener.isActive());
  } else {
    this._setForceFirstPolling(false);
  }
  this.setStartPollingTime(3);
  this.setPollingTime(3);
  this.workableID = null; // mongo id of the workable
  this.jacketID = null; // mongo id of the jacket
  this.isDead = false; // flag indicating of the connection is still alive, is still waiting for answers
  this.reasonToStop = null; // string containing the reason to abort or stop
  this.abortingStatus = null; // actual status of the aborting process
  this.started = false; // is the connection already started or not?
  this.startDate = null; // the start point when the connection is openend
  this.tooLongBussy = false; // flag indicating the connection time oversee a sertain time span
  connections.push(this);
  this.longlive = false; // is this connection of faital inportance and should not be aborted when the user session is done
  this._setLongLive(pLongLive);
  this.eventListenersDict = {};
  this.timeoutID = undefined; // timer id
  this.pauseStatus = "running";
  this.pausePromise = null;
}
;
WhitepaperConnection.prototype = {
  constructor: WhitepaperConnection,
  _setWhitepaper: function _setWhitepaper(pWhitepaperName) {
    if (typeof pWhitepaperName !== "string" || pWhitepaperName.length <= 0) {
      throw new Error("parameter whitepapername must be a not emtpy string");
    }
    this.whitepaper = pWhitepaperName;
  },
  _setWhitepaperInput: function _setWhitepaperInput(pWhitepaperInputName) {
    if (typeof pWhitepaperInputName !== "string" || pWhitepaperInputName.length <= 0) {
      throw new Error("parameter whitepapername must be a not emtpy string");
    }
    this.inputname = pWhitepaperInputName;
  },
  _setConnection: function _setConnection(pConnection) {
    if (pConnection && pConnection.connectionType === "database_proxy") {
      this.connectionType = "database_proxy";
      this.connectionFunctionName = pConnection.connectionFunctionName;
      this.connectionCallOptions = pConnection.connectionCallOptions;
    } else {
      this.connectionType = "hub";
      this.connectionFunctionName = "start_from";
      this.connectionCallOptions = {};
    }
  },
  _setInputParameters: function _setInputParameters(pInputParameters) {
    if (this.connectionType === "hub") {
      if (pInputParameters === undefined || pInputParameters === null) {
        this.inputparameters = {};
        return;
      }
      if (_typeof(pInputParameters) !== "object" || Array.isArray(pInputParameters)) {
        throw new Error("parameter pInputParameters must be a plain object");
      }
      this.inputparameters = structuredClone(pInputParameters);
    } else {
      if (pInputParameters === undefined || pInputParameters === null) {
        this.inputparameters = [];
        return;
      }
      if (Array.isArray(pInputParameters) === false) {
        throw new Error("parameter pInputParameters must be an array");
      }
      this.inputparameters = pInputParameters;
    }
  },
  _setFiles: function _setFiles(pFiles) {
    if (Array.isArray(pFiles)) {
      this.files = pFiles.slice(); // copy
    } else {
      this.files = null;
    }
  },
  _setLongLive: function _setLongLive(pLongLive) {
    if (pLongLive === true) {
      this.longlive = true;
    } else {
      // default value
      this.longlive = false;
    }
  },
  /**
   * @description set if we need to force the first polling or not, is justed durring debugging
   * @function
   * @name WhitepaperConnection#_setForceFirstPolling
   * @private
   * @param {Boolean} pForceFirstPolling 
   * @returns {undefined}
   */
  _setForceFirstPolling: function _setForceFirstPolling(pForceFirstPolling) {
    if (pForceFirstPolling === true) {
      this.forceFirstPolling = true;
    } else {
      this.forceFirstPolling = false;
    }
  },
  /**
   * @description Set the first timeout during start up on a different number.
   * @name WhitepaperConnection#setStartPollingTime
   * @function 
   * @param {Number} pStartPollingTime The delay in seconds
   * @return {undefined}
   */
  setStartPollingTime: function setStartPollingTime(pStartPollingTime) {
    if (typeof pStartPollingTime !== "number" || pStartPollingTime <= 0) {
      throw new Error("setStartPollingTime parameter must be a positive number");
    }
    this.startPollingTime = pStartPollingTime;
  },
  /**
   * @description Set delay between pollings on a different number (not the first one)
   * @name WhitepaperConnection#setPollingTime
   * @function
   * @param {Number} pPollingTime The delay in seconds
   * @return {undefined}
   */
  setPollingTime: function setPollingTime(pPollingTime) {
    if (typeof pPollingTime !== "number" || pPollingTime <= 0) {
      throw new Error("setPollingTime parameter must be a positive number");
    }
    this.pollingTime = pPollingTime;
  },
  /**
   * @description Check if the whitepaper and input exits or not?
   * @name WhitepaperConnection#exist
   * @function
   * @returns {Deferred} true if the whitepaper exists, false otherwise
   */
  exist: function exist() {
    return WhitepaperConnection.exist(this.whitepaper, this.inputname);
  },
  /**
   * @name WhitepaperConnection#getWorkableID
   * @description Get the current workable id if the polling has entered the first state or null
   * @function
   * @return {String} workableId or null
   */
  getWorkableID: function getWorkableID() {
    return this.workableID;
  },
  /**
   * @name WhitepaperConnection#getJacketID
   * @description Get the current jacket id if the polling has entered the first state or null
   * @function
   * @return {String} workableId or null
   */
  getJacketID: function getJacketID() {
    return this.jacketID;
  },
  /**
   * @description Must we use short or long polling
   * @function
   * @name WhitepaperConnection#_needShortPolling
   * @private
   * @returns {Boolean} true if we need to convert to short polling
   */
  _needShortPolling: function _needShortPolling() {
    return _serverIsOverloaded === true || this.tooLongBussy === true;
  },
  /**
   * @description Add an callbackfunction for an event
   * @function
   * @name WhitepaperConnection#addEventListener
   * @param {String} pEventName the name of the event
   * @param {Function} pFunction the callback function when the event occured
   */
  addEventListener: function addEventListener(pEventName, pFunction) {
    if (typeof pEventName !== "string" || pEventName.length <= 0) {
      throw new Error("parameter pEventname is missing");
    }
    if (typeof pFunction !== "function") {
      throw new Error("The eventlistener must be a function");
    }
    if (this.eventListenersDict[pEventName] === undefined) {
      this.eventListenersDict[pEventName] = [];
    }
    this.eventListenersDict[pEventName].push(pFunction);
  },
  /**
   * @description Remove an callbackfunction for an event, if no link found, it ignores
   * @function
   * @name WhitepaperConnection#removeEventListener
   * @param {String} pEventName the name of the event
   * @param {Function} pFunction the callback function when the event occured
   */
  removeEventListener: function removeEventListener(pEventName, pFunction) {
    if (typeof pEventName !== "string" || pEventName.length <= 0) {
      throw new Error("parameter pEventname is missing");
    }
    if (typeof pFunction !== "function") {
      throw new Error("The eventlistener must be a function");
    }
    if (Array.isArray(this.eventListenersDict[pEventName]) && this.eventListenersDict[pEventName].length > 0) {
      for (var i = this.eventListenersDict[pEventName].length - 1; i >= 0; i--) {
        if (this.eventListenersDict[pEventName][i] === pFunction) {
          this.eventListenersDict[pEventName].splice(i, 1);
        }
      }
    }
  },
  _dispatchEvent: function _dispatchEvent(pEventName, pEvent, pData) {
    if (typeof this["on" + pEventName] === "function") {
      this["on" + pEventName](pEvent, pData);
    }
    if (Array.isArray(this.eventListenersDict[pEventName]) && this.eventListenersDict[pEventName].length > 0) {
      for (var i = 0; i < this.eventListenersDict[pEventName].length; i++) {
        this.eventListenersDict[pEventName][i](pEvent, pData);
      }
    }
  },
  /**
   * @description check if a workable has already been started or not.
   * @function
   * @name WhitepaperConnection#isStarted
   * @returns {Boolean} true if the workable has started already
   */
  isStarted: function isStarted() {
    return this.started === true;
  },
  /**
   * @function
   * @description Check if the workable has been stopped by the stop methode 
   * @name  WhitepaperConnection#isAlive
   * @returns {Boolean} true if the workable has been aborted by the stop or not 
   */
  isAlive: function isAlive() {
    return this.isDead === false;
  },
  /**
   * @description Is the connection a long live allowed?
   * @function
   * @name WhitepaperConnection#hasLongLive
   * @returns {Boolean} true if the connection may live longer, false otherwise
   */
  hasLongLive: function hasLongLive() {
    return this.longlive;
  },
  /**
   * @description check if the connection known he need to pause
   * @function
   * @name WhitepaperConnection#isPaused
   * @returns {Boolean} true if the connection knows it need to pause
   */
  isPaused: function isPaused() {
    return this.pauseStatus === "waiting";
  },
  /**
   * @description pause the connection, it will stop polling on the next cycle
   * @function
   * @name WhitepaperConnection#pause
   * @returns {undefined}
   */
  pause: function pause() {
    if (this.isStarted() === false) {
      console.warn("pause asked when connection is not started yet");
    }
    this.pauseStatus = "waiting";
  },
  /**
   * @description restart polling when the connection is paused
   * @function
   * @name WhitepaperConnection#resume
   * @returns {undefined}
   */
  resume: function resume() {
    if (this.isPaused() && this.isAlive()) {
      this.pauseStatus = "running";
      if (this.pausePromise && typeof this.pausePromise.then === "function") {
        // restart polling
        this._polling(this.pausePromise);
      } else if (this.pausePromise === null) {
        // we resume before it could catch the next polling
      }
    }
  },
  /**
   * @name WhitepaperConnection#stop
   * @description Stop the polling and clean up, the user is not interested anymore in the results
   * @function
   * @return {undefined}
   */
  stop: function stop(pReason) {
    if (this.isAlive() === false) {
      return; // prevent killing dead connections ...
    }

    this._stop(pReason);
    this._abort();
    clearTimeout(this.timeoutID);
  },
  /**
   * @name WhitepaperConnection#_abort
   * @description abort the workable
   * @function
   * @private
   * @return {undefined}
   */
  _abort: function _abort() {
    if (this.getWorkableID() !== null && this.abortingStatus === null && window.api_async !== undefined && api_async.hub !== undefined) {
      var that = this;
      this.abortingStatus = "aborting";
      // only in case we have a workable id
      api_async.hub.abort_workable(this.getWorkableID(), false, function () {
        that.abortingStatus = "aborted";
      }, function (pError) {
        console.error(pError);
        that.abortingStatus = "error";
      });
    }
  },
  /**
   * @name WhitepaperConnection#_stop
   * @description Function runs when the connection is closed
   * @function
   * @private
   * @return {undefined}
   */
  _stop: function _stop(pReason) {
    this.isDead = true;
    if (typeof pReason === "string") {
      this.reasonToStop = pReason;
    } else {
      this.reasonToStop = "???";
    }
    // remove yourself of the list and do this async
    var that = this;
    setTimeout(function () {
      for (var i = 0; i < connections.length; i++) {
        if (connections[i] === that) {
          connections.splice(i, 1);
          break;
        }
      }
    });
  },
  /**
   * @name WhitepaperConnection#start
   * @description Start the workflow
   * @function
   * @return {Deferred}
   */
  start: function start() {
    if (this.isStarted() === true) {
      return $.Deferred().reject({
        "error": "no_restart"
      });
    }
    this.started = true;
    this.startDate = new Date();
    if (this.connectionType === "hub") {
      return this._startHub();
    } else {
      return this._startProxy();
    }
  },
  _startHub: function _startHub() {
    var that = this;
    if (this.forceFirstPolling === true || this.isPaused()) {
      // polling time is minimum a second, can not be smaller,
      // so do a normal start which garanties us a "jacket_id" and "workable_id"
      return $.Deferred(function (pDefer) {
        that.justStart(true).then(function () {
          that._polling(pDefer);
        }, pDefer.reject);
      });
    }
    return $.Deferred(function (pDefer) {
      var processDef;
      if (Array.isArray(that.files)) {
        processDef = api_defer.hub.process_from_whitepaper_with_files_and_variables(that.whitepaper, that.inputname, that.files, that.inputparameters, that._needShortPolling() ? 0.1 : that.startPollingTime);
      } else {
        processDef = api_defer.hub.process_from_whitepaper_with_variables(that.whitepaper, that.inputname, that.inputparameters, that._needShortPolling() ? 0.1 : that.startPollingTime);
      }
      processDef.then(function (pResults) {
        if (that.isAlive() === false) {
          if (pResults && pResults.workable_id !== undefined) {
            that.workableID = pResults.workable_id;
            that.jacketID = pResults.jacket_id;
            if (that.abortingStatus === null && pResults.timed_out === true) {
              that._abort();
            }
          }
          pDefer.reject({
            "error": "stop_called",
            "error_reason": that.reasonToStop,
            "debug": {
              "debug_type": "workflow",
              "whitepaperName": that.whitepaper,
              "whitepaperInputName": that.inputname
            }
          });
          return;
        }

        // do we get results ??
        if (pResults && pResults.timed_out === true && pResults.workable_id !== undefined) {
          that.workableID = pResults.workable_id;
          that.jacketID = pResults.jacket_id;
          var progressData = {
            workableID: that.workableID,
            jacketID: that.jacketID,
            nodeName: pResults.node_name,
            milestone: pResults.milestone,
            pollingCount: 0
          };
          pDefer.notify(progressData);
          that._dispatchEvent("progress", new ProgressEvent("progress", {
            lengthComputable: false
          }), progressData);
          that._polling(pDefer);
        } else if (pResults !== undefined && pResults.no_results === true) {
          that.workableID = pResults.workable_id;
          that.jacketID = pResults.jacket_id;
          var debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
          console.error("probably an error in the workflow " + that.whitepaper + " ! debug: " + window.location.origin + debugURL);
          pDefer.reject({
            "error": "no_results",
            "debug": {
              "debug_type": "workflow",
              "whitepaperName": that.whitepaper,
              "whitepaperInputName": that.inputname,
              "jacketID": pResults.jacket_id,
              "workableID": pResults.workable_id,
              "nodeName": pResults.node_name
            }
          });
        } else if (pResults && pResults.status === 303 && typeof pResults.content_type === "string" && pResults.contents !== undefined) {
          if (typeof pResults.contents === "string" && pResults.contents.length > 0) {
            var progressData = {
              action: "redirect",
              url: pResults.contents,
              defer: pDefer
            };
            pDefer.notify(progressData);
            that._dispatchEvent("progress", new ProgressEvent("progress", {
              lengthComputable: true,
              total: 1,
              loaded: 1
            }), progressData);
          } else {
            pDefer.reject({
              "error": "no_link_redirect",
              "debug": {
                "debug_type": "workflow",
                "whitepaperName": that.whitepaper,
                "whitepaperInputName": that.inputname
              }
            });
          }
        } else if (pResults && pResults.status >= 500 && pResults.status <= 599) {
          pDefer.reject(pResults.contents);
        } else {
          that._stop("end_success_call");
          pDefer.resolve(pResults);
        }
      }, function (pError) {
        console.error(pError);
        pDefer.reject(pError);
      });
    });
  },
  _startProxy: function _startProxy() {
    var that = this;
    return $.Deferred(function (pDefer) {
      var goodCallBack = function goodCallBack(pResults) {
        if (that.isAlive() === false) {
          if (pResults && pResults.workable_id !== undefined) {
            that.workableID = pResults.workable_id;
            that.jacketID = pResults.jacket_id;
            if (that.abortingStatus === null && pResults.timed_out === true) {
              that._abort();
            }
          }
          pDefer.reject({
            "error": "stop_called",
            "error_reason": that.reasonToStop,
            "debug": {
              "debug_type": "workflow",
              "whitepaperName": that.whitepaper,
              "whitepaperInputName": that.inputname
            }
          });
          return;
        }
        // do we get results ??
        if (pResults && pResults.timed_out === true && pResults.workable_id !== undefined) {
          that.workableID = pResults.workable_id;
          that.jacketID = pResults.jacket_id;
          var progressData = {
            workableID: that.workableID,
            jacketID: that.jacketID,
            nodeName: pResults.node_name,
            milestone: pResults.milestone,
            pollingCount: 0
          };
          pDefer.notify(progressData);
          that._dispatchEvent("progress", new ProgressEvent("progress", {
            lengthComputable: false
          }), progressData);
          that._polling(pDefer);
        } else if (pResults && pResults.no_results === true) {
          var debugURL;
          if (typeof pResults.workable_id === "string" && pResults.workable_id.length > 0) {
            that.workableID = pResults.workable_id;
            that.jacketID = pResults.jacket_id;
            debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
          } else {
            debugURL = "/portal.cgi?quantum&whitepaperName=" + that.whitepaper;
          }
          console.error("probably an error in the workflow " + that.whitepaper + " ! debug: " + window.location.origin + debugURL);
          pDefer.reject({
            "error": "no_results",
            "debug": {
              "debug_type": "workflow",
              "whitepaperName": that.whitepaper,
              "whitepaperInputName": that.inputname,
              "jacketID": pResults.jacket_id,
              "workableID": pResults.workable_id,
              "nodeName": pResults.node_name
            }
          });
        } else {
          that._stop("end_success_call");
          pDefer.resolve(pResults);
        }
      };
      var errorCallback = function errorCallback(pError) {
        console.error(pError);
        pDefer.reject(pError);
      };
      if (that.forceFirstPolling === true || that.isPaused() || that._needShortPolling()) {
        that.connectionCallOptions.time_out = 0.1;
      } else {
        that.connectionCallOptions.time_out = that.startPollingTime;
      }
      var apiCallArguments = [{
        "whitepaper_name": that.whitepaper,
        "input_name": that.inputname
      }].concat(that.inputparameters);
      apiCallArguments = apiCallArguments.concat([that.connectionCallOptions, goodCallBack, errorCallback]);
      api_async.database_proxy[that.connectionFunctionName].apply(api_async.database_proxy, apiCallArguments);
    });
  },
  _polling: function _polling(pDefer) {
    var that = this;
    // prevent loop when pauze is activated
    if (this.pauseStatus === "waiting") {
      if (this.pausePromise === null) {
        this.pausePromise = pDefer;
      }
      return;
    }
    // if user need to wait too long, swith to short polling
    if (this.tooLongBussy === false && this.startDate && +this.startDate + 15000 < +new Date()) {
      this.tooLongBussy = true;
    }
    var pollingDef;
    if (this._needShortPolling() === false) {
      // normal process
      pollingDef = this._pollResults(pDefer);
    } else {
      // panic mode
      clearTimeout(this.timeoutID);
      pollingDef = $.Deferred();
      var timeToWait;
      if (_serverIsOverloaded === true) {
        timeToWait = Math.min(2147483600 - 1, Math.max(this.pollingTime, 5) * 1000);
      } else if (this.tooLongBussy === true) {
        timeToWait = Math.min(2147483600 - 1, this.pollingTime * 1000);
      } else {
        // should not come here
        timeToWait = Math.max(this.pollingTime * 1000, 4);
      }
      this.timeoutID = setTimeout(function () {
        that._pollResults(pDefer).then(pollingDef.resolve, pollingDef.reject);
      }, timeToWait);
    }
    pollingDef.done(function (pResults) {
      that._stop("end_success_call");
      pDefer.resolve(pResults);
    }).fail(function (pError) {
      if (that.isAlive() === false) {
        // do nothing, 
        // just prevent further action, if element is zomby
        pDefer.reject({
          "error": "stop_called",
          "error_reason": that.reasonToStop,
          "debug": {
            "debug_type": "workflow",
            "whitepaperName": that.whitepaper,
            "whitepaperInputName": that.inputname
          }
        });
        return;
      } else if (pError === "wait") {
        that._polling(pDefer);
      } else {
        console.error(pError);
        if (pError && pError.debug === undefined) {
          pError.debug = {
            "debug_type": "workflow",
            "whitepaperName": that.whitepaper,
            "whitepaperInputName": that.inputname,
            "jacketID": that.jacketID,
            "workableID": that.workableID
          };
          if (pError.error_code === "Workable does not exist") {
            delete pError.debug.jacketID;
            delete pError.debug.workableID;
          }
        }
        pDefer.reject(pError);
      }
    });
  },
  _pollResults: function _pollResults(pDefer) {
    if (this.connectionType === "hub") {
      return this._pollResultsHub(pDefer);
    } else {
      return this._pollResultsProxy(pDefer);
    }
  },
  _pollResultsHub: function _pollResultsHub(pPreviousDefer) {
    var that = this;
    return $.Deferred(function (pDefer) {
      api_async.hub.poll_for_workable_result(that.workableID, that._needShortPolling() ? 0.1 : that.pollingTime, function (pResults) {
        if (that.isAlive() === false) {
          pDefer.reject({
            "error": "stop_called",
            "error_reason": that.reasonToStop,
            "debug": {
              "debug_type": "workflow",
              "whitepaperName": that.whitepaper,
              "whitepaperInputName": that.inputname
            }
          });
          return;
        }
        if (pResults && pResults.timed_out === true) {
          if (typeof pResults.milestone === "string" || typeof pResults.node_name === "string") {
            var progressData = {
              workableID: that.workableID,
              jacketID: that.jacketID,
              nodeName: pResults.node_name,
              milestone: pResults.milestone
            };
            pPreviousDefer.notify(progressData);
            that._dispatchEvent("progress", new ProgressEvent("progress", {
              lengthComputable: false
            }), progressData);
          }
          // waiting
          pDefer.reject("wait");
        } else if (pResults && pResults.no_results === true) {
          var debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
          console.error("probably an error in the workflow " + that.whitepaper + " ! debug: " + window.location.origin + debugURL);
          pDefer.reject({
            "error": "no_results",
            "debug": {
              "debug_type": "workflow",
              "whitepaperName": that.whitepaper,
              "whitepaperInputName": that.inputname,
              "jacketID": pResults.jacket_id,
              "workableID": pResults.workable_id,
              "nodeName": pResults.node_name
            },
            "milestone": pResults.milestone
          });
        } else if (pResults && pResults.result !== undefined && pResults.result.status === 303 && typeof pResults.result.content_type === "string" && pResults.result.contents !== undefined) {
          if (typeof pResults.result.contents === "string" && pResults.result.contents.length > 0) {
            var progressData = {
              action: "redirect",
              url: pResults.result.contents,
              defer: pPreviousDefer
            };
            pPreviousDefer.notify(progressData);
            that._dispatchEvent("progress", new ProgressEvent("progress", {
              lengthComputable: true,
              total: 1,
              loaded: 1
            }), progressData);
          } else {
            var debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
            console.error("debug: " + window.location.origin + debugURL);
            pDefer.reject({
              "error": "no_link_redirect",
              "debug": {
                "debug_type": "workflow",
                "whitepaperName": that.whitepaper,
                "whitepaperInputName": that.inputname,
                "jacketID": pResults.jacket_id,
                "workableID": pResults.workable_id,
                "nodeName": pResults.node_name
              }
            });
          }
        } else if (pResults && pResults.result !== undefined && pResults.result.status >= 500 && pResults.result.status <= 599) {
          pDefer.reject(pResults.result.contents);
        } else {
          pDefer.resolve(pResults.result);
        }
      }, function (pError) {
        console.error(pError);
        pDefer.reject(pError);
      });
    });
  },
  _pollResultsProxy: function _pollResultsProxy(pPreviousDefer) {
    var that = this;
    return $.Deferred(function (pDefer) {
      api_async.database_proxy.poll_for_result(that.workableID, that._needShortPolling() ? 0.1 : that.pollingTime, function (pResults) {
        if (that.isAlive() === false) {
          pDefer.reject({
            "error": "stop_called",
            "error_reason": that.reasonToStop,
            "debug": {
              "debug_type": "workflow",
              "whitepaperName": that.whitepaper,
              "whitepaperInputName": that.inputname
            }
          });
          return;
        }
        if (pResults && pResults.timed_out === true) {
          if (typeof pResults.milestone === "string" || typeof pResults.node_name === "string") {
            var progressData = {
              workableID: that.workableID,
              jacketID: that.jacketID,
              nodeName: pResults.node_name,
              milestone: pResults.milestone
            };
            pPreviousDefer.notify(progressData);
            that._dispatchEvent("progress", new ProgressEvent("progress", {
              lengthComputable: false
            }), progressData);
          }
          // waiting
          pDefer.reject("wait");
        } else if (pResults && pResults.no_results === true) {
          var debugURL;
          if (typeof pResults.workable_id === "string" && pResults.workable_id.length > 0) {
            debugURL = "/portal.cgi?quantum&jacketId=" + pResults.jacket_id + "&workableId=" + pResults.workable_id;
          } else {
            debugURL = "/portal.cgi?quantum&whitepaperName=" + that.whitepaper;
          }
          console.error("probably an error in the workflow " + that.whitepaper + " ! debug: " + window.location.origin + debugURL);
          pDefer.reject({
            "error": "no_results",
            "debug": {
              "debug_type": "workflow",
              "whitepaperName": that.whitepaper,
              "whitepaperInputName": that.inputname,
              "jacketID": pResults.jacket_id,
              "workableID": pResults.workable_id
            }
          });
        } else {
          pDefer.resolve(pResults);
        }
      }, function (pError) {
        console.error(pError);
        pDefer.reject(pError);
      });
    });
  },
  /**
   * @description Just start and do not wait for results
   * @function
   * @name WhitepaperConnection#justStart
   * @return {Deferred}
   */
  justStart: function justStart(pIgnoreCheckes) {
    if (pIgnoreCheckes !== true) {
      if (this.isStarted() === true) {
        return $.Deferred().reject({
          "error": "no_restart"
        });
      }
    }
    this.started = true;
    this.startDate = new Date();
    var that = this;
    return $.Deferred(function (pDefer) {
      var files = [];
      if (Array.isArray(that.files)) {
        files = that.files;
      }
      api_async.hub.start_from_whitepaper_with_files_and_variables(that.whitepaper, that.inputname, files, that.inputparameters, function (pResults) {
        that.workableID = pResults.workable_id;
        that.jacketID = pResults.jacket_id;
        pDefer.resolve({
          workableID: that.workableID,
          jacketID: that.jacketID
        });
      }, function (pError) {
        console.error(pError);
        pDefer.reject(pError);
      });
    });
  },
  /**
   * @description Run a httpService. This will run a script on the server and will return directly. This does not requires workers or workables
   * @function
   * @name WhitepaperConnection#httpService
   * @return {Promise}
   */
  httpService: function httpService() {
    var promiseDict = Promise.withResolvers();
    var xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
      if (xhttp.status < 200 || xhttp.status > 299) {
        var errorObject = {
          error_code: "http",
          error: xhttp.statusText
        };
        if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
          try {
            errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
          } catch (e) {}
        }
        promiseDict.reject(errorObject);
      } else {
        if (typeof xhttp.responseText === "string") {
          var data = null;
          if (xhttp.responseText.length === 0) {
            promiseDict.resolve({});
          } else if (xhttp.responseText.length > 0) {
            try {
              data = JSON.parse(xhttp.responseText);
            } catch (e) {
              promiseDict.reject({
                error_code: "content_not_json",
                error: e.message
              });
              return;
            }
            promiseDict.resolve(data);
          }
        } else {
          promiseDict.reject({
            "error_code": "missing_response",
            "error": "response is missing"
          });
        }
      }
    };
    xhttp.onerror = function () {
      var errorObject = {
        error_code: "http_error_load",
        error: xhttp.statusText
      };
      if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
        try {
          errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
        } catch (e) {}
      }
      promiseDict.reject(errorObject);
    };
    xhttp.onabort = function () {
      promiseDict.reject({
        error_code: "abort",
        error: "connection has been aborted"
      });
    };
    // encode to be able to pass a '#' charater
    xhttp.open("post", "/portal.cgi?http_service=" + encodeURIComponent(this.inputname) + "&whitepaper=" + encodeURIComponent(this.whitepaper));
    xhttp.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
    xhttp.send(JSON.stringify(this.inputparameters));
    return promiseDict.promise;
  },
  /**
   * @description If a workable is already fired, try to catch up and follow that workable.
   * So no need to create a second workable
   * @function
   * @name WhitepaperConnection#catchup
   * @param {Object} pJacketSettings containing workable_id and jacket_id
   * @return {Deferred}
   * @example whitepaperConnection.catchup({
   *      workable_id: "581afff771bc000000000005",
   *      jacket_id: "631ae550e0f1192dee5464f5",
   * });
   */
  catchup: function catchup(pJacketSettings) {
    if (this.isStarted() === true) {
      return $.Deferred().reject({
        "error": "no_restart"
      });
    }
    this.workableID = pJacketSettings.workable_id;
    this.jacketID = pJacketSettings.jacket_id;
    var that = this;
    return $.Deferred(function (pDefer) {
      that._polling(pDefer);
    });
  }
};

/**
 * @description Is there a whitepaper with this specific name?
 * @function
 * @static
 * @name WhitepaperConnection.exist
 * @param {String} pWhitepaper the name of the workflow
 * @param {String} pInputName the start from kiosk
 * @returns {Deferred}
 */
WhitepaperConnection.exist = function (pWhitepaper, pInputName) {
  return api_defer.hub.get_whitepaper_input_options(pWhitepaper, pInputName).then(function (pResults) {
    if (pResults && _typeof(pResults) === "object" && Object.keys(pResults).length > 0) {
      return true;
    } else {
      return false;
    }
  }, function (pError) {
    if (pError !== undefined && pError.error_code === "WhitePaper not found") {
      return false;
    } else if (pError !== undefined && pError.error_code === "Input not found in WhitePaper") {
      return false;
    } else {
      console.error(pError);
      // other errors;
      return false;
    }
  });
};

/**
 * @description parse the input to a user friendly string
 * @function
 * @static
 * @name WhitepaperConnection.parseMilestone
 * @param {Mixed} pInput the input to parse
 * @param {String} pLanguage the current language of the user
 * @returns {String} parsed output
 */
WhitepaperConnection.parseMilestone = function (pInput) {
  var pLanguage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
  if (typeof pLanguage !== "string" || pLanguage.length <= 1) {
    throw new Error("parameter language is missing or invalid");
  }
  if (pInput === undefined || pInput === null) {
    return "";
  }
  if (pInput && _typeof(pInput) === "object") {
    if (typeof pInput[pLanguage] === "string") {
      return pInput[pLanguage];
    } else if (typeof pInput["en"] === "string") {
      return pInput["en"];
    }
    return JSON.stringify(pInput);
  } else if (typeof pInput === "string" && pInput.length > 0) {
    try {
      var obj = JSON.parse(pInput);
      if (typeof obj[pLanguage] === "string") {
        return obj[pLanguage];
      } else if (typeof obj["en"] === "string") {
        return obj["en"];
      }
    } catch (e) {/* ignore it is a normal string*/}
  }
  return "" + pInput;
};

/**
 * @description only used for internal use, 
 * @param {String} pKey 
 * @param {Mixed} pValue 
 * @private
 */
WhitepaperConnection._setStatus = function (pKey, pValue) {
  if (pKey === "_serverIsOverloaded") {
    _serverIsOverloaded = !!pValue;
  }
};
if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") {
  if (window.addEventListener) {
    // handle quitting page
    // abort all running workables, if they are still running
    window.addEventListener("beforeunload", function (event) {
      for (var i = 0; i < connections.length; i++) {
        if (connections[i].hasLongLive() === true) {
          continue; // do not kill long lived connections
        }

        connections[i].stop("quit_page");
      }
    });
    document.addEventListener("visibilitychange", function () {
      if (document.hidden === true) {
        for (var i = 0; i < connections.length; i++) {
          connections[i].pause();
        }
      } else if (document.hidden === false) {
        for (var i = 0; i < connections.length; i++) {
          connections[i].resume();
        }
      }
    });
  }
  if (typeof window.BroadcastChannel === "function") {
    var nixpsBroadcast = new BroadcastChannel("nixps");
    nixpsBroadcast.onmessage = function (pEvent) {
      if (pEvent && pEvent.data) {
        if (pEvent.data.type === "nixps.error.server_overload") {
          _serverIsOverloaded = true;
        } else if (pEvent.data.type === "nixps.error.server_overload_reset") {
          _serverIsOverloaded = false;
        }
      }
    };
  }
}
module.exports = WhitepaperConnection;

},{}],94:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

(function () {
  if (window.nixps === undefined) {
    window.nixps = {};
  }
  if (nixps.cloudflowutil === undefined) {
    nixps.cloudflowutil = {};
  }
  /**
   * @description this function gives you tools to handle with filenames.
   * @class
   * @namespace nixps.cloudflowutil.NameToolKit
   * @private
   */
  nixps.cloudflowutil.NameToolKit = {
    /**
     * @function 
     * @name nixps.cloudflowutil.NameToolKit#getNameSequence
     * @description search and calculate the next sequence name
     * @param {Array<String>} nameList
     * @param {String} name
     * @returns {String} the next sequence name 
     */
    getNameSequence: function getNameSequence(nameList, name, pCountSeparator) {
      // control if name exists
      var found = false;
      for (var i = 0; i < nameList.length; i++) {
        if (nameList[i] === name) {
          found = true;
          break;
        }
      }
      if (found === false) {
        // the name itself does not exists, so name is good candidate
        return name;
      } else {
        var separator;
        if (typeof pCountSeparator === "string") {
          separator = pCountSeparator;
        } else {
          separator = " ";
        }
        found = false;
        var count = 1;
        // control if name 1 exists?
        //         if name 2 exists?
        //          ....
        for (var j = 0; j < nameList.length; j++) {
          var searchName = name + separator + count;
          for (var k = 0; k < nameList.length; k++) {
            if (nameList[k] === searchName) {
              found = true;
              break;
            }
          }
          if (found === false) {
            // not found, good then this is the good candidate for a new name
            return searchName;
          } else {
            // found, bad ...very sad, reset and retry
            found = false;
            count++;
          }
        }
      }
      // there is something wrong with the algoritme. 
      // throw error like in the past.
      throw new Error("wrong name in list");
    }
  };
})();

},{}],95:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global $, alert, setTimeout, namespace, nixps */
/*global jQuery*/
(function ($) {
  require("../../../polyfill/polyfill.js");
  if (typeof $.fn.ListView !== "function") {
    require("../../ListView/js/nixps-cloudflow-ListView.js");
  }
  if (typeof $.fn.IconView !== "function") {
    require("../../IconView/js/nixps-cloudflow-IconView.js");
  }
  if (typeof $.fn.ReaderView !== "function") {
    require("../../IconView/js/nixps-cloudflow-ReaderView.js");
  }

  /**
  * @desc the options to lock down a view (readersview)
  * @private
  * @type object
  */
  var kLockViewOptions = {
    "showUploadIcon": false,
    "showViewIcon": false
  };

  /**
  * @desc the options to unlock a view (readersview)
  * @private
  * @type object
  */
  var kUnlockViewOptions = {
    // "showUploadIcon": true,
    // "showViewIcon": true
    "showUploadIcon": false,
    "showViewIcon": false
  };

  /**
   * @description The amount of files/pages we want to limit the book view
   * @static
   * @type Number
   * @private
   */
  var kLimitBookViewPages = 30000;

  /**
   * @description The max amount to load files, when the system suppose to load all the files
   * @static
   * @type Number
   * @private
   */
  var kMaxLimitAssets = 500000;

  /**
   * @description The number of asset to be loaded if no number is given.
   * @static
   * @type Number
   * @private
   */
  var kInitLimit = 200;
  var eventTypeRegExp = new RegExp("^(listview|iconview|readerview)(.+)$");

  /**
   * @namespace nixps-cloudflow.CombinedView
   * @description layer between item (like asstes) provider and show components
   * This can trigger "action", "contextmenu", "select", "open"
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.CombinedView", {
    widgetEventPrefix: "combinedview",
    options: {
      /**
       * @name nixps-cloudflow.CombinedView#view
       * @description Choose the view. You can coose between "icon", "list", "reader", "iconChooser",
       * IconChooser, means that the component will switch to the best fitting view
       * @type {String}
       * @default list
       */
      view: "list",
      /**
       * @name nixps-cloudflow.CombinedView#lockFolder
       * @desc must the current folder be locked or not, this is now only possible on icon/readers view
       * @type {Boolean}
       * @default false
      */
      lockFolder: false,
      /**
       * @name nixps-cloudflow.CombinedView#showDownloadIcon
       * @description Is the user allowed to download assets?
       * @type {Boolean}
       * @default false
       */
      showDownloadIcon: false,
      /**
       * @name nixps-cloudflow.CombinedView#enableAssetDragging
       * @description Is the user allowed to drag and drop files?
       * @type {Boolean}
       * @default false
       */
      enableAssetDragging: false,
      /**
       * @name nixps-cloudflow.CombinedView#enableSelecting
       * @description enable file and folder selection
       * @type {Boolean}
       * @default false
       */
      enableSelecting: false,
      /**
       * @name nixps-cloudflow.CombinedView#enableMultipleSelection
       * @description if enableSelection is set on true, are we allowed to select multiple files or can we only select one a time
       * @type {Boolean}
       * @default true
       */
      enableMultipleSelection: true,
      fastMultipleSelection: false,
      deselectWhenRowClick: false,
      disableSorting: false,
      /**
       * @name nixps-cloudflow.CombinedView#enableContextMenu
       * @description Must we enable the contextmenu
       * @type {Boolean}
       * @default false
       */
      enableContextMenu: false,
      /**
       * @name nixps-cloudflow.CombinedView#iconWidth
       * @description the with of the icons in icon view
       * @type {Number}
       * @default 150
       */
      iconWidth: 150,
      /**
       * @name nixps-cloudflow.CombinedView#bodyClasses
       * @description classes to be given to the list view
       * @type {String}
       * @default undefined
       */
      bodyClasses: undefined,
      columns: [],
      files: [],
      folders: []
    },
    _create: function _create() {
      if (typeof this.options.showDownloadIcon !== "boolean") {
        throw new Error("option showDownloadIcon must be a boolean");
      }
      if (typeof this.options.enableAssetDragging !== "boolean") {
        throw new Error("option enableAssetDragging must be a boolean");
      }
      this.element.addClass(this.widgetFullName);
      this.orderBy = this.options.orderBy;
      // this is the amount to ask to backend, and not the amount of files to see!!
      this.askingLimit = kInitLimit + 1;

      // add actions column only for list view and only if not added already
      if (this.options.showDownloadIcon === true) {
        this.columns = [].concat(this.options.columns).concat(["actions"]);
      } else {
        this.columns = this.options.columns;
      }
      this.m_iconview = $("<div>");
      this.element.append(this.m_iconview);
      this.m_iconview.IconView({
        showDownloadIcon: this.options.showDownloadIcon,
        enableAssetDragging: this.options.enableAssetDragging,
        enableSelecting: this.options.enableSelecting,
        enableMultipleSelection: this.options.enableMultipleSelection,
        fastMultipleSelection: this.options.fastMultipleSelection,
        enableContextMenu: this.options.enableContextMenu,
        iconWidth: this.options.iconWidth,
        orderBy: this.orderBy,
        limit: this.askingLimit - 1
      }).hide();
      this.m_readerview = $("<div>");
      this.element.append(this.m_readerview);
      var readersViewOptions = {
        limit: kLimitBookViewPages,
        iconWidth: this.options.iconWidth,
        enableContextMenu: this.options.enableContextMenu
      };
      if (this.options.lockFolder === true) {
        readersViewOptions = Object.assign({}, readersViewOptions, kLockViewOptions);
      }
      this.m_readerview.ReaderView(readersViewOptions);
      this.m_readerview.hide();
      this.m_listview = $("<div>");
      this.element.append(this.m_listview);
      this.m_listview.ListView({
        columns: this.columns,
        showDownloadIcon: this.options.showDownloadIcon,
        enableAssetDragging: this.options.enableAssetDragging,
        enableSelecting: this.options.enableSelecting,
        enableMultipleSelection: this.options.enableMultipleSelection,
        fastMultipleSelection: this.options.fastMultipleSelection,
        deselectWhenRowClick: this.options.deselectWhenRowClick,
        enableContextMenu: this.options.enableContextMenu,
        bodyClasses: this.options.bodyClasses,
        orderBy: this.orderBy,
        limit: this.askingLimit - 1
      }).hide();
      this._redraw();
      this._on(this.element, {
        "iconviewopen": this._forwardEvent,
        "listviewopen": this._forwardEvent,
        "readerviewopen": this._forwardEvent,
        "readerviewaction": this._forwardEvent,
        "readerviewselect": this._forwardEvent,
        "iconviewselect": this._forwardEvent,
        "listviewselect": this._forwardEvent,
        "listviewsearch": this._forwardEvent,
        "iconviewcontextmenu": this._contextmenuHandler,
        "listviewcontextmenu": this._contextmenuHandler,
        "readerviewcontextmenu": this._contextmenuHandler,
        "contextmenu": this._otherContectmenuHandler,
        "listviewdataprovider": this._dataProviderHandler,
        "iconviewdataprovider": this._dataProviderHandler,
        "readerviewdataprovider": this._dataProviderHandler,
        "listviewrefreshfinished": this._forwardEvent,
        "iconviewrefreshfinished": this._forwardEvent,
        "readerviewrefreshfinished": this._forwardEvent,
        "listviewselectbytypingfinished": this._forwardEvent,
        "dragstart": this._dragstartHandler,
        "dragstop": this._dragendHandler
      });
      this.keyDownHandler = this._keyDownHandler.bind(this);
      if (this.options.enableSelecting === true) {
        $(this.element).on("keydown", this.keyDownHandler);
      }
    },
    /**
     * @description Set the preferences, used for orderBy on default
     * @function
     * @name nixps-cloudflow.CombinedView#initPreferences
     * @param {object} pPreferences
     * @returns {undefined}
     */
    initPreferences: function initPreferences(pPreferences) {
      this.preferences = pPreferences;
      var changeoptions = {};
      // set the amount of assets to load
      if (this.preferences !== undefined && typeof this.preferences.assetLimit === "number" && this.preferences.assetLimit > 0) {
        this.askingLimit = this.preferences.assetLimit + 1;
        changeoptions.limit = this.preferences.assetLimit;
        changeoptions.stepSize = this.preferences.assetLimit;
        // for the moment no influence on readersView!
      }
      // set the orderBy array preferences
      if (Array.isArray(this.options.initOrderBy) && this.options.initOrderBy.length > 0) {
        // do not set orderBy of preferences 
        // if initOrderBy is set!
        // return false;
      } else if (this.preferences !== undefined && typeof this.preferences.fileorder === "string" && this.preferences.fileorder.length > 0 && typeof this.preferences.fileasc === "boolean") {
        this.orderBy = [this.preferences.fileorder, this.preferences.fileasc ? "ascending" : "descending"];
        changeoptions.orderBy = this.orderBy;
      }
      if ($.isEmptyObject(changeoptions) === false) {
        this.m_listview.ListView("changeOptionsSilence", changeoptions);
        this.m_iconview.IconView("changeOptionsSilence", changeoptions);
      }
    },
    _actionHandler: function _actionHandler(pEvent, pData) {
      this._trigger("action", pEvent, pData);
    },
    _fileSelectHandler: function _fileSelectHandler(pEvent, pData) {
      this._trigger("select", pEvent, pData);
    },
    _dragstartHandler: function _dragstartHandler(pEvent, pData) {
      if (pData === undefined) {
        // is dragging event outside jquery, do nothing
        return true;
      }
      $(pEvent.target).closest(".ui-draggable").addClass("ui-draging-source");
    },
    _dragendHandler: function _dragendHandler(pEvent, pData) {
      $(pEvent.target).closest(".ui-draggable").removeClass("ui-draging-source");
    },
    /**
     * @description function runs when user right click on a asset
     * @function
     * @private
     * @name nixps-cloudflow.CombinedView#_contextmenuHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _contextmenuHandler: function _contextmenuHandler(pEvent, pData) {
      // add transparent layer to catch all click events
      var protectLayer = $("<div>").addClass("assetview_contextmenu_protectlayer").css({
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        background: "transparent"
        //background: "rgba(150,12,69, 0.5)"
      });

      this.element.append(protectLayer);
      // add style contextmenu
      if (pData !== undefined && pData.targetDOMElement !== undefined && pData.targetDOMElement.length === 1) {
        pData.targetDOMElement.addClass("folderview_contextmenu_item");
      }
      // inform others
      this._trigger("contextmenu", pEvent.originalEvent, pData);
    },
    /**
     * @description function runs when a contextmenu is triggered
     * @function
     * @private
     * @name nixps-cloudflow.CombinedView#_otherContectmenuHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _otherContectmenuHandler: function _otherContectmenuHandler(pEvent, pData) {
      // the contextmenu should 
      if (this.options.enableContextMenu === true && nixps.contextmenu !== false) {
        // prevent open context menu
        // but must bubbel up
        pEvent.preventDefault();
      }
    },
    /**
     * @description Stop the contextmenu 
     * @funtion
     * @name nixps-cloudflow.CombinedView#cleanContextmenuLayer
     * @return {undefined}
     */
    cleanContextmenuLayer: function cleanContextmenuLayer() {
      var layer = this.element.find(".assetview_contextmenu_protectlayer");
      if (layer !== undefined && layer.length >= 1) {
        // only continue if there is still the layer
        this.element.find(".assetview_contextmenu_protectlayer").remove();
        // stop context styling
        this.element.find(".folderview_contextmenu_item").removeClass("folderview_contextmenu_item");
      }
    },
    /**
     * @description function runs when user press a key
     * @function
     * @private
     * @name nixps-cloudflow.CombinedView#_keyDownHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _keyDownHandler: function _keyDownHandler(pEvent, pData) {
      if ($("input:focus, textarea:focus, select:focus, [contenteditable]:focus").length === 1) {
        return true;
      }
      if (pEvent.which === $.ui.keyCode.UP) {
        if (this.m_iconview.is(":visible")) {
          this.m_iconview.IconView("moveSelected", pEvent, "up");
        } else if (this.m_listview.is(":visible")) {
          this.m_listview.ListView("moveSelected", pEvent, "up");
        } else if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("moveSelected", pEvent, "up");
        }
      } else if (pEvent.which === $.ui.keyCode.DOWN) {
        if (this.m_iconview.is(":visible")) {
          this.m_iconview.IconView("moveSelected", pEvent, "down");
        } else if (this.m_listview.is(":visible")) {
          this.m_listview.ListView("moveSelected", pEvent, "down");
        } else if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("moveSelected", pEvent, "down");
        }
      } else if (pEvent.which === $.ui.keyCode.LEFT) {
        if (this.m_iconview.is(":visible")) {
          this.m_iconview.IconView("moveSelected", pEvent, "left");
        } else if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("moveSelected", pEvent, "left");
        }
      } else if (pEvent.which === $.ui.keyCode.RIGHT) {
        if (this.m_iconview.is(":visible")) {
          this.m_iconview.IconView("moveSelected", pEvent, "right");
        } else if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("moveSelected", pEvent, "right");
        }
      } else if (pEvent.which === $.ui.keyCode.ENTER) {
        var assets = this.getSelectedItems();
        if (Array.isArray(assets) && assets.length === 1 && assets[0].cloudflow !== undefined) {
          this._trigger("open", pEvent, assets[0]);
        }
      }
    },
    _dataProviderHandler: function _dataProviderHandler(pEvent, pData) {
      this.orderBy = pData.orderBy;
      this.askingLimit = pData.limit;
      this._forwardEvent(pEvent, pData);
    },
    _forwardEvent: function _forwardEvent(pEvent, pData) {
      var match = pEvent.type.match(eventTypeRegExp);
      if (match.length >= 3) {
        this._trigger(match[2], pEvent, pData);
      }
    },
    _redraw: function _redraw() {
      if (Array.isArray(this.options.files)) {
        this.m_files = this.options.files;
      }
      if (Array.isArray(this.options.folders)) {
        this.m_folders = this.options.folders;
      }
      if (this.options.view === "list") {
        this.m_listview.show();
        this.m_iconview.hide();
        this.m_readerview.hide();
        this.m_listview.ListView("option", {
          "columns": this.columns,
          "limit": this.askingLimit - 1,
          "files": this.m_files,
          "folders": this.m_folders
        });
      } else if (this.options.view === "icon") {
        this.m_listview.hide();
        this.m_iconview.show();
        this.m_readerview.hide();
        this.m_iconview.IconView({
          "orderBy": this.orderBy,
          "limit": this.askingLimit - 1,
          "files": this.m_files,
          "folders": this.m_folders
        });
      } else if (this.options.view === "reader") {
        // if needed, ask immediatly for the rest of files...
        // this is needed if there is a overflow, but do not repeat!
        if (this.m_files.length === this.askingLimit && this.askingLimit < kLimitBookViewPages) {
          this.askingLimit = kLimitBookViewPages;
          this.orderBy = []; // sorting done by readerView component
        }

        var readerOptions = {
          "folders": this.m_folders,
          "files": this.m_files
        };
        if (this.options.lockFolder === true) {
          readerOptions = Object.assign(readerOptions, kLockViewOptions);
        } else {
          readerOptions = Object.assign(readerOptions, kUnlockViewOptions);
        }
        this.m_listview.hide();
        this.m_iconview.hide();
        this.m_readerview.show();
        this.m_readerview.ReaderView("option", readerOptions);
      } else if (this.options.view === "iconChooser") {
        throw new Error("unsupported");
      } else {
        throw new Error("Unkown option view :" + this.options.view);
      }
    },
    selectByTyping: function selectByTyping(pSearchString) {
      if (this.options.view === "list") {
        this.m_listview.ListView("selectByTyping", pSearchString);
      } else if (this.options.view === "icon") {
        this.m_iconview.IconView("selectByTyping", pSearchString);
      } else if (this.options.view === "reader") {
        //not supported
      }
    },
    _setOptions: function _setOptions(p_options) {
      // add actions column only for list view and only if not added already
      var iconChangeOptions = {};
      var listChangeOptions = {};
      if (Array.isArray(p_options.columns) && _.isEqual(p_options.columns, this.options.columns) === false) {
        // columns change
        this.columns = p_options.columns;
        if (p_options.showDownloadIcon === true || p_options.showDownloadIcon === undefined && this.options.showDownloadIcon === true) {
          this.columns = [].concat(this.columns).concat(["actions"]);
        }
        listChangeOptions.columns = this.columns;
      } else {
        // no columns changes
        // perhapse download change
        if (p_options.showDownloadIcon === true) {
          this.columns = this.options.columns;
          this.columns = [].concat(this.columns).concat(["actions"]);
          listChangeOptions.columns = this.columns;
        }
      }
      if (p_options.showDownloadIcon === true && this.options.showDownloadIcon === false) {
        // reset option download asset
        iconChangeOptions.showDownloadIcon = true;
      }
      if (typeof p_options.enableAssetDragging === "boolean" && p_options.enableAssetDragging !== this.options.enableAssetDragging) {
        // reset option dragging asset
        iconChangeOptions.enableAssetDragging = p_options.enableAssetDragging;
        listChangeOptions.enableAssetDragging = p_options.enableAssetDragging;
      }
      if (typeof p_options.enableSelecting === "boolean" && p_options.enableSelecting !== this.options.enableSelecting) {
        iconChangeOptions.enableSelecting = p_options.enableSelecting;
        listChangeOptions.enableSelecting = p_options.enableSelecting;
        if (iconChangeOptions.enableSelecting === true) {
          $(this.element).on("keydown", this.keyDownHandler);
        } else {
          $(this.element).off("keydown", this.keyDownHandler);
        }
      }
      if (typeof p_options.fastMultipleSelection === "boolean" && p_options.fastMultipleSelection !== this.options.fastMultipleSelection) {
        iconChangeOptions.fastMultipleSelection = p_options.fastMultipleSelection;
        listChangeOptions.fastMultipleSelection = p_options.fastMultipleSelection;
      }
      if (typeof p_options.enableMultipleSelection === "boolean" && p_options.enableMultipleSelection !== this.options.enableMultipleSelection) {
        iconChangeOptions.enableMultipleSelection = p_options.enableMultipleSelection;
        listChangeOptions.enableMultipleSelection = p_options.enableMultipleSelection;
      }
      if (typeof p_options.deselectWhenRowClick === "boolean" && p_options.deselectWhenRowClick !== this.options.deselectWhenRowClick) {
        listChangeOptions.deselectWhenRowClick = p_options.deselectWhenRowClick;
      }
      if (typeof p_options.deselectable === "boolean" && p_options.deselectable !== this.options.deselectable) {
        iconChangeOptions.deselectable = p_options.deselectable;
      }
      if (p_options.orderBy !== undefined && _.isEqual(p_options.orderBy, this.options.orderBy) === false) {
        iconChangeOptions.orderBy = p_options.orderBy;
        listChangeOptions.orderBy = p_options.orderBy;
      }
      if ($.isEmptyObject(iconChangeOptions) === false) {
        this.m_iconview.IconView(iconChangeOptions);
      }
      if ($.isEmptyObject(listChangeOptions) === false) {
        this.m_listview.ListView(listChangeOptions);
      }
      if ((typeof p_options.disableSorting === "boolean" || p_options.disableSorting === null) && p_options.disableSorting !== this.options.disableSorting) {
        if (p_options.disableSorting === true) {
          this.m_listview.ListView("disableSorting");
        } else {
          this.m_listview.ListView("enableSorting");
        }
      }
      var selectedItems;
      if (this.options.enableSelecting === true) {
        selectedItems = this.getSelectedItems();
      }
      if (p_options.files !== undefined || p_options.folders !== undefined || p_options.view !== this.options.view || p_options.lockFolder !== this.options.lockFolder) {
        this._super(p_options);
        this._redraw();
      } else {
        this._super(p_options);
      }
      if (this.options.enableSelecting === true && Array.isArray(selectedItems) && selectedItems.length >= 1 && _typeof(selectedItems[0]) === "object" && Object.keys(selectedItems[0]).length > 0) {
        this._selectItems(selectedItems);
        var viewHeight = this.element.height();
        var position = this.element.find(".select:visible").position();
        if (typeof viewHeight === "number" && viewHeight > 0 && $.isPlainObject(position) && typeof position.top === "number" && position.top > viewHeight) {
          // if we have sufficient data and if first selected file is hidden under the overflow view
          var currentScrollTop = this.element.scrollTop();
          this.element.scrollTop(currentScrollTop + (position.top - viewHeight) + 150 /* extra buffer */);
        }
      } else {
        this.action("unselectAll");
      }
    },
    action: function action(pAction, pData) {
      if (pAction === "sort") {
        // sorting action only when iconview is active
        // folderview will do the reloading
        this.orderBy = pData;
      } else if (pAction === "browserSearch") {
        // action when user is searching with browser
        // only ask more items if they are not loaded yet!
        if (this.askingLimit < kMaxLimitAssets + 1) {
          this.askingLimit = kMaxLimitAssets + 1;
          if (this.m_iconview.is(":visible")) {
            this.m_iconview.IconView("option", {
              "limit": this.askingLimit - 1
            });
          } else {
            this.m_listview.ListView("option", {
              "limit": this.askingLimit - 1
            });
          }
        }
      } else if (pAction === "selectAll") {
        if (this.m_iconview.is(":visible")) {
          this.m_iconview.IconView("selectAll");
        } else if (this.m_listview.is(":visible")) {
          this.m_listview.ListView("selectAll");
        } else if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("selectAll");
        }
      } else if (pAction === "unselectAll") {
        if (this.m_iconview.is(":visible")) {
          this.m_iconview.IconView("unselectAll");
        } else if (this.m_listview.is(":visible")) {
          this.m_listview.ListView("unselectAll");
        } else if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("unselectAll");
        }
      } else if (pAction === "lockFolder") {
        if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("option", kLockViewOptions);
        }
      } else if (pAction === "unlockFolder") {
        if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("option", kUnlockViewOptions);
        }
      } else if (pAction === "acceptUI") {
        if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("changeApprovalStateSelectedFiles", "accept", pData);
        }
      } else if (pAction === "rejectUI") {
        if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("changeApprovalStateSelectedFiles", "reject", pData);
        }
      } else if (pAction === "selectItems") {
        // select specific files, pData must be an array
        this._selectItems(pData);
      }
    },
    /**
     * @name nixps-cloudflow.CombinedView#getSelectedItems
     * @description Get all data of all selected files
     * @function
     * @return {Array} array of all data of all selected assets
     */
    getSelectedItems: function getSelectedItems() {
      var requestedSelection = [];
      if (this.options.view === "icon") {
        requestedSelection = this.m_iconview.IconView("getSelectedItemData");
      } else if (this.options.view === "list") {
        requestedSelection = this.m_listview.ListView("getSelectedItemData");
      } else if (this.options.view === "reader") {
        requestedSelection = this.m_readerview.ReaderView("getSelectedItemData");
      } else {
        // we are in iconChooser
        if (this.m_iconview.is(":visible")) {
          requestedSelection = this.m_iconview.IconView("getSelectedItemData");
        } else if (this.m_listview.is(":visible")) {
          requestedSelection = this.m_listview.ListView("getSelectedItemData");
        } else {
          requestedSelection = this.m_readerview.ReaderView("getSelectedItemData");
        }
      }
      return requestedSelection;
    },
    /**
     * @description Select specific files
     * @function
     * @private
     * @param {string} pFileNames
     * @return {undefined}
     */
    _selectItems: function _selectItems(pFileNames) {
      if (Array.isArray(pFileNames) === false) {
        throw new Error("parameter pFileNames must be an array");
      }
      if (this.options.view === "iconChooser") {
        if (this.m_iconview.is(":visible")) {
          this.m_iconview.IconView("selectItems", pFileNames);
        } else if (this.m_readerview.is(":visible")) {
          this.m_readerview.ReaderView("selectItems", pFileNames);
        } else {
          throw new Error("_selectItems: icon or readers view must be visible");
        }
      } else if (this.options.view === "list") {
        this.m_listview.ListView("selectItems", pFileNames);
      } else if (this.options.view === "icon") {
        this.m_iconview.IconView("selectItems", pFileNames);
      } else if (this.options.view === "reader") {
        this.m_readerview.ReaderView("selectItems", pFileNames);
      } else {
        throw new Error("_selectItems: not supported options view");
      }
    },
    /**
     * @description called when object will be destroyed
     * @function
     * @private
     * @return {undefined}
     */
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this._super();
      $(this.element).off("keydown", this.keyDownHandler);
    }
  });
})(jQuery);

},{"../../../polyfill/polyfill.js":433,"../../IconView/js/nixps-cloudflow-IconView.js":171,"../../IconView/js/nixps-cloudflow-ReaderView.js":172,"../../ListView/js/nixps-cloudflow-ListView.js":181}],96:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var UserPreferences = require("../../Preferences/js/UserPreferences.js");
var CloudflowURL = require("../../CloudflowUtil/js/CloudflowURL.js");
var ApplicationPreferences = require("../../Preferences/js/ApplicationPreferences.js");
function isGuest() {
  var userID = api_util.get_cookie("user_id");
  return userID === null;
}
/**
 * @description The current version of the pravicy conent
 * @type {Number}
 * @private
 * @static
 */
var kCurrentVersionNumber = 0;
/**
 * @description all the change callback functions
 * @type {Array.<Function>}
 * @private
 * @default []
 * @static
 */
var changeCallBacks = [];
/**
 * @description Contains the options of the current user
 * @type {Object}
 * @private
 * @default {}
 * @static
 */
var user_options = {
  consent_content: null
};
/**
 * @description Contains the options of the system
 * @type {Object}
 * @private
 * @default {} 
 * @static
 */
var system_options = {};
/**
 * @description must we ask the user for the first time, his approval or not?
 * @type {Boolean}
 * @private
 * @default undefined
 * @static
 */
var _need_to_ask;

/**
 * @constructor Consent
 * @description Class for GDPR privacy consent. Contains all the tool to manage the consent of a user, contact or guest.
 * @param {Object} pSystemOptions All the options on system level
 * @param {Object} pUserOptions All the optionson user level
 */
var Consent = function Consent(pSystemOptions, pUserOptions) {
  // init system options
  if (pSystemOptions === undefined || pSystemOptions === null) {
    pSystemOptions = {};
  } else if (_typeof(pSystemOptions) !== "object" || Array.isArray(pSystemOptions)) {
    throw new Error("parameter pSystemOptions must be an object");
  }
  pSystemOptions = structuredClone(pSystemOptions); // deep copy

  // init user options
  if (pUserOptions === undefined || pUserOptions === null) {
    pUserOptions = {};
  } else if (_typeof(pUserOptions) !== "object" || Array.isArray(pUserOptions)) {
    throw new Error("parameter pUserOptions must be an object");
  }
  pUserOptions = structuredClone(pUserOptions); // deep copy

  this.setType(pSystemOptions.consent_type);
  this.setPreferencePageURL(pSystemOptions.preferences_page_URL);
  var goodVersionNumber = this._setVersionNumber(pUserOptions.version_number_when_approved);
  var goodDate = this._setDateWhenApprove(pUserOptions.date_when_approved);
  this._setContent(pUserOptions.consent_content);

  // setType function can overrule
  if (_need_to_ask === undefined) {
    if (goodVersionNumber && goodDate) {
      _need_to_ask = false;
    } else {
      _need_to_ask = true;
    }
  }
};
Consent.get = function () {
  var systemOptions, userOptions;
  if (system_options && _typeof(system_options) === "object" && Object.keys(system_options).length > 0) {
    // use cache
    systemOptions = system_options;
    if (user_options && user_options.date_when_approved !== undefined) {
      userOptions = user_options; // use cache
    } else {
      userOptions = {
        consent_content: null
      };
      console.error("user data not in sync with system data");
    }
    return Promise.resolve(new Consent(systemOptions, userOptions));
  } else if (isGuest()) {
    var userConsentData = null; // default
    var consentRetrieveString = api_util.get_cookie("consent");
    if (typeof consentRetrieveString === "string" && consentRetrieveString.length > 0) {
      try {
        userConsentData = JSON.parse(consentRetrieveString);
      } catch (e) {
        console.error(e);
        userConsentData = null;
      }
    }
    return UserPreferences.get().then(function (pUserPref) {
      return new Consent(pUserPref.getSystemConsent(), userConsentData);
    });
  } else {
    return UserPreferences.get().then(function (pUserPref) {
      return new Consent(pUserPref.getSystemConsent(), pUserPref.getUserConsent());
    });
  }
};
Consent.getResources = function () {
  return UserPreferences.getResources();
};
Consent.set = function () {
  UserPreferences.set.apply(UserPreferences, arguments);
};
Consent.clear = function () {
  user_options = {};
  system_options = {};
  if (window.api_util !== undefined && typeof api_util.set_cookie === "function") {
    api_util.set_cookie("consent", null);
  }
  Consent.clearData();
  UserPreferences.clearCaches();
};
Consent.clearData = function () {
  user_options.consent_content = null;
  if (window.api_util !== undefined && typeof api_util.set_cookie === "function") {
    api_util.set_cookie("cf_sidebar_displaymode", null, {
      path: "/"
    });
    api_util.set_cookie("cf_jsoneditor_displaymode", null, {
      path: "/"
    });
  }
};
Consent.fromJSON = function (pJSON) {
  return new Consent(pJSON.system, pJSON.user);
};
Consent.prototype = {
  constructor: Consent,
  setType: function setType(pConsentType) {
    if (pConsentType === undefined || pConsentType === null) {
      // default value for the moment
      system_options.consent_type = "none";
      _need_to_ask = false;
      // set default
      user_options.consent_content = {
        user_preferences: true,
        statistics: true,
        "3rdParty": {
          "youtube": true,
          "twitter": true
        }
      };
    } else if (pConsentType === "none") {
      system_options.consent_type = pConsentType;
      _need_to_ask = false;
      // set default
      user_options.consent_content = {
        user_preferences: true,
        statistics: true,
        "3rdParty": {
          "youtube": true,
          "twitter": true
        }
      };
    } else if (pConsentType === "GDPR") {
      system_options.consent_type = pConsentType;
      _need_to_ask = undefined; // depends on other values
      // set default
      user_options.consent_content = null;
    } else {
      /// ???
      console.error("setType: unknown consentType found");
      // current fallback
      system_options.consent_type = "none";
      _need_to_ask = false;
    }
  },
  getType: function getType() {
    return system_options.consent_type;
  },
  _setVersionNumber: function _setVersionNumber(pVersionNumber) {
    user_options.version_number_when_approved = null;
    if (typeof pVersionNumber === "number" && pVersionNumber >= 0) {
      user_options.version_number_when_approved = pVersionNumber;
      if (system_options.consent_type === "none") {
        return true;
      }
      if (user_options.version_number_when_approved < kCurrentVersionNumber) {
        // reask
        user_options.version_number_when_approved = null; // reset data
        Consent.clearData(); // reset data
        return false;
      }
      return true;
    }
    return false;
  },
  _setDateWhenApprove: function _setDateWhenApprove(pDate) {
    user_options.date_when_approved = null;
    if (typeof pDate === "string" && pDate.length > 0 || typeof pDate === "number" && pDate > 0) {
      var dAcceptDate = new Date(pDate);
      // check validation date
      if (isNaN(dAcceptDate.getTime())) {
        throw new Error("_setDateWhenApprove: invalid date format");
      }
      user_options.date_when_approved = dAcceptDate.toISOString();
    }
    if (user_options.date_when_approved !== null) {
      if (system_options.consent_type === "none") {
        return true;
      }
      if (new Date() - new Date(user_options.date_when_approved) > 31536000000) {
        // 365 days
        // reask
        user_options.date_when_approved = null; // reset data
        Consent.clearData(); // reset data
        return false;
      }
      return true;
    }
    return false;
  },
  _setContent: function _setContent(pContent) {
    if (pContent && _typeof(pContent) === "object" && Object.keys(pContent).length > 0) {
      user_options.consent_content = structuredClone(pContent);
    } else if (pContent === null) {
      user_options.consent_content = null;
    } else {
      // default, but what is default ?
    }
  },
  setContent: function setContent(pContent) {
    if (pContent && _typeof(pContent) === "object" && !Array.isArray(pContent) && Object.keys(pContent).length > 0) {
      // preferences
      if (typeof pContent.user_preferences === "boolean") {
        user_options.consent_content.user_preferences = pContent.user_preferences;
      } else if (pContent.user_preferences && _typeof(pContent.user_preferences) === "object" && !Array.isArray(pContent.user_preferences) && Object.keys(pContent.user_preferences).length > 0) {
        user_options.consent_content.user_preferences = structuredClone(pContent.user_preferences);
      }

      // statistics
      if (typeof pContent.statistics === "boolean") {
        user_options.consent_content.statistics = pContent.statistics;
      } else {
        user_options.consent_content.statistics = false;
      }

      // 3rdParty
      if (typeof pContent["3rdParty"] === "boolean") {
        user_options.consent_content["3rdParty"] = pContent["3rdParty"];
      } else if (pContent["3rdParty"] && _typeof(pContent["3rdParty"]) === "object" && !Array.isArray(pContent["3rdParty"]) && Object.keys(pContent["3rdParty"]).length > 0) {
        user_options.consent_content["3rdParty"] = {};
        user_options.consent_content["3rdParty"].youtube = pContent["3rdParty"].youtube == true;
        user_options.consent_content["3rdParty"].twitter = pContent["3rdParty"].twitter == true;
      }
      this._setVersionNumber(kCurrentVersionNumber);
      this._setDateWhenApprove(new Date().toISOString());
      _need_to_ask = false;
      this._informChange();
      return this.save();
    } else {
      throw new Error("setContent: expect parameter pContent to be an object");
    }
  },
  /**
   * @description must we show the confirmation dialog to the user or not?
   * @function
   * @name Consent.needToAsk
   * @returns {Boolean} true if we need to ask confirmation, false if user already accepted the consent
   */
  needToAsk: function needToAsk() {
    // do not ask if you are on the preference page itself
    var currentPreferenceURL = this.getPreferencePageURL();
    if (window.location.pathname === currentPreferenceURL) {
      return false;
    }
    return _need_to_ask;
  },
  /**
   * @description user want to accept all private and personal use of data
   * @function
   * @name Consent.acceptAll
   * @returns deferred when saving is done
   */
  acceptAll: function acceptAll() {
    this._setVersionNumber(kCurrentVersionNumber);
    this._setDateWhenApprove(new Date().toISOString());
    _need_to_ask = false;
    user_options.consent_content = {
      user_preferences: true,
      statistics: true,
      "3rdParty": {
        "youtube": true,
        "twitter": true
      }
    };
    this._informChange();
    return this.save();
  },
  accept3rdParty: function accept3rdParty(p3rdPartyName) {
    if (this.is3rdPartyAllowed(p3rdPartyName) === false) {
      if (user_options.consent_content === null) {
        user_options.consent_content = {
          user_preferences: false,
          statistics: false,
          "3rdParty": false
        };
      }
      if (typeof user_options.consent_content["3rdParty"] === "boolean") {
        user_options.consent_content["3rdParty"] = {};
      }
      user_options.consent_content["3rdParty"][p3rdPartyName] = true;
      this._informChange();
      return this.save();
    }
    return;
  },
  isUserPreferencesAllowed: function isUserPreferencesAllowed(pUserPreferenceName) {
    if (user_options.consent_content !== null && user_options.consent_content["user_preferences"] !== undefined) {
      if (typeof user_options.consent_content["user_preferences"] === "boolean") {
        return user_options.consent_content["user_preferences"];
      } else {
        return user_options.consent_content["user_preferences"][pUserPreferenceName] === true;
      }
    }
    return false;
    /**
     * color
     * kiosk
     * user_preferences
     * cf-sidebar_displaymode
     * filechooser
     * tabs
     * position_panels
     */
  },

  is3rdPartyAllowed: function is3rdPartyAllowed(p3rdPartyName) {
    if (user_options.consent_content !== null && user_options.consent_content["3rdParty"] !== undefined) {
      if (typeof user_options.consent_content["3rdParty"] === "boolean") {
        return user_options.consent_content["3rdParty"];
      } else {
        return user_options.consent_content["3rdParty"][p3rdPartyName] === true;
      }
    }
    return false;
  },
  isStatisticsAllowed: function isStatisticsAllowed() {
    if (user_options.consent_content !== null) {
      return user_options.consent_content.statistics === true;
    }
    return false;
  },
  _informChange: function _informChange(pChangeData) {
    for (var i = 0; i < changeCallBacks.length; i++) {
      changeCallBacks[i](pChangeData);
    }
  },
  registerChangeCallBack: function registerChangeCallBack(pChangeCallbackFunc) {
    if (typeof pChangeCallbackFunc !== "function") {
      throw new Error("registerChangeCallBack: parameter must be a function");
    }
    changeCallBacks.push(pChangeCallbackFunc);
  },
  unregisterChangeCallBack: function unregisterChangeCallBack(pChangeCallbackFunc) {
    if (typeof pChangeCallbackFunc !== "function") {
      throw new Error("unregisterChangeCallBack: parameter must be a function");
    }
    for (var i = 0; i < changeCallBacks.length; i++) {
      if (changeCallBacks[i] === pChangeCallbackFunc) {
        changeCallBacks.splice(i, 1);
        break;
      }
    }
  },
  setPreferencePageURL: function setPreferencePageURL(pPageURL) {
    if (typeof pPageURL === "string" && pPageURL.length > 0) {
      var cloudflowURL = new CloudflowURL(pPageURL);
      system_options.preferences_page_URL = cloudflowURL.getUploadPath();
    } else {
      system_options.preferences_page_URL = null;
    }
  },
  getPreferencePageURL: function getPreferencePageURL() {
    if (typeof system_options.preferences_page_URL === "string" && system_options.preferences_page_URL.length > 0) {
      return system_options.preferences_page_URL;
    } else {
      return "/cloudflow/Consent/privacy_policy.html";
    }
  },
  save: function save() {
    if (isGuest() === true) {
      var data = JSON.stringify(this.toUserJSON());
      var options = {
        expires: 365,
        path: "/",
        samesite: "Strict"
      };
      if (document.location.protocol === "https:") {
        options.secure = true;
      }
      api_util.set_cookie("consent", data, options);
    } else {
      ApplicationPreferences.saveUserValue("", "consent", this.toUserJSON()).then(function (pResult) {
        return {};
      }, function (pError) {
        console.error(pError);
      });
    }
  },
  clone: function clone() {
    return new Consent(this.toJSON());
  },
  toUserJSON: function toUserJSON() {
    return structuredClone(user_options);
  },
  toJSON: function toJSON() {
    return {
      system: structuredClone(system_options),
      user: this.toUserJSON()
    };
  }
};
if (window.nixps !== undefined && window.nixps.testing !== undefined) {
  window.nixps.testing.clear_consent.push(Consent.clear);
}
module.exports = Consent;

},{"../../CloudflowUtil/js/CloudflowURL.js":80,"../../Preferences/js/ApplicationPreferences.js":201,"../../Preferences/js/UserPreferences.js":202}],97:[function(require,module,exports){
"use strict";

(function ($) {
  var Consent = require("./Consent.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  require("../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js");
  $.widget("nixps-cloudflow.ConsentDialog", {
    version: "1.0.0",
    widgetEventPrefix: "consentdialog",
    options: {
      /**
       * @name nixps-cloudflow.ConsentDialog#language
       * @description the language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.ConsentDialog#consent
       * @description the consentobject
       * @type {Object}
       * @default null
       */
      consent: null,
      /**
       * @name nixps-cloudflow.ConsentDialog#modal
       * @description Must we modal the dialog or not?
       * @type {Boolean}
       * @default true
       */
      modal: true,
      created: function created() {}
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      var that = this;
      this.consent;
      var creatingDef = {};
      if ($.isPlainObject(this.options.consent)) {
        this.consent = Consent.fromJSON(this.options.consent);
      } else if (this.options.consent instanceof Consent) {
        this.consent = this.options.consent;
      } else {
        creatingDef = Consent.get().then(function (pConsent) {
          that.consent = pConsent;
        });
      }
      $.when(creatingDef).done(function () {
        that._draw();
      }).fail(function (pError) {
        console.error(pError);
      }).always(function () {
        that.options.created();
      });
      this._on(this.element, {
        "click .consentdialog-acceptbutton": this._accectAllClickHandler,
        "click .consentdialog-partialacceptbutton": this._acceptPartialClickHandler
      });
    },
    /**
     * @description Function runs when user accept all terms of privacy
     * @function
     * @private
     * @name nixps-cloudflow.ConsentDialog#_accetAllClickHander
     */
    _accectAllClickHandler: function _accectAllClickHandler() {
      this.consent.acceptAll();
      this.element.remove();
    },
    /**
     * @description Function rus when user partialy accept the settings
     * @function
     * @private
     * @name nixps-cloudflow.ConsentDialog#_acceptPartialClickHandler
     */
    _acceptPartialClickHandler: function _acceptPartialClickHandler() {
      var consentPreferences = {};
      this.element.find("input[type=checkbox][name]").each(function () {
        var name = $(this).attr("name");
        if (typeof name === "string" && name.length > 0) {
          consentPreferences = CloudflowObject.setParameter(consentPreferences, name, $(this).is(":checked"));
        }
      });
      this.consent.setContent(consentPreferences);
      this.element.remove();
    },
    close: function close() {
      this.element.remove();
    },
    _draw: function _draw() {
      // reset DOM
      $("body").children(".consentdialog-modal").remove();
      this.element.empty();
      if (this.consent.needToAsk()) {
        if (this.options.modal === true) {
          var modalPanel = $("<div>").addClass("consentdialog-modal cf-overlay-light cf-zindex-dropdownlist-low");
          $("body").append(modalPanel);
        }
        var iconType = "class";
        var iconContent = "cf-icon cf-icon-lg cf-icon-cloudflow-logo";
        var titleText = $.i18n._("nixps-cloudflow-consentdialog.title_text");
        var descriptionIntroText = $.i18n._("nixps-cloudflow-consentdialog.content_text");
        var settingsURL = this.consent.getPreferencePageURL();

        // header
        var title = $("<div>").addClass("consentdialog-header cf-dialog-header");
        var iconDOM = $("<span>").addClass("consentdialog-header-icon");
        title.append(iconDOM);
        if (iconType === "class") {
          iconDOM.addClass(iconContent);
        }
        title.append($("<span>").addClass("consentdialog-header-title cf-title-h4").text(titleText));

        // content
        var description = $("<div>").addClass("consentdialog-description cf-dialog-content cf-dialog-padding");
        var descriptionIntroDOM = $("<div>").addClass("consentdialog-description-intro").html(descriptionIntroText.replace(/\\n/g, "<br>"));
        description.append(descriptionIntroDOM);

        /*var techniacallyContainer = $("<div>").addClass("consentdialog-check");
        description.append(techniacallyContainer);
        var techniacally = $("<label>");
        techniacallyContainer.append(techniacally);
        techniacally.append($("<input>").addClass("cf-checkbox").attr("type", "checkbox").prop("disabled", true).prop("checked", true));
        techniacally.append($("<div>").addClass("consentdialog-check-explanation cf-col-9 cf-col-offset-1 cf-vertical-middle")
                                    .append($("<div>").addClass("cf-title-h4")._t("required"))
                                    .append($("<div>").addClass("consentdialog-check-explanation-text")._t("cookies and data who are recuired for the correct functional of the service"))
                            );
        
         var preferencesContainer = $("<div>").addClass("consentdialog-check");
        description.append(preferencesContainer);
        var preferences = $("<label>");
        preferencesContainer.append(preferences);
        preferences.append($("<input>").addClass("cf-checkbox").attr("type", "checkbox").attr("name", "user_preferences"));
        preferences.append($("<div>").addClass("consentdialog-check-explanation  cf-col-9 cf-col-offset-1 cf-vertical-middle")
                                    .append($("<div>").addClass("cf-title-h4")._t("preferences"))
                                    .append($("<div>").addClass("consentdialog-check-explanation-text")._t("cookies and data saved your personal preferences"))
                            );
        
         var externalsContainer = $("<div>").addClass("consentdialog-check");
        description.append(externalsContainer);
        var externals = $("<label>");
        externalsContainer.append(externals);
        externals.append($("<input>").addClass("cf-checkbox").attr("type", "checkbox").attr("name", "3rdParty"));
        externals.append($("<div>").addClass("consentdialog-check-explanation  cf-col-9 cf-col-offset-1 cf-vertical-middle")
                                    .append($("<div>").addClass("cf-title-h4")._t("3rd Parties"))
                                    .append($("<div>").addClass("consentdialog-check-explanation-text")._t("cookies and data used by YouTube and Twitter"))
                            );
        
         description.append($("<div>").addClass("cf-buttonbar").append($("<button>").attr("type", "button").addClass("cf-button-secondary consentdialog-partialacceptbutton")._t("nixps-cloudflow-manage.generic-save")));
        */
        // bottom
        var bottomBar = $("<div>").addClass("consentdialog-bottombar cf-dialog-bottom");
        var link = $("<a>").attr("href", settingsURL).addClass("consentdialog-settingslink cf-link")._t("nixps-cloudflow-consentdialog.go_to_settings");
        var acceptButton = $("<div>").addClass("consentdialog-acceptbutton").CloudflowButton({
          label: $.i18n._("nixps-cloudflow-consentdialog.accept_all"),
          classes: "cf-button-main"
        });
        bottomBar.append($("<div>").addClass("cf-col-md-6 cf-center-text cf-vertical-middle").append(link)).append($("<div>").addClass("cf-col-md-6 cf-center-text cf-vertical-middle").append(acceptButton));

        // collect all peaces togetter
        this.element.addClass("cf-dialog cf-dialog-center cf-dialog-fixwidth cf-dialog-flex cf-zindex-dropdownlist").append(title).append(description).append(bottomBar);
        this.element.css({
          "position": "fixed",
          "top": 0,
          "left": 0,
          "right": 0,
          "margin-left": "auto",
          "margin-right": "auto"
        });
      }
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      this._draw();
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.modal !== "boolean") {
        throw new Error("input option modal must be a boolean");
      }
    },
    _destroy: function _destroy() {
      $("body").children(".consentdialog-modal").remove();
      this._super();
    }
  });
})(jQuery);

},{"../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js":282,"../../CloudflowUtil/js/CloudflowObject.js":79,"./Consent.js":96}],98:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

(function ($) {
  require('./nixps-dfe-Engineer.js');
  require('./nixps-dfe-SeparationList.js');
  require('./nixps-dfe-SeparationListSummary.js');
  require('./nixps-dfe-MediaSelector.js');
  require('../../../3rdParty/jquery.ui.onresize.js');
  $.widget("nixps.DFEEditor", {
    widgetEventPrefix: "dfeeditor",
    options: {
      /**
       * The settings blob with the RIP parameters
       */
      settings: undefined,
      /**
       * Set this to true to use with bootstrap, no for regular jQueryUI
       */
      bootstrap: true,
      /**
       * Our categories
       */
      inputCategory: undefined,
      outputCategory: undefined,
      separationsCategory: undefined,
      colorCategory: undefined,
      preflightCategory: undefined,
      /**
       * @bief Is the Editor used in 'Submission' mode (false) or in 'Preset Edition' mode.
       * @type {Boolean}
       * @default false
       */
      standaloneView: false,
      readOnly: false,
      summarize: false,
      /**
       * @description DFE context. IT IS MANDATORY
       * @type {object}
       * @default undefined
       */
      dfe_context: undefined
    },
    _silentChanges: false,
    /**
     * @brief creates the editor component
     */
    _create: function _create() {
      var that = this;
      this.element.addClass(this.widgetFullName);
      if (this.options.dfe_context === undefined || this.options.dfe_context.app === undefined) {
        this.element.append($("<label >").text('Fundamentals context is unspecified.'));
        return;
      }
      this.Engineer = nixps.dfe.getEngineerInstance(this.options.dfe_context);
      if (this.options.settings !== undefined) {
        this.options.settings.dfe = {
          'app': this.options.dfe_context.app
        }; // Force the RIP Setting to work in the 'dfe' mode

        if (this.options.settings.color === undefined) {
          this.options.settings.color = {
            'media': 'Default'
          };
        } else if (this.options.settings.color.media === undefined) {
          this.options.settings.color.media = 'Default';
        }
      }
      this.draw();
      this.resizeListener = _.throttle(this._resizeListener.bind(this), 200);
      // this.element.onresize( this._resizeListener.bind(this) );
      if (window.ResizeObserver !== undefined) {
        var resizeObserver = new ResizeObserver(this.resizeListener);
        resizeObserver.observe(this.element[0]);
      } else {
        $(window).on("resize", this.resizeListener);
      }
      this._resizeAdded = true;
      this._installHandlers();
    },
    _resizeListener: function _resizeListener() {
      var myWidth = this.element.width();
      // console.log(myWidth);
      if (myWidth > 1000) {
        this.element.find('.resize_panel').addClass("col-lg-6 cf-col-lg-6");
        this.element.find('.resize_panel').removeClass("col-md-12 cf-col-md-12");
      } else {
        this.element.find('.resize_panel').addClass("col-md-12 cf-col-md-12");
        this.element.find('.resize_panel').removeClass("col-lg-6 cf-col-lg-6");
      }
    },
    _destroy: function _destroy() {
      console.log("Editor destroyed: !!! ");
      this._super();
      if (this._resizeAdded === true) {
        // this.element.removeOnResize(this._resizeListener);
      }
      if (window.ResizeObserver === undefined) {
        $(window).off("resize", this.resizeListener);
      }
    },
    draw: function draw() {
      this.element.empty();
      var form = $('<div>').addClass('draggablePanelList row-fluid form-horizontal ui-sortable').appendTo($('<div>').addClass("container-fluid").appendTo(this.element));

      // O U T P U T
      var panel = $('<div>').addClass("DFEEditor_Output preset_output resize_panel").appendTo(form);
      this._addOutput(panel);
      var subform = $('<div>').addClass("resize_panel").appendTo(form);

      // M E D I A
      var panel = $('<div>').addClass("DFEEditor_Media preset_color_management").appendTo(subform);
      // div = $('<div>').addClass("preset_color_management").appendTo(rightForm); //rightForm);
      var outputPanel = $('<div>').addClass("panel cf-panel panel-default").appendTo(panel);
      outputPanel.append($('<div>').addClass("panel-heading profile-subtitle").append($('<h3>').addClass('panel-title profile-subtitle').text($.i18n._("nixps-rip-editor-color.title")))).append($('<div>').addClass("panel-body").append($('<div>').addClass('media grid_2columns').append($('<label for="mediaProfile">').addClass('control-label cf-form-label').text($.i18n._("nixps-rip-editor-color.media-profile"))).append($('<div>').append($('<select name="mediaProfile">').addClass('dfe-media-dropdown form-control cf-form-select cf-form-control')))));
      var selectMedia = this.element.find('select[name=mediaProfile]');
      selectMedia.MediaSelector({
        'dfe_context': this.options.dfe_context,
        'readOnly': this.options.readOnly
      });

      // S E P A R A T I O N S
      // The Separations Category
      panel = $('<div>').addClass("DFEEditor_Separations").appendTo(subform);
      this.separationsCategory = $("<div class='item'>");
      this.separationsCategory.appendTo(panel);
      if (this.options.summarize) {
        this.separationsCategory.DFESeparationListSummary({
          settings: this.options.settings,
          bootstrap: this.options.bootstrap,
          summarize: this.options.summarize,
          dfe_context: this.options.dfe_context
        });
      } else {
        this.separationsCategory.DFESeparationList({
          settings: this.options.settings,
          bootstrap: this.options.bootstrap,
          summarize: this.options.summarize,
          dfe_context: this.options.dfe_context,
          standaloneView: this.options.standaloneView,
          readOnly: this.options.readOnly
        });
      }
      // P R E F L I G H T
      panel = $('<div>').addClass("DFEEditor_Preflight preset_preflight").appendTo(subform);
      this._addPreflight(panel);

      // The Output Category
      /****this.preflightCategory = $("<div class='item'>");
      this.preflightCategory.appendTo(ripRow2);
      if ( this.Engineer.get('appOptions.behavior.preflight.perform') ) {
          this.preflightCategory.RIPEditorPreflight({
              settings: this.options.settings,
              readOnly: this.options.readOnly
          });
      }***/
      // this._populateMediaDropDown(true);
      this._refresh();
    },
    _addOutput: function _addOutput(form) {
      var panel = $('<div>').addClass("panel cf-panel panel-default").appendTo(form);
      var body = $('<div>').addClass("panel-body");
      panel.append($('<div>').addClass("panel-heading profile-subtitle").append($('<h3>').addClass('panel-title profile-subtitle').text($.i18n._("nixps-rip-editor-output.title")))).append(body);
      if (this.Engineer.get('appOptions.ui.showBehavior')) {
        body.append($('<legend>').addClass('cf-legend').text($.i18n._('nixps-rip-editor-output.behaviour')));
        body.append(this._addBehaviour());
      }
      body.append($('<legend>').addClass('cf-legend').text($.i18n._('nixps-RIPEditor-output.sub_title_resolution')));
      body.append(this._addResolution());
      body.append($('<legend>').addClass('cf-legend').text($.i18n._('nixps-RIPEditor-output.sub_title_outputproperties')));
      body.append(this._addOutputProperties());
      if (this.Engineer.getBehavior('screening.perform') && (this.Engineer.get("output.halftone") || this.Engineer.getBehavior('SPDirect'))) {
        body.append($('<legend>').hide().addClass('output_screening cf-legend').text($.i18n._('nixps-media-editor.screening')));
        body.append(this._addScreening().hide()); // Trac#34913: The screening becomes hardcoded now.
      }
    },

    _addPreflight: function _addPreflight(form) {
      var panel = $('<div>').addClass("panel cf-panel panel-default").appendTo(form);
      var body = $('<div>').addClass("panel-body");
      panel.append($('<div>').addClass("panel-heading profile-subtitle").append($('<h3>').addClass('panel-title profile-subtitle').text($.i18n._("nixps-rip-editor-preflight.title")))).append(body);
      var div = $('<div>').addClass("preflight-group").append($('<legend>').addClass('cf-legend').text($.i18n._('nixps-rip-editor-preflight.images'))).appendTo(body);

      // ['min_res', 'max_res'].forEach(function (field) {
      //     $('<label name="preflight.' + field + '_check">').text(field)
      //         .appendTo(div);
      //     // $('<label name="preflight.' + field + '_check">').addClass('checkbox-label cf-form-checkboxlabel')
      //     //     .append($('<input type="checkbox" name="preflight.' + field + '_check" class="cf-form-checkbox">'))
      //     //     .append($('<span>').addClass("cf-form-checkboxlabel").text($.i18n._('nixps-rip-editor-preflight.images.' + field)))
      //     //     .append($('<input type="number" name="preflight.' + field + '_value" disabled="disabled">').addClass('form-control cf-form-control'))
      //     //     .appendTo(div);
      // })

      // var field = 'min_res';
      ['min_res', 'max_res'].forEach(function (field) {
        $('<label name="preflight.' + field + '_check">').addClass('checkbox-label cf-form cf-form-checkboxlabel').append($('<input type="checkbox" name="preflight.' + field + '_check" class="cf-form-checkbox">')).append($('<span>').addClass("cf-form-checkboxlabel").text($.i18n._('nixps-rip-editor-preflight.images.' + field))).append($('<input type="number" name="preflight.' + field + '_value" disabled="disabled">').addClass('form-control cf-form-control')).appendTo(div);
      });
      // field = 'max_res';
      // $('<label name="preflight.' + field + '_check">').addClass('checkbox-label cf-form cf-form-checkboxlabel')
      //     .append($('<input type="checkbox" name="preflight.' + field + '_check" class="cf-form-checkbox">'))
      //     .append($('<span>').addClass("cf-form-checkboxlabel").text($.i18n._('nixps-rip-editor-preflight.images.' + field)))
      //     .append($('<input type="number" name="preflight.' + field + '_value" disabled="disabled">').addClass('form-control cf-form-control'))
      //     .appendTo(div);

      ['rgb', 'bitmap'].forEach(function (field) {
        $('<label name="preflight.' + field + '_check">').addClass('checkbox-label cf-form cf-form-checkboxlabel').append($('<input type="checkbox" name="preflight.' + field + '_check" class="cf-form-checkbox">')).append($('<span>').addClass("cf-form-checkboxlabel").text($.i18n._('nixps-rip-editor-preflight.images.' + field))).appendTo(div);
      });
      div = $('<div>').addClass("preflight-group").append($('<legend>').addClass('cf-legend').text($.i18n._('nixps-rip-editor-preflight.fonts'))).appendTo(body);
      [{
        'v': 'non_embedded_check',
        'n': 'embedded'
      }, {
        'v': 'ko_black_text_check',
        'n': 'ko_black'
      }].forEach(function (prop) {
        $('<div>').addClass('control-checkbox').append($('<label name="preflight.' + prop.v + '">').addClass('checkbox-label cf-form-checkboxlabel').append($('<input type="checkbox" name="preflight.' + prop.v + '" class="cf-form-checkbox">')).append($('<span>').addClass("cf-form-checkboxlabel").text($.i18n._('nixps-rip-editor-preflight.fonts.' + prop.n)))).appendTo(div);
      });
      div = $('<div>').addClass("preflight-group").append($('<legend>').addClass('cf-legend').text($.i18n._('nixps-rip-editor-preflight.separations'))).appendTo(body);
      [{
        'v': 'ko_technical_check',
        'n': 'technical'
      }, {
        'v': 'non_sep_check',
        'n': 'non_separable'
      }].forEach(function (prop) {
        $('<div>').addClass('control-checkbox').append($('<label name="preflight.' + prop.v + '">').addClass('checkbox-label cf-form-checkboxlabel').append($('<input type="checkbox" name="preflight.' + prop.v + '" class="cf-form-checkbox">')).append($('<span>').addClass("cf-form-checkboxlabel").text($.i18n._('nixps-rip-editor-preflight.separations.' + prop.n)))).appendTo(div);
      });
      if (!this.Engineer.getBehavior('preflight.perform')) {
        panel.hide();
      }
    },
    // _populateMediaDropDown: function(preset) {
    //     if ( this.options.settings !== undefined ) {
    //         var restriction = {};
    //         if ( preset ) {
    //             // Get restriction from the preset
    //             restriction = {'resolution': this.options.settings.output.resolution_v,
    //                 'screening': this.options.settings.separations.default_screen
    //             };
    //         } else {
    //             // Get restriction from the UI
    //             var vRes = this._getVerticalResolution();
    //             restriction = {'resolution': vRes === undefined ? 1200 : vRes.value,
    //                 'screening': this.element.find('select[name=screening]').val()
    //             };
    //
    //         }
    //         // var selectMedia = this.element.find('select[name="mediaProfile"]');
    //         // selectMedia.MediaSelector('option', 'settings', restriction);
    //     }
    // },

    _addBehaviour: function _addBehaviour() {
      var that = this;
      var form = $('<div>').addClass('output_behavior grid_2columns');
      var toPress = $('<label>').addClass('control-label cf-form-label').html('Send to Device').append($('<input type="radio" name="device_tiff" value="send_to_device">').prop('checked', 'checked').addClass("cf-form-checkbox").css({
        'margin-left': '7px',
        'margin-right': '5px'
      })).append($('<span>').text(' or ').css('font-weight', 'initial')).appendTo(form);
      var toTIFF = $('<div>').append($('<label>').addClass('control-label cf-form-label').css('justify-self', 'start').append($('<input type="radio" name="device_tiff" value="save_as_tiff">').addClass("cf-form-checkbox").css('margin-right', '7px')).append($('<span>').text("Save as TIFF"))).appendTo(form);
      if (this.Engineer.getBehavior('sendToPress')) {
        if (this.Engineer.getBehavior('TIFF_saved_by_FUJI')) {
          toTIFF.find('span').text('Send to be saved as TIFF');
        } else {
          $('<span>').appendTo(form);
        }
      } else {
        toPress.hide();
        toTIFF.hide();
        this.element.find('input[value="send_to_device"]').prop('checked', false);
        $('<label name="save_as_tiff">').addClass('cf-form-label').css({
          'justify-self': 'end',
          'align-self': 'start',
          'padding-top': '10px'
        }).text('Save as TIFF').appendTo(form);
      }
      var div = $('<div name="save_as_tiff">').css({
        'display': 'grid',
        'grid-template-columns': '20px auto',
        'margin-top': '5px'
      }).append($('<span name="save_as_tiff">').prop('disabled', this.options.readOnly).addClass('cf-form-label').css({
        'text-align': 'left',
        'padding-top': '5px'
      }).text(' in ')).appendTo(form);
      $('<input type="text" name="save_as_tiff">').addClass('osPathSelector cf-form-select cf-form-control').prop('disabled', this.options.readOnly).appendTo(div);
      div.append($('<div name="save_as_tiff_error">').css({
        'grid-column': '2',
        'line-height': '1.5',
        'color': 'rgb(255 255 255)',
        'background-color': 'orange',
        'margin': '2px 0 4px 0',
        'padding': '5px'
      }).hide());
      if (this.Engineer.getBehavior('TIFF_saved_by_FUJI')) {
        div.hide();
      }
      $('<label name="behavior.Preflight">').addClass('control-label cf-form-label').text('Perform Preflight').appendTo(form);
      $('<span name="behavior.Preflight">').append($('<label>').addClass('control-label cf-form-label cf-form').css({
        'justify-self': 'start',
        'text-align': 'left'
      }).append($('<input type="checkbox" name="preflight" value="preflight" class="cf-form-checkbox">')).append($('<span>').addClass("cf-form-checkboxlabel").text("on the first 10 pages"))).appendTo(form);
      if (!this.Engineer.getBehavior('preflight.perform')) {
        form.find('label[name="behavior.Preflight"]').hide();
        form.find('span[name="behavior.Preflight"]').hide();
        form.find('input[name="preflight"]').prop('checked', false);
      }
      $('<label name="behavior.Proofscope">').addClass('control-label cf-form-label').text('Hold in Proofscope').appendTo(form);
      $('<label name="behavior.Proofscope">').addClass('control-label cf-form-label').css({
        'justify-self': 'start',
        'text-align': 'left'
      }).append($('<input type="checkbox" name="proofscope" value="proofscope" class="cf-form-checkbox">')).append($('<span>').addClass("cf-form-checkboxlabel").text("To check RIP results, on the first 10 pages.")).appendTo(form);
      if (!this.Engineer.getBehavior('proofscope.perform', true)) {
        form.find('label[name="behavior.Proofscope"]').hide();
        // form.find('span[name="behavior.Proofscope"]').hide();
        form.find('input[name="proofscope"]').prop('checked', false);
      }
      if (this.Engineer.getBehavior('postprocess.is_job_life_limited', false)) {
        var allowArchive = this.Engineer.get('appOptions.config.allow_to_archive_job', true);
        var maxAge = this.Engineer.get('appOptions.config.transactional_life_expectancy', 24);
        var archiveText = "Archive the job after ";
        if (maxAge === 1) {
          archiveText += '1 hour.';
        } else if (maxAge < 25) {
          archiveText += maxAge + ' hours.';
        } else {
          archiveText += Math.ceil(maxAge / 24) + ' days.';
        }
        var title = [$.i18n._('On Job Completion'), ''];
        if (this.options.standaloneView || allowArchive) {
          $('<label>').addClass('control-label cf-form-label').text(title[0]).appendTo(form);
          $('<span name="behavior.archive">').prop('disabled', !allowArchive).append($('<label>').addClass('control-label cf-form-label cf-form').css({
            'justify-self': 'start',
            'text-align': 'left'
          }).append($('<input type="radio" name="archive" value="archive_job" class="archive_job cf-form-checkbox">').prop('checked', true).prop('disabled', !allowArchive)).append($('<span>').addClass("cf-form-checkboxlabel").text(archiveText))).appendTo(form);
          if (!allowArchive) {
            form.find('span[name="behavior.archive"] .cf-form-checkboxlabel').css({
              'text-decoration': 'line-through'
            });
          }
        } else {
          title[1] = title[0];
        }
        $('<label>').addClass('control-label cf-form-label').text(title[1]).appendTo(form);
        var ages = $('<select name="life_expectancy">').addClass('form-control cf-form-select').prop('disabled', allowArchive).prop('maxAge', maxAge).css({
          'width': 'initial',
          'display': 'initial',
          'height': '25px',
          'padding': '2px 8px 3px 8px'
        });
        var opt = [[1, '1 hour'], [4, '4 hours'], [12, '12 hours'], [24, '24 hours'], [168, '7 days'], [336, '14 days'], [672, '28 days']];
        for (var a = 0; a < opt.length && opt[a][0] <= maxAge; a++) {
          ages.append($('<option>').prop('value', opt[a][0]).attr("selected", opt[a][0] === maxAge ? 'selected' : '').text(opt[a][1]));
        }
        $('<span name="behavior.archive">').append($('<label>').addClass('control-label cf-form-label').css({
          'margin': 0
        }).append($('<input type="radio" name="archive" value="delete_job" class="delete_job cf-form-checkbox">').prop('disabled', !allowArchive)).append($('<span>').addClass("cf-form-checkboxlabel").text("Delete the job after ")).append(ages)).appendTo(form);
      }
      if (that.options.readOnly) {
        form.find('input').prop('disabled', true);
        // this.outputSelectize.disable()
      }

      return form;
    },
    _consolidateURLandOSPATH: function _consolidateURLandOSPATH(pair) {
      if (pair !== undefined && pair.url !== undefined) {
        if (pair.valid === undefined && pair.exists === undefined && pair.error === undefined) {
          var check = api.file.does_exist(pair.url);
          if (check.error_code !== undefined) {
            pair.error = check.error_code;
          } else if (check.valid) {
            pair.url = check.url; // the url is appended with a '/' for folders.
            pair.exists = check.exists || false;
            pair.is_folder = check.is_folder || false;
          } else {
            pair.valid = false;
          }
        }
        if (pair.subpath !== undefined && pair.error === undefined) {
          pair.ospath += pair.subpath;
          pair.url += pair.subpath.replace(/\\/g, '/');
          pair.is_folder = false;
          pair.exists = false;
          delete pair.subpath;
        }
      }
      return pair;
    },
    _getURLandOSPATH: function _getURLandOSPATH(path) {
      var that = this;
      return $.Deferred(function (pDefer) {
        var pair = {
          'ospath': path
        };
        if (path === undefined || typeof path === 'string' && path.length === 0) {
          pair.error = 'An Output path is required.';
          pDefer.resolve(pair);
          return;
        }
        if (path.indexOf('cloudflow://') === 0 || path.indexOf('file://') === 0) {
          api_defer.file.url_to_ospath(path).then(function (ret) {
            if (ret.ospath !== undefined) {
              pair = ret;
              pair.url = path;
              pDefer.resolve(that._consolidateURLandOSPATH(pair));
            }
          }).fail(function (ret) {
            if (ret.error_code === "Could not convert URL to local path") {
              var protocol = path.substring(0, path.indexOf('://') + 3);
              var sep = path.lastIndexOf('/', path.length - 2); // '/' ending the path is to ignore
              if (sep > protocol.length + 1) {
                var subpath = path.substring(0, sep + 1); // with the separator
                that._getURLandOSPATH(subpath).then(function (pair) {
                  pair.subpath = path.substring(sep + 1);
                  pair.badPath = (pair.badPath || '') + path.substring(sep + 1);
                  pDefer.resolve(that._consolidateURLandOSPATH(pair));
                  return;
                });
              } else {
                pair.error = ret.error_code;
                pDefer.resolve(that._consolidateURLandOSPATH(pair));
              }
            } else {
              pair.error = ret.error_code;
              pDefer.resolve(that._consolidateURLandOSPATH(pair));
            }
          });
        } else if (path !== "") {
          var isWindowsPath = path.indexOf('\\') !== -1 || path.match(/^.:/) !== null ? true : false;
          var osPathSep = isWindowsPath ? '\\' : '/';
          api_defer.file.ospath_to_url(path).then(function (ret) {
            if (ret.url !== undefined) {
              pair = ret;
              api_defer.file.url_to_ospath(pair.url).then(function (ret2) {
                if (ret2.ospath !== undefined) {
                  pair.ospath = ret2.ospath;
                } else {
                  pair.ospath = path;
                }
                pDefer.resolve(that._consolidateURLandOSPATH(pair));
              });
            }
          }).fail(function (ret) {
            if (ret.error_code === "The specified file is not accessible") {
              var sep = path.lastIndexOf(osPathSep, path.length - 2); // '/' ending the path is to ignore
              if (sep > 1) {
                var subpath = path.substring(0, sep + 1); // with the separator
                that._getURLandOSPATH(subpath).then(function (pair) {
                  pair.subpath = path.substring(sep + 1);
                  pair.badPath = (pair.badPath || '') + path.substring(sep + 1);
                  pDefer.resolve(that._consolidateURLandOSPATH(pair));
                  return;
                });
              } else {
                pair = {
                  'ospath': path,
                  'error': ret.error_code
                };
                pDefer.resolve(that._consolidateURLandOSPATH(pair));
              }
            } else {
              pair = {
                'ospath': path,
                'error': ret.error_code
              };
              pDefer.resolve(that._consolidateURLandOSPATH(pair));
            }
          });
        }
      });
    },
    _getValidPath: function _getValidPath(url) {
      var check = api.file.does_exist(url);
      if (check.valid !== true || check.error_code !== undefined) {
        var el = document.createElement('a');
        el.href = url;
        var path = el.pathname;
        var sep = path.lastIndexOf('/', path.length - 1);
        if (sep < 1) {
          return check;
        } else {
          var suburl = el.protocol + '//' + el.host + path.substring(0, sep - 1);
          var subcheck = this._getValidPath(suburl);
          return subcheck;
        }
      } else {
        return check;
      }
    },
    _onQualityChange: function _onQualityChange(quality) {
      var selectRes = this.element.find('select[name="output.canon_resolutions"]');
      if (quality === 'quality' || quality === 'alpine') {
        selectRes.val('720 dpi x 1080 dpi');
      } else if (quality === 'performance') {
        selectRes.val('720 dpi x 720 dpi');
      } else {
        selectRes.val('720 dpi x 360 dpi');
      }
    },
    _checkOutputPath: function _checkOutputPath(path) {
      var that = this;
      this._getURLandOSPATH(path).then(function (pair) {
        // settingsBehavior.tiffOutputFolder = pair.url;
        if (pair.error !== undefined) {
          that.element.find('[name=save_as_tiff_error]').text(pair.error).show();
        } else if (pair.is_folder === false) {
          that.element.find('[name=save_as_tiff_error]').text('Path pointing an unexisting folder' + (pair.badPath === undefined ? '' : ': ' + pair.badPath)).show();
        } else if (pair.valid === false) {
          that.element.find('[name=save_as_tiff_error]').text('Path is not valid' + (pair.url === undefined ? '' : ': ' + pair.url)).show();
        } else {
          that.element.find('div[name="save_as_tiff_error"]').hide();
        }
      });
    },
    _addResolution: function _addResolution() {
      var that = this;
      var form = $('<div>').addClass('output_resolutions cf-form-group grid_2columns');
      if (this.Engineer.get('context.app') === 'canon_dfe') {
        var selectVRes = $('<select name="output.canon_resolutions">').addClass('cf-form-control form-control cf-form-select');
        var vResolutions = this.Engineer.getVerticalResolutions();
        vResolutions.forEach(function (vr) {
          var hResolutions = that.Engineer.getHorizontalResolutions(vr);
          for (var res in hResolutions) {
            var combined = hResolutions[res].name + " x " + vr.name; // Trac #32279
            selectVRes.append("<option value='" + combined + "'>" + combined + "</option>");
          }
        });
        var selectQuality = $('<select name="output.quality">').addClass('cf-form-control form-control cf-form-select').append("<option value='alpine'>Alpine</option>").append("<option value='quality'>Quality</option>").append("<option value='performance'>Performance</option>").append("<option value='graphics'>Graphics</option>");
        form.append($('<label name="output.quality">').addClass('control-label cf-form-label').text($.i18n._("nixps-cloudflow-assets.metadata-references_column_quality"))).append($('<span name="output.quality">').addClass('control-checkbox').append(selectQuality.css({
          'display': 'inline-block',
          'width': '33.33%',
          'margin-right': '10px'
        })).append($('<span>').addClass('control-checkbox').append(selectVRes.attr('disabled', 'disabled').css({
          'display': 'inline-block',
          'width': 'calc(66.66% - 10px)'
        }))));
        if (this.options.readOnly) {
          selectQuality.attr('disabled', 'disabled');
          form.find('input').attr('disabled', 'disabled');
        } else {
          selectQuality.on('change', function (pEvent, pData) {
            that._onQualityChange(pEvent.target.value);
          });
          form.find('input[name="save_as_tiff"]').on('blur', function (pEvent, pData) {
            that._checkOutputPath(pEvent.target.value);
          });
        }
      } else {
        var resModeVH = this.Engineer.get("appOptions.ui.allowNoneSquareResolutions");
        var vResolutions = this.Engineer.getVerticalResolutions();
        var selectVRes = $('<select name="output.resolution_v">').addClass('cf-form-control form-control cf-form-select');
        if (resModeVH === 'COMBINED') {
          vResolutions.forEach(function (vr) {
            var hResolutions = that.Engineer.getHorizontalResolutions(vr);
            for (var res in hResolutions) {
              var combined = hResolutions[res].name + " x " + vr.name; // Trac #32279
              selectVRes.append("<option value='" + combined + "'>" + combined + "</option>");
            }
          });
        } else {
          for (var res in vResolutions) {
            selectVRes.append("<option value='" + vResolutions[res].name + "'>" + vResolutions[res].name + "</option>");
          }
        }
        var label = resModeVH === true ? $.i18n._("nixps-RIPEditor-output.vertical") : $.i18n._("nixps-dfe-editor-output.hrespervres");
        form.append($('<label for="output.resolution_v">').addClass('control-label cf-form-label').text(label)).append($('<div>').append(selectVRes));
        if (this.options.readOnly) {
          selectVRes.attr('disabled', 'disabled');
        } else {
          selectVRes.on('change', function () {
            // that._populateMediaDropDown(false);
          });
        }
        if (resModeVH === true) {
          var selectHRes = $('<select name="output.resolution_h">').addClass('form-control cf-form-select');
          for (var res in vResolutions) {
            selectHRes.append("<option value='" + vResolutions[res].name + "'>" + vResolutions[res].name + "</option>");
          }
          form.append($('<label for="output.resolution_h">').addClass('control-label cf-form-label').text($.i18n._("nixps-RIPEditor-output.horizontal"))).append($('<div>').append(selectHRes));
          if (this.options.readOnly) {
            selectHRes.attr('disabled', 'disabled');
          } else {
            selectHRes.on('change', function () {
              // that._populateMediaDropDown(false);
            });
          }
        }
      }
      return form;
    },
    _addOutputProperties: function _addOutputProperties() {
      var that = this;
      var form = $('<div>').addClass('output_transformation grid_2columns');

      // --- Number of Copies
      form.append($('<label name="output.copies">').addClass('control-label cf-form-label').text($.i18n._("nixps-rip-editor-output.copies"))).append($('<span name="output.copies">').addClass('control-checkbox').css({
        'font-size': '12px'
      }).append($('<input type="number" name="output.copies">').addClass('cf-form-control').val("1").css({
        'display': 'inline-block',
        'width': '33.33%',
        'margin-right': '10px'
      })).append($('<span>').addClass('control-checkbox').append($('<label name="output.collate_copies">').addClass('cf-form-label').css('margin', 'initial').append($('<input type="checkbox" name="output.collate_copies" class="cf-form-checkbox">')).append($('<span>').addClass("cf-form-checkboxlabel").text('Collate')))));
      if (!this.Engineer.getBehavior('sendToPress') && this.Engineer.get('context.app') !== 'canon_dfe') {
        form.find('label[name="output.copies"]').hide();
        form.find('span[name="output.copies"]').hide();
      }

      // --- Page Range
      var selectPagerange = $('<select name="output.pagerange" class="cf-form-select">').append($('<option value="all" selected>').html($.i18n._("nixps-RIPEditor-output.page_all"))).append($('<option value="range">').html($.i18n._("nixps-RIPEditor-output.page_range"))).append($('<option value="offset_block">').html($.i18n._("nixps-cloudflow-projectmetadata.custom")));
      selectPagerange.on('change', function (pEvent, pData) {
        if (selectPagerange.val() === 'range') {
          var val = that.element.find('input[name="output.pagerange"]').val();
          if (val.length === 0) {
            that.element.find('input[name="output.pagerange"]').val('1 - ');
          }
        }
      });
      if (this.options.readOnly) {
        selectPagerange.attr('disabled', 'disabled');
      }
      form.append($('<label name="output.pagerange">').addClass('control-label cf-form-label').text($.i18n._("nixps-rip-editor-output.pages"))).append($('<div>').append($('<span>').addClass('cf-col-4 cf-form cf-inlineform').css({
        'position': 'initial'
      }).append(selectPagerange)).append($('<span>').addClass('cf-col-8 cf-form cf-inlineform').css({
        'position': 'initial'
      }).append($('<input type="text" name="output.pagerange" placeholder="3, 5, 10-20, 30-">').hide().addClass('form-control cf-form-control')).append($('<span name="output.page_no_option">'))));
      form.append($('<label name="output.page_offset_block">').addClass('control-label cf-form-label').hide()).append($('<span name="output.page_offset_block">').hide().append($('<div>').addClass('col-md-4 cf-col-md-4').append($('<label>').text('From').addClass('cf-form-label')).append($('<span>').append($('<input type="number" name="output.custom_pagestart" min="1" value="1" placeholder="1">').addClass('form-control cf-form-control')))).append($('<div>').addClass('col-md-4 cf-col-md-4').append($('<label>').text('To').addClass('cf-form-label')).append($('<span>').append($('<input type="number" name="output.custom_pagestop" value="" placeholder="the end.">').addClass('form-control cf-form-control')))).append($('<div>').addClass('col-md-4 cf-col-md-4').append($('<label>').text('Every').addClass('cf-form-label')).append($('<span>').append($('<input type="number" name="output.pageblock" min="2" value="2" placeholder="2">').addClass('form-control cf-form-control')))));

      // --- Page Box
      var selectPagebox = $('<select name="output.pagebox">').addClass('form-control cf-form-select').css({
        'width': '50%'
      }).append($('<option value="mediabox" selected>').html($.i18n._("nixps-cloudflow-assets.mediabox"))).append($('<option value="cropbox">').html($.i18n._("nixps-cloudflow-assets.cropbox"))).append($('<option value="bleedbox">').html($.i18n._("nixps-cloudflow-assets.bleedbox"))).append($('<option value="trimbox">').html($.i18n._("nixps-cloudflow-assets.trimbox"))).append($('<option value="artbox">').html($.i18n._("nixps-cloudflow-assets.artbox")));
      if (this.options.readOnly) {
        selectPagebox.attr('disabled', 'disabled');
      }
      form.append($('<label name="output.pagebox">').addClass('control-label cf-form-label').text($.i18n._("nixps-rip-editor-output.pagebox"))).append($('<div>').append(selectPagebox));

      // Vertical Distortion
      var inputV = $("<input>").attr('name', 'output.distortion_v').attr('type', 'text').addClass('form-control cf-form-control');
      inputV.ValueInput({
        language: this.options.language,
        name: 'output.distortion_v',
        displayDefinition: "distortion",
        storageUnit: '%',
        transform: {
          from: function from(value) {
            return value + 100;
          },
          to: function to(value) {
            return value - 100;
          }
        }
      });
      form.append($("<label>").addClass("control-label cf-form-label").attr("for", "output.distortion_v")._t("nixps-RIPEditor-output.verticaldistortion")).append($('<div>').append(inputV));

      // Horizontal Distortion
      var inputH = $("<input>").attr('name', 'output.distortion_h').attr('type', 'text').addClass('form-control cf-form-control');
      inputH.ValueInput({
        language: this.options.language,
        name: 'output.distortion_h',
        displayDefinition: "distortion",
        storageUnit: '%',
        transform: {
          from: function from(value) {
            return value + 100;
          },
          to: function to(value) {
            return value - 100;
          }
        }
      });
      form.append($("<label>").addClass("control-label cf-form-label").attr("for", "output.distortion_h")._t("nixps-RIPEditor-output.horizonaldistortion")).append($('<div>').append(inputH));

      // --- Rotation
      var selectRot = $('<select name="output.rotation">').addClass('form-control cf-form-select').css({
        'width': '50%'
      }).append($('<option value="0">').html($.i18n._("nixps-RIPEditor-output.rotation_0"))).append($('<option value="90">').html($.i18n._("nixps-RIPEditor-output.rotation_90"))).append($('<option value="180">').html($.i18n._("nixps-RIPEditor-output.rotation_180"))).append($('<option value="270">').html($.i18n._("nixps-RIPEditor-CIP3.rotation_270")));
      if (this.options.readOnly) {
        selectRot.attr('disabled', 'disabled');
      }
      form.append($('<label name="output.rotation">').addClass('control-label cf-form-label').text($.i18n._("nixps-rip-editor-output.rotation"))).append($('<div name="output.rotation">').append(selectRot));
      if (this.Engineer.get('appOptions.ui.allowRotation') === false) {
        form.find('[name="output.rotation"]').hide();
        selectRot.val("0");
      }

      // --- Mirroring
      form.append($('<label name="output.mirror">').addClass('control-label cf-form-label').text($.i18n._("nixps-rip-editor-output.mirror")));
      var directionForm = $('<span name="output.mirror">').appendTo(form);
      [{
        'v': 'output.mirror_output',
        'n': 'horizontal'
      }, {
        'v': 'output.flip_output',
        'n': 'vertical'
      }].forEach(function (prop) {
        var span = $('<span>').addClass('control-checkbox').append($('<label name="' + prop.v + '">').addClass('checkbox-label cf-form-label').append($('<input type="checkbox" name="' + prop.v + '" class="cf-form-checkbox">')).append($('<span>').addClass("cf-form-checkboxlabel").text($.i18n._('nixps-RIPEditor-output.' + prop.n)))).appendTo(directionForm);
        if (that.options.readOnly) {
          span.find('input').attr('disabled', 'disabled');
        }
      });
      form.find('input[name="output.flip_output"]').css({
        'margin-left': '15px'
      });

      // --- Bits per Channel
      form.append($('<label name="bitspercomponent">').addClass('control-label cf-form-label').text($.i18n._("nixps-RIPEditor-output.bitsperchanel"))).append($('<span name="bitspercomponent">').addClass('control-checkbox').css({
        'font-size': '12px'
      }).append($('<select name="bitspercomponent" class="cf-form-select">').css({
        'display': 'inline-block',
        'width': '25%',
        'margin-right': '10px'
      }).append($('<option name="1bpc" value="1">').text('1')).append($('<option name="2bpc" value="2">').text('2'))).append($('<span>').addClass('control-checkbox').append($('<label name="output.compression">').addClass('checkbox-label cf-form-checkboxlabel').append($('<input type="checkbox" name="output.compression" class="cf-form-checkbox">')).append($('<span>').addClass("cf-form-checkboxlabel").text('Compressed')))));
      if (!this.Engineer.getBehavior('screening.perform')) {
        form.find('label[name="bitspercomponent"]').hide();
        form.find('span[name="bitspercomponent"]').hide();
        form.find('select[name="bitspercomponent"]').append($('<option name="4bpc" value="4">').text('4')).append($('<option name="8bpc" value="8">').text('8')).append($('<option name="10bpc" value="10">').text('10')).append($('<option name="16bpc" value="16">').text('16'));
      } else {
        if (this.Engineer.getBehavior('SPDirect')) {
          form.find('label[name="output.compression"]').hide();
        }
        if (that.options.readOnly) {
          form.find('select[name="bitspercomponent"]').attr('disabled', 'disabled');
          form.find('input[name="output.compression"]').attr('disabled', 'disabled');
        }
      }
      return form;
    },
    _addScreening: function _addScreening() {
      var that = this;
      var form = $('<div>').addClass('output_screening grid_2columns');
      form.append($('<label name="screeningTitle">').addClass('control-label cf-form-label').text('Screens'));
      var screeningCard = $('<div>').appendTo(form);
      var screenings;
      if (this.Engineer.getBehavior('SPDirect')) {
        screenings = this.Engineer.getScreenProScreenings();
      } else {
        screenings = nixps.dfeeditor.util.getScreenings(this.options.dfe_context.app);
      }
      if (Array.isArray(screenings) && screenings.length > 0) {
        screeningCard.attr('name', "screening");
        var selScreens = $('<select name="screen">').addClass('form-control cf-form-select').appendTo(screeningCard);
        for (var sc in screenings) {
          selScreens.append($('<option>').val(screenings[sc].value).text(screenings[sc].name));
        }
        if (this.options.readOnly) {
          selScreens.attr('disabled', 'disabled');
        } else {
          selScreens.on('change', function () {
            // that._populateMediaDropDown(false);
          });
        }
      } else {
        $('<div name="screening">').appendTo(screeningCard).ScreenSelector().find('select').addClass("form-control cf-form-control");
      }

      // ScreenPro Values
      // var screenproSettings = this.Engineer.getScreenProScreenings();
      // var screenproData = $('<div name="screenproData">').hide().appendTo(screeningCard)
      // var screenproSel = $('<select name="screenpro">').addClass('form-control').appendTo(screenproData);
      // this._on(screenproSel, {'change': this._handleScreenProOptions});
      // for (var sc in screenproSettings) {
      //     screenproSel.append($('<option>').val(sc).text(screenproSettings[sc].name));
      // }

      if (!this.Engineer.getBehavior('SPDirect')) {
        var row2Left = $('<div>').addClass('control-label cf-form-label').css({
          'font-size': 'smaller',
          'align-self': 'start'
        }).appendTo(form);
        row2Left.append($('<div name="AnglesAndRuling">').append($('<label name="subAnglesAndRuling">').addClass('cf-form-label').css({
          'margin': '2px 0 3px 0'
        }).text("Angles")).append('<br name="subAnglesAndRuling">').append($('<label name="subAnglesAndRuling">').addClass('cf-form-label').text($.i18n._('nixps-RIPEditor-separations.color_ruling'))));
        row2Left.append($('<label name="ScreenProOptions">').addClass('cf-form-label') /*.text("Options")*/.hide());
        var row2Right = $('<span>').appendTo(form);
        $('<div name="AnglesAndRuling">').css({
          'font-size': 'smaller'
        }).append($('<div name="subAnglesAndRuling">').append(this.Engineer.getAngles())).append($('<div name="subAnglesAndRuling">').append(this.Engineer.getRuling())).appendTo(row2Right);
      }
      // $('<div name="ScreenProOptions">').addClass('control-checkbox').append($('<label name="ScreenProErrorDiffusion">').addClass('checkbox-label')
      //     .append($('<input type="checkbox" name="ScreenProErrorDiffusion" class="cf-form-checkbox">'))
      //     .append($('<span>').addClass("cf-form-checkboxlabel").text($.i18n._('nixps-rip-editor-output.error_diffusion')))).hide().appendTo(row2Right);

      // if (this.options.readOnly) {
      //     screenproSel.attr('disabled', 'disabled');
      //     // screenproData.find('[name="ScreenProErrorDiffusion"]').attr('disabled', 'disabled');
      // }

      if (!this.options.readOnly && this.Engineer.get("output.halftone")) {
        // TODO  "output.halftone" no more take in account. To do again!!!
        // form.find('[name=AnglesAndRuling]').append($('<label>').text("Angles"));

        // var screening_details = $("<div class='row'>");
        // screening_details.append("<label class='col-xs-3 control-label'></label>");
        //
        // var anglesAndRuling = $("<div id='screeningDetails'>").addClass('col-xs-9');
        // anglesAndRuling.append(this.Engineer.getAnglesAndRuling());
        // screening_details.append(anglesAndRuling);
        //
        // var screenproOptions = $("<span name='ScreenProOptions' style='padding: 0 10px'/>");
        // screening_details.append(screenproOptions);
        //
        // pPanelBody.append(screening_details);
      }
      return form;
    },
    /**
     * @brief Helper function that makes the panels draggable
     */
    _makeDraggable: function _makeDraggable() {
      var panelList = this.element.find('.draggablePanelList');
      if (this.options.bootstrap) {
        jQuery(function ($) {
          panelList.sortable({
            // Only make the .panel-heading child elements support dragging.
            // Omit this to make then entire <li>...</li> draggable.
            handle: '.panel-heading',
            update: function update() {
              $('.panel', panelList).each(function (index, elem) {
                var $listItem = $(elem),
                  newIndex = $listItem.index();

                // Persist the new indices.
              });
            }
          });
        });
      } else {
        jQuery(function ($) {
          panelList.accordion({
            collapsible: true,
            heightStyle: "content"
          });
        });
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      this._super(pKey, pValue);
      if (pKey === "settings" && _typeof(pValue) === "object") {
        // console.log('DFEEditor.setOption.settings');
        if (typeof this.options.settings.dfe === 'boolean' || this.options.settings.color === undefined || this.options.settings.color.media === undefined) {
          // The setting set seems not being a 'DFE' setting.
          var engineer;
          if (!window.dfe_context && this.options.dfe_context) {
            engineer = nixps.dfe.getEngineerInstance(this.options.dfe_context);
          } else {
            engineer = nixps.dfe.getEngineerInstance(window.dfe_context);
          }
          var json = engineer.get('defaultJobTicket', {});
          if (json.separations === undefined) {
            json.separations = {};
          }
          json.separations.inks = engineer.getDefaultInks(true);

          // Extend/Replace the settings with the "Default" one.
          // var extended = $.extend(true, this.options.settings, json);
        }

        this.options.settings.dfe = {
          'app': this.options.dfe_context.app
        };
        if (this.options.settings.color === undefined) {
          this.options.settings.color = {
            'media': 'Default'
          };
        } else if (this.options.settings.color.media === undefined) {
          this.options.settings.color.media = 'Default';
        }

        // Set the default resolution and media according to the job information (url parameter)
        // TODO: to review
        // if ($.isPlainObject(window.QueryString) === true
        //     && typeof QueryString["media"] === "string" && QueryString["media"].length > 0
        //     && typeof QueryString["resolution"] === "string" && QueryString["resolution"].length > 0) {
        //     var medianame = decodeURI(QueryString["media"]);
        //     var resolution = parseInt(QueryString["resolution"]);
        //     this.options.settings.output.resolution_v = resolution;
        //     this.options.settings.output.resolution_h = resolution;
        //     this.options.settings.color.media = medianame;
        // }

        if (this.options.summarize) {
          this.separationsCategory.DFESeparationListSummary("option", pKey, pValue);
        } else {
          this.separationsCategory.DFESeparationList("option", pKey, pValue);
        }
      }
      this._refresh();
    },
    _refresh: function _refresh() {
      var that = this;
      this.element.find('input').prop('disabled', this.options.readOnly);
      this.element.find('select').prop('disabled', this.options.readOnly);
      this.element.find('select[name="output.canon_resolutions"]').prop('disabled', true);
      if (this.options.settings === undefined) {
        this.options.settings = {};
      }
      ['output', 'color', 'separations', 'postprocess'].forEach(function (prop) {
        if (that.options.settings[prop] === undefined) {
          that.options.settings[prop] = {};
        }
      });
      if (this.options.settings.separations.inks === undefined) {
        this.options.settings.separations.inks = [];
      }
      if (this.options.settings.postprocess.behavior === undefined) {
        this.options.settings.postprocess.behavior = {};
      }
      if (this.Engineer.get('appOptions.ui.showBehavior')) {
        // Behavior
        var settingsBehavior = this.options.settings.postprocess.behavior;
        if (!this.Engineer.getBehavior('sendToPress')) {
          settingsBehavior.send_to_device = false;
        }
        this.element.find('input[value="send_to_device"]').prop('checked', settingsBehavior.send_to_device);
        this.element.find('input[value="save_as_tiff"]').prop('checked', !settingsBehavior.send_to_device);
        this.element.find('[name=save_as_tiff]').prop('disabled', settingsBehavior.send_to_device || this.options.readOnly);

        // TODO
        this.element.find('input[name="save_as_tiff"]').val(settingsBehavior.tiffOutputFolder);
        if (this.Engineer.getBehavior('screening.enableAIS')) {
          // Advanced Inkjet Screens: Mirror and Pearl
          // - 1 bits per component for AIS dicts
          // - 2 bits for Pearl
          // - 4 bits for Mirror
          var screen = this.options.settings.separations.default_screen;
          var bits = this.options.settings.output.bitspercomponent;
          if (screen === 'Mirror') {
            if (bits === 2) {
              bits = 4;
            }
            this.element.find('select[name="bitspercomponent"] option[name="2bpc"]').text("4").attr("value", "4");
          } else {
            if (bits === 4) {
              bits = 2;
            }
            this.element.find('select[name="bitspercomponent"] option[name="2bpc"]').text("2").attr("value", "2");
          }
          this.element.find('select[name="bitspercomponent"]').val(bits);
        } else {
          this.element.find('select[name="bitspercomponent"]').val(this.options.settings.output.bitspercomponent);
        }
        this.element.find('input[value="proofscope"]').prop('checked', settingsBehavior.proofscope);
        if (this.options.settings.postprocess.behavior.preflight === undefined) {
          this.options.settings.postprocess.behavior.preflight = !settingsBehavior.send_to_device;
        }
        // if (this.options.settings.postprocess.behavior.preflightLimit === undefined)
        //     this.options.settings.postprocess.behavior.preflightLimit = 10;
        this.element.find('input[name="preflight"]').prop('checked', this.options.settings.postprocess.behavior.preflight);
        // this.element.find('select[name="preflightLimit"]').val(this.options.settings.postprocess.behavior.preflightLimit);

        // Perform Preflight or NOT
        var on = this.Engineer.getBehavior('preflight.perform') && this.element.find('input[name="preflight"]').is(':checked');
        if (on) {
          this.element.find('.preset_preflight').show();
        } else {
          this.element.find('.preset_preflight').hide();
          this.element.find('[name="preflightRecommandation"]').hide();
        }
        if (this.Engineer.getBehavior('postprocess.is_job_life_limited', false)) {
          var allowArchive = this.Engineer.get('appOptions.config.allow_to_archive_job', true);
          var maxAge = this.Engineer.get('appOptions.config.transactional_life_expectancy', 24);
          if (this.options.settings.postprocess.behavior.life_expectancy === undefined) {
            this.options.settings.postprocess.behavior.life_expectancy = allowArchive ? 0 : maxAge;
          }
          var expectancy = this.options.settings.postprocess.behavior.life_expectancy;
          if (allowArchive === false || expectancy > 0) {
            expectancy = Math.min(maxAge, Math.max(1, expectancy));
            this.element.find('input.archive_job').prop('disabled', !allowArchive);
            this.element.find('input.delete_job').prop('checked', true).prop('disabled', !allowArchive);
            this.element.find('select[name="life_expectancy"]').prop('disabled', false);
            this.element.find('select[name="life_expectancy"]').val(expectancy);
          } else {
            this.element.find('input.archive_job').prop('checked', true);
            this.element.find('select[name="life_expectancy"]').prop('disabled', true);
          }
        }
      }

      // Resolution
      var settingsOutput = this.options.settings.output;
      var resModeVH = this.Engineer.get("appOptions.ui.allowNoneSquareResolutions");
      if (this.Engineer.get('context.app') === 'canon_dfe') {
        this.element.find('input[name="save_as_tiff"]').val(this.options.settings.output_folder);
        if (settingsOutput.quality === undefined) {
          settingsOutput.quality = 'performance';
          if (settingsOutput.resolution_v === 1080) {
            settingsOutput.quality = 'alpine';
          } else if (settingsOutput.resolution_v === 360) {
            settingsOutput.quality = 'graphics';
          }
        }
        this.element.find('select[name="output.quality"]').val(settingsOutput.quality);
        this._onQualityChange(settingsOutput.quality);
        this._checkOutputPath(this.options.settings.output_folder);
      } else {
        var vResName = this.Engineer.getResolutionName(settingsOutput.resolution_v);
        var hResName = this.Engineer.getResolutionName(settingsOutput.resolution_h);
        if (resModeVH === true) {
          this.element.find('[name="output.resolution_v"]').val(vResName);
          this._updateHResolutionHandler();
          this.element.find('[name="output.resolution_h"]').val(hResName);
        } else if (resModeVH === 'COMBINED') {
          this.element.find('[name="output.resolution_v"]').val(hResName + " x " + vResName); // Trac#32279
        } else {
          this.element.find('[name="output.resolution_v"]').val(vResName);
        }
      }

      // Output Settings
      var rangemode = "all";
      var range = settingsOutput.pagerange;
      var block = settingsOutput.pageblock;
      var offset = settingsOutput.pageoffset;
      if (offset === undefined) {
        if (block === undefined) {
          if (range !== undefined && range.length > 0) {
            rangemode = "range";
            range = this._pageRangeToString(range);
          }
        } else {
          var start = range[0][0];
          rangemode = "offset_block";
          this.element.find('input[name="output.custom_pagestart"]').val(range[0][0]);
          this.element.find('input[name="output.custom_pagestop"]').val(range[0][1]);
          range = this._pageRangeToString(range);
          this.element.find('input[name="output.pageblock"]').val(block);
        }
      } else {
        rangemode = "offset_block";
        range = this._pageRangeToString(range);
      }
      this.element.find('select[name="output.pagerange"]').val(rangemode);
      this.element.find('input[name="output.pagerange"]').val(range);
      this.element.find('input[name="output.pagerange"]').hide();
      this.element.find('[name="output.page_offset_block"]').hide();
      this.element.find('span[name="output.page_no_option"]').hide();
      if (rangemode === 'range') {
        this.element.find('input[name="output.pagerange"]').show();
      } else if (rangemode === 'offset_block') {
        this.element.find('[name="output.page_offset_block"]').show();
      } else {
        this.element.find('span[name="output.page_no_option"]').show();
      }
      this.element.find('.nixps-quantum-ValueInput[name="output.distortion_v"]').ValueInput('option', 'value', nixps.dfeeditor.util.getValue(settingsOutput.distortion_v, 0));
      this.element.find('.nixps-quantum-ValueInput[name="output.distortion_h"]').ValueInput('option', 'value', nixps.dfeeditor.util.getValue(settingsOutput.distortion_h, 0));
      this.element.find('select[name="output.pagebox"]').val(nixps.dfeeditor.util.getValue(settingsOutput.pagebox, "mediabox"));
      this.element.find('select[name="output.rotation"]').val(nixps.dfeeditor.util.getValue(settingsOutput.rotation, 0));
      this.element.find('input[name="output.mirror_output"]').prop('checked', settingsOutput.mirror_output ? 'checked' : '');
      this.element.find('input[name="output.flip_output"]').prop('checked', settingsOutput.flip_output ? 'checked' : '');
      this.element.find('input[name="output.copies"]').val(settingsOutput.copies || "1");
      this.element.find('input[name="output.collate_copies"]').prop('checked', settingsOutput.collate_copies ? 'checked' : '');
      var enabled = !this.options.readOnly && (settingsBehavior !== undefined && settingsBehavior.send_to_device || this.Engineer.get('context.app') === 'canon_dfe');
      this.element.find('[name="output.copies"]').prop('disabled', !enabled);
      this.element.find('[name="output.collate_copies"]').prop('disabled', !enabled);
      if (this.Engineer.get('context.app') !== 'canon_dfe' && settingsOutput.copies > 1) {
        this.element.find('[name="output.collate_copies"]').show();
      } else {
        this.element.find('[name="output.collate_copies"]').hide();
      }
      this.element.find('input[name="output.compression"]').prop('checked', settingsOutput.compression === 'None' ? '' : 'checked');

      // Screening
      var settingsSeparations = this.options.settings.separations;
      // Trac#34913  this.element.find('div[name="screening"] select').val(settingsSeparations.default_screen);

      if (settingsSeparations.hasOwnProperty("screenpro")) {
        this.element.find('[name=screeningEngine]').val("ScreenPro");
        this.element.find('[name="screeningTitle"]').text("ScreenPro");
        var jsonSP = JSON.stringify(settingsSeparations.screenpro);
        // var sped = jQuery.extend(true, {}, settingsSeparations.screenpro)
        // sped.errorDiffusion = !settingsSeparations.screenpro
        // var jsonSPED = JSON.stringify(sped)
        // sped = jQuery.extend(true, {}, settingsSeparations.screenpro)
        // delete sped.errorDiffusion;
        // var jsonNoED = JSON.stringify(sped)
        var screenproSettings = this.Engineer.get('ScreenPro.screens');
        for (var sc in screenproSettings) {
          var jsp = JSON.stringify(screenproSettings[sc]);
          if (jsp === jsonSP /*|| jsp === jsonSPED || jsp === jsonNoED*/) {
            this.element.find('[name="screenpro"]').val(sc);
            break;
          }
        }
        // if (!this.options.readOnly) {
        //     this.element.find('input[name=ScreenProErrorDiffusion]').prop('checked', (settingsSeparations.screenpro.errorDiffusion ? 'checked' : ''))
        // } else {
        //     this.element.find('[name=ScreenProErrorDiffusion]').html(settingsSeparations.screenpro.errorDiffusion ? $.i18n._('nixps-rip-editor-output.error_diffusion') : '')
        // }
      } else {
        this.element.find('[name=screeningEngine]').val('Harlequin');
        this.element.find('[name="screeningTitle"]').text('Screen');
      }
      this._updateScreeningDetails(undefined);
      if (!this.options.readOnly) {
        this._handleScreeningEngine();
        this._handleScreenProOptions();
      } else {
        // Readonly mode. Shows only one dropdown list.
        var screenpro = settingsSeparations.hasOwnProperty("screenpro");
        this.element.find("[name=screenproData]").css('display', screenpro ? 'inherited' : 'none');
        this.element.find("[name=screening]").css('display', !screenpro ? "inherited" : "none");
      }

      // var data = {'resolution': this.options.settings.output.resolution_v,
      //     'screening': this.options.settings.separations.default_screen,
      //     'value': this.options.settings.color.media
      // };
      this.element.find('select[name=mediaProfile]').MediaSelector('setValue', this.options.settings.color.media);

      // Preflight
      var preflight_settings;
      if (this.options.settings !== undefined && this.options.settings.preflight !== undefined) {
        preflight_settings = this.options.settings.preflight;
      } else {
        preflight_settings = {};
      }
      ['min_res_check', 'max_res_check', 'rgb_check', 'bitmap_check', 'non_embedded_check', 'ko_black_text_check', 'ko_technical_check', 'non_sep_check'].forEach(function (check) {
        that.element.find('input[name="preflight.' + check + '"]').prop('checked', preflight_settings[check] ? 'checked' : '');
      });
      ['min_res', 'max_res'].forEach(function (check) {
        that.element.find('input[name="preflight.' + check + '_value"]').val(preflight_settings[check + '_value'] || 0).prop('disabled', that.options.readOnly || !preflight_settings[check + '_check']);
      });
    },
    _updateHResolutionHandler: function _updateHResolutionHandler(dummyEvent) {
      var resName = this.element.find('[name="output.resolution_v"]').val();
      if (resName == null || resName.indexOf(" x ") != -1) {
        return;
      }
      var vRes = this.Engineer.getResolutionByName(resName);
      var resolutions = this.Engineer.getHorizontalResolutions(vRes);
      var rulingSettingH = this.element.find('[name="output.resolution_h"]');
      if (Array.isArray(resolutions) && resolutions.length > 0) {
        var currHRes = rulingSettingH.val();
        rulingSettingH.empty();
        for (var res in resolutions) {
          rulingSettingH.append("<option value='" + resolutions[res].name + "'>" + resolutions[res].name + "</option>");
        }
        if (currHRes == null) {
          currHRes = resName;
        }
        rulingSettingH.val(currHRes);
        var val = rulingSettingH.val();
        if (val !== currHRes) {
          rulingSettingH.val(resolutions[0].name);
        }
      } else {
        rulingSettingH.empty();
      }
      if (dummyEvent != undefined) {
        this._changeHandler(dummyEvent);
      }
    },
    _updateScreeningDetails: function _updateScreeningDetails(pEvent) {
      // if ( !this.options.readOnly ) {

      var sName = this.element.find('div[name="screening"] select').val();
      if (sName == null) {
        return;
      }
      if (sName.startsWith("HDS-") || sName === "Mirror" || sName === "Pearl" /*|| screenpro */) {
        this.element.find("[name=subAnglesAndRuling]").hide();
      } else {
        this.element.find("[name=subAnglesAndRuling]").show();
      }
      // }
    },

    _parsePageRange: function _parsePageRange(range) {
      if (range !== undefined && Array.isArray(range)) {
        range = this._pageRangeToString(range);
      }
      var pageRanges = range !== undefined ? [] : null;
      if (typeof range === 'string' && range.length > 0) {
        var endSet = false;
        var maxRange = this.Engineer.get('appOptions.ui.maxNumberOfPageRange', -1);
        range.split(',').some(function (value) {
          value = value.trim();
          if (value == parseInt(value, 10) && parseInt(value, 10) > 0) {
            pageRanges.push(parseInt(value, 10));
          } else {
            var re = /(-*)(\d+) *- *(-*)(\d*)/;
            var matches;
            if ((matches = re.exec(value)) !== null) {
              var from = matches[2];
              var to = matches[4];
              if (matches[1] === "" && matches[3] === "" && from == parseInt(from, 10)) {
                from = parseInt(from, 10);
                if (to !== "" && to == parseInt(to, 10)) {
                  to = parseInt(to, 10);
                  if (from <= to) {
                    pageRanges.push([from, to]);
                  }
                } else if (!endSet && to === "") {
                  pageRanges.push([from, to]);
                  endSet = true;
                }
              }
            }
          }
          return maxRange > 0 ? pageRanges.length >= maxRange : false;
        });
      }
      return pageRanges;
    },
    _pageRangeToString: function _pageRangeToString(pageRanges) {
      var str = "";
      pageRanges.forEach(function (part) {
        str += str.length > 0 ? ', ' : '';
        if (Array.isArray(part) && part.length > 1) {
          str += part[0] + ' - ' + part[1];
        } else {
          str += part;
        }
      });
      return str;
    },
    _handleScreeningEngine: function _handleScreeningEngine() {
      if (!this.options.readOnly) {
        var screenpro = this.element.find('[name=screeningEngine]').val() === "ScreenPro";
        this.element.find("[name=screenproData]").css('display', screenpro ? "inherit" : "none");
        this.element.find("[name=ScreenProOptions]").css('display', screenpro ? "inherit" : "none");
        this.element.find("[name=screening]").css('display', !screenpro ? "inherit" : "none");
        this.element.find("[name=AnglesAndRuling]").css('display', !screenpro ? "inherit" : "none");
      }
    },
    _handleScreenProOptions: function _handleScreenProOptions() {
      // var screen = this.element.find("[name=screenpro]").val()
      // var options = this.Engineer.getScreenProOptions(screen)
      // this.element.find('[name=ScreenProOptions]').html(options)
    },
    _installHandlers: function _installHandlers() {
      this._on(this.element, {
        'dfeseparationlistchange': this._changeHandler,
        'change select': this._changeHandler,
        'change input': this._changeHandler
      });
      this._on(this.element.find('[name="output.resolution_v"]'), {
        'change': this._updateHResolutionHandler
      });
      // this._on(this.element.find('[name!="output.resolution_v"]'), {'change': this._changeHandler});
      // if ( !this.options.readOnly ) {
      this._on(this.element.find('select[name="screening"]'), {
        'change': this._updateScreeningDetails
      });
      // }
    },

    _getVerticalResolution: function _getVerticalResolution() {
      var val = this.element.find('[name="output.resolution_v"]').val();
      if (val == null) {
        return;
      }
      if (val.indexOf(' x ') != -1) {
        // Combined resolutions
        var pos = val.indexOf(' x ');
        val = val.substring(pos + 3); // Trac#32279
      }

      return this.Engineer.getResolutionByName(val);
    },
    _getHorizontalResolution: function _getHorizontalResolution() {
      var val = this.element.find('[name="output.resolution_v"]').val();
      if (val == null) {
        return;
      }
      var hVal = this.element.find('[name="output.resolution_h"]').val();
      if (val.indexOf(' x ') != -1) {
        // Combined resolutions
        var pos = val.indexOf(' x ');
        hVal = val.substring(0, pos); // Trac#32279
        val = val.substring(pos + 3);
      }
      var vres = this.Engineer.getResolutionByName(val);
      var hres = hVal === undefined || hVal === null || hVal.length == 0 ? vres : this.Engineer.getResolutionByName(hVal);
      return hres;
    },
    _changeHandler: function _changeHandler(pEvent, pData) {
      if (this._silentChanges) {
        return;
      }
      var output = {};
      if (this.Engineer.get('context.app') === 'canon_dfe') {
        this.options.settings.output_folder = this.element.find('input[name="save_as_tiff"]').val();
        output.quality = this.element.find('select[name="output.quality"]').val();
        var hres = 720,
          vres = 360;
        if (output.quality === 'quality' || output.quality === 'alpine') {
          vres = 1080;
        } else if (output.quality === 'performance') {
          vres = 720;
        }
        output.resolution_v = vres;
        output.resolution_h = hres;
      } else {
        var vres = this._getVerticalResolution();
        var hres = this._getHorizontalResolution();
        output.resolution_v = vres === undefined ? 1200 : vres.value;
        output.resolution_h = hres === undefined ? 1200 : hres.value;
      }
      this.options.settings.dfe = {
        app: this.options.dfe_context.app
      };

      // output settings
      output.distortion_v = parseFloat(this.element.find('[name="output.distortion_v"]').ValueInput('option', 'value'));
      output.distortion_h = parseFloat(this.element.find('[name="output.distortion_h"]').ValueInput('option', 'value'));
      output.pagebox = this.element.find('select[name="output.pagebox"]').val();
      output.rotation = this.Engineer.get('appOptions.ui.allowRotation') ? parseInt(this.element.find('select[name="output.rotation"]').val()) : 0;
      output.mirror_output = this.element.find('input[name="output.mirror_output"]').is(':checked') || false;
      output.flip_output = this.element.find('input[name="output.flip_output"]').is(':checked') || false;
      output.copies = Math.max(1, parseInt(this.element.find('input[name="output.copies"]').val() || 1));
      output.collate_copies = this.element.find('input[name="output.collate_copies"]').is(':checked') || false;
      output.bitspercomponent = parseInt(this.element.find('select[name="bitspercomponent"]').val() || 1);
      for (var prop in output) {
        this.options.settings.output[prop] = output[prop];
      }
      if (this.element.find('input[name="output.compression"]').is(':checked')) {
        delete this.options.settings.output.compression; // output.compression is removed to allow overload with FundamentalsCustom.json output settings
      } else {
        this.options.settings.output.compression = 'None';
      }
      var rangemode = this.element.find('select[name="output.pagerange"]').val();
      var range = this.element.find('input[name="output.pagerange"]').val();
      var pages = this._parsePageRange(range);
      if (rangemode === "range" && pages.length > 0) {
        this.options.settings.output.pagerange = pages;
        delete this.options.settings.output.pageoffset;
        delete this.options.settings.output.pageblock;

        // } else if ( rangemode === "even" || rangemode === "odd" ) {
        //     var start = Math.max(1, parseInt( this.element.find('input[name="output.pagestart"]').val()) );
        //     var stop = this.element.find('input[name="output.pagestop"]' ).val();
        //     if ( stop === "" || parseInt(stop) === NaN )
        //         stop = '';
        //     else
        //         stop = Math.max( stop, start+2);
        //     if ( rangemode === "even" )
        //         start += (start % 2 === 1 ? 1 : 0);
        //     else
        //         start += (start % 2 === 1 ? 0 : 1);
        //     this.options.settings.output.pagerange = [ [start, stop]];
        //     delete this.options.settings.output.pageoffset;
        //     this.options.settings.output.pageblock = 2;
      } else if (rangemode === "offset_block") {
        var block = Math.max(1, parseInt(this.element.find('input[name="output.pageblock"]').val()));
        var start = Math.max(1, parseInt(this.element.find('input[name="output.custom_pagestart"]').val()));
        var stop = this.element.find('input[name="output.custom_pagestop"]').val();
        if (stop === "" || isNaN(stop)) {
          stop = '';
        } else {
          stop = Math.max(stop, start + block);
        }
        this.options.settings.output.pagerange = [[start, stop]];
        delete this.options.settings.output.pageoffset;
        this.options.settings.output.pageblock = Math.max(2, block);
      } else if (rangemode === "all") {
        delete this.options.settings.output.pagerange;
        delete this.options.settings.output.pageoffset;
        delete this.options.settings.output.pageblock;
      }
      if (this.Engineer.get('appOptions.ui.showBehavior')) {
        // Behavior
        if (this.options.settings.postprocess.behavior === undefined) {
          this.options.settings.postprocess.behavior = {};
        }
        this.options.settings.postprocess.behavior.send_to_device = this.element.find('input[name=device_tiff]:checked').val() === 'send_to_device';

        // TODO
        this.options.settings.postprocess.behavior.tiffOutputFolder = this.element.find('input[name=save_as_tiff]').val();
        if (!this.options.settings.postprocess.behavior.send_to_device && this.Engineer.get('context.app') !== 'canon_dfe') {
          this.options.settings.output.copies = 1; // Save as TIFF. No sense to set a number of copies > 1
        }

        this.options.settings.postprocess.behavior.proofscope = this.element.find('input[name=proofscope]').is(':checked');
        this.options.settings.postprocess.behavior.preflight = this.element.find('input[name="preflight"]').is(':checked');
        // this.options.settings.postprocess.behavior.preflightLimit = this.element.find('select[name="preflightLimit"]').val();
        if (this.Engineer.getBehavior('postprocess.is_job_life_limited', false)) {
          if (this.element.find('input.archive_job:checked').length > 0) {
            this.options.settings.postprocess.behavior.life_expectancy = 0;
          } else {
            var expectancy = parseInt(this.element.find('select[name="life_expectancy"]').val());
            this.options.settings.postprocess.behavior.life_expectancy = expectancy;
          }
        }
      }

      // Separations
      // Trac#34913
      // if (this.options.settings.hasOwnProperty("separations")) {
      //     this.options.settings.separations.default_screen = this.element.find('div[name="screening"] select').val();
      // } else {
      //     this.options.settings.separations = {
      //         default_screen: this.element.find('div[name="screening"] select').val()
      //     }
      // }

      if (this.element.find('[name=screeningEngine]').val() === "ScreenPro") {
        var sp = this.element.find('select[name=screenpro]').val();
        var screenpro = this.Engineer.get('ScreenPro.screens')[sp];
        // screenpro.errorDiffusion = this.element.find('input[name=ScreenProErrorDiffusion]').is(':checked')
        this.options.settings.separations.screenpro = screenpro;
      } else {
        delete this.options.settings.separations.screenpro;
      }
      this.options.settings.color.media = this.element.find('select[name=mediaProfile]').MediaSelector('getValue');
      // Is media restricted. If yes, replace with the 'Default' one.
      // TODO
      // var constrained = $('#media').Media2('isCalibrationRestricted', this.options.settings.color.media,
      //     {'resolution': this.options.settings.output.resolution_v, 'screening': this.options.settings.separations.default_screen} );
      // if ( constrained || this.options.settings.color.media === "")
      //     this.options.settings.color.media = 'Default';

      var v = this.element.find('input[name="preflight.max_res_value"]').val();
      var w = parseInt(v);
      this.options.settings.preflight = {
        rgb_check: this.element.find('input[name="preflight.rgb_check"]').is(':checked'),
        bitmap_check: this.element.find('input[name="preflight.bitmap_check"]').is(':checked'),
        ko_black_text_check: this.element.find('input[name="preflight.ko_black_text_check"]').is(':checked'),
        ko_technical_check: this.element.find('input[name="preflight.ko_technical_check"]').is(':checked'),
        max_res_check: this.element.find('input[name="preflight.max_res_check"]').is(':checked'),
        max_res_value: parseInt(this.element.find('input[name="preflight.max_res_value"]').val()),
        min_res_check: this.element.find('input[name="preflight.min_res_check"]').is(':checked'),
        min_res_value: parseInt(this.element.find('input[name="preflight.min_res_value"]').val()),
        non_embedded_check: this.element.find('input[name="preflight.non_embedded_check"]').is(':checked'),
        non_sep_check: this.element.find('input[name="preflight.non_sep_check"]').is(':checked')
      };
      this.option("settings", this.options.settings);
      this._trigger("change", pEvent, {
        "settings": this.options.settings
      });
    }
  });
})(jQuery);
(function () {
  namespace("nixps.dfeeditor.util");
  var mResolutions = undefined;
  var mScreening = undefined;
  // var mAllowNSRes = undefined;

  nixps.dfeeditor.util = {
    flushResolutions: function flushResolutions() {
      mResolutions = undefined;
    },
    flushScreening: function flushScreening() {
      mScreening = undefined;
    },
    loadShit: function loadShit(dfeApp) {
      var engineer = nixps.dfe.getEngineerInstance(dfeApp);

      // Resolution Stuff
      if (Array.isArray(engineer.getVerticalResolutions())) {
        mResolutions = engineer.getVerticalResolutions();
      } else {
        mResolutions = [];
      }

      // Retrieve Screening Stuff
      var halftone = engineer.getSetting("output.halftone");
      /*if ( halftone == false) {
          mScreening = ["None"];
      } else */
      if (Array.isArray(engineer.getScreenings())) {
        mScreening = engineer.getScreenings();
      } else {
        mScreening = [];
      }
    },
    getResolutions: function getResolutions(dfeApp) {
      if (mResolutions === undefined) {
        this.loadShit(dfeApp);
      }
      ;
      return mResolutions;
    },
    updateResolutions: function updateResolutions(pResolutions) {
      mResolutions = pResolutions;
    },
    // getAllowNSR: function() {
    //     if (mAllowNSRes === undefined) {
    //         this.loadShit();
    //     }
    //     return mAllowNSRes;
    // },
    //
    // updateAllowNSR: function(pAllowNSR) {
    //     mAllowNSRes = pAllowNSR;
    // },

    getScreenings: function getScreenings(dfeApp) {
      if (mScreening === undefined) {
        this.loadShit(dfeApp);
      }
      ;
      return mScreening;
    },
    updateScreenings: function updateScreenings(pScreening) {
      mScreening = pScreening;
    },
    getValue: function getValue(pParameter, pDefault) {
      if (pParameter === undefined) {
        return pDefault;
      }
      return pParameter;
    },
    createFormGroup: function createFormGroup(pLabel, pControl, pLabelWidth, pControlWidth) {
      var formGroup = $("<div>");
      formGroup.addClass("row");
      formGroup.append("<label for=\"" + pControl.attr("name") + "\" class=\"" + (pLabelWidth || "col-xs-3") + " control-label cf-form-label\">" + pLabel + "</label>");
      var controls = $("<div>");
      controls.addClass(pControlWidth || "col-xs-9");
      controls.appendTo(formGroup);
      pControl.appendTo(controls);
      return formGroup;
    },
    /**
     * @brief this function controls the input of the outputfile\
     * if empty it fills in with a default value pDefaultName
     * if it do not end with a / then add one to it
     * @param {string} pDefaultName: the name we must use if no value is aviable
     * @param {html_DOM_jQuery} pInputTagValue: the inputTag with value we must correct
     */
    controlOutputPath: function controlOutputPath(pDefaultName, pInputTagValue) {
      var path = pInputTagValue.val();
      if (typeof path !== "string" || path.length <= 0) {
        path = pDefaultName; //'file:///';
      } else if (path.slice(-1) !== '/' && path.slice(-1) !== '\\') {
        path = path.concat('/');
      }
      pInputTagValue.val(path);
      return path;
    }
  };
})();

},{"../../../3rdParty/jquery.ui.onresize.js":6,"./nixps-dfe-Engineer.js":99,"./nixps-dfe-MediaSelector.js":100,"./nixps-dfe-SeparationList.js":101,"./nixps-dfe-SeparationListSummary.js":102}],99:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * Created by laurent on 27/03/2017.
 */

(function ($) {
  require('../../../common/js/namespace.js');
  var Context = require("../../../pagebuilder/js/Context.js");
  window.namespace("nixps.dfe");

  /** List of keys required in the engineer configuration, and there allowed values.
      *  First value of the array is the default value
   *  If value is not an array then the check ensure the key is defined, otherwise the value is set to it.
  	 NOTE: This object is duplicated in the CFApp DFE_Core/...../js/wfl-Engineer.js
          Ensure that both definition are identical.
   */
  var _engineerAllowedValues = {
    'appOptions.behavior.export.nonDigital': [false, true],
    'appOptions.behavior.SPDirect': [false, true],
    'appOptions.behavior.export.dieSeparately': [false, true],
    'appOptions.behavior.outputContoneAsPDF': [false, true],
    'appOptions.behavior.outputInSubFolder': [true, false],
    'appOptions.behavior.preflight.perform': [true, false],
    'appOptions.behavior.preflight.onErrorAction': ['Abort', 'Continue', 'HoldOn'],
    'appOptions.behavior.print.convertSpot': [true, false],
    'appOptions.behavior.print.mapSpot': [false, true],
    'appOptions.behavior.print.namedColorEdition': [false, true],
    'appOptions.behavior.ripMaxPageRange': 1000,
    'appOptions.behavior.screening.perform': [true, false],
    'appOptions.behavior.screening.enableAIS': [false, true],
    'appOptions.behavior.sendToPress': [false, true],
    'appOptions.ui.allowRotation': [true, false],
    'appOptions.ui.allowNoneSquareResolutions': [true, false],
    'appOptions.ui.allowPresetEditionInJobStation': [true, false],
    'appOptions.ui.showBehavior': [true, false],
    'appOptions.ui.showMediaCM': [undefined, true, false],
    'appOptions.ui.showPrintbars': [false, true],
    'output.filetype': ['TIFF', 'BMP'],
    'output.separated': [true, false],
    'output.halftone': [false, true],
    'output.bitspercomponent': [1, 2, 4, 8, 12, 16],
    // Bits per channel
    'output.negative_output': [false, true],
    'output.mirror_output': [false, true],
    // TIFF options
    'output.tiff_format': ['Multiple strips', 'single strip'],
    'output.compression': ['LZW', 'None', 'CCITT Group 3', 'CCITT Group 4', 'CCITT Huffman', 'Flate'],
    'output.anti_alias': ['None', '2x2', '4x4'],
    'output.reverse_order': [false, true],
    'output.pad_32': [false, true],
    'separations.inkspace': 'CMYK'
  };

  /**
   NOTE: This object is duplicated in the CFApp DFE_Core/...../js/wfl-Engineer.js
          Ensure that both definition are identical.
   */
  var _defaultDFESettings = {
    // Engineer Settings
    context: {
      app: 'Fundamentals',
      core: "core",
      productName: "Fundamentals"
    },
    appOptions: {
      // Applications Options
      dfeHostname: "localhost",
      // Useful to FUNDEV2 - Host name of the DFE
      behavior: {
        SPDirect: false,
        // Enable/Disable the use of ScreenProDirect.
        preflight: {// Preflight behavior
          // 	perform: true,
          // 	onErrorAction: "Abort"
        },
        screening: {// Screening behavior
          // 	perform: true,
          // 	ScreenPro: false,     // OBSOLETE
          // 	enableAIS: false		// Enable Advanced Inkjet Screens - Require HHR MLSMix license option as well
        },
        print: {
          // 	convertSpot: true,       // Convert Spot Color to Output ICCProfile or CMYK
          // 	mapSpot: false,		     // Map Spot Color to an ink (not printed)
          // 	namedColorEdition: false // Spot Color - Named Color Edition
        },
        // sendToPress: false,         // "Send to Press/Device" versus "Save as TIFF"
        "export": {
          // 	nonDigital: false,		// Export "flexo" and technical separations
          // 	dieSeparately: false	// Export "die" and technical separations in a second folder
        },
        postprocess: {
          db_connect: {// Useful to FUNDEV2.
          }
          // is_job_life_limited: false
        },

        "import": {
          cgats_density: 'visual'
        }
        // outputContoneAsPDF: false,   // Export/Save CMYK contone wrapped in a PDF.
        // outputInSubFolder: true,	 // Create a subfolder (with job name) in TIFF/Export Output location
        // ripMaxPageRange: 1000		 // Maximum length of page range to RIP
        // byPassScreening: false    // Useful to FUNDEV1.
      },

      proofscope: {
        renderSingleColorantAsBlack: false
      },
      ui: {
        // allowRotation: true,
        // allowNoneSquareResolutions: true,      // true/false or COMBINED
        // allowPresetEditionInJobStation: true,  // Allow to customize Job Ticket in Job Station or not
        // maxNumberOfPageRange: -1,  // Maximum number of Page Range allowed in the UI (< 1 means 'unlimited')
        // showBehavior: true,  // Show/Hide Behavior part in Preset
        // showMediaCM: true,	 // Show/Hide Media Color Management (true/false/undefined (colorspace dependent))
        // showPrintbars: false // Show/Hide Printbar management in Settings/Setup
      }
    },
    outputFolder: {
      toPrint: "cloudflow://PP_FILE_STORE/Output/Digital/",
      toExport: "cloudflow://PP_FILE_STORE/Output/Flexo/"
    },
    output: {
      // RIP Output settings
      filetype: "TIFF",
      // "TIFF" or "BMP" or "PDF"
      separated: true,
      // output separated or composite
      halftone: true,
      // output haltone or not (not used in composite).
      bitspercomponent: 1,
      // Bits per channel
      negative_output: false,
      mirror_output: false,
      // TIFF options
      tiff_format: "Multiple strips",
      compression: "LZW",
      anti_alias: "None",
      reverse_order: false,
      pad_32: false,
      ruling: 150 // Unit: lpi

      // postprocess: {
      //     behavior: {
      //         ...
      //     }
      //	   ...
      // },
      // "fast_patterns": false,
      // "old_imagemasks": false,
      // "abort_fonts": false,
      // "font_emulation": false,
      // "colormodel": "DeviceCMYK",
      // "rotation": 0,
      // "bmp_format": "domino",
      // "outputPathEnable": false,
      // "outputPathHold": false
    },

    pressModel: {
      name: undefined,
      // Press model name
      // 	printhead_per_printbar: 4    // Number of Printhead per Printbar. Printbars are described in 'separations.printbar'
      maxPrintbar: 16,
      // Max number of printbar to manage.
      onePrintbarPerInk: true // An ink can be assigned to one and only one printbar.
    },

    separations: {
      inkspace: "CMYK",
      // CMYKOGVcm",
      printbar: [// Ordered inks used on printbar. Define the number of separation to print.
        // "Cyan", "Magenta", "Yellow", "Black", ...
        // {"name": "Cyan", "PB": [1,2] }, {"name": "Magenta", "PB": [4] },  {"name": "Yellow", "PB": [3] },
      ],
      inks: [{
        name: "Cyan",
        letter: "C",
        cmyk: [1, 0, 0, 0],
        rgb: "cyan",
        angle: 15
      }, {
        name: "Magenta",
        letter: "M",
        cmyk: [0, 1, 0, 0],
        rgb: "magenta",
        angle: 75
      }, {
        name: "Yellow",
        letter: "Y",
        cmyk: [0, 0, 1, 0],
        rgb: "yellow",
        angle: 90
      }, {
        name: "Black",
        letter: "K",
        cmyk: [0, 0, 0, 1],
        rgb: "black",
        angle: 45
      }
      // {name: "White", letter: "W", cmyk: [0,0,0,0], rgb: "white", angle: 90},
      // {name: "Orange", letter: "O", cmyk: [0,0.353,1,0], rgb: "orange", angle: 15},
      // {name: "Green", letter: "G", cmyk: [0.63,0,1,0], rgb: "green", angle: 75},
      // {name: "Violet", letter: "V", cmyk: [0.5,1,0,0], rgb: "violet", angle: 45},
      // {name: "Cyan light", letter: "c", cmyk: [0.27,0.01,0.03,0], rgb: "lightcyan", angle: 15},
      // {name: "Magenta light", letter: "m", cmyk: [0.11,0.4,0.03,0], rgb: "lightpink", angle: 75},
      // {name: "Yellow light", letter: "y", cmyk: [0.1,0,0.14,0], rgb: "lightyellow", angle: 90},
      // {name: "Black light", letter: "k", cmyk: [0.5,0.4,0.31,0.02], rgb: "lightslategray", angle: 45}
      ],

      toFlexo: ["^spot\\s\\d$"],
      toFinish: ["^die(\\s*line)*$", "^cut$", "fold(ing)*"]
    },
    screens: ["_ALL_"]
    // resolutions: [
    //     { horizontal: 1200, vertical: [1200, 900, 600] }
    // ]
    // resolutions: [ // Vertical resolutions. unit: dpi
    // 	{ value: 2000,
    // 	    horizontal: [  // horizontal resolutions. unit: dpi
    // 	        { value: 2010 }, {value: 2005}, {value: 1995}
    // 	    ]},
    // 	{ value: 1200 },
    // 	{ value: 600,
    // 	    horizontal: [
    // 	        { value: 605 },
    // 	        { value: 595 }
    // 	    ]},
    // 	{ value: 300 }
    // ]
  };

  var _engineerInstances = {};
  nixps.dfe.getEngineerInstance = function (setting, cfContext) {
    if (setting.context !== undefined && setting.context.app !== undefined) setting = setting.context.app;else if (setting.app !== undefined) setting = setting.app;
    if (typeof setting === 'string') {
      var ret = _engineerInstances[setting];
      if (ret !== undefined) return ret;
    }
    return new nixps.dfe.Engineer(setting, cfContext);
  };
  nixps.dfe.Engineer = function (setting, cfContext) {
    var that = this;
    this._settings = _defaultDFESettings;
    this.cfContext = cfContext;
    if (this.cfContext === undefined) {
      var ctxt = Context.fromURL();
      ctxt.loadDataAndReturnsMe({
        use_cache: true
      }).then(function (cfCtxt) {
        that.cfContext = cfCtxt;
      });
    }
    if (_typeof(setting) === 'object' && setting._id === undefined) {
      if (setting.context !== undefined && setting.context.app !== undefined) {
        setting = setting.context.app;
      } else if (setting.app !== undefined) {
        setting = setting.app;
      }
    }
    if (typeof setting === 'string') {
      var dfeDB = api.custom_objects.list('fundamentals', ['type', 'equal to', 'Engineer', 'and', 'context.app', 'equal to', setting]).results;
      if (dfeDB.length > 0) {
        this._settings = dfeDB[0]; // Take the first one. // TODO. To improve. Might introduce incoherences
      } else {
        throw new Error('Engineer is not defined for the app: "' + setting + "'");
      }
    } else {
      this._settings = setting;
    }
    _engineerInstances[this._settings.context.app] = this;
    if (this._settings.appOptions !== undefined) {
      this._settings.appOptions.unitPrefs = api.preferences.get_for_current_user('', 'units').preferences;
    }
    var _outdated = function _outdated() {
      api_async.custom_objects.list('fundamentals', ['type', 'equal to', 'Engineer', 'and', 'context.app', 'equal to', that._settings.context.app], ['context', 'save_id', 'engineerDate', 'customDate'], function (dfeDB) {
        if (dfeDB.results !== undefined) {
          if (dfeDB.results.length > 0 && that._settings.save_id !== dfeDB.results[0].save_id) {
            if (that._settings.context.app_version !== dfeDB.results[0].context.app_version) {
              throw {
                'severity': 'fatal',
                'message': dfeDB.results[0].context.productName + ' has been updated (v' + dfeDB.results[0].context.app_version + ').\nPlease reload the UI.'
              };
            } else {
              api_async.portal.version(function () {
                setTimeout(_outdated, 30000);
              }, function (pError) {
                throw {
                  'severity': 'fatal',
                  'message': "Cannot reach the server. " + dfeDB.results[0].context.productName + " seems down."
                };
              });

              // TODO - Handle changes not from our fact.
              // throw {'severity': 'fatal', 'message': dfeDB.results[0].context.productName+"'s setting has been changed."};
            }
          } else {
            setTimeout(_outdated, 30000);
          }
        }
      }, function (pError) {
        if (pError.error_code == 'no_permission') {
          // Is the session still valid???
        }
        console.error(pError);
      });
    };
    setTimeout(_outdated, 60000);
  };
  nixps.dfe.Engineer.prototype = {
    constructor: nixps.dfe.Engineer,
    get: function get(keyPath, defaultValue) {
      if (keyPath === undefined) {
        return this;
      }
      return this.getSetting(keyPath, defaultValue);
    },
    _getDefaultSetting: function _getDefaultSetting(keyPath) {
      var arrKey = keyPath.split('.');
      var dst = _defaultDFESettings;
      for (var i = 0; i < arrKey.length - 1; i++) {
        if (dst[arrKey[i]] === undefined) {
          return null;
        }
        dst = dst[arrKey[i]];
      }
      i = arrKey.length - 1;
      if (dst[arrKey[i]] !== undefined) return dst[arrKey[i]];
      return undefined;
    },
    /**
     * @brief returns the setting value(s) linked to the keyPath
     * @function
     * @name engineer.getSetting
     * @param {String} keyPath key path of a setting. i.e 'output.filetype' or 'output'
     * @param {any} defaultValue
     * @returns {any} value of the setting or null if no setting linked to the keyPath
     */
    getSetting: function getSetting(keyPath, defaultValue) {
      if (keyPath === undefined || keyPath.length === 0) return this._settings;
      var arrKey = keyPath.split('.');
      var dst = this._settings;
      var retValue = defaultValue !== undefined ? defaultValue : null;
      for (var i = 0; i < arrKey.length - 1; i++) {
        if (dst[arrKey[i]] === undefined) {
          return retValue;
        }
        dst = dst[arrKey[i]];
      }
      i = arrKey.length - 1;
      if (dst[arrKey[i]] !== undefined) return dst[arrKey[i]];
      if (retValue !== null) return retValue;
      return this._getDefaultSetting(keyPath);
    },
    /**
     * @brief Set the setting value(s) linked to the keyPath
     * @function
     * @name engineer.setSetting
     * @param {String|Object} keyPath key path of a setting. i.e 'output.filetype' or 'output'
     * @param {any} value
     * @returns {Deferred|Object} value of the setting or the default value if the given value is not supported or null if no setting linked to the keyPath
     */
    setSetting: function setSetting(keyPath, value) {
      if (typeof keyPath === 'string') {
        var settings = {};
        settings[keyPath] = value;
        keyPath = settings;
      }
      var dfeDB = api.custom_objects.get('fundamentals', this._settings._id);
      if (dfeDB.error !== undefined) {
        var dfeDB = api.custom_objects.list('fundamentals', ['type', 'equal to', 'Engineer', 'and', 'context.app', 'equal to', this._settings.context.app]).results;
        if (Array.isArray(dfeDB) && dfeDB.length > 0) dfeDB = this._settings = dfeDB[0]; // Take the first one. // TODO. To improve. Might introduce incoherences
        else {
          throw {
            'severity': 'fatal',
            'message': dfeDB.error
          };
        }
      }
      // if ( dfeDB.save_id !== this._settings.save_id )
      // 	throw {'severity': 'fatal', 'message': dfeDB[0].context.productName+"'s setting has been changed.\"};

      var that = this;
      var toSave = [];
      Object.keys(keyPath).forEach(function (key) {
        if (keyPath.hasOwnProperty(key)) {
          var ret = that._setSetting(key, keyPath[key]);
          if (ret.error !== undefined) console.log(ret.error);else if (ret.keys !== undefined) toSave.push(ret);
        }
      });
      if (toSave.length > 0) return this._saveSettings(toSave);else return $.Deferred(function (pDefer) {
        pDefer.resolve({});
      });
    },
    _setSetting: function _setSetting(keyPath, value) {
      var arrKey = keyPath.split('.');
      var dst = this._settings;
      for (var i = 0; i < arrKey.length - 1; i++) {
        if (dst[arrKey[i]] === undefined) break; //return null;
        dst = dst[arrKey[i]];
      }
      i = arrKey.length - 1;
      if (dst[arrKey[i]] !== undefined) {
        if (_engineerAllowedValues.hasOwnProperty(keyPath)) {
          var allowedValues = _engineerAllowedValues[keyPath];
          if (allowedValues instanceof Array) {
            if (allowedValues.indexOf(value) === -1) return {
              keyPath: allowedValues[0]
            }; // Invalid Value. Returns the default allowed one.
          }
        }

        dst[arrKey[i]] = value; // Set the value in the current instance of Engineer.
        return {
          'keys': arrKey,
          'value': value
        };
      } else return {
        'error': 'Key not defined. Creation of new key is not allowed.'
      };
    },
    _saveSettings: function _saveSettings(settings) {
      var that = this;
      if (this.cfContext !== undefined) {
        this.cfContext.setConnector('whitepaper');
        this.cfContext.setCollection(this._settings.context.core);
        this.cfContext.setKey({
          'inputname': 'Set_Engineer',
          'variables': {
            'context': {
              'app': this._settings.context.app,
              'core': this._settings.context.core
            },
            'keyPath': settings,
            'value': null,
            createIfMissing: true
          }
        });
        this.cfContext.setUseCache(false);
        return $.Deferred(function (pDefer) {
          Promise.resolve(that.cfContext.loadData({
            relativeBasePath: "cloudflow://PP_FILE_STORE/" + that._settings.context.app + "/"
          })).then(function (reply) {
            // More Secure. Do "Set Engineer" in a 'singleton script node'. To avoid concurrent access.
            if (reply.result !== undefined && reply.result.save_id !== undefined) {
              that._settings.save_id = reply.result.save_id;
              pDefer.resolve(settings);
            } else {
              console.error(reply);
              that._fallbackSetSetting(settings, pDefer);
            }
          }, function (pError) {
            // console.error(pError);
            that._fallbackSetSetting(settings, pDefer);
          })["finally"](function () {
            delete _engineerInstances[that._settings.context.app];
          });
        });
      } else {
        return $.Deferred(function (pDefer) {
          that._fallbackSetSetting(settings, pDefer);
        });
      }
    },
    /**
     * @description Fallback if the cfContext is not defined or if the workflow failed.
     * @param arrKey
     * @param value
     * @param pDefer
     * @private
     */
    _fallbackSetSetting: function _fallbackSetSetting(settingsToSave, pDefer) {
      var that = this;
      api_defer.file.create_folder("cloudflow://PP_FILE_STORE/" + that._settings.context.app + '/', "Resources").then(function (ok) {
        var customURL = "cloudflow://PP_FILE_STORE/" + that._settings.context.app + "/Resources/FundamentalsCustom.json";
        var json = {
          data: {}
        };
        api_defer.file.does_exist(customURL).then(function (stat) {
          if (stat.exist) {
            json = api.file.json.read(customURL);
            if (json.data === undefined) {
              json = {
                data: {}
              };
            }
          } else {
            json = {
              data: {}
            };
          }
        });
        settingsToSave.forEach(function (toSave) {
          var data = json.data;
          var arrKey = toSave.keys;
          for (var j = 0; j < arrKey.length - 1; j++) {
            if (data[arrKey[j]] === undefined) {
              data[arrKey[j]] = {};
            }
            data = data[arrKey[j]];
          }
          data[arrKey[j]] = toSave.value;
        });
        api_defer.file.json.write(json.data, customURL, {
          'overwrite': true
        });
        that._settings.save_id = that.uuid();
        api_defer.custom_objects.set_keys('fundamentals', that._settings._id, settingsToSave).then(function (id) {
          pDefer.resolve(settingsToSave);
        }).fail(function (failed) {
          pDefer.reject(failed);
        });
      }).fail(function (failed) {
        pDefer.reject(failed);
      });
    },
    getBehavior: function getBehavior(behaviorPath, defaultBehavior) {
      return this.get('appOptions.behavior.' + behaviorPath, defaultBehavior);
    },
    getCFAppName: function getCFAppName() {
      if (this._settings.context.app !== undefined) return this._settings.context.app;
      var name = this._settings['appName'];
      var ret = 'Fundamentals';
      if (/FUNDEV1/.test(name)) ret = 'dfe' + '_' + 'fdmx';
      if (/FUNDEV2/.test(name)) {
        ret = 'Digital';
        if (/F.+2o/.test(name)) ret += 'One';else if (/F.+2m/.test(name)) ret += 'Screen';else if (/F.+2s/.test(name)) ret += 'Series';
      }
      return ret;
    },
    /**
     *
     * @returns {Array} of screens. {name: ..., value: ...}
     */
    getScreenings: function getScreenings() {
      return this._settings.screens;
    },
    getScreeningName: function getScreeningName(screen) {
      if (this.screensDefinition[screen] !== undefined) return this.screensDefinition[screen].name;
      return undefined;
    },
    getVerticalResolutions: function getVerticalResolutions() {
      var ret = [];
      this._settings.resolutions.forEach(function (entry) {
        ret.push({
          'value': entry.value,
          'name': entry.name
        });
      });
      return ret;
    },
    getHorizontalResolutions: function getHorizontalResolutions(vertRes) {
      if (vertRes === undefined) {
        throw "Unexpected vertical resolution";
        // console.error('Shit');
      }

      var ret = [];
      this._settings.resolutions.forEach(function (entry) {
        if (vertRes.value === entry.value) ret = entry.horizontal;
      });
      return ret;
    },
    getResolutionByName: function getResolutionByName(resolutionName) {
      var ret = undefined;
      this._settings.resolutions.forEach(function (item) {
        if (ret !== undefined) {
          return;
        }
        if (item.hasOwnProperty('name') && resolutionName === item.name) {
          ret = item;
        } else if (item.hasOwnProperty('horizontal')) {
          item.horizontal.forEach(function (nsq) {
            if (ret !== undefined) {
              return;
            }
            if (nsq.hasOwnProperty('name') && resolutionName === nsq.name) {
              ret = nsq;
            }
          });
        }
      });
      return ret;
    },
    getResolutionName: function getResolutionName(resolution) {
      var ret = undefined;
      this._settings.resolutions.forEach(function (item) {
        if (ret !== undefined) {
          return;
        }
        if (resolution === item.value) {
          ret = item;
        } else if (item.hasOwnProperty('horizontal')) {
          item.horizontal.forEach(function (nsq) {
            if (ret !== undefined) {
              return;
            }
            if (resolution === nsq.value) {
              ret = nsq;
            }
          });
        }
      });
      if (ret !== undefined && ret.hasOwnProperty('name')) return ret.name;
      return ret;
    },
    getDefaultInks: function getDefaultInks(lowercase) {
      var lower = typeof lowercase === "boolean" ? lowercase : false; //true;
      var cs = this._settings.separations.inkspace;
      var inks = [];
      for (var i = 0, len = cs.length; i < len; i++) {
        //var ink = $.extend(true, {}, this.getInkPerLetter( cs[i] ));
        //var ink = Object.assign({}, this.getInkPerLetter( cs[i] )); // Make a copy
        var ink = this._merge(this.getInkPerLetter(cs[i]), {}, true);
        if (ink !== null /*&& ink !== {} */) {
          ink.print = true;
          ink.letter = cs[i];
          ink.dotshape = 'Round';
          ink.name = lower ? ink.name.toLowerCase() : this.normalizeColorName(ink.name, true);
          ink.ruling = this._settings.output.ruling;
          inks.push(ink);
        }
      }
      return inks;
    },
    getDefaultInksNames: function getDefaultInksNames(lowercase) {
      var inks = this.getDefaultInks(lowercase);
      return inks.map(function (ink) {
        return ink.name;
      });
    },
    getInkPerLetter: function getInkPerLetter(letter) {
      var ret = null;
      var inks = this._settings.separations.inks || [];
      inks.some(function (ink) {
        var inkLetter = ink.letter || '';
        if (inkLetter === letter) {
          ret = JSON.parse(JSON.stringify(ink));
          return true;
        }
      });
      return ret;
    },
    getInkPerName: function getInkPerName(inkname) {
      var myself = this;
      var ret = undefined;
      var name = inkname;
      var inks = this._settings.separations.inks || [];
      inks.some(function (ink) {
        if (name === ink.name || ink.name === myself.normalizeColorName(name)) {
          ret = JSON.parse(JSON.stringify(ink));
          ret.name = name;
          return true;
        }
      });
      return ret;
    },
    getInkLetter: function getInkLetter(inkname) {
      var ret = this.getInkPerName(inkname);
      if (ret !== undefined) return ret.letter;
      return "";
    },
    normalizeColorName: function normalizeColorName(pName, cmykOnly) {
      var all = cmykOnly === undefined ? true : cmykOnly !== true;
      var cmykColors = ' cyan magenta yellow black ';
      if (all || cmykColors.indexOf(' ' + pName.toLowerCase() + ' ') > -1) return pName.charAt(0).toUpperCase() + pName.slice(1);
      return pName;
    },
    getPrintbarIds: function getPrintbarIds(printbar, rasterDesc) {
      if (typeof printbar === 'string') printbar = this.getPrintbarEntry(printbar);
      var ids = rasterDesc ? ": " : "On Printbar ";
      var nbPB = printbar.PB.length;
      for (var pbi = 0; pbi < nbPB; pbi++) ids += (rasterDesc ? "PB#" : "#") + printbar.PB[pbi] + (pbi < nbPB - 1 ? rasterDesc ? "," : ", " : "");
      return ids;
    },
    getInkColorantName: function getInkColorantName(printbar) {
      if (typeof printbar === 'string') printbar = this.getPrintbarEntry(printbar);
      var colorant = printbar.name + this.getPrintbarIds(printbar, true);
      return colorant;
    },
    getPrintbarEntry: function getPrintbarEntry(printbarName) {
      var find = this._settings.separations.printbar.find(function (item, index) {
        if (typeof item === "string" && item === printbarName) {
          return {
            "name": printbarName,
            "PB": [index]
          };
        } else if (item.name === printbarName || item.name.toLowerCase() === printbarName.toLowerCase()) {
          if (item.PB === undefined) item.PB = [index];
          return item;
        }
      });
      if (find !== undefined) return find;
      return {
        "name": printbarName,
        "PB": [-1]
      }; // PB < 0 means "unused"
    },

    // getPrintbarNumber: function( inkName ) {
    // 	var pbEntry = this.getPrintbarEntry(inkName);
    // 	return
    // 	var index = this._settings.separations.printbar.indexOf( inkName );
    // 	if ( index < 0 ) {
    // 		inkName = this.normalizeColorName(inkName);
    // 		index = this._settings.separations.printbar.indexOf( x => x.name === inkName );
    // 	}
    // 	return index;
    // },

    /**
     * @brief returns if separationName matches one of the export's regexp
     **/
    isSeparationToExport: function isSeparationToExport(separationName) {
      if (this._settings.appOptions.behavior["export"].nonDigital) {
        var sepName = separationName.toLowerCase();
        var itIs = this._settings.separations.toFlexo.some(function (pattern) {
          var re = new RegExp(pattern.toLowerCase());
          return re.test(sepName);
        }, null);
        if (!itIs) {
          itIs = this._settings.separations.toFinish.some(function (pattern, idx) {
            var re = new RegExp(pattern.toLowerCase());
            return re.test(sepName);
          }, null);
        }
        return itIs;
      }
      return false;
    },
    initializeInksActions: function initializeInksActions(inks) {
      var myself = this;
      var eng = this._settings;
      var colors = myself.getDefaultInksNames();
      var mapp = colors.slice();
      var nbPrint = 0;
      if (Array.isArray(inks)) {
        inks.forEach(function (ink) {
          var sepname = ink.name;
          var exists = colors.indexOf(sepname) >= 0;
          if (!exists) {
            sepname = myself.normalizeColorName(sepname);
            exists = colors.indexOf(sepname) >= 0;
          }
          if (exists) {
            ink.print = true;
            nbPrint++;
            ink["export"] = false;
            ink.convert = false;
            ink.digital = true;
            mapp.some(function (m, index) {
              if (m === sepname) {
                mapp.splice(index, 1);
                return true;
              }
              return false;
            });
          } else if (sepname !== '<spot>') {
            ink.print = false;
            ink.convert = false;
            ink["export"] = myself.isSeparationToExport(ink.name);
          }
        });
        if (nbPrint < colors.length) {
          inks.some(function (ink) {
            if (ink.print === false && ink["export"] === false) {
              ink.print = true;
              nbPrint++;
              if (eng.appOptions.behavior.print.mapSpot && mapp.length > 0) {
                ink.mapped = mapp.splice(0, 1)[0];
                ink.printbar = colors.length - mapp.length;
                ink.angle = myself.getAngleForInk(ink.mapped);
              } else if (eng.appOptions.behavior.print.convertSpot) {
                ink.convert = true;
              } else ink.print = false;
            }
            return !(nbPrint < colors.length);
          });
        }
      }
      return inks;
    },
    getAngleForInk: function getAngleForInk(inkname) {
      var myself = this;
      var ret = undefined;
      var inks = this._settings.separations.inks || [];
      var name = inkname;
      inks.some(function (ink) {
        if ((ink.name === name || ink.name === myself.normalizeColorName(name)) && ink.angle !== undefined) {
          ret = ink.angle;
          return true;
        }
      });
      return ret;
    },
    isConvertApplicable: function isConvertApplicable(media) {
      var convertSpot = this._settings.appOptions.behavior.print.convertSpot;
      if (convertSpot) {
        var outputCS = "CMYK";
        if (media !== undefined) outputCS = this.getMediaOutputProfile(media);

        // Convertion can be performed only if outputCS is a subset of the inkspace (and inkspace is higher than 1 ?!!)
        var defined = "";
        if (this._datas.inkspace.length > 1 && this._datas.inkspace.length >= this._datas.outputCS.length) {
          convertSpot = this.isColorSpaceEqualToPrintbarDefinition(outputCS);
        } else convertSpot = defined === outputCS;
      }
      return convertSpot;
    },
    getAnglesAndRuling: function getAnglesAndRuling(cs) {
      var div = this.getAngles(cs);
      var ruling = this.getRuling(cs);
      ruling.find('label').text($.i18n._('nixps-RIPEditor-separations.color_ruling'));
      div.append($('<span>').css('flex-grow', '2')).append(ruling.find('span').first());
      return div;
    },
    getAngles: function getAngles(cs) {
      var ispace = cs || this.getSetting('separations.inkspace');
      var style = {
        'text-align': 'right',
        'margin-left': '3px',
        'margin-right': '10px',
        'padding-right': '3px',
        'border': 'solid 1px gray',
        'width': '3em',
        'display': 'inline-block',
        'background-color': 'transparent'
      };
      var div = $('<div name="Angles">').addClass('hLayout').css({
        'align-items': 'baseline',
        'flex-wrap': 'wrap'
      });
      for (var i = 0, len = ispace.length; i < len; i++) {
        var ink = this.getInkPerLetter(ispace[i]);
        if (ink !== null) {
          var color = ink.rgb || ink.name.toLowerCase();
          if (color === 'cyan light') {
            color = 'rgb(180,255,255)';
          } else if (color === 'magenta light') {
            color = 'rgb(255,180,255)';
          }
          style['border-color'] = color;
          div.append($('<span>').append($('<label>').text(ink.letter)).append($('<input>').attr('disabled', 'disabled').attr('size', '3').css(style).val(ink.angle + '°')));
        }
      }
      return div;
    },
    getRuling: function getRuling() {
      var style = {
        'text-align': 'right',
        'margin-left': '3px',
        'margin-top': '1px',
        'margin-right': '1px',
        'padding-right': '3px',
        'border': 'solid 1px gray',
        'width': '6em',
        'display': 'inline-block',
        'background-color': 'transparent'
      };
      var div = $('<div name="Ruling">').addClass('hLayout').css({
        'align-items': 'baseline',
        'flex-wrap': 'wrap'
      });
      var lpi = this._settings.appOptions.unitPrefs.ruling.unit;
      var ruling = this.getSetting('output.ruling');
      if (lpi !== 'lpi') ruling = Math.round(ruling / 25.4);
      div.append($('<span>').append($('<label>').text('R')).append($('<input>').attr('disabled', 'disabled').attr('size', '6').css(style).val(ruling + ' ' + lpi)));
      return div;
    },
    isScreenProUsable: function isScreenProUsable() {
      var usable = this.getSetting('appOptions.behavior.SPDirect');
      //var usable = this.getSetting('appOptions.behavior.screening.perform');
      // usable = usable && /Windows*/.test(getOS());

      return usable;
    },
    getScreenProScreenings: function getScreenProScreenings() {
      if (this._settings.SPDirect !== undefined) return this._settings.SPDirect.screens;
      return [];
    },
    getScreenProOptions: function getScreenProOptions(screen) {
      var setting = this.getSetting('SPDirect.screens.' + screen, {});
      if (setting.hasOwnProperty('options')) {
        return setting.options.join(' ');
      }
      return '';
    },
    getDefaultOutputFolder: function getDefaultOutputFolder(type) {
      // var type === 'toExport' ? type : 'toPrint';

      var folders = this._settings.outputFolder[type];
      if (Array.isArray(folders) && folders.length > 0) return folders[0];else if (typeof folders === 'string') return folders;
      return "";
    },
    getMediaOutputProfile: function getMediaOutputProfile(mediaName) {
      var mediaFilter = ['type', 'equal to', 'Media', 'and', 'app', 'equal to', this._settings.context.app, 'and', 'name', 'equal to', mediaName];
      var media = api.custom_objects.list_with_options('fundamentals', mediaFilter, [], ['name', 'color_profile']);
      if (Array.isArray(media.results) && media.results.length > 0) {
        var media = media.results[0];
        if (media.color_profile !== undefined && media.color_profile.length > 0) {
          // TODO #colorprofiles is not available. Following lines to be replaced by function
          // var cpui = $('#colorprofiles');
          // var rsrc = cpui.ICCProfiles('getResource', media.color_profile );
          // var cs = cpui.ICCProfiles('getOutputColorSpace', rsrc);
          // if ( cs !== undefined )
          // 	return cs;
          var meta = api.metadata.get_from_asset(media.color_profile);
          if (meta.color_profile !== undefined && meta.color_profile.output_cs !== undefined) {
            var letters = "";
            var open = "ABDEFHIJLNPQRSTUXZ"; //, reserved = "CMYKOGVWcmyk";
            meta.color_profile.output_cs.colorants.forEach(function (colorant) {
              var letter = '';
              switch (colorant.name.toLowerCase()) {
                case 'cyan':
                  letter = 'C';
                  break;
                case 'magenta':
                  letter = 'M';
                  break;
                case 'yellow':
                  letter = 'Y';
                  break;
                case 'black':
                case 'gray':
                  letter = 'K';
                  break;
                default:
                  {
                    letter = colorant.name[0].toUpperCase();
                    for (var i = 0; letters.indexOf(letter) !== -1 && i < open.length;) {
                      if (letter !== letter.toLowerCase()) letter = letter.toLowerCase();else {
                        letter = open[i];
                        i++;
                      }
                    }
                  }
              }
              letters += letter;
            });
            if (letters.length > 0) return letters;
          }
          // TODO End of the lines to set in a function.
        }
      }

      return "CMYK";
    },
    isColorSpaceEqualToPrintbarDefinition: function isColorSpaceEqualToPrintbarDefinition(colorspace) {
      if (colorspace === undefined) return true;
      var inkspace = this.get('separations.inkspace');
      var convertible = colorspace.length > 0;
      for (var i = 0; i < colorspace.length && convertible; i++) {
        var letter = colorspace[i];
        if (inkspace.indexOf(letter) < 0) convertible = false;
      }
      return convertible;
    },
    hasCMYK: function hasCMYK(space, fully) {
      var nb = 0;
      ['C', 'M', 'Y', 'K'].forEach(function (letter) {
        nb += space.indexOf(letter) >= 0 ? 1 : 0;
      });
      return fully ? nb === 4 : nb !== 0;
    },
    /* @brief: Merge Engineering settings into RIP settings  */
    _merge: function _merge(from, into, recursive) {
      if (from !== undefined && into !== undefined) {
        for (var prop in from)
        // Merge from properties
        {
          if (into[prop] === undefined) {
            // Overload avoided
            into[prop] = from[prop];
          } else if (recursive) {
            if (_typeof(from[prop]) === 'object' && !Array.isArray(from[prop])) {
              if (_typeof(into[prop]) === 'object' && !Array.isArray(into[prop])) {
                this._merge(from[prop], into[prop], recursive);
              }
            }
          }
        }
      }
      return from;
    },
    uuid: function uuid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
    /** List of screens **/
    screensDefinition: {
      'CosineDot': {
        name: 'Cosine Dot'
      },
      'Cross': {
        name: 'Cross'
      },
      'Diamond': {
        name: 'Diamond'
      },
      'Double': {
        name: 'Double'
      },
      'DoubleDot': {
        name: 'Double Dot'
      },
      'Ellipse': {
        name: 'Ellipse'
      },
      'EllipseA': {
        name: 'Ellipse A'
      },
      'EllipseB': {
        name: 'Ellipse B'
      },
      'EllipseB2': {
        name: 'Ellipse B2'
      },
      'Elliptical1': {
        name: 'Elliptical 1'
      },
      'Elliptical2': {
        name: 'Elliptical 2'
      },
      'EllipticalP': {
        name: 'Elliptical P'
      },
      'EllipticalQ1': {
        name: 'Elliptical Q1'
      },
      'EllipticalQ2': {
        name: 'Elliptical Q2'
      },
      'Euclidian': {
        name: 'Euclidean'
      },
      'InvertedDouble': {
        name: 'Inverted Double'
      },
      'InvertedDoubleDot': {
        name: 'Inverted Double Dot'
      },
      'InvertedEllipseA': {
        name: 'Inverted Ellipse A'
      },
      'InvertedEllipseB': {
        name: 'Inverted Ellipse B'
      },
      'InvertedEllipseB2': {
        name: 'Inverted Ellipse B2'
      },
      'InvertedSimpleDot': {
        name: 'Inverted Round'
      },
      'LineAdobe': {
        name: 'Line'
      },
      'Line90': {
        name: 'Line 90'
      },
      'LineX': {
        name: 'Line X'
      },
      'LineY': {
        name: 'Line Y'
      },
      'RhomboidAdobe': {
        name: 'Rhomboid'
      },
      'Round': {
        name: 'Round'
      },
      'Square': {
        name: 'Square'
      },
      'Square1': {
        name: 'Square 1'
      },
      'Square2': {
        name: 'Square 2'
      },
      //'HCS': {name:'HCS'},
      'Mirror': {
        name: 'AIS Mirror'
      },
      'Pearl': {
        name: 'AIS Pearl'
      },
      'HDS-A': {
        name: 'HDS Super Fine (FM)'
      },
      'HDS-B': {
        name: 'HDS Fine (FM)'
      },
      'HDS-C': {
        name: 'HDS Medium (FM)'
      },
      'HDS-D': {
        name: 'HDS Coarse (FM)'
      },
      'HDS-E': {
        name: 'HDS Super Coarse (FM)'
      }
      // 'HXM': {name:'HXM (Flexo Hybrid)'},
      // 'HXM_Round': {name:'HXM (Offset Round)'},
      // 'HXM_Trad': {name:'HXM (Offset Traditional)'}
    }
  };

  function getOS() {
    var clientStrings = [{
      s: 'Windows 10',
      r: /(Windows 10.0|Windows NT 10.0)/
    }, {
      s: 'Windows 8.1',
      r: /(Windows 8.1|Windows NT 6.3)/
    }, {
      s: 'Windows 8',
      r: /(Windows 8|Windows NT 6.2)/
    }, {
      s: 'Windows 7',
      r: /(Windows 7|Windows NT 6.1)/
    }
    // {s:'Windows Vista', r:/Windows NT 6.0/},
    // {s:'Windows Server 2003', r:/Windows NT 5.2/},
    // {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
    // {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
    // {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
    // {s:'Windows 98', r:/(Windows 98|Win98)/},
    // {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
    // {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
    // {s:'Windows CE', r:/Windows CE/},
    // {s:'Windows 3.11', r:/Win16/},
    // {s:'Android', r:/Android/},
    // {s:'Open BSD', r:/OpenBSD/},
    // {s:'Sun OS', r:/SunOS/},
    // {s:'Linux', r:/(Linux|X11)/},
    // {s:'iOS', r:/(iPhone|iPad|iPod)/},
    // {s:'Mac OS X', r:/Mac OS X/},
    // {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
    // {s:'QNX', r:/QNX/},
    // {s:'UNIX', r:/UNIX/},
    // {s:'BeOS', r:/BeOS/},
    // {s:'OS/2', r:/OS\/2/},
    // {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];

    for (var id in clientStrings) {
      if (clientStrings.hasOwnProperty(id)) {
        var cs = clientStrings[id];
        if (cs.r.test(navigator.userAgent)) {
          return cs.s;
        }
      }
    }
    return undefined;
  }
})(jQuery);

},{"../../../common/js/namespace.js":389,"../../../pagebuilder/js/Context.js":413}],100:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */
var redirectToLogin = require('../../CloudflowInit/js/redirectToLogin.js');
(function ($) {
  /**
      * @namespace nixps-dfe.MediaSelector
      * @description Show a panel with a select element
      */
  $.widget("nixps-dfe.MediaSelector", $.Widget, {
    widgetEventPrefix: "mediaselector",
    options: {
      /**
       * @description DFE context. IT IS MANDATORY
       * @type {object}
       * @default undefined
       */
      dfe_context: undefined,
      /**
       * @description value to show on start, put here the key that must be selected on start.
       * @name nixps-dfe.MediaSelector#default
       * @type object
       * @default null
       */
      "default": null,
      value: "",
      readOnly: false
    },
    _names: [],
    _tempOption: undefined,
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._populateMedia();
    },
    _populateMedia: function _populateMedia() {
      var that = this;
      this._getMedias().then(function (pMedias) {
        var select = that.element; // .find('.media_profile');
        select.empty();
        that._names = [];
        that._tempOption = undefined;
        pMedias.forEach(function (media) {
          var option = $('<option>').val(media.name).prop('mediaID', media._id).text(media.name);
          that._names.push(media.name);
          if (media.name === 'Default') {
            select.prepend(option);
          } else {
            select.append(option);
          }
        });
        if (that._names.indexOf(that.options.value) !== -1) {
          select.removeClass('invalid_value');
        } else {
          that._tempOption = $('<option>').val(that.options.value) /*.prop('mediaID', media._id)*/.text('( ' + that.options.value + ' )');
          select.append(that._tempOption);
          select.addClass('invalid_value');
        }
        select.val(that.options.value);
      }, function (pError) {
        // console.error(pError);
        that.element.find('.media_profile').hide();
        $('<label>').addClass('cf-form-label control-label col-sm-10 cf-col-sm-10 media_error').text($.i18n._('No media is defined. ')).appendTo(that.element);
      });
    },
    _getMedias: function _getMedias() {
      if (this.options.dfe_context === undefined || this.options.dfe_context.app === undefined) {
        return []; // do nothing if dfe_context is not defined
      }

      var that = this;
      var mediaFilter = ['type', 'equal to', 'Media', 'and', 'app', 'equal to', this.options.dfe_context.app];
      return $.Deferred(function (pDefer) {
        api_async.custom_objects.list_with_options('fundamentals', mediaFilter, ['name', 'ascending'], [], {}, function (pResult) {
          if (pResult.results.length === 0) {
            // The Default Media has to be created.
            that.Engineer = nixps.dfe.getEngineerInstance(that.options.dfe_context);
            var defaultMedia = that.Engineer.get('defaultMedia', undefined);
            if (defaultMedia !== undefined) {
              defaultMedia.app = that.options.dfe_context;
              defaultMedia.type = "Media";
              api.custom_objects.create('fundamentals', defaultMedia.dfe);
              pResult.results = [defaultMedia];
            }
          }
          if (pResult.results.length > 0) {
            pDefer.resolve(pResult.results);
          } else {
            pDefer.reject("No Media is defined.");
          }
        }, function (pError) {
          if (pError !== undefined && pError.error_code === "no_permission") {
            // if user has no permission, or no permission anymore
            redirectToLogin(false);
          }
          pDefer.reject(pError);
        });
      });
    },
    setValue: function setValue(pValue) {
      this.options.value = pValue;
      if (pValue === undefined) {
        return;
      }
      if (pValue === null) {
        pValue = "Default";
      }
      if (this._tempOption !== undefined) {
        //this.element.remove(this._tempOption);
        this._tempOption.remove();
        this._tempOption = undefined;
      }
      if (this._names.indexOf(pValue) !== -1) {
        this.element.removeClass('invalid_value');
      } else {
        this._tempOption = $('<option>').val(pValue) /*.prop('mediaID', media._id)*/.text('( ' + pValue + ' )');
        this.element.append(this._tempOption);
        this.element.addClass('invalid_value');
      }
      this.element.val(pValue);
    },
    getValue: function getValue() {
      return this.element.val();
    },
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._populateMedia();
    },
    refreshCache: function refreshCache() {
      this._populateMedia();
      // var that = this;
      // return $.when(load(this.options.resource_type, true)).done(function(pResourceLocators){
      //     that._populateSelect(pResourceLocators);
      // });
    }
  });
})(jQuery);

},{"../../CloudflowInit/js/redirectToLogin.js":69}],101:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

(function ($) {
  require('./nixps-dfe-Engineer.js');

  /**
   * @desc translate the color names to names that begins with a uppercase letter
   * @function
   * @private
   * @static
   * @param {string} pInkt
   * @returns {String}
   */

  function translateSeparationNames(pInkt, digitalOnly, digitalColors) {
    var all = digitalOnly === undefined ? true : digitalOnly !== true;
    var inkIndex = -1;
    if (!all) {
      var lowernames = [];
      if (digitalColors === undefined) {
        digitalColors = ['Cyan', 'Magenta', 'Yellow', 'Black'];
        lowernames = ['cyan', 'magenta', 'yellow', 'black'];
      } else {
        ['Cyan', 'Magenta', 'Yellow', 'Black'].forEach(function (cmyk) {
          digitalColors.splice(0, 0, cmyk); // Ensure that the CMYK inks are defined.
        });

        digitalColors.forEach(function (n, i) {
          lowernames.push(n.toLowerCase());
        });
      }
      inkIndex = $.inArray(pInkt.toLowerCase(), lowernames);
      if (inkIndex >= 0) {
        return digitalColors[inkIndex];
      }
    } else {
      return pInkt.charAt(0).toUpperCase() + pInkt.slice(1);
    }
    return pInkt;
  }
  function uniformNames(name, digitalOnly, digitalColors) {
    return translateSeparationNames(name, digitalOnly, digitalColors.slice());
  }
  $.widget("nixps.DFESeparationList", {
    widgetEventPrefix: "dfeseparationlist",
    options: {
      /**
       * The settings blob with the RIP parameters
       */
      settings: undefined,
      summarize: true,
      /**
       * @description DFE context. IT IS MANDATORY
       * @type {object}
       * @default undefined
       */
      dfe_context: undefined,
      /**
       * @bief Is the Editor used in 'Submission' mode (false) or in 'Preset Edition' mode.
       * @type {Boolean}
       * @default false
       */
      standaloneView: false,
      readOnly: false
    },
    _datas: {},
    /**
     * @brief creates the editor component
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName).addClass('nixps-RIPEditorSeparations');
      if (this.options.dfe_context === undefined || this.options.dfe_context.app === undefined) {
        this.element.append($("<label >").text('DFESeparationList: Fundamentals context is unspecified.'));
        return;
      }
      this.Engineer = nixps.dfe.getEngineerInstance(this.options.dfe_context);
      if (this.options.settings === undefined) {
        this.options.settings = {
          'separations': {
            'inks': []
          }
        };
      } else if (this.options.settings.separations === undefined) {
        this.options.settings.separations = {
          'inks': []
        };
      } else if (this.options.settings.separations.inks === undefined) {
        this.options.settings.separations.inks = [];
      }
      this._updateDatas();
      this._initUI();
      this._refresh();
      this._saveSettings();
      this._installHandlers();
    },
    _installHandlers: function _installHandlers() {
      this._on(this.element, {
        'change .col-print input': this._onPrintHandler,
        'change .col-export input': this._onExportHandler,
        "change .col-convertSpot select": this._onOptionHandler,
        "click .delete-spot": this._deleteSpotHandler,
        'change input[name="separations.ConvertDeviceGray"]': this._onConvertGray,
        "change select": this._changeHandler,
        "change input": this._changeHandler,
        "click button": this._NCEHandler
      });
    },
    _onPrintHandler: function _onPrintHandler(pEvent) {
      var print = $(pEvent.target).is(':checked');
      if (print) {
        // If 'Print' is checked then 'Export' should be unchecked
        var name = pEvent.target.name.replace(/print/, 'export');
        this.element.find('input[name="' + name + '"]').prop('checked', false);
        $(pEvent.target).prop('change_ts', Date.now());
      }
      var ink = this._datas.inks[$(pEvent.target).attr('rowindex')];
      if (ink !== undefined) {
        ink.print = print;
        this._consolidateInkStates(ink);
      } else if (pEvent.target.name === 'separations-printAll') {
        var that = this;
        this._datas.inks.forEach(function (ink) {
          ink.print = print;
          that._consolidateInkStates(ink);
        });
      }
    },
    _deleteSpotHandler: function _deleteSpotHandler(pEvent) {
      var rowindex = $(pEvent.target).attr('rowindex');
      this._datas.inks[rowindex].realIndex = this._datas.inks[rowindex].realIndex - this.options.settings.separations.inks.length;
      this._changeHandler();
    },
    _consolidateInkStates: function _consolidateInkStates(ink) {
      var that = this;
      if (ink.digital) {
        if (ink.print) {
          this._checkToPrint(ink);
          this._setMapping(ink, ink.name);
        }
      } else {
        if (ink.print) {
          if (this._hasMappable() /*|| !this._isInkLocked() */) {
            // Mapping FIRST !!!
            this._checkToPrint(ink);
            var found = this._nextMappable();
            if (found !== undefined) {
              this._setMapping(ink, found.inkname);
            } else if (this._datas.convertSpot) {
              this._setConverted(ink, true);
            } else if (!this.options.settings.separations.ConvertDeviceGray) {
              ink.print = false;
              this._consolidateInkStates(ink);
            }
          } else {
            if (this._datas.convertSpot) {
              this._setConverted(ink, true);
            } else {
              this._checkToPrint(ink);
              var found = this._nextMappable();
              if (found !== undefined) {
                this._setMapping(ink, found.inkname);
              } else if (!this.options.settings.separations.ConvertDeviceGray) {
                ink.print = false;
                this._consolidateInkStates(ink);
              }
            }
          }
        } else {
          if (ink.convert) {
            this._setConverted(ink, false, null);
          } else if (ink.mapped !== undefined) {
            this._unmapSpotName(ink.name);
          }
        }
      }
    },
    _onExportHandler: function _onExportHandler(pEvent) {
      var exported = $(pEvent.target).is(':checked');
      if (exported) {
        // If 'Export' is checked then 'Print' should be unchecked
        var name = pEvent.target.name.replace(/export/, 'print');
        this.element.find('input[name="' + name + '"]').prop('checked', false);
      }
      var ink = this._datas.inks[$(pEvent.target).attr('rowindex')];
      if (ink !== undefined) {
        ink["export"] = exported;
        if (exported) {
          ink.print = false;
        }
        this._consolidateInkStates(ink);
      } else if (pEvent.target.name === 'separations-exportAll') {
        this._datas.inks.forEach(function (ink) {
          ink["export"] = exported;
          if (exported && !ink.digital) {
            ink.print = false;
          }
        });
      }
    },
    _onOptionHandler: function _onOptionHandler(pEvent) {
      var val = $(pEvent.target).val();
      var ink = this._datas.inks[$(pEvent.target).attr('rowindex')];
      if (ink !== undefined) {
        if (val === '_convert_') {
          this._setConverted(ink, true);
        } else {
          this._setConverted(ink, false, val);
        }
      }
    },
    _onConvertGray: function _onConvertGray(pEvent) {
      this.options.settings.separations.ConvertDeviceGray = $(pEvent.target).is(':checked');
      if (!this.options.settings.separations.ConvertDeviceGray) {
        this._printDefaultInks();
      }
      this._checkInkSettings();
    },
    _NCEHandler: function _NCEHandler(pEvent) {
      var that = this;
      var inkIndex = $(pEvent.target).attr('inkIndex');
      var inkName = this.element.find('.sep-row.col-name:visible[inkIndex="' + inkIndex + '"]').text();
      var ncEditor = this.element.NamedColor();
      ncEditor.NamedColor('editNamedColor', inkName, function (hasBeenEdited) {
        if (hasBeenEdited) {
          var edited = ncEditor.NamedColor('isNamedColorEdited', inkName);

          //that.element.find('div.col-convertSpot button[inkIndex="'+inkIndex+'"]').text(edited ? 'Edit' : 'Define');
          that.element.find('div.col-convertSpot input[name="separations.inks.' + inkIndex + '.nce"]').attr('checked', edited); //.css('visibility', edited ? 'visible' : 'hidden');
          that._changeHandler(pEvent);
        }
      });
    },
    _changeHandler: function _changeHandler(pEvent) {
      if (this._handlingChanges) {
        return;
      }
      try {
        this._handlingChanges = true;
        this._saveSettings(true);
      } finally {
        this._handlingChanges = false;
        this._trigger("change", pEvent, {
          "settings": this.options.settings
        });
      }
    },
    _saveSettings: function _saveSettings(force) {
      var that = this;
      if (this._datas.inks.length > 0 && (force || this._datas.saveInks || this._datas.inks.length === this.options.settings.separations.inks.length)) {
        // if ( this._datas.inks.length > 0 && this._datas.inks.length ===  this.options.settings.separations.inks.length ) {
        // Store the regular stuff
        this.options.settings.separations.override_rulings = this.element.find('[name="separations.override_rulings"]').is(':checked');
        this.options.settings.separations.override_dotshape = this.element.find('[name="separations.override_dotshape"]').is(':checked');
        this.options.settings.separations.output_empty = this.element.find('[name="separations.output_empty"]').is(':checked');
        this.options.settings.separations.spot_screens = 'explicit'; // this.element.find('[name="separations.spot_screens"]').val();

        var ui = this.element.find('input[name="separations.ConvertDeviceGray"]');
        if (ui.is(':visible')) {
          this.options.settings.separations.ConvertDeviceGray = ui.is(':checked');
        } else {
          delete this.options.settings.separations.ConvertDeviceGray;
        }
        this._datas.inks.forEach(function (pInk) {
          that._storeSeparation(pInk);
        });
        var ink_to_delete = [];
        this._datas.inks.forEach(function (pInk) {
          var pIndex = pInk.realIndex;
          if (pIndex < 0) {
            ink_to_delete.push(pIndex + that.options.settings.separations.inks.length);
          }
        });
        ink_to_delete.sort(function (a, b) {
          return b - a;
        }).forEach(function (pRealIndex) {
          that.options.settings.separations.inks.splice(pRealIndex, 1);
        });
        this._datas.saveInks = false;
      }
    },
    _storeSeparation: function _storeSeparation(pInk, rowIndex) {
      var pIndex = pInk.realIndex;
      if (pIndex < 0) {
        return;
      }
      if (this.options.settings.separations.inks[pIndex] === undefined) {
        this.options.settings.separations.inks[pIndex] = pInk;
      }
      var sepInk = this.options.settings.separations.inks[pIndex];
      ['print', 'convert', 'mapped', 'digital', 'printbar', 'angle'].forEach(function (prop) {
        if (pInk[prop] !== undefined) {
          sepInk[prop] = pInk[prop];
        } else {
          delete sepInk[prop];
        }
      });
      ['rgb', 'cmyk', 'toHide', 'letter', 'printLocked', 'realIndex', 'convertable'].forEach(function (prop) {
        delete sepInk[prop]; // some cleaning.
      });

      delete sepInk["export"];
      if (this._datas.enableExport) {
        var exportUI = this.element.find('input[name="separations.inks.' + pIndex + '.export"]');
        if (exportUI.length > 0 && $(exportUI[0]).css('display') !== 'none') {
          sepInk["export"] = this._safeSave(false, exportUI.is(':checked'));
        }
      }
      if (sepInk.printbar === -1 && sepInk.mapped !== undefined) {
        var map = this._datas.mappables.find(function (m) {
          if (m.inkname === sepInk.mapped) {
            return m;
          }
        });
        if (map !== undefined) {
          sepInk.printbar = map.printbar[0];
        }
      }

      // sepInk.angle = parseFloat(this._safeSave(sepInk.angle, this.element.find('[name="separations.inks.' +pIndex + '.angle"]').val()));
      // sepInk.ruling = parseFloat(this._safeSave(sepInk.ruling, this.element.find('[name="separations.inks.' +pIndex + '.ruling"]').val()));
      // sepInk.dotshape = this._safeSave(sepInk.dotshape, this.element.find('[name="separations.inks.' +pIndex + '.dotshape"]').val());

      if (sepInk.print) {
        var mappingUI = this.element.find('select[name="separations.inks.' + pIndex + '.mapto"]');
        if (mappingUI.length === 0 || $(mappingUI[0]).css('display') === 'none') {
          delete sepInk.mapped;
          var convertUI = this.element.find('input[name="separations.inks.' + pIndex + '.convert"]');
          if (convertUI.length > 0 && $(convertUI[0]).css('display') !== 'none') {
            sepInk.convert = true; //this._safeSave(sepInk.convert, convertUI.is(':checked'));
          } else {
            sepInk.convert = false;
          }
          if (this._datas.nce) {
            sepInk.nce = sepInk.nce = this.element.find('input[name="separations.inks.' + pIndex + '.nce"]').is(':checked');
            if (sepInk.nce) {
              var ncEditor = this.element.NamedColor();
              var xyz = sepInk.xyz = ncEditor.NamedColor('getXYZNamedColorEdited', sepInk.name);
              if (!Array.isArray(xyz) || xyz.length !== 3) {
                delete sepInk.xyz;
              } else {
                sepInk.xyz = xyz;
              }
            } else {
              delete sepInk.xyz;
            }
          }
        }
      } else {
        sepInk.convert = false;
        delete sepInk.mapped;
      }
    },
    _initUI: function _initUI() {
      var body = $('<div>').addClass('panel-body cf-panel-body');
      $('<div>').addClass('panel panel-default cf-panel').append($('<div>').addClass("panel-heading").append($('<h3>').addClass("panel-title").text('Separations'))).append(body).appendTo(this.element);
      var override_rulings = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.override_rulings\" class='cf-form-checkbox'/>" + $.i18n._("nixps-RIPEditor-separations.setruling") + "</label></div>");
      nixps.dfeeditor.util.createFormGroup($.i18n._("nixps-RIPEditor-separations.overridedefaults"), override_rulings).hide().appendTo(body);
      var override_dotshape = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.override_dotshape\" class='cf-form-checkbox'/>" + $.i18n._("nixps-RIPEditor-separations.setdothape") + "</label></div>");
      nixps.dfeeditor.util.createFormGroup("", override_dotshape).hide().appendTo(body);
      var output_empty_separations = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.output_empty\"/ class='cf-form-checkbox'>" + $.i18n._("nixps-RIPEditor-separations.outputemptycolors") + "</label></div>");
      nixps.dfeeditor.util.createFormGroup($.i18n._("nixps-RIPEditor-separations.emptyseparations"), output_empty_separations).hide().appendTo(body);
      var spot_screens = $("<select name=\"separations.spot_screens\">");
      spot_screens.addClass("form-control");
      spot_screens.append("<option value=\"none\">" + $.i18n._("nixps-RIPEditor-separations.spotcolorscreens_not") + "</option>");
      spot_screens.append("<option value=\"iterate\">" + $.i18n._("nixps-RIPEditor-separations.spotcolorscreens_iterate") + "</option>");
      spot_screens.append("<option value=\"explicit\">" + $.i18n._("nixps-RIPEditor-separations.spotcolorscreens_specify") + "</option>");
      nixps.dfeeditor.util.createFormGroup("Spot color screens", spot_screens).hide().appendTo(body);

      // Convert to Gray
      var toGray = $('<div>').addClass('convertToGray').append($('<label>').css({
        'margin-left': '10px',
        'margin-bottom': '10px'
      }).append($('<input type="checkbox" class="cf-form-checkbox">').prop('name', 'separations.ConvertDeviceGray')).append($('<span>').addClass('cf-form-label').css({
        'margin-left': '10px'
      }).text('Convert to Gray'))).append($('<span>').text(' Selected Separations  ...  or Output only one Separation').css('margin-left', '10px')).appendTo(body);
      if (this._datas.inkspace.length > 1) {
        // 'K'
        toGray.hide();
      }
      toGray.find('input').attr('checked', false);

      // Create the separation table
      this.separationTable = $("<div>").addClass('.cf-table').appendTo(body);

      // Angle family prepopulation
      var angle_families = $("<select name=\"angle_families\">").addClass("form-control").attr('nixps-quantum-util-autobind', "false");
      angle_families.append("<option selected value=\"x\">" + $.i18n._("nixps-RIPEditor-separations.anglefamily_choose") + "</option>");
      angle_families.append("<option value=\"default\">" + $.i18n._("nixps-RIPEditor-separations.anglefamily_offset") + "</option>");
      angle_families.append("<option value=\"flexo\">" + $.i18n._("nixps-RIPEditor-separations.anglefamily_flexo") + "</option>");
      nixps.dfeeditor.util.createFormGroup($.i18n._("nixps-RIPEditor-separations.anglefamily"), angle_families).hide().appendTo(body);
    },
    _refresh: function _refresh() {
      var that = this;
      if (this.options.settings === undefined || this.options.settings.separations === undefined) {
        return;
      }
      this.element.find('[name="angle_families"]').val('x');
      this.element.find('[name="separations.override_rulings"]').attr('checked', this._getValue(this.options.settings.separations.override_rulings, false));
      this.element.find('[name="separations.override_dotshape"]').attr('checked', this._getValue(this.options.settings.separations.override_dotshape, false));
      this.element.find('[name="separations.output_empty"]').attr('checked', this._getValue(this.options.settings.separations.output_empty, false));
      this.element.find('[name="separations.spot_screens"]').val(nixps.dfeeditor.util.getValue(this.options.settings.separations.spot_screens, "explicit"));

      // Convert to Gray
      var ui = this.element.find('input[name="separations.ConvertDeviceGray"]');
      if (!ui.is(':visible')) {
        delete this.options.settings.separations.ConvertDeviceGray;
      } else if (this.options.settings.separations.ConvertDeviceGray === undefined) {
        this.options.settings.separations.ConvertDeviceGray = false;
      }
      ui.attr('checked', this.options.settings.separations.ConvertDeviceGray);

      // var inks = this.options.settings.separations.inks || [];
      this.separationTable.empty();

      // Add Table Headers
      this.sepTableContent = $('<div>').append($('<label>').addClass('sep-heading col-print')
      // .append($('<input type="checkbox" class=\'cf-form-checkbox\'>').prop('name','separations-printAll').on('change', function() {
      // 	var checked = that.element.find('[name=separations-printAll]').is(':checked');
      // 	that.element.find('.sep-row.col-print input').prop('checked', checked);
      // }))
      .append($('<span>').text($.i18n._('nixps-RIPEditor-separations.color_print')))).appendTo(this.separationTable);
      if (this._datas.enableExport) {
        this.sepTableContent.addClass('grid_4columns');
        this.sepTableContent.append($('<label>').addClass('sep-heading col-export')
        // .append($('<input type="checkbox" class=\'cf-form-checkbox\'>').prop('name','separations-exportAll').on('change', function() {
        // 	var checked = that.element.find('[name=separations-exportAll]').is(':checked');
        // 	that.element.find('.sep-row.col-export input').prop('checked', checked);
        // }))
        .append($('<span>').text($.i18n._('nixps-RIPEditor-separations.color_export'))));
      } else {
        this.sepTableContent.addClass('grid_3columns');
      }

      // Separation name
      this.sepTableContent.append($('<label>').addClass('sep-heading col-name cf-form-label').text($.i18n._("nixps-RIPEditor-separations.color_name")));
      this.sepTableContent.append($('<label>').addClass('sep-heading col-convert').text('Options'));
      if (this.options.readOnly) {
        this.sepTableContent.find('.sep-heading input').hide();
      }

      // Trac #41578
      this._drawSeparations(this.options.settings.separations.spot_screens === "explicit" || this.options.standaloneView === true);
    },
    _drawSeparations: function _drawSeparations(pAddSpotColors) {
      var that = this;
      if (this.options.readOnly) {
        var nbInks = this.options.settings.separations.inks.length - 1;
        this.options.settings.separations.inks.forEach(function (ink, index) {
          if (pAddSpotColors || ink.digital || ink.print) {
            that._addSeparation(ink, index, nbInks);
          }
        });
      } else {
        var nbInks = this._datas.inks.length - 1;
        this._datas.inks.forEach(function (ink, index) {
          if (pAddSpotColors || ink.digital || ink.print) {
            that._addSeparation(ink, index, nbInks);
          }
        });
        var nbInk = this.element.find('.sep-row.col-print input').length;
        var nbToPrint = this.element.find('.sep-row.col-print input:checked').length;
        var nbConvert = this.element.find('.sep-row.col-convertSpot input').length;
        var nbToConvert = this.element.find('.sep-row.col-convertSpot input:checked').length;
        this.element.find('[name=separations-printAll]').prop('checked', nbToPrint === nbInk);
        if (this._datas.enableExport) {
          var nbToExport = this.element.find('.sep-row.col-export input:checked').length;
          nbInk = this.element.find('.sep-row.col-export input').length;
          this.element.find('[name=separations-exportAll]').prop('checked', nbToExport === nbInk).prop('disabled', nbToExport === nbInk);
        }
      }
    },
    _addSeparation: function _addSeparation(pInk, rowIndex, nbInks) {
      var that = this;
      var pair_odd_row = rowIndex % 2 ? 'odd-row' : 'pair-row';
      if (rowIndex === 0) {
        pair_odd_row += ' first-row';
      } else if (rowIndex === nbInks) {
        pair_odd_row += ' last-row';
      }

      // UI: 'Print'
      this.sepTableContent.append($('<label>').addClass('col-print sep-row ' + pair_odd_row).attr('rowIndex', rowIndex).append($('<input type="checkbox" class="cf-form-checkbox">').attr('rowIndex', rowIndex)));

      // UI: 'Export'
      if (this._datas.enableExport) {
        // Only not Digital Ink can be exported
        if (pInk.digital) {
          this.sepTableContent.append($('<label>').addClass('col-export sep-row ' + pair_odd_row).attr('rowIndex', rowIndex));
        } else {
          this.sepTableContent.append($('<label>').addClass('col-export sep-row ' + pair_odd_row).attr('rowIndex', rowIndex).append($('<input type="checkbox" class=\'cf-form-checkbox\'>').attr('rowIndex', rowIndex)));
        }
      }

      // UI: 'Ink name'
      this.sepTableContent.append($('<label>').addClass('col-name sep-row cf-form-label ' + pair_odd_row).attr('rowIndex', rowIndex).attr('inkIndex', pInk.realIndex).prop('name', 'separations.inks.' + pInk.realIndex + '.name').text(translateSeparationNames(pInk.name)));
      if (!pInk.digital && !this.options.readOnly) {
        // For a inkbar mapping: [C,M,Y,K,O,G,V, W] and an output profile colorspace [CMYKOG]
        // only the ‘V’ and ‘W’ become a target for a mapping.
        // PDF separations C,M,Y,K and O,G have to be printed (like they are) without conversion or mapping.
        // PDF separations ‘V’ and ‘W’ have to be mapped respectively to ‘V’ and ‘W'
        // And any other separations can be converted to ‘CMYKOG’ or mapped to ‘V’ or ‘W’ (if these targets are not already used)

        // If one of the separation defined in the inkbar mapping is not to be printed, it can be used as a target mapping.

        // UI: Div 'Options'
        var optionColumn = $('<div>').addClass('col-convertSpot sep-row ' + pair_odd_row).attr('rowIndex', rowIndex).appendTo(this.sepTableContent);
        optionColumn.css({
          'display': 'inline-grid',
          'grid-template-columns': 'auto 100px',
          'padding-right': '5px',
          'grid-column-gap': '0'
        });
        if (!pInk.print && this.options.standaloneView === true) {
          optionColumn.append($('<span>').addClass("delete-spot cf-icon cf-icon-trash").attr('rowIndex', rowIndex).css({
            'position': "relative",
            "left": "-35px"
          }));
        }
        if (this._datas.convertSpot && !this._datas.mapSpot) {
          optionColumn.append($('<span>').css({
            'padding-top': '1px',
            'padding-left': '10px'
          }).append($('<input type="checkbox" class=\'cf-form-checkbox\'>').attr('rowIndex', rowIndex).attr('inkIndex', pInk.realIndex).attr('name', 'separations.inks.' + pInk.realIndex + '.convert').css('visibility', 'hidden')).append($('<span>').attr('rowIndex', rowIndex).text(this._datas.convertToLabel).css('visibility', 'hidden')));
          if (this._datas.nce) {
            var nce = pInk.nce === undefined ? true : pInk.nce;
            var ncEditor = this.element.NamedColor();
            var edited = ncEditor.NamedColor('isNamedColorEdited', pInk.name);
            optionColumn.append($('<div>').append($('<input type="checkbox" class=\'cf-form-checkbox\'>').attr('rowIndex', rowIndex).attr('inkIndex', pInk.realIndex).attr('checked', edited && nce).attr('name', 'separations.inks.' + pInk.realIndex + '.nce').css('visibility', 'hidden')).append($('<button>').attr('rowIndex', rowIndex).attr('inkIndex', pInk.realIndex).text(edited ? 'Edit' : 'Define').css({
              'visibility': 'hidden',
              'width': '75px'
            })));
            // if ( edited && pInk.xyz !== undefined )
            //     optionColumn.find("input").attr('checked', true);
          }
        } else if (this._datas.mapSpot) {
          optionColumn.append($('<select>').attr('name', 'separations.inks.' + pInk.realIndex + '.mapto').attr('inkIndex', pInk.realIndex).attr('rowIndex', rowIndex).css('visibility', 'hidden'));
        }
      } else {
        this.sepTableContent.append($('<label>').addClass('col-convertSpot sep-row ' + pair_odd_row).attr('rowIndex', rowIndex));
      }
      var rI = undefined;
      this.sepTableContent.find('label:contains("' + translateSeparationNames(pInk.name) + '")').each(function (i, elmt) {
        if (rI === undefined && $(elmt).text() === translateSeparationNames(pInk.name)) {
          // avoid names like 'PANTONE Yellow 012 C'
          rI = parseInt($(elmt).attr('rowIndex'));
        }
      });
      if (rI === undefined) {
        return;
      }

      // if ( ""+rI !== ""+rowIndex )
      // 	console.error("INDEXES:  rI="+rI+'   rowIndex='+rowIndex);

      var labels = this.sepTableContent.find('label[rowIndex="' + rI + '"]');
      labels.removeClass('odd-row pair-row first-row last-row');
      labels.addClass(pair_odd_row);

      // Update row
      var ePrint = this.sepTableContent.find('label.col-print input[rowIndex="' + rI + '"]').prop('name', 'separations.inks.' + pInk.realIndex + '.print').attr('ink', 'ink_' + pInk.name).prop('checked', pInk.print).prop('disabled', pInk.printLocked);
      if (!pInk.print) {
        ePrint.removeProp('change_ts');
      } else if (ePrint.prop('change_ts') === undefined) {
        ePrint.prop('change_ts', Date.now());
      }
      if (this._datas.enableExport) {
        this.sepTableContent.find('label.col-export input[rowIndex="' + rI + '"]').prop('name', 'separations.inks.' + pInk.realIndex + '.export').prop('checked', pInk["export"]);
      }
      if (!pInk.digital) {
        var showOptions = pInk.print && !(this._datas.enableExport && pInk["export"]) && this._datas.inkspace.length > 1; // 'K'
        if (showOptions) {
          if (this.options.readOnly) {
            if (pInk.mapped !== undefined) {
              var info = info = this._renamePrintbarColorant(pInk.printbar - 1);
              info = $.i18n._('nixps-separationList.mapped_to_2', [pInk.mapped, ' - ' + info]);
              this.sepTableContent.find('label.col-convertSpot[rowIndex="' + rI + '"]').text(info);
            } else if (pInk.convert === true) {
              this.sepTableContent.find('label.col-convertSpot[rowIndex="' + rI + '"]').text("Converted");
            }
          } else if (this._datas.mapSpot) {
            var sel = this.sepTableContent.find('div.col-convertSpot select[rowIndex="' + rI + '"]').prop('name', 'separations.inks.' + pInk.realIndex + '.mapto').attr('ink', 'ink_' + pInk.name).css('visibility', 'visible');
            sel.empty();
            if (this._datas.convertSpot) {
              $('<option>').val("_convert_").append($('<span>').text(this._datas.convertToLabel)).appendTo(sel);
            }
            var mappable = [];
            this._datas.mappables.forEach(function (map) {
              if (map.spotname === undefined || map.spotname === pInk.name) {
                var ink = that._getInkPerName(map.inkname);
                if (ink === undefined) {
                  ink = that.Engineer.get('separations.inks').find(function (ink) {
                    if (ink.name /*.toLowerCase()*/ === map.inkname || ink.name.toLowerCase() === map.inkname.toLowerCase()) {
                      return ink;
                    }
                  });
                  if (ink === undefined) {
                    mappable.push(map);
                  } else {
                    if (that._datas.outputCS.indexOf(ink.letter) === -1) {
                      mappable.push(map);
                    } else {
                      var converted = that._datas.inks.find(function (i) {
                        return i.convert;
                      });
                      if (converted === undefined) {
                        mappable.push(map);
                      }
                    }
                  }
                } else if (ink.printLocked !== true) {
                  mappable.push(map);
                }
              }
            });
            if (mappable.length > 0) {
              var parent = sel;
              if (this._datas.convertSpot) {
                parent = $('<optgroup>').attr('label', "Ink Mapping").appendTo(sel);
              }
              mappable.forEach(function (map) {
                info = that.Engineer.getPrintbarIds(map.inkname);
                if (info.endsWith("-1")) {
                  info = that.Engineer.getPrintbarIds(that.Engineer.normalizeColorName(map.inkname));
                }
                var opt = $('<option>').val(map.inkname).append($('<span>').text($.i18n._('nixps-separationList.mapped_to_2', [translateSeparationNames(map.inkname, true), ' - ' + info]))).appendTo(parent);
              });
            }
            if (pInk.mapped !== undefined && pInk.mapped !== null /*&& pInk.mapped.length > 0*/) {
              sel.val(pInk.mapped);
            } else if (pInk.convert && this._datas.convertSpot) {
              sel.val('_convert_');
            }
          } else {
            this.sepTableContent.find('div.col-convertSpot input[name="separations.inks.' + rI + '.convert"]').prop('name', 'separations.inks.' + pInk.realIndex + '.convert').prop('checked', true /*pInk.convert === undefined || pInk.convert*/).prop('disabled', true).css('visibility', 'visible');
            this.sepTableContent.find('div.col-convertSpot span[rowIndex="' + rI + '"]').css('visibility', 'visible');
            if (this._datas.nce) {
              var edited = ncEditor.NamedColor('isNamedColorEdited', pInk.name);
              this.sepTableContent.find('div.col-convertSpot input[name="separations.inks.' + rI + '.nce"]').prop('name', 'separations.inks.' + pInk.realIndex + '.nce').css('visibility', edited ? 'visible' : 'hidden');
              this.sepTableContent.find('div.col-convertSpot button[rowIndex="' + rI + '"]').css('visibility', 'visible');
            }
          }
        }
      } else {
        var info = "";
        if (pInk.print && this._datas.mapSpot) {
          if (this.options.readOnly) {
            // Show the printbar #
            info = this._renamePrintbarColorant(pInk.printbar);
          } else if (this._datas.printbar.length > 1) {
            // Show the printbar #
            info = this.Engineer.getPrintbarIds(pInk.name);
            if (info.endsWith("-1")) {
              info = this.Engineer.getPrintbarIds(this.Engineer.normalizeColorName(pInk.name));
            }
          }
        }
        this.sepTableContent.find('label.col-convertSpot[rowIndex="' + rI + '"]').text(info);
      }
    },
    _renamePrintbarColorant: function _renamePrintbarColorant(inkIndex) {
      var info;
      if (this.options.settings.printbar_definition !== undefined && this.options.settings.printbar_definition.ink_mapping.length > inkIndex) {
        info = this.options.settings.printbar_definition.ink_mapping[inkIndex].colorant;
        info = info.replace(/^([^:]+): /, 'On Printbar: ').replace(/PB#/g, '#');
      } else {
        info = "On Printbar: PB#" + (inkIndex + 1);
      }
      return info;
    },
    _setOption: function _setOption(pKey, pValue) {
      this._super(pKey, pValue);
      if (pKey === "settings") {
        this._updateDatas();
        this._refresh();
        this._saveSettings();
      }
    },
    _initDatas: function _initDatas() {
      this._datas = {
        enableExport: this.Engineer.getBehavior("export.nonDigital"),
        convertSpot: this.Engineer.getBehavior("print.convertSpot"),
        mapSpot: this.Engineer.getBehavior("print.mapSpot"),
        nce: this.Engineer.getBehavior("print.namedColorEdition"),
        inkspace: this.Engineer.getSetting("separations.inkspace"),
        printbar: this.Engineer.getSetting("separations.printbar"),
        outputCS: "CMYK",
        convertToLabel: undefined,
        /**
         * List of ordered inks.
         */
        inks: [],
        saveInks: false,
        /**
         * List of <spot> inks converted.
         */
        converts: [],
        /**
         * List of digital inks not yet mapped or not printed.
         * {'name': digitalink name, 'printbar': printbar number array, 'ref': SpotInk using this mapping.}
         */
        mappables: []
      };

      // var outputCS = "CMYK";
      if (this.options.settings !== undefined && this.options.settings.color !== undefined) {
        this._datas.outputCS = this.Engineer.getMediaOutputProfile(this.options.settings.color.media);
      } else {
        this._datas.outputCS = "CMYK";
      }
      var namespace = this._datas.outputCS.length === 1 ? 'Gray' : this._datas.outputCS; // 'K'
      this._datas.convertToLabel = $.i18n._("nixps-RIPEditor-separations.convertTo", [namespace]);
      if (this._datas.convertSpot) {
        // Convertion can be performed only if outputCS is a subset of inkspace and inkspace is higher than 2

        var defined = "";
        if (this._datas.inkspace.length > 1 /*&&  this._datas.inkspace.length === this._datas.outputCS.length*/) {
          this._datas.convertSpot = this.Engineer.isColorSpaceEqualToPrintbarDefinition(this._datas.outputCS);
          // var letters = this._datas.inkspace;
          // for (var i = 0; i < this._datas.outputCS.length; i++) {
          // 	var letter = this._datas.outputCS[i];
          // 	var idx = letters.indexOf(letter);
          // 	if (idx >= 0) {
          // 		defined += letter;
          // 		letters = letters.substring(0, idx)+letters.substring(idx+1) ;
          // 	}
          // }
          // this._datas.convertSpot = defined === this._datas.outputCS || letters.length === 0;
        } else {
          this._datas.convertSpot = defined === this._datas.outputCS;
        }
      }
    },
    _updateDatas: function _updateDatas() {
      this._initDatas();
      var pInks = this.options.settings.separations.inks;
      if (this.options.readOnly) {
        if (this.options.settings.printbar_definition === undefined || this.options.settings.printbar_definition.ink_mapping.length > 1) {
          // 'K'
          this.element.find('.convertToGray').hide();
        } else {
          this.element.find('.convertToGray').show();
        }
        return;
      }
      var colors = this.Engineer.getDefaultInksNames(false);
      var spotColors = [];
      var that = this;
      this._datas.mappables = [];
      if (this._datas.mapSpot) {
        colors.forEach(function (inkname, index) {
          that.Engineer.get("separations.printbar").some(function (pb) {
            if (pb.name === inkname || pb.name.toLowerCase() === inkname.toLowerCase()) {
              that._datas.mappables.push({
                'inkname': uniformNames(inkname, true, colors),
                'printbar': pb.PB,
                'spotname': undefined
              });
              return true;
            }
          });
        });
      }
      // Order separations inks with the digital ink first
      pInks.forEach(function (sep, index) {
        var ink = $.extend({}, sep);
        delete ink.printbar;
        ink.realIndex = index;
        ink.name = uniformNames(ink.name, true, colors);

        // Sadly a bug created preset with duplicated inks.
        if (that._datas.inks.some(function (i) {
          return i.name === ink.name;
        }) || spotColors.some(function (i) {
          return i.name === ink.name;
        })) {
          return; // Ink defined twice in the preset.
        }

        var index = $.inArray(ink.name, colors);
        if (index >= 0 && ink.mapped === undefined) {
          ink.printbar = index;
        }
        ink.digital = index >= 0;
        ink.letter = that.Engineer.getInkLetter(ink.name);
        if (ink.letter === undefined) {
          // TODO. Define the right letter.
        }
        if (ink.print) {
          ink["export"] = false;
        }
        if (ink["export"]) {
          ink.print = false;
        }
        ink.printLocked = false;
        if (ink.digital) {
          // ink defined in the Default Inks
          ink.convert = false;
          delete ink.mapped;
          that._datas.inks.push(ink);
        } else if (ink.name.toLowerCase() !== '<spot>') {
          spotColors.push(ink);
        }
      });
      if (this.options.standaloneView === true) {
        // In case of preset edition, complete the inks with the ones defining the printbars.
        // Not to do, in case of job submission: the effective PDF separations has'nt to be completed.
        //if ( this._datas.inks.length  < colors.length ) {
        var defInks = this.Engineer.getDefaultInks();
        defInks.forEach(function (defInk, index) {
          if (!that._datas.inks.some(function (ink) {
            return ink.name === defInk.name;
          })) {
            defInk.printbar = index;
            defInk.realIndex = that._datas.inks.length + spotColors.length;
            defInk.digital = true;
            defInk.print = true;
            that._datas.inks.push(defInk);
            pInks.splice(defInk.realIndex, 1, defInk);
            that._datas.saveInks = true;
          }
        });
        //}
      }
      // Sort digital inks on the printbar number.
      this._datas.inks.sort(function (i1, i2) {
        return i1.printbar - i2.printbar;
      });
      spotColors.forEach(function (ink) {
        that._datas.inks.push(ink);
        if (ink.print) {
          if (ink.convert) {
            that._setConverted(ink, true);
          } else if (ink.mapped !== undefined && ink.mapped !== null && ink.mapped.length > 0) {
            if (!that._setMapping(ink, ink.mapped)) {
              that._unmapSpotName(ink.name);
            }
          } else if (ink.printbar >= 0) {
            // ink was previoulsy a 'digital' one
            that._setMapping(ink, "_dum_my+");
          } else {
            ink.print = false; // If a spot ink is neither converted or mapped it can't be printed.
          }

          ink.printbar = -1;
        }
      });
      if (this._datas.inkspace.length > 1) {
        // 'K'
        this.element.find('.convertToGray').hide();
      } else {
        this.element.find('.convertToGray').show();
      }
      this._updateMappables();
      this._checkInkSettings();
    },
    _getInkPerName: function _getInkPerName(name) {
      return this._datas.inks.find(function (ink) {
        return ink.name === name;
      });
    },
    _updateMappables: function _updateMappables() {
      var that = this;
      this._datas.mappables.forEach(function (map, index) {
        var idx = that._getInkIndex(map.inkname);
        if (idx !== -1 && that._datas.inks[idx].print && that._datas.inks[idx].digital) {
          map.spotname = that._datas.inks[idx].name;
        } else {
          var found = that._datas.inks.find(function (item) {
            return item.mapped === map.inkname;
          });
          if (found !== undefined) {
            map.spotname = found.name;
          }
        }
      });
    },
    _lockOutputCS: function _lockOutputCS(convertDeviceGray, lock) {
      var that = this;
      var cs = convertDeviceGray ? "CMYK" : this._datas.outputCS;
      for (var i = 0; i < cs.length; i++) {
        this._datas.inks.some(function (ink) {
          if (ink.letter === cs[i] /*&& (convertDeviceGray || ink.digital)*/) {
            ink.printLocked = lock;
            if (lock) {
              ink.print = true;
              ink["export"] = false;
            }
            return true;
          }
          return false;
        });
      }

      // Locked ink cannot be mapped.
      this._datas.inks.forEach(function (ink) {
        if (ink.printLocked) {
          that._unmapInkName(ink.name);
        }
      });
    },
    _isInkLocked: function _isInkLocked() {
      return this._datas.inks.some(function (ink) {
        return ink.printLocked;
      });
    },
    _checkInkSettings: function _checkInkSettings() {
      var that = this;
      if (this._datas.inkspace.length === 1) {
        // 'K'
        this._lockOutputCS(true, this.options.settings.separations.ConvertDeviceGray);
        this._datas.inks.forEach(function (ink) {
          ink.convert = that.options.settings.separations.ConvertDeviceGray;
        });
        this._datas.converts = [];
        if (!this.options.settings.separations.ConvertDeviceGray) {
          this._checkToPrint();
        }
      } else if (this._datas.converts.length > 0) {
        this._lockOutputCS(false, true);
      } else {
        this._checkToPrint();
      }
    },
    /**
     * Ensure the number of ink to print is ok: At least 1. At max, the number of printbar.
     * @param editedInk Optional ink edited
     * @returns {*}
     * @private
     */
    _checkToPrint: function _checkToPrint(editedInk) {
      if (this.options.settings.separations.ConvertDeviceGray || this._datas.converts.length > 0) {
        return;
      }
      var that = this;
      // options.inkspace define the number of ink printed.
      // If a spot-color is printed BUT converted to CMYK, it should be counted as an ink printed.
      // if (!this._datas.enableExport && this._datas.inkspace !== "CMYK") {

      // // Unlock all inks
      // if (!this.options.settings.separations.ConvertDeviceGray && this._datas.inkspace.length === 1) { // 'K'
      // 	this._datas.inks.forEach(function (ink) {
      // 		ink.convert = false;
      // 	});
      // }

      // Only one Sep can be printed. The Black by default.
      var nbPrintable = Math.max(1, this._datas.printbar.length);
      var nbToPrint = this._nbInkPrinted();
      if (nbToPrint > nbPrintable) {
        if (editedInk !== undefined && editedInk.digital) {
          var changed = this._unmapInkName(editedInk.name);
          if (changed !== undefined) {
            if (this._datas.convertSpot) {
              changed.convert = true;
            } else {
              changed.print = false;
            }
            this._consolidateInkStates(changed);
            return this._checkToPrint(undefined);
          }
        }
        this._printChangeTS(nbPrintable, true);
        nbToPrint = this._nbInkPrinted();
      }
      if (nbToPrint === 0) {
        this._printChangeTS(undefined, false);
        var sortedInput = [];
        this.element.find('.sep-row.col-print input').each(function (idx, eInput) {
          sortedInput.push(eInput);
        });
        sortedInput = sortedInput.sort(function (a, b) {
          if (a.change_ts === undefined && b.change_ts === undefined) {
            return 0;
          }
          return a.change_ts === undefined || a.change_ts < b.change_ts ? 1 : b.change_ts === undefined || a.change_ts > b.change_ts ? -1 : 0;
        });
        if (sortedInput.length > 0) {
          var rowIndex = $(sortedInput[0]).attr('rowindex');
          $(sortedInput[0]).removeProp('change_ts');
          var ink = this._datas.inks[rowIndex];
          if (ink !== undefined) {
            ink.print = true;
            if (ink.convert) {
              this._setConverted(ink, false, null);
            } else {
              // if ( ink.mapped !== undefined )
              this._unmapSpotName(ink.name);
            }
          }
        }
        nbToPrint = this._nbInkPrinted();
      }
      if (nbToPrint === 0) {
        // Select the inks name defined by the inkspace.
        this._printDefaultInks();
        nbToPrint = this._nbInkPrinted();
      }
      if (nbToPrint === 0) {
        // Select the N first one (if Default Inks are not available)
        for (var i = 0; i < nbPrintable && i < that._datas.inks.length; i++) {
          that._datas.inks[i].print = true;
        }
      }
    },
    _printChangeTS: function _printChangeTS(nbPrintable, checked) {
      var sortedInput = [];
      this.element.find('.sep-row.col-print input' + (checked ? ':checked' : '')).each(function (idx, eInput) {
        sortedInput.push(eInput);
      });
      sortedInput = sortedInput.sort(function (a, b) {
        if (a.change_ts === undefined && b.change_ts === undefined) {
          return 0;
        }
        return a.change_ts === undefined || a.change_ts < b.change_ts ? 1 : b.change_ts === undefined || a.change_ts > b.change_ts ? -1 : 0;
      });
      var from = nbPrintable || 0;
      var to = nbPrintable === undefined ? 1 : sortedInput.length;
      for (var i = from; i < to && i < sortedInput.length; i++) {
        var rowIndex = $(sortedInput[i]).attr('rowindex');
        $(sortedInput[i]).removeProp('change_ts');
        var ink = this._datas.inks[rowIndex];
        if (ink !== undefined) {
          ink.print = false;
          if (ink.convert) {
            this._setConverted(ink, false, null);
          } else {
            // if ( ink.mapped !== undefined )
            this._unmapSpotName(ink.name);
          }
        }
      }
    },
    _printDefaultInks: function _printDefaultInks() {
      var that = this;
      this.Engineer.getDefaultInks().forEach(function (ink) {
        var rowindex = that._getInkIndex(ink.name);
        if (rowindex >= 0) {
          that._datas.inks[rowindex].print = true;
        }
      });
    },
    _nbInkPrinted: function _nbInkPrinted() {
      var nb = 0;
      this._datas.inks.forEach(function (ink) {
        if (ink.print) {
          nb++;
        }
      });
      return nb;
    },
    _getInkIndex: function _getInkIndex(inkname) {
      var ret = -1;
      this._datas.inks.some(function (ink, index) {
        if (ink.name === inkname) {
          ret = index;
          return true;
        }
      });
      return ret;
    },
    _setConverted: function _setConverted(ink, convert, mappingTarget) {
      var that = this;
      ink.convert = convert;
      if (convert) {
        ink.print = true;
        if (this._datas.converts.find(function (item) {
          return item.name === ink.name;
        }) === undefined) {
          this._datas.converts.push({
            'name': ink.name,
            'inks_index': this._getInkIndex(ink.name)
          });
        }
        this._unmapSpotName(ink.name);
        // At least one sep is to convert. Other inks part of the outputCS can't be mapped.
        this._datas.mappables.forEach(function (map) {
          if (map.spotname !== undefined && map.spotname !== map.inkname) {
            var ink2 = that._getInkPerName(map.inkname);
            if (ink2 === undefined) {
              ink2 = that.Engineer.get('separations.inks').find(function (ink3) {
                if (ink3.name === map.inkname) {
                  return ink3;
                }
              });
            }
            if (ink2 !== undefined && that._datas.outputCS.indexOf(ink2.letter) !== -1) {
              that._unmapInkName(map.inkname);
            }
          }
        });
      } else {
        var that = this;
        this._datas.converts.some(function (conv, index) {
          if (conv.name === ink.name) {
            that._datas.converts.splice(index, 1);
            return true;
          }
          return false;
        });
        if (mappingTarget !== null) {
          if (mappingTarget === undefined) {
            var found = this._nextMappable();
            if (found !== undefined) {
              mappingTarget = found.inkname;
            }
          }
          this._setMapping(ink, mappingTarget);
        }
      }
    },
    _isMappable: function _isMappable(inkname) {
      var found = this._datas.mappables.find(function (item) {
        return item.inkname === inkname;
      });
      return found !== undefined;
    },
    _hasMappable: function _hasMappable() {
      return this._nextMappable() !== undefined;
    },
    _nextMappable: function _nextMappable() {
      var that = this;
      var found = undefined;
      this._datas.mappables.some(function (map) {
        if (map.spotname === undefined) {
          var ink2 = that._getInkPerName(map.inkname);
          if (ink2 === undefined) {
            ink2 = that.Engineer.get('separations.inks').find(function (ink) {
              if (ink.name === map.inkname) {
                return ink;
              }
            });
            if (ink2 === undefined) {
              found = map;
              return true;
            } else {
              if (that._datas.outputCS.indexOf(ink2.letter) === -1) {
                found = map;
                return true;
              } else {
                var converted = that._datas.inks.find(function (i) {
                  return i.convert;
                });
                if (converted === undefined) {
                  found = map;
                  return true;
                }
              }
            }
          } else if (ink2.printLocked !== true) {
            found = map;
            return true;
          }
          return false;
        }
      });
      return found;
    },
    /**
     * @description: Try to set a mapping. Return true if succeeded. Otherwise false.
     * @param ink
     * @param mapped
     * @private
     */
    _setMapping: function _setMapping(ink, mapped) {
      var that = this;
      var inkMapped = this.Engineer.getInkPerName(mapped);
      var mappedIndex = this._getInkIndex(mapped);
      if (mappedIndex !== -1) {
        inkMapped = this._datas.inks[mappedIndex];
      }
      if (inkMapped === undefined && ink.printbar >= 0) {
        var map = this._datas.mappables.find(function (item) {
          // => item.printbar === ink.printbar );
          for (var i = 0; i < item.printbar.length; i++) {
            if (item.printbar[i] === ink.printbar) {
              return item;
            }
          }
          return undefined;
        });
        if (map !== undefined) {
          mapped = map.inkname;
        }
      }
      if (inkMapped !== undefined && inkMapped.printLocked) {
        return false;
      }
      var found = this._datas.mappables.find(function (item) {
        return item.inkname === mapped;
      });
      if (found !== undefined) {
        if (found.spotname !== undefined) {
          var refMapped = this._datas.inks.find(function (item) {
            return item.name === found.spotname;
          });
          if (refMapped !== undefined) {
            if (refMapped.print) {
              if (this._datas.convertSpot) {
                refMapped.convert = true;
              } else {
                var unmapped = this._nextMappable();
                if (unmapped !== undefined) {
                  this._setMapping(refMapped, unmapped.inkname);
                } else {
                  // refMapped.print = false;
                  delete refMapped.mapped;
                }
              }
            } else {
              delete refMapped.mapped;
            }
            ink.angle = refMapped.angle;
          }
        }
        refMapped = this.Engineer.getDefaultInks().find(function (ink) {
          if (ink.name === mapped) {
            return ink;
          }
        });
        if (refMapped !== undefined) {
          ink.angle = refMapped.angle;
        }
        found.spotname = ink.name;
        ink.mapped = mapped;
        return true;
      }
      delete ink.mapped;
      return false;
    },
    _unsetMapping: function _unsetMapping(inkname, prop) {
      var found = this._datas.mappables.find(function (item) {
        return item[prop] === inkname;
      });
      if (found !== undefined) {
        var mapped = this._datas.inks.find(function (item) {
          return item.name === found.spotname;
        });
        if (mapped !== undefined) {
          delete mapped.mapped;
          if (mapped.print && this._datas.convertSpot) {
            mapped.convert = true;
          } else if (!mapped.printLocked) {
            mapped.print = false;
          }
        }
        found.spotname = undefined;
        return mapped;
      }
      return undefined;
    },
    _unmapInkName: function _unmapInkName(inkname) {
      return this._unsetMapping(inkname, 'inkname');
    },
    _unmapSpotName: function _unmapSpotName(inkname) {
      this._unsetMapping(inkname, 'spotname');
    },
    /**
     * @description remove the handles, listeners of the (change) events, and other unfriendly update functions
     * @function
     * @returns {undefined}
     */
    desactivateHandlers: function desactivateHandlers() {
      // remove change event listeners
      this._off(this.element, "change");
      // reset _setoptions  to remove refresh call if options are set
      this._setOption = function () {};
    },
    /**
     * @description remove inputfields or selectors that can not be used during editing in the workflowbuilder (quantum)
     * @function
     * @returns {undefined}
     */
    desactivateUnusableFields: function desactivateUnusableFields() {
      this.element.find('label[for="angle_families"]').parent().remove();
    },
    _safeSave: function _safeSave(defaultValue, pValue) {
      if (pValue !== undefined) {
        return pValue;
      }
      return defaultValue;
    },
    _getValue: function _getValue(pParameter, pDefault) {
      if (pParameter === undefined) {
        return pDefault;
      }
      return pParameter;
    }
  });
})(jQuery);

},{"./nixps-dfe-Engineer.js":99}],102:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

(function ($) {
  require('./nixps-dfe-Engineer.js');

  /**
   * @desc translate the color names to names that begins with a uppercase letter
   * @function
   * @private
   * @static
   * @param {string} pInkt
   * @returns {String}
   */

  function translateSeparationNames(pInkt, cmykOnly) {
    var all = cmykOnly === undefined ? true : cmykOnly !== true;
    var cmykColors = ['cyan', 'magenta', 'yellow', 'black'];
    if (all || $.inArray(pInkt.toLowerCase(), cmykColors) >= 0) {
      return pInkt.charAt(0).toUpperCase() + pInkt.slice(1);
    }
    return pInkt;
  }
  function uniformNames(name) {
    return name.toLowerCase();
  }
  $.widget("nixps.DFESeparationListSummary", {
    widgetEventPrefix: "dfeseparationlistsummary",
    options: {
      /**
       * The settings blob with the RIP parameters
       */
      settings: undefined,
      /**
       * @description DFE context. IT IS MANDATORY
       * @type {object}
       * @default undefined
       */
      dfe_context: undefined
    },
    _datas: {},
    /**
     * @brief creates the editor component
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      if (this.options.dfe_context === undefined || this.options.dfe_context.app === undefined) {
        this.element.append($("<label >").text('DFESeparationList: Fundamentals context is unspecified.'));
        return;
      }
      this.Engineer = nixps.dfe.getEngineerInstance(this.options.dfe_context);
      if (this.options.settings === undefined) {
        this.options.settings = {
          'separations': {
            'inks': []
          }
        };
      } else if (this.options.settings.separations === undefined) {
        this.options.settings.separations = {
          'inks': []
        };
      } else if (this.options.settings.separations.inks === undefined) {
        this.options.settings.separations.inks = [];
      }
      this._datas.convertSpot = this.Engineer.getBehavior('print.convertSpot');
      this._datas.mapSpot = this.Engineer.getBehavior('print.mapSpot');
      this._datas.enableExport = this.Engineer.getBehavior("export.nonDigital");
      this._initUI();
      this._refresh();
    },
    _initUI: function _initUI() {
      // var override_rulings = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.override_rulings\"/>" + $.i18n._("nixps-RIPEditor-separations.setruling") + "</label></div>");
      // nixps.dfeeditor.util.createFormGroup($.i18n._("nixps-RIPEditor-separations.overridedefaults"), override_rulings).appendTo(this.element);
      //
      // var override_dotshape = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.override_dotshape\"/>" + $.i18n._("nixps-RIPEditor-separations.setdothape") + "</label></div>");
      // nixps.dfeeditor.util.createFormGroup("", override_dotshape).appendTo(this.element);
      //
      // var output_empty_separations = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.output_empty\"/>" + $.i18n._("nixps-RIPEditor-separations.outputemptycolors") + "</label></div>");
      // nixps.dfeeditor.util.createFormGroup($.i18n._("nixps-RIPEditor-separations.emptyseparations"), output_empty_separations).appendTo(this.element);

      // var spot_screens = $("<select name=\"separations.spot_screens\">");
      // spot_screens.addClass("form-control");
      // spot_screens.append("<option value=\"none\">" +$.i18n._("nixps-RIPEditor-separations.spotcolorscreens_not") + "</option>");
      // spot_screens.append("<option value=\"iterate\">" +$.i18n._("nixps-RIPEditor-separations.spotcolorscreens_iterate") + "</option>");
      // spot_screens.append("<option value=\"explicit\">" +$.i18n._("nixps-RIPEditor-separations.spotcolorscreens_specify") + "</option>");
      // nixps.dfeeditor.util.createFormGroup("Spot color screens", spot_screens).appendTo(this.element);

      // Convert to Gray
      var toGray = $('<div>').addClass('convertDeviceGray').append($('<label>').css({
        'margin-left': '10px',
        'margin-bottom': '10px'
      }).append($('<input type="checkbox">').prop('name', 'separations.ConvertDeviceGray')).append($('<span>').text('Convert to Gray'))).append($('<span>').text(' Selected Separations  ...  or Output only one Separation').css('margin-left', '10px')).appendTo(this.element);

      // Create the separation table
      this.separationTable = $("<div>").appendTo(this.element);

      // Angle family prepopulation
      // var angle_families = $("<select name=\"angle_families\">").addClass("form-control").attr('nixps-quantum-util-autobind', "false");
      // angle_families.append("<option selected value=\"x\">" + $.i18n._("nixps-RIPEditor-separations.anglefamily_choose") + "</option>");
      // angle_families.append("<option value=\"default\">" + $.i18n._("nixps-RIPEditor-separations.anglefamily_offset") + "</option>");
      // angle_families.append("<option value=\"flexo\">" + $.i18n._("nixps-RIPEditor-separations.anglefamily_flexo") + "</option>");
      // nixps.dfeeditor.util.createFormGroup($.i18n._("nixps-RIPEditor-separations.anglefamily"), angle_families).appendTo(this.element);
    },

    _refresh: function _refresh() {
      var that = this;
      if (this.options.settings === undefined || this.options.settings.separations === undefined) {
        return;
      }

      // Convert to Gray
      if (this.options.settings.separations.ConvertDeviceGray === undefined) {
        this.element.find('.convertDeviceGray').hide();
      } else {
        this.element.find('input[name="separations.ConvertDeviceGray"]').attr('checked', this.options.settings.separations.ConvertDeviceGray);
      }
      // var inks = this.options.settings.separations.inks || [];
      this.separationTable.empty();

      // Add Table Headers
      this.sepTableContent = $('<div>').append($('<label>').addClass('sep-heading col-print')
      // .append($('<input type="checkbox">').prop('name','separations-printAll')
      .append($('<span>').text($.i18n._('nixps-RIPEditor-separations.color_print')))).appendTo(this.separationTable);
      // TODO
      if (this._datas.enableExport) {
        this.sepTableContent.addClass('grid_4columns');
        this.sepTableContent.append($('<label>').addClass('sep-heading col-export')
        // .append($('<input type="checkbox">').prop('name','separations-exportAll')
        .append($('<span>').text($.i18n._('nixps-RIPEditor-separations.color_export'))));
      } else {
        this.sepTableContent.addClass('grid_3columns');
      }

      // Separation name
      this.sepTableContent.append($('<label>').addClass('sep-heading col-name').text($.i18n._("nixps-RIPEditor-separations.color_name")));
      this.sepTableContent.append($('<label>').addClass('sep-heading col-convert').text('Options'));
      this._drawSeparations(this.options.settings.separations.spot_screens === "explicit");
    },
    _drawSeparations: function _drawSeparations(pAddSpotColors) {
      var that = this;
      var nbInks = this.options.settings.separations.inks.length - 1;
      this.options.settings.separations.inks.forEach(function (ink, index) {
        if (pAddSpotColors || ink.digital) {
          that._addSeparation(ink, index, nbInks);
        }
      });
    },
    _addSeparation: function _addSeparation(pInk, rowIndex, nbInks) {
      var pair_odd_row = rowIndex % 2 ? 'odd-row' : 'pair-row';
      if (rowIndex === 0) {
        pair_odd_row += ' first-row';
      } else if (rowIndex === nbInks) {
        pair_odd_row += ' last-row';
      }

      // UI: 'Print'
      this.sepTableContent.append($('<label>').addClass('col-print sep-row ' + pair_odd_row).attr('rowIndex', rowIndex).append($('<input type="checkbox">').attr('rowIndex', rowIndex)));

      // UI: 'Export'
      if (this._datas.enableExport) {
        // Only not Digital Ink can be exported
        if (pInk.digital) {
          this.sepTableContent.append($('<label>').addClass('col-export sep-row ' + pair_odd_row).attr('rowIndex', rowIndex));
        } else {
          this.sepTableContent.append($('<label>').addClass('col-export sep-row ' + pair_odd_row).attr('rowIndex', rowIndex).append($('<input type="checkbox">').attr('rowIndex', rowIndex)));
        }
      }

      // UI: 'Ink name'
      this.sepTableContent.append($('<label>').addClass('col-name sep-row ' + pair_odd_row).attr('rowIndex', rowIndex).attr('inkIndex', pInk.realIndex).prop('name', 'separations.inks.' + pInk.realIndex + '.name').text(translateSeparationNames(pInk.name)));
      this.sepTableContent.append($('<label>').addClass('col-convertSpot sep-row ' + pair_odd_row).attr('rowIndex', rowIndex));
      var rI = undefined;
      this.sepTableContent.find('label:contains("' + translateSeparationNames(pInk.name) + '")').each(function (i, elmt) {
        if (rI === undefined && $(elmt).text() === translateSeparationNames(pInk.name)) {
          // avoid names like 'PANTONE Yellow 012 C'
          rI = $(elmt).attr('rowIndex');
        }
      });
      if (rI === undefined) {
        return;
      }

      // if ( ""+rI !== ""+rowIndex )
      // 	console.error("INDEXES:  rI="+rI+'   rowIndex='+rowIndex);

      var labels = this.sepTableContent.find('label[rowIndex="' + rI + '"]');
      labels.removeClass('odd-row pair-row first-row last-row');
      labels.addClass(pair_odd_row);

      // Update row
      this.sepTableContent.find('label.col-print input[rowIndex="' + rI + '"]').prop('name', 'separations.inks.' + pInk.realIndex + '.print').attr('ink', 'ink_' + pInk.name).prop('checked', pInk.print);
      if (this._datas.enableExport) {
        this.sepTableContent.find('label.col-export input[rowIndex="' + rI + '"]').prop('name', 'separations.inks.' + pInk.realIndex + '.export').prop('checked', pInk["export"]);
      }

      // TODO ? Is it relevant to use the current Engineer instead of the setting used for this rip_setting.
      if (!pInk.digital) {
        var showOptions = pInk.print && !(this._datas.enableExport && pInk["export"]) && this.options.settings.separations.ConvertDeviceGray === undefined; // 'K'
        if (showOptions) {
          if (pInk.mapped !== undefined) {
            // info = this.Engineer.getPrintbarIds( pInk.mapped );
            // if ( info.endsWith("-1") )
            // 	info = this.Engineer.getPrintbarIds( this.Engineer.normalizeColorName(pInk.mapped) );

            this.sepTableContent.find('label.col-convertSpot[rowIndex="' + rI + '"]').text($.i18n._('nixps-separationList.mapped_to_2', [pInk.mapped, ' - ' + (pInk.printbar + 1)]));
            // [pInk.mapped, ' - '+info]));
          } else if (pInk.convert === true) {
            this.sepTableContent.find('label.col-convertSpot[rowIndex="' + rI + '"]').text("Converted");
          }
        }
      } else if (pInk.printbar !== undefined && pInk.printbar > -1) {
        var info = "";
        if (pInk.print && this._datas.mapSpot) {
          // info = this.Engineer.getPrintbarIds( pInk.name );
          // if ( info.endsWith("-1") )
          // 	info = this.Engineer.getPrintbarIds( this.Engineer.normalizeColorName(pInk.name) );
          info = "On Printbar: PB #" + (pInk.printbar + 1);
        }
        this.sepTableContent.find('label.col-convertSpot[rowIndex="' + rI + '"]').text(info);
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      this._super(pKey, pValue);
      if (pKey === "settings") {
        this._refresh();
      }
    }
  });
})(jQuery);

},{"./nixps-dfe-Engineer.js":99}],103:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 26 jun 2019
 */
(function ($) {
  require("../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponent.js");
  require("../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js");

  /**
   * @namespace nixps-cloudflow.DetailsPanel
   * @description Draw a panel to show and edit the details of an item
   * @example $("<div>").DetailsPanel({
    * });
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.DetailsPanel", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "detailspanel",
    options: {
      /**
       * @name nixps-cloudflow.DetailsPanel#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.DetailsPanel#relativeBasePath
       * @description The path to be used if the url is relative
       * @type {string}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.DetailsPanel#title
       * @description The main title of the details panel
       * @type {String}
       * @default ""
       */
      title: "",
      /**
       * @name nixps-cloudflow.DetailsPanel#imageURL
       * @description The main thumbnail image of the panel
       * @type {String}
       * @default null
       */
      imageURL: null,
      /**
       * @description the icon to be show
       * @name nixps-cloudflow.DetailsPanel#imageIcon
       * @type {String}
       * @default null
       */
      imageIcon: null,
      /**
       * @name nixps-cloudflow.DetailsPanel#imageLabel
       * @description The label beyond the image 
       * @type {String}
       * @default ""
       */
      imageLabel: "",
      /**
       * @name nixps-cloudflow.DetailsPanel#imageDimensions
       * @description the max with and maax height of the image
       * @type {Number}
       * @default 105
       */
      imageDimensions: 105,
      /**
       * @name nixps-cloudflow.DetailsPanel#contentType
       * @description The type of content, defines how we must draw the content.
       * The only possible values are: "custom", "form", "customPageComponent"
       * @type {String}
       * @default ""
       */
      contentType: "custom",
      /**
       * @name nixps-cloudflow.DetailsPanel#content
       * @description The content to be displayed
       * @type {mixed}
       * @default null
       */
      content: null,
      /**
       * @name nixps-cloudflow.DetailsPanel#formClasses
       * @description The classes to be apllied on the form
       * @type {String}
       * @default "cf-form cf-form-detailspanel"
       */
      formClasses: "cf-form cf-form-detailspanel",
      /**
       * @name nixps-cloudflow.DetailsPanel#bottomBarButtons
       * @description The buttons configuration of the bottom buttons bar
       * @type {Array.<Object>}
       * @default null
       */
      bottomBarButtons: null,
      /**
       * @name nixps-cloudflow-DetailsPanel#bottomBarClasses
       * @description The classes given to the bottombar
       * @type {String}
       * @default "cf-buttonbar-center cf-buttonbar-bottom"
       */
      bottomBarClasses: "cf-buttonbar-center cf-buttonbar-bottom",
      /**
       * @name nixps-cloudflow-DetailsPanel#openOnCreation
       * @description Must the details panel be open on creation?
       * @type {Boolean}
       * @default false
       */
      openOnCreation: false,
      /**
       * @name nixps-cloudflow-DetailsPanel#enableCloseButton
       * @description Must we show the close button at the right top of the panel
       * @type {Boolean}
       * @default true
       */
      enableCloseButton: true,
      /**
       * @name nixps-cloudflow-DetailsPanel#closeAfterDecision
       * @description Must we close the panel when the user cancel ar save correctly the form?
       * @type {Boolean}
       * @default false
       */
      closeAfterDecision: false,
      /**
       * @name nixps-cloudflow-DetailsPanel#hideBottomBarButtonsOnDisable
       * @description Must we hide the buttons when disabled
       * @type {Boolean}
       * @default true
       */
      hideBottomBarButtonsOnDisable: true,
      /**
       * @name nixps-cloudflow-DetailsPanel#adaptPageContent
       * @description Must we adapt automaticaly the neighbour pagecontent, so he can adapt his width?
       * This will only work if you have a correct page class setup
       * @type {Boolean}
       * @default false
       */
      adaptPageContent: false,
      /**
       * @name nixps-cloudflow.DetailsPanel#widthFormat
       * @description Which width format must the detailspanel take
       * @type {String}
       * @default "normal"
       */
      widthFormat: "normal",
      /**
       * @name nixps-cloudflow.DetailsPanel#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       * @default "default
       */
      style_type: "default",
      /**
       * @name nixps-cloudflow.DetailsPanel#closeOnEscape
       * @description Must we close on press escape, this is the same code as jQuery UI Dialog
       * @type {Boolean}
       * @default true
       */
      closeOnEscape: true,
      /**
       * @name nixps-cloudflow.DetailsPanel#enableMaximize
       * @description Must we close on press escape, this is the same code as jQuery UI Dialog
       * @type {Boolean}
       * @default false
       */
      enableMaximize: false,
      /**
       * @description Whether the component is inside the pagebuilder editor or not.
       * @name nixps-cloudflow.DetailsPanel#isInEditor
       * @type {Boolean}
       * @default false
       */
      isInEditor: false,
      created: function created() {}
    },
    _getCreateEventData: function _getCreateEventData() {
      return {
        isOpen: this.isOpen()
      };
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.DetailsPanel#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("cf-detailspanel CloudflowStyle_" + this.options.style_type).attr("data-widgetname", this.widgetName);
      this.creating = true;
      this.screenToSmall = false;
      if (typeof window.matchMedia === "function") {
        var mql = window.matchMedia("(max-width: 780px)");
        if (mql !== undefined && mql !== null && mql.matches === true) {
          this.screenToSmall = true;
        }
      }
      if (this.options.widthFormat === "large") {
        this.element.addClass("cf-detailspanel-large");
      }
      if (this.options.openOnCreation === false) {
        // do not call this.close, because we
        // dont want to fire events
        this.element.addClass("cf-detailspanel-closed");
        if (this.options.adaptPageContent === true) {
          this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().removeClass("cf-pagecontent-detailspanel").removeClass("cf-pagecontent-detailspanel-large");
        }
      } else if (this.options.openOnCreation === "whenBigScreen") {
        if (this.screenToSmall === true) {
          // close dialog
          this.element.addClass("cf-detailspanel-closed");
          if (this.options.adaptPageContent === true) {
            this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().removeClass("cf-pagecontent-detailspanel").removeClass("cf-pagecontent-detailspanel-large");
          }
        } else {
          // open dialog
          if (this.options.adaptPageContent === true) {
            var addClasses = "cf-pagecontent-detailspanel";
            if (this.options.widthFormat === "large") {
              addClasses += " cf-pagecontent-detailspanel-large";
            }
            this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().addClass(addClasses);
          }
        }
      } else {
        // open on creation
        if (this.options.adaptPageContent === true) {
          var addClasses = "cf-pagecontent-detailspanel";
          if (this.options.widthFormat === "large") {
            addClasses += " cf-pagecontent-detailspanel-large";
          }
          this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().addClass(addClasses);
        }
      }
      if (this.options.closeOnEscape === true) {
        this.element.attr("tabIndex", -1);
      }
      // variables
      this.originalFormValues = {};
      this.shouldButtonBarBeVisible;

      // draw skeleton
      this.element.append($("<h3>").addClass("cf-title-heading cf-detailspanel-title"));
      this.element.append($("<button>").attr("type", "button").addClass("cf-icon cf-icon-close detailspanel_closebutton cf-detailspanel-close").attr("aria-label", $.i18n._("nixps-cloudflow-dialog.close")));
      if (this.options.enableMaximize === true) {
        this.element.append($("<button>").attr("type", "button").addClass("cf-icon cf-icon-maximize detailspanel_maximizebutton cf-detailspanel-maximizebutton"));
      } else {
        this.element.append($("<button>").attr("type", "button").addClass("cf-icon cf-icon-maximize detailspanel_maximizebutton cf-detailspanel-maximizebutton").hide());
      }
      this.element.append($("<button>").attr("type", "button").addClass("cf-icon cf-icon-minimize detailspanel_minimizebutton cf-detailspanel-minimizebutton").hide());
      this.element.append($("<div>").addClass("detailspanel_image cf-detailspanel-thumb"));
      this.element.append($("<div>").addClass("detailspanel_imagelabel cf-detailspanel-thumblabel cf-title-subheading notranslate"));
      this.element.append($("<div>").addClass("detailspanel_content"));
      this.element.append($("<div>").addClass("detailspanel_buttonbar cf-buttonbar " + this.options.bottomBarClasses));
      this._draw();
      this._on(this.element, {
        "click .detailspanel_buttonbar [data-action=create]": this._createClickActionHandler,
        "click .detailspanel_buttonbar [data-action=edit]": this._editClickActionHandler,
        "click .detailspanel_buttonbar [data-action=save]": this._saveClickActionHandler,
        "click .detailspanel_buttonbar [data-action=cancel]": this._cancelClickActionHandler,
        "custompagebuilderclosecontainer": this._closePageBuilderEventHandler,
        "formrendererchange": this._formChangeHandler,
        "keydown": this._keyDownHandler
      });

      //pass true first since disabled detailspanels won't be able to closed / maximized / minimized
      this._on(true, this.element, {
        "click .detailspanel_closebutton": this._closeClickHandler,
        "click .detailspanel_maximizebutton": this._maximizeClickHandler,
        "click .detailspanel_minimizebutton": this._minimizeClickHandler
      });
      this._bindInfoToggleEvent();
    },
    /**
     * @description Function runs when user click on the close button
     * @function 
     * @name nixps-cloudflow.DetailsPanel#_closeClickHandler
     * @private
     * @param {Object} pEvent
     * @param {Object} pData
     * @return {undefined}
     */
    _closeClickHandler: function _closeClickHandler(pEvent, pData) {
      this.close();
    },
    /**
     * @description Function runs when user click on the maximize button
     * @function 
     * @name nixps-cloudflow.DetailsPanel#_maximizeClickHandler
     * @private
     * @param {Object} pEvent
     * @param {Object} pData
     * @return {undefined}
     */
    _maximizeClickHandler: function _maximizeClickHandler(pEvent, pData) {
      this.element.find(".cf-detailspanel-maximizebutton").hide();
      this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().removeClass("cf-pagecontent-detailspanel-large").addClass("cf-pagecontent-detailspanel-maximize");
      this.element.removeClass("cf-detailspanel-large");
      this.element.addClass("cf-detailspanel-maximize");
      this.element.find(".cf-detailspanel-minimizebutton").show();
    },
    /**
     * @description Function runs when user click on the minimize button
     * @function 
     * @name nixps-cloudflow.DetailsPanel#_minimizeClickHandler
     * @private
     * @param {Object} pEvent
     * @param {Object} pData
     * @return {undefined}
     */
    _minimizeClickHandler: function _minimizeClickHandler(pEvent, pData) {
      this.element.find(".cf-detailspanel-minimizebutton").hide();
      this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().removeClass("cf-pagecontent-detailspanel-maximize").addClass("cf-pagecontent-detailspanel-large");
      this.element.addClass("cf-detailspanel-large");
      this.element.removeClass("cf-detailspanel-maximize");
      this.element.find(".cf-detailspanel-maximizebutton").show();
    },
    /**
     * @description Function runs when user clicked on the create action button
     * @function
     * @name nixps-cloudflow.DetailsPanel#_createClickActionHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _createClickActionHandler: function _createClickActionHandler(pEvent, pData) {
      this._finalyseAction("createnew", {
        originalValues: this.originalFormValues
      });
    },
    /**
     * @description Function runs when user clicked on the create action button
     * @function
     * @name nixps-cloudflow.DetailsPanel#_createClickActionHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _editClickActionHandler: function _editClickActionHandler(pEvent, pData) {
      this._finalyseAction("edit", {
        originalValues: this.originalFormValues
      });
    },
    /**
     * @description Function runs when user clicked on the save action button
     * @function
     * @name nixps-cloudflow.DetailsPanel#_saveClickActionHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _saveClickActionHandler: function _saveClickActionHandler(pEvent, pData) {
      this._finalyseAction("save", {});
    },
    _finalyseAction: function _finalyseAction(pTriggerName, pTriggerData) {
      var values = this.getValue();
      this.disableButtonBar();
      if (this._trigger(pTriggerName, null, Object.assign(pTriggerData, {
        values: values
      })) !== false) {
        this.enableButtonBar();
        this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
        if (this.options.closeAfterDecision === true) {
          this.close();
        }
        if (this.screenToSmall === true) {
          // panel takes all space, close in all situations
          this.close();
        }
      }
    },
    /**
     * @description Function runs when user clicked on the cancel button
     * @function
     * @private
     * @name nixps-cloudflow.DetailsPanel#_cancelClickActionHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _cancelClickActionHandler: function _cancelClickActionHandler(pEvent, pData) {
      if (this._trigger("cancel", null, {}) !== false && this.options.closeAfterDecision === true) {
        this.close();
      }
      if (this.screenToSmall === true) {
        // panel takes all space, close in all situations
        this.close();
      }
    },
    /**
     * @description function runs when user added a custom trigger to close the dialog
     * @function
     * @name nixps-cloudflow.DetailsPanel#_closePageBuilderEventHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _closePageBuilderEventHandler: function _closePageBuilderEventHandler(pEvent, pData, pOriginalEvent) {
      this.close();
      pEvent.stopPropagation();
      pEvent.preventDefault();
      if (pOriginalEvent !== undefined && pOriginalEvent.stopPropagation !== undefined) {
        pOriginalEvent.stopPropagation();
      }
      return false;
    },
    /**
     * @description function runs when there is a change in the form
     * @function
     * @private
     * @name nixps-cloudflow.DetailsPanel#_formChangeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _formChangeHandler: function _formChangeHandler(pEvent, pData) {
      if (typeof this.options.title === "string" && this.options.title.length > 0) {
        this.element.find(".cf-detailspanel-title").addClass("cf-title-unsaved");
      }
    },
    /**
     * @description function runs when user does a key down
     * @function
     * @private
     * @name nixps-cloudflow.DetailsPanel#_keyDownHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     * @returns {undefined}
     */
    _keyDownHandler: function _keyDownHandler(pEvent, pData) {
      if (this.options.closeOnEscape === true && !pEvent.isDefaultPrevented() && pEvent.keyCode && pEvent.keyCode === $.ui.keyCode.ESCAPE) {
        pEvent.preventDefault();
        this.close();
        return;
      }
    },
    _submitCallBackHandler: function _submitCallBackHandler() {
      this.element.find(".detailspanel_buttonbar").find("[data-action=create], [data-action=edit], [data-action=save]").trigger("click");
      return false;
    },
    _bindInfoToggleEvent: function _bindInfoToggleEvent() {
      var that = this;
      if (that.isOpen() === true) {
        var topBar = this.element.closest(".cf-page, .cf-pageframe").find(".cf-topbar");
        if (topBar.is(".nixps-cloudflow-TopBar")) {
          // exists
          topBar.TopBar("setButtonState", "toggledetailspanel", true);
        } else {
          // topbar in making
          topBar.attr("data-buttonstate-toggledetailspanel", true);
        }
      }
    },
    /**
     * @description function runws when we are done drawing.
     * @fucntion
     * @private
     * @name nixps-cloudflow.DetailsPanel#_doneCreating
     */
    _doneCreating: function _doneCreating() {
      if (this.creating === true) {
        this.options.created.apply(this.options, arguments);
        this.creating = false;
      }
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.DetailsPanel#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      // adapt title
      this.element.children(".cf-detailspanel-title").empty().removeClass("cf-detailspanel-emptytitle");
      if (typeof this.options.title === "string" && this.options.title.length > 0) {
        this.element.children(".cf-detailspanel-title").text(this.options.title);
      }
      // image
      this._drawImage();
      this._drawLabel();
      // show hide close icon
      if (this.options.enableCloseButton === true) {
        this.element.children(".detailspanel_closebutton").css("display", "");
        // make sure the close button is visible
        if (this._hasTitleOrImage() === false) {
          this.element.children(".cf-detailspanel-title").addClass("cf-detailspanel-emptytitle"); // add empty header
        }
      } else {
        this.element.children(".detailspanel_closebutton").hide();
      }
      this.element.children(".detailspanel_content").empty();
      if (this.options.contentType === "customPageComponent") {
        if ($.isPlainObject(this.options.content) === false) {
          this.options.content = {};
        }
        var options = Object.assign({}, this.options.content, {
          "language": this.options.language,
          "relativeBasePath": this.options.relativeBasePath,
          "disabled": this.options.disabled
        });
        options.isInEditor = this.options.isInEditor;
        options.pageCSSSelector = this.element.attr("id") ? "#" + this.element.attr("id") + " > .detailspanel_content.nixps-pagebuilder-CustomPageComponent" : null, options.created = this._doneCreating.bind(this);
        this.element.children(".detailspanel_content").CustomPageComponent(options);
      } else if (this.options.contentType === "form") {
        if ($.isPlainObject(this.options.content) === false) {
          throw new Error("The option content must be a plain object for formrenderer");
        }
        var options = Object.assign({
          "variableDictionary": {}
        }, this.options.content, {
          "language": this.options.language,
          "relativeBasePath": this.options.relativeBasePath,
          "formClasses": this.options.formClasses,
          "submitCallBackFunction": this._submitCallBackHandler.bind(this),
          "disabled": this.options.disabled
        });
        options.variableDictionary = Object.assign(options.variableDictionary, $.i18n.dict);
        this.element.children(".detailspanel_content").FormRenderer(options);
        this.originalFormValues = this.element.children(".detailspanel_content").FormRenderer("getValues");
        this._doneCreating();
      } else if (this.options.contentType === "custom") {
        // developer can make add his own content
        this._doneCreating();
      }
      // button bars
      this.element.children(".detailspanel_buttonbar").empty();
      if (Array.isArray(this.options.bottomBarButtons) && this.options.bottomBarButtons.length > 0) {
        var defaultButtonOptions = {
          "language": this.options.language,
          "relativeBasePath": this.options.relativeBasePath
        };
        for (var i = 0; i < this.options.bottomBarButtons.length; i++) {
          this.element.children(".detailspanel_buttonbar").append($("<span>").CloudflowButton(Object.assign({}, defaultButtonOptions, this.options.bottomBarButtons[i])));
        }
        if (this.options.hideBottomBarButtonsOnDisable === true) {
          if (this.options.disabled === true) {
            this.hideButtonBar();
            this.shouldButtonBarBeVisible = true;
          } else {
            this.shouldButtonBarBeVisible = false;
          }
        } else {
          if (this.options.disabled === true) {
            this.disableButtonBar();
          }
        }
      }
    },
    /**
     * @description draw the image
     * @function
     * @private
     * @name nixps-cloudflow.DetailsPanel#_drawImage
     * @returns {undefined}
     */
    _drawImage: function _drawImage() {
      // image
      if (typeof this.options.imageURL === "string" && this.options.imageURL.length > 0) {
        if (this.element.children(".detailspanel_image").children(".nixps-cloudflow-Image").length > 0) {
          this.element.children(".detailspanel_image").children(".nixps-cloudflow-Image").Image({
            "url": this.options.imageURL,
            "relativeBasePath": this.options.relativeBasePath
          });
        } else {
          var img = $('<div>').Image({
            "url": this.options.imageURL,
            "relativeBasePath": this.options.relativeBasePath,
            "width": "auto",
            "height": "auto",
            "maxWidth": this.options.imageDimensions,
            "maxHeight": this.options.imageDimensions,
            "objectFit": "contain"
          });
          this.element.children(".detailspanel_image").empty().append(img);
        }
      } else if (typeof this.options.imageIcon === "string" && this.options.imageIcon.length > 0) {
        this.element.children(".detailspanel_image").empty().append($('<span>').addClass(this.options.imageIcon));
      } else {
        this.element.children(".detailspanel_image").empty();
      }
    },
    _drawLabel: function _drawLabel() {
      // label
      this.element.children(".detailspanel_imagelabel").empty();
      if (typeof this.options.imageLabel === "string" && this.options.imageLabel.length > 0) {
        this.element.children(".detailspanel_imagelabel").text(this.options.imageLabel);
      }
    },
    _hasTitleOrImage: function _hasTitleOrImage() {
      if (typeof this.options.title === "string" && this.options.title.length > 0) {
        return true;
      }
      if (typeof this.options.imageURL === "string" && this.options.imageURL.length > 0) {
        return true;
      } else if (typeof this.options.imageIcon === "string" && this.options.imageIcon.length > 0) {
        return true;
      }
      if (typeof this.options.imageLabel === "string" && this.options.imageLabel.length > 0) {
        return true;
      }
      return false;
    },
    /**
     * @description Is the panel visible/open or not?
     * @function
     * @name nixps-cloudflow.DetailsPanel#isOpen
     * @returns {Boolean} true if the panel is visible false if the panel is hidden
     */
    isOpen: function isOpen() {
      return this.element.hasClass("cf-detailspanel-closed") === false;
    },
    /**
     * @description Toggle visibility of  the panel.
     * @function
     * @name nixps-cloudflow.DetailsPanel#toggle
     * @returns {undefined}
     */
    toggle: function toggle() {
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    },
    /**
     * @description Close or hide the panel.
     * @function
     * @name nixps-cloudflow.DetailsPanel#close
     * @returns {undefined}
     */
    close: function close() {
      if (this.isOpen()) {
        if (this._trigger("close", null, {}) !== false) {
          this.element.closest(".cf-page, .cf-pageframe").find(".cf-topbar").TopBar('setButtonState', 'toggledetailspanel', false);
          this.element.addClass("cf-detailspanel-closed");
          if (this.options.adaptPageContent === true) {
            this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().removeClass("cf-pagecontent-detailspanel").removeClass("cf-pagecontent-detailspanel-large");
          }
        }
      }
    },
    /**
     * @description Open or show the panel.
     * @function
     * @name nixps-cloudflow.DetailsPanel#open
     * @returns {undefined}
     */
    open: function open() {
      if (this.isOpen() === false) {
        if (this._trigger("open", null, {}) !== false) {
          this.element.closest(".cf-page, .cf-pageframe").find(".cf-topbar").TopBar('setButtonState', 'toggledetailspanel', true);
          this.element.css("display", "").removeClass("cf-detailspanel-closed");
          if (this.options.adaptPageContent === true) {
            var addClasses = "cf-pagecontent-detailspanel";
            if (this.element.hasClass("cf-detailspanel-large")) {
              addClasses += " cf-pagecontent-detailspanel-large";
            }
            this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().addClass(addClasses);
          }
        }
      }
    },
    getValue: function getValue() {
      if (this.options.contentType === "customPageComponent") {
        var contextConnector = this.element.children(".detailspanel_content").CustomPageComponent("option", "contextConnector");
        if (contextConnector === "object") {
          var contextKey = this.element.children(".detailspanel_content").CustomPageComponent("option", "contextKey");
          if ($.isPlainObject(contextKey)) {
            return contextKey;
          }
        }
      }
      var form = this.element.find(".nixps-cloudflow-FormRenderer").first();
      if (form.length === 1) {
        return form.FormRenderer("getValues");
      }
      return null;
    },
    setValue: function setValue(pValues, pFormVariables) {
      if (this._trigger("beforesetvalue", null, pValues, pFormVariables) !== false) {
        this.setValueReturnDeferred(pValues, pFormVariables);
      }
      return; // continues chaining jquery functions
    },

    setValueReturnDeferred: function setValueReturnDeferred(pValue, pFormVariables) {
      if ($.isPlainObject(pValue) === false) {
        // force to be an object
        pValue = {
          value: pValue
        };
      }
      // save original values to be able to clear afterwards
      this.originalFormValues = $.extend(true, {}, pValue);
      if (this.options.contentType === "customPageComponent") {
        return this.element.children(".detailspanel_content").CustomPageComponent("refresh", "object", "dummy", $.extend(true, {}, pValue), true, undefined, undefined);
      } else {
        var form = this.element.find(".nixps-cloudflow-FormRenderer").first().css("display", "");
        if (form.length === 1) {
          form.FormRenderer("reset");
          form.FormRenderer("setValues", pValue);
          form.find(":focus").trigger("blur");
          this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
        }
        if ($.isEmptyObject(pFormVariables) === false) {
          console.warn("form variables are not supported for plain forms");
        }
        return $.Deferred().resolve({});
      }
    },
    setValueWithContext: function setValueWithContext(pConnector, pCollection, pKey, pRootContext) {
      if (this.options.contentType === "customPageComponent") {
        return this.element.children(".detailspanel_content").CustomPageComponent("refresh", pConnector, pCollection, pKey, true, pRootContext, undefined);
      } else {
        console.error("setValueWithContext is not supported for other contentTypes then customPageComponent.");
      }
      return {};
    },
    /**
     * @description call this if multiple rows are selected, give all the data of select event as argument
     * @function
     * @name nixps-cloudflow.DetailsPanel#setMultipleValues
     * @param {Object} pValues 
     */
    setMultipleValues: function setMultipleValues(pValues, pFormVariables) {
      if (pValues !== undefined && Array.isArray(pValues.rowObjects)) {
        if (this.options.contentType === "form") {
          if (pValues.rowObjects.length === 0) {
            // zero 
            this.element.children(".detailspanel_content").hide();
            this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
            this.hideButtonBar();
          } else if (pValues.rowObjects.length === 1) {
            this.element.children(".detailspanel_content").css("display", "");
            if (Array.isArray(pValues.rowObjects) && pValues.rowObjects.length > 0) {
              this.setValue(pValues.rowObjects[0]);
            }
            this.showButtonBar();
          } else {
            // multiple
            this.element.children(".detailspanel_content").hide();
            this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
            this.hideButtonBar();
          }
        }
      }
    },
    runSubPageAction: function runSubPageAction(pID, pName, pInputParameters, pEvent, pData, pPreviousResults) {
      if (this.options.contentType === "customPageComponent") {
        return this.element.children(".detailspanel_content").CustomPageComponent("runSubPageAction", pID, pName, pInputParameters, pEvent, pData, pPreviousResults);
      } else {
        console.error("runSubPageAction is not supported for other contentTypes then customPageComponent.");
      }
      return {};
    },
    showButtonBar: function showButtonBar() {
      if (this.options.disabled === false) {
        this.element.children(".detailspanel_buttonbar").css("display", "");
      } else {
        this.shouldButtonBarBeVisible = true;
      }
    },
    hideButtonBar: function hideButtonBar() {
      this.element.children(".detailspanel_buttonbar").hide();
      this.shouldButtonBarBeVisible = false;
    },
    disableButtonBar: function disableButtonBar() {
      this.element.children(".detailspanel_buttonbar").find("button").prop("disabled", true);
    },
    enableButtonBar: function enableButtonBar() {
      this.element.children(".detailspanel_buttonbar").find("button").prop("disabled", false);
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.DetailsPanel#_setOptions
     */
    _setOptions: function _setOptions(options) {
      var that = this;
      var redraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          redraw = true;
        }
        ;
      });
      this._controlOptions();
      if (redraw === true) {
        this.element.children(".detailspanel_content").filter(".nixps-pagebuilder-CustomPageComponent").CustomPageComponent("destroy");
        this.element.children(".detailspanel_content").filter(".nixps-cloudflow-FormRenderer").FormRenderer("destroy");
        this._draw();
      } else {
        if (this.options.enableCloseButton === true && options.title !== undefined) {
          // make sure the close button is visible
          if (this._hasTitleOrImage() === false) {
            this.element.children(".cf-detailspanel-title").addClass("cf-detailspanel-emptytitle"); // add empty header
          }
        }
      }
    },

    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "language") {
        // language can not change during a session
        this._superApply(arguments);
        return;
      }
      if (pKey === "openOnCreation") {
        // has no impact durring live
        this._superApply(arguments);
        return;
      }
      if (pKey === "HTMLPageJSON") {
        // ignore
        this._superApply(arguments);
        return;
      }
      if (pKey === "hideBottomBarButtonsOnDisable") {
        // ignore
        this._superApply(arguments);
        return;
      }
      if (pKey === "title") {
        if (pValue !== this.options.title) {
          this._superApply(arguments);
          this._controlOptions();
          this.element.children(".cf-detailspanel-title").empty().removeClass("cf-detailspanel-emptytitle");
          if (typeof this.options.title === "string" && this.options.title.length > 0) {
            this.element.children(".cf-detailspanel-title").text(this.options.title);
          }
          // make sure the close button is visible
          if (this.options.enableCloseButton === true && this._hasTitleOrImage() === false) {
            this.element.children(".cf-detailspanel-title").addClass("cf-detailspanel-emptytitle"); // add empty header
          }
        }

        return;
      }
      if (pKey === "relativeBasePath") {
        if (pValue !== this.options.relativeBasePath) {
          // change redraw
          this._superApply(arguments);
          this._controlOptions();
          return true;
        } else {
          // no change
          this._superApply(arguments);
          this._controlOptions();
          return;
        }
      }
      if (pKey === "enableCloseButton") {
        if (pValue !== this.options.enableCloseButton) {
          this._superApply(arguments);
          this._controlOptions();
          if (this.options.enableCloseButton === true) {
            this.element.children(".detailspanel_closebutton").css("display", "");
            // make sure the close button is visible
            if (this._hasTitleOrImage() === false) {
              this.element.children(".cf-detailspanel-title").addClass("cf-detailspanel-emptytitle"); // add empty header
            }
          } else {
            this.element.children(".detailspanel_closebutton").hide();
            this.element.children(".cf-detailspanel-title").removeClass("cf-detailspanel-emptytitle");
          }
        }
        return;
      }
      if (pKey === "imageURL") {
        if (pValue !== this.options.imageURL) {
          this._superApply(arguments);
          this._controlOptions();
          this._drawImage();
        }
        return;
      }
      if (pKey === "imageIcon") {
        if (pValue !== this.options.imageIcon) {
          this._superApply(arguments);
          this._controlOptions();
          this._drawImage();
        }
        return;
      }
      if (pKey === "imageLabel") {
        if (pValue !== this.options.imageLabel) {
          this._superApply(arguments);
          this._controlOptions();
          this._drawLabel();
        } else {
          this._superApply(arguments);
        }
        return;
      }
      if (pKey === "contentType") {
        if (pValue !== this.options.contentType) {
          // redraw anyway
          if (this.options.contentType === "customPageComponent") {
            // remove old
            this.element.children(".detailspanel_content").filter(".nixps-pagebuilder-CustomPageComponent").CustomPageComponent("destroy");
          } else if (this.options.contentType === "form") {
            this.element.children(".detailspanel_content").filter(".nixps-cloudflow-FormRenderer").FormRenderer("destroy");
          }
          this._superApply(arguments);
          this._controlOptions();
          return true;
        } else {
          this._superApply(arguments);
          return;
        }
      }
      if (pKey === "widthFormat") {
        if (this.options.widthFormat !== pValue) {
          this._superApply(arguments);
          this._controlOptions();
          if (this.options.widthFormat === "large") {
            this.element.addClass("cf-detailspanel-large");
            if (this.options.adaptPageContent === true) {
              this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().addClass("cf-pagecontent-detailspanel-large");
            }
          } else {
            this.element.removeClass("cf-detailspanel-large");
            if (this.options.adaptPageContent === true) {
              this.element.closest(".cf-page, .cf-pageframe").find(".cf-pagecontent").first().removeClass("cf-pagecontent-detailspanel-large");
            }
          }
        } else {
          this._superApply(arguments);
          this._controlOptions();
        }
        return;
      }
      if (pKey === "bottomBarButtons") {
        if (_.isEqual(pValue, this.options.bottomBarButtons) === false) {
          this._superApply(arguments);
          this.element.children(".detailspanel_buttonbar").empty();
          if (Array.isArray(this.options.bottomBarButtons) && this.options.bottomBarButtons.length > 0) {
            var defaultButtonOptions = {
              "language": this.options.language,
              "relativeBasePath": this.options.relativeBasePath
            };
            for (var i = 0; i < this.options.bottomBarButtons.length; i++) {
              this.element.children(".detailspanel_buttonbar").append($('<span>').CloudflowButton($.extend({}, defaultButtonOptions, this.options.bottomBarButtons[i])));
            }
          }
        }
        return;
      }
      if (pKey === "content") {
        if (_.isEqual(pValue, this.options.content) === true) {
          // no changes detected
          this._superApply(arguments);
        } else {
          this._superApply(arguments);
          if (this.options.contentType === "customPageComponent") {
            if ($.isPlainObject(this.options.content) === false) {
              this.options.content = {};
            }
            var options = Object.assign({}, this.options.content, {
              "language": this.options.language,
              "relativeBasePath": this.options.relativeBasePath,
              "isInEditor": this.options.isInEditor
            });
            this.element.children(".detailspanel_content").CustomPageComponent("option", options);
          } else if (this.options.contentType === "form") {
            this.originalFormValues = this.element.children(".detailspanel_content").FormRenderer("getValues");
            if ($.isPlainObject(this.options.content) === false) {
              throw new Error("The option contentType must be a plain object for formrenderer");
            }
            var options = Object.assign({}, this.options.content, {
              "language": this.options.language,
              "relativeBasePath": this.options.relativeBasePath,
              "formClasses": this.options.formClasses
            });
            if (options.variableDictionary) {
              options.variableDictionary = Object.assign(options.variableDictionary, $.i18n.dict);
            }
            this.element.children(".detailspanel_content").FormRenderer("option", options);
            if ($.isEmptyObject(this.originalFormValues) === false) {
              this.element.children(".detailspanel_content").FormRenderer("reset");
              this.element.children(".detailspanel_content").FormRenderer("setValues", this.originalFormValues);
            }
          } else if (this.options.contentType === "custom") {
            // developer can make add his own content
          }
        }
        return;
      }
      if (pKey === "disabled") {
        if (this.options.disabled !== pValue) {
          this._superApply(arguments);
          if (this.options.contentType === "customPageComponent") {
            this.element.children(".detailspanel_content").CustomPageComponent("option", "disabled", pValue);
          } else if (this.options.contentType === "form") {
            this.element.children(".detailspanel_content").FormRenderer("option", "disabled", pValue);
          } else if (this.options.contentType === "custom") {
            // ??
          }
          if (this.options.hideBottomBarButtonsOnDisable === true) {
            if (pValue === true) {
              // disabled
              this.hideButtonBar();
              this.shouldButtonBarBeVisible = true;
            } else if (this.shouldButtonBarBeVisible === true) {
              this.showButtonBar();
            }
          } else {
            if (pValue === true) {
              this.disableButtonBar();
            } else {
              this.enableButtonBar();
            }
          }
        }
        return;
      }
      if (pKey === "adaptPageContent" || pKey === "closeAfterDecision") {
        this._superApply(arguments);
        this._controlOptions();
        // this option is applied during redraw but only on methodes
        return;
      }
      if (pKey === "style_type") {
        if (this.options.style_type !== pValue) {
          this.element.removeClass("CloudflowStyle_" + this.options.style_type).addClass("CloudflowStyle_" + pValue);
        }
        this._superApply(arguments);
        return;
      }
      this._superApply(arguments);
      return true;
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.DetailsPanel#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.contentType !== "string" || this.options.contentType.length <= 0) {
        throw new Error("DetailsPanel: input option contentType must be a not empty string");
      }
      if (typeof this.options.enableCloseButton !== "boolean") {
        throw new Error("DetailsPanel: input option enableCloseButton must be a boolean");
      }
      if (typeof this.options.style_type !== "string") {
        throw new Error("DetailsPanel: input option style_type must be a string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("cf-detailspanel").removeClass("CloudflowStyle_" + this.options.style_type).removeAttr("data-widgetname");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js":282,"../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponent.js":419}],104:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 8 oktober 2019
 */
(function ($) {
  require("./nixps-cloudflow-DetailsPanel.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  function hasContentTypeMultipleForms(pType) {
    return pType === "createworkable" || pType === "staticform";
  }
  function manageContentTypeOwnButtons(pType) {
    return pType === "createworkable";
  }
  /**
   * @namespace nixps-cloudflow.FormDetailsPanel
   * @description Draw a Nebula right side panel with a form to edit the details of an item
   * @example $('<div>').FormDetailsPanel({
    * });
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.FormDetailsPanel", $["nixps-cloudflow"].DetailsPanel, {
    version: "1.0.0",
    widgetEventPrefix: "formdetailspanel",
    options: {
      /**
       * @description The language of the user
       * @name nixps-cloudflow.FormDetailsPanel#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @description The user object
       * @name nixps-cloudflow.FormDetailsPanel#user
       * @type {Object}
       * @default null
       */
      user: null,
      /**
       * @description The consent object
       * @name nixps-cloudflow.FormDetailsPanel#consent
       * @type {Object}
       * @default undefined
       */
      consent: undefined,
      /**
       * @description The name of the host
       * @name nixps-cloudflow.FormDetailsPanel#host
       * @type {String}
       * @default undefined
       */
      host: undefined,
      contentType: "form",
      bottomBarClasses: "cf-buttonbar-right cf-buttonbar-bottom",
      closeAfterDecision: true,
      disableBottomBarButtons: false,
      adaptPageContent: true,
      content: {
        labelBootstrapClass: "cf-col-sm-4",
        inputBootstrapClass: "cf-col-sm-8"
      },
      createProvider: undefined,
      editProvider: undefined,
      createworkable_options: {
        "language": "en",
        "user": "<user>",
        "whitepaper": undefined,
        "whitepaperInputName": undefined,
        "panels": undefined,
        "stickToBorders": true,
        "formClasses": "cf-form cf-form-details",
        "fileChooserContext": "pagebuilder_custompage",
        "newWorkableMessage": "",
        "resetFormAfterSubmit": false,
        "dummy_temp_uiaction_prefillFormValues": true,
        "dummy_temp_uiaction_mainFormVariables": false,
        "fileSelectionHeight": -1,
        "moveFileSectionToTop": false,
        "enableStickyButtons": false,
        "submitButtonClasses": "btn btn-primary cf-button-main",
        "enableCancelButton": true,
        "cancelButtonClasses": "btn btn-default cf-button-secondary",
        "relativeBasePath": "",
        "prefillFormValues": undefined,
        "prefillJobFormValues": undefined,
        "mainFormVariables": {},
        "jobFormVariables": {},
        "buttonbarClasses": "cf-buttonbar-right cf-buttonbar-bottom"
      },
      createworkable_update_options: {
        "language": "en",
        "user": "<user>",
        "whitepaper": undefined,
        "whitepaperInputName": undefined,
        "panels": undefined,
        "stickToBorders": true,
        "formClasses": "cf-form cf-form-details",
        "fileChooserContext": "pagebuilder_custompage",
        "newWorkableMessage": "",
        "resetFormAfterSubmit": false,
        "dummy_temp_uiaction_prefillFormValues": true,
        "dummy_temp_uiaction_mainFormVariables": false,
        "fileSelectionHeight": -1,
        "moveFileSectionToTop": false,
        "enableStickyButtons": false,
        "submitButtonClasses": "btn btn-primary cf-button-main",
        "enableCancelButton": true,
        "cancelButtonClasses": "btn btn-default cf-button-secondary",
        "relativeBasePath": "",
        "prefillFormValues": undefined,
        "prefillJobFormValues": undefined,
        "mainFormVariables": {},
        "jobFormVariables": {},
        "buttonbarClasses": "cf-buttonbar-right cf-buttonbar-bottom"
      },
      createworkable_updatemultiple_options: {
        "language": "en",
        "user": "<user>",
        "whitepaper": undefined,
        "whitepaperInputName": undefined,
        "panels": undefined,
        "stickToBorders": true,
        "formClasses": "cf-form cf-form-details",
        "fileChooserContext": "pagebuilder_custompage",
        "newWorkableMessage": "",
        "resetFormAfterSubmit": false,
        "dummy_temp_uiaction_prefillFormValues": true,
        "dummy_temp_uiaction_mainFormVariables": false,
        "fileSelectionHeight": -1,
        "moveFileSectionToTop": false,
        "enableStickyButtons": false,
        "submitButtonClasses": "btn btn-primary cf-button-main",
        "enableCancelButton": true,
        "cancelButtonClasses": "btn btn-default cf-button-secondary",
        "relativeBasePath": "",
        "prefillFormValues": undefined,
        "prefillJobFormValues": undefined,
        "mainFormVariables": {},
        "jobFormVariables": {},
        "buttonbarClasses": "cf-buttonbar-right cf-buttonbar-bottom"
      },
      created: function created() {}
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        bottomBarButtons: [{
          "classes": "cf-button-secondary",
          "label": $.i18n._("nixps-cloudflow-manage.generic-cancel"),
          "action": "cancel",
          "disabled": this.options.disableBottomBarButtons
        }, {
          "classes": "cf-button-main",
          "label": $.i18n._("nixps-cloudflow-manage.generic-save"),
          "action": "save",
          "disabled": this.options.disableBottomBarButtons
        }],
        createworkable_options: {
          cancelButtonText: $.i18n._("nixps-cloudflow-manage.generic-cancel"),
          submitButtonText: $.i18n._("nixps-cloudflow-manage.generic-save")
        }
      };
    },
    _create: function _create() {
      this.formDetailsPanelEndCreate = false;
      this.formDetailsPanelEndCreatedArg;
      this._newFormDOM = null;
      this._updateFormDOM = null;
      this._multipleUpdateFormDOM = null;
      this._currentFormDOM;
      if (this.options.contentType === "createworkable") {
        this.options.bottomBarButtons = [];
      }
      this._superApply(arguments);

      // variables
      this.originalTitle = this.options.title;
      this._noValues();
      this._on(this.element, {
        "createworkablesubmitted": this._submittedFormHandler,
        "createworkablecancelled": this._cancelledFormHandler,
        "change": function change(ev, data) {
          this._trigger("change", ev, this.getValue());
        }
      });
      this.formDetailsPanelEndCreate = true;
      if (this.formDetailsPanelEndCreatedArg !== undefined) {
        this.options.created.apply(this.options, this.formDetailsPanelEndCreatedArg);
      }
    },
    /**
     * @description Function runs when user clicked on the create action button
     * @function
     * @name nixps-cloudflow.DetailsPanel#_createClickActionHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _createClickActionHandler: function _createClickActionHandler(pEvent, pData) {
      if (this.options.contentType !== "createworkable" && typeof this.options.createProvider === "function") {
        var that = this;
        if (this.isValid() === true) {
          this.disableButtonBar();
          var values = this.getValue();
          $.when(this.options.createProvider({
            values: values,
            originalValues: this.originalFormValues
          })).done(function () {
            that.enableButtonBar();
            that.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
            if (that.options.closeAfterDecision === true) {
              that.close();
            }
          }).fail(function (pError) {
            that.enableButtonBar();
            if (pError !== undefined && pError !== null) {
              if (pError.error_type === "form_structured") {
                that.showErrorMessage(pError);
              } else if (typeof pError.error === "string" && pError.error.length > 0) {
                that.showErrorMessage(pError.error);
              }
            }
          });
        }
      } else {
        if (this.isValid() === true) {
          this._superApply(arguments);
        }
      }
    },
    /**
     * @description Function runs when user clicked on the create action button
     * @function
     * @name nixps-cloudflow.DetailsPanel#_createClickActionHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _editClickActionHandler: function _editClickActionHandler(pEvent, pData) {
      if (this.options.contentType !== "createworkable" && typeof this.options.editProvider === "function") {
        var that = this;
        if (this.isValid() === true) {
          this.disableButtonBar();
          var values = this.getValue();
          $.when(this.options.editProvider({
            values: values,
            originalValues: this.originalFormValues
          })).done(function () {
            that.enableButtonBar();
            that.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
            if (that.options.closeAfterDecision === true) {
              that.close();
            }
          }).fail(function (pError) {
            that.enableButtonBar();
            if (pError !== undefined && pError !== null) {
              if (pError.error_type === "form_structured") {
                that.showErrorMessage(pError);
              } else if (typeof pError.error === "string" && pError.error.length > 0) {
                that.showErrorMessage(pError.error);
              }
            }
          });
        }
      } else {
        if (this.isValid() === true) {
          this._superApply(arguments);
        }
      }
    },
    _saveClickActionHandler: function _saveClickActionHandler(pEvent, pData) {
      if (this.isValid() === true) {
        this._superApply(arguments);
      }
    },
    /**
     * @description Function runs when user clicked on the cancel button
     * @function
     * @private
     * @name nixps-cloudflow.FormDetailsPanel#_cancelClickActionHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _cancelClickActionHandler: function _cancelClickActionHandler(pEvent, pData) {
      this.clearForm();
      this._superApply(arguments);
    },
    _submittedFormHandler: function _submittedFormHandler(pEvent, pData) {
      if (this.options.contentType === "createworkable") {
        var that = this;
        this._currentFormDOM.CreateWorkable("waitUntilSubmitWorkflowIsDone", pData, true).done(function (pReturnData) {
          that.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
          var submitData = {
            workable: pData.workable,
            replyObject: pReturnData,
            editMode: that._getEditMode()
          };
          that._trigger("submitted", null, submitData);
        }).fail(function (pError) {
          if (pError !== undefined) {
            if (pError.error === "no_results" || pError.error_code === "no_results") {
              var submitData = {
                workable: pData.workable,
                editMode: that._getEditMode(),
                replyObject: undefined,
                error_code: "no_results"
              };
              that._trigger("submitted", null, submitData);
            }
          }
        });
      }
    },
    _cancelledFormHandler: function _cancelledFormHandler(pEvent, pData) {
      if (this.options.contentType === "createworkable") {
        this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
        this._trigger("cancel", null, pData);
      }
    },
    _doneCreating: function _doneCreating() {
      if (this.creating === true) {
        if (this.formDetailsPanelEndCreate === true) {
          this.options.created.apply(this.options, arguments);
          this.creating = false;
        } else {
          this.formDetailsPanelEndCreatedArg = arguments;
        }
      }
    },
    _draw: function _draw() {
      this._superApply(arguments);
      if (hasContentTypeMultipleForms(this.options.contentType)) {
        var componentName, optionsName, updateOptionsName, updateMultipleOptionsName;
        var defaultOptions = {
          "disabled": this.options.disabled,
          "variableDictionary": {}
        };
        var forceOptions = {
          "language": this.options.language,
          "relativeBasePath": this.options.relativeBasePath,
          "formClasses": this.options.formClasses,
          "user": this.options.user,
          "consent": this.options.consent,
          "host": this.options.host
        };
        var isValidOptions = function isValidOptions() {
          return true;
        };
        if (this.options.contentType === "createworkable") {
          componentName = "CreateWorkable";
          optionsName = "createworkable_options";
          updateOptionsName = "createworkable_update_options";
          updateMultipleOptionsName = "createworkable_updatemultiple_options";
          isValidOptions = function isValidOptions(pOptions) {
            return pOptions.whitepaper !== undefined && pOptions.whitepaperInputName !== undefined;
          };
        } else if (this.options.contentType === "staticform") {
          componentName = "FormRenderer";
          optionsName = "content";
          updateOptionsName = "update_content";
          updateMultipleOptionsName = "updatemultiple_content";
          isValidOptions = function isValidOptions(pOptions) {
            return $.isPlainObject(pOptions.formJSON);
          };
        }
        this._newFormDOM = null;
        this._updateFormDOM = null;
        this._multipleUpdateFormDOM = null;
        if (this.options[optionsName] !== undefined && isValidOptions(this.options[optionsName])) {
          var options = Object.assign({}, defaultOptions, this.options[optionsName], forceOptions);
          Object.assign(options.variableDictionary, $.i18n.dict);
          options.created = this._doneCreating.bind(this);
          this._newFormDOM = $("<div>").hide();
          this.element.children(".detailspanel_content").append(this._newFormDOM);
          this._newFormDOM[componentName](options);
        }
        if (this.options[updateOptionsName] !== undefined && isValidOptions(this.options[updateOptionsName])) {
          var options = Object.assign({}, defaultOptions, this.options[updateOptionsName], forceOptions);
          Object.assign(options.variableDictionary, $.i18n.dict);
          options.created = this._doneCreating.bind(this);
          this._updateFormDOM = $("<div>").hide();
          this.element.children(".detailspanel_content").append(this._updateFormDOM);
          this._updateFormDOM[componentName](options);
        }
        if (this.options[updateMultipleOptionsName] !== undefined && isValidOptions(this.options[updateMultipleOptionsName])) {
          var options = Object.assign({}, defaultOptions, this.options[updateMultipleOptionsName], forceOptions);
          Object.assign(options.variableDictionary, $.i18n.dict);
          options.created = this._doneCreating.bind(this);
          this._multipleUpdateFormDOM = $("<div>").hide();
          this.element.children(".detailspanel_content").append(this._multipleUpdateFormDOM);
          this._multipleUpdateFormDOM[componentName](options);
        }
        if (this._updateFormDOM === null && this._newFormDOM !== null) {
          this._updateFormDOM = this._newFormDOM;
        } else if (this._newFormDOM === null && this._updateFormDOM !== null) {
          this._newFormDOM = this._updateFormDOM;
        } else if (this._updateFormDOM === null && this._newFormDOM === null) {
          console.error("FormDetailsPanel: missing form");
        }
        this._currentFormDOM = this._newFormDOM;
      }
    },
    clearForm: function clearForm() {
      var form = this.element.find(".nixps-cloudflow-FormRenderer");
      if (form.length > 0 && $.isPlainObject(this.originalFormValues) && $.isEmptyObject(this.originalFormValues) === false) {
        form.FormRenderer("setValues", this.originalFormValues);
        form.find(":focus").trigger("blur");
        this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
      }
      this.hideErrorMessages();
    },
    /**
     * @description Show some error messages
     * @function
     * @name nixps-cloudflow.FormDetailsPanel#showErrorMessage
     * @param {String} pMessage The message to be displayed
     */
    showErrorMessage: function showErrorMessage(pMessage) {
      var form = this.element.find(".nixps-cloudflow-FormRenderer");
      if (form.length > 0) {
        form.FormRenderer("setValidationPhase", false);
        if ($.isPlainObject(pMessage)) {
          form.FormRenderer("showStructuredErrorMessages", pMessage);
        } else if (typeof pMessage === "string") {
          form.FormRenderer("showErrorMessages", [pMessage]);
        } else if (Array.isArray(pMessage)) {
          form.FormRenderer("showErrorMessages", pMessage);
        }
      } else {
        if (typeof pMessage === "string") {
          this.element.find(".nixps-cloudflow-ErrorMessage").first().ErrorMessage("showErrorMessage", pMessage);
        }
      }
    },
    /**
     * @description Hide error messages
     * @function
     * @name nixps-cloudflow.FormDetailsPanel#hideErrorMessages
     * @returns {undefined}
     */
    hideErrorMessages: function hideErrorMessages() {
      var form = this.element.find(".nixps-cloudflow-FormRenderer");
      if (form.length > 0) {
        form.FormRenderer("hideStructuredErrorMessages");
      }
      this.element.find(".nixps-cloudflow-ErrorMessage").first().ErrorMessage("hideErrorMessages");
    },
    _getEditMode: function _getEditMode() {
      if (this._newFormDOM !== null && this._newFormDOM.is(":visible")) {
        return "create_new";
      } else if (this._updateFormDOM !== null && this._updateFormDOM.is(":visible")) {
        return "single_update";
      } else if (this._multipleUpdateFormDOM !== null && this._multipleUpdateFormDOM.is(":visible")) {
        return "multiple_update";
      } else {
        return "unknown";
      }
    },
    /**
     * @description apply the is valid code and returns true if the elements are valid
     * @function
     * @name nixps-cloudflow.FormDetailsPanel#isValid
     * @returns {Boolean}
     */
    isValid: function isValid() {
      var form;
      if (this.options.contentType === "createworkable") {
        throw new Error("isValid is not supported in this setup");
      } else {
        form = this.element.find(".nixps-cloudflow-FormRenderer").first();
      }
      if (form.length === 1) {
        return form.FormRenderer("isValid");
      } else {
        return true;
      }
    },
    newValue: function newValue(pValues, pFormVariables) {
      if (pFormVariables === true) {
        pFormVariables = pValues;
      }
      if (hasContentTypeMultipleForms(this.options.contentType)) {
        this.element.children(".detailspanel_content").css("display", "");
        if (this._updateFormDOM !== null) {
          this._updateFormDOM.hide();
        }
        if (this._multipleUpdateFormDOM !== null) {
          this._multipleUpdateFormDOM.hide();
        }
        this._currentFormDOM = this._newFormDOM;
        var preFillValues = {};
        if ($.isPlainObject(pValues) && $.isEmptyObject(pValues) === false) {
          preFillValues = Object.assign({}, pValues);
        }
        var mainFormVariables = undefined,
          jobFormVariables = undefined;
        if ($.isPlainObject(pFormVariables)) {
          mainFormVariables = CloudflowObject.merge([{}, pFormVariables]);
          jobFormVariables = CloudflowObject.merge([{}, pFormVariables]);
        }
        if (this.options.contentType === "createworkable") {
          this._currentFormDOM.CreateWorkable("option", {
            "submitButtonText": $.i18n._("nixps-cloudflow-manage.generic-create"),
            "prefillFormValues": preFillValues,
            "prefillJobFormValues": preFillValues,
            "mainFormVariables": mainFormVariables,
            "jobFormVariables": jobFormVariables
          }).css("display", "");
        } else if (this.options.contentType === "staticform") {
          this._currentFormDOM.FormRenderer("reset");
          this._currentFormDOM.FormRenderer("setValues", pValues).css("display", "");
        }
        this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
      } else {
        this.setValueReturnDeferred(pValues, pFormVariables);
      }
      if (manageContentTypeOwnButtons(this.options.contentType) === false) {
        this.option("bottomBarButtons", [{
          "classes": "cf-button-secondary",
          "label": $.i18n._("nixps-cloudflow-manage.generic-cancel"),
          "action": "cancel",
          "disabled": this.options.disableBottomBarButtons
        }, {
          "classes": "cf-button-main",
          "label": $.i18n._("nixps-cloudflow-manage.generic-create"),
          "action": "create",
          "disabled": this.options.disableBottomBarButtons
        }]);
        this.showButtonBar();
        this.enableButtonBar();
      } else {
        this.hideButtonBar();
      }
      this.option({
        "title": $.i18n._("nixps-cloudflow-manage.generic-new") + " " + this.originalTitle,
        "imageIcon": "",
        "imageLabel": ""
      });
      return; // continues chaining jquery functions
    },

    /**
     * @description prefill the form with values
     * @function
     * @name nixps-cloudflow.FormDetailsPanel#setValue
     * @param {Object} pValue the value to be used to fill in fields
     * @param {Object} pFormVariables true or an object to be injected as form variables
     * @returns {undefined}
     */
    setValue: function setValue(pValue, pFormVariables) {
      if (pFormVariables === true) {
        pFormVariables = pValue;
      }
      this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
      if (hasContentTypeMultipleForms(this.options.contentType)) {
        if (this._newFormDOM !== null) {
          this._newFormDOM.hide();
        }
        if (this._multipleUpdateFormDOM !== null) {
          this._multipleUpdateFormDOM.hide();
        }
        if (this._updateFormDOM === null) {
          throw new Error("update Form does not exists");
        }
        this._currentFormDOM = this._updateFormDOM;
        if ($.isPlainObject(pValue) === false) {
          // force to be an object
          pValue = {
            value: pValue
          };
        }
        // save original values to be able to clear afterwards
        this.originalFormValues = $.extend(true, {}, pValue);
        var mainFormVariables = undefined,
          jobFormVariables = undefined;
        if ($.isPlainObject(pFormVariables) === false) {
          // force to be an object
          mainFormVariables = {
            value: pFormVariables
          };
          jobFormVariables = {
            value: pFormVariables
          };
        } else {
          mainFormVariables = CloudflowObject.merge([{}, pFormVariables]);
          jobFormVariables = CloudflowObject.merge([{}, pFormVariables]);
        }
        if (this.options.contentType === "createworkable") {
          this._currentFormDOM.CreateWorkable("option", {
            "submitButtonText": $.i18n._("nixps-cloudflow-FormDetailsPanel.button_edit"),
            "prefillFormValues": pValue,
            "prefillJobFormValues": pValue,
            "mainFormVariables": mainFormVariables,
            "jobFormVariables": jobFormVariables
          }).css("display", "");
        } else if (this.options.contentType === "staticform") {
          this._currentFormDOM.FormRenderer("reset");
          this._currentFormDOM.FormRenderer("setValues", pValue).css("display", "");
        }
      } else {
        this._superApply(arguments);
      }
      if (manageContentTypeOwnButtons(this.options.contentType) === false) {
        this.option("bottomBarButtons", [{
          "classes": "cf-button-secondary",
          "label": $.i18n._("nixps-cloudflow-manage.generic-cancel"),
          "action": "cancel",
          "disabled": this.options.disableBottomBarButtons
        }, {
          "classes": "cf-button-main",
          "label": $.i18n._("nixps-cloudflow-FormDetailsPanel.button_edit"),
          "action": "edit",
          "disabled": this.options.disableBottomBarButtons
        }]);
        this.showButtonBar();
        this.enableButtonBar();
      } else {
        this.hideButtonBar();
      }
      this.option({
        "title": $.i18n._("nixps-cloudflow-FormDetailsPanel.button_edit") + " " + this.originalTitle,
        "imageIcon": "",
        "imageLabel": ""
      });
    },
    /**
     * @description set no, one or multiple objects as editable in the form
     * @function
     * @name nixps-cloudflow.FormDetailsPanel#setMultipleValues
     * @param {Object} pValues 
     * @param {Boolean|Object} pFormVariables true or object to be injected as form variables
     * @returns {undefined}
     */
    setMultipleValues: function setMultipleValues(pValues, pFormVariables) {
      this.option("title", this.originalTitle);
      var inputs = {
        // default is empty value
        ids: [],
        rowObjects: []
      };
      if ($.isPlainObject(pValues)) {
        if (pValues.ids === undefined && pValues.rowObjects === undefined && pValues.rowObject === undefined) {
          // a plain mongodb object is presented, transform it 
          // make deep copy, 
          // parameter "ids" will be filled in later
          inputs.rowObjects = [$.extend(true, {}, pValues)];
        } else {
          // make deep copy, do not change outside world
          inputs = $.extend(true, {}, inputs, pValues);
        }
      } else if (Array.isArray(pValues)) {
        // direclty the rowObjects
        inputs.rowObjects = $.extend(true, [], pValues);
        for (var i = 0; i < inputs.rowObjects.length; i++) {
          inputs.ids.push(inputs.rowObjects[i]._id || inputs.rowObjects[i].id || inputs.rowObjects[i].ID);
        }
      }
      // transform single object to multiple
      if (inputs.ids.length === 0 && (inputs.id || inputs._id || inputs.ID) !== undefined) {
        inputs.ids = [inputs.id || inputs._id || inputs.ID];
      }
      if (inputs.rowObjects.length === 0 && inputs.rowObject !== undefined) {
        inputs.rowObjects = [inputs.rowObject];
      }
      if (Array.isArray(inputs.rowObjects)) {
        // add missing ids
        if (Array.isArray(inputs.ids) === false || inputs.ids.length < inputs.rowObjects.length) {
          inputs.ids = $.makeArray(inputs.ids);
          for (var i = 0; i < inputs.rowObjects.length; i++) {
            if (inputs.ids[i] === undefined) {
              inputs.ids[i] = inputs.rowObjects[i]._id || inputs.rowObjects[i].id || inputs.rowObjects[i].ID;
            }
          }
        } else if (inputs.ids.length > inputs.rowObjects.length) {
          // cutoff all unneeded data
          inputs.ids.splice(inputs.rowObjects.length);
        }
      }
      if (inputs.rowObjects.length === 0) {
        this._noValues();
      } else if (inputs.rowObjects.length === 1) {
        this.element.children(".detailspanel_content").css("display", "");
        if (Array.isArray(inputs.rowObjects) && inputs.rowObjects.length > 0) {
          this.setValue(inputs.rowObjects[0], pFormVariables);
        }
      } else {
        // multiple
        this._multipleValues(inputs, pFormVariables);
      }
    },
    _noValues: function _noValues() {
      this.originalFormValues = {};
      this.element.children(".detailspanel_content").hide();
      this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
      this.option({
        "imageIcon": "cf-icon cf-icon-5x cf-icon-check-square",
        "imageLabel": $.i18n._("nixps-cloudflow-FormDetailsPanel.select_one_item")
      });
      this.hideButtonBar();
      this.enableButtonBar();
    },
    _multipleValues: function _multipleValues(pInputs, pFormVariables) {
      if (pFormVariables === true) {
        pFormVariables = pInputs;
      }
      this.element.find(".cf-detailspanel-title").removeClass("cf-title-unsaved");
      if (hasContentTypeMultipleForms(this.options.contentType) && this._multipleUpdateFormDOM !== null) {
        /** @todo to be tested */
        this.element.children(".detailspanel_content").css("display", "");
        if (this._newFormDOM !== null) {
          this._newFormDOM.hide();
        }
        if (this._updateFormDOM !== null) {
          this._updateFormDOM.hide();
        }
        this._currentFormDOM = this._multipleUpdateFormDOM;
        var values = $.extend.apply($, pInputs.rowObjects);
        var mainFormVariables = undefined,
          jobFormVariables = undefined;
        if ($.isPlainObject(pFormVariables) === false) {
          // force to be an object
          mainFormVariables = {
            value: pFormVariables
          };
          jobFormVariables = {
            value: pFormVariables
          };
        } else {
          mainFormVariables = CloudflowObject.merge([{}, pFormVariables]);
          jobFormVariables = CloudflowObject.merge([{}, pFormVariables]);
        }
        if (this.options.contentType === "createworkable") {
          this._currentFormDOM.CreateWorkable("option", {
            "submitButtonText": $.i18n._("nixps-cloudflow-FormDetailsPanel.button_edit"),
            "prefillFormValues": values,
            "prefillJobFormValues": values,
            "mainFormVariables": mainFormVariables,
            "jobFormVariables": jobFormVariables
          }).css("display", "");
        }
        this.option({
          "title": $.i18n._("nixps-cloudflow-FormDetailsPanel.button_edit") + " " + this.originalTitle,
          "imageIcon": "",
          "imageLabel": ""
        });
        this.showButtonBar();
        this.enableButtonBar();
      } else {
        this.element.children(".detailspanel_content").hide();
        this.option({
          "imageIcon": "",
          "imageLabel": ""
        });
        this.hideButtonBar();
        this.enableButtonBar();
      }
    },
    setTitle: function setTitle(pTitle) {
      if (typeof pTitle === "string") {
        this.originalTitle = pTitle;
        this.option("title", this.originalTitle);
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      var that = this;
      var returnObject = this._superApply(arguments);
      if (pKey === "disabled") {
        if (this.options.contentType === "createworkable" || this.options.contentType === "staticform") {
          var componentName, componentClass;
          if (this.options.contentType === "createworkable") {
            componentName = "CreateWorkable";
            componentClass = ".nixps-kiosk-CreateWorkable";
          } else if (this.options.contentType === "staticform") {
            componentName = "FormRenderer";
            componentClass = ".nixps-cloudflow-FormRenderer";
          }
          [this._newFormDOM, this._multipleUpdateFormDOM, this._updateFormDOM, this._currentFormDOM].forEach(function (pElem) {
            if (pElem !== null) {
              pElem.filter(componentClass)[componentName](that.options.disabled ? "disable" : "enable");
            }
          });
        }
      }
      if (returnObject === true) {
        return true;
      }
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"./nixps-cloudflow-DetailsPanel.js":103}],105:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/
/*globals $, _, jsPlumb, console, api_sync, window, api_async */
/**
 * @namespace nixps-cloudflow.DropDownMenu
 *
 * @description This component is a dropdown menu. All the nessasary information can you just add to the option Items.
 * @trows "itemclicked" when a item is clicked
 */
$.widget('nixps-cloudflow.DropDownMenu', {
  options: {
    /**
     * @description the list items of the dropdown
     * @name nixps-cloudflow.DropDownMenu#items
     * @type {Array}
     * @default items
     */
    items: [],
    /**
     * @name nixps-cloudflow.CloudflowBar#style_type
     * @description The type of style you want
     * @type {String}
     * @private
     */
    style_type: "default"
  },
  _create: function _create() {
    this._controlOptions();
    this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type);
    this.element.append($('<ul>').addClass('items noselect'));
    this._draw();
    this._on(this.element, {
      'click .item': this._itemClickedHandler
    });
  },
  _itemClickedHandler: function _itemClickedHandler(event) {
    var item = $(event.target);
    var itemData = item.data('item');
    if ($.isPlainObject(itemData.action) === true) {
      this._trigger('itemclicked', null, {
        action: itemData.action
      });
    }
    if (typeof itemData.url === 'string' && itemData.url.length > 0) {
      window.location = itemData.url;
    } else if (typeof itemData.new_url === 'string' && itemData.new_url.length > 0) {
      window.open(itemData.new_url, '_blank');
    }
  },
  _draw: function _draw() {
    var list = this.element.find('.items');
    list.empty();
    var items = this.options.items;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var classes = '';
      if (typeof item.classes === 'string') {
        classes = item.classes;
      }
      $('<li>').addClass('item').addClass(classes).data('item', item)._t(item.text).attr('title', $.i18n._(item.text)).appendTo(list);
    }
  },
  _setOption: function _setOption(key, value) {
    if (key === "items") {
      this._super(key, value);
      this._controlOptions();
      this._draw();
    } else if (key === "style_type" && value !== this.options.style_type) {
      this.element.removeClass("CloudflowStyle_" + this.options.style_type).addClass("CloudflowStyle_" + value);
      this._super(key, value);
      this._controlOptions();
    }
  },
  _controlOptions: function _controlOptions() {
    if (!Array.isArray(this.options.items)) {
      throw new Error('option items must be a array');
    }
  }
});

},{}],106:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 15 freb 2022
 */
(function ($) {
  var CloudflowURL = require("../../CloudflowUtil/js/CloudflowURL.js");
  var EditorUtil = require("../../CloudflowUtil/js/EditorUtil.js");
  var hyphensURLRegExp = new RegExp("[/]", "g");
  function hyphensURL(pURL) {
    if (typeof pURL === "string") {
      return pURL.replace(hyphensURLRegExp, "/&shy;");
    }
    return pURL;
  }

  /**
   * @namespace nixps-cloudflow.OpenEditorButton
   * @description A button to open the editor in cloudflow
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.OpenEditorButton", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "openeditorbutton",
    options: {
      /**
       * @description The icon classes, the class to be added to the link
       * @name nixps-cloudflow.OpenEditorButton#icon
       * @type {String}
       * @default "cf-icon cf-icon-pencil"
       */
      icon: "cf-icon cf-icon-pencil",
      /**
       * @description The icon classes added when the component is disabled
       * @name nixps-cloudflow.OpenEditorButton#disabledIcon
       * @type {String}
       * @default ""
       */
      disabledIcon: "",
      /**
       * @description The text to be added on the link
       * @name nixps-cloudflow.OpenEditorButton#label
       * @type {String}
       * @default ""
       */
      label: "",
      /**
       * @description Must we splite the name with slaches and hyphens?
       * @name nixps-cloudflow.OpenEditorButton#enableHyphens
       * @type {Boolean}
       * @default false
       */
      enableHyphens: false,
      /**
       * @description The target atrribute to added on the link DOM
       * @name nixps-cloudflow.OpenEditorButton#linkTarget
       * @type {String}
       * @default ""
       */
      linkTarget: "",
      /**
       * @description Is the page embedded or not?
       * @name nixps-cloudflow.OpenEditorButton#embedded
       * @type {Boolean}
       * @default false
       */
      embedded: false,
      /**
       * @description The name of the app
       * @name nixps-cloudflow.EditableButton#cfappName
       * @default null
       * @type {String}
       */
      cfappName: null,
      /**
       * @description The technical name of the parent editor
       * @name nixps-cloudflow.EditableButton#sender_contenttype
       * @type {String}
       * @default "webpage"
       */
      sender_contenttype: "webpage",
      /**
       * @description The url of the file we want to open
       * @name nixps-cloudflow.EditableButton#url
       * @type {String}
       * @default null
       */
      url: null,
      /**
       * @description The name of the whitepaper to open
       * @name nixps-cloudflow.EditableButton#whitepaperName
       * @type {String}
       * @default null
       */
      whitepaperName: null,
      /**
       * @description The name of the form to open
       * @name nixps-cloudflow.EditableButton#formName
       * @type {String}
       * @default null
       */
      formName: null,
      /**
       * @description The jacketID linked to the items we want to invistigate
       * @name nixps-cloudflow.EditableButton#jacketID
       * @type {String}
       * @default null
       */
      jacketID: null,
      /**
       * @description The workableID linked to the items we want to invistigate
       * @name nixps-cloudflow.EditableButton#workableID
       * @type {String}
       * @default null
       */
      workableID: null
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._draw();
      this._on(this.element, {
        "click .editbutton_icon": this._clickHandler
      });
    },
    _clickHandler: function _clickHandler(pEvent, pData) {
      if (this.options.embedded === true && window.top !== undefined && typeof window.top.postMessage === "function") {
        var postMessageData = this._getPostMessageData();
        if (postMessageData !== null) {
          window.top.postMessage(postMessageData, window.location.origin);
        }
      }
    },
    _draw: function _draw() {
      this.element.empty();
      var button;
      if (this.options.embedded === true) {
        button = $("<span>");
      } else {
        button = $("<a>").attr("href", this._getEditURL()).attr("target", this.options.linkTarget);
      }
      button.addClass("editbutton_icon " + this.options.icon);
      if (this.options.enableHyphens === true) {
        button.addClass("cf-hyphens-auto").html(hyphensURL(decodeURI(this.options.label)));
      } else {
        button.text(this.options.label);
      }
      this.element.append(button);
      if (this.options.url === null && this.options.whitepaperName === null && this.options.formName === null && this.options.jacketID === null && this.options.workableID === null) {
        this._disable();
      }
    },
    _getEditURL: function _getEditURL() {
      var url = "";
      var parameters = {};
      if (typeof this.options.cfappName === "string" && this.options.cfappName.length > 0) {
        parameters["cfappName"] = this.options.cfappName;
      }
      if (typeof this.options.url === "string") {
        url = "";
        if (this.options.url.length > 0) {
          url += this.options.url;
        } else {
          // url is PP_FILE_STORE, lets propose the creating of new file
          url += "cloudflow://PP_FILE_STORE/";
        }
        return EditorUtil.getEditorURL("pagebuilder", url, "nebula", parameters);
      } else if (typeof this.options.whitepaperName === "string") {
        url = "/portal.cgi?quantum";
        if (this.options.whitepaperName.length > 0) {
          url += "&whitepaperName=" + encodeURIComponent(this.options.whitepaperName);
        }
        if (typeof this.options.jacketID === "string" && this.options.jacketID.length > 0) {
          url += "&jacketId=" + encodeURIComponent(this.options.jacketID);
        }
        if (typeof this.options.workableID === "string" && this.options.workableID.length > 0) {
          url += "&workableId=" + encodeURIComponent(this.options.workableID);
        }
        if (typeof this.options.nodeID === "string" && this.options.nodeID.length > 0) {
          url += "&nodeId=" + encodeURIComponent(this.options.nodeID);
        }
      } else if (typeof this.options.formName === "string") {
        url = "/portal.cgi?form=editor";
        if (this.options.formName.length > 0) {
          url += "&formname=" + encodeURIComponent(this.options.formName);
        }
      } else if (typeof this.options.jacketID === "string" || typeof this.options.workableID === "string") {
        url = "/portal.cgi?quantum";
        if (typeof this.options.jacketID === "string" && this.options.jacketID.length > 0) {
          url += "&jacketId=" + encodeURIComponent(this.options.jacketID);
        }
        if (typeof this.options.workableID === "string" && this.options.workableID.length > 0) {
          url += "&workableId=" + encodeURIComponent(this.options.workableID);
        }
        if (typeof this.options.nodeID === "string" && this.options.nodeID.length > 0) {
          url += "&nodeId=" + encodeURIComponent(this.options.nodeID);
        }
      }
      if (typeof this.options.cfappName === "string" && this.options.cfappName.length > 0) {
        url += "&cfappName=" + encodeURIComponent(this.options.cfappName);
      }
      return url;
    },
    _getPostMessageData: function _getPostMessageData() {
      var data = {
        "action": "newtab",
        "data": {},
        "resource": null,
        "sender_contenttype": this.options.sender_contenttype
      };
      if (typeof this.options.url === "string" && this.options.url.length > 0) {
        var url = this.options.url;
        if (url.indexOf("?") > 0) {
          url = url.substring(0, url.indexOf("?"));
        }
        data.data = {
          "type": "webpage",
          "resource": url
        };
      } else if (typeof this.options.whitepaperName === "string" && this.options.whitepaperName.length > 0) {
        data.data = {
          "type": "whitepaper",
          "resource": this.options.whitepaperName,
          "url_parameters": {}
        };
        if (typeof this.options.jacketID === "string" && this.options.jacketID.length > 0) {
          data.data.url_parameters.jacketId = this.options.jacketID;
        }
        if (typeof this.options.workableID === "string" && this.options.workableID.length > 0) {
          data.data.url_parameters.workableId = this.options.workableID;
        }
        if (typeof this.options.nodeID === "string" && this.options.nodeID.length > 0) {
          data.data.url_parameters.nodeId = this.options.nodeID;
        }
      } else if (typeof this.options.formName === "string" && this.options.formName.length > 0) {
        data.data = {
          "type": "form",
          "resource": this.options.formName
        };
      } else {
        return null;
      }
      return data;
    },
    _enable: function _enable() {
      this.element.find("a").attr("href", this._getEditURL());
      this.element.find(".editbutton_icon").removeClass(this.options.disabledIcon);
    },
    _disable: function _disable() {
      this.element.find("a").attr("href", "javascript:void(0)");
      this.element.find(".editbutton_icon").addClass(this.options.disabledIcon);
    },
    _setOptions: function _setOptions(options) {
      this._super(options);
      this._draw();
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this._super();
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowURL.js":80,"../../CloudflowUtil/js/EditorUtil.js":85}],107:[function(require,module,exports){
"use strict";

var EntityComposer = require('./EntityComposer.js');
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
function guid() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

/**
 * @brief this object represents a building block in the expression builder
 * A building block is a provider P and an array of modifiers M
 */
var BuildingBlock = function BuildingBlock(pProvider, pTransformers) {
  if (!(pProvider instanceof EntityComposer)) {
    if (!pProvider && !pProvider.constructor && pProvider.constructor.name !== "EntityComposer") {
      throw new Error('BuildingBlock: constructor: provider is not an entity composer');
    }
  }
  if (Array.isArray(pTransformers) === false) {
    throw new Error('BuildingBlock: constructor: transformers is not an array');
  }
  for (var i = 0; i < pTransformers.length; i++) {
    var transformer = pTransformers[i];
    if (transformer instanceof EntityComposer === false) {
      throw new Error('BuildingBlock: constructor: invalid transformer passed');
    }
  }
  this.id = guid();
  this.provider = pProvider;
  this.transformers = pTransformers;
};
BuildingBlock.prototype = {
  constructor: BuildingBlock,
  /** 
   * @brief returns the entity composer id
   */
  getID: function getID() {
    return this.id;
  },
  /**
   * @brief returns the type
   * @return {string} type of provider
   */
  getProviderType: function getProviderType() {
    return this.provider.getType();
  },
  /**
   * @brief returns the tyep of the output,
   * if there is only a provider, it is his type,
   * if there ara transformers it gives the type of the last of the upper transformer.
   * @returns {string} output type example: "string, "array"
   */
  getOutputType: function getOutputType() {
    if (this.transformers.length === 0) {
      return this.provider.getDefinition().getOutputType();
    } else {
      var outputType = this.transformers[this.transformers.length - 1].getDefinition().getOutputType();
      if (outputType === "child") {
        return this.provider.getDefinition().getOutputType();
      }
      return outputType;
    }
  },
  /**
   * @brief returns the provider
   */
  getProvider: function getProvider() {
    return this.provider;
  },
  /**
   * @brief returns the transformers
   * @return {Array| ValueComposer} transformers
   */
  getTransformers: function getTransformers() {
    return this.transformers;
  },
  /**
   * @brief to add a transformer, 
   * if the inputvalue is not a valuecomposer, he throws a error.
   * @param {objet|ValueComposer} pValueComposer: tha valuecomposer to add.
   * @returns {nothing}
   */
  addTransformer: function addTransformer(pEntityComposer) {
    if (pEntityComposer instanceof EntityComposer === false) {
      throw new Error('BuildingBlock: addTransformer: inputvalue must be an entity composer');
    } else {
      this.transformers.push(pEntityComposer);
    }
  },
  /**
   * @brief sets the provider
   */
  setProvider: function setProvider(pEntityComposer) {
    if (pEntityComposer instanceof EntityComposer === false) {
      throw new Error('BuildingBlock: setTransformer: inputvalue must be an entity composer');
    } else {
      this.provider = pEntityComposer;
    }
  },
  /**
   * @brief set Transformers and remove the old ones
   */
  setTransformers: function setTransformers(pEntityComposers) {
    if (typeof pEntityComposers.length !== "number") {
      throw new Error('BuildingBlock: setTransformers: pEntityComposers can not be iterated');
    }
    this.transformers = [];
    var length = pEntityComposers.length;
    for (var i = 0; i < length; i++) {
      this.addTransformer(pEntityComposers[i]);
    }
  },
  /**
   * @brief returns the title for this node
   */
  getTitle: function getTitle() {
    var data = this.getProvider().getParameters();
    return this.provider.getDefinition().calculateTitle(this.getTransformers(), data);
  },
  /**
   * @description Make a deep copy of the building block
   * @function
   * @return {nixps.quantum.BuildingBlock}
   */
  clone: function clone(pApplyCustomDeepClone) {
    // first make copies of transformers
    var newTransformers = [];
    var oldTransformers = this.getTransformers();
    for (var i = 0; i < oldTransformers.length; i++) {
      newTransformers.push(oldTransformers[i].clone());
    }
    return new BuildingBlock(this.getProvider().clone(pApplyCustomDeepClone), newTransformers);
  },
  /**
   * @brief returns the json representation for that node
   */
  getJSON: function getJSON() {
    var outputJSON = [];
    var count = this.transformers.length;
    if (count === 0) {
      //if no transformers ther is only a provider
      return this.provider.toJSON();
    }
    var outputJSON = this.provider.toJSON()[0];
    // handle the other transformers
    for (var i = 0; i < count; i++) {
      var transformer = this.transformers[i];
      var inputField = transformer.getDefinition().getInputField();
      var previous = outputJSON;
      outputJSON = $.extend(true, {}, this.transformers[i].toJSON()[0]);
      outputJSON[inputField] = [previous];
    }
    return [outputJSON];
  }
};
module.exports = BuildingBlock;

},{"./EntityComposer.js":109}],108:[function(require,module,exports){
"use strict";

/**
 * @brief this container contains buildingblocks that are in use!
 * @type {Object}
 * @default {}
 * @static
 * @private
 */
var bookshelf = {};

/**
 * @class BuilingBlockStock
 * @description Save data globaly to retieve later.
 * @version 1.0.0
 */
var BuildingBlockStock = function BuildingBlockStock() {};
BuildingBlockStock.prototype = {
  constructor: BuildingBlockStock,
  /** 
   * @brief add a item to the list
   * if already exist then it overwrites it
   * @function
   * @param {pID} (String) The id of the item
   * @param {pValue} The value to be saved  
   * @name BuildingBlockStock.addItem
   */
  addItem: function addItem(pID, pValue) {
    bookshelf[pID] = pValue;
  },
  /** 
   * @brief Remove a item
   * @function
   * @param {String} Id of the element to remove
   * @name BuildingBlockStock.removeItem
   */
  removeItem: function removeItem(pID) {
    delete bookshelf[pID];
  },
  /**
   * @brief Get the specific element with pID
   * @function
   * @name BuildingBlockStock.getItem
   * @param {String} pID
   * @returns {pValue}
   */
  getItem: function getItem(pID) {
    return bookshelf[pID];
  }
};
module.exports = BuildingBlockStock;

},{}],109:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
var EntityComposerDefinition = require("./EntityComposerDefinition.js");
var EntityComposer = function EntityComposer(pValue, pDefinition) {
  var value = pValue;
  var definition = pDefinition;
  if (definition instanceof EntityComposerDefinition === false) {
    throw new Error("EntityComposer.constructor: invalid entity composer \"definition\"");
  }
  if (!(value && typeof value.type === "string" && value.type.length > 0)) {
    /* franckhack */
    // fallback to support more
    // if pValue is not correct, the value can be from a default Values array 
    // make than a correct "value"
    if (value.parameters && _typeof(value.parameters) === "object" && value.parameters.constructor && value.parameters.constructor.name === "Object") {
      value = pValue.parameters;
      value.type = pDefinition.getID(); //ex. nixp.quantum.sdsd.0
    } else {
      throw new Error("EntityComposer.constructor: invalid \"pValue\" composer");
    }
  }
  this.mDefinition = definition;
  this.mJSON = value;
};
EntityComposer.fromDefinition = function (pDefinition) {
  if (!(pDefinition instanceof EntityComposerDefinition)) {
    throw new Error("EntityComposer.fromDefinition: expecting value definition");
  }
  var instance = Object.assign({
    type: pDefinition.getID()
  }, pDefinition.getDefaultParameters());
  return new EntityComposer(instance);
};
EntityComposer.prototype = {
  constructor: EntityComposer,
  /**
   * @brief get the id of the definition
   * @returns {String}
   */
  getID: function getID() {
    return this.mDefinition.getID();
  },
  /**
   * @brief returns the category of the definition
   * @returns {String}
   */
  getCategory: function getCategory() {
    return this.mDefinition.getCategory();
  },
  /**
   * @brief returns provider, transformer
   */
  getType: function getType() {
    return this.mDefinition.getType();
  },
  /**
   * @brief the value composer type
   */
  setType: function setType(pType) {
    if (typeof pType !== "string" || pType.length === 0) {
      throw new Error("EntityComposer.setType: invalid parameter");
    }
    this.mJSON.type = pType;
  },
  /**
   * @brief returns the definition associated with the composer
   */
  getDefinition: function getDefinition() {
    return this.mDefinition;
  },
  /**
   * @brief sets the parameter of the value composer
   */
  setParameter: function setParameter(pName, pValue) {
    if (!this.hasParameter(pName)) {
      throw new Error("EntityComposer.setParameter: no such parameter: " + pName);
    }
    if (pValue instanceof EntityComposer) {
      this.mJSON[pName] = pValue.toJSON();
    } else {
      this.mJSON[pName] = pValue;
    }
  },
  /**
   * @brief returns true if there is a parameter with that name
   */
  hasParameter: function hasParameter(pName) {
    return this.getAllParameterNames().indexOf(pName) >= 0;
  },
  /**
   * @brief returns an array with all the value composer parameters
   */
  getParameterNames: function getParameterNames() {
    return Object.keys(this.mJSON).filter(function (pKey) {
      return pKey !== "type";
    });
  },
  getAllParameterNames: function getAllParameterNames() {
    return Object.keys(this.mJSON);
  },
  /**
   * @brief returns the value for that parameter
   */
  getParameter: function getParameter(pName) {
    if (!this.hasParameter(pName)) {
      throw new Error("EntityComposer.getParameter: no such parameter: " + pName);
    }
    var value = this.mJSON[pName];
    return value;
  },
  /**
   * @brief gets all the parameters and there values
   * @returns {Object} all parameters
   */
  getParameters: function getParameters() {
    var parametersKeyValue = {};
    var keys = this.getParameterNames();
    for (var i = 0; i < keys.length; i++) {
      var keyName = keys[i];
      parametersKeyValue[keyName] = this.getParameter(keyName);
    }
    return parametersKeyValue;
  },
  /**
   * @brief get the json object with key values paires and try to 
   * set each key/value to the EntityComposer. Use the setParameter function.
   * @param {JSON|Object} pJSONKeyValue: a JSON object with the key values paires
   * @returns {nothing}
   */
  setParameters: function setParameters(pJSONKeyValue) {
    if (!pJSONKeyValue || _typeof(pJSONKeyValue) !== "object") {
      throw new Error("EntityComposer.setParameters: wrong input value");
    }
    this.mJSON = {
      type: this.mJSON.type
    };
    var json = this.mJSON;
    for (var key in pJSONKeyValue) {
      var value = pJSONKeyValue[key];
      if (key !== "type") {
        if (value instanceof EntityComposer) {
          json[key] = value.toJSON();
        } else {
          json[key] = value;
        }
      }
    }
    ;
  },
  /**
   * @description make a deep copy clone of it
   * @function
   * @return {nixps.quantum.EntityComposer}
   */
  clone: function clone(pApplyCustomDeepClone) {
    if (pApplyCustomDeepClone === true) {
      return new EntityComposer(this.mDefinition.applyDeepClone($.extend(true, {}, this.mJSON)), this.mDefinition.clone());
    }
    return new EntityComposer($.extend(true, {}, this.mJSON), this.mDefinition.clone());
  },
  adaptAfterDrop: function adaptAfterDrop(pBlocks) {
    var enviromentData = [];
    if (Array.isArray(pBlocks)) {
      // pBlock items contains functions
      enviromentData = $.extend(true, [], pBlocks);
    }
    this.mJSON = this.mDefinition.adaptAfterDrop($.extend(true, {}, this.mJSON), enviromentData);
  },
  getParameterType: function getParameterType() {
    if (typeof this.mJSON["type"] === "string") {
      return this.mJSON["type"];
    } else {
      return "";
    }
  },
  getSubObjectParameter: function getSubObjectParameter() {
    var keys = this.getAllParameterNames();
    for (var i = 0; i < keys.length; i++) {
      var keyName = keys[i];
      var value = this.getParameter(keyName);
      if (Array.isArray(value)) {
        return value;
      }
    }
    return null;
  },
  /**
   * @brief returns a json representation
   * @return {Object} "deep" copy of the value, json 
   */
  toJSON: function toJSON() {
    // copy and set inside an array
    return [CloudflowObject.merge([{}, this.mJSON])];
  }
};
module.exports = EntityComposer;

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"./EntityComposerDefinition.js":111}],110:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var EntityComposerDefinition = require("./EntityComposerDefinition.js");
var ValueComposer = require("./ValueComposer.js");

/**
 * @brief the collection of all Value composer definitions
 */
var EntityComposerCollection = function EntityComposerCollection(pEntityComposers) {
  this.entityComposers = [];
  if (pEntityComposers !== undefined) {
    if (!Array.isArray(pEntityComposers)) {
      throw new Error("EntityComposerCollection.constructor invalid parameter");
    }
    for (var i = 0; i < pEntityComposers.length; i++) {
      if (pEntityComposers[i] instanceof ValueComposer) {
        this.entityComposers.push(pEntityComposers[i]);
      } else if (pEntityComposers[i] && _typeof(pEntityComposers[i]) === "object" && pEntityComposers[i].constructor && pEntityComposers[i].constructor.name === "Object") {
        this.entityComposers.push(new EntityComposerDefinition(pEntityComposers[i]));
      } else {
        throw new Error("EntityComposerCollection.constructor ValueComposerCollection: invalid parameter, the " + i + "element");
      }
    }
  } else {
    throw new Error("EntityComposerCollection invalid parameter");
  }
};
EntityComposerCollection.prototype = {
  constructor: EntityComposerCollection,
  /**
   * @brief finds the definition given an id
   */
  _findDefinition: function _findDefinition(pEntityComposerID) {
    if (typeof pEntityComposerID !== "string" || pEntityComposerID.length === 0) {
      throw Error("EntityComposerCollection._findDefinition: invalid parameter");
    }
    var matchingEntities = this.entityComposers.filter(function (pDefinition) {
      return pDefinition.getID() === pEntityComposerID;
    });
    return matchingEntities;
  },
  /**
   * @brief find only one definition
   */
  _findOneDefinition: function _findOneDefinition(pEntityComposerID) {
    var matching = this._findDefinition(pEntityComposerID);
    if (matching.length === 0) {
      this._throwNotFound(pEntityComposerID);
    } else if (matching.length > 1) {
      this._throwTooMany(pEntityComposerID, matching.length);
    }
    return matching[0];
  },
  /**
   * @brief throws an error that the composer is not found
   */
  _throwNotFound: function _throwNotFound(pEntityComposerID) {
    throw new Error("EntityComposerCollection._throwNotFound: no definition found for: " + pEntityComposerID);
  },
  /**
   * @brief throws an error that the composer is not found
   */
  _throwTooMany: function _throwTooMany(pEntityComposerID, pAmount) {
    throw new Error("EntityComposerCollection._throwTooMany: too many (" + pAmount + ") found for: " + pEntityComposerID);
  },
  /**
   * @brief returns the size of the Value composer collection
   */
  getSize: function getSize() {
    return this.entityComposers.length;
  },
  /**
   * @brief returns true if there is a composer with that id
   */
  hasEntityComposer: function hasEntityComposer(pEntityComposerID) {
    var result = this._findDefinition(pEntityComposerID);
    return result.length > 0;
  },
  /**
   * @brief returns the Value composer given the collar id
   */
  getEntityComposer: function getEntityComposer(pEntityComposerID) {
    var matching = this._findOneDefinition(pEntityComposerID);
    return matching;
  },
  /**
   * @brief returns all the transformers
   */
  getAllTransformers: function getAllTransformers() {
    return this.entityComposers.filter(function (d) {
      return d.getType() === "transformer";
    });
  }
};
module.exports = EntityComposerCollection;

},{"./EntityComposerDefinition.js":111,"./ValueComposer.js":112}],111:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");

/** 
 * @brief represents a value composer definition, the definition is immutable
 */
var EntityComposerDefinition = function EntityComposerDefinition(pJSON) {
  if (!pJSON || _typeof(pJSON) !== "object" || pJSON.constructor && pJSON.constructor.name !== "Object") {
    throw new Error("EntityComposerDefinition.constructor: invalid parameter");
  }
  // pJSON contains functions
  this.mJSON = $.extend(true, {}, pJSON);
};
EntityComposerDefinition.prototype = {
  constructor: EntityComposerDefinition,
  /**
   * @description make a copy of it
   * @function
   * @return {EntityComposerDefinition}
   */
  clone: function clone() {
    // the json will be deep copied by the constructor
    return new EntityComposerDefinition(this.mJSON);
  },
  /**
   * @description apply specific code after deep copy 
   * @function
   * @param {Object} pData 
   * @returns {object}
   */
  applyDeepClone: function applyDeepClone(pData) {
    if (typeof this.mJSON.deepClone === "function") {
      return this.mJSON.deepClone(pData);
    }
    return pData;
  },
  adaptAfterDrop: function adaptAfterDrop(pData, pEnvironmentData) {
    if (typeof this.mJSON.adaptAfterDrop === "function" && pData && _typeof(pData) === "object" && pData.constructor.name === "Object") {
      return this.mJSON.adaptAfterDrop($.extend(true, {}, pData), pEnvironmentData);
    }
    return pData;
  },
  /** 
   * @brief returns the value composer id of identifier
   * @function
   */
  getID: function getID() {
    return this.mJSON.identifier;
  },
  /**
   * @brief returns the type of the composer
   * @function
   */
  getType: function getType() {
    return this.mJSON.type;
  },
  /** 
   * @brief returns the category of the value composer
   * @function
   */
  getCategory: function getCategory() {
    return this.mJSON.category;
  },
  /** 
   * @brief returns the default title
   * @function
   */
  getTitle: function getTitle() {
    return this.mJSON.name;
  },
  /**
   * @brief calculate the addapted title 
   * @param {Boolean} isTransformerActive
   * @param {Object} pData
   * @returns {String} the adapted title that change if content change
   */
  calculateTitle: function calculateTitle(pTransformers, pData) {
    var title = "";
    if (Array.isArray(pTransformers) && pTransformers.length > 0) {
      var titles = [];
      for (var i = 0; i < pTransformers.length; i++) {
        titles.push(pTransformers[i].getDefinition().mJSON.getTitle(pData, pTransformers[i].getParameters()));
      }
      titles = _.uniq(titles);
      for (var i = titles.length - 1; i >= 0; i--) {
        title += titles[i];
      }
    }
    title += this.mJSON.getTitle(pData);
    return title;
  },
  canApplyOn: function canApplyOn(pType) {
    if (this.getType() !== "transformer") {
      throw new Error("EntityComposerDefinition.canApplyOn: definition is not a transformer");
    }
    if (Array.isArray(this.mJSON.apply_on)) {
      return this.mJSON.apply_on.includes(pType);
    }
    return false;
  },
  /**
   * @brief returns the input field to plug the next value composer on
   */
  getInputField: function getInputField() {
    if (this.getType() !== "transformer") {
      throw new Error("EntityComposerDefinition.getInputField: definition is not a transformer");
    }
    return this.mJSON.input_field;
  },
  /**
   * @brief returns a copy of the default parameters
   */
  getDefaultParameters: function getDefaultParameters() {
    return structuredClone(this.mJSON.entity);
  },
  /**
   * @brief returns the default parameter, given a path
   */
  getDefaultParameter: function getDefaultParameter(pKey) {
    var parameters = this.getDefaultParameters();
    return CloudflowObject.getParameter(parameters, pKey);
  },
  getOutputType: function getOutputType() {
    return this.mJSON.output_type;
  },
  /**
   * @brief returns a general HTML-form
   * @returns {String} html form
   */
  getHTML: function getHTML() {
    if (!this.mJSON.editor || !this.mJSON.editor.en) {
      return "<form></form>";
    }
    return this.mJSON.editor.en;
  },
  getEditorScript: function getEditorScript() {
    if (typeof this.mJSON.editor_script === "function") {
      return this.mJSON.editor_script;
    }
    return null;
  }
};
module.exports = EntityComposerDefinition;

},{"../../CloudflowUtil/js/CloudflowObject.js":79}],112:[function(require,module,exports){
"use strict";

var EntityComposer = require('./EntityComposer.js');
var ValueComposer = function ValueComposer(pValue) {
  if (arguments.length === 0) {
    this.mJSON = [];
  } else if (arguments.length === 1) {
    if (Array.isArray(pValue) === false) {
      throw new Error('ValueComposer.consturctor: invalid value composer');
    }
    this.mJSON = pValue;
  } else {
    throw new Error('ValueComposer.consturctor: invalid arguments');
  }
};
ValueComposer.prototype = {
  constructor: ValueComposer,
  clear: function clear() {
    this.mJSON.splice(0, this.mJSON.length);
  },
  addEntityComposer: function addEntityComposer(pComposer, pIndex) {
    if (!(pComposer instanceof EntityComposer)) {
      throw new Error('ValueComposer.addEntityComposer: invalid entity composer');
    }
    if (pIndex !== undefined) {
      if (typeof pIndex !== "number" || pIndex < 0 || pIndex > this.mJSON.length) {
        throw new Error('ValueComposer.addEntityComposer: invalid insert position');
      }
    }
    if (pIndex !== undefined) {
      this.mJSON.splice(pIndex, 0, pComposer.toJSON());
    } else {
      this.mJSON.push(pComposer.toJSON());
    }
  },
  getEntityComposer: function getEntityComposer(pIndex) {
    if (typeof pIndex !== "number") {
      throw new Error('ValueComposer.getEntityComposer: index must be a number');
    }
    return new EntityComposer(this.mJSON[pIndex]);
  },
  removeEntityComposer: function removeEntityComposer(pIndex) {
    if (typeof pIndex !== "number" || pIndex < 0 || pIndex >= this.mJSON.length) {
      throw new Error('ValueComposer.removeEntityComposer: invalid index');
    }
    this.mJSON.splice(pIndex, 1);
  },
  getSize: function getSize() {
    return this.mJSON.length;
  },
  toJSON: function toJSON() {
    return structuredClone(this.mJSON);
  }
};
module.exports = ValueComposer;

},{"./EntityComposer.js":109}],113:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var PREVIOUS = "previous";
var EntityComposer = require("./EntityComposer.js");
var BuildingBlock = require("./BuildingBlock.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
var tempateVariableRegExp = /\${(\\}|[^}$])+}/g;
var encodeLimited = function encodeLimited(pVal) {
  return pVal.split("\\").join("%5C").split("\"").join("%22").split(":").join("%3A").split(",").join("%2C");
};
var decodeLimited = function decodeLimited(pVal) {
  return pVal.split("%22").join("\"").split("%3A").join(":").split("%2C").join(",").split("%5C").join("\\");
};
var doubleEscape = function doubleEscape(pObj) {
  return structuredClone(pObj).replaceAll("\\", "\\\\").replaceAll("\"", "\\\"");
};

/**
 * @brief checks if JSON structure is a value composer
 */
function isValueComposer(pValueComposer) {
  if (!Array.isArray(pValueComposer) || pValueComposer.length <= 0) {
    return false;
  }
  for (var i = 0; i < pValueComposer.length; i++) {
    if (typeof pValueComposer[i].type !== "string" || pValueComposer[i].type.length <= 0) {
      return false;
    }
  }
  return true;
}
;
var skipFlattenFn = function skipFlattenFn(pValueComposerJSON) {
  return Array.isArray(pValueComposerJSON) && pValueComposerJSON.length > 0 && typeof pValueComposerJSON[0].type === "string" && pValueComposerJSON[0].type.length > 0;
};
function getProviderAndTransformers(json, definitions) {
  var transformers = [];
  var provider = null;
  var entity = json[0];
  var definition = definitions.getEntityComposer(entity.type);
  while (definition.getType() !== "provider") {
    transformers.unshift(entity);
    entity = entity[definition.getInputField()][0];
    definition = definitions.getEntityComposer(entity.type);
  }
  provider = entity;
  return {
    provider: provider,
    transformers: transformers
  };
}
;

/**
 * @brief connect the child to his father
 * @param {String} pInputKey
 * @param {ValueComposer} pFather
 * @param {ValueComposer} pChild
 * @returns {@var;pChild}
 */
function compose(pInputKey, pFather, pChild) {
  var newFather = {};
  var newChild = [];
  $.extend(true, newFather, pFather);
  $.extend(true, newChild, pChild);
  newFather[pInputKey] = newChild;
  if (!Array.isArray()) {
    return [newFather];
  } else {
    return newFather;
  }
}

/**
 * @desc when split a string in array, sometimes the delimiter is escapes, so we have splitted a thing to much
 * clue those things now to getter, who should not have splitted.
 * @function
 * @param {array} pArray
 * @param {string} pChar
 * @returns {Array}
 */
function concatWrongSplited(pArray, pChar) {
  if (!Array.isArray(pArray)) {
    throw new Error('input pArray must be a array');
  }
  if (typeof pChar !== "string" || pChar.length !== 1) {
    throw new Error('input pChar must be a string with length one');
  }
  if (pArray.length <= 1) {
    return pArray;
  }
  var output = [],
    word;
  for (var i = 0; i < pArray.length - 1; i++) {
    word = pArray[i];
    // clue the peases that are cut but not supposed to be cutted, 
    // there was a escape char that was not followed by a other escap character
    if (word.charAt(word.length - 1) === '\\' && (word.length - 2 < 0 || word.charAt(word.length - 2) !== '\\')) {
      // remove delimiter, add escaped char and concat to the next part
      pArray[i + 1] = word.slice(0, -1) + pChar + pArray[i + 1];
    } else {
      // otherwise consider as one pice
      output.push(word);
    }
  }
  output.push(pArray[pArray.length - 1]);
  return output;
}

/**
 * @description get a string containing a function and return the arguments in a array. we now suppose there are always 4 arguments
 * @function
 * @param {String} pFunctionString
 * @returns {Array} the arguments, string have quates
 */
function getArguments(pFunctionString) {
  var args = pFunctionString.replace(/^[a-zA-Z]*\(\ *(.+)\ *\)$/g, "$1");
  var separArgComma = args.split(',');
  if (separArgComma.length < 4) {
    throw new Error('invalid function arguments, there are less then four arguments');
  } else if (separArgComma.length === 4) {
    // return the trimed arguments as a array
    return separArgComma.map(function (elem) {
      if (typeof elem === "string") {
        return elem.trim();
      }
      return elem;
    });
  } else {
    // there are more then 4 arguments, there could be possible commas in the strings,
    // parse by strings " or ' 
    // arguments is trimed by the function getStringArgument
    var stringDelim = args.charAt(0);
    // string delimiter must be a " or a '
    if (stringDelim !== '"' && stringDelim !== "'") {
      throw new Error('invalid function argument, first argument must be a string');
    }
    // split in function of ' or ",
    var separArgString = args.split(stringDelim);
    // split in function of ' or ", because the first element is a " the array will always start with a empty string ""
    // so remove that!
    separArgString.shift();
    separArgString = concatWrongSplited(separArgString, stringDelim);
    // remake string to string
    return ["'" + separArgString[0] + "'", separArgString[1].replace(/[, ]/g, ""), "'" + separArgString[2] + "'", separArgString[3].replace(/[, ]/g, "")];
  }
}
var ValueComposerTranslator = {
  /**
   * @brief translate from backend, first it controls of the inputvalue is correct 
   * aftewards it translate it
   * @param {ValueComposer} the valuecomposer that must be translated
   * @throw "valueComposer must be a not empty array"
   * @throw "valueComposer must have a type"
   * @throw "unknow type"
   */
  fromBackEnd: function fromBackEnd(pValueComposer) {
    if (!Array.isArray(pValueComposer) || pValueComposer.length === 0) {
      throw new Error('valueComposer must be a not empty array');
    }
    if (Array.isArray(pValueComposer[0]) && pValueComposer[0].length > 0) {
      var result = [];
      for (var i = 0; i < pValueComposer.length; i++) {
        var element = pValueComposer[i];
        result.push(this.fromBackEnd(element));
      }
      return result;
    }
    var valuecomposer = pValueComposer[0];
    if (typeof valuecomposer.type !== "string" || valuecomposer.type.length <= 0) {
      throw new Error('valueComposer must have a type');
    }
    switch (valuecomposer.type) {
      case 'com.nixps.quantum.characters_of.0':
      case 'com.nixps.quantum.length_of.0':
        return compose('input', valuecomposer, this.fromBackEnd(valuecomposer.input));
      case 'com.nixps.quantum.type_converter.0':
        return compose('value', valuecomposer, this.fromBackEnd(valuecomposer.value));

      //				case 'com.nixps.quantum.url_to_local_path.0':
      case 'com.nixps.quantum.url_encoder.0':
        return compose('url', valuecomposer, this.fromBackEnd(valuecomposer.url));
      case 'com.nixps.quantum.parse_url.0':
        return this.fromParseUrl(valuecomposer);
      case 'com.nixps.quantum.data_from_node.0':
        return this.fromDataFromNode(valuecomposer);
      case 'com.nixps.quantum.data_from_previous_node.0':
        return this.fromDataFromPreviousNode(valuecomposer);
      case 'com.nixps.quantum.current_time.0':
        return this.fromCurrentTime(valuecomposer);
      case 'com.nixps.quantum.project.files.0':
        return this.fromProjectFilesNode(valuecomposer);
      case 'com.nixps.quantum.project.folders.0':
        return this.fromProjectFoldersNode(valuecomposer);
      case "com.nixps.quantum.calculations.0":
        return this.fromBackEndCalculation(valuecomposer);
      case 'com.nixps.quantum.role.0':
      case 'com.nixps.quantum.value.0':
      case 'com.nixps.quantum.variable.0':
      case 'com.nixps.quantum.generate_uuid.0':
      case 'com.nixps.quantum.workable_info.0':
      case 'com.nixps.quantum.project.team_members.0':
      case 'com.nixps.quantum.project.contents.0':
      case 'com.nixps.quantum.last_error.0':
      case 'com.nixps.quantum.logical.0':
      case 'com.nixps.localization.look_up.0':
      case 'com.nixps.pagebuilder.current_user.0':
      case "com.nixps.quantum.project.sub_projects_contents.0":
      case "com.nixps.quantum.unit_converter.0":
      case "com.nixps.preferences.user.0":
      case "com.nixps.quantum.object.0":
      case "com.nixps.quantum.conditional.0":
      case "com.nixps.device.settings.0":
        // Do not translate
        return [valuecomposer];
      default:
        throw new Error('valueComposer unknow type');
    }
  },
  /**
   * @brief translate to backend, first it controls of the inputvalue is correct 
   * aftewards it translate it
   * @param {ValueComposer} the valuecomposer that must be translated
   * @throw "valueComposer must be a not empty array"
   * @throw "valueComposer must have a type"
   * @throw "unknow type"
   */
  toBackEnd: function toBackEnd(pValueComposer) {
    if (!Array.isArray(pValueComposer) || pValueComposer.length === 0) {
      throw new Error('valueComposer must be a not empty array');
    }
    var valuecomposer = pValueComposer[0];
    if (typeof valuecomposer.type !== "string" || valuecomposer.type.length <= 0) {
      throw new Error('valueComposer must have a type');
    }
    switch (valuecomposer.type) {
      case 'com.nixps.quantum.characters_of.0':
      case 'com.nixps.quantum.length_of.0':
        return compose('input', valuecomposer, this.toBackEnd(valuecomposer.input));

      //				case 'com.nixps.quantum.url_to_local_path.0':
      case 'com.nixps.quantum.url_encoder.0':
        return compose('url', valuecomposer, this.toBackEnd(valuecomposer.url));
      case 'com.nixps.quantum.file_name.0':
        return this.toFileName(valuecomposer);
      case 'com.nixps.quantum.file_name_without_extension.0':
        return this.toFileNameWithoutExtension(valuecomposer);
      case 'com.nixps.quantum.file_name_extension.0':
        return this.toFileNameExtension(valuecomposer);
      case 'com.nixps.quantum.full_file_url.0':
        return this.toFullFileUrl(valuecomposer);
      case 'com.nixps.quantum.folder_path.0':
        return this.toFolderPath(valuecomposer);
      case 'com.nixps.quantum.all_files_from_node.0':
        return this.toDataFromNode(valuecomposer);
      case 'com.nixps.quantum.data_from_previous_node.0':
        return this.toDataFromPreviousNode(valuecomposer);
      case 'com.nixps.quantum.current_hour.0':
        return this.toCurrentTime(valuecomposer);
      case 'com.nixps.quantum.quantum_data_from_node.0':
        return this.toDataFromNode(valuecomposer);
      case 'com.nixps.quantum.project.one_file.0':
        return this.toProjectFiles(valuecomposer, true);
      case 'com.nixps.quantum.project.files.0':
        return this.toProjectFiles(valuecomposer, false);
      case 'com.nixps.quantum.project.one_folder.0':
        return this.toProjectFolders(valuecomposer, true);
      case 'com.nixps.quantum.project.folders.0':
        return this.toProjectFolders(valuecomposer, false);
      case 'com.nixps.quantum.type_converter.0':
        var converted = [];
        for (var i = 0; i < valuecomposer.value.length; i++) {
          var element = valuecomposer.value[i];
          converted.push(this.toBackEnd([element])[0]);
        }
        valuecomposer.value = converted;
        return [valuecomposer];
      case 'com.nixps.quantum.role.0':
      case 'com.nixps.quantum.value.0':
      case 'com.nixps.quantum.variable.0':
      case 'com.nixps.quantum.generate_uuid.0':
      case 'com.nixps.quantum.current_time.0':
      case 'com.nixps.quantum.workable_info.0':
      case 'com.nixps.quantum.project.team_members.0':
      case 'com.nixps.quantum.project.contents.0':
      case 'com.nixps.quantum.last_error.0':
      case 'com.nixps.quantum.logical.0':
      case 'com.nixps.localization.look_up.0':
      case 'com.nixps.pagebuilder.current_user.0':
      case "com.nixps.quantum.project.sub_projects_contents.0":
      case "com.nixps.quantum.unit_converter.0":
      case "com.nixps.preferences.user.0":
      case "com.nixps.quantum.object.0":
      case "com.nixps.quantum.calculations.0":
      case "com.nixps.quantum.conditional.0":
      case "com.nixps.device.settings.0":
        // Do not translate
        return [valuecomposer];
      default:
        throw new Error('valueComposer unknow type');
    }
  },
  /********************************************************
  * functions translating from UI to backend
  *******************************************************/
  toFileName: function toFileName(pValueComposer) {
    var outputComposer = {
      type: 'com.nixps.quantum.parse_url.0',
      parts: 'Name+Extension',
      decoded: pValueComposer.decoded,
      url: []
    };
    if (pValueComposer.is_previous === true) {
      outputComposer.url = [{
        type: 'com.nixps.quantum.data_from_previous_node.0',
        first_only: true
      }];
    } else {
      outputComposer.url = [{
        type: 'com.nixps.quantum.data_from_node.0',
        node_name: pValueComposer.node_name,
        first_only: true
      }];
    }
    return [outputComposer];
  },
  toFileNameWithoutExtension: function toFileNameWithoutExtension(pValueComposer) {
    var outputComposer = {
      type: 'com.nixps.quantum.parse_url.0',
      parts: 'Name',
      decoded: pValueComposer.decoded,
      url: []
    };
    if (pValueComposer.is_previous === true) {
      outputComposer.url = [{
        type: 'com.nixps.quantum.data_from_previous_node.0',
        first_only: true
      }];
    } else {
      outputComposer.url = [{
        type: 'com.nixps.quantum.data_from_node.0',
        node_name: pValueComposer.node_name,
        first_only: true
      }];
    }
    return [outputComposer];
  },
  toFileNameExtension: function toFileNameExtension(pValueComposer) {
    var outputComposer = {
      type: 'com.nixps.quantum.parse_url.0',
      parts: 'Extension',
      decoded: pValueComposer.decoded,
      url: []
    };
    if (pValueComposer.is_previous === true) {
      outputComposer.url = [{
        type: 'com.nixps.quantum.data_from_previous_node.0',
        first_only: true
      }];
    } else {
      outputComposer.url = [{
        type: 'com.nixps.quantum.data_from_node.0',
        node_name: pValueComposer.node_name,
        first_only: true
      }];
    }
    return [outputComposer];
  },
  toFullFileUrl: function toFullFileUrl(pValueComposer) {
    if (pValueComposer.node_name === PREVIOUS) {
      return [{
        type: "com.nixps.quantum.data_from_previous_node.0",
        first_only: true
      }];
    } else {
      return [{
        type: "com.nixps.quantum.data_from_node.0",
        node_name: pValueComposer.node_name,
        first_only: true
      }];
    }
  },
  toFolderPath: function toFolderPath(pValueComposer) {
    var output = [{
      type: "com.nixps.quantum.parse_url.0",
      parts: "Protocol+Node+Path",
      decoded: pValueComposer.decoded,
      url: ''
    }];
    if (pValueComposer.node_name === PREVIOUS) {
      output[0].url = [{
        type: "com.nixps.quantum.data_from_previous_node.0",
        first_only: true
      }];
    } else {
      output[0].url = [{
        type: "com.nixps.quantum.data_from_node.0",
        node_name: pValueComposer.node_name,
        first_only: true
      }];
    }
    return output;
  },
  //all files from node
  toDataFromNode: function toDataFromNode(pValueComposer) {
    var output = {
      type: "com.nixps.quantum.data_from_node.0",
      node_name: pValueComposer.node_name,
      first_only: false
    };

    // Check if it's from the previous node
    if (pValueComposer.node_name === PREVIOUS) {
      output.type = "com.nixps.quantum.data_from_previous_node.0";
      delete output.node_name;
    }

    // Set the sub key if there is one
    if (typeof pValueComposer.sub_json_path === "string") {
      output.sub_json_path = pValueComposer.sub_json_path;
    }
    return [output];
  },
  toDataFromPreviousNode: function toDataFromPreviousNode(valuecomposer) {
    var outputComposer = [{
      type: "com.nixps.quantum.data_from_previous_node.0",
      first_only: valuecomposer.first_only
    }];
    return outputComposer;
  },
  toCurrentTime: function toCurrentTime(valuecomposer) {
    return [{
      type: 'com.nixps.quantum.current_time.0',
      format: valuecomposer.format,
      utc: valuecomposer.utc
    }];
  },
  toProjectFiles: function toProjectFiles(pValueComposer, pFirstOnly) {
    return [{
      type: "com.nixps.quantum.project.files.0",
      tag: pValueComposer.tag,
      first_only: pFirstOnly
    }];
  },
  toProjectFolders: function toProjectFolders(pValueComposer, pFirstOnly) {
    return [{
      type: "com.nixps.quantum.project.folders.0",
      tag: pValueComposer.tag,
      first_only: pFirstOnly
    }];
  },
  /********************************************************
   * functions translating from backend to UI
   *******************************************************/
  fromParseUrl: function fromParseUrl(pValueComposer) {
    if (typeof pValueComposer.parts !== "string" || pValueComposer.parts.length <= 0) {
      throw new Error('invalid ValueComposer');
    }
    if (!isValueComposer(pValueComposer.url)) {
      throw new Error('invalid ValueComposer');
    }
    switch (pValueComposer.parts) {
      case 'Name+Extension':
        if (pValueComposer.url[0].type === "com.nixps.quantum.data_from_previous_node.0") {
          if (pValueComposer.url[0].first_only === false) {
            throw new Error('valueComposer unsupported composer');
          }
          return [{
            type: 'com.nixps.quantum.file_name.0',
            is_previous: true,
            node_name: PREVIOUS,
            decoded: pValueComposer.decoded
          }];
        }
        if (pValueComposer.url[0].type === "com.nixps.quantum.data_from_node.0") {
          return [{
            type: 'com.nixps.quantum.file_name.0',
            is_previous: false,
            node_name: pValueComposer.url[0].node_name,
            decoded: pValueComposer.decoded
          }];
        }
        break;
      case "Name":
        if (pValueComposer.url[0].type === "com.nixps.quantum.data_from_previous_node.0") {
          if (pValueComposer.url[0].first_only === false) {
            throw new Error('valueComposer unsupported composer');
          }
          return [{
            type: 'com.nixps.quantum.file_name_without_extension.0',
            is_previous: true,
            node_name: PREVIOUS,
            decoded: pValueComposer.decoded
          }];
        }
        if (pValueComposer.url[0].type === "com.nixps.quantum.data_from_node.0") {
          return [{
            type: 'com.nixps.quantum.file_name_without_extension.0',
            is_previous: false,
            node_name: pValueComposer.url[0].node_name,
            decoded: pValueComposer.decoded
          }];
        }
        break;
      case "Extension":
        if (pValueComposer.url[0].type === "com.nixps.quantum.data_from_previous_node.0") {
          if (pValueComposer.url[0].first_only === false) {
            throw new Error('valueComposer unsupported composer');
          }
          return [{
            type: 'com.nixps.quantum.file_name_extension.0',
            is_previous: true,
            node_name: PREVIOUS,
            decoded: pValueComposer.decoded
          }];
        }
        if (pValueComposer.url[0].type === "com.nixps.quantum.data_from_node.0") {
          return [{
            type: 'com.nixps.quantum.file_name_extension.0',
            is_previous: false,
            node_name: pValueComposer.url[0].node_name,
            decoded: pValueComposer.decoded
          }];
        }
        break;
      case "Protocol+Node+Path":
        if (pValueComposer.url[0].type === "com.nixps.quantum.data_from_previous_node.0") {
          if (pValueComposer.url[0].first_only === false) {
            throw new Error('valueComposer unsupported composer');
          }
          return [{
            type: 'com.nixps.quantum.folder_path.0',
            is_previous: true,
            node_name: PREVIOUS,
            decoded: pValueComposer.decoded
          }];
        }
        if (pValueComposer.url[0].type === "com.nixps.quantum.data_from_node.0") {
          return [{
            type: 'com.nixps.quantum.folder_path.0',
            is_previous: false,
            node_name: pValueComposer.url[0].node_name,
            decoded: pValueComposer.decoded
          }];
        }
        break;
      default:
        throw new Error('unkown ValueComposer parts');
    }
  },
  fromDataFromNode: function fromDataFromNode(pValueComposer) {
    var is_previous = pValueComposer.node_name === PREVIOUS;
    var output = {
      "type": 'com.nixps.quantum.full_file_url.0',
      "node_name": pValueComposer.node_name,
      "is_previous": is_previous
    };
    if (is_previous === true) {
      output.node_name = PREVIOUS;
    }
    if (typeof pValueComposer.sub_json_path === 'string') {
      output.type = 'com.nixps.quantum.quantum_data_from_node.0';
      output.sub_json_path = pValueComposer.sub_json_path;
    } else if (pValueComposer.first_only === true) {
      output.type = 'com.nixps.quantum.full_file_url.0';
    } else {
      output.type = 'com.nixps.quantum.all_files_from_node.0';
    }
    return [output];
  },
  fromDataFromPreviousNode: function fromDataFromPreviousNode(pValueComposer) {
    var is_previous = pValueComposer.node_name === PREVIOUS;
    var output = {
      "type": 'com.nixps.quantum.full_file_url.0',
      "node_name": PREVIOUS,
      "is_previous": true
    };
    if (typeof pValueComposer.sub_json_path === 'string') {
      output.type = 'com.nixps.quantum.quantum_data_from_node.0';
      output.sub_json_path = pValueComposer.sub_json_path;
    } else if (pValueComposer.first_only === true) {
      output.type = 'com.nixps.quantum.full_file_url.0';
    } else {
      output.type = 'com.nixps.quantum.all_files_from_node.0';
    }
    return [output];
  },
  fromCurrentTime: function fromCurrentTime(pValueComposer) {
    var format = pValueComposer.format;
    if (typeof format === "string") {
      if (format.indexOf('%H') >= 0 || format.indexOf('%I') >= 0 || format.indexOf('%M') >= 0 || format.indexOf('%S') >= 0) {
        return [{
          "type": 'com.nixps.quantum.current_hour.0',
          "format": format,
          "utc": pValueComposer.utc
        }];
      } else {
        return [{
          "type": 'com.nixps.quantum.current_time.0',
          "format": format,
          "utc": pValueComposer.utc
        }];
      }
    } else {
      throw new Error('invalid valuecomposer nixps.quantum.current_time.0');
    }
  },
  fromProjectFilesNode: function fromProjectFilesNode(pValueComposer) {
    var output = {
      "type": 'com.nixps.quantum.project.files.0',
      "tag": pValueComposer.tag
    };
    if (pValueComposer.first_only === true) {
      output.type = 'com.nixps.quantum.project.one_file.0';
    }
    return [output];
  },
  fromProjectFoldersNode: function fromProjectFoldersNode(pValueComposer) {
    var output = {
      "type": 'com.nixps.quantum.project.folders.0',
      "tag": pValueComposer.tag
    };
    if (pValueComposer.first_only === true) {
      output.type = 'com.nixps.quantum.project.one_folder.0';
    }
    return [output];
  },
  fromBackEndCalculation: function fromBackEndCalculation(pValueComposer) {
    var resultComposer = Object.assign({}, pValueComposer);
    if (pValueComposer.operations && Array.isArray(pValueComposer.operations)) {
      var translatedOperations = [];
      for (var i = 0; i < pValueComposer.operations.length; i++) {
        var element = Object.assign({}, pValueComposer.operations[i]);
        var resultOperation = element;
        if (element.type === "value" && Array.isArray(element.value)) {
          resultOperation.value = this.fromBackEnd(element.value);
        }
        translatedOperations.push(resultOperation);
      }
      resultComposer.operations = translatedOperations;
      return [resultComposer];
    }
    throw new Error("valueComposer Wrong type");
  },
  /********************************
   * translations to and from template 
   **********************************/

  fromTemplateToFrontEnd: function fromTemplateToFrontEnd(pTemplate, pSubTemplates) {
    var category, secondPart;
    category = pTemplate.replace(/^\${([^.]+)\.(.|\n)+}$/g, "$1");
    secondPart = pTemplate.replace(/^\${([^.]+)\.((.|\n)+)}$/g, "$2");
    if (pTemplate.indexOf("${=") === 0) {
      category = "calculation";
      secondPart = pTemplate.slice(3, -1);
    }
    var output;
    var functionString;
    if (secondPart.includes(":substring(") || secondPart.includes(":size(") || secondPart.includes(":convert_to(") || secondPart.includes(":convert_unit(")) {
      // get all the functions except the first ':'
      functionString = secondPart.replace(/[^:]+(:.+)$/g, "$1");
      // remove all the functions of the second part
      secondPart = secondPart.substring(0, secondPart.indexOf(":"));
    }
    switch (category) {
      case "variable":
        var sourceDashIndex = secondPart.indexOf("/");
        if (sourceDashIndex > 0) {
          output = [{
            type: "com.nixps.quantum.variable.0",
            variable: secondPart.substring(sourceDashIndex + 1),
            source: secondPart.substring(0, sourceDashIndex)
          }];
        } else {
          output = [{
            type: "com.nixps.quantum.variable.0",
            variable: secondPart
          }];
        }
        break;
      case "file":
        output = [{
          type: "com.nixps.quantum." + secondPart + ".0",
          "node_name": "previous",
          "is_previous": true
        }];
        break;
      case "files":
        output = [{
          type: "com.nixps.quantum.all_files_from_node.0",
          "node_name": secondPart,
          "is_previous": secondPart === PREVIOUS
        }];
        break;
      case "general":
        if (secondPart.indexOf("generate_uuid") === 0) {
          output = [{
            type: "com.nixps.quantum.generate_uuid.0"
          }];
        } else if (secondPart.indexOf("last_error") === 0) {
          output = [{
            type: "com.nixps.quantum.last_error.0"
          }];
          // } else if(secondPart.indexOf('url_to_local_path') === 0) {
          //     output = [{ type: "com.nixps.quantum.url_to_local_path.0" }];
        } else if (secondPart.indexOf("url_encoder") === 0) {
          output = [{
            type: "com.nixps.quantum.url_encoder.0"
          }];
        } else {
          throw new Error("valueComposer unsupported template form category general");
        }
        break;
      case "role":
        output = [{
          type: "com.nixps.quantum.role.0",
          role: secondPart
        }];
        break;
      case "current_user":
        output = [{
          type: "com.nixps.pagebuilder.current_user.0",
          part: secondPart
        }];
        break;
      case "logical":
        output = [{
          type: "com.nixps.quantum.logical.0",
          logical: secondPart
        }];
        break;
      case "workable":
        output = [{
          type: "com.nixps.quantum.workable_info.0",
          part: secondPart
        }];
        break;
      case "date":
        var outputValueComposer = {
          type: "com.nixps.quantum.current_time.0",
          utc: false
        };
        var format = secondPart;
        switch (format) {
          case "year":
            outputValueComposer.format = "%Y";
            output = [outputValueComposer];
            break;
          case "month":
            outputValueComposer.format = "%B";
            output = [outputValueComposer];
            break;
          case "month_number":
            outputValueComposer.format = "%m";
            output = [outputValueComposer];
            break;
          case "weekday":
            outputValueComposer.format = "%A";
            output = [outputValueComposer];
            break;
          case "month_day":
            outputValueComposer.format = "%d";
            output = [outputValueComposer];
            break;
          default:
            outputValueComposer.format = format;
            output = [outputValueComposer];
            break;
        }
        break;
      case "time":
        var outputValueComposer = {
          type: "com.nixps.quantum.current_hour.0",
          utc: false
        };
        var format = secondPart;
        switch (format) {
          case "hour":
            outputValueComposer.format = "%H";
            output = [outputValueComposer];
            break;
          case "minutes":
            outputValueComposer.format = "%M";
            output = [outputValueComposer];
            break;
          case "seconds":
            outputValueComposer.format = "%S";
            output = [outputValueComposer];
            break;
          default:
            outputValueComposer.format = format;
            output = [outputValueComposer];
            break;
        }
        break;
      case "container":
        var outputValueComposer = {
          type: "com.nixps.quantum.quantum_data_from_node.0"
        };
        var node_name = secondPart.slice(0, secondPart.search(/[^\\]\./) + 1);
        outputValueComposer.node_name = node_name.replace(/\\[.]/g, ".");
        outputValueComposer.sub_json_path = secondPart.slice(secondPart.search(/[^\\]\./) + 2);
        outputValueComposer.first_only = false;
        output = [outputValueComposer];
        break;
      case "project":
        var outputValueComposer = {};
        var type = secondPart.slice(0, secondPart.indexOf('.'));
        switch (type) {
          case "contents":
            outputValueComposer.type = "com.nixps.quantum.project.contents.0";
            outputValueComposer.json_path = secondPart.slice(secondPart.indexOf('.') + 1);
            output = [outputValueComposer];
            break;
          case "sub_projects_contents":
            outputValueComposer.type = "com.nixps.quantum.project.sub_projects_contents.0";
            outputValueComposer.tag = secondPart.slice(secondPart.indexOf('.') + 1);
            outputValueComposer.json_path = secondPart.slice(secondPart.indexOf('.') + 2);
            output = [outputValueComposer];
            break;
          case "files":
            outputValueComposer.type = "com.nixps.quantum.project.files.0";
            outputValueComposer.tag = secondPart.slice(secondPart.indexOf('.') + 1);
            output = [outputValueComposer];
            break;
          case "one_file":
            outputValueComposer.type = "com.nixps.quantum.project.one_file.0";
            outputValueComposer.tag = secondPart.slice(secondPart.indexOf('.') + 1);
            output = [outputValueComposer];
            break;
          case "folders":
            outputValueComposer.type = "com.nixps.quantum.project.folders.0";
            outputValueComposer.tag = secondPart.slice(secondPart.indexOf('.') + 1);
            output = [outputValueComposer];
            break;
          case "one_folder":
            outputValueComposer.type = "com.nixps.quantum.project.one_folder.0";
            outputValueComposer.tag = secondPart.slice(secondPart.indexOf('.') + 1);
            output = [outputValueComposer];
            break;
          case "team_members":
            outputValueComposer.type = "com.nixps.quantum.project.team_members.0";
            var crap = secondPart.slice(secondPart.indexOf('.') + 1);
            outputValueComposer.role = crap.slice(0, crap.indexOf('.'));
            outputValueComposer.json_path = crap.slice(crap.indexOf('.') + 1);
            output = [outputValueComposer];
            break;
          default:
            throw new Error('valueComposer invalid second part projects value composer');
        }
        break;
      case "translation":
        output = [{
          type: "com.nixps.localization.look_up.0",
          translation_key: secondPart
        }];
        break;
      case "preferences_user":
        var parts = secondPart.split("/");
        output = [{
          type: "com.nixps.preferences.user.0",
          application_id: parts[0],
          sub_key: parts[1],
          system_realm_only: parts[2] == "true"
        }];
        break;
      case "device":
        output = [{
          type: "com.nixps.device.settings.0",
          parameter: secondPart
        }];
        break;
      case "conditional":
        var condition = [];
        var staticOffset = 14; // "${conditional.".length
        if (Array.isArray(pSubTemplates) && pSubTemplates.length > 0) {
          // make a string to an array of value composers
          var parts = secondPart.split("");
          for (var i = 0; i < pSubTemplates.length; i++) {
            parts[pSubTemplates[i].start - staticOffset] = "$";
            parts[pSubTemplates[i].start - staticOffset + 1] = "{";
            parts[pSubTemplates[i].end - staticOffset] = "}";
          }
          secondPart = parts.join("");
          condition = JSON.parse(secondPart, function (key, value) {
            if (typeof value === "string" && value.indexOf("${") >= 0) {
              var output = [],
                pointer = 0;
              value.replace(tempateVariableRegExp, function (match, p1, offset) {
                if (pointer < offset) {
                  output.push({
                    type: "com.nixps.quantum.value.0",
                    value: value.substring(pointer, offset)
                  });
                }
                pointer = offset + match.length;
                var subTemplate = pSubTemplates.find(function (temp) {
                  return temp.template === match;
                });
                if (subTemplate !== undefined && subTemplate !== null) {
                  output = output.concat(subTemplate.value_composer);
                }
              });
              if (pointer < value.length) {
                output.push({
                  type: "com.nixps.quantum.value.0",
                  value: value.substring(pointer, value.length)
                });
              }
              return output;
            }
            return value;
          });
        } else {
          condition = JSON.parse(secondPart);
        }
        if (Array.isArray(condition)) {
          // make from every inputstring a value composer
          var index = 0;
          for (var i = 0; i < condition.length; i++) {
            if (condition[i] === "(") {
              continue;
            } else if (condition[i] === ")") {
              index = index - 2;
              continue;
            } else if (index % 2 === 0) {
              if (["string", "number", "boolean"].includes(_typeof(condition[i]))) {
                condition[i] = [{
                  type: "com.nixps.quantum.value.0",
                  value: condition[i]
                }];
              }
            }
            index++;
          }
        }
        output = [{
          type: "com.nixps.quantum.conditional.0",
          condition: condition,
          strict: false
        }];
        break;
      case "calculation":
        if (Array.isArray(pSubTemplates) && pSubTemplates.length > 0) {
          var staticOffset = 3; // "${=".length 
          var parts = secondPart.split("");
          for (var i = 0; i < pSubTemplates.length; i++) {
            parts[pSubTemplates[i].start - staticOffset] = "$";
            parts[pSubTemplates[i].start - staticOffset + 1] = "{";
            parts[pSubTemplates[i].end - staticOffset] = "}";
          }
          secondPart = parts.join("");
        }
        output = this.valueComposerToCalculation(this.templateToValuecomposer(secondPart).valuecomposer);
        break;
      default:
        // can be created by user, so error can caused by user, 
        // do not simply error, return all bunch
        throw new Error("valueComposer invalid template element");
      //output = [{type: "com.nixps.quamtum.value", value: pTemplate}];
    }
    // if there are functions?
    if (typeof functionString === "string" && functionString.length > 0) {
      var functions = functionString.split(/(:size|:substring|:convert_to|:convert_unit)/);
      functions.shift();
      for (var i = 0; i < functions.length - 1; i++) {
        if (functions[i] === ":size" && functions[i + 1] === "()") {
          output = [{
            type: "com.nixps.quantum.length_of.0",
            input: output
          }];
        } else if (functions[i].indexOf(":substring") === 0) {
          output = Object.assign({}, this.templateToCharactersOf(functions[i + 1])[0], {
            input: output
          });
          if (!Array.isArray(output)) {
            output = [output];
          }
        } else if (functions[i].indexOf(":convert_to") === 0) {
          var toType = functions[i + 1];
          if (typeof toType === "string" && toType.length > 0) {
            if (toType[0] === "(") {
              toType = toType.slice(1);
            }
            if (toType[toType.length - 1] === ")") {
              toType = toType.slice(0, -1);
            }
            output = [{
              type: "com.nixps.quantum.type_converter.0",
              to_type: toType,
              value: output,
              top_level: false
            }];
          }
        } else if (functions[i].indexOf(":convert_unit") === 0) {
          var fromUnit = "mm";
          var toUnit = "mm";
          var functionArguments = functions[i + 1];
          if (typeof functionArguments === "string" && functionArguments.length > 0) {
            if (functionArguments[0] === "(") {
              functionArguments = functionArguments.slice(1);
            }
            if (functionArguments[functionArguments.length - 1] === ")") {
              functionArguments = functionArguments.slice(0, -1);
            }
            var arrayFunctionArguments = functionArguments.split(",");
            arrayFunctionArguments = arrayFunctionArguments.map(function (pArg) {
              return pArg.replaceAll(" ", "").replaceAll("'", "").replaceAll("\"", "");
            });
            fromUnit = arrayFunctionArguments[0];
            toUnit = arrayFunctionArguments[1];
          }
          output = [{
            type: "com.nixps.quantum.unit_converter.0",
            from_unit: fromUnit,
            to_unit: toUnit,
            value: output
          }];
        }
      }
    }
    return output;
  },
  operationsToValueComposer: function operationsToValueComposer(pOperations) {
    var result = [];
    for (var i = 0; i < pOperations.length; i++) {
      var operation = pOperations[i];
      switch (operation.type) {
        case "value":
          if (_typeof(operation.value) === "object") {
            if (Array.isArray(operation.value)) {
              if (operation.value.length <= 0) {
                continue;
              }
              result = result.concat(operation.value);
            } else if (_typeof(operation.value) === "object") {
              result.push(operation.value);
            }
          } else if (typeof operation.value === "string" || typeof operation.value === "number") {
            if (result[result.length - 1] && result[result.length - 1].type === "com.nixps.quantum.value.0") {
              result[result.length - 1].value = result[result.length - 1].value + operation.value;
            } else {
              result.push({
                "type": "com.nixps.quantum.value.0",
                "value": operation.value
              });
            }
          }
          break;
        case "operation":
          var operationText = "";
          switch (operation.operation) {
            case "add":
              operationText = "+";
              break;
            case "divide":
              operationText = "/";
              break;
            case "subtract":
              operationText = "-";
              break;
            case "multiply":
              operationText = "*";
              break;
            default:
              break;
          }
          if (result[result.length - 1] && result[result.length - 1].type === "com.nixps.quantum.value.0") {
            result[result.length - 1].value = result[result.length - 1].value + operationText;
          } else {
            result.push({
              "type": "com.nixps.quantum.value.0",
              "value": operationText
            });
          }
          break;
        case "grouping":
          if (result[result.length - 1] && result[result.length - 1].type === "com.nixps.quantum.value.0") {
            result[result.length - 1].value = result[result.length - 1].value + operation.bracket;
          } else {
            result.push({
              "type": "com.nixps.quantum.value.0",
              "value": operation.bracket
            });
          }
          break;
        default:
          break;
      }
    }
    return result;
  },
  textToCalculationOperations: function textToCalculationOperations(pText) {
    if (typeof pText !== "string" && typeof pText !== "number") {
      throw new Error("valueComposer Wrong input type for calculations");
    }
    pText = "" + pText; // Make sure it's a string
    var result = [];
    // 1. replace(): Remove spaces
    // 2. split(): Split into parts based on +-/*() characters, preserve the characters used to split as separate items eg. "2+2" = ["2","+","2"].
    // 3. filter(): Remove empty values which are created by this method.
    var splitText = pText.replace(/ /g, "").split(/([\+\-\*\/\(\)])/).filter(function (t) {
      return !!t;
    });
    for (var i = 0; i < splitText.length; i++) {
      var item = splitText[i];
      switch (item) {
        case "+":
          if (result.length > 0 && result[result.length - 1].type === "operation" && splitText[i + 1]) {
            break;
          }
          result.push({
            "type": "operation",
            "operation": "add"
          });
          break;
        case "-":
          if (result.length > 0 && result[result.length - 1].type === "operation" && splitText[i + 1]) {
            splitText[i + 1] = "-" + splitText[i + 1];
            break;
          } else if (result.length > 0 && result[result.length - 1].type === "grouping" && result[result.length - 1].bracket === "(" && splitText[i + 1]) {
            splitText[i + 1] = "-" + splitText[i + 1];
            break;
          }
          result.push({
            "type": "operation",
            "operation": "subtract"
          });
          break;
        case "/":
          result.push({
            "type": "operation",
            "operation": "divide"
          });
          break;
        case "*":
          result.push({
            "type": "operation",
            "operation": "multiply"
          });
          break;
        case "(":
          result.push({
            "type": "grouping",
            "bracket": "("
          });
          break;
        case ")":
          result.push({
            "type": "grouping",
            "bracket": ")"
          });
          break;
        default:
          if (typeof item === "string" && item.length > 0) {
            var num = parseFloat(item);
            result.push({
              "type": "value",
              "value": num
            });
          }
          break;
      }
    }
    return result;
  },
  valueComposerToCalculation: function valueComposerToCalculation(pValueComposer) {
    var operations = [];
    if (Array.isArray(pValueComposer) && pValueComposer.length === 0) {
      return [{
        "type": "com.nixps.quantum.calculations.0",
        "operations": [{
          "type": "value",
          "value": ""
        }]
      }];
    }
    if (Array.isArray(pValueComposer) && isValueComposer(pValueComposer)) {
      if (pValueComposer.length === 1 && pValueComposer[0].type === "com.nixps.quantum.calculations.0") {
        // Already calculation
        return pValueComposer;
      }
      for (var i = 0; i < pValueComposer.length; i++) {
        var element = pValueComposer[i];
        if (element.type === "com.nixps.quantum.value.0") {
          if (element.value === "") {
            operations.push({
              "type": "value",
              "value": ""
            });
          } else {
            operations = operations.concat(this.textToCalculationOperations(element.value));
          }
        } else {
          if (element.value && typeof element.value === "string") {
            operations = operations.concat(this.textToCalculationOperations(element.value));
          } else {
            operations.push({
              "type": "value",
              "value": [element]
            });
          }
        }
      }
      for (var i = 0; i < operations.length - 1; i++) {
        if (operations[i] && operations[i].type === "value" && operations[i + 1] && operations[i + 1].type === "grouping" && operations[i + 1].bracket === "(") {
          operations.splice(i + 1, 0, {
            "type": "operation",
            "operation": "multiply"
          });
          i = i + 2;
        } else if (operations[i] && operations[i].type === "grouping" && operations[i].bracket === ")" && operations[i + 1] && operations[i + 1].type === "value") {
          operations.splice(i + 1, 0, {
            "type": "operation",
            "operation": "multiply"
          });
          i = i + 2;
        }
      }
      if (operations[0] && operations[0].type === "operation" && operations[1] && operations[1].type === "value" && typeof operations[1].value === "number") {
        if (operations[0].operation === "subtract") {
          operations[1].value = -operations[1].value;
          operations.shift();
        } else if (operations[0].operation === "add") {
          operations.shift();
        }
        // Let it fail on other operations
      }

      return [{
        "type": "com.nixps.quantum.calculations.0",
        "operations": operations
      }];
    }
    throw new Error("valueComposer Wrong type for calculations");
  },
  valueComposerRemoveCalculation: function valueComposerRemoveCalculation(pValueComposer) {
    if (Array.isArray(pValueComposer) && isValueComposer(pValueComposer)) {
      if (pValueComposer.length === 1 && pValueComposer[0].type === "com.nixps.quantum.calculations.0") {
        var output = [];
        for (var i = 0; i < pValueComposer[0].operations.length; i++) {
          if (pValueComposer[0].operations[i].type === "value") {
            if (Array.isArray(pValueComposer[0].operations[i].value)) {
              output = output.concat(pValueComposer[0].operations[i].value);
            } else {
              output.push({
                type: "com.nixps.quantum.value.0",
                value: pValueComposer[0].operations[i].value
              });
            }
          } else if (pValueComposer[0].operations[i].type === "operation") {
            var visualChar = "";
            switch (pValueComposer[0].operations[i].operation) {
              case "add":
                visualChar = "+";
                break;
              case "subtract":
                visualChar = "-";
                break;
              case "divide":
                visualChar = "/";
                break;
              case "multiply":
                visualChar = "*";
                break;
            }
            output.push({
              type: "com.nixps.quantum.value.0",
              value: visualChar
            });
          } else if (pValueComposer[0].operations[i].type === "grouping") {
            output.push({
              type: "com.nixps.quantum.value.0",
              value: pValueComposer[0].operations[i].bracket
            });
          }
        }
        return output;
      }
    }
    return pValueComposer;
  },
  templateToValuecomposer: function templateToValuecomposer(pTemplateString, pEntityComposerDefinitions) {
    var that = this;
    var templateTitles = [];
    var addVariableName = function addVariableName(pValueComposer, pEntityComposerDefinitions) {
      if (pEntityComposerDefinitions === undefined) {
        return;
      }
      var providerAndTransfomers = getProviderAndTransformers([pValueComposer], pEntityComposerDefinitions);
      var provider = new EntityComposer(providerAndTransfomers.provider, pEntityComposerDefinitions.getEntityComposer(providerAndTransfomers.provider.type));
      var transformers = [];
      if (Array.isArray(providerAndTransfomers.transformers)) {
        transformers = providerAndTransfomers.transformers.map(function (t) {
          return new EntityComposer(t, pEntityComposerDefinitions.getEntityComposer(t.type));
        });
      }
      var buildingBlock = new BuildingBlock(provider, transformers);
      var title = buildingBlock.getProvider().getDefinition().calculateTitle(false, buildingBlock.getProvider().getParameters());
      templateTitles.push(title);
    };
    if (typeof pTemplateString === "string") {
      // get all template variables in one array
      var templateVariables = [];
      var firstLoop = pTemplateString.replace(tempateVariableRegExp, function (match, p1, offset) {
        templateVariables.push({
          template: match,
          start: offset,
          end: offset + match.length - 1,
          value_composer: that.fromTemplateToFrontEnd(match)
        });
        return "[[" + match.slice(2, -1) + "]";
      });
      // if there are no variables, return just one value composer: value
      if (!Array.isArray(templateVariables) || templateVariables.length === 0) {
        return {
          valuecomposer: [{
            type: "com.nixps.quantum.value.0",
            value: pTemplateString
          }],
          templateTitles: templateTitles
        };
      }
      // you can have variables in variables, try recover parent variables who contains child variables..
      var secondLoop = firstLoop.replace(tempateVariableRegExp, function (match, p1, offset) {
        var subTemplates = templateVariables.filter(function (template) {
          return template.start > offset && template.start < offset + match.length;
        });
        subTemplates.forEach(function (template) {
          template.sub = true;
        });
        templateVariables.push({
          template: match,
          start: offset,
          end: offset + match.length - 1,
          value_composer: that.fromTemplateToFrontEnd(match, subTemplates)
        });
        return "[[" + match.slice(2, -1) + "]";
      });

      // if there are variables
      templateTitles = [];
      var output = []; // the array containing valuecomposer elements
      var index = -1;
      var oldIndex = 0;
      for (var i = 0; i < templateVariables.length; i++) {
        if (templateVariables[i].sub === true) {
          continue;
        }
        // calculate the index of the beginning of the next template
        index = templateVariables[i].start;
        // put the text between now and the next template  
        if (oldIndex < index) {
          output.push({
            type: "com.nixps.quantum.value.0",
            value: pTemplateString.substring(oldIndex, index)
          });
        }
        var frontendValueComposer = templateVariables[i].value_composer;
        addVariableName(frontendValueComposer[0], pEntityComposerDefinitions);
        // put the template in
        output.push(this.toBackEnd(frontendValueComposer)[0]);
        // the oldIndex is the index of the end of the template, this means the beginning of the new startpoint.
        oldIndex = index + templateVariables[i].template.length;
      }
      // add last piece of text between last template and the end
      var endString = pTemplateString.substring(index + templateVariables[i - 1].template.length);
      if (typeof endString === "string" && endString.length > 0) {
        output.push({
          type: "com.nixps.quantum.value.0",
          value: endString
        });
      }
      return {
        valuecomposer: output,
        templateTitles: templateTitles
      };
    }
    return {
      valuecomposer: [],
      templateTitles: templateTitles
    };
  },
  objectToValueComposer: function objectToValueComposer(pObject, addNewLines) {
    if (!$.isPlainObject(pObject)) {
      throw new Error("valueComposer wrong type for template");
    }
    var ReplacingExpression = [];
    pObject = CloudflowObject.replaceEmptyArrayRows(pObject, [{
      type: "com.nixps.quantum.value.0",
      value: ""
    }]);
    var flattend = CloudflowObject.flatten(pObject, skipFlattenFn);
    var flattenedKeys = Object.keys(flattend);
    // if(flattenedKeys.length <= 0){
    //     return [{
    //         type: "com.nixps.quantum.value.0",
    //         value: ""
    //     }]
    // }
    flattenedKeys = flattenedKeys.sort(function (a, b) {
      return b > a ? 1 : -1;
    });
    var result = [];
    for (var i = 0; i < flattenedKeys.length; i++) {
      if (Array.isArray(flattend[flattenedKeys[i]])) {
        ReplacingExpression.push(flattend[flattenedKeys[i]]);
        flattend[flattenedKeys[i]] = "${nixps.quantum.replace.variable.internal.use." + (ReplacingExpression.length - 1) + "}";
      }
    }
    var replacedObject = {};
    for (var i = 0; i < flattenedKeys.length; i++) {
      CloudflowObject.setParameter(replacedObject, flattenedKeys[i], flattend[flattenedKeys[i]]);
    }
    var objectJSON = addNewLines === true ? JSON.stringify(replacedObject, null, 2) : JSON.stringify(replacedObject);
    var replaceitemsIndex = [];
    for (var j = 0; j < ReplacingExpression.length; j++) {
      if (objectJSON.indexOf("${nixps.quantum.replace.variable.internal.use." + j + "}") !== -1) {
        replaceitemsIndex.push({
          stringIndex: objectJSON.indexOf("${nixps.quantum.replace.variable.internal.use." + j + "}"),
          toReplaceIndex: j
        });
      }
    }
    replaceitemsIndex = replaceitemsIndex.sort(function (a, b) {
      return a.stringIndex > b.stringIndex ? 1 : -1;
    });
    for (var i = 0; i < replaceitemsIndex.length; i++) {
      objectJSON = objectJSON.split("${nixps.quantum.replace.variable.internal.use." + replaceitemsIndex[i].toReplaceIndex + "}");
      result.push({
        type: "com.nixps.quantum.value.0",
        value: objectJSON[0]
      });
      for (var j = 0; j < ReplacingExpression[replaceitemsIndex[i].toReplaceIndex].length; j++) {
        if (ReplacingExpression[replaceitemsIndex[i].toReplaceIndex][j].type === "com.nixps.quantum.value.0") {
          ReplacingExpression[replaceitemsIndex[i].toReplaceIndex][j].value = doubleEscape(ReplacingExpression[replaceitemsIndex[i].toReplaceIndex][j].value);
        }
        result.push(ReplacingExpression[replaceitemsIndex[i].toReplaceIndex][j]);
      }
      objectJSON = objectJSON[1];
    }
    if (typeof objectJSON === "string") {
      result.push({
        type: "com.nixps.quantum.value.0",
        value: objectJSON
      });
    }
    var simplifiedResult = [];
    for (var i = 0; i < result.length; i++) {
      if (simplifiedResult.length > 0 && simplifiedResult[simplifiedResult.length - 1].type === "com.nixps.quantum.value.0" && result[i].type === "com.nixps.quantum.value.0") {
        simplifiedResult[simplifiedResult.length - 1].value = simplifiedResult[simplifiedResult.length - 1].value + result[i].value;
      } else {
        simplifiedResult.push(result[i]);
      }
    }
    return simplifiedResult;
  },
  valueComposerToObject: function valueComposerToObject(pValueComposer, pEntityComposerDefinitions) {
    if (Array.isArray(pValueComposer) && pValueComposer.length <= 0) {
      return {};
    }
    if (_typeof(pValueComposer) === "object" && Object.keys(pValueComposer).length === 0) {
      return {};
    }
    if (!isValueComposer(pValueComposer)) {
      throw new Error("valueComposer wrong type");
    }
    var JSONToParse = "";
    var toReplace = [];
    for (var i = 0; i < pValueComposer.length; i++) {
      var element = pValueComposer[i];
      if (element.type === "com.nixps.quantum.value.0") {
        JSONToParse = JSONToParse + element.value;
      } else {
        JSONToParse = JSONToParse + "${nixps.quantum.replace.variable.internal.use." + toReplace.length + "}";
        toReplace.push(element);
      }
    }
    var resultJSON;
    try {
      resultJSON = JSON.parse(JSONToParse);
      if (!$.isPlainObject(resultJSON)) {
        return {
          "": pValueComposer
        };
      }
    } catch (error) {
      if (Array.isArray(pValueComposer) && pValueComposer.length === 1 && pValueComposer[0] && pValueComposer[0].type === "com.nixps.quantum.value.0" && pValueComposer[0].value === "") {
        return {};
      }
      return {
        "": pValueComposer
      };
    }
    resultJSON = CloudflowObject.replaceEmptyArrayRows(resultJSON, "");
    var flattened = CloudflowObject.flatten(resultJSON, skipFlattenFn);

    // for (var i = 0; i < toReplace.length; i++) {
    //     var key = Object.keys(flattened).find(function(key){return flattened[key].indexOF("${nixps.quantum.replace.variable.internal.use."+i+"}") !== -1 });
    //     flattened[key] = flattened[key].split("${nixps.quantum.replace.variable.internal.use."+i+"}").join(toReplace[i]);
    // }

    var keys = Object.keys(flattened);
    keys = keys.sort(function (a, b) {
      return b > a ? 1 : -1;
    });
    var result = {};
    for (var i = 0; i < keys.length; i++) {
      var keyResult = [];
      var val = flattened[keys[i]];
      var replaceitemsIndex = [];
      for (var j = 0; j < toReplace.length; j++) {
        if (typeof val === "string" && val.indexOf("${nixps.quantum.replace.variable.internal.use." + j + "}") !== -1) {
          replaceitemsIndex.push({
            stringIndex: val.indexOf("${nixps.quantum.replace.variable.internal.use." + j + "}"),
            toReplaceIndex: j
          });
        }
      }
      replaceitemsIndex = replaceitemsIndex.sort(function (a, b) {
        return a.stringIndex > b.stringIndex ? 1 : -1;
      });
      var valClone = structuredClone(val);
      for (var j = 0; j < replaceitemsIndex.length; j++) {
        var currentStringIndex = valClone.indexOf("${nixps.quantum.replace.variable.internal.use." + replaceitemsIndex[j].toReplaceIndex + "}");
        keyResult.push({
          type: "com.nixps.quantum.value.0",
          value: valClone.slice(0, currentStringIndex)
        });
        keyResult.push(toReplace[replaceitemsIndex[j].toReplaceIndex]);
        valClone = valClone.slice(currentStringIndex + ("${nixps.quantum.replace.variable.internal.use." + replaceitemsIndex[j].toReplaceIndex + "}").length);
      }
      if (["string", "number", "boolean"].includes(_typeof(valClone))) {
        keyResult.push({
          type: "com.nixps.quantum.value.0",
          value: valClone
        });
      }
      if (keyResult.length === 0) {
        keyResult.push({
          type: "com.nixps.quantum.value.0",
          value: ""
        });
      }
      CloudflowObject.setParameter(result, keys[i], keyResult);
    }
    return result;
  },
  objectToTemplate: function objectToTemplate(pObject) {
    var emptyObject = {
      "": [{
        "type": "com.nixps.quantum.value.0",
        "value": ""
      }]
    };
    if (!$.isPlainObject(pObject)) {
      throw new Error("valueComposer wrong type for template");
    }
    if (_.isEqual(pObject, emptyObject)) {
      return "";
    }
    var copyObject = structuredClone(pObject);
    for (var key in copyObject) {
      if (isValueComposer(copyObject[key])) {
        copyObject[key] = this.valuecomposerToTemplate(copyObject[key]);
      } else if (Array.isArray(copyObject[key]) && copyObject[key].length > 0) {
        copyObject[key] = this.arrayToTemplate(copyObject[key]);
      } else if (copyObject[key] && Object.getPrototypeOf(copyObject[key]) === Object.prototype) {
        copyObject[key] = this.objectToTemplate(copyObject[key]);
      }
    }
    return JSON.stringify(copyObject, null, 2);
  },
  templateToObject: function templateToObject(pTemplate, pEntityComposerDefinitions) {
    if (typeof pTemplate === "string" && pTemplate.length > 0) {
      var parsed;
      try {
        parsed = JSON.parse(pTemplate);
        if (Array.isArray(parsed)) {
          parsed = {
            "": pTemplate
          };
        }
      } catch (e) {
        parsed = {
          "": pTemplate
        };
      }
      CloudflowObject.travers(parsed, function (pVal, pKey) {
        return ValueComposerTranslator.templateToValuecomposer(pVal, pEntityComposerDefinitions).valuecomposer;
      });
      return parsed;
    } else {
      return {};
    }
  },
  arrayToValueComposer: function arrayToValueComposer(pArray, pEntityComposerDefinitions, pAcceptEmptyArray) {
    var all_files_template = [{
      "type": "com.nixps.quantum.data_from_previous_node.0",
      "first_only": false
    }];
    if (!Array.isArray(pArray)) {
      throw new Error("valueComposer wrong type");
    }
    if (pAcceptEmptyArray === true && pArray.length <= 0) {
      return [];
    }
    if (pArray.length <= 0 || pArray.length === 1 && pArray[0].type === "com.nixps.quantum.value.0" && pArray[0].value === "") {
      return [{
        type: "com.nixps.quantum.value.0",
        value: ""
      }];
    }

    // If we detect all files from prev node return it without an array wrapped around it.
    if (CloudflowObject.contains(pArray, function (k, v) {
      return _typeof(v) === "object" && v.type === "com.nixps.quantum.data_from_previous_node.0" && v.first_only !== true;
    })) {
      return all_files_template;
    }
    var ReplacingExpression = [];
    pArray = CloudflowObject.replaceEmptyArrayRows(pArray, [{
      type: "com.nixps.quantum.value.0",
      value: ""
    }]);
    var flattend = CloudflowObject.flatten(pArray, skipFlattenFn);
    var flattenedKeys = Object.keys(flattend);
    var result = [];
    for (var i = 0; i < flattenedKeys.length; i++) {
      if (Array.isArray(flattend[flattenedKeys[i]])) {
        ReplacingExpression.push(flattend[flattenedKeys[i]]);
        flattend[flattenedKeys[i]] = "${nixps.quantum.replace.variable.internal.use." + (ReplacingExpression.length - 1) + "}";
      }
    }
    var replacedObject = [];
    for (var i = 0; i < flattenedKeys.length; i++) {
      CloudflowObject.setParameter(replacedObject, flattenedKeys[i], flattend[flattenedKeys[i]]);
    }
    var objectJSON = JSON.stringify(replacedObject);
    for (var i = 0; i < ReplacingExpression.length; i++) {
      objectJSON = objectJSON.split("${nixps.quantum.replace.variable.internal.use." + i + "}");
      result.push({
        type: "com.nixps.quantum.value.0",
        value: objectJSON[0]
      });
      for (var j = 0; j < ReplacingExpression[i].length; j++) {
        if (ReplacingExpression[i][j].type === "com.nixps.quantum.value.0") {
          ReplacingExpression[i][j].value = doubleEscape(ReplacingExpression[i][j].value);
        }
        result.push(ReplacingExpression[i][j]);
      }
      objectJSON = objectJSON[1];
    }
    if (typeof objectJSON === "string") {
      result.push({
        type: "com.nixps.quantum.value.0",
        value: objectJSON
      });
    }
    var simplifiedResult = [];
    for (var i = 0; i < result.length; i++) {
      if (simplifiedResult.length > 0 && simplifiedResult[simplifiedResult.length - 1].type === "com.nixps.quantum.value.0" && result[i].type === "com.nixps.quantum.value.0") {
        simplifiedResult[simplifiedResult.length - 1].value = simplifiedResult[simplifiedResult.length - 1].value + result[i].value;
      } else {
        simplifiedResult.push(result[i]);
      }
    }
    return simplifiedResult;

    // var template = this.arrayToTemplate(pArray);
    // return ValueComposerTranslator.templateToValuecomposer(template,pEntityComposerDefinitions).valuecomposer;
  },

  valueComposerToArray: function valueComposerToArray(pValueComposer, pEntityComposerDefinitions) {
    if (Array.isArray(pValueComposer) && pValueComposer.length <= 0) {
      return [];
    }
    if (!isValueComposer(pValueComposer)) {
      throw new Error("valueComposer wrong type");
    }
    var all_files_template = [{
      "type": "com.nixps.quantum.data_from_previous_node.0",
      "first_only": false
    }];
    if (_.isEqual(all_files_template, pValueComposer)) {
      return all_files_template;
    }
    var JSONToParse = "";
    var toReplace = [];
    for (var i = 0; i < pValueComposer.length; i++) {
      var element = pValueComposer[i];
      if (element.type === "com.nixps.quantum.value.0") {
        JSONToParse = JSONToParse + element.value;
      } else {
        JSONToParse = JSONToParse + "${nixps.quantum.replace.variable.internal.use." + toReplace.length + "}";
        toReplace.push(element);
      }
    }
    var resultJSON;
    try {
      resultJSON = JSON.parse(JSONToParse);
      if (!Array.isArray(resultJSON)) {
        return [pValueComposer];
      }
    } catch (error) {
      return [pValueComposer];
    }
    resultJSON = CloudflowObject.replaceEmptyArrayRows(resultJSON, "");
    var flattened = CloudflowObject.flatten(resultJSON, skipFlattenFn);

    // for (var i = 0; i < toReplace.length; i++) {
    //     var key = Object.keys(flattened).find(function(key){return flattened[key].indexOF("${nixps.quantum.replace.variable.internal.use."+i+"}") !== -1 });
    //     flattened[key] = flattened[key].split("${nixps.quantum.replace.variable.internal.use."+i+"}").join(toReplace[i]);
    // }

    var keys = Object.keys(flattened);
    var result = [];
    for (var i = 0; i < keys.length; i++) {
      var keyResult = [];
      var val = flattened[keys[i]];
      var replaceitemsIndex = [];
      for (var j = 0; j < toReplace.length; j++) {
        if (val.indexOf("${nixps.quantum.replace.variable.internal.use." + j + "}") !== -1) {
          replaceitemsIndex.push({
            stringIndex: val.indexOf("${nixps.quantum.replace.variable.internal.use." + j + "}"),
            toReplaceIndex: j
          });
        }
      }
      replaceitemsIndex = replaceitemsIndex.sort(function (a, b) {
        return a.stringIndex > b.stringIndex ? 1 : -1;
      });
      var valClone = structuredClone(val);
      for (var j = 0; j < replaceitemsIndex.length; j++) {
        var currentStringIndex = valClone.indexOf("${nixps.quantum.replace.variable.internal.use." + replaceitemsIndex[j].toReplaceIndex + "}");
        keyResult.push({
          type: "com.nixps.quantum.value.0",
          value: valClone.slice(0, currentStringIndex)
        });
        keyResult.push(toReplace[replaceitemsIndex[j].toReplaceIndex]);
        valClone = valClone.slice(currentStringIndex + ("${nixps.quantum.replace.variable.internal.use." + replaceitemsIndex[j].toReplaceIndex + "}").length);
      }
      if (typeof valClone === "string" && valClone.length > 0) {
        keyResult.push({
          type: "com.nixps.quantum.value.0",
          value: valClone
        });
      }
      if (keyResult.length === 0) {
        keyResult.push({
          type: "com.nixps.quantum.value.0",
          value: ""
        });
      }
      CloudflowObject.setParameter(result, keys[i], keyResult);
    }
    return result;
  },
  arrayToTemplate: function arrayToTemplate(pArray) {
    var emptyArray = [[{
      "type": "com.nixps.quantum.value.0",
      "value": ""
    }]];
    if (!Array.isArray(pArray)) {
      throw new Error("valueComposer wrong type");
    }
    if (_.isEqual(pArray, emptyArray)) {
      return "";
    }
    var template = "[";
    for (var i = 0; i < pArray.length; i++) {
      if (i > 0) {
        template += ",";
      }
      template += "\"" + encodeLimited(ValueComposerTranslator.valuecomposerToTemplate(pArray[i])) + "\"";
    }
    template += "]";
    if (template === "[\"${files.previous}\"]" || template === "[${files.previous}]") {
      return "${files.previous}";
    }
    return template;
  },
  templateToArray: function templateToArray(pTemplate, pEntityComposerDefinitions) {
    var resultArray = [];
    if (typeof pTemplate !== "string" || pTemplate.length <= 0) {
      return [[{
        type: "com.nixps.quantum.value.0",
        value: ""
      }]];
    }
    if (pTemplate === "${files.previous}") {
      return [[{
        "type": "com.nixps.quantum.data_from_previous_node.0",
        "first_only": false
      }]];
    }
    if (pTemplate.charAt(0) === "[" || pTemplate[pTemplate.length - 1] === "]") {
      var strippedTemplate = pTemplate.split("\"").join("") + "";
      if (strippedTemplate.charAt(0) === "[") {
        strippedTemplate = strippedTemplate.substring(1);
      }
      if (strippedTemplate[strippedTemplate.length - 1] === "]") {
        strippedTemplate = strippedTemplate.slice(0, -1);
      }
      var splitTemplate = strippedTemplate.split(",");
      for (var i = 0; i < splitTemplate.length; i++) {
        resultArray.push(ValueComposerTranslator.templateToValuecomposer(decodeLimited(splitTemplate[i]), pEntityComposerDefinitions).valuecomposer);
      }
      return resultArray;
    } else {
      return [ValueComposerTranslator.templateToValuecomposer(pTemplate, pEntityComposerDefinitions).valuecomposer];
    }
  },
  valuecomposerToTemplate: function valuecomposerToTemplate(pValueComposer) {
    if (Array.isArray(pValueComposer) && pValueComposer.length === 0) {
      return "";
    }

    // The input must be a array, otherwise it is not a valid valueComposer
    if (isValueComposer(pValueComposer)) {
      var outputContentString = '';
      // loop over all the child objects
      // if it is a value => add the value to the string
      // it it is a variable => add the template variable ${name} to the string
      var template;
      for (var i = 0; i < pValueComposer.length; i++) {
        if (pValueComposer[i] && typeof pValueComposer[i].type === "string") {
          template = this.fromFrontEndToTemplate(this.fromBackEnd([pValueComposer[i]]));
          outputContentString += template;
        } else {
          // the child of a valuecomposer must be a object
          throw new Error('invalid ValueComposer detected');
        }
      }
      return outputContentString;
    }
    return "";
  },
  fromFrontEndToTemplate: function fromFrontEndToTemplate(pValueComposerComp, pAppendString) {
    if (isValueComposer(pValueComposerComp) === false) {
      throw new Error('input must be value composer');
    }
    if (pAppendString === undefined) {
      pAppendString = '}';
    }
    var valueComposerElem = pValueComposerComp[0];
    switch (valueComposerElem.type) {
      case "com.nixps.quantum.value.0":
        return valueComposerElem.value;
      case "com.nixps.quantum.variable.0":
        if (typeof valueComposerElem.source === "string" && valueComposerElem.source.length > 0) {
          return '${variable.' + valueComposerElem.source + "/" + valueComposerElem.variable + pAppendString;
        }
        return '${variable.' + valueComposerElem.variable + pAppendString;
      case "com.nixps.quantum.file_name.0":
        return '${file.file_name' + pAppendString;
      case "com.nixps.quantum.file_name_without_extension.0":
        return "${file.file_name_without_extension" + pAppendString;
      case "com.nixps.quantum.file_name_extension.0":
        return "${file.file_name_extension" + pAppendString;
      case "com.nixps.quantum.full_file_url.0":
        return "${file.full_file_url" + pAppendString;
      case "com.nixps.quantum.folder_path.0":
        return "${file.folder_path" + pAppendString;
      case "com.nixps.quantum.generate_uuid.0":
        return "${general.generate_uuid" + pAppendString;
      case "com.nixps.quantum.last_error.0":
        return "${general.last_error" + pAppendString;
      // case 'com.nixps.quantum.url_to_local_path.0':
      // 	return "${general.url_to_local_path" + pAppendString;
      case 'com.nixps.quantum.url_encoder.0':
        return "${general.url_encoder" + pAppendString;
      case "com.nixps.quantum.role.0":
        return "${role." + valueComposerElem.role + pAppendString;
      case "com.nixps.pagebuilder.current_user.0":
        return "${current_user." + valueComposerElem.part + pAppendString;
      case "com.nixps.quantum.logical.0":
        return "${logical." + valueComposerElem.logical + pAppendString;
      case "com.nixps.quantum.workable_info.0":
        return "${workable." + valueComposerElem.part + pAppendString;
      case "com.nixps.quantum.current_time.0":
        switch (valueComposerElem.format) {
          case "%Y":
            return "${date.year" + pAppendString;
          case "%B":
            return "${date.month" + pAppendString;
          case "%m":
            return "${date.month_number" + pAppendString;
          case "%A":
            return "${date.weekday" + pAppendString;
          case "%d":
            return "${date.month_day" + pAppendString;
          default:
            return "${date." + valueComposerElem.format + pAppendString;
        }
      case "com.nixps.quantum.current_hour.0":
        switch (valueComposerElem.format) {
          case "%H":
            return "${time.hour" + pAppendString;
          case "%M":
            return "${time.minutes" + pAppendString;
          case "%S":
            return "${time.seconds" + pAppendString;
          case "%FT%H:%M:%SZ":
            return "${time.iso" + pAppendString;
          default:
            return "${time." + valueComposerElem.format + pAppendString;
        }
      case "com.nixps.quantum.quantum_data_from_node.0":
        return "${container." + valueComposerElem.node_name.replace(/\./g, "\\.") + "." + valueComposerElem.sub_json_path + pAppendString;
      case "com.nixps.quantum.data_from_previous_node.0":
        return "${container." + PREVIOUS + "." + valueComposerElem.sub_json_path + pAppendString;
      case "com.nixps.quantum.characters_of.0":
        // if ends with '}' remove this last char
        if (pAppendString.charAt(pAppendString.length - 1) === '}') {
          pAppendString = pAppendString.slice(0, -1);
        }
        // append to appendString
        pAppendString = this.charactersOfToTemplate(pValueComposerComp) + pAppendString + '}';
        return this.fromFrontEndToTemplate(valueComposerElem.input, pAppendString);
      case "com.nixps.quantum.length_of.0":
        pAppendString = ":size()" + pAppendString;
        return this.fromFrontEndToTemplate(valueComposerElem.input, pAppendString);
      case "com.nixps.quantum.project.contents.0":
        return "${project.contents." + valueComposerElem.json_path + pAppendString;
      case "com.nixps.quantum.project.sub_projects_contents.0":
        return "${project.sub_projects_contents." + valueComposerElem.tag + "." + valueComposerElem.json_path + pAppendString;
      case "com.nixps.quantum.project.files.0":
        return "${project.files." + valueComposerElem.tag + pAppendString;
      case "com.nixps.quantum.project.one_file.0":
        return "${project.one_file." + valueComposerElem.tag + pAppendString;
      case "com.nixps.quantum.project.folders.0":
        return "${project.folders." + valueComposerElem.tag + pAppendString;
      case "com.nixps.quantum.project.one_folder.0":
        return "${project.one_folder." + valueComposerElem.tag + pAppendString;
      case "com.nixps.quantum.all_files_from_node.0":
        return "${files." + valueComposerElem.node_name + pAppendString;
      case "com.nixps.quantum.project.team_members.0":
        return "${project.team_members." + valueComposerElem.role + '.' + valueComposerElem.json_path + pAppendString;
      case "com.nixps.localization.look_up.0":
        return "${translation." + valueComposerElem.translation_key + pAppendString;
      case "com.nixps.quantum.type_converter.0":
        pAppendString = ":convert_to(" + valueComposerElem.to_type + ")" + pAppendString;
        return this.fromFrontEndToTemplate(valueComposerElem.value, pAppendString);
      case "com.nixps.quantum.unit_converter.0":
        pAppendString = ":convert_unit(" + valueComposerElem.from_unit + "," + valueComposerElem.to_unit + ")" + pAppendString;
        return this.fromFrontEndToTemplate(valueComposerElem.value, pAppendString);
      case "com.nixps.preferences.user.0":
        valueComposerElem.application_id = valueComposerElem.application_id || "";
        valueComposerElem.sub_key = valueComposerElem.sub_key || valueComposerElem.preference_key;
        valueComposerElem.system_realm_only = valueComposerElem.system_realm_only || false;
        return "${preferences_user." + valueComposerElem.application_id + "/" + valueComposerElem.sub_key + "/" + valueComposerElem.system_realm_only + pAppendString;
      case "com.nixps.device.settings.0":
        return "${device." + valueComposerElem.parameter + pAppendString;
      case "com.nixps.quantum.calculations.0":
        var calcVC = this.operationsToValueComposer(pValueComposerComp[0].operations);
        var result = "";
        for (var i = 0; i < calcVC.length; i++) {
          result = result + this.fromFrontEndToTemplate([calcVC[i]]);
        }
        return result;
      case "com.nixps.quantum.object.0":
        if (Array.isArray(valueComposerElem.object)) {
          return this.arrayToTemplate(valueComposerElem.object);
        } else if (valueComposerElem.object && _typeof(valueComposerElem.object) === "object") {
          return this.objectToTemplate(valueComposerElem.object);
        } else {
          throw new Error("invalid value composer com.nixps.quantum.object.0");
        }
      case "com.nixps.quantum.conditional.0":
        var condition = "[]";
        if (Array.isArray(valueComposerElem.condition)) {
          condition = this.arrayToTemplate(valueComposerElem.condition.map(function (pCond) {
            if (["string", "number", "boolean"].includes(_typeof(pCond))) {
              return [{
                type: "com.nixps.quantum.value.0",
                value: pCond
              }];
            }
            return pCond;
          }));
        }
        return "${conditional." + condition + pAppendString;
      default:
        throw new Error("invalid value composer element");
    }
  },
  charactersOfToTemplate: function charactersOfToTemplate(pValueComposer) {
    if (isValueComposer(pValueComposer) === false) {
      throw new Error('input must be value composer');
    }
    var valueComposerElem = pValueComposer[0];
    var outputString = ":substring(";
    var fromToMode = valueComposerElem.mode.split('+'); // array first elem is first mode second elem is second function
    if (fromToMode[0] === "FromIndex") {
      outputString += "''," + valueComposerElem.from_index + ",";
    } else if (fromToMode[0] === "FromSearch") {
      outputString += "'" + valueComposerElem.from_search_string.replace(/(['"\\}])/g, "\\$1") + "'," + valueComposerElem.from_index + ',';
    } else {
      throw new Error('invalid mode of characters valuecomposer');
    }
    if (fromToMode[1] === "ToIndex") {
      outputString += "''," + valueComposerElem.to_index;
    } else if (fromToMode[1] === "ToSearch") {
      outputString += "'" + valueComposerElem.to_search_string.replace(/(['"\\}])/g, "\\$1") + "'," + valueComposerElem.to_index;
    } else {
      throw new Error('invalid mode of characters valuecomposer');
    }
    outputString += ')';
    return outputString;
  },
  templateToCharactersOf: function templateToCharactersOf(pTemplate) {
    if (typeof pTemplate !== "string" || pTemplate.length <= 0) {
      throw new Error('pTemplate must be a string');
    }
    var outputValueComposer = {
      type: "com.nixps.quantum.characters_of.0",
      "include_from_search_string": false,
      "include_to_search_string": false
    };
    var functionArguments = getArguments(pTemplate);
    // format string arguments, this implice removing " en ' at beginning and end of string
    if (typeof functionArguments[0] === "string" && functionArguments[0].charAt(0) === functionArguments[0].charAt(functionArguments[0].length - 1)) {
      // remove first and last character
      functionArguments[0] = functionArguments[0].slice(0, -1).slice(1).replace(/\\(['"\\}])/g, "$1");
    } else {
      throw new Error('function first argument must be a string');
    }
    if (typeof functionArguments[2] === "string" && functionArguments[2].charAt(0) === functionArguments[2].charAt(functionArguments[2].length - 1)) {
      // remove first and last character
      functionArguments[2] = functionArguments[2].slice(0, -1).slice(1).replace(/\\(['"\\}])/g, "$1");
    } else {
      throw new Error('function thirth argument must be a string');
    }
    // translate to value composer 
    if (typeof functionArguments[0] === "string" && functionArguments[0].length > 0) {
      outputValueComposer.mode = "FromSearch+";
    } else {
      outputValueComposer.mode = "FromIndex+";
    }
    if (typeof functionArguments[2] === "string" && functionArguments[2].length > 0) {
      outputValueComposer.mode += "ToSearch";
    } else {
      outputValueComposer.mode += "ToIndex";
    }
    outputValueComposer.from_index = parseInt(functionArguments[1]);
    outputValueComposer.from_search_string = functionArguments[0];
    outputValueComposer.to_index = parseInt(functionArguments[3]);
    outputValueComposer.to_search_string = functionArguments[2];
    return [outputValueComposer];
  }
};
module.exports = ValueComposerTranslator;

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"./BuildingBlock.js":107,"./EntityComposer.js":109}],114:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var ValueComposerTranslator = require("./ValueComposerTranslator.js");
var ValueComposerUtil = function ValueComposerUtil() {};
/**
* @description the technical key to indicate: that no transformer will be applied
* @enum
* @constant
*/
ValueComposerUtil.types = Object.freeze({
  /** there is no casting applied */
  NO_CASTING_FORMAT: "as_is",
  /** an array, or vector */
  ARRAY: "array",
  /** a plain js object, key values */
  OBJECT: "object"
});
ValueComposerUtil.isValueComposer = function (pValueComposerJSON) {
  return Array.isArray(pValueComposerJSON) && pValueComposerJSON.length > 0 && typeof pValueComposerJSON[0].type === "string" && pValueComposerJSON[0].type.indexOf("com.nixps.") === 0;
};
ValueComposerUtil.isValueComposerExtend = function (pValueComposerJSON) {
  if (ValueComposerUtil.isValueComposer(pValueComposerJSON) === true) {
    return true;
  } else if (Array.isArray(pValueComposerJSON) && pValueComposerJSON.length > 0) {
    for (var i = 0; i < pValueComposerJSON.length; i++) {
      if (!ValueComposerUtil.isValueComposer(pValueComposerJSON[i])) {
        return false;
      }
    }
    return true;
  } else if ($.isPlainObject(pValueComposerJSON)) {
    var keys = Object.keys(pValueComposerJSON);
    for (var i = 0; i < keys.length; i++) {
      if (!ValueComposerUtil.isValueComposerExtend(pValueComposerJSON[keys[i]])) {
        return false;
      }
    }
    return true;
  } else {
    return false;
  }
};

/**
 * @description Get an empty value composer, containing an empty string
 * @function
 * @name ValueComposerUtil.getEmptyValueComposer
 * @returns Array
 */
ValueComposerUtil.getEmptyValueComposer = function () {
  return [{
    "type": "com.nixps.quantum.value.0",
    "value": ""
  }];
};
ValueComposerUtil.replaceVariables = function (pValueComposerJSON, pValue) {
  if (this.isValueComposer(pValueComposerJSON)) {
    if (pValueComposerJSON[0].type === "com.nixps.quantum.generate_uuid.0") {
      // do nothing
    } else if (["com.nixps.quantum.characters_of.0", "com.nixps.quantum.length_of.0"].includes(pValueComposerJSON[0].type)) {
      this.replaceVariables(pValueComposerJSON[0].input, pValue);
    } else if (["com.nixps.quantum.unit_converter.0"].includes(pValueComposerJSON[0].type)) {
      this.replaceVariables(pValueComposerJSON[0].value, pValue);
    } else if (pValueComposerJSON[0].type === "com.nixps.quantum.all_files_from_node.0") {
      pValueComposerJSON[0].type = "com.nixps.quantum.value.0";
      // add default value for "all files node" 
      pValueComposerJSON[0].value = ["cloudflow://PP_FILE_STORE/04_beautybiz3.pdf", "cloudflow://PP_FILE_STORE/04_beautybiz32.pdf"];
    } else {
      pValueComposerJSON[0].type = "com.nixps.quantum.value.0";
      pValueComposerJSON[0].value = pValue;
    }
  }
};
ValueComposerUtil.getProviderAndTransformers = function (json, definitions) {
  var transformers = [];
  var provider = null;
  var entity = json[0];
  var definition = definitions.getEntityComposer(entity.type);
  while (definition.getType() !== "provider") {
    transformers.unshift(entity);
    entity = entity[definition.getInputField()][0];
    definition = definitions.getEntityComposer(entity.type);
  }
  provider = entity;
  return {
    provider: provider,
    transformers: transformers
  };
};

/**
 * @description control if the format is a well formed and known by backend?
 * @function
 * @param {string} pFormat - the format to control
 * @returns {Boolean} true if format is a good type converter type, recognise by backend, false if format is not kown by backend
 */
ValueComposerUtil.isValidCastingFormat = function (pFormat) {
  if (typeof pFormat !== "string" || pFormat.length === 0) {
    return false;
  }
  // control if format is pressent in the fix list of known formats
  return ["number", "string", "boolean", "array", "object"].includes(pFormat);
};

/**
 * @description cast a valuecomposer to a specific format
 * @function
 * @param {array|valuecomposer} pValueComposerJSON the valuescomposer to cast
 * @param {string} pCastingFormat - the format to casting to
 * @returns {Array|nixps.quantum.ValueComposerUtil.addCasting.outputValueComposerJSON} the casted valuecomposer
 */
ValueComposerUtil.addCasting = function (pValueComposerJSON, pCastingFormat, pEntityComposerDefinitions) {
  // control input fields
  if (typeof pCastingFormat !== "string" || pCastingFormat.length <= 0) {
    throw new Error("invalid casting format");
  }
  if (pCastingFormat === this.types.NO_CASTING_FORMAT) {
    // return directly if nothing is needed
    return pValueComposerJSON;
  } else if (this.isValidCastingFormat(pCastingFormat) === false) {
    throw new Error("unknown casting format " + pCastingFormat);
  }
  if (!this._isValidExpression(pValueComposerJSON)) {
    throw new Error("invalid expression");
  }
  if (pCastingFormat === "array") {
    return ValueComposerTranslator.valueComposerToArray(pValueComposerJSON, pEntityComposerDefinitions);
  } else if (pCastingFormat === "object") {
    return ValueComposerTranslator.valueComposerToObject(pValueComposerJSON, pEntityComposerDefinitions);
  }
  // converting algoritme
  return [{
    type: "com.nixps.quantum.type_converter.0",
    top_level: true,
    to_type: pCastingFormat,
    value: pValueComposerJSON
  }];
};

/**
 * @description get the casting format it is used in the valuecomposer, the casting transformer must be at the root!
 * @param {array|valuecomposer} pValueComposerJSON the valuecomposer conatining casting
 * @returns {String} the casting format
 */
ValueComposerUtil.getCastingFormat = function (pValueComposerJSON) {
  // short cut for empty things
  if (Array.isArray(pValueComposerJSON) && pValueComposerJSON.length === 0) {
    return this.types.NO_CASTING_FORMAT;
  }
  // no value composers, return null 
  if (!this._isValidExpression(pValueComposerJSON)) {
    return null;
  }
  if (Object.getPrototypeOf(pValueComposerJSON) === Object.prototype) {
    // global is plain object > object
    // first check an object, because we can have objects with key "0"
    return this.types.OBJECT;
  } else
    // first item is array > array
    if (Array.isArray(pValueComposerJSON[0])) {
      return this.types.ARRAY;
      // global is plain object > object
    } else if (_typeof(pValueComposerJSON) === "object" && !Array.isArray(pValueComposerJSON)) {
      return this.types.OBJECT;
    }

  // converters
  if (pValueComposerJSON[0].type === "com.nixps.quantum.type_converter.0") {
    if (pValueComposerJSON[0].top_level === true) {
      return pValueComposerJSON[0].to_type;
    }
    // fallback old setups
    if (Array.isArray(pValueComposerJSON[0].value) && pValueComposerJSON[0].value.length <= 1) {
      return this.types.NO_CASTING_FORMAT;
    }
    return pValueComposerJSON[0].to_type;
  }
  // plain object
  if (pValueComposerJSON[0].type === "com.nixps.quantum.object.0") {
    if ($.isPlainObject(pValueComposerJSON[0].object)) {
      return this.types.OBJECT;
    } else if (Array.isArray(pValueComposerJSON[0].object)) {
      return this.types.ARRAY;
    }
  }
  return this.types.NO_CASTING_FORMAT;
};

/**
 * @description remove the fist transformer of each element that is a casting transformer. 
 * @function
 * @param {array|valuecomposer} pValueComposerJSON
 * @returns {Array|nixps.quantum.ValueComposerUtil.removeCastingFormat.outputValueComposer}
 */
ValueComposerUtil.removeCastingFormat = function (pValueComposerJSON, pEntityComposerDefinitions) {
  // short cut for empty things
  if (Array.isArray(pValueComposerJSON) && pValueComposerJSON.length === 0) {
    return pValueComposerJSON;
  }
  if (_typeof(pValueComposerJSON) === "object" && Object.keys(pValueComposerJSON).length === 0) {
    return pValueComposerJSON;
  }
  // control input fields
  if (!this._isValidExpression(pValueComposerJSON)) {
    throw new Error("invalid expression");
  }
  if (Array.isArray(pValueComposerJSON) && pValueComposerJSON.length > 0 && Array.isArray(pValueComposerJSON[0]) && pValueComposerJSON[0].length > 0) {
    return ValueComposerTranslator.arrayToValueComposer(pValueComposerJSON, pEntityComposerDefinitions);
  }
  if (_typeof(pValueComposerJSON) === "object" && !Array.isArray(pValueComposerJSON) && Object.keys(pValueComposerJSON).length > 0) {
    return ValueComposerTranslator.objectToValueComposer(pValueComposerJSON);
  }
  var outputValueComposer = [];
  for (var i = 0; i < pValueComposerJSON.length; i++) {
    if (pValueComposerJSON[i].type === "com.nixps.quantum.type_converter.0") {
      outputValueComposer = outputValueComposer.concat(pValueComposerJSON[i].value);
    } else {
      outputValueComposer.push(pValueComposerJSON[i]);
    }
  }
  return outputValueComposer;
};
ValueComposerUtil._isValidExpression = function (pExpression) {
  if (this.isValueComposer(pExpression) !== false) {
    return true;
  } else if (Array.isArray(pExpression) && pExpression.length > 0) {
    for (var i = 0; i < pExpression.length; i++) {
      var element = pExpression[i];
      if (this.isValueComposer(element)) {
        return true;
      } else if (this._isValidExpression(element) === false) {
        return false;
      }
    }
    return true;
  } else if ($.isPlainObject(pExpression)) {
    var keys = Object.keys(pExpression);
    for (var i = 0; i < keys.length; i++) {
      var element = pExpression[keys[i]];
      if (_typeof(element) === "object") {
        return this._isValidExpression(element);
      } else if (!this.isValueComposer(element)) {
        return false;
      }
    }
    return true;
  } else {
    return false;
  }
};

/**
 * @description try to convert a value composer to a string, to represent it to the user
 * @function
 * @name ValueComposerUtil.convertToString
 * @static
 * @param {mixed} pValueArray 
 * @returns {String}
 */
ValueComposerUtil.convertToString = function (pValueArray) {
  if (typeof pValueArray === "string" || typeof pValueArray === "number" || typeof pValueArray === "boolean") {
    return "" + pValueArray;
  }
  if (Array.isArray(pValueArray)) {
    if (pValueArray.length === 0) {
      return "";
    }
    // if coat of type converter, remove coat
    var typeConverterValueComposer = [];
    for (var i = 0; i < pValueArray.length; i++) {
      if (pValueArray[i].type === "com.nixps.quantum.type_converter.0" && pValueArray[i].to_type === "string") {
        typeConverterValueComposer = typeConverterValueComposer.concat(pValueArray[i].value);
      } else {
        typeConverterValueComposer.push(pValueArray[i]);
      }
    }
    pValueArray = typeConverterValueComposer;
    if (pValueArray.length > 1) {
      for (var i = pValueArray.length - 1; i > 0; i--) {
        if (pValueArray[i].type === "com.nixps.quantum.value.0" && pValueArray[i - 1].type === "com.nixps.quantum.value.0") {
          pValueArray[i - 1].value += pValueArray[i].value;
          pValueArray.splice(i, 1);
        }
      }
    }
    // is it one specific value composer?
    if (pValueArray.length === 1 && pValueArray[0] !== undefined && pValueArray[0].type === "com.nixps.quantum.value.0") {
      if (typeof pValueArray[0].value === "string") {
        return pValueArray[0].value; // return specific that value because it can be an value different then a string
      }
    }
  }

  return null;
};

/**
 * @description transform a value composer to its orginal value, use when switching from vc to input with alt key.
 * retrieve the inner value
 * @function
 * @name ValueComposerUtil.castToValue
 * @static
 * @param {mixed} pValueComposer 
 * @param {Boolean} pAcceptObjectAsValueComposer 
 * @returns the original value hidden in the value composer
 */
ValueComposerUtil.castToValue = function (pValueComposer, pAcceptObjectAsValueComposer) {
  if (["string", "number", "boolean"].includes(_typeof(pValueComposer))) {
    return pValueComposer;
  } else if (pAcceptObjectAsValueComposer === true && pValueComposer !== null && _typeof(pValueComposer) === "object" && !Array.isArray(pValueComposer)) {
    return pValueComposer;
  } else if (Array.isArray(pValueComposer)) {
    for (var i = 0; i < pValueComposer.length; i++) {
      if ($.isPlainObject(pValueComposer[i]) === false || typeof pValueComposer[i].type !== "string" || pValueComposer[i].type.indexOf("com.nixps.") !== 0) {
        return pValueComposer;
      }
    }
  }

  // if coat of type converter, remove coat
  if (pValueComposer.length === 1 && pValueComposer[0] !== undefined && pValueComposer[0].type === "com.nixps.quantum.type_converter.0") {
    if (pValueComposer[0].to_type === "string") {
      return ValueComposerUtil.castToValue(pValueComposer[0].value, pAcceptObjectAsValueComposer);
    } else if (pValueComposer[0].to_type === "number") {
      return parseFloat(ValueComposerUtil.castToValue(pValueComposer[0].value, pAcceptObjectAsValueComposer));
    } else if (pValueComposer[0].to_type === "boolean") {
      var bool = ("" + ValueComposerUtil.castToValue(pValueComposer[0].value, pAcceptObjectAsValueComposer)).toLowerCase().trim();
      if (["true", "yes", "1", "t"].includes(bool)) {
        return true;
      } else if (["false", "no", "0", "f"].includes(bool)) {
        return false;
      }
      return bool;
    }
  } else if (pValueComposer.length === 1 && pValueComposer[0] !== undefined && pValueComposer[0].type === "com.nixps.quantum.object.0") {
    pValueComposer = pValueComposer[0].object;
  }

  // in the rest of the code, we known that the value is an array and an value composer!
  // is it one specific value composer?
  if (pValueComposer.length === 1 && pValueComposer[0] !== undefined && pValueComposer[0].type === "com.nixps.quantum.value.0") {
    return pValueComposer[0].value; // return specific that value because it can be an value different then a string
  }

  var outputValue = "";
  // we are one specific array
  for (var i = 0; i < pValueComposer.length; i++) {
    if (pValueComposer[i]) {
      if (pValueComposer[i].type === "com.nixps.quantum.value.0") {
        outputValue += pValueComposer[i].value;
      } else if (pValueComposer[0].type === "com.nixps.quantum.variable.0" && pValueComposer[0].default_value !== undefined) {
        // if default value is present use that
        if (_typeof(pValueComposer[0].default_value) === "object") {
          outputValue += JSON.stringify(pValueComposer[0].default_value);
        } else {
          outputValue += pValueComposer[0].default_value;
        }
      } else if (pValueComposer[0].type === "com.nixps.quantum.generate_uuid.0") {
        outputValue += "822cf72e-64f3-4f4a-1e3c-697d252e9cd9"; // some example value
      }
    }
  }

  return outputValue;
};

/**
 * @description translate a plain original value with normal interface to a basic value composer, representing that value
 * @function
 * @name ValueComposerUtil.translateToValueComposer
 * @param {mixed} pValue the input value to translate
 * @returns A value composer from a plain original interface
 */
ValueComposerUtil.translateToValueComposer = function (pValue) {
  if (pValue === undefined || pValue === null) {
    pValue = "";
  }
  if (["number", "string", "boolean"].includes(_typeof(pValue))) {
    return [{
      "type": "com.nixps.quantum.value.0",
      "value": pValue
    }];
  }
  return pValue;
};

/**
 * @function
 * @description Check if the value composer is a comming from a calculation
 * @name ValueComposerUtil.isValueComposerACalculation
 * @param {Array} pValueComposer The value composer to check
 * @returns Boolean true if the vc is a calculation
 */
ValueComposerUtil.isValueComposerACalculation = function (pValueComposer) {
  return Array.isArray(pValueComposer) && pValueComposer.length > 0 && pValueComposer[0].type === "com.nixps.quantum.calculations.0";
};

/**
 * @function
 * @description Check if the value composer is a comming from a condition
 * @name ValueComposerUtil.isValueComposerConditional
 * @param {Array} pValueComposer The value composer to check
 * @returns Boolean true if the vc is a conditional
 */
ValueComposerUtil.isValueComposerConditional = function (pValue) {
  return Array.isArray(pValue) && pValue.length === 1 && pValue[0].type === "com.nixps.quantum.conditional.0";
};
ValueComposerUtil.removeConditional = function (pValue) {
  if (ValueComposerUtil.isValueComposerConditional(pValue)) {
    if (Array.isArray(pValue[0].condition)) {
      if (pValue[0].condition.length > 0) {
        return pValue[0].condition[0];
      }
    }
    return ValueComposerUtil.getEmptyValueComposer();
  }
};
module.exports = ValueComposerUtil;

},{"./ValueComposerTranslator.js":113}],115:[function(require,module,exports){
"use strict";

var WorkflowDataCollection = function WorkflowDataCollection(result) {
  // Default construction
  if (result === undefined) {
    this.rootNames = [];
    this.variableData = [];
  } else {
    if (!Array.isArray(result.entities)) {
      result.entities = [];
    }
    var variableEntities = result.entities.find(function (e) {
      return e.identifier === "com.nixps.quantum.data_from_node.0";
    });
    if (variableEntities === undefined || !Array.isArray(variableEntities.values)) {
      this.rootNames = [];
      this.variableData = [];
      return;
    }
    this.rootNames = variableEntities.values.filter(function (ve) {
      return ve.is_data === true;
    }).map(function (ve) {
      return ve.parameters.node_name;
    });
    this.variableData = variableEntities.values;
  }
};
WorkflowDataCollection.getForContext = function (context) {
  return api_defer.whitepaper.get_value_composer_editor_configuration(context).then(function (pResult) {
    return new WorkflowDataCollection(pResult);
  });
};
WorkflowDataCollection.prototype = {
  constructor: WorkflowDataCollection,
  /**
   * @brief returns all the variable names
   */
  getNames: function getNames() {
    return this.rootNames.slice();
  },
  /**
   * @brief returns true if the variable has a sample
   */
  hasSample: function hasSample(pName) {
    var entry = undefined;
    if (Array.isArray(this.variableData)) {
      entry = this.variableData.find(function (vd) {
        return vd.parameters.node_name === pName;
      });
    }
    return entry !== undefined;
  },
  /**
   * @brief returns the sample given the name
   * @param {string} name of the root tree
   */
  getSample: function getSample(name) {
    var entry = undefined;
    if (Array.isArray(this.variableData)) {
      entry = this.variableData.find(function (vd) {
        return vd.parameters.node_name === name;
      });
    }
    if (entry === undefined) {
      throw new Error("no sample for variable: " + name);
    }
    return entry.sample;
  },
  /**
   * @brief this function returns the specifiek sample value of a variable deep in the sampletree
   * this function try to return a value in all situation even if input parameters don"t match with content
   * @param {string} pName, the path name of the variable parentnodes are separated by dots.
   * ex "file_info.file.blabla"
   * @returns {Mixed} the tree or the specifiek default sample in string format
   * @default ""
   */
  getSampleForPath: function getSampleForPath(pName) {
    if (typeof pName !== "string" || pName.length <= 0) {
      throw new Error("invalid variable name");
    }
    var treeNodes = pName.split(".");
    if (treeNodes.length === 0) {
      return "";
    }
    if (this.hasSample(treeNodes[0]) === true) {
      var tree = this.getSample(treeNodes[0]);
      var iteratorNode = tree;
      for (var i = 1; i < treeNodes.length; i++) {
        iteratorNode = iteratorNode[treeNodes[i]];
        if (iteratorNode === undefined) {
          return "";
        }
      }
      return iteratorNode;
    }
    return "";
  }
};
module.exports = WorkflowDataCollection;

},{}],116:[function(require,module,exports){
"use strict";

var WorkflowVariableCollection = function WorkflowVariableCollection(result) {
  // Default construction
  if (result === undefined) {
    this.rootNames = [];
    this.variableData = [];
  } else {
    if (!Array.isArray(result.entities)) {
      result.entities = [];
    }
    var variableEntities = result.entities.find(function (e) {
      return e.identifier === "com.nixps.quantum.variable.0";
    });
    if (variableEntities === undefined) {
      this.rootNames = [];
      this.variableData = [];
      return;
    }
    this.rootNames = variableEntities.values.filter(function (ve) {
      return typeof ve.label === "string" && ve.label.indexOf('.') === -1 || typeof ve.label === "number";
    }).map(function (ve) {
      return ve.label;
    });
    this.variableData = variableEntities.values;
  }
};
WorkflowVariableCollection.getForContext = function (context) {
  return api_defer.whitepaper.get_value_composer_editor_configuration(context).then(function (pResult) {
    return new WorkflowVariableCollection(pResult);
  });
};
WorkflowVariableCollection.prototype = {
  constructor: WorkflowVariableCollection,
  /**
   * @brief adds a variable
   */
  addVariable: function addVariable(pName) {
    if (typeof pName !== "string" || pName.length === 0) {
      throw new Error('invalid variable name');
    }
    if (this.rootNames.indexOf(pName) === -1) {
      this.rootNames.push(pName);
    }
  },
  /**
   * @brief returns all the variable names
   */
  getNames: function getNames() {
    return this.rootNames.slice();
  },
  getCategories: function getCategories() {
    var categories = this.variableData.filter(function (elem) {
      if (elem !== undefined && typeof elem.category === "string" && elem.category.length > 0) {
        return true;
      }
      return false;
    }).map(function (elem) {
      return elem.category;
    });
    return _.uniq(categories);
  },
  /**
   * @brief returns true if the variable has a sample
   */
  hasSample: function hasSample(pName) {
    var entry = this.variableData.find(function (vd) {
      return vd.label === pName;
    });
    return entry !== undefined && entry.sample !== undefined;
  },
  /**
   * @brief returns the sample given the name
   * @param {string} name of the root tree
   */
  getSample: function getSample(name) {
    var entry = this.variableData.find(function (vd) {
      return vd.label === name;
    });
    if (entry === undefined) {
      throw new Error('no sample for variable: ' + name);
    }
    return entry.sample;
  },
  getVariable: function getVariable(name) {
    var entry = this.variableData.find(function (vd) {
      return vd.label === name;
    });
    if (entry === undefined) {
      return undefined;
    }
    if (entry.parameters === undefined) {
      return undefined;
    }
    return entry.parameters.variable;
  },
  /**
   * @description Has the item a gategory?
   * @function
   * @param {type} pNamet he name of the element to search
   * @return {Boolean}
   */
  hasCategory: function hasCategory(pName) {
    var entry = this.variableData.find(function (vd) {
      return vd.label === pName;
    });
    if (entry === undefined) {
      return false;
    }
    return typeof entry.category === "string";
  },
  /**
   * @description The gategory of the element
   * @function
   * @param {type} pName the name of the element to search
   * @returns {String} The category 
   */
  getCategory: function getCategory(pName) {
    var entry = this.variableData.find(function (vd) {
      return vd.label === pName;
    });
    if (entry === undefined) {
      return null;
    }
    return entry.category;
  },
  hasHelp: function hasHelp(pName) {
    var entry = this.variableData.find(function (vd) {
      return vd.label === pName;
    });
    if (entry === undefined) {
      return false;
    }
    return entry.help !== undefined;
  },
  getHelp: function getHelp(pName) {
    var entry = this.variableData.find(function (vd) {
      return vd.label === pName;
    });
    if (entry === undefined) {
      return null;
    }
    return entry.help;
  },
  hasSource: function hasSource(pName) {
    var entry = this.variableData.find(function (vd) {
      return vd.label === pName;
    });
    if (entry === undefined) {
      return false;
    }
    return entry.parameters !== undefined && entry.parameters !== null && typeof entry.parameters.source === "string" && entry.parameters.source.length > 0;
  },
  getSource: function getSource(pName) {
    var entry = this.variableData.find(function (vd) {
      return vd.label === pName;
    });
    if (entry === undefined) {
      return null;
    }
    return entry.parameters.source;
  },
  /** 
   * @brief this function returns the specifiek sample value of a variable deep in the sampletree
   * this function try to return a value in all situation even if input parameters don't match with content
   * @param {string} pName, the path name of the variable parentnodes are separated by dots.
   * ex 'file_info.file.blabla'
   * @returns {Mixed} the tree or the specifiek default sample in string format
   * @default ''
   **/
  getSampleForPath: function getSampleForPath(pName) {
    if (typeof pName !== "string" || pName.length <= 0) {
      throw new Error('invalid variable name');
    }
    var treeNodes = pName.split('.');
    if (treeNodes.length === 0) {
      return '';
    }
    if (this.hasSample(treeNodes[0]) === true) {
      var tree = this.getSample(treeNodes[0]);
      var iteratorNode = tree;
      for (var i = 1; i < treeNodes.length; i++) {
        iteratorNode = iteratorNode[treeNodes[i]];
        if (iteratorNode === undefined) {
          return '';
        }
      }
      return iteratorNode;
    }
    return '';
  }
};
module.exports = WorkflowVariableCollection;
if (window.nixps === undefined) {
  window.nixps = {};
}
if (nixps.quantum === undefined) {
  nixps.quantum = {};
}
nixps.quantum.WorkflowVariableCollection = WorkflowVariableCollection;

},{}],117:[function(require,module,exports){
"use strict";

(function ($) {
  require("../../../quantum/js/nixps-quantum-ConfigureArray.js");
  var ValueComposerTranslator = require("./ValueComposerTranslator.js");
  var ValueComposerUtil = require("./ValueComposerUtil.js");
  var all_files_template = [{
    "type": "com.nixps.quantum.data_from_previous_node.0",
    "first_only": false
  }];

  /**
   * @namespace nixps-quantum-ArrayEditor
   * @description the component where you can write code, like xml, js, json
   * @version 1.0.0
   */
  $.widget("nixps-quantum.ArrayEditor", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "arrayeditor",
    options: {
      /**
       * @description The content
       * @name nixps-quantum.ArrayEditor#content
       * @type {Array}
       * @default []
       */
      content: [],
      /**
       * @description Array containing all the known variables by the system
       * @name nixps-quantum.ArrayEditor#knownVariableNames
       * @default []
       * @type {Array}
       */
      knownVariableNames: [],
      /**
       * @description The EntityComposerDefinitions
       * @name nixps-quantum.ArrayEditor#entityComposerDefinitions
       * @default null
       */
      entityComposerDefinitions: null,
      /**
       * @description The jQuery scope in where the elements live
       * @name nixps-quantum.ArrayEditor#scope
       * @type {String}
       * @default "worfklow" 
       */
      scope: "workflow",
      /**
       * @description The uuid of the expressionlist
       * @type {Number}
       * @default null
       * @private
       * @name nixps-quantum.ArrayEditor#expressionListUUID
       */
      expressionListUUID: null,
      created: function created() {}
    },
    /**
     * @description create the component
     * @name nixps-quantum.ArrayEditor#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this.mEditor = undefined;
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._on(this.element, {
        "configurearraychanged": this._handleChange,
        "expressioneditorchange": this._preventPropagation
      });
      this._draw();
      this.options.created();
    },
    _preventPropagation: function _preventPropagation(pEvent) {
      pEvent.stopPropagation();
    },
    _handleChange: function _handleChange(pEvent, pData) {
      if (pData && Array.isArray(pData.data)) {
        this._trigger("change", pEvent, this.getValue());
      }

      // If data contains all files from prev node -> disable button

      if (ValueComposerTranslator.arrayToTemplate(pData.data).indexOf("${files.previous}") !== -1) {
        this.element.find(".nixps-quantum-EditableTable-remove-button-td").hide();
      } else {
        this.element.find(".nixps-quantum-EditableTable-remove-button-td").css("display", "");
      }
    },
    getValue: function getValue() {
      var content = this.mEditor.ConfigureArray("getValue");
      var variables = [];
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      for (var i = 0; i < editors.length; i++) {
        variables = variables.concat($(editors[i]).ExpressionEditor("getVariableNames"));
      }
      return {
        content: content,
        variables: variables
      };
    },
    hasResult: function hasResult() {
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      for (var i = 0; i < editors.length; i++) {
        if ($(editors[i]).ExpressionEditor("hasResult") !== true) {
          return false;
        }
      }
      return true;
    },
    /**
     * @description Check every expression editor inside if it is blocking or not
     * @function
     * @name nixps-quantum.CodeEditor#isBlocking
     * @returns {boolean}
     */
    isBlocking: function isBlocking() {
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      for (var i = 0; i < editors.length; i++) {
        var blocking = $(editors[i]).ExpressionEditor("isBlocking");
        if (blocking === true) {
          return true;
        }
      }
      return false;
    },
    /**
     * @description Get the results for sending to backend for calculating sample. 
     * The result function is to be compatible with the expression Editor. 
     * Do not use the for getting the content of the component 
     * @function
     * @name nixps-quantum.CodeEditor#getSampleResult
     * @returns {undefined}
     */
    getSampleResult: function getSampleResult(pVariables) {
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      var result = [];
      for (var i = 0; i < editors.length; i++) {
        result.push($(editors[i]).ExpressionEditor("getResult", pVariables));
      }
      return result;
    },
    addContent: function addContent(pContent) {
      this.mEditor.ConfigureArray("addNewRow");
      this.element.find(".nixps-quantum-ExpressionEditor").last().ExpressionEditor("addContent", pContent);
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps-quantum.ArrayEditor#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {},
    /**
     * @description redraw the component
     * @function
     * @name nixps-quantum.ArrayEditor#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-quantum.ArrayEditor#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      var arrayData = ValueComposerTranslator.valueComposerToArray(this.options.content, this.options.entityComposerDefinitions);
      if (Array.isArray(arrayData) && arrayData.length === 0) {
        arrayData = ValueComposerUtil.getEmptyValueComposer();
      }
      var editor = $("<div>").ConfigureArray({
        expressionListUUID: this.options.expressionListUUID,
        expressionScope: this.options.scope,
        rowData: arrayData,
        preventEditorSwitch: true
      });
      this.mEditor = editor;
      this.element.append(editor);
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-quantum.ArrayEditor#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "content") {
        if (Array.isArray(this.options.content)) {
          if (_.isEqual(this.options.content, all_files_template)) {
            this.mEditor.ConfigureArray("setValue", [this.options.content]);
            this.element.find(".nixps-quantum-EditableTable-remove-button-td").hide();
            return;
          }
          if (this.options.content.length === 1 && this.options.content[0].type === "com.nixps.quantum.object.0" && Array.isArray(this.options.content[0].object)) {
            this.mEditor.ConfigureArray("setValue", this.options.content[0].object);
          } else {
            this.mEditor.ConfigureArray("setValue", ValueComposerTranslator.valueComposerToArray(this.options.content, this.options.entityComposerDefinitions));
          }
          var returnData = this.mEditor.ConfigureArray("getValue");
          if (ValueComposerTranslator.arrayToTemplate(returnData).indexOf("${files.previous}") !== -1) {
            this.element.find(".nixps-quantum-EditableTable-remove-button-td").hide();
          } else {
            this.element.find(".nixps-quantum-EditableTable-remove-button-td").css("display", "");
          }
        }
      }
    }
  });
})(jQuery);

},{"../../../quantum/js/nixps-quantum-ConfigureArray.js":436,"./ValueComposerTranslator.js":113,"./ValueComposerUtil.js":114}],118:[function(require,module,exports){
"use strict";

(function ($) {
  var ValueComposerUtil = require("./ValueComposerUtil.js");
  var ValueComposerTranslator = require("./ValueComposerTranslator.js");
  function getQueryFromVC(pValueComposer) {
    if (Array.isArray(pValueComposer) && pValueComposer.length === 1 && pValueComposer[0].type === "com.nixps.quantum.conditional.0") {
      if (Array.isArray(pValueComposer[0].condition)) {
        var outputQuery = [],
          inputQuery = pValueComposer[0].condition;
        for (var i = 0; i < inputQuery.length; i++) {
          if (Array.isArray(inputQuery[i]) && ["equal to", "not equal to", "contains", "contains text like"].includes(inputQuery[i + 1]) && Array.isArray(inputQuery[i + 2])) {
            outputQuery = outputQuery.concat(["$__custom__", "equal to", [inputQuery[i].slice(), inputQuery[i + 1], inputQuery[i + 2].slice()]]);
            i = i + 2;
          } else {
            outputQuery.push(inputQuery[i]);
          }
        }
        return outputQuery;
      } else {}
    }
    return ["$__custom__", "equal to", [pValueComposer, "equal to", ValueComposerUtil.getEmptyValueComposer()]];
  }
  function getVCfromQuery(pQuery, pAdditionalData) {
    if (!Array.isArray(pQuery)) {
      throw new Error("expect array");
    }
    var outputQuery = [];
    for (var i = 0; i < pQuery.length; i++) {
      if (pQuery[i] === "$__custom__" && pQuery[i + 1] === "equal to" && Array.isArray(pQuery[i + 2])) {
        outputQuery = outputQuery.concat(pQuery[i + 2]);
        i = i + 2;
      } else {
        outputQuery.push(pQuery[i]);
      }
    }
    return [Object.assign({
      "type": "com.nixps.quantum.conditional.0",
      "condition": outputQuery,
      "strict": false
    }, pAdditionalData)];
  }

  /**
   * @namespace nixps-quantum-BooleanEditor
   * @description the component to define the condition
   * @version 1.0.0
   */
  $.widget("nixps-quantum.BooleanEditor", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "booleaneditor",
    options: {
      /**
       * @description The content
       * @name nixps-quantum.BooleanEditor#content
       * @type {Array}
       * @default []
       */
      content: [],
      /**
       * @description Array containing all the known variables by the system
       * @name nixps-quantum.BooleanEditor#knownVariableNames
       * @default []
       * @type {Array}
       */
      knownVariableNames: [],
      /**
       * @description The EntityComposerDefinitions
       * @name nixps-quantum.BooleanEditor#entityComposerDefinitions
       * @default null
       */
      entityComposerDefinitions: null,
      /**
       * @description The entityComposerDefinitionResults
       * @name nixps-quantum.BooleanEditor#entityComposerDefinitionResults
       * @default null
       */
      entityComposerDefinitionResults: null,
      /**
       * @description The jQuery scope in where the elements live
       * @name nixps-quantum.BooleanEditor#scope
       * @type {String}
       * @default "worfklow" 
       */
      scope: "workflow",
      /**
       * @description The uuid of the expressionlist
       * @type {Number}
       * @default null
       * @private
       * @name nixps-quantum.BooleanEditor#expressionListUUID
       */
      expressionListUUID: null,
      created: function created() {}
    },
    /**
     * @description create the component
     * @name nixps-quantum.BooleanEditor#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);

      // variables
      this.mEditor = undefined;
      this.strict = false; // part of value composer

      this._on(this.element, {
        "serverqueryeditorchange": this._handleChange,
        "expressioneditorchange": this._expressionEdiorChangeHandler
      });
      this._draw();
      this.options.created();
    },
    _expressionEdiorChangeHandler: function _expressionEdiorChangeHandler(pEvent, pData) {
      if (this.isValid()) {
        this._trigger("change", null, this.getValue());
      }
      pEvent.stopPropagation();
    },
    _handleChange: function _handleChange(pEvent, pData) {
      if (this.isValid()) {
        this._trigger("change", null, this.getValue());
      }
    },
    getValue: function getValue() {
      var query = this.mEditor.ServerQueryEditor("getQuery");
      var content = getVCfromQuery(query, {
        strict: this.strict
      });
      var variables = [];
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      for (var i = 0; i < editors.length; i++) {
        variables = variables.concat($(editors[i]).ExpressionEditor("getVariableNames"));
      }
      return {
        content: content,
        variables: variables
      };
    },
    hasResult: function hasResult() {
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      for (var i = 0; i < editors.length; i++) {
        if ($(editors[i]).ExpressionEditor("hasResult") !== true) {
          return false;
        }
      }
      return true;
    },
    isBlocking: function isBlocking() {
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      for (var i = 0; i < editors.length; i++) {
        var blocking = $(editors[i]).ExpressionEditor("isBlocking");
        if (blocking === true) {
          return true;
        }
      }
      return false;
    },
    /**
     * @description Get the results for sending to backend for calculating sample. 
     * The result function is to be compatible with the expression Editor. 
     * Do not use the for getting the content of the component 
     * @function
     * @name nixps-quantum.CodeEditor#getSampleResult
     * @returns {undefined}
     */
    getSampleResult: function getSampleResult(pVariables) {
      if (this.isValid() === false) {
        return "";
      }
      var that = this;
      var index = 0;
      var query = this.mEditor.ServerQueryEditor("getQuery");
      var conditionalValueComposers = getVCfromQuery(query, {
        strict: this.strict
      })[0].condition;
      var conditionalValueComposerExample = conditionalValueComposers.map(function (pValueCompElem) {
        if (Array.isArray(pValueCompElem)) {
          var regularResults = that.element.find(".nixps-quantum-ExpressionEditor").eq(index++).ExpressionEditor("getResult", pVariables);
          return regularResults.reduce(function (pPrevious, pCurrent) {
            return pPrevious.concat(pCurrent);
          }, []);
        }
        return pValueCompElem;
      });
      return [{
        "type": "com.nixps.quantum.conditional.0",
        "condition": conditionalValueComposerExample,
        "strict": this.strict
      }];
    },
    isValid: function isValid() {
      return this.mEditor.ServerQueryEditor("validate");
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps-quantum.BooleanEditor#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {},
    /**
     * @description redraw the component
     * @function
     * @name nixps-quantum.BooleanEditor#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-quantum.BooleanEditor#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      this.element.empty();

      //  
      this.mEditor = $("<div>").addClass("be_queryeditor");
      this.element.append(this.mEditor);
      this.mEditor.ServerQueryEditor({
        allow_groups: true,
        conditions: ["AND", "OR"],
        allowNotOperator: false,
        allowValueComposers: true,
        // fieldInput: this.options.fieldInput,
        // fieldValueSetter: this.options.fieldValueSetter,
        fieldValueGetter: this._expressionEditorValueGetter,
        // fieldValidation: this.options.fieldValidation,
        fieldEvents: "change input fieldcustomchange expressioneditorchange"
      });
      this.mEditor.ServerQueryEditor("setFields", [{
        id: "$__custom__",
        label: "$__custom__",
        type: "string",
        operators: ["equal"],
        input_event: "expressioneditorchange",
        // operators: [],
        input: function input(rule, input_name) {
          var selector = '<select class="cqb_custom_select">';
          selector += "<option value='equal to' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.equal") + "</option>";
          selector += "<option value='not equal to' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.not_equal") + "</option>";
          selector += "<option value='contains' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.contains") + "</option>";
          // selector += "<option value='begins with' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.begins_with") + "</option>";
          // selector += "<option value='ends with' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.ends_with") + "</option>";
          // selector += "<option value='is like' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.is_like") + "</option>";
          selector += "<option value='contains text like' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.contains_text_like") + "</option>";
          // selector += "<option value='begins like' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.begins_like") + "</option>";
          // selector += "<option value='ends like' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.ends_like") + "</option>";
          // selector += "<option value='exists'>" + $.i18n._("nixps-cloudflow-ServerQueryEditor.exists") + "</option>"; 
          // selector += "<option value='does not exist'>" + $.i18n._("nixps-cloudflow-ServerQueryEditor.does_not_exists") + "</option>";
          // selector += "<option value='less than' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.less") + "</option>";
          // selector += "<option value='less than or equal to' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.less_or_equal") + "</option>";
          // selector += "<option value='greater than' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.greater") + "</option>";
          // selector += "<option value='greater than or equal to' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.greater_or_equal") + "</option>";
          // selector += "<option value='in' >" + $.i18n._("nixps-cloudflow-ServerQueryEditor.in") + "</option>";
          selector += "</select>";
          return $("<span>").addClass("booleaneditor_row").append($("<div>").attr("name", input_name + "_1").addClass("cqb_custom_input_1").ExpressionEditor({
            expressionListUUID: that.options.expressionListUUID,
            entityComposerDefinitions: that.options.entityComposerDefinitions,
            entityComposerDefinitionResults: that.options.entityComposerDefinitionResults,
            scope: that.options.scope
          })).append(selector).append($("<div>").attr("name", input_name + "_2").addClass("cqb_custom_input_1").ExpressionEditor({
            expressionListUUID: that.options.expressionListUUID,
            entityComposerDefinitions: that.options.entityComposerDefinitions,
            entityComposerDefinitionResults: that.options.entityComposerDefinitionResults,
            scope: that.options.scope
          }));
        },
        validation: {
          callback: function callback(pValue, rule) {
            return true;
          }
        },
        valueGetter: this._expressionEditorValueGetter.bind(this),
        valueSetter: function valueSetter(rule, value) {
          if (Array.isArray(value)) {
            if (value[0] === "$__custom__" && value[1] === "equal to" && Array.isArray(value[2]) && value[2].length === 3) {
              rule.$el.find(".rule-value-container [name$=_1]").ExpressionEditor("option", "valueComposer", value[2][0]);
              rule.$el.find(".rule-value-container select.cqb_custom_select").val(value[2][1]);
              rule.$el.find(".rule-value-container [name$=_2]").ExpressionEditor("option", "valueComposer", value[2][2]);
            } else if (value.length === 3) {
              var value0 = value[0],
                operator = value[1],
                value2 = value[2];
              if (!ValueComposerUtil.isValueComposer(value2)) {
                value2 = ValueComposerUtil.translateToValueComposer(value2);
              }
              rule.$el.find(".rule-value-container [name$=_1]").ExpressionEditor("option", "valueComposer", value0);
              rule.$el.find(".rule-value-container select.cqb_custom_select").val(operator);
              rule.$el.find(".rule-value-container [name$=_2]").ExpressionEditor("option", "valueComposer", value2);
            }
          }
        }
      }]);
      this.mEditor.ServerQueryEditor("setQuery", getQueryFromVC(this.options.content));
      if (Array.isArray(this.options.content) && this.options.content.length === 1) {
        if (typeof this.options.content[0].strict === "boolean") {
          this.strict = this.options.content[0].strict;
        } else {
          this.strict = false;
        }
      }
    },
    _expressionEditorValueGetter: function _expressionEditorValueGetter(rule) {
      var compare = rule.$el.find(".rule-value-container [name$=_1]").ExpressionEditor("option", "valueComposer");
      var operator = rule.$el.find(".rule-value-container select.cqb_custom_select").val();
      var value = rule.$el.find(".rule-value-container [name$=_2]").ExpressionEditor("option", "valueComposer");
      return [compare, operator, value];
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-quantum.BooleanEditor#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "content") {
        this.mEditor.ServerQueryEditor("setQuery", getQueryFromVC(this.options.content));
        if (Array.isArray(this.options.content) && this.options.content.length === 1) {
          if (typeof this.options.content[0].strict === "boolean") {
            this.strict = this.options.content[0].strict;
          } else {
            this.strict = false;
          }
        }
      }
    }
  });
})(jQuery);

},{"./ValueComposerTranslator.js":113,"./ValueComposerUtil.js":114}],119:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 * 
 *   created by guillaume on Jun 2, 2016 12:12:35 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  require("../../../quantum/js/nixps-quantum-ScriptEditor.js");
  var ValueComposerUtil = require("./ValueComposerUtil.js");
  var ValueComposerTranslator = require("./ValueComposerTranslator.js");
  var EntityComposer = require("./EntityComposer.js");
  var BuildingBlock = require("./BuildingBlock.js");
  var tempateVariableRegExp = new RegExp(/\${(\\}|[^}])+}/g);
  /**
   * @namespace nixps-quantum-CodeEditor
   * @description the component where you can wrinte code, like xml, js, json
   * @version 1.0.0
   */
  $.widget("nixps-quantum.CodeEditor", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "codeeditor",
    options: {
      /**
       * @description The mode in with you want, this is the code language.
       * @name nixps-quantum.CodeEditor#mode
       * @type {String}
       * @example "xml"
       * @default "text"
       */
      mode: "text",
      /**
       * @description The content of de code
       * @name nixps-quantum.CodeEditor#content
       * @type {String}
       * @default ""
       */
      content: "",
      /**
       * @description Array containing all the known variables by the system
       * @name nixps-quantum.CodeEditor#knownVariableNames
       * @default []
       * @type {Array}
       */
      knownVariableNames: [],
      /**
       * @description The EntityComposerDefinitions
       * @name nixps-quantum.CodeEditor#entityComposerDefinitions
       * @default null
       */
      entityComposerDefinitions: null,
      /**
       * @description The jQuery scope in where the elements live
       * @name nixps-quantum.CodeEditor#scope
       * @type {String}
       * @default "worfklow" 
       */
      scope: "workflow",
      /**
       * @description The uuid of the expressionlist
       * @type {Number}
       * @default null
       * @private
       * @name nixps-quantum.CodeEditor#expressionListUUID
       */
      expressionListUUID: null,
      /**
       * @description Enable/disable math mode
       * @type {Boolean}
       * @default false
       */
      mathMode: false
    },
    /**
     * @description create the component
     * @name nixps-quantum.CodeEditor#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.templateTitles = [];
      // templateContent is the content in template format like hallo my name is ${variablenaam}
      // content option is in form of value composers
      this.templateContent = this.options.content;
      if (_typeof(this.options.content) === "object") {
        this.templateContent = this._transformValueComposerToTemplate(this.options.content);
      }
      this.changeHandler = _.throttle(this._changeHandler.bind(this), 900, {
        leading: false
      });
      this._draw();
      this._on(this.element, {
        "drop": this._dropHandler,
        "scripteditorchange": this.changeHandler,
        "scripteditorchangemode": this._changeModeHandler
      });
    },
    /**
     * @description function runs when user drops a variable
     * @fucntion
     * @private
     * @param {type} pEvent
     * @param {type} pUI
     * @returns {undefined}
     */
    _dropHandler: function _dropHandler(pEvent, pUI) {
      if ($.isPlainObject(pUI)) {
        var definition = pUI.draggable.ExpressionListItem("option", "definition");
        if (!$.isEmptyObject(definition) && Array.isArray(definition.composer) && definition.composer.length === 1 && !$.isEmptyObject(definition.composer[0])) {
          var template = ValueComposerTranslator.fromFrontEndToTemplate(definition.composer);
          this.element.find(".editField").ScriptEditor("insertTextAtPositionEvent", template, pEvent);
        }
      }
    },
    /**
     * @description function runs when user is being dragging, This handles the cursor
     * @function
     * @private
     * @name nixps-quantum.CodeEditor#dragHandler
     * @param {type} pEvent
     * @param {type} pUI
     * @returns {undefined}
     */
    dragHandler: function dragHandler(pEvent, pUI) {
      if (pUI !== undefined && !$.isEmptyObject(pUI.offset)) {
        // only change cursor if dragging is fired by draggable jquery UI component
        this.element.find(".editField").ScriptEditor("setCursorAtPointerEvent", pEvent);
      }
    },
    /**
     * @function
     * @name nixps-quantum.CodeEditor#startDragHandler
     * @param {type} pEvent
     * @param {type} pUI
     * @returns {undefined}
     */
    startDragHandler: function startDragHandler(pEvent, pUI) {
      if (pUI !== undefined) {
        // add class to helper
        pUI.helper.addClass("CodeEditorHelper");
      }
    },
    /**
     * @description function runs when the content has changed.
     * @function
     * @private
     * @name nixps-quantum.CodeEditor#_changeHandler
     * @param {object} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _changeHandler: function _changeHandler(pEvent, pData) {
      if (typeof pData.script === "string") {
        this.templateContent = pData.script.trim();
        try {
          this._trigger("change", null, {
            "content": this._transformTemplateToValueComposer(this.templateContent),
            "variables": this.templateTitles
          });
        } catch (pError) {
          // if it can not parse to value composer
          console.error(pError);
          this._trigger("error", null, {
            error_code: "invalid_valuecomposer",
            error: pError.message
          });
        }
      }
    },
    /**
     * @desciption function runs when the mode has changed and is setled, so worker is known,
     * This event is triggerd by plugin.
     * @function
     * @name nixps-quantum.CodeEditor#_changeModeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _changeModeHandler: function _changeModeHandler(pEvent, pData) {
      this.element.find(".nixps-quantum-ScriptEditor").ScriptEditor("setOptionsEditWorker", {
        nixpsVariables: this.options.knownVariableNames,
        onUpdateExtra: onUpdate.toString()
      });
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps-quantum.CodeEditor#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.mode !== "string" || this.options.mode.length <= 2) {
        throw new Error("input option mode must be a not empty string");
      }
      if (typeof this.options.content !== "string" && _typeof(this.options.content) !== "object") {
        throw new Error("input option content must be a string");
      }
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps-quantum.CodeEditor#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-quantum.CodeEditor#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      var scriptEditor = $("<div>").addClass("editField");
      this.element.append(scriptEditor);
      try {
        scriptEditor.ScriptEditor({
          mode: this.options.mode,
          script: this.templateContent
        }).droppable({
          accept: ".nixps-quantum-ExpressionListItem, .nixps-quantum-BuildingBlock",
          tolerance: "pointer",
          scope: this.options.scope
        });
      } catch (e) {
        console.error(e);
        this.disable();
        this._trigger("loaderror", null, {
          error: e
        });
      }
    },
    /**
     * @description Transform a valuecomposer, with is one array with objects to a string with template variabels.
     * The valuecomposer must have one level, more levels will not be translated. Unkonwn items will be skipped
     * @function
     * @private
     * @param {Array} pValueComposer the valuecomposer to translate to a string with template variable
     * @returns {String} the translated string with template variables.
     */
    _transformValueComposerToTemplate: function _transformValueComposerToTemplate(pValueComposer) {
      var casting = ValueComposerUtil.getCastingFormat(pValueComposer);
      if (casting === "array") {
        return ValueComposerTranslator.arrayToTemplate(pValueComposer);
      } else if (casting === "object") {
        return ValueComposerTranslator.objectToTemplate(pValueComposer);
      }
      return ValueComposerTranslator.valuecomposerToTemplate(pValueComposer);
    },
    /**
     * @description translate a string to a one level valuecomposer, with value and variable types.
     * text will be translated to values and templatevariable to backend variables
     * @function
     * @private
     * @name nixps-quantum.CodeEditor#_transformTemplateToValueComposer
     * @param {string} pTemplateString
     * @returns {Array} ValueComposer: containing objects with type value or variable
     */
    _transformTemplateToValueComposer: function _transformTemplateToValueComposer(pTemplateString, pSkipCalc) {
      if (typeof pTemplateString === "string") {
        // get all template variables in one array
        var templateVariables = pTemplateString.match(tempateVariableRegExp);
        // if there are no variables, return just one value composer: value
        if (!Array.isArray(templateVariables) || templateVariables.length === 0) {
          if (this.options.mathMode === true && !pSkipCalc) {
            return [{
              type: "com.nixps.quantum.calculations.0",
              operations: ValueComposerTranslator.textToCalculationOperations(pTemplateString)
            }];
          }
        }
      }
      var translation = ValueComposerTranslator.templateToValuecomposer(pTemplateString, this.options.entityComposerDefinitions);
      this.templateTitles = translation.templateTitles;
      return translation.valuecomposer;
    },
    /**
     * @description function to control if actual information is is not dangerous
     * @function
     * @param {array|valuecomposer} pValueComposer
     * @returns {Boolean}
     */
    willInfoLostValueComposer: function willInfoLostValueComposer(pValueComposer) {
      for (var i = 0; i < pValueComposer.length; i++) {
        if (pValueComposer[i] && typeof pValueComposer[i].type === "string") {
          if (pValueComposer[i].type === "com.nixps.quantum.variable.0" && pValueComposer[i].variable.indexOf(":") >= 0) {
            // variable contains ":" this can cause trubuls for interpretating functions (modifiers)
            return true;
          } else if (pValueComposer[i].type === "com.nixps.quantum.value.0" && typeof pValueComposer[i].value === "string" && pValueComposer[i].value.search(/\$\{/) >= 0) {
            // if value contains ${ this can cause problems by interpretation of real template names
            return true;
          }
        } else {
          throw new Error("invalid value composer");
        }
      }
      return false;
    },
    /**
     * @description Get the results for sending to backend for calculating sample. 
     * The result function is to be compatible with the expression Editor. 
     * Do not use the for getting the content of the component 
     * @function
     * @name nixps-quantum.CodeEditor#getSampleResult
     * @returns {undefined}
     */
    getSampleResult: function getSampleResult(pVariables) {
      var variableSampleDict = {};
      for (var index in pVariables) {
        variableSampleDict[pVariables[index].name] = pVariables[index].value;
      }
      function getSample(pName) {
        if (variableSampleDict[pName] !== undefined) {
          if (typeof variableSampleDict[pName] === "function") {
            return variableSampleDict[pName](pName);
          }
          return variableSampleDict[pName];
        }
        return "variable";
      }
      var that = this;
      var index = 0;
      var result = $.map(this._transformTemplateToValueComposer(this.templateContent, true), function (pValueCompElem) {
        if (pValueCompElem && pValueCompElem.type !== "com.nixps.quantum.value.0") {
          var output = [pValueCompElem];
          ValueComposerUtil.replaceVariables(output, getSample(that.templateTitles[index++]));
          return output;
        }
        return pValueCompElem;
      });
      return that.options.mathMode === true ? [ValueComposerTranslator.valueComposerToCalculation(result)] : [result];
    },
    /**
     * @description Does the component has some interest content? Does it has some results?
     * This is the same interface as expressionEditor
     * @function
     * @name nixps-quantum.CodeEditor#hasResult
     * @returns {Boolean} true if the editor has some value not equal to space and new lines, false if the value is empty or contains only space or newlines.
     */
    hasResult: function hasResult() {
      return ("" + this.templateContent).trim().length > 0;
    },
    /**
     * @description add the focus on the editor
     * @function
     * @name nixps-quantum.CodeEditor#focus
     * @returns {undefined}
     */
    focus: function focus() {
      this.element.find(".editField").ScriptEditor("focus");
    },
    setMathMode: function setMathMode(pValue) {
      if (typeof pValue !== "boolean") {
        return;
      }
      this.options.mathMode = pValue;
      if (this.options.mathMode === true) {
        this.element.addClass("nixps-quantum-math");
      } else {
        this.element.removeClass("nixps-quantum-math");
      }
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-quantum.CodeEditor#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "content") {
        if (_typeof(this.options.content) === "object") {
          this.templateContent = this._transformValueComposerToTemplate(this.options.content);
        } else {
          this.templateContent = this.options.content;
        }
        this.element.find(".editField").ScriptEditor("option", "script", this.templateContent);
        // no redraw needed, the scripteditor will do that.
      } else if (pKey === "mode") {
        this.element.find(".editField.nixps-quantum-ScriptEditor").ScriptEditor("option", "mode", pValue);
        // no redraw needed, the scripteditor will do that.
      } else if (pKey === "knownVariableNames") {
        this._changeModeHandler();
        // no redraw needed.
      } else {
        this._draw();
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
    }
  });
  /**
   * @function
   * @returns {Array} a array containing errors, with a ace editor interface.
   * @description function runs in ace worker enviroment, to detect errors and warnings in the code. It is supposed to work in only this enviroment.
   * ATTENSION: DO NOT USE jQuery, _.underscore or other js library! because this function is run in a worker enviroment. it only known basic js!
   * 
   * @algoritme: firts control if the category is known and if nessassary go in detail in that specific category.
   * afterwards control if there are functions (modifiers) and try to control the arguments
   */
  var onUpdate = function onUpdate() {
    var goodModules = ["variable", "role", "current_user", "time", "date", "general", "file", "files", "container", "workable", "project", "logical", "translation", "preferences_user", "conditional"];
    var goodFileSubModule = ["file_name", "file_name_without_extension", "file_name_extension", "full_file_url", "folder_path"];
    var goodProjectSubModule = ["contents", "files", "full_file_url", "one_file", "folders", "one_folder"];
    var goodGeneralSubModule = ["last_error", "generate_uuid"];
    var lines = this.doc.$lines;
    var errors = [],
      moduleNames;
    for (var i = 0; i < lines.length; i++) {
      moduleNames = lines[i].match(/\$\{([\\]}|[^}])+[^\\]}/g);
      if (moduleNames !== null && typeof moduleNames.length === "number") {
        for (var j = 0; j < moduleNames.length; j++) {
          // control file submodules
          if (moduleNames[j].indexOf("${file.") === 0) {
            var submodule = moduleNames[j].match(/\$\{file\.[^.:}]+/);
            if (submodule !== null && typeof submodule.length === "number") {
              if (goodFileSubModule.indexOf(submodule[0].slice(7)) === -1) {
                errors.push({
                  row: i,
                  column: 5,
                  text: "'" + submodule[0].slice(7) + "' is unkown file module name",
                  type: "error"
                });
              }
            } else {
              errors.push({
                row: i,
                column: 5,
                text: "file must have a module name",
                type: "error"
              });
            }
            // control general template
          } else if (moduleNames[j].indexOf("${general") === 0) {
            var submodule = moduleNames[j].match(/\$\{general\.[^.:}]+/);
            if (submodule !== null && typeof submodule.length === "number") {
              if (goodGeneralSubModule.indexOf(submodule[0].slice(10)) === -1) {
                errors.push({
                  row: i,
                  column: 5,
                  text: "'" + submodule[0].slice(10) + "' is unkown general module name",
                  type: "error"
                });
              }
            } else {
              errors.push({
                row: i,
                column: 5,
                text: "general must have a module name",
                type: "error"
              });
            }
            // control workable 
          } else if (moduleNames[j].indexOf("${workable") === 0) {
            if (lines[i].match(/\$\{workable.workableID/) === null) {
              errors.push({
                row: i,
                column: 5,
                text: "category workable only support 'workableID' as module",
                type: "error"
              });
            }
            // control variables
          } else if (moduleNames[j].indexOf("${variable") === 0 && this.$nixpsVar !== undefined && this.$nixpsVar.length >= 0) {
            var templateTitles = moduleNames[j].match(/\$\{variable\.([^}:]*)[:}]/g);
            if (templateTitles !== null && typeof templateTitles.length === "number") {
              // remove ${variable. and last '}' , and look if it is in array?
              var variableName = templateTitles[0].slice(11).slice(0, -1);
              if (variableName.length <= 0) {
                errors.push({
                  row: i,
                  column: 5,
                  text: "variablename is missing",
                  type: "error"
                });
              } else if (this.$nixpsVar.indexOf(variableName) === -1) {
                errors.push({
                  row: i,
                  column: 5,
                  text: "variable '" + variableName + "' is not known yet. make sure it will exist",
                  type: "warning"
                });
              }
            } else {
              errors.push({
                row: i,
                column: 5,
                text: "variablename is missing",
                type: "error"
              });
            }
            // control project/jobs 
          } else if (moduleNames[j].indexOf("${project") === 0) {
            var submodule = moduleNames[j].match(/\$\{project\.[^.:}]+/);
            if (submodule !== null && typeof submodule.length === "number") {
              if (goodProjectSubModule.indexOf(submodule[0].slice(10)) === -1) {
                errors.push({
                  row: i,
                  column: 5,
                  text: "'" + submodule[0].slice(10) + "' is unkown project module name",
                  type: "error"
                });
              }
            } else {
              errors.push({
                row: i,
                column: 5,
                text: "project must have a module name",
                type: "error"
              });
            }
          } else if (moduleNames[j].indexOf("${=") === 0) {
            //     var splitCalc = moduleNames[j].replace(/\$\{.+?\}/,"var").split(/[\(\)]+/);
            //     for (var p = 0; p < splitCalc.length; p++) {
            //         var element = splitCalc[p];
            //         if(!element.match(/^\s*([-+]?)((?:\d|var)(\.+\d+)?)(?:\s*([-+*\/])\s*((?:\s[-+])?(?:\d|var)(\.+\d+)?)\s*)*$/)){
            //             errors.push({row: i, column: 5, text: "calculation invalid", type: "error"});
            //         }
            //     }
          } else {
            // control other modules
            var indexDot = moduleNames[j].indexOf(".");
            if (indexDot <= 0) {
              errors.push({
                row: i,
                column: 5,
                text: "each categorie must have a module",
                type: "error"
              });
            } else if (goodModules.indexOf(moduleNames[j].substring(2, indexDot)) === -1) {
              errors.push({
                row: i,
                column: 5,
                text: "'" + moduleNames[j].substring(2, indexDot) + "' is unkown categorie name",
                type: "error"
              });
            }
          }
          // control function strings
          var substringRegExp = /(:substring\( *'(\\'|[^'])*' *,-?[0-9 ]+, *'(\\'|[^'])*' *,-?[0-9 ]+\)|:substring\( *"(\\"|[^"])*" *,-?[0-9 ]+, *"(\\"|[^"])*" *,-?[0-9 ]+\))|:size\(\)|:convert_to\((number|boolean|string)\)|:convert_unit\([µcdmintpf]{1,2},[µcdmintpf]{1,2}\)/g;
          var rest = lines[i].replace(substringRegExp, "");
          if (rest.indexOf(":substring(") >= 0) {
            errors.push({
              row: i,
              column: 5,
              text: "function substring has wrong arguments",
              type: "error"
            });
          } else if (rest.indexOf(":convert_to(") >= 0) {
            errors.push({
              row: i,
              column: 5,
              text: "function convert_to accepts only arguments, 'boolean', 'number' or 'string'",
              type: "error"
            });
          } else if (rest.search(/\${.*:.*}/) >= 0) {
            errors.push({
              row: i,
              column: 5,
              text: "unkown function, we only support 'convert_to', 'convert_unit', 'substring' or 'size' as function",
              type: "error"
            });
          }
        }
      }
      if (lines[i].match(/\$\{([\\]}|[^}])+$/g) !== null) {
        errors.push({
          row: i,
          column: 5,
          text: "found '${' but no ending '}'",
          type: "error"
        });
      }
    }
    return errors;
  };
})(jQuery);

},{"../../../quantum/js/nixps-quantum-ScriptEditor.js":440,"./BuildingBlock.js":107,"./EntityComposer.js":109,"./ValueComposerTranslator.js":113,"./ValueComposerUtil.js":114}],120:[function(require,module,exports){
"use strict";

(function () {
  if (window.nixps === undefined) {
    window.nixps;
  }
  if (nixps.quantum === undefined) {
    nixps.quantum = {};
  }
  if (nixps.quantum.util === undefined) {
    nixps.quantum.util = {};
  }
  function isComposer(pValue) {
    return false;
  }
  nixps.quantum.util.entityComposerAutoBind = function (pForm, pDefaults, pCustomCollect) {
    return nixps.quantum.util.genericAutoBind(pForm, pDefaults, pCustomCollect, function () {}, isComposer);
  };
})();

},{}],121:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/
/*globals $, _, jsPlumb, console, api_sync, QuantumBlueCollar, namespace, nixps */

(function ($) {
  var ValueComposerUtil = require("./ValueComposerUtil.js");
  var WorkflowVariableCollection = require("./WorkflowVariableCollection.js");
  var WorkflowDataCollection = require("./WorkflowDataCollection.js");
  var EntityComposerCollection = require("./EntityComposerCollection.js");
  var ValueComposerTranslator = require("./ValueComposerTranslator.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  require("./nixps-quantum-EntityComposerAutoBind.js");
  require("./nixps-quantum-ExpressionHelpPanel.js");
  require("./nixps-quantum-ExpressionVariablesSearch.js");
  require("./nixps-quantum-VariableList.js");
  require("./nixps-quantum-ExpressionList.js");
  require("./nixps-quantum-ExpressionListItem.js");
  require("./nixps-quantum-VariableTreeView.js");
  require("./nixps-quantum-CodeEditor.js");
  require("./nixps-quantum-ExpressionEditor.js");
  require("./nixps-quantum-ModifierList.js");
  require("./nixps-quantum-ArrayEditor.js");
  require("./nixps-quantum-ObjectEditor.js");
  require("./nixps-quantum-BooleanEditor.js");

  /**
   * @description try to sniff if it is a expression (or return fals if is could be a code text)
   * @param {array | valuecomposer} pValueComposer
   * @returns {Boolean}
   */
  function sniffExpressionMode(pValueComposer) {
    if (!Array.isArray(pValueComposer)) {
      throw new Error("valuecomposer must be a array");
    }
    for (var i = 0; i < pValueComposer.length; i++) {
      if ($.isPlainObject(pValueComposer[i]) && pValueComposer[i].type === "com.nixps.quantum.value.0" && /\n/.test(pValueComposer[i].value) === true) {
        return false;
      }
    }
    return true;
  }
  ;

  /**
   * @description try to detect the type of format the user want. We try to do that at the hand of the first character
   * @function
   * @private
   * @param {type} pValueComposer
   * @returns {String}
   */
  function sniffCodeFormat(pValueComposer) {
    if (!Array.isArray(pValueComposer)) {
      // can be an object
      return "textVariable";
    }
    if (pValueComposer.length > 0) {
      if (typeof pValueComposer[0].value === "string" && pValueComposer[0].value.length > 0) {
        if (pValueComposer[0].value.charAt(0) === "<") {
          return "xmlVariable";
        } else if (pValueComposer[0].value.charAt(0) === "{") {
          return "jsonVariable";
        }
      }
    }
    return "textVariable";
  }
  ;
  function isBrowserCompatible() {
    if (document.caretRangeFromPoint) {
      return true;
    } else if (document.caretPositionFromPoint) {
      return true;
    }
    return false;
  }

  // A warning message used next to the result
  var warningMessage = $("<div>").addClass("message warning").append($("<span>").addClass("fa fa-exclamation-triangle").css({
    display: "inline-block",
    marginRight: 5
  })).append($("<span>").addClass("message")).css({
    marginTop: 4,
    marginBottom: 4
  });

  /**
   * @description the key of no casting, when user want that his value are not casted, if he want the value as is.
   * @static
   * @constant
   * @type String
   */
  var NO_CASTING_FORMAT = ValueComposerUtil.types.NO_CASTING_FORMAT;
  var CalcAllowedChars = new RegExp(/^[0-9\/\*\+\-\(\)\.]*$/);
  $.widget("nixps-quantum.ExpressionBuilder", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "expressionbuilder",
    options: {
      /**
       * @description The language of the user
       * @name nixps-quantum.ExpressionBuilder#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @brief The title of the expression builder window
       * @name nixps-quantum.ExpressionBuilder#title
       * @type {String}
       * @default "Start From Kiosk - Workable"
       */
      title: "Start From Kiosk - Workable",
      /**
       * @description The classes to be added to the dialog
       * @name nixps-quantum.ExpressionBuilder#classes
       * @type {String}
       * @default ""
       * @since 1.1.0
       */
      classes: "",
      /** 
       * @brief the value composer to edit
       * @name nixps-quantum.ExpressionBuilder#valueComposer
       * @default null
       */
      valueComposer: null,
      /**
       * @brief the collection of the value composer
       * @name nixps-quantum.ExpressionBuilder#valueComposerCollection
       * @default null
       */
      valueComposerCollection: null,
      /**
       * @description object or deferred to get the ententities for the variables and data of the expresionbuilder
       * @name nixps-quantum.ExpressionBuilder#getValueComposerEditorConfiguration
       * @type {Object}
       * @default {}
       */
      getValueComposerEditorConfiguration: {},
      /**
       * @description get composer definitions
       * @name nixps-quantum.ExpressionBuilder#entityComposerDefinitionResults
       * @type entitycomposer
       * @default null
       */
      entityComposerDefinitionResults: null,
      /**
       * @description function who must return the simutated results as string
       * @name nixps-quantum.ExpressionBuilder#simulation
       * @type {Function}
       * @default null
       */
      simulation: null,
      /**
       * @brief the context to get the correct variables en valuecomposer
       * @name nixps-quantum.ExpressionBuilder#context
       * @default null
       */
      context: null,
      /**
       * @description The consent, privacy and cookies object
       * @name nixps-quantum.ExpressionBuilder#consent
       * @type {Object}
       * @default null
       */
      consent: null,
      /**
       * @description Must we show the add path button or not?
       * @name nixps-quantum.ExpressionBuilder#enableAddPathButton
       * @type {Boolean}
       * @default true
       */
      enableAddPathButton: true,
      /**
       * @description Must we allow the user to edit in the textual code editor
       * @name nixps-quantum.ExpressionBuilder#enableCodeEditor 
       * @type {Boolean}
       * @default true
       */
      enableCodeEditor: true,
      /**
       * @description Must we show the categories?
       * @name nixps-quantum.ExpressionBuilder#showCategorie
       * @type {Boolean}
       * @default true
       */
      showCategorie: true,
      /**
       * @description show the add variable button, or hide it
       * @name nixps-quantum.ExpressionBuilder#showAddVariableButton
       * @type {Boolean}
       * @default true
       */
      showAddVariableButton: true,
      /**
       * @description show the original state button, or hide it
       * @name nixps-quantum.ExpressionBuilder#showOriginalStateButton
       * @type {Boolean}
       * @default true
       */
      showOriginalStateButton: true,
      /**
       * @name nixps-quantum.ExpressionBuilder#forceFormat
       * @description whith format must the end result be
       * @example "string", "number", "boolean"
       * @type {string}
       * @default "as_is"
       */
      forceFormat: NO_CASTING_FORMAT,
      /**
       * @description must we accept arays as input?
       * @name nixps-quantum.ExpressionBuilder#acceptArray
       * @type {Boolean}
       * @default false
       */
      acceptArray: true,
      /**
       * @description The jQuery scope in where the elements live
       * @name nixps-quantum.ExpressionBuilder#scope
       * @type {String}
       * @default "worfklow" 
       * @since 1.1.0
       */
      scope: "workflow",
      /**
       * @description Enable/disable math mode
       * @name nixps-quantum.ExpressionBuilder#mathMode
       * @type {Boolean}
       * @default false
       */
      mathMode: false
    },
    _create: function _create() {
      this._controlOptions();
      var that = this;
      var idPrefix = this.widgetFullName + "-" + this.uuid;
      this.element.addClass(this.widgetFullName).addClass(this.options.classes).addClass("cf-dialog").attr({
        "role": "dialog",
        "aria-modal": "true",
        "aria-labelledby": idPrefix + "-titleText",
        "tabindex": "-1"
      });

      // control first level format
      // we do not block if format if it is wrong
      if (this.options.forceFormat === undefined || this.options.forceFormat === null || this.options.forceFormat === NO_CASTING_FORMAT) {
        // default force format do indicate no formting, we use format value null
        this.options.forceFormat = NO_CASTING_FORMAT;
      } else if (ValueComposerUtil.isValidCastingFormat(this.options.forceFormat) === false) {
        console.error("unsupported expression casting type: " + this.options.forceFormat);
        this.options.forceFormat = NO_CASTING_FORMAT;
      }
      /**
       * flag to indicate we could not parse to good value composer
       * default on false, no error
       */
      this.isWrongValueComposer = false;
      this.alive = true;
      this.scheduleResultTimer;
      this.element.Dialog();

      // The title bar
      var dialogTitle = $("<div>").addClass("titleBar cf-dialog-header");
      dialogTitle.append($("<div>").addClass("titleText").attr("id", idPrefix + "-titleText").text(this.options.title));
      dialogTitle.append($("<div>").addClass("close cf-dialog-close").attr({
        "role": "button",
        "aria-label": $.i18n._("nixps-cloudflow-dialog.close")
      }));
      this.element.append(dialogTitle);
      // add eventlistener very early, in case of error, we can still close dialog
      // and are not forced to reload page
      this._on(this.element, {
        "click .close": this._closeDialogHandle
      });

      // LEFT SITE
      var leftPanel = $("<div>").addClass("leftPanel");
      leftPanel.appendTo(this.element);
      var searchField = $("<search>").ExpressionVariablesSearch();
      searchField.appendTo(leftPanel);

      // The expression list
      var expressionList = $("<div>").addClass("expressionList");
      expressionList.appendTo(leftPanel);

      // The help panel
      var helpPanel = $("<div>").addClass("helpPanel");
      helpPanel.appendTo(leftPanel);
      helpPanel.ExpressionHelpPanel();

      // RIGHT SITE 
      var rightPanel = $("<div>").addClass("rightPanel");
      rightPanel.appendTo(this.element);

      // remove the coat of casting,
      // we will add it when user press save button.
      var castingFormat = ValueComposerUtil.getCastingFormat(this.options.valueComposer);
      if (castingFormat !== NO_CASTING_FORMAT) {
        this.options.valueComposer = ValueComposerUtil.removeCastingFormat(this.options.valueComposer, new EntityComposerCollection(this.options.entityComposerDefinitionResults));
      }

      // to add a url 
      var addFileUrlFromFolderButton = $("<button>").attr("type", "button").addClass("addFileUrlFromFolderButton cf-button-secondary").text($.i18n._("nixps-quantum-expressionbuilder.add_path")).toggle(true);

      // to go to default value settup
      if (this.options.showOriginalStateButton === true) {
        var goToDefaultButton = $("<button>").attr("type", "button").addClass("goToDefaultButton cf-button-secondary").text($.i18n._("nixps-quantum-expressionbuilder.original_state")).toggle(true);
      }
      // to switch to code
      var codeTextButton = $("<div>").addClass("codeTextButton").text($.i18n._("nixps-quantum-expressionbuilder.code"));
      var codeEditFormat = sniffCodeFormat(this.options.valueComposer);
      var formatCastingPanel = $("<label>").addClass("formatCastingPanel");
      formatCastingPanel.append($("<span>").addClass("formatCastingLabel").text($.i18n._("nixps-quantum-expressionbuilder.format")));
      var formatCastingSelector = $("<select>").addClass("formatCastingSelector");
      formatCastingSelector.append($("<option>")._t("nixps-quantum-expressionbuilder.format_as_is").val(NO_CASTING_FORMAT));
      formatCastingSelector.append($("<option>")._t("nixps-quantum-expressionbuilder.format_string").val("string"));
      formatCastingSelector.append($("<option>")._t("nixps-quantum-expressionbuilder.format_number").val("number"));
      formatCastingSelector.append($("<option>")._t("nixps-quantum-expressionbuilder.format_boolean").val("boolean"));
      formatCastingSelector.append($("<option>").addClass("extended")._t("nixps-quantum-expressionbuilder.format_array").val("array"));
      formatCastingSelector.append($("<option>").addClass("extended")._t("nixps-quantum-expressionbuilder.format_object").val("object"));
      formatCastingSelector.append($("<option>")._t("nixps-quantum-expressionbuilder.format_conditional").val("conditional"));
      formatCastingSelector.append($("<option>")._t("nixps-quantum-expressionbuilder.format_calc").val("calculation"));
      if (this.options.forceFormat !== NO_CASTING_FORMAT) {
        // if forceFormat is aviable this means we must force the user to a specific format
        // the user have no choose, and can not change
        formatCastingSelector.val(this.options.forceFormat);
        // if number, allow also calc, sinces calc is returning a number
        if (this.options.forceFormat === "number") {
          formatCastingSelector.find("option").prop("disabled", true);
          formatCastingSelector.find("option[value='number']").prop("disabled", false);
          formatCastingSelector.find("option[value='calculation']").prop("disabled", false);
        } else if (this.options.forceFormat === "boolean") {
          formatCastingSelector.find("option").prop("disabled", true);
          formatCastingSelector.find("option[value='boolean']").prop("disabled", false);
          formatCastingSelector.find("option[value='conditional']").prop("disabled", false);
          if (ValueComposerUtil.isValueComposerConditional(this.options.valueComposer)) {
            formatCastingSelector.val("conditional");
          }
        } else {
          formatCastingSelector.prop("disabled", true);
        }
      } else {
        if (ValueComposerUtil.isValueComposerConditional(this.options.valueComposer)) {
          formatCastingSelector.val("conditional");
        } else {
          formatCastingSelector.val(castingFormat);
        }
      }
      if (typeof formatCastingSelector.val() !== "string") {
        // add brackets arround unknown values, to be future compatible
        formatCastingSelector.append($("<option>").val(castingFormat).text("( " + castingFormat + " )"));
        formatCastingSelector.val(castingFormat);
      }
      // always add it, we will retrieve this information, even if it is hidden.
      formatCastingPanel.append(formatCastingSelector);
      var codeModePanel = $("<span>").addClass("codeModePanel").toggle(false);
      codeModePanel.append($("<span>").addClass("languageLabel").text($.i18n._("nixps-quantum-expressionbuilder.language")));
      var codeModeSelector = $("<span>").addClass("languageSelector").Select({
        keyValues: {
          "xmlVariable": $.i18n._("nixps-quantum-expressionbuilder.lang_xml"),
          "jsonVariable": $.i18n._("nixps-quantum-expressionbuilder.lang_json"),
          "textVariable": $.i18n._("nixps-quantum-expressionbuilder.lang_plaintext")
        },
        showUnknownValue: true,
        "default": codeEditFormat
      });
      codeModePanel.append(codeModeSelector);

      // warning message
      var warnIcon = $("<span>").addClass("cf-icon cf-icon-alert-triangle cf-icon-lg wrongValueComposerMessage").attr("title", $.i18n._("nixps-quantum-expressionbuilder.wrong_format")).hide();
      var modeSwitch = $("<div>").addClass("expression-switch");
      modeSwitch.append($("<div>").addClass("expressionTitle expression-switch_selected").text($.i18n._("nixps-quantum-expressionbuilder.expression")));
      modeSwitch.append(codeTextButton);
      var titleExpression = $("<div>").addClass("toolTopBar noselect");
      if (this.options.enableCodeEditor === true) {
        titleExpression.append(modeSwitch);
        titleExpression.append($("<span>&nbsp;&nbsp;</span>"));
        titleExpression.append(codeModePanel);
      }
      titleExpression.append(warnIcon);
      titleExpression.append(formatCastingPanel);
      if (this.options.showOriginalStateButton === true) {
        titleExpression.append(goToDefaultButton);
      }
      if (this.options.enableAddPathButton === true) {
        titleExpression.append(addFileUrlFromFolderButton);
      }
      titleExpression.find(".expressionTitle").addClass("enableButton");

      // The expression editor field
      titleExpression.appendTo(rightPanel);
      var expressionEditor = $("<div>").appendTo(rightPanel).ExpressionEditor({
        entityComposerDefinitions: new EntityComposerCollection(this.options.entityComposerDefinitionResults),
        scope: this.options.scope,
        expressionListUUID: this.uuid
      }).addClass("expressionEditor").toggle(true);

      // code editor
      var mCodeEditorDOM = null;
      if (this.options.enableCodeEditor === true) {
        mCodeEditorDOM = $("<div>").addClass("codeEditor").toggle(false).CodeEditor({
          entityComposerDefinitions: new EntityComposerCollection(this.options.entityComposerDefinitionResults),
          scope: this.options.scope,
          expressionListUUID: this.uuid,
          mode: codeEditFormat,
          content: ValueComposerUtil.addCasting(this.options.valueComposer, castingFormat, new EntityComposerCollection(this.options.entityComposerDefinitionResults)),
          loaderror: function loaderror(pEvent, pData) {
            that.element.find(".expression-switch").hide();
          }
        }).appendTo(rightPanel);
      }
      var typeEditorOptions = {
        entityComposerDefinitions: new EntityComposerCollection(this.options.entityComposerDefinitionResults),
        scope: this.options.scope,
        expressionListUUID: this.uuid,
        mode: codeEditFormat,
        content: []
      };
      var arrayEditor = $("<div>").addClass("arrayEditor typeEditor").appendTo(rightPanel).toggle(false).ArrayEditor(typeEditorOptions);
      var objectEditor = $("<div>").addClass("objectEditor typeEditor").appendTo(rightPanel).toggle(false).ObjectEditor(typeEditorOptions);
      var booleanEditor = $("<div>").addClass("booleanEditor typeEditor").appendTo(rightPanel).toggle(false).BooleanEditor(typeEditorOptions);

      // The variable list
      $("<h3>").addClass("variableTitle cf-title-h4").text($.i18n._("nixps-quantum-expressionbuilder.title_variables")).appendTo(rightPanel);
      var variableList = $("<div>").appendTo(rightPanel).VariableList({
        variables: $.map(this.options.valueComposerCollection, function (e, i) {
          return {
            name: e.name,
            value: e.sample,
            fixed: e.fixed_sample,
            visible: e.sample_visible
          };
        })
      });

      // The result
      $("<h3>").addClass("resultTitle cf-title-h4").text($.i18n._("nixps-quantum-expressionbuilder.title_result")).appendTo(rightPanel);
      // The messages from the result calculation
      $("<div>").addClass("messages").hide().appendTo(rightPanel);
      var result = $("<div>").addClass("result");
      result.appendTo(rightPanel);
      this._setResult(false);

      // The footer with buttons
      var buttonBar = $("<div>").addClass("buttonBar cf-buttonbar");
      buttonBar.append($("<button>").attr("type", "button").addClass("cancel button cf-button-secondary").text($.i18n._("nixps-quantum-expressionbuilder.cancel")));
      buttonBar.append($("<button>").attr("type", "button").addClass("save button cf-button-main").text($.i18n._("nixps-quantum-expressionbuilder.save")));
      buttonBar.appendTo(this.element);
      this._on(this.element, {
        "expressionvariablessearchchange": this._searchChangeHandler,
        "expressioneditorchange": this._expressionEditorChangeHandler,
        "codeeditorchange": this._codeEditorChangeHandler,
        "codeeditorerror": this._codeEditorErrorHandler,
        "arrayeditorchange": this._arrayEditorChangeHandler,
        "objecteditorchange": this._objectEditorChangeHandler,
        "booleaneditorchange": this._booleanEditorChangeHandler,
        "variablelistchange": this._variableListChangeHandler,
        "expressionlistexpressionselected": this._expressionSelectedHandler,
        "expressionlistaddvariable": this._expressionAddVariableHandler,
        "click .cancel": this._closeDialogHandle,
        "click .save": this._saveDialogHandle,
        "change.languageSelector": this._changeLanguageHandler,
        "click .codeTextButton": this._codeEditorModeHandler,
        "click .expressionTitle": this._showExpressionEditor,
        "click .addFileUrlFromFolderButton": this._addFileUrlFromFolderHandler,
        "click .goToDefaultButton": this._goToDefaultHandler,
        "dragstart": this._dragstartHandler,
        "drag": this._dragHandler,
        "keydown": this._keyDownHandler,
        "expressioneditortogglemath": this.handleToggleMath,
        "change .formatCastingSelector": this._handleCastingChange
      });

      //init resize
      var that = this;
      leftPanel.resizable({
        containment: that.element,
        handles: "e",
        minWidth: 200,
        resize: function resize(event, ui) {
          rightPanel.css("left", leftPanel.width() + 5);
          if (rightPanel.outerWidth() <= 350) {
            rightPanel.css("left", that.element.width() - 350);
            leftPanel.width(that.element.width() - rightPanel.outerWidth() - 5);
          }
        }
      });

      // first do the long call
      var defCollection = $.when(this.options.getValueComposerEditorConfiguration).then(function (results) {
        return {
          workflowVariableCollection: new WorkflowVariableCollection(results),
          workflowDataCollection: new WorkflowDataCollection(results)
        };
      });

      // then, inform the user that it will take a time, showing waiting icon
      leftPanel.append($("<div>").FreezeOverlay());
      leftPanel.find(".nixps-FreezeOverlay").FreezeOverlay("show"); // find afterwards so the overlay has het parents to better possition the spinner

      // wait the results
      $.when(defCollection, variableList.VariableList("updateList")).always(function () {
        // remove the spinner in each situation
        leftPanel.find(".nixps-FreezeOverlay").remove();
      }).done(function (collections) {
        if (that.alive === false) {
          return; // kill zombie
        }
        // if everyhting is done well
        that.workflowVariableCollection = collections.workflowVariableCollection;
        that.workflowDataCollection = collections.workflowDataCollection;
        expressionList.ExpressionList({
          composerList: that.options.valueComposerCollection,
          workflowVariableCollection: that.workflowVariableCollection,
          dataVariableCollection: that.workflowDataCollection,
          showCategorie: that.options.showCategorie,
          showAddButton: that.options.showAddVariableButton,
          scope: that.options.scope,
          list_uuid: that.uuid
        });
        if (castingFormat === ValueComposerUtil.types.NO_CASTING_FORMAT) {
          var templatestring = ValueComposerTranslator.valuecomposerToTemplate(that.options.valueComposer);
          switch (templatestring) {
            case "${files.previous}":
              // castingFormat = ValueComposerUtil.types.ARRAY;
              // formatCastingSelector.val(castingFormat);
              break;
            default:
              break;
          }
        }
        if (that.options.enableCodeEditor === true) {
          mCodeEditorDOM.CodeEditor("option", "knownVariableNames", that.workflowVariableCollection.getNames());
        }
        variableList.VariableList("option", "workflowVariableCollection", that.workflowVariableCollection);
        if (castingFormat === "array") {
          arrayEditor.ArrayEditor("option", "content", that.options.valueComposer);
        } else if (castingFormat === "object") {
          objectEditor.ObjectEditor("option", "content", that.options.valueComposer);
        } else if (ValueComposerUtil.isValueComposerConditional(that.options.valueComposer) || castingFormat === "conditional") {
          booleanEditor.BooleanEditor("option", "content", that.options.valueComposer);
        }
        expressionEditor.ExpressionEditor("option", "valueComposer", that.options.valueComposer);
        variableList.VariableList("option", "variableNames", expressionEditor.ExpressionEditor("getVariableNames"));
        that._setResult(true, expressionEditor.ExpressionEditor("getResult", expressionEditor.ExpressionEditor("getVariableNames")));
        if (isBrowserCompatible() === false) {
          that.element.find(".nixps-quantum-ExpressionList").ExpressionList("disable", "nixps-quantum-expressionlist.error_wrongbrowser");
          that.element.find(".formatCastingPanel, .addFileUrlFromFolderButton").remove();
          if (expressionEditor.ExpressionEditor("isBlocking")) {
            that.element.find(".expression-switch").hide();
          }
        } else {
          // if there are arrays, prevent other edit actions
          if (castingFormat !== "object" && expressionEditor.ExpressionEditor("isBlocking")) {
            that.element.find(".nixps-quantum-ExpressionList").ExpressionList("disable", "nixps-quantum-expressionlist.error_notedit", false);
            that.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
            that.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
            that.element.find(".expression-switch").addClass("disabled");
          }
          if (castingFormat === "array") {
            that._showArrayEditor();
          } else if (castingFormat === "object") {
            that._showObjectEditor();
          } else if (ValueComposerUtil.isValueComposerConditional(that.options.valueComposer) || castingFormat === "conditional") {
            that._showBooleanEditor();
          } else if (that.options.enableCodeEditor === true) {
            var showExpression = sniffExpressionMode(that.options.valueComposer);
            if (showExpression === true) {
              that._showExpressionEditor();
            } else {
              that._codeEditorModeHandler();
            }
          }
          if (arrayEditor.ArrayEditor("isBlocking") || objectEditor.ObjectEditor("isBlocking")) {
            that.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
            that.element.find(".expression-switch").addClass("disabled");
          }
        }
      }).fail(function (pError) {
        // if this fails the variabe list is not poppulated, so now we could see something if something goes wrong
        console.error(pError);
      });
    },
    _searchChangeHandler: function _searchChangeHandler(event, data) {
      var query = data.value;
      this.element.find(".nixps-quantum-ExpressionList").ExpressionList("option", "filter", query);
    },
    _closeDialogHandle: function _closeDialogHandle() {
      this._trigger("cancel", null, {});
    },
    _saveDialogHandle: function _saveDialogHandle() {
      var that = this;
      // control if value is good, can be parsed
      var showingDialog = null;
      if (that.isWrongValueComposer === true) {
        showingDialog = $.Deferred(function (pDefer) {
          that.element.Dialog("showDialog", $.i18n._("nixps-quantum-expressionbuilder.mess_wrong_format_title"), $.i18n._("nixps-quantum-expressionbuilder.mess_wrong_format"), {}, [{
            classes: "dialog_no_button cf-button-secondary",
            type: "no",
            label: "nixps-cloudflow-dialog.cancel",
            cbFunction: pDefer.reject
          }, {
            classes: "dialog_yes_button cf-button-error",
            type: "yes",
            label: "nixps-cloudflow-dialog.continue",
            cbFunction: pDefer.resolve
          }]);
        });
      }
      if (that.isWrongValueComposer === false && that.element.find(".objectEditor").css("display") !== "none" && that.element.find(".objectEditor").ObjectEditor("hasKeyIssues") === true) {
        showingDialog = $.Deferred(function (pDefer) {
          that.element.Dialog("showDialog", $.i18n._("nixps-quantum.error_key_issue"), $.i18n._("nixps-quantum-expressionbuilder.object_wrong_format_0"), {}, [{
            classes: "dialog_no_button cf-button-secondary",
            type: "no",
            label: "nixps-cloudflow-dialog.cancel",
            cbFunction: pDefer.reject
          }, {
            classes: "dialog_yes_button cf-button-error",
            type: "yes",
            label: "nixps-cloudflow-dialog.continue",
            cbFunction: pDefer.resolve
          }]);
        });
      }
      $.when(showingDialog).then(function () {
        if (that.alive === false) {
          return; // kill zombie
        }

        var outputValueComposer;
        // Skip casting when in math mode.
        if (that.options.mathMode === true) {
          outputValueComposer = that.options.valueComposer;
          if (Array.isArray(outputValueComposer) && outputValueComposer.length > 0 && outputValueComposer[0].type !== "com.nixps.quantum.calculations.0") {
            outputValueComposer = ValueComposerTranslator.valueComposerToCalculation(outputValueComposer);
          }
          that._trigger("save", null, {
            valueComposer: outputValueComposer
          });
          return;
        } else if (ValueComposerUtil.isValueComposerACalculation(that.options.valueComposer) && Array.isArray(that.options.valueComposer[0].operations)) {
          that.options.valueComposer = ValueComposerTranslator.operationsToValueComposer(that.options.valueComposer[0].operations);
        }
        var castingChoose = that.element.find(".formatCastingSelector").val();
        // add coat of generale casting
        if (typeof castingChoose === "string" && castingChoose.length > 0) {
          if (castingChoose === "conditional") {
            // do not add castings...
            that._trigger("save", null, {
              valueComposer: that.options.valueComposer
            });
            return;
          }
          // if not object and empty, save empty value composer
          if (castingChoose !== "object" && ValueComposerTranslator.valuecomposerToTemplate(that.options.valueComposer) === "") {
            that._trigger("save", null, {
              valueComposer: ValueComposerUtil.getEmptyValueComposer()
            });
            return;
          }
          outputValueComposer = ValueComposerUtil.addCasting(that.options.valueComposer, castingChoose, new EntityComposerCollection(that.options.entityComposerDefinitionResults));
          if (castingChoose === "object") {
            outputValueComposer = CloudflowObject.replaceEmptyArrayRows(outputValueComposer, ValueComposerUtil.getEmptyValueComposer());
          }
        } else {
          outputValueComposer = that.options.valueComposer;
        }
        that._trigger("save", null, {
          valueComposer: outputValueComposer
        });
      });
    },
    _handleCastingChange: function _handleCastingChange(pEvent, pValue) {
      var currentValue = $(pEvent.target).val();
      if (currentValue === "calculation" && this.options.mathMode !== true) {
        this.setMathMode(true);
        this._scheduleResultChange();
      } else if (this.options.mathMode === true) {
        this.setMathMode(false);
        this._scheduleResultChange();
      }
      if (currentValue !== "conditional" && ValueComposerUtil.isValueComposerConditional(this.options.valueComposer)) {
        this.options.valueComposer = ValueComposerUtil.removeConditional(this.options.valueComposer);
        this._scheduleResultChange();
      }
      if (this.element.find(".nixps-quantum-CodeEditor").is(":visible")) {
        return; // Do not switch editors when in code mode.
      }

      if (currentValue === "array") {
        if (this.element.find(".arrayEditor").css("display") === "none") {
          this._showArrayEditor();
        }
      } else if (currentValue === "object") {
        if (this.element.find(".objectEditor").css("display") === "none") {
          this._showObjectEditor();
        }
      } else if (currentValue === "conditional") {
        if (this.element.find(".booleanEditor").css("display") === "none") {
          this._showBooleanEditor();
        }
      } else {
        if (this.element.find(".arrayEditor").css("display") !== "none" || this.element.find(".objectEditor").css("display") !== "none" || this.element.find(".booleanEditor").css("display") !== "none") {
          this._showExpressionEditor();
        } else {
          if (this.options.mathMode === true || this.element.find(".expressionEditor").ExpressionEditor("isBlocking")) {
            this.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
          } else {
            this.element.find(".addFileUrlFromFolderButton").prop("disabled", false).removeClass("disable");
          }
        }
      }
      if (currentValue !== "object" && this.element.find(".expressionEditor").ExpressionEditor("isBlocking")) {
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("disable", "nixps-quantum-expressionlist.error_notedit", false);
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
        this.element.find(".expression-switch").addClass("disabled");
      } else {
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("enable");
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", false);
        this.element.find(".expression-switch").removeClass("disabled");
      }
    },
    handleToggleMath: function handleToggleMath(pEvent, pValue) {
      this.setMathMode(pValue.enabled);
    },
    setMathMode: function setMathMode(pValue) {
      if (typeof pValue !== "boolean") {
        return;
      }
      this.options.mathMode = pValue;
      this.element.find(".nixps-quantum-CodeEditor").CodeEditor("setMathMode", this.options.mathMode);
      this.element.find(".nixps-quantum-ExpressionEditor").ExpressionEditor("setMathMode", this.options.mathMode);
      if (this.options.mathMode === true) {
        this.element.addClass("nixps-quantum-mathMode");
        this.element.find(".formatCastingSelector").val("calculation");
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
      } else {
        // mathMode is false
        // remove calc coat
        this.options.valueComposer = ValueComposerTranslator.valueComposerRemoveCalculation(this.options.valueComposer);
        this.element.removeClass("nixps-quantum-mathMode");
        this.element.find(".nixps-quantum-ExpressionEditor").removeClass("editor-textwarning");
        if (this.element.find(".formatCastingSelector").val() === "calculation") {
          this.element.find(".formatCastingSelector").val(ValueComposerUtil.types.NO_CASTING_FORMAT);
        }
        if (this.element.find(".nixps-quantum-CodeEditor").is(":visible")) {
          this.element.find(".goToDefaultButton, .addFileUrlFromFolderButton").hide();
        } else {
          this.element.find(".goToDefaultButton, .addFileUrlFromFolderButton").css("display", "");
        }
      }
    },
    toggleMathMode: function toggleMathMode() {
      this.setMathMode(!this.options.mathMode);
    },
    /**
     * @description function runs when user change the language selector
     * @function
     * @private
     * @returns {undefined}
     */
    _changeLanguageHandler: function _changeLanguageHandler() {
      var language = this.element.find(".languageSelector").Select("getValue");
      if (typeof language === "string" && language.length > 0) {
        this.element.find(".nixps-quantum-CodeEditor").CodeEditor("option", "mode", language);
      }
    },
    /**
     * @description function runs when user click on "code", when user want to swhich from expressiobuilder to code editor
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _codeEditorModeHandler: function _codeEditorModeHandler(pEvent, pData) {
      var editor = this.element.find(".nixps-quantum-CodeEditor");
      var that = this;
      // control if info is good, not bad ??
      var lostInfo = editor.CodeEditor("willInfoLostValueComposer", this.options.valueComposer);
      var showingDialog;
      if (lostInfo) {
        showingDialog = $.Deferred(function (pDefer) {
          that.element.Dialog("showDialog", $.i18n._("nixps-quantum-expressionbuilder.mess_lost_info_title"), $.i18n._("nixps-quantum-expressionbuilder.mess_lost_info"), {}, [{
            classes: "dialog_no_button cf-button-secondary",
            type: "no",
            label: "nixps-cloudflow-dialog.cancel",
            cbFunction: pDefer.reject
          }, {
            classes: "dialog_yes_button cf-button-error",
            type: "yes",
            label: "nixps-cloudflow-dialog.continue",
            cbFunction: pDefer.resolve
          }]);
        });
      }
      if (this.element.find(".formatCastingSelector").val() === "object" && this.element.find(".objectEditor").ObjectEditor("hasKeyIssues") === true) {
        showingDialog = $.Deferred(function (pDefer) {
          that.element.Dialog("showDialog", $.i18n._("nixps-quantum.error_key_issue"), $.i18n._("nixps-quantum-expressionbuilder.object_wrong_format_0"), {}, [{
            classes: "dialog_no_button cf-button-secondary",
            type: "no",
            label: "nixps-cloudflow-dialog.cancel",
            cbFunction: pDefer.reject
          }, {
            classes: "dialog_yes_button cf-button-error",
            type: "yes",
            label: "nixps-cloudflow-dialog.continue",
            cbFunction: pDefer.resolve
          }]);
        });
      }
      $.when(showingDialog).then(function () {
        // handle ui of topbar
        that.element.find(".expressionTitle").removeClass("enableButton");
        that.element.find(".codeTextButton").addClass("enableButton");
        // set codeeditor good
        // editor.CodeEditor("option", "content", ValueComposerUtil.addCasting(that.options.valueComposer,that.element.find(".formatCastingSelector").val(),new EntityComposerCollection(that.options.entityComposerDefinitionResults)));
        editor.CodeEditor("option", "content", that.options.valueComposer);
        editor.CodeEditor("setMathMode", that.options.mathMode);
        that.element.find(".nixps-quantum-ExpressionList").ExpressionList("enableArrays");
        // handle ui of topbar
        that.element.find(".expressionEditor, .goToDefaultButton, .addFileUrlFromFolderButton, .arrayEditor, .objectEditor, .booleanEditor").hide();
        that.element.find(".codeEditor, .codeModePanel").css("display", "");
        editor.CodeEditor("focus");
        that.element.find(".expressionTitle").removeClass("expression-switch_selected");
        that.element.find(".codeTextButton").addClass("expression-switch_selected");
      });
    },
    _showArrayEditor: function _showArrayEditor() {
      var editor = this.element.find(".nixps-quantum-ArrayEditor");
      // control if info is good, not bad ??
      // var lostInfo = editor.CodeEditor("willInfoLostValueComposer", this.options.valueComposer);
      // if needed ask permission to continou
      // if (lostInfo === false || (lostInfo === true && confirm($.i18n._("nixps-quantum-expressionbuilder.mess_lost_info")))) {
      // handle ui of topbar
      this.element.find(".expressionTitle").removeClass("enableButton");
      this.element.find(".codeTextButton").addClass("enableButton");
      var temp = ValueComposerTranslator.valuecomposerToTemplate(this.options.valueComposer);
      if (temp === "" || temp === "[]") {
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("enableArrays");
      } else {
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("disableArrays");
      }
      if (this.element.find(".objectEditor:visible").length > 0 && this.options.valueComposer.length === 1 && this.options.valueComposer[0].value && this.options.valueComposer[0].type === "com.nixps.quantum.value.0") {
        switch (this.options.valueComposer[0].value) {
          case "{}":
            this.options.valueComposer = ValueComposerUtil.getEmptyValueComposer();
            break;
          default:
            break;
        }
      }

      // set editor good
      editor.ArrayEditor("option", "content", this.options.valueComposer);

      // handle ui of topbar
      this.element.find(".expressionEditor, .codeEditor, .codeModePanel, .objectEditor, .booleanEditor").hide();
      this.element.find(".formatCastingPanel, .arrayEditor, .goToDefaultButton, .addFileUrlFromFolderButton").css("display", "");
      this.element.find(".expressionTitle").addClass("expression-switch_selected");
      this.element.find(".codeTextButton").removeClass("expression-switch_selected");
      if (editor.ArrayEditor("isBlocking")) {
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
        this.element.find(".expression-switch").addClass("disabled");
      } else {
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", false).removeClass("disable");
      }
      // }
    },

    _showObjectEditor: function _showObjectEditor() {
      var editor = this.element.find(".objectEditor");
      this.element.find(".nixps-quantum-ExpressionList").ExpressionList("enableArrays");
      // control if info is good, not bad ??
      // var lostInfo = editor.CodeEditor("willInfoLostValueComposer", this.options.valueComposer);
      // if needed ask permission to continou
      // if (lostInfo === false || (lostInfo === true && confirm($.i18n._("nixps-quantum-expressionbuilder.mess_lost_info")))) {
      // handle ui of topbar
      this.element.find(".expressionTitle").removeClass("enableButton");
      this.element.find(".codeTextButton").addClass("enableButton");
      if (this.element.find(".arrayEditor:visible").length > 0 && this.options.valueComposer.length === 1 && this.options.valueComposer[0].value && this.options.valueComposer[0].type === "com.nixps.quantum.value.0") {
        switch (this.options.valueComposer[0].value) {
          case "[\"\"]":
            // Empty value
            this.options.valueComposer = ValueComposerUtil.getEmptyValueComposer();
            break;
          default:
            break;
        }
      }

      // set editor good
      editor.ObjectEditor("option", "content", this.options.valueComposer);

      // handle ui of topbar
      this.element.find(".expressionEditor, .codeEditor, .codeModePanel, .arrayEditor, .booleanEditor").hide();
      this.element.find(".formatCastingPanel, .objectEditor, .goToDefaultButton, .addFileUrlFromFolderButton").css("display", "");
      this.element.find(".expressionTitle").addClass("expression-switch_selected");
      this.element.find(".codeTextButton").removeClass("expression-switch_selected");
      if (editor.ObjectEditor("isBlocking")) {
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
        this.element.find(".expression-switch").addClass("disabled");
      } else {
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", false).removeClass("disable");
      }
      // }
    },

    _showBooleanEditor: function _showBooleanEditor() {
      var editor = this.element.find(".booleanEditor");
      this.element.find(".nixps-quantum-ExpressionList").ExpressionList("disableArrays");
      this.element.find(".expressionTitle").removeClass("enableButton");
      this.element.find(".codeTextButton").addClass("enableButton");
      if (this.element.find(".arrayEditor:visible, .objectEditor:visible").length > 0 && this.options.valueComposer.length === 1 && this.options.valueComposer[0].value && this.options.valueComposer[0].type === "com.nixps.quantum.value.0") {
        switch (this.options.valueComposer[0].value) {
          case "{}":
          case "[\"\"]":
            this.options.valueComposer = ValueComposerUtil.getEmptyValueComposer();
            break;
          default:
            break;
        }
      }
      // set codeeditor good
      editor.BooleanEditor("option", "content", this.options.valueComposer);

      // handle ui of topbar
      this.element.find(".expressionEditor, .codeEditor, .addFileUrlFromFolderButton, .codeModePanel, .objectEditor, .arrayEditor").hide();
      this.element.find(".formatCastingPanel, .booleanEditor, .goToDefaultButton").css("display", "");
      this.element.find(".expressionTitle").addClass("expression-switch_selected");
      this.element.find(".codeTextButton").removeClass("expression-switch_selected");
      if (editor.BooleanEditor("isBlocking")) {
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
        this.element.find(".expression-switch").addClass("disabled");
      } else {
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", false).removeClass("disable");
      }
    },
    /**
     * @description function runs when user want to go back to expressionbuilder from code editor
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _showExpressionEditor: function _showExpressionEditor() {
      var that = this;
      // control if value is good, can be parsed
      var showingDialog = null;
      if (that.isWrongValueComposer === true) {
        showingDialog = $.Deferred(function (pDefer) {
          that.element.Dialog("showDialog", $.i18n._("nixps-quantum-expressionbuilder.mess_wrong_format_title"), $.i18n._("nixps-quantum-expressionbuilder.mess_wrong_format"), {}, [{
            classes: "dialog_no_button cf-button-secondary",
            type: "no",
            label: "nixps-cloudflow-dialog.cancel",
            cbFunction: pDefer.reject
          }, {
            classes: "dialog_yes_button cf-button-error",
            type: "yes",
            label: "nixps-cloudflow-dialog.continue",
            cbFunction: pDefer.resolve
          }]);
        });
      }
      // control if we can parse the dump typed by the user, if needed ask for permission
      $.when(showingDialog).done(function () {
        if (that.alive === false) {
          return; // kill zombie
        }

        var formatCasting = that.element.find(".formatCastingSelector").val();
        if (formatCasting === "array") {
          that._showArrayEditor();
          return;
        } else if (formatCasting === "object") {
          that._showObjectEditor();
          return;
        } else if (formatCasting === "conditional") {
          that._showBooleanEditor();
          return;
        }

        // handle ui of topbar
        that.element.find(".wrongValueComposerMessage").hide();
        that.element.find(".codeTextButton").removeClass("enableButton");
        that.element.find(".expressionTitle").addClass("enableButton");
        if (that.element.find(".arrayEditor:visible, .objectEditor:visible").length > 0 && that.options.valueComposer.length === 1 && that.options.valueComposer[0].value && that.options.valueComposer[0].type === "com.nixps.quantum.value.0") {
          switch (that.options.valueComposer[0].value) {
            case "{}":
            case "[\"\"]":
              that.options.valueComposer = ValueComposerUtil.getEmptyValueComposer();
              break;
            default:
              break;
          }
        } else if (that.element.find(".objectEditor:visible").length > 0 && $.isPlainObject(that.options.valueComposer) && $.isEmptyObject(that.options.valueComposer)) {
          that.options.valueComposer = ValueComposerUtil.getEmptyValueComposer();
        }

        // set the expression builder good
        var mathMode = that.options.mathMode;
        that.element.find(".nixps-quantum-ExpressionEditor").ExpressionEditor("setValueComposer", that.options.valueComposer, false);
        that.element.find(".nixps-quantum-ExpressionEditor").ExpressionEditor("setMathMode", mathMode);

        // handle ui of topbar
        that.element.find(".codeEditor, .codeModePanel, .arrayEditor, .objectEditor, .booleanEditor").hide();
        that.element.find(".expressionEditor, .formatCastingPanel, .goToDefaultButton, .addFileUrlFromFolderButton").css("display", "");
        that.element.find(".expressionTitle").addClass("expression-switch_selected");
        that.element.find(".codeTextButton").removeClass("expression-switch_selected");
        if (formatCasting === "conditional" || that.options.mathMode === true || that.element.find(".expressionEditor").ExpressionEditor("isBlocking")) {
          that.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
        } else {
          that.element.find(".addFileUrlFromFolderButton").prop("disabled", false).removeClass("disable");
        }

        //if there are only strings prevent adding arrays
        if (ValueComposerTranslator.valuecomposerToTemplate(that.options.valueComposer) === "") {
          that.element.find(".nixps-quantum-ExpressionList").ExpressionList("enableArrays");
        } else {
          that.element.find(".nixps-quantum-ExpressionList").ExpressionList("disableArrays");
        }

        // the user ackseped to go the the last good value, so set the flag to good
        that.isWrongValueComposer = false;
      });
    },
    /**
     * @description draw dialog when user press button,
     * @function
     * @private
     * @returns {dialog}
     */
    _addFileUrlFromFolderHandler: function _addFileUrlFromFolderHandler() {
      this.fileSelectPanel = $("<div>").addClass("selectFiles").dialog({
        title: $.i18n._("nixps-quantum-expressionbuilder.select"),
        closeText: "",
        width: 500,
        minWidth: 300,
        height: 350,
        minHeight: 300,
        dialogClass: "selectFileDialog cf-dialog",
        classes: {
          "ui-dialog": "selectFileDialog cf-dialog"
        },
        autoOpen: true,
        close: function close(event, ui) {
          $(this).remove();
        }
      }).css({
        "display": "block",
        "position": "relative",
        padding: 0
      });
      var fileChooser = $("<div>").css({
        "height": "100%"
      });
      var that = this;
      this.fileSelectPanel.append(fileChooser);
      fileChooser.FileChooser2({
        multiple: false,
        enableSelectButton: true,
        consent: this.options.consent,
        select: function select(pEvent, pData) {
          var url = "";
          if (Array.isArray(pData.files) && pData.files.length > 0) {
            url = pData.files[0];
          } else {
            url = that.document.find(".nixps-cloudflow-FileChooser").FileChooser2("getCurrentFolder");
          }
          if (that.element.find(".arrayEditor:visible").length > 0) {
            that.element.find(".arrayEditor").ArrayEditor("addContent", url);
          } else if (that.element.find(".objectEditor:visible").length > 0) {
            that.element.find(".objectEditor").ObjectEditor("addContent", url);
          } else {
            that.element.find(".expressionEditor").ExpressionEditor("addContent", url);
          }
          that.fileSelectPanel.dialog("close");
        }
      });
    },
    /**
     * @brief function runs when user click on "_goToDefaultSettings" button
     * this function cleans the settings and put the original settings 
     * @param {type} pEvent
     * @param {type} pData
     * @returns {nothing}
     */
    _goToDefaultHandler: function _goToDefaultHandler(pEvent, pData) {
      var defaultValue = undefined;
      var collarDefinition = this.options.context.node_definition;
      var expressionEditor = this.element.find(".nixps-quantum-ExpressionEditor:visible");
      var parameter_name = this.options.context.parameter_name;
      if (collarDefinition !== undefined && !$.isEmptyObject(collarDefinition.parameters) && Array.isArray(collarDefinition.parameters[parameter_name])) {
        // normal valuecomposers
        defaultValue = collarDefinition.parameters[parameter_name];
      } else if (collarDefinition !== undefined && !$.isEmptyObject(collarDefinition.parameters) && collarDefinition.parameters[parameter_name] !== undefined) {
        // special case, if you force to value compose (ex. alt + click)
        defaultValue = {
          type: "com.nixps.quantum.value.0"
        };
        defaultValue.value = collarDefinition.parameters[parameter_name];
        defaultValue = [defaultValue];
      }
      if (defaultValue === undefined) {
        // if nothing is known, try to reset if possible
        if (this.options.mathMode === false && this.element.find(".expressionEditor:visible").ExpressionEditor("isBlocking") === false) {
          defaultValue = ValueComposerUtil.getEmptyValueComposer();
        }
      }
      if (Array.isArray(defaultValue)) {
        if (this.options.forceFormat === NO_CASTING_FORMAT) {
          this.element.find(".formatCastingSelector").val(NO_CASTING_FORMAT);
        }
        if (this.options.mathMode === true) {
          this.setMathMode(false);
        }
        expressionEditor.ExpressionEditor("option", "valueComposer", defaultValue);
        this.options.valueComposer = defaultValue;
        if (this.element.find(".objectEditor:visible").length > 0 || this.element.find(".booleanEditor:visible").length > 0 || this.element.find(".arrayEditor:visible").length > 0) {
          this._showExpressionEditor();
        }
        this._expressionEditorChangeHandler(null, {
          variables: expressionEditor.ExpressionEditor("getVariableNames")
        });
      } else {
        console.warn("_goToDefaultHandler: no correct default value composer found");
      }
      if (pEvent.altKey === true && pEvent.shiftKey === true) {
        this.element.find(".nixps-quantum-VariableList").VariableList("resetSavedValues");
      }
    },
    _expressionEditorChangeHandler: function _expressionEditorChangeHandler(e, data) {
      var variables = data.variables,
        expressionEditor = this.element.find(":nixps-quantum-ExpressionEditor"),
        variableList = this.element.find(":nixps-quantum-VariableList"),
        mustBlock = expressionEditor.ExpressionEditor("isBlocking") === true,
        mustBlockArrays = expressionEditor.ExpressionEditor("isString") === true;
      if (isBrowserCompatible() === false || this.options.forceFormat !== NO_CASTING_FORMAT) {
        // leave block as it is
      } else if (mustBlock) {
        // if ther are arrays, prevent other edit actions
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("disable", "nixps-quantum-expressionlist.error_notedit", false);
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
        this.element.find(".expression-switch").addClass("disabled");
      } else {
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("enable");
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", false).removeClass("disable");
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", false);
        this.element.find(".expression-switch").removeClass("disabled");
      }

      // Side effect will set the result as the variables will change
      variableList.VariableList("option", "variableNames", variables);
      this.options.valueComposer = expressionEditor.ExpressionEditor("option", "valueComposer");
      if (ValueComposerTranslator.valuecomposerToTemplate(this.options.valueComposer) === "") {
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("enableArrays");
      } else {
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("disableArrays");
      }
      this._scheduleResultChange();
      // if(Array.isArray(this.options.valueComposer) && this.options.valueComposer.length === 1 && this.options.valueComposer[0].first_only !== true && this.options.valueComposer[0].type === "com.nixps.quantum.data_from_previous_node.0"){
      //     this.element.find(".formatCastingSelector").val("array");
      //     this._showArrayEditor();
      // }
    },

    _dragstartHandler: function _dragstartHandler(pEvent, pData) {
      this.element.find(".nixps-quantum-CodeEditor:visible").CodeEditor("startDragHandler", pEvent, pData);
    },
    _dragHandler: function _dragHandler(pEvent, pData) {
      this.element.find(".nixps-quantum-CodeEditor:visible").CodeEditor("dragHandler", pEvent, pData);
    },
    _keyDownHandler: function _keyDownHandler(event) {
      if (!event.isDefaultPrevented() && event.keyCode !== undefined && event.keyCode === $.ui.keyCode.ESCAPE) {
        this._trigger("cancel", null, {});
        event.preventDefault();
        event.stopPropagation();
      }
    },
    /**
     * @description function runs when there is a change in the code editor and when he can parse correctly to value composers
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _codeEditorChangeHandler: function _codeEditorChangeHandler(pEvent, pData) {
      this.isWrongValueComposer = false; // if change event comes, the user resolved the case
      this.element.find(".wrongValueComposerMessage").hide(); // hide warning messages/ icons
      if (pData && Array.isArray(pData.content)) {
        this.options.valueComposer = pData.content;
        if (Array.isArray(pData.variables)) {
          this.element.find(".nixps-quantum-VariableList").VariableList("option", "variableNames", pData.variables);
        } else {
          this.element.find(".nixps-quantum-VariableList").VariableList("option", "variableNames", []);
        }
        if (this.options.mathMode === false && ValueComposerUtil.isValueComposerACalculation(this.options.valueComposer)) {
          // user has typed "${=" as generic stuff , when mathMode was false 
          this.setMathMode(true);
        }
        this._scheduleResultChange();
      }
    },
    /**
     * @description function runs when there is a change in the code editor and when he can parse correctly to value composers
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _arrayEditorChangeHandler: function _arrayEditorChangeHandler(pEvent, pData) {
      this.isWrongValueComposer = false; // if change event comes, the user resolved the case
      this.element.find(".wrongValueComposerMessage").hide(); // hide warning messages/ icons
      this.element.find(".codeTextButton, .formatCastingPanel, .expression-switch").css("display", "");
      if (this.element.find(".nixps-quantum-ArrayEditor").ArrayEditor("isBlocking")) {
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("disable", "nixps-quantum-expressionlist.error_notedit", false);
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", true).addClass("disable");
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
        this.element.find(".expression-switch").addClass("disabled");
      } else {
        this.element.find(".nixps-quantum-ExpressionList").ExpressionList("enable");
        this.element.find(".addFileUrlFromFolderButton").prop("disabled", false).removeClass("disable");
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", false);
        this.element.find(".expression-switch").removeClass("disabled");
      }
      if (pData !== undefined && pData !== null && Array.isArray(pData.content)) {
        this.options.valueComposer = ValueComposerTranslator.arrayToValueComposer(pData.content, new EntityComposerCollection(this.options.entityComposerDefinitionResults), true);
        if (Array.isArray(pData.variables)) {
          this.element.find(".nixps-quantum-VariableList").VariableList("option", "variableNames", pData.variables);
        } else {
          this.element.find(".nixps-quantum-VariableList").VariableList("option", "variableNames", []);
        }
        var tmplate = ValueComposerTranslator.arrayToTemplate(pData.content, new EntityComposerCollection(this.options.entityComposerDefinitionResults));
        if (tmplate === "[\"\"]" || tmplate === "[]" || tmplate === "") {
          this.element.find(".nixps-quantum-ExpressionList").ExpressionList("enableArrays");
        } else {
          this.element.find(".nixps-quantum-ExpressionList").ExpressionList("disableArrays");
        }
        this._scheduleResultChange();
      }
    },
    /**
     * @description function runs when there is a change in the code editor and when he can parse correctly to value composers
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _objectEditorChangeHandler: function _objectEditorChangeHandler(pEvent, pData) {
      this.isWrongValueComposer = false; // if change event comes, the user resolved the case
      this.element.find(".wrongValueComposerMessage").hide(); // hide warning messages/ icons
      this.element.find(".codeTextButton, .formatCastingPanel, .expression-switch").css("display", "");
      if (this.element.find(".objectEditor").ObjectEditor("isBlocking")) {
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
        this.element.find(".expression-switch").addClass("disabled");
      } else {
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", false);
        this.element.find(".expression-switch").removeClass("disabled");
      }
      if (pData && _typeof(pData.content) === "object") {
        var tempcfObject = {};
        var keys = Object.keys(pData.content);
        if (keys.indexOf("") !== -1) {
          this.isWrongValueComposer = true;
        } else {
          this.isWrongValueComposer = false;
        }
        for (var i = 0; i < keys.length; i++) {
          CloudflowObject.setParameter(tempcfObject, keys[i], pData.content[keys[i]]);
        }
        this.options.valueComposer = ValueComposerTranslator.objectToValueComposer(tempcfObject, true);
        if (Array.isArray(pData.variables)) {
          this.element.find(".nixps-quantum-VariableList").VariableList("option", "variableNames", pData.variables);
        } else {
          this.element.find(".nixps-quantum-VariableList").VariableList("option", "variableNames", []);
        }
        this._scheduleResultChange();
      }
    },
    _booleanEditorChangeHandler: function _booleanEditorChangeHandler(pEvent, pData) {
      this.isWrongValueComposer = false; // if change event comes, the user resolved the case
      this.element.find(".wrongValueComposerMessage").hide(); // hide warning messages/ icons
      this.element.find(".codeTextButton, .formatCastingPanel, .expression-switch").css("display", "");
      if (this.element.find(".booleanEditor").BooleanEditor("isBlocking")) {
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", true);
        this.element.find(".expression-switch").addClass("disabled");
      } else {
        this.element.find(".codeTextButton, .formatCastingSelector").prop("disabled", false);
        this.element.find(".expression-switch").removeClass("disabled");
      }
      if ($.isPlainObject(pData) && Array.isArray(pData.content)) {
        this.options.valueComposer = pData.content;
        if (Array.isArray(pData.variables)) {
          this.element.find(".nixps-quantum-VariableList").VariableList("option", "variableNames", pData.variables);
        } else {
          this.element.find(".nixps-quantum-VariableList").VariableList("option", "variableNames", []);
        }
        this._scheduleResultChange();
      }
    },
    /**
     * @description function runs when codeEditor has a error, when he can not parse to a correct value composer,
     * Do some actions to show, handle when value is wrong
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _codeEditorErrorHandler: function _codeEditorErrorHandler(pEvent, pData) {
      // a error occured, activate flag that we have a error
      this.isWrongValueComposer = true;
      this.element.find(".wrongValueComposerMessage").show();
    },
    _variableListChangeHandler: function _variableListChangeHandler(e, d) {
      this._scheduleResultChange();
    },
    _checkCalculation: function _checkCalculation(pCalculation) {
      if (ValueComposerUtil.isValueComposerACalculation(pCalculation)) {
        var operations = pCalculation[0].operations;
        var hasMessage = false;
        if (!operations || operations.length <= 0) {
          return true;
        }
        var brackets = operations.filter(function (op) {
          return op.type === "grouping";
        });
        var countClose = brackets.filter(function (br) {
          return br.bracket === ")";
        }).length;
        var countOpen = brackets.filter(function (br) {
          return br.bracket === "(";
        }).length;
        var concatValues = _.reduce(operations, function (pPrev, pNext) {
          if (pNext.type === "value" && typeof pNext.value === "string" || typeof pNext.value === "number") {
            pPrev = pPrev + pNext.value;
          }
          return pPrev;
        }, []);
        var msg = this.element.find(".messages");
        var hasUnconvertedValuecomposer = false;
        for (var i = 0; i < operations.length; i++) {
          if (operations[i].type === "value" && Array.isArray(operations[i].value) && operations[i].value[0].type !== "com.nixps.quantum.variable.0" && operations[i].value[0].type !== "com.nixps.quantum.type_converter.0" && operations[i].value[0].to_type !== "number") {
            hasUnconvertedValuecomposer = true;
            break;
          }
        }
        var hasDoubleOperations = false;
        for (var i = 0; i < operations.length; i++) {
          if (operations[i].type === "operation" && operations[i - 1] && operations[i - 1].type === "operation") {
            hasDoubleOperations = true;
            break;
          }
        }
        if (hasUnconvertedValuecomposer === true) {
          warningMessage.clone().appendTo(msg).find(".message")._t("nixps-quantum-expressionbuilder.calc_not_converted");
          hasMessage = true;
        }
        var hasDoubleValues = false;
        for (var i = 0; i < operations.length; i++) {
          if (operations[i].type === "value" && operations[i - 1] && operations[i - 1].type === "value") {
            hasDoubleValues = true;
            break;
          }
        }
        if (!Array.isArray(operations) || operations.length <= 0) {
          warningMessage.clone().appendTo(msg).find(".message")._t("nixps-quantum-expressionbuilder.calc_cant_read");
          hasMessage = true;
        } else if (countClose !== countOpen) {
          warningMessage.clone().appendTo(msg).find(".message")._t("nixps-quantum-expressionbuilder.calc_missing_parentheses");
          hasMessage = true;
        } else if (operations[operations.length - 1].type === "operation") {
          warningMessage.clone().appendTo(msg).find(".message")._t("nixps-quantum-expressionbuilder.calc_ending_on_operation");
          hasMessage = true;
        } else if (hasDoubleOperations === true) {
          warningMessage.clone().appendTo(msg).find(".message")._t("nixps-quantum-expressionbuilder.calc_double_operator");
          hasMessage = true;
        } else if (hasDoubleValues === true) {
          warningMessage.clone().appendTo(msg).find(".message")._t("nixps-quantum-expressionbuilder.calc_double_value");
          hasMessage = true;
        } else if (concatValues && typeof concatValues === "string" && concatValues.length > 0 && !concatValues.match(CalcAllowedChars)) {
          warningMessage.clone().appendTo(msg).find(".message")._t("nixps-quantum-expressionbuilder.calc_invalid_characters");
          hasMessage = true;
        }
        if (hasMessage === true) {
          this.element.find(".nixps-quantum-ExpressionEditor").addClass("editor-textwarning");
          return false;
        }
        this.element.find(".nixps-quantum-ExpressionEditor").removeClass("editor-textwarning");
        return true;
      }
      warningMessage.clone().appendTo(msg).find(".message")._t("nixps-quantum-expressionbuilder.calc_cant_read");
      return false;
    },
    _scheduleResultChange: function _scheduleResultChange() {
      this.element.find(".result").addClass("waiting_on_result");
      clearTimeout(this.scheduleResultTimer);
      this.scheduleResultTimer = this._delay(function () {
        if (this.alive === false) {
          return; // do nothing when we are zombie
        }

        var variables = this.element.find(".nixps-quantum-VariableList").VariableList("option", "variables");
        var editor = this.element.find(".nixps-quantum-ExpressionEditor:visible");
        var arrayEditor = this.element.find(".nixps-quantum-ArrayEditor:visible");
        var objectEditor = this.element.find(".nixps-quantum-ObjectEditor:visible");
        var booleanEditor = this.element.find(".nixps-quantum-BooleanEditor:visible");
        var codeEditor = this.element.find(".nixps-quantum-CodeEditor:visible");
        var hasResult = false;
        var pJSONResult;
        if (arrayEditor.length > 0) {
          hasResult = arrayEditor.ArrayEditor("hasResult") === true;
          if (hasResult) {
            pJSONResult = [arrayEditor.ArrayEditor("getSampleResult", variables)];
          }
        } else if (objectEditor.length > 0) {
          hasResult = objectEditor.ObjectEditor("hasResult") === true;
          if (hasResult) {
            pJSONResult = objectEditor.ObjectEditor("getSampleResult", variables);
          }
        } else if (booleanEditor.length > 0) {
          hasResult = booleanEditor.BooleanEditor("hasResult") === true;
          if (hasResult) {
            pJSONResult = booleanEditor.BooleanEditor("getSampleResult", variables);
          }
        } else if (editor.length > 0) {
          hasResult = editor.ExpressionEditor("hasResult") === true;
          if (hasResult) {
            pJSONResult = editor.ExpressionEditor("getResult", variables);
          }
        } else if (codeEditor.length > 0) {
          hasResult = codeEditor.CodeEditor("hasResult") === true;
          if (hasResult) {
            pJSONResult = codeEditor.CodeEditor("getSampleResult", variables);
          }
        }
        var result = this.element.find(".result"),
          messages = this.element.find(".messages");
        if (hasResult) {
          var that = this;
          if (that.options.mathMode === true) {
            messages.empty();
            messages.hide();
            var isCorrect = that._checkCalculation.call(that, ValueComposerTranslator.valueComposerToCalculation(that.options.valueComposer));
            if (!isCorrect) {
              messages.show();
              result.empty();
              result.append($("<div>").addClass("noresult")._t("nixps-quantum-expressionbuilder.no_result"));
              return;
            }
          }
          $.when(this.options.simulation(pJSONResult, this.options.context)).then(function (pResult) {
            that._setResult(true, pResult, undefined);
            that.element.find(".result").removeClass("waiting_on_result");
          }, function (pError) {
            that._setResult(false, undefined, pError);
          });
        } else {
          this._setResult(false);
        }
      }, 500);
    },
    _setResult: function _setResult(pHasResult, pResult, pErrorMessage) {
      var result = this.element.find(".result"),
        messages = this.element.find(".messages");
      messages.hide();
      messages.empty();
      result.empty();
      if (pErrorMessage !== undefined) {
        // uncatched error from backend 
        warningMessage.clone().appendTo(messages).find(".message").text($.i18n._("nixps-quantum-expressionbuilder.unknown_error_for_result"));
        messages.show();
      }
      if (pHasResult === false || ["string", "number", "boolean"].includes(_typeof(pResult)) === false) {
        result.addClass("no_result").append($("<div>").addClass("noresult")._t("nixps-quantum-expressionbuilder.no_result"));
      } else {
        result.removeClass("no_result");
        if (pResult.length > 0) {
          // Check the first character of the result
          if (pResult[0].match(/\s/) !== null) {
            warningMessage.clone().appendTo(messages).find(".message").text($.i18n._("nixps-quantum-expressionbuilder.mess_space_begin"));
            messages.show();
          }
        }
        if (pResult.length > 1) {
          // Check the last character of the result
          if (pResult[pResult.length - 1].match(/\s/) !== null) {
            warningMessage.clone().appendTo(messages).find(".message").text($.i18n._("nixps-quantum-expressionbuilder.mess_space_end"));
            messages.show();
          }
        }
        result.text(pResult);
      }
    },
    _expressionSelectedHandler: function _expressionSelectedHandler(e, data) {
      var definition = data.definition;
      if (typeof definition.name === "string") {
        this.element.find(".nixps-quantum-ExpressionHelpPanel").ExpressionHelpPanel("option", "title", definition.name);
      }
      if ($.isPlainObject(definition.help)) {
        var helptext = null;
        if (this.options.language !== "en" && typeof definition.help[this.options.language] === "string") {
          helptext = definition.help[this.options.language];
        } else if (typeof definition.help.en === "string") {
          helptext = definition.help.en;
        }
        if (typeof helptext === "string") {
          this.element.find(".nixps-quantum-ExpressionHelpPanel").ExpressionHelpPanel("option", "contents", helptext);
        }
      } else if (typeof definition.help === "string") {
        this.element.find(".nixps-quantum-ExpressionHelpPanel").ExpressionHelpPanel("option", "contents", definition.help);
      }
    },
    _expressionAddVariableHandler: function _expressionAddVariableHandler(pEvent, pData) {
      if (pData && pData.append_to_content === true && typeof pData.variable_name === "string" && pData.variable_name.length > 0) {
        var newValueComposer = [{
          "type": "com.nixps.quantum.variable.0",
          "variable": pData.variable_name
        }];
        if (this.element.find(".arrayEditor:visible").length > 0) {
          if (Array.isArray(this.options.valueComposer)) {
            this.options.valueComposer = this.options.valueComposer.concat(newValueComposer);
            this.element.find(".arrayEditor").ArrayEditor("option", "content", this.options.valueComposer);
          }
        } else if (this.element.find(".objectEditor:visible").length > 0) {
          var valuecomposerToObject = ValueComposerTranslator.valueComposerToObject(this.options.valueComposer);
          if ($.isPlainObject(valuecomposerToObject) && valuecomposerToObject[pData.variable_name] === undefined) {
            valuecomposerToObject[pData.variable_name] = newValueComposer;
            this.options.valueComposer = ValueComposerTranslator.objectToValueComposer(valuecomposerToObject);
            this.element.find(".objectEditor").ObjectEditor("option", "content", this.options.valueComposer);
          }
        } else if (this.element.find(".nixps-quantum-CodeEditor:visible").length > 0) {
          if (Array.isArray(this.options.valueComposer)) {
            this.options.valueComposer = this.options.valueComposer.concat(newValueComposer);
            this.element.find(".nixps-quantum-CodeEditor").CodeEditor("option", "content", this.options.valueComposer);
          }
        } else {
          if (this.options.mathMode === true) {
            newValueComposer = [{
              "to_type": "number",
              "type": "com.nixps.quantum.type_converter.0",
              "top_level": false,
              "fail_if_not_number": true,
              "value": newValueComposer
            }];
          }
          if (Array.isArray(this.options.valueComposer)) {
            this.options.valueComposer = this.options.valueComposer.concat(newValueComposer);
            this.element.find(".expressionEditor:visible").ExpressionEditor("option", "valueComposer", this.options.valueComposer);
          }
        }
        this._scheduleResultChange();
      }
      this._trigger("addvariable", pEvent, pData);
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.simulation !== "function") {
        throw new Error(this.widgetName + ": input option simulation must be a function");
      }
      if (typeof this.options.enableAddPathButton !== "boolean") {
        throw new Error(this.widgetName + ": input option enableAddPathButton must be a boolean");
      }
      if (typeof this.options.enableCodeEditor !== "boolean") {
        throw new Error(this.widgetName + ": input option enableCodeEditor must be a boolean");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.widgetFullName);
      this.element.removeAttr("tabindex");
      clearTimeout(this.scheduleResultTimer);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"./EntityComposerCollection.js":110,"./ValueComposerTranslator.js":113,"./ValueComposerUtil.js":114,"./WorkflowDataCollection.js":115,"./WorkflowVariableCollection.js":116,"./nixps-quantum-ArrayEditor.js":117,"./nixps-quantum-BooleanEditor.js":118,"./nixps-quantum-CodeEditor.js":119,"./nixps-quantum-EntityComposerAutoBind.js":120,"./nixps-quantum-ExpressionEditor.js":122,"./nixps-quantum-ExpressionHelpPanel.js":123,"./nixps-quantum-ExpressionList.js":124,"./nixps-quantum-ExpressionListItem.js":125,"./nixps-quantum-ExpressionVariablesSearch.js":126,"./nixps-quantum-ModifierList.js":128,"./nixps-quantum-ObjectEditor.js":130,"./nixps-quantum-VariableList.js":131,"./nixps-quantum-VariableTreeView.js":132}],122:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/

(function ($) {
  require("../../../common/Tooltip/js/nixps-common-DialogTooltip.js");
  var BuildingBlock = require("./BuildingBlock.js");
  var ValueComposerUtil = require("./ValueComposerUtil.js");
  var EntityComposer = require("./EntityComposer.js");
  var EntityComposerCollection = require("./EntityComposerCollection.js");
  var ValueComposerTranslator = require("./ValueComposerTranslator.js");
  var BuildingBlockStock = require("./BuildingBlockStock.js");
  var regExpBuildingBlock = new RegExp("<img [^>]+>", "g");
  var lastClipboardAction; // the last type of clipboard action

  /**
   * @description contains all ids and buildingblocks, so with this we can copy, move blocks to other input fields
   * @static
   * @private
   * @type nixps.quantum.BuildingBlockStock
   */
  var buildingBlockDictionary = new BuildingBlockStock();
  var isCompatibleFlag;
  function isCompatibleForDragging() {
    if (typeof isCompatibleFlag === "boolean") {
      return isCompatibleFlag;
    } else {
      // check if IE
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        isCompatibleFlag = false;
        return isCompatibleFlag;
      }
      var trident = ua.indexOf("Trident/");
      if (trident > 0) {
        // IE 11
        isCompatibleFlag = false;
        return isCompatibleFlag;
      }
      // otherwise it is allowed
      isCompatibleFlag = true;
      return isCompatibleFlag;
    }
  }
  $.widget("nixps-quantum.ExpressionEditor", $.Widget, {
    version: "1.2.0",
    widgetEventPrefix: "expressioneditor",
    options: {
      /** 
       * @brief the entity composer definitions
       * @type {EntityComposerDefinition}
       */
      entityComposerDefinitions: null,
      entityComposerDefinitionResults: null,
      /**
       * @description contains the content to show in valuecomposer format.
       * @name nixps-quantum.ExpressionEditor#valueComposer
       * @type {Array}
       * @default []
       */
      valueComposer: [],
      /**
       * @description overrule the coat of casting, we will give to the valuecompser
       * this will be used as default format. this can be overruled. possible values are "number", "string", "boolean"
       * @type {String}
       * @name nixps-quantum.ExpressionEditor#forceFormat
       * @default "no_casting_format"
       * @example "boolean"
       */
      forceFormat: null,
      /**
       * @description the font to be used on drawed components
       * @type {String}
       * @default "normal normal 400 normal 14.56px / 16.016px Helvetica, Arial, Verdana, sans-serif"
       */
      font: "normal normal 400 normal 14.56px / 16.016px Helvetica, Arial, Verdana, sans-serif",
      /**
       * @description The jQuery scope in where the elements live
       * @name nixps-quantum.ExpressionEditor#scope
       * @type {String}
       * @default "worfklow" 
       */
      scope: "workflow",
      /**
       * @description The uuid of the expressionlist
       * @type {Number}
       * @default null
       * @private
       * @name nixps-quantum.ExpressionEditor#expressionListUUID
       */
      expressionListUUID: null,
      contentType: "plain/text",
      /**
       * @description Enable/disable math mode
       * @name nixps-quantum.ExpressionEditor#mathMode
       * @type {Boolean}
       * @default false
       */
      mathMode: false,
      /**
       * @description Save objects and arrays as an "com.nixps.quantum.object.0" expression.
       * @name nixps-quantum.ExpressionEditor#useObjectExpression
       * @type {Boolean}
       * @default false
       */
      useObjectExpression: false,
      /**
       * @description are the fields required?
       * @name nixps-quantum.ExpressionEditor#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.2.0
       */
      required: false
    },
    _create: function _create() {
      this._super();
      this.element.addClass(this.widgetFullName);
      this.element.attr({
        "spellcheck": false,
        "contenteditable": true,
        "dropzone": "move string:text/html",
        "focus": "1",
        "aria-required": this.options.required === true ? "true" : "false"
      });
      this.element.droppable({
        accept: ".nixps-quantum-BuildingBlock, .nixps-quantum-ExpressionListItem" + this.options.expressionListUUID === null ? "" : ".list_uuid_" + this.options.expressionListUUID,
        scope: this.options.scope,
        tolerance: "pointer"
      });
      if (this.options.disabled === true) {
        this.element.attr({
          "contenteditable": false,
          "disabled": true
        });
      }
      if (Array.isArray(this.options.entityComposerDefinitionResults) && this.options.entityComposerDefinitionResults.length > 0 && this.options.entityComposerDefinitions === null) {
        this.options.entityComposerDefinitions = new EntityComposerCollection(this.options.entityComposerDefinitionResults);
      }
      this._on(this.element, {
        "dragover": this._dragOverHandler,
        "drop": this._dropHandler,
        "keyup": this._fieldChangedHandler,
        "keydown": this._keyDownHandler.bind(this),
        "buildingblockchange": this._fieldChangedHandler,
        "dragstart .nixps-quantum-BuildingBlock": this._buildingBlockDragStartHandler,
        "click .nixps-quantum-BuildingBlock": this._clickBuildingBlockHandler,
        "mouseover .nixps-quantum-BuildingBlock": this._hoverBuildingBlockHandler,
        "mousemove .nixps-quantum-BuildingBlock": this._hoverBuildingBlockHandler,
        "mouseout": this._mouseOutBuildingBlockHandler,
        "cut": this._cutHandler,
        "copy": this._copyHandler,
        "paste": this._beforePasteHandler,
        "nixpsdeleteddragged": this._deletedItemAfterDropHandler
      });

      // variables
      this.displayedTooltipRef = undefined;
      this.displayedTooltipRefClick = undefined;
      this.pasteRegEx = undefined;
      this.mEntityTitles = [];
      this.blocks = [];
      this.castingFormat = ValueComposerUtil.types.NO_CASTING_FORMAT;
      this.conditionalMode = false;
      this.conditionalValueComposer = null;

      // Browser shouldn't show resize handles for image resize in contenteditables
      document.execCommand("enableObjectResizing", false, false);
    },
    _renderBuildingBlock: function _renderBuildingBlock(pBuildingBlock, pParent) {
      var that = this;
      return $.Deferred(function (pDefer) {
        var content = pBuildingBlock.getTitle();
        var referenceBlock = $("<div>").addClass("nixps-quantum-BuildingBlock").text(content);
        if (that.element.is(":visible") === true) {
          // this element is visible and not empty
          referenceBlock.appendTo(that.element);
        } else {
          // if parent is not visible, then width will be negative, 
          // so hide element and append to body
          // to get the good width, and remove it afterwards
          // move under current parent, retrieve the font, move back to parent to retrieve other information
          referenceBlock.css({
            "position": "absolute",
            "visibility": "hidden"
          }).appendTo(that.element);
          var newfont = referenceBlock.css("font");
          referenceBlock.appendTo($("body"));
          referenceBlock.css("font", newfont);
        }
        var helpCanvas = $("<canvas>").css("display", "none");
        // Add the canvas temporarily in so that it inherits the css of the current element and draws correctly
        helpCanvas.appendTo(that.element);
        var width = referenceBlock.width();
        // var width = 0;
        var height = referenceBlock.height();
        if (width < 0) {
          width = 0;
        }
        if (height < 0) {
          height = 0;
        }
        helpCanvas.attr("width", width);
        helpCanvas.attr("height", height);
        var ctx = helpCanvas[0].getContext("2d");
        var icon = undefined;
        var transformers = pBuildingBlock.getTransformers();
        for (var i = 0; i < transformers.length; i++) {
          var transformer = transformers[i];
          var parameters = transformer.getParameters();
          if (parameters.to_type) {
            // Last one wins, last conversion is the result type.
            icon = parameters.to_type;
          }
        }
        var icondefer = null;
        if (typeof icon === "string" && icon.length > 0) {
          var iconWidth = that.getIconSize(ctx, icon);
          if (iconWidth) {
            width = width + iconWidth + 4;
            helpCanvas.attr("width", width);
          }
          icondefer = that._renderIcon(ctx, icon, height);
        }
        var font = referenceBlock.css("font");
        if (font.length === 0) {
          ctx.font = referenceBlock.css("font-size") + " " + referenceBlock.css("font-family");
        } else {
          ctx.font = font;
        }
        ctx.fillStyle = "#000";
        ctx.lineWidth = 0.1;
        ctx.fillText(content, iconWidth ? iconWidth + 4 : 0, 8.0 / 10.0 * height);
        ctx.strokeText(content, iconWidth ? iconWidth + 4 : 0, 8.0 / 10.0 * height);
        referenceBlock.remove();
        $.when(icondefer).done(function () {
          var image = helpCanvas[0].toDataURL();

          // Remove the temp canvas 
          helpCanvas.remove();
          pParent.css({
            "background-image": 'url(\'' + image + '\')',
            "width": width + 14,
            "height": height + 7
          });
          pDefer.resolve({
            dataURL: image,
            width: width,
            height: height
          });
        });
      });
    },
    getIconSize: function getIconSize(pCtx, pIcon) {
      switch (pIcon) {
        case "string":
          pCtx.font = "9px 'Montserrat', sans-serif";
          return pCtx.measureText("ABC").width;
        case "number":
          pCtx.font = "9px 'Montserrat', sans-serif";
          return pCtx.measureText("123").width;
        case "boolean":
          return 14;
        default:
          break;
      }
    },
    /**
    * @description Renders the icon for the building block
    * @function
    * @name nixps-quantum.ExpressionEditor#_renderIcon
    * @returns {undefined}
    */
    _renderIcon: function _renderIcon(pCtx, pIcon, pHeight) {
      return $.Deferred(function (pDefer) {
        switch (pIcon) {
          case "string":
            pCtx.font = "9px 'Montserrat', sans-serif";
            pCtx.lineWidth = 0.1;
            pCtx.fillStyle = "#036a07";
            pCtx.fillText("ABC", 0, 8.0 / 10.0 * pHeight);
            pCtx.strokeText("ABC", 0, 8.0 / 10.0 * pHeight);
            pDefer.resolve();
            break;
          case "number":
            pCtx.font = "9px 'Montserrat', sans-serif";
            pCtx.fillStyle = "mediumblue";
            pCtx.lineWidth = 0.1;
            pCtx.fillText("123", 0, 8.0 / 10.0 * pHeight);
            pCtx.strokeText("123", 0, 8.0 / 10.0 * pHeight);
            pDefer.resolve();
            break;
          case "boolean":
            var img = new Image();
            img.onload = function () {
              pCtx.drawImage(img, 0, pHeight / 2 - 4, 14, 7);
              pDefer.resolve();
            };
            img.onerror = pDefer.reject;
            img.src = "/nebula/images/boolean.svg";
            break;
          default:
            break;
        }
      });
    },
    /**
    * @description Creates the building block first in canvas, then creates an byte64 image and uses it in an img tag
    * @function
    * @name nixps-quantum.ExpressionEditor#pBuildingBlock
    * @returns {undefined}
    */
    _createBuildingBlock: function _createBuildingBlock(pBuildingBlock) {
      if (pBuildingBlock instanceof BuildingBlock === false) {
        throw new Error("invalid building block");
      }
      var that = this;
      var buildingBlockUI = $("<img>");
      that._renderBuildingBlock(pBuildingBlock, buildingBlockUI);
      if (isCompatibleForDragging() === true) {
        buildingBlockUI.attr("draggable", "true");
      } else {
        buildingBlockUI.attr("unselectable", "on");
      }
      buildingBlockUI.attr("data-blockid", pBuildingBlock.getID());
      buildingBlockUI.addClass("nixps-quantum-BuildingBlock");
      buildingBlockUI.attr("data-type", pBuildingBlock.getOutputType());
      buildingBlockUI.attr("data-scope", that.options.scope);
      buildingBlockUI.attr("alt", pBuildingBlock.getProvider().getDefinition().getTitle());
      buildingBlockUI.attr("title", pBuildingBlock.getProvider().getDefinition().getTitle());
      buildingBlockUI.attr("src", "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");
      buildingBlockUI.css({
        "display": "inline-block",
        "background-position": "7px 3px",
        "background-repeat": "no-repeat"
      });
      that.blocks.push(pBuildingBlock);
      buildingBlockDictionary.addItem(pBuildingBlock.getID(), pBuildingBlock);
      return buildingBlockUI;
    },
    _mouseOutBuildingBlockHandler: function _mouseOutBuildingBlockHandler(pEvent) {
      if (this.displayedTooltipRef !== undefined) {
        if (this.displayedTooltipRef.hasClass("nixps-Tooltip")) {
          this.displayedTooltipRef.DialogTooltip("destroy");
        }
        this.displayedTooltipRef = undefined;
      }
    },
    _hoverBuildingBlockHandler: function _hoverBuildingBlockHandler(pEvent) {
      if (this.displayedTooltipRef !== undefined && pEvent.altKey !== true) {
        $(pEvent.target).DialogTooltip("destroy");
        return;
      } else if (pEvent.altKey === true && this.displayedTooltipRef === undefined) {
        var that = this;
        var target = $(pEvent.target);
        var id = target.attr("data-blockid");
        var buildingBlock = this.getBuildingBlock(id, false);
        this.displayedTooltipRef = target;
        var buildingBlokUI = $("<div>").ModifierList({
          buildingBlock: buildingBlock,
          transformers: that.options.entityComposerDefinitions.getAllTransformers(),
          close: function close(pEvent) {
            that.element.find(".nixps-DialogTooltip").DialogTooltip("destroy");
          },
          save: function save(pEvent) {
            target.attr("data-type", buildingBlock.getOutputType());
            that._renderBuildingBlock(buildingBlock, target);
            that._fieldChangedHandler(pEvent);
          }
        });
        target.DialogTooltip({
          content: {
            text: function text() {
              return buildingBlokUI;
            },
            title: buildingBlock.getTitle(),
            button: $("<span>").addClass("cf-dialog-close cf-icon cf-icon-x").attr("aria-label", $.i18n._("nixps-cloudflow-dialog.close"))
          },
          style: {
            width: 550
          },
          position: {
            my: "top center",
            at: "bottom center",
            target: target,
            viewport: $("body"),
            adjust: {
              screen: true
            }
          },
          show: {
            ready: true,
            solo: true
          },
          hide: {
            event: "click"
          },
          events: {
            show: function show(pEvent) {
              $(this).addClass("cf-dialog");
            },
            hide: function hide(pEvent) {
              that.displayedTooltipRef = undefined;
            },
            hidden: function hidden() {
              buildingBlokUI.remove();
            },
            destroy: function destroy() {}
          }
        });
      }
    },
    _clickBuildingBlockHandler: function _clickBuildingBlockHandler(pEvent) {
      var that = this;
      var target = $(pEvent.target);
      this.displayedTooltipRefClick = target;
      var id = target.attr("data-blockid");
      var buildingBlock = this.getBuildingBlock(id, false);
      var buildingBlokUI = $("<div>").ModifierList({
        buildingBlock: buildingBlock,
        transformers: that.options.entityComposerDefinitions.getAllTransformers(),
        close: function close(pEvent) {
          that.element.find(".nixps-DialogTooltip").DialogTooltip("destroy");
        },
        save: function save(pEvent) {
          target.attr("data-type", buildingBlock.getOutputType());
          that._renderBuildingBlock(buildingBlock, target);
          that._fieldChangedHandler(pEvent);
        }
      });
      target.DialogTooltip({
        content: {
          text: function text() {
            return buildingBlokUI;
          },
          title: buildingBlock.getTitle(),
          button: $("<span>").addClass("cf-dialog-close cf-icon cf-icon-x")
        },
        style: {
          width: 550
        },
        position: {
          my: "top center",
          at: "bottom center",
          target: target,
          viewport: $("body"),
          adjust: {
            screen: true,
            method: "flipfit"
          }
        },
        show: {
          ready: true,
          solo: true
        },
        hide: {
          event: "click"
        },
        events: {
          show: function show(pEvent) {
            $(this).addClass("cf-dialog");
          },
          hidden: function hidden() {
            buildingBlokUI.remove();
          },
          destroy: function destroy() {}
        }
      });
    },
    _buildingBlockDragStartHandler: function _buildingBlockDragStartHandler(e) {
      $(".dragged").removeClass("dragged");
      if (!e.target.id) {
        e.target.id = new Date().getTime();
      }
      e.originalEvent.dataTransfer.setData("text/html", e.target.outerHTML);
      e.originalEvent.dataTransfer.dropEffect = "move";
      e.originalEvent.dataTransfer.effectAllowed = "move";
      $(e.target).addClass("dragged");
      // var offset = this.element.offset();
      // var mouseX = e.offsetX; 
      // var mouseY = e.offsetY;
      // user agents are not agree to interpret standard
      if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
        this._delay(function () {
          e.originalEvent.dataTransfer.setDragImage(e.target, 0, 0);
        }, 100);
      } else {
        e.originalEvent.dataTransfer.setDragImage(e.target, 0, 0);
      }
    },
    /**
     * @description Check if the keycode is allowed when in math mode
     * @function
     * @name nixps-quantum.ExpressionEditor#_isKeyCodeAllowedInMath
     * @returns {boolean}
     */
    _isKeyCodeAllowedInMath: function _isKeyCodeAllowedInMath(pEvent) {
      if (!isNaN(pEvent.key)) {
        return true;
      }
      switch (pEvent.key) {
        case "Backspace":
        case "Delete":
        case "Del": // IE supprot
        case "ArrowDown":
        case "ArrowUp":
        case "ArrowLeft":
        case "ArrowRight":
        case "Down": // IE & old Firefox support
        case "Up":
        case "Left":
        case "Right":
        case "*":
        case "/":
        case "+":
        case "-":
        case "(":
        case ")":
        case ".":
        case "F12":
          return true;
        case "c":
        case "v":
        case "x":
        case "a":
        case "f":
          if (pEvent.ctrlKey === true || pEvent.metaKey === true) {
            return true;
          } else {
            return false;
          }
        default:
          return false;
      }
    },
    isMathMode: function isMathMode() {
      return !!this.options.mathMode;
    },
    setMathMode: function setMathMode(pValue) {
      if (typeof pValue !== "boolean") {
        return;
      }
      this.options.mathMode = pValue;
      if (pValue === true) {
        if (this.element.closest(".nixps-quantum-ExpressionBuilder").length <= 0) {
          this.element.addClass("nixps-quantum-math");
          this.element.attr("title", $.i18n._("nixps-quantum-expressioneditor.casted_calc"));
        }
      } else {
        if (this.element.closest(".nixps-quantum-ExpressionBuilder").length <= 0) {
          this.element.removeClass("nixps-quantum-math");
          this.element.attr("title", "");
        }
      }
    },
    isConditionalMode: function isConditionalMode() {
      return !!this.conditionalMode;
    },
    setConditionalMode: function setConditionalMode(pValue, pValueComposer) {
      if (typeof pValue !== "boolean") {
        return;
      }
      this.conditionalMode = pValue;
      if (pValue === true) {
        if (this.element.closest(".nixps-quantum-ExpressionBuilder").length <= 0) {
          this.element.addClass("nixps-quantum-conditional");
          this.element.attr("contenteditable", false);
        }
        this.conditionalValueComposer = structuredClone(pValueComposer);
      } else {
        if (this.element.closest(".nixps-quantum-ExpressionBuilder").length <= 0) {
          this.element.removeClass("nixps-quantum-conditional");
          if (this.options.disabled === false) {
            this.element.attr("contenteditable", true);
          }
        }
        this.conditionalValueComposer = null;
      }
    },
    _keyDownHandler: function _keyDownHandler(pEvent) {
      if (this.options.mathMode === true && !this._isKeyCodeAllowedInMath(pEvent)) {
        pEvent.preventDefault();
        // return false;
      } else if ($.isEmptyObject(pEvent) === false && this.isBlocked && !this._isKeyCodeAllowed(pEvent)) {
        pEvent.preventDefault();
        return false;
      } else if ($.isPlainObject(pEvent) === true && pEvent.keyCode === 13) {
        // press enter key 
        return false;
      }
    },
    // https://stackoverflow.com/questions/17678843/cant-restore-selection-after-html-modify-even-if-its-the-same-html
    _saveSelection: function _saveSelection(pContainer) {
      var range = window.getSelection().getRangeAt(0);
      var preSelectionRange = range.cloneRange();
      preSelectionRange.selectNodeContents(pContainer);
      preSelectionRange.setEnd(range.startContainer, range.startOffset);
      var start = preSelectionRange.toString().length;
      return {
        start: start,
        end: start + range.toString().length
      };
    },
    _restoreSelection: function _restoreSelection(pContainer, pSelection) {
      var charIndex = 0;
      var range = document.createRange();
      range.setStart(pContainer, 0);
      range.collapse(true);
      var nodeStack = [pContainer];
      var node;
      var foundStart = false;
      var stop = false;
      while (!stop && (node = nodeStack.pop())) {
        if (node.nodeType === 3) {
          var nextCharIndex = charIndex + node.length;
          if (!foundStart && pSelection.start >= charIndex && pSelection.start <= nextCharIndex) {
            range.setStart(node, pSelection.start - charIndex);
            foundStart = true;
          }
          if (foundStart && pSelection.end >= charIndex && pSelection.end <= nextCharIndex) {
            range.setEnd(node, pSelection.end - charIndex);
            stop = true;
          }
          charIndex = nextCharIndex;
        } else {
          var i = node.childNodes.length;
          while (i--) {
            nodeStack.push(node.childNodes[i]);
          }
        }
      }
      var sel = document.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    },
    _fieldChangedHandler: function _fieldChangedHandler(pEvent) {
      var that = this;

      // Hide the dialog on change

      if (this.displayedTooltipRef !== undefined) {
        if (this.displayedTooltipRef.data("DialogTooltip")) {
          this.displayedTooltipRef.DialogTooltip("destroy");
        }
        this.displayedTooltipRef = undefined;
      }
      if (this.displayedTooltipRefClick !== undefined) {
        if (this.displayedTooltipRefClick.data("DialogTooltip")) {
          this.displayedTooltipRefClick.DialogTooltip("destroy");
        }
        this.displayedTooltipRefClick = undefined;
      }
      if ($.isEmptyObject(pEvent) === false && pEvent.type !== "modifierlistsave" && this.isBlocked && !this._isKeyCodeAllowed(pEvent)) {
        pEvent.preventDefault();
        return false;
      } else {
        if ($.isPlainObject(pEvent) === true && pEvent.keyCode === 13) {
          // press enter key 
          return false;
        }
        // if copy/paste there can be buildingblocks with the same id
        // changes those in new genereated id
        var buildingBlocks = this.element.find(".nixps-quantum-BuildingBlock");
        for (var i = 0; i < buildingBlocks.length; i++) {
          var block = $(buildingBlocks[i]);
          var blockid = block.attr("data-blockid");
          var blockData = this.getBuildingBlock(blockid, true, block);
          if (blockData === undefined) {
            // the user paste some invalid buildingblocks
            this.element.children().remove();
            $("body.nixps-Dialog").Dialog("show_ok", "Error", "The elements you want to copy are invalid.");
            break;
          }
          var blockScope = block.attr("data-scope");
          if (typeof blockScope === "string" && blockScope.length > 0 && blockScope !== this.options.scope) {
            block.remove();
            console.warn("element paste outside the scope");
            continue;
          }
          var others = this.element.find('[data-blockid=' + blockid + ']').filter(function () {
            return block[0] !== this;
          });
          for (var j = 0; j < others.length; j++) {
            //create every time a new one, we want all diverent uuids
            var buildingblock = blockData.clone(lastClipboardAction === "copy-paste");
            $(others[j]).attr("data-blockid", buildingblock.getID());
            this.blocks.push(buildingblock);
            buildingBlockDictionary.addItem(buildingblock.getID(), buildingblock);
            this._informCopy(blockData, buildingblock);
          }
        }
        var buildingblockIDs = this.element.find(".nixps-quantum-BuildingBlock").map(function () {
          return $(this).attr("data-blockid");
        }).get();
        var missingBuildingBlocks = [];
        this.blocks = $.map(this.blocks, function (blockData, index) {
          if ($.inArray(blockData.getID(), buildingblockIDs) === -1) {
            missingBuildingBlocks.push(blockData);
            return undefined; // remove element
          }

          return blockData;
        });
        if (missingBuildingBlocks.length > 0) {
          this._informRemove(missingBuildingBlocks);
        }
        if (pEvent !== undefined && pEvent.type === "paste" && this.options.contentType === "plain/text") {
          // remove all unwanted elements
          // the user can past html types, translate them to plain text
          this.element.children().each(function () {
            if ($(this).is("style,script")) {
              $(this).replaceWith("");
            } else if ($(this).hasClass("nixps-quantum-BuildingBlock") === false) {
              // doing replaceWith will cause new HTML to be drawn -> loss of selection
              var savedSel = that._saveSelection(that.element[0]);
              $(this).replaceWith(_.escape($(this).text()));
              that._restoreSelection(that.element[0], savedSel);
            }
          });
          if (this.options.mathMode === true) {
            if (!this.pasteRegEx || !Array.isArray(this.mEntityTitles) || Array.isArray(this.mEntityTitles) && this.mEntityTitles.length <= 0) {
              this.mEntityTitles = [];
              for (var i = 0; i < this.options.entityComposerDefinitions.entityComposers.length; i++) {
                var title = this.options.entityComposerDefinitions.entityComposers[i].getTitle();
                if (typeof title === "string" && title.length > 0) {
                  this.mEntityTitles.push(title);
                  var pasteRegExString = "[0-9\\/\\*\\+\\-\\(\\)]|(" + this.mEntityTitles.join(")|(") + ")";
                  this.pasteRegEx = new RegExp(pasteRegExString, "g");
                }
              }
            }
            this.element.contents().each(function () {
              if ($(this).text() !== "") {
                var newText = $(this).text().match(that.pasteRegEx);
                if (Array.isArray(newText)) {
                  newText = newText.join("");
                }
                this.textContent = newText;
              }
            });
          }
        }
        this._trigger("change", null, {
          variables: this.getVariableNames(),
          inner_valuecomposer: pEvent !== undefined && pEvent.type === "modifierlistsave",
          is_empty: this.element.text() === "" && this.element.find(".nixps-quantum-BuildingBlock").length === 0
        });
        this.isBlocking();
      }
    },
    _dragOverHandler: function _dragOverHandler(pEvent) {
      // this.element.find("img").css({
      //     "margin-left": 12,
      //     "margin-right": 12
      // });

      pEvent.preventDefault();
    },
    _dropHandler: function _dropHandler(pEvent, pUI) {
      if (this.isBlocked) {
        pEvent.preventDefault();
        return;
      }
      if ($.isPlainObject(pUI) === true) {
        var draggable = pUI.draggable;
        if (draggable.is(".nixps-quantum-ExpressionListItem")) {
          if (pUI.helper && pUI.helper.hasClass("array") && Array.isArray(this.options.valueComposer) && ValueComposerTranslator.valuecomposerToTemplate(this._getValueComposer()) !== "") {
            pEvent.preventDefault();
            $(".nixps-NotifyArea").NotifyArea("createMessage", "closeable-error", $.i18n._("nixps-quantum-expressioneditor.error_drop_title"), $.i18n._("nixps-quantum-expressioneditor.error_drop"), 7000);
            return;
          }
          var range = null;
          if (document.caretRangeFromPoint) {
            // Chrome
            range = document.caretRangeFromPoint(pEvent.clientX, pEvent.clientY);
          } else if (document.caretPositionFromPoint) {
            // Firefox
            var caretPosition = document.caretPositionFromPoint(pEvent.clientX, pEvent.clientY);
            range = new Range();
            range.setStart(caretPosition.offsetNode, caretPosition.offset);
            range.setEnd(caretPosition.offsetNode, caretPosition.offset);
          }
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          this.element.get(0).focus(); // essential

          var definition = draggable.ExpressionListItem("option", "definition");
          draggable.addClass(definition.output_type);
          var buildingBlock;
          var definitions = this.options.entityComposerDefinitions;
          var providerAndTransfomers = ValueComposerUtil.getProviderAndTransformers(definition.composer, definitions);
          var provider = new EntityComposer(providerAndTransfomers.provider, definitions.getEntityComposer(providerAndTransfomers.provider.type));
          provider.adaptAfterDrop(this.blocks);
          var transformers = [];
          if (Array.isArray(providerAndTransfomers.transformers)) {
            transformers = providerAndTransfomers.transformers.map(function (t) {
              return new EntityComposer(t, definitions.getEntityComposer(t.type));
            });
          }
          if (this.options.mathMode === true) {
            transformers.push(new EntityComposer({
              "to_type": "number",
              "type": "com.nixps.quantum.type_converter.0",
              "top_level": false,
              "fail_if_not_number": true,
              "value": provider
            }, definitions.getEntityComposer("com.nixps.quantum.type_converter.0")));
          }
          buildingBlock = new BuildingBlock(provider, transformers);
          var buildingBockNode = this._createBuildingBlock(buildingBlock);
          range.insertNode(buildingBockNode[0]);
          sel = window.getSelection();
          sel.removeAllRanges();
          range.collapse(false);
          sel.addRange(range);
        }
      } else {
        pEvent.preventDefault();
        pEvent = pEvent.originalEvent;
        var content = pEvent.dataTransfer.getData("text/html");
        if ($(content).length > 0 && $(content).attr("data-type") === "array" && Array.isArray(this.options.valueComposer) && ValueComposerTranslator.valuecomposerToTemplate(this.options.valueComposer) !== "") {
          return;
        }
        var sel = window.getSelection();
        var range = null;
        if (document.caretRangeFromPoint) {
          // Chrome
          range = document.caretRangeFromPoint(pEvent.clientX, pEvent.clientY);
        } else if (pEvent.rangeParent) {
          // Firefox
          range = document.createRange();
          range.setStart(pEvent.rangeParent, pEvent.rangeOffset);
        } else if (document.caretPositionFromPoint) {
          range = document.caretPositionFromPoint(pEvent.clientX, pEvent.clientY);
        }
        if ($(range.startContainer).closest(".nixps-quantum-ExpressionEditor", this.element).length === 0) {
          sel.removeAllRanges();
          return;
        }

        // Insert the new block

        if ($(content).filter("img").length > 0) {
          sel.removeAllRanges();
          sel.addRange(range);
          this.element.get(0).focus();
          range.insertNode($(content).filter("img")[0]);
        } else {
          sel.deleteFromDocument();
          this.element.get(0).focus();
          range.insertNode(document.createTextNode($(content).text()));
        }

        // Remove the old one
        var dragged = this.document.find(".nixps-quantum-BuildingBlock.dragged"); //can be dragged over to different editors
        if (dragged.length > 0) {
          var deleteRange = document.createRange();
          deleteRange.selectNode(dragged[0]);
          sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(deleteRange);
          var parent = dragged.closest(".nixps-quantum-ExpressionEditor");
          dragged.parents(".ui-droppable").get(0).focus(); // focus the old element where the node was original
          document.execCommand("delete");
          parent.trigger("nixpsdeleteddragged");
        }
        sel = window.getSelection();
        sel.removeAllRanges();
        range.collapse(false);
        sel.addRange(range);
      }
      if (this.hasResult()) {
        this._trigger("change", null, {
          variables: this.getVariableNames(),
          is_empty: this.element.text() === "" && this.element.find(".nixps-quantum-BuildingBlock").length === 0
        });
      } else {
        this._trigger("change", null, {
          variables: this.getVariableNames(),
          is_empty: this.element.text() === "" && this.element.find(".nixps-quantum-BuildingBlock").length === 0
        });
      }

      // this.element.find("img").css({
      //     "margin-left": 5,
      //     "margin-right": 5
      // });
      this.isBlocking();
    },
    /**
     * @description function runs when user want to cut
     * @function
     * @private
     * @name nixps-quantum.ExpressionEditor#_cutHandler
     * @param {*} pEvent 
     */
    _cutHandler: function _cutHandler(pEvent) {
      lastClipboardAction = "cut";
    },
    /**
     * @description function runs when user want to copy
     * @function
     * @private
     * @name nixps-quantum.ExpressionEditor#_copyHandler
     * @param {*} pEvent 
     */
    _copyHandler: function _copyHandler(pEvent) {
      lastClipboardAction = "copy";
    },
    /**
     * @description function runs when user want to paste something, this runs before the past action actualy happen
     * this should run before "paste browser event" add content to inputfield
     * @function
     * @private
     * @name nixps-quantum.ExpressionEditor#_beforePasteHandler
     * @param {event} pEvent the paste event
     * @param {object} pData data from the paste event
     */
    _beforePasteHandler: function _beforePasteHandler(pEvent, pData) {
      // prevent pasting if user may not edit (array value composers)
      if (this.isBlocking() === true) {
        pEvent.preventDefault();
        return false;
      }
      if (lastClipboardAction === "cut" || lastClipboardAction === "copy") {
        lastClipboardAction = lastClipboardAction + "-paste";
      }
      var that = this;
      // because this event is fired before paste, we put a async call.
      // if run directly, we do not have the past data. 
      // The data is added after this function call
      // so, this should run after the text is added, and we can handle the new paste buildingblocks
      this._delay(function () {
        this._fieldChangedHandler(pEvent);
      });
      return true;
    },
    /**
     * @description function runs when a building block has been removed
     * @function
     * @name nixps-quantum-ExpressionBuilder#_deletedItemAfterDropHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _deletedItemAfterDropHandler: function _deletedItemAfterDropHandler(pEvent, pData) {
      this._trigger("change", null, {
        variables: this.getVariableNames(),
        is_empty: this.element.text() === "" && this.element.find(".nixps-quantum-BuildingBlock").length === 0
      });
    },
    /**
     * @description Replace all special not visible characters to visible replacers, To maintain the visible text.
     * @function
     * @private
     * @name nixps-quantum.ExpressionEditor#_makeReadableText
     * @param {String} pText text to be replaced
     * @returns {unresolved}
     */
    _makeReadableText: function _makeReadableText(pNode) {
      var text;
      if (this.options.contentType === "plain/text") {
        text = pNode.text();
      } else if (this.options.contentType === "html/text" && typeof pNode !== "string") {
        console.log(pNode);
        text = $(pNode)[0].outerHTML || $(pNode)[0].textContent;
        console.log(text);
      }
      if (typeof text === "string") {
        // replace all &nbsp to spaces
        return text.replace(/\u00A0/g, " ");
      }
      // if not a string, just return itself
      return text;
    },
    _makeTextualNode: function _makeTextualNode(pText) {
      if (this.options.contentType === "plain/text") {
        if (Array.isArray(pText) || $.isPlainObject(pText)) {
          return document.createTextNode(JSON.stringify(pText));
        }
        return document.createTextNode(pText);
      } else if (this.options.contentType === "html/text") {
        var domelement;
        try {
          var domelement = $(pText);
          if (domelement === undefined || domelement.length === 0) {
            domelement = document.createTextNode("" + pText);
          }
        } catch (e) {
          domelement = document.createTextNode("" + pText);
        }
        return domelement;
      }
      // unknown type
      return document.createTextNode(pText);
    },
    /**
     * @description add string at the end of the expressionEditor
     * @todo try to add text at after place of cursor
     * @function
     * @param {string} pContent
     * @returns {undefined}
     */
    addContent: function addContent(pContent) {
      var range = null;
      this.element.get(0).focus();
      document.execCommand("insertHTML", false, pContent);
      this._fieldChangedHandler();
    },
    /**
     * @description Deside if the user is allowed to do this kind of handling/event. This function checked if the event is allowed.
     * deleting/removing, changing cursor or cut copy are allowed
     * @function
     * @param {event} pEvent - the juqery event
     * @returns {Boolean} is the event caused by the user allowed
     */
    _isKeyCodeAllowed: function _isKeyCodeAllowed(pEvent) {
      switch (pEvent.keyCode) {
        case 8: // <-- key
        case 46: // delete key
        case 37: // arrow keys
        case 38:
        case 39:
        case 40:
          return true;
        case 65: // 'a'-key (for ctrl-a)
        case 67: // 'c'-key
        case 88:
          // 'x'-key
          if (pEvent.ctrlKey === true || pEvent.metaKey === true) {
            return true;
          } else {
            return false;
          }
        default:
          return false;
      }
    },
    /**
     * @brief get the correct buildingBlock
     * @param {string | id} pID
     * @returns {buildingBlock} corresponding to inputID
     */
    getBuildingBlock: function getBuildingBlock(pID, pAddingIfMissing, pDOM) {
      var block = this.blocks.find(function (blockData) {
        return blockData.getID() === pID;
      });
      if (pAddingIfMissing === undefined) {
        pAddingIfMissing = true; // for the moment default true
      }
      // if nothing found, look up in dictionary
      if (block === undefined) {
        var blockData = buildingBlockDictionary.getItem(pID);
        if (blockData !== undefined && pAddingIfMissing === true && pDOM !== undefined) {
          // we suppose only cut,copy, paste needs to add items to this.block
          var buildingblock = blockData.clone(lastClipboardAction === "copy-paste");
          $(pDOM).attr("data-blockid", buildingblock.getID());
          this.blocks.push(buildingblock);
          buildingBlockDictionary.addItem(buildingblock.getID(), buildingblock);
          this._informCopy(blockData, buildingblock);
          return buildingblock;
        }
      }
      return block;
    },
    /**
     * @description function to inform parents of that there was a copy action
     * @function
     * @private
     * @name nixps-quantum.ExpressionEditor#_informCopy
     * @param {Object} pOrigBluildingBlock 
     * @param {Object} pNewBuildingBlock 
     */
    _informCopy: function _informCopy(pOrigBluildingBlock, pNewBuildingBlock) {
      var valueComposerType = pOrigBluildingBlock.getProvider().getID();
      if (valueComposerType === "com.nixps.localization.look_up.0") {
        var origTranslationKey = pOrigBluildingBlock.getProvider().getParameter("translation_key");
        var newTranslationKey = pNewBuildingBlock.getProvider().getParameter("translation_key");
        // check if different, otherwise it is not needed to inform changes
        if (origTranslationKey !== newTranslationKey) {
          this.element.trigger("translationinputcopy", {
            origTranslationKey: origTranslationKey,
            newTranslationKey: newTranslationKey
          });
        }
      }
    },
    /**
     * @description function to inform parents of that there was a remove action
     * @function
     * @private
     * @name nixps-quantum.ExpressionEditor#_informRemove
     * @param {Array<Object>} pBuildingBlocks 
     */
    _informRemove: function _informRemove(pBuildingBlocks) {
      if (Array.isArray(pBuildingBlocks) && pBuildingBlocks.length > 0) {
        var translationKeys = [];
        for (var i = 0; i < pBuildingBlocks.length; i++) {
          var valueComposerType = pBuildingBlocks[i].getProvider().getID();
          if (valueComposerType === "com.nixps.localization.look_up.0") {
            var translationKey = pBuildingBlocks[i].getProvider().getParameter("translation_key");
            // do not remove custom keys
            if (typeof translationKey === "string" && translationKey.indexOf("custom-") !== 0) {
              translationKeys.push(translationKey);
            }
          }
        }
        if (translationKeys.length > 0) {
          this.element.trigger("translationinputremove", {
            translationKeys: translationKeys
          });
        }
      }
    },
    /**
     * @brief do we have a building with this ID?
     * @param {string|ID} pID
     * @returns {Boolean} is the buildingBlock in the BuildingBlock list or not
     */
    hasBuildingBlock: function hasBuildingBlock(pID) {
      return this.blocks.find(function (blockData) {
        return blockData.getID() === pID;
      }) !== undefined;
    },
    /**
     * @brief if there are array elements, we must prevent user to compare strings and arrays.
     * this function returns if all elements gives arrays back.
     * @returns {Boolean} true if there is a blocking element, false if there are no blocking element
     */
    isBlocking: function isBlocking() {
      var that = this;
      var arrayElements = this.element.children(".nixps-quantum-BuildingBlock").map(function () {
        var blockId = $(this).attr("data-blockid"),
          composer = that.getBuildingBlock(blockId, false);
        if (composer !== undefined && composer.getOutputType() === "array") {
          return composer;
        } else {
          return undefined;
        }
      });
      this.isBlocked = arrayElements.length > 0;
      return this.isBlocked;
    },
    /**
     * @desc Does the expression contains an array?
     * @function
     * @name nixps-quantum.ExpressionEditor#isArray
     * @returns {Boolean} true if there is at least one array elements
     */
    isArray: function isArray() {
      var that = this;
      var arrayElements = this.element.children(".nixps-quantum-BuildingBlock").map(function () {
        var blockId = $(this).attr("data-blockid"),
          composer = that.getBuildingBlock(blockId, false);
        if (composer !== undefined && composer.getOutputType() === "array") {
          return composer;
        } else {
          return undefined;
        }
      });
      return arrayElements.length > 0;
    },
    /**
     * @description Contains the expression a string object
     * @function
     * @name nixps-quantum.ExpressionEditor#isString
     * @return {Boolean} true if there is at least one string element, false otherwise
     */
    isString: function isString() {
      var that = this;
      var arrayElements = this.element.children(".nixps-quantum-BuildingBlock").map(function () {
        var blockId = $(this).attr("data-blockid"),
          composer = that.getBuildingBlock(blockId, false);
        if (composer !== undefined && composer.getOutputType() === "string") {
          return composer;
        } else {
          return undefined;
        }
      });
      return arrayElements.length > 0;
    },
    getVariableNames: function getVariableNames() {
      var that = this,
        names = this.element.children(".nixps-quantum-BuildingBlock").map(function () {
          var blockId = $(this).attr("data-blockid"),
            composer = that.getBuildingBlock(blockId, false);
          if (composer === undefined) {
            return undefined;
          }
          if (composer.getOutputType() !== "array" && composer.getProvider().getDefinition().getOutputType() !== "array") {
            if (composer.getProvider().getDefinition().getID() === "com.nixps.quantum.variable.0") {
              if (composer.getProvider().hasParameter("source") === false) {
                return composer.getProvider().getParameter("variable");
              } else {
                return composer.getProvider().getDefinition().calculateTitle([], composer.getProvider().getParameters());
              }
            } else {
              /*if () {
                  // the source is an array, but result is not an array / FIXME later
                  // for now only length is possible
                  return "All files from prev. node";
              }*/
              return composer.getProvider().getDefinition().calculateTitle([], composer.getProvider().getParameters());
            }
          }
          return undefined;
        });
      return _.uniq(names);
    },
    hasResult: function hasResult() {
      return this.isArray() === false;
    },
    getResult: function getResult(pVariables) {
      if (this.hasResult() === false) {
        return "";
      }
      var variableSampleDict = {};
      for (var index in pVariables) {
        variableSampleDict[pVariables[index].name] = pVariables[index].value;
      }
      function getSample(pName) {
        if (variableSampleDict[pName] !== undefined) {
          if (typeof variableSampleDict[pName] === "function") {
            return variableSampleDict[pName](pName);
          }
          return variableSampleDict[pName];
        }
        return "";
      }
      var that = this,
        contents = this.element.contents();
      var transformedComposer = Array.from(contents).reduce(function (pPrev, pNext) {
        var next = $(pNext);
        if (next.is(".nixps-quantum-BuildingBlock") === true) {
          var blockId = next.attr("data-blockid"),
            blockData = that.getBuildingBlock(blockId, true, next);
          var input = "";
          input = getSample(blockData.getProvider().getDefinition().calculateTitle([], blockData.getProvider().getParameters()));
          var outputJSON = blockData.getJSON();
          ValueComposerUtil.replaceVariables(outputJSON, input);
          pPrev.push(outputJSON);
        } else if (next[0].nodeName === "#text" && next.text() === "") {
          // ignore;
          return pPrev;
        } else {
          pPrev.push([{
            type: "com.nixps.quantum.value.0",
            value: that._makeReadableText(next)
          }]);
        }
        return pPrev;
      }, []);
      if (this.options.mathMode === true) {
        var merged = [].concat.apply([], transformedComposer);
        transformedComposer = [ValueComposerTranslator.valueComposerToCalculation(merged)];
      }
      return transformedComposer;
    },
    /**
     * @description get the value (value composer) as a string format, in textual representation
     * @function    
     * @returns {String} the value in string format
     */
    getTextualRepresentation: function getTextualRepresentation() {
      var that = this;
      // loop over all items
      var blockItemTitles = _.reduce(this.element.contents(), function (pPrev, pNext) {
        var next = $(pNext);
        // if building block, add title
        if (next.is(".nixps-quantum-BuildingBlock") === true) {
          var blockId = next.attr("data-blockid"),
            composer = that.getBuildingBlock(blockId, false);
          if (composer !== undefined) {
            pPrev.push(composer.getTitle());
          }
          return pPrev;
        }

        // if text, add simply this text
        if (next.text().length > 0) {
          pPrev.push(that._makeReadableText(next));
        }
        return pPrev;
      }, []);

      // transform the array to a string
      var outputString = ""; // default value is a empty string
      for (var i = 0; i < blockItemTitles.length; i++) {
        outputString += blockItemTitles[i];
      }
      return outputString;
    },
    _getValueComposer: function _getValueComposer() {
      var that = this;
      if (this.isConditionalMode()) {
        return structuredClone(this.conditionalValueComposer);
      }
      var result = _.reduce(this.element.contents(), function (pPrev, pNext) {
        var next = $(pNext);
        if (next.is(".nixps-quantum-BuildingBlock") === true) {
          var blockId = next.attr("data-blockid"),
            composer = that.getBuildingBlock(blockId, true, next);
          if (composer !== undefined) {
            pPrev.push(composer.getJSON());
          }
          return pPrev;
        }
        if (that.options.contentType === "html/text") {
          var htmlString = pNext.outerHTML || pNext.textContent;
          if (typeof htmlString !== "string" || htmlString.length <= 0) {
            return pPrev;
          }
          var buildingblockParts = htmlString.match(regExpBuildingBlock);
          if (Array.isArray(buildingblockParts) && buildingblockParts.length > 0) {
            var textParts = htmlString.split(regExpBuildingBlock);
            pPrev.push([{
              "type": "com.nixps.quantum.value.0",
              "value": textParts[0]
            }]);
            for (var i = 0; i < buildingblockParts.length; i++) {
              var blockId = $(buildingblockParts[i]).attr("data-blockid"),
                composer = that.getBuildingBlock(blockId, true, $(buildingblockParts[i]));
              if (composer !== undefined) {
                pPrev.push(composer.getJSON());
              }
            }
            return pPrev;
          } else {
            pPrev.push([{
              "type": "com.nixps.quantum.value.0",
              "value": that._makeReadableText(next)
            }]);
            return pPrev;
          }
        }
        if (next.text().length > 0) {
          pPrev.push([{
            "type": "com.nixps.quantum.value.0",
            "value": that._makeReadableText(next)
          }]);
        }
        return pPrev;
      }, []);
      if (result.length === 0) {
        result = ValueComposerUtil.getEmptyValueComposer();
      } else {
        // translate
        for (var i = 0; i < result.length; i++) {
          result[i] = ValueComposerTranslator.toBackEnd(result[i])[0];
        }
      }
      if (this.options.mathMode === true) {
        return ValueComposerTranslator.valueComposerToCalculation(result);
      }

      // add casting coat
      // give priority to forceFormat 
      // second in line is the current old casting coat
      if (this.options.forceFormat !== null && this.options.forceFormat !== ValueComposerUtil.types.NO_CASTING_FORMAT) {
        result = ValueComposerUtil.addCasting(result, this.options.forceFormat, this.options.entityComposerDefinitions);
      } else if (this.castingFormat !== ValueComposerUtil.types.NO_CASTING_FORMAT) {
        result = ValueComposerUtil.addCasting(result, this.castingFormat, this.options.entityComposerDefinitions);
      }
      if ((this.castingFormat === ValueComposerUtil.types.ARRAY || this.castingFormat === ValueComposerUtil.types.OBJECT) && this.options.useObjectExpression === true) {
        return [{
          type: "com.nixps.quantum.object.0",
          "object": result
        }];
      }
      return result;
    },
    setValueComposer: function setValueComposer(pValueComposer, pFireEvent) {
      var that = this;
      if (ValueComposerUtil.isValueComposerConditional(pValueComposer)) {
        this.setMathMode(false);
        this.setConditionalMode(true, pValueComposer);
        // pValueComposer = JSON.stringify(pValueComposer[0].condition);
        // this.element.empty().append(this._makeTextualNode(pValueComposer[0].condition));
        pValueComposer = pValueComposer[0].condition;
      } else if (ValueComposerUtil.isValueComposerACalculation(pValueComposer)) {
        this.setMathMode(true);
        pValueComposer = ValueComposerTranslator.operationsToValueComposer(pValueComposer[0].operations);
        this.setConditionalMode(false);
      } else {
        this.setMathMode(false);
        this.setConditionalMode(false);
      }
      if (pFireEvent === true) {
        this._trigger("togglemath", null, {
          enabled: this.options.mathMode === true
        });
      }
      if (Array.isArray(pValueComposer) === false && _typeof(pValueComposer) !== "object") {
        throw new Error("invalid value composer");
      }
      this.element.removeClass("nixps-quantum-number nixps-quantum-array nixps-quantum-object nixps-quantum-string nixps-quantum-boolean nixps-quantum-math");
      this.element.attr("title", "");

      // remove casting coat 
      try {
        this.castingFormat = ValueComposerUtil.getCastingFormat(pValueComposer);
        if (this.castingFormat === null) {
          throw new Error("no value composer");
        }
      } catch (error) {
        $(".nixps-NotifyArea").NotifyArea("createMessage", "closeable-error", $.i18n._("nixps-quantum-expressioneditor.error_invalid_title"), $.i18n._("nixps-quantum-expressioneditor.error_invalid"), 7000);
        this.castingFormat = ValueComposerUtil.types.NO_CASTING_FORMAT;
        pValueComposer = ValueComposerUtil.getEmptyValueComposer();
      }
      if (this.options.forceFormat !== null && this.options.forceFormat !== ValueComposerUtil.types.NO_CASTING_FORMAT) {
        this.castingFormat = this.options.forceFormat;
      }
      if (this.castingFormat !== ValueComposerUtil.types.NO_CASTING_FORMAT) {
        pValueComposer = ValueComposerUtil.removeCastingFormat(pValueComposer, this.options.entityComposerDefinitions);
      }

      // Only if not in expression builder
      if (this.element.closest(".nixps-quantum-ExpressionBuilder").length <= 0) {
        if (this.castingFormat !== ValueComposerUtil.types.NO_CASTING_FORMAT) {
          this.element.addClass("nixps-quantum-" + this.castingFormat);
          if (this.castingFormat === "boolean") {
            this.element.attr("title", $.i18n._("nixps-quantum-expressioneditor.casted_bool"));
          } else {
            this.element.attr("title", $.i18n._("nixps-quantum-expressioneditor.casted_" + this.castingFormat));
          }
        }
      }
      if (this.options.mathMode === true) {
        this.element.addClass("nixps-quantum-math");
      }

      // translate
      var valueComposer = [];
      for (var i = 0; i < pValueComposer.length; i++) {
        valueComposer.push(ValueComposerTranslator.fromBackEnd([pValueComposer[i]])[0]);
      }

      // Translate to type
      if (Array.isArray(valueComposer[0])) {
        valueComposer = ValueComposerTranslator.arrayToValueComposer(valueComposer, this.options.entityComposerDefinitions);
      } else if ($.isPlainObject(valueComposer)) {
        valueComposer = ValueComposerTranslator.objectToValueComposer(valueComposer);
      } else if (valueComposer.length === 1 && valueComposer[0].type === "com.nixps.quantum.object.0") {
        if (Array.isArray(valueComposer[0].object)) {
          valueComposer = ValueComposerTranslator.arrayToValueComposer(valueComposer[0].object);
        } else if ($.isPlainObject(valueComposer[0].object)) {
          valueComposer = ValueComposerTranslator.objectToValueComposer(valueComposer[0].object);
        }
      }
      var elements = [];
      var collection = this.options.entityComposerDefinitions;
      for (var i = 0; i < valueComposer.length; i++) {
        var entity = structuredClone(valueComposer)[i];
        if (entity === undefined) {
          continue;
        }
        var definition = collection.getEntityComposer(entity.type);
        if (entity.type === "com.nixps.quantum.value.0") {
          elements.push(this._makeTextualNode(entity.value));
        } else if (definition.getType() === "provider") {
          var provider = new EntityComposer(entity, definition);
          var buildingBlock = new BuildingBlock(provider, []);
          elements.push(that._createBuildingBlock(buildingBlock));
        } else {
          var providerAndTransformers = ValueComposerUtil.getProviderAndTransformers([entity], collection);
          var provider = new EntityComposer(providerAndTransformers.provider, collection.getEntityComposer(providerAndTransformers.provider.type));
          var transformers = [];
          if (Array.isArray(providerAndTransformers.transformers)) {
            transformers = providerAndTransformers.transformers.map(function (t) {
              return new EntityComposer(t, collection.getEntityComposer(t.type));
            });
          }
          var buildingBlock = new BuildingBlock(provider, transformers);
          elements.push(that._createBuildingBlock(buildingBlock));
        }
        ;
      }
      that.element.empty();
      that.element.append(elements);
      // to update the parameter
      that.isBlocking();
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "valueComposer") {
        this.setValueComposer(pValue, true);
        return;
      }
      if (pKey === "disabled") {
        if (pValue !== this.options.disabled) {
          this._superApply(arguments);
          this.element.attr("contenteditable", !pValue);
          this.element.attr("disabled", pValue);
        }
      }
      if (pKey === "required") {
        if (pValue !== this.options.required) {
          this._superApply(arguments);
          this.element.attr("aria-required", pValue === true ? "true" : "false");
        }
      }
      this._superApply(arguments);
    },
    /**
     * @returns one option
     */
    option: function option(optionName) {
      // If we ask for the value composer, update it first
      if (optionName === "valueComposer") {
        this.options.valueComposer = this._getValueComposer();
      }
      return this._superApply(arguments);
    },
    /**
     * @brief destructor
     * @function
     * @private
     * @namespace nixps-quantum.ExpressionEditor#_destroy
     */
    _destroy: function _destroy() {
      this.element.find(".nixps-DialogTooltip").DialogTooltip("destroy");
      this.element.removeClass(this.widgetFullName).removeAttr("contenteditable").removeAttr("dropzone").removeAttr("focus");
      this.element.filter(".ui-droppable").droppable("destroy");
      this.element.removeClass("nixps-quantum-number nixps-quantum-array nixps-quantum-object nixps-quantum-string nixps-quantum-boolean nixps-quantum-math");
      return this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../common/Tooltip/js/nixps-common-DialogTooltip.js":379,"./BuildingBlock.js":107,"./BuildingBlockStock.js":108,"./EntityComposer.js":109,"./EntityComposerCollection.js":110,"./ValueComposerTranslator.js":113,"./ValueComposerUtil.js":114}],123:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/
/*globals $, _, jsPlumb, console, api_sync, QuantumBlueCollar, namespace, nixps */

(function ($) {
  $.widget("nixps-quantum.ExpressionHelpPanel", $.Widget, {
    widgetEventPrefix: "expressionhelppanel",
    options: {
      /**
       * @brief The title to show in the help panel
      * @type {String}
      * @default ""
       */
      title: "",
      /**
       * @brief The content string to show in the help panle
      * @type {String}
      * @default ""
       */
      contents: ""
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.append($('<h1>').addClass("cf-title-h4"));
      this.element.append($('<div>').addClass("help"));
      this._draw();
    },
    _draw: function _draw() {
      if (typeof this.options.title === "string") {
        this.element.children("h1").text(this.options.title);
      } else {
        this.element.children("h1").text("");
      }
      if (typeof this.options.contents === "string") {
        this.element.children(".help").text(this.options.contents);
      } else {
        this.element.children(".help").text("");
      }
    },
    _setOptions: function _setOptions(pOptions) {
      this._super(pOptions);
      this._draw();
    }
  });
})(jQuery);

},{}],124:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/
/*globals $, _, jsPlumb, console, api_sync, QuantumBlueCollar, namespace, nixps */

(function ($) {
  require("./nixps-quantum-ExpressionListItem.js");
  $.widget("nixps-quantum.ExpressionList", $.Widget, {
    widgetEventPrefix: "expressionlist",
    options: {
      /**
       * @brief the list of prefilled value composers
       */
      composerList: null,
      /**
       * @brief the collection of workflow variables
       */
      workflowVariableCollection: null,
      /**
       * @brief the collection of workflow variables
       */
      dataVariableCollection: null,
      /**
       * @brief the filter applied to the expression list
       * @type {Boolean}
       */
      filter: false,
      /**
       * @description must we show the categories?
       * @name nixps-quantum.ExpressionList#showCategorie
       * @type {Boolean}
       * @default true
       */
      showCategorie: true,
      /**
       * @description Must be show the add variable button
       * @name nixps-quantum.ExpressionList#showAddButton
       * @type {Boolean}
       * @default true
       */
      showAddButton: true,
      /**
       * @description The jQuery scope in where the elements live
       * @name nixps-quantum.ExpressionList#scope
       * @type {String}
       * @default "worfklow" 
       */
      scope: "workflow",
      /**
       * @description the expressionlist uuid
       * @name nixps-quantum.ExpressionList#list_uuid
       * @type {Number}
       * @default null
       */
      list_uuid: null
    },
    /**
     * @brief widget constructor
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.css({
        "overflow": "none"
      });

      // The categories (displayed left)
      this.categories = $("<ul>").addClass("categories").css({
        "list-style-type": "none",
        "overflow-y": "auto",
        "padding-top": 0
      });
      if (this.options.showCategorie === false) {
        this.categories.hide();
      }
      this.element.append(this.categories);

      // The expressions (displayed right)
      this.expressions = $("<ul>").addClass("expressions").css({
        "list-style-type": "none",
        "overflow-y": "auto",
        "padding-top": 0
      });
      this.element.append(this.expressions);

      // The default selected category
      this.selectedCategory = "all";
      if (this.options.showAddButton === true) {
        // The button bar at the bottom with the "Add variable" button
        var buttonBar = $("<div>").addClass("expressionlist_bottombar");
        buttonBar.appendTo(this.element);
        var addVariableButton = $("<button>").attr("type", "button").addClass("addVariable cf-button-main")._t("nixps-quantum-expressionlist.add_variable");
        addVariableButton;
        buttonBar.append(addVariableButton);
      }
      // Draw the 2 lists
      this._draw();
      this._on(this.element, {
        "click .categories li": this._categoryItemClickedHandler,
        "click .expressions li": this._expressionClickedHandler,
        "click .addVariable": this._addVariableClickedHandler
      });
    },
    /**
     * @brief handler for the add variable button
     */
    _addVariableClickedHandler: function _addVariableClickedHandler(pEvent, pData) {
      var that = this;
      var buttons = [{
        "classes": "cf-button-secondary dialog_button",
        "type": "cancel",
        "label": "nixps-cloudflow-dialog.cancel"
      }, {
        "classes": "cf-button-secondary dialog_button",
        "type": "ok_append",
        "label": "nixps-quantum-expressionlist.button_add_and_append_variable"
      }, {
        "classes": "cf-button-main dialog_button",
        "type": "ok",
        "label": "nixps-quantum-expressionlist.button_add_variable"
      }];
      var appendToContent = false;
      this.element.Dialog("prompt", $.i18n._("nixps-quantum-expressionlist.add_variable"), $.i18n._("nixps-quantum-expressionlist.add_variable_prompt"), "", true, undefined, undefined, buttons).then(function (variableData) {
        var variable = variableData.newValue;
        if (typeof variable !== "string" || variable.length === 0) {
          return;
        }
        if (variableData.type === "ok_append") {
          appendToContent = true;
        }
        that.options.workflowVariableCollection.addVariable(variable);
        that._trigger("addvariable", null, {
          "variable_name": variable,
          "append_to_content": appendToContent
        });
        that._draw();
      });
    },
    /**
     * @brief handles clicks on expressions (right panel)
     */
    _expressionClickedHandler: function _expressionClickedHandler(pEvent) {
      this.element.find(".expressions li");
      var target = $(pEvent.target);
      if (!target.is("li")) {
        target = target.parents("li");
      }
      if (target.is(".nixps-quantum-ExpressionListItem") === true) {
        this._trigger("expressionselected", null, {
          definition: target.ExpressionListItem("option", "definition")
        });
      }
    },
    /**
     * @brief handles clicks on the categories (left panel)
     */
    _categoryItemClickedHandler: function _categoryItemClickedHandler(pEvent) {
      var target = $(pEvent.target);
      this.categories.children("li").removeClass("cf-select");
      target.addClass("cf-select");
      this.selectedCategory = target.attr("category");
      this._filterExpressions();
    },
    /**
     * @brief fileters the expressions
     */
    _filterExpressions: function _filterExpressions() {
      var category = this.selectedCategory,
        filter = this.options.filter,
        hasFilter = typeof filter === "string" && filter.length > 0;
      var items = this.expressions.children("li");
      items.hide();
      if (category !== "all") {
        items = items.filter('li[category="' + category + '"]');
      }
      if (hasFilter) {
        filter = filter.toUpperCase();
        items = items.filter(function () {
          var item = $(this);
          if (item.is(".nixps-quantum-VariableTreeView") === true) {
            item.VariableTreeView("option", "filter", filter);
            return true;
          }
          return item.attr("title").toUpperCase().indexOf(filter) >= 0;
        });
      } else {
        this.expressions.children(".nixps-quantum-VariableTreeView").VariableTreeView("option", "filter", false);
      }
      items.show();
    },
    redraw: function redraw() {
      this._draw();
    },
    _draw: function _draw() {
      this.categories.empty();
      this.expressions.empty();
      var composerList = this.options.composerList;
      this.categories.css({
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 30,
        width: this.element.outerWidth() / 2 - 20
      });
      var leftExpr = this.element.outerWidth() / 2 - 20;
      if (this.options.showCategorie === false) {
        leftExpr = 0;
      }
      this.expressions.css({
        position: "absolute",
        left: leftExpr,
        top: 0,
        bottom: 30,
        right: 0
      });
      this.categories.append($("<li>")._t("nixps-quantum-expressionlist.all").attr("category", "all"));
      var categoryIDs = _.uniq(composerList.map(function (c) {
        return c.category;
      }));
      for (var i = 0; i < categoryIDs.length; i++) {
        this.categories.append($("<li>").text(categoryIDs[i]).attr("category", categoryIDs[i]));
      }
      for (var i = 0; i < composerList.length; i++) {
        this.expressions.append($("<li>").addClass("item").ExpressionListItem({
          definition: composerList[i],
          scope: this.options.scope,
          list_uuid: this.options.list_uuid,
          showIcon: true
        }));
      }
      var wfVariableCollection = this.options.workflowVariableCollection;
      var variables = wfVariableCollection.getNames();
      if (variables.length > 0) {
        var extraCategories = wfVariableCollection.getCategories();
        for (var i = 0; i < extraCategories.length; i++) {
          if (categoryIDs.includes(extraCategories[i]) === false) {
            this.categories.append($("<li>").text(extraCategories[i]).attr("category", extraCategories[i]));
          }
        }
        if (categoryIDs.indexOf("Custom Variables") === -1) {
          this.categories.append($("<li>")._t("nixps-quantum-expressionlist.custom_variables").attr("category", "Custom Variables"));
        }
        for (var i = 0; i < variables.length; i++) {
          var name = variables[i];
          var sample = "";
          var category = "Custom Variables";
          var source = undefined;
          var variable = name;
          var help = undefined;
          if (wfVariableCollection.hasSample(name) === true) {
            sample = wfVariableCollection.getSample(name);
          }
          if (wfVariableCollection.hasCategory(name) === true) {
            category = wfVariableCollection.getCategory(name);
          }
          if (wfVariableCollection.hasSource(name) === true) {
            source = wfVariableCollection.getSource(name);
          }
          if (wfVariableCollection.getVariable(name) !== undefined) {
            variable = wfVariableCollection.getVariable(name);
          }
          if (wfVariableCollection.hasHelp(name) !== undefined) {
            help = wfVariableCollection.getHelp(name);
          }
          this.expressions.append($("<li>").addClass("item").attr("category", category).VariableTreeView({
            name: name,
            variable: variable,
            value: sample,
            scope: this.options.scope,
            list_uuid: this.options.list_uuid,
            help: help,
            source: source
          }));
        }
      }
      var dataVariableCollection = this.options.dataVariableCollection,
        variables = dataVariableCollection.getNames();
      if (variables.length > 0 && categoryIDs.includes("Data") === false) {
        this.categories.append($("<li>")._t("nixps-quantum-expressionlist.container_variables").attr("category", "Data"));
      }
      for (var i = 0; i < variables.length; i++) {
        var name = variables[i];
        if (dataVariableCollection.hasSample(name) === true) {
          this.expressions.append($("<li>").addClass("item").attr("category", "Data").VariableTreeView({
            name: name,
            value: dataVariableCollection.getSample(name),
            type: "com.nixps.quantum.data_from_previous_node.0",
            scope: this.options.scope,
            list_uuid: this.options.list_uuid
          }));
        } else {
          this.expressions.append($("<li>").addClass("item").attr("category", "Data").VariableTreeView({
            name: name,
            value: "",
            type: "com.nixps.quantum.data_from_previous_node.0",
            scope: this.options.scope,
            list_uuid: this.options.list_uuid
          }));
        }
      }
      this.element.Dialog();
      this.categories.children('li[category="' + this.selectedCategory + '"]').addClass("cf-select");
      this._filterExpressions();
    },
    /**
     * @brief put disablePanel before all the content, so user can not use any button, element
     * The panel seems to be disabled, but is not theoretical disabled, it looks only so.
     * @returns {nothing}
     */
    disable: function disable(pTextMessage, pShowIcon) {
      this._super();
      if (this.element.children(".expressionlist-disablepanel").length > 0) {
        return; // do not disable again
      }

      var parent = $("<div>").addClass("expressionlist-disablepanel");
      var disabledPanel = $("<div>");
      var opacityPanel = $("<div>");
      var warnPanel = $("<div>").addClass("expressionlist-warnmessage");
      if (typeof pTextMessage === "string") {
        warnPanel._t(pTextMessage);
      } else {
        warnPanel.text("");
      }
      if (pShowIcon !== false) {
        var icon = $("<span>").addClass("cf-icon cf-icon-alert-triangle");
        warnPanel.prepend(icon);
      }
      parent.append(warnPanel);
      disabledPanel.append(opacityPanel);
      parent.append(disabledPanel);
      this.element.append(parent);
    },
    /**
     * remove disable panel
     * user can now handel his stuff
     */
    enable: function enable() {
      this._super();
      this.element.find(".expressionlist-disablepanel").remove();
    },
    /**
     * @brief disable all components that represent arrays, to prevent mixing strings and not-strings
     * @returns {nothing}
     */
    disableArrays: function disableArrays() {
      this.element.find(".nixps-quantum-ExpressionListItem").each(function () {
        var def = $(this).ExpressionListItem("option", "definition");
        if (def.output_type === "array") {
          $(this).draggable("disable").find(".title").css({
            cursor: "no-drop"
          });
        }
      });
      this._filterExpressions();
    },
    /**
     * @brief restore everyting to normal state after preventing mixing strings and not-string
     * retoring after calling _disableArrays
     * @returns {nothing}
     */
    enableArrays: function enableArrays() {
      this.element.find(".ui-draggable").draggable("enable").find(".title").css({
        cursor: "pointer"
      });
    },
    /** 
     * @brief sets the options
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "composerList") {
        this._super(pKey, pValue);
        this._draw();
      } else if (pKey === "disableArrays") {
        if (pValue) {
          this.disableArrays();
        } else {
          this.enableArrays();
        }
      } else if (pKey === "filter") {
        this._super(pKey, pValue);
        this._filterExpressions();
      }
    }
  });
})(jQuery);

},{"./nixps-quantum-ExpressionListItem.js":125}],125:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/
/*globals $, _, jsPlumb, console, api_sync, QuantumBlueCollar, namespace, nixps */

(function ($) {
  function getIconClass(pCategory) {
    switch (pCategory) {
      case "array":
        return "fa fa-list-ol";
      case "string":
        return "fa fa-font";
      case "mixed":
        return "fa fa-empty";
      default:
        return undefined;
    }
  }
  $.widget("nixps-quantum.ExpressionListItem", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "expressionlistitem",
    options: {
      /**
       * @brief the value that the definition must have
       * this is the concretisation of the definition
       * @default null
       */
      definition: null,
      /**
       * @description The jQuery scope in where the elements live
       * @type {String}
       * @default "worfklow" 
       * @since 1.1.0
       */
      scope: "workflow",
      /**
       * @description the uuid of the expressionlist
       * @type {Number}
       * @default null
       */
      list_uuid: null,
      /**
       * @description Must we show the icon or not?
       * @type {Boolean}
       * @default false
       */
      showIcon: false
    },
    _create: function _create() {
      this._super();
      var definition = this.options.definition;
      this.element.data("draggable", this); // Fixes TypeError, WTF !?
      this._addClass(this.widgetFullName);
      this.element.append($("<span>").addClass("expressionlistitem_categoryIcon"));
      this.element.append($("<span>").addClass("expressionlistitem_title"));
      this.element.attr("category", definition.category);
      if (this.options.list_uuid !== null) {
        this.element.addClass("list_uuid_" + this.options.list_uuid);
      }
      var that = this;
      this.element.draggable({
        helper: function helper() {
          return $("<div>").css({
            "z-index": 100110,
            whiteSpace: "nowrap"
          }).addClass("nixps-quantum-BuildingBlock").attr("data-type", definition.output_type).text(that.options.definition.name);
        },
        cursorAt: {
          left: -10,
          top: -10
        },
        cursor: "-webkit-grabbing",
        appendTo: "body",
        revert: "invalid",
        scope: this.options.scope,
        delay: 300
      });
      this._on(true, this.element, {
        "dragstart": function dragstart(e, ui) {
          this._trigger("dragstart", e, {
            ui: ui,
            composer: this.options.definition.composer
          });
        },
        "dragstop": function dragstop(e, ui) {
          this._trigger(true, "dragstop", e, {
            ui: ui,
            composer: this.options.definition.composer
          });
        }
      });
      this._draw();
    },
    _draw: function _draw() {
      var definition = this.options.definition;
      this.element.children(".expressionlistitem_title").text(definition.name);
      this.element.attr("title", definition.name);
      this.element.attr("category", definition.category);
      if (this.options.showIcon === true) {
        this.element.children(".expressionlistitem_categoryIcon").addClass(getIconClass(definition.output_type));
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "definition") {
        this._super(pKey, pValue);
        this._draw();
      }
    }
  });
})(jQuery);

},{}],126:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @description An input field tha search inside the possible value composers and variables in the expressionbuilder
   * @namespace nixps-quantum.ExpressionVariablesSearch
   * @version 1.1.0
   */
  $.widget("nixps-quantum.ExpressionVariablesSearch", $.Widget, {
    options: {
      /**
       * @brief the placeholder string to show
       * @name nixps-quantum.ExpressionVariablesSearch#placeHolder
       * @type {String}
       * @default "Search"
       */
      placeHolder: undefined,
      /**
       * @brief the delay for which the query must be stable
       * @name nixps-quantum.ExpressionVariablesSearch#throttle
       * @type {Number}
       * @default 500
       */
      throttle: 500
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        placeHolder: $.i18n._("nixps-quantum-expressionbuilder.placeholder_search")
      };
    },
    _create: function _create() {
      this._addClass(this.widgetFullName);
      this.element.append($("<span>").addClass("cf-icon cf-icon-search").attr("aria-hidden", "true"));
      this.element.append($("<input>").attr("placeholder", this.options.placeHolder).attr("type", "search"));
      this.mInput = this.element.children("input");
      this.searchValue = "";
      this.timerID = null;
      this._on(this.element, {
        "input input": this._handleInput,
        "change input": this._handleInput
      });
    },
    _handleInput: function _handleInput(event) {
      if (this.searchValue !== this.mInput.val()) {
        this.searchValue = this.mInput.val();
        this._delayedTrigger(event);
      }
    },
    _delayedTrigger: function _delayedTrigger(pEvent) {
      clearTimeout(this.timerID);
      this.timerID = this._delay(function () {
        this._trigger("change", pEvent, {
          value: this.searchValue
        });
      }, this.options.throttle);
    },
    /**
     * @brief sets the option
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "placeHolder") {
        this._superApply(arguments);
        this.element.children("input").attr("placeholder", pValue);
      } else if (pKey === "throttle") {
        this._superApply(arguments);
      }
    },
    _destroy: function _destroy() {
      clearTimeout(this.timerID);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],127:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var EntityComposer = require("./EntityComposer.js");
  $.widget("nixps-quantum.Modifier", $.Widget, {
    widgetEventPrefix: "modifier",
    options: {
      /**
       * @brief the valuecomposer containing the content
       */
      valueComposer: null
    },
    _create: function _create() {
      // control input
      var isInstanceOf = this.options.valueComposer instanceof EntityComposer;
      var isConstructor = this.options.valueComposer && this.options.valueComposer.constructor && this.options.valueComposer.constructor.name === "EntityComposer";
      if (!isInstanceOf && !isConstructor) {
        throw new Error('valueComposer has wrong interface');
      }
      // init
      this.element.addClass(this.widgetFullName);
      //variable

      this._draw();

      // event handlers
      this._on(this.element, {
        'parameterschanged': this._changeHandler
      });
    },
    /**
     * @brief handler runs when user change something
     *   here we update the model,data
     *   we update the this.options.valueComposer
     * @param {type} pEvent
     * @param {type} pData
     * @returns {nothing}
     */
    _changeHandler: function _changeHandler(pEvent, pData) {
      if ($.isPlainObject(pData.parameters)) {
        this.options.valueComposer.setParameters(pData.parameters);
        this._trigger("change", pEvent, {});
      } else {
        console.warn('get wrong event data!');
      }
    },
    /**
     * @brief redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief draws the dialog according to the current state
     */
    _draw: function _draw() {
      // draw content
      var html = this.options.valueComposer.getDefinition().getHTML();
      var editorScript = this.options.valueComposer.getDefinition().getEditorScript();
      var parent = this.element;

      // draw and bind the content
      var that = this;
      loadEntityComposerEditorFromString(html, editorScript, parent, function (pForm) {
        pForm.trigger('setparameters', that.options.valueComposer.getParameters());
      }, this.options.valueComposer);
    },
    /**
     * @brief sets the option
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._draw();
    },
    _destroy: function _destroy() {}
  });
  function loadEntityComposerEditorFromString(pNodeEditorHTMLString, pNodeEditorScript, pParentElement, pLoadedCallback, pEntityComposer) {
    if (typeof pEntityComposer.constructor !== "function" || pEntityComposer.constructor.name !== "EntityComposer") {
      throw new Error('invalid entity composer');
    }
    var form = $(pNodeEditorHTMLString.trim());

    // Get form and script from the form
    var formData = form.filter('form');

    // Append the form
    formData.on('submit', function () {
      return false;
    });
    pParentElement.append(formData);
    if (typeof pNodeEditorScript === "function") {
      pNodeEditorScript(formData[0], pEntityComposer);
    } else {
      nixps.quantum.util.entityComposerAutoBind(formData[0], pEntityComposer.getParameters());
    }
    pLoadedCallback(formData);
    return;
  }
})(jQuery);

},{"./EntityComposer.js":109}],128:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var BuildingBlock = require("./BuildingBlock.js");
  require("./nixps-quantum-Modifier.js");
  require("./nixps-quantum-ModifierListItem.js");
  var EntityComposer = require("./EntityComposer.js");

  /**
   * @namespace nixps-quantum.ModifierList
   * @description displaying the modifierlist of the specific value composer
   * @version 1.1.0
   */
  $.widget("nixps-quantum.ModifierList", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "modifierlist",
    options: {
      /**
       * @brief buildingBlock
       * @name nixps-quantum.ModifierList#buildingBlock
       * @type {BuildingBlock}
       * @default null
       */
      buildingBlock: null,
      /**
       * @description transformers
       * @name nixps-quantum.ModifierList#transformers
       * @type {Array}
       * @default []
       */
      transformers: []
    },
    _create: function _create() {
      /*
       * control input
       */
      var isInstanceOf = this.options.buildingBlock instanceof BuildingBlock;
      var isConstructor = this.options.buildingBlock && this.options.buildingBlock.constructor && this.options.buildingBlock.constructor.name === "BuildingBlock";
      if (!isInstanceOf && !isConstructor) {
        throw new Error("buildingblock has wrong interfase");
      }
      /*
       * initial
       */
      this.element.addClass(this.widgetFullName);
      /*
       * draw
       */
      this._draw();
      /*
       * event handling
       */
      this._on(this.element, {
        "click .savebutton": this._saveClickHandler,
        "click .cancelbutton": this._cancelClickHandler,
        "click .addTransformer": this._addTransformerHandler,
        "change": this._changeHandler,
        "modifierlistitemchange": this._changeHandler,
        "sortupdate": this._sortChangeHandler
      });
    },
    /**
     * @description user clicked on the save button
     * @function
     * @private
     * @name nixps-quantum.ModifierList#_saveClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _saveClickHandler: function _saveClickHandler(pEvent, pData) {
      this.saveAndClose(pEvent);
    },
    /**
     * @description user clicked on the cancel button
     * @function
     * @private
     * @name nixps-quantum.ModifierList#_cancelClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _cancelClickHandler: function _cancelClickHandler(pEvent, pData) {
      this._trigger("close", pEvent, {});
    },
    /**
     * @brief handlers runs when user click on add button, 
     *        when user want to add a transformer.
     * @function
     * @private
     * @name nixps-quantum.ModifierList#_addTransformerHandler
     * @param {type} pEvent
     * @param {type} pData
     * @event
     * @returns {undefined}
     */
    _addTransformerHandler: function _addTransformerHandler(pEvent, pData) {
      var transformerIdentifier = this.element.find("select.selectTransformers").val();
      if (transformerIdentifier === undefined) {
        // in case there is just one transformer, or fall back
        transformerIdentifier = this.options.transformers[0].getID();
      }
      var transformers = this.options.transformers;

      // Look up the definition
      var definition = null;
      $.each(transformers, function (i, n) {
        if (n.getID() === transformerIdentifier) {
          definition = n;
          return false;
        }
      });

      // If none found throw error
      if (definition === null) {
        throw new Error("no such transfomer found: " + transformerIdentifier);
      }
      var value = definition.getDefaultParameters();
      var transformer = new EntityComposer(value, definition);

      //add to model, buildingblock
      this.options.buildingBlock.addTransformer(transformer);
      //add UI
      var transformerUI = $("<div>").Modifier({
        valueComposer: transformer
      });
      var modifierListItem = $("<div>").ModifierListItem({
        modifier: transformerUI,
        title: transformer.getDefinition().getTitle()
      });
      this.element.find("ul.transformerList").append(modifierListItem);
      /** 
       * 1
       * 2
       * 3
       * 
       * 
       */
      this._updatePossibleTransformers();
    },
    _changeHandler: function _changeHandler(pEvent, pData) {
      if ($(pEvent.target).is(".selectTransformers")) {
        return;
      }
      if ($.isPlainObject(pData) && pData.from === "close") {
        $(pEvent.target).remove();
      }
      this._updatePossibleTransformers();
    },
    /**
     * @description function runsw when user sort items
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _sortChangeHandler: function _sortChangeHandler(pEvent, pData) {
      var valueComposers = $.makeArray(this.element.find(":nixps-quantum-Modifier").map(function (i, n) {
        return $(n).Modifier("option", "valueComposer");
      }));
      // loop through item and check if each fit on the previous one
      if (Array.isArray(valueComposers) && valueComposers.length > 1) {
        var previous = valueComposers[0].getDefinition().getOutputType();
        for (var i = 1; i < valueComposers.length; i++) {
          var childType = valueComposers[i - 1].getDefinition().getOutputType();
          if (childType === "child") {
            childType = previous;
          } else {
            previous = childType;
          }
          if (valueComposers[i].getDefinition().canApplyOn(childType) === false) {
            // one item does not fit, cancel operations
            this.element.find(".transformerList").sortable("cancel");
            return;
          }
        }
      }
      this._updatePossibleTransformers();
    },
    /**
     * @brief collect all the information from the UI
     * @returns {BuildingBlock}
     */
    collectData: function collectData() {
      var valueComposersUI = $.makeArray(this.element.find(":nixps-quantum-Modifier").map(function (i, n) {
        return $(n).Modifier("option", "valueComposer");
      }));
      var provider = valueComposersUI.shift();
      var transformers = valueComposersUI;
      this.options.buildingBlock.setProvider(provider);
      this.options.buildingBlock.setTransformers(transformers);
    },
    /**
     * @brief redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    saveAndClose: function saveAndClose(pEvent) {
      if (pEvent === undefined) {
        pEvent = null;
      }
      this.collectData();
      this._trigger("save", pEvent, {});
      this._trigger("close", pEvent, {});
    },
    /**
     * @brief draws the dialog according to the current state
     */
    _draw: function _draw() {
      // initiale 
      this.element.empty();
      var drawingBuildingBlock = this.options.buildingBlock.clone();

      // draw provider
      var provider = drawingBuildingBlock.getProvider();
      var providerUI = $("<div>").Modifier({
        valueComposer: provider
      });
      this.element.append(providerUI);

      // draw modifiers
      var transformersList = $("<ul>").addClass("transformerList").appendTo(this.element).sortable({
        handle: ".title"
      });
      var transformers = drawingBuildingBlock.getTransformers();
      for (var i = 0; i < transformers.length; i++) {
        //create model 
        var transformerUI = $("<div>").Modifier({
          valueComposer: transformers[i]
        });
        //put model in jacket
        var modifierListItem = $("<div>").ModifierListItem({
          modifier: transformerUI,
          title: transformers[i].getDefinition().getTitle()
        }).appendTo(transformersList);
      }

      //add modifierbutton and selection 
      this._addButtonTransformer();
    },
    /**
     * @brief add a button and a selection for adding a transformer
     * @returns {nothing}
     */
    _addButtonTransformer: function _addButtonTransformer() {
      this.element.append($("<hr>"));
      var buttonBar = $("<div>").addClass("cf-buttonbar");
      // select
      var selection = $("<select>").addClass("selectTransformers");

      // save
      var savebutton = $("<button>").addClass("savebutton modifierlist_rightbutton cf-button-main").attr("type", "button").text($.i18n._("QuantumEditor.button_text_save"));
      // cancel
      var cancelbutton = $("<button>").addClass("cancelbutton modifierlist_rightbutton cf-button-secondary").attr("type", "button").text($.i18n._("QuantumEditor.button_text_cancel"));
      // add button
      var addmodifierbutton = $("<button>").addClass("addTransformer cf-button-secondary").attr("type", "button").text($.i18n._("QuantumEditor.button_text_addmodifier"));
      buttonBar.append([selection, savebutton, cancelbutton, addmodifierbutton]);
      this.element.append(buttonBar);
      this._updatePossibleTransformers();
    },
    /**
     * @brief get the possible transformers and put those in the select input, from inputparameter
     * @param {jQuery} pSelection: the jQuery object where the options will be added to.
     * @returns {undefined}
     */
    _updatePossibleTransformers: function _updatePossibleTransformers() {
      if (Array.isArray(this.options.transformers) === false) {
        return;
      }
      var valueComposersUI = $.makeArray(this.element.find(":nixps-quantum-Modifier").map(function (i, n) {
        return $(n).Modifier("option", "valueComposer");
      }));
      var provider = valueComposersUI.shift();
      var transformers = valueComposersUI;
      var tempBuilderBlock = new BuildingBlock(provider, transformers);
      var resultType = tempBuilderBlock.getOutputType();
      var translators = this.options.transformers;
      var selector = this.element.find(".selectTransformers").empty();
      for (var i = 0; i < translators.length; i++) {
        if (translators[i].canApplyOn(resultType) === true) {
          var option = $("<option>").val(translators[i].getID()).text(translators[i].getTitle());
          selector.append(option);
        }
      }
      if (selector.find("option").length === 0) {
        selector.hide();
        this.element.find(".addTransformer").prop("disabled", true);
      } else {
        selector.css("display", "");
        this.element.find(".addTransformer").prop("disabled", false);
      }
    },
    _destroy: function _destroy() {},
    /**
     * @brief sets the option
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._draw();
    }
  });
})(jQuery);

},{"./BuildingBlock.js":107,"./EntityComposer.js":109,"./nixps-quantum-Modifier.js":127,"./nixps-quantum-ModifierListItem.js":129}],129:[function(require,module,exports){
"use strict";

(function ($) {
  $.widget("nixps-quantum.ModifierListItem", $.Widget, {
    options: {
      /**
       * @brief contains the modifier
       */
      modifier: null,
      /**
       * @brief the title that must show on the title bar
       */
      title: "modifier",
      /**
       * @brief closable, may we have the possibility to close?
       */
      closable: true
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._draw();
      this._on(this.element, {
        "click .removeIcon": this._removeHandler
      });
    },
    _removeHandler: function _removeHandler(pEvent, pData) {
      this._trigger("change", pEvent, {
        from: "close"
      });
    },
    /**
     * @brief redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief draws the dialog according to the current state
     */
    _draw: function _draw() {
      //draw dark box, titlebar and closing button            
      var title = $("<div>").addClass("title").text(this.options.title);
      if (this.options.closable === true) {
        //draw only button if the option says closable
        title.append($("<button>").attr("type", "button").addClass("removeIcon cf-iconbutton cf-icon cf-icon-x"));
      }
      var modifierUI = $("<li>").addClass("modifier");
      modifierUI.append(title);
      modifierUI.append(this.options.modifier);
      this.element.append(modifierUI);
    },
    /**
     * @brief sets the option
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._draw();
    },
    _destroy: function _destroy() {
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],130:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function ($) {
  require("../../../quantum/js/nixps-quantum-ConfigureObject.js");
  var ValueComposerUtil = require("./ValueComposerUtil.js");
  var ValueComposerTranslator = require("./ValueComposerTranslator.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");

  /**
   * @namespace nixps-quantum-ObjectEditor
   * @description the component to configure an object of value composers
   * @version 1.0.0
   */
  $.widget("nixps-quantum.ObjectEditor", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "objecteditor",
    options: {
      /**
       * @description The content
       * @name nixps-quantum.ObjectEditor#content
       * @type {Array}
       * @default []
       */
      content: [],
      /**
       * @description Array containing all the known variables by the system
       * @name nixps-quantum.ObjectEditor#knownVariableNames
       * @default []
       * @type {Array}
       */
      knownVariableNames: [],
      /**
       * @description The EntityComposerDefinitions
       * @name nixps-quantum.ObjectEditor#entityComposerDefinitions
       * @default null
       */
      entityComposerDefinitions: null,
      /**
       * @description The jQuery scope in where the elements live
       * @name nixps-quantum.ObjectEditor#scope
       * @type {String}
       * @default "worfklow" 
       */
      scope: "workflow",
      /**
       * @description The uuid of the expressionlist
       * @type {Number}
       * @default null
       * @private
       * @name nixps-quantum.ObjectEditor#expressionListUUID
       */
      expressionListUUID: null,
      created: function created() {}
    },
    /**
     * @description create the component
     * @name nixps-quantum.ObjectEditor#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this.mEditor = undefined;
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._on(this.element, {
        "configureobjectchanged": this._handleChange,
        "expressioneditorchange": this._preventPropagation
      });
      this._draw();
      this.options.created();
    },
    _preventPropagation: function _preventPropagation(pEvent) {
      pEvent.stopPropagation();
    },
    _handleChange: function _handleChange(pEvent, pData) {
      if (pData && _typeof(pData.data) === "object") {
        this._trigger("change", pEvent, this.getValue());
      }
    },
    hasKeyIssues: function hasKeyIssues() {
      var getType = function getType(pVal) {
        if (isNaN(pVal)) {
          return "object";
        } else {
          return "array";
        }
      };
      var content = this.mEditor.ConfigureObject("getValue");
      if (Array.isArray(content)) {
        content = content.slice(0);
        var keyMatrix = [];
        content = content.sort(function (a, b) {
          return b.variable_name.length - a.variable_name.length;
        });
        for (var i = 0; i < content.length; i++) {
          if (content[i].variable_name === "") {
            if (Array.isArray(content[i].value) && content[i].value.length === 1 && content[i].value[0].type === "com.nixps.quantum.value.0" && content[i].value[0].value === "") {
              // skip empty rows with empty values
              continue;
            } else if (content[i].value === "") {
              // skip empty rows with empty values
              continue;
            }
          }
          var keys = content[i].variable_name.split(".");
          if (keys.indexOf("") !== -1) {
            return true;
          }
          keyMatrix.push(keys);
        }
        for (var i1 = 0; i1 < keyMatrix.length; i1++) {
          for (var j1 = 0; j1 < keyMatrix[i1].length; j1++) {
            for (var i2 = i1 + 1; i2 < keyMatrix.length; i2++) {
              if (keyMatrix[i2][j1] === keyMatrix[i1][j1]) {
                for (var j2 = 0; j2 < keyMatrix[i2].length; j2++) {
                  if (keyMatrix[i1][j2] !== undefined && getType(keyMatrix[i2][j2]) !== getType(keyMatrix[i1][j2])) {
                    return true;
                  } else if (keyMatrix[i1][j2] === keyMatrix[i2][j2]) {
                    if (j2 + 1 === keyMatrix[i2].length) {
                      return true;
                    }
                    continue;
                  } else {
                    break;
                  }
                }
              }
            }
          }
        }
        return false;
      }
    },
    getValue: function getValue() {
      var content = this.editorValueToObject(this.mEditor.ConfigureObject("getValue"));
      var variables = [];
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      for (var i = 0; i < editors.length; i++) {
        variables = variables.concat($(editors[i]).ExpressionEditor("getVariableNames"));
      }
      return {
        content: content,
        variables: variables
      };
    },
    objectToEditorValue: function objectToEditorValue(pObject) {
      var result = [];
      var flattended = CloudflowObject.flatten(pObject, ValueComposerUtil.isValueComposer);
      var keys = Object.keys(flattended);
      keys = keys.sort(function (a, b) {
        return a > b ? 1 : -1;
      });
      for (var i = 0; i < keys.length; i++) {
        result.push({
          variable_name: keys[i],
          value: flattended[keys[i]]
        });
      }
      if (result.length === 0) {
        return [{
          variable_name: "",
          value: ""
        }];
      }
      return result;
    },
    editorValueToObject: function editorValueToObject(pEditorValue) {
      var result = {};
      var sorted = pEditorValue.slice().sort(function (a, b) {
        return a.variable_name > b.variable_name ? -1 : 1;
      });
      for (var i = 0; i < sorted.length; i++) {
        if (sorted[i].variable_name !== "") {
          CloudflowObject.setParameter(result, sorted[i].variable_name, sorted[i].value);
        }
      }
      return result;
    },
    hasResult: function hasResult() {
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      for (var i = 0; i < editors.length; i++) {
        if ($(editors[i]).ExpressionEditor("hasResult") !== true) {
          return false;
        }
      }
      return true;
    },
    isBlocking: function isBlocking() {
      var editors = this.element.find(".nixps-quantum-ExpressionEditor");
      for (var i = 0; i < editors.length; i++) {
        var blocking = $(editors[i]).ExpressionEditor("isBlocking");
        if (blocking === true) {
          return true;
        }
      }
      return false;
    },
    /**
     * @description Get the results for sending to backend for calculating sample. 
     * The result function is to be compatible with the expression Editor. 
     * Do not use the for getting the content of the component 
     * @function
     * @name nixps-quantum.CodeEditor#getSampleResult
     * @returns {undefined}
     */
    getSampleResult: function getSampleResult(pVariables) {
      var rows = this.element.find("tbody tr:not(.addRow)");
      var result = {};
      var rowsSorted = rows.slice().sort(function (r1, r2) {
        return $(r1).find("input").val() < $(r2).find("input").val() ? 1 : -1;
      });
      for (var i = 0; i < rowsSorted.length; i++) {
        var keyInputDOM = rowsSorted.eq(i).find("input");
        var value = rowsSorted.eq(i).find(".nixps-quantum-ExpressionEditor").ExpressionEditor("getResult", pVariables);
        if (Array.isArray(value) && value.length === 0) {
          value = "";
        }
        CloudflowObject.setParameter(result, keyInputDOM.val(), value);
      }
      // resort keys
      var sortedKeys = Object.keys(result).sort(function (a, b) {
        return a > b ? 1 : -1;
      });
      var resultOrdered = {};
      for (var i = 0; i < sortedKeys.length; i++) {
        CloudflowObject.setParameter(resultOrdered, sortedKeys[i], result[sortedKeys[i]]);
      }
      return resultOrdered;
    },
    addContent: function addContent(pContent) {
      this.mEditor.ConfigureObject("addNewRow");
      this.element.find(".nixps-quantum-ExpressionEditor").last().ExpressionEditor("addContent", pContent);
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps-quantum.ObjectEditor#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {},
    /**
     * @description redraw the component
     * @function
     * @name nixps-quantum.ObjectEditor#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-quantum.ObjectEditor#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      var objectData = ValueComposerTranslator.valueComposerToObject(this.options.content, this.options.entityComposerDefinitions);
      var editor = $("<div>");
      this.element.append(editor);
      editor.ConfigureObject({
        expressionListUUID: this.options.expressionListUUID,
        expressionScope: this.options.scope,
        preventEditorSwitch: true,
        columnHeaders: [$.i18n._("nixps-quantum.object_editor_key"), $.i18n._("nixps-quantum.object_editor_value")]
      });
      editor.ConfigureObject("setValue", this.objectToEditorValue(objectData));
      this.mEditor = editor;
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-quantum.ObjectEditor#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "content") {
        if (_typeof(this.options.content) === "object") {
          if (Array.isArray(this.options.content) && this.options.content.length === 1 && this.options.content[0].type === "com.nixps.quantum.object.0" && $.isPlainObject(this.options.content[0].object)) {
            this.mEditor.ConfigureObject("setValue", this.objectToEditorValue(this.options.content[0].object));
          } else {
            this.mEditor.ConfigureObject("setValue", this.objectToEditorValue(ValueComposerTranslator.valueComposerToObject(this.options.content, this.options.entityComposerDefinitions)));
          }
        }
      }
    }
  });
})(jQuery);

},{"../../../quantum/js/nixps-quantum-ConfigureObject.js":437,"../../CloudflowUtil/js/CloudflowObject.js":79,"./ValueComposerTranslator.js":113,"./ValueComposerUtil.js":114}],131:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _, chooser */

(function ($) {
  $.widget("nixps-quantum.VariableList", $.Widget, {
    options: {
      /**
       * @brief an array of pairs { name, value, fixed, visible }
       */
      variables: [],
      /**
       * @brief the array of variable names to filter on
       */
      variableNames: [],
      /**
       * @brief the collection to get the default sample values of real variables
       */
      workflowVariableCollection: undefined,
      /**
       * @brief the text to use if we don't know what to use, if we can retrieve nothing.
       */
      fallBackDefaultValue: "variable",
      /**
       * @description key for saving preferences
       * @type {String}
       * @default "com.nixps.quantum.expressionbuilder"
       */
      application_id: "com.nixps.quantum.expressionbuilder"
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.append($("<table>").append($("<tbody>").addClass("contents")));
      $("body").not(".nixps-Dialog").Dialog();
      this._draw();
      this._on(this.element, {
        "change input": this._inputChangedHandler,
        "keyup input": this._inputChangedHandler,
        "keydown input": this._inputChangedHandler
      });
    },
    _inputChangedHandler: function _inputChangedHandler(e) {
      var target = $(e.target);
      var varname = target.attr("data-varname");
      var found = false;
      if (Array.isArray(this.options.variables)) {
        found = this.options.variables.find(function (v) {
          return v.name === varname;
        });
      }
      found.value = target.val();
      if (found.fixed === false) {
        //keep all closed fired function, and just call the function once afterwards 
        //if there are no firing during 800 ms.
        clearTimeout(this.changeTimer);
        this.changeTimer = this._delay(function () {
          this._saveValue(found.name, found.value);
        }, 800);
      }
      this._trigger("change", null, {});
    },
    /**
     * @brief initial list from backend, to be called just after create
     * @returns {Deferred}
     */
    updateList: function updateList() {
      var that = this;
      return that._getSavedValues().done(function (variables) {
        $.each(variables, function (key, value) {
          for (var i = 0; i < that.options.variables.length; i++) {
            if (that.options.variables[i].name === key.replace(/\%2E/g, ".")) {
              that.options.variables[i].value = value;
              break;
            }
          }
        });
        that.controlAndRestoreVariableList();
        that._draw();
      });
    },
    /**
     * @brief look up for the sample of a variable of the workflow
     * this function should be call ones per variable,
     * once called, you should save the value
     * @param {string} pName of the path of the variable
     * @returns {Deferred} the default sample value
     */
    _getSampleOfWorkflowVariable: function _getSampleOfWorkflowVariable(pName) {
      if (this.options.workflowVariableCollection !== undefined) {
        var defaultValue = this.options.workflowVariableCollection.getSampleForPath(pName);
        if (typeof defaultValue === "string" && defaultValue.length > 0 || typeof defaultValue === "number") {
          return $.when(defaultValue);
        } else {
          return this._getSavedValue(pName);
        }
      } else {
        return this._getSavedValue(pName);
      }
    },
    /**
     * @brief loop over the variables and if one has a wrong value, replace with a fallbackDefault value
     * @returns {nothing}
     */
    controlAndRestoreVariableList: function controlAndRestoreVariableList() {
      var that = this;
      $.each(this.options.variables, function (i, e) {
        if (e.value === undefined) {
          this.value = that._getBestMatchedDefaultValue(e.name);
        }
      });
    },
    /**
     * @brief this function looks for a good matching default value.
     * you must first look for the correct value, just if you found nothing, then in last case call this function.
     * this function looks for other names/keys that are substrings of the pNodeName inputparameter.
     * this value can be a good default sample
     * @default this.options.fallBackDefaultValue
     * @param {string} pNodeName: the nodename/key, where you want a default value
     * @returns {String} the best matching default value
     */
    _getBestMatchedDefaultValue: function _getBestMatchedDefaultValue(pNodeName) {
      var length = this.options.variables.length;
      for (var i = 0; i < length; i++) {
        if (pNodeName.search(this.options.variables[i].name) >= 0) {
          return this.options.variables[i].value;
        }
      }
      return this.options.fallBackDefaultValue;
    },
    _draw: function _draw() {
      for (var i = 0; i < this.options.variables.length; i++) {
        if (this.options.variables[i].fixed === undefined) {
          this.options.variables[i].fixed = false;
        }
        if (this.options.variables[i].visible === undefined) {
          this.options.variables[i].visible = true;
        }
      }
      var contents = this.element.find(".contents").empty();
      if (this.options.variableNames.length === 0) {
        contents.append($("<div>").addClass("novariables").text($.i18n._("nixps-quantum-expressionbuilder.no_variables")));
        this._trigger("change", null, {});
        return;
      }
      var rowTemplate = $("<tr>").append($("<td>").css({
        "white-space": "nowrap",
        "text-align": "right",
        "text-overflow": "ellipsis",
        "max-width": "400px"
      }).append($("<label>"))).append($("<td>").css({
        width: "100%"
      }).append($("<input>").css({
        "width": "99%"
      })));
      var variableNames = this.options.variableNames;
      var variablesToShow = this.options.variables.filter(function (v) {
        if (v.visible === true) {
          return variableNames.indexOf(v.name) >= 0;
        }
      });
      if (variablesToShow.length === 0) {
        contents.append($("<div>").addClass("novariables").text($.i18n._("nixps-quantum-expressionbuilder.no_variables")));
        this._trigger("change", null, {});
        return;
      }
      for (var i = 0; i < variablesToShow.length; i++) {
        var v = variablesToShow[i],
          row = rowTemplate.clone(),
          value = v.value;
        if (typeof value === "function") {
          value = v.value(v.name);
        }
        row.find("label").text(v.name).attr("title", v.name);
        row.find("input").attr("data-varname", v.name).val(value);
        contents.append(row);
      }

      // if there are changes throw the change event
      this._trigger("change", null, {});
    },
    /**
     * @brief this function retrief the value saved in the backend/preferences
     * that is fill in as last by the user.
     * @param {string} pName: the key
     * @returns {Deferred}
     */
    _getSavedValue: function _getSavedValue(pName) {
      var that = this;
      var name = pName.replace(/\./g, "%2E");
      return $.Deferred(function (pDefer) {
        api_async.preferences.get_for_current_user(that.options.application_id, "samples." + name, function (pResult) {
          if (!$.isEmptyObject(pResult.preferences)) {
            pDefer.resolve(pResult.preferences);
          } else {
            pDefer.reject("no preferences found");
          }
        }, function (pError) {
          console.error(pError);
          pDefer.reject("preferences no acces");
        });
      });
    },
    /**
     * @brief this function retrieves all preferencekeys and values, thus all valuenames and keys
     * and returns this in the deferred object
     * @returns {Deferred} with the resulting pairs name and values
     */
    _getSavedValues: function _getSavedValues() {
      var that = this;
      return $.Deferred(function (pDefer) {
        api_async.preferences.get_for_current_user(that.options.application_id, "samples", function (pResult) {
          pDefer.resolve(pResult.preferences);
        }, function () {
          pDefer.resolve({});
        });
      });
    },
    /**
     * @brief save the value typed by user to the backend/ preferences
     * @param {string} pName: the key
     * @param {string} pValue: the value, this is the text typed by the user
     * @returns {Deferred}
     */
    _saveValue: function _saveValue(pName, pValue) {
      var that = this;
      var name = pName.replace(/\./g, "%2E");
      return $.Deferred(function (pDefer) {
        api_async.preferences.save_for_current_user(pValue, that.options.application_id, "samples." + name, function (pResult) {
          pDefer.resolve();
        }, function (pError) {
          console.error(pError);
          pDefer.reject(pError);
        });
      });
    },
    /**
     * @brief this function removes all preferences samples stored.
     * 
     * @returns {Deferred}
     */
    resetSavedValues: function resetSavedValues() {
      var that = this;
      return $("body").Dialog("show_yes_no", "Confirm", "clear all variable preferences?").then(function (pResult) {
        if (pResult.type === "yes") {
          return $.Deferred(function (pDefer) {
            return api_defer.preferences.save_for_current_user({}, that.options.application_id, "samples");
          });
        }
        return $.Deferred().reject("user reject");
      });
    },
    _setOption: function _setOption(pKey, pValue) {
      this._super(pKey, pValue);
      var that = this;
      if (pKey === "variables") {
        this._draw();
        return;
      }
      if (pKey === "variableNames") {
        var names = pValue;
        var defers = [];
        for (var i = 0; i < names.length; i++) {
          var name = names[i];
          var records = [];
          if (Array.isArray(this.options.variables)) {
            records = this.options.variables.filter(function (v) {
              return v.name === name;
            });
          }
          if (records.length === 0) {
            (function (nodeName) {
              defers.push($.Deferred(function (pDefer) {
                // look up for values if no found use a default value
                that._getSampleOfWorkflowVariable(nodeName).done(function (sample) {
                  that.options.variables.push({
                    name: nodeName,
                    value: sample,
                    fixed: false,
                    visible: true
                  });
                }).fail(function () {
                  that.options.variables.push({
                    name: nodeName,
                    value: that._getBestMatchedDefaultValue(nodeName),
                    fixed: false,
                    visible: true
                  });
                }).always(function () {
                  pDefer.resolve();
                });
              }));
            })(name);
          }
        }
        if (defers.length > 0) {
          // if all lookups are done (+/-), you can redraw
          $.when.apply($, defers).always(function () {
            that._draw();
          });
        } else {
          this._draw();
        }
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],132:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/
/*globals $, _, jsPlumb, console, api_sync, QuantumBlueCollar, namespace, nixps, jQuery */

(function ($) {
  require("../../../common/TreeView/js/nixps-TreeView.js");
  require("./nixps-quantum-ExpressionListItem.js");

  /**
   * @brief transforms the *object* passed to a tree view node, *parent* is the 
   *        parent tree node and *key* is the keypath array to reach the object
   *        from the root
   * @function
   * @private
   */
  function transform(object, parent, key, label, source, pHelp) {
    if (typeof label !== "string" || label.length <= 0) {
      label = key[key.length - 1];
    }
    if ($.isPlainObject(object) === true) {
      var currentParent = {};
      var children = [];
      var keys = Object.keys(object);
      for (var i = 0; i < keys.length; i++) {
        var childKey = $.extend(true, [], key);
        childKey.push(keys[i]);
        children.push(transform(object[keys[i]], currentParent, childKey, childKey, source));
      }
      currentParent.expanded = false;
      currentParent.leaf = false;
      currentParent.label = label;
      currentParent.data = {
        value: object,
        keyPath: key,
        parent: parent,
        source: source
      };
      currentParent.children = children;
      return currentParent;
    }
    if (Array.isArray(object) === true) {
      var currentParent = {};
      var children = [];
      for (var i = 0; i < object.length; i++) {
        var childKey = $.extend(true, [], key);
        childKey.push(i);
        children.push(transform(object[i], currentParent, childKey, childKey, source));
      }
      currentParent.expanded = false;
      currentParent.leaf = false;
      currentParent.label = label;
      currentParent.data = {
        value: object,
        keyPath: key,
        parent: parent,
        source: source
      };
      currentParent.children = children;
      return currentParent;
    }
    return {
      expanded: false,
      leaf: true,
      label: label,
      data: {
        value: object,
        keyPath: key,
        parent: parent,
        source: source
      },
      help: pHelp,
      children: []
    };
  }

  /**
   * @brief filters the tree that starts with *node*, *query* is the string to find
   */
  function filter(node, query) {
    var q = query.toUpperCase();
    function checkLeaf(node, query) {
      if (node.children.length > 0) {
        var children = node.children;
        for (var i = 0; i < children.length; i++) {
          if (filter(children[i], query) === true) {
            i = i - 1;
          }
        }
        if (children.length === 0) {
          // Remove myself
          var parent = node.data.parent;
          if (parent !== null) {
            var index = parent.children.indexOf(node);
            if (index > -1) {
              parent.children.splice(index, 1);
              return true;
            }
          }
        }
        node.expanded = true;
        return false;
      }
      if (node.children.length === 0) {
        // Check myself
        var path = node.data.keyPath.join(".").toUpperCase();
        var parent = node.data.parent;
        if (parent !== null && path.indexOf(query) < 0) {
          var index = parent.children.indexOf(node);
          if (index > -1) {
            parent.children.splice(index, 1);
            return true;
          }
        }
      }
      return false;
    }
    return checkLeaf(node, q);
  }
  $.widget("nixps-quantum.VariableTreeView", $.Widget, {
    options: {
      /**
       * @brief the name of the variable
       * @default ""
       */
      name: "",
      variable: "",
      /** 
       * @brief json that represents the variable
       * @default {}
       */
      value: {},
      /**
       * @brief the filter to apply
       * @default false
       */
      filter: false,
      /**
       * @brief the type of item being generated
       * @type {String}
       * @default ""
       */
      type: "",
      /**
       * @description The jQuery scope in where the elements live
       * @name nixps-quantum.VariableTreeView#scope
       * @type {String}
       * @default "worfklow" 
       */
      scope: "workflow",
      /**
       * @description the help text for a specific variable
       * @name nixps-quantum.VariableTreeView#help
       * @type {mixed}
       * @default undefined
       */
      help: undefined,
      /**
       * @description the expressionlist uuid
       * @name nixps-quantum.VariableTreeView#list_uuid
       * @type {Number}
       * @default null
       */
      list_uuid: null
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.treeView = $("<div>");
      var renderFunction = this._renderJSONNode.bind(this);
      switch (this.options.type) {
        case "com.nixps.quantum.data_from_previous_node.0":
          renderFunction = this._renderDataFromPreviousNode.bind(this);
          break;
        default:
          renderFunction = this._renderJSONNode.bind(this);
          break;
      }
      this.element.append(this.treeView.TreeView({
        renderNode: renderFunction
      }));
      this.unfilteredTransformed = transform(this.options.value, null, [this.options.variable], this.options.name, this.options.source, this.options.help);
      this._draw();
    },
    _draw: function _draw() {
      var f = this.options.filter;
      this._waiting();
      this.timerID = this._delay(function () {
        if (typeof f === "string" && f.length > 0) {
          this.filteredTransformed = transform(this.options.value, null, [this.options.variable], this.options.name, this.options.source, this.options.help);
          filter(this.filteredTransformed, f);
          this.treeView.TreeView("option", "root", this.filteredTransformed);
          if (this.filteredTransformed.children.length === 0 && this.filteredTransformed.leaf === false) {
            this.treeView.hide();
          } else if (this.filteredTransformed.children.length === 0 && this.filteredTransformed.data.keyPath.join(".").toUpperCase().indexOf(f) < 0) {
            this.treeView.hide();
          } else {
            this.treeView.show();
          }
          this.element.children(".wait").remove();
        } else {
          this.treeView.TreeView("option", "root", this.unfilteredTransformed);
          this.element.children(".wait").remove();
          this.treeView.show();
        }
      }, 100 + Math.random() * 100);
    },
    _renderJSONNode: function _renderJSONNode(node) {
      if ($.isPlainObject(node.data) === false) {
        return $("<span>");
      }
      var keyPath = node.data.keyPath,
        title = node.label,
        fullKey = keyPath.join("."),
        source = node.data.source,
        output_type = node.data.output_type || "string",
        help = node.help || {
          "en": "The variable: " + fullKey
        };
      if (node.leaf === false) {
        return $("<span>").css({
          whiteSpace: "nowrap",
          display: "inline"
        }).addClass("nixps-quantum-VariableTreeNode").ExpressionListItem({
          definition: {
            name: title,
            composer: [{
              type: "com.nixps.quantum.variable.0",
              variable: fullKey,
              source: source
            }],
            category: "variables",
            output_type: output_type,
            help: help
          },
          scope: this.options.scope,
          list_uuid: this.options.list_uuid
        });
      }
      return $("<li>").ExpressionListItem({
        definition: {
          name: title,
          composer: [{
            type: "com.nixps.quantum.variable.0",
            variable: fullKey,
            source: source
          }],
          category: "variables",
          output_type: output_type,
          help: help
        },
        scope: this.options.scope,
        list_uuid: this.options.list_uuid
      });
    },
    _renderDataFromPreviousNode: function _renderDataFromPreviousNode(node) {
      if ($.isPlainObject(node.data) === false) {
        return $("<span>");
      }
      var keyPath = node.data.keyPath,
        title = node.label,
        fullKey = keyPath.join("."),
        nodeName = keyPath[0],
        subKey = _.rest(keyPath).join("."),
        output_type = "string",
        help = node.help || {
          en: "The container name: " + fullKey
        };
      var composer;
      if (typeof nodeName === "string" && nodeName.length > 0) {
        composer = [{
          type: "com.nixps.quantum.quantum_data_from_node.0",
          node_name: nodeName,
          sub_json_path: subKey
        }];
      } else {
        composer = [{
          type: "com.nixps.quantum.quantum_data_from_node.0",
          node_name: "previous",
          sub_json_path: subKey
        }];
      }
      if (node.leaf === false) {
        return $("<span>").css({
          whiteSpace: "nowrap",
          display: "inline"
        }).addClass("nixps-quantum-VariableTreeNode").ExpressionListItem({
          definition: {
            name: title,
            composer: composer,
            category: "variables",
            output_type: output_type,
            help: help
          },
          scope: this.options.scope,
          list_uuid: this.options.list_uuid
        });
      }
      return $("<li>").ExpressionListItem({
        definition: {
          name: title,
          composer: composer,
          category: "variables",
          output_type: output_type,
          help: help
        },
        scope: this.options.scope,
        list_uuid: this.options.list_uuid
      });
    },
    _waiting: function _waiting() {
      this.treeView.hide();
      if (this.element.children(".wait").length === 0) {
        this.element.append($("<span>").addClass("wait").append($("<span>").addClass("fa fa-hourglass-o")).append($("<span>").text(this.options.name)));
      }
    },
    _setOption: function _setOption(key, value) {
      if (key === "json") {
        this._super(key, value);
        this.unfilteredTransformed = transform(this.options.value, null, [this.options.variable], this.options.name, this.options.source, this.options.help);
        this._draw();
      } else if (key === "filter") {
        if (this.options.filter !== value) {
          clearTimeout(this.timerID);
          this._super(key, value);
          this._draw();
        }
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      clearTimeout(this.timerID);
    }
  });
})(jQuery);

},{"../../../common/TreeView/js/nixps-TreeView.js":383,"./nixps-quantum-ExpressionListItem.js":125}],133:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _, chooser */

(function ($) {
  require("../../../polyfill/polyfill.js");
  if (typeof $.fn.Table !== "function") {
    require("../../Table/js/nixps-cloudflow-Table.js");
  }
  if (typeof $.fn.ListView !== "function") {
    require("../../ListView/js/nixps-cloudflow-ListView.js");
  }
  if (typeof $.fn.IconView !== "function") {
    require("../../IconView/js/nixps-cloudflow-IconView.js");
  }
  if (typeof $.fn.ReaderView !== "function") {
    require("../../IconView/js/nixps-cloudflow-ReaderView.js");
  }
  if (typeof $.fn.BreadCrumb !== "function") {
    require("../../../nebulaportal/js/assetview/nixps-asset-BreadCrumb.js");
  }
  if (typeof $.fn.FolderView !== "function") {
    require("../../FolderView/js/nixps-cloudflow-FolderView-main.js");
  }
  function decodeURL(pURL) {
    try {
      return decodeURI(pURL);
    } catch (e) {
      return pURL;
    }
  }
  var staticPref = {};
  function getStaticPreferences() {
    if ($.isPlainObject(staticPref) && $.isEmptyObject(staticPref) === false) {
      return staticPref;
    }
    return $.Deferred(function (pDefer) {
      api_async.preferences.get_for_current_user("workspace", "assetview", function (pResults) {
        if (pResults !== undefined && pResults.preferences !== undefined && typeof pResults.preferences.assetLimit === "number" && pResults.preferences.assetLimit > 0) {
          staticPref.assetLimit = pResults.preferences.assetLimit;
        } else {
          // if error set on default
          staticPref.assetLimit = 200;
        }
        if (pResults !== undefined && pResults.preferences !== undefined && typeof pResults.preferences.searchOnTyping === "boolean") {
          staticPref.searchOnTyping = pResults.preferences.searchOnTyping;
        } else {
          //default to true
          staticPref.searchOnTyping = true;
        }
        pDefer.resolve(staticPref);
      }, function (pError) {
        // if error set on default
        console.error(pError);
        staticPref.assetLimit = 200;
        staticPref.searchOnTyping = true;
        pDefer.resolve(staticPref);
      });
    });
  }
  var contextPref = {};
  function get_filename(url) {
    if (url !== undefined) {
      return url.substring(url.lastIndexOf("/") + 1);
    } else {
      return url;
    }
  }
  function get_path(url) {
    if (url !== undefined) {
      return url.substring(0, url.lastIndexOf("/") + 1);
    } else {
      return url;
    }
  }

  /**
      * @namespace nixps-cloudflow.FileChooser
      * @description Component to select a file or folder in the PP_FILE_STORE <br />
      * This component can send next events:
      * <ul>
      * <li>viewchanged: if user change from icon to view or the other way round</li>
      * <li>selection: if user has (de)select some files/folders</li>
      * <li>choosen: if user has choosen (double clicked on) a file</li>
      * </ul>
      * @example $("<div>").FileChooser({multiple: false, foldersOnly: true, ...});
      */
  $.widget("nixps-cloudflow.FileChooser", $.Widget, {
    widgetEventPrefix: "FileChooser",
    options: {
      /**
       * @desc Allow multiple file selection
                * @name nixps-cloudflow.FileChooser#multiple
                * @type Boolean
                * @default true
       */
      multiple: true,
      /**
       * @description Show only folders and hide files
                * @name nixps-cloudflow.FileChooser#foldersOnly
                * @type Boolean
                * @default false
       */
      foldersOnly: false,
      /**
       * @desc The name of the default view to use. You can choose between "icon" and "list"
                * @type {String}
                * @default "icon"
                * @example "list"
       */
      view: "icon",
      /**
       * @description Filter the files on filetype. Specify the allowed filetypes. To allowed all files specify a empty array
       * @name nixps-cloudflow.FileChooser#allowed_file_types
       * @type {Array.<String>}
       * @example ["application/pdf", "image/jpeg"]
       * @default []
       */
      allowed_file_types: [],
      /**
       * @description Filter the files on extension. Specify the allowed file extensions. To allowed all specify a empty array
       * @name nixps-cloudflow.FileChooser#allowed_file_extensions
       * @type {Array.<String>}
       * @example [".pdf"]
       * @default undefined
       */
      allowed_file_extensions: undefined,
      /**
       * @description The default url to open the file chooser in.
                * @name nixps-cloudflow.FileChooser#url
                * @type {String}
                * @default null
                * @example "cloudflow://PP_FILE_STORE/folder/"
       */
      url: null,
      /**
       * @description Must we use the url of the preferences in case of empty url? If the option url is defined, than that option url will overwrite the preferences
       * @name nixps-cloudflow.FileChooser#useUrlOfPreferences
       * @private
       * @type {Boolean}
       * @default true
       */
      useUrlOfPreferences: true,
      /**
       * @description The root folders
       * @name nixps-cloudflow.FileChooser#rootFolders
       * @private
       * @type {Array}
       * @default []
       */
      rootFolders: [],
      /**
       * @description The root files
       * @name nixps-cloudflow.FileChooser#rootFiles
       * @private
       * @type {Array}
       * @default []
       */
      rootFiles: [],
      /**
       * @description This is a tachnical option, do not use it
       * @name nixps-cloudflow.FileChooser#searchOnfolders
       * @private
       * @type {Boolean}
       * @default false
       */
      searchOnfolders: false,
      /**
       * @description Specify the columns you want to see in the list view mode. You can choose between "thumb", "name", "approval", "filetype"  and "modtime"
       * @name nixps-cloudflow.FileChooser#columns
       * @type {Array}
       * @default [ "thumb", "name", "filetype", "modtime"]
       * @example ["thumb", "name"]
       */
      columns: ["thumb", "name", "filetype", "modtime"],
      /**
       * @description Load the tags into the system
       * @name nixps-cloudflow.FileChooser#loadTags
       * @type {Boolean}
       * @default false
       */
      loadTags: false,
      /**
       * @description The css position value of the main component
       * @name nixps-cloudflow.FileChooser#mainPossitionCSS
       * @type {String}
       * @default "relative"
       */
      mainPossitionCSS: "relative",
      /**
       * @description The context in wich this component is used. So we can have different preferences or different locations/ contexts
       * @name nixps-cloudflow.FileChooser#context
       * @type {String}
       * @default ""
       */
      context: "",
      /**
       * @description function runs when user double clicked on a file. This should replace the old "callback" function.
       * @type Function
       * @default function(){}
       * @returns {undefined}
       */
      choosen: function choosen() {},
      /**
       * @description Returns  the updated url (from a breadcrumb or file picker change)
       * @type Function
       * @default function(){}
       * @returns {undefined}
       */
      urlUpdate: function urlUpdate() {},
      /**
       * @description Specify if you want to use the component for a "save as". Must we show a "save as panel" ?
       * @name nixps-cloudflow.FileChooser#enableSaveAs
       * @type {Boolean}
       * @default false
       */
      enableSaveAs: false,
      /**
       * @description The filename we fill in if no name via url is given. This option will only be important if option "enableSaveAs" is activated.
       * @name nixps-cloudflow.FileChooser#defaultSaveAsFileName
       * @type {String}
       * @default "Untitled"
       * @example "untitled.pdf"
       */
      defaultSaveAsFileName: "Untitled",
      /**
       * @description Must we show a save button on the component? This button will only trow a "save" event, no other action are taken.
       * This can be handy if option enableSaveAs is activeted.
       * @name nixps-cloudflow.FileChooser#enableSaveButton
       * @type {Boolean}
       * @default false
       */
      enableSaveButton: false,
      /**
       * @description Must we show a select button on the component? This button will only trow a "select" event, no other action are taken.
       * This can be handy if option enableSaveAs is activeted.
       * @name nixps-cloudflow.FileChooser#enableSelectButton
       * @type {Boolean}
       * @default false
       */
      enableSelectButton: false,
      /**
       * @description Must we show a cancel button on the component? This button will only trow a "cancel" event, no other action are taken.
       * This can be handy if option enableSaveAs is activeted.
       * @name nixps-cloudflow.FileChooser#enableCancelButton
       * @type {Boolean}
       * @default false
       */
      enableCancelButton: false,
      /**
       * @description The text to be added to the icon Button
       * @name nixps-cloudflow.FileChooser#chooseIconButtonText
       * @type {String}
       * @default "nixps-cloudflow-FileChooser.icon"
       */
      chooseIconButtonText: "nixps-cloudflow-FileChooser.icon",
      /**
       * @description The icon to be added to the icon Button
       * @name nixps-cloudflow.FileChooser#chooseIconButtonIcon
       * @type {String}
       * @default null
       */
      chooseIconButtonIcon: null,
      /**
       * @description The text to be added to the list Button
       * @name nixps-cloudflow.FileChooser#chooseListButtonText
       * @type {String}
       * @default "nixps-cloudflow-FileChooser.list"
       */
      chooseListButtonText: "nixps-cloudflow-FileChooser.list",
      /**
       * @description The icon to be added to the list Button
       * @name nixps-cloudflow.FileChooser#chooseListButtonIcon
       * @type {String}
       * @default null
       */
      chooseListButtonIcon: null,
      /**
       * @description object to retrieve consent
       * @name nixps-cloudflow.FileChooser#consent
       * @type {Object}
       * @default null
       */
      consent: null,
      /**
       * @description must we save the preferences or not, attention the consent can overwrite this
       * @name nixps-cloudflow.FileChooser#savePreferences
       * @type {Boolean}
       * @default true
       */
      savePreferences: true,
      /**
       * @description must we add a dropdown that allows filtering the search 
       * @name nixps-cloudflow.FileChooser#enableSearchFilter
       * @type {Boolean}
       * @default false
       */
      enableSearchFilter: false,
      /**
       * @description Callback function when the component is drawed and ready to use
       * @name nixps-cloudflow.FileChooser#created
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    _create: function _create() {
      var that = this;
      this._controlOptions();
      this.element.addClass(this.widgetFullName);

      // variables 
      this.alive = true;
      this.m_root = ""; // current folder of viewing
      this.url = "";
      this.view = this.options.view;
      this.orderByPref = {}; // the order by object to get and save to retore the previous state
      this.context = "default"; // set preferences key

      if (typeof this.options.mainPossitionCSS === "string" && this.options.mainPossitionCSS.length > 0) {
        this.element.css({
          position: this.options.mainPossitionCSS
        });
      }
      if (typeof window._ === "function" && typeof _.debounce === "function") {
        this.searchHandler = _.debounce(this._searchHandler, 900);
      } else {
        console.error("include the underscore plugin for performace reasons");
        this.searchHandler = this._searchHandler;
      }
      if (this.options.savePreferences === true && (this.options.consent === null || this.options.consent.isUserPreferencesAllowed("filechooser"))) {
        /** set preferences key **/
        this.context = "default";
        if (typeof this.options.context === "string" && this.options.context.length > 0) {
          this.context = this.options.context;
        } else {
          // lets take a default that is based on the current window we are on
          if (window.location.search == "") {
            this.context = "default";
          } else {
            this.context = window.location.search.replace(/\W+/g, "");
          }
        }
        if (typeof window._ === "function" && typeof _.debounce === "function") {
          this.savePreferences = _.debounce(this._savePreferences, 1000);
        } else {
          this.savePreferences = this._savePreferences;
        }
      } else {
        this.savePreferences = function () {};
      }

      /** set and go to the correct page **/
      var userPrefDef = {};
      if (this.options.consent === null || this.options.consent.isUserPreferencesAllowed("filechooser")) {
        userPrefDef = this._getPreferences();
      }
      $.when(getStaticPreferences(), userPrefDef).done(function (pStaticPreferences) {
        that._draw();
        var folderViewInitPreferences = {};
        // there are some preferences, apply them to have a default
        if ($.isPlainObject(that.orderByPref) && $.isEmptyObject(that.orderByPref) === false) {
          folderViewInitPreferences = Object.assign({}, that.orderByPref);
        }
        if ($.isPlainObject(pStaticPreferences) && $.isEmptyObject(pStaticPreferences) === false) {
          folderViewInitPreferences = Object.assign(folderViewInitPreferences, pStaticPreferences);
          if (pStaticPreferences.searchOnTyping !== undefined) {
            that.searchOnTyping = pStaticPreferences.searchOnTyping;
            if (that.searchOnTyping === false) {
              that.searchHandler = that._searchHandler;
              that._on(that.element, {
                "input input.search-field": that.searchHandler,
                "keyup input.search-field": that.searchHandler
              });
            }
          }
        }
        if ($.isEmptyObject(folderViewInitPreferences) === false) {
          that.element.find(".filechooser_view.nixps-cloudflow-FolderView").FolderView("initPreferences", folderViewInitPreferences);
        }
        if (typeof that.options.url === "string" && that.options.url.length > 0) {
          that.set_url(that.options.url);
        } else {
          that.set_url(that.url);
        }
        that.options.created();
      }).fail(function () {
        that._draw();
        that.set_url(that.url);
        that.options.created();
      });

      /*
      if (window.Mousetrap !== undefined && typeof window._ && typeof _.throttle === "function") {
          var stack = "";
          var _select = function(str) {
              console.log(stack);
              stack = "";
          };
          var select = _.throttle(_select, 700, {leading: false});
           Mousetrap.bind(["q","w","e","r","t","y","u","i","o","p","a","s","d","f","g","h","j","k","l","z","x","c","v","b","n","m"], function(e, combo) {
              stack += combo;
              select();
          });
      }
      */

      this._on(this.element, {
        "click .list_view_selector": this._listViewClickHandler,
        "click .icon_view_selector": this._iconViewClickHandler,
        "click [data-action]": this._actionClickHandler,
        "folderviewselect": this._selectionHandler,
        "folderviewopen": this._filesChooseHandler,
        "input input.search-field": this.searchHandler,
        "keyup input.search-field": this.searchHandler,
        "keyup input.saveNameInput": this._keyUpSaveNameInputHandler,
        "input .saveNameInput": this._inputSaveAsHandler,
        "folderviewdraw": this._drawedHandler,
        "folderviewchangepreferences": this._preferencesChangedHandler,
        "change .search_view_filter select": this._setTagsIcon
      });
    },
    /**
     * @description function runs when user click on the list icon, to switch to list view
     * @function
     * @name nixps-cloudflow.FileChooser#_listViewClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _listViewClickHandler: function _listViewClickHandler(pEvent, pData) {
      this.show_list_view();
      this.view = "list";
      this._trigger("viewchanged", null, {
        view: "list"
      });
      this.savePreferences();
    },
    /**
     * @description function runs when user click on the "icon" icon, to switch to icon view
     * @function
     * @name nixps-cloudflow.FileChooser#_iconViewClickHandler
     * @private
     * @returns {undefined}
     */
    _iconViewClickHandler: function _iconViewClickHandler() {
      this.show_icon_view();
      this.view = "icon";
      this._trigger("viewchanged", null, {
        view: "icon"
      });
      this.savePreferences();
    },
    /**
     * @description function runs when user press a action button. This will only throw events
     * @function
     * @name nixps-cloudflow.FileChooser#_actionClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _actionClickHandler: function _actionClickHandler(pEvent, pData) {
      var action = $(pEvent.target).closest("[data-action]").attr("data-action");
      if (typeof action === "string" && action.length > 0) {
        var eventData = {
          files: this.getSelectedItems()
        };
        if (this.options.enableSaveAs === true) {
          // if we are in save as mode, we need also to give the "save as" information
          var filename = this.element.find("input.saveNameInput").val();
          if (typeof filename !== "string") {
            // give support for error handling in higher levels
            // we may not handle this ourself
            eventData.filenameError = true;
            eventData.filenameErrorMessage = "not_a_string";
            eventData.candidateFileName = filename;
            eventData.folderurl = this.m_root;
          } else if (filename.length <= 2) {
            // give support for error handling in higher levels
            // we may not handle this ourself
            eventData.filenameError = true;
            eventData.filenameErrorMessage = "length_too_small";
            eventData.candidateFileName = filename;
            eventData.folderurl = this.m_root;
          } else {
            eventData.fileurl = this.m_root + filename;
            eventData.filenameExist = this._hasFile(filename);
            eventData.filenameError = false;
          }
        }
        this._trigger(action, null, eventData);
      }
    },
    /**
     * @description function runs when user select or deselect some files
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _selectionHandler: function _selectionHandler(pEvent, pData) {
      var assets = [];
      // first make copy, to prevent changes to original objects
      if (Array.isArray(pData.files)) {
        assets = $.extend(true, [], pData.files);
      }
      // add missing data
      assets = this._extendAssetData(assets);
      if (assets.length > 0) {
        this._trigger("selection", null, {
          files: assets
        });
      }
    },
    /**
     * @description function runs when user dblclicks on a item, all selected file names will come
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _filesChooseHandler: function _filesChooseHandler(pEvent, pData) {
      if (pData && pData.cloudflow && typeof pData.cloudflow.folder === "string") {
        // clear search filter
        this.element.find("input.search-field").val("");
        // handle folders
        this.set_url(pData.cloudflow.folder);
        return true;
      } else {
        // first make copy, to prevent changes to original objects
        this._trigger("choosen", null, {
          files: this._extendAssetData($.extend(true, [], [pData]))
        });
      }
    },
    /**
     * @description function runs when user want to search on files and folders
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _searchHandler: function _searchHandler(pEvent, pData) {
      if (this.alive === false) {
        return; // zombie
      }

      if (pEvent !== undefined) {
        if (this.searchOnTyping === false && pEvent.type === "input" && pEvent.target.value.length !== 0) {
          return;
        }
        if (this.searchOnTyping === false && pEvent.type === "keyup" && pEvent.keyCode !== 13) {
          //keyCode 13 = enter keys
          return;
        }
      }
      var newSearchQuery = this._prepareSearchQuery(this.m_root);
      var oldSearchQuery = this.element.find(".nixps-cloudflow-FolderView").FolderView("option", "search_query");
      if (Array.isArray(oldSearchQuery) && _.isEqual(oldSearchQuery, newSearchQuery)) {
        return; // no change
      }

      this.element.find(".nixps-cloudflow-FolderView").FolderView("option", {
        "cf_url": this.m_root,
        "search_query": newSearchQuery,
        "quickSearchOnly": newSearchQuery.includes("searchstring")
      });
    },
    _getUserSearchQuery: function _getUserSearchQuery() {
      var filter = this.element.find(".search_view_filter_select").length > 0 ? this.element.find(".search_view_filter_select").Select("getValue") : "";
      var searchString = filter + this.element.find("input.search-field").val();
      if (typeof searchString === "string" && searchString.length > 0) {
        return ["searchstring", "contains text like", searchString];
      }
      return [];
    },
    /**
     * @description Function runs when the user press a key, to detect and handle enters
     * @function
     * @private
     * @name nixps-cloudflow.FileChooser#_keyUpSaveNameInputHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _keyUpSaveNameInputHandler: function _keyUpSaveNameInputHandler(pEvent, pData) {
      if (pEvent !== undefined && [$.ui.keyCode.ENTER, $.ui.keyCode.NUMPAD_ENTER].includes(pEvent.which) && this.options.enableSaveAs === true) {
        var eventData = {
          files: this.getSelectedItems()
        };
        // if we are in save as mode, we need also to give the "save as" information
        var filename = this.element.find("input.saveNameInput").val();
        if (typeof filename !== "string") {
          // give support for error handling in higher levels
          // we may not handle this ourself
          eventData.filenameError = true;
          eventData.filenameErrorMessage = "not_a_string";
          eventData.candidateFileName = filename;
          eventData.candidateFileURL = this.m_root + filename;
          eventData.folderurl = this.m_root;
        } else if (filename.length <= 2) {
          // give support for error handling in higher levels
          // we may not handle this ourself
          eventData.filenameError = true;
          eventData.filenameErrorMessage = "length_too_small";
          eventData.candidateFileName = filename;
          eventData.candidateFileURL = this.m_root + filename;
          eventData.folderurl = this.m_root;
        } else {
          eventData.fileurl = this.m_root + filename;
          eventData.filenameExist = this._hasFile(filename);
          eventData.filenameError = false;
        }
        this._trigger("save", null, eventData);
      }
    },
    /**
     * @description function runs when user change the text in the savename input field
     * @function
     * @private
     * @name nixps-cloudflow.FileChooser#_inputSaveAsHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _inputSaveAsHandler: function _inputSaveAsHandler(pEvent, pData) {
      var filename = this.element.find("input.saveNameInput").val();
      if (typeof filename === "string") {
        this._trigger("changesavenameinput", null, {
          "filename": filename
        });
      }
    },
    /**
     * @description function runs when the list of asset has been drawn, inform others that we has just drawn
     * @function
     * @name nixps-cloudflow.FileChooser#_drawedHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _drawedHandler: function _drawedHandler(pEvent, pData) {
      this._trigger("draw", pEvent, pData);
    },
    /**
     * @description function runs when the preferences has been changed by children folder view component
     * @function
     * @name nixps-cloudflow.FileChooser#_preferencesChangedHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _preferencesChangedHandler: function _preferencesChangedHandler(pEvent, pData) {
      if ($.isPlainObject(pData.preferences)) {
        // merge preferences from folderView
        this.orderByPref.fileorder = pData.preferences.fileorder;
        this.orderByPref.fileasc = pData.preferences.fileasc;
        this.savePreferences();
      }
      pEvent.stopPropagation();
    },
    /**
     * @description Get the preferences from the backend
     * @function
     * @name nixps-cloudflow.FileChooser#_getPreferences
     * @private
     * @return {Deferred}
     */
    _getPreferences: function _getPreferences() {
      if (contextPref[this.context] !== undefined) {
        if (this.options.useUrlOfPreferences === true && typeof contextPref[this.context].assetPath === "string") {
          this.url = contextPref[this.context].assetPath;
        } else {
          this.url = "";
        }
        if (["icon", "list"].includes(contextPref[this.context].view)) {
          this.view = contextPref[this.context].view;
        } else if (["icon", "list"].includes(this.view) === false) {
          this.view = "icon"; // default
        }

        if ($.isPlainObject(contextPref[this.context].orderBy) && $.isEmptyObject(contextPref[this.context].orderBy) === false) {
          this.orderByPref = contextPref[this.context].orderBy;
        }
        return $.Deferred().resolve();
      }
      var that = this;
      return $.Deferred(function (pDefer) {
        api_async.preferences.get_for_current_user("com.nixps.chooser", "context." + that.context, function (pResult) {
          var defaultAssetPath = "";
          if (that.options.useUrlOfPreferences === true && $.isPlainObject(pResult.preferences) && typeof pResult.preferences.assetPath === "string" && pResult.preferences.assetPath.length > 0) {
            defaultAssetPath = pResult.preferences.assetPath;
            if (defaultAssetPath === "cloudflow://X") {
              defaultAssetPath = "";
            }
          }
          that.url = defaultAssetPath;
          if ($.isPlainObject(pResult.preferences) && ["icon", "list"].includes(pResult.preferences.view)) {
            that.view = pResult.preferences.view;
          }
          if (["icon", "list"].includes(that.view) === false) {
            that.view = "icon"; // default
          }

          if (pResult.preferences !== undefined && $.isPlainObject(pResult.preferences.orderBy) && $.isEmptyObject(pResult.preferences.orderBy) === false) {
            that.orderByPref = pResult.preferences.orderBy;
          }
          contextPref[that.context] = pResult.preferences;
          pDefer.resolve();
        }, function (pError) {
          pDefer.reject(pError);
        });
      });
    },
    /**
     * @description Save the preferences to the backend
     * @function
     * @private
     * @return {undefined}
     */
    _savePreferences: function _savePreferences() {
      this._delay(function () {
        var preferences = {
          assetPath: this.url,
          view: this.view,
          orderBy: this.orderByPref
        };
        contextPref[this.context] = preferences;
        if (window.api_async !== undefined && api_async.preferences !== undefined) {
          api_async.preferences.save_for_current_user(preferences, "com.nixps.chooser", "context." + this.context, function () {}, function () {});
        }
      });
    },
    /**
     * @description draw the component
     * @function
     * @private
     * @return {undefined}
     */
    _draw: function _draw() {
      this.element.empty().data("controller", this);
      var l_$extra_div = $("<div>").addClass("chooser");
      this.element.append(l_$extra_div);
      // save as panel
      if (this.options.enableSaveAs === true) {
        var savePanel = $("<div>").addClass("savePanel filechooser_panel");
        l_$extra_div.append(savePanel);
        var saveLabel = $("<span>").addClass("saveAsLabel")._t("nixps-cloudflow-FileChooser.saveas");
        savePanel.append(saveLabel).append($("<input>").attr("type", "text").attr("inputmode", "search").addClass("saveNameInput"));
        var inputValue = this.options.defaultSaveAsFileName; // default value
        if (typeof this.options.url === "string" && this.options.url.length > 2) {
          var filename = get_filename(this.options.url);
          if (typeof filename === "string" && filename.length > 2) {
            inputValue = filename; // overwrite default value
          }
        }

        savePanel.find("input.saveNameInput").val(inputValue);
      }
      // path
      var l_$path_view = $("<div>").addClass("path_view filechooser_panel").BreadCrumb({
        separatorHTML: "<span class=\"cf-icon cf-icon-chevron-down cf-rotate-270 separatorIcon\"></span>",
        callback: this._breadcrumbFolderClickHandler.bind(this),
        rootIcon: "<span class=\"cf-icon cf-icon-filestore rootIcon\"></span>"
      });
      l_$extra_div.append(l_$path_view);

      // extra filter
      var extraAssetFilter = false;
      if (Array.isArray(this.options.allowed_file_types)) {
        var file_types = this.options.allowed_file_types.filter(function (pType) {
          return typeof pType === "string" && pType.length > 0;
        });
        if (file_types.length > 0) {
          extraAssetFilter = ["mime_types", "in", file_types];
        }
      }
      if (Array.isArray(this.options.allowed_file_extensions)) {
        var file_extensions = this.options.allowed_file_extensions.filter(function (pType) {
          return typeof pType === "string" && pType.length > 0;
        });
        if (file_extensions.length > 0) {
          if (Array.isArray(extraAssetFilter)) {
            extraAssetFilter.push("and");
          } else {
            extraAssetFilter = [];
          }
          extraAssetFilter = extraAssetFilter.concat(["file_extension", "in", file_extensions]);
        }
      }
      l_$extra_div.append($("<div>").addClass("filechooser_view").FolderView({
        search_query: this.options.search_query,
        searchOnFolders: this.options.searchOnfolders,
        fileFilter: extraAssetFilter,
        foldersOnly: this.options.foldersOnly,
        columnsOnDefault: this.options.columns,
        columnsWhenSearching: this.options.columns,
        view: this.view,
        enableSelecting: true,
        enableMultipleSelection: this.options.multiple,
        fastMultipleSelection: true,
        deselectable: true,
        iconWidth: 64,
        loadTags: this.options.loadTags,
        tableBodyClasses: "cf-table-body-main cf-table-body-small",
        refreshDelay: 0
      }));

      // search
      var l_$search = $("<div>").addClass("search_view");
      var searchPanel = $("<input>").attr("type", "search").addClass("search-field cf-inlinesearch-small");
      l_$search.append(searchPanel);
      var searchTags;
      if (this.options.enableSearchFilter === true) {
        searchTags = $("<div>").addClass("search_view_filter");
        this._populateSearchTags(searchTags);
        l_$search.append(searchTags);
      }
      l_$extra_div.append(l_$search);
      if (searchTags !== undefined) {
        this._setTagsIcon();
      }

      // action buttons
      if (this.options.enableSaveButton === true || this.options.enableCancelButton === true || this.options.enableSelectButton === true) {
        var actionPanel = $("<div>").addClass("actionPanel cf-buttonbar");
        l_$extra_div.append(actionPanel);
        if (this.options.enableCancelButton === true) {
          actionPanel.append($("<button>").attr("type", "button").addClass("cf-button-secondary cancelButton").attr("data-action", "cancel").text($.i18n._("nixps-cloudflow-FileChooser.cancel")));
        }
        if (this.options.enableSaveButton === true) {
          actionPanel.append($("<button>").attr("type", "button").addClass("cf-button-main saveButton").attr("data-action", "save").text($.i18n._("nixps-cloudflow-FileChooser.save")));
        }
        if (this.options.enableSelectButton === true) {
          actionPanel.append($("<button>").attr("type", "button").addClass("cf-button-main selectButton").attr("data-action", "select").text($.i18n._("nixps-cloudflow-FileChooser.select")));
        }
      }

      // buttons to switch views
      var l_$selector = $("<div>").addClass("view_selector filechooser_panel");
      l_$extra_div.append(l_$selector);
      var l_$selector_icon = $("<button>").attr("type", "button").addClass("icon_view_selector noselect cf-select");
      if (typeof this.options.chooseIconButtonIcon === "string" && this.options.chooseIconButtonIcon.length > 0) {
        l_$selector_icon.prepend($("<span>").addClass(this.options.chooseIconButtonIcon));
      }
      if (typeof this.options.chooseIconButtonText === "string" && this.options.chooseIconButtonText.length > 0) {
        l_$selector_icon._t(this.options.chooseIconButtonText);
      }
      l_$selector.append(l_$selector_icon);
      var l_$selector_list = $("<button>").attr("type", "button").addClass("list_view_selector noselect");
      if (typeof this.options.chooseListButtonIcon === "string" && this.options.chooseListButtonIcon.length > 0) {
        l_$selector_list.prepend($("<span>").addClass(this.options.chooseListButtonIcon));
      }
      if (typeof this.options.chooseListButtonText === "string" && this.options.chooseListButtonText.length > 0) {
        l_$selector_list._t(this.options.chooseListButtonText);
      }
      l_$selector.append(l_$selector_list);
      if (this.view === "icon") {
        this.show_icon_view();
      } else {
        // option view is controlled in controlOptions function
        this.show_list_view();
      }
      this.element.find("input.saveNameInput").trigger("select");
    },
    /**
     * @description add extra data to the files and folders data object
     * @function
     * @private
     * @param {array} pAssets
     * @return {array}
     */
    _extendAssetData: function _extendAssetData(pAssets) {
      if (Array.isArray(pAssets) === false) {
        throw new Error("argument pAssets must be an array");
      }
      // loop over all assets and add the missing data to each element, asset
      for (var i = 0; i < pAssets.length; i++) {
        // if element has cloudflow parameter
        if (pAssets[i].cloudflow !== undefined) {
          // if it is a folder
          if (typeof pAssets[i].cloudflow.folder === "string") {
            pAssets[i].folder = true;
            pAssets[i].filetype = "folder";
            if (pAssets[i].parent === true || pAssets[i].cloudflow !== undefined && pAssets[i].cloudflow.parent === true) {
              pAssets[i].url = this.m_root;
            } else if (Array.isArray(pAssets[i].path)) {
              pAssets[i].url = pAssets[i].path.join("/");
            } else if (typeof pAssets[i].cloudflow.enclosing_folder === "string") {
              // remove the beginning substring "cloudflow://" 12 chars long
              // and remove last "/" char
              pAssets[i].url = pAssets[i].cloudflow.enclosing_folder.slice(12, -1);
            } else {
              // fallback
              pAssets[i].url = "";
            }
            // if it is a file
          } else if (typeof pAssets[i].cloudflow.file === "string") {
            pAssets[i].folder = false;
            pAssets[i].name = pAssets[i].file_name;
            if (Array.isArray(pAssets[i].path)) {
              pAssets[i].url = pAssets[i].path.join("/");
            } else if (typeof pAssets[i].cloudflow.enclosing_folder === "string") {
              // remove the beginning substring "cloudflow://" 12 chars long
              // and remove last "/" char
              pAssets[i].url = decodeURL(pAssets[i].cloudflow.enclosing_folder.slice(12, -1));
            } else {
              // fallback
              pAssets[i].url = "";
            }
          }
        }
      }
      return pAssets;
    },
    _prepareSearchQuery: function _prepareSearchQuery(pUrl) {
      var userSearchQuery = this._getUserSearchQuery();
      if (this.options.rootFolders.length > 0 || this.options.rootFiles.length > 0) {
        for (var i = 0; i < this.options.rootFolders.length; i++) {
          if (pUrl.indexOf(this.options.rootFolders[i]) === 0) {
            return userSearchQuery;
          }
        }
        if (userSearchQuery.length > 0) {
          var foldersQuery = [];
          if (this.options.rootFolders.length > 0) {
            for (var i = 0; i < this.options.rootFolders.length; i++) {
              foldersQuery = foldersQuery.concat(["cloudflow.folder", "begins with", this.options.rootFolders[i]]);
              foldersQuery.push("or");
            }
          }
          var rootQuery = [];
          if (Array.isArray(this.options.rootFiles) && this.options.rootFiles.length > 0) {
            rootQuery = foldersQuery.concat(["cloudflow.file", "in", this.options.rootFiles]);
            rootQuery.push("and");
          }
          rootQuery.push("(");
          userSearchQuery.push(")");
          return rootQuery.concat(userSearchQuery);
        } else {
          return ["cloudflow.folder", "in", this.options.rootFolders, "or", "cloudflow.file", "in", this.options.rootFiles];
        }
      }
      return userSearchQuery;
    },
    /**
     * @description function runs when user click on a folder on the breabCrumb
     * @function
     * @private
     * @param {string} pUrl The url to go
     * @returns {undefined}
     */
    _breadcrumbFolderClickHandler: function _breadcrumbFolderClickHandler(pUrl) {
      if (typeof pUrl !== "string" || pUrl.length < 0) {
        throw new Error("input parameter url must be a valid string");
      }
      // reset search
      this.element.find("input.search-field").val("");
      this.set_url(pUrl);
    },
    refresh: function refresh() {
      this._searchHandler();
    },
    /**
     * @name nixps-cloudflow.FileChooser#getCurrentFolder
     * @description Get the url of the root folder
     * @function
     * @return {String}
     */
    getCurrentFolder: function getCurrentFolder() {
      return this.get_url();
    },
    /**
     * @name nixps-cloudflow.FileChooser#get_url
     * @description Get the url of the parent url where you are lokking at.
     * @function
     * @return {String}
     */
    get_url: function get_url() {
      return this.m_root;
    },
    /**
     * @name nixps-cloudflow.FileChooser#set_url
     * @description Go to a specific url
     * @function
     * @param {string} p_url
     * @return {undefined}
     */
    set_url: function set_url(pUrl) {
      if (typeof pUrl !== "string") {
        throw new Error("parameter url must be a string");
      }
      if (pUrl === "" || pUrl === "X" || pUrl === "cloudflow://" || pUrl === "cloudflow://X") {
        pUrl = "";
      } else if (pUrl.length > 0 && pUrl.indexOf("cloudflow://") !== 0) {
        pUrl = "cloudflow://" + pUrl;
      }

      //reset the search filter
      if (this.options.enableSearchFilter === true) {
        this.element.find(".search_view_filter .nixps-cloudflow-Select").Select("setValue", "");
        this._setTagsIcon();
      }

      // save the root url of the view
      this.m_root = get_path(pUrl);
      this.element.find(".nixps-cloudflow-FolderView").FolderView({
        cf_url: this.m_root,
        search_query: this._prepareSearchQuery(this.m_root),
        quickSearchOnly: undefined
      });
      var breadCrumbPath = this.m_root;
      if (this.options.rootFolders.length > 0 || this.options.rootFiles.length > 0) {
        breadCrumbPath = ""; //for the moment disable, we will see later how we will fix enhance this
      }

      this.element.find(".path_view").BreadCrumb("update_root", breadCrumbPath);
      if (pUrl.length > 0 && pUrl !== this.url) {
        this.url = pUrl;
        this.savePreferences();
      }
      this._trigger("urlUpdate", null, {
        url: pUrl
      });
    },
    /**
     * @deprecated
     */
    select_files: function select_files() {},
    /**
     * @name nixps-cloudflow.FileChooser#getSelectedItems
     * @description Get an array of all selected files and folders
     * @function
     * @return {Array}
     */
    getSelectedItems: function getSelectedItems() {
      var items = this.element.find(".nixps-cloudflow-FolderView").FolderView("getSelectedItems");
      if (Array.isArray(items) && items.length > 0) {
        return items.map(function (elem) {
          if (elem.cloudflow !== undefined) {
            if (typeof elem.cloudflow.file === "string") {
              return elem.cloudflow.file;
            } else if (typeof elem.cloudflow.folder === "string") {
              return elem.cloudflow.folder;
            }
          }
        }).filter(function (i) {
          return i !== undefined;
        });
      } else {
        return [];
      }
    },
    /**
     * @description Switch from icon view to list view
     * @function
     * @name nixps-cloudflow.FileChooser#show_list_view
     * @returns {undefined}
     */
    show_list_view: function show_list_view() {
      this.element.find(".icon_view_selector").removeClass("cf-select");
      this.element.find(".list_view_selector").addClass("cf-select");
      var currentViewOption = this.element.find(".nixps-cloudflow-FolderView").FolderView("option", "view");
      if (currentViewOption !== "list") {
        this.element.find(".nixps-cloudflow-FolderView").FolderView("option", "view", "list");
      }
    },
    /**
     * @description Switch from list view to icon view
     * @function
     * @name nixps-cloudflow.FileChooser#show_icon_view
     * @returns {undefined}
     */
    show_icon_view: function show_icon_view() {
      this.element.find(".icon_view_selector").addClass("cf-select");
      this.element.find(".list_view_selector").removeClass("cf-select");
      var currentViewOption = this.element.find(".nixps-cloudflow-FolderView").FolderView("option", "view");
      if (currentViewOption !== "icon") {
        this.element.find(".nixps-cloudflow-FolderView").FolderView("option", "view", "icon");
      }
    },
    /**
     * @description control if the current folder contains a file or folder with a specific filename
     * @function
     * @private
     * @param {string} pFileName
     * @returns {Boolean} true if a file or folder with the same filename exists, false otherwise
     */
    _hasFile: function _hasFile(pFileName) {
      if (typeof pFileName === "string" && pFileName.length > 0) {
        return this.element.find(".nixps-cloudflow-FolderView").FolderView("containsFile", pFileName);
      }
      return false;
    },
    /**
     * @description populate the select for the search input with ways to filter the search 
     * @function
     * @private
     * @param {Element} pDOM the filter element added in front of the input
     * @returns {undefined}
     */
    _populateSearchTags: function _populateSearchTags(pDOM) {
      this.element.find("search_view").addClass("filter_icon_empty");
      pDOM.append($("<span>").addClass("search_view_filter_icon"));
      pDOM.append($("<div>").addClass("search_view_filter_select").Select({
        keyValues: {
          "": "Any",
          "folder:": "folder:"
        }
      }));
    },
    /**
     * @description set the correct icon for the dropdown search filter on change 
     * @function
     * @private
     * @param {Event} pEvent change event for the select
     * @param {Object} pData
     * @returns {undefined}
     */
    _setTagsIcon: function _setTagsIcon(pEvent, pData) {
      var iconDOM = this.element.find(".search_view_filter_icon");
      var selectDOM;
      if (pEvent === undefined) {
        selectDOM = this.element.find(".search_view_filter .nixps-cloudflow-Select");
      } else {
        selectDOM = $(pEvent.target).closest(".nixps-cloudflow-Select");
      }
      var value = selectDOM.Select("getValue");
      iconDOM.removeClass();
      iconDOM.addClass("search_view_filter_icon");
      switch (value) {
        case "folder:":
          this.element.find(".search_view").removeClass("filter_icon_empty");
          iconDOM.addClass(["cf-icon", "cf-icon-folder-icon"]);
          break;
        case "":
          this.element.find(".search_view").addClass("filter_icon_empty");
          break;
        default:
          console.error("FileChooser: filter tags value not supported: defaulting to any");
      }
      if (pEvent !== undefined) {
        //call searchHandler when the function was called because of a change event
        this._searchHandler();
      }
    },
    /**
     * @description call resize function to draw the list panel if it is created when table was hidden
     * @deprecated was needed for slickgrid
     * @returns {undefined}
     */
    resizeCanvas: function resizeCanvas() {},
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "view") {
        if (pValue === "list") {
          this._super("view", "list");
          this.show_list_view();
        } else if (pValue === "icon") {
          this._super("view", "icon");
          this.show_icon_view();
        }
      } else {
        this._super(pKey, pValue);
      }
      this._controlOptions();
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.widgetFullName).css("position", "");
      this._super();
    },
    /**
     * @description control the input options
     * @function
     * @private
     * @return {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.multiple !== "boolean") {
        throw new Error("FileChooser: input option multiple must be a boolean");
      }
      if (typeof this.options.foldersOnly !== "boolean") {
        throw new Error("FileChooser: input option foldersOnly must be a boolean");
      }
      if (Array.isArray(this.options.rootFolders) === false) {
        throw new Error("FileChooser: input option rootFolders must be an array");
      }
      if (Array.isArray(this.options.rootFiles) === false) {
        throw new Error("FileChooser: input option rootFiles must be an array");
      }
      if (["icon", "list"].includes(this.options.view) === false && this.options.view !== null) {
        throw new Error("FileChooser: input option view must be \"icon\" or \"list\" or null");
      }
      if (!Array.isArray(this.options.allowed_file_types)) {
        throw new Error("FileChooser: input option allowed_file_types must be a array");
      }
      if (typeof this.options.enableSaveAs !== "boolean") {
        throw new Error("FileChooser: input option enableSaveAs must be a boolean");
      }
      if (typeof this.options.defaultSaveAsFileName !== "string" || this.options.defaultSaveAsFileName.length <= 0) {
        throw new Error("FileChooser: input option defaultSaveAsFileName must be a valid not empty string");
      }
      if (typeof this.options.enableSaveButton !== "boolean") {
        throw new Error("FileChooser: input option enableSaveButton must be a boolean");
      }
      if (typeof this.options.enableCancelButton !== "boolean") {
        throw new Error("FileChooser: input option enableCancelButton must be a boolean");
      }
      if (typeof this.options.useUrlOfPreferences !== "boolean") {
        throw new Error("FileChooser: input option useUrlOfPreferences must be a boolean");
      }
      if (typeof this.options.loadTags !== "boolean") {
        throw new Error("FileChooser: input option loadTags must be a boolean");
      }
      if (typeof this.options.enableSearchFilter !== "boolean") {
        throw new Error("FileChooser: input option enableSearchFilter must be a boolean");
      }
    },
    clearCaches: function clearCaches() {
      contextPref = {};
      staticPref = {};
    }
  });
})(jQuery);

},{"../../../nebulaportal/js/assetview/nixps-asset-BreadCrumb.js":403,"../../../polyfill/polyfill.js":433,"../../FolderView/js/nixps-cloudflow-FolderView-main.js":136,"../../IconView/js/nixps-cloudflow-IconView.js":171,"../../IconView/js/nixps-cloudflow-ReaderView.js":172,"../../ListView/js/nixps-cloudflow-ListView.js":181,"../../Table/js/nixps-cloudflow-Table.js":218}],134:[function(require,module,exports){
"use strict";

module.exports = {
  /**
   * Different types if FolderViews
   * @readonly
   * @enum {string} 
   **/
  types: Object.freeze({
    /** grid view, aggally spead over the page */
    "ICON": "icon",
    /** table view */
    "LIST": "list",
    /** grid view grouped by two, like pages of a book */
    "READER": "reader",
    /** automatic switching between ICON and READER depending of the content */
    "ICON_CHOOSER": "iconChooser"
  })
};

},{}],135:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 * README
 * 
 * operators: are special keywords. If the user type this words followed by other text. 
 * The search will be handle differend. 
 *  tags:    -> all files with "contains text like" will be listed
 *  status   -> all files with has a status "contains text like" will be listed 
 */
/**
 * @description magic search word for tags
 * @type String
 */
var specialTag = "tags:";
/**
 * @description magic search word for status /approvals
 * @type String
 */
var specialStatus = "status:";
/**
 * @description magic search word for folder
 * @type String
 */
var specialFolder = "folder:";
/**
 * @description name of the database fields of tags, were we store the tag string itself
 * @type String
 */
var tagFieldName = "name";
/**
 * @description name of the database fields of tags, were we store the tag string itself
 * @type String
 */
var statusFieldName = "approvals.assessment";
/**
 * @description the technical name of to distinguage the tag fields with other fields in the query maker
 * @type String
 */
var kTagDataField = "metadata.tags";

/**
 * @description the key name of the quick search key:
 * @type String
 */
var kQuickSearchString = "searchstring";
var kBindingsKeys = {
  "equal to": "equal to",
  "not equal to": "not equal to",
  "contains": "contains",
  "begins with": "begins with",
  "ends with": "ends with",
  "is like": "is like",
  "contains text like": "contains text like",
  "begins like": "begins like",
  "ends like": "ends like",
  "less than": "less than",
  "less than or equal to": "less than or equal to",
  "greater than": "greater than",
  "greater than or equal to": "greater than or equal to",
  "exists": "exists",
  "does not exist": "does not exist",
  "in": "in",
  "contains element matching": "contains element matching"
};
/**
 * @class QueryUtil
 * @description this class provides help functions to extracting tag querys.
 * usely you got a general query with tag querys inside. This function gifs you unit function to work with them
 * @returns {nixps.cloudflow.QueryUtil}
 */
var QueryUtil = function QueryUtil() {};
QueryUtil.prototype = {
  constructor: QueryUtil,
  modifyQuery: function modifyQuery(pQuery, pFieldToExclude, pFieldsToReplace) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      if (!Array.isArray(pFieldToExclude)) {
        pFieldToExclude = [];
      }
      if (_typeof(pFieldsToReplace) !== "object" || pFieldsToReplace === null) {
        pFieldsToReplace = {};
      }
      var outputQuery = pQuery;
      var subIndex = -1;
      // remove sub as query
      var newOutputQuery = [];
      for (var index = 0; index < outputQuery.length; index++) {
        if (pFieldToExclude.some(function (pField) {
          if (typeof pField.test === "function") {
            return pField.test(outputQuery[index]);
          }
          return pField === outputQuery[index];
        }) && typeof kBindingsKeys[outputQuery[index + 1]] === "string") {
          subIndex = index;
          continue;
        } else if (subIndex > -1 && index - subIndex < 3) {
          continue;
        } else if (pFieldsToReplace[outputQuery[index]] !== undefined && typeof kBindingsKeys[outputQuery[index + 1]] === "string") {
          newOutputQuery.push(pFieldsToReplace[outputQuery[index]]);
          continue;
        }
        newOutputQuery.push(outputQuery[index]);
      }
      return this.removeEmptyStuff(newOutputQuery);
    } else {
      return [];
    }
  },
  folderOnly: function folderOnly(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var i = pQuery.indexOf(kQuickSearchString);
      if (pQuery[i + 2].substring(0, specialFolder.length) === specialFolder) {
        return true;
      }
    }
    return false;
  },
  containsFolderQuery: function containsFolderQuery(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      if (pQuery.includes("folder_name")) {
        return true;
      }
    }
    return false;
  },
  translateToFileQuery: function translateToFileQuery(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var outputQuery = pQuery;
      var subIndex = -1;
      // remove sub as query
      var newOutputQuery = [];
      for (var index = 0; index < outputQuery.length; index++) {
        if (["cloudflow.folder", "folder_name"].includes(outputQuery[index])) {
          subIndex = index;
          continue;
        } else if (subIndex > -1 && index - subIndex < 3) {
          continue;
        }
        newOutputQuery.push(outputQuery[index]);
      }
      return this.removeEmptyStuff(newOutputQuery);
    } else {
      return [];
    }
  },
  /**
   * @description translate some keys and remove some keys, to get a optimal query
   * @funtion
   * @name QueryUtil.translateToFolderQuery
   * @param {type} pQuery
   * @returns {Array}
   */
  translateToFolderQuery: function translateToFolderQuery(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var outputQuery = pQuery;
      var subIndex = -1;
      // remove sub as query
      var newOutputQuery = [];
      for (var index = 0; index < outputQuery.length; index++) {
        if (["sub", "cloudflow.file", "filetype", "mime_types", "file_extension"].includes(outputQuery[index]) && typeof kBindingsKeys[outputQuery[index + 1]] === "string") {
          subIndex = index;
          continue;
        } else if (subIndex > -1 && index - subIndex < 3) {
          continue;
        }
        newOutputQuery.push(outputQuery[index]);
      }
      // replace all "searchstrings" to "name"
      var newOutputQuery2 = [];
      for (var index = 0; index < newOutputQuery.length; index++) {
        if (newOutputQuery[index] === kQuickSearchString && typeof kBindingsKeys[newOutputQuery[index + 1]] === "string") {
          newOutputQuery2.push("name");
        } else if (newOutputQuery[index] === "folder_name" && typeof kBindingsKeys[newOutputQuery[index + 1]] === "string") {
          newOutputQuery2.push("name");
        } else {
          newOutputQuery2.push(newOutputQuery[index]);
        }
      }
      return this.removeEmptyStuff(newOutputQuery2);
    } else {
      return [];
    }
  },
  /**
   * @description search if there are special keywords operator words, if they are? it returns the filtered and transformed query
   * if no special keywords operators words are found a empty array is returned
   * @function
   * @param {Array.<String>} pQuery - the query to search in.
   * @returns {Array}
   */
  getOperatorsQuery: function getOperatorsQuery(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      // if special key word is the starting substring of the "searchstring"
      // query ea ["searchstring" , "contains text like", "status:waiting" ]
      var i = pQuery.indexOf(kQuickSearchString);
      if (i >= 0 && typeof pQuery[i + 2] === "string") {
        if (pQuery[i + 2].search(specialStatus) === 0) {
          return this.getStatusOperatorQuery(pQuery);
        } else if (pQuery[i + 2].search(specialTag) === 0) {
          return this.getTagOperatorQuery(pQuery);
        } else if (pQuery[i + 2].search(specialFolder) === 0) {
          return this.getFolderOperatorQuery(pQuery);
        } else {
          return [];
        }
      } else {
        return [];
      }
    } else {
      return [];
    }
  },
  replaceOperatorsQuery: function replaceOperatorsQuery(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var operatorQuery = this.getOperatorsQuery(pQuery);
      if (operatorQuery.length === 0) {
        // there are no operators in there
        return pQuery;
      }
      // remove operators
      var noOperatorQuery = this.removeQuery(pQuery, "searchstring");
      //add operatorQuery
      if (noOperatorQuery.length === 0) {
        return operatorQuery;
      }
      operatorQuery.push("and");
      return operatorQuery.concat(noOperatorQuery);
    } else {
      return [];
    }
  },
  /**
   * @description replace every item to a new item
   * @function
   * @param {array} pQuery the query to be handled
   * @param {type} pOldName the old name to be replaced
   * @param {type} pNewName the new name that must be replaced to
   * @return {Array}
   */
  replaceQueryArguments: function replaceQueryArguments(pQuery, pOldName, pNewName) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var output = [];
      for (var i = 0; i < pQuery.length; i++) {
        if (pQuery[i] === pOldName) {
          output.push(pNewName);
        } else {
          output.push(pQuery[i]);
        }
      }
      return output;
    } else {
      return [];
    }
  },
  /**
   * @description get the query for status/approvals, if uses put the special keystring "status:"
   * @function 
   * @param {array} pQuery - the generale query from upside 
   * @returns {Array} Query - the transformed query to search in approvals/status of files
   */
  getStatusOperatorQuery: function getStatusOperatorQuery(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var i = pQuery.indexOf(kQuickSearchString);
      if (i >= 0 && typeof pQuery[i + 2] === "string" && pQuery[i + 2].search(specialStatus) === 0) {
        var searchText = pQuery[i + 2].slice(specialStatus.length);
        if (searchText === "") {
          return [statusFieldName, pQuery[i + 1], ""];
        } else if ("rejected".search(searchText) === 0) {
          return [statusFieldName, pQuery[i + 1], "reject"];
        } else if ("accept".search(searchText) === 0) {
          return [statusFieldName, pQuery[i + 1], "accept"];
        } else if ("waiting".search(searchText) === 0 || "pending".search(searchText) === 0) {
          return [statusFieldName, pQuery[i + 1], "pending"];
        } else {
          return [];
        }
      }
      return [];
    }
    return [];
  },
  /**
   * @description get the query for tags, if uses put the special string "tags:"
   * @function 
   * @param {array} pQuery - the generale query from upside 
   * @returns {Array} Query - the transformed query to search in tags
   */
  getTagOperatorQuery: function getTagOperatorQuery(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var i = pQuery.indexOf(kQuickSearchString);
      if (i >= 0 && pQuery[i + 2].search(specialTag) === 0) {
        return [tagFieldName, pQuery[i + 1], pQuery[i + 2].slice(specialTag.length)];
      }
      return [];
    }
    return [];
  },
  /**
   * @description get the query for folders, if uses put the special string "folder:"
   * @function 
   * @param {array} pQuery - the generale query from upside 
   * @returns {Array} Query - the transformed query to search in tags
   */
  getFolderOperatorQuery: function getFolderOperatorQuery(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var i = pQuery.indexOf(kQuickSearchString);
      if (i >= 0 && pQuery[i + 2].search(specialFolder) === 0) {
        return [kQuickSearchString, pQuery[i + 1], pQuery[i + 2].slice(specialFolder.length)];
      }
      return [];
    }
    return [];
  },
  /**
   * @desc get the query of tags, we want only the tag query, remove the rest
   * @param {type} pQuery - the query to cleanup, the querywith to must information 
   * @returns {Array} the tag query, with only his information 
   */
  extractTagQuery: function extractTagQuery(pQuery) {
    return this.extractQuery(pQuery, kTagDataField, tagFieldName);
  },
  /**
   * 
   * @param {array | query} pQuery
   * @param {string} pRemoveFieldName The name of the inputfield passed by the search query, to be filtered
   * @param {string} pNewFieldName The name of the field in the returned query
   * @returns {Array}
   */
  extractQuery: function extractQuery(pQuery, pRemoveFieldName, pNewFieldName) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var tagIndex = null;
      // ex . ["ddd", "metadata.tag" , "eq", "zomer", "and", "name" , ... ]
      var output = [];
      for (var index = 0; index < pQuery.length; index++) {
        var elem = pQuery[index];
        if (elem === "(" || elem === ")") {
          output.push(elem);
        } else if (elem === pRemoveFieldName) {
          // copy element
          if (tagIndex !== null) {
            // tagIndex is not null we are not the first element
            tagIndex = index;
            var prevElem = pQuery[index - 1];
            if (prevElem === "(") {
              if (index >= 2) {
                output[output.length - 1] = pQuery[index - 2];
                output.push("(");
              }
            } else {
              output.push(prevElem);
            }
            output.push(pNewFieldName);
          } else {
            //tagIndex is null, we have the first tag 
            tagIndex = index;
            output.push(pNewFieldName);
          }
        } else if (tagIndex !== null && index - tagIndex < 3) {
          output.push(elem); // add all two other equations stuff
        } else {}
      }
      ;
      output = this.removeEmptyStuff(output);
      return output;
    } else {
      return [];
    }
  },
  /**
   * @description remove all the operator tag query information
   * @param {type} pQuery - the query with to must information that must be filtered 
   * @returns {Array.<String>} the filterd query, 
   * the query with no tag information
   */
  removeTagOperatorQuery: function removeTagOperatorQuery(pQuery) {
    // look if tags start with "tags:"
    return this.removeQuery(pQuery, function (queryField) {
      return typeof queryField === "string" && queryField.substring(0, specialTag.length) === specialTag;
    });
  },
  /**
   * @description remove all the operator status query information
   * @param {type} pQuery - the query with to must information that must be filtered 
   * @returns {Array.<String>} the filterd query, 
   * the query with no tag information
   */
  removeStatusOperatorQuery: function removeStatusOperatorQuery(pQuery) {
    // look if tags start with "tags:"
    return this.removeQuery(pQuery, function (queryField) {
      return typeof queryField === "string" && queryField.substring(0, specialStatus.length) === specialStatus;
    });
  },
  /**
   * @description remove all the tag query information
   * @param {type} pQuery - the query with to must information that must be filtered 
   * @returns {Array.<String>} the filterd query, 
   * the query with no tag information
   */
  removeTagQuery: function removeTagQuery(pQuery) {
    return this.removeQuery(pQuery, kTagDataField);
  },
  /**
   * @description remove a subquery of the query
   * @param {Array | query} pQuery
   * @param {string} pRemoveFieldName the name of the column of the subquery we want to remove
   * @returns {Array.<String>}
   */
  removeQuery: function removeQuery(pQuery, pRemoveFieldName) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      var compareFunction;
      if (typeof pRemoveFieldName === "function") {
        compareFunction = pRemoveFieldName;
      } else {
        compareFunction = function compareFunction(a) {
          return a === pRemoveFieldName;
        };
      }
      var tagIndex = null;
      // ex. ["ddd", "metadata.tag" , "eq", "zomer", "and", "name" , ... ]
      var outputQuery = [];
      for (var index = 0; index < pQuery.length; index++) {
        if (compareFunction(pQuery[index])) {
          // copy element
          tagIndex = index; // init tagindex, to detect the two other and remove 
          continue; // return nothing, remove from array
        } else if (tagIndex !== null && index - tagIndex < 3) {
          continue; // remove two other equations stuff
        } else {
          outputQuery.push(pQuery[index]); // has nothing to do with tags, put in array
        }
      }
      // now we have removed everything that has to do with tags
      // we now still have empty bracklets and empty holes. 
      // This is a malformed query,
      // next line removes empty holes and reform the query to a good formed one.
      outputQuery = this.removeEmptyStuff(outputQuery);
      return outputQuery;
    } else {
      return [];
    }
  },
  addEnclosingFolderToSearchQuery: function addEnclosingFolderToSearchQuery(pQuery, pEnclosingFolder, pRecursive) {
    var encodingFolders;
    if (pEnclosingFolder === null || pEnclosingFolder === undefined) {
      encodingFolders = [];
    } else if (Array.isArray(pEnclosingFolder)) {
      encodingFolders = pEnclosingFolder;
    } else {
      encodingFolders = [pEnclosingFolder];
    }
    if (encodingFolders.length === 0) {
      return pQuery;
    }
    var enclosingFolderQuery = [];
    if (pRecursive === undefined) {
      for (var i = 0; i < encodingFolders.length; i++) {
        enclosingFolderQuery = enclosingFolderQuery.concat(["cloudflow.enclosing_folder", "begins with", encodingFolders[i]]);
      }
    } else if (pRecursive === false) {
      for (var i = 0; i < encodingFolders.length; i++) {
        enclosingFolderQuery = enclosingFolderQuery.concat(["cloudflow.enclosing_folder", "equal to", encodingFolders[i]]);
      }
    } else if (pRecursive === true) {
      for (var i = 0; i < encodingFolders.length; i++) {
        enclosingFolderQuery = enclosingFolderQuery.concat(["(", "cloudflow.enclosing_folder", "not equal to", encodingFolders[i], "and", "cloudflow.enclosing_folder", "begins with", encodingFolders[i], ")"]);
      }
    }
    if (encodingFolders.length > 1) {
      enclosingFolderQuery.unshift("(");
      enclosingFolderQuery.shift(")");
    }
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      pQuery.push("and");
      return pQuery.concat(enclosingFolderQuery);
    } else {
      return enclosingFolderQuery;
    }
  },
  isInRoots: function isInRoots(pURL, pRootFolders, pRootFiles) {
    if (Array.isArray(pRootFolders) && pRootFolders.length > 0) {
      for (var i = 0; i < pRootFolders.length; i++) {
        if (pURL.substring(0, pRootFolders[i].length) === pRootFolders[i]) {
          return true;
        }
      }
    }
    if (Array.isArray(pRootFiles) && pRootFiles.length > 0 && pRootFiles.includes(pURL)) {
      return true;
    }
    return false;
  },
  isQuickSearchQuery: function isQuickSearchQuery(pQuery) {
    return Array.isArray(pQuery) && pQuery.length === 3 && pQuery[0] === kQuickSearchString && pQuery[1] === "contains text like";
  },
  /**
   * @description removes empty bracklets and useless "and"s
   * @param {array | query} pQuery
   * @returns {Array}
   */
  removeEmptyStuff: function removeEmptyStuff(pQuery) {
    if (Array.isArray(pQuery) && pQuery.length > 0) {
      pQuery = this._removeAnd(pQuery);
      // loop over all the query and removes the bracklets, 
      // if something is removed and can creating new empty bracklets
      // so redo until we have nothing to remove
      for (var i = 0; i < pQuery.length; i++) {
        if (pQuery[i] === "(") {
          if (pQuery[i + 1] === ")") {
            // removing "(" ")"
            if (pQuery[i - 1] === "and" || pQuery[i - 1] === "or") {
              // removing "and" "(" ")"
              delete pQuery[i - 1];
            }
            delete pQuery[i];
            delete pQuery[i + 1];
            i++;
          } else if (pQuery[i + 1] === "and" || pQuery[i + 1] === "or") {
            // removing "(" "and"
            delete pQuery[i + 1];
            i++;
          }
        } else if (pQuery[i] === ")" && (pQuery[i - 1] === "and" || pQuery[i - 1] === "or")) {
          // removing  "and" ")"
          delete pQuery[i - 1];
        }
      }
      // deleting gives undefineds
      // removing undefineds
      var output = [];
      for (var i = 0; i < pQuery.length; i++) {
        if (pQuery[i] !== undefined) {
          output.push(pQuery[i]);
        }
      }
      // are there changes?
      if (output.length < pQuery.length) {
        // yes there are changes, redo everything
        return this.removeEmptyStuff(output);
      } else {
        // no changes, return end result
        return output;
      }
    } else {
      return [];
    }
  },
  /**
   * @description removes the too many "and"
   * @param {type} pQuery
   * @returns {Array} a better query
   */
  _removeAnd: function _removeAnd(pQuery) {
    var tempQuery = [];
    for (var index = 0; index < pQuery.length; index++) {
      if ((pQuery[index] === "and" || pQuery[index] === "or") && (pQuery[index + 1] === "and" || pQuery[index + 1] === "or")) {
        // remove the "and" if there is a other afterwards.
        // if there is a other, other afterwards it will also be removed,
        // but the last one will not be removed
        continue;
      }
      tempQuery.push(pQuery[index]); // otherwards add to array
    }
    // if array begins with "and" remove it.
    if (tempQuery[0] === "and" || tempQuery[0] === "or") {
      delete tempQuery[0];
    }
    // if array ends with "and" remove it.
    if (tempQuery[tempQuery.length - 1] === "and" || tempQuery[tempQuery.length - 1] === "or") {
      delete tempQuery[tempQuery.length - 1];
    }
    // all the removes. changes the array elements to undefined. 
    // the array length didn"t change, it contains just undefineds.
    // in the next line we removes the undefineds
    var output = [];
    for (var i = 0; i < tempQuery.length; i++) {
      if (tempQuery[i] !== undefined) {
        output.push(tempQuery[i]);
      }
    }
    return output;
  }
};
module.exports = QueryUtil;

},{}],136:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

/* triggers: */
/* - refresh-finished */
/* - select */
(function ($) {
  require("../../../polyfill/polyfill.js");
  var QueryUtil = require("./QueryUtil.js");
  var Query = require("../../Table/js/Query.js");
  var Sites = require("../../Sites/js/Sites.js");
  require("../../CombinedView/js/nixps-cloudflow-CombinedView.js");
  var FolderViews = require("./FolderViews.js");
  var Device = require("../../PWA/js/Device.js");

  /**
   * @description translate a orderby array for files to folders
   * @private
   * @param {array} pFileOrderby
   * @returns {Array} a orderBy for folders call
   */
  function translateFileToFolderOrderBy(pFileOrderby) {
    var folderOrderBy = new Array(pFileOrderby.length);
    for (var i = 0; i < pFileOrderby.length; i++) {
      if (pFileOrderby[i] === "file_name") {
        folderOrderBy[i] = "name";
      } else if (pFileOrderby[i] === "file_size") {
        folderOrderBy[i] = "size";
      } else {
        folderOrderBy[i] = pFileOrderby[i];
      }
    }
    return folderOrderBy;
  }
  ;

  /**
   * @description add a default orderby query as second sorting
   * @private
   * @param {array} pOrderBy
   * @returns {Array}
   */
  function addDefaultOrderBy(pOrderBy) {
    if (Array.isArray(pOrderBy) && pOrderBy.length > 0) {
      if (pOrderBy[0] !== "file_name") {
        // if first is not file_name add file_name as second
        return pOrderBy.concat(["file_name", "ascending"]);
      } else {
        // first sorting is filename, do not add sorting, just return sorting array
        return pOrderBy;
      }
    }
    return [];
  }
  ;
  function getSearchAssetIndexes(pCurrentIndex) {
    switch (pCurrentIndex) {
      case "Asset_SortSubFileNameEnclosingFolderURL":
        return ["Asset_SortSubEnclosingFolderURLFileName", "Asset_SortSubFileNameEnclosingFolderURL"];
      case "Asset_SortSubFileTypeFileNameEnclosingFolderURL":
        return ["Asset_SortSubEnclosingFolderURLFileTypeFileName", "Asset_SortSubFileTypeFileNameEnclosingFolderURL"];
      case "Asset_SortSubModTimeFileNameEnclosingFolderURL":
        return ["Asset_SortSubEnclosingFolderURLModTimeFileName", "Asset_SortSubModTimeFileNameEnclosingFolderURL"];
      default:
        return [pCurrentIndex];
    }
  }
  ;

  /**
   * @description the disctionary with keys: folder urls containing all the folder that will be come in the future
   * @private
   * @type object | dictionary
   */
  var foldersInMakingDict = {};

  /**
   * @description the disctionary with keys: folder urls containing all the files that will be come in the future
   * @private
   * @type object | dictionary
   */
  var filesInMakingDict = {};

  /**
   * @desc the prefix of technical tags. Those tags are used for internal use.
   * Changing those can have a use inpact!
   * @private
   * @type string
   */
  var kTechnicalTagsPrefix = "nixps.";

  /**
  * @description The amount of files/pages we want to limit the book view
  * @static
  * @type Number
  * @private
  */
  var kLimitBookViewPages = 30000;

  /**
   * @description The max amount to load files, when the system suppose to load all the files
   * @static
   * @type Number
   * @private
   */
  var kMaxLimitAssets = 500000;

  /**
   * @description The number of asset to be loaded if no number is given.
   * @static
   * @type Number
   * @private
   */
  var kInitLimit = 200;
  var kPageRegExp = new RegExp("(.*)p([0-9]+)\.[a-z]+$");
  function containFolderABook(pFiles, pFolders) {
    if (pFiles === undefined || pFolders === undefined) {
      return false;
    }
    if (!Array.isArray(pFiles) || !Array.isArray(pFolders)) {
      throw new Error("inputparameters must be a array");
    }
    if (pFiles.length === 0 || pFolders.length > 1) {
      // if no pages/files we have no book; 
      // if there are multiple folders we are not 100% sure to have a correct book 
      return false;
    }
    if (pFolders.length !== 1 || $.isEmptyObject(pFolders[0].cloudflow) || pFolders[0].cloudflow.parent !== true) {
      return false; // we must have exactly one parent folder.
    }
    // if has a name that end as <something> + "p" + <number> + "." + <extentie>
    if (pFiles[0].cloudflow === undefined || typeof pFiles[0].cloudflow.file !== "string" || kPageRegExp.test(pFiles[0].cloudflow.file) === false) {
      return false; // the first filename must have a correct interface
    } else {
      // control if the rest of the filenames has the correct interface and start with the same string as first filename
      var bookPagePostTitle = pFiles[0].cloudflow.file.replace(kPageRegExp, "$1");
      var specificPageRegExp = new RegExp(bookPagePostTitle + "p([0-9]+)\.[a-z]+$");
      for (var i = 1; i < pFiles.length; i++) {
        if (specificPageRegExp.test(pFiles[i].cloudflow.file) === false) {
          return false;
        }
      }
    }
    return true;
  }
  var jquerySelectableRegExp = new RegExp("%|[.]", "g");
  function makejQuerySelectable(pString) {
    return encodeURIComponent(pString).replace(jquerySelectableRegExp, "_");
  }

  // Triggers "select"
  /**
   * @namespace nixps-cloudflow.FolderView
   * @description Retrieve all the file and folder data and pass that through the [CombinedView]@{link nixps-cloudflow.CombinedView} component
   * 
   */
  $.widget("nixps-cloudflow.FolderView", {
    widgetEventPrefix: "folderview",
    options: {
      /**
       * @name nixps-cloudflow.FolderView#cf_url
       * @description The current url of the folder we are looking at.
       * @type {String | url }
       * @default "cloudflow://"
       */
      cf_url: "cloudflow://",
      /**
       * @name nixps-cloudflow.FolderView#site
       * @description The site name
       * @type {string}
       * @default null
       */
      site: null,
      /**
       * @name nixps-cloudflow.FolderView#search_query
       * @description The query to search on. This is deliverd by the search query builder component, in his format
       * @type {Array.<String>}
       * @default []
       */
      search_query: [],
      /**
       * @name nixps-cloudflow.FolderView#search_folder_query
       * @description The query to filter on folders. if null that the old behavior is applied on search_query. 
       * if empty array, we dont search on folder
       * @type {Array.<String>}
       * @default null
       */
      search_folder_query: null,
      /**
       * @name nixps-cloudflow.FolderView#quickSearchOnly
       * @description Is the folderView for quicksearch only or not?
       * @type {Boolean}
       * @default undefined
       */
      quickSearchOnly: undefined,
      /**
       * @name nixps-cloudflow.FolderView#quickSearchSplitRecurcive
       * @description must we use different recursive steps during search
       * @default false
       * @type {Boolean}
       * @private
       */
      quickSearchSplitRecurcive: false,
      /**
       * @description Add extra asset filter.
       * @type {Array}
       * @default false
       */
      fileFilter: false,
      /**
       * @name nixps-cloudflow.FolderView#foldersOnly
       * @description Must we show only folders and do not show files?
       * @type {Boolean}
       * @default false
       */
      foldersOnly: false,
      searchOnFolders: false,
      /**
       * @name nixps-cloudflow.FolderView#initOrderBy
       * @description The orderBy query what we must use on startup. It initialise the orderBy Query. This must be a valid orderBy query array
       * @type {array | orderBy_array}
       * @default []
       * @example ["modtime", "ascending"]
       */
      initOrderBy: [],
      /**
       * @name nixps-cloudflow.FolderView#columnsWhenSearching
       * @description what are the columns when we are searching
       * @type {Array}
       * @default ["thumb", "name", "filetype", "filepath", "approvals", "tags", "modtime"]
       */
      columnsWhenSearching: ["thumb", "name", "filetype", "filepath", "approvals", "tags", "filesize", "modtime"],
      /**
       * @name nixps-cloudflow.FolderView#columnsOnDefault
       * @description What are the columns when showing the list
       * @type {Array}
       * @default ["thumb", "name", "filetype", "approvals", "tags", "modtime"]
       */
      columnsOnDefault: ["thumb", "name", "filetype", "approvals", "tags", "filesize", "modtime"],
      /**
       * @name nixps-cloudflow.FolderView#view
       * @description Choose the view. You can coose between "icon", "list", "reader", "iconChooser",
       * IconChooser, means that the component will switch to the best fitting view
       * @type {String}
       * @default list
       */
      view: "list",
      /**
       * @name nixps-cloudflow.FolderView#lockFolder
       * @desc must the current folder be locked or not, this is now only possible on icon/readers view
       * @type {Boolean}
       * @default false
      */
      lockFolder: false,
      /**
       * @name nixps-cloudflow.FolderView#enableDownload
       * @description Is the user allowed to download assets?
       * @type {Boolean}
       * @default false
       */
      enableDownload: false,
      /**
       * @name nixps-cloudflow.FolderView#enableDragging
       * @description Is the user allowed to drag and drop files?
       * @type {Boolean}
       * @default false
       */
      enableDragging: false,
      /**
       * @name nixps-cloudflow.FolderView#enableSelecting
       * @description enable file and folder selection
       * @type {Boolean}
       * @default false
       */
      enableSelecting: false,
      /**
       * @name nixps-cloudflow.FolderView#enableMultipleSelection
       * @description if enableSelection is set on true, are we allowed to select multiple files or can we only select one a time
       * @type {Boolean}
       * @default true
       */
      enableMultipleSelection: true,
      fastMultipleSelection: false,
      /**
       * @name nixps-cloudflow.ListView#deselectWhenRowClick
       * @description deselect other rows if we click on a not checkbox
       * @type {Boolean}
       * @default false
       */
      deselectWhenRowClick: false,
      /**
       * @name nixps-cloudflow.FolderView#deselectable
       * @description Must we able to deselect files or folders?
       * @default false
       * @type {Boolean}
       */
      deselectable: false,
      /**
       * @name nixps-cloudflow.FolderView#enableContextMenu
       * @description Must we enable the contextmenu
       * @type {Boolean}
       * @default false
       */
      enableContextMenu: false,
      /**
       * @name nixps-cloudflow.FolderView#rootFolder
       * @description the rootfolder
       * @type {String}
       * @default null
       */
      rootFolder: null,
      /**
       * @description the with of the icons in icon view
       * @type {Number}
       * @default 150
       */
      iconWidth: 150,
      /**
       * @name nixps-cloudflow.FolderView#loadTags
       * @description Must we load and show the tags of the assets?
       * @type {Boolean}
       * @default true
       */
      loadTags: true,
      /**
       * @name nixps-cloudflow.FolderView#tableBodyClasses
       * @description classes to be given to the list view
       * @type {String}
       * @default undefined
       */
      tableBodyClasses: undefined,
      /**
       * @name nixps-cloudflow.FolderView#refreshDelay
       * @description The delay between two refreshing updates in miliseconds
       * @type {Number}
       * @default 10000
       */
      refreshDelay: 10000
    },
    _create: function _create() {
      if (typeof this.options.refreshDelay !== "number" || this.options.refreshDelay.length < 0) {
        throw new Error("input option refreshDelay must be a positive number");
      }
      if (!Array.isArray(this.options.initOrderBy)) {
        throw new Error("option initOrderBy must be a array");
      }
      if (!Array.isArray(this.options.columnsWhenSearching)) {
        throw new Error("option columnsWhenSearching must be a array");
      }
      if (!Array.isArray(this.options.columnsOnDefault)) {
        throw new Error("option columnsOnDefault must be a array");
      }
      if (typeof this.options.loadTags !== "boolean") {
        throw new Error("option loadTags must be a boolean");
      }
      this.element.addClass(this.widgetFullName);
      this.callingID = 0; // increment the seach ID, to be sure the returned calles are the good one, if one came later to cancel them
      this.preferences = {};
      this._savePreferencesFunction = _.debounce(this._savePreferences, 1500);
      this.queryUtil = new QueryUtil(); // kit tool to work with search querys
      this.delayTimerID; // it timer id of the refessh timer
      this.loadingPanelTimerID; // the timer of the panel showing the system is being loading...

      this.orderBy = this.options.initOrderBy;
      // this is the amount to ask to backend, and not the amount of files to see!!
      this.askingLimit = kInitLimit + 1;
      this._drawCallBackFunction = function () {};
      // the current view we have
      this.view = this.options.view === FolderViews.types.ICON_CHOOSER ? FolderViews.types.ICON : this.options.view; // files and folder are empty 

      // make deep copy
      this.options.columnsWhenSearching = this.options.columnsWhenSearching.slice();
      this.options.columnsOnDefault = this.options.columnsOnDefault.slice();
      this.m_combinedview = $("<div>");
      this.element.append(this.m_combinedview);
      this.element.prepend($("<span>").addClass("folderview_loadingpanel cf-center-text")._t("nixps-cloudflow-assets.loadingtext"));
      this._redraw();
      this._on(this.element, {
        "combinedviewopen": this._openItemHandler,
        "combinedviewaction": this._actionHandler,
        "combinedviewselect": this._fileSelectHandler,
        "combinedviewsearch": this._searchActionHandler,
        "combinedviewcontextmenu": this._contextmenuHandler,
        //"click .assetview_contextmenu_protectlayer": this._cleanContextmenuProtecterHandler,
        "combinedviewdataprovider": this._dataProviderHandler,
        "combinedviewrefreshfinished": this._dataDrawedhandler,
        "combinedviewselectbytypingfinished": this._selectByTypingFinished,
        "dragstart": this._dragstartHandler,
        "dragstop": this._dragendHandler,
        "drop .ui-droppable": this._dropHandler
      });
      $(document).on("visibilitychange", this._visibilityHandler.bind(this));
    },
    selectByTyping: function selectByTyping(pSearchString) {
      this.m_combinedview.CombinedView("selectByTyping", pSearchString);
    },
    _selectByTypingFinished: function _selectByTypingFinished(pEvent, pData) {
      var element = pData.element;
      //check if element is in view
      if (this._isElementFullyInView(element) === false) {
        element[0].scrollIntoView(true);
        if (element.offset().top === $("#topbar").height() && this.options.view === "list") {
          //at the top of the window - 59 is height of topbar
          this.element[0].scrollBy(0, -this.element.find(".nixps-cloudflow-CombinedView .nixps-cloudflow-ListView .cf-table-head").height()); //tableheader correction, maybe get the height programatically
        }
      }
    },

    _isElementFullyInView: function _isElementFullyInView(element) {
      var containerTop = this.element.scrollTop(); //tableheader;
      var containerBottom = containerTop + this.element.height();
      var elemTop = element.position().top;
      var elemBottom = elemTop + element.height();
      return containerTop < elemTop && containerBottom > elemBottom;
    },
    _openItemHandler: function _openItemHandler(pEvent, pData) {
      this._trigger("open", pEvent, pData);
    },
    _actionHandler: function _actionHandler(pEvent, pData) {
      this._trigger("action", pEvent, pData);
    },
    _fileSelectHandler: function _fileSelectHandler(pEvent, pData) {
      this._trigger("select", pEvent, pData);
    },
    _dataProviderHandler: function _dataProviderHandler(pEvent, pData) {
      this.orderBy = pData.orderBy;
      this.skip = pData.skip;
      this.askingLimit = pData.limit;
      this._reloadDataAndInform();
    },
    _dataDrawedhandler: function _dataDrawedhandler(pEvent, pData) {
      if (typeof pData.amount === "number" && pData.amount > 0) {
        var target = $(pEvent.target);
        if (target.is(":visible")) {
          this._triggerTimer();
        }
      }
      this._trigger("draw", pEvent, pData);
    },
    _dragstartHandler: function _dragstartHandler(pEvent, pData) {
      if (pData === undefined) {
        // is dragging event outside jquery, do nothing
        return true;
      }
      this._pauseTimer();
    },
    _dragendHandler: function _dragendHandler(pEvent, pData) {
      this._restartTimer();
    },
    /**
     * @description function runs when user drop a fHelloile in a folder
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _dropHandler: function _dropHandler(pEvent, pData) {
      if (pData !== undefined && pData.draggable !== undefined) {
        var isMultiple = false;
        var draggingElem = pData.draggable;
        var toCopy = pEvent.metaKey;
        var draggedFiles = pData.draggable.data("dataitem");
        if (pData.helper !== undefined && pData.helper.hasClass("multipleDraggableHelperContainer")) {
          var multipleDraggableData = $(pData.helper).data("items");
          if (Array.isArray(multipleDraggableData) && multipleDraggableData.length > 1) {
            isMultiple = true;
            draggedFiles = multipleDraggableData;
          }
        }
        if (isMultiple === false) {
          if (draggedFiles !== undefined && !$.isEmptyObject(draggedFiles.cloudflow) && typeof draggedFiles.cloudflow.part === "string" && draggedFiles.cloudflow.part.length > 0) {
            // in case of icon view
            var targetFolder = $(pEvent.currentTarget).data("dataitem");
            if (targetFolder !== undefined && !$.isEmptyObject(targetFolder.cloudflow) && typeof targetFolder.cloudflow.folder === "string" && targetFolder.cloudflow.folder.length > 0) {
              var fromFile = draggedFiles.cloudflow.part;
              var toFolder = targetFolder.cloudflow.folder;
              if (toCopy === false) {
                // is being moving... delete item
                draggingElem.addClass("item_processing item_deleting");
              }
              this._trigger("droppedasset", pEvent, {
                from: fromFile,
                to: toFolder,
                copy: toCopy,
                fromAssetID: draggedFiles._id,
                recyclebin: false
              });
            } else if (targetFolder && !$.isEmptyObject(targetFolder.cloudflow) && targetFolder.cloudflow.recyclebin === true) {
              //dragged to the recyclebin!
              var fromFile = draggedFiles.cloudflow.part;
              draggingElem.addClass("item_processing item_deleting");
              this._trigger("droppedasset", pEvent, {
                from: fromFile,
                to: "",
                copy: toCopy,
                fromAssetID: draggedFiles._id,
                recyclebin: true
              });
            }
          } else {
            //TODO: case doesn't seem to happen anymore?
            var draggedFiles = pData.draggable.data("dataitem");
            if (draggedFiles && draggedFiles.cloudflow && typeof draggedFiles.cloudflow.part === "string" && draggedFiles.cloudflow.part.length > 0) {
              // in case of list view, the table component add the dataitem data to the rows
              var targetFolder = $(pEvent.currentTarget).data("dataitem");
              if (targetFolder && targetFolder.cloudflow && typeof targetFolder.cloudflow.folder === "string" && targetFolder.cloudflow.folder.length > 0) {
                var fromFile = draggedFiles.cloudflow.part;
                var toFolder = targetFolder.cloudflow.folder;
                if (toCopy === false) {
                  // is being moving... delete item
                  draggingElem.addClass("item_processing item_deleting");
                }
                this._trigger("droppedasset", pEvent, {
                  from: fromFile,
                  to: toFolder,
                  copy: toCopy,
                  fromAssetID: draggedFiles._id,
                  recyclebin: false
                });
              } else if (targetFolder && targetFolder.cloudflow && targetFolder.cloudflow.recyclebin === true) {
                //dragged to the recyclebin!
                var fromFile = draggedFiles.cloudflow.part;
                draggingElem.addClass("item_processing item_deleting");
                this._trigger("droppedasset", pEvent, {
                  from: fromFile,
                  to: "",
                  copy: toCopy,
                  fromAssetID: draggedFiles._id,
                  recyclebin: true
                });
              }
            }
          }
        } else {
          var fromFiles = [];
          var targetFolder = $(pEvent.currentTarget).data("dataitem");
          if (targetFolder && targetFolder.cloudflow && typeof targetFolder.cloudflow.folder === "string" && targetFolder.cloudflow.folder.length > 0) {
            for (var i = 0; multipleDraggableData.length > i; i++) {
              fromFiles.push(multipleDraggableData[i].cloudflow.part);
            }
            var toFolder = targetFolder.cloudflow.folder;
            if (toCopy === false) {
              // is being moving... delete item
              draggingElem.addClass("item_processing item_deleting");
            }
            this._trigger("droppedasset", pEvent, {
              from: fromFiles,
              to: toFolder,
              copy: toCopy,
              fromAssetID: draggedFiles._id,
              recyclebin: false
            });
          } else if (targetFolder && targetFolder.cloudflow && targetFolder.cloudflow.recyclebin === true) {
            //dragged to the recyclebin!
            for (var i = 0; multipleDraggableData.length > i; i++) {
              fromFiles.push(multipleDraggableData[i].cloudflow.part);
            }
            draggingElem.addClass("item_processing item_deleting");
            this._trigger("droppedasset", pEvent, {
              from: fromFiles,
              to: toFolder,
              copy: toCopy,
              fromAssetID: draggedFiles._id,
              recyclebin: true
            });
          }
        }
      }
    },
    /**
     * @description function runs when user want to search something generale 
     * @function
     * @private
     * @name nixps-cloudflow.FolderView#_searchActionHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _searchActionHandler: function _searchActionHandler(pEvent, pData) {
      this._trigger("search", pEvent, pData);
    },
    /**
     * @description function runs when user right click on a asset
     * @function
     * @private
     * @name nixps-cloudflow.FolderView#_contextmenuHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _contextmenuHandler: function _contextmenuHandler(pEvent, pData) {
      // pause the automatic fresh
      this._pauseTimer();
      // inform others
      this._trigger("contextmenu", pEvent.originalEvent, pData);
    },
    /**
     * @description function runt when user want to disable contextmenu
     * @function
     * @private
     * @name nixps-cloudflow.FolderView#_cleanContextmenuProtecterHandler
     * @return {undefined}
     */
    _cleanContextmenuProtecterHandler: function _cleanContextmenuProtecterHandler() {
      this.cleanContextmenuLayer();
    },
    /**
     * @description Stop the contextmenu 
     * @funtion
     * @name nixps-cloudflow.FolderView#cleanContextmenuLayer
     * @private
     * @return {undefined}
     */
    cleanContextmenuLayer: function cleanContextmenuLayer() {
      this._restartTimer();
      this.m_combinedview.CombinedView("cleanContextmenuLayer");
    },
    /**
     * @description function runs when browser tab are hidden/changed or reappears
     * @fucntion
     * @private
     * @name nixps-cloudflow.FolderView#_visibilityHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _visibilityHandler: function _visibilityHandler(pEvent, pData) {
      // only pause and replay if we loop for a dynamic list, otherwise we do not need to pauze, ...
      // if browser known the document.hidden attribute
      if (this.options.refreshDelay > 0 && typeof document.hidden === "boolean") {
        // only clear if hidden attr exists
        // because only _reloadData will retrigger new timer
        clearTimeout(this.delayTimerID);
        // if browser tab reappear
        if (document.hidden === false) {
          this._reload();
        }
      }
    },
    _redraw: function _redraw() {
      var columns = this.options.columnsOnDefault;
      if (Array.isArray(this.options.search_query) && this.options.search_query.length > 0) {
        columns = this.options.columnsWhenSearching.slice();
      }
      this.m_combinedview.CombinedView({
        view: this.view,
        showDownloadIcon: this.options.enableDownload,
        enableAssetDragging: this.options.enableDragging,
        enableSelecting: this.options.enableSelecting,
        enableMultipleSelection: this.options.enableMultipleSelection,
        fastMultipleSelection: this.options.fastMultipleSelection,
        deselectWhenRowClick: this.options.deselectWhenRowClick,
        deselectable: this.options.deselectable,
        enableContextMenu: this.options.enableContextMenu,
        orderBy: this.orderBy,
        limit: this.askingLimit - 1,
        // Icon properties
        iconWidth: this.options.iconWidth,
        // List properties
        columns: columns,
        bodyClasses: this.options.tableBodyClasses,
        disableSorting: this.options.quickSearchOnly,
        // Reader properties
        lockFolder: this.options.lockFolder

        // no files and folder
        // because we do not want to flikker, will be added later on
      });
    },

    /**
     * @description Set the preferences, used for orderBy on default
     * @function
     * @name nixps-cloudflow.FolderView#initPreferences
     * @param {object} pPreferences
     * @returns {undefined}
     */
    initPreferences: function initPreferences(pPreferences) {
      this.preferences = pPreferences;
      // set the amount of assets to load
      if (this.preferences !== undefined && typeof this.preferences.assetLimit === "number" && this.preferences.assetLimit > 0) {
        this.askingLimit = this.preferences.assetLimit + 1;
        // for the moment no influence on readersView!
      }
      // set the orderBy array preferences
      if (Array.isArray(this.options.initOrderBy) && this.options.initOrderBy.length > 0) {
        // do not set orderBy of preferences 
        // if initOrderBy is set!
        //return false;
      } else if (this.preferences !== undefined && typeof this.preferences.fileorder === "string" && this.preferences.fileorder.length > 0 && typeof this.preferences.fileasc === "boolean") {
        this.orderBy = [this.preferences.fileorder, this.preferences.fileasc ? "ascending" : "descending"];
      }
      if (this.preferences !== undefined && this.preferences.easy_search_overwite !== undefined) {}
      this.m_combinedview.CombinedView("initPreferences", pPreferences);
    },
    /**
     * @description Reload the data, this can be the list of site, folders and/or files
     * @name nixps-cloudflow.FolderView#_reload
     * @function
     * @private
     * @returns {unresolved}
     */
    _reload: function _reload() {
      if (this.options.cf_url === "" && this.options.site === "") {
        return this._reloadSites();
      } else {
        this._reloadData();
      }
    },
    /**
     * @description Load the different sites, of no found redirect to loadData function
     * @name nixps-cloudflow.FolderView#_reloadSites
     * @function
     * @private
     * @returns {unresolved}        
     */
    _reloadSites: function _reloadSites() {
      var that = this;
      this.callingID++;
      clearTimeout(this.delayTimerID);
      return $.Deferred(function (pDefer) {
        Sites.get(true).then(function (pSites) {
          if (pSites.areMultipleSites()) {
            var sitesAsFolders = [];
            var sites = pSites.getSites();
            if (Array.isArray(that.orderBy) && that.orderBy[0] === "file_name") {
              var p_ascending = that.orderBy[1] === "ascending" ? true : false;
              sites.sort(function (a, b) {
                var result = 0;
                if (a.name === undefined) {
                  return -1;
                } else if (b.name === undefined) {
                  return 1;
                } else {
                  result = a.name.localeCompare(b.name);
                }
                return p_ascending ? result : -result; // rechange to force always ascending
              });
            }

            for (var i = 0; i < sites.length; i++) {
              sitesAsFolders.push({
                _id: makejQuerySelectable(sites[i].url),
                url: sites[i].url,
                name: sites[i].name,
                site: true,
                description: sites[i].description,
                cloudflow: {
                  enclosing_folder: "",
                  folder: sites[i].name + "/"
                }
              });
            }
            that._filesAndFolderInjection({
              results: sitesAsFolders
            }, {
              results: []
            }, false, that.callingID);
          } else {
            pDefer.reject("no sites found");
          }
        }, pDefer.reject);
      }).fail(function (pError) {
        // error go to default behavior, see local filestores
        console.error(pError);
        that._reloadData();
      });
    },
    _reloadDataAndInform: function _reloadDataAndInform() {
      this._reload();

      // handle saving and changing after demaning backend
      if (Array.isArray(this.orderBy) && this.orderBy.length >= 2) {
        var ascending = this.orderBy[1] === "ascending" ? true : false;
        if (this.preferences.fileorder !== this.orderBy[0] || this.preferences.fileasc !== ascending) {
          this.preferences.fileorder = this.orderBy[0];
          this.preferences.fileasc = ascending;
          this._delay(function () {
            this._savePreferencesFunction();
          }, 100);
        }
      }
    },
    _getQueryToStart: function _getQueryToStart(pRecursive) {
      var query = this.queryUtil.addEnclosingFolderToSearchQuery(["sub", "equal to", ""], this.m_enclosing_folder, pRecursive);
      if (Array.isArray(this.options.fileFilter) && this.options.fileFilter.length > 0) {
        query = query.concat(["and", "("]).concat(this.options.fileFilter).concat(")");
      }
      if (Array.isArray(this.options.search_query) && this.options.search_query.length > 0) {
        query = query.concat(["and", "("]).concat(this.options.search_query);
        query.push(")");
      }
      return Query.prepare(query);
    },
    _getFolderQueryToStart: function _getFolderQueryToStart(pRecursive) {
      var query = this.queryUtil.addEnclosingFolderToSearchQuery(["sub", "equal to", ""], this.m_enclosing_folder, pRecursive);
      if (Array.isArray(this.options.search_folder_query) && this.options.search_folder_query.length > 0) {
        query = query.concat(["and", "("]).concat(this.options.search_folder_query);
        query.push(")");
      }
      return Query.prepare(query);
    },
    _reloadData: function _reloadData() {
      var that = this;
      this.callingID++; // increment the seach ID, to be sure the returned calles are the good one, if one came later to cancel them
      clearTimeout(this.delayTimerID); // if this function is called, when the timer is still running for a new call, cancel the timer 
      var assetCallOptions = {};
      var folderCallOptions = {
        use_index: "Folder_EnclosingFolderURL"
      };
      var orderByAsset = [];
      var orderByFolder = [];
      if (Array.isArray(this.orderBy)) {
        var assetOrderBy = addDefaultOrderBy(this.orderBy);
        orderByAsset = assetOrderBy;
        orderByFolder = translateFileToFolderOrderBy(assetOrderBy);
        if (Array.isArray(orderByAsset) && orderByAsset.length > 0) {
          if (Array.isArray(this.options.search_query) && this.options.search_query.length > 0) {
            // when searching
            switch (orderByAsset[0]) {
              case "file_name":
                assetCallOptions.use_index = "Asset_SortSubFileNameEnclosingFolderURL";
                break;
              case "filetype":
                assetCallOptions.use_index = "Asset_SortSubFileTypeFileNameEnclosingFolderURL";
                break;
              case "modtime":
                assetCallOptions.use_index = "Asset_SortSubModTimeFileNameEnclosingFolderURL";
                break;
              case "cloudflow.enclosing_folder":
              default:
                assetCallOptions.use_index = "Asset_EnclosingFolderURL";
            }
          } else {
            // when not searching
            switch (orderByAsset[0]) {
              case "file_name":
                assetCallOptions.use_index = "Asset_SortSubEnclosingFolderURLFileName";
                break;
              case "filetype":
                assetCallOptions.use_index = "Asset_SortSubEnclosingFolderURLFileTypeFileName";
                break;
              case "modtime":
                assetCallOptions.use_index = "Asset_SortSubEnclosingFolderURLModTimeFileName";
                break;
              case "cloudflow.enclosing_folder":
              default:
                assetCallOptions.use_index = "Asset_EnclosingFolderURL";
            }
          }
        }
      }
      if (typeof this.skip === "number" && this.skip >= 0) {
        assetCallOptions.first = this.skip;
        folderCallOptions.first = this.skip;
      }
      if (typeof this.askingLimit === "number" && this.askingLimit > 0) {
        assetCallOptions.maximum = this.askingLimit;
        folderCallOptions.maximum = this.askingLimit;
      }
      this.m_enclosing_folder = this.options.cf_url;
      if (this.m_enclosing_folder === "cloudflow://") {
        this.m_enclosing_folder = "";
      }
      this._startLoading(); // start timer loading panel
      if (this._isSearching()) {
        if (this.options.quickSearchOnly === true) {
          assetCallOptions.timeout = true;
          folderCallOptions.timeout = true;
        }
        var recursive = undefined;
        if (this.options.quickSearchSplitRecurcive === true) {
          recursive = false;
        }
        var query = this._getQueryToStart(recursive);
        var folderQuery;
        if (this.options.search_folder_query === null) {
          folderQuery = query;
        } else {
          folderQuery = this._getFolderQueryToStart(recursive);
        }
        var tag_query = [];
        var no_tags_query = [];
        var operator_tag_query = this.queryUtil.getTagOperatorQuery(this.options.search_query);
        if (Array.isArray(operator_tag_query) && operator_tag_query.length > 0) {
          // we are in special case, the user press the operator keyword
          tag_query = operator_tag_query;
          no_tags_query = this.queryUtil.removeQuery(this.options.search_query, "searchstring");
          if (no_tags_query.length === 0) {
            no_tags_query = this.queryUtil.addEnclosingFolderToSearchQuery(["sub", "equal to", ""], this.m_enclosing_folder);
          }
        } else {
          // the user use the advanced search logic tool to search
          tag_query = this.queryUtil.extractTagQuery(this.options.search_query);
          no_tags_query = this.queryUtil.removeTagQuery(query);
        }
        if (Array.isArray(tag_query) && tag_query.length > 0) {
          // only when we want to search on tags (or files and tags) 
          (function (pID) {
            $.when(that._getTagsFolderList(that.queryUtil.translateToFolderQuery(no_tags_query), tag_query, orderByFolder, folderCallOptions, pID), that._getTagsAssetList(no_tags_query, tag_query, orderByAsset, assetCallOptions, pID)).done(function (pFolder, pFiles) {
              that._filesAndFolderInjection(pFolder, pFiles, false, pID);
              that._endLoading();
            }).fail(function (pError) {
              console.error(pError);
            });
          })(this.callingID);
        } else {
          // only when we do not search on tags
          var folderOnly = this.queryUtil.folderOnly(query);
          var containsFolderQuery = this.queryUtil.containsFolderQuery(query);
          query = this.queryUtil.replaceOperatorsQuery(query);
          var askFolders;
          if (this.options.search_folder_query === null) {
            askFolders = folderOnly || containsFolderQuery || query.includes("searchstring") || that.options.searchOnFolders === true || that.options.search_query && that.options.search_query.length > 0;
          } else if (Array.isArray(this.options.search_folder_query)) {
            if (this.options.search_folder_query.length > 0) {
              askFolders = true;
              containsFolderQuery = true;
            } else {
              askFolders = false;
              containsFolderQuery = false;
            }
          }

          // Request folders
          if (askFolders) {
            var defFolders, defFiles;
            (function (pID) {
              folderQuery = that.queryUtil.replaceOperatorsQuery(folderQuery);
              delete folderCallOptions.use_index; // remove wrong index, should work faster
              defFolders = that._getFoldersList(that.queryUtil.translateToFolderQuery(folderQuery), orderByFolder, folderCallOptions, undefined, that.options.loadTags, pID).done(function (pFolder) {
                that._filesAndFolderInjection(pFolder, {}, false, pID);
                if (that.callingID === pID && that.options.quickSearchSplitRecurcive === true) {
                  if (typeof folderCallOptions.maximum === "number" && folderCallOptions.maximum <= pFolder.results.length) {
                    return;
                  }
                  var deepRecursiveQuery;
                  if (that.options.search_folder_query === null) {
                    deepRecursiveQuery = that.queryUtil.replaceOperatorsQuery(that._getQueryToStart(true));
                  } else {
                    deepRecursiveQuery = that.queryUtil.replaceOperatorsQuery(that._getFolderQueryToStart(true));
                  }
                  folderCallOptions.maximum -= pFolder.results.length;
                  that._getFoldersList(that.queryUtil.translateToFolderQuery(deepRecursiveQuery), orderByFolder, folderCallOptions, undefined, that.options.loadTags, pID).done(function (pDeepFolders) {
                    that._addFilesAndFoldersAfterwards(pDeepFolders, {}, false, pID);
                  });
                }
              });
            })(this.callingID);
            (function (pID) {
              if (folderOnly === true) {
                // we want to see only folders, so we dont want to see files
                that._filesAndFolderInjection({}, [], false, pID);
              } else {
                var assetCallOptions_first;
                if (that.options.quickSearchSplitRecurcive === true) {
                  assetCallOptions_first = Object.assign({}, assetCallOptions);
                  switch (orderByAsset[0]) {
                    case "file_name":
                      assetCallOptions_first.use_index = "Asset_SortSubEnclosingFolderURLFileName";
                      break;
                    case "filetype":
                      assetCallOptions_first.use_index = "Asset_SortSubEnclosingFolderURLFileTypeFileName";
                      break;
                    case "modtime":
                      assetCallOptions_first.use_index = "Asset_SortSubEnclosingFolderURLModTimeFileName";
                      break;
                    case "cloudflow.enclosing_folder":
                    default:
                      assetCallOptions_first.use_index = "Asset_EnclosingFolderURL";
                  }
                  orderByAsset = [];
                } else {
                  assetCallOptions_first = assetCallOptions;
                }
                defFiles = that._getAssetsListMultiIndex(that.queryUtil.translateToFileQuery(query), orderByAsset, assetCallOptions_first, that.options.loadTags, pID).done(function (pFiles) {
                  that._filesAndFolderInjection({}, pFiles, false, pID);
                  if (that.callingID === pID && that.options.quickSearchSplitRecurcive === true) {
                    if (typeof assetCallOptions.maximum === "number" && assetCallOptions.maximum <= pFiles.results.length) {
                      return;
                    }
                    var deepRecursiveQuery = that.queryUtil.replaceOperatorsQuery(that._getQueryToStart(true));
                    assetCallOptions.maximum -= pFiles.results.length;
                    that._getAssetsListMultiIndex(that.queryUtil.translateToFileQuery(deepRecursiveQuery), orderByAsset, assetCallOptions, that.options.loadTags, pID).done(function (pDeepFiles) {
                      that._addFilesAndFoldersAfterwards({}, pDeepFiles, false, pID);
                    });
                  }
                });
              }
            })(this.callingID);
            $.when(defFolders, defFiles).always(function () {
              that._endLoading();
            }).fail(function (pError) {
              console.error(pError);
            });
          } else {
            (function (pID) {
              that._getAssetsListMultiIndex(that.queryUtil.translateToFileQuery(query), orderByAsset, assetCallOptions, that.options.loadTags, pID).done(function (pFiles) {
                that._filesAndFolderInjection({
                  results: []
                }, pFiles, false, pID);
                if (that.callingID === pID && that.options.quickSearchSplitRecurcive === true) {
                  if (typeof assetCallOptions.maximum === "number" && assetCallOptions.maximum <= pFiles.results.length) {
                    that._endLoading();
                    return;
                  }
                  var deepRecursiveQuery = that.queryUtil.replaceOperatorsQuery(that._getQueryToStart(true));
                  assetCallOptions.maximum -= pFiles.results.length;
                  that._getAssetsListMultiIndex(that.queryUtil.translateToFileQuery(deepRecursiveQuery), orderByAsset, assetCallOptions, that.options.loadTags, pID).done(function (pDeepFiles) {
                    that._addFilesAndFoldersAfterwards({}, pDeepFiles, false, pID);
                  }).always(function () {
                    that._endLoading();
                  });
                } else {
                  that._endLoading();
                }
              }).fail(function (pError) {
                console.error(pError);
              });
            })(this.callingID);
          }
        }
      } else {
        // no searching
        // Request folders 
        var fileQuery = ["sub", "equal to", "", "and", "cloudflow.enclosing_folder", "equal to", this.m_enclosing_folder];
        if (Array.isArray(this.options.fileFilter) && this.options.fileFilter.length > 0) {
          fileQuery = fileQuery.concat(["and", "("]).concat(this.options.fileFilter).concat(")");
        }
        var folderQuery = ["cloudflow.enclosing_folder", "equal to", this.m_enclosing_folder];
        (function (pID) {
          $.when(that._getFoldersList(folderQuery, orderByFolder, folderCallOptions, true, that.options.loadTags, pID), that._getAssetsList(fileQuery, orderByAsset, assetCallOptions, that.options.loadTags, pID)).done(function (pFolder, pFiles) {
            that._filesAndFolderInjection(pFolder, pFiles, false, pID);
            that._endLoading();
          }).fail(function (pError) {
            console.error(pError);
          });
        })(this.callingID);
      }
    },
    _getTagsAssetList: function _getTagsAssetList(no_tags_query, tag_query, orderByAsset, pOptions, pID) {
      if (this.options.foldersOnly === true) {
        return $.Deferred().resolve({
          results: []
        });
      }
      var that = this;
      // no control on ID needed, this is called immediatly
      // there are two kind of indexes, one fast, but can give somethines no results, where there are actualy results
      // one slow which will give always the correct results
      // do the two (2) calls in parallell, one with a fast index and the other with a slow index,
      // if the fast index get results, use this, if empty the slow can give the results
      return $.Deferred(function (pDefer) {
        var fields = ["url", "sub", "cloudflow", "thumb", "modtime", "approvals", "file_time", "filetype", "file_name", "mime_types", "proofscope.uuid", "proofscope3d.id", "metadata.page_limit", "metadata.number_of_pages", "metadata.output_color_space.colorants", "file_size"];
        var indexesToUse = getSearchAssetIndexes(pOptions.use_index);
        var found;
        // fast search 
        api_async.asset.list_with_tag_query_and_options(no_tags_query, tag_query, "Some", orderByAsset, fields, Object.assign({}, pOptions, {
          use_index: indexesToUse[0]
        }), function (pData) {
          if (pData === undefined) {
            throw new Error("folderview._getTagsAssetList wrong return interface");
          }
          if (found === undefined) {
            if (indexesToUse.length === 1 || Array.isArray(pData.results) && pData.results.length > 0) {
              found = true;
              that._addTagsAndLoad(pData, "file", pID).then(pDefer.resolve, pDefer.reject);
            }
          }
        }, pDefer.reject);
        if (indexesToUse.length > 1) {
          // slow search 
          api_async.asset.list_with_tag_query_and_options(no_tags_query, tag_query, "Some", orderByAsset, fields, Object.assign({}, pOptions, {
            use_index: indexesToUse[1]
          }), function (pData) {
            if (found === undefined) {
              found = true;
              that._addTagsAndLoad(pData, "file", pID).then(pDefer.resolve, pDefer.reject);
            }
          }, pDefer.reject);
        }
      });
    },
    _getTagsFolderList: function _getTagsFolderList(no_tags_query, tag_query, orderByFolder, pOptions, pID) {
      var that = this;
      // no control on ID needed, this is called immediatly
      return $.Deferred(function (pDefer) {
        api_async.folder.list_with_tag_query_and_options(no_tags_query, tag_query, "Some", orderByFolder, ["cloudflow", "name", "size"], pOptions, function (pData) {
          that._addTagsAndLoad(pData, "folder", pID).then(pDefer.resolve, pDefer.reject);
        }, pDefer.reject);
      });
    },
    _getAssetsList: function _getAssetsList(pQuery, pOrderBy, pOptions, pAddTags, pID) {
      if (this.options.foldersOnly === true) {
        return $.Deferred().resolve({
          results: []
        });
      }
      var that = this;
      // no control on ID needed, this is called imediatly
      return $.Deferred(function (pDefer) {
        api_async.asset.list_with_options(pQuery, pOrderBy, ["url", "sub", "cloudflow", "thumb", "approvals", "modtime", "filetype", "sync_status", "file_name", "file_time", "mime_types", "proofscope.uuid", "proofscope3d.id", "metadata.page_limit", "metadata.number_of_pages", "metadata.output_color_space.colorants", "file_size"], pOptions, function (pData) {
          if (pAddTags === true) {
            that._addTagsAndLoad(pData, "file", pID).then(pDefer.resolve, pDefer.reject);
          } else {
            pDefer.resolve(pData);
          }
        }, pDefer.reject);
      });
    },
    _getAssetsListMultiIndex: function _getAssetsListMultiIndex(pQuery, pOrderBy, pOptions, pAddTags, pID) {
      if (this.options.foldersOnly === true) {
        return $.Deferred().resolve({
          results: []
        });
      }
      var that = this;
      // no control on ID needed, this is called imediatly
      return $.Deferred(function (pDefer) {
        var fields = ["url", "sub", "cloudflow", "thumb", "approvals", "modtime", "filetype", "sync_status", "file_name", "file_time", "mime_types", "proofscope.uuid", "proofscope3d.id", "metadata.page_limit", "metadata.number_of_pages", "metadata.output_color_space.colorants", "file_size"];
        var indexesToUse = getSearchAssetIndexes(pOptions.use_index);
        var found;
        // fast index
        api_async.asset.list_with_options(pQuery, pOrderBy, fields, Object.assign({}, pOptions, {
          use_index: indexesToUse[0]
        }), function (pData) {
          if (pData === undefined) {
            throw new Error("folderview._getAssetsListMultiIndex wrong return interface");
          }
          if (found === undefined) {
            if (indexesToUse.length === 1 || Array.isArray(pData.results) && pData.results.length > 0) {
              found = true;
              if (pAddTags === true) {
                that._addTagsAndLoad(pData, "file", pID).then(pDefer.resolve, pDefer.reject);
              } else {
                pDefer.resolve(pData);
              }
            }
          }
        }, pDefer.reject);
        if (indexesToUse.length > 1) {
          // slow index        
          api_async.asset.list_with_options(pQuery, pOrderBy, fields, Object.assign({}, pOptions, {
            use_index: indexesToUse[1]
          }), function (pData) {
            if (pData === undefined) {
              throw new Error("folderview._getAssetsListMultiIndex wrong return interface");
            }
            if (found === undefined) {
              found = true;
              if (pAddTags === true) {
                that._addTagsAndLoad(pData, "file", pID).then(pDefer.resolve, pDefer.reject);
              } else {
                pDefer.resolve(pData);
              }
            }
          }, pDefer.reject);
        }
      });
    },
    _getFoldersList: function _getFoldersList(pQuery, pOrderBy, pOptions, pAddParentFolder, pAddTags, pID) {
      var that = this;
      // no control on ID needed, this is called immediatly
      return $.Deferred(function (pDefer) {
        api_async.folder.list_with_options(pQuery, pOrderBy, ["_id", "cloudflow", "name", "path", "size"], pOptions, function (pData) {
          function addSpecificFolders(pData) {
            //do recyclebin first, so it appears under the parent folder link
            if (that.preferences.recyclebin === true && that.options.rootFolder !== that.m_enclosing_folder && that.m_enclosing_folder !== "") {
              var recyclebin = {
                cloudflow: {
                  enclosing_folder: "cloudflow://PP_FILE_STORE/",
                  folder: "",
                  recyclebin: true
                }
              };
              pData.results.unshift(recyclebin);
            }
            if (pAddParentFolder === true) {
              if (that.options.rootFolder === that.m_enclosing_folder) {
                return; // add no parents at all
              }

              if (that.m_enclosing_folder !== "") {
                var upFolder = {
                  cloudflow: {
                    enclosing_folder: that.m_enclosing_folder,
                    folder: that.m_enclosing_folder.substring(0, that.m_enclosing_folder.substring(0, that.m_enclosing_folder.length - 1).lastIndexOf("/") + 1),
                    parent: true
                  }
                };
                pData.results.unshift(upFolder);
              } else if (typeof that.options.site === "string" && that.options.site.length > 0) {
                // if no parentfolder need to add, and we are in a site situation, whith is not the parent, add "go to parent site"
                var upSite = {
                  parent: true,
                  site: true,
                  cloudflow: {
                    enclosing_folder: that.m_enclosing_folder,
                    folder: "/parent/",
                    parent: true
                  }
                };
                pData.results.unshift(upSite);
              }
            }
          }
          ;
          if (pAddTags === true) {
            that._addTagsAndLoad(pData, "folder", pID).done(function (pResults) {
              addSpecificFolders(pData);
              pDefer.resolve(pData);
            }).fail(function (pError) {
              console.error(pError);
              addSpecificFolders(pData);
              pDefer.resolve(pData);
            });
          } else {
            addSpecificFolders(pData);
            pDefer.resolve(pData);
          }
        }, pDefer.reject);
      });
    },
    /**
     * @desc load all the tags and add to the files, call afterwards the filesLoaded()
     * @function
     * @private
     * @name nixps-cloudflow.FolderView#_addTagsAndLoad
     * @param {type} p_data
     * @returns {undefined}
     */
    _addTagsAndLoad: function _addTagsAndLoad(pData, pAssetKind, pID) {
      var that = this;
      return $.Deferred(function (pDefer) {
        if (that.callingID !== pID) {
          //controlling
          pDefer.reject("Different calling ID");
          return true;
        }
        if (pData.results.length === 0) {
          pDefer.resolve(pData);
          return true;
        }
        var files = {},
          folders = {};
        if (pAssetKind === "file") {
          var query = ["assets", "in", "("];
          for (var i = 0, leng = pData.results.length; i < leng; i++) {
            query.push(pData.results[i].cloudflow.file);
            files[pData.results[i].cloudflow.file] = i;
            pData.results[i].tags = [];
          }
          query.push(")");
        } else if (pAssetKind === "folder") {
          var query = ["folders", "in", "("];
          for (var i = 0, leng = pData.results.length; i < leng; i++) {
            query.push(pData.results[i].cloudflow.folder);
            folders[pData.results[i].cloudflow.folder] = i;
            pData.results[i].tags = [];
          }
          query.push(")");
        }
        query = ["(", "not", "name", "begins with", kTechnicalTagsPrefix, ")", "and"].concat(query); // this will hide/filter technical tags
        api_async.tag.list(query, ["name", "assets", "folders"], function (res) {
          if (that.callingID !== pID) {
            // control again
            pDefer.reject("Different calling ID");
            return true;
          }
          var temp;
          if (pAssetKind === "file") {
            for (var ind = 0, leng = res.results.length; ind < leng; ind++) {
              var elem = res.results[ind];
              for (var iAsset = 0, assetLeng = elem.assets.length; iAsset < assetLeng; iAsset++) {
                temp = files[elem.assets[iAsset]];
                if (temp !== undefined) {
                  pData.results[temp].tags.push(elem.name);
                }
              }
            }
          } else if (pAssetKind === "folder") {
            for (var ind = 0, leng = res.results.length; ind < leng; ind++) {
              var elem = res.results[ind];
              for (var iAsset = 0, folderLeng = elem.folders.length; iAsset < folderLeng; iAsset++) {
                temp = folders[elem.folders[iAsset]];
                if (temp !== undefined) {
                  pData.results[temp].tags.push(elem.name);
                }
              }
            }
          }
          pDefer.resolve(pData);
        }, function (error) {
          console.error(error);
          pDefer.resolve(pData);
        });
      });
    },
    _addFilesAndFoldersAfterwards: function _addFilesAndFoldersAfterwards(pFolderData, pFilesData, pAddTags, pCallID) {
      if (this.callingID === pCallID) {
        var assetsToAdd = false;
        if (Array.isArray(pFilesData.results) && pFilesData.results.length > 0) {
          if (Array.isArray(this.m_files) === false) {
            this.m_files = [];
          }
          this.m_files = this.m_files.concat(pFilesData.results);
          assetsToAdd = true;
        }
        if (Array.isArray(pFolderData.results) && pFolderData.results.length > 0) {
          if (Array.isArray(this.m_folders) === false) {
            this.m_folders = [];
          }
          this.m_folders = this.m_folders.concat(pFolderData.results);
          assetsToAdd = true;
        }
        if (assetsToAdd === false) {
          // no assets to ba added
          return;
        }
        this.m_combinedview.CombinedView({
          "files": this.m_files,
          "folders": this.m_folders
        });

        // add tags afterwards
        // ToDo Refactor
        if (pAddTags === true) {
          var that = this;
          $.when(this._addTagsAndLoad(pFilesData, "file", pCallID), this._addTagsAndLoad(pFolderData, "folder", pCallID)).done(function (pFiles, pFolders) {
            that._insertTags(pFiles.results, pFolders.results);
          });
        }
      }
    },
    _insertTags: function _insertTags(pFilesDataResults, pFoldersDataResults) {
      for (var i = 0; i < pFoldersDataResults.length; i++) {
        var tags = pFoldersDataResults[i].tags;
        if (tags.length === 0) {
          continue;
        }
        if (this.m_folders[i]._id === pFoldersDataResults[i]._id) {
          this.m_folders[i].tags = pFoldersDataResults[i].tags;
        }
      }
      for (var i = 0; i < pFilesDataResults.length; i++) {
        var tags = pFilesDataResults[i].tags;
        if (tags.length === 0) {
          continue;
        }
        if (this.m_files[i]._id === pFilesDataResults[i]._id) {
          this.m_files[i].tags = pFilesDataResults[i].tags;
        }
      }
      this.m_combinedview.CombinedView({
        "files": this.m_files,
        "folders": this.m_folders
      });
    },
    _filesAndFolderInjection: function _filesAndFolderInjection(pFolderData, pFilesData, pAddTags, pCallID) {
      if (this.callingID === pCallID) {
        // add dummy files
        if (filesInMakingDict[this.options.cf_url] !== undefined) {
          pFilesData.results = pFilesData.results.concat(filesInMakingDict[this.options.cf_url]);
        }
        if (foldersInMakingDict[this.options.cf_url] !== undefined) {
          //remove dummies that have been returned by the api call
          var dictClurls = [];
          for (var i = 0; i < foldersInMakingDict[this.options.cf_url].length; i++) {
            if (foldersInMakingDict[this.options.cf_url][i].cloudflow.confirmed_folder !== undefined) {
              dictClurls.push(foldersInMakingDict[this.options.cf_url][i].cloudflow.confirmed_folder);
            } else {
              dictClurls.push(foldersInMakingDict[this.options.cf_url][i].cloudflow.folder);
            }
          }
          for (var i = 0; i < pFolderData.results.length; i++) {
            if (dictClurls.indexOf(pFolderData.results[i].cloudflow.folder) > -1) {
              foldersInMakingDict[this.options.cf_url].splice(dictClurls.indexOf(pFolderData.results[i].cloudflow.folder), 1);
            }
          }
          // add dummy folders
          pFolderData.results = pFolderData.results.concat(foldersInMakingDict[this.options.cf_url]);
        }
        if (Array.isArray(pFilesData.results)) {
          this.m_files = pFilesData.results;
        }
        if (Array.isArray(pFolderData.results)) {
          this.m_folders = pFolderData.results;
        }
        var columns = [];
        if (this._isSearching()) {
          columns = this.options.columnsWhenSearching.slice();
        } else {
          columns = this.options.columnsOnDefault.slice();
        }
        var viewChangeTriggerData = {};
        var isFolderBook = containFolderABook(this.m_files, this.m_folders);
        if (isFolderBook === true) {
          viewChangeTriggerData.possible_views = [FolderViews.types.READER];
        } else {
          if (this.options.view === FolderViews.types.READER || this.options.view == FolderViews.types.ICON_CHOOSER) {
            // was book, but now not
            viewChangeTriggerData.possible_views = [];
          }
        }
        if (this.options.view == FolderViews.types.ICON_CHOOSER) {
          viewChangeTriggerData.view = isFolderBook ? FolderViews.types.READER : FolderViews.types.ICON;
          this.view = viewChangeTriggerData.view;
        }
        if (!$.isEmptyObject(viewChangeTriggerData)) {
          this._trigger("viewchange", null, viewChangeTriggerData);
        }
        this.m_combinedview.CombinedView({
          columns: columns,
          limit: this.askingLimit - 1,
          files: this.m_files,
          folders: this.m_folders,
          lockFolder: this.options.lockFolder,
          view: this.options.view == FolderViews.types.ICON_CHOOSER ? isFolderBook ? FolderViews.types.READER : FolderViews.types.ICON : this.options.view
        });
        this._drawCallBackFunction();

        // if needed, ask immediatly for the rest of files...
        // this is needed if there is a overflow, but do not repeat!              
        if (this.m_files.length === this.askingLimit && this.askingLimit < kLimitBookViewPages && (this.options.view === FolderViews.types.READER || this.options.view == FolderViews.types.ICON_CHOOSER && isFolderBook)) {
          this.askingLimit = kLimitBookViewPages;
          this.orderBy = []; // sorting done by readerView component
          this._reloadData();
        }

        // add tags afterwards
        if (pAddTags === true) {
          var that = this;
          $.when(this._addTagsAndLoad(pFilesData, "file", pCallID), this._addTagsAndLoad(pFolderData, "folder", pCallID)).done(function (pFiles, pFolders) {
            that.m_listview.ListView("insertTags", pFiles.results, pFolders.results);
          });
        }
      }
    },
    _isSearching: function _isSearching() {
      return Array.isArray(this.options.search_query) && this.options.search_query.length > 0 || Array.isArray(this.options.search_folder_query) && this.options.search_folder_query.length > 0;
    },
    _triggerTimer: function _triggerTimer() {
      // control on document !== true, because there  are some rare browser who dont know document.hidden
      // this give undefined !== true, so the optimalisation only works on "normal updated" browsers
      if (this.options.refreshDelay > 0 && (!Array.isArray(this.options.search_query) || this.options.search_query.length === 0) && document.hidden !== true) {
        clearTimeout(this.delayTimerID);
        this.delayTimerID = this._delay(function () {
          if (this.element.is(":hidden")) {
            this._triggerTimer();
          } else {
            this._reload();
          }
        }, Device.getPollingFactor(this.uuid) * this.options.refreshDelay);
      }
    },
    _pauseTimer: function _pauseTimer() {
      clearTimeout(this.delayTimerID);
    },
    _restartTimer: function _restartTimer() {
      this._triggerTimer();
    },
    /**
     * @description start the timer, after 1.5 sec a loading text will be showing: that the system is loading the items
     * @function
     * @private
     * @name nixps-cloudflow.FolderView#_startLoading
     * @return {undefined}
     */
    _startLoading: function _startLoading() {
      clearTimeout(this.loadingPanelTimerID);
      this.loadingPanelTimerID = this._delay(function () {
        this.element.children(".folderview_loadingpanel").show();
      }, 1500);
    },
    /**
     * @description hide the panel that indicated the user to wait for the items
     * @function
     * @private
     * @name nixps-cloudflow.FolderView#_endLoading
     * @return {undefined}
     */
    _endLoading: function _endLoading() {
      clearTimeout(this.loadingPanelTimerID);
      this.element.children(".folderview_loadingpanel").hide();
    },
    redraw: function redraw() {
      this._reload();
    },
    errorDropped: function errorDropped() {
      /** @todo add general stuff, here we remove all dropping items layout ven for those who are still in process !!!! ***/
      this.element.find(".item_deleting").removeClass("item_deleting").removeClass("item_processing");
    },
    /**
     * @description Ask to add a dummy folder, who is in a process of makeing. So it does not exists but will be
     * @function
     * @name nixps-cloudflow.FolderView#addFolderInMaking
     * @param {String} pFolderName 
     * @param {String} pInMakingID 
     * @param {String} pParentUrl 
     * @rturns {undefined}
     */
    addFolderInMaking: function addFolderInMaking(pFolderName, pInMakingID, pParentUrl) {
      if (typeof pFolderName === "string" && pFolderName.length > 0) {
        if (foldersInMakingDict[pParentUrl] === undefined) {
          foldersInMakingDict[pParentUrl] = [];
        }
        var folderDataItem = {
          name: decodeURI(pFolderName),
          _id: "inmakingid_" + pInMakingID,
          cloudflow: {
            folder: pParentUrl + pFolderName + "/"
          }
        };
        foldersInMakingDict[pParentUrl].push(folderDataItem);
        if (pParentUrl === this.options.cf_url) {
          var folders = $.map(this.m_folders, function (elem) {
            return elem;
          });
          folders.push(folderDataItem);
          this.m_folders = folders;
          this.m_combinedview.CombinedView({
            "folders": this.m_folders
          });
        }
      }
    },
    /**
     * @description Ask to add a dummy File, who is in a process of makeing. So it does not exists but will be
     * @function
     * @name nixps-cloudflow.FolderView#addFolderInMaking
     * @param {String} pFileName 
     * @param {String} pInMakingID 
     * @param {String} pParentUrl 
     * @returns {undefined}
     */
    addFileInMaking: function addFileInMaking(pFileName, pInMakingID, pParentUrl) {
      if (typeof pFileName === "string" && pFileName.length > 0) {
        if (filesInMakingDict[pParentUrl] === undefined) {
          filesInMakingDict[pParentUrl] = [];
        }
        var fileDataItem = {
          file_name: decodeURI(pFileName),
          _id: "inmakingid_" + pInMakingID,
          cloudflow: {
            file: pParentUrl + pFileName,
            part: pParentUrl + pFileName
          }
        };
        filesInMakingDict[pParentUrl].push(fileDataItem);
        if (pParentUrl === this.options.cf_url) {
          var files = this.m_files.map(function (elem) {
            return elem;
          });
          files.push(fileDataItem);
          this.m_files = files;
          this.m_combinedview.CombinedView({
            "files": this.m_files
          });
        }
      }
    },
    /**
     * @description Remove the dummy folder
     * @function
     * @name nixps-cloudflow.FolderView#removeFolderInMaking
     * @param {String} pInMakingID 
     * @param {Boolean} pReload 
     * @param {String} pActualFolder 
     * @returns {undefined}
     */
    removeFolderInMaking: function removeFolderInMaking(pInMakingID, pReload, pActualFolder) {
      var pFolderUrl;
      $.each(foldersInMakingDict, function (key, value) {
        for (var i = 0; i < value.length; i++) {
          if (value[i]._id === "inmakingid_" + pInMakingID) {
            pFolderUrl = key;
            //foldersInMakingDict[key].splice(i, 1);
            foldersInMakingDict[key][i].cloudflow.confirmed_folder = pActualFolder;
            return false;
          }
        }
      });
      if (typeof pFolderUrl === "string" && pFolderUrl === this.options.cf_url && (pReload === undefined || pReload === true)) {
        // if we removed a asset that is in the current folder we view, refresh the view
        this._reloadData();
      }
    },
    /**
     * @description Remove the dummy file
     * @function
     * @name nixps-cloudflow.FolderView#removeFileInMaking
     * @param {String} pInMakingID 
     * @param {Boolean} pReload 
     * @returns {undefined}
     */
    removeFileInMaking: function removeFileInMaking(pInMakingID, pReload) {
      var pFolderParentUrl;
      $.each(filesInMakingDict, function (key, value) {
        for (var i = 0; i < value.length; i++) {
          if (value[i]._id === "inmakingid_" + pInMakingID) {
            pFolderParentUrl = key;
            filesInMakingDict[key].splice(i, 1);
            return false;
          }
        }
      });
      if (typeof pFolderParentUrl === "string" && pFolderParentUrl === this.options.cf_url && (pReload === undefined || pReload === true)) {
        // if we removed a asset that is in the current folder we view, refresh the view
        this._reloadData();
      }
    },
    reloadFolderView: function reloadFolderView() {
      this._reloadData();
    },
    action: function action(pAction, pData) {
      this.m_combinedview.CombinedView("action", pAction, pData);
      if (pAction === "sort") {
        // sorting action only when iconview is active
        this.orderBy = pData;
        this._reloadDataAndInform();
      } else if (pAction === "browserSearch") {
        // action when user is searching with browser
        // only ask more items if they are not loaded yet!
        if (this.askingLimit < kMaxLimitAssets + 1) {
          this.askingLimit = kMaxLimitAssets + 1;
          this._reloadData();
        }
      }
    },
    /**
     * @name nixps-cloudflow.FolderView#getOrderByQuery
     * @description Get the current orderBy query
     * @function
     * @returns {Array}
     */
    getOrderByQuery: function getOrderByQuery() {
      return this.orderBy;
    },
    /**
     * @name nixps-cloudflow.FolderView#containsFile
     * @description Control if there is a file with filename pFileName
     * @function
     * @param {String} pFilename - the filename to control on
     * @returns {Boolean} true if there is a file with that name, false if there is no file with that name
     */
    containsFile: function containsFile(pFilename, pLookDeep) {
      var filename = pFilename;
      if (typeof pFilename.normalize === "function") {
        filename = pFilename.normalize("NFC");
      }
      var leng = this.m_files.length;
      for (var i = 0; i < leng; i++) {
        if (this.m_files[i].file_name === filename) {
          return true;
        }
      }
      // sometimes a file is not loaded because there is set a limit, 
      // if not found in the visible files, do a request, perhapse it is in one of the hidden files
      if (pLookDeep === true) {
        var that = this;
        var query = ["sub", "equal to", "", "and", "cloudflow.enclosing_folder", "equal to", this.m_enclosing_folder, "and", "file_name", "equal to", filename];
        return $.Deferred(function (pDefer) {
          api_async.asset.list_with_options(query, [], ["_id"], {
            maximum: 1
          }, function (pResults) {
            if (pResults !== undefined && Array.isArray(pResults.results) && pResults.results.length > 0) {
              pDefer.resolve(true);
            } else {
              pDefer.resolve(false);
            }
          }, function (pError) {
            console.error(pError);
            pDefer.reject(pError);
          });
        });
      }
      return false;
    },
    /**
     * @name nixps-cloudflow.FolderView#getSelectedItems
     * @description Get all data of all selected files
     * @function
     * @return {Array} array of all data of all selected assets
     */
    getSelectedItems: function getSelectedItems() {
      return this.m_combinedview.CombinedView("getSelectedItems");
    },
    setSelection: function setSelection(pSelection) {
      if (Array.isArray(pSelection) && pSelection.length > 0) {
        this.m_combinedview.CombinedView("action", "selectItems", pSelection);
      } else {
        this.m_combinedview.CombinedView("action", "unselectAll");
      }
    },
    setOptionsReturnDeferred: function setOptionsReturnDeferred(pOptions, pCleanRedraw) {
      var returnOutput = $.Deferred();
      this._setOptions(pOptions, function (pResults) {
        returnOutput.resolve(pResults);
      }, pCleanRedraw);
      return returnOutput;
    },
    /**
     * @description save the settings
     * @function
     * @private
     * @name nixps-cloudflow.FolderView#_savePreferences
     * @returns {undefined}
     */
    _savePreferences: function _savePreferences() {
      this._trigger("changepreferences", null, {
        preferences: this.preferences
      });
    },
    _setOptions: function _setOptions(p_options, pCallback, pCleanRedraw) {
      var cleanRedraw = false;
      var redraw = false;
      var viewChanged = false;
      if (p_options.cf_url !== undefined && this.options.cf_url !== p_options.cf_url) {
        cleanRedraw = true;
      } else if (p_options.search_query !== undefined && _.isEqual(p_options.search_query, this.options.search_query) === false) {
        cleanRedraw = true;
      } else if (p_options.search_folder_query !== undefined && _.isEqual(p_options.search_folder_query, this.options.search_folder_query) === false) {
        cleanRedraw = true;
      } else if (p_options.view !== undefined && this.options.view !== p_options.view) {
        redraw = true;
        viewChanged = true;
      } else if (p_options.site !== undefined && this.options.site !== p_options.site) {
        cleanRedraw = true;
      } else if (pCleanRedraw) {
        cleanRedraw = pCleanRedraw;
      }
      this._super(p_options);
      // do normal stuff
      if (cleanRedraw) {
        //do go to other folder, re init limit settings 
        if (this.preferences !== undefined && typeof this.preferences.assetLimit === "number" && this.preferences.assetLimit > 0) {
          this.askingLimit = this.preferences.assetLimit + 1;
        } else {
          this.askingLimit = kInitLimit + 1;
        }
        this.m_files = [];
        this.m_folders = [];
        if (this.options.view !== FolderViews.types.ICON_CHOOSER) {
          this.view = this.options.view;
        }
        this._redraw();
        if (typeof pCallback === "function") {
          var that = this;
          this._drawCallBackFunction = function () {
            pCallback();
            that._drawCallBackFunction = function () {};
          };
        }
        this._reload();
      } else if (redraw) {
        if (viewChanged) {
          if (p_options.view === FolderViews.types.ICON_CHOOSER) {
            // only view has been changed
            var viewChangeTriggerData = {};
            var isFolderBook = containFolderABook(this.m_files, this.m_folders);
            if (isFolderBook === true) {
              viewChangeTriggerData.possible_views = [FolderViews.types.READER];
            } else {
              viewChangeTriggerData.possible_views = [];
            }
            this.view = isFolderBook ? FolderViews.types.READER : FolderViews.types.ICON;
            viewChangeTriggerData.view = this.view;
            this._trigger("viewchange", null, viewChangeTriggerData);
          } else {
            this.view = p_options.view;
          }
        }
        this._redraw();
        if (typeof pCallback === "function") {
          pCallback();
        }
      } else {
        this._redraw();
        if (typeof pCallback === "function") {
          pCallback();
        }
      }
    },
    /**
     * @description called when object will be destroyed
     * @function
     * @name nixps-cloudflow.FolderView#_destroy
     * @private
     * @return {undefined}
     */
    _destroy: function _destroy() {
      clearTimeout(this.delayTimerID);
      clearTimeout(this.loadingPanelTimerID);
      this._super();
    }
  });
})(jQuery);

},{"../../../polyfill/polyfill.js":433,"../../CombinedView/js/nixps-cloudflow-CombinedView.js":95,"../../PWA/js/Device.js":198,"../../Sites/js/Sites.js":207,"../../Table/js/Query.js":211,"./FolderViews.js":134,"./QueryUtil.js":135}],137:[function(require,module,exports){
"use strict";

/* 
 * This file must contains all items what can be added by the formbuilder
 * It is used to include everywhere the kiosk component is included, so the parents does not need to unclude all the sub components them self
 * Do not add items to this list!!
 * except for the rip settings
 */
require("./nixps-cloudflow-ErrorMessage.js");
require("./nixps-cloudflow-Image.js");
require("./nixps-cloudflow-Title.js");
require("./nixps-cloudflow-FormAgreement.js");
require("../../../common/Popup/js/nixps-Popup.js");
require("../../../common/PanelSeparator/js/nixps-PanelSeparator.js");
// inputs
require("./nixps-cloudflow-Select.js");
require("./nixps-cloudflow-Input.js");
require("./nixps-cloudflow-RadioInput.js");
require("./nixps-cloudflow-RadioInputs.js");
require("./nixps-cloudflow-ReadOnlyInput.js");
require("./nixps-cloudflow-ArrayInput.js");
require("./nixps-cloudflow-AutoFill.js");
require("./nixps-cloudflow-InteractionSelect.js");
require("../../ManageUsers/js/nixps-cloudflow-TagList.js");
require("./nixps-cloudflow-DatetimeSelector.js");
require("./nixps-cloudflow-CalendarSelector.js");
require("./nixps-cloudflow-CalendarSelectorWConnector.js");
require("./nixps-cloudflow-ShowHideCheckBox.js");
require("./nixps-cloudflow-MultiSelect.js");
require("./nixps-cloudflow-ValueInput.js");
require("./nixps-cloudflow-FormListItemRepeater.js");
require("./nixps-cloudflow-ConfigurePlainObject.js");
require("./nixps-cloudflow-AutoFillExtend.js");
require("./nixps-cloudflow-TranslationInput.js");
require("./nixps-cloudflow-Password.js");
require("../../PathChooser/js/nixps-cloudflow-PathChooser.js");
require("../../TranslatedLanguagesSelector/js/nixps-cloudflow-TranslatedLanguagesSelector.js");
require("../../../pagebuilder/js/nixps-cloudflow-ExpressionBuilderInput.js");
require("../../../colorspace/js/nixps-colorspace-ColorspaceSettings.js");
// for rip settings
require("./nixps-cloudflow-ScreenSelector.js");
require("./nixps-cloudflow-ResourceSelector.js");
require("../../Team/js/nixps-cloudflow-TeamFormImpl.js");
require("../../Team/js/nixps-cloudflow-MemberListImpl.js");
require("../../Team/js/nixps-cloudflow-MemberListByRoleImpl.js");
require("../../../common/RIPEditor/js/nixps-RIPEditor-main.js");

},{"../../../colorspace/js/nixps-colorspace-ColorspaceSettings.js":274,"../../../common/PanelSeparator/js/nixps-PanelSeparator.js":300,"../../../common/Popup/js/nixps-Popup.js":301,"../../../common/RIPEditor/js/nixps-RIPEditor-main.js":303,"../../../pagebuilder/js/nixps-cloudflow-ExpressionBuilderInput.js":432,"../../ManageUsers/js/nixps-cloudflow-TagList.js":185,"../../PathChooser/js/nixps-cloudflow-PathChooser.js":200,"../../Team/js/nixps-cloudflow-MemberListByRoleImpl.js":224,"../../Team/js/nixps-cloudflow-MemberListImpl.js":225,"../../Team/js/nixps-cloudflow-TeamFormImpl.js":227,"../../TranslatedLanguagesSelector/js/nixps-cloudflow-TranslatedLanguagesSelector.js":238,"./nixps-cloudflow-ArrayInput.js":138,"./nixps-cloudflow-AutoFill.js":139,"./nixps-cloudflow-AutoFillExtend.js":140,"./nixps-cloudflow-CalendarSelector.js":142,"./nixps-cloudflow-CalendarSelectorWConnector.js":143,"./nixps-cloudflow-ConfigurePlainObject.js":144,"./nixps-cloudflow-DatetimeSelector.js":145,"./nixps-cloudflow-ErrorMessage.js":146,"./nixps-cloudflow-FormAgreement.js":147,"./nixps-cloudflow-FormListItemRepeater.js":148,"./nixps-cloudflow-Image.js":149,"./nixps-cloudflow-Input.js":150,"./nixps-cloudflow-InteractionSelect.js":151,"./nixps-cloudflow-MultiSelect.js":153,"./nixps-cloudflow-Password.js":154,"./nixps-cloudflow-RadioInput.js":155,"./nixps-cloudflow-RadioInputs.js":156,"./nixps-cloudflow-ReadOnlyInput.js":157,"./nixps-cloudflow-ResourceSelector.js":158,"./nixps-cloudflow-ScreenSelector.js":159,"./nixps-cloudflow-Select.js":160,"./nixps-cloudflow-ShowHideCheckBox.js":161,"./nixps-cloudflow-Title.js":162,"./nixps-cloudflow-TranslationInput.js":163,"./nixps-cloudflow-ValueInput.js":164}],138:[function(require,module,exports){
"use strict";

/* 
 * 
 *   created by guillaume on Dec 21, 2016 3:00:24 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @description check if the object has the interface of a tree array
   * @function
   * @private
   * @param {type} pNode
   * @return {Boolean} true if the interfase of the obejct correspond to the array node
   */
  function isArrayTreeNode(pNode) {
    if (!Array.isArray(pNode) || pNode.length <= 0) {
      return false;
    }
    for (var i = 0; i < pNode.length; i++) {
      if (!$.isPlainObject(pNode[i]) || pNode[i].key === undefined || Array.isArray(pNode[i].value) === false || pNode[i].value.length <= 0) {
        return false;
      }
    }
    return true;
  }
  ;

  /**
   * @description transform the input to a usefull array to be given to a selector
   * @function
   * @private
   * @param {type} pValue
   * @return {Array}
   */
  function transformToArray(pValue) {
    // if array, give it back, as it
    if (Array.isArray(pValue)) {
      return pValue;
      // if a string, beginning and ending with delimitters, pase it to array
    } else if (typeof pValue === "string" && pValue.length > 2 && pValue[0] === pValue[pValue.length - 1]) {
      var options = pValue.split(pValue[0]);
      var array = options.filter(function (pValue) {
        return pValue.length > 0;
      });
      return array;
      // if string has a stringified array
    } else if (typeof pValue === "string" && pValue[0] === "[" && pValue[pValue.length - 1] === "]") {
      try {
        var array = JSON.parse(pValue);
        return array;
      } catch (e) {
        console.error("could not transform value to array");
        return pValue;
      }
      // if not usefull but empty, convert to empty array
    } else if (typeof pValue === "string" && pValue.length <= 0 || pValue === undefined || pValue === null) {
      // values with no specifications, we translate to a empty array
      return [];
      // still not found? return as it
    } else {
      console.error("could not transform value to array");
      return pValue;
    }
  }
  /**
   * @namespace nixps-cloudflow.ArrayInput
   * @description A good UI for editing arrays. <br />
   * This events fires next events 
   * <ul>
   *  <li> VariableInput_enable: when there is just on item left</li>
   *  <li> VariableInput_disable: when there are more items </li>
   *  <li> change: when change has been made </li>
   * </ul>
   * @example $("<div>"").ArrayInput(value: ["a","b","c"]);
   * @private
   * @version "1.5.0"
   */
  $.widget("nixps-cloudflow.ArrayInput", $.Widget, {
    widgetEventPrefix: "arrayinput",
    version: "1.5.0",
    options: {
      /**
       * @name nixps-cloudflow.ArrayInput#value
       * @description The value to be showing
       * @type {array}
       * @default []
       */
      value: [],
      /**
       * @name nixps-cloudflow.ArrayInput#valueWhenEmpty
       * @description the value to be given to the array item, when the array/list is empty
       * @type {string}
       * @default ""
       */
      valueWhenEmpty: "",
      /**
       * @desciption Must we allow empty values
       * @name nixps-cloudflow.ArrayInput#allowEmptyValue
       * @type {Boolean}
       * @default false
       */
      allowEmptyValue: false,
      /**
       * @description Must we enforce arrays containing object that they have not empty keys and that those keys are unique?
       * @name nixps-cloudflow.ArrayInput#uniqueNotEmptyKeyRequired
       * @type {Boolean}
       * @default false
       * @since 1.3.0
       */
      uniqueNotEmptyKeyRequired: false,
      /**
       * @description must all keys be unique or not?
       * @name nixps-cloudflow.ArrayInput#uniqueKeyRequired
       * @type {Boolean}
       * @default false
       * @since 1.4.0
       */
      uniqueKeyRequired: false,
      /**
       * @description The input name of the component that cares about the value
       * @name nixps-cloudflow.ArrayInput#valueComponentName
       * @type {String}
       * @default "Input"
       * @since 1.1.0
       */
      valueComponentName: "Input",
      /**
       * @description The options to use during creating of the components who cares and are responsible about the values
       * @name nixps-cloudflow.ArrayInput#valueComponentOptions
       * @type {Object}
       * @default {
          "type": "text",
          "required": false,
          "classes": "form-control  cf-form-control"
      }
       * @since 1.1.0
       */
      valueComponentOptions: {
        "type": "text",
        "required": false,
        "classes": "form-control cf-form-control"
      },
      /**
       * @description The value when a new row is created
       * @name nixps-cloudflow.ArrayInput#newValue
       * @type {String}
       * @default "Input"
       * @since 1.2.0
       */
      newValue: "",
      /**
       * @description The name of the key to use for injecting the new value to the valueComponent
       * @name nixps-cloudflow.ArrayInput#valueComponentValueKeyName
       * @type {String}
       * @default "value"
       * @since 1.2.0
       */
      valueComponentValueKeyName: "value",
      /**
       * @description Is the field required?
       * @name nixps-cloudflow.ArrayInput#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.5.0
       */
      required: false
    },
    /**
     * @description create the component
     * @name nixps-cloudflow.ArrayInput#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.unvalidvalue; // container of plain object, with could not be converted to array
      this.list; // a simple, one level array 
      this.node; // a container for multiple level selectors

      this.setValue(this.options.value);
      if (this.options.disabled === true) {
        this.element.addClass(this.widgetFullName + "-disabled ui-state-disabled");
        this.element.find("button:disabled").attr("data-disabled", "true");
        this.element.find("button").prop("disabled", true);
      }
      this._on(this.element, {
        "change input": this._changeHandler,
        "click .arrayinput_add": this._addRowClickHandler,
        "click .arrayinput_remove": this._removeRowClickHandler
      });
    },
    /**
     * @description function rus when there is a change made by the user
     * @function
     * @private
     * @name nixps-cloudflow.ArrayInput#_changeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _changeHandler: function _changeHandler(pEvent, pData) {
      this._trigger("change", pEvent, {});
    },
    /**
     * @description function runs when user click on the add icon, to insert a new row
     * @function
     * @private
     * @name nixps-cloudflow.ArrayInput#_addRowClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _addRowClickHandler: function _addRowClickHandler(pEvent, pData) {
      this._addRowAction($(pEvent.target), this.options.newValue);
      this._trigger("change", pEvent, {});
    },
    _addRowAction: function _addRowAction(pTarget, pNewValue) {
      var row = pTarget.closest(".arrayinput_row");
      // if you want to add add higher level, add also children
      if (row.children(".arrayinput_children").length > 0) {
        row.after(this._makeRow(pNewValue, this._makeList([pNewValue], function () {})));
      } else {
        row.after(this._makeRow(pNewValue));
      }
      if (row.hasClass("arrayinput_emptyvalue")) {
        row.remove(); // remove also .arrayinput_fackinput
      }
      // select the new input fields
      pTarget.closest(".arrayinput_row").next().find("input").trigger("focus").trigger("select");
      // show the remove buttons, because now there are more then one row 
      pTarget.closest(".arrayinput_arraylist").children(".arrayinput_row").find(".arrayinput_remove").prop("disabled", false);
      // inform the variable input, that he can disable his pencil icon, to prevent overlapping buttons
      this.element.trigger("VariableInput_disable", {});
    },
    /**
     * @description function runs when user click on the remove button, to remove a row
     * @function
     * @private
     * @name nixps-cloudflow.ArrayInput#_removeRowClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _removeRowClickHandler: function _removeRowClickHandler(pEvent, pData) {
      var row = $(pEvent.target).closest(".arrayinput_row");
      // we will remove a row in the futur, so if there will be one left over (before removing 2 rows), hide the other remove buttons
      // to prevent removing the last row
      if (row.closest(".arrayinput_arraylist").children(".arrayinput_row").length <= 2 && this.options.allowEmptyValue === false) {
        row.closest(".arrayinput_arraylist").children(".arrayinput_row").children(".arrayinput_value").find(".arrayinput_remove").prop("disabled", true);
        // inform the variable input, that he can enable his pencil icon, to prevent overlapping buttons
        this.element.trigger("VariableInput_enable", {});
      }
      // check if we are the last
      if (row.closest(".arrayinput_arraylist").children(".arrayinput_row").length === 1 && this.options.allowEmptyValue === true) {
        row.addClass("arrayinput_emptyvalue");
        row.children(".arrayinput_value").children(".arrayinput_valuecontainer").addClass("arrayinput_fackinput").css("visibility", "hidden");
        row.children(".arrayinput_value").children(".arrayinput_remove").prop("disabled", true);
      } else {
        row.remove();
      }
      this._trigger("change", pEvent, {});
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps-cloudflow.ArrayInput#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the list according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.ArrayInput#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      if (this.unvalidvalue !== undefined) {
        // we can not convert to array, so just put the value in one input field
        this.element.append($("<div>").addClass("arrayinput_unvalidvalue").Input({
          type: "text",
          value: this.unvalidvalue,
          required: false,
          classes: "form-control cf-form-control",
          disabled: this.options.disabled
        }));
      } else if (Array.isArray(this.list)) {
        // it is just one level array
        this.element.append(this._makeList(this.list, function () {}));
      } else if (this.node !== undefined) {
        this.element.addClass("arrayinput_multilevel");
        // multiple level array
        var that = this;
        var rootValues = $.map(this.node, function (elem) {
          return elem.key;
        });
        this.element.append(this._makeList(rootValues, function (pItemIndex) {
          return that._makeList(that.node[pItemIndex].value, function () {});
        }));
      }
    },
    /**
     * @description make a list of rows
     * @function
     * @private
     * @name nixps-cloudflow.ArrayInput#_makeList
     * @param {array} pList
     * @param {function} pRowChildrenFunction
     * @return {unresolved}
     */
    _makeList: function _makeList(pList, pRowChildrenFunction) {
      var list = $("<div>").addClass("arrayinput_arraylist");
      for (var i = 0; i < pList.length; i++) {
        list.append(this._makeRow(pList[i], pRowChildrenFunction(i)));
      }
      if (pList.length === 0 && this.options.allowEmptyValue === true) {
        var newRow = this._makeRow("", pRowChildrenFunction(i));
        newRow.addClass("arrayinput_emptyvalue");
        newRow.children(".arrayinput_value").children(".arrayinput_valuecontainer").addClass("arrayinput_fackinput").css("visibility", "hidden");
        newRow.children(".arrayinput_value").children(".arrayinput_remove").prop("disabled", true);
        list.append(newRow);
      } else if (pList.length <= 1 && this.options.allowEmptyValue === false) {
        list.find(".arrayinput_remove").prop("disabled", true);
      }
      return list;
    },
    /**
     * @description make one row with inputfield and add/ remove buttons
     * @function
     * @private
     * @name nixps-cloudflow.ArrayInput#_makeRow
     * @param {type} pValue value to be added in the input field
     * @param {type} pChildren the htmlobject to be added at the end
     * @return {unresolved}
     */
    _makeRow: function _makeRow(pValue, pChildren) {
      var row = $("<div>").addClass("arrayinput_row");
      var rowValue = $("<div>").addClass("arrayinput_value");
      var optionsObject = {
        "disabled": this.options.disabled
      };
      optionsObject[this.options.valueComponentValueKeyName] = pValue;
      var createInputOptions = $.extend({}, this.options.valueComponentOptions, optionsObject);
      row.append(rowValue);
      rowValue.append($("<div>").addClass("arrayinput_valuecontainer")[this.options.valueComponentName](createInputOptions)).append($("<button>").attr("type", "button").addClass("cf-iconbutton cf-icon cf-icon-bg cf-icon-minus-circle arrayinput_remove").attr("title", $.i18n._("nixps-cloudflow-ArrayInput.remove_row"))).append($("<button>").attr("type", "button").addClass("cf-iconbutton cf-icon cf-icon-bg cf-icon-plus-circle arrayinput_add").attr("title", $.i18n._("nixps-cloudflow-ArrayInput.add_row")));
      if (pChildren !== undefined) {
        row.append($("<div>").addClass("arrayinput_children").append(pChildren));
      }
      return row;
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      if (options.valueComponentName !== undefined && options.valueComponentName !== this.options.valueComponentName) {
        needRedraw = true;
      } else if (options.valueComponentOptions !== undefined && _.isEqual(options.valueComponentOptions, this.options.valueComponentOptions) === false) {
        needRedraw = true;
      }
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      if (options.value !== undefined) {
        this.setValue(options.value);
      }
      if (needRedraw === true) {
        this._draw();
      }
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ArrayInput#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "disabled") {
        this._superApply(arguments);
        this._controlOptions();
        this.element.find(".nixps-cloudflow-Input").Input("option", "disabled", pValue);
        this.element.find(".nixps-cloudflow-TranslationInput").TranslationInput("option", "disabled", pValue);
        if (pValue === true) {
          this.element.find("button:disabled").attr("data-disabled", "true");
          this.element.find("button").prop("disabled", true);
        } else {
          this.element.find("button").not("[data-disabled=true]").prop("disabled", false);
          this.element.find("button[data-disabled=true]").attr("data-disabled", "");
        }
        return;
      }
      if (pKey === "required") {
        this._superApply(arguments);
        this._controlOptions();
        return;
      }
      this._superApply(arguments);
      this._controlOptions();
    },
    /**
     * @name nixps-cloudflow.ArrayInput#isValid
     * @description Validate the value
     * @function
     * @returns {Boolean} returns true if valid or a string containing the error message
     * @since 1.3.0
     */
    isValid: function isValid() {
      if (this.options.uniqueNotEmptyKeyRequired === true || this.options.uniqueKeyRequired === true) {
        var value = this.getValue();
        if (Array.isArray(value) && value.length > 0) {
          var keysDict = {};
          for (var i = 0; i < value.length; i++) {
            if ($.isPlainObject(value[i])) {
              if (this.options.uniqueNotEmptyKeyRequired && ("" + value[i].key).length === 0) {
                return $.i18n._("nixps-cloudflow-FormBuilder.validationmessage_missingkey");
              }
              if (keysDict[value[i].key] !== undefined) {
                return $.i18n._("nixps-cloudflow-FormBuilder.validationmessage_doublekey");
              } else {
                keysDict[value[i].key] = 1;
              }
            }
          }
        }
      }
      return true;
    },
    /**
     * @name nixps-cloudflow.ArrayInput#setValue
     * @description Set the input to a specific value
     * @function
     * @param {Array} pValue
     * @returns {undefined}
     */
    setValue: function setValue(pValue) {
      this.options.value = structuredClone(pValue);
      this.unvalidvalue = undefined;
      this.list = undefined;
      this.node = undefined;

      // if it is a plain object, just place this in one input field
      if ($.isPlainObject(this.options.value)) {
        this.unvalidvalue = JSON.stringify(this.options.value);
        // otherwise it can be an array, string, multilevel array, ...
      } else {
        // is it a multilevel array?
        if (isArrayTreeNode(this.options.value)) {
          this.node = this.options.value;
        } else {
          // no transform to array, just one level
          var possibleValue = transformToArray(this.options.value);
          if (!Array.isArray(possibleValue)) {
            this.unvalidvalue = this.options.value;
          } else if (possibleValue.length > 0) {
            this.list = possibleValue;
          } else if (possibleValue.length === 0 && this.options.allowEmptyValue === true) {
            this.list = [];
          } else {
            this.list = [this.options.valueWhenEmpty];
          }
        }
      }
      this._draw();
    },
    /**
     * @name nixps-cloudflow.ArrayInput#getValue
     * @description Get the value of the input
     * @function
     * @returns {Array}
     */
    getValue: function getValue() {
      // first check in with situation we are ...
      if (this.unvalidvalue !== undefined) {
        var unvalid = this.element.find(".arrayinput_unvalidvalue.nixps-cloudflow-Input").Input("getValue");
        try {
          // try to convert to object 
          return JSON.parse(unvalid);
        } catch (e) {
          // if there is a object, just give empty array
          return [this.options.valueWhenEmpty];
        }
      } else {
        var root = this._getArrayValue(this.element.children(".arrayinput_arraylist").children(".arrayinput_row").children(".arrayinput_value"));
        if (this.list !== undefined) {
          return root;
        } else {
          var output = [];
          var that = this;
          this.element.children(".arrayinput_arraylist").children(".arrayinput_row").each(function (index, elem) {
            var array = that._getArrayValue($(this).children(".arrayinput_children").children(".arrayinput_arraylist").children(".arrayinput_row").children(".arrayinput_value"));
            output.push({
              key: root[index],
              value: array
            });
          });
          return output;
        }
      }
    },
    reset: function reset() {
      return this.setValue([]);
    },
    /**
     * @description get all jquery Items
     * @function
     * @name nixps-cloudflow.ArrayInput#getAllItems
     * @returns {jQuery}
     */
    getAllItems: function getAllItems() {
      return this.element.find(".arrayinput_valuecontainer").not(".arrayinput_fackinput");
    },
    appendRows: function appendRows(pValues) {
      for (var i = 0; i < pValues.length; i++) {
        this._addRowAction(this.element.find(".arrayinput_add").last(), pValues[i]);
      }
    },
    /**
     * @description Get the values of the list 
     * @function
     * @private
     * @name nixps-cloudflow.ArrayInput#_getArrayValue
     * @param {html} pParent the html dom where to search
     * @return {Array}
     */
    _getArrayValue: function _getArrayValue(pParent) {
      var that = this;
      var output = [];
      pParent.children(".arrayinput_valuecontainer").not(".arrayinput_fackinput").each(function () {
        var value = $(this)[that.options.valueComponentName]("getValue");
        output.push(value);
      });
      return output;
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps-cloudflow.ArrayInput#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.allowEmptyValue !== "boolean") {
        throw new Error("ArrayInput: input option allowEmptyValue must be a boolean");
      }
      if (typeof this.options.valueComponentName !== "string" && this.options.valueComponentName.length <= 0) {
        throw new Error("ArrayInput: input option valueComponentName must be a not empty string");
      }
      if ($.fn[this.options.valueComponentName] === undefined) {
        throw new Error("ArrayInput: input option valueComponentName represends an unknown component");
      }
      if ($.isPlainObject(this.options.valueComponentOptions) === false) {
        throw new Error("ArrayInput: input option valueComponentOptions must be a plain object");
      }
    }
  });
})(jQuery);

},{}],139:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  var CloudflowConnection = require("../../CloudflowUtil/js/CloudflowConnection.js");
  require("../../ManageUsers/js/nixps-cloudflow-TagList.js");

  // own autocomplete where we add the possibility to change the list
  // so we can add "..." if there are limited by option maxAmountPosibilities
  $.widget("nixps-cloudflow.limitautocomplete", $.ui.autocomplete, {
    widgetEventPrefix: "limitautocomplete",
    options: {
      maxAmountPosibilities: -1
    },
    _renderMenu: function _renderMenu(ul, items) {
      // if there is a limit and if we recieve one more => we have tuckated the list.
      $(ul).css("zIndex", "1000");
      if (this.options.maxAmountPosibilities > 0 && items.length > this.options.maxAmountPosibilities) {
        items.pop(); //remove extra "useless" item
        this._superApply(arguments); // make list
        $(ul).append("..."); // add overload sign
      } else {
        this._superApply(arguments); // there are less items, do like normal
      }
    },

    _resizeMenu: function _resizeMenu() {
      // after the menu is drawed and is added to the DOM
      this._superApply(arguments);
      // go over all items and add a title if the text is overflowed
      this.menu.element.find("li div").each(function () {
        if (this.scrollWidth > this.clientWidth) {
          this.setAttribute("title", this.textContent);
        }
      });
    }
  });

  /**
   * @namespace nixps-cloudflow.AutoFill
   * @description This simulate a select to handle large amount of options.
   * It contains an input field with an arrow button. When you type, the matching items <i>({@link nixps-cloudflow.AutoFill#displayValueField})</i> will be show in the list.
   * <br/> Only items in the list can be selected. <br/> 
   * If a text does not match, it will be removed and an "not item fould" message will be visible. <br>
   * This component fires next events: 
   * <dl>
   *  <dt>change</dt><dd>Fires when a change in the value is detected. This will be fired when a blur occured. The data contains parameters "key" and "value". 
   *  The "key" is the value returned when calling {@link nixps-cloudflow.AutoFill#getValue}, The "value" is the string that was last visible by the user. It can also contain a field "found" <i>(boolean)</i>
   *  This "found" is set on true, if the value must and is be known. It is set on false, if the value must be known and is not known.</dd>
   *  <dt>select</dt><dd>Fires when the user select a specific value. The data contains parameters "value" and "key", who are the same as in the "change"-event</dd>
   * </dl>
   * @version 2.9.0
   */
  $.widget("nixps-cloudflow.AutoFill", $.Widget, {
    widgetEventPrefix: "autofill",
    version: "2.9.0",
    options: {
      /**
       * @name nixps-cloudflow.AutoFill#multiple
       * @description Set on true to accept multiple inputs. An extra input will be added after selecting one of the list.
       * @type {boolean}
       * @default false
       * @example true
       * @since 2.0.0
       */
      multiple: false,
      /**
       * @name nixps-cloudflow.AutoFill#selectedItemID
       * @description The id of the selected item.
       * @type {string}
       * @default undefined
       */
      selectedItemID: "",
      /**
       * @name nixps-cloudflow.AutoFill#getAllItems
       * @description Is a function that must return (a Defer Object) with the object dictionary as result. 
       * Use this of local data, leave this null for remote data. 
       * @type {function}
       * @default null
       */
      getAllItems: null,
      /**
       * @name nixps-cloudflow.AutoFill#collectionTable
       * @description The name of the table containing all the information, where you want to select from. this must be a custom table!
       * This corresponds with the "collection" from the custom_objects backend api.
       * @type {string}
       * @default ""
       */
      collectionTable: "",
      /**
       * @name nixps-cloudflow.AutoFill#collection
       * @description The name of the collection to be used.
       * @type {String}
       * @default ""
       * @example "nucleus.users"
       * @since 2.2.0
       */
      collection: "",
      /**
       * @description The filter to be used as general filter on the collection item. This can be used to prevent showing internal or technical items
       * @type {Array}
       * @default []
       * @since 2.2.0
       */
      collectionFilter: [],
      /**
       * @description The path to be used if the url is relative.
       * @name nixps-cloudflow.AutoFill#relativeBasePath
       * @private
       * @type {String}
       * @since 2.4.1
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.AutoFill#dataFileURL
       * @description the url of the data file to read
       * @type {String}
       * @default ""
       * @since 2.4.1
       */
      dataFileURL: "",
      /**
       * @name nixps-cloudflow.AutoFill#orderByQuery
       * @description The array order_by will order the elements. 
       * It must be compatible with the cloudflow backend api order_by query.
       * This will be passed through the backend api call
       * @type {array}
       * @default []
       */
      orderByQuery: [],
      /**
       * @name nixps-cloudflow.AutoFill#keyField
       * @description This is the name of the column in the collectionTable, where we will find the id/key to return if user select something.
       * The values found in that column will be the ids/keys of the selecting items.
       * @type {String}
       * @default "" 
       */
      keyField: "",
      /**
       * @name nixps-cloudflow.AutoFill#displayValueField
       * @description This is the name of the column in the collectionTable, where we will find the string to show to the user.
       * The values found in that column will be the display strings of the selecting items. Do not use "_id" bacause the mongo db can not search on keys.
       * @type {String}
       * @default "" 
       */
      displayValueField: "",
      /**
       * @name nixps-cloudflow.AutoFill#classes
       * @description class names spearated by space added to the input field
       * @type {String}
       * @default ""
       * @since 2.4.1
       */
      classes: "",
      /**
       * @name nixps-cloudflow.AutoFill#requireValueToBeOneOfList
       * @description Set this value on true, if you want to require that the input value set by the user must be one of proposed values. 
       * So the user can not add a free text. If this is set on false, the keys will be the same as the corresponding values.
       * @type {Boolean}
       * @private
       * @default true
       * @example false
       * @since 2.1.0
       */
      requireValueToBeOneOfList: true,
      /**
       * @name nixps-cloudflow.AutoFill#defaultValue
       * @description The value used if there are no items selected
       * @type {mixed}
       * @example null
       * @example ""
       * @since 2.4.0
       */
      defaultValue: null,
      /**
       * @name nixps-cloudflow.AutoFill#noItemFoundText
       * @description the text to show when no items has been found
       * @type {String}
       * @default ""
       */
      noItemFoundText: "",
      /**
       * @description must we display only unique display values
       * @name nixps-cloudflow.AutoFill#uniqueDisplayNames
       * @type {Boolean}
       * @default false
       * @since 2.5.0
       */
      uniqueDisplayNames: false,
      /**
       * @description can a user only select unique options
       * @name nixps-cloudflow.AutoFill#uniqueChooses
       * @type {Boolean}
       * @default false
       */
      uniqueChooses: false,
      enableClearButton: false,
      /**
       * @name nixps-cloudflow.AutoFill#position
       * @default the jquery ui position object to possition the dropdown list
       * @type {Object}
       * @default undefined
       * @since 2.6.0
       */
      position: undefined,
      /**
       * @name nixps-cloudflow.AutoFill#maxAmountPosibilities
       * @description Sometimes the returned list is to big. With this option you can add a limit to the possibilities.
       * works only on remote
       * @type {Number}
       * @default -1
       */
      maxAmountPosibilities: -1,
      /**
       * @name nixps-cloudflow.AutoFill#minLength
       * @description the minLength option for the autocomplete component, this is the min length typed to startbefore sugesting.
       * <a href="http://api.jqueryui.com/autocomplete/#option-minLength" > See autocomplete documentation </a>
       * @link http://api.jqueryui.com/autocomplete/#option-minLength
       * @type {Number}
       * @default 1
       */
      minLength: 1,
      /**
       * @name nixps-cloudflow.AutoFill#delay
       * @description The delay option for the autocomplete component, this is the time between keystroke and the start search.
       * <a href="http://api.jqueryui.com/autocomplete/#option-delay" > See autocomplete documentation </a>
       * @link http://api.jqueryui.com/autocomplete/#option-delay
       * @type {Number}
       * @default 300
       */
      delay: 300,
      /**
       * @description Must we show values that are used in the setValue methode, but who are not listed?
       * in that case it will be surrounded by brackets like "&nbsp;( key ) "
       * @name nixps-cloudflow.Autofill#showUnknownValue
       * @type {Boolean}
       * @default false
       * @since 2.7.0
       */
      showUnknownValue: false,
      /**
       * @description Is the field required?
       * @name nixps-cloudflow.Autofill#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 2.9.0
       */
      required: false,
      /**
       * @name nixps-cloudflow.Autofill#id
       * @description The id attribute, to be used for linking the label tag
       * @type {String}
       * @default undefined
       * @since 2.8.0
       */
      id: undefined,
      /**
       * @name nixps-cloudflow.Autofill#testid
       * @description the test id to be given to the select DOM
       * @type {String}
       * @default undefined
       * @since 2.8.0
       */
      testid: undefined
    },
    /**
     * @function
     * @name nixps-cloudflow.AutoFill#_create
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      // variable made by control options
      var that = this;
      this.collection = "";
      this._cloudflowConnection; // generic connector to a source
      this._waitingTimerID = undefined; // id returning from this._delay
      this._isRemoteChecking = false; // flag indicating we are bussy to check the value

      // control options
      this._controlOptions();
      // make object
      this.element.addClass(this.widgetFullName).addClass("cf-autocomplete");
      this.selectedKey = null;
      if (typeof this.options.selectedItemID === "string" && this.options.selectedItemID.length > 0) {
        this.selectedKey = this.options.selectedItemID;
      } else if (Array.isArray(this.options.selectedItemID)) {
        this.selectedKey = $.extend(true, [], this.options.selectedItemID);
      }
      if (this.options.getAllItems === null) {
        this.useRemote = true;
        this._initCloudflowConnection();
      } else {
        this.useRemote = false;
      }
      if (this.useRemote === false) {
        $.when(this.options.getAllItems()).done(function (pItems) {
          if (!$.isPlainObject(pItems)) {
            throw new Error("AutoFill._create: return value must be a non empty object");
          }
          that.items = pItems;
          that._draw();
        }).fail(function (pError) {
          throw new Error(pError);
        });
      } else {
        // this.useRemote is true
        this._draw();
      }
      this._on(this.element, {
        "limitautocompleteselect": this._autocompleteSelectHandler,
        "limitautocompletechange": this._autocompleteChangeHandler,
        "input .inputCombobox": this._autocompleteInputHandler,
        "limitautocompleteopen": this._autocompleteOpenHandler,
        "limitautocompleteclose": this._autocompleteCloseHandler,
        "keydown input.inputCombobox": this._keyDownHandler,
        "click input": this._clickInputHandler
      });
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        "noItemFoundText": $.i18n._("nixps-cloudflow-components.no_item_found")
      };
    },
    /**
     * @description fucntion runs when user select a item on the list
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_autocompleteSelectHandler
     * @param {type} event
     * @param {type} ui
     * @return {undefined}
     */
    _autocompleteSelectHandler: function _autocompleteSelectHandler(event, ui) {
      if (this.options.multiple === true) {
        this._addSelectedKey(ui.item.key);
        this.element.children(".nixps-cloudflow-TagList").TagList("addItem", ui.item.key, ui.item.value, true);
        this.element.find("input.inputCombobox").val("");
        this._trigger("select", null, {
          key: ui.item.key,
          value: ui.item.value
        });
        return false;
      } else {
        this.selectedKey = ui.item.key;
        this._trigger("select", null, {
          key: ui.item.key,
          value: ui.item.value
        });
      }
    },
    /**
     * @description function runs when the panel of posibilities has been open
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_autocompleteOpenHandler
     * @param {type} event
     * @param {type} ui
     * @return {undefined}
     */
    _autocompleteOpenHandler: function _autocompleteOpenHandler(event, ui) {
      this.element.find("input.inputCombobox").addClass("autofill_open");
      this.element.find("input.inputCombobox:ui-tooltip").tooltip("disable");
      this._trigger("open");
    },
    /**
     * @description function runs when the panel of posibilities has been closed
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_autocompleteCloseHandler
     * @param {type} event
     * @param {type} ui
     * @return {undefined}
     */
    _autocompleteCloseHandler: function _autocompleteCloseHandler(event, ui) {
      this.element.find("input.inputCombobox").removeClass("autofill_open");
      this.element.find("input.inputCombobox:ui-tooltip").tooltip("enable");
      this._trigger("close");
    },
    /**
     * @description function runs when user press a button
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_keyDownHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _keyDownHandler: function _keyDownHandler(pEvent, pData) {
      var keyCode = $.ui.keyCode;
      switch (pEvent.keyCode) {
        case keyCode.ENTER:
        case keyCode.NUMPAD_ENTER:
          var value = this.element.find("input.inputCombobox").val();
          if (this.options.requireValueToBeOneOfList === false) {
            if (typeof value === "string" && value.length > 0) {
              if (this.options.multiple === true) {
                this._addSelectedKey(value);
                this.element.children(".nixps-cloudflow-TagList").TagList("addItem", value, value, true);
                this.element.find("input.inputCombobox").val("");
                this._trigger("select", null, {
                  key: value,
                  value: value
                });
              } else {
                // pre setup, in case of external does a "getValue"
                this.selectedKey = value;
              }
              // prevent form submitting
              pEvent.stopPropagation();
            } else if (value.length === 0) {
              if (this.options.multiple === false) {
                // pre setup, in case of external does a "getValue"
                this.selectedKey = null;
              }
            }
          } else {
            if (typeof value === "string" && value.length > 0) {
              // prevent form submitting
              pEvent.stopPropagation();
            } else {
              // input is empty, trigger submit
            }
          }
          break;
        default:
          break;
      }
    },
    _clickInputHandler: function _clickInputHandler(pEvent, pData) {
      var currentValue = this.element.find("input.inputCombobox").val();
      this.element.find(".inputCombobox").limitautocomplete("search", currentValue);
    },
    /**
     * @function
     * @name nixps-cloudflow.AutoFill#redraw
     * @description redraw the panel
     * @brief redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    _initCloudflowConnection: function _initCloudflowConnection() {
      this._cloudflowConnection = new CloudflowConnection({
        "collection": this.collection,
        "relativeBasePath": this.options.relativeBasePath,
        "dataFileURL": this.options.dataFileURL,
        "assetmetadataEnclosingFolder": undefined
      });
    },
    /**
     * @function
     * @name nixps-cloudflow.AutoFill#_draw
     * @private
     * @brief draws the dialog according to the current state
     */
    _draw: function _draw() {
      this.element.empty();
      // value on start
      var value = this.selectedKey !== null ? this.selectedKey : "";

      // remote callback functions
      var resourceFunction;
      if (this.useRemote === true) {
        resourceFunction = this._sourceRemote;
      } else {
        resourceFunction = this._source;
      }
      if (this.options.multiple === true) {
        if (Array.isArray(this.selectedKey)) {
          value = "";
        }
        var that = this;
        var tagList = $("<div>");
        this.element.append(tagList);
        tagList.TagList({
          addInputField: false,
          beforeInputComponent: "",
          getAllItems: function getAllItems() {
            if (Array.isArray(that.selectedKey) === false) {
              return [];
            }
            if (that.options.requireValueToBeOneOfList === false) {
              var dict = {};
              for (var i = 0; i < that.selectedKey.length; i++) {
                dict[that.selectedKey[i]] = that.selectedKey[i];
              }
              return dict;
            }
            if (that.useRemote === true) {
              return that._getItemsRemotely(that.selectedKey).then(function (pKeyValues) {
                var dict = {};
                for (var i = 0; i < pKeyValues.length; i++) {
                  dict[pKeyValues[i].key] = pKeyValues[i].value;
                }
                return dict;
              });
            } else if (that.useRemote === false) {
              var retievedValues = that.getItems(that.selectedKey);
              var dict = {};
              for (var i = 0; i < retievedValues.length; i++) {
                if ($.isPlainObject(retievedValues[i]) && retievedValues[i].key !== undefined) {
                  dict[retievedValues[i].key] = retievedValues[i].value;
                }
              }
              return dict;
            }
          },
          selectedItemsID: this.selectedKey === null ? [] : $.extend(true, [], this.selectedKey),
          tagClass: "autofill_tag",
          removeItem: function removeItem(pKey, pIndex) {
            if (that.selectedKey[pIndex] === pKey) {
              that.selectedKey.splice(pIndex, 1);
              /*if (that.options.uniqueChooses === true && that.options.multiple === true) {
               }*/
              that._trigger("change", null, {});
              return true;
            }
            return false;
          }
        });
      }

      // setting autocomplete component
      $("<input>").appendTo(this.element).val(value).attr({
        "title": "",
        "autocorrect": "off",
        "spellcheck": false,
        "nixps-quantum-util-autobind": "false",
        "id": typeof this.options.id === "string" ? this.options.id : "",
        "aria-required": this.options.required === true ? "true" : "false",
        "data-testid": typeof this.options.testid === "string" ? this.options.testid : ""
      }).addClass("inputCombobox").addClass(this.options.classes).prop("type", this.options.enableClearButton ? "search" : "").limitautocomplete({
        delay: this.options.delay,
        minLength: this.options.minLength,
        appendTo: this.element,
        position: this.options.position,
        source: resourceFunction.bind(this),
        maxAmountPosibilities: this.options.maxAmountPosibilities
      });
      this.element.append($("<span>").addClass("fa fa-spinner fa-pulse").hide());

      // control if id given by input option is valid?
      if (this.options.requireValueToBeOneOfList === false) {
        // if we may not force, do no controls or checks
        // do nothing, ignore
      } else if (this.useRemote === true) {
        if (typeof this.selectedKey === "string") {
          var that = this;
          this.getItemRemotely(this.selectedKey).done(function (pItem) {
            if ($.isEmptyObject(pItem)) {
              that.selectedKey = null;
              that.element.find("input.inputCombobox").val("").attr("placeholder", that.options.noItemFoundText);
            }
          });
        } else if (Array.isArray(this.selectedKey)) {
          return this._getItemsRemotely(this.selectedKey).then(function (pKeyValues) {
            that.selectedKey = $.map(pKeyValues, function (elem) {
              return elem.key;
            });
          });
        }
      }
      this.element.children("input.inputCombobox").tooltip({
        content: function content() {
          if (this.scrollWidth > this.clientWidth) {
            // only add when internal text value is clipped
            var title = $(this).val();
            // Escape title, since we're going from an attribute to raw HTML
            return $("<a>").text(title).html();
          } else {
            return null;
          }
        },
        classes: {
          "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
        },
        items: ".inputCombobox",
        position: {
          my: "center bottom-15px",
          at: "center center",
          collision: "flipfit flip"
        }
      });
      if (this.options.disabled === true) {
        this.element.children("input.inputCombobox").prop("disabled", true);
      }
    },
    /**
     * @description callback function of the autocomplete component to get all the matched items remotely
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_sourceRemote
     * @param {type} request
     * @param {type} response
     * @returns {undefined}
     */
    _sourceRemote: function _sourceRemote(request, response) {
      var that = this;
      var searchString = request.term;
      // initial settings
      var query = [this.options.displayValueField, "contains text like", searchString];
      if (Array.isArray(this.options.collectionFilter) && this.options.collectionFilter.length > 0) {
        query.push("and", "(");
        query = query.concat(this.options.collectionFilter);
        query.push(")");
      }
      if (this.options.uniqueChooses === true && this.options.multiple === true && Array.isArray(this.selectedKey) && this.selectedKey.length > 0) {
        query = query.concat(["and", "(", "not", this.options.keyField, "in", this.selectedKey, ")"]);
      }
      var fields = [this.options.keyField, this.options.displayValueField];
      var options = {};
      if (typeof this.options.maxAmountPosibilities === "number" && this.options.maxAmountPosibilities > 0) {
        options.maximum = this.options.maxAmountPosibilities + 1;
      }
      // callback
      this._startWaiting();
      $.when(this._cloudflowConnection.list_with_options(query, this.options.orderByQuery, fields, options.skip, options.maximum)).then(function (pResults) {
        if (pResults === undefined) {
          that._endWaiting();
          response([{
            label: "Error occured",
            value: "Error occured"
          }]);
          return;
        }
        that.items = {};
        that._endWaiting();
        var results = $.map(pResults.results, function (row, index) {
          var value = CloudflowObject.getParameter(row, fields[1]);
          var key = CloudflowObject.getParameter(row, fields[0]);
          that.items[key] = value;
          return {
            label: value,
            value: value,
            key: key
          };
        });
        if (that.options.uniqueDisplayNames === true) {
          response(_.uniq(results, false, function (a) {
            return a.label + a.key;
          }));
        } else {
          response(results);
        }
      }, function (pError) {
        if (pError === "stop_called") {
          response();
          return;
        }
        console.error(pError);
        that._endWaiting();
        response([{
          label: "Error occured",
          value: "Error occured"
        }]);
      });
    },
    /**
     * @desc function callback called from autocomplete component in not remote mode, if data is localy stored
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_source
     * @param {type} request
     * @param {type} response
     * @returns {undefined}
     */
    _source: function _source(request, response) {
      var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), "i");
      var that = this;
      var returnPossibilities = [];
      var itemsToShow = Object.assign({}, this.items);
      if (this.options.uniqueChooses === true && this.options.multiple === true && Array.isArray(this.selectedKey) && this.selectedKey.length > 0) {
        for (var i = 0; i < this.selectedKey.length; i++) {
          delete itemsToShow[this.selectedKey[i]];
        }
      }
      $.map(itemsToShow, function (elem, index) {
        var text = elem;
        if (!request.term || matcher.test(text)) {
          if (that.options.maxAmountPosibilities > 0 && that.options.maxAmountPosibilities < returnPossibilities.length - 1) {
            return false;
          }
          returnPossibilities.push({
            label: text,
            value: text,
            option: this,
            key: index
          });
        }
      });
      response(returnPossibilities);
    },
    /**
     * @description Callback if there was a change. If the value is not a item, remove the value
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_autocompleteChangeHandler
     * @param {type} event
     * @param {type} ui
     * @returns {undefined}
     */
    _autocompleteChangeHandler: function _autocompleteChangeHandler(event, ui) {
      // Selected an item, nothing to do
      if (ui.item) {
        this._trigger("change", null, {
          key: ui.item.key,
          value: ui.item.value
        });
        return;
      }

      // Search for a match (case-insensitive)
      var input = this.element.find("input.inputCombobox");
      var value = input.val();
      if (value === "") {
        // the input is empty, set to initial state
        input.attr("placeholder", this.options.noItemFoundText);
        if (this.options.multiple === false) {
          this.selectedKey = null;
        }
        this._trigger("change", null, {
          key: this.selectedKey,
          value: value
        });
        return;
      }
      if (this.options.requireValueToBeOneOfList === false) {
        // do nothing if it is not required
        if (this.options.multiple === false) {
          this.selectedKey = value;
        }
        this._trigger("change", null, {
          key: this.selectedKey,
          value: value
        });
        return;
      }
      if (this.useRemote === false) {
        var returnedObject = this.getItem(value);
        if ($.isEmptyObject(returnedObject) === false) {
          // Found a match, nothing to do
          if (this.options.multiple === false) {
            this.selectedKey = returnedObject.key;
          }
          this._trigger("change", null, {
            key: this.selectedKey,
            value: value,
            found: true
          });
          return;
        } else {
          // Remove invalid value
          input.val("").attr("placeholder", this.options.noItemFoundText);
          if (this.options.multiple === false) {
            this.selectedKey = null;
          }
          this._trigger("change", null, {
            key: this.selectedKey,
            value: value,
            found: false
          });
        }
      } else {
        var that = this;
        this._startWaiting();
        this._isRemoteChecking = true;
        this.getItemRemotely(undefined, value).done(function (pItem) {
          if ($.isEmptyObject(pItem)) {
            // Remove invalid value
            input.val("").attr("placeholder", that.options.noItemFoundText);
            if (that.options.multiple === false) {
              that.selectedKey = null;
            }
            that._trigger("change", null, {
              key: that.selectedKey,
              value: value,
              found: false
            });
          } else if (typeof pItem.key === "string" && pItem.key.length > 0) {
            if (that.options.multiple === false) {
              that.selectedKey = pItem.key;
            }
            that._trigger("change", null, {
              key: that.selectedKey,
              value: value,
              found: true
            });
          }
        }).always(function () {
          that._endWaiting();
          that._isRemoteChecking = false;
        });
      }
    },
    /**
     * @description function called when input has changed
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_autocompleteInputHandler
     * @param {type} event
     * @param {type} ui
     * @returns {undefined}
     */
    _autocompleteInputHandler: function _autocompleteInputHandler(pEvent, pData) {
      // handle case if autofill becomes normal input field
      // and all values are good
      if (this.useRemote === false && this.options.multiple === false && this.options.requireValueToBeOneOfList === false) {
        // all input values are allowed, so input event must update the model
        this.selectedKey = this.element.find("input.inputCombobox").val();
      }
    },
    /**
     * @description function to get a sepecific item. It controls the value lowercase, with values in lowercase
     * @function
     * @name nixps-cloudflow.AutoFill#getItem
     * @param {string} pKey The key of the specific item to control in the list
     * @param {string} pValue The value of the specific item to control in the list
     * @returns {element} the item, if found in list, empty object if list does not contains this item
     * @since 2.0
     */
    getItem: function getItem(pKey, pValue) {
      if (typeof pKey === "string" && pKey.length > 0) {
        if (this.items[pKey] !== undefined) {
          var returnObject = {
            key: pKey,
            value: this.items[pKey]
          };
          return returnObject;
        } else {
          return {};
        }
      } else if (this.options.showUnknownValue === true && pKey !== "*") {
        returnObject.push({
          key: pKey,
          value: "(" + pKey + ")"
        });
      } else {
        var outputObject = {};
        $.each(this.items, function (key, value) {
          if (value.toLowerCase() === pValue.toLowerCase()) {
            outputObject.key = key;
            outputObject.value = value;
            return false;
          }
        });
        return outputObject;
      }
    },
    getItems: function getItems(pKeys) {
      var returnObjects = [];
      if (Array.isArray(pKeys) && pKeys.length > 0) {
        for (var i = 0; i < pKeys.length; i++) {
          if (this.items[pKeys[i]] !== undefined) {
            returnObjects.push({
              key: pKeys[i],
              value: this.items[pKeys[i]]
            });
          } else if (this.options.showUnknownValue === true && pKeys[i] !== "*") {
            returnObjects.push({
              key: pKeys[i],
              value: "(" + pKeys[i] + ")"
            });
          } else {
            returnObjects.push({});
          }
        }
      }
      return returnObjects;
    },
    /**
     * @description Function to get the item. Works only if you work remotely 
     * @function
     * @name nixps-cloudflow.AutoFill#getItemRemotely
     * @param {string} pKey
     * @param {string} pValue
     * @returns {deferred} A empty object if error occured or item is not in list, the object if found.
     * @since 2.0
     */
    getItemRemotely: function getItemRemotely(pKey, pValue) {
      var that = this;
      if (typeof pKey === "string" && pKey.length > 0 || typeof pKey === "number") {
        var key = pKey;
        return $.Deferred(function (pDefer) {
          that._cloudflowConnection.list_with_options([that.options.keyField, "equal to", pKey], [], [that.options.keyField, that.options.displayValueField], undefined, 1).then(function (pResults) {
            if (Array.isArray(pResults.results) && pResults.results.length === 1) {
              var identific = {
                key: pResults.results[0][that.options.keyField],
                value: pResults.results[0][that.options.displayValueField]
              };
              if (identific.key !== pKey) {
                console.error("AutoFill.getItemRemotely(key) return object from api is wrong");
                pDefer.resolve({});
              } else {
                pDefer.resolve(identific);
              }
            } else {
              console.error("AutoFill.getItemRemotely(key) wrong return interface");
              // if not found
              pDefer.resolve({});
            }
          }, function (pError) {
            console.error("AutoFill.getItemRemotely(key) call error");
            console.error(pError);
            // if not found goes here
            pDefer.resolve({});
          });
        });
      } else if (typeof pValue === "string" && pValue.length > 0) {
        return $.Deferred(function (pDefer) {
          var query = [that.options.displayValueField, "is like", pValue];
          if (Array.isArray(that.options.collectionFilter) && that.options.collectionFilter.length > 0) {
            query.push("and", "(");
            query = query.concat(that.options.collectionFilter);
            query.push(")");
          }
          var fields = [that.options.keyField, that.options.displayValueField];
          that._cloudflowConnection.list_with_options(query, [], fields, undefined, undefined).then(function (pResults) {
            if (pResults !== undefined && Array.isArray(pResults.results) && pResults.results.length >= 1) {
              pDefer.resolve({
                key: pResults.results[0][that.options.keyField],
                value: pResults.results[0][that.options.displayValueField]
              });
            } else {
              console.error("AutoFill.getItemRemotely(value) nothing found");
              // noting found
              pDefer.resolve({});
            }
          }, function (pError) {
            console.error("AutoFill.getItemRemotely(value) call error");
            // if not found goes here
            pDefer.resolve({});
          });
        });
      } else {
        throw new Error("AutoFill.getItemRemotely invalid parameters");
      }
    },
    /**
     * @description Function to get the item. Works only if you work remotely 
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_getItemsRemotely
     * @param {string} pKey
     * @param {string} pValue
     * @returns {deferred} A empty object if error occured or item is not in list, the object if found.
     * @since 2.0
     */
    _getItemsRemotely: function _getItemsRemotely(pKeys) {
      if (pKeys === null || pKeys === undefined) {
        return $.Deferred().resolve([]);
      }
      if (Array.isArray(pKeys) === false) {
        throw new Error("AutoFill._getItemsRemotely input parameter must be an array");
      }
      if (pKeys.length === 0) {
        return $.Deferred().resolve([]);
      }
      var that = this;
      return $.Deferred(function (pDefer) {
        var fields = [that.options.keyField, that.options.displayValueField];
        that._cloudflowConnection.list_with_options([that.options.keyField, "in", pKeys], [], fields, undefined, undefined).then(function (pResults) {
          if (pResults !== undefined && Array.isArray(pResults.results) && pResults.results.length > 0) {
            var output = [];
            for (var i = 0; i < pResults.results.length; i++) {
              output.push({
                key: pResults.results[i][that.options.keyField],
                value: CloudflowObject.getParameter(pResults.results[i], that.options.displayValueField)
              });
            }
            pDefer.resolve(output);
          } else {
            pDefer.resolve([]);
          }
        }, function (pError) {
          // if not found goes here
          pDefer.resolve([]);
        });
      });
    },
    _addSelectedKey: function _addSelectedKey(pSelectedKey) {
      if (this.options.multiple === true) {
        if (this.selectedKey === null) {
          this.selectedKey = [];
        }
        // push to number of keys
        this.selectedKey.push(pSelectedKey);
      } else {
        this.selectedKey = pSelectedKey;
      }
    },
    /**
     * @description get the selected value
     * @name nixps-cloudflow.AutoFill#getValue
     * @function
     * @returns {string} the selected value
     */
    getValue: function getValue() {
      if (this.options.multiple === true) {
        var selectedKeys = [];
        if (this.options.requireValueToBeOneOfList === false) {
          var currentValue = this.element.find("input.inputCombobox").val();
          if (typeof currentValue === "string" && currentValue.length > 0) {
            selectedKeys.push(currentValue);
          }
        }
        return [].concat(this.selectedKey === null ? [] : this.selectedKey).concat(selectedKeys);
      }
      if (this.selectedKey === undefined) {
        // this may not happend because it will then return the complete widget. 
        // Try good fallback
        console.error("AutoFill: returning value is undefined!!");
        return this.options.defaultValue;
      }
      if (this.selectedKey === null) {
        return this.options.defaultValue;
      }
      return this.selectedKey;
    },
    /**
     * @description set the combobox on a specifique value
     * @name nixps-cloudflow.AutoFill#setValue
     * @function
     * @param {string} pValue The key of the item.
     * @returns {undefined}
     */
    setValue: function setValue(pValue) {
      // first handle empty setValues
      if (pValue === null || pValue === undefined || pValue === "") {
        // items set by setValue has wrong id
        this.element.find("input.inputCombobox").val("").attr("placeholder", this.options.noItemFoundText);
        this.selectedKey = null;
        return;
      }
      if (this.options.requireValueToBeOneOfList === false) {
        if (this.options.multiple === true) {
          this.element.children(".nixps-cloudflow-TagList").TagList("setValue", []);
          this.element.find("input.inputCombobox").val("");
          if (Array.isArray(pValue) && pValue.length > 0) {
            this.selectedKey = pValue.slice();
            for (var i = 0; i < this.selectedKey.length; i++) {
              this.element.children(".nixps-cloudflow-TagList").TagList("addItem", this.selectedKey[i], this.selectedKey[i]);
            }
          } else {
            this.selectedKey = null;
          }
        } else {
          // key and value are the same
          this.element.find("input.inputCombobox").val(pValue);
          this.selectedKey = pValue;
        }
        return;
      }
      if (this.useRemote === false) {
        var key = pValue;
        if (this.options.multiple === false) {
          var retievedValue = this.getItem(key);
          if (!$.isEmptyObject(retievedValue) && $.isPlainObject(retievedValue)) {
            this.selectedKey = key;
            this.element.find("input.inputCombobox").val(this.items[key]);
          }
        } else {
          this.element.children(".nixps-cloudflow-TagList").TagList("setValue", []);
          this.element.find("input.inputCombobox").val("");
          if (Array.isArray(pValue) && pValue.length > 0) {
            this.selectedKey = pValue.slice();
            for (var i = 0; i < this.selectedKey.length; i++) {
              var value = this.items[this.selectedKey[i]];
              if (this.options.showUnknownValue === true && (value === undefined || value === null)) {
                value = "(" + this.selectedKey[i] + ")";
              }
              this.element.children(".nixps-cloudflow-TagList").TagList("addItem", this.selectedKey[i], value);
            }
          } else {
            this.selectedKey = null;
          }
        }
      } else {
        // remote on true
        var that = this;
        if (this.options.multiple === false) {
          $.when(this.getItemRemotely(pValue)).done(function (pContains) {
            if (!$.isEmptyObject(pContains)) {
              that.element.find("input.inputCombobox").val(pContains.value);
              that.selectedKey = pContains.key;
            } else {
              // items set by setValue has wrong id
              that.element.find("input.inputCombobox").val("").attr("placeholder", that.options.noItemFoundText);
              that.selectedKey = null;
            }
          });
        } else {
          $.when(this._getItemsRemotely(pValue)).done(function (pKeyValues) {
            that.element.children(".nixps-cloudflow-TagList").TagList("setValue", []);
            if (Array.isArray(pKeyValues) && pKeyValues.length > 0) {
              that.element.find("input.inputCombobox").val("").attr("placeholder", that.options.noItemFoundText);
              // first make dict of all items
              var itemsDict = {};
              for (var i = 0; i < pKeyValues.length; i++) {
                itemsDict[pKeyValues[i].key] = pKeyValues[i].value;
              }
              if (that.options.showUnknownValue === false) {
                //only remove the undefined values if we don't want to see unknown values
                that.selectedKey = $.map(pValue, function (elem) {
                  if (itemsDict[elem] !== undefined) {
                    return elem;
                  }
                });
              } else {
                that.selectedKey = $.map(pValue, function (elem) {
                  return elem;
                });
              }
              for (var i = 0; i < that.selectedKey.length; i++) {
                var value = itemsDict[that.selectedKey[i]];
                if (that.options.showUnknownValue === true && (value === undefined || value === null)) {
                  value = "(" + that.selectedKey[i] + ")";
                }
                that.element.children(".nixps-cloudflow-TagList").TagList("addItem", that.selectedKey[i], value);
              }
            } else {
              // items set by setValue has wrong id
              that.element.find("input.inputCombobox").val("").attr("placeholder", that.options.noItemFoundText);
              that.selectedKey = null;
            }
          });
        }
      }
    },
    isValid: function isValid() {
      if (this._isRemoteChecking === true) {
        return $.i18n._("nixps-cloudflow-components.bussy");
      }
      return true;
    },
    reset: function reset() {
      this.element.children(".nixps-cloudflow-TagList").TagList("setValue", []);
      this.setValue(null);
    },
    _startWaiting: function _startWaiting() {
      if (this._waitingTimerID === undefined) {
        this._waitingTimerID = this._delay(function () {
          this.element.children(".fa-spinner").css("display", "");
        }, 500);
      }
    },
    _endWaiting: function _endWaiting() {
      clearTimeout(this._waitingTimerID);
      this._waitingTimerID = undefined;
      this.element.children(".fa-spinner").hide();
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var redraw = false;
      var changeGetAllItems = false;
      if (options.getAllItems !== undefined && options.getAllItems !== this.options.getAllItems) {
        changeGetAllItems = true;
      }
      $.each(options, function (key, value) {
        if (key !== "disabled" && key !== "collectionFilter" && key !== "required") {
          redraw = true;
        }
        that._setOption(key, value);
      });
      this._controlOptions();
      if (changeGetAllItems) {
        if (this.options.getAllItems === null) {
          this.useRemote = true;
          this._initCloudflowConnection();
        } else {
          this.useRemote = false;
        }
        if (this.useRemote === false) {
          var that = this;
          $.when(this.options.getAllItems()).done(function (pItems) {
            if (!$.isPlainObject(pItems)) {
              throw new Error("AutoFill._create: return value must be a non empty object");
            }
            that.items = pItems;
            that._draw();
          }).fail(function (pError) {
            throw new Error(pError);
          });
        } else {
          // this.useRemote is true
          this._draw();
        }
      } else if (redraw) {
        this._initCloudflowConnection();
        this._draw();
      }
    },
    /**
     * @function
     * @name nixps-cloudflow.AutoFill#_setOptions
     * @private
     * @brief sets the option
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      if (pKey === "disabled") {
        this.element.children(".nixps-cloudflow-TagList").TagList("option", "disabled", pValue);
        this.element.children("input.inputCombobox").prop("disabled", pValue);
        return;
      } else if (pKey === "collectionFilter") {
        return;
      } else if (pKey === "required") {
        this.element.children("input.inputCombobox").attr("aria-required", pValue === true ? "true" : "false");
        return;
      }
      return;
    },
    /**
     * @description control the input options
     * @function
     * @private
     * @name nixps-cloudflow.AutoFill#_controlOptions
     * @return {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.multiple !== "boolean") {
        throw new Error("AutoFill: input option multiple must be a boolean");
      }
      if (this.options.multiple === false && typeof this.options.selectedItemID !== "string") {
        throw new Error("AutoFill: input option selectedItemID must be a string");
      }
      if (typeof this.options.getAllItems !== "function" && this.options.getAllItems !== null) {
        throw new Error("AutoFill: input option getAllItems must be a function");
      }
      if (typeof this.options.minLength !== "number" && this.options.minLength >= 0) {
        throw new Error("AutoFill: input option minLenght must be a positive number");
      }
      if (typeof this.options.delay !== "number" && this.options.delay >= 0) {
        throw new Error("AutoFill: input option delay must be a positive number");
      }
      if (typeof this.options.collectionTable !== "string") {
        throw new Error("AutoFill: input option collectionTable must be a string");
      }
      if (typeof this.options.collection !== "string") {
        throw new Error("AutoFill: input option collection must be a string");
      }
      if (this.options.getAllItems === null) {
        this.collection = "";
        if (typeof this.options.collection === "string" && this.options.collection.length > 0) {
          this.collection = this.options.collection;
        } else if (typeof this.options.collectionTable === "string" && this.options.collectionTable.length > 0) {
          this.collection = "nucleus.customobjects." + this.options.collectionTable;
        } else {
          console.error("unknown collection to take");
        }
      }
      if (Array.isArray(this.options.collectionFilter) === false) {
        throw new Error("AutoFill: input option collectionFilter must be a array");
      }
      if (!Array.isArray(this.options.orderByQuery)) {
        throw new Error("AutoFill: input option orderByQuery must be a array");
      }
      if (typeof this.options.keyField !== "string") {
        throw new Error("AutoFill: input option keyField must be a string");
      }
      if (typeof this.options.displayValueField !== "string") {
        throw new Error("AutoFill: input option displayValueField must be a string");
      } else if (this.options.displayValueField === "_id" && this.options.getAllItems === null) {
        console.error("Autofill can not work with _id as displayField");
      }
      if (typeof this.options.maxAmountPosibilities !== "number") {
        throw new Error("AutoFill: input option maxAmountPosibilities must be a number");
      }
      if (typeof this.options.requireValueToBeOneOfList !== "boolean") {
        throw new Error("The input option requireValueToBeOneOfList must be a boolean");
      }
    },
    _destroy: function _destroy() {
      if (this._waitingTimerID !== undefined) {
        clearTimeout(this._waitingTimerID);
      }
      if (this._cloudflowConnection !== undefined) {
        this._cloudflowConnection.stop();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowConnection.js":78,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../ManageUsers/js/nixps-cloudflow-TagList.js":185}],140:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jul 20, 2018 10:12:27 AM
 */
(function ($) {
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  require("../../Table/js/nixps-cloudflow-PreConfiguredTable.js");
  require("./nixps-cloudflow-Input.js");
  var mSearchButton = $("<button>").attr("type", "button").addClass("afes_searchbutton hideInSummary").append($("<span>").addClass("fa fa-search")).append($("<span>").addClass("fa fa-align-justify"));

  /**
   * @namespace nixps-cloudflow.AutoFillExtend
   * @description Draw an input component with a button to do an extended autofill search.
   * It works with the @link{nixps-cloudflow.FormRenderer} component. when the user double click on a row on the dialog table.
   * The object in that row will be used and will be injected in the form (minimal setValue). the fileds will be highlighted as mark that they have been changed by the system.
   * @example $("<div>").AutoFillExtend({});
   * @private
   * @version 1.3.0
   */
  $.widget("nixps-cloudflow.AutoFillExtend", $.Widget, {
    version: "1.3.0",
    options: {
      /**
       * @description The language of the user
       * @name nixps-cloudflow.AutoFillExtend#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @description The key of the value
       * @type {String}
       * @name nixps-cloudflow.AutoFillExtend#key
       * @default ""
       */
      key: "",
      /**
       * @description The value of the input field
       * @name nixps-cloudflow.AutoFillExtend#value
       * @type {String}
       * @default ""
       */
      value: "",
      /**
       * @description This option will be given through the input component {@link nixps-cloudflow.Input#placeholder}
       * @name nixps-cloudflow.AutoFillExtend#placeholder
       * @type {String}
       * @default ""
       */
      placeholder: "",
      /**
       * @description The input options for the search table component
       * @name nixps-cloudflow.AutoFillExtend#tableOptions
       * @type {Object}
       * @default {}
       */
      tableOptions: {
        tableOptions: {
          enableStickyHeader: true,
          stickyHeaderAppliedBy: "css",
          searchingThrottleDelay: 900
        }
      },
      /**
       * @description proxy for formactions
       * @type {String}
       * @default undefined
       * @name nixps-cloudflow.AutoFillExtend#extraQuery
       * @private
       */
      extraQuery: undefined,
      /**
       * @description The input options for the dialog containing the table
       * @name nixps-cloudflow.AutoFillExtend#dialogOptions
       * @type {Object}
       * @default {}
       */
      dialogOptions: {
        top: 50
      },
      /**
       * @description Must the text input be editable or not?
       * @name nixps-cloudflow.AutoFillExtend#value
       * @type {Boolean}
       * @default true
       * @since 1.1.0
       */
      editable: true,
      /**
       * @description Must the dialog be modal or not?
       * @name nixps-cloudflow.AutoFillExtend#modal
       * @type {Boolean}
       * @default true
       * @since 1.0.1
       */
      modal: true,
      /**
       * @description The height of the dialog
       * @name nixps-cloudflow.AutoFillExtend#height
       * @type {Number}
       * @default 300
       */
      height: 300,
      /**
       * @description add classes to the input field
       * @name nixps-cloudflow.AutoFillExtend#inputClasses
       * @type {String}
       * @default ""
       * @since 1.3.0
       */
      inputClasses: "",
      /**
       * @name nixps-cloudflow.AutoFillExtend#style_type
       * @description The type of style you want
       * @type {String}
       * @private
      */
      style_type: "default",
      /**
       * @description Is the field required?
       * @name nixps-cloudflow.AutoFillExtend#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.2.0
       */
      required: false,
      /**
       * @description function runs when the component is done drawing
       * @name nixps-cloudflow.AutoFillExtend#created
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.AutoFillExtend#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._addClass(this.widgetFullName);
      this.alive = true;
      this.dialogDOMElement; // the link to the dialog

      if (this.options.extraQuery !== undefined && _typeof(this.options.tableOptions) === "object") {
        this.options.tableOptions.extraQuery = this.options.extraQuery;
      }
      this._draw();
      if (this.options.disabled === true) {
        this.element.addClass(this.widgetFullName + "-disabled ui-state-disabled");
      }
      this._on(this.element, {
        "click .afes_searchbutton:not(.afes_disabled)": this._searchClickHandler
      });
      this.options.created();
    },
    /**
     * @description function runs when the user want to search an object
     * @function
     * @private
     * @name nixps-cloudflow.AutoFillExtend#_searchClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _searchClickHandler: function _searchClickHandler(pEvent, pData) {
      if (this.dialogDOMElement !== undefined) {
        return false;
      }
      var dialogOpenDef = $.Deferred(); // when dialog is open
      var tableOpenDef = $.Deferred(); // when table is ready and drawed for the first time
      this.element.find(".afes_searchbutton").addClass("afes_disabled");
      this.dialogDOMElement = $("<div>");
      // table
      var table = $("<div>").addClass("afes_searchtable");
      this.dialogDOMElement.append(table);
      var fixOptions = {
        "language": this.options.language,
        "created": function created() {
          tableOpenDef.resolve();
        }
      };
      var searchObject = {};
      CloudflowObject.setParameter(searchObject, this.options.key, this.getValue());
      table.PreConfiguredTable(this._prepareTableOptions($.extend(true, {}, this.options.tableOptions, fixOptions), searchObject));
      // dialog
      //    height
      if (typeof this.options.height === "string" && this.options.height.length > 0 && this.options.height !== "auto") {
        var height = this.options.height.trim();
        // if is percentage
        if (height[height.length - 1] === "%") {
          var vwHeight = $(window).height();
          if (typeof vwHeight !== "number" || vwHeight <= 0) {
            // fallback
            vwHeight = 800;
            console.warn("we could not define the current height of the window");
          }
          this.options.height = vwHeight * parseFloat(height) / 100;
        } else {
          this.options.height = parseFloat(height);
        }
      }
      if (isFinite(this.options.height) === false || this.options.height <= 0) {
        // the value is wrong, fall back to default 
        this.options.height = "auto";
      }
      if (isNaN(parseFloat(this.options.dialogOptions.top)) || parseFloat(this.options.dialogOptions.top) < 0) {
        this.options.dialogOptions.top = "50%";
      } else if (typeof this.options.dialogOptions.top === "string" && isNaN(parseFloat(this.options.dialogOptions.top)) === false && this.options.dialogOptions.top.endsWith("%") === false) {
        this.options.dialogOptions.top = parseFloat(this.options.dialogOptions.top) + "%";
      } else if (typeof this.options.dialogOptions.top === "number" && isNaN(this.options.dialogOptions.top) === false) {
        this.options.dialogOptions.top += "%";
      }
      var that = this;
      this.dialogDOMElement.dialog({
        autoOpen: true,
        dialogClass: "cf-dialog nixps-cloudflow-AutoFillExtendDialog CloudflowDepend_formrenderer CloudflowStyle_" + this.options.style_type,
        classes: {
          "ui-dialog": "cf-dialog nixps-cloudflow-AutoFillExtendDialog CloudflowDepend_formrenderer CloudflowStyle_" + this.options.style_type
        },
        closeText: "",
        width: 800,
        height: this.options.height,
        modal: this.options.modal,
        zIndex: 100100,
        position: {
          my: this.options.dialogOptions.top === "50%" ? "center" : "center top",
          at: this.options.dialogOptions.top === "50%" ? "center" : "center top+" + this.options.dialogOptions.top,
          of: window
        },
        title: $.i18n._("nixps-cloudflow-autofillextend.dialog_title"),
        open: function open() {
          dialogOpenDef.resolve();
        },
        close: function close() {
          $(this).remove();
          that.dialogDOMElement = undefined;
          that.element.find(".afes_searchbutton").removeClass("afes_disabled");
        },
        resizeStop: function resizeStop(pEvent, pData) {
          that.dialogDOMElement.css("width", "auto"); // fix width bug
        }
      });

      this.dialogDOMElement.on("preconfiguredtabledblclick", this._rowSelectHandler.bind(this));
      $.when(dialogOpenDef, tableOpenDef).then(function () {
        if (that.alive === false) {
          return; // zombie
        }

        table.find("thead").find(".autofillextend_focusinput").trigger("focus").trigger("select");
      });
    },
    /**
     * @description function runs when the user double clicked on a row
     * @function
     * @name nixps-cloudflow.AutoFillExtend#_rowSelectHandler
     * @private 
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _rowSelectHandler: function _rowSelectHandler(pEvent, pData) {
      if (pData !== undefined && typeof pData.id === "string" && pData.id.length > 0) {
        var table = $(pEvent.target);
        var row = $(pEvent.originalEvent.target);
        if (table.length === 0 || row.length === 0) {
          throw new Error("There must be a linked table and row");
        }
        var selectedObject = table.PreConfiguredTable("getRowObject", row);
        var objectToPrefill = this._filterObject(selectedObject);
        if ($.isPlainObject(objectToPrefill) === false) {
          throw new Error("Object to be passed must be a plain object");
        }
        this.dialogDOMElement.dialog("close");
        this.element.trigger("fieldcutomprefillfields", {
          prefillObject: objectToPrefill,
          rowObject: pData.rowObject
        });
      }
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.AutoFillExtend#redraw
     */
    redraw: function redraw() {
      var inputClasses = this.element.find("input").attr("class");
      this._draw();
      if (typeof inputClasses === "string" && inputClasses.length > 0) {
        this.element.find("input").addClass(inputClasses);
      }
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.AutoFillExtend#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      var inputField = $("<div>").addClass("afes_inputfield");
      inputField.Input({
        "type": "text",
        "value": this.options.value,
        "placeholder": this.options.placeholder,
        "classes": this.options.inputClasses,
        "autocorrect": "off",
        "spellcheck": false,
        "readonly": this.options.editable === false,
        "disabled": this.options.disabled
      });
      inputField.append(mSearchButton.clone());
      this.element.append(inputField);
    },
    /**
     * @description Go throught the options and add the nessassary fields
     * @fucntion
     * @private
     * @name nixps-cloudflow.AutoFillExtend#_prepareTableOptions
     * @param {Object} pOptions
     * @param {Object} pSearchObject
     * @return {unresolved}
     */
    _prepareTableOptions: function _prepareTableOptions(pOptions, pSearchObject) {
      // search_startquery
      if (pOptions !== undefined && pOptions.tableOptions !== undefined && Array.isArray(pOptions.tableOptions.columns) && $.isPlainObject(pSearchObject) && $.isEmptyObject(pSearchObject) === false) {
        var columns = pOptions.tableOptions.columns;
        for (var i = 0; i < columns.length; i++) {
          if (columns[i].key === ".") {
            continue;
          }
          var value = CloudflowObject.getParameter(pSearchObject, columns[i].key);
          if (columns[i].searchable === true && value !== undefined) {
            if (columns[i].key === "_id" && value === "") {
              delete columns[i].search_startquery;
            } else {
              columns[i].search_startquery = ["(", columns[i].key, "contains text like", value, ")"];
              // add class so we can retreive witch input we must focus and select the text
              columns[i].search_inputclasses = "autofillextend_focusinput";
            }
          } else {
            delete columns[i].search_startquery;
          }
        }
      }
      return pOptions;
    },
    /**
     * @description desice with parameters will be pass through and which not.
     * @function
     * @private
     * @name nixps-cloudflow.AutoFillExtend#_filterObject
     * @param {Object} pObject
     * @return {nixps-cloudflow-AutoFillExtendL#8.nixps-cloudflow-AutoFillExtendAnonym$0._filterObject.nixps-cloudflow-AutoFillExtendAnonym$6}
     */
    _filterObject: function _filterObject(pObject) {
      if (this.options.tableOptions !== undefined && this.options.tableOptions.tableOptions !== undefined && Array.isArray(this.options.tableOptions.tableOptions.columns)) {
        var columns = this.options.tableOptions.tableOptions.columns;
        // make a new object with only the parameters that has a column
        var filterdObject = {};
        for (var i = 0; i < columns.length; i++) {
          if (typeof columns[i].key === "string" && columns[i].key.length > 0) {
            CloudflowObject.setParameter(filterdObject, columns[i].key, CloudflowObject.getParameter(pObject, columns[i].key));
          }
        }
        return filterdObject;
      }
      // in other cases return empty object, because there are no columns
      return {};
    },
    /**
     * @description set the input field to a specific value
     * @function
     * @name nixps-cloudflow.AutoFillExtend#setValue
     * @param {String} pValue The value to be injected
     * @return {undefined}
     */
    setValue: function setValue(pValue) {
      this.options.value = pValue;
      this.element.children(".afes_inputfield").Input("setValue", pValue);
    },
    /**
     * @description Get the value of the single input field
     * @function
     * @name nixps-cloudflow.AutoFillExtend#getValue
     * @return {String} The value in the single input field
     */
    getValue: function getValue() {
      return this.element.children(".afes_inputfield").Input("getValue");
    },
    /**
     * @description Reset the autofill extend
     * @function
     * @name nixps-cloudflow.AutoFillExtend#rest
     * @returns {undefined}
     */
    reset: function reset() {
      this.element.children(".afes_inputfield").Input("reset");
      if (this.dialogDOMElement !== undefined && this.dialogDOMElement.hasClass("ui-dialog")) {
        this.dialogDOMElement.dialog("close");
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.AutoFillExtend#_setOptions
     */
    _setOptions: function _setOptions(options) {
      if (typeof options.disabled === "boolean" && Object.keys(options).length === 1) {
        this._setOption("disabled", options.disabled);
        return;
      }
      if (typeof options.required === "boolean" && Object.keys(options).length === 1) {
        this._setOption("required", options.required);
        return;
      }
      this._superApply(arguments);
      this._controlOptions();
      this.redraw();
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      if (pKey === "disabled") {
        this.element.find(".nixps-cloudflow-Input").Input("option", "disabled", pValue);
        this.element.find(".afes_searchbutton").remove();
        this.element.find(".nixps-cloudflow-Input").append(mSearchButton.clone().toggleClass("afes_disabled", pValue));
      }
      if (pKey === "required") {
        // this.element.find(".nixps-cloudflow-Input").Input("option", "disabled", pValue);
      }
      if (pKey === "extraQuery") {
        this.option("tableOptions.extraQuery", pValue);
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.AutoFillExtend#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if ($.isPlainObject(this.options.tableOptions) === false) {
        throw new Error("AutoFillExtend: input option tableOptions must be a plain object");
      }
      if ($.isPlainObject(this.options.dialogOptions) === false) {
        throw new Error("AutoFillExtend: input option dialogOptions must be a plain object");
      }
      if (typeof this.options.style_type !== "string" || this.options.style_type.length <= 0) {
        throw new Error("AutoFillExtend: input option style_type must be a not empty string");
      }
      if (typeof this.options.modal !== "boolean") {
        throw new Error("AutoFillExtend: input option modal must be a boolean");
      }
      if (typeof this.options.editable !== "boolean") {
        throw new Error("AutoFillExtend: input option editable must be a boolean");
      }
      if (typeof this.options.key !== "string" || this.options.key.length <= 0) {
        throw new Error("AutoFillExtend: input option key must be a not empty string");
      }
    },
    /**
     * @description function runs when the underlining component is gone, then also remove the dialog
     * @return {undefined}
     * @function
     * @name nixps-cloudflow.AutoFillExtend#_destroy
     * @private 
     */
    _destroy: function _destroy() {
      this.alive = false;
      if (this.dialogDOMElement !== undefined) {
        this.dialogDOMElement.remove();
      }
      this._super();
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"../../Table/js/nixps-cloudflow-PreConfiguredTable.js":217,"./nixps-cloudflow-Input.js":150}],141:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  require("./nixps-cloudflow-Image.js");
  var imagesDOMDict = {};
  // var imagesDOMCache = new Map();
  function addCache(pKey, pValue) {
    imagesDOMDict[pKey] = pValue;
    /*if (imagesDOMCache.size > 500 && imagesDOMCache.keys !== undefined) {
        var i = 0;
        for (var k of imagesDOMCache.keys()) {
            if (i++ > 250) {
                break;
            }
            imagesDOMCache.delete(k);
        }
    }
    imagesDOMCache.set(pKey, pValue);*/
  }

  function getCache(pKey) {
    //return imagesDOMCache.get(pKey);
    return imagesDOMDict[pKey];
  }
  function removeCache(pKey) {
    //imagesDOMCache.delete(pKey);
    delete imagesDOMDict[pKey];
  }
  /**
   * @namespace nixps-cloudflow.CachedImage
   * @description To display an CachedImage.
   * @version 1.3.0
   * @private
   */
  $.widget("nixps-cloudflow.CachedImage", $.Widget, {
    widgetEventPrefix: "cachedimage",
    version: "1.0.0",
    options: {},
    _create: function _create() {
      this.element.addClass(this.widgetFullName);

      // variable
      this.hash = this.options.url + this.options.width + this.options.height + this.options.maxWidth + this.options.maxHeight + this.options.relativeBasePath;
      if (typeof this.options.url === "string" && this.options.url.length > 0) {
        var cachedImage = getCache(this.hash);
        if (cachedImage !== undefined) {
          if (cachedImage.DOM.style !== undefined) {
            cachedImage.DOM.style.position = "absolute";
          }
          this.element.css({
            "display": "block"
          });
          this.element.append(cachedImage.DOM);
          this.element.height(cachedImage.elementHeight).width(cachedImage.elementWidth);
          // if image is present more then one time, the image is moved in state of copying
          // copying is not usefull, it required reload of image
          // so clear cache so doubles are recreated, it is the same time as copy 
          removeCache(this.hash);
        }
      }
      var newImage = $("<div>").Image(this.options);
      this.element.append(newImage);
      if (cachedImage !== undefined) {
        newImage.find("img").on("load", this._mainImageLoadHandler.bind(this)).on("error", this._mainImageErrorHandler.bind(this));
      }
    },
    _mainImageLoadHandler: function _mainImageLoadHandler(pEvent, pData) {
      // the new image can be smaller or bigger
      // clear height and width
      this.element.css({
        "height": "",
        "width": ""
      });
      // hide old image 
      this.element.children().first().hide();
    },
    _mainImageErrorHandler: function _mainImageErrorHandler(pEvent, pData) {
      this.element.css({
        "height": "",
        "width": ""
      });
    },
    setValue: function setValue(pURL) {
      this.element.children(".nixps-cloudflow-Image").last().Image("setValue", pURL);
    },
    getValue: function getValue() {
      return this.element.children(".nixps-cloudflow-Image").last().Image("getValue");
    },
    /**
     * @brief sets the option
     * @private
     * @function
     * @name nixps-cloudflow.CachedImage#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this.element.children(".nixps-cloudflow-Image").Image("option", options);
    },
    _destroy: function _destroy() {
      this.element.css({
        "display": "block"
      });
      addCache(this.hash, {
        "DOM": this.element.children().last()[0],
        "elementWidth": this.element.width(),
        "elementHeight": this.element.height()
      });

      //this.element.find("img").attr("src", " ");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"./nixps-cloudflow-Image.js":149}],142:[function(require,module,exports){
"use strict";

var Calendar = require("../../CloudflowCalendar/js/model/Calendar.js");
require("./nixps-cloudflow-DatetimeSelector.js");
$.widget("nixps-cloudflow.CalendarSelector", $.Widget, {
  options: {
    calendar: null,
    days_offset: 0.5,
    required: false
  },
  _create: function _create() {
    this.element.addClass(this.widgetFullName);
    this.startDate;
    this._draw();
  },
  _draw: function _draw() {
    var options = {
      format: this.options.format,
      outputFormat: this.options.outputFormat,
      disabled: this.options.disabled,
      required: this.options.required
    };
    if (this.options.calendar != null) {
      options.startDate = Calendar.getFirstAvailableDate(this.options.calendar, this.options.days_offset, this.startDate);
    }
    this.element.DatetimeSelector(options);
    this.datetimepicker = this.element.find('.datetimepickerBegin');
    this.datetimepicker.on("dp.show", this._draw_dates.bind(this));
    this.datetimepicker.on("dp.update", this._draw_dates.bind(this));
    this.datetimepicker.on("dp.change", this._draw_dates.bind(this));
    if (this.startDate != options.startDate) {
      this.startDate = options.startDate;
      this.element.trigger("change");
    }
  },
  _draw_dates: function _draw_dates() {
    var that = this;
    this.datetimepicker.find(".day").each(function () {
      var element = $(this);
      var locale = moment.locale();
      var localeFormat = moment.localeData(locale).longDateFormat('L');
      if (!Calendar.isAvailableDate(that.options.calendar, Date.parse(moment(element.data("day"), localeFormat).locale("en").format()), that.options.days_offset)) {
        element.addClass("disabled");
      }
    });
  },
  _setOptions: function _setOptions() {
    this._superApply(arguments);
    this._draw();
    this._draw_dates();
  },
  getValue: function getValue() {
    return this.element.DatetimeSelector("getValue");
  },
  setValue: function setValue(pValue) {
    this.startDate = Date.parse(pValue);
    return this.element.DatetimeSelector("setValue", pValue);
  }
});

},{"../../CloudflowCalendar/js/model/Calendar.js":56,"./nixps-cloudflow-DatetimeSelector.js":145}],143:[function(require,module,exports){
"use strict";

require("./nixps-cloudflow-CalendarSelector.js");
$.widget("nixps-cloudflow.CalendarSelectorWConnector", $.Widget, {
  options: {
    calendar_name: "",
    days_offset: 0.5,
    required: false
  },
  _create: function _create() {
    this._draw();
  },
  _draw: function _draw() {
    var that = this;
    this.element.CalendarSelector(this.options);
    api_async.calendar.list(["name", "equal to", this.options.calendar_name], [], function (pResult) {
      if (pResult.results.length > 0) {
        that.element.CalendarSelector("option", "calendar", pResult.results[0]);
      }
    });
  },
  _setOptions: function _setOptions() {
    this._superApply(arguments);
    this._draw();
  },
  getValue: function getValue() {
    return this.element.CalendarSelector("getValue");
  },
  setValue: function setValue(pValue) {
    return this.element.CalendarSelector("setValue", pValue);
  }
});

},{"./nixps-cloudflow-CalendarSelector.js":142}],144:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jul 10, 2018 10:44:51 AM
 */
(function ($) {
  "use strict";

  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  require("./nixps-cloudflow-ListEditButtons.js");
  function isValueComposer(pValue) {
    if (Array.isArray(pValue) === false) {
      return false;
    }
    for (var i = 0; i < pValue.length; i++) {
      if (pValue[i] === undefined || typeof pValue[i].type !== "string" || pValue[i].type.indexOf("com.nixps.") !== 0) {
        return false;
      }
    }
    return true;
  }
  function parseToNumber(pValue) {
    var numericValue = parseFloat(pValue);
    if (isNaN(numericValue) || isFinite(numericValue) === false) {
      // in case of NaN
      return 0;
    }
    return numericValue;
  }

  /**
   * @namespace nixps-cloudflow.ConfigurePlainObject
   * @description Component that givs the possibility to the user to create and edit an plain json object or an array
   * using the dot notation.
   * @example $("<div>").ConfigurePlainObject({});
   * @version 1.3.0
   */
  $.widget("nixps-cloudflow.ConfigurePlainObject", $.Widget, {
    version: "1.3.0",
    widgetEventPrefix: "configureplainobject",
    options: {
      /**
       * @description The function who can make one object from cloudflow paths and values
       * @name nixps-cloudflow.ConfigurePlainObject#pathsCollector
       * @type {Function}
       * @param {type} pObject
       * @param {type} pField
       * @param {type} pNewValue
       * @return {unresolved}
       */
      pathsCollector: function pathsCollector(pObject, pField, pNewValue) {
        pObject[pField] = pNewValue;
        return pObject;
      },
      /**
       * @description The value to be representing
       * @name nixps-cloudflow.ConfigurePlainObject#value
       * @default {}
       * @type {Object}
       */
      value: {},
      /**
       * @description What are the supported types?
       * @name nixps-cloudflow.ConfigurePlainObject#supportedTypes
       * @type {Array.<String>}
       * @default ["text", "decimal", "checkbox"]
       * @since 1.1.0
       */
      supportedTypes: ["text", "decimal", "checkbox"],
      /**
       * @description Allow we to have empty values?
       * @type {Boolean}
       * @default true
       */
      allowEmptyValue: true,
      /**
       * @description The title of the path column
       * @name nixps-cloudflow.ConfigurePlainObject#titlePath
       * @type {String}
       * @default "nixps-cloudflow-configureobject.title_path"
       * @since 1.1.0
       */
      titlePath: "",
      /**
      * @description The title of the value column
      * @name nixps-cloudflow.ConfigurePlainObject#titleValue
      * @type {String}
      * @default "nixps-cloudflow-configureobject.title_value"
      * @since 1.1.0
      */
      titleValue: "",
      /**
       * @description The context to pass to the expressionbuilder of the rows. used in pagebuilder
       * @name nixps-cloudflow.ConfigurePlainObject#context
       * @type {Object.<Context>}
       * @private
       * @default null
       */
      context: null,
      /**
       * @description options to be given through the expressionBuilderInput
       * @name nixps-cloudflow.ConfigurePlainObject#expressionBuilderInputOptions
       * @type {Object}
       * @default {}
       */
      expressionBuilderInputOptions: {},
      /**
       * @name nixps-cloudflow.ConfigurePlainObject#componentClasses
       * @description the classes names to be added to the component 
       * @type {String}
       * @default ""
       * @since 1.2.0
       */
      componentClasses: "",
      /**
       * @description classes add to the add and remove button
       * @type {String}
       * @default ""
       * @since 1.3.0
       */
      buttonParentClasses: ""
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.ConfigurePlainObject#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass(this.options.componentClasses);
      // variables
      this.keyValues = {};
      for (var i = 0; i < this.options.supportedTypes.length; i++) {
        this.keyValues[this.options.supportedTypes[i]] = $.i18n._("nixps-cloudflow-configureobject.type_" + this.options.supportedTypes[i]);
      }
      if (this.options.context !== null && $.fn.ExpressionBuilderInput !== undefined) {
        this.keyValues["valuecomposer"] = $.i18n._("nixps-cloudflow-configureobject.type_valuecomposer");
      }
      this.element.toggleClass("configureplainobject_single", Object.keys(this.keyValues).length === 1);
      // draw skeleton
      var header = $("<div>").addClass("co_header");
      header.append($("<span>").text(this.options.titlePath).addClass("co_pathheader"));
      header.append($("<span>").text(this.options.titleValue).addClass("co_valueheader"));
      this.element.append(header);
      this._setValue(this.options.value);
      this.element.ListEditButtons({
        "rowSelector": ".arrayinput_row",
        "allowEmptyValue": this.options.allowEmptyValue,
        "buttonClasses": "co_buttons " + this.options.buttonParentClasses,
        "addButtonsOnStart": true,
        "appendEmptyRow": function () {
          return this._makeRow("", "");
        }.bind(this),
        "change": function (pEvent) {
          this._trigger("change", pEvent, {});
          this.element.trigger("fieldcustomchange");
        }.bind(this)
      });
      this._on(this.element, {
        "change .typeSelecting": this._typeChangeHandler
      });
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        "pathsCollector": CloudflowObject.setParameter,
        "titlePath": $.i18n._("nixps-cloudflow-configureobject.title_path"),
        "titleValue": $.i18n._("nixps-cloudflow-configureobject.title_value")
      };
    },
    /**
     * @description Function runs when user want to change the type
     * @function
     * @private
     * @name nixps-cloudflow.ConfigurePlainObject#_typeChangeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _typeChangeHandler: function _typeChangeHandler(pEvent, pData) {
      var type = $(pEvent.target).closest(".nixps-cloudflow-Select").Select("getValue");
      var valueDOMElement = $(pEvent.target).closest(".arrayinput_value").find(".valueInput");
      var oldValue;
      if (valueDOMElement.is(".nixps-cloudflow-Input")) {
        oldValue = valueDOMElement.Input("getValue");
      } else if (valueDOMElement.is(".nixps-cloudflow-Select")) {
        oldValue = valueDOMElement.Select("getValue");
      } else if (valueDOMElement.is(".nixps-cloudflow-ExpressionBuilderInput")) {
        var expression = valueDOMElement.ExpressionBuilderInput("getValue");
        if (Array.isArray(expression) && expression.length > 0 && expression[0] !== undefined) {
          if (typeof expression[0].value === "string") {
            oldValue = expression[0].value;
          } else if (typeof expression[0].variable === "string") {
            oldValue = expression[0].variable;
          } else {
            oldValue = "";
          }
        } else {
          oldValue = "";
        }
      } else {
        oldValue = "";
      }
      if (type === "text") {
        valueDOMElement.replaceWith($("<div>").Input({
          type: "text",
          value: oldValue.toString(),
          required: false,
          classes: "form-control cf-form-control"
        }).addClass("valueInput cf-col-sm-4"));
      } else if (type === "checkbox") {
        valueDOMElement.replaceWith($("<div>").Select({
          keyValues: {
            "true": $.i18n._("nixps-cloudflow-FormBuilder.checkboxOnStart_true"),
            "false": $.i18n._("nixps-cloudflow-FormBuilder.checkboxOnStart_false")
          },
          outputFormat: "boolean",
          classes: "form-control cf-form-control",
          "default": oldValue == true
        }).addClass("valueInput cf-col-sm-4"));
      } else if (type === "decimal") {
        var numericValue = parseToNumber(oldValue);
        valueDOMElement.replaceWith($("<div>").Input({
          type: "decimal",
          value: numericValue,
          required: false,
          classes: "form-control cf-form-control"
        }).addClass("valueInput cf-col-sm-4"));
      } else if (type === "valuecomposer") {
        var options = Object.assign({
          maintitle: "",
          title: ""
        }, this.options.expressionBuilderInputOptions, {
          value: [{
            type: "com.nixps.quantum.value.0",
            value: oldValue
          }],
          context: this.options.context
        });
        valueDOMElement.replaceWith($("<div>").ExpressionBuilderInput(options).addClass("valueInput cf-col-sm-4"));
      }
    },
    /**
     * @description make one row with inputfield and add/ remove buttons
     * @function
     * @private
     * @name nixps-cloudflow.ConfigurePlainObject#_makeRow
     * @param {type} pValue value to be added in the input field
     * @return {unresolved}
     */
    _makeRow: function _makeRow(pKey, pValue) {
      var row = $("<div>").addClass("arrayinput_row");
      var rowValue = $("<div>").addClass("arrayinput_value");
      var type;
      var valueInput;
      if (typeof pValue === "boolean") {
        type = "checkbox";
        valueInput = $("<div>").Select({
          keyValues: {
            "true": $.i18n._("nixps-cloudflow-FormBuilder.checkboxOnStart_true"),
            "false": $.i18n._("nixps-cloudflow-FormBuilder.checkboxOnStart_false")
          },
          "default": pValue == true,
          outputFormat: "boolean",
          classes: "form-control cf-form-control",
          disabled: this.options.disabled
        });
      } else if (typeof pValue === "number") {
        type = "decimal";
        valueInput = $("<div>").Input({
          type: "decimal",
          value: pValue,
          required: false,
          classes: "form-control cf-form-control",
          disabled: this.options.disabled
        });
      } else if (Array.isArray(pValue)) {
        type = "valuecomposer";
        var options = Object.assign({
          maintitle: "",
          title: "",
          disabled: this.options.disabled
        }, this.options.expressionBuilderInputOptions, {
          value: pValue,
          context: this.options.context
        });
        valueInput = $("<div>").ExpressionBuilderInput(options);
      } else {
        type = "text";
        valueInput = $("<div>").Input({
          type: "text",
          value: pValue,
          required: false,
          classes: "form-control cf-form-control",
          disabled: this.options.disabled
        });
      }
      row.append(rowValue);
      rowValue.append($("<div>").Input({
        type: "text",
        value: pKey,
        required: false,
        classes: "form-control cf-form-control",
        disabled: this.options.disabled
      }).addClass("keyInput cf-col-sm-4")).append($("<div>").Select({
        keyValues: this.keyValues,
        "default": type,
        classes: "form-control cf-form-control",
        disabled: this.options.disabled
      }).addClass("typeSelecting cf-col-sm-1")).append(valueInput.addClass("valueInput cf-col-sm-4"));
      return row;
    },
    /**
     * @description Set the object to be editing witout adding row buttons
     * @function
     * @private
     * @name nixps-cloudflow.ConfigurePlainObject#_setValue
     * @param {Object} pObject The json object to be editing 
     * @return {undefined}
     */
    _setValue: function _setValue(pObject) {
      this.element.children(".arrayinput_row").remove();
      this.options.value = pObject;
      var that = this;
      if ($.isEmptyObject(pObject)) {
        this.element.append(this._makeRow("", ""));
      } else {
        $.each(pObject, function (key, value) {
          that._makeRowsOfObject(key, value);
        });
      }
    },
    /**
     * @description Set the object to be editing
     * @function
     * @name nixps-cloudflow.ConfigurePlainObject#setValue
     * @param {Object} pObject The json object to be editing 
     * @return {undefined}
     */
    setValue: function setValue(pObject) {
      this._setValue(pObject);
      this.element.ListEditButtons("appendMissingButtons");
    },
    /**
     * @description The object value after editing
     * @function
     * @name nixps-cloudflow.ConfigurePlainObject#getValue
     * @return {Object} The object representation after editing
     */
    getValue: function getValue() {
      var that = this;
      this.options.value = {};
      this.element.children(".arrayinput_row:not(.arrayinput_emptyvalue)").children(".arrayinput_value").each(function () {
        var key = $(this).find(".keyInput").Input("getValue");
        if (typeof key !== "string" || key.length <= 0) {
          return; // do not save when key is empty
        }

        var valueType = $(this).find(".typeSelecting").Select("getValue");
        var value;
        var newValue;
        switch (valueType) {
          case "checkbox":
            value = $(this).find(".valueInput.nixps-cloudflow-Select").Select("getValue");
            newValue = value == true;
            break;
          case "decimal":
            value = $(this).find(".valueInput.nixps-cloudflow-Input").Input("getValue");
            newValue = parseToNumber(value);
            break;
          case "valuecomposer":
            value = $(this).find(".valueInput.nixps-cloudflow-ExpressionBuilderInput").ExpressionBuilderInput("getValue");
            newValue = value;
            break;
          case "text":
          default:
            value = $(this).find(".valueInput.nixps-cloudflow-Input").Input("getValue");
            newValue = value;
        }
        that.options.value = that.options.pathsCollector(that.options.value, key, newValue);
      });
      return Object.assign({}, this.options.value);
    },
    reset: function reset() {
      return this.setValue({});
    },
    /**
     * @description draw all the rows depending of the object
     * @function
     * @private
     * @name nixps-cloudflow.ConfigurePlainObject#_makeRowsOfObject
     * @param {String} pKey
     * @param {Object} pValue
     * @return {undefined}
     */
    _makeRowsOfObject: function _makeRowsOfObject(pKey, pValue) {
      if (this.options.context !== null && isValueComposer(pValue) || ["string", "number", "boolean"].includes(_typeof(pValue))) {
        this.element.append(this._makeRow(pKey, pValue));
      } else if (Array.isArray(pValue) || $.isPlainObject(pValue)) {
        var that = this;
        $.each(pValue, function (key, value) {
          that._makeRowsOfObject(pKey + "." + key, value);
        });
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ConfigurePlainObject#_setOption
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      if (options.disabled !== undefined) {
        this.element.find(".nixps-cloudflow-Select").Select("option", "disabled", options.disabled);
        this.element.find(".nixps-cloudflow-Input").Input("option", "disabled", options.disabled);
        this.element.find(".nixps-cloudflow-ExpressionBuilderInput").ExpressionBuilderInput("option", "disabled", options.disabled);
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.ConfigurePlainObject#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.pathsCollector !== "function") {
        throw new Error("input options pathsCollector must be a function");
      }
      if ($.isPlainObject(this.options.expressionBuilderInputOptions) === false) {
        throw new Error("input options expressionBuilderInputOptions must be an object");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass(this.options.componentClasses);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"./nixps-cloudflow-ListEditButtons.js":152}],145:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  function isEmpty(pValue) {
    return pValue === "" || pValue === null;
  }
  function convertDefaultMomentParameter(pValue) {
    if (isEmpty(pValue)) {
      return undefined;
    }
    return pValue;
  }
  function formatContainsHours(pFormat) {
    if (typeof pFormat !== "string") {
      throw new Error("parameter formt must be a string");
    }
    return /(a|A|h|H|k|m|s|S|LT|LLL|lll)/.test(pFormat);
  }

  /**
   * @desc function convert a moment to a specific string
   * @private
   * @static
   * @param {string} pConvertingMode
   * @param {moment} pMoment
   * @returns {unresolved}
   */
  function convertMoment(pConvertingMode, pMoment) {
    if (pMoment === null) {
      // the date is undefined, or wrong, return then null
      return null;
    }
    switch (pConvertingMode) {
      case null:
        return pMoment;
      case "ISO":
        return pMoment.toISOString();
      case "UNIX":
        return pMoment.valueOf();
      case "ISO-timeoffset":
        return pMoment.format();
      // "2020-10-20T17:21:03+02:00"
      default:
        return pMoment.format(pConvertingMode);
    }
  }
  ;

  /**
   * @namespace nixps-cloudflow.DatetimeSelector
   * @description A component where you can choose a periode of dates, start and end date, Or you can pick a single date 
   * @requires moment
   * @requires bootstrap
   * @requires bootstrapDatetimepicker
   * @example $("<div>").DatetimeSelector({startDate: "2017-06-25", format: "YYYY-MM-DD"});
   * @version 1.5.0
   */
  $.widget("nixps-cloudflow.DatetimeSelector", $.Widget, {
    version: "1.5.0",
    widgetEventPrefix: "datetimeselector",
    options: {
      /**
       * @name nixps-cloudflow.DatetimeSelector#language
       * @description The language of the timepicker. In which language must it shows the months, day names, ...
       * @type {string}
       * @default "en"
       * @example "fr"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.DatetimeSelector#native
       * @description Must we use the native browser one or not?
       * @type {Boolean}
       * @default false
       * @since 1.4.0
       */
      "native": false,
      /**
       * @name nixps-cloudflow.DatetimeSelector#datetimeSelectorClass
       * @description The class given to the main component
       * @type {String}
       * @default "container"
       * @since 1.2.0
       */
      datetimeSelectorClass: "container",
      /**
       * @name nixps-cloudflow.DatetimeSelector#periodClass
       * @description The class name given to the two parts of the from and to
       * @type {String}
       * @default "col-md-6 cf-col-md-6"
       * @since 1.2.0
       */
      periodClass: "col-md-6 cf-col-md-6",
      /**
       * @name nixps-cloudflow.DatetimeSelector#format
       * @description The format of the dates and of time, if you want only to see the date, you can configure it here.
       * <a href="http://momentjs.com/docs/#/displaying/format/"> Click here for more information </a>
       * If you leave it black a default value will be used.
       * @type {string|momentlocal}
       * @default "L"
       */
      format: "L",
      /**
       * @name nixps-cloudflow.DatetimeSelector#outputFormat
       * @description In with outputformat must we return the singel date value? You can choose between:
       * <ul> 
       *  <li> null: the moment as object </li>
       *  <li> "ISO": the moment as ISO 8601 string </li>
       *  <li> "UNIX": the moment as UNIX Timestamp string </li>
       *  <li> other string: the moment formated as the format string </li>
       * </ul>
       * only used for single date
       * @type {String}
       * @default null.
       * @example "LT L"
       */
      outputFormat: null,
      /**
       * @name nixps-cloudflow.DatetimeSelector#nameInput
       * @default the name attribute to be given tot the input
       * @type {String}
       * @default undefined
       * @since 1.3.0
       */
      inputName: undefined,
      /**
       * @name nixps-cloudflow.DatetimeSelector#startDate
       * @description The input parameter for moment, to whith date it must start.
       * @default ""
       */
      startDate: "",
      /**
       * @description The minimun date that will be possible to select
       * @name nixps-cloudflow.DatetimeSelector#minDate
       * @type {date | moment | string}
       * @default false
       */
      minDate: false,
      /**
       * @description The max date that will be possible to select
       * @name nixps-cloudflow.DatetimeSelector#maxDate
       * @type {date | moment | string}
       * @default false
       */
      maxDate: false,
      /**
       * @name nixps-cloudflow.DatetimeSelector#showTodayButton
       * @description Show the button to go the the current day
       * @type {boollean}
       * @default false
       * @since 1.1
       */
      showTodayButton: false,
      /**
       * @name nixps-cloudflow.DatetimeSelector#calendarIcon
       * @description The icon to show as clandar icon
       * @type {String}
       * @default "fa fa-calendar"
       */
      calendarIcon: "fa fa-calendar",
      /**
       * @name nixps-cloudflow.DatetimeSelector#showClearButton
       * @description Must we show a clear button.
       * @type {boolean}
       * @default false
       * @since 1.1
       */
      showClearButton: false,
      /**
       * @name nixps-cloudflow.DatetimeSelector#clearIcon
       * @description The icon we must show as clear button. Place here the name of a bootstrap icon
       * @type {string}
       * @default "fa fa-trash"
       * @example "fa fa-trash"
       * @since 1.1
       */
      clearIcon: "fa fa-trash",
      /**
       * @name nixps-cloudflow.DatetimeSelector#clearIconTooltip
       * @description the text to be shown as tooltip on the clear button
       * @type {string}
       * @default "Clear selection"
       * @since 1.1.1
       */
      clearIconTooltip: "Clear selection",
      /**
       * @name nixps-cloudflow.DatetimeSelector#enableEmptyPanel
       * @description show a different overlay panel when the value of the date is unvalid or cleared. 
       * Its will only work when {@link nixps-cloudflow.DatetimeSelector#periode} is set to false.
       * Set this option to true to activate this behavior
       * @default false,
       * @type {boolean}
       * @since 1.1.1
       */
      enableEmptyPanel: false,
      /**
       * @name nixps-cloudflow.DatetimeSelector#emptyPanelText
       * @description The text to be shown on the clear panel. This panel must be activated by {@link nixps-cloudflow.DatetimeSelector#enableEmptyPanel}
       * @default ""
       * @type {string}
       * @since 1.1.1
       */
      emptyPanelText: "",
      /**
       * @description Must the compoment give you the possibility to choose between two values or just one input value.
       * true: two input values, use this for choosing a periode of time, false: just one time moment.
       * @name nixps-cloudflow.DatetimeSelector#periode
       * @type {boolean}
       * @default false
       */
      periode: false,
      /**
       * @description The default for the from date time picker
       * @name nixps-cloudflow.DatetimeSelector#defaultDateFrom
       * @type {moment}
       * @since 1.2.0
       * @default undefined
       */
      defaultDateFrom: undefined,
      /**
       * @description The default for the from date time picker
       * @name nixps-cloudflow.DatetimeSelector#defaultDateTo
       * @type {moment}
       * @since 1.2.0
       * @default undefined
       */
      defaultDateTo: undefined,
      /**
       * @description Get additional Datetimepicker plugin options
       * @name nixps-cloudflow.DatetimeSelector#additionalDatetimepickerOptions
       * @default undefined
       * @type {Object}
       * @private
       * @since 1.2.0
       */
      additionalDatetimepickerOptions: undefined,
      /**
       * @description Is the field required?
       * @name nixps-cloudflow.DatetimeSelector#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.5.0
       */
      required: false
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        defaultDateFrom: moment().subtract(1, "week"),
        defaultDateTo: moment().add(1, "weeks")
      };
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._controlOptions();
      this._draw();
      this._on(this.element, {
        "click input[type=text]": this._clickInputHandler,
        "click .emptyClearPanel .removeEmptyClearPanelButton:not(.disabledButton)": this._removeEmptyPanelClickHandler
      });
    },
    /**
     * @description function runs when user click on the input field
     * @name nixps-cloudflow.DatetimeSelector#_clickInputHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _clickInputHandler: function _clickInputHandler(pEvent, pData) {
      if (this.options.periode === false) {
        $(pEvent.currentTarget).parent(".date").find("button").first().trigger("click");
      } else {
        $(pEvent.currentTarget).parent(".date").find("span").first().trigger("click");
      }
    },
    /**
     * @description fucntion runs when user click on the remove empty panel cross button
     * @function
     * @private
     * @name nixps-cloudflow.DatetimeSelector#_removeEmptyPanelClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _removeEmptyPanelClickHandler: function _removeEmptyPanelClickHandler(pEvent, pData) {
      // remove panel
      this.element.find(".emptyClearPanel").remove();
      // set date to today
      var currentDay = moment();
      this.element.find(".datetimepickerBegin").data("DateTimePicker").date(currentDay);
      // inform others of change
      this._trigger("change", null, {
        date: currentDay,
        oldDate: false
      });
    },
    /**
     * @description function runs when the beginning date is cleared
     * @name nixps-cloudflow.DatetimeSelector#_clearDayHandler
     * @function
     * @private
     * @return {undefined}
     */
    _clearDayHandler: function _clearDayHandler() {
      // if there is only one date selctor and if option is enable add empty panel
      if (this.options.periode === false && this.options.enableEmptyPanel === true) {
        this.element.find(".datetimepickerBegin").data("DateTimePicker").hide();
        var panel = $("<div>").addClass("emptyClearPanel").css({
          "position": "absolute",
          "top": 0,
          left: 0,
          right: 0,
          bottom: 0
        })._t(this.options.emptyPanelText).append($("<span>").addClass("removeEmptyClearPanelButton fa fa-times fa-lg"));
        this.element.find(".datetimepickerBegin").append(panel);
      }
    },
    /**
     * @description function runs when user change the date
     * @name nixps-cloudflow.DatetimeSelector#_datetimepickerChangeHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _datetimepickerChangeHandler: function _datetimepickerChangeHandler(pEvent, pData) {
      //handle consistentie between the two date pickers
      if ($(pEvent.target).hasClass("datetimepickerBegin")) {
        this.element.find(".datetimepickerEnd").data("DateTimePicker").minDate(pEvent.date);
      } else if ($(pEvent.target).hasClass("datetimepickerEnd")) {
        this.element.find(".datetimepickerBegin").data("DateTimePicker").maxDate(pEvent.date);
      } else {
        console.error("error in event handling");
      }
      this._trigger("change", null, this.getPeriode());
    },
    /**
     * @description function runs when user change the date
     * @name nixps-cloudflow.DatetimeSelector#_datetimepickerSingleChangeHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _datetimepickerSingleChangeHandler: function _datetimepickerSingleChangeHandler(pEvent, pData) {
      if (pEvent.date === false && moment.isMoment(pEvent.oldDate) === true) {
        this._clearDayHandler();
      }
      this._trigger("change", null, {
        date: pEvent.date,
        oldDate: pEvent.oldDate
      });
    },
    /**
     * @description function runs when panel opens and the chooing panel has been drawn
     * @name nixps-cloudflow.DatetimeSelector#_datetimepickerSingleOpenHandler
     * @function
     * @private
     * @return {undefined}
     */
    _datetimepickerSingleOpenHandler: function _datetimepickerSingleOpenHandler(pEvent, pData) {
      if (this.options.showClearButton === true) {
        this.element.find("[title='Clear selection']").attr("title", this.options.clearIconTooltip);
      }
      // handle jquery 3.4
      $(pEvent.target).find(".dropdown-menu").first().css("display", "block");
      this._trigger("open");
    },
    /**
     * @description function runs when the panel closes
     * @function
     * @private
     * @name nixps-cloudflow.DatetimeSelector#_datetimepickerSingleHideHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _datetimepickerSingleHideHandler: function _datetimepickerSingleHideHandler(pEvent, pData) {
      this._trigger("close");
    },
    /**
     * @description function runs when the panel opens
     * @name nixps-cloudflow.DatetimeSelector#_datetimepickerOpenHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _datetimepickerOpenHandler: function _datetimepickerOpenHandler(pEvent, pData) {
      // handle jquery 3.4
      $(pEvent.target).find(".dropdown-menu").first().css("display", "block");
      this._trigger("open");
    },
    /**
     * @description function runs when the panel close
     * @name nixps-cloudflow.DatetimeSelector#_datetimepickerHideHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _datetimepickerHideHandler: function _datetimepickerHideHandler(pEvent, pData) {
      this._trigger("close");
    },
    /**
     * @description This function controls input options and required includes. If some compoments are required and not aviable a error will be throw
     * @name nixps-cloudflow.DatetimeSelector#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof moment !== "function") {
        throw new Error("component \"moment\" not found, you must include it for using this component");
      }
      if (typeof $.fn.datetimepicker !== "function") {
        throw new Error('component "datetimepicker" not found, you must include it for using this component');
      }
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("inputoption language must be a not empty string");
      }
      if (typeof this.options.showTodayButton !== "boolean") {
        throw new Error("input option showTodayButton must be a boolean");
      }
      if (typeof this.options.showClearButton !== "boolean") {
        throw new Error("input option showClearButton must be a boolean");
      }
      if (typeof this.options.clearIcon !== "string" || this.options.clearIcon.length <= 0) {
        throw new Error("input option clearIcon must be a not empty string");
      }
      if (typeof this.options.clearIconTooltip !== "string") {
        throw new Error("input option clearIconTooltip must be a string");
      }
      if (typeof this.options.enableEmptyPanel !== "boolean") {
        throw new Error("input option enableEmptyPanel must be a boolean");
      }
      if (typeof this.options.emptyPanelText !== "string") {
        throw new Error("input option emptyPanelText must be a string");
      }
    },
    /**
     * @desc redraw
     * @name nixps-cloudflow.DatetimeSelector#redraw
     * @function
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @desc draws the dialog according to the current state
     * @name nixps-cloudflow.DatetimeSelector#_draw
     * @function
     * @private
     */
    _draw: function _draw() {
      // create big container
      this.element.addClass(this.options.datetimeSelectorClass);
      var form = $("<div>").addClass("form-group");
      this.element.empty().append(form);
      // get language
      var language;
      if (this.options.language === "en") {
        var browserlanguage = navigator.language || navigator.userLanguage;
        if (typeof browserlanguage === "string" && browserlanguage.length > 0) {
          language = [browserlanguage, "en"];
        } else {
          language = "en";
        }
      } else {
        language = [this.options.language, "en"];
      }
      // decise in which case we are
      if (this.options.periode === false) {
        // in case of just one picker
        var input = $("<input>").attr("type", "text").attr("name", this.options.inputName).attr("aria-required", this.options.required === true ? "true" : "false").addClass("form-control cf-form-control cf-form-control-prefix tableSearchInputText"); /* add class for table styling */
        var date = $("<div>").addClass("input-group date datetimepickerBegin ").css("position", "relative").append(input);
        form.append(date);
        this.options.startDate = convertDefaultMomentParameter(this.options.startDate);
        var defaultDate = moment(this.options.startDate);
        if (defaultDate.isValid() == false) {
          console.warn("invalid date found, " + this.options.startDate + "  fallback to other date");
          if (this.options.minDate !== false) {
            defaultDate = moment(this.options.minDate);
          } else if (this.options.maxDate !== false) {
            defaultDate = moment(this.options.maxDate);
          } else {
            defaultDate = moment();
          }
        }
        if (this.options["native"] === true) {
          var containsHours = formatContainsHours(this.options.format);
          var inputFormat = containsHours ? "YYYY-MM-DDTHH:mm" : "YYYY-MM-DD";
          var minDateMoment = moment(this.options.minDate);
          var maxDateMoment = moment(this.options.maxDate);
          input.attr({
            "type": containsHours ? "datetime-local" : "date",
            "min": minDateMoment.isValid() ? minDateMoment.format(inputFormat) : undefined,
            "max": maxDateMoment.isValid() ? maxDateMoment.format(inputFormat) : undefined
          }).val(defaultDate.format(inputFormat)).prop("disabled", this.options.disabled === true);
        } else {
          // important the class "input-group-addon" must be the first class!
          date.append($("<button>").attr("type", "button").addClass("input-group-addon cf-button cf-input-appendbutton").attr("aria-label", $.i18n._("nixps-cloudflow-DatetimeSelector.action_opencalendardialog")).append($("<span>").addClass(this.options.calendarIcon)));
          date.datetimepicker({
            useCurrent: false,
            debug: false,
            defaultDate: defaultDate,
            locale: language,
            minDate: this.options.minDate,
            maxDate: this.options.maxDate,
            showTodayButton: this.options.showTodayButton,
            showClear: this.options.showClearButton,
            icons: {
              time: "fa fa-clock-o",
              date: "fa fa-calendar",
              up: "fa fa-angle-up",
              down: "fa fa-angle-down",
              previous: "fa fa-angle-left",
              next: "fa fa-angle-right",
              today: "fa fa-crosshairs",
              clear: this.options.clearIcon,
              close: "fa fa-remove"
            },
            format: this.options.format,
            //not remove, otherwise panel don't hide when click 
            widgetPositioning: {
              vertical: "bottom"
            }
          });

          // if we need to start on today and that date is not presiced, 
          // then we need to show the empty panel if default date is empty
          if (this.options.startDate === undefined) {
            this._clearDayHandler(); // function does internal checkes
          }

          date.on("dp.change", this._datetimepickerSingleChangeHandler.bind(this));
          date.on("dp.show", this._datetimepickerSingleOpenHandler.bind(this));
          date.on("dp.hide", this._datetimepickerSingleHideHandler.bind(this));
        }
      } else {
        // in case of two pickers
        var date1 = $("<div>").addClass("input-group date datetimepickerBegin").css("position", "relative");
        var date2 = $("<div>").addClass("input-group date datetimepickerEnd").css("position", "relative");
        $("<div>").addClass("input-group-addon datetimepickerAddonStart").text($.i18n._("nixps-cloudflow-DatetimeSelector.from")).appendTo(date1);
        $("<input>").addClass("form-control cf-form-control cf-form-noroundedborders tableSearchInputText").attr("type", "text").appendTo(date1);
        $("<div>").addClass("input-group-addon datetimepickerAddonStart").text($.i18n._("nixps-cloudflow-DatetimeSelector.to")).appendTo(date2);
        $("<input>").addClass("form-control cf-form-control cf-form-noroundedborders tableSearchInputText").attr("type", "text").appendTo(date2);
        var iconCal = $("<span>").addClass("input-group-addon cf-input-appendbutton").attr("aria-label", $.i18n._("nixps-cloudflow-DatetimeSelector.action_opencalendardialog")).append($("<span>").addClass(this.options.calendarIcon));
        iconCal.appendTo([date1, date2]);
        form.append($("<div>").addClass(this.options.periodClass).append(date1)).append($("<div>").addClass(this.options.periodClass).append(date2));
        var fromOptions = {
          defaultDate: this.options.defaultDateFrom,
          debug: false,
          locale: language,
          format: this.options.format,
          //not remove, otherwise panel don't hide when click 
          minDate: this.options.minDate,
          // input option to set on min date
          maxDate: moment().add(1, "weeks"),
          showTodayButton: this.options.showTodayButton,
          showClear: this.options.showClearButton,
          icons: {
            time: "fa fa-clock-o",
            date: "fa fa-calendar",
            up: "fa fa-angle-up",
            down: "fa fa-angle-down",
            previous: "fa fa-angle-left",
            next: "fa fa-angle-right",
            today: "fa fa-crosshairs",
            clear: this.options.clearIcon,
            close: "fa fa-remove"
          },
          widgetPositioning: {
            vertical: "bottom"
          }
        };
        if ($.isPlainObject(this.options.additionalDatetimepickerOptions)) {
          fromOptions = Object.assign(fromOptions, this.options.additionalDatetimepickerOptions);
        }
        date1.datetimepicker(fromOptions);
        var toOptions = {
          debug: false,
          defaultDate: this.options.defaultDateTo,
          locale: language,
          format: this.options.format,
          minDate: moment().subtract(1, "week"),
          maxDate: this.options.maxDate,
          // input option to set on max date
          showTodayButton: this.options.showTodayButton,
          showClear: this.options.showClearButton,
          icons: {
            time: "fa fa-clock-o",
            date: "fa fa-calendar",
            up: "fa fa-angle-up",
            down: "fa fa-angle-down",
            previous: "fa fa-angle-left",
            next: "fa fa-angle-right",
            today: "fa fa-crosshairs",
            clear: this.options.clearIcon,
            close: "fa fa-remove"
          },
          widgetPositioning: {
            vertical: "bottom"
          }
        };
        if ($.isPlainObject(this.options.additionalDatetimepickerOptions)) {
          toOptions = Object.assign(toOptions, this.options.additionalDatetimepickerOptions);
        }
        date2.datetimepicker(toOptions);

        // link events
        date1.on("dp.change", this._datetimepickerChangeHandler.bind(this));
        date2.on("dp.change", this._datetimepickerChangeHandler.bind(this));
        date1.on("dp.show", this._datetimepickerOpenHandler.bind(this));
        date2.on("dp.show", this._datetimepickerOpenHandler.bind(this));
        date1.on("dp.hide", this._datetimepickerHideHandler.bind(this));
        date2.on("dp.hide", this._datetimepickerHideHandler.bind(this));
      }
      if (this.options["native"] === true) {
        this.element.find(".removeEmptyClearPanelButton").toggleClass("disabledButton", this.options.disabled === true);
      } else {
        if (this.options.disabled === true) {
          this.element.find(".datetimepickerBegin, .datetimepickerEnd").data("DateTimePicker").disable();
          this.element.find(".removeEmptyClearPanelButton").addClass("disabledButton");
        } else {
          this.element.find(".datetimepickerBegin, .datetimepickerEnd").data("DateTimePicker").enable();
          this.element.find(".removeEmptyClearPanelButton").removeClass("disabledButton");
        }
      }
    },
    /**
     * @description Get the current value. This is the same as function getPeriode
     * @name nixps-cloudflow.DatetimeSelector#getValue
     * @function 
     * @see nixps-cloudflow.DatetimeSelector#getPeriode
     * @example $("#datetimeselector").DatetimeSelector("getValue");
     * @returns {object}
     */
    getValue: function getValue() {
      if (this.options.periode === true) {
        return this.getPeriode();
      } else {
        if (this.element.find(".emptyClearPanel").length === 1) {
          // the emptyClearPanel is created and removed each time,
          // so checking on existing is enouph, we supoose it is visible if it is there
          return null;
        }
        var valueMoment;
        if (this.options["native"] === true) {
          var value = this.element.find("input").val();
          if (typeof value === "string" && value.length > 0) {
            valueMoment = moment(value);
          } else {
            // invalid moment
            return null;
          }
        } else {
          valueMoment = this.element.find(".datetimepickerBegin").data("DateTimePicker").date();
        }
        return convertMoment(this.options.outputFormat, valueMoment);
      }
    },
    /**
     * @description Set Value, Set and change the begin ( and end) date of the component.
     * @function
     * @name nixps-cloudflow.DatetimeSelector#setValue
     * @param {moment} pStartMoment The start date, can be everything accepted by the moment parameter
     * @param {moment} pEndMoment (required in periode mode) The end date, can be everything accepted by the moment parameter
     * @example $("#datetimeselector").DatetimeSelector("setValue", "2016-08-25");
     * @returns {element} 
     */
    setValue: function setValue(pStartMoment, pEndMoment) {
      pStartMoment = convertDefaultMomentParameter(pStartMoment);
      if (this.options.periode === true) {
        this.element.find(".datetimepickerBegin").data("DateTimePicker").date(moment(pStartMoment));
        this.element.find(".datetimepickerEnd").data("DateTimePicker").date(moment(pEndMoment));
      } else {
        // pStartMoment should be already converted
        if (pStartMoment === undefined && this.options.startDate !== undefined) {
          // we come from specific date to no date, so add panel
          // add clearpanel
          this._clearDayHandler(); // function does internal checkes
        } else if (pStartMoment !== undefined && this.options.startDate === undefined) {
          // we come from no date to specific date
          // remove clear panel
          this.element.find(".emptyClearPanel").remove();
        }
        if (this.options["native"] === true) {
          this.element.find("input").val(pStartMoment);
        } else {
          this.element.find(".datetimepickerBegin").data("DateTimePicker").date(moment(pStartMoment));
        }
      }
      return this;
    },
    /**
     * @description reset the datatimeselector
     * @name nixps-cloudflow.DatetimeSelector#reset
     * @function
     * @returns {undefined}
     */
    reset: function reset() {
      if (this.element.find(".emptyClearPanel").length === 1) {
        // the emptyClearPanel is created and removed each time,
        return;
      }
      if (this.options.periode === false) {
        this.options.startDate = convertDefaultMomentParameter(this.options.startDate);
        var defaultDate = moment(this.options.startDate);
        if (defaultDate.isValid() == false) {
          console.warn("invalid date found, " + this.options.startDate + "  fallback to other date");
          if (this.options.minDate !== false) {
            defaultDate = moment(this.options.minDate);
          } else if (this.options.maxDate !== false) {
            defaultDate = moment(this.options.maxDate);
          } else {
            defaultDate = moment();
          }
        }
        this.setValue(defaultDate);
      } else {
        this.setValue(this.options.defaultDateFrom, this.options.defaultDateTo);
      }
    },
    /**
     * @description Get all the information about the periode. This returns a object with fromDate and toDate in moment format
     * @name nixps-cloudflow.DatetimeSelector#getPeriode 
     * @function
     * @returns {Object}  Object containing fromDate and toDate, each in moment format
     */
    getPeriode: function getPeriode() {
      return {
        fromDate: this.element.find(".datetimepickerBegin").data("DateTimePicker").date(),
        toDate: this.element.find(".datetimepickerEnd").data("DateTimePicker").date()
      };
    },
    /**
     * @description Open the date picker choose dialog
     * @name nixps-cloudflow.DatetimeSelector#open
     * @function 
     * @returns {undefined}
     */
    open: function open() {
      if (this.options["native"] === true) {} else {
        this.element.find(".datetimepickerBegin").data("DateTimePicker").show();
      }
    },
    /**
     * @brief sets the option
     * @function
     * @private
     * @name nixps-cloudflow.DatetimeSelector#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "minDate") {
        this._superApply(arguments);
        // in period or not both are .datetimepickerBegin
        var minDateValue = this.options.minDate;
        if (minDateValue !== false) {
          minDateValue = moment(this.options.minDate);
        }
        if (this.options["native"] === true) {} else {
          this.element.find(".datetimepickerBegin").data("DateTimePicker").minDate(minDateValue);
        }
      } else if (pKey === "maxDate") {
        this._superApply(arguments);
        var maxDateValue = this.options.maxDate;
        if (maxDateValue !== false) {
          maxDateValue = moment(this.options.maxDate);
        }
        if (this.options["native"] === true) {} else {
          if (this.options.periode === false) {
            this.element.find(".datetimepickerBegin").data("DateTimePicker").maxDate(maxDateValue);
          } else {
            this.element.find(".datetimepickerEnd").data("DateTimePicker").maxDate(maxDateValue);
          }
        }
      } else if (pKey === "disabled") {
        this._superApply(arguments);
        if (this.options["native"] === true) {
          this.element.find("input").prop("disabled", pValue);
          this.element.find(".removeEmptyClearPanelButton").toggleClass("disabledButton", pValue);
        } else {
          if (pValue === true) {
            this.element.find(".datetimepickerBegin, .datetimepickerEnd").data("DateTimePicker").disable();
            this.element.find(".removeEmptyClearPanelButton").addClass("disabledButton");
          } else {
            this.element.find(".datetimepickerBegin, .datetimepickerEnd").data("DateTimePicker").enable();
            this.element.find(".removeEmptyClearPanelButton").removeClass("disabledButton");
          }
        }
      } else if (pKey === "required") {
        this._superApply(arguments);
        this.element.find("input").attr("aria-required", pValue === true ? "true" : "false");
      } else {
        this._superApply(arguments);
        this._draw();
      }
    }
  });
})(jQuery);

},{}],146:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @namespace nixps-cloudflow.ErrorMessage
   * @description This component shows an errorMessage to the user. Used in forms
   * @version 1.1.0
   */
  $.widget("nixps-cloudflow.ErrorMessage", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "errormessage",
    options: {
      /**
       * @name nixps-cloudflow.ErrorMessage#useBootStrap
       * @description Is the component in a enviroment of bootstrap? Do you want a message is bootstrap visual mode?
       * @type {Boolean}
       * @default true
       */
      useBootStrap: true,
      /**
       * @name nixps-cloudflow.ErrorMessage#errorMessage
       * @description Error message to be shown on creation
       * @type {String}
       * @default null
       * @since 1.1.0
       */
      errorMessage: null,
      /**
       * @name nixps-cloudflow.ErrorMessage#warningMessage
       * @description Show warning messages on creation
       * @type {String}
       * @default null
       * @since 1.1.0
       */
      warningMessage: null,
      /**
       * @name nixps-cloudflow.ErrorMessage#formDependent
       * @description Is the component part of the underling form
       * @type {Boolean}
       * @default true
       * @since 1.1.0
       */
      formDependent: true
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName).addClass("cf-hideable");
      this._controlOptions();
      var errorContainer = $("<div>").addClass("errorMessageContainer").attr({
        "role": "alert",
        "aria-live": "assertive"
      }).hide();
      this.element.append(errorContainer);
      this._draw();
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.useBootStrap !== "boolean") {
        throw new Error("invalid option useBootStrap must be a boolean");
      }
    },
    /**
     * @description Show an error message to the user. 
     * @name nixps-cloudflow.ErrorMessage#showErrorMessage
     * @function
     * @param {String} pMessage The text to be show to the user
     * @returns {undefined}
     */
    showErrorMessage: function showErrorMessage(pMessage) {
      if (typeof pMessage !== "string" || pMessage.length <= 0) {
        throw new Error("invalid parameter pMessage, pMessage must be a string");
      } else {
        this.element.find(".errorMessageContainer").empty().append(pMessage).show();
      }
      this.element.removeClass("cf-message-warning").addClass("cf-message-error");
      if (this.options.useBootStrap === true) {
        this.element.find(".errorMessageContainer").removeClass("alert-warning").addClass("alert-danger");
      }
    },
    /**
     * @description Show a warning message to the user. 
     * @name nixps-cloudflow.ErrorMessage#showWarningMessage
     * @function
     * @param {String} pMessage The text to be show to the user
     * @returns {undefined}
     */
    showWarningMessage: function showWarningMessage(pMessage) {
      if (typeof pMessage !== "string" || pMessage.length <= 0) {
        throw new Error("invalid parameter pMessage, pMessage must be a string");
      } else {
        this.element.find(".errorMessageContainer").empty().append($("<span>").addClass("warnMessageIcon fa fa-exclamation-triangle")).append(pMessage).show();
      }
      this.element.removeClass("cf-message-error").addClass("cf-message-warning");
      if (this.options.useBootStrap === true) {
        this.element.find(".errorMessageContainer").removeClass("alert-danger").addClass("alert-warning");
      }
    },
    /**
     * @description Hide the error message
     * @name nixps-cloudflow.ErrorMessage#hideErrorMessages
     * @function
     * @returns {undefined}
     */
    hideErrorMessages: function hideErrorMessages() {
      this.element.removeClass("cf-message-warning").removeClass("cf-message-error").find(".errorMessageContainer").hide();
    },
    /**
     * @description Redraw
     * @function
     * @name nixps-cloudflow.ErrorMessage#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    setValue: function setValue(pMessage) {
      if (typeof pMessage === "string" && pMessage.length > 0) {
        this.showErrorMessage(pMessage);
      } else {
        this.hideErrorMessages();
      }
    },
    getValue: function getValue() {
      return "";
    },
    /**
     * @desc Draws the dialog according to the current state
     * @private
     * @function
     * @name nixps-cloudflow.ErrorMessage#_draw
     */
    _draw: function _draw() {
      if (this.options.useBootStrap === true) {
        this.element.find(".errorMessageContainer").addClass("alert");
      } else {
        this.element.find(".errorMessageContainer").removeClass("alert");
      }
      this.element.toggleClass("errormessage_formdependent", this.options.formDependent === true);
      if (typeof this.options.errorMessage === "string") {
        this.showErrorMessage(this.options.errorMessage);
      } else if (typeof this.options.warningMessage === "string") {
        this.showWarningMessage(this.options.warningMessage);
      }
    },
    /**
     * @brief Sets the option
     * @private
     * @function
     * @private
     * @name nixps-cloudflow.ErrorMessage#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    _destory: function _destory() {
      this.element.removeClass(this.widgetFullName).removeClass("cf-hideable");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],147:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 2-nov-2018 11:40:08
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @namespace nixps-cloudflow.FormAgreement
   * @description Draw an argeement of use. 
   * @example $('<div>').FormAgreement({});
   * @version "0.1.0"
   */
  $.widget("nixps-cloudflow.FormAgreement", $.Widget, {
    version: "0.1.0",
    widgetEventPrefix: "formagreement",
    options: {
      /**
       * @desc The text to be show
       * @name nixps-cloudflow.FormAgreement#globalText
       * @type {String}
       * @default "" 
       */
      globalText: "",
      /**
       * @description The url of the link
       * @name nixps-cloudflow.FormAgreement#linkURL
       * @type {String}
       * @default ""
       */
      linkURL: "",
      /**
       * @description The text of the link
       * @name nixps-cloudflow.FormAgreement#linkLabel
       * @type {String}
       * @default ""
       */
      linkLabel: "",
      /**
       * @description The second url of the link
       * @name nixps-cloudflow.FormAgreement#secondLinkURL
       * @type {String}
       * @default ""
       */
      secondLinkURL: "",
      /**
       * @description The second text of the link
       * @name nixps-cloudflow.FormAgreement#secondLinkLabel
       * @type {String}
       * @default ""
       */
      secondLinkLabel: ""
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.FormAgreement#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._draw();
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.FormAgreement#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.FormAgreement#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      if (typeof this.options.linkURL === "string" && this.options.linkURL.length > 0) {
        var link = $('<a>').addClass("cf-link").attr("href", this.options.linkURL);
        if (typeof this.options.linkLabel === "string" && this.options.linkLabel.length > 0) {
          link.text(this.options.linkLabel);
        } else {
          link.text(this.options.linkURL);
        }
        var secondLink;
        if (typeof this.options.secondLinkURL === "string" && this.options.secondLinkURL.length > 0) {
          secondLink = $('<a>').addClass("cf-link").attr("href", this.options.secondLinkURL);
          if (typeof this.options.secondLinkLabel === "string" && this.options.secondLinkLabel.length > 0) {
            secondLink.text(this.options.secondLinkLabel);
          } else {
            secondLink.text(this.options.secondLinkURL);
          }
        }
        if (this.options.globalText.indexOf("${url}") >= 0) {
          var elementHTML = _.escape(this.options.globalText).replace("${url}", link[0].outerHTML);
          if (this.options.globalText.indexOf("${url2}") >= 0 && secondLink !== undefined) {
            elementHTML = elementHTML.replace("${url2}", secondLink[0].outerHTML);
          }
          this.element.append(elementHTML);
        } else {
          this.element.text(this.options.globalText).append(link);
        }
      } else {
        // no link
        this.element.text(this.options.globalText);
      }
    },
    /**
     * @description Sets the options
     * @function
     * @private
     * @name nixps-cloudflow.FormAgreement#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.FormAgreement#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.globalText !== "string") {
        throw new Error("input option globalText must be a string");
      }
    }
  });
})(jQuery);

},{}],148:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Apr 10, 2018 3:00:37 PM
 */
(function ($) {
  var Form = require('../../UIProfiles/js/Form.js');
  var Layout = require('../../UIProfiles/js/Layout.js');
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  /**
   * @namespace nixps-cloudflow.FormListItemRepeater
   * @description Draw a small mini form that we must repeat. this component is used inside the FormRenderer
   * @private
   * @example $('<div>').FormListItemRepeater({});
   */
  $.widget("nixps-cloudflow.FormListItemRepeater", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "formlistitemrepeater",
    options: {
      /**
       * @description The language of the user
       * @name nixps-cloudflow.FormListItemRepeater#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      formJSON: {},
      layoutJSON: null,
      variableDictionary: {},
      startUpOldOptions: {},
      /**
       * @description Is the field required?
       * @name nixps-cloudflow.FormListItemRepeater#required
       * @type {Boolean}
       * @default false
       * @example true
       */
      required: false,
      /**
       * @name nixps-cloudflow.FormListItemRepeater#value 
       * @description The value as Array
       * @type {Array}
       * @default []
       */
      value: [],
      /**
       * @name nixps-cloudflow.FormListItemRepeater#style_type
       * @description The type of style you want
       * @type {String}
       * @private
      */
      style_type: undefined
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.FormListItemRepeater#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.element.append($('<div>').addClass("list"));
      this._on(this.element, {
        "formrendererbeforeprefillfields": this._beforePrefillFieldsHandler
      });
      this.setValue(this.options.value);
      if (this.options.disabled === true) {
        this.element.children(".list.nixps-cloudflow-FormRenderer").FormRenderer("option", "disabled", true);
      }
    },
    /**
     * @description function runs when user want to use autofill fields include in this row
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {*} pData 
     * @returns 
     */
    _beforePrefillFieldsHandler: function _beforePrefillFieldsHandler(pEvent, pData) {
      pEvent.preventDefault();
      if (pData && pData.prefillObject && pEvent && pEvent.originalEvent) {
        var dataKey = $(pEvent.originalEvent.currentTarget).closest("[data-key]").attr("data-key");
        if (typeof dataKey === "string" && dataKey.length > 0) {
          var prefixIndex = parseInt(dataKey.substring(0, dataKey.indexOf(".")));
          if (typeof prefixIndex == "number" && isFinite(prefixIndex)) {
            // make new value array
            var oldValueArray = this.getValue();
            oldValueArray[prefixIndex] = CloudflowObject.merge([oldValueArray[prefixIndex], pData.prefillObject]);
            // generate the injectedKey names
            var flattenObject = CloudflowObject.flatten(pData.prefillObject);
            var injectedKeys = [];
            for (var oldKeys in flattenObject) {
              injectedKeys.push(prefixIndex + "." + oldKeys);
            }
            this.element.children(".list").FormRenderer("setValues", oldValueArray, true, injectedKeys);
            this.element.trigger("fieldcustomchange");
          }
        }
      }
      return false;
    },
    /**
     * @description Draws 
     * @function
     * @private
     * @name nixps-cloudflow.FormListItemRepeater#_draw
     * @return {undefined} 
     */
    _draw: function _draw(pNumber) {
      if (typeof pNumber === "number" && pNumber > 0 && $.isEmptyObject(this.options.formJSON) === false && $.isEmptyObject(this.options.layoutJSON) === false) {
        this.element.children(".list").FormRenderer({
          language: this.options.language,
          formJSON: this._multiplyFormJSON(pNumber),
          layoutJSON: this._multiplyLayoutJSON(pNumber),
          variableDictionary: this.options.variableDictionary,
          style_type: this.options.style_type
        }).css("display", "");
      } else {
        this.element.children(".list").hide();
      }
    },
    /**
     * @description Set an specific array value, this will trigger to draw the amount of rows asked by this function
     * @function
     * @name nixps-cloudflow.FormListItemRepeater#setValue
     * @param {Array} pValues
     * @return {undefined}
     */
    setValue: function setValue(pValues) {
      if (Array.isArray(pValues) === false) {
        throw new Error("parameter must be an array");
      }
      this._draw(pValues.length);
      if (pValues.length > 0) {
        this.element.children(".list.nixps-cloudflow-FormRenderer").FormRenderer("setValues", pValues);
      }
    },
    /**
     * @description Get the array value of it
     * @function
     * @name nixps-cloudflow.FormListItemRepeater#getValue
     * @return {Array}
     */
    getValue: function getValue() {
      var values = this.element.children(".list.nixps-cloudflow-FormRenderer").FormRenderer("getValues");
      if (Array.isArray(values)) {
        return values;
      } else if ($.isPlainObject(values)) {
        // translate object to array
        var keys = Object.keys(values);
        var output = [];
        for (var i = 0; i < keys.length; i++) {
          output.push(values[i]);
        }
        return output;
      }
      return [];
    },
    reset: function reset() {
      return this.element.children(".list.nixps-cloudflow-FormRenderer").FormRenderer("reset");
    },
    isValid: function isValid() {
      return this.element.children(".list.nixps-cloudflow-FormRenderer").FormRenderer("isValid", true);
    },
    _multiplyFormJSON: function _multiplyFormJSON(pNumber) {
      var form;
      if (this.options.formJSON === undefined || $.isEmptyObject(this.options.formJSON)) {
        // if options is missing, create empty form;
        return [];
      } else if (Array.isArray(this.options.formJSON)) {
        // if old format is injected
        form = Form.translateOldFormat(this.options.formJSON, this.options.startUpOldOptions);
      } else if (!$.isEmptyObject(this.options.formJSON)) {
        // new format
        form = Form.fromJSON(this.options.formJSON);
      } else {
        // we do not know what to do?
        throw new Error("invalid inputparameter formJSON");
      }
      var formelements = $.extend(true, [], form.getElements());
      var originalKeys = [];
      var originalComponentIDs = [];
      for (var i = 0; i < form.getElements().length; i++) {
        originalComponentIDs.push(form.getElements()[i].getComponentID());
        if (form.getElements()[i].getType() === "field") {
          // key
          var oldKey = form.getElements()[i].getElement().getKey();
          form.getElements()[i].getElement().setKey("0." + oldKey);
          originalKeys.push(oldKey);
          // component id
          form.getElements()[i].getElement().getComponent().id = "0." + form.getElements()[i].getElement().getComponent().getID();
        } else {
          originalKeys.push(null);
          form.getElements()[i].getElement().id = "0." + form.getElements()[i].getElement().getID();
        }
      }
      for (var i = 1; i < pNumber; i++) {
        for (var j = 0; j < formelements.length; j++) {
          var formElement = formelements[j].clone();
          if (formelements[j].getType() === "field") {
            formElement.getElement().setKey("" + i + "." + originalKeys[j]);
            formElement.getElement().getComponent().id = "" + i + "." + originalComponentIDs[j];
          } else {
            formElement.getElement().id = "" + i + "." + originalComponentIDs[j];
          }
          form.addElement(formElement);
        }
      }
      return form.toJSON();
    },
    _multiplyLayoutJSON: function _multiplyLayoutJSON(pNumber) {
      if ($.isPlainObject(this.options.layoutJSON)) {
        var layout = Layout.fromJSON(this.options.layoutJSON);
        var originalAmountRows = layout.getParameters().getRows().length;
        for (var i = 0; i < pNumber; i++) {
          for (var j = 0; j < originalAmountRows; j++) {
            var row = layout.getParameters().getRow(j);
            layout.getParameters().addRow(row.clone());
          }
        }
        for (var i = 0; i < pNumber; i++) {
          for (var k = 0; k < originalAmountRows; k++) {
            var rowIndex = k + originalAmountRows * i;
            var elements = layout.getParameters().getRow(rowIndex).getElements();
            for (var j = 0; j < elements.length; j++) {
              if (layout.getParameters().getRow(rowIndex).getElement(j).isDump() === false) {
                var oldID = layout.getParameters().getRow(rowIndex).getElement(j).getID();
                layout.getParameters().getRow(rowIndex).getElement(j).setID("" + i + "." + oldID);
              }
            }
          }
        }
        return layout.toJSON();
      }
      return null;
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.FormListItemRepeater#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "disabled") {
        this.element.children(".list.nixps-cloudflow-FormRenderer").FormRenderer("option", "disabled", pValue);
      } else if (pKey === "value") {
        this.options.value = $.extend([], pValue);
        this.setValue(this.options.value);
      } else if (pKey === "required") {
        // ignore completly
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.FormListItemRepeater#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (Array.isArray(this.options.value) === false) {
        throw new Error("FormListItemRepeater input option value must be an array");
      }
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"../../UIProfiles/js/Form.js":249,"../../UIProfiles/js/Layout.js":255}],149:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var kCssLeft = Object.freeze({
    "float": "left"
  });
  var kCssRight = Object.freeze({
    "float": "right"
  });
  var kCssCenter = Object.freeze({
    display: "block",
    "margin-left": "auto",
    "margin-right": "auto"
  });
  var spacesRegExp = new RegExp(" ", "g");
  var CloudflowURL = require("../../CloudflowUtil/js/CloudflowURL.js");
  var kViewableFileRegExp = new RegExp(".*(\.pdf|\.ai|\.art|\.tif|\.tiff|\.ic3|\.ic3d|\.len|\.cf2)$", "i");
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");

  /**
   * @namespace nixps-cloudflow.Image
   * @description To display an image. The option url can also contain an cloudflow url of an pdf-file, in this case the thumbnail will be shown
   * @version 1.5.0
   * @private
   */
  $.widget("nixps-cloudflow.Image", $.Widget, {
    widgetEventPrefix: "image",
    version: "1.5.0",
    options: {
      /**
       * @description The url of the image. The url will be added directly in the src attribute. 
       * We will not change/prepaire or touch the url itself.
       * @name nixps-cloudflow.Image#url
       * @type {String}
       * @default ""
       */
      url: "",
      /**
       * @description The fallback url if the image does not exists
       * @name nixps-cloudflow.Image#fallbackURL
       * @type {String}
       * @default null
       * @since 1.3.0
       */
      fallbackURL: null,
      /**
       * @description The width of the image. This will be added as attribute. If it is a string it will be given as argument to the css jquery  
       * @name nixps-cloudflow.Image#width
       * @type number
       * @default 50
       */
      width: 50,
      /**
       * @description The height of the image. This will be added as attribute. If it is a string it will be given as argument to the css jquery 
       * @name nixps-cloudflow.Image#height
       * @type number
       * @default 50
       */
      height: 50,
      /**
       * @description The maximum with of the image. This value will be give to the jquery css fucntion
       * @name nixps-cloudflow.Image#maxWidth
       * @type {String}
       * @default null
       * @since 1.1.0
       */
      maxWidth: null,
      /**
       * @description The maximum height of the image. This value will be give to the jquery css fucntion
       * @name nixps-cloudflow.Image#maxHeight
       * @type {String}
       * @default null
       * @since 1.1.0
       */
      maxHeight: null,
      /**
       * @description The alt of the image. This will be added as attribute 
       * @name nixps-cloudflow.Image#alt
       * @type {String}
       * @default ""
       */
      alt: "",
      /**
       * @description The tooltip of the image.
       * @name nixps-cloudflow.Image#tooltip
       * @type {String}
       * @default ""
       * @since 1.4.0
       */
      tooltip: "",
      /**
       * @description The name of the plugin to use to add the tooltip
       * @type {String} 
       * @default "jqueryui"
       * @since 1.4.0
       */
      tooltipPlugin: "jqueryui",
      /**
       * @description The options for the tooltip
       * @name nixps-cloudflow.Image#tooltipOptions
       * @type {Object}
       * @default {}
       * @since 1.4.0
       */
      tooltipOptions: {
        tooltipClass: "cf-tooltip cf-tooltip-secondary",
        classes: {
          "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
        }
      },
      /**
       * @description The float of the image. With this you can put the image left, right or centered in his container.
       * The only possible values are: "left", "center", "right"
       * @name nixps-cloudflow.Image#float
       * @type {String}
       * @example "left" 
       * @default null
       */
      "float": "",
      /**
       * @description If the url is a relative path and if this options is given, add this as relative path to make it a static one
       * @name nixps-cloudflow.Image#relativeBasePath
       * @type {String}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @description When there is a cloudflow path must we add a attribute precalculated_only=true to the url or not?
       * @name nixps-cloudflow.Image#precalculated_only
       * @type {Boolean}
       * @default true
       * @since 1.1.0
       */
      precalculatedOnly: true,
      /**
       * @description The postfix to be added to the url to disable cashing
       * @name nixps-cloudflow.Image#urlCachePostfix
       * @type {String}
       * @default "auto"
       */
      urlCachePostfix: "auto",
      /**
       * @name nixps-cloudflow.Image#pagebuilderStyleClass
       * @description Which style class do you want to apply on the component
       * @type {String}
       * @default ""
       * @private
       * @since 1.2.0
       */
      pagebuilderStyleClass: "",
      /**
      * @description The object-fit css style option
      * @name nixps-cloudflow.Image#objectFit
      * @type {String}
      * @default undefined
      */
      objectFit: undefined,
      /**
       * @description What is the loading attribute or policy of this image
       * @name nixps-cloudflow.Image#loadingPolicy
       * @type {String}
       * @default undefined
       * @since 1.5.0
       */
      loadingPolicy: undefined,
      /**
       * @name nixps-cloudflow.Image#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    _create: function _create() {
      this._addClass(this.widgetFullName);
      // variables
      this.url = this.options.url;
      this._draw();
      var that = this;
      if (typeof this.url === "string" && this.url.length > 0) {
        this.element.find("img").one("load", function (pEvent) {
          that.options.created();
        }).one("error", function (pEvent) {
          that.options.created();
        });
      } else {
        // there will be no src image, so it will not trigger load or error
        // empty img
        this.options.created();
      }
    },
    /**
     * @description Function runs when the url could not be loaded
     * @function
     * @name nixps-cloudflow.Image#_errorHandler
     * @private
     * @param {pObject} pEvent 
     */
    _errorHandler: function _errorHandler(pEvent) {
      var originalURL = this.element.find("img").attr("src");
      if (typeof this.options.fallbackURL === "string" && this.options.fallbackURL.length > 0 && this.options.fallbackURL !== this.options.url && this.url !== this.options.fallbackURL) {
        this.url = this.options.fallbackURL;
        this._draw();
      }
      var errorObj = {
        "error_code": "loading_failed",
        "error": "The image could not be loaded"
      };
      this._trigger("error", pEvent, errorObj);
      LogListener.addLog({
        event_type: "error",
        details_data: Object.assign({
          url: originalURL
        }, errorObj),
        component_name: this.widgetFullName
      }, this.element);
    },
    /**
     * @brief redraw
     * @function
     * @private
     * @name nixps-cloudflow.Image#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief draws the dialog according to the current state
     * @name nixps-cloudflow.Image#_draw
     * @function
     * @private
     */
    _draw: function _draw() {
      var image = $("<img>").on("error", this._errorHandler.bind(this));
      if (typeof this.options.tooltip === "string" && this.options.tooltip.length > 0) {
        image.attr("title", this.options.tooltip);
        if (this.options.tooltipPlugin === "jqueryui" && $.fn.tooltip !== undefined) {
          image.tooltip(this.options.tooltipOptions);
        }
      }
      if (typeof this.options.alt === "string") {
        image.attr("alt", this.options.alt);
      }
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        image.addClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
      }
      if (["lazy", "eager"].includes(this.options.loadingPolicy)) {
        image.attr("loading", this.options.loadingPolicy);
      }
      if (typeof this.url === "string" && this.url.length > 0) {
        var url;
        var sourceURL;
        if (this.url.indexOf("http") === 0) {
          // http and https
          url = new CloudflowURL(this.url);
          sourceURL = url.getUploadPath();
        } else if (this.url.indexOf("data:") === 0) {
          // the url is a data base 64
          // no relative paths
          sourceURL = this.url;
        } else {
          if (kViewableFileRegExp.test(this.url) === true) {
            var cloudflowpath = new CloudflowURL(this.options.relativeBasePath, this.url, true).getCloudflowPath();
            url = new CloudflowURL("", "/portal.cgi?metadata=get_thumbnail&file=" + encodeURIComponent(cloudflowpath) + (this.options.precalculatedOnly === true ? "&precalculated_only=true" : ""));
          } else {
            url = new CloudflowURL(this.options.relativeBasePath, this.url);
          }
          sourceURL = url.getUploadPath();
        }
        if (sourceURL.indexOf("data:") === 0) {
          // the url is a data base 64, so no need for url caching
          // continue;
        } else if (this.options.urlCachePostfix === "auto") {
          var cachingMode = this._getCachingMode();
          if (cachingMode === false) {
            var parameterPrefix = sourceURL.indexOf("?") >= 0 ? "&" : "?";
            sourceURL = sourceURL + parameterPrefix + "timestamp=" + +new Date();
          }
        } else if (this.options.urlCachePostfix === true) {
          var parameterPrefix = sourceURL.indexOf("?") >= 0 ? "&" : "?";
          sourceURL = sourceURL + parameterPrefix + "timestamp=" + +new Date();
        }
        image.attr("src", sourceURL);
      }
      this._addCSSValue(image, "width", this.options.width);
      this._addCSSValue(image, "height", this.options.height);
      this._addCSSValue(image, "max-width", this.options.maxWidth);
      this._addCSSValue(image, "max-height", this.options.maxHeight);
      if (typeof this.options.objectFit === "string") {
        this._addCSSValue(image, "object-fit", this.options.objectFit);
      }
      if (this.options["float"] === "right") {
        image.css(kCssRight);
      } else if (this.options["float"] === "left") {
        image.css(kCssLeft);
      } else if (this.options["float"] === "center") {
        image.css(kCssCenter);
      }
      this.element.empty().append($("<div>").append(image));
    },
    _addCSSValue: function _addCSSValue(pImage, pKey, pValue) {
      if (typeof pValue === "number" && pValue > 0) {
        if (pKey === "height" || pKey === "width") {
          pImage.attr(pKey, pValue);
        } else {
          pImage.css(pKey, pValue);
        }
      } else if (typeof pValue === "string" && pValue.length > 0) {
        pImage.css(pKey, this._prepareCSSValue(pValue));
      }
    },
    _prepareCSSValue: function _prepareCSSValue(pCSSValue) {
      // first remove all spaces
      var value = pCSSValue.replace(spacesRegExp, "");
      var parsedValue = parseFloat(value);
      // check if value contains only numbers, so check if string is same as parsed of string
      if (parsedValue == value) {
        return parsedValue; // if so return type number
      }

      return value;
    },
    _getCachingMode: function _getCachingMode() {
      if ($.ui !== undefined && $.ui.nixpsImageCaching !== undefined) {
        return $.ui.nixpsImageCaching;
      } else {
        return null;
      }
    },
    setValue: function setValue(pURL) {
      this.option("url", pURL);
    },
    getValue: function getValue() {
      return this.url;
    },
    setValueReturnDeferred: function setValueReturnDeferred(pURL) {
      // add function that can later be used in pagebuilder, 
      // so let live for a while in this component, so it can savely be used later, without problem of futer compatible
      this.setValue(pURL);
      return {};
    },
    /**
     * @brief sets the option
     * @private
     * @function
     * @name nixps-cloudflow.Image#_setOptions
     */
    _setOptions: function _setOptions(options) {
      var needRedraw = false;
      var imgDOM = this.element.find("img");
      if (options.url !== undefined && options.url !== this.options.url) {
        needRedraw = true;
      }
      if (options.relativeBasePath !== undefined && options.relativeBasePath !== this.options.relativeBasePath) {
        needRedraw = true;
      }
      if (options["float"] !== undefined && options["float"] !== this.options["float"]) {
        needRedraw = true;
      }
      if (options.precalculatedOnly !== undefined && options.precalculatedOnly !== this.options.precalculatedOnly) {
        needRedraw = true;
      }
      if (options.pagebuilderStyleClass !== undefined && options.pagebuilderStyleClass !== this.options.pagebuilderStyleClass) {
        needRedraw = true;
      }
      if (options.width !== undefined && options.width !== this.options.width) {
        this._addCSSValue(imgDOM, "width", options.width);
      }
      if (options.height !== undefined && options.height !== this.options.height) {
        this._addCSSValue(imgDOM, "height", options.height);
      }
      if (options.maxWidth !== undefined && options.maxWidth !== this.options.maxWidth) {
        this._addCSSValue(imgDOM, "max-width", options.maxWidth);
      }
      if (options.maxHeight !== undefined && options.maxHeight !== this.options.maxHeight) {
        this._addCSSValue(imgDOM, "max-height", options.maxHeight);
      }
      if (typeof options.objectFit === "string" && options.objectFit !== this.options.objectFit) {
        this._addCSSValue(imgDOM, "object-fit", options.objectFit);
      }
      if (typeof options.loadingPolicy === "string" && options.loadingPolicy !== this.options.loadingPolicy) {
        if (["lazy", "eager"].includes(options.loadingPolicy)) {
          imgDOM.attr("loading", options.loadingPolicy);
        } else {
          imgDOM.removeAttr("loading");
        }
      }
      if (options.alt !== undefined && options.alt !== this.options.alt) {
        imgDOM.attr("alt", options.alt);
      }
      this._superApply(arguments);
      if (needRedraw === true) {
        this.url = this.options.url;
        this._draw();
      }
    }
  });
})(jQuery);

},{"../../../pagebuilder/js/inspect/LogListener.js":431,"../../CloudflowUtil/js/CloudflowURL.js":80}],150:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @namespace nixps-cloudflow.Input
   * @description Component containing input field. This can be a text, textarea, numberfield, ...
   * It has a correct formcomponent interface
   * @example $("<div>").Input({
      maxLength: 10,
      placeHolder: "event name",
      type: "text",
      value: "hallo"
   * });
   * @version 1.9.0
   * 
   * @readme
   * README:
   *  this component is subject of backwards compability translation! 
   *      Do not remove or change inputoptions, without permission!
   * 
   * 
   */
  $.widget("nixps-cloudflow.Input", {
    widgetEventPrefix: "input",
    version: "1.9.0",
    options: {
      /**
       * @description The type of the input field. We support next types 
       * <ul> <li>text</li> <li>number</li> <li>decimal</li> <li>textarea</li> <li>checkbox</li></ul>
       * @name nixps-cloudflow.Input#type
       * @type {String}
       * @example "checkbox"
       * @default text
       */
      type: "text",
      /**
       * @description The default text that must be show at the beginning
       * @name nixps-cloudflow.Input#value
       * @type String
       * @default ""
       */
      value: "",
      /**
       * @description The placeholder. This is the gray background text when the inputfield is empty.
       * @name nixps-cloudflow.Input#placeholder
       * @type String
       * @default ""
       */
      placeholder: "",
      /**
       * @description The size of a input field. It will be added as the size parameter to the input field. Read online documentation for more information.
       * @name nixps-cloudflow.Input#size
       * @type Number
       * @default undefined, use default HTML setting
       */
      size: undefined,
      /**
       * @description The maxLength of a input field
       * @name nixps-cloudflow.Input#maxLength
       * @type Number
       * @default undefined
       * @example 7
       */
      maxLength: undefined,
      /**
       * @description The amount of rows to be show on start. This only applys on type "textarea"
       * @name nixps-cloudflow.Input#rows
       * @type Number
       * @default 3
       * @example 6
       */
      rows: 3,
      /**
       * @description The language tag. Contains the language for parsing: decide to use comma, or dot.
       * @name nixps-cloudflow.Input#lang
       * @type String
       * @default undefined
       * @example "en"
       */
      lang: undefined,
      /**
       * @name nixps-cloudflow.Input#id
       * @description The id attribute, to be used for linking the label tag
       * @type {String}
       * @default undefined
       * @since 1.9.0
       */
      id: undefined,
      /**
       * @description Is the field required?
       * @name nixps-cloudflow.Input#required
       * @type Boolean
       * @default false
       * @example true
       */
      required: false,
      /**
       * @description The minimum allowed number as value. This will only work for types: number and decimal
       * @name nixps-cloudflow.Input#min
       * @type Number
       * @default null
       * @example 0
       */
      min: null,
      /**
       * @description The maximum allowed number as value. This will only work for types: number and decimal
       * @name nixps-cloudflow.Input#max
       * @type Number
       * @default null
       * @example 100
       */
      max: null,
      /**
       * @desc Must we force the input to be in the range?
       * @name nixps-cloudflow.Input#forceInRange
       * @type Boolean
       * @default true
       */
      forceInRange: true,
      /**
       * @desc The text to show after the checkbox, if you use type: checkbox
       * @name nixps-cloudflow.Input#checkboxLabel
       * @type String
       * @default ""
       */
      checkboxLabel: "",
      /**
       * @description Add additional classNames to the component input, so you can add "form-control" to use it in a bootstrap environment.
       * To add more classes, put a space between the names
       * @name nixps-cloudflow.Input#classes
       * @type {String}
       * @default ""
       * @example "form-control"
       * @example "form-control inputCheck"
       * @since 1.1
       */
      classes: "",
      /**
       * @name nixps-cloudflow.Input#pattern
       * @description The pattern were to match to, This must simulate the pattern attribute of the input tag. It must be a string
       * and may not start with "/". It works only for types "text", "password", "tel", "url", "email", "search" and must match the all value.
       * This is a regular expression
       * @type {String}
       * @default null
       */
      pattern: null,
      /**
       * @name nixps-cloudflow.Input#patternMessage
       * @description The message to be show when the value does not match the option pattern
       * @type {String}
       * @default ""
       * @example "value does not match expression"
       */
      patternMessage: "",
      /**
       * @name nixps-cloudflow.Input#enablePatternOnEmptyValue
       * @description Set on true to check the value with the pattern even if the value is empty, It will check in all cases.
       * Set on false to enable optional fields, so it will not check if the input value is empty
       * @type {Boolean}
       * @default false
       */
      enablePatternOnEmptyValue: false,
      /**
       * @name nixps-cloudflow.Input#autocorrect
       * @description This value will be added as the parameter value of the autocorrect
       * @type {String}
       * @default null
       * @example "off"
       * @since 1.2
       */
      autocorrect: null,
      /**
       * @name nixps-cloudflow.Input#autocomplete
       * @description This value will be added as the parameter value of the autocomplete
       * @type {String}
       * @default null
       * @example ""
       * @since 1.2
       */
      autocomplete: null,
      /**
       * @name nixps-cloudflow.Input#autocapitalize
       * @description This value defines if mobile must start autocapitalize or not
       * @type {String}
       * @default null
       * @example null
       * @since 1.7
       */
      autocapitalize: null,
      /**
       * @name nixps-cloudflow.Input#spellcheck
       * @description This value will be added as the parameter value of the autocomplete. This value must be a empty string (true) or false.
       * Please read [the html specification]{@link https://html.spec.whatwg.org/multipage/interaction.html#spelling-and-grammar-checking} for more detailed information
       * @type {Boolean}
       * @default null
       * @example false
       * @since 1.2.2
       */
      spellcheck: "",
      /**
       * @description Must we set the input field in readonly mode or not?
       * @name nixps-cloudflow.Input#readonly
       * @type {Boolean}
       * @default false
       * @since 1.4.0
       */
      readonly: false,
      /**
       * @description must we disable the setValue function?
       * @name nixps-cloudflow.Input#fixedValue
       * @type {Boolean}
       * @private
       * @default false
       * @since 1.5.0
       */
      fixedValue: false,
      /**
       * @name nixps-cloudflow.Input#name
       * @description The name to be given as value to the name attribute
       * @type {String}
       * @default null
       * @since 1.2
       */
      name: null,
      /**
       * @name nixps-cloudflow.Select#ariaLabel
       * @description Give a help text for accessibility readers
       * @type {String}
       * @default undefined
       * @since 1.9.0
       */
      ariaLabel: undefined,
      /**
       * @name nixps-cloudflow.Input#appendIconClasses
       * @description Add an intern button, by defining the class names
       * @type {String}
       * @default null
       * @since 1.6.0
       */
      appendIconClasses: null,
      /**
       * @name nixps-cloudflow.Input#testid
       * @description the test id to be given to the select DOM
       * @type {String}
       * @default undefined
       * @since 1.8.0
       */
      testid: undefined
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.originalValue = ""; // same as default value for option value
      if (this.options.type === "hidden") {
        try {
          this.originalValue = structuredClone(this.options.value);
        } catch (e) {}
        ;
      }
      this._controlOptions();
      this._draw();
      this._on(this.element, {
        "blur input": this._blurHandler,
        "change": this._changeHandler
      });
    },
    /**
     * @description control the input options of the widget/component
     * @function
     * @private
     * @name nixps-cloudflow.Input#_controlOptions
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.type !== "string" || this.options.type.length <= 0) {
        throw new Error("Input: invalid type option, this must be a well formed string");
      }
      // for some strange reasons the default value "" changed automaticly to true 
      // if value is true and you want no boolean? change to default value ""
      if (this.options.value === true && this.options.type !== "checkbox" && this.options.type !== "hidden") {
        this.options.value = "";
      }
      if (this.options.spellcheck !== "" && typeof this.options.spellcheck !== "boolean") {
        throw new Error("input option spellcheck must be a boolean or a empty string");
      }
      if (typeof this.options.enablePatternOnEmptyValue !== "boolean") {
        throw new Error("input option enablePatternOnEmptyValue must be a boolean");
      }
      if (typeof this.options.readonly !== "boolean") {
        throw new Error("input option readonly must be a boolean");
      }
    },
    /**
     * @description function runs when user change the input. 
     * this function change the value of the input, if the value is out of range.
     * @function
     * @private
     * @name nixps-cloudflow.Input#_blurHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _blurHandler: function _blurHandler(pEvent, pData) {
      if (this.options.forceInRange === true && (this.options.type === "number" || this.options.type === "decimal")) {
        var val = this.element.find(".inputComponent").val();
        if (val === null || val === undefined) {
          val = "";
        } else if (typeof val === "number") {
          val = "" + val;
        }
        val = val.trim();
        if (val.length === 0) {
          // control min and max
          if (typeof this.options.min === "number" && 0 < this.options.min) {
            this.element.find(".inputComponent").val(this.options.min);
          } else if (typeof this.options.max === "number" && 0 > this.options.max) {
            this.element.find(".inputComponent").val(this.options.max);
          }
          return true;
        }
        var decimalSign;
        var foundDecimalSign = false;
        if (val.indexOf(".") >= 0) {
          if (val.indexOf(",") >= 0 && val.indexOf(",") < val.indexOf(".")) {
            decimalSign = ",";
          } else {
            decimalSign = ".";
          }
        } else if (val.indexOf(",") >= 0) {
          decimalSign = ",";
        }
        // parse to remove unusefull stuff
        if (this.options.type === "number") {
          val = parseInt(val);
        } else if (this.options.type === "decimal") {
          if (val.charAt(val.length - 1) === decimalSign) {
            foundDecimalSign = true;
          }
          val = val.replace(/,/g, ".");
          val = parseFloat(val);
        }
        // control result parsing
        if (isNaN(val)) {
          if (typeof this.options.min === "number") {
            this.element.find(".inputComponent").val(this.options.min);
          } else {
            this.element.find(".inputComponent").val(0);
          }
          return true;
        }

        // control min and max
        if (typeof this.options.min === "number" && val < this.options.min) {
          this.element.find(".inputComponent").val(this.options.min);
        } else if (typeof this.options.max === "number" && val > this.options.max) {
          this.element.find(".inputComponent").val(this.options.max);
        } else {
          // no min and max, add value to input
          val = val.toString().replace(/\./g, decimalSign);
          val = foundDecimalSign ? val + decimalSign : val;
          this.element.find(".inputComponent").val(val);
        }
      }
    },
    /**
     * @description fucntion runs when a change occurs
     * @function
     * @private
     * @name nixps-cloudflow.Input#_changeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _changeHandler: function _changeHandler(pEvent, pData) {
      // Need to be wrapped in an object because if the value is false the data in the listener if en empty object.
      this._trigger("change", pEvent, {
        value: this.getValue()
      });
    },
    /**
     * @desc Redraw
     * @function
     * @name nixps-cloudflow.Input#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @desc Draws the input
     * @private
     * @function
     * @name nixps-cloudflow.Input#_draw
     */
    _draw: function _draw() {
      this.element.empty();
      var component;
      if (this.options.type === "textarea") {
        component = $("<textarea>");
        if (typeof this.options.rows === "number" && this.options.rows > 0) {
          component.attr("rows", this.options.rows);
        }
      } else if (this.options.type === "number") {
        component = $("<input>").attr("type", "number").attr("step", 1);
      } else if (this.options.type === "decimal") {
        component = $("<input>").attr("type", "text").attr("step", "any");
      } else {
        component = $("<input>").attr("type", this.options.type);
      }
      component.attr("placeholder", this.options.placeholder).prop("required", this.options.required).attr("maxLength", this.options.maxLength).attr("lang", this.options.lang).attr("autocorrect", this.options.autocorrect).attr("autocomplete", this.options.autocomplete).attr("spellcheck", this.options.spellcheck).attr("name", this.options.name).addClass("inputComponent").addClass(this.options.classes).val(this.options.value);
      if (this.options.autocapitalize !== null) {
        if (this.options.autocapitalize === false) {
          component.attr("autocapitalize", "off");
        } else if (typeof this.options.autocapitalize === "string") {
          component.attr("autocapitalize", this.options.autocapitalize);
        }
      }
      if (typeof this.options.id === "string") {
        component.attr("id", this.options.id);
      }
      if (typeof this.options.testid === "string") {
        component.attr("data-testid", this.options.testid);
      }
      if (typeof this.options.ariaLabel === "string") {
        component.attr("aria-label", this.options.ariaLabel);
      }

      // add disabled
      if (this.options.disabled === true) {
        component.prop("disabled", true);
      }
      if (this.options.readonly === true) {
        component.attr("readonly", "readonly");
      }
      if (isNaN(this.options.min)) {
        this.options.min = undefined;
      }
      if (isNaN(this.options.max)) {
        this.options.max = undefined;
      }

      // add min/max attribute
      if (this.options.type === "number" || this.options.type === "decimal") {
        if (typeof this.options.min === "number") {
          component.attr("min", this.options.min);
          if (this.options.min >= 0) {
            component.attr("inputmode", this.options.type === "number" ? "numeric" : "decimal");
          }
        }
        if (typeof this.options.max === "number") {
          component.attr("max", this.options.max);
        }
      }

      // add size attribute
      if (this.options.type === "text" || this.options.type === "search" || this.options.type === "tel" || this.options.type === "url" || this.options.type === "email" || this.options.type === "password" || this.options.type === "number" || this.options.type === "decimal") {
        component.attr("size", this.options.size);
      } else {
        component.css("min-width", this.options.size + "em");
      }

      // add class to parent for css reson
      this.element.attr("data-type", this.options.type);
      this.element.append(component);
      if (this.options.type === "checkbox") {
        component.addClass("cf-form-checkbox").prop("checked", this.options.value).after($("<span>").addClass("cf-form-checkboxlabel").text(this.options.checkboxLabel));
        this.element.wrapInner("<label></label>").css("cursor", "pointer");
      }
      if (this.options.type === "hidden") {
        this.element.addClass("cf-hideable");
        component.data("value", this.options.value); // save value in data to be able to retrieve in same format
      }

      if (["url", "email", "search", "tel"].includes(this.options.type)) {
        component.attr("inputmode", this.options.type);
      }
      if (typeof this.options.appendIconClasses === "string" && this.options.appendIconClasses.length > 0) {
        var iconElement;
        if (this.options.appendIconClasses.indexOf("cf-iconbutton") >= 0 || this.options.appendIconClasses.indexOf("cf-button") >= 0 || this.options.appendIconClasses.indexOf("cf-input-appendbutton") >= 0) {
          iconElement = $("<button>").attr("type", "button");
        } else {
          iconElement = $("<span>");
        }
        this.element.append(iconElement.addClass(this.options.appendIconClasses));
      }
    },
    /**
     * @description Function returns the value of the inputField as type: defined in option type.
     * Pay attention for return carries in textarea. It use the normal jquery .val() function for textareas. 
     * @function
     * @name nixps-cloudflow.Input#getValue
     * @returns {String}
     */
    getValue: function getValue() {
      if (this.options.type === "checkbox") {
        return this.element.find(".inputComponent").is(":checked");
      } else if (this.element.find(".inputComponent").val().length === 0 && this.options.type === "decimal") {
        return null; //otherwise parseInt will return NaN, but here it must be null
      } else if (this.options.type === "number") {
        var value = parseInt(this.element.find(".inputComponent").val());
        if (isNaN(value)) {
          return null;
        }
        return value;
      } else if (this.options.type === "decimal") {
        // sinces version 1.2.1
        // value should be string and should be converted to a float
        // the value should be alreay parsed by the blurhandler and double characters commas and dots should be already removed
        // this float can contain a comma or a dot
        var decimalValue = this.element.find(".inputComponent").val();
        if (typeof decimalValue === "string") {
          // replace the comma to a dot because the parseFloat can only handle dots!
          decimalValue = decimalValue.replace(/,/g, ".");
        }
        return parseFloat(decimalValue);
      } else if (this.options.type === "hidden") {
        return this.element.find(".inputComponent").data("value");
      }
      return this.element.find(".inputComponent").val();
    },
    /**
     * @description Set the input field to a specific value
     * @function
     * @name nixps-cloudflow.Input#setValue
     * @param {type} pValue
     * @returns {undefined}
     */
    setValue: function setValue(pValue) {
      if (this.options.fixedValue === true) {
        return true;
      }
      if (this.options.type === "checkbox") {
        this.options.value = pValue == true;
        this.element.find(".inputComponent").prop("checked", pValue == true);
      } else if (this.options.type === "hidden") {
        this.options.value = pValue;
        this.element.find(".inputComponent").data("value", pValue).val(pValue);
      } else if (this.options.type === "number") {
        var value = parseInt("" + pValue);
        if (isNaN(value)) {
          value = "";
        } else if (typeof this.options.min === "number" && value < this.options.min) {
          value = this.options.min;
        } else if (typeof this.options.max === "number" && value > this.options.max) {
          value = this.options.max;
        }
        this.options.value = value;
        this.element.find(".inputComponent").val(value);
      } else if (this.options.type === "decimal") {
        var value = parseFloat(pValue);
        if (isNaN(value)) {
          value = "";
        } else if (typeof this.options.min === "number" && value < this.options.min) {
          value = this.options.min;
        } else if (typeof this.options.max === "number" && value > this.options.max) {
          value = this.options.max;
        }
        this.options.value = value;
        this.element.find(".inputComponent").val(value);
      } else {
        this.options.value = pValue;
        this.element.find(".inputComponent").val(pValue);
      }
    },
    /**
     * @description Controls if the input is valid
     * @function
     * @name nixps-cloudflow.Input#isValid
     * @returns {Boolean_string} - true, if everything is correct, or a string containing the errormessage
     */
    isValid: function isValid() {
      if (this.options.type === "number") {
        if (typeof this.options.max === "number" && this.getValue() > this.options.max) {
          return $.i18n._("nixps-cloudflow-FormRenderer.out_of_range");
        }
        if (typeof this.options.min === "number" && this.getValue() < this.options.min) {
          return $.i18n._("nixps-cloudflow-FormRenderer.out_of_range");
        }
      } else if (["text", "password", "tel", "url", "email", "search", "textarea"].includes(this.options.type)) {
        if (typeof this.options.pattern === "string" && this.options.pattern.length > 0 && (this.getValue() !== "" || this.options.enablePatternOnEmptyValue === true)) {
          // only check empty values if option is set on true
          // add pre and post strings according to the html input tag pattern spec
          // see https://html.spec.whatwg.org/multipage/forms.html#the-pattern-attribute
          var regExp = new RegExp("^(?:" + this.options.pattern + ")$");
          if (regExp.test(this.getValue()) === false) {
            return this.options.patternMessage;
          }
        }
      }
      if (this.options.required === true) {
        var value = this.getValue();
        if (typeof value === "string" && value.length === 0) {
          return $.i18n._("nixps-cloudflow-FormRenderer.missing_fields_message");
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    reset: function reset() {
      if (this.options.type === "checkbox") {
        this.setValue(false);
      } else if (this.options.type === "number" || this.options.type === "decimal") {
        this.setValue(0);
      } else if (this.options.type === "hidden") {
        this.setValue(this.originalValue);
      } else {
        this.setValue("");
      }
    },
    enable: function enable() {
      return this._setOption("disabled", false);
    },
    disable: function disable() {
      return this._setOption("disabled", true);
    },
    _setOptions: function _setOptions(pOptions) {
      if (pOptions.type === undefined) {
        this.element.removeClass("cf-hideable"); // class will be added later on
      }
      // restore for setup when user interacted itself, without passing the setValue methode
      var oldValue;
      if (["checkbox", "hidden"].includes(this.options.type)) {
        oldValue = this.getValue();
      } else {
        oldValue = this.element.find("input, textarea").val();
      }
      this._superApply(arguments);
      this._controlOptions();
      // restore old classes, added by parents
      var oldClasses = undefined;
      if (pOptions.classes === undefined) {
        oldClasses = this.element.find("input, textarea").attr("class");
      }
      this._draw();
      this.element.find("input, textarea").addClass(oldClasses);
      if (oldValue !== undefined && "value" in pOptions === false) {
        if (["checkbox", "hidden"].includes(this.options.type)) {
          this.setValue(oldValue);
        } else {
          this.element.find("input, textarea").val(oldValue);
        }
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      if (pKey === "disabled") {
        this.element.find("input, textarea").prop("disabled", pValue);
      }
      if (pKey === "required") {
        this.element.find("input, textarea").prop("required", pValue);
      }
      if (pKey === "ariaLabel") {
        if (typeof pValue === "string") {
          this.element.find("input, textarea").attr("aria-label", pValue);
        } else {
          this.element.find("input, textarea").removeAttr("aria-label");
        }
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this.element.removeClass("cf-hideable");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],151:[function(require,module,exports){
"use strict";

(function ($) {
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");

  /**
   * @namespace nixps-cloudflow.InteractionSelect
   * @description Draw two selectors where the seconds depends of the valu of the first selector.
   * @example $('<div>').InteractionSelect({});
   * @version 1.5
   */
  $.widget("nixps-cloudflow.InteractionSelect", $.Widget, {
    options: {
      /**
       * @description The label to be used as root
       * @name nixps-cloudflow.InteractionSelect#rootLabel
       * @type {String}
       * @default ""
       */
      rootLabel: "",
      /**
       * @description The label to be used as child
       * @name nixps-cloudflow.InteractionSelect#childLabel
       * @type {String}
       * @default ""
       */
      childLabel: "",
      /**
       * @description The key to be used as root
       * @name nixps-cloudflow.InteractionSelect#rootKey
       * @type {String}
       * @default ""
       */
      rootKey: "",
      /**
       * @description The key to be used as child
       * @name nixps-cloudflow.InteractionSelect#childKey
       * @type {String}
       * @default ""
       */
      childKey: "",
      /**
       * @description The type to which the selected variable should be cast. Can be string, integer, number or boolean.
       * @name nixps-cloudflow.Select#rootFormat
       * @type {String}
       * @default "string"
       */
      rootFormat: "string",
      /**
       * @description The type to which the selected variable should be cast. Can be string, integer, number or boolean.
       * @name nixps-cloudflow.Select#childFormat
       * @type {String}
       * @default "string"
       */
      childFormat: "string",
      /**
       * @name nixps-cloudflow.InteractionSelect#keyValues
       * @description
       * This can be an array of objects with a "key" for the first select and an array "value" for the second select when having select corresponding key
       * or
       * An array of objects with an array for the keys, an element for the value, a function with the dataProvider which provides an array with objects and the label.
       * The selects will be rendered in the order they're provided in the array.
       * A select will be filled with the given dataProvider and as arguments the keys of the previously selected.
       * The first dataProvider will not be passed any arguments
       * @type {Array<object>}
       * @default []
       * @example
       * [
       * 	{ keys: ["_id"], dataProvider: function() { *do something and return results* }, value: "name", label: "Users" }
       * 	{ keys: ["approval_id"], dataProvider: function(_id) { *do something and return results* }, value: "name", label: "Approvals" }
       * 	{ keys: ["project_id"], dataProvider: function(approval_id) { *do something and return results* }, value: "name", label: "Projects" }
       * ]
       */
      keyValues: [],
      /**
       * @name nixps-cloudflow.InteractionSelect#selectClasses
       * @description The class names to be added to the selects
       * @type {String}
       * @default "cf-form-control"
       */
      selectClasses: "cf-form-control",
      /**
       * @name nixps-cloudflow.InteractionSelect#labelClasses
       * @description the classes to be given to the parents of the slects
       * @type {String}
       * @default "cf-col-sm-8 col-sm-8",
       */
      mainSelectClasses: "cf-col-sm-8 col-sm-8",
      /**
       * @name nixps-cloudflow.InteractionSelect#labelClasses
       * @description The class names to be added to the labels
       * @type {String}
       * @default "cf-col-sm-4 col-sm-4 cf-form-label cf-form-mainlabel"
       */
      labelClasses: "cf-col-sm-4 col-sm-4 cf-form-label cf-form-mainlabel",
      groupClasses: "cf-form-group",
      /**
       * @description Should we show values that are used in the setValue methode, but who are not listed?
       * @name nixps-cloudflow.InteractionSelect#showUnknownValue
       * @type {Boolean}
       * @default false
       */
      showUnknownValue: false,
      /**
                * @description are the fields required?
                * @name nixps-cloudflow.InteractionSelect#required
                * @type {Boolean}
                * @default false
                * @example true
                */
      required: false
    },
    _create: function _create() {
      this.selectedValues = [];
      this.drawn = false;
      this.backwardsCompatibilityMode = false;
      this.dataProviders;
      this.validKeyValues = {};
      this.renderID = 0;
      this._validateOptions();
      this.element.addClass(this.widgetFullName).addClass("groupComponent");
      this._on(this.element, {
        "change .nixps-cloudflow-Select": this._changeHandler
      });
      if (this.backwardsCompatibilityMode === true) {
        this._backwardsCompatibility();
      } else {
        this.dataProviders = this.options.keyValues;
        this._draw();
      }
    },
    _backwardsCompatibility: function _backwardsCompatibility() {
      var that = this;
      var convertToRootObject = function convertToRootObject(keyValues) {
        return $.map(keyValues, function (elem) {
          var item = {};
          item[that.options.rootKey] = that._formatOutput(elem.key, that.options.rootFormat);
          return item;
        });
      };
      this.initDef = {};
      this.keyValues;
      var rootDataProvider = function rootDataProvider() {
        return $.Deferred(function (pDefer) {
          if (Array.isArray(that.options.keyValues)) {
            that.keyValues = that.options.keyValues;
            pDefer.resolve(convertToRootObject(that.keyValues));
          } else if (typeof that.options.keyValues === "function") {
            if (that.redraw == true || that.drawn === false) {
              that.initDef = $.when(that.options.keyValues());
              that.initDef.then(function (keyValues) {
                that.keyValues = keyValues;
                pDefer.resolve(convertToRootObject(keyValues));
              });
            } else {
              that.initDef.done(function (keyValues) {
                pDefer.resolve(convertToRootObject(keyValues));
              });
            }
          }
        });
      };
      var childDataProvider = function childDataProvider(rootKey) {
        for (var i = 0, len = that.keyValues.length; i < len; i++) {
          if (that._formatOutput(that.keyValues[i].key, that.options.rootFormat) === rootKey) {
            return $.map(that.keyValues[i].value, function (elem) {
              var item = {};
              item[that.options.childKey] = that._formatOutput(elem, that.options.childFormat);
              return item;
            });
          }
        }
        return [];
      };
      this.dataProviders = [];
      this.dataProviders.push({
        keys: [this.options.rootKey],
        dataProvider: rootDataProvider,
        value: this.options.rootKey,
        label: this.options.rootLabel
      });
      this.dataProviders.push({
        keys: [this.options.childKey],
        dataProvider: childDataProvider,
        value: this.options.childKey,
        label: this.options.childLabel
      });
      this._draw();
    },
    _formatOutput: function _formatOutput(pValue, pFormat) {
      switch (pFormat) {
        case "number":
        case "decimal":
        case "double":
          return parseFloat(pValue);
        case "integer":
          return parseInt(pValue);
        case "boolean":
          return pValue.toString() === 'true';
        default:
          // default for string, text , ...
          return pValue;
      }
    },
    /**
     * @brief redraws list
     * @private
     * @function
     * @name nixps-cloudflow.InteractionSelect#redraw
     */
    redraw: function redraw() {
      this._redraw = true;
      this._draw();
    },
    /**
     * @brief draws the list according to the current state
           * @private
     * @function
     * @name nixps-cloudflow.InteractionSelect#_draw
     */
    _draw: function _draw() {
      this._trigger("changing", null, {});
      this._drawSelect(0, []);
    },
    /**
     * @brief starts drawing the selects from index of this.dataProviders and iterates until the last
     * Gives the fetchArguments to the dataProvider to fill the select.
     * Defer can be given if this method is called within a defer
           * @private
     * @function
     * @name nixps-cloudflow.InteractionSelect#_drawSelect
     */
    _drawSelect: function _drawSelect(index, fetchArguments, defer) {
      if (index === this.dataProviders.length) {
        //Trigger the necesarry events and/or resolve the defer
        this._trigger("change", null, {
          values: this.getValue(true)
        });
        this._redraw = false;
        if (this.drawn === false) {
          this.drawn = true;
          this._trigger("drawed");
        }
        if (defer !== undefined) {
          defer.resolve();
        }
        return;
      }
      //Set the dataProvider and the select if it's already drawn
      var item = this.dataProviders[index];
      var that = this;
      var currentElem = this.element.children(".interactionselect_row:nth-child(" + (index + 1) + ")");
      var renderID = ++this.renderID;
      //Retrieve the values that are going to be used for the select with the arguments given.
      //This should be an array of objects and each should include values for the keys and the value of the dataProvider
      $.when(item.dataProvider.apply(null, fetchArguments)).done(function (values) {
        if (renderID !== that.renderID) {
          return;
        }

        //Convert the object to an object for the keyValues option of the select
        var selectedIndex = -1;
        item.resolvedData = values;
        var keyValues = values.reduce(function (accumulator, currentValue, currentIndex) {
          if (that.selectedValues.length > index && that.selectedValues[index] != null && item.keys.some(function (pKey) {
            return that.selectedValues[index][pKey] !== currentValue[pKey];
          }) === false) {
            selectedIndex = currentIndex;
          }
          accumulator[currentIndex] = currentValue[item.value];
          return accumulator;
        }, {});
        if (selectedIndex === -1 && that.options.showUnknownValue && that.selectedValues.length > index && that.selectedValues[index] != null) {
          keyValues[values.length] = "(" + that._convertKeysFromObjectToString(item.keys, that.selectedValues[index]) + ")";
          selectedIndex = values.length;
        } else if (selectedIndex === -1) {
          selectedIndex = 0;
        }

        //Create the select if it doesn't already exists
        if (currentElem.length === 0) {
          var selectContainer = $("<div>").addClass("row groupRow interactionselect_row").addClass(that.options.groupClasses);
          if (index === 0) {
            that.element.prepend(selectContainer);
          } else {
            that.element.children(".interactionselect_row:nth-child(" + index + ")").after(selectContainer);
          }
          var label = $("<label>").addClass(that.options.labelClasses).text(item.label).appendTo(selectContainer);
          var select = $("<div>").addClass("componentContainer").addClass(that.options.mainSelectClasses).appendTo(selectContainer).Select({
            "default": null,
            keyValues: keyValues,
            classes: that.options.selectClasses,
            disabled: that.options.disabled === true,
            required: that.options.required === true,
            outputFormat: "number",
            showUnknownValue: that.options.showUnknownValue
          });
          //Change only the options if it does
        } else {
          select = currentElem.children(".nixps-cloudflow-Select");
          select.Select("option", {
            "default": null,
            keyValues: keyValues,
            classes: that.options.selectClasses,
            disabled: that.options.disabled === true,
            required: that.options.required === true,
            outputFormat: "number",
            showUnknownValue: that.options.showUnknownValue
          });
        }

        //Add the appropriate classes
        if (index === 0) {
          select.addClass("interactionselect_rootselect");
        } else {
          select.addClass("interactionselect_select");
        }
        select.Select("setValue", selectedIndex);

        //Keep iterating until the last dataProvider
        if (that.dataProviders.length !== index + 1) {
          //Build the arguments that will be given to the next dataProvider
          if (values.length === 0) {
            fetchArguments = [];
          } else {
            if (that.selectedValues.length > index) {
              fetchArguments = that._convertKeysFromObjectToArray(item.keys, that.selectedValues[index]);
            } else {
              that.selectedValues[index] = values[0];
              fetchArguments = that._convertKeysFromObjectToArray(item.keys, values[0]);
            }
          }
          that._drawSelect(++index, fetchArguments, defer);
        } else {
          that._drawSelect(++index, [], defer);
        }
      });
    },
    _convertKeysFromObjectToString: function _convertKeysFromObjectToString(pKeys, pObject) {
      return pKeys.reduce(function (accumulator, currentValue) {
        if (pObject !== undefined && pObject !== null) {
          if (accumulator.length > 0) {
            accumulator += " ";
          }
          accumulator += pObject[currentValue];
        }
        return accumulator;
      }, "");
    },
    _convertKeysFromObjectToObject: function _convertKeysFromObjectToObject(pKeys, pObject) {
      return pKeys.reduce(function (accumulator, currentValue) {
        if (pObject !== undefined && pObject !== null) {
          accumulator[currentValue] = pObject[currentValue];
        }
        return accumulator;
      }, {});
    },
    _convertKeysFromObjectToArray: function _convertKeysFromObjectToArray(pKeys, pObject) {
      return pKeys.reduce(function (accumulator, currentValue, currentIndex) {
        if (pObject !== undefined && pObject !== null) {
          accumulator[currentIndex] = pObject[currentValue];
        }
        return accumulator;
      }, []);
    },
    /**
     * @brief get the values of the selects, optionally as an array in case some keys overlap otherwise if the same key is present the key of the last dataprovider wil be used
           * @private
     * @function
     * @name nixps-cloudflow.InteractionSelect#getValue
     */
    getValue: function getValue(asArray) {
      if (asArray === undefined) {
        asArray = false;
      }
      var that = this;
      var valuesAsArray = this._getValueAsArray();
      if (asArray === true) {
        return valuesAsArray;
      } else {
        var values = {};
        for (var i = 0; i < valuesAsArray.length; i++) {
          if (valuesAsArray[i] !== null) {
            $.each(valuesAsArray[i], function (keys, value) {
              values = CloudflowObject.setParameter(values, keys, value);
            });
          } else {
            return null;
          }
        }
        return values;
      }
    },
    /**
     * @description Gets the keys as an array which can possibly
           * @private
     * @function
     * @name nixps-cloudflow.InteractionSelect#_getValueAsArray
     */
    _getValueAsArray: function _getValueAsArray() {
      var values = [];
      var selects = this.element.find(".nixps-cloudflow-Select");
      for (var i = 0, len = selects.length; i < len; i++) {
        var index = $(selects[i]).Select("getValue");
        if (index !== null) {
          var index = parseInt(index);
          var length = this.dataProviders[i].resolvedData.length;
          if (index < length) {
            var value = this._convertKeysFromObjectToObject(this.dataProviders[i].keys, this.dataProviders[i].resolvedData[index]);
          } else if (this.selectedValues.length > i) {
            var value = this._convertKeysFromObjectToObject(this.dataProviders[i].keys, this.selectedValues[i]);
          } else {
            var value = null;
          }
        } else {
          var value = null;
        }
        values.push(value);
      }
      return values;
    },
    setValue: function setValue(pValue) {
      var that = this;
      return $.Deferred(function (pDefer) {
        if ($.isPlainObject(pValue)) {
          that.selectedValues = [];
          for (var i = 0, len = that.dataProviders.length; i < len; i++) {
            var item = {};
            for (var j = 0, jLen = that.dataProviders[i].keys.length; j < jLen; j++) {
              var value = CloudflowObject.getParameter(pValue, that.dataProviders[i].keys[j]);
              if (value !== undefined) {
                item[that.dataProviders[i].keys[j]] = value;
              }
            }
            if (Object.keys(item).length > 0) {
              that.selectedValues[i] = item;
            }
          }
        } else {
          that.selectedValues = pValue;
        }
        that._trigger("changing", null, {});
        that._drawSelect(0, [], pDefer);
      });
    },
    reset: function reset() {},
    _changeHandler: function _changeHandler(event, data) {
      var indexSelect = $(event.currentTarget).closest(".interactionselect_row").index();
      var argsSelect = $(event.currentTarget).Select("getValue");
      this._trigger("changing", null, {});
      this.selectedValues.splice(indexSelect, this.selectedValues.length - indexSelect, this.dataProviders[indexSelect].resolvedData[parseInt(argsSelect)]);
      this._drawSelect(indexSelect, indexSelect > 0 ? this._convertKeysFromObjectToArray(this.dataProviders[indexSelect - 1].keys, this.selectedValues[indexSelect - 1]) : []);
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._validateOptions();
      if (pKey === "disabled") {
        this.element.find('.nixps-cloudflow-Select').Select("option", "disabled", pValue);
      } else if (pKey === "required") {
        this.element.find('.nixps-cloudflow-Select').Select("option", "required", pValue);
      } else {
        this.redraw();
      }
    },
    /**
     * @brief validates the options
           * @private
     * @function
     * @name nixps-cloudflow.InteractionSelect#_validateOptions
     */
    _validateOptions: function _validateOptions() {
      var that = this;
      if (Array.isArray(this.options.keyValues) === true && this.options.keyValues.length > 0) {
        $.each(this.options.keyValues, function (index, item) {
          if (item.dataProvider === undefined || Array.isArray(item.keys) === false || item.value === undefined) {
            that.backwardsCompatibilityMode = true;
          }
        });
      } else {
        this.backwardsCompatibilityMode = true;
      }
      if (this.backwardsCompatibilityMode === true) {
        if (typeof this.options.rootLabel !== "string") {
          throw new Error("input option rootLabel must be a string");
        }
        if (typeof this.options.childLabel !== "string") {
          throw new Error("input option childLabel must be a string");
        }
        if (typeof this.options.rootKey !== "string" || this.options.rootKey.length <= 0) {
          throw new Error("input option rootKey must be a string");
        }
        if (typeof this.options.childKey !== "string" || this.options.childKey.length <= 0) {
          throw new Error("input option childKey must be a string");
        }
        if (typeof this.options.selectClasses !== "string") {
          throw new Error("input option selectClasses must be an string");
        }
        if (typeof this.options.keyValues === "function") {
          // if function do not control the rest, (other possibilities of type of the option)
          return true;
        }
        if (!Array.isArray(this.options.keyValues)) {
          throw new Error("input option value must be an array");
        }
        for (var i = 0; i < this.options.keyValues.length; i++) {
          if (this.options.keyValues[i].key === undefined) {
            throw new Error("each item must have a parameter key");
          }
          if (!Array.isArray(this.options.keyValues[i].value)) {
            throw new Error("each item must have a parameter value as array");
          }
        }
      }
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowObject.js":79}],152:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jul 10, 2018 10:44:51 AM
 */
(function ($) {
  "use strict";

  /**
   * @namespace nixps-cloudflow.ListEditButtons
   * @description This component adds, insert and remove row buttons and managed the actions.
   * Make a component with headers and add this component on the same element to handle the row buttons.
   * So in contrast with other components this component can/should live inside an other component.
   * @example $("<div>").ListEditButtons({
   *  "rowSelector": ".row"
   * });
   * @version 1.2.0
   */
  $.widget("nixps-cloudflow.ListEditButtons", $.Widget, {
    version: "1.2.0",
    options: {
      /**
       * @description The jQuery selector to recognise a row
       * @name nixps-cloudflow.ListEditButtons#rowSelector
       * @type {String}
       * @default ""
       */
      rowSelector: "",
      /**
       * @description Are we allowed to have no rows at all?
       * @name nixps-cloudflow.ListEditButtons#allowEmptyValue
       * @type {Boolean}
       * @default false
       */
      allowEmptyValue: false,
      /**
       * @description The classes separated by space will be added to the buttons parent
       * @name nixps-cloudflow.ListEditButtons#buttonClasses
       * @type {String}
       * @default ""
       */
      buttonClasses: "",
      /**
       * @description Must we add the insert and remove buttons on all the rows when we init the element
       * @name nixps-cloudflow.ListEditButtons#addButtonsOnStart
       * @type {Boolean}
       * @default true
       */
      addButtonsOnStart: true,
      /**
       * @description Create an visible empty row on start up
       * @name nixps-cloudflow.ListEditButtons#createEmptyRowOnStart
       * @type {Boolean}
       * @default true
       */
      createEmptyRowOnStart: true,
      /**
       * @description Callback to ask to add and return a new empty row
       * @name nixps-cloudflow.ListEditButtons#appendEmptyRow
       * @type {Function}
       * @default function(){}
       */
      appendEmptyRow: function appendEmptyRow(pParent, pOrigRow) {},
      /**
       * @description The html of the first button
       * @name nixps-cloudflow.ListEditButtons#firstButtonHTML
       * @type {String}
       * @default "<button class='cf-icon cf-icon-minus-circle leb_removebutton'></button>"
       */
      firstButtonHTML: "<button type='button' class='cf-iconbutton cf-icon cf-icon-minus-circle leb_removebutton'></button>",
      /**
       * @description The html of the second button
       * @name nixps-cloudflow.ListEditButtons#secondButtonHTML
       * @type {String}
       * @default "<button class='cf-icon cf-icon-plus-circle leb_addbutton'></button>"
       */
      secondButtonHTML: "<button type='button' class='cf-iconbutton cf-icon cf-icon-plus-circle leb_addbutton'></button>",
      /**
       * @description The tooltip to be applied on the first button
       * @name nixps-cloudflow.ListEditButtons#firstButtonTooltip
       * @type {String}
       * @default $.i18n._("nixps-cloudflow-ArrayInput.add_row")
       */
      firstButtonTooltip: "",
      /**
       * @description The tooltip to be applied on the second button
       * @name nixps-cloudflow.ListEditButtons#secondButtonTooltip
       * @type {String}
       * @default $.i18n._("nixps-cloudflow-ArrayInput.remove_row")
       */
      secondButtonTooltip: ""
    },
    /**
     * @description init the options
     * @function
     * @name nixps-cloudflow.ListEditButtons#_getCreateOptions
     * @private
     */
    _getCreateOptions: function _getCreateOptions() {
      return {
        firstButtonTooltip: $.i18n._("nixps-cloudflow-ArrayInput.remove_row"),
        secondButtonTooltip: $.i18n._("nixps-cloudflow-ArrayInput.add_row")
      };
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.ListEditButtons#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      if (this.element.find(this.options.rowSelector).length === 0) {
        var newRow = this.options.appendEmptyRow(this.element);
        if (newRow.parent().is(this.element) === false) {
          this.element.append(newRow);
        }
        if (this.options.addButtonsOnStart === true) {
          newRow.append(this._drawButtons());
          if (this.options.allowEmptyValue === false) {
            newRow.find(".leb_removebutton").prop("disabled", true).not("button").hide();
          }
        }
        if (this.options.createEmptyRowOnStart === false) {
          newRow.addClass("arrayinput_emptyvalue");
          newRow.find(":not(.leb_addbutton):not(.leb_buttons)").css("visibility", "hidden");
        }
      } else if (this.options.addButtonsOnStart === true) {
        this.appendMissingButtons();
      }
      this._on(this.element, {
        "click .leb_addbutton": this._addRowClickHandler,
        "click .leb_removebutton": this._removeRowClickHandler
      });
    },
    /**
     * @description function runs when user click on the add icon, to insert a new row
     * @function
     * @private
     * @name nixps-cloudflow.ListEditButtons#_addRowClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     **/
    _addRowClickHandler: function _addRowClickHandler(pEvent, pData) {
      this._addRowAction($(pEvent.target));
      pEvent.stopPropagation();
      this._trigger("change", pEvent, {
        action: "add"
      });
    },
    /**
     * @description function runs when user click on the remove button, to remove a row
     * @function
     * @private
     * @name nixps-cloudflow.ListEditButtons#_removeRowClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _removeRowClickHandler: function _removeRowClickHandler(pEvent, pData) {
      var row = $(pEvent.target).closest(this.options.rowSelector);
      // we will remove a row in the futur, so if there will be one left over (before removing 2 rows), hide the other remove buttons
      // to prevent removing the last row
      if (this.element.children(this.options.rowSelector).length <= 2 && this.options.allowEmptyValue === false) {
        this.element.children(this.options.rowSelector).find(".leb_removebutton").prop("disabled", true).not("button").hide();
      }
      // check if we are the last
      if (this.element.children(this.options.rowSelector).length === 1 && this.options.allowEmptyValue === true) {
        row.addClass("arrayinput_emptyvalue");
        row.find(":not(.leb_addbutton):not(.leb_buttons)").css("visibility", "hidden");
      } else {
        row.remove();
      }
      this._trigger("change", pEvent, {
        action: "remove",
        row: row
      });
      pEvent.stopPropagation();
    },
    _addRowAction: function _addRowAction(pRowDOM) {
      var row = pRowDOM.closest(this.options.rowSelector);
      var newRow = this.options.appendEmptyRow(this.element, row);
      if (newRow.parent().is(this.element) === false) {
        row.after(newRow);
      }
      if (row.hasClass("arrayinput_emptyvalue")) {
        row.remove();
      }
      // add buttons
      newRow.append(this._drawButtons());
      // select the new input fields
      pRowDOM.closest(this.options.rowSelector).next().find("input").first().trigger("focus").trigger("select");
      // show the remove buttons, because now there are more then one row 
      this.element.children(this.options.rowSelector).find(".leb_removebutton").prop("disabled", "").not("button").css("display", "");
      return newRow;
    },
    /**
     * @description function returns the add and remove buttons
     * @function
     * @private
     * @name nixps-cloudflow.ListEditButtons#_drawButtons
     * @returns {jQueryDOM}
     */
    _drawButtons: function _drawButtons() {
      return $("<div>").addClass("leb_buttons").addClass(this.options.buttonClasses).append($(this.options.firstButtonHTML).attr("title", this.options.firstButtonTooltip)).append($(this.options.secondButtonHTML).attr("title", this.options.secondButtonTooltip));
    },
    /**
     * @description add missing buttons on the rows who has no buttons
     * @function
     * @name nixps-cloudflow.ListEditButtons#appendMissingButtons
     * @returns {undefined}
     */
    appendMissingButtons: function appendMissingButtons() {
      var that = this;
      this.element.find(this.options.rowSelector).each(function () {
        if ($(this).children(".leb_buttons").length === 0) {
          $(this).append(that._drawButtons());
        }
      });
      if (this.element.find(this.options.rowSelector).length === 1 && this.options.allowEmptyValue === false) {
        this.element.find(this.options.rowSelector).find(".leb_removebutton").prop("disabled", true).not("button").hide();
      }
    },
    addNewRow: function addNewRow(pRowDOM) {
      return this._addRowAction(pRowDOM);
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ConfigurePlainObject#_setOption
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      if (options.disabled !== undefined) {
        this.element.find(".leb_buttons").children().prop("disabled", options.disabled);
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.ConfigurePlainObject#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.firstButtonTooltip !== "string") {
        throw new Error("ListEditButtons input option firstButtonTooltip must be a string");
      }
      if (typeof this.options.secondButtonTooltip !== "string") {
        throw new Error("ListEditButtons input option secondButtonTooltip must be a string");
      }
    }
  });
})(jQuery);

},{}],153:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on May 25, 2016 11:19:17 AM
 */

(function ($) {
  "use strict";

  /**
   * @function
   * @static
   * @desc try to decode a url
   * @param {string} pUrl the url to decode
   * @return {undefined}
   */
  function decodeURL(pUrl) {
    try {
      return decodeURIComponent(pUrl);
    } catch (e) {
      return pUrl;
    }
  }
  /**
   * @namespace nixps-cloudflow.MultiSelect
   * @description A component that give you the possibility to give a dynamic list of checkboxes, compatible with the formbuilder.
   * This component is only for internal use! This component will be used for the (kiosk formbuilder) 
   * Do not change without permission.
   * @version 1.3.0
   */
  $.widget("nixps-cloudflow.MultiSelect", $.Widget, {
    version: "1.3.0",
    options: {
      /**
       * @description The input fields for displaying the selection fields. This is a array of strings.
       * The strings will be visible as item title.
       * @name nixps-cloudflow.MultiSelect#inputFields
       * @type {Array.<String>}
       * @default []
       */
      inputFields: [],
      /**
       * @description The fields that must be selected on creation.
       * @name nixps-cloudflow.MultiSelect#selectFields
       * @type {Array.<String>}
       * @default []
       */
      selectFields: [],
      /**
       * @description Which field must be disabled, so the user can not change them.
       * @name nixps-cloudflow.MultiSelect#disabledFields
       * @type {Array.<String>}
       * @default []
       * @since 1.1.0
       */
      disabledFields: [],
      /**
       * @description Wich type of values do we have? Now we only support "file" type.
       * @name nixps-cloudflow.MultiSelect#type
       * @type {String}
       * @default "file"
       */
      type: "file",
      /**
       * @description The minimal amount of selected items
       * @name nixps-cloudflow.MultiSelect#minSelectedItems
       * @type {Number}
       * @default 0
       * @since 1.1.0
       */
      minSelectedItems: 0,
      /**
       * @description are the fields required?
       * @name nixps-cloudflow.MultiSelect#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.3.0
       */
      required: false
    },
    /**
     * @description create the component
     * @name nixps-cloudflow.MultiSelect#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._controlOptions();
      this._draw();
      if (this.options.disabled === true) {
        this.element.addClass(this.widgetFullName + "-disabled ui-state-disabled");
      }
    },
    /**
     * @description control all the input options and throw errors
     * @name nixps-cloudflow.MultiSelect#_setOption
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (!Array.isArray(this.options.inputFields)) {
        throw new Error("inputField inputFields must be an array");
      }
      if (!Array.isArray(this.options.selectFields)) {
        throw new Error("inputField selectFields must be a array");
      }
      if (["file", "as_is"].includes(this.options.type) === false) {
        throw new Error("inputField type: we only support type 'file' or 'as_is'");
      }
      if (typeof this.options.minSelectedItems !== "number") {
        throw new Error("input option minSelectedItems must be a number");
      }
      if (!Array.isArray(this.options.disabledFields)) {
        throw new Error("input option disabledFields must be an array");
      }
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps-cloudflow-MultiSelect#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.MultiSelect#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      for (var i = 0; i < this.options.inputFields.length; i++) {
        var id;
        var label;
        if (this.options.inputFields[i].id !== undefined) {
          id = this.options.inputFields[i].id;
          label = this.options.inputFields[i].label;
        } else {
          id = this.options.inputFields[i];
          label = this.options.inputFields[i];
        }
        this.element.append($("<div>").addClass("chooseItem").Input({
          type: "checkbox",
          value: this.options.selectFields.includes(id),
          required: false,
          forceInRange: false,
          checkboxLabel: this._calcDisplayLabel(label),
          disabled: this.options.disabled === true || this.options.disabledFields.includes(id)
        }).data("inputFieldID", id));
      }
    },
    /**
     * @description get the correct output text corresponding to the option type
     * @function
     * @private
     * @name nixps-cloudflow.MultiSelect#_calcDisplayLabel
     */
    _calcDisplayLabel: function _calcDisplayLabel(pInputField) {
      if (this.options.type === "as_is") {
        return "" + pInputField;
      } else if (this.options.type === "file" && typeof pInputField === "string") {
        return decodeURL(pInputField.replace(/.*\/([^\/\.]*\..*)$/, "$1"));
      } else {
        return "" + pInputField;
      }
    },
    /**
     * @description get the value of the select items.
     * @name nixps-cloudflow.MultiSelect#getValue
     * @function
     * @returns {string}  the selected items.
     */
    getValue: function getValue() {
      var that = this;
      return this.element.find(".chooseItem").map(function (index, elem) {
        if ($(this).Input("getValue") === true) {
          if (that.options.inputFields[index].id !== undefined) {
            return that.options.inputFields[index].id;
          } else {
            return that.options.inputFields[index];
          }
        }
      }).get();
    },
    /**
     * @description set the select items.
     * @name nixps-cloudflow.MultiSelect#setValue
     * @param {Array.<String>} pValues The values to be selected 
     * @function
     */
    setValue: function setValue(pValues) {
      if (!Array.isArray(pValues)) {
        throw new Error("invalid input parameter, it must be a array");
      }
      this.element.find(".chooseItem").each(function (elem, index) {
        var inputID = $(this).data("inputFieldID");
        if (pValues.includes(inputID)) {
          $(this).Input("setValue", true);
        } else {
          $(this).Input("setValue", false);
        }
      });
    },
    /**
     * @description Is the current setup valid or not? Checks if the amount of selected checkboxes is archived
     * @function
     * @name nixps-cloudflow.MultiSelect#isValid
     * @since 1.1.0
     * @return {String|Boolean}
     */
    isValid: function isValid() {
      if (typeof this.options.minSelectedItems === "number" && this.options.minSelectedItems >= 0) {
        var amount = 0;
        this.element.find(".chooseItem").each(function () {
          if ($(this).Input("getValue") === true) {
            amount++;
          }
        });
        if (amount < this.options.minSelectedItems) {
          return $.i18n._("nixps-cloudflow-FormRenderer.min_selected_items", [this.options.minSelectedItems]);
        }
      }
      return true;
    },
    /**
     * @description Reset
     * @function
     * @name nixps-cloudflow.MultiSelect#reset
     * @returns {undefined}
     */
    reset: function reset() {
      this.element.find(".chooseItem").each(function (elem, index) {
        $(this).Input("setValue", false);
      });
    },
    setMetadata: function setMetadata(pMetadata) {
      if ($.isPlainObject(pMetadata)) {
        var colorNames = pMetadata["ColorantNames"];
        if (Array.isArray(colorNames) && colorNames.length > 0) {
          this.options.inputFields = colorNames;
          this._draw();
        }
      }
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-cloudflow.MultiSelect#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "disabled") {
        if (pValue === true) {
          this.element.find(".nixps-cloudflow-Input").Input("option", "disabled", true);
        } else {
          var that = this;
          this.element.find(".nixps-cloudflow-Input").filter(function (index, elem) {
            // return true to include in the list
            var listID = $(this).data("inputFieldID");
            return that.options.disabledFields.includes(listID) === false;
          }).Input("option", "disabled", false);
        }
      } else if (pKey === "required") {
        //
      } else {
        this._draw();
      }
    }
  });
})(jQuery);

},{}],154:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Apr 25, 2017 2:55:33 PM
 */
(function ($) {
  var WhitepaperConnection = require("../../CloudflowUtil/js/WhitepaperConnection.js");

  /**
   * @description Does the workflow exists or not?
   * @static
   * @private
   * @type Boolean
   */
  var workflowExist;

  /**
   * @namespace nixps-cloudflow.Password
   * @description Draw a pasword field, connected to the backend workflow. Triggers next events
   * <ul>
   *  <li> <b> startchecking </b>, fires before checking</li>
   *  <li> <b> checked </b>, data: result, fires when result is known </li>
   *  <li> <b> checkedfailed </b>, data: error, fires when checking has failed </li>
   * </ul>
   * @private
   * @version 2.1.0
   * @example $("<div>").Password({});
   */
  $.widget("nixps-cloudflow.Password", $.Widget, {
    version: "2.1.0",
    widgetEventPrefix: "password",
    options: {
      /**
       * @name nixps-cloudflow.Password#misleadAutocomplete
       * @description Try to misslead the autocomplate functionality
       * @default true
       * @type {Boolean}
       */
      misleadAutocomplete: true,
      /**
       * @name nixps-cloudflow.Password#checkStrength
       * @description Must we check the password
       * @type {Boolean}
       * @default false
       */
      checkStrength: false,
      /**
       * @name nixps-cloudflow.Password#pattern
       * @description The pattern were to match to, This must simulate the pattern attribute of the input tag. It must be a string
       * and may not start with '/'. It works only for types "text", "password", "tel", "url", "email", "search" and must match the all value.
       * This is a regular expression
       * @type {String}
       * @default null
       */
      pattern: null,
      /**
       * @name nixps-cloudflow.Password#patternMessage
       * @description The message to be show when the value does not match the option pattern
       * @type {String}
       * @default ""
       * @example "value does not match expression"
       */
      patternMessage: "",
      /**
       * @name nixps-cloudflow.Password#whitepaperName
       * @description The name of the whitepaper, who must handle the controls and checks
       * @type {Boolean}
       * @default "UserManagement"
       */
      whitepaperName: "User Management Flow",
      /**
       * @description The id to assign to the input field itself
       * @name nixps-cloudflow.Password#id
       * @type {String}
       * @default undefined
       * @since 2.1.0
       */
      id: undefined,
      /**
       * @description Is the field required?
       * @name nixps-cloudflow.Password#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 2.1.0
       */
      required: false
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.Password#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.dead = false; // inform we are alive !!
      this.validating = false; // flag to indicate we are being validating, to prevent checks during checks
      this.workableID;

      // first check existing of workflow on start up, cache also that result
      if (typeof this.options.whitepaperName === "string" && this.options.whitepaperName.length > 0) {
        this.checkWorkflow = this._checkWorkflowExist();
      } else {
        this.checkWorkflow = false;
      }

      // draw the input field
      this._draw();
      this._on(this.element, {});
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.Password#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Sraws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.Password#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var realInputOptions = {
        type: "password",
        autocorrect: "off",
        autocomplete: null,
        name: "userpass",
        classes: "cf-form-control",
        id: this.options.id,
        required: this.options.required,
        disabled: this.options.disabled
      };
      if (this.options.checkStrength === true) {
        realInputOptions.pattern = this.options.pattern;
        realInputOptions.patternMessage = this.options.patternMessage;
        realInputOptions.enablePatternOnEmptyValue = true;
        realInputOptions.autocomplete = "new-password";
      }
      var fakeInputs = undefined;
      if (this.options.misleadAutocomplete === true) {
        fakeInputs = $("<div>").addClass("username").append($("<div>").append($("<input>").attr({
          "type": "text",
          "name": "username",
          "tabIndex": "-1",
          "aria-label": "username is optional"
        })).append($("<input>").attr({
          "type": "password",
          "tabIndex": "-1",
          "aria-label": "un used field"
        })));
        realInputOptions.autocomplete = "new-password";
      }
      var passwordWaitIconDOM = $("<span>");
      passwordWaitIconDOM.addClass('password_waitIcon').hide();
      this.element.empty().append(fakeInputs).append($("<div>").addClass("password_input").Input(realInputOptions)).append(passwordWaitIconDOM).append("<div class='password_resultpanel password_resultpanel_empty'><span class='password_resulticon'></span></div>");
      if (this.options.misleadAutocomplete === true) {
        this.element.find(".username").css({
          height: "0px",
          overflow: "hidden",
          padding: "0px"
        });
      }
    },
    /**
     * @description inform the user that a password has been changed
     * @function
     * @name nixps-cloudflow.Password#inform
     * @param {string} pEmail The email address
     * @param {string} pWhitepaperInputName
     * @param {object} pVariables the variables send to the backend workflow
     * @returns {Deferred}
     */
    inform: function inform(pEmail, pWhitepaperInputName, pVariables) {
      if (typeof pEmail !== "string") {
        throw new Error("parameter email must be a string");
      }
      if (workflowExist === false) {
        return $.Deferred().reject("whitepaper does not exist");
      }
      var that = this;
      // password
      var password = this.element.find(".password_input").Input("getValue");
      // input name
      var inputName = "informPassword";
      if (typeof pWhitepaperInputName === "string" && pWhitepaperInputName.length > 0) {
        inputName = pWhitepaperInputName;
      }
      // variables
      var variables = {
        email: pEmail,
        password: password
      };
      if ($.isPlainObject(pVariables) && $.isEmptyObject(pVariables) === false) {
        variables = $.extend({}, pVariables, variables);
      }
      return $.Deferred(function (pDefer) {
        if (workflowExist === true) {
          api_async.hub.start_from_whitepaper_with_variables(that.options.whitepaperName, inputName, variables, pDefer.resolve, pDefer.reject);
        } else {
          that.checkWorkflow.then(function () {
            api_async.hub.start_from_whitepaper_with_variables(that.options.whitepaperName, inputName, variables, pDefer.resolve, pDefer.reject);
          }, pDefer.reject);
        }
      });
    },
    /**
     * @description check if a password is valid
     * @function
     * @name nixps-cloudflow.Password#isValid
     * @param {string} pEmail
     * @returns {undefined}
     */
    isValid: function isValid(pEmail, pAudit) {
      if (this.options.checkStrength === false) {
        return true;
      }
      var that = this;
      var isValid = this.element.find(".password_input").Input("isValid");
      if (isValid !== true) {
        return isValid;
      }
      var password = this.element.find(".password_input").Input("getValue");
      if (this.validating === true) {
        return;
      }
      if (typeof this.options.whitepaperName === "string" && this.options.whitepaperName.length > 0) {
        this.validating = true; // we will start validating, set the lock
        if (workflowExist === true) {
          return this._checkPasswordByWhitepaper(password, pEmail).then(function (pResults) {
            if (pResults === undefined || typeof pResults.approved !== "boolean") {
              console.error('wrong interface, found parameter is required');
              that._informError({});
              return Promise.reject({
                "error": "wrong interface",
                "error_code": "wrong_interface"
              });
            } else {
              that._informResult(pResults, pAudit);
              return true;
            }
          })["catch"](function (pError) {
            that._informError(pError);
            return Promise.reject(pError);
          });
        } else if (workflowExist === false) {
          this._informResult(true, pAudit);
          return $.Deferred().resolve(true);
        } else {
          return this.checkWorkflow.done(function (pExist) {
            if (pExist === true) {
              that._checkPasswordByWhitepaper(password, pEmail).then(function (pResults) {
                if (pResults === undefined || typeof pResults.approved !== "boolean") {
                  console.error("wrong interface, found parameter is required");
                  that._informError({});
                  return Promise.reject({
                    "error": "wrong interface",
                    "error_code": "wrong_interface"
                  });
                } else {
                  that._informResult(pResults, pAudit);
                  return true;
                }
              })["catch"](function (pError) {
                that._informError(pError);
                return Promise.reject(pError);
              });
            } else {
              that._informResult(true, pAudit);
              return true;
            }
          }).fail(function (pError) {
            that._informError(pError);
          });
        }
      } else {
        return true;
      }
    },
    _checkPasswordByWhitepaper: function _checkPasswordByWhitepaper(pPassword, pEmail) {
      if (typeof pEmail !== "string") {
        pEmail = "";
      }
      if (typeof pPassword !== "string") {
        throw new Error("parameter pPassword must be a string");
      }
      this._informStartChecking();
      var connection = new WhitepaperConnection(this.options.whitepaperName, "change", {
        "password": pPassword,
        "email": pEmail
      });
      connection.setStartPollingTime(3);
      return connection.start();
    },
    /**
     * @description inform the world we are bussy with checking the password
     * @function
     * @name nixps-cloudflow.Password#_informStartChecking
     * @private
     * @return {undefined}
     */
    _informStartChecking: function _informStartChecking() {
      this.element.find(".password_waitIcon").css("display", "");
      this.element.find(".password_input").Input("disable");
      // reset previous text message
      this.element.find(".password_resultpanel").addClass("password_resultpanel_empty");
      this.element.find(".password_resulticon").removeClass("fa-check cf-text-success fa-times cf-text-error").attr("title", "");
      this._trigger("startchecking", null, {});
    },
    /**
     * @description inform the world about the returned results
     * @function
     * @name nixps-cloudflow.Password#_informResult
     * @private
     * @param {type} pResult
     * @return {undefined}
     */
    _informResult: function _informResult(pResult, pAudit) {
      this.element.find('.password_input').Input('enable');
      var result = pResult;
      if (typeof pResult === "boolean") {
        result = {
          "approved": pResult,
          "message": ""
        };
      }
      // first clean previous
      this.element.find(".password_resultpanel").addClass("password_resultpanel_empty");
      this.element.find('.password_waitIcon').hide();
      this.element.find('.password_resulticon').removeClass('fa-check cf-text-success fa-times cf-text-error').filter(".ui-tooltip").tooltip("destroy");
      // install good icons and text
      if (result.approved === true) {
        this.element.find(".password_resultpanel").removeClass("password_resultpanel_empty");
        this.element.find('.password_resulticon').addClass('fa fa-check cf-text-success');
      } else if (result.approved === false) {
        this.element.find(".password_resultpanel").removeClass("password_resultpanel_empty");
        this.element.find('.password_resulticon').addClass('fa fa-times cf-text-error');
      }
      if (typeof result.message === "string" && result.message.length > 0) {
        this.element.find(".password_resultpanel").removeClass("password_resultpanel_empty");
        var tooltipExtraClass = "";
        if (result.approved === true) {
          tooltipExtraClass = " cf-tooltip-success";
        } else if (result.approved === false) {
          tooltipExtraClass = " cf-tooltip-error";
        }
        this.element.find('.password_resulticon').attr("title", $.i18n._(result.message)).tooltip({
          content: function content() {
            var title = $(this).attr("title");

            // Escape title, since we're going from an attribute to raw HTML
            return $("<a>").text(title).html();
          },
          tooltipClass: "cf-tooltip" + tooltipExtraClass,
          classes: {
            "ui-tooltip": "cf-tooltip" + tooltipExtraClass
          },
          position: {
            my: "center top+15px",
            at: "center center",
            collision: "flipfit flip"
          }
        });
      }
      if (typeof result.classes === "string" && result.classes.length > 0) {
        this.element.find('.password_resulticon').addClass(result.classes);
      }
      this._trigger("checked", null, {
        result: result,
        audit: pAudit
      });
      this.validating = false; // the checking is done, release lock
    },

    /**
     * @description inform the outside orld there was an error
     * @function
     * @name nixps-cloudflow.Password#_informError
     * @private
     * @param {type} pError
     * @return {undefined}
     */
    _informError: function _informError(pError) {
      this.element.find(".password_waitIcon").hide();
      this.element.find(".password_input").Input("enable");
      this._trigger("checkedfailed", null, {
        error: pError
      });
      this.validating = false; // the checking is done, release lock
    },

    _checkWorkflowExist: function _checkWorkflowExist() {
      // use caches
      if (typeof workflowExist === "boolean") {
        return workflowExist;
      } else {
        var that = this;
        return $.Deferred(function (pDefer) {
          api_async.hub.get_whitepaper_input_options(that.options.whitepaperName, "change", function (pResults) {
            if ($.isPlainObject(pResults) && !$.isEmptyObject(pResults)) {
              pDefer.resolve(true);
            } else {
              pDefer.resolve(false);
            }
          }, function (pError) {
            if (pError !== undefined && pError.error_code === "WhitePaper not found") {
              pDefer.resolve(false);
            } else if (pError !== undefined && pError.error_code === "Input not found in WhitePaper") {
              pDefer.resolve(true);
            } else {
              console.error(pError);
              // other errors;
              pDefer.resolve(false);
            }
          });
        }).done(function (pResult) {
          if (typeof pResult === "boolean") {
            workflowExist = pResult;
          } else {
            workflowExist = false;
          }
        }).fail(function (pError) {
          console.error(pError);
          workflowExist = false;
        });
      }
    },
    /**
     * @name nixp-cloudflow.Password#getValue
     * @description Get the current value of the input field, controlled or not. You get the value without any caranty
     * @function
     * @return {string} the current value in the password input field
     */
    getValue: function getValue() {
      return this.element.children(".nixps-cloudflow-Input").Input("getValue");
    },
    /**
     * @name nixp-cloudflow.Password#setValue
     * @description set the input value to a specific value
     * @param {string} pValue
     * @return {undefined}
     */
    setValue: function setValue(pValue) {
      if (typeof pValue === "string") {
        this.element.children(".nixps-cloudflow-Input").Input("setValue", pValue);
      } else {
        this.element.children(".nixps-cloudflow-Input").Input("setValue", "");
      }
    },
    reset: function reset() {
      this.element.children(".nixps-cloudflow-Input").Input("setValue", "");
    },
    /**
     * @name nixps-cloudflow.Password#disable
     * @description Disable the component. Put a gray overlay to prevent the input to be edited.
     * @function
     * @return {undefined}
     */
    disable: function disable() {
      this._superApply(arguments);
      this.element.children(".nixps-cloudflow-Input").Input("disable");
    },
    /**
     * @name nixps-cloudflow.Password#enable
     * @description Enable the component, activate the component after calling the {@link nixps-cloudflow.Input#disable} function
     * @function
     * @return {undefined}
     */
    enable: function enable() {
      this._superApply(arguments);
      this.element.children(".nixps-cloudflow-Input").Input("enable");
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.Password#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      var oldValue = this.getValue();
      this._draw();
      this.setValue(oldValue);
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.Password#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.checkStrength !== "boolean") {
        throw new Error("Password: input option checkStrength must be a boolean");
      }
    },
    _destroy: function _destroy() {
      this.dead = true; // set lock to inform the component is a zomby, and should be dead
    },

    clearCaches: function clearCaches() {
      workflowExist = undefined;
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/WhitepaperConnection.js":93}],155:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Jun 21, 2017 4:50:03 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @namespace nixps-cloudflow.RadioInput
   * @description Draw a radio button
   * @example $("<div>").RadioInput({});
   * @version 1.1.0
   */
  $.widget("nixps-cloudflow.RadioInput", $.Widget, {
    widgetEventPrefix: "radioinput",
    version: "1.1.0",
    options: {
      /**
       * @name nixps-cloudflow.RadioInput#relativeBasePath
       * @description The path to be used if the url is relative
       * @type {String}
       * @default ""
       * @since 1.1.0 
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.RadioInput#imgUrl
       * @description The url of an image, you can place above the input field. If you leave this as empty string, no image will be added.
       * This option will be given to the image component, see {@link nixps-cloudflow.Image#url}
       * @type {String}
       * @default ""
       */
      imgUrl: "",
      /**
       * @name nixps-cloudflow.RadioInput#iconClasses
       * @description The classes of an icon, you can place above the input field. If you leave this as empty string, no image will be added.
       * @type {String}
       * @default ""
       */
      iconClasses: "",
      /**
       * @name nixps-cloudflow.RadioInput#imgWidth
       * @description This is the width of the image. 
       * This option will be given to the image component, see {@link nixps-cloudflow.Image#width}
       * @type {number}
       * @default 30
       */
      imgWidth: 30,
      /**
       * @name nixps-cloudflow.RadioInput#imgHeight
       * @description This is the height of the image. 
       * This option will be given to the image component, see {@link nixps-cloudflow.Image#height}
       * @type {Number}
       * @default 30
       */
      imgHeight: 30,
      /**
       * @name nixps-cloudflow.RadioInput#imgMaxWidth
       * @description This is the max width of the image. 
       * This option will be given to the image component, see {@link nixps-cloudflow.Image#maxWidth}
       * @type {Number}
       * @default null
       * @since 1.1.0 
       */
      imgMaxWidth: null,
      /**
       * @name nixps-cloudflow.RadioInput#imgMaxHeight
       * @description This is the max height of the image. 
       * This option will be given to the image component, see {@link nixps-cloudflow.Image#maxHeight}
       * @type {Number}
       * @default null
       * @since 1.1.0 
       */
      imgMaxHeight: null,
      /**
       * @name nixps-cloudflow.RadioInput#name
       * @description The name of the radio input button
       * @type {string}
       * @default ""
       */
      name: "",
      /**
       * @name nixps-cloudflow.RadioInput#text
       * @description Then text of the radio input button to show to the user
       * @type {string}
       * @default ""
       */
      text: "",
      /**
       * @name nixps-cloudflow.RadioInput#value
       * @description The value to be given to the radio input button
       * @type {string}
       * @default ""
       */
      value: "",
      /**
       * @name nixps-cloudflow.RadioInput#parentForm
       * @description Give the form element where the other brothers and sisters radio inputs are situated, to get the value.
       * If not specified the conponent will look itself to the closest "form" element
       * @type {HTMLElement}
       * @default "auto"
       */
      parentForm: "auto",
      /**
       * @name nixps-cloudflow.RadioInput#labelClasses
       * @description The classes to be added to the label
       * @type {String}
       * @default ""
       * @since 1.1.0
       */
      labelClasses: "",
      imgClasses: "",
      tooltip: ""
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.RadioInput#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._addClass(this.widgetFullName);
      this.element.addClass("radio");
      this._draw();
      if (this.options.disabled === true) {
        this.element.find("input").prop("disabled", true);
      }
      this._on(this.element, {
        "click .nixps-cloudflow-Image": this._clickImageHandler,
        "click .radioinput_classes": this._clickImageHandler
      });
    },
    /**
     * @description function runs when user click on the image
     * @function
     * @name nixps-cloudflow.RadioInput#_clickImageHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _clickImageHandler: function _clickImageHandler(pEvent, pData) {
      this.element.find("input[type=radio]").trigger("click");
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.RadioInput#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Sraws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.RadioInput#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      var input = $("<input>").attr({
        "type": "radio",
        "name": this.options.name,
        "value": this.options.value
      }).addClass("cf-form-radio");
      var label = $("<label>").addClass("cf-form-radiolabel").addClass(this.options.labelClasses).append(input).append(this.options.text);
      this.element.append(label);
      if (typeof this.options.imgUrl === "string" && this.options.imgUrl.length > 0) {
        var img = $("<div>").Image({
          url: this.options.imgUrl,
          relativeBasePath: this.options.relativeBasePath,
          width: this.options.imgWidth,
          height: this.options.imgHeight,
          maxWidth: this.options.imgMaxWidth,
          maxHeight: this.options.imgMaxHeight,
          objectFit: "contain",
          "float": "center",
          tooltip: this.options.tooltip
        }).addClass(this.options.imgClasses);
        this.element.prepend(img);
      } else if (typeof this.options.iconClasses === "string" && this.options.iconClasses.length > 0) {
        this.element.prepend($("<span>").addClass("radioinput_classes").addClass(this.options.iconClasses).css({
          width: this.options.imgWidth,
          height: this.options.imgHeight,
          maxWidth: this.options.imgMaxWidth,
          maxHeight: this.options.imgMaxHeight,
          display: "block",
          "margin-left": "auto",
          "margin-right": "auto"
        }));
      }
    },
    /**
     * @name nixps-cloudflow.RadioInput#getValue
     * @description get the selected value of the radio button
     * @function
     * @return {string} The name of the selected input
     */
    getValue: function getValue() {
      var parentForm = $("body");
      if (this.options.parentForm === "auto") {
        parentForm = this.element.closest("form");
      } else if (this.options.parentForm.length === 1) {
        parentForm = this.options.parentForm;
      } else {
        console.warn("no parentForm found!");
      }
      var checkedInput = parentForm.find('input[type="radio"][name="' + this.options.name + '"]:checked');
      if (checkedInput.length === 1) {
        return checkedInput.val();
      } else {
        // no selected items found!!!
        return null;
      }
    },
    /**
     * @name nixps-cloudflow.RadioInput#setValue
     * @description set the component to a specific value
     * @function
     * @param {string} pValue
     * @return {undefined}
     */
    setValue: function setValue(pValue) {
      if (typeof pValue === "string" && pValue.length > 0) {
        // check if value is same as internal value
        this.element.find("input[type=radio]").prop("checked", pValue === this.options.value);
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.RadioInput#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "disabled") {
        this.element.find("input").prop("disabled", pValue);
      } else {
        this._draw();
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.RadioInput#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.name !== "string") {
        throw new Error("input option name must be a string");
      }
      if (typeof this.options.value !== "string" && this.options.value.length > 0) {
        throw new Error("input option value must be a string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass("radio");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],156:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Oct 17, 2017 3:51:00 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @namespace nixps-cloudflow.RadioInputs
   * @description This component is a container for all radio inputs
   * @example $("<div>").RadioInputs({});
   * @version 1.2.0
   */
  $.widget("nixps-cloudflow.RadioInputs", $.Widget, {
    widgetEventPrefix: "radioinputs",
    version: "1.2.0",
    options: {
      /**
       * @name nixps-cloudflow.RadioInput#relativeBasePath
       * @description The path to be used if the url is relative
       * @type {String}
       * @default ""
       * @since 1.1.0 
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.RadioInputs#imgWidth
       * @description This is the width of each of the option images. 
       * This option will be given to the image component, see {@link nixps-cloudflow.Image#width}
       * @type {Number}
       * @default 30
       */
      imgWidth: 30,
      /**
       * @name nixps-cloudflow.RadioInputs#imgHeight
       * @description This is the height of each of the option images. 
       * This option will be given to the image component, see {@link nixps-cloudflow.Image#height}
       * @type {Number}
       * @default 30
       */
      imgHeight: 30,
      /**
       * @name nixps-cloudflow.RadioInputs#imgMaxWidth
       * @description This is the width of each of the option images. 
       * This option will be given to the image component, see {@link nixps-cloudflow.Image#maxWidth}
       * @type {Number}
       * @default null
       * @since 1.1.0
       */
      imgMaxWidth: null,
      /**
       * @name nixps-cloudflow.RadioInputs#imgMaxHeight
       * @description This is the height of each of the option images. 
       * This option will be given to the image component, see {@link nixps-cloudflow.Image#maxHeight}
       * @type {Number}
       * @default null
       * @since 1.1.0
       */
      imgMaxHeight: null,
      /**
       * @name nixps-cloudflow.RadioInputs#name
       * @description The name of the radio input button
       * @type {String}
       * @default ""
       */
      name: "",
      /**
       * @description Define a methode to retrieve dynamically the name for the radio inputs, if null the option name will be used, 
       * Or you can use "label_for", then a slibilings label for attribute will be used
       * @type {String}
       * @name nixps-cloudflow.RadioInputs#dynamicNameMethod
       * @default null
       * @since 1.2.0
       */
      dynamicNameMethod: null,
      /**
       * @name nixps-cloudflow.RadioInputs#labelClasses
       * @description The classes to be added to the label
       * @type {String}
       * @default ""
       * @since 1.1.0
       */
      labelClasses: "",
      /**
       * @name nixps-cloudflow.RadioInputs#imgClasses
       * @description The classes to be added to the radio inputs
       * @type {String}
       * @default ""
       * @since 1.1.0
       */
      imgClasses: "",
      /**
       * @name nixps-cloudflow.RadioInputs#defaultValue
       * @description With radiobutton must we select on default?
       * @type {String}
       * @default ""
       */
      defaultValue: "",
      /**
       * @name nixps-cloudflow.RadioInputs#inputsPosition
       * @description are the inputs inline of vertical blocked
       * @type {String}
       * @default "inline"
       * @example "vertical"
       */
      inputsPosition: "inline",
      /**
       * @name nixps-cloudflow.RadioInputs#radioInputs
       * @description The array containing information about the separated radio inputs
       * @type {Array}
       * @default []
       */
      radioInputs: [],
      /**
       * @description are the fields required?
       * @name nixps-cloudflow.RadioInputs#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.3.0
       */
      required: false
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.RadioInputs#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._addClass(this.widgetFullName);
      this._draw();
      this._on(this.element, {
        "change input[type=radio]": this._changeHandler
      });
    },
    _changeHandler: function _changeHandler(pEvent, pData) {
      this.element.find(".nixps-cloudflow-RadioInput.selected").removeClass("selected");
      $(pEvent.currentTarget).closest(".nixps-cloudflow-RadioInput").addClass("selected");
      this._trigger("change");
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.RadioInputs#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.RadioInputs#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      var name = "";
      if (this.options.dynamicNameMethod === "label_for") {
        var labelDOM = this.element.parent().find("label");
        var forAttr = labelDOM.attr("for");
        var labelText = labelDOM.text().trim();
        if (typeof forAttr === "string" && forAttr.length > 0) {
          name = forAttr;
        } else if (typeof labelText === "string" && labelText.length > 0) {
          name = labelText;
        } else if (typeof this.options.name === "string" && this.options.name.length > 0) {
          name = this.options.name;
        }
      } else if (this.options.dynamicNameMethod === "auto_increment") {
        name = "nixps_radioinput_" + this.uuid;
      } else {
        name = this.options.name;
      }
      if (typeof name !== "string" || name.length <= 0) {
        // fallback
        console.warn("name is missing");
        name = "nixps_fallback_radioinput_" + this.uuid;
      }
      var radioContainerClasses = "cf-form-radio-container";
      if (this.options.inputsPosition === "vertical") {
        radioContainerClasses = "cf-form-radio-container-block";
      }
      for (var i = 0; i < this.options.radioInputs.length; i++) {
        this.element.append($("<div>").addClass(radioContainerClasses).RadioInput({
          relativeBasePath: this.options.relativeBasePath,
          imgUrl: this.options.radioInputs[i].imgUrl,
          iconClasses: this.options.radioInputs[i].iconClasses,
          imgWidth: this.options.imgWidth,
          imgHeight: this.options.imgHeight,
          imgMaxWidth: this.options.imgMaxWidth,
          imgMaxHeight: this.options.imgMaxHeight,
          name: name,
          text: this.options.radioInputs[i].text,
          value: this.options.radioInputs[i].value,
          tooltip: this.options.radioInputs[i].tooltip,
          parentForm: this.element,
          labelClasses: this.options.labelClasses,
          imgClasses: this.options.imgClasses,
          disabled: this.options.disabled
        }));
      }
      this.setValue(this.options.defaultValue);
      this.element.find("input:checked").closest(".nixps-cloudflow-RadioInput").addClass("selected");
    },
    /**
     * @description Get the current value of the radio buttons
     * @function
     * @name nixps-cloudflow.RadioInputs#getValue
     * @return {unresolved}
     */
    getValue: function getValue() {
      if (this.options.radioInputs.length === 0) {
        // if there are no radio buttons ...
        return null;
      } else {
        // if there are radio buttons, one can handle for the group
        return this.element.children().first().RadioInput("getValue");
      }
    },
    /**
     * @description Set the radioInputs to a specific value
     * @function
     * @name nixps-cloudflow.RadioInputs#setValue 
     * @param {type} pValue
     * @return {undefined}
     */
    setValue: function setValue(pValue) {
      if (pValue === null) {
        // if value is null, deactivate all inputs
        this.element.find("input[type=radio]:checked").prop("checked", false);
      } else {
        var radioInput = this.element.find('input[type=radio][value="' + pValue + '"]').first().closest(".nixps-cloudflow-RadioInput");
        radioInput.RadioInput("setValue", pValue);
        this.element.find(".nixps-cloudflow-RadioInput.selected").removeClass("selected");
        radioInput.addClass("selected");

        // others should disable automaticly
      }
    },

    reset: function reset() {
      this.setValue(null);
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.RadioInputs#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (["relativeBasePath", "imgWidth", "imgHeight", "imgMaxWidth", "imgMaxHeight", "name", "labelClasses", "imgClasses", "disabled"].includes(pKey)) {
        this.element.children(".nixps-cloudflow-RadioInput").RadioInput("option", pKey, pValue);
      } else if (pKey === "defaultValue" || pKey === "required") {
        // ignore change durring live session
      } else {
        this._draw();
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.RadioInputs#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.name !== "string" || this.options.name.length <= 0) {
        throw new Error("input option name must be a not empty string");
      }
      if (Array.isArray(this.options.radioInputs) === false) {
        throw new Error("input option radioInputs must be an array");
      }
    }
  });
})(jQuery);

},{}],157:[function(require,module,exports){
"use strict";

(function ($) {
  var hypsRegExp = new RegExp("&amp;shy;", "g");
  var nbspRegExp = new RegExp("&amp;nbsp;", "g");

  /**
   * @namespace nixps-cloudflow.ReadOnlyInput
   * @description Component to show a readonly plain text
   * @example $("<div>").ReadOnlyInput({
   *      "value": "text to show"
   * });
   * @version 1.1.0
   * @private
   */
  $.widget("nixps-cloudflow.ReadOnlyInput", {
    version: "1.1.0",
    options: {
      /**
       * @description The value it represents
       * @name nixps-cloudflow.ReadOnlyInput#value
       * @type {String}
       * @default ""
       */
      value: "",
      /**
       * @description The class names separated by a space character to be added to the text panel
       * @name nixps-cloudflow.ReadOnlyInput#classes
       * @type {String}
       * @default ""
       */
      classes: "",
      /**
       * @description The type of parent node type
       * @type {String}
       * @default "<span>"
       * @since 1.1.0
       */
      parentNodeType: "<span>"
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options of the widget/component
     * @function
     * @private
     * @name nixps-cloudflow.ReadOnlyInput#_controlOptions
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.classes !== "string") {
        throw new Error("ReadOnlyInput: input option classes must be a string");
      }
    },
    /**
     * @desc draws the dialog according to the current state
     * @function
     * @name nixps-cloudflow.ReadOnlyInput#_draw
     * @private
     */
    _draw: function _draw() {
      this.element.empty();
      var parentNodeType;
      switch (this.options.parentNodeType) {
        case "<div>":
          parentNodeType = "<div>";
          break;
        default:
          parentNodeType = "<span>";
      }
      if (typeof this.options.value === "string" || typeof this.options.value === "number") {
        this.element.append($(parentNodeType).addClass("readonlyinput_value").addClass(this.options.classes).text(this.options.value).each(function () {
          $(this).html($(this).html().replace(hypsRegExp, "&shy;").replace(nbspRegExp, "&nbsp;"));
        }));
      } else if (typeof this.options.value === "boolean") {
        this.element.append($("<div>").addClass("readonlyinput_value").addClass(this.options.classes).Input({
          "type": "checkbox",
          "value": this.options.value,
          "readOnly": true,
          "disabled": true
        }));
      } else if ($.isPlainObject(this.options.value)) {
        this.element.append($(parentNodeType).addClass("readonlyinput_value").addClass(this.options.classes).text(JSON.stringify(this.options.value)));
      } else if (Array.isArray(this.options.value)) {
        var text = "";
        for (var i = 0, len = this.options.value.length; i < len; i++) {
          text += this.options.value[i];
          if (i + 1 < len) {
            text += ", ";
          }
        }
        this.element.append($(parentNodeType).addClass("readonlyinput_value").addClass(this.options.classes).text(text));
      } else if (this.options.value === null || this.options.value === undefined) {
        this.element.append($(parentNodeType).addClass("readonlyinput_value").addClass(this.options.classes).text("" + this.options.value));
      }
    },
    /**
     * @description Function returns the value.
     * @function
     * @name nixps-cloudflow.ReadOnlyInput#getValue
     * @returns {string}
     */
    getValue: function getValue() {
      return this.options.value;
    },
    /**
     * @description Set to the readonly value
     * @function
     * @name nixps-cloudflow.ReadOnlyInput#setValue
     * @param {type} pValue
     * @returns {undefined}
     */
    setValue: function setValue(pValue) {
      this.options.value = pValue;
      this._draw();
    },
    /**
     * @brief sets the option
     * @private
     * @function
     * @name nixps-cloudflow.ReadOnlyInput#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    }
  });
})(jQuery);

},{}],158:[function(require,module,exports){
"use strict";

/**
 * A jQuery UI plugin to select "a resource"
 */
(function ($) {
  var mLoaded = {};
  var mLoadedPromises = {};
  function resetResource(pType) {
    if (typeof pType !== "string") {
      throw new Error("invalid resource type");
    }
    if (mLoaded[pType]) {
      delete mLoaded[pType];
    }
  }
  function load(pType) {
    if (typeof pType !== "string") {
      throw new Error("invalid resource type");
    }
    if (mLoaded[pType]) {
      return Promise.resolve(mLoaded[pType]);
    } else if (mLoadedPromises[pType] && typeof mLoadedPromises[pType].then === "function") {
      return Promise.resolve(mLoadedPromises[pType]);
    } else {
      mLoadedPromises[pType] = new Promise(function (pResolve, pReject) {
        api_async.resource.enumerate(pType, function (pResult) {
          if (Array.isArray(pResult.resource_locators)) {
            mLoaded[pType] = pResult.resource_locators;
            pResolve(mLoaded[pType]);
          } else {
            pReject();
          }
        }, pReject);
      });
      return mLoadedPromises[pType];
    }
  }
  ;
  /**
   * @namespace nixps-cloudflow.ResourceSelector
   * @description Show a selecotir of resources
   * @example $("<div>").ResourceSelector({});
   */
  $.widget("nixps-cloudflow.ResourceSelector", $.Widget, {
    widgetEventPrefix: "resourceselector",
    options: {
      /**
       * @brief The resource type to display
                * @name nixps-cloudflow.ResourceSelector#name
                * @type {String}
                * @default null
       */
      name: null,
      /**
       * @description The value of the selector
       * @name nixps-cloudflow.ResourceSelector#value
       * @type {String}
       * @default null
       */
      value: null,
      /**
       * @description The type of resources
       * @name nixps-cloudflow.ResourceSelector#resource_type
       * @type {String}
       * @default null
       */
      resource_type: null,
      /**
       * @desc The text to show when value is empty
       * @name nixps-cloudflow.ResourceSelector#text_when_empty
       * @type {string}
       * @default ""
       */
      text_when_empty: "",
      /**
       * @desc Add or not the entry "No Curve" as a possible choice.
       * @type {Boolean}
       */
      allowNoResource: true,
      /**
       * @description The classes to be added to the select
       * @name nixps-cloudflow.ResourceSelector#selectClasses
       * @type {String}
       * @default ""
       */
      selectClasses: "",
      /**
                * @description are the fields required?
                * @name nixps-cloudflow.ResourceSelector#required
                * @type {Boolean}
                * @default false
                * @example true
                */
      required: false,
      /**
                * @description The ID if the field
                * @name nixps-cloudflow.ResourceSelector#id
                * @type {String}
                * @default undefined
                */
      id: undefined
    },
    /**
     * @desc List of resources.
     * @private
     * @name nixps-cloudflow.ResourceSelector#_resources
     */
    _resources: [],
    /**
     * @desc List of resources to exclude from the list
     * @private
     * @name nixps-cloudflow.ResourceSelector#_excludedResources
     */
    _excludedResources: [],
    _create: function _create() {
      this._super();
      this._addClass(this.widgetFullName);
      if (this.options.resource_type === null) {
        throw new Error("you need to specify a resource type");
      }

      // variables 
      this.alive = true;
      var select = $("<select>").addClass(this.options.selectClasses).prop("disabled", this.options.disabled).prop("required", this.options.required);
      if (typeof this.options.id === "string" && this.options.id.length > 0) {
        select.attr("id", this.options.id);
      }
      if (typeof this.options.name === "string" && this.options.name.length > 0) {
        select.attr("name", this.options.name);
      }
      this.element.append(select);
      var that = this;
      $.when(load(this.options.resource_type)).done(function (pResourceLocators) {
        that._populateSelect(pResourceLocators);
      });
      this._on(this.element, {
        "change select": this._selectionChangedHandler
      });
    },
    _populateSelect: function _populateSelect(pResourceLocators) {
      var that = this;
      this._resources = pResourceLocators || this._resources;
      var selector = this.element.find("select");
      selector.empty();
      if (this.options.allowNoResource) {
        selector.append($("<option>").text(this.options.text_when_empty).val(""));
      }
      if (this._resources !== undefined && this._resources.length > 0) {
        for (var countResources = 0; countResources < this._resources.length; ++countResources) {
          var resourceLocator = this._resources[countResources];
          if (this._excludedResources.length > 0) {
            var excluded = this._excludedResources.find(function (ex) {
              if (ex.name === resourceLocator.name) {
                var exPath = api.file.url_to_ospath(ex.url);
                var rlPath = api.file.url_to_ospath(resourceLocator.url);
                if (exPath.ospath === rlPath.ospath) {
                  return ex;
                }
              }
            });
            if (excluded === undefined) {
              selector.append($("<option>").text(resourceLocator.name).val(resourceLocator.url));
            }
          } else {
            selector.append($("<option>").text(resourceLocator.name).val(resourceLocator.url));
          }
        }
      }
      if (this.options.value !== undefined) {
        var excluded = this._excludedResources.find(function (ex) {
          if (ex.name === that.options.value) {
            return ex;
          }
        });
        if (excluded === undefined) {
          this._setSelection(this.options.value);
        }
      }
    },
    /**
     * @brief handle language selector changes
           * @function
           * @name nixps-cloudflow.ResourceSelector#_selectionChangedHandler
           * @private
     */
    _selectionChangedHandler: function _selectionChangedHandler(event) {
      var newValue = this.element.find("select").val();
      if (this.options.value !== newValue) {
        this.options.value = newValue;
        this._trigger("change", event, {
          value: newValue
        });
      }
    },
    /**
     * @desc Get the text that must be visible for the user
     * @function
     * @name nixps-cloudflow.ResourceSelector#_getTextToShow
     * @private
     * @param {type} pValue - The value that must be analysed 
     * @returns {String}
     */
    _getTextToShow: function _getTextToShow(pValue) {
      if (typeof pValue === "string" && pValue.length > 0) {
        return "(" + pValue + ")";
      } else {
        return this.options.text_when_empty;
      }
    },
    _setSelection: function _setSelection(pValue) {
      var options = this.element.find("select option");
      var foundValue = false;
      for (var countOptions = 0; countOptions < options.length; ++countOptions) {
        if ($(options[countOptions]).attr("value") === pValue) {
          foundValue = true;
        }
      }
      var selector = this.element.find("select");
      if (foundValue === false) {
        if (typeof pValue === "string" && pValue.length > 0) {
          var textShow = this._getTextToShow(pValue);
          selector.append($("<option>").text(textShow).val(pValue));
        } else if (!this.options.allowNoResource && options.length > 0) {
          // Select the first one.
          pValue = $(options[0]).attr("value");
        }
      }
      selector.val(pValue);
    },
    /**
     * @desc Set the list of resources to exclude to the list.
     * For example, it can useful to exclude from this list the resource currently edited.
     * @name nixps-cloudflow.ResourceSelector#excludeResources
     * @function
     */
    excludeResources: function excludeResources(pArg) {
      if (Array.isArray(pArg)) {
        this._excludedResources = pArg;
      } else {
        this._excludedResources = [pArg];
      }
      this._populateSelect();
    },
    getValue: function getValue() {
      return this.options.value;
    },
    setValue: function setValue(pValue) {
      this._setOption("value", pValue);
    },
    /**
     * @desc Returns the metadata of the ICC profile
     * @name nixps-cloudflow.ResourceSelector#getMetadata
     * @param {string} profile
     */
    getMetadata: function getMetadata(profile) {
      var data = undefined;
      if (this._resources !== undefined && this._resources.length > 0) {
        this._resources.some(function (rsrc) {
          if (rsrc.url === profile || rsrc.name === profile) {
            data = rsrc.metadata;
            return true;
          }
        });
      }
      return data;
    },
    getSize: function getSize() {
      return this.element.find("select option").length;
    },
    _setOption: function _setOption(pKey, pValue) {
      this._super(pKey, pValue);
      if (pKey === "value" && pValue !== undefined) {
        this._setSelection(pValue);
      } else if (pKey === "disabled") {
        this.element.find("select").prop("disabled", pValue);
      } else if (pKey === "required") {
        this.element.find("select").prop("required", pValue);
      } else if (pKey === "id") {
        if (typeof pValue === "string" && pValue.length > 0) {
          this.element.find("select").attr("id", pValue);
        } else {
          this.element.find("select").removeAttr("id");
        }
      }
    },
    refreshCache: function refreshCache() {
      var that = this;
      resetResource(this.options.resource_type);
      return $.when(load(this.options.resource_type)).done(function (pResourceLocators) {
        that._populateSelect(pResourceLocators);
      });
    },
    _destroy: function _destroy() {
      this.alive = false;
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],159:[function(require,module,exports){
"use strict";

(function ($) {
  var LicenseFactory = require("../../License/js/License.js");
  var UserPreferences = require("../../Preferences/js/UserPreferences.js");
  var kScreenNames = [{
    value: "CosineDot",
    name: "nixps-RIPEditor-separation.screenselector_CosineDot"
  }, {
    value: "Cross",
    name: "nixps-ripeditor-separation.screenselector_cross"
  }, {
    value: "Diamond",
    name: "nixps-ripeditor-separation.screenselector_diamond"
  }, {
    value: "DiamondPDF",
    name: "nixps-ripeditor-separation.screenselector_diamond_pdf"
  }, {
    value: "Double",
    name: "nixps-ripeditor-separation.screenselector_double"
  }, {
    value: "DoubleDot",
    name: "nixps-ripeditor-separation.screenselector_doubledot"
  }, {
    value: "Ellipse",
    name: "nixps-ripeditor-separation.screenselector_ellipse"
  }, {
    value: "EllipseA",
    name: "nixps-ripeditor-separation.screenselector_ellipsea"
  }, {
    value: "EllipseB",
    name: "nixps-ripeditor-separation.screenselector_ellipseb"
  }, {
    value: "EllipseB2",
    name: "nixps-ripeditor-separation.screenselector_ellipseb2"
  }, {
    value: "Elliptical1",
    name: "nixps-ripeditor-separation.screenselector_elliptical1"
  }, {
    value: "Elliptical2",
    name: "nixps-ripeditor-separation.screenselector_elliptical2"
  }, {
    value: "EllipticalP",
    name: "nixps-ripeditor-separation.screenselector_ellipticalp"
  }, {
    value: "EllipticalQ1",
    name: "nixps-ripeditor-separation.screenselector_ellipticalq1"
  }, {
    value: "EllipticalQ2",
    name: "nixps-ripeditor-separation.screenselector_ellipticalq2"
  }, {
    value: "Euclidean",
    name: "nixps-ripeditor-separation.screenselector_euclidian"
  }, {
    value: "InvertedDouble",
    name: "nixps-ripeditor-separation.screenselector_inverteddouble"
  }, {
    value: "InvertedDoubleDot",
    name: "nixps-ripeditor-separation.screenselector_inverteddoubledot"
  }, {
    value: "InvertedEllipseA",
    name: "nixps-ripeditor-separation.screenselector_invertedellipsea"
  }, {
    value: "InvertedEllipseB",
    name: "nixps-ripeditor-separation.screenselector_invertedellipseb"
  }, {
    value: "InvertedEllipseB2",
    name: "nixps-ripeditor-separation.screenselector_invertedellipseb2"
  }, {
    value: "InvertedSimpleDot",
    name: "nixps-ripeditor-separation.screenselector_invertedround"
  }, {
    value: "LineAdobe",
    name: "nixps-ripeditor-separation.screenselector_line"
  }, {
    value: "Line90",
    name: "nixps-ripeditor-separation.screenselector_line90"
  }, {
    value: "LineX",
    name: "nixps-ripeditor-separation.screenselector_linex"
  }, {
    value: "LineY",
    name: "nixps-RIPEditor-separation.screenselector_Liney"
  }, {
    value: "RhomboidAdobe",
    name: "nixps-ripeditor-separation.screenselector_rhomboid"
  }, {
    value: "Round",
    name: "nixps-ripeditor-separation.screenselector_round"
  }, {
    value: "Square",
    name: "nixps-ripeditor-separation.screenselector_square"
  }, {
    value: "Square1",
    name: "nixps-ripeditor-separation.screenselector_square1"
  }, {
    value: "Square2",
    name: "nixps-ripeditor-separation.screenselector_square2"
  }, {
    value: "HCS",
    name: "nixps-ripeditor-separation.screenselector_hcs"
  }, {
    value: "HDS-A",
    name: "nixps-ripeditor-separation.screenselector_hdssuperfine(fm)"
  }, {
    value: "HDS-B",
    name: "nixps-ripeditor-separation.screenselector_hdsfine(fm)"
  }, {
    value: "HDS-C",
    name: "nixps-ripeditor-separation.screenselector_hdsmedium(fm)"
  }, {
    value: "HDS-D",
    name: "nixps-ripeditor-separation.screenselector_hdscoarse(fm)"
  }, {
    value: "HDS-E",
    name: "nixps-ripeditor-separation.screenselector_hdssupercoarse(fm)"
  }, {
    value: "HDS-2D",
    name: "nixps-ripeditor-separation.screenselector_hdscoarsedbl(fm)"
  }, {
    value: "HDS-2E",
    name: "nixps-ripeditor-separation.screenselector_hdssupercoarsedbl(fm)"
  }, {
    value: "Velvet_Round",
    name: "nixps-ripeditor-separation.screenselector_velvetround"
  }, {
    value: "Velvet_Euclidean",
    name: "nixps-ripeditor-separation.screenselector_velveteuclidean"
  }, {
    value: "HXM",
    name: "nixps-ripeditor-separation.screenselector_hxmflexohybrid"
  }, {
    value: "HXM_Round",
    name: "nixps-ripeditor-separation.screenselector_hxmoffsetround"
  }, {
    value: "HXM_Trad",
    name: "nixps-ripeditor-separation.screenselector_hxmoffsettraditional"
  }];

  /**
   * @namespace nixps.ScreenSelector
   * @example $("<div>").ScreenSelector({});
   * @private
   * @version 1.1.0
   */
  $.widget("nixps.ScreenSelector", {
    version: "1.1.0",
    options: {
      /**
       * @description the name attribute of the select item
       * @name nixps.ScreenSelector#name
       * @type {String}
       * @default "screen"
       */
      name: "screen",
      /**
       * @description the value of the selector on startup, and the value after user change.
       * This is the key of the options
       * @name nixps.ScreenSelector#value
       * @type {String}
       * @default "Round"
       */
      value: "Round",
      /**
       * @description Classes name added to the select
       * @type {String}
       * @name nixps.ScreenSelector#selectClasses
       * @default ""
       * @since 1.1.0
       */
      selectClasses: "",
      /**
       * @description List of screens to excluded from the selector.
       * @name nixps.ScreenSelector#excludedScreens
       * @type {Array<String>}
       * @default ["HCS"]
       */
      excludedScreens: ["HCS"],
      /**
       * @description are the fields required?
       * @name nixps.ScreenSelector#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.1.0
       */
      required: false,
      /**
       * @description function runs when component is done creating
       * @name nixps.ScreenSelector#created
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @brief creates the editor component
     * @private
     * @name nixps.ScreenSelector#_create
     */
    _create: function _create() {
      var _this = this;
      this._addClass(this.widgetFullName, "nixps-cloudflow-ScreenSelector");
      this.element.addClass("asyncInSummary").attr("data-uuid", this.uuid);
      this.element.append($("<select>").attr({
        name: this.options.name
      }).addClass(this.options.selectClasses).prop("disabled", this.options.disabled).prop("required", this.options.required));

      // variables
      this.alive = true;

      // add placeholder
      if (typeof this.options.value === "string") {
        var name = "( " + this.options.value + " )";
        var screen = kScreenNames.find(function (s) {
          return s.value === _this.options.value;
        });
        if (screen) {
          name = $.i18n._(screen.name);
        }
        this.element.find("select").append($("<option>").val(this.options.value).attr("value", this.options.value).text(name));
      }
      this._on(this.element, {
        "change": this._selectionChangedHandler
      });
      var that = this;
      $.when(LicenseFactory.get(), UserPreferences.get()).then(function (pLicense, pUserPreferences) {
        var successorDOM = null;
        if (that.alive === false) {
          // kill zombies
          successorDOM = $("[data-clone-uuid='" + that.uuid + "']");
          if (successorDOM.length === 0) {
            that.options.created();
            return;
          } else {
            // it is dead, but there is a successor, that needs that value
          }
        }
        var screenNames = [];
        var customScreens = pUserPreferences.getPrerelease("customized_screens");
        if (Array.isArray(customScreens) && customScreens.length > 0) {
          for (var i = 0; i < customScreens.length; i++) {
            if (customScreens[i].value !== undefined && customScreens[i].name !== undefined) {
              screenNames.push(customScreens[i]);
            }
          }
        } else {
          screenNames = kScreenNames;
        }
        var excludedScreens = [];
        if (Array.isArray(that.options.excludedScreens)) {
          excludedScreens = that.options.excludedScreens; // Trac #40990
        }

        if (pLicense.check("hxm_screening") === false) {
          excludedScreens = excludedScreens.concat(["HXM", "HXM_Round", "HXM_Trad"]);
        }
        if (pLicense.check("velvet_screening") === false) {
          excludedScreens = excludedScreens.concat(["Velvet_Round", "Velvet_Euclidean"]);
        }
        // from back to front because we remove items
        for (var i = screenNames.length - 1; i >= 0; i--) {
          if (excludedScreens.includes(screenNames[i].value)) {
            screenNames.splice(i, 1);
          }
        }
        that._initUI(that.element.children("select").empty(), screenNames);
        if (Array.isArray(that.options.excludedScreens) && that.options.excludedScreens.includes(that.options.value)) {
          that.element.find("select").val("Round"); // Fallback to "Round" for excluded screens
        }

        if (successorDOM !== null && successorDOM.length === 1) {
          // copy value from dead component to successor
          successorDOM.text(that.element.find("select").find(":selected").text());
        }
        that.options.created();
      }, function (pError) {
        console.error(pError);
        that.options.created();
      });
    },
    /**
     * @brief Add options to the selector
     * @param selector
     * @private
     * @name nixps.ScreenSelector#_initUI
     */
    _initUI: function _initUI(selector, pScreenNames) {
      for (var i = 0; i < pScreenNames.length; i++) {
        selector.append($("<option>").attr("value", pScreenNames[i].value).text($.i18n._(pScreenNames[i].name)));
      }
      this._draw();
    },
    /**
     * @brief draw the selector
     * @private
     * @name nixps.ScreenSelector#_draw
     */
    _draw: function _draw() {
      this.element.find("select").val(this.options.value);
    },
    /**
     * @brief handle screen selector changes
     * @private
     * @name nixps.ScreenSelector#_selectionChangedHandler
     */
    _selectionChangedHandler: function _selectionChangedHandler(pEvent) {
      var newValue = this.element.find("select").val();
      if (this.options.value !== newValue) {
        this.options.value = newValue;
        this._trigger("change", pEvent, {
          value: newValue
        });
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "value" && pValue == "Euclidian") {
        pValue = "Euclidean";
      }
      if (Array.isArray(this.options.excludedScreens) && this.options.excludedScreens.indexOf(pValue) !== -1) {
        pValue = "Round"; // Fallback to "Round" for excluded screens
      }

      if (pKey === "selectClasses") {
        this.element.find("select").removeClass(this.options.selectClasses).addClass(pValue);
      }
      this._super(pKey, pValue);
      if (pKey === "value") {
        this._draw();
      }
      if (pKey === "disabled") {
        this.element.find("select").prop("disabled", pValue);
      }
      if (pKey === "name") {
        this.element.find("select").attr("name", pValue);
      }
      if (pKey === "required") {
        this.element.find("select").prop("required", pValue === true);
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      // class "asyncInSummary" needs to live after dead
      this._superApply(arguments);
    },
    clearCaches: function clearCaches() {
      LicenseFactory.clear();
      UserPreferences.clearCaches();
    }
  });
})(jQuery);

},{"../../License/js/License.js":175,"../../Preferences/js/UserPreferences.js":202}],160:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  if ($.fn.selectmenu !== undefined) {
    $.widget("nixps-cloudflow.selectmenucustom", $.ui.selectmenu, {
      widgetEventPrefix: "selectmenucustom",
      options: {
        icons: {
          button: "cf-icon cf-icon-chevron-down"
        }
      },
      _drawButton: function _drawButton() {
        this._superApply(arguments);
        this.button.addClass("cf-form-control");
      },
      _renderItem: function _renderItem(ul, item) {
        var li = $("<li>"),
          wrapper = $("<div>", {
            title: item.element.attr("title")
          });
        if (item.disabled) {
          this._addClass(li, null, "ui-state-disabled");
        }
        this._setText(wrapper, item.label);
        return li.append(wrapper).appendTo(ul);
      },
      _setText: function _setText(element, value) {
        if (value) {
          element.html(value);
        } else {
          element.html("&#160;");
        }
      }
    });
  }

  /**
      * @namespace nixps-cloudflow.Select
      * @description Show a panel with a select element. Users can select one item from the list. It uses the \<select\> tag.
      * The adavtage of this component is, that is can be used in FormRenderer and it can show unkown items with brackets, like  "&nbsp;(&nbsp;unknown&nbsp;)&nbsp;".
      * It also supports asycn data provider.
      * @version 1.7.0
      * @example $("<div>").Select({keyValues: ["a", "b", "c"], default: "b"});
      * 
      * @README:
      *  this component is subject of backwards compability translation! 
      *      Do not remove or change inputoptions, without permission!
      *      
      *      
      *      
      */
  $.widget("nixps-cloudflow.Select", $.Widget, {
    version: "1.7.0",
    widgetEventPrefix: "select",
    options: {
      /**
       * @description The input to add key values for the possible values where the user can select from.
       * This can be an array or an object or a function returning one of those
       * @name nixps-cloudflow.Select#keyValues
       * @default null
       */
      keyValues: null,
      /**
       * @description Which value must we show on start, put here the key that must be selected on start.
       * @name nixps-cloudflow.Select#default
       * @type {Object}
       * @default null
       */
      "default": null,
      /**
       * @description The Interface format of the selected value, you wich to have. can be string/integer/number/boolean
       * @name nixps-cloudflow.Select#outputFormat
       * @type {String}
       * @default "string"
       */
      outputFormat: "string",
      /**
       * @description The class to be added to the selctor itself. To add multiple classes, separete the names with a space.
       * @name nixps-cloudflow.Select#classes
       * @type {String}
       * @default ""
       * @since 1.0.1
       */
      classes: "",
      /**
       * @description Must we interpret the options as html, to show customised selector
       * @name nixps-cloudflow.Select#customisedOptions
       * @type {Boolean}
       * @default false
       * @since 1.4.0
       */
      customisedOptions: false,
      /**
       * @description Must we show values that are used in the setValue methode, but who are not listed?
       * in that case it will be surrounded by brackets like "&nbsp;( unknown ) "
       * @name nixps-cloudflow.Select#showUnknownValue
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.1.0
       */
      showUnknownValue: false,
      /**
       * @name nixps-cloudflow.Select#readOnlyInPlainText
       * @description Put the selector in readonly modus with a ui that seems like a plain text. Set this to true and the value seems like a normal text
       * @type {Boolean}
       * @default false
       * @since 1.1.3
       */
      readOnlyInPlainText: false,
      /**
       * @name nixps-cloudflow.Select#emptyText
       * @description Text to show when there are no options to show
       * @type {String}
       * @default ""
       * @since 1.2.0
       */
      emptyText: "",
      /**
       * @name nixps-cloudflow.Select#ariaLabel
       * @description Give a help text for accessibility readers
       * @type {String}
       * @default undefined
       * @since 1.7.0
       */
      ariaLabel: undefined,
      /**
       * @name nixps-cloudflow.Select#required
       * @description Is the select a required field or not?
       * @type {Boolean}
       * @default false
       * @since 1.7.0
       */
      required: false,
      /**
       * @name nixps-cloudflow.Select#id
       * @description The id attribute, to be used for linking the label tag
       * @type {String}
       * @default undefined
       * @since 1.6.0
       */
      id: undefined,
      /**
       * @name nixps-cloudflow.Select#testid
       * @description the test id to be given to the select DOM
       * @type {String}
       * @default undefined
       * @since 1.5.0
       */
      testid: undefined
    },
    _create: function _create() {
      if (this.options.customisedOptions === true && $.fn.selectmenucustom === undefined) {
        console.error("jquery ui selectmenu is missing, a recent jQuery UI 1.12.1 is needed. We fallback to normal select");
      }
      this.element.addClass(this.widgetFullName);
      // normal case
      var select = $("<select>").addClass("mainSelect").addClass(this.options.classes).attr("nixps-quantum-util-autobind", "false").attr("aria-required", this.options.required === true ? "true" : "false");
      this.element.append(select);
      if (typeof this.options.id === "string") {
        select.attr("id", this.options.id);
      }
      if (typeof this.options.testid === "string") {
        select.attr("data-testid", this.options.testid);
      }
      if (typeof this.options.ariaLabel === "string") {
        select.attr("aria-label", this.options.ariaLabel);
      }
      // custom case
      var selectCustom = $("<div>").addClass("mainSelect").addClass(this.options.classes);
      this.element.append(selectCustom);
      this.tempSetValue = undefined;
      this.inputValueDeferred; // if input value is deferred object, some functions can come before the function is done

      this._draw();
      this._on(this.element, {
        "selectmenucustomchange": this._changeHandler
      });
    },
    /**
     * @description function runs when user choose something in custom
     * @name nixps-cloudflow.Select#_changeHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _changeHandler: function _changeHandler(pEvent, pData) {
      this.element.trigger("change");
    },
    /**
     * @description Redraw the select
     * @function
     * @name nixps-cloudflow.Select#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief draws the dialog according to the current state
     * @private
     * @function
     * @name nixps-cloudflow.Select#_draw
     */
    _draw: function _draw() {
      this._drawNormal();
      if (this.options.customisedOptions === true) {
        if ($.fn.selectmenucustom !== undefined) {
          this.element.children("select.mainSelect").selectmenucustom({
            appendTo: this.element
          });
        } else {
          // fallback to normal slect, user want customised, but there is no engine
          // remove all html and display only the text
          this.element.children("select.mainSelect").children("option").each(function () {
            $(this).text($("<div>").append($(this).text()).text());
          });
        }
      }
    },
    _drawNormal: function _drawNormal() {
      this.element.children("div.mainSelect").hide();
      var select = this.element.children("select.mainSelect").empty().css("display", "");
      // if source is function, call this function than
      if (typeof this.options.keyValues === "function" || this.options.keyValues && typeof this.options.keyValues.then === "function") {
        var that = this;
        if (typeof this.options.keyValues === "function") {
          this.inputValueDeferred = $.when(this.options.keyValues());
        } else if (typeof this.options.keyValues.then === "function") {
          this.inputValueDeferred = $.when(this.options.keyValues); // use thenables
        }

        this.inputValueDeferred.done(function (pResults) {
          if ($.isPlainObject(pResults)) {
            that._drawAsPlainObject(select, pResults);
            select.val(that.options["default"]);
            that._checkAndInsertValue(that.options["default"]);
            // if nothing is selected, select first element
            if (select.find("option:selected").length === 0) {
              select.val(select.find("option").first().val());
            }
          } else if (Array.isArray(pResults)) {
            that._drawAsArray(select, pResults);
            select.val(that.options["default"]);
            that._checkAndInsertValue(that.options["default"]);
            // if nothing is selected, select first element
            if (select.find("option:selected").length === 0) {
              select.val(select.find("option").first().val());
            }
          } else {
            throw new Error("invalid inputvalues select");
          }
          if (typeof that.options.emptyText === "string" && that.options.emptyText.length > 0 && select.children().length === 0) {
            that.element.append($("<span>").addClass("select_emptytext noselect").text(that.options.emptyText));
          } else {
            that.element.children(".select_emptytext").remove();
          }
        });
      } else if ($.isPlainObject(this.options.keyValues)) {
        // if source is a object, get all the key values
        this._drawAsPlainObject(select, this.options.keyValues);
      } else if (Array.isArray(this.options.keyValues)) {
        // if source is array, ...
        this._drawAsArray(select, this.options.keyValues);
      } else if (typeof this.options.keyValues === "string" && this.options.keyValues.length > 2 && this.options.keyValues[0] === this.options.keyValues[this.options.keyValues.length - 1]) {
        var options = this.options.keyValues.split(this.options.keyValues[0]);
        var notEmptyOptions = options.filter(function (pValue) {
          return pValue.length > 0;
        });
        for (var i = 0; i < notEmptyOptions.length; i++) {
          select.append($("<option>").text(notEmptyOptions[i]).val(notEmptyOptions[i]).data("value", notEmptyOptions[i]));
        }
      } else {
        // help!! What is the sources??? 
        // We could not recognise the source,
        throw new Error("invalid inputvalues select");
      }
      if (this.options["default"] !== undefined && this.options["default"] !== null) {
        select.val(this.options["default"].toString());
        this._checkAndInsertValue(this.options["default"]);
      }
      // if nothing is selected, select first element
      if (select.find("option:selected").length === 0) {
        select.val(select.find("option").first().val());
      }
      // enable disable
      if (this.options.disabled === true) {
        select.prop("disabled", true);
      }
      // set in readonly and plaintext mode
      if (this.options.readOnlyInPlainText === true) {
        select.attr("readonly", "readonly").addClass("select_plaintext");
      }
      if (typeof this.options.emptyText === "string" && this.options.emptyText.length > 0 && select.children().length === 0) {
        this.element.append($("<span>").addClass("select_emptytext noselect").text(this.options.emptyText));
      } else {
        this.element.children(".select_emptytext").remove();
      }
    },
    /**
     * @description Draw the select with array as input
     * @function
     * @private
     * @name nixps-cloudflow.Select#_drawAsArray
     * @param {DOMElement} pSelectDOM The select jQuery DOM element to append to
     * @param {Array} pArray The array to display
     */
    _drawAsArray: function _drawAsArray(pSelectDOM, pArray) {
      if (Array.isArray(pArray) && pArray.length > 0) {
        for (var i = 0; i < pArray.length; i++) {
          if (pArray[i] && pArray[i].key !== undefined) {
            pSelectDOM.append($("<option>").text(pArray[i].value || pArray[i].label).val(pArray[i].key).data("value", pArray[i].key).prop("disabled", pArray[i].disabled === true));
          } else if (_typeof(pArray[i]) !== "object") {
            // allow item containing only parameter "separator"
            pSelectDOM.append($("<option>").text(pArray[i]).val(pArray[i]).data("value", pArray[i]));
          }
          if (pArray[i] && pArray[i].separator === true) {
            pSelectDOM.append($("<hr>"));
          }
        }
      }
    },
    /**
     * @description Draw the select with a plain object as input
     * @function
     * @private
     * @name nixps-cloudflow.Select#_drawAsPlainObject
     * @param {DOMElement} pSelectDOM The select jQuery DOM element to append to    
     * @param {Object} pObject The plain object to display
     */
    _drawAsPlainObject: function _drawAsPlainObject(pSelectDOM, pObject) {
      $.each(pObject, function (key, value) {
        if ($.isPlainObject(value)) {
          var optgroup = $("<optgroup>").attr("label", key);
          pSelectDOM.append(optgroup);
          $.each(value, function (subKey, subValue) {
            optgroup.append($("<option>").text(subValue).val(subKey).data("value", subKey));
          });
        } else {
          pSelectDOM.append($("<option>").text(value).val(key).data("value", key));
        }
      });
    },
    /**
     * @description Get the value of the select item.
     * @name nixps-cloudflow.Select#getValue
     * @function
     * @returns {String} The key of the selected item.
     */
    getValue: function getValue() {
      var returnValue;
      if (this.element.find("select option:selected").length > 0) {
        // value of selected item
        returnValue = this.element.find("select option:selected").data("value");
      } else if (this.element.find("select option").length > 0) {
        // no selection, get first item
        returnValue = this.element.find("select option").eq(0).data("value");
      } else if (typeof this.options.keyValues === "function") {
        // system is still being loading values
        // give in this situation de default value
        if (this.tempSetValue !== undefined) {
          // if setValue is called before, use that value in the main while
          return this.tempSetValue;
        }
        return this.options["default"];
      } else if (this.element.find("select option").length === 0) {
        // there are no options the select is empty 
        // return empty 
        return null;
      } else {
        throw new Error("getValue Select, could not get value of select");
      }
      switch (this.options.outputFormat) {
        case "number":
        case "decimal":
        case "double":
          return parseFloat(returnValue);
        case "integer":
          return parseInt(returnValue);
        case "boolean":
          if (returnValue === undefined || returnValue === null) {
            return false;
          }
          return returnValue.toString() === "true";
        default:
          // default for string, text , ...
          return returnValue;
      }
    },
    /**
     * @description Set the value of the select item.
     * @name nixps-cloudflow.Select#setValue
     * @function
     * @return {undefined}
     */
    setValue: function setValue(pValue) {
      /** @todo for customising **/
      if (typeof this.options.keyValues === "function") {
        var that = this;
        this.tempSetValue = pValue;
        this.inputValueDeferred.done(function () {
          that.tempSetValue = undefined;
          if (that.element.find("select option").length === 0 && pValue === null) {
            // there are no options and value is null, so do nothing, the get value will return the correct value null if select is empty
          } else if (pValue === null && that.options["default"] === null) {
            // if value is set on null and default is null 
            // do nothing the selector will be set on the first one
          } else {
            if (pValue === undefined || pValue === null) {
              pValue = "";
            }
            that.element.find("select").val(pValue.toString());
            that._checkAndInsertValue(pValue);
            if (typeof pValue !== "string" && $.isPlainObject(that.options.keyValues)) {
              // overwrite string to accoring type
              that.element.find("select option:selected").data("value", pValue);
            }
            if (typeof that.options.emptyText === "string" && that.options.emptyText.length > 0 && that.element.find("select").children().length === 0) {
              that.element.append($("<span>").addClass("select_emptytext noselect").text(that.options.emptyText));
            } else {
              that.element.children(".select_emptytext").remove();
            }
            if (that.options.customisedOptions === true && $.fn.selectmenucustom !== undefined) {
              that.element.children("select.mainSelect").selectmenucustom("refresh");
            }
          }
        });
      } else if (pValue === null && this.element.find("select option").length === 0) {
        // there are no options and value is null, so do nothing, the get value will return the correct value null if select is empty
      } else if (pValue === null && this.options["default"] === null) {
        // if value is set on null and default is null 
        // do nothing the selector will be set on the first one
      } else {
        if (pValue === undefined || pValue === null) {
          pValue = "";
        }
        this.element.find("select").val(pValue.toString());
        this._checkAndInsertValue(pValue);
        if (typeof pValue !== "string" && $.isPlainObject(this.options.keyValues)) {
          // overwrite string to according type
          this.element.find("select option:selected").data("value", pValue);
        }
        if (typeof this.options.emptyText === "string" && this.options.emptyText.length > 0 && this.element.find("select").children().length === 0) {
          this.element.append($("<span>").addClass("select_emptytext noselect").text(this.options.emptyText));
        } else {
          this.element.children(".select_emptytext").remove();
        }
        if (this.options.customisedOptions === true && $.fn.selectmenucustom !== undefined) {
          this.element.children("select.mainSelect").selectmenucustom("refresh");
        }
      }
    },
    /**
     * @description If asked add unknown values to the selector
     * @name nixps-cloudflow.Select#_checkAndInsertValue
     * @function
     * @private
     * @param {String} pWantedValue
     * @return {undefined}
     */
    _checkAndInsertValue: function _checkAndInsertValue(pWantedValue) {
      if (this.options.showUnknownValue === true && pWantedValue !== undefined && pWantedValue !== null && pWantedValue !== "") {
        if (this.element.find("select").val() != pWantedValue) {
          this.element.find("select").append($("<option>").text("(" + pWantedValue + ")").attr("data-unknownadded", "true").val(pWantedValue).data("value", pWantedValue));
          this.element.find("select").val(pWantedValue.toString());
        }
      }
    },
    /**
     * @description Reset the selected option. The possible options will not we updated, 
     * only the selected option will be deselected and the first option in the list will be "selected"
     * @name nixps-cloudflow.Select#reset
     * @function
     * @param {Boolean} pSetToDefault Must we reset the select to the option default?
     * @return {undefined}
     * @since 1.3.0
     */
    reset: function reset(pSetToDefault) {
      this.tempSetValue = undefined;
      // deselect all values
      this.element.find("select option").prop("selected", false);
      if (pSetToDefault === true) {
        this.element.find("select").val(this.options["default"]);
        this._checkAndInsertValue(this.options["default"]);
        if (this.options.customisedOptions === true && $.fn.selectmenucustom !== undefined) {
          this.element.children("select.mainSelect").selectmenucustom("refresh");
        }
      }
    },
    /**
     * @name nixps-cloudflow.Select#_setOptions
     * @description sets the option
     * @function
     * @private
     */
    _setOptions: function _setOptions(options) {
      var oldValue;
      if (options.keyValues !== undefined || options.customisedOptions !== undefined) {
        oldValue = this.getValue();
      }
      this._superApply(arguments);
      if (options.keyValues !== undefined || options.customisedOptions !== undefined) {
        this._draw();
        if (oldValue !== null) {
          this.setValue(oldValue);
        }
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "disabled") {
        this._superApply(arguments);
        this.element.find("select").prop("disabled", pValue);
      } else if (pKey === "classes") {
        if (pValue !== this.options.classes) {
          this.element.find(".mainSelect").removeClass(this.options.classes).addClass(pValue);
        }
        this._superApply(arguments);
      } else if (pKey === "showUnknownValue") {
        if (pValue !== this.options.showUnknownValue) {
          this._superApply(arguments);
          var oldValue = this.getValue();
          if (oldValue !== null) {
            this.setValue(oldValue);
          }
        } else {
          this._superApply(arguments);
        }
      } else if (pKey === "readOnlyInPlainText") {
        if (pValue !== this.options.readOnlyInPlainText) {
          this._superApply(arguments);
          // set in readonly and plaintext mode
          if (this.options.readOnlyInPlainText === true) {
            this.element.children("select.mainSelect").attr("readonly", "readonly").addClass("select_plaintext");
          } else {
            this.element.children("select.mainSelect").removeAttr("readonly").removeClass("select_plaintext");
          }
        }
      } else if (pKey === "emptyText") {
        this._superApply(arguments);
        if (typeof pValue === "string" && pValue.length > 0) {
          if (this.element.find("select").children().length === 0) {
            if (this.element.children(".select_emptytext").length === 0) {
              this.element.append($("<span>").addClass("select_emptytext noselect"));
            }
            this.element.children(".select_emptytext").text(pValue);
          }
        } else {
          this.element.children(".select_emptytext").remove();
        }
      } else if (pKey === "required") {
        this._superApply(arguments);
        this.element.find("select").attr("aria-required", pValue === true ? "true" : "false");
      } else if (pKey === "ariaLabel") {
        this._superApply(arguments);
        if (typeof pValue === "string") {
          this.element.find("select").attr("aria-label", pValue);
        } else {
          this.element.find("select").removeAttr("aria-label");
        }
      } else {
        this._superApply(arguments);
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this._superApply();
    }
  });
})(jQuery);

},{}],161:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @namespace nixps-cloudflow.ShowHideCheckBox
   * @description Show a checkbox, if toggled on the checkbox, you can show and hide the content.
   * @deprecated Is not supported anymore. In the future we will add a more general action handler on the form level.
   * @version 1.0
   * @private
   */
  $.widget("nixps-cloudflow.ShowHideCheckBox", $.Widget, {
    options: {
      /**
       * @description the text to show as label after the checkbox
       * @name nixps-cloudflow.showHideCheckBox#checkBoxLabel
       * @type string
       * @default ""
       */
      checkBoxLabel: "",
      /**
       * @description must we enable the checkbox on start up?
       * @name nixps-cloudflow.showHideCheckBox#enabledOnStartup
       * @type boolean
       * @default false
       */
      enabledOnStartup: false,
      /**
       * @description what must be use as container, what must be hide/ show
       * @name nixps-cloudflow.showHideCheckBox#container
       * @type HTML
       * @default empty_span
       * @example  $('<span>').
       */
      container: $('<span>'),
      /**
       * @description the options you can give in the jquery toggle function.
       * see jquery toggle function documentation
       * @type obejct
       * @default empty object
       */
      toggleOptions: undefined
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._draw();
      this._on(this.element, {
        "click input.showHideCheckBox": this._changeCheckBoxHandler
      });
    },
    /**
     * @description function runs when user press the container button
     * @private
     * @name nixps-cloudflow.ShowHideCheckBox#_changeCheckBoxHandler
     * @param {object} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _changeCheckBoxHandler: function _changeCheckBoxHandler(pEvent, pData) {
      this.element.find(".containerToToggle").toggle(this.options.toggleOptions);
    },
    /**
     * @description returns the value
     * @function
     * @name nixps-cloudflow.ShowHideCheckBox#getValue
     * @returns {object} 
     */
    getValue: function getValue() {
      var checked = this.element.find('input.showHideCheckBox').is(":checked");
      if (checked === false) {
        return false;
      } else {
        if (this.element.find(".nixps-cloudflow-FormRenderer").length > 0) {
          return this.element.find(".nixps-cloudflow-FormRenderer").FormRenderer('getValues');
        }
        return true;
      }
    },
    /**
     * @description sets the value, 
     * @function
     * @name nixps-cloudflow.ShowHideCheckBox#setValue
     * @param {object} pValueObject, if boolean, only the checkbox will changed, if it is a object, the hole object will be passed down.
     * @returns {undefined}
     */
    setValue: function setValue(pValueObject) {
      if (typeof pValueObject === "boolean") {
        this.element.find('input.showHideCheckBox').prop("checked", pValueObject);
      } else if (!$.isEmptyObject(pValueObject)) {
        this.element.find('input.showHideCheckBox').prop("checked", true);
        this.element.find(".nixps-cloudflow-FormRenderer").FormRenderer('setValues', pValueObject);
      }
    },
    /**
     * @description controls if the inputvalue is valid
     * @function
     * @name nixps-cloudflow.ShowHideCkeckBox#isValid
     * @returns {Boolean_string} true if value is valid, the error_message if input is invalid
     */
    isValid: function isValid() {
      if (this.element.find('input.showHideCheckBox').is(":checked") === true && this.element.find('.containerToToggle > .nixps-cloudflow-FormRenderer').length > 0) {
        return this.element.find('.containerToToggle > .nixps-cloudflow-FormRenderer').FormRenderer('isValid', true);
      } else {
        return true;
      }
    },
    reset: function reset() {
      this.element.find('input.showHideCheckBox').prop("checked", false);
      return this.element.find(".nixps-cloudflow-FormRenderer").FormRenderer('reset');
    },
    /**
     * @brief redraw
     * @private
     * @name nixps.cloudflow.ShowHideCheckBox#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief draws the dialog according to the current state
     * @private
     * @name nixps.cloudflow.ShowHideCheckBox#_draw
     */
    _draw: function _draw() {
      this._controlOptions();
      this.element.empty();
      // add checkbox
      var checkbox = $("<input>").attr("type", "checkbox").addClass("showHideCheckBox").prop("checked", this.options.enabledOnStartup);
      this.element.append(checkbox);
      // add label
      var textLabel = $("<label>").addClass("checkboxLabel").text(this.options.checkBoxLabel).css({
        "margin-left": 10,
        "width": '90%'
      });
      this.element.append(textLabel);

      // add container
      var containerToToggle;
      if ($.isPlainObject(this.options.container)) {
        containerToToggle = $("<div>").addClass("containerToToggle").append($('<div>').FormRenderer({
          isInline: true,
          formJSON: this.options.container
        })).toggle(this.options.enabledOnStartup);
      } else {
        containerToToggle = $("<div>").addClass("containerToToggle").append(this.options.container).toggle(this.options.enabledOnStartup);
      }
      this.element.append(containerToToggle);
    },
    /**
     * @description control if the options has a good interface, format
     * @name nixps.cloudflow.ShowHideCheckBox#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.checkBoxLabel !== "string") {
        throw new Error("option checkBoxLabel must be a string");
      }
      if (typeof this.options.enabledOnStartup !== "boolean") {
        throw new Error("option enabledOnStartup must be a boolean");
      }
      if (!(this.options.toggleOptions === undefined || $.isPlainObject(this.options.toggleOptions))) {
        throw new Error("option toggleOptions must be undefined or a object");
      }
    },
    /**
     * @brief sets the option
     * @private
     * @name nixps-cloudflow.ProjectTemplatePanel#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._draw();
    }
  });
})(jQuery);

},{}],162:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @description the dict containing all the ids
   * @type {Object}
   * @static
   */
  var titleIDsDict = {};

  /**
   * @namespace nixps-cloudflow.Title
   * @description Show a title. It uses the html tags 'h1' up to 'h6'. It is used for forms.
   * @private 
   * @example $("<div>").Title({
   *   "text": "hallo new World",
   *   "level": 2
   * })
   */
  $.widget("nixps-cloudflow.Title", $.Widget, {
    widgetEventPrefix: "title",
    options: {
      /**
       * @name nixps-cloudflow.Title#text
       * @description The text to put in the title. The text to show.
       * @type {String}
       * @default ""
       */
      text: "",
      /**
       * @name nixps-cloudflow.Title#tooltip
       * @description The tooltip of the title.
       * @type {String}
       * @default ""
       */
      tooltip: "",
      /**
       * @name nixps-cloudflow.Title#tooltipClasses
       * @description The classes given to the tooltip
       * @type {String}
       * @default ""
       */
      tooltipClasses: "cf-tooltip cf-tooltip-secondary",
      /**
       * @name nixps-cloudflow.Title#level
       * @description The level of the title. Is it a subtitle or a subtitle.
       * the higher the level the lower importance the title has. This level must be between 0 and 6.
       * @type {Number}
       * @default 1
       */
      level: 1,
      /**
       * @description The id of the Title 
       * @name nixps-cloudflow.Title#id
       * @type {String}
       * @default null
       */
      id: null,
      /**
       * @description Must we auto generate the id
       * @name nixps-cloudflow.Title#autoGenerateID
       * @type {Boolean}
       * @default true
       */
      autoGenerateID: true,
      /**
       * @description The prefix of the auto generated id
       * @name nixps-cloudflow.Title#autoGeneratePrefixID
       * @type {String}
       * @default "title_"
       */
      autoGeneratePrefixID: "title_",
      /**
       * @name nixps-cloudflow.Title#float
       * @description How must we position the text. Must we center the text or place at the left side.
       * This string will be used as value for the css text-align value
       * @type {String}
       * @default null
       */
      "float": null,
      /**
       * @name nixps-cloudflow.Title#classes
       * @description The class names separated by space to be added to the title
       * @type {String}
       * @default ""
       */
      classes: "",
      /**
       * @name nixps-cloudflow.Title#pagebuilderStyleClass
       * @description Which style class do you want to apply on the component
       * @type {String}
       * @default ""
       * @private
       */
      pagebuilderStyleClass: "",
      /**
       * @name nixps-cloudflow.Title#paddingStyle
       * @description what kind of padding do you want?
       * @type {String}
       * @default undefined
       */
      paddingStyle: undefined,
      /**
       * @name nixps-cloudflow.Title#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    _create: function _create() {
      if (["string", "number", "boolean", "bigint"].includes(_typeof(this.options.text)) === false) {
        throw new Error("inputoption text must be a string");
      }
      if (typeof this.options.level !== "number") {
        throw new Error("inputoption level must be a number");
      }
      if (typeof this.options["float"] !== "string" && this.options["float"] !== null) {
        throw new Error("inputoption float must be a string");
      }
      if (typeof this.options.classes !== "string") {
        throw new Error("inputoption classes must be a string");
      }
      if (typeof this.options.pagebuilderStyleClass !== "string") {
        throw new Error("inputoption pagebuilderStyleClass must be a string");
      }
      if (typeof this.options.autoGeneratePrefixID !== "string") {
        throw new Error("inputoption autoGeneratePrefixID must be a string");
      }
      this.element.addClass(this.widgetFullName);
      // variables
      this.hashID = null;
      this._draw();
      this.options.created();
    },
    /**
     * @desc redraw
     * @function
     * @name nixps-cloudflow.Title#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief draws the dialog according to the current state
     * @private
     * @function
     * @name nixps-cloudflow.Title#_draw
     */
    _draw: function _draw() {
      this.element.empty();
      var realLevel = this.options.level;
      if (this.options.level <= 0) {
        realLevel = 1;
      } else if (this.options.level > 6) {
        realLevel = 6;
      }
      var that = this;
      var classes = this.options.classes;
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        classes += " nixps_styling_class_" + this.options.pagebuilderStyleClass;
      }
      classes += " pagebuilder-event-container cf-title-h" + realLevel;
      if (typeof this.options.paddingStyle === "string" && this.options.paddingStyle.length > 0) {
        if (this.options.paddingStyle === "basic") {
          classes += " cf-tabsection";
        } else {
          classes += " cf-tabsection-" + this.options.paddingStyle;
        }
      }
      var textToDisplay = this.options.text;
      if (textToDisplay === undefined) {
        textToDisplay = "";
      } else if (typeof textToDisplay === "bigint" || typeof textToDisplay === "number" && isFinite(textToDisplay) === false) {
        // edge cases who are converted to null when stringified
        textToDisplay = "" + textToDisplay;
      } else if (typeof textToDisplay !== "string") {
        textToDisplay = JSON.stringify(textToDisplay);
      }
      if (typeof textToDisplay === "string" && textToDisplay.indexOf("&") >= 0) {
        textToDisplay = textToDisplay.replaceAll("&amp;", "&").replaceAll("&quot;", '"').replaceAll("&#x27;", "'").replaceAll("&nbsp;", " ");
      }
      var titleDOM = $("<h" + parseInt(realLevel) + ">").addClass(classes).text(textToDisplay).css("text-align", function () {
        if (typeof that.options["float"] === "string" && that.options["float"].length > 0) {
          return that.options["float"];
        }
      }).css({
        "overflow": "hidden",
        "line-height": "1.1em" // the letters j g p are clipped below, in the current font, so increase lineheight to make those letters fully visible
      });

      if (typeof this.options.tooltip === "string" && this.options.tooltip.length > 0) {
        titleDOM.attr("title", this.options.tooltip);
        titleDOM.tooltip({
          tooltipClass: "" + this.options.tooltipClasses,
          classes: {
            "ui-tooltip": "" + this.options.tooltipClasses
          },
          position: {
            my: "center bottom-15px",
            at: "center center",
            collision: "flipfit flip"
          }
        });
      }
      if (typeof this.options.id === "string" && this.options.id.length > 0) {
        this.hashID = this.options.id;
        titleIDsDict[this.options.id] |= 0;
        titleDOM.attr("id", this.options.id);
      } else if (this.options.autoGenerateID === true) {
        this.hashID = textToDisplay.toLowerCase().replace(/[^a-z0-9]/g, "");
        if (titleIDsDict[this.hashID] === undefined) {
          titleIDsDict[this.hashID] = 0;
          titleDOM.attr("id", this.options.autoGeneratePrefixID + this.hashID);
        } else {
          titleIDsDict[this.hashID]++;
          titleDOM.attr("id", this.options.autoGeneratePrefixID + this.hashID + "-" + titleIDsDict[this.hashID]);
        }
      }
      this.element.append(titleDOM);
    },
    /**
     * @brief sets the option
     * @private
     * @function
     * @name nixps-cloudflow.Title#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._draw();
    },
    _destroy: function _destroy() {
      // to prevent issues only delete if it was the only one
      if (titleIDsDict[this.hashID] === 0) {
        delete titleIDsDict[this.hashID];
      }
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],163:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Mar 13, 2018 12:17:34 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var leadingNumberRegExp = new RegExp("[0-9]*[}]?$");
  function getTailNumber(pName) {
    if (typeof pName === "string") {
      var result = leadingNumberRegExp.exec(pName);
      if (Array.isArray(result) && result.length > 0) {
        return parseInt(result[0]); // parseInt removes also the ended "}"
      }
    }

    return null;
  }
  var groupscope_translation_keys = {};

  /**
   * @description Checks if a key is known by the translations
   * @function
   * @private
   * @static
   * @param {String} pKey
   * @return {Boolean}
   */
  function isTranslationKnown(pKey) {
    return $.i18n._(pKey) !== pKey;
  }
  /**
   * @namespace nixps-cloudflow.TranslationInput
   * @description draw a component to put a translation string inside
   * @example $('<div>').TranslationInput({});
   * @version 1.3.0
   * @private
   */
  $.widget("nixps-cloudflow.TranslationInput", $.Widget, {
    version: "1.3.0",
    widgetEventPrefix: "translationinput",
    defaultElement: "<div>",
    options: {
      /**
       * @name nixps-cloudflow.TranslationInput#prefix
       * @description The string to be added before the value
       * @type {String}
       * @default ""
       */
      prefix: "${",
      /**
       * @name nixps-cloudflow.TranslationInput#postfix
       * @description The string to be added to the end of the value
       * @type {String}
       * @default ""
       */
      postfix: "}",
      /**
       * @description The translation key
       * @name nixps-cloudflow.TranslationInput#value
       * @type {String}
       * @default ""
       */
      value: "",
      /**
       * @description The post fix string, to be append to the value option
       * @name nixps-cloudflow.TranslationInput#valuePostFix
       * @type {String}
       * @default ""
       */
      valuePostFix: "",
      /**
       * @description The placeholder of the inputfield
       * @name nixps-cloudflow.TranslationInput#placeholder
       * @type {String}
       * @default "not defined"
       */
      placeholder: "",
      /**
       * @description Must we return an other default value if no translations has been found
       * @name nixps-cloudflow.TranslationInput#enableUndefined
       * @type {Boolean}
       * @default false
       */
      enableUndefined: false,
      /**
       * @description if the option {@link nixps-cloudflow.TranslationInput#enableUndefined} is enabled, use this value if the translation is not known
       * @name nixps-cloudflow.TranslationInput#defaultValue
       * @type {undefined}
       * @default undefined}
       */
      defaultValue: undefined,
      /**
       * @description Must we show the key as tooltip
       * @name nixps-cloudflow.TranslationInput#showKeyOnToolTip
       * @type {Boolean}
       * @default false
       */
      showKeyOnToolTip: false,
      /**
       * @description The request for the editor dialog title
       * @name nixps-cloudflow.TranslationInput#editDialogTitle
       * @type {String}
       * @default " " 
       */
      editDialogTitle: " ",
      /**
       * @description the classes given to the component.
       * @name nixps-cloudflow.TranslationInput#classes
       * @type {String}
       * @default ""
       */
      classes: "",
      /**
       * @description The scope where this input translation belongs, this is not the cloudflow scope, but just a ui group name
       * By specifying the names will be appended with a uniq name
       * @name nixps-cloudflow.TranslationInput#groupscope
       * @type {String}
       * @default null
       */
      groupscope: null,
      /**
       * @name nixps-cloudflow.TranslationInput#existingGroupScopeValues
       * @description Provide the list of existing group labels, so if a new comes he will recieve a correct laeding number. 
       * You need to provide this for the first component only. 
       * This only works if {@link nixps-cloudflow.TranslationInput#groupscope} is set on true.
       * This is a kind of static option
       * @type {Array}
       * @default undefined
       * @since 1.2.0
       */
      existingGroupScopeValues: undefined,
      /**
       * @description Must we trigger the remove function, must we apply the remove on the scope, wen the item is removed from the DOM?
       * @name nixps-cloudflow.TranslationInput#removeWhenDestroy
       * @type {Boolean}
       * @default false
       * @since 1.1.0
       */
      removeWhenDestroy: false,
      /**
       * @description The prefix used for custom transaltion keys
       * @name nixps-cloudflow.TranslationInput#customPrefixKey
       * @type {String}
       * @default "custom-"
       * @since 1.3.0
       * @private
       */
      customPrefixKey: "custom-",
      /**
       * @description are the fields required?
       * @name nixps-cloudflow.TranslationInput#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.3.0
       */
      required: false
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.TranslationInput#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.element.append($("<div>").addClass("ti_translatedString inputField").attr("tabindex", "0").addClass(this.options.classes).attr("aria-required", this.options.required === true ? "true" : "false"));
      this.element.append($("<span>").addClass("fa fa-globe ti_icon"));
      // validation and requirement checks are done in the function itself
      this.addExistingGroup(this.options.existingGroupScopeValues);
      this._setValue(this.options.value);
      if (this.options.disabled === true) {
        this.editable(false);
      }
      this._on(this.element, {
        "keypress": this._keypressHandler,
        "click .ti_icon:not(.ti_disable)": this._iconClickHandler,
        "dblclick": this._dblClickHandler
      });
    },
    /**
     * @description Runs to calc default options
     * @name nixps-cloudflow.TranslationInput#_getCreateOptions
     * @function
     * @private
     * @return {undefined}
     */
    _getCreateOptions: function _getCreateOptions() {
      return {
        placeholder: $.i18n._("nixps-cloudflow-TranslationInput.not_defined")
      };
    },
    /**
     * @description User press a key stroke
     * @name nixps-cloudflow.TranslationInput#_keypressHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _keypressHandler: function _keypressHandler(pEvent, pData) {
      if (pEvent.which === $.ui.keyCode.ENTER) {
        this.open();
      }
    },
    /**
     * @description function runs when user clicked on the worl icon
     * @function
     * @name nixps-cloudflow.TranslationInput#_iconClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _iconClickHandler: function _iconClickHandler(pEvent, pData) {
      this.open();
    },
    /**
     * @description Function runs when user double click on the element
     * @function
     * @private
     * @name nixps-cloudflow.TranslationInput#_dblClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _dblClickHandler: function _dblClickHandler(pEvent, pData) {
      this.open();
    },
    /**
     * @description update the ui, because some translation text has been changed
     * @function
     * @name nixps-cloudflow.TranslationInput#update
     * @return {undefined}
     */
    update: function update() {
      if (isTranslationKnown(this.options.value) === false) {
        // the string can not be translated
        this.element.children(".ti_translatedString").text(this.options.placeholder);
        this.element.removeClass("ti_foundTranslation");
      } else {
        // the string could be translated
        this.element.children(".ti_translatedString")._t(this.options.value);
        this.element.addClass("ti_foundTranslation");
      }
      if (this.options.showKeyOnToolTip === true) {
        this.element.children(".ti_translatedString").attr("title", this.options.value);
      }
    },
    /**
     * @description Open the translation dialog
     * @function
     * @name nixps-cloudflow.TranslationInput#open
     * @return {undefined}
     */
    open: function open() {
      this._trigger("open", null, {
        value: this.options.value,
        dialogTitle: this.options.editDialogTitle,
        enableEmpty: this.options.enableUndefined
      });
    },
    /**
     * @description Get the current translation key
     * @function
     * @name nixps-cloudflow.TranslationInput#getValue
     * @return {String} the ranslation key
     */
    getValue: function getValue() {
      if (typeof this.options.value === "string" && this.options.value.indexOf(this.options.customPrefixKey) === 0) {
        // the value is a custom defined translation key
        return this.options.prefix + this.options.value + this.options.postfix;
      }
      if (this.options.enableUndefined === false) {
        return this.options.prefix + this.options.value + this.options.postfix;
      } else {
        if (isTranslationKnown(this.options.value)) {
          return this.options.prefix + this.options.value + this.options.postfix;
        } else {
          return this.options.defaultValue;
        }
      }
    },
    setValue: function setValue(pValue) {
      if (typeof pValue === "string") {
        // do nothing, value is fixed defined by creation!
        // check if the value is a normal word and not a key, if so propose to add this as new translation word
        if (pValue.length > 0 && pValue.substring(0, this.options.prefix.length) !== this.options.prefix && isTranslationKnown(this.options.value) === false && pValue.indexOf(this.options.customPrefixKey) !== 0) {
          if (this._trigger("add", null, {
            "translationKey": this.options.value,
            "value": pValue
          }) !== false) {
            this.update();
          }
        }

        // Backwards compatibility with custom translation keys
        if (pValue.startsWith(this.options.prefix) && pValue.endsWith(this.options.postfix)) {
          pValue = pValue.substring(this.options.prefix.length, pValue.length - this.options.postfix.length);
          this.options.value = pValue;
          this.update();
        }
      }
    },
    /**
     * @description Set the input to a specific string
     * @function
     * @private
     * @name nixps-cloudflow.TranslationInput#_setValue
     * @param {String} pValue
     * @return {undefined} 
     */
    _setValue: function _setValue(pValue) {
      if (typeof pValue !== "string") {
        throw new Error("TranslationInput: parameter pValue must be a string");
      }
      if (pValue.startsWith(this.options.prefix) === true) {
        pValue = pValue.substring(this.options.prefix.length);
      }
      if (pValue.endsWith(this.options.postfix)) {
        pValue = pValue.substring(0, pValue.length - this.options.postfix.length);
      }
      if (pValue.indexOf(this.options.customPrefixKey) === 0) {
        // customised key
        this.options.value = pValue;
        this.options.valuePostFix = "";
        // no groups scopes
      } else {
        // normal case
        if (typeof this.options.groupscope !== "string" || this.options.groupscope.length <= 0) {
          // update model
          this.options.value = pValue + this.options.valuePostFix;
          this.options.valuePostFix = "";
        }
        if (typeof this.options.groupscope === "string" && this.options.groupscope.length > 0) {
          var tailNumber = getTailNumber(pValue);
          if (typeof this.options.valuePostFix === "string" && this.options.valuePostFix.length > 0) {
            // case of groupScope and valuepastfix like: ...458_label0}
            if (pValue.endsWith(this.options.valuePostFix + tailNumber) === false) {
              // tailnumber not found, apply
              this.options.value = pValue + this.options.valuePostFix + this._getNextTranslationKeyTailNumber();
            } else {
              // tailnumber already applied, already good
              this.options.value = pValue;
            }
          } else if (typeof tailNumber === "number" && isNaN(tailNumber) === false) {
            // there is already a number, so tailnumber is already added
            this.options.value = pValue;
          } else {
            // no valuepastfix, so no tailnumber found
            this.options.value = pValue + this.options.valuePostFix + this._getNextTranslationKeyTailNumber();
          }
          this.options.valuePostFix = "";
          this._addToGroup(this.options.value);
        }
      }
      this.update();
    },
    /**
     * @description Enable or disable editing the translations
     * @function
     * @name nixps-cloudflow.TranslationInput#editable
     * @param {Boolean} pEditable
     * @return {undefined}
     */
    editable: function editable(pEditable) {
      this.element.find(".ti_icon").toggleClass("ti_disable", pEditable === false);
      if (pEditable === true) {
        this.element.children(".ti_translatedString").attr("tabindex", "0");
      } else {
        this.element.children(".ti_translatedString").attr("tabindex", "");
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.TranslationInput#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "prefix" || pKey === "postfix") {
        return; // do nothing
      }

      if (pKey === "disabled") {
        this.editable(pValue === false);
        return;
      }
      if (pKey === "required") {
        this.element.children(".ti_translatedString").attr("aria-required", pValue === true ? "true" : "false");
        return;
      }
      this.update();
    },
    /**
     * @description Remove a translation key from the temp memory
     * @function
     * @private
     * @name nixps-cloudflow.TranslationInput#remove
     * @param {String} pTranslationKey
     * @return {undefined}
     */
    remove: function remove() {
      if (typeof this.options.groupscope === "string" && this.options.groupscope.length > 0 && groupscope_translation_keys[this.options.groupscope] !== undefined) {
        var index = $.inArray(this.options.value, groupscope_translation_keys[this.options.groupscope]);
        if (index >= 0) {
          groupscope_translation_keys[this.options.groupscope].splice(index, 1);
        }
      }
    },
    /**
     * @description add a string to the group dict
     * @function
     * @private
     * @name nixps-cloudflow.TranslationInput#_addToGroup
     * @param {String} pValue The value to be added to the group dict
     * @since 1.2.0
     */
    _addToGroup: function _addToGroup(pValue) {
      if (groupscope_translation_keys[this.options.groupscope] === undefined) {
        groupscope_translation_keys[this.options.groupscope] = [];
      }
      if ($.inArray(pValue, groupscope_translation_keys[this.options.groupscope]) === -1) {
        groupscope_translation_keys[this.options.groupscope].push(pValue);
      }
    },
    /**
     * @description add values at the group at ones, to be run before the first values is set, of the group of all 
     * inputs
     * @function
     * @name nixps-cloudflow.TranslationInput#addExistingGroup
     * @param {Array<String>} pValues The values to be added to the group at ones
     * @since 1.2.0
     */
    addExistingGroup: function addExistingGroup(pValues) {
      if (Array.isArray(pValues) && pValues.length > 0 && typeof this.options.groupscope === "string" && this.options.groupscope.length > 0) {
        for (var i = 0; i < pValues.length; i++) {
          if (typeof pValues[i] !== "string") {
            throw new Error("TranslationInput:_addExistingGroup parameter pValue must be a string");
          }
          var existingTranslationValue = pValues[i];
          if (existingTranslationValue.startsWith(this.options.prefix) === true) {
            existingTranslationValue = existingTranslationValue.substring(this.options.prefix.length);
          }
          if (existingTranslationValue.endsWith(this.options.postfix)) {
            existingTranslationValue = existingTranslationValue.substring(0, existingTranslationValue.length - this.options.postfix.length);
          }
          if (existingTranslationValue.indexOf(this.options.customPrefixKey) === 0) {
            continue; //ignore custom keys
          }

          var tailNumber = getTailNumber(existingTranslationValue);
          if (typeof tailNumber === "number" && isNaN(tailNumber) === false) {
            this._addToGroup(existingTranslationValue);
          }
        }
      }
    },
    /**
     * @description get all specific translations for the specific groupscope
     * @function
     * @name nixps-cloudflow.TranslationInput#_getGroupScopeTranslationKeys
     * @private
     * @return {groupscope_translation_keys|nixps-cloudflow.TranslationInputL#8.groupscope_translation_keys|Array}
     */
    _getGroupScopeTranslationKeys: function _getGroupScopeTranslationKeys() {
      if (typeof this.options.groupscope === "string" && this.options.groupscope.length > 0) {
        if (groupscope_translation_keys[this.options.groupscope] === undefined) {
          return [];
        }
        return groupscope_translation_keys[this.options.groupscope];
      }
      return null;
    },
    /**
     * @description get the next iterative number, to make unique transaltion keys
     * @function
     * @name nixps-cloudflow.TranslationInput#_getNextTranslationKeyTailNumber
     * @private
     * @return {Number}
     */
    _getNextTranslationKeyTailNumber: function _getNextTranslationKeyTailNumber() {
      var currentNumber;
      var maxNumber = -1;
      var translationKeys = this._getGroupScopeTranslationKeys();
      if (Array.isArray(translationKeys)) {
        for (var i = 0; i < translationKeys.length; i++) {
          currentNumber = getTailNumber(translationKeys[i]);
          if (typeof currentNumber === "number" && currentNumber > maxNumber) {
            maxNumber = currentNumber;
          }
        }
      }
      return maxNumber + 1;
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.TranslationInput#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.value !== "string") {
        throw new Error("TranslationInput: input option value must be a string");
      }
      if (typeof this.options.valuePostFix !== "string") {
        throw new Error("TranslationInput: input option valuePostFix must be a string");
      }
      if (typeof this.options.prefix !== "string") {
        throw new Error("TranslationInput: input option prefix must be a string");
      }
      if (typeof this.options.postfix !== "string") {
        throw new Error("TranslationInput: input option postfix must be a string");
      }
      if (typeof this.options.enableUndefined !== "boolean") {
        throw new Error("TranslationInput: input option enableUndefined must be a boolean");
      }
      if (typeof this.options.showKeyOnToolTip !== "boolean") {
        throw new Error("TranslationInput: input option showKeyOnToolTip must be a boolean");
      }
    },
    _destroy: function _destroy() {
      if (this.options.removeWhenDestroy === true) {
        this.remove();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],164:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, vim, mathjs */
/*globals OperatiopmNode, SymbolNode, ConstantNode, nixps */

(function ($) {
  var Unit = require("../../Units/js/Unit.js");
  var Value = require("../../Units/js/Value.js");
  var UnitPreferences = require("../../Units/js/UnitPreferences.js");
  function getDecimalSeparator(pLanguageCode) {
    var n = 1.1;
    n = n.toLocaleString(pLanguageCode).substring(1, 2);
    return n;
  }

  /**
   * @returns true if the bounds [a, b] are valid, this means a < b and a != b
   */
  function validateBounds(pMinValue, pMaxValue) {
    if (typeof pMinValue === "number" && typeof pMaxValue === "number") {
      if (pMinValue > pMaxValue || Math.abs(pMinValue - pMaxValue) < 0.0000001) {
        return false;
      }
    }
    return true;
  }

  /**
   * @brief returns true if the value is within bounds [minValue, maxValue]
   */
  function isInBounds(pValue, pMinValue, pMaxValue) {
    if (typeof pValue !== "number") {
      return false;
    }
    if (typeof pMinValue === "number" && pValue < pMinValue) {
      return false;
    }
    if (typeof pMaxValue === "number" && pValue > pMaxValue) {
      return false;
    }
    return true;
  }

  /**
   * @brief returns a default value in bounds, if minValue is defined it takes the minValue else it takes the maxValue
   */
  function getDefaultValue(pMinValue, pMaxValue) {
    if (validateBounds(pMinValue, pMaxValue) === false) {
      throw new Error("invalid bounds");
    }
    if (typeof pMinValue === "number") {
      return pMinValue;
    }
    if (typeof pMaxValue === "number") {
      return pMaxValue;
    }
    return 0;
  }

  /**
   * @brief validates a transformation function
   */
  function validateTransform(transform) {
    return $.isPlainObject(transform) === true && typeof transform.to === "function" && typeof transform.from === "function";
  }

  /**
   * @brief the identity transformation
   */
  var kIdentityTransform = {
    from: function from(value) {
      return value;
    },
    to: function to(value) {
      return value;
    }
  };

  /**
   * @namespace nixps-cloudflow.ValueInput
      * @description Draw an input component with displays the unit according to the user preferences
      * @example $("<input>").ValueInput({});
      * @version 2.3.0
   */
  $.widget("nixps-cloudflow.ValueInput", $.Widget, {
    defaultElement: "<input>",
    widgetEventPrefix: "valueinput",
    version: "2.3.0",
    options: {
      /** 
       * @brief the locale to display
       * @name nixps-cloudflow.ValueInput#language
       * @type {String}
       * @default false
       */
      language: false,
      /**
       * @description The name of the component
      * @name nixps-cloudflow.ValueInput#name
       * @type {String}
       * @default null
       */
      name: null,
      /**
      * @brief the name of the unit which should be shown, is a key in the unit preferences
      * @name nixps-cloudflow.ValueInput#displayDefinition
      * @default null
      */
      displayDefinition: null,
      /**
       * @brief the unit in which we want to save
       * @name nixps-cloudflow.ValueInput#storageUnit
       * @default null
       */
      storageUnit: null,
      /**
       * @brief the maximium value
       * @name nixps-cloudflow.ValueInput#maxValue
       * @type {Number}
       * @default false
       */
      maxValue: false,
      /** 
       * @brief the minimum value
       * @name nixps-cloudflow.ValueInput#minValue
       * @type {Number}
       * @default false
       */
      minValue: false,
      /** 
       * @brief the value in the input box
       * @name nixps-cloudflow.ValueInput#value
       * @type {Number}
       * @default false
       */
      value: false,
      /**
       * @name nixps-cloudflow.ValueInput#transform
       * @brief a transformation function, first the displayed value is converted to the storage unit, then it is transformed.
       *        from: option.value -> value in storage unit
       *		  to: value in storage unit -> option.value
       * 		  This is the transformers format: 
       *			{
       *				to: function(value) {
       *					return value;
       *				},
       *				from: function(value) {
       *					return value;
       *				}
       *			}
       */
      transform: kIdentityTransform,
      /**
       * @description The classes object containing key value, where each key is a predefined class.
       * This option is predefined in recent jQuery UI
       * @type {Object}
       * @name nixps-cloudflow.ValueInput#classes
       * @since 2.1.0
       */
      classes: {
        "valueinput-input": ""
      },
      /**
       * @description Must we create the internal input field
      * @name nixps-cloudflow.ValueInput#createInput
       * @type {Boolean}
       * @default false
       */
      createInput: false,
      /**
                * @description Is the field required?
                * @name nixps-cloudflow.ValueInput#required
                * @type {Boolean}
                * @default false
                * @example true
                * @since 2.2.0
                */
      required: false,
      created: function created() {}
    },
    _create: function _create() {
      this._isValid = false; // is the current value valid or not?
      this._isDirty = false; // it the current value triggered away or not?

      if (this.element.attr("type") !== undefined) {
        console.warn("ValueInput has a type attribute, this can cause issues with the autobind");
      }
      var inputDOM;
      if (this.options.createInput === true) {
        inputDOM = $("<input>").prop("disabled", this.options.disabled);
        this.element.append(inputDOM);
      } else {
        if (!this.element.is("input")) {
          throw new Error(this.widgetName + ": must be constructed on <input>");
        }
        inputDOM = this.element;
      }
      if (typeof this._addClass === "function") {
        // recent jQuery UI
        this._addClass(inputDOM, "valueinput-input");
      } else {
        // older jQuery UI
        inputDOM.addClass("valueinput-input");
        if (this.options.classes !== undefined && typeof this.options.classes["valueinput-input"] === "string") {
          inputDOM.addClass(this.options.classes["valueinput-input"]);
        }
      }
      if (typeof this.element.attr("name") === "string" && this.element.attr("name").length > 0) {
        this.options.name = this.element.attr("name");
      }
      if (typeof this.options.name !== "string" || this.options.name.length === 0) {
        throw new Error(this.widgetName + ": name attribute must be specified");
      }
      if (this.element.attr("type") === "number") {
        throw new Error(this.widgetName + ": type attribute cannot be number");
      }
      if (typeof this.options.value !== "number") {
        // If no value is passed, get a default value between the min and max value 
        // If no min and max is specified, 0 is the default value
        this.options.value = getDefaultValue(this.options.minValue, this.options.maxValue);
      } else if (isInBounds(this.options.value, this.options.minValue, this.options.maxValue) === false) {
        // Check if the passed default value is between the min and max bounds, if not throw an error
        throw new Error(this.widgetName + ": default value is not between the min and max value");
      }
      if (validateBounds(this.options.minValue, this.options.maxValue) === false) {
        throw new Error(this.widgetName + ": invalid combination of min and max value");
      }

      // AI Codex
      if (window.math === undefined && window.jsep === undefined) {
        console.error("include math.js or jsep to activate calculation feature");
      }
      // IA

      if (typeof this.options.language !== "string" || this.options.language.length === 0) {
        // fallback on the html code of the page
        var htmlLang = $("html").attr("lang");
        if (typeof htmlLang === "string" && htmlLang.length > 0) {
          this.options.language = htmlLang;
        }
      }

      // Validate the transformation
      if (validateTransform(this.options.transform) === false) {
        throw new Error("invalid transform");
      }
      this.element.addClass(this.widgetFullName).addClass("nixps-quantum-ValueInput asyncInSummary").attr("data-uuid", this.uuid);
      inputDOM.prop("required", this.options.required);

      // variables
      this.displayDefinition = undefined;
      this.storageUnit = undefined;
      this.dead = false;
      this._on(this.element, {
        "change": this._inputChangeHander,
        "blur": this._inputChangeHander,
        "input": this._inputInputHandler
      });
      var that = this;
      this.unitPrefDef = UnitPreferences.get().then(function (unitPreferences) {
        var successorDOM = null;
        if (that.dead === true) {
          successorDOM = $("[data-clone-uuid='" + that.uuid + "']");
          if (successorDOM.length === 0) {
            that.options.created();
            return; // prevent zombie actions
          } else {
            // it is dead, but there is a successor, that needs that value
          }
        }
        var preferences = unitPreferences;
        if (typeof that.options.displayDefinition == "string") {
          that.displayDefinition = preferences.getDefinition(that.options.displayDefinition);
        } else {
          that.displayDefinition = that.options.displayDefinition;
        }
        if (typeof that.options.displayDefinition == "string") {
          that.storageUnit = new Unit({
            unit: that.options.storageUnit
          });
        } else {
          that.storageUnit = that.options.storageUnit;
        }
        that._isValid = true;
        that._draw();
        if (that.options.disabled === true) {
          if (that.options.createInput === true) {
            that.element.children("input").prop("disabled", true);
          } else {
            that.element.prop("disabled", true);
          }
        }
        if (successorDOM !== null && successorDOM.length === 1) {
          // copy value from dead component to successor
          successorDOM.text(that.element.val());
        }
        that.options.created();
      })["catch"](function (pError) {
        that.options.created();
        return $.Deferred().reject(pError);
      });
    },
    /**
     * @description function runs when user blur the input field
     * @function
     * @private
     * @name nixps-cloudflow.ValueInput#_inputChangeHander
     * @param {Object} pEvent 
     * @returns undefined
     */
    _inputChangeHander: function _inputChangeHander(pEvent) {
      try {
        var data = this._getData();
        if (data.redraw === true) {
          this._draw();
          this._isValid = true;
          this.triggerChange();
          this._isDirty = false;
          return;
        }
        var newValue = data.value;
        if (this._isDirty === true && data.addedDefaultUnit === true) {
          // special case, user remove unit but keeps value intact
          this._draw(); // (re)add unit
          this._isValid = true;
          this.triggerChange();
          this._isDirty = false;
          return;
        }
        if (isInBounds(newValue, this.options.minValue, this.options.maxValue) === false) {
          throw new Error("value is not in bounds");
        }
        this._isValid = true;
        this.option("value", newValue);
        this.triggerChange();
        this._isDirty = false;
      } catch (pError) {
        this._isValid = false;
      }
      this._draw();
    },
    /**
     * @description function runs when user change the input field
     * @function
     * @private
     * @name nixps-cloudflow.ValueInput#_inputInputHandler
     * @param {Object} pEvent 
     * @returns undefined
     */
    _inputInputHandler: function _inputInputHandler(pEvent) {
      this._isDirty = true;
      try {
        var data = this._getData();
        // update options.value, when the input value is valid but before the change trigger has been triggered 
        if (data.redraw === false && this.options.value !== data.value && data.value !== null && isInBounds(data.value, this.options.minValue, this.options.maxValue)) {
          this.options.value = data.value;
        }
      } catch (pError) {
        // ignore, unless it is a unit test compare error
        if (pError.name === "AssertionError") {
          throw pError;
        }
      }
    },
    /**
     * @description Get the current value and other info about the current state
     * @function
     * @private
     * @name nixps-cloudflow.ValueInput#_getData
     * @returns Object containing value, and other info
     */
    _getData: function _getData() {
      var toParse;
      if (this.options.createInput === true) {
        toParse = this.element.children("input").val();
      } else {
        toParse = this.element.val();
      }
      if (typeof toParse !== "string" || toParse.length === 0) {
        return {
          redraw: true,
          value: null,
          addedDefaultUnit: false
        };
      }

      // Replace all "," with ".", support , and . decimal separators
      toParse = toParse.replace(/,/g, ".");

      // AI Codex
      // Handle percent values directly because % is not a JSEP unit identifier.
      // IA
      var result = null;
      var addedDefaultUnit = false;
      if (this._isPercentUnit() === true && toParse.indexOf("%") > 0) {
        var value = parseFloat(toParse);
        if (isNaN(value) === true) {
          throw new Error("invalid number");
        }
        result = new Value(value, new Unit({
          unit: "%"
        }));
      } else if (window.jsep) {
        // AI Codex
        // Make an adjacent unit explicit so jsep can parse expressions such as 5m + 6cm.
        toParse = toParse.replace(/((?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?)[\s]*([a-zA-Zµ][a-zA-Z0-9µ]*)/g, "$1 * $2");
        var tree = new window.jsep(toParse).parse();
        result = this._evalTree(tree);
        // IA
      } else if (window.math && typeof window.math.parse === "function") {
        // AI Codex
        // Keep the math.js parser for older pages that still load it.
        var mathInput = toParse.replace(String.fromCharCode(181) + "m", "");
        result = this._evalTree(window.math.parse(mathInput));
        // IA
      } else {
        // in case of old pagebuilders or old kiosk page, just fallback and do not providing this feature
        // fail grasfully
        var value = parseFloat(toParse);
        if (isNaN(value) === true) {
          throw new Error("invalid number");
        }
        var unit = toParse = toParse.replace(/^\s*[0-9.]+\s*([a-zA-Zµ]*[a-zA-Zµ]*).*/i, "$1");
        if (typeof unit === "string" && unit.length > 0) {
          result = new Value(value, new Unit({
            unit: unit
          }));
        } else {
          // no unit found
          addedDefaultUnit = true;
          result = new Value(value, this.displayDefinition);
        }
      }
      // AI Codex
      if (result.getUnit().getShortName() === "") {
        // add default unit measurement
        addedDefaultUnit = true;
        result = new Value(result.getValue(), this.displayDefinition);
      }
      // IA

      var newValue = result.convert(this.storageUnit).getValue();
      newValue = this.options.transform.to(newValue);
      return {
        redraw: false,
        value: newValue,
        addedDefaultUnit: addedDefaultUnit
      };
    },
    _draw: function _draw() {
      var inputElement;
      if (this.options.createInput === true) {
        inputElement = this.element.children("input");
      } else {
        inputElement = this.element;
      }
      if (this.isValid() === false) {
        inputElement.css({
          color: "red"
        });
      } else {
        inputElement.css({
          color: ""
        });
      }
      var storedValue = new Value(this.options.transform.from(this.options.value), this.storageUnit);
      var displayValue = storedValue.convert(this.displayDefinition);
      var value = displayValue.toString().replace(/[.]/g, getDecimalSeparator(this.options.language));
      inputElement.val(value);
    },
    // AI Codex
    _evalTree: function _evalTree(pTree) {
      // JSEP AST nodes
      if (pTree.type === "Literal" && typeof pTree.value === "number") {
        return new Value(pTree.value, new Unit({
          unit: ""
        }));
      }
      if (pTree.type === "Identifier") {
        return new Value(1, new Unit({
          unit: pTree.name
        }));
      }
      if (pTree.type === "UnaryExpression") {
        var unaryValue = this._evalTree(pTree.argument);
        switch (pTree.operator) {
          case "+":
            return unaryValue;
          case "-":
            return new Value(-unaryValue.getValue(), unaryValue.getUnit());
          default:
            throw new Error("unsupported unary operator " + pTree.operator);
        }
      }
      if (pTree.type === "BinaryExpression") {
        var left = this._evalTree(pTree.left);
        var right = this._evalTree(pTree.right);
        var matched = this._matchUnits(left, right);
        switch (pTree.operator) {
          case "*":
            return new Value(matched[0].getValue() * matched[1].getValue(), matched[1].getUnit());
          case "/":
            return new Value(matched[0].getValue() / matched[1].getValue(), matched[1].getUnit());
          case "+":
            return new Value(matched[0].getValue() + matched[1].getValue(), matched[1].getUnit());
          case "-":
            return new Value(matched[0].getValue() - matched[1].getValue(), matched[1].getUnit());
          default:
            throw new Error("unsupported binary operator " + pTree.operator);
        }
      }

      // Math.js AST nodes kept for compatibility with older pages.
      if (typeof pTree.op === "string" && pTree.op.length > 0 && pTree.params.length === 1) {
        var value = pTree.params[0];
        if (!(pTree.params[0] instanceof Value || window.nixps !== undefined && nixps.cloudflow !== undefined && nixps.cloudflow.Value !== undefined && pTree.params[0] instanceof nixps.cloudflow.Value)) {
          value = this._evalTree(pTree.params[0]);
        }
        switch (pTree.op) {
          case "+":
            return value;
          case "-":
            return new Value(-value.getValue(), value.getUnit());
        }
      }
      if (typeof pTree.op === "string" && pTree.op.length > 0) {
        var left = pTree.params[0];
        if (!(pTree.params[0] instanceof Value || window.nixps !== undefined && nixps.cloudflow !== undefined && nixps.cloudflow.Value !== undefined && pTree.params[0] instanceof nixps.cloudflow.Value)) {
          left = this._evalTree(pTree.params[0]);
        }
        var right = pTree.params[1];
        if (!(pTree.params[1] instanceof Value || window.nixps !== undefined && nixps.cloudflow !== undefined && nixps.cloudflow.Value !== undefined && pTree.params[1] instanceof nixps.cloudflow.Value)) {
          right = this._evalTree(pTree.params[1]);
        }
        var matched = this._matchUnits(left, right);
        switch (pTree.op) {
          case "*":
            return new Value(matched[0].getValue() * matched[1].getValue(), matched[1].getUnit());
          case "/":
            return new Value(matched[0].getValue() / matched[1].getValue(), matched[1].getUnit());
          case "+":
            return new Value(matched[0].getValue() + matched[1].getValue(), matched[1].getUnit());
          case "-":
            return new Value(matched[0].getValue() - matched[1].getValue(), matched[1].getUnit());
        }
      }
      if (typeof pTree.name === "string" && pTree.name.length > 0) {
        return new Value(1, new Unit({
          unit: pTree.name
        }));
      }
      if (typeof pTree.value === "string" && pTree.value.length > 0) {
        return new Value(parseFloat(pTree.value), new Unit({
          unit: ""
        }));
      }
      throw new Error("unsupported expression type " + pTree.type);
    },
    // IA

    _matchUnits: function _matchUnits(pLeft, pRight) {
      if (pLeft.getUnit().getShortName() === "") {
        return [new Value(pLeft.getValue(), pRight.getUnit()), pRight];
      }
      if (pRight.getUnit().getShortName() === "") {
        return [pLeft, new Value(pRight.getValue(), pLeft.getUnit())];
      }
      return [pLeft.convert(pRight.getUnit()), pRight];
    },
    _isPercentUnit: function _isPercentUnit() {
      return this.displayDefinition.getShortName() === "%";
    },
    /**
     * @name nixps-cloudflow.ValueInput#setValue
     * @description Set the input to a specific numeric value
     * @function
     * @param {Number} pValue The numeric value you want to have, it can be displayed otherwise
     */
    setValue: function setValue(pValue) {
      this.option("value", pValue);
    },
    /**
     * @name nixps-cloudflow.ValueInput#getValue
     * @description get the numeric value good to store in the backend
     * @function
     * @returns {Number}
     */
    getValue: function getValue() {
      return this.options.value;
    },
    triggerChange: function triggerChange() {
      // prevent error of outside to set internal value on unvalid
      try {
        this._trigger("change", null, {
          name: this.options.name,
          value: this.getValue()
        });
      } catch (pError) {
        console.error(pError);
        // it is a unit test compare error
        if (pError.name === "AssertionError") {
          throw pError;
        }
      }
    },
    /**
     * @description check if the input is valid or not
     * @name mixps-cloudflow.ValueInput#isValid
     * @function
     * @returns {Boolean} true if it is valid, false otherwise
     */
    isValid: function isValid() {
      return this._isValid === true;
    },
    reset: function reset() {
      var that = this;
      if (this.displayDefinition !== undefined) {
        this.setValue(0);
        return Promise.resolve();
      } else {
        return this.unitPrefDef.then(function () {
          that.setValue(0);
        });
      }
    },
    _setOptions: function _setOptions(options) {
      var key;
      var needRedraw = false;
      for (key in options) {
        if (this._setOption(key, options[key]) === true) {
          needRedraw = true;
        }
      }
      if (needRedraw === true) {
        var that = this;
        this.unitPrefDef.then(function () {
          if (that.dead === true) {
            return; // prevent zombie actions
          }

          that._draw();
        });
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "value") {
        if (typeof pValue !== "number") {
          this._super(pKey, getDefaultValue(this.options.minValue, this.options.maxValue));
        } else {
          this._super(pKey, pValue);
        }
        return true;
      } else if (pKey === "minValue") {
        if (validateBounds(pValue, this.options.maxValue) === false) {
          throw new Error("Invalid min / max value combination");
        }
        this._super(pKey, pValue);
        if (isInBounds(this.options.value, pValue, this.options.maxValue) === false) {
          this._isValid = false;
        } else {
          this._isValid = true;
        }
        return true;
      } else if (pKey === "maxValue") {
        if (validateBounds(this.options.minValue, pValue) === false) {
          throw new Error("Invalid min / max value combination");
        }
        this._super(pKey, pValue);
        if (isInBounds(this.options.value, this.options.minValue, pValue) === false) {
          this._isValid = false;
        } else {
          this._isValid = true;
        }
        return true;
      } else if (pKey === "transform") {
        if (validateTransform(pValue) === false) {
          throw new Error("invalid transform");
        }
        this._super(pKey, pValue);
        return true;
      } else if (pKey === "disabled") {
        if (this.options.createInput === true) {
          this.element.children("input").prop("disabled", pValue);
        } else {
          this.element.prop("disabled", pValue);
        }
        this._super(pKey, pValue);
        return false;
      } else if (pKey === "required") {
        if (this.options.createInput === true) {
          this.element.children("input").prop("required", pValue);
        } else {
          this.element.prop("required", pValue);
        }
        this._super(pKey, pValue);
        return false;
      }
      return true;
    },
    _destroy: function _destroy() {
      this.dead = true;
    }
  });
})(jQuery);

},{"../../Units/js/Unit.js":264,"../../Units/js/UnitPreferences.js":265,"../../Units/js/Value.js":266}],165:[function(require,module,exports){
"use strict";

/**
 * @constructor BootstrapGridLayoutRender
 * @description The renderer of bootstrap layout
 */
var BootstrapGridLayoutRender = function BootstrapGridLayoutRender(pParent, pIDAttribute, pIDPrefix) {
  this.rowClassRegExp = new RegExp("(^|\\s)(col-|cf-col-)\\S+", "g");
  this.element = pParent;
  this.container;
  this.IDAttribute = pIDAttribute;
  if (typeof pIDPrefix === "string") {
    this.IDPrefix = pIDPrefix;
  } else {
    this.IDPrefix = "";
  }
};
BootstrapGridLayoutRender.prototype = {
  constructor: BootstrapGridLayoutRender,
  /**
   * @description Render the layout according to the options
   * @function
   * @private
   * @param {pRowParameters} pParameters 
   * @param {Object} pRenderOptions 
   */
  render: function render(pLayoutParameters, pRenderOptions) {
    var renderOptions = Object.assign({
      "xsClassName": "col-xs-$1 cf-col-xs-$1",
      "smClassName": "col-sm-$1 cf-col-sm-$1",
      "mdClassName": "col-md-$1 cf-col-md-$1",
      "lgClassName": "col-lg-$1 cf-col-lg-$1",
      "rowClassName": "row layoutRow"
    }, pRenderOptions);
    if (pLayoutParameters.hasTableOfContents() && renderOptions.table_of_contents === true) {
      var tableOfContentsOptions = pLayoutParameters.getTableOfContents();
      this.container = $("<div>").addClass("container-fluid layouttype_bootstrapGrid").addClass(pLayoutParameters.getRootClasses());
      this.element.addClass("cf-settingslist-embedded").append($("<div>").attr(this.IDAttribute, tableOfContentsOptions.content).addClass("cf-settingslist"));
      this.container.addClass("cf-settingslist-contentpage");
      this.element.append(this.container);
    } else {
      this.container = this.element.addClass("container-fluid layouttype_bootstrapGrid").addClass(pLayoutParameters.getRootClasses());
    }

    // loop over all rows
    var row = undefined,
      layoutRow = undefined,
      layoutComponent = undefined,
      element = undefined,
      elementsContainer = undefined;
    var rowContainer = new Array(pLayoutParameters.getRows().length);
    for (var i = 0; i < pLayoutParameters.getRows().length; i++) {
      layoutRow = pLayoutParameters.getRow(i);
      row = $("<div>").addClass("row layoutRow").addClass(pLayoutParameters.getRowClasses()).addClass("cf-children-overflow" + pLayoutParameters.getChildrenOverflow());
      elementsContainer = [];
      // loop over all elements in that row
      for (var j = 0; j < layoutRow.getElements().length && j < 12; j++) {
        // make a element
        layoutComponent = layoutRow.getElement(j);
        element = $("<div>").addClass("layoutComponent").attr(this.IDAttribute, typeof layoutComponent.getID() === "string" ? this.IDPrefix + layoutComponent.getID() : layoutComponent.getID());
        var widthObject = layoutComponent.getWidths();
        var widthClass = "";
        if (typeof widthObject.xs === "number") {
          widthClass += " " + renderOptions.xsClassName.replaceAll("$1", widthObject.xs);
        }
        if (typeof widthObject.sm === "number") {
          widthClass += " " + renderOptions.smClassName.replaceAll("$1", widthObject.sm);
        }
        if (typeof widthObject.md === "number") {
          widthClass += " " + renderOptions.mdClassName.replaceAll("$1", widthObject.md);
        }
        if (typeof widthObject.lg === "number") {
          widthClass += " " + renderOptions.lgClassName.replaceAll("$1", widthObject.lg);
        }
        element.addClass(widthClass);
        elementsContainer.push(element);
      }
      row.append(elementsContainer);
      if (row.children("[" + this.IDAttribute + "]").length === 0) {
        row.addClass("layoutRow_emptyRow");
      }
      rowContainer[i] = row;
    }
    this.container.append(rowContainer);
  },
  addElement: function addElement(pDOMElement, pID) {
    // search for the place, empty it (because it could be filled with previous data)
    // so last will overwrite and win, append then
    var id = typeof pID === "string" ? this.IDPrefix + pID : pID;
    return this.element.find("[" + this.IDAttribute + "='" + id + "']").first().empty().append(pDOMElement);
  },
  getElement: function getElement(pID) {
    var id = typeof pID === "string" ? this.IDPrefix + pID : pID;
    return this.element.find("[" + this.IDAttribute + "='" + id + "']").first().children();
  },
  getFieldElements: function getFieldElements() {
    return this.container.children(".layoutRow").children(".layoutComponent").children(".formGroup.fieldElement");
  },
  showErrorMessages: function showErrorMessages(pMessages) {
    return this.container.children(".layoutRow").children(".layoutComponent").children(".formGroup").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage("showErrorMessage", pMessages.join("<br/>"));
  },
  hideErrorMessages: function hideErrorMessages() {
    return this.container.children(".layoutRow").children(".layoutComponent").children(".formGroup").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage("hideErrorMessages");
  },
  updateRow: function updateRow(pRowIndex, pParameters, pRenderOptions) {
    var renderOptions = Object.assign({
      "xsClassName": "col-xs-$1 cf-col-xs-$1",
      "smClassName": "col-sm-$1 cf-col-sm-$1",
      "mdClassName": "col-md-$1 cf-col-md-$1",
      "lgClassName": "col-lg-$1 cf-col-lg-$1",
      "rowClassName": "row layoutRow"
    }, pRenderOptions);
    var rows = pParameters;
    var layoutRow = rows.getRow(pRowIndex);
    var that = this;
    var layoutComponent = undefined;
    var rowDOM = this.container.children(".row.layoutRow").eq(pRowIndex);
    rowDOM.children(".layoutComponent").each(function (index) {
      layoutComponent = layoutRow.getElement(index);
      $(this).attr(that.IDAttribute, typeof layoutComponent.getID() === "string" ? that.IDPrefix + layoutComponent.getID() : layoutComponent.getID());
      $(this).removeClass(function (classindex, className) {
        return (className.match(that.rowClassRegExp) || []).join(" ");
      });
      var widthObject = layoutComponent.getWidths();
      var widthClass = "";
      if (typeof widthObject.xs === "number") {
        widthClass += " " + renderOptions.xsClassName.replaceAll("$1", widthObject.xs);
      }
      if (typeof widthObject.sm === "number") {
        widthClass += " " + renderOptions.smClassName.replaceAll("$1", widthObject.sm);
      }
      if (typeof widthObject.md === "number") {
        widthClass += " " + renderOptions.mdClassName.replaceAll("$1", widthObject.md);
      }
      if (typeof widthObject.lg === "number") {
        widthClass += " " + renderOptions.lgClassName.replaceAll("$1", widthObject.lg);
      }
      $(this).addClass(widthClass);
    });
    if (typeof pParameters.getRowClasses() === "string" && pParameters.getRowClasses().length > 0) {
      rowDOM.addClass(pParameters.getRowClasses());
    }
    if (rowDOM.children("[" + this.IDAttribute + "]").length === 0) {
      rowDOM.addClass("layoutRow_emptyRow");
    } else {
      rowDOM.removeClass("layoutRow_emptyRow");
    }
  }
};
module.exports = BootstrapGridLayoutRender;

},{}],166:[function(require,module,exports){
"use strict";

var BootstarpGridLayoutRender = require('./BootstrapGridLayoutRender.js');
var TableGridLayoutRender = require('./TableGridLayoutRender.js');
var Layout = require('../../UIProfiles/js/Layout.js');
var CompassLayoutRender = function CompassLayoutRender(pParent, pIDAttribute, pIDPrefix) {
  this.element = pParent;
  this.IDAttribute = pIDAttribute;
  if (typeof pIDPrefix === "string") {
    this.IDPrefix = pIDPrefix;
  } else {
    this.IDPrefix = "";
  }
  this._centerDOM;
  this._centerLayoutRender;
};
CompassLayoutRender.prototype = {
  constructor: CompassLayoutRender,
  _setRenderOptions: function _setRenderOptions(pRenderOptions, pParameters) {
    var options = Object.assign({
      "pageClasses": "cf-page",
      "centerClasses": "cf-pagecontent",
      "northClasses": "",
      "eastClasses": "",
      "southClasses": "cf-bottombar",
      "westClasses": "",
      "centerNoWestClasses": "cf-pagecontent cf-pagecontent-fullwidth",
      "centerRenderOptions": {}
    }, pRenderOptions);
    if (pParameters.getCenter().getType() === Layout.type.COMPASS) {
      options.centerRenderOptions = Object.assign({
        "pageClasses": "",
        "centerClasses": "cf-settingslist-contentpage"
      }, options.centerRenderOptions);
    }
    return options;
  },
  /**
   * @description Render the layout according to the options
   * @function
   * @private
   * @param {pRowParameters} pParameters 
   * @param {pObject} pRenderOptions 
   */
  render: function render(pParameters, pRenderOptions) {
    // merge options with defaults
    var options = this._setRenderOptions(pRenderOptions, pParameters);
    var container = this.element.addClass('layouttype_compass').addClass(options.pageClasses);
    if (pParameters.getNorth() !== null) {
      var north = $('<div>').addClass("layoutcompass_north").addClass(options.northClasses);
      var id = typeof pParameters.getNorth().getID() === "string" ? this.IDPrefix + pParameters.getNorth().getID() : pParameters.getNorth().getID();
      north.attr(this.IDAttribute, id);
      container.append(north);
      if (pParameters.isShowNorth() === false) {
        north.addClass("layoutcompass_notshow");
      }
    }
    if (pParameters.getWest() !== null) {
      var west = $('<div>').addClass("layoutcompass_west").addClass(options.westClasses);
      var id = typeof pParameters.getWest().getID() === "string" ? this.IDPrefix + pParameters.getWest().getID() : pParameters.getWest().getID();
      west.attr(this.IDAttribute, id);
      container.append(west);
      if (pParameters.isShowWest() === false) {
        west.addClass("layoutcompass_notshow");
      }
    }
    this._centerDOM = $('<div>').addClass("layoutcompass_center").addClass(options.centerClasses);
    container.append(this._centerDOM);
    if (pParameters.getCenter() !== null) {
      if (pParameters.getCenter() instanceof Layout) {
        if (pParameters.getCenter().getType() === Layout.type.BOOTSTRAPGRID) {
          this._centerLayoutRender = new BootstarpGridLayoutRender(this._centerDOM, this.IDAttribute, this.IDPrefix);
          this._centerLayoutRender.render(pParameters.getCenter().getParameters(), options.centerRenderOptions);
        } else if (pParameters.getCenter().getType() === Layout.type.TABLEGRID) {
          this._centerLayoutRender = new TableGridLayoutRender(this._centerDOM, this.IDAttribute, this.IDPrefix);
          this._centerLayoutRender.render(pParameters.getCenter().getParameters(), options.centerRenderOptions);
        } else if (pParameters.getCenter().getType() === Layout.type.COMPASS) {
          this._centerLayoutRender = new CompassLayoutRender(this._centerDOM, this.IDAttribute, this.IDPrefix);
          this._centerLayoutRender.render(pParameters.getCenter().getParameters(), options.centerRenderOptions);
        } else if (pParameters.getCenter().getType() === Layout.type.CUSTOM) {
          throw new Error("custom type not supported yet");
          this._centerLayoutRender.render(pParameters.getCenter().getParameters(), options.centerRenderOptions);
        } else {
          throw new Error("unknown layout type found");
        }
      }
    }
    if (pParameters.getEast() !== null) {
      var east = $('<div>').addClass("layoutcompass_east").addClass(options.eastClasses);
      var id = typeof pParameters.getEast().getID() === "string" ? this.IDPrefix + pParameters.getEast().getID() : pParameters.getEast().getID();
      east.attr(this.IDAttribute, id);
      container.append(east);
      if (pParameters.isShowEast() === false) {
        east.addClass("layoutcompass_notshow");
      }
    }
    if (pParameters.getSouth() !== null) {
      var south = $('<div>').addClass("layoutcompass_south").addClass(options.southClasses);
      var id = typeof pParameters.getSouth().getID() === "string" ? this.IDPrefix + pParameters.getSouth().getID() : pParameters.getSouth().getID();
      south.attr(this.IDAttribute, id);
      container.append(south);
      if (pParameters.isShowSouth() === false) {
        south.addClass("layoutcompass_notshow");
      }
    }
  },
  addElement: function addElement(pDOMElement, pID) {
    // search for the place, empty it (because it could be filled with previous data)
    // so last will overwrite and win, append then
    var id = typeof pID === "string" ? this.IDPrefix + pID : pID;
    return this.element.find("[" + this.IDAttribute + "='" + id + "']").first().empty().append(pDOMElement);
  },
  getElement: function getElement(pID) {
    var id = typeof pID === "string" ? this.IDPrefix + pID : pID;
    return this.element.find("[" + this.IDAttribute + "='" + id + "']").first().children();
  },
  getFieldElements: function getFieldElements() {
    return this._centerDOM.children(".layoutRow").children(".layoutComponent").children(".formGroup.fieldElement");
  },
  showErrorMessages: function showErrorMessages(pMessages) {
    return this._centerDOM.children(".layoutRow").children(".layoutComponent").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage('showErrorMessage', pMessages.join('<br/>'));
  },
  hideErrorMessages: function hideErrorMessages() {
    return this._centerDOM.children(".layoutRow").children(".layoutComponent").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage('hideErrorMessages');
  },
  updateRow: function updateRow(pUICoordinates, pParameters, pRenderOptions) {
    var options = this._setRenderOptions(pRenderOptions, pParameters);
    if (typeof pUICoordinates === "string") {
      if (pUICoordinates.indexOf("center_") === 0) {
        var uiCoordinates = pUICoordinates.substring(7);
        this._centerLayoutRender.updateRow(uiCoordinates, pParameters.getCenter().getParameters(), options.centerRenderOptions);
        return;
      }
      var id;
      switch (pUICoordinates) {
        case "north":
          id = typeof pParameters.getNorth().getID() === "string" ? this.IDPrefix + pParameters.getNorth().getID() : pParameters.getNorth().getID();
          this.element.children().eq(0).addClass("layoutcompass_north").addClass(options.northClasses).attr(this.IDAttribute, id);
          break;
        case "west":
          id = typeof pParameters.getWest().getID() === "string" ? this.IDPrefix + pParameters.getWest().getID() : pParameters.getWest().getID();
          this.element.children().eq(1).addClass("layoutcompass_west").addClass(options.westClasses).attr(this.IDAttribute, id);
          break;
        case "east":
          id = typeof pParameters.getEast().getID() === "string" ? this.IDPrefix + pParameters.getEast().getID() : pParameters.getEast().getID();
          this.element.children().eq(3).addClass("layoutcompass_east").addClass(options.eastClasses).attr(this.IDAttribute, id);
          break;
        case "south":
          id = typeof pParameters.getSouth().getID() === "string" ? this.IDPrefix + pParameters.getSouth().getID() : pParameters.getSouth().getID();
          this.element.children().eq(4).addClass("layoutcompass_south").addClass(options.southClasses).attr(this.IDAttribute, id);
          break;
        default:
          throw new Error("unknown coordinates to update the ui");
      }
    } else if (typeof pUICoordinates === "number") {
      this._centerLayoutRender.updateRow(pUICoordinates, pParameters.getCenter().getParameters(), options.centerRenderOptions);
    }
  }
};
module.exports = CompassLayoutRender;

},{"../../UIProfiles/js/Layout.js":255,"./BootstrapGridLayoutRender.js":165,"./TableGridLayoutRender.js":167}],167:[function(require,module,exports){
"use strict";

/**
 * @constructor TableGridLayoutRender
 * @description The renderer of tablegrid layout
 */
var TableGridLayoutRender = function TableGridLayoutRender(pParent, pIDAttribute, pIDPrefix) {
  this.rowClassRegExp = new RegExp("(^|\\s)(col-|cf-col-)\\S+", "g");
  this.element = pParent;
  this.container;
  this.IDAttribute = pIDAttribute;
  if (typeof pIDPrefix === "string") {
    this.IDPrefix = pIDPrefix;
  } else {
    this.IDPrefix = "";
  }
};
TableGridLayoutRender.prototype = {
  constructor: TableGridLayoutRender,
  /**
   * @description Render the layout according to the options
   * @function
   * @private
   * @param {pRowParameters} pParameters 
   * @param {Object} pRenderOptions 
   */
  render: function render(pLayoutParameters, pRenderOptions) {
    var that = this;
    var disableSkipRef = pRenderOptions.disableRefAttribute ? pRenderOptions.disableRefAttribute : false; //default is on
    this.container = this.element.addClass("container-fluid layouttype_tableGrid").addClass(pLayoutParameters.getRootClasses());
    var tableWidth = pLayoutParameters.getTableWidth();
    var tableHeight = pLayoutParameters.getTableHeight();
    if (pLayoutParameters.getTableLayout().length !== tableWidth * tableHeight) {
      pLayoutParameters.initialiseRows();
    }
    var table = document.createElement("table");
    table.setAttribute("role", "none");
    for (var i = 0; i < tableHeight; i++) {
      var row = document.createElement("tr");
      table.append(row);
      for (var j = 0; j < tableWidth; j++) {
        var td = document.createElement("td");
        var container = document.createElement("div");
        td.classList.add("layoutComponent");
        td.append(container);
        row.append(td);
      }
    }
    var components = pLayoutParameters.getTableLayout();
    var toRemove = [];
    for (var _i = 0; _i < components.length; _i++) {
      var pLayoutComponent = components[_i];
      if (pLayoutComponent.isDump() === true && pLayoutComponent.isSkipComponent() === false) {
        continue;
      }
      var yPos = pLayoutComponent.getYPos();
      var xPos = pLayoutComponent.getXPos();
      if (table.rows[yPos] === undefined) {
        console.error("Component " + pLayoutComponent.getID() + " is out of bounds - did not add");
        continue;
      }
      if (table.rows[yPos].cells[xPos] === undefined) {
        console.error("Component " + pLayoutComponent.getID() + " is out of bounds - did not add");
        continue;
      }
      var cellToInsertInto = table.rows[yPos].cells[xPos];
      if (Array.from(cellToInsertInto.classList).includes("skipCell") === true) {
        console.error("Component " + pLayoutComponent.getID() + " is obstructed by another - did not add");
        continue;
      }
      var width = pLayoutComponent.getWidth();
      var height = pLayoutComponent.getHeight();
      if (pLayoutComponent.isSkipComponent() === true) {
        if (disableSkipRef === true) {
          //no need to show the skipcells
          toRemove.push(cellToInsertInto);
        }
        cellToInsertInto.setAttribute("data-reference-element", this.IDPrefix + pLayoutComponent.getSkipReference());
        cellToInsertInto.classList.add("skipCell");
      } else {
        //make space for the layoutComponents;
        cellToInsertInto.removeChild(cellToInsertInto.querySelector("div"));
        var _container = document.createElement("div");
        _container.setAttribute(this.IDAttribute, this.IDPrefix + pLayoutComponent.getID());
        cellToInsertInto.append(_container);
        cellToInsertInto.setAttribute("colSpan", width);
        cellToInsertInto.setAttribute("rowSpan", height);
      }
      cellToInsertInto.classList.add("layoutComponent");
    }
    toRemove.forEach(function (pRemove) {
      pRemove.remove();
    });
    table.querySelectorAll("tr").forEach(function (pRow) {
      pRow.classList.add("row", "layoutRow", "cf-children-overflow" + pLayoutParameters.getChildrenOverflow());
      if (pLayoutParameters.getRowClasses() !== null && pLayoutParameters.getRowClasses() !== undefined) {
        pRow.classList.add(pLayoutParameters.getRowClasses());
      }
    });
    this.container.append(table);
  },
  addElement: function addElement(pDOMElement, pID) {
    // search for the place, empty it (because it could be filled with previous data)
    // so last will overwrite and win, append then
    var id = typeof pID === "string" ? this.IDPrefix + pID : pID;
    return this.element.find("[" + this.IDAttribute + "='" + id + "']").first().empty().append(pDOMElement);
  },
  getElement: function getElement(pID) {
    var id = typeof pID === "string" ? this.IDPrefix + pID : pID;
    return this.element.find("[" + this.IDAttribute + "='" + id + "']").first().children();
  },
  getFieldElements: function getFieldElements() {
    return this.container.children(".layoutRow").children(".layoutComponent").children(".formGroup.fieldElement");
  },
  showErrorMessages: function showErrorMessages(pMessages) {
    return this.container.children(".layoutRow").children(".layoutComponent").children(".formGroup").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage("showErrorMessage", pMessages.join("<br/>"));
  },
  hideErrorMessages: function hideErrorMessages() {
    return this.container.children(".layoutRow").children(".layoutComponent").children(".formGroup").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage("hideErrorMessages");
  },
  updateRow: function updateRow(pRowIndex, pParameters, pRenderOptions) {
    var layout = pParameters;
    var yPos = pRowIndex;
    var that = this;
    var layoutComponent = undefined;
    var rowDOM = this.container.children("table").children(".row.layoutRow").eq(pRowIndex);
    rowDOM.children(".layoutComponent").each(function (index, pElement) {
      // if (Array.from(pElement.classList).includes("skipCell") === true) {
      //     return true;
      // }
      var xPos = index;
      layoutComponent = layout.getElement(yPos, xPos);
      if ($(this).find("[data-id]").length > 0) {
        $(this).find("[data-id]").attr(that.IDAttribute, typeof layoutComponent.getID() === "string" ? that.IDPrefix + layoutComponent.getID() : layoutComponent.getID());
      } else {
        $(this).empty();
        $(this).append($("<div>").attr(that.IDAttribute, typeof layoutComponent.getID() === "string" ? that.IDPrefix + layoutComponent.getID() : layoutComponent.getID()));
      }
      if (layoutComponent.isSkipComponent() === true) {
        $(this).addClass("skipCell").attr("data-reference-element", layoutComponent.getSkipReference());
      } else {
        $(this).removeClass("skipCell").removeAttr("data-reference-element");
      }
      $(this).removeClass(function (classindex, className) {
        return (className.match(that.rowClassRegExp) || []).join(" ");
      });
      if (layoutComponent.isSkipComponent() === false && layoutComponent.isDump() === false) {
        $(this).attr("colspan", layoutComponent.getWidth());
        $(this).attr("rowspan", layoutComponent.getHeight());
      }
    });
    if (typeof pParameters.getRowClasses() === "string" && pParameters.getRowClasses().length > 0) {
      rowDOM.addClass(pParameters.getRowClasses());
    }
    if (rowDOM.find(".layoutComponent div[" + this.IDAttribute + "]").length === 0) {
      rowDOM.addClass("layoutRow_emptyRow");
    } else {
      rowDOM.removeClass("layoutRow_emptyRow");
    }
  }
};
module.exports = TableGridLayoutRender;

},{}],168:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  require("../../../polyfill/polyfill.js");
  var Form = require("../../UIProfiles/js/Form.js");
  var FormElement = require("../../UIProfiles/js/FormElement.js");
  var Field = require("../../UIProfiles/js/Field.js");
  var FormAction = require("../../UIProfiles/js/FormAction.js");
  var WebFramework = require("../../UIProfiles/js/WebFramework.js");
  require("./nixps-cloudflow-FormSectionList.js");
  require("./nixps-cloudflow-LayoutRenderer.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  var regExpVariable = new RegExp("^\\${[^}]*}$");
  var kInputsElementSelector = "input,select,textarea,[contenteditable=true],[contenteditable=plaintext-only]";
  function makeComponent(pFormElement, pParent, pOptions) {
    var formComponent = $("<div>").data("componentOptions", pFormElement.getElement()).addClass("componentElement");
    if (pParent) {
      pParent.append(formComponent);
    }
    try {
      var formElementOptions = pFormElement.getElement().getOptions();
      formElementOptions.language = pOptions.language;
      if (pOptions.disabled === true) {
        formElementOptions.disabled = true;
      }
      var framwork = pFormElement.getElement().getWidgetFramework();
      if (framwork !== null && framwork !== WebFramework.type.JQUERY_UI) {
        WebFramework.constructLive(framwork, formComponent[0], pFormElement.getElement().getType(), formElementOptions);
      } else {
        formComponent[pFormElement.getElement().getType()](formElementOptions);
      }
    } catch (pError) {
      console.error(pError);
      if (pParent) {
        pParent.addClass("errorState");
      }
    }
    return formComponent;
  }
  function makeField(pField, pParent, pOptions) {
    if (!(pField instanceof Field)) {
      throw new Error("makeField: inputparameter must be a field");
    }
    var type = pField.getComponent().getType();
    var framework = pField.getComponent().getWidgetFramework();
    if (WebFramework.isPresent(framework, type) === false) {
      console.error("Form: missing include for widget " + type);
    }
    var options;
    switch (type) {
      case "ValueInput":
        options = pField.getComponent().getOptions();
        options.createInput = true;
        break;
      case "FormListItemRepeater":
        options = pField.getComponent().getOptions();
        options.variableDictionary = pOptions.variableDictionary;
        options.startUpOldOptions = pOptions.startUpOldOptions;
        break;
      case "RIPEditorPresets":
        options = pField.getComponent().getOptions();
        if (pOptions && pOptions.startUpOldOptions && _typeof(pOptions.startUpOldOptions) === "object" && Object.keys(pOptions.startUpOldOptions).length > 0) {
          if (options.whitepaper === undefined) {
            options.whitepaper = pOptions.startUpOldOptions.whitepaper;
          }
          if (options.whitepaper_input_name === undefined) {
            options.whitepaper_input_name = pOptions.startUpOldOptions.whitepaperInputName;
          }
        }
        break;
      case "DatetimeSelector":
      case "CalendarSelectorWConnector":
        options = pField.getComponent().getOptions();
        if (options !== undefined && options.format === null && typeof pOptions.dateFormat === "string" && pOptions.dateFormat.length > 0) {
          options.format = pOptions.dateFormat;
        }
        break;
      default:
        options = pField.getComponent().getOptions();
        break;
    }
    var tagName = framework === WebFramework.type.NATIVE_WEBCOMPONENT ? type : "div";
    var component = $("<" + tagName + ">").addClass("component");
    if (options.disabled === true) {
      component.addClass("formrendererDisabledByCreation");
    }
    if (framework === WebFramework.type.NATIVE_WEBCOMPONENT) {
      if (pOptions.disabled === true) {
        component[0].disabled = true;
      }
    } else {
      options.language = pOptions.language;
      if (pOptions.disabled === true) {
        options.disabled = true;
      }
      options.required = pField.isRequired();
    }
    pParent.append(component);
    try {
      if (framework === WebFramework.type.NATIVE_WEBCOMPONENT) {
        component[0].nixpsSetOptions(options);
      } else {
        component = component[type](options);
      }
      pParent.removeClass("errorState");
    } catch (error) {
      console.error(error);
      pParent.addClass("errorState");
    }
    component.addClass("componentContainer");
    return component;
  }
  ;
  function getValueOfField(pField, pComponent) {
    if (!(pField instanceof Field)) {
      throw new Error("getValueOfField: input parameter pField must be a field");
    }
    var value;
    var type = pField.getComponent().getType();
    var framework = pField.getComponent().getWidgetFramework();
    if (framework === WebFramework.type.NATIVE_WEBCOMPONENT) {
      value = pComponent[0].nixpsGetValue();
    } else {
      value = pComponent[type]("getValue");
    }
    return value;
  }
  ;
  function setValueOfField(pField, pComponent, pNewValue) {
    if (!(pField instanceof Field)) {
      throw new Error("setValueOfField: input parameter pField must be a field");
    }
    if (pNewValue !== undefined) {
      try {
        var type = pField.getComponent().getType();
        var framework = pField.getComponent().getWidgetFramework();
        if (framework === WebFramework.type.NATIVE_WEBCOMPONENT) {
          pComponent[0].nixpsSetValue(pNewValue);
        } else {
          switch (type) {
            case "InteractionSelect":
              var fullwidgetname = pField.getComponent().getWidgetFullName();
              if (pComponent.data(fullwidgetname).backwardsCompatibilityMode === true) {
                var rootKeyValue = CloudflowObject.getParameter(pNewValue, pField.getComponent().getOptions().rootKey);
                var childKeyValue = CloudflowObject.getParameter(pNewValue, pField.getComponent().getOptions().childKey);
                if (rootKeyValue === undefined && childKeyValue === undefined) {
                  // complete object is passed through, but no concrete value has been found,
                  // do not update interaction select
                  return false;
                }
                var newValueObj = {};
                newValueObj = CloudflowObject.setParameter(newValueObj, pField.getComponent().getOptions().rootKey, rootKeyValue);
                newValueObj = CloudflowObject.setParameter(newValueObj, pField.getComponent().getOptions().childKey, childKeyValue);
                pComponent[type]("setValue", newValueObj);
              } else {
                pComponent[type]("setValue", pNewValue);
              }
              break;
            default:
              pComponent[type]("setValue", pNewValue);
              break;
          }
        }
        pComponent.parent().removeClass("errorState");
        return true;
      } catch (error) {
        console.error(error);
        pComponent.parent().addClass("errorState");
      }
    } else {
      throw new Error("the new value must be defined");
    }
  }
  ;
  function checkValidity(pType) {
    switch (pType) {
      case "ValueInput":
        return false;
      default:
        return true;
    }
  }
  var kBootstarpClassMode = "sm-Mode";
  var kComponentBootstrapClass = "col-sm-12 cf-col-sm-12";
  var kFieldLabelSyncStateDataKey = "expressionBuilderVariableInputFieldLabelState";

  /**
   * @namespace nixps-cloudflow.FormRenderer
   * @description Build a form. This form will have a correct form and DOM structure. Where the css can be applied automatically. 
   * You provide a json "formJSON", that represents the objects who must be drawn. There is also a layout option to
   * overwrite the positions of the form elements. This component provides you a way to retrieve all the data "getValues", as an object, inject an object as "setValues".
   * Handles validation, if the subcomponent has "isValid" function, this will be called, or looks to the required field in the formJSON
   * @version 1.10.0
   */
  $.widget("nixps-cloudflow.FormRenderer", $.Widget, {
    version: "1.10.0",
    widgetEventPrefix: "formrenderer",
    options: {
      /**
       * @description The data source to build our form
       * @name nixps-cloudflow.FormRenderer#formJSON
       * @type JSONObject
       * @default {}
       * @required
       */
      formJSON: {},
      /**
       * @description The data source to the layout, position the elements of the form
       * @name nixps-cloudflow.FormRenderer#layoutJSON
       * @type JSONObject
       * @default null
       */
      layoutJSON: null,
      /**
       * @description A custom layout renderer class
       * @name nixps-cloudflow.FormRenderer#layoutRender
       * @private
       * @type {Class}
       * @default null
       * @since 1.6.0
       */
      layoutRender: null,
      /**
       * @description The options to render the layout
       * @name nixps-cloudflow.FormRenderer#layoutRenderOptions
       * @private
       * @type {Object}
       * @default {}   
       * @since 1.8.0
       */
      layoutRenderOptions: {
        table_of_contents: true
        // table_of_contents: undefined
      },

      /**
       * @desc Options for compatibility old format
       * @name nixps-cloudflow.FormRenderer#startUpOldOptions
       * @type {Object}
       * @private
       * @default {}
       */
      startUpOldOptions: {},
      /**
       * @description The dictionary containing all the variables and there values
       * @name nixps-cloudflow.FormRenderer#variableDictionary
       * @type {Object}
       * @default {}
       */
      variableDictionary: {},
      /**
       * @description Must we add classes for bootstrap use?
       * @name nixps-cloudflow.FormRenderer#useBootstrap
       * @type {Boolean}
       * @default true
       */
      useBootstrap: true,
      /**
       * @description Must we use some extended Bootstrap classes for help texts and labels?
       * @name nixps-cloudflow.FormRenderer#useExtendBoodstrap
       * @type {Boolean}
       * @default true
       */
      useExtendBoodstrap: true,
      /**
       * @description Function runs when submit event is fired. So default prevent default.
       * This indicates that, when pressing enter the page will not submit. Change this option to do something else!
       * The return of this function will become the return on the submit function.
       * @name nixps-cloudflow.FormRenderer#submitCallBackFunction
       * @type {Function} 
       * @default function(){return false;}
       * @returns {Boolean}
       */
      submitCallBackFunction: function submitCallBackFunction(pReason) {
        return false;
      },
      /**
       * @description The language of the user, compatible with moment plugins. This will be given to each component who need the language
       * of the user. If plugin moment is available the language will be applied to
       * @name nixps-cloudflow.FormRenderer#language
       * @type {String}
       * @default "en"
       * @example "nl"
       */
      language: "en",
      /**
       * @description The preferences to display the date
       * @name nixps-cloudflow.FormRenderer#dateFormat
       * @type {String}
       * @default null
       * @since 1.3.1
       */
      dateFormat: null,
      /**
       * @description The form classes to be added to the form tag
       * @name nixps-cloudflow.FormRenderer#formClasses
       * @type {String}
       * @default 
       * @since 1.7.0
       */
      formClasses: "",
      /**
       * @description A custom class name, separated by spaces to be added to the formGroup
       * @name nixps-cloudflow.FormRenderer#formGroupClasses
       * @type {String}
       * @default ""
       * @since 1.2.3
       */
      formGroupClasses: "",
      /**
       * @description Must we keep validation and updating ui after change events, or not,
       * @name nixps-cloudflow.FormRenderer#keepValidating
       * @type {Boolean}
       * @default true
       * @since 1.2
       */
      keepValidating: true,
      /**
       * @description What must we do with the values given by hidden fields? Use false to not retrieve those filed values or "null" to return null
       * or "current" to return the actual value  
       * @name nixps-cloudflow.FormRenderer#returnActionHiddenFields
       * @type {mixed}
       * @default false
       * @example "current"
       * @example "null"
       * @since 1.5.0
       */
      returnActionHiddenFields: false,
      /**
       * @description Must we apply actions on hidden fields, hidden by actions during creation?
       * @name nixps-cloudflow.FormRenderer#applyActionOnHiddenFieldDuringInit
       * @type {Boolean}
       * @default true
       * @since 1.10.0
       */
      applyActionOnHiddenFieldDuringInit: true,
      /**
       * @description The time in milliseconds to be given as argument to the throttle function
       * @name nixps-cloudflow.FormRenderer#throttleTime
       * @type {Number}
       * @default 600
       * @since 1.2.3
       */
      throttleTime: 600,
      /**
       * @description Class to be applied on label
       * @name nixps-cloudflow.FormRenderer#labelBootstrapClass
       * @type {String}
       * @default "cf-col-sm-4 col-sm-4"
       * @since 1.4.0
       */
      labelBootstrapClass: "cf-col-sm-4 col-sm-4",
      /**
       * @description Class to be applied on input
       * @name nixps-cloudflow.FormRenderer#inputBootstrapClass
       * @type {String}
       * @default "cf-col-sm-8 col-sm-8"
       * @since 1.4.0
       */
      inputBootstrapClass: "cf-col-sm-8 col-sm-8",
      /**
       * @description Class to be applied on help texts
       * @name nixps-cloudflow.FormRenderer#helptextBootstrapClass
       * @type {String}
       * @default "col-sm-8 col-sm-offset-4 cf-col-sm-8 cf-col-sm-offset-4"
       * @since 1.9.0
       */
      helptextBootstrapClass: "col-sm-8 col-sm-offset-4 cf-col-sm-8 cf-col-sm-offset-4",
      /**
       * @name nixps-cloudflow.CloudflowBar#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       * @since 1.3.0
      */
      style_type: "default"
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type);
      // false: has user want a validation?
      // put on true, if user has tried to fill in the form already
      this.validationFase = false;
      this.useBoodstrap = this.options.useBootstrap;
      this.form; // the form in interface of the Form object
      this.formJSON; // see function makeDeepCopyOfInputs
      this.validLayout = false;
      this.blockChangeEvents = false; // flag indication must block change events
      this.isDrawing = false; // is the element drawing?
      this.alive = true; // is alive or not
      this.lastTimeStapSubmit = 0; // the timeStamp of the last submit event

      // make deep copy
      this._makeDeepCopyOfInputs();
      // translate the variables
      this._translateVariables();
      this._draw();
      if (typeof window._ === "function") {
        if (this.options.throttleTime >= 0) {
          this.changeHandler = _.throttle(this._changeHandler, this.options.throttleTime);
        } else {
          // allow to set negative values, to disable throttleing, for strange architectures ....
          this.changeHandler = this._changeHandler;
        }
      } else {
        console.warn("for performance reasons please include underscore js plugin");
        this.changeHandler = this._changeHandler;
      }
      this._on(this.element, {
        "change .formGroup.fieldElement": this.changeHandler,
        // selects, checkbox and radio will pass here
        "input .formGroup.fieldElement [contenteditable='true']": this.changeHandler,
        "input .formGroup.fieldElement [contenteditable='plaintext-only']": this.changeHandler,
        "input .formGroup.fieldElement input[type!=checkbox][type!=radio]": this.changeHandler,
        "input .formGroup.fieldElement textarea": this.changeHandler,
        "fieldcustomchange .formGroup.fieldElement": this.changeHandler,
        "expressionbuildervariableinputdisplaymodechange .formGroup.fieldElement": this._expressionBuilderVariableInputDisplayModeChangeHandler,
        "datetimeselectorchange .formGroup.fieldElement": this.changeHandler,
        "autofillchange .formGroup.fieldElement": this.changeHandler,
        "autofillselect .formGroup.fieldElement": this.changeHandler,
        "arrayinputchange .formGroup.fieldElement": this.changeHandler,
        "change .fieldElement .showHideContainer .toggleOptionCheckbox": this._toggleHideabelFieldHandler,
        "submit": this._submitPageHandler,
        "keydown input.cf-form-control": this._keydownHandler,
        "click label.cf-form-label:not([for])": this._clickLabelHandler,
        "fieldcutomprefillfields .formGroup.fieldElement": this._prefillFieldsHandler,
        "input .formrenderer_informAutoChange": this._prefilledFieldChangedHandler,
        "change .formrenderer_informAutoChange": this._prefilledFieldChangedHandler
      });
    },
    /**
     * @name nixps-cloudflow.FormRenderer#redraw
     * @function
     * @description Redraw the form
     */
    redraw: function redraw() {
      var focusID = null;
      var focusDOM = this.element.find(":focus");
      if (focusDOM.length > 0) {
        focusID = focusDOM.closest("[data-id]").attr("data-id");
      }
      this._draw();
      if (typeof focusID === "string" && focusID.length > 0) {
        this.element.find("[data-id='" + focusID + "']").find(kInputsElementSelector).first().trigger("focus");
      }
    },
    /**
     * @brief draws the dialog according to the current state
     * @private
     * @fucntion
     * @name nixps-cloudflow.FormRenderer#_draw
     */
    _draw: function _draw() {
      this.isDrawing = true;
      this.element.empty();
      if (this.formJSON === undefined || $.isEmptyObject(this.formJSON)) {
        // if options is missing, create empty form;
        return;
      } else if (Array.isArray(this.formJSON)) {
        // if old format is injected
        this.form = Form.translateOldFormat(this.formJSON, this.options.startUpOldOptions);
      } else if (!$.isEmptyObject(this.formJSON)) {
        // new format
        this.form = Form.fromJSON(this.formJSON);
      } else {
        // we do not know what to do?
        throw new Error("invalid inputparameter formJSON");
      }
      // form 
      var formContainer = $("<form>").addClass("formContainer").addClass(this.options.formClasses).attr("method", "post");
      this.element.append(formContainer);
      formContainer.LayoutRenderer({
        layout: this.options.layoutJSON,
        layoutRender: this.options.layoutRender,
        renderOptions: this.options.layoutRenderOptions
      });
      this.validLayout = formContainer.LayoutRenderer("isLayoutValid");
      var formElement = undefined,
        formGroup = undefined,
        addedForms = undefined,
        field = undefined,
        specialFormElements = [];
      for (var i = 0; i < this.form.getElements().length; i++) {
        formElement = this.form.getElements()[i];
        if (formElement.getCreationRequirement() !== null) {
          specialFormElements.push(formElement);
          // to be rendered later
          continue;
        }
        formGroup = $("<div>").addClass("formGroup cf-form-group " + this.options.formGroupClasses).hide();
        addedForms = formContainer.LayoutRenderer("addElement", formGroup, formElement.getComponentID());
        if (addedForms.length === 0) {
          // the item is not visible, so do not render it!
          continue; //continue loop
        }

        if (formElement.getType() === "component") {
          makeComponent(formElement, formGroup, this.options);

          // boodstrap class
          if (this.useBoodstrap === true) {
            formGroup.addClass("row").children().addClass(kComponentBootstrapClass);
          }
          formGroup.css("display", "");

          // set the customized style
          this._setCustomStyle(formGroup, formElement);
        } else if (formElement.getType() === "field") {
          field = formElement.getElement();

          // create group
          formGroup.data("inputFieldOptions", field).addClass("fieldElement");
          if (field.isRequired() === true) {
            formGroup.addClass("requiredComponent cf-form-required");
          }

          // hideable constructions
          if (field.isHideable() === true) {
            var optionalContainer = $("<div>").addClass("showHideContainer");
            var toggleFieldCheckBox = $("<input>").attr("type", "checkbox").addClass("toggleOptionCheckbox").prop("checked", field.getHideOptions().showOnStart);
            optionalContainer.append(toggleFieldCheckBox);
            optionalContainer.append($("<label>").addClass("cf-form-label toggleOptionLabel").text(field.getHideOptions().hidetext));
            formGroup.append(optionalContainer);
          }

          // component
          var component = makeField(field, formGroup, this.options);

          // label
          var labelDOM = undefined;
          if (typeof field.getLabel() === "string" && field.getLabel().length > 0) {
            labelDOM = $("<label>").addClass("cf-form-label").text(_.unescape(field.getLabel()));
            var options = field.getComponent().getOptions();
            if (typeof options.id === "string" && options.id.length > 0) {
              if (options.id.indexOf(" ") > 0) {
                labelDOM.attr("aria-labelledby", options.id.trim());
              } else {
                labelDOM.attr("for", options.id.trim());
              }
            }
            formGroup.prepend(labelDOM);
          }

          //      hide if options is hideable and we want to hide on start    
          if (field.isHideable() === true && field.getHideOptions().showOnStart === false) {
            if (labelDOM !== undefined) {
              labelDOM.hide();
            }
            component.hide();
          }

          // help text
          if (field.getHelptext().length > 0) {
            formGroup.append($("<span>").addClass("cf-form-helptext").text(_.unescape(field.getHelptext())));
          }

          // boodstrap class
          if (this.useBoodstrap === true) {
            component.find("input[type!=checkbox][type!=radio], select, textarea").not(".no-form-control").addClass("form-control cf-form-control");
            if (this.options.useExtendBoodstrap === true) {
              formGroup.addClass("from-group row " + kBootstarpClassMode).children(".cf-form-helptext").addClass("help-block " + this.options.helptextBootstrapClass);
              formGroup.children("label").filter(function () {
                return $(this).siblings(".componentContainer").length > 0;
              }).addClass(this.options.labelBootstrapClass).siblings(".componentContainer").addClass(this.options.inputBootstrapClass);
            }
          }
          this._syncExpressionBuilderVariableInputFieldLabel(formGroup, null, true);
          formGroup.attr("data-key", field.getKey()).css("display", "");

          // set the customized style
          this._setCustomStyle(formGroup, formElement);
          // init the form actions
          this._preparationActions(formGroup, formElement);
        } else {
          throw new Error("invalid formelement type");
        }
      }
      if (this.validLayout === true && this.options.layoutRenderOptions !== undefined && this.options.layoutRenderOptions.table_of_contents === true) {
        for (var i = 0; i < specialFormElements.length; i++) {
          if (specialFormElements[i].getType() === "component") {
            if (specialFormElements[i].getElement().getOption("contentPage") === undefined) {
              specialFormElements[i].getElement().addOption("contentPage", formContainer);
            }
            formContainer.LayoutRenderer("addElement", makeComponent(specialFormElements[i], null, this.options), specialFormElements[i].getComponentID());
          }
        }
      }
      this.isDrawing = false;
      this._initActions();
    },
    _setCustomStyle: function _setCustomStyle(pDomElement, formElement) {
      pDomElement.removeClass("form_styled");
      if (formElement.hasBackground()) {
        pDomElement.css("background", formElement.getBackground()).addClass("form_styled");
      } else {
        pDomElement.css("background", "");
      }
      if (formElement.hasFontColor()) {
        pDomElement.css("color", formElement.getFontColor()).addClass("form_styled");
      } else {
        pDomElement.css("color", "");
      }
    },
    _expressionBuilderVariableInputDisplayModeChangeHandler: function _expressionBuilderVariableInputDisplayModeChangeHandler(pEvent, pData) {
      var fieldElement = $(pEvent.target).closest(".formGroup.fieldElement");
      if (fieldElement.length === 1) {
        this._syncExpressionBuilderVariableInputFieldLabel(fieldElement, pData, false);
      }
    },
    _syncExpressionBuilderVariableInputFieldLabel: function _syncExpressionBuilderVariableInputFieldLabel(pFieldElement, pDisplayModeData, pResetOriginalState) {
      if (!(pFieldElement instanceof $) || pFieldElement.length !== 1) {
        return;
      }
      var field = pFieldElement.data("inputFieldOptions");
      if (!(field instanceof Field) || field.getComponent().getType() !== "ExpressionBuilderVariableInput") {
        return;
      }
      var component = pFieldElement.children(".component").first();
      if (component.length !== 1 || component.data("nixps-cloudflow-ExpressionBuilderVariableInput") === undefined) {
        return;
      }
      if (pResetOriginalState === true) {
        pFieldElement.removeData(kFieldLabelSyncStateDataKey);
      }
      var originalLabelState = this._getExpressionBuilderVariableInputOriginalLabelState(pFieldElement);
      var displayModeData = pDisplayModeData || this._getExpressionBuilderVariableInputDisplayModeData(component);
      if (displayModeData === null || this._isBlankFieldLabel(originalLabelState.label) === false) {
        this._restoreExpressionBuilderVariableInputFieldLabel(pFieldElement, originalLabelState);
        return;
      }
      if (displayModeData.shouldMirrorFieldLabel === true && displayModeData.displayMode === "expressionbuilder") {
        this._setExpressionBuilderVariableInputFieldLabel(pFieldElement, displayModeData.checkboxLabel);
      } else {
        this._restoreExpressionBuilderVariableInputFieldLabel(pFieldElement, originalLabelState);
      }
    },
    _getExpressionBuilderVariableInputDisplayModeData: function _getExpressionBuilderVariableInputDisplayModeData(pComponent) {
      if (!(pComponent instanceof $) || pComponent.length !== 1) {
        return null;
      }
      var widgetInstance = pComponent.data("nixps-cloudflow-ExpressionBuilderVariableInput");
      if (widgetInstance === undefined || typeof widgetInstance.getDisplayMode !== "function") {
        return null;
      }
      var componentJSON = pComponent.ExpressionBuilderVariableInput("option", "componentJSON");
      var checkboxLabel = "";
      if (componentJSON && componentJSON.options && typeof componentJSON.options.checkboxLabel === "string") {
        checkboxLabel = componentJSON.options.checkboxLabel;
      }
      var showCheckboxLabel = pComponent.ExpressionBuilderVariableInput("option", "showCheckboxLabel") === true;
      return {
        displayMode: pComponent.ExpressionBuilderVariableInput("getDisplayMode"),
        showCheckboxLabel: showCheckboxLabel,
        checkboxLabel: checkboxLabel,
        shouldMirrorFieldLabel: showCheckboxLabel === true && checkboxLabel.trim().length > 0
      };
    },
    _getExpressionBuilderVariableInputOriginalLabelState: function _getExpressionBuilderVariableInputOriginalLabelState(pFieldElement) {
      var state = pFieldElement.data(kFieldLabelSyncStateDataKey);
      if (state && _typeof(state) === "object") {
        return state;
      }
      var field = pFieldElement.data("inputFieldOptions");
      state = {
        label: field.getLabel(),
        hadLabelNode: pFieldElement.children("label").length > 0
      };
      pFieldElement.data(kFieldLabelSyncStateDataKey, state);
      return state;
    },
    _isBlankFieldLabel: function _isBlankFieldLabel(pLabel) {
      return typeof pLabel === "string" && pLabel.trim().length === 0;
    },
    _createFieldLabelDOM: function _createFieldLabelDOM(pFieldElement, pLabelText) {
      var field = pFieldElement.data("inputFieldOptions");
      var labelText = typeof pLabelText === "string" ? pLabelText : "";
      var labelDOM = $("<label>").addClass("cf-form-label").text(_.unescape(labelText));
      var options = field.getComponent().getOptions();
      if (typeof options.id === "string" && options.id.length > 0) {
        if (options.id.indexOf(" ") > 0) {
          labelDOM.attr("aria-labelledby", options.id.trim());
        } else {
          labelDOM.attr("for", options.id.trim());
        }
      }
      if (this.useBoodstrap === true && this.options.useExtendBoodstrap === true) {
        labelDOM.addClass(this.options.labelBootstrapClass);
      }
      return labelDOM;
    },
    _setExpressionBuilderVariableInputFieldLabel: function _setExpressionBuilderVariableInputFieldLabel(pFieldElement, pLabelText) {
      var labelDOM = pFieldElement.children("label").first();
      var labelText = typeof pLabelText === "string" ? pLabelText : "";
      if (labelDOM.length === 0) {
        labelDOM = this._createFieldLabelDOM(pFieldElement, labelText);
        pFieldElement.prepend(labelDOM);
      } else {
        labelDOM.text(_.unescape(labelText));
      }
    },
    _restoreExpressionBuilderVariableInputFieldLabel: function _restoreExpressionBuilderVariableInputFieldLabel(pFieldElement, pOriginalLabelState) {
      var labelDOM = pFieldElement.children("label").first();
      var originalLabel = typeof pOriginalLabelState.label === "string" ? pOriginalLabelState.label : "";
      if (pOriginalLabelState.hadLabelNode === true) {
        if (labelDOM.length === 0) {
          labelDOM = this._createFieldLabelDOM(pFieldElement, originalLabel);
          pFieldElement.prepend(labelDOM);
        } else {
          labelDOM.text(_.unescape(originalLabel));
        }
      } else if (labelDOM.length > 0) {
        labelDOM.remove();
      }
    },
    /**
     * @description Add the actions to the elements 
     * @name nixps-cloudflow.FormRenderer#_preparationActions
     * @function
     * @private
     * @param {type} pDomElement
     * @param {type} formElement
     * @return {undefined}
     */
    _preparationActions: function _preparationActions(pDomElement, formElement) {
      if (formElement.hasActions() === true) {
        var actions = formElement.getActionList();
        var formActions = [];
        for (var i = 0; i < actions.getActions().length; i++) {
          if (actions.getActions()[i].getType() === "formAction") {
            formActions.push(actions.getActions()[i].getParameters().toJSON());
          }
        }
        if (formActions.length > 0) {
          // append as json
          pDomElement.data("formactions", formActions);
        }
      }
    },
    /**
     * @description loop over all elements and apply all the the actions
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_initActions
     * @return {undefined}
     */
    _initActions: function _initActions() {
      var that = this;
      if (this.options.applyActionOnHiddenFieldDuringInit === true) {
        this._getFieldElements().each(function () {
          that._applyAction($(this), false);
        });
      } else {
        this._getFieldElements().each(function () {
          if (!FormAction.needToSkip($(this))) {
            that._applyAction($(this), false);
          }
        });
      }
    },
    /**
     * @description the function that runs when the user change something
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_changeHandler
     * @param {object} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _changeHandler: function _changeHandler(pEvent, pData) {
      if (this.isDrawing === true || this.alive === false) {
        // do not change if some drawing is in progress or
        // if component is a zombie
        return;
      }
      this._applyAction($(pEvent.currentTarget).closest(".formGroup.fieldElement"), true);
      // only start automation validation, if user has already tried.
      if (this.options.keepValidating === true && this.validationFase === true) {
        this.isValid();
      }
      if (this.blockChangeEvents !== true) {
        this._trigger("change", pEvent, {});
      }
    },
    /**
     * @desc function show hide options is pressed. Function runs when user press the checkbox to show/hide a field.
     * @name nixps-cloudflow.FormRenderer#_toggleHideabelFieldHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _toggleHideabelFieldHandler: function _toggleHideabelFieldHandler(pEvent, pData) {
      var parent = $(pEvent.currentTarget).parents(".showHideContainer");
      if (parent.children(".toggleOptionCheckbox").is(":checked")) {
        parent.nextAll("label").first().css("display", "");
        var field = parent.nextAll(".componentContainer").first().css("display", "").closest(".fieldElement");
        FormAction.markNeedToSkip(field, false);
      } else {
        parent.nextAll("label").first().hide();
        var field = parent.nextAll(".componentContainer").first().hide().closest(".fieldElement");
        FormAction.markNeedToSkip(field, true);
      }
    },
    /**
     * @description function runs when there is a submit form the form.
     * @name nixps-cloudflow.FormRenderer#_submitPageHandler
     * @function
     * @private
     * @param {object} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _submitPageHandler: function _submitPageHandler(pEvent, pData) {
      this.lastTimeStapSubmit = pEvent.timeStamp;
      // call the callback function and return his returns
      if (typeof this.options.submitCallBackFunction === "function") {
        return this.options.submitCallBackFunction("submit_event");
      }
    },
    /**
     * @description get the keypass actions to catch the barcode scnanner keys
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_keydownHandler
     * @param {Object} pEvent 
     */
    _keydownHandler: function _keydownHandler(pEvent) {
      // try to catch barcode scanners
      if (this.options.disabled !== true && typeof this.options.submitCallBackFunction === "function") {
        if (pEvent.isDefaultPrevented()) {
          return true;
        }
        if (pEvent.keyCode === $.ui.keyCode.ENTER) {
          this._delay(function () {
            if (pEvent.timeStamp < this.lastTimeStapSubmit) {
              // theire was a submit event before, do not call it twice
              return false;
            }
            this.options.submitCallBackFunction("keydown_event");
          });
        } else if (pEvent.keyCode === 10 && pEvent.ctrlKey === true) {
          // press SKIP, is same as ctrl + j
          this._delay(function () {
            if (pEvent.timeStamp < this.lastTimeStapSubmit) {
              // theire was a submit event before, do not call it twice
              return false;
            }
            this.options.submitCallBackFunction("keydown_event");
          });
          // prevent FF to open bookmarks
          pEvent.preventDefault();
        }
      }
    },
    /**
     * @description function runs when user clicked on a label that does not have a "for" attribute
     * to simulate the "for" and "aria-labelledby" attribute 
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_clickLabelHandler  
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _clickLabelHandler: function _clickLabelHandler(pEvent, pData) {
      if ($(pEvent.target).is("label")) {
        var inputDOM;
        // simulate focus click of "aria-labelledby" attribute
        var ids = $(pEvent.target).attr("aria-labelledby");
        if (typeof ids === "string" && ids.length > 0) {
          var _iterator = _createForOfIteratorHelper(ids.split(" ")),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var id = _step.value;
              inputDOM = this.element.find("#" + id + ":visible").filter(kInputsElementSelector);
              if (inputDOM.length > 0) {
                inputDOM.trigger("focus");
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          // simulate click on empty attribute labels
          // do not continue if inputs are inside, in that case the browser will do the work for us
          if ($(pEvent.target).find(kInputsElementSelector).length === 0) {
            $(pEvent.target).closest(".formGroup").find(kInputsElementSelector).filter(":visible").first().trigger("focus");
          }
        }
      }
    },
    /**
     * @description Apply all the actions of that element
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_applyAction
     * @param {type} pFieldElem
     * @param {Boolean} pHasUserInteraction true if the function is called due to user interaction
     * @return {undefined}
     */
    _applyAction: function _applyAction(pFieldElem, pHasUserInteraction) {
      var actions = $(pFieldElem).data("formactions");
      if (Array.isArray(actions) && actions.length > 0) {
        var field = $(pFieldElem).data("inputFieldOptions");
        var newValue = getValueOfField(field, $(pFieldElem).children(".component"));
        var action, componentIDS;
        var targetObject, targetFieldName, componentDOM;
        for (var i = 0; i < actions.length; i++) {
          action = FormAction.fromJSON(actions[i]);
          if (action.getOnUserActionOnly() === true && pHasUserInteraction === false) {
            continue;
          }
          componentIDS = action.getComponentIDs();
          for (var j = 0; j < componentIDS.length; j++) {
            var targetElem = this.element.children(".formContainer").LayoutRenderer("getElement", componentIDS[j]);
            if (targetElem.length !== 1) {
              continue; // break if no field is found
            }

            targetObject = undefined;
            targetFieldName = undefined;
            componentDOM = undefined;
            if (targetElem.hasClass("fieldElement") === true) {
              targetObject = targetElem.data("inputFieldOptions");
              if (targetObject === undefined) {
                continue;
              }
              targetFieldName = targetObject.getComponent().getType();
              componentDOM = targetElem.children(".component");
            } else if (targetElem.hasClass("componentElement") === true) {
              targetObject = targetElem.data("componentOptions");
              if (targetObject === undefined) {
                continue;
              }
              targetFieldName = targetObject.getType();
              componentDOM = targetElem;
            } else if (targetElem.find(".componentElement").length > 0) {
              componentDOM = targetElem.find(".componentElement").eq(0);
              targetObject = componentDOM.data("componentOptions");
              if (targetObject === undefined) {
                continue;
              }
              targetFieldName = targetObject.getType();
            }
            try {
              // console.log("apply action from " + field.getKey() + " apply " +  action.getFunctionName() + " > " + (targetObject.getKey ? targetObject.getKey() : componentIDS[j]));
              var actionResult = action.applyAction(newValue, targetElem, componentDOM, targetFieldName, {
                disabled: this.options.disabled
              });
              if (action.needForBubbling(actionResult)) {
                this._applyAction(targetElem, pHasUserInteraction);
              }
            } catch (e) {
              // prevent other code to stop running
              console.error("FormAction", e);
              if (componentDOM.length === 1) {
                componentDOM.parent().addClass("errorState");
              } else if (targetElem.length === 1) {
                targetElem.closest(".formGroup").addClass("errorState");
              }
            }
          }
        }
      }
    },
    /**
     * @description function runs when the user want to prefill some fields
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_prefillFieldsHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _prefillFieldsHandler: function _prefillFieldsHandler(pEvent, pData) {
      if (pData && pData.prefillObject && $.isEmptyObject(pData.prefillObject) === false) {
        if (this._trigger("beforeprefillfields", pEvent, pData) !== false) {
          this.setValues(pData.prefillObject, true);
          this._trigger("change", pEvent, {});
        }
        pEvent.stopPropagation();
      }
    },
    /**
     * @description function runs when user changed some fields
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_prefilledFieldChangedHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {Boolean}
     */
    _prefilledFieldChangedHandler: function _prefilledFieldChangedHandler(pEvent, pData) {
      $(pEvent.target).closest(".formrenderer_informAutoChange").removeClass("formrenderer_informAutoChange");
      pEvent.stopPropagation();
    },
    /**
     * @description validate the inputs of the user and show the appripiotated messages.
     * @function
     * @name nixps-cloudflow.FormRenderer#isValid
     * @param {Boolean} pReturnErrorMessage if we must return the error messages in state of false 
     * @returns {boolean_string} true if every thing is good you can submit, false is user need to change input.
     */
    isValid: function isValid(pReturnErrorMessage, pHighlightError) {
      var that = this;
      this.validationFase = pHighlightError !== false;
      var errorMessage = "";
      var errorMessagesToShow = [];
      var isFormGood = true;
      var missingField = false;
      // loop over all
      this._getFieldElements().each(function (index, formGroup) {
        var component = $(this).children(".component");
        var field = $(this).data("inputFieldOptions"); // maintain data(), because formaction change the data of DOM to change recuired
        var type = field.getComponent().getType();
        if (that._needToSkip($(formGroup)) === false) {
          var dataType = field.getComponent().getWidgetFullName();
          if (dataType === null) {
            isFormGood = false;
            $(formGroup).addClass("invalidFromGroup cf-form-invalid");
            errorMessage = "unknown component";
            return true;
          }
          // first control if value is there if required
          if (field.isRequired() === true) {
            var value;
            if (typeof component[0].nixpsGetValue === "function") {
              // native web component
              value = component[0].nixpsGetValue();
            } else if (component.data(dataType) && typeof component.data(dataType).getValue === "function") {
              // jquery retrieve
              value = component[type]("getValue");
            } else {
              isFormGood = false;
              $(formGroup).addClass("invalidFromGroup cf-form-invalid");
              errorMessage = "unknown getValue methode";
              return true;
            }
            if (field.isGroup() === true) {
              for (var subKey in value) {
                var subValue = value[subKey];
                var valid = typeof subValue === "string" && subValue.length > 0 || typeof subValue === "number" || !$.isEmptyObject(subValue) || subValue === true || Array.isArray(subValue) && subValue.length > 0;
                if (valid === false) {
                  isFormGood = false;
                  if (pHighlightError !== false) {
                    $(formGroup).addClass("invalidFromGroup cf-form-invalid");
                  }
                  errorMessage = $.i18n._("nixps-cloudflow-FormRenderer.missing_fields_message");
                  missingField = true;
                  return true;
                }
              }
              $(formGroup).removeClass("invalidFromGroup").removeClass("cf-form-invalid");
            } else {
              if (typeof value === "string" && value.length > 0 || typeof value === "number" || !$.isEmptyObject(value) || value === true || Array.isArray(value) && value.length > 0) {
                $(formGroup).removeClass("invalidFromGroup").removeClass("cf-form-invalid");
              } else {
                isFormGood = false;
                if (pHighlightError !== false) {
                  $(formGroup).addClass("invalidFromGroup cf-form-invalid");
                }
                errorMessage = $.i18n._("nixps-cloudflow-FormRenderer.missing_fields_message");
                missingField = true;
                return true;
              }
            }
          }
          // otherwise control if component has no valid function?
          // if there is, use it
          if (checkValidity(type) && component.data(dataType) && typeof component.data(dataType).isValid === "function") {
            var isValid = component[type]("isValid");
            if (isValid === false || typeof isValid === "string") {
              that._trigger("invalid", null, {
                formGroup: $(this)
              });
              isFormGood = false;
              if (typeof isValid === "string" && isValid.length > 0) {
                if (pHighlightError !== false) {
                  $(formGroup).addClass("invalidFromGroup cf-form-invalid");
                }
                errorMessage = isValid;
                errorMessagesToShow.push(errorMessage);
              }
            } else {
              $(formGroup).removeClass("invalidFromGroup").removeClass("cf-form-invalid");
            }
          }
        }
      });
      if (missingField === true) {
        errorMessagesToShow.unshift($.i18n._("nixps-cloudflow-FormRenderer.missing_fields_message"));
      }
      if (errorMessagesToShow.length > 0) {
        this.showErrorMessages(errorMessagesToShow);
      }

      // if everything goes well, hide the errormessages.
      if (isFormGood === true) {
        this.hideErrorMessages();
      }
      if (pReturnErrorMessage === true && isFormGood === false) {
        return errorMessage;
      } else {
        return isFormGood;
      }
    },
    /**
     * @description Returns an object with the key, values paires containing the requested data filled in by the user.
     * @name nixps-cloudflow.FormRenderer#getValues
     * @function
     * @returns {object}
     */
    getValues: function getValues() {
      var that = this;
      var outputObject = {};
      // loop over objects
      this._getFieldElements().each(function (index, elem) {
        var field = $(elem).data("inputFieldOptions");
        var component = $(this).children(".component");
        var key = field.getKey();
        if (that._needToSkip($(elem)) === false) {
          // if field is a group, merge all data in object
          if (field.isGroup() === true) {
            outputObject = $.extend(true, outputObject, getValueOfField(field, component));
            // if field is optional, get no value
          } else {
            if (key === "" && $.isEmptyObject(outputObject) === false) {
              console.warn("FormRenderer: you are overwriting existing values");
            }
            outputObject = CloudflowObject.setParameter(outputObject, key, getValueOfField(field, component));
          }
        } else {
          // field is hidden by action
          if (that.options.returnActionHiddenFields === "current") {
            if (field.isGroup() === true) {
              outputObject = $.extend(true, outputObject, getValueOfField(field, component));
            } else {
              outputObject = CloudflowObject.setParameter(outputObject, key, getValueOfField(field, component));
            }
          } else if (that.options.returnActionHiddenFields === "null") {
            outputObject = CloudflowObject.setParameter(outputObject, key, null);
          }
          // else returnActionHiddenFields === false > do nothing
        }
      });

      return outputObject;
    },
    /**
     * @function
     * @description determin if we need to skip the component or not
     * @private
     * @name nixps-cloudflow.FormRenderer#_needToSkip
     * @param {type} pFieldElement
     * @return {unresolved}
     */
    _needToSkip: function _needToSkip(pFieldElement) {
      return FormAction.needToSkip(pFieldElement);
    },
    /**
     * @description set all the fields to a specific value. this function loops over the fields and put the corresponding value.
     * if the component has a function "setValue"
     * @function
     * @name nixps-cloudflow.FormRenderer#setValues
     * @param {object} pValueObject - object with the same keys as the fieldkeys, 
     * the corresponding values will be used to value for the separated calls "setValue"
     * @returns {undefined}
     */
    setValues: function setValues(pValueObject, pChangedByMachine, pKeysChangedByMachine) {
      if (pValueObject === undefined || pValueObject === null) {
        throw new Error("setValues: invalid input parameter");
      }
      this.blockChangeEvents = true;
      // loop over the fields
      this._getFieldElements().each(function (index, elem) {
        var field = $(elem).data("inputFieldOptions");
        var component = $(this).children(".component");
        var key = field.getKey();
        var includesInKeys = Array.isArray(pKeysChangedByMachine) ? pKeysChangedByMachine.includes(key) : true;
        // if key exist
        if (key && field.isGroup() === true && pValueObject !== undefined) {
          if (setValueOfField(field, component, pValueObject) === true) {
            component.toggleClass("formrenderer_informAutoChange", pChangedByMachine === true && includesInKeys);
          }
        } else if (key && pValueObject[key] !== undefined) {
          setValueOfField(field, component, pValueObject[key]);
          component.toggleClass("formrenderer_informAutoChange", pChangedByMachine === true && includesInKeys);
        } else if (key && CloudflowObject.getParameter(pValueObject, key) !== undefined) {
          setValueOfField(field, component, CloudflowObject.getParameter(pValueObject, key));
          component.toggleClass("formrenderer_informAutoChange", pChangedByMachine === true && includesInKeys);
        }
      });
      this._initActions();
      this.blockChangeEvents = false;
    },
    /**
     * @description Reset the form, ask for each field to reset, if they have a reset function
     * @function
     * @name nixps-cloudflow.FormRenderer#reset
     * @return {undefined}
     */
    reset: function reset() {
      this.blockChangeEvents = true;
      // loop over the fields
      this._getFieldElements().each(function (index, elem) {
        var field = $(elem).data("inputFieldOptions");
        var type = field.getComponent().getType();
        var dataType = field.getComponent().getWidgetFullName();
        var component = $(this).children(".component");
        if (component.data(dataType) && typeof component.data(dataType).reset === "function") {
          try {
            component[type]("reset");
          } catch (e) {
            console.error("could not reset component type " + type, e);
          }
        } else if (typeof component[0].nixpsReset === "function") {
          try {
            component[0].nixpsReset();
          } catch (e) {
            console.error("could not reset component type " + type, e);
          }
        }
        $(elem).removeClass("invalidFromGroup").removeClass("cf-form-invalid");
      });
      this._initActions();
      this.blockChangeEvents = false;
    },
    /**
     * @description refresh one specific element of the form. And this only if there is a layout
     * @function
     * @name nixps-cloudflow.FormRenderer#refreshElementUI
     * @param {type} pFormElement
     * @return {unresolved} null if we could not update otherwise undefined if everythings goes good
     */
    refreshElementUI: function refreshElementUI(pFormElement) {
      if (this.validLayout === false) {
        console.error("refreshElementUI: we do not support refreshing when layout is missing");
        return null;
      }
      // first translate the complete json internal format
      var formElement = FormElement.fromJSON(this._translateJSONObject(pFormElement.clone().toJSON()));
      var formElementDOM = this.element.children(".formContainer").LayoutRenderer("getElement", formElement.getComponentID());
      if (formElementDOM === undefined || formElementDOM === null || formElementDOM.length === 0) {
        console.error("refreshElementUI: we could not find element");
        return null;
      }
      if (formElement.getType() === "component") {
        // the previous state was a field, so field becomes component
        if (formElementDOM.hasClass("fieldElement") === true) {
          formElementDOM = formElementDOM.first();
          formElementDOM.removeAttr("data-key").removeClass("requiredComponent cf-form-required fieldElement from-group").removeData("inputFieldOptions").removeClass(kBootstarpClassMode).removeData("key").children().remove();
          var parent = formElementDOM;
          formElementDOM = $("<div>").data("componentOptions", formElement.getElement()).addClass("componentElement");
          parent.append(formElementDOM);
        } else
          // the formrenderereditor has put the components deep inside,
          // so we need to find it back, dug it back
          if (formElementDOM.hasClass("componentElement") === false) {
            formElementDOM = formElementDOM.find(".componentElement").first();
            if (formElementDOM === undefined || formElementDOM.length === 0) {
              console.error("refreshElementUI: we could not find element");
              return null;
            }
          }
        if (formElementDOM.parent().hasClass("errorState")) {
          formElementDOM.parent().removeClass("errorState");
          // if we had an error, recreate from scratch, destroy the old one
          formElementDOM.empty();
          formElementDOM[formElement.getElement().getType()]("destroy");
        } else if (formElementDOM.data(formElement.getElement().getWidgetFullName()) === undefined) {
          // remove and recreate
          var parent = formElementDOM.parent();
          parent.children(".componentElement").remove();
          formElementDOM = $("<div>").data("componentOptions", formElement.getElement()).addClass("componentElement");
          parent.append(formElementDOM);
        }
        // try to update this component
        try {
          var formElementOptions = formElement.getElement().getOptions();
          formElementOptions.language = this.options.language;
          formElementDOM[formElement.getElement().getType()](formElementOptions);
        } catch (pError) {
          console.error(pError);
          formElementDOM.parent().addClass("errorState");
        }
        if (this.useBoodstrap === true) {
          formElementDOM.parent().addClass("row").children().addClass(kComponentBootstrapClass);
        }
        formElementDOM.parent().removeData(kFieldLabelSyncStateDataKey);
        this._setCustomStyle(formElementDOM.closest(".formGroup"), formElement);
      } else if (formElement.getType() === "field") {
        if (formElementDOM.hasClass("fieldElement") === false) {
          // we have a component to be transformed to a field
          var elementDOM;
          if (formElementDOM.hasClass("componentElement")) {
            elementDOM = formElementDOM.first();
          } else if (formElementDOM.find(".componentElement").length > 0) {
            elementDOM = formElementDOM.find(".componentElement").first();
          } else {
            // too difficult to retrieve the correct one, 
            // so put a error in this case
            console.error("we could not find element");
            return null;
          }
          formElementDOM = elementDOM.parent();
          formElementDOM.addClass("fieldElement").children().remove();
        } else {
          formElementDOM = formElementDOM.first();
        }
        // update data
        formElementDOM.data("inputFieldOptions", formElement.getElement());
        // change require class *
        formElementDOM.toggleClass("requiredComponent", formElement.getElement().isRequired());
        formElementDOM.toggleClass("cf-form-required", formElement.getElement().isRequired());
        // change label
        var label = _.unescape(formElement.getElement().getLabel());
        if (typeof label !== "string" || label.length <= 0) {
          formElementDOM.children("label").remove();
        } else if (formElementDOM.children("label").length === 0) {
          formElementDOM.prepend($("<label>").addClass("cf-form-label").text(label));
        } else {
          formElementDOM.children("label").text(label);
        }
        // change key
        formElementDOM.attr("data-key", formElement.getElement().getKey());
        // change options component in field
        formElementDOM.find(".component").first().remove();
        // remove previous error class
        formElementDOM.removeClass("errorState");
        // try to update this component
        makeField(formElement.getElement(), formElementDOM, this.options);
        // change helpblock
        var helptext = _.unescape(formElement.getElement().getHelptext());
        formElementDOM.children(".cf-form-helptext").remove();
        if (typeof helptext === "string" && helptext.length > 0) {
          formElementDOM.append($("<span>").addClass("cf-form-helptext").text(helptext));
        }
        // boodstrap class
        if (this.useBoodstrap === true) {
          formElementDOM.children(".component").find("input[type!=checkbox][type!=radio], select, textarea").addClass("form-control cf-form-control");
          formElementDOM.addClass("from-group row " + kBootstarpClassMode).children(".cf-form-helptext").addClass("help-block " + this.options.helptextBootstrapClass);
          formElementDOM.children("label").filter(function () {
            return $(this).siblings(".componentContainer").length > 0;
          }).addClass(this.options.labelBootstrapClass).siblings(".componentContainer").addClass(this.options.inputBootstrapClass);
        }
        this._syncExpressionBuilderVariableInputFieldLabel(formElementDOM, null, true);
        this._setCustomStyle(formElementDOM.closest(".formGroup"), formElement);
      }
    },
    createNewElement: function createNewElement(pDOMElement, pFormElement) {
      var formGroup = $("<div>").addClass("formGroup cf-form-group " + this.options.formGroupClasses);
      if (pDOMElement.length !== 1) {
        throw new Error("createNewElement: we expect extactly one element, no less, no more");
      }
      pDOMElement.empty().append(formGroup);
      if (pFormElement.getType() === "component") {
        formGroup.append($("<div>").addClass("componentElement"));
      } else if (pFormElement.getType() === "field") {
        formGroup.addClass("fieldElement");
      }
      this.refreshElementUI(pFormElement);
    },
    /**
     * @description Resets the form metadata
     * @function
     * @name nixps-cloudflow.FormRenderer#resetMetadata
     * @returns {undefined}
     */
    resetMetadata: function resetMetadata() {
      // loop over all elements
      this._getFieldElements().each(function (index, elem) {
        var field = $(elem).data("inputFieldOptions");
        var type = field.getComponent().getType();
        var neededMetadata = field.getNeededMetadata();
        if (type === "RIPEditorPresets" && (Array.isArray(neededMetadata) == false || neededMetadata.length <= 0)) {
          neededMetadata = ["ColorantsPerFile", "ColorantNames"];
        }
        // check if component needs some info
        if (Array.isArray(neededMetadata) && neededMetadata.length > 0) {
          var component = $(this).children(".component");
          // check if component has a function/methode to reset
          var dataWidget = field.getComponent().getWidgetFullName();
          if (typeof dataWidget === "string" && dataWidget.length > 0) {
            if (component.data(dataWidget) !== undefined && typeof component.data(dataWidget).resetMetadata === "function") {
              component[type]("resetMetadata");
            }
          } else {
            console.error("resetMetadata: unknown component");
          }
        }
      });
    },
    /**
     * @description Does the form needs specific metadata?
     * @function
     * @name nixps-cloudflow.FormRenderer#getNeededMetadata
     * @returns {Array.<String>}
     */
    getNeededMetadata: function getNeededMetadata() {
      var neededMetadata = [];
      if (this.form !== undefined) {
        neededMetadata = this.form.getNeededMetadata();
      }
      var RIPComponents = this.element.find(".nixps-RIPEditorPresets, .nixps-colorspace-ColorspaceSettings");
      if (RIPComponents.length > 0) {
        neededMetadata = neededMetadata.concat(["ColorantsPerFile", "ColorantNames"]);
      }
      if (window._ && typeof _.uniq === "function") {
        neededMetadata = _.uniq(neededMetadata);
      }
      return neededMetadata;
    },
    /**
     * @description inform the metadata is being processing
     * @function
     * @name nixps-cloudflow.FormRenderer#processNeededMetadata
     * @returns {undefined}
     */
    processNeededMetadata: function processNeededMetadata(pProcessInfo) {
      // loop over all elements
      this._getFieldElements().each(function (index, elem) {
        var field = $(elem).data("inputFieldOptions");
        var type = field.getComponent().getType();
        var neededMetadata = field.getNeededMetadata();
        if (type === "RIPEditorPresets" && (Array.isArray(neededMetadata) == false || neededMetadata.length <= 0)) {
          neededMetadata = ["ColorantsPerFile", "ColorantNames"];
        }
        // check if component needs some info
        if (Array.isArray(neededMetadata) && neededMetadata.length > 0) {
          var component = $(this).children(".component");
          // check if component has a function/methode to transfer this info
          var dataWidget = field.getComponent().getWidgetFullName();
          if (typeof dataWidget === "string" && dataWidget.length > 0) {
            if (component.data(dataWidget) !== undefined && typeof component.data(dataWidget).processMetadata === "function") {
              component[type]("processMetadata", pProcessInfo);
            }
          } else {
            console.error("processNeededMetadata: unknown component");
          }
        }
      });
    },
    /**
     * @description transfer the metadata to the components who asked for it
     * @function
     * @name nixps-cloudflow.FormRenderer#setNeededMetadata
     * @param {Object} pMetadata The metadata with key (metadata name) and the corresponding value (metadata)
     */
    setNeededMetadata: function setNeededMetadata(pMetadata) {
      if ($.isPlainObject(pMetadata) === false || $.isEmptyObject(pMetadata)) {
        // shortcut, there is no info to transfer
        return;
      }
      // loop over all elements
      this._getFieldElements().each(function (index, elem) {
        var field = $(elem).data("inputFieldOptions");
        var type = field.getComponent().getType();
        var neededMetadata = field.getNeededMetadata();
        if (type === "RIPEditorPresets" && (Array.isArray(neededMetadata) == false || neededMetadata.length <= 0)) {
          neededMetadata = ["ColorantsPerFile", "ColorantNames"];
        }
        // check if component needs some info
        if (Array.isArray(neededMetadata) && neededMetadata.length > 0) {
          var component = $(this).children(".component");
          // check if component has a function/methode to transfer this info
          var dataWidget = field.getComponent().getWidgetFullName();
          if (typeof dataWidget === "string" && dataWidget.length > 0) {
            if (component.data(dataWidget) !== undefined && typeof component.data(dataWidget).setMetadata === "function") {
              // prepare: component should only recieve what he asked!
              var injectedMetadata = {};
              for (var i = 0; i < neededMetadata.length; i++) {
                injectedMetadata[neededMetadata[i]] = pMetadata[neededMetadata[i]];
              }
              // deep copy to prevent handling one component to change in other component
              component[type]("setMetadata", $.extend(true, {}, injectedMetadata));
            }
          } else {
            console.error("setNeededMetadata: unknown component");
          }
        }
      });
    },
    /**
     * @description Show a typical error message
     * @function
     * @name nixps-cloudflow.FormRenderer#showErrorMessages
     * @private
     * @param {Array} pMessage
     * @return {undefined}
     */
    showErrorMessages: function showErrorMessages(pMessages) {
      if (typeof pMessages === "string") {
        pMessages = [pMessages];
      }
      if (this.validLayout === false) {
        return this.element.children("form").children(".formGroup").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage("showErrorMessage", pMessages.join("<br/>"));
      } else {
        return this.element.children(".formContainer").LayoutRenderer("showErrorMessages", pMessages);
      }
    },
    /**
     * @description mark specific fields and messages, linked to specific fields. Is used durring custom erroring
     * @function
     * @name nixps-cloudflow.FormRenderer#showStructuredErrorMessages
     * @private
     * @param {Object} pError 
     */
    showStructuredErrorMessages: function showStructuredErrorMessages(pError) {
      if (pError && _typeof(pError) === "object" && pError.error_type === "form_structured") {
        var that = this;
        var messages = [];
        if (Array.isArray(pError.fields) && pError.fields.length > 0) {
          this._getFieldElements().each(function (index, formGroup) {
            if (that._needToSkip($(formGroup)) === false) {
              var field = $(this).data("inputFieldOptions"); // maintain data(), because formaction change the data of DOM to change recuired
              var key = field.getKey();

              // if key exist
              if (key !== undefined) {
                var foundError = false;
                for (var i = 0; i < pError.fields.length; i++) {
                  if (pError.fields[i] && pError.fields[i].key === key) {
                    $(formGroup).addClass("invalidFromGroup cf-form-invalid");
                    if (typeof pError.fields[i].error_message === "string" && pError.fields[i].error_message.length > 0) {
                      messages.push(pError.fields[i].error_message);
                    }
                    foundError = true;
                    break;
                  }
                }
                if (foundError === false) {
                  $(formGroup).removeClass("invalidFromGroup").removeClass("cf-form-invalid");
                }
              }
            }
          });
        }
        if (messages.length > 0) {
          this.showErrorMessages(messages);
        }
      } else {
        console.warn("showStructuredErrorMessages: unknown structed error type");
      }
    },
    /**
     * @description Hide the error message
     * @function
     * @name nixps-cloudflow.FormRenderer#hideErrorMessages
     * @private
     * @return {undefined}
     */
    hideErrorMessages: function hideErrorMessages() {
      if (this.validLayout === false) {
        return this.element.children("form").children(".formGroup").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage("hideErrorMessages");
      } else {
        return this.element.children(".formContainer").LayoutRenderer("hideErrorMessages");
      }
    },
    /**
     * @description Hide all te structered error messages. This do also a @link{nixps-cloudflow.FormRenderer#hideErrorMessages}
     * @function
     * @name nixps-cloudflow.FormRenderer#hideStructuredErrorMessages
     * @private
     * @returns {undefined}
     */
    hideStructuredErrorMessages: function hideStructuredErrorMessages() {
      this.hideErrorMessages();
      this._getFieldElements().each(function (index, formGroup) {
        $(formGroup).removeClass("invalidFromGroup").removeClass("cf-form-invalid");
      });
    },
    /**
     * @description Make a deep copy of the form we receive from the input options,
     * so if there a changes, we do not change the outside objects
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_makeDeepCopyOfInputs
     * @returns {undefined}
     */
    _makeDeepCopyOfInputs: function _makeDeepCopyOfInputs() {
      if (Array.isArray(this.options.formJSON)) {
        this.formJSON = $.extend(true, [], this.options.formJSON);
      } else {
        this.formJSON = $.extend(true, {}, this.options.formJSON);
      }
      if (_typeof(this.options.variableDictionary) === "object") {
        this.options.variableDictionary = Object.assign({}, this.options.variableDictionary);
      }
    },
    /**
     * @description fucntion translate all the know variables in the values, given by the dictionary (input options)
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_translateVariables
     * @returns {undefined}
     */
    _translateVariables: function _translateVariables() {
      if ($.isPlainObject(this.options.variableDictionary) && !$.isEmptyObject(this.options.variableDictionary)) {
        this.formJSON = this._translateJSONObject(this.formJSON);
      }
    },
    /**
     * @description Translate a specific json object
     * @function
     * @name nixps-cloudflow.FormRenderer#_translateJSONObject
     * @private
     * @param {type} pJSON
     * @return {unresolved}
     */
    _translateJSONObject: function _translateJSONObject(pJSON) {
      var that = this;
      return CloudflowObject.travers(pJSON, function (pString) {
        if (regExpVariable.test(pString)) {
          // if begin with ${ and end with }
          var variableName = pString.slice(2, -1); // remove ${ and }
          var translated = that.options.variableDictionary[variableName];
          // only translate if dictionary knows
          if (translated !== undefined) {
            return translated;
          } else if (variableName === ".") {
            return that.options.variableDictionary;
          }
        }
        return pString;
      });
    },
    /**
     * @description update the dictionary but do not do a redraw
     * @function
     * @name nixps-cloudflow.FormRenderer#silenceUpdateVariables
     * @private
     * @param {Object} pVariableDictionary
     * @return {undefined}
     */
    silenceUpdateVariables: function silenceUpdateVariables(pVariableDictionary) {
      if ($.isPlainObject(pVariableDictionary) === false) {
        throw new Error("Variable dictionary must be a plain object");
      }
      this.options.variableDictionary = Object.assign({}, pVariableDictionary);
    },
    /**
     * @description Update a specific row without updating the rest. But the ui must be already good
     * @function
     * @name nixps-cloudflow.FormRenderer#updatePartialDOM
     * @private
     * @param {mixed} pUICoordinates the row index to be updated
     * @param {Object} pLayout The new Layout to be applied
     */
    updatePartialDOM: function updatePartialDOM(pUICoordinates, pLayout, pRenderOptions) {
      if (this.validLayout === false) {
        console.error("updatePartialDOM: we do not support row updating when layout is missing");
        return null;
      }
      this.options.layoutJSON = pLayout;
      this._controlOptions();
      this.element.children(".formContainer").LayoutRenderer("updateDOM", pUICoordinates, pLayout, pRenderOptions);
    },
    /**
     * @description Set all the field to read only or to editable. This will only work if the underling component interpret the disable functionality well.
     * @function
     * @name nixps-cloudflow.FormRenderer#setReadOnly
     * @param {Boolean} pReadOnly true to set every input field in disabeld mode, set on false to enable every field
     * @return {undefined}
     */
    setReadOnly: function setReadOnly(pReadOnly) {
      this._setDisabledOption(pReadOnly);
    },
    setValidationPhase: function setValidationPhase(pBool) {
      this.validationFase = pBool;
    },
    /**
     * @description Disable or enable all fields
     * @function
     * @private
     * @name nixps-cloudflow.FormRenderer#_setDisabledOption
     * @param {Boolean} pValue true to disable, set false to enable
     * @return {undefined}
     */
    _setDisabledOption: function _setDisabledOption(pValue) {
      if (typeof pValue !== "boolean") {
        throw new Error("FormRenderer._setDisable parameter must be a boolean");
      }
      // loop over the fields
      this._getFieldElements().each(function (index, elem) {
        var field = $(elem).data("inputFieldOptions");
        var component = $(this).children(".component");
        var type = field.getComponent().getType();
        if (typeof type === "string" && type.length > 0) {
          if (pValue === false && (component.hasClass("formrendererDisabledByCreation") || FormAction.isDisabledByAction(component))) {
            // do not reanable if it was disabled by creation!!
          } else if (pValue === false) {
            component[type]("enable");
          } else if (pValue === true) {
            component[type]("disable");
          }
        }
      });
    },
    /**
     * @description set options
     * @function
     * @name nixps-cloudflow.FormRenderer#_setOptions
     * @private
     * @param {object} options
     * @return {undefined}
     */
    _setOptions: function _setOptions(options) {
      var that = this;
      var needToRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needToRedraw = true;
        }
        ;
      });
      if (needToRedraw === true) {
        this._draw();
      }
    },
    /**
     * @brief sets the option
     * @private
     * @name nixps-cloudflow.FormRenderer#_setOption
     * @function
     */
    _setOption: function _setOption(pKey, pValue) {
      // control first if we realy need to refresh all.
      // this preventing to clearing input of users currently being editing the form
      if (pKey === "formJSON") {
        if (_.isEqual(this.options.formJSON, pValue)) {
          // no changes detected do nothing
          return;
        } // changes detected
        this._controlOptions();
        this._superApply(arguments);
        this._makeDeepCopyOfInputs();
        this._translateVariables();
        return true;
      }
      if (pKey === "layoutJSON") {
        if (_.isEqual(this.options.layoutJSON, pValue)) {
          // no changes detected
          return;
        }
        this._controlOptions();
        this._superApply(arguments);
        return true;
      }
      if (pKey === "language" && this.options.language === pValue) {
        // no changes detected
        return;
      }
      if (pKey === "keepValidating") {
        if (this.options.keepValidating !== pValue) {
          // value used durring running
          this._superApply(arguments);
          this._controlOptions();
        }
        // no changes detected
        return;
      }
      if (pKey === "throttleTime") {
        if (this.options.throttleTime !== pValue) {
          this._superApply(arguments);
          this._controlOptions();
          if (typeof window._ === "function") {
            if (this.options.throttleTime >= 0) {
              this.changeHandler = _.throttle(this._changeHandler, this.options.throttleTime);
            } else {
              // allow to set negative values, to disable throttleing
              this.changeHandler = this._changeHandler;
            }
          }
        }
        return;
      }
      if (pKey === "formClasses") {
        if (this.options.formClasses !== pValue) {
          var formDOM = this.element.children(".formContainer").removeClass(this.options.formClasses);
          this._superApply(arguments);
          this._controlOptions();
          formDOM.addClass(this.options.formClasses);
        }
        return;
      }
      if (pKey === "disabled") {
        if (pValue !== this.options.disabled) {
          this._superApply(arguments);
          this._controlOptions();
          this._setDisabledOption(pValue);
        }
        return;
      }
      if (pKey === "style_type") {
        if (pValue !== this.options.style_type) {
          this.element.removeClass("CloudflowStyle_" + this.options.style_type);
          this.element.addClass("CloudflowStyle_" + pValue);
          this._superApply(arguments);
        }
        return;
      }
      if (pKey === "variableDictionary") {
        if (_.isEqual(this.options.variableDictionary, pValue)) {
          // no changes detected
          return;
        }
      }
      if (pKey === "returnActionHiddenFields") {
        if (this.options.returnActionHiddenFields !== pValue) {
          this._superApply(arguments);
          this._controlOptions();
        }
        // no changes detected
        return;
      }
      if (pKey === "helptextBootstrapClass" && this.options.helptextBootstrapClass === pValue) {
        // no changes detected
        return;
      }
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "variableDictionary") {
        this._makeDeepCopyOfInputs();
        this._translateVariables();
      }
      // inform to redraw
      return true;
    },
    /**
     * @description control if the inputoptions are correct?
     * @function
     * @name nixps-cloudflow.FormRenderer#_controlOptions
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("input option language must be a not empty string");
      }
      // run only if moment js plugin is included
      if (window.moment !== undefined && typeof moment.locale === "function") {
        if (this.options.language === "en") {
          var browserlanguage = navigator.language || navigator.userLanguage;
          if (typeof browserlanguage === "string" && browserlanguage.length > 0) {
            moment.locale(browserlanguage);
          } else {
            moment.locale("en");
          }
        } else {
          moment.locale(this.options.language);
        }
      }
      if (this.options.layoutJSON === undefined) {
        // put to default value
        this.options.layoutJSON = null;
      } else if (this.options.layoutJSON !== null && $.isEmptyObject(this.options.layoutJSON)) {
        throw new Error("invalid option layoutJSON");
      }
      if (typeof this.options.keepValidating !== "boolean") {
        throw new Error("input option keepValidating must be a boolean");
      }
      if (typeof this.options.formGroupClasses !== "string") {
        throw new Error("input option formGroupClasses must be a string");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.widgetFullName).removeClass("CloudflowStyle_" + this.options.style_type);
      this._superApply(arguments);
    },
    /**
     * @description Get all the form elements
     * @function
     * @name nixps-cloudflow.FormRenderer#_getFieldElements
     * @private
     * @returns {jqueryHTML}
     */
    _getFieldElements: function _getFieldElements() {
      if (this.validLayout === false) {
        return this.element.children("form").children(".formGroup.fieldElement");
      } else {
        return this.element.children(".formContainer").LayoutRenderer("getFieldElements");
      }
    }
  });
})(jQuery);

},{"../../../polyfill/polyfill.js":433,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../UIProfiles/js/Field.js":248,"../../UIProfiles/js/Form.js":249,"../../UIProfiles/js/FormAction.js":250,"../../UIProfiles/js/FormElement.js":251,"../../UIProfiles/js/WebFramework.js":261,"./nixps-cloudflow-FormSectionList.js":169,"./nixps-cloudflow-LayoutRenderer.js":170}],169:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Aug 30, 2017 10:18:21 AM
 */
(function ($) {
  /**
   * @namespace nixps-cloudflow.FormSectionList
   * @description A Content Table of a form
   * @example $("<div>").FormSectionList({});
   * @version 1.4.0
   */
  $.widget("nixps-cloudflow.FormSectionList", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "formsectionlist",
    options: {
      /**
       * @description The classes added to the main class
       * @name nixps-cloudflow.FormSelectionList#mainClasses
       * @type {String}
       * @default "cf-settingslist"
       */
      mainClasses: "cf-settingslist",
      /**
       * @description The DOM who contains the content to retreive information 
       * @name nixps-cloudflow.FormSelectionList#contentPage
       * @type {Mixed}
       * @default undefined
       */
      contentPage: undefined,
      /**
       * @description The jquery selection to find the section
       * @name nixps-cloudflow.FormSelectionList#sectionSelector
       * @type {String}
       * @default ".cf-section"
       */
      sectionSelector: ".cf-section",
      /**
       * @description The jquery selection to find the titles
       * @name nixps-cloudflow.FormSelectionList#titleSectionSelector
       * @type {String}
       * @default ".cf-title-title, .cf-title-h1"
       */
      titleSectionSelector: ".cf-title-title, .cf-title-h1",
      /**
       * @description callback function to indicate the component is done creating
       * @name nixps-cloudflow.FormSelectionList#created
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.FormSectionList#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._addClass(this.widgetFullName);
      this.element.addClass(this.options.mainClasses);

      // used variables
      this.mContentPanel = $(this.options.contentPage);
      this._draw();
      this._screenScrolledHandler();
      this.screenScrolledHandler = _.throttle(this._screenScrolledHandler, 100).bind(this);
      this._on(this.element, {
        "click .cf-settingslist-item": this._settingsListClickedHandler
      });
      if (typeof IntersectionObserver === "function") {
        var observer = new IntersectionObserver(this._screenObserverHandler.bind(this), {
          threshold: [0, 1],
          rootMargin: "0px"
        });
        this.mContentPanel.find(this.options.sectionSelector).filter(":visible").each(function () {
          observer.observe(this);
        });
      } else {
        this.mContentPanel.on("scroll", this.screenScrolledHandler);
      }
      this.options.created();
    },
    /**
    * @description Menu entry on the left has been clicked
    * @function
    * @private
    * @name nixps-cloudflow.FormSectionList#_settingsListClickedHandler
    * @returns {undefined}
    */
    _settingsListClickedHandler: function _settingsListClickedHandler(pEvent) {
      clearTimeout(this._clearClickTimer);
      this.element.addClass("settingsui-user-clicked");
      this._clearClickTimer = this._delay(function () {
        this.element.removeClass("settingsui-user-clicked");
      }, 2000);
      this.element.find(".cf-settingslist-currentitem").removeClass("cf-settingslist-currentitem");
      var target = $(pEvent.target).closest(".cf-settingslist-item");
      target.addClass("cf-settingslist-currentitem");
      var itemId = target.attr("for");
      if (typeof itemId === "string" && itemId.length > 0) {
        var section = this.mContentPanel.find("#" + itemId);
        if (section.length === 1) {
          section[0].scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    },
    /**
     * @description Handles scroll events to update the sidebar
     * @function
     * @private
     * @name nixps-cloudflow.FormSectionList#_settingsListClickedHandler
     * @returns {undefined}
     */
    _screenScrolledHandler: function _screenScrolledHandler(pEvent) {
      if (!this.element.hasClass("settingsui-user-clicked")) {
        var sections = this.mContentPanel.find(this.options.sectionSelector);
        var closest = null;
        var closestDistance = Number.MAX_SAFE_INTEGER;
        var section = undefined,
          top = undefined;
        for (var i = 0; i < sections.length; i++) {
          section = $(sections[i]);
          top = section.offset().top;
          if (top > 0 && top < closestDistance) {
            closest = section;
            closestDistance = top;
          }
        }
        if (closest) {
          this.element.find(".cf-settingslist-currentitem").removeClass("cf-settingslist-currentitem");
          var which = closest.closest("[id]").attr("id");
          if (typeof which === "string" && which.length > 0) {
            this.element.find(".cf-settingslist-item[for=\"" + which + "\"]").addClass("cf-settingslist-currentitem");
          }
        } else if (closest === null && top < 0) {
          this.element.find(".cf-settingslist-currentitem").removeClass("cf-settingslist-currentitem");
          this.element.find(".cf-settingslist-item").last().addClass("cf-settingslist-currentitem");
        }
      }
    },
    _screenObserverHandler: function _screenObserverHandler(pEvent) {
      this.screenScrolledHandler(pEvent);
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.FormSectionList#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.FormSectionList#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      var itemDOMs = [];
      this.mContentPanel.find(this.options.sectionSelector).filter(":visible").each(function () {
        var section = $(this);
        var id = section.attr("id");
        var titleDOM;
        if (section.is(that.options.titleSectionSelector)) {
          titleDOM = section;
        } else {
          titleDOM = section.find(that.options.titleSectionSelector).first();
        }
        if (typeof id !== "string" || id.length <= 0) {
          id = titleDOM.attr("id");
        }
        itemDOMs.push($("<div>").addClass("cf-settingslist-item").text(titleDOM.text()).attr("for", id));
      });
      this.element.empty().append(itemDOMs);
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      if (options.contentPage !== undefined && options.contentPage !== this.options.contentPage) {
        this.mContentPanel = $(options.contentPage);
      }
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.FormSectionList#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (this.options.contentPage === undefined) {
        throw new Error("option contentPage must be defined");
      }
      if (typeof this.options.sectionSelector !== "string") {
        throw new Error("option sectionSelector must be a string");
      }
      if (typeof this.options.titleSectionSelector !== "string") {
        throw new Error("option titleSectionSelector must be a string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.options.mainClasses);
      if (this.mContentPanel !== undefined) {
        // prevent error when creation failed
        this.mContentPanel.off("scroll", this.screenScrolledHandler);
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],170:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Aug 30, 2017 10:18:21 AM
 */

(function ($) {
  var Layout = require('../../UIProfiles/js/Layout.js');
  var BootstrapGridLayoutRender = require("./BootstrapGridLayoutRender.js"); // default renderer
  var CompassLayoutRender = require("./CompassLayoutRender.js");
  var TableGridLayoutRender = require('./TableGridLayoutRender.js');

  /**
   * @namespace nixps-cloudflow.LayoutRenderer
   * @description Draw a skeleton of the layout, where you can add components or items afterwards. This will draw the layout for you
   * @example $('<div>').LayoutRenderer({});
   * @version 1.4.0
   */
  $.widget("nixps-cloudflow.LayoutRenderer", $.Widget, {
    version: "1.4.0",
    widgetEventPrefix: "layoutrenderer",
    options: {
      /**
       * @name nixps-cloudflow.LayoutRenderer#layout
       * @description The layout to be drawn
       * @type {Object | Layout}
       * @default null
       */
      layout: null,
      /**
       * @name nixps-cloudflow.LayoutRenderer#idAttribute
       * @description The attribute to be used to store the element id
       * @type {String}
       * @default "data-id"
       */
      idAttribute: "data-id",
      /**
       * @name nixps-cloudflow.LayoutRenderer#idPrefix
       * @description The text to prefic all ids
       * @type {String}
       * @default ""
       * @since 1.4.0
       */
      idPrefix: "",
      /**
       * @name nixps-cloudflow.LayoutRenderer#layoutRender
       * @description A specific layout renderer
       * @private
       * @type {Class}
       * @default null
       * @since 1.2.0
       */
      layoutRender: null,
      /**
       * @name nixps-cloudflow.LayoutRenderer#renderOptions
       * @description The render options
       * @type {Object}
       * @default {}
       * @since 1.3.0
       */
      renderOptions: {}
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.LayoutRenderer#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);

      // used variables
      this.layout = null;
      this.renderer;
      this._draw();
      this._on(this.element, {});
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.LayoutRenderer#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.LayoutRenderer#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      this.layout = null;

      // shortcut
      if (this.options.layout === null) {
        return;
      }

      // convert option to layout
      if (this.options.layout instanceof Layout) {
        this.layout = this.options.layout;
      } else if ($.isPlainObject(this.options.layout) === true) {
        this.layout = Layout.fromJSON(this.options.layout);
      }
      if (this.layout === null) {
        // if the layout is unknow, draw nothing; items will just be appended
        return;
      }
      this.renderer;
      // apply the correct layout 
      if (this.layout.getType() === "bootstrapGrid") {
        this.renderer = new BootstrapGridLayoutRender(this.element, this.options.idAttribute, this.options.idPrefix);
        this.renderer.render(this.layout.getParameters(), this.options.renderOptions);
      } else if (this.layout.getType() === "compass") {
        this.renderer = new CompassLayoutRender(this.element, this.options.idAttribute, this.options.idPrefix);
        this.renderer.render(this.layout.getParameters(), this.options.renderOptions);
      } else if (this.layout.getType() === "tableGrid") {
        this.renderer = new TableGridLayoutRender(this.element, this.options.idAttribute, this.options.idPrefix);
        this.renderer.render(this.layout.getParameters(), this.options.renderOptions);
      } else if (this.layout.getType() === "custom" && this.options.layoutRender !== null) {
        this.renderer = new this.options.layoutRender(this.element, this.options.idAttribute, this.options.idPrefix);
        this.renderer.render(this.layout.getParameters(), this.options.renderOptions);
      } else {
        // unsupported type, this component can be out of sync with the layout object
        console.error("unsupported layout type");
        // reset layout
        this.layout = null;
      }
    },
    /**
     * @desc update a row classes
     * @function
     * @private
     * @name nixps-cloudflow.LayoutRenderer#updateDOM
     * @param {Number} pRowIndex
     * @return {undefined}
     */
    updateDOM: function updateDOM(pRowIndex, pLayoutJSON, pRenderOptions) {
      if ($.isPlainObject(pLayoutJSON)) {
        this.layout = Layout.fromJSON(pLayoutJSON);
        this.options.layout = this.layout;
      }
      this.renderer.updateRow(pRowIndex, this.layout.getParameters(), pRenderOptions);
    },
    /**
     * @description Add an element to the layout
     * @function
     * @name nixps-cloudflow.LayoutRenderer#addElement
     * @param {DOMElement} domElement the element to be added
     * @param {String} pID the id to search where to add the element
     * @return {unresolved} 
     */
    addElement: function addElement(domElement, pID) {
      if (this.layout === null) {
        return this.element.append(domElement.attr(this.options.idAttribute, typeof pID === "string" ? this.options.idPrefix + pID : pID));
      } else {
        return this.renderer.addElement(domElement, pID);
      }
    },
    /**
     * @description Get the DOM element 
     * @function
     * @name nixps-cloudflow.LayoutRenderer#getElement
     * @param {String} pID the id of the element we want
     * @return {DOMElement}
     */
    getElement: function getElement(pID) {
      if (this.layout === null) {
        var id = typeof pID === "string" ? this.options.idPrefix + pID : pID;
        return this.element.find("[" + this.options.idAttribute + "='" + id + "']").first();
      } else {
        return this.renderer.getElement(pID);
      }
    },
    /**
     * @description Get all field elements from layout
     * @function
     * @name nixps-cloudflow.LayoutRenderer#getFieldElements
     * @returns {DOMElements}
     */
    getFieldElements: function getFieldElements() {
      if (this.layout === null) {
        return this.element.children("form").children(".formGroup.fieldElement");
      } else {
        return this.renderer.getFieldElements();
      }
    },
    /**
     * @description show all error messages
     * @function
     * @name nixps-cloudflow.LayoutRenderer#showErrorMessages
     * @param {Array.<String>} pMessages The messages to show
     */
    showErrorMessages: function showErrorMessages(pMessages) {
      if (typeof pMessages === "string") {
        pMessages = [pMessages];
      }
      if (this.layout === null) {
        return this.element.children("form").children(".formGroup").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage('showErrorMessage', pMessages.join('<br/>'));
      } else {
        return this.renderer.showErrorMessages(pMessages);
      }
    },
    /**
     * @description Hide all error messages
     * @function
     * @name nixps-cloudflow.LayoutRenderer#hideErrorMessages
     */
    hideErrorMessages: function hideErrorMessages() {
      if (this.layout === null) {
        return this.element.children("form").children(".formGroup").children(".nixps-cloudflow-ErrorMessage.errormessage_formdependent").ErrorMessage('hideErrorMessages');
      } else {
        return this.renderer.hideErrorMessages();
      }
    },
    /**
     * @description Get the html structure as string of the layout
     * @function
     * @name nixps-cloudflow.LayoutRenderer#getHTMLStructure
     * @return {string} The hole HTML structure
     */
    getHTMLStructure: function getHTMLStructure(pAddaptFunc) {
      if (typeof pAddaptFunc === "function") {
        var that = this;
        this.element.find('[' + this.options.idAttribute + ']').each(function () {
          pAddaptFunc($(this).attr(that.options.idAttribute), $(this));
        });
      }
      var html = this.element[0].outerHTML;
      if (typeof html !== "string" || html.length <= 0) {
        throw new Error("could not convert structure to string");
      }
      return html;
    },
    /**
     * @description has the layout given by the input options been good converted to a Layout object.
     * Does the component has a good valid Layout.
     * @function
     * @name nixps-cloudflow.LayoutRenderer#isLayoutValid
     * @return {boolean} 
     */
    isLayoutValid: function isLayoutValid() {
      return this.layout instanceof Layout;
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow-LayoutRenderer#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.LayoutRenderer#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if ($.isPlainObject(this.options.layout) === false && this.options.layout instanceof Layout === false && this.options.layout !== null) {
        throw new Error("input option layout must be an json object of a layout object");
      }
      if (typeof this.options.idAttribute !== "string" || this.options.idAttribute.length <= 0) {
        throw new Error("input option idAttribute must be a not empty string");
      }
      if (typeof this.options.idPrefix !== "string") {
        throw new Error("input option idPrefix must be a string");
      }
    }
  });
})(jQuery);

},{"../../UIProfiles/js/Layout.js":255,"./BootstrapGridLayoutRender.js":165,"./CompassLayoutRender.js":166,"./TableGridLayoutRender.js":167}],171:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

/* triggers: */
/* - refresh-finished */
/* - select */

(function ($) {
  var Asset = {
    getDedicatedFileIcon: function getDedicatedFileIcon() {
      return "cf-icon cf-icon-clipboard-list";
    }
  };
  if (typeof require !== "undefined") {
    require("../../../common/Selectable/js/nixps-Selecting.js");
    Asset = require("../../../nebulaportal/js/assetview/Asset.js");
  }

  /**
   * @description remove the icons that are not in the list {pItems}
   * @param {Array} pItems
   * @returns {Jquery}
   */
  $.fn.removeUnUsed = function (pItems) {
    if (!Array.isArray(pItems) || pItems.length === 0) {
      return this.remove("[data-id]"); // remove everything
    }

    return this.each(function () {
      var id = $(this).attr("data-id");
      if (typeof id === "string") {
        for (var i = 0; i < pItems.length; i++) {
          if (typeof pItems[i]._id === "string" && id === pItems[i]._id) {
            return true;
          }
        }
        $(this).remove();
      } else {
        for (var i = 0; i < pItems.length; i++) {
          if (typeof pItems[i]._id !== "string") {
            return true;
          }
        }
        $(this).remove();
      }
    });
  };
  function getFileName(url) {
    if (typeof url === "string") {
      return url.substring(url.lastIndexOf("/") + 1);
    } else {
      return url;
    }
  }
  ;

  // regular expression for checking if item is in making or not
  var kInmakingReg = new RegExp(/^inmakingid_/);
  // regular expression for checking the lmslayout
  var kLmsCheckReg = new RegExp(/.lmslayout$/);
  // class use to indicated it is selected
  var kSelectClassName = "select";

  /**
   * Triggers "select"
   * @namespace nixps-cloudflow.IconView
   * @description Draw all the assets (give fron the options) in a raster of big icons
   * @example $("<div>").ListView({folders: [..], files:[..], ... });
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.IconView", {
    version: "1.0.0",
    widgetEventPrefix: "iconview",
    options: {
      folders: undefined,
      files: undefined,
      /**
       * @name nixps-cloudflow.IconView#baselocation
       * @description The url to the server who hostes the assets and thumbs. It must be a string
       * @private
       * @type {String}
       * @default ""
       */
      baselocation: "",
      /**
       * @name nixps-cloudflow.IconView#enableSelecting
       * @description Must the user be able to select files witout opening directly? 
       * Put on true to enabling the selecting function
       * @type {Boolean}
       * @default false
       */
      enableSelecting: false,
      /**
       * @name nixps-cloudflow.IconView#enableMultipleSelection
       * @description If enableSelection is set on true, are we allowed to select multiple files or can we only select one a time
       * @type {Boolean}
       * @default true
       */
      enableMultipleSelection: true,
      /**
       * @name nixps-cloudflow.IconView#fastMultipleSelection
       * @description Must we enable fast multi selection or not?
       * @type {Boolean}
       * @default false
       */
      fastMultipleSelection: false,
      /**
       * @name nixps-cloudflow.IconView#deselectable
       * @description Must we able to deselect files or folders?
       * @default false
       * @type {Boolean}
       */
      deselectable: false,
      childrenSelectorSelecting: "children",
      /**
       * @description Is the user allowed to drag assets to folders
       * @name nixps-cloudflow.IconView#enableAssetDragging
       * @type {Boolean}
       * @default false
       */
      enableAssetDragging: false,
      /**
       * @description define if something may be copied or moved to that folder
       * @name nixps-cloudflow.IconView#mayDrop
       * @type {Funtion}
       * @param {Object} pFolder
       * @returns {Boolean}
       */
      mayDrop: function mayDrop(pFolder) {
        return pFolder !== undefined && pFolder.cloudflow !== undefined && pFolder.cloudflow.folder !== "cloudflow://";
      },
      /**
       * @description Must we enable the contextmenu
       * @name nixps-cloudflow.IconView#enableContextMenu
       * @type {Boolean}
       * @default false
       */
      enableContextMenu: false,
      /**
       * @desc Must we show the download icon or not
       * @name nixps-cloudflow.IconView#showDownloadIcon
       * @type {Boolean}
       * @default false
       */
      showDownloadIcon: false,
      /**
       * @description html to show the approve icon on the image
       * @type {Object | dictionary}
       */
      approveIcons: {
        pending: '?',
        accepted: '&#10003;',
        // 'v',
        rejected: '&#10005;' // 'x'
      },

      orderBy: [],
      skip: 0,
      limit: 200,
      /**
       * @name nixps-cloudflow.IconView#iconWidth
       * @description The width of the icons
       * @private
       * @type {Number}
       * @default 150
       */
      iconWidth: 150,
      /**
       * @name nixps-cloudflow.IconView#stepSize
       * @description the amount of rows we must load for each time
       * @type {Number}
       * @default 200
       */
      stepSize: 200,
      /**
       * @name nixps-cloudflow.IconView#draggableOptions
       * @description the options given to the draggable jQury UI widget
       * @type {Object}
       * @default {
          helper: "clone",
          opacity: 0.5,
          revert: "invalid"
         }
       */
      draggableOptions: {
        helper: "clone",
        opacity: 0.7,
        revert: "invalid",
        cursor: "move",
        distance: 10,
        drag: function drag(pEvent, pUI) {
          if (pEvent.metaKey) {
            $(pUI.helper).addClass('help_dragging_copy');
          } else {
            $(pUI.helper).removeClass('help_dragging_copy');
          }
        }
      },
      /**
       * @name nixps-cloudflow.IconView#droppableOption
       * @description the options given to the droppable jQury UI widget
       * @type {Object}
       * @default {
          accept: ".typeFile",
          hoverClass: "ui-droppable-hover"
      }
       */
      droppableOption: {
        accept: ".typeFile",
        hoverClass: "ui-droppable-hover",
        "tolerance": "pointer"
      }
    },
    _fileNameFormatter: function _fileNameFormatter(p_data) {
      if (p_data.site === true) {
        // if it is a site
        if (p_data.parent === true) {
          return $.i18n._('nixps-cloudflow-assets.parentsite');
        } else if (p_data.name !== undefined) {
          return p_data.name;
        } else {
          return "";
        }
        // else if it is not a site
      } else if (p_data.cloudflow === undefined) {
        return "";
      } else if (p_data.cloudflow.file !== undefined) {
        return decodeURIComponent(getFileName(p_data.cloudflow.file));
      } else if (p_data.cloudflow.parent === true) {
        return $.i18n._('nixps-cloudflow-assets.parentfolder');
      } else if (p_data.cloudflow.recyclebin === true) {
        return $.i18n._("nixps-cloudflow-assets.recyclebin");
      } else if (p_data.cloudflow.folder !== undefined) {
        return decodeURIComponent(getFileName(p_data.cloudflow.folder.substring(0, p_data.cloudflow.folder.length - 1)));
      }
      return "";
    },
    _thumbFolderFormater: function _thumbFolderFormater(pData) {
      if (pData.site === true) {
        // temp for the moment
        if (pData.parent === true) {
          return "cf-icon cf-icon-site-up";
        } else {
          return "cf-icon cf-icon-site";
        }
      } else if (pData.cloudflow.enclosing_folder === "") {
        return "cf-icon cf-icon-filestore";
      } else if (pData.cloudflow.parent === true) {
        return "cf-icon cf-icon-folder-chevron-up-filled";
      } else if (pData.cloudflow.recyclebin) {
        return "cf-icon cf-icon-trash";
      } else {
        return "cf-icon cf-icon-folder-filled";
      }
    },
    _thumbFormatter: function _thumbFormatter(p_data) {
      if (p_data.thumb === undefined || p_data.thumb.length === 0) {
        return Asset.getDedicatedFileIcon(p_data.filetype, 1);
      } else {
        return this.options.baselocation + p_data.thumb;
      }
    },
    // [START] TODO: TEMPORARY TO REMOVE ////////////////////////////////////////////
    _thumbFormatterForLMSLayoutFile: function _thumbFormatterForLMSLayoutFile(p_data) {
      return $.Deferred(function (pDefer) {
        api_async.file.read_string(p_data.cloudflow.part, function (pString) {
          var layout = JSON.parse(pString.contents);
          if ($.isPlainObject(layout.lms) === true && typeof layout.lms.thumbnail === "string") {
            pDefer.resolve(layout.lms.thumbnail);
          } else if ($.isPlainObject(layout.data) === true && typeof layout.data.thumbnail === "string") {
            pDefer.resolve(layout.data.thumbnail);
          } else {
            // Transparent image
            pDefer.resolve("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");
          }
        }, pDefer.reject);
      });
    },
    // [END] TODO: TEMPORARY TO REMOVE ////////////////////////////////////////////////

    _hasMultipleApproveStates: function _hasMultipleApproveStates(pFileData) {
      return pFileData.approvals !== undefined && pFileData.approvals.length > 1;
    },
    _getApprovalData: function _getApprovalData(p_data) {
      if (p_data.approvals !== undefined) {
        var aggregatedAssessment = "";
        for (var assesmentIndex = 0; assesmentIndex < p_data.approvals.length; ++assesmentIndex) {
          var checkAssessment = p_data.approvals[p_data.approvals.length - 1 - assesmentIndex].assessment;
          if (aggregatedAssessment === '' && checkAssessment !== "cancel" || checkAssessment === "pending") {
            aggregatedAssessment = checkAssessment;
          }
        }
        if (aggregatedAssessment === "") {
          // nothing ...
        } else if (aggregatedAssessment === "reject") {
          return {
            state: "rejected",
            label: $.i18n._('nixps-cloudflow-assets.status_rejected')
          };
        } else if (aggregatedAssessment === "accept") {
          return {
            state: "accepted",
            label: $.i18n._('nixps-cloudflow-assets.status_approved')
          };
        } else {
          return {
            state: "pending",
            label: $.i18n._('nixps-cloudflow-assets.status_waiting_approval')
          };
        }
      }
      return null;
    },
    _subAssetFormatter: function _subAssetFormatter(p_data) {
      if (p_data.sub !== undefined && p_data.sub !== "") {
        if (p_data.sub.indexOf("p_") === 0) {
          var page = parseInt(p_data.sub.substring(2), 10) + 1;
          return "<br/><font size='2'><i>" + _.escape($.i18n._('nixps-cloudflow-assets.page_n', page)) + "</i></font>";
        }
      }
      return "";
    },
    _create: function _create() {
      this._controlOptions();
      this.downloadIcon = $('<div>').addClass('actionIcon downloadIcon').append($('<span>').addClass('fa fa-download fa-lg noAdvancedToolTip').attr('title', _.escape($.i18n._('nixps-cloudflow-assets.action-download_file')))).append($("<div>").text($.i18n._("nixps-cloudflow-assets.action-download_file"))).css({
        'position': 'absolute',
        'overflow': 'visible',
        'z-index': 2,
        'white-space': 'nowrap'
      });
      this.amountIconsOnLine = 0;
      this.selectedFolderIDs = undefined;
      this.selectedFilesIDs = undefined;
      if (this.options.enableAssetDragging === true && this.options.enableSelecting === true && this.options.enableMultipleSelection === true) {
        if ($.isPlainObject(this.options.draggableOptions)) {
          this.options.draggableOptions.helper = this._draggableHelper.bind(this);
        }
      }

      // Create our UI
      var containerDOM = $("<div>").addClass("iconview_container");
      this.element.addClass(this.widgetFullName).append(containerDOM).append($("<div>").addClass("bottombar").hide().append($("<button>").attr("type", "button").addClass("loadMore cf-button-secondary colored-button").text($.i18n._("nixps-cloudflow-assets.load_more_text"))));
      if (this.options.enableSelecting === true) {
        containerDOM.attr("role", "grid");
        if (this.options.enableMultipleSelection === true) {
          containerDOM.attr("aria-multiselectable", "true");
        }
      }
      this._redraw();
      this.element.tooltip({
        tooltipClass: 'icon-view-tooltip',
        classes: {
          "ui-tooltip": "icon-view-tooltip"
        },
        track: false,
        position: {
          my: "left top+15",
          at: "left bottom",
          collision: "none"
        }
      });
      this._on(this.element, {
        "selectingselect": this._selectHandler,
        "click .thumb_box:not(.item_processing)": this._clickImageHandler,
        "dblclick .thumb_box:not(.item_processing)": this._dblclickImageHandler,
        "click .downloadIcon": this._downloadClickHandler,
        "click button.loadMore": this._loadMoreClickHandler
      });
      if (this.options.enableContextMenu === true) {
        this._on(this.element, {
          "contextmenu": this._rightClickHandler
        });
      }
      if (this.options.enableSelecting === true) {
        this.element.children(".iconview_container").Selecting({
          items: ".thumb_box",
          selectClass: kSelectClassName,
          cancel: "input,textarea,button,select,option,[contenteditable='true'],[contenteditable='plaintext-only'],.downloadIcon, .parentFolder, .thumb_box_hidden",
          multiple: this.options.enableMultipleSelection,
          fastMultiple: this.options.fastMultipleSelection,
          deselectable: this.options.deselectable,
          childrenSelector: this.options.childrenSelectorSelecting
        });
        var containerWidth = this.element.width();
        var iconOuterWidth = this.options.iconWidth + 82;
        this.amountIconsOnLine = Math.floor(containerWidth / iconOuterWidth);
        this.windowResizeHandler = _.debounce(this._windowResizeHandler, 20);
        $(document).on("resize", this.windowResizeHandler.bind(this));
      }
    },
    _selectHandler: function _selectHandler() {
      this._trigger('select', null, {
        files: this.getSelectedItemData(),
        selected_all: this.isAllSelected()
      });
      //return false;
    },

    /**
     * @desc function runs when user single click on the image container
     * @function 
     * @private
     * @name nixps-cloudflow.IconView#_clickImageHandler
     **/
    _clickImageHandler: function _clickImageHandler(pEvent, pData) {
      if (this.options.enableSelecting !== true) {
        // activate when option is not set on true,
        // it must be activated on default, and any other case exept true
        var fileData = $(pEvent.currentTarget).data("dataitem");
        this._trigger('open', null, fileData);
      }
    },
    /**
     * @desc function runs when user double click on the imahe container
     * @function
     * @private
     * @name nixps-cloudflow.IconView#_dblclickImageHandler
     * @return {undefined}
     **/
    _dblclickImageHandler: function _dblclickImageHandler(pEvent, pData) {
      if (this.options.enableSelecting === true) {
        // only activate when option is set on true
        var fileData = $(pEvent.currentTarget).data("dataitem");
        this._trigger('open', null, fileData);
      }
    },
    /**
     * @description function runs when user want to download a file
     * @function
     * @private
     * @name nixps-cloudflow.IconView#_downloadClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {Boolean}
     */
    _downloadClickHandler: function _downloadClickHandler(pEvent, pData) {
      var fileData = $(pEvent.target).closest('.thumb_box').data("dataitem");
      if ($.isPlainObject(fileData.cloudflow) && typeof fileData.cloudflow.file === "string" && fileData.cloudflow.file.length > 0) {
        location.href = this.options.baselocation + "/portal.cgi?asset=download_file&url=" + encodeURIComponent(fileData.cloudflow.file);
      }
      return false;
    },
    /**
     * @description function runs when user click on load more button. This will load more files and folders
     * @function
     * @private
     * @name nixps-cloudflow.IconView#_loadMoreClickHandler
     * @param {type} pEvent
     * @returns {undefined}
     */
    _loadMoreClickHandler: function _loadMoreClickHandler(pEvent) {
      $(pEvent.currentTarget).prop('disabled', true);
      // adapt the options.limit to a correct value
      this.options.limit += this.options.stepSize;
      // ask one more to control if there is a overload.
      this._trigger('dataprovider', null, {
        orderBy: this.options.orderBy,
        skip: this.options.skip,
        limit: this.options.limit + 1
      });
    },
    /**
     * @description fucntion runs when user right click/ contextmenu
     * @function
     * @private
     * @name nixps-cloudflow.IconView#_rightClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {Boolean}
     */
    _rightClickHandler: function _rightClickHandler(pEvent, pData) {
      var thumbBox = $(pEvent.target).closest('.thumb_box');
      if (thumbBox.length === 1 && thumbBox.is(':not(.item_processing)')) {
        var itemData = thumbBox.data("dataitem");
        if (itemData && !$.isEmptyObject(itemData.cloudflow) && itemData.cloudflow.parent !== true && itemData.site !== true) {
          if (typeof itemData.cloudflow.file === "string" && itemData.cloudflow.file.length > 0) {
            this._trigger("contextmenu", pEvent, {
              url: itemData.cloudflow.file,
              itemData: itemData,
              targetDOMElement: thumbBox
            });
          } else if (typeof itemData.cloudflow.folder === "string" && itemData.cloudflow.folder.length > 0) {
            this._trigger("contextmenu", pEvent, {
              url: itemData.cloudflow.folder,
              itemData: itemData,
              targetDOMElement: thumbBox
            });
          }
        }
      }
      return false;
    },
    /**
     * @description function runs as helper of the draggable, only in multiselect handler
     * @function
     * @name nixps-cloudflow.IconView#_draggableHelper
     * @private
     * @param {Object} pEvent 
     */
    _draggableHelper: function _draggableHelper(pEvent) {
      var currentItem = $(pEvent.currentTarget);
      var otherItems;
      var items = [currentItem.data("dataitem")];
      var isItemSelected = currentItem.hasClass(kSelectClassName);
      if (isItemSelected) {
        otherItems = this.element.children(".iconview_container").children(".thumb_box." + kSelectClassName).not(currentItem).each(function () {
          items.push($(this).data("dataitem"));
        }).clone().removeAttr("id");
      }
      var container = $("<div>").addClass("multipleDraggableHelperContainer").data("items", items);
      container.append(currentItem.clone().removeAttr("id"));
      if (isItemSelected) {
        container.append(otherItems);
      }
      return container;
    },
    _clearIcons: function _clearIcons() {
      this.element.find(".iconview_container").children().remove();
    },
    _windowResizeHandler: function _windowResizeHandler(pEvent, pWidth, pHeight) {
      if (typeof pWidth === "number") {
        // check if it is a document event and not a widget event
        var containerWidth = this.element.width();
        var iconOuterWidth = this.element.children(".iconview_container").children(".thumb_box").eq(0).outerWidth(true);
        this.amountIconsOnLine = Math.floor(containerWidth / iconOuterWidth);
      }
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRefresh = false;
      if (options.orderBy !== undefined && _.isEqual(this.options.orderBy, options.orderBy) === false) {
        console.log(options.orderBy);
        this._clearIcons();
        this._redraw();
      }
      $.each(options, function (key, value) {
        that._setOption(key, value);
        if (key === "folders" || key === "files" || key === "showUploadIcon" || key === "showViewIcon") {
          needRefresh = true;
        }
      });
      if (this.options.enableSelecting === true && options.folders === undefined && options.files === undefined) {
        this.selectedFolderIDs = {};
        this.selectedFilesIDs = {};
        this.element.children(".iconview_container").children(".typeFolder." + kSelectClassName).each(function () {
          that.selectedFolderIDs[$(this).attr("data-id")] = 1;
        });
        this.element.children(".iconview_container").children(".typeFile." + kSelectClassName).each(function () {
          that.selectedFilesIDs[$(this).attr("data-id")] = 1;
        });
      }
      if (this.options.enableAssetDragging === true && $.isPlainObject(this.options.draggableOptions)) {
        if (this.options.enableSelecting === true && this.options.enableMultipleSelection === true) {
          this.options.draggableOptions.helper = this._draggableHelper.bind(this);
        } else {
          // reset to original value
          this.options.draggableOptions.helper = "clone";
        }
      }
      if (needRefresh === true) {
        this._redraw();
      }
      if (this.options.enableSelecting === true && this.selectedFolderIDs !== undefined && options.folders !== undefined) {
        this.element.children(".iconview_container").children(".typeFolder").each(function () {
          if (that.selectedFolderIDs[$(this).attr("data-id")] !== undefined) {
            $(this).addClass(kSelectClassName);
          }
        });
        this.selectedFolderIDs = undefined;
      }
      if (this.options.enableSelecting === true && this.selectedFilesIDs !== undefined && options.files !== undefined) {
        this.element.children(".iconview_container").children(".typeFile").each(function () {
          if (that.selectedFilesIDs[$(this).attr("data-id")] !== undefined) {
            $(this).addClass(kSelectClassName);
          }
        });
        this.selectedFilesIDs = undefined;
      }
    },
    _setOption: function _setOption(p_key, p_value) {
      if (p_key === "enableSelecting") {
        if (p_value === true && p_value !== this.options.enableSelecting) {
          this._super(p_key, p_value);
          this._controlOptions();
          var containerWidth = this.element.width();
          var iconOuterWidth = this.options.iconWidth + 82;
          this.amountIconsOnLine = Math.floor(containerWidth / iconOuterWidth);
          this.windowResizeHandler = _.debounce(this._windowResizeHandler, 20);
          $(document).on("resize", this.windowResizeHandler.bind(this));
          this.element.children(".iconview_container").Selecting({
            items: ".thumb_box",
            selectClass: kSelectClassName,
            cancel: "input,textarea,button,select,option,[contenteditable='true'],[contenteditable='plaintext-only'],.downloadIcon, .parentFolder",
            multiple: this.options.enableMultipleSelection,
            fastMultiple: this.options.fastMultipleSelection,
            deselectable: this.options.deselectable
          });
        } else if (p_value === false && p_value !== this.options.enableSelecting) {
          this._super(p_key, p_value);
          this._controlOptions();
          $(document).off("resize", this.windowResizeHandler.bind(this));
          this.element.children(".iconview_container").Selecting("destroy");
        }
      } else if (p_key === "deselectable") {
        if (p_value === true && p_value !== this.options.deselectable) {
          this._super(p_key, p_value);
          this._controlOptions();
          this.element.children(".iconview_container").Selecting({
            deselectable: this.options.deselectable
          });
        }
      } else {
        this._super(p_key, p_value);
        this._controlOptions();
      }
    },
    changeOptionsSilence: function changeOptionsSilence(options) {
      var that = this;
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
    },
    /**
     * @description control the input options of the component
     * @function
     * @private
     * @name nixps-cloudflow.IconView#_controlOptions
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.stepSize !== "number" || this.options.stepSize <= 0) {
        throw new Error("input option stepSize must be a positive number");
      }
      if (typeof this.options.baselocation !== "string") {
        throw new Error("input option baselocation must be a string");
      }
      if (typeof this.options.iconWidth !== "number" || this.options.iconWidth <= 0) {
        throw new Error("input option iconWidth must be a positive number");
      }
    },
    _redraw: function _redraw() {
      var showMoreButton = false;
      var container = this.element.children(".iconview_container");
      // remove first all items that are not present any more
      container.children(".typeFolder").removeUnUsed(this.options.folders);

      // Folders
      if (Array.isArray(this.options.folders)) {
        if (this.options.folders.length > this.options.limit) {
          this.options.folders = this.options.folders.slice(0, this.options.limit - this.options.folders.length);
          showMoreButton = true;
        }
        for (var idx = 0; idx < this.options.folders.length; idx++) {
          // if there is no item in the ui, add the item to it.
          if (container.children(".typeFolder").length === 0) {
            container.prepend(this._makeFolderElement(this.options.folders[idx]));
          } else if (typeof this.options.folders[idx]._id === "string" && container.children('.typeFolder[data-id="' + this.options.folders[idx]._id + '"]').length === 0) {
            // if the item is not present, then it is new to it. 
            // Try to insert in the correct place 
            if (idx > 0) {
              var prevElem = container.children('.typeFolder[data-id="' + this.options.folders[idx - 1]._id + '"]');
              if (prevElem.length > 0) {
                prevElem.after(this._makeFolderElement(this.options.folders[idx]));
              } else {
                // if only parent folder is there, he has no data-id attr
                // there might also be a recyclebin present? let's see how much we offset to append after
                var alreadyPresent = container.children(".typeFolder").length - 1;
                container.children(".typeFolder").eq(alreadyPresent).after(this._makeFolderElement(this.options.folders[idx]));
              }
            } else {
              // if idx === 0
              container.children(".typeFolder").eq(0).before(this._makeFolderElement(this.options.folders[idx]));
            }
          }
          // folders that already exists, do not need a update,
          // but two have no _id: the parent folder & recycle bin
          else if (typeof this.options.folders[idx]._id !== "string") {
            // if not present add it.
            if (this.options.folders[idx].cloudflow.parent === true) {
              var parentFolder = this.element.find(".typeFolder:not([data-id]).parentFolder");
              if (parentFolder.length > 0) {
                // replace parent folder
                parentFolder.replaceWith(this._makeFolderElement(this.options.folders[idx], parentFolder.hasClass("select")));
              } else {
                container.prepend(this._makeFolderElement(this.options.folders[idx]));
              }
            } else if (this.options.folders[idx].cloudflow.recyclebin === true) {
              var recycleBinFolder = this.element.find(".typeFolder:not([data-id]).recycleBin");
              if (recycleBinFolder.length > 0) {
                // replace recyclebin folder
                recycleBinFolder.replaceWith(this._makeFolderElement(this.options.folders[idx], recycleBinFolder.hasClass("select")));
              } else {
                //check if the parentfolder is there?
                var parentFolder = this.element.find(".typeFolder:not([data-id]).parentFolder");
                if (parentFolder.length > 0) {
                  parentFolder.after(this._makeFolderElement(this.options.folders[idx]));
                } else {
                  container.prepend(this._makeFolderElement(this.options.folders[idx]));
                }
              }
            }
          }
        }
      }

      // remove files that are not present anymore
      container.children(".typeFile").removeUnUsed(this.options.files);

      // Files
      if (Array.isArray(this.options.files)) {
        if (this.options.files.length > this.options.limit) {
          this.options.files = this.options.files.slice(0, this.options.limit - this.options.files.length);
          showMoreButton = true;
        }
        var file = undefined;
        for (var idx = 0; idx < this.options.files.length; idx++) {
          file = this.options.files[idx];
          // if there are not files in the ui, add the first file then.
          if (container.children(".typeFile").length === 0) {
            container.append(this._makeFileElement(this.options.files[idx]));
          } else if (typeof file._id === "string" && container.children('.typeFile[data-id=' + file._id + ']').length === 0) {
            // if file is not present insert to the correct place
            if (idx > 0) {
              container.children('.typeFile[data-id=' + this.options.files[idx - 1]._id + ']').after(this._makeFileElement(file));
            } else {
              container.children(".typeFile").eq(0).before(this._makeFileElement(file));
            }
            // in the other case do we need updating? if so, do it.
          } else if (this._needFileReplace(file, this.element.find(".typeFile[data-id=" + file._id + "]").data("dataitem")) === true) {
            container.children(".typeFile[data-id=" + file._id + "]").replaceWith(this._makeFileElement(file, container.hasClass("select")));
          }
        }
      }
      this._delay(function () {
        this.element.find(".bottombar").toggle(showMoreButton).children("button").prop("disabled", false);
        var amount = this.options.files === undefined ? 0 : this.options.files.length;
        amount += this.options.folders === undefined ? 0 : this.options.folders.length;
        this._trigger("refreshfinished", null, {
          amount: amount
        });
      });
    },
    /**
     * @description make and returns the ui for the folder
     * @function
     * @private
     * @name nixps-cloudflow.IconView#_makeFolderElement
     * @param {object} folderobject
     * @returns {window.$|$} html DOM element that represents the folder object
     */
    _makeFolderElement: function _makeFolderElement(folder, pSelected) {
      var isInMaking = typeof folder._id === "string" && kInmakingReg.test(folder._id);
      var folderName = this._fileNameFormatter(folder);
      var container = generate_icon("transparant_thumb_border", "transparent_thumb_image " + this._thumbFolderFormater(folder), "<span title='" + _.escape(folderName) + "'>" + _.escape(folderName) + "</span>", this.options.iconWidth);
      if (this.options.enableAssetDragging === true && isInMaking === false && this.options.mayDrop(folder)) {
        container.droppable(this.options.droppableOption);
      }
      container.attr("tabindex", -1);
      if (pSelected === true) {
        container.addClass(kSelectClassName);
      }
      if (folder.cloudflow.parent === true) {
        container.addClass("parentFolder");
      }
      if (folder.cloudflow.recyclebin === true) {
        container.addClass("recycleBin");
      }
      return container.data("dataitem", folder).attr("data-id", folder._id).addClass("typeFolder").addClass(function () {
        if (isInMaking) {
          return "item_processing";
        }
      });
    },
    /**
     * @description make and returns the ui for the file
     * @function
     * @name nixps-cloudflow.IconView#_makeFileElement
     * @private
     * @param {object} fileobject
     * @returns {window.$|$} html DOM element that represents the file
     */
    _makeFileElement: function _makeFileElement(file, pSelected) {
      var isInMaking = typeof file._id === "string" && kInmakingReg.test(file._id);
      var fileName = this._fileNameFormatter(file);
      var subText = "<span title='" + _.escape(fileName) + "'>" + _.escape(fileName) + "</span>" + this._subAssetFormatter(file);

      // [START] TODO: TEMPORARY TO REMOVE ////////////////////////////////////////////
      if ($.isPlainObject(file) === true && file.filetype === "application/json" && typeof file.file_name === "string" && kLmsCheckReg.test(file.file_name)) {
        var that = this;
        var callback = function (pFile, pFileName) {
          var file = pFile;
          return function (thumb) {
            var subText = "<span title='" + _.escape(pFileName) + "'>" + _.escape(pFileName) + "</span>";
            var container = generate_thumb("transparant_thumb_border", "thumb_image", thumb, subText, that.options.iconWidth);
            container.data("dataitem", file).attr("data-id", file._id).addClass("typeFile").attr("tabindex", -1);
            that.element.find(".typeFile[data-id=" + file._id + "]").replaceWith(container);
            if (that.options.showDownloadIcon === true) {
              container.find(".thumb_border").append(that.downloadIcon.clone());
            }
            if (that.options.enableAssetDragging === true) {
              container.draggable(that.options.draggableOptions);
            }
          };
        }(file, fileName);
        this._thumbFormatterForLMSLayoutFile(file).then(callback);
        return $("<div>").data("dataitem", file).attr("data-id", file._id).addClass("typeFile").addClass(function () {
          var returnClasses = " ";
          if (isInMaking) {
            returnClasses += "item_processing";
          }
          if (pSelected === true) {
            returnClasses += kSelectClassName;
          }
          return returnClasses;
        });
      }
      // [END] TODO: TEMPORARY TO REMOVE ////////////////////////////////////////////
      else {
        var container;
        if (typeof file.thumb === "string" && file.thumb.length > 0) {
          container = generate_thumb("thumb_border", "thumb_image", this._thumbFormatter(file), subText, this.options.iconWidth);
        } else {
          container = generate_icon("transparant_thumb_border", "transparent_thumb_image " + this._thumbFormatter(file), subText, this.options.iconWidth);
        }
        var approvalData = this._getApprovalData(file);
        var thumb_border = container.data("dataitem", file).attr("data-id", file._id).addClass("typeFile").find(".thumb_border, .transparant_thumb_border");
        if (approvalData && this._hasMultipleApproveStates(file)) {
          thumb_border.append($("<span>").addClass("approvalIcon approvalStateMultiple").addClass("state-" + approvalData.state).text($.i18n._("nixps-cloudflow-assets.status_multiplestack_abbreviation")));
        } else if (approvalData) {
          thumb_border.append($("<span>").addClass("approvalIcon").addClass("state-" + approvalData.state).append(this.options.approveIcons[approvalData.state]));
        }
        if (file.sync_status !== undefined) {
          var progress = 0;
          var sites = Object.keys(file.sync_status);
          if (sites.length > 0) {
            for (var siteIndex = 0; siteIndex < sites.length; ++siteIndex) {
              var siteProgress = file.sync_status[sites[siteIndex]];
              if (siteProgress.progress === undefined) {
                progress += 1;
              } else {
                progress += siteProgress.progress;
              }
            }
            // for testing, decommand next line
            // progress = 0.5;
            if (progress == sites.length) {
              var icon = $("<span>").addClass("thumb_sync_status cf-icon cf-icon-lg cf-icon-check-circle cf-text-success");
              thumb_border.append(icon);
            } else {
              var progressDiv = $("<div>").addClass("thumb_sync_progress_bar");
              var progressFill = $("<div>").addClass("thumb_sync_progress_fill");
              progressFill.css("width", (100 * progress / sites.length).toFixed(0) + "%");
              thumb_border.append(progressDiv);
              progressDiv.append(progressFill);
            }
          }
        }
        if (this.options.showDownloadIcon === true) {
          thumb_border.append(this.downloadIcon.clone());
        }
        if (this.options.enableAssetDragging === true) {
          container.draggable(this.options.draggableOptions);
        }
        container.attr("tabindex", -1);
        if (pSelected === true) {
          container.addClass(kSelectClassName);
        }
        if (isInMaking) {
          container.addClass("item_processing");
        }
        return container;
      }
    },
    /**
     * @description Must we update the file or not?
     * @function
     * @name nixps-cloudflow.IconView#_needFileReplace
     * @private
     * @param {object} pNewFile fileobject of the current state 
     * @param {object} pOldFile fileobject of the old state
     * @returns {Boolean} true if the ui-file need to be updated, false if the ui may stay as it.
     */
    _needFileReplace: function _needFileReplace(pNewFile, pOldFile) {
      if (pNewFile.thumb !== pOldFile.thumb) {
        return true; // in case of new calculated thumb is ready
      } else if ($.isPlainObject(pNewFile.sync_status) && $.isPlainObject(pOldFile.sync_status)) {
        // if a sync status is aviable in old and new
        if (_.isEqual(pNewFile.sync_status, pOldFile.sync_status) === false) {
          return true; // if the status are different
        }
      } else if ($.isPlainObject(pNewFile.sync_status) || $.isPlainObject(pOldFile.sync_status)) {
        // in case of adding or removing the sync status
        return true;
      } else if (Array.isArray(pNewFile.approvals) && Array.isArray(pOldFile.approvals)) {
        if (_.isEqual(pNewFile.approvals, pOldFile.approvals) === false) {
          return true;
        }
      } else if (Array.isArray(pNewFile.approvals) || Array.isArray(pOldFile.approvals)) {
        // in case of adding or removing the approvals status
        return true;
      } else if (pNewFile.file_name !== pOldFile.file_name) {
        // the file has same id but has changed name
        return true;
      } else if (pNewFile.filetype !== pOldFile.filetype) {
        // the file has same id but has changed name
        return true;
      }
      // default, in all other cases, the files do not need to be updated
      return false;
    },
    selectByTyping: function selectByTyping(pSearchString) {
      if (this.options.enableSelecting === false) {
        //no selecting possible
        return;
      }
      var found = false;
      var foundName;
      var _iterator = _createForOfIteratorHelper(this.options.folders),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pFolder = _step.value;
          if (found) {
            break;
          }
          if (pFolder.name !== undefined && pFolder.name.toLowerCase().startsWith(pSearchString) === true) {
            foundName = pFolder.name;
            found = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (foundName === undefined) {
        var _iterator2 = _createForOfIteratorHelper(this.options.files),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var pFile = _step2.value;
            if (found) {
              break;
            }
            if (pFile.file_name !== undefined && pFile.file_name.toLowerCase().startsWith(pSearchString) === true) {
              foundName = pFile.file_name;
              found = true;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      if (foundName !== undefined) {
        this.selectItems([foundName]);
        this.element.find(".thumb_box." + kSelectClassName).focus();
      }
    },
    appendFolders: function appendFolders(pFolders) {
      if (Array.isArray(pFolders) && pFolders.length > 0) {
        if (Array.isArray(this.options.folders) === false) {
          this.options.folders = [];
        }
        var container = this.element.children(".iconview_container");
        for (var i = 0; i < pFolders.length; i++) {
          container.append(this._makeFolderElement(pFolders[i]));
          this.options.folders.push(pFolders[i]);
        }
      }
    },
    appendFiles: function appendFiles(pFiles) {
      if (Array.isArray(pFiles) && pFiles.length > 0) {
        if (Array.isArray(this.options.files) === false) {
          this.options.files = [];
        }
        var container = this.element.children(".iconview_container");
        for (var i = 0; i < pFiles.length; i++) {
          container.append(this._makeFolderElement(pFiles[i]));
          this.options.files.push(pFiles[i]);
        }
      }
    },
    /**
     * @description Select all files and folders that are visible, so not selecting the invisible 
     * @function
     * @name nixps-asset.IconView#selectAll
     * @returns {undefined}
     */
    selectAll: function selectAll() {
      if (this.options.enableSelecting === true) {
        this.element.find(".thumb_box").addClass(kSelectClassName);
        this._trigger("select", null, {
          files: this.getSelectedItemData(),
          selected_all: true
        });
      }
    },
    /**
     * @description Unselect all files and folders
     * @function
     * @name nixps-asset.IconView#unselectAll
     * @param {String} pQueryExeptionSelection string provided to skip the DOM who would not need to be unselected
     * @returns {undefined}
     */
    unselectAll: function unselectAll(pQueryExeptionSelection) {
      if (this.options.enableSelecting === true) {
        this.element.find(".thumb_box." + kSelectClassName).not(pQueryExeptionSelection).removeClass(kSelectClassName);
        this._trigger("select", null, {
          files: [],
          selected_all: false
        });
      }
    },
    /**
     * @description Are there assets who are selected or not?
     * @function
     * @name nixps-asset.IconView#hasSelectedItems
     * @returns {Boolean} true if theier are assets who are selected
     */
    hasSelectedItems: function hasSelectedItems() {
      return this.element.find(".thumb_box." + kSelectClassName).lenght > 0;
    },
    /**
     * @description Get all data of all assets who are selected
     * @function
     * @name nixps-cloudflow.IconView#getSelectedItemData
     * @return {array} containing data of all selected assests
     */
    getSelectedItemData: function getSelectedItemData() {
      return this.element.find(".thumb_box." + kSelectClassName).map(function () {
        return $(this).data("dataitem");
      }).get();
    },
    /**
     * @description Check if all asstes are selected or not
     * @function
     * @name nixps-cloudflow.IconView#isAllSelected
     * @returns {Boolean} true if all asstes are selected, false otherwise
     */
    isAllSelected: function isAllSelected() {
      return this.element.find(".thumb_box:visible." + kSelectClassName).length === this.element.find(".thumb_box:visible").length;
    },
    /**
     * @description Select the first file where the filename match
     * @function
     * @name nixps-cloudflow.IconView#selectItems
     * @param {Array} a items
     * @return {undefined}
     */
    selectItems: function selectItems(pItems) {
      this.element.find(".thumb_box." + kSelectClassName).removeClass(kSelectClassName);
      if (Array.isArray(pItems) && pItems.length > 0) {
        if (typeof pItems[0] === "string") {
          this.element.find(".thumb_box").children(".thumb_name").children().each(function () {
            var fileName = $(this).attr("title");
            if (pItems.indexOf(fileName) >= 0) {
              $(this).closest(".thumb_box").addClass(kSelectClassName);
              return false;
            }
          });
        } else {
          for (var i = 0; i < pItems.length; i++) {
            if (typeof pItems[i]._id === "string") {
              this.element.find('.thumb_box[data-id="' + pItems[i]._id + '"]').addClass(kSelectClassName);
            } else if ($.isPlainObject(pItems[i]) && pItems[i].cloudflow !== undefined && pItems[i].cloudflow.parent === true) {
              var firstData = this.element.find(".thumb_box").not("[data-id]").first().data("dataitem");
              if (firstData.cloudflow !== undefined && _.isEqual(firstData.cloudflow, pItems[i].cloudflow)) {
                this.element.find(".thumb_box").not("[data-id]").first().addClass(kSelectClassName);
              }
            }
          }
        }
      }
    },
    moveSelected: function moveSelected(pEvent, pDirection) {
      this.element.children(".iconview_container").Selecting("moveSelected", pEvent, pDirection);
      this._trigger("select", null, {
        files: this.getSelectedItemData(),
        by: "moveSelected"
      });
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      if (this.element.data("uiTooltip") !== undefined) {
        this.element.tooltip("destroy");
      }
      this._superApply(arguments);
    }
  });
  function generate_thumb(pThumbBorderClass, pTumbImageClass, p_img_url, p_caption, pDimension) {
    // Generate the Box HTML
    var l_box = $("<div>").addClass("thumb_box").css({
      "width": pDimension + 12 + "px",
      "height": pDimension + 32 + "px"
    });

    // Generate the Border HTML
    var l_border = $("<div>").addClass(pThumbBorderClass).css({
      "width": pDimension + 12 + "px",
      "height": pDimension + 12 + "px"
    });
    l_border.appendTo(l_box);
    var l_href = $("<span>");
    l_href.appendTo(l_border);

    // Generate the Image HTML
    var l_image = $("<img>").addClass(pTumbImageClass).attr({
      "max_dim": pDimension,
      "src": p_img_url,
      "alt": "" // there are the labels that give more info
    }).css({
      "width": pDimension + "px",
      "height": pDimension + "px"
    });
    if (l_image.complete) {
      reposition_thumb(l_image);
    } else {
      l_image.on("load", function () {
        reposition_thumb($(this));
      });
    }
    l_image.appendTo(l_href);
    l_box.append($("<div>").addClass("thumb_name").append(p_caption));

    // Return top-level object
    return l_box;
  }
  function generate_icon(pThumbBorderClass, pTumbImageClass, p_caption, pDimension) {
    // Generate the Box HTML
    var l_box = $("<div>").addClass("thumb_box").css({
      "width": pDimension + 12 + "px",
      "height": pDimension + 32 + "px"
    });

    // Generate the Border HTML
    var l_border = $("<div>").addClass(pThumbBorderClass).css({
      "width": pDimension + 12 + "px",
      "height": pDimension + 12 + "px"
    });
    l_border.appendTo(l_box);

    // Generate the Image HTML
    var l_image = $("<span>").addClass(pTumbImageClass).css({
      "fontSize": pDimension
    });
    l_image.appendTo(l_border);
    l_box.append($("<div>").addClass("thumb_name").append(p_caption));

    // Return top-level object
    return l_box;
  }
  function reposition_thumb(thumb_image) {
    var new_width = thumb_image[0].naturalWidth;
    var new_height = thumb_image[0].naturalHeight;
    var max_dim = parseInt(thumb_image.attr("max_dim"));
    if (new_width < new_height) {
      var new_width = new_width * (max_dim / new_height);
      var new_height = max_dim;
    } else {
      var new_height = new_height * (max_dim / new_width);
      var new_width = max_dim;
    }
    thumb_image.css({
      "width": new_width + "px",
      "height": new_height + "px"
    });
    thumb_image.parent().parent().css({
      "height": new_height + 12 + "px",
      "width": new_width + 12 + "px",
      "margin-left": (max_dim - new_width) / 2 + "px",
      "margin-top": (max_dim - new_height) / 2 + "px"
    });
  }
})(jQuery);

},{"../../../common/Selectable/js/nixps-Selecting.js":318,"../../../nebulaportal/js/assetview/Asset.js":402}],172:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

(function ($) {
  var endingPageRegExp = new RegExp(".*p([0-9]+)\.[a-z]+$"); // if has a name that end as <something> + "p" + <number> + <extentie>

  function getApprovalID(pFileData) {
    if (Array.isArray(pFileData.approvals) && pFileData.approvals.length > 0) {
      for (var assesmentIndex = 0; assesmentIndex < pFileData.approvals.length; ++assesmentIndex) {
        var checkAssessment = pFileData.approvals[pFileData.approvals.length - 1 - assesmentIndex].assessment;
        if (checkAssessment === "pending") {
          var assessID = pFileData.approvals[pFileData.approvals.length - 1 - assesmentIndex].id;
        }
      }
      return assessID;
    }
    return null;
  }
  ;
  /**
   * @namespace nixps-cloudflow.ReaderView
   * @description component to display an overview of an book with assets
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.ReaderView", $["nixps-cloudflow"].IconView, {
    version: "1.0.0",
    widgetEventPrefix: "readerview",
    options: {
      /**
       * @name nixps-cloudlow.ReaderView#folders
       * @description The folders to show, in this case only a parent
       * @type {array}
       * @default undefined
       */
      folders: undefined,
      /**
       * @name nixps-cloudlow.ReaderView#files
       * @description The files, pages to show to the user
       * @type {array}
       * @default undefined
       */
      files: undefined,
      orderBy: [],
      skip: 0,
      /**
      * @name nixps-cloudflow.readersView#iconWidth
      * @description The width of the icons
      * @type {number}
      * @default 150
      */
      iconWidth: 150,
      /**
       * @name nixps-cloudflow.readersView#limit
       * @description the limit of files asked from the backend, and we must show
       * @type {number}
       * @default 30000
       */
      limit: 30000,
      /**
       * @name nixps-cloudflow.readersView#stepSize
       * @description the amount of rows we must load for each time
       * @type {number}
       * @default 200
      */
      stepSize: 200,
      /**
       * @name nixps-cloudlow.ReaderView#enableSelecting
       * @description Must the user be able to select files witout opening directly? 
       * Put on true to enabling the selecting function
       * @type {boolean}
       * @default true
      */
      enableSelecting: true,
      childrenSelectorSelecting: "find",
      /**
       * @name nixps-cloudlow.ReaderView#showUploadIcon
       * @description Must we show the replace button, to upload and replace a file
       * @type {boolean}
       * @default true
       */
      showUploadIcon: false,
      /**
       * @name nixps-cloudlow.ReaderView#showViewIcon
       * @description Must we show the view button, to show the details of the asset direclty
       * @type {boolean}
       * @default true
       */
      showViewIcon: false
    },
    _create: function _create() {
      this._super();
      this.uploadIcon = $("<div>").addClass("actionIcon uploadIcon").append($("<span>").addClass("fa fa-folder-open noAdvancedToolTip").attr("title", _.escape($.i18n._("nixps-cloudflow-assets.action-replace_file")))).append($("<div>").text($.i18n._("nixps-cloudflow-assets.action-replace_file"))).css({
        "position": "absolute",
        "top": 0,
        "left": "91%",
        "overflow": "visible",
        "z-index": 2,
        "white-space": "nowrap"
      });
      this.viewIcon = $("<div>").addClass("actionIcon viewIcon").append($("<span>").addClass("fa fa-file noAdvancedToolTip").attr("title", "Open File")).append($("<div>").append("Open File")).css({
        "position": "absolute",
        "left": "91%",
        "overflow": "visible",
        "z-index": 2,
        "white-space": "nowrap"
      });
      this.element.tooltip({
        items: ".pageTitle[title]:not(.noAdvancedToolTip)",
        track: false,
        tooltipClass: "icon-view-tooltip",
        classes: {
          "ui-tooltip": "icon-view-tooltip"
        },
        position: {
          my: "left top+15",
          at: "left bottom",
          collision: "none"
        },
        hide: false
      });
      this._on(this.element, {
        "click .parentFolderLink": this._parentLinkClickHandler,
        "click .uploadIcon": this._uploadClickHandler,
        "click .viewIcon": this._viewClickHandler
      });
    },
    /**
     * @desc function runs when user single click on the image container
     * This overwrite the function on iconView
     * @extends _clickImageHandler
     * @function 
     * @private
     * @name nixps-cloudflow.ReaderView#_clickImageHandler
    **/
    _clickImageHandler: function _clickImageHandler(pEvent, pData) {
      if (this.options.enableSelecting !== true) {
        // activate when option is not set on true,
        // it must be activated on default, and any other case exept true
        var fileData = $(pEvent.currentTarget).data("dataitem");
        this._trigger("open", null, fileData);
      }
    },
    /**
     * @description function runs when user press "parent folder" link
     * @function
     * @private
     * @name nixps-cloudflow.ReaderView#_parentLinkClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _parentLinkClickHandler: function _parentLinkClickHandler(pEvent, pData) {
      if (this.options.folders !== undefined && Array.isArray(this.options.folders) && this.options.folders.length > 0) {
        this._trigger("open", null, this.options.folders[0]);
      }
    },
    _uploadClickHandler: function _uploadClickHandler(pEvent, pData) {
      var fileData = $(pEvent.currentTarget).closest(".thumb_box").data("dataitem");
      this._trigger("action", null, {
        action: "replace",
        file: fileData
      });
      return false;
    },
    _viewClickHandler: function _viewClickHandler(pEvent, pData) {
      var fileData = $(pEvent.currentTarget).closest(".thumb_box").data("dataitem");
      this._trigger("open", null, fileData);
      return false;
    },
    _fileNameCompresser: function _fileNameCompresser(pFileName) {
      if (endingPageRegExp.test(pFileName)) {
        return pFileName.replace(endingPageRegExp, "p$1");
      }
      return pFileName;
    },
    _readerFileSorting: function _readerFileSorting(a, b) {
      if (a.cloudflow.file === undefined) {
        return -1;
      }
      if (b.cloudflow.file === undefined) {
        return 1;
      }
      return a.cloudflow.file.replace(endingPageRegExp, "$1") - b.cloudflow.file.replace(endingPageRegExp, "$1");
    },
    _redraw: function _redraw() {
      var that = this;
      var container = this.element.find(".iconview_container");

      // Parent Folder, add if information exists and if not added before
      if (container.children(".parentFolderLink").length === 0 && Array.isArray(this.options.folders) && !$.isEmptyObject(this.options.folders[0].cloudflow) && this.options.folders[0].cloudflow.parent === true) {
        var parentLink = $("<span>").addClass("parentFolderLink").append($("<span>").addClass("fa fa-arrow-up")).append("&nbsp;" + this._fileNameFormatter(this.options.folders[0]));
        container.prepend(parentLink);
      }

      // Files
      if (this.options.files !== undefined) {
        this.options.files.sort(this._readerFileSorting.bind(this));
      } else {
        // if no files, stop processing
        container.find(".pageView").remove();
        return true; // break
      }

      var thumb_boxs = container.find(".thumb_box[data-id]");
      // save old length
      var oldFilesLength = thumb_boxs.length;
      // remove file that are not present anymore
      thumb_boxs.removeUnUsed(this.options.files);
      container.find(".pageView:empty").remove();

      // control old lenght with new length 
      var hasFilesRemoved = oldFilesLength !== container.find(".thumb_box[data-id]").length;
      var hasInserted = false,
        hasAdded = false;
      for (var idx = 0; idx < this.options.files.length; idx++) {
        var file = this.options.files[idx];
        // add file if there is no files in the ui
        if (container.find(".thumb_box").length === 0) {
          container.append(this._makeFileElement(this.options.files[idx]));
          hasAdded = true;
        } else if (typeof file._id === "string" && this.element.find(".thumb_box[data-id=" + file._id + "]").length === 0) {
          // insert the new file in the correct place 
          hasInserted = false;
          var files = container.find(".thumb_box:not(.thumb_box_hidden)");
          for (var i = 0; i < files.length; i++) {
            if (this._readerFileSorting($(files[i]).data("dataitem"), file) > 0) {
              $(files[i]).before(this._makeFileElement(file));
              hasInserted = true;
              break;
            }
          }
          // if not inserted add at the end
          if (!hasInserted) {
            hasAdded = true;
            container.append(this._makeFileElement(file));
          }
          // in the other case the file already exists, 
          // do we need a update? if so do it.
        } else if (this._needFileReplace(file, container.find(".thumb_box[data-id=" + file._id + "]").data("dataitem")) === true) {
          container.find(".thumb_box[data-id=" + file._id + "]").replaceWith(this._makeFileElement(file));
        }
      }

      // first element add right site, if not added before
      if (container.find(".thumb_box_cover").first().length === 0) {
        // remove prev old hidden cover
        container.find(".thumb_box_hidden").remove();
        container.children(".pageView").first().filter(":empty").remove();
        var firstBox = container.find(":not(.folder).thumb_box").first();
        container.find(":not(.folder).thumb_box").first().before(firstBox.clone().removeAttr("data-id").removeAttr("tabindex").addClass("thumb_box_hidden"));
        firstBox.addClass("thumb_box_cover");
      }

      // if there was a change in the ui, we need to remap the files
      if (hasFilesRemoved || hasInserted || hasAdded) {
        container.find(".pageView .thumb_box").unwrap(); // remove parents (.pageView) of .thumb_box"s

        // add catch all pares in a div.pageView
        var containerPageView = $("<div>").addClass("pageView");
        container.children(".thumb_box, .thumb_box_hidden").not(".folder").each(function (index, thumb) {
          if (index > 0 && index % 2 === 1) {
            $(this).prev().addBack().wrapAll(containerPageView.clone());
          }
        });
        // if last stay, wrap, catch him!
        container.children(":not(.folder).thumb_box").wrapAll(containerPageView.clone());
      }
      this.element.find(".thumb_box_hidden").first().removeClass("thumb_box");
      this._trigger("refreshfinished");
      this._delay(function () {
        var showMoreButton = this.options.files.length + 1 /*amount folders*/ > this.options.limit;
        this.element.find(".bottombar").toggle(showMoreButton).children("button").prop("disabled", false);
        this._trigger("refreshfinished", null, {
          amount: this.options.files === undefined ? 0 : this.options.files.length + 1
        });
      });
    },
    /**
     * @description make and returns the ui for the file
     * @function
     * @private
     * @name nixps-cloudflow.ReaderView#_makeFileElement
     * @param {object} pAssetData
     * @returns {window.$|$} html DOM element that represents the file
     */
    _makeFileElement: function _makeFileElement(pAssetData) {
      var container = generate_thumb(this._thumbFormatter(pAssetData), this.options.iconWidth);
      var thumbBorder = container.data("dataitem", pAssetData).attr("data-id", pAssetData._id).find(".thumb_border");
      var approvalData = this._getApprovalData(pAssetData);
      if (approvalData !== null) {
        thumbBorder.append("<br>").append($("<div>").addClass("approvalState state-" + approvalData.state).text(approvalData.label));
      }
      thumbBorder.append(this._subAssetFormatter(pAssetData)).append($("<div>").addClass("pageTitle").attr("title", this._fileNameFormatter(pAssetData)).text(this._fileNameCompresser(this._fileNameFormatter(pAssetData))));
      if (this.options.showUploadIcon === true && approvalData !== null && approvalData.state !== "accepted") {
        // activate uploading
        thumbBorder.append(this.uploadIcon.clone());
      }
      if (this.options.showViewIcon === true) {
        // activation viewing (alternative for double clicking)
        thumbBorder.append(this.viewIcon.clone());
      }
      return container;
    },
    _setOption: function _setOption(p_key, p_value) {
      this._super(p_key, p_value);
      if (p_key === "showUploadIcon") {
        this.options.showUploadIcon = p_value;
      }
      if (p_key === "showViewIcon") {
        this.options.showViewIcon = p_value;
      }
    },
    _destroy: function _destroy() {
      this._superApply(arguments);
    },
    /**
    * @desc change the ui of the approval of the selected waiting files to a other state (accept or reject).
    * ATTENTION: this change ONLY the ui, the internal state can be wrong!! 
    * @fucntion
    * @name nixps-asset.ReaderView#changeApprovalStateSelectedFiles
    * @param {string} pChoose "accept" or "reject" In what we must replace the waiting text.
    * @return undefined
    **/
    changeApprovalStateSelectedFiles: function changeApprovalStateSelectedFiles(pChoose, pApprovalIDs) {
      if (pChoose === "accept" || pChoose === "reject") {
        var selection;
        if (pApprovalIDs === undefined) {
          selection = this.element.find(".thumb_box.select .approvalState.state-pending");
        } else if (Array.isArray(pApprovalIDs)) {
          selection = this.element.find(".thumb_box").filter(function (index, elem) {
            var itemData = $(elem).data("dataitem");
            if (itemData !== undefined) {
              return pApprovalIDs.includes(getApprovalID(itemData));
            } else {
              return false;
            }
          }).find(".approvalState.state-pending");
        } else {
          throw new Error("parameter pAprovelIDs must be undefined or be a array");
        }
        selection.removeClass("state-pending").addClass(function () {
          if (pChoose === "accept") {
            return "state-accepted";
          } else {
            return "state-rejected";
          }
        }).text(function () {
          if (pChoose === "accept") {
            return $.i18n._("nixps-cloudflow-assets.status_approved");
          } else {
            return $.i18n._("nixps-cloudflow-assets.status_rejected");
          }
        }).each(function () {
          if (pChoose === "accept") {
            $(this).parent(".thumb_border").find(".actionIcon.uploadIcon").remove();
          }
        });
      } else {
        throw new Error("invalid approval state");
      }
    }
  });
  function generate_thumb(p_img_url, pDimention) {
    // Generate the Box HTML
    var l_box = $("<div>").addClass("thumb_box").attr("tabindex", -1).css("width", pDimention + 12 + "px").css("height", pDimention + 32 + "px");

    // Generate the Border HTML
    var l_border = $("<div>").addClass("thumb_border").css("width", pDimention + 12 + "px").css("height", pDimention + 12 + "px");
    l_border.appendTo(l_box);
    var l_href = $("<span>");
    l_href.appendTo(l_border);

    // Generate the Image HTML
    var l_image = $("<img>").addClass("thumb_image").attr("max_dim", pDimention).attr("src", p_img_url).css("width", pDimention + "px").css("height", pDimention + "px");
    if (l_image.complete) {
      reposition_thumb(l_image);
    } else {
      l_image.on("load", function () {
        reposition_thumb($(this));
      });
    }
    l_image.appendTo(l_href);

    // Return top-level object
    return l_box;
  }
  function reposition_thumb(thumb_image) {
    var new_width = thumb_image[0].naturalWidth;
    var new_height = thumb_image[0].naturalHeight;
    var max_dim = parseInt(thumb_image.attr("max_dim"));
    if (new_width < new_height) {
      var new_width = new_width * (max_dim / new_height);
      var new_height = max_dim;
    } else {
      var new_height = new_height * (max_dim / new_width);
      var new_width = max_dim;
    }
    thumb_image.css({
      "width": new_width + "px",
      "height": new_height + "px"
    });
    thumb_image.parent().parent().css({
      "height": new_height + 12 + "px",
      "width": new_width + 12 + "px",
      "margin-left": (max_dim - new_width) / 2 + "px",
      "margin-top": (max_dim - new_height) / 2 + "px"
    });
  }
})(jQuery);

},{}],173:[function(require,module,exports){
"use strict";

var Device = require("../../PWA/js/Device.js");
/**
 * @name KeyMapping
 * @description model to retrieve the key press short cuts for a specific action and application
 * @version "1.0.0" 
 */
function KeyMapping(pUpdatedResource) {
  var that = this;
  this.errors = [];
  if (pUpdatedResource === null || pUpdatedResource === undefined) {
    this._outputResource = null;
    return;
  }
  if (Object.getPrototypeOf(pUpdatedResource) === Object.prototype && Object.keys(pUpdatedResource).length > 0) {
    this._outputResource = structuredClone(pUpdatedResource);
    for (var pApplication in pUpdatedResource) {
      if (resource[pApplication] === undefined || resource[pApplication] === null || Object.getPrototypeOf(resource[pApplication]) !== Object.prototype) {
        this.errors.push({
          error_code: "application_not_found",
          error: "KeyMapping: name of application does not exist (got '" + pApplication + "')"
        });
      } else {
        for (var pAction in pUpdatedResource[pApplication]) {
          var isValid = [];
          if (Array.isArray(resource[pApplication][pAction]) === false) {
            isValid.push({
              error_code: "action_not_found",
              error: "Keymapping: action (got '" + pAction + "') for application '" + pApplication + "' does not exist"
            });
          } else {
            isValid = that._validateChange(pUpdatedResource[pApplication][pAction]);
          }
          if (isValid.length <= 0) {
            that._mergeChange(pApplication, pAction, pUpdatedResource[pApplication][pAction]);
          } else {
            this.errors = this.errors.concat(isValid);
          }
        }
      }
    }
  }
  if (this.errors.length > 0) {
    this.errors.forEach(function (pErrorMessage) {
      console.error(pErrorMessage);
    });
  }
}
KeyMapping.fromJSON = function (pJSON) {
  return new KeyMapping(pJSON.output_resource);
};
KeyMapping.clear = function () {
  resource = structuredClone(defaultResource);
};
KeyMapping.prototype = {
  constructor: KeyMapping,
  /**
   * @function
   * @name KeyMapping.get
   * @description Get all the key mappings of a specific action
   * @param {String} pApplication The name of the application
   * @param {String} pAction The name of action assosiated
   * @returns Array an array containing all the short cuts for that specific action
   */
  get: function get(pApplication, pAction) {
    if (resource[pApplication] !== undefined) {
      if (resource[pApplication][pAction] !== undefined) {
        if (resource[pApplication][pAction] === null) {
          return [];
        } else {
          return resource[pApplication][pAction];
        }
      }
    }
    return [];
  },
  /**
   * @function
   * @description Get all short cuts of a specific application
   * @name KeyMapping.getAll
   * @param {String} pApplication 
   * @returns Array an array of all shortcuts used in that application
   */
  getAll: function getAll(pApplication) {
    if (resource[pApplication] !== undefined) {
      var outputKeymappings = [];
      for (var acctionNames in resource[pApplication]) {
        outputKeymappings = outputKeymappings.concat(resource[pApplication][acctionNames]);
      }
      return outputKeymappings;
    }
    return [];
  },
  getFull: function getFull() {
    if (resource !== undefined) {
      return resource;
    }
    return {};
  },
  /**
   * @function
   * @name KeyMapping.get
   * @description Get all the key mappings of a specific action
   * @param {String} pApplication The name of the application
   * @param {String} pAction The name of action assosiated
   * @returns Array an array containing all the short cuts for that specific action
   */
  getConfig: function getConfig(pApplication, pAction) {
    if (config[pApplication] !== undefined) {
      if (config[pApplication][pAction] !== undefined) {
        return config[pApplication][pAction];
      }
    }
    return {};
  },
  /**
   * @function
   * @description Get all short cuts of a specific application
   * @name KeyMapping.getAll
   * @param {String} pApplication 
   * @returns Array an array of all shortcuts used in that application
   */
  getAllConfig: function getAllConfig(pApplication) {
    if (config[pApplication] !== undefined) {
      return config[pApplication];
    }
    return {};
  },
  getFullConfig: function getFullConfig() {
    if (config !== undefined) {
      return config;
    }
    return {};
  },
  /**
   * @description Get the text to display to the user
   * @function
   * @name KeyMapping.getSuggestion
   * @param {String} pApplication 
   * @param {String} pAction 
   * @returns {String} the suggestion text to display as tooltip or text to the customer  
   */
  getSuggestion: function getSuggestion(pApplication, pAction) {
    if (Device.hasMobileWidth() === true) {
      return "";
    }
    if (window.navigator !== undefined && typeof navigator.platform === 'string' && navigator.platform.indexOf("Mac") === 0) {
      // for Mac
      var possibilities = this.get(pApplication, pAction);
      if (Array.isArray(possibilities) && possibilities.length > 0) {
        return this._styleSuggestion(possibilities[0], true, false, ""); // &thinsp;
      } else {
        return "";
      }
    } else {
      // for Windows
      var possibilities = this.get(pApplication, pAction);
      if (Array.isArray(possibilities) && possibilities.length > 0) {
        var windowsMeta = false;
        if (possibilities[0].indexOf("meta") === 0) {
          windowsMeta = true;
        }
        if (possibilities.length > 1 && possibilities[0].indexOf("command") === 0) {
          return this._styleSuggestion(possibilities[1], false, windowsMeta);
        } else {
          return this._styleSuggestion(possibilities[0], false, windowsMeta);
        }
      }
      return "";
    }
  },
  /**
   * @description Convert the suggestion to a visual text
   * @function
   * @name KeyMapping._styleSuggestion
   * @private
   * @param {String} pSuggestion The suggestion string to convert
   * @param {Boolean} toSigns Must we use only signs, if false we use words
   * @param {String} pConcatSign The character(s) to combind the shortcuts
   * @returns {String} the converted suggestion
   */
  _styleSuggestion: function _styleSuggestion(pSuggestion, toSigns, pWindowsMeta, pConcatSign) {
    if (pConcatSign === undefined) {
      pConcatSign = "+";
    }
    if (typeof pSuggestion === "string" && pSuggestion.length > 0) {
      if (toSigns === true) {
        pSuggestion = pSuggestion.replace("command", "⌘").replace("meta", "⌘").replace("alt", "⌥").replace("shift", "⇧").replace("ctrl", "⌃").replace("up", "↑").replace("right", "→").replace("down", "↓").replace("left", "←");
      }
      if (pWindowsMeta === true) {
        pSuggestion = pSuggestion.replace("meta", "win");
      }
      return pSuggestion.split("+").map(function (pSign) {
        if (typeof pSign === "string") {
          if (pSign === "plus") {
            return "+";
          }
          return pSign[0].toLocaleUpperCase() + pSign.slice(1); // make first character an upper case 
        }

        return pSign;
      }).join(pConcatSign);
    }
    return pSuggestion;
  },
  /**
   * @description Get all the key mappings who are forbidden, because some browser does not allow them
   * @function
   * @name KeyMapping.getNotAllowed
   * @returns Array.<String> the keymappings who are not allowed
   */
  getNotAllowed: function getNotAllowed() {
    return ["ctrl+n", "ctrl+shift+n", "ctrl+t", "ctrl+shift+t", "ctrl+w", "ctrl+shift+w", "command+n", "command+shift+n", "command+t", "command+shift+t", "command+w", "command+shift+w"];
  },
  /**
   * @description Add an errormessage to the errors property
   * @function
   * @name KeyMapping._addErrorMessage
   * @private
   * @param {Object} pErrorMessage the errormessage to add to errors 
   * @returns {undefined}
   */
  _addErrorMessage: function _addErrorMessage(pErrorMessage) {
    if (pErrorMessage === undefined || Object.getPrototypeOf(pErrorMessage) !== Object.prototype || Object.keys(pErrorMessage).length <= 0) {
      throw new Error("KeyMapping: errormessage should be an object");
    }
    this.errors.push(pErrorMessage);
  },
  /**
   * @description Merge new key shortcuts with the existing default ones
   * @function
   * @name KeyMapping._mergeChange
   * @private
   * @param {String} pApplication the application which the new shortcuts are for 
   * @param {String} pChangeAction the action inside the application which the new shortcuts are for
   * @param {Array} pKeyMaps an array of key combinations add to the default shortcuts
   * @returns {undefined}
   */
  _mergeChange: function _mergeChange(pApplication, pChangeAction, pKeyMaps) {
    var that = this;
    if (Array.isArray(pKeyMaps) === false && pKeyMaps !== null) {
      throw new Error("KeyMapping: new shortcuts should be in an array");
    }
    //check for duplicate keybinds in other actions and remove them
    if (pKeyMaps === null) {
      resource[pApplication][pChangeAction] = null;
    } else {
      pKeyMaps.forEach(function (pKeyMap) {
        for (var pAction in resource[pApplication]) {
          if (resource[pApplication][pAction] === null) {
            continue;
          }
          var duplicateIndex = resource[pApplication][pAction].indexOf(pKeyMap);
          if (duplicateIndex >= 0 && resource[pApplication][pAction].length > 0 && pAction !== pChangeAction) {
            resource[pApplication][pAction] = [];
            that._addErrorMessage({
              overwroteShortcut: "KeyMapping: overwrote action '" + pAction + "' in '" + pApplication + "'"
            });
          }
        }
      });
      resource[pApplication][pChangeAction] = resource[pApplication][pChangeAction].concat(pKeyMaps);
    }
  },
  /**
   * @description Validate shortcuts that we would want to merge with default ones
   * @function
   * @name KeyMapping._validateChange
   * @private
   * @param {Array} pNewKeyMaps the new keyboard shortcuts
   * @returns {Array} an array containing objects with validation errors, if there are any
   */
  _validateChange: function _validateChange(pNewKeyMaps, pKey) {
    var that = this;
    var pattern = /^(ctrl\+|alt\+|command\+)+(shift\+)?([a-z]|up|right|down|left)$/;
    var isValid = [];
    if (Array.isArray(pNewKeyMaps) === false && pNewKeyMaps !== null) {
      throw new Error("KeyMapping: new shortcuts should be in an array");
    }
    if (pNewKeyMaps !== null) {
      pNewKeyMaps.forEach(function (pNewKeyMap) {
        if (pattern.test(pNewKeyMap) === false) {
          var errormsg = "nixps-keymapping-page.wrong_pattern_error";
          if (window.$ !== undefined && window.$.i18n !== undefined) {
            errormsg = $.i18n._("nixps-keymapping-page.wrong_pattern_error");
          }
          isValid.push({
            wrongPattern: "KeyMapping: the pattern of '" + pNewKeyMap + "' has to start with ctrl, alt or delete, " + "optionally followed by 'shift+' and end with a letter from a to z",
            errorMessage: errormsg,
            applicationAction: pKey
          });
        }
        if (that.getNotAllowed().includes(pNewKeyMap) === true) {
          var _errormsg = "nixps-keymapping-page.forbidden_error";
          if (window.$ !== undefined && window.$.i18n !== undefined) {
            _errormsg = $.i18n._("nixps-keymapping-page.forbidden_error", [pNewKeyMap]);
          }
          isValid.push({
            forbiddenShortcut: "KeyMapping: '" + pNewKeyMap + "' is not allowed to be used",
            errorMessage: _errormsg,
            applicationAction: pKey
          });
        }
      });
    }
    return isValid;
  },
  /**
   * @description Get all the errors related to key shortcuts
   * @function
   * @name KeyMapping.getErrors
   * @returns {Array} an array with objects containing error messages
   */
  getErrors: function getErrors() {
    return this.errors;
  },
  /**
   * @description Normalize the user input of one or multiplme keyshortcuts
   * @function
   * @name KeyMapping.normalize
   * @param {String} pKeyShortcutsString the user input, containing one or multiple shortcuts in a string
   * @param {String} pKey the application and action for which the new shortcut(s) are, separated by "-"
   * @param {Boolean} pIsValidating whether the normalize was called in a validation environment,
   * or if we just want the normalized shortcuts back
   * @returns {Array} an array with each new shortcut
   */
  normalize: function normalize(pKeyShortcutsString, pKey, pIsValidating) {
    var application = pKey.split("-")[0];
    var action = pKey.split("-")[1];
    var keyShortcuts = pKeyShortcutsString.split(/[;,]+/);

    //trims, lowercases, normalizes words to what Mousetrap expects, changes one or more spaces to + signs
    for (var index in keyShortcuts) {
      keyShortcuts[index] = keyShortcuts[index].trim().toLowerCase();
      if (keyShortcuts[index].length <= 0) {
        keyShortcuts.splice(index);
        continue;
      }
      keyShortcuts[index] = keyShortcuts[index].replace("control", "ctrl").replace("cmd", "command").replace("option", "alt");
      keyShortcuts[index] = keyShortcuts[index].replaceAll(" ", "+");
      for (var i = keyShortcuts[index].length - 1; i > 0; i--) {
        if (keyShortcuts[index][i] === "+" && keyShortcuts[index][i - 1] === "+") {
          keyShortcuts[index] = keyShortcuts[index].slice(0, i) + keyShortcuts[index].slice(i + 1);
        }
      }
    }
    if (pIsValidating === true) {
      var isValid = [];
      var isReserved = this._isReserved(keyShortcuts, application, action);
      if (isReserved !== false) {
        isValid.push(isReserved);
      }
      isValid = isValid.concat(this._validateChange(keyShortcuts, pKey));
      if (isValid.length > 0) {
        return isValid[0]["errorMessage"];
      }
    }
    return keyShortcuts;
  },
  /**
   * @description Check whether an action within an application already has the keyshortcut that's been inputted
   * @function
   * @name KeyMapping._isReserved
   * @param {Array} pKeyShortcuts an array with one or multiple shortcuts the user has inputted
   * @param {String} pApplication the application which the new shortcuts are for
   * @param {String} pAction the action inside the application which the user is adding shortcuts for
   * @returns {false|Object} will return false is the shortcuts aren't reserved, otherwise an object with error message
   * to communicate which action already has inputted shortcut
   */
  _isReserved: function _isReserved(pKeyShortcuts, pApplication, pAction) {
    var isReserved = false;
    pKeyShortcuts.forEach(function (pNewKeyMap) {
      for (var pDefaultAction in resource[pApplication]) {
        //don't check the action which we are testing for
        if (pAction !== pDefaultAction) {
          if (resource[pApplication][pDefaultAction] !== null && resource[pApplication][pDefaultAction].includes(pNewKeyMap)) {
            var actionName = pDefaultAction;
            var transKey = "nixps-cloudflow-keymapping-form.label_" + actionName;
            if (window.$ !== undefined && window.$.i18n !== undefined && $.i18n._(transKey) !== transKey) {
              actionName = $.i18n._(transKey);
            } else {
              transKey = "nixps-proofscope-toolbar." + actionName;
              if (window.$ !== undefined && window.$.i18n !== undefined && $.i18n._(transKey) !== transKey) {
                actionName = $.i18n._(transKey);
              }
            }
            if (actionName.endsWith(" %1$s") === true) {
              actionName = actionName.slice(0, -5);
            }
            if (window.$ !== undefined && window.$.i18n !== undefined && $.i18n._("nixps-cloudflow-keymapping-form.label_" + pDefaultAction) !== "nixps-cloudflow-keymapping-form.label_" + pDefaultAction) {
              actionName = $.i18n._("nixps-cloudflow-keymapping-form.label_" + pDefaultAction);
            }
            var errormsg = "nixps-keymapping-page.reserved_error";
            if (window.$ !== undefined && window.$.i18n !== undefined) {
              errormsg = $.i18n._("nixps-keymapping-page.reserved_error", [pNewKeyMap]) + ' "' + actionName + '".';
            }
            isReserved = {
              errorMessage: errormsg
            };
          }
        }
      }
    });
    return isReserved;
  },
  /**
   * @description Normalize an object of keyshortcuts coming from a form
   * @function
   * @name KeyMapping.normalizeKeyShortcuts
   * @param {Object} pValues an object which has keys for application-action, each with an array of shortcuts from user's input
   * @returns {Object} will return an object with the same interface as the parameter, but with the normalized keyshortcuts
   */
  normalizeKeyShortcuts: function normalizeKeyShortcuts(pValues) {
    var normalizedShortcuts = {};
    for (var pKeyShortcut in pValues) {
      normalizedShortcuts[pKeyShortcut] = [];
      if (pValues[pKeyShortcut] === null) {
        normalizedShortcuts[pKeyShortcut] = null;
      } else {
        for (var i = 0; i < pValues[pKeyShortcut].length; i++) {
          var normalizedInput = this.normalize(pValues[pKeyShortcut][i], pKeyShortcut, false);
          normalizedShortcuts[pKeyShortcut].push(normalizedInput[0]);
        }
      }
    }
    return normalizedShortcuts;
  },
  /**
   * @description Format an object containing normalized keyshortcuts
   * @function
   * @name KeyMapping.formatKeyShortcuts
   * @param {Object} pNormalizedShortcuts an object which has keys for application-action, each with an array of normalized shortcuts
   * @returns {Object} an object with objects for each application there was a shortcut for, each in their turn containing keys for
   * the different actions that have the value of an array with the shortcuts
   */
  formatKeyShortcuts: function formatKeyShortcuts(pNormalizedShortcuts) {
    var saveValues = {};
    if (this.errors.length > 0) {
      saveValues["errors"] = this.errors;
      this.errors = [];
    }
    for (var key in pNormalizedShortcuts) {
      //[application, action]
      var splitKey = key.split("-");
      if (pNormalizedShortcuts[key] === null) {
        if (saveValues[splitKey[0]] === undefined) {
          saveValues[splitKey[0]] = {};
        }
        saveValues[splitKey[0]][splitKey[1]] = null;
      } else if (pNormalizedShortcuts[key].length > 0) {
        var saveShortcuts = pNormalizedShortcuts[key];
        if (saveValues[splitKey[0]] === undefined) {
          saveValues[splitKey[0]] = {};
        }
        saveValues[splitKey[0]][splitKey[1]] = saveShortcuts;
      } else {
        if (saveValues[splitKey[0]] === undefined) {
          saveValues[splitKey[0]] = {};
        }
        saveValues[splitKey[0]][splitKey[1]] = [];
      }
    }
    return saveValues;
  },
  clone: function clone() {
    return KeyMapping.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {
      errors: this.errors,
      output_resource: this._outputResource
    };
  }
};
///
// Next short cuts will never work in default Chrome,
// ctrl+n, ctrl+shift+n, ctrl+t, ctrl+shift+t, ctrl+w, ctrl+shift+w
// First value is for Mac and second value is for other systems
var resource = {
  "appbuilder": {
    "saveall": ["command+shift+s", "ctrl+shift+s"],
    "refresh": ["command+shift+r", "ctrl+shift+r"],
    "close": ["command+w", "ctrl+w"],
    "togglebrowserpanel": ["command+y", "ctrl+y"]
  },
  "appview": {
    "zoomin": ["alt+plus", "ctrl+shift+plus", "alt+="],
    "zoomout": ["ctrl+shift+-", "alt+-"],
    "zoom100prc": ["ctrl+shift+0", "ctrl+shift+)", "ctrl+0", "ctrl+shift+ins", "alt+0"],
    "zoomfit": ["ctrl+shift+=", "ctrl+shift+clear"]
  },
  "assetview": {
    "find": ["command+f", "ctrl+f"],
    "selectall": ["command+a", "ctrl+a"],
    "openeditor": ["command+shift+e", "ctrl+shift+e"],
    "createwebpage": ["alt+n"],
    "addfolder": [],
    // ["alt+shift+n"],
    "rename": [],
    // ["alt+r"],
    "download": [],
    // ["alt+shift+d", "alt+shift+d"],
    "delete": ["backspace", "del"],
    "cut": ["command+x", "ctrl+x"],
    "copy": ["command+c", "ctrl+c"],
    "paste": ["command+v", "ctrl+v"],
    "submitflow": []
  },
  "colorspaceconfiguration": {
    "save": ["command+s", "ctrl+s"],
    "undo": ["command+z", "ctrl+z"]
  },
  "formbuilder": {
    "save": ["command+s", "ctrl+s"],
    "undo": ["command+z", "ctrl+z"]
  },
  "inspect": {
    "clear": ["command+e", "ctrl+e"],
    "reload": ["command+r", "ctrl+r"],
    "togglePosition": ["command+t", "ctrl+t"]
  },
  "manifest": {
    "save": ["command+s", "ctrl+s"],
    "undo": ["command+z", "ctrl+z"],
    "redo": ["command+shift+z", "ctrl+shift+z"]
  },
  "markdowneditor": {
    "save": ["command+s", "ctrl+s"]
  },
  "pagebuilder": {
    "save": ["command+s", "ctrl+s"],
    "undo": ["command+z", "ctrl+z"],
    "redo": ["command+shift+z", "ctrl+shift+z"],
    "delete": ["backspace", "del"],
    "duplicate": ["ctrl+shift+c"],
    "cut": ["command+x", "ctrl+x"],
    "copy": ["command+c", "ctrl+c"],
    "paste": ["command+v", "ctrl+v"]
  },
  "proofscope": {
    "zoomin": ["command+plus", "ctrl+plus", "command+=", "ctrl+=", "alt+plus", "alt+="],
    "zoomout": ["command+-", "ctrl+-", "alt+-"],
    "zoomfit": ["ctrl+0", "meta+0", "ctrl+`", "meta+`", "ctrl+zero", "meta+zero"],
    //meta+keycode 48 won't work, OS shortcut
    "rotateleft": [],
    "rotateright": [],
    "mirror": [],
    "toggle1": [],
    "toggle2": [],
    "zoom": [],
    "pan_tool": [],
    "notes": [],
    "densitometer": [],
    "measure_tool": [],
    "measure_halftones_tool": [],
    "barcode_tool": [],
    "braille_tool": [],
    "pixel_count_tool": [],
    "font_properties_tool": [],
    "crop_tool": [],
    "diff_a_view": [],
    "diff_b_view": [],
    "copy": ["command+c", "ctrl+c"],
    "paste": ["command+v", "ctrl+v"],
    "debug": ["ctrl+alt+d"]
  },
  "native3drenderer": {
    "zoomin": ["command+plus", "ctrl+plus", "command+=", "ctrl+=", "alt+plus", "alt+="],
    "zoomout": ["command+-", "ctrl+-", "alt+-"],
    "resetview": ["ctrl+0", "meta+0", "ctrl+`", "meta+`", "ctrl+zero", "meta+zero"]
  },
  "workfloweditor": {
    "undo": ["command+z", "ctrl+z"],
    "redo": ["command+shift+z", "ctrl+shift+z"],
    "save": ["command+s", "ctrl+s"],
    "delete": ["command+backspace", "ctrl+backspace", "del", "backspace"],
    "cut": ["command+x", "ctrl+x"],
    "copy": ["command+c", "ctrl+c"],
    "paste": ["command+v", "ctrl+v"],
    "zoomin": ["alt+plus", "alt+=", "ctrl+shift+plus"],
    "zoomout": ["alt+-", "ctrl+shift+-"],
    "zoom100prc": ["alt+0", "ctrl+shift+0", "ctrl+shift+)", "ctrl+0", "ctrl+shift+ins"],
    "zoomfit": ["ctrl+shift+=", "ctrl+shift+clear"],
    "selectall": ["command+a", "ctrl+a"],
    "reposition": ["ctrl+shift+f"],
    "heatmap": ["ctrl+shift+t"],
    "hidepanels": ["alt+h"]
  },
  "stylebuilder": {
    "save": ["command+s", "ctrl+s"]
  }
};
var defaultResource = Object.freeze(structuredClone(resource));
var config = {
  "application_whitelist": ["*"],
  "action_blacklist": ["assetview-openeditor", "workfloweditor-reposition", "assetview-find"],
  "appbuilder": {
    "application_config": {
      "license": "portal",
      "title": "nixps-cloudflow-applications.toolbar_appbuilder_title"
    },
    "saveall": {
      "label": "nixps-cloudflow-keymapping-form.label_saveall"
    },
    "refresh": {
      "label": "nixps-cloudflow-keymapping-form.label_refresh",
      "helptext": "nixps-cloudflow-keymapping-form.helptext_appbuilder_refresh"
    },
    "close": {
      "label": "nixps-cloudflow-keymapping-form.label_close"
    },
    "togglebrowserpanel": {
      "label": "nixps-cloudflow-keymapping-form.label_togglebrowserpanel",
      "helptext": "nixps-cloudflow-keymapping-form.helptext_appbuilder_togglebrowserpanel"
    }
  },
  "appview": {
    "application_config": {
      "license": "portal",
      "title": "nixps-cloudflow-viewapp.title"
    },
    "zoomin": {
      "label": "nixps-cloudflow-keymapping-form.label_zoomin"
    },
    "zoomout": {
      "label": "nixps-cloudflow-keymapping-form.label_zoomout"
    },
    "zoom100prc": {
      "label": "nixps-cloudflow-keymapping-form.label_zoom100prc"
    },
    "zoomfit": {
      "label": "nixps-cloudflow-keymapping-form.label_zoomfit"
    }
  },
  "assetview": {
    "application_config": {
      "license": "portal",
      "title": "nixps-cloudflow-preferences.assetviewer.title"
    },
    "find": {
      "label": "nixps-cloudflow-keymapping-form.label_find"
    },
    "selectall": {
      "label": "nixps-cloudflow-keymapping-form.label_selectall"
    },
    "openeditor": {
      "label": "nixps-cloudflow-keymapping-form.label_openeditor"
    },
    "createwebpage": {
      "label": "nixps-cloudflow-keymapping-form.label_createwebpage"
    },
    "addfolder": {
      "label": "nixps-asset-assetactionlist.addfolder"
    },
    "rename": {
      "label": "nixps-asset-assetactionlist.rename"
    },
    "download": {
      "label": "nixps-asset-assetactionlist.download"
    },
    "delete": {
      "label": "nixps-cloudflow-keymapping-form.label_delete"
    },
    "cut": {
      "label": "nixps-cloudflow-keymapping-form.label_cut"
    },
    "copy": {
      "label": "nixps-cloudflow-keymapping-form.label_copy"
    },
    "paste": {
      "label": "nixps-cloudflow-keymapping-form.label_paste"
    },
    "submitflow": {
      "label": "nixps-cloudflow-pagebuilder.actionfunctiontype_start_flow"
    }
  },
  "colorspaceconfiguration": {
    "save": {
      "label": "nixps-cloudflow-keymapping-form.label_save"
    },
    "undo": {
      "label": "nixps-cloudflow-keymapping-form.label_undo"
    }
  },
  "formbuilder": {
    "application_config": {
      "license": "portal",
      "title": "nixps-cloudflow-formmanager.page_title"
    },
    "save": {
      "label": "nixps-cloudflow-keymapping-form.label_save"
    },
    "undo": {
      "label": "nixps-cloudflow-keymapping-form.label_undo"
    }
  },
  "inspect": {
    "application_config": {
      "license": "portal",
      "title": "nixps-cloudflow-keymapping-form.title_inspect"
    },
    "clear": {
      "label": "nixps-cloudflow-keymapping-form.label_clear"
    },
    "reload": {
      "label": "nixps-cloudflow-keymapping-form.label_reload"
    },
    "togglePosition": {
      "label": "nixps-cloudflow-keymapping-form.label_togglePosition",
      "helptext": "nixps-cloudflow-keymapping-form.helptext_inspect_togglePosition"
    }
  },
  "manifest": {
    "application_config": {
      "license": "portal",
      "title": "nixps-cloudflow-CloudflowBar.manifest"
    },
    "save": {
      "label": "nixps-cloudflow-keymapping-form.label_save"
    },
    "undo": {
      "label": "nixps-cloudflow-keymapping-form.label_undo"
    },
    "redo": {
      "label": "nixps-cloudflow-keymapping-form.label_redo"
    }
  },
  "markdowneditor": {
    "application_config": {
      "license": "portal",
      "title": "nixps-cloudflow-keymapping-form.title_markdowneditor"
    },
    "save": {
      "label": "nixps-cloudflow-keymapping-form.label_save"
    }
  },
  "pagebuilder": {
    "application_config": {
      "license": "portal",
      "title": "nixps-cloudflow-pagemanager.title"
    },
    "save": {
      "label": "nixps-cloudflow-keymapping-form.label_save"
    },
    "undo": {
      "label": "nixps-cloudflow-keymapping-form.label_undo"
    },
    "redo": {
      "label": "nixps-cloudflow-keymapping-form.label_redo"
    },
    "delete": {
      "label": "nixps-cloudflow-keymapping-form.label_delete"
    },
    "duplicate": {
      "label": "nixps-cloudflow-keymapping-form.label_duplicate",
      "helptext": "nixps-cloudflow-keymapping-form.helptext_pagebuilder_duplicate"
    },
    "cut": {
      "label": "nixps-cloudflow-keymapping-form.label_cut"
    },
    "copy": {
      "label": "nixps-cloudflow-keymapping-form.label_copy",
      "helptext": "nixps-cloudflow-keymapping-form.helptext_pagebuilder_copy"
    },
    "paste": {
      "label": "nixps-cloudflow-keymapping-form.label_paste"
    }
  },
  "proofscope": {
    "application_config": {
      "license": "proofscope",
      "title": "nixps-cloudflow-preferences.proofscope.title_1"
    },
    "zoomin": {
      "label": "nixps-cloudflow-keymapping-form.label_zoomin"
    },
    "zoomout": {
      "label": "nixps-cloudflow-keymapping-form.label_zoomout"
    },
    "zoomfit": {
      "label": "nixps-cloudflow-keymapping-form.label_zoomfit"
    },
    "rotateleft": {
      "label": "nixps-cloudflow-keymapping-form.label_rotateleft"
    },
    "rotateright": {
      "label": "nixps-cloudflow-keymapping-form.label_rotateright"
    },
    "mirror": {
      "label": "nixps-cloudflow-keymapping-form.label_mirror"
    },
    "toggle1": {
      "label": "nixps-cloudflow-keymapping-form.label_toggle1"
    },
    "toggle2": {
      "label": "nixps-cloudflow-keymapping-form.label_toggle2"
    },
    "zoom": {
      "label": "nixps-cloudflow-keymapping-form.label_zoom",
      "subtitle": "nixps-cloudflow-keymapping-form.proofscope_tools_subtitle"
    },
    "pan_tool": {
      "label": "nixps-cloudflow-keymapping-form.label_pan_tool"
    },
    "notes": {
      "label": "nixps-cloudflow-keymapping-form.label_note_tool"
    },
    "densitometer": {
      "label": "nixps-cloudflow-keymapping-form.label_densitometer"
    },
    "measure_tool": {
      "label": "nixps-cloudflow-keymapping-form.label_measure_tool"
    },
    "measure_halftones_tool": {
      "label": "nixps-cloudflow-keymapping-form.label_measure_halftones_tool"
    },
    "barcode_tool": {
      "label": "nixps-cloudflow-keymapping-form.label_barcode_tool"
    },
    "braille_tool": {
      "label": "nixps-cloudflow-keymapping-form.label_braille_tool"
    },
    "pixel_count_tool": {
      "label": "nixps-cloudflow-keymapping-form.label_pixel_count_tool"
    },
    "font_properties_tool": {
      "label": "nixps-cloudflow-keymapping-form.label_font_properties_tool"
    },
    "crop_tool": {
      "label": "nixps-cloudflow-keymapping-form.label_crop_tool"
    },
    "diff_a_view": {
      "label": "nixps-cloudflow-keymapping-form.label_diff_a_view"
    },
    "diff_b_view": {
      "label": "nixps-cloudflow-keymapping-form.label_diff_b_view"
    }
  },
  "workfloweditor": {
    "application_config": {
      "license": "quantum",
      "title": "QuantumEditor.title"
    },
    "undo": {
      "label": "nixps-cloudflow-keymapping-form.label_undo"
    },
    "redo": {
      "label": "nixps-cloudflow-keymapping-form.label_redo"
    },
    "save": {
      "label": "nixps-cloudflow-keymapping-form.label_save",
      "helptext": "nixps-cloudflow-keymapping-form.helptext_workfloweditor_save"
    },
    "delete": {
      "label": "nixps-cloudflow-keymapping-form.label_delete"
    },
    "cut": {
      "label": "nixps-cloudflow-keymapping-form.label_cut"
    },
    "copy": {
      "label": "nixps-cloudflow-keymapping-form.label_copy"
    },
    "paste": {
      "label": "nixps-cloudflow-keymapping-form.label_paste"
    },
    "zoomin": {
      "label": "nixps-cloudflow-keymapping-form.label_zoomin"
    },
    "zoomout": {
      "label": "nixps-cloudflow-keymapping-form.label_zoomout"
    },
    "zoom100prc": {
      "label": "nixps-cloudflow-keymapping-form.label_zoom100prc"
    },
    "zoomfit": {
      "label": "nixps-cloudflow-keymapping-form.label_zoomfit"
    },
    "selectall": {
      "label": "nixps-cloudflow-keymapping-form.label_selectall",
      "helptext": "nixps-cloudflow-keymapping-form.helptext_workfloweditor_selectall"
    },
    "reposition": {
      "label": "nixps-cloudflow-keymapping-form.label_reposition"
    },
    "heatmap": {
      "label": "nixps-cloudflow-keymapping-form.label_heatmap"
    },
    "hidepanels": {
      "label": "nixps-cloudflow-keymapping-form.label_hidepanels"
    }
  },
  "stylebuilder": {
    "application_config": {
      "license": "portal",
      "title": "nixps-cloudflow-StyleManager.title"
    },
    "save": {
      "label": "nixps-cloudflow-keymapping-form.label_save"
    }
  }
};

//these keyboard shortcuts are handled by the Operating System of the user.
//we are not able to prevent the default behavior of these.
var exceptionsForOS = {
  windows: {
    "*": {
      actionScreen: {
        _message: "shows a screen for several operating system actions",
        shortcut: ["ctrl+alt+del"]
      },
      closeWindow: {
        _message: "closes the currently focused window",
        shortcut: ["alt+f4"]
      },
      taskbarSwitch: {
        _message: "switches to the application that's in the position on the taskbar equal the pressed number",
        shortcut: ["meta+0", "...", "meta+9"]
      }
    }
  },
  Mac: {
    "*": {
      screenLock: {
        _message: "immediately locks the screen, no warning",
        shortcut: ["ctrl+command+q"]
      },
      logOutUser: {
        _message: "logs the user out - with warning",
        shortcut: ["shift+command+q"]
      },
      logOutUserNoWarn: {
        _message: "logs the user out - no warning",
        shortcut: ["options+shift+command+q"]
      }
    },
    safari: {
      closeWindow: {
        _message: "closes the current application - other browsers will warn",
        shrotcut: ["command + q"]
      }
    }
  }
};
module.exports = KeyMapping;

},{"../../PWA/js/Device.js":198}],174:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var TemporyBrowserObjectCache = require("../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var Device = require("../../PWA/js/Device.js");
var KeyMapping = require("./KeyMapping.js");
var fileMetadata = {};
var keyShortcuts;
function KeyMappingHandler(pUrl) {
  this.url = pUrl;
}
KeyMappingHandler.getResources = function () {
  return [{
    apiCall: "get_for_current_user",
    apiAppKey: "com.nixps.keymapping",
    apiSubKey: "keymapping"
  }];
};
KeyMappingHandler.set = function (pKeyShortcuts) {
  if (pKeyShortcuts === undefined) {
    // no keyshortcuts are defined, set up as empty
    keyShortcuts = {};
  } else if (pKeyShortcuts && _typeof(pKeyShortcuts) === "object") {
    TemporyBrowserObjectCache.save("nixps_cloudflow_keyshortcuts", pKeyShortcuts);
    keyShortcuts = pKeyShortcuts;
  } else {
    // ignore error, data will be reasked later on
    console.error("invalid interface for KeyMappingHandler.set :", pKeyShortcuts);
  }
};
KeyMappingHandler.get = function (pUrl) {
  var handler = new KeyMappingHandler(pUrl);
  return handler.get(typeof pUrl === "string" && pUrl.length > 0).then(function () {
    return handler;
  });
};
KeyMappingHandler.getWithInstance = function (pUrl) {
  var handler = new KeyMappingHandler(pUrl);
  return handler.get(typeof pUrl === "string" && pUrl.length > 0).then(function (pData) {
    return new KeyMapping(pData);
  });
};
KeyMappingHandler.clear = function () {
  keyShortcuts = undefined;
  TemporyBrowserObjectCache.remove("nixps_cloudflow_keyshortcuts");
};
KeyMappingHandler.prototype = {
  constructor: KeyMappingHandler,
  loadFromFile: function loadFromFile(shortcutsRequired) {
    var that = this;
    var getUrl = "/portal.cgi?asset=download_file&url=" + encodeURIComponent(this.url);
    return new Promise(function (pResolve, pReject) {
      if (Device.hasMobileWidth() === true) {
        //we don't need shortcuts on mobile
        pResolve({});
      } else {
        fetch(getUrl, {
          method: "GET"
        }).then(function (response) {
          return response.text();
        }).then(function (pData) {
          keyShortcuts = JSON.parse(pData);
          pResolve(keyShortcuts);
        })["catch"](function (pFail) {
          //if file doesn't exist or wasn't read properly, we do so and resolve with empty keyshortcuts object
          if (shortcutsRequired === true) {
            pResolve({
              error_code: "failedRead",
              error_message: window.$ && window.$.i18n ? $.i18n._("nixps-keymapping-page.failed_read_error") : "nixps-keymapping-page.failed_read_error"
            });
          } else {
            pResolve({});
          }
        });
      }
    }).then(function (pResult) {
      return pResult;
    })["catch"](function (pFail) {
      console.error(pFail);
      return Promise.reject(pFail);
    });
  },
  loadFromPreferences: function loadFromPreferences(shortcutsRequired) {
    return new Promise(function (pResolve, pReject) {
      if (Device.hasMobileWidth() === true) {
        //we don't need shortcuts on mobile
        pResolve({
          preferences: {}
        });
      } else {
        api_async.preferences.get_for_current_user("com.nixps.keymapping", "keymapping", pResolve, function () {
          if (shortcutsRequired === true) {
            pResolve({
              error_code: "failedRead",
              error_message: window.$ && window.$.i18n ? $.i18n._("nixps-keymapping-page.failed_read_error") : "nixps-keymapping-page.failed_read_error"
            });
          } else {
            pResolve({});
          }
        });
      }
    }).then(function (pResult) {
      if (pResult.preferences["undefined"] !== undefined) {
        delete pResult.preferences["undefined"];
      }
      return pResult.preferences;
    })["catch"](function (pFail) {
      console.error(pFail);
      return Promise.reject(pFail);
    });
  },
  get: function get(isLoadFromFile) {
    if (Device.hasMobileWidth() === true) {
      return Promise.resolve({});
    }
    if (keyShortcuts === undefined) {
      if (TemporyBrowserObjectCache.isPageReload() !== true || Device.getPollingFactor() > 1) {
        var cacheObject = TemporyBrowserObjectCache.get("nixps_cloudflow_keyshortcuts");
        if (cacheObject !== null) {
          keyShortcuts = cacheObject;
          return Promise.resolve(keyShortcuts);
        }
      }
      if (isLoadFromFile === true) {
        return this.loadFromFile(false).then(function (pKeyShortcuts) {
          TemporyBrowserObjectCache.save("nixps_cloudflow_keyshortcuts", pKeyShortcuts);
          keyShortcuts = pKeyShortcuts;
          return keyShortcuts;
        })["catch"](function (pError) {
          console.error(pError);
        });
      } else {
        return this.loadFromPreferences(false).then(function (pKeyShortcuts) {
          TemporyBrowserObjectCache.save("nixps_cloudflow_keyshortcuts", pKeyShortcuts);
          keyShortcuts = pKeyShortcuts;
          return keyShortcuts;
        })["catch"](function (pError) {
          console.error(pError);
        });
      }
    } else {
      return Promise.resolve(keyShortcuts);
    }
  },
  saveToFile: function saveToFile(pContent) {
    var that = this;
    return new Promise(function (pResolve, pReject) {
      var session = "";
      if (api_util.get_session() !== undefined) {
        session = "&session=" + api_util.get_session();
      }
      var checks = "";
      if (fileMetadata[that.url] !== undefined && typeof fileMetadata[that.url].etag === "string" && fileMetadata[that.url].etag.length > 0) {
        checks = "&check_etag=" + fileMetadata[that.url].etag;
      } else if (fileMetadata[that.url] !== undefined && (typeof fileMetadata[that.url].modification === "number" || typeof fileMetadata[that.url].modification === "string" && fileMetadata[that.url].modification.length > 0)) {
        checks = "&check_modification=" + fileMetadata[that.url].modification;
      }
      var headers = {
        "Content-Type": "application/json"
      };
      var csrfToken = api_util.get_cookie("csrf-token");
      if (typeof csrfToken === "string" && csrfToken.length > 0) {
        headers["X-Csrf-Token"] = csrfToken;
      }
      var boundary = "----cloudflowfileconnection" + Date.now();
      // attention keep this header clean,
      // header need to use \r\n for new lines
      // header may not have spaces before or after header keys
      var sendContent = "--" + boundary + '\r\nContent-Type: text/json\r\nContent-Disposition: form-data;filename="dumyblabla.json"\r\n\r\n' + JSON.stringify(pContent);
      sendContent = sendContent + "\r\n--" + boundary + "--\r\n";
      var upload_url = "/portal.cgi?asset=upload_file&url=" + encodeURIComponent(that.url) + "&overwrite=true" + session + checks;
      fetch(upload_url, {
        method: "POST",
        body: sendContent,
        headers: headers,
        success: function success(output, pStatus, jqXHR) {
          if (pStatus === "success") {
            var data = output;
            if (typeof output === "string" && output.length > 0) {
              try {
                data = JSON.parse(output);
              } catch (e) {
                return pReject(output);
              }
            }
            if (Array.isArray(data.files)) {
              if (data.files.length === 1) {
                // etag has been changed, but what is the new value??
                if (fileMetadata[that.url] === undefined) {
                  fileMetadata[that.url] = {};
                }
                fileMetadata[that.url].etag = "";
                fileMetadata[that.url].modification = undefined;
                if (Array.isArray(data.file_info) && data.file_info.length === 1) {
                  if (typeof data.file_info[0].etag === "string") {
                    fileMetadata[that.url].etag = data.file_info[0].etag;
                  }
                  if (typeof data.file_info[0].modification === "number") {
                    fileMetadata[that.url].modification = data.file_info[0].modification;
                  }
                }
                pResolve(pContent);
              } else if (data.files.length === 0) {
                pReject({
                  "error_code": "Document not saved",
                  "error": "saving conflict, the file has been modified by somebody else"
                });
              } else {
                // really strange thing
                pReject({
                  "error_code": "unknown_error",
                  "error": "unknown error"
                });
              }
            }
          } else {
            pReject(data);
          }
        }
      })["catch"](function (pError) {
        if (pError !== undefined && typeof pError.responseText === "string") {
          try {
            return pReject(JSON.parse(pError.responseText));
          } catch (e) {
            return pReject(pError.responseText);
          }
        } else {
          return pReject(pError);
        }
      });
    });
  },
  saveToPreferences: function saveToPreferences(pKeyMappings) {
    return api_defer.preferences.save_for_current_user(pKeyMappings, "com.nixps.keymapping", "keymapping");
  }
};
module.exports = KeyMappingHandler;

},{"../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../PWA/js/Device.js":198,"./KeyMapping.js":173}],175:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var TemporyBrowserObjectCache = require("../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var Device = require("../../PWA/js/Device.js");
var license = null;

/**
 * @description The deferred object of the call to get all the info
 * @default empty
 * @private
 * @type deferred
 */
var getLicenseDeferred = undefined;

/**
 * @constructor License
 * @description The license object, is not to be constructed manually, use nixps.cloudflow.License.get instead.
 * This reprecents the licens of the customer. You can check if he is allowed to do some actions.
 * In most case use the {@link License.get} mothode
 */
var License = function License(pLicenseData) {
  this.mLicenseData = Object.freeze(pLicenseData);
};

/**
 * @brief returns a deferred that returns a license object
 * @name License.get
 * @function
 * @example var License = require("License.js");
 * License.get().then(function(pLicense){
 *      if (pLicense.check("job")) {
 *      
 *      }
 * })
 * @returns {Promise.<License>}
 */
License.get = function () {
  if (license !== null) {
    return Promise.resolve(license);
  }
  if (getLicenseDeferred === undefined) {
    if (TemporyBrowserObjectCache.isPageReload() === true && Device.getPollingFactor() > 1) {
      // we are refreshing when page reload is active, warn developer
      console.warn("Refreshing the page will not solve server overheating issues, it just make it worse!");
    }
    if (TemporyBrowserObjectCache.isPageReload() !== true || Device.getPollingFactor() > 1) {
      var licenseData = TemporyBrowserObjectCache.get("nixps_cloudflow_license");
      if (licenseData !== null) {
        license = new License(licenseData);
        return Promise.resolve(license);
      }
    }
    getLicenseDeferred = api_defer.license.get_license({}).then(function (data) {
      TemporyBrowserObjectCache.save("nixps_cloudflow_license", data);
      license = new License(data);
      return license;
    });
  }
  return getLicenseDeferred;
};

/**
 * @description Clear the license content, clear all the caches
 * @function
 * @name License.clear
 */
License.clear = function () {
  license = null;
  getLicenseDeferred = undefined;
  TemporyBrowserObjectCache.remove("nixps_cloudflow_license");
  TemporyBrowserObjectCache.remove("nixps_cloudflow_menu");
};

/**
 * @description Create a license object from json
 * @name License.fromJSON
 * @function
 * @returns {License}
 */
License.fromJSON = function (json) {
  return new License(json.data);
};
License.prototype = {
  constructor: License,
  /**
   * @brief Checks if the license with pLicenseCode is present in the license
   * @function
   * @name License#check
   * @returns {Boolean} true if the current system has that license, otherwise returns false 
   */
  check: function check(pLicenseCode) {
    var data = this.mLicenseData;
    if (data === undefined || data === null || data.machines === undefined) {
      return false;
    }
    var now = Date.now() / 1000;
    for (var countMachine = 0; countMachine < data.machines.length; ++countMachine) {
      var machine = data.machines[countMachine];
      for (var countLicense = 0; countLicense < machine.licenses.length; ++countLicense) {
        var license = machine.licenses[countLicense];
        if (license.code === pLicenseCode) {
          var ok = true;
          if (license.start !== undefined && license.start > now) {
            ok = false;
          }
          if (license.start !== undefined && license.end < now) {
            ok = false;
          }
          if (ok) {
            return true;
          }
        }
      }
    }

    // If there is no distributed array, we don't have this license
    if (Array.isArray(data.distributed) === false) {
      return false;
    }
    for (var countLicense = 0; countLicense < data.distributed.length; ++countLicense) {
      var license = data.distributed[countLicense];
      if (license.code === pLicenseCode) {
        var ok = true;
        if (license.start !== undefined && license.start > now) {
          ok = false;
        }
        if (license.start !== undefined && license.end < now) {
          ok = false;
        }
        if (ok) {
          return true;
        }
      }
    }
    return false;
  },
  /**
   * @description Are we in an tenant environment, or not?
   * @function
   * @name License#isTenant
   * @returns {Boolean} true if the use is an tenant
   */
  isTenant: function isTenant() {
    var data = this.mLicenseData;
    if (data === undefined || data === null || data.current_tenant === undefined) {
      return false;
    } else {
      return true;
    }
  },
  /**
   * @description get the current tenant name, or an empty string if there is no tenant
   * @function
   * @name License#getTenantName
   * @returns current tenant name or an empty string
   */
  getTenantName: function getTenantName() {
    var data = this.mLicenseData;
    if (data === undefined || data === null || data.current_tenant !== undefined) {
      return data.current_tenant;
    } else {
      return "";
    }
  },
  hasProduct: function hasProduct(pProductName) {
    var data = this.mLicenseData;
    if (data === undefined || data === null || data.products === undefined || data.products === null) {
      return false;
    }
    if (_typeof(data.products.sites) !== "object" || Object.keys(data.products.sites).length === 0) {
      return false;
    }
    var serverName = this.getCurrentServer();
    if (typeof serverName === "string" && serverName.length > 0) {
      var currentSiteName = this.getCurrentSiteName();
      if (currentSiteName === undefined) {
        currentSiteName = "*";
      }
      var serverObj = data.products.sites[currentSiteName];
      if (serverObj !== undefined) {
        var toDay = new Date().toISOString().replace(new RegExp("[.][0-9]{3}"), "");
        var products = serverObj[serverName.toLowerCase()];
        if (Array.isArray(products) && products.length > 0) {
          for (var p = 0; p < products.length; p++) {
            if (products[p].name === pProductName) {
              if (Array.isArray(products[p].interval) && products[p].interval.length === 2) {
                if (products[p].interval[0] <= toDay && products[p].interval[1] >= toDay) {
                  return true;
                } // else there can be an other same name with other intervals so continue
              } else {
                // no interval 
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  },
  /**
   * @description Will the licens expire ?
   * @function
   * @name License#willExpire
   * @param {String} pLicenseCode The code of the license
   * @param {Number} pDays the number of days for now on to the end.
   * @returns {boolean}  returns true if the license code will expire within the given days
   */
  willExpire: function willExpire(pLicenseCode, pDays) {
    var now = Date.now() / 1000;
    var license = this.getInfo(pLicenseCode);
    if (license !== undefined && license !== null && license.end - now < 86400 * pDays) {
      return true;
    }
    return false;
  },
  /**
   * @description any license will expire ?
   * @function
   * @name License#getExpiringLicenseCodes
   * @param {Number} pDays the number of days for now on to the end.
   * @returns {array}  return all license codes that will exprire within the given days
   */
  getExpiringLicenseCodes: function getExpiringLicenseCodes(pDays) {
    var that = this;
    var expiringLicenseCodes = [];
    var codes = this.getAllLicenseCodes();
    codes.forEach(function (pLicenseCode) {
      if (that.willExpire(pLicenseCode, pDays)) {
        expiringLicenseCodes.push(pLicenseCode);
      }
    });
    return expiringLicenseCodes;
  },
  /**
   * @description Is the license expired or not, dected it.
   * @function
   * @name License#isExpired
   * @param {String} pLicenseCode  The code of the license
   * @returns {Boolean} returns true if the license code is expired
   */
  isExpired: function isExpired(pLicenseCode) {
    var now = Date.now() / 1000;
    var license = this.getInfo(pLicenseCode);
    if (license !== undefined && license !== null && license.end < now) {
      return true;
    }
    return false;
  },
  /**
   * @description are there any expired license or not, dected it.
   * @function
   * @name License#getExpiredLicenseCodes
   * @param {String} pLicenseCode  The code of the license
   * @returns {array}  return all license codes that are exprired
   */
  getExpiredLicenseCodes: function getExpiredLicenseCodes() {
    var that = this;
    var expiredLicenseCodes = [];
    var codes = this.getAllLicenseCodes();
    codes.forEach(function (pLicenseCode) {
      if (that.isExpired(pLicenseCode)) {
        expiredLicenseCodes.push(pLicenseCode);
      }
    });
    return expiredLicenseCodes;
  },
  /**
   * @brief returns the license info of a license code
   * @function
   * @name License#getInfo
   */
  getInfo: function getInfo(pLicenseCode) {
    var data = this.mLicenseData;
    if (data === undefined || data === null || data.machines === undefined) {
      return null;
    }
    for (var m = 0; m < data.machines.length; m++) {
      var machine = data.machines[m];
      for (var l = 0; l < machine.licenses.length; l++) {
        var license = machine.licenses[l];
        if (license.code === pLicenseCode) {
          return license;
        }
      }
    }
    return null;
  },
  /**
   * @brief returns all license codes in the license
   * @function
   * @name License#getAllLicenseCodes
   */
  getAllLicenseCodes: function getAllLicenseCodes() {
    var codes = [];
    var data = this.mLicenseData;
    if (data === undefined || data === null || data.machines === undefined) {
      return codes;
    }
    for (var m = 0; m < data.machines.length; m++) {
      var machine = data.machines[m];
      for (var l = 0; l < machine.licenses.length; l++) {
        var license = machine.licenses[l];
        codes.push(license.code);
      }
    }
    return codes;
  },
  /**
   * @description Get the name of the current site.
   * @function
   * @name License#getCurrentSiteName
   * @returns {String} The name of the current Site
   */
  getCurrentSiteName: function getCurrentSiteName() {
    var name;
    if (this.mLicenseData !== undefined && this.mLicenseData !== null && typeof this.mLicenseData.current_site === "string" && this.mLicenseData.current_site.length > 0) {
      name = this.mLicenseData.current_site;
    }
    return name;
  },
  /**
   * @description Get the name of the current server
   * @function
   * @name License#getCurrentServer
   * @returns the name of the current server, mostly returned in cappital letters
   */
  getCurrentServer: function getCurrentServer() {
    var name = null;
    if (this.mLicenseData !== undefined && this.mLicenseData !== null && typeof this.mLicenseData.current_server === "string" && this.mLicenseData.current_server.length > 0) {
      name = this.mLicenseData.current_server;
    }
    return name;
  },
  /**
   * @brief returns the customer code
   * @function
   * @name License#getCustomerCode
   * @returns {String} The customer code otherwise null
   */
  getCustomerCode: function getCustomerCode() {
    var name = null;
    if (this.mLicenseData !== undefined && this.mLicenseData !== null && typeof this.mLicenseData.customer_code === "string" && this.mLicenseData.customer_code.length > 0) {
      name = this.mLicenseData.customer_code;
    }
    return name;
  },
  hasLayoutCustomisation: function hasLayoutCustomisation() {
    return false;
  },
  getLayoutCustomisation: function getLayoutCustomisation() {
    return null;
  },
  /**
   * @description Get the row data
   * @function
   * @private
   * @name License#getData
   * @return {json}
   */
  getData: function getData() {
    return this.mLicenseData;
  },
  /**
   * @brief returns true if this is a datalink license
   * @function
   * @name License#isDataLink
   * @returns {Boolean} true if license is a datalink, false otherwise
   */
  isDataLink: function isDataLink() {
    return this.check("portal") === false && this.check("datalink") === true && this.check("java_web_apps_host") === true;
  },
  /**
   * @brief returns true if this is a standalone rip license
   * @function
   * @name License#isStandaloneRip
   * @returns {Boolean} true if license is a standalone rip, false otherwise
   */
  isStandaloneRip: function isStandaloneRip() {
    return this.check("portal") === false && this.check("quantumrip") === true;
  },
  /**
   * @description Is the current settup a demo licens or not?
   * @function
   * @name License#isDemoLicens
   * @returns {Boolean}
   */
  isDemoLicense: function isDemoLicense() {
    return this.check("demo");
  },
  /**
   * @brief returns the site names defined in the license
   * @function
   * @name License#getSiteNames
   * @returns {Array.<String>} A list of sitenames
   */
  getSiteNames: function getSiteNames() {
    var licenseData = this.mLicenseData;
    var siteList = [];
    if (licenseData.sites !== undefined) {
      var sites = licenseData.sites;
      for (var i = 0; i < sites.length; i++) {
        // Skip the "*" placeholders
        if (sites[i].name === "*") {
          continue;
        }
        siteList.push(sites[i].name);
      }
    }
    return siteList;
  },
  /**
   * @brief returns true if this is a multisite license (share and/or more than one site name)
   * @function
   * @name License#isMultiSite
   * @returns {Boolean} true if multisite, otherwise false 
   */
  isMultiSite: function isMultiSite() {
    var licenseData = this.mLicenseData;
    return this.check("share") || licenseData.products.distributed.length > 0;
  },
  getStatus: function getStatus() {
    return this.mLicenseData.status;
  },
  /**
   * @description Check if the license is valid or not
   * @function
   * @name License#isValid
   * @returns Boolean true if the license is valid
   */
  isValid: function isValid() {
    return this.mLicenseData !== undefined && this.mLicenseData !== null && this.mLicenseData.status !== "invalid";
  },
  /**
   * @description Returns the json structure of the license object
   * @function
   * @name License#toJSON
   * @returns {Object} The json object
   */
  toJSON: function toJSON() {
    return {
      "data": Object.assign({}, this.mLicenseData)
    };
  }
};
module.exports = License;

},{"../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../PWA/js/Device.js":198}],176:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jul 31, 2018 11:19:54 AM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  "use strict";

  require("../../../common/NotifyArea/js/nixps-NotifyArea.js");
  var User = require("../../User/js/User.js");
  var License = require("../../License/js/License.js");

  /**
   * @namespace nixps-cloudflow.LicenseBanner
   * @description draw a banner depending the licenses
   * @private
   * @example $("<div>").LicenseBanner({});
   */
  $.widget("nixps-cloudflow.LicenseBanner", $.Widget, {
    options: {
      /**
       * @name nixps-cloudflow.LicenseBanner#user
       * @description The current User
       * @default null
       */
      user: null,
      showMaintenanceWarning: false,
      /**
       * @name nixps-cloudflow.LicenseBanner#ignoreWhenLicense
       * @description Ignore the warnings if in specific license
       * @type {Array}
       */
      ignoreWhenLicense: ""
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.LicenseBanner#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._addClass(this.widgetFullName);
      this._controlOptions();
      this.alive = true;
      this.user = null; // the current user

      var that = this;
      $.when(this._getUser()).then(function (pUser) {
        if (that.alive === false) {
          return; // kill zombies
        }

        that._draw();
      });
      this._on(this.element, {});
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.LicenseBanner#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      if ($.fn.notify !== undefined && this.user !== null && this.user.hasAdminPermissions() === true) {
        var that = this;
        this._preparePanel();
        $.when(this._getMessageToShow()).then(function (pMessages) {
          if (that.alive === false) {
            return; // kill zombies
          }

          if (Array.isArray(pMessages) && pMessages.length > 0) {
            for (var i = 0; i < pMessages.length; i++) {
              that._showMessage(pMessages[i].title, pMessages[i].text);
            }
          }
        });
      } else {
        // do nothing
      }
    },
    _showMessage: function _showMessage(pTitle, pText) {
      $("#notify-area").notify("create", "warning", {
        title: pTitle,
        text: pText
      }, {
        expires: 0,
        click: function click(e, instance) {
          instance.close();
        },
        close: function close(pEvent) {}
      });
    },
    _preparePanel: function _preparePanel() {
      // check if there are notify-areas without created inside the dedicated NotifyArea component
      // notifyArea has already the licensebanner template
      if ($('#notify-area:not(".nixps-NotifyArea")').length > 0) {
        // there is an old one
        var warningBanner = "<div id='warning' class='cf-notify-message cf-notify-warning'>" + "<a class='cf-notify-close ui-notify-cross ui-notify-close' href='#'>x</a>" + "<h1 class='cf-notify-title'>#{title}</h1>" + "<p class='cf-notify-messagetext'>#{text}</p>" + "</div>";
        // there is a notify panel !
        var dataEchNotify = $('#notify-area').data("echNotify");
        if (dataEchNotify !== undefined) {
          dataEchNotify.templates["licensebanner"] = warningBanner;
          dataEchNotify.templates["warning"] = warningBanner;
        }
        var dataNotify = $('#notify-area').data("notify");
        if (dataNotify !== undefined) {
          dataNotify.templates["licensebanner"] = warningBanner;
          dataNotify.templates["warning"] = warningBanner;
        }
      } else if ($.fn.notify !== undefined && $("#notify-area").length === 0) {
        // there is no notify panel?
        $('body').append($('<div>').NotifyArea({
          'top': 32
        }));
      } else {
        // ??
      }
    },
    _getUser: function _getUser() {
      if (this.options.user === null) {
        var that = this;
        return $.when(User.get()).then(function (pUser) {
          that.user = pUser;
          return that.user;
        });
      } else {
        this.user = this.options.user;
        return this.user;
      }
    },
    /**
     * @description Get all the messages to show
     * @function
     * @private
     * @name nixps-cloudflow.LicenseBanner#_getMessageToShow
     * @return {Deferred}
     */
    _getMessageToShow: function _getMessageToShow() {
      var that = this;
      return $.Deferred(function (pDefer) {
        License.get().then(function (pLicense) {
          if (that.alive === false) {
            return;
          }
          if (typeof that.options.ignoreWhenLicense === "string" && that.options.ignoreWhenLicense.length > 0) {
            if (pLicense.check(that.options.ignoreWhenLicense)) {
              pDefer.resolve([]);
              return;
            }
          } else if (Array.isArray(that.options.ignoreWhenLicense) && that.options.ignoreWhenLicense.length > 0) {
            for (var i = 0; i < that.options.ignoreWhenLicense.length; i++) {
              if (pLicense.check(that.options.ignoreWhenLicense[i])) {
                pDefer.resolve([]);
                return;
              }
            }
          }
          var pData = pLicense.getData();
          var messages = [];
          if (that.options.showMaintenanceWarning === true && that.user.isAdminAdmin()) {
            if (pLicense.isExpired("maintenance")) {
              messages.push({
                title: $.i18n._("nixps-cloudflow-notifications.title_group_maintenaince"),
                text: $.i18n._("nixps-cloudflow-top.message_maintenance")
              });
            } else if (pLicense.willExpire("maintenance", 30)) {
              messages.push({
                title: $.i18n._("nixps-cloudflow-notifications.title_group_maintenaince"),
                text: $.i18n._("nixps-cloudflow-top.message_expire", [api.utils.format_date(pLicense.getInfo("maintenance").end * 1000, "%B %d, %Y", new Date().getTimezoneOffset()).result])
              });
            }
          }
          if (pData !== null && pData.machines !== undefined) {
            for (var m = 0; m < pData.machines.length; ++m) {
              //pData.machines[m].activation = "not activated";
              //pData.machines[m].activation_days_left = m*2;
              //pData.machines[m].activation = "error";
              //pData.days_until_renew = 20;
              if (pData.machines[m].activation === "not activated") {
                if (pData.machines[m].activation_days_left === 0) {
                  messages.push({
                    title: $.i18n._("nixps-cloudflow-license.title"),
                    text: $.i18n._("nixps-cloudflow-license.activation-workserver_needs_activation_today", [pData.machines[m].name])
                  });
                } else if (pData.machines[m].activation_days_left < 10) {
                  messages.push({
                    title: $.i18n._("nixps-cloudflow-license.title"),
                    text: $.i18n._("nixps-cloudflow-license.activation-workserver_needs_activation_days_left", [pData.machines[m].name, pData.machines[m].activation_days_left])
                  });
                }
              } else if (pData.machines[m].activation === "required") {
                messages.push({
                  title: $.i18n._("nixps-cloudflow-license.title"),
                  text: $.i18n._("nixps-cloudflow-license.activation-workserver_inactive_needs_activation", [pData.machines[m].name])
                });
              } else if (pData.machines[m].activation === "error") {
                messages.push({
                  title: $.i18n._("nixps-cloudflow-license.title"),
                  text: $.i18n._("nixps-cloudflow-license.activation-workserver_inactive_invalid_activation", [pData.machines[m].name])
                });
              }
            }
            if (pData.days_until_renew <= 30) {
              messages.push({
                title: $.i18n._("nixps-cloudflow-license.title"),
                text: $.i18n._("nixps-cloudflow-license.time_left_for_renew", [90, pData.days_until_renew])
              });
            }
          }
          pDefer.resolve(messages);
        }, function (pError) {
          pDefer.resolve([]);
        });
      });
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.LicenseBanner#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.LicenseBanner#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {},
    _destroy: function _destroy() {
      this.alive = false;
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../common/NotifyArea/js/nixps-NotifyArea.js":299,"../../License/js/License.js":175,"../../User/js/User.js":268}],177:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 19 mrt 2021
 */
(function ($) {
  "use strict";

  require("../../../common/js/myjQueryPlugins.js");
  require("../../../common/NotifyArea/js/nixps-NotifyArea.js");
  require("../../../common/DynamicList/js/nixps-DynamicList.js");
  require("../../../common/DropdownList/js/nixps-DropdownList.js");
  require("../../../common/ActionMenu/js/nixps-ActionMenu.js");
  require("./nixps-cloudflow-ListPanelEdit.js");
  require("../../../common/FileDropUpload/js/nixps-FileDropUpload.js");
  require("../../../common/SearchHighlight/js/nixpsSearchHighlight.js");
  var CloudflowObject = require("../../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
  var Device = require("../../PWA/js/Device.js");

  /**
   * @namespace nixps-cloudflow.ListGroup
   * @description Draw a panel to group items. is a child of ListPanel
   * @example $("<div>").ListGroup({
    * });
   * @version 1.2.0
   */
  $.widget("nixps-cloudflow.ListGroup", $.Widget, {
    version: "1.2.0",
    widgetEventPrefix: "listgroup",
    options: {
      /**
       * @name nixps-cloudflow.ListGroup#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.ListGroup#listGroupIdentifier
       * @description An idnetifier of the list group, to be given through event data
       * @type {String}
       * @default undefined
       */
      listGroupIdentifier: undefined,
      /**
       * @name nixps-cloudflow.ListGroup#relativeBasePath
       * @description The path to be used if the url is relative
       * @type {String}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.ListGroup#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       * @default "default"
       */
      style_type: "default",
      /**
       * @description The title of the group
       * @name nixps-cloudflow.ListGroup#title
       * @type {String}
       * @default ""
       */
      title: "",
      /**
       * @description The content or children of the group. Can be an array or a function returning the data.
       * Data must contain next data
       * <dl>
       * <dt>label:</dt> <dd>String|Function text to display</dd>
       * <dt>classes:</dt> <dd>String class names to be added to the item container</dd>
       * <dt>badge_number:</dt> <dd>Number number to display as badge number</dd>
       * <dt>disabled:</dt> <dd>Boolean if true the item will be disabled</dd>
       * </dl>
       * @name nixps-cloudflow.ListGroup#children
       * @type {Array}
       * @default []
       */
      children: [],
      /**
       * @description Technical options for handling the items. It contains disableClasses and keyUniqID
       * @type {Object} 
       * @name nixps-cloudflow.ListGroup#childrenOptions
       * @default {
          "disabledClasses": "",
          "keyUniqID": "_id"
         }
       */
      childrenOptions: {
        "disabledClasses": "",
        "keyUniqID": "_id"
      },
      /**
       * @description The search key used for searching while option @link{nixps-cloudflow.ListGroup#lazyScrollLoading} is active
       * @name nixps-cloudflow.ListGroup#searchKey
       * @type {String}
       * @default ""
       * @since 1.1.0
       */
      searchKey: "",
      /**
       * @description The options to give to the formDetailsPanel, wh will create or update the items
       * @name nixps-cloudflow.ListGroup#formdetailspanelOptions
       * @type {Object}
       * @default {}
       */
      formdetailspanelOptions: {},
      /**
       * @description The options to give to the ListPanelEdit
       * @name nixps-cloudflow.ListGroup#formParentPositioning
       * @type {String}
       * @default {undefined
       */
      formParentPositioning: undefined,
      /**
       * @description The default options while creating a new item
       * @name nixps-cloudflow.ListGroup#formdetailspanelCreateNewValues
       * @type {Object}
       * @default {}
       */
      formdetailspanelCreateNewValues: {},
      /**
       * @description function to alter data after creation
       * @name nixps-cloudflow.ListGroup#afterCreatingCB
       * @type {Function}
       * @default undefined
       */
      afterCreatingCB: undefined,
      /**
       * @description function to alter data before editing
       * @name nixps-cloudflow.ListGroup#beforeEditingCB
       * @type {Function}
       * @default undefined
       */
      beforeEditingCB: undefined,
      /**
       * @description function to alter data after editing
       * @name nixps-cloudflow.ListGroup#afterEditingCB
       * @type {Function}
       * @default undefined
       */
      afterEditingCB: undefined,
      /**
       * @description The options of selecting
       * @name nixps-cloudflow.ListGroup#selectingOptions
       * @type {Object}
       * @description {
       *  multiple: false,
          deselectable: false,
          selectClass: "cf-select"
       * }
       */
      selectingOptions: {
        multiple: false,
        deselectable: false,
        selectClass: "cf-select",
        cancel: "input,textarea,button,select,option,[contenteditable='true'],[contenteditable=plaintext-only],.cf-settingslist-groupitem-settings"
      },
      /**
       * @description The time between updates in milliseconds
       * @name nixps-cloudflow.ListGroup#updateDelay
       * @type {Number}
       * @default 0
       */
      updateDelay: 0,
      /**
       * @description The text to be displayed when no items are there
       * @name nixps-cloudflow.ListGroup#textNoItemsToDisplay
       * @type {String}
       * @default "nixps-cloudflow-listgroup.message_noitemstodisplay"
       */
      textNoItemsToDisplay: undefined,
      /**
       * @description The text to be visible between creating and drawing the first time
       * @type {String}
       * @name nixps-cloudflow.ListGroup#textCreatingToDisplay
       * @default undefined
       * @since 1.2.0
       */
      textCreatingToDisplay: undefined,
      /**
       * @description The text to be displayed as tooltip upload button
       * @name nixps-cloudflow.ListGroup#textTooltipUpload
       * @type {String}
       * @default "nixps-cloudflow-listgroup.tooltip_upload"
       */
      textTooltipUpload: undefined,
      /**
       * @description The text to be displayed as tooltip add button
       * @name nixps-cloudflow.ListGroup#textTooltipAdd
       * @type {String}
       * @default "nixps-cloudflow-listgroup.tooltip_add"
       */
      textTooltipAdd: undefined,
      /**
      * @description The text to be displayed as tooltip of the settings menu
      * @name nixps-cloudflow.ListGroup#textTooltipMenu
      * @type {String}
      * @default "nixps-cloudflow-listgroup.tooltip_more"
      */
      textTooltipMenu: undefined,
      /**
       * @description Must we show the upload button or not?
       * @name nixps-cloudflow.ListGroup#enableUploadButton
       * @type {Boolean}
       * @default false
       */
      enableUploadButton: false,
      /**
       * @description Must we show the add button or not?
       * @name nixps-cloudflow.ListGroup#enableAddButton
       * @type {Boolean}
       * @default true
       */
      enableAddButton: true,
      /**
       * @description Must we show the drop down menu or not?
       * @name nixps-cloudflow.ListGroup#enableDropdownMenu
       * @type {Boolean}
       * @default true
       */
      enableDropdownMenu: true,
      /**
       * @description The icon classes to represent the settings
       * @name nixps-cloudflow.ListGroup#settingsIcon
       * @type {String}
       * @default "cf-icon cf-icon-settings"
       */
      settingsIcon: "cf-icon cf-icon-settings",
      /**
       * @description Must the main group be collapsable or not
       * @name nixps-cloudflow.ListGroup#collapsable
       * @type {Boolean}
       * @default false
       */
      collapsable: false,
      /**
       * @description The additional items to add to the drop down
       * @name nixps-cloudflow.ListGroup#dropdownListItems
       * @type {Array.<Object>}
       * @default []
       */
      dropdownListItems: [],
      /**
       * @description Sort data ascending? if not true sort descending
       * @name nixps-cloudflow.ListGroup#ascending
       * @type {Boolean}
       * @default true
       */
      ascending: true,
      /**
       * @description Sort function, if not defined the data is not sorted.
       * @name nixps-cloudflow.ListGroup#sortFunction
       * @type {Function}
       * @default undefined
       */
      sortFunction: undefined,
      /**
       * @description The classes to given to the menu button when there is no menu items
       * @name nixps-cloudflow.ListGroup#emptyMenuButtonClasses
       * @type {String}
       * @default "cf-disabled"
       */
      emptyMenuButtonClasses: "cf-disabled",
      /**
       * @description Must we do a lazyloading scrolling or not?
       * @name nixps-cloudflow.ListGroup#lazyScrollLoading
       * @type {Boolean}
       * @default false
       * @since 1.1.0
       */
      lazyScrollLoading: false,
      /**
       * @name nixps-cloudflow.ListGroup#created
       * @description Function run when component is done being created
       * @function
       * @private
       * @type {Function}
       */
      created: function created() {}
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        "textNoItemsToDisplay": $.i18n._("nixps-cloudflow-listgroup.message_noitemstodisplay"),
        "textTooltipUpload": $.i18n._("nixps-cloudflow-listgroup.tooltip_upload"),
        "textTooltipAdd": $.i18n._("nixps-cloudflow-listgroup.tooltip_add"),
        "textTooltipMenu": $.i18n._("nixps-cloudflow-listgroup.tooltip_more"),
        "textCreatingToDisplay": $.i18n._("nixps-cloudflow-listgroup.text_loading")
      };
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.ListGroup#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      var that = this;
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type).attr("data-uuid", this.uuid);
      this.creating = true;
      this.panel;
      this.searchString = "";
      this.disabledManageFunction = false; // are we disabling the function to manage the list?

      var titleDOM = $("<div>").addClass("lg_title cf-settingslist-grouptitle").append($("<div>").addClass("lg_title_text cf-settingslist-grouptitle-text").text(this.options.title));
      this.element.append(titleDOM);
      if ($(".nixps-ActionMenu").length === 0) {
        $("body").append($("<div>").ActionMenu());
      }
      if (Array.isArray(this.options.topbarButtons) && this.options.topbarButtons.length > 0) {
        var buttonDOMs = new Array(this.options.topbarButtons.length);
        for (var i = 0; i < this.options.topbarButtons.length; i++) {
          buttonDOMs[i] = $("<button>").attr("type", "button").addClass("cf-iconbutton").addClass(this.options.topbarButtons[i].classes).attr("title", this.options.topbarButtons[i].tooltip);
          if (typeof this.options.topbarButtons[i].action === "string") {
            buttonDOMs[i].attr("data-action", this.options.topbarButtons[i].action);
          }
          if (typeof this.options.topbarButtons[i].data_testid === "string") {
            buttonDOMs[i].attr("data-testid", this.options.topbarButtons[i].data_testid);
          }
          if (typeof this.options.topbarButtons[i].onclick === "function") {
            buttonDOMs[i].on("click", this.options.topbarButtons[i].onclick);
          }
        }
        titleDOM.append(buttonDOMs);
      }
      if (this.options.enableUploadButton === true) {
        var uploadIconBttnDOM = $("<button>").attr("type", "button").addClass("lg_title_upload cf-iconbutton cf-icon cf-icon-lg cf-icon-upload listgroup_tooltip").attr("title", this.options.textTooltipUpload);
        titleDOM.append(uploadIconBttnDOM);
      }
      if (this.options.enableAddButton === true) {
        var addIconBttnDOM = $("<button>").attr("type", "button").addClass("lg_title_add cf-iconbutton cf-icon cf-icon-lg cf-icon-plus-circle listgroup_tooltip").attr("title", this.options.textTooltipAdd);
        addIconBttnDOM.attr("data-button-id", this.options.addButtonId);
        titleDOM.append(addIconBttnDOM);
      }
      if ($.fn.tooltip !== undefined) {
        this.element.tooltip({
          content: function content() {
            var title = $(this).attr("title");

            // Escape title, since we're going from an attribute to raw HTML
            return $("<a>").text(title).html();
          },
          items: ".listgroup_tooltip[title]",
          tooltipClass: "cf-tooltip cf-tooltip-secondary",
          classes: {
            "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
          },
          position: {
            my: "left+5px center",
            at: "right center",
            collision: "flipfit flip"
          }
        });
      }
      var content = $("<div>").addClass("lg_children");
      this.element.append(content);
      content.one("dynamiclistdrawed", function () {
        if (that.creating) {
          that.creating = false;
          that.options.created();
        }
      }).one("dynamiclisterror", function () {
        if (that.creating) {
          that.creating = false;
          that.options.created();
        }
      });
      content.DynamicList({
        dataProvider: this._dataProvider.bind(this),
        makeItem: this._makeItem.bind(this),
        updateItem: this._updateItem.bind(this),
        hasItemChanged: this._hasItemChanged.bind(this),
        keyUniqID: this.options.childrenOptions.keyUniqID,
        updateDelay: this.options.updateDelay,
        allowToUpdate: function allowToUpdate(pElem) {
          return pElem.is(":visible");
        },
        editNameSelector: null,
        nameChange: function nameChange() {},
        enableSortable: false,
        enableSelecting: this.options.selectingOptions !== null,
        selectingOptions: this.options.selectingOptions,
        sortFunction: this.options.sortFunction,
        ascending: this.options.ascending,
        emptyRowsPanel: $("<span>").text(this.options.textNoItemsToDisplay),
        loadingPanel: $("<span>").addClass("cf-addmarginsection cf-tabsection").text(this.options.textCreatingToDisplay),
        lazyLoading: this.options.lazyScrollLoading,
        scrollElement: this.element.parent()
      });
      var searchContent = $("<div>").addClass("lg_searchchildren").hide();
      this.element.append(searchContent);
      this.search = this._search;
      if (this.options.lazyScrollLoading === true) {
        this.search = this._searchWithLazyLoading;
      }
      if ($.isEmptyObject(this.options.formdetailspanelOptions) === false) {
        this.panel = $("<div>");
        this.panel.ListPanelEdit({
          detailsOptions: Object.assign(this.options.formdetailspanelOptions, {
            "language": this.options.language
          }),
          parentPositioning: this.options.formParentPositioning,
          settingsButtonSelector: this.options.formSettingsButtonSelector
        });
        this.panel.on("listpaneleditcreatenew", this._creatingNewHandler.bind(this));
        this.panel.on("listpaneleditedit", this._editingHandler.bind(this));
      }
      if ($.isEmptyObject(this.options.dropOptions) === false) {
        this.element.FileDropUpload(Object.assign({
          useDropZone: true,
          addInputFiles: true,
          replaceNewLinesBySemicolon: false,
          droppingClass: "cf-settingslist-dragdropping",
          informDroppingElement: this.element
        }, this.options.dropOptions));
        var dropText = "";
        if (typeof this.options.dropOptions.dropText === "string") {
          dropText = this.options.dropOptions.dropText;
        } else {
          dropText = $.i18n._("nixps-cloudflow-listgroup.text_while_dropping");
        }
        this.element.append($("<div>").addClass("cf-settingslist-dragginghelp cf-center-text").append($("<span>").addClass("cf-icon cf-icon-5x cf-icon-download")).append($("<div>").addClass("cf-settingslist-dragginghelp-text").text(dropText)));
        this._on(this.element, {
          "filedropuploaduploaded": this._uploadNewHandler
        });
      }
      this._on(this.element, {
        "click .lg_title_add": this._clickNewHandler,
        "click .lg_title_upload": this._clickUploadHandler,
        "click .list_item .cf-settingslist-groupitem-settings": this._showActionMenu,
        "dynamiclistselect": this._selectHandler,
        "dynamiclistdrawed": this._drawedHandler,
        "dynamiclistupdate": this._drawedHandler,
        "dynamiclistdesactivescrolling.lg_children": this._deactivateScrollingHandler,
        "dynamiclistactivescrolling.lg_children": this._activateScrollingHandler
      });
    },
    _showActionMenu: function _showActionMenu(pEvent) {
      var that = this;
      pEvent.stopPropagation();
      pEvent.stopImmediatePropagation();
      pEvent.preventDefault();
      var id = $(pEvent.currentTarget).parents(".list_item").attr("data-id");
      var object = this.getValue().find(function (item) {
        return CloudflowObject.getParameter(item, that.options.childrenOptions.keyUniqID) === id;
      });
      var actionArray = [];
      if (object.edit === true) {
        actionArray.push({
          text: $.i18n._("nixps-cloudflow-listgroup.label_edit"),
          iconClass: "cf-icon cf-icon-pencil",
          onClick: function onClick(pClickEvent) {
            if ($.isEmptyObject(that.options.formdetailspanelOptions) === false && object.data !== undefined) {
              var value = object.data;
              if (typeof that.options.beforeEditingCB === "function") {
                that.panel.ListPanelEdit("open", pEvent).ListPanelEdit("hideErrorMessages").ListPanelEdit("setMultipleValues", {
                  rowObjects: [object.data]
                }).ListPanelEdit("disable");
                $.when(that.options.beforeEditingCB(object.data)).then(function (pAdaptedData) {
                  if (pAdaptedData !== null) {
                    value = pAdaptedData;
                  }
                  that.panel.ListPanelEdit("enable").ListPanelEdit("setMultipleValues", {
                    rowObjects: [value]
                  });
                });
              } else {
                that.panel.ListPanelEdit("open", pEvent).ListPanelEdit("hideErrorMessages").ListPanelEdit("setMultipleValues", {
                  rowObjects: [value]
                }).ListPanelEdit("repositionMe", pEvent);
              }
            }
            that._trigger("edit", null, that._getTriggerRowData(object, pEvent));
          }
        });
      }
      if (object.duplicate === true) {
        actionArray.push({
          text: $.i18n._("nixps-cloudflow-listgroup.label_duplicate"),
          iconClass: "cf-icon cf-icon-duplicate",
          onClick: function onClick(pClickEvent) {
            that._trigger("duplicate", null, that._getTriggerRowData(object, pEvent, pClickEvent));
          }
        });
      }
      if (object.download === true) {
        if (typeof object.download_url === "string" && object.download_url.length > 0) {
          actionArray.push({
            text: $.i18n._("nixps-cloudflow-listgroup.label_download"),
            iconClass: "cf-icon cf-icon-download",
            download_filename: object.download_filename || "filename",
            clickCB: object.download_url
          });
        } else {
          actionArray.push({
            text: $.i18n._("nixps-cloudflow-listgroup.label_download"),
            iconClass: "cf-icon cf-icon-download",
            onClick: function onClick(pClickEvent) {
              that._trigger("download", null, that._getTriggerRowData(object, pEvent, pClickEvent));
            }
          });
        }
      }
      var dropdownListItems = [];
      var dropdownListItemsDef;
      if (Array.isArray(object.dropdownListItems) && object.dropdownListItems.length > 0) {
        dropdownListItems = object.dropdownListItems;
      }
      if (this.options.dropdownListItems.length > 0) {
        dropdownListItems = dropdownListItems.concat(this.options.dropdownListItems);
      }
      if (dropdownListItems.length > 0) {
        dropdownListItemsDef = $.Deferred(function (pDefer) {
          var listItemDefs = [];
          var _loop = function _loop() {
            var isDeferred = false;
            var listItemDef = dropdownListItems[i];
            if (typeof dropdownListItems[i] === "function") {
              isDeferred = true;
              listItemDef = dropdownListItems[i](pEvent, object);
            } else if (typeof dropdownListItems[i] === "string" || typeof dropdownListItems[i] === "number") {
              (function (pAction) {
                listItemDef = {
                  text: dropdownListItems[i],
                  onClick: function onClick(pEvent) {
                    that._trigger("dropdownitemclick", pEvent, Object.assign(that._getTriggerRowData(object), {
                      action: pAction
                    }));
                  }
                };
              })(dropdownListItems[i]);
            } else if ($.isPlainObject(dropdownListItems[i]) === false) {
              console.error("_addDropdownList: invalid interface found for dropdownlist");
              return "continue";
            }
            listItemDefs.push(listItemDef);
            $.when(listItemDef).done(function (dropdownListItem) {
              if (Array.isArray(dropdownListItem.subbuttons) === true) {
                dropdownListItem.subbuttons.forEach(function (pSubButton) {
                  if (pSubButton.label) {
                    pSubButton.text = pSubButton.label;
                  }
                  if (pSubButton.action) {
                    (function (pAction) {
                      pSubButton.onClick = function (pEventArg) {
                        that._trigger("dropdownitemclick", pEventArg, Object.assign(that._getTriggerRowData(object), {
                          action: pAction
                        }));
                      };
                    })(pSubButton.action);
                  }
                  if (pSubButton.onClick) {
                    (function (pOnClick) {
                      pSubButton.onClick = function (pEventArg) {
                        pOnClick(pEventArg, that._getTriggerRowData(object));
                      };
                    })(pSubButton.onClick);
                  }
                  if (pSubButton.icon) {
                    pSubButton.iconClass = pSubButton.icon;
                  }
                });
              }
              if (dropdownListItem.label) {
                dropdownListItem.text = dropdownListItem.label;
              }
              if (dropdownListItem.action) {
                (function (pAction) {
                  dropdownListItem.onClick = function (pEventArg) {
                    that._trigger("dropdownitemclick", pEventArg, Object.assign(that._getTriggerRowData(object), {
                      action: pAction
                    }));
                  };
                })(dropdownListItem.action);
              }
              if (dropdownListItem.onClick) {
                (function (pOnClick) {
                  dropdownListItem.onClick = function (pEventArg) {
                    pOnClick(pEventArg, that._getTriggerRowData(object));
                  };
                })(dropdownListItem.onClick);
              }
              if (dropdownListItem.icon) {
                dropdownListItem.iconClass = dropdownListItem.icon;
              }
              actionArray.push(dropdownListItem);
            });
          };
          for (var i = 0; i < dropdownListItems.length; i++) {
            var _ret = _loop();
            if (_ret === "continue") continue;
          }
          $.when.apply($, listItemDefs).done(function () {
            pDefer.resolve({});
          });
        });
      }
      var pointerX = pEvent.clientX;
      var pointerY = pEvent.clientY;
      if (pointerX === 0 && pointerY === 0 && pEvent.detail === 0 && typeof pEvent.target.getBoundingClientRect === "function") {
        var clientRect = pEvent.target.getBoundingClientRect();
        pointerX = clientRect.left;
        pointerY = clientRect.top;
      }
      if (dropdownListItemsDef !== undefined) {
        $.when(dropdownListItemsDef).done(function () {
          //add the delete as last
          if (object["delete"] === true) {
            actionArray.push({
              text: $.i18n._("nixps-cloudflow-listgroup.label_delete"),
              iconClass: "cf-icon cf-icon-trash",
              classes: "cf-dropdown-item-error",
              onClick: function onClick(pClickEvent) {
                that._trigger("delete", null, that._getTriggerRowData(object, pEvent, pClickEvent));
              }
            });
          }
          if (actionArray.length > 0) {
            $(".nixps-ActionMenu").ActionMenu("show", pointerX, pointerY, actionArray);
          }
        });
      } else {
        if (object["delete"] === true) {
          actionArray.push({
            text: $.i18n._("nixps-cloudflow-listgroup.label_delete"),
            iconClass: "cf-icon cf-icon-trash",
            classes: "cf-dropdown-item-error",
            onClick: function onClick(pClickEvent) {
              that._trigger("delete", null, that._getTriggerRowData(object, pEvent, pClickEvent));
            }
          });
        }
        if (actionArray.length > 0) {
          $(".nixps-ActionMenu").ActionMenu("show", pointerX, pointerY, actionArray);
        }
      }
    },
    _creatingNewHandler: function _creatingNewHandler(pEvent, pData) {
      pEvent.stopPropagation();
      pData.listGroupIdentifier = this.options.listGroupIdentifier;
      if (typeof this.options.afterCreatingCB === "function") {
        var adaptedData = this.options.afterCreatingCB(pData);
        if (adaptedData !== undefined) {
          if (adaptedData.result !== undefined) {
            if (this.options.formdetailspanelOptions && this.options.formdetailspanelOptions.closeAfterDecision === false && this.options.formdetailspanelOptions.hideBottomBarButtonsOnDisable === false) {
              this.panel.ListPanelEdit("disable");
            }
            return this._trigger("creatingnew", null, [adaptedData.result, this._afterFormHandingCallBack.bind(this)]);
          } else if (adaptedData.error !== undefined) {
            this._afterFormHandingCallBack(adaptedData);
            return false;
          }
        }
        return;
      }
      if (this.options.formdetailspanelOptions && this.options.formdetailspanelOptions.closeAfterDecision === false && this.options.formdetailspanelOptions.hideBottomBarButtonsOnDisable === false) {
        this.panel.ListPanelEdit("disable");
      }
      return this._trigger("creatingnew", null, [pData, this._afterFormHandingCallBack.bind(this)]);
    },
    _editingHandler: function _editingHandler(pEvent, pData) {
      pEvent.stopPropagation();
      if (typeof this.options.afterEditingCB === "function") {
        var adaptedData = this.options.afterEditingCB(pData);
        if (adaptedData !== undefined) {
          if (adaptedData.result !== undefined) {
            if (this.options.formdetailspanelOptions && this.options.formdetailspanelOptions.closeAfterDecision === false && this.options.formdetailspanelOptions.hideBottomBarButtonsOnDisable === false) {
              this.panel.ListPanelEdit("disable");
            }
            return this._trigger("editing", null, [adaptedData.result, this._afterFormHandingCallBack.bind(this)]);
          } else if (adaptedData.error !== undefined) {
            this._afterFormHandingCallBack(adaptedData);
            return false;
          }
        }
        return;
      }
      if (this.options.formdetailspanelOptions && this.options.formdetailspanelOptions.closeAfterDecision === false && this.options.formdetailspanelOptions.hideBottomBarButtonsOnDisable === false) {
        this.panel.ListPanelEdit("disable");
      }
      return this._trigger("editing", null, [pData, this._afterFormHandingCallBack.bind(this)]);
    },
    _afterFormHandingCallBack: function _afterFormHandingCallBack(pError) {
      this.panel.ListPanelEdit("enable");
      if (pError !== undefined && pError.error !== undefined) {
        this.panel.ListPanelEdit("showErrorMessage", pError.error);
      } else if (typeof pError === "string" && pError.length > 0) {
        this.panel.ListPanelEdit("showErrorMessage", pError);
      } else {
        this.panel.ListPanelEdit("close");
      }
    },
    /**
     * @description user want to add a new item
     * @name nixps-cloudflow.ListGroup#_clickNewHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _clickNewHandler: function _clickNewHandler(pEvent, pData) {
      this._trigger("add", pEvent, {
        listGroupIdentifier: this.options.listGroupIdentifier
      });
      if ($.isEmptyObject(this.options.formdetailspanelOptions) === false) {
        this.panel.ListPanelEdit("open", pEvent).ListPanelEdit("hideErrorMessages").ListPanelEdit("newValue", this.options.formdetailspanelCreateNewValues).ListPanelEdit("repositionMe", pEvent);
      }
    },
    /**
     * @description Function runs when user want to upload some file
     * @function
     * @private
     * @name nixps-cloudflow.ListGroup#_clickUploadHandler
     * @param {Object} pEvent 
     */
    _clickUploadHandler: function _clickUploadHandler(pEvent) {
      if (this._trigger("beforeupload", pEvent, {
        listGroupIdentifier: this.options.listGroupIdentifier
      }) !== false) {
        this.element.filter(".nixps-FileDropUpload").FileDropUpload("openInputDialog");
      }
    },
    /**
     * @description function runs when user just dropped a file
     * @name nixps-cloudflow.ListGroup#_uploadNewHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _uploadNewHandler: function _uploadNewHandler(pEvent, pData) {
      pEvent.stopPropagation();
      if (pData !== undefined) {
        if (typeof pData.data === "string" && pData.data.length > 0) {
          try {
            pData.data = JSON.parse(pData.data);
          } catch (e) {}
        }
        if ($.isPlainObject(pData.data) && $.isEmptyObject(pData.data) === false) {
          this._trigger("upload", null, {
            rowObjects: [pData.data],
            listGroupIdentifier: this.options.listGroupIdentifier
          });
        } else if (Array.isArray(pData.data)) {
          this._trigger("upload", null, {
            rowObjects: pData.data,
            listGroupIdentifier: this.options.listGroupIdentifier
          });
        } else {
          // fail
          $(".nixps-NotifyArea").NotifyArea("createMessage", "closeable-error", $.i18n._("nixps-cloudflow-listgroup.errordroptitle"), $.i18n._("nixps-cloudflow-listgroup.errordropmessage"), 8000);
        }
      }
    },
    /**
     * @description user select an item
     * @name nixps-cloudflow.ListGroup#_selectHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _selectHandler: function _selectHandler(pEvent, pData) {
      if (pData !== undefined && Array.isArray(pData.rowObjects)) {
        var ids = pData.ids;
        var rowObjects = pData.rowObjects.map(function (elem) {
          return elem.data;
        });
        this._trigger("select", null, {
          ids: ids,
          rowObjects: rowObjects,
          amountSelected: ids.length
        });
      }
    },
    /**
     * @description function runs when dynamic list has been drawned or updated
     * @function
     * @private
     * @name nixps-cloudflow.ListGroup#_drawedHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _drawedHandler: function _drawedHandler(pEvent, pData) {
      pEvent.stopPropagation();
      var data = {
        listGroupIdentifier: this.options.listGroupIdentifier,
        originalEvent: pEvent,
        removedIDs: null,
        removedSelectedIDs: null
      };
      if (pData.removedIDs) {
        data.removedIDs = pData.removedIDs;
      }
      if (pData.removedSelectedIDs) {
        data.removedSelectedIDs = pData.removedSelectedIDs;
      }
      this._trigger("update", pEvent, data);
    },
    /**
     * @description function runs when the lazy scrolling is not needed, because all data is retrieved
     * @function
     * @private
     * @name nixps-cloudflow.ListGroup#_deactivateScrollingHandler
     * @param {Object} pEvent 
     * @returns {undefined}
     */
    _deactivateScrollingHandler: function _deactivateScrollingHandler(pEvent) {
      pEvent.stopPropagation();
      // we can search locally
      if (this.options.lazyScrollLoading === true) {
        this.search = this._search;
      }
    },
    /**
     * @description function runs when the lazy scrolling is re-activated
     * @function
     * @private
     * @name nixps-cloudflow.ListGroup#_activateScrollingHandler
     * @param {Object} pEvent 
     * @returns {undefined}
     */
    _activateScrollingHandler: function _activateScrollingHandler(pEvent) {
      pEvent.stopPropagation();
      // we can search by api call
      if (this.options.lazyScrollLoading === true) {
        this.search = this._searchWithLazyLoading;
      }
    },
    _dataProvider: function _dataProvider(pQuery, pOrderBy, pSkip, pLimit) {
      if (typeof this.options.children === "function") {
        return this.options.children(pQuery, pOrderBy, pSkip, pLimit);
      } else {
        return this.options.children;
      }
    },
    _dataSearchProvider: function _dataSearchProvider(pQuery, pOrderBy, pSkip, pLimit) {
      if (typeof this.options.children === "function") {
        return this.options.children([this.options.searchKey, "contains text like", this.searchString], pOrderBy, pSkip, pLimit);
      }
    },
    _makeItem: function _makeItem(pObject, pParent) {
      var itemContainer = $("<div>").addClass("cf-settingslist-groupitem");
      if (typeof pObject.classes === "string") {
        itemContainer.addClass(pObject.classes);
      }
      pParent.append(itemContainer);

      // text
      var textDOM = $("<div>").addClass("cf-settingslist-groupitem-title");
      var title_span = $("<span>").addClass("cf-settingslist-groupitem-title-text");
      if (typeof pObject.label === "string") {
        title_span.text(pObject.label);
        textDOM.append(title_span);
      } else if (typeof pObject.label === "function") {
        var labelDOM = pObject.label(pObject, textDOM, itemContainer, false);
        if (labelDOM !== undefined && labelDOM.length > 0) {
          textDOM.append(labelDOM);
        }
      }
      var plainText = textDOM.text(); // without badgenumber

      // badge
      var badge_span = null;
      if (typeof pObject.badge_number === "number" && pObject.badge_number > 0) {
        itemContainer.addClass("cf-hasbadges");
        badge_span = $("<span>").addClass("cf-badgenumber").text(pObject.badge_number);
        textDOM.append(badge_span);
      } else if ($.isPlainObject(pObject.badge_number) && typeof pObject.badge_number.count === "number" && pObject.badge_number.count > 0) {
        itemContainer.addClass("cf-hasbadges");
        badge_span = $("<span>").addClass("cf-badgenumber").text(pObject.badge_number.count);
        if (pObject.badge_number.severity === "error") {
          badge_span.addClass("cf-badgenumber-error");
        } else if (pObject.badge_number.severity === "warning") {
          badge_span.addClass("cf-badgenumber-warning");
        }
        textDOM.append(badge_span);
      }
      itemContainer.append(textDOM);
      if (typeof pObject.tooltip === "string" && pObject.tooltip.length > 0) {
        textDOM.attr("title", pObject.tooltip);
      } else if (badge_span === null) {
        if (textDOM.length > 0 && textDOM[0].scrollWidth > textDOM.width()) {
          textDOM.attr("title", plainText);
        }
      } else {
        // in case of badges, the css is different, so look to the title-text instate
        var textToCheck = textDOM.find(".cf-settingslist-groupitem-title-text");
        // width can be not clear and in decimals, so move the best integer and then compare
        if (textToCheck.length > 0 && Math.round(textToCheck[0].scrollWidth) > Math.round(textToCheck.width())) {
          textDOM.attr("title", plainText);
        }
      }
      var settingsBttnDOM;
      if (this.options.enableDropdownMenu === true) {
        settingsBttnDOM = $("<button>").attr("type", "button").addClass("cf-settingslist-groupitem-settings cf-iconbutton cf-icon-lg " + this.options.settingsIcon);
        itemContainer.addClass("cf-settingslist-groupitem-hassettings").append(settingsBttnDOM);
      }
      if (pObject.disabled == true) {
        itemContainer.addClass(this.options.childrenOptions.disabledClasses);
      }
      if (this.options.enableDropdownMenu === true && typeof this.options.textTooltipMenu === "string" && this.options.textTooltipMenu.length > 0) {
        settingsBttnDOM.attr("title", this.options.textTooltipMenu).addClass("listgroup_tooltip");
      }
      if (this.disabledManageFunction === true) {
        settingsBttnDOM.hide();
      }
      return;
    },
    _updateItem: function _updateItem(pHTMLElem, pObject, pOldObject) {
      if (pHTMLElem.length === 0) {
        console.warn("parent is empty, does the list has a correct key name for _id?");
        return;
      }
      var itemContainer = pHTMLElem.first();
      if (typeof pOldObject.classes === "string") {
        itemContainer.removeClass(pOldObject.classes);
      }
      if (typeof pObject.classes === "string") {
        itemContainer.addClass(pObject.classes);
      }

      // text
      var textDOM;
      var plainText;
      if (typeof pObject.label === "string") {
        textDOM = itemContainer.children(".cf-settingslist-groupitem-title").find(".cf-settingslist-groupitem-title-text").text(pObject.label);
        plainText = pObject.label;
      } else if (typeof pObject.label === "function") {
        textDOM = itemContainer.children(".cf-settingslist-groupitem-title").empty();
        var labelDOM = pObject.label(pObject, textDOM, itemContainer, true);
        if (labelDOM !== undefined && labelDOM.length > 0) {
          textDOM.append(labelDOM);
        }
        plainText = textDOM.text();
      } else {
        textDOM = itemContainer.children(".cf-settingslist-groupitem-title").find(".cf-settingslist-groupitem-title-text").empty();
        plainText = "";
      }
      if (typeof pObject.tooltip === "string" && pObject.tooltip.length > 0) {
        textDOM.attr("title", pObject.tooltip);
      } else if (textDOM.length > 0 && textDOM[0].scrollWidth > textDOM.width()) {
        textDOM.attr("title", plainText);
      } else {
        textDOM.removeAttr("title");
      }
      if (pObject.disabled !== itemContainer.hasClass(this.options.childrenOptions.disabledClasses)) {
        // difference detected
        if (pObject.disabled === true) {
          itemContainer.addClass(this.options.childrenOptions.disabledClasses);
        } else {
          itemContainer.removeClass(this.options.childrenOptions.disabledClasses);
        }
      }
      // badge number
      if (typeof pObject.badge_number === "number" && pObject.badge_number !== 0) {
        if (itemContainer.find(".cf-badgenumber").length === 1) {
          itemContainer.find(".cf-badgenumber").removeClass("cf-badgenumber-warning cf-badgenumber-error").text(pObject.badge_number);
        } else {
          var badge_span = $("<span>").addClass("cf-badgenumber").text(pObject.badge_number);
          itemContainer.addClass("cf-hasbadges");
          itemContainer.find(".cf-settingslist-groupitem-title").append(badge_span);
        }
      } else if (pObject.badge_number && typeof pObject.badge_number.count === "number" && pObject.badge_number.count > 0) {
        var className = "";
        if (pObject.badge_number.severity === "error") {
          className = "cf-badgenumber-error";
        } else if (pObject.badge_number.severity === "warning") {
          className = "cf-badgenumber-warning";
        }
        if (itemContainer.find(".cf-badgenumber").length === 1) {
          itemContainer.find(".cf-badgenumber").removeClass("cf-badgenumber-warning cf-badgenumber-error").addClass(className).text(pObject.badge_number.count);
        } else {
          var badge_span = $("<span>").addClass("cf-badgenumber").addClass(className).text(pObject.badge_number.count);
          itemContainer.addClass("cf-hasbadges");
          itemContainer.find(".cf-settingslist-groupitem-title").append(badge_span);
        }
      } else {
        itemContainer.find(".cf-badgenumber").remove();
        itemContainer.removeClass("cf-hasbadges cf-badgenumber-warning cf-badgenumber-error");
      }
    },
    _hasDropMenu: function _hasDropMenu(pObject) {
      return pObject.edit === true || pObject.duplicate === true || pObject["delete"] === true || pObject.dropdownListItems + this.options.dropdownListItems.length > 0;
    },
    _getTriggerRowData: function _getTriggerRowData(pObject, pClickEvent, pChooseEvent) {
      var triggerData = {
        originalEvent: pClickEvent,
        chooseEvent: pChooseEvent,
        displayData: pObject,
        keyUniqID: this.options.childrenOptions.keyUniqID,
        isSelected: false
      };
      if (pObject.data !== undefined) {
        triggerData.rowObject = pObject.data;
        triggerData.id = CloudflowObject.getParameter(pObject.data, this.options.childrenOptions.keyUniqID);
        triggerData.rowObjects = [pObject.data];
        triggerData.ids = [triggerData.id];
      }
      var selectedItems = this.element.children(".lg_children").DynamicList("getSelectedItems");
      if (Array.isArray(selectedItems) && selectedItems.length > 0) {
        for (var i = 0; i < selectedItems.length; i++) {
          if (triggerData.id === CloudflowObject.getParameter(selectedItems[i], this.options.childrenOptions.keyUniqID)) {
            triggerData.isSelected = true;
            break;
          }
        }
      }
      return triggerData;
    },
    _hasItemChanged: function _hasItemChanged(A, B) {
      return "" + A.label + A.tooltip + A.disabled + A.edit + A.duplicate + A["delete"] + A.modification + JSON.stringify(A.badge_number) !== "" + B.label + B.tooltip + B.disabled + B.edit + B.duplicate + B["delete"] + B.modification + JSON.stringify(B.badge_number);
    },
    search: function search() {},
    /**
     * @description Search and highight a specific string
     * @function
     * @name nixps-cloudflow.ListGroup#search
     * @param {String} searchValue the word to search and highlight
     * @returns {undefined}
     */
    _search: function _search(pSearchValue) {
      this.element.children(".lg_children").children(".list_item").nixpsSearchHighlight(pSearchValue);
    },
    _searchWithLazyLoading: function _searchWithLazyLoading(pSearchValue) {
      if (typeof pSearchValue !== "string") {
        throw new Error("searchValue must be a string");
      }
      var that = this;
      if (pSearchValue.length === 0) {
        // user want to stop searching, input is empty  
        this.element.children(".lg_searchchildren").hide().children(".list_item").nixpsClearSearchHighlight();
        var selectedItems = this.element.children(".lg_searchchildren").DynamicList("getSelectedItems");
        var ids = selectedItems.map(function (s) {
          return CloudflowObject.getParameter(s, that.options.childrenOptions.keyUniqID);
        });
        this.element.children(".lg_children").css("display", "").DynamicList("unselectAll");
        if (Array.isArray(ids) && ids.length > 0) {
          for (var i = 0; i < ids.length; i++) {
            this.element.children(".lg_children").DynamicList("select", ids[i], false);
          }
        }
      } else {
        // user is searching something specific
        this.searchString = pSearchValue;
        var ids = null;
        if (this.element.children(".lg_children").is(":visible")) {
          this.element.children(".lg_children").hide();
          var selectedItems = this.element.children(".lg_children").DynamicList("getSelectedItems");
          ids = selectedItems.map(function (s) {
            return CloudflowObject.getParameter(s, that.options.childrenOptions.keyUniqID);
          });
        }
        this.element.children(".lg_searchchildren").css("display", "").one("dynamiclistdrawed", function () {
          $(this).children(".list_item").nixpsSearchHighlight(pSearchValue);
          if (Array.isArray(ids) && ids.length > 0) {
            for (var i = 0; i < ids.length; i++) {
              $(this).DynamicList("select", ids[i], false);
            }
          }
        });
        // init
        if (this.element.children(".lg_searchchildren").css("display", "").hasClass("nixps-DynamicList") === false) {
          this.element.children(".lg_searchchildren").DynamicList({
            dataProvider: this._dataSearchProvider.bind(this),
            makeItem: this._makeItem.bind(this),
            updateItem: this._updateItem.bind(this),
            hasItemChanged: this._hasItemChanged.bind(this),
            keyUniqID: this.options.childrenOptions.keyUniqID,
            updateDelay: this.options.updateDelay,
            allowToUpdate: function allowToUpdate(pElem) {
              return pElem.is(":visible") && Device.continuePolling(this.uuid);
            },
            editNameSelector: null,
            nameChange: function nameChange() {},
            enableSortable: false,
            enableSelecting: this.options.selectingOptions !== null,
            selectingOptions: this.options.selectingOptions,
            sortFunction: this.options.sortFunction,
            ascending: this.options.ascending,
            emptyRowsPanel: $("<span>").text(this.options.textNoItemsToDisplay),
            lazyLoading: this.options.lazyScrollLoading,
            scrollElement: this.element.parent()
          });
        } else {
          var selectedItems = this.element.children(".lg_searchchildren").DynamicList("getSelectedItems");
          ids = selectedItems.map(function (s) {
            return CloudflowObject.getParameter(s, that.options.childrenOptions.keyUniqID);
          });
          this.element.children(".lg_searchchildren").DynamicList("redraw");
        }
      }
    },
    /**
     * @description select a specific item
     * @function
     * @name nixps-cloudflow.ListGroup#select
     * @param {String} pID the id of the item to select
     * @param {Boolean} pTrigger true if we fire the select event
     */
    select: function select(pID, pTrigger) {
      this.element.children(".lg_children").DynamicList("select", pID, pTrigger);
    },
    /**
     * @description select the first item item
     * @function
     * @name nixps-cloudflow.ListGroup#selectFirst
     * @param {Boolean} pTrigger 
     */
    selectFirst: function selectFirst(pTrigger) {
      //what if dynamic list has no data-id?
      var item = this.element.children(".lg_children").children(".list_item[data-id]").first();
      if (item.length === 1) {
        var id = item.attr("data-id");
        if (typeof id === "string" && id.length > 0) {
          this.select(id, pTrigger);
        }
      }
    },
    /**
     * @description Select all items
     * @function
     * @name nixps-cloudflow.ListGroup#selectAll
     * @returns {undefined}
     */
    selectAll: function selectAll() {
      this.element.children(".lg_children").DynamicList("selectAll");
    },
    /**
     * @description Unselect all items
     * @function
     * @name nixps-cloudflow.ListGroup#unselectAll
     * @returns {undefined}
     */
    unselectAll: function unselectAll() {
      this.element.children(".lg_children").DynamicList("unselectAll");
    },
    /**
     * @description Get all the objects of all selected items
     * @function
     * @name nixps-cloudflow.ListGroup#getSelectedItems
     * @returns {Array.<Object>}
     */
    getSelectedItems: function getSelectedItems() {
      return this.element.children(".lg_children").DynamicList("getSelectedItems");
    },
    /**
     * @description Get all the objects of all items
     * @function
     * @name nixps-cloudflow.ListGroup#getValue
     * @returns {Array.<Object>}
     */
    getValue: function getValue() {
      return this.element.children(".lg_children").DynamicList("getValue");
    },
    /**
     * @description ask to update the list
     * @function
     * @name nixps-cloudflow.ListGroup#update
     * @returns Deferred
     */
    update: function update() {
      return this.element.children(".lg_children").DynamicList("update");
    },
    /**
     * @description remove multiple items and select a nabour if needed
     * @function
     * @name nixps-cloudflow.ListGroup#removeByIDs
     * @param {Array<String>} pIDs 
     * @returns {undefined}
     */
    removeByIDs: function removeByIDs(pIDs) {
      var dynamicListDOM = this.element.children(".lg_children");
      for (var i = 0; i < pIDs.length; i++) {
        if (typeof pIDs[i] === "string" || typeof pIDs[i] === "number") {
          dynamicListDOM.DynamicList("removeItem", pIDs[i], "previous");
        }
      }
    },
    /**
     * @description Update the DOM item given the new json, the link will be made with the unique key
     * @function
     * @name nixps-cloudflow.ListGroup#updateItem
     * @param {Object} pNewData 
     * @returns {undefined}
     */
    updateItem: function updateItem(pNewData, pOptions) {
      var id = CloudflowObject.getParameter(pNewData, this.options.childrenOptions.keyUniqID);
      return this.element.children(".lg_children").DynamicList("updateDOMItem", id, pNewData, pOptions);
    },
    /**
     * @description Disable all buttons that manage the list
     * @function
     * @name nixps-cloudflow.ListGroup#disableManageFunctionality
     * @returns {undefined}
     */
    disableManageFunctionality: function disableManageFunctionality() {
      this.disabledManageFunction = true;
      this.element.children(".lg_title").find(".lg_title_upload, .lg_title_add").hide();
      this.element.find(".cf-settingslist-groupitem-settings").hide();
    },
    /**
     * @description Re-enable all buttons that manage the list
     * @function
     * @name nixps-cloudflow.ListGroup#enableManageFunctionality
     * @returns {undefined}
     */
    enableManageFunctionality: function enableManageFunctionality() {
      this.disabledManageFunction = false;
      this.element.children(".lg_title").find(".lg_title_upload, .lg_title_add").css("display", "");
      this.element.find(".cf-settingslist-groupitem-settings").css("display", "");
    },
    disableFileDrop: function disableFileDrop() {
      this.element.filter(".nixps-FileDropUpload").FileDropUpload("option", "disabled", true);
    },
    enableFileDrop: function enableFileDrop() {
      this.element.filter(".nixps-FileDropUpload").FileDropUpload("option", "disabled", false);
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ListGroup#_setOptions
     */
    _setOptions: function _setOptions(options) {
      var that = this;
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      this._controlOptions();
      if (options.selectingOptions !== undefined || options.sortFunction !== undefined || options.ascending !== undefined || options.lazyScrollLoading !== undefined) {
        this.element.children(".lg_children").DynamicList("option", {
          enableSelecting: this.options.selectingOptions !== null,
          selectingOptions: this.options.selectingOptions,
          sortFunction: this.options.sortFunction,
          ascending: this.options.ascending,
          lazyLoading: this.options.lazyScrollLoading
        });
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "style_type") {
        if (pValue !== this.options.style_type) {
          this.element.removeClass("CloudflowStyle_" + this.options.style_type).addClass("CloudflowStyle_" + pValue);
        }
      }
      this._superApply(arguments);
      if (pKey === "title") {
        this.element.children(".lg_title").children(".lg_title_text").text(pValue);
      } else if (pKey === "children") {
        this.element.children(".lg_children").DynamicList("update");
      } else if (pKey === "lazyScrollLoading") {
        if (this.options.lazyScrollLoading === true) {
          this.element.children(".lg_searchchildren").DynamicList({
            dataProvider: this._dataSearchProvider.bind(this),
            makeItem: this._makeItem.bind(this),
            updateItem: this._updateItem.bind(this),
            hasItemChanged: this._hasItemChanged.bind(this),
            keyUniqID: this.options.childrenOptions.keyUniqID,
            updateDelay: this.options.updateDelay,
            allowToUpdate: function allowToUpdate(pElem) {
              return pElem.is(":visible");
            },
            editNameSelector: null,
            nameChange: function nameChange() {},
            enableSortable: false,
            enableSelecting: this.options.selectingOptions !== null,
            selectingOptions: this.options.selectingOptions,
            sortFunction: this.options.sortFunction,
            ascending: this.options.ascending,
            emptyRowsPanel: $("<span>").text(this.options.textNoItemsToDisplay),
            lazyLoading: this.options.lazyScrollLoading,
            scrollElement: this.element.parent()
          });
          this.search = this._searchWithLazyLoading;
        } else if (this.options.lazyScrollLoading === false) {
          this.element.children(".lg_searchchildren").DynamicList("destroy").hide();
          this.search = this._search;
        }
      } else if (pKey === "enableUploadButton") {
        var uploadButtonDOM = this.element.children(".lg_title").find(".lg_title_upload");
        if (pValue === false) {
          uploadButtonDOM.hide();
        } else if (pValue === true) {
          if (uploadButtonDOM.length === 1) {
            uploadButtonDOM.css("display", ""); // re show
          } else {
            // create and add
            var uploadIconBttnDOM = $("<button>").attr("type", "button").addClass("lg_title_upload cf-iconbutton cf-icon cf-icon-lg cf-icon-upload listgroup_tooltip").attr("title", this.options.textTooltipUpload);
            this.element.children(".lg_title").find(".lg_title_text").after(uploadIconBttnDOM);
          }
        }
      } else if (pKey === "enableAddButton") {
        var addIconButtonDOM = this.element.children(".lg_title").find(".lg_title_add");
        if (pValue === false) {
          addIconButtonDOM.hide();
        } else if (pValue === true) {
          if (addIconButtonDOM.length === 1) {
            addIconButtonDOM.css("display", ""); // re show
          } else {
            // create and add
            var addIconBttnDOM = $("<button>").attr("type", "button").addClass("lg_title_add cf-iconbutton cf-icon cf-icon-lg cf-icon-plus-circle listgroup_tooltip").attr("title", this.options.textTooltipAdd);
            addIconBttnDOM.attr("data-button-id", this.options.addButtonId);
            // add as last item
            this.element.children(".lg_title").append(addIconBttnDOM);
          }
        }
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.ListGroup#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("input option language must be a not empty string");
      }
      if (typeof this.options.emptyMenuButtonClasses !== "string") {
        throw new Error("input option emptyMenuButtonClasses must be a string");
      }
      if (typeof this.options.settingsIcon !== "string") {
        throw new Error("input option settingsIcon must be a string");
      }
      if (typeof this.options.relativeBasePath !== "string") {
        throw new Error("input option relativeBasePath must be a string");
      }
      if (Array.isArray(this.options.dropdownListItems) === false) {
        throw new Error("input option dropdownListItems must be an array");
      }
      if (typeof this.options.lazyScrollLoading !== "boolean") {
        throw new Error("input option lazyScrollLoading must be a boolean");
      }
      if (typeof this.options.searchKey !== "string") {
        throw new Error("input option searchKey must be a string");
      }
    },
    _destroy: function _destroy() {
      this._super();
      this.element.filter(".nixps-FileDropUpload").FileDropUpload("destroy");
      this.element.removeClass(this.widgetFullName).removeClass("CloudflowStyle_" + this.options.style_type).removeAttr("data-uuid");
      if (this.panel !== undefined && this.panel !== null) {
        this.panel.remove();
      }
    }
  });
})(jQuery);

},{"../../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79,"../../../common/ActionMenu/js/nixps-ActionMenu.js":275,"../../../common/DropdownList/js/nixps-DropdownList.js":288,"../../../common/DynamicList/js/nixps-DynamicList.js":290,"../../../common/FileDropUpload/js/nixps-FileDropUpload.js":291,"../../../common/NotifyArea/js/nixps-NotifyArea.js":299,"../../../common/SearchHighlight/js/nixpsSearchHighlight.js":317,"../../../common/js/myjQueryPlugins.js":388,"../../PWA/js/Device.js":198,"./nixps-cloudflow-ListPanelEdit.js":179}],178:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 19 mrt 2021
 */
(function ($) {
  require("./nixps-cloudflow-ListGroup.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  var kNoTagValue = "Any";

  /**
   * @namespace nixps-cloudflow.ListPanel
   * @description Draw a panel to show a group of ListGroups components. Pass the options through and also pass the events throughs
   * fires next events
   * <dl>
   *  <dt> select      </dt><dd> when an item is selected in a group </dd>
   *  <dt> change      </dt><dd> when a change is detected in the data </dd>
   *  <dt> add         </dt><dd> when user want to add, and clicked in + icon</dd>
   *  <dt> creatingnew </dt><dd> when user want to save the data and clicked on the save button</dd>
   *  <dt> edit        </dt><dd></dd>
   *  <dt> editing     </dt><dd></dd>
   *  <dt> duplicated  </dt><dd></dd>
   *  <dt> delete      </dt><dd></dd>
   *  <dt> download    </dt><dd></dd>
   *  <dt> upload      </dt><dd></dd>
   *  <dt> dropdownitemclick<action>      </dt><dd> when user clicked on the custom label </dd>
   * </dl> 
   * @example $("<div>").ListPanel({
    * });
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.ListPanel", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "listpanel",
    options: {
      /**
       * @name nixps-cloudflow.ListPanel#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.ListPanel#mainClasses
       * @description classes split be spaces to be added to the component
       * @type {String}
       * @default "cf-settingslist"
       * @private
       */
      mainClasses: "cf-settingslist",
      /**
       * @name nixps-cloudflow.ListPanel#relativeBasePath
       * @description The path to be used if the url is relative
       * @type {String}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.ListPanel#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       * @default "default
       */
      style_type: "default",
      /**
       * @description the options content to visualise
       * @type {Array<Object>}
       * @name nixps-cloudflow.ListPanel#lists
       * @default []
       */
      lists: [],
      /**
       * @description Must we enable the search input panel or not?
       * @type {Boolean}
       * @name nixps-cloudflow.ListPanel#enableSearch
       * @default true
       */
      enableSearch: true,
      /**
       * @name nixps-cloudflow.ListPanel#searchTags
       * @description The search fast tags for dedicated specialised searching
       * @type {Array.<String>}
       * @default undefined
       */
      searchTags: undefined,
      /**
       * @description How must we select the first item after creation? 
       * we can use "none", to select nothing, "first" to select the first item or "byID" to select by _id
       * @type {String}
       * @default "none"
       * @name nixps-cloudflow.ListPanel#selectOnCreationMethod
       */
      selectOnCreationMethod: "none",
      /**
       * @description Define an array of ids to be selected on the first time, 
       * it only applies when the option selectOnCreationMethod is set to "byID"
       * @type {Array<String>}
       * @default undefined
       * @name nixps-cloudflow.ListPanel#selectOnCreationIDs
       */
      selectOnCreationIDs: undefined,
      /**
       * @description Define an array of labels to be selected on the first time, 
       * it only applies when the option selectOnCreationMethod is set to "byLabel"
       * @type {Array<String>}
       * @default undefined
       * @name nixps-cloudflow.ListPanel#selectOnCreationLabels
       */
      selectOnCreationLabels: undefined,
      /**
       * @description Trigger a select event when we select on creation
       * @type {Boolean}
       * @default true
       * @name nixps-cloudflow.ListPanel#triggerEventOnSelectOnCreation
       */
      triggerEventOnSelectOnCreation: true,
      /**
       * @description The default classes to given to the menu button when there is no menu items
       * @name nixps-cloudflow.ListPanel#emptyMenuButtonClasses
       * @type {String}
       * @default "cf-diabled"
       */
      emptyMenuButtonClasses: "cf-diabled",
      /**
       * @name nixps-cloudflow.ListPanel#created
       * @description function run when component is done being created
       * @function
       * @private
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.ListPanel#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass(this.options.mainClasses).addClass("CloudflowStyle_" + this.options.style_type);

      // variables
      this.alive = true;
      this.creating = true;
      this.creatingCountDown = this.options.lists.length;

      // skeleton
      this.element.empty();
      var searchLabelBy = null;
      if (Array.isArray(this.options.lists) && this.options.lists.length > 0) {
        searchLabelBy = $.i18n._("nixps-cloudflow-table.searchby", [this.options.lists.map(function (l) {
          return l.title || "";
        }).join(",")]);
      }
      var searchDOM = $("<div>").addClass("lp_searchpanel " + (this.options.searchTags !== undefined ? "cf-listpanel-smallwidth-searchtags" : "")).attr("role", "search")
      //   .append($("<span>").addClass("cf-icon lp_collapsebutton").css("width", 11))
      .append($("<span>").addClass("cf-icon cf-icon-search")).append($("<input>").attr({
        "type": "text",
        "inputmode": "search",
        "aria-label": searchLabelBy
      }).addClass("cf-settingslist-search")).append($("<span>").addClass("cf-icon cf-icon-close listpanel-clearsearch"));
      var searchTags = $("<span>").addClass("cf-listpanel-searchtags").append($("<span>").addClass("cf-listpanel-searchtags-icon"));
      if (this.options.searchTags !== undefined) {
        var keyValuesToDisplay = {};
        for (var key in this.options.searchTags) {
          keyValuesToDisplay[key] = this.options.searchTags[key].label;
        }
        searchTags.append($("<div>").Select({
          keyValues: keyValuesToDisplay
        }));
        searchDOM.append(searchTags);
      }
      this.element.append(searchDOM);
      this.element.append($("<div>").addClass("lp_listgroups"));
      this._draw();
      this.searchHandler = _.debounce(this._searchHandler, 800);
      this._on(this.element, {
        "input .lp_searchpanel": this.searchHandler,
        "click .listpanel-clearsearch": this._handleClearSearch,
        "click .lp_collapsebutton": this._collapseClickHandler,
        "listgroupadd": this._addHandler,
        "listgroupbeforeupload": this._beforeUploadHandler,
        "listgroupedit": this._editHandler,
        "listgroupduplicate": this._duplicateHandler,
        "listgroupdelete": this._deleteHandler,
        "listgroupdownload": this._downloadHandler,
        "listgroupupload": this._uploadHandler,
        "listgroupdropdownitemclick": this._customDropdownListItemClickHandler,
        "listgroupselect": this._selectHandler,
        "listgroupupdate": this._changeHandler,
        "listgroupcreatingnew": this._creatingNewHandler,
        "listgroupediting": this._editingHandler,
        "wheel": this._wheelHandler,
        "change .cf-listpanel-searchtags": this._changeSearchTagHandler
      });
    },
    _getSearchString: function _getSearchString(pEvent) {
      var searchValue = this.element.find(".cf-settingslist-search").val();
      if (this.options.searchTags !== undefined) {
        var searchTagValue = this.element.find(".cf-listpanel-searchtags").find(".nixps-cloudflow-Select").Select("getValue");
        if (searchTagValue !== kNoTagValue) {
          searchValue = searchTagValue + searchValue;
        }
        this._upgradeSearchTagSelector(searchValue, false);
      }
      return searchValue;
    },
    _changeSearchTagHandler: function _changeSearchTagHandler() {
      var searchTagValue = this.element.find(".cf-listpanel-searchtags").find(".nixps-cloudflow-Select").Select("getValue");
      if (searchTagValue === kNoTagValue) {
        this.element.find(".cf-listpanel-searchtags-icon").removeAllClasses().addClass("cf-listpanel-searchtags-icon");
        this.element.find(".lp_searchpanel").removeClass("cf-listpanel-fullwidth-searchtags").addClass("cf-listpanel-smallwidth-searchtags");
      } else {
        this.element.find(".cf-listpanel-searchtags-icon").removeAllClasses().addClass("cf-listpanel-searchtags-icon").addClass(this.options.searchTags[searchTagValue].icon);
        this.element.find(".lp_searchpanel").removeClass("cf-listpanel-smallwidth-searchtags").addClass("cf-listpanel-fullwidth-searchtags");
      }
    },
    setSearchTag: function setSearchTag(pSearchTag) {
      this.element.find(".cf-listpanel-searchtags").find(".nixps-cloudflow-Select").Select("setValue", pSearchTag);
    },
    /**
     * @description function runs when user is searching for a specific item
     * @name nixps-cloudflow.ListPanel#_searchHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _searchHandler: function _searchHandler(pEvent, pData) {
      var searchString = this._getSearchString();
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").ListGroup("search", searchString);
    },
    /**
     * @description function runs when user clicks on the clear search button
     * @name nixps-cloudflow.ListPanel#_handleClearSearch
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _handleClearSearch: function _handleClearSearch(pEvent, pData) {
      this.element.find("input.cf-settingslist-search").val("");
      if (this.options.searchTags !== undefined) {
        // update selector
        this.element.find(".cf-listpanel-searchtags").find(".nixps-cloudflow-Select").Select("setValue", kNoTagValue);
        // update icon
        this.element.find(".cf-listpanel-searchtags-icon").removeAllClasses().addClass("cf-listpanel-searchtags-icon");
        // the input is updated outsode this function
        // full of small window
        this.element.children(".lp_searchpanel").removeClass("cf-listpanel-fullwidth-searchtags").addClass("cf-listpanel-smallwidth-searchtags");
      }
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").ListGroup("search", "");
    },
    /**
     * @description function runs when user whant to (de)collapse the panel
     * @function
     * @private
     * @name nixps-cloudflow.ListPanel#_collapseClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _collapseClickHandler: function _collapseClickHandler(pEvent, pData) {
      this.element.toggleClass("cf-settingslist-collapsed");
    },
    /**
     * @description function runs when user want to add 
     * @function
     * @name nixps-cloudflow.ListPanel#_addHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _addHandler: function _addHandler(pEvent, pData) {
      pEvent.stopPropagation();
      this._trigger("add", pEvent, pData);
    },
    /**
     * @description function runs when user want to upload a file
     * @function
     * @name nixps-cloudflow.ListPanel#_beforeUploadHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _beforeUploadHandler: function _beforeUploadHandler(pEvent, pData) {
      pEvent.stopPropagation();
      this._trigger("beforeupload", pEvent, pData);
    },
    /**
     * @description function runs when user want to edit 
     * @function
     * @name nixps-cloudflow.ListPanel#_editHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _editHandler: function _editHandler(pEvent, pData) {
      pEvent.stopPropagation();
      this._trigger("edit", null, pData);
    },
    /**
     * @description function runs when user want to edit 
     * @function
     * @name nixps-cloudflow.ListPanel#_duplicateHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _duplicateHandler: function _duplicateHandler(pEvent, pData) {
      pEvent.stopPropagation();
      this._trigger("duplicate", null, pData);
    },
    /**
     * @description function runs when user want to delete 
     * @function
     * @name nixps-cloudflow.ListPanel#_deleteHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _deleteHandler: function _deleteHandler(pEvent, pData) {
      pEvent.stopPropagation();
      this._trigger("delete", null, pData);
    },
    /**
     * @description function runs when user want to download an item
     * @function
     * @name nixps-cloudflow.ListPanel#_downloadHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _downloadHandler: function _downloadHandler(pEvent, pData) {
      // do not stop events for downloading
      this._trigger("download", null, pData);
    },
    /**
     * @description function runs when user want to upload an item
     * @function
     * @name nixps-cloudflow.ListPanel#_uploadHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _uploadHandler: function _uploadHandler(pEvent, pData) {
      pEvent.stopPropagation();
      this._trigger("upload", null, pData);
    },
    /**
     * @description function runs when user clicked on a custom self added dropdownlist item
     * @function
     * @name nixps-cloudflow.ListPanel#_customDropdownListItemClickHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _customDropdownListItemClickHandler: function _customDropdownListItemClickHandler(pEvent, pData) {
      if (typeof pData.action === "string" && pData.action.length > 0) {
        this._trigger("dropdownitemclick" + pData.action, pEvent, pData);
      }
    },
    _creatingNewHandler: function _creatingNewHandler(pEvent, pData, pCallbackFc) {
      pEvent.stopPropagation();
      this._trigger("creatingnew", null, [pData, pCallbackFc]);
    },
    _editingHandler: function _editingHandler(pEvent, pData) {
      pEvent.stopPropagation();
      this._trigger("editing", null, pData);
    },
    _wheelHandler: function _wheelHandler() {
      this.hideActionMenu();
    },
    /**
     * @description function runs when user select a specific item
     * @name nixps-cloudflow.ListPanel#_selectHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _selectHandler: function _selectHandler(pEvent, pData) {
      // deselect all other list groups
      var currentlistgroup = $(pEvent.target).closest(".nixps-cloudflow-ListGroup");
      var listgroupID = currentlistgroup.attr("data-uuid");
      if (typeof listgroupID === "string" && listgroupID.length > 0) {
        this.element.children(".lp_listgroups").children('.nixps-cloudflow-ListGroup:not([data-uuid="' + listgroupID + '"])').ListGroup("unselectAll");
      }
      if (pData !== undefined) {
        this._trigger("select", pEvent, pData);
      }
    },
    _changeHandler: function _changeHandler(pEvent, pData) {
      pEvent.stopPropagation();
      this._trigger("change", null, pData);
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.ListPanel#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.children(".lp_searchpanel").toggle(this.options.enableSearch);
      this.element.children(".lp_listgroups").empty();
      for (var l = 0; l < this.options.lists.length; l++) {
        var listgroup = $("<div>").addClass("lp_listgroup");
        this.element.children(".lp_listgroups").append(listgroup);
        var listGroupOption = this.options.lists[l];
        listGroupOption.language = this.options.language;
        listGroupOption.relativeBasePath = this.options.relativeBasePath;
        listGroupOption.style_type = this.options.style_type;
        listGroupOption.dropdownPosition = this.options.dropdownPosition;
        if (typeof listGroupOption.emptyMenuButtonClasses !== "string" || listGroupOption.emptyMenuButtonClasses.length <= 0) {
          listGroupOption.emptyMenuButtonClasses = this.options.emptyMenuButtonClasses;
        }
        listGroupOption.created = this._creatingCB.bind(this);
        listgroup.ListGroup(listGroupOption);
      }
    },
    _upgradeSearchTagSelector: function _upgradeSearchTagSelector(pSearchString, pAllowDowngrade) {
      if (this.options.searchTags === undefined) {
        return;
      }
      var found = false;
      for (var tag in this.options.searchTags) {
        if (tag !== kNoTagValue && pSearchString.indexOf(tag) === 0) {
          // if this is the tags
          // update selector
          this.element.find(".cf-listpanel-searchtags").find(".nixps-cloudflow-Select").Select("setValue", tag);
          // update icon
          this.element.find(".cf-listpanel-searchtags-icon").removeAllClasses().addClass("cf-listpanel-searchtags-icon").addClass(this.options.searchTags[tag].icon);
          // update clippled search text
          this.element.find(".cf-settingslist-search").val(pSearchString.substring(tag.length));
          // update full of small window
          this.element.children(".lp_searchpanel").removeClass("cf-listpanel-smallwidth-searchtags").addClass("cf-listpanel-fullwidth-searchtags");
          found = true;
          break;
        }
      }
      if (pAllowDowngrade === true && found === false) {
        // update selector
        this.element.find(".cf-listpanel-searchtags").find(".nixps-cloudflow-Select").Select("setValue", kNoTagValue);
        // update icon
        this.element.find(".cf-listpanel-searchtags-icon").removeAllClasses().addClass("cf-listpanel-searchtags-icon");
        // the input is updated outsode this function
        // full of small window
        this.element.children(".lp_searchpanel").removeClass("cf-listpanel-fullwidth-searchtags").addClass("cf-listpanel-smallwidth-searchtags");
      }
    },
    /**
     * @description internal function to fire options.creating
     * @function
     * @name nixps-cloudflow.ListPanel#_creatingCB
     * @private
     * @returns {undefined}
     */
    _creatingCB: function _creatingCB() {
      if (this.creating === true) {
        this.creatingCountDown--;
        if (this.creatingCountDown <= 0) {
          this.creating = false;
          var selected = false;
          if (this.options.selectOnCreationMethod === "first") {
            this.selectFirst(this.options.triggerEventOnSelectOnCreation);
            selected = true;
          } else if (this.options.selectOnCreationMethod === "byID") {
            if (Array.isArray(this.options.selectOnCreationIDs) && this.options.selectOnCreationIDs.length > 0) {
              this.select(this.options.selectOnCreationIDs[0], this.options.triggerEventOnSelectOnCreation); // select first !!
              selected = true;
            } else if (typeof this.options.selectOnCreationIDs === "string") {
              var selectArray = [this.options.selectOnCreationIDs];
              this.select(selectArray[0], this.options.triggerEventOnSelectOnCreation);
              selected = true;
            }
          } else if (this.options.selectOnCreationMethod === "byLabel") {
            // select first !!
            if (Array.isArray(this.options.selectOnCreationLabels) && this.options.selectOnCreationLabels.length > 0) {
              var that = this;
              var itemByName = this.getValue().find(function (item) {
                return item !== undefined && that.options.selectOnCreationLabels.includes(item.label);
              });
              if (itemByName === undefined) {
                // item not found
              } else {
                var keyUniqID = "_id";
                if (this.options.lists[0].childrenOptions !== undefined && typeof this.options.lists[0].childrenOptions.keyUniqID === "string") {
                  keyUniqID = this.options.lists[0].childrenOptions.keyUniqID;
                }
                var id = CloudflowObject.getParameter(itemByName, keyUniqID);
                if (id !== undefined) {
                  this.select(id, this.options.triggerEventOnSelectOnCreation);
                  selected = true;
                }
              }
            }
          } else if (this.options.selectOnCreationMethod === "none") {
            selected = true; // use does not want selection, so do not goe to fallback
          } else {
            // unknow option
            console.error("unknown input option selectOnCreationMethod ", this.options.selectOnCreationMethod);
          }
          if (selected === false) {
            // fallback
            this.selectFirst(this.options.triggerEventOnSelectOnCreation);
          }
          this.options.created();
        }
      }
    },
    /**
     * @description Update the list
     * @function
     * @name nixps-cloudflow.ListPanel#update
     * @returns deferred object
     */
    update: function update() {
      var updateDefs = [];
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").each(function () {
        updateDefs.push($(this).ListGroup("update"));
      });
      return $.when.apply($, updateDefs);
    },
    /**
     * @description remove multiple items and select a nabour if needed
     * @function
     * @name nixps-cloudflow.ListPanel#removeByIDs
     * @param {Array<String>} pIDs 
     * @returns {undefined}
     */
    removeByIDs: function removeByIDs(pIDs) {
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").each(function () {
        $(this).ListGroup("removeByIDs", pIDs);
      });
    },
    /**
     * @description Select an item from the list
     * @function
     * @name nixps-cloudflow.ListPanel#select
     * @param {Number} pID the id of the item to select
     * @param {Boolean} pTrigger Must we trigger a change event or not
     */
    select: function select(pID, pTrigger) {
      var matchedItems = this.element.find(".list_item[data-id='" + pID + "']");
      var currentlistgroupDOM = matchedItems.first().closest(".nixps-cloudflow-ListGroup");
      // deselect all other list groups
      var listgroupID = currentlistgroupDOM.attr("data-uuid");
      if (typeof listgroupID === "string" && listgroupID.length > 0) {
        this.element.children(".lp_listgroups").children('.nixps-cloudflow-ListGroup:not([data-uuid="' + listgroupID + '"])').ListGroup("unselectAll");
      }
      currentlistgroupDOM.ListGroup("select", pID, pTrigger);
      // scroll to selection
      if (this.element.find(".cf-select").length > 0) {
        var topSelection = this.element.find(".list_item").first().position().top;
        var topFirstSelection = this.element.find(".cf-select").position().top;
        if (typeof topFirstSelection === "number" && typeof topSelection === "number") {
          var currentScrollTop = this.element.children(".lp_listgroups").scrollTop();
          this.element.children(".lp_listgroups").scrollTop(currentScrollTop + topFirstSelection - topSelection);
        }
      }
    },
    /**
     * @description Select an item from the list
     * @function
     * @name nixps-cloudflow.ListPanel#selectFirst
     * @param {Boolean} pTrigger Must we trigger a change event or not
     */
    selectFirst: function selectFirst(pTrigger) {
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").first().ListGroup("selectFirst", pTrigger);
    },
    /**
     * @description Unselect all items in all lists
     * @function
     * @name nixps-cloudflow.ListPanel#unselectAll
     * @return undefined
     */
    unselectAll: function unselectAll() {
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").ListGroup("unselectAll");
    },
    /**
     * @description Get all the objects of all selected items
     * @function
     * @name nixps-cloudflow.ListPanel#getSelectedItems
     * @returns {Array.<Object>}
     */
    getSelectedItems: function getSelectedItems() {
      var selectedItems = [];
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").each(function () {
        selectedItems = selectedItems.concat($(this).ListGroup("getSelectedItems"));
      });
      return selectedItems;
    },
    disableManageFunctionality: function disableManageFunctionality() {
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").ListGroup("disableManageFunctionality");
    },
    enableManageFunctionality: function enableManageFunctionality() {
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").ListGroup("enableManageFunctionality");
    },
    disableFileDrop: function disableFileDrop(pListIndex) {
      if (pListIndex === undefined) {
        this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").ListGroup("disableFileDrop");
      } else {
        this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").eq(pListIndex).ListGroup("disableFileDrop");
      }
    },
    enableFileDrop: function enableFileDrop(pListIndex) {
      if (pListIndex === undefined) {
        this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").ListGroup("enableFileDrop");
      } else {
        this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").eq(pListIndex).ListGroup("enableFileDrop");
      }
    },
    /**
     * @description get all data of all items
     * @function
     * @private
     * @returns {Array.<Object>} the array containing all the jsons of all items
     */
    getValue: function getValue() {
      var items = [];
      this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").each(function () {
        items = items.concat($(this).ListGroup("getValue"));
      });
      return items;
    },
    /**
     * @description Hide the action menu
     * @function
     * @name nixps-cloudflow.ListPanel#hideActionMenu
     */
    hideActionMenu: function hideActionMenu() {
      $(".nixps-ActionMenu").ActionMenu("hide");
    },
    /**
     * @desprecated use hideActionMenu
     */
    _hideActionMenu: function _hideActionMenu() {
      return this.hideActionMenu();
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ListPanel#_setOptions
     */
    _setOptions: function _setOptions(options) {
      var that = this;
      var redraw = false;
      if (Array.isArray(options.lists)) {
        // only full lists, not subparts of it
        if (options.lists.length !== this.options.lists.length) {
          redraw = true;
        }
      }
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      if (redraw) {
        this._draw();
      } else {
        if (options.language !== undefined || options.relativeBasePath !== undefined || options.style_type !== undefined) {
          this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").ListGroup("option", {
            language: this.options.language,
            relativeBasePath: this.options.relativeBasePath,
            style_type: this.options.style_type
          });
        }
        if (Array.isArray(options.lists)) {
          for (var l = 0; l < this.options.lists.length; l++) {
            this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").eq(l).ListGroup("option", this.options.lists[l]);
          }
        } else if (_typeof(options.lists) === "object" && _typeof(options.lists["0"]) === "object") {
          this.element.children(".lp_listgroups").children(".nixps-cloudflow-ListGroup").eq(0).ListGroup("option", this.options.lists["0"]);
        }
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.ListPanel#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof window._ !== "function") {
        throw new Error("please include the underscore js plugin");
      }
      if (Array.isArray(this.options.lists) === false) {
        throw new Error("input option lists must be an array");
      } else {
        this.options.lists = this.options.lists.slice(); // make copy
      }

      if (typeof this.options.triggerEventOnSelectOnCreation !== "boolean") {
        throw new Error("input options triggerEventOnSelectOnCreation must be a boolean");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.options.mainClasses).removeClass("CloudflowStyle_" + this.options.style_type);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"./nixps-cloudflow-ListGroup.js":177}],179:[function(require,module,exports){
"use strict";

(function ($) {
  require("../../DetailsPanel/js/nixps-cloudflow-FormDetailsPanel.js");

  /**
   * @namespace nixps-cloudflow.ListPanelEdit
   * @description the panel use to add or edit items of the listpanel
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.ListPanelEdit", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "listpaneledit",
    options: {
      /**
       * @name nixps-cloudflow.ListPanelEdit#detailsOptions
       * @description the options to be given to the formdetailsPanel. See {@link nixps.cloudflow.FormDetailsPanel}
       * @type {Object}
       * @default {}
       */
      detailsOptions: {},
      /**
       * @name nixps-cloudflow.ListPanelEdit#parentPositioning
       * @description The css to find the parent to possition to
       * @type {String}
       * @default ".cf-settingslist"
       */
      parentPositioning: ".cf-settingslist",
      /**
       * @name nixps-cloudflow.ListPanelEdit#settingsButtonSelector
       * @description The css selector to find the settings (or target) button to possition to
       * @type {String}
       * @default ".cf-settingslist-groupitem-settings"
       */
      settingsButtonSelector: ".cf-settingslist-groupitem-settings",
      /**
       * @name nixps-cloudflow.ListPanelEdit#ignoreOverlayClass
       * @description The css selector which will ignore the overlayClickedHandler if clicked within
       * @type {String}
       * @default ".ignoreListPanelEditOverlay"
       */
      ignoreOverlaySelector: ".ignoreListPanelEditOverlay",
      /**
       * @name nixps-cloudflow.ListPanelEdit#disabled
       */
      disabled: false
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._otherClickHanlder = this._overlayClickHandler.bind(this);
      this._ignoreEvent = null; // the event that opens the dialog, to prevent conflict with click event outside to close dialog

      this.element.addClass("cf-dialog");
      $("body").append(this.element);
      this.dialog = this.element;
      this.dialog.attr("role", "dialog");
      this.form = this.dialog.FormDetailsPanel(Object.assign(this.options.detailsOptions, {
        disabled: this.options.disabled
      }));
      this.dialog.draggable({
        cancel: ".detailspanel_content, .cf-detailspanel-close",
        handle: ".cf-detailspanel-title",
        containment: "document"
      });
      this._on(this.element, {
        "formdetailspanelclose": this._formCloseHandler,
        "formdetailspanelcancel": this._formCloseHandler,
        "formdetailspanelcreatenew": this._createNewHandler,
        "formdetailspaneledit": this._editHandler
      });
    },
    _overlayClickHandler: function _overlayClickHandler(pEvent) {
      if ($(pEvent.target).closest("." + this.widgetFullName).length > 0) {
        return;
      }
      if (typeof this.options.ignoreOverlaySelector === "string" && this.options.ignoreOverlaySelector.length > 0) {
        if ($(pEvent.target).closest(this.options.ignoreOverlaySelector).length > 0) {
          return;
        }
      }
      if (this._ignoreEvent !== undefined) {
        if (pEvent.type === this._ignoreEvent.type && pEvent.timeStamp === this._ignoreEvent.timeStamp) {
          this._ignoreEvent = undefined;
          return;
        }
      }
      this.close();
    },
    _formCloseHandler: function _formCloseHandler(pEvent) {
      // do not call this.close, otherwise this function will be recalled
      // and then we loop.....
      this._trigger("close");
      this._removeClickEventHandler();
      this.dialog.hide();
    },
    _createNewHandler: function _createNewHandler(pEvent, pData) {
      pEvent.stopPropagation();
      if (pData !== undefined) {
        if (this._trigger("createnew", null, pData) === false) {
          return false;
        }
      }
    },
    _editHandler: function _editHandler(pEvent, pData) {
      pEvent.stopPropagation();
      if (pData !== undefined) {
        if (this._trigger("edit", null, pData) === false) {
          return false;
        }
      }
    },
    open: function open(pEventToIgnore) {
      this.repositionMe(pEventToIgnore);
      this._ignoreEvent = pEventToIgnore;
      this._addClickEventHandler();
      this.dialog.css("display", "");
      this.form.FormDetailsPanel("open");
    },
    close: function close() {
      this._removeClickEventHandler();
      this.dialog.hide();
      this.form.FormDetailsPanel("close");
    },
    newValue: function newValue(pValue) {
      this.form.FormDetailsPanel("newValue", pValue);
    },
    setMultipleValues: function setMultipleValues(pValues) {
      this.form.FormDetailsPanel("setMultipleValues", pValues);
    },
    showErrorMessage: function showErrorMessage(pErrorMessage, pEnableButtons) {
      this.form.FormDetailsPanel("showErrorMessage", pErrorMessage);
      if (pEnableButtons === true) {
        this.form.FormDetailsPanel("enableButtonBar");
      }
    },
    hideErrorMessages: function hideErrorMessages(pEnableButtons) {
      this.form.FormDetailsPanel("hideErrorMessages");
      if (pEnableButtons === true) {
        this.form.FormDetailsPanel("enableButtonBar");
      }
    },
    repositionMe: function repositionMe(pOpenEvent) {
      // complate list component
      var settingsListDOM = $(pOpenEvent.target).closest(this.options.parentPositioning);
      if (settingsListDOM.length === 1) {
        var rightBorder = settingsListDOM.offset().left + settingsListDOM.width();

        // cogwheel list item buttom
        var settingsButtonDOM = $(pOpenEvent.target).closest(this.options.settingsButtonSelector);
        var settingsBttonBorder;
        if (settingsButtonDOM.length === 1) {
          settingsBttonBorder = settingsButtonDOM.position().top + settingsListDOM.offset().top;
        } else {
          var topBorder = settingsListDOM.offset().top;
          settingsBttonBorder = topBorder;
        }
        if (settingsBttonBorder + this.dialog.outerHeight() > $(window).height()) {
          // dialog is outside, (below the bottom) of the screen
          // reset top, so dialog is shift to visible area
          settingsBttonBorder = $(window).height() - this.dialog.outerHeight();
        }
        this.dialog.css({
          "left": rightBorder,
          "top": settingsBttonBorder
        });
        if (settingsListDOM.closest(".cf-dialog").length === 1) {
          this.dialog.css("zIndex", 1800);
        }
      }
    },
    _addClickEventHandler: function _addClickEventHandler() {
      if ($("body")[0].addEventListener === undefined) {
        $("body").on("mousedown", this._otherClickHanlder);
      } else {
        // use capture, when event goes down,
        // sometimes the ui DOM is removed, so we can not detect the parent DOM!
        $("body")[0].addEventListener("mousedown", this._otherClickHanlder, true);
      }
    },
    _removeClickEventHandler: function _removeClickEventHandler() {
      if ($("body")[0].addEventListener === undefined) {
        $("body").off("mousedown", this._otherClickHanlder);
      } else {
        $("body")[0].removeEventListener("mousedown", this._otherClickHanlder, true);
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      if (pKey === "disabled") {
        this.form.FormDetailsPanel("option", "disabled", this.options.disabled);
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("cf-dialog");
      this._removeClickEventHandler();
      this.dialog.filter(".nixps-cloudflow-FormDetailsPanel").FormDetailsPanel("destroy");
      this.dialog.removeAttr("role");
      this._super();
    }
  });
})(jQuery);

},{"../../DetailsPanel/js/nixps-cloudflow-FormDetailsPanel.js":104}],180:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by Guillaume Desmet on 11/28/2018, 10:14:01 AM
 */
(function ($) {
  // external includes
  require("./nixps-cloudflow-ListPanel.js");
  var CloudflowConnection = require("../../CloudflowUtil/js/CloudflowConnection.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  var User = require("../../User/js/User.js");
  require("../../CloudflowUtil/js/nixps-cloudflowutil-NameToolKit.js");
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");
  var Query = require("../../Table/js/Query.js");

  /**
   * @namespace nixps-cloudflow.PreConfiguredListPanel
   * @description Draw a PreConfiguredListPanel component
   * @example $("<div>").PreConfiguredListPanel({});
   * @version 1.1.0
   */
  $.widget("nixps-cloudflow.PreConfiguredListPanel", $["nixps-cloudflow"].ListPanel, {
    widgetEventPrefix: "preconfiguredlistpanel",
    version: "1.0.0",
    options: {
      /**
       * @description the user object 
       * @name nixps-cloudflow.PreConfiguredListPanel#user
       * @type {User}
       * @default null
       */
      user: null,
      /**
       * @description Where can we find the data to display?
       * @name nixps-cloudflow.PreConfiguredListPanel#collection
       * @type {String}
       * @default ""
       */
      collection: "",
      /**
       * @description The extra filter query asked to the backend
       * @name nixps-cloudflow.PreConfiguredListPanel#extraQuery
       * @type {Array.<String>}
       * @default []
       */
      extraQuery: [],
      /**
       * @description The default orderby of the list
       * @name nixps-cloudflow.PreConfiguredListPanel#orderBy
       * @type {Array.<String>}
       * @default []
       */
      orderBy: [],
      /**
       * @description The plain static data
       * @name nixps-cloudflow.PreConfiguredListPanel#data
       * @type {Array.<Object>}
       * @default []
       */
      data: [],
      collectionArray: [],
      /**
       * @description The input name of the http service
       * @name nixps-cloudflow.PreConfiguredListPanel#httpserviceInputName
       * @type {String}
       * @default ""
       */
      httpserviceInputName: "",
      /**
       * @description The whitepaper name of the http service
       * @name nixps-cloudflow.PreConfiguredListPanel#httpserviceWhitepaperName
       * @type {String}
       * @default ""
       */
      httpserviceWhitepaperName: "",
      /**
       * @name nixps-cloudflow.PreConfiguredListPanel#keyUniqID
       * @description The parameter name of the id of the objects
       * @type {String}
       * @default "_id"
       */
      keyUniqID: "_id",
      /**
       * @description The file url to search for data
       * @name nixps-cloudflow.PreConfiguredListPanel#dataFileURL
       * @type {String}
       * @default ""
       */
      dataFileURL: "",
      /**
       * @description The relative base path of the data file
       * @name nixps-cloudflow.PreConfiguredListPanel#relativeBasePath
       * @type {String}
       * @default ""
      */
      relativeBasePath: "",
      /**
       * @description must we select the first element of the list and send an event
       * @name nixps-cloudflow.PreConfiguredListPanel#selectOnCreationMethod
       * @type {String}
       * @default "first"
       */
      selectOnCreationMethod: "first",
      /**
       * @description The name of the parameter who contains the label text to display in the list
       * @name nixps-cloudflow.PreConfiguredListPanel#keyNameForLabel
       * @type {String}
       * @default "label"
       */
      keyNameForLabel: "label",
      /**
       * @description The name of the parameter who contains the badge number to display in the list
       * @name nixps-cloudflow.PreConfiguredListPanel#keyNameForBadge
       * @type {String}
       * @default "badge_number"
       */
      keyNameForBadge: "badge_number",
      /**
       * @description Is the user allowed to edit 
       * @name nixps-cloudflow.PreConfiguredListPanel#enableEdit
       * @type {Boolean}
       * @default false
       */
      enableEdit: false,
      /**
       * @description Is the user allowed to delete 
       * @name nixps-cloudflow.PreConfiguredListPanel#enableDelete
       * @type {Boolean}
       * @default false
       */
      enableDelete: false,
      /**
       * @description Is the user allowed to duplicate 
       * @name nixps-cloudflow.PreConfiguredListPanel#enableDuplicate
       * @type {Boolean}
       * @default false
       */
      enableDuplicate: false,
      /**
       * @description is the user allowed to download the item
       * @name nixps-cloudflow.PreConfiguredListPanel#enableDownload
       * @type {Boolean}
       * @default false
       */
      enableDownload: false,
      /**
       * @name nixps-cloudflow.PreConfiguredListPanel#deleteConfirmationTitle
       * @description The message title to ask confirmation to the user when deleting a row
       * @type {String}
       * @default ""
       */
      deleteConfirmationTitle: "",
      /**
       * @name nixps-cloudflow.PreConfiguredListPanel#deleteConfirmationMessage
       * @description The message to ask confirmation to the user when deleting a row
       * @type {String}
       * @default ""
       */
      deleteConfirmationMessage: "",
      /**
       * @name nixps-cloudflow.PreConfiguredListPanel#deleteConfirmationMessageRowObjectParameter
       * @description The field to be used in the delete confirmation message
       * @type {String}
       * @default ""
       */
      deleteConfirmationMessageRowObjectParameter: "",
      /**
       * @name nixps-cloudflow.PreConfiguredListPanel#lazyloading
       * @description must we load only the name for listing and do separated calls when selection (value true), 
       * or must we load directly everything (value false)
       * @type {Boolean}
       * @default false
       */
      lazyloading: false,
      /**
       * @name nixps-cloudflow.PreConfiguredListPanel#lazyScrollLoading
       * @description must we load a part and not everything, afterwards load after scrolling
       * @type {Boolean}
       * @default undefined
       */
      lazyScrollLoading: true,
      /**
       * @description What are the extra fields we need to ask in the first call to be able to display the item
       * @name nixps-cloudlfow.PreConfiguredListPanel#additionalFields
       * @type {Array.<String>}
       * @default []
       */
      additionalFields: [],
      /**
       * @description function runws when the component is done rendering
       * @name nixps-cloudlfow.PreConfiguredListPanel#created
       * @private
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Calc default options
     * @name nixps-cloudflow.PreConfiguredListPanel#_getCreateOptions
     * @function
     * @private
     * @returns {Object}
     */
    _getCreateOptions: function _getCreateOptions() {
      return {};
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.PreConfiguredListPanel#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);

      // variables
      this.listCallingID = 0; // calling id to prevent race conditions on update list
      this.connection = null;
      this.alive = true;
      this.allowToDelete = null; // has permissions to delete
      this.allowToUpdate = null; // has permissions to update
      this.rowObjectCacheDict = {}; // temp cache for lazy loading objects
      this.user = null;
      if ($.isPlainObject(this.options.user)) {
        this.user = User.fromJSON(this.options.user);
      } else if (this.options.user instanceof User) {
        this.user = this.options.user;
      } else {
        throw new Error("option user must be filled in with user data");
      }

      // update option lists
      this._configConnection();
      this._initList();
      this._super();
    },
    _changeHandler: function _changeHandler(pEvent, pData) {
      // clear caches
      this.rowObjectCacheDict = {};
      this._superApply(arguments);
    },
    _selectHandler: function _selectHandler(pEvent, pData) {
      if (this.options.lazyloading === true && pData !== undefined && Array.isArray(pData.rowObjects) && pData.rowObjects.length > 0) {
        var that = this;
        var supFc = this._super;
        var ids = [];
        var cachedRowObjects = [];
        var isCachedPresent = true;
        for (var i = 0; i < pData.rowObjects.length; i++) {
          ids.push(CloudflowObject.getParameter(pData.rowObjects[i], this.options.keyUniqID));
          if (isCachedPresent === true && this.rowObjectCacheDict[ids[ids.length - 1]] !== undefined) {
            cachedRowObjects.push(Object.assign({}, this.rowObjectCacheDict[ids[ids.length - 1]]));
          } else {
            isCachedPresent = false;
          }
        }
        if (isCachedPresent) {
          pData.rowObjects = cachedRowObjects;
          this._super(pEvent, pData);
          return;
        }
        this.connection.list_with_options([this.options.keyUniqID, "in", ids], [], [], 0, undefined).then(function (pResult) {
          if (pResult !== undefined && Array.isArray(pResult.results)) {
            pResult.results.forEach(function (pRow) {
              // feeding cache
              that.rowObjectCacheDict[CloudflowObject.getParameter(pRow, that.options.keyUniqID)] = pRow;
            });
            pData.rowObjects = pResult.results;
            supFc.apply(that, [pEvent, pData]);
          } else {
            console.error("invalid retuning interface");
          }
        }, function (pError) {
          console.error("failed selection", pError);
        });
      } else {
        this._super(pEvent, pData);
      }
    },
    /**
     * @description function runs when user want to delete 
     * @function
     * @name nixps-cloudflow.PreConfiguredListPanel#_deleteHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _deleteHandler: function _deleteHandler(pEvent, pData) {
      pEvent.stopPropagation();
      if (pData !== undefined && Array.isArray(pData.rowObjects) && pData.rowObjects.length > 0) {
        var that = this;
        var listGroupDOM = $(pData.originalEvent.target).closest(".nixps-cloudflow-ListGroup");
        if (listGroupDOM.length === 0) {
          console.error("listGroup not found for delete updating");
        }
        var confirmationOptions = this._getDeleteConfimationTitles(pData.rowObjects);
        return $("body").Dialog("show_delete_no", confirmationOptions.title, confirmationOptions.message, function () {}, function () {}).then(function (pResult) {
          if (pResult !== undefined && pResult.type === "delete") {
            // calc array of ids
            var ids = pData.rowObjects.map(function (elem) {
              return CloudflowObject.getParameter(elem, that.options.keyUniqID);
            });
            return that.connection.delete_by_query([that.options.keyUniqID, "in", ids]).then(function (pResult) {
              if (pResult.results !== undefined && pResult.results.ok === ids.length) {
                listGroupDOM.ListGroup("removeByIDs", ids);
                that._trigger("deleted", null, pData);
                // clear cache
                for (var i = 0; i < ids.length; i++) {
                  delete that.rowObjectCacheDict[ids[i]];
                }
              } else {
                console.warn("Error durring delete we will do a generic update");
                return $.when(listGroupDOM.listGroup("update")).always(function () {
                  that._trigger("deleted", null, pData);
                });
              }
            })["catch"](function (pError) {
              console.error(pError);
              return Promise.reject(pError);
            });
          }
        });
      } else {
        console.error("_deleteHandler: no selected items data found to delete");
      }
    },
    _creatingNewHandler: function _creatingNewHandler(pEvent, pData, pFormCallBack) {
      pEvent.stopPropagation();
      var that = this;
      if (pData !== undefined || pData.values !== undefined) {
        var createNewJSON = {};
        if ($.isPlainObject(pData.originalValues) && $.isEmptyObject(pData.originalValues) === false) {
          createNewJSON = Object.assign(pData.originalValues, pData.values);
        } else {
          createNewJSON = pData.values;
        }
        this._createObject(createNewJSON).then(function (pCreatedObject) {
          if (typeof pFormCallBack === "function") {
            pFormCallBack();
          }
          that._trigger("itemcreated", null, {
            createdObject: pCreatedObject
          });
        }, function (pError) {
          if (typeof pFormCallBack === "function") {
            pFormCallBack(pError);
          }
        });
      } else {
        if (typeof pFormCallBack === "function") {
          pFormCallBack({
            error_code: "invalid_interface",
            error: "invalid data from event"
          });
        }
        console.error("_creatingNewHandler: invalid data from event");
      }
    },
    _editingHandler: function _editingHandler(pEvent, pData, pFormCallBack) {
      pEvent.stopPropagation();
      var that = this;
      if (pData !== undefined && pData.values !== undefined && pData.originalValues !== undefined) {
        var originalValuesDef = pData.originalValues;
        if (this.options.lazyloading === true) {
          var id = CloudflowObject.getParameter(pData.originalValues, this.options.keyUniqID);
          originalValuesDef = this.connection.list_with_options([this.options.keyUniqID, "equal to", id], [], [], 0, 1).then(function (pResults) {
            if (Array.isArray(pResults.results) && pResults.results.length === 1) {
              return pResults.results[0];
            }
            return null;
          });
        }
        $.when(originalValuesDef).then(function (pOriginalValue) {
          if (pOriginalValue === null) {
            console.error("item does not exists");
            if (typeof pFormCallBack === "function") {
              pFormCallBack({
                error: "item does not exist any more",
                error_code: "item_removed_by_other"
              });
            }
            return;
          }
          if (that._trigger("beforeedit", null, [{
            originalValues: pOriginalValue,
            newValues: pData.values
          }, pFormCallBack]) !== false) {
            var updatedObject = Object.assign(pOriginalValue, pData.values);
            $.when(that.updateObject(updatedObject)).then(function (pUpdatedObject) {
              if (typeof pFormCallBack === "function") {
                pFormCallBack();
              }
              that._trigger("edited", null, {
                updatedObject: pUpdatedObject
              });
            }).fail(function (pError) {
              if (typeof pFormCallBack === "function") {
                pFormCallBack(pError);
              }
            });
          }
        }).fail(function (pError) {
          if (typeof pFormCallBack === "function") {
            pFormCallBack(pError);
          }
        });
      } else {
        if (typeof pFormCallBack === "function") {
          pFormCallBack({
            error_code: "invalid_interface",
            error: "invalid data from event"
          });
        }
        console.error("_editingHandler: invalid data from event");
      }
    },
    /**
     * @description function runs when user want to duplicate an item
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredListPanel#_duplicateHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _duplicateHandler: function _duplicateHandler(pEvent, pData) {
      pEvent.stopPropagation();
      if (pData !== undefined && Array.isArray(pData.rowObjects) && pData.rowObjects.length > 0) {
        if (this.options.lazyloading === true) {
          var that = this;
          var id = CloudflowObject.getParameter(pData.rowObjects[0], this.options.keyUniqID);
          this.connection.list_with_options([this.options.keyUniqID, "equal to", id], [], [], 0, 1).then(function (pResults) {
            if (Array.isArray(pResults.results) && pResults.results.length === 1) {
              that._duplicateObject(pResults.results[0]);
            } else {
              console.error("item does not exists");
            }
          });
        } else {
          this._duplicateObject(pData.rowObjects[0]);
        }
      }
    },
    /**
     * @description function runs when user want to download the item
     * @name nixps-cloudflow.PreConfiguredListPanel#_downloadHandler
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _downloadHandler: function _downloadHandler(pEvent, pData) {
      if (pData !== undefined && Array.isArray(pData.rowObjects) && pData.rowObjects.length > 0) {
        var id = CloudflowObject.getParameter(pData.rowObjects[0], this.options.keyUniqID);
        if (typeof id !== "string" || id.length <= 0) {
          throw new Error("could not retrieve id to download item");
        }
        var downloadURL = this.connection.get_download_url(id);
        if (typeof downloadURL === "string" && downloadURL.length > 0) {
          window.location.href = downloadURL;
        }
      }
    },
    _uploadHandler: function _uploadHandler(pEvent, pData) {
      if (pData !== undefined && Array.isArray(pData.rowObjects) && pData.rowObjects.length > 0) {
        var createDefs = [];
        for (var i = 0; i < pData.rowObjects.length; i++) {
          createDefs.push(this._createObject(pData.rowObjects[i]));
        }
        $.when.apply($, createDefs);
      }
    },
    /**
     * @description function runs when api calls erors and we need to inform others
     * @function
     * @name nixps-cloudflow.PreConfiguredListPanel#_errorHandler
     * @private
     * @param {String} pCodeSection an string indication where the error occured
     * @param {Object} pError 
     */
    _errorHandler: function _errorHandler(pCodeSection, pError) {
      console.error(pError);
      this._trigger("error", null, pError);
      LogListener.addLog({
        event_type: "error",
        details_data: pError,
        component_name: this.widgetFullName
      }, this.element);
    },
    /**
     * @description function runs when source triggers changes
     * @function
     * @name nixps-cloudflow.PreConfiguredListPanel#_sourceChangeHandler
     * @private
     */
    _sourceChangeHandler: function _sourceChangeHandler() {
      this.update();
    },
    /**
     * @description Set up correctly the list options
     * @function
     * @name nixps-cloudflow.PreConfiguredListPanel#_initList
     * @private
     */
    _initList: function _initList() {
      // update option lists
      if (Array.isArray(this.options.lists) === false) {
        if ($.isPlainObject(this.options.lists) && $.isEmptyObject(this.options.lists) === false) {
          this.options.lists = [this.options.lists];
        } else {
          this.options.lists = [];
        }
      }
      if (this.options.lists.length === 0) {
        this.options.lists.push({
          "title": "title",
          "selectingOptions": {
            "multiple": false,
            "deselectable": false,
            "selectClass": "cf-select"
          },
          "enableAddButton": true,
          "enableDropdownMenu": false,
          "updateDelay": 0
        });
      }
      this.options.lists[0].children = this._dataProvider.bind(this);
      if ($.isPlainObject(this.options.lists[0].selectingOptions) === false || $.isEmptyObject(this.options.lists[0].selectingOptions)) {
        this.options.lists[0].selectingOptions = {};
      }
      Object.assign(this.options.lists[0].selectingOptions, {
        "multiple": false,
        "deselectable": false,
        "selectClass": "cf-select"
      });
      // use internally _id, so force it
      if (this.options.keyUniqID !== "_id") {
        for (var i = 0; i < this.options.lists.length; i++) {
          if (this.options.lists[i].childrenOptions === undefined) {
            this.options.lists[i].childrenOptions = {};
          }
          this.options.lists[i].childrenOptions.keyUniqID = "_id";
        }
      }
      var lazyScrollLoading = undefined;
      if (typeof this.options.lazyScrollLoading === "boolean") {
        lazyScrollLoading = this.options.lazyScrollLoading;
      } else if (this.options.collection === "object") {
        lazyScrollLoading = false;
      }
      var enableDropdownMenu = this.options.enableEdit || this.options.enableDelete && this.allowToDelete === true || this.options.enableDuplicate || this.options.enableDownload;
      var beforeEditingCB = this.options.lazyloading === true ? this._beforeEditingCB.bind(this) : undefined;
      for (var i = 0; i < this.options.lists.length; i++) {
        this.options.lists[i].enableDropdownMenu = enableDropdownMenu;
        this.options.lists[i].searchKey = this.options.keyNameForLabel;
        this.options.lists[i].lazyScrollLoading = lazyScrollLoading;
        this.options.lists[i].beforeEditingCB = beforeEditingCB;
      }
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredListPanel#_configConnection
     * @return {undefined} 
     */
    _configConnection: function _configConnection() {
      if (this.connection !== null) {
        this.connection.stop();
      }
      // check if we have at least some data
      if (this.options.collection === undefined || this.options.collection === null || this.options.collection === "") {
        return true;
      }
      // do the request for data
      var data = [];
      if (Array.isArray(this.options.data)) {
        data = data.concat(this.options.data);
      }
      if (Array.isArray(this.options.collectionArray)) {
        data = data.concat(this.options.collectionArray);
      }
      this.connection = new CloudflowConnection({
        collection: this.options.collection,
        data: data,
        dataFileURL: this.options.dataFileURL,
        relativeBasePath: this.options.relativeBasePath,
        httpserviceInputName: this.options.httpserviceInputName,
        httpserviceWhitepaperName: this.options.httpserviceWhitepaperName,
        protectRaceConditions: false,
        error_cb: this._errorHandler.bind(this),
        change_cb: this._sourceChangeHandler.bind(this)
      });
      this.allowToDelete = CloudflowConnection.isAllowedToDelete(this.options.collection, this.user);
      this.allowToUpdate = CloudflowConnection.isAllowedToUpdate(this.options.collection, this.user);
    },
    _dataProvider: function _dataProvider(pQuery, pOrderBy, pSkip, pLimit) {
      if (this.options.collection === undefined || this.options.collection === null || this.options.collection === "") {
        return [];
      }
      var that = this;
      var filter;
      if (Array.isArray(pQuery) && pQuery.length > 0) {
        filter = Query.concatQuery(pQuery, this.options.extraQuery);
      } else {
        filter = this.options.extraQuery;
      }
      var fields = [];
      if (this.options.lazyloading === true) {
        fields = [this.options.keyUniqID, this.options.keyNameForLabel, "modification", "save_id"];
        if (typeof this.options.keyNameForBadge === "string" && this.options.keyNameForBadge.length > 0) {
          fields.push(this.options.keyNameForBadge);
        }
      }
      fields = fields.concat(this.options.additionalFields);
      var orderBy = [];
      var optionOrderBy;
      if (this.options.orderBy.some(function (t) {
        return t.length === 0;
      })) {
        // user has disabled the sorting by setting a key to empty
        optionOrderBy = [];
      } else {
        optionOrderBy = this.options.orderBy;
      }
      if (Array.isArray(pOrderBy) && pOrderBy.length > 0) {
        orderBy = pOrderBy.concat(optionOrderBy);
      } else {
        orderBy = optionOrderBy;
      }
      return $.when(this.connection.list_with_options(filter, orderBy, fields, pSkip || 0, pLimit), ++this.listCallingID).then(function (pResults, pCallingID) {
        if (that.alive === false) {
          return; // zombie
        }

        if (pCallingID < that.listCallingID) {
          // call came to late, do not overwrite newer call
          return;
        }
        var items;
        if (pResults !== undefined && pResults !== null && Array.isArray(pResults.results || pResults.documents)) {
          items = pResults.results || pResults.documents;
        } else if (Array.isArray(pResults)) {
          items = pResults;
        } else {
          console.error("_dataProvider: no good returning array interface");
          that._trigger("error", null, {
            "error_code": "wrong_interface",
            "error": "wrong returning interface"
          });
          LogListener.addLog({
            event_type: "error",
            details_data: {
              "error_code": "wrong_interface",
              "error": "wrong returning interface"
            },
            component_name: that.widgetFullName
          }, this.element);
          return;
        }
        var output = new Array(items.length),
          _id,
          download_url;
        for (var i = 0; i < items.length; i++) {
          _id = CloudflowObject.getParameter(items[i], that.options.keyUniqID);
          download_url = false;
          if (_id && that.options.enableDownload) {
            var downloadURL = that.connection.get_download_url(_id);
            if (typeof downloadURL === "string" && downloadURL.length > 0) {
              download_url = downloadURL;
            }
          }
          output[i] = {
            _id: _id,
            label: CloudflowObject.getParameter(items[i], that.options.keyNameForLabel),
            badge_number: CloudflowObject.getParameter(items[i], that.options.keyNameForBadge),
            classes: "",
            disabled: false,
            edit: that.allowToUpdate === true && that.options.enableEdit,
            duplicate: that.options.enableDuplicate,
            "delete": that.allowToDelete === true && that.options.enableDelete,
            download: that.options.enableDownload,
            download_url: download_url,
            modification: items[i].modification,
            data: items[i]
          };
        }
        return output;
      }).fail(function (pError) {
        console.error(pError);
      });
    },
    _getDeleteConfimationTitles: function _getDeleteConfimationTitles(pSelectedRowObjects) {
      return CloudflowConnection.getDeleteConfimationTitles(this.options.collection, $.makeArray(pSelectedRowObjects), this.options.deleteConfirmationTitle, this.options.deleteConfirmationMessage, this.options.deleteConfirmationMessageRowObjectParameter);
    },
    _createObject: function _createObject(pCreateNewJSON) {
      var that = this;
      return this.connection.create(pCreateNewJSON).then(function (pCreatedObject) {
        return $.when(that.update()).then(function () {
          if (pCreatedObject !== undefined) {
            var id = CloudflowObject.getParameter(pCreatedObject, that.options.keyUniqID);
            if (typeof id === "string" || typeof id === "number") {
              // update cache
              that.rowObjectCacheDict[id] = pCreatedObject;
              that.select(id, true);
            }
          }
          return pCreatedObject;
        });
      }).fail(function (pError) {
        console.error(pError);
      });
    },
    _duplicateObject: function _duplicateObject(pObject) {
      var that = this;
      var candidateNewName = null;
      var items = this.getValue();
      if (Array.isArray(items)) {
        var existingLabels = items.map(function (item) {
          return item.label;
        });
        if (Array.isArray(existingLabels) && window.nixps !== undefined && nixps.cloudflowutil !== undefined) {
          candidateNewName = nixps.cloudflowutil.NameToolKit.getNameSequence(existingLabels, CloudflowObject.getParameter(pObject, this.options.keyNameForLabel));
        }
      }
      var duplicatedObject = $.extend(true, {}, pObject);
      if (typeof candidateNewName === "string" && candidateNewName.length > 0) {
        duplicatedObject = CloudflowObject.setParameter(duplicatedObject, this.options.keyNameForLabel, candidateNewName);
      }
      duplicatedObject = CloudflowObject.deleteParameter(duplicatedObject, this.options.keyUniqID);
      delete duplicatedObject.birth;
      delete duplicatedObject.modification;
      delete duplicatedObject.save_id;
      return this._createObject(duplicatedObject).then(function (pNewObject) {
        that._trigger("duplicated", null, {
          duplicatedObject: pNewObject
        });
      });
    },
    /**
     * @description update a specific object and update the list afterwards
     * @function
     * @name nixps-cloudflow.PreConfiguredListPanel#updateObject
     * @param {Object} pObject 
     * @returns {Deferred}
     */
    updateObject: function updateObject(pObject) {
      var that = this;
      return this.connection.update(pObject).then(function (pUpdatedObject) {
        return $.when(that.update()).then(function () {
          // update cache
          var id = CloudflowObject.getParameter(pUpdatedObject, that.options.keyUniqID);
          if (typeof id === "string" || typeof id === "number") {
            that.rowObjectCacheDict[id] = pUpdatedObject;
          }
          return pUpdatedObject;
        });
      })["catch"](function (pError) {
        console.error(pError);
        return Promise.reject(pError);
      });
    },
    /**
     * @description in case of layzyloading, try to load the data for the edit form 
     * @function
     * @name nixps-cloudflow.PreConfiguredListPanel#_beforeEditingCB
     * @param {Object} pData 
     * @returns Deferred object
     */
    _beforeEditingCB: function _beforeEditingCB(pData) {
      if (pData !== undefined) {
        var that = this;
        var id = CloudflowObject.getParameter(pData, this.options.keyUniqID);
        if (id !== undefined) {
          return this.connection.list_with_options([this.options.keyUniqID, "equal to", id], [], [], 0, 1).then(function (pResults) {
            if (Array.isArray(pResults.results) && pResults.results.length === 1) {
              return pResults.results[0];
            } else {
              that._errorHandler("before_edit", {
                error_code: "missing_object",
                error: "object to edit is missing"
              });
            }
          });
        } else {
          this._errorHandler("before_edit", {
            error_code: "missing_uniq_parameter",
            error: "missing uniqe parameter"
          });
        }
      }
      return null;
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredListPanel#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._configConnection();
      this._initList();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.PreConfiguredListPanel#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.keyNameForLabel !== "string" || this.options.keyNameForLabel.length <= 0) {
        throw new Error("PreConfiguredListPanel: input option keyNameForLabel should be a not empty string");
      }
      if (Array.isArray(this.options.orderBy) === false) {
        throw new Error("PreConfiguredListPanel: input option orderBy must be an array");
      } else if (this.options.orderBy.length % 2 !== 0) {
        throw new Error("PreConfiguredListPanel: input option orderBy must be an array with event amount of elements");
      } else {
        // deep copy
        this.options.orderBy = this.options.orderBy.slice();
      }
      for (var i = 0; i < this.options.orderBy.length; i++) {
        if (typeof this.options.orderBy[i] !== "string") {
          throw new Error("PreConfiguredListPanel: input option sort index " + i + " must be a string");
        }
        if (i % 2 === 1 && ["ascending", "descending"].includes(this.options.orderBy[i]) === false) {
          throw new Error("PreConfiguredListPanel: input option sort index " + i + " must be the string ascending or descending");
        }
      }
      if (typeof this.options.enableEdit !== "boolean") {
        throw new Error("PreConfiguredListPanel: input option enableEdit must be a boolean");
      }
      if (typeof this.options.enableDelete !== "boolean") {
        throw new Error("PreConfiguredListPanel: input option enableDelete must be a boolean");
      }
      if (typeof this.options.enableDuplicate !== "boolean") {
        throw new Error("PreConfiguredListPanel: input option enableDuplicate must be a boolean");
      }
      if (typeof this.options.httpserviceWhitepaperName !== "string") {
        throw new Error("PreConfiguredListPanel: input option httpserviceWhitepaperName must be a string");
      }
      if (typeof this.options.httpserviceInputName !== "string") {
        throw new Error("PreConfiguredListPanel: input option httpserviceInputName must be a string");
      }
      if (typeof this.options.collection === "string" && this.options.collection.indexOf("nucleus.") === 0) {
        this.options.keyUniqID = "_id";
      }
      if (typeof this.options.keyUniqID !== "string" || this.options.keyUniqID.length <= 0) {
        throw new Error("PreConfiguredListPanel: input option keyUniqID must be a not empty string");
      }
      if (Array.isArray(this.options.extraQuery) === false) {
        throw new Error("PreConfiguredListPanel: input option extraQuery must be an array");
      }
      if (typeof this.options.lazyloading !== "boolean") {
        throw new Error("PreConfiguredListPanel: input option lazyloading must be a boolean");
      }
      this._super();
    },
    _destroy: function _destroy() {
      this.alive = false;
      if (this.connection !== undefined && this.connection !== null) {
        this.connection.stop();
      }
      this.element.removeClass(this.widgetFullName);
      this._super();
    }
  });
})(jQuery);

},{"../../../pagebuilder/js/inspect/LogListener.js":431,"../../CloudflowUtil/js/CloudflowConnection.js":78,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../CloudflowUtil/js/nixps-cloudflowutil-NameToolKit.js":94,"../../Table/js/Query.js":211,"../../User/js/User.js":268,"./nixps-cloudflow-ListPanel.js":178}],181:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

/* triggers: */
/* - refresh-finished */
/* - select */
(function ($) {
  var Asset = {
    getDedicatedFileIcon: function getDedicatedFileIcon() {
      return "cf-icon cf-icon-clipboard-list";
    }
  };
  var FileSizeUtils = {
    toString: function toString(e) {
      return e;
    }
  };
  if (typeof require !== "undefined") {
    if (typeof $.fn.Table !== "function") {
      require("../../Table/js/nixps-cloudflow-Table.js");
    }
    Asset = require("../../../nebulaportal/js/assetview/Asset.js");
    FileSizeUtils = require("../../../cloudflow/CloudflowUtil/js/FileSizeUtils.js");
  }
  function get_descriptive_filetype(p_mimetype) {
    if (p_mimetype === "folder") {
      return $.i18n._("nixps-cloudflow-assets.filetype-folder");
    } else if (p_mimetype.indexOf("text/") === 0) {
      var type = p_mimetype.substring(5).toUpperCase();
      if (type.indexOf("PLAIN") != -1) {
        return $.i18n._("nixps-cloudflow-assets.filetype-text_file");
      }
      return $.i18n._("nixps-cloudflow-assets.filetype-regular_file", [type]);
    } else if (p_mimetype === "vnd.nixps-layout") {
      return "Cloudflow Layout";
    } else if (p_mimetype.indexOf("application/") === 0 && p_mimetype !== "application/unknown") {
      var type = p_mimetype.substring(12).toUpperCase();
      if (type.indexOf("ILLUSTRATOR") !== -1) {
        type = "Adobe Illustrator";
      }
      return $.i18n._("nixps-cloudflow-assets.filetype-regular_file", [type]);
    } else if (p_mimetype.indexOf("image/") === 0) {
      var type = p_mimetype.substring(6).toUpperCase();
      return $.i18n._("nixps-cloudflow-assets.filetype-image", [type]);
    } else if (p_mimetype.indexOf("model/") === 0) {
      var type = p_mimetype.substring(6);
      if (type === "vnd.collada-zipped") {
        return $.i18n._("nixps-cloudflow-assets.filetype-colladazip");
      } else if (type.indexOf("vnd.collada") === 0) {
        return $.i18n._("nixps-cloudflow-assets.filetype-collada");
      } else if (type === "gltf-binary") {
        return $.i18n._("nixps-cloudflow-assets.filetype-regular_file", ["GLB"]);
      } else if (type === "gltf+json") {
        return $.i18n._("nixps-cloudflow-assets.filetype-regular_file", ["GLTF"]);
      }
      return $.i18n._("nixps-cloudflow-assets.filetype-regular_file", [type.toUpperCase()]);
    } else if (p_mimetype.indexOf("font/") === 0) {
      return $.i18n._("nixps-cloudflow-assets.filetype-regular_file", ["FONT"]);
    } else {
      return $.i18n._("nixps-cloudflow-assets.filetype-unknown");
    }
  }
  ;
  var rowIDRegExpr = new RegExp("^tableRowID_[0-9a-zA-Z]+$");

  /**
   * Triggers "select"
   * @description Component shows the list of assets and folders in a specific folder in form of a table, list
   * @namespace nixps-cloudflow.ListView
   * @example $("<div>").ListView({folders: [..], files:[..], ... });
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.ListView", {
    version: "1.0.0",
    widgetEventPrefix: "listview",
    options: {
      /**
       * @name nixps-cloudflow.ListView#folders
       * @description The folders to show
       * @type {Array}
       */
      folders: undefined,
      /**
       * @name nixps-cloudflow.ListView#files
       * @description The files to show
       * @type {Array}
       */
      files: undefined,
      /**
       * @name nixps-cloudflow.ListView#baselocation
       * @description The url of the server who hosts the assets and thumbs. Must be a string
       * @type {String}
       * @default ""
       */
      baselocation: "",
      /**
       * @name nixps-cloudflow.ListView#columns
       * @description The columns to show
       * @type {Array}
       */
      columns: ["thumb", "name", "filetype", "filepath", "approvals", "tags", "modtime"],
      orderBy: [],
      skip: 0,
      limit: 200,
      /**
       * @name nixps-cloudflow.ListView#stepSize
       * @description The amount of rows we must load for each time
       * @type {Number}
       * @default 200
       */
      stepSize: 200,
      /**
       * @name nixps-cloudflow.ListView#enableAssetDragging
       * @description Is the user allowed to drag assets to folders
       * @type {Boolean}
       * @default false
       */
      enableAssetDragging: false,
      /**
       * @name nixps-cloudflow.ListView#enableSelecting
       * @description Enable file and folder selection
       * @type {Boolean}
       * @default false
       */
      enableSelecting: false,
      /**
       * @name nixps-cloudflow.ListView#enableMultipleSelection
       * @description If enableSelection is set on true, are we allowed to select multiple files or can we only select one a time
       * @type {Boolean}
       * @default true
       */
      enableMultipleSelection: true,
      fastMultipleSelection: false,
      /**
       * @name nixps-cloudflow.ListView#deselectWhenRowClick
       * @description deselect other rows if we click on a not checkbox
       * @type {Boolean}
       * @default false
       */
      deselectWhenRowClick: false,
      /**
       * @name nixps-cloudflow.ListView#deselectable
       * @description Must we able to deselect files or folders?
       * @default false
       * @type {Boolean}
       */
      deselectable: false,
      /**
       * @name nixps-cloudflow.ListView#mayDrop
       * @description define if something may be copied or moved to that folder
       * @type {Funtion}
       * @param {Object} pFolder
       * @returns {Boolean}
       */
      mayDrop: function mayDrop(pFolder) {
        return pFolder !== undefined && pFolder.cloudflow !== undefined && pFolder.cloudflow.folder !== "cloudflow://";
      },
      /**
       * @name nixps-cloudflow.ListView#enableContextMenu
       * @description Must we enable the contextmenu
       * @type {Boolean}
       * @default false
       */
      enableContextMenu: false,
      /**
       * @name nixps-cloudflow.ListView#bodyClasses
       * @description The classes to be added to the table body
       * @type {String}
       * @default "cf-table-body-main"
       */
      bodyClasses: "cf-table-body-main"
    },
    _fileImageFormatter: function _fileImageFormatter(pFile, pOptions, pRow, pComumn, pRowIndex) {
      if (typeof pFile.thumb === "string" && pFile.thumb.length > 0) {
        return $("<img>").attr({
          "src": pFile.thumb,
          "loading": pRowIndex > 30 ? "lazy" : undefined
        }).on("error", this._imageErrorHandler.bind(this));
      } else if (typeof pFile.thumb_icon === "string") {
        return $("<span>").addClass(pFile.thumb_icon);
      }
    },
    _fileNameFormatter: function _fileNameFormatter(pValue) {
      if (typeof pValue === "string" && pValue.length > 0) {
        return $("<span>").text(pValue);
      }
    },
    _fileTypeFormatter: function _fileTypeFormatter(pValue) {
      if (pValue == null) {
        return $.i18n._("nixps-cloudflow-assets.filetype-unknown");
      } else {
        return get_descriptive_filetype(pValue + "");
      }
    },
    _fileSizeFormatter: function _fileSizeFormatter(pValue) {
      if (typeof pValue === "number") {
        return FileSizeUtils.toString(pValue);
      }
      return "";
    },
    _timeFormatter: function _timeFormatter(pValue) {
      if (pValue == null) {
        return "--";
      } else {
        return moment(pValue * 1000).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    _filePathFormatter: function _filePathFormatter(pValue) {
      if (typeof pValue === "string") {
        if (pValue.indexOf("cloudflow://") === 0) {
          return pValue.slice(12);
        }
        return pValue;
      }
      return "";
    },
    _approvalFormatter: function _approvalFormatter(pApprovalStatus) {
      var status = "";
      var previousApprovalBubbles = "";
      if (Array.isArray(pApprovalStatus) && pApprovalStatus.length > 0) {
        var currentStatusIndex;
        var assessmentStack = [];
        for (var assesmentIndex = 0; assesmentIndex < pApprovalStatus.length; ++assesmentIndex) {
          var checkAssessment = pApprovalStatus[pApprovalStatus.length - 1 - assesmentIndex].assessment;
          assessmentStack.unshift(checkAssessment); // save for later to show previous approvals
          if (status === "" && checkAssessment !== "cancel" || checkAssessment === "pending") {
            currentStatusIndex = assesmentIndex; // save to know the current position
            status = checkAssessment;
          }
        }
        // show the last ten approval statess
        if (pApprovalStatus.length > 1) {
          // remove current state, this will be showed anyway
          assessmentStack.splice(assessmentStack.length - 1 - currentStatusIndex, 1);
          // cut off, so we will only show the ten most recent approvals
          assessmentStack = assessmentStack.slice(-10);
          for (var i = 0; i < assessmentStack.length; i++) {
            previousApprovalBubbles += "<span class='previousbubble asset-" + assessmentStack[i] + "' ></span>";
          }
        }
      }
      if (status === "") {
        // nothing ...
      } else if (status === "reject") {
        return previousApprovalBubbles + "<div class='approval asset-rejected bubble' data-status='reject' style='cursor: pointer;'>" + $.i18n._('nixps-cloudflow-assets.status_rejected') + "</div>";
      } else if (status === "accept") {
        return previousApprovalBubbles + "<div class='approval asset-accepted bubble' data-status='accept' style='cursor: pointer;'>" + $.i18n._('nixps-cloudflow-assets.status_approved') + "</div>";
      } else {
        return previousApprovalBubbles + "<div class='approval asset-waiting bubble' data-status='waiting' style='cursor: pointer;'>" + $.i18n._('nixps-cloudflow-assets.status_waiting_approval') + "</div>";
      }
    },
    _tagFormatter: function _tagFormatter(p_value) {
      if (p_value === false) {
        // special case, disable all funcionality of tags
        return "";
      }
      var output = $("<span>").addClass("tagspanel");
      if (Array.isArray(p_value) && p_value.length > 0) {
        var tagCocon = $("<span>").addClass("cf-tag bubble");
        // add each tag to output stream
        for (var i = 0; i < p_value.length; i++) {
          output.append(tagCocon.clone(true).text(p_value[i]).attr("title", _.escape(p_value[i])));
        }
      }
      output.append($("<span>").addClass("addTagButton fa fa-plus"));
      return output;
    },
    _actionFormatter: function _actionFormatter(pFile /* pUrl */) {
      /** @todo add remove button with class "removeIcon" but not for parent folder!!
       * alsp add "data-url" parameter and a data-folder="true" parameter 
       * */
      if (typeof pFile === "string" && pFile.length > 0) {
        // folders do not have a file attribute
        //return '<span class="fa fa-fw fa-download downloadIcon" data-url="' + pFile + '" title="' + $.i18n._('nixps-cloudflow-assets.action-download_file') + '"> </span>';
        return '<span class="cf-icon cf-icon-download downloadIcon" data-url="' + pFile + '" title="' + $.i18n._('nixps-cloudflow-assets.action-download_file') + '"> </span>';
      }
    },
    _create: function _create() {
      if (typeof moment !== "function") {
        // for compatibility reasons it can be, that the moment plugin is not included, 
        // if moment is not there, create fallback for it
        window.moment = function (pDateNumber) {
          return {
            format: function format() {
              return new Date(pDateNumber).toLocaleString();
            }
          };
        };
        moment.locale = function () {};
        console.error("please include moment plugin");
      }
      this.alive = true;
      this._controlOptions();
      // make deep copy of arrays
      this.options.columns = this.options.columns.slice();
      this.options.orderBy = this.options.orderBy.slice();
      // diferent types for the table component
      this.additionalTypes = [{
        type: "fileimage",
        renderFunction: this._fileImageFormatter.bind(this)
      }, {
        type: "filename",
        renderFunction: this._fileNameFormatter.bind(this)
      }, {
        type: "filetype",
        renderFunction: this._fileTypeFormatter.bind(this)
      }, {
        type: "filesize",
        renderFunction: this._fileSizeFormatter.bind(this)
      }, {
        type: "approvals",
        renderFunction: this._approvalFormatter.bind(this)
      }, {
        type: "modtime",
        renderFunction: this._timeFormatter.bind(this)
      }, {
        type: "filepath",
        renderFunction: this._filePathFormatter.bind(this)
      }, {
        type: "tags",
        renderFunction: this._tagFormatter.bind(this)
      }, {
        type: "actions",
        renderFunction: this._actionFormatter.bind(this)
      }];
      this.disabledSorting = false;
      this.extraFolders = [];
      this.extraFiles = [];
      this.focussedElement;

      // The columns
      this.columnsDict = {
        selectCheckbox: {
          label: "",
          type: "selectCheckbox",
          key: ".",
          cellClass: "cf-tablecell-select-checkbox",
          headerClass: "cf-tablecell-select-checkbox",
          ignoreClickEvent: true
        },
        thumb: {
          label: "",
          type: "fileimage",
          key: ".",
          sortable: false,
          searchable: false,
          cellClass: "thumbCell"
        },
        name: {
          label: $("<span>").addClass("listviewtable_label_name cf-table-lineheight").css("display", "inline-block").text($.i18n._("nixps-cloudflow-assets.list_column-name")),
          type: "filename",
          key: "file_name",
          sortable: true,
          searchable: false,
          cellClass: "listview_fileName notranslate"
        },
        filetype: {
          label: $.i18n._("nixps-cloudflow-assets.list_column-filetype"),
          type: "filetype",
          key: "filetype",
          sortable: true,
          searchable: false
        },
        filesize: {
          label: $.i18n._("nixps-cloudflow-assets.list_column-filesize"),
          type: "filesize",
          key: "file_size",
          sortable: true,
          searchable: false
        },
        approvals: {
          label: $.i18n._("nixps-cloudflow-assets.list_column-approval"),
          type: "approvals",
          key: "approvals",
          sortable: false,
          searchable: false
        },
        modtime: {
          label: $.i18n._("nixps-cloudflow-assets.list_column-modtime"),
          type: "modtime",
          key: "modtime",
          sortable: true,
          searchable: false
        },
        filepath: {
          label: $.i18n._("nixps-cloudflow-assets.list_column-filepath"),
          type: "filepath",
          key: "cloudflow.enclosing_folder",
          sortable: true,
          searchable: false,
          cellClass: "listview_filePathName"
        },
        tags: {
          label: $.i18n._("nixps-cloudflow-assets.list_column-tags"),
          type: "tags",
          key: "tags",
          sortable: true,
          searchable: false
        },
        actions: {
          label: "",
          type: "actions",
          key: "cloudflow.file",
          sortable: false,
          searchable: false
        }
      };

      // Create our UI
      this.element.addClass(this.widgetFullName).empty().append($("<div>").addClass("asset_grid")).append($("<div>").addClass("bottombar").hide().append($("<button>").attr("type", "button").addClass("loadMore cf-button-secondary colored-button").text($.i18n._("nixps-cloudflow-assets.load_more_text"))));
      this._draw();
      this._on(this.element, {
        "tableclick": this._rowClickHandler,
        "tableselect": this._rowSelectHandler,
        "dblclick tr:not(.item_processing) td": this._dblclickRowHandler,
        "click .cf-tag": this._tagClickHandler,
        "click .addTagButton": this._addTagClickHandler,
        "click .approval": this._approvalClickHandler,
        "click tr:not(.item_processing) .downloadIcon": this._downloadIconClickHandler,
        "click button.loadMore": this._loadMoreClickHandler,
        "tabledataloaded": this._dataLoadedHandler,
        "tableimageloaderror": this._imageErrorHandler
      });
      if (this.options.enableContextMenu === true) {
        this._on(this.element, {
          "contextmenu tr:not(.item_processing)": this._rightClickHandler
        });
      }
    },
    /**
     * @description Function runs when user click on a row
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _rowClickHandler: function _rowClickHandler(pEvent, pData) {
      /** @todo make general action class to have a general skipping */
      if (!$(pEvent.originalEvent.target).hasClass("cf-tag") && !$(pEvent.originalEvent.target).hasClass("addTagButton") && !$(pEvent.originalEvent.target).hasClass("approval") && !$(pEvent.originalEvent.target).hasClass("downloadIcon") && !$(pEvent.originalEvent.target).hasClass("removeIcon") && !$(pEvent.originalEvent.target).closest("tr").hasClass("item_processing") && !(typeof $(pEvent.originalEvent.target).closest("tr").attr("id") === "string" && $(pEvent.originalEvent.target).closest("tr").attr("id").search("inmakingid") === 0)) {
        if (this.options.enableSelecting !== true) {
          this._trigger("open", pEvent.originalEvent, pData.rowObject);
        } else {
          if (this.options.deselectWhenRowClick === true && pData.rowObject.cloudflow.parent !== true) {
            this._trigger("select", null, {
              files: this.getSelectedItemData(),
              by: "click",
              row: pData.rowObject
            });

            //comment what is next for feature
            if (pEvent.metaKey !== true && pEvent.shiftKey !== true) {
              this.element.children(".asset_grid").Table("unselectAllRows").Table("selectRows", pData.rowObject._id, true);
            }
          }
        }
      }
    },
    _rowSelectHandler: function _rowSelectHandler(pEvent, pData) {
      this._trigger("select", null, {
        files: this.getSelectedItemData(),
        by: "click"
      });
      // do not stop event, needs for download, ...
    },

    /**
     * @description function runs when user double click on a table cell, and want to open folders
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _dblclickRowHandler: function _dblclickRowHandler(pEvent, pData) {
      if (this.options.enableSelecting === true) {
        if ($(pEvent.target).is("input, textarea, select")) {
          return;
        }
        var fileData = this.element.children(".nixps-cloudflow-Table").Table("getRowObject", $(pEvent.currentTarget));
        this._trigger("open", pEvent.event, fileData);
      }
    },
    /**
     * @description function runs when user click on a tag
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _tagClickHandler: function _tagClickHandler(pEvent, pData) {
      // when clicking on tags
      var tag = $(pEvent.currentTarget).text();
      this._trigger("search", null, {
        searchString: "tags:" + tag
      });
      pEvent.stopPropagation();
    },
    /**
     * @description user click on the add button of the tags, he want to edit the tags
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {Boolean}
     */
    _addTagClickHandler: function _addTagClickHandler(pEvent, pData) {
      var that = this;
      var row = $(pEvent.target).closest("tr");
      row.addClass("listview_row_hover"); // give the inpression that the row stays hovered or selected
      var rowID = row.attr("id"); // save the id of the row we are editing
      // get the object that is related to that file or folder
      var assetObject = this.element.children(".nixps-cloudflow-Table").Table("getRowObject", $(pEvent.target));
      if (assetObject !== undefined) {
        // disable scolling
        $("body").addClass("holdScroll");
        // create a panel and possition just under the button
        var proposedTop = pEvent.pageY + 17;
        var proposedLeft = pEvent.pageX - 175;
        var tags = $("<div>").addClass("cf-form cf-form-details cf-dialog cf-dialog-content cf-dialog-padding").css({
          position: "absolute",
          overflow: "visible",
          top: proposedTop,
          left: proposedLeft
        });
        // get the correct url to add and remove the tags
        var url = "";
        if (assetObject.filetype === "folder") {
          url = assetObject.cloudflow.folder;
        } else {
          url = assetObject.cloudflow.file;
        }
        // first create and add to body before creating tag component
        var tagsPanel = $("<div>").addClass("folderTagsPanel cf-overlay").append(tags);
        $("body").append(tagsPanel);
        tags.Tags({
          assetUrl: url,
          showEmptyText: true,
          drawed: function drawed(pEvent) {
            var screenHeight = $(document).height();
            if ($(this).outerHeight() + proposedTop > screenHeight) {
              $(this).css("top", screenHeight - $(this).outerHeight());
            }
            // add close button
            $(pEvent.target).append($("<span>").addClass("closeButton fa fa-times fa-lg cf-dialog-close"));
          },
          change: function change(pEvent, pData) {
            if ($.isEmptyObject(pData)) {
              throw new Error("pData must not be empty");
            }
            // put the table in sync with the changes
            // work with ids because the table can be updated and then the rows are gone ...
            if (pData.action === "remove") {
              that.element.find("tr#" + rowID).find('.tagspanel .cf-tag[title="' + pData.removedTag + '"]').remove();
            } else if (pData.action === "add") {
              that.element.find("tr#" + rowID).find(".tagspanel").prepend($("<span>").addClass("cf-tag bubble").text(pData.addedTag).attr("title", pData.addedTag));
            }
          }
        });

        // bind the quit event
        tagsPanel.on("click", this._closeTagsPanelClickHandler.bind(this));
      }
      pEvent.stopPropagation();
      return false;
    },
    /**
     * @description function runs when user want to quit the tags edit panel
     * @function
     * @private
     * @param {type} pEvent
     * @return {Boolean}
     */
    _closeTagsPanelClickHandler: function _closeTagsPanelClickHandler(pEvent) {
      // only remove if click comes form outsite the editpanel or come from the close button
      if ($(pEvent.target).closest(".closeButton").length === 1 || $(pEvent.target).closest(".nixps-cloudflow-Tags").length === 0) {
        this.element.find("tr.listview_row_hover").removeClass("listview_row_hover"); // disable the impression of hovering/ selection
        $("body .folderTagsPanel").remove(); // remove the tags edit panel
        $("body").removeClass("holdScroll"); // remove the style on the body for correct editing modal panel 
        pEvent.stopPropagation(); // do not inform other of internal actions
        return false;
      }
    },
    /**
     * @description Function runs when user click on a approval status
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _approvalClickHandler: function _approvalClickHandler(pEvent, pData) {
      // when clicking on approval bubles
      var status = $(pEvent.currentTarget).attr("data-status");
      this._trigger("search", null, {
        searchString: "status:" + status
      });
      pEvent.stopPropagation();
    },
    /**
     * @description Function runs when user click on the download icon
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _downloadIconClickHandler: function _downloadIconClickHandler(pEvent, pData) {
      // when clicking on download 
      var url = $(pEvent.currentTarget).attr("data-url");
      if (typeof url === "string" && url.length > 0) {
        location.href = this.options.baselocation + "/portal.cgi?asset=download_file&url=" + encodeURIComponent(url);
      }
      pEvent.preventDefault();
    },
    /**
     * @description function runs when user click on load more button. This will load more files and folders
     * @function
     * @private
     * @param {type} pEvent
     * @returns {undefined}
     */
    _loadMoreClickHandler: function _loadMoreClickHandler(pEvent) {
      $(pEvent.currentTarget).prop("disabled", true);
      // table will self adapt this.options.limit to a correct value.
      this.element.children(".asset_grid").Table("option", "maxRows", this.options.limit + this.options.stepSize);
      // scroll to bottom
      $("body").scrollTop($("body").height());
    },
    _dataLoadedHandler: function _dataLoadedHandler(pEvent, pData) {
      this._addInprocessClass();
      this._addDropablesAndDraggables();
      this._addSelectingClass();
      this._insertFocusAttr();
      if (typeof this.focussedElement === "string") {
        this.element.children(".nixps-cloudflow-Table").find("#" + this.focussedElement).focus();
        this.focussedElement = undefined;
      }
      this._trigger("refreshfinished", pEvent, {
        amount: pData.dataCount
      });
      pEvent.stopPropagation();
    },
    /**
     * @description function runs when original image could not been loaded
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _imageErrorHandler: function _imageErrorHandler(pEvent, pData) {
      if (this.alive === false) {
        // zombie
        return;
      }
      // get the data of the corresponding asset
      var assetData = this.element.children(".nixps-cloudflow-Table").Table("getRowObject", $(pEvent.originalEvent.target).closest("td"));
      // continue if we get a good filetype
      if (assetData !== undefined && typeof assetData.filetype === "string" && assetData.filetype.length > 0) {
        // get the current bad image url
        var wrongUrl = $(pEvent.originalEvent.target).attr("src");
        // get the dedicatate image for file type
        var suggestedUrl = Asset.getDedicatedFileIcon(assetData.filetype, 1);
        // reset the url to a dedicated url
        // if the new url is a string and if it differs from the old, to prevent etternal loops for ever!
        if (typeof suggestedUrl === "string" && wrongUrl !== suggestedUrl) {
          $(pEvent.originalEvent.target).attr("src", suggestedUrl);
        }
      }
    },
    /**
     * @description function runs when user right click/ contextmenu
     * @function
     * @param {type} pEvent
     * @param {type} pData
     * @returns {Boolean}
     */
    _rightClickHandler: function _rightClickHandler(pEvent, pData) {
      var itemData = this.element.children(".nixps-cloudflow-Table").Table("getRowObject", $(pEvent.target));
      if (itemData && !$.isEmptyObject(itemData.cloudflow) && itemData.cloudflow.parent !== true && itemData.site !== true) {
        var itemDomElement = $(pEvent.currentTarget);
        if (this.options.enableSelecting === true) {
          var isSelected = itemDomElement.hasClass("select");
          if (isSelected === false) {
            // there may be only one selection
            this.element.children(".nixps-cloudflow-Table").Table("unselectAllRows");
          }
          // add current row to selection
          this.element.children(".nixps-cloudflow-Table").Table("selectRows", itemData);
          this._trigger("select", null, {
            files: this.getSelectedItemData(),
            by: "click"
          });
        }
        if (typeof itemData.cloudflow.file === "string" && itemData.cloudflow.file.length > 0) {
          this._trigger("contextmenu", pEvent, {
            url: itemData.cloudflow.file,
            itemData: itemData,
            targetDOMElement: itemDomElement
          });
        } else if (typeof itemData.cloudflow.folder === "string" && itemData.cloudflow.folder.length > 0) {
          this._trigger("contextmenu", pEvent, {
            url: itemData.cloudflow.folder,
            itemData: itemData,
            targetDOMElement: itemDomElement
          });
        }
      }
      return false;
    },
    _draw: function _draw() {
      var columns = [];
      var sortByArray = [];
      for (var i = 0; i < this.options.columns.length; i++) {
        // update the columns array model
        columns.push(this.columnsDict[this.options.columns[i]]);
        // make init default sorting array
        if (Array.isArray(this.options.orderBy) && this.options.orderBy.length >= 2 && this.options.orderBy[0] === this.columnsDict[this.options.columns[i]].key) {
          sortByArray = [{
            column: this.options.orderBy[0],
            order: this.options.orderBy[1]
          }];
        }
      }
      if (sortByArray.length === 0 && Array.isArray(this.options.orderBy) && this.options.orderBy.length > 0) {
        // there is a orderBy option but we can not init because the colomn to order does not exists
        // so remove the option than. This will affect others because the array is given by reference, but they should also change!
        this.options.orderBy = [];
      }
      var selecting = null;
      if (this.options.enableSelecting === true) {
        selecting = {
          items: ".row_selectable",
          multiple: this.options.enableMultipleSelection,
          fastMultiple: this.options.fastMultipleSelection,
          selectClass: "select",
          deselectable: this.options.deselectable,
          handle: ""
        };
      }
      this.element.children(".asset_grid").empty().Table({
        additionalTypes: this.additionalTypes,
        columns: columns,
        maxRows: this.options.limit,
        keyUniqID: "_id",
        enableIDAttribute: true,
        editCellEvent: false,
        selecting: selecting,
        dataProvider: this._dataProvider.bind(this),
        dataExists: this._dataExists.bind(this),
        sort: sortByArray,
        classes: "cf-table cf-table-fullwidth",
        enableStickyHeader: true,
        stickyHeaderAppliedBy: "css",
        bodyClasses: this.options.bodyClasses
      });
      if (this.disabledSorting === true) {
        this.element.children(".asset_grid").Table("disableSorting");
      }
      var nameColumnIndex = this.options.columns.indexOf("name");
      if (nameColumnIndex >= 0) {
        this._delay(function () {
          this.element.children(".asset_grid.nixps-cloudflow-Table").children("table").children("thead").children("tr").children("th").eq(nameColumnIndex).not(".ui-resizable").resizable({
            handles: "e",
            start: function start(e) {
              e.stopPropagation();
            },
            resize: function resize(e, pData) {
              /*pData.element.css("height", "");
              pData.helper.css("height", "");
              pData.originalElement.css("height", "");
              var currentHeight = pData.element.closest("tr").height();
              pData.element.find(".listviewtable_label_name").height(currentHeight); */
              e.stopPropagation();
            },
            stop: function stop(e) {
              e.stopPropagation();
            }
          });
        }, 100);
      }
      if (Array.isArray(this.options.folders)) {
        for (var i = 0; i < this.options.folders.length; i++) {
          var tags = this.options.folders[i].tags;
          if (!Array.isArray(tags) || tags.length === 0) {
            continue;
          }
          var tagCocon = $("<span>").addClass("tag bubble");
          // add each tag to output stream
          var assetTagPanel = this.element.find("#tableRowID_" + this.options.folders[i]._id + " .tagspanel");
          for (var j = 0; j < tags.length; j++) {
            assetTagPanel.append(tagCocon.clone(true).text(tags[j]).attr("title", tags[j]));
          }
        }
      }
      if (Array.isArray(this.options.files)) {
        for (var i = 0; i < this.options.files.length; i++) {
          var tags = this.options.files[i].tags;
          if (!Array.isArray(tags) || tags.length === 0) {
            continue;
          }
          var tagCocon = $("<span>").addClass("cf-tag bubble");
          // add each tag to output stream
          var assetTagPanel = this.element.find("#tableRowID_" + this.options.files[i]._id + " .tagspanel");
          for (var j = 0; j < tags.length; j++) {
            assetTagPanel.append(tagCocon.clone(true).text(tags[j]).attr("title", tags[j]));
          }
        }
      }
    },
    moveSelected: function moveSelected(pEvent, pDirection) {
      this.element.children(".nixps-cloudflow-Table").Table("moveSelected", pEvent, pDirection);
      this._trigger("select", null, {
        files: this.getSelectedItemData(),
        by: "moveSelected"
      });
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRefresh = false;
      var needRedraw = false;
      var needTableOptionsChanged = false;
      this.focussedElement = undefined;
      if (options.columns !== undefined && _.isEqual(options.columns, this.options.columns) === false || options.orderBy !== undefined && _.isEqual(options.orderBy, this.options.orderBy) === false) {
        needRedraw = true;
      } else if (typeof options.limit === "number" && options.limit !== this.options.limit) {
        needTableOptionsChanged = true;
      } else if (typeof options.enableSelecting === "boolean" && options.enableSelecting !== this.options.enableSelecting) {
        needTableOptionsChanged = true;
      } else if (typeof options.fastMultipleSelection === "boolean" && options.fastMultipleSelection !== this.options.fastMultipleSelection) {
        needTableOptionsChanged = true;
      } else if (typeof options.enableMultipleSelection === "boolean" && options.enableMultipleSelection !== this.options.enableMultipleSelection) {
        needTableOptionsChanged = true;
      }
      if (needRedraw === false) {
        // only check if not redraw
        if (options.folders !== undefined && _.isEqual(options.folders, this.options.folders) === false) {
          needRefresh = true;
        } else if (options.files !== undefined && _.isEqual(options.files, this.options.files) === false) {
          needRefresh = true;
        }
      }
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      this._controlOptions();
      var rowFocus = $(document.activeElement);
      if (rowFocus.length === 1 && rowFocus.is("tr[id^=tableRowID]") && rowIDRegExpr.test(rowFocus.attr("id"))) {
        this.focussedElement = rowFocus.attr("id");
      }
      if (needRedraw === true) {
        // complete redraw is needed
        this._draw();
        this.element.children(".bottombar").find("button.loadMore").prop("disabled", false);
      } else if (needTableOptionsChanged === true) {
        var tableOptions = {};
        if (options.limit !== undefined) {
          tableOptions.maxRows = options.limit;
        }
        if (options.enableSelecting !== undefined || options.enableMultipleSelection !== undefined) {
          tableOptions.selecting = {
            items: "tr",
            multiple: this.options.enableMultipleSelection,
            fastMultiple: this.options.fastMultipleSelection,
            selectClass: "select",
            deselectable: this.options.deselectable
          };
        }
        // this will trigger redraw in the table
        this.element.children(".nixps-cloudflow-Table").Table("option", tableOptions);
        this.element.children(".bottombar").find("button.loadMore").prop("disabled", false);
      } else if (needRefresh === true) {
        // only change the internal rows
        this.element.children(".nixps-cloudflow-Table").Table("refreshData", null, true);
        this.element.children(".bottombar").find("button.loadMore").prop("disabled", false);
      } else if (options.files !== undefined || options.folders !== undefined) {
        // files and folders came in, but no refresh needed
        // inform parent to (re)start refresh timer
        this._trigger("refreshfinished", null, {
          amount: (options.files !== undefined ? options.files.length : 0) + (options.folders !== undefined ? options.folders.length : 0)
        });
      }
    },
    _setOption: function _setOption(p_key, p_value) {
      this._super(p_key, p_value);
    },
    changeOptionsSilence: function changeOptionsSilence(options) {
      var that = this;
      var needTableOptions = {};
      if (options.limit !== undefined && options.limit !== this.options.limit) {
        needTableOptions.maxRows = options.limit;
      } else if (typeof options.enableSelecting === "boolean" && options.enableSelecting !== this.options.enableSelecting) {} else if (Array.isArray(options.orderBy)) {
        options.orderBy = options.orderBy.slice();
        if (options.orderBy.length === 2) {
          var keys = this.options.columns.map(function (pColumnName) {
            if (that.columnsDict[pColumnName] !== undefined) {
              return that.columnsDict[pColumnName].key;
            }
          });
          if (keys.includes(options.orderBy[0])) {
            needTableOptions.sort = [{
              column: options.orderBy[0],
              order: options.orderBy[1]
            }];
          }
        } else {
          needTableOptions.sort = [];
        }
      }
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      if ($.isEmptyObject(needTableOptions) === false) {
        this.element.children(".nixps-cloudflow-Table").Table("changeOptionsSilence", needTableOptions);
      }
    },
    /**
     * @description control the input options of the component
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (!Array.isArray(this.options.columns)) {
        throw new Error("input option columns must be an array");
      }
      if (!Array.isArray(this.options.orderBy)) {
        throw new Error("input option orderBy must be an array");
      }
      this.options.orderBy = this.options.orderBy.slice();
      if (typeof this.options.stepSize !== "number" || this.options.stepSize <= 0) {
        throw new Error("input option stepSize must be a positive number");
      }
      if (typeof this.options.baselocation !== "string") {
        throw new Error("input option baselocation must be a string");
      }
      if (typeof this.options.enableSelecting !== "boolean") {
        throw new Error("input option enableSelecting must be a boolean");
      }
      if (typeof this.options.enableMultipleSelection !== "boolean") {
        throw new Error("input option enableMultipleSelection must be a boolean");
      }
      if (typeof this.options.deselectable !== "boolean") {
        throw new Error("input option deselectable must be a boolean");
      }
    },
    /**
     * @description The dataprovider function used by the component table
     * @function
     * @private
     * @param {type} pQuery
     * @param {type} pOrderBy
     * @param {type} pSkip
     * @param {type} pLimit
     * @returns {Array.<Object>}
     */
    _dataProvider: function _dataProvider(pQuery, pOrderBy, pSkip, pLimit) {
      if (_.isEqual(pOrderBy, this.options.orderBy) === false || pSkip !== this.options.skip || pLimit !== this.options.limit + 1) {
        if (Array.isArray(pOrderBy) && pOrderBy.length >= 2) {
          this.options.orderBy = pOrderBy;
        }
        this.options.skip = pSkip;
        this.options.limit = pLimit - 1;
        this._trigger("dataprovider", null, {
          orderBy: this.options.orderBy,
          skip: this.options.skip,
          limit: this.options.limit + 1
        });
      }
      var rows = [];
      var showMoreButton = false;
      if (Array.isArray(this.options.files) && this.options.files.length > this.options.limit) {
        showMoreButton = true;
        this.options.files = this.options.files.slice(0, this.options.limit - this.options.files.length);
      }
      if (Array.isArray(this.options.folders) && this.options.folders.length > this.options.limit) {
        showMoreButton = true;
        this.options.folders = this.options.folders.slice(0, this.options.limit - this.options.folders.length);
      }
      if (Array.isArray(pOrderBy) && pOrderBy.length >= 2) {
        // put in correct order
        if (pOrderBy[0] === "tags") {
          rows = this._sortRows(this._translateFiles(this.options.files), pOrderBy[0], pOrderBy[1]).concat(this._translateFolder(this.options.folders));
        } else if (["filetype", "cloudflow.enclosing_folder"].includes(pOrderBy[0])) {
          rows = this._translateFolder(this.options.folders).concat(this._translateFiles(this.options.files));
          rows = this._sortRows(rows, pOrderBy[0], pOrderBy[1]);
        } else if (["modtime"].includes(pOrderBy[0])) {
          rows = this._translateFiles(this.options.files).concat(this._translateFolder(this.options.folders));
        } else {
          rows = this._translateFolder(this.options.folders).concat(this._translateFiles(this.options.files));
        }
      } else {
        rows = this._translateFolder(this.options.folders).concat(this._translateFiles(this.options.files));
      }
      if (this.extraFolders.length > 0) {
        rows = rows.concat(this.extraFolders);
        this.options.folders = this.options.folders.concat(this.extraFolders);
        this.extraFolders = [];
      }
      if (this.extraFiles.length > 0) {
        rows = rows.concat(this.extraFiles);
        this.options.files = this.options.files.concat(this.extraFiles);
        this.extraFiles = [];
      }
      this.element.children(".bottombar").toggle(showMoreButton);
      if (showMoreButton) {
        // we handle the load more and too much our self, 
        // add empty object, so table will remove it when detecting overflow, 
        // so it do not removes usefull asset/folder
        rows.push({});
      }
      return rows;
    },
    /**
     * @description check if the selected items still exists
     * @function
     * @private
     * @name nixps-cloudflow.ListView#_dataExists
     * @param {Array<String>} pSelectedRowIDs 
     */
    _dataExists: function _dataExists(pSelectedRowIDs) {
      var existingRows = [];
      if (Array.isArray(pSelectedRowIDs) && pSelectedRowIDs.length > 0) {
        var fileIDs = [];
        if (Array.isArray(this.options.files)) {
          fileIDs = [];
          for (var i = 0; i < this.options.files.length; i++) {
            fileIDs.push(this.options.files[i]._id);
          }
        }
        var folderIDs = [];
        if (Array.isArray(this.options.folders)) {
          folderIDs = [];
          for (var i = 0; i < this.options.folders.length; i++) {
            folderIDs.push(this.options.folders[i]._id);
          }
        }
        for (var i = 0; i < pSelectedRowIDs.length; i++) {
          // not needed to return object because the data didn't change
          if (fileIDs.indexOf(pSelectedRowIDs[i]) > -1) {
            existingRows.push(pSelectedRowIDs[i]);
          } else if (folderIDs.indexOf(pSelectedRowIDs[i]) > -1) {
            existingRows.push(pSelectedRowIDs[i]);
          }
        }
      }
      return existingRows;
    },
    /**
     * @description Make table objects of folder option object
     * @function
     * @private
     * @returns {Array} table objects
     */
    _translateFolder: function _translateFolder(pFolders) {
      var outputRows = [];
      // Convert the folder entries to a file-style entry and add it to the list
      if (Array.isArray(pFolders) && pFolders.length > 0) {
        for (var i = 0; i < pFolders.length; i++) {
          var folderEntry = $.extend({}, pFolders[i]);
          folderEntry.filetype = "folder";
          folderEntry.approvalTranslatedStatus = null;
          folderEntry.file_name = pFolders[i].name;
          folderEntry.file_size = pFolders[i].size;
          if (pFolders[i].site === true) {
            if (pFolders[i].parent === true) {
              folderEntry.file_name = $.i18n._("nixps-cloudflow-assets.parentsite");
              folderEntry.thumb_icon = "cf-icon cf-icon-site-up";
            } else {
              folderEntry.thumb_icon = "cf-icon cf-icon-site";
            }
            folderEntry.tags = false;
          } else if (pFolders[i].cloudflow.enclosing_folder === "") {
            folderEntry.thumb_icon = "cf-icon cf-icon-filestore";
          } else if (pFolders[i].cloudflow.parent === true) {
            folderEntry.thumb_icon = "cf-icon cf-icon-folder-chevron-up-filled";
            folderEntry.file_name = $.i18n._("nixps-cloudflow-assets.parentfolder");
          } else if (pFolders[i].cloudflow.recyclebin) {
            folderEntry.thumb_icon = "cf-icon cf-icon-trash";
            folderEntry.file_name = $.i18n._("nixps-cloudflow-assets.recyclebin");
          } else {
            folderEntry.thumb_icon = "cf-icon cf-icon-folder-filled";
          }
          outputRows.push(folderEntry);
        }
      }
      return outputRows;
    },
    /**
     * @description Make table objects of files option object
     * @function
     * @private
     * @returns {Array} table objects
     */
    _translateFiles: function _translateFiles(pFiles) {
      var outputRows = [];
      if (Array.isArray(pFiles) && pFiles.length > 0) {
        for (var i = 0; i < pFiles.length; i++) {
          var fileEntry = $.extend({}, pFiles[i]);
          if (typeof pFiles[i].thumb !== "string" || pFiles[i].thumb.length <= 0) {
            fileEntry.thumb_icon = Asset.getDedicatedFileIcon(fileEntry.filetype, 1);
          } else {
            fileEntry.thumb = this.options.baselocation + fileEntry.thumb;
          }
          outputRows.push(fileEntry);
        }
      }
      return outputRows;
    },
    /**
     * @description Sorting function to sort in frontend
     * @function
     * @private
     * @param {array} pRows - the array to be sorted
     * @param {string} p_field - field/key name to be sort on
     * @param {string} pAscending "ascending" or "descending"
     * @returns {unresolved}
     */
    _sortRows: function _sortRows(pRows, p_field, pAscending) {
      var p_ascending = pAscending === "ascending" ? true : false;
      function sortFileName(a, b) {
        var result = 0;
        if (a.file_name === undefined) {
          return -1;
        } else if (b.file_name === undefined) {
          return 1;
        } else {
          result = a.file_name.localeCompare(b.file_name);
        }
        return p_ascending ? result : -result; // rechange to force always ascending
      }

      if (p_field === "cloudflow.enclosing_folder") {
        pRows.sort(function (a, b) {
          var result = 0;
          if (a.cloudflow.enclosing_folder == undefined) {
            return -1;
          } else if (b.cloudflow.enclosing_folder == undefined) {
            return 1;
          } else {
            result = a.cloudflow.enclosing_folder > b.cloudflow.enclosing_folder ? 1 : a.cloudflow.enclosing_folder < b.cloudflow.enclosing_folder ? -1 : sortFileName(a, b);
          }
          return p_ascending ? result : -result;
        });
      } else {
        pRows.sort(function (a, b) {
          var result = 0;
          if (a[p_field] == undefined) {
            return -1;
          } else if (b[p_field] == undefined) {
            return 1;
          } else {
            result = a[p_field] > b[p_field] ? 1 : a[p_field] < b[p_field] ? -1 : sortFileName(a, b);
          }
          return p_ascending ? result : -result;
        });
      }
      return pRows;
    },
    appendFolders: function appendFolders(pFolders) {
      if (Array.isArray(pFolders) && pFolders.length > 0) {
        this.extraFolders = this.extraFolders.concat(this._translateFolder(pFolders));
        this._draw();
      }
    },
    appendFiles: function appendFiles(pFiles) {
      if (Array.isArray(pFiles) && pFiles.length > 0) {
        this.extraFiles = this.extraFiles.concat(this._translateFiles(pFiles));
        this._draw();
      }
    },
    _addInprocessClass: function _addInprocessClass() {
      this.element.children(".nixps-cloudflow-Table").children("table").children("tbody").children("[id^=tableRowID_inmakingid_]").addClass("item_processing");
    },
    _addSelectingClass: function _addSelectingClass() {
      if (this.options.enableSelecting === true) {
        this.element.children(".nixps-cloudflow-Table").children("table").children("tbody").children("tr:not([id^=tableRowID_inmakingid])").each(function () {
          var rowID = $(this).attr("id");
          if (typeof rowID === "string" && rowID !== "tableRowID_undefined") {
            $(this).addClass("row_selectable");
          }
        });
      }
    },
    _addDropablesAndDraggables: function _addDropablesAndDraggables() {
      // control if we can and may dragging assets
      if (this.options.enableAssetDragging !== true || !Array.isArray(this.options.folders) || this.options.folders.length === 0) {
        // continou only if allowed and if there are folders
        return false;
      }
      var that = this;
      // make folder id array
      var folderIDs = [];
      var folderMayNotDrop = {};
      var folderID;
      for (var i = 0; i < this.options.folders.length; i++) {
        // save _id;
        if (this.options.folders[i]._id === undefined) {
          folderID = "tableRowID_undefined";
        } else {
          folderID = "tableRowID_" + this.options.folders[i]._id;
        }
        // save ids in array
        if (this.options.mayDrop(this.options.folders[i])) {
          // add id to array
          folderIDs.push(folderID);
        } else {
          // save the id of forbidden folders
          folderMayNotDrop[folderID] = 1;
        }
      }
      // put draggings and droppingss
      this.element.children(".nixps-cloudflow-Table").children("table").children("tbody").children("tr:not([id^=tableRowID_inmakingid])").each(function () {
        var rowID = $(this).attr("id");
        if (typeof rowID === "string" && folderMayNotDrop[rowID] === undefined) {
          if (rowID === undefined) {
            rowID = "tableRowID_undefined";
          }
          // continue only if known and allowed
          if (folderIDs.indexOf(rowID) >= 0) {
            // is folder
            $(this).droppable({
              accept: "tr",
              hoverClass: "ui-droppable-hover",
              "tolerance": "pointer"
            });
          } else {
            var helper = "clone";
            if (that.options.enableSelecting && that.options.enableMultipleSelection) {
              helper = that._draggableHelper.bind(that);
            }
            // is file
            $(this).draggable({
              helper: helper,
              opacity: 0.85,
              revert: "invalid",
              cursor: "move",
              drag: function drag(pEvent, pUI) {
                if (pEvent.metaKey) {
                  $(pUI.helper).addClass("help_dragging_copy");
                } else {
                  $(pUI.helper).removeClass("help_dragging_copy");
                }
              }
            });
          }
        }
      });
    },
    _draggableHelper: function _draggableHelper(pEvent) {
      var currentRow = $(pEvent.currentTarget);
      var items = [currentRow.data("dataitem")];
      var isRowSelected = currentRow.hasClass("select");
      if (isRowSelected) {
        var otherRows = this.element.children(".nixps-cloudflow-Table").children("table").children("tbody").children("tr.select").not(currentRow).each(function () {
          items.push($(this).data("dataitem"));
        }).clone().removeAttr("id");
      }
      var container = $("<div>").addClass("multipleDraggableHelperContainer").data("items", items);
      container.append(currentRow.clone().removeAttr("id"));
      if (isRowSelected) {
        container.append(otherRows);
      }
      return container;
    },
    /**
     * @description Insert an dedicated focus attribute tab index
     * @function
     * @name nixps-cloudflow.ListView#_insertFocusAttr
     * @private
     */
    _insertFocusAttr: function _insertFocusAttr() {
      if (this.options.enableSelecting === true) {
        this.element.children(".nixps-cloudflow-Table").children("table").children("tbody").children("tr").attr("tabindex", -1).addClass("remove_focus_blue");
      }
    },
    disableSorting: function disableSorting() {
      this.disabledSorting = true;
      this.element.children(".nixps-cloudflow-Table").Table("disableSorting");
    },
    enableSorting: function enableSorting() {
      this.disabledSorting = false;
      this.element.children(".nixps-cloudflow-Table").Table("enableSorting");
    },
    /**
     * @description Get all data of all assets who are selected
     * @function
     * @name nixps-cloudflow.ListView#getSelectedItemData
     * @return {array} containing data of all selected assests
     */
    getSelectedItemData: function getSelectedItemData() {
      var selectedRows = this.element.children(".nixps-cloudflow-Table").Table("getSelectedRows");
      if (Array.isArray(selectedRows)) {
        var foundParent = false;
        for (var i = 0; i < selectedRows.length; i++) {
          if (selectedRows[i].cloudflow !== undefined && selectedRows[i].cloudflow.parent === true) {
            foundParent = true;
            break;
          }
        }
        if (foundParent === false) {
          var selectedParent = this.element.find("#tableRowID_undefined.select");
          if (selectedParent.length > 0) {
            var parentData = this.element.children(".nixps-cloudflow-Table").Table("getRowObject", selectedParent);
            if ($.isPlainObject(parentData)) {
              selectedRows.unshift(parentData);
            }
          }
        }
      }
      return selectedRows;
    },
    /**
     * @description Select the first file where the filename match
     * @function
     * @name nixps-cloudflow.ListView#selectItems
     * @param {Array} a regular expression were filename must pass
     * @return {undefined}
     */
    selectItems: function selectItems(pFiles) {
      var that = this;
      if (Array.isArray(pFiles) && pFiles.length > 0) {
        this.element.children(".nixps-cloudflow-Table").find("tr.select").removeClass("select");
        if (typeof pFiles[0] === "string") {
          // all arguments are strings
          this.element.find(".listview_fileName").children().each(function () {
            var fileName = $(this).text();
            if (pFiles.indexOf(fileName) >= 0) {
              $(this).closest("tr").addClass("select");
              var rowObject = that.element.children(".nixps-cloudflow-Table").Table("getRowObject", $(this).closest("tr"));
              that.element.children(".nixps-cloudflow-Table").Table("selectRows", [rowObject]);
            }
          });
        } else {
          // all arguments are objects
          this.element.children(".nixps-cloudflow-Table").Table("unselectAllRows");
          this.element.children(".nixps-cloudflow-Table").Table("selectRows", pFiles);
        }
      }
    },
    selectAll: function selectAll() {
      var ids = [];
      this.element.children(".nixps-cloudflow-Table").children("table").children("tbody").children("tr:not([id^=tableRowID_inmakingid])").each(function () {
        var attrID = $(this).attr("id");
        if (typeof attrID === "string" && attrID.length > 0) {
          var id = attrID.substring(11); // length tableRowID_
          if (id !== "undefined") {
            // not selecting parent icon
            ids.push(id);
          }
        }
      });
      this.element.children(".nixps-cloudflow-Table").Table("selectRows", ids);
    },
    selectByTyping: function selectByTyping(pSearchString) {
      var found = false;
      var foundRow;
      var _iterator = _createForOfIteratorHelper(this.options.folders),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pFolder = _step.value;
          if (found) {
            break;
          }
          if (pFolder.name !== undefined && pFolder.name.toLowerCase().startsWith(pSearchString) === true) {
            foundRow = pFolder;
            found = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (foundRow === undefined) {
        var _iterator2 = _createForOfIteratorHelper(this.options.files),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var pFile = _step2.value;
            if (found) {
              break;
            }
            if (pFile.file_name !== undefined && pFile.file_name.toLowerCase().startsWith(pSearchString) === true) {
              foundRow = pFile;
              found = true;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      if (foundRow !== undefined) {
        this.element.children(".nixps-cloudflow-Table").Table("unselectAllRows");
        this.element.children(".nixps-cloudflow-Table").Table("selectRows", foundRow._id);
        // this.element.find("[id=tableRowID_" + foundRow._id + "]")[0].scrollIntoView(true);
        this._trigger("selectbytypingfinished", null, {
          element: this.element.find("[id=tableRowID_" + foundRow._id + "]")
        });
      }
    },
    unselectAll: function unselectAll() {
      this.element.children(".nixps-cloudflow-Table").Table("unselectAllRows");
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.widgetFullName);
      this._super();
    }
  });
})(jQuery);

},{"../../../cloudflow/CloudflowUtil/js/FileSizeUtils.js":88,"../../../nebulaportal/js/assetview/Asset.js":402,"../../Table/js/nixps-cloudflow-Table.js":218}],182:[function(require,module,exports){
"use strict";

(function ($) {
  "use strict";

  // remove other existing deprecated widgets
  if ($.fn["ManageProjects"] !== undefined) {
    $.fn["ManageProjects"] = undefined;
    $["nixps-cloudflow"]["ManageProjects"] = undefined;
  }
  require("../../Table/js/nixps-cloudflow-PreConfiguredTable.js");

  /**
   * @namespace nixps-cloudflow.EditUser
   * @description show a panel to edit a user
   * @version 1.0.0
   */
  $.widget("nixps-cloudflow.ManageProjects", $["nixps-cloudflow"].PreConfiguredTable, {
    version: "1.0.0",
    widgetEventPrefix: "manageprojects",
    options: {
      /**
       * @description The language of the user
       * @name nixps-cloudflow.ManageProjects#language
       * @type {string}
       * @default "en"
       * @example "nl"
       */
      language: "en",
      /**
       * @description The user object. If you have an user? give this to speed up page.
       * @name nixps-cloudflow.ManageProjects#user
       * @type {User}
       * @default null
       */
      user: null,
      /**
       * @description The delay in miliseconds between two refreshes.
       * @name nixps-cloudflow.ManageProjects#refreshDelay
       * @type {number}
       * @default 10000
       */
      refreshDelay: 10000,
      collection: "nucleus.job",
      /**
       * @description Show the blue Activity Bar. It this option is set on false the option {@link nixps-cloudflow.ManageProjects#showCreateJobButton} will be ignored. 
       * @name nixps-cloudflow.ManageProjects#showActivityBar
       * @type {string}
       * @default true
       * @deprecated
       */

      /**
       * @description Must we show the "Create new job" button or not? It option is only valid if option {@link nixps-cloudflow.ManageProjects#showActivityBar} is set on true
       * @name nixps-cloudflow.ManageProjects#showCreateJobButton
       * @type {Boolean}
       * @default true
       * @deprecated
       */

      /**
       * @description The options for the list component. See documentation of {@link nixps-cloudflow.ProjectList} component
       * @name nixps-cloudflow.ManageProjects#listOptions
       * @type {object}
       * @default undefined,
       * @desprecated
       */

      extraQuery: null,
      tableOptions: null,
      enableUserConfig: null,
      rowConditionalStyling: null,
      hideOtherCollapsibles: null,
      optimizeForContent: null,
      topbarbuttons: null,
      /**
       * @name nixps-cloudflow.ManageProjects#enableCollapsible
       * @description If this options is set on true, we will prepend a collapsble column 
       * @type {Boolean}
       * @default false
       */
      enableCollapsible: false,
      /**
       * @name nixps-cloudflow.ManageProjects#collapsibleContent
       * @description Get the information to build a collapseble
       * @type {Object}
       * @default {}
       */
      collapsibleContent: {
        options: {}
      },
      /**
       * @description The path to be used if the url is relative. This must be set on root, to prevent overwriting by deep copies.
       * This option will be given to custom_panel compontent
       * @name nixps-cloudflow.ManageProjects#relativeBasePath
       * @private
       * @type {string}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.ManageProjects#usePreviousSettings
       * @description Must we save the user settings to the preferences and retrieve it later on to set it up like the last time
       * @type {Boolean}
       * @default true
       */
      usePreviousSettings: true,
      /**
       * @name nixps-cloudflow.ManageProjects#context
       * @description A context string to specify the preferences, so to retrieve the preference that corresponds to the same context
       * @type {string}
       * @default ""
       */
      context: "",
      /**
       * @name nixps-cloudflow.ManageProjects#pagebuilderStyleType
       * @description The type of pagebuilder table style
       * @default ""
       * @type "{String}" 
       * @private
       */
      pagebuilderStyleType: "",
      created: function created() {}
    },
    _create: function _create() {
      if (typeof window._ !== "function") {
        throw new Error("ManageProjects: requires 3rdParty underscore.js");
      }
      this.element.addClass(this.widgetFullName).addClass("nixps-cloudflow-ProjectList") // backward compatible with event bubbling check
      .attr("data-uuid", this.uuid);
      var newOptionNames = [];
      var oldOptionNames = ["startnew", "viewdetails", "showActivityBar", "showCreateJobButton"];
      var changes = [];
      if (this.options.usePreviousSettings === true) {
        this.savePreferences = _.debounce(this._saveCurrentViewState.bind(this), 1000);
        this.context = this.options.context;
        if (this.context === "") {
          if (window.location.search == "") {
            this.context = "default";
          } else {
            this.context = window.location.search.replace(/\W+/g, "");
          }
        }
      } else {
        this.savePreferences = function () {};
      }
      if (this.options.tableOptions === null && $.isPlainObject(this.options.listOptions)) {
        if (this.options.extraQuery === null) {
          if (Array.isArray(this.options.listOptions.extraQuery)) {
            this.options.extraQuery = this.options.listOptions.extraQuery;
            changes.push({
              old: "listOptions.extraQuery",
              "new": "extraQuery"
            });
          } else {
            this.options.extraQuery = [];
          }
          newOptionNames.push("extraQuery");
        }
        if (this.options.configID === null && typeof this.options.listOptions.configID === "string") {
          this.options.configID = this.options.listOptions.configID;
          changes.push({
            old: "listOptions.configID",
            "new": "configID"
          });
          newOptionNames.push("configID");
        }
        if (this.options.enableUserConfig === null) {
          if (typeof this.options.listOptions.enableUserConfig === "boolean") {
            this.options.enableUserConfig = this.options.listOptions.enableUserConfig;
            changes.push({
              old: "listOptions.enableUserConfig",
              "new": "enableUserConfig"
            });
          } else {
            this.options.enableUserConfig = false;
          }
          newOptionNames.push("enableUserConfig");
        }
        if (this.options.rowConditionalStyling === null) {
          if (Array.isArray(this.options.listOptions.rowConditionalStyling)) {
            this.options.rowConditionalStyling = this.options.listOptions.rowConditionalStyling;
            changes.push({
              old: "listOptions.rowConditionalStyling",
              "new": "rowConditionalStyling"
            });
          } else {
            this.options.rowConditionalStyling = [];
          }
          newOptionNames.push("rowConditionalStyling");
        }
        if (this.options.hideOtherCollapsibles === null) {
          if (typeof this.options.listOptions.hideOtherCollapsibles === "boolean") {
            this.options.hideOtherCollapsibles = this.options.listOptions.hideOtherCollapsibles;
            changes.push({
              old: "listOptions.hideOtherCollapsibles",
              "new": "hideOtherCollapsibles"
            });
          } else {
            this.options.hideOtherCollapsibles = false;
          }
          newOptionNames.push("hideOtherCollapsibles");
        }
        if (this.options.optimizeForContent === null) {
          if (typeof this.options.listOptions.optimizeForContent === "boolean") {
            this.options.optimizeForContent = this.options.listOptions.optimizeForContent;
            changes.push({
              old: "listOptions.optimizeForContent",
              "new": "optimizeForContent"
            });
          } else {
            this.options.optimizeForContent = true;
          }
          newOptionNames.push("optimizeForContent");
        }
        if (this.options.topbarbuttons === null) {
          if (Array.isArray(this.options.listOptions.topbarbuttons)) {
            this.options.topbarbuttons = this.options.listOptions.topbarbuttons;
            changes.push({
              old: "listOptions.topbarbuttons",
              "new": "topbarbuttons"
            });
          } else {
            this.options.topbarbuttons = [];
          }
          newOptionNames.push("topbarbuttons");
        }
      }
      this.needSupportProjectListEvents = false;
      if ($.isPlainObject(this.options.listOptions) && this.options.listOptions.includeActionNameInEventName === true) {
        // old event handlings
        this.needSupportProjectListEvents = true;
      }
      var oldOptions = false;
      if (this.options.tableOptions === null) {
        if ($.isPlainObject(this.options.listOptions)) {
          oldOptions = true;
          this.options.tableOptions = {};
          if (Array.isArray(this.options.listOptions.defaultOrderBy)) {
            this.options.tableOptions.sort = $.extend([], this.options.listOptions.defaultOrderBy);
            changes.push({
              old: "listOptions.defaultOrderBy",
              "new": "tableOptions.sort"
            });
          }
          delete this.options.listOptions.defaultOrderBy;
          delete this.options.listOptions.extraQuery;
          delete this.options.listOptions.configID;
          delete this.options.listOptions.classes;
          delete this.options.listOptions.enableUserConfig;
          delete this.options.listOptions.rowConditionalStyling;
          delete this.options.listOptions.hideOtherCollapsibles;
          delete this.options.listOptions.optimizeForContent;
          delete this.options.listOptions.topbarbuttons;
          delete this.options.listOptions.includeActionNameInEventName;
          delete this.options.listOptions.style_type;
          this.options.tableOptions = $.extend(true, this.options.tableOptions, this.options.listOptions);
          changes.push({
            old: "listOptions",
            "new": "tableOptions"
          });
        } else {
          // default
          this.options.tableOptions = {};
        }
        newOptionNames.push("tableOptions");
        oldOptionNames.push("listOptions");
      }
      if (oldOptions === true) {
        this._on(this.element, {
          "projectsetstatechange": this._projectSetStateChangeHandler
        });
      }
      if (this.options.extraQuery === null) {
        this.options.extraQuery = [];
      }
      if (this.options.enableUserConfig === null) {
        this.options.enableUserConfig = false;
      }
      if (this.options.rowConditionalStyling === null) {
        this.options.rowConditionalStyling = [];
      }
      if (this.options.hideOtherCollapsibles === null) {
        this.options.hideOtherCollapsibles = false;
      }
      if (this.options.optimizeForContent === null) {
        this.options.optimizeForContent = true;
      }
      if (this.options.topbarbuttons === null) {
        this.options.topbarbuttons = [];
      }
      if ($.isPlainObject(this.options.tableOptions)) {
        this.options.tableOptions.keyUniqID = "_id";
      }
      this._super();
      if (oldOptions === true) {
        this._delay(function () {
          if (this.dead === true) {
            return; // do nothing if component is gone ...
          }

          this.element.trigger("nixpscustomchangeoptions", {
            options: this.options,
            newOptionNames: newOptionNames,
            oldOptionNames: oldOptionNames,
            triggerNameChanges: [{
              old_componentname: "ProjectList",
              new_componentname: "ManageProjects"
            }],
            changes: changes
          });
        });
      }
    },
    _tableDataLoadedHandler: function _tableDataLoadedHandler(pEvent, pData) {
      this._superApply(arguments);
      this.savePreferences();
    },
    _projectSetStateChangeHandler: function _projectSetStateChangeHandler(pEvent, pData) {
      // only handle event of this table
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      this.refresh("open_en_refresh", true);
    },
    _actionClickHandler: function _actionClickHandler(pEvent, pData, pAction, pKeyName) {
      if ($.isEmptyObject(pData.rowObject) || typeof pData.rowObject._id !== "string" || pData.rowObject._id.length <= 0) {
        throw new Error("ManageProjects: invalid data, _id is missing");
      }
      if (typeof pAction !== "string" || pAction.length <= 0) {
        throw new Error("ManageProjects: invalid data, action is missing");
      }
      switch (pAction) {
        case "remove":
          // user want to remove
          this._deleteRowObject(pData.rowObject._id, pData.rowObject);
          break;
        case "view":
          // user want to see details
          this._trigger("viewdetails", pEvent, {
            "id": pData.rowObject._id,
            "rowObject": pData.rowObject
          });
          break;
        case "_settings_mobile":
          // function is in parent
          this._showMobileContextMenu(pEvent, pData.rowObject._id, pData.rowObject);
          break;
        default:
          var rowObject = Object.assign({}, pData.rowObject);
          var columnObject = Object.assign({}, pData.columObject);
          if (this.needSupportProjectListEvents) {
            this.element.trigger("projectlistaction" + pAction, {
              id: rowObject._id,
              rowObject: rowObject,
              columnObject: columnObject,
              action: pAction
            });
          } else {
            // custom action buttons
            this._trigger("action" + pAction.toLowerCase(), pEvent, {
              "id": pData.rowObject._id,
              "rowObject": rowObject,
              name: pAction
            });
          }
      }
    },
    _deleteRowObject: function _deleteRowObject(pRowID, pRowObject) {
      if (typeof pRowID !== "string" || pRowID.length <= 0) {
        throw new Error("input parameter pRowID must be a not empty string");
      }
      if (this._trigger("deleting", null, {
        "id": pRowID,
        "rowObject": pRowObject,
        "collection": "nucleus.job"
      }) === false) {
        return false;
      }
      var that = this;
      return $.Deferred(function (pDefer) {
        $("body").Dialog("show_delete_no", $.i18n._("nixps-cloudflow-manageprojects.delete_title"), $.i18n._("nixps-cloudflow-manageprojects.delete_confirmation_text", [pRowObject.name]), function () {}, function () {}).done(function (pResult) {
          if (pResult !== undefined && pResult.type === "delete") {
            // we should remove also the child projects
            // first get all children
            api_async.project.get_recursive(pRowID, {}, function (pProject) {
              if ($.isEmptyObject(pProject)) {
                pDefer.reject("recieve empty object");
                return true;
              }
              // make list if all ids of all project to be removed
              var projectIDS = [pRowID];
              if (Array.isArray(pProject.projects) && pProject.projects.length > 0) {
                for (var i = 0; i < pProject.projects.length; i++) {
                  if (pProject.projects[i] !== undefined && typeof pProject.projects[i]._id === "string" && pProject.projects[i]._id.length > 0) {
                    projectIDS.push(pProject.projects[i]._id);
                  }
                }
              }
              // loop over all ids and remove them
              var defs = [];
              for (var i = 0; i < projectIDS.length; i++) {
                defs.push($.Deferred(function (pDef) {
                  api_async.project["delete"](projectIDS[i], pDef.resolve, pDef.reject);
                }));
              }
              // wait until everything is done and do some stuff afterwards ...
              $.when.apply($, defs).done(function () {
                if (that.dead === true) {
                  return; // do nothing if component is gone ...
                }
                // refresh table
                that.refreshData(null, true, true).then(function () {
                  that._trigger("delete", null, {
                    id: pRowID,
                    rowObject: pRowObject
                  });
                  pDefer.resolve();
                }, function (pError) {
                  console.error("refresh after deleted failed ", pError);
                  pDefer.reject(pError);
                });
              }).fail(function (pError) {
                // a error occured during removing 
                console.error(pError);
                pDefer.reject(pError);
              });
            }, function (pError) {
              // could not get all children of project
              console.error(pError);
              pDefer.reject(pError);
            });
          } else {
            // user want not remove some thing
            pDefer.resolve();
          }
        });
      });
    },
    /**
     * @description function called in preConfiguredTable
     * @function
     * @private
     * @name nixps-cloudflow.ManageProjects#_initAdditional
     */
    _initAdditional: function _initAdditional() {
      this._superApply(arguments);
      if (this.options.usePreviousSettings === false) {
        return {};
      }
      var that = this;
      return $.when(this._getConfigurationSettings()).done(function (pJobsPreferenceObject) {
        if (Array.isArray(pJobsPreferenceObject.orderBy) && pJobsPreferenceObject.orderBy.length > 0) {
          that.options.tableOptions.sort = pJobsPreferenceObject.orderBy;
        }
      });
    },
    _getConfigurationSettings: function _getConfigurationSettings() {
      if (this.options.usePreviousSettings === false) {
        return {};
      }
      var that = this;
      return $.Deferred(function (pDefer) {
        // get everything from the jobs ...
        api_async.preferences.get_for_current_user("com.nixps.jobs", "", function (pPref) {
          if ($.isPlainObject(pPref.preferences) && $.isEmptyObject(pPref.preferences) === false) {
            if ($.isPlainObject(pPref.preferences.overview) && $.isPlainObject(pPref.preferences.overview[that.context]) && typeof pPref.preferences.overview[that.context].timestamp === "number" && new Date(pPref.preferences.overview[that.context].timestamp).getDate() === new Date().getDate()) {
              delete pPref.preferences.overview[that.context].timestamp;
              pDefer.resolve(pPref.preferences.overview[that.context]);
              return;
            }
          }
          // if there is an error, just suppose there is no information saved in the settings
          pDefer.resolve({});
        }, function (pError) {
          console.error(pError);
          // if there is an error, just suppose there is no information saved in the settings
          pDefer.resolve({});
        });
      });
    },
    _saveCurrentViewState: function _saveCurrentViewState() {
      if (this.dead === true) {
        return; // do nothing if component is gone ...
      }

      if (this.options.usePreviousSettings === false) {
        return {};
      }
      clearTimeout(this.saveCurrentViewStateTimeoutID);
      this.saveCurrentViewStateTimeoutID = this._delay(function () {
        if (this.dead === true) {
          return; // do nothing if component is gone ...
        }
        // state of table
        var currentStateOfList = this.element.children(".nixps-cloudflow-Table").Table("getState");
        if ($.isPlainObject(currentStateOfList) && $.isEmptyObject(currentStateOfList) === false) {
          // collection of all usefull information in one object
          var preferences = {
            "orderBy": currentStateOfList.orderBy_apicall
          };
          // send only if there is a differences
          if (_.isEqual(preferences, this.previousPreferences) === false) {
            // save , to compare next time
            this.previousPreferences = Object.assign({}, preferences);
            // add timestamp
            preferences.timestamp = Date.now();
            // send to backend to save in database
            api_async.preferences.save_for_current_user(preferences, "com.nixps.jobs", "overview." + this.context);
          }
        }
      }, 100);
    },
    _setOptions: function _setOptions(options) {
      if (typeof options.usePreviousSettings === "boolean" && options.usePreviousSettings !== this.options.usePreviousSettings) {
        this._superApply(arguments);
        var that = this;
        $.when(this._getConfigurationSettings()).done(function () {
          that._draw();
        });
      } else {
        this._superApply(arguments);
      }
    },
    _destroy: function _destroy() {
      this.dead = true;
      clearTimeout(this.saveCurrentViewStateTimeoutID);
      if (typeof this.savePreferences.cancel === "function") {
        this.savePreferences.cancel();
      }
      this.savePreferences = function () {};
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../Table/js/nixps-cloudflow-PreConfiguredTable.js":217}],183:[function(require,module,exports){
"use strict";

/* 
 * 
 *   created by guillaume on Jan 17, 2017 1:51:35 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var LogListener = {
    addLog: function addLog() {}
  };
  if (typeof require === "function") {
    LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");
  }

  /**
   * @namespace nixps-cloudflow.ProjectSetState
   * @description Draw a panel containing a different buttons for each next state. 
   * When clicking on one of the buttons the project will be notified about the state change.
   * This component fires next events. <br />
   * <ul> 
   *      <li> "change":  when a project has been changed succesfully of the state. ("newState") </li>
   *      <li> "beforechange" event before the change will happen, return false will prevent, cancel the change</li>
   * </ul>
   * @example $("<div>").ProjectSetState({"projectData": {...}});
   * @version 1.4.0
   */
  $.widget("nixps-cloudflow.ProjectSetState", $.Widget, {
    widgetEventPrefix: "projectsetstate",
    version: "1.4.0",
    options: {
      /**
       * @name nixps-cloudflow.ProjectSetState#projectData
       * @description The projectData as object
       * @type {Object|String}
       * @default {}
       */
      projectData: {},
      /**
       * @name nixps-cloudflow.ProjectSetState#statesTranslationDict
       * @description The object dictionary containing the translations for the different states
       * @type {Object}
       * @default {}
       */
      statesTranslationDict: {},
      /**
       * @name nixps-cloudflow.ProjectSetState#disableOnNeedMetadata
       * @description Must we disable the buttons if need_metadata is present
       * @type {Boolean}
       * @default false
       */
      disableOnNeedMetadata: false,
      /**
       * @name nixps-cloudflow.ProjectSetState#created
       * @description The callback of creation
       * @type {Function}
       * @default function(){}
       * @since 1.3.0
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.ProjectSetState#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._addClass(this.widgetFullName);

      // variables
      this.alive = true;
      this.projectData = {};

      // skeleton
      this.element.append($("<div>").addClass("buttonPanel"));
      this._draw("creation");
      this._on(this.element, {
        "click button": this._clickStateHandler
      });
    },
    /**
     * @description function runs when user click on one state
     * @function
     * @name nixps-cloudflow.ProjectSetState#_clickStateHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _clickStateHandler: function _clickStateHandler(pEvent, pData) {
      var that = this;
      var state = $(pEvent.currentTarget).attr("data-state");
      if (typeof state !== "string" || state.length <= 0) {
        throw new Error("ProjectSetState: button must have a attribute data-state");
      }
      var buttons = this.element.children(".buttonPanel").find("button").prop("disabled", true);
      if (this._trigger("beforechange", pEvent, {
        newState: state,
        oldState: this.projectData.state
      }) !== false) {
        var options = {
          current_state: this.projectData.state,
          current_next_states: this.projectData.next_states
        };
        api_async.project.set_state_with_options(this.projectData.project_id, state, options, function (pResults) {
          var data = {
            newState: state,
            oldState: that.projectData.state
          };
          if (typeof that.projectData._id === "string") {
            data.id = that.projectData._id;
          } else {
            data.id = that.projectData.project_id;
          }
          buttons.remove();
          that._trigger("change", pEvent, data);
        }, function (pError) {
          buttons.prop("disabled", false);
          that._errorHandler(pError);
        });
      } else {
        buttons.prop("disabled", false);
      }
    },
    /**
     * @description Sraws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.ProjectSetState#_draw
     * @return {undefined} 
     */
    _draw: function _draw(pReason) {
      var that = this;
      var projectDataDef = {};
      if (typeof this.options.projectData === "string" && this.options.projectData.length > 0) {
        if (this.options.projectData.indexOf("-") === -1) {
          // mongo id
          projectDataDef = api_defer.job.get_recursive(this.options.projectData, {});
        } else {
          // project_id
          projectDataDef = api_defer.job.get_by_project_id(this.options.projectData, {});
        }
        projectDataDef.then(function (pResult) {
          if (that.alive === false) {
            return;
          }
          that.projectData = pResult;
          that._drawButtons();
          if (pReason === "creation") {
            that.options.created();
          }
        }, function (pError) {
          that._errorHandler(pError);
          if (pReason === "creation") {
            that.options.created();
          }
        });
      } else if (this.options.projectData) {
        this.projectData = this.options.projectData;
        this._drawButtons();
        if (pReason === "creation") {
          this.options.created();
        }
      } else {
        // clear panel
        this.element.children(".buttonPanel").empty();
        if (pReason === "creation") {
          this.options.created();
        }
      }
      return projectDataDef;
    },
    /**
     * @description Draw all the buttons
     * @function
     * @private
     * @name nixps-cloudflow.ProjectSetState#_drawButtons
     */
    _drawButtons: function _drawButtons() {
      var panel = this.element.children(".buttonPanel").empty();
      // look if there is a key next_states, this key is optional!
      if (Array.isArray(this.projectData.next_states)) {
        var button;
        var state;
        var disabled = false;
        if (this.options.disableOnNeedMetadata === true && this.projectData.need_metadata !== undefined) {
          disabled = true;
        }
        for (var i = 0; i < this.projectData.next_states.length; i++) {
          state = this.projectData.next_states[i];
          if (typeof state === "string" && state.length > 0) {
            var buttonText = state;
            if (typeof this.options.statesTranslationDict[state] === "string") {
              buttonText = this.options.statesTranslationDict[state];
            }
            button = $("<button>").attr("type", "button").addClass("state_button cf-button-secondary").text(buttonText).attr("data-state", state).prop("disabled", disabled);
            panel.append(button);
          } else {
            console.error("ProjectSetState: state is not a string");
          }
        }
      }
    },
    /**
     * @description handle errors and inform others of the error
     * @function
     * @private
     * @name nixps-cloudflow.ProjectSetState#_errorHandler
     * @param {Object} pError 
     */
    _errorHandler: function _errorHandler(pError) {
      console.error(this.widgetFullName, pError);
      LogListener.addLog({
        event_type: "error",
        details_data: pError,
        component_name: this.widgetFullName
      }, this.element);
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.ProjectSetState#redraw
     */
    redraw: function redraw() {
      this._draw("redraw");
    },
    /**
     * @description update andredraw the component
     * @function
     * @name nixps-cloudflow.ProjectSetState#update
     * @return {Promise}
     */
    update: function update(pProjectData) {
      if (pProjectData) {
        this.options.projectData = pProjectData;
      }
      // first disable all existing buttons
      this.element.children(".buttonPanel").find("button").prop("disabled", true);
      // then update and return empty object
      return Promise.resolve(this._draw("update")).then(function () {
        return {};
      });
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ProjectSetState#_setOptions
     */
    _setOptions: function _setOptions(pOptions) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw("options");
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.ProjectSetState#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (this.options.projectData === null || this.options.projectData === "") {
        // accept empty, will display nothing
      } else if ((typeof this.options.projectData !== "string" || this.options.projectData.length <= 0) && (typeof this.options.projectData.project_id !== "string" || this.options.projectData.project_id.length <= 0)) {
        throw new Error("ProjectSetState: input option projectData must have a valid project_id");
      }
      if ($.isPlainObject(this.options.statesTranslationDict) === false) {
        throw new Error("ProjectSetState: input option statesTranslationDict must be an object");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../pagebuilder/js/inspect/LogListener.js":431}],184:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Nov 24, 2016 5:50:36 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  require("../../../3rdParty/timeline/timeline.custom.js");
  require("../../../common/Timeline/js/nixps-Timeline.js");
  var CloudflowConnection = require("../../CloudflowUtil/js/CloudflowConnection.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");
  /**
   * @description Are two dates the same?
   * @function
   * @private
   * @static
   * @param {date} pA the first date to control
   * @param {date} pB the second date to control over the first one
   * @returns {Boolean} true if two dates are the same, false if the two dates are different.
   */
  function isDateSame(pA, pB) {
    // transform first both dates to numberic values before comparing
    return Date.parse(pA) === Date.parse(pB);
  }
  ;

  /**
   * @description filter the data given by events to beter interface
   * @function
   * @private
   * @static
   * @param {object} pData data object from event
   * @returns {object} object containing the adapted data of events
   */
  function eventDataFilter(pData) {
    var itemData = [];
    if (Array.isArray(pData.rows) && pData.rows.length > 0) {
      for (var i = 0; i < pData.rows.length; i++) {
        if (pData.rows[i].projectData !== undefined) {
          itemData.push(pData.rows[i].projectData);
        } else {
          // no projectData found
          itemData.push({});
        }
      }
    }
    var clusterData = [];
    if (Array.isArray(pData.clusterRows) && pData.clusterRows.length > 0) {
      for (var i = 0; i < pData.clusterRows.length; i++) {
        if (Array.isArray(pData.clusterRows[i])) {
          var clusterDataItems = [];
          for (var j = 0; j < pData.clusterRows[i].length; j++) {
            if (pData.clusterRows[i][j].projectData !== undefined) {
              clusterDataItems.push(pData.clusterRows[i][j].projectData);
            } else {
              // no projectData found
              clusterDataItems.push({});
            }
          }
          clusterData.push(clusterDataItems);
        } else {
          // cluster is not an array
          console.warn("clusterRows of pData event is not an array");
          clusterData.push([{}]);
        }
      }
    }
    return {
      "itemData": itemData,
      "clusterData": clusterData
    };
  }
  ;
  var regExpExtendToNormal = new RegExp("[.][0-9][0-9][0-9]Z$");
  function getFilterDate(pDate, pFormat) {
    switch (pFormat) {
      case "seconds":
        return parseInt(pDate.getTime() / 1000);
      case "miliseconds":
        return pDate.getTime();
      case "ISOExtend":
        return pDate.toISOString();
      case "ISO":
      default:
        return pDate.toISOString().replace(regExpExtendToNormal, "Z");
    }
  }

  /**
   * @namespace nixps-cloudflow.ProjectTimeline
   * @description Show a timeline with cloudflow project information. <br />
   * Items with start and end will be draw acording there start and end time. If start and end date are the same the component will draw them as a point ("box") type.
   * If there are to many items, the component will merge some together. <br /> 
   * The time events or periods added to the timeline have each the class "projecttimeline_item". If start and end period are differend a class name 
   * "projecttimeline_range" is added, otherwise the class name "projecttimeline_box" is added. <br />
   * Each content of a item
   * is a span element with class name "cloudflowtimeline_rowitem_content" and has a "data-id" attribute containing the id of the item (given by the backend) 
   * <br/>This component send next events.
   * <ul>
   * <li> select: with data itemData containing a object, recieved from backend </li>
   * <li> dblclick: with data itemData containing a object, recieved from backend </li>
   * <li> drawed: the table has drawed the items, you can now use the methods on the plugin </li>
   * </ul>
   * @example $("<div>").ProjectTimeline({language: "en", projectID:"5836cf310af90000000029c4"});
   * @version 1.3.1
   */
  $.widget("nixps-cloudflow.ProjectTimeline", $.Widget, {
    widgetEventPrefix: "projecttimeline",
    version: "1.3.1",
    options: {
      /**
       * @name nixps-cloudflow.ProjectTimeline#language
       * @description The language of th user. used to define the correct language and month names.
       * This string must be a moment local valid string
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.ProjectTimeline#height
       * @description The total height of the internal component. this value is given directly to the internal component. It can be in pixels, percentage or "auto"
       * @type {string} 
       * @default "auto"
       */
      height: "auto",
      /**
       * @name nixps-cloudflow.ProjectTimeline#projectID
       * @description the _id of the project (if you want to visualize the tasks of a project). If you use this, you overwrite the option taskListQuery
       * @type {string}
       * @default ""
       * @example "5836cf310af90000000029c4"
       */
      projectID: "",
      /**
       * @name nixps-cloudflow.ProjectTimeline#sourceChooser
       * @description The pagebuilder select key to choose between tasklits or collections. you can choose between "tasklist" or "custom_connections" 
       * @type: {String}
       * @default undefined
       * @private
       */
      sourceChooser: undefined,
      /**
       * @name nixps-cloudflow.ProjectTimeline#taskListQuery
       * @description a query to select one or more task lists (if you want to visualize the tasks of a task_list). This option can be overwritten by option projectID! 
       * @type {string}
       * @default ""
       * @example ["task_list_id", "equal to", "3a738a6e-14d0-4f0e-adde-f2b7c5d52ebd"]
       */
      taskListQuery: [],
      /**
       * @name nixps-cloudflow.ProjectTimeline#collection
       * @description The source of the data to visualise in a pagebuilder format
       * @type {String}
       * @default ""
       */
      collection: "timeline",
      /**
       * @description The extra filter query asked to the backend
       * @name nixps-cloudflow.ProjectTimeline#extraQuery
       * @type {Array.<String>}
       * @default []
       * @since 1.3.0
       */
      extraQuery: [],
      data: [],
      /**
       * @name nixps-cloudflow.ProjectTimeline#httpserviceInputName
       * @description The name of the whitepaper input name node 
       * @type {String}
       * @default ""
       */
      httpserviceInputName: "",
      /**
       * @name nixps-cloudflow.ProjectTimeline#httpserviceWhitepaperName
       * @description The name of the whitepaper 
       * @type {String}
       * @default ""
       */
      httpserviceWhitepaperName: "",
      /**
       * @description The file url to search for data
       * @name nixps-cloudflow.ProjectTimeline#dataFileURL
       * @type {String}
       * @default ""
       * @since 1.3.0
       */
      dataFileURL: "",
      /**
       * @description The relative base path of the data file
       * @name nixps-cloudflow.ProjectTimeline#relativeBasePath
       * @type {String}
       * @default ""
       * @since 1.3.0
      */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.ProjectTimeline#filterDateFormat
       * @description Get the format of date to be used in the filtering. Allowed types are "ISO", "ISOExtend", "seconds", "miliseconds".
       * When converting we cut of the strings and do not round it.
       * @type {String}
       * @default "ISO"
       * @since 1.2.0
       */
      filterDateFormat: "ISO",
      /**
       * @name nixps-cloudflow.ProjectTimeline#filterFromDateParameterName
       * @description The name of the from date parameter name of in the collection
       * @type {String}
       * @default "from"
       * @since 1.3.0
       */
      filterFromDateParameterName: "from",
      /**
       * @name nixps-cloudflow.ProjectTimeline#filterToDateParameterName
       * @description The name of the to date parameter name of in the collection
       * @type {String}
       * @default "to"
       * @since 1.3.0
       */
      filterToDateParameterName: "to",
      /**
       * @name nixps-cloudflow.ProjectTimeline#keyUniqID
       * @description the parameter name of the id of the objects
       * @type {String}
       * @default "_id"
       * @since 1.2.0
       */
      keyUniqID: "_id",
      /**
       * @name nixps-cloudflow.ProjectTimeline#selectable
       * @description Must it be possible to select items?
       * @type {boolean}
       * @default true
       * @example false
       */
      selectable: true,
      /**
       * @name nixps-cloudflow.ProjectTimeline#enableTooltip
       * @description Must we enable a default tooltips on own events, or not, use this if you want use a custom tooltip plugin.
       * Set on true to add the default tml tooltip. This will not disable the tooltips added by the plugin self!
       * @type {boolean}
       * @default true
       * @example false
       */
      enableTooltip: true,
      /**
       * @name nixps-cloudflow.ProjectTimeline#translateItemFunction
       * @description function to translate items, Use this at own risk! No support will be given!
       * @type {function}
       * @default null
       */
      translateItemFunction: null,
      /**
       * @name nixps-cloudflow.ProjectTimeline#adaptClusterFunction
       * @description Adapt the ui of clusters
       * @type {function}
       * @example function(pUI, pObject) {
              if(pObject.items.length > 5) {
                  pUI.css("background", "red");
              }
       */
      adaptClusterFunction: null,
      /**
       * @name nixps-cloudflow.ProjectTimeline#maxItemsInGroup
       * @description The maximum amount of items in a group, if there are more items, the last will collepsd to one cluster.This option must be equal or bigger than one.
       * @type {Number}
       * @default 7
       */
      maxItemsInGroup: 7,
      /**
       * @name nixps-cloudflow.ProjectTimeline#start
       * @description The start date of the timeline on creation
       * @type {Date}
       * @default undefined
       */
      start: undefined,
      /**
       * @name nixps-cloudflow.ProjectTimeline#end
       * @description The end date of the timeline on creation
       * @type {Date}
       * @default undefined
       */
      end: undefined,
      /**
       * @name nixps-cloudflow.ProjectTimeline#startDate
       * @description What is the beginning possition of date. How many days before now must we retrieve the data from.
       * If this is a string it will use that as the Date parameter, if this is a number it will use that to calculate the difference with now and that number (of days)
       * @type {mixed}
       * @default -100
       * @since 1.2.0
       */
      startDate: -100,
      /**
       * @name nixps-cloudflow.ProjectTimeline#endDate
       * @description What is the ending possition of date. How many days after now must we retrieve the data from.
       * If this is a string it will use that as the Date parameter, if this is a number it will use that to calculate the difference with now and that number (of days)
       * @type {mixed}
       * @default 100
       * @since 1.2.0
       */
      endDate: 100,
      /**
       * @name nixps-cloudflow.ProjectTimeline#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       * @since 1.1.0
       */
      style_type: "default",
      /**
       * @name nixps-cloudflow.ProjectTimeline#created
       * @description function called when component is done drawing
       * @type {Function}
       * @private
       * @since 1.3.1
       */
      created: function created() {}
    },
    /**
     * @description create the component
     * @name nixps-cloudflow.ProjectTimeline#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      // variables
      this.connection = null;
      this.hasCSSattr = false;
      this.creating = true;
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type);

      // skeleton
      this.element.append($("<div>").addClass("cloudflowtimeline_container"));
      this._initConnection();
      this._draw();
      this._on(this.element, {
        "timelineselect": this._selectHandler,
        "timelinedblclick": this._dblClickHandler,
        "timelineready": this._readyHandler,
        "timelinerefresh": this._refreshHandler,
        "timelinedrawed": this._drawedHandler
      });
    },
    /**
     * @description Function runs when user select a item
     * @name nixps-cloudflow.ProjectTimeline#_selectHandler
     * @function
     * @private
     * @param {object} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _selectHandler: function _selectHandler(pEvent, pData) {
      var eventData = eventDataFilter(pData);
      // for the moment there is only one selectable at the time !!
      // add parameter id to be compatible with other components
      if (Array.isArray(eventData.itemData) && eventData.itemData.length > 0 && eventData.itemData[0].id !== undefined) {
        eventData.id = eventData.itemData[0].id;
      }
      this._trigger("select", pEvent, eventData);
    },
    /**
     * @description Function runs when user double click on a item
     * @name nixps-cloudflow.ProjectTimeline#_dblClickHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _dblClickHandler: function _dblClickHandler(pEvent, pData) {
      var eventData = eventDataFilter(pData);
      var id;
      if ($(pEvent.originalEvent.target).hasClass("cloudflowtimeline_rowitem_content")) {
        id = $(pEvent.originalEvent.target).attr("data-id");
      } else {
        id = $(pEvent.originalEvent.target).find(".cloudflowtimeline_rowitem_content").attr("data-id");
      }
      if (typeof id === "string" && id.length > 0) {
        eventData.id = id;
      }
      this._trigger("dblclick", pEvent, eventData);
    },
    /**
     * @description Function runs when component is ready to use. fired by plugin
     * @name nixps-cloudflow.ProjectTimeline#_readyHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _readyHandler: function _readyHandler(pEvent, pData) {
      this._trigger("drawed", pEvent, {});
      this._afterDrawCall();
      if (this.creating === true) {
        this.creating = false;
        this.options.created();
      }
    },
    /**
     * @description fucntion runs when a refresh of rows has been done.
     * @name nixps-cloudflow.ProjectTimeline#_refreshHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _refreshHandler: function _refreshHandler(pEvent, pData) {
      this._trigger("drawed", pEvent, {});
      this._afterDrawCall();
    },
    /**
     * @description Function runs when timeline has been drawed
     * @name nixps-cloudflow.ProjectTimeline#_drawedHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _drawedHandler: function _drawedHandler(pEvent, pData) {
      // triggered when user is scrolling
      this._afterDrawCall();
    },
    /**
     * @description Inform other of the errors
     * @name nixps-cloudflow.ProjectTimeline#_errorHandler
     * @function
     * @private
     * @param {String} pCodeSection the name where the error occured 
     * @param {Object} pError
     */
    _errorHandler: function _errorHandler(pCodeSection, pError) {
      this._trigger("error", null, pError);
      LogListener.addLog({
        event_type: "error",
        details_data: pError,
        component_name: this.widgetFullName
      }, this.element);
      if (this.creating === true) {
        this.creating = false;
        this.options.created();
      }
    },
    /**
     * @description Inform other of the changes
     * @name nixps-cloudflow.ProjectTimeline#_sourceChangeHandler
     * @function
     * @private
     */
    _sourceChangeHandler: function _sourceChangeHandler() {
      if (this.alive === true) {
        this.refresh();
      }
    },
    /**
     * @description Refresh the timeline, recalling the backend with the current data
     * @name nixps-cloudflow.ProjectTimeline#refresh
     * @function
     * @returns {Deferred}
     */
    refresh: function refresh() {
      return this.element.children(".cloudflowtimeline_container").Timeline("refresh", this._getTimelineDataFromBackend());
    },
    /**
     * @description Redraw the component
     * @name nixps-cloudflow.ProjectTimeline#redraw
     * @function
     * @returns {undefined} 
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.ProjectTimeline#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      if (this.options.sourceChooser === "custom_connections" && this.options.collection === "") {
        this.element.append($("<div>").addClass("projecttimeline_infopanel")._t("nixps-cloudflow-projecttimeline.nodata").css("height", this.options.height));
        return true;
      }
      this.element.children(".projecttimeline_infopanel").remove();
      this.element.children(".cloudflowtimeline_container").Timeline({
        start: this.options.start,
        end: this.options.end,
        height: this.options.height,
        rows: this._getTimelineDataFromBackend(),
        loading_text: $.i18n._("nixps-cloudflow-projecttimeline.loading_text"),
        editable: false,
        selectable: this.options.selectable,
        maxItemsInGroup: this.options.maxItemsInGroup,
        language: this.options.language
      });
    },
    /**
     * @description Get the visible range of the timeline. Calls and return the function "getVisibleRange" of child plugin.
     * @function
     * @name nixps-cloudflow.ProjectTimeline#getVisibleRange
     * @returns {object} An object containing start and end Dates, of the visible range or null if timeline is not ready.  Both in js Date format
     */
    getVisibleRange: function getVisibleRange() {
      return this.element.children(".cloudflowtimeline_container").Timeline("getVisibleRange");
    },
    /**
     * @description Get the starting and end dates to request from backend
     * @function
     * @name nixps-cloudflow.ProjectTimeline#_getStartAndEndData
     * @private
     * @returns Object with from and to as dates
     */
    _getStartAndEndData: function _getStartAndEndData() {
      var from;
      var to;
      if (typeof this.options.startDate === "number") {
        from = new Date();
        from.setDate(from.getDate() + this.options.startDate);
      } else if (typeof this.options.startDate === "string") {
        from = new Date(this.options.startDate);
      }
      if (typeof this.options.endDate === "number") {
        to = new Date();
        to.setDate(to.getDate() + this.options.endDate);
      } else if (typeof this.options.endDate === "string") {
        to = new Date(this.options.endDate);
      }
      return {
        from: from,
        to: to
      };
    },
    /**
     * @description (re)init the connnection to backend
     * @function
     * @name nixps-cloudflow.ProjectTimeline#_initConnection
     * @private
     * @returns {undefined}
     */
    _initConnection: function _initConnection() {
      if (this.connection !== null) {
        this.connection.stop();
      }
      // do the request for data
      this.connection = new CloudflowConnection({
        collection: this.options.collection,
        data: this.options.data,
        dataFileURL: this.options.dataFileURL,
        relativeBasePath: this.options.relativeBasePath,
        httpserviceInputName: this.options.httpserviceInputName,
        httpserviceWhitepaperName: this.options.httpserviceWhitepaperName,
        error_cb: this._errorHandler.bind(this),
        change_cb: this._sourceChangeHandler.bind(this)
      });
    },
    /**
     * @description Get information to show from backend
     * @name nixps-cloudflow.ProjectTimeline#_getTimelineDataFromBackend
     * @function
     * @private
     * @returns {Deferred} containing rows array
     */
    _getTimelineDataFromBackend: function _getTimelineDataFromBackend() {
      var that = this;
      this.hasCSSattr = false;
      return $.Deferred(function (pDefer) {
        // if projectID is given with
        if (typeof that.options.projectID === "string" && that.options.projectID.length > 0) {
          api_async.project.get_task_list_visualization_data(that.options.projectID, {}, function (pResult) {
            if (pResult !== undefined && pResult !== null && Array.isArray(pResult.rows)) {
              var rows = [];
              for (var i = 0; i < pResult.rows.length; i++) {
                if (that._isValidRowItem(pResult.rows[i]) === true) {
                  rows.push(that._translateRowToTimeLineItem(pResult.rows[i], i));
                }
              }
              pDefer.resolve(rows);
            } else {
              var errorObject = {
                "error_code": "invalid_return_interface",
                "error": "return object must have an array rows"
              };
              that._errorHandler("load", errorObject);
              pDefer.reject(errorObject);
            }
          }, function (pError) {
            console.error("ProjectTimeline: could not load data from backend");
            that._errorHandler("load", {
              "error_code": "load_failed",
              "error": "could not load timeline data"
            });
            pDefer.reject(pError);
          });
        } else if (that._isCloudflowConnectionPossible() === true) {
          var borders = that._getStartAndEndData();
          var startDate = getFilterDate(borders.from, that.options.filterDateFormat);
          var endDate = getFilterDate(borders.to, that.options.filterDateFormat);
          var query = [that.options.filterToDateParameterName, "greater than or equal to", startDate, "and", that.options.filterFromDateParameterName, "less than or equal to", endDate];
          if (Array.isArray(that.options.extraQuery) && that.options.extraQuery.length > 0) {
            query = query.concat(["and", "("]).concat(that.options.extraQuery);
            query.push(")");
          }
          that.connection.stop();
          $.when(that.connection.list_with_options(query, [], [])).then(function (pResults) {
            if (pResults !== undefined && pResults !== null) {
              var rows = [];
              pResults.results = pResults.results || pResults.documents;
              if (Array.isArray(pResults.results)) {
                for (var i = 0; i < pResults.results.length; i++) {
                  var row = that._isValidAndChangeRowItem(pResults.results[i]);
                  if (row !== null) {
                    rows.push(that._translateRowToTimeLineItem(row));
                  }
                }
                pDefer.resolve(rows);
              } else {
                // no results nor documents
                var errorObject = {
                  "error_code": "invalid_return_interface",
                  "error": "expected an array results as retrun interface"
                };
                that._errorHandler("load", errorObject);
                pDefer.reject(errorObject);
              }
            } else {
              // no results at all
              var errorObject = {
                "error_code": "invalid_return_interface",
                "error": "return object is empty"
              };
              that._errorHandler("load", errorObject);
              pDefer.reject(errorObject);
            }
          }, function (pError) {
            console.error("ProjectTimeline: could not load data from backend");
            that._errorHandler("load", {
              "error_code": "load_failed",
              "error": "could not load timeline data"
            });
            pDefer.reject(pError);
          });
        } else {
          var borders = that._getStartAndEndData();
          api_async.task_list.get_visualization_data(that.options.taskListQuery, borders.from.toISOString().substring(0, 10), borders.to.toISOString().substring(0, 10), {}, function (pResult) {
            if (pResult !== undefined && pResult !== null && Array.isArray(pResult.rows)) {
              var rows = [];
              for (var i = 0; i < pResult.rows.length; i++) {
                if (that._isValidRowItem(pResult.rows[i]) === true) {
                  rows.push(that._translateRowToTimeLineItem(pResult.rows[i]));
                }
              }
              pDefer.resolve(rows);
            } else {
              var errorObject = {
                "error_code": "invalid_return_interface",
                "error": "return object must have an array rows"
              };
              that._errorHandler("load", errorObject);
              pDefer.reject(errorObject);
            }
          }, function (pError) {
            console.error("ProjectTimeline: could not load data from backend");
            that._errorHandler("load", {
              "error_code": "load_failed",
              "error": "could not load timeline data"
            });
            pDefer.reject(pError);
          });
        }
      });
    },
    /**
     * @description Control if the item has a good interface, to be used as a time event/ period
     * @function
     * @private
     * @name nixps-cloudflow.ProjectTimeline#_isValidRowItem
     * @param {object} pRowItem oject from backend to control
     * @returns {Boolean} true if the item has a good interface, false if the item has a wrong interface.
     */
    _isValidRowItem: function _isValidRowItem(pRowItem) {
      if ($.isPlainObject(pRowItem)) {
        if (typeof pRowItem.name !== "string" || pRowItem.name.length <= 0) {
          return false;
        }
        if (!Array.isArray(pRowItem.values) || pRowItem.values.length <= 0) {
          return false;
        }
        if (!(typeof pRowItem.values[0].from === "number" && pRowItem.values[0].from > 0 || typeof pRowItem.values[0].from === "string" && pRowItem.values[0].from.length > 0)) {
          return false;
        }
        if (isNaN(Date.parse(new Date(pRowItem.values[0].from)))) {
          return false;
        }
        if (!(typeof pRowItem.values[0].to === "number" && pRowItem.values[0].to > 0 || typeof pRowItem.values[0].to === "string" && pRowItem.values[0].to.length > 0)) {
          return false;
        }
        if (isNaN(Date.parse(new Date(pRowItem.values[0].to)))) {
          return false;
        }
        return true;
      }
      return false;
    },
    /**
     * @description Try to translate to valid rowobject
     * @name nixps-cloudflow.ProjectTimeline#_isValidAndChangeRowItem
     * @function
     * @private
     * @param {Object} pRowItem 
     * @returns {Object} translated RowItem
     */
    _isValidAndChangeRowItem: function _isValidAndChangeRowItem(pRowItem) {
      if ($.isPlainObject(pRowItem) === false || $.isEmptyObject(pRowItem)) {
        return null;
      }
      // endpoints dates
      var from;
      var to;
      var fromCandidate = CloudflowObject.getParameter(pRowItem, this.options.filterFromDateParameterName);
      var toCandidate = CloudflowObject.getParameter(pRowItem, this.options.filterToDateParameterName);
      if (fromCandidate !== undefined && isNaN(new Date(fromCandidate)) === false) {
        from = fromCandidate;
      }
      if (toCandidate !== undefined && isNaN(new Date(toCandidate)) === false) {
        to = toCandidate;
      }
      if (to === undefined && from === undefined && Array.isArray(pRowItem.values) && pRowItem.values.length > 0) {
        if (typeof pRowItem.values[0].from === "string" && pRowItem.values[0].from.length > 0 && isNaN(new Date(pRowItem.values[0].from)) === false) {
          from = pRowItem.values[0].from;
        }
        if (typeof pRowItem.values[0].to === "string" && pRowItem.values[0].to.length > 0 && isNaN(new Date(pRowItem.values[0].to)) === false) {
          to = pRowItem.values[0].to;
        }
      }
      if (from === undefined && isNaN(new Date(pRowItem.from)) === false) {
        from = pRowItem.from;
      }
      if (to === undefined && isNaN(new Date(pRowItem.to)) === false) {
        to = pRowItem.to;
      }
      if (from === undefined || to === undefined) {
        return null;
      }
      if (Date.parse(to) < Date.parse(from)) {
        return null;
      }
      // name
      var name;
      if (typeof pRowItem.name === "string" && pRowItem.name.length > 0) {
        name = pRowItem.name;
      } else if (typeof pRowItem.label === "string" || pRowItem.label.length > 0) {
        name = pRowItem.label;
      } else {
        name = " ";
      }
      var outputRowItem = {
        name: name,
        values: [{
          "from": from,
          "to": to
        }]
      };
      if (typeof pRowItem.group === "string" && pRowItem.group.length > 0) {
        outputRowItem.group = pRowItem.group; // activate the group if there are more groups
      }

      if (typeof pRowItem._id === "string" && pRowItem._id.length > 0) {
        outputRowItem.id = pRowItem._id;
      } else if (this.options.keyUniqID !== "_id" && pRowItem[this.options.keyUniqID] !== undefined) {
        outputRowItem.id = pRowItem[this.options.keyUniqID];
      }
      if (typeof pRowItem["class"] === "string" && pRowItem["class"].length > 0) {
        outputRowItem.classes = pRowItem["class"];
      } /* else if (pRowItem.style_class === "string" && pRowItem.style_class.length > 0) {
          outputRowItem.classes = "nixps_styling_class_" + pRowItem.style_class;
        }*/
      var background_color;
      var border_color;
      if (typeof pRowItem.background_color === "string" && pRowItem.background_color.length > 0) {
        background_color = pRowItem.background_color;
      } else if (typeof pRowItem.color === "string" && pRowItem.color.length > 0) {
        background_color = pRowItem.color;
      }
      if (typeof pRowItem.border_color === "string" && pRowItem.border_color.length > 0) {
        border_color = pRowItem.border_color;
      } else if (typeof pRowItem.color === "string" && pRowItem.color.length > 0) {
        border_color = pRowItem.color;
      }
      if (background_color !== undefined || border_color !== undefined) {
        outputRowItem.css = {
          backgroundColor: background_color,
          borderColor: border_color
        };
        this.hasCSSattr = true;
      }
      return outputRowItem;
    },
    /**
     * @description Translate teh itemobejct from backend to a well formed object for the timeline plugin
     * @name nixps-cloudflow.ProjectTimeline#_translateRowToTimeLineItem
     * @function
     * @private 
     * @param {Object} pRowItem - time event/period object from backend
     * @returns {Object} a object with the good timeline interface
     */
    _translateRowToTimeLineItem: function _translateRowToTimeLineItem(pRowItem) {
      if (typeof this.options.translateItemFunction === "function") {
        return this.options.translateItemFunction(pRowItem);
      } else {
        var that = this;
        // unused information: pRowItem.id and pRowItem.reference
        var item = {
          projectData: pRowItem,
          start: new Date(pRowItem.values[0].from),
          end: new Date(pRowItem.values[0].to),
          editable: false
        };
        // making the content
        item.content = $("<span>").attr("title", function () {
          if (that.options.enableTooltip === true) {
            return pRowItem.name;
          }
        }).addClass("cloudflowtimeline_rowitem_content").attr("data-id", pRowItem.id).text(pRowItem.name)[0].outerHTML;
        // updating classes
        item.className = "projecttimeline_item";
        if (typeof pRowItem.classes === "string" && pRowItem.classes.length > 0) {
          item.className += " " + pRowItem.classes;
        }
        // updating group
        if (typeof pRowItem.group === "string" && pRowItem.group.length > 0) {
          item.group = pRowItem.group; //activate the group if there are more groups
        }
        // update type
        if (isDateSame(item.start, item.end)) {
          item.type = "box";
          item.className += " projecttimeline_box";
        } else {
          item.className += " projecttimeline_range";
        }
        return item;
      }
    },
    /**
     * @description Call after drawing
     * @name nixps-cloudflow.ProjectTimeline#_afterDrawCall
     * @function
     * @private
     * @returns {undefined}
     */
    _afterDrawCall: function _afterDrawCall() {
      // only procede if option function is delivered
      if (typeof this.options.adaptClusterFunction === "function") {
        // get all clusters
        var clusters = this.element.children('.cloudflowtimeline_container').Timeline('getClusters');
        // only continue if there are clusters
        if (Array.isArray(clusters) && clusters.length > 0) {
          for (var i = 0; i < clusters.length; i++) {
            // call function with first parameter the jQuery element and second the object information about the cluster
            this.options.adaptClusterFunction(this.element.children('.cloudflowtimeline_container').Timeline('getClusterElement', i), clusters[i]);
          }
        }
      }
      // if needed color the items
      if (this.hasCSSattr === true) {
        var visibleItems = this.element.children('.cloudflowtimeline_container').Timeline("getVisibleItems");
        if (Array.isArray(visibleItems)) {
          for (var i = 0; i < visibleItems.length; i++) {
            if (visibleItems[i] !== undefined && visibleItems[i].data !== undefined && visibleItems[i].data.projectData !== undefined && visibleItems[i].data.projectData.css !== undefined) {
              $(visibleItems[i].dom).closest(".timeline-event").css(visibleItems[i].data.projectData.css);
            }
          }
        }
      }
    },
    /**
     * @description Is cloudflow connection in use or not?
     * @function
     * @name nixps-cloudflow.ProjectTimeline#_isCloudflowConnectionPossible
     * @private
     * @returns {Boolean} true if the cloudflow connection is in use, false otherwise
     */
    _isCloudflowConnectionPossible: function _isCloudflowConnectionPossible() {
      if (this.options.sourceChooser === "tasklist") {
        return false;
      }
      if (this.options.sourceChooser === "custom_connections") {
        return true;
      }
      return typeof this.options.collection === "string" && this.options.collection.length > 0 && this.options.collection !== "timeline";
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ProjectTimeline#_setOptions
     */
    _setOptions: function _setOptions(options) {
      if (options.collection !== undefined && options.collection !== this.options.collection || options.data !== undefined && _.isEqual(options.data, this.options.data) === false || options.httpserviceInputName !== undefined && options.httpserviceInputName !== this.options.httpserviceInputName || options.httpserviceWhitepaperName !== undefined && options.httpserviceWhitepaperName !== this.options.httpserviceWhitepaperName) {
        this._superApply(arguments);
        this._initConnection();
      } else {
        this._superApply(arguments);
      }
      this._controlOptions();
      this._draw();
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps-cloudflow.ProjectTimeline#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error('ProjectTimeline: option language must be a not empty string');
      }
      if (typeof this.options.selectable !== "boolean") {
        throw new Error('ProjectTimeline: option selectable must be a boolean');
      }
      if (typeof this.options.maxItemsInGroup !== "number" || this.options.maxItemsInGroup < 1) {
        throw new Error('ProjectTimeline: option maxItemsInGroup must be a number bigger or equal to one');
      }
      if (typeof this.options.enableTooltip !== "boolean") {
        throw new Error('ProjectTimeline: option enableTooltip must be a boolean');
      }
      if (typeof this.options.filterFromDateParameterName !== "string" || this.options.filterFromDateParameterName.length <= 0) {
        throw new Error('ProjectTimeline: option filterFromDateParameterName must be a not empty string');
      }
      if (typeof this.options.filterToDateParameterName !== "string" || this.options.filterToDateParameterName.length <= 0) {
        throw new Error('ProjectTimeline: option filterToDateParameterName must be a not empty string');
      }
      if (typeof this.options.collection === "string" && this.options.collection.indexOf("nucleus.") === 0) {
        this.options.keyUniqID = "_id";
      }
      if (typeof this.options.keyUniqID !== "string" || this.options.keyUniqID.length <= 0) {
        throw new Error("ProjectTimeline input option keyUniqID must be a not empty string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("CloudflowStyle_" + this.options.style_type);
      this.alive = false;
      if (this.connection !== null) {
        this.connection.stop();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../3rdParty/timeline/timeline.custom.js":8,"../../../common/Timeline/js/nixps-Timeline.js":378,"../../../pagebuilder/js/inspect/LogListener.js":431,"../../CloudflowUtil/js/CloudflowConnection.js":78,"../../CloudflowUtil/js/CloudflowObject.js":79}],185:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
      * @namespace nixps-cloudflow.TagList
      * @description show a panel to select and add a item
      * @version 1.2.0
      */
  $.widget("nixps-cloudflow.TagList", $.Widget, {
    version: "1.2.0",
    widgetEventPrefix: "taglist",
    options: {
      /**
       * @name nixps-cloudflow.TagList#maxPossibilitiesShow
       * @description How many possibilities may we show
       * @default 10
       * @type Number
       */
      maxPossibilitiesShow: 10,
      /**
       * @name nixps-cloudflow.TagList#selectedItemsID
       * @description An array containing all the ids that must be selected on creation
       * @type {array}
       * @default []
       */
      selectedItemsID: [],
      /**
       * @name nixps-cloudflow.TagList#getAllItems
       * @description a function that gives a list of all possible values at ones
       * @type {function}
       * @default null
       */
      getAllItems: null,
      allowNotDefinedValues: false,
      /**
       * @name nixps-cloudflow.TagList#beforeInputComponent
       * @type HTML
       * @desciption the component that must stay before the inputfield, this can be the label.
       * @default ""
       */
      beforeInputComponent: "",
      /**
       * @name nixps-cloudflow.TagList#placeholder
       * @description The placeholder of the input field, the graded text visual in the input when no text is there
       * @type {String}
       * @default ""
       * @since 1.2.0
       */
      placeholder: "",
      /**
       * @name nixps-cloudflow.TagList#removeItem
       * @description the callback function, that is called when removing a item.
       * If this function contains async calls, it must return a Deferred object. If resolved, the item will be removed.
       * @type function
       * @param {object} item - the item that the user want to remove, the type should be the same as the input.
       * @return {Deferred}
       * @default function(){}
       */
      removeItem: function removeItem() {},
      /**
       * @name nixps-cloudflow.TagList#addItem
       * @description the callback function, that is called when adding a item.
       * If this function contains async calls, it must return a Deferred object. If resolved, the item will be added.
       * @type function
       * @param {string} item - the item that the user want to add
       * @return {Deferred}
       * @default function(){}
       */
      addItem: function addItem() {},
      /**
       * @name nixps-cloudflow.TagList#tagClass
       * @description The html class to add to the tags, for layout reasons
       * @type string
       * @default ""
       */
      tagClass: "",
      /**
       * @description Must we provide a input field to add items?
       * @name nixps-cloudflow.TagList#addInputField
       * @type {boolean}
       * @default true
       */
      addInputField: true,
      /**
       * @description Are the setValue and getValue key or value based
       * @name nixps-cloudflow.TagList#valueBasedBy
       * @type {String}
       * @default "key"
       * @example "value"
       */
      valueBasedBy: "key",
      created: function created() {}
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        "placeholder": $.i18n._("nixps-cloudflow-Tags.placeholder_default")
      };
    },
    /**
     * @function
     * @name nixps-cloudflow.TagList#_create
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("cf-autocomplete").css({
        position: "relative"
      });

      // variables
      this.allTags = {};
      this.setValueCallingID = 0;
      this.dead = false;
      var that = this;
      this.getAllItemDef = $.when(this._updateAllItems()).then(function () {
        that._draw();
      }).fail(function (pError) {
        console.error(pError);
      }).always(function () {
        that.options.created();
      });
      this._on(this.element, {
        "click .cf-tag-remove": this._removeHandler,
        "click .addTagButton": this._addedHandler,
        "keydown .editPanel input": this._keyDownHandler
      });
    },
    _updateAllItems: function _updateAllItems() {
      var that = this;
      return $.Deferred(function (pDefer) {
        that.getAllItemDef = $.when(that.options.getAllItems()).then(function (pItems) {
          if (that.dead === true) {
            return; // zombies
          }

          that.allTags = {};
          if (Array.isArray(pItems)) {
            for (var i = 0; i < pItems.length; i++) {
              that.allTags[pItems[i]] = pItems[i];
            }
            pDefer.resolve();
          } else if ($.isPlainObject(pItems)) {
            that.allTags = pItems;
            pDefer.resolve();
          } else {
            pDefer.reject({
              error_code: "invalid_return_interface",
              error: "_updateAllItems: return value must be a non empty object"
            });
            throw new Error("_updateAllItems: return value must be a non empty object");
          }
        }).fail(pDefer.reject);
      });
    },
    /**
           * @function
           * @name nixps-cloudflow.TagList#redraw
           * @description redraw the panel
     * @brief redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
           * @function
           * @name nixps-cloudflow.TagList#_draw
           * @private
     * @brief draws the dialog according to the current state
     */
    _draw: function _draw() {
      var that = this;
      this.element.empty();

      // make view panel
      var container = $("<div>").addClass("TagContainer");
      this.element.append(container);
      this._drawTags();

      // make edit panel
      var editPanel = $("<div>").addClass("editPanel").css("visibility", "hidden");
      editPanel.append(this.options.beforeInputComponent);
      var input = $("<input>").addClass("autocompleteTag cf-form-control cf-form-control-prefix").attr("placeholder", this.options.placeholder);
      var addButton = $("<span>").text("+").addClass("addTagButton cf-autocomplete-add cf-input-appendbutton").attr("title", $.i18n._("nixps-cloudflow-Tags.addnew"));
      editPanel.append(input).append(addButton);
      this.element.append(editPanel);
      input.autocomplete({
        appendTo: that.element,
        minLength: 1,
        autoFocus: true,
        source: that.autocompleteSearchCallBack.bind(that)
      });
      this._switchEditPanel();
    },
    _drawTags: function _drawTags(pTriggerEvent) {
      var container = this.element.children(".TagContainer").empty();
      for (var i = 0; i < this.options.selectedItemsID.length; i++) {
        var key = this.options.selectedItemsID[i];
        var label = this.allTags[key];
        if (this.options.allowNotDefinedValues === true && label === undefined) {
          label = key;
        }
        if (label !== undefined) {
          var tagElem = $("<span>").addClass("cf-tag tag " + this.options.tagClass).text(label).data("item", key);
          var closeCross = $("<span>").addClass("fa fa-times-circle cf-tag-remove").attr("title", $.i18n._("nixps-cloudflow-manage.generic-remove")).css({
            "margin-right": 2
          });
          if (this.options.disabled === true) {
            closeCross.hide();
          }
          tagElem.prepend(closeCross);
          container.append(tagElem);
        } else {
          // item is unknown, remove it then from model
          delete this.options.selectedItemsID[i];
        }
      }
      this.options.selectedItemsID = $.map(this.options.selectedItemsID, function (elem) {
        return elem;
      });
      if (pTriggerEvent) {
        this._trigger("drawtags", null, {});
      }
    },
    /**
    * @description filter self the data to show.
    * @function
    * @name nixps-cloudflow.TagList#autocompleteSearchCallBack
    * @param {string} pRequest
    * @param {function} pResponseCB function to call with the requested data
    * @returns {undefined}
    */
    autocompleteSearchCallBack: function autocompleteSearchCallBack(pRequest, pResponseCB) {
      // always call pResponsCB even if in error state
      if (typeof pRequest.term === "string" && pRequest.term.length > 0) {
        var outputArray = [];
        var bound = this.options.maxPossibilitiesShow;
        if (this.allTags[pRequest.term] !== undefined) {
          // add element later
          bound--;
        }
        var expression = new RegExp($.ui.autocomplete.escapeRegex(pRequest.term));
        // start heuristic to find and try to order well
        // 
        // loop over all tags and until max allowed tags are found
        $.each(this.allTags, function ( /*key*/tag, value) {
          var index = value.search(expression);
          if (index >= 0 && value !== pRequest.term) {
            // if match and not same (this will be added later)
            if (index === 0) {
              // if begins, it is more important, put before
              outputArray.unshift(value);
            } else {
              // less important
              outputArray.push(value);
            }
            if (bound > 0) {
              bound--;
            } else {
              return false; //break
            }
          }
        });
        // if needed put the exact match in front
        if (this.allTags[pRequest.term] !== undefined) {
          // add element now
          outputArray.unshift(pRequest.term);
        }
        pResponseCB(outputArray);
      } else {
        pResponseCB();
      }
    },
    /**
     * @desc function runs when user click on remove cross button
     * @function
     * @name nixps-cloudflow.TagList#_removeHandler
     * @private
     * @param {event} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _removeHandler: function _removeHandler(pEvent, pData) {
      var key = $(pEvent.currentTarget).parent().data("item");
      var index = $(pEvent.currentTarget).parent().prevAll(".tag").length;
      if (this.options.selectedItemsID.includes(key)) {
        var that = this;
        $.when(this.options.removeItem(key, index)).done(function (pResult) {
          // remove item from list
          if (that.options.selectedItemsID[index] === key) {
            that.options.selectedItemsID.splice(index, 1);
          }
          // remove tag from ui
          $(pEvent.currentTarget).parent().remove();
          that.element.trigger("fieldcustomchange", {
            type: "remove",
            key: key
          });
        }).fail(function (pError) {
          throw new Error(pError);
        });
      }
    },
    /**
     * @description this function runs when the system had added already a tag. 
     * It provide the modele and ui update 
     * @function
     * @private
     * @name nixps-cloudflow.TagList#_addedHandler
     * @param {event} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _addedHandler: function _addedHandler(pEvent, pData) {
      var item = this.element.find(".editPanel input").val();
      if (typeof item === "string" && item.length > 0 && this.options.selectedItemsID.includes(item) === false) {
        var that = this;
        $.when(this.options.addItem(item)).done(function (pResult) {
          var key = item;
          var label = item;
          if (pResult !== undefined && pResult.key !== undefined) {
            key = pResult.key;
          }
          // update data model
          that.options.selectedItemsID.push(key);
          // clear input 
          that.element.find(".editPanel input").val("");
          // add element to the list ui
          var tagElem = $("<span>").addClass("cf-tag tag " + that.options.tagClass).text(label).data("item", key);
          var closeCross = $("<span>").addClass("cf-tag-remove fa fa-times-circle").attr("title", $.i18n._("nixps-cloudflow-manage.generic-remove")).css({
            "margin-right": 2
          });
          tagElem.prepend(closeCross);
          that.element.find(".noTagsText").remove();
          that.element.find(".TagContainer").append(tagElem);
          //add tag to global, static tagscontaner if not added already
          if (that.allTags[key] === undefined) {
            that.allTags[key] = label;
          }
          that._trigger("add", null, {
            key: key,
            label: label,
            newKey: !$.isEmptyObject(pResult) && pResult.newKey === true
          });
          that.element.trigger("fieldcustomchange", {
            type: "add",
            key: key
          });
        });
      } else {
        // tag already exists or is empty
      }
    },
    /**
     * @desc this function must hide and show the editpanel. 
     * This function must switch between edit and view mode
     * @function
     * @private 
     * @name nixps-cloudflow.TagList#switchEditPanel
     * @returns {undefined}
     */
    _switchEditPanel: function _switchEditPanel() {
      if (this.options.addInputField === true) {
        this.element.addClass("editMode").children(".editPanel").css("display", "").css("visibility", "");
      } else {
        this.element.removeClass("editMode").children(".editPanel").hide();
      }
    },
    /**
     * @desc handlers runs when user press a key. When user leave enter button, we add the tag
     * @function
     * @private
     * @name nixps-cloudflow.TagList#_keyDownHandler
     * @param {event} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _keyDownHandler: function _keyDownHandler(pEvent, pData) {
      // if press enter: add to list
      if (pEvent.which === 13) {
        var value = this.element.find(".editPanel input").val();
        if (typeof value === "string" && value.length > 0) {
          this._addedHandler(pEvent, pData);
          pEvent.preventDefault();
        } else {
          // do not prevent and close the form
        }
      }
    },
    /**
     * @description Add a new item to the list
     * @function
     * @name nixps-cloudflow.TagList#addItem
     * @param {string} pKey the internal id, key of the added item
     * @param {string} pValue the text label of the added item
     * @return {undefined}
     */
    addItem: function addItem(pKey, pValue, pTriggerEvent) {
      var that = this;
      return this.getAllItemDef.then(function () {
        // update data model
        that.options.selectedItemsID.push(pKey);
        // add element to the list ui
        var tagElem = $("<span>").addClass("cf-tag tag " + that.options.tagClass).text(pValue).data("item", pKey);
        var closeCross = $("<span>").addClass("cf-tag-remove fa fa-times-circle").attr("title", $.i18n._("nixps-cloudflow-manage.generic-remove")).css({
          "margin-right": 2
        });
        tagElem.prepend(closeCross);
        that.element.find(".noTagsText").remove();
        that.element.find(".TagContainer").append(tagElem);
        //add tag to global, static tagscontaner if not added already
        if (that.allTags[pKey] === undefined) {
          that.allTags[pKey] = pValue;
        }
        if (pTriggerEvent === true) {
          that.element.trigger("fieldcustomchange", {
            type: "add",
            key: pKey
          });
        }
      });
    },
    /**
     * @description function returning the tags. function added to be conform the formrender interfase.
     * @function
     * @name nixps-cloudflow.TagList#getValue
     * @returns {Array} array containing the ids of the tags
     */
    getValue: function getValue() {
      if (this.options.valueBasedBy === "value") {
        var that = this;
        if (that.options.allowNotDefinedValues === true) {
          return $.map(this.options.selectedItemsID, function (elem, index) {
            if (that.allTags[elem] === undefined) {
              return elem;
            }
            return that.allTags[elem];
          });
        } else {
          return $.map(this.options.selectedItemsID, function (elem, index) {
            return that.allTags[elem];
          });
        }
      } else {
        // default key
        return this.options.selectedItemsID;
      }
    },
    /**
     * @description function to set up the tags, tags must be know add reason
     * @function
     * @name nixps-cloudflow.TagList#setValue
     * @param {array} pTagIds array containing the ids to be show 
     * @returns {undefined}
     */
    setValue: function setValue(pTags) {
      var tags;
      if (pTags === undefined || pTags === null || pTags === "") {
        tags = [];
      } else if (typeof pTags === "string" && pTags.length > 0 || typeof pTags === "number" || typeof pTags === "boolean") {
        tags = [pTags];
      } else {
        tags = $.extend([], pTags);
      }
      if (this.options.valueBasedBy === "value") {
        var that = this;
        this.options.selectedItemsID = [];
        if (this.options.allowNotDefinedValues === true) {
          $.when(this.getAllItemDef, ++this.setValueCallingID).then(function (pAllItems, pCallingID) {
            if (that.dead === true) {
              return; // zombies
            }

            if (pCallingID !== that.setValueCallingID) {
              return;
            }
            that.options.selectedItemsID = tags;
            that._drawTags(true);
          });
        } else {
          $.when(this.getAllItemDef, ++this.setValueCallingID).then(function (pAllItems, pCallingID) {
            if (that.dead === true) {
              return; // zombies
            }

            if (pCallingID !== that.setValueCallingID) {
              return;
            }
            $.each(that.allTags, function (key, value) {
              if (tags.includes(value)) {
                that.options.selectedItemsID.push(key);
              }
            });
            that._drawTags(true);
          });
        }
        this._drawTags(false);
      } else {
        // default keys
        this.options.selectedItemsID = tags;
        this._drawTags(true);
      }
    },
    reset: function reset() {
      this.options.selectedItemsID = [];
    },
    /**
           * @function
           * @name nixps-cloudflow.TagList#_setOptions
           * @private
     * @brief sets the option
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "addInputField") {
        this._superApply(arguments);
        this._controlOptions();
        this._switchEditPanel();
      } else if (pKey === "disabled") {
        if (pValue !== this.options.disabled) {
          this._superApply(arguments);
          this._controlOptions();
          if (pValue === true) {
            this.element.find(".cf-tag-remove").hide();
          } else {
            this.element.find(".cf-tag-remove").css("display", "");
          }
        }
      } else {
        this._superApply(arguments);
        this._controlOptions();
        this._draw();
      }
    },
    /**
     * @description control the options to there espected interfase
     * @function
     * @private
     * @name nixps-cloudflow.TagList#_controlOptions
     * @return {undefined}
     */
    _controlOptions: function _controlOptions() {
      // control options
      if (typeof this.options.maxPossibilitiesShow !== "number") {
        throw new Error("TagList: input option maxPossibilitiesShow must be a number");
      }
      if (!Array.isArray(this.options.selectedItemsID)) {
        throw new Error("TagList: input option selectedItemsID must be a array");
      }
      if (typeof this.options.getAllItems !== "function") {
        throw new Error("TagList: input option getAllItems must be a function");
      }
      if (typeof this.options.removeItem !== "function") {
        throw new Error("TagList: input option removeItem must be a function");
      }
      if (typeof this.options.addItem !== "function") {
        throw new Error("TagList: input option addItem must be a function");
      }
      if (typeof this.options.tagClass !== "string") {
        throw new Error("TagList: input option tagClass must be a string");
      }
      if (typeof this.options.addInputField !== "boolean") {
        throw new Error("TagList: input option addInputField must be a boolean");
      }
    },
    _destroy: function _destroy() {
      this.dead = true;
      this.element.removeClass(this.widgetFullName).removeClass("cf-autocomplete");
      this.element.css({
        position: ""
      });
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],186:[function(require,module,exports){
"use strict";

module.exports = function (pLicense) {
  // no "portal" mains standalone version
  if (typeof pLicense.check === "function" && pLicense.check("portal") === false) {
    if (pLicense.check("quantumrip") && pLicense.check("dfe") === false) {
      return structuredClone(require("./default_installation_menu_standalone_rip.js"));
    } else if (pLicense.check("zepra")) {
      return structuredClone(require("./default_installation_menu_standalone_colorspace.js"));
    }
  }
  return structuredClone(require("./default_installation_menu.js"));
};

},{"./default_installation_menu.js":187,"./default_installation_menu_standalone_colorspace.js":188,"./default_installation_menu_standalone_rip.js":189}],187:[function(require,module,exports){
"use strict";

module.exports = [{
  "icon": "cf-icon cf-icon-home",
  "link": "/portal.cgi?home=1",
  "tooltip": "nixps-cloudflow-top_navigation.home",
  "text": "nixps-cloudflow-top_navigation.home",
  "license_datalink": false,
  "license": "max_cpu"
}, {
  "id": "notifications",
  "icon": "cf-icon cf-icon-bell",
  "link": "/portal.cgi?notifications=1",
  "text": "nixps-cloudflow-top_navigation.notifications",
  "tooltip": "nixps-cloudflow-top_navigation.notifications",
  "license": "portal",
  "admin_only": true,
  "predefined_badge_number": "notifications"
}, {
  "id": "assets",
  "icon": "cf-icon cf-icon-assets",
  "link": "/portal.cgi?asset=X",
  "text": "nixps-cloudflow-top_navigation.assets",
  "tooltip": "nixps-cloudflow-top_navigation.assets",
  "license": "portal"
}, {
  "id": "approvals",
  "icon": "cf-icon cf-icon-approve",
  "text": "nixps-cloudflow-top_navigation.approval",
  "tooltip": "nixps-cloudflow-top_navigation.approval",
  "license": "portal",
  "sub_buttons": [{
    "id": "emailtemplates",
    "icon": "cf-icon cf-icon-at",
    "link": "/portal.cgi?chains=1#emailtemplates",
    "text": "nixps-cloudflow-manage.templates-title_1",
    "tooltip": "nixps-cloudflow-manage.templates-title_1",
    "user_permission": "MANAGE_TEMPLATES"
  }, {
    "id": "allapprovalslist",
    "icon": "cf-icon cf-icon-approve",
    "link": "/portal.cgi?chains=1#all_approvals",
    "text": "nixps-cloudflow-manage.all_approvals-title",
    "tooltip": "nixps-cloudflow-manage.all_approvals-title",
    "user_permission": "MANAGE_CHAINS"
  }, {
    "id": "myapprovalslist",
    "icon": "cf-icon cf-icon-approval-my",
    "link": "/portal.cgi?chains=1#my_approvals",
    "text": "nixps-cloudflow-manage.my_approvals-title",
    "tooltip": "nixps-cloudflow-manage.my_approvals-title"
  }, {
    "id": "teamsapprovalslist",
    "icon": "cf-icon cf-icon-teams-approval",
    "link": "/portal.cgi?chains=1#team_approvals",
    "text": "nixps-cloudflow-manage.my_teams_approvals-title",
    "tooltip": "nixps-cloudflow-manage.my_teams_approvals-title"
  }]
}, {
  "id": "tasks",
  "icon": "cf-icon cf-icon-approval-overview",
  "text": "nixps-cloudflow-top_navigation.tasks",
  "tooltip": "nixps-cloudflow-top_navigation.tasks",
  "license": "project",
  "predefined_badge_number": "my_ready_tasks",
  "sub_buttons": [{
    "id": "alltasks",
    "icon": "cf-icon cf-icon-approval-overview",
    "link": "/portal.cgi?task_list=allTasks",
    "text": "nixps-cloudflow-manage.all_tasks-title",
    "tooltip": "nixps-cloudflow-manage.all_tasks-title",
    "user_permission": "MANAGE_JOBS"
  }, {
    "id": "mytasks",
    "icon": "cf-icon cf-icon-approval-overview",
    "link": "/portal.cgi?task_list=myTasks",
    "text": "nixps-cloudflow-manage.my_tasks-title",
    "tooltip": "nixps-cloudflow-manage.my_tasks-title"
  }, {
    "id": "allcalendars",
    "icon": "cf-icon cf-icon-task",
    "link": "/portal.cgi?calendar=allCalendars",
    "text": "all_calendars.title",
    "tooltip": "all_calendars.title",
    "user_permission": "ADMIN_USER"
  }]
}, "${jobs}", {
  "id": "kiosk",
  "icon": "cf-icon cf-icon-kiosk",
  "link": "/portal.cgi?hub&topbar=true",
  "tooltip": "nixps-cloudflow-top_navigation.kiosk",
  "text": "nixps-cloudflow-top_navigation.kiosk",
  "predefined_badge_number": "hold_in_kiosk",
  "license_datalink": false,
  "license": "max_cpu"
}, {
  "id": "flows",
  "icon": "cf-icon cf-icon-flows",
  "link": "/portal.cgi?quantum",
  "text": "nixps-cloudflow-top_navigation.flows",
  "tooltip": "nixps-cloudflow-top_navigation.flows",
  "license": "quantum",
  "user_permission": "MANAGE_QUANTUM"
}, {
  "id": "rip",
  "icon": "cf-icon cf-icon-rip",
  "text": "nixps-cloudflow-top_navigation.standalone_rip",
  "tooltip": "nixps-cloudflow-top_navigation.standalone_rip",
  "license": "quantumrip",
  "sub_buttons": [{
    "id": "standalonerip",
    "icon": "cf-icon cf-icon-sandbox",
    "link": "/standalone_rip_nebula.html#jobs",
    "text": "nixps-standalone-title.jobs",
    "tooltip": "nixps-standalone-title.jobs"
  }, {
    "id": "presets",
    "icon": "cf-icon cf-icon-adjust",
    "link": "/standalone_rip_nebula.html#presets",
    "text": "nixps-standalone-title.presets",
    "tooltip": "nixps-standalone-title.presets",
    "user_permission": "MANAGE_RIP_RESOURCES"
  }, {
    "id": "curves",
    "icon": "cf-icon cf-icon-bar-chart",
    "link": "/standalone_rip_nebula.html#curves",
    "text": "nixps-standalone-title.curves",
    "tooltip": "nixps-standalone-title.curves",
    "user_permission": "MANAGE_RIP_RESOURCES"
  }, {
    "id": "colorprofiles",
    "icon": "cf-icon cf-icon-landscape",
    "link": "/standalone_rip_nebula.html#colorprofiles",
    "text": "nixps-standalone-title.colorprofiles",
    "tooltip": "nixps-standalone-title.colorprofiles",
    "user_permission": "MANAGE_RIP_RESOURCES"
  }]
}, {
  "id": "patchplanner",
  "icon": "cf-icon cf-icon-patchplanner",
  "link": "/portal.cgi?patchplanner=1",
  "tooltip": "nixps-cloudflow-top_navigation.patchplanner",
  "text": "nixps-cloudflow-top_navigation.patchplanner",
  "license": "patchplanner",
  "user_permission": "USE_PATCHPLANNER",
  "prerelease": "still_show_patchplanner"
}, {
  "id": "variabledataprinting",
  "icon": "cf-icon cf-icon-vdp",
  "tooltip": "nixps-cloudflow-top_navigation.variabledataprinting",
  "text": "nixps-cloudflow-top_navigation.variabledataprinting",
  "license": "workflow_vdp_execute",
  "sub_buttons": [{
    "id": "variabledataprinting_queue",
    "icon": "cf-icon cf-icon-vdp",
    "link": "/portal.cgi/__CloudflowApps/VDP/index_queue.html",
    "tooltip": "nixps-cloudflow-top_navigation.variabledataprinting_queue",
    "text": "nixps-cloudflow-top_navigation.variabledataprinting_queue",
    "license": "workflow_vdp_execute"
  }, {
    "id": "variabledataprinting_archives",
    "icon": "cf-icon cf-icon-archive",
    "link": "/portal.cgi/__CloudflowApps/VDP/index_archives.html",
    "tooltip": "nixps-cloudflow-top_navigation.variabledataprinting_archives",
    "text": "nixps-cloudflow-top_navigation.variabledataprinting_archives",
    "license": "workflow_vdp_execute"
  }, {
    "id": "variabledataprinting_log",
    "icon": "cf-icon cf-icon-clipboard-list",
    "link": "/portal.cgi/__CloudflowApps/VDP/index_log.html",
    "tooltip": "nixps-cloudflow-top_navigation.variabledataprinting_log",
    "text": "nixps-cloudflow-top_navigation.variabledataprinting_log",
    "license": "workflow_vdp_execute"
  }]
}, {
  "id": "tectonics",
  "icon": "cf-icon cf-icon-tectonics",
  "tooltip": "nixps-cloudflow-top_navigation.tectonics",
  "text": "nixps-cloudflow-top_navigation.tectonics",
  "sub_buttons": [{
    "id": "tectonics_placement",
    "icon": "cf-icon cf-icon-placement",
    "tooltip": "nixps-cloudflow-top_navigation.tectonics_placement_tooltip",
    "text": "nixps-cloudflow-top_navigation.tectonics_placement",
    "link": "/portal.cgi/__CloudflowApps/tectonics/application/tectonics.html",
    "user_permission": "USE_PATCHPLANNER"
  }, {
    "id": "tectonics_cutoffs",
    "icon": "cf-icon cf-icon-cutoffs",
    "tooltip": "nixps-cloudflow-top_navigation.tectonics_cutoffs_tooltip",
    "text": "nixps-cloudflow-top_navigation.tectonics_cutoffs",
    "link": "/portal.cgi/__CloudflowApps/tectonics/application/cutoffs.html",
    "user_permission": "USE_PATCHPLANNER"
  }, {
    "id": "tectonics_archive",
    "icon_type": "classes",
    "icon": "cf-icon cf-icon-tectonics-archive",
    "tooltip": "nixps-cloudflow-top_navigation.tectonics_archive_tooltip",
    "text": "nixps-cloudflow-top_navigation.tectonics_archive",
    "link": "/portal.cgi/__CloudflowApps/tectonics/application/archive.html",
    "user_permission": "USE_PATCHPLANNER"
  }, {
    "id": "tectonics_queues_settings",
    "icon": "cf-icon cf-icon-queues",
    "tooltip": "nixps-cloudflow-top_navigation.tectonics_queues_settings_tooltip",
    "text": "nixps-cloudflow-top_navigation.tectonics_queues_settings",
    "link": "/portal.cgi/__CloudflowApps/tectonics/application/queues-setting.html",
    "user_permission": "ADMIN_USER"
  }, {
    "id": "tectonics_devices",
    "icon": "cf-icon cf-icon-printer",
    "tooltip": "nixps-cloudflow-resources.title-for-tectonics",
    "text": "nixps-cloudflow-resources.title-for-tectonics",
    "link": "/portal.cgi/__CloudflowApps/tectonics/application/devices.html",
    "user_permission": "ADMIN_USER"
  }],
  "license": "patchplanner",
  "user_permission": "USE_PATCHPLANNER"
}, {
  "id": "colorspace",
  "icon": "cf-icon cf-icon-colorspace",
  "tooltip": "nixps-cloudflow-top_navigation.colorspace",
  "text": "nixps-cloudflow-top_navigation.colorspace",
  "license": "zepra",
  "sub_buttons": [{
    "id": "colorspaceconfigurations",
    "icon": "cf-icon cf-icon-adjust",
    "link": "/colorspace/color.html#configurations",
    "tooltip": "nixps-cloudflow-top_navigation.colorspace_configuration",
    "text": "nixps-cloudflow-top_navigation.colorspace_configuration",
    "license": "zepra"
  }, {
    "id": "smartlink",
    "icon": "cf-icon cf-icon-color-gamut",
    "link": "/colorspace/color.html#smartlinks",
    "tooltip": "nixps-cloudflow-top_navigation.colorspace_smartlink",
    "text": "nixps-cloudflow-top_navigation.colorspace_smartlink",
    "license": "zepra"
  }, {
    "id": "iccprofiles",
    "icon": "cf-icon cf-icon-landscape",
    "link": "/colorspace/color.html#iccprofiles",
    "tooltip": "nixps-cloudflow-top_navigation.colorspace_iccprofiles",
    "text": "nixps-cloudflow-top_navigation.colorspace_iccprofiles",
    "license": "zepra"
  }, {
    "id": "colorbook",
    "icon": "cf-icon cf-icon-color-book",
    "link": "/colorspace/color.html#colorbooks",
    "tooltip": "nixps-cloudflow-top_navigation.colorspace_colorbooks",
    "text": "nixps-cloudflow-top_navigation.colorspace_colorbooks",
    "license": "zepra"
  }]
}, "**main_menu_buttons**", {
  "id": "mars",
  "icon": "cf-icon cf-icon-mars",
  "link": "/appsnebula/index.html",
  "tooltip": "nixps-cloudflow-top_navigation.mars",
  "text": "nixps-cloudflow-top_navigation.mars",
  "license": "mars",
  "user_permission": "ADMIN_USER",
  "license_or_preferences": "com.nixps.mars"
}, {
  // Dashboard
  "id": "dashboard",
  "icon": "cf-icon cf-icon-pie-chart",
  "text": "nixps-cloudflow-top_navigation.dashboard",
  "tooltip": "nixps-cloudflow-top_navigation.dashboard",
  "license": "max_cpu",
  "sub_buttons": [{
    "id": "maindashboard",
    "icon": "cf-icon cf-icon-bar-chart",
    "link": "/portal.cgi?portal=dashboard",
    "tooltip": "nixps-cloudflow-top_navigation.dashboard_main",
    "text": "nixps-cloudflow-top_navigation.dashboard_main",
    "user_permission": "ADMIN_USER"
  }, {
    "id": "logs",
    "icon": "cf-icon cf-icon-clipboard-list",
    "link": "/portal.cgi?logging=1",
    "tooltip": "nixps-cloudflow-top_navigation.dashboard_logs",
    "text": "nixps-cloudflow-top_navigation.dashboard_logs",
    "user_permission": "ADMIN_USER"
  }, {
    "id": "workables",
    "icon": "cf-icon cf-icon-maprun",
    "link": "/portal.cgi?config=1#workables",
    "tooltip": "nixps-cloudflow-top_navigation.dashboard_workables",
    "text": "nixps-cloudflow-top_navigation.dashboard_workables",
    "user_permission": "ADMIN_USER"
  }, {
    "id": "shareprogress",
    "icon": "cf-icon cf-icon-share",
    "link": "/portal.cgi?config=1#share_activity",
    "tooltip": "nixps-cloudflow-top_navigation.dashboard_share",
    "text": "nixps-cloudflow-top_navigation.dashboard_share",
    "license": "share",
    "user_permission": "MANAGE_SHARE"
  }, {
    "id": "tectonics_statistics",
    "icon": "cf-icon cf-icon-tectonics-statistics",
    "tooltip": "nixps-cloudflow-top_navigation.tectonics_statistics_tooltip",
    "text": "nixps-cloudflow-top_navigation.tectonics_statistics_tooltip",
    "link": "/portal.cgi/__CloudflowApps/tectonics/application/statistics0.html",
    "license": "patchplanner",
    "user_permission": "ADMIN_USER"
  }, {
    "id": "proofscope_renderers",
    "icon": "cf-icon cf-icon-cpu",
    "link": "/portal.cgi?proofscope=live_renderers",
    "tooltip": "nixps-proofscope-renderer.title",
    "text": "nixps-proofscope-renderer.title",
    "user_permission": "ADMIN_USER",
    "preferences_single": {
      "id": "com.nixps.proofscope",
      "key": "live_render"
    }
  }, {
    "id": "mongocloud",
    "icon": "cf-icon cf-icon-inspectcollection",
    "link": "/mongoCloud/mongoCloud_nebula.html",
    "tooltip": "nixps-cloudflow-CloudflowBar.inspect_tabels",
    "text": "nixps-cloudflow-CloudflowBar.inspect_tabels",
    "user_permission": "ADMIN_USER"
  } /*{
     "id": "trashbin",
     "icon": "cf-icon cf-icon-trash",
     "link": "/trashbin/trashbin.html",
     "tooltip": "nixps-cloudflow-top_navigation.trash_bin",
     "text": "nixps-cloudflow-top_navigation.trash_bin",
     "user_permission": "ADMIN_USER"
    }*/]
}, {
  // Settings
  "id": "settings",
  "icon": "cf-icon cf-icon-settings",
  "text": "nixps-cloudflow-top_navigation.settings",
  "tooltip": "nixps-cloudflow-top_navigation.settings",
  "sub_buttons": [{
    // Main settings
    "id": "mainsettings",
    "icon": "cf-icon cf-icon-adjust",
    "link": "/portal.cgi?config=1#settings",
    "tooltip": "nixps-cloudflow-top_navigation.settings_main",
    "text": "nixps-cloudflow-top_navigation.settings_main",
    "user_permission": "ADMIN_USER",
    "license": "max_cpu"
  }, {
    "id": "contacts",
    "icon": "cf-icon cf-icon-at",
    "link": "/portal.cgi?manageusers=1",
    "tooltip": "nixps-cloudflow-top_navigation.settings_contacts",
    "text": "nixps-cloudflow-top_navigation.settings_contacts",
    "user_permission": "MANAGE_USERS",
    "license": "max_cpu"
  }, {
    "id": "users",
    "icon": "cf-icon cf-icon-users",
    "link": "/portal.cgi?manageusers=1&usersonly=true",
    "tooltip": "nixps-cloudflow-top_navigation.settings_users",
    "text": "nixps-cloudflow-top_navigation.settings_users",
    "user_permission": "MANAGE_USERS",
    "license": "max_cpu"
  }, {
    "id": "scopes",
    "icon": "cf-icon cf-icon-scopes",
    "link": "/portal.cgi?config=1#scopes",
    "tooltip": "nixps-cloudflow-top_navigation.settings_scopes",
    "text": "nixps-cloudflow-top_navigation.settings_scopes",
    "user_permission": "MANAGE_SCOPES",
    "license": "max_cpu"
  }, {
    "id": "tenantmanagement",
    "icon": "fa fa-building-o",
    "link": "/portal.cgi?config=1#tenantmanagement",
    "tooltip": "nixps-cloudflow-top_navigation.settings_tenantmanagement",
    "text": "nixps-cloudflow-top_navigation.settings_tenantmanagement",
    "user_permission": "ADMIN_USER",
    "license": "multi_tenant"
  }, {
    "id": "agent",
    "icon": "cf-icon cf-icon-flows-map",
    "link": "/portal.cgi?config=1#agent",
    "tooltip": "nixps-cloudflow-top_navigation.settings_agent",
    "text": "nixps-cloudflow-top_navigation.settings_agent",
    "user_permission": "ADMIN_USER",
    "license": "agent"
  }, {
    "id": "sites",
    "icon": "cf-icon cf-icon-site",
    "link": "/portal.cgi?config=1#share_sites",
    "tooltip": "nixps-cloudflow-share-sites-title",
    "text": "nixps-cloudflow-share-sites-title",
    "user_permission": "MANAGE_SHARE",
    "license": "max_cpu"
  }, {
    "id": "sharesettings",
    "icon": "cf-icon cf-icon-share",
    "link": "/portal.cgi?share=1",
    "tooltip": "nixps-cloudflow-share-syncspec-title_2",
    "text": "nixps-cloudflow-share-syncspec-title_2",
    "license": "share",
    "user_permission": "MANAGE_SHARE",
    "tenant_view": false
  }, {
    "id": "datalink",
    "icon": "cf-icon cf-icon-datalink",
    "link": "/portal.cgi/__CloudflowApps/datalink/datalink.html",
    "tooltip": "nixps-cloudflow-top_navigation.datalink",
    "text": "nixps-cloudflow-top_navigation.datalink",
    "license": "datalink",
    "user_permission": "ADMIN_USER",
    "tenant_view": false
  }, {
    "id": "filestoresettings",
    "icon": "cf-icon cf-icon-filestore",
    "link": "/portal.cgi?config=1#filestores",
    "tooltip": "nixps-cloudflow-top_navigation.settings_filestores",
    "text": "nixps-cloudflow-top_navigation.settings_filestores",
    "user_permission": "ADMIN_USER",
    "license": "max_cpu"
  }, {
    "id": "foldermappings",
    "icon": "cf-icon cf-icon-folder-icon",
    "link": "/portal.cgi?config=1#foldermappingtable",
    "tooltip": "nixps-cloudflow-top_navigation.settings_foldermapping",
    "text": "nixps-cloudflow-top_navigation.settings_foldermapping",
    "user_permission": "ADMIN_USER",
    "license": "max_cpu"
  }, {
    "id": "workers",
    "icon": "cf-icon cf-icon-cpu",
    "link": "/portal.cgi?config=1#workers",
    "tooltip": "nixps-cloudflow-top_navigation.settings_workers",
    "text": "nixps-cloudflow-top_navigation.settings_workers",
    "user_permission": "ADMIN_USER",
    "license": "max_cpu",
    "tenant_view": false
  }, {
    "id": "resources",
    "icon": "cf-icon cf-icon-server",
    "link": "/portal.cgi?config=1#resources",
    "tooltip": "nixps-cloudflow-top_navigation.settings_resources",
    "text": "nixps-cloudflow-top_navigation.settings_resources",
    "user_permission": "ADMIN_USER",
    "license": "max_cpu"
  }, {
    "id": "outputdevices",
    "icon": "cf-icon cf-icon-printer",
    "link": "/portal.cgi?config=1#outputdevices",
    "tooltip": "paperdefinitions.title",
    "text": "paperdefinitions.title",
    "user_permission": "ADMIN_USER",
    "license": "max_cpu"
  }, {
    "id": "accounts",
    "icon": "cf-icon cf-icon-key-hole",
    "link": "/portal.cgi?config=1#accounts",
    "tooltip": "nixps-cloudflow-top_navigation.settings_accounts",
    "text": "nixps-cloudflow-top_navigation.settings_accounts",
    "user_permission": "ADMIN_USER",
    "license": "max_cpu"
  }, {
    "id": "mainmaintenance",
    "icon": "cf-icon cf-icon-maintenance-cogwheel",
    "link": "/portal.cgi?config=1#maintenance",
    "tooltip": "nixps-cloudflow-top_navigation.settings_systemtools",
    "text": "nixps-cloudflow-top_navigation.settings_systemtools",
    "license_datalink": false,
    "license": "max_cpu",
    "user_permission": "ADMIN_USER"
  }, {
    "id": "forms",
    "icon": "cf-icon cf-icon-editlist",
    "link": "/portal.cgi?form=editor",
    "text": "nixps-cloudlow-form.title",
    "tooltip": "nixps-cloudlow-form.title",
    "user_permission": {
      "condition": "or",
      "ruleA": "MANAGE_JOBS",
      "ruleB": "MANAGE_QUANTUM"
    }
  }, {
    "id": "patchplanner",
    "icon": "cf-icon cf-icon-patchplanner",
    "link": "/portal.cgi?patchplannerconfig=1",
    "tooltip": "nixps-cloudflow-top_navigation.settings_patchplanner",
    "text": "nixps-cloudflow-top_navigation.settings_patchplanner",
    "license": "patchplanner",
    "user_permission": "USE_PATCHPLANNER",
    "prerelease": "still_show_patchplanner"
  }, {
    "id": "tectonics_settings",
    "icon": "cf-icon cf-icon-tectonics",
    "tooltip": "nixps-cloudflow-top_navigation.tectonics_settings_tooltip",
    "text": "nixps-cloudflow-top_navigation.tectonics_settings_1",
    "link": "/portal.cgi/__CloudflowApps/tectonics/application/settings.html",
    "license": "patchplanner",
    "user_permission": "ADMIN_USER"
  },
  // {
  //     "id": "resources",
  //     "icon": "cf-icon cf-icon-printer",
  //     "link": "/portal.cgi?job=resource.configuration",
  //     "text": "nixps-cloudflow-resources.title",
  //     "tooltip": "nixps-cloudflow-resources.title",
  //     "user_permission": "MANAGE_JOBS"
  // },

  {
    "id": "license",
    "icon": "cf-icon cf-icon-unlock",
    "link": "/portal.cgi?config=1#license",
    "tooltip": "nixps-cloudflow-top_navigation.maintenance_license",
    "text": "nixps-cloudflow-top_navigation.maintenance_license",
    "user_permission": "ADMIN"
  }]
}, {
  "id": "learning",
  "icon": "cf-icon cf-icon-help-circle",
  "text": "nixps-cloudflow-CloudflowBar.manual",
  "tooltip": "nixps-cloudflow-CloudflowBar.manual",
  "license": "max_cpu",
  "sub_buttons": [{
    "id": "manual",
    "icon": "fa fa-book",
    "tooltip": "nixps-cloudflow-CloudflowBar.manual",
    "text": "nixps-cloudflow-CloudflowBar.manual",
    "link": "/manual/manual.html",
    "admin_only": true
  }, {
    "id": "api_manual",
    "icon": "fa fa-terminal",
    "tooltip": "nixps-cloudflow-CloudflowBar.api_manual",
    "text": "nixps-cloudflow-CloudflowBar.api_manual",
    "link": "/apireference/apireference.html",
    "admin_only": true
  }],
  "admin_only": true
}];

},{}],188:[function(require,module,exports){
"use strict";

module.exports = [{
  "id": "standalonecolorspace",
  "icon": "cf-icon cf-icon-home",
  "link": "/portal.cgi?home=1",
  "tooltip": "nixps-cloudflow-top_navigation.home",
  "text": "nixps-cloudflow-top_navigation.home",
  "license_datalink": false,
  "license": "max_cpu"
}, {
  "id": "notifications",
  "icon": "cf-icon cf-icon-bell",
  "link": "/portal.cgi?notifications=1",
  "text": "nixps-cloudflow-top_navigation.notifications",
  "tooltip": "nixps-cloudflow-top_navigation.notifications",
  "license": "max_cpu",
  "admin_only": true,
  "predefined_badge_number": "notifications"
}, {
  "id": "colorspace",
  "icon": "cf-icon cf-icon-colorspace",
  "tooltip": "nixps-cloudflow-top_navigation.colorspace",
  "text": "nixps-cloudflow-top_navigation.colorspace",
  "license": "zepra",
  "sub_buttons": [{
    "id": "colorspaceconfigurations",
    "icon": "cf-icon cf-icon-adjust",
    "link": "/colorspace/color.html#configurations",
    "tooltip": "nixps-cloudflow-top_navigation.colorspace_configuration",
    "text": "nixps-cloudflow-top_navigation.colorspace_configuration",
    "license": "zepra"
  }, {
    "id": "smartlink",
    "icon": "cf-icon cf-icon-color-gamut",
    "link": "/colorspace/color.html#smartlinks",
    "tooltip": "nixps-cloudflow-top_navigation.colorspace_smartlink",
    "text": "nixps-cloudflow-top_navigation.colorspace_smartlink",
    "license": "zepra"
  }, {
    "id": "iccprofiles",
    "icon": "cf-icon cf-icon-landscape",
    "link": "/colorspace/color.html#iccprofiles",
    "tooltip": "nixps-cloudflow-top_navigation.colorspace_iccprofiles",
    "text": "nixps-cloudflow-top_navigation.colorspace_iccprofiles",
    "license": "zepra"
  }, {
    "id": "colorbook",
    "icon": "cf-icon cf-icon-color-book",
    "link": "/colorspace/color.html#colorbooks",
    "tooltip": "nixps-cloudflow-top_navigation.colorspace_colorbooks",
    "text": "nixps-cloudflow-top_navigation.colorspace_colorbooks",
    "license": "zepra"
  }]
}, {
  "id": "mars",
  "icon": "cf-icon cf-icon-mars",
  "link": "/appsnebula/index.html",
  "tooltip": "nixps-cloudflow-top_navigation.mars",
  "text": "nixps-cloudflow-top_navigation.mars",
  "license": "mars",
  "user_permission": "ADMIN_USER",
  "license_or_preferences": "com.nixps.mars"
}, {
  // Dashboard
  "id": "dashboard",
  "icon": "cf-icon cf-icon-pie-chart",
  "text": "nixps-cloudflow-top_navigation.dashboard",
  "sub_buttons": [{
    "id": "logs",
    "icon": "cf-icon cf-icon-clipboard-list",
    "link": "/portal.cgi?logging=1",
    "tooltip": "nixps-cloudflow-top_navigation.dashboard_logs",
    "text": "nixps-cloudflow-top_navigation.dashboard_logs",
    "user_permission": "ADMIN"
  }]
}, {
  // Settings
  "id": "settings",
  "icon": "cf-icon cf-icon-settings",
  "text": "nixps-cloudflow-top_navigation.settings",
  "sub_buttons": [{
    // Main settings
    "id": "mainsettings",
    "icon": "cf-icon cf-icon-adjust",
    "link": "/portal.cgi?config=1#settings",
    "tooltip": "nixps-cloudflow-top_navigation.settings_main",
    "text": "nixps-cloudflow-top_navigation.settings_main",
    "user_permission": "ADMIN"
  }, {
    "id": "workers",
    "icon": "cf-icon cf-icon-cpu",
    "link": "/portal.cgi?config=1#workers",
    "tooltip": "nixps-cloudflow-top_navigation.settings_workers",
    "text": "nixps-cloudflow-top_navigation.settings_workers",
    "user_permission": "ADMIN",
    "license": "max_cpu",
    "tenant_view": false
  }, {
    "id": "license",
    "icon": "cf-icon cf-icon-unlock",
    "link": "/portal.cgi?config=1#license",
    "tooltip": "nixps-cloudflow-top_navigation.maintenance_license",
    "text": "nixps-cloudflow-top_navigation.maintenance_license",
    "user_permission": "ADMIN"
  }]
}, {
  "id": "learning",
  "icon": "cf-icon cf-icon-help-circle",
  "text": "nixps-cloudflow-CloudflowBar.manual",
  "sub_buttons": [{
    "id": "manual",
    "icon": "fa fa-book",
    "tooltip": "nixps-cloudflow-CloudflowBar.manual",
    "text": "nixps-cloudflow-CloudflowBar.manual",
    "link": "/manual/manual.html",
    "admin_only": true
  }],
  "admin_only": true
}];

},{}],189:[function(require,module,exports){
"use strict";

module.exports = [{
  "id": "standalonerip",
  "icon": "cf-icon cf-icon-home",
  "link": "/portal.cgi?home=1",
  "tooltip": "nixps-cloudflow-top_navigation.home",
  "text": "nixps-cloudflow-top_navigation.home",
  "license_datalink": false,
  "license": "max_cpu"
}, {
  "id": "notifications",
  "icon": "cf-icon cf-icon-bell",
  "link": "/portal.cgi?notifications=1",
  "text": "nixps-cloudflow-top_navigation.notifications",
  "tooltip": "nixps-cloudflow-top_navigation.notifications",
  "license": "max_cpu",
  "admin_only": true,
  "predefined_badge_number": "notifications"
}, {
  "id": "assets",
  "icon": "cf-icon cf-icon-assets",
  "link": "/portal.cgi?asset=X",
  "text": "nixps-cloudflow-top_navigation.assets",
  "tooltip": "nixps-cloudflow-top_navigation.assets",
  "license": "max_cpu"
}, {
  "id": "presets",
  "icon": "cf-icon cf-icon-adjust",
  "link": "/standalone_rip_nebula.html#presets",
  "text": "nixps-standalone-title.presets",
  "tooltip": "nixps-standalone-title.presets",
  "license": "max_cpu"
}, {
  "id": "curves",
  "icon": "cf-icon cf-icon-bar-chart",
  "link": "/standalone_rip_nebula.html#curves",
  "text": "nixps-standalone-title.curves",
  "tooltip": "nixps-standalone-title.curves",
  "license": "max_cpu"
}, {
  "id": "colorprofiles",
  "icon": "cf-icon cf-icon-landscape",
  "link": "/standalone_rip_nebula.html#colorprofiles",
  "text": "nixps-standalone-title.colorprofiles",
  "tooltip": "nixps-standalone-title.colorprofiles",
  "license": "max_cpu"
}, {
  // Dashboard
  "id": "dashboard",
  "icon": "cf-icon cf-icon-pie-chart",
  "text": "nixps-cloudflow-top_navigation.dashboard",
  "sub_buttons": [{
    "id": "logs",
    "icon": "cf-icon cf-icon-clipboard-list",
    "link": "/portal.cgi?logging=1",
    "tooltip": "nixps-cloudflow-top_navigation.dashboard_logs",
    "text": "nixps-cloudflow-top_navigation.dashboard_logs",
    "user_permission": "ADMIN"
  }]
}, {
  // Settings
  "id": "settings",
  "icon": "cf-icon cf-icon-settings",
  "text": "nixps-cloudflow-top_navigation.settings",
  "sub_buttons": [{
    // Main settings
    "id": "mainsettings",
    "icon": "cf-icon cf-icon-adjust",
    "link": "/portal.cgi?config=1#settings",
    "tooltip": "nixps-cloudflow-top_navigation.settings_main",
    "text": "nixps-cloudflow-top_navigation.settings_main",
    "user_permission": "ADMIN"
  }, {
    // File stores
    "id": "filestoresettings",
    "icon": "cf-icon cf-icon-filestore",
    "link": "/portal.cgi?config=1#filestores",
    "tooltip": "nixps-cloudflow-top_navigation.settings_filestores",
    "text": "nixps-cloudflow-top_navigation.settings_filestores",
    "user_permission": "ADMIN",
    "license": "max_cpu"
  }, {
    "id": "workers",
    "icon": "cf-icon cf-icon-cpu",
    "link": "/portal.cgi?config=1#workers",
    "tooltip": "nixps-cloudflow-top_navigation.settings_workers",
    "text": "nixps-cloudflow-top_navigation.settings_workers",
    "user_permission": "ADMIN",
    "license": "max_cpu",
    "tenant_view": false
  }, {
    "id": "resources",
    "icon": "cf-icon cf-icon-server",
    "link": "/portal.cgi?config=1#resources",
    "tooltip": "nixps-cloudflow-top_navigation.settings_resources",
    "text": "nixps-cloudflow-top_navigation.settings_resources",
    "user_permission": "ADMIN",
    "license": "max_cpu"
  }, {
    "id": "mainmaintenance",
    "icon": "cf-icon cf-icon-bell",
    "link": "/portal.cgi?config=1#maintenance",
    "tooltip": "nixps-cloudflow-top_navigation.settings_systemtools",
    "text": "nixps-cloudflow-top_navigation.settings_systemtools",
    "license_datalink": false,
    "license": "max_cpu",
    "user_permission": "ADMIN"
  }, {
    "id": "license",
    "icon": "cf-icon cf-icon-unlock",
    "link": "/portal.cgi?config=1#license",
    "tooltip": "nixps-cloudflow-top_navigation.maintenance_license",
    "text": "nixps-cloudflow-top_navigation.maintenance_license",
    "user_permission": "ADMIN"
  }]
}, {
  "id": "learning",
  "icon": "cf-icon cf-icon-help-circle",
  "text": "nixps-cloudflow-CloudflowBar.manual",
  "sub_buttons": [{
    "id": "manual",
    "icon": "fa fa-book",
    "tooltip": "nixps-cloudflow-CloudflowBar.manual",
    "text": "nixps-cloudflow-CloudflowBar.manual",
    "link": "/manual/manual.html",
    "admin_only": true
  }],
  "admin_only": true
}];

},{}],190:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var MenuButton = require("./MenuButton.js");
var Menu = function Menu(pButtons) {
  this.buttons = [];
  this.setButtons(pButtons);
};
Menu.fromJSON = function (pJSON) {
  return new Menu(pJSON);
};
Menu.prototype = {
  constructor: Menu,
  setButtons: function setButtons(pButtons) {
    this.buttons = [];
    if (Array.isArray(pButtons) && pButtons.length > 0) {
      for (var i = 0; i < pButtons.length; i++) {
        if (pButtons[i] instanceof MenuButton) {
          this.buttons.push(pButtons[i]);
        } else if (pButtons[i] && _typeof(pButtons[i]) === "object" && !Array.isArray(pButtons[i])) {
          this.buttons.push(MenuButton.fromJSON(pButtons[i]));
        }
      }
    }
  },
  getButtons: function getButtons() {
    return this.buttons;
  },
  getAllButtons: function getAllButtons(pIncludeGroup) {
    var buttons = [];
    for (var i = 0; i < this.buttons.length; i++) {
      if (this.buttons[i].hasSubButtons()) {
        if (pIncludeGroup === true) {
          buttons.push(this.buttons[i]);
        }
        var subButtons = this.buttons[i].getSubButtons();
        for (var s = 0; s < subButtons.length; s++) {
          buttons.push(subButtons[s]);
        }
      } else {
        buttons.push(this.buttons[i]);
      }
    }
    return buttons;
  },
  getTranslationFullDict: function getTranslationFullDict(pPrefixKey) {
    if (typeof pPrefixKey !== "string") {
      pPrefixKey = "sidebar-";
    }
    var dict = {};
    for (var i = 0; i < this.buttons.length; i++) {
      var text = this.buttons[i].getText();
      if (text && _typeof(text) === "object" && !Array.isArray(text) && Object.keys(text).length > 0) {
        for (var lang in text) {
          if (dict[lang] === undefined) {
            dict[lang] = {};
          }
          dict[lang][pPrefixKey + this.buttons[i].getUUID() + ".text"] = text[lang];
        }
      }
      var tooltip = this.buttons[i].getTooltip();
      if (tooltip && _typeof(tooltip) === "object" && !Array.isArray(tooltip) && Object.keys(tooltip).length > 0) {
        for (var lang in text) {
          if (dict[lang] === undefined) {
            dict[lang] = {};
          }
          dict[lang][pPrefixKey + this.buttons[i].getUUID() + ".tooltip"] = tooltip[lang];
        }
      }
    }
    return dict;
  },
  getTranslationUtilMemory: function getTranslationUtilMemory() {
    // retrieve information for the autofill of the translation proposition
    var memoryUtil = [];
    for (var i = 0; i < this.buttons.length; i++) {
      var text = this.buttons[i].getText();
      if (text && _typeof(text) === "object" && !Array.isArray(text) && Object.keys(text).length > 0) {
        memoryUtil.push(text);
      }
      var tooltip = this.buttons[i].getTooltip();
      if (tooltip && _typeof(tooltip) === "object" && !Array.isArray(tooltip) && Object.keys(tooltip).length > 0) {
        memoryUtil.push(tooltip);
      }
    }
    return memoryUtil;
  },
  clone: function clone() {
    return Menu.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var output = [];
    for (var i = 0; i < this.buttons.length; i++) {
      output.push(this.buttons[i].toJSON());
    }
    return output;
  }
};
module.exports = Menu;

},{"./MenuButton.js":191}],191:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var GUID = require("../../CloudflowUtil/js/GUID.js");

/**
 * @name MenuButton
 * @description Represents the menu button visible on the SideBar
 * @param {Object} pOptions 
 */
var MenuButton = function MenuButton(pOptions) {
  this.setID(pOptions.id);
  this.setLink(pOptions.link);
  this.setDynamicLink(pOptions.dynamic_link);
  this.setAction(pOptions.action);
  this.setIconType(pOptions.icon_type);
  this.setIcon(pOptions.icon);
  this.setTooltip(pOptions.tooltip);
  this.setText(pOptions.text);
  this.setClasses(pOptions.classes);
  this.setName(pOptions.name);
  this.setBadgeNumber(pOptions.badge_number);
  this.setPredefinedBadgeNumber(pOptions.predefined_badge_number);
  this.setContextBagdeNumber(pOptions.context_badge_number);
  this.setSubButtons(pOptions.sub_buttons);
  this.setOnlyAdmin(pOptions.admin_only);
  this.setLicense(pOptions.license);
  this.setLicenseOrPreferences(pOptions.license_or_preferences);
  this.setProduct(pOptions.product);
  this.setUserPermission(pOptions.user_permission);
  this.setUserAttributes(pOptions.user_attribute);
  this.setImagePath(pOptions.image_path);
  this.setSelectedImagePath(pOptions.selected_image_path);
  this.setPrereleaseKey(pOptions.prerelease);
  this.setPreferences(pOptions.preferences_single);
  this.setTenantView(pOptions.tenant_view);
  this.setCollectionInUse(pOptions.collection_in_use);
  this.setUUID(pOptions.uuid);
  if (this.hasLink() && this.hasSubButtons()) {
    throw new Error("menubutton has a link and sub buttons");
  }
};
MenuButton.fromJSON = function (pJSON) {
  return new MenuButton(pJSON);
};
MenuButton.prototype = {
  constructor: MenuButton,
  hasID: function hasID() {
    return this.id !== null;
  },
  setID: function setID(pID) {
    if (typeof pID === "string" && pID.length > 0) {
      this.id = pID;
    } else {
      this.id = null;
    }
  },
  getID: function getID() {
    return this.id;
  },
  hasLink: function hasLink() {
    return this.link !== null;
  },
  setLink: function setLink(pLink) {
    this.link = null;
    if (typeof pLink === "string" && pLink.length > 0) {
      this.link = pLink;
    } else if (Array.isArray(pLink)) {
      // value composer 
      this.link = structuredClone(pLink);
    }
  },
  getLink: function getLink() {
    return this.link;
  },
  /** @deprecated **/
  hasDynamicLink: function hasDynamicLink() {
    return typeof this.dynamic_link === "string" && this.dynamic_link.length > 0;
  },
  /** @deprecated **/
  setDynamicLink: function setDynamicLink(pDynamicLink) {
    this.dynamic_link = null;
    if (typeof pDynamicLink === "string" && pDynamicLink.length > 0) {
      this.dynamic_link = pDynamicLink;
    }
  },
  /** @deprecated **/
  getDynamicLink: function getDynamicLink() {
    return this.dynamic_link;
  },
  /** @deprecated **/
  calcDynamicLink: function calcDynamicLink(pOptions) {
    if (pOptions === undefined || pOptions === null) {
      pOptions = {
        "language": "en"
      };
    } else if (typeof pOptions.language !== "string" || pOptions.language.length <= 0) {
      pOptions.language = "en";
    }
    return this.dynamic_link.replace("<lang>", pOptions.language);
  },
  hasAction: function hasAction() {
    return typeof this.action === "string" && this.action.length > 0;
  },
  setAction: function setAction(pAction) {
    if (typeof pAction === "string") {
      this.action = pAction;
    } else {
      this.action = null;
    }
  },
  getAction: function getAction() {
    return this.action;
  },
  hasUUID: function hasUUID() {
    return typeof this.uuid === "string" && this.uuid.length > 0;
  },
  setUUID: function setUUID(pUUID) {
    if (typeof pUUID === "string" && pUUID.length > 0) {
      this.uuid = pUUID;
    } else {
      this.uuid = null;
    }
  },
  _getUUID: function _getUUID() {
    return this.uuid;
  },
  getUUID: function getUUID() {
    if (this.hasUUID() === false) {
      this.setUUID(GUID.generate());
    }
    return this.uuid;
  },
  setIconType: function setIconType(pIconType) {
    if (pIconType === "image") {
      this.icon_type = "image";
    } else {
      this.icon_type = "classes";
    }
  },
  getIconType: function getIconType() {
    return this.icon_type;
  },
  setIcon: function setIcon(pIcon) {
    if (typeof pIcon === "string") {
      this.icon = pIcon;
    } else {
      this.icon = "fa fa-square-o";
    }
  },
  getIcon: function getIcon() {
    return this.icon;
  },
  hasImagePath: function hasImagePath() {
    return typeof this.image_path === "string" && this.image_path.length > 0;
  },
  setImagePath: function setImagePath(pImagePath) {
    if (typeof pImagePath === "string" && pImagePath.length > 0) {
      this.image_path = pImagePath;
    } else {
      this.image_path = "";
    }
  },
  getImagePath: function getImagePath() {
    return this.image_path;
  },
  hasSelectedImagePath: function hasSelectedImagePath() {
    return typeof this.selected_image_path === "string" && this.selected_image_path.length > 0;
  },
  setSelectedImagePath: function setSelectedImagePath(pSelectedImagePath) {
    if (typeof pSelectedImagePath === "string" && pSelectedImagePath.length > 0) {
      this.selected_image_path = pSelectedImagePath;
    } else {
      this.selected_image_path = "";
    }
  },
  getSelectedImagePath: function getSelectedImagePath() {
    return this.selected_image_path;
  },
  hasTooltip: function hasTooltip() {
    return this.tooltip !== null;
  },
  setTooltip: function setTooltip(pTooltip) {
    if (typeof pTooltip === "string" && pTooltip.length > 0) {
      this.tooltip = pTooltip;
    } else if (pTooltip && _typeof(pTooltip) === "object" && !Array.isArray(pTooltip) && Object.keys(pTooltip).length !== 0) {
      this.tooltip = structuredClone(pTooltip);
    } else {
      this.tooltip = null;
    }
  },
  getTooltip: function getTooltip() {
    return this.tooltip;
  },
  getTranslatedTooltip: function getTranslatedTooltip(pLanguage) {
    return this._getTranslatedString(this.tooltip, pLanguage, ".tooltip");
  },
  setText: function setText(pText) {
    if (typeof pText === "string") {
      this.text = pText;
    } else if (pText && _typeof(pText) === "object" && !Array.isArray(pText)) {
      this.text = structuredClone(pText);
    } else {
      this.text = "";
    }
  },
  getText: function getText() {
    return this.text;
  },
  getTranslatedText: function getTranslatedText(pLanguage) {
    return this._getTranslatedString(this.text, pLanguage, ".text");
  },
  _getTranslatedString: function _getTranslatedString(pValue, pLanguage, pTranslationPostFix) {
    if (typeof pValue === "string" && pValue.length > 0) {
      return $.i18n._(pValue);
    } else if (this.hasUUID()) {
      // if data is in translated cfapp
      var key = "sidebar-" + this._getUUID() + pTranslationPostFix;
      if ($.i18n._(key) !== key) {
        return $.i18n._(key);
      }
    }
    if (pValue && _typeof(pValue) === "object") {
      if (typeof pValue[pLanguage] === "string" && pValue[pLanguage].length > 0) {
        return pValue[pLanguage];
      } else if (typeof pValue["en"] === "string") {
        return pValue["en"];
      }
    }
    return "";
  },
  hasBadgeNumber: function hasBadgeNumber() {
    return this.badge_number !== null;
  },
  setBadgeNumber: function setBadgeNumber(pBadgeNumber) {
    if (typeof pBadgeNumber === "string" || typeof pBadgeNumber === "number") {
      this.badge_number = pBadgeNumber;
    } else if (typeof pBadgeNumber === "function") {
      this.badge_number = pBadgeNumber;
    } else if (pBadgeNumber !== null && _typeof(pBadgeNumber) === "object" && !Array.isArray(pBadgeNumber)) {
      this.badge_number = structuredClone(pBadgeNumber);
    } else {
      this.badge_number = null;
    }
  },
  getBadgeNumber: function getBadgeNumber() {
    return this.badge_number;
  },
  setPredefinedBadgeNumber: function setPredefinedBadgeNumber(pPredefinedBadgeNumber) {
    if (typeof pPredefinedBadgeNumber === "string" && pPredefinedBadgeNumber.length > 0) {
      this.predefined_badge_number = pPredefinedBadgeNumber;
    } else {
      this.predefined_badge_number = null;
    }
  },
  getPredefinedBadgeNumber: function getPredefinedBadgeNumber() {
    return this.predefined_badge_number;
  },
  setContextBagdeNumber: function setContextBagdeNumber(pContextJSON) {
    if (pContextJSON && _typeof(pContextJSON) === "object" && !Array.isArray(pContextJSON)) {
      this.context_badge_number = pContextJSON;
    } else {
      this.context_badge_number = null;
    }
  },
  getContextBadgeNumber: function getContextBadgeNumber() {
    return this.context_badge_number;
  },
  setClasses: function setClasses(pClasses) {
    if (typeof pClasses === "string") {
      this.classes = pClasses;
    } else {
      this.classes = "";
    }
  },
  getClasses: function getClasses() {
    return this.classes;
  },
  /**
   * @deprecated useless, name has no added value, added as backwards comp. for somehing hacky
   */
  hasName: function hasName() {
    return typeof this.name === "string" && this.name.length > 0;
  },
  /**
   * @deprecated useless, name has no added value, added as backwards comp. for somehing hacky
   */
  setName: function setName(pName) {
    if (typeof pName === "string" && pName.length > 0) {
      this.name = pName;
    } else {
      this.name = null;
    }
  },
  /**
   * @deprecated useless, name has no added value, added as backwards comp. for somehing hacky
   */
  getName: function getName() {
    return this.name;
  },
  hasSubButtons: function hasSubButtons() {
    return Array.isArray(this.sub_buttons) && this.sub_buttons.length > 0;
  },
  setSubButtons: function setSubButtons(pButtons) {
    this.sub_buttons = null;
    if (Array.isArray(pButtons) && pButtons.length > 0) {
      this.sub_buttons = [];
      for (var i = 0; i < pButtons.length; i++) {
        if (pButtons[i] instanceof MenuButton) {
          this.sub_buttons.push(pButtons[i]);
        } else if (pButtons[i] && _typeof(pButtons[i]) === "object" && !Array.isArray(pButtons[i])) {
          this.sub_buttons.push(MenuButton.fromJSON(pButtons[i]));
        }
      }
    }
  },
  getSubButtons: function getSubButtons() {
    return this.sub_buttons;
  },
  removeSubButton: function removeSubButton(pButton) {
    if (this.hasSubButtons() === false) {
      throw new Error("could not remove if no subbuttons are there");
    }
    var removedButton;
    if (pButton instanceof MenuButton) {
      removedButton = pButton;
    } else if (pButton && _typeof(pButton) === "object" && !Array.isArray(pButton)) {
      removedButton = MenuButton.fromJSON(pButton);
    }
    for (var i = 0; i < this.sub_buttons.length; i++) {
      if (this.sub_buttons[i].isEqual(removedButton)) {
        this.sub_buttons.splice(i, 1);
        return i;
      }
    }
    return -1;
  },
  insertSubButton: function insertSubButton(pNewIndex, pNewButton) {
    if (typeof pNewIndex !== "number" || pNewIndex < 0) {
      throw new Error("index must be a positive number");
    }
    if (Array.isArray(this.sub_buttons) === false) {
      this.sub_buttons = [];
    }
    var newButton;
    if (pNewButton instanceof MenuButton) {
      newButton = pNewButton.clone();
    } else if (pNewButton && _typeof(pNewButton) === "object" && !Array.isArray(pNewButton)) {
      newButton = MenuButton.fromJSON(pNewButton);
    }
    this.sub_buttons.splice(pNewIndex, 0, newButton);
  },
  _cleanForExternal: function _cleanForExternal() {
    this.classes = "";
    this.admin_only = false;
    this.license = null;
    this.product = null;
    this.prerelease = null;
    this.predefined_badge_number = null;
    delete this.dynamic_link;
    delete this.license_datalink;
    delete this.license_or_preferences;
    delete this.preferences_single;
  },
  setOnlyAdmin: function setOnlyAdmin(pOnlyAdmin) {
    if (pOnlyAdmin === true) {
      this.admin_only = true;
    } else {
      this.admin_only = false;
    }
  },
  isOnlyAdmin: function isOnlyAdmin() {
    return this.admin_only;
  },
  setLicense: function setLicense(pLicense) {
    if (typeof pLicense === "string" && pLicense.length > 0) {
      this.license = pLicense;
    } else {
      this.license = null;
    }
  },
  getLicense: function getLicense() {
    return this.license;
  },
  setLicenseOrPreferences: function setLicenseOrPreferences(pLicenseOrPreferences) {
    if (typeof pLicenseOrPreferences === "string" && pLicenseOrPreferences.length > 0) {
      this.license_or_preferences = pLicenseOrPreferences;
    } else {
      this.license_or_preferences = null;
    }
  },
  getLicenseOrPreferences: function getLicenseOrPreferences() {
    return this.license_or_preferences;
  },
  setProduct: function setProduct(pProduct) {
    if (typeof pProduct === "string" && pProduct.length > 0) {
      this.product = pProduct;
    } else {
      this.product = null;
    }
  },
  getProduct: function getProduct() {
    return this.product;
  },
  setUserPermission: function setUserPermission(pUserPermission) {
    if (this._checkUserPermission(pUserPermission)) {
      this.user_permission = structuredClone(pUserPermission);
    } else {
      this.user_permission = null;
    }
  },
  getUserPermission: function getUserPermission() {
    return this.user_permission;
  },
  _checkUserPermission: function _checkUserPermission(pUserPermission) {
    if (typeof pUserPermission === "string" && pUserPermission.length > 0) {
      return true;
    } else if (pUserPermission && _typeof(pUserPermission) === "object" && !Array.isArray(pUserPermission)) {
      if (!["or", "and"].includes(pUserPermission.condition)) {
        console.error("Menu item found with incorrect user_permission, unknown condition");
        return false;
      }
      return this._checkUserPermission(pUserPermission.ruleA) && this._checkUserPermission(pUserPermission.ruleB);
    } else if (pUserPermission !== undefined && pUserPermission !== null && pUserPermission !== "") {
      console.error("Menu item found with incorrect user_permission, unknown interface");
    }
    return false;
  },
  setUserAttributes: function setUserAttributes(pUserAttributes) {
    if (pUserAttributes === undefined || pUserAttributes === null || pUserAttributes === "") {
      this.user_attribute = null;
    } else if (typeof pUserAttributes === "string" && pUserAttributes.length > 0) {
      this.user_attribute = pUserAttributes;
    } else if (Array.isArray(pUserAttributes) && pUserAttributes.length > 0) {
      this.user_attribute = pUserAttributes.slice(0);
    } else if (_typeof(pUserAttributes) === "object" && (pUserAttributes.condition === "and" || pUserAttributes.condition === "or")) {
      this.user_attribute = structuredClone(pUserAttributes);
    } else {
      this.user_attribute = null;
    }
  },
  /**
   * @name MenuButton.getUserAttributes
   * @description get all the config to filter on user_attributes
   * @returns user_attributes
   */
  getUserAttributes: function getUserAttributes() {
    return this.user_attribute;
  },
  /**
   * @desprecated use MenuButton.getUserAttributes
   * @name MenuButton.getUserAttribute
   */
  getUserAttribute: function getUserAttribute() {
    return this.getUserAttributes();
  },
  setPrereleaseKey: function setPrereleaseKey(pPrereleaseKey) {
    if (typeof pPrereleaseKey === "string" && pPrereleaseKey.length > 0) {
      this.prerelease = pPrereleaseKey;
    } else {
      this.prerelease = null;
    }
  },
  getPrereleaseKey: function getPrereleaseKey() {
    return this.prerelease;
  },
  setPreferences: function setPreferences(pPrefences) {
    if (pPrefences !== undefined && typeof pPrefences.id === "string" && typeof pPrefences.key === "string") {
      this.preferences_single = Object.assign({}, pPrefences);
    } else {
      this.preferences_single = null;
    }
  },
  getPreferences: function getPreferences() {
    return this.preferences_single;
  },
  setTenantView: function setTenantView(pTenantView) {
    this.tenant_view = null;
    if (typeof pTenantView === "boolean") {
      // true: only visible on tentant
      // false: only visible when no tenant
      // null visible on both
      this.tenant_view = pTenantView;
    }
  },
  getTentantView: function getTentantView() {
    return this.tenant_view;
  },
  setCollectionInUse: function setCollectionInUse(pCollectionInUse) {
    this.collection_in_use = null;
    if (typeof pCollectionInUse === "string" && pCollectionInUse.length > 0) {
      this.collection_in_use = pCollectionInUse;
    }
  },
  getCollectionInUse: function getCollectionInUse() {
    return this.collection_in_use;
  },
  isEqual: function isEqual(pMenuButton) {
    if (this.icon !== pMenuButton.getIcon()) {
      return false;
    }
    if (_typeof(this.text) !== _typeof(pMenuButton.getText())) {
      return false;
    }
    if (_.isEqual(this.text, pMenuButton.getText()) === false) {
      return false;
    }
    if (this.hasUUID() && pMenuButton.hasUUID() && this._getUUID() !== pMenuButton._getUUID()) {
      return false;
    }
    if (this.user_permission !== pMenuButton.getUserPermission()) {
      return false;
    }
    if (this.hasLink()) {
      return _.isEqual(this.getLink(), pMenuButton.getLink());
    } else if (this.hasSubButtons() && pMenuButton.hasSubButtons()) {
      if (this.sub_buttons.length !== pMenuButton.getSubButtons().length) {
        return false;
      }
      for (var i = 0; i < this.sub_buttons.length; i++) {
        if (this.sub_buttons[i].isEqual(pMenuButton.getSubButtons()[i]) === false) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  },
  clone: function clone() {
    var cloneMenuButton = MenuButton.fromJSON(this.toJSON());
    // regenerate the uuid for main
    if (cloneMenuButton.hasUUID()) {
      cloneMenuButton.setUUID(GUID.generate());
    }
    // regenerate the uuid for sub buttons
    if (cloneMenuButton.hasSubButtons()) {
      for (var i = 0; i < cloneMenuButton.sub_buttons.length; i++) {
        if (cloneMenuButton.sub_buttons[i].hasUUID()) {
          cloneMenuButton.sub_buttons[i].setUUID(GUID.generate());
        }
      }
    }
    return cloneMenuButton;
  },
  cloneToExternal: function cloneToExternal(pLanguage) {
    if (this.hasID()) {
      // clone a cloudflow own icon
      var clone = this.clone();
      clone.setID(null);
      clone._cleanForExternal();
      // move translation strings to translation dictionary
      if (this.hasUUID() === false) {
        if (typeof this.getText() === "string" && this.getText().length > 0) {
          var textLangDict = {
            "en": $.i18n._(this.getText())
          };
          if (typeof pLanguage === "string" && pLanguage.length > 0 && pLanguage !== "en") {
            textLangDict[pLanguage] = textLangDict["en"];
          }
          this.setText(textLangDict);
        }
        if (this.hasTooltip() && typeof this.getTooltip() === "string" && this.getTooltip().length > 0) {
          var tooltipLangDict = {
            "en": $.i18n._(this.getTooltip())
          };
          if (typeof pLanguage === "string" && pLanguage.length > 0 && pLanguage !== "en") {
            tooltipLangDict[pLanguage] = tooltipLangDict["en"];
          }
          this.setTooltip(tooltipLangDict);
        }
      }
      if (clone.hasSubButtons()) {
        for (var i = 0; i < clone.sub_buttons.length; i++) {
          clone.sub_buttons[i] = clone.sub_buttons[i].cloneToExternal(pLanguage);
        }
      }
      // transform complex permission to one permission
      // because ui is still basic and can not handle complex stuff
      var userPerm = clone.getUserPermission();
      if (userPerm && _typeof(userPerm) === "object" && userPerm.constructor && userPerm.constructor.name === "Object") {
        clone.setUserPermission(clone.getUserPermission().ruleA);
      }
      return clone;
    } else {
      // clone custom icon
      var clone = this.clone();
      clone._cleanForExternal();
      return clone;
    }
  },
  toFullJSON: function toFullJSON() {
    var outputJSON = {
      "id": this.id,
      "link": this.link,
      "dynamic_link": this.dynamic_link,
      "action": this.getAction(),
      "icon_type": this.icon_type,
      "icon": this.icon,
      "image_path": this.getImagePath(),
      "selected_image_path": this.getSelectedImagePath(),
      "tooltip": this.tooltip === null ? "" : this.tooltip,
      "text": this.text,
      "classes": this.getClasses(),
      "sub_buttons": [],
      "admin_only": this.admin_only == true,
      "license": "",
      "license_or_preferences": this.getLicenseOrPreferences(),
      "user_permission": "",
      "user_attribute": "",
      "badge_number": this.badge_number,
      "predefined_badge_number": this.predefined_badge_number,
      "context_badge_number": this.context_badge_number,
      "tenant_view": this.tenant_view,
      "uuid": this._getUUID()
    };
    if (this.hasSubButtons()) {
      outputJSON.sub_buttons = [];
      for (var i = 0; i < this.sub_buttons.length; i++) {
        outputJSON.sub_buttons.push(this.sub_buttons[i].toFullJSON());
      }
    }
    if (this.getLicense() !== null) {
      outputJSON.license = this.getLicense();
    }
    if (this.getProduct() !== null) {
      outputJSON.product = this.getProduct();
    }
    if (this.getUserPermission() !== null) {
      outputJSON.user_permission = this.getUserPermission();
    }
    if (this.getUserAttributes() !== null) {
      outputJSON.user_attribute = this.getUserAttributes();
    }
    if (this.getPrereleaseKey() !== null) {
      outputJSON.prerelease = this.getPrereleaseKey();
    }
    if (this.getPreferences() !== undefined && this.getPreferences() !== null) {
      outputJSON.preferences_single = this.getPreferences();
    }
    if (this.getCollectionInUse() !== null) {
      outputJSON.collection_in_use = this.getCollectionInUse();
    }
    return outputJSON;
  },
  toJSON: function toJSON() {
    var outputJSON = {
      "icon_type": this.icon_type,
      "icon": this.icon,
      "tooltip": this.tooltip === null ? "" : this.tooltip,
      "text": this.text,
      "classes": this.getClasses()
    };
    if (this.hasLink()) {
      outputJSON.link = this.getLink();
    }
    if (this.hasDynamicLink()) {
      outputJSON.dynamic_link = this.getDynamicLink();
    }
    if (this.id !== null) {
      outputJSON.id = this.id;
    }
    if (this.hasAction()) {
      outputJSON.action = this.getAction();
    }
    if (this.hasImagePath()) {
      outputJSON.image_path = this.image_path;
      outputJSON.selected_image_path = this.selected_image_path;
    }
    if (this.hasName()) {
      outputJSON.name = this.getName();
    }
    if (this.badge_number !== null) {
      outputJSON.badge_number = this.badge_number;
    }
    if (this.predefined_badge_number !== null) {
      outputJSON.predefined_badge_number = this.predefined_badge_number;
    }
    if (this.context_badge_number !== null) {
      outputJSON.context_badge_number = this.context_badge_number;
    }
    if (this.sub_buttons !== null) {
      outputJSON.sub_buttons = [];
      for (var i = 0; i < this.sub_buttons.length; i++) {
        outputJSON.sub_buttons.push(this.sub_buttons[i].toJSON());
      }
    }
    if (this.isOnlyAdmin() === true) {
      outputJSON.admin_only = true;
    }
    if (this.getLicense() !== null) {
      outputJSON.license = this.getLicense();
    }
    if (this.getLicenseOrPreferences() !== null) {
      outputJSON.license_or_preferences = this.getLicenseOrPreferences();
    }
    if (this.getProduct() !== null) {
      outputJSON.product = this.getProduct();
    }
    if (this.getUserPermission() !== null) {
      outputJSON.user_permission = this.getUserPermission();
    }
    if (this.getUserAttributes() !== null) {
      outputJSON.user_attribute = this.getUserAttributes();
    }
    if (this.getPrereleaseKey() !== null) {
      outputJSON.prerelease = this.getPrereleaseKey();
    }
    if (this.getPreferences() !== undefined && this.getPreferences() !== null) {
      outputJSON.preferences_single = this.getPreferences();
    }
    if (this.getTentantView() !== null) {
      outputJSON.tenant_view = this.getTentantView();
    }
    if (this.getCollectionInUse() !== null) {
      outputJSON.collection_in_use = this.getCollectionInUse();
    }
    if (this.hasUUID()) {
      outputJSON.uuid = this._getUUID();
    }
    return outputJSON;
  }
};
module.exports = MenuButton;

},{"../../CloudflowUtil/js/GUID.js":89}],192:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("../../../polyfill/polyfill.js");
var ApplicationPreferences = require("../../Preferences/js/ApplicationPreferences.js");
var getDefaultInstallationMenuButtons = require("../defaults/default_installation.js");
var templatesFactory = require("./default_installation_factory.js");
var PredefinedBadgeNumbers = require("./predefined_badgenumber.js");
var FixButtonIDOptions = require("./predefined_buttonid_options.js");
var InstalledApps = require("./default_installation_installedapps.js");
var TemporyBrowserObjectCache = require("../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
var FileConnection = require("../../CloudflowUtil/js/FileConnection.js");
var UserPreferences = require("../../Preferences/js/UserPreferences.js");
var ExpressionToJS = require("../../../pagebuilder/js/ExpressionToJS.js");
var User = require("../../User/js/User.js");
var License = require("../../License/js/License.js");
var Context = require("../../../pagebuilder/js/Context.js");
var Menu = require("./Menu.js");
var Device = require("../../PWA/js/Device.js");
var kKeysToRemove = new Set(["mediawedge"]); // all the ids that needs to remove dynamically

var kDefaultCloudflowPath = "cloudflow://PP_FILE_STORE/Menu/sitemap.json";
var templates;
var templatesResourcePromise;
function getAllTemplates() {
  if (templates !== undefined) {
    return templates;
  }
  return new Promise(function (pResolve, pReject) {
    // templatesResourcePromise can be undefined or be a promise
    // if it is a promise, this means it need to wait, because it is loading the resourses like the preferences
    Promise.resolve(templatesResourcePromise).then(function () {
      templatesFactory(ApplicationPreferences).then(function (pTemplates) {
        if (pTemplates && _typeof(pTemplates) === "object") {
          templates = structuredClone(pTemplates);
          pResolve(templates);
        } else {
          templates = {};
          pResolve(templates);
        }
      }, function (pError) {
        templates = {};
        pResolve(templates);
      });
    }, function (pError) {
      templates = {};
      pResolve(templates);
    });
  });
}
var preferences;
var preferencesPromise;
function getAllPreferences() {
  if (preferences !== undefined) {
    return preferences; // cache
  }

  preferences = {};
  if (preferencesPromise === undefined) {
    preferencesPromise = api_defer.preferences.get_for_realm("system", "", "com.nixps.proofscope", "live_render");
  }
  var defs = [api_defer.preferences.get_for_current_user("com.nixps.mars", "showUI"), preferencesPromise];
  return Promise.all(defs).then(function (pResults) {
    var pPreferencesMars = pResults[0];
    var pPreferencedLiveRender = pResults[1];
    if (typeof pPreferencesMars.preferences === "boolean") {
      preferences["com.nixps.mars"] = pPreferencesMars.preferences;
    }
    if (typeof pPreferencedLiveRender.preferences === "boolean") {
      preferences["com.nixps.proofscope"] = {
        live_render: pPreferencedLiveRender.preferences
      };
    }
    return preferences;
  });
}
function setPreference(pApplicationID, pValue) {
  if (pApplicationID === "com.nixps.proofscope") {
    preferences["com.nixps.proofscope"] = {
      live_render: pValue
    };
  }
}
var collectionInUse = undefined;
function getAllConnectionInUse() {
  if (collectionInUse !== undefined) {
    return collectionInUse; // cache
  }

  var def = api_defer.database.document.list_with_options("nucleus.syncspec", [], [], ["_id"], {
    first: 0,
    maximum: 1
  }).then(function (pResult) {
    if (collectionInUse === undefined) {
      collectionInUse = {};
    }
    collectionInUse["nucleus.syncspec"] = pResult && Array.isArray(pResult.documents) && pResult.documents.length > 0;
  }, function (pError) {
    if (collectionInUse === undefined) {
      collectionInUse = {};
    }
    // error while calling, i assume it can not be used
    collectionInUse["nucleus.syncspec"] = false;
  });
  return def.then(function () {
    return collectionInUse;
  });
}
var settings;
var settingsPromise;
function getSettings() {
  if (settings && typeof settings.use_custom_menu === "boolean") {
    return settings;
  }
  if (settingsPromise && typeof settingsPromise.then === "function") {
    return settingsPromise;
  }
  settingsPromise = api_defer.preferences.get_for_realm("system", "", "portal", "").then(function (pPreferences) {
    settings = {
      use_custom_menu: false,
      menu_location: kDefaultCloudflowPath
    };
    if (pPreferences !== undefined && pPreferences.preferences !== undefined) {
      if (typeof pPreferences.preferences.use_custom_menu === "boolean" && typeof pPreferences.preferences.menu_location === "string") {
        settings = Object.assign(settings, pPreferences.preferences);
      }
    }
    return settings;
  });
  return settingsPromise;
}
function setSettings(pSettings) {
  settings = pSettings;
}
function setSettingsURL(pUseCustomMenu, pURL) {
  if (settings === undefined) {
    settings = {};
  }
  if (typeof pUseCustomMenu === "boolean") {
    settings.use_custom_menu = pUseCustomMenu;
  }
  if (typeof pURL === "string" && pURL.length > 0) {
    settings.menu_location = pURL;
    if (settings.use_custom_menu === undefined) {
      settings.use_custom_menu = true; // default value
    }
  } else {
    settings.menu_location = "";
    if (settings.use_custom_menu === undefined) {
      settings.use_custom_menu = false; // default value
    }
  }

  return ApplicationPreferences.saveSystemValue("portal", "", settings);
}
var MenuHandler = function MenuHandler(pInputType, pOptions, pRelativePath, pUser, pLicense, pUserPreferences, pCacheObject) {
  this.inputType = pInputType;
  this.inputParameters = pOptions;
  this.relativePath = pRelativePath;
  this.userDef = this.setUser(pUser);
  this.licenseDef = this.setLicense(pLicense);
  this.buttons;
  this.templateDef;
  this.allPreferencesDef;
  this.installedAppsDef;
  this.collectionsInUseDef;
  if (pCacheObject !== undefined && pCacheObject !== null) {
    if (Array.isArray(pCacheObject.buttons)) {
      this.buttons = pCacheObject.buttons;
    }
    if (pCacheObject.templates !== undefined) {
      this.templateDef = pCacheObject.templates;
    }
    if (pCacheObject.allPreferences !== undefined) {
      this.allPreferencesDef = pCacheObject.allPreferences;
    }
    if (pCacheObject.installedApps !== undefined) {
      this.installedAppsDef = pCacheObject.installedApps;
    }
    if (pCacheObject.collectionsInUse !== undefined) {
      this.collectionsInUseDef = pCacheObject.collectionsInUse;
    }
  }
  if (this.inputType === "settings") {
    if (this.templateDef === undefined) {
      this.templateDef = getAllTemplates();
    }
    if (this.installedAppsDef === undefined) {
      this.installedAppsDef = InstalledApps.getDefaultMenuItems(this.license);
    }
  }
  this.userpreferencesDef = this.setUserPreferences(pUserPreferences);
};
MenuHandler.filter_buttons = function (pButtons, pUser, pLicense, pPreferencesObject, pAttributeNames, pIgnoreAttributeNames, pUserPreferences) {
  var pCollectionsInUse = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
  var visibleButtons = [];
  for (var i = 0; i < pButtons.length; i++) {
    // check if needed to update the button with new info
    if (typeof pButtons[i].id === "string" && pButtons[i].id.length > 0) {
      if (kKeysToRemove.has(pButtons[i].id)) {
        // those keys should be removed
        continue;
      }
      if (FixButtonIDOptions[pButtons[i].id] !== undefined) {
        // there are predefined buttons, where we want to ovewrite the options
        pButtons[i] = Object.assign({}, pButtons[i], FixButtonIDOptions[pButtons[i].id]);
      }
    }
    if (typeof pButtons[i].user_permission === "string" && pButtons[i].user_permission.length > 0 && pUser.hasPermission(pButtons[i].user_permission) === false) {
      // button may only be visible for specific user attributes
      continue;
    }
    if (pButtons[i].user_permission && _typeof(pButtons[i].user_permission) === "object") {
      if (pButtons[i].user_permission.condition === "or") {
        if (!(pUser.hasPermission(pButtons[i].user_permission.ruleA) || pUser.hasPermission(pButtons[i].user_permission.ruleB))) {
          continue;
        }
      }
    }
    if (pButtons[i].admin_only === true && pUser.hasAdminPermissions() === false) {
      // button may only be visible for admins
      continue;
    }
    if (typeof pButtons[i].license === "string" && pButtons[i].license.length > 0 && pLicense.check(pButtons[i].license) === false) {
      // you have not the correct license, check the preferences
      if (pButtons[i].license_or_preferences === "com.nixps.mars") {
        if (pPreferencesObject[pButtons[i].license_or_preferences] === false || pLicense.check("max_cpu") === false) {
          // you have not the correct licence and the preferences are set to false
          continue;
        }
      } else {
        continue;
      }
    }
    if (pIgnoreAttributeNames !== true) {
      if (!Array.isArray(pAttributeNames)) {
        pAttributeNames = [];
      }
      if (typeof pButtons[i].user_attribute === "string" && pButtons[i].user_attribute.length > 0 && pAttributeNames.includes(pButtons[i].user_attribute.trim()) === false) {
        // button may only be visible for specific user attributes
        continue;
      }
      if (Array.isArray(pButtons[i].user_attribute) && pButtons[i].user_attribute.length > 0) {
        var match = true;
        for (var att = 0; att < pButtons[i].user_attribute.length; att++) {
          if (typeof pButtons[i].user_attribute[att] === "string" && pButtons[i].user_attribute[att].length > 0 && pAttributeNames.includes(pButtons[i].user_attribute[att].trim()) === false) {
            match = false;
            break;
          }
        }
        if (match === false) {
          continue;
        }
      }
      if (pButtons[i].user_attribute !== null && _typeof(pButtons[i].user_attribute) === "object" && !Array.isArray(pButtons[i].user_attribute)) {
        var conditionObj = pButtons[i].user_attribute;
        if (conditionObj.condition === "and") {
          var match = true;
          for (var att = 0; att < conditionObj.attributes.length; att++) {
            if (typeof conditionObj.attributes[att] === "string" && conditionObj.attributes[att].length > 0 && pAttributeNames.includes(conditionObj.attributes[att].trim()) === false) {
              match = false;
              break;
            }
          }
          if (match === false) {
            continue;
          }
        } else if (conditionObj.condition === "or") {
          var matchOR = false;
          for (var att = 0; att < conditionObj.attributes.length; att++) {
            if (typeof conditionObj.attributes[att] === "string" && conditionObj.attributes[att].length > 0 && pAttributeNames.includes(conditionObj.attributes[att].trim())) {
              matchOR = true;
              break;
            }
          }
          if (matchOR === false) {
            continue;
          }
        } else {
          console.error("unknown condition, filter out");
          continue;
        }
      }
    }
    if (typeof pButtons[i].prerelease === "string" && pButtons[i].prerelease.length > 0 && pUserPreferences.getPrerelease(pButtons[i].prerelease) !== true) {
      // the prerelease flag is not set
      continue;
    }
    if (pButtons[i].preferences_single !== undefined && pButtons[i].preferences_single !== null && typeof pButtons[i].preferences_single.id === "string" && typeof pButtons[i].preferences_single.key === "string") {
      if (pPreferencesObject[pButtons[i].preferences_single.id] !== undefined) {
        if (pPreferencesObject[pButtons[i].preferences_single.id][pButtons[i].preferences_single.key] !== true) {
          continue;
        }
      } else {
        continue;
      }
    }
    if (typeof pButtons[i].collection_in_use === "string" && pCollectionsInUse[pButtons[i].collection_in_use] === false) {
      // collection in not in use, do not show
      continue;
    }
    if (typeof pButtons[i].license_datalink === "boolean" && pLicense.isDataLink() !== pButtons[i].license_datalink) {
      // you have not the correct license
      continue;
    }
    if (typeof pButtons[i].product === "string" && pButtons[i].product.length > 0 && pLicense.hasProduct(pButtons[i].product) === false) {
      // you dont have the correct product
      continue;
    }
    if (typeof pButtons[i].tenant_view === "boolean") {
      if (pButtons[i].tenant_view === false && pLicense.isTenant()) {
        // not viewing when tenant is active
        continue;
      }
      if (pButtons[i].tenant_view === true && pLicense.isTenant() === false) {
        continue;
      }
    }
    if (typeof pButtons[i].predefined_badge_number === "string" && typeof PredefinedBadgeNumbers[pButtons[i].predefined_badge_number] === "function") {
      pButtons[i]["badge_number"] = PredefinedBadgeNumbers[pButtons[i].predefined_badge_number];
    } else if (pButtons[i].context_badge_number && _typeof(pButtons[i].context_badge_number) === "object" && Object.keys(pButtons[i].context_badge_number).length > 0) {
      (function (pBadgeNumber, pButtonIndex) {
        pButtons[pButtonIndex]["badge_number"] = function () {
          return Context.fromJSON(pBadgeNumber).loadDataFromCache({
            suppressRedirect: true
          });
        };
      })(pButtons[i].context_badge_number, i);
    }
    if (Array.isArray(pButtons[i].sub_buttons) && pButtons[i].sub_buttons.length > 0) {
      pButtons[i].sub_buttons = MenuHandler.filter_buttons(pButtons[i].sub_buttons, pUser, pLicense, pPreferencesObject, pAttributeNames, pIgnoreAttributeNames, pUserPreferences, pCollectionsInUse);
    }
    visibleButtons.push(pButtons[i]);
  }
  return visibleButtons;
};
MenuHandler.createAndloadFromCache = function (pInputType, pOptions, pRelativePath, pUser, pLicense, pUserPreferences) {
  var cacheObject = null,
    cacheObjectKey = undefined;
  if (TemporyBrowserObjectCache.isPageReload() !== true || Device.getPollingFactor() > 1) {
    cacheObject = TemporyBrowserObjectCache.get("nixps_cloudflow_menu");
    cacheObjectKey = "" + pInputType + pOptions;
    if (typeof pRelativePath === "string") {
      cacheObjectKey += pRelativePath;
    }
    if (cacheObject !== null && cacheObject.buttonsDict && Array.isArray(cacheObject.buttonsDict[cacheObjectKey])) {
      var handler = new MenuHandler(pInputType, pOptions, pRelativePath, pUser, pLicense, pUserPreferences || cacheObject.userPreferences, {
        buttons: cacheObject.buttonsDict[cacheObjectKey],
        templates: cacheObject.templates,
        allPreferences: cacheObject.allPreferences,
        installedApps: cacheObject.installedApps
      });
      return handler.loadRequirements().then(function () {
        return handler;
      });
    }
  }
  if (pInputType === "settings") {
    // load all preferences in advance and fill in there promises, to the get calls will wait on this return

    // the resources for the templates
    var templateResourceResolvers = Promise.withResolvers();
    templatesResourcePromise = templateResourceResolvers.promise;
    // the settings, use_custom and custom url of json 
    var portalResolvers = Promise.withResolvers();
    settingsPromise = portalResolvers.promise;
    // the prefernces proofscope live render etc
    var proofscopeResolvers = Promise.withResolvers();
    preferencesPromise = proofscopeResolvers.promise;
    ApplicationPreferences.get([], ["com.nixps.proofscope", "com.nixps.jobs.joda", "portal"]).then(function (pPreferencesClass) {
      // the resources for the templates
      templateResourceResolvers.resolve();
      // the settings, use_custom and custom url of json 
      setSettings(pPreferencesClass.getSystemValue("portal", ""));
      portalResolvers.resolve(pPreferencesClass.getSystemValue("portal", ""));
      // the prefernces proofscope live render etc
      setPreference("com.nixps.proofscope", pPreferencesClass.getSystemValue("com.nixps.proofscope", "live_render"));
      proofscopeResolvers.resolve({
        "preferences": pPreferencesClass.getSystemValue("com.nixps.proofscope", "live_render")
      });
    }, function (pError) {
      templateResourceResolvers.reject(pError);
      portalResolvers.reject(pError);
      proofscopeResolvers.reject(pError);
    });
  }
  var menuHandler = new MenuHandler(pInputType, pOptions, pRelativePath, pUser, pLicense, pUserPreferences);
  return Promise.all([menuHandler.loadFactoryRequirements(), menuHandler.load(true)]).then(function (pResults) {
    var pFactoryRequirements = pResults[0];
    var pLoad = pResults[1];
    if (typeof cacheObjectKey === "string" && cacheObjectKey.length > 0) {
      var buttonsDict = {};
      if (cacheObject !== null && cacheObject.buttonsDict !== undefined) {
        buttonsDict = cacheObject.buttonsDict;
      }
      buttonsDict[cacheObjectKey] = pLoad[1];
      TemporyBrowserObjectCache.save("nixps_cloudflow_menu", {
        templates: pFactoryRequirements.templates,
        installedApps: pFactoryRequirements.installedApps,
        userPreferences: pLoad[0].userPreferences,
        allPreferences: pLoad[0].preferencesObject,
        buttonsDict: buttonsDict
      });
    }
    return menuHandler;
  });
};
MenuHandler.clear = function () {
  templates = undefined;
  templatesResourcePromise = undefined;
  preferences = undefined;
  preferencesPromise = undefined;
  settings = undefined;
  settingsPromise = undefined;
  collectionInUse = undefined;
  License.clear();
  User.clear();
  UserPreferences.clearCaches();
  TemporyBrowserObjectCache.remove("nixps_cloudflow_menu");
  ApplicationPreferences.clear();
};
MenuHandler.getDefaultCloudflowPath = function () {
  return kDefaultCloudflowPath;
};
MenuHandler.clearAllTemplates = function () {
  templates = undefined;
};
MenuHandler.clearCaches = function () {
  TemporyBrowserObjectCache.remove("nixps_cloudflow_menu");
};
MenuHandler.prototype = {
  constructor: MenuHandler,
  loadRequirements: function loadRequirements() {
    var that = this;
    if (this.allPreferencesDef === undefined) {
      this.allPreferencesDef = getAllPreferences();
    }
    if (this.collectionsInUseDef === undefined) {
      this.collectionsInUseDef = getAllConnectionInUse();
    }
    return Promise.all([this.userDef, this.licenseDef, this.allPreferencesDef, this.userpreferencesDef, this.collectionsInUseDef]).then(function (pResults) {
      that.user = pResults[0];
      that.license = pResults[1];
      that.preferencesObject = pResults[2];
      that.userPreferences = pResults[3];
      that.collectionsInUse = pResults[4];
      return {
        user: that.user,
        license: that.license,
        preferencesObject: that.preferencesObject,
        userPreferences: that.userPreferences,
        collectionsInUse: that.collectionsInUse
      };
    }, function (pError) {
      console.error(pError);
      return Promise.reject(pError);
    });
  },
  loadFactoryRequirements: function loadFactoryRequirements() {
    return Promise.all([this.templateDef, this.installedAppsDef]).then(function (pResults) {
      return {
        templates: pResults[0],
        installedApps: pResults[1]
      };
    });
  },
  loadButtons: function loadButtons(pUseFallBack, pCreateFile) {
    var that = this;
    this.buttons;
    if (this.connection !== undefined) {
      this.connection.stop();
    }
    this.connection = undefined;
    if (this.inputType === "settings") {
      return Promise.resolve(getSettings()).then(function (pSettings) {
        if (pSettings.use_custom_menu === true) {
          that.connection = new FileConnection(pSettings.menu_location, that.relativePath, "json");
          return that._collectButtons(pUseFallBack, pCreateFile);
        } else {
          return that._getFactoryMenuButtons().then(function (pButtons) {
            that.buttons = pButtons;
            return pButtons;
          });
        }
      });
    } else if (this.inputType === "options" && Array.isArray(this.inputParameters)) {
      this.buttons = this.inputParameters.slice();
      return this.buttons;
    } else if (this.inputType === "url" && typeof this.inputParameters === "string" && this.inputParameters.length > 0) {
      this.connection = new FileConnection(this.inputParameters, this.relativePath, "json");
      if (pCreateFile === true) {
        return this.connection.touch().then(function (pResult) {
          if (pResult !== undefined && typeof pResult.url === "string" && that.inputParameters !== pResult.url) {
            // the url of the file is different then the input
            that.inputParameters = pResult.url;
          }
          // set pFillWhenEmpty on true, if the file is just created
          return that._collectButtons(pUseFallBack, false, pResult.exists === false);
        }, function (pError) {
          console.error("could not create file");
          return Promise.reject(pError);
        });
      }
    } else if (this.inputType === "default") {
      this.connection = new FileConnection(kDefaultCloudflowPath, this.relativePath, "json");
    }
    if (this.connection !== undefined) {
      return this._collectButtons(pUseFallBack, pCreateFile);
    } else {
      console.warn("no connection found, fallback to fabric reset settings!");
      return that._getFactoryMenuButtons().then(function (pButtons) {
        that.buttons = pButtons;
        return pButtons;
      });
    }
  },
  _collectButtons: function _collectButtons(pUseFallBack, pCreateFile, pFillWhenEmpty) {
    var that = this;
    return new Promise(function (pResolve, pReject) {
      that.connection.list_with_options([], [], [], {}, function (pResults) {
        if (Array.isArray(pResults.results)) {
          // in case of a new json file, to start from
          if (pResults.results.length === 0 && pFillWhenEmpty === true) {
            // fill the new file with default data
            that._getFactoryMenuButtons().then(function (pButtons) {
              // directly save the file, there are customers who click on cancel and then are not happy that the file is empty
              that.connection.update_all(pButtons).then(function () {
                that.buttons = pButtons;
                pResolve(pButtons);
              }, pReject);
            }, pReject);
          } else {
            that.buttons = pResults.results;
            pResolve(pResults.results);
          }
        } else {
          console.error("no buttons found for the SideBar");
          if (pUseFallBack === true) {
            that._getFactoryMenuButtons().then(function (pButtons) {
              that.buttons = pButtons;
              pResolve(pButtons);
            }, pReject);
          } else {
            pReject({
              "error_code": "no_buttons",
              "error": "No buttons found"
            });
          }
        }
      }, function (pError) {
        var error = that.connection.getError();
        if (error !== undefined && error.error_code === "file_not_found") {
          if (pCreateFile === true) {
            that._getFactoryMenuButtons().then(function (pMenuButtons) {
              that.connection.update_all(pMenuButtons).then(function () {
                that.buttons = pMenuButtons;
                pResolve(pMenuButtons);
              }, pReject);
            });
          } else if (pUseFallBack === true && that.connection.getURL() !== kDefaultCloudflowPath) {
            new FileConnection(kDefaultCloudflowPath, that.relativePath, "json").list_with_options([], [], [], {}, function (pResults) {
              if (Array.isArray(pResults.results)) {
                that.buttons = pResults.results;
                pResolve(pResults.results);
              } else {
                console.error("no buttons found for the SideBar");
                if (pUseFallBack === true) {
                  that._getFactoryMenuButtons().then(function (pButtons) {
                    that.buttons = pButtons;
                    pResolve(pButtons);
                  }, pReject);
                } else {
                  pReject({
                    "error_code": "no_buttons",
                    "error": "No buttons found"
                  });
                }
              }
            }, function (pError) {
              if (pUseFallBack === true) {
                that._getFactoryMenuButtons().then(function (pButtons) {
                  that.buttons = pButtons;
                  pResolve(pButtons);
                }, pReject);
              } else {
                console.error(pError);
                pReject(error);
              }
            });
          } else {
            if (pUseFallBack === true) {
              that._getFactoryMenuButtons().then(function (pButtons) {
                that.buttons = pButtons;
                pResolve(pButtons);
              }, pReject);
            } else {
              console.error(pError);
              pReject(error);
            }
          }
        } else {
          console.error(pError);
          if (pUseFallBack === true) {
            that._getFactoryMenuButtons().then(function (pButtons) {
              that.buttons = pButtons;
              pResolve(pButtons);
            }, pReject);
          } else {
            pReject(error);
          }
        }
      });
    });
  },
  _mergeRuntimeButtons: function _mergeRuntimeButtons(pButtons, pRuntimeDict) {
    if (!pRuntimeDict || _typeof(pRuntimeDict) !== "object") {
      return pButtons;
    }
    var runtimeDict = structuredClone(pRuntimeDict);
    var buttons = [];
    if (Array.isArray(pButtons) && pButtons.length > 0) {
      for (var i = 0; i < pButtons.length; i++) {
        if (typeof pButtons[i] === "string" && pButtons[i].startsWith("**") && pButtons[i].endsWith("**")) {
          var runtimePlaceName = pButtons[i].slice(2).slice(0, -2);
          if (Array.isArray(runtimeDict[runtimePlaceName])) {
            buttons = buttons.concat(runtimeDict[runtimePlaceName]);
            delete runtimeDict[runtimePlaceName];
          }
        } else {
          buttons.push(pButtons[i]);
        }
      }
    }
    return buttons;
  },
  _getFactoryMenuButtons: function _getFactoryMenuButtons() {
    if (this.templateDef === undefined) {
      this.templateDef = getAllTemplates();
    }
    if (this.installedAppsDef === undefined) {
      this.installedAppsDef = InstalledApps.getDefaultMenuItems(this.license);
    }
    var that = this;
    return Promise.all([this.templateDef, this.installedAppsDef, this.licenseDef]).then(function (pResults) {
      var pTemplates = pResults[0];
      var pInstalledApps = pResults[1];
      var pLicense = pResults[2];
      if (that.license === undefined) {
        that.license = pLicense;
      }
      var pathsToRemove = [];
      var defaultMenuButtons = CloudflowObject.travers(getDefaultInstallationMenuButtons(that.license), function (pValue, pKey) {
        if (pValue.length > 3 && pValue.startsWith("${") && pValue.endsWith("}")) {
          var templateKey = pValue.slice(2, -1);
          if (pTemplates[templateKey] !== undefined) {
            return pTemplates[templateKey];
          } else {
            pathsToRemove.push(pKey);
          }
        }
        return pValue;
      });
      if (pathsToRemove.length > 0) {
        for (var i = 0; i < pathsToRemove.length; i++) {
          defaultMenuButtons = CloudflowObject.deleteParameter(defaultMenuButtons, pathsToRemove[i]);
        }
      }
      // add installed apps
      defaultMenuButtons = that._mergeRuntimeButtons(defaultMenuButtons, pInstalledApps);
      return defaultMenuButtons;
    }, function (pError) {
      console.error(pError);
      return Promise.reject(pError);
    });
  },
  save: function save(pMenu) {
    var that = this;
    if (pMenu instanceof Menu) {
      TemporyBrowserObjectCache.remove("nixps_cloudflow_menu"); // clear caches
      if (this.inputType === "settings") {
        if (settings === undefined || settings.use_custom_menu === false) {
          settings = {
            "use_custom_menu": true,
            "menu_location": kDefaultCloudflowPath
          };
        } else if (settings.use_custom_menu === true) {
          if (typeof settings.menu_location !== "string" && settings.menu_location.length <= 0) {
            settings.menu_location = kDefaultCloudflowPath;
          }
        }
        if (this.connection === undefined) {
          this.connection = new FileConnection(settings.menu_location, this.relativePath, "json");
        }
        return Promise.resolve(FileConnection.createParentFolders(settings.menu_location)).then(function () {
          return Promise.all([that.connection.update_all(pMenu.toJSON()), setSettingsURL(true, settings.menu_location)]);
        });
      } else if (this.inputType === "url" && typeof this.inputParameters === "string" && this.inputParameters.length > 0) {
        if (this.connection === undefined) {
          this.connection = new FileConnection(this.inputParameters, this.relativePath, "json");
        }
        return this.connection.update_all(pMenu.toJSON());
      }
      if (this.connection === undefined) {
        throw new Error("missing this.connection to save");
      }
      return this.connection.update_all(pMenu.toJSON());
    } else {
      console.error("save: menu has not correct interfase");
    }
  },
  load: function load(pUseFallBack, pCreateFile) {
    return Promise.all([this.loadRequirements(), this.loadButtons(pUseFallBack, pCreateFile)]);
  },
  setUser: function setUser(pUser) {
    if (pUser && _typeof(pUser) === "object" && pUser.constructor && pUser.constructor.name === "Object") {
      this.user = User.fromJSON(pUser);
      return this.user;
    } else if (pUser instanceof User) {
      this.user = pUser;
      return this.user;
    } else {
      return User.get();
    }
  },
  setLicense: function setLicense(pLicense) {
    if (pLicense && _typeof(pLicense) === "object" && pLicense.constructor && pLicense.constructor.name === "Object") {
      this.license = License.fromJSON(pLicense);
      return this.license;
    } else if (pLicense instanceof License) {
      this.license = pLicense;
      return this.license;
    } else {
      return License.get();
    }
  },
  setUserPreferences: function setUserPreferences(pUserPreferences) {
    if (pUserPreferences instanceof UserPreferences) {
      this.userPreferences = pUserPreferences;
      return this.userPreferences;
    } else {
      return UserPreferences.get();
    }
  },
  setButtons: function setButtons(pButtons) {
    this.buttons = pButtons;
  },
  getButtons: function getButtons(pAttributeNames, pIgnoreAttributeNames, pIgnoreTemplates) {
    if (Array.isArray(this.buttons)) {
      var buttons;
      if (pIgnoreTemplates === true) {
        buttons = this.buttons;
      } else {
        var expressionToJS = new ExpressionToJS({}, this.user, this.userPreferences);
        buttons = expressionToJS.applyOnObject(this.buttons).translatedObject;
      }
      var buttonJSONs = MenuHandler.filter_buttons(buttons, this.user, this.license, this.preferencesObject, pAttributeNames, pIgnoreAttributeNames, this.userPreferences, this.collectionsInUse);
      var menu = new Menu(buttonJSONs);
      return menu.getButtons();
    }
    return [];
  },
  getMenu: function getMenu(pAttributeNames, pIgnoreAttributeNames, pIgnoreTemplates) {
    return new Menu(this.getButtons(pAttributeNames, pIgnoreAttributeNames, pIgnoreTemplates));
  },
  factoryReset: function factoryReset(pDeactivateCustomMenu) {
    var that = this;
    TemporyBrowserObjectCache.remove("nixps_cloudflow_menu"); // clear caches
    if (this.templateDef === undefined) {
      this.templateDef = getAllTemplates();
    }
    return Promise.all([this.templateDef, setSettingsURL(!pDeactivateCustomMenu, settings && settings.menu_location)]).then(function (pResults) {
      var pTemplates = pResults[0];
      that.buttons = CloudflowObject.travers(getDefaultInstallationMenuButtons(that.license), function (pValue, pKey) {
        if (pValue.length > 3 && pValue.startsWith("${") && pValue.endsWith("}")) {
          var templateKey = pValue.slice(2, -1);
          if (pTemplates[templateKey] !== undefined) {
            return pTemplates[templateKey];
          } else {
            return {};
          }
        }
        return pValue;
      });
      return that.buttons;
    }, function (pError) {
      console.error(pError);
      return Promise.reject(pError);
    });
  },
  stop: function stop() {
    if (this.connection !== undefined) {
      this.connection.stop();
    }
  }
};
module.exports = MenuHandler;

},{"../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../../pagebuilder/js/Context.js":413,"../../../pagebuilder/js/ExpressionToJS.js":415,"../../../polyfill/polyfill.js":433,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../CloudflowUtil/js/FileConnection.js":86,"../../License/js/License.js":175,"../../PWA/js/Device.js":198,"../../Preferences/js/ApplicationPreferences.js":201,"../../Preferences/js/UserPreferences.js":202,"../../User/js/User.js":268,"../defaults/default_installation.js":186,"./Menu.js":190,"./default_installation_factory.js":193,"./default_installation_installedapps.js":194,"./predefined_badgenumber.js":195,"./predefined_buttonid_options.js":196}],193:[function(require,module,exports){
"use strict";

function _parseType(pType) {
  return ("" + pType).replace(/[^a-zA-Z0-9-_]/g, "-").toLowerCase();
}
function _getJobMenuItems(pApplicationPreferences) {
  // we hope this info is already loaded before....
  return pApplicationPreferences.getSystemValue("com.nixps.jobs.joda", "configuration").then(function (pResult) {
    var menuItems = {
      "id": "jobs",
      "icon": "cf-icon cf-icon-jobs",
      "text": "nixps-cloudflow-top_navigation.jobs",
      "tooltip": "nixps-cloudflow-top_navigation.jobs",
      "license": "project",
      "sub_buttons": []
    };
    if (pResult && Array.isArray(pResult.types) && pResult.types.length > 0) {
      for (var i = 0, len = pResult.types.length; i < len; i++) {
        var type = pResult.types[i];
        if (type) {
          menuItems.sub_buttons.push({
            "id": "jobtype" + _parseType(type.job_type),
            "icon": "cf-icon cf-icon-jobs",
            "link": "/portal.cgi?job=dashboard#type=" + _parseType(type.job_type),
            "text": "" + type.name,
            "tooltip": "" + type.name
          });
        }
      }
    }
    menuItems.sub_buttons.push({
      "id": "jobconfiguration",
      "icon": "cf-icon cf-icon-adjust",
      "link": "/portal.cgi?job=configuration",
      "text": "nixps-joda-DashboardPage.config",
      "tooltip": "nixps-joda-DashboardPage.config",
      "user_permission": "MANAGE_JOBS"
    }, {
      "id": "teams",
      "icon": "cf-icon cf-icon-users",
      "link": "/portal.cgi?team=teams",
      "text": "nixps-team-dashboard.title",
      "tooltip": "nixps-team-dashboard.title",
      "user_permission": "MANAGE_JOBS"
    }, {
      "id": "jobresources",
      "icon": "cf-icon cf-icon-printer-human",
      "link": "/portal.cgi?job=resource.configuration",
      "text": "nixps-cloudflow-jobresources.title",
      "tooltip": "nixps-cloudflow-jobresources.title",
      "user_permission": "MANAGE_JOBS"
    });
    return {
      "jobs": menuItems
    };
  });
}
module.exports = function (pApplicationPreferences) {
  return _getJobMenuItems(pApplicationPreferences);
};

},{}],194:[function(require,module,exports){
"use strict";

var CFApp = require("../../../appnavigator/js/CFApp.js");
// cache
var defaultMenuItemsDef;
module.exports = {
  getDefaultMenuItems: function getDefaultMenuItems(pLicense) {
    if (pLicense !== undefined && pLicense.getStatus() === "invalid") {
      return Promise.resolve({
        "main_menu_buttons": []
      });
    }
    if (defaultMenuItemsDef === undefined) {
      defaultMenuItemsDef = this._getDefaultMenuItems();
      return defaultMenuItemsDef;
    } else {
      return defaultMenuItemsDef;
    }
  },
  _getDefaultMenuItems: function _getDefaultMenuItems() {
    return new Promise(function (pResolve, pReject) {
      api_async.registry.cfapp.list_with_options(["main_menu_buttons", "exists"], [], ["name", "main_menu_buttons"], {}, function (pResults) {
        if (Array.isArray(pResults.results)) {
          var menuButtons = [];
          for (var i = 0; i < pResults.results.length; i++) {
            var cfapp = CFApp.fromJSON(pResults.results[i]);
            if (cfapp.hasMainMenuButtons()) {
              menuButtons = menuButtons.concat(cfapp.getMainMenuButtons());
            }
          }
          pResolve({
            "main_menu_buttons": menuButtons
          });
        } else {
          console.error("wrong_interface");
          pResolve({
            "main_menu_buttons": []
          });
        }
      }, function (pError) {
        console.error(pError);
        pResolve({
          "main_menu_buttons": []
        });
      });
    });
  }
};

},{"../../../appnavigator/js/CFApp.js":47}],195:[function(require,module,exports){
"use strict";

module.exports = {
  "hold_in_kiosk": function hold_in_kiosk(pUser, pLicense) {
    var query = ["hold_in_kiosk", "equal to", true, "and", "roles.handler", "equal to", pUser.getUserName()];
    return api_defer.workable.count(query).then(function (result) {
      return result.count;
    });
  },
  "notifications": function notifications(pUser, pLicense) {
    var FixNotificationHandler = require("../../../nebulaportal/js/notifications/FixedNotificationHandler.js");
    var notifications = new FixNotificationHandler(pLicense, pUser);
    return $.Deferred().resolve({
      count: notifications.count(),
      severity: "warning"
    });
  },
  "my_ready_tasks": function my_ready_tasks(pUser, pLicense) {
    return api_defer.task_list.list_with_options(["filters.users", "equal to", pUser.getUserName(), "and", "items.state", "equal to", "ready"], [], ["items.state"], {
      maximum: 1000
    }).then(function (pResult) {
      if (pResult && Array.isArray(pResult.results)) {
        if (pResult.results.length >= 1000) {
          return 1000; // short cut to show overflow, no need to loop
        }

        var count = 0;
        for (var i = 0; i < pResult.results.length; i++) {
          for (var j = 0; j < pResult.results[i].items.length; j++) {
            if (pResult.results[i].items[j].state === "ready") {
              count++;
            }
          }
        }
        return count;
      }
      return 0;
    });
  }
};

},{"../../../nebulaportal/js/notifications/FixedNotificationHandler.js":407}],196:[function(require,module,exports){
"use strict";

module.exports = {};

},{}],197:[function(require,module,exports){
"use strict";

var Context = require("../../../pagebuilder/js/Context.js");
/**
 * @constructor BadgeNumberUtil
 * @static
 * @description Static help function to work with badge numbers
 */
var BadgeNumberUtil = {
  /**
   * @name BadgeNumberUtil#parse
   * @description Retrieve the correct number out if the input. 
   * The input can be a string, number, array or a return collection of an list_with_options api call, or an page context
   * @function
   * @param {Mixed} pValue 
   * @returns {Number} a valid number
   */
  parse: function parse(pValue) {
    if (typeof pValue === "number" && pValue > 0) {
      return pValue;
    } else if (Array.isArray(pValue) && pValue.length > 0) {
      return pValue.length;
    } else if (pValue && typeof pValue.count === "number" && pValue.count > 0) {
      return pValue.count;
    } else if (pValue && Array.isArray(pValue.results || pValue.documents) && (pValue.results || pValue.documents).length > 0) {
      return (pValue.results || pValue.documents).length;
    } else if (typeof pValue === "string" && pValue.length > 0) {
      var integer = parseInt(pValue);
      if (integer > 0) {
        return integer;
      }
    } else if (pValue && typeof pValue.connector === "string") {
      var that = this;
      return Promise.all([Context.fromJSON(pValue).loadDataFromCache({
        suppressRedirect: true
      })]).then(function (pResult) {
        return that.parse(pResult[0]);
      });
    } else if (typeof pValue === "function") {
      return this.parse(pValue());
    }
    return null;
  }
};
module.exports = BadgeNumberUtil;

},{"../../../pagebuilder/js/Context.js":413}],198:[function(require,module,exports){
"use strict";

// private parameters
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _isOnLine = true; // if the application can access the internet? can we contact the server?
var _serviceWorkerRegistration = undefined;
var _updateSWTimeoutID = null; // setTimeout id, for updating the service worker
var _messageListeners = []; // list of callbacks for service worker messages, the communitaction between browser page and service worker
var _error = null; // object of last registered error
var _energySaving = null; // is the battery so low and we are not connected to the enrery lighting, true if we are in battery saving mode

/**
 * @static
 * @constructor Device
 * @description An util function to retrieve all information about the device the page is running in
 */
var Device = {
  /**
   * @description run init code, set the theme color if needed
   * @function
   * @name Device.init
   */
  init: function init(pOptions) {
    var options = Object.assign({
      mainColorVariableName: "--cloudflow-main",
      serviceWorkerURL: undefined,
      serviceWorkerScope: undefined,
      appBadgeNumber: undefined
    }, pOptions || {});

    // add a default theme-color, the background color of browser headers, if supported (Safari 15) 
    if (typeof window.getComputedStyle === "function" && typeof document.querySelector === "function" && document.querySelector("meta[name='theme-color']") === null) {
      var color = getComputedStyle(document.documentElement).getPropertyValue(options.mainColorVariableName);
      if (typeof color === "string" && color.length >= 4 && typeof color.trim === "function") {
        // some pages does not have custom css variables
        var metaTag = document.createElement("META");
        metaTag.setAttribute("name", "theme-color");
        metaTag.setAttribute("content", color.trim());
        document.head.appendChild(metaTag);
      }
    }
    if (window.origin !== "null" && typeof options.serviceWorkerURL === "string" && options.serviceWorkerURL.length > 0 && window.navigator !== undefined && "serviceWorker" in window.navigator) {
      clearTimeout(_updateSWTimeoutID);
      var url = options.serviceWorkerURL;
      if (options.serviceWorkerURL.indexOf("cloudflow://") === 0) {
        url = "/portal.cgi/" + options.serviceWorkerURL.slice(12);
      }
      var parameters = undefined;
      if (_typeof(parameters) === "object") {
        url += url.indexOf("?") >= 0 ? "&" : "?";
        for (var name in parameters) {
          if (["string", "number", "boolean"].includes(_typeof(parameters[name]))) {
            url += name + "=" + encodeURIComponent(parameters[name]) + "&";
          }
        }
      }
      navigator.serviceWorker.addEventListener("message", function (pEvent) {
        if (pEvent && pEvent.data) {
          if (pEvent.data.error_code === "failed_loading_main") {
            // big error occured, main script could not be loaded
            // unregister and try to reload the next page load
            _serviceWorkerRegistration.unregister();
            return;
          }
          if (pEvent.data.data) {
            // if main service worker is less than one week loaded, try to enforce an update
            if (typeof pEvent.data.data.serviceWorkerlastLoaded === "number" && pEvent.data.data.serviceWorkerlastLoaded < new Date() - 7 * 24 * 3600 * 1000) {
              _serviceWorkerRegistration.update();
              return;
            }
          }
        }
        _messageListeners.forEach(function (pCallBackFunction) {
          pCallBackFunction(pEvent.data);
        });
      });
      navigator.serviceWorker.register(url, {
        scope: options.serviceWorkerScope,
        updateViaCache: "none"
      }).then(function (registration) {
        // registration worked
        _serviceWorkerRegistration = registration;
        if (_serviceWorkerRegistration && _serviceWorkerRegistration.active) {
          // ask one thing add start up, if we recieve error, unrigister 
          _serviceWorkerRegistration.active.postMessage({
            type: "request_data",
            data: {}
          });
        }
        _updateSWTimeoutID = setTimeout(function () {
          if (_serviceWorkerRegistration && _serviceWorkerRegistration.update) {
            _serviceWorkerRegistration.update();
          }
        }, 43200000); // 12 h
      })["catch"](function (pError) {
        _serviceWorkerRegistration = null;
        console.error(pError);
      });
    }
    if (options.appBadgeNumber) {
      this.setAppBadge(options.appBadgeNumber);
    }
  },
  /**
   * @description Set or remove the app badgenumber. It is the badge number a user see above the installed app icon in the operation system
   * @function
   * @name Device.setAppBadge
   * @param {Mixed} pConfiguration the information to retreive the correct badge number
   */
  setAppBadge: function setAppBadge(pBadgeNumber) {
    if (window.navigator !== undefined && typeof navigator.setAppBadge === "function") {
      if (typeof pBadgeNumber === "number" && pBadgeNumber > 0) {
        return navigator.setAppBadge(pBadgeNumber);
      } else if (pBadgeNumber === null) {
        return navigator.clearAppBadge();
      }
    }
    return Promise.resolve();
  },
  postMessage: function postMessage(pType, pData) {
    if (typeof pType !== "string" || pType.length <= 0) {
      throw new Error("parameter pType must be a not empty string");
    }
    if (!window.navigator || navigator.serviceWorker === undefined) {
      // old browser
      return null;
    }
    return navigator.serviceWorker.ready.then(function (pRegistration) {
      if (pRegistration !== undefined && pRegistration.active !== undefined) {
        pRegistration.active.postMessage({
          type: pType,
          data: pData
        });
      } else {
        throw new Error("registration has wrong interface");
      }
    });
  },
  addPostMessageListener: function addPostMessageListener(pCallBackFunction) {
    if (typeof pCallBackFunction !== "function") {
      throw new Error("parameter pCallBackFunction must be a function");
    }
    _messageListeners.push(pCallBackFunction);
  },
  removePostMessageListener: function removePostMessageListener(pCallBackFunction) {
    if (typeof pCallBackFunction !== "function") {
      throw new Error("parameter pCallBackFunction must be a function");
    }
    var found = false;
    for (var i = _messageListeners.length - 1; i >= 0; i--) {
      if (_messageListeners[i] === pCallBackFunction) {
        _messageListeners.splice(i, 1);
        found = true;
      }
    }
    return found;
  },
  /**
   * @description Inform everybody that we have an error
   * @function
   * @name Device.bringInError
   * @param {Object} pError error object   
   */
  bringInError: function bringInError(pError) {
    if (pError === null || _typeof(pError) === "object") {
      _error = pError;
    }
  },
  /**
   * @description Get the last error, could be null then no error is dilivered
   * @function
   * @name Device.getLastError
   * @return {Object} pError error object or null  
   */
  getLastError: function getLastError() {
    return structuredClone(_error);
  },
  /**
   * @description Must we continue polling or better skip one loop
   * @function
   * @name Device.continuePolling
   * @param {Number} pWidgetUUID 
   * @returns {Boolean} true if the polling may happend, false if you better skip the polling     
   */
  continuePolling: function continuePolling(pWidgetUUID) {
    // if (window.frameElement && ! (window.frameElement.offsetWidth || window.frameElement.offsetHeight || window.frameElement.getClientRects().length)) {
    //     return false;
    // }
    return document.hidden !== true && _isOnLine === true;
  },
  /**
   * @description Get the factor to multiply on the polling, With this we can delay the polling frequentie
   * @function
   * @name Device.getPollingFactor
   * @param {Number} pWidgetUUID 
   * @returns {Boolean} true if the polling may happend, false if you better skip the polling     
   */
  getPollingFactor: function getPollingFactor(pWidgetUUID) {
    if (_error && ["http_errorcode_503", "http_errorcode_504", "http_errorcode_429"].includes(_error.error_code)) {
      return 1.3;
    } else if (_energySaving === true) {
      return 1.25;
    }
    return 1;
  },
  /**
   * @description Check if we are online
   * @function
   * @name Device.isOnline
   * @returns {Boolean} true if we are online, false if we are offline
   */
  isOnline: function isOnline() {
    return _isOnLine;
  },
  /**
   * @description check if the device is a mobile device or not
   * @function
   * @name Device.hasMobileWidth
   * @returns {Boolean} true if the device is mobile
   */
  hasMobileWidth: function hasMobileWidth() {
    if (window.navigator.userAgent.toLowerCase().includes("mobi")) {
      return true;
    }
    if (Math.max(screen.availHeight, screen.availWidth) > 1200) {
      return false;
    }
    if (screen.availHeight < screen.availWidth) {
      // landscape
      return window.innerHeight < 431;
    } else {
      // portrait
      return window.innerWidth < 576;
    }
  },
  /**
   * @description Check if the device is an iOS (Apple) device or not
   * @function
   * @name Device.iSIOS
   * @returns Boolean true if the mobile is an iOS device
   */
  isIOS: function isIOS() {
    return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform)
    // iPad on iOS 13 detection
    || navigator.userAgent.includes("Mac") && "ontouchend" in document;
  },
  /**
   * @description Are we in eco modus or not?
   * @function
   * @name Device.isEnerySaveMode
   * @returns {Boolean} true if we need to save energy, false otherwise
   */
  isEnerySaveMode: function isEnerySaveMode() {
    return _energySaving === true;
  },
  destroy: function destroy() {
    clearTimeout(_updateSWTimeoutID);
    _error = null;
    _serviceWorkerRegistration = undefined;
    _messageListeners = [];
    _energySaving = null;
  }
};
if (window.navigator !== undefined && navigator.onLine === false) {
  // strange it is offline from start
  _isOnLine = false;
  if (document.body) {
    document.body.classList.add("cf-offline");
  }
}

// switch to online, when online event is triggered
window.addEventListener("online", function () {
  _isOnLine = true;
  if (document.body) {
    // make sure the body is present
    document.body.classList.remove("cf-offline");
  }
});

// switch to offline, when offline event is triggered
window.addEventListener("offline", function () {
  _isOnLine = false;
  if (document.body) {
    // make sure the body is present
    document.body.classList.add("cf-offline");
  }
});

// logic to handle energy saving
// it is like the iPhone where you can activate the erergy saving mode. (The battery icon becomes yellow on the iPhone)
// when the device has a battery less then 9% who is not charging, switch the ergery saving mode on
// When the battery is bigger the 30% in saving mode, the mode will be disabled
if (window.navigator !== undefined && typeof navigator.getBattery === "function") {
  navigator.getBattery().then(function (battery) {
    if (typeof battery.level === "number" && battery.level < 0.09 && battery.charging !== true) {
      _energySaving = true; // start with low battery
    }

    battery.onlevelchange = function (pEvent) {
      if (typeof battery.level === "number" && battery.level >= 0 && battery.level <= 1) {
        if (battery.level < 0.09 && battery.charging !== true) {
          _energySaving = true;
        } else if (battery.level > 0.3 && _energySaving === true) {
          _energySaving = null;
        }
      }
    };
    battery.onchargingchange = function (pEvent) {
      if (battery.charging === true) {
        if (_energySaving === true) {
          _energySaving = null;
        }
      } else if (battery.charging === false) {
        if (typeof battery.level === "number" && battery.level < 0.09) {
          _energySaving = true;
        }
      }
    };
  });
}
module.exports = Device;

},{}],199:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var sizesRegExp = new RegExp("^(?<size>[0-9]+)x\\k<size>$");

/**
 * @constructor PWAIcon
 * @description Represents an icon configuration in the manifest.json
 * @param {Object} pOptions 
 */
var PWAIcon = function PWAIcon(pOptions) {
  this.setURL(pOptions.src);
  this.setSizes(pOptions.sizes);
  this.setType(pOptions.type);
};
PWAIcon.fromJSON = function (pJSON) {
  return new PWAIcon(pJSON);
};
function isURLValid(pURL) {
  if (typeof pURL !== "string" || pURL.length <= 0) {
    return {
      error_code: "icon_url_empty",
      error: $.i18n._("nixps-cloudflow-pwamanifestbuilder.error_icon_url_empty")
    };
  }
  return true;
}
function isSizesValid(pSizes) {
  if (typeof pSizes !== "string" || pSizes.length <= 0) {
    return {
      error_code: "icon_sizes_empty",
      error: $.i18n._("nixps-cloudflow-pwamanifestbuilder.error_icon_sizes_empty")
    };
  }
  var separatedSizes = pSizes.split(" ");
  for (var i = 0; i < separatedSizes.length; i++) {
    if (sizesRegExp.test(separatedSizes[i]) === false) {
      return {
        error_code: "size_height_width_not_same",
        error: $.i18n._("nixps-cloudflow-pwamanifestbuilder.error_size_height_width_not_same")
      };
    }
  }
  return true;
}
function isTypeValid(pType) {
  if (typeof pType !== "string" || pType.length <= 0) {
    return {
      error_code: "icon_type_empty",
      error: $.i18n._("nixps-cloudflow-pwamanifestbuilder.error_icon_type_empty")
    };
  }
  return true;
}
PWAIcon.hasValidJSON = function (pJSON) {
  var errors = [];
  if (_typeof(pJSON) !== "object" || pJSON === null || Array.isArray(pJSON)) {
    return [{
      error_code: "icon_not_json",
      error: $.i18n._("nixps-cloudflow-pwamanifestbuilder.error_icon_not_json")
    }];
  }
  var errorURL = isURLValid(pJSON.src);
  if (errorURL !== true) {
    errors.push(errorURL);
  }
  var errorSizes = isSizesValid(pJSON.sizes);
  if (errorSizes !== true) {
    errors.push(errorSizes);
  }
  var errorType = isTypeValid(pJSON.type);
  if (errorType !== true) {
    errors.push(errorType);
  }
  return errors;
};
PWAIcon.getSupportedExtensions = function () {
  return [".png", ".jpeg", ".gif", ".svg", ".webp"];
};
PWAIcon.getSupportedFileTypes = function () {
  return ["image/png", "image/jpeg", "image/gif", "image/svg+xml", "image/webp"];
};
PWAIcon.getJSONFromMetadata = function (pMetadata) {
  var iconJSON = {
    src: null,
    sizes: null,
    type: null
  };
  if (pMetadata !== undefined && pMetadata.cloudflow !== undefined && typeof pMetadata.cloudflow.file === "string") {
    iconJSON.src = pMetadata.cloudflow.file;
  }
  if (pMetadata !== undefined && pMetadata.metadata !== undefined && pMetadata.metadata.pages !== undefined && pMetadata.metadata.pages.length > 0 && pMetadata.metadata.pages[0].pixel_data !== undefined && pMetadata.metadata.pages[0].pixel_data.size !== undefined) {
    iconJSON.sizes = pMetadata.metadata.pages[0].pixel_data.size.width + "x" + pMetadata.metadata.pages[0].pixel_data.size.height;
  }
  if (pMetadata !== undefined && typeof pMetadata.filetype === "string") {
    iconJSON.type = pMetadata.filetype;
  }
  return iconJSON;
};
PWAIcon.prototype = {
  constructor: PWAIcon,
  setURL: function setURL(pURL) {
    var errorURL = isURLValid(pURL);
    if (errorURL !== true) {
      throw new Error(errorURL.error);
    }
    if (pURL.indexOf("cloudflow://") === 0) {
      this.src = "/portal.cgi/" + pURL.slice(12);
    } else {
      this.src = pURL;
    }
  },
  getURL: function getURL() {
    return this.src;
  },
  setSizes: function setSizes(pSizes) {
    var errorSizes = isSizesValid(pSizes);
    if (errorSizes !== true) {
      throw new Error(errorSizes.error);
    }
    this.sizes = pSizes;
  },
  getSizes: function getSizes() {
    return this.sizes;
  },
  containsSize: function containsSize(pSize) {
    if (typeof pSize !== "string" || pSize.length <= 0) {
      throw new Error("parameter size must be a not empty string");
    }
    if (sizesRegExp.test(pSize) === false) {
      throw new Error("parameter size does not match the interface for size");
    }
    return this.sizes.indexOf(pSize) >= 0;
  },
  setType: function setType(pType) {
    var errorType = isTypeValid(pType);
    if (errorType !== true) {
      throw new Error(errorType.error);
    }
    this.type = pType;
  },
  getType: function getType() {
    return this.type;
  },
  clone: function clone() {
    return PWAIcon.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var output = {
      src: this.src,
      sizes: this.sizes,
      type: this.type
    };
    return output;
  }
};
module.exports = PWAIcon;

},{}],200:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, chooser */

(function ($) {
  var CloudflowURL = require("../../CloudflowUtil/js/CloudflowURL.js");
  var decoding = require("../../CloudflowUtil/js/Decoding.js");
  require("../../FileChooser/js/nixps-cloudflow-FileChooser.js");
  require("../../../common/Dialog/js/nixps-Dialog.js");
  require("../../../common/InteractiveDialog/js/nixps-MobileDialog.js");
  var cloudflowPathRegExp = new RegExp("^(cloudflow:\/\/|\/portal\.cgi\/|\.\.\/|\.\/).*");
  var notHttpPathRegExp = new RegExp("^(?!https?:)");

  /**
   * @namespace nixps-cloudflow.PathChooser
   * @description Draw a input field were we can select a file or folder
   * @version 1.9.0
   */
  $.widget("nixps-cloudflow.PathChooser", {
    widgetEventPrefix: "pathchooser",
    version: "1.9.0",
    options: {
      /**
       * @name nixps-cloudflow.PathChooser#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.PathChooser#name
       * @description attr the name attribute
       * @type {String}
       * @default ""
       */
      name: "",
      /**
       * @not done yet, in progress
       * @name nixps-cloudflow.PathChooser#multiple
       * @description Must we allow to select multiple files/folders
       * @type {Boolean}
       * @default false
       * @since 1.8.0
       */
      multiple: false,
      /**
       * @name nixps-cloudflow.PathChooser#foldersOnly
       * @description Must we show only folder or not.
       * @type {Boolean}
       * @default false
       * @since 1.0.0
       */
      foldersOnly: false,
      /**
       * @name nixps-cloudflow.PathChooser#selectFilesOnly
       * @description Allow only selecting files and not folders
       * @type {Boolean}
       * @default false
       * @since 1.4.0
       */
      selectFilesOnly: false,
      /**
       * @name nixps-cloudflow.PathChooser#allowed_file_types
       * @description The filestypes to be allowed to view 
       * @type {Array}
       * @default []
       * @since 1.1.0
       */
      allowed_file_types: [],
      /**
       * @name nixps-cloudflow.PathChooser#allowed_file_extensions
       * @description The file extensions to be allowed to view 
       * @type {Array}
       * @default []
       * @since 1.7.0
       */
      allowed_file_extensions: [],
      /**
       * @name nixps-cloudflow.PathChooser#path
       * @description The path of the choosen folder or file
       * @type {String}
       * @default ""
       * @since 1.0.0
       */
      path: "",
      /**
       * @name nixps-cloudflow.PathChooser#relativePath
       * @description The relative path to be taken
       * @type {String}
       * @default ""
       * @since 1.1.0
       */
      relativePath: "",
      /**
       * @name nixps-cloudflow.PathChooser#dialogTitle
       * @description The text to be show as title of the dialog
       * @type {String}
       * @default Select file
       * @since 1.1.0
       */
      dialogTitle: undefined,
      /**
       * @name nixps-cloudflow.PathChooser#dialogClass
       * @desc The classname to be given to the dialog
       * @type {String}
       * @default ""
       * @since 1.1.0
       */
      dialogClass: "",
      /**
       * @name nixps-cloudflow.PathChooser#inputClasses
       * @desc The classname to be given to the input
       * @type {String}
       * @default ""
       * @since 1.4.0
       */
      inputClasses: "",
      /**
       * @name nixps-cloudflow.PathChooser#enableExpressionBuilding
       * @description Must we disable the expressionbuilder or not, This option only disables!
       * @type {Boolean}
       * @default true
       * @since 1.3.0
       */
      enableExpressionBuilding: true,
      /**
       * @name nixps-cloudflow.PathChooser#enableCORS
       * @description Must we check if the url is comming from cloudlow otherwise it is invalid
       * @type {String}
       * @default "none"
       * @since 1.9.0
       */
      enableCORS: "none",
      /**
       * @name nixps-cloudflow.PathChooser#modal
       * @description Must the dialog be modal ?
       * @type {Boolean}
       * @default false
       * @since 1.2.0
       */
      modal: false,
      /**
       * @name nixps-cloudflow.PathChooser#decodeInput
       * @description Must we see, edit the paths in user decoded format, or false we see the urls in backend encoded format
       * @type {Boolean}
       * @default false
       * @since 1.8.0
       */
      decodeInput: false,
      /**
       * @name nixps-cloudflow.PathChooser#consent
       * @description The object containing info for privacy and cookies
       * @type {Object}
       * @default null
       * @since 1.5.0
       */
      consent: null,
      /**
       * @name nixps-cloudflow.PathChooser#buttonCSS
       * @description The css object to be applied on the button
       * @type {Object}
       * @default {
      "height": "22px",
      "margin-top": -1
      }
       * @since 1.1.0
       */
      buttonCSS: {
        height: "24px"
      },
      /**
       * @name nixps-cloudflow.PathChooser#inputCSS
       * @description The css object to be applied on the input
       * @type {Object}
       * @default {
      width: "calc(100% - 36px)",
          display: "inline-block"
      }
       * @since 1.6.0
       */
      inputCSS: {
        width: "calc(100% - 36px)",
        display: "inline-block"
      },
      /**
       * @name nixps-cloudflow.PathChooser#zIndex
       * @description Set the zIndex for the dialog
       * @type {Number}
       * @default 1000
       * @since 1.1.1
       */
      zIndex: 1000
    },
    _create: function _create() {
      // we need to keep it working in quatum nodes !
      if (typeof this.options.path === "string" && this.options.multiple === true) {
        if (this.options.path === "") {
          // default value, becomes default multiple value
          this.options.path = [];
        } else {
          // contains existon path, make array of it
          this.options.path = [this.options.path];
        }
      }
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("nixps-quantum-PathChooser");
      if (typeof this.element.attr("name") === "string" && this.element.attr("name").length > 0) {
        this.options.name = this.element.attr("name");
      }
      $("body:not(.nixps-Dialog)").Dialog();
      if (typeof this.options.dialogTitle !== "string") {
        if (this.options.foldersOnly === true) {
          this.options.dialogTitle = $.i18n._("nixps-cloudflow-pathchooser.dialogtitle_selectfolder");
        } else {
          this.options.dialogTitle = $.i18n._("nixps-cloudflow-pathchooser.dialogtitle_selectfile");
        }
      }
      var pathInput = $("<input>").attr("nixps-quantum-util-autobind", "false").attr("spellcheck", "false").addClass("cf-form-control-prefix").addClass(this.options.inputClasses).attr("inputmode", "url");
      if (this.options.enableExpressionBuilding === false) {
        pathInput.attr("data-nixps-quantum-onlyplainobject", true);
      }
      this.element.append(pathInput);
      if (this.options.inputCSS !== undefined && this.options.inputCSS !== "" && this.options.inputCSS !== null) {
        pathInput.css(this.options.inputCSS);
      }
      pathInput.tooltip({
        content: function content() {
          var title = $(this).attr("title");
          if (title.indexOf(";") > 0) {
            return $("<ul>").append(title.split(";").map(function (e) {
              return $("<li>").text(e);
            }));
          }
          // Escape title, since we're going from an attribute to raw HTML
          return $("<a>").text(title).html();
        },
        classes: {
          "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
        },
        position: {
          my: "center bottom-15px",
          at: "center center",
          collision: "flipfit flip"
        }
      });
      var buttonContainer = $("<div>").css({
        "float": "right"
      });
      var browseButton = $("<button>").attr("type", "button").addClass("cf-button cf-input-appendbutton");
      if (this.options.buttonCSS !== undefined && this.options.buttonCSS !== "" && this.options.buttonCSS !== null) {
        browseButton.css(this.options.buttonCSS);
      }
      browseButton.append($("<span>").addClass("cf-icon cf-icon-folder-icon"));
      browseButton.attr("title", $.i18n._("nixps-cloudflow-pathchooser.tooltip_openchooser"));
      browseButton.appendTo(buttonContainer);
      this.element.append(buttonContainer);
      if (this.options.disabled === true) {
        this.element.find("input, button").prop("disabled", true);
      }
      this._on(this.element, {
        "click button": this._clickBrowseHandler,
        "input input": this._pathChangedHandler,
        "paste input": this._pasteInputHandler
      });
      this._draw();
    },
    /**
     * @description function runs when user clicked on the folder icon
     * @function
     * @private
     * @name nixps-cloudflow.PathChooser#_clickBrowseHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _clickBrowseHandler: function _clickBrowseHandler(pEvent, pData) {
      this._browseFiles(pEvent);
    },
    /**
     * @description function runs when changes has been detected on the input field
     * @function
     * @private
     * @name nixps-cloudflow.PathChooser#_pathChangedHandler
     */
    _pathChangedHandler: function _pathChangedHandler() {
      if (this.options.multiple === true) {
        var stringifyPath = this.options.path.join(";");
        var newValue = this._getValueofInput().split(";").map(function (p) {
          return p.trim();
        }).filter(function (p) {
          return p.length > 0;
        });
        var stringifyNewValue = newValue.join(";");
        if (stringifyPath !== stringifyNewValue) {
          this.options.path = newValue;
          this._triggerChange();
        }
      } else {
        if (this.options.path !== this._getValueofInput()) {
          this.options.path = this._getValueofInput();
          this._triggerChange();
        }
      }
    },
    _pasteInputHandler: function _pasteInputHandler(pEvent, pData) {
      var that = this;
      var pastedValue = pEvent.originalEvent.clipboardData.getData("text");
      if (decoding.isNeutral(pastedValue)) {
        // if value is neutral, it is valid for all cases
        return;
      }
      if (this.options.decodeInput === true) {
        // users want to see decoded
        if (!decoding.isDecoded(pastedValue)) {
          //
          $("body").Dialog("showDialog", $.i18n._("nixps-cloudflow-pathchooser.pastemessage_title"), $.i18n._("nixps-cloudflow-pathchooser.pastemessage_messageisencoded"), {}, [{
            classes: "cf-button-secondary",
            type: "no",
            label: "nixps-cloudflow-dialog.no",
            cbFunction: function cbFunction() {/* do nothing */}
          }, {
            classes: "cf-button-main",
            type: "yes",
            label: "nixps-cloudflow-dialog.yes",
            cbFunction: function cbFunction() {
              if (that.options.multiple === true) {
                that.options.path = pastedValue.split(";").map(function (p) {
                  return p.trim();
                }).filter(function (p) {
                  return p.length > 0;
                });
                that.element.find("input").val(decodeURI(that.options.path.join(";")));
              } else {
                that.options.path = pastedValue;
                that.element.find("input").val(decodeURI(that.options.path));
              }
            }
          }]);
        }
      } else {
        // users want to see encoded
        if (decoding.isDecoded(pastedValue)) {
          // the value is decoded
          $("body").Dialog("showDialog", $.i18n._("nixps-cloudflow-pathchooser.pastemessage_title"), $.i18n._("nixps-cloudflow-pathchooser.pastemessage_messageisdecoded"), {}, [{
            classes: "cf-button-secondary",
            type: "no",
            label: "nixps-cloudflow-dialog.no",
            cbFunction: function cbFunction() {/* do nothing */}
          }, {
            classes: "cf-button-main",
            type: "yes",
            label: "nixps-cloudflow-pathchooser.buttonlabel_encode",
            cbFunction: function cbFunction() {
              that.element.find("input").val(decoding.encodeBackend(pastedValue));
            }
          }]);
        }
      }
    },
    _triggerChange: function _triggerChange() {
      this._trigger("change", null, {
        path: this.options.path
      });
    },
    triggerChange: function triggerChange() {
      this._trigger("change", null, {
        name: this.options.name,
        value: this.getValue()
      });
    },
    _browseFiles: function _browseFiles(pLinkedEvent) {
      var that = this;
      if (this.browseDialog instanceof jQuery) {
        this.browseDialog.remove();
      }
      this.browseDialog = $("<div>");

      // Create the dialog
      var chooserDiv = $("<div>");
      this.browseDialog.append(chooserDiv);
      var dialogClass = this.options.dialogClass + " nixps-cloudflow-PathChooserDialog cf-dialog";
      this.browseDialog.MobileDialog({
        autoOpen: false,
        modal: this.options.modal,
        height: 500,
        width: 500,
        title: this.options.dialogTitle,
        closeText: "",
        dialogClass: dialogClass,
        classes: {
          "ui-dialog": dialogClass
        },
        open: function open() {
          $(this).find(".nixps-cloudflow-FileChooser").FileChooser("resizeCanvas");
          $(this).closest(".nixps-cloudflow-PathChooserDialog").css("z-index", "99999999999999999999");
        },
        close: function close(pEvent) {
          var eventtype = "";
          if (pEvent !== undefined && pEvent.originalEvent !== undefined) {
            // only known events
            if (["filechooserselect", "filechooserchoosen"].includes(pEvent.originalEvent.type)) {
              eventtype = pEvent.originalEvent.type.slice(11);
            }
          }
          that._trigger("close", pEvent, {
            eventtype: eventtype
          });
        },
        zIndex: this.options.zIndex
      });
      var url = undefined;
      if (this.options.multiple === true) {
        url = ""; // use empty string if array has length 0
        if (Array.isArray(this.options.path) && this.options.path.length > 0) {
          url = this.options.path[0];
        }
      } else {
        url = this.options.path;
      }
      if (typeof url !== "string") {
        url = "";
      } else if (url.startsWith("/portal.cgi/")) {
        url = "cloudflow://" + url.slice(12);
      }
      if (typeof this.options.relativePath === "string" && this.options.relativePath.length > 0 && url.substring(0, 12) !== "cloudflow://") {
        if (url === "") {
          url = new CloudflowURL(this.options.relativePath).getCloudflowPath();
        } else {
          url = new CloudflowURL(this.options.relativePath, url).getCloudflowPath();
        }
      }

      //if the input is empty, we're in a relativePath/no url situation, and don't want the end "/" to be removed
      if (this.options.foldersOnly === true && typeof url === "string" && url.substring(url.length - 1) === "/" && this._getValueofInput().length !== 0 && this._getValueofInput() !== "cloudflow://") {
        url = url.slice(0, -1);
      }

      // Create the chooser
      chooserDiv.FileChooser({
        multiple: this.options.multiple,
        foldersOnly: this.options.foldersOnly,
        allowed_file_types: this.options.allowed_file_types,
        allowed_file_extensions: this.options.allowed_file_extensions,
        columns: ["thumb", "name", "filetype", "modtime"],
        context: "pathchooser",
        url: url,
        consent: this.options.consent,
        choosen: function choosen(pEvent, pData) {
          var selectedItems = pData.files;
          if (selectedItems.length > 0) {
            var newCanditatePaths = selectedItems.map(function (pURL) {
              if (that.options.relativePath.length > 0 && pURL.cloudflow.file.indexOf(that.options.relativePath) === 0) {
                // file can be transformed to relativePath
                return pURL.cloudflow.file.slice(that.options.relativePath.length);
              } else {
                return pURL.cloudflow.file;
              }
            });
            if (that.options.multiple === false) {
              if (newCanditatePaths[0] !== that.options.path) {
                that.options.path = newCanditatePaths[0];
                that._setValueOfInput(that.options.path);
                that._triggerChange();
                // this trigger changes for form and page builders
                that.element.trigger("fieldcustomchange");
              }
            } else if (that.options.multiple === true) {
              that.options.path = newCanditatePaths.slice();
              that._setValueOfInput(that.options.path.join(";"));
              that._triggerChange();
              // this trigger changes for form and page builders
              that.element.trigger("fieldcustomchange");
            }
            that.browseDialog.MobileDialog("close", pEvent);
            that.browseDialog.remove();
          }
        },
        enableSelectButton: true,
        select: function select(pEvent, pData) {
          var selectedItems = pData.files;
          if (selectedItems.length > 0) {
            if (that.options.selectFilesOnly === true) {
              selectedItems = selectedItems.filter(function (pURL) {
                return pURL[pURL.length - 1] !== "/";
              });
              if (selectedItems.length === 0) {
                return false; // do not select folder if we want only files
              }
            }

            var newCanditatePaths = selectedItems.map(function (pURL) {
              if (that.options.relativePath.length > 0 && pURL.indexOf(that.options.relativePath) === 0) {
                // file can be transformed to relativePath
                return pURL.slice(that.options.relativePath.length);
              } else {
                return pURL;
              }
            });
            if (that.options.multiple === false) {
              if (newCanditatePaths[0] !== that.options.path) {
                that.options.path = newCanditatePaths[0];
                that._setValueOfInput(that.options.path);
                that._triggerChange();
                // this trigger changes for form and page builders
                that.element.trigger("fieldcustomchange");
                that._trigger("select", null, {
                  path: newCanditatePaths[0]
                });
              }
            } else if (that.options.multiple === true) {
              that.options.path = newCanditatePaths.slice();
              that._setValueOfInput(that.options.path.join(";"));
              that._triggerChange();
              // this trigger changes for form and page builders
              that.element.trigger("fieldcustomchange");
              that._trigger("select", null, {
                path: newCanditatePaths
              });
            }
            that.browseDialog.MobileDialog("close", pEvent);
            that.browseDialog.remove();
          } else if (that.options.foldersOnly === true) {
            var currentFolder = $(this).FileChooser("getCurrentFolder");
            if (that.options.multiple === true) {
              that.options.path = [currentFolder];
              that._setValueOfInput(that.options.path[0]);
            } else {
              that.options.path = currentFolder;
              that._setValueOfInput(that.options.path);
            }
            that._triggerChange();
            // this trigger changes for form and page builders
            that.element.trigger("fieldcustomchange");
            that._trigger("globalselect", null, {
              path: that.options.path
            });
            that.browseDialog.MobileDialog("close", pEvent);
            that.browseDialog.remove();
          }
        },
        viewchanged: function viewchanged(pEvent, pData) {
          that._trigger("viewchanged", null, {
            view: pData.view
          });
        }
      });
      this.browseDialog.MobileDialog("open");
    },
    _draw: function _draw() {
      if (this.options.multiple === true) {
        if (Array.isArray(this.options.path) && this.options.path.length > 0) {
          this._setValueOfInput(this.options.path.join(";"));
        }
        // keep empty if array has length zero, or has other values
      } else {
        this._setValueOfInput(this.options.path);
      }
    },
    _setValueOfInput: function _setValueOfInput(pValue) {
      if (this.options.decodeInput === true) {
        this.element.find("input").attr("title", decodeURI(pValue)).val(decodeURI(pValue));
      } else {
        this.element.find("input").attr("title", decodeURI(pValue)).val(pValue);
      }
    },
    _getValueofInput: function _getValueofInput() {
      var value = this.element.find("input").val();
      if (this.options.decodeInput === true) {
        return decoding.encodeBackend(value);
      } else {
        return value;
      }
    },
    /**
     * @description get the selected path
     * @function
     * @name nixps-cloudflow.PathChooser#getValue
     * @returns {Array|String} the paht
     */
    getValue: function getValue() {
      return this.options.path;
    },
    /**
     * @description set to a specific path
     * @function
     * @name nixps-cloudflow.PathChooser#setValue
     * @param {String|Array} pPath the value to give
     */
    setValue: function setValue(pPath) {
      if (this.options.multiple === true) {
        if (typeof pPath === "string") {
          this.options.path = [pPath]; // make array of single url
        } else if (Array.isArray(pPath)) {
          this.options.path = pPath.slice(); // clone
        }

        this._draw();
      } else {
        this.options.path = pPath;
        this._draw();
      }
    },
    reset: function reset() {
      this.setValue("");
    },
    isValid: function isValid() {
      if (this.options.enableCORS !== "none") {
        var urlsToCheck = [];
        if (Array.isArray(this.options.path)) {
          urlsToCheck = this.options.path;
        } else {
          urlsToCheck = [this.options.path];
        }
        var regExp = new RegExp(".*");
        switch (this.options.enableCORS) {
          case "full_and_relative":
            regExp = cloudflowPathRegExp;
            break;
          case "not_http":
            regExp = notHttpPathRegExp;
            break;
          default:
            console.error("unknown CORS option ", this.options.enableCORS);
        }
        for (var i = 0; i < urlsToCheck.length; i++) {
          if (regExp.test(urlsToCheck[i]) === false) {
            return $.i18n._("nixps-cloudflow-FormRenderer.url_violates_cors");
          }
        }
      }
      return true;
    },
    /**
     * @description Open the dialog
     * @function
     * @name nixps-cloudflow.PathChooser#open
     * @returns {undefined}
     */
    open: function open() {
      this._browseFiles();
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      if (pKey === "path") {
        this._draw();
      }
      if (pKey === "disabled") {
        this.element.find("input, button").prop("disabled", pValue);
      }
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.foldersOnly !== "boolean") {
        throw new Error("input option foldersOnly must be a boolean");
      }
      if (typeof this.options.relativePath !== "string") {
        throw new Error("input option relativePath must be a string");
      }
      if (typeof this.options.dialogTitle !== "string" && this.options.dialogTitle !== undefined) {
        throw new Error("input option dialogTitle must be a string");
      }
      if (typeof this.options.dialogClass !== "string") {
        throw new Error("input option dialogClass must be a string");
      }
      if (Array.isArray(this.options.allowed_file_types) === false) {
        throw new Error("input option allowed_file_types must be an array");
      }
      if (Array.isArray(this.options.allowed_file_extensions) === false) {
        throw new Error("input option allowed_file_types must be an array");
      }
      if ($.isPlainObject(this.options.buttonCSS) === false && this.options.buttonCSS !== null) {
        throw new Error("input option buttonCSS must be a plain object");
      }
      if (typeof this.options.selectFilesOnly !== "boolean") {
        throw new Error("input option selectFilesOnly must be a boolean");
      }
      if (this.options.foldersOnly === true && this.options.selectFilesOnly === true) {
        throw new Error("conflicting input options, foldersOnly and selectFilesOnly may not be both on true");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("nixps-quantum-PathChooser").removeAttr("name");
      this._super();
      if (this.browseDialog instanceof jQuery) {
        this.browseDialog.remove();
      }
    }
  });
})(jQuery);

},{"../../../common/Dialog/js/nixps-Dialog.js":287,"../../../common/InteractiveDialog/js/nixps-MobileDialog.js":293,"../../CloudflowUtil/js/CloudflowURL.js":80,"../../CloudflowUtil/js/Decoding.js":84,"../../FileChooser/js/nixps-cloudflow-FileChooser.js":133}],201:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var TemporyBrowserObjectCache = require("../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var Device = require("../../PWA/js/Device.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
var kCacheID = "nixps_cloudflow_applicationpreferences";
var userPreferences = {};
var systemPreferences = {};
function saveBrowserCache() {
  TemporyBrowserObjectCache.save(kCacheID, {
    user_preferences: userPreferences,
    system_preferences: systemPreferences
  });
}

/**
 * @constructor ApplicationPreferences
 * @description Create the class that read the application preferences
 */
var ApplicationPreferences = function ApplicationPreferences(pOptions) {};

/**
 * @description Get the ApplicationPreferences but load already the needed data
 * @function
 * @static
 * @name ApplicationPreferences#get
 * @param {Array.<String>} pApplicationsForUser All the user scoped application preferences to be loaded
 * @param {Array.<String>} pApplicationForSystem All the system scopes application preferences to be loaded
 * @returns {Promise} ApplicationPreferences
 */
ApplicationPreferences.get = function (pApplicationsForUser, pApplicationForSystem) {
  if (Object.keys(userPreferences).length === 0) {
    if (TemporyBrowserObjectCache.isPageReload() !== true || Device.getPollingFactor() > 1) {
      var cacheObject = TemporyBrowserObjectCache.get(kCacheID);
      if (cacheObject !== null && _typeof(cacheObject) === "object") {
        if (_typeof(cacheObject.user_preferences) === "object") {
          userPreferences = cacheObject.user_preferences;
        }
        if (_typeof(cacheObject.system_preferences) === "object") {
          systemPreferences = cacheObject.system_preferences;
        }
      }
    }
  }
  var userPrefPromise = {},
    systemPrefPromise = {};
  if (Array.isArray(pApplicationsForUser) && pApplicationsForUser.length > 0) {
    var appForUsers = pApplicationsForUser.filter(function (a) {
      return userPreferences[a] === undefined;
    }); // filter out the cached ones

    if (appForUsers.length > 0) {
      appForUsers = Array.from(new Set(appForUsers)); // make unique
    }

    if (appForUsers.length > 0) {
      userPrefPromise = api_defer.preferences.get_for_current_user(appForUsers, Array(appForUsers.length).fill("")).then(function (pResult) {
        if (!pResult) {
          pResult = {};
        }
        if (pResult.preferences === undefined || pResult.preferences === null) {
          pResult.preferences = [];
        }
        for (var i = 0; i < pResult.preferences.length; i++) {
          if (!pResult.preferences[i]) {
            pResult.preferences[i] = {};
          }
        }
        // update inner model
        appForUsers.forEach(function (pApplicationID, pIndex) {
          userPreferences[pApplicationID] = pResult.preferences[pIndex];
        });
      });
    }
  }
  if (Array.isArray(pApplicationForSystem) && pApplicationForSystem.length > 0) {
    var appForSystem = pApplicationForSystem.filter(function (a) {
      return systemPreferences[a] === undefined;
    }); // filter out the cached ones

    if (appForSystem.length > 0) {
      appForSystem = Array.from(new Set(appForSystem)); // make unique
    }

    if (appForSystem.length > 0) {
      systemPrefPromise = api_defer.preferences.get_for_realm("system", "", appForSystem, Array(appForSystem.length).fill("")).then(function (pResult) {
        if (!pResult) {
          pResult = {};
        }
        if (pResult.preferences === undefined || pResult.preferences === null) {
          pResult.preferences = [];
        }
        for (var i = 0; i < pResult.preferences.length; i++) {
          if (!pResult.preferences[i]) {
            pResult.preferences[i] = {};
          }
        }
        // update inner model
        appForSystem.forEach(function (pApplicationID, pIndex) {
          systemPreferences[pApplicationID] = pResult.preferences[pIndex];
        });
      });
    }
  }
  return Promise.all([userPrefPromise, systemPrefPromise]).then(function () {
    // update browser model
    saveBrowserCache();
    return new ApplicationPreferences();
  });
};

/**
 * @description Get the user preferences of a specific application id and Key
 * @function
 * @static
 * @name ApplicationPreferences#getUserValue
 * @param {String} pApplicationID the id of the application
 * @param {String} pKey the parameter (leave) you want to retrieve from
 * @param {Boolean} pForce must we enfoce to reload, reask to the backend
 * @returns {Promise}
 */
ApplicationPreferences.getUserValue = function (pApplicationID, pKey, pForce, pDefault) {
  if (typeof pApplicationID !== "string" || pApplicationID.length <= 0) {
    throw new Error("pApplicationID must be a not empty string");
  }
  if (typeof pKey !== "string") {
    throw new Error("pKey must be a string");
  }
  if (pKey === "") {
    pKey = ".";
  }
  if (pForce === undefined) {
    pForce = false;
  }
  if (pForce === true || userPreferences[pApplicationID] === undefined) {
    // load complete application JSON
    return api_defer.preferences.get_for_current_user(pApplicationID, "").then(function (pResult) {
      if (!pResult) {
        pResult = {};
      }
      if (pResult.preferences === undefined || pResult.preferences === null) {
        pResult.preferences = {};
      }
      // update inner model
      userPreferences[pApplicationID] = pResult.preferences;
      if (pDefault !== undefined && CloudflowObject.getParameter(userPreferences[pApplicationID], pKey) === undefined) {
        userPreferences[pApplicationID] = CloudflowObject.setParameter(userPreferences[pApplicationID], pKey, pDefault);
      }
      // update browser model
      saveBrowserCache();
      return structuredClone(CloudflowObject.getParameter(userPreferences[pApplicationID], pKey));
    }, function (pError) {
      console.error(pError);
      return Promise.reject(pError);
    });
  } else {
    if (pDefault !== undefined && CloudflowObject.getParameter(userPreferences[pApplicationID], pKey) === undefined) {
      userPreferences[pApplicationID] = CloudflowObject.setParameter(userPreferences[pApplicationID], pKey, pDefault);
    }
    return Promise.resolve(structuredClone(CloudflowObject.getParameter(userPreferences[pApplicationID], pKey)));
  }
};

/**
 * @description Get the system preferences of a specific application id and Key
 * @function
 * @static
 * @name ApplicationPreferences#getSystemValue
 * @param {String} pApplicationID the id of the application
 * @param {String} pKey the parameter (leave) you want to retrieve from
 * @param {Boolean} pForce must we enfoce to reload, reask to the backend
 * @returns {Promise}
 */
ApplicationPreferences.getSystemValue = function (pApplicationID, pKey, pForce, pDefault) {
  if (typeof pApplicationID !== "string" || pApplicationID.length <= 0) {
    throw new Error("pApplicationID must be a not empty string");
  }
  if (typeof pKey !== "string") {
    throw new Error("pKey must be a string");
  }
  if (pKey === "") {
    pKey = ".";
  }
  if (pForce === undefined) {
    pForce = false;
  }
  if (pForce === true || systemPreferences[pApplicationID] === undefined) {
    // load complete application JSON
    return api_defer.preferences.get_for_realm("system", "", pApplicationID, "").then(function (pResult) {
      if (!pResult) {
        pResult = {};
      }
      if (pResult.preferences === undefined || pResult.preferences === null) {
        pResult.preferences = {};
      }
      // update inner model
      systemPreferences[pApplicationID] = pResult.preferences;
      if (pDefault !== undefined && CloudflowObject.getParameter(systemPreferences[pApplicationID], pKey) === undefined) {
        systemPreferences[pApplicationID] = CloudflowObject.setParameter(systemPreferences[pApplicationID], pKey, pDefault);
      }
      // update browser model
      saveBrowserCache();
      return structuredClone(CloudflowObject.getParameter(systemPreferences[pApplicationID], pKey));
    }, function (pError) {
      console.error(pError);
      return Promise.reject(pError);
    });
  } else {
    if (pDefault !== undefined && CloudflowObject.getParameter(systemPreferences[pApplicationID], pKey) === undefined) {
      systemPreferences[pApplicationID] = CloudflowObject.setParameter(systemPreferences[pApplicationID], pKey, pDefault);
    }
    return Promise.resolve(structuredClone(CloudflowObject.getParameter(systemPreferences[pApplicationID], pKey)));
  }
};

/**
 * @description set or save some settings to the preferences
 * @function
 * @static
 * @name ApplicationPreferences#saveUserValue
 * @param {String} pApplicationID the id of the application
 * @param {String} pKey the subkey
 * @param {Mixed} pValue the value to assign
 * @returns {Promise}
 */
ApplicationPreferences.saveUserValue = function (pApplicationID, pKey, pValue) {
  if (typeof pApplicationID !== "string") {
    throw new Error("pApplicationID must be a not empty string");
  }
  if (typeof pKey !== "string") {
    throw new Error("pKey must be a string");
  }
  if (userPreferences[pApplicationID] === undefined) {
    userPreferences[pApplicationID] = {};
  }
  // save inner model
  if (pKey === "") {
    userPreferences[pApplicationID] = CloudflowObject.merge([userPreferences[pApplicationID], pValue]);
  } else {
    userPreferences[pApplicationID] = CloudflowObject.setParameter(userPreferences[pApplicationID], pKey, pValue);
  }
  if (_typeof(pValue) === "object") {
    // users can delete parameters, by appling undefined
    var keysToDelete = [];
    CloudflowObject.contains(userPreferences[pApplicationID], function (pKey, pValue) {
      if (pValue === undefined) {
        keysToDelete.push(pKey);
      }
    });
    if (keysToDelete.length > 0) {
      for (var i = 0; i < keysToDelete.length; i++) {
        CloudflowObject.deleteParameter(userPreferences[pApplicationID], keysToDelete[i]);
      }
    }
  }
  // save browser model
  saveBrowserCache();
  // save only specific key value in database
  return api_defer.preferences.save_for_current_user(pValue, pApplicationID, pKey);
};

/**
 * @description set or save some settings to the preferences
 * @function
 * @static
 * @name ApplicationPreferences#saveSystemValue
 * @param {String} pApplicationID the id of the application
 * @param {String} pKey the subkey
 * @param {Mixed} pValue the value to assign
 * @returns {Promise}
 */
ApplicationPreferences.saveSystemValue = function (pApplicationID, pKey, pValue) {
  if (typeof pApplicationID !== "string" || pApplicationID.length <= 0) {
    throw new Error("pApplicationID must be a not empty string");
  }
  if (typeof pKey !== "string") {
    throw new Error("pKey must be a string");
  }
  if (systemPreferences[pApplicationID] === undefined) {
    systemPreferences[pApplicationID] = {};
  }
  // save inner model
  if (pKey === "") {
    systemPreferences[pApplicationID] = CloudflowObject.merge([systemPreferences[pApplicationID], pValue]);
  } else {
    systemPreferences[pApplicationID] = CloudflowObject.setParameter(systemPreferences[pApplicationID], pKey, pValue);
  }
  if (_typeof(pValue) === "object") {
    // users can delete parameters, by appling undefined
    var keysToDelete = [];
    CloudflowObject.contains(systemPreferences[pApplicationID], function (pKey, pValue) {
      if (pValue === undefined) {
        keysToDelete.push(pKey);
      }
    });
    if (keysToDelete.length > 0) {
      for (var i = 0; i < keysToDelete.length; i++) {
        CloudflowObject.deleteParameter(systemPreferences[pApplicationID], keysToDelete[i]);
      }
    }
  }
  // check user model
  var needSpecialMerge = false;
  if (userPreferences[pApplicationID] !== undefined) {
    if (/[.][0-9]+/.test(pKey)) {
      needSpecialMerge = true;
    } else {
      userPreferences[pApplicationID] = CloudflowObject.setParameter(userPreferences[pApplicationID], pKey, pValue);
    }
  }
  // save browser model
  saveBrowserCache();
  // save only specific key value in database
  return api_defer.preferences.save_for_realm(pValue, "system", "", pApplicationID, pKey).then(function (pResults) {
    if (needSpecialMerge === true) {
      return ApplicationPreferences.getUserValue(pApplicationID, pKey, true);
    }
    return pResults;
  });
};

/**
 * @description clear the complete application section on user scope
 * @function
 * @static
 * @name ApplicationPreferences#clearUserApplication
 * @param {String} pApplicationID the application to clear
 * @returns {undefined}
 */
ApplicationPreferences.clearUserApplication = function (pApplicationID) {
  if (typeof pApplicationID !== "string") {
    throw new Error("pApplicationID must be a not empty string");
  }
  delete userPreferences[pApplicationID];
  // save updated model that contains less data
  saveBrowserCache();
};

/**
 * @description clear the complete application section on system scope
 * @function
 * @static
 * @name ApplicationPreferences#clearSystemApplication
 * @param {String} pApplicationID the application to clear
 * @returns {undefined}
 */
ApplicationPreferences.clearSystemApplication = function (pApplicationID) {
  if (typeof pApplicationID !== "string") {
    throw new Error("pApplicationID must be a not empty string");
  }
  delete systemPreferences[pApplicationID];
  // save updated model that contains less data
  saveBrowserCache();
};

/**
 * @description Clear the working memory and the browser cache
 * @function
 * @static
 * @name ApplicationPreferences#clear
 * @returns {undefined}
 */
ApplicationPreferences.clear = function () {
  userPreferences = {};
  systemPreferences = {};
  TemporyBrowserObjectCache.remove(kCacheID);
};
ApplicationPreferences.prototype = {
  constructor: ApplicationPreferences,
  isUserApplicationPresent: function isUserApplicationPresent(pApplicationID) {
    if (typeof pApplicationID !== "string") {
      throw new Error("pApplicationID must be a not empty string");
    }
    return userPreferences[pApplicationID] !== undefined;
  },
  isSystemApplicationPresent: function isSystemApplicationPresent(pApplicationID) {
    if (typeof pApplicationID !== "string") {
      throw new Error("pApplicationID must be a not empty string");
    }
    return systemPreferences[pApplicationID] !== undefined;
  },
  /**
   * @description Get sync the value of the user preferences
   * @function
   * @name ApplicationPreferences#getUserValue
   * @param {String} pApplicationID the key of the application
   * @param {String} pKey the name of the parameter you want
   * @returns {Object} the value of the preferences
   */
  getUserValue: function getUserValue(pApplicationID, pKey) {
    if (typeof pApplicationID !== "string") {
      throw new Error("pApplicationID must be a string");
    }
    if (typeof pKey !== "string") {
      throw new Error("pKey must be a string");
    }
    if (pKey === "") {
      pKey = ".";
    }
    if (this.isUserApplicationPresent(pApplicationID) === false) {
      throw new Error("application " + pApplicationID + " is not present and loaded");
    }
    return structuredClone(CloudflowObject.getParameter(userPreferences[pApplicationID], pKey));
  },
  /**
   * @description Get sync the value of the system preferences
   * @function
   * @name ApplicationPreferences#getSystemValue
   * @param {String} pApplicationID the key of the application
   * @param {String} pKey the name of the parameter you want
   * @returns {Object} the value of the preferences
   */
  getSystemValue: function getSystemValue(pApplicationID, pKey) {
    if (typeof pApplicationID !== "string") {
      throw new Error("pApplicationID must be a string");
    }
    if (typeof pKey !== "string") {
      throw new Error("pKey must be a string");
    }
    if (pKey === "") {
      pKey = ".";
    }
    if (this.isSystemApplicationPresent(pApplicationID) === false) {
      throw new Error("application " + pApplicationID + " is not present and loaded");
    }
    return structuredClone(CloudflowObject.getParameter(systemPreferences[pApplicationID], pKey));
  }
};
if (window.nixps && window.nixps.testing !== undefined && window.nixps.testing.clear_applicationpreferences !== undefined) {
  window.nixps.testing.clear_applicationpreferences.push(ApplicationPreferences.clear);
}
module.exports = ApplicationPreferences;

},{"../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../PWA/js/Device.js":198}],202:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
var Version = require("../../Version/js/Version.js");
var TemporyBrowserObjectCache = require("../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var Device = require("../../PWA/js/Device.js");
var clearCachingCallingID = 0;
var preferences = null;
var preferencesDef = null;
var preferencesResolvers = null;
var prereleaseSettings = null;
var prereleaseDef = null;
var prereleaseResolvers = null;
var versionObject;

/**
 * @deprecated use getPreferencesAsync
 * @function
 * @private
 * @static
 * @returns preferences
 */
function getPreferences() {
  if (preferences === null) {
    var output = window.api_sync.preferences.get_for_current_user("", "");
    if (output && output.preferences && _typeof(output.preferences) === "object") {
      preferences = output.preferences;
    } else if (output && output.error) {
      throw new Error(output.error);
    }
  }
  return preferences;
}

/**
 * @deprecated use getPrereleaseSettingsAsync
 * @function
 * @private
 * @static
 * @returns prerelease settings
 */
function getPrereleaseSettings() {
  if (prereleaseSettings === null) {
    prereleaseSettings = window.api_sync.preferences.get_for_current_user("com.nixps.general.prerelease", "").preferences;
  }
  return prereleaseSettings;
}
function getPreferencesAndPrereleaseSettingsAsync() {
  var output = {
    preferences: undefined,
    prereleases: undefined
  };
  if (preferences !== null) {
    output.preferences = preferences;
  } else if (preferencesDef !== null) {
    output.preferences = preferencesDef;
  }
  if (prereleaseSettings !== null) {
    output.prereleases = prereleaseSettings;
  } else if (prereleaseDef !== null) {
    output.prereleases = prereleaseDef;
  }
  if (TemporyBrowserObjectCache.isPageReload() !== true || Device.getPollingFactor() > 1) {
    var cacheObject = TemporyBrowserObjectCache.get("nixps_cloudflow_prerelease");
    if (cacheObject !== null) {
      prereleaseSettings = cacheObject;
      output.prereleases = prereleaseSettings;
    }
  }
  if (output.prereleases === undefined && output.preferences === undefined) {
    var prereleasePromiseDict = Promise.withResolvers();
    prereleaseDef = prereleasePromiseDict.promise;
    preferencesDef = api_defer.preferences.get_for_current_user(["", "com.nixps.general.prerelease"], ["", ""]).then(function (pResults) {
      if (pResults && Array.isArray(pResults.preferences) && pResults.preferences.length === 2) {
        // initialise the model
        preferences = pResults.preferences[0];
        prereleaseSettings = pResults.preferences[1];
        TemporyBrowserObjectCache.save("nixps_cloudflow_prerelease", pResults.preferences[1]);
        prereleasePromiseDict.resolve(prereleaseSettings);
        return preferences;
      }
    }, function (pError) {
      console.error(pError);
      prereleasePromiseDict.reject(pError);
      return Promise.reject(pError);
    });
    output.prereleases = prereleaseDef;
    output.preferences = preferencesDef;
  } else if (output.prereleases !== undefined && output.preferences === undefined) {
    preferencesDef = api_defer.preferences.get_for_current_user("", "").then(function (pResults) {
      preferences = pResults.preferences;
      return pResults.preferences;
    });
    output.preferences = preferencesDef;
  } else if (output.prereleases === undefined && output.preferences !== undefined) {
    prereleaseDef = api_defer.preferences.get_for_current_user("com.nixps.general.prerelease", "").then(function (pResults) {
      prereleaseSettings = pResults.preferences;
      TemporyBrowserObjectCache.save("nixps_cloudflow_prerelease", pResults.preferences);
      return pResults.preferences;
    });
    output.prereleases = prereleaseDef;
  }
  return Promise.all([output.preferences, output.prereleases]);
}

/**
 * @description an unit has a unique name and optionally a precision
 * @constructor UserPreferences
 * @name UserPreferences
 */
var UserPreferences = function UserPreferences(pPreferences, pPreReleaseSettings, pVersionHashString) {
  // Legacy: if an old page constructs without parameters -> use the sync way to get the preferences
  if (pPreferences === undefined || pPreferences === null) {
    this.mPreferences = getPreferences();
    this.mPrereleaseSettings = getPrereleaseSettings();
  } else {
    this.mPreferences = preferences;
    this.mPrereleaseSettings = prereleaseSettings;
  }
  this.versionHashString = null;
  if (typeof pVersionHashString === "string" && pVersionHashString.length > 0) {
    this.versionHashString = pVersionHashString;
  }
};
UserPreferences.getResources = function (pResourceObject) {
  if (preferencesDef === null) {
    preferencesResolvers = Promise.withResolvers();
    preferencesResolvers.status = "pending";
    preferencesDef = preferencesResolvers.promise;
  }
  if (prereleaseDef === null) {
    prereleaseResolvers = Promise.withResolvers();
    prereleaseResolvers.status = "pending";
    prereleaseDef = prereleaseResolvers.promise;
  }
  return [{
    apiCall: "get_for_current_user",
    apiAppKey: "",
    apiSubKey: ""
  }, {
    apiCall: "get_for_current_user",
    apiAppKey: "com.nixps.general.prerelease",
    apiSubKey: ""
  }];
};

/**
 * @desc returns a deferred that resolves to the user preferences
 * @name UserPreferences.get
 * @static
 * @example nixps.cloudflow.UserPreferences.get().then(function(pPreferences) {
 *      that.language = pPreferences.getLanguage();
 * });
 */
UserPreferences.get = function (pLoadVersion) {
  var defLoadVersionHashString = {};
  if (pLoadVersion === true) {
    defLoadVersionHashString = Version.get().then(function (version) {
      versionObject = version.getVersionObject();
      return version.getHashString();
    })["catch"](function (pError) {
      console.error(pError);
      versionObject = null;
      return "" + new Date().getFullYear() + "-" + new Date().getMonth();
    });
  }
  return Promise.all([getPreferencesAndPrereleaseSettingsAsync(), defLoadVersionHashString, clearCachingCallingID]).then(function (pResult) {
    var pPreferences = pResult[0],
      pVersionHashString = pResult[1],
      pClearCachingID = pResult[2];
    if (pClearCachingID !== clearCachingCallingID) {
      return Promise.reject({
        error_code: "testing_error",
        error: "clear happend in the meanwhile"
      });
    }
    return new UserPreferences(pPreferences[0], pPreferences[1], pVersionHashString);
  });
};
UserPreferences.set = function (pPreferences, pPreReleaseSettings) {
  if (pPreferences && _typeof(pPreferences) === "object") {
    preferences = Object.freeze(pPreferences);
    if (preferencesResolvers && preferencesResolvers.status === "pending") {
      preferencesResolvers.status = "resolved";
      preferencesResolvers.resolve(preferences);
    }
  } else {
    // ignore error, data will be reasked later on
    console.error("invalid interface for UserPreferences.set :");
  }
  if (pPreReleaseSettings && _typeof(pPreReleaseSettings) === "object") {
    prereleaseSettings = Object.freeze(pPreReleaseSettings);
    if (prereleaseResolvers && prereleaseResolvers.status === "pending") {
      prereleaseResolvers.status = "resolved";
      prereleaseResolvers.resolve(prereleaseSettings);
    }
    TemporyBrowserObjectCache.save("nixps_cloudflow_prerelease", prereleaseSettings);
  } else {
    // ignore error, data will be reasked later on
    console.error("invalid interface for UserPreferences.set: ");
  }
};
UserPreferences.clearCaches = function () {
  preferences = null;
  preferencesDef = null;
  preferencesResolvers = null;
  prereleaseSettings = null;
  prereleaseDef = null;
  prereleaseResolvers = null;
  Version.reset();
  TemporyBrowserObjectCache.remove("nixps_cloudflow_prerelease");
  TemporyBrowserObjectCache.remove("nixps_cloudflow_menu");
  clearCachingCallingID++;
};
UserPreferences.prototype = {
  constructor: UserPreferences,
  /**
   * @description Do we known the language or not?
   * @function
   * @name UserPreferences#isLanguageKnown
   * @returns {Boolean} true if the language is known, otherwise false
   */
  isLanguageKnown: function isLanguageKnown() {
    return this.mPreferences && typeof this.mPreferences.language === "string" && this.mPreferences.language.length > 0;
  },
  /**
   * @description Get the language of the current user
   * @function
   * @name UserPreferences#getLanguage
   * @example preferences.getLanguage();
   * @returns {String} The language code of the user
   */
  getLanguage: function getLanguage() {
    if (this.isLanguageKnown()) {
      return this.mPreferences.language;
    }
    return "en";
  },
  /**
   * @description change the language of the user
   * @function
   * @name UserPreferences#setLanguage
   * @param {String} pLanguage 
   */
  setLanguage: function setLanguage(pLanguage) {
    if (typeof pLanguage === "string" && pLanguage.length === 2) {
      if (this.mPreferences) {
        this.mPreferences.language = pLanguage;
      }
      if (preferences) {
        var isFroozen = Object.isFrozen(preferences);
        preferences = Object.assign({}, preferences, {
          language: pLanguage
        });
        if (isFroozen) {
          Object.freeze(preferences);
        }
      }
    }
  },
  /**
   * @description Do the current user want to see system workflows
   * @function
   * @name UserPreferences#canViewSystemFlows
   * @example preferences.canViewSystemFlows();
   * @returns {Boolean} true if the user want to see system workflows, false otherwise
   */
  canViewSystemFlows: function canViewSystemFlows() {
    return this.mPreferences && this.mPreferences.workflow !== undefined && this.mPreferences.workflow !== null && this.mPreferences.workflow.view_system_flows === true;
  },
  /**
   * @description Get the preferences
   * @function
   * @name UserPreferences#getPreferences
   * @param {String} pName The key of the sub preferences you want
   * @returns {pObject}
   */
  getPreferences: function getPreferences(pName) {
    if (this.mPreferences === null || _typeof(this.mPreferences) !== "object" || Array.isArray(this.mPreferences)) {
      return;
    }
    if (pName === "workflow") {
      if (this.mPreferences && this.mPreferences.workflow !== undefined && this.mPreferences.workflow !== null && _typeof(this.mPreferences.workflow) === "object") {
        return this.mPreferences.workflow;
      }
      return;
    }
    return this.mPreferences;
  },
  /**
   * @description Get the custom preferences object
   * @function
   * @name UserPreferences#getCustomPreference
   * @param {String} pKey the sub key of the custom preferences you want
   * @returns {pObject}
   */
  getCustomPreference: function getCustomPreference(pKey) {
    if (this.mPreferences !== undefined && this.mPreferences !== null && this.mPreferences.custom !== undefined && this.mPreferences.custom !== null && _typeof(this.mPreferences.custom) === "object") {
      return CloudflowObject.getParameter(this.mPreferences.custom, pKey);
    }
    return undefined;
  },
  /**
   * @description Get the consent json definition of the system
   * @function
   * @name UserPreferences#getSystemConsent
   * @returns {Object}
   */
  getSystemConsent: function getSystemConsent() {
    if (this.mPreferences !== undefined && this.mPreferences.system_consent !== undefined) {
      return this.mPreferences.system_consent;
    }
    return null;
  },
  /**
   * @description Get the consent json of the user
   * @function
   * @name UserPreferences#getUserConsent
   * @returns {Object}
   */
  getUserConsent: function getUserConsent() {
    if (this.mPreferences !== undefined && this.mPreferences.consent !== undefined) {
      return this.mPreferences.consent;
    }
    return null;
  },
  /**
   * @description Get the current Date format the user prefer
   * @function
   * @private
   * @name UserPreferences#getDateFormat
   * @return {String} the date format
   */
  getDateFormat: function getDateFormat() {
    if (this.mPreferences !== null && this.mPreferences !== undefined && typeof this.mPreferences.date_format === "string" && this.mPreferences.date_format.length > 0) {
      return this.mPreferences.date_format;
    } else {
      return null;
    }
  },
  /**
   * @description Get the prerelease flag a a specific key
   * @function
   * @name UserPreferences#getPrerelease
   * @param {String} pPrereleaseKey the key/ name of the prerelease
   * @returns {boolean} true if the prerelease is set on true, false if the key is set on false, undefined if the key is not found
   */
  getPrerelease: function getPrerelease(pPrereleaseKey) {
    if (typeof pPrereleaseKey !== "string" || pPrereleaseKey.length <= 0) {
      throw new Error("parameter prereleaseKey must be a not empty string");
    }
    if (this.mPrereleaseSettings !== undefined && this.mPrereleaseSettings !== null && _typeof(this.mPrereleaseSettings) === "object") {
      return this.mPrereleaseSettings[pPrereleaseKey];
    }
  },
  /**
   * @description get all the prerelease flags and there value
   * @function
   * @name UserPreferences#getPrereleaseObject
   * @returns {Object} copy of the prerelease object
   */
  getPrereleaseObject: function getPrereleaseObject() {
    if (this.mPrereleaseSettings !== undefined && this.mPrereleaseSettings !== null && _typeof(this.mPrereleaseSettings) === "object") {
      return Object.assign({}, this.mPrereleaseSettings);
    }
    return {};
  },
  _getVersion: function _getVersion() {
    if (typeof this.versionHashString === "string" && this.versionHashString.length > 0) {
      return Promise.resolve(this.versionHashString);
    } else {
      var that = this;
      return Version.get().then(function (version) {
        that.versionHashString = version.getHashString();
        versionObject = version.getVersionObject();
        return that.versionHashString;
      })["catch"](function (pError) {
        console.error(pError);
        versionObject = null;
        return "" + new Date().getFullYear() + "-" + new Date().getMonth();
      });
    }
  },
  /**
   * @deprecated use Version.getVersionObject
   */
  getVersionObject: function getVersionObject() {
    return versionObject;
  },
  /**
   * @description returns the translations dictionary for that user
   * @function
   * @param {String} pPath The source path of the translation file
   * @param {String} pFileNameTemplate The template of the files
   * @param {Array.<object>} pExtraFiles An array of paths to extra translation folders
   * @name UserPreferences#getTranslations
   * @return {object | dict} Translation dictionary
   */
  getTranslations: function getTranslations(pMainPath, pFileNameTemplate, pExtraFiles) {
    // prepare the variables
    var mainPath = "/";
    if (typeof pMainPath === "string" && pMainPath.length > 0) {
      mainPath = pMainPath;
    }
    var extraFiles = [];
    if (pExtraFiles !== undefined && Array.isArray(pExtraFiles)) {
      extraFiles = pExtraFiles;
    }
    var filenameTemplate = "cloudflow_";
    if (typeof pFileNameTemplate === "string" && pFileNameTemplate.length > 0) {
      filenameTemplate = pFileNameTemplate;
    }
    var that = this;
    return this._getVersion().then(function (version) {
      var mainTranslations = that._getTranslationFile(mainPath, filenameTemplate, version).then(function (json) {
        return json;
      }, function (pError) {
        // do not recall if they ask directly for path /cloudflow
        if (mainPath !== "/") {
          return $.get("/cloudflow_en.json?" + version);
        } else {
          return Promise.reject(pError);
        }
      });
      if (Array.isArray(extraFiles) && extraFiles.length > 0) {
        var defers = [];
        for (var i = 0; i < extraFiles.length; i++) {
          defers.push(that._getTranslationFile(extraFiles[i].path, extraFiles[i].templateFileName, version));
        }
        var extraTranslations = new Promise(function (pResolve, pReject) {
          Promise.all(defers).then(function (pTranslations) {
            // merge all extra translations together
            var translations = {};
            for (var i = 0; i < pTranslations.length; i++) {
              Object.assign(translations, pTranslations[i]);
            }
            pResolve(translations);
          }, function () {
            // if fail return empty object
            pResolve({});
          });
        });
        return Promise.all([mainTranslations, extraTranslations]).then(function (pResult) {
          // the main json has priority on the extra ones
          return Object.assign(pResult[1], pResult[0]);
        }, function (pError) {
          return mainTranslations;
        });
      } else {
        // there are no extra paths,
        // default way
        // so return the normal translations
        return mainTranslations;
      }
    });
  },
  /**
   * @description returns the translations dictionary for that user of a specific file
   * @function
   * @param {String} pPath The source path of the translation file
   * @param {String} pFileNameTemplate How must a filename look like
   * @param {String} pVersion A string that will be added to the url to prevent caching issues
   * @name UserPreferences.getTranslationFile
   * @private
   * @return {object | dict} Translation dictionary
   */
  _getTranslationFile: function _getTranslationFile(pPath, pFileNameTemplate, pVersion) {
    // get path
    if (typeof pPath !== "string" || pPath.length <= 0) {
      throw new Error("parameter path must be a not empty string");
    }
    var path = pPath;
    if (path[path.length - 1] !== "/") {
      // force to be a path
      path = path + "/";
    }
    // get filename template
    var filenameTemplate = "cloudflow_";
    if (typeof pFileNameTemplate === "string" && pFileNameTemplate.length > 0) {
      filenameTemplate = pFileNameTemplate;
    }
    // get language
    var language = this.getLanguage();
    // get url post fix to prevent caching issues
    var urlPostFix = "";
    if (path === "/" || path === "/proofscopeComponent/lang/") {
      // do not add session, is not needed and so will improve caches, since URLs will be similar
    } else if (api_util.get_session() !== undefined) {
      urlPostFix = "session=" + api_util.get_session();
    }
    if (typeof pVersion === "string") {
      if (urlPostFix.length > 0) {
        urlPostFix += "&";
      }
      urlPostFix += pVersion;
    }
    return new Promise(function (pResolve, pReject) {
      $.getJSON(path + filenameTemplate + language + ".json?" + urlPostFix).then(function (pTranslations) {
        pResolve(pTranslations);
      }, function (pReturnObj, pError, pErrorMessage) {
        console.error(pErrorMessage);
        // fallback try English version
        $.getJSON(path + filenameTemplate + "en.json?" + urlPostFix).then(function (pTranslations) {
          pResolve(pTranslations);
        }, function (pError) {
          if (pError && pError.status === 403) {
            console.error("forbidden to load translations. Are the translation files in the correct scope?", pError);
          } else {
            console.error("could not load translations ", pError);
          }
          pReject(pError);
        });
      });
    });
  },
  /**
   * @brief returns the proofscope translations dictionary for that users
   * @private
   * @deprecated use .getTranslations("/proofscopeComponent/lang", "proofscope_", []) instate
   */
  getProofscopeTranslations: function getProofscopeTranslations() {
    return this.getTranslations("/proofscopeComponent/lang", "proofscope_", []);
  }
};
module.exports = UserPreferences;

},{"../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../PWA/js/Device.js":198,"../../Version/js/Version.js":269}],203:[function(require,module,exports){
"use strict";

(function ($) {
  var GUID = require("../../CloudflowUtil/js/GUID.js");
  var CloudflowURL = require("../../CloudflowUtil/js/CloudflowURL.js");
  $.widget("nixps-cloudflow.ProofscopeEmbed", $.Widget, {
    version: "0.0.1",
    options: {
      /**
       * @description The language of the user
       * @name nixps-cloudflow.ProofscopeEmbed#language
       * @type {String | language_code}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.ProofscopeEmbed#assetURL
       * @description The view URL / cloudflow url / asset ID for the asset to be shown in the component
       * @type {String}
       * @default ""
       */
      assetURL: "",
      /**
       * @name nixps-cloudflow.ProofscopeEmbed#viewID
       * @description A proofscope view ID 
       * @type {String}
       * @default ""
       */
      viewID: "",
      /**
       * @name nixps-cloudflow.ProofscopeEmbed#signature
       * @description A proofscope signature that belongs to given view ID 
       * @type {String}
       * @default ""
       */
      signature: "",
      /**
       * @name nixps-cloudflow.ProofscopeEmbed#height
       * @description The height of the component  
       * @type {String}
       * @default "900"
       */
      height: "900",
      /**
       * @name nixps-cloudflow.ProofscopeEmbed#minWidth
       * @description The minimum width of the component
       * @type {Number}
       * @default 0
       */
      minWidth: 0,
      /**
       * @name nixps-cloudflow.ProofscopeEmbed#created
       * @description Function called when the iframe inside the component is loaded
       * @type {Function}
       * @default function() {}
       */
      created: function created() {}
    },
    _create: function _create() {
      var that = this;
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.iframe;
      this.responseDict = {};
      this._draw();
      this.messageHandlerBind = this._messageHandler.bind(this);
      window.addEventListener("message", this.messageHandlerBind);
      this._on(this.element, {});
      if (this.iframe[0].src.length > 0 && this.iframe[0].src !== "about:blank") {
        this.iframe.one("load", function (pEvent) {
          that.options.created();
        }).one("error", function (pEvent) {
          that.options.created();
        });
      } else {
        this.options.created();
      }
    },
    _draw: function _draw() {
      this.element.empty();
      if (this.options.minWidth > 0) {
        if (this.options.minWidth > $(window).width()) {
          this.element.css("min-width", "100%");
        } else {
          this.element.css("min-width", this.options.minWidth);
        }
      }
      this.element.removeClass("cf-pagecontent-fullheight");
      if (this.options.height !== "auto") {
        this.element.css("height", this.options.height);
      } else {
        this.element.css("height", "");
        this.element.addClass("cf-pagecontent-fullheight");
      }
      this.iframe = $("<iframe>");
      var url = "about:blank";
      if (this.options.assetURL.includes("/portal.cgi?proofscope")) {
        //this is a case where the component received a view URL - we don't adapt anything
        if (this.options.assetURL.includes("&topbar=true")) {
          this.options.assetURL = this.options.assetURL.replace("&topbar=true", "");
        }
        url = this.options.assetURL;
      } else if (this.options.assetURL.length > 0) {
        //we assume an assetID or cloudflowURL was given, make up the URL
        var test = new RegExp(/^[a-zA-Z0-9]*$/);
        if (this.options.assetURL.includes("/")) {
          url = encodeURIComponent(new CloudflowURL(this.options.relativeBasePath, this.options.assetURL, true).getCloudflowPath());
          url = window.origin + "/portal.cgi?proofscope&url=" + url;
        } else if (this.options.assetURL.length === 24 && test.test(this.options.assetURL) === true) {
          //we assume assetID if given link wasn't a cloudflowURL
          url = window.origin + "/portal.cgi?proofscope&asset_id=" + this.options.assetURL;
        }
        if (this.options.viewID.length > 0) {
          if (this.options.signature.length <= 0) {
            //fall back to just a viewURL with the asset name as url param
            console.error("ProofscopeEmbed: missing a signature trying to make an URL with a viewID");
          } else {
            url += "&view_id=" + this.options.viewID + "&signature=" + this.options.signature;
          }
        }
      }
      if (url !== "about:blank") {
        url += "&embedded=true";
      }
      this.iframe.attr({
        src: url,
        width: "100%",
        height: "100%"
      });
      this.element.append(this.iframe);
    },
    /**
     * @description Handler when receiving a message from within the proofscope iframe
     * @function
     * @private
     * @name nixps-cloudflow.ProofscopeEmbed#_messageHandler
     * @param {Object} pMessage the event object from the message trigger 
     * @return {undefined} 
     */
    _messageHandler: function _messageHandler(pMessage) {
      if (pMessage.origin !== window.location.origin) {
        return {};
      }
      if (this.responseDict[pMessage.data.uuid] !== undefined) {
        this.responseDict[pMessage.data.uuid].resolve(pMessage.data);
        delete this.responseDict[pMessage.data.uuid];
      }
    },
    /**
     * @description Refresh method that will call _postMessage with proper data and add ID to the dict
     * @function
     * @name nixps-cloudflow.ProofscopeEmbed#refresh
     * @return {Deferred} 
     */
    refresh: function refresh() {
      var responseUUID = GUID.generate();
      this._postMessage({
        "action": "refresh",
        "uuid": responseUUID
      });
      this.responseDict[responseUUID] = $.Deferred();
      return this.responseDict[responseUUID];
    },
    /**
     * @description Posts a message to the iframe within the component
     * @function
     * @private
     * @name nixps-cloudflow.ProofscopeEmbed#_postMessage
     * @param {Object} pData object with keys 'action' and 'uuid'
     * @return {undefined} 
     */
    _postMessage: function _postMessage(pData) {
      this.iframe[0].contentWindow.postMessage(pData, window.location.origin);
    },
    redraw: function redraw() {
      this._draw();
    },
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.assetURL !== "string") {
        throw new Error("ProofscopeEmbed: option assetURL must be a string");
      }
      if (typeof this.options.viewID !== "string") {
        throw new Error("ProofscopeEmbed: option viewID must be a string");
      }
      if (typeof this.options.signature !== "string") {
        throw new Error("ProofscopeEmbed: option signature must be a string");
      }
      if (typeof this.options.height !== "string") {
        throw new Error("ProofscopeEmbed: option height must be a string");
      }
      if (typeof this.options.minWidth !== "number") {
        throw new Error("ProofscopeEmbed: option minWidth must be a number");
      }
      if (typeof this.options.created !== "function") {
        throw new Error("ProofscopeEmned: option created must be a function");
      }
    },
    _destroy: function _destroy() {
      window.removeEventListener("message", this.messageHandlerBind);
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../CloudflowUtil/js/CloudflowURL.js":80,"../../CloudflowUtil/js/GUID.js":89}],204:[function(require,module,exports){
"use strict";

var TemporyBrowserObjectCache = require("../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var User = require("../../User/js/User.js");
var Device = require("../../PWA/js/Device.js");

/**
 * @version 1.0
 * @constructor Scopes
 * @description This represents the scopes (on folder level). 
 * this component uses his own cache, please use {@link Scopes#refresh} function to clear the cache
 * @return {deferred} scopes
 */
var Scopes = function Scopes() {
  if (this.scopes === undefined || this.scopes === null || Object.keys(this.scopes).length === 0) {
    if (TemporyBrowserObjectCache.isPageReload() !== true || Device.getPollingFactor() > 1) {
      var cacheObject = TemporyBrowserObjectCache.get("nixps_cloudflow_scopes");
      if (cacheObject !== null) {
        this.scopes = cacheObject;
        return Promise.resolve(this);
      }
    }
    return this.refresh();
  }
  return Promise.resolve(this);
};
Scopes.get = function () {
  return new Scopes();
};
Scopes.getLoginScopes = function (pUser) {
  return api_defer.users.get_all_scopes_for_user(pUser.getUserName()).then(function (pResult) {
    if (pResult !== undefined && Array.isArray(pResult.scopes)) {
      // login_scopes = pResult.scopes;
      pResult.scopes.sort(function (scopeA, scopeB) {
        if (scopeA.name === scopeB.name) {
          return 0;
        } else if (scopeA.name < scopeB.name) {
          return -1;
        }
        return 1;
      });
      for (var i = 0; i < pResult.scopes.length; i++) {
        if (pResult.scopes[i]._id === undefined && typeof pResult.scopes[i].id === "string") {
          pResult.scopes[i]._id = pResult.scopes[i].id; // copy
        }
      }
    } else {
      pResult.scopes = [];
    }
    return pResult.scopes;
  }, function (pError) {
    console.error(pError);
    return Promise.reject(pError);
  });
};
Scopes.reset = function () {
  TemporyBrowserObjectCache.remove("nixps_cloudflow_scopes");
};
Scopes.prototype = {
  constructor: Scopes,
  /**
   * @description Get all scopes from backend and store in memory, objet this.scopes,
   * the ids are the key.
   * @name Scopes#_retrieveScopes
   * @private
   * @function
   * @returns {Deferred}
   */
  _retrieveScopes: function _retrieveScopes() {
    var that = this;
    this.scopes = {};
    this.scopes["*"] = {
      name: $.i18n._("nixps-cloudflow-top.all_scopes")
    };
    return api_defer.scopes.list_all().then(function (pResult) {
      pResult.sort(function (a, b) {
        return a.name.toLowerCase() > b.name.toLowerCase();
      });
      for (var i = 0; i < pResult.length; i++) {
        var welcomPage = typeof pResult[i].welcomepage !== "string" ? "" : pResult[i].welcomepage;
        that.scopes[pResult[i]._id] = {
          filter: pResult[i].filter,
          name: pResult[i].name,
          welcomepage: welcomPage
        };
      }
      ;
      return that;
    }, function (pError) {
      if (pError && pError.error_code === "no_permission") {
        return User.get().then(function (pUser) {
          var userScopes = pUser.getScopes();
          if (userScopes.length > 0 && userScopes[0] !== "*") {
            pUser.getScopesObjectArray().forEach(function (s) {
              that.scopes[s._id] = {
                filter: null,
                welcomPage: null,
                name: s.name
              };
            });
            return that;
          }
          return Promise.reject(pError);
        });
      }
      console.error(pError);
      return Promise.reject(pError);
    });
  },
  /**
   * @function
   * @name Scopes#getScopeByID
   * @description get the scope with the specific id
   * @param {string} pID ID of the scope
   * @returns {String|nixps.cloudflow.Scopes.scopes} the scope object that correspond with the id
   */
  getScopeByID: function getScopeByID(pID) {
    if (typeof pID === "string" && pID.length > 0) {
      var scope = this.scopes[pID];
      if (scope === undefined) {
        return "unkown scope";
      } else {
        return scope;
      }
    } else {
      console.error("getScopeByID: inputparameter pID must be a well formed string");
    }
  },
  /**
   * @description Get the current scope name, if no scope is applied, the translated text "All Scopes" will be returned
   * @function
   * @name Scopes#getCurrentScopeName
   * @returns {String} the current scope name
   */
  getCurrentScopeName: function getCurrentScopeName() {
    var currentScopeID = api_util.get_cookie("scope");
    if (currentScopeID !== null && this.scopes[currentScopeID] !== undefined) {
      return this.scopes[currentScopeID].name;
    }
    return $.i18n._("nixps-cloudflow-top.all_scopes");
  },
  /**
   * @name Scopes#getScopes
   * @function
   * @returns {Scopes.scopes}
   */
  getScopes: function getScopes() {
    return structuredClone(this.scopes);
  },
  /**
   * @description refresh the scopes, reload the scopes from backend
   * the cache will be cleared. Default there is no fall back
   * @name Scopes#refresh
   * @function
   * @returns {Deferred} the new uploaded scopes in deferred object
   */
  refresh: function refresh(pUseFallback) {
    var that = this;
    this.scopes = {};
    return this._retrieveScopes().then(function (results) {
      TemporyBrowserObjectCache.save("nixps_cloudflow_scopes", that.scopes);
      return results;
    });
  },
  /**
   * @description get the scopes in array format. The key is injected as "_id"
   * @function
   * @name Scopes#getArray
   * @returns {Array} the different scopes in a array 
   */
  getArray: function getArray() {
    var scopesArray = [];
    for (var key in this.scopes) {
      scopesArray.push(Object.assign(this.scopes[key], {
        "_id": key
      }));
    }
    scopesArray = scopesArray.sort(function (scopeA, scopeB) {
      if (scopeA.name < scopeB.name) {
        return -1;
      } else if (scopeA.name === scopeB.name) {
        return 0;
      }
      return 1;
    });
    return scopesArray;
  }
};
module.exports = Scopes;

},{"../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../PWA/js/Device.js":198,"../../User/js/User.js":268}],205:[function(require,module,exports){
"use strict";

module.exports = [{
  "name": "getVariables",
  "value": "getVariables()",
  "desc": "Get the variables from the workflow."
}, {
  "name": "getParameters",
  "value": "getParameters()",
  "desc": "This function will get the parameters that were specified for the script node. This will give you access to the variables of the workable, the files you need to precess etc"
}, {
  "name": "getJSONFromContainer",
  "value": "getJSONFromContainer({\"type\": \"com.nixps.quantum.data_provider.0\", \"url\": \"cfqworkdata:///1234/\"})",
  "desc": "This function will get json (data) from a container. That data is typically from an workable output container that was saved by a previous 'data' node or script node that saved work-data. In those cases you will have a reference to that data, and this call will load that data into the script. The container_reference parameter can be an object containing a 'data provider value composer' node, or it can be a string. The advantage of using the object, is that the references stored in the workable are typically inside objects and as such they can be used 'as is'"
}, {
  "name": "getTextFromContainer",
  "value": "getTextFromContainer({\"type\": \"com.nixps.quantum.data_provider.0\", \"url\": \"cfqworkdata:///1234/\"})",
  "desc": "This function will get text (data) from a container. That data is typically from an workable output container that was saved by a previous 'data' node or script node that saved work-data. In those cases you will have a reference to that data, and this call will load that data into the script. The container_reference parameter can be an object containing a 'data provider value composer' node, or it can be a string. The advantage of using the object, is that the references stored in the workable are typically inside objects and as such they can be used 'as is'"
}, {
  "name": "setResultContainerFromJSON",
  "value": "setResultContainerFromJSON(",
  "desc": "This function will save the specified JSON data in the workable output container and add a reference to the saved JSON data and to results of this node. The json_data parameter will be saved 'as is' for later use."
}, {
  "name": "setResultContainerFromXML",
  "value": "setResultContainerFromXML(",
  "desc": "This function will set the file reference(s) that should be assigned as results of this node. The files parameter can be a single string for a single file, or an array of strings for multiple output files."
}, {
  "name": "setResultContainerFromText",
  "value": "setResultContainerFromText(",
  "desc": "This function will set the file reference(s) that should be assigned as results of this node. The files parameter can be a single string for a single file, or an array of strings for multiple output files."
}, {
  "name": "addMessageToLog",
  "value": "addMessageToLog(level, message)",
  "snippet": "addMessageToLog(${1:'info'}, ${2:'some text'})",
  "desc": "Add a message to the workable log. The difference between this function and print is that you can specify a 'severity' in this function, while print() is always 'info' Possible severities are: debug, info, warning, error"
}, {
  "name": "addSystemMessage",
  "value": "addSystemMessage(pSeverity, pMessage)",
  "desc": "Add a message to the system log only. (addMessageToLog will send the feedback to the workable log, and sometimes to the system log) Possible severities are: debug, info, warning, error"
}, {
  "name": "addEventMessage",
  "value": "addEventMessage(",
  "snippet": "addEventMessage(${1:'error'}, ${2:'asset is broken'}, ${3:'cloudflow://PP_FILE_STORE/test/asset.pdf'})",
  "desc": "Add a event message to the system log linked to the specified asset. The event type will be 'kGenericAssetMessage' Possible severities are: debug, info, warning"
}, {
  "name": "setProgress",
  "value": "setProgress(",
  "snippet": "setProgress(${1:0.5}, ${2:'working'})",
  "desc": "Set some progress info. This contains both a progress value (between 0 and 1) and an 'activity text'). This progress and activity will be fed back to the dashboard (when the script takes a long time …)"
}, {
  "name": "setOutput",
  "value": "setOutput(",
  "desc": "This function will control the output path of the workable when the script is finished. E.g. The workable will be send to the failure output when you specify 'failure'"
}, {
  "name": "setResultVariables",
  "value": "setResultVariables(",
  "desc": "This function will set the variables that should be assigned as results of this node."
}, {
  "name": "setResultFiles",
  "value": "setResultFiles(",
  "desc": "This function will set the file reference(s) that should be assigned as results of this node. The files parameter can be a single string for a single file, or an array of strings for multiple output files."
}, {
  "name": "setResults",
  "value": "setResults({ variables: ",
  "desc": "SetResults"
}, {
  "name": "setWait",
  "value": "setWait(",
  "snippet": "setWait(${1:5});",
  "desc": "This function will tell Cloudflow to keep the workable in this script node, not write any results, and wait for the specified amount of seconds. Then the script node will load the script again, and re-run it. Any non-zero value for waitSeconds will trigger the wait, calling this function (again) with waitSeconds to zero will reset standard behaviour."
}, {
  "name": "getSelectedJobID",
  "value": "getSelectedJobID()",
  "desc": "Get the selected job ID"
}];

},{}],206:[function(require,module,exports){
"use strict";

var scriptNodeWordList = require("../data/ScriptNodeData.js");
module.exports = {
  init: function init() {
    return $.Deferred(function (pDefer) {
      pDefer.resolve();
    });
  },
  getCompletion: function getCompletion() {
    return {
      getCompletions: function getCompletions(editor, session, pos, prefix, callback) {
        var obj = editor.getSession().getTokenAt(pos.row, pos.column.count);
        callback(null, scriptNodeWordList.map(function (word) {
          var outputObj = {
            caption: word.name,
            value: word.value || word.name,
            meta: "script node",
            docHTML: ["<b class='cf-strong'>", word.name, "</b>", "<hr></hr>", "<span class='scriptDescription'>", word.desc, "</span>"].join("")
          };
          if (word.snippet !== undefined) {
            outputObj.snippet = word.snippet;
            outputObj.type = "snippet";
          }
          return outputObj;
        }));
      }
    };
  }
};

},{"../data/ScriptNodeData.js":205}],207:[function(require,module,exports){
"use strict";

var TemporyBrowserObjectCache = require("../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var Device = require("../../PWA/js/Device.js");
/**
 * @description The model
 * @static
 * @private
 * @type { Array | nixps.cloudflow.Sites}
 * @default null
 */
var sites = null;

/**
 * @constructor Sites
 * @description The sites array, is not to be constructed manually, use nixps.cloudflow.License.get instead
 * @param {Array} array containing the Sites
 */
var Sites = function Sites(pSites) {
  this._setSites(pSites);
};

/**
 * @name Sites.get
 * @desc Create the sites object
 * @example nixps.cloudflow.Sites.get().then(function(Sites) {});
 * @returns {Thenable}
 */
Sites.get = function (pRefresh) {
  if (pRefresh !== true) {
    if (sites !== null) {
      return Promise.resolve(sites);
    }
    if (TemporyBrowserObjectCache.isPageReload() !== true || Device.getPollingFactor() > 1) {
      var cacheObject = TemporyBrowserObjectCache.get("nixps_cloudflow_sites");
      if (cacheObject !== null) {
        sites = new Sites(cacheObject);
        return Promise.resolve(sites);
      }
    }
  }
  return api_defer.site.list().then(function (pSites) {
    sites = new Sites(pSites.sites);
    TemporyBrowserObjectCache.save("nixps_cloudflow_sites", pSites.sites);
    return sites;
  });
};

/**
 * @description Create a sites from the json
 * @function
 * @name Sites.fromJSON
 * @param {Object} JSON
 * @returns {Sites}
 */
Sites.fromJSON = function (json) {
  return new Sites(json.sites);
};

/**
 * @description reset the caches
 * @function
 * @name Sites.reset
 * @returns {undefined}
 */
Sites.reset = function () {
  sites = null;
  TemporyBrowserObjectCache.remove("nixps_cloudflow_sites");
};
Sites.prototype = {
  constructor: Sites,
  /**
   * @description Set up the sites data
   * @function
   * @private
   * @name Sites#_setSites
   * @param {Array} pSites 
   */
  _setSites: function _setSites(pSites) {
    if (Array.isArray(pSites)) {
      this.sites = pSites;
      for (var i = 0; i < this.sites.length; i++) {
        Object.freeze(this.sites[i]);
      }
    } else {
      this.sites = [];
    }
  },
  /**
   * @description Is the system part of multiple sites?
   * @function
   * @name Sites#areMultipleSites
   * @returns {boolean} true if there are more then one site known.
   */
  areMultipleSites: function areMultipleSites() {
    return Array.isArray(this.sites) && this.sites.length > 1;
  },
  /**
   * @description Returns the site object for that specific site
   * @function
   * @name Sites#getSite
   * @param {string} pSiteName
   * @returns {object}
   */
  getSite: function getSite(pSiteName) {
    if (typeof pSiteName !== "string" || pSiteName.length <= 0) {
      throw new Error("parameter pSitename must be a string");
    }
    if (Array.isArray(this.sites)) {
      for (var i = 0; i < this.sites.length; i++) {
        if (this.sites[i].name === pSiteName) {
          return this.sites[i];
        }
      }
    }
  },
  /**
   * @description check if the site exists
   * @name Sites#existSite
   * @param {String} pSiteName 
   * @returns {Boolean} true if the sitename exists
   */
  existSite: function existSite(pSiteName) {
    if (typeof pSiteName !== "string" || pSiteName.length <= 0) {
      throw new Error("parameter pSitename must be a string");
    }
    if (Array.isArray(this.sites)) {
      for (var i = 0; i < this.sites.length; i++) {
        if (this.sites[i].name === pSiteName) {
          return true;
        }
      }
    }
    return false;
  },
  /**
   * @description Returns the array of all known sites
   * @function
   * @name Sites#getSites
   * @returns {Array} An array of known sites, can be null
   */
  getSites: function getSites() {
    return this.sites;
  },
  /**
   * @description Get all the information of the current site
   * @function
   * @name Sites#getCurrentSite
   * @returns {object} The current site object
   */
  getCurrentSite: function getCurrentSite() {
    if (Array.isArray(this.sites)) {
      for (var i = 0; i < this.sites.length; i++) {
        if (this.sites[i].self === true) {
          return this.sites[i];
        }
      }
    }
  },
  /**
   * @description Get the url of the site with name pName
   * @function
   * @name Sites#getHostUrl
   * @param {string} pName the name of a site 
   * @returns {string} The url of the server from where the site is situated
   */
  getHostUrl: function getHostUrl(pName) {
    var site = this.getSite(pName);
    if (typeof site.url === "string") {
      return site.url;
    }
  },
  /**
   * @description Get the session to connect to the other sites
   * @function
   * @name Sites#getSession
   * @param {string} pSiteName The name of the other site
   * @param {type} pUserName The name of the user
   * @returns {Deferred}
   */
  getSession: function getSession(pSiteName, pUserName) {
    if (typeof pUserName !== "string" || pUserName.length <= 0) {
      throw new Error("username must be a not empty string");
    }
    if (this.existSite(pSiteName) === false) {
      throw new Error("unknown site name");
    }
    return new Promise(function (pResolve, pReject) {
      api_async.site.request_session(pSiteName, pUserName, {
        expiry: 12 * 3600 /* in seconds!! = 12h*/
      }, function (pResult) {
        if (pResult !== undefined && typeof pResult.session === "string" && pResult.session.length > 0) {
          pResolve(pResult.session);
        } else {
          // wrong return interface
          pReject({
            error: "session return value has wrong return interface",
            error_code: "wrong_return_interface"
          });
        }
      }, function (pError) {
        pReject(pError);
      });
    });
  },
  /**
   * @description Redirect to the other site.
   * @function
   * @name Sites#redirect
   * @param {String} pSiteName The name of the other site where you want to go
   * @param {String} pUserName The username of the current user. He must have the same username and password on the other site.
   * @param {String} pTargetUrlPart The cloudflow part where to land on the other site, if not defined, we use "home=1"
   * @example site.redirectTo("home_site_name", "admin", "asset=X").then(function(pUrl) {
   *      window.location = pUrl;
   * })
   * @returns {Deferred}
   */
  redirectTo: function redirectTo(pSiteName, pUserName, pTargetUrlPart) {
    // control parameters
    if (typeof pUserName !== "string" || pUserName.length <= 0) {
      throw new Error("username must be a not empty string");
    }
    if (this.existSite(pSiteName) === false) {
      throw new Error("unknown site name");
    }
    // set the target url
    var targetUrl;
    if (typeof pTargetUrlPart !== "string" || pTargetUrlPart.length < 0) {
      targetUrl = "home=1";
    } else {
      targetUrl = pTargetUrlPart;
    }
    // get session and redirect, or call reject
    var that = this;
    return new Promise(function (pResolve, pReject) {
      // retrieve first a session to transfer afterwards the user to that site...
      that.getSession(pSiteName, pUserName).then(function (pSession) {
        if (typeof pSession === "string" && pSession.length > 0) {
          var server = that.getHostUrl(pSiteName);
          var urlArguments = targetUrl + "&session=" + pSession;
          if (typeof server === "string" && server.length > 0) {
            pResolve(server + "?" + urlArguments);
          } else {
            pReject({
              error: "invalid server url",
              error_code: "invalid_server_url"
            });
          }
        } else {
          pReject({
            error: "invalid session",
            error_code: "invalid_session"
          });
        }
      }, function (pError) {
        pReject(pError);
      });
    });
  },
  /**
   * @description Reset the situation, so you will work localy.
   * @function
   * @name Sites#resetSession
   * @private
   * @returns {undefined}
   */
  resetSession: function resetSession() {
    api.set_session(null);
  },
  /**
   * @description Initial the api calls to forwards then to a other site. So all returning results of the api calls are
   * from the other site.
   * @function
   * @name Sites#setSession
   * @private
   * @param {String} pSessionKey the session
   * @param {String} pSiteName the name of the site
   * @returns {undefined}
   */
  setSession: function setSession(pSessionKey, pSiteName) {
    if (typeof pSessionKey !== "string" || pSessionKey.length <= 0) {
      throw new Error("parameter pSessionKey must be a not empty string");
    }
    if (this.existSite(pSiteName) === false) {
      throw new Error("parameter pSiteName gives unknown site name");
    }
    api.set_session(pSessionKey);
  },
  /**
   * @description Get the expirydate of the session. This is usefull for debugging purposes
   * If there is no session, it will return undefined.
   * @function
   * @private
   * @name Sites#getExpiryDate
   * @returns {Date} The date when the session expires.
   */
  getExpiryDate: function getExpiryDate() {
    if (typeof api_util.get_session() === "string" && api_util.get_session().length > 0) {
      return new Date(parseInt(api_util.get_session().substring(api_util.get_session().length - 10) + "000"));
    }
  },
  /**
   * @description Returns the short name of the site to recognise your site
   * @function
   * @name Site#getShortSiteName
   * @returns {String} The short name of the current site, if no site found or you are not in a site complex, an empty string will be returned
   */
  getShortSiteName: function getShortSiteName() {
    if (this.areMultipleSites() === false) {
      // this function is only to recognise other sites, so 
      // if there are no others sites, just return empty string
      return "";
    }
    var currentSite = this.getCurrentSite();
    if (currentSite !== undefined && currentSite !== null) {
      return currentSite.name;
    } else {
      // fallback: no current site found
      return "";
    }
  },
  /**
   * @description Get the JSON structure of the Sites 
   * @function
   * @name Site#toJSON
   * @returns {Object} The JSON structure of the sites class
   */
  toJSON: function toJSON() {
    return {
      "sites": structuredClone(this.sites)
    };
  }
};
module.exports = Sites;

},{"../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../PWA/js/Device.js":198}],208:[function(require,module,exports){
"use strict";

(function ($) {
  var CloudflowConnection = require("../../CloudflowUtil/js/CloudflowConnection.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  var redirectToLogin = require("../../CloudflowInit/js/redirectToLogin.js");
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");
  var Device = require("../../PWA/js/Device.js");

  /**
   * @namespace nixps-cloudflow.StatusBar
   * @example $('#StatusBar').StatusBar({
   * });
   * @private
   * @version 1.1.0
   */
  $.widget('nixps-cloudflow.StatusBar', {
    version: "1.1.0",
    widgetEventPrefix: "statusbar",
    options: {
      /**
       * @description The default text to be show when the status bar is bussing retrieving the actual status string
       * @name nixps-cloudflow.StatusBar#startingText
       * @type {String}
       * @default ""
       */
      startingText: "",
      /**
       * @description The location to search for the data
       * @name nixps-cloudflow.StatusBar#dataSource
       * @type {Object}
       * @since 1.1.0
       */
      dataSource: {
        collection: "",
        data: [],
        dataFileURL: "",
        httpserviceInputName: "",
        httpserviceWhitepaperName: ""
      },
      /**
       * @description The extra filter query asked to the backend
       * @name nixps-cloudflow.StatusBar#extraQuery
       * @type {Array.<String>}
       * @default []
       */
      extraQuery: [],
      /**
       * @description The json path to find the status string to be displayed in the result object
       * @name nixps-cloudflow.StatusBar#statusPath
       * @type {String}
       * @default ""
       */
      statusPath: "",
      /**
       * @description The relative base path of the data file
       * @name nixps-cloudflow.StatusBar#relativeBasePath
       * @type {String}
       * @default ""
      */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.StatusBar#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       */
      style_type: "default",
      /**
       * @name nixps-cloudflow.StatusBar#padding
       * @description the padding on the panel
       * @type {String}
       * @default "5px 10px"
       */
      padding: "5px 10px",
      /**
       * @name nixps-cloudflow.StatusBar#pagebuilderStyleClass
       * @description Which style class do you want to apply on the component
       * @type {String}
       * @default ""
       * @private
       */
      pagebuilderStyleClass: "",
      /**
       * @name nixps-cloudflow.StatusBar#refreshDelay
       * @description The delay between two request for new statusses in milliseconds
       * @type {Number}
       * @default 10000
       */
      refreshDelay: 10000,
      /**
       * @description function runs when component is completed
       * @name nixps-cloudflow.StatusBar#created
       * @type {Function}
       * @default function(){}
       * @private
       */
      created: function created() {}
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type);
      this._controlOptions();

      // variables
      var that = this;
      this.alive = true;
      this.updateTimerid;
      this.statusText = "";
      this.errorTime = 0;
      this._setStyle();
      this.element.append($("<div>").addClass("status_barstring"));
      if (typeof this.options.startingText === "string") {
        this.statusText = this.options.startingText;
        this.element.children(".status_barstring").text(this.options.startingText);
      }
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        this.element.addClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
      }
      this._setConnection();
      $.when(this._getDataAndShow()).always(function () {
        that.options.created();
      });
    },
    /**
     * @description An error occured, inform others
     * @name nixps-cloudflow.StatusBar#_errorHandler
     * @function
     * @private
     * @param {String} pMain
     * @param {Object} pError
     * @returns {undefined}
     */
    _errorHandler: function _errorHandler(pMain, pError) {
      this._trigger("error", null, pError);
      LogListener.addLog({
        event_type: "error",
        details_data: pError,
        component_name: this.widgetFullName
      }, this.element);
    },
    /**
     * @description An change occured, inform others
     * @name nixps-cloudflow.StatusBar#_sourceChangeHandler
     * @function
     * @private
     * @returns {undefined}
     */
    _sourceChangeHandler: function _sourceChangeHandler() {
      if (this.alive === true) {
        clearTimeout(this.updateTimerid);
        this._getDataAndShow();
      }
    },
    _setConnection: function _setConnection() {
      if (this.connection !== undefined && this.connection !== null) {
        this.connection.stop();
      }
      // do the request for data
      this.options.dataSource.relativeBasePath = this.options.relativeBasePath;
      this.options.dataSource.error_cb = this._errorHandler.bind(this);
      this.options.dataSource.change_cb = this._sourceChangeHandler.bind(this);
      this.connection = new CloudflowConnection(this.options.dataSource);
    },
    _getDataAndShow: function _getDataAndShow() {
      var that = this;
      return $.when(this.connection.list_with_options(this.options.extraQuery, [], [this.options.statusPath, "custom", "done", "refresh_delay"], 0, 1)).then(function (pResults) {
        if (that.alive === false) {
          return; // zombie
        }

        if (pResults === undefined || pResults === null || Array.isArray(pResults.results) === false) {
          console.error("StatusBar _getDataAndShow: wrong returning interface");
          if (that.element.children(".status_barstring").text() !== " ?? ") {
            that._trigger("change", null, {
              correctHandling: false,
              text: " ?? ",
              error_code: "wrong_interface",
              error: "wrong returning interface",
              rowObject: null
            });
          }
          that.element.children(".status_barstring").text(" ?? ");
          return; // wrong returning interface
        }

        if (pResults.results.length > 0) {
          var returnObject = pResults.results[pResults.results.length - 1];
          if ($.isPlainObject(returnObject)) {
            var newValue = CloudflowObject.getParameter(returnObject, that.options.statusPath);
            if (newValue === undefined || newValue === null) {
              that.statusText = "";
            } else if ($.isPlainObject(newValue) || Array.isArray(newValue)) {
              that.statusText = JSON.stringify(newValue);
            } else {
              that.statusText = "" + newValue;
            }
            if (that.element.children(".status_barstring").text() !== that.statusText) {
              that._trigger("change", null, {
                correctHandling: true,
                text: that.statusText,
                rowObject: returnObject
              });
            }
            that.element.children(".status_barstring").text(that.statusText);
            if (typeof returnObject.refresh_delay === "number" && returnObject.refresh_delay > 999) {
              if (returnObject.refresh_delay >= 2147483647) {
                returnObject.refresh_delay = 2147483646;
              }
              that.options.refreshDelay = returnObject.refresh_delay;
            }
          } else {
            console.error("StatusBar results are not objects");
          }
        } else {
          // result is empty
        }
        that._triggerTimer();
      }, function (pError) {
        console.error(pError);
        if (pError !== undefined && pError.error_code === "no_permission") {
          redirectToLogin(false);
          return;
        }
        // wait 10 sec after serious error
        // could be over burning server
        that.errorTime = 10000;
        var errorMessage = "ERROR: SB_1, waiting 10 sec before retrying";
        if (that.element.children(".status_barstring").text() !== errorMessage) {
          that._trigger("change", null, {
            correctHandling: false,
            text: errorMessage,
            error_code: pError.error_code,
            error: pError.error,
            rowObject: null
          });
        }
        that.element.children(".status_barstring").text(errorMessage);
        that._triggerTimer();
        return $.Deferred().reject(pError);
      });
    },
    _triggerTimer: function _triggerTimer() {
      clearTimeout(this.updateTimerid);
      this.updateTimerid = this._delay(function () {
        if (this.element.is(":visible") && Device.continuePolling(this.uuid)) {
          this._getDataAndShow();
        } else {
          this._triggerTimer();
        }
      }, Device.getPollingFactor(this.uuid) * this.options.refreshDelay + this.errorTime);
      this.errorTime = 0;
    },
    _setStyle: function _setStyle() {
      this.element.css({
        "padding": this.options.padding,
        "box-sizing": "border-box"
      });
    },
    _setOptions: function _setOptions(options) {
      if (typeof options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass !== options.pagebuilderStyleClass) {
        this.element.removeClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
        if (typeof options.pagebuilderStyleClass === "string" && options.pagebuilderStyleClass.length > 0) {
          this.element.addClass("nixps_styling_class_" + options.pagebuilderStyleClass);
        }
      }
      this._super(options);
      this._controlOptions();
      if (options["padding"] !== undefined) {
        this._setStyle();
      }
      if (options.relativeBasePath !== undefined || options.extraQuery !== undefined || options.statusPath !== undefined) {
        clearTimeout(this.updateTimerid);
        this._setConnection();
        this._getDataAndShow();
      } else if (options.dataSource !== undefined) {
        if (options.dataSource.collection !== undefined || options.dataSource.data !== undefined || options.dataSource.dataFileURL !== undefined || options.dataSource.httpserviceInputName !== undefined || options.dataSource.httpserviceWhitepaperName !== undefined) {
          clearTimeout(this.updateTimerid);
          this._setConnection();
          this._getDataAndShow();
        }
      } else if (options.refreshDelay !== undefined) {
        this.errorTime = 0;
        this._triggerTimer();
      }
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.startingText !== "string") {
        throw new Error("StatusBar: input options startingText must be a string");
      }
      if (typeof this.options.dataSource.collection !== "string" && Array.isArray(this.options.dataSource.collection) === false) {
        throw new Error("StatusBar: input options collection must be a string");
      }
      if (Array.isArray(this.options.extraQuery) === false) {
        throw new Error("StatusBar: input options extraQuery must be an array");
      }
      if (typeof this.options.statusPath !== "string") {
        throw new Error("StatusBar: input options statusPath must be a string");
      }
      if (typeof this.options.refreshDelay !== "number") {
        throw new Error("StatusBar: input option refreshDelay must be a number");
      }
      if (this.options.refreshDelay < 1000) {
        this.options.refreshDelay = 1000;
      } else if (this.options.refreshDelay > 2147483647) {
        this.options.refreshDelay = 2147483647;
      }
      if (typeof this.options.pagebuilderStyleClass !== "string") {
        throw new Error("StatusBar: input options pagebuilderStyleClass must be a string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("CloudflowStyle_" + this.options.style_type);
      this._super();
      this.alive = false;
      clearTimeout(this.updateTimerid);
      if (this.connection !== undefined && this.connection !== null) {
        this.connection.stop();
      }
    }
  });
})(jQuery);

},{"../../../pagebuilder/js/inspect/LogListener.js":431,"../../CloudflowInit/js/redirectToLogin.js":69,"../../CloudflowUtil/js/CloudflowConnection.js":78,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../PWA/js/Device.js":198}],209:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var WhitepaperCRUD = require("./WhitepaperCRUD.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
/**
 * @description A dictionary containing all the fix querys for each collection
 * @type {Object.<Array>}
 * @static
 * @private
 */
var kPrefixQuerys = Object.freeze({
  "nucleus.job": ["template", "does not exist"],
  "nucleus.project": ["template", "does not exist"],
  "nucleus.job_recursive": ["template", "does not exist"],
  "nucleus.users": ["(", "username", "not equal to", "guest", "and", "username", "not equal to", "event", ")"],
  "nucleus.scope": ["temporary", "does not exist"],
  "nucleus.bucket": ["temporary", "does not exist"],
  "nucleus.agent": ["name", "not equal to", "*"]
});

/**
 * @description A RegExp to filter out all the arrays, otherwise mongo will return nothing
 * @type {RegExp}
 * @static
 * @private
 */
var kNumberFieldPathRegExp = new RegExp("[.]([0-9]+[.]){1,}", "g");
function _getPredefinedFilter(pCollection) {
  if (kPrefixQuerys[pCollection] !== undefined) {
    return kPrefixQuerys[pCollection].slice();
  }
  return [];
}
;
function _normaliseCollectionName(pCollectionName) {
  if (typeof pCollectionName !== "string" || pCollectionName.length <= 0) {
    return pCollectionName; // check or error handling should be done by caller
  }
  // check if there is already a prefix
  if (pCollectionName.indexOf("nucleus.") === 0 || pCollectionName.indexOf("dataconnector.") === 0) {
    // name is already normalised
    return pCollectionName;
  } else {
    // there is no prefix, so add default one
    return "nucleus." + pCollectionName;
  }
}
function _getDetailsDataConnector(pCollectionName) {
  if (pCollectionName.indexOf("dataconnector.") === 0) {
    var infoPart = pCollectionName.substring(14); // remove prefix
    var separatorIndex = infoPart.lastIndexOf("/"); // first part is data_connector, second part is table, try to retrieve each part
    if (typeof separatorIndex === "number" && separatorIndex > 0) {
      return {
        name: infoPart.substring(0, separatorIndex),
        table: infoPart.substring(separatorIndex + 1)
      };
    }
    return null;
  }
  return null;
}
function _mokeupDataConnectorQuery(pQuery) {
  /*if (Array.isArray(pQuery) && pQuery.length > 0) {
      var outputQuery = [];
      for (var i=0; i< pQuery.length; i++) {
          if (pQuery[i] === "contains text like") {
              outputQuery.push("contains");
              console.error("the query to dataconnector has been changed becasue it does no support the "contains text like" query");
          } else {
              outputQuery.push(pQuery[i]);
          }
      }
      return outputQuery;
  }*/
  return pQuery;
}
var DatabaseConnection = {};
DatabaseConnection.list_with_options = function (pCollection, pQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack) {
  // make deep copy, to prevent changes
  if (Array.isArray(pQuery)) {
    pQuery = pQuery.slice();
  }
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection.list_with_options(pQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  var endQuery = _getPredefinedFilter(collectionName);
  if (Array.isArray(pQuery) && pQuery.length > 0) {
    if (endQuery.length > 0) {
      pQuery.unshift("(");
      pQuery.push(")");
      pQuery.push("and");
    }
    endQuery = pQuery.concat(endQuery);
  }
  if (collectionName.indexOf("dataconnector.") === 0) {
    var dataconnectionInfo = _getDetailsDataConnector(collectionName);
    if (dataconnectionInfo !== null) {
      api_async.dataconnector.list(dataconnectionInfo.name, dataconnectionInfo.table, _mokeupDataConnectorQuery(endQuery), pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
    } else {
      pBadCallBack({
        "error_code": "wrong_collectionname",
        "error": "wrong collectionname: " + collectionName
      });
    }
    return;
  }
  if (Array.isArray(pFields) && pFields.length > 0) {
    for (var i = 0; i < pFields.length; i++) {
      if (typeof pFields[i] === "string" && pFields[i].length > 0) {
        // remove all .0. from the fields, otherwise the list with options will return nothing
        pFields[i] = pFields[i].replace(kNumberFieldPathRegExp, ".");
      }
    }
  }
  if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects.list_with_options(collectionName.substring(22), endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
    return;
  }
  switch (collectionName) {
    case "nucleus.job":
    case "nucleus.project":
      api_async.job.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.job_recursive":
      if (pOptions === undefined || pOptions === null) {
        pOptions = {};
      }
      pOptions.recursive = true;
      api_async.job.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.users":
      api_async.users.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.approval":
      api_async.approval.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.asset":
      api_async.asset.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_active_users":
      api_async.stats.active_users.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_database":
      api_async.stats.database.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_workers":
      api_async.stats.workers.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_work_servers":
      api_async.stats.work_servers.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.team":
      api_async.team.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      api_async.template.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      api_async.task_list.list_with_options(endQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack);
      break;
    default:
      api_async.database.document.list_with_options(collectionName, endQuery, pOrderby, pFields, pOptions, function (pResult) {
        pGoodCallBack({
          results: pResult.documents
        });
      }, pBadCallBack);
  }
};
DatabaseConnection.list = function (pCollection, pQuery, pFields, pGoodCallBack, pBadCallBack) {
  // make deep copy, to prevent changes
  if (Array.isArray(pQuery)) {
    pQuery = pQuery.slice();
  }
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection.list_with_options(pQuery, [], pFields, {}, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  var endQuery = _getPredefinedFilter(collectionName);
  if (Array.isArray(pQuery) && pQuery.length > 0) {
    if (endQuery.length > 0) {
      pQuery.unshift("(");
      pQuery.push(")");
      pQuery.push("and");
    }
    endQuery = pQuery.concat(endQuery);
  }
  if (collectionName.indexOf("dataconnector.") === 0) {
    var dataconnectionInfo = _getDetailsDataConnector(collectionName);
    if (dataconnectionInfo !== null) {
      api_async.dataconnector.list(dataconnectionInfo.name, dataconnectionInfo.table, _mokeupDataConnectorQuery(endQuery), [], pFields, {}, pGoodCallBack, pBadCallBack);
    } else {
      pBadCallBack({
        "error_code": "wrong_collectionname",
        "error": "wrong collectionname: " + collectionName
      });
    }
    return;
  }
  if (Array.isArray(pFields) && pFields.length > 0) {
    for (var i = 0; i < pFields.length; i++) {
      if (typeof pFields[i] === "string" && pFields[i].length > 0) {
        // remove all .0. from the fields, otherwise the list with options will return nothing
        pFields[i] = pFields[i].replace(kNumberFieldPathRegExp, ".");
      }
    }
  }
  if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects.list(collectionName.substring(22), endQuery, pFields, pGoodCallBack, pBadCallBack);
    return;
  }
  switch (collectionName) {
    case "nucleus.job":
    case "nucleus.project":
      api_async.job.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.users":
      api_async.users.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.approval":
      api_async.approval.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.asset":
      api_async.asset.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.scope":
      api_async.scope.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_active_users":
      api_async.stats.active_users.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_database":
      api_async.stats.database.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_workers":
      api_async.stats.workers.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_work_servers":
      api_async.stats.work_servers.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.team":
      api_async.team.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      api_async.template.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      api_async.task_list.list(endQuery, pFields, pGoodCallBack, pBadCallBack);
      break;
    default:
      //fix result key
      api_async.database.document.list_with_options(collectionName, endQuery, [], pFields, {}, function (pResult) {
        pGoodCallBack({
          results: pResult.documents
        });
      }, pBadCallBack);
  }
};

//Override documents key by results key
var GoodCallBack = {};
GoodCallBack.results = function (pGoodCallBack) {
  return {
    "results": pGoodCallBack.documents
  };
};
DatabaseConnection.get = function (pCollection, pID, pGoodCallBack, pBadCallBack) {
  if (typeof pID !== "string" || pID.length <= 0) {
    pBadCallBack({
      "error_code": "wrong_parameters",
      "error": "DatabaseConnection.get: parameter pID must be a not empty string"
    });
    return;
  }
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection.get(pID, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  if (collectionName.indexOf("dataconnector.") === 0) {
    var dataconnectionInfo = _getDetailsDataConnector(collectionName);
    if (dataconnectionInfo !== null) {
      api_async.dataconnector.get(dataconnectionInfo.name, dataconnectionInfo.table, pID, {}, pGoodCallBack, pBadCallBack);
    } else {
      pBadCallBack({
        "error_code": "wrong_collectionname",
        "error": "wrong collectionname: " + collectionName
      });
    }
    return;
  } else if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects.get(collectionName.substring(22), pID, pGoodCallBack, pBadCallBack);
    return;
  }
  switch (collectionName) {
    case "nucleus.job":
    case "nucleus.project":
    case "nucleus.job_recursive":
      if (pID.indexOf("-") === -1) {
        // mongo id
        api_async.job.get_recursive(pID, {}, pGoodCallBack, pBadCallBack);
      } else {
        // project_id
        api_async.job.get_by_project_id(pID, {}, pGoodCallBack, pBadCallBack);
      }
      break;
    case "nucleus.users":
      api_async.users.get(pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.approval":
      api_async.approval.get(pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.asset":
      api_async.asset.get(pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.jobrecursive":
      // old case
      // mongoID
      api_async.job.get_recursive(pID, {}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.portal_get_stats":
      api_async.portal.get_stats(pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.portal_get_db_status":
      api_async.portal.get_db_status({}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.scope":
      api_async.scope.get(pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_active_users":
      api_async.stats.active_users.list(["_id", "equal to", pID], [], pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_database":
      api_async.stats.database.list(["_id", "equal to", pID], [], pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_workers":
      api_async.stats.workers.list(["_id", "equal to", pID], [], pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_work_servers":
      api_async.stats.work_servers.list(["_id", "equal to", pID], [], pGoodCallBack, pBadCallBack);
      break;
    case "nucleus._get_license":
      api_async.license.get_license({}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      api_async.template.get(pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      if (pID.indexOf("-") === -1) {
        // mongo id
        api_async.task_list.get(pID, pGoodCallBack, pBadCallBack);
      } else {
        // task_list_id
        api_async.task_list.get_by_task_list_id(pID, {}, pGoodCallBack, pBadCallBack);
      }
      break;
    default:
      api_async.database.document.get(collectionName, pID, pGoodCallBack, pBadCallBack);
  }
};
DatabaseConnection.set_keys = function (pCollection, pID, pKeyData, pGoodCallBack, pBadCallBack) {
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection.set_keys(pID, pKeyData, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects.set_keys(collectionName.substring(22), pID, pKeyData, pGoodCallBack, pBadCallBack);
    return;
  } else if (collectionName.indexOf("dataconnector.") === 0) {
    DatabaseConnection.set_keys_by_query(pCollection, ["ID", "equal to", pID], pKeyData, {}, pGoodCallBack, pBadCallBack);
    return;
  }
  switch (pCollection) {
    case "nucleus.job":
    case "nucleus.project":
    case "nucleus.job_recursive":
      api_async.job.set_keys(pID, pKeyData, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.users":
      api_async.users.set_keys(pID, pKeyData, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.asset":
      // administartor ...
      api_async.asset.set_keys(pID, pKeyData, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.scope":
      // api_async.scope.set_keys(pID, pKeyData, pGoodCallBack, pBadCallBack);
      api_async.database.document.set_keys(pCollection, pID, pKeyData, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      // api_async.template.set_keys(pQuery, pKeyData, pGoodCallBack, pBadCallBack);
      api_async.database.document.set_keys(pCollection, pID, pKeyData, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      api_async.task_list.set_keys(pID, pKeyData, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.portal_get_stats":
    case "nucleus.portal_get_db_status":
    case "nucleus.stats_active_users":
    case "nucleus.stats_database":
    case "nucleus.stats_workers":
    case "nucleus.stats_work_servers":
      pBadCallBack({
        "error_code": "readonly_collection",
        "error": "DatabaseConnection.set_keysy: collection " + pCollection + " is readonly"
      });
      break;
    default:
      api_async.database.document.set_keys(pCollection, pID, pKeyData, pGoodCallBack, pBadCallBack);
  }
};
DatabaseConnection.set_keys_by_query = function (pCollection, pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack) {
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection.set_keys_by_query(pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects.set_keys_by_query(collectionName.substring(22), pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack);
    return;
  } else if (collectionName.indexOf("dataconnector.") === 0) {
    var dataconnectionInfo = _getDetailsDataConnector(collectionName);
    if (dataconnectionInfo !== null) {
      DatabaseConnection.list_with_options(pCollection, pQuery, [], [], pOptions, function (pResult) {
        if (pResult !== undefined && Array.isArray(pResult.results) && pResult.results.length > 0) {
          var dataDefs = new Array(pResult.results.length);
          for (var i = 0; i < pResult.results.length; i++) {
            for (var key in pKeyData) {
              pResult.results[i] = CloudflowObject.setParameter(pResult.results[i], key, pKeyData[key]);
            }
            dataDefs[i] = api_defer.dataconnector.update(dataconnectionInfo.name, dataconnectionInfo.table, pResult.results[i], pOptions);
          }
          Promise.allSettled(dataDefs).then(function () {
            pGoodCallBack({});
          }, function (pError) {
            pBadCallBack(pError);
          });
        } else {
          pGoodCallBack({});
        }
      }, pBadCallBack);
    } else {
      pBadCallBack({
        "error_code": "wrong_collectionname",
        "error": "wrong collectionname: " + collectionName
      });
    }
    return;
  }
  switch (pCollection) {
    case "nucleus.job":
    case "nucleus.project":
    case "nucleus.job_recursive":
      api_async.job.set_keys_by_query(pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.users":
      //api_async.users.set_keys_by_query(pQuery, pOptions, pGoodCallBack, pBadCallBack);
      //pBadCallBack({ "error_code": "missing_api", "error": "DatabaseConnection.set_keys_by_query: collection " + pCollection + " api is missing"});
      api_async.database.document.set_keys_by_query(pCollection, pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.asset":
      // administartor ...
      api_async.asset.set_keys_by_query(pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.scope":
      // api_async.scope.set_keys_by_query(pQuery, pOptions, pGoodCallBack, pBadCallBack);
      //pBadCallBack({ "error_code": "missing_api", "error": "DatabaseConnection.set_keys_by_query: collection " + pCollection + " api is missing"});
      api_async.database.document.set_keys_by_query(pCollection, pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      // api_async.template.set_keys_by_query(pQuery, pOptions, pGoodCallBack, pBadCallBack);
      //pBadCallBack({ "error_code": "missing_api", "error": "DatabaseConnection.set_keys_by_query: collection " + pCollection + " api is missing"});
      api_async.database.document.set_keys_by_query(pCollection, pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      api_async.task_list.set_keys_by_query(pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.portal_get_stats":
    case "nucleus.portal_get_db_status":
    case "nucleus.stats_active_users":
    case "nucleus.stats_database":
    case "nucleus.stats_workers":
    case "nucleus.stats_work_servers":
      pBadCallBack({
        "error_code": "readonly_collection",
        "error": "DatabaseConnection.set_keys_by_query: collection " + pCollection + " is readonly"
      });
      break;
    default:
      api_async.database.document.set_keys_by_query(pCollection, pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack);
  }
};
DatabaseConnection["delete"] = function (pCollection, pID, pOptions, pGoodCallBack, pBadCallBack) {
  if (typeof pID !== "string" || pID.length <= 0) {
    pBadCallBack({
      "error_code": "wrong_parameters",
      "error": "DatabaseConnection.delete: parameter pID must be a not empty string"
    });
    return;
  }
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection["delete"](pID, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects["delete"](collectionName.substring(22), pID, pGoodCallBack, pBadCallBack);
    return;
  } else if (collectionName.indexOf("dataconnector.") === 0) {
    pBadCallBack({
      "error_code": "no_support",
      "error": "DatabaseConnection.delete: no support for dataconnector"
    });
    return;
  }
  switch (pCollection) {
    case "nucleus.job":
    case "nucleus.project":
    case "nucleus.job_recursive":
      api_async.job["delete"](pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.users":
      api_async.users["delete"](pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.asset":
      api_async.asset["delete"](pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      api_async.template["delete"](pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.scope":
      api_async.scope["delete"](pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      api_async.task_list["delete"](pID, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.portal_get_stats":
    case "nucleus.portal_get_db_status":
    case "nucleus.stats_active_users":
    case "nucleus.stats_database":
    case "nucleus.stats_workers":
    case "nucleus.stats_work_servers":
      pBadCallBack({
        "error_code": "readonly_collection",
        "error": "DatabaseConnection.delete: collection " + pCollection + " is readonly"
      });
      break;
    default:
      api_async.database.document["delete"](pCollection, pID, pGoodCallBack, pBadCallBack);
  }
};
DatabaseConnection.delete_by_query = function (pCollection, pQuery, pOptions, pGoodCallBack, pBadCallBack) {
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection.delete_by_query(pQuery, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects.delete_by_query(collectionName.substring(22), pQuery, pOptions, pGoodCallBack, pBadCallBack);
    return;
  } else if (collectionName.indexOf("dataconnector.") === 0) {
    pBadCallBack({
      "error_code": "no_support",
      "error": "DatabaseConnection.delete_by_query: no support for dataconnector"
    });
    return;
  }
  switch (pCollection) {
    case "nucleus.job":
    case "nucleus.project":
    case "nucleus.job_recursive":
      api_async.job.delete_by_query(pQuery, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.users":
      api_async.users.delete_by_query(pQuery, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.asset":
      api_async.asset.delete_by_query(pQuery, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.scope":
      api_async.scope.delete_by_query(pQuery, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      api_async.template.delete_by_query(pQuery, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      api_async.task_list.delete_by_query(pQuery, pOptions, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.portal_get_stats":
    case "nucleus.portal_get_db_status":
    case "nucleus.stats_active_users":
    case "nucleus.stats_database":
    case "nucleus.stats_workers":
    case "nucleus.stats_work_servers":
      pBadCallBack({
        "error_code": "readonly_collection",
        "error": "DatabaseConnection.delete_by_query: collection " + pCollection + " is readonly"
      });
      break;
    default:
      api_async.database.document.delete_by_query(pCollection, pQuery, pOptions, pGoodCallBack, pBadCallBack);
  }
};
DatabaseConnection.count = function (pCollection, pQuery, pGoodCallBack, pBadCallBack) {
  // make deep copy, to prevent changes
  if (Array.isArray(pQuery)) {
    pQuery = pQuery.slice();
  }
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection.count(pQuery, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  var endQuery = _getPredefinedFilter(collectionName);
  if (Array.isArray(pQuery) && pQuery.length > 0) {
    if (endQuery.length > 0) {
      pQuery.unshift("(");
      pQuery.push(")");
      pQuery.push("and");
    }
    endQuery = pQuery.concat(endQuery);
  }
  if (collectionName.indexOf("dataconnector.") === 0) {
    var dataconnectionInfo = _getDetailsDataConnector(collectionName);
    if (dataconnectionInfo !== null) {
      api_async.dataconnector.list(dataconnectionInfo.name, dataconnectionInfo.table, _mokeupDataConnectorQuery(endQuery), [], [], {}, pGoodCallBack, pBadCallBack);
    } else {
      pBadCallBack({
        "error": "wrong collectionname: " + collectionName
      });
    }
    return;
  } else if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects.count(collectionName.substring(22), endQuery, pGoodCallBack, pBadCallBack);
    return;
  }
  switch (collectionName) {
    case "nucleus.job":
    case "nucleus.project":
      api_async.job.count(endQuery, {}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.job_recursive":
      api_async.job.count(endQuery, {
        recursive: true
      }, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.users":
      api_async.users.list_with_options(endQuery, [], ["_id"], {}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.approval":
      // .count only for admins
      api_async.approval.list_with_options(endQuery, [], ["_id"], {}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.scope":
      api_async.scope.list_with_options(endQuery, [], ["_id"], {}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_active_users":
      api_async.stats.active_users.list_with_options(endQuery, [], ["_id"], {}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_workers":
      api_async.stats.workers.list_with_options(endQuery, [], ["_id"], {
        first: 0,
        maximum: 1,
        count: true
      }, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.stats_work_servers":
      api_async.stats.work_servers.list_with_options(endQuery, [], ["_id"], {
        first: 0,
        maximum: 1,
        count: true
      }, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      api_async.template.list_with_options(endQuery, [], ["_id"], {}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      api_async.job.count(endQuery, {}, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.asset":
    case "nucleus.jacket":
    case "nucleus.logs":
      pBadCallBack({
        "error_code": "no_support",
        "error": "for performans reasons we do not support count on " + collectionName
      });
      break;
    default:
      api_async.database.document.count(collectionName, endQuery, {}, pGoodCallBack, pBadCallBack);
  }
};
DatabaseConnection.create = function (pCollection, pObject, pGoodCallBack, pBadCallBack) {
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection.create(pObject, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  if (collectionName.indexOf("dataconnector.") === 0) {
    var dataconnectionInfo = _getDetailsDataConnector(collectionName);
    if (dataconnectionInfo !== null) {
      pBadCallBack({
        "error_code": "not_programmed_yet",
        "error": "create functionality does not exist for dataconnector"
      });
    } else {
      pBadCallBack({
        "error": "wrong collectionname: " + collectionName
      });
    }
    return;
  } else if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects.create(collectionName.substring(22), pObject, pGoodCallBack, pBadCallBack);
    return;
  }
  switch (collectionName) {
    case "nucleus.job":
    case "nucleus.project":
    case "nucleus.job_recursive":
      api_async.job.create(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.users":
      api_async.users.create(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.approval":
      api_async.approval.create(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.scope":
      api_async.scope.create(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      api_async.template.create(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      api_async.task_list.create(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.logs":
    case "nucleus.asset":
    case "nucleus.jacket":
    case "nucleus.portal_get_stats":
    case "nucleus.portal_get_db_status":
    case "nucleus.stats_active_users":
    case "nucleus.stats_database":
    case "nucleus.stats_workers":
    case "nucleus.stats_work_servers":
      pBadCallBack({
        "error_code": "readonly_collection",
        "error": "DatabaseConnection.create: collection " + pCollection + " is readonly"
      });
      break;
    default:
      api_async.database.document.create(collectionName, pObject, pGoodCallBack, pBadCallBack);
  }
};
DatabaseConnection.update = function (pCollection, pObject, pGoodCallBack, pBadCallBack) {
  if (pCollection && _typeof(pCollection) === "object") {
    var connection = WhitepaperCRUD.fromJSON(pCollection);
    connection.update(pObject, pGoodCallBack, pBadCallBack);
    return;
  }
  var collectionName = _normaliseCollectionName(pCollection);
  if (collectionName.indexOf("dataconnector.") === 0) {
    var dataconnectionInfo = _getDetailsDataConnector(collectionName);
    if (dataconnectionInfo !== null) {
      api_async.dataconnector.update(dataconnectionInfo.name, dataconnectionInfo.table, pObject, {}, pGoodCallBack, pBadCallBack);
    } else {
      pBadCallBack({
        "error": "wrong collectionname: " + collectionName
      });
    }
    return;
  } else if (collectionName.indexOf("nucleus.customobjects.") === 0) {
    api_async.custom_objects.update(collectionName.substring(22), pObject, pGoodCallBack, pBadCallBack);
    return;
  }
  switch (collectionName) {
    case "nucleus.job":
    case "nucleus.project":
    case "nucleus.job_recursive":
      api_async.job.update(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.users":
      api_async.users.update(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.approval":
      // only admins
      api_async.approval.update(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.scope":
      api_async.scope.update(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.template":
      api_async.template.update(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.task_list":
      api_async.task_list.update(pObject, pGoodCallBack, pBadCallBack);
      break;
    case "nucleus.logs":
    case "nucleus.asset":
    case "nucleus.jacket":
    case "nucleus.portal_get_stats":
    case "nucleus.portal_get_db_status":
    case "nucleus.stats_active_users":
    case "nucleus.stats_database":
    case "nucleus.stats_workers":
    case "nucleus.stats_work_servers":
      pBadCallBack({
        "error_code": "readonly_collection",
        "error": "DatabaseConnection.update: collection " + pCollection + " is readonly"
      });
      break;
    default:
      api_async.database.document.update(collectionName, pObject, pGoodCallBack, pBadCallBack);
  }
};
module.exports = DatabaseConnection;

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"./WhitepaperCRUD.js":213}],210:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var Unit = require("../../Units/js/Unit.js");
var UnitPreferences = require("../../Units/js/UnitPreferences.js");
require("../../ManageProjects/js/nixps-cloudflow-ProjectSetState.js");
require("../../FormElements/js/nixps-cloudflow-Image.js");
require("../../FormElements/js/nixps-cloudflow-CachedImage.js");
require("../../../common/RichEditor/js/richRenderer.js");
require("../../../common/RichEditor/js/nixps-RichEditor2.js");
require("../../../common/js/nixps-common-Languages.js");
require("../../CloudflowProgressBar/js/nixps-cloudflow-CloudflowProgressBar.js");
var expressionToJS = require("../../../pagebuilder/js/ExpressionToJS.js");
var FileSizeUtils = require("../../CloudflowUtil/js/FileSizeUtils.js");
var ColorUtil = require("../../CloudflowUtil/js/ColorUtils.js");
var QueryApplier = require("../../CloudflowUtil/js/QueryApplier.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
var Duration = require("../../../common/Duration/js/Duration.js");
var additionalType = [{
  type: "mongounderscoreid",
  renderFunction: "string",
  editable: true,
  editFunction: "string",
  searchRenderFunction: function searchRenderFunction(pColumnObject) {
    var searchinput = $("<input>").attr("type", "search").addClass("table-search");
    if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length === 5 && pColumnObject.search_startquery[2] === "equal to") {
      searchinput.val(pColumnObject.search_startquery[3].toString());
    }
    return searchinput;
  },
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var value = searchDOMElem.find("input").val();
    var key = pColumnObject.key;
    if (typeof value === "string" && value.length > 0) {
      return ["(", key, "equal to", value, ")"];
    } else {
      return [];
    }
  },
  clearSearchFunction: function clearSearchFunction(searchDOMElem, pColumnObject) {
    searchDOMElem.find("input").val("");
  }
}, {
  type: "collapsible",
  renderFunction: function renderFunction() {
    return $("<span>").addClass("fa fa-caret-right fa-lg pct_collapsible cf-iconbutton");
  },
  editable: false,
  editFunction: function editFunction() {},
  searchRenderFunction: function searchRenderFunction() {},
  getSearchQueryFunction: function getSearchQueryFunction() {},
  clearSearchFunction: function clearSearchFunction() {}
}, {
  type: "remove",
  renderFunction: function renderFunction(pw) {
    return $("<span>").addClass("fa fa-trash table_type_removeButton cf-table-toggleable").attr("data-action", "remove").attr("title", $.i18n._("nixps-cloudflow-preconfiguredtable.remove_tooltip"));
  },
  editable: false,
  editFunction: function editFunction() {},
  searchRenderFunction: function searchRenderFunction() {},
  getSearchQueryFunction: function getSearchQueryFunction() {},
  clearSearchFunction: function clearSearchFunction() {}
}, {
  type: "view",
  renderFunction: function renderFunction() {
    return $("<span>").addClass("fa fa-eye table_type_viewButton cf-table-toggleable").attr("data-action", "view").attr("title", $.i18n._("nixps-cloudflow-projectlist.actionbutton_view"));
  },
  editable: false,
  editFunction: function editFunction() {},
  searchRenderFunction: function searchRenderFunction() {},
  getSearchQueryFunction: function getSearchQueryFunction() {},
  clearSearchFunction: function clearSearchFunction() {}
}, {
  type: "edit",
  renderFunction: function renderFunction() {
    return $("<span>").addClass("fa fa-eye table_type_editButton cf-table-toggleable").attr("data-action", "edit").attr("title", $.i18n._("nixps-cloudflow-projectlist.actionbutton_edit"));
  },
  editable: false,
  editFunction: function editFunction() {},
  searchRenderFunction: function searchRenderFunction() {},
  getSearchQueryFunction: function getSearchQueryFunction() {},
  clearSearchFunction: function clearSearchFunction() {}
}, {
  type: "settings_mobile",
  renderFunction: function renderFunction() {
    return $("<span>").addClass("cf-icon cf-icon-more-actions table_type_settingsButton cf-table-toggleable").attr("data-action", "_settings_mobile");
  },
  editable: false,
  editFunction: function editFunction() {},
  searchRenderFunction: function searchRenderFunction() {},
  getSearchQueryFunction: function getSearchQueryFunction() {},
  clearSearchFunction: function clearSearchFunction() {}
}, {
  type: "progress",
  renderFunction: function renderFunction(pData, pOptions, pRows, pColumn) {
    if (!pColumn.options) {
      pColumn.options = {};
    }
    if (typeof pColumn.options.progressInputType !== "string" || pColumn.options.progressInputType.length <= 0) {
      pColumn.options.progressInputType = "value";
    }
    if (pColumn.options.progressInputType === "object" && !$.isPlainObject(pData) || pColumn.options.progressInputType === "value" && !(typeof pData === "string" || typeof pData === "number")) {
      return "";
    }
    var max = 1,
      classes = "",
      showValue = false;
    if (pOptions && _typeof(pOptions) === "object") {
      if (typeof pOptions.max === "number" && pOptions.max > 0) {
        max = pOptions.max;
      }
      if (typeof pOptions.colorType === "string" && pOptions.colorType.length > 0) {
        switch (pOptions.colorType) {
          case "followRowConditional":
            classes += "nixps-styles-follow-color ";
            break;
        }
      }
      if (typeof pOptions.showValue === "boolean") {
        showValue = pOptions.showValue;
      }
    }
    if (typeof pData === "number" || typeof pData === "string") {
      var progressNumber = pData;
      if (typeof progressNumber === "string" && progressNumber.trim().endsWith("%")) {
        progressNumber = parseFloat(progressNumber) / 100;
        max = 1; // reset max if value is percentage
      } else {
        progressNumber = parseFloat(progressNumber);
      }
      if (!isFinite(progressNumber)) {
        return "";
      }
      var progressDOM = $("<span>").CloudflowProgressBar({
        value: progressNumber,
        max: parseFloat(max)
      }).addClass(classes);
      return progressDOM;
      // return progressDOM.after($("<span>").addClass("table_progressvalue").text(parseInt(progressNumber/parseFloat(max)) + "%"))
    } else if (pData && _typeof(pData) === "object" && Object.keys(pData).length > 0) {
      if (typeof pData.value !== "number" && typeof pData.value !== "string") {
        return "";
      }
      var maxValue = typeof pData.max === "number" && pData.max > 0 ? pData.max : max;
      var progressNumber = pData.value;
      if (typeof progressNumber === "string" && progressNumber.trim().endsWith("%")) {
        progressNumber = parseFloat(progressNumber) / 100;
        maxValue = 1; // reset max if value is percentage
      } else {
        progressNumber = parseFloat(progressNumber);
      }
      if (!isFinite(progressNumber)) {
        return "";
      }
      var progressDOM = $("<span>").CloudflowProgressBar({
        value: progressNumber,
        max: maxValue,
        styleClassProgress: pData.styleClassProgress,
        styleClassBackground: pData.styleClassBackground,
        progressColor: pData.progressColor,
        backgroundColor: pData.backgroundColor || "#dcdcdc"
      }).addClass(classes);
      return progressDOM;
      // return progressDOM.after($("<span>").addClass("table_progressvalue").text(parseInt(progressNumber/maxValue) + "%"))
    }

    return "";
  },
  editable: false,
  editFunction: "string",
  searchRenderFunction: function searchRenderFunction(pColumnObject) {
    var searchInput = $("<span>").append($('<select class="table-search">').append($('<option value="equal to">')._t("nixps-cloudflow-table.equalto")).append($('<option value="greater than">')._t("nixps-cloudflow-table.greaterthan")).append($('<option value="less than">')._t("nixps-cloudflow-table.lessthan"))).append("<input type='text' class='table-search'/>");
    if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length === 5) {
      searchInput.find("select").val(pColumnObject.search_startquery[2]);
      searchInput.find("input").val(parseFloat(pColumnObject.search_startquery[3]));
    }
    return searchInput;
  },
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var operator = searchDOMElem.find("select").val();
    var value = searchDOMElem.find("input").val();
    value = value.trim();
    if (value.endsWith("%")) {
      value = value.replace("%", "");
      value = "" + parseFloat(value) / 100;
    }
    var key = pColumnObject.key;
    if (typeof value === "string" && value.length > 0) {
      return ["(", key, operator, parseFloat(value), "or", key + ".value", operator, parseFloat(value), ")"];
    } else {
      return [];
    }
  }
}, {
  type: "duration",
  renderFunction: function renderFunction(pData, pOptions, pRows, pColumn) {
    var data;
    if (typeof pData === "string") {
      data = parseFloat(pData);
      if (isNaN(data)) {
        return "";
      }
    } else if (typeof pData === "number" && !isNaN(pData)) {
      data = pData;
    } else {
      return "";
    }
    var time_ms = 0;
    if (!pOptions || !pOptions.format || pOptions.format === "seconds") {
      time_ms = data * 1000;
    } else if (pOptions.format === "milliseconds") {
      time_ms = data;
    } else if (pOptions.format === "minutes") {
      time_ms = data * 60000;
    } else {
      return "";
    }
    var duration = new Duration(time_ms);
    return duration.getDuration(0, false);
  },
  editable: true,
  editFunction: "string",
  searchRenderFunction: function searchRenderFunction(pColumnObject) {},
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {}
}, {
  type: "nextStateButtons",
  renderFunction: function renderFunction(pProjectData, pOptions, pAllData, pColumn) {
    if (!pOptions) {
      pOptions = {};
    }
    // check if there is a job/project data?
    if (pProjectData !== undefined && typeof pProjectData.project_id === "string" && pProjectData.project_id.length > 0) {
      return $("<div>").addClass("cf-table-toggleable").ProjectSetState({
        statesTranslationDict: pOptions.translations,
        projectData: pProjectData,
        disableOnNeedMetadata: pColumn.key !== "."
      });
    }
    return "";
  },
  editable: false,
  editFunction: function editFunction() {},
  searchRenderFunction: function searchRenderFunction() {},
  getSearchQueryFunction: function getSearchQueryFunction() {}
}, {
  type: "image",
  renderFunction: function renderFunction(pUrl, pOptions, pData) {
    var action = "image";
    var tooltip;
    var tooltipOptions = {};
    var _float = "";
    var objectFit = undefined;
    var width = null;
    var height = null;
    var maxWidth = null;
    var maxHeight = null;
    var relativeBasePath = "";
    var loadingPolicy = undefined;
    if (pOptions !== undefined) {
      if (typeof pOptions.action === "string" && pOptions.action.length > 0) {
        action = pOptions.action;
      }
      if (pOptions.tooltip !== undefined) {
        if (Array.isArray(pOptions.tooltip) && pOptions.tooltip.length > 0) {
          // expression
          var expressionHandler = new expressionToJS(pUrl);
          tooltip = expressionHandler.applyValue(pOptions.tooltip);
        } else if (typeof _typeof(pOptions.tooltip) === "string") {
          tooltip = pOptions.tooltip;
        }
      }
      if (pOptions.tooltipOptions && _typeof(pOptions.tooltipOptions) === "object") {
        tooltipOptions = Object.assign({
          tooltipClass: "cf-tooltip cf-tooltip-secondary",
          classes: {
            "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
          }
        }, pOptions.tooltipOptions);
      }
      if (pOptions["float"] !== undefined) {
        _float = pOptions["float"];
      }
      if (pOptions.objectFit !== undefined) {
        objectFit = pOptions.objectFit;
      }
      if (pOptions.maxWidth !== undefined) {
        width = "auto";
        maxWidth = pOptions.maxWidth;
      }
      if (pOptions.maxHeight !== undefined) {
        height = "auto";
        maxHeight = pOptions.maxHeight;
      }
      if (pOptions.loadingPolicy !== undefined) {
        loadingPolicy = pOptions.loadingPolicy;
      }
      if (Array.isArray(pOptions.expression) && pOptions.expression.length > 0 && pUrl && _typeof(pUrl) === "object" && pUrl.constructor && pUrl.constructor.name === "Object") {
        var expressionHandler = new expressionToJS(pUrl);
        pUrl = expressionHandler.applyValue(pOptions.expression);
      }
      if (typeof pOptions.relativeBasePath === "string" && pOptions.relativeBasePath.length > 0) {
        relativeBasePath = pOptions.relativeBasePath;
      }
    }
    var imgDOM = $("<span>").attr("data-action", action);
    if (pOptions !== undefined && typeof pOptions.cursortype === "string" && pOptions.cursortype.length > 0) {
      imgDOM.addClass("table-layout-cursortype-" + pOptions.cursortype);
    }
    imgDOM.CachedImage({
      "url": pUrl,
      "tooltip": tooltip,
      "tooltipOptions": tooltipOptions,
      "float": _float,
      "objectFit": objectFit,
      "loadingPolicy": loadingPolicy,
      "width": width,
      "height": height,
      "maxWidth": maxWidth,
      "maxHeight": maxHeight,
      "relativeBasePath": relativeBasePath
    });
    return imgDOM;
  },
  editable: false,
  editFunction: function editFunction() {},
  searchRenderFunction: "string",
  getSearchQueryFunction: "string"
}, {
  type: "link",
  renderFunction: function renderFunction(pUrl, pOptions) {
    if (typeof pUrl !== "string" || pUrl.length <= 0) {
      return "";
    }
    var linkText = pUrl;
    var newTab = false;
    if (pOptions !== undefined) {
      if (typeof pOptions.link_text === "string" && pOptions.link_text.length > 0) {
        linkText = pOptions.link_text;
      }
      if (pOptions.new_tab === true) {
        newTab = true;
      }
    }
    return $("<a>").attr("href", pUrl).text(linkText).addClass("cf-link").attr("target", function () {
      if (newTab === true) {
        return "_black";
      }
    });
  },
  editable: true,
  editFunction: "text",
  searchRenderFunction: function searchRenderFunction() {},
  getSearchQueryFunction: function getSearchQueryFunction() {}
}, {
  type: "expressionbuilder",
  renderFunction: function renderFunction(pObject, pOptions) {
    if (pOptions !== undefined) {
      if (Array.isArray(pOptions.expression)) {
        var expressionHandler = new expressionToJS(pObject);
        return $("<span>").text(expressionHandler.applyValue(pOptions.expression));
      } else if (pOptions.expression === "string" || pOptions.expression === "number") {
        return $("<span>").text(pOptions.expression);
      }
    }
    return $("<span>");
  },
  editable: false,
  editFunction: function editFunction() {},
  searchRenderFunction: function searchRenderFunction() {},
  getSearchQueryFunction: function getSearchQueryFunction() {}
}, {
  type: "enum_mapping",
  renderFunction: function renderFunction(pValue, pOptions) {
    if (Array.isArray(pOptions) === false || pOptions.length <= 0) {
      return "";
    }
    for (var i = 0; i < pOptions.length; i++) {
      if (pOptions[i].compare_kind === "default" || pOptions[i].compare_kind === "unfiltered") {
        if (i === pOptions.length - 1) {
          // do the code;
        } else {
          continue; // skip and go to next option
        }
      } else {
        var query;
        if (["exists", "does not exist"].includes(pOptions[i].compare_kind)) {
          query = ["value", pOptions[i].compare_kind];
        } else {
          query = ["value", pOptions[i].compare_kind || "equal to", pOptions[i].compare_value];
        }
        if (new QueryApplier(query).validate({
          value: pValue
        }) === true) {
          // do the code;
        } else {
          continue; // skip and go to next option
        }
      }

      var cursorClasses = "";
      var styleclass = "";
      var fullStyleClass = "";
      if (typeof pOptions[i].style_class === "string" && pOptions[i].style_class.length > 0) {
        styleclass = pOptions[i].style_class;
        fullStyleClass = "nixps_styling_class_" + pOptions[i].style_class;
      }
      if (typeof pOptions[i].cursortype === "string" && pOptions[i].cursortype.length > 0) {
        cursorClasses = " table-layout-cursortype-" + pOptions[i].cursortype;
      }
      var action = null;
      if (typeof pOptions[i].action === "string" && pOptions[i].action.length > 0) {
        action = pOptions[i].action;
      }
      var tooltip = null;
      if (typeof pOptions[i].tooltip === "string" && pOptions[i].tooltip.length > 0) {
        tooltip = pOptions[i].tooltip;
      }
      var tooltipOptions = {};
      if (pOptions[i].tooltipOptions && _typeof(pOptions[i].tooltipOptions) === "object") {
        tooltipOptions = Object.assign({
          tooltipClass: "cf-tooltip cf-tooltip-secondary",
          classes: {
            "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
          }
        }, pOptions[i].tooltipOptions);
      }
      if (pOptions[i].display_type === "icon") {
        // addClass(null) is equal as not adding at all
        return $("<span>").addClass(pOptions[i].display_icon).toggleClass("cf-table-toggleable", action !== null).addClass(fullStyleClass + cursorClasses).attr("data-action", action).attr("title", tooltip).each(function () {
          if (typeof tooltip === "string" && $.fn.tooltip) {
            $(this).tooltip(tooltipOptions);
          }
        });
      } else if (pOptions[i].display_type === "image") {
        var width = pOptions[i].display_image.width;
        var height = pOptions[i].display_image.height;
        var maxWidth, maxHeight, loadingPolicy;
        if (pOptions[i].display_image.maxWidth !== undefined) {
          width = "auto";
          maxWidth = pOptions[i].display_image.maxWidth;
        }
        if (pOptions[i].display_image.maxHeight !== undefined) {
          height = "auto";
          maxHeight = pOptions[i].display_image.maxHeight;
        }
        if (pOptions[i].display_image.loadingPolicy !== undefined) {
          loadingPolicy = pOptions[i].display_image.loadingPolicy;
        }
        var relativeBasePath = "";
        if (typeof pOptions[i].relativeBasePath === "string" && pOptions[i].relativeBasePath.length > 0) {
          relativeBasePath = pOptions[i].relativeBasePath;
        }
        return $("<span>").Image({
          "url": pOptions[i].display_image.url,
          "float": "",
          "tooltip": tooltip,
          "tooltipOptions": tooltipOptions,
          "width": width,
          "height": height,
          "maxWidth": maxWidth,
          "maxHeight": maxHeight,
          "loadingPolicy": loadingPolicy,
          "relativeBasePath": relativeBasePath,
          "pagebuilderStyleClass": styleclass
        }).toggleClass("cf-table-toggleable", action !== null).attr("data-action", action).addClass(cursorClasses);
      } else if (pOptions[i].display_type === "text") {
        return $("<span>").text(pOptions[i].display_text).addClass(fullStyleClass + cursorClasses).toggleClass("cf-table-toggleable", action !== null).attr("data-action", action).attr("title", tooltip).each(function () {
          if (typeof tooltip === "string" && $.fn.tooltip) {
            $(this).tooltip(tooltipOptions);
          }
        });
      }
    }
  },
  editable: false,
  editFunction: function editFunction(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
    if (Array.isArray(pColumnModel.options)) {}
  },
  searchRenderFunction: function searchRenderFunction(pColumnObject) {
    var searchSelect;
    if (Array.isArray(pColumnObject.options)) {
      var valueType = "string";
      var dict = {};
      // add all possibilities
      dict['*'] = $.i18n._("nixps-cloudflow-table.selector_allpossibilities");
      if (pColumnObject.options.length > 0) {
        for (var i = 0; i < pColumnObject.options.length; i++) {
          if (pColumnObject.options[i].compare_kind === 'unfiltered') {
            dict['*'] = $.i18n._(pColumnObject.options[i].selector);
          }
          if (pColumnObject.options[i].selector !== undefined && pColumnObject.options[i].compare_kind !== 'unfiltered') {
            if (typeof pColumnObject.options[i].selector === "string" && pColumnObject.options[i].selector[pColumnObject.options[i].selector.length - 1] === "}" && (pColumnObject.options[i].selector.indexOf("${pb-") === 0 || pColumnObject.options[i].selector.indexOf("${custom-") === 0)) {
              dict[pColumnObject.options[i].selector] = $.i18n._(pColumnObject.options[i].selector.slice(2, -1));
            } else {
              dict[pColumnObject.options[i].selector] = pColumnObject.options[i].selector;
            }
          }
        }
        valueType = _typeof(pColumnObject.options[0].compare_value);
      }
      // make selector
      searchSelect = $("<div>").Select({
        keyValues: dict,
        "default": "*",
        classes: "table-search",
        ariaLabel: $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label])
      }).attr("data-valuetype", valueType);
      if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length > 0) {
        if (pColumnObject.search_startquery.length > 5 && pColumnObject.search_startquery.includes("or") && pColumnObject.search_startquery[0] === "(" && pColumnObject.search_startquery[pColumnObject.search_startquery.length - 1] === ")") {
          pColumnObject.search_startquery.pop();
          pColumnObject.search_startquery.shift();
        }
        var selector;
        var andIndex = pColumnObject.search_startquery.indexOf("and");
        if (andIndex > 3 && pColumnObject.search_startquery[andIndex - 2] === "greater than or equal" && pColumnObject.search_startquery[andIndex + 2] === "less than or equal") {
          selector = "between";
        } else if (pColumnObject.search_startquery.length > 3) {
          for (var i = 0; i < pColumnObject.options.length; i++) {
            if (pColumnObject.options[i].compare_kind === pColumnObject.search_startquery[2] && pColumnObject.options[i].compare_value === pColumnObject.search_startquery[3]) {
              selector = pColumnObject.options[i].selector;
              break;
            }
          }
        }
        if (typeof selector === "string") {
          searchSelect.Select("setValue", selector);
        }
      }
    } else {
      searchSelect = $("<div>").Select({
        keyValues: {
          "*": $.i18n._("nixps-cloudflow-table.selector_allpossibilities")
        },
        "default": "*",
        classes: "table-search",
        ariaLabel: $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label])
      }).attr("data-valuetype", "string");
    }
    return searchSelect;
  },
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var searchQuery = [];
    var selector = searchDOMElem.find('.nixps-cloudflow-Select').Select('getValue');
    if (selector !== "*") {
      var valueType = searchDOMElem.find('.nixps-cloudflow-Select').attr("data-valuetype");
      if (Array.isArray(pColumnObject.options) && pColumnObject.options.length > 0) {
        for (var i = 0; i < pColumnObject.options.length; i++) {
          if (pColumnObject.options[i].selector === selector) {
            if (searchQuery.length > 0) {
              searchQuery.push("or");
            }
            var value = pColumnObject.options[i].compare_value;
            if (valueType === "number") {
              value = parseFloat(value);
            } else if (valueType === "boolean") {
              value = "" + value == "true";
            }
            if (pColumnObject.options[i].compare_kind === "between") {
              var value2 = pColumnObject.options[i].compare_value2;
              if (valueType === "number") {
                value2 = parseFloat(value2);
              } else if (valueType === "boolean") {
                value2 = "" + value2 == "true";
              }
              searchQuery = searchQuery.concat(['(', pColumnObject.key, "greater than or equal", value, "and", pColumnObject.key, "less than or equal", value2, ')']);
            } else if (["exists", "does not exist"].includes(pColumnObject.options[i].compare_kind)) {
              searchQuery = searchQuery.concat(['(', pColumnObject.key, pColumnObject.options[i].compare_kind, ')']);
            } else {
              searchQuery = searchQuery.concat(['(', pColumnObject.key, pColumnObject.options[i].compare_kind || "equal to", value, ')']);
            }
          }
        }
      }
      if (searchQuery.length > 5) {
        searchQuery.unshift("(");
        searchQuery.push(")");
      }
    }
    return searchQuery;
  }
}, {
  type: "unit",
  renderFunction: function renderFunction(pValue, pOptions) {
    if (typeof pValue !== "number") {
      if (isNaN(parseFloat(pValue))) {
        return "";
      } else {
        pValue = parseFloat(pValue);
      }
    }
    var displayDefinition = pOptions.displayDefinition;
    if (typeof displayDefinition !== "string" || displayDefinition.length <= 0) {
      return pValue;
    }
    var storageUnit = pOptions.storageUnit;
    if (typeof storageUnit !== "string" || storageUnit.length <= 0) {
      return pValue;
    }
    var inputUnit = new Unit({
      unit: storageUnit
    });
    // retrieve the user preferended unit
    var outputUnit = new UnitPreferences().getDefinition(displayDefinition);
    // convert to the correct unit styling
    return outputUnit.toString(inputUnit.convert(pValue, outputUnit), true);
  },
  editable: true,
  editFunction: function editFunction(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
    pCell.wrapInner($('<span>').addClass('innerTextSpan').css('visibility', 'hidden'));
    var panel = $('<form>').addClass('cf-table-changePanel');
    panel.css({
      'position': 'absolute',
      'top': 0,
      'left': 0,
      'right': 0,
      'bottom': 0
    });
    pCell.css({
      'position': 'relative'
    }).append(panel);
    var input = $('<input>');
    panel.append(input);
    var inputValue;
    var value = CloudflowObject.getParameter(pRowObject, pColumnModel.key);
    if (typeof value !== "number") {
      if (isNaN(parseFloat(value))) {
        inputValue = 0;
      } else {
        inputValue = parseFloat(value);
      }
    } else {
      inputValue = value;
    }
    input.ValueInput({
      name: "searchUnit",
      displayDefinition: pColumnModel.options.displayDefinition,
      storageUnit: pColumnModel.options.storageUnit,
      value: inputValue
    });
    input.focus();
    panel.one('focusout submit', function (pEvent) {
      panel.off('focusout submit');
      var newValue = input.ValueInput('getValue');
      if (value !== newValue) {
        pUpdateEditCellCB(pCell, pColumnModel, pRowObject, newValue);
      } else {
        pCancelEditCellCB(pCell);
      }
      if (pEvent.type === "submit") {
        return false;
      }
      return true;
    });
  },
  searchRenderFunction: function searchRenderFunction(pColumnObject) {
    if (pColumnObject.options === undefined || typeof pColumnObject.options.displayDefinition !== "string" || typeof pColumnObject.options.storageUnit !== "string") {
      pColumnObject.options = {
        displayDefinition: "length",
        storageUnit: "m"
      };
    }
    var searchInput = $('<span>').append($('<select class="table-search">').append($('<option value="all">')._t("nixps-cloudflow-table.allvalues")).append($('<option value="equal to">')._t("nixps-cloudflow-table.equalto")).append($('<option value="greater than">')._t("nixps-cloudflow-table.greaterthan")).append($('<option value="less than">')._t("nixps-cloudflow-table.lessthan"))).append($("<input>").addClass("table-search").hide().ValueInput({
      name: "searchUnit",
      displayDefinition: pColumnObject.options.displayDefinition,
      storageUnit: pColumnObject.options.storageUnit
    }));
    searchInput.children("select").change(function () {
      if ($(this).val() === "all") {
        $(this).next('.table-search').hide();
      } else {
        $(this).next('.table-search').css("display", "");
      }
    });
    if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length === 5) {
      searchInput.find('select').val(pColumnObject.search_startquery[2]);
      searchInput.find('input').val(parseFloat(pColumnObject.search_startquery[3]));
      if (searchInput.find('select').val() !== "all") {
        searchInput.find('input').css("display", "");
      }
    }
    return searchInput;
  },
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var operator = searchDOMElem.find('select').val();
    var unit = searchDOMElem.find(".nixps-cloudflow-ValueInput").ValueInput('getValue');
    var key = pColumnObject.key;
    if (operator === "all") {
      return [];
    } else if (typeof unit === "number") {
      return ['(', key, operator, unit, ')'];
    } else {
      return [];
    }
  }
}, {
  type: "file_size",
  renderFunction: function renderFunction(pValue) {
    return FileSizeUtils.toString(pValue, undefined, "&nbsp;");
  },
  editable: false,
  editFunction: function editFunction(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
    pCell.wrapInner($('<span>').addClass('innerTextSpan').css('visibility', 'hidden'));
    var cellWidth = pCell.find('span.innerTextSpan').width();
    var panel = $('<form>').addClass('cf-table-changePanel');
    panel.css({
      'position': 'absolute',
      'top': 0,
      'left': 0,
      'right': 0,
      'bottom': 0
    });
    pCell.css({
      'position': 'relative'
    }).append(panel);
    var inputDOM = $('<div>');
    panel.append(inputDOM);
    var unitJSON = {
      unit: "B",
      accuracy: 0
    };
    var value = CloudflowObject.getParameter(pRowObject, pColumnModel.key);
    if (value >= 1000000000) {
      unitJSON = {
        unit: "GB",
        accuracy: 3
      };
    } else if (value >= 1000000) {
      unitJSON = {
        unit: "MB",
        accuracy: 3
      };
    } else if (value >= 1000) {
      unitJSON = {
        unit: "KB",
        accuracy: 2
      };
    }
    inputDOM.ValueInput({
      createInput: true,
      name: "edit_percentage",
      value: value,
      displayDefinition: new Unit(unitJSON),
      storageUnit: new Unit({
        unit: "B",
        accuracy: 0
      })
    });
    inputDOM.find("input").css("width", "99%").focus();
    panel.one('focusout submit', function (pEvent) {
      panel.off('focusout submit');
      var inputValue = inputDOM.ValueInput('getValue');
      if (value !== inputValue) {
        pUpdateEditCellCB(pCell, pColumnModel, pRowObject, inputValue);
      } else {
        pCancelEditCellCB(pCell);
      }
      if (pEvent.type === "submit") {
        return false;
      }
      return true;
    });
  },
  searchRenderFunction: function searchRenderFunction(pColumnObject) {
    var searchInput = $('<span>').append($("<select>").addClass("table-search filesizeoperator").attr("aria-label", $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label])).append($('<option value="all">').text($.i18n._("nixps-cloudflow-table.allvalues"))).append($('<option value="equal to">').text($.i18n._("nixps-cloudflow-table.equalto"))).append($('<option value="greater than">').text($.i18n._("nixps-cloudflow-table.greaterthan"))).append($('<option value="less than">').text($.i18n._("nixps-cloudflow-table.lessthan")))).append($("<div>").addClass("filesizeinput").hide().append($("<div>").addClass("table-search").Input({
      "type": "decimal",
      "min": 0,
      "size": 7
    }).css("display", "inline-block")).append($("<div>").addClass("table-search filesize_multiplier").Select({
      keyValues: {
        1: "B",
        1000: "KB",
        1000000: "MB",
        1000000000: "GB"
      },
      outputFormat: "number"
    }).css("display", "inline-block")));
    searchInput.children("select.filesizeoperator").change(function () {
      if ($(this).val() === "all") {
        $(this).next('.filesizeinput').hide();
      } else {
        $(this).next('.filesizeinput').css("display", "");
      }
    });
    if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length === 5) {
      searchInput.find('select').val(pColumnObject.search_startquery[2]);
      searchInput.find('input').val(parseFloat(pColumnObject.search_startquery[3]));
      if (searchInput.find('select').val() !== "all") {
        searchInput.find('input').css("display", "");
      }
    }
    return searchInput;
  },
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var operator = searchDOMElem.find('select.filesizeoperator').val();
    var value = searchDOMElem.find(".nixps-cloudflow-Input").Input('getValue');
    var multiplier = searchDOMElem.find(".filesize_multiplier").Select('getValue');
    var key = pColumnObject.key;
    if (operator === "all") {
      return [];
    } else if (typeof value === "number") {
      return ['(', key, operator, value * multiplier, ')'];
    } else {
      return [];
    }
  }
}, {
  type: "rich_text",
  renderFunction: function renderFunction(pValue) {
    if (pValue === undefined || pValue === null) {
      return "";
    }
    return $("<span>").richText(pValue);
  },
  editable: true,
  editFunction: function editFunction(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
    pCell.wrapInner($('<span>').addClass('innerTextSpan').css('visibility', 'hidden'));
    var panel = $('<div>').addClass('');
    panel.css({
      'position': 'absolute',
      'top': 0,
      'left': 0,
      'right': 0,
      'bottom': 0
    });
    pCell.css({
      'position': 'relative'
    }).append(panel);
    var inputEditor = $('<div>');
    panel.append(inputEditor);
    var value = CloudflowObject.getParameter(pRowObject, pColumnModel.key);
    inputEditor.RichEditor2({
      language: "en",
      inline: true,
      enterMode: "BR",
      enableUndoRedoAction: false,
      translator: function translator(pString) {
        pString = pString.replace(/<strong\>/g, "<b>").replace(/<\/strong>/g, "</b>");
        pString = pString.replace(/<em>/g, "<i>").replace(/<\/em>/g, "</i>");
        pString = pString.replace(/<p>/g, "").replace(/<\/p>/g, "<br>");
        pString = pString.replace(/\n|\r/g, "");
        pString = pString.replace(/&nbsp;/g, " ");
        return pString;
      },
      blur: function blur(pEvent, pData) {
        $(this).RichEditor2("option", "disabled", true);
        var text = $(this).RichEditor2('getValue', false);
        if (value !== text) {
          pUpdateEditCellCB(pCell, pColumnModel, pRowObject, text);
        } else {
          $(this).RichEditor2("destroy");
          pCancelEditCellCB(pCell);
        }
        return true;
      }
    });
    inputEditor.RichEditor2("setValue", value);
    inputEditor.RichEditor2("focus");
  },
  searchRenderFunction: "text",
  getSearchQueryFunction: "text"
}, {
  type: "tags",
  renderFunction: function renderFunction(pValue) {
    if (Array.isArray(pValue) && pValue.length > 0) {
      var outputArray = [];
      for (var i = 0; i < pValue.length; i++) {
        var name = "";
        if (["string", "number", "boolean"].includes(_typeof(pValue[i]))) {
          name = pValue[i];
        } else if (pValue[i] && _typeof(pValue[i]) === "object") {
          if (["string", "number", "boolean"].includes(_typeof(pValue[i].label))) {
            name = pValue[i].label;
          } else if (["string", "number", "boolean"].includes(_typeof(pValue[i].text))) {
            name = pValue[i].text;
          } else if (["string", "number", "boolean"].includes(_typeof(pValue[i].name))) {
            name = pValue[i].name;
          }
        }
        outputArray.push($("<span>").addClass("cf-tag").text(name));
      }
      return outputArray;
    }
    return "";
  },
  editable: false,
  editFunction: function editFunction(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {},
  searchRenderFunction: "text",
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var value = searchDOMElem.find("input").val();
    var key = pColumnObject.key;
    if (typeof value === "string" && value.length > 0) {
      // look through arrays
      return ["(", key, "contains text like", value, ")"];
    } else {
      return [];
    }
  }
}, {
  type: "color",
  renderFunction: function renderFunction(pValue) {
    if (pValue === undefined || pValue === null || pValue === "") {
      return "";
    }
    var color = ColorUtil.getWebColor(pValue, null);
    if (color === null) {
      // color is unknown because it could not be translated
      return $("<div>").addClass("cf-colorpreview cf-colorpreview-unknown");
    } else {
      return $("<div>").addClass("cf-colorpreview").css("backgroundColor", color);
    }
  },
  editable: false,
  editFunction: function editFunction(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {},
  searchRenderFunction: function searchRenderFunction() {},
  getSearchQueryFunction: function getSearchQueryFunction() {}
}, {
  type: "percentage",
  renderFunction: function renderFunction(pValue) {
    var numericValue = pValue,
      max = 1;
    if (pValue && _typeof(pValue) === "object" && Object.keys(pValue).length > 0) {
      if (typeof pValue.value !== "number" && typeof pValue.value !== "string") {
        return "--";
      }
      if (typeof pValue.max === "number" && pValue.max > 0) {
        max = pValue.max;
      }
      numericValue = pValue.value;
    }
    if (typeof numericValue === "string" && numericValue.trim().endsWith("%")) {
      numericValue = parseFloat(numericValue) / 100;
      max = 1; // reset max if value is percentage
    } else {
      numericValue = parseFloat(numericValue);
    }
    if (typeof max === "number" && max > 0 && max !== 1) {
      numericValue = numericValue / max;
    }
    if (!isFinite(numericValue)) {
      return "--";
    }
    // round to max 2 numbar after comma 
    var roundedValue = Math.round(numericValue * 10000) / 10000;
    // some ductape to fix isses like  0.5556 * 100
    return parseFloat((roundedValue * 100).toFixed(10)) + "&nbsp;%";
  },
  editable: true,
  editFunction: function editFunction(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
    pCell.wrapInner($("<span>").addClass("innerTextSpan").css("visibility", "hidden"));
    var cellWidth = pCell.find("span.innerTextSpan").width();
    var panel = $("<div>").addClass("cf-table-changePanel");
    panel.css({
      "position": "absolute",
      "top": 0,
      "left": 0,
      "right": 0,
      "bottom": 0
    });
    pCell.css({
      "position": "relative"
    }).append(panel);
    var inputDOM = $("<div>");
    panel.append(inputDOM);
    var valueFromObject = CloudflowObject.getParameter(pRowObject, pColumnModel.key);
    var value = 0;
    var numericValue = 0,
      max = 1,
      valueFormat;
    if (typeof valueFromObject == "string") {
      valueFormat = valueFromObject.endsWith("%") ? "percentage" : "string";
      numericValue = parseFloat(valueFromObject);
    } else if (typeof valueFromObject === "number") {
      valueFormat = "number";
      numericValue = parseFloat(valueFromObject);
    } else if (valueFromObject && _typeof(valueFromObject) === "object") {
      if (typeof valueFromObject.max === "number" && valueFromObject.max > 0) {
        max = valueFromObject.max;
      }
      if (typeof valueFromObject.value === "string") {
        valueFormat = "value_" + (valueFromObject.value.endsWith("%") ? "percentage" : "string");
        numericValue = parseFloat(valueFromObject.value);
        max = 1; // reset max if value is percentage
      } else if (typeof valueFromObject.value === "number") {
        valueFormat = "value_number";
        numericValue = parseFloat(valueFromObject.value);
      }
    }
    if (isFinite(numericValue)) {
      // round to max 2 numbar after comma 
      var roundedValue = Math.round(numericValue * 10000) / 10000;
      // some ductape to fix isses like  0.5556 * 100
      value = parseFloat((roundedValue * 100).toFixed(10));
    }
    inputDOM.ValueInput({
      createInput: true,
      name: "edit_percentage",
      value: value,
      displayDefinition: new Unit({
        unit: "%",
        accuracy: 2
      }),
      storageUnit: new Unit({
        unit: "%",
        accuracy: 2
      })
    });
    inputDOM.find("input").css("width", "99%").focus();
    panel.one("focusout submit", function (pEvent) {
      panel.off("focusout submit");
      var inputValue = inputDOM.ValueInput("getValue");
      var valueToSave = inputValue;
      if (typeof max === "number" && max !== 1) {
        valueToSave = valueToSave * max;
      }
      if (valueFormat.endsWith("percentage")) {
        valueToSave = "" + valueToSave + "%";
      } else {
        valueToSave = parseFloat((valueToSave / 100).toFixed(10));
      }
      if (valueFormat.endsWith("string")) {
        valueToSave = "" + valueToSave;
      }
      if (valueFormat.startsWith("value_")) {
        valueToSave = Object.assign(valueFromObject, {
          value: valueToSave
        });
      }
      pUpdateEditCellCB(pCell, pColumnModel, pRowObject, valueToSave);
      if (pEvent.type === "submit") {
        return false;
      }
      return true;
    });
  },
  searchRenderFunction: function searchRenderFunction(pColumnObject) {
    var searchInput = $("<span>").append($("<select>").addClass("table-search percentageoperator").attr("aria-label", $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label])).append($('<option value="all">').text($.i18n._("nixps-cloudflow-table.allvalues"))).append($('<option value="equal to">').text($.i18n._("nixps-cloudflow-table.equalto"))).append($('<option value="greater than">').text($.i18n._("nixps-cloudflow-table.greaterthan"))).append($('<option value="less than">').text($.i18n._("nixps-cloudflow-table.lessthan")))).append($("<div>").addClass("percentageinput").hide().append($("<div>").addClass("table-search").Input({
      "type": "decimal",
      "size": 7
    }).css("display", "inline-block")).append("%"));
    searchInput.children("select.percentageoperator").on("change", function () {
      if ($(this).val() === "all") {
        $(this).next(".percentageinput").hide();
      } else {
        $(this).next(".percentageinput").css("display", "");
      }
    });
    return searchInput;
  },
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var operator = searchDOMElem.find("select.percentageoperator").val();
    var value = searchDOMElem.find(".nixps-cloudflow-Input").Input("getValue");
    var key = pColumnObject.key;
    if (operator === "all") {
      return [];
    } else if (typeof value === "number") {
      return ["(", key, operator, value / 100, "or", key + ".value", operator, value / 100, ")"];
    } else {
      return [];
    }
  }
}, {
  type: "language",
  renderFunction: function renderFunction(pLanguage) {
    if (pLanguage === undefined || pLanguage === null) {
      return "";
    }
    if (typeof pLanguage === "string" && window.nixps !== undefined && nixps.common !== undefined && nixps.common.isoLangs !== undefined) {
      var languageInfo = nixps.common.isoLangs[pLanguage];
      if (languageInfo !== undefined && typeof languageInfo.nativeName === "string") {
        return languageInfo.nativeName + " (" + pLanguage + ")";
      }
    }
    return pLanguage;
  },
  editable: false,
  editFunction: function editFunction(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {},
  searchRenderFunction: function searchRenderFunction(pColumnObject) {
    if (window.$ === undefined || $.fn === undefined || $.fn.LanguageSelector === undefined) {
      throw new Error("LanguageSelector must be included");
    }
    var searchInput = $("<span>").append($("<div>").addClass("table-search").LanguageSelector({
      addOptionAll: true,
      value: ""
    }));
    return searchInput;
  },
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var language = searchDOMElem.find(".nixps-LanguageSelector").LanguageSelector("getValue");
    var key = pColumnObject.key;
    if (typeof language === "string" && language.length > 0) {
      return ["(", key, "equal to", language, ")"];
    } else {
      return [];
    }
  }
}, {
  type: "array_length",
  renderFunction: function renderFunction(pArray) {
    // padding with small spaces, trying to make all columns same width, to prevent column shifting
    if (!Array.isArray(pArray)) {
      return "\u2009\u2009";
    }
    return pArray.length.toString().padStart(2, "\u2009");
  },
  editable: false,
  editFunction: function editFunction() {},
  searchRenderFunction: function searchRenderFunction(pColumnObject) {
    var searchDOM = document.createElement("SPAN");
    var selectDOM = document.createElement("SELECT");
    selectDOM.className = "table-search arrayLengthOperator";
    selectDOM.setAttribute("aria-label", $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label]));
    var allOptionDOM = document.createElement("OPTION");
    allOptionDOM.setAttribute("value", "all");
    allOptionDOM.textContent = $.i18n._("nixps-cloudflow-table.allvalues");
    selectDOM.appendChild(allOptionDOM);
    var equalToOptionDOM = document.createElement("OPTION");
    equalToOptionDOM.setAttribute("value", "equal to");
    equalToOptionDOM.textContent = $.i18n._("nixps-cloudflow-table.equalto");
    selectDOM.appendChild(equalToOptionDOM);
    searchDOM.appendChild(selectDOM);
    var inputDOM = document.createElement("INPUT");
    inputDOM.className = "table-search arrayLengthAmount cf-table-filter-smallinput";
    inputDOM.setAttribute("type", "number");
    inputDOM.setAttribute("min", 0);
    inputDOM.setAttribute("step", 1);
    inputDOM.style = "visibility:hidden;";
    searchDOM.appendChild(inputDOM);
    selectDOM.addEventListener("change", function () {
      if (selectDOM.value === "all") {
        inputDOM.style = "visibility:hidden;";
      } else {
        inputDOM.style = "display:inline-block;";
      }
    });
    return searchDOM;
  },
  getSearchQueryFunction: function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var inputDOM = searchDOMElem[0].querySelector("input.arrayLengthAmount");
    var operatorDOM = searchDOMElem[0].querySelector("select.arrayLengthOperator");
    if (inputDOM && operatorDOM) {
      var operator = operatorDOM.value;
      var amount = parseInt(inputDOM.value);
      if (operator === "all") {
        return [];
      } else if (operator === "equal to") {
        if (isFinite(amount) && amount >= 0) {
          return ["(", pColumnObject.key + "." + (amount - 1), "exists", "and", pColumnObject.key + "." + amount, "does not exist", ")"];
        }
      } else if (operator === "greater than") {
        if (isFinite(amount) && amount >= 0) {
          return ["(", pColumnObject.key + "." + amount, "exists", ")"];
        }
      } else if (operator === "less than") {
        if (isFinite(amount) && amount >= 0) {
          if (amount === 0) {
            return ["(", pColumnObject.key + ".-1", "exists", ")"];
          } else {
            return ["(", pColumnObject.key, "exists", "and", pColumnObject.key + "." + (amount - 1), "does not exist", ")"];
          }
        }
      } else {
        throw new Error("unknown operator value " + operator);
      }
    }
    return [];
  }
}];
module.exports = additionalType;

},{"../../../common/Duration/js/Duration.js":289,"../../../common/RichEditor/js/nixps-RichEditor2.js":315,"../../../common/RichEditor/js/richRenderer.js":316,"../../../common/js/nixps-common-Languages.js":390,"../../../pagebuilder/js/ExpressionToJS.js":415,"../../CloudflowProgressBar/js/nixps-cloudflow-CloudflowProgressBar.js":70,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../CloudflowUtil/js/ColorUtils.js":81,"../../CloudflowUtil/js/FileSizeUtils.js":88,"../../CloudflowUtil/js/QueryApplier.js":91,"../../FormElements/js/nixps-cloudflow-CachedImage.js":141,"../../FormElements/js/nixps-cloudflow-Image.js":149,"../../ManageProjects/js/nixps-cloudflow-ProjectSetState.js":183,"../../Units/js/Unit.js":264,"../../Units/js/UnitPreferences.js":265}],211:[function(require,module,exports){
"use strict";

var CloudflowObject = require('../../CloudflowUtil/js/CloudflowObject.js');
var QueryPredefinedKeys = require('../../CloudflowUtil/js/QueryPredefinedKeys.js');

/**
 * @constructor Query
 * @name Query
 * @version 1
 * @description This class present a Query. This gives some help functionality to work with querys with a cloudflow API-interface.
 * @param {Array} pQuery - The query array that will be the main query array. 
 */
var Query = function Query(pQuery, pSearchQuery) {
  var errorMessage = Query.hasGoodInterface(pQuery);
  if (errorMessage !== true) {
    throw new Error(errorMessage);
  }
  // make a copy of the array
  this.query = Query.surroundBrack(pQuery);
  this.searchQuery = [];
  this.selectionQuery = [];
  if (Array.isArray(pSearchQuery)) {
    this.setSearchQuery(pSearchQuery);
  }
};

/**
* @function
* @desc this function controls if the query has a good interface.
* it controls if it is a array of strings|numbers|booleans.
* it does not control the logic itself. The query can be malformed.
* @static
* @name Query.hasGoodInterface
* @param {array} pQuery
* @returns {boolean_or_String} boolean true if the array has a good interface or a string with the explication why the query is bad.
*/
Query.hasGoodInterface = function (pQuery) {
  if (Array.isArray(pQuery)) {
    for (var i = 0; i < pQuery.length; i++) {
      if (Array.isArray(pQuery[i])) {
        if (pQuery[i - 1] !== "in") {
          return 'an array inside a query should be precended by the "in" operator';
        }
      } else if (typeof pQuery[i] !== "string" && typeof pQuery[i] !== "number" && typeof pQuery[i] !== "boolean") {
        return 'All elements of the query ' + pQuery + 'must be a string/number or a boolean';
      }
    }
    return true;
  } else {
    return 'Query ' + pQuery + 'must be a array';
  }
};

/**
 * @function
 * @description Control the input parameter array, if it is a good candidate for sortBy query.
 * @name Query.hasGoodOrderByQueryInterface
 * @static
 * @param {array} pSortByQuery The query to control
 * @param {array} pSortingKeys (optional) the array containgings the only possible sortings key 
 * @returns {boolean_or_String|String|Boolean} retruns the error string or true if interface is good.
 */
Query.hasGoodOrderByQueryInterface = function (pSortByQuery, pSortingKeys) {
  var basicCheckValue = Query.hasGoodInterface(pSortByQuery);
  if (typeof basicCheckValue === "string") {
    return basicCheckValue;
  }
  // control if items are even
  if (pSortByQuery.length % 2 !== 0) {
    return 'the sortBy query must have even amount of items';
  }
  // loop over and each odd must be "ascending" or "descending"
  for (var i = 1; i < pSortByQuery.length; i = i + 2) {
    if (['ascending', 'descending'].indexOf(pSortByQuery[i]) < 0) {
      return "item at index " + i + " must be 'ascending' or 'descending'";
    }
  }
  // control the sorting keys if there are given!
  if (Array.isArray(pSortingKeys) && pSortingKeys.length > 0) {
    // loop over each even item and this must be a valid sorting key 
    for (var i = 0; i < pSortByQuery.length; i = i + 2) {
      if (pSortingKeys.indexOf(pSortByQuery[i]) < 0) {
        return "item at index " + i + " must be a valid sorting key";
      }
    }
  }
  return true;
};

/**
* @function
* @description Change the query, so it will be sorted  on the specific column
* @name Query.sortByColumn
* @static
* @param {String} pColumn the columnname where we must sort on
* @param {Boolean} pAsc true to sort on ascending, false to sort descending
* @returns {array | query} the changed query where we add the command to sort on that Column
*/
Query.getQueryDataSortByColumn = function (pColumn, pAsc) {
  if (typeof pColumn !== "string" || pColumn.length <= 0) {
    throw new Error('pColumn must be a string');
  }
  if (typeof pAsc !== "boolean") {
    throw new Error('pAsc must be a boolean');
  }
  var sorting = pAsc ? "ascending" : "descending";
  return [pColumn, sorting];
};

/**
 * @desc this functions concats two querys
 * @function
 * @name Query.concatQuery
 * @static
 * @param {Array} pQueryA the query that becomes before
 * @param {Array} pQueryB the query that becomes afterwards
 * @returns {Array} returns a query that is the concatanation of the two
 */
Query.concatQuery = function (pQueryA, pQueryB) {
  if (Query.hasGoodInterface(pQueryA) === true && Query.hasGoodInterface(pQueryA) === true) {
    if (pQueryA.length === 0) {
      return pQueryB;
    } else if (pQueryB.length === 0) {
      return pQueryA;
    } else {
      return Query.surroundBrack(pQueryA.slice()).concat(['and']).concat(Query.surroundBrack(pQueryB.slice()));
    }
  } else {
    throw new Error(Query.hasGoodInterface(pQueryA) + Query.hasGoodInterface(pQueryA));
  }
};
Query.surroundBrack = function (pQuery) {
  var query = pQuery.slice();
  if (query.length > 0) {
    query.push(')');
    query.unshift('(');
  }
  return query;
};

/**
 * @description filter statically the rows, designed for table component
 * @function
 * @name Query.apply
 * @static
 * @param {Array.<Object>} pRows All the rows, to be filtered
 * @param {Array.<String>} pSearchQuery A backend like query, limmitted by what the table generete
 * @param {Array.<String>} pOrderBy The array orberby, similar like the list_with_options call
 * @param {Number} pSkip the number to start of
 * @param {Number} pLimit the max amount of rows to retrun
 * @param {Number} pLast The number last of
 * @returns Array The filtered and sorted rows  
 */
Query.apply = function (pRows, pSearchQuery, pOrderBy, pSkip, pLimit, pLast) {
  if (!Array.isArray(pRows)) {
    throw new Error("parameter pRows must be an array");
  }
  // short-cut for empty rows
  if (pRows.length === 0) {
    return [];
  }
  // control pSearchQuery
  pSearchQuery = pSearchQuery.slice(); // make little copy
  var errorMessage = Query.hasGoodInterface(pSearchQuery);
  if (errorMessage !== true) {
    throw new Error(errorMessage);
  }
  // control pOrderByquery
  if (pOrderBy === undefined) {
    pOrderBy = [];
  }
  errorMessage = Query.hasGoodOrderByQueryInterface(pOrderBy);
  if (errorMessage !== true) {
    throw new Error(errorMessage);
  }
  // control pSkip
  if (pSkip === undefined) {
    pSkip = 0;
  } else if (typeof pSkip !== "number" || pSkip < 0) {
    throw new Error("parameter pSkip must be a positive number");
  }
  // control pLimit
  if (pLimit === undefined || pLimit === null) {
    pLimit = Number.MAX_SAFE_INTEGER || Number.MAX_VALUE || 10000000000;
  } else if (typeof pLimit !== "number" || pLimit < 0) {
    throw new Error("parameter pLimit must be a positive number");
  }
  function getField(pParent, pField) {
    return CloudflowObject.getParameter(pParent, pField);
  }
  // apply search, filter first
  // we suppose only "and"s are used !!!
  // we ony support querys of form >>>> ( a eq b) and ( c eq f ) and ( v eq s )
  // groups of 5 elements devided by ands
  if (Array.isArray(pSearchQuery) && pSearchQuery.length > 0) {
    // prepare pSearchQuery for exists and not exists, by entering dummy values
    for (var i = 1; i < pSearchQuery.length; i++) {
      if ((pSearchQuery[i] === "exists" || pSearchQuery[i] === "does not exist") && ["and", "or", ")", undefined].includes(pSearchQuery[i + 1])) {
        pSearchQuery.splice(i + 1, 0, "");
        i++;
      }
    }
    // analyse query
    var rows = [];
    var searchRestriction = [];
    for (var i = 1; i < pSearchQuery.length; i++) {
      if ((i + 1) % 6 === 0 && pSearchQuery[i] !== "and") {
        // sub querys must be clued by and's
        throw new Error("there is no support for this kind of search query, sub querys must be clued by ands");
      } else if (pSearchQuery[i] === "contains text like") {
        // make analyse model object
        // make 'value' a "string" by adding "" before
        searchRestriction.push({
          field: pSearchQuery[i - 1],
          value: "" + pSearchQuery[i + 1],
          compareType: "contains text like"
        });
      } else if (pSearchQuery[i] === "contains") {
        // make analyse model object
        // make 'value' a "string" by adding "" before
        searchRestriction.push({
          field: pSearchQuery[i - 1],
          value: "" + pSearchQuery[i + 1],
          compareType: "contains"
        });
      } else if (["equal to", "greater than", "greater than or equal to", "less than", "less than or equal to"].indexOf(pSearchQuery[i]) >= 0) {
        searchRestriction.push({
          field: pSearchQuery[i - 1],
          value: pSearchQuery[i + 1],
          compareType: pSearchQuery[i]
        });
      } else if (pSearchQuery[i] === "in") {
        searchRestriction.push({
          field: pSearchQuery[i - 1],
          value: pSearchQuery[i + 1],
          compareType: "in"
        });
      } else if (pSearchQuery[i] === "exists") {
        searchRestriction.push({
          field: pSearchQuery[i - 1],
          compareType: "exists"
        });
      } else if (pSearchQuery[i] === "does not exist") {
        searchRestriction.push({
          field: pSearchQuery[i - 1],
          compareType: "does not exist"
        });
      } else if (pSearchQuery[i] === "contains element matching") {
        searchRestriction.push({
          field: pSearchQuery[i - 1],
          value: pSearchQuery[i + 1],
          compareType: "contains element matching"
        });
      }
    }
    // control supported query
    // there are groups of 6 ( two breackes, one equation, two values and one "and")
    if ((pSearchQuery.length + 1) / 6 !== searchRestriction.length) {
      throw new Error("there is no support for this kind of search query");
    }
    // apply query
    for (var i = 0; i < pRows.length; i++) {
      var match = true;
      for (var j = 0; j < searchRestriction.length; j++) {
        // change to uppercase because "contains text like" is case free, undependend of uppercase, lowercase
        var searchValue = getField(pRows[i], searchRestriction[j].field);
        if (searchRestriction[j].compareType === "contains text like") {
          if (Array.isArray(searchValue) && searchValue.every(function (v) {
            return typeof v === "string";
          })) {
            searchValue = searchValue.join("");
          }
          if (typeof searchValue !== "string" || searchValue.toUpperCase().indexOf(searchRestriction[j].value.toUpperCase()) === -1) {
            match = false;
            break;
          }
        }
        if (searchRestriction[j].compareType === "contains") {
          if (Array.isArray(searchValue) && searchValue.every(function (v) {
            return typeof v === "string";
          })) {
            searchValue = searchValue.join("");
          }
          if (typeof searchValue !== "string" || searchValue.indexOf(searchRestriction[j].value) === -1) {
            match = false;
            break;
          }
        }
        if (searchRestriction[j].compareType === "greater than" && searchValue <= searchRestriction[j].value) {
          match = false;
          break;
        }
        if (searchRestriction[j].compareType === "greater than or equal to" && searchValue < searchRestriction[j].value) {
          match = false;
          break;
        }
        if (searchRestriction[j].compareType === "less than" && searchValue >= searchRestriction[j].value) {
          match = false;
          break;
        }
        if (searchRestriction[j].compareType === "less than or equal to" && searchValue > searchRestriction[j].value) {
          match = false;
          break;
        }
        if (searchRestriction[j].compareType === "equal to" && searchValue !== searchRestriction[j].value) {
          match = false;
          break;
        }
        if (searchRestriction[j].compareType === "in" && searchRestriction[j].value.includes(searchValue) === false) {
          match = false;
          break;
        }
        if (searchRestriction[j].compareType === "exists" && searchValue === undefined) {
          match = false;
          break;
        }
        if (searchRestriction[j].compareType === "does not exist" && searchValue !== undefined) {
          match = false;
          break;
        }
        if (searchRestriction[j].compareType === "contains element matching") {
          break;
        }
      }
      if (match) {
        rows.push(pRows[i]);
      }
    }
    pRows = rows;
  }
  pRows = Query.orderBy(pRows, pOrderBy);

  // clip results
  if (typeof pLast === "number") {
    pRows = pRows.slice(pSkip, pLast);
    pRows = pRows.slice(0, pLimit);
    return pRows;
  }
  pRows = pRows.slice(pSkip, pSkip + pLimit);
  return pRows;
};
Query.orderBy = function (pRows, pOrderBy) {
  function getField(pParent, pField) {
    return CloudflowObject.getParameter(pParent, pField);
  }
  // apply orderBy
  if (Array.isArray(pOrderBy) && pOrderBy.length > 0) {
    if (pOrderBy.length === 2) {
      var field = pOrderBy[0];
      var ascending = pOrderBy[1] === "ascending" ? 1 : -1;
      pRows.sort(function (a, b) {
        var fieldA = getField(a, field);
        // all undefineds go up, before
        if (fieldA === undefined) {
          return -1 * ascending;
        }
        var fieldB = getField(b, field);
        if (fieldB === undefined) {
          return 1 * ascending;
        }
        if (typeof fieldA === "number" && typeof fieldB === "number") {
          return fieldA > fieldB ? ascending : -ascending;
        }
        // make of a[field] a string
        // b[field] may be a number
        return ("" + getField(a, field)).localeCompare(getField(b, field)) * ascending;
      });
    } else if (pOrderBy.length === 4) {
      var field = pOrderBy[0];
      var field2 = pOrderBy[2];
      var ascending = pOrderBy[1] === "ascending" ? 1 : -1;
      var ascending2 = pOrderBy[3] === "ascending" ? 1 : -1;
      pRows.sort(function (a, b) {
        // all undefineds go up, before
        if (getField(a, field) === undefined) {
          return -1 * ascending;
        }
        if (getField(b, field) === undefined) {
          return 1 * ascending;
        }
        // make of a[field] a string
        // b[field] may be a number
        var firstCompare = ("" + getField(a, field)).localeCompare(getField(b, field)) * ascending;
        if (firstCompare === 0) {
          // all undefineds go up, before
          if (getField(a, field2) === undefined) {
            return -1 * ascending2;
          }
          if (getField(b, field2) === undefined) {
            return 1 * ascending2;
          }
          return ("" + getField(a, field2)).localeCompare(getField(b, field2)) * ascending2;
        } else {
          return firstCompare;
        }
      });
    } else {
      throw new Error('there is no support for multiple order by');
    }
  }
  return pRows;
};

/**
 * @description change the given date with a given calculation
 * Example: date, -1 day will give the date for yesterday
 * @function
 * @name Query._dateCalc
 * @private
 * @param {Date} date The date to modify
 * @param {String} calcString -xD, +xD, -xM, +xM, -xH, +xH
 * where X is a number
 * @returns {Date} The modified date. Empty string when invalid interface or no found calculations  
 */
var dateCalculations = new RegExp("([+-]) *([0-9]+) *([DMH])");
function _dateCalc(date, calcString) {
  calcString.replace(dateCalculations, function (match, p1, p2, p3) {
    switch (p3) {
      case 'H':
        if (p1 == '+') {
          date.setHours(date.getHours() + parseInt(p2));
        } else {
          date.setHours(date.getHours() - parseInt(p2));
        }
        break;
      case 'D':
        if (p1 == '+') {
          date.setDate(date.getDate() + parseInt(p2));
        } else {
          date.setDate(date.getDate() - parseInt(p2));
        }
        break;
      case 'M':
        if (p1 == '+') {
          date.setMonth(date.getMonth() + parseInt(p2));
        } else {
          date.setMonth(date.getMonth() - parseInt(p2));
        }
        break;
    }
    return '';
  });
  return date;
}

/**
 * @description prepare query for a server interface
 * Example: $_UNIX_TODAY will return the UNIX number for today
 * @function
 * @name Query.prepare
 * @static
 * @param {Array.<Object>} pRows All the rows, to be prepared
 * @returns {Array} Array The prepared rows  
 */
Query.prepare = function (pRows) {
  if (Array.isArray(pRows) === false) {
    throw new Error("parameter pRows must be an array");
  }
  var rows = pRows.slice(),
    today,
    now;
  for (var i = 0; i < rows.length; i++) {
    if (typeof rows[i] === "string" && rows[i][0] === "$") {
      // calc today and use as cache, prevent multiple different dates in one query
      now = now || new Date();
      if (today === undefined) {
        today = new Date();
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);
      }
      if (rows[i].indexOf(QueryPredefinedKeys.ISO_NOW) === 0) {
        var date = new Date(+now); // clone date
        var rest = rows[i].substring(QueryPredefinedKeys.ISO_NOW.length);
        if (rest.length > 0) {
          date = _dateCalc(date, rest);
        }
        // ISO date none extended
        rows[i] = date.toISOString().substring(0, 19) + "Z";
      } else if (rows[i].indexOf(QueryPredefinedKeys.UNIX_NOW) === 0) {
        var date = new Date(+now); // clone date
        var rest = rows[i].substring(QueryPredefinedKeys.UNIX_NOW.length);
        if (rest.length > 0) {
          date = _dateCalc(date, rest);
        }
        rows[i] = parseInt(+date / 1000);
      } else if (rows[i].indexOf(QueryPredefinedKeys.UNIXMILLISEC_NOW) === 0) {
        var date = new Date(+now); // clone date
        var rest = rows[i].substring(QueryPredefinedKeys.UNIXMILLISEC_NOW.length);
        if (rest.length > 0) {
          date = _dateCalc(date, rest);
        }
        rows[i] = +date;
      } else if (rows[i].indexOf(QueryPredefinedKeys.ISO_TODAY) === 0) {
        var date = new Date(+today); // clone date
        var rest = rows[i].substring(QueryPredefinedKeys.ISO_TODAY.length);
        if (rest.length > 0) {
          date = _dateCalc(date, rest);
        }
        // ISO date none extended
        rows[i] = date.toISOString().substring(0, 19) + "Z";
      } else if (rows[i].indexOf(QueryPredefinedKeys.UNIX_TODAY) === 0) {
        var date = new Date(+today); // clone date
        var rest = rows[i].substring(QueryPredefinedKeys.UNIX_TODAY.length);
        if (rest.length > 0) {
          date = _dateCalc(date, rest);
        }
        rows[i] = parseInt(+date / 1000);
      } else if (rows[i].indexOf(QueryPredefinedKeys.UNIXMILLISEC_TODAY) === 0) {
        var date = new Date(+today); // clone date
        var rest = rows[i].substring(QueryPredefinedKeys.UNIXMILLISEC_TODAY.length);
        if (rest.length > 0) {
          date = _dateCalc(date, rest);
        }
        rows[i] = +date;
      }
    }
  }
  return rows;
};
Query.prototype = {
  constructor: Query,
  /**
   * @description Get the main start query, not the search query
   * @function
   * @name Query#getMainQuery
   * @returns {Array.<String>}
   */
  getMainQuery: function getMainQuery() {
    return this.query.slice();
  },
  /**
   * @description Get the search query in array format. 
   * This is not the main query, but only the search query.
   * @function
   * @name Query#getSearchQuery
   * @returns {Array} - the search query
   */
  getSearchQuery: function getSearchQuery() {
    return this.searchQuery;
  },
  /**
   * @description Replace the current search query to the query from the inputparameter.
   * The main query stay untouched.
   * @function
   * @name Query#setSearchQuery
   * @throws {type} if the inputparameter pQuery is not a well formed query array
   * @param {array} pQuery - the search query
   * @returns {undefined}
   */
  setSearchQuery: function setSearchQuery(pQuery) {
    var errorMessage = Query.hasGoodInterface(pQuery);
    if (errorMessage !== true) {
      throw new Error(errorMessage);
    }
    this.searchQuery = pQuery.slice();
  },
  /**
   * @description is the quesry the same or not?
   * @function
   * @name Query#isSameSearchQuery 
   * @param {Array} pQuery 
   * @returns Boolean true if query is the same
   */
  isSameSearchQuery: function isSameSearchQuery(pQuery) {
    if (this.searchQuery.length !== pQuery.length) {
      return false;
    }
    for (var i = 0; i < this.searchQuery.length; i++) {
      if (this.searchQuery[i] !== pQuery[i]) {
        return false;
      }
    }
    return true;
  },
  getSelectionQuery: function getSelectionQuery() {
    return this.selectionQuery.slice();
  },
  setSelectionQuery: function setSelectionQuery(pQuery) {
    var errorMessage = Query.hasGoodInterface(pQuery);
    if (errorMessage !== true) {
      throw new Error(errorMessage);
    }
    this.selectionQuery = pQuery.slice();
  },
  /**
   * @description Concat a query array at the end of the main query.
   * The searchquery stays untouched.
   * @function
   * @name Query#concat 
   * @param {Array} pQuery the query array to concat add the main query
   * @returns {nixps-cloudflow-Query_L8.Query.prototype}
   */
  concat: function concat(pQuery) {
    this.query = Query.concatQuery(this.query, pQuery);
    return this;
  },
  /**
   * @description Returns the query in array format. This is a concatenation between the main query and the search query
   * @function
   * @name Query#getQuery
   * @returns {array}
   */
  getQuery: function getQuery() {
    if (this.selectionQuery.length === 0) {
      return Query.concatQuery(this.query, this.searchQuery);
    } else {
      return Query.concatQuery(this.selectionQuery, this.searchQuery);
    }
  }
};
module.exports = Query;
if (window.Query === undefined) {
  window.Query = Query;
}

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"../../CloudflowUtil/js/QueryPredefinedKeys.js":92}],212:[function(require,module,exports){
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
'use strict';

var Storage = require("../../CloudflowUtil/js/ContextStorage.js");
/**
 * @description technical key to identifier the data in the browser storage
 * @type {String}
 * @default "nixps.cloudflow.Table.config"
 * @private
 * @static
 */
var kTableStorageID = "nixps.cloudflow.Table.config";
function containsSameValues(pArrayA, pArrayB) {
  if (pArrayA.length !== pArrayB.length) {
    return false;
  }
  for (var i = 0; i < pArrayA.length; i++) {
    if (pArrayA[i] !== pArrayB[i]) {
      return false;
    }
  }
  return true;
}
function hashCode(pString) {
  var hash = 0,
    i,
    chr;
  if (pString.length === 0) {
    return hash;
  }
  for (i = 0; i < pString.length; i++) {
    chr = pString.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
}
;
/**
 * @constructor TableConfig
 * @description The component retrieve, save and returns the table user configurations. Those are settings specialy for that specific user
 * @version 1.0.0
 * @private
 */
var TableConfig = function TableConfig(pTableID, pColumns) {
  this.columns = [];
  this.defaultColumnsToShow = [];
  this.tableID = pTableID;
  this._setColumns(pColumns);
  this._calcDefaultColumnsToShow();
  if (Storage.isSupport() === false) {
    console.error("Web API Storage is not supported");
    this._retrieve = this._retrieveIfStorageNoSupport;
    this.save = function () {};
  }
  this.columnsToShow = null;
  this._retrieve();
};
TableConfig.prototype = {
  constructor: TableConfig,
  _setColumns: function _setColumns(pColumns) {
    if (Array.isArray(pColumns) === false) {
      throw new Error("columns must be an array");
    }
    // make deep copy, pColumns can contain DOM Elements and structureClone can not handle them
    this.columns = $.extend(true, [], pColumns);
  },
  _calcDefaultColumnsToShow: function _calcDefaultColumnsToShow() {
    this.defaultColumnsToShow = [];
    for (var i = 0; i < this.columns.length; i++) {
      this.defaultColumnsToShow.push(this.columns[i].show !== false);
    }
  },
  getColumnsToShow: function getColumnsToShow() {
    if (this.columnsToShow === null) {
      return this.defaultColumnsToShow.slice();
    }
    return this.columnsToShow.slice();
  },
  setColumnsToShow: function setColumnsToShow(pColumns) {
    this.columnsToShow = pColumns;
  },
  _isDefault: function _isDefault() {
    return this.columnsToShow === null || containsSameValues(this.columnsToShow, this.defaultColumnsToShow);
  },
  clear: function clear() {
    this.columnsToShow = null;
    if (typeof this.tableID === "string" && this.tableID.length > 0) {
      Storage.remove(this.tableID, kTableStorageID);
    }
  },
  _retrieve: function _retrieve() {
    if (typeof this.tableID === "string" && this.tableID.length > 0) {
      var prevColumns = Storage.read(this.tableID, false, kTableStorageID);
      if (Array.isArray(prevColumns)) {
        if (prevColumns.length !== this.columns.length) {
          console.warn("old config found for table, clear saved config");
          this.clear();
        } else {
          this.columnsToShow = [];
          for (var i = 0; i < this.columns.length; i++) {
            if (prevColumns[i] === undefined || prevColumns[i].key !== this.columns[i].key) {
              // table columns settup has changed during last save, clear all settings
              console.warn("old config found for table, clear saved config");
              this.clear();
              break;
            }
            this.columnsToShow.push(prevColumns[i].show == true);
          }
        }
      }
    }
  },
  _retrieveIfStorageNoSupport: function _retrieveIfStorageNoSupport() {
    // if there is no support for storage, use the defined default values
    if (Array.isArray(this.defaultColumnsToShow) && this.defaultColumnsToShow.length > 0) {
      this.columnsToShow = this.defaultColumnsToShow.slice();
    }
  },
  save: function save() {
    if (typeof this.tableID === "string" && this.tableID.length > 0) {
      // only save if there is a change and different then default
      if (this._isDefault() === false) {
        // remove all settings who are not read the last year
        var yearMilleSec = 350 * 24 * 3600 * 1000;
        var dataToSave = [];
        for (var i = 0; i < this.columns.length; i++) {
          dataToSave.push({
            "key": this.columns[i].key,
            "show": this.columnsToShow[i] == true
          });
        }
        var returnValue = Storage.update(dataToSave, this.tableID, kTableStorageID, 0, yearMilleSec);
        if (returnValue === null) {
          // if we could not update, the element does not exists, so create it.
          return Storage.write(dataToSave, this.tableID, kTableStorageID, 0, yearMilleSec);
        }
      } else {
        // remove if data is equal to default, this is the same setup if no values are found
        Storage.remove(this.tableID, kTableStorageID);
      }
    }
  }
};
module.exports = TableConfig;

},{"../../CloudflowUtil/js/ContextStorage.js":82}],213:[function(require,module,exports){
"use strict";

var WhitepaperConnection = require("../../CloudflowUtil/js/WhitepaperConnection.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");

/**
 * @constructor WhitepaperCRUD
 * @description A handler to have a CRUD by whitepapers
 * @private
 * @param {pWhitepaper} The name of the whitepaper
 * @param {pWhitepaperNameInput} The input name 
 */
var WhitepaperCRUD = function WhitepaperCRUD(pWhitepaper, pWhitepaperNameInput, pType) {
  this._setWhitepaperName(pWhitepaper);
  this._setWhitepaperInputName(pWhitepaperNameInput);
  this.runningConnections = [];
  this.nonAbortableConnections = [];
  this.setType(pType);
};
WhitepaperCRUD.fromJSON = function (json) {
  return new WhitepaperCRUD(json.whitepaper_name, json.input_name, json.type);
};
WhitepaperCRUD.prototype = {
  constructor: WhitepaperCRUD,
  _setWhitepaperName: function _setWhitepaperName(pWhitepaperName) {
    if (typeof pWhitepaperName !== "string" || pWhitepaperName.length <= 0) {
      throw new Error("_setWhitepaperName: parameter WhitepaperName must be a not empty string");
    }
    this.whitepaper = pWhitepaperName;
  },
  _setWhitepaperInputName: function _setWhitepaperInputName(pWhitepaperInputName) {
    if (typeof pWhitepaperInputName !== "string" || pWhitepaperInputName.length <= 0) {
      throw new Error("_setWhitepaperInputName: parameter WhitepaperinputName must be a not empty string");
    }
    this.whitepaperInputName = pWhitepaperInputName;
  },
  create: function create(pObject, pGoodCallBack, pBadCallBack) {
    if (this.type === "startFrom") {
      return this._call([pObject], "create", {}, 2, function (pResult) {
        if (pResult !== undefined && pResult.document !== undefined && Object.keys(pResult).length === 1) {
          pGoodCallBack(pResult.document);
        } else {
          pGoodCallBack(pResult);
        }
      }, pBadCallBack);
    } else {
      var inputparameters = {
        action: "create",
        query: null,
        orderby: null,
        fields: null,
        options: {},
        id: null,
        object: pObject
      };
      return this._call(inputparameters, undefined, {}, 3, function (pResult) {
        if (pResult !== undefined && pResult.document !== undefined && Object.keys(pResult).length === 1) {
          pGoodCallBack(pResult.document);
        } else {
          pGoodCallBack(pResult);
        }
      }, pBadCallBack);
    }
  },
  list_with_options: function list_with_options(pQuery, pOrderby, pFields, pOptions, pGoodCallBack, pBadCallBack) {
    if (this.type === "startFrom") {
      return this._call([pQuery, pOrderby, pFields], "list", pOptions, 1, function (pResults) {
        if (pResults !== undefined && Array.isArray(pResults.documents)) {
          pGoodCallBack({
            results: pResults.documents
          });
        } else {
          pBadCallBack({
            error: "database_proxy list",
            error_code: "database_proxy_list_wrong_returninterface"
          });
        }
      }, pBadCallBack);
    } else {
      var inputparameters = {
        action: "list_with_options",
        query: pQuery,
        orderby: pOrderby,
        fields: pFields,
        options: pOptions,
        id: null,
        object: null
      };
      return this._call(inputparameters, undefined, {}, 3, pGoodCallBack, pBadCallBack);
    }
  },
  get: function get(pID, pGoodCallBack, pBadCallBack) {
    if (this.type === "startFrom") {
      return this._call([pID], "get", {}, 3, function (pResult) {
        if (pResult !== undefined && pResult.document !== undefined && Object.keys(pResult).length === 1) {
          pGoodCallBack(pResult.document);
        } else {
          pGoodCallBack(pResult);
        }
      }, pBadCallBack);
    } else {
      var inputparameters = {
        action: "get",
        query: null,
        orderby: null,
        fields: null,
        options: null,
        id: pID,
        object: null
      };
      return this._call(inputparameters, undefined, {}, 3, function (pResult) {
        if (pResult !== undefined && pResult.document !== undefined && Object.keys(pResult).length === 1) {
          pGoodCallBack(pResult.document);
        } else {
          pGoodCallBack(pResult);
        }
      }, pBadCallBack);
    }
  },
  count: function count(pQuery, pGoodCallBack, pBadCallBack) {
    if (this.type === "startFrom") {
      return this._call([pQuery], "count", {}, 1, pGoodCallBack, pBadCallBack);
    } else {
      var inputparameters = {
        action: "count",
        query: pQuery,
        orderby: null,
        fields: null,
        options: null,
        id: null,
        object: null
      };
      return this._call(inputparameters, undefined, {}, 3, pGoodCallBack, pBadCallBack);
    }
  },
  update: function update(pObject, pGoodCallBack, pBadCallBack) {
    if (this.type === "startFrom") {
      return this._call([pObject], "update", {}, 2, function (pResult) {
        if (pResult !== undefined && pResult.document !== undefined && Object.keys(pResult).length === 1) {
          pGoodCallBack(pResult.document);
        } else {
          pGoodCallBack(pResult);
        }
      }, pBadCallBack);
    } else {
      var inputparameters = {
        action: "update",
        query: null,
        orderby: null,
        fields: null,
        options: {},
        id: null,
        object: pObject
      };
      return this._call(inputparameters, undefined, {}, 3, function (pResult) {
        if (pResult !== undefined && pResult.document !== undefined && Object.keys(pResult).length === 1) {
          pGoodCallBack(pResult.document);
        } else {
          pGoodCallBack(pResult);
        }
      }, pBadCallBack);
    }
  },
  set_keys: function set_keys(pID, pKeyData, pOptions, pGoodCallBack, pBadCallBack) {
    if (this.type === "startFrom") {
      //throw new Error("unsupported set_keys for DBIO");
      //return this._call([pID, pKeyData], "set_keys", {}, 2, pGoodCallBack, pBadCallBack);
      var that = this;
      var outputDef = Promise.withResolvers();
      this.get(pID, function (pResult) {
        for (var key in pKeyData) {
          pResult = CloudflowObject.setParameter(pResult, key, pKeyData[key]);
        }
        that.update(pResult, function (pReturnResult) {
          pGoodCallBack(pReturnResult);
          outputDef.resolve(pReturnResult);
        }, function (pError) {
          pBadCallBack(pError);
          outputDef.reject(pError);
        });
      }, function (pError) {
        pBadCallBack(pError);
        outputDef.reject(pError);
      });
      return outputDef.promise;
    } else {
      var inputparameters = {
        action: "set_keys",
        query: null,
        orderby: null,
        fields: null,
        options: null,
        id: pID,
        object: pKeyData
      };
      if (pOptions.oldKeyData !== undefined) {
        inputparameters.old_key_data = pOptions.oldKeyData;
      }
      return this._call(inputparameters, undefined, {}, 3, pGoodCallBack, pBadCallBack);
    }
  },
  set_keys_by_query: function set_keys_by_query(pQuery, pKeyData, pOptions, pGoodCallBack, pBadCallBack) {
    if (this.type === "startFrom") {
      //throw new Error("unsupported set_keys_by_query for DBIO");
      //return this._call([pQuery, pKeyData, pOptions], "set_keys_by_query", {}, 2, pGoodCallBack, pBadCallBack);
      var that = this;
      var outputDef = Promise.withResolvers();
      this.list_with_options(pQuery, [], [], pOptions, function (pResult) {
        var dataDefs = [];
        if (pResult !== undefined && Array.isArray(pResult.results)) {
          for (var i = 0; i < pResult.results.length; i++) {
            for (var key in pKeyData) {
              pResult.results[i] = CloudflowObject.setParameter(pResult.results[i], key, pKeyData[key]);
            }
            (function (index) {
              dataDefs.push(new Promise(function (pResolve, pReject) {
                that.update(pResult.results[index], pResolve, pReject);
              }));
            })(i);
          }
        }
        Promise.allSettled(dataDefs).then(function () {
          pGoodCallBack({});
          outputDef.resolve({});
        }, function (pError) {
          pGoodCallBack({});
          outputDef.resolve({});
        });
      }, function (pError) {
        pBadCallBack(pError);
        outputDef.reject(pError);
      });
      return outputDef.promise;
    } else {
      var inputparameters = {
        action: "set_keys_by_query",
        query: pQuery,
        orderby: null,
        fields: null,
        options: pOptions,
        id: null,
        object: pKeyData
      };
      return this._call(inputparameters, undefined, {}, 3, pGoodCallBack, pBadCallBack);
    }
  },
  "delete": function _delete(pID, pGoodCallBack, pBadCallBack) {
    if (this.type === "startFrom") {
      return this._call([pID], "delete", {}, 2, pGoodCallBack, pBadCallBack);
    } else {
      var inputparameters = {
        action: "delete",
        query: null,
        orderby: null,
        fields: null,
        options: null,
        id: pID,
        object: null
      };
      return this._call(inputparameters, undefined, {}, 3, pGoodCallBack, pBadCallBack);
    }
  },
  delete_by_query: function delete_by_query(pQuery, pGoodCallBack, pBadCallBack) {
    if (this.type === "startFrom") {
      if (pQuery.length > 0) {
        /** @todo not tested !! */
        if (pQuery.length === 3 && pQuery[0] === "_id" && pQuery[1] === "equal to") {
          return this._call([pQuery[2]], "delete", {}, 2, pGoodCallBack, pBadCallBack);
        } else if (pQuery.length === 3 && pQuery[0] === "_id" && pQuery[1] === "in" && Array.isArray(pQuery[2])) {
          var defIDs = [],
            that = this;
          for (var i = 0; i < pQuery[2].length; i++) {
            (function (index) {
              defIDs.push(new Promise(function (pResolve, pReject) {
                that._call([pQuery[2][index]], "delete", {}, 2, pResolve, pReject);
              }));
            })(i);
          }
          return Promise.allSettled(defIDs).then(function (pResults) {
            var firstFailing = pResults.find(function (r) {
              return r.status === "rejected";
            });
            if (firstFailing) {
              pBadCallBack(firstFailing.reason);
            } else {
              pGoodCallBack({
                deleted_ids: pQuery[2]
              });
            }
          });
        } else {
          pBadCallBack({
            error_code: "wrong_input_format",
            error: "the input format is wrong"
          });
        }
      } else {
        pBadCallBack({
          error_code: "wrong_input_format",
          error: "the input format is wrong"
        });
      }
    } else {
      var inputparameters = {
        action: "delete_by_query",
        query: pQuery,
        orderby: null,
        fields: null,
        options: {},
        id: null,
        object: null
      };
      return this._call(inputparameters, undefined, {}, 3, pGoodCallBack, pBadCallBack);
    }
  },
  _call: function _call(pParameters, pFunctionName, pOptions, pStartPollingTime, pGoodCallBack, pBadCallBack) {
    var longLive = ["delete", "delete_by_query", "update", "create", "set_keys", "set_keys_by_query"].indexOf(pFunctionName) >= 0;
    if (this.type === "startFrom") {
      var that = this;
      var type = {
        connectionType: "database_proxy",
        connectionFunctionName: pFunctionName,
        connectionCallOptions: pOptions
      };
      var connection = new WhitepaperConnection(this.whitepaper, this.whitepaperInputName, pParameters, type, longLive);
      connection.setStartPollingTime(pStartPollingTime);
      this._addRunningConnection(connection, longLive === false);
      return Promise.resolve(connection.start()).then(pGoodCallBack, function (pError) {
        pBadCallBack(pError);
        return Promise.reject(pError);
      })["finally"](function () {
        that._removeRunningConnection(connection);
      });
    } else {
      var connection = new WhitepaperConnection(this.whitepaper, this.whitepaperInputName, pParameters, undefined, longLive);
      return connection.httpService().then(pGoodCallBack, function (pError) {
        pBadCallBack(pError);
        return Promise.reject(pError);
      });
    }
  },
  setType: function setType(pType) {
    if (pType === "httpService") {
      this.type = "httpService";
    } else {
      // default value
      this.type = "startFrom";
    }
  },
  getType: function getType() {
    return this.type;
  },
  _addRunningConnection: function _addRunningConnection(pConnection, pAbortable) {
    if (pAbortable === true) {
      this.runningConnections.push(pConnection);
    } else {
      // may not abort
      this.nonAbortableConnections.push(pConnection);
    }
  },
  _removeRunningConnection: function _removeRunningConnection(pConnection) {
    for (var i = 0; i < this.runningConnections.length; i++) {
      if (this.runningConnections[i] === pConnection) {
        this.runningConnections.splice(i, 1);
        return i;
      }
    }
    for (var i = 0; i < this.nonAbortableConnections.length; i++) {
      if (this.nonAbortableConnections[i] === pConnection) {
        this.nonAbortableConnections.splice(i, 1);
        return i;
      }
    }
    return -1;
  },
  stop: function stop(pReason) {
    for (var i = 0; i < this.runningConnections.length; i++) {
      this.runningConnections[i].stop(pReason);
    }
    this.runningConnections = [];
  },
  countRunningConnections: function countRunningConnections() {
    return this.runningConnections.length + this.nonAbortableConnections.length;
  },
  toJSON: function toJSON() {
    return {
      whitepaper_name: this.whitepaper,
      input_name: this.whitepaperInputName,
      type: this.type
    };
  },
  clone: function clone() {
    return WhitepaperCRUD.fromJSON(this.toJSON());
  }
};
module.exports = WhitepaperCRUD;

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"../../CloudflowUtil/js/WhitepaperConnection.js":93}],214:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jul 5, 2018 2:35:33 PM
 */
(function ($) {
  require("../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js");
  require("../../../common/DropdownList/js/nixps-DropdownList.js");
  var QueryApplier = require("../../CloudflowUtil/js/QueryApplier.js");

  /**
   * @namespace nixps-cloudflow.ButtonsBarTableExtension
   * @description Draw a topbar of buttons for a table or other items manager
   * @private
   * @example $("<div>").ButtonsBarTableExtension({});
   * @version 2.0.1
   */
  $.widget("nixps-cloudflow.ButtonsBarTableExtension", $.Widget, {
    widgetEventPrefix: "buttonsbartableextension",
    version: "2.0.1",
    options: {
      /**
       * @description the array containing all the info about buttons
       * @name nixps-cloudflow.ButtonsBarTableExtension#buttons
       * @type {Array}
       * @default []
       */
      buttons: [],
      /**
       * @description The type of styling to be applied on the buttons
       * @name nixps-cloudflow.ButtonsBarTableExtension#buttons_style_type
       * @type {String}
       * @private
       * @default "CloudflowStyle_defaulttopbarbutton"
       */
      buttons_style_type: "CloudflowStyle_defaulttopbarbutton",
      /**
       * @description The jquery DOM element of the table component where he can find the seleced rows
       * @name nixps-cloudflow.ButtonsBarTableExtension#listDOM
       * @type {jQueryDOMElement}
       * @since 2.0.0
       */
      listDOM: $("body"),
      /**
       * @description The selector of the list / table
       * @name nixps-cloudflow.ButtonsBarTableExtension#listSelector
       * @type {String}
       * @default ".nixps-cloudflow-Table"
       * @since 2.0.0
       */
      listSelector: ".nixps-cloudflow-Table",
      /**
       * @description The component name of the list / table
       * @name nixps-cloudflow.ButtonsBarTableExtension#listComponentName
       * @type {String}
       * @default "Table"
       * @since 2.0.0
       */
      listComponentName: "Table",
      /**
       * @description The name of the get rows methode
       * @name nixps-cloudflow.ButtonsBarTableExtension#listgetRowsMethodeName
       * @type {String}
       * @default "getSelectedRows"
       * @since 2.0.0
       */
      listgetRowsMethodeName: "getSelectedRows",
      /**
       * @description The name of the get rows ids methode
       * @name nixps-cloudflow.ButtonsBarTableExtension#listgetRowIDsMethodeName
       * @type {String}
       * @default "getSelectedRowIDs"
       * @since 2.0.0
       */
      listgetRowIDsMethodeName: "getSelectedRowIDs"
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.ButtonsBarTableExtension#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("nixps-cloudflow-TableMenuActions").attr("data-uuid", this.uuid);
      // variables
      this.queryAppliers = [];
      this._draw();
      if (this.options.listComponentName === "Table") {
        this._on(this.options.listDOM, {
          "tabledataloaded": this._tableDataLoaded,
          "tableselect": this._rowSelectHandler
        });
      } else if (this.options.listComponentName === "CustomPageComponentDynamicList") {
        this._on(this.options.listDOM, {
          "custompagecomponentdynamiclistupdate": this._rowSelectHandler,
          "custompagecomponentdynamiclistselect": this._rowSelectHandler
        });
      }
      this._on(this.element, {
        "click .bbte_topbar button:not([disabled]):not(.cf-tablebutton-sub_menu)": this._buttonTopbarClickHandler
      });
    },
    /**
     * @description function runs when the table loaded new data
     * @function
     * @private
     * @name nixps-cloudflow.ButtonsBarTableExtension#_tableDataLoaded
     * @param {type} pEvent
     * @param {type} pData
     * @returns {Boolean}
     */
    _tableDataLoaded: function _tableDataLoaded(pEvent, pData) {
      if (pData !== undefined && pData.wrongReturnOrder === true) {
        // rows didn't change
        return true;
      }
      this._rowSelectHandler(pEvent, pData);
    },
    /**
     * @description function runs when user change the selection of the rows
     * @function
     * @name nixps-cloudflow.ButtonsBarTableExtension#_rowSelectHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _rowSelectHandler: function _rowSelectHandler(pEvent, pData) {
      // first check if change come from maintable and not from a child
      if ($(pEvent.target).closest(this.options.listSelector).is(this.options.listDOM) === false) {
        return; // select comes from child, ignore
      }

      this.updateButtons();
    },
    /**
     * @description function runs when user clicked on one of the top bar buttons
     * @function
     * @name nixps-cloudflow.ButtonsBarTableExtension#_buttonTopbarClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _buttonTopbarClickHandler: function _buttonTopbarClickHandler(pEvent, pData) {
      if (this._isEventFromTableComponent(pEvent) === false) {
        return true;
      }
      var button = $(pEvent.target).closest(".nixps-pagebuilder-CloudflowButton");
      var rows = this._getSelectedRowsIDs();
      if (Array.isArray(rows)) {
        var action = button.CloudflowButton("option", "action");
        var actionname = button.CloudflowButton("option", "actionname");
        if (typeof action === "string" && action.length > 0 && typeof actionname === "string" && actionname.length > 0) {
          this._trigger(action, null, {
            ids: rows,
            action: actionname
          });
        } else {
          console.error("ButtonsBarTableExtension: empty action found");
        }
      }
    },
    _isEventFromTableComponent: function _isEventFromTableComponent(pEvent) {
      return $(pEvent.target).closest("." + this.widgetFullName).attr("data-uuid") == this.uuid;
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.ButtonsBarTableExtension#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.ButtonsBarTableExtension#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      // reset
      this.element.empty();
      this.queryAppliers = [];
      // draw
      var topbar = $("<div>").addClass("bbte_topbar");
      this.element.append(topbar);
      var topbarButtons = this.options.buttons;
      for (var i = 0; i < topbarButtons.length; i++) {
        if (topbarButtons[i].show === false) {
          continue;
        }
        if (typeof topbarButtons[i].activation_type !== "string" || topbarButtons[i].activation_type.length <= 0) {
          topbarButtons[i].activation_type = "always";
        }
        var activationType = topbarButtons[i].activation_type;
        topbarButtons[i].disabled = ["single", "multiple", "one_or_more", "dynamic", "dynamic_one"].includes(activationType);
        if (typeof topbarButtons[i].classes === "string") {
          if (topbarButtons[i].classes.indexOf(this.options.buttons_style_type) === -1) {
            // add space to separat from other classes
            topbarButtons[i].classes = this.options.buttons_style_type + " " + topbarButtons[i].classes;
          }
        } else {
          topbarButtons[i].classes = this.options.buttons_style_type;
        }
        if (topbarButtons[i].predefinedType && topbarButtons[i].predefinedType === "button_group") {
          var subButton;
          var menu = $("<div>").addClass("nixps-pagebuilder-CloudflowButton-DropDownButtons").DropdownList({
            "buttonClass": topbarButtons[i].classes += " cf-button-topbar cf-tablebutton-sub_menu",
            "buttonText": topbarButtons[i].label,
            "buttonIcon": topbarButtons[i].icon,
            "buttonTooltip": topbarButtons[i].tooltip,
            "mainButtonActivationType": topbarButtons[i].activation_type,
            "classes": {
              "dropdownlist-actionlist": "nixps_styling_constants_bodybackground cf-dropdown cf-dropdown-checkable noselect",
              "dropdownlist-mainbutton": "buttonsbartableextension-maindropdownbutton"
            }
          });
          if (Array.isArray(topbarButtons[i].sub_buttons) && topbarButtons[i].sub_buttons.length > 0) {
            for (var s = 0; s < topbarButtons[i].sub_buttons.length; s++) {
              if (topbarButtons[i].sub_buttons[s].show === false) {
                continue;
              }
              topbarButtons[i].sub_buttons[s].classes = topbarButtons[i].sub_buttons[s].classes + " cf-tablebutton-sub_button";
              subButton = this._createButtonDOM(topbarButtons[i].sub_buttons[s], topbarButtons[i]);
              menu.DropdownList("addListItemAppendComponent", subButton.addClass("cf-dropdown-item-block"));
            }
          }
          if (["dynamic", "dynamic_one"].includes(topbarButtons[i].activation_type)) {
            var button = menu.find(".buttonsbartableextension-maindropdownbutton");
            if (Array.isArray(topbarButtons[i].activation_query)) {
              this.queryAppliers.push(new QueryApplier(topbarButtons[i].activation_query));
              button.attr("data-queryapplier-index", this.queryAppliers.length - 1);
            } else {
              console.error("invalid topbarbutton: an query is required");
              // fallback to always
              button.attr("data-activationtype", "always");
            }
          }
          topbar.append(menu);
        } else {
          topbarButtons[i].classes += " cf-button-topbar";
          var button = $("<div>").CloudflowButton(topbarButtons[i]).attr("data-activationtype", activationType);
          if (["dynamic", "dynamic_one"].includes(activationType)) {
            if (Array.isArray(topbarButtons[i].activation_query)) {
              this.queryAppliers.push(new QueryApplier(topbarButtons[i].activation_query));
              button.attr("data-queryapplier-index", this.queryAppliers.length - 1);
            } else {
              console.error("invalid topbarbutton: an query is required");
              // fallback to always
              button.attr("data-activationtype", "always");
            }
          }
          topbar.append(button);
        }
      }
    },
    _createButtonDOM: function _createButtonDOM(pButtonJSON, pParentButton) {
      if (typeof pButtonJSON.activation_type !== "string" || pButtonJSON.activation_type.length <= 0) {
        pButtonJSON.activation_type = "always";
      }
      var activationType = pButtonJSON.activation_type;
      pButtonJSON.disabled = ["single", "multiple", "one_or_more", "dynamic", "dynamic_one"].includes(activationType);
      if (typeof pButtonJSON.classes === "string") {
        if (pButtonJSON.classes.indexOf(this.options.buttons_style_type) === -1) {
          // add space to separat from other classes
          pButtonJSON.classes = this.options.buttons_style_type + " " + pButtonJSON.classes;
        }
      } else {
        pButtonJSON.classes = this.options.buttons_style_type;
      }
      pButtonJSON.classes += " cf-button-topbar";
      var button = $("<div>").CloudflowButton(pButtonJSON).attr("data-activationtype", activationType);
      if (activationType === "dynamic" || activationType === "dynamic_one") {
        if (Array.isArray(pButtonJSON.activation_query)) {
          this.queryAppliers.push(new QueryApplier(pButtonJSON.activation_query));
          button.attr("data-queryapplier-index", this.queryAppliers.length - 1);
        } else {
          console.error("invalid topbarbutton: an query is required");
          // fallback to always
          button.attr("data-activationtype", "always");
        }
      }
      return button;
    },
    updateButtons: function updateButtons() {
      var that = this;
      var rows = this._getSelectedRowsIDs();
      if (Array.isArray(rows)) {
        this.element.children(".bbte_topbar").find(".nixps-pagebuilder-CloudflowButton").not("[data-activationtype=always]").CloudflowButton("disable");
        //find sub buttons
        // this.element.children(".bbte_topbar").find(".dropdownlist-actionlist").find(".nixps-pagebuilder-CloudflowButton").not("[data-activationtype=always]").CloudflowButton("disable");
        if (rows.length === 0) {
          this.element.children(".bbte_topbar").children("[data-activationtype=none]").CloudflowButton("enable");
          //find sub buttons
          this.element.children(".bbte_topbar").find("[data-activationtype=none]").CloudflowButton("enable");
        } else if (rows.length === 1) {
          this.element.children(".bbte_topbar").children("[data-activationtype=single]").CloudflowButton("enable");
          //find sub buttons
          this.element.children(".bbte_topbar").find("[data-activationtype=single]").CloudflowButton("enable");
          this.element.children(".bbte_topbar").children("[data-activationtype=one_or_more]").CloudflowButton("enable");
          //find sub buttons
          this.element.children(".bbte_topbar").find("[data-activationtype=one_or_more]").CloudflowButton("enable");

          // dynamic one
          var dynamicList = this.element.children(".bbte_topbar").find("[data-activationtype=dynamic_one]").add(this.element.children(".bbte_topbar").find(".dropdownlist-actionlist").children("[data-activationtype=dynamic_one]"));
          dynamicList.each(function () {
            var rowsObjects = that._getSelectedItems();
            var index = $(this).attr("data-queryapplier-index");
            if (typeof index === "string" && index.length > 0) {
              index = parseInt(index);
            }
            if (that.queryAppliers[index] === undefined) {
              console.error("missing queryApplier");
              return true;
            }
            if (that.queryAppliers[index].validate(rowsObjects[0])) {
              $(this).CloudflowButton("enable");
            }
          });
        } else if (rows.length > 1) {
          this.element.children(".bbte_topbar").children("[data-activationtype=multiple]").CloudflowButton("enable");
          // find sub buttons
          this.element.children(".bbte_topbar").find("[data-activationtype=multiple]").CloudflowButton("enable");
          this.element.children(".bbte_topbar").children("[data-activationtype=one_or_more]").CloudflowButton("enable");
          // find sub buttons
          this.element.children(".bbte_topbar").find("[data-activationtype=one_or_more]").CloudflowButton("enable");
        }
        // multiple dynamic
        if (rows.length !== 0 && (this.element.children(".bbte_topbar").find("[data-activationtype=dynamic]").length > 0 || this.element.children(".bbte_topbar").find(".dropdownlist-actionlist").children("[data-activationtype=dynamic]").length > 0)) {
          var rowsObjects = this._getSelectedItems();
          var multi_dynamic = this.element.children(".bbte_topbar").find("[data-activationtype=dynamic]").add(this.element.children(".bbte_topbar").find("[data-activationtype=dynamic]"));
          multi_dynamic.each(function () {
            var index = $(this).attr("data-queryapplier-index");
            if (typeof index === "string" && index.length > 0) {
              index = parseInt(index);
            }
            if (that.queryAppliers[index] === undefined) {
              console.error("missing queryApplier");
              return true;
            }
            var validRows = that.queryAppliers[index].apply(rowsObjects);
            if (validRows.length === rowsObjects.length) {
              $(this).CloudflowButton("enable");
            }
          });
        }
      }
    },
    _getSelectedRowsIDs: function _getSelectedRowsIDs() {
      return this.options.listDOM[this.options.listComponentName](this.options.listgetRowIDsMethodeName);
    },
    _getSelectedItems: function _getSelectedItems() {
      return this.options.listDOM[this.options.listComponentName](this.options.listgetRowsMethodeName);
    },
    _arrangeButtonGroups: function _arrangeButtonGroups() {
      var finalButtons = [];
      var buttonGroups = {};
      for (var i = 0; this.options.buttons.length > i; i++) {
        if (this.options.buttons[i].buttonGroup) {
          if (Object.keys(buttonGroups).indexOf(this.options.buttons[i].buttonGroup) > -1) {
            buttonGroups[this.options.buttons[i].buttonGroup].push(this.options.buttons[i]);
          } else {
            buttonGroups[this.options.buttons[i].buttonGroup] = {
              "label": this.options.buttons[i].buttonGroup,
              "classes": this.options.buttons[i].classes,
              "sub_buttons": [this.options.buttons[i]]
            };
          }
        } else {
          buttonGroups[this.options.buttons[i].label] = this.options.buttons[i];
        }
      }
      for (var j = 0; Object.keys(buttonGroups).length > j; j++) {
        finalButtons.push(buttonGroups[Object.keys(buttonGroups)[j]]);
      }
      return finalButtons;
    },
    /**
     * @description disable a button you can only reenable by calling the function enableButton
     * @function
     * @name nixps-cloudflow-ButtonsBarTableExtension#disableButton
     * @param {String} pAction the action of the button
     * @param {String} pActionName the actionname of the button
     */
    disableButton: function disableButton(pAction, pActionName) {
      this.element.children(".bbte_topbar").find(".nixps-pagebuilder-CloudflowButton").each(function () {
        if (typeof pAction === "string" && $(this).CloudflowButton("option", "action") === pAction || typeof pActionName === "string" && $(this).CloudflowButton("option", "actionname") === pActionName) {
          $(this).CloudflowButton("disable");
          $(this).attr("data-prev-activationtype", $(this).attr("data-activationtype"));
          $(this).removeAttr("data-activationtype");
          return false;
        }
      });
    },
    /**
     * @description enable a button that was previously disabled by the function disableButton
     * @function
     * @name nixps-cloudflow-ButtonsBarTableExtension#enableButton
     * @param {String} pAction the action of the button
     * @param {String} pActionName the actionname of the button
     */
    enableButton: function enableButton(pAction, pActionName) {
      this.element.children(".bbte_topbar").find(".nixps-pagebuilder-CloudflowButton").each(function () {
        if (typeof pAction === "string" && $(this).CloudflowButton("option", "action") === pAction || typeof pActionName === "string" && $(this).CloudflowButton("option", "actionname") === pActionName) {
          $(this).CloudflowButton("enable");
          $(this).attr("data-activationtype", $(this).attr("data-prev-activationtype"));
          $(this).removeAttr("data-prev-activationtype");
          return false;
        }
      });
      // button can be disabled, if row conditions are so...
      this.updateButtons();
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ButtonsBarTableExtension#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "buttons") {
        this._superApply(arguments);
        this._controlOptions();
        this._draw();
      } else if (pKey === "listDOM" && pValue !== this.options.listDOM) {
        throw new Error("table option can not be changed dynamicaly");
      } else {
        this._superApply(arguments);
        this._controlOptions();
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.ButtonsBarTableExtension#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (Array.isArray(this.options.buttons) === false) {
        throw new Error("input options buttons must be an array");
      }
      if (typeof this.options.buttons_style_type !== "string" || this.options.buttons_style_type.length <= 0) {
        throw new Error("input options buttons_style_type must be an not empty string");
      }
      if (typeof this.options.listSelector !== "string" || this.options.listSelector.length <= 0) {
        throw new Error("input options listSelector must be an not empty string");
      }
      if (typeof this.options.listComponentName !== "string" || this.options.listComponentName.length <= 0) {
        throw new Error("input options listComponentName must be an not empty string");
      }
      if (typeof this.options.listgetRowsMethodeName !== "string" || this.options.listgetRowsMethodeName.length <= 0) {
        throw new Error("input options listgetRowsMethodeName must be an not empty string");
      }
      if (typeof this.options.listgetRowIDsMethodeName !== "string" || this.options.listgetRowIDsMethodeName.length <= 0) {
        throw new Error("input options listgetRowIDsMethodeName must be an not empty string");
      }
    }
  });
})(jQuery);

},{"../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js":282,"../../../common/DropdownList/js/nixps-DropdownList.js":288,"../../CloudflowUtil/js/QueryApplier.js":91}],215:[function(require,module,exports){
'use strict';

(function ($) {
  /**
      * @namespace nixps-cloudflow.CollapsibleColumns
      * @description Collapse, show or hide columns
      * @private
      * @version 1.0.0
      */
  $.widget("nixps-cloudflow.CollapsibleColumns", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "collapsablecolumns",
    options: {
      /**
       * @name nixps-cloudflow.CollapsibleColumns#columns
       * @description The columns options of the table
       * @type {Array<Object>}
       * @default []
       */
      columns: [],
      /**
       * @name nixps-cloudflow.CollapsibleColumns#columnsToShow
       * @description The init settings of the show hide columns
       * @type {Array<Boolean>}
       * @default null
       */
      columnsToShow: null
    },
    /**
     * @function
     * @name nixps-cloudflow.CollapsibleColumns#_create
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName).attr("data-uuid", this.uuid);
      if (Array.isArray(this.options.columns) === false || this.options.columns.length <= 0) {
        throw new Error("input option columns may not be an empty array");
      } else {
        // make a deep copy
        this.options.columns = $.extend(true, [], this.options.columns);
      }

      // event handling          
      this._on(this.element, {
        "change .cc_columns .cf-checkbox": this._changeHandler
      });
    },
    /**
     * @description fucntion runs when the user made a change in the checkboxes list
     * @function
     * @private 
     * @name nixps-cloudflow.CollapsibleColumns#_changeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _changeHandler: function _changeHandler(pEvent, pData) {
      var index = $(pEvent.target).closest("[data-index]").attr("data-index");
      if (isNaN(parseInt(index))) {
        throw new Error("could not retrieve index");
      }
      var checked = $(pEvent.target).closest(".cc_column").find("input").is(":checked");
      if (typeof checked !== "boolean") {
        throw new Error("can not retrieve value of input checkbox");
      }
      // we are sure the options columnsToShow is an array
      // if there is a change the dialog is drawed and there it is made an array
      this.options.columnsToShow[parseInt(index)] = checked;
      this._trigger("change", null, {
        columns: this.options.columnsToShow
      });
      // prevent hiding all
      if (this.element.find(".cc_column input:checked").length === 1) {
        this.element.find(".cc_column input:checked").prop("disabled", true);
      } else {
        this.element.find(".cc_column input:checked").prop("disabled", false);
      }
    },
    /**
     * @description  function runs when user clicked on the overlay to close the dialog
     * @function
     * @private
     * @name nixps-cloudflow.CollapsibleColumns#_otherSpaceClickHandler
     * @returns {undefined}
     */
    _otherSpaceClickHandler: function _otherSpaceClickHandler() {
      this.element.find(".cc_columns").hide();
      this._trigger("close", null, {});
    },
    /**
     * @description draw the dialog to choose a column
     * @function
     * @private
     * @name nixps-cloudflow.CollapsibleColumns#_drawDialog
     * @returns {unresolved}
     */
    _drawDialog: function _drawDialog() {
      // make default values
      if (Array.isArray(this.options.columnsToShow) === false || this.options.columnsToShow.length !== this.options.columns.length) {
        this.options.columnsToShow = [];
        for (var i = 0; i < this.options.columns.length; i++) {
          this.options.columnsToShow[i] = true;
        }
      }
      var choosePanel = $("<div>").addClass("cc_columns cf-zindex-dropdownlist").css("position", "absolute");
      this.element.append(choosePanel);
      for (var i = 0; i < this.options.columns.length; i++) {
        if (this.options.columns[i].noCollapsibleColumn === true || this.options.columns[i].type === "selectCheckbox") {
          continue;
        }
        var chooseLabelDOM = $('<span>');
        if (typeof this.options.columns[i].chooseLabel === "string" && this.options.columns[i].chooseLabel.length > 0) {
          chooseLabelDOM.addClass("cc_columnname")._t(this.options.columns[i].chooseLabel);
        } else if (typeof this.options.columns[i].label === "string" && this.options.columns[i].label.length > 0) {
          chooseLabelDOM.addClass("cc_columnname").html(this.options.columns[i].label);
        } else {
          chooseLabelDOM.addClass("cc_columnname em cf-em").text("[" + $.i18n._("nixps-cloudflow-table.config_notitle") + "]");
        }
        choosePanel.append($('<label>').addClass("cc_column").attr("data-index", i).append($('<span>').addClass("cc_columnicon").append($('<input>').attr("type", "checkbox").addClass("cf-checkbox").prop("checked", this.options.columnsToShow[i] === true))).append(chooseLabelDOM));
      }
      if (choosePanel.find(".cc_column input:checked").length === 1) {
        choosePanel.find(".cc_column input:checked").prop("disabled", true);
      }
      return choosePanel;
    },
    /**
     * @description show and hide and place the list at the correct place
     * @function
     * @name nixps-cloudflow.CollapsibleColumns#toggleChooser
     * @param {type} pEvent
     * @returns {undefined}
     */
    toggleChooser: function toggleChooser(pEvent) {
      // draw panel
      var choosePanel;
      if (this.element.find(".cc_columns").length === 0) {
        // not found, create then
        choosePanel = this._drawDialog();
        var parentDOM = $(pEvent.target).closest(".nixps-cloudflow-Table");
        var parentHeight = parentDOM.height();
        if (parentHeight > 0) {
          choosePanel.css("max-height", parentHeight);
        }
        choosePanel.position({
          "my": "center top",
          "at": "center bottom",
          "collision": "fit",
          "of": $(pEvent.target).closest("button, .tableConfigButton"),
          "within": $(pEvent.target).closest(".nixps-cloudflow-Table")
        });
        this._trigger("open", null, {
          clickCB: this._otherSpaceClickHandler.bind(this)
        });
      } else {
        // alread exists, just show or hide
        choosePanel = this.element.find(".cc_columns");
        if (choosePanel.is(":visible")) {
          choosePanel.hide();
          choosePanel.css("max-height", "");
          this._trigger("close", null, {});
        } else {
          choosePanel.css("display", "");
          var parentDOM = $(pEvent.target).closest(".nixps-cloudflow-Table");
          var parentHeight = parentDOM.height();
          if (parentHeight > 0) {
            choosePanel.css("max-height", parentHeight);
          }
          choosePanel.position({
            "my": "center top",
            "at": "center bottom",
            "collision": "fit",
            "of": $(pEvent.target).closest("button, .tableConfigButton"),
            "within": $(pEvent.target).closest(".nixps-cloudflow-Table")
          });
          this._trigger("open", null, {
            clickCB: this._otherSpaceClickHandler.bind(this)
          });
        }
      }
    }
  });
})(jQuery);

},{}],216:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jul 5, 2018 2:35:33 PM
 */
(function ($) {
  require("../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js");
  require("../../../common/DropdownList/js/nixps-DropdownList.js");
  var QueryApplier = require("../../CloudflowUtil/js/QueryApplier.js");

  /**
   * @namespace nixps-cloudflow.ContextMenuTableExtension
   * @description Draw a topbar of buttons for a table or other items manager
   * @private
   * @example $("<div>").ContextMenuTableExtension({});
   * @version 2.0.1
   */
  $.widget("nixps-cloudflow.ContextMenuTableExtension", $.Widget, {
    widgetEventPrefix: "buttonsbartableextension",
    version: "2.0.1",
    options: {
      /**
       * @description the array containing all the info about buttons
       * @name nixps-cloudflow.ContextMenuTableExtension#buttons
       * @type {Array}
       * @default []
       */
      buttons: [],
      /**
       * @description The type of styling to be applied on the buttons
       * @name nixps-cloudflow.ContextMenuTableExtension#buttons_style_type
       * @type {String}
       * @private
       * @default "CloudflowStyle_defaulttopbarbutton"
       */
      buttons_style_type: "CloudflowStyle_defaulttopbarbutton",
      /**
       * @description The jquery DOM element of the table component where he can find the seleced rows
       * @name nixps-cloudflow.ContextMenuTableExtension#listDOM
       * @type {jQueryDOMElement}
       * @since 2.0.0
       */
      listDOM: $("body"),
      /**
       * @description The selector of the list / table
       * @name nixps-cloudflow.ContextMenuTableExtension#listSelector
       * @type {String}
       * @default ".nixps-cloudflow-Table"
       * @since 2.0.0
       */
      listSelector: ".nixps-cloudflow-Table",
      /**
       * @description The component name of the list / table
       * @name nixps-cloudflow.ContextMenuTableExtension#listComponentName
       * @type {String}
       * @default "Table"
       * @since 2.0.0
       */
      listComponentName: "Table",
      /**
       * @description The name of the get rows methode
       * @name nixps-cloudflow.ContextMenuTableExtension#listgetRowsMethodeName
       * @type {String}
       * @default "getSelectedRows"
       * @since 2.0.0
       */
      listgetRowsMethodeName: "getSelectedRows",
      /**
       * @description The name of the get rows ids methode
       * @name nixps-cloudflow.ContextMenuTableExtension#listgetRowIDsMethodeName
       * @type {String}
       * @default "getSelectedRowIDs"
       * @since 2.0.0
       */
      listgetRowIDsMethodeName: "getSelectedRowIDs",
      /**
       * @description Must we activate the mobile slide panel when needed?
       * @name nixps-cloudflow.ContextMenuTableExtension#mobileSlidePanel
       * @type {Boolean}
       * @default false
       */
      mobileSlidePanel: false
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.ContextMenuTableExtension#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("nixps-cloudflow-TableMenuActions").attr("data-uuid", this.uuid);
      // variables
      this.queryAppliers = []; // data for filter, saved to optimalise
      this.visualBoundaryes = null; // data of browser screen boundaries

      this._draw();
      if (this.options.listComponentName === "Table") {
        this._on(this.options.listDOM, {
          "tabledataloaded": this._tableDataLoaded,
          "tableselect": this._rowSelectHandler,
          "tablelongpress": this._rowLongPressHandler
        });
      } else if (this.options.listComponentName === "CustomPageComponentDynamicList") {
        this._on(this.options.listDOM, {
          "custompagecomponentdynamiclistupdate": this._rowSelectHandler,
          "custompagecomponentdynamiclistselect": this._rowSelectHandler
        });
      }
      this._on(this.element, {
        "click .table_contextmenu button:not([disabled]):not(.cf-tablecontext-sub_menu)": this._buttonTopbarClickHandler,
        "click .table_contextmenu_overlay": this._closeHandler,
        "contextmenu .table_contextmenu_overlay": this._closeHandler
      });
    },
    /**
     * @description function runs when the table loaded new data
     * @function
     * @private
     * @name nixps-cloudflow.ContextMenuTableExtension#_tableDataLoaded
     * @param {type} pEvent
     * @param {type} pData
     * @returns {Boolean}
     */
    _tableDataLoaded: function _tableDataLoaded(pEvent, pData) {
      if (pData !== undefined && pData.wrongReturnOrder === true) {
        // rows didn't change
        return true;
      }
      this._rowSelectHandler(pEvent, pData);
    },
    /**
     * @description function runs when user change the selection of the rows
     * @function
     * @name nixps-cloudflow.ContextMenuTableExtension#_rowSelectHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _rowSelectHandler: function _rowSelectHandler(pEvent, pData) {
      // first check if change come from maintable and not from a child
      if ($(pEvent.target).closest(this.options.listSelector).is(this.options.listDOM) === false) {
        return; // select comes from child, ignore
      }

      this.updateButtons();
    },
    _rowLongPressHandler: function _rowLongPressHandler(pEvent, pData) {
      if (pData.tableInlineRow === true) {
        return;
      }
      this._rowSelectHandler(pEvent, pData);
    },
    /**
     * @description function runs when user clicked on one of the top bar buttons
     * @function
     * @name nixps-cloudflow.ContextMenuTableExtension#_buttonTopbarClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _buttonTopbarClickHandler: function _buttonTopbarClickHandler(pEvent, pData) {
      if (this._isEventFromTableComponent(pEvent) === false) {
        return true;
      }
      //close the context menu if user clicked a button that triggers an action 
      if ($(pEvent.target.closest("button")).hasClass("cf-tablebutton-sub_menu") === false) {
        this._closeHandler();
      }
      var button = $(pEvent.target).closest(".nixps-pagebuilder-CloudflowButton");
      var rows = this._getSelectedRowsIDs();
      if (Array.isArray(rows)) {
        var action = button.CloudflowButton("option", "action");
        var actionname = button.CloudflowButton("option", "actionname");
        if (button.children(".cf-tablebutton-sub_menu").length > 0) {
          //submenu button, doesn't execute an action, no need to check for it
          return;
        }
        if (typeof action === "string" && action.length > 0 && typeof actionname === "string" && actionname.length > 0) {
          this._trigger("buttonclick", pEvent, {
            triggername: action,
            data: {
              ids: rows,
              action: actionname
            },
            originalEvent: pEvent
          });
        } else {
          console.error("ContextMenuTableExtension: empty action found");
        }
      }
    },
    _isEventFromTableComponent: function _isEventFromTableComponent(pEvent) {
      return $(pEvent.target).closest("." + this.widgetFullName).attr("data-uuid") == this.uuid;
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.ContextMenuTableExtension#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.ContextMenuTableExtension#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      // reset
      this.element.empty();
      this.queryAppliers = [];
      // draw
      var topbar = $("<div>").addClass("table_contextmenu");
      var overlay = $("<div>").addClass("table_contextmenu_overlay");
      if (this.options.mobileSlidePanel === true) {
        this.element.append($("<div>").addClass("cf-slidepanel-header").append($("<div>").addClass("cf-handlebar")));
        topbar.addClass("cf-slidepanel-body");
        overlay.addClass("cf-overlay-light");
        this.element.not(".nixps-MobileSlidePanel").MobileSlidePanel({
          openStateOnStart: open,
          overlayDOM: overlay,
          heightCSSWhenOpen: "auto",
          change: function change(pEvent, pData) {
            if (typeof pData.openState === "string" && pData.openState.length > 0) {
              if (pData.openState === "close") {
                that._closeHandler();
              }
            }
          }
        });
      }
      this.element.append(overlay).append(topbar);
      var topbarButtons = this.options.buttons;
      for (var i = 0; i < topbarButtons.length; i++) {
        if (topbarButtons[i].show === false) {
          continue;
        }
        if (typeof topbarButtons[i].activation_type !== "string" || topbarButtons[i].activation_type.length <= 0) {
          topbarButtons[i].activation_type = "always";
        }
        var activationType = topbarButtons[i].activation_type;
        topbarButtons[i].disabled = ["single", "multiple", "one_or_more", "dynamic", "dynamic_one"].includes(activationType);
        if (typeof topbarButtons[i].classes === "string") {
          if (topbarButtons[i].classes.indexOf(this.options.buttons_style_type) === -1) {
            // add space to separat from other classes
            topbarButtons[i].classes = this.options.buttons_style_type + " " + topbarButtons[i].classes;
          }
        } else {
          topbarButtons[i].classes = this.options.buttons_style_type;
        }
        if (topbarButtons[i].predefinedType && topbarButtons[i].predefinedType === "button_group") {
          var subButton;
          if (this.options.mobileSlidePanel === true) {
            // make everything flate, we dont have space
            if (Array.isArray(topbarButtons[i].sub_buttons) && topbarButtons[i].sub_buttons.length > 0) {
              for (var s = 0; s < topbarButtons[i].sub_buttons.length; s++) {
                topbarButtons[i].sub_buttons[s].classes = topbarButtons[i].sub_buttons[s].classes + " cf-button-topbar";
                subButton = this._createButtonDOM(topbarButtons[i].sub_buttons[s], topbarButtons[i]);
                topbar.append(subButton);
              }
            }
          } else {
            // we have space, use it
            var menu = $("<div>").addClass("nixps-pagebuilder-CloudflowButton-DropDownButtons").DropdownList({
              "buttonClass": topbarButtons[i].classes += " cf-button-topbar cf-tablebutton-sub_menu",
              "buttonText": topbarButtons[i].label,
              "buttonIcon": topbarButtons[i].icon,
              "buttonTooltip": topbarButtons[i].tooltip,
              "mainButtonActivationType": topbarButtons[i].activation_type,
              "attachment": "next",
              "classes": {
                "dropdownlist-actionlist": "nixps_styling_constants_bodybackground cf-dropdown cf-dropdown-checkable noselect",
                "dropdownlist-mainbutton": "contextmenutableextension-maindropdownbutton"
              }
            }).css("display", "");
            if (Array.isArray(topbarButtons[i].sub_buttons) && topbarButtons[i].sub_buttons.length > 0) {
              for (var s = 0; s < topbarButtons[i].sub_buttons.length; s++) {
                if (topbarButtons[i].sub_buttons[s].show === false) {
                  continue;
                }
                topbarButtons[i].sub_buttons[s].classes = topbarButtons[i].sub_buttons[s].classes + " cf-tablebutton-sub_button";
                subButton = this._createButtonDOM(topbarButtons[i].sub_buttons[s], topbarButtons[i]);
                menu.DropdownList("addListItemAppendComponent", subButton.addClass("cf-dropdown-item-block"));
              }
            }
            if (["dynamic", "dynamic_one"].includes(topbarButtons[i].activation_type)) {
              var button = menu.find(".contextmenutableextension-maindropdownbutton");
              if (Array.isArray(topbarButtons[i].activation_query)) {
                this.queryAppliers.push(new QueryApplier(topbarButtons[i].activation_query));
                button.attr("data-queryapplier-index", this.queryAppliers.length - 1);
              } else {
                console.error("invalid topbarbutton: an query is required");
                // fallback to always
                button.attr("data-activationtype", "always");
              }
            }
            topbar.append(menu);
          }
        } else {
          topbarButtons[i].classes += " cf-button-topbar";
          var button = $("<div>").CloudflowButton(topbarButtons[i]).attr("data-activationtype", activationType);
          if (["dynamic", "dynamic_one"].includes(activationType)) {
            if (Array.isArray(topbarButtons[i].activation_query)) {
              this.queryAppliers.push(new QueryApplier(topbarButtons[i].activation_query));
              button.attr("data-queryapplier-index", this.queryAppliers.length - 1);
            } else {
              console.error("invalid topbarbutton: an query is required");
              // fallback to always
              button.attr("data-activationtype", "always");
            }
          }
          topbar.append(button);
        }
      }
      // var left = 0;

      // topbar.find(".nixps-pagebuilder-CloudflowButton").each(function(){
      //     if($(this).find("button").width() > left) {
      //         left = $(this).find("button").width();
      //     }
      // });
      // menu.DropdownList("changeActionListStyle", {top:0, left:left+20});
      this.element.hide();
    },
    _createButtonDOM: function _createButtonDOM(pButtonJSON, pParentButton) {
      if (typeof pButtonJSON.activation_type !== "string" || pButtonJSON.activation_type.length <= 0) {
        pButtonJSON.activation_type = "always";
      }
      var activationType = pButtonJSON.activation_type;
      pButtonJSON.disabled = ["single", "multiple", "one_or_more", "dynamic", "dynamic_one"].includes(activationType);
      if (typeof pButtonJSON.classes === "string") {
        if (pButtonJSON.classes.indexOf(this.options.buttons_style_type) === -1) {
          // add space to separat from other classes
          pButtonJSON.classes = this.options.buttons_style_type + " " + pButtonJSON.classes;
        }
      } else {
        pButtonJSON.classes = this.options.buttons_style_type;
      }
      pButtonJSON.classes += " cf-button-topbar";
      var button = $("<div>").CloudflowButton(pButtonJSON).attr("data-activationtype", activationType);
      if (activationType === "dynamic" || activationType === "dynamic_one") {
        if (Array.isArray(pButtonJSON.activation_query)) {
          this.queryAppliers.push(new QueryApplier(pButtonJSON.activation_query));
          button.attr("data-queryapplier-index", this.queryAppliers.length - 1);
        } else {
          console.error("invalid topbarbutton: an query is required");
          // fallback to always
          button.attr("data-activationtype", "always");
        }
      }
      return button;
    },
    updateButtons: function updateButtons() {
      var that = this;
      var rows = this._getSelectedRowsIDs();
      if (Array.isArray(rows)) {
        this.element.children(".table_contextmenu").find(".nixps-pagebuilder-CloudflowButton").not("[data-activationtype=always]").CloudflowButton("disable");
        //find sub buttons
        this.element.children(".table_contextmenu").find(".dropdownlist-actionlist").find(".nixps-pagebuilder-CloudflowButton").not("[data-activationtype=always]").CloudflowButton("disable");
        if (rows.length === 0) {
          this.element.children(".table_contextmenu").children("[data-activationtype=none]").CloudflowButton("enable");
          //find sub buttons
          this.element.children(".table_contextmenu").find(".dropdownlist-actionlist").find("[data-activationtype=none]").CloudflowButton("enable");
        } else if (rows.length === 1) {
          this.element.children(".table_contextmenu").children("[data-activationtype=single]").CloudflowButton("enable");
          //find sub buttons
          this.element.children(".table_contextmenu").find(".dropdownlist-actionlist").find("[data-activationtype=single]").CloudflowButton("enable");
          this.element.children(".table_contextmenu").children("[data-activationtype=one_or_more]").CloudflowButton("enable");
          //find sub buttons
          this.element.children(".table_contextmenu").find(".dropdownlist-actionlist").find("[data-activationtype=one_or_more]").CloudflowButton("enable");
          // dynamic one
          var dynamicList = this.element.children(".table_contextmenu").children("[data-activationtype=dynamic_one]").add(this.element.children(".table_contextmenu").find(".dropdownlist-actionlist").children("[data-activationtype=dynamic_one]"));
          dynamicList.each(function () {
            var rowsObjects = that._getSelectedItems();
            var index = $(this).attr("data-queryapplier-index");
            if (typeof index === "string" && index.length > 0) {
              index = parseInt(index);
            }
            if (that.queryAppliers[index] === undefined) {
              console.error("missing queryApplier");
              return true;
            }
            if (that.queryAppliers[index].validate(rowsObjects[0])) {
              $(this).CloudflowButton("enable");
            }
          });
        } else if (rows.length > 1) {
          this.element.children(".table_contextmenu").children("[data-activationtype=multiple]").CloudflowButton("enable");
          // find sub buttons
          this.element.children(".table_contextmenu").find(".dropdownlist-actionlist").find("[data-activationtype=multiple]").CloudflowButton("enable");
          this.element.children(".table_contextmenu").children("[data-activationtype=one_or_more]").CloudflowButton("enable");
          // find sub buttons
          this.element.children(".table_contextmenu").find(".dropdownlist-actionlist").find("[data-activationtype=one_or_more]").CloudflowButton("enable");
        }
        // multiple dynamic
        if (rows.length !== 0 && (this.element.children(".table_contextmenu").find("[data-activationtype=dynamic]").length > 0 || this.element.children(".table_contextmenu").find(".dropdownlist-actionlist").children("[data-activationtype=dynamic]").length > 0)) {
          var rowsObjects = this._getSelectedItems();
          var multi_dynamic = this.element.children(".table_contextmenu").find("[data-activationtype=dynamic]").add(this.element.children(".table_contextmenu").find(".dropdownlist-actionlist").children("[data-activationtype=dynamic]"));
          multi_dynamic.each(function () {
            var index = $(this).attr("data-queryapplier-index");
            if (typeof index === "string" && index.length > 0) {
              index = parseInt(index);
            }
            if (that.queryAppliers[index] === undefined) {
              console.error("missing queryApplier");
              return true;
            }
            var validRows = that.queryAppliers[index].apply(rowsObjects);
            if (validRows.length === rowsObjects.length) {
              $(this).CloudflowButton("enable");
            }
          });
        }
      }
    },
    _getSelectedRowsIDs: function _getSelectedRowsIDs() {
      return this.options.listDOM[this.options.listComponentName](this.options.listgetRowIDsMethodeName);
    },
    _getSelectedItems: function _getSelectedItems() {
      return this.options.listDOM[this.options.listComponentName](this.options.listgetRowsMethodeName);
    },
    _arrangeButtonGroups: function _arrangeButtonGroups() {
      var finalButtons = [];
      var buttonGroups = {};
      for (var i = 0; this.options.buttons.length > i; i++) {
        if (this.options.buttons[i].buttonGroup) {
          if (Object.keys(buttonGroups).indexOf(this.options.buttons[i].buttonGroup) > -1) {
            buttonGroups[this.options.buttons[i].buttonGroup].push(this.options.buttons[i]);
          } else {
            buttonGroups[this.options.buttons[i].buttonGroup] = {
              "label": this.options.buttons[i].buttonGroup,
              "classes": this.options.buttons[i].classes,
              "sub_buttons": [this.options.buttons[i]]
            };
          }
        } else {
          buttonGroups[this.options.buttons[i].label] = this.options.buttons[i];
        }
      }
      for (var j = 0; Object.keys(buttonGroups).length > j; j++) {
        finalButtons.push(buttonGroups[Object.keys(buttonGroups)[j]]);
      }
      return finalButtons;
    },
    /**
     * @description disable a button you can only reenable by calling the function enableButton
     * @function
     * @name nixps-cloudflow-ContextMenuTableExtension#disableButton
     * @param {String} pAction the action of the button
     * @param {String} pActionName the actionname of the button
     */
    disableButton: function disableButton(pAction, pActionName) {
      this.element.children(".table_contextmenu").find(".nixps-pagebuilder-CloudflowButton").each(function () {
        if (typeof pAction === "string" && $(this).CloudflowButton("option", "action") === pAction || typeof pActionName === "string" && $(this).CloudflowButton("option", "actionname") === pActionName) {
          $(this).CloudflowButton("disable");
          $(this).attr("data-prev-activationtype", $(this).attr("data-activationtype"));
          $(this).removeAttr("data-activationtype");
          return false;
        }
      });
    },
    /**
     * @description enable a button that was previously disabled by the function disableButton
     * @function
     * @name nixps-cloudflow-ContextMenuTableExtension#enableButton
     * @param {String} pAction the action of the button
     * @param {String} pActionName the actionname of the button
     */
    enableButton: function enableButton(pAction, pActionName) {
      this.element.children(".table_contextmenu").find(".nixps-pagebuilder-CloudflowButton").each(function () {
        if (typeof pAction === "string" && $(this).CloudflowButton("option", "action") === pAction || typeof pActionName === "string" && $(this).CloudflowButton("option", "actionname") === pActionName) {
          $(this).CloudflowButton("enable");
          $(this).attr("data-activationtype", $(this).attr("data-prev-activationtype"));
          $(this).removeAttr("data-prev-activationtype");
          return false;
        }
      });
      // button can be disabled, if row conditions are so...
      this.updateButtons();
    },
    /**
     * @description Open the mobile slide panel
     * @function
     * @name nixps-cloudflow-ContextMenuTableExtension#show
     * @param {Object} pEvent 
     */
    show: function show(pEvent) {
      var posX, posY;
      if (pEvent !== null && pEvent !== undefined) {
        pEvent.stopPropagation();
        pEvent.preventDefault();
        posX = pEvent.clientX;
        posY = pEvent.clientY;
        var windowWidth = $(window).width();
        var windowHeight = $(window).height();
        var extraSpace = this._getStaticVisualData();
        if (windowWidth <= posX + this.element.width()) {
          posX = windowWidth - this.element.width() - 3;
        }
        if (windowHeight <= posY + this.element.height() + extraSpace.bottom) {
          posY = windowHeight - this.element.height() - extraSpace.bottom - 3;
        }
      }
      if (this.element.hasClass("nixps-MobileSlidePanel")) {
        this.element.MobileSlidePanel("open");
        posX = undefined;
        posY = undefined;
      }
      this.element.css({
        top: posY,
        left: posX,
        display: "",
        position: "fixed",
        "z-index": 1000
      });
    },
    /**
     * @description Calc the amount of space we need to tac into account for the possitioning of the contect menu
     * @function
     * @private
     * @name nixps-cloudflow-ContextMenuTableExtension#_getStaticVisualData
     * @returns {Object}
     */
    _getStaticVisualData: function _getStaticVisualData() {
      // cache the data, we suppose that the page structure states unchanges, untouched during user session
      if (this.visualBoundaryes === null) {
        this.visualBoundaryes = {
          bottom: 0
        };
        // search in the world DOM if there are particularry elements i need to take care of...
        // first look for bottombars, they are always at the bottom
        var buttonBarsDOM = $(".cf-bottombar").not(".cf-hide, .layoutcompass_notshow");
        if (buttonBarsDOM.length > 0 && typeof buttonBarsDOM[0].getBoundingClientRect === "function") {
          var boundary = buttonBarsDOM[0].getBoundingClientRect();
          if (typeof boundary.height === "number" && boundary.height > 0) {
            this.visualBoundaryes.bottom = boundary.height;
          }
        }
      }
      return this.visualBoundaryes;
    },
    _closeHandler: function _closeHandler(pEvent) {
      if (pEvent !== undefined && typeof pEvent.preventDefault === "function") {
        pEvent.preventDefault();
      }
      var dropdowns = this.element.find(".nixps-pagebuilder-CloudflowButton-DropDownButtons");
      // toggle open dropdowns
      dropdowns.each(function (pIndex, pDropdown) {
        if ($(pDropdown).hasClass("dropdownlist_active") === true) {
          $(pDropdown).DropdownList("toggle");
        }
      });
      this.element.hide();
      return false;
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ContextMenuTableExtension#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "buttons") {
        this._superApply(arguments);
        this._controlOptions();
        this._draw();
      } else if (pKey === "listDOM" && pValue !== this.options.listDOM) {
        throw new Error("table option can not be changed dynamicaly");
      } else {
        this._superApply(arguments);
        this._controlOptions();
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.ContextMenuTableExtension#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (Array.isArray(this.options.buttons) === false) {
        throw new Error("input options buttons must be an array");
      }
      if (typeof this.options.buttons_style_type !== "string" || this.options.buttons_style_type.length <= 0) {
        throw new Error("input options buttons_style_type must be an not empty string");
      }
      if (typeof this.options.listSelector !== "string" || this.options.listSelector.length <= 0) {
        throw new Error("input options listSelector must be an not empty string");
      }
      if (typeof this.options.listComponentName !== "string" || this.options.listComponentName.length <= 0) {
        throw new Error("input options listComponentName must be an not empty string");
      }
      if (typeof this.options.listgetRowsMethodeName !== "string" || this.options.listgetRowsMethodeName.length <= 0) {
        throw new Error("input options listgetRowsMethodeName must be an not empty string");
      }
      if (typeof this.options.listgetRowIDsMethodeName !== "string" || this.options.listgetRowIDsMethodeName.length <= 0) {
        throw new Error("input options listgetRowIDsMethodeName must be an not empty string");
      }
    }
  });
})(jQuery);

},{"../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js":282,"../../../common/DropdownList/js/nixps-DropdownList.js":288,"../../CloudflowUtil/js/QueryApplier.js":91}],217:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Nov 15, 2017 5:09:37 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/

(function ($) {
  "use strict";

  require("./nixps-cloudflow-Table.js");
  require("../../CloudflowQueryBuilder/js/nixps-cloudflow-CloudflowQueryPanel.js");
  require("./nixps-cloudflow-ButtonsBarTableExtension.js");
  require("./nixps-cloudflow-ContextMenuTableExtension.js");
  require("../../../common/Dialog/js/nixps-Dialog.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  var CloudflowConnection = require("../../CloudflowUtil/js/CloudflowConnection.js");
  var DatabaseConnection = require("./DatabaseConnection.js");
  var Query = require("./Query.js");
  var QueryApplier = require("../../CloudflowUtil/js/QueryApplier.js");
  var FileConnection = require("../../CloudflowUtil/js/FileConnection.js");
  var extendedAdditionTypes = require("./ExtendedTableTypes.js");
  var WhitepaperCRUD = require("./WhitepaperCRUD.js");
  var User = require("../../User/js/User.js");
  var License = require("../../License/js/License.js");
  var UnitPreferences = require("../../Units/js/UnitPreferences.js");
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");
  var Device = require("../../PWA/js/Device.js");

  /**
   * @description If the list is bigger then this amount we show a warning
   * @type {Number}
   * @default 1000
   * @private
   * @static
   */
  var kWarningAmountItems = 1000;

  /**
   * @namespace nixps-cloudflow.PreConfiguredTable
   * @description Draw a generic table, that is preconfigured so that the options can be transformed to valid JSON. No options may be functions <br />
   * this component throws next events
   * <ul>
   * <li> preconfiguredtableclick: when user clicked on a row </li>
   * <li> preconfiguredtabledelete: when a row has been deleted correctly </li>
   * </ul>
   * Do not change this component without permission. This component is used in the PageBuilder!
   * @example $("<div>").PreConfiguredTable({});
   * @version 1.7.0
   */
  $.widget("nixps-cloudflow.PreConfiguredTable", $.Widget, {
    widgetEventPrefix: "preconfiguredtable",
    version: "1.7.0",
    options: {
      /**
       * @name nixps-cloudflow.PreConfiguredTable#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#eventtriggerLayoutInfo
       * @description option set by HTMLHandler to provide info about the actual active trigger listeners
       * so we can adapt the ui for them
       * @type {Array.<Object>}
       * @default undefined
       * @since 1.6.3
       */
      eventtriggerLayoutInfo: undefined,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#user
       * @description The user object
       * @type {User}
       * @default null
       */
      user: null,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#license
       * @description The license object
       * @type {License}
       * @default null
       */
      license: null,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#classes
       * @description The class names separated by space that will be added to the component
       * @type {String}
       * @default ""
       * @example "bootstrap"
       */
      classes: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#collectionType
       * @description Which list must we get from the backend to show. You can choose between <ul><li> jobs </li> <li> custom_objects </li> </ul>
       * @private
       * @type {String}
       * @default "custom_objects"
       * @example "jobs"
       */
      collectionType: "custom_objects",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#collectionName
       * @description The name of the custom object table
       * @private
       * @type {String}
       * @default ""
       */
      collectionName: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#collectionArray
       * @description The array to be used as input if the option collection is set to object
       * @type {Array}
       * @default []
       */
      collectionArray: [],
      /**
       * @name nixps-cloudflow.PreConfiguredTable#collection
       * @description The full name of the collection that must be displayed.
       * @type {String}
       * @default ""
       * @example "nucleus.customobjects.collectionname"
       * @example "nucleus.users"
       */
      collection: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#httpserviceInputName
       * @description the name of the http service input name
       * @type {String}
       * @default ""
       * @private
       */
      httpserviceInputName: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#httpserviceWhitepaperName
       * @description the name of the whitepaper where the http service is running
       * @type {String}
       * @default ""
       * @private
       */
      httpserviceWhitepaperName: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#dataFileURL
       * @description The URL of the data file to read
       * @type {String}
       * @default ""
       */
      dataFileURL: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#assetmetadataEnclosingFolder
       * @description The cloudflow URL of the enclosing folder to retrieve the metadatas
       * @type {String}
       * @default ""
       */
      assetmetadataEnclosingFolder: undefined,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#extraQuery
       * @description The extra filter to apply on the rows 
       * @type {Array}
       * @default []
       */
      extraQuery: [],
      /**
       * @name nixps-cloudflow.PreConfiguredTable#tableOptions
       * @description The options given back to the table component
       * @type {Object}
       */
      tableOptions: {
        "keyUniqID": "_id"
      },
      /**
       * @name nixps-cloudflow.PreConfiguredTable#configID
       * @description The id of the table configurations
       * @type {String}
       * @default null
       * @since 1.3.0
       */
      configID: null,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#enableUserConfig
       * @description Must we enable user table configurations or not?
       * @type {Boolean}
       * @default false
       * @since 1.3.0
       */
      enableUserConfig: false,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#asyncCount
       * @description Must we call the count on a different api call or not
       * @type {Boolean}
       * @default true
       * @since 1.2.0
       */
      asyncCount: true,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#rowConditionalStyling
       * @description The row conditional styling
       * @type {Array.<Object>}
       * @since 1.2.0
       */
      rowConditionalStyling: [],
      /**
       * @name nixps-cloudflow.PreConfiguredTable#enableCollapsible
       * @description If this options is set on true, we will prepend a collapsble column 
       * @type {Boolean}
       * @default false
       */
      enableCollapsible: false,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#collapsibleContent
       * @description Get the information to build a collapseble
       * @type {Object}
       * @default {}
       */
      collapsibleContent: {
        options: {}
      },
      /**
       * @name nixps-cloudflow.PreConfiguredTable#hideOtherCollapsibles
       * @description Must we hide other collapsibles on other rows, when we want to collapse a row
       * @type {boolean}
       * @default false
       * @since 1.2.1
       */
      hideOtherCollapsibles: false,
      /**
       * @description What is the with of the table
       * @type {String}
       * @name nixps-cloudflow.PreConfiguredTable#width
       * @default true
       * @since 1.3.0
       */
      width: "100%",
      /**
       * @description Must we try to fit the complete table inside the container or must we optimise for content
       * @type {Boolean}
       * @name nixps-cloudflow.PreConfiguredTable#optimizeForContent
       * @default true
       * @since 1.4.0
       */
      optimizeForContent: true,
      optimizeForMobile: false,
      /**
       * @description The path to be used if the url is relative. This must be set on root, to prevent overwriting by deep copies.
       * This option will be given to custom_panel compontent
       * @name nixps-cloudflow.PreConfiguredTable#relativeBasePath
       * @private
       * @type {string}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#refreshDelay
       * @description The number of miliseconds beween refreshing. Set on zero to disable the refreshing
       * @type {Number}
       * @default 0
       * @example 10000
       */
      refreshDelay: 0,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#advancedFilterOptions
       * @description The options to display the advanced filter panel
       * @type {Object}
       * @default undefined
       * @since 1.7.0
       */
      advancedFilterOptions: undefined,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#showAdvancedFiltersOnStart
       * @description Must we show the advanced filter panle on startup or not? 
       * @type {Boolean}
       * @default false
       * @since 1.7.0
       */
      showAdvancedFiltersOnStart: false,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#topbarbuttons
       * @description the buttons on the top bar
       * @type {Array}
       * @default []
       * @private
       */
      topbarbuttons: [],
      /**
       * @name nixps-cloudflow.PreConfiguredTable#deleteConfirmationTitle
       * @description The message title to ask confirmation to the user when deleting a row
       * @type {String}
       * @default ""
       * @since 1.5.0
       */
      deleteConfirmationTitle: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#deleteConfirmationMessage
       * @description The message to ask confirmation to the user when deleting a row
       * @type {String}
       * @default ""
       * @since 1.5.0
       */
      deleteConfirmationMessage: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#deleteConfirmationMessageRowObjectParameter
       * @description The field to be used in the delete confirmation message
       * @type {String}
       * @default ""
       * @since 1.5.0
       */
      deleteConfirmationMessageRowObjectParameter: "",
      /**
       * @name nixps-cloudflow.PreConfiguredTable#noItemsText
       * @description The text to be visible when there are no items
       * @type {String}
       * @default undefined
       * @since 1.5.0
       */
      noItemsText: undefined,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#deselectWhenRowClick
       * @description Must we deselect all rows when user clicked on a row, but not on a checkbox?
       * @type {Boolean}
       * @default false
       * @since 1.6.0
       */
      deselectWhenRowClick: false,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#forceCollapsePanelToUpdateWhenOpen
       * @description force updateing the collapsable panel, when it is open
       * @type {Boolean}
       * @default false
       * @since 1.6.2
       */
      forceCollapsePanelToUpdateWhenOpen: false,
      /**
       * @name nixps-cloudflow.PreConfiguredTable#pagebuilderStyleType
       * @description The type of pagebuilder table style
       * @default ""
       * @type "{String}" 
       * @private
       * @since 1.2.0
       */
      pagebuilderStyleType: "",
      /**
      * @name nixps-cloudflow.PreConfiguredTable#additionalTypes
      * @description Array to add more types of rendering a cell
      * @type {Array}
      * @private
      * @default []
      * @since 1.6.2
      */
      additionalTypes: [],
      /**
       * @name nixps-cloudflow.PreConfiguredTable#created
       * @description Function runs when component is done creating
       * @type {Function}
       * @private
       * @default function(){}
       * @since 1.6.1
       */
      created: function created() {}
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        noItemsText: $.i18n._("nixps-cloudflow-projectlist.no_items_available")
      };
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.PreConfiguredTable#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass(this.options.classes).addClass("cloudflowTableParentComponent") // class for styling indicating there is a table inside
      .addClass("cloudflowMenuButtonsParentComponent") // add class for filtering the pagebuilder topbar buttons actions to parent
      .addClass(this.options.pagebuilderStyleType).attr("data-uuid", this.uuid);
      if ($("body").hasClass("nixps-Dialog") === false) {
        $("body").Dialog();
      }

      // variables
      this.collection; // the name where we must get the data from
      this.rowContextJSON; // the generic context JSON of a row
      this.refreshTimerID; // the id of the refresh timer
      this.refreshCallingID = 0; // the uniq number to sync refresh calls
      this.dead = false; // to prevent actions on dead components
      this.dataProviderDef; // deferd object of the load data
      this.countProviderDef; // deferd object of the count data
      this.collectionCRUDconnection = null; // the connection to the whitepaper who provide data
      this.collectionCRUDconnectionExits = null; // the connection to the whitepaper who provide data exists
      this.blokkingID; // timerid of the blokking frame
      this.askCountOnList = false; // must we ask the count during the list_with_options or not?
      this.collectionArray = [];
      this.callingID = 0;
      this.countCallingID = 0;
      this.runningCountCalls = 0; //the current running calls to get the amount of the rows
      this.rowConditions = null; // the rowConditions to apply specific stylings on specific rows
      this.collectionFileConnection;
      this.lastQueryHash = ""; // hash of last request
      this.lastErrorMessageHash = undefined;
      this.extraErrorDelay = 0;
      this.creating = true; // is component still bussy creating
      this.isSelecting = null; // is row selecting activted or not
      this.openRowIDsDurringRefresh = null; // the closed rows durring refresh
      this.advancedFilter = [];
      this.quickSearchFilter = [];
      this.isMobile = null; // are we a mobile table or not
      this.listenToResize = false; // must we update something when the width of the browser changed?
      this.fixedScrollingHeight = 0; // the fixed skipping parent padding

      this._defineCollection();
      this._transformCollectionArray();
      this._initRowConditions();
      var licenseDef = {};
      var licenseToCheck = this._getLicenseToCheck();
      if (licenseToCheck !== false) {
        licenseDef = this._initLicenseObject();
      }
      var that = this; // this should be sync in new dropped tables
      $.when(this._initUserObject(), licenseDef, this._initAdditional(), this._getUnitPreferencesCheck()).then(function (pUser, pLicense) {
        if (Array.isArray(licenseToCheck) && licenseToCheck.length > 0) {
          var foundLicense = false;
          for (var i = 0; i < licenseToCheck.length; i++) {
            if (that.license.check(licenseToCheck[i]) === true) {
              foundLicense = true;
              break;
            }
          }
          if (foundLicense === false) {
            that._errorHandler({
              "error_code": "missing_license",
              "error": $.i18n._("nixps-cloudflow-preconfiguredtable.errormessage_missing_license", [licenseToCheck[0]])
            });
            that.creating = false;
            that.options.created();
            return;
          }
        }
        that.element.one("tabledataloaded", function () {
          if (that.creating) {
            that.creating = false;
            that.options.created();
          }
        }).one("tabledataloaderror", function () {
          if (that.creating) {
            that.creating = false;
            that.options.created();
          }
        });
        that._draw();
      })["catch"](function (pError) {
        that._errorHandler(pError);
        that.creating = false;
        that.options.created();
      });
      this._on(this.element, {
        "tabledataloaded .preconfiguredtable": this._tableDataLoadedHandler,
        "tabledataloaderror .preconfiguredtable": this._tableDataLoadErrorHandler,
        "tablestartcellediting .preconfiguredtable": this._tableStartCellEditingHandler,
        "tablecancelcellediting .preconfiguredtable": this._tableStopCellEditingHandler,
        "tableclick .preconfiguredtable": this._rowClickHandler,
        "dblclick .preconfiguredtable tbody tr:not(.tableInlineRow)": this._dblRowClickHandler,
        "contextmenu .preconfiguredtable tbody tr:not(.tableInlineRow)": this._contextMenuRowClickHandler,
        "tableselect .preconfiguredtable": this._rowSelectHandler,
        "preconfiguredtabledblclick": this._preconfiguredTableDblClickHandler,
        "preconfiguredtableclick": this._preconfiguredTableClickHandler,
        "custompagebuilderclosecontainer .nixps-pagebuilder-CustomPageComponent": this._closeEventHandler,
        "custompagebuilderrefreshcontainer .nixps-pagebuilder-CustomPageComponent": this._refreshMeCollapsableHandler,
        "cloudflowquerypanelclose": this._advancedFilterCloseHandler,
        "cloudflowquerypanelchange": this._advancedFilterChangeHandler
      });
      this.windowResizeHandler = _.throttle(this._windowResizeHandler.bind(this), 1500, {
        leading: false
      });
      $(window).on("resize", this.windowResizeHandler);
    },
    /**
     * @description fucntion runs when the table has finished loading new data
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_tableDataLoadedHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _tableDataLoadedHandler: function _tableDataLoadedHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      if (pData !== undefined && pData.wrongReturnOrder !== true) {
        this.lastErrorMessageHash = undefined;
        this.extraErrorDelay = 0;
      }
      this._triggerTimer();
    },
    /**
     * @description Function runs when table occured an error
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_tableDataLoadErrorHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _tableDataLoadErrorHandler: function _tableDataLoadErrorHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      // try to analyse the error,
      // if the error can be ignored, continue the refresh loop
      // otherwise stop refresh loop if error occurs twice
      if (pData !== undefined && pData.error !== undefined) {
        if (pData.error.error === "stop_called") {
          // ignore stop called errors
          this._triggerTimer();
          return true;
        }
        if (pData.error.error_code === "http_error" && pData.error.http_result !== undefined && (pData.error.http_result.status === 503 || pData.error.http_result.status === 504 || pData.error.http_result.status === 429)) {
          clearTimeout(this.refreshTimerID);
          this.options.refreshDelay = 0;
          console.error("server overloaded, disable refreshing");
          return;
        }
        // error: {error: "ProcessEntry Create Failure: Other process has lock(s)", error_code: "unknown"}
        var errorMessageHash = JSON.stringify(pData.error);
        if (typeof errorMessageHash === "string" && this.lastErrorMessageHash !== errorMessageHash) {
          this.lastErrorMessageHash = errorMessageHash;
          if (this.extraErrorDelay + this.options.refreshDelay + 5000 < 2147483600) {
            this.extraErrorDelay += 5000;
          }
          this._triggerTimer();
        } else {
          this.options.refreshDelay = 0;
          this._stopTimer();
          console.error("Stop table refreshing, we encoutered the same error twice: ", pData.error);
        }
      }
    },
    /**
     * @description Function run when user start editing some cells
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_tableStartCellEditingHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     * @returns {undefined}
     */
    _tableStartCellEditingHandler: function _tableStartCellEditingHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      pEvent.stopPropagation();
      this._stopTimer(); // we will reactivate later in the function _dataUpdater
    },

    /**
     * @description function runs when the editing cell is cancelled
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_tableStopCellEditingHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     * @returns {undefined}
     */
    _tableStopCellEditingHandler: function _tableStopCellEditingHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      pEvent.stopPropagation();
      this._triggerTimer();
    },
    /**
     * @description function runs when user cliked on a row
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_rowClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {Boolean}
     */
    _rowClickHandler: function _rowClickHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      if (pData.tableInlineRow === true) {
        return true;
      }
      if (pData !== undefined && pData.columObject !== undefined) {
        if (pData.columObject.type === "collapsible") {
          this._collapseClickHandler(pEvent.originalEvent, pData);
          return true;
        }
        if (pData.columObject.type === "selectCheckbox") {
          return true;
        }
      }
      var actionButton = $(pEvent.originalEvent.target).closest("[data-action]");
      if (actionButton.length > 0 && this._isElementOutside(actionButton) === false) {
        // clicked on action button
        this._actionClickHandler(pEvent, pData, actionButton.attr("data-action"), this.options.tableOptions.keyUniqID);
      } else {
        if (pData !== undefined && pData.rowObject !== undefined) {
          var rowObject = Object.assign({}, pData.rowObject);
          var columnObject = Object.assign({}, pData.columObject);
          var rowID = CloudflowObject.getParameter(rowObject, this.options.tableOptions.keyUniqID);

          // no action button clicked
          if (this.options.deselectWhenRowClick === true && this.isSelecting === true) {
            if (pEvent.metaKey !== true && pEvent.shiftKey !== true) {
              this.element.children(".preconfiguredtable").Table("unselectAllRows").Table("selectRows", rowID, true);
            }
          }
          this._trigger("click", null, {
            id: rowID,
            rowObject: rowObject /*, columnObject: columObject*/
          });
        } else {
          console.error("_rowClickHandler: missing rowObject to handle click trigger");
        }
      }
    },
    _actionClickHandler: function _actionClickHandler(pEvent, pData, pAction, pKeyName) {
      if (pData !== undefined && pData.rowObject !== undefined) {
        var rowID = CloudflowObject.getParameter(pData.rowObject, pKeyName);
        if (rowID !== undefined) {
          if (pAction === "remove") {
            this._deleteRowObject(rowID, pData.rowObject);
          } else if (pAction === "_settings_mobile") {
            this._showMobileContextMenu(pEvent, rowID, pData.rowObject);
          } else {
            var rowObject = Object.assign({}, pData.rowObject);
            var columnObject = Object.assign({}, pData.columObject);
            this._trigger("action" + pAction, pEvent.originalEvent, {
              id: rowID,
              rowObject: rowObject,
              /*columnObject: columnObject,*/action: pAction
            });
          }
        } else {
          console.error("_actionClickHandler: missing unique row indentifier to handler action");
        }
      } else {
        console.error("_actionClickHandler: missing rowObject to handler action");
      }
    },
    /**
     * @description function runs when user double click on a row
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_dblRowClickHandler
     * @private
     * @return {undefined}
     */
    _dblRowClickHandler: function _dblRowClickHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      if ($(pEvent.target).is(".pct_collapsible, input")) {
        return true; // do not handle double click on disclosure buttons or inputs
      }

      if ($(pEvent.target).is("[data-action]")) {
        pEvent.stopPropagation();
      } else {
        pEvent.stopPropagation();
        var rowObject = this.getRowObject($(pEvent.target));
        //var columnObject = this.getColumnObject($(pEvent.target));
        var rowID = $(pEvent.target).closest("tr").attr("data-TableRowID");
        if (rowID === undefined) {
          this._errorHandler({
            "error_code": "missing_id",
            "error": "rowID is missing"
          });
        } else {
          this._trigger("dblclick", pEvent, {
            id: rowID,
            rowObject: rowObject /*, columnObject:columnObject*/
          });
        }
      }
    },

    /**
    * @description function runs when user right click on a row
    * @function
    * @name nixps-cloudflow.PreConfiguredTable#_contextMenuRowClickHandler
    * @private
    * @return {undefined}
    */
    _contextMenuRowClickHandler: function _contextMenuRowClickHandler(pEvent) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      if (this.isMobile === true) {
        // we handle or own context menu on mobile
        return false;
      }
      if (this.mContextmenu !== undefined && this.mContextmenu !== null) {
        this.mContextmenu.ContextMenuTableExtension("show", pEvent);
      }
    },
    /**
     * @description function runs when rows are selected or unselected
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_rowSelectHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _rowSelectHandler: function _rowSelectHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      var ids = this.element.children(".preconfiguredtable").Table("getSelectedRowIDs");
      var rowObjects = this.element.children(".preconfiguredtable").Table("getSelectedRows");
      this._trigger("select", null, {
        "ids": ids,
        "rowObjects": rowObjects,
        "amountSelected": ids.length
      });
    },
    /**
     * @description function runs when an dblclick event is fired, try to prevent bubbling, only the current parent may use this event
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_preconfiguredTableDblClickHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _preconfiguredTableDblClickHandler: function _preconfiguredTableDblClickHandler(pEvent, pData) {
      if ($(pEvent.target).closest("." + this.widgetFullName).attr("data-uuid") === this.uuid.toString() === false) {
        // ~~do not continue if event comes from children~~
        // stopImmadiatePropagation() methode is used to block event completely in a immunity reaction, not to frienly block
        // so try to block the actions with the findUUID in state
        // ~~pEvent.stopImmediatePropagation();~~
      }
    },
    /**
     * @description function runs when an click event is fired, try to prevent bubbling, only the current parent may use this event
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_preconfiguredTableDblClickHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _preconfiguredTableClickHandler: function _preconfiguredTableClickHandler(pEvent, pData) {
      if ($(pEvent.target).closest("." + this.widgetFullName).attr("data-uuid") === this.uuid.toString() === false) {
        // ~~do not continue if event comes from children~~
        // stopImmadiatePropagation() methode is used to block event completely in a immunity reaction, not to frienly block
        // so try to block the actions with the findUUID in state
        // ~~pEvent.stopImmediatePropagation();~~
      }
    },
    /**
     * @description function runs when user click on the collapse button
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_collapseClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {Boolean}
     */
    _collapseClickHandler: function _collapseClickHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      var collapseIcon = $(pEvent.target).closest("tr").find(".pct_collapsible");
      if (collapseIcon.hasClass("fa-caret-right") === true) {
        // want to open
        this.showCollapsePanel(pData !== undefined ? pData.rowObject : undefined, pEvent);
      } else if (collapseIcon.hasClass("fa-caret-right") === false) {
        this.hideCollapsePanel(pData !== undefined ? pData.rowObject : undefined, pEvent);
      } else {
        console.error("PreConfiguredTable: click: nothing found during collapse click handler icon");
      }
    },
    showCollapsePanel: function showCollapsePanel(pRowObject, pEvent) {
      var rowDOM = [];
      if (pEvent !== undefined && pEvent !== null && pEvent.target !== undefined) {
        rowDOM.push($(pEvent.target).closest("tr"));
      }
      var rowObjectMap = {};
      var rowObjectList = [];
      var keyUniqID = this.options.tableOptions.keyUniqID || "_id";
      if (pRowObject !== undefined && pRowObject !== null) {
        if (Array.isArray(pRowObject) === false) {
          pRowObject = [pRowObject];
        }
        rowObjectList = pRowObject;
        var selector = "";
        for (var i = 0; i < pRowObject.length; i++) {
          var rowObjectID = pRowObject[i][keyUniqID];
          if (rowObjectID === undefined && keyUniqID !== "_id") {
            rowObjectID = pRowObject[i]._id;
          }
          if (rowObjectID !== undefined) {
            rowObjectMap[rowObjectID] = pRowObject[i];
            selector += "tr[data-tablerowid=\"" + rowObjectID + "\"], ";
          }
        }
        if (rowDOM.length === 0 && selector !== "") {
          selector = selector.slice(0, -2); // remove last ", "
          // select only rows that are still closed
          rowDOM = this.element.find(selector).filter(function (pIndex, pElement) {
            return $(pElement).find(".pct_collapsible").hasClass("fa-caret-right") === true;
          });
        }
      }
      if (rowDOM.length === 0) {
        return Promise.resolve({});
      }
      var openPagePromises = [];
      for (var j = 0; j < rowDOM.length; j++) {
        var row = $(rowDOM[j]);
        var rowID = row.attr("data-tablerowid");
        var collapseIcon = row.find(".pct_collapsible");
        if (collapseIcon.length === 0 || collapseIcon.hasClass("fa-caret-right") === false) {
          continue;
        }
        var currentRowObject = rowObjectMap[rowID];
        if (currentRowObject === undefined && rowDOM.length === 1 && rowObjectList.length === 1) {
          currentRowObject = rowObjectList[0];
        }
        collapseIcon.removeClass("fa-caret-right").addClass("fa-caret-down");
        // adapt internal model durring refresh
        if (Array.isArray(this.openRowIDsDurringRefresh) && this.openRowIDsDurringRefresh.indexOf(rowID) === -1) {
          this.openRowIDsDurringRefresh.push(rowID);
        }
        if (this.options.hideOtherCollapsibles === true) {
          var that = this;
          collapseIcon.closest("tr").prevAll("tr.tableInlineRow").add(collapseIcon.closest("tr").next().nextAll("tr.tableInlineRow")).hide().prev().each(function () {
            if (Array.isArray(that.openRowIDsDurringRefresh)) {
              var innerRowID = $(this).attr("data-tablerowid");
              if (typeof innerRowID === "string" || typeof innerRowID === "number") {
                var innerRowIDindex = that.openRowIDsDurringRefresh.indexOf(innerRowID);
                if (innerRowIDindex >= 0) {
                  that.openRowIDsDurringRefresh.splice(innerRowIDindex, 1);
                }
              }
            }
          }).find(".pct_collapsible").removeClass("fa-caret-down").addClass("fa-caret-right");
        }
        var isCollapsCreated = collapseIcon.closest("tr").next("tr").hasClass("tableInlineRow");
        if (isCollapsCreated === false) {
          if ($.fn.CustomPageComponent === undefined) {
            console.error("no CustomPageComponent jQuery widget found");
            return true;
          }
          // create new
          var newRow = this.element.children(".preconfiguredtable").Table("insertOneCollapseRow", collapseIcon, true);
          var custompage = $("<div>");
          newRow.append(custompage);
          var options = {};
          if (currentRowObject !== undefined) {
            // for the moment we get all fields, so we can give everything
            options.contextConnector = "object";
            options.contextCollection = "";
            options.contextKey = currentRowObject;
            if ($.isPlainObject(this.rowContextJSON)) {
              if (this.rowContextJSON.connector === "file") {
                options.context = $.extend(true, {}, {
                  key: [this.options.tableOptions.keyUniqID, "equal to", rowID]
                }, this.rowContextJSON);
              } else if (this.rowContextJSON.connector === "startFromDBIO") {
                // important that extend() starts with 'true'
                options.context = $.extend(true, {}, {
                  key: {
                    variables: rowID
                  }
                }, this.rowContextJSON);
              } else if (this.rowContextJSON.connector === "httpservice") {
                options.context = $.extend(true, {}, {
                  key: {
                    variables: {
                      action: "get",
                      query: null,
                      orderby: null,
                      fields: null,
                      options: null,
                      id: rowID,
                      object: null
                    }
                  }
                }, this.rowContextJSON);
              } else {
                options.context = $.extend(true, {}, {
                  key: rowID
                }, this.rowContextJSON);
              }
            }
          }
          if (currentRowObject !== undefined && this.options.collapsibleContent.options !== undefined && this.options.collapsibleContent.options.contextConnector === "whitepaper") {
            options.contextKey = {
              "variables": currentRowObject
            };
            if ($.isPlainObject(this.options.collapsibleContent.options.contextKey) && $.isPlainObject(this.options.collapsibleContent.options.contextKey.variables) && $.isPlainObject(this.options.collapsibleContent.options.contextKey.variables.extraInputs)) {
              options.contextKey.variables = Object.assign(options.contextKey.variables, {
                extraInputs: this.options.collapsibleContent.options.contextKey.variables.extraInputs
              });
            }
          }
          options = $.extend(true, options, this.options.collapsibleContent.options); // overwrite then
          options.relativeBasePath = this.options.relativeBasePath; // fix options
          options.language = this.options.language;
          options.parentWillRefresh = true;
          options.publicParentWidgetName = this.widgetFullName;
          options.customchangeTriggerIdentifier = rowID;
          if (this.element.attr("id")) {
            options.pageCSSSelector = "#" + this.element.attr("id") + " tr[data-tablerowid=\"" + rowID + "\"] + .tableInlineRow > td > .nixps-pagebuilder-CustomPageComponent";
          }
          openPagePromises.push(new Promise(function (pResolve, pReject) {
            custompage.one("custompagecomponentdrawed", function () {
              pResolve();
            });
          }));
          custompage.CustomPageComponent(options);
        } else if (isCollapsCreated === true) {
          var collapsePanel = collapseIcon.closest("tr").next("tr.tableInlineRow").css("display", "");
          // reopen
          if (currentRowObject !== undefined) {
            this._refreshCustompageComponentCollapse(collapsePanel.children("td").children(".nixps-pagebuilder-CustomPageComponent"), currentRowObject, false, false);
          }
        }
      }
      return Promise.allSettled(openPagePromises).then(function () {
        return Promise.resolve({});
      });
    },
    hideCollapsePanel: function hideCollapsePanel(pRowObject, pEvent) {
      var rowDOM = [];
      if (pEvent !== undefined && pEvent !== null && pEvent.target !== undefined) {
        rowDOM.push($(pEvent.target).closest("tr"));
      }
      if (rowDOM.length === 0 && pRowObject !== undefined && pRowObject !== null) {
        if (Array.isArray(pRowObject) === false) {
          pRowObject = [pRowObject];
        }
        var selector = "";
        for (var i = 0; i < pRowObject.length; i++) {
          var keyUniqID = this.options.tableOptions.keyUniqID || "_id";
          var rowObjectID = pRowObject[i][keyUniqID];
          if (rowObjectID === undefined && keyUniqID !== "_id") {
            rowObjectID = pRowObject[i]._id;
          }
          if (rowObjectID !== undefined) {
            selector += "tr[data-tablerowid=\"" + rowObjectID + "\"], ";
          }
        }
        selector = selector.slice(0, -2); //remove last ", "

        //select only the rows which are closed, if there are some opened they should not be closed by this function
        rowDOM = this.element.find(selector).filter(function (pIndex, pElement) {
          return $(pElement).find(".pct_collapsible").hasClass("fa-caret-right") === false;
        });
      }
      if (rowDOM.length === 0) {
        return {};
      }
      for (var _i = 0; _i < rowDOM.length; _i++) {
        var row = $(rowDOM[_i]);
        var rowID = row.attr("data-tablerowid");
        var collapseIcon = row.find(".pct_collapsible");
        // want to close
        collapseIcon.removeClass("fa-caret-down").addClass("fa-caret-right");
        // hide injected
        collapseIcon.closest("tr").next("tr.tableInlineRow").hide();
        // adapt internal model durring refresh 
        if (Array.isArray(this.openRowIDsDurringRefresh)) {
          var rowIDindex = this.openRowIDsDurringRefresh.indexOf(rowID);
          if (rowIDindex >= 0) {
            this.openRowIDsDurringRefresh.splice(rowIDindex, 1);
          }
        }
      }
      return {};
    },
    toggleCollapsePanel: function toggleCollapsePanel(pRowObject, pEvent) {
      var rowDOM = [];
      if (pEvent !== undefined && pEvent !== null && pEvent.target !== undefined) {
        rowDOM.push($(pEvent.target).closest("tr"));
      }
      var rowObjectMap = {};
      var rowObjectList = [];
      var keyUniqID = this.options.tableOptions.keyUniqID || "_id";
      var selector = "";
      if (pRowObject !== undefined && pRowObject !== null) {
        if (Array.isArray(pRowObject) === false) {
          pRowObject = [pRowObject];
        }
        rowObjectList = pRowObject;
        for (var i = 0; i < pRowObject.length; i++) {
          var rowObjectID = pRowObject[i][keyUniqID];
          if (rowObjectID === undefined && keyUniqID !== "_id") {
            rowObjectID = pRowObject[i]._id;
          }
          if (rowObjectID !== undefined) {
            rowObjectMap[rowObjectID] = pRowObject[i];
            selector += "tr[data-tablerowid=\"" + rowObjectID + "\"], ";
          }
        }
      }
      if (rowDOM.length === 0 && pRowObject !== undefined && pRowObject !== null) {
        if (selector !== "") {
          selector = selector.slice(0, -2); // remove last ", "
        }

        rowDOM = selector === "" ? [] : this.element.find(selector);
      }
      if (rowDOM.length === 0) {
        return {};
      }

      // Event based toggle always targets one row.
      if (pEvent !== undefined && pEvent !== null && pEvent.target !== undefined) {
        var eventRow = $(rowDOM[0]);
        var eventRowID = eventRow.attr("data-tablerowid");
        var eventRowObject = rowObjectMap[eventRowID];
        if (eventRowObject === undefined && rowObjectList.length === 1) {
          eventRowObject = rowObjectList[0];
        }
        var eventCollapseIcon = eventRow.find(".pct_collapsible");
        if (eventCollapseIcon.hasClass("fa-caret-right") === true) {
          this.showCollapsePanel(eventRowObject, pEvent);
        } else if (eventCollapseIcon.hasClass("fa-caret-right") === false) {
          this.hideCollapsePanel(eventRowObject, pEvent);
        } else {
          console.error("PreConfiguredTable: toggle collapse action: nothing found during collapse click handler icon");
        }
        return {};
      }
      var rowObjectsToOpen = [];
      var rowObjectsToClose = [];
      for (var j = 0; j < rowDOM.length; j++) {
        var row = $(rowDOM[j]);
        var rowID = row.attr("data-tablerowid");
        var collapseIcon = row.find(".pct_collapsible");
        if (collapseIcon.length === 0) {
          continue;
        }
        var currentRowObject = rowObjectMap[rowID];
        if (collapseIcon.hasClass("fa-caret-right") === true) {
          if (currentRowObject !== undefined) {
            rowObjectsToOpen.push(currentRowObject);
          }
        } else if (collapseIcon.hasClass("fa-caret-right") === false) {
          if (currentRowObject !== undefined) {
            rowObjectsToClose.push(currentRowObject);
          }
        }
      }
      var openPromise = Promise.resolve({});
      if (rowObjectsToOpen.length > 0) {
        openPromise = this.showCollapsePanel(rowObjectsToOpen);
      }
      if (rowObjectsToClose.length > 0) {
        this.hideCollapsePanel(rowObjectsToClose);
      }
      if (rowObjectsToOpen.length === 0 && rowObjectsToClose.length === 0) {
        console.error("PreConfiguredTable: toggle collapse action: nothing found during collapse click handler icon");
      }
      return openPromise.then(function () {
        return Promise.resolve({});
      });
    },
    _refreshCustompageComponentCollapse: function _refreshCustompageComponentCollapse(pCustompageComponent, pRowObject, pForce, pOrigStateURL) {
      if (pOrigStateURL !== true) {
        var historyStates = pCustompageComponent.CustomPageComponent("getHistoryStates");
        if (historyStates !== undefined && Array.isArray(historyStates.historyStates) && historyStates.historyStates.length > 0 && typeof historyStates.historyStates[0].url === "string" && historyStates.currentState !== undefined && typeof historyStates.currentState.url === "string") {
          if (historyStates.historyStates[0].url !== historyStates.currentState.url) {
            // do not updates, cpc is on other url
            return;
          }
        }
      }
      var needToUpdate = false;
      if (pForce !== true) {
        var oldData = pCustompageComponent.CustomPageComponent("option", "contextKey");
        if ($.isPlainObject(oldData) === false) {
          oldData = {};
        }
        var newChangeKey = pRowObject.save_id || pRowObject.modification;
        if (newChangeKey !== undefined) {
          var oldChangeKey;
          if (this.options.collapsibleContent.options !== undefined && this.options.collapsibleContent.options.contextConnector === "whitepaper" && oldData.variables !== undefined) {
            oldChangeKey = oldData.variables.save_id || oldData.variables.modification;
          } else {
            oldChangeKey = oldData.save_id || oldData.modification;
          }
          needToUpdate = oldChangeKey !== newChangeKey;
        } else {
          needToUpdate = _.isEqual(pRowObject, oldData) === false;
        }
      } else {
        needToUpdate = true;
      }
      if (needToUpdate) {
        var options = {
          contextConnector: "object",
          contextCollection: "",
          contextKey: pRowObject
        };
        if (this.options.collapsibleContent.options !== undefined && this.options.collapsibleContent.options.contextConnector === "whitepaper") {
          options.contextKey = {
            "variables": pRowObject
          };
        }
        options = $.extend(true, options, this.options.collapsibleContent.options); // overwrite then
        pCustompageComponent.CustomPageComponent("refresh", options.contextConnector, options.contextCollection, options.contextKey, undefined, undefined, true, pOrigStateURL);
      }
    },
    /**
     * @description function runs when user want to close the highest container
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_closeEventHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _closeEventHandler: function _closeEventHandler(pEvent, pData, pOriginalEvent, pClosePassingData) {
      this.refreshData(null);
      pEvent.stopPropagation();
      pEvent.preventDefault();
      if (pOriginalEvent !== undefined && pOriginalEvent.stopPropagation !== undefined) {
        pOriginalEvent.stopPropagation();
      }
      return false;
    },
    /**
     * @description function runs when the collapsable custom page component asked to refresh itself
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_refreshMeCollapsableHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _refreshMeCollapsableHandler: function _refreshMeCollapsableHandler(pEvent, pData, pOriginalEvent) {
      if (pData !== undefined) {
        pEvent.stopPropagation();
        pEvent.preventDefault();
        if (pOriginalEvent !== undefined && pOriginalEvent.stopPropagation !== undefined) {
          pOriginalEvent.stopPropagation();
        }
        this.lastQueryHash = ""; // show waiting panel
        var origStateURLCPCDict = {};
        if (pData.originalURL === true) {
          var uuid = $(pEvent.target).closest(".nixps-pagebuilder-CustomPageComponent").attr("data-uuid");
          origStateURLCPCDict[uuid] = true;
        }
        this.refreshData(null, true, true, pData.force, origStateURLCPCDict);
      }
    },
    /**
     * @description Function runs when user close the  advanced panel
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_advancedFilterCloseHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _advancedFilterCloseHandler: function _advancedFilterCloseHandler(pEvent, pData) {
      pEvent.stopPropagation();
      this._closeAdvancedFilter();
    },
    /**
     * @description function runs when a change is detected in the query building UI
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_advancedFilterChangeHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     * @returns undefined
     */
    _advancedFilterChangeHandler: function _advancedFilterChangeHandler(pEvent, pData) {
      if ($(pEvent.target).closest(".nixps-cloudflow-PreConfiguredTable, .nixps-cloudflow-ManageProjects, ." + this.widgetFullName).attr("data-uuid") !== this.uuid.toString()) {
        return true;
      }
      var valid = this.element.children(".advancedfilterpanel").CloudflowQueryPanel("validate");
      if (valid === true) {
        var query = this.element.children(".advancedfilterpanel").CloudflowQueryPanel("getValue");
        if (_.isEqual(query, this.advancedFilter) === false) {
          this.advancedFilter = query.slice();
          this.refreshData(null, true, true);
        }
      }
    },
    _windowResizeHandler: function _windowResizeHandler() {
      if (this.listenToResize === true) {
        var topbar = this.element.find(".nixps-cloudflow-ButtonsBarTableExtension:visible");
        if (topbar.length > 0) {
          this.element.find(".preconfiguredtable.nixps-cloudflow-Table").Table("windowResized", {
            "stickyHeaderMarginTop": this.fixedScrollingHeight + (topbar.height() || 27)
          });
        }
      }
    },
    /**
     * @description control if the event comes from this component and not from a child that can also be a table
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_isEventFromComponent
     * @param {type} pEvent
     * @returns {bollean} true if events source comes from this component, false if event comes form a child component, that bubbles up
     */
    _isEventFromComponent: function _isEventFromComponent(pEvent) {
      return $(pEvent.target).closest(".nixps-cloudflow-Table").hasClass("preconfiguredtable") && $(pEvent.target).closest(".nixps-cloudflow-PreConfiguredTable, .nixps-cloudflow-ManageProjects, ." + this.widgetFullName).attr("data-uuid") === this.uuid.toString();
    },
    /**
     * @description Is the element outside this.element
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_isElementOutside
     * @returns {Boolean} true if the element is outside this component
     */
    _isElementOutside: function _isElementOutside(pElem) {
      return pElem.find("." + this.widgetFullName + "[data-uuid='" + this.uuid + "']").length > 0;
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the Table according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      this.element.empty();
      // table
      var table = $("<div>").addClass("preconfiguredtable");
      this.element.append(table);
      // empty panel
      this.element.append($("<div>").text(this.options.noItemsText).addClass("pct_noItemToShowPanel").hide());
      var defaultOptions = {
        "editCellEvent": false,
        "keyUniqID": "_id",
        "language": "en",
        "classes": "cf-table",
        "searchingThrottleDelay": 400
      };
      if (typeof this.options.collection === "string" && this.options.collection.indexOf("whitepaperCRUD.") === 0) {
        defaultOptions.searchingThrottleDelay = 800;
      }
      var options = $.extend(true, defaultOptions, this._prepareTableOptions(this.options.tableOptions));
      options.language = this.options.language;
      options.dataProvider = this._dataProvider.bind(this);
      options.countProvider = this._countProvider.bind(this);
      options.dataExists = this._dataExists.bind(this);
      options.dataUpdater = this._dataUpdater.bind(this);
      if (Array.isArray(options.columns) === false) {
        options.columns = [];
      }
      if (options.showRowCounter === true && this.options.asyncCount === false) {
        this.askCountOnList = true;
      }
      if (this.rowConditions !== null) {
        options.rowClassKey = "_nixps_preconfiguredtable_row_class";
      }
      if (typeof this.options.width === "string") {
        this.options.width = this.options.width.trim();
      }
      if (this.options.width === "100%" && options.classes.indexOf("cf-table-fullwidth") < 0) {
        // add class
        options.classes += " cf-table-fullwidth";
      } else if (this.options.width !== "100%") {
        if (options.classes.indexOf("cf-table-fullwidth") >= 0) {
          // remove class
          var classNameIndex = options.classes.indexOf("cf-table-fullwidth");
          options.classes = options.classes.substring(0, classNameIndex) + options.classes.substring(classNameIndex + 18);
        }
        if (typeof this.options.width === "string" && this.options.width.length > 0 || typeof this.options.width === "number" && this.options.width > 0) {
          table.css("width", this.options.width);
        }
      }
      if (this.options.optimizeForContent === false) {
        options.classes += " cf-table-fittwidth";
      }
      if (this.options.optimizeForMobile === true && options.classes.indexOf("cf-table-mobile") < 0) {
        options.classes += " cf-table-mobile";
      }
      if (typeof this.options.pagebuilderStyleType === "string" && this.options.pagebuilderStyleType.length > 0) {
        options.classes += " cf-table-customized";
      }
      if (this.options.enableUserConfig === true) {
        if (typeof this.options.configID === "string" && this.options.configID.length > 10 && this.options.configID !== "<config_id>") {
          options.configColumns = {};
          options.configTableID = this.options.configID;
        }
      }
      options.additionalTypes = $.extend([], extendedAdditionTypes, this._getAdditionalTypes());
      if (this.options.enableCollapsible === true) {
        if (options.columns.some(function (pColumn) {
          return pColumn !== undefined && pColumn.type === "collapsible";
        }) === false) {
          var collapsbleColumn = {
            label: "",
            noCollapsibleColumn: true,
            type: "collapsible",
            key: ".",
            sortable: false,
            searchable: false,
            cellClass: "fix_width_30 pct_collapsible_container",
            headerClass: "fix_width_30 pct_collapsible_container_header"
          };
          if (options.columns.length > 0 && options.columns[0].type === "selectCheckbox") {
            // move selectCheckBox to front
            var selectCheckBox = options.columns.shift();
            options.columns.unshift(collapsbleColumn);
            options.columns.unshift(selectCheckBox);
          } else {
            options.columns.unshift(collapsbleColumn);
          }
        }
      }
      this.isMobile = options.classes.indexOf("cf-table-mobile") >= 0 && Device.hasMobileWidth();
      if (this.isMobile) {
        if (this.options.topbarbuttons.length > 0 /*|| options.columns.some(function(pColumn){ return pColumn !== undefined && ["remove", "edit"].includes(pColumn.type);})*/) {
          options.columns.push({
            label: "",
            type: "settings_mobile",
            key: ".",
            sortable: false,
            searchable: false,
            cellClass: "cf-table-settingscolumncell",
            headerClass: "cf-table-settingscolumncell"
          });
        }
      }
      // add topbar buttons 
      var buttonBarButtons = [];
      if (this.options.topbarbuttons.length > 0) {
        if (options.columns.some(function (pColumn) {
          return pColumn !== undefined && pColumn.type === "selectCheckbox";
        }) === false) {
          options.columns.unshift({
            label: "",
            type: "selectCheckbox",
            key: ".",
            sortable: false,
            searchable: false,
            cellClass: "tablerowinputselector",
            headerClass: "tablerowinputselectorheader"
          });
        }
        var topbar = $("<div>");
        this.element.prepend(topbar);
        buttonBarButtons = this.options.topbarbuttons.filter(function (bttn) {
          return [undefined, "topbarbutton", "topbarcontextbutton"].includes(bttn.button_type);
        });
        topbar.ButtonsBarTableExtension({
          "buttons": buttonBarButtons,
          "listDOM": table,
          "listSelector": ".nixps-cloudflow-Table",
          "listComponentName": "Table",
          "listgetRowsMethodeName": "getSelectedRows",
          "listgetRowIDsMethodeName": "getSelectedRowIDs"
        });
        var contextMenuButtons = this.options.topbarbuttons.filter(function (bttn) {
          return [undefined, "contextbutton", "topbarcontextbutton"].includes(bttn.button_type);
        });
        if (Array.isArray(contextMenuButtons) && contextMenuButtons.length > 0) {
          this.mContextmenu = $("<div>").addClass("nixps_styling_constants_bodybackground");
          if (this.isMobile) {
            $("body").append(this.mContextmenu);
          } else {
            this.element.prepend(this.mContextmenu);
          }
          this.mContextmenu.ContextMenuTableExtension({
            "buttons": contextMenuButtons,
            "listDOM": table,
            "listSelector": ".nixps-cloudflow-Table",
            "listComponentName": "Table",
            "listgetRowsMethodeName": "getSelectedRows",
            "listgetRowIDsMethodeName": "getSelectedRowIDs",
            "mobileSlidePanel": this.isMobile,
            "buttonclick": function buttonclick(pEvent, pData) {
              that.element.trigger("buttonsbartableextension" + pData.triggername, pData.data);
            }
          });
        }

        // make sure the topbar buttons stay sticky to the top
        if (options.enableStickyHeader === true) {
          topbar.addClass("cf-sticky-top nixps_styling_constants_bodybackground");
          if (options.stickyHeaderAppliedBy === undefined || options.stickyHeaderAppliedBy === "js") {
            if (buttonBarButtons.some(function (b) {
              return b.predefinedType === "button_group";
            })) {
              // make sure the sub menu goes over the headers
              topbar.addClass("cf-zindex-dropdownlist-low"); // the stickHeader has a z-index of 3, so set one level higher
            }

            this.listenToResize = true;
            options.stickyHeaderMarginTop = topbar.height() || 27;
            this.fixedScrollingHeight = 0;
            // #59258 when a parent has a fixed possition and has top padding
            // we should add that padding to the calculations
            var paddingsDOMs = this.element.closest(".cf-pagecontent.cf-pagecontent-addpadding");
            if (paddingsDOMs.length === 1 && typeof window.getComputedStyle === "function") {
              var computedStyles = getComputedStyle(paddingsDOMs[0], null);
              var position = computedStyles.getPropertyValue("position");
              var extraPadding = computedStyles.getPropertyValue("padding-top");
              extraPadding = parseFloat(extraPadding);
              if (position === "fixed" && isFinite(extraPadding) && !isNaN(extraPadding)) {
                this.fixedScrollingHeight = extraPadding;
                options.stickyHeaderMarginTop += extraPadding;
              }
            }
            if (buttonBarButtons.length > 0) {
              options.stickyTableHeadersParent = this.element;
            }
          }
        }
      }
      // add advanced filter panel
      this.element.prepend($("<div>").addClass("advancedfilterpanel").hide());
      if (this.options.showAdvancedFiltersOnStart === true) {
        this._openAdvancedFilter();
      }
      table.Table(options);
      this.isSelecting = table.Table("option", "selecting") !== null;
    },
    /**
     * @description Preprocess the return data
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_preprossesData
     * @private
     * @param {Array.<Object>} pRows 
     * @returns {Array.<Object>} The rows to be passed to the table component
     */
    _preprossesData: function _preprossesData(pRows, pCount) {
      if (this.rowConditions !== null) {
        // loop over all rows
        for (var r = 0; r < pRows.length; r++) {
          // for each row loop over all conditions
          for (var c = 0; c < this.rowConditions.length; c++) {
            if (this.rowConditions[c].queryApplier.validate(pRows[r]) === true) {
              pRows[r]["_nixps_preconfiguredtable_row_class"] = this.rowConditions[c]["class"];
              break; // stop on first valid condition
            }
          }
        }
      }

      if (typeof pCount === "number") {
        return {
          results: pRows,
          count: pCount
        };
      }
      return pRows;
    },
    /**
     * @description option function of table to give the needed data
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_dataProvider
     * @private
     * @param {Array} pQuery 
     * @param {Array} pOrderby 
     * @param {Number} pSkip 
     * @param {Number} pLimit 
     */
    _dataProvider: function _dataProvider(pQuery, pOrderby, pSkip, pLimit) {
      if (this.dead === true) {
        // we are a zombie, do not continue
        return Promise.reject({
          error_code: "call_after_destroy",
          error: "component is not active"
        });
      }
      // ignore the extraQuery, the Query.apply can not handle them!
      if (this.collection === "object") {
        var rows = Query.apply(this.collectionArray, pQuery, pOrderby, pSkip, pLimit);
        this.dataProviderDef = this._preprossesData(rows);
        this.element.children(".pct_noItemToShowPanel").toggle(rows.length === 0);
        return this.dataProviderDef;
      }
      var that = this;
      if (Array.isArray(this.options.extraQuery) && this.options.extraQuery.length > 0) {
        if (Array.isArray(pQuery) && pQuery.length > 0) {
          pQuery.push("and");
          pQuery.push("(");
          pQuery = pQuery.concat(this.options.extraQuery);
          pQuery.push(")");
        } else {
          pQuery = pQuery.concat(this.options.extraQuery);
        }
      }
      if (Array.isArray(this.advancedFilter) && this.advancedFilter.length > 0) {
        if (Array.isArray(pQuery) && pQuery.length > 0) {
          pQuery.push("and");
          pQuery.push("(");
          pQuery = pQuery.concat(this.advancedFilter);
          pQuery.push(")");
        } else {
          pQuery = pQuery.concat(this.advancedFilter);
        }
      }
      if (Array.isArray(this.quickSearchFilter) && this.quickSearchFilter.length > 0) {
        if (Array.isArray(pQuery) && pQuery.length > 0) {
          pQuery.push("and");
          pQuery.push("(");
          pQuery = pQuery.concat(this.quickSearchFilter);
          pQuery.push(")");
        } else {
          pQuery = pQuery.concat(this.quickSearchFilter);
        }
      }
      if (this.collection === "whitepaperCRUD") {
        this.collectionCRUDconnection.stop("start_next_list_call");
        (function (pCallingID) {
          that.dataProviderDef = $.Deferred(function (pDefer) {
            that.collectionCRUDconnection.list_with_options(pQuery, pOrderby, [], {
              first: pSkip,
              maximum: pLimit
            }, function (pResults) {
              if (pCallingID < that.callingID) {
                pDefer.reject({
                  expected: true,
                  message: "wrong_callingid"
                });
              } else if (pResults === undefined || pResults === null || Array.isArray(pResults.results) === false) {
                that._errorHandler({
                  "error_code": "wrong_return_interface",
                  "error": $.i18n._("nixps-cloudflow-preconfiguredtable.errormessage_wrong_returninterface")
                });
                pDefer.reject({
                  "error_code": "wrong_return_interface",
                  "error": "wrong returning interface, i'm expect an array results"
                });
              } else {
                that.element.children(".pct_noItemToShowPanel").toggle(pResults.results.length === 0);
                if (pLimit > 0 && pResults.results.length > pLimit + 5) {
                  that._errorHandler({
                    "error_code": "dbio_too_much_returned",
                    "error": "DBIO returned too much data"
                  });
                }
                pDefer.resolve(that._preprossesData(pResults.results, pResults.count));
              }
            }, function (pError) {
              // ignore next errors
              if (pError !== undefined && pError.error === "stop_called") {
                pDefer.reject({
                  expected: true,
                  message: pError.error
                });
                return;
              }
              // warn users for it
              if (pError !== undefined && pError.error === "no_results") {
                that._errorHandler({
                  "error_code": "error_in_workflow",
                  "error": $.i18n._("nixps-cloudflow-preconfiguredtable.errormessage_in_workflow")
                });
              } else {
                that._errorHandler(pError);
              }
              pDefer.reject(pError);
            });
            that._startBlokking(950, pQuery, pOrderby, pSkip, pLimit);
          }).always(function () {
            that._endBlokking(pCallingID);
          });
        })(++this.callingID);
        return this.dataProviderDef;
      }
      if (this.collection === "file") {
        return $.Deferred(function (pDefer) {
          var options = {
            first: pSkip,
            maximum: pLimit,
            count: true
          };
          that.collectionFileConnection.list_with_options(pQuery, pOrderby, [], options, function (pResults) {
            that.element.children(".pct_noItemToShowPanel").toggle(pResults.results.length === 0);
            pDefer.resolve(that._preprossesData(pResults.results, pResults.count));
          }, function (pError) {
            if (pError.error === "deprecated_results") {
              // error caused by own code, error is expected
              pDefer.reject({
                expected: true
              });
            } else {
              var error = that.collectionFileConnection.getError();
              that._errorHandler(error);
              pDefer.reject(error);
            }
          });
        });
      } else if (this.collection.startsWith("resource.") || this.collection.startsWith("assetmetadata.")) {
        var connection = new CloudflowConnection({
          collection: this.options.collection,
          assetmetadataEnclosingFolder: this.options.assetmetadataEnclosingFolder,
          error_cb: function error_cb(pMain, pError) {
            that._errorHandler({
              "error_code": "could_not_list",
              "error": "could not list rows"
            }, pError);
          }
        });
        return connection.list_with_options(pQuery, pOrderby, [], pSkip, pLimit, that.askCountOnList === true || this.collection.startsWith("resource.")).then(function (pResult) {
          if (pResult && Array.isArray(pResult.results) && that.collection.startsWith("assetmetadata.")) {
            for (var i = 0; i < pResult.results.length; i++) {
              pResult.results[i].__rowClass = "";
              if (pResult.results[i].need_metadata !== undefined) {
                pResult.results[i].__rowClass = "tablerow_need_metadata";
              }
            }
          }
          return pResult;
        });
      }
      this.dataProviderDef = $.Deferred(function (pDefer) {
        var options = {
          first: pSkip,
          maximum: pLimit
        };
        if (that.askCountOnList === true) {
          options.count = true;
        }
        DatabaseConnection.list_with_options(that.collection, pQuery, pOrderby, [], options, function (pResults) {
          that.element.children(".pct_noItemToShowPanel").toggle(pResults.results.length === 0);
          pDefer.resolve(that._preprossesData(pResults.results, pResults.count));
        }, function (pError) {
          that._errorHandler(pError);
          pDefer.reject(pError);
        });
      });
      return this.dataProviderDef;
    },
    /**
     * @description option function of table to get the amount of rows
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_countProvider
     * @param {Array<String>} pQuery 
     * @param {Array<String>} pOrderby 
     * @param {Number} pSkip 
     * @param {Number} pLimit 
     */
    _countProvider: function _countProvider(pQuery, pOrderby, pSkip, pLimit) {
      if (this.dead === true) {
        // we are a zombie, do not continue
        return Promise.reject({
          error_code: "call_after_destroy",
          error: "component is not active"
        });
      }
      // ignore the extraQuery, the Query.apply can not handle them!
      if (this.collection === "object") {
        this.countProviderDef = Query.apply(this.collectionArray, pQuery, pOrderby, pSkip, pLimit);
        return this.countProviderDef;
      }
      var that = this;
      if (Array.isArray(this.options.extraQuery) && this.options.extraQuery.length > 0) {
        if (Array.isArray(pQuery) && pQuery.length > 0) {
          pQuery.push("and");
          pQuery.push("(");
          pQuery = pQuery.concat(this.options.extraQuery);
          pQuery.push(")");
        } else {
          pQuery = pQuery.concat(this.options.extraQuery);
        }
      }
      if (Array.isArray(this.advancedFilter) && this.advancedFilter.length > 0) {
        if (Array.isArray(pQuery) && pQuery.length > 0) {
          pQuery.push("and");
          pQuery.push("(");
          pQuery = pQuery.concat(this.advancedFilter);
          pQuery.push(")");
        } else {
          pQuery = pQuery.concat(this.advancedFilter);
        }
      }
      if (Array.isArray(this.quickSearchFilter) && this.quickSearchFilter.length > 0) {
        if (Array.isArray(pQuery) && pQuery.length > 0) {
          pQuery.push("and");
          pQuery.push("(");
          pQuery = pQuery.concat(this.quickSearchFilter);
          pQuery.push(")");
        } else {
          pQuery = pQuery.concat(this.quickSearchFilter);
        }
      }
      // check if we are not beyond or limits?
      if (this.runningCountCalls >= 3) {
        this.countProviderDef = $.Deferred().reject("too many calls");
        return this.countProviderDef;
      }
      if (this.collection === "whitepaperCRUD") {
        this.collectionCRUDconnection.stop("start_next_count_call");
        (function (pCallingID) {
          that.countProviderDef = $.Deferred(function (pDefer) {
            that.runningCountCalls++;
            that.collectionCRUDconnection.count(pQuery, function (pResult) {
              if (pCallingID < that.countCallingID) {
                pDefer.reject({
                  expected: true,
                  message: "wrong_callingid"
                });
              } else if (pResult === undefined || pResult === null || typeof pResult.count !== "number" || pResult.count < 0) {
                that._errorHandler({
                  "error_code": "wrong_return_interface",
                  "error": $.i18n._("nixps-cloudflow-preconfiguredtable.errormessage_wrong_returninterface")
                });
                pDefer.reject({
                  "error_code": "wrong_return_interface",
                  "error": "wrong returning interface, i'm expect an array results"
                });
              } else {
                pDefer.resolve(pResult.count);
              }
            }, function (pError) {
              // ignore next errors
              if (pError !== undefined && pError.error === "stop_called") {
                pDefer.reject({
                  expected: true,
                  message: pError.error
                });
                return;
              }
              // warn users for it
              if (pError !== undefined && pError.error === "no_results") {
                that._errorHandler({
                  "error_code": "workflow_error",
                  "error": $.i18n._("nixps-cloudflow-preconfiguredtable.errormessage_in_workflow")
                });
              } else {
                that._errorHandler(pError);
              }
              pDefer.reject(pError);
            });
          }).always(function () {
            that.runningCountCalls--;
          });
        })(++this.countCallingID);
        return this.countProviderDef;
      }
      if (this.collection === "file") {
        this.runningCountCalls++;
        return $.Deferred(function (pDefer) {
          that.collectionFileConnection.count(pQuery, function (pResults) {
            that.runningCountCalls--;
            if (pResults && typeof pResults.count === "number") {
              pDefer.resolve(pResults.count);
            } else {
              var error = {
                "error_code": "wrong_return_interface",
                "error": "wrong returning count interface"
              };
              that._errorHandler(error);
              pDefer.reject(error);
            }
          }, function (pError) {
            that.runningCountCalls--;
            if (pError.error === "deprecated_results") {
              // error caused by own code, error is expected
              pDefer.reject({
                expected: true
              });
            } else {
              that.runningCountCalls--;
              that._errorHandler(pError);
              pDefer.reject(pError);
            }
          });
        });
      } else if (this.collection.startsWith("resource.") || this.collection.startsWith("assetmetadata.")) {
        var connection = new CloudflowConnection({
          collection: this.options.collection,
          assetmetadataEnclosingFolder: this.options.assetmetadataEnclosingFolder,
          error_cb: function error_cb(pMain, pError) {
            that._errorHandler({
              "error_code": "could_not_count",
              "error": "could not count"
            }, pError);
          }
        });
        return connection.count(pQuery, [], [], {});
      }
      this.countProviderDef = $.Deferred(function (pDefer) {
        that.runningCountCalls++;
        DatabaseConnection.count(that.collection, pQuery, function (pResults) {
          that.runningCountCalls--;
          if (pResults !== undefined) {
            pDefer.resolve(pResults);
          } else {
            var errorMessage = "wrong returning count interface";
            that._errorHandler({
              "error_code": "wrong_return_interface",
              "error": errorMessage
            });
            pDefer.reject(errorMessage);
          }
        }, function (pError) {
          that.runningCountCalls--;
          that._errorHandler(pError);
          pDefer.reject(pError);
        });
      });
      return this.countProviderDef;
    },
    /**
     * @description option function of table to check if the selected rows are still existing
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_dataExists
     * @param {Array} pIDs 
     */
    _dataExists: function _dataExists(pIDs) {
      var that = this;
      if (this.collection === "object") {
        return pIDs;
      }
      var query = [this.options.tableOptions.keyUniqID, "in", pIDs];
      if (Array.isArray(this.options.extraQuery) && this.options.extraQuery.length > 0) {
        query.push("and");
        query.push("(");
        query = query.concat(this.options.extraQuery);
        query.push(")");
      }
      if (Array.isArray(this.advancedFilter) && this.advancedFilter.length > 0) {
        query.push("and");
        query.push("(");
        query = query.concat(this.advancedFilter);
        query.push(")");
      }
      if (Array.isArray(this.quickSearchFilter) && this.quickSearchFilter.length > 0) {
        query.push("and");
        query.push("(");
        query = query.concat(this.quickSearchFilter);
        query.push(")");
      }
      if (this.collection === "whitepaperCRUD") {
        this.collectionCRUDconnectionExists.stop("start_next_dataexists_call");
        return $.Deferred(function (pDefer) {
          that.collectionCRUDconnectionExists.list_with_options(query, [], [], {}, function (pResults) {
            if (pResults === undefined || Array.isArray(pResults.results) === false) {
              that._errorHandler({
                "error_code": "wrong_return_interface",
                "error": $.i18n._("nixps-cloudflow-preconfiguredtable.errormessage_wrong_returninterface")
              });
              pDefer.reject({
                "error_code": "wrong_return_interface",
                "error": "wrong returning interface, i'm expect an array results"
              });
            } else {
              pDefer.resolve(pResults.results);
            }
          }, function (pError) {
            if (pError !== undefined && pError.error === "stop_called") {
              pDefer.reject({
                expected: true,
                message: pError.error
              });
              return;
            }
            pDefer.reject(pError);
          });
        });
      } else if (this.collection === "file") {
        var that = this;
        return $.Deferred(function (pDefer) {
          that.collectionFileConnection.list_with_options(query, [], [], {}, function (pResults) {
            pDefer.resolve(pResults.results);
          }, function (pError) {
            if (pError.error === "deprecated_results") {
              // error caused by own code, error is expected
              pDefer.reject({
                expected: true
              });
            } else {
              var error = that.collectionFileConnection.getError();
              that._errorHandler(error);
              pDefer.reject(error);
            }
          });
        });
      } else if (this.collection.startsWith("resource.") || this.collection.startsWith("assetmetadata.")) {
        var connection = new CloudflowConnection({
          collection: this.options.collection,
          assetmetadataEnclosingFolder: this.options.assetmetadataEnclosingFolder,
          error_cb: function error_cb(pMain, pError) {
            that._errorHandler({
              "error_code": "could_not_update",
              "error": "could not update row"
            }, pError);
          }
        });
        return connection.list_with_options(query, [], [], 0).then(function (pResult) {
          if (pResult && pResult.results) {
            return pResult.results;
          }
          return [];
        });
      }
      return $.Deferred(function (pDefer) {
        DatabaseConnection.list_with_options(that.collection, query, [], [], {}, function (pResults) {
          pDefer.resolve(pResults.results);
        }, function (pError) {
          that._errorHandler(pError);
          pDefer.reject(pError);
        });
      });
    },
    /**
     * @description A callback function when data has changed
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_dataUpdater
     * @param {Object} pNewObject the new updated object
     * @param {Object} pColumnOptions the options of the column
     * @param {Object} pOldObject the old, previous object
     */
    _dataUpdater: function _dataUpdater(pNewObject, pColumnOptions, pOldObject) {
      var that = this;
      var connection = new CloudflowConnection({
        collection: this.options.collection,
        data: this.options.collectionArray,
        dataFileURL: this.options.dataFileURL,
        httpserviceInputName: this.options.httpserviceInputName,
        httpserviceWhitepaperName: this.options.httpserviceWhitepaperName,
        assetmetadataEnclosingFolder: this.options.assetmetadataEnclosingFolder,
        error_cb: function error_cb(pMain, pError) {
          that._errorHandler({
            "error_code": "could_not_update",
            "error": "could not update row"
          }, pError);
        }
      });
      var rowUniqueID = CloudflowObject.getParameter(pOldObject, this.options.tableOptions.keyUniqID);
      if (typeof rowUniqueID !== "string" && typeof rowUniqueID !== "number") {
        rowUniqueID = CloudflowObject.getParameter(pNewObject, this.options.tableOptions.keyUniqID);
        if (typeof rowUniqueID !== "string" && typeof rowUniqueID !== "number") {
          throw new Error("unknown row id");
        }
      }
      // if key has deeper level then 0, so contains a dot
      // the updata object must contain a key with a dot
      var updateObject = {};
      updateObject[pColumnOptions.key] = CloudflowObject.getParameter(pNewObject, pColumnOptions.key);
      if (typeof pNewObject.save_id === "string" && pNewObject.save_id.length > 0) {
        updateObject["save_id"] = pNewObject.save_id;
      }
      var oldObject = {};
      oldObject[pColumnOptions.key] = CloudflowObject.getParameter(pOldObject, pColumnOptions.key);
      var options = {
        keyUniqID: this.options.tableOptions.keyUniqID,
        oldKeyData: oldObject
      };
      return connection.set_keys(rowUniqueID, updateObject, options).always(function () {
        // when starting we have stoped the timer, so reactive it now
        that._triggerTimer();
      });
    },
    /**
     * @description trigger a new refresh of the table
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_triggerTimer
     * @return {undefined}
     */
    _triggerTimer: function _triggerTimer() {
      clearTimeout(this.refreshTimerID);
      if (this.options.refreshDelay > 0) {
        this.refreshTimerID = this._delay(function () {
          if (this.dead === true) {
            return; // we are zombie
          }

          if (this.element.is(":visible") === true && Device.continuePolling(this.uuid)) {
            // loading triggers the next timer
            this.refreshData(null, true, true, this.options.forceCollapsePanelToUpdateWhenOpen);
          } else {
            // trigger next timer
            this._triggerTimer();
          }
        }, Device.getPollingFactor(this.uuid) * this.options.refreshDelay + this.extraErrorDelay);
      }
    },
    /**
     * @description stop the timer, you can reactive it be calling _triggerTimer
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_stopTimer
     * @returns {undefined}
     */
    _stopTimer: function _stopTimer() {
      clearTimeout(this.refreshTimerID);
    },
    /**
     * @description handle errors, show them, and log them
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_errorHandler
     * @param {mixed} pError the main error
     * @param {mixed} pSubError the suberror
     */
    _errorHandler: function _errorHandler(pError, pSubError) {
      console.error(this.widgetFullName, pError, pSubError || "");
      this._trigger("error", null, pError);
      LogListener.addLog({
        event_type: "error",
        details_data: pError,
        component_name: this.widgetFullName
      }, this.element);
    },
    /**
     * @description show and if needed create the query builder ui
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_openAdvancedFilter
     * @returns {Object} empty object
     */
    _openAdvancedFilter: function _openAdvancedFilter() {
      if ($.isPlainObject(this.options.advancedFilterOptions)) {
        if (Array.isArray(this.options.advancedFilterOptions.collection) && this.options.advancedFilterOptions.collection.length > 0) {
          var panel = this.element.children(".advancedfilterpanel").css("display", "");
          if (panel.hasClass("nixps-cloudflow-CloudflowQueryPanel") === false) {
            if (typeof this.options.configID === "string" && this.options.configID.length > 10 && this.options.configID !== "<config_id>") {
              panel.CloudflowQueryPanel(Object.assign({
                defaultQuery: [],
                groupContext: "pagebuilder_table",
                saveContext: "configid_" + this.options.configID,
                showCloseButton: true,
                showConfigurationButton: true,
                querysProvider: "backend_readtimestamp"
              }, this.options.advancedFilterOptions));
            }
          }
        }
      }
      return {};
    },
    /**
     * @description hide the query builder ui
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_closeAdvancedFilter
     * @returns {Object} empty object
     */
    _closeAdvancedFilter: function _closeAdvancedFilter() {
      this.element.children(".advancedfilterpanel").hide();
      // clear the query, set query to [] empty array
      if (this.advancedFilter.length > 0) {
        this.advancedFilter = [];
        return this.refreshData(null, true, true).then(function () {
          return {};
        });
      }
      return {};
    },
    /**
     * @description Toggle the advanced filter panel
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#toggleAdvancedFilter
     * @param {Boolean} pMode true will show, false will hide, undefined will switch between visible and hide
     * @returns {Object} empty object
     */
    toggleAdvancedFilter: function toggleAdvancedFilter(pMode) {
      if (this.collection === "object") {
        // no support
        LogListener.addLog({
          event_type: "error",
          details_data: {
            error_code: "advancedfilter_not_supported",
            error: "advanced filytering is not supported on static collection"
          },
          component_name: this.widgetFullName
        }, this.element);
      }
      if (pMode === true) {
        return this._openAdvancedFilter();
      } else if (pMode === false) {
        return this._closeAdvancedFilter();
      } else {
        if (this.element.children(".advancedfilterpanel").is(":visible")) {
          return this._closeAdvancedFilter();
        } else {
          return this._openAdvancedFilter();
        }
      }
    },
    /**
     * @description Delete a row from the database
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_deleteRowObject
     * @param {String} pRowID
     * @return {Deferred}
     */
    _deleteRowObject: function _deleteRowObject(pRowID, pRowObject) {
      if (typeof pRowID !== "string" || pRowID.length <= 0) {
        throw new Error("input parameter pRowID must be a not empty string");
      }
      if (this._trigger("deleting", null, {
        "id": pRowID,
        "rowObject": pRowObject,
        "collection": this.collection
      }) === false) {
        return false;
      }
      var that = this;
      var connection = new CloudflowConnection({
        collection: this.options.collection,
        data: this.options.collectionArray,
        dataFileURL: this.options.dataFileURL,
        httpserviceInputName: this.options.httpserviceInputName,
        httpserviceWhitepaperName: this.options.httpserviceWhitepaperName,
        assetmetadataEnclosingFolder: this.options.assetmetadataEnclosingFolder,
        error_cb: function error_cb(pMain, pError) {
          that._errorHandler({
            "error_code": "could_not_delete",
            "error": "could not delete row"
          }, pError);
        }
      });
      var deleteConfirmationOptions = CloudflowConnection.getDeleteConfimationTitles(this.collection, [pRowObject], this.options.deleteConfirmationTitle, this.options.deleteConfirmationMessage, this.options.deleteConfirmationMessageRowObjectParameter);
      return $("body").Dialog("show_delete_no", deleteConfirmationOptions.title, deleteConfirmationOptions.message, function () {}, function () {}).then(function (pResult) {
        if (pResult !== undefined && pResult.type === "delete") {
          if (that.collection === "whitepaperCRUD") {
            that._startBlokking(950, ["delete"], [], undefined, undefined);
          }
          return $.Deferred(function (pDefer) {
            connection["delete"](pRowID).then(function () {
              that.refreshData(null, true, true).then(function () {
                that._trigger("delete", null, {
                  id: pRowID,
                  rowObject: pRowObject
                });
                pDefer.resolve({
                  id: pRowID,
                  rowObject: pRowObject
                });
              }, function (pError) {
                console.error("refresh after deleted failed ", pError);
                pDefer.reject(pError);
              });
            }, function (pError) {
              that._endBlokking(that.callingID);
              console.error(pError);
              pDefer.reject(pError);
            });
          });
        }
      });
    },
    /**
     * @description Delete all the selected row objects
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#deleteSelectedRowObjects
     * @returns {Deferred}
     */
    deleteSelectedRowObjects: function deleteSelectedRowObjects() {
      var that = this;
      var connection = new CloudflowConnection({
        collection: this.options.collection,
        data: this.options.collectionArray,
        dataFileURL: this.options.dataFileURL,
        httpserviceInputName: this.options.httpserviceInputName,
        httpserviceWhitepaperName: this.options.httpserviceWhitepaperName,
        assetmetadataEnclosingFolder: this.options.assetmetadataEnclosingFolder,
        error_cb: function error_cb(pMain, pError) {
          that._errorHandler({
            "error_code": "could_not_delete",
            "error": "could not delete the selected rows"
          }, pError);
        }
      });
      var selectedRowIDs = this.element.children(".preconfiguredtable").Table("getSelectedRowIDs");
      if (Array.isArray(selectedRowIDs) && selectedRowIDs.length > 0) {
        var selectedRows = this.element.children(".preconfiguredtable").Table("getSelectedRows");
        var deleteConfirmationOptions = CloudflowConnection.getDeleteConfimationTitles(this.collection, selectedRows, this.options.deleteConfirmationTitle, this.options.deleteConfirmationMessage, this.options.deleteConfirmationMessageRowObjectParameter);
        return $("body").Dialog("show_delete_no", deleteConfirmationOptions.title, deleteConfirmationOptions.message, function () {}, function () {}).then(function (pResult) {
          if (pResult !== undefined && pResult.type === "delete") {
            if (that.collection === "whitepaperCRUD") {
              that._startBlokking(950, ["delete"], [], undefined, undefined);
            }
            return $.Deferred(function (pDefer) {
              connection.delete_by_query([that.options.tableOptions.keyUniqID, "in", selectedRowIDs]).then(function () {
                that.refreshData(null, true, true).then(function () {
                  that._trigger("deleteselected", null, {
                    ids: selectedRowIDs
                  });
                  pDefer.resolve({
                    type: "yes",
                    ids: selectedRowIDs
                  });
                }, function (pError) {
                  console.error("refresh after delete failed ", pError);
                  pDefer.reject(pError);
                });
              }, function (pError) {
                that._endBlokking(that.callingID);
                console.error(pError);
                pDefer.reject(pError);
              });
            });
          }
          return {
            type: pResult.type,
            ids: selectedRowIDs
          };
        });
      }
      return $.Deferred().resolve({
        type: "ignore",
        ids: []
      });
    },
    /**
     * @description Get the selected rows of the table
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#getSelectedRows
     * @returns {Object} the information about the selected rows
     */
    getSelectedRows: function getSelectedRows() {
      var tableDOM = this.element.children(".preconfiguredtable");
      var ids = tableDOM.Table("getSelectedRowIDs");
      var rowObjects = tableDOM.Table("getSelectedRows");
      return {
        "ids": ids,
        "rowObjects": rowObjects,
        "amountSelected": ids.length
      };
    },
    _showMobileContextMenu: function _showMobileContextMenu(pEvent, pRowID, pRowObject) {
      if (typeof pRowID !== "string" || pRowID.length <= 0) {
        throw new Error("input parameter pRowID must be a not empty string");
      }
      if (this.mContextmenu !== undefined && this.mContextmenu !== null) {
        this.mContextmenu.ContextMenuTableExtension("show", null);
      }
    },
    /**
     * @description prepare the options before giving to the table component
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_prepareTableOptions
     * @param {Object} pTableOptions
     * @return {undefined}
     */
    _prepareTableOptions: function _prepareTableOptions(pTableOptions) {
      if (Array.isArray(pTableOptions.columns)) {
        // remove column type "remove", "edit" if user has not the correct permission
        for (var i = pTableOptions.columns.length - 1; i >= 0; i--) {
          if (pTableOptions.columns[i].type === "remove" && CloudflowConnection.isAllowedToDelete(this.collection, this.user) === false) {
            pTableOptions.columns.splice(i, 1);
          } else if (pTableOptions.columns[i].type === "edit" && CloudflowConnection.isAllowedToUpdate(this.collection, this.user) === false) {
            pTableOptions.columns.splice(i, 1);
          } else {
            pTableOptions.columns[i].label = _.escape(pTableOptions.columns[i].label);
            if (pTableOptions.columns[i].editable === undefined) {
              pTableOptions.columns[i].editable = false; // default on false
            }
          }
        }

        if (Array.isArray(this.options.eventtriggerLayoutInfo) && this.options.eventtriggerLayoutInfo.length > 0) {
          var eventtriggerLayoutInfoDict = {};
          for (var i = 0; i < this.options.eventtriggerLayoutInfo.length; i++) {
            if (typeof this.options.eventtriggerLayoutInfo[i].eventname === "string" && this.options.eventtriggerLayoutInfo[i].eventname.startsWith(this.widgetName.toLowerCase())) {
              eventtriggerLayoutInfoDict[this.options.eventtriggerLayoutInfo[i].eventname] = this.options.eventtriggerLayoutInfo[i];
            }
          }
          if ($.isEmptyObject(eventtriggerLayoutInfoDict) === false) {
            for (var i = 0; i < pTableOptions.columns.length; i++) {
              if (pTableOptions.columns[i].type === "enum_mapping") {
                for (var o = 0; o < pTableOptions.columns[i].options.length; o++) {
                  var eventname = this.widgetName.toLowerCase() + "action" + pTableOptions.columns[i].options[o].action;
                  if (eventtriggerLayoutInfoDict[eventname] !== undefined) {
                    pTableOptions.columns[i].options[o].cursortype = eventtriggerLayoutInfoDict[eventname].cursortype;
                  }
                }
              } else if (pTableOptions.columns[i].type === "image") {
                if (pTableOptions.columns[i].options !== undefined && pTableOptions.columns[i].options.action !== undefined) {
                  var eventname = this.widgetName.toLowerCase() + "action" + pTableOptions.columns[i].options.action;
                  if (eventtriggerLayoutInfoDict[eventname] !== undefined) {
                    pTableOptions.columns[i].options.cursortype = eventtriggerLayoutInfoDict[eventname].cursortype;
                  }
                }
              }
            }
          }
        }
        // inject relative path
        if (typeof this.options.relativeBasePath === "string" && this.options.relativeBasePath.length > 0) {
          for (var i = 0; i < pTableOptions.columns.length; i++) {
            if (pTableOptions.columns[i].type === "enum_mapping") {
              for (var o = 0; o < pTableOptions.columns[i].options.length; o++) {
                pTableOptions.columns[i].options[o].relativeBasePath = this.options.relativeBasePath;
              }
            } else if (pTableOptions.columns[i].type === "image") {
              if (pTableOptions.columns[i].options === undefined) {
                pTableOptions.columns[i].options = {};
              }
              pTableOptions.columns[i].options.relativeBasePath = this.options.relativeBasePath;
            }
          }
        }
        if (typeof pTableOptions.editCellEvent === "string" && pTableOptions.editCellEvent.length > 1) {
          if (CloudflowConnection.isAllowedToUpdate(this.collection, this.user) === false) {
            // user may not edit the table
            pTableOptions.editCellEvent = false;
          } else {}
        }
        // lazy loading
        if (pTableOptions.maxRows >= 50) {
          for (var i = 0; i < pTableOptions.columns.length; i++) {
            if (pTableOptions.columns[i].type === "enum_mapping") {
              for (var o = 0; o < pTableOptions.columns[i].options.length; o++) {
                if (pTableOptions.columns[i].options[o].display_type === "image") {
                  pTableOptions.columns[i].options[o].display_image.loadingPolicy = "lazy";
                }
              }
            } else if (pTableOptions.columns[i].type === "image") {
              if (pTableOptions.columns[i].options === undefined) {
                pTableOptions.columns[i].options = {};
              }
              pTableOptions.columns[i].options.loadingPolicy = "lazy";
            }
          }
        }
        // fix columns _id of mongodb, it is not possible to filter on, only equal to works
        // so silencly change of column type
        if (this.collection.indexOf("nucleus.") === 0) {
          for (var i = 0; i < pTableOptions.columns.length; i++) {
            if (pTableOptions.columns[i].key === "_id" && pTableOptions.columns[i].searchable === true) {
              pTableOptions.columns[i].type = "mongounderscoreid";
            }
          }
        }
      }
      return pTableOptions;
    },
    _getAdditionalTypes: function _getAdditionalTypes() {
      return this.options.additionalTypes;
    },
    /**
     * @description Apply or reset a quick search from outside
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#quickSearch
     * @param {Array} pQuery the query to apply as a quick search
     * @param {String} pAction the refresh action "clsoe" or "open_en_refresh" 
     * @returns {Deferred} the refresh deferred
     */
    quickSearch: function quickSearch(pQuery, pAction) {
      if (this.collection === "object") {
        // no support
        LogListener.addLog({
          event_type: "error",
          details_data: {
            error_code: "quicksearch_not_supported",
            error: "quick search is not supported on static collection"
          },
          component_name: this.widgetFullName
        }, this.element);
      }
      if (pQuery === undefined || pQuery === null || pQuery === "") {
        this.quickSearchFilter = [];
      } else if (typeof pQuery === "string" && pQuery.length > 0) {
        this.quickSearchFilter = ["searchstring", "contains text like", pQuery];
      } else if (Array.isArray(pQuery)) {
        this.quickSearchFilter = pQuery.slice(); // copy
        if (pQuery.length === 3 && pQuery[1].indexOf("contains") === 0 && pQuery[2] === "") {
          // clear out the quickSearchFilter
          this.quickSearchFilter = [];
        }
      } else {
        throw new Error("unsupported query for the quickSearch");
      }
      if (typeof pAction !== "string" || pAction.length <= 0) {
        pAction = "close";
      }
      return this.refresh(pAction, true).then(function () {
        return {};
      });
    },
    /**
     * @description Generic refresh the table with default values 
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#refresh
     * @param {String} pAction, what to do with the injected rows, choose between "close" and "open_en_refresh"
     * @param {Boolean} pKeepSelectedRows if false we will reset all the selection, default on true to keep them
     * @returns {Deferred}
     */
    refresh: function refresh(pAction, pKeepSelectedRows) {
      // default
      var keepPage = true;
      var keepInjectedRows = true;
      var forceRefresh = false;
      // specify 
      if (pAction === "close") {
        keepInjectedRows = false;
      } else if (pAction === "open_en_refresh") {
        keepInjectedRows = true;
        forceRefresh = true;
      }
      if (pKeepSelectedRows === false) {
        this.element.children(".preconfiguredtable").Table("unselectAllRows");
      }
      this.lastQueryHash = ""; // show waiting panel
      return this.refreshData(null, keepPage, keepInjectedRows, forceRefresh);
    },
    /**
     * @description Refresh the table. This has the same interface as {@link nixps-cloudflow.Table#refreshData}
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#refreshData
     * @param {QueryObject} pQuery
     * @param {Boolean} pKeepPage
     * @param {Boolean} pKeepInjectedRows
     * @return {undefined}
     */
    refreshData: function refreshData(pQuery, pKeepPage, pKeepInjectedRows, pForceRefresh, pOrigStateURLCPCDict) {
      if (this.dead === true) {
        // we are a zombie, do not continue
        return true;
      }
      if (this.creating === true) {
        // we are currently creating, strange...
        return true;
      }
      this._stopTimer();
      var that = this;
      this.openRowIDsDurringRefresh = [];
      if (pKeepInjectedRows === true) {
        this.openRowIDsDurringRefresh = this.element.children(".preconfiguredtable").children("table").children("tbody").children("tr").children("td.pct_collapsible_container").map(function () {
          if ($(this).find(".fa-caret-down").length === 1) {
            return $(this).closest("tr").attr("data-tablerowid");
          }
        }).get();
      }
      var currentRefreshingCallID = ++this.refreshCallingID;
      return this.element.children(".preconfiguredtable").Table("refreshData", pQuery, pKeepPage, pKeepInjectedRows).done(function () {
        if (that.refreshCallingID > currentRefreshingCallID) {
          // out of sync, call came to late
          return;
        }
        if (that.openRowIDsDurringRefresh.length > 0) {
          that.element.children(".preconfiguredtable").children("table").children("tbody").children("tr").filter(function () {
            return that.openRowIDsDurringRefresh.indexOf($(this).attr("data-tablerowid")) >= 0;
          }).find(".fa-caret-right").removeClass("fa-caret-right").addClass("fa-caret-down");
        }
        that.openRowIDsDurringRefresh = null;
        if (pForceRefresh === true) {
          var table = that.element.children(".preconfiguredtable");
          that.element.children(".preconfiguredtable").children("table").children("tbody").children("tr.tableInlineRow").each(function () {
            var newData = table.Table("getRowObject", $(this).prev("tr").children());
            if ($.isPlainObject(newData) && $.isEmptyObject(newData) === false) {
              var customPageComponentDOM = $(this).children("td").children(".nixps-pagebuilder-CustomPageComponent");
              if (customPageComponentDOM.length === 1) {
                var origStateURL = undefined;
                if ($.isPlainObject(pOrigStateURLCPCDict)) {
                  origStateURL = pOrigStateURLCPCDict[customPageComponentDOM.attr("data-uuid")] === true;
                }
                that._refreshCustompageComponentCollapse(customPageComponentDOM, newData, pForceRefresh, origStateURL);
              }
            }
          });
        }
      }).fail(function () {
        if (that.refreshCallingID > currentRefreshingCallID) {
          // out of sync, call came to late
          return;
        }
        that.openRowIDsDurringRefresh = null;
      });
    },
    /**
     * @description Get the row object from the table
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#getRowObject
     * @param {type} pDOMElement
     * @return {Object} The object corresponding to the row
     */
    getRowObject: function getRowObject(pDOMElement) {
      return this.element.children(".preconfiguredtable").Table("getRowObject", pDOMElement);
    },
    /**
     * @description Get the row object from the table
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#getColumnObject
     * @param {type} pDOMElement
     * @return {Object} The object corresponding to the row
     */
    getColumnObject: function getColumnObject(pDOMElement) {
      return this.element.children(".preconfiguredtable").Table("getColumnObject", pDOMElement);
    },
    /**
     * @description Select specific rows depending on the ids given by the parameter
     * @function
     * @deprecated use selectRows
     * @name nixps-cloudflow.PreConfiguredTable#setValue
     * @param {Array} pSelectionIDs
     * @return {undefined}
     */
    setValue: function setValue(pSelectionIDs) {
      throw new Error("function has been removed");
    },
    /**
     * @description Retrieve which rows are selected
     * @function
     * @deprecated
     * @name nixps-cloudflow.PreConfiguredTable#getValue
     * @return {Array|Object.values} The array containing all the ids of the rows who are selected, otherwise an empty array is returned
     */
    getValue: function getValue() {
      throw new Error("function has been removed");
    },
    /**
     * @description Unselect all rows of the table
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#unselectAllRows
     * @returns {undefined}
     */
    unselectAllRows: function unselectAllRows() {
      this.element.children(".preconfiguredtable").Table("unselectAllRows");
      this.element.children(".nixps-cloudflow-ButtonsBarTableExtension").ButtonsBarTableExtension("updateButtons");
    },
    /**
     * @description Select extra rows
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#selectRows
     * @param {Mixed} pRows The rowObjects or ids
     * @returns {undefined}
     */
    selectRows: function selectRows(pRowIDs) {
      this.element.children(".preconfiguredtable").Table("selectRows", pRowIDs);
      this.element.children(".nixps-cloudflow-ButtonsBarTableExtension").ButtonsBarTableExtension("updateButtons");
    },
    /**
     * @description Unselect one row
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#unselectRow
     * @param {String} pRowID The id of the row
     */
    unselectRow: function unselectRow(pRowID) {
      this.element.children(".preconfiguredtable").Table("unselectRow", pRowID);
      this.element.children(".nixps-cloudflow-ButtonsBarTableExtension").ButtonsBarTableExtension("updateButtons");
    },
    /**
     * @description disable a topbar button
     * @name nixps-cloudflow.PreConfiguredTable#disableTopBarButton
     * @param {String} pAction the action of the button
     * @param {String} pActionName the actionname of the button
     * @returns undefined
     */
    disableTopBarButton: function disableTopBarButton(pAction, pActionName) {
      return this.element.children(".nixps-cloudflow-ButtonsBarTableExtension").ButtonsBarTableExtension("disableButton", pAction, pActionName);
    },
    /**
     * @description enable a topbar button
     * @name nixps-cloudflow.PreConfiguredTable#enableTopBarButton
     * @param {String} pAction the action of the button
     * @param {String} pActionName the actionname of the button
     * @returns undefined
     */
    enableTopBarButton: function enableTopBarButton(pAction, pActionName) {
      return this.element.children(".nixps-cloudflow-ButtonsBarTableExtension").ButtonsBarTableExtension("enableButton", pAction, pActionName);
    },
    /**
     * @description Set a waiting blocking panel, freezeOverlay on the table
     * @function
     * @private
     * @name  nixps-cloudflow.PreConfiguredTable#_startBlokking
     * @param {Number} delay
     * @return {undefined}
     */
    _startBlokking: function _startBlokking(delay, pQuery, pOrderby, pSkip, pLimit) {
      if (this.blokkingID === undefined && typeof delay === "number" && delay >= 0 && $.fn.FreezeOverlay !== undefined) {
        var queryHash = pQuery.toString() + pOrderby.toString() + pSkip + pLimit;
        if (this.lastQueryHash === queryHash) {
          return;
          // do not show waiting if request was the same (in refresh mode); user did no actions
        }

        this.lastQueryHash = queryHash;
        this.blokkingID = this._delay(function () {
          this.element.find("input:focus").each(function () {
            $(this).trigger("blur").addClass("preconfiguredtable_blurred");
          });
          var freezeOverlay = $("<div>").FreezeOverlay({
            text: "",
            useFlex: true
          });
          this.element.append(freezeOverlay);
          freezeOverlay.FreezeOverlay("show");
        }, delay);
      }
    },
    /**
     * @description hide the blocking waiting panel
     * @function
     * @private
     * @name  nixps-cloudflow.PreConfiguredTable#_endBlokking
     * @param {Number} pCallingID
     * @return {undefined}
     */
    _endBlokking: function _endBlokking(pCallingID) {
      if (pCallingID < this.callingID) {
        // do not stop blocking when there are calls waiting to process
        return;
      }
      this.element.find("input.preconfiguredtable_blurred").removeClass("preconfiguredtable_blurred").focus();
      clearTimeout(this.blokkingID); // stop timer
      this.blokkingID = undefined; // clear, so the overlay can restart
      this.element.children(".nixps-FreezeOverlay").remove();
    },
    /**
     * @description Define or calc the name of the collection we must use
     * @function
     * @private
     * @name  nixps-cloudflow.PreConfiguredTable#_defineCollection
     * @return {undefined}
     */
    _defineCollection: function _defineCollection() {
      this.collection = "";
      this.rowContextJSON = null;
      // if the option collection is defined, use that.
      if (typeof this.options.collection === "string" && this.options.collection.length > 0) {
        if (this.options.collection === "object") {
          this.collection = "object";
          this.rowContextJSON = null;
        } else if (this.options.collection.startsWith("nucleus.")) {
          // there is a prefix found.
          this.collection = this.options.collection;
          this.rowContextJSON = {
            "connector": "nucleus",
            "collection": this.options.collection.substring(8)
          };
          this.options.collectionArray = [];
        } else if (this.options.collection.startsWith("dataconnector.")) {
          // there is a prefix found.
          this.collection = this.options.collection;
          this.rowContextJSON = {
            "connector": "dataconnector",
            "collection": this.options.collection.substring(14)
          };
          this.options.collectionArray = [];
        } else if (this.options.collection.startsWith("whitepaperCRUD.")) {
          var whitepaperDetails = this.options.collection.substring(15).split("/");
          if (Array.isArray(whitepaperDetails) && whitepaperDetails.length === 2) {
            this.collection = "whitepaperCRUD";
            this.rowContextJSON = {
              "connector": "startFromDBIO",
              "collection": whitepaperDetails[0],
              "key": {
                "inputname": whitepaperDetails[1]
              }
            };
            this.collectionCRUDconnection = new WhitepaperCRUD(whitepaperDetails[0], whitepaperDetails[1], "startFrom");
            this.collectionCRUDconnectionExists = new WhitepaperCRUD(whitepaperDetails[0], whitepaperDetails[1], "startFrom");
          } else {
            throw new Error("invalid whitepaperCRUD input options");
          }
          this.options.collectionArray = [];
        } else if (this.options.collection === "whitepaperHTTPService") {
          if (typeof this.options.httpserviceInputName === "string" && this.options.httpserviceInputName.length > 0 && typeof this.options.httpserviceWhitepaperName === "string" && this.options.httpserviceWhitepaperName.length > 0) {
            this.collection = "whitepaperCRUD";
            this.rowContextJSON = {
              "connector": "httpservice",
              "collection": this.options.httpserviceWhitepaperName,
              "key": {
                "inputname": this.options.httpserviceInputName
              }
            };
            this.collectionCRUDconnection = new WhitepaperCRUD(this.options.httpserviceWhitepaperName, this.options.httpserviceInputName, "httpService");
            this.collectionCRUDconnectionExists = new WhitepaperCRUD(this.options.httpserviceWhitepaperName, this.options.httpserviceInputName, "httpService");
          }
          this.options.collectionArray = [];
        } else if (this.options.collection === "file") {
          this.collection = "file";
          this.rowContextJSON = {
            "connector": "file"
          };
          if (typeof this.options.dataFileURL === "string" && this.options.dataFileURL.length > 0) {
            this.collectionFileConnection = new FileConnection(this.options.dataFileURL, this.options.relativeBasePath, "json");
            this.rowContextJSON.collection = this.options.dataFileURL;
          }
          this.options.collectionArray = [];
        } else if (this.options.collection.startsWith("resource.")) {
          // there is a prefix found.
          this.collection = this.options.collection;
          this.rowContextJSON = {
            "connector": "resource",
            "collection": this.options.collection.substring(9)
          };
          this.options.collectionArray = [];
        } else if (this.options.collection.startsWith("assetmetadata.")) {
          // there is a prefix found.
          this.collection = this.options.collection;
          this.rowContextJSON = {
            "connector": "assetmetadata",
            "collection": this.options.collection.substring(14)
          };
          this.options.collectionArray = [];
        } else {
          // append prefix if no prefix is defined
          this.collection = "nucleus." + this.options.collection;
          this.rowContextJSON = {
            "connector": "nucleus",
            "collection": this.options.collection
          };
          this.options.collectionArray = [];
        }
        // remove and clean old options
        this.options.collectionType = "";
        this.options.collectionName = "";
      } else {
        if (this.options.collectionType === "custom_objects") {
          this.collection = "nucleus.customobjects." + this.options.collectionName;
          this.rowContextJSON = {
            "connector": "nucleus",
            "collection": "customobjects." + this.options.collectionName
          };
          // correct the old options to correct new options
          this.options.collection = this.collection;
          this.options.collectionType = "";
          this.options.collectionName = "";
          this.options.collectionArray = [];
        } else if (this.options.collectionType === "jobs") {
          this.collection = "nucleus.job";
          this.rowContextJSON = {
            "connector": "nucleus",
            "collection": "job"
          };
          // correct the old options to correct new options
          this.options.collection = this.collection;
          this.options.collectionType = "";
          this.options.collectionName = "";
          this.options.collectionArray = [];
        } else {
          throw new Error("unknown option collectionType, use option collection in state");
        }
      }
    },
    /**
     * @return {undefined}       
     * @description transform the incomming array to usefull array, To not error because the value are entered by the pagebuilder editor
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_transformCollectionArray
     */
    _transformCollectionArray: function _transformCollectionArray() {
      this.collectionArray = [];
      if (Array.isArray(this.options.collectionArray) === false) {
        // not an array, so make one
        this.options.collectionArray = [this.options.collectionArray];
      }
      this.options.collectionArray = $.extend(true, [], this.options.collectionArray);
      if (this.options.collectionArray.length > kWarningAmountItems) {
        this._errorHandler({
          "error_code": "custom_array_too_long",
          "error": "The list is too long"
        });
        if (api_async.logging !== undefined && api_async.logging.trace !== undefined) {
          api_async.logging.trace.log("com.nixps.pagebuilder", "error", "The fix list in PreConfiguredTable is too long!");
        }
      }
      for (var i = 0; i < this.options.collectionArray.length; i++) {
        if ($.isPlainObject(this.options.collectionArray[i])) {
          this.collectionArray.push(this.options.collectionArray[i]);
        } else {
          this.collectionArray.push({
            "value": this.options.collectionArray[i]
          });
          this.options.tableOptions.keyUniqID = "value";
        }
      }
    },
    /**
     * @description Make the queryAplliers ready
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_initRowConditions
     * @private
     */
    _initRowConditions: function _initRowConditions() {
      if (this.options.rowConditionalStyling.length > 0) {
        this.rowConditions = [];
        for (var i = 0; i < this.options.rowConditionalStyling.length; i++) {
          this.rowConditions.push({
            queryApplier: new QueryApplier(this.options.rowConditionalStyling[i].condition),
            "class": "nixps_styling_class_" + this.options.rowConditionalStyling[i].style
          });
        }
      } else {
        this.rowConditions = null;
      }
    },
    /**
     * @description Init the user info
     * @function
     * @name nixps-cloudflow.PreConfiguredTable#_initUserObject
     * @private
     */
    _initUserObject: function _initUserObject() {
      if (this.options.user instanceof User) {
        this.user = this.options.user;
        return this.user;
      } else if ($.isPlainObject(this.options.user)) {
        this.user = User.fromJSON(this.options.user);
        return this.user;
      } else {
        var that = this;
        return $.when(User.get()).done(function (pUser) {
          that.user = pUser;
        });
      }
    },
    _initLicenseObject: function _initLicenseObject() {
      if (this.options.license instanceof License) {
        this.license = this.options.license;
        return this.license;
      } else if ($.isPlainObject(this.options.license)) {
        this.license = License.fromJSON(this.options.license);
        return this.license;
      } else {
        var that = this;
        return $.when(License.get()).done(function (pLicense) {
          that.license = pLicense;
        });
      }
    },
    _getLicenseToCheck: function _getLicenseToCheck() {
      if (this.collection === "nucleus.job" || this.collection === "nucleus.project" || this.collection === "nucleus.job_recursive") {
        return ["project", "project_for_apps"];
      }
      return false;
    },
    _initAdditional: function _initAdditional() {
      /** this function can be overwrite and used for components who heritate this */
      return {};
    },
    _getUnitPreferencesCheck: function _getUnitPreferencesCheck() {
      if (this.options.tableOptions && Array.isArray(this.options.tableOptions.columns) && this.options.tableOptions.columns.length > 0) {
        if (this.options.tableOptions.columns.some(function (c) {
          return c.type === "unit";
        })) {
          return UnitPreferences.get();
        }
      }
      return {};
    },
    _setOptions: function _setOptions(options) {
      var key;
      var needRedraw = false;
      for (key in options) {
        if (this._setOption(key, options[key]) === true) {
          needRedraw = true;
        }
      }
      if (needRedraw === true) {
        this._defineCollection();
        this._controlOptions();
        this._draw();
      }
      return this;
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      var needRedraw = false;
      if (pKey === "language") {
        if (pValue !== this.options.language) {
          needRedraw = true;
        }
        this._superApply(arguments);
        return needRedraw;
      } else if (pKey === "classes" && pValue !== this.options.classes) {
        needRedraw = true;
      } else if (pKey === "optimizeForContent" && pValue !== this.options.optimizeForContent) {
        needRedraw = true;
      } else if (pKey === "collectionName" && pValue !== this.options.collectionName) {
        needRedraw = true;
      } else if (pKey === "collectionType" && pValue !== this.options.collectionType) {
        needRedraw = true;
      } else if (pKey === "collection" && pValue !== this.options.collection) {
        needRedraw = true;
      } else if (pKey === "httpserviceInputName" && pValue !== this.options.httpserviceInputName) {
        needRedraw = true;
      } else if (pKey === "httpserviceWhitepaperName" && pValue !== this.options.httpserviceWhitepaperName) {
        needRedraw = true;
      } else if (pKey === "assetmetadataEnclosingFolder" && pValue !== this.options.assetmetadataEnclosingFolder) {
        needRedraw = true;
      } else if (pKey === "enableCollapsible" && pValue !== this.options.enableCollapsible) {
        needRedraw = true;
      } else if (pKey === "tableOptions" && _.isEqual(pValue, this.options.tableOptions) === false) {
        needRedraw = true;
      } else if (pKey === "collectionArray" && _.isEqual(pValue, this.options.collectionArray) === false) {
        this._superApply(arguments);
        this._transformCollectionArray();
        if (this.creating !== true) {
          this.refreshData();
        }
        return false;
      } else if (pKey === "topbarbuttons" && _.isEqual(pValue, this.options.topbarbuttons) === false) {
        if (this.options.topbarbuttons.length === 0 && pValue.length > 0) {
          // create new
          needRedraw = true;
        } else if (this.options.topbarbuttons.length > 0 && pValue.length === 0) {
          // remove
          needRedraw = true;
        } else {
          // update
          this.element.children(".nixps-cloudflow-ButtonsBarTableExtension").ButtonsBarTableExtension("option", "buttons", pValue);
        }
      } else if (pKey === "pagebuilderStyleType" && typeof pValue === "string" && pValue !== this.options.pagebuilderStyleType) {
        this.element.removeClass(this.options.pagebuilderStyleType).addClass(pValue);
        this._superApply(arguments);
        return false;
      } else if (pKey === "rowConditionalStyling") {
        if (_.isEqual(pValue, this.options.rowConditionalStyling) === false) {
          this._superApply(arguments);
          needRedraw = true;
          this._initRowConditions();
        }
      } else if (pKey === "extraQuery" && _.isEqual(pValue, this.options.extraQuery) === false) {
        needRedraw = true;
      } else if (pKey === "dataFileURL") {
        if (pValue !== this.options.dataFileURL) {
          if (this.collectionFileConnection !== undefined) {
            this.collectionFileConnection.stop("options_changed");
          }
          needRedraw = true;
        } else {
          return false;
        }
      } else if (pKey === "user") {
        // user can not change durring live
      } else if (pKey === "refreshDelay") {
        if (this.options.refreshDelay !== pValue) {
          this._superApply(arguments);
          this._triggerTimer();
          return false;
        }
      }
      this._superApply(arguments);
      return needRedraw;
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.PreConfiguredTable#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("input option language must be a not empty string");
      }
      if (typeof this.options.classes !== "string") {
        throw new Error("input option classes must be a string");
      }
      if ($.isPlainObject(this.options.tableOptions) === false) {
        throw new Error("input option tableOptions must be a plain object");
      }
      if (typeof this.options.collection !== "string") {
        throw new Error("input option collection must be a string");
      }
      if (this.options.collection.indexOf("nucleus.") === 0 && this.options.tableOptions !== undefined) {
        this.options.tableOptions.keyUniqID = "_id";
      } else if (typeof this.options.tableOptions.keyUniqID !== "string" || this.options.tableOptions.keyUniqID.length <= 0) {
        this.options.tableOptions.keyUniqID = "_id";
      }
      if (Array.isArray(this.options.extraQuery) === false) {
        throw new Error("input option extraQuery must be an array");
      }
      if (typeof this.options.refreshDelay !== "number" || this.options.refreshDelay < 0 || this.options.refreshDelay > 2147483647) {
        throw new Error("input option refreshDelay must be a number between 0 and 2147483647");
      }
      if (typeof this.options.enableCollapsible !== "boolean") {
        throw new Error("input option enableCollapsible must be an boolean");
      } else if (this.options.enableCollapsible === true) {
        if ($.isPlainObject(this.options.collapsibleContent.options) === false) {
          throw new Error("The options of collapsibleContent must be an object");
        }
      }
      if (typeof this.options.hideOtherCollapsibles !== "boolean") {
        throw new Error("input options hideOtherCollapsibles must be a boolean");
      }
      if (Array.isArray(this.options.topbarbuttons) === false) {
        throw new Error("input options topbarbuttons must be an array");
      }
      if (Array.isArray(this.options.rowConditionalStyling) === false) {
        throw new Error("input options rowConditionalStyling must be an array");
      }
      for (var i = 0; i < this.options.rowConditionalStyling.length; i++) {
        if (typeof this.options.rowConditionalStyling[i].style !== "string" || this.options.rowConditionalStyling[i].style.length <= 0) {
          throw new Error("input rowConditionalStyling must be an not empty string as style parameter");
        }
        if (Array.isArray(this.options.rowConditionalStyling[i].condition) === false || this.options.rowConditionalStyling[i].condition.length <= 0) {
          throw new Error("input rowConditionalStyling must be an not empty array as condition");
        }
      }
    },
    /**
     * @description fucntion runs when component is being removing
     * @function
     * @private
     * @name nixps-cloudflow.PreConfiguredTable#_destroy
     * @return {undefined}
     */
    _destroy: function _destroy() {
      this.dead = true;
      clearTimeout(this.refreshTimerID);
      $(window).off("resize", this.windowResizeHandler);
      if (this.collectionCRUDconnection !== undefined && this.collectionCRUDconnection !== null) {
        this.collectionCRUDconnection.stop("quit_DOM");
      }
      if (this.collectionCRUDconnectionExists !== undefined && this.collectionCRUDconnectionExists !== null) {
        this.collectionCRUDconnectionExists.stop("quit_DOM");
      }
      if (this.collectionFileConnection !== undefined && this.collectionFileConnection !== null) {
        this.collectionFileConnection.stop("quite_DOM");
      }
      if (this.mContextmenu !== undefined && this.mContextmenu !== null) {
        this.mContextmenu.remove();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../common/Dialog/js/nixps-Dialog.js":287,"../../../pagebuilder/js/inspect/LogListener.js":431,"../../CloudflowQueryBuilder/js/nixps-cloudflow-CloudflowQueryPanel.js":74,"../../CloudflowUtil/js/CloudflowConnection.js":78,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../CloudflowUtil/js/FileConnection.js":86,"../../CloudflowUtil/js/QueryApplier.js":91,"../../License/js/License.js":175,"../../PWA/js/Device.js":198,"../../Units/js/UnitPreferences.js":265,"../../User/js/User.js":268,"./DatabaseConnection.js":209,"./ExtendedTableTypes.js":210,"./Query.js":211,"./WhitepaperCRUD.js":213,"./nixps-cloudflow-ButtonsBarTableExtension.js":214,"./nixps-cloudflow-ContextMenuTableExtension.js":216,"./nixps-cloudflow-Table.js":218}],218:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("../../CheckExternals/js/CheckExternals.js");
(function ($) {
  // first time there sould not be a component called Table be present
  // only if you added a other component named "table", or included the framework.js more then ones
  if ($.fn.Table !== undefined) {
    console.warn("component already loaded, did you included framework.js twice ?");
  } else {
    if (window.nixps !== undefined && window.nixps.testing !== undefined) {
      // skip in case of testing
    } else if (typeof $.Deferred.exceptionHook === "function" || $.fn.jquery.startsWith("3.")) {
      // in jQuery >= 3.0, errors are swallowed, but 
      // the exceptionHook function shows then on the console, 
      // but that function should show also the normal Error!!, which is filtered out in jQuery
      var hook = $.Deferred.exceptionHook;
      $.Deferred.exceptionHook = function (e, t) {
        if (e !== undefined && ["Error", "EvalError", "ReferenceError", "TypeError"].includes(e.name)) {
          console.error("jQuery.Deferred exception: " + e.message, e.stack, t);
        } else if (typeof hook === "function") {
          hook(e, t);
        }
      };
    }
  }
  require("../../FormElements/js/nixps-cloudflow-DatetimeSelector.js");
  require("../../../common/Selectable/js/nixps-Selecting.js");
  require("./nixps-cloudflow-CollapsibleColumns.js");
  require("../../../common/DropdownList/js/nixps-DropdownList.js");
  var TableConfig = require("./TableConfig.js");
  var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
  var Query = require("../../Table/js/Query.js");
  var TouchUtil = require("../../../common/Touch/js/TouchUtil.js");
  var DateFunctions = require("../../CloudflowUtil/js/DateFunctions.js");
  var htmlEscape;
  if (window._ !== undefined && typeof _.escape === "function") {
    htmlEscape = _.escape;
  } else {
    var ampEscapeRegExp = new RegExp("&", "g");
    var lessEscapeRegExp = new RegExp("<", "g");
    var grtEscapeRegExp = new RegExp(">", "g");
    /**
     * @description Escape some special characters of a text. 
     * This function only change the characters <,> and & this should be enough to disable javascript injections and is fast enough 
     * @function
     * @private
     * @static
     * @param {string} pText The text that must be escaped
     * @returns {string} the escaped string
     */
    htmlEscape = function htmlEscape(pText) {
      return pText.toString().replace(ampEscapeRegExp, "&amp;").replace(lessEscapeRegExp, "&lt;").replace(grtEscapeRegExp, "&gt;");
    };
  }
  var cssSelectorTransformerRegExp = new RegExp("[.#~+>]", "g");
  function cssSelectorEscape(pSelector) {
    return ("" + pSelector).replace(cssSelectorTransformerRegExp, "\\$&");
  }

  /**
      * @description Get the correct value of a object given a nixps formed key 
      * @function
      * @private
      * @static
      * @param {object} pObject The parent tree to look into
      * @param {string} pKey the key path to follow in the pObject
      * @param {boolean} pNixpsFormedKey true if we need to folow a path, false to not follow a path
      * @returns {Object | value} The value corresponding to the key path
      */
  function getDataOfObjectTree(pObject, pKey, pNixpsFormedKey) {
    if (pNixpsFormedKey === true && typeof pKey === "string" && pKey.length > 0) {
      return CloudflowObject.getParameter(pObject, pKey);
    } else {
      // in case of not nixps formed key, to support normal cases
      return pObject[pKey];
    }
  }
  ;
  function setDataOfObjectTree(pObject, pKey, pNewValue, pNixpsFormedKey) {
    if (pNixpsFormedKey === true && typeof pKey === "string" && pKey.length > 0) {
      return CloudflowObject.setParameter(pObject, pKey, pNewValue);
    } else {
      pObject[pKey] = pNewValue;
      return pObject;
    }
  }
  ;
  /**
   * @description transform the sort options format to a cloudflow backend format
   * @function
   * @private
   * @static
   * @param {array} pSort - sorting array in input option format
   * @returns {Array} a sorting array in backend format
   */
  function transformSortToBackendSort(pSort) {
    if (!Array.isArray(pSort)) {
      throw new Error("pSort parameter must be a array");
    }
    var outputSort = [];
    for (var i = 0; i < pSort.length; i++) {
      if (typeof pSort[i] === "string") {
        outputSort.push(pSort[i]);
        continue;
      } else if (typeof pSort[i].column !== "string" || typeof pSort[i].order !== "string") {
        throw new Error("pSort parameter item has wrong interface");
      }
      outputSort.push(pSort[i].column);
      outputSort.push(pSort[i].order);
    }
    return outputSort;
  }

  /**
   * @description transform the sort backend format to a input options format for sorting
   * @function
   * @private
   * @param {array} pSort backend format
   * @returns {Array} a sorting array in input options format
   */
  function transformBackendSortToSort(pSort) {
    if (!Array.isArray(pSort)) {
      throw new Error("pSort parameter must be a array");
    }
    var outputSort = [];
    for (var i = 0; i < pSort.length; i++) {
      if (i % 2 === 0) {
        outputSort.push({
          column: pSort[i]
        });
      } else {
        outputSort[outputSort.length - 1].order = pSort[i];
      }
    }
    return outputSort;
  }

  /**
   * @namespace nixps-cloudflow.Table
   * @description Show a table. A abstract model for a tabel, only for internal use.
   * <br />This component fires next events
   * <ul><li>tabledataloaded data: skip, limit, dataCount</li> 
   * <li>tableclick data: rowObject, columObject</li>
   * <li>tableimageloaderror data: {}, error throw when image has not been loaded </li>
   * </ul>
   * @example $("<div>").Table({columns: [...], dataProvider: function(..){} , ...})
   * @version 1.12.0 cloudflow 26.00
   */
  $.widget("nixps-cloudflow.Table", $.Widget, {
    version: "1.12.0",
    widgetEventPrefix: "table",
    options: {
      /**
       * @name nixps-cloudflow.Table#language
       * @description Language of the user. This will be used to localise the data like dates. This has no impact on the translations of the table keyswords. 
       * That must be handled by the programmer hem/her self. 
       * This string must be a correct language string for the class "moment". In case of a not valid language, the compoment moment will decide itself.
       * Now he chooses automaticaly English without warning.
       * @type {String|language_code}
       * @default "en"
       * @since 1.1
       */
      language: "en",
      /**
       * @name nixps-cloudflow.Table#dataProvider
       * @description This is a (callback) function that must provide data to the component,
       * <ol>
       * <li>first parameter is a searchstring, (cloudflow apicalls query compatible) </li>
       * <li>second parameter is a orderby query, (cloudflow apicalls query compatible) </li>
       * <li>third parameter provide the number of rows we want to skip (type number)</li>
       * <li>last parameter is the max amount of rows we want. (type number)</li>
       * </ol>
       * It must return a array of objects or a defer object with a resolve argument of a array of objects.
       * @type {function(sql, pOrderBy, skip, limit)}
       * @default function(){}
       * @example function(pQuery, pOrderBy, pSkip, pLimit) { 
       *     return $.Deferred(function(pDefer) {
       *         api_async.approval.list_with_options(pQuery, pOrderBy, ["name", "birth"], {first: pSkip, maximum: pLimit}, function (pResult) {
       *             pDefer.resolve(pResult.results);
       *         }, pDefer.reject);
       *     });
       *   }        
       */
      dataProvider: function dataProvider() {},
      /**
       * @name nixps-cloudflow.Table#countProvider
       * @description This function must return an array or a number of the total rows depending of the query it ask. 
       * This can also be returned as a deferred object. This will only be used if option {@link nixps-cloudflow.Table#showRowCounter} is set on true.
       * <ol>
       * <li>first parameter is a searchstring, (cloudflow api query compatible) </li>
       * </ol>
       * @type {Function}
       * @default function(){}
       * @example function(pQuery) { 
       *     return $.Deferred(function(pDefer) {
       *         api_async.approval.list_with_options(pQuery, [], ["_id"], {}, function (pResult) {
       *             pDefer.resolve(pResult.results);
       *         }, pDefer.reject);
       *     });
       *   } 
       * @example function(pQuery) { 
       *     return $.Deferred(function(pDefer) {
       *         api_async.approval.list_with_options(pQuery, [], ["_id"], {}, function (pResult) {
       *             pDefer.resolve(pResult.results.length);
       *         }, pDefer.reject);
       *     });
       *   }
       * @since 1.4.0 cloudflow 17.06
       */
      countProvider: function countProvider() {},
      /**
       * @name nixps-cloudflow.Table#dataUpdater
       * @description This is a (callback) function called when the user changed data (ex. by dblclicking on a field via the editCellEvent).  
       * This function recieves the new/changed dataobject as first input parameter and the programmer should saved the object.
       * The second parameter is the column object of the column of the cell that is just editted.
       * You must return a deferred object.
       * @type {function}
       * @default function(){}
       * @example function(pNewObject, pColumnObject) {
       *    return $.Deferred(function(pDefer) {
       *          api_defer.object.update(pNewObject, pDefer.resolve, pDefer.reject);
       *       };
       * } 
       */
      dataUpdater: function dataUpdater() {},
      /**
       * @name nixps-cloudflow.Table#dataExists
       * @description Checks if the selected row ids still exists? This is a function that must return all still existing items
       * @type {Function}
       * @default function(pSelectedRowIDs) {
          return pSelectedRowIDs;
      }
       * @since 1.5.5
       */
      dataExists: function dataExists(pSelectedRowIDs) {
        return pSelectedRowIDs;
      },
      /** 
       * @name nixps-cloudflow.Table#columns
       * @description Specify the columns.
       * If we recieve an array of objects, the element must contain a label, type, key.
       * <dl>
       * <dt>label:</dt> <dd><i>required</i> The title text to show</dd>
       * <dt>chooseLabel:</dt> <dd>(optional) string The title to be used in the user config panel. If defined if overwrites the label</dd>
       * <dt>type:</dt>  <dd><i>required</i> string The technical type of the data, that is used to correct handle the data, sorting ex. </dd>
       * <dt>key:</dt>  <dd><i>required</i> string The key to map with the object recieving from dataProvider. So we can map the object attribute to te correct column </dd>
       * <dt>sortable:</dt>   <dd>(optional) boolean to indicate that we must provide a sorting on that column </dd>
       * <dt>searchable:</dt> <dd>(optional) boolean to indicate that we must provide a searching on that column </dd>
       * <dt>search_startquery:</dt> <dd>(optional) array to indicate the default filtering when creating </dd>
       * <dt>cellClass:</dt>  <dd>(optional) string to use as class to add to the cell </dd>
       * <dt>headerClass:</dt><dd>(optional) string to use as class to add to the header </dd>
       * <dt>show:</dt><dd>(optional) boolean if false, the column will be hidden by default if user config is enabled</dd>
       * <dt>noCollapsibleColumn:</dt><dd>(optional) boolean if true, ignore the complete column in the user config</dd>
       * <dt>editable:</dt><dd>(optional) boolean if false the cell is not inline editable, default is true </dd>
       * <dt>options:</dt><dd>(optional) object to be passed to the renderFunction. Usefull for custom column types </dd>
       * </dl>
       * 
       * <b>Supported (render) types:</b> string, password, array, html, number, image (for general images, data should be a complete source path), link, boolean, date (number amount milliseconds), dateISO (string as ISO8601), enum, selectCheckbox<br />
       * If you use type boolean, you can change the layout with css, the text itself comes from the translation JSON files. <br/>
       * If you use type date/dateISO you need to include moment and bootstrap-datetimepicker yourself. <br />
       * With type selectCheckbox, you can add a selectbox to enable selecting a row. Use {@link nixps-cloudflow.Table#getSelectedRowIDs} to get all the ids of all the selected rows.
       * With this type you can not activate searching and sorting on it. Deselecting rows can only be done by manualy deselecting or by calling the {@link nixps-cloudflow.Table#unselectAllRows},
       * so pay attention on high dynamicaly rows. You need to check afterwards if the selected rows still exists!
       * @example [{label:"username", type: "string", key:"username", sortable:true, cellClass: "usernameClass", headerClass: "userTitle"} , 
       * {label:"e-mail", type: "string" , key:"email", sortable:true}, 
       * {label:"password", type: "password", key:"userpass", sortable:false, searchable:false }]
       * @default [],
       * @type {Array<Object>}
       */
      columns: [],
      /**
       * @name nixps-cloudflow.Table#additionalTypes
       * @description Those additional types will be added to the typesdictionary. Use this if you have custom types.
       * Add here your custom rendering function. be carefully, you can overwrite existing render types!
       * All parameters Function must be a function or a string, refering to the previous added type name who has that parameter.
       * So if you use searchRenderFunction: "string", it will use the searchRenderFunction of column Type "string"
       * @example [{type: "password", 
       *   renderFunction: function(pw){return "*****";}, 
       *   editFunction: function(pw){},
       *   searchRenderFunction: function(){},
       *   getSearchQueryFunction: function(searchDOMElem, pColumnObject){}]
       * @type {Array<Object>}
       * @default []
       */
      additionalTypes: [],
      /**
       * @name nixps-cloudflow.Table#keyUniqID
       * @description Give the name of the key, this must be a uniq key id. <br />
       * This field will not be show as extra.
       * The value in this field will be added as attribute "data-tableRowID" on the row if the option {@link nixps-cloudflow.Table#enableIDAttribute} is set on false.
       * otherwise it will be added as id "tableRowID__&lt;value&gt;"  <br />
       * You can use this to connect an event to the correct data, <br />
       * We encourage to use this field, some features need this! Most cloudflow calls uses "_id" as unique object key.
       * @type {String}
       * @example "_id"
       * @default false
       */
      keyUniqID: false,
      /**
       * @name nixps-cloudflow.Table#enableIDAttribute
       * @description The attribute data-tableRowID will be removed and replaced by a id called tableRowID_&lt;value&gt;
       * @type {Boolean}
       * @example true
       * @default false
       * @since 1.4.0 cloudflow 17.06
       */
      enableIDAttribute: false,
      /**
       * @name nixps-cloudflow.Table#rowClassKey
       * @description The key of the rowobjects that must be used as class for the row object
       * @type {String}
       * @default null
       * @since 1.5.5
       */
      rowClassKey: null,
      /**
       * @name nixps-cloudflow.Table#sort
       * @description The sorting settings. How must we sort the columns (on startup)? 
       * It is a array containing objects, each object containing a key "column" (this must be the column key) 
       * and "order" (this must be strings "ascending" or "descending")
       * @type {Array}
       * @default []
       * @example [{column: "name", order: "ascending"}]
       * @since 1.2.1
       */
      sort: [],
      /**
       * @name nixps-cloudflow.Table#initSkip
       * @description The initial amoutn to skip, when paging whn creating
       * @type {Number}
       * @default 0
       * @private 
       * @since 1.9.1
       */
      initSkip: 0,
      /**
       * @name nixps-cloudflow.Table#maxRows
       * @description (optional) The max numbers of row you want to see, if null there will be no limit. You can also use "auto", 
       * in this case the component will calculate his own maxRows, but for that the component must be already possitioned on the DOM. 
       * @type {Number}
       * @default null
       * @example 50
       */
      maxRows: null,
      /**
       * @name nixps-cloudflow.Table#overflowMechanism
       * @description How must we handle overflows? Must we page or auto scroll, ... <br/>The numeric value of maxRows is nessesary and will be used in both cases!
       * possibile values are: <ul> <li>paging: a left and right arrow will appear to go to next rows</li>
       * <li>scrolling: when detecting bottom, the component will auto load the next rows</li></ul>
       * @type {String}
       * @default "paging"
       * @example "scrolling"
       * @since 1.3 cloudflow 17.1
       */
      overflowMechanism: "paging",
      /**
       * @name nixps-cloudflow.Table#keepHeight
       * @description Keep the height on min-height or not?
       * @type {Boolean}
       * @since 1.10.0
       */
      keepHeight: false,
      /**
       * @name nixps-cloudflow.Table#showRowCounter
       * @description Show the number of rows in the bottombar. This will only be activated if <strong>paging</strong> is choosen as option {@link nixps-cloudflow.Table#overflowMechanism}
       * and if option {@link nixps-cloudflow.Table#maxRows} is defined.
       * @type {Boolean}
       * @default false
       * @since 1.4.0 cloudflow 17.06
       */
      showRowCounter: false,
      /**
       * @description Must the table must have a fixed header, that stays visible when scrolling down? 
       * You must include the 3rthParty component stickyTableHeaders
       * @name nixps-cloudflow.Table#enableStickyHeader
       * @type {Boolean}
       * @default false
       * @since 1.5.5
       */
      enableStickyHeader: false,
      /**
       * @description If the table has parents with postion absolute or fixed, add here the parent where there scroll
       * @name nixps-cloudflow.Table#stickyHeaderScrollableArea
       * @type {mixed}
       * @default "auto" 
       * @since 1.7.0
       */
      stickyHeaderScrollableArea: "auto",
      /**
       * @description Must we aply the stick headers by css or js?
       * @name nixps-cloudflow.Table#stickyHeaderAppliedBy
       * @type {String}
       * @default "js"
       * @since 1.9.0
       */
      stickyHeaderAppliedBy: "js",
      /**
       * @description The margin top of the sticky header, so the topbarbuttons can stay visible
       * @name nixps-cloudflow.Table#stickyHeaderMarginTop
       * @type {Number}
       * @default 0
       * @since 1.11.0
       */
      stickyHeaderMarginTop: 0,
      /**
       * @description the jquery element to apply the stickheaders on
       * @type {jQuery}
       * @default undefined
       * @since 1.12.0
       */
      stickyTableHeadersParent: undefined,
      /**
       * @name nixps-cloudflow.Table#noItemsText
       * @description The text to be visible when there are no items
       * @type {String}
       * @default undefined
       * @since 1.10.0
       */
      noItemsText: undefined,
      /**
       * @name nixps-cloudflow.Table#selecting
       * @description Must we allow selecting rows, put here the options for the Selecting component
       * @type {Object}
       * @default null
       * @since 1.8.0
       */
      selecting: null,
      /**
       * @name nixps-cloudflow.Table#configColumns
       * @description Do we want to enable the configurations for the columns, set null for no configurations
       * @type {Object}
       * @default null
       * @since 1.8.0
       */
      configColumns: null,
      /**
       * @name nixps-cloudflow.Table#configTableID
       * @description The table id for the save and retrieve of the table configurations
       * @type {String}
       * @default null
       * @since 1.8.0
       */
      configTableID: null,
      /**
       * @name nixps-cloudflow.Table#editCellEvent
       * @description The event for individual cell editing. When this event is fired. 
       * The editFunction will be called, 
       * to be able to change te value of that specifique cell. <br />
       * Insert the boolean false, to disable this inline cell editing feature. 
       * @type {String}
       * @example "click"
       * @default "dblclick"
       */
      editCellEvent: "dblclick",
      /**
       * @name nixps-cloudflow.Table#allowEditRow
       * @description Function that gives the permission to edit a cell of a row. If this option is a function and if the function returns the boolean false 
       * then the cell will not be editable.
       * @type {function}
       * @example function(pObject) { return pObject.editable === true; }
       * @default null
       * @since 1.3.1 cloudflow 17.2 
       */
      allowEditRow: null,
      /**
       * @name nixps-cloudflow.Table#enableJSONPathInKeys
       * @description Must the keys be interpreded as cloudflow JSON paths. 
       * So a dot "." will refer to a subobject and a number (like 0) to the x"the child item of the array.
       * Put this on "false" if there are keys, who contains dots ".".
       * @type {Boolean}
       * @default true
       * @since 1.2  
       */
      enableJSONPathInKeys: true,
      /**
       * @name nixps-cloudflow.Table#searchingThrottleDelay
       * @description The delay in ms of debounce when searching
       * @type {Number}
       * @default 0
       * @since 1.5.2
       */
      searchingThrottleDelay: 0,
      /**
       * @name nixps-cloudflow.Table#dateFormat
       * @description How must we format the date to display in the table? 
       * This must be a string corresponding to the format function of  the "moment" component.
       * <br /> <a href="http://momentjs.com/docs/#/displaying/format/"> Click here for more information and the valid possibilities</a>
       * @type {String}
       * @example "DD/MM/YYYY"
       * @default "L LT"
       * @since 1.1
       */
      dateFormat: "L LT",
      /**
       * @name nixps-cloudflow.Table#classes
       * @description The classes speparated by spaces added to the table tag
       * @type {String}
       * @default "cf-table"
       */
      classes: "cf-table",
      /**
       * @name nixps-cloudflow.Table#pagingButtonClasses
       * @description The classes applied on the paging buttons
       * @type {String}
       * @default "cf-button-secondary cf-minwidth-button",
       * @since 1.6.1
       */
      pagingButtonClasses: "cf-button-secondary cf-minwidth-button",
      /**
       * @name nixps-cloudflow.Table#bodyClasses
       * @description The classes to be added to the table body
       * @type {String}
       * @default "cf-table-body"
       * @since 1.8.0
       */
      bodyClasses: "cf-table-body-main",
      /**
       * @name nixps-cloudflow.Table#bottombarClasses
       * @description the classes to be added to the bottombar
       * @type {String}
       * @default ""
       * @since 1.11.0
       */
      bottombarClasses: ""
    },
    /**
     * @function
     * @name nixps-cloudflow.Table#addRow
     * @description Add a row at the end of the table.
     * @private
     * @param {array} pArray - The array contains the cell value. The first element will be added first, afterwards the second will be inserted and so on.
     * The array element will be inserted as html contents, so you need to translate before. Use it add own risk!    
     * @returns {object|jqueryRow} the new created table row
     */
    addRow: function addRow(pArray) {
      var row = $("<tr>");
      var length = this.options.columns.length;
      var rows = [];
      for (var i = 0; i < length; i++) {
        rows.push($("<td>").addClass(this.options.columns[i].cellClass).append(pArray[i]));
      }
      row.append(rows);
      this.element.children("table").children("tbody").append(row);
      return row;
    },
    /**
     * @function
     * @name nixps-cloudflow.Table#insertOneCollapseRow
     * @description Insert a row to the table, this row contains no columns. it is a colspan of all columns
     * the inserted row will be removed after a refresh or redraw.
     * @throws {jsError} insertOneCollapseRow: invalid "pRowSelection" selection
     * @param {jQuerySelection} pRowSelection jquery selection of the row above the inserted row, the selection begins from the component itself.
     * @param {Boolean} pAddDummyRow if true we will add two rows, so the css :even and :odd will work correctly when injecting a row
     * @returns {$|Window.$|jQuery} The inserted row
     */
    insertOneCollapseRow: function insertOneCollapseRow(pRowSelection, pAddDummyRow) {
      var rowAbove = this.element.find(pRowSelection).closest("tr");
      if (rowAbove.length > 0 && rowAbove.is("tr") && rowAbove.parents(".nixps-cloudflow-Table").length > 0) {
        // collapseable
        var colspan;
        if (this.collapsibleColumns === null) {
          colspan = this.options.columns.length;
        } else {
          colspan = 0;
          for (var i = 0; i < this.collapsibleColumns.length; i++) {
            if (this.collapsibleColumns[i]) {
              colspan++;
            }
          }
        }
        var row = $("<tr>").append($("<td>").attr("colspan", colspan)).addClass("tableInlineRow");
        if (typeof this.options.keyUniqID === "string" && this.options.keyUniqID.length > 0) {
          row.data("rowID", CloudflowObject.getParameter(rowAbove.data("dataitem"), this.options.keyUniqID));
        }
        if (pAddDummyRow === true) {
          rowAbove.after($("<tr>").addClass("tableDummyInlineRow"));
        }
        rowAbove.after(row);
        return row.find("td");
      } else {
        throw new Error("insertOneCollapseRow: invalid \"pRowSelection\" selection");
      }
    },
    /**
     * @name nixps-cloudflow.Table#removeCollapsedRows
     * @description Remove all the collapsed rows
     * @function
     * @returns {undefined}
     */
    removeCollapsedRows: function removeCollapsedRows() {
      this.element.children("table").children("tbody").children("tr.tableInlineRow, tr.tableDummyInlineRow").remove();
    },
    /**
     * @function
     * @name nixps-cloudflow.Table#refreshData
     * @description This function clears the data of the table, it removes all the rows and does a recall to the dataProvider.
     * It keeps the headers.
     * @param {QueryObject} pQuery (optional) the query that you want to give to the table. Put "null" if you want to keep the current query
     * @param {Boolean} pKeepPage (optional) put on true, to refresh only the current page, the skip stay unchanged.
     * put on false/undefined to reset the skip parameter and refresh all, the table will go to the first page.
     * @param {Boolean} pKeepInjectedRows Must we try to keep the injected rows?
     * @example $("#table").Table("refreshData")
     * @example $("#table").Table("refreshData", null) // keep the current query 
     * @example $("#table").Table("refreshData", null, true) // keep the current query and page   
     * @returns {defer}
     */
    refreshData: function refreshData(pQuery, pKeepPage, pKeepInjectedRows) {
      if (pQuery === undefined) {
        this.query = new Query([]);
        this._clearHeaderSearch();
      } else if (pQuery === null) {
        // do nothing, keep the current query
      } else if (pQuery instanceof Query) {
        this.query = pQuery;
      } else if (typeof Query.hasGoodInterface(pQuery) === "string") {
        throw new Error(Query.hasGoodInterface(pQuery));
      } else {
        this.query = new Query(pQuery);
      }
      if (pKeepPage !== true) {
        // draw the body with data
        this.isEnd = false;
        this.skip = 0;
        this.element.children(".tableBottomBar").find(".leftPagingButton").prop("disabled", true);
      }
      this.overflow = true; // it can be possible that there are rows added after refresh, so user should see added rows

      return this._drawBody(this.query, this.orderBy, this.skip, this.limit, pKeepInjectedRows);
    },
    /**
     * @description Load the next "pNumber" number of rows and add at the end of the table.
     * @name nixps-cloudflow.Table#addNextRows
     * @function
     * @param {Number} pNumber - The number of rows to load
     * @returns {deferred}
     */
    addNextRows: function addNextRows(pNumber) {
      if (typeof pNumber !== "number" || pNumber <= 0) {
        throw new Error("parameter pNumber must be a positieve number");
      }
      // add data
      this.skip += this.limit;
      var limit;
      if (pNumber > this.limit) {
        // add more because the _makeTableWithInputData will remove one of the array
        limit = this.limit + 1;
      } else {
        limit = pNumber;
      }
      var data = this.options.dataProvider(this.query.getQuery().slice(), this.orderBy, this.skip, limit + 1); //ask one more, so we know if we get the last
      if (data === undefined) {
        throw new Error("Table: Could not load data");
      }
      this.dataProviderCallID++;
      var that = this; // if ascyncrone
      return $.when(data).then(function (pData) {
        if (pData && Array.isArray(pData.results || pData.documents)) {
          pData = pData.results || pData.documents;
        }
        if (Array.isArray(pData) === false) {
          throw new Error("invalid data from dataProvider");
        }
        that.overflow = false;
        if (pData.length > limit) {
          pData.pop();
          that.overflow = true;
        }
        that._makeTableWithInputData(pData, undefined, true, true, that.dataProviderCallID);
        that._trigger("dataloaded", null, {
          skip: this.skip,
          limit: this.limit,
          dataCount: pData.length,
          nextPossible: that.overflow
        });
      })["catch"](function (pError) {
        console.error("Table: Could not load data: ", pError);
        that._trigger("dataloaderror", null, {
          error: pError
        });
        return Promise.reject(pError);
      });
    },
    /**
     * @name nixps-cloudflow.Table#adaptHeight
     * @description If you use the option maxRows, this option will be changed to addapt in the current box, to avoid scolling. 
     * This function will change your option mawRows to avoid scolling the page. after succesfully change it will jumb to the first page.
     * @function
     * @returns {undefined}
     * @since 1.2
     */
    adaptHeight: function adaptHeight() {
      // internal function to detect the source of error, to help the user-developer of the component
      var that = this;
      function throwErrorWithHelp() {
        if (that.element.parents("body").length <= 0) {
          throw new Error('could not adapt height, because current height could not be calculated, because the component is not embedded in DOM tree.\n\
                    it must be add to the body before calling this function.');
        } else if (that.element.is(':hidden')) {
          throw new Error('could not adapt height, because current height could not be calculated, because component is hidden');
        } else {
          throw new Error('could not adapt height, because current height can not be calculated for unknow reason');
        }
      }
      if (this.options.maxRows !== null && (typeof this.options.maxRows === "number" || this.options.maxRows === 'auto')) {
        this.element.css("min-height", ""); // remove the css added to prevent ui shocs
        var totalheight = this.element.height();
        if (typeof totalheight !== "number" || totalheight <= 0) {
          throwErrorWithHelp();
        } else {
          // header
          var header = this.element.children('table').children('thead:not(.tableFloatingHeader)');
          if (header === undefined || header.length === 0) {
            throw new Error('could not find header');
          }
          var headerHeight = header.outerHeight();
          // bottombar is optional
          var bottomBar = this.element.children('.tableBottomBar');
          var bottomBarHeight = 0;
          if (bottomBar.length === 1) {
            bottomBarHeight = bottomBar.outerHeight();
          }
          // row
          var rowVolunteer = this.element.children('table').children('tbody tr').first();
          var rowHeight = 23;
          if (rowVolunteer === undefined || rowVolunteer.length === 0) {
            console.warn('could not find any row, we take height 23 as guest row height');
          } else {
            rowHeight = rowVolunteer.outerHeight();
            if (typeof totalheight !== "number" || totalheight <= 0) {
              throwErrorWithHelp();
            }
          }
          var freeHeightSpace = totalheight - headerHeight - bottomBarHeight - 10; /* add 10px extra buffer */
          this.limit = Math.floor(freeHeightSpace / rowHeight);
          if (typeof this.options.maxRows === 'number') {
            this.options.maxRows = this.limit;
          }
          this.refreshData(null, false);
        }
      }
    },
    /**
     * @function
     * @name nixps-cloudflow.Table#_create
     * @description create the component table
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      //control inputoptions
      if (typeof this.options.dataProvider !== "function") {
        throw new Error('Table: inputoption data must be a function');
      }
      if (typeof this.options.dataUpdater !== "function") {
        throw new Error('Table: inputoption data must be a function');
      }
      if (!Array.isArray(this.options.columns)) {
        throw new Error('Table: inputoption columns must be a array');
      }
      for (var i = 0; i < this.options.columns.length; i++) {
        if (this.options.columns[i].label === undefined) {
          throw new Error('Table: each element in inputoption columns must have a label');
        }
        if (typeof this.options.columns[i].key !== "string" && typeof this.options.columns[i].key !== "number") {
          throw new Error('Table: each element in inputoption columns must have a key {string} ');
        }
        if (typeof this.options.columns[i].type !== "string") {
          throw new Error('Table: each element in inputoption columns must have a type ');
        }
        if (this.options.columns[i].headerClass !== undefined && typeof this.options.columns[i].headerClass !== "string") {
          throw new Error('Table: each headerClass element in inputoption columns must be a string');
        }
        if (this.options.columns[i].cellClass !== undefined && typeof this.options.columns[i].cellClass !== "string") {
          throw new Error('Table: each cellClass element in inputoption columns must be a string');
        }
      }
      ;
      if (!(this.options.maxRows === null || typeof this.options.maxRows === "number" && this.options.maxRows > 0 || this.options.maxRows === "auto")) {
        throw new Error('Table: inputoption maxRows must be null or a number or contain the string auto');
      }
      if (typeof this.options.dateFormat !== "string") {
        throw new Error('Table: inputoption dateFormat must be a string');
      }
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error('Table: inputoption language must be a non empty string');
      }
      if (typeof this.options.enableJSONPathInKeys !== "boolean") {
        throw new Error('Table: inputoption enableJSONPathInKeys must be a boolean');
      }
      if (!Array.isArray(this.options.sort)) {
        throw new Error('Table: inputoption sort must be a array');
      }
      if (typeof this.options.overflowMechanism !== "string" || this.options.overflowMechanism.length <= 0) {
        throw new Error('Table: inputoption overflowMechanism must be a string');
      }
      if (['paging', 'scrolling'].indexOf(this.options.overflowMechanism) < 0) {
        throw new Error('Table: inputoption overflowMechanism is not supported, only paging and scrolling is suppored');
      }
      if (typeof this.options.enableIDAttribute !== "boolean") {
        throw new Error('Table: inputoption enableIDAttribute must be an boolean');
      }
      if (typeof this.options.stickyHeaderMarginTop !== "number") {
        throw new Error('Table: inputoption stickyHeaderMarginTop must be an number');
      }
      // make component
      this.element.addClass(this.widgetFullName).attr("data-uuid", this.uuid);
      // initial language in moment class, if moment is aviable
      if (typeof moment === "function") {
        if (this.options.language === "en") {
          var browserlanguage = navigator.language || navigator.userLanguage;
          if (typeof browserlanguage === "string" && browserlanguage.length > 0) {
            moment.locale(browserlanguage);
          } else {
            moment.locale("en");
          }
        } else {
          moment.locale(this.options.language);
        }
        if (typeof moment.localeData()._invalidDate === "string") {
          // overwrite the "Invalid date" to a translated version
          moment.localeData()._invalidDate = $.i18n._("nixps-cloudflow-table.invalid_date");
        }
      }
      // make renderingDictionary
      this.renderDict = {
        "password": function password(sw) {
          return "*****";
        },
        "array": function array(pArray) {
          var output = "";
          $.each(pArray, function (index, element) {
            output = output + element + " ";
          });
          return output;
        },
        "string": function string(vl) {
          if (vl === undefined || vl === null) {
            return "";
          }
          return htmlEscape(vl);
        },
        "HTML": function HTML(vl) {
          return vl;
        },
        "number": function number(vl) {
          if (vl === undefined || vl === null) {
            return "";
          }
          if (typeof vl === "number") {
            return vl;
          }
          return htmlEscape(vl);
        },
        "image": function image(src) {
          if (typeof src !== "string" || src.length <= 0) {
            return "";
          }
          if (typeof src === "string" && src.indexOf("cloudflow://") === 0) {
            // url starts with "cloudflow://" so we get a cloudflow path ...
            src = "/portal.cgi?metadata=get_thumbnail&file=" + encodeURIComponent(src) + "&precalculated_only=true";
          }
          return $("<img>").attr("src", src).on("error", function (pEvent) {
            $(this).closest(".nixps-cloudflow-Table").Table("triggerEvent", "imageloaderror", pEvent, {});
          });
        },
        "link": function link(linkHref) {
          if (typeof linkHref === "string" && linkHref.length > 0) {
            return $("<a>").attr("href", linkHref);
          }
          return "";
        },
        "boolean": function boolean(bool) {
          if (bool === true) {
            return $("<span>").addClass("boolTrue").append($("<span>").addClass("boolIcon").html("&#10003;")).append($("<span>").addClass("boolText").text($.i18n._("nixps-cloudflow-table.boolean_true")));
          } else if (bool === false) {
            return $("<span>").addClass("boolFalse").append($("<span>").addClass("boolIcon").html("&#10005;")).append($("<span>").addClass("boolText").text($.i18n._("nixps-cloudflow-table.boolean_false")));
          } else {
            return "";
          }
        },
        "date": function date(_date, pColumOptions) {
          if (_date === undefined || _date === null || _date === "") {
            return "";
          }
          var valueDate = moment(_date);
          if (pColumOptions && pColumOptions.dateFunctionsOptions) {
            return DateFunctions.toLocaleString(valueDate.toDate(), pColumOptions.dateFunctionsOptions);
          }
          var format;
          if (pColumOptions && typeof pColumOptions.dateFormat === "string" && pColumOptions.dateFormat.length > 0) {
            format = pColumOptions.dateFormat;
          } else {
            format = that.options.dateFormat;
          }
          if (format.indexOf("LTS.SSS") >= 0 && moment.localeData().longDateFormat("LTS").match(new RegExp("a", "i"))) {
            format = format.replace("LTS", moment().localeData().longDateFormat("LTS"));
            format = format.replace(":ss A.SSS", ":ss.SSS A");
          }
          if (pColumOptions && pColumOptions.utc === true) {
            return valueDate.utc().format(format);
          }
          return valueDate.format(format);
        },
        "dateISO": function dateISO(date, pColumOptions) {
          if (date === undefined || date === null || date === "") {
            return "";
          }
          var valueDate = moment(date);
          if (pColumOptions && pColumOptions.dateFunctionsOptions) {
            return DateFunctions.toLocaleString(valueDate.toDate(), pColumOptions.dateFunctionsOptions);
          }
          var format;
          if (pColumOptions && typeof pColumOptions.dateFormat === "string" && pColumOptions.dateFormat.length > 0) {
            format = pColumOptions.dateFormat;
          } else {
            format = that.options.dateFormat;
          }
          if (format.indexOf("LTS.SSS") >= 0 && moment.localeData().longDateFormat("LTS").match(new RegExp("a", "i"))) {
            format = format.replace("LTS", moment().localeData().longDateFormat("LTS"));
            format = format.replace(":ss A.SSS", ":ss.SSS A");
          }
          if (pColumOptions && pColumOptions.utc === true) {
            return valueDate.utc().format(format);
          }
          return valueDate.format(format);
        },
        "enum": function _enum(pKey, pColumOptions) {
          var value = pColumOptions.keyValues[pKey];
          if (value === undefined) {
            return "";
          }
          return value;
        },
        "translationObject": function translationObject(pTranslationObject, pColumOptions) {
          if (pTranslationObject && _typeof(pTranslationObject) === "object" && !Array.isArray(pTranslationObject)) {
            if (pTranslationObject[that.options.language]) {
              // short cut, when language is known
              return pTranslationObject[that.options.language];
            } else {
              if (!pColumOptions) {
                pColumOptions = {};
              }
              if (pColumOptions.strict !== true) {
                var languages = Object.keys(pTranslationObject);
                languages = languages.sort(); // make sure the "en-gb" come later in list ten "en"
                for (var i = 0; i < languages.length; i++) {
                  if (languages[i].startsWith(that.options.language)) {
                    return pTranslationObject[languages[i]];
                  }
                }
                for (var i = 0; i < languages.length; i++) {
                  if (languages[i].substring(0, 2) === "en") {
                    return pTranslationObject[languages[i]];
                  }
                }
              }
            }
          }
          return "";
        },
        "selectCheckbox": function selectCheckbox(pRowID, pColumOptions) {
          return $("<input>").addClass("table_select cf-select-checkbox").attr({
            "type": "checkbox",
            "aria-label": $.i18n._("nixps-cloudflow-table.selectionmenu_actionname_select")
          }).prop("checked", that.selectedDictIDs[pRowID] !== undefined).toggleClass("cf-table-toggleable", that.selectedDictIDs[pRowID] === undefined).data("table_select_rowid", pRowID);
        }
      };
      // create aliasing
      this.renderDict.text = this.renderDict.string;

      // make searchDictionary
      this.searchDict = {
        "string": function string(pColumnObject) {
          var searchinput = $("<input>").attr({
            "type": "search",
            "aria-label": $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label])
          }).addClass("table-search");
          if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length === 5 && pColumnObject.search_startquery[2] === "contains text like") {
            searchinput.val(pColumnObject.search_startquery[3].toString());
          }
          if (typeof pColumnObject.search_inputclasses === "string") {
            searchinput.addClass(pColumnObject.search_inputclasses);
          }
          return searchinput;
        },
        "boolean": function boolean(pColumnObject) {
          var searchBoolean = $("<select>").attr({
            "aria-label": $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label])
          }).addClass("table-search table-search-boolean").append($("<option>").text($.i18n._("nixps-cloudflow-table.no_filter")).val(null)).append($("<option>").append($("<span>").addClass("boolIcon").html("&#10003;")).append("&nbsp;").append($("<span>").addClass("boolText").text($.i18n._("nixps-cloudflow-table.boolean_true"))).val(true)).append($("<option>").append($("<span>").addClass("boolIcon").html("&#10005;")).append("&nbsp;").append($("<span>").addClass("boolText").text($.i18n._("nixps-cloudflow-table.boolean_false"))).val(false));
          if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length === 5 && pColumnObject.search_startquery[2] === "equal to") {
            searchBoolean.val(pColumnObject.search_startquery[3].toString());
          }
          if (typeof pColumnObject.search_inputclasses === "string") {
            searchBoolean.addClass(pColumnObject.search_inputclasses);
          }
          return searchBoolean;
        },
        "date": function date(dateColumnObject) {
          var button = $("<span>").text($.i18n._("nixps-cloudflow-table.filter_dateperiode_start")).addClass("filterDateStartButton closeMode").attr("data-filterKey", dateColumnObject.key);
          button.on("click", function () {
            $(this).removeClass("closeMode").addClass("openMode").hide();
            var filterText = $("<span>").addClass("filterDateText").text(dateColumnObject.label);
            var closeButton = $("<span>").addClass("closeFilter noselect").html("&#10005;").attr("title", $.i18n._("nixps-cloudflow-table.close")).on("click", function (pEvent) {
              var key = $(pEvent.target).parents("[data-filterKey]").attr("data-filterKey");
              that.element.children("table").children("thead:not(.tableFloatingHeader)").find('.tableHeaderSearch .filterDateStartButton[data-filterKey="' + key + '"]').removeClass("openMode").addClass("closeMode").show().trigger("customchange");
              $(pEvent.target).parents(".tableHeaderSearch").detach();
            });
            var searchRow = $("<tr>").addClass("tableHeaderSearch").attr("data-filterKey", dateColumnObject.key).append($("<th>").attr("colspan", that.options.columns.length).addClass("cf-table-header-overflowvisible").append(filterText).append($("<div>").css("display", "inline-block").addClass("table-search datetimepicker").DatetimeSelector({
              format: that.options.dateFormat,
              language: that.options.language,
              periode: true
            })).append(closeButton));
            // ['(', pColumnObject.key, 'greater than or equal to', value.fromDate.valueOf(), 'and', pColumnObject.key, 'less than or equal to', value.toDate.valueOf(), ')'];
            if (Array.isArray(dateColumnObject.search_startquery) && dateColumnObject.search_startquery.length === 9 && dateColumnObject.search_startquery[2] === "greater than or equal to" && dateColumnObject.search_startquery[4] === "and" && dateColumnObject.search_startquery[6] === "less than or equal to") {
              searchRow.find(".datetimepicker").DatetimeSelector("setValue", dateColumnObject.search_startquery[3], dateColumnObject.search_startquery[7]);
            }
            that.element.children("table").children("thead:not(.tableFloatingHeader)").append(searchRow);
            $(this).trigger("customchange");
          });
          return button;
        },
        "number": function number(pColumnObject) {
          var searchInput = $("<span>").append($("<select>").addClass("table-search").attr({
            "aria-label": $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label])
          }).append($("<option>").attr("value", "equal to").text($.i18n._("nixps-cloudflow-table.equalto"))).append($("<option>").attr("value", "greater than").text($.i18n._("nixps-cloudflow-table.greaterthan"))).append($("<option>").attr("value", "less than").text($.i18n._("nixps-cloudflow-table.lessthan")))).append("<input type='text' class='table-search'/>");
          if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length === 5) {
            searchInput.find("select").val(pColumnObject.search_startquery[2]);
            searchInput.find("input").val(parseFloat(pColumnObject.search_startquery[3]));
            if (typeof pColumnObject.search_inputclasses === "string") {
              searchInput.find("input").addClass(pColumnObject.search_inputclasses);
            }
          }
          return searchInput;
        },
        "enum": function _enum(pColumnObject) {
          if (pColumnObject.options !== undefined && $.isPlainObject(pColumnObject.options.keyValues)) {
            // add all posibilities
            pColumnObject.options.keyValues["*"] = $.i18n._("nixps-cloudflow-table.selector_allpossibilities");
            // make selector
            var searchEnum = $("<div>").Select({
              keyValues: pColumnObject.options.keyValues,
              "default": "*",
              classes: "table-search",
              ariaLabel: $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label])
            });
            if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length === 5 && pColumnObject.search_startquery[2] === "equal to") {
              searchEnum.Select("setValue", pColumnObject.search_startquery[3]);
            }
            if (typeof pColumnObject.search_inputclasses === "string") {
              searchEnum.addClass(pColumnObject.search_inputclasses);
            }
            return searchEnum;
          }
          return "";
        },
        "translationObject": function translationObject(pColumnObject) {
          var searchinput = $("<input>").attr({
            "type": "search",
            "aria-label": $.i18n._("nixps-cloudflow-table.searchby", [pColumnObject.label])
          }).addClass("table-search");
          if (Array.isArray(pColumnObject.search_startquery) && pColumnObject.search_startquery.length === 5 && pColumnObject.search_startquery[2] === "contains text like") {
            searchinput.val(pColumnObject.search_startquery[3].toString());
          }
          if (typeof pColumnObject.search_inputclasses === "string") {
            searchinput.addClass(pColumnObject.search_inputclasses);
          }
          return searchinput;
        },
        "selectCheckbox": function selectCheckbox() {
          return $("<div>").addClass("cf-table-amount-selected tableAmountSelectedRows text_center");
        }
      };
      // create aliasing
      this.searchDict.text = this.searchDict.string;
      this.searchDict.dateISO = this.searchDict.date;

      // make searchQueryDictionary
      this.searchQueryDict = {
        "string": function string(searchDOMElem, pColumnObject) {
          var value = searchDOMElem.find("input").val();
          var key = pColumnObject.key;
          if (typeof value === "string" && value.length > 0) {
            return ["(", key, "contains text like", value, ")"];
          } else {
            return [];
          }
        },
        "text": function text(searchDOMElem, pColumnObject) {
          var value = searchDOMElem.find("input").val();
          var key = pColumnObject.key;
          if (typeof value === "string" && value.length > 0) {
            return ["(", key, "contains text like", value, ")"];
          } else {
            return [];
          }
        },
        "boolean": function boolean(searchDOMElem, pColumnObject) {
          var value = searchDOMElem.find("select").val();
          var key = pColumnObject.key;
          if (value === "true" || value === true) {
            return ["(", key, "equal to", true, ")"];
          } else if (value === "false" || value === false) {
            return ["(", key, "equal to", false, ")"];
          } else {
            // also in case of null / no filtering
            return [];
          }
        },
        "date": function date(searchDOMElem, pColumnObject) {
          if (searchDOMElem.find(".filterDateStartButton").hasClass("closeMode")) {
            return [];
          }
          var value = searchDOMElem.closest("thead").find('[data-filterKey="' + pColumnObject.key + '"] .nixps-cloudflow-DatetimeSelector').DatetimeSelector('getValue');
          if ($.isPlainObject(value) && !$.isEmptyObject(value.fromDate) && !$.isEmptyObject(value.toDate)) {
            return ["(", pColumnObject.key, "greater than or equal to", value.fromDate.valueOf(), "and", pColumnObject.key, "less than or equal to", value.toDate.valueOf(), ")"];
          } else {
            return [];
          }
        },
        "dateISO": function dateISO(searchDOMElem, pColumnObject) {
          if (searchDOMElem.find(".filterDateStartButton").hasClass("closeMode")) {
            return [];
          }
          var value = searchDOMElem.closest("thead").find('[data-filterKey="' + pColumnObject.key + '"] .nixps-cloudflow-DatetimeSelector').DatetimeSelector("getValue");
          if ($.isPlainObject(value) && !$.isEmptyObject(value.fromDate) && !$.isEmptyObject(value.toDate)) {
            return ["(", pColumnObject.key, "greater than or equal to", value.fromDate.toJSON(), "and", pColumnObject.key, "less than or equal to", value.toDate.toJSON(), ")"];
          } else {
            return [];
          }
        },
        "number": function number(searchDOMElem, pColumnObject) {
          var operator = searchDOMElem.find("select").val();
          var value = searchDOMElem.find("input").val();
          var key = pColumnObject.key;
          if (typeof value === "string" && value.length > 0) {
            return ["(", key, operator, parseFloat(value), ")"];
          } else {
            return [];
          }
        },
        "enum": function _enum(searchDOMElem, pColumnObject) {
          var value = searchDOMElem.find(".nixps-cloudflow-Select").Select("getValue");
          var key = pColumnObject.key;
          if (value !== "*") {
            if (pColumnObject.options && pColumnObject.options.outputFormat === "number") {
              value = parseFloat(value);
            }
            return ["(", key, "equal to", value, ")"];
          } else {
            return [];
          }
        },
        "translationObject": function translationObject(searchDOMElem, pColumnObject) {
          var value = searchDOMElem.find("input").val();
          var key = pColumnObject.key;
          if (typeof value === "string" && value.length > 0) {
            if (pColumnObject.strict !== true) {
              return ["(", key + "." + that.options.language, "contains text like", value, ")", "or", "(", "(", key + "." + that.options.language, "does not exist", ")", "and", "(", key + ".en", "contains text like", value, ")", ")"];
            } else {
              return ["(", key + "." + that.options.language, "contains text like", value, ")"];
            }
          } else {
            return [];
          }
        },
        "selectCheckbox": function selectCheckbox() {}
      };
      // make editDictionary
      var that = this;
      this.editDict = {
        "string": that._editStringCellHandler.bind(that),
        "number": that._editNumberCellHandler.bind(that),
        "password": that._editPasswordCellHandler.bind(that),
        "boolean": that._editBooleanCellHandler.bind(that),
        "date": that._editDateCellHandler.bind(that),
        "enum": that._editEnumHandler.bind(that),
        "translationObject": that._editTranslationObjectCellHandler.bind(that),
        "selectCheckbox": function selectCheckbox() {}
      };
      // create aliasing
      this.editDict.text = this.editDict.string;
      this.editDict.dateISO = this.editDict.date;
      this.clearSearchDict = {
        "string": function string(searchDOMElem, pColumnObject) {
          searchDOMElem.find("input").val("");
        },
        "boolean": function boolean(searchDOMElem, pColumnObject) {
          searchDOMElem.find(".table-search").val(null);
        },
        "number": function number(searchDOMElem, pColumnObject) {
          searchDOMElem.find("select").val("equal to");
          searchDOMElem.find("input").val("");
        },
        "enum": function _enum(searchDOMElem, pColumnObject) {
          searchDOMElem.find(".nixps-cloudflow-Select").Select("setValue", "*");
        },
        "date": function date(searchDOMElem, pColumnObject) {
          if (searchDOMElem.find(".filterDateStartButton").hasClass("closeMode")) {
            return true;
          }
          searchDOMElem.closest("thead").find("[data-filterKey='" + pColumnObject.key + "']").find(".closeFilter").trigger("click");
        },
        "dateISO": function dateISO(searchDOMElem, pColumnObject) {
          if (searchDOMElem.find(".filterDateStartButton").hasClass("closeMode")) {
            return true;
          }
          searchDOMElem.closest("thead").find("[data-filterKey='" + pColumnObject.key + "']").find(".closeFilter").trigger("click");
        },
        "translationObject": function translationObject(searchDOMElem, pColumnObject) {
          searchDOMElem.find("input").val("");
        }
      };
      this.clearSearchDict.text = this.clearSearchDict.string;

      // add additional functions
      for (var i = 0, leng = this.options.additionalTypes.length; i < leng; i++) {
        this.addAdditionType(this.options.additionalTypes[i].type, this.options.additionalTypes[i]);
      }
      this.dataProviderCallID = 0; // the numbers of calls, done, to have a unique number for every call, to prevent lost calls 
      this.selectedDictIDs = {}; // object containing the ids of the selected rows
      this.stickyHeaderActive = false;
      this.stickyHeaderScrollingArea = $(document);
      this.stickyHeaderTopOffset;
      this.showOnlySelection = false; // only show selected rows, init false

      this.stickHeadersArea = window; // same default as plugin
      if (this.options.enableStickyHeader === true && this.options.stickyHeaderAppliedBy === "js") {
        if (this.options.stickyHeaderScrollableArea === "auto") {
          if (this.element.closest(".cf-pagecontent").length === 1) {
            this.stickHeadersArea = this.element.closest(".cf-pagecontent");
            this.stickyHeaderScrollingArea = this.stickHeadersArea;
          }
        } else if (typeof this.options.stickyHeaderScrollableArea === "string" || this.options.stickyHeaderScrollableArea.length === 1) {
          this.stickHeadersArea = $(this.options.stickyHeaderScrollableArea);
          this.stickyHeaderScrollingArea = this.stickHeadersArea;
        }
      }
      if (typeof this.options.searchingThrottleDelay === "number" && this.options.searchingThrottleDelay > 0 && window._ !== undefined && typeof _.debounce === "function") {
        this.searchHeaderChangeHandler = _.debounce(this._searchHeaderChangeHandler, this.options.searchingThrottleDelay);
      } else {
        this.searchHeaderChangeHandler = this._searchHeaderChangeHandler;
      }
      this._draw();
      this._on(this.element, {
        "click th.sortable": this._sortColumnHandler,
        "click .leftPagingButton": this._leftPagingClickHandler,
        "click .rightPagingButton": this._rightPagingClickHandler,
        "change .tableHeaderSearch th .table-search": this.searchHeaderChangeHandler,
        "input .tableHeaderSearch th .table-search": this.searchHeaderChangeHandler,
        "datetimeselectorchange .tableHeaderSearch th .table-search": this.searchHeaderChangeHandler,
        "customchange .tableHeaderSearch": this.searchHeaderChangeHandler,
        "click td": this._clickCellHandler,
        "dblclick td": this._dblClickCellHandler,
        "change thead .tableColumnHeaderSelectBox": this._selectHeaderCheckBoxClickHandler,
        "selectingselect": this._selectingHandler,
        "nixps:longpress tr": this._longpressHandler,
        "nixps:swipeleft tr": this._swipeleftHandler,
        "nixps:swiperight tr": this._swiperightHandler,
        "click .tableConfigButtonIcon": this._configClickHandler,
        "click .tableCheckboxSelectionMenu": this._selectionCaretClickHandler,
        "click .tableProtectionLayer": this._protectionLayerClickHandler
      });
      var stickyHeaderDOM = this.element;
      if (this.options.stickyTableHeadersParent !== undefined && this.options.stickyTableHeadersParent instanceof jQuery) {
        stickyHeaderDOM = that.options.stickyTableHeadersParent;
      }
      stickyHeaderDOM.on("enabledStickiness.stickyTableHeaders", this._startStickyHeaderHandler.bind(this));
      stickyHeaderDOM.on("disabledStickiness.stickyTableHeaders", this._endStickyHeaderHandler.bind(this));
      if (typeof this.options.editCellEvent === "string" && this.options.editCellEvent.length > 1) {
        var editEvent = this.options.editCellEvent + " tr:not(.tableInlineRow) td";
        var eventObject = {};
        eventObject[editEvent] = this._editCellHandler;
        this._on(this.element, eventObject);
      }
      if (this.options.overflowMechanism === "scrolling") {
        this._on(this.element, {
          "scroll": this._scrollHandler
        });
      }
    },
    /**
     * @description redraw
     * @name nixps-cloudflow.Table#redraw
     * @function
     */
    redraw: function redraw() {
      // destroy the sticky header, it will be readded in the drawBody function
      if (this.options.enableStickyHeader === true) {
        var stickyHeaderDOM;
        if (this.options.stickyTableHeadersParent && this.options.stickyTableHeadersParent instanceof jQuery) {
          stickyHeaderDOM = this.options.stickyTableHeadersParent;
        } else {
          stickyHeaderDOM = this.element.children("table");
        }
        // inform the sticky that the columns headers changed
        var data = stickyHeaderDOM.data();
        // check if plugin is applied
        if (data && data.plugin_stickyTableHeaders) {
          stickyHeaderDOM.stickyTableHeaders("destroy");
        }
      }
      this._draw();
    },
    /**
     * @description Draw the table according to the current state
     * @name nixps-cloudflow.Table#_draw
     * @function
     * @private
     */
    _draw: function _draw() {
      var that = this;
      var stickHeaderByCSS = this.options.enableStickyHeader === true && this.options.stickyHeaderAppliedBy === "css";

      // draw table and header, table is still empty 
      var table = $("<table>").addClass("table").addClass(this.options.classes).toggleClass("cf-table-stickyheader", stickHeaderByCSS);
      this.element.empty().append(table);

      // add colgroup
      var colgroup = $("<colgroup>");
      table.append(colgroup);
      this.mSectionDropdown = $();
      var headerRow = $("<tr>").addClass("tableHeaderTitels");
      var headerSearching = false;
      var startSearchQuery = [];
      var headerCells = [],
        colgroupCells = [];
      for (var i = 0, leng = this.options.columns.length; i < leng; i++) {
        // handle and prepare selectCheckbox
        if (this.options.columns[i].type === "selectCheckbox") {
          // reset key
          if (typeof this.options.keyUniqID === "string" && this.options.keyUniqID.length > 0) {
            this.options.columns[i].key = this.options.keyUniqID;
          } else {
            console.warn("Table: A unique key is needed for selecting rows, we toke _id as fallback");
            this.options.columns[i].key = "_id";
          }
          if (this.options.selecting === null) {
            this.options.selecting = {};
          }
          this.options.selecting = Object.assign({
            multiple: true,
            fastMultiple: true,
            handle: " input[type=checkbox].table_select",
            deselectable: true
          }, this.options.selecting);
          // reset label, searchable and sortable
          this.options.columns[i].searchable = this.options.selecting.multiple === true;
          this.options.columns[i].sortable = false;
          // add a general header checkbox
          var selectionSearchDOM = $("<span>");
          selectionSearchDOM.append($("<input>").attr("type", "checkbox").addClass("cf-select-checkbox tableColumnHeaderSelectBox").attr("title", $.i18n._("nixps-cloudflow-table.selectionmenu_tooltipgenericcheckbox")));
          var caretDownButton = $('<span>').addClass("tableCheckboxSelectionMenu cf-select-checkboxcaret fa fa-caret-down");
          selectionSearchDOM.append(caretDownButton);
          // create it only once
          if (this.mSectionDropdown.hasClass(".nixps-DropdownList") === false) {
            this.mSectionDropdown = $('<div>').addClass("tableSelectionDropdown").DropdownList({
              trigger: caretDownButton,
              cssContainer: {
                position: "absolute",
                display: "inline-block"
              },
              hideOnScroll: false,
              classes: {
                "dropdownlist-actionlist": "cf-dropdown cf-dropdown-secondary cf-dropdown-checkable"
              },
              show: function show() {
                that.addProtectionLayer();
              },
              hide: function hide() {
                that.removeProtectionLayer();
              }
            });
            var hasSelection = Object.keys(this.selectedDictIDs).length > 0;
            this.mSectionDropdown.DropdownList("addListItem", "dropdownlistSelectionOnly", "<span>", $.i18n._("nixps-cloudflow-table.selectionmenu_showonlyselection"), hasSelection, this._showOnlySelectionClickHandler.bind(this));
            this.mSectionDropdown.DropdownList("addListItem", "dropdownlistRemoveSelection", "<span>", $.i18n._("nixps-cloudflow-table.selectionmenu_removeall"), hasSelection, this._unselectAllRowsClickHandler.bind(this));
            this.element.prepend(this.mSectionDropdown);
          }
          this.options.columns[i].label = selectionSearchDOM;
        }
        if (this.options.columns[i].searchable === true) {
          headerSearching = true;
        }
        headerCells.push($("<th>").html(this.options.columns[i].label).data("model", this.options.columns[i]).addClass(function () {
          if (that.options.columns[i].sortable === true) {
            return "noselect sortable";
          }
          return "noselect";
        }).addClass(this.options.columns[i].headerClass).attr("scope", "col").attr("data-title", typeof this.options.columns[i].label === "string" ? this.options.columns[i].label : "").append(function () {
          if (that.options.columns[i].sortable === true) {
            return $('<span>').addClass('tableColumnIcon cf-table-head-icon');
          }
        }));
        // add col element
        colgroupCells.push($("<col>").addClass("tableColumn-" + this.options.columns[i].key));
      }
      headerRow.append(headerCells);
      colgroup.append(colgroupCells);
      var tableHeader = $("<thead>").addClass("cf-table-head nixps_styling_constants_bodybackground").append(headerRow);
      table.append(tableHeader).append($("<tbody>").addClass(this.options.bodyClasses));
      if (headerSearching) {
        var searchRow = $("<tr>").addClass('tableHeaderSearch cf-table-filter');
        var searchCells = [];
        for (var i = 0, leng = this.options.columns.length; i < leng; i++) {
          if (this.options.columns[i].searchable === true) {
            searchCells.push($("<th>").attr("scope", "col").append(this._getSearchType(this.options.columns[i].type)(this.options.columns[i])).addClass(function () {
              if (typeof that.options.columns[i].headerClass === "string" && that.options.columns[i].headerClass.indexOf("fix_width") == 0) {
                return that.options.columns[i].headerClass;
              }
            }));
            if (Array.isArray(this.options.columns[i].search_startquery) && this.options.columns[i].search_startquery.length > 0) {
              if (startSearchQuery.length > 0) {
                startSearchQuery.push("and");
                startSearchQuery = startSearchQuery.concat(this.options.columns[i].search_startquery);
              } else {
                startSearchQuery = this.options.columns[i].search_startquery;
              }
            }
          } else {
            searchCells.push($("<th>").attr("scope", "col"));
          }
        }
        searchRow.append(searchCells);
        tableHeader.append(searchRow);
      }
      this.tableConfig = null;
      this.collapsibleColumns = null;
      if (this.options.configColumns !== null) {
        if (typeof this.options.configTableID === "string" && this.options.configTableID.length > 0) {
          // set up config objects
          this.tableConfig = new TableConfig(this.options.configTableID, this.options.columns);
          this.collapsibleColumns = this.tableConfig.getColumnsToShow();
          this._toggleColumnsHeader();
          // set up ui config
          var configContainer = $("<div>").addClass("tableHeaderConfig").toggleClass("tableHeaderConfig_stick_byCSS", stickHeaderByCSS);
          var button = $("<button>").attr({
            "type": "button",
            "aria-label": $.i18n._("nixps-cloudflow-table.action_configurecolumns")
          }).addClass("tableConfigButton cf-table-header-colors").append($("<span>").addClass("tableConfigButtonIcon fa fa-cog"));
          configContainer.append(button);
          this.element.prepend(configContainer);
          var collabsibleHelpDom = $("<div>");
          button.append(collabsibleHelpDom);
          collabsibleHelpDom.CollapsibleColumns({
            columns: this.options.columns,
            columnsToShow: this.collapsibleColumns,
            change: function change(pEvent, pData) {
              if (pData !== undefined && Array.isArray(pData.columns)) {
                that.collapsibleColumns = pData.columns;
                that.tableConfig.setColumnsToShow(that.collapsibleColumns);
                that._toggleColumnsHeader.apply(that);
                that._toggleColumnsBody.apply(that);
                that._delay(function () {
                  that.tableConfig.save();
                });
              }
            },
            open: function open(pEvent, pData) {
              that.addProtectionLayer("cf-zindex-dropdownlist-low", pData.clickCB);
              $(pEvent.target).closest(".tableHeaderConfig").addClass("tableHeaderConfig_bussy");
            },
            close: function close(pEvent) {
              that.removeProtectionLayer();
              $(pEvent.target).closest(".tableHeaderConfig").removeClass("tableHeaderConfig_bussy");
            }
          });
        }
      }
      if (this.options.showRowCounter === true) {
        if (window._ !== undefined && typeof _.debounce === "function") {
          this.updateRowDetails = _.debounce(this._updateRowDetails, 500);
        } else {
          console.error("please, include underscore.js for performanse reasons");
          this.updateRowDetails = this._updateRowDetails;
        }
      }
      this.scrollCallBackBusy; // flag indication busy with loading data when scrolling, init on undefined
      this.overflow = true; // flag indication overflow when user addRows,  scolling
      // draw the body with data
      this.isEnd = false;
      this.skip = 0;
      if (typeof this.options.initSkip === "number" && this.options.initSkip > 0) {
        this.skip = this.options.initSkip;
      }
      this.query = new Query([], startSearchQuery);
      this.orderBy = transformSortToBackendSort(this.options.sort);
      if (Array.isArray(this.orderBy) && this.orderBy.length > 0 && this.orderBy.length % 2 === 0 && typeof this.orderBy[0] === "string" && this.orderBy[0].length > 0) {
        var columnIndex = -1;
        for (var i = 0; i < this.options.columns.length; i++) {
          if (this.options.columns[i].sortable === true && this.options.columns[i].key === this.orderBy[0]) {
            columnIndex = i;
            break;
          }
        }
        if (columnIndex < 0) {
          // column not found, sorting on other keys
        } else {
          // column found
          var columnToSort = this.element.find("th").eq(columnIndex);
          if (columnToSort.length > 0) {
            // default ascending
            this._prepareSortColumn(columnToSort, this.orderBy[0], this.orderBy[1] !== "descending");
          }
        }
      } else {
        // reset orderBy if data is bad
        this.orderBy = [];
      }
      if (this.options.maxRows === null) {
        // if no maxRows add maximum rows
        this.limit = Number.MAX_VALUE;
      } else if (typeof this.options.maxRows === "number") {
        this.limit = this.options.maxRows;
      } else if (this.options.maxRows === "auto") {
        this.limit = 1; // get 1 row to have at least 1 row to calc the height
      }

      if (this.options.maxRows !== null) {
        if (this.options.overflowMechanism === "scrolling") {
          // we are auto loading
          this.element.append($("<div>").addClass("table_loadingpanel").text($.i18n._("nixps-cloudflow-table.loading_text")).hide());
        } else {
          // only add paging bar if maxRow are fill in
          this.element.append(this._getPagingBottomBar(this.options.pagingButtonClasses));
        }
      }

      // panel to show when no items are there
      this.mEmptyRowsPanel = $("<div>").addClass("table_noItemToShowPanel").hide();
      if (typeof this.options.noItemsText === "string") {
        this.mEmptyRowsPanel.append($("<span>").text(this.options.noItemsText));
      }
      this.element.append(this.mEmptyRowsPanel);
      if ($.isPlainObject(this.options.selecting)) {
        this.element.children("table").children("tbody").addClass("cf-parent-selectable").Selecting(Object.assign({
          items: "tr:not(.tableInlineRow)",
          cancel: "[type=text],[type=number],textarea,button,select,option",
          selectClass: "cf-table-rowselect"
        }, this.options.selecting));
      }
      if (this.options.columns.length === 0) {
        // do ask nothing of no columns needs to be shown....
        return;
      }
      this._drawBody(this.query, this.orderBy, this.skip, this.limit).done(function () {
        if (that.options.maxRows === "auto") {
          that.adaptHeight();
        }
      });
    },
    /**
     * @function
     * @private
     * @name nixps-cloudflow.Table#_drawBody
     * @description This function clears all his internal data, keeps it headers, reask his data to the backend and draw the rest of the table
     * @throws {Error} 'Table: Could not load data'
     * @param {Query} pSql - the array to specify with data you want
     * @param {array | string} pOrderBy - the order by query, a array of strings
     * @param {number| integer} pSkip - how many rows must be skiped?
     * @param {number| integer} pLimit - the max amout of rows do we want.
     * @param {Boolean} pKeepInjectedRows - Must we keep the injected page in when refresh
     * @returns {undefined}
     */
    _drawBody: function _drawBody(pSql, pOrderBy, pSkip, pLimit, pKeepInjectedRows) {
      if (pSkip < 0) {
        // repair skip parameter 
        pSkip = 0;
      }
      // instal a min-height because we want to prevent ui switch earthseack
      var height = this.element.height();
      var unrealHeight = 0;
      this.element.children("table").children("tbody").children("tr.tableInlineRow").each(function () {
        unrealHeight += $(this).height();
      });
      if (height > unrealHeight + 10 /*delta*/) {
        this.element.css("min-height", pKeepInjectedRows === true ? height : height - unrealHeight);
      }

      // add data
      var data = this.options.dataProvider(pSql.getQuery().slice(), pOrderBy, pSkip, pLimit + 1); //ask one more, so we know if we get the last
      if (data === undefined) {
        throw new Error("Table: Could not load data");
      }
      this.dataProviderCallID++; // the number of calls done, to have a unique number for every call
      var dataExists = {};
      // check existing selected checkboxs
      if (this.showOnlySelection === false && $.isEmptyObject(this.selectedDictIDs) === false) {
        if (typeof this.options.dataExists === "function") {
          dataExists = this.options.dataExists(this.getSelectedRowIDs());
        }
      }
      var that = this;
      return $.when(data, dataExists, this.dataProviderCallID).done(function (pData, pSelectedRows, pCallingID) {
        if (pCallingID !== that.dataProviderCallID) {
          // call of previous calls came later than needed
          that._trigger("dataloaded", null, {
            skip: pSkip,
            limit: pLimit,
            dataCount: pData.length,
            wrongReturnOrder: true
          });
          return true;
        }
        var rows = [];
        var rowsCount = undefined;
        if (Array.isArray(pData.results || pData.documents)) {
          rows = pData.results || pData.documents;
          rowsCount = pData.count;
        } else {
          rows = pData;
        }
        if (rows.length === 0 && that.skip > 0 && that.limit > 0 && that.skip >= that.limit) {
          // warning there where more rows, but they are gone now
          if (rowsCount === 0) {
            // we are in special case, there are no rows at all, even no rows after left paging
            // simulate a draw of empty table in first page
            that.skip = 0;
            // continue to draw
          } else if (typeof rowsCount === "number" && rowsCount > 0) {
            var newSkip = parseInt(rowsCount / that.limit) * that.limit;
            // preventing loop, newSkip must be smaller and smaller
            if (newSkip < that.skip) {
              that.skip = newSkip;
              that._drawBody(that.query, that.orderBy, that.skip, that.limit);
              return true;
            } else {
              // strange situation, this rowsCount is wrongly calculated outside component
              console.error("Table: wrong calculation of rowsCount");
              that.skip = 0;
              // continue to draw
            }
          } else if (that.options.showRowCounter === false) {
            // we know that that.skip > that.limit
            that.skip -= that.limit;
            that._drawBody(that.query, that.orderBy, that.skip, that.limit);
            return true;
          } else if (that.options.showRowCounter === true) {
            // for the moment do this choose
            // we know that that.skip > that.limit
            that.skip -= that.limit;
            that._drawBody(that.query, that.orderBy, that.skip, that.limit);
            return true;
          }
        }
        // remove all data after the header
        that._makeTableWithInputData(rows, rowsCount, false, pKeepInjectedRows, that.dataProviderCallID);
        // clean up selected row ids model, remove non-existings
        var selectedRows = pSelectedRows;
        if (selectedRows && !Array.isArray(selectedRows) && Array.isArray(selectedRows.results || selectedRows.documents)) {
          selectedRows = selectedRows.results || selectedRows.documents;
        }
        if (Array.isArray(selectedRows) && that.showOnlySelection === false) {
          var newDictIDs = {};
          for (var i = 0, leng = selectedRows.length; i < leng; i++) {
            // extra check of uncorrected api calls
            var selectedRowID;
            var selectedRowObject;
            if (typeof selectedRows[i] === "string" || typeof selectedRows[i] === "number") {
              selectedRowID = selectedRows[i];
              selectedRowObject = that.selectedDictIDs[selectedRowID];
            } else if ($.isPlainObject(selectedRows[i])) {
              if (typeof that.options.keyUniqID === "string" && that.options.keyUniqID.length > 0) {
                selectedRowID = CloudflowObject.getParameter(selectedRows[i], that.options.keyUniqID);
              } else {
                selectedRowID = selectedRows[i]._id;
              }
              selectedRowObject = selectedRows[i];
            } else {
              console.error("invalid return type dataExists");
            }
            if (that.selectedDictIDs[selectedRowID] !== undefined) {
              newDictIDs[selectedRowID] = selectedRowObject;
            }
          }
          that.selectedDictIDs = newDictIDs;
          that._informAmountSelectedRows();
        }
        // update header
        if (that.options.enableStickyHeader === true && that.options.stickyHeaderAppliedBy === "js" && $.fn.stickyTableHeaders !== undefined) {
          var stickyHeaderDOM;
          if (that.options.stickyTableHeadersParent !== undefined && that.options.stickyTableHeadersParent instanceof jQuery) {
            stickyHeaderDOM = that.options.stickyTableHeadersParent;
          } else {
            stickyHeaderDOM = that.element.children("table");
          }
          stickyHeaderDOM.stickyTableHeaders({
            cacheHeaderHeight: that.options.stickyHeaderMarginTop === 0,
            fixedOffset: 0,
            marginTop: that.options.stickyHeaderMarginTop,
            scrollableArea: that.stickHeadersArea
          });
        }
        // inform others
        that._trigger("dataloaded", null, {
          skip: pSkip,
          limit: pLimit,
          dataCount: pData.length,
          wrongReturnOrder: false
        });
        if (that.options.keepHeight !== true) {
          that.element.css("min-height", "");
        }
      }).fail(function (pError, pErrorData) {
        if (pError && pError.expected === true) {
          return;
        }
        if (pError === "ajax call failed" && pErrorData !== undefined) {
          pError = pErrorData;
        }
        console.error("Table: Could not load data", pError);
        var filterhash = null;
        var query = pSql.getQuery();
        if (Array.isArray(query)) {
          filterhash = query.join("");
        }
        that._trigger("dataloaderror", null, {
          error: pError,
          filterhash: filterhash
        });
      });
    },
    /**
     * @function
     * @private
     * @name nixps-cloudflow.Table#getPagingBottomBar
     * @description make a HTML element that must serve as paging buttombar.
     * add classes 'leftPagingButton' and 'rightPagingButton' to link with the click event listeners.
     * @param {string} pTextLeftButton The text to show on the left side button
     * @param {string} pTextRightButton The text to show on the right side button 
     * @returns {jquery | HTML} bottompale for the paging
     */
    _getPagingBottomBar: function _getPagingBottomBar(pButtonClasses, pTextLeftButton, pTextRightButton) {
      // .tableBottomBar
      //        \--->   .rowsDetailsPanel
      //                         \---->  .rowsDetails
      //        \--->   .pagingButtonPanel
      //                         \---->  .leftPagingButton
      //                         \---->  .rightPagingButton
      var panel = $("<div>").addClass("tableBottomBar cf-table-paging " + this.options.bottombarClasses);
      if (this.options.showRowCounter === true) {
        // rows details bar
        var rowsDetailsPanel = $("<div>").addClass("rowsDetailsPanel");
        rowsDetailsPanel.append($("<span>").addClass("rowsDetails"));
        rowsDetailsPanel.append($("<span>").addClass("selectionDetails"));
        panel.append(rowsDetailsPanel);
      }
      // buttons
      var buttonPanel = $("<div>").addClass("pagingButtonPanel");
      var leftArrow = $("<button>").attr("type", "button").addClass("leftPagingButton").addClass(pButtonClasses).attr("title", $.i18n._("nixps-cloudflow-table.tooltip_leftpaging"));
      leftArrow.append($("<span>").addClass("fa fa-caret-left")).prop("disabled", true).append(pTextLeftButton);
      var rightArrow = $("<button>").attr("type", "button").addClass("rightPagingButton").addClass(pButtonClasses).attr("title", $.i18n._("nixps-cloudflow-table.tooltip_rightpaging"));
      rightArrow.prop("disabled", true).append(pTextRightButton).append($("<span>").addClass("fa fa-caret-right"));
      buttonPanel.append(leftArrow).append(rightArrow);
      panel.append(buttonPanel);
      return panel;
    },
    /**
     * @function
     * @private
     * @description Draw the table with the data recieved from the inputparameter. It just add information add the end of the table. 
     * @name nixps-cloudflow.Table#_makeTableWithInputData
     * @throws {Error} "_makeTableWithInputData: input data for Table must be a array"
     * @throws {Error} "Table: each element in inputoption columns must have a key {string} "
     * @param {array} pData
     * @param {boolean} pIsAddingData boolean indicating of the table must be cleaned or not. true: not cleaned, just added, false: clean the table before adding 
     * @param {boolean} pKeepInjectedRows boolean indicating of the table must try to keep his injected rows while refreshing
     * @param {number} pCallID the unique number refrering to that dataprovider call 
     * @returns {number} the number of added data rows
     */
    _makeTableWithInputData: function _makeTableWithInputData(pData, pDataCount, pIsAddingData, pKeepInjectedRows, pCallID) {
      if (!Array.isArray(pData)) {
        throw new Error("_makeTableWithInputData: input data for Table must be a array");
      }
      var technicalClassesRowIDs = [];
      // remove old data if needed
      if (pIsAddingData === false) {
        if (pKeepInjectedRows === true) {
          var keysObject = {};
          var containsDummyRow = {};
          this.element.children("table").children("tbody").children("tr.tableInlineRow").each(function () {
            var id = $(this).data("rowID");
            if (id !== undefined) {
              if ($(this).next().is(".tableDummyInlineRow")) {
                containsDummyRow[id] = true;
              }
              // remove from the DOM and store in the object
              keysObject[id] = $(this).detach();
            } else {
              return false;
            }
          });
        }
        if ($.isPlainObject(this.options.selecting) && typeof this.options.keyUniqID === "string" && this.options.keyUniqID.length > 0) {
          var technicalClasses = this.element.children("table").children("tbody.nixps-Selecting").Selecting("getTechnicalClasses");
          if (Array.isArray(technicalClasses) && technicalClasses.length > 0) {
            for (var t = 0; t < technicalClasses.length; t++) {
              var rowObject = this.element.children("table").children("tbody").children("tr." + technicalClasses[t]).data("dataitem");
              if ($.isPlainObject(rowObject)) {
                technicalClassesRowIDs.push({
                  "class": technicalClasses[t],
                  id: CloudflowObject.getParameter(rowObject, this.options.keyUniqID)
                });
              }
            }
          }
        }
        this.element.children("table").children("tbody").empty();
      }
      var that = this;
      // Setting paging
      if (this.skip === 0) {
        // disable enable paging buttons
        this.element.children(".tableBottomBar").find(".leftPagingButton").prop("disabled", true);
      } else {
        this.element.children(".tableBottomBar").find(".leftPagingButton").prop("disabled", false);
      }
      // we asked one element extra
      if (pData.length <= this.limit) {
        this.isEnd = true;
        this.element.children(".tableBottomBar").find(".rightPagingButton").prop("disabled", true);
      } else {
        this.isEnd = false;
        pData.pop(); // remove last element
        this.element.children(".tableBottomBar").find(".rightPagingButton").prop("disabled", false);
      }

      // if uniqID is a string. inputdata must be array of objects
      var attrPrefix = "";
      var attribute = "data-tableRowID";
      if (this.options.enableIDAttribute === true) {
        attrPrefix = "tableRowID_";
        attribute = "id";
      }
      var rowClass = false; // fastes way to run addClass
      if (typeof this.options.rowClassKey === "string" && this.options.rowClassKey.length > 0) {
        // the pData variable is known in _makeTableWithInputData function
        // the variable i is also known in the complete _makeTableWithInputData function! and is known when this function is called!
        rowClass = function rowClass() {
          return CloudflowObject.getParameter(pData[i], that.options.rowClassKey);
        };
      }
      var tbody = this.element.children("table").children("tbody");
      var columnsLength = this.options.columns.length;
      var rows = new Array(pData.length),
        cells = [],
        rowDOM = "";
      if (typeof this.options.keyUniqID === "string" && this.options.keyUniqID.length > 0) {
        for (var i = 0, leng = pData.length; i < leng; i++) {
          rowDOM = $("<tr>").attr(attribute, attrPrefix + CloudflowObject.getParameter(pData[i], this.options.keyUniqID)).data("dataitem", pData[i]).addClass(rowClass);
          cells = [];
          for (var r = 0; r < columnsLength; r++) {
            if (this.options.columns[r].repeat_label_in_cell) {
              cells.push($("<td>").addClass("cf-table-headercolumncell").text(this.options.columns[r].label));
            }
            cells.push($("<td>").addClass(this.options.columns[r].cellClass).append(this._getRenderingType(this.options.columns[r].type)(getDataOfObjectTree(pData[i], this.options.columns[r].key, this.options.enableJSONPathInKeys), this.options.columns[r].options, pData, this.options.columns[r], i)));
          }
          rowDOM.append(cells);
          rows[i] = rowDOM;
        }
      } else {
        for (var i = 0, leng = pData.length; i < leng; i++) {
          rowDOM = $("<tr>").data("dataitem", pData[i]).addClass(rowClass);
          cells = [];
          for (var r = 0; r < columnsLength; r++) {
            if (this.options.columns[r].repeat_label_in_cell) {
              cells.push($("<td>").addClass("cf-table-headercolumncell").text(this.options.columns[r].label));
            }
            cells.push($("<td>").addClass(this.options.columns[r].cellClass).append(this._getRenderingType(this.options.columns[r].type)(getDataOfObjectTree(pData[i], this.options.columns[r].key, this.options.enableJSONPathInKeys), this.options.columns[r].options, pData, this.options.columns[r], i)));
          }
          rowDOM.append(cells);
          rows[i] = rowDOM;
        }
      }
      tbody.append(rows);
      if (pKeepInjectedRows === true && $.isEmptyObject(keysObject) === false) {
        if (this.options.enableIDAttribute === true) {
          for (var key in keysObject) {
            if (this.element.children("table").children("tbody").children("tr#tableRowID_" + key).length > 0) {
              this.insertOneCollapseRow("#tableRowID_" + key, containsDummyRow[key] === true).parent().replaceWith(keysObject[key]);
            }
          }
        } else {
          for (var key in keysObject) {
            if (this.element.children("table").children("tbody").children('tr[data-tableRowID="' + key + '"]').length > 0) {
              this.insertOneCollapseRow('[data-tableRowID="' + key + '"]', containsDummyRow[key] === true).parent().replaceWith(keysObject[key]);
            }
          }
        }
      }
      if (this.options.configColumns !== null) {
        this._toggleColumnsBody();
      }
      if ($.isPlainObject(this.options.selecting)) {
        var selectingClass = that.element.children("table").children("tbody.nixps-Selecting").Selecting("option", "selectClass");
        if (typeof selectingClass === "string" && selectingClass.length > 0) {
          this.element.children("table").children("tbody").children("tr").each(function () {
            var rowObject = $(this).data("dataitem");
            if (rowObject !== undefined) {
              var key = "_id";
              if (typeof that.options.keyUniqID === "string") {
                key = that.options.keyUniqID;
              }
              if (that.selectedDictIDs[CloudflowObject.getParameter(rowObject, key)] !== undefined) {
                $(this).addClass(selectingClass);
              }
              for (var t = 0, leng = technicalClassesRowIDs.length; t < leng; t++) {
                if (technicalClassesRowIDs[t].id !== undefined && technicalClassesRowIDs[t].id === rowObject[key]) {
                  $(this).addClass(technicalClassesRowIDs[t]["class"]);
                }
              }
            }
          });
          if (pData.length === 0) {
            this.element.children("table").children("thead").children("tr.tableHeaderTitels").find(".tableColumnHeaderSelectBox").prop("disabled", true).prop("checked", false);
          } else if (this.element.children("table").children("tbody").Selecting("areAllSelected")) {
            this.element.children("table").children("thead").children("tr.tableHeaderTitels").find(".tableColumnHeaderSelectBox").prop("disabled", false).prop("checked", true);
          } else {
            this.element.children("table").children("thead").children("tr.tableHeaderTitels").find(".tableColumnHeaderSelectBox").prop("disabled", false).prop("checked", false);
          }
        }
      }
      this.mEmptyRowsPanel.toggle(pData.length === 0);
      if (this.options.showRowCounter === true) {
        if (typeof pDataCount === "number" && pDataCount >= 0) {
          // count is delivered with the dataProvider function
          this._updateRowDetails(pCallID, pData.length, pDataCount);
        } else {
          this.updateRowDetails(pCallID, pData.length);
        }
      }
      return pData.length;
    },
    /**
     * @description control if the event comes from this component and not from a child that can also be a table
     * @function
     * @name nixps-cloudflow.Table#_isEventFormComponent
     * @private
     * @param {type} pEvent
     * @returns {bollean} true if events source comes from this component, false if event comes form a child component, that bubbles up
     */
    _isEventFormComponent: function _isEventFormComponent(pEvent) {
      return $(pEvent.target).closest('.' + this.widgetFullName).attr('data-uuid') === this.uuid.toString();
    },
    /**
     * @function
     * @private
     * @name nixps-cloudflow.Table#_sortColumnHandler
     * @description this handles the sort handler, when user click on the header.
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _sortColumnHandler: function _sortColumnHandler(pEvent, pData) {
      var column = $(pEvent.currentTarget);
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      var columnModel = column.data('model');
      var columnName = columnModel.key;
      this.skip = 0;
      this.element.children('table').children('thead').children("tr.tableHeaderTitels").find('th .tableColumnIcon').removeClass('fa-caret-down fa-caret-up');
      if (column.hasClass("tableSortUp")) {
        // make down
        this._prepareSortColumn(column, columnName, true);
      } else if (column.hasClass("tableSortDown")) {
        // make up
        this._prepareSortColumn(column, columnName, false);
      } else {
        // make down
        this._prepareSortColumn(column, columnName, true);
      }
      this._drawBody(this.query, this.orderBy, this.skip, this.limit);
    },
    /**
     * @description Internal function that set the ui and this data
     * @name nixps-cloudflow.Table#_prepareSortColumn
     * @function
     * @private
     * @param {HTML} pColumn
     * @param {string} pColumnName - the key of the column object
     * @param {boolean} pAsc - true for ascending, false for descending 
     * @returns {undefined}
     */
    _prepareSortColumn: function _prepareSortColumn(pColumn, pColumnKey, pAsc) {
      this.element.children('table').children('thead').children("tr.tableHeaderTitels").children("th").removeClass("tableSortDown").removeClass("tableSortUp").removeAttr("aria-sort");
      pColumn.addClass(function () {
        if (pAsc) {
          $(this).attr("aria-sort", "ascending");
          return "tableSortDown";
        } else {
          $(this).attr("aria-sort", "descending");
          return "tableSortUp";
        }
      }).find(".tableColumnIcon").addClass(function () {
        if (pAsc) {
          return "fa fa-caret-up";
        } else {
          return "fa fa-caret-down";
        }
      });
      this.orderBy = Query.getQueryDataSortByColumn(pColumnKey, pAsc);
      this.options.sort = transformBackendSortToSort(this.orderBy);
    },
    /**
     * in development
     * @private
     * @function
     * @name nixps-cloudflow.Table#_scrollHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _scrollHandler: function _scrollHandler(pEvent, pData) {
      if (this.overflow === true) {
        this._scrollTrottleFunction();
      }
    },
    /**
     * @description Control and if needed load extra rows
     * @name nixps-cloudflow.Table#_scrollTrottleFunction
     * @function
     * @private
     * @returns {undefined}
     */
    _scrollTrottleFunction: function _scrollTrottleFunction() {
      // if function is not being loading and if bottom reached, go loading ...
      if (this.scrollCallBackBusy !== true && this.element.scrollTop() + this.element.height() >= this.element.children('table')[0].scrollHeight - 5) {
        // set flag to loading, prevent to called multiple times when result is not finished
        this.scrollCallBackBusy = true;
        // show waiting panel
        this.element.find('.table_loadingpanel').show();
        var that = this;
        // load and show rows
        this.addNextRows(this.options.maxRows).always(function (pResults) {
          // loading is done, disable flags and messages
          that.element.find('.table_loadingpanel').hide();
          that.scrollCallBackBusy = undefined;
        });
      }
    },
    /**
     * @function
     * @private
     * @name nixps-cloudflow.Table#_leftPagingClickHandler
     * @description function runs when user click on button to see the previeuw rows
     * @param {event} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _leftPagingClickHandler: function _leftPagingClickHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      this.element.children('.tableBottomBar').find('.leftPagingButton, .rightPagingButton').prop('disabled', true);
      if (this.skip > this.limit) {
        this.skip -= this.limit;
        this.isEnd = false;
        this._drawBody(this.query, this.orderBy, this.skip, this.limit);
      } else if (this.skip > 0) {
        this.skip = 0;
        this.isEnd = false;
        this._drawBody(this.query, this.orderBy, this.skip, this.limit);
      }
    },
    /**
     * @function
     * @private
     * @name nixps-cloudflow.Table#_rightPagingClickHandler
     * @description function runs when user click on button to see the next rows
     * @param {event} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _rightPagingClickHandler: function _rightPagingClickHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      this.element.children('.tableBottomBar').find('.leftPagingButton, .rightPagingButton').prop('disabled', true);
      if (this.isEnd === false) {
        this.skip += this.limit;
        this._drawBody(this.query, this.orderBy, this.skip, this.limit);
      }
    },
    /**
     * @description function runs when user want to search on a column
     * @function
     * @private
     * @name nixps-cloudflow.Table#_searchHeaderChangeHandler
     * @param {event} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _searchHeaderChangeHandler: function _searchHeaderChangeHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      var searchQueryArray = [];
      for (var i = 0; i < this.options.columns.length; i++) {
        if (this.options.columns[i].searchable === true) {
          var queryArray = this._getSearchQuery(this.options.columns[i].type)(this.element.find('.tableHeaderSearch th').eq(i), this.options.columns[i]);
          if (Array.isArray(queryArray) && queryArray.length > 0) {
            if (searchQueryArray.length > 0) {
              searchQueryArray.push('and');
              searchQueryArray = searchQueryArray.concat(queryArray);
            } else {
              searchQueryArray = queryArray;
            }
          }
        }
      }
      if (this.query.isSameSearchQuery(searchQueryArray) === true) {
        // if we have the same search query, prevent searching
        return;
      }
      this.query.setSearchQuery(searchQueryArray);
      var that = this;
      this.refreshData(this.query).then(function () {
        if (that.stickyHeaderActive === true && typeof that.stickyHeaderTopOffset === "number" && that.stickyHeaderTopOffset >= 0) {
          that.stickyHeaderScrollingArea.scrollTop(that.stickyHeaderTopOffset);
        }
      });
    },
    _clearHeaderSearch: function _clearHeaderSearch() {
      for (var i = 0; i < this.options.columns.length; i++) {
        if (this.options.columns[i].searchable === true) {
          this._getClearSearch(this.options.columns[i].type)(this.element.find('.tableHeaderSearch th').eq(i), this.options.columns[i]);
        }
      }
    },
    /**
     * @description function runs when user click on a cell. This function fires a custom click event with the row and column objects
     * @function
     * @private
     * @name nixps-cloudflow.Table#_clickCellHandler
     * @param {object} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _clickCellHandler: function _clickCellHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      var tableInlineRow = $(pEvent.currentTarget).closest("tr").is(".tableInlineRow");
      var rowObject = this.getRowObject($(pEvent.target));
      var columnObject = this.getColumnObject($(pEvent.target));
      if (columnObject !== undefined) {
        if (columnObject.ignoreClickEvent === true) {
          return true;
        }
        this._trigger("click", pEvent, {
          tableInlineRow: tableInlineRow,
          rowObject: rowObject,
          columObject: columnObject,
          // backward compatibility
          columnObject: columnObject
        });
      } else {
        console.error("_clickCellHandler: missing data");
      }
    },
    /**
     * @description Function runs when users double clicks on a cell
     * @function
     * @private
     * @name nixps-cloudflow.Table#_dblclickCellHandler
     * @param {*} pEvent 
     * @param {*} pData 
     */
    _dblClickCellHandler: function _dblClickCellHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      this._trigger("dblclick", pEvent, {
        tableInlineRow: $(pEvent.currentTarget).closest("tr").is(".tableInlineRow"),
        rowObject: this.getRowObject($(pEvent.target)),
        columnObject: this.getColumnObject($(pEvent.target))
      });
    },
    /**
     * @description function runs when user clicked on the header checkbox
     * @function
     * @private
     * @name nixps-cloudflow.Table#_selectHeaderCheckBoxClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {Boolean}
     */
    _selectHeaderCheckBoxClickHandler: function _selectHeaderCheckBoxClickHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      if ($(pEvent.currentTarget).is(":checked")) {
        // select all visibles
        var that = this;
        this.element.children('table').children('tbody').children('tr').each(function () {
          var rowObject = $(this).data("dataitem");
          if (rowObject !== undefined) {
            $(this).children("td").children("input.table_select").each(function () {
              var rowid = $(this).prop("checked", true).removeClass("cf-table-toggleable").data("table_select_rowid");
              if (rowid !== undefined) {
                that.selectedDictIDs[rowid] = rowObject;
              }
            });
          }
        });
        this.element.children('table').children('tbody.nixps-Selecting').Selecting("selectAll");
        this._informAmountSelectedRows();
      } else {
        // deselect all visible
        this.unselectAllVisibleRows();
        this._stopFilteringAllSelectedRows();
      }
      TouchUtil.sendHapticFeedback();
      this._trigger("select", pEvent, {});
    },
    /**
     * @description Function runs when user want to select a row
     * @name nixps-cloudflow.Table#_selectingHandler
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {Boolean}
     */
    _selectingHandler: function _selectingHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      if (pData.unselectOthers === true) {
        // in special cases where there is no multiselect and the selectiong has disabled all
        // we should remove the selectedid from the rows who are hidden
        // clear model
        this.selectedDictIDs = {};
        // the selected ids will be added in the _afterselect function
      }

      this._afterSelecting();
      TouchUtil.sendHapticFeedback();
      this._trigger("select", pEvent, {});
    },
    /**
     * @description function runs when user longclick on a row
     * @function
     * @private
     * @name nixps-cloudflow.Table#_longpressHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     * @returns {undefined}
     */
    _longpressHandler: function _longpressHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      this._trigger("longpress", null, {
        tableInlineRow: $(pEvent.currentTarget).closest("tr").is(".tableInlineRow"),
        rowObject: this.getRowObject($(pEvent.target))
      });
      var selectingDOM = this.element.children("table").children("tbody.nixps-Selecting");
      if (selectingDOM.length === 1) {
        // when there is some selecting
        this.element.children("table").addClass("cf-table-enableselecting-mobile");
        TouchUtil.sendHapticFeedback();
      }
    },
    _swipeleftHandler: function _swipeleftHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      $(pEvent.target).closest("tr").addClass("cf-table-showactions-mobile");
    },
    _swiperightHandler: function _swiperightHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      $(pEvent.target).closest("tr").removeClass("cf-table-showactions-mobile");
    },
    /**
     * @description function runs when the user clicked on the cog wheel, the user want to show or hide columns
     * @function
     * @name nixps-cloudflow.Table#_configClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {Boolean}
     */
    _configClickHandler: function _configClickHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      // get first header, second is loosy sticky copy
      this.element.children(".tableHeaderConfig").find(".nixps-cloudflow-CollapsibleColumns").first().CollapsibleColumns("toggleChooser", pEvent);
    },
    /**
     * @description function runs when user click on the button to toggle between showing only selection
     * @function
     * @private
     * @name nixps-cloudflow.Table#_showOnlySelectionClickHandler
     * @param {Object} pEvent 
     */
    _showOnlySelectionClickHandler: function _showOnlySelectionClickHandler(pEvent) {
      if (this.showOnlySelection === false) {
        this.showOnlySelection = true;
        this.mSectionDropdown.filter(".nixps-DropdownList").DropdownList("checkItem", "dropdownlistSelectionOnly");
        this._filterAllSelectedRows();
      } else if (this.showOnlySelection === true) {
        // function needs this.showOnlySelection to be true
        this._stopFilteringAllSelectedRows();
      }
    },
    /**
     * @description function runs when user want to disable all selection
     * @function
     * @private
     * @name nixps-cloudflow.Table#_unselectAllRowsClickHandler
     * @returns {undefined}
     */
    _unselectAllRowsClickHandler: function _unselectAllRowsClickHandler(pEvent) {
      this.unselectAllRows();
      this._stopFilteringAllSelectedRows();
    },
    /**
     * @description function runs when user clicked on the caret icon to open the selection menu
     * @function
     * @private
     * @name nixps-cloudflow.Table#_selectionCaretClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     * @returns {undefined}
     */
    _selectionCaretClickHandler: function _selectionCaretClickHandler(pEvent, pData) {
      if (!this._isEventFormComponent(pEvent)) {
        return true;
      }
      var caretButton = $(pEvent.currentTarget);
      this.mSectionDropdown.DropdownList("openListWithoutButton", pEvent).position({
        "my": "center top",
        "at": "left bottom",
        "collision": "fit",
        "of": caretButton,
        "within": $(pEvent.target).closest("." + this.widgetFullName)
      });
      ;
      this.addProtectionLayer();
    },
    /**
     * @description function runs when user click on the blocking panel, 
     * so removed it then
     * @function
     * @private
     * @name nixps-cloudflow.Table#_protectionLayerClickHandler
     * @returns {undefined}
     */
    _protectionLayerClickHandler: function _protectionLayerClickHandler(pEvent) {
      // remove panel
      this.removeProtectionLayer();
    },
    /**
     * @description function runs when the header become sticky
     * @function
     * @name nixps-cloudflow.Table#_startStickyHeaderHandler
     * @private
     * @param {Object} pEvent 
     */
    _startStickyHeaderHandler: function _startStickyHeaderHandler(pEvent) {
      if ($(pEvent.target).is(this.element) || $(pEvent.target).is(this.options.stickyTableHeadersParent)) {
        this.stickyHeaderActive = true;
        this.stickyHeaderTopOffset = this.stickyHeaderScrollingArea.scrollTop();
        this.element.children(".tableHeaderConfig").addClass("tableHeaderConfig_sticky");
        if (this.options.stickyHeaderMarginTop > 0) {
          this.element.children(".tableHeaderConfig").css("top", this.options.stickyHeaderMarginTop);
        }
      }
    },
    /**
     * @description function runs when the sticky header stops
     * @function
     * @name nixps-cloudflow.Table#_endStickyHeaderHandler
     * @param {Object} pEvent 
     */
    _endStickyHeaderHandler: function _endStickyHeaderHandler(pEvent) {
      if ($(pEvent.target).is(this.element) || $(pEvent.target).is(this.options.stickyTableHeadersParent)) {
        this.stickyHeaderActive = false;
        this.element.children(".tableHeaderConfig").removeClass("tableHeaderConfig_sticky").css("top", "");
      }
    },
    /**
     * @function
     * @name nixps-cloudflow.Table#_getRenderingType
     * @private
     * @description returns the correct rendering function that needs for that type,
     * if no rendering can found, we will return a default function, that returns the inputvalue
     * @default function(vd){return vd;}
     * @param {string} pType - the input type of the column
     * @returns {function}
     */
    _getRenderingType: function _getRenderingType(pType) {
      var renderFunction = this.renderDict[pType];
      if (typeof renderFunction === "function") {
        return renderFunction;
      } else {
        return function (vd) {
          return vd;
        };
      }
    },
    /**
     * @name nixps-cloudflow.Table#_getSearchType
     * @function
     * @private
     * @description returns the correct search function that needs for that type,
     * if no rendering can found, we will return a default function, that returns the inputvalue
     * @default function(vd){return vd;}
     * @param {string} pType - the input type of the column
     * @returns {function}
     */
    _getSearchType: function _getSearchType(pType) {
      if (typeof this.searchDict[pType] === "function") {
        return this.searchDict[pType];
      } else {
        return function () {};
      }
    },
    /**
     * @name nixps-cloudflow.Table#_getSearchQuery
     * @function
     * @private
     * @description returns the correct search function that needs for that type,
     * if no rendering can found, we will return a default function, that returns the inputvalue
     * @default function(vd){return vd;}
     * @param {String} pType - the input type of the column
     * @returns {Function}
     */
    _getSearchQuery: function _getSearchQuery(pType) {
      if (typeof this.searchQueryDict[pType] === "function") {
        return this.searchQueryDict[pType];
      } else {
        return function () {};
      }
    },
    /**
     * @description get the clear search function
     * @name nixps-cloudflow.Table#_getClearSearch
     * @function
     * @private
     * @param {String} pType the column type
     * @returns {Function}
     */
    _getClearSearch: function _getClearSearch(pType) {
      if (typeof this.clearSearchDict[pType] === "function") {
        return this.clearSearchDict[pType];
      } else {
        return function () {};
      }
    },
    /**
     * @function
     * @name nixps-cloudflow.Table#addAdditionType
     * @description Add a addidtional renderings type. <br /> 
     * If a renderings type already exist, it will be overwritten
     * and no warning will be given.
     * @throws {error} addAdditionType: inputparameter pKeyType must be a well formed string
     * @throws {error} addAdditionType: inputparameter pFunction must be a function.
     * @param {string} pKeyType - The name of the type, you want to add
     * @param {object} pAddTypeObject - the object containing the needed functions.
     * This will provide the tools for the user to change the data. We expects a html component as return. 
     * @returns {undefined}
     */
    addAdditionType: function addAdditionType(pKeyType, pAddTypeObject) {
      var renderFunction = pAddTypeObject.renderFunction;
      var editFunction = pAddTypeObject.editFunction;
      var searchRenderFunction = pAddTypeObject.searchRenderFunction;
      var getSearchQueryFunction = pAddTypeObject.getSearchQueryFunction;
      var clearSearchFunction = pAddTypeObject.clearSearchFunction;
      if (typeof pKeyType !== "string" || pKeyType.length <= 0) {
        throw new Error('addAdditionType: inputparameter pKeyType must be a well formed string.');
      }
      // render function
      if (typeof renderFunction === "function") {
        this.renderDict[pKeyType] = renderFunction;
      } else if (typeof renderFunction === "string" && typeof this.renderDict[renderFunction] === "function") {
        this.renderDict[pKeyType] = this.renderDict[renderFunction];
      } else {
        throw new Error('addAdditionType: renderFunction must be a function.');
      }
      if (typeof editFunction === "function") {
        this.editDict[pKeyType] = editFunction;
      } else if (typeof editFunction === "string" && typeof this.editDict[editFunction] === "function") {
        this.editDict[pKeyType] = this.editDict[editFunction]; // add alias
      } else if (typeof this.options.editCellEvent === "string" && this.options.editCellEvent.length > 0) {
        // editfunction is undefined en editCellEvent is on
        this.editDict[pKeyType] = function () {};
        console.warn('Table addAdditionType: no editfunction found for ' + pKeyType + ". We add empty edit function for it.");
      }
      if (typeof searchRenderFunction === "function") {
        this.searchDict[pKeyType] = searchRenderFunction;
      } else if (typeof searchRenderFunction === "string" && typeof this.searchDict[searchRenderFunction] === "function") {
        this.searchDict[pKeyType] = this.searchDict[searchRenderFunction]; // add alias
      }

      if (typeof getSearchQueryFunction === "function") {
        this.searchQueryDict[pKeyType] = getSearchQueryFunction;
      } else if (typeof getSearchQueryFunction === "string" && typeof this.searchQueryDict[getSearchQueryFunction] === "function") {
        this.searchQueryDict[pKeyType] = this.searchQueryDict[getSearchQueryFunction]; // add alias
      } else if (typeof searchRenderFunction === "string" && typeof this.searchQueryDict[searchRenderFunction] === "function") {
        // use the texual string for the search render, use the backend that corresponds to the visual
        this.searchQueryDict[pKeyType] = this.searchQueryDict[searchRenderFunction]; // add alias
      }

      if (typeof clearSearchFunction === "function") {
        this.clearSearchDict[pKeyType] = clearSearchFunction;
      } else if (typeof clearSearchFunction === "string" && typeof this.clearSearchDict[clearSearchFunction] === "function") {
        this.clearSearchDict[pKeyType] = this.clearSearchDict[clearSearchFunction];
      }
    },
    /**
     * @function
     * @name nixps-cloudflow.Table#getRowObject
     * @description return the object that corresponds to the row. This is the object returned by the dataProvider callback function.
     * @param {DOMElement} pDOMElement a DOMelement that must be insite a row
     * @throws {error} 'getRowObject: inputparameter must have "tr" as parent.'
     * @returns {object} object(model) corresponding to the row
     */
    getRowObject: function getRowObject(pDOMElement) {
      var trElement = $(pDOMElement).closest('tr');
      if (trElement === undefined || trElement.length <= 0) {
        throw new Error('getRowObject: inputparameter must have <tr> as parent.');
      }
      return trElement.data("dataitem");
    },
    /**
     * @description return the information about the column. returns the column object from inputoptions 
     * corresponding with the column of the pDOMElement
     * @function
     * @name nixps-cloudflow.Table#getColumnObject
     * @throws {error} 'getColumnObject: inputparameter must have "td" or "th" as parent.'
     * @param {DOMElement} pDomElement where you want to know his column object.
     * @returns {object} The object of the column, given from the (input)options 
     */
    getColumnObject: function getColumnObject(pDomElement) {
      var tdElement = null;
      if ($(pDomElement).is('td') || $(pDomElement).is('th')) {
        tdElement = $(pDomElement);
      } else if ($(pDomElement).parents('td').length > 0) {
        tdElement = $(pDomElement).parents('td');
      } else if ($(pDomElement).parents('th').length > 0) {
        tdElement = $(pDomElement).parents('th');
      } else {
        throw new Error('getColumnObject: inputparameter must have <td> or <th> as parent.');
      }
      var columnIndex = tdElement.prevAll().length;
      return this.element.children('table').children('thead:not(.tableFloatingHeader)').children('tr.tableHeaderTitels').children('th').eq(columnIndex).data('model');
    },
    /**
     * @description Get the current state of the table, that can be used later to retore it. This is experimental code !!!
     * @function
     * @private
     * @name nixps-cloudflow.Table#getState
     * @returns {object} an object containing all the information about the current state of the table 
     */
    getState: function getState() {
      var searchArray = [];
      for (var i = 0; i < this.options.columns.length; i++) {
        if (this.options.columns[i].searchable === true) {
          var queryArray = this._getSearchQuery(this.options.columns[i].type)(this.element.find(".tableHeaderSearch th").eq(i), this.options.columns[i]);
          if (Array.isArray(queryArray) && queryArray.length > 0) {
            searchArray.push({
              column: Object.assign({}, this.options.columns[i]),
              search_startquery: queryArray.slice()
            });
          }
        }
      }
      // make some copies, to prevent that changes outside the component has impact insite it
      return {
        // the filtered, search query
        query: this.query.getQuery().slice(),
        // the columns search query
        columnSearchQuery: searchArray,
        // the sorting or orderby
        orderBy: transformBackendSortToSort(this.orderBy).slice(),
        // the sorting of orderby in a array interface like api calls are working
        orderBy_apicall: this.orderBy.slice(),
        // in which page are we?
        skip: this.skip,
        // flag indication we showed only selected rows, special case
        showOnlySelectedRows: this.showOnlySelection
      };
    },
    _afterSelecting: function _afterSelecting() {
      var that = this;
      // add new selected
      this.element.children('table').children('tbody').Selecting('getSelectedItems').each(function () {
        var rowObject = $(this).data("dataitem");
        if (rowObject !== undefined) {
          $(this).children("td").children("input.table_select").prop("checked", true).removeClass("cf-table-toggleable"); // user can press shift of cntrl to select multiple rows 
          var key = "_id";
          if (typeof that.options.keyUniqID === "string") {
            key = that.options.keyUniqID;
          }
          var rowID = CloudflowObject.getParameter(rowObject, key);
          if (rowID !== undefined) {
            that.selectedDictIDs[rowID] = rowObject;
          }
        }
      });
      this.element.children('table').children('tbody').Selecting("getUnselectedItems").each(function () {
        var rowObject = $(this).data("dataitem");
        if (rowObject !== undefined) {
          $(this).children("td").children("input.table_select").prop("checked", false).addClass("cf-table-toggleable");
          var key = "_id";
          if (typeof that.options.keyUniqID === "string") {
            key = that.options.keyUniqID;
          }
          var rowID = CloudflowObject.getParameter(rowObject, key);
          if (rowID !== undefined) {
            delete that.selectedDictIDs[rowID];
          }
        }
      });
      if (this.element.children('table').children('tbody').Selecting('areAllSelected')) {
        this.element.children('table').children('thead').children("tr.tableHeaderTitels").find(".tableColumnHeaderSelectBox").prop("disabled", false).prop("checked", true);
      } else {
        this.element.children('table').children('thead').children("tr.tableHeaderTitels").find(".tableColumnHeaderSelectBox").prop("disabled", false).prop("checked", false);
      }
      if (this.showOnlySelection === true) {
        // adapt model
        var selectedRowIds = Object.keys(this.selectedDictIDs);
        var key = "_id";
        if (typeof this.options.keyUniqID === "string") {
          key = this.options.keyUniqID;
        }
        this.query.setSelectionQuery([key, "in", selectedRowIds]);
        this._filterAllSelectedRows();
      }
      this._informAmountSelectedRows();
    },
    /**
     * @description Get all the ids of all the selected rows. Those ids has no specific order and the order can change!
     * @function
     * @since 1.5.0
     * @name nixps-cloudflow.Table#getSelectedRowIDs
     * @return {Array.<ids>} An array containing all the ids of all selected rows
     */
    getSelectedRowIDs: function getSelectedRowIDs() {
      var keyParameter = "_id";
      if (typeof this.options.keyUniqID === "string") {
        keyParameter = this.options.keyUniqID;
      }
      return $.map(this.selectedDictIDs, function (value, key) {
        return CloudflowObject.getParameter(value, keyParameter);
      });
    },
    /**
     * @description Get all the row objects of all the selected rows. Those has no specific order and the order can change!
     * @function
     * @since 1.6.0
     * @name nixps-cloudflow.Table#getSelectedRows
     * @return {Array.<Object>} An array containing all the row objects of all selected rows
     */
    getSelectedRows: function getSelectedRows() {
      var that = this;
      if (this.options.enableIDAttribute === true) {
        return $.map(this.selectedDictIDs, function (value, key) {
          var rowObject = that.element.children("table").children("tbody").children('tr#tableRowID_' + key).data("dataitem");
          if (rowObject === undefined) {
            return value;
          }
          return rowObject;
        });
      } else {
        return $.map(this.selectedDictIDs, function (value, key) {
          var rowObject = that.element.children("table").children("tbody").children('tr[data-tableRowID="' + key + '"]').data("dataitem");
          if (rowObject === undefined) {
            return value;
          }
          return rowObject;
        });
      }
    },
    /**
     * @description Unselect all rows
     * @function
     * @since 1.5.0
     * @name nixps-cloudflow.Table#unselectAllRows
     * @return {undefined}
     */
    unselectAllRows: function unselectAllRows() {
      // clear the internal model
      this.selectedDictIDs = {};
      // disable all visual checkboxes, the hiden ones does not exist. 
      // if user update or change the new updated status will be shown
      this.element.children('table').children('tbody').children('tr').children("td").children(".table_select").prop("checked", false).addClass("cf-table-toggleable");
      // unselect help component
      this.element.children('table').children('tbody.nixps-Selecting').Selecting("unselectAll");
      // unselect header checkbox
      this.element.children('table').children('thead').children("tr.tableHeaderTitels").find(".tableColumnHeaderSelectBox").prop("checked", false);
      this._informAmountSelectedRows();
    },
    /**
     * @description Unselect all rows
     * @function
     * @since 1.10.0
     * @name nixps-cloudflow.Table#unselectAllVisibleRows
     * @return {undefined}
     */
    unselectAllVisibleRows: function unselectAllVisibleRows() {
      // disable all visual checkboxes, the hiden ones will be ignored
      // if user update or change the new updated status will be shown
      var that = this;
      this.element.children('table').children('tbody').children('tr').children("td").children(".table_select").prop("checked", false).addClass("cf-table-toggleable").each(function () {
        // clear the internal model
        var rowid = $(this).data("table_select_rowid");
        delete that.selectedDictIDs[rowid];
      });
      // unselect help component
      this.element.children('table').children('tbody.nixps-Selecting').Selecting("unselectAll");
      this._informAmountSelectedRows();
    },
    /**
     * @description Unselect one row
     * @function
     * @since 1.5.5
     * @name nixps-cloudflow.Table#unselectRow
     * @param {String} pRowID The id of the row
     */
    unselectRow: function unselectRow(pRowID) {
      var that = this;
      delete this.selectedDictIDs[pRowID];
      // loop over all items and check if they come in the list
      this.element.children('table').children('tbody').children('tr').children("td").children("input.table_select").each(function () {
        var rowid = $(this).data("table_select_rowid");
        if (rowid === pRowID) {
          $(this).prop("checked", false).addClass("cf-table-toggleable"); // update ui
          if ($.isPlainObject(that.options.selecting)) {
            // the selecting component is active
            var selectingClass = that.element.children('table').children('tbody.nixps-Selecting').Selecting("option", "selectClass");
            if (typeof selectingClass === "string" && selectingClass.length > 0) {
              $(this).closest("tr").removeClass(selectingClass);
            }
          }
          return false;
        }
      });
      this._informAmountSelectedRows();
    },
    /**
     * @description Select specific rows by there ids. The other selected rows stays intact.
     * @function
     * @name nixps-cloudflow.Table#selectRows
     * @param {String} pRowsIDs Specify the id we must select. This may be a string or an array of strings.
     * @param {Boolean} pTriggerEvent must we trigger the select event or not, default not
     * @since 1.5.1
     * @return {undefined}
     */
    selectRows: function selectRows(pRows, pTriggerEvent) {
      var rowIDs = [];
      var pRowIDs = $.makeArray(pRows);
      for (var i = 0; i < pRowIDs.length; i++) {
        if ($.isPlainObject(pRowIDs[i])) {
          if (typeof this.options.keyUniqID === "string") {
            rowIDs.push(CloudflowObject.getParameter(pRowIDs[i], this.options.keyUniqID));
          } else {
            throw new Error("missing keyUniqID to compare object to select");
          }
        } else if (typeof pRowIDs[i] === "string" && pRowIDs[i].length > 0 || typeof pRowIDs[i] === "number") {
          rowIDs.push(pRowIDs[i]);
        } else {
          throw new Error("invalid interface for parameter pRowIDs");
        }
      }
      // update model
      var rowjQuerySelector = "";
      if (this.options.enableIDAttribute === true) {
        for (var i = 0; i < rowIDs.length; i++) {
          this.selectedDictIDs[rowIDs[i]] = this.element.children("table").children("tbody").children("tr#tableRowID_" + cssSelectorEscape(rowIDs[i])).data("dataitem");
          if (this.selectedDictIDs[rowIDs[i]] === undefined) {
            this.selectedDictIDs[rowIDs[i]] = {};
          }
          rowjQuerySelector += "tr#tableRowID_" + cssSelectorEscape(rowIDs[i]) + ",";
        }
      } else {
        for (var i = 0; i < rowIDs.length; i++) {
          this.selectedDictIDs[rowIDs[i]] = this.element.children('table').children('tbody').children('tr[data-tableRowID="' + rowIDs[i] + '"]').data("dataitem");
          if (this.selectedDictIDs[rowIDs[i]] === undefined) {
            this.selectedDictIDs[rowIDs[i]] = {};
          }
          rowjQuerySelector += 'tr[data-tableRowID="' + rowIDs[i] + '"],';
        }
      }
      // remove last character ","
      rowjQuerySelector = rowjQuerySelector.slice(0, -1);

      // loop over all items and check if they come in the list
      this.element.children("table").children("tbody").children("tr").children("td").children("input.table_select").each(function () {
        var rowid = $(this).data("table_select_rowid");
        if ((typeof rowid === "string" && rowid.length > 0 || typeof rowid === "number") && rowIDs.indexOf(rowid) >= 0) {
          $(this).prop("checked", true).removeClass("cf-table-toggleable"); // update ui
        }
      });

      this.element.children("table").children("tbody.nixps-Selecting").Selecting("selectItems", rowjQuerySelector);
      this._informAmountSelectedRows();
      if (pTriggerEvent === true) {
        TouchUtil.sendHapticFeedback();
        this._trigger("select", null, {});
      }
    },
    stopSelectionMode: function stopSelectionMode() {
      this.element.children("table").removeClass("cf-table-enableselecting-mobile");
    },
    /**
     * @description function runs when the user clicked on the layer to only show selected rows
     * @function
     * @private
     * @name nixps-cloudflow.Table#_filterAllSelectedRows
     */
    _filterAllSelectedRows: function _filterAllSelectedRows() {
      var selectedRowIds = Object.keys(this.selectedDictIDs);
      var key = "_id";
      if (typeof this.options.keyUniqID === "string") {
        key = this.options.keyUniqID;
      }
      this.query.setSelectionQuery([key, "in", selectedRowIds]);
      var knownData = this.getSelectedRows();
      if (knownData.length == selectedRowIds.length) {
        this.dataProviderCallID++;
        this._makeTableWithInputData(knownData, knownData.length, false, false, this.dataProviderCallID);
      } else {
        this._drawBody(this.query, this.orderBy, this.skip, this.limit);
      }
    },
    /**
     * @description function runs when user clicked on the deselelect all
     * @function
     * @private
     * @name nixps-cloudflow.Table#_stopFilteringAllSelectedRows
     */
    _stopFilteringAllSelectedRows: function _stopFilteringAllSelectedRows() {
      if (this.showOnlySelection === true) {
        this.showOnlySelection = false;
        this.mSectionDropdown.filter(".nixps-DropdownList").DropdownList("uncheckItem", "dropdownlistSelectionOnly");
        this.query.setSelectionQuery([]);
        this._drawBody(this.query, this.orderBy, this.skip, this.limit);
      }
    },
    /**
     * @description show the number of selected rows somewhere in the table
     * @name nixps-cloudflow.Table#_informAmountSelectedRows
     * @function
     * @private
     * @since 1.10.0
     * @returns {undefined}
     */
    _informAmountSelectedRows: function _informAmountSelectedRows() {
      var amount = Object.keys(this.selectedDictIDs).length;
      this.element.children("table").children("thead").children("tr").find(".tableAmountSelectedRows").text(amount);
      if (amount === 0) {
        this.mSectionDropdown.filter(".nixps-DropdownList").DropdownList("disableItem", "dropdownlistSelectionOnly");
        this.mSectionDropdown.filter(".nixps-DropdownList").DropdownList("disableItem", "dropdownlistRemoveSelection");
        this._stopFilteringAllSelectedRows();
        this.element.children(".tableBottomBar").find(".selectionDetails").text("");
      } else {
        this.mSectionDropdown.filter(".nixps-DropdownList").DropdownList("enableItem", "dropdownlistSelectionOnly");
        this.mSectionDropdown.filter(".nixps-DropdownList").DropdownList("enableItem", "dropdownlistRemoveSelection");
        if (amount > 1) {
          this.element.children(".tableBottomBar").find(".selectionDetails").text("(" + $.i18n._("nixps-cloudflow-table.selectiondetails_multiple", [amount]) + ")");
        } else {
          this.element.children(".tableBottomBar").find(".selectionDetails").text("(" + $.i18n._("nixps-cloudflow-table.selectiondetails_one", [amount]) + ")");
        }
      }
    },
    /**
     * @description Move the selected row up or down
     * @name nixps-cloudflow.Table#moveSelected
     * @function
     * @since 1.10.0
     * @param {Object} pEvent 
     * @param {Object} pDirection 
     */
    moveSelected: function moveSelected(pEvent, pDirection) {
      // check first if there are elements
      if (this.element.children('table').children('tbody').children("tr").length === 0) {
        return;
      }
      this.element.children('table').children('tbody.nixps-Selecting').Selecting("moveSelected", pEvent, pDirection);
      this._afterSelecting();
    },
    _stopWheelEventInConfigMode: function _stopWheelEventInConfigMode(e) {
      // tables can be large and long, prevent that the button and panel becomes outsink with table 
      if ($(e.target).closest(".nixps-cloudflow-CollapsibleColumns").length > 0) {
        // allow when you are inside it
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
    },
    /**
     * @description Add a protection layer so you can use an contextmenu, without activating other actions by accident
     * @function
     * @name nixps-cloudflow.Table#addProtectionLayer
     * @since 1.11.0
     * @returns {undefined}
     */
    addProtectionLayer: function addProtectionLayer(pClasses, pOnClickCB) {
      pClasses = pClasses || "";
      var protectionLayerDOM = $('<div>').addClass("tableProtectionLayer cf-overlay-transparent " + pClasses);
      if (typeof pOnClickCB === "function") {
        protectionLayerDOM.on("click", pOnClickCB);
      }
      this.element.append(protectionLayerDOM);
      this.element.on("wheel", this._stopWheelEventInConfigMode);
    },
    /**
     * @description Remove the protection layer added by {@link nixps-cloudflow.Table#addProtectionLayer}
     * @function
     * @name nixps-cloudflow.Table#removeProtectionLayer
     * @since 1.11.0
     * @returns {undefined}
     */
    removeProtectionLayer: function removeProtectionLayer() {
      this.element.children(".tableProtectionLayer").remove();
      this.element.off("wheel", this._stopWheelEventInConfigMode);
    },
    disableSorting: function disableSorting() {
      this.element.children('table').children('thead').children("tr.tableHeaderTitels").children('th.sortable').removeClass('sortable').addClass("sortable_disabled");
    },
    enableSorting: function enableSorting() {
      this.element.children('table').children('thead').children("tr.tableHeaderTitels").children('th.sortable_disabled').removeClass("sortable_disabled").addClass('sortable');
    },
    /**
     * @description Show or hide the table column titles of the columns that must be hidden or show
     * @function
     * @name nixps-cloudflow.Table#_toggleColumnsHeader
     * @private
     * @returns {undefined}
     */
    _toggleColumnsHeader: function _toggleColumnsHeader() {
      if (this.collapsibleColumns === null) {
        return true; // do nothing
      }

      var that = this;
      var length = this.collapsibleColumns.length;
      this.element.children("table").children("colgroup").children("col").each(function (index, elem) {
        if (that.collapsibleColumns[index % length]) {
          $(this).css("display", "");
        } else {
          $(this).hide();
        }
      });
      this.element.children("table").children("thead").children("").children("th").each(function (index, elem) {
        if (that.collapsibleColumns[index % length]) {
          $(this).css("display", "");
        } else {
          $(this).hide();
        }
      });
      if (this.options.enableStickyHeader === true) {
        var stickyHeaderDOM;
        if (this.options.stickyTableHeadersParent && this.options.stickyTableHeadersParent instanceof jQuery) {
          stickyHeaderDOM = this.options.stickyTableHeadersParent;
        } else {
          stickyHeaderDOM = this.element.children("table");
        }
        // inform the sticky that the columns headers changed
        var data = stickyHeaderDOM.data();
        // check if plugin is applied
        if (data && data.plugin_stickyTableHeaders) {
          stickyHeaderDOM.stickyTableHeaders("updateWidth");
        }
      }
    },
    /**
     * @description Show or hide all the rows, depending on the user preferences
     * @function
     * @name nixps-cloudflow.Table#_toggleColumnsBody
     * @private
     * @returns {undefined}
     */
    _toggleColumnsBody: function _toggleColumnsBody() {
      if (this.collapsibleColumns === null) {
        return true; // do nothing
      }

      var that = this;
      var length = this.collapsibleColumns.length;
      this.element.children('table').children("tbody").children(":not(.tableInlineRow, .tableDummyInlineRow)").children().each(function (index, elem) {
        if (that.collapsibleColumns[index % length]) {
          $(this).css("display", "");
        } else {
          $(this).hide();
        }
      });
      // collapseable
      var amountVisible = 0;
      for (var i = 0; i < length; i++) {
        if (this.collapsibleColumns[i]) {
          amountVisible++;
        }
      }
      this.element.children('table').children("tbody").children(".tableInlineRow").children("[colspan]").attr("colspan", amountVisible);
    },
    /**
     * @name nixps-cloudflow.Table#_getTotalRowsThatMatch
     * @description get the total number of rows that match with the query
     * @function
     * @private
     * @return {Deferred} the number of rows if call succesd, otherwise -1 if call failed
     */
    _getTotalRowsThatMatch: function _getTotalRowsThatMatch() {
      var that = this;
      return $.Deferred(function (pDefer) {
        $.when(that.options.countProvider(that.query.getQuery().slice(), [])).then(function (pResult) {
          // if result is an array
          if (Array.isArray(pResult)) {
            pDefer.resolve(pResult.length);
            // if result is a positive number
          } else if (typeof pResult === "number" && pResult >= 0) {
            pDefer.resolve(pResult);
            // if results comes from an api call count
          } else if (pResult !== undefined && typeof pResult.count === "number" && pResult.count >= 0) {
            pDefer.resolve(pResult.count);
            // if the result comes from a api call list
          } else if (pResult !== undefined && Array.isArray(pResult.results || pResult.documents)) {
            var rows = pResult.results || pResult.documents;
            pDefer.resolve(rows.length);
            // else unknow, reject ...
          } else {
            pDefer.reject("no valid result returned");
          }
        }, function (pError) {
          console.error(pError);
          pDefer.reject(pError);
        });
      });
    },
    /**
     * @name nixps-cloudflow.Table#_updateRowDetails
     * @description Update the details panel about the number of rows
     * @function
     * @private
     * @param {Number} pID the uniq number of the dataprovider, to ignore the lost calls
     * @param {Number} pNumberShowedRows the number of rows who are displayed
     * @return {undefined}
     */
    _updateRowDetails: function _updateRowDetails(pID, pNumberShowedRows, pTotalRows) {
      if (typeof pNumberShowedRows !== "number" || pNumberShowedRows < 0) {
        throw new Error("parameter pNumberShowedRows must be a positive number");
      }
      var that = this;
      var from = pNumberShowedRows > 0 ? that.skip + 1 : that.skip;
      var to = that.skip + pNumberShowedRows;
      if (typeof pTotalRows === "number" && pTotalRows >= 0) {
        that.element.children('.tableBottomBar').find('.rowsDetails')._t("nixps-cloudflow-table.rowdetails", [from, to, pTotalRows]).removeClass("table_rowDetailsPending").data("nr_of_space_for_count", parseInt(Math.log10(pTotalRows)) + 1);
      } else {
        // adapt css to show, we are bussy doing the search, ...
        var rowDetailsDOM = this.element.children('.tableBottomBar').find('.rowsDetails');
        var previousAmountChars = rowDetailsDOM.data("nr_of_space_for_count");
        var waitingText = "x";
        if (typeof previousAmountChars === "number" && previousAmountChars > 1 && typeof waitingText.padStart === "function") {
          waitingText = waitingText.padStart(previousAmountChars);
        }
        rowDetailsDOM._t("nixps-cloudflow-table.rowdetails", [from, to, waitingText]).addClass("table_rowDetailsPending");
        this._getTotalRowsThatMatch().done(function (pNumber) {
          // first control if call is not lost ...
          if (pID !== that.dataProviderCallID) {
            // call came to late, ignore than
            return true;
          }
          if (pNumber < to) {
            // the amount has been decreased after load and is less then content
            console.warn("Table: the count of rows (" + pNumber + ") is lower than content (" + to + ")");
            that.isEnd = true;
            var newSkip = Math.ceil(pNumber / that.limit) * that.limit;
            if (newSkip < that.skip) {
              that.skip = newSkip;
            }
            that.element.children('.tableBottomBar').find('.rightPagingButton').prop('disabled', true);
            that.element.children('.tableBottomBar').find('.rowsDetails')._t("nixps-cloudflow-table.rowdetails", [from, to, "-"]).removeClass("table_rowDetailsPending").data("nr_of_space_for_count", 1);
          } else {
            that.element.children('.tableBottomBar').find('.rowsDetails')._t("nixps-cloudflow-table.rowdetails", [from, to, pNumber]).removeClass("table_rowDetailsPending").data("nr_of_space_for_count", parseInt(Math.log10(pNumber)) + 1);
          }
        }).fail(function () {
          // first control if call is not lost ...
          if (pID !== that.dataProviderCallID) {
            // call came to late, ignore than
            return true;
          }
          // there is an error, indicate the total number as question mark
          that.element.children('.tableBottomBar').find('.rowsDetails')._t("nixps-cloudflow-table.rowdetails", [from, to, "?"]).removeClass("table_rowDetailsPending").data("nr_of_space_for_count", 1);
        });
      }
    },
    /**
     * @description this function runs when a user want to edit a cell. when a user double clicks(default action) on a cell.
     * @function
     * @name nixps-cloudflow.Table#_editCellHandler
     * @private 
     * @param {event} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _editCellHandler: function _editCellHandler(pEvent, pData) {
      var cell = $(pEvent.currentTarget);
      if (cell.hasClass("editMode") || cell.closest("td.editMode, tr.tableHeaderSearch").length > 0) {
        // user is already modifying the cell/value, or if user is manipulation something in the search/filter fields
        return;
      }
      var columnModel = this.getColumnObject(cell);
      if (columnModel.editable === false) {
        // if we are not allowed to edit do not continue
        return;
      }
      var rowObject = this.getRowObject(cell);
      if (typeof this.options.allowEditRow === "function" && this.options.allowEditRow(rowObject) === false) {
        // if we are not allowed to edit to row do not continue
        return;
      }
      var editFunction = this.editDict[columnModel.type];
      if (typeof editFunction === "function") {
        cell.addClass("editMode cf-table-cell-overflowvisible");
        this._trigger("startcellediting", null, {});
        editFunction(cell, columnModel, rowObject, this._updateEditCell.bind(this), this._cancelEditCell.bind(this));
      } else {
        throw new Error("_editCellHandler: unkown edit function for type: " + columnModel.type);
      }
    },
    _editPasswordCellHandler: function _editPasswordCellHandler(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
      pCell.wrapInner($("<span>").addClass("innerTextSpan").css("visibility", "hidden"));
      var cellWidth = pCell.find("span.innerTextSpan").width();
      var value = getDataOfObjectTree(pRowObject, pColumnModel.key, this.options.enableJSONPathInKeys);
      var input = $('<input>').attr('type', 'password').val(value).css('min-width', cellWidth + 20);
      var panel = $('<div>').addClass('cf-table-changePanel');
      panel.append(input);
      panel.css({
        'position': 'absolute',
        'top': 0,
        'left': 0,
        'right': 0,
        'bottom': 0
      });
      pCell.css({
        'position': 'relative'
      }).append(panel);
      input.trigger("focus").one('blur', function (pEvent) {
        pUpdateEditCellCB(pCell, pColumnModel, pRowObject, $(pEvent.currentTarget).val());
        pEvent.bubbles = true;
        return true;
      });
    },
    _editStringCellHandler: function _editStringCellHandler(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
      pCell.wrapInner($('<span>').addClass('innerTextSpan').css('visibility', 'hidden'));
      var cellWidth = pCell.find('span.innerTextSpan').width();
      var value = getDataOfObjectTree(pRowObject, pColumnModel.key, this.options.enableJSONPathInKeys);
      if (value === null || value === undefined) {
        value = "";
      } else if ($.isPlainObject(value)) {
        value = JSON.stringify(value);
      }
      var input = $('<input>').attr('type', 'text').val(value).css('min-width', cellWidth + 20);
      var panel = $('<form>').addClass('cf-table-changePanel');
      panel.append(input);
      panel.css({
        'position': 'absolute',
        'top': 0,
        'left': 0,
        'right': 0,
        'bottom': 0
      });
      pCell.css({
        'position': 'relative'
      }).append(panel);
      this._floatFromRightBorder(panel, pCell, input, 100);
      var that = this;
      input.trigger("focus");
      panel.one("focusout submit", function (pEvent) {
        panel.off('focusout submit');
        var oldValue = value;
        var newValue = input.val();
        if (oldValue !== newValue) {
          input.prop("disabled", true);
          // only update if changes has been detected
          pUpdateEditCellCB(pCell, pColumnModel, pRowObject, newValue);
        } else {
          pCancelEditCellCB(pCell);
        }
        if (pEvent.type === "submit") {
          return false;
        }
        return true;
      });
    },
    _editNumberCellHandler: function _editNumberCellHandler(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
      pCell.wrapInner($('<span>').addClass('innerTextSpan').css('visibility', 'hidden'));
      var cellWidth = pCell.find('span.innerTextSpan').width();
      var value = getDataOfObjectTree(pRowObject, pColumnModel.key, this.options.enableJSONPathInKeys);
      var startValue = parseFloat(value);
      if (isFinite(startValue) === false) {
        startValue = 0;
      }
      var input = $('<input>').attr('type', 'number').attr("step", "any").val(startValue).css('min-width', cellWidth + 20);
      var panel = $('<form>').addClass('cf-table-changePanel');
      panel.append(input);
      panel.css({
        'position': 'absolute',
        'top': 0,
        'left': 0,
        'right': 0,
        'bottom': 0
      });
      pCell.css({
        'position': 'relative'
      }).append(panel);
      this._floatFromRightBorder(panel, pCell, input, 100);
      var that = this;
      input.trigger("focus");
      panel.one('focusout submit', function (pEvent) {
        panel.off('focusout submit');
        var newFloatValue = parseFloat(input.val());
        if (value !== newFloatValue) {
          input.prop("disabled", true);
          pUpdateEditCellCB(pCell, pColumnModel, pRowObject, newFloatValue);
        } else {
          pCancelEditCellCB(pCell);
        }
        if (pEvent.type === "submit") {
          return false;
        }
        return true;
      });
    },
    _editBooleanCellHandler: function _editBooleanCellHandler(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
      pCell.wrapInner($('<span>').addClass('innerTextSpan').css('visibility', 'hidden'));
      var cellWidth = pCell.find('span.innerTextSpan').width();
      var startValue = getDataOfObjectTree(pRowObject, pColumnModel.key, this.options.enableJSONPathInKeys);
      var input = $('<input>').addClass("cf-checkbox").attr('type', 'checkbox').css('max-width', cellWidth + 20).prop("checked", startValue == true);
      var panel = $('<form>').addClass('cf-table-changePanel');
      panel.append(input);
      panel.css({
        'position': 'absolute',
        'top': 0,
        'left': 0,
        'right': 0,
        'bottom': 0
      });
      pCell.css({
        'position': 'relative'
      }).append(panel);
      var that = this;
      var hasClickedOrSpaceBarPressed = false;
      var hasMousedDown = false;
      var hasMousedUp = false;
      input.trigger("focus");
      panel.one("mousedown", function () {
        hasMousedDown = true;
      });
      panel.one("mouseup", function () {
        hasMousedUp = true;
      });
      panel.one("click", function () {
        hasClickedOrSpaceBarPressed = true;
      });
      panel.one("focusout submit", function (pEvent) {
        panel.off("focusout submit click mouseup mousedown");
        var newValue;
        // special case of safari
        // issue: where the focusout has been triggered before mousedown and click events
        if (hasClickedOrSpaceBarPressed === false && hasMousedUp === false && hasMousedDown === true) {
          // user has not used the space bar (click event)
          // and has clicked (mousedown event)
          // and no mouseup event (otherwise it was an other browser)
          newValue = !(startValue == true); // use opposide of startvalue
        } else {
          // normal case
          newValue = input.is(":checked");
        }
        if (startValue !== newValue) {
          input.prop("disabled", true);
          pUpdateEditCellCB(pCell, pColumnModel, pRowObject, newValue);
        } else {
          pCancelEditCellCB(pCell);
        }
        if (pEvent.type === "submit") {
          return false;
        }
        return true;
      });
    },
    _editDateCellHandler: function _editDateCellHandler(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
      pCell.wrapInner($("<span>").addClass("innerTextSpan").css("visibility", "hidden"));
      var cellWidth = pCell.find("span.innerTextSpan").width();
      var input = $("<div>"); // add datetimeselector when parents are known
      var panel = $("<div>").addClass("cf-table-changePanel").append(input).css({
        "position": "absolute",
        "top": 0,
        "left": 0,
        "right": 0,
        "bottom": 0
      });
      pCell.css({
        "position": "relative"
      }).append(panel);
      input.DatetimeSelector({
        startDate: getDataOfObjectTree(pRowObject, pColumnModel.key, this.options.enableJSONPathInKeys),
        format: this.options.dateFormat,
        language: this.options.language,
        periode: false
      }).DatetimeSelector("open").css("min-width", cellWidth + 20).css("display", "inline-block");
      this._floatFromRightBorder(panel, pCell, input);
      var that = this;
      input.trigger("focus").on("dp.hide", function (pEvent, pData) {
        var value = pEvent.date;
        if (pColumnModel.type === "date") {
          value = pEvent.date.valueOf();
        } else {
          value = pEvent.date.toJSON();
        }
        pUpdateEditCellCB(pCell, pColumnModel, pRowObject, value);
        return true;
      });
    },
    _editEnumHandler: function _editEnumHandler(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
      pCell.wrapInner($('<span>').addClass('innerTextSpan').css('visibility', 'hidden'));
      var value = getDataOfObjectTree(pRowObject, pColumnModel.key, this.options.enableJSONPathInKeys);
      var input = $('<div>'); // add datetimeselector when parents are known
      var panel = $('<div>').addClass('cf-table-changePanel').append(input).css({
        'position': 'absolute',
        'top': 0,
        'left': 0,
        'right': 0,
        'bottom': 0
      });
      pCell.css({
        'position': 'relative'
      }).append(panel);
      input.Select({
        keyValues: pColumnModel.options.keyValues,
        showUnknownValue: true,
        "default": value,
        classes: "table-search"
      });
      var that = this;
      input.trigger("focus");
      panel.one('focusout submit', function (pEvent) {
        panel.off('focusout submit');
        var newValue = input.Select('getValue');
        if (value !== newValue) {
          input.Select("disable");
          pUpdateEditCellCB(pCell, pColumnModel, pRowObject, newValue);
        } else {
          pCancelEditCellCB(pCell);
        }
        if (pEvent.type === "submit") {
          return false;
        }
        return true;
      });
    },
    _editTranslationObjectCellHandler: function _editTranslationObjectCellHandler(pCell, pColumnModel, pRowObject, pUpdateEditCellCB, pCancelEditCellCB) {
      var innerText = pCell.text();
      pCell.wrapInner($("<span>").addClass("innerTextSpan").css("visibility", "hidden"));
      var cellWidth = pCell.find("span.innerTextSpan").width();
      var translationObject = getDataOfObjectTree(pRowObject, pColumnModel.key, this.options.enableJSONPathInKeys);
      var input = $("<input>").attr("type", "text").val(innerText).css("min-width", cellWidth + 20);
      var panel = $("<form>").addClass("cf-table-changePanel");
      panel.append(input);
      panel.css({
        "position": "absolute",
        "top": 0,
        "left": 0,
        "right": 0,
        "bottom": 0
      });
      pCell.css({
        "position": "relative"
      }).append(panel);
      this._floatFromRightBorder(panel, pCell, input, 100);
      var that = this;
      input.trigger("focus");
      panel.one("focusout submit", function (pEvent) {
        panel.off("focusout submit");
        var newValue = input.val();
        if (innerText !== newValue) {
          input.prop("disabled", true);
          var newTranslationObject = structuredClone(translationObject);
          newTranslationObject[that.options.language] = newValue;
          // only update if changes has been detected
          pUpdateEditCellCB(pCell, pColumnModel, pRowObject, newTranslationObject);
        } else {
          pCancelEditCellCB(pCell);
        }
        if (pEvent.type === "submit") {
          return false;
        }
        return true;
      });
    },
    /**
     * @description callback function after the cell updating is done
     * @function
     * @private
     * @name nixps-cloudflow.Table#_updateEditCell
     * @param {DOM} pCell 
     * @param {Object} pColumnModel 
     * @param {Object} pRowObject 
     * @param {Mixed} pNewValue 
     * @returns {undefined}
     */
    _updateEditCell: function _updateEditCell(pCell, pColumnModel, pRowObject, pNewValue) {
      if (!$.isEmptyObject(pRowObject) && !$.isEmptyObject(pColumnModel) && pColumnModel.key !== undefined) {
        // get copy of old data
        var oldObject = $.extend(true, {}, pRowObject);
        // change/update info in object
        pRowObject = setDataOfObjectTree(pRowObject, pColumnModel.key, pNewValue, this.options.enableJSONPathInKeys);
        // call update callback function
        var returnValue = this.options.dataUpdater(pRowObject, pColumnModel, oldObject);
        // update data info in data() tr element
        if (returnValue !== undefined) {
          var that = this;
          return $.when(returnValue).then(function (pReturnValue) {
            return that.refreshData(null, true);
          }).fail(function (pError) {
            console.error(pError);
            that._repairEditCell(pCell);
          });
        } else {
          this._repairEditCell(pCell);
          return {};
        }
      } else {
        throw new Error("_updateEditCellHandler: information is missing");
      }
    },
    /**
     * @description the callback function called when the editing has to be cancelled
     * @function
     * @private
     * @name nixps-cloudflow.Table#_cancelEditCell
     * @param {DOM} pCell the cell dom 
     */
    _cancelEditCell: function _cancelEditCell(pCell) {
      this._repairEditCell(pCell);
      this._trigger("cancelcellediting", null, {});
    },
    /**
     * @description clear the table of the cell editing function
     * @function
     * @private
     * @name nixps-cloudflow.Table#_repairEditCell
     * @param {DOM} pCell 
     */
    _repairEditCell: function _repairEditCell(pCell) {
      // if we get undefined, try to repair situation
      var oldValue = pCell.find(".innerTextSpan");
      if (oldValue.length === 1) {
        // if an innerTextSpan is found, put oldValue in it
        pCell.html(oldValue.html());
      }
      pCell.removeClass("editMode").removeClass("cf-table-cell-overflowvisible");
      pCell.css("position", ""); // for some unknown reason, do not chain with removeClass
    },

    _floatFromRightBorder: function _floatFromRightBorder(pPanel, pCell, pInput, pMinWidth) {
      var availableWidth = pCell.closest("tr").width() - pCell.position().left;
      var missingWidth = pInput.outerWidth() - availableWidth;
      if (missingWidth > 0) {
        if (typeof pMinWidth === "number" && pMinWidth > 0) {
          if (pInput.outerWidth() > pMinWidth && pInput.outerWidth() - pMinWidth > missingWidth) {
            // try to scrink the input without need to move something
            pInput.css("width", pInput.width() - missingWidth - 10).css("min-width", "");
          } else {
            // schrink input to minimal
            pInput.css("width", pMinWidth).css("min-width", "");
            // move the panel to left
            missingWidth = pMinWidth - availableWidth;
            pPanel.css("left", -missingWidth - 12);
          }
        } else {
          pPanel.css("left", -missingWidth - 12);
        }
      }
    },
    windowResized: function windowResized(pNewOptions) {
      // special code for resizing window in case of sticky headers
      if (this.options.enableStickyHeader === true) {
        // first remove and later readded
        var stickyHeaderDOM;
        if (this.options.stickyTableHeadersParent && this.options.stickyTableHeadersParent instanceof jQuery) {
          stickyHeaderDOM = this.options.stickyTableHeadersParent;
        } else {
          stickyHeaderDOM = this.element.children("table");
        }
        // inform the sticky that the columns headers changed
        var data = stickyHeaderDOM.data();
        // check if plugin is applied
        if (data && data.plugin_stickyTableHeaders) {
          stickyHeaderDOM.stickyTableHeaders("destroy");
        }
        // update header
        this.changeOptionsSilence(pNewOptions);
      }
    },
    triggerEvent: function triggerEvent(pEventName, pEvent, pData) {
      /* do not use this function !! */
      if (pEvent === undefined) {
        pEvent = null;
      }
      if (pData === undefined || pData === null) {
        pData = {};
      }
      this._trigger(pEventName, pEvent, pData);
    },
    /**
     * @function
     * @description Sets the option
     * @name nixps-cloudflow.Table#_setOption
     * @throws {Error} when inputValue has the wrong type
     * @private
     */
    _setOption: function _setOption(pKey, pValue) {
      switch (pKey) {
        case "dataProvider":
          if (typeof pValue !== "function") {
            throw new Error("table _setOption: option dataProvider must be a function");
          }
          break;
        case "dataUpdater":
          if (typeof pValue !== "function") {
            throw new Error("table _setOption: option dataUpdater must be a function");
          }
          break;
        case "countProvider":
          if (typeof pValue !== "function") {
            throw new Error("table _setOption: option countProvider must be a function");
          }
          break;
        case "dataExists":
          if (typeof pValue !== "function") {
            throw new Error("table _setOption: option dataExists must be a function");
          }
          break;
        case "keepHeight":
          if (typeof pValue !== "boolean") {
            throw new Error("table _setOption: option keepHeight must be a boolean");
          }
        case "columns":
          if (!Array.isArray(pValue)) {
            throw new Error("table _setOption: option columns must be a array");
          }
          break;
        case "additionalTypes":
          if (!Array.isArray(pValue)) {
            throw new Error("table _setOption: option additionalTypes must be a array");
          }
          break;
        case "rowClassKey":
        case "pagingButtonClasses":
        case "keyUniqID":
        case "maxRows":
        case "editCellEvent":
        case "dateFormat":
        case "searchingThrottleDelay":
        case "selecting":
        case "classes":
        case "bodyClasses":
        case "configColumns":
        case "configTableID":
          // may be false or a string
          break;
        case "language":
          if (typeof pValue !== "string" || pValue.length <= 0) {
            throw new Error("table _setOption: option language must be a not empty string");
          }
          break;
        case "enableJSONPathInKeys":
          if (typeof pValue !== "boolean") {
            throw new Error("table _setOption: option enableJSONPathInKeys must be a boolean");
          }
          break;
        case "sort":
          if (!Array.isArray(pValue)) {
            throw new Error("table _setOption: option sort must be a array");
          }
          break;
        case "enableIDAttribute":
          if (typeof pValue !== "boolean") {
            throw new Error("table _setOption: option enableIDAttribute must be a boolean");
          }
          break;
        case "showRowCounter":
          if (typeof pValue !== "boolean") {
            throw new Error("table _setOption: option showRowCounter must be a boolean");
          }
          break;
        case "overflowMechanism":
          if (pValue !== "paging" && pValue !== "scrolling") {
            throw new Error("table _setOption: option overflowMechanism must be equal to paging or scrolling");
          }
          break;
        case "enableStickyHeader":
          if (typeof pValue !== "boolean") {
            throw new Error("table _setOption: option enableStickyHeader must be a boolean");
          }
          break;
        case "stickyHeaderAppliedBy":
          if (pValue !== "js" && pValue !== "css") {
            throw new Error("table _setOption: option stickyHeaderAppliedBy must be equal to 'js' or 'css'");
          }
          break;
        case "stickyHeaderMarginTop":
          break;
        default:
          throw new Error("table _setOption: unknown option " + pKey);
      }
      this._superApply(arguments);
    },
    _setOptions: function _setOptions(options) {
      var keys = Object.keys(options);
      if (keys.every(function (e) {
        return ["maxRows", "classes"].includes(e);
      })) {
        this.changeOptionsSilence(options);
        this.refreshData(null, undefined, true);
      } else {
        this._super(options);
        this.redraw();
      }
    },
    changeOptionsSilence: function changeOptionsSilence(options) {
      var that = this;
      $.each(options, function (key, value) {
        if (key === "maxRows") {
          that._setOption(key, value);
          if (that.options.maxRows === null) {
            // if no maxRows add maximum rows
            that.limit = Number.MAX_VALUE;
          } else if (typeof that.options.maxRows === "number") {
            that.limit = that.options.maxRows;
          }
        } else if (key === "classes") {
          if (that.options.classes !== value) {
            that.element.children("table").removeClass(that.options.classes).addClass(value);
            that._setOption(key, value);
          }
        } else if (key === "sort") {
          that._setOption(key, value);
          that.orderBy = transformSortToBackendSort(that.options.sort);
          // if sorting is enbaled
          if (that.element.children("table").children("thead").find(".sortable_disabled").length === 0) {
            // add sorting triangle
            for (var i = 0; i < that.options.columns.length; i++) {
              // get correct column
              if (that.options.columns[i].sortable === true && that.options.columns[i].key === that.orderBy[0]) {
                var columnToSort = that.element.children("table").children("thead").children("tr.tableHeaderTitels").children("th").eq(i);
                that._prepareSortColumn(columnToSort, that.orderBy[0], that.orderBy[1] !== "descending");
                break;
              }
            }
          }
        } else if (key === "stickyHeaderMarginTop") {
          that._setOption(key, value);
          if (that.options.enableStickyHeader === true && that.options.stickyHeaderAppliedBy === "js" && $.fn.stickyTableHeaders !== undefined) {
            var stickyHeaderDOM;
            if (that.options.stickyTableHeadersParent !== undefined && that.options.stickyTableHeadersParent instanceof jQuery) {
              stickyHeaderDOM = that.options.stickyTableHeadersParent;
            } else {
              stickyHeaderDOM = that.element.children("table");
            }
            stickyHeaderDOM.stickyTableHeaders({
              cacheHeaderHeight: that.options.stickyHeaderMarginTop === 0,
              fixedOffset: 0,
              marginTop: that.options.stickyHeaderMarginTop,
              scrollableArea: that.stickHeadersArea
            });
          }
        } else {
          throw new Error("not supported option");
        }
      });
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeAttr("data-uuid");
      this.element.off("enabledStickiness.stickyTableHeaders");
      this.element.off("disabledStickiness.stickyTableHeaders");
      this.element.off("wheel", this._stopWheelEventInConfigMode);
      if (this.searchHeaderChangeHandler && typeof this.searchHeaderChangeHandler.cancel === "function") {
        this.searchHeaderChangeHandler.cancel();
      }
      this._super();
    }
  });
})(jQuery);

},{"../../../common/DropdownList/js/nixps-DropdownList.js":288,"../../../common/Selectable/js/nixps-Selecting.js":318,"../../../common/Touch/js/TouchUtil.js":382,"../../CheckExternals/js/CheckExternals.js":54,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../CloudflowUtil/js/DateFunctions.js":83,"../../FormElements/js/nixps-cloudflow-DatetimeSelector.js":145,"../../Table/js/Query.js":211,"./TableConfig.js":212,"./nixps-cloudflow-CollapsibleColumns.js":215}],219:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require('../../../../common/polyfills/polyfill-assign.js');
var Task = function Task(pJSON) {
  for (var prop in pJSON) {
    this[prop] = pJSON[prop];
  }
};
Task.state = {
  PENDING: 'pending',
  READY: 'ready',
  BUSY: 'busy',
  DONE: 'done',
  SUSPEND: 'suspended',
  FAILED: "failed",
  CANCELLED: "cancelled"
};
Task.action = {
  START: 'Start',
  SUSPEND: 'Suspend',
  STOP: 'Done'
};
Task.DUE_STATES = {
  "Normal": "normal",
  "CriticalPlannedBegin": "critical",
  "LatePlannedBegin": "late",
  "CriticalPlannedEnd": "critical",
  "LatePlannedEnd": "late",
  "LateActualBegin": "late",
  "LateActualEnd": "late"
};
Task.canStop = function (pTask) {
  if (!(_typeof(pTask) === "object" && pTask !== null)) {
    return false;
  }
  return pTask.state === Task.state.BUSY || pTask.state == Task.state.SUSPEND;
};
Task.canStart = function (pTask) {
  if (!(_typeof(pTask) === "object" && pTask !== null)) {
    return false;
  }
  return pTask.state === Task.state.READY || pTask.state === Task.state.SUSPEND;
};
Task.canSuspend = function (pTask) {
  if (!(_typeof(pTask) === "object" && pTask !== null)) {
    return false;
  }
  return pTask.state == Task.state.BUSY;
};
Task.isActive = function (pTask) {
  if (!(_typeof(pTask) === "object" && pTask !== null)) {
    return false;
  }
  return pTask.state === Task.state.READY || pTask.state === Task.state.BUSY || pTask.state === Task.state.SUSPEND;
};
Task.nextAction = function (pTask) {
  if (!(_typeof(pTask) === "object" && pTask !== null)) {
    return undefined;
  }
  switch (pTask.state) {
    case Task.state.READY:
      return Task.action.START;
    case Task.state.BUSY:
      return Task.action.STOP;
  }
};
/**
 * @deprecated not used
 */
Task.getTaskVisualization = function (pTask, pGroup, pReference) {
  if (pTask.group) {
    pGroup = pTask.group;
  }
  if (pTask.reference) {
    pReference = pTask.reference;
  }
  if (pGroup === undefined) {
    pGroup = "";
  }
  var beginAndEndTime = Task.getBeginAndEndTime(pTask);
  if (!beginAndEndTime) {
    return;
  }
  var item = {
    name: pTask.description,
    id: pTask.id,
    state: pTask.state,
    values: [{
      from: beginAndEndTime.begin,
      to: beginAndEndTime.end
    }],
    group: pGroup
  };
  if (pReference !== undefined) {
    item["reference"] = pReference;
  }
  if (pTask.custom) {
    item["custom"] = pTask.custom;
  }
  return item;
};
/**
 * @deprecated not used
 */
Task.getBeginAndEndTime = function (pTask) {
  var beginTime;
  var endTime;
  if (pTask.begin && pTask.begin.actual && pTask.state !== Task.state.PENDING && pTask.state !== Task.state.READY) {
    beginTime = pTask.begin.actual;
  } else if (pTask.begin && pTask.begin.planned && pTask.begin.planned.time) {
    beginTime = pTask.begin.planned.time;
  }
  if (pTask.end && pTask.end.actual && pTask.state !== Task.state.PENDING && pTask.state !== Task.state.READY) {
    endTime = pTask.end.actual;
  } else if (pTask.end && pTask.end.planned && pTask.end.planned.time) {
    endTime = pTask.end.planned.time;
  }
  if (beginTime === undefined && endTime === undefined) {
    return false;
  }
  if (beginTime === undefined) {
    beginTime = endTime;
  } else if (endTime === undefined) {
    endTime = beginTime;
  }
  return {
    begin: beginTime,
    end: endTime
  };
};
module.exports = Task;

},{"../../../../common/polyfills/polyfill-assign.js":393}],220:[function(require,module,exports){
"use strict";

var Store = require("../../../../proofscopeComponent/js/store/nixps-proofscope-Store.js");
var Member = require("../model/Member.js");
var getMemberForm = function getMemberForm(pOptions) {
  if (pOptions === undefined) {
    pOptions = {};
  }
  if (pOptions.roles === undefined) {
    pOptions.roles = [];
  }
  // var form = Store.memoizeFromObject("team_getmemberform", pOptions);
  // if(form === undefined) {
  var form = {
    "layout": {
      "type": "bootstrapGrid",
      "parameters": [[{
        "content": "userInput",
        "width": 12
      }]]
    },
    "contents": {
      "elements": [{
        "type": "component",
        "element": {
          "id": "errorMessage",
          "type": "ErrorMessage"
        }
      }, {
        "type": "field",
        "element": {
          "key": "user_name",
          "label": pOptions.hideMemberLabel === true ? "" : $.i18n._('nixps-team.member'),
          "component": {
            "id": "userInput",
            "type": "AutoFill",
            "options": {
              "collection": "nucleus.users",
              "collectionTable": "users",
              "keyField": "username",
              "displayValueField": "username",
              "collectionFilter": ["not", "username", "in", pOptions.used_usernames]
            }
          },
          "required": true
        }
      }]
    }
  };
  if (pOptions.withRoles === true) {
    form.layout.parameters.push([{
      "content": "rolesInput",
      "width": 12
    }]);
    form.contents.elements.push({
      "type": "field",
      "element": {
        "key": "roles",
        "label": pOptions.hideRolesLabel === true ? "" : $.i18n._('nixps-team.role-list'),
        "component": {
          "id": "rolesInput",
          "type": "MultiSelect",
          "options": {
            "inputFields": pOptions.roles
          }
        }
      }
    });
  }
  if (pOptions.showButtons === true) {
    form.layout.parameters.push([{
      "content": "errorMessage",
      "width": 12
    }]);
  }
  if (pOptions.asList === true) {
    form = {
      "layout": {
        "type": "bootstrapGrid",
        "parameters": [[{
          "content": "memberListInput",
          "width": 12
        }]]
      },
      "contents": {
        "elements": [{
          "type": "field",
          "element": {
            "key": "members",
            "label": pOptions.hideMembersLabel === true ? "" : $.i18n._("nixps-team.members"),
            "component": {
              "id": "memberListInput",
              "type": "OrderedArrayInput",
              "options": {
                "formOptions": {
                  "formJSON": form.contents,
                  "layoutJSON": form.layout,
                  "keepValidating": false,
                  "throttleTime": 0,
                  "formClasses": "cf-form"
                },
                "valueWhenEmpty": Member.empty(),
                "allowEmpty": pOptions.required === false
              }
            }
          }
        }]
      }
    };
  }
  // Store.memoizeFromObject("team_getmemberform", pOptions, form);
  // }
  return form;
};
module.exports = getMemberForm;

},{"../../../../proofscopeComponent/js/store/nixps-proofscope-Store.js":434,"../model/Member.js":222}],221:[function(require,module,exports){
"use strict";

var getMemberForm = require("./getMemberForm.js");
var Member = require("../model/Member.js");
var getTeamForm = function getTeamForm(pOptions) {
  var roleForm = {
    "layout": {
      "type": "bootstrapGrid",
      "parameters": [[{
        "content": "roleInput",
        "width": 12
      }]]
    },
    "contents": {
      "elements": [{
        "type": "field",
        "element": {
          "key": "role",
          "component": {
            "id": "roleInput",
            "type": "Input",
            "options": {
              "type": "text"
            }
          }
        }
      }]
    }
  };
  var form = {
    "layout": {
      "type": "bootstrapGrid",
      "parameters": [[{
        "content": "nameInput",
        "width": 12
      }], [{
        "content": "descriptionInput",
        "width": 12
      }], [{
        "content": "roleListInput",
        "width": 12
      }]]
    },
    "contents": {
      "elements": [{
        "type": "component",
        "element": {
          "id": "errorMessage",
          "type": "ErrorMessage",
          "options": {
            "useBootStrap": false
          }
        }
      }, {
        "type": "field",
        "element": {
          "key": "name",
          "label": $.i18n._("nixps-team.name"),
          "component": {
            "id": "nameInput",
            "type": "Input",
            "options": {
              "type": "text"
            }
          },
          "required": true
        }
      }, {
        "type": "field",
        "element": {
          "key": "description",
          "label": $.i18n._("nixps-team.description"),
          "component": {
            "id": "descriptionInput",
            "type": "Input",
            "options": {
              "type": "text"
            }
          },
          "required": true
        }
      }, {
        "type": "field",
        "element": {
          "key": "role_list",
          "label": $.i18n._("nixps-team.role-list"),
          "component": {
            "id": "roleListInput",
            "type": "OrderedArrayInput",
            "options": {
              "formOptions": {
                "formJSON": roleForm.contents,
                "layoutJSON": roleForm.layout,
                "keepValidating": false,
                "throttleTime": 0,
                "formClasses": "cf-form"
              },
              "valueWhenEmpty": {
                role: ""
              },
              "allowEmpty": true
            }
          }
        }
      }]
    }
  };
  if (Array.isArray(pOptions.scopes)) {
    var scopeForm = {
      "layout": {
        "type": "bootstrapGrid",
        "parameters": [[{
          "content": "scopeInput",
          "width": 12
        }]]
      },
      "contents": {
        "elements": [{
          "type": "field",
          "element": {
            "key": "scope",
            "component": {
              "id": "scopeInput",
              "type": "Select",
              "options": {
                "keyValues": pOptions.scopes.reduce(function (pAcc, pScope) {
                  pAcc[pScope._id] = pScope.name;
                  return pAcc;
                }, {})
              }
            }
          }
        }]
      }
    };
    form.layout.parameters.push([{
      "content": "scopeListInput",
      "width": 12
    }]);
    form.contents.elements.push({
      "type": "field",
      "element": {
        "key": "scope",
        "label": $.i18n._("nixps-team.scopes"),
        "component": {
          "id": "scopeListInput",
          "type": "OrderedArrayInput",
          "options": {
            "formOptions": {
              "formJSON": scopeForm.contents,
              "layoutJSON": scopeForm.layout,
              "keepValidating": false,
              "throttleTime": 0,
              "formClasses": "cf-form"
            },
            "valueWhenEmpty": {
              scope: ""
            },
            "allowEmpty": true
          }
        }
      }
    });
  }
  if (pOptions.withMembers !== false) {
    var memberForm = getMemberForm({
      withRoles: true,
      showButtons: false,
      used_usernames: pOptions.used_usernames,
      roles: pOptions.roles
    });
    form.layout.parameters.push([{
      "content": "memberListInput",
      "width": 12
    }]);
    form.contents.elements.push({
      "type": "field",
      "element": {
        "key": "members",
        "label": $.i18n._("nixps-team.members"),
        "component": {
          "id": "memberListInput",
          "type": "OrderedArrayInput",
          "options": {
            "formOptions": {
              "formJSON": memberForm.contents,
              "layoutJSON": memberForm.layout,
              "keepValidating": false,
              "throttleTime": 0,
              "formClasses": "cf-form"
            },
            "valueWhenEmpty": Member.empty(),
            "allowEmpty": true
          }
        }
      }
    });
  }
  if (pOptions.showButtons === true) {
    form.layout.parameters.push([{
      "content": "errorMessage",
      "width": 12
    }]);
  }
  return form;
};
module.exports = getTeamForm;

},{"../model/Member.js":222,"./getMemberForm.js":220}],222:[function(require,module,exports){
"use strict";

var Member = function Member() {};
Member.empty = function () {
  return {
    user_name: "",
    full_name: "",
    email_address: "",
    roles: []
  };
};
module.exports = Member;

},{}],223:[function(require,module,exports){
"use strict";

var Store = require("../../../../proofscopeComponent/js/store/nixps-proofscope-Store.js");
var Team = function Team(options) {
  if (!options) {
    options = Team.empty();
  }
  this._setID(options._id);
  this.setName(options.name);
  this.setDescription(options.description);
  this.setRoleList(options.role_list);
  this.setMembers(options.members);
  this.setScopes(options.scopes);
};
Team.empty = function () {
  return {
    _id: undefined,
    name: "",
    description: "",
    role_list: [],
    members: []
  };
};
Team.duplicate = function (pTeam) {
  return {
    name: pTeam.name,
    description: pTeam.description,
    role_list: [].concat(pTeam.role_list),
    members: pTeam.members.map(function (pMember) {
      return {
        user_name: pMember.user_name,
        full_name: pMember.full_name,
        email_address: pMember.email_address,
        roles: [].concat(pMember.roles)
      };
    }),
    scope: pTeam.scope ? [].concat(pTeam.scope) : undefined
  };
};
Team.fromJSON = function (pJSON) {
  return new Team(pJSON);
};
Team.getIncludedMembers = function (pTeam, pUserNameOnly, pRole, pExact) {
  var members = Store.memoize("team_getincludedmembers", [pUserNameOnly, pTeam, pRole, pExact]);
  if (members === undefined) {
    members = Array.isArray(pTeam.members) === false ? [] : pTeam.members.reduce(function (pAcc, pMember) {
      if (pRole === undefined || pMember.roles.indexOf(pRole) !== -1 && (pExact && pMember.roles.length === 1 || !pExact)) {
        if (pUserNameOnly === true) {
          pAcc.push(pMember.user_name);
        } else {
          pAcc.push(pMember);
        }
      }
      return pAcc;
    }, []);
    Store.memoize("team_getincludedmembers", [pUserNameOnly, pTeam, pRole, pExact], members);
  }
  return members;
};
Team.prototype = {
  constructor: Team,
  _setID: function _setID(pID) {
    this._id = pID;
  },
  setName: function setName(pName) {
    if (typeof pName !== "string") {
      throw new Error("parameter name must be a string");
    }
    this.name = pName;
  },
  getName: function getName() {
    return this.name;
  },
  setDescription: function setDescription(pDescription) {
    if (typeof pDescription !== "string") {
      throw new Error("parameter pDescription must be a string");
    }
    this.description = pDescription;
  },
  getDescription: function getDescription() {
    return this.description;
  },
  setRoleList: function setRoleList(pRoleList) {
    this.role_list = [];
    if (Array.isArray(pRoleList) && pRoleList.length > 0) {
      for (var i = 0; i < pRoleList.length; i++) {
        if (typeof pRoleList[i] === "string" && pRoleList[i].length > 0) {
          this.role_list.push(pRoleList[i]);
        }
      }
    }
  },
  getRoleList: function getRoleList() {
    return this.role_list;
  },
  setMembers: function setMembers(pMembers) {
    this.members = [];
    if (Array.isArray(pMembers) && pMembers.length > 0) {
      for (var i = 0; i < pMembers.length; i++) {
        if (pMembers[i] !== undefined && pMembers[i] !== null) {
          if (typeof pMembers[i].email_address === "string" || typeof pMembers[i].user_name === "string") {
            this.members.push(pMembers[i]);
          } else {
            throw new Error("invalid member found", pMembers[i]);
          }
        }
      }
    }
  },
  containsUser: function containsUser(pUser) {},
  removeUser: function removeUser(pUser) {},
  setScopes: function setScopes(pScopes) {
    this.scopes = undefined;
    if (Array.isArray(pScopes)) {
      this.scopes = pScopes.slice();
    }
  },
  getScopes: function getScopes() {
    return this.scopes;
  },
  clone: function clone() {
    return Team.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var output = {
      _id: this._id,
      name: this.name,
      description: this.description,
      role_list: this.role_list.slice(),
      members: this.members.slice()
    };
    if (Array.isArray(this.scopes)) {
      output.scopes = this.scopes;
    }
    return output;
  }
};
module.exports = Team;

},{"../../../../proofscopeComponent/js/store/nixps-proofscope-Store.js":434}],224:[function(require,module,exports){
"use strict";

var JSONPatch = require("../../../JODANebula/Framework/General/JSON/js/nixps-JSONPatch.js");
var getMemberForm = require("./functions/getMemberForm.js");
var Team = require("./model/Team.js");
var FormRendererUtilities = require("../../../JODANebula/Framework/General/Form/js/nixps-FormRendererUtilities");
require("../../../JODANebula/Framework/Component/Form/js/nixps-form-OrderedArrayInput.js");
$.widget("nixps-cloudflow.MemberListByRoleImpl", $.Widget, {
  options: {
    /**
     * @name nixps-cloudflow.MemberListByRoleImpl#team
     * @description the team to display
     * @type {Object}
     * @default {}
     */
    team: null,
    role: "",
    multiple: false,
    exact: false,
    formClasses: "",
    /**
     * @name nixps-cloudflow.MemberListByRoleImpl#required
     * @description are the inputs required?
     * @type {Boolean}
     * @default false
     */
    required: false
  },
  _create: function _create() {
    if (this.options.team === null) {
      this.options.team = Team.empty();
    }
    this.retrieving = false;
    this.element.addClass(this.widgetFullName);
    this._draw();
    FormRendererUtilities.onchange(this.element, this._onChange.bind(this));
  },
  _draw: function _draw() {
    var form = getMemberForm({
      used_usernames: this._getIncludedMembers(true),
      withRoles: false,
      withButtons: false,
      hideMembersLabel: true,
      hideMemberLabel: true,
      hideRolesLabel: true,
      asList: this.options.multiple,
      required: this.options.required
    });
    this.element.FormRenderer({
      formJSON: form.contents,
      layoutJSON: form.layout,
      variableDictionary: form.localization,
      formClasses: "cf-form " + this.options.formClasses,
      disabled: this.options.disabled
    });
    this.element.FormRenderer("setValidationPhase", false);
    var includedMembers = this._getIncludedMembers();
    if (this.options.multiple) {
      this.element.FormRenderer("setValues", {
        members: includedMembers
      });
    } else if (includedMembers.length > 0) {
      this.element.FormRenderer("setValues", includedMembers[0]);
    }
  },
  _getIncludedMembers: function _getIncludedMembers(pUserNameOnly) {
    return Team.getIncludedMembers(this.options.team, pUserNameOnly, this.options.role, this.options.exact);
  },
  _setOptions: function _setOptions(options) {
    this._super(options);
    this._draw();
  },
  enable: function enable() {
    // ovewrite so it works on jquery ui < 1.12
    this._setOptions({
      "disabled": false
    });
  },
  disable: function disable() {
    // ovewrite so it works on jquery ui < 1.12
    this._setOptions({
      "disabled": true
    });
  },
  _onChange: function _onChange() {
    var that = this;
    var patches = [];
    var members = [];
    if (this.options.multiple) {
      var members = this.element.find(".nixps-form-OrderedArrayInput").OrderedArrayInput("getValue", false).reduce(function (pAcc, pMember) {
        if (typeof pMember.user_name === "string" && pMember.user_name.length > 0) {
          pAcc.push(pMember.user_name);
        }
        return pAcc;
      }, []);
    } else {
      var values = this.element.FormRenderer("getValues");
      if (typeof values.user_name === "string" && values.user_name.length > 0) {
        members.push(values.user_name);
      }
    }
    if (!Array.isArray(this.options.team.members)) {
      this.options.team = JSONPatch.add(patches, "/members", []);
    } else {
      for (var i = this.options.team.members.length - 1; i >= 0; i--) {
        var member = this.options.team.members[i];
        var found = false;
        for (var j = 0, jlen = members.length; j < jlen; j++) {
          if (members[j] === member.user_name) {
            found = true;
            members.splice(j, 1);
            if (this.options.exact === false && member.roles.indexOf(this.options.role) === -1) {
              JSONPatch.add(patches, "/members/" + i + "/roles/-", this.options.role);
            } else if (this.options.exact === true) {
              JSONPatch.replace(patches, "/members/" + i + "/roles", [this.options.role]);
            }
            break;
          }
        }
        var index = member.roles.indexOf(this.options.role);
        if (found === false && index !== -1) {
          JSONPatch.remove(patches, "/members/" + i + "/roles/" + index);
        }
      }
    }
    if (members.length > 0) {
      this.retrieving = true;
      for (var i = 0, len = members.length; i < len; i++) {
        JSONPatch.add(patches, "/members/-", {
          user_name: members[i],
          roles: [that.options.role]
        });
      }
      api_async.users.list(["username", "in", members], [], function (pUsers) {
        var patches = [];
        for (var i = 0, len = pUsers.results.length; i < len; i++) {
          var user = pUsers.results[i];
          var index = that.options.team.members.findIndex(function (pMember) {
            return pMember.user_name === user.username;
          });
          JSONPatch.replace(patches, "/members/" + index, {
            user_name: user.username,
            full_name: user.fullname,
            email_address: user.email,
            roles: [that.options.role]
          });
        }
        that.options.team = JSONPatch.patch(that.options.team, patches, true);
        that.retrieving = false;
      });
    }
    if (this.options.multiple) {
      var used_usernames = this._getIncludedMembers(true);
      var member_form = getMemberForm({
        used_usernames: used_usernames,
        hideMembersLabel: true,
        hideMemberLabel: true,
        hideRolesLabel: true,
        withRoles: false,
        withButtons: false,
        asList: false
      });
      var formOptions = this.element.find(".nixps-form-OrderedArrayInput").OrderedArrayInput("option", "formOptions");
      formOptions.formJSON = member_form.contents;
      formOptions.layoutJSON = member_form.layout;
      this.element.find(".nixps-cloudflow-AutoFill").AutoFill({
        "collectionFilter": ["not", "username", "in", used_usernames]
      });
    }
    this.options.team = JSONPatch.patch(this.options.team, patches, true);
  },
  isValid: function isValid(pReturnErrorMessage, pHighlightError) {
    if (this.retrieving === true) {
      if (pHighlightError === true) {
        this.element.FormRenderer("showErrorMessages", [$.i18n._('nixps-cloudflow-FormRenderer.missing_fields_message')]);
      } else if (pReturnErrorMessage === true) {
        return $.i18n._('nixps-cloudflow-FormRenderer.missing_fields_message');
      } else {
        return false;
      }
    } else if (this.options.multiple) {
      return this.element.FormRenderer("isValid", pReturnErrorMessage, pHighlightError);
    } else {
      var that = this;
      return !this.options.required || this.options.team.members.some(function (pMember) {
        return pMember.roles.indexOf(that.options.role) !== -1;
      });
    }
  },
  getValue: function getValue() {
    return this.options.team;
  },
  setValue: function setValue(pTeam) {
    this._setOptions({
      team: pTeam
    });
  },
  _destroy: function _destroy() {
    this._super();
    this.element.removeClass(this.widgetFullName);
  }
});

},{"../../../JODANebula/Framework/Component/Form/js/nixps-form-OrderedArrayInput.js":14,"../../../JODANebula/Framework/General/Form/js/nixps-FormRendererUtilities":25,"../../../JODANebula/Framework/General/JSON/js/nixps-JSONPatch.js":29,"./functions/getMemberForm.js":220,"./model/Team.js":223}],225:[function(require,module,exports){
"use strict";

var JSONPatch = require("../../../JODANebula/Framework/General/JSON/js/nixps-JSONPatch.js");
var getMemberForm = require("./functions/getMemberForm.js");
var Team = require("./model/Team.js");
require("../../../JODANebula/Framework/Component/Form/js/nixps-form-OrderedArrayInput.js");
$.widget("nixps-cloudflow.MemberListImpl", $.Widget, {
  version: "1.1.0",
  widgetEventPrefix: "memberlistimpl",
  options: {
    /**
     * @name nixps-cloudflow.MemberListImpl#team
     * @description the team to display
     * @type {Object}
     * @default null
     */
    team: null,
    formClasses: "",
    /**
     * @name nixps-cloudflow.MemberListImpl#required
     * @description are the inputs required?
     * @type {Boolean}
     * @default false
     */
    required: false,
    disabled: false
  },
  _create: function _create() {
    if (this.options.team === null) {
      this.options.team = Team.empty();
    }
    this.element.addClass(this.widgetFullName);

    // variables
    this.retrieving = false;
    this._draw();
    this._on(this.element, {
      "formrendererchange": this._onChangeHandler
    });
  },
  _onChangeHandler: function _onChangeHandler(pEvent, pData) {
    var that = this;
    var members = this.element.find(".nixps-form-OrderedArrayInput").OrderedArrayInput("getValue", false);
    if (members.length > 0) {
      var memberNames = members.reduce(function (pAcc, pMember) {
        if (typeof pMember.user_name === "string" && pMember.user_name.length > 0) {
          pAcc.push(pMember.user_name);
        }
        return pAcc;
      }, []);
      that.retrieving = true;
      this.options.team = JSONPatch.patch(this.options.team, [JSONPatch._replace("/members", members)], true);
      api_async.users.list(["username", "in", memberNames], [], function (pUsers) {
        var patches = [];
        for (var i = 0, len = pUsers.results.length; i < len; i++) {
          var user = pUsers.results[i];
          var index = that.options.team.members.findIndex(function (pMember) {
            if (pMember.user_name === user.username) {
              return true;
            }
            return false;
          });
          JSONPatch.add(patches, "/members/" + index + "/full_name", user.fullname);
          JSONPatch.add(patches, "/members/" + index + "/email_address", user.email);
        }
        that.options.team = JSONPatch.patch(that.options.team, patches, true);
        that.retrieving = false;
      });
    } else {
      this.options.team = JSONPatch.patch(this.options.team, [JSONPatch._replace("/members", [])], true);
    }
    var used_usernames = this._getIncludedMembers(true);
    var member_form = getMemberForm({
      used_usernames: used_usernames,
      roles: this.options.team.role_list,
      hideMembersLabel: true,
      withRoles: true,
      withButtons: false,
      asList: false,
      required: this.options.required
    });
    var formOptions = this.element.find(".nixps-form-OrderedArrayInput").OrderedArrayInput("option", "formOptions");
    formOptions.formJSON = member_form.contents;
    formOptions.layoutJSON = member_form.layout;
    var real_used_usernames = used_usernames.filter(function (name) {
      return typeof name === "string" && name.length > 0;
    });
    this.element.find(".nixps-cloudflow-AutoFill").AutoFill({
      "collectionFilter": ["not", "username", "in", real_used_usernames]
    });
  },
  _draw: function _draw() {
    var form = getMemberForm({
      used_usernames: this._getIncludedMembers(true),
      roles: this.options.team.role_list,
      hideMembersLabel: true,
      withRoles: true,
      withButtons: false,
      asList: true,
      required: this.options.required
    });
    this.element.FormRenderer({
      formJSON: form.contents,
      layoutJSON: form.layout,
      variableDictionary: form.localization,
      formClasses: "cf-form " + this.options.formClasses,
      throttleTime: 750,
      disabled: this.options.disabled
    });
    this.element.FormRenderer("setValidationPhase", false);
    this.element.FormRenderer("setValues", {
      members: this._getIncludedMembers()
    });
  },
  _getIncludedMembers: function _getIncludedMembers(pUserNameOnly) {
    return Team.getIncludedMembers(this.options.team, pUserNameOnly);
  },
  _setOptions: function _setOptions(options) {
    this._super(options);
    this._draw();
  },
  enable: function enable() {
    // ovewrite so it works on jquery ui < 1.12
    this._setOptions({
      "disabled": false
    });
  },
  disable: function disable() {
    // ovewrite so it works on jquery ui < 1.12
    this._setOptions({
      "disabled": true
    });
  },
  isValid: function isValid(pReturnErrorMessage, pHighlightError) {
    if (this.retrieving === true) {
      if (pHighlightError === true) {
        this.element.FormRenderer("showErrorMessages", [$.i18n._('nixps-cloudflow-FormRenderer.missing_fields_message')]);
      } else if (pReturnErrorMessage === true) {
        return $.i18n._('nixps-cloudflow-FormRenderer.missing_fields_message');
      } else {
        return false;
      }
    } else {
      return this.element.FormRenderer("isValid", pReturnErrorMessage, pHighlightError);
    }
  },
  getValue: function getValue() {
    return this.options.team;
  },
  setValue: function setValue(pTeam) {
    this._setOptions({
      team: pTeam
    });
  },
  _destroy: function _destroy() {
    this._super();
    this.element.removeClass(this.widgetFullName);
  }
});

},{"../../../JODANebula/Framework/Component/Form/js/nixps-form-OrderedArrayInput.js":14,"../../../JODANebula/Framework/General/JSON/js/nixps-JSONPatch.js":29,"./functions/getMemberForm.js":220,"./model/Team.js":223}],226:[function(require,module,exports){
"use strict";

var getComponent = require("../../../JODANebula/Framework/General/Component/js/functions/nixps-getComponent.js");
var setComponent = require("../../../JODANebula/Framework/General/Component/js/functions/nixps-setComponent.js");
var FormRendererUtilities = require("../../../JODANebula/Framework/General/Form/js/nixps-FormRendererUtilities");
var getMemberForm = require("./functions/getMemberForm.js");
var getTeamForm = require("./functions/getTeamForm.js");
require("../../../JODANebula/Framework/Component/Form/js/nixps-form-OrderedArrayInput.js");
function setValues(pElement, pValues) {
  var values = Object.assign({}, pValues);
  var role_list = [];
  if (Array.isArray(pValues.role_list)) {
    for (var i = 0, len = pValues.role_list.length; i < len; i++) {
      role_list.push({
        role: pValues.role_list[i]
      });
    }
  }
  values.role_list = role_list;
  var scope = [];
  if (Array.isArray(pValues.scope)) {
    for (var i = 0, len = pValues.scope.length; i < len; i++) {
      scope.push({
        scope: pValues.scope[i]
      });
    }
  }
  values.scope = scope;
  $(pElement).FormRenderer("setValues", values);
}
function getValues(pElement) {
  var values = $(pElement).FormRenderer("getValues");
  var role_list = [];
  for (var i = 0, len = values.role_list.length; i < len; i++) {
    role_list.push(values.role_list[i].role);
  }
  values.role_list = role_list;
  var scope = [];
  if (Array.isArray(values.scope)) {
    for (var i = 0, len = values.scope.length; i < len; i++) {
      scope.push(values.scope[i].scope);
    }
  }
  values.scope = scope;
  return values;
}
function TeamForm(pElement, pOptions) {
  var component = getComponent(pElement, "TeamForm");
  function onSaveClick() {
    if ($(component._Form).FormRenderer("isValid") === true) {
      pElement.dispatchEvent(new CustomEvent("submit", {
        bubbles: true,
        detail: Object.assign({}, pOptions.team, getValues(component._Form))
      }));
    }
  }
  function onChange() {
    var team = Object.assign({}, pOptions.team, getValues(component._Form));
    if (pOptions.withMembers) {
      var members = $(pElement).find("[data-id='memberListInput']").find(".nixps-form-OrderedArrayInput").OrderedArrayInput("getValue", false);
      var used_usernames = Array.isArray(members) ? members.reduce(function (pAcc, pMember) {
        if (typeof pMember.user_name === "string") {
          pAcc.push(pMember.user_name);
        }
        return pAcc;
      }, []) : [];
      if (Array.isArray(team.role_list) && team.role_list.length > 0) {
        var member_form = getMemberForm({
          withRoles: true,
          showButtons: false,
          used_usernames: used_usernames,
          roles: team.role_list
        });
        $(pElement).find("[data-id='memberListInput']").show();
        var formOptions = $(pElement).find("[data-id='memberListInput']").find(".nixps-form-OrderedArrayInput").OrderedArrayInput("option", "formOptions");
        formOptions.formJSON = member_form.contents;
        formOptions.layoutJSON = member_form.layout;
        $(pElement).find("[data-id='memberListInput']").find(".nixps-cloudflow-MultiSelect").each(function () {
          var val = $(this).MultiSelect("getValue");
          $(this).MultiSelect({
            inputFields: team.role_list
          });
          $(this).MultiSelect("setValue", val);
        });
        $(pElement).find("[data-id='memberListInput']").find(".nixps-cloudflow-AutoFill").AutoFill({
          "collectionFilter": ["not", "username", "in", used_usernames]
        });
      } else {
        $(pElement).find("[data-id='memberListInput']").hide();
        $(pElement).find("[data-id='memberListInput']").find(".nixps-cloudflow-MultiSelect").MultiSelect("setValue", []);
      }
    }
    pElement.dispatchEvent(new CustomEvent("changeteam", {
      bubbles: true,
      detail: team
    }));
  }
  if (component == null) {
    pElement.classList.add("Team_Form");
    var form = document.createElement("div");
    pElement.appendChild(form);
    var buttonbar = document.createElement("div");
    buttonbar.className = "cf-buttonbar-center";
    pElement.appendChild(buttonbar);
    var cancelButton = document.createElement("button");
    cancelButton.className = "cf-button-secondary";
    cancelButton.textContent = $.i18n._("nixps-form-Button.cancel");
    cancelButton.addEventListener("click", function () {
      pElement.dispatchEvent(new CustomEvent("cancel", {
        bubbles: true
      }));
    });
    buttonbar.appendChild(cancelButton);
    var saveButton = document.createElement("button");
    saveButton.className = "cf-button-main";
    saveButton.textContent = $.i18n._("nixps-form-Button.save");
    buttonbar.appendChild(saveButton);
    component = setComponent(pElement, "TeamForm", {
      _Form: form,
      _ButtonBar: buttonbar,
      _Save: saveButton,
      _Save_Listener: null,
      _Change_Listener: null
    });
  }
  pOptions.used_usernames = Array.isArray(pOptions.team.members) === false ? [] : pOptions.team.members.map(function (pMember) {
    return pMember.user_name;
  });
  pOptions.roles = pOptions.team.role_list;
  var form = getTeamForm(pOptions);
  $(component._Form).FormRenderer({
    formJSON: form.contents,
    layoutJSON: form.layout,
    variableDictionary: form.localization,
    formClasses: "cf-form " + pOptions.formClasses
  });
  setValues(component._Form, pOptions.team);
  $(component._Form).FormRenderer("setValidationPhase", false);
  if (pOptions.withMembers && Array.isArray(pOptions.team.role_list) && pOptions.team.role_list.length > 0) {
    $(pElement).find("[data-id='memberListInput']").show();
  } else {
    $(pElement).find("[data-id='memberListInput']").hide();
  }
  if (pOptions.showButtons === true) {
    component._ButtonBar.style.display = "";
  } else {
    component._ButtonBar.style.display = "none";
  }
  if (component._Save_Listener !== null) {
    component._Save.removeEventListener("click", component._Save_Listener);
  }
  component._Save.addEventListener("click", onSaveClick);
  component._Save_Listener = onSaveClick;
  if (component._Change_Listener !== null) {
    FormRendererUtilities.offchange($(component._Form), component._Change_Listener);
  }
  FormRendererUtilities.onchange($(component._Form), onChange);
  component._Change_Listener = onChange;
}
$.widget("nixps-cloudflow.TeamForm", $.Widget, {
  options: {
    /**
     * @name nixps-cloudflow.TeamForm#team
     * @description the team to display
     * @type {Object}
     * @default {}
     */
    team: {},
    /**
     * @name nixps-cloudflow.TeamForm#scopes
     * @description the scopes
     * @type {Object[]}
     * @default []
     */
    scopes: [],
    used_usernames: [],
    roles: [],
    formClasses: "",
    withMembers: false,
    showButtons: true
  },
  _create: function _create() {
    this.element.addClass(this.widgetFullName);
    TeamForm(this.element[0], this.options);
  },
  _setOptions: function _setOptions(options) {
    this._super(options);
    TeamForm(this.element[0], this.options);
  }
});
module.exports = TeamForm;

},{"../../../JODANebula/Framework/Component/Form/js/nixps-form-OrderedArrayInput.js":14,"../../../JODANebula/Framework/General/Component/js/functions/nixps-getComponent.js":19,"../../../JODANebula/Framework/General/Component/js/functions/nixps-setComponent.js":20,"../../../JODANebula/Framework/General/Form/js/nixps-FormRendererUtilities":25,"./functions/getMemberForm.js":220,"./functions/getTeamForm.js":221}],227:[function(require,module,exports){
"use strict";

var Team = require("./model/Team.js");
var TeamForm = require("./nixps-cloudflow-TeamForm.js");
$.widget("nixps-cloudflow.TeamFormImpl", $.Widget, {
  options: {
    /**
     * @name nixps-cloudflow.TeamForm#team
     * @description the team to display
     * @type {Object}
     * @default {}
     */
    team: null,
    withMembers: true,
    showButtons: false
  },
  _create: function _create() {
    var that = this;
    if (this.options.team === null) {
      this.options.team = Team.empty();
    }
    this.value = this.options.team;
    this.element.addClass(this.widgetFullName);
    this.element[0].addEventListener("changeteam", function (event) {
      that.value = event.detail;
      delete that.value.scope;
      if (Array.isArray(that.value.members)) {
        var members = that.value.members.reduce(function (pAcc, pMember) {
          if (typeof pMember.user_name === "string" && pMember.user_name.length > 0) {
            pAcc.push(pMember.user_name);
          }
          return pAcc;
        }, []);
        if (members.length > 0) {
          that.retrieving = true;
          api_async.users.list(["username", "in", members], [], function (pUsers) {
            for (var i = 0, len = pUsers.results.length; i < len; i++) {
              var user = pUsers.results[i];
              that.value.members.find(function (pMember) {
                if (pMember.user_name === user.username) {
                  pMember.full_name = user.fullname;
                  pMember.email_address = user.email;
                  return true;
                }
                return false;
              });
            }
            that.retrieving = false;
          });
        }
      } else {
        that.value.members = [];
      }
    });
    this._draw();
  },
  _draw: function _draw() {
    var that = this;
    TeamForm(that.element[0], that.options);
  },
  _setOptions: function _setOptions(options) {
    this._super(options);
    if (options.team !== undefined) {
      this.value = options.team;
    }
    this._draw();
  },
  isValid: function isValid(pReturnErrorMessage, pHighlightError) {
    if (this.retrieving === true) {
      if (pHighlightError === true) {
        $(this.element[0].children[0]).FormRenderer("showErrorMessages", [$.i18n._('nixps-cloudflow-FormRenderer.missing_fields_message')]);
      } else if (pReturnErrorMessage === true) {
        return $.i18n._('nixps-cloudflow-FormRenderer.missing_fields_message');
      } else {
        return false;
      }
    } else {
      return $(this.element[0].children[0]).FormRenderer("isValid", pReturnErrorMessage, pHighlightError);
    }
  },
  getValue: function getValue() {
    return this.value;
  },
  setValue: function setValue(pTeam) {
    this._setOptions({
      team: pTeam
    });
  }
});

},{"./model/Team.js":223,"./nixps-cloudflow-TeamForm.js":226}],228:[function(require,module,exports){
"use strict";

/* 
 * 
 *   created by guillaume on 01 jul, 2019 
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @namespace nixps-cloudflow.ScopesChooser
   * @description Draw a scopes panel
   * @example $("<div>").ScopesChooser({});
   */
  $.widget("nixps-cloudflow.ScopesChooser", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "scopeschooser",
    options: {
      /**
       * @desc The language of the user
       * @name nixps-cloudflow.ScopesChooser#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @description All the scopes
       * @name nixps-cloudflow.ScopesChooser#scopes
       * @type {Object}
       * @default null
       * @private
       **/
      scopes: []
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.ScopesChooser#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      var container = $("<div>").addClass("scopecontainer cf-dialog cf-dialog-content cf-dialog-fixwidth");
      this.element.append(container);
      container.append($("<div>").addClass("scope_searchpanel").append($("<input>").attr("type", "text").attr("placeholder", $.i18n._("nixps-cloudflow-CloudflowBar.search_scopes_placeholder")).addClass("cf-search-fullsearchfield scopechooser_searchinput")).append($("<div>").addClass("cf-icon cf-icon-x cf-icon-2x scopechooser_closebutton")));
      container.append($("<div>").addClass("scope_list"));

      // variables
      this._draw();
      container.find("input").trigger("focus");
      this._on(this.element, {
        "input .scopechooser_searchinput": this._searchScopeHandler,
        "click .scope_list .scope_item": this._applyScopeHandler,
        "click .scopechooser_closebutton": this._closeClickHandler
      });
    },
    _searchScopeHandler: function _searchScopeHandler(pEvent, pData) {
      var searchString = this.element.find(".scopechooser_searchinput").val();
      if (typeof searchString === "string" && searchString.length > 0) {
        var upperCaseSearchString = searchString.toUpperCase();
        this.element.find(".scope_item").hide().filter(function (i, e) {
          return $(this).text().toUpperCase().indexOf(upperCaseSearchString) >= 0;
        }).show();
      } else {
        this.element.find(".scope_item").show();
      }
    },
    _applyScopeHandler: function _applyScopeHandler(pEvent, pData) {
      var scopeDOM = $(pEvent.target).closest(".scope_item");
      var scopeData = scopeDOM.data("data-scope");
      if (scopeData._id === "*") {
        // all scopes
        api_util.set_cookie("scope", "", {
          path: "/"
        });
        window.location.reload();
      } else if (typeof scopeData._id === "string" && scopeData._id.length > 0) {
        api_util.set_cookie("scope", scopeData._id, {
          path: "/"
        });
        window.location.reload();
      }
    },
    _closeClickHandler: function _closeClickHandler(pEvent, pData) {
      this._trigger("close", null, {});
    },
    /**
     * @description Sraws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.ScopesChooser#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var list = this.element.find(".scope_list").empty();
      for (var i = 0; i < this.options.scopes.length; i++) {
        list.append($("<div>").addClass("scope_item cf-itemlist-clickable").text(this.options.scopes[i].name).data("data-scope", this.options.scopes[i]));
      }
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ScopesChooser#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.ScopesChooser#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {}
  });
})(jQuery);

},{}],229:[function(require,module,exports){
"use strict";

/* 
 * 
 *   created by guillaume on 27 jun, 2019 
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */
(function ($) {
  require("./nixps-cloudflow-ScopesChooser.js");
  require("../../FormElements/js/nixps-cloudflow-Image.js");
  var User = require("../../User/js/User.js");
  var License = require("../../License/js/License.js");
  var Version = require("../../Version/js/Version.js");
  var Consent = require("../../Consent/js/Consent.js");
  var Scopes = require("../../Scopes/js/Scopes.js");
  var CloudflowURL = require("../../CloudflowUtil/js/CloudflowURL.js");
  var MenuHandler = require("../../Menu/js/MenuHandler.js");
  var redirectToLogin = require("../../CloudflowInit/js/redirectToLogin.js");
  var logoutHandler = require("../../CloudflowInit/js/logout.js");
  var BadgeNumberUtil = require("../../PWA/js/BadgeNumberUtil.js");
  var Device = require("../../PWA/js/Device.js");
  var kRelativeGoBackPath = new RegExp("\\\.\\\./", "g");
  var kFirstParameterURLRegExp = new RegExp("[?]([^=]*)");
  var kMenuEditorURL = "/nebulaportal/menu_editor.html";
  var chatai = require("../../../nebulaportal/js/aichat/aichat.js");

  /**
   * @namespace nixps-cloudflow.SideBar
   * @description Draw a SideBar
   * @example $("<div>").SideBar({});
   * @version 1.1.0
   */
  $.widget("nixps-cloudflow.SideBar", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "sidebar",
    defaultElement: "<nav>",
    options: {
      /**
       * @desc The language of the user
       * @name nixps-cloudflow.SideBar#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @description The user object
       * @name nixps-cloudflow.SideBar#user
       * @type {User}
       * @default null
       **/
      user: null,
      /**
       * @description The license object
       * @name nixps-cloudflow.SideBar#license
       * @type {License}
       * @default null
       */
      license: null,
      /**
       * @description the versionobject, this can be used to speed up the pages
       * @name nixps-cloudflow.SideBar#versionObject
       * @type {Object}
       * @default null
       * @private
       **/
      versionObject: null,
      /**
       * @description The consent object
       * @name nixps-cloudflow.SideBar#consent
       * @type {Consent}
       * @default null
       */
      consent: null,
      /**
       * @description How must we show, display this panel
       * @name nixps-cloudflow.SideBar#displayMode
       * @type {String}
       * @default "auto"
       */
      displayMode: "auto",
      /**
       * @name nixps-cloudflow.SideBar#pageSelector
       * @description The selector of the page to retrieve the sidebar
       * @type {String}
       * @default "body, .cf-page, .cf-pageframe"
       */
      pageSelector: "body, .cf-page, .cf-pageframe",
      /**
       * @name nixps-cloudflow.SideBar#pageContentSelector
       * @description The css selector to the pagecontent, starting from the parent defined by option "parentSelector"
       * @type {String}
       * @default ".cf-pagecontent:first"
       */
      pageContentSelector: ".cf-pagecontent:first",
      /**
       * @name nixps-cloudflow.SideBar#navigationSource
       * @description How must we retrieve the source to build the naviagtionbuttons, 
       * you can choose between "default", "options", "url" 
       * @type {String}
       * @default "settings"
       */
      navigationSource: "settings",
      /**
       * @description The links / buttons to show
       * @name nixps-cloudflow.SideBar#naviagtionButtons
       * @type {Array.<Object>}
       * @default []
       */
      navigationButtons: [],
      /**
       * @name nixps-cloudflow.SideBar#navigationURL
       * @description The url to retrieve the buttons
       * @type {String}
       * @default ""
       */
      navigationURL: "",
      /**
       * @description If the url is a relative path and if this options is given, add this as relative path to make it a static one
       * @name nixps-cloudflow.SideBar#relativeBasePath
       * @type {String}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @description Which button must be selected
       * @name nixps-cloudflow.SideBar#selectedNavigationButton
       * @type {mixed}
       * @default null
       */
      selectedNavigationButton: null,
      /**
       * @description Must we show the quantum AI button or not?
       * @name nixps-cloudflow.SideBar#showAIButton
       * @type {Boolean}
       * @default false
       * @since 1.1.0
       */
      showAIButton: false,
      /**
       * @desc Must we show the bottom User icon
       * @name nixps-cloudflow.SideBar#showUserSection
       * @type {Boolean}
       * @default true
       */
      showUserSection: true,
      /**
       * @description must we show or hide the logout 
       * @name nixps-cloudflow.SideBar#enableLogout
       * @type {Mixed}
       * @default true
       */
      enableLogout: true,
      /**
       * @description Which type of logout do you want, added for customisation.
       * @name nixps-cloudflow.SideBar#logoutType
       * @type {String}
       * @default "logout_and_keep"
       */
      logoutType: "logout_and_keep",
      /**
       * @description The customised logout function
       * @name nixps-cloudflow.SideBar#logout
       * @type {Function}
       * @default undefined
       */
      logout: undefined,
      /**
       * @description Is the page located at a custom location and must we use an other way to logout ? 
       * @name nixps-cloudflow.SideBar#logoutCustomLocation
       * @type {Boolean}
       * @default false
       */
      logoutCustomLocation: false,
      /**
       * @description Must we show the scopes or not?
       * @name nixps-cloudflow.SideBar#enableScopes
       * @type {Boolean}
       * @default true
       */
      enableScopes: true,
      /**
       * @name nixps-cloudflow.SideBar#style_type
       * @description The type of style you want to apply
       * @type {String}
       * @private
       */
      style_type: "default",
      /**
       * @name nixps-cloudflow.SideBar#pagebuilderStyleClass
       * @description Which style class do you want to apply on the component
       * @type {String}
       * @default ""
       * @private
       */
      pagebuilderStyleClass: "",
      /**
       * @name nixps-cloudflow.SideBar#badgeRefreshRate
       * @description The number of milliseconds to refresh the badges
       * @type {Number}
       * @default 60000
       * @private
       */
      badgeRefreshRate: 60000,
      /**
      * @name nixps-cloudflow.SideBar#created
      * @description Callback when component has been created
      * @type {Function}
      * @private
      * @description function(){}
      */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.SideBar#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      var that = this;
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("cf-sidebar cf-zindex-content-over CloudflowStyle_" + this.options.style_type).attr("role", "navigation").attr("lang", this.options.language);

      // variables 
      this.badgeNumberTimerIDs = {};
      this.user;
      this.license;
      this.MenuHandler;
      this.alive = true;
      this.userDef;
      if ($.isPlainObject(this.options.user)) {
        this.userDef = User.fromJSON(this.options.user);
      } else if (this.options.user instanceof User) {
        this.userDef = this.options.user;
      } else {
        this.userDef = User.get();
      }
      this.licenserDef;
      if ($.isPlainObject(this.options.license)) {
        this.licenserDef = License.fromJSON(this.options.license);
      } else if (this.options.license instanceof License) {
        this.licenserDef = this.options.license;
      } else {
        this.licenserDef = License.get();
      }
      var isConsentNeeded = this.options.displayMode === "auto";
      this.consentDef;
      if (isConsentNeeded) {
        if ($.isPlainObject(this.options.consent)) {
          this.consentDef = Consent.fromJSON(this.options.license);
        } else if (this.options.consent instanceof Consent) {
          this.consentDef = this.options.consent;
        } else {
          this.consentDef = Consent.get();
        }
      }
      if (this.options.displayMode === "auto") {
        $.when(this.consentDef).done(function (pConsent) {
          that.options.displayMode = "extend";
          if (pConsent.isUserPreferencesAllowed("cf_sidebar_displaymode")) {
            var prevDisplay = api_util.get_cookie("cf_sidebar_displaymode");
            if (prevDisplay === "basic") {
              that.options.displayMode = "basic";
            }
          }
          that.setDisplayMode(true, false);
        });
      } else {
        this.setDisplayMode(true, false);
      }
      this.element.tooltip({
        content: function content() {
          var title = $(this).attr("title");

          // Escape title, since we"re going from an attribute to raw HTML
          return $("<a>").text(title).html();
        },
        items: ".sibebar_tooltip[title]",
        classes: {
          "ui-tooltip": "cf-tooltip cf-select-alike"
        },
        position: {
          my: "left+5px center",
          at: "right center",
          collision: "flipfit flip"
        }
      });
      $.when(this.userDef, this.licenserDef).then(function (pUser, pLicense) {
        if (that.alive === false) {
          return; // kill zombie
        }

        that.user = pUser;
        that.license = pLicense;

        // draw skeleton
        var container = $("<div>").addClass("cf-sidebar-container");
        var buttonTextClass = "";
        if (typeof that.options.pagebuilderStyleClass === "string" && that.options.pagebuilderStyleClass.length > 0) {
          that.element.addClass("cf-sidebar-customized nixps_styling_class_" + that.options.pagebuilderStyleClass);
          buttonTextClass = " nixps_styling_helperclass_" + that.options.pagebuilderStyleClass;
        }
        that.element.append(container);
        container.append($("<div>").addClass("cf-sidebar-buttons"));
        if (that.options.showAIButton === true && that.license.check("quatumai") === true) {
          container.append($("<button>").attr("type", "button").addClass("cf-sidebar-button cf-sidebar-ai noselect").attr("data-button-index", "ai").append($("<span>").addClass("cf-sidebar-button-icon cf-icon cf-icon-ai")).append($("<span>").addClass("cf-sidebar-button-text" + buttonTextClass).text($.i18n._("nixps-cloudflow-CloudflowBar.ai"))));
        }
        if (that.options.showUserSection === true) {
          var usernameText = that.user.getFullName();
          container.append($("<div>").addClass("cf-sidebar-button cf-sidebar-user noselect").attr("data-button-index", "user").append($("<span>").addClass("cf-sidebar-button-icon cf-icon cf-icon-user-circle")).append($("<span>").addClass("cf-sidebar-button-text" + buttonTextClass).text(usernameText)));
          if (pLicense.isTenant()) {
            container.find(".cf-icon-user-circle").removeClass("cf-icon-user-circle").addClass("cf-icon-user");
          }
        }
        that.element.append($("<div>").addClass("cf-sidebar-contenthover"));
        that._draw().always(function () {
          that.options.created();
        });
        that._on(that.element, {
          "click a": that._linkClickHandler,
          "click button.cf-sidebar-button:not(.cf-sidebar-button-active)": that._subMenuClickHandler,
          "click .cf-sidebar-ai.cf-sidebar-button": that._AIMenuClickHandler,
          "click .cf-sidebar-user.cf-sidebar-button": that._userMenuClickHandler,
          "click button.cf-sidebar-button.cf-sidebar-button-active": that._activeSubMenuClickHandler,
          "click .cf-sidebar-pagecontentHover": that._subcontainerClickHandler,
          "click .sidebar_scopesbutton": that._scopesListClickHandler,
          "click .sidebar_logoutbutton": that._logoutClickHandler,
          "mouseenter .cf-sidebar-button": function mouseenterCfSidebarButton(event) {
            $(event.currentTarget).addClass("cf-select-alike");
          },
          "mouseleave .cf-sidebar-button": function mouseleaveCfSidebarButton(event) {
            $(event.currentTarget).removeClass("cf-select-alike");
          }
        });
        that._windowResizeHandlerBind = _.debounce(that._windowResizeHandler.bind(that), 1000);
        window.addEventListener("resize", that._windowResizeHandlerBind);
        if (that.options.navigationSource === "settings" && that.user.isAdminAdmin()) {
          var scopeCookies = api_util.get_cookie("scope");
          if (typeof scopeCookies !== "string" || scopeCookies.length <= 0) {
            that.element.find(".cf-sidebar-user").after($("<span>").addClass("editmenubutton cf-icon cf-icon-pencil"));
            that._on(that.element, {
              "mousemove": that._editMouseMoveHandler,
              "mouseout": that._editMouseOutHandler,
              "click .editmenubutton": that._editMenuHandler
            });
          }
        }
      }, function (pError) {
        console.error(pError);
      });
    },
    _linkClickHandler: function _linkClickHandler(pEvent, pData) {
      var pageHoverContainer = $(pEvent.target).closest(".cf-sidebar-pagecontentHover");
      if (pageHoverContainer.length > 0) {
        // we are sub button
        if (this.element.find(".cf-sidebar-button-subselect").length > 0) {
          this._unSubSelectButton(this.element.find(".cf-sidebar-button-subselect"));
        }
        this._unselectButton(this.element.find(".cf-select").closest(".cf-sidebar-button"));
        var buttonIndex = pageHoverContainer.attr("data-button-index");
        if (typeof buttonIndex === "string" && buttonIndex.length > 0) {
          this._selectButton(this.element.find(".cf-sidebar-button[data-button-index='" + buttonIndex + "']"));
        }
      } else {
        // we are main button
        this._unselectButton(this.element.find(".cf-select").closest(".cf-sidebar-button"));
        this._selectButton($(pEvent.target).closest(".cf-sidebar-button"));
      }
    },
    _subMenuClickHandler: function _subMenuClickHandler(pEvent, pData) {
      this._openContent(pEvent);
    },
    _userMenuClickHandler: function _userMenuClickHandler(pEvent, pData) {
      if (pEvent.altKey === true) {
        this._AIMenuClickHandler(pEvent, pData);
        return false;
      }
      var buttonIndex = $(pEvent.target).closest(".cf-sidebar-button").attr("data-button-index");
      if (typeof buttonIndex === "string" && buttonIndex.length > 0) {
        if (this.element.find(".cf-sidebar-button-subselect").length > 0) {
          this._unselectButton(this.element.find(".cf-sidebar-button-active:not(.cf-sidebar-button-subselect)"));
          this._unSubSelectButton(this.element.find(".cf-sidebar-button-subselect"));
        }
        this.element.children(".cf-sidebar-contenthover").find(".cf-sidebar-pagecontentHover").addClass("cf-sidebar-pagecontentHover-hidden");
        this._subSelectButton(this.element.find(".cf-select").closest(".cf-sidebar-button"));
        this.element.addClass("cf-sidebar-open");
        this.element.children(".cf-sidebar-contenthover").find("[data-button-index='" + buttonIndex + "']").removeClass("cf-sidebar-pagecontentHover-hidden");
      }
    },
    _AIMenuClickHandler: function _AIMenuClickHandler(pEvent, pData) {
      var domElement = chatai({
        language: this.options.language
      });
      var jqueryDOM = $(domElement);
      jqueryDOM.css({
        zIndex: 1000000
      });
      if (Device.hasMobileWidth()) {
        jqueryDOM.css({
          position: "fixed",
          bottom: 0,
          right: 0,
          top: 0,
          left: 0
        });
      } else {
        jqueryDOM.css({
          position: "absolute",
          bottom: 100,
          right: 200,
          width: 500,
          height: 500,
          border: "1px solid gray",
          borderRadius: 4
        });
        jqueryDOM.draggable();
        jqueryDOM.resizable({
          handles: "n,e,s,se,w",
          minWidth: 460,
          minHeight: 500
        });
      }
      $("body").append(jqueryDOM);
      return false;
    },
    _subcontainerClickHandler: function _subcontainerClickHandler(pEvent, pData) {
      this._closeContentHover();
    },
    _activeSubMenuClickHandler: function _activeSubMenuClickHandler(pEvent) {
      if (this.element.hasClass("cf-sidebar-open")) {
        var openPanel = false;
        var buttonIndex = $(pEvent.target).closest(".cf-sidebar-button").attr("data-button-index");
        if (typeof buttonIndex === "string" && buttonIndex.length > 0) {
          if (this.element.children(".cf-sidebar-contenthover").find("[data-button-index='" + buttonIndex + "']").hasClass("cf-sidebar-pagecontentHover-hidden")) {
            // not same panel
            openPanel = true;
          }
        }
        this._closeContentHover();
        if (openPanel) {
          this._openContent(pEvent);
        }
      } else {
        this._openContent(pEvent);
      }
    },
    _outsideClickHandler: function _outsideClickHandler(pEvent, pData) {
      if ($(pEvent.target).closest(".nixps-cloudflow-SideBar").length === 0) {
        // hide all
        this._closeContentHover();
      }
    },
    /**
     * @description function run when user want to change of scopes
     * @function
     * @private
     * @name nixps-cloudflow.SideBar#_scopesListClickHandler
     * @param {Event} pEvent 
     * @param {Event} pData 
     */
    _scopesListClickHandler: function _scopesListClickHandler(pEvent, pData) {
      var that = this;
      var modalHide = $("<div>").addClass("chooserOverlay cf-zindex-modal cf-overlay-light cf-page");
      $("body").append(modalHide);
      var scopespanel = $("<div>").addClass("cf-pagecontent");
      if (this.options.displayMode === "extend") {
        scopespanel.addClass("cf-pagecontent-small");
      } else if (this.options.displayMode === "hidden") {
        scopespanel.addClass("cf-pagecontent-fullwidth");
      }
      /** @todo improve this */
      var parent;
      if (typeof this.options.pageSelector === "string" && this.options.pageSelector.length > 0) {
        parent = this.element.closest(this.options.pageSelector);
      } else {
        parent = $("body");
      }
      var pageContent = parent.find(this.options.pageContentSelector);
      if (pageContent.hasClass("cf-pagecontent-maximise")) {
        scopespanel.addClass("cf-pagecontent-maximise");
      }
      modalHide.append(scopespanel);
      var userScopes = this.user.getScopesObjectArray();
      if (userScopes.length === 0) {
        /* all scopes */
        // reask scopes, in case the scopes internal cache has been changed, like in the scopes manae page
        new Scopes().then(function (pResult) {
          scopespanel.ScopesChooser({
            language: that.options.language,
            scopes: pResult.getArray(),
            close: function close() {
              modalHide.remove();
            }
          });
        });
      } else {
        /* specific scopes */
        scopespanel.ScopesChooser({
          language: that.options.language,
          scopes: userScopes,
          close: function close() {
            modalHide.remove();
          }
        });
      }
    },
    /**
     * @description function runs when user want to log out
     * @function
     * @private
     * @name nixps-cloudflow.SideBar#_logoutClickHandler
     * @param {*} pEvent 
     * @param {*} pData 
     */
    _logoutClickHandler: function _logoutClickHandler(pEvent, pData) {
      var that = this;
      $.when(logoutHandler(false)).always(function (pReturn) {
        if (pReturn !== undefined && pReturn.redirect === false) {
          //do not redirect
        } else {
          if (typeof that.options.logout === "function") {
            that.options.logout();
          } else if (that.options.logoutType === "logout_and_keep") {
            if (that.options.logoutCustomLocation === true) {
              redirectToLogin(false);
            } else {
              redirectToLogin(true);
            }
          } else if (that.options.logoutType === "logout") {
            redirectToLogin();
          }
        }
      });
    },
    _openContent: function _openContent(pEvent) {
      var buttonIndex = $(pEvent.target).closest(".cf-sidebar-button").attr("data-button-index");
      if (typeof buttonIndex === "string" && buttonIndex.length > 0) {
        if (this.element.find(".cf-sidebar-button-subselect").length > 0) {
          this._unselectButton(this.element.find(".cf-sidebar-button-active:not(.cf-sidebar-button-subselect)"));
          this._unSubSelectButton(this.element.find(".cf-sidebar-button-subselect"));
        }
        this.element.children(".cf-sidebar-contenthover").find(".cf-sidebar-pagecontentHover").addClass("cf-sidebar-pagecontentHover-hidden");
        this._subSelectButton(this.element.find(".cf-select").closest(".cf-sidebar-button"));
        this._selectButton($(pEvent.target).closest(".cf-sidebar-button"));
        this.element.addClass("cf-sidebar-open");
        this.element.children(".cf-sidebar-contenthover").find("[data-button-index='" + buttonIndex + "']").removeClass("cf-sidebar-pagecontentHover-hidden");
      }
    },
    _closeContentHover: function _closeContentHover() {
      this.element.removeClass("cf-sidebar-open");
      if (this.element.find(".cf-sidebar-button-subselect").length > 0) {
        this._unselectButton(this.element.find(".cf-sidebar-button-active:not(.cf-sidebar-button-subselect)"));
        this._unSubSelectButton(this.element.find(".cf-sidebar-button-subselect"));
      }
      this.element.children(".cf-sidebar-contenthover").find(".cf-sidebar-pagecontentHover").addClass("cf-sidebar-pagecontentHover-hidden");
    },
    /**
    * @brief shows/hide the debug menu
     * @function
     * @private
     * @name nixps-cloudflow.SideBar#_editMouseMoveHandler
    */
    _editMouseMoveHandler: function _editMouseMoveHandler(pEvent) {
      if (pEvent.altKey && pEvent.shiftKey) {
        this.element.addClass("editMenu");
      } else {
        this.element.removeClass("editMenu");
      }
    },
    /**
     * @brief hides the debug menu
           * @function
           * @private
           * @name nixps-cloudflow.SideBar#_editMouseMoveHandler
     */
    _editMouseOutHandler: function _editMouseOutHandler(pEvent) {
      this.element.removeClass("editMenu");
    },
    _editMenuHandler: function _editMenuHandler(pEvent, pData) {
      window.location = kMenuEditorURL;
    },
    _windowResizeHandler: function _windowResizeHandler() {
      // the sub panels are possitioned at the bottom
      // resizing can place the subpanels at the wrong possition
      this._drawNavigationButtons(this.element.children(".cf-sidebar-container").children(".cf-sidebar-buttons").empty(), this.element.children(".cf-sidebar-contenthover").empty());
    },
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Sraws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.SideBar#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      return $.when(this._retrieveNavigationButtons(), this.licenserDef).then(function () {
        if (that.alive === false) {
          return; // kill zombie
        }

        return that._drawNavigationButtons(that.element.children(".cf-sidebar-container").children(".cf-sidebar-buttons").empty(), that.element.children(".cf-sidebar-contenthover").empty());
      }, function (pError) {
        console.error(pError);
      });
    },
    _retrieveNavigationButtons: function _retrieveNavigationButtons() {
      var that = this;
      var options;
      if (this.options.navigationSource === "options") {
        options = this.options.navigationButtons;
      } else {
        options = this.options.navigationURL;
      }
      // this.MenuHandler = new MenuHandler(this.options.navigationSource, options, this.options.relativeBasePath, this.user, this.options.license);
      // return this.MenuHandler.loadFromCache(true);
      return $.when(MenuHandler.createAndloadFromCache(this.options.navigationSource, options, this.options.relativeBasePath, this.user, this.options.license)).then(function (pMenuHandler) {
        that.MenuHandler = pMenuHandler;
      });
    },
    _drawNavigationButtons: function _drawNavigationButtons(pParent, pPageContentHoverParent) {
      var pButtons = this.MenuHandler.getButtons(this.user.getAttributesName());
      if (Array.isArray(pButtons) === false) {
        throw new Error("_drawButtons: parameter pButton must be an array");
      }
      var subpanelClasses = "";
      var buttonTextClass = "";
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        subpanelClasses = "nixps_styling_class_" + this.options.pagebuilderStyleClass;
        buttonTextClass = " nixps_styling_helperclass_" + this.options.pagebuilderStyleClass;
      }
      var button;
      // draw the buttons
      for (var i = 0; i < pButtons.length; i++) {
        if (pButtons[i].hasLink()) {
          var link = pButtons[i].getLink();
          if (pButtons[i].hasID() === false) {
            // translate cloudflow paths to actual links
            link = new CloudflowURL(this.options.relativeBasePath, link, true).getUploadPath();
          }
          button = $("<a>").addClass("cf-sidebar-button").attr("href", link);
          pParent.append(button);
          /** no tooltip for current active button**/
          this._drawButton(button, pButtons[i], i, "cf-sidebar-button-icon", "cf-sidebar-button-text" + buttonTextClass, true, 20);
        } else if (pButtons[i].hasSubButtons()) {
          button = $("<button>").attr("type", "button").attr("data-button-index", i).addClass("cf-sidebar-button");
          pParent.append(button);
          this._drawButton(button, pButtons[i], i, "cf-sidebar-button-icon", "cf-sidebar-button-text" + buttonTextClass, true, 20);
          var subContainer = $("<div>").attr("data-button-index", i).addClass("cf-sidebar-pagecontentHover cf-sidebar-pagecontentHover-hidden");
          pPageContentHoverParent.append(subContainer);
          var quitHoverContainer = $("<div>").addClass("cf-sidebar-quitehovercontainer");
          subContainer.append(quitHoverContainer);
          var subPanel = $("<div>").addClass("cf-sidebar-sub").addClass(subpanelClasses);
          quitHoverContainer.append(subPanel);
          var sub_buttons = pButtons[i].getSubButtons();
          var subButtonsDOMArray = new Array(sub_buttons.length + 1);
          subButtonsDOMArray[0] = $("<h4>").addClass("cf-sidebar-sub-header")._t(pButtons[i].getTranslatedText(this.options.language));
          var subButtonDOM = undefined;
          for (var j = 0; j < sub_buttons.length; j++) {
            var _link = sub_buttons[j].getLink();
            if (sub_buttons[j].hasID() === false || sub_buttons[j].getID().startsWith("cfapp-") && _link.startsWith("cloudflow://")) {
              // translate cloudflow paths to actual links
              _link = new CloudflowURL(this.options.relativeBasePath, _link, true).getUploadPath();
            }
            subButtonDOM = $("<a>").attr("href", _link).addClass("cf-sidebar-sub-button");
            this._drawButton(subButtonDOM, sub_buttons[j], i, "cf-sidebar-sub-icon", "cf-sidebar-sub-text" + buttonTextClass, false, 50);
            subButtonsDOMArray[j + 1] = subButtonDOM;
          }
          subPanel.append(subButtonsDOMArray);
          // position
          subContainer.css({
            "position": "fixed",
            "visibility": "hidden",
            "display": "inline",
            "top": -1000,
            "left": -1000,
            "zIndex": 0
          });
          var top = button.position().top - subPanel.height() / 2 + button.outerHeight() / 2;
          if (typeof top === "number") {
            if ($(document).height() < top + subPanel.height() + 20) {
              // preventing panel unther screen
              subPanel.css("bottom", 0);
              quitHoverContainer.css("bottom", -5);
            } else {
              if (top < 5) {
                top = 5;
              }
              subPanel.css("top", top);
              quitHoverContainer.css("top", top - 20);
            }
          }
          subContainer.css({
            "position": "",
            "visibility": "",
            "display": "",
            "top": "",
            "left": "",
            "zIndex": ""
          });
        }
      }
      var activeFound = this._setActiveButton();
      // fallback for redirected home pages
      if (activeFound === false && (typeof this.options.selectedNavigationButton !== "string" || this.options.selectedNavigationButton.length === 0)) {
        if (window.location.search === "") {
          var defaultButton = this.element.find(".cf-sidebar-button[href='/portal.cgi?home=1']").first();
          if (defaultButton.length === 0) {
            defaultButton = this.element.find(".cf-sidebar-button").first();
          }
          this._selectButton(defaultButton);
        }
      }
      var userSectionDef = this._drawUserSection(pPageContentHoverParent);
      this._trigger("buttondrawed", null, {});
      return userSectionDef;
    },
    /**
     * @description  draw one specific button
     * @function
     * @private
     * @name nixps-cloudflow.SideBar#_drawButton
     * @param {jQuery} pButton
     * @param {JSON} pButtonJSON
     * @param {Number} pButtonIndex
     * @param {String} pIconClass
     * @param {String} pTextClass
     * @param {Boolean} pAddTooltip
     * @return {undefined}
     */
    _drawButton: function _drawButton(pButtonDOM, pButton, pButtonIndex, pIconClass, pTextClass, pAddTooltip, pImageSize) {
      pButtonDOM.addClass(pButton.getClasses());
      var icon;
      if (pButton.getIconType() === "image" && pButton.hasImagePath()) {
        pButtonDOM.data("imagePath", pButton.getImagePath());
        if (pButton.hasSelectedImagePath()) {
          pButtonDOM.data("selectedImagePath", pButton.getSelectedImagePath());
        }
        icon = $("<div>").addClass(pIconClass).Image({
          "url": pButton.getImagePath(),
          "relativeBasePath": this.options.relativeBasePath,
          "width": "auto",
          "height": "auto",
          "maxWidth": pImageSize,
          "maxHeight": pImageSize
        });
      } else {
        icon = $("<span>").addClass(pIconClass).addClass(pButton.getIcon());
      }
      var buttonText = $("<span>").addClass(pTextClass).text(_.unescape(pButton.getTranslatedText(this.options.language)));
      pButtonDOM.append(icon).append(buttonText);
      if (pButton.hasID()) {
        pButtonDOM.attr("data-id", pButton.getID());
      }
      if (pButton.hasAction()) {
        pButtonDOM.attr("data-action", pButton.getAction());
      }
      if (pButton.hasName()) {
        pButtonDOM.attr("name", pButton.getName());
      }
      if (pAddTooltip === true) {
        if (pButton.hasTooltip()) {
          var tooltip = pButton.getTranslatedTooltip(this.options.language);
          pButtonDOM.data("tooltipText", tooltip);
          this._addTooltip(pButtonDOM, tooltip);
        }
        if (buttonText[0].scrollWidth > buttonText.width()) {
          this._addTooltip(buttonText, buttonText.text());
        }
      }
      if (pButton.hasBadgeNumber()) {
        var badge = $("<span>").addClass("cf-badgenumber");
        if (typeof pButton.getBadgeNumber() === "function") {
          this._drawBadgeNumber(badge, pButton.getBadgeNumber(), pButtonIndex);
        } else {
          var number = BadgeNumberUtil.parse(pButton.getBadgeNumber());
          if (number > 999) {
            badge.text("> 999").addClass("cf-badgenumber-max");
          } else {
            badge.text(number).addClass(function () {
              return "cf-badgenumber-length" + $(this).html().length;
            });
          }
        }
        pButtonDOM.append(badge);
      }
    },
    /**
     * @description draw the user panel
     * @function
     * @name nixps-cloudflow.SideBar#_drawUserSection
     * @private
     * @param {DOM} pPageContentHoverParent 
     */
    _drawUserSection: function _drawUserSection(pPageContentHoverParent) {
      var that = this;
      var subContainer = $("<div>").attr("data-button-index", "user").addClass("cf-sidebar-pagecontentHover cf-sidebar-pagecontentHover-hidden");
      pPageContentHoverParent.append(subContainer);
      var quitHoverContainer = $("<div>").addClass("cf-sidebar-quitehovercontainer");
      subContainer.append(quitHoverContainer);
      var subPanel = $("<div>").addClass("cf-sidebar-sub");
      var buttonTextClass = "";
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        subPanel.addClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
        buttonTextClass = " nixps_styling_helperclass_" + this.options.pagebuilderStyleClass;
      }
      quitHoverContainer.append(subPanel);
      subPanel.append($("<h3>").addClass("cf-title-subheading cf-sidebar-sub-header").text(this.user.getUserName()));
      subPanel.append($("<div>").addClass("cf-sidebar-sub-header sidebar_cloudflowversion"));
      this._getAndAddVersion();

      // logout
      if (this.options.enableLogout === true) {
        var subButton = $("<button>").attr("type", "button").addClass("cf-sidebar-sub-button sidebar_logoutbutton");
        subButton.append($("<span>").addClass("cf-sidebar-sub-icon cf-icon cf-icon-logout"));
        subButton.append($("<span>").addClass("cf-sidebar-sub-text" + buttonTextClass).text($.i18n._("nixps-cloudflow-CloudflowBar.logout")));
        subPanel.append(subButton);
      }

      // scopes
      var scopesDef = {};
      if (this.options.enableScopes === true) {
        var subButton = $("<button>").attr("type", "button").addClass("cf-sidebar-sub-button sidebar_scopesbutton").hide();
        subPanel.append(subButton);
        scopesDef = $.when(this.licenserDef, this.userDef).then(function () {
          if (that.alive === false) {
            return; // kill zombie
          }

          if (that.license.isDataLink() === false && that.license.check("max_cpu") !== false) {
            var scopes = that.user.getScopesObjectArray();
            if (scopes.length === 0 /* allscopes */ || scopes.length > 1 /* multiple specific scopes */) {
              var scopeLabel = "nixps-cloudflow-CloudflowBar.all_scopes";
              var currentScopeID = api_util.get_cookie("scope");
              for (var i = 0; i < scopes.length; i++) {
                if (scopes[i]._id === currentScopeID) {
                  scopeLabel = scopes[i].name;
                  break;
                }
              }
              var scopebutton = that.element.find(".sidebar_scopesbutton").empty();
              scopebutton.append($("<span>").addClass("cf-sidebar-sub-icon cf-icon cf-icon-scopes"));
              scopebutton.append($("<span>").addClass("cf-sidebar-sub-text" + buttonTextClass).text($.i18n._(scopeLabel)));
              scopebutton.css("display", "");
            } else {
              that.element.find(".sidebar_scopesbutton").remove();
            }
          } else {
            that.element.find(".sidebar_scopesbutton").remove();
          }
        }, function (pError) {
          if (pError !== undefined && pError.ignore_error === true) {
            // ignore, do not put on console
          } else {
            console.error(pError);
          }
          that.element.find(".sidebar_scopesbutton").remove();
        });
      }

      // user preferences
      var userPrefButton = $("<a>").attr("href", "/portal.cgi?user_preferences=1").addClass("cf-sidebar-sub-button").hide();
      userPrefButton.append($("<span>").addClass("cf-sidebar-sub-icon cf-icon cf-icon-user-preferences"));
      userPrefButton.append($("<span>").addClass("cf-sidebar-sub-text" + buttonTextClass).text($.i18n._("nixps-cloudflow-CloudflowBar.preferences")));
      subPanel.append(userPrefButton);
      $.when(this.licenserDef).then(function (pLicense) {
        if (that.alive === false) {
          return; // kill zombie
        }

        if (pLicense.check("max_cpu") && that.user.isExternalUser() === false) {
          userPrefButton.css("display", "");
        }
        // tenant environment info
        if (pLicense.isTenant() === true) {
          subPanel.children(".cf-title-subheading").text(that.user.getUserName() + " " + pLicense.getTenantName());
        }
      });

      //plugin suite settings
      var userPluginButton = $("<a>").attr("href", "http://127.0.0.1:9091/frameCGI/frame.cgi?frame.os=preferences").addClass("cf-sidebar-sub-button frame-os-setup-feature frame-os-setup-feature-inline-block").hide();
      userPluginButton.append($("<span>").addClass("cf-sidebar-sub-icon cf-icon cf-icon-plugin-suite"));
      userPluginButton.append($("<span>").addClass("cf-sidebar-sub-text" + buttonTextClass).text($.i18n._("nixps-cloudflow-CloudflowBar.frame_settings")));
      subPanel.append(userPluginButton);
      $.when(this.licenserDef).then(function (pLicense) {
        if (that.alive === false) {
          return; // kill zombie
        }

        if (pLicense.check("max_cpu")) {
          userPluginButton.css("display", "");
        }
      });
      quitHoverContainer.css("bottom", -12);
      return scopesDef;
    },
    _getAndAddVersion: function _getAndAddVersion() {
      if ($.isPlainObject(this.options.versionObject) && $.isEmptyObject(this.options.versionObject) === false) {
        var version = new Version(this.options.versionObject);
        this.element.find(".sidebar_cloudflowversion").text(version.toString());
      } else {
        var that = this;
        Version.get().then(function (version) {
          that.element.find(".sidebar_cloudflowversion").text(version.toString());
        });
      }
    },
    /**
     * @description Set classes, image and tooltip for the active button.
     * @function
     * @private
     * @name nixps-cloudflow.SideBar#_setActiveButton
     * @return {Boolean} Is a button active
     */
    _setActiveButton: function _setActiveButton() {
      var that = this;
      var foundActiveButton = false;

      // first unselect all <a> links and <buttons>
      this.element.find(".cf-sidebar-button").each(function (index, button) {
        that._unselectButton($(button));
      });
      this.element.find("a.cf-sidebar-button").each(function (idx, button) {
        var link = $(button).attr("href");
        var buttonID = $(button).attr("data-id");
        var actionName = $(button).attr("data-action");
        if (typeof link === "string" && that._isButtonActive(link, buttonID, actionName) === true) {
          foundActiveButton = true;
          that._selectButton($(button));
          return false;
        }
      });
      if (foundActiveButton === false) {
        this.element.find("a.cf-sidebar-sub-button").each(function (idx, button) {
          var link = $(button).attr("href");
          var buttonIndex = $(button).closest("[data-button-index]").attr("data-button-index");
          var parentButton;
          if (typeof buttonIndex === "string" && buttonIndex.length > 0) {
            parentButton = that.element.find("button.cf-sidebar-button[data-button-index='" + buttonIndex + "']");
          } else {
            console.error("no button index found!");
            return true;
          }
          var actionName = $(button).attr("data-action");
          var buttonID = $(button).attr("data-id");
          if (typeof link === "string" && that._isButtonActive(link, buttonID, actionName) === true) {
            foundActiveButton = true;
            that._selectButton(parentButton);
            return false;
          }
        });
      }
      return foundActiveButton;
    },
    /**
     * @description Set pButton as the active button
     * @param {jQuery} pButton
     * @private
     * @function
     * @name nixps-cloudflow.SideBar#_unselectButton
     */
    _selectButton: function _selectButton(pButton) {
      pButton.addClass("cf-sidebar-button-active cf-select");
      this._removeTooltip(pButton);
      var img = pButton.data("selectedImagePath");
      if (typeof img === "string" && img.length > 0) {
        pButton.find(".cf-sidebar-button-icon.nixps-cloudflow-Image").Image("option", "url", img);
      }
    },
    /**
     * @description Set pButton as the inactive button
     * @param pButton
     * @private
     * @function
     * @name nixps-cloudflow.SideBar#_unselectButton
     */
    _unselectButton: function _unselectButton(pButton) {
      pButton.removeClass("cf-sidebar-button-active").removeClass("cf-select");
      if (this.options.displayMode !== "extend") {
        this._addTooltip(pButton, pButton.data("tooltipText"));
      } else {
        this._removeTooltip(pButton);
      }
      var img = pButton.data("imagePath");
      if (typeof img === "string" && img.length > 0) {
        pButton.find(".cf-sidebar-button-icon.nixps-cloudflow-Image").Image("option", "url", img);
      }
    },
    _subSelectButton: function _subSelectButton(pButton) {
      pButton.addClass("cf-sidebar-button-subselect");
    },
    _unSubSelectButton: function _unSubSelectButton(pButton) {
      pButton.removeClass("cf-sidebar-button-subselect");
    },
    /**
     * @description Add the tooltip on pButton
     * @name nixps-cloudflow.SideBar#_addTooltip
     * @param pButton
     * @param tooltip
     * @private
     */
    _addTooltip: function _addTooltip(pButton, tooltip) {
      if (tooltip !== undefined) {
        pButton.attr("title", tooltip).addClass("sibebar_tooltip");
      }
    },
    /**
     * @desc Remove the tooltip on pButton
     * @fucntion
     * @name nixps-cloudflow.SideBar#_removeTooltip
     * @param pButton
     * @private
     */
    _removeTooltip: function _removeTooltip(pButton) {
      if (pButton.attr("title") !== undefined) {
        // pButton.tooltip("destroy").removeAttr("title");
        pButton.removeClass("sibebar_tooltip").removeAttr("title");
      }
    },
    _isButtonActive: function _isButtonActive(pLink, pButtonID, pButtonActionName) {
      // Try to match with the link with the window url in case no active option is passed
      if (typeof this.options.selectedNavigationButton !== "string" || this.options.selectedNavigationButton.length === 0) {
        var hash = window.location.hash;
        if (pLink.indexOf("#") > 0 && typeof hash === "string" && hash.length > 0 && typeof window.location.href.endsWith === "function" && window.location.href.endsWith(pLink.replace(kRelativeGoBackPath, "")) === false) {
          return false; // hashtags must be equal
        }

        var firstParameter = window.location.search.match(kFirstParameterURLRegExp);
        if (Array.isArray(firstParameter) === true && firstParameter.length > 0 && firstParameter[0] === "?job") {
          if (typeof window.location.href.endsWith === "function" && window.location.href.endsWith(pLink.substring(pLink.indexOf("?")))) {
            return true;
          }
        } else if (Array.isArray(firstParameter) === true && firstParameter.length > 0 && firstParameter[0] !== "?connector" &&
        // no pagebuilder pages 
        pLink.indexOf(firstParameter[0]) >= 0) {
          // is parameter also first parameter in link?
          return true;
        } else if (typeof window.location.href === "string") {
          if (typeof window.location.href.endsWith === "function" && window.location.href.endsWith(pLink.replace(kRelativeGoBackPath, "")) === true) {
            return true;
          } else if (pLink.indexOf("?") === -1 && window.location.href.indexOf(pLink + "?") >= 0) {
            return true;
          }
        }
      } else {
        if (pButtonActionName === undefined) {
          pButtonActionName = pButtonID;
        }
        if (this.options.selectedNavigationButton === pButtonActionName) {
          return true;
        }
      }
      return false;
    },
    _recalcEllipsisTooltips: function _recalcEllipsisTooltips() {
      var that = this;
      this.element.children(".cf-sidebar-container").children(".cf-sidebar-buttons").children(".cf-sidebar-button").each(function () {
        var textDOM = $(this).children(".cf-sidebar-button-text");
        if (textDOM.is("[title]") === false) {
          if (textDOM[0].scrollWidth > textDOM.width()) {
            that._addTooltip(textDOM, textDOM.text());
          }
        }
      });
    },
    addBadge: function addBadge(pButtonIdentifier, pBadgeType, pContentNumber) {
      var buttonDOM;
      if (typeof pButtonIdentifier === "number" && pButtonIdentifier >= 0) {
        buttonDOM = this.element.children(".cf-sidebar-container").children(".cf-sidebar-buttons").children(".cf-sidebar-button").eq(pButtonIdentifier);
      } else if (typeof pButtonIdentifier === "string" && pButtonIdentifier.length > 0) {
        buttonDOM = this.element.children(".cf-sidebar-container").children(".cf-sidebar-buttons").children(".cf-sidebar-button[data-action='" + pButtonIdentifier + "']").eq(0);
        if (buttonDOM.length === 0) {
          buttonDOM = this.element.children(".cf-sidebar-container").children(".cf-sidebar-buttons").children(".cf-sidebar-button[data-id='" + pButtonIdentifier + "']").eq(0);
        }
        var index = buttonDOM.prevAll(".cf-sidebar-button").length;
      }
      if (buttonDOM.length === 0) {
        console.error("SideBar, could not retrieve the button to add the badge");
        return false;
      }
      var badge = $("<span>").addClass("cf-badgenumber");
      if (pBadgeType === "error") {
        badge.addClass("cf-badgenumber-error");
      } else if (pBadgeType === "warning") {
        badge.addClass("cf-badgenumber-warning");
      }
      var number = BadgeNumberUtil.parse(pContentNumber);
      if (number === null) {
        badge.addClass("cf-badgenumber-length1").append($("<span>").addClass("cf-badgenumber-value").text("!"));
      } else if (number > 999) {
        badge.addClass("cf-badgenumber-max").append($("<span>").addClass("cf-badgenumber-value").text("> 999"));
      } else {
        badge.addClass(function () {
          return "cf-badgenumber-length" + $(this).html().length;
        }).append($("<span>").addClass("cf-badgenumber-value").text(number));
      }
      buttonDOM.append(badge);
    },
    removeBadge: function removeBadge(pButtonIdentifier) {
      var buttonDOM;
      if (typeof pButtonIdentifier === "number" && pButtonIdentifier >= 0) {
        buttonDOM = this.element.children(".cf-sidebar-container").children(".cf-sidebar-buttons").children(".cf-sidebar-button").eq(pButtonIdentifier);
        clearTimeout(this.badgeNumberTimerIDs[pButtonIdentifier]);
        delete this.badgeNumberTimerIDs[pButtonIdentifier];
      } else if (typeof pButtonIdentifier === "string" && pButtonIdentifier.length > 0) {
        buttonDOM = this.element.children(".cf-sidebar-container").children(".cf-sidebar-buttons").children(".cf-sidebar-button[data-action='" + pButtonIdentifier + "']").eq(0);
        if (buttonDOM.length === 0) {
          buttonDOM = this.element.children(".cf-sidebar-container").children(".cf-sidebar-buttons").children(".cf-sidebar-button[data-id='" + pButtonIdentifier + "']").eq(0);
        }
        var index = buttonDOM.prevAll(".cf-sidebar-button").length;
        if (index >= 0) {
          clearTimeout(this.badgeNumberTimerIDs[index]);
          delete this.badgeNumberTimerIDs[index];
        }
      }
      buttonDOM.children(".cf-badgenumber").remove();
    },
    /**
     * @description Function that do the drawing and refreshing of the badgenumbers
     * @function
     * @private
     * @name nixps-cloudflow.TopNavigation#_drawBadgeNumber
     * @param {type} pContainer
     * @param {type} pCallingFct
     * @param {type} pButtonIndex
     * @return {undefined}
     */
    _drawBadgeNumber: function _drawBadgeNumber(pContainer, pCallingFct, pButtonIndex) {
      clearTimeout(this.badgeNumberTimerIDs[pButtonIndex]);
      var that = this;
      $.when(pCallingFct(this.user, this.license)).done(function (pResults) {
        if (that.alive === false) {
          return; // kill zombie
        }
        // reset ui
        pContainer.removeClass("cf-badgenumber-length1 cf-badgenumber-length2 cf-badgenumber-length3").removeClass("cf-badgenumber-max");
        // color of classes
        var className;
        if (pResults && pResults.severity !== undefined) {
          if (pResults.severity === "error") {
            className = "cf-badgenumber-error";
          } else if (pResults.severity === "warning") {
            className = "cf-badgenumber-warning";
          }
        }
        // calc the number to show
        var number = BadgeNumberUtil.parse(pResults);
        if (number !== null) {
          // set color
          pContainer.addClass(className);
          // set the number
          if (number > 999) {
            pContainer.text("> 999").addClass("cf-badgenumber-max");
          } else {
            pContainer.text(number).addClass(function () {
              return "cf-badgenumber-length" + $(this).html().length;
            });
          }
        } else {
          // no number found
          pContainer.text("");
        }
        that._badgeNumberTrigger(pContainer, pCallingFct, pButtonIndex);
      }).fail(function (pError, pErrorData) {
        if (that.alive === false) {
          return; // kill zombie
        }

        if (pError === "ajax call failed" && pErrorData !== undefined) {
          pError = pErrorData;
        } else if (pErrorData === "error" && $.isPlainObject(arguments[3])) {
          pError = arguments[3];
        }
        console.error(pError);
        // in case of error
        // reset
        pContainer.removeClass("cf-badgenumber-length1 cf-badgenumber-length2 cf-badgenumber-length3").removeClass("cf-badgenumber-max").text("");
        // do not retry for some specific errors
        if (pError !== undefined) {
          if (pError.error_code === "no_permission" || pError.error_code === "unknown_command") {
            return;
          }
          if (pError !== undefined && pError.error_code === "http_error" && pError.http_result !== undefined && pError.http_result.status >= 500) {
            return;
          }
        }
        // if fails, than retry
        that._badgeNumberTrigger(pContainer, pCallingFct, pButtonIndex);
      });
    },
    /**
     * @description funtion to handle refresh loop
     * @function
     * @private
     * @name nixps-cloudflow.SideBar#_badgeNumberTrigger
     * @param {DOM} pContainer 
     * @param {Function} pCallingFct 
     * @param {Number} pButtonIndex 
     */
    _badgeNumberTrigger: function _badgeNumberTrigger(pContainer, pCallingFct, pButtonIndex) {
      clearTimeout(this.badgeNumberTimerIDs[pButtonIndex]);
      if (typeof this.options.badgeRefreshRate === "number" && this.options.badgeRefreshRate > 0) {
        this.badgeNumberTimerIDs[pButtonIndex] = this._delay(function () {
          if (this.alive === false) {
            return; // kill zombies
          }

          if (Device.continuePolling(this.uuid)) {
            this._drawBadgeNumber(pContainer, pCallingFct, pButtonIndex);
          } else {
            this._badgeNumberTrigger(pContainer, pCallingFct, pButtonIndex);
          }
        }, Device.getPollingFactor(this.uuid) * this.options.badgeRefreshRate);
      }
    },
    /**
     * @description  change the current display mode, visible or not, or extended
     * @function
     * @private
     * @name nixps-cloudflow.SideBar#setDisplayMode
     * @return {undefined}
     */
    setDisplayMode: function setDisplayMode(pAddTransitionClass, pTriggerEvent) {
      // reset
      this.element.removeClass("cf-sidebar-hidden cf-sidebar-extend");
      var parent;
      if (typeof this.options.pageSelector === "string" && this.options.pageSelector.length > 0) {
        parent = this.element.closest(this.options.pageSelector);
      } else {
        parent = $("body");
      }
      var pageContent = parent.find(this.options.pageContentSelector);
      var detailspanel = pageContent.siblings("#detailspanel");
      pageContent.removeClass("cf-pagecontent-fullwidth cf-pagecontent-small");
      detailspanel.removeClass("cf-detailspanel-small");
      var bottombar = parent.children(".cf-bottombar").last();
      if (bottombar.length === 0) {
        bottombar = parent.find(".cf-bottombar").first();
      }
      bottombar.removeClass("cf-bottombar-fullwidth cf-bottombar-small");
      // set up correct stylings classes
      if (this.options.displayMode === "extend") {
        this.element.addClass("cf-sidebar-extend");
        pageContent.addClass("cf-pagecontent-small");
        detailspanel.addClass("cf-detailspanel-small");
        bottombar.addClass("cf-bottombar-small");
        this._delay(function () {
          this._recalcEllipsisTooltips();
        }, 600);
      } else if (this.options.displayMode === "hidden") {
        this.element.addClass("cf-sidebar-hidden");
        pageContent.addClass("cf-pagecontent-fullwidth");
        detailspanel.addClass("cf-detailspanel-fullwidth");
        bottombar.addClass("cf-bottombar-fullwidth");
      }
      this._setActiveButton();
      if (pAddTransitionClass === true) {
        this._delay(function () {
          parent.addClass("cf-transition");
        });
      }
      if (pTriggerEvent === true) {
        this._delay(function () {
          // inform the width has been changed, used in pagebuilder editor
          this._trigger("changewidth", null, {});
        }, 600); // 100 miliseconds longer then the animation
      }
    },

    _setOptions: function _setOptions(options) {
      var that = this;
      var redraw = false;
      if (options.enableScopes !== undefined && options.enableScopes !== this.options.enableScopes) {
        redraw = true;
      }
      if (options.license !== undefined && options.license !== this.options.license) {
        // sometimes we provide exactly the same object references, 
        // skip this easy case
        redraw = true; // when update license
      }

      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      this._controlOptions();
      if (options.displayMode !== undefined) {
        this.setDisplayMode(false, true);
      }
      if (options.navigationSource !== undefined || options.navigationButtons !== undefined || options.navigationURL !== undefined || options.selectedNavigationButton !== undefined) {
        this._draw();
      }
      if (redraw === true) {
        this._draw();
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.SideBar#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      var buttonTextClass = "";
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        buttonTextClass = " nixps_styling_helperclass_" + this.options.pagebuilderStyleClass;
      }
      if (pKey === "disabled") {
        if (pValue !== this.options.disabled) {
          if (pValue === true) {
            this.element.addClass("cf-sidebar-disabled");
            this.element.find(".cf-sidebar-button").addClass("cf-disabled").filter("button").prop("disabled", true);
            this._closeContentHover();
          } else {
            this.element.removeClass("cf-side-disabled");
            this.element.find(".cf-sidebar-button").removeClass("cf-disabled").filter("button").prop("disabled", false);
          }
        }
      }
      if (pKey === "showAIButton") {
        if (pValue !== this.options.showAIButton) {
          this.options.showAIButton = pValue;
          if (pValue === true) {} else {}
        }
      }
      if (pKey === "showUserSection") {
        if (pValue !== this.options.showUserSection) {
          this.options.showUserSection = pValue;
          if (pValue === true) {
            this.element.children(".cf-sidebar-container").append($("<div>").addClass("cf-sidebar-button cf-sidebar-user noselect").attr("data-button-index", "user").append($("<span>").addClass("cf-sidebar-button-icon cf-icon cf-icon-user-circle")).append($("<span>").addClass("cf-sidebar-button-text" + buttonTextClass).text(this.user.getFullName())));
          } else {
            this.element.children(".cf-sidebar-container").children(".cf-sidebar-user").remove();
          }
        }
      }
      if (pKey === "enableLogout") {
        if (pValue !== this.options.enableLogout) {
          if (pValue === false) {
            this.element.find(".sidebar_logoutbutton").remove();
          } else if (pValue === true) {
            var subButton = $("<button>").attr("type", "button").addClass("cf-sidebar-sub-button sidebar_logoutbutton");
            subButton.append($("<span>").addClass("cf-sidebar-sub-icon cf-icon cf-icon-logout"));
            subButton.append($("<span>").addClass("cf-sidebar-sub-text" + buttonTextClass).text($.i18n._("nixps-cloudflow-CloudflowBar.logout")));
            this.element.find(".cf-sidebar-pagecontentHover .cf-sidebar-quitehovercontainer .cf-sidebar-sub").prepend(subButton);
          }
        }
      }
      if (pKey === "license") {
        this.options.license = pValue;
        if ($.isPlainObject(this.options.license)) {
          this.licenserDef = License.fromJSON(this.options.license);
        } else if (this.options.license instanceof License) {
          this.licenserDef = this.options.license;
        }
        var that = this;
        $.when(this.licenserDef).done(function (pLicense) {
          that.license = pLicense;
        });
      }
      if (pKey === "pagebuilderStyleClass") {
        if (pValue !== this.options.pagebuilderStyleClass) {
          this.element.find(".nixps_styling_class_" + this.options.pagebuilderStyleClass).removeClass("nixps_styling_class_" + this.options.pagebuilderStyleClass).addClass("nixps_styling_class_" + pValue);
          this.element.find(".nixps_styling_helperclass_" + this.options.pagebuilderStyleClass).removeClass("nixps_styling_helperclass_" + this.options.pagebuilderStyleClass).addClass("nixps_styling_helperclass_" + pValue);
          this.element.removeClass("nixps_styling_class_" + this.options.pagebuilderStyleClass).addClass("nixps_styling_helperclass_" + pValue);
          if (typeof pValue === "string" && pValue.length > 0) {
            this.element.addClass("cf-sidebar-customized");
          } else {
            this.element.removeClass("cf-sidebar-customized");
          }
        }
      }
      this._superApply(arguments);
      if (pKey === "selectedNavigationButton") {
        this._setActiveButton();
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.SideBar#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error(this.widgetName + " input option language must be a not empty string");
      }
      if (typeof this.options.displayMode !== "string") {
        throw new Error(this.widgetName + " input option displayMode must be a string");
      }
      if (typeof this.options.style_type !== "string" || this.options.style_type.length <= 0) {
        throw new Error(this.widgetName + " input option style_type must be a not empty string");
      }
    },
    _destroy: function _destroy() {
      var that = this;
      this.alive = false;
      this.element.removeClass(this.widgetFullName).removeClass("cf-sidebar cf-zindex-content-over CloudflowStyle_" + this.options.style_type).removeAttr("role").removeAttr("lang");
      $.each(this.badgeNumberTimerIDs, function (buttonIndex, timeoutID) {
        clearTimeout(timeoutID);
      });
      if (this.element.data("uiTooltip") !== undefined) {
        this.element.tooltip("destroy");
      }
      window.removeEventListener("resize", this._windowResizeHandlerBind);
      this._superApply(arguments);
    },
    clear: function clear() {
      if (this.element.data("uiTooltip") !== undefined) {
        this.element.tooltip("destroy");
      }
      MenuHandler.clear();
    }
  });
})(jQuery);

},{"../../../nebulaportal/js/aichat/aichat.js":401,"../../CloudflowInit/js/logout.js":66,"../../CloudflowInit/js/redirectToLogin.js":69,"../../CloudflowUtil/js/CloudflowURL.js":80,"../../Consent/js/Consent.js":96,"../../FormElements/js/nixps-cloudflow-Image.js":149,"../../License/js/License.js":175,"../../Menu/js/MenuHandler.js":192,"../../PWA/js/BadgeNumberUtil.js":197,"../../PWA/js/Device.js":198,"../../Scopes/js/Scopes.js":204,"../../User/js/User.js":268,"../../Version/js/Version.js":269,"./nixps-cloudflow-ScopesChooser.js":228}],230:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 * 
 *   created by guillaume on 27 jun, 2019 
 */
(function ($) {
  require("../../../common/js/myjQueryPlugins.js");
  require("../../LicenseBanner/js/nixps-cloudflow-LicenseBanner.js");
  require("../../FormElements/js/nixps-cloudflow-Image.js");
  require("../../FormElements/js/nixps-cloudflow-Select.js");
  require("../../../common/DropdownList/js/nixps-DropdownList.js");
  var Consent = require("../../Consent/js/Consent.js");
  function getDisplayMode() {
    return api_util.get_cookie("cf_sidebar_displaymode");
  }
  function saveDisplayMode(pDisplayMode) {
    var options = {
      expires: 365,
      path: "/",
      samesite: "Strict"
    };
    return api_util.set_cookie("cf_sidebar_displaymode", pDisplayMode, options);
  }
  var kNoTagValue = "Any";

  /**
   * @namespace nixps-cloudflow.TopBar
   * @description Draw a topbar
   * @example $("<div>").TopBar({});
   * @version 1.1.0
   */
  $.widget("nixps-cloudflow.TopBar", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "topbar",
    defaultElement: "<header>",
    options: {
      /**
       * @description The language of the user
       * @name nixps-cloudflow.TopBar#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @description The user object
       * @name nixps-cloudflow.TopBar#user
       * @type {User}
       * @default null
       */
      user: null,
      /**
       * @description The title text to be displayed
       * @name nixps-cloudflow.TopBar#titleText
       * @type {String}
       * @default null
       */
      titleText: null,
      /**
       * @description The title to be displayed
       * @name nixps-cloudflow.TopBar#titleContent
       * @type {String}
       * @default ""
       */
      titleContent: "",
      /**
       * @description The tooltip to be used on the title
       * @name nixps-cloudflow.TopBar#titleTooltip
       * @type {String}
       * @default ""
       */
      titleTooltip: "",
      /**
       * @description The classes to be added to the title
       * @name nixps-cloudflow.TopBar#titleClasses
       * @type {String}
       * @default ""
       * @private
       */
      titleClasses: "",
      /**
       * @description The icon to show
       * @name nixps-cloudflow.TopBar#titleImageURL
       * @type {String}
       * @default null
       */
      titleImageURL: null,
      /**
       * @description If the url is a relative path and if this options is given, add this as relative path to make it a static one
       * @name nixps-cloudflow.TopBar#relativeBasePath
       * @type {String}
       * @default ""
      */
      relativeBasePath: "",
      /**
       * @name nixps-cloudflow.TopBar#pageSelector
       * @description The selector of the page to retrieve the sidebar
       * @type {String}
       * @default "body, .cf-page, .cf-pageframe"
       */
      pageSelector: "body, .cf-page, .cf-pageframe",
      /**
       * @name nixps-cloudflow.TopBar#enableSideBarSelector
       * @description Must we show the hamburger icon or not?
       * @type {Boolean}
       * @default true
       */
      enableSideBarSelector: true,
      /**
       * @name nixps-cloudflow.TopBar#sideBarSelector
       * @description The jQuery selector to find the connected sidebar
       * @type {String}
       * @default "auto"
       */
      sideBarSelector: "auto",
      /**
       * @name nixps-cloudflow.TopBar#minimise
       * @description Must we minimise or not?
       * @type {Boolean}
       * @default false
       */
      minimise: false,
      /**
       * @name nixps-cloudflow.TopBar#enableInlineSearch
       * @description Must we display the inline search ui 
       * @type {Boolean}
       * @default false
       */
      enableInlineSearch: false,
      /**
       * @name nixps-cloudflow.TopBar#enableSearchButton
       * @description Must we see the search icon as a button or not?
       * @type {Boolean}
       * @default false
       */
      enableSearchButton: false,
      /**
       * @name nixps-cloudflow.TopBar#searchButtonTooltip
       * @description The tooptip for the search button
       * @type {String}
       * @default ""
       */
      searchButtonTooltip: "",
      /**
       * @name nixps-cloudflow.TopBar#searchThrottleDelay
       * @description The search throttle delay in milleseconds
       * @default 800
       * @type {Number}
       */
      searchThrottleDelay: 800,
      /**
       * @name nixps-cloudflow.TopBar#searchTags
       * @description The search fast tags for dedicated specialised searching, the parent must handle the search
       * @type {Array.<String>}
       * @default undefined
       * @since 1.1.0
       */
      searchTags: undefined,
      /**
       * @name nixps-cloudflow.TopBar#buttons
       * @description The buttons to be shown at the right side of the bar
       * @type {Array.<Object>}
       * @default []
       */
      buttons: [],
      /**
       * @private
       * @name nixps-cloudflow.TopBar#buttonTooltipOptions
       * @description the options object of the topbar tooltip
       * @type {Object}
       */
      buttonTooltipOptions: {
        tooltipClass: "cf-tooltip cf-tooltip-secondary",
        classes: {
          "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
        },
        position: {
          my: "center bottom-15px",
          at: "center center",
          collision: "flipfit flip"
        }
      },
      /**
       * @private
       * @name nixps-cloudflow.TopBar#disabledButtonTooltipOptions
       * @description the tooltip options of deisabled buttons, undefined to hide, object to show them
       * @type {Object}
       * @default undefined
       */
      disabledButtonTooltipOptions: undefined,
      /**
       * @name nixps-cloudflow.TopBar#style_type
       * @description The type of style you want to apply
       * @type {String}
       * @private
       */
      style_type: "default",
      /**
       * @name nixps-cloudflow.TopBar#topbarButtonContainerClasses
       * @description Classes added to the topbar buttons container
       * @type {String}
       * @default ""
       */
      topbarButtonContainerClasses: "",
      /**
       * @name nixps-cloudflow.TopBar#pagebuilderStyleClass
       * @description Which style class do you want to apply on the component
       * @type {String}
       * @default ""
       * @private
       */
      pagebuilderStyleClass: "",
      /**
       * @name nixps-cloudflow.TopBar#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {},
      alignCenter: false
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.TopBar#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      var that = this;
      this._controlOptions();
      this.element.addClass(this.widgetFullName).attr("data-uuid", this.uuid).addClass("cf-topbar").addClass("CloudflowStyle_" + this.options.style_type);
      this.element.addClass("nixps-cloudflow-TopBar");
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        this.element.addClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
      }
      if (this.element.is("header") === false) {
        this.element.attr("role", "banner");
      }

      // variables
      this.alive = true;
      this.minimalPrevDisplayState;
      this.consent;
      this.toggleDetailsPanelState;
      this.dropdownOverrides = [];
      var consentDef = Consent.get().then(function (pConsent) {
        that.consent = pConsent;
      });

      // sceleton
      var startSideBarIcon = "";
      if (this.options.enableSideBarSelector === true && this.options.sideBarSelector !== false) {
        // mamange only ui of button
        $.when(consentDef).then(function () {
          if (that.alive === false) {
            return; // zombie
          }

          startSideBarIcon = "cf-icon-hamburger";
          if (that.consent.isUserPreferencesAllowed("cf_sidebar_displaymode")) {
            var prevDisplay = getDisplayMode();
            if (prevDisplay === "extend" || prevDisplay === null) {
              startSideBarIcon = "cf-icon-hamburger";
            } else {
              startSideBarIcon = "cf-icon-hamburger-short";
            }
          }
          // can be async or sync
          that.element.children(".topbar_toggle_sidebar").addClass(startSideBarIcon);
        });
      }
      this.element.empty();
      if (this.options.enableSideBarSelector === true) {
        // consent can be sync
        this.element.append($("<span>").addClass("topbar_toggle_sidebar cf-topbar-logo cf-icon " + startSideBarIcon));
      }
      this.element.append($("<span>").addClass("cf-topbar-title").attr({
        "role": "heading",
        "aria-level": 1
      }));
      this.element.append($("<span>").addClass("cf-topbar-titleicon").hide());
      this.alignment = this.options.alignCenter === true ? "cf-topbar-aligncenter" : "cf-topbar-alignright";
      var topbarButtonsContainer = $("<div>").addClass("topbar_buttons ".concat(this.alignment)).addClass(this.options.topbarButtonContainerClasses);
      this.element.append(topbarButtonsContainer);
      var searchIcon = $("<span>").addClass("cf-icon cf-icon-search cf-search-icon").toggleClass("cf-search-icon-clickable", this.options.enableSearchButton === true);
      if (typeof this.options.searchButtonTooltip === "string" && this.options.searchButtonTooltip.length > 0) {
        searchIcon.attr("title", $.i18n._(this.options.searchButtonTooltip));
        searchIcon.tooltip({
          content: function content() {
            var title = $(this).attr("title");

            // Escape title, since we're going from an attribute to raw HTML
            return $("<a>").text(title).html();
          },
          tooltipClass: "cf-tooltip cf-tooltip-secondary",
          classes: {
            "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
          },
          position: {
            my: "center bottom-15px",
            at: "center center",
            collision: "flipfit flip"
          }
        });
      }
      var searchTags = $("<span>").addClass("cf-topbar-searchtags").append($("<span>").addClass("cf-topbar-searchtags-icon"));
      if (this.options.searchTags !== undefined) {
        var keyValuesToDisplay = {};
        for (var key in this.options.searchTags) {
          keyValuesToDisplay[key] = this.options.searchTags[key].label;
        }
        searchTags.append($("<div>").Select({
          keyValues: keyValuesToDisplay
        }));
      }
      this.element.append($("<div>").addClass("topbar_search cf-topbar-search").addClass(this.options.searchTags !== undefined ? "cf-topbar-smallwidth-searchtags" : "").attr("role", "search").hide().append(searchIcon).append($("<input>").attr({
        "type": "text",
        "inputmode": "search",
        "autoCapitalize": "off",
        "aria-label": $.i18n._("nixps-cloudflow-topbar.arialabel_searchinput")
      }).addClass("cf-inlinesearch")).append($("<span>").addClass("cf-topbar-searchamount noselect")).append($("<span>").addClass("cf-icon cf-icon-close cf-topbar-clearsearch")).append(searchTags));
      this.element.append($("<div>").addClass("cf-topbar-morebutton cf-icon cf-icon-more-actions"));
      this.element.append($("<div>").addClass("topbar_licensebanner"));
      if (this.options.minimise === true) {
        this.minimise();
      }
      this.dropdownMenu = $("<div>");
      this.element.append(this.dropdownMenu);
      if (this.options.buttonTooltipOptions !== undefined && this.options.buttonTooltipOptions !== null) {
        this.element.tooltip(Object.assign({}, this.options.buttonTooltipOptions, {
          content: function content() {
            var title = $(this).attr("title");
            // Escape title, since we're going from an attribute to raw HTML
            return $("<a>").text(title).html();
          },
          items: ".cf-topbar-button[title]:not([disabled]), .cf-topbar-arrowmenu-arrow[title]:not([disabled]), .topbar-input-tooltip[title]:not([disabled])"
        }));
      }
      if (this.options.disabledButtonTooltipOptions !== undefined && this.options.disabledButtonTooltipOptions !== null) {
        // add on other dom to prevent conflict with enabled button tooltip
        topbarButtonsContainer.tooltip(Object.assign({
          tooltipClass: "cf-tooltip cf-tooltip-secondary",
          classes: {
            "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
          },
          position: {
            my: "center bottom-15px",
            at: "center center",
            collision: "flipfit flip"
          }
        }, this.options.disabledButtonTooltipOptions, {
          content: function content() {
            var title = $(this).attr("title");

            // Escape title, since we're going from an attribute to raw HTML
            return $("<span>").append($("<div>").addClass("cf-tooltip-title").text($.i18n._("nixps-cloudflow-topbar.tooltiptitle_disabled"))).append($("<span>").text(title)).html();
          },
          items: ".cf-topbar-button[title][disabled], .cf-topbar-arrowmenu-arrow[title][disabled], .topbar-input-tooltip[title][disabled]"
        }));
      }
      this._draw();

      // we should remove this later on...
      this.element.children(".topbar_licensebanner").LicenseBanner({
        "showMaintenanceWarning": true,
        "user": this.options.user,
        "ignoreWhenLicense": ["portal", "quantumrip", "dfe"]
      });
      this.searchHandler = _.debounce(this._searchHandler, this.options.searchThrottleDelay);
      this._on(this.element, {
        "click .topbar_buttons_button_behavetab": this._buttonTabClickHandler,
        "click .topbar_buttons_button_activetoggleable": this._buttonActiveClickHandler,
        "click [data-action].cf-topbar-button": this._buttonActionClickHandler,
        "click [title].cf-topbar-button": this._buttonTooltipClickHandler,
        "click .topbar_toggle_sidebar": this._toggleSideBarHandler,
        "click .topbar_toggle_maximise": this._maximiseHandler,
        "input .cf-topbar-inlinesearch": this.searchHandler,
        "keydown .cf-topbar-inlinesearch": this._keydownSearchHandler,
        "click .topbar_search .cf-icon-search.cf-search-icon-clickable": this._searchIconClickHandler,
        "click .cf-topbar-clearsearch": this._removeSearchTextHandler,
        "change .cf-topbar-searchtags": this._changeSearchTagHandler,
        "click .cf-topbar-morebutton": this._showButtonsMobileClickHandler,
        "mousemove [data-action].cf-topbar-button": this._mouseMoveHandler,
        "mouseout [data-action].cf-topbar-button": this._mouseOutHandler,
        "click .open-context-menu": this._arrowdownActionClickHandler,
        "click .toggle-tabgroup": this._buttonToggleTabGroupSettingsHandler,
        "mousedown .hold-for-context": this._buttonHoldClickHandler,
        "change input": this._inputChangedHandler
      });
      $.when(consentDef).always(function () {
        that.options.created();
      });
    },
    _inputChangedHandler: function _inputChangedHandler(pEvent, pData) {
      //parent holds the data attributes, reason -> styling
      var targetDOM = $(pEvent.target).parent();
      this._trigger("action" + targetDOM.attr("data-action"), pEvent, {
        actionname: targetDOM.attr("data-actionname"),
        value: $(pEvent.target).val()
      });
    },
    _buttonHoldClickHandler: function _buttonHoldClickHandler(pEvent, pData) {
      var that = this;
      var holdTimer = setTimeout(that._arrowdownActionClickHandler.bind(that, pEvent, pData), 500);
      $(pEvent.currentTarget).closest(".cf-topbar-button").on("mouseup mouseleave", function () {
        clearTimeout(holdTimer);
      });
    },
    _buttonTabClickHandler: function _buttonTabClickHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return;
      }
      var activeButtonsFilter = ".cf-topbar-button-active";
      if (typeof $(pEvent.currentTarget).attr("data-tabgroup") === "string") {
        activeButtonsFilter += '[data-tabgroup="' + $(pEvent.currentTarget).attr("data-tabgroup") + '"]';
      }
      this.element.children(".topbar_buttons").find(activeButtonsFilter).not($(pEvent.currentTarget)).filter(".topbar_buttons_button_behavetab").removeClass("cf-topbar-button-active");
      // filter out toggable, it will behandled later topbar_buttons_button_behavetab
      $(pEvent.currentTarget).not(".topbar_buttons_button_activetoggleable").addClass("cf-topbar-button-active");
    },
    _buttonActiveClickHandler: function _buttonActiveClickHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return;
      }
      var closestButtonDOM = $(pEvent.currentTarget).closest(".cf-topbar-button");
      if (closestButtonDOM.hasClass("cf-topbar-button-active") && closestButtonDOM.hasClass("topbar-buttons-nodeselect")) {
        return;
      }
      closestButtonDOM.toggleClass("cf-topbar-button-active");
      var action = $(pEvent.target).closest("[data-action]").attr("data-action");
      var toggle_state = closestButtonDOM.hasClass("cf-topbar-button-active");
      if (typeof action === "string" && action.length > 0) {
        this._trigger("toggle" + action, null, {
          "toggled": toggle_state,
          "action": action
        });
        if (action === "toggledetailspanel") {
          var detailspanelDOM = this.element.closest(".cf-page, .cf-pageframe").find(".cf-detailspanel").first();
          if (detailspanelDOM.length > 0) {
            var widgetName = detailspanelDOM.attr("data-widgetname");
            if (typeof widgetName === "string" && widgetName.length > 0) {
              detailspanelDOM[widgetName]("toggle");
              this.toggleDetailsPanelState = toggle_state;
            }
          }
        }
      }
    },
    _buttonToggleTabGroupSettingsHandler: function _buttonToggleTabGroupSettingsHandler(pEvent, pData) {
      var target = $(pEvent.currentTarget).closest(".cf-topbar-button");
      var elements = target.next().children().filter(".toggleable-tabgroup");
      if (target.hasClass("cf-topbar-button-active")) {
        elements.removeClass("topbar_buttons_button_behavetab");
        elements.parent().addClass("button-group-box");
      } else {
        elements.addClass("topbar_buttons_button_behavetab");
        elements.parent().removeClass("button-group-box");
      }
    },
    /**
     * @description function runs when user clicked on a button
     * @function
     * @private
     * @name nipx-cloudflow.TopBar#_buttonActionClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _buttonActionClickHandler: function _buttonActionClickHandler(pEvent, pData) {
      if (this._isEventFromComponent(pEvent) === false) {
        return;
      }
      var targetDOM = $(pEvent.target).closest("[data-action]");
      var action = targetDOM.attr("data-action");
      var actionname = targetDOM.attr("data-actionname");
      var isChecked = null;
      if (targetDOM.hasClass("topbar_buttons_button_activetoggleable")) {
        isChecked = targetDOM.hasClass("cf-topbar-button-active");
      }
      if (typeof action === "string" && action.length > 0) {
        this._trigger("action" + action, pEvent, {
          actionname: actionname,
          checked: isChecked
        });
      }
    },
    _arrowdownActionClickHandler: function _arrowdownActionClickHandler(pEvent, pData) {
      var targetDOM = $(pEvent.target.closest(".open-context-menu"));

      //when clicking on the arrow, the data is here
      var data = $(pEvent.target.closest(".open-context-menu")).data();
      if (data === undefined) {
        //when click to hold is active, find the arrow associated with the held click.
        targetDOM = $(pEvent.target.closest(".hold-for-context")).next();
        data = $(pEvent.target.closest(".hold-for-context")).next().data();
      }
      if (this.dropdownMenu.hasClass("nixps-DropdownList") === false) {
        this.dropdownMenu.DropdownList({
          classes: {
            "dropdownlist-actionlist": "cf-dropdown cf-dropdown-secondary noselect"
          }
        }).css({
          "z-index": 100000
        });
      } else {
        this.dropdownMenu.DropdownList("clearListItems");
      }

      //set the trigger to the element that was clicked.
      this.dropdownMenu.DropdownList({
        trigger: targetDOM.prevObject !== undefined ? targetDOM.prevObject[0] : targetDOM[0]
      });
      if (targetDOM.hasClass("cf-topbar-arrowmenu-arrow")) {
        targetDOM = targetDOM.prev();
      }

      //add the different context button items
      if (Array.isArray(data.contextMenu)) {
        var item = undefined;
        for (var i = 0; i < data.contextMenu.length; i++) {
          item = data.contextMenu[i];
          if (item.show !== false) {
            var classes = item.classes !== undefined ? item.classes + " " + item.actionname : item.actionname;
            var text = item.text;
            if (typeof item.showAltText === "function" && item.showAltText() || typeof item.showAltText === "boolean" && item.showAltText) {
              text = item.alt_text;
            }
            this.dropdownMenu.DropdownList("addListItem", {
              classes: classes,
              icon: $("<span>").addClass(item.icon),
              text: text,
              enabled: true,
              keyshortcut_suggestion: item.keybind,
              extraAttributes: {
                "data-actionname": item.actionname
              },
              clickCB: this._setToolFromSubmenu.bind(this, {
                action: item.action,
                actionname: item.actionname,
                button_override: targetDOM.data("override")
              }),
              data_testid: item.data_testid
            });
          }
        }
      }

      // open the window manually
      if ($(this.dropdownMenu).find(".dropdownlist-actionlist").is(":visible")) {
        this.dropdownMenu.DropdownList("closeDropdownList", pEvent).css({
          left: 0
        });
      } else {
        this.dropdownMenu.css({
          left: 0
        });
        this.dropdownMenu.DropdownList('openListWithoutButton', pEvent, true, targetDOM.offset().left).css({
          position: "absolute",
          top: "".concat(this.element.height(), "px")
        });
      }
      this.dropdownMenu.appendTo(".nixps-Dialog");
      this._trigger("contextopened");
    },
    _setToolFromSubmenu: function _setToolFromSubmenu(pData, pEvent) {
      if (typeof pData.action === "string" && pData.action.length > 0) {
        this._trigger("action" + pData.action, undefined, {
          actionname: pData.actionname
        });
      }

      //this updates the state of the button with what is selected in the dropdown where possible
      //(This code will only execute when the icon_as_dropdown_state property is true)
      if (_typeof(pData.button_override) === "object") {
        var oldActionname = pData.button_override.actionname;
        pData.button_override.action = pData.action;
        pData.button_override.actionname = pData.actionname;
        if (Array.isArray(pData.button_override.arrowdown_menu)) {
          var el = pData.button_override.arrowdown_menu.find(function (x) {
            return x.id === pData.actionname;
          });
          if (el !== undefined) {
            pData.button_override.icon = el.icon;
            pData.button_override.tooltip = el.tooltip;
          }
        }

        //update the UI state
        this.replaceButtonByActionName(oldActionname, pData.button_override);
        var existingOverride = this.dropdownOverrides.find(function (item) {
          return item.actionname === oldActionname;
        });
        if (existingOverride) {
          existingOverride.override = pData.button_override;
        } else {
          this.dropdownOverrides.push({
            "actionname": oldActionname,
            "override": pData.button_override
          });
        }
        if (pData.button_override.active_toggleable === true) {
          this.activateButtonByActionName(pData.button_override.actionname, pData.button_override.tabgroup);
        }
      }
    },
    _mouseMoveHandler: function _mouseMoveHandler(pEvent) {
      if (this._isEventFromComponent(pEvent) === false) {
        return;
      }
      var action = $(pEvent.target).closest('[data-action]').attr("data-action");
      this._trigger("mousemove" + action, pEvent, {});
    },
    _mouseOutHandler: function _mouseOutHandler(pEvent) {
      if (this._isEventFromComponent(pEvent) === false) {
        return;
      }
      var action = $(pEvent.target).closest('[data-action]').attr("data-action");
      this._trigger("mouseout" + action, pEvent, {});
    },
    /**
     * @description Function runs when user clicked on a button containing a tooltip
     * @function
     * @private
     * @name nixps-cloudflow.TopBar#_buttonTooltipClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _buttonTooltipClickHandler: function _buttonTooltipClickHandler(pEvent, pData) {
      var button = $(pEvent.currentTarget);
      if (button.length === 1) {}
    },
    _removeSeparatorStack: function _removeSeparatorStack() {
      var items = $(this.element).find(".topbar_buttons").children().filter(function () {
        return $(this).css('display') !== 'none';
      });
      items.each(function (index, element) {
        var elementDOM = $(element);
        if (elementDOM.hasClass("cf-topbar-separator")) {
          var next = elementDOM.next();
          if (next.hasClass("cf-topbar-separator")) {
            next.hide();
          }
        }
      });
    },
    /**
     * @description function runs when user want to control the sidebar 
     * @function
     * @private
     * @name nipx-cloudflow.TopBar#_toggleSideBarHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _toggleSideBarHandler: function _toggleSideBarHandler(pEvent, pData) {
      this._toggleSideBar(undefined, true);
    },
    _maximiseHandler: function _maximiseHandler(pEvent, pData) {
      this.maximise();
    },
    _upgradeSearchTagSelector: function _upgradeSearchTagSelector(pSearchString, pAllowDowngrade) {
      if (this.options.searchTags === undefined) {
        return;
      }
      var found = false;
      for (var tag in this.options.searchTags) {
        if (tag !== kNoTagValue && pSearchString.indexOf(tag) === 0) {
          // if this is the tags
          // update selector
          this.element.find('.cf-topbar-searchtags').find(".nixps-cloudflow-Select").Select("setValue", tag);
          // update icon
          this.element.find('.cf-topbar-searchtags-icon').removeAllClasses().addClass("cf-topbar-searchtags-icon").addClass(this.options.searchTags[tag].icon);
          // update clippled search text
          this.element.find(".cf-topbar-inlinesearch").find("input").first().val(pSearchString.substring(tag.length));
          // update full of small window
          this.element.children(".cf-topbar-search").removeClass("cf-topbar-smallwidth-searchtags").addClass("cf-topbar-fullwidth-searchtags");
          found = true;
          break;
        }
      }
      if (pAllowDowngrade === true && found === false) {
        // update selector
        this.element.find('.cf-topbar-searchtags').find(".nixps-cloudflow-Select").Select("setValue", kNoTagValue);
        // update icon
        this.element.find('.cf-topbar-searchtags-icon').removeAllClasses().addClass("cf-topbar-searchtags-icon");
        // the input is updated outsode this function
        // full of small window
        this.element.children(".cf-topbar-search").removeClass("cf-topbar-fullwidth-searchtags").addClass("cf-topbar-smallwidth-searchtags");
      }
    },
    _getSearchString: function _getSearchString(pEvent) {
      var searchValue = this.element.find(".cf-topbar-inlinesearch").find("input").first().val();
      if (this.options.searchTags !== undefined) {
        var searchTagValue = this.element.find('.cf-topbar-searchtags').find('.nixps-cloudflow-Select').Select('getValue');
        if (searchTagValue !== kNoTagValue) {
          searchValue = searchTagValue + searchValue;
        }
        this._upgradeSearchTagSelector(searchValue, false);
      }
      return searchValue;
    },
    _searchHandler: function _searchHandler(pEvent, pData) {
      this._trigger("search", null, {
        searchString: this._getSearchString(),
        keyEnter: false,
        clearButton: false,
        changeTags: $(pEvent.target).is('select')
      });
    },
    _keydownSearchHandler: function _keydownSearchHandler(pEvent, pData) {
      if (pEvent.keyCode === $.ui.keyCode.ENTER) {
        this._trigger("search", null, {
          searchString: this._getSearchString(),
          keyEnter: true,
          clearButton: false,
          changeTags: false
        });
      }
    },
    _searchIconClickHandler: function _searchIconClickHandler(pEvent, pData) {
      this._trigger("iconsearchclick", null, {});
    },
    _removeSearchTextHandler: function _removeSearchTextHandler(pEvent, pData) {
      var searchString = this._getSearchString();
      if (searchString.length > 0) {
        // only clear if something is to be cleared
        this.element.find(".cf-topbar-inlinesearch").find("input").first().val("");
        this._trigger("search", null, {
          searchString: "",
          keyEnter: false,
          clearButton: true,
          changeTags: false
        });
        this.element.children(".cf-topbar-search").removeClass("cf-topbar-search-searchamount-activated").children(".cf-topbar-searchamount").text("");
      }
      if (this.options.searchTags !== undefined) {
        this.element.find('.cf-topbar-searchtags').find('.nixps-cloudflow-Select').Select('setValue', kNoTagValue);
        this.element.find('.cf-topbar-searchtags-icon').removeAllClasses().addClass("cf-topbar-searchtags-icon");
        this.element.children(".cf-topbar-search").removeClass("cf-topbar-fullwidth-searchtags").addClass("cf-topbar-smallwidth-searchtags");
      }
    },
    _changeSearchTagHandler: function _changeSearchTagHandler(pEvent, pData) {
      var searchTagValue = this.element.find(".cf-topbar-searchtags").find(".nixps-cloudflow-Select").Select("getValue");
      if (searchTagValue === kNoTagValue) {
        this.element.find(".cf-topbar-searchtags-icon").removeAllClasses().addClass("cf-topbar-searchtags-icon");
        this.element.find(".cf-topbar-search").removeClass("cf-topbar-fullwidth-searchtags").addClass("cf-topbar-smallwidth-searchtags");
      } else {
        this.element.find('.cf-topbar-searchtags-icon').removeAllClasses().addClass("cf-topbar-searchtags-icon").addClass(this.options.searchTags[searchTagValue].icon);
        this.element.find(".cf-topbar-search").removeClass("cf-topbar-smallwidth-searchtags").addClass("cf-topbar-fullwidth-searchtags");
      }
    },
    _showButtonsMobileClickHandler: function _showButtonsMobileClickHandler(pEvent, pData) {
      this.element.find(".".concat(this.alignment)).find(".ui-tooltip").tooltip("destroy");
      this.element.toggleClass("cf-topbar-showbuttons");
    },
    _isEventFromComponent: function _isEventFromComponent(pEvent) {
      return $(pEvent.target).closest("." + this.widgetFullName).attr("data-uuid") == this.uuid;
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-cloudflow.TopBar#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      // draw title
      this._drawTitle();

      // draw optionaly the icon
      this._drawTitleIcon();
      this._drawButtons();
      this._toggleSearch();
    },
    _drawTitle: function _drawTitle() {
      var title = this.element.children('.cf-topbar-title').empty().addClass(this.options.titleClasses);
      if (typeof this.options.titleText === "string" || typeof this.options.titleText === "number") {
        title.text(_.unescape(this.options.titleText));
      } else {
        title.append(this.options.titleContent);
      }
      if (typeof this.options.titleTooltip === "string" && this.options.titleTooltip.length > 0) {
        title.attr("title", this.options.titleTooltip).tooltip({
          content: function content() {
            var title = $(this).attr("title");

            // Escape title, since we're going from an attribute to raw HTML
            return $("<a>").text(title).html();
          },
          tooltipClass: "cf-tooltip cf-tooltip-secondary",
          classes: {
            "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
          },
          position: {
            my: "center bottom-15px",
            at: "center center",
            collision: "flipfit flip"
          }
        });
      }
    },
    _drawTitleIcon: function _drawTitleIcon() {
      if (typeof this.options.titleImageURL === "string" && this.options.titleImageURL.length > 0) {
        var icon = $('<div>');
        this.element.children(".cf-topbar-titleicon").empty().css("display", "").append(icon);
        icon.Image({
          url: this.options.titleImageURL,
          width: null,
          height: null,
          maxWidth: 59,
          maxHeight: 59,
          relativeBasePath: this.options.relativeBasePath
        });
      } else {
        this.element.children(".cf-topbar-titleicon").hide();
      }
    },
    _retrieveSideBar: function _retrieveSideBar() {
      if (this.options.sideBarSelector === false) {
        return null;
      }
      if (this.options.sideBarSelector === "auto" && typeof this.options.pageSelector === "string") {
        var page = this.element.closest(this.options.pageSelector);
        return page.find(".nixps-cloudflow-SideBar").first();
      } else {
        return $(this.options.sideBarSelector).filter(".nixps-cloudflow-SideBar");
      }
    },
    _toggleSideBar: function _toggleSideBar(pNewDisplayMode, pSave) {
      var sidebar = this._retrieveSideBar();
      if (sidebar === null) {
        return;
      }
      if (sidebar.length === 1) {
        var currentDisplayMode = sidebar.SideBar("option", "displayMode");
        var newDisplayMode;
        if (pNewDisplayMode === undefined) {
          if (currentDisplayMode === "basic") {
            newDisplayMode = "extend";
          } else if (currentDisplayMode === "extend") {
            newDisplayMode = "basic";
          } else if (currentDisplayMode === "hidden") {
            newDisplayMode = "extend";
          }
        } else {
          newDisplayMode = pNewDisplayMode;
        }
        if (pSave === true && this.consent !== undefined && this.consent.isUserPreferencesAllowed("cf_sidebar_displaymode")) {
          if (newDisplayMode === "extend") {
            saveDisplayMode("extend");
          } else if (newDisplayMode === "basic") {
            saveDisplayMode("basic");
          } else if (currentDisplayMode === "hidden") {
            saveDisplayMode("hidden");
          }
        }
        sidebar.SideBar("option", "displayMode", newDisplayMode);
        if (newDisplayMode === "basic") {
          this.element.find(".topbar_toggle_sidebar").removeClass("cf-icon-more-actions cf-icon-hamburger").addClass("cf-icon-hamburger-short");
        } else if (newDisplayMode === "extend") {
          this.element.find(".topbar_toggle_sidebar").removeClass("cf-icon-more-actions cf-icon-hamburger-short").addClass("cf-icon-hamburger");
        } else {
          // hidden
          this.element.find(".topbar_toggle_sidebar").removeClass("cf-icon-hamburger cf-icon-hamburger-short").addClass("cf-icon-more-actions");
        }
      } else {
        // "could not found SideBar"
      }
    },
    _toggleSearch: function _toggleSearch() {
      if (this.options.enableInlineSearch === true) {
        this.element.children(".cf-topbar-search").css("display", "").addClass("cf-topbar-inlinesearch");
        this.element.children(".".concat(this.alignment)).addClass("cf-topbar-alignright-inlinesearch");
      } else {
        this.element.children(".cf-topbar-search").hide().removeClass("cf-topbar-inlinesearch");
        this.element.children(".".concat(this.alignment)).removeClass("cf-topbar-alignright-inlinesearch");
      }
    },
    _drawButtons: function _drawButtons() {
      if (this.element.children(".topbar_buttons").children(".topbar_buttons_button").length > 0) {
        this.element.addClass("cf-topbar-notransition");
      }
      this.element.children(".topbar_buttons").find("[data-external=true]").detach();
      var focussedDOM = this.element.children(".topbar_buttons").find(":focus");
      var inputDOM = this.element.children(".topbar_buttons").find("input").closest("[data-action]").detach();
      var buttonsPanel = this.element.children(".topbar_buttons").empty();
      if (Array.isArray(this.options.buttons) && this.options.buttons.length > 0) {
        for (var i = 0; i < this.options.buttons.length; i++) {
          if (this.options.buttons[i] === "separator" || this.options.buttons[i] && this.options.buttons[i].predefinedType === "separator") {
            buttonsPanel.append($("<span>").addClass("cf-topbar-separator").append("<span>"));
          } else if (this.options.buttons[i] === "filler" || this.options.buttons[i] && this.options.buttons[i].predefinedType === "filler") {
            buttonsPanel.append($("<span>").addClass("cf-topbar-filler").append("<span>"));
          } else if (this.options.buttons[i] && this.options.buttons[i].type === "input") {
            if (inputDOM.length === 1 && inputDOM.attr("data-action") === this.options.buttons[i].action) {
              buttonsPanel.append(inputDOM);
            } else {
              buttonsPanel.append(this.createInputField(this.options.buttons[i]));
            }
          } else if ($.isPlainObject(this.options.buttons[i])) {
            buttonsPanel.append(this.createButton(this.options.buttons[i]));
          }
        }
        this.normalise();
        if (this.element.is("[data-buttonstate-toggledetailspanel=true]") || this.toggleDetailsPanelState === true) {
          this.setButtonState("toggledetailspanel", true);
          this.element.removeAttr("data-buttonstate-toggledetailspanel");
        }
        if (focussedDOM.length === 1) {
          var focussedAction = focussedDOM.closest("[data-action]").attr("data-action");
          if (typeof focussedAction === "string" && focussedAction.length > 0) {
            this.element.children(".topbar_buttons").find("[data-action='" + focussedAction + "'] " + focussedDOM[0].tagName).trigger("focus");
          }
        }
        this._delay(function () {
          this.element.removeClass("cf-topbar-notransition");
        });
        this._trigger("buttonsdrawed", null, {});
      }
    },
    _redrawButtons: function _redrawButtons(pNewButtons, pOldButtons) {
      this.options.buttons = pNewButtons;
      this._drawButtons();
      return;
    },
    createInputField: function createInputField(pInputJSON) {
      var inputDOM = $("<input>").addClass("cf-topbar-input");
      if (typeof pInputJSON.name === "string" && pInputJSON.name.length > 0) {
        inputDOM.attr('name', pInputJSON.name);
      }
      if (typeof pInputJSON.input_type === "string" && pInputJSON.input_type.length > 0) {
        inputDOM.attr('type', pInputJSON.input_type);
      }
      var inputFieldContainerDOM = $("<div>").addClass(pInputJSON.classes).append(inputDOM);
      if (typeof pInputJSON.action === "string" && pInputJSON.action.length > 0) {
        inputFieldContainerDOM.attr("data-action", pInputJSON.action);
      }
      if (typeof pInputJSON.actionname == "string" && pInputJSON.actionname.length > 0) {
        inputFieldContainerDOM.attr("data-actionname", pInputJSON.actionname);
      }
      if (typeof pInputJSON.data_testid === "string") {
        inputDOM.attr("data-testid", pInputJSON.data_testid);
      }
      if (pInputJSON.show === false) {
        inputFieldContainerDOM.hide();
      }
      if (pInputJSON.disabled === true || pInputJSON.disable === true) {
        inputFieldContainerDOM.addClass("cf-topbar-button-disabled").prop("disabled", true);
      }
      if (typeof pInputJSON.tooltip === "string" && pInputJSON.tooltip.length != 0) {
        inputDOM.attr("title", $.i18n._(pInputJSON.tooltip));
        inputDOM.addClass("topbar-input-tooltip");
      }
      return inputFieldContainerDOM;
    },
    createButton: function createButton(pButtonJSON) {
      var that = this;
      var button;
      if (typeof pButtonJSON.url === "string" && pButtonJSON.url.length > 0) {
        button = $("<a>").addClass("topbar_buttons_button cf-topbar-button").attr("href", pButtonJSON.url);
      } else if (typeof pButtonJSON.content === "function") {
        button = pButtonJSON.content($("<button>").attr("type", "button").addClass("topbar_buttons_button cf-topbar-button"));
      } else {
        button = $("<button>").attr("type", "button").addClass("topbar_buttons_button cf-topbar-button");
      }
      if (typeof pButtonJSON.tooltip === "string" && pButtonJSON.tooltip.length > 0) {
        button.attr("title", $.i18n._(pButtonJSON.tooltip));
      }
      if (typeof pButtonJSON.action === "string" && pButtonJSON.action.length > 0) {
        button.attr("data-action", pButtonJSON.action);
      }
      if (typeof pButtonJSON.tabgroup === "string" && pButtonJSON.tabgroup.length > 0) {
        button.attr("data-tabgroup", pButtonJSON.tabgroup);
        button.addClass("topbar_buttons_button_behavetab");
      }
      if (typeof pButtonJSON.actionname === "string" && pButtonJSON.actionname.length > 0) {
        button.attr("data-actionname", pButtonJSON.actionname);
      }
      if (typeof pButtonJSON.classes === "string" && pButtonJSON.classes.length > 0) {
        button.addClass(pButtonJSON.classes);
      }
      if (pButtonJSON.icon_type === "image") {
        button.append($("<img>").attr("src", pButtonJSON.icon));
      } else if (pButtonJSON.icon_type === "letter") {
        button.append($("<span>").addClass("icon-as-text").text($.i18n._(pButtonJSON.icon)));
      } else if (typeof pButtonJSON.icon === "string") {
        button.append($("<span>").addClass(pButtonJSON.icon));
      } else if (Array.isArray(pButtonJSON.icon)) {
        if (pButtonJSON.icon.length > 2) {
          throw new Error("Topbar: button icons can only be stacked up to 2");
        }
        var container = $("<span>").addClass("cf-icon cf-icon-stack");
        container.append($("<span>").addClass(pButtonJSON.icon[0] + " cf-icon-stacked"));
        container.append($("<span>").addClass(pButtonJSON.icon[1] + " cf-icon-stacked"));
        button.append(container);
      } else if (typeof pButtonJSON.content !== "function") {
        button.append($("<span>").addClass("cf-icon"));
      }
      if (typeof pButtonJSON.text === "string") {
        button.append($("<span>").addClass("topbar_buttons_text cf-topbar-button-text").text($.i18n._(pButtonJSON.text)));
      }
      if (pButtonJSON.active_toggleable === true) {
        button.addClass("topbar_buttons_button_activetoggleable");
      }
      if (pButtonJSON.active) {
        button.addClass("cf-topbar-button-active");
      }
      if (pButtonJSON.behave_tab === true) {
        button.addClass("topbar_buttons_button_behavetab");
      }
      if (typeof pButtonJSON.onclick === "function") {
        button.on("click", pButtonJSON.onclick);
      }
      if (pButtonJSON.dropdownlist !== undefined) {
        $(pButtonJSON.dropdownlist).attr("data-external", true).DropdownList("option", "trigger", button);
        button.append(pButtonJSON.dropdownlist);
      }
      if (pButtonJSON.disabled === true || pButtonJSON.disable === true) {
        button.addClass("cf-topbar-button-disabled").filter("button").prop("disabled", true);
      }
      if (pButtonJSON.hide === true || pButtonJSON.show === false) {
        button.hide();
      }
      if (pButtonJSON.noDeselect === true) {
        button.addClass("topbar-buttons-nodeselect");
      }
      if (typeof pButtonJSON.data_testid === "string" && pButtonJSON.data_testid.length > 0) {
        button.attr("data-testid", pButtonJSON.data_testid);
      }
      if (pButtonJSON.is_default === true) {
        button.addClass("is_default");
      }
      if (Array.isArray(pButtonJSON.arrowdown_menu) && pButtonJSON.show !== false && pButtonJSON.hide !== true) {
        var shouldHide = pButtonJSON.arrowdown_menu.every(function (x) {
          return x.show == false || x.hide == true;
        });
        if (shouldHide && pButtonJSON.arrowdown_menu.length !== 0) {
          button.hide();
        }
        if (pButtonJSON.sideways_menu !== true) {
          var arrowButton = $("<button>").attr("type", "button").addClass("cf-topbar-arrowmenu-arrow").append($("<span>"));
          if (typeof pButtonJSON.arrowdown_tooltip === "string" && pButtonJSON.arrowdown_tooltip.length > 0) {
            arrowButton.attr("title", $.i18n._(pButtonJSON.arrowdown_tooltip));
          }
          if (typeof pButtonJSON.data_testid_arrow === "string" && pButtonJSON.data_testid_arrow.length > 0) {
            arrowButton.attr("data-testid", pButtonJSON.data_testid_arrow);
          }

          //if the main button should act as the dropdown, trigger the arrow on the main button and hide the arrow
          if (pButtonJSON.mainbutton_is_dropdown === true) {
            button.addClass("open-context-menu");
            button.data("contextMenu", pButtonJSON.arrowdown_menu);
            arrowButton.hide();
          } else {
            arrowButton.addClass("cf-icon cf-icon-chevron-down").addClass("arrow-resized-small open-context-menu");
            button.addClass("has_dropdown_arrow");
            arrowButton.data("contextMenu", pButtonJSON.arrowdown_menu);
          }
          if (pButtonJSON.long_press_dropdown === true) {
            button.addClass("hold-for-context");
          }
          var dropdownButton = [button, arrowButton];
          for (var index = 0; index < pButtonJSON.arrowdown_menu.length; index++) {
            var element = pButtonJSON.arrowdown_menu[index];
            if (pButtonJSON.icon_as_dropdown_state === true) {
              button.data("override", pButtonJSON);
            }
          }
          if (pButtonJSON.disabled === true || pButtonJSON.disable === true) {
            $(dropdownButton).addClass("cf-topbar-button-disabled").filter("button").prop("disabled", true);
          }
          if (pButtonJSON.arrowdown_menu.length === 0) {
            arrowButton.css("visibility", "hidden");
          }
          return dropdownButton;
        } else {
          var subSpan = $("<span>");
          var buttons = [button, subSpan];
          button.addClass("toggle-tabgroup");
          if (button.hasClass("cf-topbar-button-active")) {
            subSpan.addClass("button-group-box");
          }
          button.on("mouseenter", function () {
            subSpan.addClass("button-group-box");
          });
          button.on("mouseleave", function () {
            if (!button.hasClass("cf-topbar-button-active")) {
              subSpan.removeClass("button-group-box");
            }
          });
          for (var _index = 0; _index < pButtonJSON.arrowdown_menu.length; _index++) {
            var subButton = this.createButton(pButtonJSON.arrowdown_menu[_index]);
            if (pButtonJSON.arrowdown_menu[_index].change_tab_state_when_parent_active === true) {
              subButton.addClass("toggleable-tabgroup");
              if (pButtonJSON.active === true) {
                subButton.removeClass("topbar_buttons_button_behavetab");
              }
            }
            subSpan.append(subButton);
          }
          return buttons;
        }
      }
      return button;
    },
    _disableButton: function _disableButton(pFilter) {
      $.merge(this.element.children(".topbar_buttons"), this.element.children(".nixps-DropdownList").map(function (x, el) {
        return $(el).DropdownList("getListItems");
      })).children(pFilter).addClass("cf-topbar-button-disabled").filter("button").prop("disabled", true);
    },
    _enableButton: function _enableButton(pFilter) {
      $.merge(this.element.children(".topbar_buttons"), this.element.children(".nixps-DropdownList").map(function (x, el) {
        return $(el).DropdownList("getListItems");
      })).children(pFilter).removeClass("cf-topbar-button-disabled").filter("button").prop("disabled", false);
    },
    isButtonChecked: function isButtonChecked(actionname) {
      var targetDOM = this.element.find("[data-actionname=".concat(actionname, "]"));
      var isChecked = false;
      if (targetDOM.hasClass("topbar_buttons_button_activetoggleable")) {
        isChecked = targetDOM.hasClass("cf-topbar-button-active");
      }
      return isChecked;
    },
    getButton: function getButton(actionname) {
      return this.element.find("[data-actionname=".concat(actionname, "]"));
    },
    getButtonsInGroup: function getButtonsInGroup(groupname) {
      return this.element.find("[data-tabgroup=".concat(groupname, "]"));
    },
    disableButton: function disableButton(pAction) {
      return this._disableButton('[data-action="' + pAction + '"]');
    },
    disableButtons: function disableButtons(pActions) {
      for (var i = 0; i < pActions.length; i++) {
        this.disableButton(pActions[i]);
      }
    },
    enableButton: function enableButton(pAction) {
      return this._enableButton('[data-action="' + pAction + '"]');
    },
    enableButtons: function enableButtons(pActions) {
      for (var i = 0; i < pActions.length; i++) {
        this.enableButton(pActions[i]);
      }
    },
    disableButtonByActionName: function disableButtonByActionName(pActionName) {
      return this._disableButton('[data-actionname="' + pActionName + '"]');
    },
    enableButtonByActionName: function enableButtonByActionName(pActionName) {
      return this._enableButton('[data-actionname="' + pActionName + '"]');
    },
    replaceButton: function replaceButton(pButtonJSON) {
      // update model
      for (var i = 0; i < this.options.buttons.length; i++) {
        if (this.options.buttons[i].action === pButtonJSON.action) {
          this.options.buttons[i] = pButtonJSON;
          break;
        }
      }
      // update DOM
      var button = this.element.children('.topbar_buttons').children('[data-action="' + pButtonJSON.action + '"]').eq(0);
      button.replaceWith(this.createButton(pButtonJSON));
    },
    replaceButtonByActionName: function replaceButtonByActionName(oldActionName, pButtonJSON) {
      // update model
      for (var i = 0; i < this.options.buttons.length; i++) {
        if (this.options.buttons[i].actionname === oldActionName) {
          this.options.buttons[i] = pButtonJSON;
          break;
        }
      }

      // update DOM
      var button = this.element.children('.topbar_buttons').children('[data-actionname="' + oldActionName + '"]').eq(0);

      //if the adjacent element is a dropdown arrow, it needs to be removed so createButton can recreate it correctly
      button.next().filter('.cf-topbar-arrowmenu-arrow').remove();
      button.replaceWith(this.createButton(pButtonJSON));
    },
    _hideButton: function _hideButton(pFilter) {
      this.element.children('.topbar_buttons').children(pFilter).hide();
      this.normalise();
    },
    _showButton: function _showButton(pFilter) {
      this.element.children('.topbar_buttons').children(pFilter).css("display", "");
      this.normalise();
    },
    hideButton: function hideButton(pAction) {
      return this._hideButton('[data-action="' + pAction + '"]');
    },
    showButton: function showButton(pAction) {
      return this._showButton('[data-action="' + pAction + '"]');
    },
    hideButtons: function hideButtons(pAction) {
      for (var i = 0; i < pAction.length; i++) {
        this.hideButton(pAction[i]);
      }
    },
    showButtons: function showButtons(pAction) {
      for (var i = 0; i < pAction.length; i++) {
        this.showButton(pAction[i]);
      }
    },
    hideButtonByActionName: function hideButtonByActionName(pActionName) {
      return this._hideButton('[data-actionname="' + pActionName + '"]');
    },
    showButtonByActionName: function showButtonByActionName(pActionName) {
      return this._showButton('[data-actionname="' + pActionName + '"]');
    },
    activateButton: function activateButton(pAction, pTabGroup) {
      if (this.element.children('.topbar_buttons').children('.topbar_buttons_button_behavetab').length > 1 && pTabGroup !== undefined) {
        this.element.children(".topbar_buttons").find('[data-tabgroup="' + pTabGroup + '"]').removeClass("cf-topbar-button-active");
        this.element.children('.topbar_buttons').children('[data-action="' + pAction + '"]').addClass("cf-topbar-button-active");
      } else {
        this.element.find('.cf-topbar-button-active').removeClass("cf-topbar-button-active");
        this.element.children('.topbar_buttons').children('[data-action="' + pAction + '"]').addClass("cf-topbar-button-active");
      }
    },
    activateButtonByActionName: function activateButtonByActionName(pActionName, pTabGroup) {
      if (this.element.children('.topbar_buttons').children('.topbar_buttons_button_behavetab').length > 1 && pTabGroup !== undefined) {
        this.element.children(".topbar_buttons").find('[data-tabgroup="' + pTabGroup + '"]').removeClass("cf-topbar-button-active");
        this.element.children('.topbar_buttons').children('[data-actionname="' + pActionName + '"]').addClass("cf-topbar-button-active");
      } else {
        this.element.find('.cf-topbar-button-active').removeClass("cf-topbar-button-active");
        this.element.children('.topbar_buttons').children('[data-actionname="' + pActionName + '"]').addClass("cf-topbar-button-active");
      }
    },
    setButtonState: function setButtonState(pAction, pState) {
      var button = this.element.children('.topbar_buttons').children('[data-action="' + pAction + '"]');
      if (button.length === 0) {
        if (Array.isArray(this.options.buttons) && this.options.buttons.length > 0) {
          for (var i = 0; i < this.options.buttons.length; i++) {
            if (this.options.buttons[i].action === pAction) {
              this.options.buttons[i].active = pState === true;
              break;
            }
          }
        }
      } else {
        button.toggleClass("cf-topbar-button-active", pState);
      }
      if (pAction === "toggledetailspanel") {
        this.toggleDetailsPanelState = pState;
      }
    },
    normalise: function normalise() {
      // reset
      this.element.children('.topbar_buttons').children(".cf-topbar-separator-hidden").removeClass("cf-topbar-separator-hidden").css("display", "");
      // hide
      var visibleButtons = this.element.children('.topbar_buttons').children(":visible");
      visibleButtons.each(function (index) {
        if ($(this).hasClass("cf-topbar-separator")) {
          if (visibleButtons.eq(index - 1).filter(".cf-topbar-separator").is(":visible")) {
            $(this).addClass("cf-topbar-separator-hidden").hide();
          } else if (index === 0) {
            // the first visible element may not be visible, because there is no visible button left of it
            $(this).addClass("cf-topbar-separator-hidden").hide();
          }
        }
      });
    },
    setInlineSearchValue: function setInlineSearchValue(pValue) {
      if (typeof pValue !== "string") {
        throw new Error("value search must be a string");
      }
      this.element.children(".topbar_search").find("input.cf-inlinesearch").val(pValue);
      this._upgradeSearchTagSelector(pValue, true);
    },
    setSearchAmount: function setSearchAmount(pText) {
      this.element.children(".topbar_search").addClass("cf-topbar-search-searchamount-activated").children(".cf-topbar-searchamount").text(pText);
    },
    canActivateActionName: function canActivateActionName(pActionName) {
      var pAction = this.element.find("[data-actionname='".concat(pActionName, "']"));
      if (pAction.length === 0) {
        pAction = this.element.find("[data-actionname*='".concat(pActionName, "']")).filter("button");
      }
      if (pAction.length === 0) {
        this.options.buttons.forEach(function (obj) {
          if (obj.actionname === pActionName) {
            pAction = obj;
          }
          if (Array.isArray(obj.arrowdown_menu)) {
            obj.arrowdown_menu.forEach(function (child) {
              if (child.actionname === pActionName) {
                pAction = child;
              }
            });
          }
        });
        return pAction.show !== false && pAction.hide !== true && pAction.enabled !== false && pAction.disabled !== true;
      }
      var isDisabled = pAction.hasClass("cf-topbar-button-disabled");
      var parentIsDropdown = pAction.parent().hasClass("cf-dropdown");
      var isVisible = pAction.is(":visible");
      return !isDisabled && (isVisible || parentIsDropdown);
    },
    minimise: function minimise() {
      if (this.element.hasClass("cf-topbar-minimal")) {
        return;
      }
      this.element.addClass("cf-topbar-minimal");
      this.minimalPrevDisplayState = getDisplayMode();
      this._toggleSideBar("hidden", false);
      this.element.children(".topbar_toggle_sidebar").hide();
      this.element.prepend($('<span>').addClass("topbar_toggle_maximise cf-topbar-logo cf-icon cf-icon-maximize"));
      if (typeof this.options.pageSelector === "string") {
        var page = this.element.closest(this.options.pageSelector);
        page.find(".cf-pagecontent").first().addClass("cf-pagecontent-maximise");
      }
      this._trigger("minimised", null, {});
    },
    maximise: function maximise() {
      if (this.element.hasClass("cf-topbar-minimal") === false) {
        return;
      }
      this.element.removeClass("cf-topbar-minimal");
      this._toggleSideBar(this.minimalPrevDisplayState || "basic", false);
      this.element.children(".topbar_toggle_sidebar").css("display", "");
      this.element.children(".topbar_toggle_maximise").remove();
      if (typeof this.options.pageSelector === "string") {
        var page = this.element.closest(this.options.pageSelector);
        page.find(".cf-pagecontent").first().removeClass("cf-pagecontent-maximise");
      }
      this._trigger("maximised", null, {});
    },
    /**
     * @description Add a sign to the title to indicate the content has changed but is not saved 
     * @function
     * @name nixps-cloudflow.TopBar#toggleTitleUnsaved
     * @param {Boolean} pState true to add an asterics and false to hide the asterics
     */
    toggleTitleUnsaved: function toggleTitleUnsaved(pState) {
      this.element.children(".cf-topbar-title").toggleClass("cf-title-unsaved", pState);
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      if (options.buttons !== undefined) {
        if (typeof window._ === "function" && _.isEqual(options.buttons, this.options.buttons)) {
          // skip
        } else {
          this._redrawButtons(options.buttons, this.options.buttons);
        }
      }
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      this._controlOptions();
      if (options.titleText !== undefined || options.titleContent !== undefined || options.titleTooltip !== undefined || options.titleClasses !== undefined) {
        this._drawTitle();
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.TopBar#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "disabled") {
        if (this.options.disabled !== pValue) {
          if (pValue === true) {
            this.element.addClass("cf-topbar-disabled");
            this.element.find("button").not(".cf-topbar-button-disabled").prop("disabled", true);
            this.element.find("input, textarea, select").prop("disabled", true);
          } else {
            this.element.removeClass("cf-topbar-disabled");
            this.element.find("button").not(".cf-topbar-button-disabled").prop("disabled", false);
            this.element.find("input, textarea, select").prop("disabled", false);
          }
        }
      } else if (pKey === "enableInlineSearch") {
        if (this.options.enableInlineSearch !== pValue) {
          this.options.enableInlineSearch = pValue;
          this._toggleSearch();
        }
      } else if (pKey === "enableSideBarSelector") {
        if (this.options.enableSideBarSelector !== pValue) {
          if (pValue === true) {
            this.element.prepend($("<span>").addClass("topbar_toggle_sidebar cf-topbar-logo cf-icon cf-icon-hamburger"));
          } else if (pValue === false) {
            this.element.children(".topbar_toggle_sidebar").remove();
          }
        }
      } else if (pKey === "enableSearchButton") {
        if (this.options.enableSearchButton !== pValue) {
          this.element.children(".cf-topbar-search").children(".cf-icon-search").toggleClass("cf-search-icon-clickable", pValue === true);
        }
      } else if (pKey === "searchButtonTooltip") {
        if (this.options.searchButtonTooltip !== pValue) {
          var searchIcon = this.element.children(".cf-topbar-search").children(".cf-icon-search");
          if (typeof pValue === "string" && pValue.length > 0) {
            searchIcon.attr("title", $.i18n._(pValue));
            searchIcon.tooltip({
              content: function content() {
                var title = $(this).attr("title");

                // Escape title, since we're going from an attribute to raw HTML
                return $("<a>").text(title).html();
              },
              tooltipClass: "cf-tooltip cf-tooltip-secondary",
              classes: {
                "ui-tooltip": "cf-tooltip cf-tooltip-secondary"
              },
              position: {
                my: "center bottom-15px",
                at: "center center",
                collision: "flipfit flip"
              }
            });
          } else {
            searchIcon.removeAttr("title");
            searchIcon.filter(".ui-tooltip").tooltip("destroy");
          }
        }
      } else if (pKey === "searchTags") {
        var searchTags = this.element.find('.cf-topbar-searchtags').empty();
        if (pValue !== undefined) {
          var keyValuesToDisplay = {};
          for (var key in pValue) {
            keyValuesToDisplay[key] = pValue[key].label;
          }
          searchTags.append($('<span>').addClass('cf-topbar-searchtags-icon'));
          searchTags.append($('<div>').Select({
            keyValues: keyValuesToDisplay
          }));
          this.element.find('.cf-topbar-search').addClass('cf-topbar-smallwidth-searchtags');
        } else {
          this.element.find('.cf-topbar-search').removeClass('cf-topbar-smallwidth-searchtags').removeClass('cf-topbar-fullwidth-searchtags');
        }
      } else if (pKey === "titleImageURL") {
        if (this.options.titleImageURL !== pValue) {
          this.options.titleImageURL = pValue;
          this._drawTitleIcon();
        }
      } else if (pKey === "pagebuilderStyleClass") {
        if (this.options.pagebuilderStyleClass !== pValue) {
          this.element.removeClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
          this.options.pagebuilderStyleClass = pValue;
          if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
            this.element.addClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
          }
        }
      } else if (pKey === "buttons") {
        this.options.buttons = pValue;
      }
      this._superApply(arguments);
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.TopBar#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error(this.widgetName + " input option language must be a not empty string");
      }
      if (typeof this.options.style_type !== "string" || this.options.style_type.length <= 0) {
        throw new Error(this.widgetName + " input option style_type must be a not empty string");
      }
      if (typeof this.options.relativeBasePath !== "string") {
        throw new Error(this.widgetName + " input option relativeBasePath must be a not empty string");
      }
      if (typeof this.options.enableSideBarSelector !== "boolean") {
        throw new Error(this.widgetName + " input option enableSideBarSelector must be a boolean");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.widgetFullName).removeClass("CloudflowStyle_" + this.options.style_type).removeClass("nixps-cloudflow-TopBar").removeAttr("data-uuid").removeAttr("role");
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        this.element.removeClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../common/DropdownList/js/nixps-DropdownList.js":288,"../../../common/js/myjQueryPlugins.js":388,"../../Consent/js/Consent.js":96,"../../FormElements/js/nixps-cloudflow-Image.js":149,"../../FormElements/js/nixps-cloudflow-Select.js":160,"../../LicenseBanner/js/nixps-cloudflow-LicenseBanner.js":176}],231:[function(require,module,exports){
"use strict";

// A standard span to use in the top navigation bar
var kSpan = $('<span>').css({
  display: 'inline-block',
  margin: 0,
  padding: 0
});

// A standard button to use in the top navigation bar
var kButton = $('<button>').attr('title', '').css({
  margin: 0,
  width: 28
});
var relativeGoBackPath = new RegExp("\\\.\\\./", "g");
function removeRelativePaths(pURL) {
  if (typeof pURL === "string") {
    return pURL.replace(relativeGoBackPath, "");
  }
  return pURL;
}

// Returns the list of scopes
function getScopes() {
  return $.Deferred(function (defer) {
    new window.Scopes().done(function (scopes) {
      defer.resolve(scopes.getArray());
    }).fail(defer.reject);
  });
}

// Validates the buttons parameter
function validateButtons(unknown) {
  if (Array.isArray(unknown) === false) {
    return false;
  }
  for (var i = 0; i < unknown.length; i++) {
    var button = unknown[i];
    if (typeof button.link !== 'string' || button.link.length === 0) {
      return false;
    }
    if (typeof button.tooltip !== 'string') {
      return false;
    }
  }
  return true;
}

/**
 * @deprecated use nixps-cloudflow-TopBar instate
 */
$.widget('nixps-cloudflow.TopNavigation', {
  options: {
    /**
     * @brief The buttons to show in the top navigation bar, for example this is
     *        the config for the standard cloudflow UI:
     *        {
     *            // home
     *            icon: '/portal/css/images/dark_bar_home.png',
     *            link: '/portal.cgi?home=1',
     *            tooltip: 'nixps-cloudflow-top_navigation.home',
     *            text: 'nixps-cloudflow-top_navigation.home'
     *        }, {
     *            // assets
     *            icon: '/portal/css/images/dark_bar_files.png',
     *            link: '/portal.cgi?asset=X',
     *            tooltip: 'nixps-cloudflow-top_navigation.assets'
     *        }, {
     *            // users config
     *            icon: '/portal/css/images/dark_bar_users.png',
     *            link: '/portal.cgi?manage=1',
     *            tooltip: 'nixps-cloudflow-top_navigation.users',
     *            text: 'USERS'
     *        }, {
     *            // chains config
     *            icon: '/portal/css/images/dark_bar_chains.png',
     *            link: '/portal.cgi?chains=1',
     *            tooltip: 'nixps-cloudflow-top_navigation.approval'
     *        }, {
     *            // workflow builder
     *            icon: '/portal/css/images/dark_bar_flows.png',
     *            link: '/portal.cgi?quantum',
     *            tooltip: 'nixps-cloudflow-top_navigation.workflow_builder'
     *        }, {
     *            // kiosk
     *            icon: '/portal/css/images/dark_bar_kiosk.png',
     *            link: '/portal.cgi?hub',
     *            tooltip: 'nixps-cloudflow-top_navigation.kiosk'
     *        }, {
     *            // printplanner
     *            icon: '/portal/css/images/dark_bar_printplanner.png',
     *            link: '/portal.cgi?lms',
     *            tooltip: 'nixps-cloudflow-top_navigation.printplanner'
     *        }, {
     *            // patchplanner
     *            icon: '/portal/css/images/dark_bar_patchplanner.png',
     *            link: '/portal.cgi?patchplanner=1',
     *            tooltip: 'nixps-cloudflow-top_navigation.patchplanner'
     *        }, {
     *            // rip
     *            icon: '/portal/css/images/dark_bar_rip.png',
     *            link: '/standalone_rip.html',
     *            tooltip: 'nixps-cloudflow-top_navigation.standalone_rip'
     *        }, {
     *            // settings
     *            icon: '/portal/css/images/dark_bar_config.png',
     *            link: '/portal.cgi?config=1',
     *            tooltip: 'nixps-cloudflow-home.settings'
     *        }  
     */
    buttons: [{
      // home
      icon: '/portal/css/images/dark_bar_home.png',
      link: '/portal.cgi?home=1',
      tooltip: 'nixps-cloudflow-top_navigation.home'
    }],
    /**
     * @brief true if the username should be shown in the navigation bar
     * @type boolean
     */
    showUser: true,
    /**
     * @brief true if the logout button must be shown in the navigation bar
     * @type boolean
     */
    showLogout: true,
    /**
     * @brief true if the scope selector must be shown in the navigation bar
     *        in case the user is not admin, it won't show the scope selector
     * @type boolean
     */
    showScopeSelector: false,
    /**
     * @description Give here the id of the button, which must be shown as active
     * @type {string}
     * @default undefined
     */
    active: undefined,
    created: function created() {}
  },
  _create: function _create() {
    if (validateButtons(this.options.buttons) === false) {
      throw new Error('error in buttons list');
    }
    // differens between width in large mode and medium mode
    // will be calculated in _draw function
    this.diffSmallBig = 0;
    this.badgeNumberTimerIDs = []; // an array containing all the timer ids

    this._super();
    this.element.addClass(this.widgetFullName);
    this._on(this.element, {
      'change .scopeSelector': this._scopeChangedHandler,
      'click button': this._buttonClickedHandler
    });
    this.window.on('resize', this._resizeWindowHandler.bind(this));
    if (this.options.showUser === true) {
      var that = this;
      nixps.cloudflow.User.get().then(function (user) {
        that.user = user;
        that._draw();
        that._initResize();
        that.options.created(); // no badgenumbers!!
      });
    } else {
      this._draw();
      this._initResize();
      this.options.created(); // no badgenumbers!!
    }
  },

  /**
   * @desc function runs when user change size of windows
   * @param {type} pEvent
   * @returns {Boolean} undefined
   */
  _resizeWindowHandler: function _resizeWindowHandler(pEvent) {
    var pWidth = $(window).width();
    if (pWidth < 440) {
      // if size is smaller then smartphone
      return true; // if size is to small let css files handle this
    }
    // this.oldWidthButtons: length of buttons in larged format
    // this.diffSmallBig: width difference between larged format and ipad/medium format
    var container = this.element.find('span'); // this element contains the class mode
    if (container.is('.miniMode')) {
      // if you are is mini mode, do we need to enlarge?
      if (pWidth > this.oldWidthButtons - this.diffSmallBig) {
        container.removeClass('miniMode').addClass('smallMode');
      }
    } else if (container.is('.smallMode')) {
      if (pWidth > this.oldWidthButtons) {
        container.removeClass('smallMode');
      } else if (pWidth < this.oldWidthButtons - this.diffSmallBig) {
        container.removeClass('smallMode').addClass('miniMode');
      }
    } else {
      if (pWidth < this.oldWidthButtons) {
        container.addClass('smallMode');
        if (pWidth < this.oldWidthButtons - this.diffSmallBig) {
          container.removeClass('smallMode').addClass('miniMode');
        }
      }
    }
  },
  _initResize: function _initResize() {
    // calc the original width of all buttons in larged format
    this.oldWidthButtons = 25; /* start with buffer */
    this._delay(function () {
      var that = this;
      this.element.find('span').children().each(function () {
        that.oldWidthButtons += $(this).outerWidth();
      });
      this._resizeWindowHandler(null, $(window).width(), 0);
    }, 0);
  },
  _draw: function _draw() {
    this.element.empty();
    var that = this;
    // Create the application buttons
    var applications = kSpan.clone();
    this.element.append(applications);
    var buttons = this.options.buttons;
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var appButton = kButton.clone().attr('title', $.i18n._(button.tooltip)).attr('data-nixps-top-navigation-link', button.link).attr('data-nixps-top-navigation-id', button.id).text(function (index, oldText) {
        if (typeof button.text === "string" && button.text.length > 0) {
          $(this).css('width', '').addClass('buttonText');
          return $.i18n._(button.text);
        }
      });
      if (typeof button.icon === "string" && button.icon.length > 0) {
        if (Array.isArray(button.icon.match(/.svg$/i)) === true) {
          // In case it is an svg, load the svg xml in the dom tree
          appButton.prepend($('<div>').addClass('svgIcon').load(button.icon));
        } else {
          // in case of a url 
          appButton.css({
            'background-image': 'url(' + button.icon + ')',
            'backgroundPosition': '4px 4px',
            'backgroundRepeat': 'no-repeat',
            'vertical-align': 'top'
          });
        }
      }

      // badge number for that icon
      if (typeof button.badgeNumber === "number" && button.badgeNumber > 0) {
        if (button.badgeNumber > 999) {
          appButton.append($('<span>').addClass("topnavigation_badgenumber").text("> 999").addClass("topnavigation_badgenumber_max"));
        } else {
          appButton.append($('<span>').addClass("topnavigation_badgenumber").text(button.badgeNumber).addClass(function () {
            return "topnavigation_badgenumber_length" + $(this).html().length;
          }));
        }
        appButton.addClass("button_extendneeded");
      } else if (typeof button.badgeNumber === "function") {
        var badgeNumber = $('<span>').addClass("topnavigation_badgenumber");
        appButton.append(badgeNumber);
        (function (pNumberContainer, callingFc, pButtonIndex) {
          that._delay(function () {
            that._drawBadgeNumber(pNumberContainer, callingFc, pButtonIndex);
          }, 100);
        })(badgeNumber, button.badgeNumber, i);
      }

      // Try to match with the link with the window url in case no active option is passed
      if (typeof this.options.active !== "string" || this.options.active.length === 0) {
        var firstParameter = window.location.search.match(/\?([^=]*)/);
        if (Array.isArray(firstParameter) === true && firstParameter.length > 0 && firstParameter[0] !== "?connector" && button.link.indexOf(firstParameter[0]) >= 0) {
          appButton.addClass('active');
        } else if (window.location.search === '' && button.link.indexOf('home=1') >= 0) {
          appButton.addClass('active');
        } else if (typeof window.location.href === "string") {
          if (typeof window.location.href.endsWith === "function" && window.location.href.endsWith(removeRelativePaths(button.link)) === true) {
            appButton.addClass('active');
          } else if (button.link.indexOf('?') === -1 && window.location.href.indexOf(button.link + "?") >= 0) {
            appButton.addClass('active');
          }
        }
      } else if (this.options.active === button.id) {
        appButton.addClass('active');
      }
      applications.append(appButton);
    }
    /* difference between larged format and ipad/medium format
     * 42 = 25 (image width) + (15 old padding - 3 new padding) 
     */
    this.diffSmallBig = i * 42;
    var buttonsRight = kSpan.clone().css('float', 'right').appendTo(this.element);
    if (this.options.showScopeSelector === true) {
      var scopeSelector = $('<label>').css({
        'vertical-align': 'baseline',
        display: 'inline-block',
        maxWidth: 150,
        'white-space': 'nowrap',
        overflow: 'hidden',
        marginLeft: 2,
        marginRight: 2
      }).text($.i18n._('nixps-cloudflow-top_navigation.scope')).add($('<select>').addClass('scopeSelector').css({
        'vertical-align': 'super',
        display: 'inline-block',
        marginLeft: 2,
        marginRight: 5
      }));
      buttonsRight.append(scopeSelector);
      this._refreshScopes().then(function () {
        scopeSelector.val($.cookie('scope'));
      });
    }
    if (this.options.showUser === true) {
      buttonsRight.append($('<a>').attr('href', '/?user_preferences=1').text(this.user.getFullName().toLowerCase()).css({
        'vertical-align': 'super',
        'color': 'inherit',
        marginLeft: 5,
        marginRight: 2
      }));
    }
    if (this.options.showLogout === true) {
      buttonsRight.append(kButton.clone().addClass('logout').attr('title', $.i18n._('nixps-cloudflow-top_navigation.logout')).css({
        'background-image': 'url(/portal/css/images/dark_bar_logout.png)',
        'backgroundPosition': '4px 4px',
        'backgroundRepeat': 'no-repeat',
        'vertical-align': 'bottom'
      }));
    }
  },
  _refreshScopes: function _refreshScopes() {
    var scopeSelector = this.element.find('.scopeSelector').empty();
    return getScopes().then(function (scopes) {
      for (var i = 0; i < scopes.length; i++) {
        var scope = scopes[i];
        scopeSelector.append($('<option>').attr('value', scope._id).text(scope.name));
      }
    });
  },
  /**
   * @description Function that do the drawing and refreshing of the badgenumbers
   * @function
   * @private
   * @name nixps-cloudflow.TopNavigation#_drawBadgeNumber
   * @param {type} pContainer
   * @param {type} pCallingFct
   * @param {type} pButtonIndex
   * @return {undefined}
   */
  _drawBadgeNumber: function _drawBadgeNumber(pContainer, pCallingFct, pButtonIndex) {
    clearTimeout(this.badgeNumberTimerIDs[pButtonIndex]);
    var that = this;
    $.when(pCallingFct()).done(function (pResults) {
      // reset ui
      pContainer.removeClass("topnavigation_badgenumber_length1 topnavigation_badgenumber_length2 topnavigation_badgenumber_length3").removeClass("topnavigation_badgenumber_max");
      // calc the number to show
      var number;
      if (typeof pResults === "number" && pResults > 0) {
        number = pResults;
      } else if (Array.isArray(pResults) && pResults.length > 0) {
        number = pResults.length;
      } else {
        // no number found
        pContainer.text("");
        return;
      }
      // set the number
      if (number > 999) {
        pContainer.text("> 999").addClass("topnavigation_badgenumber_max");
        pContainer.closest('button').addClass('button_extendneeded');
      } else {
        pContainer.text(number).addClass(function () {
          return "topnavigation_badgenumber_length" + $(this).html().length;
        });
        pContainer.closest('button').addClass('button_extendneeded');
      }
      that.badgeNumberTimerIDs[pButtonIndex] = that._delay(function () {
        that._drawBadgeNumber(pContainer, pCallingFct, pButtonIndex);
      }, 60000);
    }).fail(function (pError) {
      console.error(pError);
      // in case of error
      // reset
      pContainer.removeClass("topnavigation_badgenumber_length1 topnavigation_badgenumber_length2 topnavigation_badgenumber_length3").removeClass("topnavigation_badgenumber_max").text("");
      pContainer.closest('button').removeClass('button_extendneeded');
      // do not retry for some specific errors
      if (pError !== undefined && pError.error_code === "no_permission") {
        return;
      }
      // if fails, than retry
      that.badgeNumberTimerIDs[pButtonIndex] = that._delay(function () {
        that._drawBadgeNumber(pContainer, pCallingFct, pButtonIndex);
      }, 60000);
    });
  },
  _scopeChangedHandler: function _scopeChangedHandler(event) {
    var selector = $(event.target);
    $.cookie("scope", selector.val(), {
      path: '/'
    });
    window.location.reload();
  },
  _buttonClickedHandler: function _buttonClickedHandler(event) {
    var button = $(event.currentTarget);
    if (button.is('.logout') === true) {
      $.cookie('user_id', null, {
        path: '/'
      });
      $.cookie('user_hash', null, {
        path: '/'
      });
      $.cookie('expiration_date', null, {
        path: '/'
      });
      $.cookie('scope', null, {
        path: '/'
      });
      window.location.reload();
    } else {
      var link = button.attr('data-nixps-top-navigation-link');
      if (typeof link === 'string' && link.length > 0) {
        window.location = link;
      }
    }
  },
  _setOption: function _setOption(key, value) {
    if (key === 'buttons') {
      if (validateButtons(value) === false) {
        throw new Error('error in buttons list');
      }
      this._super(key, value);
      this._draw();
    } else if (key === 'showUser') {
      this._super(key, value === true);
      this._draw();
    } else if (key === 'showLogout') {
      this._super(key, value === true);
      this._draw();
    } else if (key === 'showScopeSelector') {
      this._super(key, value === true);
      this._draw();
    } else if (key === 'active') {
      this._super(key, value);
      this._draw();
    } else {
      throw new Error('invalid option: ' + key);
    }
  },
  _destroy: function _destroy() {
    if (Array.isArray(this.badgeNumberTimerIDs)) {
      for (var i = 0; i < this.badgeNumberTimerIDs.length; i++) {
        clearTimeout(this.badgeNumberTimerIDs[i]);
      }
    }
  }
});

},{}],232:[function(require,module,exports){
"use strict";

/**
 * @name Sequantial
 * @description Force an array of functions who returns deferred objects, to be called each after each other only when the previous defferred has been done
 * @author Guillaume
 * @version 1.0.0
 */
var Sequential = function Sequential() {
  this.functions = [];
};
Sequential.prototype = {
  constructor: Sequential,
  /**
   * @function
   * @name Sequential.add
   * @description append a function to the list, to be runed later on
   * @param {Function} pFunction The function to run
   * @param {Object} pThis This parameter of the function
   * @param {Array} pArgum An aray of arguments to be given to the function
   */
  add: function add(pFunction, pThis, pArgum) {
    this.functions.push({
      "function": pFunction,
      base: pThis,
      arg: pArgum
    });
  },
  /**
   * @function
   * @name Sequential.render
   * @description Start the process of the fucntions. To call them
   * @param {Object} pPreviousResults Leave this empty
   * @returns The final object of the last function
   */
  render: function render(pPreviousResults) {
    if (pPreviousResults === undefined) {
      pPreviousResults = [];
    }
    if (this.functions.length === 0) {
      return Promise.resolve(pPreviousResults);
    }
    var that = this;
    var item = this.functions.shift();
    return Promise.all([item["function"].apply(item.base, item.arg)]).then(function (pResult) {
      pPreviousResults.push(pResult[0]);
      return that.render(pPreviousResults);
    });
  }
};
module.exports = Sequential;

},{}],233:[function(require,module,exports){
"use strict";

var CloudflowURL = require("../../CloudflowUtil/js/CloudflowURL.js");
/**
 * @description A dictionary containing all the deferred object of ased files,
 * this is a cach to prevent loading files twice
 * @type {Object}
 * @default {}
 * @static
 * @private
 */
var askedLanguagesDef = {};
var fileMetadata = {};

// @param {Array.<String>} pLanguages An array containing all the languages you will use
var TranslationFiles = function TranslationFiles(pBasePath, pFileNameTemplate, pLanguages) {
  this._loading = false;
  this.languageDict = {};
  this._setBasePath(pBasePath);
  this._setFileNameTemplate(pFileNameTemplate);
  this.setLanguages(pLanguages);
  this.error = null;
};

/**
 * @description create a translationfiles from json
 * @function
 * @param {Object} json
 * @return {nm$_TranslationFiles.TranslationFiles}
 */
TranslationFiles.fromJSON = function (json) {
  return new TranslationFiles(json.basepath, json.filenametemplate, json.languages);
};

/**
 * @description Create a folder for the translations
 * @function
 * @name TranslationFiles#createFolder
 * @param {String} pNameProposition
 * @param {String} pFileStore
 * @param {String} pSubPath
 * @return {Deferred}
 */
TranslationFiles.createFolder = function (pPath) {
  if (typeof pPath !== "string" || pPath.length <= 0) {
    pPath = "PP_FILE_STORE/PageBuilder/Translations/";
  } else if (pPath[0] === "/") {
    pPath = pPath.slice(1); // remove leading slase
  }

  if (pPath.indexOf("cloudflow://") === 0) {
    pPath = pPath.slice(12);
  }
  try {
    pPath = decodeURI(pPath);
  } catch (e) {}
  var firstSlashIndex = pPath.indexOf('/') + 1;
  var rootFolder = "cloudflow://" + pPath.substring(0, firstSlashIndex);
  return $.Deferred(function (pDefer) {
    api_async.file.create_folder_with_options(rootFolder, pPath.slice(firstSlashIndex), {
      unique_name_mode: "None"
    }, function (result) {
      if (result !== undefined && typeof result.created_folder === "string" && result.created_folder.length > 0) {
        pDefer.resolve({
          url: result.created_folder
        });
      } else {
        pDefer.reject({
          error: "wrong return value api.file.create_folder",
          error_code: "wrong_return_interface"
        });
      }
    }, function (pError) {
      console.error(pError);
      pDefer.reject(pError);
    });
  });
};
TranslationFiles.prototype = {
  constructor: TranslationFiles,
  _setBasePath: function _setBasePath(pBasePath) {
    if (typeof pBasePath !== "string" || pBasePath.length <= 0) {
      throw new Error("TranslationFiles._setBasePath parameter must be a not empty string");
    }
    if (pBasePath[pBasePath.length - 1] !== "/") {
      // if not a path, make one 
      pBasePath += "/";
    }
    this.cloudflowPath = new CloudflowURL("", pBasePath, true);
  },
  _setFileNameTemplate: function _setFileNameTemplate(pFileNameTemplate) {
    if (typeof pFileNameTemplate !== "string" || pFileNameTemplate.length <= 0) {
      throw new Error("TranslationFiles._setFileNameTemplate parameter must be a not empty string");
    }
    this.fileNameTemplate = pFileNameTemplate;
  },
  setLanguages: function setLanguages(pLanguages) {
    if (Array.isArray(pLanguages) === false || pLanguages.length <= 0) {
      throw new Error("languages must be a not empty array");
    }
    this.languages = pLanguages.slice(); // copy
  },

  _getUploadUrl: function _getUploadUrl(pLang) {
    return this.cloudflowPath.getUploadPath() + this.fileNameTemplate + pLang + ".json";
  },
  _getCloudflowUrl: function _getCloudflowUrl(pLang) {
    return this.cloudflowPath.getCloudflowPath() + this.fileNameTemplate + pLang + ".json";
  },
  getCloudflowBasePath: function getCloudflowBasePath() {
    return this.cloudflowPath.getCloudflowPath();
  },
  makeHash: function makeHash() {
    return this.cloudflowPath.getCloudflowPath() + this.fileNameTemplate;
  },
  getFileNameTemplate: function getFileNameTemplate() {
    return this.fileNameTemplate;
  },
  getValue: function getValue() {
    return Object.assign({}, this.languageDict);
  },
  setValue: function setValue(pLanguageDict) {
    this.languageDict = Object.assign({}, pLanguageDict);
  },
  /**
   * @description Load all json key values of all languages
   * @function
   * @name TranslationFiles.loadData
   * @param {Function} the progress callback function
   * @return {Deferred}
   */
  loadData: function loadData(pProgressCB) {
    this._loading = true;
    var defs = [];
    for (var i = 0; i < this.languages.length; i++) {
      defs.push(this._loadLanguage(this.languages[i], pProgressCB));
    }
    var that = this;
    // each _loadLanguage should resolve and give at least an empty object or null
    return $.when.apply($, defs).then(function () {
      var errorObject = null;
      for (var i = 0; i < arguments.length; i++) {
        if (arguments[i] === null) {
          // in case of file not found or error durring loading
          if (that.languageDict[that.languages[i]] === undefined || $.isEmptyObject(that.languageDict[that.languages[i]])) {
            // original was unknown or empty, so no problem
            that.languageDict[that.languages[i]] = {};
          } else if ($.isPlainObject(that.languageDict[that.languages[i]]) && !$.isEmptyObject(that.languageDict[that.languages[i]])) {
            // original is not empty, and try ot overwrite with empty ....
            errorObject = {
              error_code: "try_overwrite_to_empty",
              error: "loading translation file fails"
            };
            continue;
          }
        } else {
          that.languageDict[that.languages[i]] = arguments[i];
        }
      }
      that._loading = false;
      if (errorObject !== null) {
        return $.Deferred().reject(errorObject);
      }
    }).fail(function (pError) {
      console.error(pError);
      that._loading = false;
    });
  },
  _loadLanguage: function _loadLanguage(pLang, pProgressCB) {
    var fileURL = this._getUploadUrl(pLang);
    if (askedLanguagesDef[fileURL] !== undefined) {
      return askedLanguagesDef[fileURL];
    }
    var cloudflowFileURL = this._getCloudflowUrl(pLang);
    askedLanguagesDef[fileURL] = $.Deferred(function (pDefer) {
      $.getJSON(fileURL, undefined, function (pData, pStatus, jqXHR) {
        var etagFormat = jqXHR.getResponseHeader("x-nixps-sourcetag");
        if (typeof etagFormat === "string" && etagFormat.length > 0 && etagFormat[0] === '"') {
          etagFormat = etagFormat.slice(1, -1);
        }
        fileMetadata[cloudflowFileURL] = {
          contentLength: parseInt(jqXHR.getResponseHeader("content-length")),
          etag: etagFormat,
          modification: undefined
        };
        if (typeof etagFormat === "string" && etagFormat.indexOf("mod=") === 0) {
          fileMetadata[cloudflowFileURL].modification = etagFormat.slice(4);
        }
      }).then(function (pTranlationJSON) {
        pDefer.resolve(pTranlationJSON);
      }, function (pErrorXDF, pSucces, pErrorString) {
        delete askedLanguagesDef[fileURL];
        if (pErrorString !== "Not Found") {
          // other errors then "Not found", this can be very dangerous!!
          var errorObject = {
            error_code: "loading_failed",
            // do not change error_code key
            error: _.escape("loading file " + fileURL + " has failed " + pErrorString),
            file: fileURL
          };
          if (typeof pProgressCB === "function") {
            pProgressCB(errorObject);
          }
          pDefer.notify(errorObject);
          if (api_async.logging !== undefined && api_async.logging.trace !== undefined) {
            api_async.logging.trace.log("com.nixps.pagebuilder.translations", "error", "Error durring loading " + fileURL + " -> " + pErrorString);
          }
          console.error("Failing to load a translation file", pErrorString);
        }
        pDefer.resolve(null);
      });
    });
    return askedLanguagesDef[fileURL];
  },
  /**
   * @description Save the changes to the backend, upload and save the json files 
   * @function
   * @name TranslationFiles.save
   * @return {Deferred}
   */
  save: function save() {
    var defs = [];
    var that = this;
    $.each(this.languageDict, function (lang, dict) {
      var urlToSave = that._getCloudflowUrl(lang);
      if ($.isPlainObject(dict) && $.isEmptyObject(dict) === false) {
        defs.push(that._saveFile(urlToSave, JSON.stringify(dict, null, "\t")));
      } else {
        console.error("attempt to write an empty object to " + urlToSave);
      }
    });
    if (Array.isArray(defs) && defs.length > 0) {
      return $.when.apply($, defs).fail(function (pError) {
        var recoverResult = that._recover(pError);
        if (recoverResult === false) {
          if (api_async.logging !== undefined && api_async.logging.trace !== undefined) {
            api_async.logging.trace.log("com.nixps.pagebuilder.translations", "error", "could not save translationfile: " + JSON.stringify(pError));
          }
        } else {
          // result is deferred object, so folders has been created
          var currentError = this._getError();
          if (currentError === null) {
            that._setError({
              error: "upload_folder_not_exists"
            });
            return recoverResult.then(function () {
              // resave all
              return that.save();
            });
          }
        }
        return $.Deferred().reject(pError);
      });
    } else {
      console.warn("No languages are saved during the saving operation");
      return $.Deferred().resolve();
    }
  },
  /**
   * @description Remove some language files
   * @function
   * @name TranslationFiles.removeLanguages
   * @param {Array.<String>} pLanguages the iso code of the languages you want to remove
   * @return {deferred}
   */
  removeLanguages: function removeLanguages(pLanguages) {
    if (Array.isArray(pLanguages) === false || pLanguages.length <= 0) {
      throw new Error("pLanguages must be a not empty array");
    }
    var defFileRemove = [];
    var that = this;
    for (var i = 0; i < pLanguages.length; i++) {
      (function (pURL, pLanguage) {
        defFileRemove.push($.Deferred(function (pDefer) {
          api_async.file.delete_file_with_options(pURL, {
            "ignore_missing_file": true
          }, function (pResult) {
            delete that.languageDict[pLanguage];
            that.languages = that.languages.filter(function (lang) {
              return lang !== pLanguage;
            });
            pDefer.resolve(pResult);
          }, function (pError) {
            console.error(pError);
            pDefer.resolve("");
          });
        }));
      })(this._getCloudflowUrl(pLanguages[i]), pLanguages[i]);
    }
    return $.when.apply($, defFileRemove);
  },
  /**
   * @description Remove the folder where all translation files are located
   * @function
   * @name TranslationFiles.removeAllLanguages
   * @return {deferred}
   */
  removeAllLanguages: function removeAllLanguages() {
    var that = this;
    var folderurl = this.cloudflowPath.getCloudflowPath();
    return $.Deferred(function (pDefer) {
      api_async.file.delete_folder_with_options(folderurl, {
        "ignore_missing_folder": true
      }, function (pResult) {
        that.languageDict = {};
        pDefer.resolve(pResult);
      }, function (pError) {
        console.error(pError);
        pDefer.reject(pError);
      });
    });
  },
  _recover: function _recover(pError) {
    if (pError !== undefined && pError.error_code === "generic" && pError.messages !== undefined && Array.isArray(pError.messages.messages) && pError.messages.messages.length > 0) {
      if (pError.messages.messages[0].type === "Upload Folder does not exist") {
        return TranslationFiles.createFolder(this.cloudflowPath.getCloudflowPath());
      }
    }
    return false;
  },
  _saveFile: function _saveFile(pURL, pContent) {
    if (typeof pURL !== "string" || pURL.length <= 0) {
      throw new Error("parameter pURL must be a string");
    }
    var checkes = "";
    if (fileMetadata[pURL] !== undefined) {
      if (typeof fileMetadata[pURL].etag === "string" && fileMetadata[pURL].etag.length > 0) {
        if (fileMetadata[pURL].etag.indexOf("mod=") === 0) {
          checkes = "&check_modification=" + fileMetadata[pURL].etag.slice(4);
        } else {
          checkes = "&check_etag=" + fileMetadata[pURL].etag;
        }
      } else if (typeof fileMetadata[pURL].modification === "number" || typeof fileMetadata[pURL].modification === "string" && fileMetadata[pURL].modification.length > 0) {
        checkes = "&check_modification=" + fileMetadata[pURL].modification;
      }
    }
    return $.Deferred(function (pDefer) {
      var boundary = "----nixpscloudflowpagebuilder" + Date.now();
      // attention keep this header clean,
      // header need to use \r\n for new lines
      // header may not have spaces before or after header keys
      var sendContent = "--" + boundary + '\r\nContent-Type: text/json\r\nContent-Disposition: form-data;filename="dumyblabla.json"\r\n\r\n' + pContent;
      sendContent = sendContent + "\r\n--" + boundary + "--\r\n";
      var upload_url = "/portal.cgi?asset=upload_file&url=" + encodeURIComponent(pURL) + "&overwrite=true&create_folders=true" + checkes;
      $.ajax({
        type: "POST",
        url: upload_url,
        data: sendContent,
        processData: true,
        contentType: "text/plain; charset=UTF-8",
        success: function success(output, pStatus, jqXHR) {
          if (pStatus === "success") {
            var data = output;
            if (typeof output === "string" && output.length > 0) {
              try {
                data = JSON.parse(output);
              } catch (e) {
                pDefer.reject(output);
              }
            }
            if (Array.isArray(data.files)) {
              if (data.files.length === 1) {
                // etag has been changed, but what is the new value??
                if (fileMetadata[pURL] === undefined) {
                  fileMetadata[pURL] = {};
                }
                fileMetadata[pURL].etag = "";
                fileMetadata[pURL].modification = undefined;
                if (Array.isArray(data.file_info) && data.file_info.length === 1) {
                  if (typeof data.file_info[0].etag === "string") {
                    fileMetadata[pURL].etag = data.file_info[0].etag;
                  }
                  if (typeof data.file_info[0].modification === "number") {
                    fileMetadata[pURL].modification = data.file_info[0].modification;
                  }
                }
                pDefer.resolve(pContent);
              } else if (data.files.length === 0) {
                // file has been ignored!!!
                pDefer.reject({
                  "error_code": "Document not saved",
                  "error": "saving conflict, the file has been modified by somebody else"
                });
              } else {
                // really strange thing
                pDefer.reject({
                  "error_code": "unknown_error",
                  "error": "unknown error"
                });
              }
            } else {
              pDefer.reject({
                "error": "wrong_return_output"
              });
            }
          } else {
            pDefer.reject(output);
          }
        },
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + boundary);
          var csrfToken = api_util.get_cookie("csrf-token");
          if (typeof csrfToken === "string" && csrfToken.length > 0) {
            xhr.setRequestHeader("X-Csrf-Token", csrfToken);
          }
        }
      }).fail(function (pError) {
        if (pError !== undefined && typeof pError.responseText === "string") {
          try {
            pDefer.reject(JSON.parse(pError.responseText));
          } catch (e) {
            pDefer.reject(pError.responseText);
          }
        } else {
          pDefer.reject(pError);
        }
      });
    });
  },
  clone: function clone() {
    return TranslationFiles.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {
      basepath: this.cloudflowPath.getCloudflowPath(),
      filenametemplate: this.fileNameTemplate,
      languages: this.languages
    };
  },
  _setError: function _setError(pError) {
    this.error = pError;
  },
  _getError: function _getError() {
    return this.error;
  },
  clear: function clear() {
    askedLanguagesDef = {};
  }
};
module.exports = TranslationFiles;

},{"../../CloudflowUtil/js/CloudflowURL.js":80}],234:[function(require,module,exports){
"use strict";

// requires
var XLIFFHandler = require("./XLIFFHandler.js");
var TranslationFiles = require('./TranslationFiles.js');
var TranslationObject = require('./TranslationObject.js');
var CloudflowObject = require('../../CloudflowUtil/js/CloudflowObject.js');
var Sequential = require("./Sequential.js");

/**
 * @description All the supported languages and there names and native names
 * @type {Object}
 * @static
 * @private
 */
var kISOLanguages = Object.freeze({
  "fr": {
    "name": "French",
    "nativeName": "français"
  },
  "en": {
    "name": "English",
    "nativeName": "English"
  },
  "de": {
    "name": "German",
    "nativeName": "Deutsch"
  },
  "es": {
    "name": "Spanish",
    "nativeName": "español"
  },
  "it": {
    "name": "Italian",
    "nativeName": "Italiano"
  },
  "pl": {
    "name": "Polish",
    "nativeName": "polski"
  },
  "ru": {
    "name": "Russian",
    "nativeName": "русский язык"
  },
  "ja": {
    "name": "Japanese",
    "nativeName": "日本語 (にほんご／にっぽんご)"
  },
  "zh": {
    "name": "Chinese",
    "nativeName": "中文 (Zhōngwén), 汉语, 漢語"
  }
});
/**
 * @description All the languages we support in the ui, that the user can changed to
 * @type {Array}
 * @static
 * @private
 */
var supportedLanguages = Object.keys(kISOLanguages);
function isSupportedLanguage(pLanguage) {
  // even if language is not string, than in that case it will also not be in the array and return false
  return supportedLanguages.includes(pLanguage);
}
var xlifffile_url_language_regexp = new RegExp(/_([a-z][a-z])[.][a-z]+$/);
function getLanguageOfURL(pFileURL) {
  if (typeof pFileURL === "string" && pFileURL.length > 0) {
    var languageMatch = pFileURL.match(xlifffile_url_language_regexp);
    if (Array.isArray(languageMatch) && languageMatch.length > 1 && typeof languageMatch[1] === "string" && languageMatch[1].length > 0 && isSupportedLanguage(languageMatch[1])) {
      return languageMatch[1];
    }
  }
  return null;
}

/**
 * @constructor TranslationHandler
 * @param {String} pBasePath The upload path of the json file 
 * @param {String} pFileNameTemplate The file name template, of the translation json file on disk
 * @param {Array.<String>} pLanguages An array containing all the languages you will use
 * @return {nm$_TranslationHandler.TranslationHandler}
 */
function TranslationHandler(pSourceType, pSourceOptions, pLanguages, pMainLanguage) {
  // object containing all the languages key values of all translations strings
  this.languageDict = {};
  // which files must we consult?
  this._setSource(pSourceType, pSourceOptions);
  // all languages strings where we will work with
  this.languages = [];
  this.setLanguages(pLanguages);
  if (typeof pMainLanguage === "string" && this.languages.includes(pMainLanguage)) {
    this.mainLanguage = pMainLanguage;
    // move main language to top
    if (this.languages[0] !== this.mainLanguage) {
      var mainLanguageIndex = this.languages.indexOf(this.mainLanguage);
      // remove main language
      this.languages.splice(mainLanguageIndex, 1);
      // add main language at the start
      this.languages.unshift(this.mainLanguage);
    }
  } else {
    this.mainLanguage = this.languages[0];
  }
  this.externalLanguageDictToBeSaved = {};
}
;

/**
 * @description create a translationhandler from json
 * @function
 * @param {Objecr} json
 * @return {TranslationHandler.TranslationHandler}
 */
TranslationHandler.fromJSON = function (json) {
  if (typeof json.source_type === "string") {
    return new TranslationHandler(json.source_type, json.source_options, json.languages, json.main_language);
  } else if (typeof json.basepath === "string") {
    // old format
    return new TranslationHandler("file", {
      "basepath": json.basepath,
      "filenametemplate": json.filenametemplate,
      "languages": json.languages
    }, json.languages, json.main_language);
  }
};

/**
 * @description Get all the information of all supported languages
 * @function 
 * @name TranslationHandler#getIsoLanguages
 * @return {TranslationHandler.isoLanguages}
 */
TranslationHandler.getIsoLanguages = function () {
  return kISOLanguages;
};
TranslationHandler.getNativeNameLanguages = function () {
  return Object.values(kISOLanguages).map(function (pLanguageInfo, pLanguageCode) {
    return pLanguageInfo.nativeName;
  });
};
TranslationHandler.getNativeNameLanguage = function (pIsoCode) {
  var languageInfo = kISOLanguages[pIsoCode];
  if (languageInfo !== undefined && typeof languageInfo.nativeName === "string") {
    return languageInfo.nativeName;
  } else {
    return null;
  }
};
TranslationHandler.getIsoCodeLanguage = function (pNativeName) {
  for (var pLanguageCode in kISOLanguages) {
    if (kISOLanguages[pLanguageCode].nativeName === pNativeName) {
      return pLanguageCode;
    }
  }
  return null;
};

/**
 * @description Create a folder for the translations
 * @function
 * @name TranslationHandler#createFolder
 * @param {String} pNameProposition
 * @param {String} pFileStore
 * @param {String} pSubPath
 * @return {Deferred}
 */
TranslationHandler.createFolder = function (pPath) {
  return TranslationFiles.createFolder(pPath);
};
TranslationHandler.prototype = {
  constructor: TranslationHandler,
  _setSource: function _setSource(pSourceType, pSourceOptions) {
    this.sourceType = pSourceType;
    this.translationSource;
    this.originalLanguageDict;
    if (this.sourceType === "file") {
      if (Array.isArray(pSourceOptions.languages) === false || pSourceOptions.languages.length === 0) {
        pSourceOptions.languages = supportedLanguages.slice();
      }
      if ($.isPlainObject(pSourceOptions)) {
        this.translationSource = TranslationFiles.fromJSON(pSourceOptions);
      } else if (pSourceOptions instanceof TranslationFiles) {
        this.translationSource = pSourceOptions;
      }
    } else if (this.sourceType === "object") {
      if ($.isPlainObject(pSourceOptions)) {
        this.translationSource = TranslationObject.fromJSON(pSourceOptions);
      } else if (pSourceOptions instanceof TranslationObject) {
        this.translationSource = pSourceOptions;
      }
      this.languageDict = this.translationSource.getValue();
      this.originalLanguageDict = $.extend(true, {}, this.languageDict);
    } else {
      throw new Error("invalid source type found for translations");
    }
  },
  getSourceType: function getSourceType() {
    return this.sourceType;
  },
  makeHash: function makeHash() {
    return this.translationSource.makeHash();
  },
  /**
   * @description Load all json key values of all languages
   * @function
   * @name TranslationHandler.loadData
   * @param {Function} the progressCallback function
   * @return {Deferred}
   */
  loadData: function loadData(pProgressCB) {
    var that = this;
    return this.translationSource.loadData(pProgressCB).then(function () {
      that.languageDict = that.translationSource.getValue();
      that.originalLanguageDict = $.extend(true, {}, that.languageDict);
    });
  },
  /**
   * @description Reload all json key values of all languages
   * @function
   * @name TranslationHandler.reloadData
   * @returns {Deferred}
   */
  reloadData: function reloadData() {
    this.translationSource.clear();
    return this.loadData();
  },
  partialDifferenceSave: function partialDifferenceSave() {
    var that = this;
    var changesFound = false;
    var differencesDict = {};
    for (var language in this.languageDict) {
      if (this.originalLanguageDict[language] !== undefined) {
        // known language
        differencesDict[language] = CloudflowObject.difference(this.originalLanguageDict[language], this.languageDict[language]);
        if (changesFound === false && (!$.isEmptyObject(differencesDict[language].added) || !$.isEmptyObject(differencesDict[language].changed) || differencesDict[language].deleted.length > 0)) {
          changesFound = true;
        }
      } else {
        // new language not known from start
        differencesDict[language] = {
          added: Object.assign({}, this.languageDict[language]),
          changed: {},
          deleted: []
        };
        changesFound = true;
      }
    }
    if (changesFound === true) {
      return this.reloadData().then(function () {
        for (var language in differencesDict) {
          that.languageDict[language] = CloudflowObject.applyDifference(differencesDict[language], that.languageDict[language]);
        }
        return that.save();
      });
    }
    return $.Deferred().resolve();
  },
  /**
   * @description Add or update a translation key value for a specific language
   * @function
   * @name TranslationHandler.update
   * @param {String} pLanguage the language code
   * @param {String} pKey The translation key to be updated or added
   * @param {String} pValue The translated string
   * @return {undefined}
   */
  update: function update(pLanguage, pKey, pValue) {
    if (typeof pLanguage !== "string" || pLanguage.length <= 0) {
      throw new Error("TranslationHandler.update parameter pLanguage must be a string");
    }
    if (typeof pKey !== "string" || pKey.length <= 0) {
      throw new Error("TranslationHandler.update parameter pKey must be a string");
    }
    if (typeof pValue !== "string") {
      throw new Error("TranslationHandler.update parameter pValue must be a string");
    }
    var langDict = this.languageDict[pLanguage];
    if ($.isEmptyObject(langDict)) {
      this.languageDict[pLanguage] = {};
    }
    this.languageDict[pLanguage][pKey] = pValue;
  },
  /**
   * @description Remove a subset of keys in all languages
   * @function
   * @name TranslationHandler.remove
   * @param {String} pKeyPrefix Remove all key that begins with pKeyPrefix
   * @return {undefined}
   */
  remove: function remove(pKeyPrefix) {
    var removeDict = {};
    $.each(this.languageDict, function (lang, dict) {
      $.each(dict, function (translationkey, translation) {
        if (translationkey.slice(0, pKeyPrefix.length) === pKeyPrefix) {
          if (removeDict[translationkey] === undefined) {
            removeDict[translationkey] = {};
          }
          removeDict[translationkey][lang] = dict[translationkey];
          delete dict[translationkey];
          delete $.i18n.dict[translationkey];
        }
      });
    });
    return removeDict;
  },
  removeExact: function removeExact(pKey) {
    if (typeof pKey !== "string" || pKey.length <= 0) {
      throw new Error("parameter pkey should be a not empty string");
    }
    var removeDict = {};
    if (removeDict[pKey] === undefined) {
      removeDict[pKey] = {};
    }
    for (var lang in this.languageDict) {
      if (this.languageDict[lang][pKey]) {
        removeDict[pKey][lang] = this.languageDict[lang][pKey];
        delete this.languageDict[lang][pKey];
      }
    }
    delete $.i18n.dict[pKey];
    return removeDict;
  },
  /**
   * @description duplicate all the keys with a specific prefic
   * @function
   * @name TranslationHandler.copy
   * @param {String} pKeyPrefix The key to copy from
   * @param {String} pNewKeyPrefix The key to copy to
   */
  copy: function copy(pKeyPrefix, pNewKeyPrefix) {
    if (typeof pKeyPrefix !== "string" || pKeyPrefix.length <= 0) {
      throw new Error("TranslationHandler.copy input parameter pKeyPrefix must be a not empty string");
    }
    if (typeof pNewKeyPrefix !== "string" || pNewKeyPrefix.length <= 0) {
      throw new Error("TranslationHandler.copy input parameter pNewKeyPrefix must be a not empty string");
    }
    var that = this;
    var prefixFound = false;
    $.each(this.languageDict, function (lang, dict) {
      $.each(dict, function (translationkey, translation) {
        if (translationkey.slice(0, pKeyPrefix.length) === pKeyPrefix) {
          var newTranslationKey = pNewKeyPrefix + translationkey.slice(pKeyPrefix.length);
          dict[newTranslationKey] = dict[translationkey];
          if (lang === that._getMainLanguage()) {
            $.i18n.dict[newTranslationKey] = dict[newTranslationKey];
          }
          prefixFound = true;
        }
      });
    });
    return prefixFound;
  },
  /**
   * @description Get all the translations of all the languages for a specific translation key
   * @function
   * @name TranslationHandler.getValues
   * @param {String} pKey The translationkey
   * @return {Object} Object with the language code as key and the corresponding translated strings as value
   */
  getValues: function getValues(pKey) {
    if (typeof pKey !== "string" || pKey.length <= 0) {
      throw new Error("TranslationHandler.getValues parameter pKey must be a not empty string");
    }
    var outputValues = {};
    $.each(this.languageDict, function (lang, dict) {
      outputValues[lang] = dict[pKey];
    });
    return outputValues;
  },
  /**
   * @description Is the translation key known or not?
   * @function
   * @name TranslationHandler.containsKey
   * @private
   * @param {String} pKey
   * @return {Boolean}
   */
  containsKey: function containsKey(pKey) {
    if (typeof pKey !== "string" || pKey.length <= 0) {
      throw new Error("TranslationHandler.containsKey parameter pKey must be a not empty string");
    }
    return this.languageDict[this._getMainLanguage()] !== undefined && typeof this.languageDict[this._getMainLanguage()][pKey] === "string";
  },
  /**
   * @description replace all translation keys to new keys, in case of a duplication of an old page
   * @function
   * @name TranslationHandler.changeKeys
   * @private
   * @param {Object} pChangeKeysDict the dict of all keys
   */
  changeKeys: function changeKeys(pChangeKeysDict) {
    // loop over all translations and replace the keys
    var that = this;
    $.each(this.languageDict, function (lang, dict) {
      $.each(pChangeKeysDict, function (pOldKey, pNewKey) {
        if (that.languageDict[lang][pOldKey] !== undefined) {
          that.languageDict[lang][pNewKey] = that.languageDict[lang][pOldKey];
          delete that.languageDict[lang][pOldKey];
        }
      });
    });
  },
  /**
   * @description replace all translation keys to new keys, in case of a duplication of a page
   * @function
   * @name TranslationHandler.duplicateKeys
   * @private
   * @param {Object} pChangeKeysDict the dict of all keys
   */
  duplicateKeys: function duplicateKeys(pChangeKeysDict) {
    // loop over all translations and replace the keys
    var that = this;
    $.each(this.languageDict, function (lang, dict) {
      $.each(pChangeKeysDict, function (pOldKey, pNewKey) {
        if (that.languageDict[lang][pOldKey] !== undefined) {
          that.languageDict[lang][pNewKey] = that.languageDict[lang][pOldKey];
        }
      });
    });
  },
  /**
   * @description Get the folder cloudflow url, where all translation files are located
   * @function
   * @name TranslationHandler.getCloudflowBasePath
   * @return {String} the folder cloudflow url
   */
  getCloudflowBasePath: function getCloudflowBasePath() {
    return this.translationSource.getCloudflowBasePath();
  },
  /**
   * @description Get all languages. The languages are iso codes
   * @function
   * @name TranslationHandler.getLanguages
   * @return {Array} All known iso codes of all languages
   */
  getLanguages: function getLanguages() {
    return this.languages;
  },
  /**
   * @description Get the dict of the main language
   * @function
   * @name TranslationHandler.getMainLanguageDict
   * @return {Object} The dictionary of the main language
   */
  getMainLanguageDict: function getMainLanguageDict() {
    return this.languageDict[this.mainLanguage];
  },
  setLanguageDict: function setLanguageDict(pLanguageDict) {
    this.languageDict = pLanguageDict;
  },
  getLanguageDict: function getLanguageDict() {
    return this.languageDict;
  },
  /**
   * @description Change all languages, if no array is given, all cloudflow supported languages are set
   * @function
   * @name TranslationHandler.setLanguages
   * @param {Array} pLanguages The iso languages codes, you want to use
   * @return {undefined}
   */
  setLanguages: function setLanguages(pLanguages, pReloadData) {
    if (Array.isArray(pLanguages) === false || pLanguages.length <= 0) {
      // fall back to all supported languages
      this.languages = supportedLanguages.slice();
    } else {
      for (var i = 0; i < pLanguages.length; i++) {
        if (isSupportedLanguage(pLanguages[i]) === false) {
          throw new Error("unsupported language found " + pLanguages[i]);
        }
      }
      var missingLanguages = _.difference(this.languages, pLanguages);
      for (var i = 0; i < missingLanguages.length; i++) {
        delete this.languageDict[missingLanguages[i]];
      }
      this.languages = pLanguages.slice();
      if (this.sourceType === "file") {
        this.translationSource.setLanguages(this.languages);
      }
      if (pReloadData === true) {
        return this.loadData();
      }
    }
  },
  _getMainLanguage: function _getMainLanguage() {
    return this.mainLanguage;
  },
  /**
   * @description Get all not empty languages that will be removed if the parameters are the new languages 
   * @function
   * @name TranslationHandler.getMissingLanguages
   * @param {Array.<String>} pLanguages the new applied languages
   * @return {Array|nm$_TranslationHandler.TranslationHandler.prototype.getMissingLanguages.missinglanguages|Object.prototype.getMissingLanguages.missinglanguages}
   */
  getMissingLanguages: function getMissingLanguages(pLanguages) {
    var possibleMissingLanguages = _.difference(this.languages, pLanguages);
    var missinglanguages = [];
    for (var i = 0; i < possibleMissingLanguages.length; i++) {
      if ($.isEmptyObject(this.languageDict[possibleMissingLanguages[i]]) === false) {
        missinglanguages.push(possibleMissingLanguages[i]);
      }
    }
    return missinglanguages;
  },
  /**
   * @description Does it countains not empty languages or not?
   * @function
   * @name TranslationHandler.containsExistingLanguages
   * @return {Boolean}
   */
  containsExistingLanguages: function containsExistingLanguages() {
    var emptyFound = false;
    $.each(this.languageDict, function (languageCode, translations) {
      if ($.isEmptyObject(translations) === false) {
        emptyFound = true;
        return false;
      }
    });
    return emptyFound;
  },
  /**
   * @description Apply the changed saved in the component on the current i18n dictionary of the current page
   * @function
   * @name TranslationHandler.applyLanguage
   * @param {String} pLanguage The language code
   * @return {undefined}
   */
  applyLanguage: function applyLanguage(pLanguage) {
    if (isSupportedLanguage(pLanguage) === false) {
      throw new Error("unsupported language found " + pLanguage);
    }
    var translations = this.languageDict[pLanguage];
    if ($.isPlainObject(translations)) {
      this._mergeToTranslationi18n(translations);
    }
  },
  /**
   * @description reset the general translation plugin to clear the language
   * @function
   * @name TranslationHandler.resetLanguage
   * @param {String} pLanguage The language code to be removed
   */
  resetLanguage: function resetLanguage(pLanguage) {
    if (isSupportedLanguage(pLanguage) === false) {
      throw new Error("unsupported language found " + pLanguage);
    }
    var translations = this.languageDict[pLanguage];
    if ($.isPlainObject(translations)) {
      this._removeFromTranslationi18n(translations);
    }
  },
  _mergeToTranslationi18n: function _mergeToTranslationi18n(pObject) {
    if ($.isPlainObject(pObject)) {
      var oldDict = $.i18n.dict;
      if (oldDict === null) {
        $.i18n.setDictionary(pObject);
      } else {
        $.i18n.setDictionary(Object.assign(oldDict, pObject));
      }
    } else {
      console.warn("try to merge a not object to the translation keys");
    }
  },
  _removeFromTranslationi18n: function _removeFromTranslationi18n(pObject) {
    var amountRemovedKeys = 0;
    if ($.isPlainObject(pObject)) {
      for (var key in pObject) {
        if ($.i18n.dict[key] === pObject[key]) {
          delete $.i18n.dict[key];
          amountRemovedKeys++;
        }
      }
    }
    return amountRemovedKeys;
  },
  clone: function clone() {
    return TranslationHandler.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var options = {};
    options = this.translationSource.toJSON();
    return {
      "source_type": this.sourceType,
      "source_options": options,
      "languages": this.languages,
      "main_language": this.mainLanguage
    };
  },
  /**
   * @description Save the changes to the backend, upload and save the json files 
   * @function
   * @name TranslationHandler.save
   * @return {Deferred}
   */
  save: function save() {
    var that = this;
    if ($.isEmptyObject(this.externalLanguageDictToBeSaved)) {
      this.translationSource.setValue(this.languageDict);
      return this.translationSource.save();
    } else {
      this.translationSource.setValue(this.languageDict);
      var normalSaveDef = this.translationSource.save();
      var newTranslationSource = new TranslationFiles(this.translationSource.getCloudflowBasePath(), this.translationSource.getFileNameTemplate(), Object.keys(this.externalLanguageDictToBeSaved));
      newTranslationSource.setValue(this.externalLanguageDictToBeSaved);
      var extraSaveDef = newTranslationSource.save();
      extraSaveDef.done(function () {
        // they are savely saved, so clear
        that.externalLanguageDictToBeSaved = {};
      });
      return $.when(normalSaveDef, extraSaveDef);
    }
  },
  clear: function clear() {
    return this.translationSource.clear();
  },
  /**
   * @description Remove some language files
   * @function
   * @name TranslationHandler.removeLanguages
   * @param {Array.<String>} pLanguages the iso code of the languages you want to remove
   * @return {deferred}
   */
  removeLanguages: function removeLanguages(pLanguages) {
    if (Array.isArray(pLanguages) === false || pLanguages.length <= 0) {
      throw new Error("pLanguages must be a not empty array");
    }
    this.translationSource.setValue(this.languageDict);
    var that = this;
    return this.translationSource.removeLanguages(pLanguages).then(function () {
      that.languageDict = that.translationSource.getValue();
      that.languages = [];
      for (var langCode in that.languageDict) {
        if (typeof langCode === "string" && langCode.length > 0) {
          that.languages.push(langCode);
        }
      }
    });
  },
  /**
   * @description Remove the folder where all translation files are located
   * @function
   * @name TranslationHandler.removeAllLanguages
   * @return {deferred}
   */
  removeAllLanguages: function removeAllLanguages() {
    var that = this;
    return this.translationSource.removeAllLanguages().then(function () {
      that.languageDict = {};
    });
  },
  includeXLIFF: function includeXLIFF(pURL, pHTMLPage, pTranslationPrefixKey, pExtraWhitepapers) {
    if (typeof pURL !== "string" || pURL.length <= 0) {
      throw new Error("input parameter pFolderURL must be a not empty string");
    }
    if (pURL[pURL.length - 1] === "/") {
      var that = this;
      return XLIFFHandler.retrieveFileURLs(pURL).then(function (pFileURLs) {
        if (Array.isArray(pFileURLs) === false || pFileURLs.length <= 0) {
          console.warn("No languages retrieved");
          return $.Deferred().resolve([{
            "error": "unknown_language"
          }]);
        }
        var defs = [];
        for (var i = 0; i < pFileURLs.length; i++) {
          defs.push(that._includeXLIFFFile(pFileURLs[i], pHTMLPage, pTranslationPrefixKey));
        }
        defs.push(that._importMetadataHTMLPageToXLIFF(pHTMLPage, pFileURLs, pExtraWhitepapers));
        return $.when.apply($, defs).then(function () {
          var result = [];
          for (var i = 0; i < arguments.length; i++) {
            if (arguments[i] !== undefined && arguments[i].language !== undefined) {
              result.push(arguments[i]);
            } else if (Array.isArray(arguments[i]) && arguments[i].length > 0) {
              for (var a = 0; a < arguments[i].length; a++) {
                if (arguments[i][a] !== undefined && arguments[i][a].language !== undefined) {
                  result.push(arguments[i][a]);
                }
              }
            }
          }
          return result;
        });
      });
    } else {
      return $.when(this._includeXLIFFFile(pURL, pHTMLPage, pTranslationPrefixKey), this._importMetadataHTMLPageToXLIFF(pHTMLPage, [pURL], pExtraWhitepapers)).then(function (pResults, pMetadataResults) {
        return [pResults].concat(pMetadataResults);
      });
    }
  },
  _includeXLIFFFile: function _includeXLIFFFile(pURL, pHTMLPage, pTranslationPrefixKey) {
    if (typeof pURL !== "string" || pURL.length <= 0) {
      throw new Error("input parameter pFolderURL must be a not empty string");
    }
    var HTMLPageID = pHTMLPage.getID();
    var that = this;
    return XLIFFHandler.fromURL(pURL).then(function (pXLIFFHandler) {
      var language = pXLIFFHandler.getTargetLanguage(HTMLPageID);
      if (typeof language !== "string" || language.length <= 0) {
        language = getLanguageOfURL(pURL);
        if (typeof language !== "string" || language.length <= 0) {
          console.error("_includeXLIFFFile: unknown language to import");
          // set url as languages to parent calls can do more debugging
          if (language === undefined || language === null) {
            language = pURL;
          }
          console.error("_includeXLIFFFile: unknown language to import");
          return $.Deferred().resolve({
            language: language,
            language_name: language,
            translations_keys: 0,
            page_keys: 0,
            error: "unknown_language"
          });
        }
      }
      var nativeLanguageName = TranslationHandler.getNativeNameLanguage(language);
      var importedDict = pXLIFFHandler.getLanguageDict(HTMLPageID);
      if ($.isPlainObject(importedDict) === false || $.isEmptyObject(importedDict)) {
        console.error("xliff file does not contain any translations at all");
        return {
          language: language,
          language_name: nativeLanguageName,
          translations_keys: 0,
          page_keys: 0,
          error: "no_translations_found"
        };
      }
      var originalAmount = Object.keys(importedDict).length;
      var pageKeys = 0;
      for (var pKey in importedDict) {
        if (typeof pKey === "string") {
          if (pKey.indexOf("pb-") !== 0 && pKey.indexOf("custom-") !== 0 && pKey.indexOf("sidebar-") !== 0) {
            // only pagebuilder strings are allowed
            delete importedDict[pKey];
          } else if (pKey.indexOf(pTranslationPrefixKey) === 0) {
            pageKeys++;
          }
        }
      }
      ;
      if ($.isEmptyObject(importedDict)) {
        console.error("no corresponding translations");
        return {
          language: language,
          language_name: nativeLanguageName,
          translations_keys: originalAmount,
          page_keys: 0,
          error: "no_translations_found"
        };
      }
      if (that.languageDict[language] === undefined) {
        // unkown language
        if (that.externalLanguageDictToBeSaved[language] === undefined) {
          that.externalLanguageDictToBeSaved[language] = {};
        }
        that.externalLanguageDictToBeSaved[language] = Object.assign(that.externalLanguageDictToBeSaved[language], importedDict);
      } else {
        // known language
        that.languageDict[language] = Object.assign(that.languageDict[language], importedDict);
      }
      return {
        language: language,
        language_name: nativeLanguageName,
        translations_keys: originalAmount,
        page_keys: pageKeys
      };
    });
  },
  /**
   * @description Export to xliff files
   * @function
   * @name TranslationHandler.exportToXLIFFs
   * @param {String} pFolderURL
   * @param {String} pHTMLPage
   * @param {String} pHTMLPageURL
   * @param {String} pHTMLCreator
   * @return {undefined}
   */
  exportToXLIFFs: function exportToXLIFFs(pFolderURL, pHTMLPage, pHTMLPageURL, pHTMLCreator, pExtraWhitepaperNames) {
    if (typeof pFolderURL !== "string" || pFolderURL.length <= 0) {
      throw new Error("input parameter pFolderURL must be a not empty string");
    }
    if (pFolderURL[pFolderURL.length - 1] !== "/") {
      pFolderURL += "/";
    }
    var HTMLPageID = pHTMLPage.getID();
    var fileNameTemplate = this.translationSource.getFileNameTemplate();
    var that = this;
    return $.when(XLIFFHandler.retrieveFileURLs(pFolderURL, fileNameTemplate)).then(function (pFileURLs) {
      var languageCodesToExport = supportedLanguages;
      var xliffsLangURLDict = {};
      for (var i = 0; i < pFileURLs.length; i++) {
        var language_code = getLanguageOfURL(pFileURLs[i]);
        if (typeof language_code === "string" && language_code.length > 0) {
          xliffsLangURLDict[language_code] = pFileURLs[i];
          if (languageCodesToExport.includes(language_code) === false) {
            // add unknown language
            languageCodesToExport.push(language_code);
          }
        } else {
          console.warn("exportToXLIFFs: could not parse language of  ", pFileURLs[i]);
        }
      }
      var defs = [];
      var fileURLs = [];
      var mainLanguage = that._getMainLanguage();
      for (var langIndex = 0; langIndex < languageCodesToExport.length; langIndex++) {
        var language = languageCodesToExport[langIndex];
        var dict = that.languageDict[language];
        if (dict === undefined) {
          dict = {};
        }
        var sourceLanguage = mainLanguage;
        var targetLanguage = mainLanguage === language ? undefined : language;
        var targetDict = mainLanguage === language ? undefined : dict;
        var fileExtention = ".xliff";
        var xliffFileDef;
        if (xliffsLangURLDict[language] === undefined) {
          xliffFileDef = new XLIFFHandler([]);
        } else {
          xliffFileDef = XLIFFHandler.fromURL(xliffsLangURLDict[language]);
          fileExtention = xliffsLangURLDict[language].substring(xliffsLangURLDict[language].lastIndexOf("."));
        }
        defs.push($.when(xliffFileDef, targetDict, targetLanguage, language, fileExtention).then(function (pXLIFFHandler, pTargetDict, pTargetLanguage, pLanguage, pFileExtention) {
          var url;
          if (pXLIFFHandler.doesSourceAndTargetLanguagesConflicts(HTMLPageID, sourceLanguage, pTargetLanguage)) {
            // conflicts, possible other language
            pXLIFFHandler = new XLIFFHandler([]);
            url = pFolderURL + fileNameTemplate + pLanguage + "_1" + pFileExtention;
          } else {
            pXLIFFHandler.addTranslations(HTMLPageID, that.languageDict[mainLanguage], pTargetDict, sourceLanguage, pTargetLanguage, pHTMLCreator, pHTMLPageURL);
            url = pFolderURL + fileNameTemplate + pLanguage + pFileExtention;
          }
          fileURLs.push(url);
          return pXLIFFHandler.save(url);
        }));
      }
      if (Array.isArray(defs) && defs.length > 0) {
        return $.when.apply($, defs).then(function () {
          // add translations from whitepapers and co
          return that._exportMetadataHTMLPageToXLIFF(pHTMLPage, pExtraWhitepaperNames, fileURLs, mainLanguage);
        }, function (pError) {
          // add translations from whitepapers and co
          return that._exportMetadataHTMLPageToXLIFF(pHTMLPage, pExtraWhitepaperNames, fileURLs, mainLanguage);
        });
      } else {
        // add translations from whitepapers and co
        return that._exportMetadataHTMLPageToXLIFF(pHTMLPage, pExtraWhitepaperNames, fileURLs, mainLanguage);
      }
    });
  },
  _getDBOurls: function _getDBOurls(pHTMLPage, pExtraWhitepaperNames) {
    var whitepaperNames = [];
    if (Array.isArray(pExtraWhitepaperNames)) {
      whitepaperNames = pExtraWhitepaperNames;
    }
    var components = pHTMLPage.getAllComponents(true);
    for (var e = 0; e < components.length; e++) {
      if (components[e].getType() === "CreateWorkable") {
        if (components[e].options !== undefined) {
          var whitepaper = components[e].options.whitepaper;
          // can be value composers, so ignore them
          if (typeof whitepaper === "string" && whitepaper.length > 0) {
            whitepaperNames.push(whitepaper);
          }
        }
      } else if (components[e].getType() === "FormDetailsPanel") {
        if (components[e].options !== undefined) {
          if (components[e].options.createworkable_options !== undefined) {
            var whitepaper = components[e].options.createworkable_options.whitepaper;
            // can be value composers, so ignore them
            if (typeof whitepaper === "string" && whitepaper.length > 0) {
              whitepaperNames.push(whitepaper);
            }
          }
          if (components[e].options.createworkable_update_options !== undefined) {
            whitepaper = components[e].options.createworkable_update_options.whitepaper;
            // can be value composers, so ignore them
            if (typeof whitepaper === "string" && whitepaper.length > 0) {
              whitepaperNames.push(whitepaper);
            }
          }
          if (components[e].options.createworkable_updatemultiple_options !== undefined) {
            whitepaper = components[e].options.createworkable_updatemultiple_options.whitepaper;
            // can be value composers, so ignore them
            if (typeof whitepaper === "string" && whitepaper.length > 0) {
              whitepaperNames.push(whitepaper);
            }
          }
        }
      }
    }
    if (whitepaperNames.length === 0) {
      return $.Deferred().resolve([]);
    }
    return $.Deferred(function (pDefer) {
      api_async.whitepaper.list(["name", "in", whitepaperNames], ["_id"], function (pResult) {
        if (pResult !== undefined && Array.isArray(pResult.results)) {
          var dbo_urls = [];
          for (var i = 0; i < pResult.results.length; i++) {
            if (typeof pResult.results[i]._id === "string" && pResult.results[i]._id.length > 0) {
              dbo_urls.push("cfdbo://whitepapers/" + pResult.results[i]._id);
            }
          }
          pDefer.resolve(dbo_urls);
        } else {
          pDefer.reject({
            "error_code": "wrong_return_interface",
            "error": "wrong interface"
          });
        }
      }, function (pError) {
        pDefer.reject(pError);
      });
    });
  },
  _exportMetadataHTMLPageToXLIFF: function _exportMetadataHTMLPageToXLIFF(pHTMLPage, pExtraWhitepaperNames, pOutputFiles, pMainLanguage) {
    var that = this;
    return this._getDBOurls(pHTMLPage, pExtraWhitepaperNames).then(function (PDBUrls) {
      var defs = [];
      for (var f = 0; f < pOutputFiles.length; f++) {
        defs.push(that._exportMetadataToXLIFF(PDBUrls, pOutputFiles[f], pMainLanguage));
      }
      return $.when.apply($, defs);
    });
  },
  _exportMetadataToXLIFF: function _exportMetadataToXLIFF(pDBOUrls, pOutputFile, pSourceLanguage) {
    if (Array.isArray(pDBOUrls) === false) {
      throw new Error("We expect an array for DBOUrls");
    }
    if (pDBOUrls.length === 0) {
      return $.Deferred().resolve();
    }
    var defs = [];
    for (var i = 0; i < pDBOUrls.length; i++) {
      if (typeof pDBOUrls[i] !== "string" || pDBOUrls[i].length <= 0) {
        throw new Error("DBOUrl must be a not empty string");
      }
      defs.push($.Deferred(function (pDefer) {
        var target_language = undefined;
        var languageMatches = pOutputFile.match(/_[a-zA-Z]{2}/g);
        if (Array.isArray(languageMatches) && languageMatches.length > 0) {
          var languageTag = languageMatches[languageMatches.length - 1];
          target_language = languageTag.slice(1);
        }
        var options = {
          "overwrite": true
        };
        if (target_language !== pSourceLanguage) {
          options["target_language"] = target_language;
        }
        api_async.xliff.scan_document(pDBOUrls[i], pOutputFile, pSourceLanguage, options, pDefer.resolve, pDefer.resolve);
      }));
    }
    return $.when.apply($, defs);
  },
  _importMetadataHTMLPageToXLIFF: function _importMetadataHTMLPageToXLIFF(pHTMLPage, pFiles, pExtraWhitepapers) {
    var that = this;
    return this._getDBOurls(pHTMLPage, pExtraWhitepapers).then(function (PDBUrls) {
      return that._importMetadataFromXLIFF(PDBUrls, pFiles, that._getMainLanguage());
    });
  },
  _importMetadataFromXLIFF: function _importMetadataFromXLIFF(pDBOUrls, pFiles, pMainLanguage) {
    if (Array.isArray(pDBOUrls) === false) {
      throw new Error("We expect an array for DBOUrls");
    }
    if (pDBOUrls.length === 0) {
      return $.Deferred().resolve([]);
    }
    var defs = [];
    for (var i = 0; i < pDBOUrls.length; i++) {
      if (typeof pDBOUrls[i] !== "string" || pDBOUrls[i].length <= 0) {
        throw new Error("DBOUrl must be a not empty string");
      }
      // make seq, because the api, can not handle access to whitepaper via parrallell calls
      var sequential = new Sequential();
      for (var f = 0; f < pFiles.length; f++) {
        if (typeof pFiles[f] !== "string" || pFiles[f].length <= 9) {
          throw new Error("file url must be a string bigger the 9 chars");
        }
        var languageMatches = pFiles[f].match(/_[a-zA-Z]{2}/g);
        if (Array.isArray(languageMatches) && languageMatches.length > 0) {
          var languageTag = languageMatches[languageMatches.length - 1];
          var target_language = languageTag.slice(1);
          if (target_language === pMainLanguage) {
            continue;
          }
          sequential.add(this._updateDocument, this, [pDBOUrls[i], pFiles[f], pMainLanguage, target_language]);
        } else {
          throw new Error("could not retrieve language form url " + pFiles[f]);
        }
      }
      defs.push(sequential.render([]));
    }
    return $.when.apply($, defs);
  },
  _updateDocument: function _updateDocument(pDBOUrl, pFile, pMainLanguage, pTargetLanguage) {
    return $.Deferred(function (pDefer) {
      var nativeLanguageName = TranslationHandler.getNativeNameLanguage(pTargetLanguage);
      api_async.xliff.update_document(pDBOUrl, pFile, pMainLanguage, pTargetLanguage, {}, function (pResults) {
        var identifiers = [];
        var translations_keys = 0;
        var page_keys = 0;
        if (pResults !== undefined && Array.isArray(pResults.processed)) {
          for (var p = 0; p < pResults.processed.length; p++) {
            identifiers.push(pResults.processed[p].identifier);
            translations_keys += pResults.processed[p].nr_items;
            page_keys += pResults.processed[p].nr_items;
          }
        }
        pDefer.resolve({
          language: pTargetLanguage,
          language_name: nativeLanguageName,
          translations_keys: translations_keys,
          page_keys: page_keys,
          identifiers: identifiers
        });
      }, function (pError) {
        var identifiers = [];
        var translations_keys = 0;
        var page_keys = 0;
        if (pError !== undefined && Array.isArray(pError.processed)) {
          for (var p = 0; p < pError.processed.length; p++) {
            identifiers.push(pError.processed[p].identifier);
            translations_keys += pError.processed[p].nr_items;
            page_keys += pError.processed[p].nr_items;
          }
        }
        if (pError.error_code === "Localized Data not found") {
          // ignore this error
          pDefer.resolve({
            language: pTargetLanguage,
            language_name: nativeLanguageName,
            translations_keys: translations_keys,
            page_keys: page_keys,
            identifiers: identifiers
          });
          return;
        }
        var errormessage = pError;
        if (typeof pError.error === "string") {
          errormessage = pError.error;
        }
        pDefer.resolve({
          language: pTargetLanguage,
          language_name: nativeLanguageName,
          translations_keys: translations_keys,
          page_keys: page_keys,
          error: errormessage
        });
      });
    });
  }
};
TranslationHandler.duplicateTranslations = function (pObjectToInspect, pIDGenerator, pOldComponentID, newComponentID, pKeep, pOldTranslationPageHash, pNewTranslationpageHash, pToEnglishDict) {
  var translationKeys = {};
  var valueComposerTranslationKeyDict = {};
  CloudflowObject.travers(pObjectToInspect, function (pValue, pPath) {
    if (typeof pValue === "string") {
      if ((pValue.startsWith("${pb-") || pValue.startsWith("${custom-")) && pValue[pValue.length - 1] === "}") {
        if (pValue.startsWith("${pb-") && pKeep === true) {
          // translate to newer translation keys
          var newKey = pValue;
          if (pOldTranslationPageHash !== pNewTranslationpageHash) {
            newKey = pValue.replace(pOldTranslationPageHash, pNewTranslationpageHash);
            if (newKey === pValue) {
              newKey = pValue.replace(/[$][{](pb-.{4})-(.{8}-.{4}-.{4}-.{4}-.{12})(.*)/, function (pMatch, p1, p2, p3, poffset) {
                return "${" + pNewTranslationpageHash + "-" + newComponentID + p3;
              });
              console.warn("duplicate: outside page translation key found, we tried to fix it");
              translationKeys[pValue.slice(2, -1)] = newKey.slice(2, -1);
              return newKey;
            }
          }
          var newKey2 = newKey.replace(pOldComponentID, newComponentID);
          if (newKey === newKey2) {
            newKey = pValue.replace(/[$][{](pb-.{4})-(.{8}-.{4}-.{4}-.{4}-.{12})(.*)/, function (pMatch, p1, p2, p3, poffset) {
              return "${" + pNewTranslationpageHash + "-" + newComponentID + p3;
            });
            console.warn("duplicate: outside component translation key found, we tried to fix it");
          } else {
            newKey = newKey2;
          }
          translationKeys[pValue.slice(2, -1)] = newKey.slice(2, -1);
        } else if (pKeep === false) {
          // quit translations and use englich (or main) language
          var oldKey = pValue.slice(2, -1);
          if (pToEnglishDict[oldKey] !== undefined) {
            newKey = pToEnglishDict[oldKey];
          } else {
            newKey = pValue;
          }
        } else if (pValue.startsWith("${custom-")) {
          return pValue;
        }
        return newKey;
      } else if ((pValue.startsWith("pb-") || pValue.startsWith("custom-")) && pPath.endsWith(".translation_key")) {
        var valueComposer = CloudflowObject.getParameter(pObjectToInspect, pPath.replace(".translation_key", ""));
        if (valueComposer.type === "com.nixps.localization.look_up.0") {
          if (pValue.startsWith("pb-") && pKeep === true) {
            // translate to newer translation keys
            var newKey = pValue.replace(pOldTranslationPageHash, pNewTranslationpageHash);
            if (newKey === pValue && pOldTranslationPageHash !== pNewTranslationpageHash) {
              newKey = pValue.replace(/(pb-.{4})-(.{8}-.{4}-.{4}-.{4}-.{12})(.*)/, function (pMatch, p1, p2, p3, pOffset) {
                var propositionNewKey = pNewTranslationpageHash + "-" + newComponentID + p3;
                if (typeof valueComposerTranslationKeyDict[propositionNewKey] === "string" && valueComposerTranslationKeyDict[propositionNewKey] !== pMatch) {
                  propositionNewKey = pNewTranslationpageHash + "-" + pIDGenerator() + p3;
                }
                return propositionNewKey;
              });
              console.warn("duplicate: outside page translation key found, we tried to fix it");
            } else {
              var newKey2 = newKey.replace(pOldComponentID, newComponentID);
              if (newKey === newKey2) {
                newKey = pValue.replace(/(pb-.{4})-(.{8}-.{4}-.{4}-.{4}-.{12})(.*)/, function (pMatch, p1, p2, p3, pOffset) {
                  var propositionNewKey = pNewTranslationpageHash + "-" + newComponentID + p3;
                  if (typeof valueComposerTranslationKeyDict[propositionNewKey] === "string" && valueComposerTranslationKeyDict[propositionNewKey] !== pMatch) {
                    propositionNewKey = pNewTranslationpageHash + "-" + pIDGenerator() + p3;
                  }
                  return propositionNewKey;
                });
              } else {
                newKey = newKey2;
              }
            }
            valueComposerTranslationKeyDict[newKey] = pValue;
            translationKeys[pValue] = newKey;
            return newKey;
          } else if (pKeep === false) {
            // quit translations and use english (or main) language
            valueComposer.type = "com.nixps.quantum.value.0";
            if (pToEnglishDict[pValue] !== undefined) {
              valueComposer.value = pToEnglishDict[pValue];
            } else {
              valueComposer.value = pValue;
            }
            delete valueComposer.translation_key;
            return undefined;
          } else if (pValue.startsWith("custom-")) {
            return pValue;
          }
        }
      }
    }
    return pValue;
  });
  return translationKeys;
};
module.exports = TranslationHandler;

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"./Sequential.js":232,"./TranslationFiles.js":233,"./TranslationObject.js":235,"./XLIFFHandler.js":236}],235:[function(require,module,exports){
"use strict";

// @param {Array.<String>} pLanguages An array containing all the languages you will use
var TranslationObject = function TranslationObject(pLanguageDict) {
  this.languageDict = {};
  this._setLanguageDict(pLanguageDict);
};

/**
 * @description create a translationfiles from json
 * @function
 * @param {Object} json
 * @return {nm$_TranslationFiles.TranslationFiles}
 */
TranslationObject.fromJSON = function (json) {
  return new TranslationObject(json.language_dict);
};
TranslationObject.prototype = {
  constructor: TranslationObject,
  _setLanguageDict: function _setLanguageDict(pLanguageDict) {
    if (pLanguageDict === undefined || pLanguageDict === null) {
      this.languageDict = {};
    } else if ($.isPlainObject(pLanguageDict) === false) {
      throw new Error("_setLanguageDict: parameter pLanguageDict must be a plain object");
    }
    this.languageDict = $.extend({}, pLanguageDict);
  },
  getCloudflowBasePath: function getCloudflowBasePath() {
    return null;
  },
  makeHash: function makeHash() {
    return "1234"; // is it used??
  },

  getFileNameTemplate: function getFileNameTemplate() {
    return "cloudflow"; // is it used??
  },

  getValue: function getValue() {
    return $.extend({}, this.languageDict);
  },
  setValue: function setValue(pLanguageDict) {
    this.languageDict = $.extend({}, pLanguageDict);
  },
  /**
   * @description Load all json key values of all languages
   * @function
   * @name TranslationObject.loadData
   * @return {Deferred}
   */
  loadData: function loadData(pProgressCB) {
    return $.Deferred().resolve();
  },
  /**
   * @description Save the changes to the backend, upload and save the json files 
   * @function
   * @name TranslationObject.save
   * @return {Deferred}
   */
  save: function save() {
    return $.Deferred().resolve();
  },
  /**
   * @description Remove some language files
   * @function
   * @name TranslationObject.removeLanguages
   * @param {Array.<String>} pLanguages the iso code of the languages you want to remove
   * @return {deferred}
   */
  removeLanguages: function removeLanguages(pLanguages) {
    if (Array.isArray(pLanguages) === false || pLanguages.length <= 0) {
      throw new Error("pLanguages must be a not empty array");
    }
    for (var i = 0; i < pLanguages.length; i++) {
      delete this.languageDict[pLanguages[i]];
    }
    return $.Deferred().resolve();
  },
  /**
   * @description Remove the folder where all translation files are located
   * @function
   * @name TranslationObject.removeAllLanguages
   * @return {deferred}
   */
  removeAllLanguages: function removeAllLanguages() {
    this.languageDict = {};
    return $.Deferred().resolve();
  },
  clone: function clone() {
    return TranslationObject.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {
      language_dict: this.getValue()
    };
  },
  clear: function clear() {}
};
module.exports = TranslationObject;

},{}],236:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// requires
var XLIFFfile = require("./XLIFFfile.js");
/**
 * @desc The model of a complete xliff. This contains files
 * @return {XLIFFHandler.XLIFFHandler}
 * @name XLIFFHandler
 * @param {Array.<XLIFFfile>} pXLIFFfiles An array of xliffiles
 */
function XLIFFHandler(pXLIFFfiles) {
  this.sourceIndexes = {};
  this.files = [];
  this.setFiles(pXLIFFfiles);
}
XLIFFHandler.fromJSON = function (pJSON) {
  return new XLIFFHandler(pJSON.files);
}, XLIFFHandler.fromURL = function (pURL) {
  return $.Deferred(function (pDefer) {
    api_async.xliff.to_json(pURL, {
      "xml_data_type": "url"
    }, function (pResult) {
      if (pResult !== undefined && pResult.xliff !== undefined) {
        pDefer.resolve(XLIFFHandler.fromJSON(pResult.xliff));
      } else {
        console.error("wrong returning interface");
        pDefer.reject({
          error_code: "wrong_return_interface",
          error: "wrong returning interface"
        });
      }
    }, function (pError) {
      console.error(pError);
      pDefer.reject(pError);
    });
  });
  // return api_defer.xliff.to_json(pURL, {"xml_data_type": "url"}).then(function(pResult){
  //     if (pResult !== undefined && pResult.xliff !== undefined) {
  //         return XLIFFHandler.fromJSON(pResult.xliff);
  //     } else {
  //         console.error("wrong returning interface");
  //         return Promise.reject({error_code: "wrong_return_interface", error: "wrong returning interface"});
  //     }
  // }, function(pError) {
  //     console.error(pError);
  //     return Promise.reject(pError);
  // });
};

XLIFFHandler.retrieveFileURLs = function (pFolderPath, pFileNameTemplate) {
  if (typeof pFolderPath !== "string" || pFolderPath.length <= 0) {
    throw new Error("parameter folderpath must be a not empty string");
  }
  if (pFolderPath[pFolderPath.length - 1] !== "/") {
    pFolderPath += "/";
  }
  var query = ['cloudflow.enclosing_folder', 'equal to', pFolderPath, 'and', '(', 'filetype', 'equal to', 'application/x-xliff+xml', 'or', 'file_extension', 'equal to', '.xliff', 'or', 'file_extension', 'equal to', '.xlf', ')'];
  if (typeof pFileNameTemplate === "string" && pFileNameTemplate.length > 0) {
    query = query.concat(["and", "file_name", "begins with", pFileNameTemplate]);
  }
  return $.Deferred(function (pDefer) {
    api_async.asset.list(query, ["cloudflow.file"], function (pResults) {
      if (pResults !== undefined && Array.isArray(pResults.results)) {
        pDefer.resolve(pResults.results.map(function (elem) {
          return elem.cloudflow.file;
        }));
      } else {
        console.error("incorrect returning interface");
        pDefer.reject({
          error_code: "wrong_return_interface",
          error: "wrong returning interface"
        });
      }
    }, function (pError) {
      console.error(pError);
      pDefer.reject(pError);
    });
  });
};
XLIFFHandler.prototype = {
  constructor: XLIFFHandler,
  setFiles: function setFiles(pFiles) {
    if (Array.isArray(pFiles) === false) {
      throw new Error("pFiles must be an array");
    }
    this.files = [];
    this.sourceIndexes = {};
    var currentFile;
    for (var i = 0; i < pFiles.length; i++) {
      if (pFiles[i] instanceof XLIFFfile) {
        currentFile = pFiles[i];
      } else if (pFiles[i] && _typeof(pFiles[i]) === "object" && pFiles[i].constructor.name === "Object") {
        currentFile = XLIFFfile.fromJSON(pFiles[i]);
      } else {
        currentFile = undefined;
        console.error("unknown xliff file interface found");
        continue;
      }
      var sourceID = currentFile.getOriginal();
      if (this.sourceIndexes[sourceID] === undefined) {
        this.sourceIndexes[sourceID] = i;
        this.files.push(currentFile);
      } else {
        console.error("double xliff file with same original found, did not add");
      }
    }
  },
  getFiles: function getFiles() {
    return this.files;
  },
  addMissingFiles: function addMissingFiles(pFiles) {},
  getLanguageDict: function getLanguageDict(pSourceID) {
    if (pSourceID === undefined) {
      var dict = {};
      for (var i = 0; i < this.files.length; i++) {
        dict = $.extend({}, dict, this.files[i].getLanguageDict());
      }
      return dict;
    } else if (typeof pSourceID === "string") {
      var fileIndex = this.sourceIndexes[pSourceID];
      if (typeof fileIndex === "number" && fileIndex >= 0) {
        return this.files[fileIndex].getLanguageDict();
      }
    }
    return null;
  },
  getTargetLanguage: function getTargetLanguage(pSourceID) {
    if (typeof pSourceID === "string") {
      var fileIndex = this.sourceIndexes[pSourceID];
      if (typeof fileIndex === "number" && fileIndex >= 0) {
        return this.files[fileIndex].getTargetLanguage();
      }
    }
    return null;
  },
  getOtherLanguageXLIFFFiles: function getOtherLanguageXLIFFFiles(pSourceID) {
    var xlifffiles = [];
    for (var i = 0; i < this.files.length; i++) {
      if (this.files[i].getOriginal() !== pSourceID) {
        xlifffiles.push(this.files[i].clone());
      }
    }
    return xlifffiles;
  },
  _filterStrangeKeys: function _filterStrangeKeys(pFileIndex, pSourceLanguageDict, pTargetLanguageDict) {
    var keys = $.map(pSourceLanguageDict, function (pTranslation, pKey) {
      return pKey;
    });
    var strangeKeys = [];
    var bigTranslationDict = {};
    for (var f = 0; f < this.files.length; f++) {
      if (f !== pFileIndex) {
        for (var k = 0; k < keys.length; k++) {
          if (this.files[f].getLanguageDict()[keys[k]] !== undefined) {
            strangeKeys.push(keys[k]);
            if (pTargetLanguageDict !== undefined && this.files[f].getLanguageDict()[keys[k]] === pTargetLanguageDict[keys[k]]) {
              continue;
            }
            if (pTargetLanguageDict === undefined && this.files[f].getLanguageDict()[keys[k]] === pSourceLanguageDict[keys[k]]) {
              continue;
            }
            var sourceObj = {};
            sourceObj[keys[k]] = pSourceLanguageDict[keys[k]];
            var targetObj = {};
            if (this.files[f].isSource() === false) {
              targetObj[keys[k]] = pTargetLanguageDict[keys[k]];
            }
            this.files[f].addTranslations(sourceObj, targetObj);
          }
        }
      }
    }
    for (var i = 0; i < strangeKeys.length; i++) {
      if (pTargetLanguageDict !== undefined) {
        delete pTargetLanguageDict[strangeKeys[i]];
      }
      delete pSourceLanguageDict[strangeKeys[i]];
    }
  },
  doesSourceAndTargetLanguagesConflicts: function doesSourceAndTargetLanguagesConflicts(pSourceID, pSourceLanguage, pTargetlanguage) {
    var fileIndex = this.sourceIndexes[pSourceID];
    if (typeof fileIndex === "number" && fileIndex >= 0) {
      // update existing one
      var xliff_file = this.files[fileIndex];
      if (xliff_file.getSourceLanguage() !== pSourceLanguage) {
        return true;
      }
      if (typeof xliff_file.getTargetLanguage() === "string" && xliff_file.getTargetLanguage() !== pTargetlanguage) {
        return true;
      }
    }
    return false;
  },
  addTranslations: function addTranslations(pSourceID, pSourceLanguageDict, pTargetLanguageDict, pSourceLanguage, pTargetlanguage, pTool, pProductName) {
    var sourceLanguageDict = undefined;
    if ($.isPlainObject(pSourceLanguageDict)) {
      sourceLanguageDict = $.extend(true, {}, pSourceLanguageDict);
    }
    var targetLanguageDict = undefined;
    if ($.isPlainObject(pTargetLanguageDict)) {
      targetLanguageDict = $.extend(true, {}, pTargetLanguageDict);
    }
    var fileIndex = this.sourceIndexes[pSourceID];
    if (typeof fileIndex === "number" && fileIndex >= 0) {
      // update existing one
      var xliff_file = this.files[fileIndex];
      if (xliff_file.getSourceLanguage() !== pSourceLanguage) {
        throw new Error("XLIFFHandler: soucre languages do not match");
      }
      if (typeof xliff_file.getTargetLanguage() === "string" && xliff_file.getTargetLanguage() !== pTargetlanguage) {
        throw new Error("XLIFFHandler: target languages do not match");
      }
      this._filterStrangeKeys(fileIndex, sourceLanguageDict, targetLanguageDict);
      xliff_file.addTranslations(sourceLanguageDict, targetLanguageDict);
      if (typeof pTool === "string" && pTool.length > 0) {
        xliff_file.setTool(pTool);
      }
      if (typeof pProductName === "string" && pProductName.length > 0) {
        xliff_file.setProductName(pProductName);
      }
    } else {
      // new one is needed
      var xliff_file = new XLIFFfile([], pSourceID, pSourceLanguage, pTargetlanguage, pTool, pProductName);
      this._filterStrangeKeys(undefined, sourceLanguageDict, targetLanguageDict);
      xliff_file.addTranslations(sourceLanguageDict, targetLanguageDict);
      this.sourceIndexes[pSourceID] = this.files.length;
      this.files.push(xliff_file);
    }
  },
  save: function save(pURL) {
    if (typeof pURL !== "string" || pURL.length <= 0) {
      throw new Error("pURL must be a not empty string");
    }
    var that = this;
    return $.Deferred(function (pDefer) {
      api_async.xliff.from_json({
        xliff: that.toJSON()
      }, pURL, {
        overwrite: true
      }, function (pResult) {
        pDefer.resolve(pResult);
      }, function (pError) {
        console.error(pError);
        pDefer.reject(pError);
      });
    });
  },
  clone: function clone() {
    return XLIFFHandler.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var filesJSON = [];
    var files = this.getFiles();
    for (var i = 0; i < files.length; i++) {
      filesJSON.push(files[i].toJSON());
    }
    return {
      "files": filesJSON
    };
  }
};
module.exports = XLIFFHandler;

},{"./XLIFFfile.js":237}],237:[function(require,module,exports){
"use strict";

/**
 * @description Model of one xliff file, compatible with the api calls
 * @name XLIFFfile
 * @param {Array} pTransUnits Contains all translation keys and values  
 * @param {String} pOriginal The fileID  
 * @param {String} pSourceLanguage   
 * @param {String} pTargetLanguage   
 * @param {String} pTool (optional)  
 * @param {String} pProductName (optional)     
*/
function XLIFFfile(pTransUnits, pOriginal, pSourceLanguage, pTargetLanguage, pTool, pProductName) {
  this.units;
  this.original;
  this.source_language;
  this.target_language;
  this.tool;
  this.product_name;
  this.setUnits(pTransUnits);
  this.setOriginal(pOriginal);
  this.setSourceLanguage(pSourceLanguage);
  this.setTargetLanguage(pTargetLanguage);
  this.setTool(pTool);
  this.setProductName(pProductName);
}
XLIFFfile.fromJSON = function (pJSON) {
  var transUnits = [];
  if (pJSON.body !== undefined && Array.isArray(pJSON.body["trans-units"])) {
    transUnits = pJSON.body["trans-units"];
  }
  return new XLIFFfile(transUnits, pJSON.original, pJSON["source-language"], pJSON["target-language"], pJSON.tool, pJSON["product-name"]);
};
XLIFFfile.prototype = {
  constructor: XLIFFfile,
  setUnits: function setUnits(pUnits) {
    if (Array.isArray(pUnits) === false) {
      throw new Error("TransUnits must be an array");
    }
    this.units = structuredClone(pUnits);
  },
  getUnits: function getUnits() {
    return this.units;
  },
  getLanguageDict: function getLanguageDict() {
    var languageDict = {};
    var translatedStringKey;
    if (this.isSource()) {
      translatedStringKey = "source";
    } else {
      translatedStringKey = "target";
    }
    for (var i = 0; i < this.units.length; i++) {
      languageDict[this.units[i].resname] = this.units[i][translatedStringKey];
    }
    return languageDict;
  },
  /**
   * @description Add extra translations to the existing translations, if needed we merge with the existing ones
   * @function
   * @param {Object} sourceLanguageDict The translation dict of the source language
   * @param {Object} targetLanguageDict The translation dict of the target language
   * @name XLIFFfile.addTranslations
   * @returns {undefined}
   */
  addTranslations: function addTranslations(sourceLanguageDict, targetLanguageDict) {
    var that = this;
    var existingKeysDict = {};
    for (var i = 0; i < this.units.length; i++) {
      existingKeysDict[this.units[i].resname] = i; // array index
    }

    if (this.isSource()) {
      for (var pKey in sourceLanguageDict) {
        var pTranslatedString = sourceLanguageDict[pKey];
        if (existingKeysDict[pKey] !== undefined) {
          // exists already
          var index = existingKeysDict[pKey];
          this.units[index].source = pTranslatedString;
        } else {
          this.units.push({
            id: pKey,
            resname: pKey,
            note: "",
            source: pTranslatedString
          });
        }
      }
    } else {
      for (var _pKey in sourceLanguageDict) {
        var _pTranslatedString = sourceLanguageDict[_pKey];
        var translatedString = targetLanguageDict[_pKey];
        if (typeof translatedString !== "string") {
          translatedString = "";
        }
        if (existingKeysDict[_pKey] !== undefined) {
          // exists already
          var index = existingKeysDict[_pKey];
          this.units[index].source = _pTranslatedString;
          this.units[index].target = translatedString;
        } else {
          this.units.push({
            id: _pKey,
            resname: _pKey,
            note: "",
            source: _pTranslatedString,
            target: translatedString
          });
        }
      }
    }
  },
  setOriginal: function setOriginal(pOriginal) {
    if (typeof pOriginal !== "string" || pOriginal.length <= 0) {
      throw new Error("pOriginal must be a string");
    }
    this.original = pOriginal;
  },
  getOriginal: function getOriginal() {
    return this.original;
  },
  setSourceLanguage: function setSourceLanguage(pLanguage) {
    if (typeof pLanguage !== "string" || pLanguage.length <= 0) {
      throw new Error("pLanguage must be a string");
    }
    this.source_language = pLanguage;
  },
  getSourceLanguage: function getSourceLanguage() {
    return this.source_language;
  },
  setTargetLanguage: function setTargetLanguage(pLanguage) {
    if (typeof pLanguage === "string" && pLanguage.length > 0) {
      this.target_language = pLanguage;
    } else {
      this.target_language = null;
    }
  },
  getTargetLanguage: function getTargetLanguage() {
    return this.target_language;
  },
  isSource: function isSource() {
    return this.target_language === null;
  },
  setTool: function setTool(pTool) {
    if (typeof pTool === "string" && pTool.length > 0) {
      this.tool = pTool;
    } else {
      this.tool = null;
    }
  },
  getTool: function getTool() {
    return this.tool;
  },
  setProductName: function setProductName(pProductName) {
    if (typeof pProductName === "string" && pProductName.length > 0) {
      this.product_name = pProductName;
    } else {
      this.product_name = null;
    }
  },
  getProductName: function getProductName() {
    return this.product_name;
  },
  clone: function clone() {
    return XLIFFfile.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var output = {
      body: {
        "trans-units": this.getUnits()
      },
      datatype: "plaintext",
      original: this.getOriginal(),
      "source-language": this.getSourceLanguage()
    };
    var targetLanguage = this.getTargetLanguage();
    if (typeof targetLanguage === "string" && targetLanguage.length > 0) {
      output["target-language"] = targetLanguage;
    }
    var tool = this.getTool();
    if (typeof tool === "string" && tool.length > 0) {
      output.tool = tool;
    }
    var productName = this.getProductName();
    if (typeof productName === "string" && productName.length > 0) {
      output["product-name"] = productName;
    }
    return output;
  }
};
module.exports = XLIFFfile;

},{}],238:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery*/
require("../../../common/js/nixps-common-Languages.js");
require("../../../common/LanguageSelector/js/nixps-LanguageSelector.js");
(function ($) {
  var translatedLanguages = require("./translatedLanguages.js");
  /**
   * @brief A language selector that contains only the translated cloudflow languages
   */
  $.widget("nixps-cloudflow.TranslatedLanguagesSelector", $.nixps.LanguageSelector, {
    options: {
      /**
       * @brief the zoom level
       */
      name: "language",
      value: "en",
      /**
       * @brief if an array of iso codes is passed, choices are filtered according to array
       */
      filter: translatedLanguages
    }
  });
})(jQuery);

},{"../../../common/LanguageSelector/js/nixps-LanguageSelector.js":294,"../../../common/js/nixps-common-Languages.js":390,"./translatedLanguages.js":239}],239:[function(require,module,exports){
"use strict";

/**
 * The list of supported languages in Cloudflow.
 * On purpose on multiple lines to make compares in source control easier.
 */
module.exports = ["fr", "en", "de", /*"cs",*/
"es", "it", "pl", "ru", "ja", "zh"];

},{}],240:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var JQueryEventPageTrigger = require("./JQueryEventPageTrigger.js");
var FormAction = require("./FormAction.js");
var SubPageAction = require("./SubAction.js");
var ActionFunction = require("./ActionFunction.js");
var KeyPressEventTrigger = require("./KeyPressEventTrigger.js");

/**
 * @class Layout
 * @description A helpclass for forming a form, This is a proxy for all types of actions. 
 * An action is a executable thing that runs when something happen.
 * @param {string} pTitle - the title to use (optionaly)
 * @param {json_object} pComponent - the compoent to show as inputfield, this can be inserted as json or as component class
 */
var Action = function Action(pType, pParameters) {
  this.type;
  this.setType(pType);
  this.parameters;
  this.setParameters(pParameters);
};

/**
 * Different types of actions
 * @readonly
 * @enum {String}
 */
Action.type = Object.freeze({
  /** classic pagebuilder action */
  "JQUERYEVENTPAGETRIGGER": "jqueryEventPageTrigger",
  /** key perssing action */
  "KEYPRESSEVENTTRIGGER": "keyPressEventTrigger",
  /** classic formbuilder action */
  "FORMACTION": "formAction",
  /** an independend action from pagebuilder */
  "SUBPAGEACTION": "subPageAction",
  /** minimal version of an action */
  "ACTIONFUNCTION": "actionFunction"
});
Action.fromJSON = function (json) {
  return new Action(json.type, json.parameters);
};
Action.prototype = {
  constructor: Action,
  getType: function getType() {
    return this.type;
  },
  setType: function setType(pType) {
    if (typeof pType !== "string" || pType.length <= 0) {
      throw new Error("input parameter pType must be a string");
    }
    if (["jqueryEventPageTrigger", "formAction", "subPageAction", "actionFunction", "keyPressEventTrigger"].includes(pType) === false) {
      throw new Error("unsupported action type " + pType);
    }
    this.type = pType;
  },
  getParameters: function getParameters() {
    return this.parameters;
  },
  setParameters: function setParameters(pParameters) {
    if (this.type === Action.type.JQUERYEVENTPAGETRIGGER) {
      if (pParameters instanceof JQueryEventPageTrigger) {
        this.parameters = pParameters;
      } else if (pParameters && _typeof(pParameters) === "object" && !Array.isArray(pParameters)) {
        this.parameters = JQueryEventPageTrigger.fromJSON(pParameters);
      } else {
        throw new Error("unsupported action element interface");
      }
    } else if (this.type === Action.type.FORMACTION) {
      if (pParameters instanceof FormAction) {
        this.parameters = pParameters;
      } else if (pParameters && _typeof(pParameters) === "object" && !Array.isArray(pParameters)) {
        this.parameters = FormAction.fromJSON(pParameters);
      } else {
        throw new Error("unsupported action element interface");
      }
    } else if (this.type === Action.type.SUBPAGEACTION) {
      if (pParameters instanceof SubPageAction) {
        this.parameters = pParameters;
      } else if (pParameters && _typeof(pParameters) === "object" && !Array.isArray(pParameters)) {
        this.parameters = SubPageAction.fromJSON(pParameters);
      } else {
        throw new Error("unsupported action element interface");
      }
    } else if (this.type === Action.type.ACTIONFUNCTION) {
      if (pParameters instanceof ActionFunction) {
        this.parameters = pParameters;
      } else if (pParameters && _typeof(pParameters) === "object" && !Array.isArray(pParameters)) {
        this.parameters = ActionFunction.fromJSON(pParameters);
      } else {
        throw new Error("unsupported action element interface");
      }
    } else if (this.type === Action.type.KEYPRESSEVENTTRIGGER) {
      if (pParameters instanceof KeyPressEventTrigger) {
        this.parameters = pParameters;
      } else if (pParameters && _typeof(pParameters) === "object" && !Array.isArray(pParameters)) {
        this.parameters = KeyPressEventTrigger.fromJSON(pParameters);
      } else {
        throw new Error("unsupported action element interface");
      }
    } else {
      throw new Error("unsupported action type");
    }
  },
  duplicate: function duplicate() {
    var _this$parameters;
    return (_this$parameters = this.parameters).duplicate.apply(_this$parameters, arguments);
  },
  hasLinkWithComponentID: function hasLinkWithComponentID(pComponentID) {
    return this.parameters.hasLinkWithComponentID(pComponentID);
  },
  removeLinkWithComponentID: function removeLinkWithComponentID(pComponentID) {
    return this.parameters.removeComponentID(pComponentID);
  },
  removeLinkWithSubActionID: function removeLinkWithSubActionID(pSubActionID) {
    return this.parameters.removeSubActionID(pSubActionID);
  },
  updateActionDueToComponentContentChange: function updateActionDueToComponentContentChange(pComponentID, pChangeParameters) {
    // only for formactions for the moment
    return this.parameters.updateActionDueToComponentContentChange(pComponentID, pChangeParameters);
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    this.parameters.changeComponentIDs(pTranslatedIDs);
  },
  clone: function clone() {
    return Action.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = {
      type: this.type,
      parameters: this.parameters.toJSON()
    };
    return outputJSON;
  }
};
module.exports = Action;

},{"./ActionFunction.js":241,"./FormAction.js":250,"./JQueryEventPageTrigger.js":253,"./KeyPressEventTrigger.js":254,"./SubAction.js":258}],241:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var GUID = require("../../../cloudflow/CloudflowUtil/js/GUID.js");
var TranslationHandler = require("../../Translate/js/TranslationHandler.js");
var ActionPreparation = require("./ActionPreparation.js");

/**
 * @constructor ActionFunction
 * @description Handler pagebuilder actions. The philosofy is that the actions can be divided in fractions or families
 * and that each action is a configuration of a certain fraction. 
 * So the action contains to which fraction is it and what for configurations it needs
 */
var ActionFunction = function ActionFunction(pActionID, pID, pName, pStaticParameters, pPreparations, pPreActionFunction, pPostActionFunction) {
  this.setActionID(pActionID);
  if (pActionID === undefined || pActionID === null) {
    this._generateActionID();
  }
  this.setName(pName);
  this.setStaticParameters(pStaticParameters);
  this.setPreparations(pPreparations);
  this.setPreActionFunction(pPreActionFunction);
  this.setPostActionFunction(pPostActionFunction);
  // we need name and paramters for setID
  this.setID(pID);
};
ActionFunction.fromJSON = function (pJSON) {
  // handle backward compability
  if (pJSON.static_parameters === undefined && pJSON.parameters !== undefined) {
    pJSON.static_parameters = pJSON.parameters;
  }
  return new ActionFunction(pJSON.action_id, pJSON.id, pJSON.name, pJSON.static_parameters, pJSON.preparations, pJSON.preactionfunction, pJSON.postactionfunction);
};
ActionFunction.getName = function (pActionFunctionName, pParameters) {
  if (typeof pActionFunctionName !== "string" || pActionFunctionName.length <= 0) {
    throw new Error("ActionFunction.getName parameter must be a not empty string");
  }
  switch (pActionFunctionName) {
    case "trigger_event":
      if (pParameters !== undefined) {
        if (pParameters.triggername === "custompagebuilderclosecontainer") {
          return "close_me";
        } else if (pParameters.triggername === "custompagebuilderinternalredirect") {
          return "internal_redirect";
        }
      }
      return false;
    case "methode":
      if (pParameters !== undefined) {
        if (pParameters.componentName === "CustomPageComponentDialog" || pParameters.componentName === "CustomPageComponentDialog_returnCloseDef") {
          if (pParameters.methodeName === "close") {
            return "close_dialog";
          }
          return "dialog";
        } else if (pParameters.componentName === "FreezeOverlay") {
          if (pParameters.methodeArguments.show === true) {
            return "block_window";
          } else {
            return "unblock_window";
          }
        } else if (pParameters.componentName === "start") {
          return "start_flow_2";
        } else {
          // we come here on old actions
          // pleister
          if (window.api_mock === undefined || api_mock.actions === undefined) {
            // in pagebuilder pages outside the editor they have no api_mock
            // so apply some heuristic and we suppose the action is known
            return pParameters.componentName + "_" + pParameters.methodeName;
          }
          var possibleID = pParameters.componentName + "_" + pParameters.methodeName;
          // allow existing old ID's
          if (["CreateWorkable_waitUntilSubmitWorkflowIsDone", "PreConfiguredTable_refresh", "ManageProjects_refresh"].includes(possibleID)) {
            return possibleID;
          }
          // check if there exists something
          var actionJSON = api_mock.actions.get(possibleID);
          if (actionJSON !== null) {
            return actionJSON.id;
          }
        }
      }
      return false;
    case "frame":
      if (pParameters !== undefined) {
        var name;
        if (pParameters.callname === "open_folder_in_os") {
          name = "frame_open_folder";
        } else if (pParameters.callname === "reveal_file_in_os") {
          name = "frame_open_file";
        } else {
          throw new Error("ActionFunctionDefinition.getName unknown frame settings");
        }
        if (pParameters.inrow === true) {
          return name + "_inrow";
        } else if (pParameters.inrow === false) {
          return name;
        } else {
          // error
          console.error("parameter inrow is not true but no pagecontext is found");
          return false;
        }
      }
      return false;
    case "apicall":
      return "start_flow";
    case "redirect":
      if (pParameters !== undefined) {
        if (typeof pParameters.url === "string") {
          if (pParameters.url.indexOf("/portal.cgi?proofscope&url=") === 0) {
            if (pParameters.inrow === undefined || pParameters.inrow === true) {
              return "open_proofscope_in_row";
            } else {
              return "open_proofscope";
            }
          } else if (pParameters.url.indexOf("/portal.cgi?asset=download_file&url=") === 0) {
            if (pParameters.inrow === true) {
              return "download_file_inrow";
            } else {
              return "download_file";
            }
          } else if (pParameters.url.indexOf("/portal.cgi?asset=") === 0) {
            if (pParameters.inrow === undefined || pParameters.inrow === true) {
              return "open_assetviewer_inrow";
            } else {
              return "open_assetviewer";
            }
          }
        }
      }
      return "redirect";
    default:
      return pActionFunctionName;
  }
};
ActionFunction.prototype = {
  constructor: ActionFunction,
  setActionID: function setActionID(pUUID) {
    this.action_id = null;
    if (typeof pUUID === "string" && pUUID.length > 0) {
      this.action_id = pUUID;
    }
  },
  getActionID: function getActionID() {
    return this.action_id;
  },
  hasActionID: function hasActionID() {
    return typeof this.action_id === "string" && this.action_id.length > 0;
  },
  _generateActionID: function _generateActionID() {
    this.action_id = GUID.generate();
  },
  getID: function getID() {
    return this.id;
  },
  setID: function setID(pID) {
    this.id = undefined;
    if (pID === undefined) {
      // backwards comp
      this.id = ActionFunction.getName(this.name, this.static_parameters);
      if (typeof this.id !== "string") {
        console.error("ActionFunction.setID: could not retrieve id from old action");
      }
    }
    if (typeof pID === "string" && pID.length > 0) {
      this.id = pID;
    }
  },
  getName: function getName() {
    return this.name;
  },
  setName: function setName(pName) {
    if (typeof pName !== "string" || pName.length <= 0) {
      throw new Error("input parameter pName must be a string");
    }
    if (pageActionsDict[pName] === undefined) {
      throw new Error("unknown function with that name");
    }
    this.name = pName;
  },
  getInputParameterNames: function getInputParameterNames() {
    return pageActionsDict[this.name].inputParameterNames;
  },
  getStaticParameters: function getStaticParameters() {
    return this.static_parameters;
  },
  setStaticParameters: function setStaticParameters(pParameters) {
    if (pParameters === undefined) {
      this.static_parameters = {};
      return;
    }
    if (!pParameters || Object.getPrototypeOf(pParameters) !== Object.prototype) {
      throw new Error("input parameter pParameters must be an object");
    }
    for (var variable in pParameters) {
      if (typeof pParameters[variable] === "function") {
        throw new Error("staticParameters contains a function on key:" + variable);
      }
      if (variable === "length") {
        throw new Error("The word 'length' may not be used as key, because this is a reserved key word");
      }
      if (variable.indexOf("${") > -1) {
        throw new Error("A key contains the characters '${', which are not allowed");
      }
    }
    ;
    this.static_parameters = Object.assign({}, pParameters);
  },
  hasPreparations: function hasPreparations() {
    return this.preparations.hasPreparations();
  },
  getPreparations: function getPreparations() {
    return this.preparations;
  },
  setPreparations: function setPreparations(pPreparations) {
    if (pPreparations === undefined || pPreparations === null) {
      this.preparations = ActionPreparation.fromJSON([]);
    } else if (Array.isArray(pPreparations) === true) {
      this.preparations = ActionPreparation.fromJSON(pPreparations);
    } else if (pPreparations instanceof ActionPreparation) {
      this.preparations = pPreparations;
    } else {
      throw new Error("invalid interface for parameter pPreparations");
    }
  },
  hasPreActionFunction: function hasPreActionFunction() {
    return this.preActionFunction !== null;
  },
  getPreActionFunction: function getPreActionFunction() {
    return this.preActionFunction;
  },
  setPreActionFunction: function setPreActionFunction(pActionFunction) {
    if (pActionFunction === undefined || pActionFunction === null) {
      this.preActionFunction = null;
    } else if (pActionFunction instanceof ActionFunction) {
      this.preActionFunction = pActionFunction.clone();
    } else if (pActionFunction && Object.getPrototypeOf(pActionFunction) === Object.prototype) {
      this.preActionFunction = ActionFunction.fromJSON(pActionFunction);
    } else {
      throw new Error("pActionFunction has wrong interface");
    }
  },
  hasPostActionFunction: function hasPostActionFunction() {
    return this.postActionFunction !== null;
  },
  getPostActionFunction: function getPostActionFunction() {
    return this.postActionFunction;
  },
  setPostActionFunction: function setPostActionFunction(pActionFunction) {
    if (pActionFunction === undefined || pActionFunction === null) {
      this.postActionFunction = null;
    } else if (pActionFunction instanceof ActionFunction) {
      this.postActionFunction = pActionFunction.clone();
    } else if (pActionFunction && Object.getPrototypeOf(pActionFunction) === Object.prototype) {
      this.postActionFunction = ActionFunction.fromJSON(pActionFunction);
    } else {
      throw new Error("pActionFunction has wrong interface");
    }
  },
  getFunction: function getFunction() {
    return pageActionsDict[this.name].runtimeFunction;
  },
  hasLinkWithComponentID: function hasLinkWithComponentID(pComponentID) {
    if (typeof pComponentID !== "string" || pComponentID.length <= 0) {
      throw new Error("input parameter pComponentID must be a not empty string");
    }
    switch (this.getName()) {
      case "methode":
        var targetElementSelector = this.getStaticParameters().targetElem;
        if (typeof targetElementSelector === "string" && targetElementSelector.length > 0) {
          return targetElementSelector.split(" ").includes("#" + pComponentID);
        }
        return false;
      default:
        return false;
    }
  },
  removeComponentID: function removeComponentID(pComponentID) {
    if (this.hasLinkWithComponentID(pComponentID) === false) {
      return [pComponentID];
    } else {
      return [];
    }
  },
  getExternalResouceComponentNames: function getExternalResouceComponentNames() {
    var externalResourceComponents = [];
    if (typeof pageActionsDict[this.name].externalResouceComponentNames === "function") {
      var components = pageActionsDict[this.name].externalResouceComponentNames(this.getStaticParameters());
      if (Array.isArray(components)) {
        externalResourceComponents = externalResourceComponents.concat(components);
      }
    }
    return externalResourceComponents;
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    if (pTranslatedIDs && _typeof(pTranslatedIDs) === "object" && !Array.isArray(pTranslatedIDs) && Object.keys(pTranslatedIDs).length > 0) {
      for (var oldKey in pTranslatedIDs) {
        if (this.hasLinkWithComponentID(oldKey)) {
          switch (this.getName()) {
            case "methode":
              var oldtargetElementSelector = this.getStaticParameters().targetElem;
              this.getStaticParameters().targetElem = oldtargetElementSelector.replace(oldKey, pTranslatedIDs[oldKey]);
          }
        }
      }
    }
  },
  removeSubActionID: function removeSubActionID(pSubActionID) {
    switch (this.getName()) {
      case "subpageaction":
        if (this.getStaticParameters().sub_action_id === pSubActionID) {
          return [];
        } else {
          return [pSubActionID];
        }
      case "route":
        // in strange cases they want to delete the underlining private sub action
        if (this.static_parameters.rhs_values && this.static_parameters.rhs_values[0] && this.static_parameters.rhs_values[0].sub_action_id === pSubActionID) {
          return [];
        }
        if (this.static_parameters["else"] && this.static_parameters["else"].sub_action_id === pSubActionID) {
          return [];
        }
      default:
        return [pSubActionID];
    }
  },
  duplicate: function duplicate(pIDGenerator, pKeepTranslations, pOldTranslationPageHash, pNewTranslationpageHash, pToEnglishDict, pOrigPastedComponentID, pPastedComponentID) {
    // action ID
    var actionIDDict = {};
    var oldActionID = this.getActionID();
    this.setActionID(GUID.generate());
    actionIDDict[oldActionID] = this.getActionID();
    // parameters
    if (typeof pageActionsDict[this.name].duplicateStaticParameters === "function") {
      this.static_parameters = pageActionsDict[this.name].duplicateStaticParameters(this.static_parameters);
    } else {
      this.static_parameters = structuredClone(this.static_parameters);
    }
    var translationsDict = TranslationHandler.duplicateTranslations(this.static_parameters, pIDGenerator, oldActionID, this.getActionID(), pKeepTranslations, pOldTranslationPageHash, pNewTranslationpageHash, pToEnglishDict);
    // preaparations
    var preparationClone = this.preparations.clone();
    if (preparationClone.hasPreparations()) {
      var preparationValueRegExp = new RegExp('{"type":"com\.nixps\.localization\.look_up\.0","translation_key":"(pb-....)-(' + oldActionID + ')(_[A-Za-z]*\.[A-Za-z]*)"', "g");
      var preparationGenericValueRegExp = new RegExp('{"type":"com\.nixps\.localization\.look_up\.0","translation_key":"(pb-.{4})-(.{8}-.{4}-.{4}-.{4}-.{12})(_[A-Za-z]*\.[A-Za-z_]*)"', "g");
      preparationClone.getVariables().forEach(function (pPreparation) {
        var value = pPreparation.getValue();
        if (typeof value === "string") {
          if (preparationValueRegExp.test(value)) {
            pPreparation.setValue(value.replace(preparationValueRegExp, function (pMatch, p1, p2, p3) {
              if (p1 === pOldTranslationPageHash && pOldTranslationPageHash !== pNewTranslationpageHash) {
                translationsDict[p1 + "-" + p2 + p3] = pNewTranslationpageHash + "-" + actionIDDict[oldActionID] + p3;
              } else {
                translationsDict[p1 + "-" + p2 + p3] = p1 + "-" + actionIDDict[oldActionID] + p3;
              }
              return '{"type":"com.nixps.localization.look_up.0","translation_key":"' + translationsDict[p1 + "-" + p2 + p3] + '"';
            }));
          } else if (preparationGenericValueRegExp.test(value)) {
            pPreparation.setValue(value.replace(preparationGenericValueRegExp, function (pMatch, p1, p2, p3) {
              if (translationsDict[p1 + "-" + p2 + p3] === undefined) {
                translationsDict[p1 + "-" + p2 + p3] = pNewTranslationpageHash + pIDGenerator() + p3;
              }
              return '{"type":"com.nixps.localization.look_up.0","translation_key":"' + translationsDict[p1 + "-" + p2 + p3] + '"';
            }));
          }
        }
      });
    }
    this.setPreparations(preparationClone.toJSON());
    if (this.hasPreActionFunction()) {
      var prepareActionFunctionClone = this.preActionFunction.clone();
      var prepareActionFunctionOutput = prepareActionFunctionClone.duplicate.apply(prepareActionFunctionClone, arguments);
      if (prepareActionFunctionOutput) {
        if (_typeof(prepareActionFunctionOutput.actionIDDict) === "object") {
          actionIDDict = Object.assign(actionIDDict, prepareActionFunctionOutput.actionIDDict);
        }
        if (_typeof(prepareActionFunctionOutput.translationsDict) === "object") {
          translationsDict = Object.assign(translationsDict, prepareActionFunctionOutput.translationsDict);
        }
      }
      this.setPreActionFunction(prepareActionFunctionClone);
    }
    if (this.hasPostActionFunction()) {
      var postActionFunctionClone = this.postActionFunction.clone();
      var postActionFunctionOutput = postActionFunctionClone.duplicate.apply(postActionFunctionClone, arguments);
      if (postActionFunctionOutput) {
        if (_typeof(postActionFunctionOutput.actionIDDict) === "object") {
          actionIDDict = Object.assign(actionIDDict, postActionFunctionOutput.actionIDDict);
        }
        if (_typeof(postActionFunctionOutput.translationsDict) === "object") {
          translationsDict = Object.assign(translationsDict, postActionFunctionOutput.translationsDict);
        }
      }
      this.setPostActionFunction(postActionFunctionClone);
    }
    return {
      "componentDict": {},
      "actionIDDict": actionIDDict,
      "translationsDict": translationsDict
    };
  },
  getPrivateInternalSubActions: function getPrivateInternalSubActions() {
    if (typeof pageActionsDict[this.name].privateSubActions === "function") {
      return pageActionsDict[this.name].privateSubActions(this.static_parameters);
    }
    return [];
  },
  clone: function clone() {
    return ActionFunction.fromJSON(this.toJSON());
  },
  toString: function toString() {
    return JSON.stringify(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = {
      action_id: this.action_id,
      id: this.id,
      name: this.name,
      static_parameters: this.static_parameters,
      preparations: this.preparations.toJSON()
    };
    if (this.hasPreActionFunction()) {
      outputJSON.preactionfunction = this.preActionFunction.toJSON();
    }
    if (this.hasPostActionFunction()) {
      outputJSON.postactionfunction = this.postActionFunction.toJSON();
    }
    return outputJSON;
  }
};
var pageActionsDict = {
  "test": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction() {
      return arguments;
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return [];
    }
  },
  "reload": {
    inputParameterNames: [],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent, pData, pPreviousResults, helpFunctions) {
      if (helpFunctions.enterAction && helpFunctions.enterAction("reload", pEvent) === false) {
        return Promise.reject({
          error_code: "abort_action",
          error: "a refresh loop has been detected and has been aborted"
        });
      }
      window.location.reload();
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return [];
    }
  },
  "redirect": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent, pData, pPreviousResults, helpFunctions) {
      if (helpFunctions.enterAction && helpFunctions.enterAction("redirect", pEvent) === false) {
        return Promise.reject({
          error_code: "abort_action",
          error: "a redirect loop has been detected and has been aborted"
        });
      }
      if (pEventdata !== undefined && typeof pEventdata.url === "string") {
        if (pEventdata.open_plugin_window === true) {
          var host = new URLSearchParams(location.search).get("host");
          if (typeof host === "string" && host.length > 0) {
            return api_defer.frame.host.get(host).then(function () {
              return api_defer.frame.host.open_window(pEventdata.url, true).then(function (pData) {
                window.close();
              });
            })["catch"](function (pError) {
              console.error(pError);
              return Promise.reject(pError);
            });
          } else {
            console.error("Action Redirect: no host found for plugin");
            return Promise.reject({
              error_code: "no_host_found",
              error: "Action Redirect: no host found for plugin"
            });
          }
        } else if (pEventdata.download === true || typeof pEventdata.download === "string") {
          var aDOM = document.createElement("A");
          aDOM.setAttribute("href", pEventdata.url);
          aDOM.setAttribute("download", typeof pEventdata.download === "string" ? pEventdata.download : "");
          aDOM.setAttribute("target", "_blank");
          aDOM.click();
          return Promise.resolve({});
        } else if (pEventdata.open_new_window === true) {
          var newWindow = window.open(pEventdata.url);
          if (newWindow === null) {
            console.error("Action Redirect: new tab has been blocked");
            return $("body").Dialog("show_yes_no", $.i18n._("nixps-cloudflow-pagebuilder.confirmmessagetitle_newtab"), $.i18n._("nixps-cloudflow-pagebuilder.confirmmessage_newtab"), {}, function () {
              window.open(pEventdata.url);
            });
          }
          return Promise.resolve({});
        } else {
          window.location.href = pEventdata.url;
        }
      } else {
        console.error("Action Redirect: missing url");
        return Promise.reject({
          error_code: "missing_url",
          error: "Action Redirect: missing url"
        });
      }
    },
    externalResouceComponentNames: function externalResouceComponentNames(pStaticData) {
      if (typeof pStaticData.url === "string" && pStaticData.open_plugin_window === true) {
        return ["frame"];
      }
      return [];
    }
  },
  "historygo": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent) {
      var steps = -1;
      if (pEventdata !== undefined) {
        if (typeof pEventdata.steps === "number") {
          steps = pEventdata.steps;
        }
      }
      window.history.go(steps);
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return [];
    }
  },
  "methode": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent) {
      if (pEventdata !== undefined && pEventdata.targetElem !== undefined && typeof pEventdata.componentName === "string" && pEventdata.componentName.length > 0) {
        var applyArguments = typeof pEventdata.methodeName === "string" ? [pEventdata.methodeName] : [];
        applyArguments = applyArguments.concat(pEventdata.methodeArguments);
        var target;
        if (pEventdata.target === "window") {
          return Promise.resolve(window[pEventdata.componentName][pEventdata.functionName].apply(window, applyArguments));
        } else if (pEventdata.target === "localvar") {
          target = pEventdata.targetElem;
        } else if (pEventdata.target === true) {
          target = $(pEvent.target).closest(pEventdata.targetElem);
          if (target.length === 0) {
            target = $(pEvent.currentTarget).closest(pEventdata.targetElem);
          }
        } else if (pEventdata.target === "jqueryselector") {
          target = $(pEventdata.targetElem);
        } else {
          target = $(pEventdata.targetElem);
        }
        if (target.length === 0) {
          console.error("Action Methode: target not found in DOM");
        }
        var out = target[pEventdata.componentName].apply(target, applyArguments);
        if (window.jQuery && target instanceof window.jQuery && out instanceof window.jQuery) {
          return Promise.resolve({});
        }
        return out && typeof out.then === "function" ? out : Promise.resolve(out);
      } else {
        console.error("Action Methode: missing targetElem or ComponentName");
        return Promise.reject({
          error_code: "missing_inputdata",
          error: "Action Methode: missing targetElem or ComponentName"
        });
      }
    },
    externalResouceComponentNames: function externalResouceComponentNames(pStaticData) {
      if (typeof pStaticData.componentName === "string" && pStaticData.componentName.length > 0) {
        return [pStaticData.componentName];
      }
      return [];
    }
  },
  "apicall": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent) {
      var apicall = api_async;
      var callproxy = api_async;
      for (var i = 0; i < pEventdata.apicall.length - 1; i++) {
        apicall = apicall[pEventdata.apicall[i]];
        callproxy = callproxy[pEventdata.apicall[i]];
      }
      apicall = apicall[pEventdata.apicall[i++]];
      return new Promise(function (pResolve, pReject) {
        pEventdata.callArguments.push(pResolve);
        pEventdata.callArguments.push(function (pError) {
          console.error("Action apicall: call failed ", Error);
          pReject(pError);
        });
        apicall.apply(callproxy, pEventdata.callArguments);
      });
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return [];
    }
  },
  "trigger_event": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent, pData, pPreviousResults, helpFunctions) {
      if (pEvent !== undefined && pEvent.target !== undefined && pEventdata !== undefined && typeof pEventdata.triggername === "string" && pEventdata.triggername.length > 0) {
        var target;
        if (pEventdata.target !== undefined) {
          target = $(pEventdata.target);
        } else {
          target = $(pEvent.target);
        }
        if (pEventdata.apply_on_parent === true) {
          target = target.parent();
        }
        if (helpFunctions.enterAction && helpFunctions.enterAction("trigger_event_" + pEventdata.triggername, pEvent) === false) {
          return Promise.reject({
            error_code: "abort_action",
            error: "an infinity loop has been detected and has been aborted"
          });
        }
        var pReturnDef = {
          returnOutput: undefined
        };
        var res = target.trigger(pEventdata.triggername, [pEventdata.triggerdata, pEvent, pReturnDef]);
        if (pReturnDef && pReturnDef.returnOutput !== undefined) {
          Promise.resolve(pReturnDef.returnOutput)["finally"](function () {
            helpFunctions.leaveAction && helpFunctions.leaveAction("trigger_event_" + pEventdata.triggername, pEvent);
          });
          return pReturnDef.returnOutput;
        }
        helpFunctions.leaveAction && helpFunctions.leaveAction("trigger_event_" + pEventdata.triggername, pEvent);
        return res;
      } else {
        console.error("Action TriggerEvent: missing target or targetname");
        return Promise.reject({
          error_code: "missing_inputdata",
          error: "Action TriggerEvent: missing target or targetname"
        });
      }
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return [];
    }
  },
  "route": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent, pData, pPreviousResults, helpFunctions) {
      if (pEventdata !== undefined && pEventdata.lhs_value !== undefined && pEventdata.rhs_values !== undefined) {
        var _runSubActionFunction = helpFunctions.runSubAction;
        var pass = false;
        for (var i = 0; i < pEventdata.rhs_values.length; i++) {
          if (pEventdata.condition === "equal to") {
            if (typeof window._ === "function" && (_typeof(pEventdata.lhs_value) === "object" || _typeof(pEventdata.rhs_values[i].value) === "object")) {
              pass = _.isEqual(pEventdata.lhs_value, pEventdata.rhs_values[i].value);
            } else if (pEventdata.lhs_value == pEventdata.rhs_values[i].value) {
              pass = true;
            }
          } else if (pEventdata.condition === "not equal to") {
            if (typeof window._ === "function" && (_typeof(pEventdata.lhs_value) === "object" || _typeof(pEventdata.rhs_values[i].value) === "object")) {
              pass = !_.isEqual(pEventdata.lhs_value, pEventdata.rhs_values[i].value);
            } else if (pEventdata.lhs_value !== pEventdata.rhs_values[i].value) {
              pass = true;
            }
          } else if (pEventdata.condition === "begins with") {
            if (["string", "number", "boolean"].includes(_typeof(pEventdata.lhs_value)) && !isNaN(pEventdata.lhs_value) && ["string", "number", "boolean"].includes(_typeof(pEventdata.rhs_values[i].value)) && !isNaN(pEventdata.rhs_values[i].value)) {
              pass = pEventdata.lhs_value.toString().startsWith("" + pEventdata.rhs_values[i].value);
            } else if (typeof window._ === "function" && Array.isArray(pEventdata.lhs_value) && pEventdata.lhs_value.length > 0 && _.isEqual(pEventdata.lhs_value[0], pEventdata.rhs_values[i].value)) {
              pass = true;
            }
          } else if (pEventdata.condition === "begins like") {
            if (["string", "number", "boolean"].includes(_typeof(pEventdata.lhs_value)) && !isNaN(pEventdata.lhs_value) && ["string", "number", "boolean"].includes(_typeof(pEventdata.rhs_values[i].value)) && !isNaN(pEventdata.rhs_values[i].value)) {
              pass = pEventdata.lhs_value.toString().toUpperCase().startsWith(pEventdata.rhs_values[i].value.toString().toUpperCase());
            }
          } else if (pEventdata.condition === "ends with") {
            if (["string", "number", "boolean"].includes(_typeof(pEventdata.lhs_value)) && !isNaN(pEventdata.lhs_value) && ["string", "number", "boolean"].includes(_typeof(pEventdata.rhs_values[i].value)) && !isNaN(pEventdata.rhs_values[i].value)) {
              pass = pEventdata.lhs_value.toString().endsWith("" + pEventdata.rhs_values[i].value);
            } else if (typeof window._ === "function" && Array.isArray(pEventdata.lhs_value) && pEventdata.lhs_value.length > 0 && _.isEqual(pEventdata.lhs_value[pEventdata.lhs_value.length - 1], pEventdata.rhs_values[i].value)) {
              pass = true;
            }
          } else if (pEventdata.condition === "ends like") {
            if (["string", "number", "boolean"].includes(_typeof(pEventdata.lhs_value)) && !isNaN(pEventdata.lhs_value) && ["string", "number", "boolean"].includes(_typeof(pEventdata.rhs_values[i].value)) && !isNaN(pEventdata.rhs_values[i].value)) {
              pass = pEventdata.lhs_value.toString().toUpperCase().endsWith(pEventdata.rhs_values[i].value.toString().toUpperCase());
            }
          } else if (pEventdata.condition === "contains") {
            if (["string", "number", "boolean"].includes(_typeof(pEventdata.lhs_value)) && !isNaN(pEventdata.lhs_value)) {
              pass = ("" + pEventdata.lhs_value).indexOf("" + pEventdata.rhs_values[i].value) >= 0;
            } else if (Array.isArray(pEventdata.lhs_value)) {
              pass = pEventdata.lhs_value.indexOf(pEventdata.rhs_values[i].value) >= 0;
            }
          } else {
            if (typeof pEventdata.lhs_value === "string" && typeof pEventdata.rhs_values[i].value === "string") {
              if (pEventdata.lhs_value.length < pEventdata.rhs_values[i].value.length) {
                pEventdata.lhs_value = pEventdata.lhs_value.padStart(pEventdata.rhs_values[i].value.length);
              } else if (pEventdata.lhs_value.length > pEventdata.rhs_values[i].value.length) {
                pEventdata.rhs_values[i].value = pEventdata.rhs_values[i].value.padStart(pEventdata.lhs_value.length);
              }
            }
            if (pEventdata.condition === "less than") {
              if ((pEventdata.lhs_value === null ? NaN : pEventdata.lhs_value) < (pEventdata.rhs_values[i].value === null ? NaN : pEventdata.rhs_values[i].value)) {
                pass = true;
              }
            } else if (pEventdata.condition === "greater than") {
              if ((pEventdata.lhs_value === null ? NaN : pEventdata.lhs_value) > (pEventdata.rhs_values[i].value === null ? NaN : pEventdata.rhs_values[i].value)) {
                pass = true;
              }
            }
          }
          if (pass === true) {
            return _runSubActionFunction(pEventdata.rhs_values[i].sub_action_id, pEvent, pData, pPreviousResults);
          }
        }
        if (pEventdata["else"] !== undefined) {
          if (typeof pEventdata["else"].sub_action_id === "string" && pEventdata["else"].sub_action_id.length > 0) {
            return _runSubActionFunction(pEventdata["else"].sub_action_id, pEvent, pData, pPreviousResults);
          }
        }
      } else {
        console.error("Action route: missing lhs_value and or rhs_values");
        return Promise.reject({
          error_code: "missing_inputdata",
          error: "Action route: missing lhs_value and or rhs_values"
        });
      }
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return [];
    },
    privateSubActions: function privateSubActions(pEventdata) {
      var subActionJSONs = [];
      if (Array.isArray(pEventdata.rhs_values) && pEventdata.rhs_values.length > 0) {
        for (var i = 0; i < pEventdata.rhs_values.length; i++) {
          subActionJSONs.push({
            id: pEventdata.rhs_values[i].sub_action_id,
            name: "__action_route__",
            access_control: "private",
            action_functions: pEventdata.rhs_values[i]._subactions
          });
        }
      }
      if (pEventdata["else"] !== undefined) {
        if (typeof pEventdata["else"].sub_action_id === "string" && pEventdata["else"].sub_action_id.length > 0) {
          subActionJSONs.push({
            id: pEventdata["else"].sub_action_id,
            name: "__action_route__",
            access_control: "private",
            action_functions: pEventdata["else"]._subactions
          });
        }
      }
      return subActionJSONs;
    },
    duplicateStaticParameters: function duplicateStaticParameters(pStaticParameters) {
      var clonedStaticParameters = structuredClone(pStaticParameters);
      if (Array.isArray(clonedStaticParameters.rhs_values) && clonedStaticParameters.rhs_values.length > 0) {
        for (var i = 0; i < clonedStaticParameters.rhs_values.length; i++) {
          if (typeof clonedStaticParameters.rhs_values[i].sub_action_id === "string" && clonedStaticParameters.rhs_values[i].sub_action_id.length > 0) {
            clonedStaticParameters.rhs_values[i].sub_action_id = GUID.generate();
          }
        }
      }
      if (clonedStaticParameters["else"] && typeof clonedStaticParameters["else"].sub_action_id === "string" && clonedStaticParameters["else"].sub_action_id.length > 0) {
        clonedStaticParameters["else"].sub_action_id = GUID.generate();
      }
      return clonedStaticParameters;
    }
  },
  "subpageaction": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent, pData, pPreviousResults, helpFunctions) {
      if (pEventdata && typeof pEventdata.sub_action_id === "string") {
        helpFunctions.enterAction && helpFunctions.enterAction(pEventdata.sub_action_id, pEvent);
        return Promise.resolve(helpFunctions.runSubAction(pEventdata.sub_action_id, pEvent, {
          inputParameters: pEventdata.input_parameters,
          eventData: pData
        }, pPreviousResults))["finally"](function () {
          helpFunctions.leaveAction && helpFunctions.leaveAction(pEventdata.sub_action_id, pEvent);
        });
      } else {
        console.error("Action subpageaction: missing sub_action_id data");
        return Promise.reject({
          error_code: "missing_inputdata",
          error: "Action subpageaction: missing sub_action_id"
        });
      }
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return [];
    }
  },
  "frame": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent) {
      if (pEventdata !== undefined) {
        return new Promise(function (pResolve, pReject) {
          api_async.frame.os.get().then(function () {
            if (pEventdata.callname === "reveal_file_in_os" && typeof pEventdata.url === "string" && pEventdata.url.length > 0) {
              api_async.frame.os.reveal_file_in_os(pEventdata.url, {}, pResolve, pReject);
            } else if (pEventdata.callname === "open_folder_in_os" && typeof pEventdata.url === "string" && pEventdata.url.length > 0) {
              api_async.frame.os.open_folder_in_os(pEventdata.url, {}, pResolve, pReject);
            } else if (pEventdata.callname === "open_file_in_application" && typeof pEventdata.url === "string" && pEventdata.url.length > 0) {
              if (typeof pEventdata.application_name !== "string" || pEventdata.application_name.length <= 0) {
                console.error("Action Frame: missing application name");
                pReject({
                  error_code: "missing_name",
                  error: "Action Frame: missing application name"
                });
              } else {
                // pEventdata.application_name = "PACKZ";
                api_async.frame.os.open_file_in_application(pEventdata.url, pEventdata.application_name, {}, pResolve, pReject);
              }
            } else {
              console.error("Action Frame: wrong input data");
              pReject({
                error_code: "wrong_input_data",
                error: "Action Frame: wrong input data"
              });
            }
          }, function (pError) {
            console.error("Action Frame: no frame activated ", pError);
            pReject({
              error_code: "no_frame_found",
              error: "Action Frame: no frame activated",
              child: pError
            });
          });
        });
      }
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return ["frame"];
    }
  },
  "wait": {
    inputParameterNames: ["pEventdata"],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent, pData, pPreviousResults) {
      if (pEventdata !== undefined) {
        if (isNaN(pEventdata.delay) || isFinite(pEventdata.delay) === false || pEventdata.delay < 0) {
          console.warn("invalid delay, reset to zero", pEventdata.delay);
          pEventdata.delay = 0;
        } else if (pEventdata.delay > 2147483.647) {
          console.warn("Delay too big, reset to 12h", pEventdata.delay);
          pEventdata.delay = 43200.000;
        }
        return new Promise(function (pResolve) {
          setTimeout(function () {
            pResolve(pPreviousResults);
          }, pEventdata.delay * 1000);
        });
      } else {
        console.error("Wait: wrong input data");
        return Promise.reject({
          error_code: "wrong_input_data",
          error: "Wait: wrong input data"
        });
      }
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return [];
    }
  },
  "/*comment*/": {
    inputParameterNames: [],
    runtimeFunction: function runtimeFunction(pEventdata, pEvent, pData, pPreviousResults) {
      return Promise.resolve(pPreviousResults);
    },
    externalResouceComponentNames: function externalResouceComponentNames() {
      return [];
    }
  }
};
module.exports = ActionFunction;

},{"../../../cloudflow/CloudflowUtil/js/GUID.js":89,"../../Translate/js/TranslationHandler.js":234,"./ActionPreparation.js":243}],242:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var Action = require("./Action.js");
var JQueryEventPageTrigger = require("./JQueryEventPageTrigger.js");

/**
 * @description object managing a group of actions
 * @constructor ActionList
 * @param {Array} pActions An array containing actions
 */
var ActionList = function ActionList(pActions) {
  this.actions = [];
  this.setActions(pActions);
};
ActionList.fromJSON = function (json) {
  return new ActionList(json);
};
ActionList.prototype = {
  constructor: ActionList,
  hasActions: function hasActions() {
    return this.actions.length > 0;
  },
  getActions: function getActions() {
    return this.actions;
  },
  setActions: function setActions(pActions) {
    if (Array.isArray(pActions) === false) {
      throw new Error("ActionList: pActions must be an array");
    }
    this.actions = [];
    for (var i = 0; i < pActions.length; i++) {
      if (pActions[i] instanceof Action) {
        this.actions.push(pActions[i]);
      } else if (pActions[i] && _typeof(pActions[i]) === "object" && Object.getPrototypeOf(pActions[i]) === Object.prototype) {
        this.actions.push(Action.fromJSON(pActions[i]));
      } else {
        throw new Error("ActionList: invalid interface of the action at index " + i);
      }
    }
  },
  removeActionByIndex: function removeActionByIndex(pIndex) {
    if (this.hasActions() && this._checkIndex(pIndex) === true) {
      this.actions.splice(pIndex, 1);
    }
  },
  removeByComponentID: function removeByComponentID(pComponentID) {
    if (Array.isArray(this.actions) && this.actions.length > 0) {
      for (var i = this.actions.length - 1; i >= 0; i--) {
        var remainingIDs = this.actions[i].removeLinkWithComponentID(pComponentID);
        if (Array.isArray(remainingIDs) && remainingIDs.length === 0) {
          // remove only if it was the last and only componentID
          this.actions.splice(i, 1);
        }
      }
    }
  },
  removeLinkWithSubActionID: function removeLinkWithSubActionID(pSubAction) {
    if (Array.isArray(this.actions) && this.actions.length > 0) {
      for (var i = this.actions.length - 1; i >= 0; i--) {
        var remainingIDs = this.actions[i].removeLinkWithSubActionID(pSubAction);
        if (Array.isArray(remainingIDs) && remainingIDs.length === 0) {
          // remove only if it was the last and only componentID
          this.actions.splice(i, 1);
        }
      }
    }
  },
  getActionsLinkedWithComponentID: function getActionsLinkedWithComponentID(pComponentID) {
    var output = [];
    if (Array.isArray(this.actions) && this.actions.length > 0) {
      for (var i = this.actions.length - 1; i >= 0; i--) {
        if (this.actions[i].hasLinkWithComponentID(pComponentID)) {
          output.push(this.actions[i].clone());
        }
      }
    }
    return output;
  },
  updateActionDueToComponentContentChange: function updateActionDueToComponentContentChange(pComponentID, pChangeParameters) {
    if (Array.isArray(this.actions) && this.actions.length > 0) {
      for (var i = this.actions.length - 1; i >= 0; i--) {
        var remainingIDs = this.actions[i].updateActionDueToComponentContentChange(pComponentID, pChangeParameters);
        if (Array.isArray(remainingIDs) && remainingIDs.length === 0) {
          // remove only if it was the last and only componentID
          this.actions.splice(i, 1);
        }
      }
    }
  },
  addAction: function addAction(pAction) {
    if (pAction instanceof Action) {
      this.actions.push(pAction);
    } else if (pAction && _typeof(pAction) === "object" && Object.getPrototypeOf(pAction) === Object.prototype) {
      this.actions.push(Action.fromJSON(pAction));
    } else {
      throw new Error("ActionList: invalid interface of the added action");
    }
  },
  addActions: function addActions(pActions) {
    if (Array.isArray(pActions) && pActions.length > 0) {
      for (var i = 0; i < pActions.length; i++) {
        this.addAction(pActions[i]);
      }
    }
  },
  setAction: function setAction(pIndex, pAction) {
    if (this._checkIndex(pIndex)) {
      if (pAction instanceof Action) {
        this.actions[pIndex] = pAction;
      } else if (pAction && _typeof(pAction) === "object" && Object.getPrototypeOf(pAction) === Object.prototype) {
        this.actions[pIndex] = Action.fromJSON(pAction);
      } else {
        throw new Error("ActionList: invalid interface of the added action");
      }
    }
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    if (Array.isArray(this.actions) && this.actions.length > 0) {
      for (var i = 0; i < this.actions.length; i++) {
        this.actions[i].changeComponentIDs(pTranslatedIDs);
      }
    }
  },
  changeTriggerNames: function changeTriggerNames(pChanges, pComponentName) {
    for (var i = 0; i < this.actions.length; i++) {
      if (this.actions[i].getType() === JQueryEventPageTrigger.getIdentificationType()) {
        this.actions[i].getParameters().triggerNameChange(pChanges, pComponentName);
      }
    }
  },
  getComponentLayoutInfo: function getComponentLayoutInfo() {
    var layoutInfoDict = {};
    for (var i = 0; i < this.actions.length; i++) {
      if (this.actions[i].getType() === JQueryEventPageTrigger.getIdentificationType()) {
        var data = this.actions[i].getParameters().getLayoutInfo();
        if (data && data.eventname !== undefined) {
          var hash = data.eventname + data.selector;
          if (layoutInfoDict[hash] === undefined) {
            layoutInfoDict[hash] = {};
          }
          layoutInfoDict[hash] = Object.assign(layoutInfoDict[hash], data);
        }
      }
    }
    var layoutInfo = [];
    for (var hash in layoutInfoDict) {
      layoutInfo.push(layoutInfoDict[hash]);
    }
    return layoutInfo;
  },
  _checkIndex: function _checkIndex(pIndex) {
    if (typeof pIndex !== "number") {
      throw new Error("The index must be an number");
    } else if (pIndex < 0) {
      throw new Error("The index may not be negative");
    } else if (pIndex >= this.actions.length) {
      throw new Error("Index out of range");
    } else {
      return true;
    }
  },
  duplicate: function duplicate() {
    var returnOutput = {};
    for (var i = 0; i < this.actions.length; i++) {
      var _this$actions$i;
      var output = (_this$actions$i = this.actions[i]).duplicate.apply(_this$actions$i, arguments);
      if (output && _typeof(output) === "object") {
        returnOutput = Object.assign(returnOutput, output);
      }
    }
    return returnOutput;
  },
  clone: function clone() {
    return ActionList.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var actionJSONs = [];
    for (var i = 0; i < this.actions.length; i++) {
      actionJSONs.push(this.actions[i].toJSON());
    }
    return actionJSONs;
  }
};
module.exports = ActionList;

},{"./Action.js":240,"./JQueryEventPageTrigger.js":253}],243:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var Preparation = function Preparation(pKey, pValue, pType) {
  this.setKey(pKey);
  this.setValue(pValue);
  this.setType(pType);
};
Preparation.fromJSON = function (json) {
  return new Preparation(json.variablekey, json.variablevalue, json.preparationtype);
};
Preparation.prototype = {
  constructor: Preparation,
  setKey: function setKey(pKey) {
    this.variablekey = pKey;
  },
  getKey: function getKey() {
    return this.variablekey;
  },
  setValue: function setValue(pValue) {
    this.variablevalue = pValue;
  },
  getValue: function getValue() {
    return this.variablevalue;
  },
  setType: function setType(pType) {
    // the type must be a known one
    if (["functionstring"].includes(pType) === false) {
      throw new Error("Preparation: invalid type found " + pType);
    }
    this.preparationtype = pType;
  },
  getType: function getType() {
    return this.preparationtype;
  },
  clone: function clone() {
    return Preparation.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {
      variablekey: this.variablekey,
      variablevalue: this.variablevalue,
      preparationtype: this.preparationtype
    };
  }
};

/**
 * @constructor ActionPreparation
 * @description do some stuff before an action can run, like setting up some variables.
 * used inside a {@link ActionFunction}
 * @param {Object} pVariables 
 */
var ActionPreparation = function ActionPreparation(pVariables) {
  this.setVariables(pVariables);
};
ActionPreparation.fromJSON = function (pJSON) {
  return new ActionPreparation(pJSON);
};
ActionPreparation.prototype = {
  constructor: ActionPreparation,
  setVariables: function setVariables(pVariables) {
    if (pVariables === undefined) {
      this.variables = [];
      return;
    }
    if (Array.isArray(pVariables) === false) {
      throw new Error("ActionPreparation: variables parameter must be an array");
    }
    this.variables = [];
    for (var i = 0; i < pVariables.length; i++) {
      if (pVariables[i] instanceof Preparation) {
        this.variables.push(pVariables[i].clone());
      } else if (pVariables[i] && _typeof(pVariables[i]) === "object" && !Array.isArray(pVariables[i])) {
        this.variables.push(Preparation.fromJSON(pVariables[i]));
      } else {
        throw new Error("ActionPreparation: variables contains one incorrect preparation");
      }
    }
  },
  getVariables: function getVariables() {
    return this.variables;
  },
  hasPreparations: function hasPreparations() {
    return this.variables.length > 0;
  },
  clone: function clone() {
    return ActionPreparation.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    if (this.hasPreparations() === false) {
      return [];
    }
    var output = [];
    for (var i = 0; i < this.variables.length; i++) {
      output.push(this.variables[i].toJSON());
    }
    return output;
  }
};
module.exports = ActionPreparation;

},{}],244:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var LayoutComponent = require("./LayoutComponent.js");
var LayoutRow = require("./LayoutRow.js");
function validateIndex(pArray, pIndex) {
  // is number
  if (typeof pIndex !== "number") {
    throw new Error("invalid index: not a number");
  }

  // is index in interval??
  if (pIndex < 0) {
    // is negative
    throw new Error("invalid index: negative");
  }
  if (pIndex >= pArray.length) {
    // out of bound of array
    throw new Error("invalid index: out of bounds");
  }
}
function calcGCD(pNumbers) {
  var g = 0;
  var _iterator = _createForOfIteratorHelper(pNumbers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var n = _step.value;
      n = Math.abs(n);
      while (n) {
        var _ref = [n, g % n];
        g = _ref[0];
        n = _ref[1];
      }
      if (g === 1) {
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return g;
}

/**
 * @class BootstrapGridLayout
 * @description A type of Layout based on the 12 columns of bootstrap
 * @param {Array} pLayoutRows  
 * @param {String} pRowClasses
 * @param {String} pRootClasses
 * @param {String} pChildrenOverflow
 */
var BootstrapGridLayout = function BootstrapGridLayout(pLayoutRows, pRowClasses, pRootClasses, pChildrenOverflow, pTableOfContents, pLabelInputPosition) {
  this.rows = [];
  this.table_of_contents = null;
  this.setRows(pLayoutRows);
  this.setRowClasses(pRowClasses);
  this.setRootClasses(pRootClasses);
  this.setChildrenOverflow(pChildrenOverflow);
  this.setTableOfContents(pTableOfContents);
  this.setLabelInputPosition(pLabelInputPosition);
};
BootstrapGridLayout.fromJSON = function (json) {
  var rows = [],
    row_classes,
    root_classes,
    children_overflow,
    table_of_contents,
    label_input_position;
  if (json && _typeof(json) === "object" && !Array.isArray(json)) {
    for (var i = 0; i < json.rows.length; i++) {
      rows.push(LayoutRow.fromJSON(json.rows[i]));
    }
    row_classes = json.row_classes;
    root_classes = json.root_classes;
    children_overflow = json.children_overflow;
    table_of_contents = json.table_of_contents;
    label_input_position = json.label_input_position;
  } else if (Array.isArray(json)) {
    for (var i = 0; i < json.length; i++) {
      rows.push(LayoutRow.fromJSON(json[i]));
    }
  } else {
    throw new Error("unknown json format to parse");
  }
  return new BootstrapGridLayout(rows, row_classes, root_classes, children_overflow, table_of_contents, label_input_position);
};
BootstrapGridLayout.createCompatibleLayout = function (pIDs, pDeviceClass, pRowClasses, pRootClasses) {
  if (Array.isArray(pIDs) === false) {
    throw new Error("parameter pIDs must be a array");
  }
  var rows = [];
  for (var i = 0; i < pIDs.length; i++) {
    if (typeof pIDs[i] !== "string" || pIDs[i].length <= 0) {
      throw new Error("the id at " + i + " must be a string");
    }
    rows.push(new LayoutRow([new LayoutComponent(pIDs[i], 12, pDeviceClass)]));
  }
  return new BootstrapGridLayout(rows, pRowClasses, pRootClasses);
};
BootstrapGridLayout.prototype = {
  constructor: BootstrapGridLayout,
  insertNewComponent: function insertNewComponent(pComponent, pIndex, pDeviceClass, pRowIndex, pDummyWidth) {
    if (pComponent instanceof LayoutComponent === false) {
      throw new Error("component must be a layoutcomponent");
    }
    if (typeof pIndex !== "number" || pIndex < 0) {
      throw new Error("parameter index must be a positive number");
    }
    var report = {
      rowIndex: pRowIndex,
      indexInRow: pIndex + 1,
      overflow: false
    };
    // ask to row to inset element
    var row = this.getRow(pRowIndex);
    row.insertNewComponent(pComponent, pIndex, pDeviceClass);
    // detect overflow and change overflowed elements to new row
    //  detect overflow
    var totalWidth = 0;
    var overflowIndex = -1; // the index of the element that should replace to new row
    for (var i = 0; i < row.getElements().length; i++) {
      totalWidth += row.getElement(i).getWidth(pDeviceClass);
      if (totalWidth > 12) {
        overflowIndex = i;
        break;
      }
    }
    if (overflowIndex > 0) {
      // overflow detected
      report.overflow = true;
      // make new row
      var oldAdapptedRowLength = row.getElements().length;
      var oldAdapptedRowElements = row.getElements().slice();
      var newRow = LayoutRow.fromEmptyRow(pDummyWidth, pDeviceClass);
      for (var i = overflowIndex, j = 0; i < oldAdapptedRowLength; i++, j++) {
        // add to new row
        var overflowElement = oldAdapptedRowElements[i].clone();
        newRow.setElement(overflowElement, j);
        // replace old by dummys
        row.replaceByDummy(overflowElement.getID(), pDummyWidth, pDeviceClass);
      }
      // remove overflow dummys of new row 
      this._removeOveflowed(newRow, pDeviceClass);
      // add new row to the rows...
      if (pRowIndex === this.rows.length - 1) {
        // last row, need to append
        this.addRow(newRow);
      } else {
        // not last row, just insert
        this.insertRow(newRow, pRowIndex + 1);
      }
      // remove overflow elements of the previous old row
      this._removeOveflowed(row, pDeviceClass);
      if (row.getIndexComponent(pComponent.getID()) === -1) {
        // the new component has been overflowed
        report.indexInRow = newRow.getIndexComponent(pComponent.getID());
        report.rowIndex++;
      }
    }
    return report;
  },
  _removeOveflowed: function _removeOveflowed(pRow, pDeviceClass) {
    var leng = pRow.getElements().length;
    var totalWidth = 0;
    for (var i = 0; i < leng; i++) {
      totalWidth += pRow.getElement(i).getWidth(pDeviceClass);
      if (totalWidth > 12) {
        break;
      }
    }
    // we know now at with index (i) we must start removing
    for (var j = i; j < leng; j++) {
      pRow.removeElement(i);
    }
  },
  initialiseRows: function initialiseRows(pDummyWidth, pDeviceClass) {
    if (typeof pDummyWidth !== "number" || pDummyWidth < 1 || pDummyWidth > 12) {
      throw new Error("parameter pDummyWidth must be a positive number between 1 and 12");
    }
    for (var i = 0; i < this.rows.length; i++) {
      this.rows[i].initialiseRow(pDummyWidth, pDeviceClass);
    }
  },
  getMinimalColumns: function getMinimalColumns(pDeviceClass) {
    var widths = [],
      tempWidth;
    for (var i = 0; i < this.rows.length; i++) {
      tempWidth = this.rows[i].getGCDWidth(pDeviceClass);
      if (tempWidth === 1) {
        return 12;
      }
      widths.push(tempWidth);
    }
    if (Array.isArray(widths) && widths.length > 0) {
      if (widths.length >= 2) {
        return 12 / calcGCD(widths);
      } else {
        // there is only one row
        return 12 / widths[0];
      }
    }
    return 12;
  },
  guestDeviceClass: function guestDeviceClass() {
    var deviceClasses = this.getAllDeviceClasses();
    if (Array.isArray(deviceClasses) && deviceClasses.length > 0) {
      return deviceClasses[0];
    }
    return LayoutComponent.defaultDeviceClass();
  },
  getAllDeviceClasses: function getAllDeviceClasses() {
    var deviceClasses = [];
    for (var i = 0; i < this.rows.length; i++) {
      deviceClasses.push(this.rows[i].guestDeviceClass());
    }
    return deviceClasses;
  },
  changeAllToDeviceClass: function changeAllToDeviceClass(pDeviceClass) {
    for (var i = 0; i < this.rows.length; i++) {
      this.rows[i].changeAllToDeviceClass(pDeviceClass);
    }
  },
  getRow: function getRow(pIndex) {
    validateIndex(this.rows, pIndex);
    return this.rows[pIndex];
  },
  getRows: function getRows() {
    return this.rows;
  },
  setRows: function setRows(pRows) {
    if (!Array.isArray(pRows)) {
      throw new Error("inputvariable must be a array");
    }
    this.rows = [];
    for (var i = 0; i < pRows.length; i++) {
      this.rows.push(pRows[i]);
    }
  },
  setRow: function setRow(pRow, pIndex) {
    validateIndex(this.rows, pIndex);
    if (pRow instanceof LayoutRow) {
      this.rows[pIndex] = pRow;
    } else if (Array.isArray(pRow)) {
      this.rows[pIndex] = new LayoutRow.fromJSON(pRow);
    } else {
      throw new Error("setRow: invalid input parameter");
    }
  },
  addRow: function addRow(pRow) {
    if (pRow instanceof LayoutRow === false) {
      throw new Error("addRow: invalid input parameter");
    }
    return this.rows.push(pRow);
  },
  moveRow: function moveRow(pFromIndex, pToIndex) {
    validateIndex(this.rows, pFromIndex);
    validateIndex(this.rows, pToIndex);
    if (pToIndex === pFromIndex) {
      return;
    }
    if (pFromIndex < pToIndex) {
      this.rows.splice(pToIndex + 1, 0, this.rows[pFromIndex]);
      this.removeRow(pFromIndex);
    } else {
      this.rows.splice(pToIndex, 0, this.rows[pFromIndex]);
      this.removeRow(pFromIndex + 1);
    }
  },
  removeRow: function removeRow(pIndex) {
    validateIndex(this.rows, pIndex);
    return this.rows.splice(pIndex, 1);
  },
  insertRow: function insertRow(pRow, pIndex) {
    if (pIndex === this.rows.length) {
      return this.addRow(pRow.clone());
    }
    validateIndex(this.rows, pIndex);
    if (pRow instanceof LayoutRow) {
      return this.rows.splice(pIndex, 0, pRow.clone());
    } else {
      throw new Error("insertRow: invalid input parameter pRow");
    }
  },
  removeEmptyTailRows: function removeEmptyTailRows() {
    for (var i = this.rows.length - 1; i >= 0; i--) {
      if (this.rows[i].isEmptyRow() === true) {
        this.removeRow(i);
      } else {
        return;
      }
    }
  },
  getRowIndexOfComponent: function getRowIndexOfComponent(pComponentID) {
    for (var i = 0; i < this.rows.length; i++) {
      if (this.rows[i].getComponentByID(pComponentID)) {
        return i;
      }
    }
    return -1;
  },
  _hasExtraOptions: function _hasExtraOptions() {
    return typeof this.row_classes === "string" && this.row_classes.length > 0 || typeof this.root_classes === "string" && this.root_classes.length > 0 || this.children_overflow !== "visible" || this.table_of_contents !== undefined && this.table_of_contents !== null || this.label_input_position !== undefined && this.label_input_position !== null;
  },
  setRowClasses: function setRowClasses(pRowClasses) {
    if (typeof pRowClasses === "string" && pRowClasses.length > 0) {
      this.row_classes = pRowClasses;
    } else {
      this.row_classes = null;
    }
  },
  getRowClasses: function getRowClasses() {
    return this.row_classes;
  },
  setRootClasses: function setRootClasses(pRootClasses) {
    if (typeof pRootClasses === "string" && pRootClasses.length > 0) {
      this.root_classes = pRootClasses;
    } else {
      this.root_classes = null;
    }
  },
  getRootClasses: function getRootClasses() {
    return this.root_classes;
  },
  setChildrenOverflow: function setChildrenOverflow(pOverflow) {
    if (pOverflow === undefined || pOverflow === null || pOverflow === "" || pOverflow === "visible") {
      this.children_overflow = "visible";
    } else if (pOverflow === "hidden") {
      this.children_overflow = "hidden";
    } else if (pOverflow === "auto") {
      this.children_overflow = "auto";
    } else {
      throw new Error("invalid children overflow value");
    }
  },
  getChildrenOverflow: function getChildrenOverflow() {
    return this.children_overflow;
  },
  hasTableOfContents: function hasTableOfContents() {
    return this.table_of_contents !== null;
  },
  getTableOfContents: function getTableOfContents() {
    return this.table_of_contents;
  },
  setTableOfContents: function setTableOfContents(pTableOfContents) {
    this.table_of_contents = null;
    if (pTableOfContents && _typeof(pTableOfContents) === "object") {
      this.table_of_contents = structuredClone(pTableOfContents);
    }
  },
  getLabelInputPosition: function getLabelInputPosition() {
    return this.label_input_position;
  },
  setLabelInputPosition: function setLabelInputPosition(pLabelInputPosition) {
    var rootclasses = this.getRootClasses() === null ? "" : this.getRootClasses();
    var rowclasses = this.getRowClasses() === null ? "" : this.getRowClasses();
    switch (pLabelInputPosition) {
      case "vertical":
        if (rootclasses.length > 0 && rootclasses.indexOf("cf-verticalform") === -1) {
          rootclasses += " cf-verticalform";
        } else if (rootclasses.indexOf("cf-verticalform") === -1) {
          rootclasses = "cf-verticalform";
        }
        if (rowclasses.length > 0 && rowclasses.indexOf("cf-verticalrow") === -1) {
          rowclasses += " cf-verticalrow";
        } else if (rowclasses.indexOf("cf-verticalform") === -1) {
          rowclasses = "cf-verticalrow";
        }
        this.setRootClasses(rootclasses);
        this.setRowClasses(rowclasses);
        break;
      case "default":
        rootclasses = rootclasses.replace("cf-verticalform", "");
        rootclasses = rootclasses.length === 0 ? null : rootclasses;
        rowclasses = rowclasses.replace("cf-verticalrow", "");
        rowclasses = rowclasses.length === 0 ? null : rowclasses;
        this.setRootClasses(rootclasses);
        this.setRowClasses(rowclasses);
        pLabelInputPosition = null;
        break;
      case undefined:
      case null:
        pLabelInputPosition = null;
        break;
      default:
        throw new Error("LabelInputPosition: " + pLabelInputPosition + " is not supported.");
    }
    this.label_input_position = pLabelInputPosition;
  },
  compress: function compress() {
    for (var i = 0; i < this.rows.length; i++) {
      this.rows[i].compress();
    }
  },
  getTypePath: function getTypePath() {
    return "bootstrapGrid";
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    if (Array.isArray(this.rows) && this.rows.length > 0) {
      for (var i = 0; i < this.rows.length; i++) {
        this.rows[i].changeComponentIDs(pTranslatedIDs);
      }
    }
  },
  removeElementByID: function removeElementByID(pElementID) {
    var ids = [];
    if (Array.isArray(this.rows) && this.rows.length > 0) {
      for (var i = 0; i < this.rows.length; i++) {
        var row = this.rows[i];
        var indexInRow = row.getIndexComponent(pElementID);
        if (indexInRow > -1) {
          var component = row.getComponentByID(pElementID);
          var widths = component.getWidths();
          var deviceClass = Object.keys(widths)[0];
          row.replaceByDummy(pElementID, widths[deviceClass], deviceClass);
          ids.push(pElementID);
        }
      }
    }
    return ids;
  },
  getAllItemIDs: function getAllItemIDs() {
    var ids = [];
    if (Array.isArray(this.rows) && this.rows.length > 0) {
      for (var i = 0; i < this.rows.length; i++) {
        for (var j = 0; j < this.rows[i].getElements().length; j++) {
          if (typeof this.rows[i].getElement(j).getID() === "string") {
            ids.push(this.rows[i].getElement(j).getID());
          }
        }
      }
    }
    if (this.hasTableOfContents()) {
      if (typeof this.getTableOfContents().content === "string" && this.getTableOfContents().content.length > 0) {
        ids.push(this.getTableOfContents().content);
      }
    }
    return ids;
  },
  replaceByDummy: function replaceByDummy(pCoordinates, pLayoutID, pOptions) {
    return this.getRow(pCoordinates).replaceByDummy(pLayoutID, pOptions.gridUnits, pOptions.deviceClass);
  },
  getFullAreaScopes: function getFullAreaScopes() {
    return [];
  },
  clone: function clone() {
    return BootstrapGridLayout.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var inputRows = [];
    for (var i = 0; i < this.rows.length; i++) {
      inputRows.push(this.rows[i].toJSON());
    }
    if (this._hasExtraOptions()) {
      return {
        rows: inputRows,
        row_classes: this.getRowClasses(),
        root_classes: this.getRootClasses(),
        children_overflow: this.getChildrenOverflow(),
        table_of_contents: this.getTableOfContents(),
        label_input_position: this.getLabelInputPosition()
      };
    } else {
      return inputRows;
    }
  }
};
module.exports = BootstrapGridLayout;

},{"./LayoutComponent.js":256,"./LayoutRow.js":257}],245:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
module.exports = function (theLayout) {
  var CompassLayoutComponent = require("./CompassLayoutComponent.js");
  var LayoutComponent = require("./LayoutComponent.js");
  var Layout = theLayout;
  /**
   * @constructor CompassLayout
   * @description A Layout based on a compass, containing a north, south, west, east and center part
   * @param {CompassLayoutComponent | JSONObject} pNorth 
   * @param {CompassLayoutComponent | JSONObject} pEast 
   * @param {CompassLayoutComponent | JSONObject} pSouth 
   * @param {CompassLayoutComponent | JSONObject} pWest 
   * @param {Layout} pCenter The center part of the Layout, can be a Bootstrap or a Compass type 
   * @param {Boolean} pShowNorth Must we show the north part or not
   * @param {Boolean} pShowEast Must we show the east part or not
   * @param {Boolean} pShowSouth Must we show the south part or not
   * @param {Boolean} pShowWest Must we show the west part or not
   */
  var CompassLayout = function CompassLayout(pNorth, pEast, pSouth, pWest, pCenter, pShowNorth, pShowEast, pShowSouth, pShowWest) {
    this.setNorth(pNorth);
    this.setEast(pEast);
    this.setSouth(pSouth);
    this.setWest(pWest);
    this.setCenter(pCenter);
    this.showNorth(pShowNorth);
    this.showEast(pShowEast);
    this.showSouth(pShowSouth);
    this.showWest(pShowWest);
  };
  CompassLayout.fromJSON = function (pJSON) {
    return new CompassLayout(pJSON.north, pJSON.east, pJSON.south, pJSON.west, pJSON.center, pJSON.show_north, pJSON.show_east, pJSON.show_south, pJSON.show_west);
  };
  CompassLayout.prototype = {
    constructor: CompassLayout,
    setNorth: function setNorth(pNorth) {
      if (pNorth instanceof CompassLayoutComponent) {
        this.north = pNorth;
      } else if (pNorth && _typeof(pNorth) === "object" && Object.getPrototypeOf(pNorth) === Object.prototype) {
        this.north = CompassLayoutComponent.fromJSON(pNorth);
      } else {
        this.north = new CompassLayoutComponent();
      }
    },
    getNorth: function getNorth() {
      return this.north;
    },
    setEast: function setEast(pEast) {
      if (pEast instanceof CompassLayoutComponent) {
        this.east = pEast;
      } else if (pEast && _typeof(pEast) === "object" && Object.getPrototypeOf(pEast) === Object.prototype) {
        this.east = CompassLayoutComponent.fromJSON(pEast);
      } else {
        this.east = new CompassLayoutComponent();
      }
    },
    getEast: function getEast() {
      return this.east;
    },
    setSouth: function setSouth(pSouth) {
      if (pSouth instanceof CompassLayoutComponent) {
        this.south = pSouth;
      } else if (pSouth && _typeof(pSouth) === "object" && Object.getPrototypeOf(pSouth) === Object.prototype) {
        this.south = CompassLayoutComponent.fromJSON(pSouth);
      } else {
        this.south = new CompassLayoutComponent();
      }
    },
    getSouth: function getSouth() {
      return this.south;
    },
    setWest: function setWest(pWest) {
      if (pWest instanceof CompassLayoutComponent) {
        this.west = pWest;
      } else if (pWest && _typeof(pWest) == "object" && Object.getPrototypeOf(pWest) === Object.prototype) {
        this.west = CompassLayoutComponent.fromJSON(pWest);
      } else {
        this.west = new CompassLayoutComponent();
      }
    },
    getWest: function getWest() {
      return this.west;
    },
    setCenter: function setCenter(pCenter) {
      this.center = null;
      if (pCenter instanceof Layout) {
        this.center = pCenter;
      } else if (pCenter && _typeof(pCenter) === "object" && Object.getPrototypeOf(pCenter) === Object.prototype) {
        this.center = Layout.fromJSON(pCenter);
      }
    },
    getCenter: function getCenter() {
      return this.center;
    },
    set: function set(pPlace, pValue) {
      if (pPlace === "north") {
        this.setNorth(pValue);
      } else if (pPlace === "west") {
        this.setWest(pValue);
      } else if (pPlace === "east") {
        this.setEast(pValue);
      } else if (pPlace === "south") {
        this.setSouth(pValue);
      } else if (pPlace.indexOf("center_") === 0) {
        this.getCenter().getParameters().set(pPlace.substring(7), pValue);
      }
    },
    showNorth: function showNorth(pShow) {
      this.show_north = true;
      var removedLayoutIDs = [];
      if (pShow === true) {
        this.show_north = true;
      } else if (pShow === false) {
        this.show_north = false;
        if (this.north.isDump() === false) {
          removedLayoutIDs.push(this.north.getID());
        }
        // reset
        this.north = new CompassLayoutComponent();
      }
      return {
        "removed": removedLayoutIDs
      };
    },
    isShowNorth: function isShowNorth() {
      if (this.show_north === false) {
        return false;
      }
      return true;
    },
    showEast: function showEast(pShow) {
      this.show_east = true;
      var removedLayoutIDs = [];
      if (pShow === true) {
        this.show_east = true;
      } else if (pShow === false) {
        this.show_east = false;
        if (this.east.isDump() === false) {
          removedLayoutIDs.push(this.east.getID());
        }
        // reset
        this.east = new CompassLayoutComponent();
      }
      return {
        "removed": removedLayoutIDs
      };
    },
    isShowEast: function isShowEast() {
      if (this.show_east === false) {
        return false;
      }
      return true;
    },
    showWest: function showWest(pShow) {
      this.show_west = true;
      var removedLayoutIDs = [];
      if (pShow === true) {
        this.show_west = true;
      } else if (pShow === false) {
        this.show_west = false;
        if (this.west.isDump() === false) {
          removedLayoutIDs.push(this.west.getID());
        }
        // reset
        this.west = new CompassLayoutComponent();
      }
      return {
        "removed": removedLayoutIDs
      };
    },
    isShowWest: function isShowWest() {
      if (this.show_west === false) {
        return false;
      }
      return true;
    },
    showSouth: function showSouth(pShow) {
      this.show_south = true;
      var removedLayoutIDs = [];
      if (pShow === true) {
        this.show_south = true;
      } else if (pShow === false) {
        this.show_south = false;
        if (this.south.isDump() === false) {
          removedLayoutIDs.push(this.south.getID());
        }
        // reset
        this.south = new CompassLayoutComponent();
      }
      return {
        "removed": removedLayoutIDs
      };
    },
    isShowSouth: function isShowSouth() {
      if (this.show_south === false) {
        return false;
      }
      return true;
    },
    replaceByDummy: function replaceByDummy(pCoordinates, pLayoutID, pOptions) {
      if (typeof pCoordinates === "string") {
        if (pCoordinates.indexOf("center_") === 0) {
          var coordinates = pCoordinates.substring(7);
          return this.center.getParameters().replaceByDummy(coordinates, pLayoutID, pOptions);
        }
        var compassLayoutComponent;
        switch (pCoordinates) {
          case "north":
            compassLayoutComponent = this.north;
            break;
          case "east":
            compassLayoutComponent = this.east;
            break;
          case "west":
            compassLayoutComponent = this.west;
            break;
          case "south":
            compassLayoutComponent = this.south;
            break;
          default:
            throw new Error("invalid ui coordinates for the compass layout");
        }
        if (compassLayoutComponent.isDump() === false && compassLayoutComponent.getID() === pLayoutID) {
          compassLayoutComponent.setDump(true);
          return 1;
        }
        return 0;
      } else if (typeof pCoordinates === "number") {
        return this.center.getParameters().replaceByDummy(pCoordinates, pLayoutID, pOptions);
      } else {
        throw new Error("invalid interface for ui coordinates of layout");
      }
    },
    compress: function compress() {
      if (this.center !== null) {
        this.center.getParameters().compress();
      }
    },
    getTypePath: function getTypePath() {
      var typePath = "compass";
      if (this.center !== null) {
        typePath += ">" + this.center.getTypePath();
      }
      return typePath;
    },
    changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
      this.north.changeComponentIDs(pTranslatedIDs);
      this.east.changeComponentIDs(pTranslatedIDs);
      this.south.changeComponentIDs(pTranslatedIDs);
      this.west.changeComponentIDs(pTranslatedIDs);
      if (this.center !== null) {
        this.center.getParameters().changeComponentIDs(pTranslatedIDs);
      }
    },
    removeElementByID: function removeElementByID(pElementID) {
      var ids = [];
      if (this.north.getID() === pElementID) {
        ids.push(pElementID);
        this.north.setDump(true);
      }
      if (this.east.getID() === pElementID) {
        ids.push(pElementID);
        this.east.setDump(true);
      }
      if (this.south.getID() === pElementID) {
        ids.push(pElementID);
        this.south.setDump(true);
      }
      if (this.west.getID() === pElementID) {
        ids.push(pElementID);
        this.west.setDump(true);
      }
      if (this.center !== null) {
        ids = ids.concat(this.center.getParameters().removeElementByID(pElementID));
      }
      return ids;
    },
    getAllItemIDs: function getAllItemIDs() {
      var ids = [];
      if (this.north.isDump() === false) {
        ids.push(this.north.getID());
      }
      if (this.east.isDump() === false) {
        ids.push(this.east.getID());
      }
      if (this.south.isDump() === false) {
        ids.push(this.south.getID());
      }
      if (this.west.isDump() === false) {
        ids.push(this.west.getID());
      }
      if (this.center !== null) {
        ids = ids.concat(this.center.getParameters().getAllItemIDs());
      }
      return ids;
    },
    guestDeviceClass: function guestDeviceClass() {
      if (this.center !== null) {
        return this.center.getParameters().guestDeviceClass();
      }
      // return default, if we have found no device classes
      return LayoutComponent.defaultDeviceClass();
    },
    changeAllToDeviceClass: function changeAllToDeviceClass(pDeviceClass) {
      if (this.center !== null) {
        this.center.getParameters().changeAllToDeviceClass(pDeviceClass);
      }
    },
    getFullAreaScopes: function getFullAreaScopes() {
      var fullAreaScopes = [];
      if (this.getNorth().isDump() === false) {
        fullAreaScopes.push("north");
      }
      if (this.getEast().isDump() === false) {
        fullAreaScopes.push("east");
      }
      if (this.getSouth().isDump() === false) {
        fullAreaScopes.push("south");
      }
      if (this.getWest().isDump() === false) {
        fullAreaScopes.push("west");
      }
      if (this.getCenter() === null) {
        fullAreaScopes = fullAreaScopes.concat(this.getCenter().getFullAreaScopes());
      }
      return fullAreaScopes;
    },
    clone: function clone() {
      return CompassLayout.fromJSON(this.toJSON());
    },
    toJSON: function toJSON() {
      return {
        "north": this.getNorth().isDump() ? null : this.getNorth().toJSON(),
        "east": this.getEast().isDump() ? null : this.getEast().toJSON(),
        "south": this.getSouth().isDump() ? null : this.getSouth().toJSON(),
        "west": this.getWest().isDump() ? null : this.getWest().toJSON(),
        "center": this.getCenter() === null ? null : this.getCenter().toJSON(),
        "show_north": this.show_north,
        "show_east": this.show_east,
        "show_west": this.show_west,
        "show_south": this.show_south
      };
    }
  };
  return CompassLayout;
};

},{"./CompassLayoutComponent.js":246,"./LayoutComponent.js":256}],246:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * @constructor CompassLayoutComponent
 * @description The component representor inside a Compass Layout type, see {@link CompassLayout}
 * @param {String} pContent The ID of the linked component, null if no component is linked 
 */
var CompassLayoutComponent = function CompassLayoutComponent(pContent) {
  this.content = null;
  if (typeof pContent === "string" && pContent.length > 0) {
    this.content = pContent;
  }
};
CompassLayoutComponent.fromJSON = function (json) {
  if (!(json && _typeof(json) === "object" && !Array.isArray(json))) {
    throw new Error("invalid json parameter");
  }
  var layout = new CompassLayoutComponent(json.content);
  return layout;
};
CompassLayoutComponent.prototype = {
  constructor: CompassLayoutComponent,
  getID: function getID() {
    return this.content;
  },
  setID: function setID(pID) {
    if (typeof pID !== "string" || pID.length <= 0) {
      throw new Error("id parameter must be a not empty string");
    }
    this.content = pID;
  },
  isDump: function isDump() {
    return this.content === null;
  },
  setDump: function setDump(pDump) {
    if (pDump === true) {
      this.content = null;
    }
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    var currentID = this.getID();
    if (typeof currentID === "string" && currentID.length > 0 && typeof pTranslatedIDs[currentID] === "string") {
      this.setID(pTranslatedIDs[currentID]);
    }
  },
  clone: function clone() {
    return CompassLayoutComponent.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = {};
    if (typeof this.content === "string" && this.content.length > 0) {
      outputJSON.content = this.content;
    }
    return outputJSON;
  }
};
module.exports = CompassLayoutComponent;

},{}],247:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var WebFramework = require("./WebFramework.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");

/**
 * @class Component
 * @description a helpclass for read-only components in a form, like title or image. Represents a component
 * @param {String} id - The ID of the component
 * @param {String} type - The short name of the widget componet
 */
var Component = function Component(id, type) {
  if (typeof id !== "string" || id.length === 0) {
    throw new Error("invalid id");
  }
  this.id = id;
  this.type = type;
  this.options = {};
  this.fullname = null;
  this.framework = null;
  if (window.$ !== undefined) {
    if ($["nixps-cloudflow"] && typeof $["nixps-cloudflow"][type] === "function") {
      this.options = $.extend({}, $["nixps-cloudflow"][type].prototype.options);
      this.fullname = "nixps-cloudflow-" + type;
      this.framework = WebFramework.type.JQUERY_UI;
    } else if ($["nixps-quantum"] && typeof $["nixps-quantum"][type] === "function") {
      this.options = $.extend({}, $["nixps-quantum"][type].prototype.options);
      this.fullname = "nixps-quantum-" + type;
      this.framework = WebFramework.type.JQUERY_UI;
    } else if ($["nixps"] && typeof $["nixps"][type] === "function") {
      this.options = $.extend({}, $["nixps"][type].prototype.options);
      this.fullname = "nixps-" + type;
      this.framework = WebFramework.type.JQUERY_UI;
    } else if ($["nixps-colorspace"] && typeof $["nixps-colorspace"][type] === "function") {
      this.options = $.extend({}, $["nixps-colorspace"][type].prototype.options);
      this.fullname = "nixps-colorspace-" + type;
      this.framework = WebFramework.type.JQUERY_UI;
    } else if ($["nixps-pagebuilder"] && typeof $["nixps-pagebuilder"][type] === "function") {
      this.options = $.extend({}, $["nixps-pagebuilder"][type].prototype.options);
      this.fullname = "nixps-pagebuilder-" + type;
      this.framework = WebFramework.type.JQUERY_UI;
    } else if ($["nixps-kiosk"] && typeof $["nixps-kiosk"][type] === "function") {
      this.options = $.extend({}, $["nixps-kiosk"][type].prototype.options);
      this.fullname = "nixps-kiosk-" + type;
      this.framework = WebFramework.type.JQUERY_UI;
    } else if ($["nixps-asset"] && typeof $["nixps-asset"][type] === "function") {
      this.options = $.extend({}, $["nixps-asset"][type].prototype.options);
      this.fullname = "nixps-asset-" + type;
      this.framework = WebFramework.type.JQUERY_UI;
    } else if ($["nixpsit-form"] && typeof $["nixpsit-form"][type] === "function") {
      this.options = $.extend({}, $["nixpsit-form"][type].prototype.options);
      this.fullname = "nixpsit-form-" + type;
      this.framework = WebFramework.type.JQUERY_UI;
    } else if ($["nixps-form"] && typeof $["nixps-form"][type] === "function") {
      this.options = $.extend({}, $["nixps-form"][type].prototype.options);
      this.fullname = "nixps-form-" + type;
      this.framework = WebFramework.type.JQUERY_UI;
    }
  }
  if (this.framework === null && window.customElements && customElements.get && customElements.get(type) !== undefined) {
    var componentClass = customElements.get(type);
    this.options = {};
    this.options = CloudflowObject.merge([this.options, componentClass.nixpsDefaultOptions || {}]);
    this.fullname = type;
    this.framework = WebFramework.type.NATIVE_WEBCOMPONENT;
  } else if (window.React !== undefined && window.React.isValidElement(window.React.createElement(type))) {
    this.options = {};
    this.fullname = type;
    this.framework = WebFramework.type.REACT;
  }
};
Component.fromJSON = function (json) {
  if (json === null || _typeof(json) !== "object" || Array.isArray(json)) {
    throw new Error("invalid parameter");
  }
  var component = new Component(json.id, json.type);
  if (window.$ !== undefined && component.getWidgetFramework() === WebFramework.type.JQUERY_UI) {
    // special copy
    component.options = $.extend(true, {}, json.options);
  } else {
    try {
      component.options = structuredClone(json.options);
    } catch (e) {
      component.options = Object.assign({}, json.options);
    }
  }
  return component;
};
Component.prototype = {
  constructor: Component,
  getID: function getID() {
    return this.id;
  },
  getType: function getType() {
    return this.type;
  },
  getWidgetFullName: function getWidgetFullName() {
    return this.fullname;
  },
  getWidgetFramework: function getWidgetFramework() {
    return this.framework;
  },
  setOption: function setOption(pName, pValue) {
    if (this.options.hasOwnProperty(pName) === false) {
      throw new Error("invalid option: " + pName);
    }
    this.options[pName] = pValue;
    return this;
  },
  setOptions: function setOptions(options) {
    this.options = options;
  },
  getOptions: function getOptions() {
    return this.options;
  },
  getOption: function getOption(pKey) {
    if (this.options !== undefined && typeof pKey === "string" && pKey.length > 0) {
      return this.options[pKey];
    } else {
      return undefined;
    }
  },
  addOption: function addOption(pName, pValue) {
    if (typeof pName !== "string" || pName.length <= 0) {
      throw new Error("Key must be a not empty string");
    }
    this.options[pName] = pValue;
  },
  clone: function clone() {
    return Component.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {
      id: this.id,
      type: this.type,
      options: this.options
    };
  }
};
module.exports = Component;

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"./WebFramework.js":261}],248:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var Component = require("./Component.js");

/**
 * @class Field
 * @description Representing a field used in {@link Form}, is a child of {@link FormElement}
 * @param {String} pKey - the key to use as key in get object returned from getValues
 * @param {String} pLabel - the text to show on the label as label
 * @param {json_object} pComponent - the component to show as inputfield, this can be inserted as json or as component class
 * @param {Boolean} pIsRequired - is the field required or not?
 * @param {String} pHelpText The text to be show with the field, that helps the user durring filling the form.
 * @param {jsonobject} pHideOptions if fill in, the field will be a optional field.
 */
var Field = function Field(pKey, pLabel, pComponent, pIsRequired, pHelptext, pHideOptions, pIsGroup, pNeededMetadata) {
  this.setKey(pKey);
  this.setRequired(pIsRequired);
  this.setHelptext(pHelptext);
  this.setLabel(pLabel);
  this.setComponent(pComponent);
  this.setHideOptions(pHideOptions);
  this.group = false;
  if (typeof pIsGroup === "boolean") {
    this.setGroup(pIsGroup);
  }
  this.setNeededMetadata(pNeededMetadata);
};
Field.fromJSON = function (json) {
  if (json === null || _typeof(json) !== "object" || Array.isArray(json)) {
    throw new Error("invalid parameter");
  }
  var field = new Field(json.key, json.label, json.component, json.required, json.helptext, json.hideoptions, json.group, json.needed_metadata);
  return field;
};
Field.prototype = {
  constructor: Field,
  setKey: function setKey(pKey) {
    this.key = pKey;
  },
  getKey: function getKey() {
    return this.key;
  },
  getLabel: function getLabel() {
    return this.label;
  },
  setLabel: function setLabel(pLabel) {
    if (Array.isArray(pLabel)) {
      this.label = structuredClone(pLabel);
    } else {
      this.label = this._removeControlChars(pLabel);
    }
  },
  isRequired: function isRequired() {
    if (typeof this.required === "boolean") {
      return this.required;
    } else {
      // fallback in case of value composer
      return false;
    }
  },
  setRequired: function setRequired(pRequired) {
    if (Array.isArray(pRequired)) {
      this.required = structuredClone(pRequired);
    } else {
      this.required = pRequired === true;
    }
    return this.required;
  },
  getRequired: function getRequired() {
    return this.required;
  },
  getHelptext: function getHelptext() {
    return this.helptext;
  },
  setHelptext: function setHelptext(pHelpText) {
    this.helptext = "";
    if (typeof pHelpText === "string") {
      this.helptext = pHelpText;
    } else if (Array.isArray(pHelpText)) {
      this.helptext = structuredClone(pHelpText);
    }
    return this.helptext;
  },
  setComponent: function setComponent(pComponent) {
    if (pComponent instanceof Component) {
      this.component = pComponent.clone();
    } else if (pComponent && _typeof(pComponent) === "object" && !Array.isArray(pComponent)) {
      this.component = Component.fromJSON(pComponent);
    } else {
      throw new Error("invalid pComponent parameter");
    }
  },
  getComponent: function getComponent() {
    return this.component;
  },
  isHideable: function isHideable() {
    return this.hideOptions !== undefined && Object.getPrototypeOf(this.hideOptions) === Object.prototype && Object.keys(this.hideOptions).length > 0;
  },
  getHideOptions: function getHideOptions() {
    return this.hideOptions;
  },
  setHideOptions: function setHideOptions(pHideOptions) {
    if (pHideOptions && Object.getPrototypeOf(pHideOptions) === Object.prototype && Object.keys(pHideOptions).length > 0) {
      if (typeof pHideOptions.hidetext !== "string" || pHideOptions.hidetext.length <= 0) {
        throw new Error("invalid hideOptions, option must have a be a not empty string parameter: hidetext");
      }
      if (typeof pHideOptions.showOnStart !== "boolean") {
        throw new Error("invalid hideOptions, option must have a be boolean parameter: showOnStart");
      }
      this.hideOptions = pHideOptions;
    } else {
      this.hideOptions = undefined;
    }
  },
  isGroup: function isGroup() {
    return this.group;
  },
  setGroup: function setGroup(pIsGroup) {
    if (typeof pIsGroup !== "boolean") {
      throw new Error("parameter must be a boolean");
    }
    this.group = pIsGroup;
  },
  setNeededMetadata: function setNeededMetadata(pMetadata) {
    this.needed_metadata = [];
    if (pMetadata === undefined || pMetadata === null || pMetadata === "") {
      return;
    } else if (typeof pMetadata === "string" && pMetadata.length > 0) {
      this.needed_metadata = [pMetadata];
    } else if (Array.isArray(pMetadata)) {
      this.needed_metadata = pMetadata.slice();
    }
  },
  getNeededMetadata: function getNeededMetadata() {
    return this.needed_metadata.slice();
  },
  clone: function clone() {
    return Field.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var object = {
      key: this.key,
      label: this.label,
      component: this.component.toJSON(),
      required: this.required,
      helptext: this.helptext,
      hideoptions: this.hideOptions,
      needed_metadata: this.getNeededMetadata()
    };
    if (this.isGroup() === true) {
      object.group = this.isGroup();
    }
    return object;
  },
  /**
   * @description sometimes there are unwanted control characters injected in the form, try to remove them
   * @param {type} pString
   * @return {unresolved}
   */
  _removeControlChars: function _removeControlChars(pString) {
    if (typeof pString === "string" && pString.length > 0) {
      if (pString.charCodeAt(0) === 8) {
        // starts with \b ??? remove first bad character
        return pString.slice(1);
      }
    }
    return pString;
  }
};
module.exports = Field;

},{"./Component.js":247}],249:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var FormElement = require("./FormElement.js");
var Field = require("./Field.js");
var Component = require("./Component.js");
var ValueComposerUtil = require("../../ExpressionBuilder/js/ValueComposerUtil.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
require("../../CloudflowUtil/js/nixps-cloudflowutil-NameToolKit.js");
function validateIndex(pArray, pIndex) {
  // is number
  if (typeof pIndex !== "number") {
    throw new Error("invalid index: not a number");
  }

  // is index in interval??
  if (pIndex < 0) {
    // is negative
    throw new Error("invalid index: negative");
  }
  if (pIndex >= pArray.length) {
    // out of bound of array
    throw new Error("invalid index: out of bounds");
  }
}

/**
 * @class Form
 * @description Represents a form, it contains a list of {@link FormElement}
 * @param {Array} pElements - Array containing formElements
 */
var Form = function Form(pElements) {
  this.elements = [];
  this.setElements(pElements);
};
Form.fromJSON = function (json) {
  if (json === null || _typeof(json) !== "object" || Array.isArray(json)) {
    throw new Error("invalid parameter");
  }
  var jsonElements = json.elements;
  var elements = new Array(jsonElements.length);
  for (var i = 0; i < jsonElements.length; i++) {
    elements[i] = FormElement.fromJSON(jsonElements[i]);
  }
  return new Form(elements);
};
Form.translateOldFormat = function (pOldFormat, pStartUpOptions) {
  var elements = [];
  var extras = [];
  for (var i = 0; i < pOldFormat.length; i++) {
    if (pOldFormat[i].dummy === true) {
      // do nothing, those are elements that may not see daylight !!!
    } else if (typeof pOldFormat[i].variable === "string" && pOldFormat[i].variable.length > 0) {
      // know field 
      elements.push(new FormElement(parseFieldOldJSON(pOldFormat[i], pStartUpOptions), pOldFormat[i].style, pOldFormat[i].actionList, pOldFormat[i].creationRequirement));
    } else if (!CloudflowObject.isEmptyObject(pOldFormat[i].element)) {
      // component not field. This component has no value
      elements.push(new FormElement(Component.fromJSON(pOldFormat[i].element), pOldFormat[i].style, pOldFormat[i].actionList, pOldFormat[i].creationRequirement));
    } else {
      // extra elements that are no fields and no components
      delete pOldFormat[i].name;
      delete pOldFormat[i].variabele;
      extras.push(pOldFormat[i]);
    }
  }
  return new Form(elements, extras);
};
Form.merge = function (pAForm, pBForm) {
  if (pAForm === undefined || Array.isArray(pAForm.elements) === false) {
    if (pBForm !== undefined && Array.isArray(pBForm.elements)) {
      return pBForm;
    }
    throw new Error("Invalid root form to merge");
  }
  // only merge if there are 2 arrays to merge, other wise return jsut the first array
  if (pBForm !== undefined && Array.isArray(pBForm.elements) && pBForm.elements.length > 0) {
    var mergedElements = [];
    var BFormElements = CloudflowObject.merge([[], pBForm.elements]);
    for (var i = 0; i < pAForm.elements.length; i++) {
      if (pAForm.elements[i].type === FormElement.type.COMPONENT) {
        // components
        var elementID = pAForm.elements[i].element.id;
        var chooosedElement = pAForm.elements[i];
        for (var j = 0; j < BFormElements.length; j++) {
          if (BFormElements[j].type === FormElement.type.COMPONENT && BFormElements[j].element.id === elementID) {
            chooosedElement = BFormElements[j];
            BFormElements.splice(j, 1);
            break;
          }
        }
        mergedElements.push(chooosedElement);
      } else {
        // fields
        var elementKey = pAForm.elements[i].element.key;
        var chooosedElement = pAForm.elements[i];
        for (var j = 0; j < BFormElements.length; j++) {
          if (BFormElements[j].type === FormElement.type.FIELD && BFormElements[j].element.key === elementKey) {
            chooosedElement = BFormElements[j];
            BFormElements.splice(j, 1);
            break;
          }
        }
        mergedElements.push(chooosedElement);
      }
    }
    // add the unmatched elements at the end of the merged array
    for (var i = 0; i < BFormElements.length; i++) {
      mergedElements.push(BFormElements[i]);
    }
    return {
      elements: mergedElements
    };
  } else {
    return pAForm;
  }
};
Form.prototype = {
  constructor: Form,
  getElement: function getElement(pIndex) {
    validateIndex(this.elements, pIndex);
    return this.elements[pIndex];
  },
  getElementByID: function getElementByID(pElementID) {
    if (typeof pElementID !== "string" || pElementID.length <= 0) {
      throw new Error("inputparameter pElementID must be a string");
    }
    for (var i = 0; i < this.elements.length; i++) {
      if (this.elements[i].getComponentID() === pElementID) {
        return this.elements[i];
      }
    }
  },
  /**
   * @description Get all formelelements
   * @function
   * @name Form.getElements
   * @returns {Array<FormElement>} All the form elements
   */
  getElements: function getElements() {
    return this.elements;
  },
  setElements: function setElements(pElements) {
    if (!Array.isArray(pElements)) {
      throw new Error("inputvariable must be a array");
    }
    this.elements = [];
    for (var i = 0; i < pElements.length; i++) {
      this.addElement(pElements[i]);
    }
  },
  replaceElementByID: function replaceElementByID(pElement, pElementID) {
    if (typeof pElementID !== "string" || pElementID.length <= 0) {
      throw new Error("inputparameter pElementID must be a string");
    }
    for (var i = 0; i < this.elements.length; i++) {
      if (this.elements[i].getComponentID() === pElementID) {
        if (pElement instanceof FormElement) {
          this.elements[i] = pElement;
        } else if (pElement && _typeof(pElement) === "object" && !Array.isArray(pElement)) {
          this.elements[i] = new FormElement.fromJSON(pElement);
        } else {
          throw new Error("replaceElementByID: invalid input parameter");
        }
        return this;
      }
    }
  },
  setElement: function setElement(pElement, pIndex) {
    validateIndex(this.elements, pIndex);
    if (pElement instanceof FormElement) {
      this.elements[pIndex] = pElement;
    } else if (pElement && _typeof(pElement) === "object" && !Array.isArray(pElement)) {
      this.elements[pIndex] = new FormElement.fromJSON(pElement);
    } else {
      throw new Error("setField: invalid input parameter");
    }
  },
  /**
   * @description Add a formelement to the end of the stack
   * @function
   * @name Form.addElement
   * @param {FormElement} pElement the formelement to be added
   * @returns {undefined}
   */
  addElement: function addElement(pElement) {
    if (pElement instanceof FormElement === false) {
      throw new Error("addElement: invalid input parameter");
    }
    return this.elements.push(pElement);
  },
  addElements: function addElements(pElements) {
    if (Array.isArray(pElements) === false) {
      throw new Error("Form.addElements parameter must be an array");
    }
    this.elements = this.elements.concat(pElements);
  },
  moveElement: function moveElement(pFromIndex, pToIndex) {
    validateIndex(this.elements, pFromIndex);
    validateIndex(this.elements, pToIndex);
    if (pToIndex === pFromIndex) {
      return;
    }
    if (pFromIndex < pToIndex) {
      this.elements.splice(pToIndex + 1, 0, this.elements[pFromIndex]);
      this.removeElement(pFromIndex);
    } else {
      this.elements.splice(pToIndex, 0, this.elements[pFromIndex]);
      this.removeElement(pFromIndex + 1);
    }
  },
  removeElement: function removeElement(pIndex) {
    validateIndex(this.elements, pIndex);
    var removedElement = this.elements.splice(pIndex, 1);
    if (Array.isArray(removedElement) && removedElement.length === 1) {
      for (var i = 0; i < this.elements.length; i++) {
        this.elements[i].removeActionLinkedComponentID(removedElement[0].getComponentID());
      }
    }
    return removedElement;
  },
  removeElementByID: function removeElementByID(pElementID) {
    if (typeof pElementID !== "string" || pElementID.length <= 0) {
      throw new Error("inputparameter pElementID must be a string");
    }
    var removedElement = [];
    for (var i = this.elements.length - 1; i >= 0; i--) {
      if (this.elements[i].getComponentID() === pElementID) {
        removedElement = this.elements.splice(i, 1);
      } else {
        this.elements[i].removeActionLinkedComponentID(pElementID);
      }
    }
    return removedElement;
  },
  componentContentChanged: function componentContentChanged(pElementID, pChangeParameters) {
    if (typeof pElementID !== "string" || pElementID.length <= 0) {
      throw new Error("inputparameter pElementID must be a string");
    }
    for (var i = this.elements.length - 1; i >= 0; i--) {
      this.elements[i].updateActionDueToComponentContentChange(pElementID, pChangeParameters);
    }
  },
  insertElement: function insertElement(pElement, pIndex) {
    validateIndex(this.elements, pIndex);
    if (pElement instanceof FormElement) {
      return this.elements.splice(pIndex, 0, pElement.clone());
    } else {
      throw new Error("insertElement: invalid input parameter pElement");
    }
  },
  duplicateElement: function duplicateElement(pElementID, pNewElementID) {
    if (typeof pElementID !== "string" || pElementID.length <= 0) {
      throw new Error("inputparameter pElementID must be a not empty string");
    }
    if (typeof pNewElementID !== "string" || pNewElementID.length <= 0) {
      throw new Error("inputparameter pNewElementID must be a not empty string");
    }
    for (var i = 0; i < this.elements.length; i++) {
      if (this.elements[i].getComponentID() === pElementID) {
        var existingKeyNames = this.elements.filter(function (pElement) {
          return pElement.getType() === FormElement.type.FIELD;
        }).map(function (pElement) {
          return pElement.getElement().getKey();
        });
        var elementToCopy = this.elements[i].clone(true, pNewElementID, function (pOldName) {
          if (window.nixps !== undefined && nixps.cloudflowutil !== undefined && nixps.cloudflowutil.NameToolKit !== undefined) {
            return nixps.cloudflowutil.NameToolKit.getNameSequence(existingKeyNames, pOldName, " ");
          }
          return pOldName + " copy";
        });
        if (i + 1 === this.elements.length) {
          this.addElement(elementToCopy);
        } else {
          this.insertElement(elementToCopy, i + 1);
        }
        return elementToCopy;
      }
    }
  },
  hasElementOfComponentType: function hasElementOfComponentType(pType) {
    if (_typeof(pType) === "object" && typeof pType.has === "function") {
      for (var i = 0; i < this.elements.length; i++) {
        if (pType.has(this.elements[i].getComponentType())) {
          return true;
        }
      }
      return false;
    } else {
      for (var i = 0; i < this.elements.length; i++) {
        if (this.elements[i].getComponentType() === pType) {
          return true;
        }
      }
      return false;
    }
  },
  getNeededMetadata: function getNeededMetadata() {
    var neededMetadata = [];
    for (var i = 0; i < this.elements.length; i++) {
      neededMetadata = neededMetadata.concat(this.elements[i].getNeededMetadata());
    }
    return _.uniq(neededMetadata);
  },
  duplicate: function duplicate(pIDGenerator, pOldPagetransaltionHash, pNewPageTranslationHash) {
    var componentDict = {};
    var translationsDict = {};
    for (var i = 0; i < this.elements.length; i++) {
      var duplicatedReturn = this.elements[i].duplicate(pIDGenerator, true, pOldPagetransaltionHash, pNewPageTranslationHash, {});
      // component ids
      Object.assign(componentDict, duplicatedReturn.componentDict);
      // translation ids
      /*var keys = Object.keys(duplicatedReturn.translationsDict);
      var duplicateKeys = [];
      for (var k = 0; k<keys.length; k++) {
          if (translationsDict[keys[k]] !== undefined) {
              duplicateKeys.push(keys[k]);
          }
      }
      if (duplicateKeys.length > 0) {
          console.error("duplicate keys found", duplicateKeys);
      }*/
      Object.assign(translationsDict, duplicatedReturn.translationsDict);
    }
    for (var i = 0; i < this.elements.length; i++) {
      this.elements[i].changeActionsComponentIDs(componentDict);
    }
    return {
      "componentDict": componentDict,
      "translationsDict": translationsDict
    };
  },
  clone: function clone() {
    return Form.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var inputJSON = [];
    inputJSON = this.elements.map(function (elem, index) {
      return elem.toJSON();
    });
    return {
      elements: inputJSON
    };
  },
  getUniqKey: function getUniqKey() {
    var names = [];
    for (var i = 0; i < this.elements.length; i++) {
      if (this.elements[i].getType() === FormElement.type.FIELD) {
        names.push(this.elements[i].getElement().getKey());
      }
    }
    for (var i = 1; i < this.elements.length + 2; i++) {
      if (names.includes("id" + i) === false) {
        return "id" + i;
      }
    }
    throw new Error("no names found");
  },
  hasDoubleComponentIDs: function hasDoubleComponentIDs() {
    var idDict = {};
    for (var i = 0; i < this.elements.length; i++) {
      var componentID = this.elements[i].getComponentID();
      if (idDict[componentID] !== undefined) {
        return true;
      }
      idDict[componentID] = 1;
    }
    return false;
  },
  /**
  * @description make something for the backend so it can validate something.
  * @returns {Array|Form.Form.makeBackendValidation.options|Form.exports.makeBackendValidation.options}
  */
  makeBackendValidation: function makeBackendValidation() {
    var options = [];
    for (var i = 0; i < this.elements.length; i++) {
      if (this.elements[i].getType() === FormElement.type.FIELD) {
        var field = this.elements[i].getElement();
        var optionName = "";
        if (typeof field.getLabel() === "string" && field.getLabel().length > 0) {
          optionName = field.getLabel();
        }
        var option = {
          name: optionName,
          variable: field.getKey(),
          storage_unit: null,
          edit_type: "string"
        };
        switch (field.getComponent().getType()) {
          case "RIPEditorPresets":
            option.edit_type = "rip_setting";
            break;
          case "ColorspaceSettings":
            option.edit_type = "colorspace_setting";
            break;
          case "Input":
            if (field.getComponent().getOptions().type === "text" || field.getComponent().getOptions().type === "textarea") {
              option.edit_type = "string";
            } else if (field.getComponent().getOptions().type === "number") {
              option.edit_type = "integer";
            } else if (field.getComponent().getOptions().type === "decimal") {
              option.edit_type = "number";
            } else if (field.getComponent().getOptions().type === "checkbox") {
              option.edit_type = "boolean"; //visual not yet supported (old format), but I believe in backend 
            } else if (field.getComponent().getOptions().type === "hidden") {
              option.edit_type = "string";
            } else {
              console.warn("unkown type of Input component, cound not be parsed");
            }
            if (field.getComponent().getOptions().value !== undefined) {
              option["default"] = field.getComponent().getOptions().value;
            }
            if (field.getComponent().getOptions().max !== null && isFinite(field.getComponent().getOptions().max)) {
              option.max_value = field.getComponent().getOptions().max;
            }
            if (field.getComponent().getOptions().min !== null && isFinite(field.getComponent().getOptions().min)) {
              option.min_value = field.getComponent().getOptions().min;
            }
            // there are no other choises in that time
            break;
          case "Select":
            option.edit_type = "string";
            if (typeof field.getComponent().getOptions().outputFormat === "string" && field.getComponent().getOptions().outputFormat.length > 0) {
              option.edit_type = field.getComponent().getOptions().outputFormat;
            }
            if (field.getComponent().getOptions()["default"] !== undefined) {
              option["default"] = field.getComponent().getOptions()["default"];
            }
            if (Array.isArray(field.getComponent().getOptions().keyValues) && field.getComponent().getOptions().keyValues.length > 0) {
              option.select_values = JSON.stringify(field.getComponent().getOptions().keyValues).replace("[", ",").replace("]", ",");
            }
            break;
          case "ValueInput":
            /* units */
            option.edit_type = field.getComponent().getOptions().displayDefinition + "_unit";
            option.storage_unit = field.getComponent().getOptions().storageUnit;
            break;
          case "DatetimeSelector":
            option.edit_type = "date";
            break;
          case "InteractionSelect":
            option.edit_type = "interaction_select";
            option.name = field.getComponent().getOptions().rootLabel; // add name for set info kiosk, will be removed afterwards
            // creating extra dummy field, this field will be ignored anyway when reading in
            var extraOption = structuredClone(option);
            extraOption.edit_type = "string";
            extraOption.variable = field.getComponent().getOptions().childKey;
            extraOption.name = field.getComponent().getOptions().childLabel; // add name for set info kiosk
            extraOption.dummy = true; // mark as ignored!
            options.push(extraOption);
            break;
          default:
            break;
        }
        option.component = field.getComponent().toJSON();
        option.required = field.isRequired();
        option.helptext = field.getHelptext();
        if (field.isGroup()) {
          option.group = true;
        }
      } else {
        // components who are no fields
        var option = {
          name: "defaultname",
          variable: ""
        };
        option.element = this.elements[i].getElement().toJSON();
      }
      if (this.elements[i].hasStyle()) {
        option.style = this.elements[i].getStyle();
      }
      if (this.elements[i].hasActions()) {
        option.actionList = this.elements[i].getActionList();
      }
      if (this.elements[i].getCreationRequirement() !== null) {
        options.creationRequirement = this.elements[i].getCreationRequirement();
      }
      options.push(option);
    }
    return options;
  }
};
function parseFieldOldJSON(pOldJSON, pStartUpOptions) {
  // remove labels from rip_settings
  if (pOldJSON.edit_type === "rip_setting" || pOldJSON.edit_type === "interaction_select") {
    pOldJSON.name = "";
    delete pOldJSON.calculated_name;
  }
  // get fist information of old format
  var component = translateComponent(pOldJSON, pStartUpOptions);
  var required = false;
  var helptext, group, name;
  // control if there is new stuff 
  // and if needed overwrite with the new stuff
  if (pOldJSON.component && _typeof(pOldJSON.component) === "object" && Object.keys(pOldJSON.component).length > 0) {
    component = pOldJSON.component;
  }
  if (typeof pOldJSON.required === "boolean") {
    required = pOldJSON.required;
  } else if (Array.isArray(pOldJSON.required) && pOldJSON.required.length > 0) {
    required = pOldJSON.required;
  }
  if (typeof pOldJSON.helptext === "string" && pOldJSON.helptext.length > 0) {
    helptext = pOldJSON.helptext;
  } else if (Array.isArray(pOldJSON.helptext) && pOldJSON.helptext.length > 0) {
    helptext = pOldJSON.helptext;
  }
  if (typeof pOldJSON.group === "boolean") {
    group = pOldJSON.group;
  }
  if (Array.isArray(pOldJSON.calculated_name) && pOldJSON.calculated_name.length > 0) {
    // pass value composer
    name = pOldJSON.calculated_name;
  } else if (typeof pOldJSON.calculated_name === "string" && pOldJSON.calculated_name.length > 0) {
    // value composer already calculated before
    name = pOldJSON.calculated_name;
  } else {
    name = pOldJSON.name;
  }
  return new Field(pOldJSON.variable, name, component, required, helptext, undefined, group);
}
;
function translateComponent(pOldJSON, pStartUpOptions) {
  var component;

  // a unit (valueInput)
  var matches = /_unit$/.exec(pOldJSON.edit_type);
  var endsWithUnit = Array.isArray(matches) && matches.length > 0;
  if (endsWithUnit) {
    component = new Component("id", "ValueInput");
    component.setOption("name", pOldJSON.variable);
    component.setOption("displayDefinition", pOldJSON.edit_type.slice(0, -5));
    component.setOption("storageUnit", pOldJSON.storage_unit);
    component.setOption("minValue", pOldJSON.min_value);
    component.setOption("maxValue", pOldJSON.min_value);
    return component;
  }

  // rip setting
  if (pOldJSON.edit_type === "rip_setting") {
    component = new Component("id", "RIPEditorPresets");
    component.getOptions().default_preset = pOldJSON["default"];
    if (pStartUpOptions && typeof pStartUpOptions.whitepaper === "string") {
      component.getOptions().whitepaper = pStartUpOptions.whitepaper;
    }
    if (pStartUpOptions && typeof pStartUpOptions.whitepaperInputName === "string") {
      component.getOptions().whitepaper_input_name = pStartUpOptions.whitepaperInputName;
    }
    if (pStartUpOptions && !CloudflowObject.isEmptyObject(pOldJSON.component) && typeof pStartUpOptions.whitepaper === "string" && typeof pStartUpOptions.whitepaperInputName === "string") {
      pOldJSON.component.options.whitepaper = pStartUpOptions.whitepaper;
      pOldJSON.component.options.whitepaper_input_name = pStartUpOptions.whitepaperInputName;
    }
    return component;
  }
  if (pOldJSON.edit_type === "colorspace_setting") {
    return component;
  }

  // a select
  if (Array.isArray(pOldJSON.select_values) && pOldJSON.select_values.length > 0) {
    component = new Component("id", "Select");
    component.setOption("default", pOldJSON["default"]);
    component.setOption("keyValues", pOldJSON.select_values);
    component.setOption("outputFormat", pOldJSON.edit_type);
    return component;
  } else if (typeof pOldJSON.select_values === "string" && pOldJSON.select_values.length > 0) {
    component = new Component("id", "Select");
    component.setOption("default", pOldJSON["default"]);
    component.setOption("keyValues", parseSelectValues(pOldJSON.select_values));
    component.setOption("outputFormat", pOldJSON.edit_type);
    return component;
  }

  // others
  switch (pOldJSON.edit_type) {
    case "string":
      component = new Component("id", "Input");
      component.setOption("type", "text");
      component.setOption("value", pOldJSON["default"]);
      break;
    case "number":
      component = new Component("id", "Input");
      component.setOption("type", "decimal");
      component.setOption("value", pOldJSON["default"]);
      component.setOption("max", pOldJSON.max_value);
      component.setOption("min", pOldJSON.min_value);
      break;
    case "integer":
      component = new Component("id", "Input");
      component.setOption("type", "number");
      component.setOption("value", pOldJSON["default"]);
      component.setOption("max", pOldJSON.max_value);
      component.setOption("min", pOldJSON.min_value);
      break;
    case "boolean":
      component = new Component("id", "Input");
      component.setOption("type", "checkbox");
      component.setOption("value", pOldJSON["default"]);
      break;
    case "array":
    case "date":
    case "interaction_select":
      // go to new type component
      // this will be overwritten
      break;
    default:
      // every component has a least a type string
      throw new Error("unknown edit_type old form format");
  }
  return component;
}
;
function parseSelectValues(pSelectValueString) {
  if (typeof pSelectValueString !== "string" || pSelectValueString.length === 0) {
    return [];
  }
  if (pSelectValueString[0] !== pSelectValueString[pSelectValueString.length - 1]) {
    return [];
  }
  var options = pSelectValueString.split(pSelectValueString[0]);
  return options.filter(function (pValue) {
    return pValue.length > 0;
  });
}
;
Form.makeJSONBackendValidation = function (pFormJSON) {
  var options = [];
  for (var i = 0; i < pFormJSON.elements.length; i++) {
    if (pFormJSON.elements[i].type === FormElement.type.FIELD) {
      var field = pFormJSON.elements[i].element;
      var option = {
        name: "",
        variable: field.key,
        storage_unit: null,
        edit_type: "string"
      };
      if (typeof field.label === "string" && field.label.length > 0) {
        option.name = field.label;
      } else if (Array.isArray(field.label) && field.label.length > 0) {
        var candidateName = ValueComposerUtil.castToValue(field.label, false);
        if (["string", "number", "boolean"].includes(_typeof(candidateName))) {
          option.name = "" + candidateName;
        }
        option.calculated_name = field.label;
      }
      switch (field.component.type) {
        case "RIPEditorPresets":
          option.edit_type = "rip_setting";
          break;
        case "ColorspaceSettings":
          option.edit_type = "colorspace_setting";
          break;
        case "Input":
          if (field.component.options.type === "text" || field.component.options.type === "textarea") {
            option.edit_type = "string";
          } else if (field.component.options.type === "number") {
            option.edit_type = "integer";
          } else if (field.component.options.type === "decimal") {
            option.edit_type = "number";
          } else if (field.component.options.type === "checkbox") {
            option.edit_type = "boolean"; //visual not yet supported (old format), but I believe in backend 
          } else if (field.component.options.type === "hidden") {
            option.edit_type = "string";
          } else {
            console.warn("unkown type of Input component, cound not be parsed");
          }
          if (field.component.options.value !== undefined) {
            option["default"] = field.component.options.value;
          }
          if (field.component.options.max !== null && isFinite(field.component.options.max)) {
            option.max_value = field.component.options.max;
          }
          if (field.component.options.min !== null && isFinite(field.component.options.min)) {
            option.min_value = field.component.options.min;
          }
          // there are no other choises in that time
          break;
        case "Select":
          option.edit_type = "string";
          if (typeof field.component.options.outputFormat === "string" && field.component.options.outputFormat.length > 0) {
            option.edit_type = field.component.options.outputFormat;
          }
          if (field.component.options["default"] !== undefined) {
            option["default"] = field.component.options["default"];
          }
          if (Array.isArray(field.component.options.keyValues) && field.component.options.keyValues.length > 0) {
            option.select_values = JSON.stringify(field.component.options.keyValues).replace("[", ",").replace("]", ",");
          }
          break;
        case "ValueInput":
          /* units */
          option.edit_type = field.component.options.displayDefinition + "_unit";
          option.storage_unit = field.component.options.storageUnit;
          break;
        case "DatetimeSelector":
          option.edit_type = "date";
          break;
        case "InteractionSelect":
          option.edit_type = "interaction_select";
          option.name = field.component.options.rootLabel; // add name for set info kiosk, will be removed afterwards
          // creating extra dummy field, this field will be ignored anyway when reading in
          var extraOption = structuredClone(option);
          extraOption.edit_type = "string";
          extraOption.variable = field.component.options.childKey;
          extraOption.name = field.component.options.childLabel; // add name for set info kiosk
          extraOption.dummy = true; // mark as ignored!
          options.push(extraOption);
          break;
        default:
          break;
      }
      option.component = field.component;
      option.required = field.required;
      option.helptext = field.helptext;
      if (field.group === true) {
        option.group = true;
      }
    } else {
      // components who are no fields
      var option = {
        name: "defaultname",
        variable: ""
      };
      option.element = pFormJSON.elements[i].element;
    }
    if (pFormJSON.elements[i].style && _typeof(pFormJSON.elements[i].style) === "object") {
      option.style = pFormJSON.elements[i].style;
      // remove styles with value null
      for (var styleKey in option.style) {
        if (option.style[styleKey] === null) {
          delete option.style[styleKey];
        }
      }
      if (Object.keys(option.style).length === 0) {
        delete option.style;
      }
    }
    if (pFormJSON.elements[i].actionList !== undefined && pFormJSON.elements[i].actionList !== null) {
      option.actionList = pFormJSON.elements[i].actionList;
    }
    if (typeof pFormJSON.elements[i].creationRequirement === "string" && pFormJSON.elements[i].creationRequirement.length > 0) {
      option.creationRequirement = pFormJSON.elements[i].creationRequirement;
    }
    options.push(option);
  }
  return options;
};
module.exports = Form;

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"../../CloudflowUtil/js/nixps-cloudflowutil-NameToolKit.js":94,"../../ExpressionBuilder/js/ValueComposerUtil.js":114,"./Component.js":247,"./Field.js":248,"./FormElement.js":251}],250:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");

/**
 * @description A class than handles the comparitions, that check if a value is valid or not.
 * @private
 * @class Comparision
 */
var Comparision = function Comparision(pComparision) {
  this.comparision = pComparision;
};
Comparision.fromJSON = function (json) {
  return new Comparision(json.comparision);
};
Comparision.prototype = {
  constructor: Comparision,
  getValueToCompareWith: function getValueToCompareWith() {
    if (Array.isArray(this.comparision)) {
      return this.comparision.slice();
    } else if (this.comparision && _typeof(this.comparision) === "object") {
      return structuredClone(this.comparision);
    } else {
      return this.comparision;
    }
  },
  isValid: function isValid(pValue) {
    if (this.comparision === undefined || this.comparision === null) {
      return true;
    } else if (["string", "number", "boolean"].indexOf(_typeof(this.comparision)) >= 0) {
      return pValue === this.comparision;
    } else if (Array.isArray(this.comparision) === true) {
      return this.comparision.indexOf(pValue) >= 0;
    } else if (this.comparision && _typeof(this.comparision) === "object" && !Array.isArray(this.comparision)) {
      switch (this.comparision.type) {
        case "some":
          if (!Array.isArray(pValue)) {
            return false;
          }
          if (this.comparision.content_type === "object") {
            return _.some(pValue, this._isValidObject, this);
          } else if (this.comparision.content_type === "array") {
            return pValue.indexOf(this.comparision.compare_value) >= 0;
          }
        case "equal to":
          return pValue === this.comparision.compare_value;
        case "not equal to":
          return pValue !== this.comparision.compare_value;
        case "less than":
          return parseFloat(pValue) < this.comparision.compare_value;
        case "less than or equal to":
          return parseFloat(pValue) <= this.comparision.compare_value;
        case "greater than":
          return parseFloat(pValue) > this.comparision.compare_value;
        case "greater than or equal to":
          return parseFloat(pValue) >= this.comparision.compare_value;
        case "begins with":
          return pValue.toString().indexOf(this.comparision.compare_value.toString()) === 0;
        case "ends with":
          return pValue.toString().endsWith(this.comparision.compare_value.toString());
        case "is like":
          return pValue.toString().toLowerCase() === this.comparision.compare_value.toString().toLowerCase();
        case "equal like":
          return (pValue.toString() === "[object Object]" ? JSON.stringify(pValue) : pValue.toString()) === this.comparision.compare_value.toString();
        case "is typeof":
          if (!["array", "string", "boolean", "number", "BigInt"].includes(this.comparision.compare_value)) {
            throw new Error("unsupported type to check " + this.comparision.compare_value);
          }
          return this.comparision.compare_value === "array" ? Array.isArray(pValue) : _typeof(pValue) === this.comparision.compare_value;
        default:
          return false;
      }
    } else {
      return false;
    }
  },
  _isValidObject: function _isValidObject(pValue) {
    if (CloudflowObject.isEmptyObject(pValue)) {
      return false;
    }
    return pValue[this.comparision.compare_key] === this.comparision.compare_value;
  },
  toJSON: function toJSON() {
    return this.comparision;
  }
};

/**
 * @description If a object contains that as value, then that value will be repaced by the incomming newValue
 * @private
 * @static
 * @type {String}
 */
var newValueInjectionKey = "${action.__newValueInjectionKey}";

/**
 * @description The key to indicate we need to filter the options
 * @private
 * @static
 * @type {String}
 */
var filterKeyOption = "__filter__";

/**
 * @description A name given to a container to indicate it was hide by an action
 * @private
 * @static
 * @type {String}
 */
var kHideByActionClass = "formaction_hidebyaction";

/**
 * @description A name given to a container to indicate it was disabled by an action
 * @private
 * @static
 * @type {String}
 */
var kDisableByActionClass = "formaction_disablebyaction";

/**
 * @description A name known by the formrenderer to display the * star indication a required field
 * @private
 * @static
 * @type {String}
 */
var kRequiredByActionClass = "requiredComponent cf-form-required";

/**
 * @description A class to indicate the value has been changed
 * @private
 * @static
 * @type {String}
 */
var changedByActionClass = "formrenderer_informAutoChange";

/**
 * @constructor FormAction
 * @description Is an Action, that is used inside forms {@link Form}
 */
var FormAction = function FormAction(pComparison, pComponentIDs, pFunctionName, pFunctionParameters, pBubbel, pOnUserActionOnly) {
  this.setComparison(pComparison);
  this.setComponentIDs(pComponentIDs);
  this.setFunctionName(pFunctionName);
  this.setFunctionParameters(pFunctionParameters);
  this.setBubbel(pBubbel);
  this.setOnUserActionOnly(pOnUserActionOnly);
};
FormAction.fromJSON = function (pJSON) {
  if (!pJSON || Object.getPrototypeOf(pJSON) !== Object.prototype || CloudflowObject.isEmptyObject(pJSON)) {
    throw new Error("pJSON parameter must be a not empty object");
  }
  return new FormAction(pJSON.comparison, pJSON.componentID, pJSON.functionName, pJSON.functionParameters, pJSON.bubbel, pJSON.onUserActionOnly);
};

/**
 * @description Mark the DOM of the Field as hidden, triggerd by the FormAction
 * @function
 * @name FormAction#markNeedToSkip
 * @param {DOM} pComponent the component to check       
 * @param {Boolean} pToggle must we show or hide  
 * @returns {undefined}  
 */
FormAction.markNeedToSkip = function (pComponent, pToggle) {
  if (pToggle === true) {
    pComponent.addClass(kHideByActionClass);
  } else {
    pComponent.removeClass(kHideByActionClass);
  }
};

/**
 * @description Is the Field hidden by a FormAction or not
 * @function
 * @name FormAction#needToSkip
 * @param {DOM} pComponent the component to check       
 * @returns {Boolean} true if the field has been hidden by an Action    
 */
FormAction.needToSkip = function (pComponent) {
  return pComponent.hasClass(kHideByActionClass);
};
FormAction.isDisabledByAction = function (pComponent) {
  return pComponent.hasClass(kDisableByActionClass);
};
FormAction.prototype = {
  constructor: FormAction,
  getComparison: function getComparison() {
    return this.comparison;
  },
  setComparison: function setComparison(pComparison) {
    this.comparison = new Comparision(pComparison);
  },
  getComponentIDs: function getComponentIDs() {
    return this.componentID;
  },
  setComponentIDs: function setComponentIDs(pComponentID) {
    if (Array.isArray(pComponentID) && pComponentID.length > 0) {
      for (var i = 0; i < pComponentID.length; i++) {
        if (typeof pComponentID[i] !== "string" || pComponentID[i].length <= 0) {
          throw new Error("parameter componentID must be a not empty string");
        }
      }
      this.componentID = pComponentID.slice();
    } else if (typeof pComponentID === "string" && pComponentID.length > 0) {
      this.componentID = [pComponentID];
    } else {
      throw new Error("parameter componentID must be a not empty string");
    }
  },
  removeComponentID: function removeComponentID(pComponentID) {
    if (typeof pComponentID !== "string" || pComponentID.length <= 0) {
      throw new Error("input paramter componentID must be a not empty string");
    }
    for (var i = this.componentID.length - 1; i >= 0; i--) {
      if (this.componentID[i] === pComponentID) {
        this.componentID.splice(i, 1);
      }
    }
    return this.componentID;
  },
  hasLinkWithComponentID: function hasLinkWithComponentID(pComponentID) {
    if (typeof pComponentID !== "string" || pComponentID.length <= 0) {
      throw new Error("input paramter componentID must be a not empty string");
    }
    for (var i = 0; i < this.componentID.length; i++) {
      if (this.componentID[i] === pComponentID) {
        return true;
      }
    }
    return false;
  },
  updateActionDueToComponentContentChange: function updateActionDueToComponentContentChange(pComponentID, pChangeParameters) {
    if (typeof pComponentID !== "string" || pComponentID.length <= 0) {
      throw new Error("input paramter componentID must be a not empty string");
    }
    if (["change_options", "set_value"].includes(this.getFunctionName())) {
      for (var i = this.componentID.length - 1; i >= 0; i--) {
        if (this.componentID[i] === pComponentID) {
          this.componentID.splice(i, 1);
        }
      }
    }
    return this.componentID;
  },
  getFunctionName: function getFunctionName() {
    return this.functionName;
  },
  setFunctionName: function setFunctionName(pFunctionName) {
    if (typeof pFunctionName !== "string" || pFunctionName.length <= 0) {
      throw new Error("parameter functionName must be a not empty string");
    }
    if (functions[pFunctionName] === undefined) {
      throw new Error("unknown function name");
    }
    this.functionName = pFunctionName;
  },
  getFunctionParameters: function getFunctionParameters() {
    return structuredClone(this.functionParameters);
  },
  setFunctionParameters: function setFunctionParameters(pFunctionParameters) {
    if (typeof this.functionName !== "string") {
      throw new Error("initial the functionname before the functionparameters");
    }
    // check parameters
    functions[this.functionName].validateParameters(pFunctionParameters);
    // save and make a copy of the parameters
    this.functionParameters = Object.assign({}, pFunctionParameters);
  },
  setBubbel: function setBubbel(pBubbel) {
    this.bubbel = null;
    if (typeof pBubbel === "boolean") {
      this.bubbel = pBubbel;
    }
  },
  getBubbel: function getBubbel() {
    return this.bubbel === true;
  },
  setOnUserActionOnly: function setOnUserActionOnly(pOnUserActionOnly) {
    this.onUserActionOnly = false;
    if (typeof pOnUserActionOnly === "boolean") {
      this.onUserActionOnly = pOnUserActionOnly;
    }
  },
  getOnUserActionOnly: function getOnUserActionOnly() {
    return this.onUserActionOnly === true;
  },
  applyAction: function applyAction(pNewValue, pContainer, pComponentElement, pComponentClassName) {
    var pFormOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    if (pComponentElement === undefined || pComponentElement === null) {
      throw new Error("invalid pComponentElement");
    }
    var isValid = this.getComparison().isValid(pNewValue);
    if (isValid === true) {
      if (typeof functions[this.getFunctionName()].validFunction === "function") {
        functions[this.getFunctionName()].validFunction(pContainer, pComponentElement, pComponentClassName, this._getAppliedFunctionParameters(pNewValue), pFormOptions);
      }
    } else if (isValid === false) {
      if (typeof functions[this.getFunctionName()].invalidFunction === "function") {
        functions[this.getFunctionName()].invalidFunction(pContainer, pComponentElement, pComponentClassName, this._getAppliedFunctionParameters(pNewValue), pFormOptions);
      }
    }
    return {
      valid: isValid
    };
  },
  needForBubbling: function needForBubbling(pActionResult) {
    return this.getBubbel() && pActionResult.valid === true && ["set_value", "toggle_visible", "show"].includes(this.getFunctionName());
  },
  _getAppliedFunctionParameters: function _getAppliedFunctionParameters(pNewValue) {
    if (this.getFunctionName() !== "change_options") {
      return this.getFunctionParameters();
    }
    var parameters = this.getFunctionParameters();
    if (!parameters || Object.getPrototypeOf(parameters) !== Object.prototype) {
      return {
        "parameters": parameters
      };
    }
    for (var key in parameters) {
      if (typeof parameters[key] === "string" && parameters[key].indexOf(newValueInjectionKey) >= 0) {
        var injectedValue = pNewValue;
        if (parameters[filterKeyOption] !== undefined) {
          var comparision = new Comparision(parameters[filterKeyOption].comparision_value);
          if (parameters[filterKeyOption].return_as === undefined || parameters[filterKeyOption].return_as === "array") {
            injectedValue = $.map(pNewValue, function (elem) {
              if (comparision.isValid(elem[parameters[filterKeyOption].comparision_key])) {
                return elem[parameters[filterKeyOption].filter];
              }
            });
          } else if (parameters[filterKeyOption].return_as === "index_object") {
            injectedValue = {};
            $.map(pNewValue, function (elem, index) {
              if (comparision.isValid(elem[parameters[filterKeyOption].comparision_key])) {
                injectedValue[index] = elem[parameters[filterKeyOption].filter];
              }
            });
          } else if (parameters[filterKeyOption].return_as === "index_translated_object") {
            injectedValue = {};
            $.map(pNewValue, function (elem, index) {
              if (comparision.isValid(elem[parameters[filterKeyOption].comparision_key])) {
                if (typeof elem[parameters[filterKeyOption].filter] === "string" && elem[parameters[filterKeyOption].filter][0] === "$" && elem[parameters[filterKeyOption].filter][1] === "{") {
                  injectedValue[index] = $.i18n._(elem[parameters[filterKeyOption].filter].slice(2, -1));
                } else {
                  injectedValue[index] = elem[parameters[filterKeyOption].filter];
                }
              }
            });
          }
          delete parameters[filterKeyOption];
        } else if (typeof parameters.newValueInjectionPath === "string" && parameters.newValueInjectionPath.length > 0) {
          injectedValue = CloudflowObject.getParameter(pNewValue, parameters.newValueInjectionPath);
        }
        if (typeof injectedValue === "string") {
          parameters[key] = parameters[key].replace(newValueInjectionKey, injectedValue);
        } else {
          // no not instring replace!
          parameters[key] = injectedValue;
        }
      } else if (Array.isArray(parameters[key]) && parameters[key].includes(newValueInjectionKey)) {
        // replace by new value
        var index = parameters[key].indexOf(newValueInjectionKey);
        parameters[key][index] = pNewValue;
      }
    }
    if (Object.keys(parameters).length === 1 && Object.keys(parameters)[0].indexOf(".") > 0) {
      var key = Object.keys(parameters)[0];
      return {
        "key": key,
        "value": parameters[key]
      };
    }
    if (parameters["."] && Object.getPrototypeOf(parameters["."]) === Object.prototype) {
      return {
        "parameters": parameters["."]
      };
    }
    return {
      "parameters": parameters
    };
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    for (var i = 0; i < this.componentID.length; i++) {
      if (typeof pTranslatedIDs[this.componentID[i]] === "string") {
        this.componentID[i] = pTranslatedIDs[this.componentID[i]];
      }
    }
  },
  removeSubActionID: function removeSubActionID(pSubActionID) {
    console.error("not developed yet");
  },
  duplicate: function duplicate() {
    console.error("not developed yet");
  },
  clone: function clone() {
    return FormAction.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {
      "comparison": this.comparison.toJSON(),
      "componentID": this.componentID,
      "functionName": this.functionName,
      "functionParameters": this.functionParameters,
      "bubbel": this.bubbel,
      "onUserActionOnly": this.onUserActionOnly
    };
  }
};
var functions = {
  "change_options": {
    validateParameters: function validateParameters(pParameters) {
      if (!(pParameters && _typeof(pParameters) === "object" && !Array.isArray(pParameters) && Object.keys(pParameters).length > 0)) {
        throw new Error("options must be an not empty object");
      }
    },
    validFunction: function validFunction(pContainer, pComponent, pComponentName, pParameters) {
      if (pParameters !== undefined) {
        if (pParameters.parameters !== undefined) {
          pComponent[pComponentName]("option", pParameters.parameters);
        } else if (pParameters.key !== undefined && pParameters.value !== undefined) {
          pComponent[pComponentName]("option", pParameters.key, pParameters.value);
        }
      }
    }
  },
  "set_value": {
    validateParameters: function validateParameters(pParameters) {
      if (!(pParameters && _typeof(pParameters) === "object" && !Array.isArray(pParameters) && Object.keys(pParameters).length > 0)) {
        throw new Error("options must be an not empty object");
      }
    },
    validFunction: function validFunction(pContainer, pComponent, pComponentName, pParameters) {
      pComponent[pComponentName]("setValue", pParameters.value);
      pComponent.toggleClass(changedByActionClass, pParameters.add_changed_layout === true);
    }
  },
  "toggle_visible": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer) {
      pContainer.removeClass(kHideByActionClass);
    },
    invalidFunction: function invalidFunction(pContainer) {
      pContainer.addClass(kHideByActionClass);
    }
  },
  "toggle_invisible": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer) {
      pContainer.addClass(kHideByActionClass);
    },
    invalidFunction: function invalidFunction(pContainer) {
      pContainer.removeClass(kHideByActionClass);
    }
  },
  "show": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer) {
      pContainer.removeClass(kHideByActionClass);
    }
  },
  "hide": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer) {
      pContainer.addClass(kHideByActionClass);
    }
  },
  "toggle_disabled": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer, pComponent, pComponentName, pParameters, pFormOptions) {
      pComponent.addClass(kDisableByActionClass);
      pComponent[pComponentName]("disable");
    },
    invalidFunction: function invalidFunction(pContainer, pComponent, pComponentName, pParameters, pFormOptions) {
      // indicate that according to this action and the flow of logical actions, this component should be enabled
      pComponent.removeClass(kDisableByActionClass);
      if (pFormOptions && pFormOptions.disabled === true) {
        return; // do not enable when form is disabled
      }

      pComponent[pComponentName]("enable");
    }
  },
  "enable": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer, pComponent, pComponentName, pParameters, pFormOptions) {
      // indicate that according to this action and the flow of logical actions, this component should be enabled
      pComponent.removeClass(kDisableByActionClass);
      if (pFormOptions && pFormOptions.disabled === true) {
        return; // do not enable when form is disabled
      }

      pComponent[pComponentName]("enable");
    }
  },
  "disable": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer, pComponent, pComponentName, pParameters, pFormOptions) {
      pComponent.addClass(kDisableByActionClass);
      pComponent[pComponentName]("disable");
    }
  },
  "toggle_required": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer) {
      pContainer.addClass(kRequiredByActionClass);
      var field = pContainer.data("inputFieldOptions");
      if (field !== undefined && field.setRequired !== undefined) {
        field.setRequired(true);
      }
    },
    invalidFunction: function invalidFunction(pContainer) {
      pContainer.removeClass(kRequiredByActionClass);
      var field = pContainer.data("inputFieldOptions");
      if (field !== undefined && field.setRequired !== undefined) {
        field.setRequired(false);
      }
    }
  },
  "required_on": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer, pComponent, pComponentName) {
      pContainer.addClass(kRequiredByActionClass);
      var field = pContainer.data("inputFieldOptions");
      if (field !== undefined && field.setRequired !== undefined) {
        field.setRequired(true);
        if (pComponent[pComponentName] !== undefined && pComponent[pComponentName]("option", "required") === false) {
          pComponent[pComponentName]("option", "required", true);
        }
      }
    }
  },
  "required_off": {
    validateParameters: function validateParameters() {},
    validFunction: function validFunction(pContainer, pComponent, pComponentName) {
      pContainer.removeClass(kRequiredByActionClass);
      var field = pContainer.data("inputFieldOptions");
      if (field !== undefined && field.setRequired !== undefined) {
        field.setRequired(false);
        if (pComponent[pComponentName] !== undefined && pComponent[pComponentName]("option", "required") === true) {
          pComponent[pComponentName]("option", "required", false);
        }
      }
    }
  },
  "change_helptext": {
    validateParameters: function validateParameters(pParameters) {},
    validFunction: function validFunction(pContainer, pComponent, pComponentName, pParameters) {
      if (pParameters !== undefined) {
        if (typeof pParameters.helptext === "string") {
          pContainer.find(".cf-form-helptext").last().text(_.unescape(pParameters.helptext));
        }
      }
    }
  }
};
module.exports = FormAction;

},{"../../CloudflowUtil/js/CloudflowObject.js":79}],251:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var Field = require("./Field.js");
var Component = require("./Component.js");
var ActionList = require("./ActionList.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
var TranslationHandler = require("../../Translate/js/TranslationHandler.js");

/**
 * @class FormElement
 * @description A child of a {@link Form}. it can represent a {@link Field}  or a {@link Component}. So it is a wrapper for both.
 * @param {Component_or_field} componentOrField The field or component.
 * @param {Object} pStyle The style of component.
 * @param {Array} pActionList The array containing the form actions of component. see {@link ActionList}
 * @param {Object} pCreationRequirement The object containing the options for the requirements during creation 
 */
var FormElement = function FormElement(componentOrField, pStyle, pActionList, pCreationRequirement) {
  if (componentOrField instanceof Component === false && componentOrField instanceof Field === false) {
    throw new Error("expect a component or a field");
  }
  this.element = componentOrField;
  // set some styling
  this.style = {};
  this.setStyle(pStyle);

  // set actions
  this.actionList = null;
  this.setActionList(pActionList);
  this.setCreationRequirement(pCreationRequirement);
};
/**
 * Different types of components supported by the FormRenderer
 * @readonly
 * @enum {String}
 */
FormElement.type = Object.freeze({
  /** readonly, show-only component */
  "COMPONENT": "component",
  /** getValue and setValue component, some that can give values */
  "FIELD": "field"
});
FormElement.fromJSON = function (json) {
  if (json === null || Array.isArray(json) || _typeof(json) !== "object") {
    throw new Error("invalid parameter");
  }
  var element = null;
  if (json.type === FormElement.type.COMPONENT) {
    element = Component.fromJSON(json.element);
  } else if (json.type === FormElement.type.FIELD) {
    element = Field.fromJSON(json.element);
  } else {
    throw new Error("expecting a \"component\" or \"field\" type");
  }
  return new FormElement(element, json.style, json.actionList, json.creationRequirement);
};
FormElement.prototype = {
  constructor: FormElement,
  /**
   * @description Get the ID of the underlying component
   * @function
   * @name FormElement.getComponentID
   * @returns {String} the id of the underlying component
   */
  getComponentID: function getComponentID() {
    if (this.getType() === FormElement.type.COMPONENT) {
      return this.element.getID();
    }
    return this.element.getComponent().getID();
  },
  /**
   * @description Which type is it? a component or a field
   * @name FormElement.getType
   * @function
   * @returns {String} the type of the formElement
   */
  getType: function getType() {
    var element = this.element;
    if (element instanceof Component) {
      return FormElement.type.COMPONENT;
    }
    return FormElement.type.FIELD;
  },
  getComponentType: function getComponentType() {
    if (this.getType() === FormElement.type.COMPONENT) {
      return this.element.getType();
    }
    return this.element.getComponent().getType();
  },
  getElement: function getElement() {
    return this.element;
  },
  getBackground: function getBackground() {
    if (this.hasBackground()) {
      return this.style.background;
    }
    return null;
  },
  setBackground: function setBackground(pBackground) {
    if (typeof pBackground !== "string" && pBackground !== null) {
      throw new Error("parameter background must be a string");
    }
    this.style.background = pBackground;
  },
  hasBackground: function hasBackground() {
    return this.style !== undefined && this.style !== null && typeof this.style.background === "string";
  },
  getFontColor: function getFontColor() {
    if (this.hasFontColor()) {
      return this.style.color;
    }
    return null;
  },
  setFontColor: function setFontColor(pFontColor) {
    if (typeof pFontColor !== "string" && pFontColor !== null) {
      throw new Error("parameter fontcolor must be a string");
    }
    this.style.color = pFontColor;
  },
  hasFontColor: function hasFontColor() {
    return this.style !== undefined && this.style !== null && typeof this.style.color === "string";
  },
  hasStyle: function hasStyle() {
    return this.hasBackground() || this.hasFontColor();
  },
  getStyle: function getStyle() {
    return this.style;
  },
  setStyle: function setStyle(pStyle) {
    if (pStyle !== undefined && pStyle !== null && _typeof(pStyle) === "object") {
      if (pStyle.background !== undefined) {
        this.setBackground(pStyle.background);
      }
      if (pStyle.color !== undefined) {
        this.setFontColor(pStyle.color);
      }
    }
  },
  /**
   * @description Get the style in a css compative object, we can give to the jquery css function
   * @function
   * @name FormElement.getCSSObject
   * @return {object}
   */
  getCSSObject: function getCSSObject() {
    if (this.hasStyle()) {
      var cssObject = {};
      if (this.hasBackground()) {
        cssObject.background = this.getBackground();
      }
      if (this.hasFontColor()) {
        cssObject.color = this.getFontColor();
      }
      return cssObject;
    } else {
      return {};
    }
  },
  hasActions: function hasActions() {
    return this.actionList !== null && this.actionList.hasActions();
  },
  getActionList: function getActionList() {
    if (this.hasActions() === false) {
      return null;
    } else {
      return this.actionList;
    }
  },
  setActionList: function setActionList(pActions) {
    if (pActions === undefined || pActions === null) {
      this.actionList = null;
    } else if (Array.isArray(pActions)) {
      if (pActions.length <= 0) {
        this.actionList = null;
      } else {
        this.actionList = ActionList.fromJSON(pActions);
      }
    } else if (pActions instanceof ActionList) {
      this.actionList = pActions;
      if (this.actionList.hasActions() === false) {
        this.actionList = null;
      }
    } else {
      throw new Error("invalid actions interface");
    }
  },
  setCreationRequirement: function setCreationRequirement(pCreationRequirement) {
    if (typeof pCreationRequirement === "string" && pCreationRequirement.length > 0) {
      this.creationRequirement = pCreationRequirement;
    } else {
      this.creationRequirement = null;
    }
  },
  getCreationRequirement: function getCreationRequirement() {
    return this.creationRequirement;
  },
  removeActionLinkedComponentID: function removeActionLinkedComponentID(pComponentID) {
    if (this.hasActions() === true) {
      this.actionList.removeByComponentID(pComponentID);
      if (this.actionList.hasActions() === false) {
        this.actionList = null;
      }
    }
  },
  updateActionDueToComponentContentChange: function updateActionDueToComponentContentChange(pComponentID, pChangeParameters) {
    if (this.hasActions() === true) {
      this.actionList.updateActionDueToComponentContentChange(pComponentID, pChangeParameters);
    }
  },
  getNeededMetadata: function getNeededMetadata() {
    if (this.getType() === FormElement.type.FIELD) {
      return this.element.getNeededMetadata();
    } else {
      return [];
    }
  },
  duplicate: function duplicate(pIDGenerator, pKeepTranslations, pOldTranslationPageHash, pNewTranslationpageHash, pToEnglishDict, pOrigPastedComponentID, pPastedComponentID) {
    var componentDict = {};
    var actionIDDict = {};
    var translationsDict = {};
    // parameters pOrigPastedComponentID, pPastedComponentID are used in ActionFunction
    // there are here to be compatible
    var oldID = this.getComponentID();
    var newID = pIDGenerator();
    if (this.getType() === FormElement.type.COMPONENT) {
      this.element.id = newID;
    } else {
      this.element.getComponent().id = newID;
    }
    // actions
    if (this.hasActions()) {
      var actionDuplicateOutput = this.getActionList().duplicate(pIDGenerator, pKeepTranslations, pOldTranslationPageHash, pNewTranslationpageHash, pToEnglishDict, pOrigPastedComponentID, pPastedComponentID);
      if (actionDuplicateOutput) {
        if (_typeof(actionDuplicateOutput.actionIDDict) === "object") {
          actionIDDict = Object.assign(actionIDDict, actionDuplicateOutput.actionIDDict);
        }
        if (_typeof(actionDuplicateOutput.translationsDict) === "object") {
          translationsDict = Object.assign(translationsDict, actionDuplicateOutput.translationsDict);
        }
      }
    }
    // translate Options
    if (typeof pOldTranslationPageHash === "string" && typeof pNewTranslationpageHash === "string") {
      translationsDict = Object.assign(translationsDict, this._updateTranslations(pIDGenerator, oldID, pKeepTranslations, pOldTranslationPageHash, pNewTranslationpageHash, pToEnglishDict));
    }
    componentDict[oldID] = newID;
    return {
      "componentDict": componentDict,
      "actionIDDict": actionIDDict,
      "translationsDict": translationsDict
    };
  },
  changeActionsComponentIDs: function changeActionsComponentIDs(pTranslatedIDs) {
    if (this.hasActions() === true) {
      this.actionList.changeComponentIDs(pTranslatedIDs);
    }
  },
  _updateTranslations: function _updateTranslations(pIDGenerator, pOldComponentID, pKeep, pOldTranslationPageHash, pNewTranslationpageHash, pToEnglishDict) {
    var optionsToInspect; // link by references !
    var newComponentID = this.getComponentID();
    if (this.getType() === FormElement.type.COMPONENT) {
      optionsToInspect = this.element.getOptions();
    } else {
      optionsToInspect = this.element.getComponent().getOptions();
    }
    return TranslationHandler.duplicateTranslations(optionsToInspect, pIDGenerator, pOldComponentID, newComponentID, pKeep, pOldTranslationPageHash, pNewTranslationpageHash, pToEnglishDict);
  },
  clone: function clone(pReplaceIDs, pNewID, pCalcNewKeyCB) {
    if (pReplaceIDs === true && typeof pNewID === "string" && pNewID.length > 0) {
      var oldID = this.getComponentID();
      var cloneElementJSON = $.extend(true, {}, this.toJSON());
      var linkedOptionsRegExp = new RegExp("^[$][{][0-9a-zA-Z\-_]*" + oldID + "[0-9a-zA-Z\-_]*[}]$");
      cloneElementJSON = CloudflowObject.travers(cloneElementJSON, function (pValue) {
        if (linkedOptionsRegExp.test(pValue)) {
          return pValue.replace(oldID, pNewID);
        }
        return pValue;
      });
      var cloneElement = FormElement.fromJSON(cloneElementJSON);
      if (cloneElement.getType() === FormElement.type.COMPONENT) {
        cloneElement.element.id = pNewID;
      } else {
        // field
        cloneElement.element.getComponent().id = pNewID;
        var oldKey = cloneElement.element.getKey();
        if (typeof pCalcNewKeyCB === "function") {
          cloneElement.element.setKey(pCalcNewKeyCB(oldKey));
        } else {
          cloneElement.element.setKey(oldKey + " copy");
        }
      }
      return cloneElement;
    } else {
      return FormElement.fromJSON(this.toJSON());
    }
  },
  toJSON: function toJSON() {
    var outputJSON = {
      type: this.getType(),
      element: this.element.toJSON(),
      style: Object.assign({}, this.style)
    };
    if (this.hasActions() === true) {
      outputJSON.actionList = this.actionList.toJSON();
    }
    if (this.creationRequirement !== null) {
      outputJSON.creationRequirement = this.getCreationRequirement();
    }
    return outputJSON;
  }
};
module.exports = FormElement;

},{"../../CloudflowUtil/js/CloudflowObject.js":79,"../../Translate/js/TranslationHandler.js":234,"./ActionList.js":242,"./Component.js":247,"./Field.js":248}],252:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
;
var Layout = require("./Layout.js");
var Form = require("./Form.js");
var CloudflowObject = require("../../CloudflowUtil/js/CloudflowObject.js");
var CloudflowURL = require("../../CloudflowUtil/js/CloudflowURL.js");
var FormElement = require("./FormElement.js");
var ActionList = require("./ActionList.js");
var Action = require("./Action.js");
var ActionFunction = require("./ActionFunction.js");
var KeyPressEventTrigger = require("./KeyPressEventTrigger.js");
var ExpressionToJS = require("../../../pagebuilder/js/ExpressionToJS.js");
var externalFileReferRegExp = new RegExp("{\"type\"\:\"com\.nixps\.quantum\.variable\.0\"[^}]*\"source_file\"\:\"([^\"]+)\"");

/**
 * @class HTMLPage
 * @description The class representing a pagebuilder page
 * @param {Object} pOptions all the page options
 */
var HTMLPage = function HTMLPage(pOptions) {
  // set Hash
  this.hash = null;
  if (pOptions.hash !== undefined && pOptions.hash !== null) {
    this.setHash(pOptions.hash);
  }
  // set ID
  this.setID(pOptions.id);
  // set title
  this.title = "";
  this.setTitle(pOptions.title);
  this.setDescription(pOptions.description);
  this.setFavicon(pOptions.favicon);
  this.setThemeColor(pOptions.theme_color);
  this._setModification(pOptions.modification);
  this.setExternalMetatags(pOptions.editor_metadata);
  // set elements
  this.setElements(pOptions.elements);
  // set layout
  this.setLayout(pOptions.layout);
  // set actions
  this.setSubActions(pOptions.sub_actions);
  this.setOnloadBeforedrawActions(pOptions.onload_beforedraw_actions);
  this.setOnloadAfterdrawActions(pOptions.onload_afterdraw_actions);
  this.setKeyPressActions(pOptions.key_press_actions);
  // set waiting options
  this.setWaitingOptions(pOptions.waiting_options);
  // set version number
  this.setVersion(pOptions.version);
  // set styling profile
  this.setStyleProfile(pOptions.style_profile);
  // set options for translations
  this.setExtraTranslationPath(pOptions.translation_path);
  this.setExtraTranslationFileTemplate(pOptions.translation_filetemplate);
  this.setManifest(pOptions.manifest);
  this.setServiceWorker(pOptions.service_worker);
  this.setOfflineMessage(pOptions.offline_message);
  // set errorpage
  this.setErrorPage(pOptions.errorpageurl);
  // set style url
  this.setStyleURL(pOptions.style_url);
  // set a context as example to test 
  this.setContextExample(pOptions.context_example);
  // set the default context
  this.setDefaultContext(pOptions.default_context);
  this.setUIMode(pOptions.ui_mode);
  this.setDesignForDevice(pOptions.design_for_device);
  this.setAccessRestrictions(pOptions.access_restrictions);
  this.setNeedRelativePaths(pOptions.needs_relative_paths);
  this.setRelativebasePath(pOptions.relative_path);
  // set the options of the privacy cookies 
  this.setConsentOptions(pOptions.consent_options);
  this.setSecurityOptions(pOptions.security_options);
};
HTMLPage.fromJSON = function (pJSON) {
  if (pJSON === null || _typeof(pJSON) !== "object" || Array.isArray(pJSON)) {
    throw new Error("parameter pJSON must be an object");
  }
  if (Object.keys(pJSON).length === 0) {
    throw new Error("parameter pJSON may not be an empty object");
  }
  return new HTMLPage(pJSON);
};
HTMLPage.generateUUID = function () {
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
};
HTMLPage.prototype = {
  constructor: HTMLPage,
  getID: function getID() {
    return this.id;
  },
  setID: function setID(pID) {
    if (typeof pID !== "string" || pID.length <= 0) {
      throw new Error("setID: parameter id must be a not empty string");
    }
    this.id = pID;
  },
  getTitle: function getTitle() {
    return this.title;
  },
  /**
   * @description Set the title of the page. This will be used for the header > title tag. 
   * So this text will be visible in the browser tab.
   * @function
   * @name HTMLPage.setTitle
   * @param {String} pTitle 
   */
  setTitle: function setTitle(pTitle) {
    if (typeof pTitle === "string") {
      this.title = pTitle;
    } else if (Array.isArray(pTitle)) {
      // value composer
      this.title = structuredClone(pTitle);
    } else {
      throw new Error("setTitle: parameter title must be a string");
    }
  },
  hasDescription: function hasDescription() {
    return typeof this.description === "string" && this.description.length > 0;
  },
  setDescription: function setDescription(pDescription) {
    if (pDescription === undefined || pDescription === null) {
      this.description = "";
    } else if (typeof pDescription === "string") {
      this.description = pDescription;
    } else {
      throw new Error("setDescription: parameter description must be a string");
    }
  },
  getDescription: function getDescription() {
    return this.description;
  },
  hasFavicon: function hasFavicon() {
    return typeof this.favicon === "string" && this.favicon.length > 4;
  },
  setFavicon: function setFavicon(pURL) {
    if (typeof pURL === "string" && pURL.length > 4) {
      this.favicon = pURL;
    } else {
      this.favicon = null;
    }
  },
  getFavicon: function getFavicon() {
    return this.favicon;
  },
  hasThemeColor: function hasThemeColor() {
    return typeof this.theme_color === "string" && this.theme_color.length > 0 && ["transparent", "initial"].includes(this.theme_color) === false;
  },
  setThemeColor: function setThemeColor(pColor) {
    if (typeof pColor === "string" && pColor.length > 0) {
      this.theme_color = pColor;
    } else {
      this.theme_color = null;
    }
  },
  getThemeColor: function getThemeColor() {
    return this.theme_color;
  },
  hasHash: function hasHash() {
    return typeof this.hash === "string" && this.hash.length > 0;
  },
  getHash: function getHash() {
    return this.hash;
  },
  setHash: function setHash(pHash) {
    if (typeof pHash !== "string" && pHash.length <= 0) {
      throw new Error("setHash: the parameter hash must be a not empty string");
    }
    this.hash = pHash;
  },
  getElements: function getElements() {
    return this.elements;
  },
  setElements: function setElements(pElements) {
    if (pElements && _typeof(pElements) === "object") {
      this.elements = Form.fromJSON(pElements);
    } else {
      throw new Error("setElements: invalid elements");
    }
  },
  setLayout: function setLayout(pLayout) {
    // set layout
    if (pLayout instanceof Layout) {
      this.layout = pLayout;
    } else if (pLayout && _typeof(pLayout) === "object" && !Array.isArray(pLayout)) {
      this.layout = Layout.fromJSON(pLayout);
    } else {
      throw new Error("setLayout: invalid layout");
    }
  },
  getLayout: function getLayout() {
    return this.layout;
  },
  getAllPrivateSubActions: function getAllPrivateSubActions() {
    function _getPrivSubActions(pActionFunctions) {
      var subActions = [];
      var internalActionFunctions = [];
      for (var i = 0; i < pActionFunctions.length; i++) {
        var internalSubActionsJSONs = pActionFunctions[i].getPrivateInternalSubActions();
        if (Array.isArray(internalSubActionsJSONs) && internalSubActionsJSONs.length > 0) {
          for (var j = 0; j < internalSubActionsJSONs.length; j++) {
            if (internalSubActionsJSONs[j] && Array.isArray(internalSubActionsJSONs[j].action_functions)) {
              subActions.push(internalSubActionsJSONs[j]);
              internalActionFunctions = internalActionFunctions.concat(internalSubActionsJSONs[j].action_functions.map(function (pActionFunction) {
                return ActionFunction.fromJSON(pActionFunction);
              }));
            }
          }
        }
      }
      if (internalActionFunctions.length > 0) {
        subActions = subActions.concat(_getPrivSubActions(internalActionFunctions));
      }
      return subActions;
    }
    var privateSubActions = [];
    var actions = [];
    var elements = this.getElements().getElements();
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].hasActions()) {
        actions = actions.concat(elements[i].getActionList().getActions());
      }
    }
    if (this.hasSubActions()) {
      actions = actions.concat(this.getSubActions().getActions());
    }
    if (this.hasOnloadBeforedrawActions()) {
      actions = actions.concat(this.getOnloadBeforedrawActions().getActions());
    }
    if (this.hasOnloadAfterdrawActions()) {
      actions = actions.concat(this.getOnloadAfterdrawActions().getActions());
    }
    if (this.hasKeyPressActions()) {
      this.getKeyPressActions().forEach(function (e) {
        actions = actions.concat(e);
      });
    }
    if (actions.length > 0) {
      var actionFunctions = [];
      for (var i = 0; i < actions.length; i++) {
        if (typeof actions[i].getParameters === "function" && actions[i].getParameters() !== undefined && typeof actions[i].getParameters().getActionFunctions === "function") {
          actionFunctions = actionFunctions.concat(actions[i].getParameters().getActionFunctions());
        } else if (typeof actions[i].getActionFunctions === "function") {
          actionFunctions = actionFunctions.concat(actions[i].getActionFunctions());
        } else if (typeof actions[i].getParameters === "function" && actions[i].getParameters() instanceof ActionFunction) {
          actionFunctions = actionFunctions.concat(actions[i].getParameters());
        }
      }
      if (actionFunctions.length > 0) {
        var subActionJSONs = _getPrivSubActions(actionFunctions);
        for (var i = 0; i < subActionJSONs.length; i++) {
          privateSubActions.push(new Action("subPageAction", subActionJSONs[i]));
        }
      }
    }
    return privateSubActions;
  },
  hasSubActions: function hasSubActions() {
    return this.sub_actions.hasActions();
  },
  setSubActions: function setSubActions(pSubActions) {
    if (pSubActions === undefined || pSubActions === null) {
      this.sub_actions = new ActionList([]);
    } else if (Array.isArray(pSubActions)) {
      this.sub_actions = ActionList.fromJSON(pSubActions);
    } else if (pSubActions instanceof ActionList) {
      this.sub_actions = pSubActions.clone();
    } else {
      throw new Error("setSubActions: unknown interface for actionlist");
    }
  },
  getSubActions: function getSubActions() {
    return this.sub_actions;
  },
  hasOnloadBeforedrawActions: function hasOnloadBeforedrawActions() {
    return this.onload_beforedraw_actions.hasActions();
  },
  setOnloadBeforedrawActions: function setOnloadBeforedrawActions(pActionList) {
    if (pActionList === undefined || pActionList === null) {
      this.onload_beforedraw_actions = new ActionList([]);
    } else if (Array.isArray(pActionList)) {
      this.onload_beforedraw_actions = ActionList.fromJSON(pActionList);
    } else if (pActionList instanceof ActionList) {
      this.onload_beforedraw_actions = pActionList.clone();
    } else {
      throw new Error("setOnloadBeforedrawActions: unknown interface for actionlist");
    }
  },
  getOnloadBeforedrawActions: function getOnloadBeforedrawActions() {
    return this.onload_beforedraw_actions;
  },
  hasOnloadAfterdrawActions: function hasOnloadAfterdrawActions() {
    return this.onload_afterdraw_actions.hasActions();
  },
  setOnloadAfterdrawActions: function setOnloadAfterdrawActions(pActionList) {
    if (pActionList === undefined || pActionList === null) {
      this.onload_afterdraw_actions = new ActionList([]);
    } else if (Array.isArray(pActionList)) {
      this.onload_afterdraw_actions = ActionList.fromJSON(pActionList);
    } else if (pActionList instanceof ActionList) {
      this.onload_afterdraw_actions = pActionList.clone();
    } else {
      throw new Error("setOnloadAfterdrawActions: unknown interface for actionlist");
    }
  },
  getOnloadAfterdrawActions: function getOnloadAfterdrawActions() {
    return this.onload_afterdraw_actions;
  },
  hasKeyPressActions: function hasKeyPressActions() {
    return Array.isArray(this.key_press_actions) && this.key_press_actions.length > 0;
  },
  setKeyPressActions: function setKeyPressActions(pKeyPressActionListDict) {
    this.key_press_actions = [];
    if (Array.isArray(pKeyPressActionListDict) && pKeyPressActionListDict.length > 0) {
      for (var i = 0; i < pKeyPressActionListDict.length; i++) {
        if (pKeyPressActionListDict[i] instanceof KeyPressEventTrigger) {
          this.key_press_actions.push(pKeyPressActionListDict[i].clone());
        } else if (pKeyPressActionListDict[i] && _typeof(pKeyPressActionListDict[i]) === "object" && !Array.isArray(pKeyPressActionListDict[i])) {
          this.key_press_actions.push(KeyPressEventTrigger.fromJSON(pKeyPressActionListDict[i]));
        }
      }
    }
  },
  getKeyPressActions: function getKeyPressActions() {
    return this.key_press_actions;
  },
  removeActionsWithComponentLink: function removeActionsWithComponentLink(pComponentID) {
    if (this.hasSubActions()) {
      this.sub_actions.removeByComponentID(pComponentID);
    }
    if (this.hasOnloadBeforedrawActions()) {
      this.onload_beforedraw_actions.removeByComponentID(pComponentID);
    }
    if (this.hasOnloadAfterdrawActions()) {
      this.onload_afterdraw_actions.removeByComponentID(pComponentID);
    }
    if (this.hasKeyPressActions()) {
      this.key_press_actions.forEach(function (e) {
        e.removeComponentID(pComponentID);
      });
    }
  },
  removeSubAction: function removeSubAction(pSubActionID) {
    if (this.hasSubActions()) {
      var index = this.sub_actions.getActions().findIndex(function (pAction) {
        return pAction.getParameters().getID() === pSubActionID;
      });
      if (index >= 0) {
        this.sub_actions.removeActionByIndex(index);
      }
    }
    this.elements.getElements().forEach(function (pFormElement) {
      if (pFormElement.hasActions()) {
        pFormElement.getActionList().removeLinkWithSubActionID(pSubActionID);
      }
    });
    // if (this.hasOnloadBeforedrawActions()) {
    //     this.onload_beforedraw_actions.removeByComponentID(pComponentID);
    // }
    // if (this.hasOnloadAfterdrawActions()) {
    //     this.onload_afterdraw_actions.removeByComponentID(pComponentID);
    // }
    // if (this.hasKeyPressActions()) {
    //     this.key_press_actions.forEach(function(e){
    //         e.removeComponentID(pComponentID);
    //     })
    // }
  },

  /**
   * @description Set options for the freezeoverlay to start the page
   * @function
   * @name HTMLPage.setWaitingOptions
   * @param {Object} pWaitingOptions 
   */
  setWaitingOptions: function setWaitingOptions(pWaitingOptions) {
    this.waiting_options = {};
    if (pWaitingOptions && _typeof(pWaitingOptions) === "object" && pWaitingOptions.constructor && pWaitingOptions.constructor.name === "Object") {
      this.waiting_options = Object.assign({}, this.waiting_options, pWaitingOptions);
    }
  },
  /**
   * @description get all the freeze overlay options
   * @function
   * @name HTMLPage.getWaitingOptions
   * @returns {Object} freezeOverlay options
   */
  getWaitingOptions: function getWaitingOptions() {
    return this.waiting_options;
  },
  setVersion: function setVersion(pVersionNumber) {
    if (typeof pVersionNumber !== "number" || pVersionNumber < 0) {
      throw new Error("setVersion: version number must be a positive number");
    }
    this.version = pVersionNumber;
  },
  getVersion: function getVersion() {
    return this.version;
  },
  getStyleURL: function getStyleURL() {
    return this.style_url;
  },
  setStyleURL: function setStyleURL(pStyleURL) {
    if (typeof pStyleURL === "string" && pStyleURL.length > 0) {
      this.style_url = pStyleURL;
      // reset deprecated value if new value is defined!
      this.setStyleProfile(null);
    } else if (pStyleURL === null) {
      this.style_url = null;
      // reset deprecated value if new value is defined!
      this.setStyleProfile(null);
    } else {
      this.style_url = null;
    }
  },
  /**
   * @deprecated use getStyleURL
   */
  getStyleProfile: function getStyleProfile() {
    // deprecated => use style url 
    return this.style_profile;
  },
  /**
   * @deprecated use setStyleURL
   * @param {String} pStyleProfile 
   */
  setStyleProfile: function setStyleProfile(pStyleProfile) {
    // deprecated => use style url 
    if (typeof pStyleProfile === "string" && pStyleProfile.length > 0) {
      this.style_profile = pStyleProfile;
    } else {
      this.style_profile = null;
    }
  },
  hasExtraTranslation: function hasExtraTranslation() {
    return this.translation_path !== null;
  },
  getExtraTranslationPath: function getExtraTranslationPath() {
    return this.translation_path;
  },
  setExtraTranslationPath: function setExtraTranslationPath(pTranslationPath) {
    if (typeof pTranslationPath === "string" && pTranslationPath.length > 0) {
      this.translation_path = pTranslationPath;
      if (this.translation_path[this.translation_path.length - 1] !== "/") {
        this.translation_path += "/";
      }
    } else {
      this.translation_path = null;
    }
  },
  getExtraTranslationFileTemplate: function getExtraTranslationFileTemplate() {
    return this.translation_filetemplate;
  },
  setExtraTranslationFileTemplate: function setExtraTranslationFileTemplate(pTranslationFileTemplate) {
    if (typeof pTranslationFileTemplate === "string" && pTranslationFileTemplate.length > 0) {
      this.translation_filetemplate = pTranslationFileTemplate;
    } else {
      this.translation_filetemplate = null;
    }
  },
  getTranslationPageHash: function getTranslationPageHash() {
    return "pb-" + this.getID().substring(0, 2) + this.getID().slice(-2);
  },
  hasManifest: function hasManifest() {
    return typeof this.manifest === "string" && this.manifest.length > 0;
  },
  setManifest: function setManifest(pManifest) {
    if (typeof pManifest === "string" && pManifest.length > 0) {
      this.manifest = pManifest;
    } else {
      this.manifest = null;
    }
  },
  getManifest: function getManifest() {
    return this.manifest;
  },
  hasServiceWorker: function hasServiceWorker() {
    return typeof this.service_worker === "string" && this.service_worker.length > 0;
  },
  setServiceWorker: function setServiceWorker(pURL) {
    if (typeof pURL === "string" && pURL.length > 0) {
      this.service_worker = pURL;
    } else {
      this.service_worker = null;
    }
  },
  getServiceWorker: function getServiceWorker() {
    return this.service_worker;
  },
  hasOfflineMessage: function hasOfflineMessage() {
    return this.offline_message !== null;
  },
  setOfflineMessage: function setOfflineMessage(pOfflineMessage) {
    this.offline_message = null;
    if (pOfflineMessage === undefined || pOfflineMessage === null) {} else if (!Array.isArray(pOfflineMessage) && _typeof(pOfflineMessage) === "object") {
      this.offline_message = structuredClone(pOfflineMessage);
    }
  },
  getOfflineMessage: function getOfflineMessage() {
    return this.offline_message;
  },
  hasErrorPage: function hasErrorPage() {
    return typeof this.errorpageurl === "string" && this.errorpageurl.length > 0;
  },
  setErrorPage: function setErrorPage(pErrorPageUrl) {
    if (typeof pErrorPageUrl === "string" && pErrorPageUrl.length > 0) {
      this.errorpageurl = pErrorPageUrl;
    } else {
      this.errorpageurl = null;
    }
  },
  getErrorPage: function getErrorPage() {
    return this.errorpageurl;
  },
  hasContextExample: function hasContextExample() {
    return this.context_example !== undefined && this.context_example !== null;
  },
  getContextExample: function getContextExample() {
    return this.context_example;
  },
  setContextExample: function setContextExample(pContextJSON) {
    if (pContextJSON === undefined || pContextJSON === null) {
      this.context_example = null;
    } else if (!Array.isArray(pContextJSON) && _typeof(pContextJSON) === "object" && Object.keys(pContextJSON).length > 0) {
      this.context_example = Object.assign({}, pContextJSON);
    }
  },
  hasDefaultContext: function hasDefaultContext() {
    return this.default_context !== null;
  },
  getDefaultContext: function getDefaultContext() {
    return this.default_context;
  },
  setDefaultContext: function setDefaultContext(pContextJSON) {
    this.default_context = null;
    if (pContextJSON && !Array.isArray(pContextJSON) && _typeof(pContextJSON) === "object" && Object.keys(pContextJSON).length > 0) {
      this.default_context = Object.assign({}, pContextJSON);
    }
  },
  setUIMode: function setUIMode(pUIMode) {
    this.ui_mode = "";
    if (pUIMode === "nebula") {
      // only known ui mode
      this.ui_mode = "nebula";
    }
  },
  getUIMode: function getUIMode() {
    return this.ui_mode;
  },
  setDesignForDevice: function setDesignForDevice(pDevice) {
    if (typeof pDevice === "string" && pDevice.length > 0) {
      this.design_for_device = pDevice;
    } else {
      this.design_for_device = "screen";
    }
  },
  getDesignForDevice: function getDesignForDevice() {
    return this.design_for_device;
  },
  hasAccessRestrictions: function hasAccessRestrictions() {
    return this.access_restrictions !== null && _typeof(this.access_restrictions) === "object" && Object.keys(this.access_restrictions).length > 0;
  },
  setAccessRestrictions: function setAccessRestrictions(pAccessRestrictions) {
    this.access_restrictions = null;
    if (pAccessRestrictions && _typeof(pAccessRestrictions) === "object" && Object.keys(pAccessRestrictions).length > 0) {
      this.access_restrictions = {};
      if (pAccessRestrictions.admin_only === true) {
        this.access_restrictions.admin_only = pAccessRestrictions.admin_only;
      }
      if (Array.isArray(pAccessRestrictions.user_attributes) && pAccessRestrictions.user_attributes.length > 0) {
        this.access_restrictions.user_attributes = pAccessRestrictions.user_attributes;
      }
      if (typeof pAccessRestrictions.user_permission === "string" && pAccessRestrictions.user_permission.length > 0) {
        this.access_restrictions.user_permission = pAccessRestrictions.user_permission;
      }
      if (typeof pAccessRestrictions.license === "string" && pAccessRestrictions.license.length > 0) {
        this.access_restrictions.license = pAccessRestrictions.license;
      }
    }
  },
  getAccessRestrictions: function getAccessRestrictions() {
    return this.access_restrictions;
  },
  setNeedRelativePaths: function setNeedRelativePaths(pNeedsRelativePaths) {
    if (typeof pNeedsRelativePaths === "boolean") {
      this.needs_relative_paths = pNeedsRelativePaths;
    } else {
      this.needs_relative_paths = null;
    }
  },
  getNeedRelativePaths: function getNeedRelativePaths() {
    return this.needs_relative_paths;
  },
  needRelativePaths: function needRelativePaths() {
    return this.needs_relative_paths === true;
  },
  hasRelativebasePath: function hasRelativebasePath() {
    return typeof this.relative_path === "string" && this.relative_path.length > 0;
  },
  setRelativebasePath: function setRelativebasePath(pPath) {
    this.relative_path = null;
    if (typeof pPath === "string" && pPath.length > 0) {
      this.relative_path = pPath;
    }
  },
  getRelativebasePath: function getRelativebasePath() {
    return this.relative_path;
  },
  setConsentOptions: function setConsentOptions(pConsentOptions) {
    this.consent_options = null;
    if (pConsentOptions && _typeof(pConsentOptions) === "object" && !Array.isArray(pConsentOptions)) {
      this.consent_options = pConsentOptions;
    }
  },
  getConsentOptions: function getConsentOptions() {
    return this.consent_options;
  },
  hasSecurityOptions: function hasSecurityOptions() {
    return this.security_options !== null;
  },
  setSecurityOptions: function setSecurityOptions(pSecurityOptions) {
    this.security_options = null;
    if (pSecurityOptions && _typeof(pSecurityOptions) === "object" && !Array.isArray(pSecurityOptions)) {
      this.security_options = structuredClone(pSecurityOptions);
    }
  },
  getSecurityOptions: function getSecurityOptions() {
    return this.security_options;
  },
  _setModification: function _setModification(pModification) {
    this.modification = null;
    if (typeof pModification === "string" && pModification.length > 5) {
      this.modification = pModification;
    }
  },
  getModification: function getModification() {
    return this.modification;
  },
  updateModification: function updateModification() {
    this.modification = new Date().toISOString();
  },
  hasExternalMetatags: function hasExternalMetatags() {
    return this.editor_metadata !== null;
  },
  setExternalMetatags: function setExternalMetatags(pEditorMetadata) {
    if (typeof pEditorMetadata === "string") {
      this.editor_metadata = pEditorMetadata;
    } else if (Array.isArray(pEditorMetadata)) {
      this.editor_metadata = pEditorMetadata.slice();
    } else {
      this.editor_metadata = null;
    }
  },
  getExternalMetatags: function getExternalMetatags() {
    return this.editor_metadata;
  },
  getErrors: function getErrors(pCurrentVersion) {
    if (typeof pCurrentVersion !== "number") {
      throw new Error("getErrors: the version number must be a number");
    }
    // array of keys (string), those keys will be translated in the translations to desant error messages
    var errors = [];
    if (pCurrentVersion < this.version) {
      errors.push("futureversion");
    }
    if (this.elements !== undefined && Array.isArray(this.elements.elements) && this.elements.elements.length > 0 && new Form(this.elements.elements).hasDoubleComponentIDs()) {
      errors.push("double_ids");
    }
    return errors;
  },
  getFileStore: function getFileStore(pURL) {
    if (typeof pURL === "string" && pURL.indexOf("cloudflow://") === 0) {
      // retrieve current filestore
      var url_without_beginning = pURL.slice(12);
      return url_without_beginning.slice(0, url_without_beginning.indexOf("/"));
    } else {
      throw new Error("getFileStore: could not retrieve correct filestore");
    }
  },
  getExternalFileURLs: function getExternalFileURLs(pCurrentURL) {
    var externalFileReferences = [];
    var fileURLs = [];
    var objectsToScan = [];
    var elements = this.getElements().getElements();
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].getType() === "component") {
        var component = elements[i].getElement();
        if (component.getOptions() !== undefined) {
          objectsToScan.push(component.getOptions());
        }
      }
    }
    if (this.hasSubActions()) {
      objectsToScan.push(this.getSubActions().getActions());
    }
    if (this.hasOnloadBeforedrawActions()) {
      objectsToScan.push(this.getOnloadBeforedrawActions().getActions());
    }
    if (this.hasOnloadAfterdrawActions()) {
      objectsToScan.push(this.getOnloadAfterdrawActions().getActions());
    }
    if (this.hasKeyPressActions()) {
      objectsToScan = objectsToScan.concat(this.getKeyPressActions().map(function (e) {
        return e.getActionFunctions();
      }));
    }
    var expressionToJS = new ExpressionToJS({});
    for (var i = 0; i < objectsToScan.length; i++) {
      expressionToJS.applyOnObjectCallBack(objectsToScan[i], function (pExpressions) {
        var valueComposerAsString = JSON.stringify(pExpressions);
        var parts = externalFileReferRegExp.exec(valueComposerAsString);
        if (Array.isArray(parts) && parts.length > 1 && typeof parts[1] === "string") {
          fileURLs.push(parts[1]);
        }
        return pExpressions;
      }, function () {});
    }
    if (fileURLs.length > 0) {
      for (var i = 0; i < fileURLs.length; i++) {
        var url = "";
        var externalLink = undefined;
        if (this.hasRelativebasePath()) {
          externalLink = new CloudflowURL(this.getRelativebasePath(), fileURLs[i]);
        } else {
          externalLink = new CloudflowURL(fileURLs[i]);
        }
        if (this.needRelativePaths() === true) {
          url = externalLink.getRelativeUploadPath(pCurrentURL);
        } else {
          url = externalLink.getUploadPath();
        }
        if (typeof url === "string" && url.length > 0) {
          externalFileReferences.push({
            uploadURL: url,
            originalURL: fileURLs[i]
          });
        }
      }
      fileURLs = _.uniq(fileURLs, function (x) {
        return x.originalURL;
      });
    }
    return externalFileReferences;
  },
  duplicate: function duplicate(pNewTitle) {
    var duplication = this.clone();
    duplication.setID(HTMLPage.generateUUID());
    duplication.hash = null;
    var oldTranslationHash = null;
    var newTranslationHash = null;
    if (this.hasExtraTranslation()) {
      oldTranslationHash = this.getTranslationPageHash();
      newTranslationHash = duplication.getTranslationPageHash();
    }
    var pageTranslationsDict = {};
    if (typeof duplication.getTitle() === "string") {
      // original title is a string
      if (typeof pNewTitle === "string" && pNewTitle.length > 0) {
        duplication.setTitle(pNewTitle);
      } else {
        duplication.setTitle(duplication.getTitle() + " copy");
      }
    } else if (Array.isArray(duplication.getTitle())) {
      // original title is a vc
      // if no translations, the title is already cloned
      var errorHappend = false;
      if (this.hasExtraTranslation()) {
        var oldPageID = this.getID();
        var newPageID = duplication.getID();
        var newTitle = CloudflowObject.travers(duplication.getTitle(), function (pValue, pPath) {
          if (typeof pValue === "string" && pValue.startsWith("pb-") && pPath.endsWith(".translation_key")) {
            var valueComposer = CloudflowObject.getParameter(duplication.getTitle(), pPath.replace(".translation_key", ""));
            if (valueComposer.type === "com.nixps.localization.look_up.0") {
              // translate to newer translation keys
              var newKey = pValue.replace(oldTranslationHash, newTranslationHash).replace(oldPageID, newPageID);
              if (newKey === pValue) {
                errorHappend = true;
                console.error("value composer error from outside found");
              } else {
                pageTranslationsDict[pValue] = newKey;
              }
              return newKey;
            }
          }
          return pValue;
        });
        if (errorHappend === false) {
          duplication.setTitle(newTitle);
        } else {
          duplication.setTitle(pNewTitle || " copy");
        }
      }
    }
    var duplicateReturn = duplication.elements.duplicate(HTMLPage.generateUUID, oldTranslationHash, newTranslationHash);
    duplication.layout.changeComponentIDs(duplicateReturn.componentDict);
    return {
      "HTMLPage": duplication,
      "translationKeys": Object.assign(pageTranslationsDict, duplicateReturn.translationsDict)
    };
  },
  getAllComponents: function getAllComponents(pDepth) {
    var form = this.getElements();
    return this._getAllElements(form.getElements(), pDepth).map(function (elem) {
      return elem.getElement();
    });
  },
  getAllElements: function getAllElements(pDepth) {
    var form = this.getElements();
    return this._getAllElements(form.getElements(), pDepth);
  },
  _getAllElements: function _getAllElements(pFormElements, pDepth) {
    var elements = [];
    if (Array.isArray(pFormElements) && pFormElements.length > 0) {
      for (var i = 0; i < pFormElements.length; i++) {
        if (pFormElements[i] instanceof FormElement) {
          elements.push(pFormElements[i].clone());
        } else if (pFormElements[i] && _typeof(pFormElements[i]) === "object" && !Array.isArray(pFormElements[i])) {
          elements.push(FormElement.fromJSON(pFormElements[i]));
        }
        var formElement = elements[elements.length - 1];
        if (pDepth === true) {
          var type = formElement.getElement().getType();
          if (type === "CustomPageComponentContainer") {
            var options = formElement.getElement().options;
            var childFormElements = CloudflowObject.getParameter(options, "contentOptions.HTMLPageJSON.elements.elements");
            if (Array.isArray(childFormElements) && childFormElements.length > 0) {
              var childElements = this._getAllElements(childFormElements, pDepth);
              if (Array.isArray(childElements)) {
                elements = elements.concat(childElements);
              }
            }
          } else if (type === "CustomPageComponent") {
            var options = formElement.getElement().options;
            var childFormElements = CloudflowObject.getParameter(options, "HTMLPageJSON.elements.elements");
            if (Array.isArray(childFormElements) && childFormElements.length > 0) {
              var childElements = this._getAllElements(childFormElements, pDepth);
              if (Array.isArray(childElements)) {
                elements = elements.concat(childElements);
              }
            }
          }
        }
      }
    }
    return elements;
  },
  overwriteAllElements: function overwriteAllElements(pFormElements) {
    var form = this.getElements();
    this._overwriteAllElements(pFormElements, form);
  },
  _overwriteAllElements: function _overwriteAllElements(pFormElements, pForm) {
    var formType;
    var form;
    if (pForm instanceof Form) {
      form = pForm;
      formType = "form";
    } else {
      form = Form.fromJSON(pForm);
      formType = "JSON";
    }
    var stillToReplace = [];
    if (Array.isArray(pFormElements) && pFormElements.length > 0) {
      for (var i = 0; i < pFormElements.length; i++) {
        var replacedFormElement = form.replaceElementByID(pFormElements[i], pFormElements[i].getComponentID());
        if (replacedFormElement === undefined) {
          // the element was not a direct element of the form
          stillToReplace.push(pFormElements[i]);
        }
      }
      if (stillToReplace.length > 0) {
        var formElements = form.getElements();
        for (var f = 0; f < formElements.length; f++) {
          var type = formElements[f].getElement().getType();
          if (type === "CustomPageComponentContainer") {
            var options = formElements[f].getElement().options;
            var childForm = CloudflowObject.getParameter(options, "contentOptions.HTMLPageJSON.elements");
            if (childForm !== undefined) {
              var newForm = this._overwriteAllElements(stillToReplace, childForm);
              CloudflowObject.setParameter(options, "contentOptions.HTMLPageJSON.elements", newForm);
            }
          } else if (type === "CustomPageComponent") {
            var options = formElements[f].getElement().options;
            var childForm = CloudflowObject.getParameter(options, "HTMLPageJSON.elements");
            if (childForm !== undefined) {
              var newForm = this._overwriteAllElements(stillToReplace, childForm);
              CloudflowObject.setParameter(options, "HTMLPageJSON.elements", newForm);
            }
          }
        }
      }
    }
    if (formType === "form") {
      return form;
    } else {
      return form.toJSON();
    }
  },
  clone: function clone() {
    return HTMLPage.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = {
      hash: this.hash,
      version: this.version,
      id: this.id,
      title: this.title,
      modification: this.modification,
      favicon: this.favicon,
      description: this.description,
      waiting_options: this.getWaitingOptions(),
      elements: this.elements.toJSON(),
      layout: this.layout.toJSON(),
      offline_message: this.getOfflineMessage(),
      style_url: this.style_url,
      ui_mode: this.ui_mode,
      design_for_device: this.getDesignForDevice(),
      access_restrictions: this.access_restrictions,
      consent_options: this.consent_options,
      needs_relative_paths: this.needs_relative_paths
    };
    if (this.hasExternalMetatags()) {
      outputJSON.editor_metadata = this.getExternalMetatags();
    }
    if (this.hasThemeColor()) {
      outputJSON.theme_color = this.getThemeColor();
    }
    if (typeof this.style_url === "string" && this.style_url.length > 0) {
      outputJSON.style_url = this.style_url;
    } else if (typeof this.style_profile === "string" && this.style_profile.length > 0) {
      // only add if style_url is undefined and style profile is defined
      outputJSON.style_profile = this.style_profile;
    }
    if (this.hasContextExample()) {
      // only add if there is one
      outputJSON.context_example = this.context_example;
    }
    if (this.hasDefaultContext()) {
      outputJSON.default_context = this.default_context;
    }
    if (this.hasSecurityOptions()) {
      outputJSON.security_options = this.getSecurityOptions();
    }
    if (this.hasExtraTranslation()) {
      outputJSON.translation_path = this.translation_path;
      outputJSON.translation_filetemplate = this.translation_filetemplate;
    }
    if (this.hasManifest()) {
      if (typeof this.manifest === "string") {
        outputJSON.manifest = this.manifest;
      }
    }
    if (this.hasServiceWorker()) {
      outputJSON.service_worker = this.getServiceWorker();
    }
    if (this.hasSubActions()) {
      outputJSON.sub_actions = this.getSubActions().toJSON();
    }
    if (this.hasOnloadBeforedrawActions()) {
      outputJSON.onload_beforedraw_actions = this.getOnloadBeforedrawActions().toJSON();
    }
    if (this.hasOnloadAfterdrawActions()) {
      outputJSON.onload_afterdraw_actions = this.getOnloadAfterdrawActions().toJSON();
    }
    if (this.hasKeyPressActions()) {
      outputJSON.key_press_actions = this.getKeyPressActions().map(function (e) {
        return e.toJSON();
      });
    }
    if (this.hasRelativebasePath()) {
      outputJSON.relative_path = this.getRelativebasePath();
    }
    if (this.hasErrorPage()) {
      outputJSON.errorpageurl = this.errorpageurl;
    }
    return outputJSON;
  }
};
module.exports = HTMLPage;

},{"../../../pagebuilder/js/ExpressionToJS.js":415,"../../CloudflowUtil/js/CloudflowObject.js":79,"../../CloudflowUtil/js/CloudflowURL.js":80,"./Action.js":240,"./ActionFunction.js":241,"./ActionList.js":242,"./Form.js":249,"./FormElement.js":251,"./KeyPressEventTrigger.js":254,"./Layout.js":255}],253:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var ActionFunction = require("./ActionFunction.js");
var JQueryEventPageTrigger = function JQueryEventPageTrigger(pEventName, pFilterSelector, pActionFunctions, pMouseType, pTargetCheckType, pTargetCheckClass, pCursorType) {
  this.setEventName(pEventName);
  this.setFilterSelector(pFilterSelector);
  if (Array.isArray(pActionFunctions)) {
    this.setActionFunctions(pActionFunctions);
  } else {
    this.setActionFunctions([pActionFunctions]);
  }
  this.setMouseType(pMouseType);
  this.setTargetCheckType(pTargetCheckType);
  this.setTargetCheckClass(pTargetCheckClass);
  this.setCursorType(pCursorType);
};
JQueryEventPageTrigger.fromJSON = function (pJSON) {
  if (!pJSON || Object.getPrototypeOf(pJSON) !== Object.prototype || $.isEmptyObject(pJSON)) {
    throw new Error("pJSON parameter must be a not empty object");
  }
  if (Array.isArray(pJSON.actionfunctions)) {
    return new JQueryEventPageTrigger(pJSON.eventname, pJSON.filterselector, pJSON.actionfunctions, pJSON.mousetype, pJSON.targetchecktype, pJSON.targetcheckclass, pJSON.cursortype);
  } else {
    return new JQueryEventPageTrigger(pJSON.eventname, pJSON.filterselector, [pJSON.actionfunction], pJSON.mousetype, pJSON.targetchecktype, pJSON.targetcheckclass, pJSON.cursortype);
  }
};
JQueryEventPageTrigger.getIdentificationType = function () {
  return "jqueryEventPageTrigger";
};
JQueryEventPageTrigger.prototype = {
  constructor: JQueryEventPageTrigger,
  getEventName: function getEventName() {
    return this.eventname;
  },
  setEventName: function setEventName(pEventName) {
    if (typeof pEventName !== "string" || pEventName.length <= 0) {
      throw new Error("pEventName must be a not empty string");
    }
    this.eventname = pEventName;
  },
  hasFilterSelector: function hasFilterSelector() {
    return typeof this.filterselector === "string";
  },
  getFilterSelector: function getFilterSelector() {
    return this.filterselector;
  },
  setFilterSelector: function setFilterSelector(pFilterselector) {
    if (pFilterselector === undefined || pFilterselector === null || pFilterselector === "") {
      this.filterselector = null;
    } else if (typeof pFilterselector !== "string") {
      throw new Error("input parameter filterselector must be a string");
    } else {
      this.filterselector = pFilterselector;
    }
  },
  setMouseType: function setMouseType(pMouseType) {
    if (typeof pMouseType === "string") {
      this.mousetype = pMouseType;
    } else {
      this.mousetype = null;
    }
  },
  getMouseType: function getMouseType() {
    return this.mousetype;
  },
  isPointerEvent: function isPointerEvent() {
    return this.getEventName().indexOf("click") >= 0;
  },
  hasTargetCheck: function hasTargetCheck() {
    return typeof this.targetchecktype === "string" || Array.isArray(this.targetchecktype);
  },
  setTargetCheckType: function setTargetCheckType(pCheckType) {
    if (pCheckType === undefined) {
      this.targetchecktype = undefined;
    } else if (pCheckType === "findUUID") {
      this.targetchecktype = "findUUID";
    } else if (pCheckType === "parentsUUID") {
      this.targetchecktype = "parentsUUID";
    } else {
      throw new Error("unknown targetcheck");
    }
  },
  getTargetCheckType: function getTargetCheckType() {
    return this.targetchecktype;
  },
  setTargetCheckClass: function setTargetCheckClass(pCheckClass) {
    this.targetcheckclass = pCheckClass;
  },
  getTargetCheckClass: function getTargetCheckClass() {
    return this.targetcheckclass;
  },
  hasCursorType: function hasCursorType() {
    return this.cursortype !== null;
  },
  setCursorType: function setCursorType(pCursorType) {
    if (typeof pCursorType === "string" && pCursorType.length > 0) {
      this.cursortype = pCursorType;
    } else {
      this.cursortype = null;
    }
  },
  getCursorType: function getCursorType() {
    return this.cursortype;
  },
  getLayoutInfo: function getLayoutInfo() {
    if (this.hasCursorType()) {
      return {
        "eventname": this.getEventName(),
        "selector": this.getFilterSelector(),
        "cursortype": this.getCursorType()
      };
    }
    return null;
  },
  getActionFunctions: function getActionFunctions() {
    return this.actionFunctions;
  },
  setActionFunctions: function setActionFunctions(pActionFunctions) {
    this.actionFunctions = [];
    if (Array.isArray(pActionFunctions)) {
      for (var i = 0; i < pActionFunctions.length; i++) {
        if (pActionFunctions[i] instanceof ActionFunction) {
          this.actionFunctions.push(pActionFunctions[i]);
        } else if (pActionFunctions[i] && Object.getPrototypeOf(pActionFunctions[i]) === Object.prototype) {
          this.actionFunctions.push(ActionFunction.fromJSON(pActionFunctions[i]));
        } else {
          throw new Error("wrong actionfunction interface");
        }
      }
    }
  },
  /**
   * @deprecated use getActionFunctions
   * @returns object
   */
  getActionFunction: function getActionFunction() {
    return this.actionFunctions[0];
  },
  /**
   * @deprecated use setActionFunctions
   * @param {Object} pActionFunction 
   */
  setActionFunction: function setActionFunction(pActionFunction) {
    this.setActionFunctions([pActionFunction]);
  },
  hasLinkWithComponentID: function hasLinkWithComponentID(pComponentID) {
    if (typeof pComponentID !== "string" || pComponentID.length <= 0) {
      throw new Error("input paramter pComponentID must be a not empty string");
    }
    return this.getActionFunctions().some(function (af) {
      return af.hasLinkWithComponentID(pComponentID);
    });
  },
  removeComponentID: function removeComponentID(pComponentID) {
    var remains = [];
    for (var i = this.actionFunctions.length - 1; i >= 0; i--) {
      var remain = this.actionFunctions[i].removeComponentID(pComponentID);
      if (Array.isArray(remain)) {
        if (remain.length === 0) {
          this.actionFunctions.splice(i, 1);
        } else {
          remains = remains.concat(remain);
        }
      }
    }
    return remains;
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    for (var i = 0; i < this.actionFunctions.length; i++) {
      this.actionFunctions[i].changeComponentIDs(pTranslatedIDs);
    }
  },
  removeSubActionID: function removeSubActionID(pSubActionID) {
    var remains = [];
    for (var i = this.actionFunctions.length - 1; i >= 0; i--) {
      var remain = this.actionFunctions[i].removeSubActionID(pSubActionID);
      if (Array.isArray(remain)) {
        if (remain.length === 0) {
          this.actionFunctions.splice(i, 1);
        } else {
          remains = remains.concat(remain);
        }
      }
    }
    return remains;
  },
  triggerNameChange: function triggerNameChange(pChanges, pComponentName) {
    var eventName = this.getEventName().toLowerCase();
    var targetCheckClass = this.getTargetCheckClass();
    for (var c = 0; c < pChanges.length; c++) {
      if (typeof pChanges[c].old_componentname === "string" && typeof pChanges[c].new_componentname === "string") {
        if (typeof eventName === "string" && eventName.startsWith(pChanges[c].old_componentname.toLowerCase())) {
          this.setEventName(eventName.replace(pChanges[c].old_componentname.toLowerCase(), pChanges[c].new_componentname.toLowerCase()));
          if (typeof targetCheckClass === "string" && targetCheckClass.indexOf(pChanges[c].old_componentname) > 0) {
            this.setTargetCheckClass(targetCheckClass.replace(pChanges[c].old_componentname, pChanges[c].new_componentname));
          }
          if (typeof targetCheckClass === "string" && targetCheckClass.indexOf(pChanges[c].old_targetcheckclass) > -1) {
            this.setTargetCheckClass(targetCheckClass.replace(pChanges[c].old_targetcheckclass, pChanges[c].new_targetcheckclass));
          }
          break;
        }
      }
      if (typeof pComponentName === "string" && eventName === pComponentName.toLowerCase() + "action" + pChanges[c].old_name.toLowerCase()) {
        // provided by references
        this.setEventName(pComponentName.toLowerCase() + "action" + pChanges[c].new_name.toLowerCase());
        break;
      }
    }
  },
  duplicate: function duplicate() {
    var actionIDDict = {},
      componentDict = {},
      translationsDict = {};
    for (var i = 0; i < this.actionFunctions.length; i++) {
      var _this$actionFunctions;
      var output = (_this$actionFunctions = this.actionFunctions[i]).duplicate.apply(_this$actionFunctions, arguments);
      if (output) {
        if (_typeof(output.actionIDDict) === "object") {
          actionIDDict = Object.assign(actionIDDict, output.actionIDDict);
        }
        if (_typeof(output.componentDict) === "object") {
          componentDict = Object.assign(componentDict, output.componentDict);
        }
        if (_typeof(output.translationsDict) === "object") {
          translationsDict = Object.assign(translationsDict, output.translationsDict);
        }
      }
    }
    return {
      "componentDict": componentDict,
      "actionIDDict": actionIDDict,
      "translationsDict": translationsDict
    };
  },
  clone: function clone() {
    return JQueryEventPageTrigger.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var output = {
      "eventname": this.eventname,
      "filterselector": this.filterselector,
      "mousetype": this.mousetype,
      "targetchecktype": this.targetchecktype,
      "targetcheckclass": this.targetcheckclass,
      "cursortype": this.cursortype
    };
    if (this.actionFunctions.length === 1) {
      // keep for go back in history, and save memory space by not include actionfunctionS
      output["actionfunction"] = this.actionFunctions[0].toJSON();
    } else if (this.actionFunctions.length > 1) {
      output["actionfunction"] = this.actionFunctions[0].toJSON(); // will lose others ...
      output["actionfunctions"] = this.actionFunctions.map(function (a) {
        return a.toJSON();
      });
    } else {
      // empty ??? actionFunctions.length === 0
      output["actionfunction"] = undefined;
      output["actionfunctions"] = [];
    }
    return output;
  }
};
module.exports = JQueryEventPageTrigger;

},{"./ActionFunction.js":241}],254:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var ActionFunction = require("./ActionFunction.js");
var KeyPressEventTrigger = function KeyPressEventTrigger(options) {
  this.setKeys(options.keys);
  this.setActionFunctions(options.action_functions);
  this.setAbortEvent(options.abort_event);
};
KeyPressEventTrigger.fromJSON = function (pJSON) {
  return new KeyPressEventTrigger(pJSON);
};
KeyPressEventTrigger.prototype = {
  constructor: KeyPressEventTrigger,
  setKeys: function setKeys(pKeys) {
    this.keys = [];
    if (Array.isArray(pKeys) && pKeys.length > 0) {
      for (var i = 0; i < pKeys.length; i++) {
        if (typeof pKeys[i] === "string" && pKeys[i].length > 0) {
          this.keys.push(pKeys[i]);
        } else {
          throw new Error("unsupported type of keys " + pKeys[i]);
        }
      }
    }
    if (this.keys.length === 0) {
      throw new Error("at least on key is epected");
    }
  },
  getKeys: function getKeys() {
    return this.keys;
  },
  setActionFunctions: function setActionFunctions(pActionFunctions) {
    if (!Array.isArray(pActionFunctions)) {
      throw new Error("actionlist must be an array");
    }
    // empty array is allowed
    this.action_functions = [];
    for (var i = 0; i < pActionFunctions.length; i++) {
      if (pActionFunctions[i] instanceof ActionFunction) {
        this.action_functions.push(pActionFunctions[i].clone());
      } else if (pActionFunctions[i] && _typeof(pActionFunctions[i]) === "object" && !Array.isArray(pActionFunctions[i])) {
        this.action_functions.push(ActionFunction.fromJSON(pActionFunctions[i]));
      } else {
        throw new Error("unsupported type of action function");
      }
    }
  },
  getActionFunctions: function getActionFunctions() {
    return this.action_functions;
  },
  setAbortEvent: function setAbortEvent(pAbortEvent) {
    if (pAbortEvent === true) {
      this.abort_event = true;
    } else {
      this.abort_event = false;
    }
  },
  isAbortEvent: function isAbortEvent() {
    return this.abort_event === true;
  },
  removeComponentID: function removeComponentID(pComponentID) {
    var remains = [];
    for (var i = this.action_functions.length - 1; i >= 0; i--) {
      var remain = this.action_functions[i].removeComponentID(pComponentID);
      if (Array.isArray(remain)) {
        if (remain.length === 0) {
          this.action_functions.splice(i, 1);
        } else {
          remains = remains.concat(remain);
        }
      }
    }
    return remains;
  },
  hasLinkWithComponentID: function hasLinkWithComponentID(pComponentID) {
    throw new Error("not supported yet");
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    for (var i = 0; i < this.action_functions.length; i++) {
      this.action_functions[i].changeComponentIDs(pTranslatedIDs);
    }
  },
  removeSubActionID: function removeSubActionID(pSubActionID) {
    var remains = [];
    for (var i = this.action_functions.length - 1; i >= 0; i--) {
      var remain = this.action_functions[i].removeSubActionID(pSubActionID);
      if (Array.isArray(remain)) {
        if (remain.length === 0) {
          this.action_functions.splice(i, 1);
        } else {
          remains = remains.concat(remain);
        }
      }
    }
    return remains;
  },
  duplicate: function duplicate() {
    var actionIDDict = {},
      componentDict = {},
      translationsDict = {};
    for (var i = 0; i < this.action_functions.length; i++) {
      var _this$action_function;
      var output = (_this$action_function = this.action_functions[i]).duplicate.apply(_this$action_function, arguments);
      if (output) {
        if (_typeof(output.actionIDDict) === "object") {
          actionIDDict = Object.assign(actionIDDict, output.actionIDDict);
        }
        if (_typeof(output.componentDict) === "object") {
          componentDict = Object.assign(componentDict, output.componentDict);
        }
        if (_typeof(output.translationsDict) === "object") {
          translationsDict = Object.assign(translationsDict, output.translationsDict);
        }
      }
    }
    return {
      "componentDict": componentDict,
      "actionIDDict": actionIDDict,
      "translationsDict": translationsDict
    };
  },
  clone: function clone() {
    return KeyPressEventTrigger.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {
      keys: this.keys,
      action_functions: this.action_functions.map(function (a) {
        return a.toJSON();
      }),
      abort_event: this.abort_event
    };
  }
};
module.exports = KeyPressEventTrigger;

},{"./ActionFunction.js":241}],255:[function(require,module,exports){
"use strict";

var BootstrapGridLayout = require("./BootstrapGridLayout.js");
var CompassLayoutReq = require("./CompassLayout.js");
var TableGridLayout = require("./TableGridLayout.js");
var CompassLayout;
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

/**
 * @class Layout
 * @description a helpclass for forming a form
 * @param {string} pTitle - the title to use (optionaly)
 * @param {mixed} pParameters - parameters for the layout of the form
 */
var Layout = function Layout(pType, pParameters) {
  this.type;
  this.setType(pType);
  this.parameters;
  this.setParameters(pParameters);
};

/**
 * Different types of layout, supporeted by the Layout component, for forms and pages
 * @readonly
 * @enum {String}
 */
Layout.type = Object.freeze({
  /** grid, adapting by screen width */
  "BOOTSTRAPGRID": "bootstrapGrid",
  /** nord, west, south, east and center */
  "COMPASS": "compass",
  /** table grid */
  "TABLEGRID": "tableGrid",
  /** develop need to make it self */
  "CUSTOM": "custom"
});
Layout.fromJSON = function (json) {
  return new Layout(json.type, json.parameters);
};
Layout.generateGUID = function () {
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
};
Layout.prototype = {
  constructor: Layout,
  getType: function getType() {
    return this.type;
  },
  setType: function setType(pType) {
    if (typeof pType !== "string" || pType.length <= 0) {
      throw new Error("input parameter pType must be a string");
    }
    switch (pType) {
      case Layout.type.BOOTSTRAPGRID:
      case Layout.type.COMPASS:
      case Layout.type.TABLEGRID:
      case Layout.type.CUSTOM:
        break;
      default:
        throw new Error("unsupported layout type");
    }
    this.type = pType;
  },
  getParameters: function getParameters() {
    return this.parameters;
  },
  setParameters: function setParameters(pLayout) {
    if (this.type === Layout.type.BOOTSTRAPGRID) {
      if (pLayout instanceof BootstrapGridLayout) {
        this.parameters = pLayout;
      } else if (Array.isArray(pLayout) || pLayout && Object.getPrototypeOf(pLayout) === Object.prototype) {
        this.parameters = BootstrapGridLayout.fromJSON(pLayout);
      } else {
        throw new Error("unsupported layout element interface for BootstrapGrid");
      }
    } else if (this.type === Layout.type.COMPASS) {
      if (pLayout instanceof CompassLayout) {
        this.parameters = pLayout;
      } else if (pLayout && Object.getPrototypeOf(pLayout) === Object.prototype) {
        this.parameters = CompassLayout.fromJSON(pLayout);
      } else {
        throw new Error("unsupported layout element interface for Compass");
      }
    } else if (this.type === Layout.type.TABLEGRID) {
      if (pLayout instanceof TableGridLayout) {
        this.parameters = pLayout;
      } else if (Array.isArray(pLayout) || pLayout && Object.getPrototypeOf(pLayout) === Object.prototype) {
        this.parameters = TableGridLayout.fromJSON(pLayout);
      } else {
        throw new Error("unsupported layout element interface for TableGridLayout");
      }
    } else if (this.type === Layout.type.CUSTOM) {
      this.parameters = pLayout;
    } else {
      throw new Error("unsupported layout type");
    }
  },
  compress: function compress() {
    this.parameters.compress();
  },
  getTypePath: function getTypePath() {
    return this.parameters.getTypePath();
  },
  changeToType: function changeToType() {
    var pType = arguments[0];
    var pSubType = arguments[1];
    var pSecSubType = arguments[2];
    // from bootstrap to compass
    if (this.type === Layout.type.BOOTSTRAPGRID && pType === Layout.type.COMPASS) {
      var newParameters = CompassLayout.fromJSON({
        "north": null,
        "east": null,
        "south": null,
        "west": null,
        "center": {
          "type": Layout.type.BOOTSTRAPGRID,
          "parameters": this.parameters.toJSON()
        }
      });
      this.setType(Layout.type.COMPASS);
      this.setParameters(newParameters);
      if (typeof pSubType === "string" && pSubType !== Layout.type.BOOTSTRAPGRID) {
        return this.getParameters().getCenter().changeToType(pSubType, pSecSubType);
      }
      return {
        removed: []
      };
      // from compass to bootstrap
    } else if (this.type === Layout.type.COMPASS && pType === Layout.type.BOOTSTRAPGRID) {
      // retrieve all removed components
      var removedLayoutIDs = [];
      var north = this.parameters.getNorth();
      if (north.isDump() === false) {
        removedLayoutIDs.push(north.getID());
      }
      var east = this.parameters.getEast();
      if (east.isDump() === false) {
        removedLayoutIDs.push(east.getID());
      }
      var south = this.parameters.getSouth();
      if (south.isDump() === false) {
        removedLayoutIDs.push(south.getID());
      }
      var west = this.parameters.getWest();
      if (west.isDump() === false) {
        removedLayoutIDs.push(west.getID());
      }
      if (this.parameters.getCenter() !== null) {
        var canbeChanged = false;
        if (this.parameters.getCenter().getType() === Layout.type.TABLEGRID || this.parameters.getCenter().getType() === Layout.type.BOOTSTRAPGRID) {
          canbeChanged = true;
        } else if (this.parameters.getCenter().getType() === Layout.type.COMPASS) {
          if (this.parameters.getCenter().getParameters().getCenter().getType() === Layout.type.BOOTSTRAPGRID || this.parameters.getCenter().getParameters().getCenter().getType() === Layout.type.TABLEGRID) {
            canbeChanged = true;
            var changedOutput = this.parameters.getCenter().changeToType(Layout.type.BOOTSTRAPGRID);
            if (changedOutput !== undefined && Array.isArray(changedOutput.removed) && changedOutput.removed.length > 0) {
              removedLayoutIDs = removedLayoutIDs.concat(changedOutput.removed);
            }
          }
        }
        if (canbeChanged === false) {
          throw new Error("could not convert layout type");
        }
        newParameters = this.parameters.getCenter().getParameters();
        if (newParameters.getTypePath() === Layout.type.TABLEGRID) {
          this.setType(Layout.type.TABLEGRID);
          this.setParameters(newParameters);
          var _changedOutput = this.changeToType(Layout.type.BOOTSTRAPGRID);
          if (_changedOutput !== undefined && Array.isArray(_changedOutput.removed) && _changedOutput.removed.length > 0) {
            removedLayoutIDs = removedLayoutIDs.concat(_changedOutput.removed);
          }
        } else {
          this.setType(Layout.type.BOOTSTRAPGRID);
          this.setParameters(newParameters);
        }
        return {
          removed: removedLayoutIDs
        };
      } else {
        throw new Error("could not convert layout type");
      }
      //from tablegrid to compass
    } else if (this.type === Layout.type.TABLEGRID && pType === Layout.type.COMPASS) {
      var newParameters = CompassLayout.fromJSON({
        "north": null,
        "east": null,
        "south": null,
        "west": null,
        "center": {
          "type": Layout.type.TABLEGRID,
          "parameters": this.parameters.toJSON()
        }
      });
      this.setType(Layout.type.COMPASS);
      this.setParameters(newParameters);
      if (typeof pSubType === "string" && pSubType !== Layout.type.TABLEGRID) {
        return this.getParameters().getCenter().changeToType(pSubType, pSecSubType);
      }
      return {
        removed: []
      };
      //from tablegrid to bootstrap
    } else if (this.type === Layout.type.TABLEGRID && pType === Layout.type.BOOTSTRAPGRID) {
      //in case when we support adding components : we'll need to remove the ones outside of the 12 width
      var rows = this.getParameters().componentsToBootstrap();
      var _newParameters = BootstrapGridLayout.fromJSON(rows);
      //make sure the rowclasses contain cf-flex
      var currentRowClasses = _newParameters.getRowClasses();
      if (currentRowClasses === null) {
        _newParameters.setRowClasses("cf-flex");
      } else if (typeof currentRowClasses === "string" && currentRowClasses.includes("cf-flex") === false) {
        if (currentRowClasses.length > 0) {
          _newParameters.setRowClasses(currentRowClasses += ",cf-flex");
        } else {
          _newParameters.setRowClasses("cf-flex");
        }
      }
      this.setType(Layout.type.BOOTSTRAPGRID);
      this.setParameters(_newParameters);
      return {
        removed: []
      };
      //from compass to tablegrid
    } else if (this.type === Layout.type.COMPASS && pType === Layout.type.TABLEGRID) {
      // retrieve all removed components
      var removedLayoutIDs = [];
      var north = this.parameters.getNorth();
      if (north.isDump() === false) {
        removedLayoutIDs.push(north.getID());
      }
      var east = this.parameters.getEast();
      if (east.isDump() === false) {
        removedLayoutIDs.push(east.getID());
      }
      var south = this.parameters.getSouth();
      if (south.isDump() === false) {
        removedLayoutIDs.push(south.getID());
      }
      var west = this.parameters.getWest();
      if (west.isDump() === false) {
        removedLayoutIDs.push(west.getID());
      }
      if (this.parameters.getCenter() !== null) {
        var canbeChanged = false;
        if (this.parameters.getCenter().getType() === Layout.type.TABLEGRID || this.parameters.getCenter().getType() === Layout.type.BOOTSTRAPGRID) {
          canbeChanged = true;
        } else if (this.parameters.getCenter().getType() === Layout.type.COMPASS) {
          if (this.parameters.getCenter().getParameters().getCenter().getType() === Layout.type.BOOTSTRAPGRID || this.parameters.getCenter().getParameters().getCenter().getType() === Layout.type.TABLEGRID) {
            canbeChanged = true;
            var changedOutput = this.parameters.getCenter().changeToType(Layout.type.TABLEGRID);
            if (changedOutput !== undefined && Array.isArray(changedOutput.removed) && changedOutput.removed.length > 0) {
              removedLayoutIDs = removedLayoutIDs.concat(changedOutput.removed);
            }
          }
        }
        if (canbeChanged === false) {
          throw new Error("could not convert layout type");
        }
        newParameters = this.parameters.getCenter().getParameters();
        if (newParameters.getTypePath() === Layout.type.BOOTSTRAPGRID) {
          this.setType(Layout.type.BOOTSTRAPGRID);
          this.setParameters(newParameters);
          var _changedOutput2 = this.changeToType(Layout.type.TABLEGRID);
          if (_changedOutput2 !== undefined && Array.isArray(_changedOutput2.removed) && _changedOutput2.removed.length > 0) {
            removedLayoutIDs = removedLayoutIDs.concat(_changedOutput2.removed);
          }
        } else {
          this.setType(Layout.type.TABLEGRID);
          this.setParameters(newParameters);
        }
        return {
          removed: removedLayoutIDs
        };
      } else {
        throw new Error("could not convert layout type");
      }
      //bootstrap to tablegrid
    } else if (this.type === Layout.type.BOOTSTRAPGRID && pType === Layout.type.TABLEGRID) {
      var _newParameters2 = TableGridLayout.fromBootstrap(this.getParameters());
      this.setType(Layout.type.TABLEGRID);
      this.setParameters(_newParameters2);
      return {
        removed: []
      };
    } else if (this.type === pType) {
      if (pType === Layout.type.COMPASS) {
        if (this.parameters.getCenter().getType() !== pSubType) {
          return this.parameters.getCenter().changeToType(pSubType, pSecSubType);
        }
        if (pSecSubType !== undefined && this.parameters.getCenter().getParameters().getCenter().getType() !== pSecSubType) {
          return this.parameters.getCenter().getParameters().getCenter().changeToType(pSecSubType);
        }
        return {
          removed: []
        }; // no changes found
      }
    }
  },

  guestDeviceClass: function guestDeviceClass() {
    return this.parameters.guestDeviceClass();
  },
  changeAllToDeviceClass: function changeAllToDeviceClass(pDeviceClass) {
    this.parameters.changeAllToDeviceClass(pDeviceClass);
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    this.parameters.changeComponentIDs(pTranslatedIDs);
  },
  removeElementByID: function removeElementByID(pElementID) {
    return this.parameters.removeElementByID(pElementID);
  },
  getAllItemIDs: function getAllItemIDs() {
    return this.parameters.getAllItemIDs();
  },
  getFullAreaScopes: function getFullAreaScopes() {
    return this.parameters.getFullAreaScopes();
  },
  clone: function clone() {
    return Layout.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = {
      type: this.type,
      parameters: this.parameters.toJSON()
    };
    return outputJSON;
  }
};
CompassLayout = CompassLayoutReq(Layout);
module.exports = Layout;

},{"./BootstrapGridLayout.js":244,"./CompassLayout.js":245,"./TableGridLayout.js":259}],256:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/** 
 * @constructor LayoutComponent
 * @description Represents a place in the layout, is a child of {@link LayoutRow}
 * @param {String} id - The id of the layout part, use null if the part is empty
 * @param {Number|Object} width - The width settings for the layout part
 * @param {String|Enum} deviceClass - The abbr of the device where the default width is meant for
 */
var LayoutComponent = function LayoutComponent(id, width, deviceClass) {
  this.content = null;
  if (typeof id === "string" && id.length > 0) {
    this.content = id;
  }
  this.width = {};
  if (width && _typeof(width) === "object" && !Array.isArray(width)) {
    this.setWidths(width);
  } else if (typeof width === "number") {
    this.setWidth(width, deviceClass);
  } else {
    throw new Error("width has wrong interface");
  }
};
LayoutComponent.fromJSON = function (json) {
  if (_typeof(json) !== "object" || json === null) {
    throw new Error("invalid parameter");
  }
  var layout = new LayoutComponent(json.content, json.width);
  return layout;
};
LayoutComponent.defaultDeviceClass = function () {
  return "md";
};
LayoutComponent.canMerge = function (a, b) {
  if (a.isDump() === false || b.isDump() === false) {
    return false;
  }
  if (_typeof(a.getWidth("xs")) !== _typeof(b.getWidth("xs"))) {
    return false;
  }
  if (_typeof(a.getWidth("sm")) !== _typeof(b.getWidth("sm"))) {
    return false;
  }
  if (_typeof(a.getWidth("md")) !== _typeof(b.getWidth("md"))) {
    return false;
  }
  if (_typeof(a.getWidth("lg")) !== _typeof(b.getWidth("lg"))) {
    return false;
  }
  return true;
};
LayoutComponent.merge = function (a, b) {
  var widths = {};
  // we suppose a and b can be merged
  if (typeof a.getWidth("xs") === "number" && typeof b.getWidth("xs") === "number") {
    widths.xs = a.getWidth("xs") + b.getWidth("xs");
  }
  if (typeof a.getWidth("sm") === "number" && typeof b.getWidth("sm") === "number") {
    widths.sm = a.getWidth("sm") + b.getWidth("sm");
  }
  if (typeof a.getWidth("md") === "number" && typeof b.getWidth("md") === "number") {
    widths.md = a.getWidth("md") + b.getWidth("md");
  }
  if (typeof a.getWidth("lg") === "number" && typeof b.getWidth("lg") === "number") {
    widths.lg = a.getWidth("lg") + b.getWidth("lg");
  }
  return new LayoutComponent(null, widths);
};
LayoutComponent.prototype = {
  constructor: LayoutComponent,
  getID: function getID() {
    return this.content;
  },
  setID: function setID(pID) {
    if (typeof pID !== "string" || pID.length <= 0) {
      throw new Error("id parameter must be a not empty string");
    }
    this.content = pID;
  },
  getWidths: function getWidths() {
    return this.width;
  },
  setWidths: function setWidths(pWidths) {
    if (!pWidths || Object.getPrototypeOf(pWidths) !== Object.prototype || $.isEmptyObject(pWidths)) {
      throw new Error("parameter pWidths must be an object");
    }
    if (typeof pWidths.xs === "number") {
      this.setWidth(pWidths.xs, "xs");
    }
    if (typeof pWidths.sm === "number") {
      this.setWidth(pWidths.sm, "sm");
    }
    if (typeof pWidths.md === "number") {
      this.setWidth(pWidths.md, "md");
    }
    if (typeof pWidths.lg === "number") {
      this.setWidth(pWidths.lg, "lg");
    }
  },
  resetWidths: function resetWidths(pWidths) {
    this.width = {};
    this.setWidths(pWidths);
    if (Object.keys(this.width).length <= 0) {
      throw new Error("reset widths may not clear the widths parameters");
    }
  },
  getWidth: function getWidth(pDeviceClass) {
    switch (pDeviceClass) {
      case "xs":
        return this.width.xs;
      case "sm":
        return this.width.sm;
      case "md":
        return this.width.md;
      case "lg":
        return this.width.lg;
      default:
        return this.width.md;
    }
  },
  setWidth: function setWidth(pWidth, pDeviceClass) {
    if (typeof pWidth !== "number") {
      throw new Error("parameter pWidth must be a number");
    }
    if (pWidth >= 1 && pWidth <= 12) {
      switch (pDeviceClass) {
        case "xs":
          this.width.xs = pWidth;
          break;
        case "sm":
          this.width.sm = pWidth;
          break;
        case "md":
          this.width.md = pWidth;
          break;
        case "lg":
          this.width.lg = pWidth;
          break;
        default:
          this.width.md = pWidth;
      }
    } else {
      throw new Error("parameter pWidth must be a number between 1 and 12");
    }
  },
  isDump: function isDump() {
    return this.content === null;
  },
  setDump: function setDump(pDump) {
    if (pDump === true) {
      this.content = null;
    }
  },
  isComponent: function isComponent() {
    return typeof this.content === "string" && this.content.length > 0;
  },
  clone: function clone() {
    return LayoutComponent.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = {};
    if (typeof this.content === "string" && this.content.length > 0) {
      outputJSON.content = this.content;
    }
    outputJSON.width = Object.assign({}, this.width);
    return outputJSON;
  }
};
module.exports = LayoutComponent;

},{}],257:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var LayoutComponent = require("./LayoutComponent.js");
function validateIndex(pArray, pIndex) {
  // is number
  if (typeof pIndex !== "number" || isNaN(pIndex)) {
    throw new Error("invalid index: not a number");
  }

  // is index in interval??
  if (pIndex < 0) {
    // is negative
    throw new Error("invalid index: negative");
  }
  if (pIndex >= pArray.length) {
    // out of bound of array
    throw new Error("invalid index: out of bounds");
  }
}
function calcGCD(pNumbers) {
  var g = 0;
  var _iterator = _createForOfIteratorHelper(pNumbers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var n = _step.value;
      n = Math.abs(n);
      while (n) {
        var _ref = [n, g % n];
        g = _ref[0];
        n = _ref[1];
      }
      if (g === 1) {
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return g;
}

/**
 * @class LayoutRow
 * @description This represents one row in the {@link BootstrapGridLayout}
 * @param {Array} pLayoutComponents - an array of {@link LayoutComponent} 
 */
var LayoutRow = function LayoutRow(pLayoutComponents) {
  this.components = [];
  // function setElements do the controls and checks
  this.setElements(pLayoutComponents);
};
LayoutRow.fromJSON = function (json) {
  var components = [];
  for (var i = 0; i < json.length; i++) {
    components.push(LayoutComponent.fromJSON(json[i]));
  }
  // this contructor does the controls and checks
  return new LayoutRow(components);
};
LayoutRow.fromEmptyRow = function (pDummyWidth, pDeviceClass) {
  var components = [];
  for (var i = 0; i < 12 / pDummyWidth; i++) {
    components.push(new LayoutComponent(null, pDummyWidth, pDeviceClass));
  }
  return new LayoutRow(components);
};
LayoutRow.prototype = {
  constructor: LayoutRow,
  getComponentByID: function getComponentByID(pComponentID) {
    for (var i = 0; i < this.components.length; i++) {
      if (this.components[i].getID() === pComponentID) {
        return this.components[i];
      }
    }
  },
  getIndexComponent: function getIndexComponent(pComponentID) {
    for (var i = 0; i < this.components.length; i++) {
      if (this.components[i].getID() === pComponentID) {
        return i;
      }
    }
    return -1;
  },
  initialiseRow: function initialiseRow(pDummyWidth, pDeviceClass) {
    // first add dummys if needed
    var totalWidth = 0;
    for (var i = 0; i < this.components.length; i++) {
      totalWidth += this.getElement(i).getWidth(pDeviceClass);
    }
    if (totalWidth < 12) {
      this.addElement(new LayoutComponent(null, 12 - totalWidth, pDeviceClass));
    }
    // first split everything to one, then group
    for (var i = 0; i < this.components.length; i++) {
      if (this.getElement(i).isDump()) {
        var originalWidth = this.getElement(i).getWidth(pDeviceClass);
        if (originalWidth > 1) {
          var dummy = new LayoutComponent(null, 1, pDeviceClass);
          this.setElement(dummy, i);
          for (var j = 1; j < originalWidth; j++) {
            this.insertElement(dummy.clone(), i);
          }
          i += j - 1;
        }
      }
    }
    // init the dummys
    for (var i = 0; i < this.components.length; i++) {
      // split of group dummys
      // if dummy
      if (this.getElement(i).isDump()) {
        // split if dummy is to big and can be splitted
        var originalWidth = this.getElement(i).getWidth(pDeviceClass);
        if (originalWidth < pDummyWidth && i < this.components.length - 1) {
          // need to group
          var widthToGroup = pDummyWidth - originalWidth;
          for (var j = i + 1; j < this.components.length; j++) {
            if (this.getElement(j).isDump() === false) {
              break;
            }
            var extraWidth = this.getElement(j).getWidth(pDeviceClass);
            widthToGroup -= extraWidth;
            if (widthToGroup === 0) {
              // group to gether
              this.getElement(i).setWidth(pDummyWidth);
              for (var k = 0; k < j - i; k++) {
                this.removeElement(i + 1);
              }
              break;
            } else if (widthToGroup < 0) {
              break;
            }
            // width is positive, we can need to go furter
          }
        }
      }
    }
  },

  replaceByDummy: function replaceByDummy(pComponentID, pDummyWidth, pDeviceClass) {
    var component = this.getComponentByID(pComponentID);
    var componentIndex = this.getIndexComponent(pComponentID);
    var originalWidth = component.getWidth(pDeviceClass);
    var dummy = new LayoutComponent(null, pDummyWidth, pDeviceClass);
    this.setElement(dummy, componentIndex);
    for (var i = 1; i < originalWidth / pDummyWidth; i++) {
      var newDummy = dummy.clone();
      this.insertElement(newDummy, componentIndex);
    }
    return originalWidth / pDummyWidth;
  },
  resizeToLeft: function resizeToLeft(pComponentID, pResizeAmount, pDummyWidth, pDeviceClass) {
    var componentIndex = this.getIndexComponent(pComponentID);
    if (pResizeAmount < 0) {
      // adding dummys
      var amountNewDummys = Math.min(this.getElement(componentIndex).getWidth(pDeviceClass) - 1, -pResizeAmount) / pDummyWidth;
      for (var i = 0; i < amountNewDummys; i++) {
        var dummyComponent = new LayoutComponent(null, pDummyWidth, pDeviceClass);
        this.insertElement(dummyComponent, componentIndex);
      }
      var component = this.getComponentByID(pComponentID);
      component.setWidth(component.getWidth(pDeviceClass) - amountNewDummys * pDummyWidth, pDeviceClass);
      return -amountNewDummys;
    } else if (pResizeAmount > 0) {
      // removing dummys
      var widthShifted = 0;
      var amountRemoveDummys = 0;
      for (var i = componentIndex - 1; i >= 0; i--) {
        if (this.getElement(i).isDump() && this.getElement(i).getWidth(pDeviceClass) <= pResizeAmount - widthShifted) {
          widthShifted += this.getElement(i).getWidth(pDeviceClass);
          amountRemoveDummys++;
        } else {
          break;
        }
      }
      var component = this.getComponentByID(pComponentID);
      component.setWidth(component.getWidth(pDeviceClass) + widthShifted, pDeviceClass);
      for (var i = 0; i < amountRemoveDummys; i++) {
        this.removeElement(componentIndex - amountRemoveDummys);
      }
      return amountRemoveDummys;
    }
  },
  resizeToRight: function resizeToRight(pComponentID, pResizeAmount, pDummyWidth, pDeviceClass) {
    var componentIndex = this.getIndexComponent(pComponentID);
    if (pResizeAmount < 0) {
      // adding dummys
      var amountNewDummys = Math.min(this.getElement(componentIndex).getWidth(pDeviceClass) - 1, -pResizeAmount) / pDummyWidth;
      for (var i = 0; i < amountNewDummys; i++) {
        var dummyComponent = new LayoutComponent(null, pDummyWidth, pDeviceClass);
        this.insertElement(dummyComponent, componentIndex + 1);
      }
      var component = this.getComponentByID(pComponentID);
      component.setWidth(component.getWidth(pDeviceClass) - amountNewDummys * pDummyWidth, pDeviceClass);
      return -amountNewDummys;
    } else if (pResizeAmount > 0) {
      // removing dummys
      var widthShifted = 0;
      var amountRemoveDummys = 0;
      for (var i = componentIndex + 1; i < this.getElements().length; i++) {
        if (this.getElement(i).isDump() && this.getElement(i).getWidth(pDeviceClass) <= pResizeAmount - widthShifted) {
          widthShifted += this.getElement(i).getWidth(pDeviceClass);
          amountRemoveDummys++;
        } else {
          break;
        }
      }
      var component = this.getComponentByID(pComponentID);
      component.setWidth(component.getWidth(pDeviceClass) + widthShifted, pDeviceClass);
      for (var i = 0; i < amountRemoveDummys; i++) {
        this.removeElement(componentIndex + 1);
      }
      return amountRemoveDummys;
    }
  },
  insertNewComponent: function insertNewComponent(pComponent, pIndex, pDevice) {
    var newWidth = pComponent.getWidth(pDevice);
    for (var i = pIndex + 1; i < this.components.length; i++) {
      if (this.components[i].isDump() && this.components[i].getWidth(pDevice) <= newWidth) {
        newWidth -= this.components[i].getWidth(pDevice);
        this.removeElement(i);
        i--;
      }
    }
    this.insertElement(pComponent, pIndex + 1);
  },
  containsDummy: function containsDummy(pWidth, pDevice) {
    for (var i = 0; i < this.components.length; i++) {
      if (this.components[i].isDump() === true && this.components[i].getWidth(pDevice) >= pWidth) {
        return true;
      }
    }
    return false;
  },
  isEmptyRow: function isEmptyRow() {
    for (var i = 0; i < this.components.length; i++) {
      if (this.components[i].isDump() === false) {
        return false;
      }
    }
    return true;
  },
  getGCDWidth: function getGCDWidth(pDeviceClass) {
    var widths = [];
    var dumpWidth;
    for (var i = 0; i < this.components.length; i++) {
      if (this.components[i].isDump() === true) {
        if (dumpWidth === undefined) {
          dumpWidth = this.components[i].getWidth(pDeviceClass);
        } else {
          dumpWidth += this.components[i].getWidth(pDeviceClass);
        }
      } else {
        if (dumpWidth !== undefined) {
          widths.push(dumpWidth);
          dumpWidth = undefined;
        }
        widths.push(this.components[i].getWidth(pDeviceClass));
      }
    }
    //last element can be dump
    if (dumpWidth !== undefined) {
      widths.push(dumpWidth);
      dumpWidth = undefined;
    }
    if (Array.isArray(widths)) {
      if (widths.length > 1) {
        return calcGCD(widths);
      } else if (widths.length === 1) {
        return widths[0];
      }
    }
    return 1;
  },
  getElement: function getElement(pIndex) {
    validateIndex(this.components, pIndex);
    return this.components[pIndex];
  },
  getElements: function getElements() {
    return this.components;
  },
  setElements: function setElements(pElements) {
    // control parameter
    if (!Array.isArray(pElements)) {
      throw new Error("inputvariable must be a array");
    }
    if (pElements.length > 12) {
      throw new Error("Row can not contain more then 12 elements");
    }
    // reset previous values
    this.components = [];
    for (var i = 0; i < pElements.length; i++) {
      this.addElement(pElements[i]);
    }
  },
  setElement: function setElement(pElement, pIndex) {
    validateIndex(this.components, pIndex);
    if (pElement instanceof LayoutComponent) {
      this.components[pIndex] = pElement;
    } else if (pElement && Object.getPrototypeOf(pElement) === Object.prototype) {
      this.components[pIndex] = new LayoutComponent.fromJSON(pElement);
    } else {
      throw new Error("setElement: invalid input parameter");
    }
  },
  addElement: function addElement(pElement) {
    if (pElement instanceof LayoutComponent === false) {
      throw new Error("addElement: invalid input parameter");
    }
    return this.components.push(pElement);
  },
  moveElement: function moveElement(pFromIndex, pToIndex) {
    validateIndex(this.components, pFromIndex);
    validateIndex(this.components, pToIndex);
    if (pToIndex === pFromIndex) {
      return;
    }
    if (pFromIndex < pToIndex) {
      this.components.splice(pToIndex + 1, 0, this.components[pFromIndex]);
      this.removeElement(pFromIndex);
    } else {
      this.components.splice(pToIndex, 0, this.components[pFromIndex]);
      this.removeElement(pFromIndex + 1);
    }
  },
  removeElement: function removeElement(pIndex) {
    validateIndex(this.components, pIndex);
    return this.components.splice(pIndex, 1);
  },
  insertElement: function insertElement(pElement, pIndex) {
    if (pIndex === this.components.length) {
      return this.addElement(pElement);
    }
    validateIndex(this.components, pIndex);
    if (pElement instanceof LayoutComponent) {
      return this.components.splice(pIndex, 0, pElement.clone());
    } else {
      throw new Error("insertElement: invalid input parameter pElement");
    }
  },
  getIndexByBoodstrapIndex: function getIndexByBoodstrapIndex(pBoodstrapIndex, pDeviceClass) {
    if (typeof pBoodstrapIndex !== "number" || pBoodstrapIndex < 0 || pBoodstrapIndex > 11) {
      throw new Error("parameter pBoodstrapIndex is wrong");
    }
    if (parseInt(pBoodstrapIndex) !== pBoodstrapIndex) {
      throw new Error("index should be an integer, not a double");
    }
    if (pBoodstrapIndex === 0) {
      // short cut, when index is zero the inner index will also be zero
      return 0;
    }
    var counter = 0;
    for (var i = 0; i < this.components.length; i++) {
      counter += this.components[i].getWidth(pDeviceClass);
      if (counter > pBoodstrapIndex) {
        return i;
      }
    }
    // no item found, row is empty, so pBoodstrapindex is same as index
    return pBoodstrapIndex;
  },
  compress: function compress() {
    var newComponents = [];
    var first, second;
    while (this.components.length > 0) {
      first = this.components.pop();
      if (first.isDump() === false || this.components.length === 0) {
        newComponents.unshift(first);
        continue;
      }
      second = this.components.pop();
      if (second.isDump() === false) {
        newComponents.unshift(first);
        newComponents.unshift(second);
        continue;
      }
      if (LayoutComponent.canMerge(first, second) === true) {
        this.components.push(LayoutComponent.merge(first, second));
      } else {
        newComponents.unshift(first);
        newComponents.unshift(second);
      }
    }
    this.components = newComponents;
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    if (Array.isArray(this.components) && this.components.length > 0) {
      for (var i = 0; i < this.components.length; i++) {
        var currentID = this.components[i].getID();
        if (typeof currentID === "string" && currentID.length > 0 && typeof pTranslatedIDs[currentID] === "string") {
          this.components[i].setID(pTranslatedIDs[currentID]);
        }
      }
    }
  },
  changeAllToDeviceClass: function changeAllToDeviceClass(pDeviceClass) {
    if (typeof pDeviceClass !== "string") {
      throw new Error("changeAllToDeviceClass: parameter pDeviceClass must be a string");
    }
    if (["xs", "sm", "md", "lg"].indexOf(pDeviceClass) === -1) {
      throw new Error("changeAllToDeviceClass: unknown parameter pDeviceClass " + pDeviceClass);
    }
    if (Array.isArray(this.components) && this.components.length > 0) {
      for (var i = 0; i < this.components.length; i++) {
        var newWidths = {};
        var widths = this.components[i].getWidths();
        var defaultDeviceClass = LayoutComponent.defaultDeviceClass();
        if (typeof widths[pDeviceClass] === "number") {
          newWidths[pDeviceClass] = widths[pDeviceClass];
        } else if (typeof widths[defaultDeviceClass] === "number") {
          newWidths[pDeviceClass] = widths[defaultDeviceClass];
        } else if (typeof widths.xs === "number") {
          newWidths[pDeviceClass] = widths.xs;
        } else if (typeof widths.sm === "number") {
          newWidths[pDeviceClass] = widths.sm;
        } else if (typeof widths.md === "number") {
          newWidths[pDeviceClass] = widths.md;
        } else if (typeof widths.lg === "number") {
          newWidths[pDeviceClass] = widths.lg;
        } else {
          throw new Error("changeAllToDeviceClass: unknown width to transform found");
        }
        this.components[i].resetWidths(newWidths);
      }
    }
  },
  guestDeviceClass: function guestDeviceClass() {
    if (Array.isArray(this.components) && this.components.length > 0) {
      for (var i = 0; i < this.components.length; i++) {
        var widths = this.components[i].getWidths();
        if (widths && Object.getPrototypeOf(widths) === Object.prototype) {
          var deviceClasses = Object.keys(widths);
          if (Array.isArray(deviceClasses) && deviceClasses.length > 0) {
            return deviceClasses[0];
          }
        }
      }
    }
    return LayoutComponent.defaultDeviceClass();
  },
  clone: function clone() {
    return LayoutRow.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var inputJSON = [];
    for (var i = 0; i < this.components.length; i++) {
      inputJSON.push(this.components[i].toJSON());
    }
    return inputJSON;
  }
};
module.exports = LayoutRow;

},{"./LayoutComponent.js":256}],258:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var ActionFunction = require("./ActionFunction.js");
/**
 * @constructor SubAction
 * @description Is an type of {@link Action} that is used in pagebuilder. It is like subflows. You you can reuse existing action types 
 * @param {String} pTitle - the title to use (optionaly)
 * @param {json_object} pComponent - the compoent to show as inputfield, this can be inserted as json or as component class
 */
var SubAction = function SubAction(pOptions) {
  this.setID(pOptions.id);
  this.setName(pOptions.name);
  this.setDescription(pOptions.description);
  this.setIcon(pOptions.icon);
  if (this.getName() === "__action_route__") {
    pOptions.access_control = "hidden";
  }
  this.setAccessControl(pOptions.access_control);
  this.setInputParameters(pOptions.input_parameters);
  this.setReturnInfo(pOptions.return_info);
  this.setActionFunctions(pOptions.action_functions);
};
SubAction.fromJSON = function (json) {
  return new SubAction(json);
};
SubAction.prototype = {
  constructor: SubAction,
  setID: function setID(pID) {
    this.id = pID;
  },
  getID: function getID() {
    return this.id;
  },
  setName: function setName(pName) {
    if (typeof pName !== "string" || pName.length <= 0) {
      throw new Error("setName: name must be a not empty string");
    }
    this.name = pName;
  },
  getName: function getName() {
    return this.name;
  },
  setDescription: function setDescription(pDescription) {
    this.description = "";
    if (typeof pDescription === "string") {
      this.description = pDescription;
    }
  },
  getDescription: function getDescription() {
    return this.description;
  },
  getDescriptionToShow: function getDescriptionToShow() {
    var desc = this.getDescription();
    if (typeof desc === "string" && desc.length > 0) {
      return desc;
    }
    return this.getName();
  },
  hasIcon: function hasIcon() {
    return typeof this.icon === "string" && this.icon.length > 0;
  },
  setIcon: function setIcon(pIcon) {
    this.icon = null;
    if (typeof pIcon === "string" && pIcon.length > 0) {
      this.icon = pIcon;
    }
  },
  getIcon: function getIcon() {
    return this.icon;
  },
  setAccessControl: function setAccessControl(pAccessControl) {
    if (pAccessControl === undefined || pAccessControl === null || pAccessControl === "") {
      this.access_control = "public";
    } else if (["hidden", "private", "public"].indexOf(pAccessControl) >= 0) {
      this.access_control = pAccessControl;
    } else {
      throw new Error("setAccessControl: unknown access control");
    }
  },
  getAccessControl: function getAccessControl() {
    return this.access_control;
  },
  setInputParameters: function setInputParameters(pInputParameters) {
    this.input_parameters = {};
    if (pInputParameters && _typeof(pInputParameters) === "object" && !Array.isArray(pInputParameters)) {
      this.input_parameters = structuredClone(pInputParameters);
    }
  },
  getInputParameters: function getInputParameters() {
    return this.input_parameters;
  },
  setReturnInfo: function setReturnInfo(pReturnInfo) {
    if (pReturnInfo && _typeof(pReturnInfo) === "object") {
      this.return_info = pReturnInfo;
    } else {
      this.return_info = null;
    }
  },
  getReturnInfo: function getReturnInfo() {
    return this.return_info;
  },
  setActionFunctions: function setActionFunctions(pActionFunctions) {
    this.action_functions = [];
    if (Array.isArray(pActionFunctions)) {
      for (var i = 0; i < pActionFunctions.length; i++) {
        if (pActionFunctions[i] instanceof ActionFunction) {
          this.action_functions.push(pActionFunctions[i].clone());
        } else if (pActionFunctions[i] && _typeof(pActionFunctions[i]) === "object") {
          this.action_functions.push(ActionFunction.fromJSON(pActionFunctions[i]));
        } else {
          console.error("setActionFunctions: unknown action function found", pActionFunctions[i]);
        }
      }
    }
    this.calcEndPoint();
  },
  getActionFunctions: function getActionFunctions() {
    return this.action_functions;
  },
  calcEndPoint: function calcEndPoint() {
    this.endpoint = calcIsEndPoint(this.action_functions, 0);
    return typeof this.endpoint === "boolean";
  },
  isEndPoint: function isEndPoint() {
    return this.endpoint;
  },
  hasLinkWithComponentID: function hasLinkWithComponentID(pComponentID) {
    if (typeof pComponentID !== "string" || pComponentID.length <= 0) {
      throw new Error("input paramter pComponentID must be a not empty string");
    }
    return this.action_functions.some(function (actionFunction) {
      return actionFunction.hasLinkWithComponentID(pComponentID);
    });
  },
  removeComponentID: function removeComponentID(pComponentID) {
    var remains = [];
    for (var i = this.action_functions.length - 1; i >= 0; i--) {
      var remain = this.action_functions[i].removeComponentID(pComponentID);
      if (Array.isArray(remain)) {
        if (remain.length === 0) {
          this.action_functions.splice(i, 1);
        } else {
          remains = remains.concat(remain);
        }
      }
    }
    return remains;
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    for (var i = 0; i < this.action_functions.length; i++) {
      this.action_functions[i].changeComponentIDs(pTranslatedIDs);
    }
  },
  removeSubActionID: function removeSubActionID(pSubActionID) {
    var remains = [];
    for (var i = this.action_functions.length - 1; i >= 0; i--) {
      var remain = this.action_functions[i].removeSubActionID(pSubActionID);
      if (Array.isArray(remain)) {
        if (remain.length === 0) {
          this.action_functions.splice(i, 1);
        } else {
          remains = remains.concat(remain);
        }
      }
    }
    return remains;
  },
  duplicate: function duplicate() {
    var actionIDDict = {},
      componentDict = {},
      translationsDict = {};
    for (var i = 0; i < this.action_functions.length; i++) {
      var _this$action_function;
      var output = (_this$action_function = this.action_functions[i]).duplicate.apply(_this$action_function, arguments);
      if (output) {
        if (_typeof(output.actionIDDict) === "object") {
          actionIDDict = Object.assign(actionIDDict, output.actionIDDict);
        }
        if (_typeof(output.componentDict) === "object") {
          componentDict = Object.assign(componentDict, output.componentDict);
        }
        if (_typeof(output.translationsDict) === "object") {
          translationsDict = Object.assign(translationsDict, output.translationsDict);
        }
      }
    }
    return {
      "componentDict": componentDict,
      "actionIDDict": actionIDDict,
      "translationsDict": translationsDict
    };
  },
  clone: function clone() {
    return SubAction.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = {
      id: this.getID(),
      name: this.getName(),
      description: this.getDescription(),
      icon: this.getIcon(),
      access_control: this.getAccessControl(),
      input_parameters: structuredClone(this.input_parameters),
      return_info: this.getReturnInfo(),
      action_functions: this.getActionFunctions().map(function (func) {
        return func.toJSON();
      })
    };
    return outputJSON;
  },
  toActionJSON: function toActionJSON() {
    return {
      "id": this.getID(),
      "actionFunctionName": "subpageaction",
      "license": [],
      "apply_on": null,
      "apply_on_target_element": null,
      "public_name": this.getName(),
      "helptext": this.getDescriptionToShow(),
      "endpoint": this.isEndPoint(),
      "icon": this.getIcon(),
      "component_specify": false,
      "show_on_list": ["hidden"].indexOf(this.getAccessControl()) >= 0 ? false : true,
      "default_parameters": {},
      "edit_form_variables": {
        "elements": [{
          "type": "component",
          "element": {
            "id": "error",
            "type": "ErrorMessage",
            "options": {}
          }
        }, {
          "type": "field",
          "element": {
            "key": "sub_action_id",
            "label": " ",
            "component": {
              "id": "sub_action_id",
              "type": "Input",
              "options": {
                "type": "hidden",
                "value": this.getID(),
                "fixedValue": true
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "input_parameters",
            "label": "",
            "component": {
              "id": "input_parameters",
              "type": "Input",
              "options": {
                "type": "hidden",
                "value": "${prepvar.datatopass}"
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "_datatopass",
            "label": "",
            "component": {
              "id": "_datatopass",
              "type": "ConfigurePlainObject",
              "options": {
                "context": "${context_during_action}",
                "expressionBuilderInputOptions": {
                  "maintitle": "${nixps-cloudflow-pagebuilder.actionfunctiontype_setvariables}",
                  "scopedVariableSources": "${scoped_variables_sources}",
                  "consent": "${consent}",
                  "relativeBasePath": "${relativePath}",
                  "user": "${user}",
                  "useObjectExpression": true,
                  "translationPrefixKey": "${actionuuid_translation_prefix_key}",
                  "translationPostfixKey": ".inputparameters"
                }
              }
            }
          }
        }]
      },
      "return_info": this.getReturnInfo(),
      "sub_action_functions": this.getActionFunctions().map(function (func) {
        return func.toJSON();
      }),
      "get_resources": function get_resources() {
        return [];
      } // will be handled by the webresource and resource_type === "*SubActionID*"
    };
  },

  toFakeTrigger: function toFakeTrigger() {
    return {
      "id": this.getID(),
      "actiontype": "subPageAction",
      "name": this.getName(),
      "context": null,
      "helptext": this.getDescriptionToShow(),
      "icon": this.getIcon(),
      "accesscontrol": this.getAccessControl(),
      "actions": this.getActionFunctions(),
      "data_info": [{
        "name": "inputParameters",
        "type": "object",
        "description": "nixps-cloudflow-pagebuilder.actiontiggertype_subaction_inputparameters_helptext"
      }, {
        "name": "eventData",
        "type": "object",
        "description": "nixps-cloudflow-pagebuilder.actiontiggertype_subaction_eventdata_helptext"
      }]
    };
  }
};
function calcIsEndPoint(pActionFunctions) {
  var pLoopIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (pActionFunctions.length === 0) {
    // no actions, that means it does not end
    return false;
  } else if (pLoopIndex >= 10) {
    // stop too may loops
    return null;
  } else {
    var lastActionFunction = pActionFunctions[pActionFunctions.length - 1];
    if (window.api_mock !== undefined && api_mock.actions !== undefined) {
      var lastActionDefJSON = api_mock.actions.get(lastActionFunction.getID());
      if (lastActionDefJSON !== null && _typeof(lastActionDefJSON) === "object") {
        if (lastActionDefJSON.endpoint === null && lastActionDefJSON.actionFunctionName === "subpageaction" && Array.isArray(lastActionDefJSON.sub_action_functions)) {
          var endPoint = calcIsEndPoint(lastActionDefJSON.sub_action_functions.map(function (f) {
            return ActionFunction.fromJSON(f);
          }), pLoopIndex + 1);
          return endPoint == true;
        } else {
          return lastActionDefJSON.endpoint == true;
        }
      } else {
        // console.error("calcEndPoint: last action is not known");
        return null;
      }
    } else {
      return null;
    }
  }
}
module.exports = SubAction;

},{"./ActionFunction.js":241}],259:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var TableLayoutComponent = require("./TableLayoutComponent.js");
/**
 * @class TableGridLayout
 * @description //TODO:
 * @param {Array} pTableLayout  
 * @param {String} pRowClasses
 * @param {String} pRootClasses
 * @param {String} pChildrenOverflow
 */
var TableGridLayout = function TableGridLayout(pTableLayout, pRowClasses, pRootClasses, pChildrenOverflow, pTableWidth, pTableHeight) {
  this.table_layout = [];
  this.setTableLayout(pTableLayout);
  this.setRowClasses(pRowClasses);
  this.setRootClasses(pRootClasses);
  this.setChildrenOverflow(pChildrenOverflow);
  this.setTableWidth(pTableWidth);
  this.setTableHeight(pTableHeight);
};
TableGridLayout.fromJSON = function (json) {
  var table_layout = [],
    row_classes,
    root_classes,
    children_overflow,
    table_width,
    table_height;
  if (json && _typeof(json) === "object" && !Array.isArray(json)) {
    table_layout = json.components;
    row_classes = json.row_classes;
    root_classes = json.root_classes;
    children_overflow = json.children_overflow;
    table_width = json.table_width;
    table_height = json.table_height;
  } else if (Array.isArray(json)) {
    table_layout = json;
  } else {
    throw new Error("unknown json format to parse");
  }
  return new TableGridLayout(table_layout, row_classes, root_classes, children_overflow, table_width, table_height);
};
TableGridLayout.createCompatibleLayout = function (pIDs, pRowClasses, pRootClasses) {
  if (Array.isArray(pIDs) === false) {
    throw new Error("parameter pIDs must be a array");
  }
  var table_layout = [];
  for (var i = 0; i < pIDs.length; i++) {
    if (typeof pIDs[i] !== "string" || pIDs[i].length <= 0) {
      throw new Error("the id at " + i + " must be a string");
    }
    table_layout.push(new TableLayoutComponent(pIDs[i], 12, 1, 0, i));
  }
  return new TableGridLayout(table_layout, pRowClasses, pRootClasses);
};
TableGridLayout.fromBootstrap = function (pJSON) {
  var table_layout = [];
  if (Array.isArray(pJSON.rows) === false) {
    throw new Error("TableGridLayout: JSON interface is wrong");
  }
  for (var i = 0; i < pJSON.rows.length; i++) {
    var row = pJSON.rows[i].getElements();
    var xPos = 0;
    for (var j = 0; j < row.length; j++) {
      var component = row[j];
      if (component.isComponent()) {
        table_layout.push({
          "content": component.getID(),
          "width": component.getWidth("md"),
          "height": 1,
          "x_pos": xPos,
          "y_pos": i,
          "isSKip": false
        });
      }
      xPos += component.getWidth("md");
    }
  }
  var layout = TableGridLayout.fromJSON({
    components: table_layout,
    row_classes: null,
    root_classes: null,
    children_overflow: pJSON.getChildrenOverflow(),
    table_width: 12,
    table_height: pJSON.rows.length
  });
  //let the initialiseRows take care of skipcomponents etc
  layout.initialiseRows();
  return layout;
};
TableGridLayout.prototype = {
  constructor: TableGridLayout,
  componentsToBootstrap: function componentsToBootstrap() {
    var rows = [];
    for (var i = 0; i < this.getTableHeight(); i++) {
      var elements = this.getElementsOnRow(i);
      var encounteredIDs = [];
      var newElements = [];
      for (var j = 0; j < elements.length; j++) {
        var element = elements[j];
        if (element.isComponent() === true) {
          encounteredIDs.push(element.getID());
          var _bootstrap = {
            "content": element.getID(),
            "width": {
              "md": element.getWidth()
            }
          };
          newElements.push(_bootstrap);
          continue;
        } else if (element.isSkipComponent() === true && element.isDump() === false) {
          //check if this skip component is for element on this row
          if (encounteredIDs.includes(element.getSkipReference())) {
            //exists on same row, we don't need to push this to the new elements
            continue;
          }
        }
        var bootstrap = {
          "width": {
            "md": 1
          }
        };
        newElements.push(bootstrap);
      }
      rows.push(newElements);
    }
    return rows;
  },
  insertNewComponent: function insertNewComponent(pComponent) {
    var _this = this;
    var that = this;
    if (pComponent instanceof TableLayoutComponent === false) {
      throw new Error("component must be a layoutcomponent");
    }
    var targetHeight = pComponent.getHeight();
    var targetWidth = pComponent.getWidth();
    var updateGrownElements = [];
    var addOnNewRow = false;
    if (this.getTableWidth() < targetWidth + pComponent.getXPos() || this.getTableHeight() < targetHeight + pComponent.getYPos()) {
      addOnNewRow = true;
    }

    //check if there's room on the current rows
    for (var i = 0; i < targetHeight; i++) {
      var elements = this.getElementsOnRow(pComponent.getYPos() + i);
      var dumps = 0;
      for (var j = 0; j < elements.length; j++) {
        if (j > pComponent.getXPos() - 1 && elements[j].isDump()) {
          dumps++;
        }
      }
      if (dumps < targetWidth) {
        addOnNewRow = true;
      }
    }
    if (addOnNewRow === true) {
      //move the component back to the left
      pComponent.setXPos(pComponent.getXPos() - targetWidth);
      pComponent.setYPos(pComponent.getYPos() + targetHeight);
      var amountNewRow = targetHeight;
      if (pComponent.getYPos() === this.getTableHeight()) {
        for (var _i = 0; _i < amountNewRow; _i++) {
          this.addRow();
        }
      } else {
        for (var _i2 = 0; _i2 < amountNewRow; _i2++) {
          var grownElements = this.addRowAtIndex(pComponent.getYPos());
          updateGrownElements = updateGrownElements.concat(grownElements);
        }
      }
    }

    //make skip components
    var height = pComponent.getHeight();
    var width = pComponent.getWidth();
    for (var _i3 = 0; _i3 < height; _i3++) {
      var _loop = function _loop() {
        if (_i3 === 0 && _j === 0) {
          var index = _this.getElement(pComponent.getYPos(), pComponent.getXPos())._index;
          _this.table_layout.splice(index, 0, pComponent);
          //delete the first dump found after xPos of new element
          var _elements = _this.getElementsOnRow(pComponent.getYPos());
          var toDelete;
          _elements.forEach(function (pElement, pIndex) {
            if (pComponent.getXPos() <= pIndex) {
              if (toDelete === undefined) {
                pElement.setXPos(pElement.getXPos() + 1);
                if (pElement.isDump()) {
                  toDelete = pElement._index;
                }
              }
            }
          });
          _this.table_layout.splice(toDelete, 1);
        } else {
          var skipComponent = new TableLayoutComponent(null, 1, 1, pComponent.getXPos() + _j, pComponent.getYPos() + _i3, true, pComponent.getID());
          var _index = _this.getElement(pComponent.getYPos() + _i3, pComponent.getXPos() + _j)._index;
          _this.table_layout.splice(_index, 0, skipComponent);
          //delete the first dump found after xPos of new element
          var _elements2 = _this.getElementsOnRow(skipComponent.getYPos());
          var _toDelete;
          _elements2.forEach(function (pElement, pIndex) {
            if (skipComponent.getXPos() <= pIndex) {
              if (_toDelete === undefined) {
                pElement.setXPos(pElement.getXPos() + 1);
                if (pElement.isDump()) {
                  _toDelete = pElement._index;
                }
              }
            }
          });
          _this.table_layout.splice(_toDelete, 1);
        }
      };
      for (var _j = 0; _j < width; _j++) {
        _loop();
      }
    }
    return {
      overflow: addOnNewRow,
      rowIndex: pComponent.getYPos(),
      indexInRow: pComponent.getXPos(),
      updateElements: Array.from(new Set(updateGrownElements))
    };
  },
  setElement: function setElement(pElement, pXPos, pYPos) {
    if (typeof pXPos !== "number" || isNaN(pXPos) || pXPos < 0 || pXPos > this.getTableWidth()) {
      throw new Error("setElement TableGridLayout: invalid xpos of " + pXPos);
    }
    if (typeof pYPos !== "number" || isNaN(pYPos) || pYPos < 0 || pYPos > this.getTableHeight()) {
      throw new Error("setElement TableGridLayout: invalid yPos of " + pYPos);
    }
    if (pElement instanceof TableLayoutComponent) {
      var index = this.getElement(pYPos, pXPos)._index;
      //ensure correct x and y pos
      pElement.setXPos(pXPos);
      pElement.setYPos(pYPos);
      this.table_layout[index] = pElement;
    } else if ($.isPlainObject(pElement)) {
      var _index2 = this.getElement(pYPos, pXPos)._index;
      //ensure correct x and y pos
      pElement["x_pos"] = pXPos;
      pElement["y_pos"] = pYPos;
      var element = new TableLayoutComponent.fromJSON(pElement);
      this.table_layout[_index2] = element;
    } else {
      throw new Error("setElement: invalid input parameter");
    }
  },
  addRow: function addRow() {
    var tableHeight = this.getTableHeight();
    var tableWidth = this.getTableWidth();
    for (var i = 0; i < tableWidth; i++) {
      this.table_layout.push(new TableLayoutComponent(null, 1, 1, i, tableHeight, false));
    }
    this.setTableHeight(this.getTableHeight() + 1);
  },
  insertRow: function insertRow(pRow, pIndex) {
    if (pIndex === this.getTableHeight()) {
      this.addRow();
      return [];
    } else {
      return this.addRowAtIndex(pIndex);
    }
  },
  insertCol: function insertCol(pIndex) {
    //WIP:
    //TODO: edge case for end of the table -> catch it before this loop
    //TODO: need to make sure addAfterEl & afterEl these are the same reference!
    //TODO: addAfter can also be a component with its skipelement coming after it
    //need to grow the element by 1 and add a skipCell
    if (pIndex > this.getTableWidth() + 1) {
      throw new Error("insertCol: invalid index");
    }
    var elements = this.getTableLayout();
    var insertIndex = pIndex;
    var addedAmount = 0;
    for (var i = 0; i < this.getTableHeight(); i++) {
      var addAfterElement = elements[insertIndex];
      var afterElement = elements[insertIndex + 1];
      if (addAfterElement.isSkipComponent() && afterElement.isSkipComponent() === true) {
        // console.log("add a skip on row " + i);
      } else {
        // console.log("add a dump on row " + i)
      }
      insertIndex += this.getTableWidth() + addedAmount;
    }
  },
  addRowAtIndex: function addRowAtIndex(index) {
    var that = this;
    var currentRowElements = this.getElementsOnRow(index);
    var newRowElements = [];
    var growElements = [];
    var knownGrowElements = [];
    for (var i = 0; i < currentRowElements.length; i++) {
      var element = currentRowElements[i].clone();
      element.setDump(true);
      element.setHeight(1);
      element.setWidth(1);
      if (element.isSkipComponent() === true) {
        var elementAbove = this.getElement(index - 1 > 0 ? index - 1 : 0, element.getXPos());
        if (elementAbove.isDump() === true || elementAbove.isSkipComponent() === false && elementAbove.isDump() === false && elementAbove.getID() !== element.getSkipReference() || elementAbove.isSkipComponent() && elementAbove.getSkipReference() !== element.getSkipReference()) {
          element.setIsSkip(false);
          element.setSkipReference(null);
        } else {
          var growElement = void 0;
          if (elementAbove.isSkipComponent()) {
            growElement = this.getComponentByID(elementAbove.getSkipReference());
          } else if (elementAbove.isDump() === false && elementAbove.isSkipComponent() === false) {
            growElement = elementAbove;
          }
          if (growElement !== undefined && knownGrowElements.includes(growElement.getID()) === false) {
            growElements.push(growElement);
            knownGrowElements.push(growElement.getID());
          }
        }
      }
      newRowElements.push(element);
    }
    growElements.forEach(function (pGrowMe) {
      pGrowMe.setHeight(pGrowMe.getHeight() + 1);
    });
    //raise all yPos of rows we're adding before
    for (var _i4 = index; _i4 < this.getTableHeight(); _i4++) {
      var elements = this.getElementsOnRow(_i4);
      elements.forEach(function (pElement) {
        pElement.setYPos(pElement.getYPos() + 1);
      });
    }
    newRowElements.reverse();
    newRowElements.forEach(function (pElement) {
      that.table_layout.splice(currentRowElements[0]._index, 0, pElement);
    });
    this.setTableHeight(this.getTableHeight() + 1);
    return knownGrowElements;
  },
  changeAllToDeviceClass: function changeAllToDeviceClass() {},
  moveRowWIP: function moveRowWIP(pFromIndex, pToIndex) {
    var isToTop = pFromIndex < pToIndex;
    var elements = this.getElementsOnRow(pFromIndex);
    var tallestHeight = 1;
    var encounteredIDs = [];
    var shrunkComponentIDs = [];
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      if (element.isSkipComponent() === true && encounteredIDs.includes(element.getSkipReference()) === false && shrunkComponentIDs.includes(element.getSkipReference()) === false) {
        //this is a skip component for a component higher up, shrink it by one
        shrunkComponentIDs.push(element.getSkipReference());
        var reference = this.getComponentByID(element.getSkipReference());
        reference.setHeight(reference.getHeight() - 1);
        element.setIsSkip(false);
      } else if (element.isComponent() === true) {
        encounteredIDs.push(element.getID());
        if (tallestHeight < element.getHeight()) {
          tallestHeight = element.getHeight();
        }
        var height = element.getHeight();
        var width = element.getWidth();
        if (element.getHeight() > 1) {
          for (var xPos = element.getXPos(); xPos < element.getXPos() + width; xPos++) {
            for (var yPos = element.getYPos() + 1; yPos < element.getYPos() + height; yPos++) {
              var skipElement = this.getElement(yPos, xPos);
              if (skipElement.isSkipComponent() === false || skipElement.getSkipReference() !== element.getID()) {
                throw new Error("moverow: editing an element that's not a skipelement");
              }
              skipElement.setIsSkip(false);
            }
          }
        }
      }
    }
    //move the elements - shrink the elements that have grow up until above 
    //TODO: moved to the end of the table
    var grownElementsIDs = this.addRowAtIndex(pToIndex + 1);
    for (var _i5 = 0; _i5 < grownElementsIDs.length; _i5++) {
      //check how much we need to shrink the element
      var _element = this.getComponentByID(grownElementsIDs[_i5]);
      var _yPos = _element.getYPos();
      var _height = _element.getHeight();
      var lastRowIndexOfElement = _yPos + _height - 1;
      var shrinkAmount = lastRowIndexOfElement - pToIndex - 1;
      this.resizeToTop(grownElementsIDs[_i5], -shrinkAmount);
    }
    //add extra row(s) for elements that span multiple
    //set correct skip components for these elements
    //?? see if the yPos of components need changing
  },

  removeRow: function removeRow(pIndex) {
    var that = this;
    var tallestHeight = 1;
    var elements = this.getElementsOnRow(pIndex);
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].isComponent()) {
        if (tallestHeight < elements[i].getHeight()) {
          tallestHeight = elements[i].getHeight();
        }
        this.replaceByDummy(elements[i].getID(), 1, false);
      }
    }
    //update the elements - see if we need to shrink some
    elements = this.getElementsOnRow(pIndex);
    //check after having removed the elements (and possible skips) on the row itself, if there's still skips from others
    var shrunkComponents = [];
    for (var _i6 = 0; _i6 < elements.length; _i6++) {
      if (elements[_i6].isSkipComponent()) {
        var reference = this.getComponentByID(elements[_i6].getSkipReference());
        if (shrunkComponents.includes(reference.getID()) === false) {
          reference.setHeight(reference.getHeight() - 1);
          shrunkComponents.push(elements[_i6].getSkipReference());
        }
        elements[_i6].setIsSkip(false);
        elements[_i6].setDump(true);
      }
    }
    //update again
    elements = this.getElementsOnRow(pIndex);
    elements.reverse().forEach(function (pElement) {
      that.table_layout.splice(pElement._index, 1);
    });
    //raise all yPos of rows we're adding before
    for (var _i7 = pIndex + 1; _i7 < this.getTableHeight(); _i7++) {
      var _elements3 = this.getElementsOnRow(_i7);
      _elements3.forEach(function (pElement) {
        pElement.setYPos(pElement.getYPos() - 1);
      });
    }
    this.setTableHeight(this.getTableHeight() - 1);
    return {
      updateAmount: tallestHeight,
      shrunk: shrunkComponents
    };
  },
  _shrink: function _shrink(pTableLayoutComponent) {
    //TODO: move to tableLayoutComponent.js
    if (pTableLayoutComponent.getHeight() !== 1) {
      //only shrink if we can shrink more
      pTableLayoutComponent.setHeight(pTableLayoutComponent.getHeight() - 1);
    }
    if (pTableLayoutComponent.getWidth() !== 1) {
      pTableLayoutComponent.setWidth(pTableLayoutComponent.getWidth() - 1);
    }
    return pTableLayoutComponent;
  },
  _isColliding: function _isColliding(pCheckArr, pCoordsArr) {
    var stringifiedCoords = pCoordsArr.map(function (r) {
      return r = JSON.stringify(r);
    });
    var stringifiedCheck = pCheckArr.map(function (r) {
      return r = JSON.stringify(r);
    });
    return stringifiedCoords.some(function (r) {
      return stringifiedCheck.includes(r);
    });
  },
  getTypePath: function getTypePath() {
    return "tableGrid";
  },
  setTableLayout: function setTableLayout(pTableLayoutComponents) {
    if (!Array.isArray(pTableLayoutComponents)) {
      throw new Error("table layout must be a array");
    }
    if (pTableLayoutComponents[0] instanceof TableLayoutComponent) {
      this.table_layout = pTableLayoutComponents;
    } else if (_typeof(pTableLayoutComponents[0]) === "object" && Array.isArray(pTableLayoutComponents[0]) === false) {
      pTableLayoutComponents = pTableLayoutComponents.map(function (pJSON) {
        return TableLayoutComponent.fromJSON(pJSON);
      });
      this.table_layout = pTableLayoutComponents;
    }
  },
  getTableLayout: function getTableLayout() {
    return this.table_layout;
  },
  setRowClasses: function setRowClasses(pRowClasses) {
    if (typeof pRowClasses === "string" && pRowClasses.length > 0) {
      this.row_classes = pRowClasses;
    } else {
      this.row_classes = null;
    }
  },
  getRowClasses: function getRowClasses() {
    return this.row_classes;
  },
  setRootClasses: function setRootClasses(pRootClasses) {
    if (typeof pRootClasses === "string" && pRootClasses.length > 0) {
      this.root_classes = pRootClasses;
    } else {
      this.root_classes = null;
    }
  },
  getRootClasses: function getRootClasses() {
    return this.root_classes;
  },
  setChildrenOverflow: function setChildrenOverflow(pOverflow) {
    if (pOverflow === undefined || pOverflow === null || pOverflow === "" || pOverflow === "visible") {
      this.children_overflow = "visible";
    } else if (pOverflow === "hidden") {
      this.children_overflow = "hidden";
    } else if (pOverflow === "auto") {
      this.children_overflow = "auto";
    } else {
      throw new Error("invalid children overflow value");
    }
  },
  getChildrenOverflow: function getChildrenOverflow() {
    return this.children_overflow;
  },
  compress: function compress() {
    this.setTableLayout(this.getTableLayout().filter(function (pEl) {
      if (pEl.isSkipComponent() === false && pEl.isDump() === false) {
        return pEl;
      }
    }));
  },
  getComponentByID: function getComponentByID(pID) {
    if (typeof pID !== "string" || typeof pID === "string" && pID.length <= 0) {
      throw new Error("TableGridLayout - getComponentByID: id must be a string");
    }
    if (Array.isArray(this.table_layout) && this.table_layout.length > 0) {
      for (var i = 0; i < this.table_layout.length; i++) {
        var component = this.table_layout[i];
        if (component.getID() === pID) {
          return component;
        }
      }
    }
    return null;
  },
  changeComponentIDs: function changeComponentIDs(pTranslatedIDs) {
    if (Array.isArray(this.table_layout) && this.table_layout.length > 0) {
      for (var i = 0; i < this.table_layout.length; i++) {
        var currentID = this.table_layout[i].getID();
        if (typeof currentID === "string" && currentID.length > 0 && typeof pTranslatedIDs[currentID] === "string") {
          this.table_layout[i].setID(pTranslatedIDs[currentID]);
        }
      }
    }
  },
  removeElementByID: function removeElementByID(pElementID) {
    var ids = [];
    var toRemove = [];
    if (Array.isArray(this.table_layout) && this.table_layout.length > 0) {
      for (var i = 0; i < this.table_layout.length; i++) {
        var component = this.table_layout[i];
        if (component.getID() === pElementID) {
          toRemove.push(i);
          ids.push(pElementID);
        }
      }
    }
    if (toRemove.length > 0) {
      for (var i = this.table_layout.length - 1; i > -1; i--) {
        if (toRemove.includes(i) === true) {
          this.table_layout.splice(i, 1);
        }
      }
    }
    return ids;
  },
  getAllItemIDs: function getAllItemIDs() {
    var ids = [];
    if (Array.isArray(this.table_layout) && this.table_layout.length > 0) {
      for (var i = 0; i < this.table_layout.length; i++) {
        if (typeof this.table_layout[i].getID() === "string") {
          ids.push(this.table_layout[i].getID());
        }
      }
    }
    return ids;
  },
  getFullAreaScopes: function getFullAreaScopes() {
    return [];
  },
  clone: function clone() {
    return TableGridLayout.fromJSON(this.toJSON());
  },
  setTableWidth: function setTableWidth(pTableWidth) {
    this.table_width = pTableWidth;
  },
  getTableWidth: function getTableWidth() {
    if (typeof this.table_width === "number") {
      return this.table_width;
    } else {
      this.setTableWidth(12);
      return this.getTableWidth();
    }
  },
  setTableHeight: function setTableHeight(pTableHeight) {
    this.table_height = pTableHeight;
  },
  getTableHeight: function getTableHeight() {
    if (typeof this.table_height === "number") {
      return this.table_height;
    } else {
      this.setTableHeight(3);
      return this.getTableHeight();
    }
  },
  initialiseRows: function initialiseRows() {
    var tableWidth = this.getTableWidth();
    var tableHeight = this.getTableHeight();
    var table = document.createElement("table");
    for (var i = 0; i < tableHeight; i++) {
      var row = document.createElement("tr");
      table.append(row);
      for (var j = 0; j < tableWidth; j++) {
        var td = document.createElement("td");
        var container = document.createElement("div");
        td.append(container);
        row.append(td);
      }
    }
    var components = this.getTableLayout();
    var _loop2 = function _loop2() {
      var pLayoutComponent = components[_i8];
      if (pLayoutComponent.isDump() === true) {
        return "continue";
      }
      var yPos = pLayoutComponent.getYPos();
      var xPos = pLayoutComponent.getXPos();
      if (table.rows[yPos] === undefined) {
        console.error("Component " + pLayoutComponent.getID() + " is out of bounds - did not add");
        return "continue";
      }
      if (table.rows[yPos].cells[xPos] === undefined) {
        console.error("Component " + pLayoutComponent.getID() + " is out of bounds - did not add");
        return "continue";
      }
      var cellToInsertInto = table.rows[yPos].cells[xPos];
      var width = pLayoutComponent.getWidth();
      var height = pLayoutComponent.getHeight();
      for (var _i10 = 0; _i10 < height; _i10++) {
        var currentRow = table.rows[yPos + _i10];
        var toSkip = [];
        for (var _j3 = 0; _j3 < width; _j3++) {
          if (currentRow.cells[xPos + _j3] !== undefined && currentRow.cells[xPos + _j3] !== cellToInsertInto) {
            toSkip.push(currentRow.cells[xPos + _j3]);
          }
        }
        toSkip.forEach(function (pCell) {
          pCell.classList.add("skipCell");
          pCell.setAttribute("data-reference-element", pLayoutComponent.getID());
        });
      }

      //make space for the layoutComponents;
      cellToInsertInto.removeChild(cellToInsertInto.querySelector("div"));
      var container = document.createElement("div");
      container.setAttribute("data-id", pLayoutComponent.getID());
      cellToInsertInto.append(container);
      cellToInsertInto.setAttribute("colSpan", width);
      cellToInsertInto.setAttribute("rowSpan", height);
    };
    for (var _i8 = 0; _i8 < components.length; _i8++) {
      var _ret = _loop2();
      if (_ret === "continue") continue;
    }
    var layout = [];
    for (var _i9 = 0; _i9 < table.rows.length; _i9++) {
      for (var _j2 = 0; _j2 < table.rows[_i9].cells.length; _j2++) {
        if (Array.from(table.rows[_i9].cells[_j2].classList).includes("skipCell") === true) {
          var width = 1;
          var height = 1;
          var xPos = _j2;
          var yPos = _i9;
          var id = null;
          var isSkip = true;
          var skipReference = table.rows[_i9].cells[_j2].getAttribute("data-reference-element");
          layout.push(new TableLayoutComponent(id, width, height, xPos, yPos, isSkip, skipReference));
        } else {
          var _width = table.rows[_i9].cells[_j2].colSpan;
          var _height2 = table.rows[_i9].cells[_j2].rowSpan;
          var _xPos = _j2;
          var _yPos2 = _i9;
          var _id = void 0;
          var _isSkip = false;
          var _skipReference = null;
          if (table.rows[_i9].cells[_j2].querySelector("div[data-id]") !== null) {
            _id = table.rows[_i9].cells[_j2].querySelector("div[data-id]").getAttribute("data-id");
          } else {
            _id = null;
          }
          layout.push(new TableLayoutComponent(_id, _width, _height2, _xPos, _yPos2, _isSkip, _skipReference));
        }
      }
    }
    this.setTableLayout(layout);
  },
  getElement: function getElement(yPos, xPos) {
    var components = this.getTableLayout();
    var tree = {};
    components.forEach(function (pLayoutComponent, index) {
      var yPos = pLayoutComponent.getYPos();
      var xPos = pLayoutComponent.getXPos();
      if (tree[yPos] === undefined) {
        tree[yPos] = {};
      }
      if (tree[yPos][xPos] === undefined) {
        tree[yPos][xPos] = {};
      }
      tree[yPos][xPos] = pLayoutComponent;
      tree[yPos][xPos]._index = index;
    });
    return tree[yPos][xPos];
  },
  getElementsOnRow: function getElementsOnRow(pRowIndex) {
    var components = this.getTableLayout();
    var tree = {};
    components.forEach(function (pLayoutComponent, pIndex) {
      var yPos = pLayoutComponent.getYPos();
      var xPos = pLayoutComponent.getXPos();
      if (tree[yPos] === undefined) {
        tree[yPos] = {};
      }
      if (tree[yPos][xPos] === undefined) {
        tree[yPos][xPos] = {};
      }
      tree[yPos][xPos] = pLayoutComponent;
      tree[yPos][xPos]._index = pIndex;
    });
    return Object.values(tree[pRowIndex]);
  },
  getIndexComponent: function getIndexComponent(pComponentID) {
    var component = this.getComponentByID(pComponentID);
    return component.getXPos();
  },
  resizeToLeft: function resizeToLeft(pComponentID, pResizeAmount) {
    var component = this.getComponentByID(pComponentID);
    var height = component.getHeight();
    var width = component.getWidth();
    var yPos = component.getYPos();
    var xPos = component.getXPos();
    if (pResizeAmount < 0) {
      var widthShifted = 0;
      var amountRemoveDummys = 0;
      var resizeAmount = Math.abs(pResizeAmount);
      for (var i = xPos; i < xPos + resizeAmount; i++) {
        for (var j = 0; j < height; j++) {
          var newElement = this.getElement(yPos + j, i).clone();
          newElement.setDump(true);
          newElement.setWidth(1);
          newElement.setHeight(1);
          newElement.setIsSkip(false);
          newElement.setSkipReference(null);
          this.setElement(newElement, i, yPos + j);
          amountRemoveDummys--;
        }
        widthShifted--;
      }
      var newComponent = component.clone();
      newComponent.setWidth(newComponent.getWidth() + widthShifted);
      this.setElement(newComponent, xPos - widthShifted, yPos);
      return amountRemoveDummys;
    } else if (pResizeAmount > 0) {
      // removing dummys
      var widthShifted = 0;
      var amountRemoveDummys = 0;
      for (var i = xPos - 1; i >= 0; i--) {
        var canGrow = true;
        for (var _j4 = 0; _j4 < height; _j4++) {
          if (widthShifted === pResizeAmount || this.getElement(yPos + _j4, i).isDump() === false || this.getElement(yPos + _j4, i).isSkipComponent() === true || this.getElement(yPos + _j4, i).getWidth() > pResizeAmount - widthShifted) {
            canGrow = false;
          }
        }
        if (canGrow) {
          for (var _j5 = 0; _j5 < height; _j5++) {
            var element = this.getElement(yPos + _j5, i);
            var _newElement = this.getElement(yPos + _j5, i).clone();
            _newElement.setIsSkip(true);
            _newElement.setSkipReference(pComponentID);
            this.setElement(_newElement, i, yPos + _j5);
            amountRemoveDummys--;
          }
          widthShifted++;
        } else {
          break;
        }
      }
      var _newComponent = component.clone();
      this.replaceByDummy(component.getID(), 1, true);
      _newComponent.setWidth(_newComponent.getWidth() + widthShifted);
      this.setElement(_newComponent, _newComponent.getXPos() - widthShifted, yPos);
      return amountRemoveDummys;
    }
  },
  resizeToRight: function resizeToRight(pComponentID, pResizeAmount) {
    var component = this.getComponentByID(pComponentID);
    var height = component.getHeight();
    var width = component.getWidth();
    var yPos = component.getYPos();
    var xPos = component.getXPos();
    if (pResizeAmount < 0) {
      var widthShifted = 0;
      var amountRemoveDummys = 0;
      for (var i = xPos + width - 1; i > xPos + width + pResizeAmount - 1; i--) {
        for (var j = 0; j < height; j++) {
          var newElement = this.getElement(yPos + j, i).clone();
          newElement.setIsSkip(false);
          newElement.setSkipReference(null);
          this.setElement(newElement, i, yPos + j);
          amountRemoveDummys--;
        }
        widthShifted--;
      }
      var newComponent = component.clone();
      newComponent.setWidth(newComponent.getWidth() + widthShifted);
      this.setElement(newComponent, xPos, yPos);
      return amountRemoveDummys;
    } else if (pResizeAmount > 0) {
      // removing dummys
      var widthShifted = 0;
      var amountRemoveDummys = 0;
      for (var i = xPos + width; i < pResizeAmount + width + xPos; i++) {
        var canGrow = true;
        for (var _j6 = 0; _j6 < height; _j6++) {
          if (widthShifted === pResizeAmount || this.getElement(yPos + _j6, i).isDump() === false || this.getElement(yPos + _j6, i).isSkipComponent() === true || this.getElement(yPos + _j6, i).getWidth() > pResizeAmount - widthShifted) {
            canGrow = false;
          }
        }
        if (canGrow) {
          for (var _j7 = 0; _j7 < height; _j7++) {
            var _newElement2 = this.getElement(yPos + _j7, i).clone();
            _newElement2.setIsSkip(true);
            _newElement2.setSkipReference(pComponentID);
            this.setElement(_newElement2, i, yPos + _j7);
            amountRemoveDummys++;
          }
          widthShifted++;
        } else {
          break;
        }
      }
      var _newComponent2 = component.clone();
      this.replaceByDummy(component.getID(), 1, true);
      _newComponent2.setWidth(_newComponent2.getWidth() + widthShifted);
      this.setElement(_newComponent2, xPos, yPos);
      return amountRemoveDummys;
    }
  },
  resizeToTop: function resizeToTop(pComponentID, pResizeAmount) {
    var component = this.getComponentByID(pComponentID);
    var yPos = component.getYPos();
    var xPos = component.getXPos();
    var width = component.getWidth();
    if (pResizeAmount < 0) {
      var heightShifted = 0;
      var amountRemoveDummys = 0;
      for (var i = yPos; i < yPos + Math.abs(pResizeAmount); i++) {
        for (var j = xPos; j < xPos + width; j++) {
          var newElement = this.getElement(i, j).clone();
          newElement.setDump(true);
          newElement.setWidth(1);
          newElement.setHeight(1);
          newElement.setIsSkip(false);
          newElement.setSkipReference(null);
          this.setElement(newElement, j, i);
          amountRemoveDummys--;
        }
        heightShifted++;
      }
      var newComponent = component.clone();
      newComponent.setHeight(newComponent.getHeight() - heightShifted);
      this.setElement(newComponent, xPos, yPos + heightShifted);
      return heightShifted;
    } else if (pResizeAmount > 0) {
      // removing dummys
      var heightShifted = 0;
      var amountRemoveDummys = 0;
      for (var i = yPos - 1; i >= 0; i--) {
        var canGrow = true;
        for (var _j8 = 0; _j8 < width; _j8++) {
          if (pResizeAmount === heightShifted || this.getElement(i, xPos + _j8).isDump() === false || this.getElement(i, xPos + _j8).getHeight() > pResizeAmount - heightShifted) {
            canGrow = false;
          }
        }
        if (canGrow) {
          for (var _j9 = 0; _j9 < width; _j9++) {
            var element = this.getElement(i, xPos + _j9);
            var _newElement3 = element.clone();
            _newElement3.setIsSkip(true);
            _newElement3.setSkipReference(pComponentID);
            this.setElement(_newElement3, xPos + _j9, i);
            amountRemoveDummys++;
          }
          heightShifted++;
        } else {
          break;
        }
      }
      var _newComponent3 = component.clone();
      this.replaceByDummy(component.getID(), 1, true);
      _newComponent3.setHeight(_newComponent3.getHeight() + heightShifted);
      this.setElement(_newComponent3, xPos, _newComponent3.getYPos() - heightShifted);
      return -heightShifted;
    }
  },
  resizeToBottom: function resizeToBottom(pComponentID, pResizeAmount) {
    var component = this.getComponentByID(pComponentID);
    var yPos = component.getYPos();
    var xPos = component.getXPos();
    var width = component.getWidth();
    var height = component.getHeight();
    if (pResizeAmount < 0) {
      var heightShifted = 0;
      var amountRemoveDummys = 0;
      for (var i = yPos + height - 1; i > yPos + height - 1 - Math.abs(pResizeAmount); i--) {
        for (var j = xPos; j < xPos + width; j++) {
          var newElement = this.getElement(i, j).clone();
          newElement.setDump(true);
          newElement.setWidth(1);
          newElement.setHeight(1);
          newElement.setIsSkip(false);
          newElement.setSkipReference(null);
          this.setElement(newElement, j, i);
          amountRemoveDummys--;
        }
        heightShifted++;
      }
      var newComponent = component.clone();
      newComponent.setHeight(newComponent.getHeight() - heightShifted);
      this.setElement(newComponent, xPos, yPos);
      return heightShifted;
    } else if (pResizeAmount > 0) {
      // removing dummys
      var heightShifted = 0;
      var amountRemoveDummys = 0;
      for (var i = yPos + height; i < yPos + height + pResizeAmount; i++) {
        var canGrow = true;
        if (i > this.getTableHeight() - 1) {
          //trying to resize to a non-existent row, we can't grow more!
          canGrow = false;
        } else {
          for (var _j10 = 0; _j10 < width; _j10++) {
            if (pResizeAmount === heightShifted || this.getElement(i, xPos + _j10).isDump() === false || this.getElement(i, xPos + _j10).getHeight() > pResizeAmount - heightShifted) {
              canGrow = false;
            }
          }
        }
        if (canGrow) {
          for (var _j11 = 0; _j11 < width; _j11++) {
            var element = this.getElement(i, xPos + _j11);
            var _newElement4 = element.clone();
            _newElement4.setIsSkip(true);
            _newElement4.setSkipReference(pComponentID);
            this.setElement(_newElement4, xPos + _j11, i);
            amountRemoveDummys++;
          }
          heightShifted++;
        } else {
          break;
        }
      }
      var _newComponent4 = component.clone();
      this.replaceByDummy(component.getID(), 1, true);
      _newComponent4.setHeight(_newComponent4.getHeight() + heightShifted);
      this.setElement(_newComponent4, xPos, yPos);
      return -heightShifted;
    }
  },
  insertElement: function insertElement(pElement, pXPos, pYPos) {
    var existing = this.getElement(pYPos, pXPos);
    if (existing === undefined) {
      this.getTableLayout().push(pElement);
    } else {
      this.getTableLayout()[existing._index] = pElement;
    }
  },
  replaceByDummy: function replaceByDummy(pComponentID, pDummyWidth, isSkips) {
    var skip = isSkips === true;
    var reference = skip ? pComponentID : null;
    var component = this.getComponentByID(pComponentID);
    var componentIndex = this.getIndexComponent(pComponentID);
    var rowIndex = component.getYPos();
    var originalWidth = component.getWidth();
    var originalHeight = component.getHeight();
    var dummy = new TableLayoutComponent(null, pDummyWidth, 1, componentIndex, rowIndex, skip, reference);
    this.setElement(dummy, componentIndex, rowIndex);
    var dummies = 1;
    for (var row = 0; row < originalHeight; row++) {
      for (var i = 0; i < originalWidth / pDummyWidth; i++) {
        if (row === 0 && i === 0) {
          //skip the top left cell
          continue;
        }
        var newDummy = dummy.clone();
        newDummy.setXPos(componentIndex + i);
        this.setElement(newDummy, componentIndex + i, rowIndex + row);
        dummies++;
      }
    }
    return dummies;
  },
  getRow: function getRow() {
    //do not remove
  },
  _hasExtraOptions: function _hasExtraOptions() {
    return typeof this.row_classes === "string" && this.row_classes.length > 0 || typeof this.root_classes === "string" && this.root_classes.length > 0 || this.children_overflow !== "visible" || this.table_height !== undefined || this.table_height !== null || this.table_width !== undefined || this.table_width !== null;
  },
  guestDeviceClass: function guestDeviceClass() {
    return;
  },
  toJSON: function toJSON() {
    var components = [];
    for (var i = 0; i < this.table_layout.length; i++) {
      components.push(this.table_layout[i].toJSON());
    }
    if (this._hasExtraOptions()) {
      return {
        components: components,
        row_classes: this.getRowClasses(),
        root_classes: this.getRootClasses(),
        children_overflow: this.getChildrenOverflow(),
        table_height: this.getTableHeight(),
        table_width: this.getTableWidth()
      };
    } else {
      return components;
    }
  }
};
module.exports = TableGridLayout;

},{"./TableLayoutComponent.js":260}],260:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/** 
 * @constructor TableLayoutComponent
 * @description Represents a place in the layout, is a child of {@link TableGridLayout}
 * @param {String} id - The id of the layout part, use null if the part is empty
 * @param {Number|Object} width - The width settings for the layout part
 */
var TableLayoutComponent = function TableLayoutComponent(id, width, height, xPos, yPos, isSkip, skipReference) {
  this.content = null;
  if (typeof id === "string" && id.length > 0) {
    isSkip = false;
    this.content = id;
  }
  this.width = {};
  if (typeof width === "number") {
    this.setWidth(width);
  } else {
    throw new Error("width has wrong interface");
  }
  this.height = {};
  if (typeof height === "number") {
    this.setHeight(height);
  } else {
    throw new Error("height has wrong interface");
  }
  if (typeof xPos === "number") {
    this.setXPos(xPos);
  } else {
    throw new Error("xPos has wrong interface");
  }
  if (typeof yPos === "number") {
    this.setYPos(yPos);
  } else {
    throw new Error("yPos has wrong interface");
  }
  if (typeof isSkip === "boolean") {
    this.setIsSkip(isSkip);
  } else {
    throw new Error("isSkip has wrong interface");
  }
  this.skipReference = null;
  if (typeof skipReference === "string" && skipReference.length > 0) {
    this.setSkipReference(skipReference);
  }
};
TableLayoutComponent.fromJSON = function (json) {
  if (_typeof(json) !== "object" || json === null) {
    throw new Error("invalid parameter");
  }
  var id, width, height, xPos, yPos, isSkip, skipReference;
  if (json && _typeof(json) === "object" && !Array.isArray(json)) {
    id = json.content;
    width = json.width;
    height = json.height;
    xPos = json.x_pos;
    yPos = json.y_pos;
    isSkip = json.isSkip;
    skipReference = json.skipReference;
  } else {
    throw new Error("unknown json format to parse");
  }
  var layout = new TableLayoutComponent(id, width, height, xPos, yPos, isSkip, skipReference);
  return layout;
};
TableLayoutComponent.canMerge = function (a, b) {
  if (a.isDump() === false || b.isDump() === false) {
    return false;
  }
  return true;
};
TableLayoutComponent.merge = function (a, b) {
  var width;
  var height;
  // we suppose a and b can be merged
  // we suppose that merged dump is at position 
  if (typeof a.getWidth() === "number" && typeof b.getWidth() === "number" && typeof a.getHeight() === "number" && typeof b.getHeight() === "number") {
    width = a.getWidth() + b.getWidth();
    height = a.getHeight() + b.getHeight();
  }
  return new TableLayoutComponent(null, width, height, a.getXPos(), a.getYPos(), false);
};
TableLayoutComponent.prototype = {
  constructor: TableLayoutComponent,
  getID: function getID() {
    return this.content;
  },
  setID: function setID(pID) {
    if (typeof pID !== "string" || pID.length <= 0) {
      throw new Error('id parameter must be a not empty string');
    }
    this.content = pID;
  },
  getWidth: function getWidth() {
    return this.width;
  },
  setWidth: function setWidth(pWidth) {
    if (typeof pWidth !== "number") {
      throw new Error("parameter pWidth must be a number");
    }
    this.width = pWidth;
  },
  setHeight: function setHeight(pHeight) {
    if (typeof pHeight !== "number") {
      throw new Error("parameter pHeight must be a number");
    }
    this.height = pHeight;
  },
  getHeight: function getHeight() {
    return this.height;
  },
  setYPos: function setYPos(pYPos) {
    this.yPos = pYPos;
  },
  setXPos: function setXPos(pXPos) {
    this.xPos = pXPos;
  },
  getXPos: function getXPos() {
    return this.xPos;
  },
  getYPos: function getYPos() {
    return this.yPos;
  },
  isSkipComponent: function isSkipComponent() {
    return this.isSkip;
  },
  setIsSkip: function setIsSkip(pIsSkip) {
    if (pIsSkip === false) {
      this.setSkipReference(null);
    }
    this.isSkip = pIsSkip;
  },
  setSkipReference: function setSkipReference(pSkipReference) {
    this.skipReference = pSkipReference;
  },
  getSkipReference: function getSkipReference() {
    return this.skipReference;
  },
  getCoordsArray: function getCoordsArray() {
    var arr = [];
    for (var i = this.yPos; i < this.height + this.yPos; ++i) {
      for (var j = this.xPos; j < this.width + this.xPos; ++j) {
        arr.push([j, i]);
      }
    }
    return arr;
  },
  isDump: function isDump() {
    return this.content === null && this.isSkip === false;
  },
  setDump: function setDump(pDump) {
    if (pDump === true) {
      this.content = null;
    }
  },
  isComponent: function isComponent() {
    return typeof this.content === "string" && this.content.length > 0;
  },
  clone: function clone() {
    return TableLayoutComponent.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = {};
    if (typeof this.content === "string" && this.content.length > 0) {
      outputJSON.content = this.content;
    }
    outputJSON.width = this.width;
    outputJSON.height = this.height;
    outputJSON.x_pos = this.xPos;
    outputJSON.y_pos = this.yPos;
    outputJSON.isSkip = this.isSkip;
    outputJSON.skipReference = this.skipReference;
    return outputJSON;
  }
};
module.exports = TableLayoutComponent;

},{}],261:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var WebFramework = function WebFramework() {};

/**
 * Different types of web frameworks
 * @readonly
 * @enum {String}
 */
WebFramework.type = Object.freeze({
  /** jQuery UI Widgets */
  "JQUERY_UI": "jQueryUI",
  /** the native web components */
  "NATIVE_WEBCOMPONENT": "nativeWebComponent",
  /** the React framework */
  "REACT": "React"
});
var dictionary = Object.freeze({
  "jQueryUI": Object.freeze({
    "is_active": function is_active() {
      return window.jQuery !== undefined && window.jQuery.fn !== undefined;
    },
    "is_present": function is_present(pComponentName) {
      return window.jQuery && window.jQuery.fn && jQuery.fn[pComponentName] !== undefined;
    },
    "construct_offline": function construct_offline(pDOMElementSelector, pComponentName, pOptionsVariableName) {
      var pRenderOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (typeof pComponentName !== "string" || pComponentName.length <= 0) {
        throw new Error("parameter pComponentName must be a not empty string");
      }
      var options = Object.assign({
        linePrefix: ""
      }, pRenderOptions);
      return options.linePrefix + "$(\"" + pDOMElementSelector + "\")." + pComponentName + "(" + pOptionsVariableName + ");\r\n";
    },
    "construct_live": function construct_live(pDOMElement, pComponentName, pComponentOptions) {
      var pRenderOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (typeof pComponentName !== "string" || pComponentName.length <= 0) {
        throw new Error("parameter pComponentName must be a not empty string");
      }
      return $(pDOMElement)[pComponentName](pComponentOptions);
    }
  }),
  "nativeWebComponent": Object.freeze({
    "is_active": function is_active() {
      return true;
    },
    "is_present": function is_present(pComponentName) {
      return window.customElements && customElements.get(pComponentName) !== undefined;
    },
    "construct_offline": function construct_offline(pDOMElementSelector, pComponentName, pOptionsVariableName) {
      var pRenderOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (typeof pComponentName !== "string" || pComponentName.length <= 0) {
        throw new Error("parameter pComponentName must be a not empty string");
      }
      var options = Object.assign({
        linePrefix: ""
      }, pRenderOptions);
      var variableName = pComponentName.replace(/[^a-zA-Z]*/g, "") + "ElementDOM";
      var scriptContent = options.linePrefix + "try{\r\n";
      scriptContent += options.linePrefix + "var " + variableName + " = document.createElement(\"" + pComponentName + "\");\r\n";
      scriptContent += options.linePrefix + "document.querySelector(\"" + pDOMElementSelector + "\").getAttributeNames().filter(function(a){return a.indexOf(\"data-\") === 0}).forEach(function(pName){\r\n";
      scriptContent += options.linePrefix + "\t" + variableName + ".setAttribute(pName, pDOMElement.getAttribute(pName))\r\n";
      scriptContent += options.linePrefix + "})\r\n";
      scriptContent += options.linePrefix + variableName + ".id = document.querySelector(\"" + pDOMElementSelector + "\").id;\r\n";
      scriptContent += options.linePrefix + variableName + ".className += document.querySelector(\"" + pDOMElementSelector + "\").className;\r\n";
      scriptContent += options.linePrefix + variableName + ".nixpsSetOptions(" + pOptionsVariableName + ");\r\n";
      scriptContent += options.linePrefix + "if (" + pOptionsVariableName + ".disabled === true) {\r\n";
      scriptContent += options.linePrefix + "\t" + variableName + ".disabled = true;\r\n";
      scriptContent += options.linePrefix + "}\r\n";
      scriptContent += options.linePrefix + "document.querySelector(\"" + pDOMElementSelector + "\").replaceWith(" + variableName + ");\r\n";
      scriptContent += options.linePrefix + "}catch(e){}\r\n";
      return scriptContent;
    },
    "construct_live": function construct_live(pDOMElement, pComponentName, pComponentOptions) {
      var pRenderOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (typeof pComponentName !== "string" || pComponentName.length <= 0) {
        throw new Error("parameter pComponentName must be a not empty string");
      }
      if (!(pDOMElement instanceof HTMLElement)) {
        throw new Error("parameter pDOMElement must be a valid DOM element");
      }
      var newDOMElement = document.createElement(pComponentName);
      pDOMElement.getAttributeNames().filter(function (a) {
        return a.indexOf("data-") === 0;
      }).forEach(function (pName) {
        newDOMElement.setAttribute(pName, pDOMElement.getAttribute(pName));
      });
      newDOMElement.id = pDOMElement.id;
      newDOMElement.className += pDOMElement.className;
      if (pComponentOptions && _typeof(pComponentOptions) === "object") {
        var options = Object.assign({}, pComponentOptions);
        var disabled = options.disabled;
        delete options.disabled;
        newDOMElement.nixpsSetOptions(options);
        if (disabled) {
          newDOMElement.disabled = true;
        }
      }
      return pDOMElement.replaceWith(newDOMElement);
    }
  }),
  "React": Object.freeze({
    "is_active": function is_active() {
      return window.React !== undefined;
    },
    "is_present": function is_present(pComponentName) {
      return false;
    },
    "construct_offline": function construct_offline(pDOMElementSelector, pComponentName, pOptionsVariableName) {
      var pRenderOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (typeof pComponentName !== "string" || pComponentName.length <= 0) {
        throw new Error("parameter pComponentName must be a not empty string");
      }
      var options = Object.assign({
        linePrefix: ""
      }, pRenderOptions);
      throw new Error("not developed yet");
      // let scriptContent = options.linePrefix + "var root = ReactDOM.createRoot(document.querySelector(\"" + pDOMElementSelector + "\"))\r\n";
      // scriptContent += options.linePrefix + "root.render(React.createElement(window.ObjectDetailsPanel, " + pOptionsVariableName + "))\r\n";
      // return scriptContent;
    },

    "construct_live": function construct_live(pDOMElement, pComponentName, pComponentOptions) {
      var pRenderOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (!(pDOMElement instanceof HTMLElement)) {
        throw new Error("parameter pDOMElement must be a valid DOM element");
      }
      var root = window.ReactDOM.createRoot(pDOMElement);
      root.render(window.React.createElement(window.ObjectDetailsPanel, pComponentOptions));
      // return root;
      throw new Error("not developed yet");
    }
  })
});

/**
 * @description Check if the framework is included and active
 * @function
 * @name Framework.isActive
 * @param {String} pFrameworkName The technical name of the framework
 * @returns {Boolean} true if the framework is included and active, false otherwise
 */
WebFramework.isActive = function isActive(pFrameworkName) {
  if (typeof pFrameworkName !== "string" || pFrameworkName.length <= 0) {
    throw new Error("parameter pFrameworkName must be a not empty string");
  }
  if (dictionary[pFrameworkName] === undefined) {
    throw new Error("unknown framework, " + pFrameworkName);
  }
  return dictionary[pFrameworkName].is_active();
};
WebFramework.isPresent = function isPresent(pFrameworkName, pComponentName) {
  if (typeof pFrameworkName !== "string" || pFrameworkName.length <= 0) {
    throw new Error("parameter pFrameworkName must be a not empty string");
  }
  if (dictionary[pFrameworkName] === undefined) {
    throw new Error("unknown framework, " + pFrameworkName);
  }
  return dictionary[pFrameworkName].is_present(pComponentName);
};

/**
 * @description Construct a component and returns it in a javascript-code string; 
 * @function
 * @name Framework.constructOffline
 * @param {String} pFrameworkName The technical name of the framework
 * @returns {String} the javascript code that creates that component 
 */
WebFramework.constructOffline = function constructOffline(pFrameworkName) {
  var _dictionary$pFramewor;
  if (typeof pFrameworkName !== "string" || pFrameworkName.length <= 0) {
    throw new Error("parameter pFrameworkName must be a not empty string");
  }
  if (dictionary[pFrameworkName] === undefined) {
    throw new Error("unknown framework, " + pFrameworkName);
  }
  for (var _len = arguments.length, constructArg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    constructArg[_key - 1] = arguments[_key];
  }
  return (_dictionary$pFramewor = dictionary[pFrameworkName]).construct_offline.apply(_dictionary$pFramewor, constructArg);
};

/**
 * @description Construct a component in runtime
 * @function
 * @name Framework.constructLive
 * @param {String} pFrameworkName The technical name of the framework
 * @returns {DOM} the DOMElement
 */
WebFramework.constructLive = function constructLive(pFrameworkName) {
  var _dictionary$pFramewor2;
  if (typeof pFrameworkName !== "string" || pFrameworkName.length <= 0) {
    throw new Error("parameter pFrameworkName must be a not empty string");
  }
  if (dictionary[pFrameworkName] === undefined) {
    throw new Error("unknown framework, " + pFrameworkName);
  }
  for (var _len2 = arguments.length, constructArg = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    constructArg[_key2 - 1] = arguments[_key2];
  }
  return (_dictionary$pFramewor2 = dictionary[pFrameworkName]).construct_live.apply(_dictionary$pFramewor2, constructArg);
};
module.exports = WebFramework;

},{}],262:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @brief an object representing the registered units, private to this scope
 */
var Register = function Register() {
  this.mTable = [];
  this.mDerived = [];
  this.addConversion("m", "mm", 1000);
  this.addConversion("m", "cm", 100);
  this.addConversion("m", "µm", 1000000);
  this.addConversion("in", "cm", 2.54);
  this.addConversion("in", "pt", 72);
  this.addConversion("ft", "in", 12);
  this.addConversion("dpmm", "dpi", 25.4);
  this.addConversion("lpmm", "lpi", 25.4);
  this.addConversion("", "%", 100);
  this.addConversion("m", "s", 60);
  this.addConversion("h", "s", 60 * 60);
  this.addConversion("d", "s", 60 * 60 * 24);
  this.addConversion("h", "m", 60);
  this.addConversion("d", "m", 60 * 24);
  this.addConversion("d", "h", 24);
  this.addConversion("KB", "B", 1000);
  this.addConversion("MB", "B", 1000000);
  this.addConversion("GB", "B", 1000000000);
  this.addDerived("m2", "m", 2);
  this.addDerived("cm2", "cm", 2);
  this.addDerived("mm2", "mm", 2);
  this.addDerived("µm2", "µm", 2);
  this.addDerived("in2", "in", 2);
  this.addDerived("pt2", "pt", 2);
  this.addDerived("ft2", "ft", 2);
  this._processConversions();
  this._calculateKnownUnits();
};
Register.prototype = {
  constructor: Register,
  /**
   * @brief returns a list of all known units
   */
  getUnits: function getUnits() {
    if (this.knownUnits === undefined) {
      this._calculateKnownUnits();
    }
    return this.knownUnits;
  },
  _calculateKnownUnits: function _calculateKnownUnits() {
    var fromUnits = this.mTable.map(function (pEntry) {
      return pEntry.from;
    });
    var toUnits = this.mTable.map(function (pEntry) {
      return pEntry.to;
    });
    if (window._ === undefined) {
      this.knownUnits = Array.from(new Set([].concat(_toConsumableArray(fromUnits), _toConsumableArray(toUnits))));
    } else {
      this.knownUnits = _.uniq(_.union(fromUnits, toUnits));
    }
  },
  /**
   * @brief processes the conversions
   */
  _processConversions: function _processConversions() {
    var addedConversions = false;
    var units = this.getUnits();
    do {
      addedConversions = false;
      for (var i = 0; i < units.length; i++) {
        for (var j = 0; j < units.length; j++) {
          var from = units[i];
          var to = units[j];
          if (this.hasConversion(from, to) === false) {
            var conversationsFrom = this.getAvailableConversions(from);
            if (!Array.isArray(conversationsFrom)) {
              conversationsFrom = [];
            }
            var conversationsTo = this.getAvailableConversions(to);
            if (!Array.isArray(conversationsTo)) {
              conversationsTo = [];
            }
            var common = conversationsFrom.filter(function (c) {
              return conversationsTo.includes(c);
            });
            if (common.length > 0) {
              var commonUnit = common[0];
              this.addConversion(from, to, this.getConversion(from, commonUnit) * this.getConversion(commonUnit, to));
              addedConversions = true;
            }
          }
        }
      }
    } while (addedConversions);
    for (var i = 0; i < this.mDerived.length; i++) {
      var dA = this.mDerived[i];
      for (var j = i + 1; j < this.mDerived.length; j++) {
        var dB = this.mDerived[j];
        if (dA.power === dB.power) {
          this.addConversion(dA.symbol, dB.symbol, Math.pow(this.getConversion(dA.base, dB.base), dA.power));
        }
      }
    }
  },
  /**
   * @brief adds a conversion to the register, if pAddInverse = false -> no inverse conversion is automatically added
   */
  addConversion: function addConversion(pFrom, pTo, pConversion, pAddInverse) {
    this.mTable.push({
      from: pFrom,
      to: pTo,
      conversion: pConversion
    });
    if (pAddInverse !== false) {
      this.mTable.push({
        to: pFrom,
        from: pTo,
        conversion: 1.0 / pConversion
      });
    }
    delete this.knownUnits;
  },
  /**
   * @brief adds a derived unit
   */
  addDerived: function addDerived(pSymbol, pBase, pPower) {
    this.mDerived.push({
      symbol: pSymbol,
      base: pBase,
      power: pPower
    });
  },
  /**
   * @brief returns the available conversion from that unit
   */
  getAvailableConversions: function getAvailableConversions(pFrom) {
    return this.mTable.filter(function (pEntry) {
      return pEntry.from === pFrom;
    }).map(function (pEntry) {
      return pEntry.to;
    });
  },
  /**
   * @brief returns true if there there a conversion from
   */
  hasConversion: function hasConversion(pFrom, pTo) {
    if (pFrom === pTo && this.getUnits().indexOf(pFrom) >= 0) {
      return true;
    }
    return this.mTable.some(function (pEntry) {
      return pEntry.from === pFrom && pEntry.to === pTo;
    });
  },
  /** 
   * @brief returns the conversion factor between the 2 units
   */
  getConversion: function getConversion(pFrom, pTo) {
    if (pFrom === pTo) {
      return 1.0;
    }
    var matchIndex = this.mTable.findIndex(function (pEntry) {
      return pEntry.from === pFrom && pEntry.to === pTo;
    });
    if (matchIndex === -1) {
      throw new Error("no conversion");
    }
    return this.mTable[matchIndex].conversion;
  }
};

/**
 * @brief the single register instance
 */
var register = new Register();

/**
 * @brief exposes an interface to the registered units
 */
var KnownUnits = function KnownUnits() {
  this.mConversionTable = register;
};
KnownUnits.prototype = {
  constructor: KnownUnits,
  /** 
   * @brief returns true if the unit is metric
   */
  isMetric: function isMetric(pUnitName) {
    if (this.mConversionTable.getUnits().indexOf(pUnitName) < 0) {
      throw new Error("unknown unit");
    }
    return ["mm", "m", "cm", "µm", "dpmm", "lpmm", "m2", "cm2", "mm2", "µm2"].indexOf(pUnitName) >= 0;
  },
  /**
   * @brief returns true if the units imperial
   */
  isImperial: function isImperial(pUnitName) {
    if (this.mConversionTable.getUnits().indexOf(pUnitName) < 0) {
      throw new Error("unknown unit");
    }
    return ["in", "pt", "dpi", "lpi", "ft", "in2", "pt2", "ft2"].indexOf(pUnitName) >= 0;
  },
  /**
   * @brief returns the list of length units
   */
  getLengthUnits: function getLengthUnits() {
    return ["m", "cm", "mm", "µm", "in", "pt", "ft"]; /*�*/
  },

  /**
   * @brief returns the list of resolution units
   */
  getResolutionUnits: function getResolutionUnits() {
    return ["dpmm", "dpi"];
  },
  /**
   * @biref returns the list of ruling units
   */
  getRulingUnits: function getRulingUnits() {
    return ["lpmm", "lpi"];
  },
  /**
   * @biref returns the list of ruling units
   */
  getScalingUnits: function getScalingUnits() {
    return ["", "%"];
  },
  /**
   * @biref returns the list of ruling units
   */
  getDensityUnits: function getDensityUnits() {
    return ["", "%"];
  },
  /**
   * @biref returns the list of font units
   */
  getFontUnits: function getFontUnits() {
    return ["mm", "pt"];
  },
  /**
   * @brief returns a list of all known units
   */
  getUnits: function getUnits() {
    return this.mConversionTable.getUnits();
  },
  /**
   * @brief returns a list of all known units
   */
  isAvailable: function isAvailable(pUnitName) {
    return this.mConversionTable.getUnits().indexOf(pUnitName) >= 0;
  },
  /**
   * @brief returns the available conversion from that unit
   */
  getAvailableConversions: function getAvailableConversions(pFrom) {
    return this.mConversionTable.getAvailableConversions(pFrom);
  },
  /**
   * @brief returns true if there there a conversion from
   */
  hasConversion: function hasConversion(pFrom, pTo) {
    return this.mConversionTable.hasConversion(pFrom, pTo);
  },
  /** 
   * @brief returns the conversion factor between the 2 units
   */
  getConversion: function getConversion(pFrom, pTo) {
    return this.mConversionTable.getConversion(pFrom, pTo);
  },
  /**
   * @brief converts a value from a unit to another (A -> B)
   */
  convert: function convert(pValue, pUnitA, pUnitB) {
    if (typeof pValue !== "number") {
      throw new Error("invalid number");
    }
    if (pUnitA === pUnitB) {
      return pValue;
    }
    if (this.isAvailable(pUnitA) === false) {
      throw new Error("invalid unit: " + pUnitA);
    }
    if (this.isAvailable(pUnitB) === false) {
      throw new Error("invalid unit: " + pUnitB);
    }
    var knownUnits = new KnownUnits();
    var conversionFactor = knownUnits.getConversion(pUnitA, pUnitB);
    return pValue * conversionFactor;
  }
};
module.exports = KnownUnits;

},{}],263:[function(require,module,exports){
"use strict";

var UnitPreferences = require("./UnitPreferences.js");
var systemPreferences = null;
function getSystemPreferences() {
  if (systemPreferences === null) {
    systemPreferences = window.api_sync.preferences.get_for_realm("system", "", "", "units").preferences;
  }
  return systemPreferences;
}

/**
 * @brief the unit preferences of the system
 */
var SystemUnitPreferences = function SystemUnitPreferences() {
  this.mPreferences = getSystemPreferences();
};

// #28451 possible deadlock during opening of Portal pages
// Do not retrieve the preferences if not needed (eg system units)
SystemUnitPreferences.prototype = new UnitPreferences(false);
module.exports = SystemUnitPreferences;

},{"./UnitPreferences.js":265}],264:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var KnownUnits = require("./RegisteredUnits.js");

/**
 * @constructor Unit
 * @brief a unit has a unique name and optionally a accuracy
 */
function Unit(pUnitJSON) {
  if (_typeof(pUnitJSON) !== "object" || pUnitJSON === null) {
    throw new Error("invalid json");
  }
  if (typeof pUnitJSON.unit !== "string") {
    throw new Error("invalid unit name field");
  } else if (pUnitJSON.unit.indexOf("nixps-units.") === 0) {
    // transform translation to unit
    // keep last a-z charaters of the translation string
    pUnitJSON.unit = pUnitJSON.unit.replace(/.*[^a-z]([a-zA-Z]+)$/, "$1");
  }
  if (pUnitJSON.accuracy !== undefined) {
    if (typeof pUnitJSON.accuracy !== "number") {
      throw new Error("invalid accuracy");
    }
  }
  this.mJSON = pUnitJSON;
}
Unit.prototype = {
  constructor: Unit,
  toString: function toString(pValue, pUseNBSP) {
    if (typeof pValue !== "number") {
      throw new Error("invalid number");
    }
    if (this.hasAccuracy()) {
      pValue = pValue.toFixed(this.getAccuracy());
    }
    if (pUseNBSP === true) {
      return pValue + "&nbsp;" + this.mJSON.unit;
    } else {
      return pValue + " " + this.mJSON.unit;
    }
  },
  toStringWithoutUnit: function toStringWithoutUnit(pValue) {
    if (typeof pValue !== "number") {
      throw new Error("invalid number");
    }
    if (this.hasAccuracy()) {
      pValue = pValue.toFixed(this.getAccuracy());
    }
    return pValue;
  },
  toElement: function toElement(pValue) {
    var label = document.createElement("label");
    var text = document.createTextNode("");
    label.appendChild(text);
    if (this.mJSON.unit.endsWith("2")) {
      var strValue = this.toString(pValue);
      text.textContent = strValue.slice(0, -1);
      var sup = document.createElement("sup");
      sup.classList = "cf-sup";
      sup.textContent = 2;
      label.appendChild(sup);
      return label;
    } else {
      text.textContent = this.toString(pValue);
      return label;
    }
  },
  toHTML: function toHTML(pValue) {
    if (this.mJSON.unit.endsWith("2")) {
      var strValue = this.toString(pValue, true);
      return strValue.slice(0, -1) + "<sup class='cf-sup'>2</sup>";
    } else {
      return this.toString(pValue, true);
    }
  },
  getShortName: function getShortName() {
    return this.mJSON.unit;
  },
  getAccuracy: function getAccuracy() {
    if (!this.hasAccuracy()) {
      throw new Error("no accuracy");
    }
    return this.mJSON.accuracy;
  },
  hasAccuracy: function hasAccuracy() {
    return this.mJSON.accuracy !== undefined;
  },
  toFormattedNumber: function toFormattedNumber(pValue) {
    if (typeof pValue !== "number") {
      throw new Error("invalid number");
    }
    if (this.hasAccuracy()) {
      return parseFloat(pValue.toFixed(this.getAccuracy()));
    }
    return pValue;
  },
  convert: function convert(pValue, pUnit) {
    if (typeof pValue !== "number") {
      throw new Error("invalid number");
    }

    // if (!(pUnit instanceof Unit || pUnit instanceof nixps.cloudflow.Unit)) {
    if (typeof pUnit.getShortName !== "function" || typeof pUnit.getShortName() !== "string") {
      throw new Error("invalid unit: " + JSON.stringify(pUnit));
    }
    var knownUnits = new KnownUnits();
    return knownUnits.convert(pValue, this.getShortName(), pUnit.getShortName());
  },
  isImperial: function isImperial() {
    var knownUnits = new KnownUnits();
    return knownUnits.isImperial(this.getShortName());
  },
  isMetric: function isMetric() {
    var knownUnits = new KnownUnits();
    return knownUnits.isMetric(this.getShortName());
  },
  getDerivedUnit: function getDerivedUnit(pPower) {
    if (typeof pPower !== "number" || pPower < 1) {
      throw new Error("invalid parameter, power should be number > 1");
    }
    var knownUnits = new KnownUnits();
    var derivedUnit = this.getShortName() + pPower;
    if (pPower === 1) {
      derivedUnit = this.getShortName();
    }
    if (knownUnits.isAvailable(derivedUnit) === false) {
      throw new Error("unknown unit: " + derivedUnit);
    }
    if (this.hasAccuracy() === true) {
      return new Unit({
        unit: derivedUnit,
        accuracy: this.getAccuracy()
      });
    }
    return new Unit({
      unit: derivedUnit
    });
  }
};
module.exports = Unit;

},{"./RegisteredUnits.js":262}],265:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var preferences = null; // contains the unit preferences
var defPreferences; // contains the def preferences
var getResourcesResolversDict;
var Unit = require("./Unit.js");

/**
 * @deprecated 
 * @returns preferences
 */
function getPreferences() {
  if (preferences === null) {
    var output = window.api_sync.preferences.get_for_current_user("", "units");
    if (output && output.preferences && _typeof(output.preferences) === "object") {
      preferences = output.preferences;
    } else if (output && output.error) {
      throw new Error(output.error);
    } else {
      throw new Error("invalid interface preferences.get_for_current_user");
    }
  }
  return preferences;
}

/**
 * @brief a unit has a unique name and optionally a precision
 * @constructor UnitPreferences
 */
function UnitPreferences(retrievePreferences) {
  this.mPreferences = {};
  // #28451 possible deadlock during opening of Portal pages
  // Do not retrieve the preferences if not needed (eg SystemUnitPreferences.js)
  if (retrievePreferences === false) {
    return;
  }
  this.mPreferences = getPreferences();
}

/**
 * @description load all the data to enable the UnitPreferences
 * @function
 * @static
 * @name UnitPreferences#get
 * @returns {Promise} promise containing the UserPreferences object
 */
UnitPreferences.get = function () {
  if (preferences === null) {
    if (defPreferences === undefined) {
      defPreferences = api_defer.preferences.get_for_current_user("", "units").then(function (pResults) {
        if (pResults && pResults.preferences && _typeof(pResults.preferences) === "object") {
          preferences = pResults.preferences;
          return new UnitPreferences();
        } else {
          return Promise.reject({
            "error_code": "invalid_return_interface",
            "error": "expected an preferences object"
          });
        }
      }, function (pError) {
        console.error(pError);
        return Promise.reject(pError);
      });
    }
    return defPreferences;
  } else {
    return Promise.resolve(new UnitPreferences());
  }
};
UnitPreferences.getResources = function () {
  if (defPreferences === undefined) {
    getResourcesResolversDict = Promise.withResolvers();
    defPreferences = getResourcesResolversDict.promise;
  }
  return [{
    apiCall: "get_for_current_user",
    apiAppKey: "",
    apiSubKey: "units"
  }];
};
UnitPreferences.clear = function () {
  preferences = null;
  defPreferences = undefined;
  getResourcesResolversDict = undefined;
};
UnitPreferences.set = function (pPreferences) {
  if (pPreferences && _typeof(pPreferences) === "object") {
    preferences = pPreferences;
    if (getResourcesResolversDict) {
      getResourcesResolversDict.resolve(preferences);
    }
  } else {
    // ignore error, data will be reasked later on
    console.error("invalid interface for UnitPreferences.set :", preferences);
  }
};
UnitPreferences.prototype = {
  constructor: UnitPreferences,
  /**
   * @brief returns the list of all available units
   */
  getDefinitions: function getDefinitions() {
    return Object.keys(this.mPreferences);
  },
  /**
   * @brief returns true if there is such a preference key
   */
  hasDefinition: function hasDefinition(pPreferenceKey) {
    if (typeof pPreferenceKey !== "string" || pPreferenceKey.length === 0) {
      throw new Error("invalid preference key");
    }
    return this.mPreferences[pPreferenceKey] !== undefined;
  },
  /**
   * @brief returns the unit associated with the preference key
   */
  getDefinition: function getDefinition(pPreferenceKey) {
    if (typeof pPreferenceKey !== "string" || pPreferenceKey.length === 0) {
      throw new Error("invalid preference key");
    }
    if (this.hasDefinition(pPreferenceKey) === false) {
      throw new Error("no such unit: " + pPreferenceKey);
    }
    return new Unit(this.mPreferences[pPreferenceKey]);
  }
};
if (window.nixps !== undefined && window.nixps.testing !== undefined) {
  window.nixps.testing.clear_unitpreferences.push(UnitPreferences.clear);
}
module.exports = UnitPreferences;

},{"./Unit.js":264}],266:[function(require,module,exports){
"use strict";

var Unit = require("./Unit.js");

/**
 * @brief an immutable value, associated with a unit
 * @constructor Value
 */
function Value(pValue, pUnit) {
  if (typeof pValue !== "number") {
    throw new Error("invalid value");
  }
  var OtherUnit = null;
  if (window.nixps !== undefined && nixps.cloudflow !== undefined && nixps.cloudflow.Unit !== undefined) {
    OtherUnit = nixps.cloudflow.Unit;
  }
  if (pUnit instanceof Unit === false && (OtherUnit && pUnit instanceof OtherUnit) === false) {
    throw new Error("invalid unit");
  }
  this.mValue = pValue;
  this.mUnit = pUnit;
}
Value.prototype = {
  constructor: Value,
  /**
   * @brief returns a string representation of the value
   * @function
   * @name Value.toStringWithoutUnit
   * @returns {string} representation witout unit
   */
  toStringWithoutUnit: function toStringWithoutUnit() {
    return this.mUnit.toStringWithoutUnit(this.mValue);
  },
  /**
   * @brief returns a string representation of the value
   * @function
   * @name Value.toString
   * @returns {string}
   */
  toString: function toString() {
    return this.mUnit.toString(this.mValue);
  },
  /**
   * @description get the format where the square is visual set upper, 
   * this is done by adding html sup tag
   * @function
   * @name Value.toElement
   * @returns the html element
   */
  toElement: function toElement() {
    return this.mUnit.toElement(this.mValue);
  },
  /**
   * @description get the format where the square is visual set upper, 
   * this is done by adding html sup tag
   * @function
   * @name Value.toHTML
   * @returns the representation in html format
   */
  toHTML: function toHTML() {
    return this.mUnit.toHTML(this.mValue);
  },
  /**
   * @brief returns a number with the precision of the unit
   * @function
   * @name Value.toFormattedNumber
   * @returns the formatted number
   */
  toFormattedNumber: function toFormattedNumber() {
    return this.mUnit.toFormattedNumber(this.mValue);
  },
  /**
   * @brief returns the stored value
   * @function
   * @name Value.getValue
   * @returns value
   */
  getValue: function getValue() {
    return this.mValue;
  },
  /**
   * @brief returns the unit
   * @function
   * @name Value.getUnit
   * @returns unit
   */
  getUnit: function getUnit() {
    return this.mUnit;
  },
  /**
   * @brief returns the value in that unit
   * @function
   * @name Value.convert
   * @returns Value
   */
  convert: function convert(pUnit) {
    var OtherUnit = null;
    if (window.nixps !== undefined && nixps.cloudflow !== undefined && nixps.cloudflow.Unit !== undefined) {
      OtherUnit = nixps.cloudflow.Unit;
    }
    if (pUnit instanceof Unit === false && (OtherUnit && pUnit instanceof OtherUnit) === false) {
      throw new Error("invalid unit");
    }
    return new Value(this.mUnit.convert(this.mValue, pUnit), pUnit);
  }
};
module.exports = Value;

},{"./Unit.js":264}],267:[function(require,module,exports){
"use strict";

(function ($) {
  if ($.fn.Upload !== undefined) {
    // do not continue if already included
    return false;
  }
  function isMSIE() {
    navigator.userAgent.toLowerCase().indexOf("msie") >= 0;
  }

  /**
   * @namespace nixps-cloudflow.Upload
   * @description Draw a upload component.
   * fires next events
   * <ul>
   *  <li>remove: a item is removed</li>
   *  <li>done: a item is upladed</li>
   *  <li>error: a item has failt to uploaded</li>
   *  <li>start: there are item(s) being uploading</li>
   *  <li>stop: all uploading files are done with oploading</li>
   * </ul>
   * This component is included in the framework.js and requires a 3rdParty component
   * @requires /3rdParty/jquery.fileupload.js
   * @example $("<div>").Upload({});
   */
  $.widget("nixps-cloudflow.Upload", {
    widgetEventPrefix: "upload",
    options: {
      /**
       * @name nixps-cloudflow.Upload#multiple
       * @desc Allow multiple files to upload
       * @type {Boolean}
       * @default true
       */
      multiple: true,
      /**
       * @name nixps-cloudflow.Upload#uploadUrl
       * @desc The upload url
       * @type {String}
       * @default null
       */
      uploadUrl: null,
      /**
       * @name nixps-cloudflow.Upload#check_file_cb
       * @desc To check a file, must return a boolean indication that the file is good or bad.
       * @type {Function}
       * @default function(){return true} 
       */
      check_file_cb: function check_file_cb(p_filename, p_size, p_type) {
        return true;
      },
      /**
       * @name nixps-cloudflow.Upload#beforeUpload
       * @desc To check if a file may be uploaded, but this is called before the function options.check_file_cb
       * @type {Function}
       * @default function(){return true} 
       */
      beforeUpload: function beforeUpload() {
        return true;
      },
      /**
       * @name nixps-cloudflow.Upload#dropZone
       * @description Define the dropZone for uploading a file
       * @type {HTML}
       * @default null
       */
      dropZone: null,
      /**
       * @name nixps-cloudflow.Upload#accept
       * @description Which accept attribute must be given to the input field. 
       * @type {String}
       * @default null
       */
      accept: null,
      /**
       * @name nixps-cloudflow.Upload#enableBootstrapUI
       * @description Must we add bootstrap classes or not?
       * @type {Boolean}
       * @default false
       */
      enableBootstrapUI: false,
      /**
       * @name nixps-cloudflow.Upload#submitButton
       * @type {object}
       * @description The options to show and activate a submit button. This are the supported options
       * <dl>
       *  <dt>label</dt><dd>(string) Text on the button (will pass the ._t function)</dd>
       *  <dt>classes</dt><dd>(string) Additional class names separeted by space added to the button.</dd>
       *  <dt>whitepaperName</dt><dd>(string) The whitepaper name where we must submit to</dd>
       *  <dt>whitepaperInputName</dt><dd>(string) The inputname of the start from kiosk node</dd>
       *  <dt>icon</dt><dd>(string) html code that can be interpretted as icon</dd>
       *  <dt>options</dt><dd>(object) the object will be passed as variables to the workflow</dd>
       * </dl>
       * @default null
       */
      submitButton: null,
      /**
       * @name nixps-cloudflow.Upload#enableBootstrapUI
       * @description Must we do post process steps
       * @type {Boolean}
       * @default true
       */
      doPostProcessing: true,
      /**
       * @name nixps-cloudflow.Upload#enableBootstrapUI
       * @description Callback function when the upload is completed
       * @type {Function}
       * @default undefined
       */
      completed_cb: undefined
    },
    /** 
     * @description Creates the editor component
     * @function
     * @private
     * @name nixps-cloudflow.Upload#_create
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.element.css({
        position: "relative"
      });
      this._draw();
      this._on(this.element, {
        "click .submitButton": this._submitButtonClickHandler
      });
    },
    /**
     * @description function runs when user click on the submit button
     * @function
     * @name nixps-cloudflow.Upload#_submitButtonClickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _submitButtonClickHandler: function _submitButtonClickHandler(pEvent, pData) {
      if (typeof this.options.submitButton.whitepaperName !== "string" || this.options.submitButton.whitepaperName.length <= 0) {
        throw new Error("Missing parameter whitepaperName in option submitButton");
      }
      if (typeof this.options.submitButton.whitepaperInputName !== "string" || this.options.submitButton.whitepaperInputName.length <= 0) {
        throw new Error("Missing parameter whitepaperInputName in option submitButton");
      }
      var assets = this.getUploadedAssets();
      var file_urls = [];
      if (Array.isArray(assets)) {
        for (var i = 0; i < assets.length; i++) {
          if (assets[i].cloudflow !== undefined && typeof assets[i].cloudflow.file === "string" && assets[i].cloudflow.file.length > 0) {
            file_urls.push(assets[i].cloudflow.file);
          }
        }
      }
      var that = this;
      api_async.hub.start_from_whitepaper_with_files_and_variables(this.options.submitButton.whitepaperName, this.options.submitButton.whitepaperInputName, file_urls, this.options.submitButton.options, function (pResults) {
        that.uploadController.reset();
        that._trigger("submit", null, {
          "whitepaperName": that.options.submitButton.whitepaperName,
          "whitepaperInputName": that.options.submitButton.whitepaperInputName,
          "file_url": file_urls,
          "return": pResults
        });
      }, function (pError) {
        console.error(pError);
        that._trigger("error", null, {
          error_code: "error_when_submiting",
          error: "error during sumbitting",
          error_message: pError
        });
      });
      pEvent.preventDefault();
    },
    /**
     * @description callback function called before file is uploaded, to check if file may be uploaded
     * @function
     * @name nixps-cloudflow.Upload#_checkFile
     * @private
     * @param {type} p_filename
     * @param {type} p_size
     * @param {type} p_type
     * @returns {function|Boolean}
     */
    _checkFile: function _checkFile(p_filename, p_size, p_type) {
      this._incrementBusyCounter();
      // if a file is rejected the fail is called, this will decrement the counter
      return this.options.check_file_cb(p_filename, p_size, p_type);
    },
    /**
     * @description Function runs when user removed or abort a file
     * @function
     * @name nixps-cloudflow.Upload#_removeClickHandler
     * @param {string} filename the filename of the removed file
     * @returns {undefined}
     */
    _removeClickHandler: function _removeClickHandler(pFileName) {
      this._trigger("remove", null, {
        filename: pFileName
      });
    },
    /**
     * @name nixps-cloudflow.Upload#getSortedUploadedAssets
     * @description get a array of objects containing information about the uploaded files. 
     * Those files are already uploaded
     * @function
     * @returns {Array} the uploaded files
     */
    getSortedUploadedAssets: function getSortedUploadedAssets() {
      var sortedFileNames = this.uploadController.get_files();
      var dictSortedFileNames = {};
      for (var i = 0; i < sortedFileNames.length; i++) {
        dictSortedFileNames[sortedFileNames[i]] = i;
      }
      var assets = this.uploadController.get_uploaded_assets();
      assets.sort(function (a, b) {
        if (a === undefined || b === undefined) {
          return 0; // all assets must be exists, so here we may not come
        }

        var aIndex = dictSortedFileNames[a.file_name];
        var bIndex = dictSortedFileNames[b.file_name];
        if (aIndex === undefined || bIndex === undefined) {
          return 0; // evrey asset must exists also in file list, so we may not come in here
        }

        return aIndex - bIndex;
      });
      return assets;
    },
    /**
     * @name nixps-cloudflow.Upload#getUploadedAssets
     * @description get a array of objects containing information about the uploaded files. 
     * Those files are already uploaded
     * @function
     * @returns {Array} the uploaded files
     */
    getUploadedAssets: function getUploadedAssets() {
      return this.uploadController.get_uploaded_assets();
    },
    hideNativeUploadButton: function hideNativeUploadButton() {
      this.element.find(".upload_div").hide();
    },
    /**
     * @description increment the amount of busy items
     * @name nixps-cloudflow.Upload#_incrementBusyCounter
     * @function
     * @private
     * @returns {undefined}
     */
    _incrementBusyCounter: function _incrementBusyCounter() {
      if (this.options.multiple === true) {
        this.busyItems++;
      } else {
        this.busyItems = 1;
      }
      if (this.busyItems === 1) {
        // start triggering on first uploading file,
        // and not firing on every file
        this._trigger("start", null, {});
        this.element.find(".submitButton").addClass("disableByUploadBusy").prop("disabled", true);
      }
    },
    /**
     * @description decrement the amount of busy items
     * @name nixps-cloudflow.Upload#_decrementBusyCounter
     * @function
     * @private
     * @returns {undefined}
     */
    _decrementBusyCounter: function _decrementBusyCounter() {
      if (this.busyItems > 0) {
        if (this.options.multiple === true) {
          this.busyItems--;
        } else {
          this.busyItems = 0;
        }
        if (this.busyItems === 0) {
          // fired when all files are done with uploading
          this._trigger("stop", null, {});
          this.element.find(".submitButton").removeClass("disableByUploadBusy").prop("disabled", false);
        }
      }
    },
    /**
     * @name nixps-cloudflow.Upload#fireUploadButtonClick
     * @description Execute this function to open the file chooser dialog, if the user want to choose a file to upload
     * @function
     * @return {undefined}
     */
    fireUploadButtonClick: function fireUploadButtonClick() {
      // click to start choosing a file to upload
      this.uploadController.uploadbutton_click();
    },
    _draw: function _draw() {
      var that = this;
      // in case of redraw we need to clear all existing data
      if (this.element.data("blueimpFileupload") !== undefined) {
        this.element.fileupload("destroy");
      }
      this.element.empty().removeData("fileupload").removeData("controller");
      delete this.uploadController;
      this.busyItems = 0;
      this.uploadController = new Controller({
        multiple: this.options.multiple,
        url: this.options.uploadUrl,
        done_cb: function done_cb(pAsset) {
          that._decrementBusyCounter();
          that._trigger("done", null, {
            asset: pAsset
          });
        },
        got_files_cb: function got_files_cb(pFileName, pURL) {},
        check_file_cb: this._checkFile.bind(this),
        fail_cb: function fail_cb(pFilename, pError) {
          that._decrementBusyCounter();
          that._trigger("error", null, {
            filename: pFilename,
            error: pError
          });
        },
        beforeUpload: this.options.beforeUpload.bind(this),
        remove_cb: this._removeClickHandler.bind(this),
        dropZone: this.options.dropZone,
        accept_attribute: this.options.accept,
        completed_cb: this.options.completed_cb,
        doPostProcessing: this.options.doPostProcessing
      });
      this.uploadController.setup_ui(this.element);
      if ($.isPlainObject(this.options.submitButton)) {
        var submitButton = $("<button>").addClass("submitButton")._t(this.options.submitButton.label).addClass(this.options.submitButton.classes);
        if (typeof this.options.submitButton.classes === "string" && this.options.submitButton.classes.indexOf("cf-button-") == -1) {
          submitButton.addClass("cf-button-secondary");
        }
        if (this.options.submitButton.icon !== undefined) {
          submitButton.prepend(this.options.submitButton.icon);
        }
        this.element.find(".upload_div").append(submitButton);
      }
      if (this.options.enableBootstrapUI === true) {
        this.element.find(".upload_button, .submitButton").addClass("btn btn-sm btn-default");
      }
    },
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief sets the option
     * @name nixps-cloudflow.Upload#_setOption
     * @function
     * @private
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "uploadUrl") {
        this.uploadController.resetUrl(pValue);
      } else if (pKey === "completed_cb") {
        this.options.completed_cb = pValue;
      } else if (pKey === "disabled") {
        if (pValue === true) {
          this.element.find("input, textarea, button").prop("disabled", true);
        } else if (pValue === false) {
          this.element.find("input, textarea, button").not(".disableByUploadBusy").prop("disabled", false);
        }
      }
      if (["completed_cb"].includes(pKey)) {
        this.uploadController.changeOption(pKey, pValue);
      }
    },
    /**
     * @description control the input options on a good interfase
     * @name nixps-cloudflow.Upload#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.check_file_cb !== "function") {
        throw new Error("input option check_file_cb must be a function");
      }
      if (typeof this.options.multiple !== "boolean") {
        throw new Error("input option multiple must be a boolean");
      }
      if (typeof this.options.enableBootstrapUI !== "boolean") {
        throw new Error("input option enableBootstrapUI must be a boolean");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).css("position", "");
      this._superApply(arguments);
    }
  });

  /**
   * @todo integrate its to this ui widget
   */
  /*! \brief Configures a jQuery div as an asset chooser.
  *  \param {jQuery} p_$div     The div to configure.
  *  \param {Object} p_options  The configuration options.
  *  \result the controller
  *
  *  \a p_options is an object with the following keys (all of which are optional):
  *  - url: Portal URL where to put the files, default null. It should *not* end with a slash. If missing, no location is specified to portal.cgi.
  *  - multiple: If it should be possible to upload multiple files at once. Default: false. Not that this has no effect on drag-and-drop.
  *  - check_file_cb: Function called to check if a file may be uploaded. It's parameters are p_filename, p_size and p_type.
  *                   It should return true if acceptable; false if not. Default simply returns true.
  *  - fail_cb: Function called if a file upload failed. It's parameter is p_filename.
  *  - process_cb: Function called when the file has been uploaded and indexed, but before it's flagged as completed. It's parameters are p_asset and p_callback.
  *                It allows postprocessing of the file (like waiting for metadata). When done, it should call p_callback with a boolean parameter indicating if
  *                the postprocessing was successful. Default simply calls p_callback(true).
  *  - done_cb: Function called when the file upload, indexing and postprocessing is done. It's parameter is p_asset.
  *  - got_files_cb: Function called when the file upload is done. It's parameters are the file name and the asset URL.
  *
  *  Examples for pre-upload validation:
  *
  *  Check file size:
  *    check_file_cb: function (p_filename, p_size, p_type)
  *    {
  *        if (p_size > 10000000)
  *        {
  *            l_uploader.add_failed_entry(p_filename, 'Too large');
  *            return false;
  *        }
  *        return true;
  *    }
  *
  *  Maximum one file:
  *    check_file_cb: function (p_filename, p_size, p_type)
  *    {
  *        // get_files() returns an array of file names that have either been uploaded or are in progress; it excludes failed and rejected files.
  *        // l_upload is the upload controller (returned by setup_ui)
  *        return l_upload.get_files().length < 1;
  *    }
  *
  *  Only PDF files:
  *    check_file_cb: function (p_filename, p_size, p_type)
  *    {
  *        if (p_type !== "application/pdf")
  *        {
  *            l_uploader.add_failed_entry(p_filename, 'Not a PDF file');
  *            return false;
  *        }
  *        return true;
  *    }
  *
  *  You can use the function get_uploaded_assets() to retrieve an array of uploaded assets.
  *  The function reset() resets the component. It takes an optional p_options object to reconfigure the component.
  */
  var Controller = function Controller(p_options) {
    var l_this = this;
    l_this.m_$div = null;
    l_this.m_$filelist = null;
    l_this.m_files = [];
    l_this.m_assets = [];
    l_this.xhrDict = {};
    l_this.m_options = {
      url: null,
      check_file_cb: function check_file_cb(p_filename, p_size, p_type) {
        return true;
      },
      fail_cb: function fail_cb(p_filename, p_error) {},
      process_cb: function process_cb(p_asset, p_callback) {
        p_callback(true);
      },
      multiple: false,
      remove_cb: function remove_cb(p_filename) {
        return true;
      },
      beforeUpload: function beforeUpload() {
        return true;
      },
      dropZone: null,
      accept_attribute: null,
      doPostProcessing: true
    };
    Object.assign(l_this.m_options, p_options);
  };
  Controller.prototype = {
    constructor: Controller,
    resetUrl: function resetUrl(url) {
      var l_this = this;
      var uploadURL = '/portal.cgi' + url;
      if (api_util.get_session() !== undefined) {
        uploadURL += "&session=" + api_util.get_session();
      }
      if (l_this.m_$div.fileupload !== undefined) {
        l_this.m_$div.fileupload({
          url: uploadURL
        });
        l_this.m_options.url = uploadURL;
      }
    },
    setup_ui: function setup_ui(p_$div) {
      var l_this = this;
      l_this.m_$div = p_$div;
      l_this.m_$div.addClass("upload");
      this.m_$div.data("controller", this);
      var l_$upload_field;
      var l_$upload_button = null;
      var l_$upload_div = $('<div class="upload_div">');
      l_this.m_$div.append(l_$upload_div);
      var l_$filescroll = $('<div class="filescroll">');
      l_this.m_$div.append(l_$filescroll);
      l_this.m_$filelist = $('<div class="filelist">');
      l_$filescroll.append(l_this.m_$filelist);
      var l_multiple = "";
      if (l_this.m_options.multiple) {
        l_multiple = " multiple";
      }
      if (isMSIE()) {
        l_$upload_field = $("<input class='upload_input_msie' type='file' name='files[]' data-url='/portal.cgi'" + l_multiple + ">");
        l_$upload_div.append(l_$upload_field);
      } else {
        l_$upload_button = $("<button class='upload_button cf-button-secondary'>").text($.i18n._("nixps-cloudflow-upload.button_text_browse"));
        l_$upload_div.append(l_$upload_button);
        l_$upload_field = $("<input class='upload_input' type='file' name='files[]' data-url='/portal.cgi'" + l_multiple + ">");
        if (l_this.m_options.accept_attribute !== null) {
          // accept do not work on ie, so do no add above
          l_$upload_field.attr('accept', l_this.m_options.accept_attribute);
        }
        l_$upload_div.append(l_$upload_field);
        l_$upload_field.hide();
      }
      var uploadURL = "/portal.cgi";
      if (l_this.m_options.url != null) {
        if (l_this.m_options.url.substring(0, 6) === "/?url=") {
          uploadURL += l_this.m_options.url.substring(1); // Deprecated behaviour
        } else if (l_this.m_options.url.substring(0, 5) === "?hub=" || l_this.m_options.url.substring(0, 7) === "?asset=" || l_this.m_options.url.substring(0, 12) === "?proofscope=") {
          uploadURL += l_this.m_options.url;
        } else {
          uploadURL += "?url=" + encodeURIComponent(l_this.m_options.url);
        }
      }
      var dropZone = l_this.m_$div;
      if (l_this.m_options.dropZone !== null) {
        dropZone = l_this.m_options.dropZone;
      }
      l_this.m_$div.fileupload({
        dataType: "json",
        dropZone: dropZone,
        pasteZone: null,
        url: uploadURL,
        add: function add(p_event, p_data) {
          if (!p_data.headers) {
            p_data.headers = {};
          }
          if (Array.isArray(p_data.files) && p_data.files.length === 1 && typeof p_data.files[0].lastModified === "number" && new Date() - p_data.files[0].lastModified > 1000) {
            p_data.headers["X-Hybrid-Last-Modified"] = new Date(p_data.files[0].lastModified).toISOString();
          }
          var csrfToken = api_util.get_cookie("csrf-token");
          if (typeof csrfToken === "string" && csrfToken.length > 0) {
            p_data.headers["X-Csrf-Token"] = csrfToken;
          }
          if (typeof l_this.m_options.beforeUpload === "function") {
            $.when(l_this.m_options.beforeUpload()).done(function (result) {
              p_data.submit();
            });
          } else {
            p_data.submit();
          }
        },
        send: function send(p_event, p_data) {
          var l_index;
          if (!l_this.m_options.multiple) {
            l_this.m_files = [];
            l_this.m_$filelist.empty();
            l_this.m_assets = [];
          }
          for (l_index = 0; l_index < p_data.files.length; l_index++) {
            var l_file = p_data.files[l_index];
            if (!l_this.m_options.check_file_cb(l_file.name, l_file.size, l_file.type)) {
              return false;
            }
          }
          for (l_index = 0; l_index < p_data.files.length; l_index++) {
            var l_file = p_data.files[l_index];
            l_this.add_file(l_file.name);
          }
          return true;
        },
        done: function done(p_event, p_data) {
          var errorObject = null;
          if (p_data && p_data.result && typeof p_data.result.error === "string" && p_data.result.error.length > 0) {
            errorObject = p_data.result;
            console.error(errorObject);
          }
          delete l_this.xhrDict[p_data.files[0].name];
          var l_$progressbar = l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .progressbar');
          var l_$progress = l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .progress');
          var l_$status = l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .status');
          l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .removeFileIcon').css('display', ''); // show remove icon

          l_$progressbar.hide();
          if (p_event.type !== "fileuploaddone" || p_data.result === undefined || p_data.result.files === undefined || errorObject !== null) {
            l_this.forget_file(p_data.files[0].name);
            l_$status.addClass("cf-text-error").text($.i18n._("nixps-cloudflow-upload.status_failed_explmark"));
            l_this.m_options.fail_cb(p_data.files[0].name, errorObject);
          } else {
            l_$status.text($.i18n._("nixps-cloudflow-upload.processing"));
            p_data.files[0].url = p_data.result.files[0];
            if (p_data.files[0].url === undefined) {
              l_this.forget_file(p_data.files[0].name);
              l_$status.addClass("cf-text-error").text($.i18n._("nixps-cloudflow-upload.status_failed_explmark"));
              l_this.m_options.fail_cb(p_data.files[0].name, errorObject);
            } else {
              l_this.post_process_file(p_data.files[0].name, p_data.files[0].url);
            }
          }
        },
        progress: function progress(p_event, p_data) {
          l_this.xhrDict[p_data.files[0].name] = p_data.xhr();
          var l_$progressbar = l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .progressbar');
          var l_$progress = l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .progress');
          var l_$status = l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .status');
          l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .removeFileIcon').css('display', ''); // show remove icon

          var l_progress_pct = parseInt(p_data.loaded / p_data.total * 100, 10);
          l_$progress.css('width', l_$progressbar.width() * l_progress_pct / 100);
          l_$status.text(l_progress_pct.toString() + "%");
        },
        fail: function fail(p_event, p_data) {
          var errorResponse = p_data.xhr().response;
          try {
            errorResponse = JSON.parse(errorResponse);
          } catch (error) {}
          delete l_this.xhrDict[p_data.files[0].name];
          var l_$progressbar = l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .progressbar');
          var l_$progress = l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .progress');
          var l_$status = l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .status');
          l_this.m_$filelist.find('.filerow[file="' + p_data.files[0].name + '"] .removeFileIcon').css('display', ''); // show remove icon

          l_this.forget_file(p_data.files[0].name);
          l_$progressbar.hide();
          l_$status.text(l_this.extractErrorMessage(p_data.jqXHR)).addClass("cf-text-error");
          l_this.m_options.fail_cb(p_data.files[0].name, errorResponse);
        }
      });
      if (l_$upload_button) {
        l_$upload_button.on("click", function () {
          l_this.m_$div.find(".upload_input").trigger("click");
        });
      }
      if (!isMSIE()) {
        dropZone.bind("dragover", function (p_event) {
          var l_$drop_zone = dropZone;
          var l_timeout = window.dropZoneTimeout;
          if (!l_timeout) {
            l_$drop_zone.addClass("in");
          } else {
            clearTimeout(l_timeout);
          }
          var l_found = false;
          var l_node = p_event.target;
          do {
            if (l_node === l_$drop_zone[0]) {
              l_found = true;
              break;
            }
            l_node = l_node.parentNode;
          } while (l_node !== null);
          if (l_found) {
            l_$drop_zone.addClass("hover");
          } else {
            l_$drop_zone.removeClass("hover");
          }
          window.dropZoneTimeout = setTimeout(function () {
            window.dropZoneTimeout = null;
            l_$drop_zone.removeClass("in hover");
          }, 100);
        });
      }
    },
    uploadbutton_click: function uploadbutton_click() {
      // simulate the click to start choosing a fil to upload
      this.m_$div.find(".upload_input").trigger("click");
    },
    extractErrorMessage: function extractErrorMessage(pJqXHR) {
      var errorMessage = $.i18n._("nixps-cloudflow-upload.status_failed_explmark");
      if (pJqXHR && typeof pJqXHR.responseText === "string" && pJqXHR.responseText.length > 0) {
        try {
          var errorObject = JSON.parse(pJqXHR.responseText);
          if (errorObject.error === "Processing Failure" && errorObject.messages && Array.isArray(errorObject.messages.messages) && errorObject.messages.messages.length > 0 && errorObject.messages.messages[0].type === "No Access to Asset") {
            return $.i18n._("nixps-cloudflow-upload.errormessage_permission");
          }
        } catch (pError) {
          return errorMessage;
        }
      }
      return errorMessage;
    },
    post_process_file: function post_process_file(p_filename, p_url) {
      var l_this = this;
      var l_$status = l_this.m_$filelist.find('.filerow[file="' + p_filename + '"] .status');
      if (l_this !== undefined && l_this.m_options !== undefined && !l_this.m_options.doPostProcessing) {
        l_$status._t("nixps-cloudflow-upload.status_completed").addClass("cf-text-success");
        l_$status.parents(".filerow").addClass("downloaddone");
        if (typeof l_this.m_options.completed_cb === "function") {
          l_this.m_options.completed_cb();
        }
        return;
      }
      if (typeof l_this.m_options.got_files_cb === "function") {
        l_this.m_options.got_files_cb(p_filename, p_url);
      }
      if (typeof l_this.m_options.done_cb === "function") {
        var getDataAPICall;
        if (typeof l_this.m_options.url === "string" && l_this.m_options.url.substring(0, 5) === "?hub=") {
          getDataAPICall = api_defer.hub.get_uploaded_file_data(p_url);
        } else {
          getDataAPICall = api_defer.asset.list(["cloudflow.part", "equal to", p_url], []);
        }
        getDataAPICall.then(function (p_data) {
          if (p_data.data === undefined && Array.isArray(p_data.results)) {
            // transfer interface asset call to interface of hub call
            p_data.data = p_data.results[0];
          }
          if (p_data.data !== undefined && p_data.data !== null) {
            var asset = p_data.data;
            if (l_this.m_options.multiple == false) {
              l_this.m_assets = [];
            }
            if (asset.cloudflow === undefined) {
              asset.cloudflow = {
                file: p_url,
                part: p_url
              };
            }
            l_this.m_assets.push(asset);
            l_this.m_options.process_cb(asset, function (p_success) {
              if (p_success) {
                l_$status._t("nixps-cloudflow-upload.status_completed").addClass("cf-text-success");
                l_$status.parents(".filerow").addClass("downloaddone");
                l_this.m_options.done_cb(asset);
              } else {
                l_this.forget_file(p_filename);
                l_$status._t("nixps-cloudflow-upload.status_failed").addClass("cf-text-error");
                l_$status.parents(".filerow").addClass("downloaddone");
                l_this.m_options.fail_cb(asset);
              }
              if (typeof l_this.m_options.completed_cb === "function") {
                l_this.m_options.completed_cb();
              }
            });
          } else {
            setTimeout(function () {
              l_this.post_process_file(p_filename, p_url);
            }, 1000);
          }
        }).fail(function (pError) {
          console.error(pError);
        });
      } else {
        if (typeof l_this.m_options.completed_cb === "function") {
          l_this.m_options.completed_cb();
        }
        l_$status._t("nixps-cloudflow-upload.status_completed").addClass("cf-text-success");
        l_$status.parents(".filerow").addClass("downloaddone");
      }
    },
    _abort: function _abort(pFileName) {
      // abort the ajax call if it is pressend
      if (this.xhrDict[pFileName] !== undefined) {
        this.xhrDict[pFileName].abort();
      }
    },
    /**
     * @description remove a file from the uploaded list if files
     * @param {string} p_filename filename with extension
     * @returns {undefined}
     */
    forget_uploaded_asset: function forget_uploaded_asset(p_filename) {
      var l_this = this;
      var l_old_list = l_this.m_assets;
      l_this.m_assets = [];
      l_old_list.forEach(function (p_file) {
        if (typeof p_file.file_name === "string") {
          if (p_file.file_name !== p_filename) {
            l_this.m_assets.push(p_file);
          }
        } else {
          l_this.m_assets.push(p_file);
        }
      });
    },
    forget_file: function forget_file(p_filename) {
      var l_this = this;
      var l_old_list = l_this.m_files;
      l_this.m_files = [];
      l_old_list.forEach(function (p_file) {
        if (p_file !== p_filename) {
          l_this.m_files.push(p_file);
        }
      });
    },
    add_file: function add_file(p_filename) {
      var l_this = this;
      l_this.m_files.push(p_filename);
      var l_$row = $('<div class="filerow">');
      l_this.m_$filelist.append(l_$row);
      l_$row.attr("file", p_filename);
      if (l_this.m_files.length % 2 == 0) {
        l_$row.addClass("even");
      } else {
        l_$row.addClass("odd");
      }
      var l_$name = $("<div>").addClass("filename");
      l_$name.text(p_filename);
      l_$name.prepend($("<button>").addClass("cf-icon cf-icon-times removeFileIcon").attr("type", "button").attr("title", $.i18n._("nixps-cloudflow-upload.remove")).hide().on('click', l_this.abortAndRemoveFileHandler.bind(l_this)));
      l_$row.append(l_$name);
      var l_$rightcolumn = $('<div class="rightcolumn">');
      l_$row.append(l_$rightcolumn);
      var l_$progresstext = $('<span class="status">');
      l_$rightcolumn.append(l_$progresstext);
      l_$progresstext.text("0%");
      var l_$progressbar = $('<div class="progressbar">');
      l_$rightcolumn.append(l_$progressbar);
      var l_$progress = $('<div class="progress">').css('width', 0);
      l_$progressbar.append(l_$progress);
    },
    add_failed_entry: function add_failed_entry(p_filename, p_msg) {
      var l_this = this;
      var l_$row = $('<div class="filerow">');
      l_this.m_$filelist.append(l_$row);
      if (l_this.m_files.length % 2 == 0) {
        l_$row.addClass('even');
      } else {
        l_$row.addClass('odd');
      }
      var l_$name = $('<div class="filename">');
      l_$name.text(p_filename);
      l_$row.append(l_$name);
      var l_$rightcolumn = $('<div class="rightcolumn">');
      l_$row.append(l_$rightcolumn);
      var l_$progresstext = $('<span class="status error">');
      l_$rightcolumn.append(l_$progresstext);
      l_$progresstext.text(p_msg);
    },
    /**
     * @description function called when user clicked on remove button
     * @function 
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    abortAndRemoveFileHandler: function abortAndRemoveFileHandler(pEvent, pData) {
      var fileName = $(pEvent.target).closest("[file]").attr("file");
      if (typeof fileName === "string" && fileName.length > 0) {
        this._abort(fileName); // abort the pending call
        this.forget_uploaded_asset(fileName); // in case of already downloaded
        this.forget_file(fileName); // in case of during process
        //
        // control if everything is done well, in this case we can remove file from list
        var allFileNames = $.map(this.get_uploaded_assets(), function (file, index) {
          if (file && typeof file.file_name === "string" && file.file_name.length > 0) {
            return file.file_name;
          }
        });
        if (allFileNames.includes(fileName) === false) {
          this.m_$filelist.find('.filerow[file=\"' + fileName + '\"]').remove();
        }
        this.m_options.remove_cb(fileName);
      }
    },
    get_files: function get_files() {
      return this.m_files;
    },
    get_uploaded_assets: function get_uploaded_assets() {
      return this.m_assets;
    },
    reset: function reset(p_options) {
      this.m_$filelist.empty();
      this.m_files = [];
      this.m_assets = [];
      if (p_options) {
        Object.assign(this.m_options, p_options);
      }
    },
    changeOption: function changeOption(pKey, pValue) {
      if (pKey === "completed_cb" && typeof pValue === "function") {
        this.m_options.completed_cb = pValue;
      }
    }
  };
})(jQuery);

},{}],268:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var TemporyBrowserObjectCache = require("../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var Device = require("../../PWA/js/Device.js");
function _isRealUser(pUserObject) {
  if (pUserObject === undefined || pUserObject === null || typeof pUserObject._id !== "string") {
    return false;
  } else {
    return true;
  }
}

/**
 * @description This is a default user data model, if something go wrong we will use this default data.
 * This is a default user.
 * @static
 * @private
 * @type Userdatamodel
 */
var defaultUser = {
  username: "",
  fullname: ""
};

/**
 * @description Permissions that the real administrator and admin users do not have
 * @static
 * @private
 * @type {Array.<String>}
 */
var noAdminPermissions = ["EXTERNAL_USER"];

/**
 * @desc This is a static user datamodel, this object contains all to information about the user
 * @static
 * @private
 * @default empty
 * @type {object}
 */
var user;

/**
 * @description The deferred object of the call to get all the info
 * @default empty
 * @private
 * @type deferred
 */
var getUserDeferred;

/**
 * @constructor User
 * @description Create the user object
 * @example var User = require("..../User.js");
 * var username = user.getUserName(); 
 * @example var user = new nixps.cloudflow.User();
 * var username = user.getUserName();
 * @example $.when(nixps.cloudflow.User.get()).then(function(pUser) {
 *    console.log(pUser.getUserName());
 * });
 * @returns {Object} The user object 
 */
function User(pUserObject) {
  if (pUserObject && _typeof(pUserObject) === "object" && !Array.isArray(pUserObject) && Object.keys(pUserObject).length > 0) {
    if (_isRealUser(pUserObject)) {
      user = Object.freeze(pUserObject);
    }
  }
  if (user === undefined || user === null || user._id === undefined) {
    this.load();
  }
}
;

/**
 * @description Get the user asynchronously and returns itself
 * @param {Boolean} pReask true if we need to ignore the cache and reask the data 
 * @example Promise.resolve(nixps.cloudflow.User.get()).then(function(pUser) {
 *    console.log(pUser.getUserName());
 * });
 * @returns {Promise|Deferred} this
 */
User.get = function (pReAsk) {
  if (pReAsk === true) {
    getUserDeferred = this.prototype.asyncLoad(true);
    return getUserDeferred.then(function (pUser) {
      return new User(pUser);
    });
  }
  if (user === undefined || user === null || user._id === undefined) {
    if (getUserDeferred === undefined || getUserDeferred === null) {
      if (TemporyBrowserObjectCache.isPageReload() !== true || Device.getPollingFactor() > 1) {
        var cacheObject = TemporyBrowserObjectCache.get("nixps_cloudflow_user");
        if (cacheObject !== null) {
          if (window.api_util !== undefined && typeof api_util.get_session() === "string" && api_util.get_session() !== cacheObject._session) {
            // we are inside a session and the cache is wrong
            // reask
          } else {
            delete cacheObject._session;
            return new User(cacheObject);
          }
        }
      }
      getUserDeferred = this.prototype.asyncLoad(true);
    }
    return Promise.resolve(getUserDeferred).then(function (pUser) {
      return new User(pUser);
    });
  } else {
    return Promise.resolve(new User());
  }
};

/**
 * @description Create a new users object from json structure
 * @function
 * @name User.fromJSON
 * @returns {User}
 */
User.fromJSON = function (json) {
  return new User(json.user);
};

/**
 * @description Clear the internal state of the user
 * @function
 * @private
 * @name User.clear
 */
User.clear = function () {
  user = undefined;
  getUserDeferred = undefined;
  TemporyBrowserObjectCache.remove("nixps_cloudflow_user");
  TemporyBrowserObjectCache.remove("nixps_cloudflow_menu");
};
User.prototype = {
  constructor: User,
  /**
   * @desc This function does a backend call to get the data/user.
   * It does not use cache
   * @function
   * @name User#load
   * @deprecated This function uses an sync call, use @{link User.get}
   * @returns {User} the userobject
   */
  load: function load() {
    user = window.api_sync.auth.get_current_user();
    if (_isRealUser(user) === false) {
      user = defaultUser;
      console.warn("nixps.cloudflow.User load: we could not load the user.");
    }
    return user;
  },
  /**
   * @description This function load all the information async of the user from the backend
   * @function
   * @name User#asyncload
   * @returns {Deferred}
   */
  asyncLoad: function asyncLoad(pReturnUserJSON) {
    var that = this;
    return api_defer.auth.get_current_user().then(function (pUser) {
      if (_isRealUser(pUser) === false) {
        user = defaultUser;
        console.warn("nixps.cloudflow.User load: we could not load the user.");
      } else {
        user = pUser;
        TemporyBrowserObjectCache.save("nixps_cloudflow_user", Object.assign({
          _session: window.api !== undefined ? window.api.m_session : undefined
        }, user));
      }
      if (pReturnUserJSON === true) {
        return pUser;
      }
      return that;
    }, function (pError) {
      console.error(pError);
      return Promise.reject(pError);
    });
  },
  /**
   * @description Reset the internal information. All information will be gone! 
   * @function
   * @name User#reset
   * @private
   * @returns {undefined}
   */
  reset: function reset() {
    user = undefined;
    getUserDeferred = undefined;
  },
  /**
   * @description Get the _id of the user object
   * @function
   * @name User#getID
   * @returns {String}
   */
  getID: function getID() {
    return user._id;
  },
  /**
   * @description Get the fullname of the user.
   * @function
   * @name User#getFullName
   * @returns {nixps.cloudflow.User.user.fullname|String}
   */
  getFullName: function getFullName() {
    return user.fullname;
  },
  /**
   * @description Get the username of the user.
   * @function
   * @name User#getUserName
   * @returns {nixps.cloudflow.User.user.username|String}
   */
  getUserName: function getUserName() {
    return user.username;
  },
  /**
   * @description Get the email of the user.
   * @function
   * @name User#getEmail
   * @returns {nixps.cloudflow.User.user.email|String}
   */
  getEmail: function getEmail() {
    return user.email;
  },
  /**
   * @description Control if the user has a specific permission.
   * @function
   * @name User#hasPermission
   * @example user.hasPermission("MAY_UPLOAD");
   * @param {String} pPermission the permission to control on
   * @returns {boolean} true if hte user has permission or false if the user does have the permission
   */
  hasPermission: function hasPermission(pPermission) {
    if (user == undefined) {
      return false; // use does not exists
    }
    // get the array of all permissions
    var permissions;
    if (Array.isArray(user.resolved_permissions)) {
      permissions = user.resolved_permissions;
    } else if (Array.isArray(user.permissions)) {
      permissions = user.permissions;
    } else {
      return false; // if there are no permissions, you get nothing
    }

    // Real administrator case
    if (permissions.indexOf("ADMIN") >= 0) {
      // The administrator has no noAdmin permissions
      if (noAdminPermissions.indexOf(pPermission) >= 0) {
        return false;
      }
      return true;
    }

    // Admin user case
    if (permissions.indexOf("ADMIN_USER") >= 0) {
      // The admin user has no noAdmin permissions
      if (noAdminPermissions.indexOf(pPermission) >= 0) {
        return false;
      }

      // The admin user has no ADMIN permission
      if (pPermission === "ADMIN") {
        return false;
      }

      // The admin user has all other permissions
      return true;
    }

    // if no real admin or permission is not automatic linked to or external user need to be checked always
    if (typeof pPermission === "string" && pPermission.length > 0) {
      return permissions.indexOf(pPermission) >= 0;
    } else {
      throw new Error("hasPermission: inputparameter pPermission must be a string");
    }
  },
  /**
   * @description Is the user a admin or has he admin rights?
   * @function
   * @name User#hasAdminPermissions
   * @returns {Boolean} has de user admin rights
   */
  hasAdminPermissions: function hasAdminPermissions() {
    return this.hasPermission("ADMIN") || this.hasPermission("ADMIN_USER");
  },
  /**
   * @description Is the user a real real super admin or not?
   * @function
   * @name User#isAdminAdmin
   * @returns {Boolean} has de user admin rights
   */
  isAdminAdmin: function isAdminAdmin() {
    if (Array.isArray(user.permissions)) {
      return user.permissions.indexOf("ADMIN") >= 0;
    }
    return false;
  },
  /**
   * @description Is the user an external user or not?
   * @function
   * @name User#isExternalUser
   * @returns {Boolean} Has de user the EXTERNAL_USER right
   */
  isExternalUser: function isExternalUser() {
    if (Array.isArray(user.permissions)) {
      return user.permissions.indexOf("EXTERNAL_USER") >= 0;
    }
    return false;
  },
  /**
   * @description Get the model of the class, the user object.
   * @function
   * @name User#getUserObject
   * @returns {nixps.cloudflow.User.user} the user object like the backend knows it.
   */
  getUserObject: function getUserObject() {
    return user;
  },
  /**
   * @desc Control if the userobject represent a real user or not.
   * @function
   * @name User#isRealUser
   * @param {object} pUserObject - the userobject to control
   * @returns {Boolean} true if the userobject is a true user object, false if the userobject do not represent a user
   */
  isRealUser: function isRealUser(pUserObject) {
    return _isRealUser(pUserObject);
  },
  /**
   * @description Is the user using a kind of active directory?
   * @function
   * @name User#isUsingActiveDirectory
   * @example user.isUsingActiveDirectory();
   * @returns {Boolean} true if the user is using a kind of active directory, false other cases
   */
  isUsingActiveDirectory: function isUsingActiveDirectory() {
    return typeof user.source === "string" && user.source !== "local";
  },
  /**
   * @description Is the user using a kind of active directory?
   * @function
   * @name User#isUsingActiveDirectory
   * @example user.isUsingActiveDirectory();
   * @returns {Boolean} true if the user is using a kind of active directory, false other cases
   */
  isUsingCloudActiveDirectory: function isUsingCloudActiveDirectory() {
    return typeof user.source === "string" && user.source !== "local" && user.source !== "ad";
  },
  /**
   * @description Get the name of the scopes of the logged in user. 
   * If user has all scopes, the array ["*"] will be returned
   * @function
   * @name User#getScopes
   * @returns {Array} An array of scopes
   */
  getScopes: function getScopes() {
    if (Array.isArray(user.scope_name) && user.scope_name.length > 0) {
      return user.scope_name;
    } else {
      ["*"];
    }
  },
  /**
   * @description Get the ids of the scopes of the logged in user.
   * If the has all scopes, the array ["*"] will be returned
   * @function
   * @name User#getScopesIDS
   * @returns {Array} An array with the ids
   */
  getScopesIDS: function getScopesIDS() {
    if (Array.isArray(user.scope) && user.scope.length > 0) {
      return user.scope;
    } else {
      ["*"];
    }
  },
  /**
   * @description Get all the scopes of the current user as a array, each element contains the id and the name.
   * If returning a empty array, this means the user has no scopes, so he has all scopes.
   * @function 
   * @name  User#getScopesObjectArray
   * @returns {Array} each element is a object containing _id and this name 
   */
  getScopesObjectArray: function getScopesObjectArray() {
    if (Array.isArray(user.scope) && user.scope.length > 0 && Array.isArray(user.scope_name) && user.scope_name.length > 0) {
      if (user.scope.length !== user.scope_name.length) {
        throw new Error("could not make objects: the number of names and ids are different");
      }
      var outputScopes = [];
      for (var i = 0; i < user.scope.length; i++) {
        outputScopes.push({
          "_id": user.scope[i],
          "name": user.scope_name[i]
        });
      }
      return outputScopes;
    } else {
      return [];
    }
  },
  /**
   * @description The the full string of the scope the user is currently in, 
   * @function
   * @name User#getActiveScopeName
   * @returns {String} the name of the active scope, otherwise "All Scopes"
   */
  getActiveScopeName: function getActiveScopeName() {
    if (typeof user.active_scope_name === "string" && user.active_scope_name.length > 0) {
      return user.active_scope_name;
    }
    return $.i18n._("nixps-cloudflow-top.all_scopes");
  },
  /**
   * @description Has the user all scopes? 
   * In fact we only control if the users has no scopes in database. This means that the users scopes is seleceted as "all scopes".
   * if someone has all scopes separatelty selected, this will return false.
   * @function
   * @name User#hasAllScopes
   * @returns {Boolean} true if user has all scopes, false if user has separetly selected scopes
   */
  hasAllScopes: function hasAllScopes() {
    return !Array.isArray(user.scope) || user.scope.length === 0;
  },
  hasLoginScopes: function hasLoginScopes() {
    return Array.isArray(user.scope) && user.scope.length > 1;
  },
  /**
   * @description Check if the user has attributes or not
   * @function
   * name User#hasAttributes
   * @returns {Boolean} true if the user as one or more attributes
   */
  hasAttributes: function hasAttributes() {
    return user !== undefined && Array.isArray(user.attributes) && user.attributes.length > 0;
  },
  /**
   * @description Get all the attribute of the user
   * @function
   * @name User#getAttributesName
   * @returns {Array.<String>} the ids of all attributes
   */
  getAttributesName: function getAttributesName() {
    if (user !== undefined && Array.isArray(user.attributes_name)) {
      return user.attributes_name;
    }
    return [];
  },
  /**
   * @description Returns the user as a JSON object
   * @function
   * @name User#toJSON
   * @returns {Object} the user as json
   */
  toJSON: function toJSON() {
    if (user === undefined || user === null) {
      return {
        "user": {}
      };
    }
    return {
      "user": structuredClone(user)
    };
  }
};
if (window.nixps !== undefined && window.nixps.testing !== undefined) {
  window.nixps.testing.clear_user.push(User.clear);
}
module.exports = User;

},{"../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../PWA/js/Device.js":198}],269:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var TemporyBrowserObjectCache = require("../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var Device = require("../../PWA/js/Device.js");
var versionObject;
var versionDef;
/**
 * @constructor Version
 * @description An utility class reprecenting the version of cloudflow. For Example 22.04 update
 * @param {Object} pObject 
 */
function Version(pObject) {
  this._setVersionObject(pObject);
}
;

/**
 * @name Version.get
 * @function
 * @description Get the version from the backend and fill it in with usefull information
 * @returns {Version}
 */
Version.get = function () {
  if (versionObject === undefined) {
    if (versionDef === undefined) {
      if (TemporyBrowserObjectCache.isPageReload() !== true || Device.getPollingFactor() > 1) {
        var cacheObject = TemporyBrowserObjectCache.get("nixps_cloudflow_version");
        if (cacheObject !== null) {
          versionObject = cacheObject;
          return Promise.resolve(new Version(versionObject));
        }
      }
      versionDef = loadVersionFromBackend();
    }
    return Promise.resolve(versionDef).then(function (pVersionObject) {
      versionObject = pVersionObject;
      TemporyBrowserObjectCache.save("nixps_cloudflow_version", versionObject);
      return new Version(versionObject);
    });
  } else {
    return Promise.resolve(new Version(versionObject));
  }
};

/**
 * @name Version.clear
 * @description reset all the internal caches
 * @private
 * @fucntion
 */
Version.reset = function () {
  versionObject = undefined;
  versionDef = undefined;
  TemporyBrowserObjectCache.remove("nixps_cloudflow_version");
};
Version.prototype = {
  constructor: Version,
  _setVersionObject: function _setVersionObject(pVersionObject) {
    if (pVersionObject !== null && _typeof(pVersionObject) === "object" && !Array.isArray(pVersionObject)) {
      this.versionObject = Object.freeze(pVersionObject);
    } else {
      throw new Error("expect an object as parameter");
    }
  },
  /**
   * @description Get the complete object represention the version
   * @name Version#getVersionObject
   * @function
   * @returns {Object}
   */
  getVersionObject: function getVersionObject() {
    return this.versionObject;
  },
  /**
   * @description Get the build number
   * @function
   * @name Version#getBuild
   * @returns {Number} buildnumber
   */
  getBuild: function getBuild() {
    if (this.versionObject.build !== undefined) {
      return this.versionObject.build;
    }
    return 0;
  },
  /**
   * @name Version#toString
   * @function
   * @description Get a textual representaion of the cloudflow version
   * @returns {String} a textual representation
   */
  toString: function toString() {
    var version = "";
    // control if major and minor number are present, otherwise do nothing.
    if (typeof this.versionObject.major === "number" && this.versionObject.major >= 0 && typeof this.versionObject.minor === "number" && this.versionObject.minor >= 0) {
      version = $.i18n._("nixps-cloudflow-login.version", [this.versionObject.major + "." + this.versionObject.minor, this.versionObject.build]);
      if (typeof this.versionObject.rev === "number" && this.versionObject.rev > 0) {
        version += " " + $.i18n._("nixps-cloudflow-login.versionupdate", [this.versionObject.rev]);
      }
    }
    return version;
  },
  /**
   * @description Converts the Version to a number, it is a help function
   * @private
   * @name Version#toNumber
   * @returns {Number}
   */
  toNumber: function toNumber() {
    return this.getBuild();
  },
  /**
   * @description Get a short notation of the version, that can be used as hash
   * @function
   * @name Version#getHashString
   * @returns {String} A short notation of the version
   */
  getHashString: function getHashString() {
    if (this.versionObject === null || this.versionObject === undefined || this.versionObject.major === undefined) {
      return "00version0";
    }
    return this.versionObject.major + "" + this.versionObject.minor + "version" + this.versionObject.build;
  },
  /**
   * @description The the json of the version object
   * @function
   * @name Version#toString
   * @returns {Object} JSON version of the version object
   */
  toJSON: function toJSON() {
    return Object.assign({}, this.versionObject);
  }
};
function loadVersionFromBackend() {
  return new Promise(function (pResolve, pReject) {
    if (window.api_async === undefined) {
      pResolve({});
      return;
    }
    if (window.api_defer === undefined) {
      pResolve({});
      return;
    }
    api_async.portal.version(function (pVersion) {
      if (pVersion && pVersion.build && window.api_util) {
        api_util.set_cookie("build_version", pVersion.build, {
          path: "/",
          expires: 31,
          samesite: "Strict"
        });
      }
      pResolve(pVersion);
    }, function (pError) {
      console.error(pError);
      pResolve({});
    });
  });
}
module.exports = Version;

},{"../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../PWA/js/Device.js":198}],270:[function(require,module,exports){
"use strict";

var kDeviceClass = Object.freeze(["scnr",
// Input device
"mntr",
// display device
"prtr",
// Output device
"link",
// DeviceLink
"spac",
// ColorSpace 
"abst",
// Abstract
"nmcl" // NamedColor 
]);

module.exports = {
  getDeviceClassDict: function getDeviceClassDict() {
    return kDeviceClass.reduce(function (a, c) {
      a[c] = $.i18n._("nixps-color-iccprofiles.deviceclass_" + c);
      return a;
    }, {});
  }
};

},{}],271:[function(require,module,exports){
"use strict";

var CloudflowObject = require("../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
var additionalType = [{
  "type": "colorspace_devicelinkprofile",
  "renderFunction": function renderFunction(pRow, pOptions) {
    if (pRow && pRow.data && pRow.data.Configuration && pRow.data.Configuration.Options) {
      if (pRow.data.Configuration.Options.DocumentConversion === "UseDeviceLink") {
        return CloudflowObject.getParameter(pRow, pOptions.key);
      } else {
        return "-";
      }
    }
    return "";
  },
  "editable": false,
  "searchRenderFunction": "string",
  "getSearchQueryFunction": function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var value = searchDOMElem.find("input").val();
    if (typeof value === "string" && value.length > 0) {
      return ["(", "data.Configuration.Options.DocumentConversion", "equal to", "UseDeviceLink", ")", "and", "(", pColumnObject.options.key, "contains text like", value, ")"];
    }
    return [];
  },
  "clearSearchFunction": "string"
}, {
  "type": "colorspace_spotcolorbooks",
  "renderFunction": function renderFunction(pLibraries) {
    if (Array.isArray(pLibraries) && pLibraries.length > 0) {
      var libDOMs = new Array(pLibraries.length);
      var text;
      for (var i = 0; i < pLibraries.length; i++) {
        text = undefined; // $SpectralData = Use CxF/X-4 from PDF  $Alternate = Use LAB from PDF,
        if (pLibraries[i] === "$SpectralData") {
          text = $.i18n._("nixps-color-configuration.column_spotlibraries_spectraldata");
        } else if (pLibraries[i] === "$Alternate") {
          text = $.i18n._("nixps-color-configuration.column_spotlibraries_alternate");
        } else {
          if (pLibraries[i].startsWith("cfresource://") === true) {
            text = decodeURIComponent(pLibraries[i].split("/").pop());
          } else {
            text = pLibraries[i];
          }
        }
        libDOMs[i] = $("<span>").addClass("cf-tag").text(text);
      }
      return $("<div>").append(libDOMs);
    }
    return "";
  },
  "editable": false,
  "searchRenderFunction": "string",
  "getSearchQueryFunction": function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var value = searchDOMElem.find("input").val();
    if (typeof value === "string" && value.length > 0) {
      var query = ["(", "data.Configuration.Options.PreferedSpotColorsLibs", "contains text like", value, ")"];
      if ($.i18n._("nixps-color-configuration.column_spotlibraries_spectraldata").toUpperCase().indexOf(value.toUpperCase()) >= 0) {
        query = query.concat(["or", "(", "data.Configuration.Options.PreferedSpotColorsLibs", "equal to", "$SpectralData", ")"]);
      } else if ($.i18n._("nixps-color-configuration.column_spotlibraries_alternate").toUpperCase().indexOf(value.toUpperCase()) >= 0) {
        query = query.concat(["or", "(", "data.Configuration.Options.PreferedSpotColorsLibs", "equal to", "$Alternate", ")"]);
      }
      query.unshift("(");
      query.push(")");
      return query;
    } else {
      return [];
    }
  },
  "clearSearchFunction": "string"
}, {
  "type": "colorspace_smartlinks",
  "renderFunction": function renderFunction(pRow, pOptions) {
    if (pRow && pRow.data && pRow.data.Configuration && pRow.data.Configuration.Options) {
      if (pRow.data.Configuration.Options.DocumentConversion != "ToDestinationColorSpace" && pRow.data.Configuration.Options.DocumentConversionSmartLink == 0) {
        return "-";
      } else {
        return CloudflowObject.getParameter(pRow, pOptions.key);
      }
    }
    return "-";
  },
  "editable": false,
  "searchRenderFunction": "string",
  "getSearchQueryFunction": function getSearchQueryFunction(searchDOMElem, pColumnObject) {
    var value = searchDOMElem.find("input").val();
    if (typeof value === "string" && value.length > 0) {
      return ["(", "data.Configuration.Options.DocumentConversion", "equal to", "ToDestinationColorSpace", ")", "and", "(", "data.Configuration.Options.DocumentConversionSmartLink", "not equal to", 0, "and", "data.Configuration.Options.DocumentConversionSmartLink", "not equal to", false, ")", "and", "(", pColumnObject.options.key, "contains text like", value, ")"];
    }
    return [];
  },
  "clearSearchFunction": "string"
}];
module.exports = additionalType;

},{"../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79}],272:[function(require,module,exports){
"use strict";

var QueryApplier = require("../../cloudflow/CloudflowUtil/js/QueryApplier.js");
var Query = require("../../cloudflow/Table/js/Query.js");
var CloudflowConnection = require("../../cloudflow/CloudflowUtil/js/CloudflowConnection.js");
var QueryUtil = require("../../cloudflow/FolderView/js/QueryUtil.js");
var OldConfigurationManager = function OldConfigurationManager() {
  this.collection = new CloudflowConnection({
    collection: "nucleus.zepra.configuration"
  });
};
OldConfigurationManager.prototype = {
  constructor: OldConfigurationManager,
  list_with_options: function list_with_options(pQuery, pOrderBy, pFields, pOptions) {
    var newQuery = new QueryUtil().modifyQuery(pQuery, ["cloudflow", "file_name", "mime_types", "save_id", "file_time.modification_utc", "need_metadata", "file_extension"], {
      "document_name": "configuration.name"
    });
    return this.collection.list_with_options(newQuery, pOrderBy, pFields, pOptions.first, pOptions.maximum).then(function (pResult) {
      if (pResult && Array.isArray(pResult.results)) {
        for (var i = 0; i < pResult.results.length; i++) {
          if (pResult.results[i].configuration && typeof pResult.results[i].configuration.name === "string") {
            pResult.results[i].document_name = pResult.results[i].configuration.name;
          } else {
            pResult.results[i].document_name = "";
          }
        }
      }
      return pResult;
    });
  },
  merge: function merge(pExternal, pInternal, pQuery, pOrderBy, pFields, pOptions) {
    if (!Array.isArray(pExternal)) {
      throw new Error("parameter must be an array");
    }
    if (!Array.isArray(pInternal)) {
      throw new Error("parameter must be an array");
    }
    var that = this;
    var skip = 0;
    var limit = undefined;
    var last = undefined;
    if (pOptions) {
      //  {first: pSkip, maximum: pLimit}
      if (pOptions.first !== undefined) {
        skip = parseInt(pOptions.first);
      }
      if (pOptions.maximum !== undefined) {
        limit = parseInt(pOptions.maximum);
      }
      if (pOptions.last !== undefined) {
        last = parseInt(pOptions.last);
      }
    }
    var queryApplier;
    var filteredData;
    try {
      queryApplier = new QueryApplier(pQuery);
      filteredData = queryApplier.apply(pExternal.concat(pInternal));
    } catch (e) {
      return Promise.reject(e);
    }
    var rows = Query.apply(filteredData, [], pOrderBy, skip, limit, last);
    var returnObject = {
      results: rows
    };
    if (pOptions && pOptions.count === true) {
      returnObject.count = filteredData.length;
    }
    return returnObject;
  },
  count: function count(pQuery, pOptions) {
    var newQuery = new QueryUtil().modifyQuery(pQuery, ["cloudflow", "file_name", "mime_types", "save_id", "file_time.modification_utc", "need_metadata", "file_extension"], {
      "document_name": "configuration.name"
    });
    return this.collection.count(newQuery, pOptions);
  }
};
module.exports = OldConfigurationManager;

},{"../../cloudflow/CloudflowUtil/js/CloudflowConnection.js":78,"../../cloudflow/CloudflowUtil/js/QueryApplier.js":91,"../../cloudflow/FolderView/js/QueryUtil.js":135,"../../cloudflow/Table/js/Query.js":211}],273:[function(require,module,exports){
"use strict";

var QueryApplier = require("../../cloudflow/CloudflowUtil/js/QueryApplier.js");
var Query = require("../../cloudflow/Table/js/Query.js");
var SpotColorManager = function SpotColorManager(pURL) {
  this.loadDef = null;
  this.data;
  this.setURL(pURL);
};
function _load(pURL) {
  var getUrl = "/portal.cgi?asset=download_file&url=" + encodeURIComponent(pURL);
  return fetch(getUrl, {
    method: "GET"
  }).then(function (pResponse) {
    if (pResponse.ok === false) {
      // we assume the return value is a JSON
      return pResponse.json().then(function (e) {
        return Promise.reject(e);
      });
    }
    return pResponse.text();
  }).then(function (pData) {
    var output = [];
    var contentObject = {};
    var subject = null;
    var lines = pData.split(/\r?\n/);
    if (Array.isArray(lines) && lines.length === 1) {
      // some old MAC OS 9 and older has only \r
      var strangeLines = pData.split(/\r/);
      if (Array.isArray(strangeLines) && strangeLines.length > 1) {
        lines = strangeLines;
      }
    }
    if (!Array.isArray(lines) || lines.length === 0) {
      throw new Error("expected content with multiple lines");
    }
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      if (line.length === 0) {
        // ignore empty lines
        continue;
      }
      if (subject === null && line.endsWith(" =")) {
        subject = line.split(" =")[0];
        continue;
      } else if (line === "{") {
        contentObject[subject] = {};
        continue;
      } else if (line === "}") {
        if (parseInt(subject) == subject) {
          output.push(contentObject[subject]);
        }
        subject = null;
        continue;
      }
      var parts = line.split(" = ");
      var key = parts[0];
      var value = parts[1];
      if (value === "true") {
        value = true;
      } else if (value === "false") {
        value = false;
      } else if (parseFloat(value) == value) {
        value = parseFloat(value);
      } else if (typeof value === "string" && value[0] === '"' && value[value.length - 1] === '"') {
        value = value.substring(1, value.length - 1);
      }
      if (subject === null) {
        console.error("subject is empty and is missing start for " + subject);
      } else if (contentObject[subject] === undefined) {
        console.error("missing start for " + subject);
      }
      contentObject[subject][key] = value;
    }
    for (var _i = 0; _i < output.length; _i++) {
      if (output[_i].ItemCount) {
        output[_i] = {
          _id: ("" + (_i + 1)).padStart(24, "0"),
          file_name: output[_i].Name,
          data: output[_i]
        };
        output[_i].data.location = "internal";
        output[_i].data.count = output[_i].data.ItemCount;
      } else {
        // if ItemCount is missing
        output.splice(_i, 1);
      }
    }
    return output;
  });
}
SpotColorManager.prototype = {
  constructor: SpotColorManager,
  setURL: function setURL(pURL) {
    if (typeof pURL === "string" && pURL.length > 0) {
      this.url = pURL;
    } else {
      throw new Error("invalid url");
    }
  },
  getURL: function getURL() {
    return this.url;
  },
  load: function load() {
    var that = this;
    this.loadDef = _load(this.getURL()).then(function (pResult) {
      that.data = pResult;
    });
    return this.loadDef;
  },
  list_with_options: function list_with_options(pQuery, pOrderBy, pFields, pOptions) {
    var pGoodCB = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
    var pErrorCB = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
    var that = this;
    var skip = 0;
    var limit = undefined;
    var last = undefined;
    if (pOptions) {
      //  {first: pSkip, maximum: pLimit}
      if (pOptions.first !== undefined) {
        skip = parseInt(pOptions.first);
      }
      if (pOptions.maximum !== undefined) {
        limit = parseInt(pOptions.maximum);
      }
      if (pOptions.last !== undefined) {
        last = parseInt(pOptions.last);
      }
    }
    if (this.loadDef === null) {
      this.load();
    }
    return Promise.resolve(this.loadDef).then(function () {
      var queryApplier;
      var filteredData;
      try {
        queryApplier = new QueryApplier(pQuery);
        filteredData = queryApplier.apply(that.data);
      } catch (e) {
        if (typeof pErrorCB === "function") {
          pErrorCB({
            error_code: "invalid_query",
            error: e
          });
        }
        return Promise.reject(e);
      }
      var rows = Query.apply(filteredData, [], pOrderBy, skip, limit, last);
      var returnObject = {
        results: rows
      };
      if (pOptions && pOptions.count === true) {
        returnObject.count = filteredData.length;
      }
      if (typeof pGoodCB === "function") {
        pGoodCB(returnObject);
      }
      return returnObject;
    })["catch"](function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB(pError);
      }
      return Promise.reject(pError);
    });
  },
  merge: function merge(pExternal, pInternal, pQuery, pOrderBy, pFields, pOptions) {
    var pGoodCB = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
    var pErrorCB = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function () {};
    if (!Array.isArray(pExternal)) {
      throw new Error("parameter must be an array");
    }
    if (!Array.isArray(pInternal)) {
      throw new Error("parameter must be an array");
    }
    var that = this;
    var skip = 0;
    var limit = undefined;
    var last = undefined;
    if (pOptions) {
      //  {first: pSkip, maximum: pLimit}
      if (pOptions.first !== undefined) {
        skip = parseInt(pOptions.first);
      }
      if (pOptions.maximum !== undefined) {
        limit = parseInt(pOptions.maximum);
      }
      if (pOptions.last !== undefined) {
        last = parseInt(pOptions.last);
      }
    }
    for (var i = 0; i < pExternal.length; i++) {
      if (!pExternal[i].data) {
        pExternal[i].data = {};
      }
      pExternal[i].data.location = "external";
    }
    var queryApplier;
    var filteredData;
    try {
      queryApplier = new QueryApplier(pQuery);
      filteredData = queryApplier.apply(pExternal.concat(pInternal));
    } catch (e) {
      if (typeof pErrorCB === "function") {
        pErrorCB({
          error_code: "invalid_query",
          error: e
        });
      }
      return Promise.reject(e);
    }
    var rows = Query.apply(filteredData, [], pOrderBy, skip, limit, last);
    var returnObject = {
      results: rows
    };
    if (pOptions && pOptions.count === true) {
      returnObject.count = filteredData.length;
    }
    if (typeof pGoodCB === "function") {
      pGoodCB(returnObject);
    }
    return returnObject;
  },
  count: function count(pQuery) {
    var pGoodCB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var pErrorCB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    return this.list_with_options(pQuery, [], ["_id"], {
      count: true
    }).then(function (pResult) {
      var returnObject = {
        count: NaN
      };
      if (pResult && Array.isArray(pResult.results)) {
        returnObject = {
          count: pResult.results.length
        };
      }
      if (typeof pGoodCB === "function") {
        pGoodCB(returnObject);
      }
      return returnObject;
    })["catch"](function (pError) {
      if (typeof pErrorCB === "function") {
        pErrorCB(pError);
      }
      return Promise.reject(pError);
    });
  }
};
module.exports = SpotColorManager;

},{"../../cloudflow/CloudflowUtil/js/QueryApplier.js":91,"../../cloudflow/Table/js/Query.js":211}],274:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function ($) {
  require("../../cloudflow/FormElements/js/nixps-cloudflow-AutoFillExtend.js");
  require("../../cloudflow/FormElements/js/nixps-cloudflow-Input.js");
  require("../../cloudflow/FormElements/js/nixps-cloudflow-RadioInputs.js");
  require("../../cloudflow/FormElements/js/nixps-cloudflow-Select.js");
  require("../../cloudflow/FormElements/js/nixps-cloudflow-ListEditButtons.js");
  var extendedColorspaceAdditionTypes = require("./ExtendedColorspaceTableTypes.js");
  var CloudflowObject = require("../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
  var CloudflowConnection = require("../../cloudflow/CloudflowUtil/js/CloudflowConnection.js");
  var DeviceClass = require("../../colorspace/js/DeviceClass.js");
  var kDefaultValue = Object.freeze({
    color_policy: {
      configuration: null,
      smartlink_cmyk: null
    },
    print_condition: null,
    variant_method: "none",
    delta_tolerance: null,
    color_books: [],
    use_color_book_in_configuration: false
  });
  var HTMLSkeleton = "<div class='cf-panel'>" + "<div class='cf-panel-head'><h3 class='cf-panel-title' data-i18n='nixps-colorspace-colorspacesettings.maintitle_colorpolicy'></h3></div>" + "<div class='cf-panel-body'>" + "<div class='cf-form-group cf-form-required'>" + "<label class='cf-form-label cf-col-sm-4' data-i18n='nixps-colorspace-colorspacesettings.label_configuration'></label>" + "<div class='cf-col-sm-8 colorspace_resource_input' data-name='configuration'></div>" + "</div>" + "<div class='cf-form-group cf-form-required'>" + "<label class='cf-form-label cf-col-sm-4' data-i18n='nixps-colorspace-colorspacesettings.label_smartlinkcmyk'></label>" + "<div class='cf-col-sm-8 colorspace_resource_input' data-name='smartlink_cmyk'></div>" + "</div>" + "<div class='cf-form-group cf-hide'>" + "<label class='cf-form-label cf-col-sm-4' data-i18n='Tags'></label>" + "<div class='cf-col-sm-8' data-name='tags'></div>" + "</div>" + "</div>" + "</div>" + "<div class='cf-panel'>" + "<div class='cf-panel-head'><h3 class='cf-panel-title' data-i18n='nixps-colorspace-colorspacesettings.maintitle_printconditions'></h3></div>" + "<div class='cf-panel-body'>" + "<div class='cf-form-group cf-form-required'>" + "<label class='cf-form-label cf-col-sm-4' data-i18n='nixps-colorspace-colorspacesettings.label_printcondition'></label>" + "<div class='cf-col-sm-8 colorspace_resource_input' data-name='iccprofile'></div>" + "</div>" + "<div class='cf-form-group'>" + "<label class='cf-form-label cf-col-sm-4' data-i18n='nixps-colorspace-colorspacesettings.label_variantmode'></label>" + "<div class='cf-col-sm-8' data-name='variant_method'></div>" + "<span class='cf-form-helptext cf-col-sm-8 cf-col-sm-offset-4' data-i18n='nixps-colorspace-colorspacesettings.helptext_variantmode'></span>" + "</div>" + "<div class='cf-form-group cf-hide'>" + "<label class='cf-form-label cf-col-sm-4'>∆E*00</label>" + "<div class='cf-col-sm-8' data-name='delta_tolerance'></div>" + "</div>" + "</div>" + "</div>" + "<div class='cf-panel'>" + "<div class='cf-panel-head'><h3 class='cf-panel-title' data-i18n='nixps-colorspace-colorspacesettings.maintitle_colorbooks'></h3></div>" + "<div class='cf-panel-body'>" + "<div class='cf-form-group'>" + "<div class='cf-form-group part_of_colorbooks'>" + "<label class='cf-form-label cf-col-sm-4'> </label>" + "<ul class='cf-col-sm-8 colorbook_items'>" + "</ul>" + "</div>" + "<div class='cf-form-group part_of_colorbooks'>" + "<label class='cf-form-label cf-col-sm-4' data-i18n='nixps-colorspace-colorspacesettings.label_usecolorbooksinconfiguration'></label>" + "<div class='cf-col-sm-8' data-name='use_color_book_in_configuration'></div>" + "</div>" + "</div>" + "</div>" + "</div>" + "</div>";
  var colorbookItemSkeleton = "<li class='cf-form-group'><div class='cf-col-sm-10 colorspace_resource_input' data-name=''></div></li>";

  /**
   * @namespace nixps-colorspace.ColorspaceSettings
   */
  $.widget("nixps-colorspace.ColorspaceSettings", {
    widgetEventPrefix: "colorspacesettings",
    version: "1.0.0",
    options: {
      /**
       * @description The language of the user
       * @name nixps-colorspace.ColorspaceSettings#lang
       * @type String
       * @default undefined
       * @example "en"
       */
      language: undefined,
      /**
       * @description The default text that must be show at the beginning
       * @name nixps-colorspace.ColorspaceSettings#value
       * @type {Object}
       */
      value: Object.assign({}, kDefaultValue),
      /**
       * @description Must we use the SmartLink or not?
       * @tye {Boolean}
       * @name nixps-colorspace.ColorspaceSettings#enableSmartLinkCMYK
       * @default true
       */
      enableSmartLinkCMYK: true,
      /**
       * @description The options of the SmartLinkCMYK
       * @tye {Object}
       * @name nixps-colorspace.ColorspaceSettings#smartLinkCMYK
       */
      smartLinkCMYK: {
        extraQuery: ["data.SrcType", "equal to", "CMYK", "and", "data.DstType", "not equal to", "GRAY", "and", "data.DstType", "not equal to", "RGB"]
      },
      /**
       * @description does we allow the user to modifie and overwrite the color books or not?
       * @name nixps-colorspace.ColorspaceSettings#editColorBooks
       * @type {Boolean}
       * @default true
       */
      editColorBooks: true,
      /**
       * @description Is the field required?
       * @name nixps-colorspace.ColorspaceSettings#required
       * @type Boolean
       * @default false
       * @example true
       */
      required: false
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);

      // variable
      this.alive = true; // is the component on the DOM or is it a zomby
      this.setNameCallingID = 0; // the calling id for retieving data
      this.colorBookOptions = {}; // the options of the AutoFillExtend for Color Books, so we can reuse the options

      this._controlOptions();
      this._draw();
      if (this.options.value) {
        this.setValue(this.options.value);
      }
      this._on(this.element, {
        "fieldcutomprefillfields[data-name='configuration']": this._configurationChangeHandler,
        "fieldcutomprefillfields.colorspace_resource_input": this._colorspaceResourceChangeHandler,
        "fieldcutomprefillfields": this._prefillHandler,
        "change [data-name='variant_method']": this._suggestedBestVariantChangeHander
      });
    },
    /**
     * @description control the input options of the widget/component
     * @function
     * @private
     * @name nixps-colorspace.ColorspaceSettings#_controlOptions
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {},
    _configurationChangeHandler: function _configurationChangeHandler(pEvent, pData) {
      var configurationData = pData.prefillObject;
    },
    _colorspaceResourceChangeHandler: function _colorspaceResourceChangeHandler(pEvent, pData) {
      if (pData) {
        var inputDOM = $(pEvent.target).closest(".nixps-cloudflow-AutoFillExtend");
        if (pData.rowObject && pData.rowObject.cloudflow && typeof pData.rowObject.cloudflow.file === "string" && pData.rowObject.cloudflow.file.length > 0) {
          inputDOM.data("colorResourceValue", pData.rowObject.cloudflow.file);
        }
        var key = inputDOM.AutoFillExtend("option", "key");
        inputDOM.AutoFillExtend("setValue", CloudflowObject.getParameter(pData.rowObject, key));
        this.element.trigger("fieldcustomchange");
      }
    },
    _prefillHandler: function _prefillHandler(pEvent, pData) {
      pEvent.preventDefault();
      pEvent.stopPropagation();
      return false;
    },
    _suggestedBestVariantChangeHander: function _suggestedBestVariantChangeHander(pEvent, pData) {
      var value = this.element.find("[data-name='variant_method']").RadioInputs("getValue");
      if (value === "custom_delta_max") {
        this.element.find("[data-name='delta_tolerance']").closest(".cf-form-group").removeClass("cf-hide");
      } else {
        this.element.find("[data-name='delta_tolerance']").closest(".cf-form-group").addClass("cf-hide");
      }
    },
    /**
     * @desc Redraw
     * @function
     * @name nixps-colorspace.ColorspaceSettings#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @desc Draws the input
     * @private
     * @function
     * @name nixps-colorspace.ColorspaceSettings#_draw
     */
    _draw: function _draw() {
      /*
          "helaba": {
              "color_policy": {
                  "configuration": "cloudflow://",
                  "smartlink_cmyk": "cloudflow://",
              },
              "print_condition":  "cloudflow://",
              "variant_method": [ "none" | "colorlogic" | "custom_delta_max" ]
              "delta_tolerance": <Number 2 cijfer na komma > | null   
              "color_books": ["cloudflow://"],
              "use_color_book_in_configuration": <Boolean>
          }
      */
      var that = this;
      this.element.empty();
      this.element.append(HTMLSkeleton);

      // translate 
      this.element.find("[data-i18n]").each(function () {
        var key = $(this).attr("data-i18n");
        if (typeof key === "string" && key.length > 0) {
          $(this).text($.i18n._(key));
        }
      });

      // add terget profile
      this.element.find("[data-name='configuration']").AutoFillExtend({
        "language": this.options.language,
        "tableOptions": {
          "collection": "assetmetadata.colorspace_configurations",
          "tableOptions": {
            "columns": [{
              "type": "text",
              "sortable": true,
              "searchable": true,
              "key": "document_name",
              "label": $.i18n._("nixps-color-configuration.column_name")
            }, {
              "type": "text",
              "sortable": true,
              "searchable": true,
              "key": "data.Configuration.Options._DstProfile_filename",
              "label": $.i18n._("nixps-color-configuration.column_targeticcprofile")
            }, {
              "type": "colorspace_smartlinks",
              "sortable": true,
              "searchable": true,
              "key": ".",
              "label": $.i18n._("nixps-color-configuration.column_smartlinkmethod_cmyk"),
              "options": {
                "key": "data.Configuration.Options.SmartLinkPresetCMYK"
              }
            }, {
              "type": "text",
              "sortable": true,
              "searchable": true,
              "key": "data.Configuration.Options.Tags",
              "label": $.i18n._("nixps-color-configuration.column_tags")
            }],
            "maxRows": 20
          },
          "extraQuery": [],
          "enableCollapsible": false,
          "refreshDelay": 0,
          "additionalTypes": extendedColorspaceAdditionTypes
        },
        "dialogOptions": {
          "top": "5%"
        },
        "height": "",
        "inputClasses": "cf-form-control",
        "key": "document_name",
        "editable": false,
        "disabled": this.options.disabled
      });
      if (this.options.enableSmartLinkCMYK) {
        this.element.find("[data-name='smartlink_cmyk']").AutoFillExtend({
          "language": this.options.language,
          "placeholder": "",
          "tableOptions": {
            "collection": "assetmetadata.colorspace_smartlink",
            "tableOptions": {
              "columns": [{
                "type": "text",
                "sortable": true,
                "searchable": true,
                "key": "data.Name",
                "label": $.i18n._("nixps-color-smartlink.column_name")
              }, {
                "type": "text",
                "sortable": true,
                "searchable": true,
                "key": "data.SrcType",
                "label": $.i18n._("nixps-color-smartlink.column_sourcetype")
              }, {
                "type": "text",
                "sortable": true,
                "searchable": true,
                "key": "data.DstType",
                "label": $.i18n._("nixps-color-smartlink.column_destinationtype")
              }],
              "maxRows": 20
            },
            "extraQuery": this.options.smartLinkCMYK.extraQuery,
            "enableCollapsible": false,
            "refreshDelay": 0
          },
          "assetmetadataTable": "colorspace_smartlink",
          "dialogOptions": {
            "top": "5%"
          },
          "height": "",
          "inputClasses": "cf-form-control",
          "key": "data.Name",
          "editable": false,
          "disabled": this.options.disabled
        });
      } else {
        this.element.find("[data-name='smartlink_cmyk']").closest(".cf-form-group").addClass("cf-hide");
      }
      this.element.find("[data-name='iccprofile']").AutoFillExtend({
        "language": this.options.language,
        "tableOptions": {
          "collection": "assetmetadata.colorspace_icc",
          "tableOptions": {
            "columns": [{
              "type": "text",
              "sortable": true,
              "searchable": true,
              "key": "file_name",
              "label": $.i18n._("nixps-color-iccprofiles.column_name")
            }, {
              "type": "text",
              "sortable": true,
              "searchable": true,
              "key": "data.colorSpace",
              "label": $.i18n._("nixps-color-iccprofiles.column_colorspace")
            }, {
              "type": "enum",
              "sortable": true,
              "searchable": true,
              "key": "data.deviceClass",
              "label": $.i18n._("nixps-color-iccprofiles.column_deviceclass"),
              "options": {
                "keyValues": DeviceClass.getDeviceClassDict()
              }
            }],
            "maxRows": 20
          },
          "extraQuery": ["data.deviceClass", "equal to", "prtr", "and", "data.colorSpace", "not equal to", "GRAY", "and", "data.colorSpace", "not equal to", "RGB "],
          "enableCollapsible": false,
          "refreshDelay": 0
        },
        "assetmetadataTable": "colorspace_icc",
        "dialogOptions": {
          "top": "50%"
        },
        "height": "300",
        "inputClasses": "cf-form-control",
        "key": "file_name",
        "editable": false,
        "disabled": this.options.disabled
      });
      this.element.find("[data-name='variant_method']").RadioInputs({
        "language": this.options.language,
        "radioInputs": [{
          "imgUrl": "",
          "text": $.i18n._("nixps-colorspace-colorspacesettings.variantmode_none"),
          "value": "none"
        }, {
          "imgUrl": "",
          "text": $.i18n._("nixps-colorspace-colorspacesettings.variantmode_colorlogic"),
          "value": "colorlogic"
        }, {
          "imgUrl": "",
          "text": $.i18n._("nixps-colorspace-colorspacesettings.variantmode_deltamax"),
          "value": "custom_delta_max"
        }],
        "imgWidth": 25,
        "imgHeight": 25,
        "defaultValue": "none",
        "name": "variant_method",
        "dynamicNameMethod": null,
        "disabled": this.options.disabled
      });
      this.element.find("[data-name='delta_tolerance']").Input({
        "type": "decimal",
        "min": 0,
        "max": 100,
        "disabled": this.options.disabled
      });
      this.colorBookOptions = {
        "language": this.options.language,
        "placeholder": "",
        "tableOptions": {
          "collection": "assetmetadata.colorspace_colorbook",
          "tableOptions": {
            "columns": [{
              "type": "text",
              "sortable": true,
              "searchable": true,
              "key": "file_name",
              "label": $.i18n._("nixps-color-smartlink.column_name")
            }, {
              "type": "number",
              "sortable": true,
              "searchable": true,
              "key": "data.count",
              "label": $.i18n._("nixps-color-colorbook.colorantcount")
            }],
            "maxRows": 10
          },
          "extraQuery": ["data.location", "equal to", "external"],
          "enableCollapsible": false,
          "refreshDelay": 0
        },
        "assetmetadataTable": "colorspace_colorbook",
        "dialogOptions": {
          "top": "5%"
        },
        "height": "",
        "inputClasses": "cf-form-control",
        "key": "file_name",
        "editable": false,
        "disabled": this.options.disabled || this.options.editColorBooks === false
      };
      this.element.find(".colorbook_items").ListEditButtons({
        "language": this.options.language,
        "rowSelector": "li",
        "allowEmptyValue": true,
        "buttonClasses": "cf-col-sm-2",
        "createEmptyRowOnStart": false,
        "firstButtonHTML": "<button type='button' class='cf-iconbutton cf-icon cf-icon-bg cf-icon-minus-circle leb_removebutton'></button>",
        "secondButtonHTML": "<button type='button' class='cf-iconbutton cf-icon cf-icon-bg cf-icon-plus-circle leb_addbutton'></button>",
        "appendEmptyRow": function appendEmptyRow(pParentDOM) {
          var rowDOM = $(colorbookItemSkeleton);
          rowDOM.find("div").data("colorResourceValue", null).AutoFillExtend(that.colorBookOptions).toggleClass("disabledByCreation", that.options.editColorBooks === false);
          return rowDOM;
        },
        "disabled": this.options.disabled || this.options.editColorBooks === false
      }).toggleClass("disabledByCreation", this.options.editColorBooks === false);
      this.element.find("[data-name='use_color_book_in_configuration']").Input({
        "type": "checkbox",
        "checkboxLabel": $.i18n._("nixps-colorspace-colorspacesettings.checkboxlabel_usecolorbooksinconfiguration"),
        "disabled": this.options.disabled || this.options.editColorBooks === false
      }).toggleClass("disabledByCreation", this.options.editColorBooks === false);
    },
    /**
     * @description Function returns the value of the inputField as type: defined in option type.
     * Pay attention for return carries in textarea. It use the normal jquery .val() function for textareas. 
     * @function
     * @name nixps-colorspace.ColorspaceSettings#getValue
     * @returns {String}
     */
    getValue: function getValue() {
      /*
       "helaba": {
              "color_policy": {
                  "configuration": "cloudflow://",
                  "smartlink_cmyk": "cloudflow://",
              },
              "print_condition":  "cloudflow://",
              "variant_method": [ "none" | "colorlogic" | "custom_delta_max" ]
              "delta_tolerance": <Number 2 cijfer na komma > | null   
              "color_books": ["cloudflow://"],
              "use_color_book_in_configuration": <Boolean>
          }
      */

      var configuration = this.element.find("[data-name='configuration']").data("colorResourceValue");
      var smartlink_cmyk = this.element.find("[data-name='smartlink_cmyk']").data("colorResourceValue");
      var print_condition = this.element.find("[data-name='iccprofile']").data("colorResourceValue");
      var variant_method = this.element.find("[data-name='variant_method']").RadioInputs("getValue");
      var delta_tolerance = this.element.find("[data-name='delta_tolerance']").Input("getValue");
      var use_color_book_in_configuration = this.element.find("[data-name='use_color_book_in_configuration']").Input("getValue");
      var output = {
        color_policy: {
          configuration: configuration,
          smartlink_cmyk: null
        },
        print_condition: print_condition || null,
        variant_method: variant_method || "none",
        delta_tolerance: null,
        color_books: [],
        use_color_book_in_configuration: false
      };
      if (this.options.enableSmartLinkCMYK === true && smartlink_cmyk) {
        output.color_policy.smartlink_cmyk = smartlink_cmyk;
      }
      if (output.variant_method === "custom_delta_max") {
        output.delta_tolerance = delta_tolerance;
      } else {
        output.delta_tolerance = null;
      }
      output.use_color_book_in_configuration = use_color_book_in_configuration;
      this.element.find(".colorbook_items li").each(function () {
        var colorbookURL = $(this).find(".nixps-cloudflow-AutoFillExtend").data("colorResourceValue");
        if (typeof colorbookURL === "string" && colorbookURL.length > 0) {
          output.color_books.push(colorbookURL);
        }
      });
      output.color_books = _toConsumableArray(new Set(output.color_books)); // make unique
      return output;
    },
    /**
     * @description Set the input field to a specific value
     * @function
     * @name nixps-colorspace.ColorspaceSettings#setValue
     * @param {type} pValue
     * @returns {undefined}
     */
    setValue: function setValue(pValue) {
      var that = this;
      var values = Object.assign({
        color_policy: {
          smartlink_cmyk: null
        },
        print_condition: null,
        variant_method: "none",
        delta_tolerance: null,
        color_books: [],
        use_color_book_in_configuration: false
      }, pValue);

      // color policy
      this.element.find("[data-name='configuration']").data("colorResourceValue", values.color_policy.configuration).AutoFillExtend("setValue", "");
      if (this.options.enableSmartLinkCMYK === true) {
        this.element.find("[data-name='smartlink_cmyk']").data("colorResourceValue", values.color_policy.smartlink_cmyk).AutoFillExtend("setValue", "");
      }

      // print condition
      this.element.find("[data-name='iccprofile']").data("colorResourceValue", values.print_condition).AutoFillExtend("setValue", "");
      this.element.find("[data-name='variant_method']").RadioInputs("setValue", values.variant_method);
      if (values.variant_method === "custom_delta_max") {
        this.element.find("[data-name='delta_tolerance']").closest(".cf-form-group").removeClass("cf-hide");
        this.element.find("[data-name='delta_tolerance']").Input("setValue", values.delta_tolerance || 0);
      } else {
        this.element.find("[data-name='delta_tolerance']").closest(".cf-form-group").addClass("cf-hide");
      }

      // color books
      this.element.find(".colorbook_items li").remove();
      if (Array.isArray(values.color_books) && values.color_books.length > 0) {
        values.color_books = _toConsumableArray(new Set(values.color_books)); // make unique
        var newDOMs = new Array(values.color_books.length);
        values.color_books.forEach(function (pColorBookURL, pIndex) {
          if (typeof pColorBookURL === "string" && pColorBookURL.indexOf("cloudflow://") === 0) {
            var newDOM = $(colorbookItemSkeleton);
            newDOM.find("div").data("colorResourceValue", pColorBookURL).AutoFillExtend(that.colorBookOptions).toggleClass("disabledByCreation", that.options.editColorBooks === false);
            newDOMs[pIndex] = newDOM;
          }
        });
        this.element.find(".colorbook_items").append(newDOMs);
      }
      this.element.find("[data-name='use_color_book_in_configuration']").Input("setValue", !!values.use_color_book_in_configuration);

      // refill the names 
      var currentCallingID = ++this.setNameCallingID;
      this.element.find(".colorspace_resource_input").each(function () {
        var thisDOM = $(this);
        var fileURL = thisDOM.data("colorResourceValue");
        if (typeof fileURL === "string" && fileURL.length > 0 && fileURL.indexOf("cloudflow://") === 0) {
          var key = thisDOM.AutoFillExtend("option", "key");
          var collection = thisDOM.AutoFillExtend("option", "tableOptions.collection");
          if (typeof collection === "string" && collection.length > 0) {
            thisDOM.AutoFillExtend("option", "disabled", true);
            var cloudflowConnection = new CloudflowConnection({
              collection: collection
            });
            cloudflowConnection.list_with_options(["cloudflow.file", "equal to", fileURL], [], [key], 0, 1).then(function (pResult) {
              if (that.element.hasClass("nixps-kiosk-Summary")) {
                thisDOM.find("div.input").text(CloudflowObject.getParameter(pResult.results[0], key));
                return;
              }
              if (that.alive === false) {
                return;
              }
              if (currentCallingID !== that.setNameCallingID) {
                return;
              }
              thisDOM.AutoFillExtend("option", "disabled", false);
              if (pResult && Array.isArray(pResult.results) && pResult.results.length === 1) {
                thisDOM.AutoFillExtend("setValue", CloudflowObject.getParameter(pResult.results[0], key));
                return;
              }
              return Promise.reject({
                error_code: "missing_data"
              });
            })["catch"](function (pError) {
              console.error(pError);
              thisDOM.AutoFillExtend("option", "disabled", false);
              thisDOM.AutoFillExtend("setValue", "");
              return Promise.reject(pError);
            });
          }
        }
      });
    },
    /**
     * @description Controls if the input is valid
     * @function
     * @name nixps-colorspace.ColorspaceSettings#isValid
     * @returns {Boolean_string} - true, if everything is correct, or a string containing the errormessage
     */
    isValid: function isValid() {
      // reset errors
      this.element.find(".cf-form-invalid").removeClass("cf-form-invalid");
      // inform of missing data
      var errorMessage = null;
      this.element.find(".colorspace_resource_input:visible").each(function () {
        var formGroupDOM = $(this).closest(".cf-form-group");
        if (formGroupDOM.hasClass("cf-form-required")) {
          var value = $(this).data("colorResourceValue");
          if (value === null) {
            formGroupDOM.addClass("cf-form-invalid");
            errorMessage = "missing data";
          }
        }
      });
      if (errorMessage === null) {
        return true;
      } else {
        return errorMessage;
      }
    },
    reset: function reset() {
      this.setValue(Object.assign({}, kDefaultValue));
      this.element.find("[data-name='delta_tolerance']").Input("reset");
    },
    enable: function enable() {
      return this._setOption("disabled", false);
    },
    disable: function disable() {
      return this._setOption("disabled", true);
    },
    _setOptions: function _setOptions(pOptions) {
      this._superApply(arguments);
      this._controlOptions();
      var oldValue = this.getValue();
      this._draw();
      this.setValue(oldValue);
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      if (pKey === "disabled") {
        this.element.find(".nixps-cloudflow-AutoFillExtend").not(".disabledByCreation").AutoFillExtend("option", "disabled", pValue);
        this.element.find(".nixps-cloudflow-Input").not(".disabledByCreation").Input("option", "disabled", pValue);
        this.element.find(".nixps-cloudflow-RadioInputs").not(".disabledByCreation").RadioInputs("option", "disabled", pValue);
        this.element.find(".colorbook_items").not(".disabledByCreation").ListEditButtons("option", "disabled", pValue);
      }
      if (pKey === "required") {
        // this.element.find("input, textarea").prop("required", pValue);
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../cloudflow/CloudflowUtil/js/CloudflowConnection.js":78,"../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79,"../../cloudflow/FormElements/js/nixps-cloudflow-AutoFillExtend.js":140,"../../cloudflow/FormElements/js/nixps-cloudflow-Input.js":150,"../../cloudflow/FormElements/js/nixps-cloudflow-ListEditButtons.js":152,"../../cloudflow/FormElements/js/nixps-cloudflow-RadioInputs.js":156,"../../cloudflow/FormElements/js/nixps-cloudflow-Select.js":160,"../../colorspace/js/DeviceClass.js":270,"./ExtendedColorspaceTableTypes.js":271}],275:[function(require,module,exports){
"use strict";

(function ($) {
  /**
   * @namespace nixps.ActionMenu
   * @description Draw an action menu
   * @example $('<div>').ActionMenu({});
   */
  $.widget("nixps.ActionMenu", $.Widget, {
    widgetEventPrefix: "actionmenu",
    options: {
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.ActionMenu#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._draw();
      this._hideHandler = this.hide.bind(this);
      $("body").on("click", this._hideHandler);
      this.element.on({
        // "blur": this.hide.bind(this), //disabled the blur - interferes when there's anchor tags
        "click": this.hide.bind(this)
      });
      this.options.created();
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.ActionMenu#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.ActionMenu#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      this.element.css("display", "fixed");
      this.element.attr("tabindex", "-1");
      this.element.hide();
    },
    _renderRows: function _renderRows(pRows) {
      var _this = this;
      var that = this;
      var actionList = $("<div>").addClass("actionList cf-dropdown");
      var _loop = function _loop() {
        if (pRows[i] === "separator" || pRows[i].separator === true) {
          actionList.append($("<div>").addClass("cf-dropdown-separator"));
        } else if (pRows[i] && Array.isArray(pRows[i].subbuttons) === true) {
          action = $("<div>").addClass("actionListItem cf-dropdown-item cf-dropdown-submenubutton cfappbrowser_opendetails").addClass(pRows[i].classes);
          action.append($("<span>").addClass("cf-dropdown-icon actionListIcon " + pRows[i].iconClass));
          action.append($("<span>").addClass("dropdownlist_itemtext").html(pRows[i].text));
          if (pRows[i].hidden === true) {
            action.addClass("cf-dropdown-item-hidden");
          }
          var submenu = $("<div>").addClass("actionList cf-dropdown cf-dropdown-submenu");
          pRows[i].subbuttons.forEach(function (pSubButton) {
            var subaction = $("<div>").addClass("actionListItem cf-dropdown-item cfappbrowser_opendetails").addClass(pSubButton.classes);
            subaction.append($("<span>").addClass("cf-dropdown-icon actionListIcon " + pSubButton.iconClass));
            subaction.append($("<span>").addClass("dropdownlist_itemtext").html(pSubButton.text));
            if (pSubButton.hidden === true) {
              subaction.addClass("cf-dropdown-item-hidden");
            } else if (pRows[i].disabled === true) {
              subaction.addClass("cf-disabled disabled");
            }
            subaction.on("click", pSubButton.onClick);
            submenu.append(subaction);
          });
          action.on("click", function (pEvent) {
            submenu.css({
              display: "block",
              left: that.element.width() - 1
            });
            var yPos = $(pEvent.target).closest(".actionListItem").offset().top - $(pEvent.target).closest(".actionListItem").offsetParent().offset().top;
            //TODO: improve this for small screen
            if (yPos + that.element.offset().top + submenu.height() > that.window.height()) {
              yPos = yPos - submenu.height() + $(pEvent.target).closest(".actionListItem").outerHeight(); // flip side
            }

            submenu.css({
              top: yPos
            });
            if (submenu.offset().top < 0) {
              submenu.css({
                top: 0
              });
            }
          });
          _this.element.append(submenu);
          actionList.append(action);
        } else if (pRows[i] && typeof pRows[i].clickCB === "string") {
          // make an anchor tag
          action = $("<a>").addClass("actionListItem cf-dropdown-item-block cf-dropdown-item cfappbrowser_opendetails").addClass(pRows[i].classes);
          action.append($("<span>").addClass("cf-dropdown-icon actionListIcon " + pRows[i].iconClass));
          action.append($("<span>").addClass("dropdownlist_itemtext").html(pRows[i].text));
          action[0].href = pRows[i].clickCB;
          if (pRows[i].hidden === true) {
            action.addClass("cf-dropdown-item-hidden");
          } else if (pRows[i].disabled === true) {
            action.addClass("cf-disabled disabled");
            action[0].disabled = true;
          }
          if (pRows[i].download_filename) {
            action.attr("download", pRows[i].download_filename);
          }
          actionList.append(action);
        } else {
          action = $("<div>").addClass("actionListItem cf-dropdown-item cfappbrowser_opendetails").addClass(pRows[i].classes);
          action.append($("<span>").addClass("cf-dropdown-icon actionListIcon " + pRows[i].iconClass));
          action.append($("<span>").addClass("dropdownlist_itemtext").html(pRows[i].text));
          if (pRows[i].hidden === true) {
            action.addClass("cf-dropdown-item-hidden");
          } else if (pRows[i].disabled === true) {
            action.addClass("cf-disabled disabled");
          }
          action.on("click", pRows[i].onClick);
          actionList.append(action);
        }
      };
      for (var i = 0; i < pRows.length; i++) {
        var action, action, action;
        _loop();
      }
      this.element.append(actionList);
      this._trigger("drawn", null, this.element);
    },
    /**
     * @description Show the context menu on the desired coordinates
     * @function
     * @name nixps.ActionMenu#show
     * @param {Number} pPosX 
     * @param {Number} pPosY 
     * @param {Array} pRows 
     * @example pRows:
     * [{
     * text: String
     * iconClass: String
     * onClick: Function
     * }, ...]
     */
    show: function show(pPosX, pPosY, pRows) {
      this.element.empty();
      if (Array.isArray(pRows) && pRows.length > 0) {
        this._renderRows(pRows);
        if (pPosY + this.element.height() > this.window.height()) {
          pPosY = pPosY - this.element.height();
          if (pPosY < 0) {
            pPosY = 0;
          }
        }
        if (pPosX + this.element.width() > this.window.width()) {
          pPosX = pPosX - this.element.width();
          if (pPosX < 0) {
            pPosX = 0;
          }
        }
        this.element.css({
          top: pPosY,
          left: pPosX,
          display: ""
        });
        this.element.focus();
      } else {
        throw new Error("Invalid attributes");
      }
    },
    /**
     * @description Hide the context menu
     * @function
     * @name nixps.ActionMenu#hide
     */
    hide: function hide(pEvent) {
      if (this.isOpen() && (pEvent === undefined || pEvent !== undefined && $(pEvent.target).closest(".cf-dropdown-item").hasClass("cf-dropdown-submenubutton") === false)) {
        this.element.css({
          top: 0,
          left: 0,
          display: "none"
        });
      }
    },
    isOpen: function isOpen() {
      return this.element.css("display") !== "none";
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.ActionMenu#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._draw();
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      $("body").off("click", this._hideHandler);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],276:[function(require,module,exports){
"use strict";

var matchLanguage = require("./matchLanguage.js");
var kKnownLanguages = require("../../../cloudflow/TranslatedLanguagesSelector/js/translatedLanguages.js");

/**
 * @description Returns one of the supported languages by matching with browser languaged.  
 * If no browser language is found or no match is found in the supportedLanguages, the passed default is used.
 * ISO codes with a sub eg "en-GB" will be matched first completely, if no match is found "en" will be matched.
 * @function
 * @module matchBrowserLanguage
 * @param {string} pDefaultLanguage the default language to return in case no match is found
 */
function matchBrowserLanguage() {
  var pDefaultLanguage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
  var browserLanguage = null;
  if (window.navigator) {
    browserLanguage = window.navigator.language || window.navigator.userLanguage || null;
  }
  return matchLanguage(browserLanguage, kKnownLanguages, pDefaultLanguage);
}
module.exports = matchBrowserLanguage;

},{"../../../cloudflow/TranslatedLanguagesSelector/js/translatedLanguages.js":239,"./matchLanguage.js":277}],277:[function(require,module,exports){
"use strict";

/**
 * @description Returns one of the supported languages by matching with the passed language
 * ISO codes with a sub eg "en-GB" will be matched first completely, if no match is found "en" will be matched.
 * @function
 * @module matchLanguage
 * @param {String|null} pLanguage the provided language to match with, either a language iso code or null in case no language is configured
 * @param {Array<String>} pSupportedLanguages the list of ISO codes to match with
 * @param {String} pDefaultLanguage the default language to return in case no match is found
 */
function matchLanguage(pLanguage, pSupportedLanguages) {
  var pDefaultLanguage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";
  if (typeof pLanguage !== "string" && pLanguage !== null) {
    throw new Error("invalid language to match");
  }
  if (Array.isArray(pSupportedLanguages) === false || pSupportedLanguages.length === 0) {
    throw new Error("invalid supportedLanguages parameter passed, should be an array with at least one item.");
  }
  if (typeof pDefaultLanguage !== "string" || pDefaultLanguage.length === 0) {
    throw new Error("a default language code should be passed in case there is no match");
  }
  if (pLanguage === null) {
    return pDefaultLanguage;
  }
  if (pSupportedLanguages.indexOf(pLanguage) >= 0) {
    return pLanguage;
  }

  // Try go split the iso code
  if (pLanguage.indexOf("-") >= 0) {
    var parts = pLanguage.split("-");
    var langBase = parts[0];
    if (pSupportedLanguages.indexOf(langBase) >= 0) {
      return langBase;
    }
  }
  if (pSupportedLanguages.indexOf(pDefaultLanguage) >= 0) {
    return pDefaultLanguage;
  }

  // Could not match, return the default
  return "en";
}
module.exports = matchLanguage;

},{}],278:[function(require,module,exports){
"use strict";

var QueryApplier = require("../../../cloudflow/CloudflowUtil/js/QueryApplier.js");
var expireTime = 15778800000; // 6 months
var kDBVersion = 2;

/**
 * @constructor IndexedStorage
 * @description Save and retrieve big amount or huge data on the browser
 * @param {String} pStoreName Store name to use.
 */
function IndexedStorage(pStoreName) {
  // compatibility with different browsers
  if (window.indexedDB === undefined) {
    window.indexedDB = window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
  }
  if (window.IDBTransaction === undefined) {
    window.IDBTransaction = window.webkitIDBTransaction || window.msIDBTransaction;
  }
  if (window.IDBKeyRange === undefined) {
    window.IDBKeyRange = window.webkitIDBKeyRange || window.msIDBKeyRange;
  }
  if (typeof pStoreName !== "string" || pStoreName.length <= 0) {
    throw new Error("Store name not specified");
  }
  this.storeName = pStoreName;
  this.db = undefined;
  this._couldNotOpenError = undefined;
}
;

/**
 * @description Add data to specified store
 * @name IndexedStorage.add
 * @param {String} pStoreName Store name to use.
 * @param {any} pDataToAdd Data to add
 * @returns {Promise}
 */
IndexedStorage.add = function (pStoreName, pDataToAdd) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      return store.add(pDataToAdd).then(function () {
        store.close();
        pResolve();
      })["catch"](pReject);
    })["catch"](pReject);
  });
};

/**
 * @description Add multiple data entries to specified store
 * @name IndexedStorage.addMultiple
 * @param {String} pStoreName Store name to use.
 * @param {Array<any>} pDataArrayToAdd Data to add
 */
IndexedStorage.addMultiple = function (pStoreName, pDataArrayToAdd) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      return store.addMultiple(pDataArrayToAdd).then(function () {
        store.close();
        pResolve();
      })["catch"](pReject);
    })["catch"](pReject);
  });
};

/**
 * @description Set the store to specified data. This clears the old store.
 * @name IndexedStorage.set
 * @param {String} pStoreName Store name to use.
 * @param {any} pDataToSet Data to set
 */
IndexedStorage.set = function (pStoreName, pDataToSet) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      store.set(pDataToSet).then(function () {
        store.close();
        pResolve();
      })["catch"](pReject);
    })["catch"](pReject);
  });
},
/**
 * @description Update data entries according to the filter
 * @name IndexedStorage.update_with_filter
 * @param {String} pStoreName Store name to use.
 * @param {Function} pFilter Function that filters the data to update
 * @param {Function} pNewData Function that updates the data.
 */
IndexedStorage.update_with_filter = function (pStoreName, pFilter, pNewData) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      store.update_with_filter(pFilter, pNewData).then(function () {
        store.close();
        pResolve();
      })["catch"](pReject);
    })["catch"](pReject);
  });
};

/**
 * @description Returns the last item in store
 * @name IndexedStorage.getLast
 * @param {String} pStoreName Store name to use.
 */
IndexedStorage.getLast = function (pStoreName) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      store.getLast().then(function (last) {
        store.close();
        pResolve(last);
      })["catch"](pReject);
    })["catch"](pReject);
  });
};

/**
 * @description Get the items from store with a filter
 * @name IndexedStorage.list_with_filter
 * @param {String} pStoreName Store name to use.
 * @param {Function} pFilter Function that filters the items
 */
IndexedStorage.list_with_filter = function (pStoreName, pFilter) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      store.list_with_filter(pFilter).then(function (data) {
        store.close();
        pResolve(data);
      })["catch"](pReject);
    })["catch"](pReject);
  });
};

/**
 * @description Get the items from store with a query
 * @name IndexedStorage.list_with_options
 * @param {String} pStoreName Store name to use.
 * @param {Array} pQuery
 */
IndexedStorage.list_with_options = function (pStoreName, pQuery) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      store.list_with_options(pQuery).then(function (data) {
        store.close();
        pResolve(data);
      })["catch"](pReject);
    })["catch"](pReject);
  });
};

/**
 * @description Clear the storage
 * @name IndexedStorage.clear
 * @param {String} pStoreName Store name to use.
 */
IndexedStorage.clear = function (pStoreName) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      store.clear().then(function () {
        store.close();
        pResolve();
      })["catch"](pReject);
    })["catch"](pReject);
  });
};

/**
 * @description Delete filtered items from store
 * @name IndexedStorage.delete_with_filter
 * @param {String} pStoreName Store name to use.
 * @param {Function} pFilter Filter function to use
 */
IndexedStorage.delete_with_filter = function (pStoreName, pFilter) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      store.delete_with_filter(pFilter).then(function () {
        store.close();
        pResolve();
      })["catch"](pReject);
    })["catch"](pReject);
  });
};

/**
 * @description Counts the amount of items in a store
 * @name IndexedStorage.count
 * @param {String} pStoreName Store name to use.
 */
IndexedStorage.count = function (pStoreName) {
  return new Promise(function (pResolve, pReject) {
    var store = new IndexedStorage(pStoreName);
    store.open().then(function () {
      return store.count().then(function (pData) {
        store.close();
        pResolve(pData);
      })["catch"](pReject);
    })["catch"](pReject);
  });
};

/**
 * @description Is indexedStorage supported on this browser?
 * @function
 * @name IndexedStorage.isSupported
 */
IndexedStorage.isSupported = function () {
  if (window.origin === "null") {
    return false;
  }
  if (window.indexedDB !== undefined) {
    return true; // indexedDB can not be overwitten is exists
  }

  window.indexedDB = window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
  if (!window.indexedDB) {
    return false;
  }
  return true;
};

/**
 * @description Delete database
 * @name IndexedStorage.deleteDB
 * @param {String} pDBName Database name to delete from indexedstorage
 * @return {Promise}
 */
IndexedStorage.deleteDB = function (pDBName) {
  return new Promise(function (pResolve, pReject) {
    var req = indexedDB.deleteDatabase(pDBName);
    req.onsuccess = function () {
      pResolve();
    };
    req.oncomplete = function () {
      pResolve();
    };
    req.onerror = function (pEvent) {
      pReject("Couldn't delete database");
    };
    req.onblocked = function (pEvent) {
      pReject("Couldn't delete database due to the operation being blocked");
    };
    req.onupgradeneeded = function (pEvent) {
      pReject("Couldn't delete database due to the operation being blocked");
    };
  });
};
IndexedStorage.prototype = {
  constructor: IndexedStorage,
  /**
   * @description Open indexedDB connection
   * @name IndexedStorage.open
   * @param {Object} pOptions Options for opening the connection
   */
  open: function open(pOptions) {
    var that = this;
    var dbName = "cloudflow";
    if (pOptions !== undefined && pOptions !== null && typeof pOptions.dbName === "string") {
      dbName = pOptions.dbName;
    }
    this.dbName = dbName;
    return new Promise(function (pResolve, pReject) {
      var DBOpenRequest = window.indexedDB.open(that.storeName, kDBVersion);
      DBOpenRequest.onerror = function (event) {
        that._couldNotOpenError = true;
        var errorObject = {
          "error_code": "indexdb_open_failed",
          "error": "Could not open IndexedDB connection"
        };
        if (event.target !== undefined && event.target.error !== undefined) {
          console.error(event.target.error);
          errorObject.messages = [event.target.error];
        }
        pReject(errorObject);
      };
      DBOpenRequest.onblocked = function (event) {
        console.error("connection blocked", event);
      };
      DBOpenRequest.onsuccess = function (event) {
        that.db = DBOpenRequest.result;
        that.db.onerror = function (pError) {
          console.error(pError);
        };
        that.db.onabort = function (pEvent, pError) {
          console.error(pError);
        };
        that.db.onversionchange = function (pVersionChangeEvent) {
          if (pVersionChangeEvent !== undefined && pVersionChangeEvent.newVersion === null) {
            // version changed to null, mains databaseDelete is trying to delete open transactions
            // kill those transactions
            that.db.close();
          }
        };
        var timeToExpire = expireTime;
        if (pOptions && typeof pOptions.expire === "number" && pOptions.expire > 0) {
          timeToExpire = pOptions.expire;
        }
        that._purge_expired(timeToExpire).then(function () {
          pResolve();
        }, function () {
          // errored clean up
          pResolve();
        });
      };

      // This event handles the event whereby a new version of the database needs to be created
      // Either one has not been created before, or a new version number has been submitted via the
      // window.indexedDB.open line above
      // it is only implemented in recent browsers
      DBOpenRequest.onupgradeneeded = function (event) {
        var transaction = event.target.transaction;
        var db = event.target.result;
        transaction.oncomplete = pResolve;
        db.onerror = function (event) {
          pReject({
            "error_code": "indexdb_upgradeneeded_failed",
            "error": "Something went wrong during creating db store"
          });
        };
        DBOpenRequest.onversionchange = function () {
          DBOpenRequest.result.close();
        };
        if (event.oldVersion === 1) {
          db.deleteObjectStore(dbName);
        }
        // Create an objectStore for this database
        var objectStore = db.createObjectStore(dbName, {
          keyPath: "_id",
          autoIncrement: true
        });
        objectStore.createIndex("_id", "_id", {
          unique: true
        });
        that.db = db;
      };
    });
  },
  /**
   * @description Close indexedDB connection
   * @name IndexedStorage.close
   */
  close: function close() {
    this.db.close();
  },
  /**
   * @description add item to store
   * @name IndexedStorage.add
   * @param {String} pData Item to add to the store
   */
  add: function add(pData) {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.onerror = pReject;
      var objectStore = transaction.objectStore(that.dbName);
      var addAction = objectStore.add({
        lastAccess: +new Date(),
        birth: +new Date(),
        data: pData
      });
      // addAction.onsuccess = function(pEvent){
      transaction.oncomplete = function (pEvent) {
        pResolve(pEvent);
      };
      addAction.onerror = pReject;
    });
  },
  /**
   * @description add multiple items to store
   * @name IndexedStorage.addMultiple
   * @param {Array} pDataArray Items to add to the store
   */
  addMultiple: function addMultiple(pDataArray) {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.oncomplete = pResolve;
      transaction.onsuccess = pResolve;
      transaction.onerror = pReject;
      var objectStore = transaction.objectStore(that.dbName);
      for (var i = 0; i < pDataArray.length; i++) {
        objectStore.add({
          lastAccess: +new Date(),
          birth: +new Date(),
          data: pDataArray[i]
        });
      }
    });
  },
  /**
   * @description set data store
   * @name IndexedStorage.set
   * @param {any} pObjectToAdd item to set store to.
   */
  set: function set(pObjectToAdd) {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.oncomplete = pResolve;
      transaction.onerror = pReject;
      var objectStore = transaction.objectStore(that.dbName);
      objectStore.clear();
      var addRequest = objectStore.add({
        lastAccess: +new Date(),
        birth: +new Date(),
        data: pObjectToAdd
      });
      addRequest.onerror = pReject;
    });
  },
  /**
   * @description get last item from store
   * @name IndexedStorage.getLast
   */
  getLast: function getLast() {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.onerror = pReject;
      var objectStore = transaction.objectStore(that.dbName);
      var dataRequest = objectStore.openCursor(null, "prev");
      dataRequest.onerror = pReject;
      dataRequest.onsuccess = function (event) {
        var cursor = event.target.result;
        if (cursor) {
          cursor.value.lastAccess = +new Date();
          var updateRequest = cursor.update(cursor.value);
          updateRequest.onerror = function (pError) {
            pReject(pError);
          };
          updateRequest.onsuccess = function (pEvent) {
            pResolve(cursor.value.data);
          };
        } else if (event.target.readyState === "pending") {
          event.target.onsuccess = function (event) {
            var cursor = event.target.result;
            if (cursor) {
              cursor.value.lastAccess = +new Date();
              var updateRequest = cursor.update(cursor.value);
              updateRequest.onerror = function (pError) {
                pReject(pError);
              };
              updateRequest.onsuccess = function (pEvent) {
                pResolve(cursor.value.data);
              };
            } else {
              pReject({
                "error_code": "indexdb_cursor_fail",
                "error": "Could not traverse the database. Cursor not present"
              });
            }
          };
          event.target.onerror = function (pError) {
            pReject(pError);
          };
        } else {
          pReject({
            "error_code": "indexdb_cursor_fail",
            "error": "Could not traverse the database. ReadyState is no pending."
          });
        }
      };
    });
  },
  /**
   * @description list filtered items
   * @name IndexedStorage.list_with_filter
   * @param {Function} pFilter Function that filters items
   */
  list_with_filter: function list_with_filter(pFilter) {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.onerror = pReject;
      var objectStore = transaction.objectStore(that.dbName);
      var dataRequest = objectStore.openCursor();
      var result = [];
      if (pFilter === undefined) {
        pFilter = function pFilter() {
          return true;
        };
      }
      dataRequest.onsuccess = function (event) {
        var cursor = event.target.result;
        if (cursor) {
          var value = cursor.value;
          if (value.data) {
            if (pFilter(value.data) === true) {
              value.lastAccess = +new Date();
              cursor.update(value);
              result.push(value.data);
            }
          }
          cursor["continue"]();
        } else {
          pResolve({
            results: result
          });
        }
      };
      dataRequest.onerror = pReject;
    });
  },
  /**
   * @description list items that match with query
   * @name IndexedStorage.list_with_options
   * @param {Array<String>} pQuery
   */
  list_with_options: function list_with_options(pQuery) {
    var queryApplier = new QueryApplier(pQuery);
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.onerror = pReject;
      var objectStore = transaction.objectStore(that.dbName);
      var dataRequest = objectStore.openCursor();
      var result = [];
      dataRequest.onsuccess = function (event) {
        var cursor = event.target.result;
        if (cursor) {
          var value = cursor.value;
          if (value.data && queryApplier.validate(value.data) === true) {
            value.lastAccess = +new Date();
            cursor.update(value);
            result.push(value.data);
          }
          cursor["continue"]();
        } else {
          pResolve({
            results: result
          });
        }
      };
      dataRequest.onerror = pReject;
    });
  },
  /**
   * @description delete filtered items
   * @name IndexedStorage.delete_with_filter
   * @param {Function} pFilter
   */
  delete_with_filter: function delete_with_filter(pFilter) {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.onerror = pReject;
      var objectStore = transaction.objectStore(that.dbName);
      var dataRequest = objectStore.openCursor();
      if (pFilter === undefined) {
        pFilter = function pFilter() {
          return true;
        };
      }
      dataRequest.onsuccess = function (event) {
        var cursor = event.target.result;
        if (cursor) {
          var value = cursor.value;
          if (value.data) {
            if (pFilter(value.data) === true) {
              cursor["delete"]();
            }
          }
          cursor["continue"]();
        } else {
          pResolve();
        }
      };
      dataRequest.onerror = pReject;
    });
  },
  /**
   * @description update filtered items
   * @name IndexedStorage.update_with_filter
   * @param {Function} pFilter
   * @param {Function} pNewData // Function that's called for each filtered item, as attribute, and has to return the updated data. 
   */
  update_with_filter: function update_with_filter(pFilter, pNewData) {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.onerror = pReject;
      var objectStore = transaction.objectStore(that.dbName);
      var dataRequest = objectStore.openCursor();
      if (pFilter === undefined) {
        pFilter = function pFilter() {
          return true;
        };
      }
      dataRequest.onsuccess = function (event) {
        var cursor = event.target.result;
        if (cursor) {
          var value = cursor.value;
          if (value.data) {
            if (pFilter(value.data) === true) {
              var newData = pNewData;
              if (typeof pNewData === "function") {
                newData = pNewData(cursor.value.data);
                cursor.value.data = newData;
              } else {
                cursor.value.data = pNewData;
              }
              cursor.value.lastAccess = +new Date();
              cursor.update(cursor.value);
            }
          }
          cursor["continue"]();
        } else {
          pResolve();
        }
      };
      dataRequest.onerror = pReject;
    });
  },
  /**
   * @description clear the store
   * @name IndexedStorage.clear
   */
  clear: function clear() {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.onerror = pReject;
      transaction.onsuccess = pResolve;
      transaction.oncomplete = pResolve;
      var objectStore = transaction.objectStore(that.dbName);
      var clearRequest = objectStore.clear();
      clearRequest.onerror = pReject;
    });
  },
  /**
   * @description count the items inside the store
   * @name IndexedStorage.count
   */
  count: function count() {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction([that.dbName], "readwrite");
      transaction.onerror = pReject;
      var objectStore = transaction.objectStore(that.dbName);
      var countRequest = objectStore.count();
      countRequest.onsuccess = function () {
        pResolve({
          count: countRequest.result
        });
      };
      countRequest.onerror = pReject;
    });
  },
  /**
   * @description Function runs after every transaction and purges all expired items
   * @name IndexedStorage._purge_expired
   * @private
   * @param {Number} pExpiryTimeMS
   */
  _purge_expired: function _purge_expired(pExpiryTimeMS) {
    var that = this;
    if (that.db === undefined) {
      throw new Error("DB connection not yet opened");
    }
    return new Promise(function (pResolve, pReject) {
      var transaction = that.db.transaction(that.db.objectStoreNames, "readwrite");
      transaction.onerror = pReject;
      for (var i = 0; i < that.db.objectStoreNames.length; i++) {
        var store = that.db.objectStoreNames[i];
        var objectStore = transaction.objectStore(store);
        var dataRequest = objectStore.openCursor();
        dataRequest.onsuccess = function (event) {
          var cursor = event.target.result;
          if (cursor) {
            var value = cursor.value;
            if (value.lastAccess < +new Date() - pExpiryTimeMS || !value.lastAccess) {
              cursor["delete"]();
            }
            cursor["continue"]();
          } else {
            pResolve();
          }
        };
        dataRequest.onerror = pReject;
      }
    });
  }
};
module.exports = IndexedStorage;

},{"../../../cloudflow/CloudflowUtil/js/QueryApplier.js":91}],279:[function(require,module,exports){
"use strict";

/**
 * @constructor SessionStorage
 * @description Save and retreive data inside the browser for sessions
 */
function SessionStorage() {}
;

/**
 * @description Check if the broser support the internal used technology
 * @function
 * @static
 * @name SessionStorage.isSupport
 * @returns {Boolean} true if the the browser support session storage
 */
SessionStorage.isSupport = function () {
  return storageAvailable("sessionStorage");
};

/**
 * @description Save data
 * @function
 * @name SessionStorage.setObject
 * @param {String} pName The path
 * @param {Object} pObjectToSave The object to save
 * @example SessionStorage.setObject("application", {"name": "CLOUDFLOW"})
 * @returns {Object} the saved object or null if the save failed
 */
SessionStorage.setObject = function (pName, pObjectToSave) {
  // always surrender by try / catch
  // storage can be full
  try {
    sessionStorage.setItem(pName, JSON.stringify(pObjectToSave));
    return pObjectToSave;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * @description retrieve data
 * @function
 * @name SessionStorage.setObject
 * @param {String} pName the path
 * @example SessionStorage.getObject("application")
 * @returns {Object} the object that was save or null if no object is present       
 */
SessionStorage.getObject = function (pName) {
  try {
    var valueFound = sessionStorage.getItem(pName);
    return JSON.parse(valueFound);
  } catch (e) {
    console.error(e);
    return null;
  }
};
SessionStorage.getObjectWithDefault = function (name, default_value) {
  try {
    return JSON.parse(sessionStorage.getItem(name)) || default_value || {};
  } catch (e) {}
  return null;
};
SessionStorage.setItem = function (name, item) {
  try {
    sessionStorage.setItem(name, item);
  } catch (e) {}
};
SessionStorage.getItem = function (name, default_value) {
  try {
    return sessionStorage.getItem(name) || default_value || "";
  } catch (e) {}
  return null;
};
SessionStorage.clear = function (pContextID) {
  try {
    return sessionStorage.removeItem(pContextID);
  } catch (e) {
    console.error(e);
    return null;
  }
};
SessionStorage.prototype = {
  constructor: SessionStorage
};
module.exports = SessionStorage;
function storageAvailable(type) {
  try {
    var storage = window[type],
      x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return e instanceof DOMException && (
    // everything except Firefox
    e.code === 22 ||
    // Firefox
    e.code === 1014 ||
    // test name field too, because code might not be present
    // everything except Firefox
    e.name === 'QuotaExceededError' ||
    // Firefox
    e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
    // acknowledge QuotaExceededError only if there's something already stored
    storage.length !== 0;
  }
}

},{}],280:[function(require,module,exports){
"use strict";

/**
 * @description Is the page triggered from a reload or not? There is no difference between hard reload or soft reload
 * @function
 * @private
 * @returns {Boolean} true if we reloaded the current browers page, false if we came from an other url
 */
function isReload() {
  if (window.performance !== undefined) {
    // first check new function
    if (typeof performance.getEntriesByType === "function") {
      var results = performance.getEntriesByType("navigation");
      if (Array.isArray(results) && results.length > 0 && typeof results[0].type === "string") {
        return results[0].type === "reload";
      }
    }
    // if not found check deprecated function
    if (performance.navigation !== undefined && typeof performance.navigation.type === "number") {
      return performance.navigation.type === 1;
    }
  }
  return false;
}
var isReloaded = isReload();

/**
 * @description This util object act as an cache for other util classes like user, license, version ,...
 * it prevents the the browser needs to call every pageload. The data stays the same for the session. 
 * Data is cleared if the user html session expired, or if the users logout or if a page refresh is detected
 * @namespace TemporyBrowserObjectCache
 * @version 1.0.0
 */
var TemporyBrowserObjectCache = {
  /**
   * @description Save data to the caches
   * @function
   * @name TemporyBrowserObjectCache#save
   * @param {String} pIdentifier An uniq identiefier, to identiefier the data 
   * @param {Object} pObject Data you which to cache
   * @returns undefined
   */
  save: function save(pIdentifier, pObject) {
    try {
      // session can not exists or storage can be full
      // so ignore errors
      sessionStorage.setItem(pIdentifier, JSON.stringify({
        "object": pObject,
        "creation": +new Date()
      }));
    } catch (e) {}
  },
  /**
   * @description Retrieve the cached data. null will be returned if no data is present or 
   * if the data is too old or if security prevents access
   * @function
   * @name TemporyBrowserObjectCache#get 
   * @param {String} pIdentifier The identifier of the cached data
   * @returns {Object} The cached data or null
   */
  get: function get(pIdentifier) {
    try {
      // sessionStorage can not exists or 
      // returnValue can not be JSON parsed correctly
      // in all cases ignore and go to retrieve by api call
      var stringified = sessionStorage.getItem(pIdentifier);
      if (typeof stringified === "string" && stringified.length > 0) {
        var memoryObject = JSON.parse(stringified);
        if (memoryObject.object !== undefined && memoryObject.creation !== undefined) {
          var now = new Date();
          if (now.setHours(now.getHours() - 12) < memoryObject.creation) {
            // if created more recent then history
            return memoryObject.object;
          }
        }
        // continue in case of wrong
        sessionStorage.removeItem(pIdentifier);
      }
    } catch (e) {
      if (window.origin === "null" && e && e.name === "SecurityError") {
        // ignore issue
      } else {
        console.error(e);
      }
    }
    return null;
  },
  /**
   * @description Remove and delete the cached data
   * @function
   * @name TemporyBrowserObjectCache#remove 
   * @param {String} pIdentifier The identifier if the cached data
   * @returns undefined
   */
  remove: function remove(pIdentifier) {
    if (window.sessionStorage !== undefined) {
      window.sessionStorage.removeItem(pIdentifier);
    }
  },
  /**
   * @description Check if the user click on the refresh button or not, it return also true if the refresh is caused by javascript location.reload()
   * @function
   * @name TemporyBrowserObjectCache#isPageReload
   * @returns {Boolean} true if the page has been reloaded, if the user clicked on the refresh button
   */
  isPageReload: function isPageReload() {
    return isReloaded == true;
  }
};
module.exports = TemporyBrowserObjectCache;

},{}],281:[function(require,module,exports){
"use strict";

(function ($) {
  require("./nixps-pagebuilder-CloudflowButton.js");
  /**
   * @namespace nixps-cloudflow.CloudflowButtonGroup
   * @description Draw a group of buttons
   */
  $.widget("nixps-cloudflow.CloudflowButtonGroup", $.Widget, {
    version: "",
    widgetEventPrefix: "cloudflowbuttongroup",
    options: {
      /**
       * @name nixps-cloudflow.CloudflowButtonGroup#gap
       * @description How much spacing there should be between the buttons. Takes any css unit. Pixels by default.
       * This value is given to the jquery css function.
       * @type {Number|String}
       * @default ""
       */
      gap: "",
      /**
       * @name nixps-cloudflow.CloudflowButtonGroup#iconPosition
       * @description How should the icon be positioned according to the label text.
       * This overrides individual iconPosition options in ButtonOptions option if it's not set to undefined!
       * @type {"auto" | "left" | "top"}
       * @default "auto"
       * @example "left"
       */
      iconPosition: undefined,
      /**
       * @name nixps-cloudflow.CloudflowButtonGroup#classes
       * @description Customize classes to be append to the buttons their container. 
       * Possible keys are ["cf-buttongroup"]
       * @type {Object}
       * @default {}
       */
      classes: {},
      /**
       * @name nixps-cloudflow.CloudflowButtonGroup#buttonsOptions
       * @description An array of objects containing the options for each button inside the group
       * @type {Array.<Object>}
       * @default [{label:"button 1", icon:"fa fa-hand-pointer-o"}, 
       * {label: "button 2", icon: "fa fa-hand-pointer-o"}]
       */
      buttonsOptions: [{
        label: "button 1",
        icon: "fa fa-hand-pointer-o",
        classes: "bootstrap_buttonalike"
      }, {
        label: "button 2",
        icon: "fa fa-hand-pointer-o",
        classes: "bootstrap_buttonalike"
      }],
      /**
       * @name nixps-cloudflow.CloudflowButtonGroup#disabled
       * @description Whether the buttons inside the group should be disabled or not
       * @type {boolean}
       * @default false
       */
      disabled: false,
      /**
       * @name nixps-cloudflow.CloudflowButtonGroup#buttonsOptions
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._draw();
      this.options.created();
      this._on(this.element, {
        "click button": this._clickHandler
      });
    },
    _draw: function _draw() {
      var _this = this;
      this.element.empty();
      var buttongroup = $("<div>").addClass("cf-buttongroup").css("gap", this.options.gap);
      this._addClass(buttongroup, "cf-buttongroup");
      this.element.append(buttongroup);
      if (this.options.disabled === true) {
        this.options.buttonsOptions.forEach(function (pButtonOption) {
          Object.assign(pButtonOption, {
            disabled: true
          });
        });
      } else if (this.options.disabled === false) {
        this.options.buttonsOptions.forEach(function (pButtonOption) {
          Object.assign(pButtonOption, {
            disabled: false
          });
        });
      }
      if (this.options.iconPosition !== undefined) {
        this.options.buttonsOptions.forEach(function (pButtonOption) {
          pButtonOption.iconPosition = _this.options.iconPosition;
        });
      }
      buttongroup.append(this.options.buttonsOptions.map(function (pButtonOption) {
        return $("<div>").CloudflowButton(pButtonOption).addClass("cf-btngroup-buttoncontainer");
      }));

      //check whether the CSS unit for gap given to the buttongroup was valid - assigns NaN if not
      var gapIntValue = parseInt(buttongroup.css("gap"));
      if (gapIntValue !== 0 && isNaN(gapIntValue) === false) {
        buttongroup.addClass("cf-buttongroup-withgap");
      }
    },
    _clickHandler: function _clickHandler(pEvent, pData) {
      var action = $(pEvent.target.closest("button")).attr("data-action");
      this._trigger("action" + action, pEvent.originalEvent, {});
    },
    /**
     * @description Enable one or multiple buttons, by action name
     * @function
     * @param {String|Array} pActionNames
     * @name nixps-cloudflow.CloudflowButtonGroup#enableButtons
     * @return {{}}
     */
    enableButtons: function enableButtons(pActionNames) {
      var that = this;
      if (typeof pActionNames !== "string" && Array.isArray(pActionNames) === false) {
        console.error("CloudflowButtonGroup: actionnames argument must be either a string or array");
        return {};
      }
      if (Array.isArray(pActionNames) === false) {
        pActionNames = [pActionNames];
      }
      pActionNames.forEach(function (pActionName) {
        that.element.find("[data-actionname=" + pActionName + "]").closest(".nixps-pagebuilder-CloudflowButton").CloudflowButton("option", "disabled", false);
      });
      return {};
    },
    /**
     * @description Disable one or multiple buttons, by action name
     * @function
     * @param {String|Array} pActionNames
     * @return {{}}
     * @name nixps-cloudflow.CloudflowButtonGroup#disableButtons
     */
    disableButtons: function disableButtons(pActionNames) {
      var that = this;
      if (typeof pActionNames !== "string" && Array.isArray(pActionNames) === false) {
        console.error("CloudflowButtonGroup: actionnames argument must be either a string or array");
        return {};
      }
      if (Array.isArray(pActionNames) === false) {
        pActionNames = [pActionNames];
      }
      pActionNames.forEach(function (pActionName) {
        that.element.find("[data-actionname=" + pActionName + "]").closest(".nixps-pagebuilder-CloudflowButton").CloudflowButton("option", "disabled", true);
      });
      return {};
    },
    /**
     * @description Toggle the state of one or multiple buttons, by action name
     * @function
     * @param {String|Array} pActionNames
     * @return {{}}
     * @name nixps-cloudflow.CloudflowButtonGroup#toggleButtonState
     */
    toggleButtonState: function toggleButtonState(pActionNames) {
      var that = this;
      if (typeof pActionNames !== "string" && Array.isArray(pActionNames) === false) {
        console.error("CloudflowButtonGroup: actionnames argument must be either a string or array");
        return {};
      }
      if (Array.isArray(pActionNames) === false) {
        pActionNames = [pActionNames];
      }
      pActionNames.forEach(function (pActionName) {
        that.element.find("[data-actionname=" + pActionName + "]").closest(".nixps-pagebuilder-CloudflowButton").CloudflowButton("toggleDisabled");
      });
      return {};
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-cloudflow.CloudflowButtonGroup#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      if (typeof options.disabled === "boolean") {
        that.element.find(".nixps-pagebuilder-CloudflowButton").CloudflowButton({
          disabled: options.disabled
        });
      }
      this.redraw();
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      if (pKey === "gap") {
        var buttongroup = this.element.find(".cf-buttongroup").css("gap", pValue);
        var gapIntValue = parseInt(buttongroup.css("gap"));
        if (gapIntValue !== 0 && isNaN(gapIntValue) === false) {
          buttongroup.addClass("cf-buttongroup-withgap");
        }
      }
    },
    _controlOptions: function _controlOptions() {
      if ($.isPlainObject(this.options.classes) === false) {
        throw new Error("CloudflowButtonGroup: input option classes must be an object");
      }
      if (Array.isArray(this.options.buttonsOptions) === false) {
        throw new Error("CloudflowButtonGroup: input option buttonOptions must be an array");
      }
      this.options.buttonsOptions.forEach(function (pButtonOption) {
        if ($.isPlainObject(pButtonOption) === false) {
          throw new Error("CloudflowButtonGroup: input option buttonOptions has to be an array of objects");
        }
      });
      if (typeof this.options.gap !== "number" && typeof this.options.gap !== "string") {
        throw new Error("CloudflowButtonGroup: input option gap must be either a number or string");
      }
      if (typeof this.options.disabled !== "boolean") {
        throw new Error("CloudflowButtonGroup: input option disabled must be a boolean");
      }
      if (["auto", "left", "top", undefined].includes(this.options.iconPosition) === false) {
        throw new Error("CloudflowButtonGroup: option iconPosition must be either auto, left, top or undefined");
      }
    },
    _destroy: function _destroy() {
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"./nixps-pagebuilder-CloudflowButton.js":282}],282:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jan 3, 2018 9:57:30 AM
 */
(function ($) {
  var kCssLeft = {
    "margin-right": "",
    "margin-left": "",
    "float": "left",
    "display": ""
  };
  var kCssRight = {
    "margin-right": "",
    "margin-left": "",
    "float": "right",
    "display": ""
  };
  var kCssCenter = {
    "margin-right": "auto",
    "margin-left": "auto",
    "float": "",
    "display": "block"
  };
  var kCssClear = {
    "margin-right": "",
    "margin-left": "",
    "float": "",
    "display": ""
  };
  function convertMissingCharacters(pTextToDisplay) {
    if (typeof pTextToDisplay === "string" && pTextToDisplay.indexOf("&") >= 0) {
      return pTextToDisplay.replaceAll("&amp;", "&").replaceAll("&quot;", '"').replaceAll("&#x27;", "'").replaceAll("&nbsp;", " ");
    }
    return pTextToDisplay;
  }

  /**
   * @namespace nixps-pagebuilder.CloudflowButton
   * @description Draw a button used for pagebuilder. Because pagebuilder requires a specif format to add and specify options.
   * Do not use this component outside pagebuilder
   * @example $("<div>").CloudflowButton({
   *  label: "submit"
   * });
   * @version 1.1.0
   */
  $.widget("nixps-pagebuilder.CloudflowButton", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "cloudflowbutton",
    options: {
      /**
       * @name nixps-pagebuilder.CloudflowButton#iconType
       * @description Which technique must be use to display the icon, is the icon a awesome class or a url? Can be "class" or "url"
       * @type {String}
       * @default "class"
       * @example "url"
       */
      iconType: "class",
      /**
       * @name nixps-pagebuilder.CloudflowButton#iconPosition
       * @description How should the icon be positioned according to the label text
       * @type {"auto" | "left" | "top"}
       * @default "auto"
       * @example "left"
       */
      iconPosition: "auto",
      /**
       * @name nixps-pagebuilder.CloudflowButton#icon
       * @description The icon to be show on the button
       * @type {String}
       * @default ""
       */
      icon: "",
      /**
       * @name nixps-pagebuilder.CloudflowButton#url
       * @description The icon url to be show on the button
       * @type {String}
       * @default ""
       */
      url: "",
      /**
       * @name nixps-pagebuilder.CloudflowButton#relativeBasePath
       * @description The path to be used if the url is relative
       * @type {string}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name ixps-pagebuilder.CloudflowButton#imageWidth
       * @description The width of the image by url
       * @type {mixed}
       * @default null
       */
      imageWidth: null,
      /**
       * @name ixps-pagebuilder.CloudflowButton#imageHeight
       * @description The height of the image by url
       * @type {mixed}
       * @default null
       */
      imageHeight: null,
      /**
       * @name nixps-pagebuilder.CloudflowButton#label
       * @description The text to be show on the button
       * @type {String}
       * @default ""
       */
      label: "",
      /**
       * @name nixps-pagebuilder.CloudflowButton#classes
       * @description The classnames to be given to the button. This will be given directly as argument to the addClass
       * @type {String}
       * @default ""
       */
      classes: "",
      /**
       * @name nixps-pagebuilder.CloudflowButton#tooltip
       * @description The text to show in the tooltip
       * @type {String}
       * @default ""
       */
      tooltip: "",
      /**
       * @name nixps-pagebuilder.CloudflowButton#action
       * @description The action of the button
       * @type {String}
       * @default ""
       */
      action: "",
      /**
       * @name nixps-pagebuilder.CloudflowButton#actionname
       * @description The actionname of the button
       * @type {String}
       * @default ""
       */
      actionname: "",
      /**
       * @name nixps-pagebuilder.CloudflowButton#style
       * @description the css style to apply on the button
       * @type {Object}
       * @default {}
       */
      style: {},
      /**
       * @name nixps-pagebuilder.CloudflowButton#activationType
       * @description the data attribute activation type to set on the button
       * @type {String}
       * @default {}
      */
      activationType: undefined,
      /**
       * @name nixps-pagebuilder.CloudflowButton#align
       * @description the alignment of the button
       * @type {String}
       * @default undefined
      */
      align: undefined,
      /**
       * @name nixps-pagebuilder.CloudflowButton#click
       * @description a CB function that fires on click
       * @type {Function}
       * @default undefined
      */
      click: undefined,
      /**
       * @name nixps-pagebuilder.CloudflowButton#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-pagebuilder.CloudflowButton#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._draw();
      this._on(this.element, {
        "click button": this._clickHandler
      });
      this.options.created();
    },
    /**
     * @description Function runs when user click on the button
     * @function
     * @name nixps-pagebuilder.CloudflowButton#_clickHandler
     * @private
     * @param {Object} pEvent
     * @param {Object} pData
     * @return {undefined}
     */
    _clickHandler: function _clickHandler(pEvent, pData) {
      if (typeof this.options.click === "function") {
        this.options.click(pEvent, pData);
      }
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-pagebuilder.CloudflowButton#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-pagebuilder.CloudflowButton#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      var button = $("<button>").attr("type", "button").addClass(this.options.classes);
      if (this.options.iconPosition !== "auto") {
        button.addClass("cf-button-layout-" + this.options.iconPosition);
      }
      var icon = $("<span>").addClass("cloudflowbutton_icon");
      if (this.options.iconType === "class" && typeof this.options.icon === "string" && this.options.icon.length > 0) {
        icon.addClass(this.options.icon);
      } else if (this.options.iconType === "url" && typeof this.options.url === "string" && this.options.url.length > 0) {
        icon.append($("<div>").Image({
          url: this.options.url,
          width: this.options.imageWidth,
          height: this.options.imageHeight,
          alt: "",
          relativeBasePath: this.options.relativeBasePath
        }));
      } else if (typeof this.options.icon === "string" && this.options.icon.length > 0) {
        if (this.options.icon.indexOf(".") > 0) {
          // we think that the icon is an url
          icon.append($("<div>").Image({
            url: this.options.icon,
            width: this.options.imageWidth,
            height: this.options.imageHeight,
            alt: "button_icon",
            relativeBasePath: this.options.relativeBasePath
          }));
        } else {
          icon.addClass(this.options.icon);
        }
      }
      button.append(icon);
      button.append($("<span>").addClass("cloudflowbutton_text").text(convertMissingCharacters(this.options.label)));
      if (typeof this.options.tooltip === "string" && this.options.tooltip.length > 0) {
        button.attr("title", convertMissingCharacters(this.options.tooltip));
      }
      if (this.options.align === "left") {
        button.css(kCssLeft);
      } else if (this.options.align === "right") {
        button.css(kCssRight);
      } else if (this.options.align === "center") {
        button.css(kCssCenter);
      } else {
        button.css(kCssClear);
      }
      if ($.isEmptyObject(this.options.style) === false) {
        button.css(this.options.style);
      }
      if (typeof this.options.action === "string" && this.options.action.length > 0) {
        button.attr("data-action", this.options.action);
      }
      if (typeof this.options.actionname === "string" && this.options.actionname.length > 0) {
        button.attr("data-actionname", this.options.actionname);
      }
      this.element.append(button);
      // disable is asked
      if (this.options.disabled === true) {
        button.prop("disabled", true);
      }
      if (this.options.activationType && typeof this.options.activationType === "string") {
        this._setActivationType();
      }
    },
    getValue: function getValue() {
      return null;
    },
    setValue: function setValue() {},
    /**
     * @description toggle the enable and disabled of the button
     * @name nixps-pagebuilder.CloudflowButton#toggleDisabled
     * @function
     * @since 1.1.0
     * @returns {undefined}
     */
    toggleDisabled: function toggleDisabled() {
      if (this.options.disabled === true) {
        this._setOption("disabled", false);
      } else if (this.options.disabled === false) {
        this._setOption("disabled", true);
      }
    },
    /**
     * @description set the data attribute of the button on an activationType usable by pagebuilder
     * @name nixps-pagebuilder.CloudflowButton#_setActivationType
     * @function
     * @private
     * @since 1.1.0
     * @returns {undefined}
    */
    _setActivationType: function _setActivationType() {
      this.element.attr("data-activationtype", this.options.activationType);
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-pagebuilder.CloudflowButton#_setOptions
     */
    _setOptions: function _setOptions(options) {
      var that = this;
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      this._controlOptions();
      if (options.iconType !== undefined || options.icon !== undefined || options.url !== undefined || options.classes !== undefined || options.action !== undefined || options.style !== undefined) {
        this._draw();
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      if (pKey === "disabled") {
        this.element.children("button").prop("disabled", pValue);
      } else if (pKey === "label") {
        this.element.find(".cloudflowbutton_text").text(pValue);
      } else if (pKey === "tooltip") {
        if (typeof pValue === "string" && pValue.length > 0) {
          this.element.children("button").attr("title", pValue);
        } else {
          this.element.children("button").removeAttr("title");
        }
      } else if (pKey === "activationType") {
        this._setActivationType();
      } else if (pKey === "align") {
        if (this.options.align === "left") {
          this.element.children("button").css(kCssLeft);
        } else if (this.options.align === "right") {
          this.element.children("button").css(kCssRight);
        } else if (this.options.align === "center") {
          this.element.children("button").css(kCssCenter);
        } else {
          this.element.children("button").css(kCssClear);
        }
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-pagebuilder.CloudflowButton#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.classes !== "string") {
        throw new Error("CloudflowButton: input option classes must be a string");
      }
      if (this.options.tooltip !== null && typeof this.options.tooltip !== "string") {
        throw new Error("CloudflowButton: input option tooltip must be a string");
      }
      if ($.isPlainObject(this.options.style) === false) {
        throw new Error("CloudflowButton: input option style must be a plain object");
      }
      if (["auto", "left", "top"].includes(this.options.iconPosition) === false) {
        throw new Error("CloudflowButtonGroup: option iconPosition must be either auto, left or top");
      }
    }
  });
})(jQuery);

},{}],283:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Aug 25, 2016 10:39:44 AM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  function isValidDate(pDate) {
    if (moment.isMoment(pDate) === true) {
      return true;
    }
    if (Object.prototype.toString.call(pDate) === "[object Date]") {
      // it is a date
      if (isNaN(pDate)) {
        // d.getTime() or d.valueOf() will also work
        // date object is not valid
        return false;
      } else {
        // date object is valid
        return true;
      }
    } else {
      return false;
    }
  }
  function isSameDate(pStart, pEnd) {
    return moment(pStart).format('YYYY-MM-DD') === moment(pEnd).format('YYYY-MM-DD');
  }
  ;

  /**
   * @namespace nixps.Calendar
   * @description The component displaying a calender. It is a proxy of the plugin fullcalendar. <br />
   * You  can find more information about the fullcalendar in <a href="http://fullcalendar.io/docs/" > http://fullcalendar.io/docs/ </a>
   * @example $('<div>').Calendar({language: 'nl', ... })
   * @readme the component use the name "event" for task items, in this component we use period as translation for this. 
   * @requires moment.js
   * @requires fullcalendar.js
   * @version 0.8
   * 
   */
  $.widget("nixps.Calendar", $.Widget, {
    options: {
      /**
       * @name nixps.Calendar#defaultDate
       * @description The default date on startup.
       * @type {moment}
       * @default now
       * @example "2016-08-05"
       * @example "2016-12-30T15:00:00"
       */
      defaultDate: undefined,
      /**
       * @name nixps.Calendar#defaultView
       * @description The default view on startup. This must be mention in the option header.
       * @type {String}
       * @default 'month'
       * @example 'agendaDay'
       */
      defaultView: 'month',
      /**
       * @name nixps.Calendar#header
       * @description How must we show, organise the header. The header must be a fullcalendar accepted header option.
       * @type {object|headeroption}
       * @default {
                  left: 'prev next today',
                  center: 'title',
                  right: 'dayGridMonth,timeGridWeek,timeGridDay'
              }
       */
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      /**
       * @name nixps.Calendar#businessHours
       * @description What are the days and hours that the people, machines work? What are the working hours? Must be a valid businessHours fullcalendar option.
       * @type {object|businessHoursoption}
       * @default { 
              dow: [1,2,3,4,5],
              start: '08:00',
              end: '18:00'
          }
       */
      businessHours: {
        // the working hours of the company
        daysOfWeek: [1, 2, 3, 4, 5],
        //monday to friday
        startTime: '08:00',
        endTime: '18:00'
      },
      /**
       * @name nixps.Calendar#hiddenDays
       * @description Which weekdays must we hide? use 0 for Sunday and 6 for Saterday. it mus be a array only containing integer from 0 till 6.
       * use [0,6] to disable weekends
       * @type {Array}
       * @default []
       * @example [0,6]
       */
      hiddenDays: [],
      /**
       * @name nixps.Calendar#eventStartEditable
       * @description Must the user be able to change the start time of the time events. Put on true to enable the editing. The duration will not change.
       * @type {Boolean}
       * @default false
       */
      eventStartEditable: false,
      /**
       * @name nixps.Calendar#eventDurationEditable
       * @description Must the user be able to change the duration of the time events. Put on true to enable the change the durations.
       * @type {Boolean}
       * @default false
       */
      eventDurationEditable: false,
      /**
       * @name nixps.Calendar#selectable
       * @description Must the user be able to select somethings
       * @type {Boolean}
       * @default false
       */
      selectable: false,
      /**
       * @name nixps.Calendar#periodeProvider
       * @description Is a function that must return a object containing the keys "periods" "unaviablePeriods" and "aviablePeriods"
       * this can return also a Deferred object
       * @type {function}
       * @param {moment} start
       * @param {moment} end
       * @returns {undefined}
       */
      periodeProvider: function periodeProvider(start, end) {},
      /**
       * @name nixps.Calendar#language
       * @description The language of the user. This must be a format compatible for plugin moment.
       * @type {String}
       * @default 'en'
       * @example "nl"
       */
      language: 'en',
      /**
       * @name nixps.Calendar#change
       * @description Event listener if a period changed
       * @type {Function}
       * @default function(){}
       */
      change: function change() {},
      /**
       * @name nixps.Calendar#clickFree
       * @description Event listener if user clicked on free period
       * @type {Function}
       * @default function(){}
       */
      clickFree: function clickFree() {},
      /**
       * @name nixps.Calendar#clickPeriod
       * @description Event listener if clicked on a period
       * @type {Function}
       * @default function(){}
       */
      clickPeriod: function clickPeriod() {},
      /**
       * @name nixps.Calendar#select
       * @description Event listener if user select something
       * @type {Function}
       * @default function(){}
       */
      select: function select() {},
      /**
       * @description The maximum Date possible (experimental)
       * @type {moment}
       * @default null
       * @version 0.5
       */
      maxDate: null,
      /**
       * @description The minimum Date possible (experimental)
       * @type {moment}
       * @default null
       * @version 0.5
       */
      minDate: null,
      /**
       * @name nixps.Calendar#enableMultipleDayPeriods
       * @description Are the periods that we drag allowed to overlap multiple days
       * @type {boolean}
       * @default true
       */
      enableMultipleDayPeriods: true,
      /**
       * @name nixps.Calendar#height
       * @description The height of the calender
       * @type {number|function|"parent"|"auto"}
       * @default "auto"
       */
      height: "auto"
    },
    /**
     * @description create the component
     * @name nixps.Calendar#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);

      // two items th help, for doubleclick event detection
      this.currentTime;
      this.pastTarget = {
        x: 0,
        y: 0
      };

      // init and translate text buttons
      this.buttonText = {};
      if ($.isPlainObject($.i18n)) {
        // if translation component found, translate it
        this.buttonText = {
          today: $.i18n._('nixps-calendar.today'),
          month: $.i18n._('nixps-calendar.month'),
          week: $.i18n._('nixps-calendar.week'),
          day: $.i18n._('nixps-calendar.day')
        };
      } else {
        // fall back if no translations found
        this.buttonText = {
          today: 'Today',
          month: 'Month',
          week: 'Week',
          day: 'Day'
        };
      }
      this._draw();
      $("body").on("transitionend", ".detailspanel", this.renderCalendar.bind(this));
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps.Calendar#redraw
     * @example $('#calendar').Calendar('redraw')
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.Calendar#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      // draw calendar
      var calendar = $('<div>').addClass('calendar');
      this.element.empty().append(calendar);
      var calendarInstance = new FullCalendar.Calendar(calendar[0], {
        initialDate: moment(this.options.defaultDate).toDate(),
        // the day to show on startup
        initialView: "timeGridWeek",
        // which view must we show on startup
        views: {
          agendaFiveDay: {
            type: 'timeGridWeek',
            duration: {
              days: 5
            },
            buttonText: '5 day'
          }
        },
        height: this.options.height,
        locales: this.options.language,
        customButtons: {
          // add custom buttons
          addPeriodButton: {
            text: '' + $.i18n._('nixps-calendar.add'),
            click: this._addPeriodButtonClickHandler.bind(this)
          }
        },
        weekends: true,
        // will be overwritten by next option hiddenDays
        hiddenDays: this.options.hiddenDays,
        buttonText: this.buttonText,
        headerToolbar: this.options.header,
        firstDay: 1,
        // zero based, zero means start on Sunday
        businessHours: this.options.businessHours,
        allDaySlot: false,
        // must we show on top a dayAll event
        editable: true,
        // must the events be draggable, droppable and changeable?
        eventStartEditable: this.options.eventStartEditable,
        eventDurationEditable: this.options.eventDurationEditable,
        selectable: this.options.selectable,
        events: this._eventsProvider.bind(this),
        viewDidMount: this._viewRender.bind(this),
        eventDrop: this._dragDrop.bind(this),
        eventResize: this._resizeHandler.bind(this),
        dateClick: this._clickFreeHandler.bind(this),
        eventClick: this._clickItemHandler.bind(this),
        select: this._selectHandler.bind(this),
        eventDidMount: this._eventRenderHandler.bind(this)
        /*googleCalendarApiKey: "AIzaSyBX29qaa_Gw7cibBP5xIfLvohryEVHg5Bk",
        events: {
            //googleCalendarId: 'hybridsoftware.com_25jhf37kvkr1jq43r0guop31kg%40group.calendar.google.com'
            googleCalendarId: 'hybridsoftware.com_25jhf37kvkr1jq43r0guop31kg@group.calendar.google.com'
        }*/
      });

      calendarInstance.render();
      this.mCalendarInstance = calendarInstance;
    },
    renderCalendar: function renderCalendar() {
      if (this.mCalendarInstance !== undefined) {
        this.mCalendarInstance.render();
      }
    },
    /**
     * @description called by plugin itself whenit needs some data,
     * @function
     * @name nixps.Calendar#_eventsProvider
     * @private
     * @param {moment} start the start of the tempory range
     * @param {moment} end the end of the tempory range
     * @param {type} timezone
     * @param {function} callback function to call when you have the data, with the data as arguments
     * @returns {undefined}
     */
    // _eventsProvider: function(start, end, timezone, callback) {
    _eventsProvider: function _eventsProvider(fetchInfo, successCallback, failureCallback) {
      var that = this;
      $.when(this.options.periodeProvider(fetchInfo.start, fetchInfo.end)).done(function (pPeriods) {
        successCallback(that._prepairAndGroupPeriods(pPeriods.periods, pPeriods.availablePeriods, pPeriods.unavailablePeriods));
      }).fail(function () {
        failureCallback([]);
      });
    },
    /**
     * @description Function runs when user click on the add event button, This fires a "clickadd" event
     * @fucntion
     * @private 
     * @name nixps.Calendar#_addPeriodButtonClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _addPeriodButtonClickHandler: function _addPeriodButtonClickHandler(pEvent, pData) {
      this._trigger('clickadd', pEvent, {
        view: this.mCalendarInstance.view
      });
    },
    /**
     * @description function runs when the calender view changed, before drawing the events
     * @function
     * @private
     * @name nixps.Calendar#_viewRender
     * @param {object} view
     * @param {HTMLObject} element
     * @returns {undefined}
     */
    _viewRender: function _viewRender(pArgs) {
      var view = pArgs.view;
      var element = pArgs.el;
      // Past
      if (this.options.minDate !== null) {
        if (this.options.minDate >= view.currentStart && this.options.minDate <= view.currentEnd) {
          this.element.find(".fc-prev-button").prop('disabled', true);
          this.element.find(".fc-prev-button").addClass('fc-state-disabled');
        } else {
          this.element.find(".fc-prev-button").removeClass('fc-state-disabled');
          this.element.find(".fc-prev-button").prop('disabled', false);
        }
      }
      // Future
      if (this.options.maxDate !== null) {
        if (this.options.maxDate >= view.currentStart && this.options.maxDate <= view.currentEnd) {
          this.element.find(".fc-next-button").prop('disabled', true);
          this.element.find(".fc-next-button").addClass('fc-state-disabled');
        } else {
          this.element.find(".fc-next-button").removeClass('fc-state-disabled');
          this.element.find(".fc-next-button").prop('disabled', false);
        }
      }
      this._trigger('view', null, {
        begin: view.currentStart,
        end: view.currentEnd
      });
    },
    updateNextAndPrevButtons: function updateNextAndPrevButtons() {
      this._viewRender({
        view: this.getView()
      });
    },
    /**
     * @description function runs when user changed begintime of existing period
     * @function
     * @private
     * @name nixps.Calendar#_dragDrop
     * @param {type} pTimeEvent
     * @param {type} pDeltaDuration
     * @param {type} jsEvent
     * @param {type} pUI
     * @param {type} pView
     * @returns {undefined}
     */
    _dragDrop: function _dragDrop(eventDropInfo) {
      var pTimeEvent = eventDropInfo.event,
        pDeltaDuration = eventDropInfo.delta,
        pRevertFunc = eventDropInfo.revert,
        jsEvent = eventDropInfo.jsEvent,
        pUI = eventDropInfo.el,
        pView = eventDropInfo.view;
      this._trigger('change', jsEvent, {
        changedPeriod: pTimeEvent,
        deltaStart: pDeltaDuration,
        deltaEnd: pDeltaDuration,
        errorCB: pRevertFunc,
        view: pView
      });
    },
    /**
     * @description function runs when user changed end time of existing period
     * @function
     * @private
     * @name nixps.Calendar#_resizeHandler
     * @param {type} pTimeEvent
     * @param {type} pDeltaDuration
     * @param {type} pRevertFunc
     * @param {type} jsEvent
     * @param {type} pUI
     * @param {type} pView
     * @returns {undefined}
     */
    _resizeHandler: function _resizeHandler(eventDragInfo) {
      var pTimeEvent = eventDragInfo.event,
        pDeltaDuration = moment.duration(eventDragInfo.endDelta),
        pRevertFunc = eventDragInfo.revert,
        jsEvent = eventDragInfo.jsEvent,
        pUI = eventDragInfo.el,
        pView = eventDragInfo.view;
      if (this.options.enableMultipleDayPeriods === false && isSameDate(pTimeEvent.start, pTimeEvent.end) === false) {
        pRevertFunc();
        return false;
      }
      this._trigger('change', jsEvent, {
        changedPeriod: pTimeEvent,
        deltaStart: moment.duration(0),
        deltaEnd: pDeltaDuration,
        errorCB: pRevertFunc,
        view: pView
      });
    },
    /**
     * @description fucntion runs when user click on a timespace without tasks
     * @function
     * @private
     * @name nixps.Calendar#_clickFreeHandler
     * @param {type} pDateMoment
     * @param {type} jsEvent
     * @param {type} view
     * @returns {undefined}
     */
    _clickFreeHandler: function _clickFreeHandler(dateClickInfo) {
      var date = dateClickInfo.date,
        jsEvent = dateClickInfo.jsEvent,
        view = dateClickInfo.view;
      if (this._isDoubleClick(jsEvent)) {
        //double click call back
        this._trigger('dblclickfree', jsEvent, {
          date: date = dateClickInfo.date,
          view: view
        });
      }
      this._trigger('clickfree', jsEvent, {
        date: date = dateClickInfo.date,
        view: view
      });
    },
    /**
     * @description function runs when user click on a item
     * @function
     * @private
     * @name nixps.Calendar#_clickItemHandler
     * @param {type} pTimeEvent
     * @param {type} jsEvent
     * @param {type} view
     * @returns {undefined}
     */
    _clickItemHandler: function _clickItemHandler(eventClickInfo) {
      var pTimeEvent = eventClickInfo.event,
        jsEvent = eventClickInfo.jsEvent,
        view = eventClickInfo.view;
      if (this._isDoubleClick(jsEvent)) {
        //double click call back
        this._trigger('dblclickperiod', jsEvent, {
          period: pTimeEvent,
          view: view
        });
      }
      this._trigger('clickperiod', jsEvent, {
        period: pTimeEvent,
        view: view
      });
      this.element.find('.nixpsCalendar_select').removeClass('nixpsCalendar_select');
      $(jsEvent.currentTarget).addClass('nixpsCalendar_select');
    },
    /**
     * @description function runs after the user has select something
     * @function
     * @private
     * @name nixps.Calendar#_selectHandler
     * @param {type} pStartMoment
     * @param {type} pEndMoment
     * @param {type} jsEvent
     * @param {type} pView
     * @returns {undefined}
     */
    _selectHandler: function _selectHandler(selectionInfo) {
      var pStartMoment = selectionInfo.start,
        pEndMoment = selectionInfo.end,
        jsEvent = selectionInfo.jsEvent,
        pView = selectionInfo.view;
      this._trigger('select', jsEvent, {
        start: pStartMoment,
        end: pEndMoment,
        view: pView
      });
    },
    /**
     * @description remove a period of the calendar
     * @name nixps-Calendar#removePeriod
     * @function
     * @param {string} idOrFilter
     * @returns {undefined}
     */
    removePeriod: function removePeriod(idOrFilter) {
      if (typeof idOrFilter === "string" && idOrFilter.length > 0) {
        var event = this.mCalendarInstance.getEventById(idOrFilter);
        event.remove();
      }
    },
    /**
     * @description internal function to help emulation the doubleclick event detection
     * @function
     * @private
     * @name nixps.Calendar#_isDoubleClick
     * @param {object | event } pEvent
     * @returns {Boolean} true if the event is a double click, false if the event is not a double click
     */
    _isDoubleClick: function _isDoubleClick(pEvent) {
      var prevTime = typeof this.currentTime === 'undefined' || this.currentTime === null ? new Date().getTime() - 1000000 : this.currentTime;
      this.currentTime = new Date().getTime();
      // if click event is vast enough and if mouse is staing on same place
      if (this.currentTime - prevTime < 500 && Math.abs(pEvent.screenX - this.pastTarget.x) < 20 && Math.abs(pEvent.screenY - this.pastTarget.y) < 20) {
        return this.currentTime - prevTime < 500;
      } else {
        this.pastTarget.x = pEvent.screenX;
        this.pastTarget.y = pEvent.screenY;
        return false;
      }
    },
    /**
     * @description function runs and calls when plugin render a event/period
     * @function
     * @private
     * @name nixps.Calendar#_eventRenderHandler
     * @param {type} helperUIModel
     * @param {type} dragableUI
     * @param {type} view
     * @returns {Boolean}
     */
    _eventRenderHandler: function _eventRenderHandler(pArgs) {
      var helperUIModel = pArgs.el;
      if (this.options.enableMultipleDayPeriods === false && helperUIModel.className[0] === "fc-helper" && isValidDate(helperUIModel.start) && isValidDate(helperUIModel.end)) {
        if (pArgs.isStart) {
          return false;
        }
        ;
      }
    },
    /**
     * @description refresh the calendar
     * @name nixps-Calendar#refresh
     * @function
     * @param {string} idOrFilter
     * @returns {undefined}
     */
    refresh: function refresh() {
      this.mCalendarInstance.refetchEvents();
    },
    /**
     * @name nixps.Calendar#gotoDate
     * @description Go directly to a specific date
     * @function
     * @param {moment} pDateMoment must be a correct moment or a correct inputparameter for a moment object
     * @example $('#calendar').Calendar('gotoDate', '2016-08-25')
     * @returns {undefined}
     */
    gotoDate: function gotoDate(pDateMoment) {
      this.mCalendarInstance.gotoDate(pDateMoment);
    },
    /**
     * @name nixps.Calendar#gotoView
     * @description Go to a specific view. The view must be specified in the option "header", otherwise it will not wok correctly.
     * @function
     * @param {string} pView The view you want to see.
     * @example $('#calendar').Calendar('gotoView', 'agendaDay')
     * @returns {undefined}
     */
    gotoView: function gotoView(pView) {
      this.mCalendarInstance.changeView(pView);
    },
    getView: function getView() {
      return this.mCalendarInstance.view;
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
      });
      if (needRedraw === true) {
        this._draw();
      }
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps.Calendar#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "minDate" || pKey === "maxDate") {
        // no redraw forced
        return false;
      } else {
        return true;
      }
    },
    /**
     * @description force the events to have some fixed parameters. 
     * So here we add and overwrite some parameters of the option unaviablePeriods
     * @function
     * @private
     * @name nixps.Calendar#_prepairPeriods
     * @returns {undefined}
     */
    _prepairAndGroupPeriods: function _prepairAndGroupPeriods(pPeriods, pAviablePeriods, pUnaviablePeriods) {
      var outputPeriods = [];
      // normal periods;
      if (Array.isArray(pPeriods) && pPeriods.length > 0) {
        outputPeriods = outputPeriods.concat(pPeriods);
      }
      // the aviable periods
      if (Array.isArray(pAviablePeriods) && pAviablePeriods.length > 0) {
        pAviablePeriods = $.map(pAviablePeriods, function (event, index) {
          event.id = 'aviable';
          event.rendering = "background";
          return event;
        });
        outputPeriods = outputPeriods.concat(pAviablePeriods);
      }
      // the unaviable periods
      if (Array.isArray(pUnaviablePeriods) && pUnaviablePeriods.length > 0) {
        pUnaviablePeriods = $.map(pUnaviablePeriods, function (event, index) {
          event.id = 'unaviable';
          event.rendering = "background";
          event.overlap = false;
          event.color = '#ff9f89';
          return event;
        });
        outputPeriods = outputPeriods.concat(pAviablePeriods);
      }
      for (var i = 0; i < outputPeriods.length; i++) {
        outputPeriods[i].start = new Date(outputPeriods[i].start);
        outputPeriods[i].end = new Date(outputPeriods[i].end);
      }
      return outputPeriods;
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps.Calendar#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof window.moment !== "function") {
        throw new Error('please include the pluging moment');
      }
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error('input option language must be a not empty string');
      }
      if (typeof this.options.defaultView !== "string" || this.options.defaultView.length <= 0) {
        throw new Error('input option defaultView must be a not empty string');
      }
      if (!$.isPlainObject(this.options.header) || $.isEmptyObject(this.options.header)) {
        throw new Error('input option header must be a not empty object');
      }
      if (typeof this.options.header.right !== "string" || this.options.header.right.length <= 0) {
        throw new Error('input option header must contain a "right" parameter containing a not empty string');
      }
      if (this.options.header.right.search(this.options.defaultView) < 0) {
        console.warn('The defaultView has no header button!');
      }
      if (typeof this.options.periodeProvider !== "function") {
        throw new Error('input option periodeProvider must be a function');
      }
      if (!Array.isArray(this.options.hiddenDays)) {
        throw new Error('input option hiddenDays must be a array');
      }
      for (var i = 0; i < this.options.hiddenDays.length; i++) {
        if ($.inArray(this.options.hiddenDays[i], [0, 1, 2, 3, 4, 5, 6]) < 0) {
          throw new Error('input option hiddenDays has invalid item:' + this.options.hiddenDays[i]);
        }
      }
      if (typeof this.options.eventStartEditable !== "boolean") {
        throw new Error('input option eventStartEditable must be a boolean');
      }
      if (typeof this.options.eventDurationEditable !== "boolean") {
        throw new Error('input option eventDurationEditable must be a boolean');
      }
      if (typeof this.options.selectable !== "boolean") {
        throw new Error('input option selectable must be a boolean');
      }
      if (typeof this.options.enableMultipleDayPeriods !== "boolean") {
        throw new Error('input option enableMultipleDayPeriods must be a boolean');
      }
      if (this.options.minDate !== null && isValidDate(this.options.minDate) === false) {
        throw new Error('input option minDate must be null or a moment');
      }
      if (this.options.maxDate !== null && isValidDate(this.options.maxDate) === false) {
        throw new Error('input option maxDate must be null or a moment');
      }
      if (isValidDate(this.options.minDate) && isValidDate(this.options.maxDate) && this.options.minDate > this.options.maxDate) {
        throw new Error('input option maxDate must become after option minDate');
      }
    }
  });
})(jQuery);

},{}],284:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by Guillaume Desmet on 11/22/2018, 5:29:45 PM
 * 
 * 
 *   README: see documentaion at https://www.chartjs.org/docs/   
 */
(function ($) {
  $.getCSS = function (pClassName, pCSSRule) {
    var shadow = $("<div>").addClass(pClassName).hide();
    $("body").append(shadow);
    var cssValue = shadow.css(pCSSRule);
    shadow.remove();
    if (cssValue === "rgba(0, 0, 0, 0)" && pCSSRule === "backgroundColor") {
      return null;
    }
    if (pCSSRule === "borderColor") {
      var shadow = $("<div>").hide();
      $("body").append(shadow);
      var cssNormalValue = shadow.css(pCSSRule);
      shadow.remove();
      if (cssValue === cssNormalValue) {
        return null;
      }
    }
    return cssValue;
  };
})(jQuery);
(function ($) {
  var kBackgroundColor = "#0080BF";
  var kBorderColor = "#fff";
  var backgroundClassDict = {};
  function getBackgroundColorFromClass(pClass) {
    if (typeof pClass !== "string" && pClass.length <= 0) {
      throw new Error("parameter pClass must be a not empty String");
    }
    if (backgroundClassDict[pClass] !== undefined) {
      return backgroundClassDict[pClass];
    }
    var color = $.getCSS("nixps_styling_class_" + pClass, "backgroundColor");
    if (color === null) {
      backgroundClassDict[pClass] = kBackgroundColor;
    } else {
      backgroundClassDict[pClass] = color;
    }
    return backgroundClassDict[pClass];
  }
  var borderColorClassDict = {};
  function getBorderColorFromClass(pClass) {
    if (typeof pClass !== "string" && pClass.length <= 0) {
      throw new Error("parameter pClass must be a not empty String");
    }
    if (borderColorClassDict[pClass] !== undefined) {
      return borderColorClassDict[pClass];
    }
    var color = $.getCSS("nixps_styling_class_" + pClass, "borderColor");
    if (color === null) {
      borderColorClassDict[pClass] = null;
    } else {
      borderColorClassDict[pClass] = color;
    }
    return borderColorClassDict[pClass];
  }
  function getPluginVersion() {
    if (typeof window.Chart.Bar === "function") {
      return "2";
    }
    return "4";
  }

  /**
   * @namespace nixps.BasicChart
   * @description Draw a BasicChart component,
   * @example $('<div>').BasicChart({});
   * @version 1.1.0
   */
  $.widget("nixps.BasicChart", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "basicchart",
    options: {
      /**
       * @description The with of the chart in px
       * @name nixps.BasicChart#width
       * @type {Number}
       * @default 400
       */
      width: 400,
      /**
       * @description The height of the chart in px
       * @name nixps.BasicChart#height
       * @type {Number}
       * @default 400
       */
      height: 400,
      /**
       * @description The type of chart we must show. This can be a "pie", "line", "bar", "polarArea"
       * @name nixps.BasicChart#type
       * @type {String}
       * @default "bar"
       * @example "pie"
       */
      type: "bar",
      /**
       * @description The list of static colors to be used
       * @name nixps.BasicChart#colors
       * @type {Array.<String>}
       * @default []
       */
      colors: [],
      /**
       * @description The static list of labels
       * @name nixps.BasicChart#labels
       * @type {Array.<String>}
       * @default []
       */
      labels: [],
      /**
       * @description The data to be show
       * @name nixps.BasicChart#data
       * @type {Array.<Object>}
       * @default []
       */
      data: [],
      /**
       * @description Must we show a labels or not?
       * @name nixps.BasicChart#showLabels
       * @type {Boolean}
       * @default false
       * @since 1.1.0
       */
      showLabels: false,
      /**
       * @description Stacked graph or not?
       * @name nixps.BasicChart#stacked
       * @type {Boolean}
       * @default false
       * @since 1.1.0
       */
      stacked: false,
      /**
       * @description Options for the legend
       * @name nixps.BasicChart#legend
       * @type {Object}
       * @default undefined
       * @since 1.1.0
       */
      legend: undefined,
      /**
       * @description Text to show when no group is defined
       * @name nixps.BasicChart#undefinedGroupLabel
       * @type {String}
       * @default "no group"
       */
      undefinedGroupLabel: "no group",
      /**
       * @name nixps.BasicChart#keyUniqID
       * @description The parameter name of the id of the objects
       * @type {String}
       * @default "_id"
       */
      keyUniqID: "_id",
      /**
       * @description function runws when the component is done rendering
       * @name nixps.BasicChart#created
       * @private
       * @type {Function}
       * @default function(){}
       */
      created: function created() {},
      /**
       * @description should the chart be responsive?
       * @name nixps.BasicChart#responsive
       * @private
       * @type {Boolean}
       * @default false
       */
      responsive: false,
      /**
       * @description hide the labels below the x-axis
       * @name nixps.BasicChart#hideXLabels
       * @private
       * @type {Boolean}
       * @default false
       */
      hideXLabels: false,
      /**
       * @description hide the labels on the y-axis
       * @name nixps.BasicChart#hideYLabels
       * @private
       * @type {Boolean}
       * @default false
       */
      hideYLabels: false,
      /**
       * @description Disable grid in chart.
       * @name nixps.BasicChart#disableGrid
       * @private
       * @type {Boolean}
       * @default false
       */
      disableGrid: false,
      /**
       * @description The title for the x-axis.
       * @name nixps.BasicChart#XAxisTitle
       * @private
       * @type {String}
       * @default ""
       */
      XAxisTitle: "",
      /**
       * @description The title for the y-axis.
       * @name nixps.BasicChart#YAxisTitle
       * @private
       * @type {String}
       * @default ""
       */
      YAxisTitle: "",
      /**
       * @description Show the gridlines inside the Chart
       * @name nixps.BasicChart#showGridLinesOnChartArea
       * @private
       * @type {Boolean}
       * @default true
       */
      showGridLinesOnChartArea: true,
      /**
       * @description The maximum Y axis value
       * @example 100, undefined, 1.0 (undefined = automatic nummering)
       * @name nixps.BasicChart#YAxisMax
       * @private
       * @type {Number}
       * @default undefined
       */
      YAxisMax: undefined,
      /**
       * @description The minimum Y axis value
       * @example 100, undefined, 1.0 (undefined = automatic nummering)
       * @name nixps.BasicChart#YAxisMin
       * @private
       * @type {Number}
       * @default undefined
       */
      YAxisMin: undefined,
      /**
       * @description The maximum X axis value
       * @example 100 | undefined | 1.0 (undefined = automatic nummering)
       * @name nixps.BasicChart#XAxisMax
       * @private
       * @type {Number}
       * @default undefined
       */
      XAxisMax: undefined,
      /**
       * @description Function to override the tick generation for the Y axis
       * @example function(value, index, values) {
                  return '$' + value;
              }
       * @name nixps.BasicChart#YAxisTicksOverride
       * @private
       * @type {Function}
       * @default undefined
       */
      YAxisTicksOverride: undefined,
      /**
      * @description Function to override the tick generation for the X axis
      * @example function(value, index, values) {
                 return '$' + value;
             }
      * @name nixps.BasicChart#XAxisTicksOverride
      * @private
      * @type {Function}
      * @default undefined
      */
      XAxisTicksOverride: undefined,
      /**
       * @description function to override the datalabels text
       * @name nixps.BasicChart#overrideDatalabels
       * @private
       * @type {Function}
       * @example function(value, context) {return context.chart.data.labels[context.dataIndex];}
       * @default undefined
       */
      overrideDatalabels: undefined,
      /**
       * @description tooltip options see https://www.chartjs.org/docs/2.7.3/configuration/tooltip.html#tooltip-callbacks
       * @name nixps.BasicChart#tooltipsOptions
       * @private
       * @type {Object}
       * @default {}
       */
      tooltipsOptions: {},
      /**
       * @description Define text inside a doughnut chart. see https://github.com/ciprianciurea/chartjs-plugin-doughnutlabel
       * @name nixps.BasicChart#doughnutlabels
       * @private
       * @type {Array}
       * @example [
                      {
                          text: 'The title',
                          font: {
                          size: '60'
                          }
                      },
                      {
                          text: function(){return "Title"},
                          font: {
                          size: '50'
                          },
                          color: 'grey'
                      },
                      {
                          text: '$100.000',
                          font: {
                          size: '30'
                          },
                          color: 'red'
                      },
                      {
                      text: '95%',
                      font: {
                          size: '45'
                          family: 'Arial, Helvetica, sans-serif',
      style: 'italic',
      weight: 'bold'
        },
      color: '#bc2c1a'
                      }
                  ]
       * @default undefined
       */
      doughnutlabels: undefined,
      /**
       * @description Disables the initial animation
       * @name nixps.BasicChart#disableAnimation
       * @type {boolean}
       * @default false
       */
      disableAnimation: false,
      /**
       * @description Border width of the arc inside doughnut chart
       * @name nixps.BasicChart#arcBorderWidth
       * @type {number}
       * @default undefined
       * 
      **/
      arcBorderWidth: undefined,
      /**
       * @description Define the lineTension, border of points when it is a line
       * @name nixps.BasicChart#lineTension
       * @type {Number}
       * @default undefined
       */
      lineTension: undefined,
      /**
       * @description Padding around the chart inside the canvas
       * @name nixps.BasicChart#padding
       * @type {number}
       * @default 4
       */
      padding: 4,
      dataOverTime: false
    },
    /**
     * @description Create the component
     * @name nixps.BasicChart#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).css({
        "height": this.options.responsive !== true ? this.options.height : undefined,
        "width": this.options.responsive !== true ? this.options.width : undefined
      });
      // init
      this.creating = true;
      this.myChart = null;
      this.labels = [];
      this.backgroundColors = [];
      this.borderColors = [];
      this.data = [];
      this.groups = [];
      this.datasets = [];
      if (window.ChartDataLabels !== undefined) {
        if (typeof window.Chart.register === "function") {
          // recent version > 2
          Chart.register(ChartDataLabels);
        } else {
          // old version version <= 2
          window.Chart.plugins.register(ChartDataLabels);
        }
      }
      var canvas = $("<canvas>").attr({
        "id": "nixpsBasicChart_" + this.uuid,
        "height": this.options.responsive !== true ? this.options.height : undefined,
        "width": this.options.responsive !== true ? this.options.width : undefined
      }).text("Your browser does not support canvas, what is needed to draw charts");
      this.element.append($("<div>").addClass("no_data").text($.i18n._("nixps-cloudflow-pagebuilder.cloudflowchart_no_data")));
      this.element.append(canvas);
      this._draw();
      this._on(this.element, {});
    },
    /**
     * @description function runs when user click on a item
     * @function
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _clickHandler: function _clickHandler(pEvent, pData) {
      if (Array.isArray(pData) && pData.length > 0) {
        var dataPoints;
        if (typeof this.myChart.getElementAtEvent === "function") {
          dataPoints = this.myChart.getElementAtEvent(pEvent);
        } else {
          dataPoints = this.myChart.getElementsAtEventForMode(pEvent, "nearest", {
            intersect: true
          }, false);
        }
        if (Array.isArray(dataPoints) === false || dataPoints.length <= 0) {
          // wrong return data
          throw new Error("BasicChart: wrong return data from getElementAtEvent");
        }
        var dataPoint = dataPoints[0];
        var index = undefined; // _index has been replaced by index
        if (typeof dataPoint._index === "number") {
          index = dataPoint._index;
        } else {
          index = dataPoint.index;
        }
        if (typeof index === "number" && index >= 0) {
          var eventData = {
            index: index,
            label: this.labels[index]
          };
          if (this.groups.length === 0) {
            eventData.value = this.datasets[0].data[index];
            eventData.group = this.datasets[0].label;
            if (this.options.data[index][this.options.keyUniqID] !== undefined) {
              eventData[this.options.keyUniqID] = this.options.data[index][this.options.keyUniqID];
              // make compatible with other components and add parameter "id"
              eventData.id = this.options.data[index][this.options.keyUniqID];
            }
          } else {
            var dataSetIndex = undefined; // _datasetIndex has been replaced by datasetIndex
            if (typeof dataPoint._datasetIndex === "number") {
              dataSetIndex = dataPoint._datasetIndex;
            } else {
              dataSetIndex = dataPoint.datasetIndex;
            }
            if (typeof dataSetIndex !== "number" || dataSetIndex < 0) {
              // we expected numeric value _datasetIndex
              throw new Error("BasicChart: We expected numeric value _datasetIndex");
            }
            eventData.value = this.datasets[dataSetIndex].data[index];
            eventData.group = this.datasets[dataSetIndex].label;
            if (this.datasets[dataSetIndex].ids[index] !== undefined) {
              eventData[this.options.keyUniqID] = this.datasets[dataSetIndex].ids[index];
              // make compatible with other components and add parameter "id"
              eventData.id = this.datasets[dataSetIndex].ids[index];
            }
          }
          this._trigger("click", pEvent, eventData);
        } else {
          console.error("_clickHandler, no index found");
        }
      }
    },
    _onCompleteHandler: function _onCompleteHandler(pData) {
      if (this.creating === true) {
        this.creating = false;
        this.options.created();
      }
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.BasicChart#redraw
     */
    redraw: function redraw() {
      this.myChart.destroy();
      this._draw();
    },
    /**
     * @description Make one array of objects containing at least default values
     * @function
     * @private
     */
    _normaliseData: function _normaliseData() {
      var currentPoint, value, label, background_color, border_color, group, fill, datalabel;
      for (var i = 0; i < this.options.data.length; i++) {
        // init default values
        value = 0;
        if (typeof this.options.labels[i] === "string" || typeof this.options.labels[i] === "number" || typeof this.options.labels[i] === "boolean") {
          label = "" + this.options.labels[i];
        } else {
          label = "" + (i + 1);
        }
        if (typeof this.options.colors[i] === "string") {
          background_color = this.options.colors[i];
          border_color = this.options.colors[i];
        } else {
          background_color = kBackgroundColor;
          border_color = kBorderColor;
        }
        group = null;
        // change those values
        if (this.options.data[i] !== null && _typeof(this.options.data[i]) === "object" && !Array.isArray(this.options.data[i])) {
          currentPoint = this.options.data[i];
          if (currentPoint.value !== undefined) {
            value = currentPoint.value;
          }
          if (typeof currentPoint.label === "string" || typeof currentPoint.label === "number" || typeof currentPoint.label === "boolean") {
            label = "" + currentPoint.label;
          }
          if (typeof currentPoint.color === "string" && currentPoint.color.length > 0) {
            background_color = currentPoint.color;
          }
          if (typeof currentPoint.background_color === "string" && currentPoint.background_color.length > 0) {
            background_color = currentPoint.background_color;
          } else if (currentPoint.color === undefined && typeof currentPoint["class"] === "string" && currentPoint["class"].length > 0) {
            // if background color is not defined, fallback to pagebuilder class 
            background_color = getBackgroundColorFromClass(currentPoint["class"]);
          }
          if (typeof currentPoint.border_color === "string" && currentPoint.border_color.length > 0) {
            border_color = currentPoint.border_color;
          } else if (typeof currentPoint["class"] === "string" && currentPoint["class"].length > 0) {
            var candidateBorderColor = getBorderColorFromClass(currentPoint["class"]);
            if (typeof candidateBorderColor === "string" && candidateBorderColor.length > 0) {
              border_color = candidateBorderColor;
            }
          }
          if (typeof currentPoint.group === "string" && currentPoint.group.length > 0) {
            group = currentPoint.group;
          } else if (typeof currentPoint.group === "number" || typeof currentPoint.group === "boolean") {
            group = "" + currentPoint.group;
          }
        } else if (typeof this.options.data[i] === "number") {
          value = this.options.data[i];
        } else if (typeof this.options.data[i] === "string" && this.options.data[i].length > 0) {
          if (this.options.data[i][0] !== "-") {
            value = parseFloat("0" + this.options.data[i]);
          } else {
            value = parseFloat(this.options.data[i]);
          }
        }
        // is value a real value and not a NaN or Infinity
        if (isNaN(value) || isFinite(value) === false) {
          value = 0;
        }
        fill = true; // default
        if (this.options.data[i].fill === false) {
          fill = false;
        }

        // some sources have _ids 
        var source_id = this.options.data[i][this.options.keyUniqID];

        // update to one object
        this.options.data[i] = {
          value: value,
          label: label,
          background_color: background_color,
          border_color: border_color,
          group: group,
          fill: fill
        };
        if (source_id !== undefined) {
          this.options.data[i][this.options.keyUniqID] = source_id;
        }
        if (typeof group === "string" && this.groups.includes(group) === false) {
          this.groups.push(group);
        }
        if (typeof label === "string" && this.labels.includes(label) === false) {
          this.labels.push(label);
        }
      }
    },
    _calcLabels: function _calcLabels() {
      // if needed rewrite the labels
      if (this.groups.length > 0) {
        // define the correct possition of the labels
        // we use the first group found for that possition
        // we suppose the data has a correct format
        var mainGroup = this.options.data[0].label;
        // get the labels of the first group
        this.labels = [];
        for (var i = 0; i < this.options.data.length; i++) {
          if (this.options.data[i].group === mainGroup && this.labels.includes(this.options.data[i].label) === false) {
            this.labels.push(this.options.data[i].label);
          }
        }
        // add all others to the end
        for (var i = 0; i < this.options.data.length; i++) {
          if (this.options.data[i].group !== mainGroup && this.labels.includes(this.options.data[i].label) === false) {
            this.labels.push(this.options.data[i].label);
          }
        }
      }
    },
    _addMissingData: function _addMissingData() {
      // look if there are missing points and add default data for them
      if (this.groups.length > 0) {
        // make dict with all known values
        var groupDict = {};
        for (var i = 0; i < this.options.data.length; i++) {
          if (groupDict["" + this.options.data[i].group] === undefined) {
            groupDict["" + this.options.data[i].group] = {};
          }
          if (groupDict["" + this.options.data[i].group][this.options.data[i].label] === undefined) {
            groupDict["" + this.options.data[i].group][this.options.data[i].label] = true;
          }
        }
        // look if all labels exist in the dict
        for (var i = 0; i < this.labels.length; i++) {
          for (var groupname in groupDict) {
            if (groupDict[groupname][this.labels[i]] === undefined) {
              this.options.data.push({
                value: 0,
                label: this.labels[i] === "null" ? "" : this.labels[i],
                background_color: kBackgroundColor,
                border_color: kBorderColor,
                group: groupname
              });
            }
          }
        }
      }
    },
    /**
     * @description sort all data according to the labels
     * @function
     * @private
     */
    _sortData: function _sortData() {
      // we suppose the array data has good interface
      if (this.groups.length > 0) {
        var that = this;
        this.options.data.sort(function (a, b) {
          if (a.label === b.label) {
            return $.inArray(a.group, that.groups) - $.inArray(b.group, that.groups);
          } else {
            return $.inArray(a.label, that.labels) - $.inArray(b.label, that.labels);
          }
        });
      }
    },
    _calcData: function _calcData() {
      this.labels = [];
      this.backgroundColors = [];
      this.borderColors = [];
      this.data = [];
      this.datasets = [];
      this.groups = [];
      if (Array.isArray(this.options.data) === false || this.options.data.length === 0) {
        // no data
        console.warn("nixpsBasicChart: no data entries to display");
        return;
      }
      this._normaliseData();
      this._calcLabels();
      this._addMissingData();
      this._sortData();
      if (this.groups.length === 0) {
        var dataset = {
          data: [],
          backgroundColor: [],
          borderColor: [],
          label: this.options.undefinedGroupLabel,
          datalabels: {
            align: 'end',
            anchor: 'end'
          }
        };
        if (["bar", "horizontalBar"].includes(this.options.type)) {
          dataset.datalabels = {
            align: 'end',
            anchor: 'start'
          };
        }
        for (var i = 0; i < this.options.data.length; i++) {
          dataset.data.push(this.options.data[i].value);
          dataset.backgroundColor.push(this.options.data[i].background_color);
          dataset.borderColor.push(this.options.data[i].border_color);
        }
        if (["line", "radar"].includes(this.options.type)) {
          dataset.backgroundColor = dataset.backgroundColor[0];
          dataset.borderColor = dataset.borderColor[0];
        } else if (["bar", "horizontalBar"].includes(this.options.type) && dataset.borderColor.some(function (c) {
          return c !== kBorderColor;
        })) {
          dataset.borderWidth = 1;
        }
        if (typeof this.options.lineTension === "number") {
          dataset.lineTension = this.options.lineTension;
        }
        this.datasets.push(dataset);
      } else {
        for (var g = 0; g < this.groups.length; g++) {
          var dataset = {
            data: [],
            backgroundColor: [],
            borderColor: [],
            label: this.groups[g],
            ids: [],
            datalabels: {
              align: 'end',
              anchor: 'end'
            }
          };
          if (g > 0 && this.options.stacked === true) {
            dataset.fill = "-1";
          }
          if (["bar", "horizontalBar"].includes(this.options.type)) {
            dataset.datalabels = {
              align: 'start',
              anchor: 'end'
            };
          }
          for (var i = 0; i < this.options.data.length; i++) {
            if (this.options.data[i].group === this.groups[g]) {
              dataset.data.push(this.options.data[i].value);
              dataset.backgroundColor.push(this.options.data[i].background_color);
              dataset.borderColor.push(this.options.data[i].border_color);
              if (this.options.data[i][this.options.keyUniqID] !== undefined) {
                dataset.ids.push(this.options.data[i][this.options.keyUniqID]);
              }
              if (this.options.data[i].fill === false) {
                dataset.fill = false;
              }
              if (typeof this.options.lineTension === "number") {
                dataset.lineTension = this.options.lineTension;
              }
            }
          }
          if (["line", "radar", "scatter"].includes(this.options.type)) {
            dataset.backgroundColor = dataset.backgroundColor[0];
            dataset.borderColor = dataset.borderColor[0];
          }
          if (this.options.type === "scatter") {
            dataset.showLine = false;
          }
          this.datasets.push(dataset);
        }
      }
    },
    /**
     * @description get the chart tyep for chartjs
     * @function
     * @private
     * @name nixps.BasicChart#_getChartType
     * @returns The type of bar known by chartjs
     */
    _getChartType: function _getChartType() {
      if (getPluginVersion() === "4") {
        if (this.options.type === "horizontalBar") {
          return "bar";
        }
        return this.options.type;
      } else {
        return this.options.type;
      }
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.BasicChart#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this._calcData();
      var ctx = document.getElementById("nixpsBasicChart_" + this.uuid);
      if (ctx === null) {
        throw new Error("_draw: canvas is missing");
      }
      if (window.Chart !== undefined) {
        var plugins = [];
        if (window.ChartDataLabels !== undefined) {
          plugins.push(ChartDataLabels);
        }
        this.myChart = new Chart(ctx, {
          plugins: plugins,
          type: this._getChartType(),
          data: {
            labels: this.labels,
            datasets: this.datasets
          },
          options: this._getOptions()
        });
        if (!Array.isArray(this.datasets) || this.datasets.length <= 0) {
          this.element.find(".no_data").css("display", "");
        } else {
          this.element.find(".no_data").hide();
        }
      }
    },
    /**
     * @description Calc the options for the chart plugin
     * @function
     * @private
     */
    _getOptions: function _getOptions() {
      var that = this;
      var options = {};
      if (["bar", "line", "horizontalBar", "scatter"].indexOf(this.options.type) >= 0) {
        options.plugins = {
          datalabels: {
            clamp: true,
            display: function display(context) {
              if (!that.options.showLabels) {
                return false;
              }
              var minValue;
              if (that.options.type === "line") {
                return true;
              } else if (that.options.type === "horizontalBar") {
                minValue = (context.chart.scales["x-axis-0"].max - context.chart.scales["x-axis-0"].min) * 0.08;
              } else {
                minValue = (context.chart.scales["y-axis-0"].max - context.chart.scales["y-axis-0"].min) * 0.12;
              }
              if (context.dataset.data[context.dataIndex] >= 0 && context.dataset.data[context.dataIndex] < minValue) {
                return false;
              } else if (context.dataset.data[context.dataIndex] <= 0 && Math.abs(context.dataset.data[context.dataIndex]) < minValue) {
                return false;
              }
              return true;
            },
            backgroundColor: function backgroundColor(context) {
              return context.dataset.backgroundColor;
            },
            borderRadius: 3,
            color: 'white',
            font: {
              weight: 'bold'
            },
            formatter: Math.round,
            padding: that.options.padding || 4
          }
        };
        if (getPluginVersion() === "4") {
          options.scales = {
            x: {
              scaleLabel: {
                display: typeof this.options.XAxisTitle === "string" && this.options.XAxisTitle.length > 0,
                labelString: this.options.XAxisTitle
              },
              stacked: this.options.stacked,
              lines: !this.options.disableGrid ? {
                color: "rgba(0, 0, 0, 0)",
                tickLength: 0,
                drawOnChartArea: this.options.showGridLinesOnChartArea
              } : {},
              ticks: {
                display: this.options.hideXLabels !== true,
                max: this.options.XAxisMax,
                beginAtZero: true,
                callback: typeof this.options.XAxisTicksOverride === "function" ? this.options.XAxisTicksOverride : function (val) {
                  return val;
                }
              }
            },
            y: {
              scaleLabel: {
                display: typeof this.options.YAxisTitle === "string" && this.options.YAxisTitle.length > 0,
                labelString: this.options.YAxisTitle
              },
              stacked: this.options.stacked,
              lines: !this.options.disableGrid ? {
                color: "rgba(0, 0, 0, 0)",
                tickLength: 0,
                drawOnChartArea: this.options.showGridLinesOnChartArea
              } : {},
              ticks: {
                display: this.options.hideYLabels !== true,
                max: this.options.YAxisMax,
                min: this.options.YAxisMin,
                beginAtZero: true,
                callback: typeof this.options.YAxisTicksOverride === "function" ? this.options.YAxisTicksOverride : function (val) {
                  return val;
                }
              }
            }
          };
        } else {
          options.scales = {
            xAxes: [{
              scaleLabel: {
                display: typeof this.options.XAxisTitle === "string" && this.options.XAxisTitle.length > 0,
                labelString: this.options.XAxisTitle
              },
              stacked: this.options.stacked,
              gridLines: !this.options.disableGrid ? {
                color: "rgba(0, 0, 0, 0)",
                tickMarkLength: 0,
                drawOnChartArea: this.options.showGridLinesOnChartArea
              } : {},
              ticks: {
                display: this.options.hideXLabels !== true,
                max: this.options.XAxisMax,
                beginAtZero: true,
                callback: typeof this.options.XAxisTicksOverride === "function" ? this.options.XAxisTicksOverride : function (val) {
                  return val;
                }
              }
            }],
            yAxes: [{
              scaleLabel: {
                display: typeof this.options.YAxisTitle === "string" && this.options.YAxisTitle.length > 0,
                labelString: this.options.YAxisTitle
              },
              stacked: this.options.stacked,
              gridLines: !this.options.disableGrid ? {
                color: "rgba(0, 0, 0, 0)",
                tickMarkLength: 0,
                drawOnChartArea: this.options.showGridLinesOnChartArea
              } : {},
              ticks: {
                display: this.options.hideYLabels !== true,
                max: this.options.YAxisMax,
                min: this.options.YAxisMin,
                beginAtZero: true,
                callback: typeof this.options.YAxisTicksOverride === "function" ? this.options.YAxisTicksOverride : function (val) {
                  return val;
                }
              }
            }]
          };
        }
        if (this.options.type === "horizontalBar") {
          options.indexAxis = "y";
        }
      } else {
        options.plugins = {
          datalabels: {
            display: false
          }
        };
      }
      if (this.options.dataOverTime !== false) {
        options.scales.xAxes[0].type = "time", options.scales.xAxes[0].time = this.options.dataOverTime;
      }
      if (this.options.type === "doughnut" && Array.isArray(this.options.doughnutlabels) && this.options.doughnutlabels.length > 0) {
        options.plugins.doughnutlabel = {
          labels: this.options.doughnutlabels
        };
      }
      options.tooltips = this.options.tooltipsOptions;
      options.tooltip = this.options.tooltipsOptions;
      options.legend = this.options.legend;
      options.responsive = true;
      options.maintainAspectRatio = false;
      if ($.isPlainObject(this.options.legend)) {
        Object.assign(options.legend, this.options.legend);
      }
      if (typeof this.options.overrideDatalabels === "function") {
        options.plugins.datalabels.formatter = this.options.overrideDatalabels;
      }
      options.onClick = this._clickHandler.bind(this);
      options.animation = {
        onComplete: this._onCompleteHandler.bind(this)
      };
      if (this.options.disableAnimation === true) {
        options.animation = false;
      }
      if (this.options.arcBorderWidth !== undefined) {
        options.elements = {
          arc: {
            borderWidth: this.options.arcBorderWidth
          }
        };
      }
      return options;
    },
    /**
     * @description update the chart
     * @function
     * @private
     */
    _update: function _update() {
      this.myChart.data = {
        labels: this.labels,
        datasets: this.datasets
      };
      if (!Array.isArray(this.datasets) || this.datasets.length <= 0) {
        this.element.find(".no_data").css("display", "");
      } else {
        this.element.find(".no_data").hide();
      }
      this.myChart.options = this._getOptions();
      this.myChart.update(0);
    },
    update: function update() {
      this._update();
    },
    _setDimentions: function _setDimentions() {
      this.element.css({
        "height": this.options.responsive !== true ? this.options.height : undefined,
        "width": this.options.responsive !== true ? this.options.width : undefined
      });
      this.element.children("canvas").attr({
        "height": this.options.responsive !== true ? this.options.height : undefined,
        "width": this.options.responsive !== true ? this.options.width : undefined
      });
      if (this.myChart !== null) {
        this.myChart.resize();
      }
    },
    generateLegend: function generateLegend() {
      if (typeof this.myChart.generateLegend === "function") {
        // deprecated and removed function
        return this.myChart.generateLegend();
      }
      return null;
    },
    /**
     * @description show or hide the groups
     * @function
     * @name nixps.BasicChart#toggleGroups
     * @param {String | Number | RegExp } pSelector with labels should we activate or desactivet
     * @param {Boolean} pMode true to show, false to hide
     */
    toggleGroups: function toggleGroups(pSelector, pMode) {
      var indexes = [];
      if (typeof pSelector === "string") {
        for (var i = 0; i < this.myChart.data.datasets.length; i++) {
          if (typeof this.myChart.data.datasets[i].label === "string" && pSelector === this.myChart.data.datasets[i].label) {
            indexes.push(i);
          }
        }
      } else if (typeof pSelector === "number") {
        indexes = [pSelector];
      } else if (pSelector && typeof pSelector.test === "function") {
        for (var _i = 0; _i < this.myChart.data.datasets.length; _i++) {
          if (typeof this.myChart.data.datasets[_i].label === "string" && pSelector.test(this.myChart.data.datasets[_i].label)) {
            indexes.push(_i);
          }
        }
      }
      var hide = pMode === true ? false : true;
      for (var _i2 = 0; _i2 < indexes.length; _i2++) {
        this.myChart.getDatasetMeta(indexes[_i2]).hidden = hide;
      }
      this.myChart.update();
    },
    getChart: function getChart() {
      return this.myChart;
    },
    /**
     * @description Set Options
     * @function
     * @name nixps.BasicChart#_setOptions
     * @private
     * @param {Object} options The options to set
     */
    _setOptions: function _setOptions(options) {
      var that = this;
      var redraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          redraw = true;
        }
      });
      this._controlOptions();
      if (redraw === true) {
        this.myChart.destroy();
        this._draw();
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.BasicChart#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "width") {
        if (pValue !== this.options.width) {
          this._superApply(arguments);
          this._setDimentions();
        }
        return false;
      } else if (pKey === "height") {
        if (pValue !== this.options.height) {
          this._superApply(arguments);
          this._setDimentions();
        }
        return false;
      } else if (pKey === "type") {
        if (pValue !== this.options.type) {
          this._superApply(arguments);
          return true;
        }
        return false;
      } else if (pKey === "data") {
        if (Array.isArray(pValue)) {
          this._superApply(arguments);
          this._calcData();
          this._update();
        }
        return false;
      } else if (pKey === "legend") {
        if (_.isEqual(pValue !== this.options.legend) === false) {
          this._superApply(arguments);
          this._update();
        }
        return false;
      } else if (pKey === "undefinedGroupLabel") {
        if (pValue !== this.options.undefinedGroupLabel) {
          this._superApply(arguments);
          this._calcData();
          this._update();
        }
        return false;
      } else if (pKey === "keyUniqID") {
        if (pValue !== this.options.keyUniqID) {
          this._superApply(arguments);
          this._calcData();
          this._update();
        }
        return false;
      } else if (pKey === "showLabels") {
        if (pValue !== this.options.showLabels) {
          this._superApply(arguments);
          this._update();
        }
        return false;
      } else if (pKey === "stacked") {
        if (pValue !== this.options.stacked) {
          this._superApply(arguments);
          this._update();
        }
        return false;
      } else if (pKey === "XAxisTitle") {
        if (pValue !== this.options.XAxisTitle) {
          this._superApply(arguments);
          this._update();
        }
        return false;
      }
      return true;
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.BasicChart#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.type !== "string") {
        throw new Error("BasicChart input option type must be a string");
      }
      if (typeof this.options.undefinedGroupLabel !== "string") {
        throw new Error("BasicChart input option undefinedGroupLabel must be a string");
      }
      if (typeof this.options.keyUniqID !== "string" || this.options.keyUniqID.length <= 0) {
        throw new Error("BasicChart input option keyUniqID must be a not empty string");
      }
      if (typeof this.options.stacked !== "boolean") {
        throw new Error("stacked option must be a boolean");
      }
    },
    _destroy: function _destroy() {
      if (this.myChart !== null) {
        this.myChart.destroy();
      }
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],285:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 3-dec-2018 9:48:08
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var removeRegExp = /["]/;
  function checkAndClean(pString) {
    if (typeof pString === "string") {
      return pString.replace(removeRegExp, "");
    }
    return pString;
  }

  /**
   * @namespace nixps.CircularPercentageChart
   * @description Draw a circle with a percentage inside
   * @example $('<div>').CircularPercentageChart({
   *      value: 75
   * });
   * @version 1.0.0
   */
  $.widget("nixps.CircularPercentageChart", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "circularpercentagechart",
    options: {
      /**
       * @description The width of the chart
       * @name nixps.CircularPercentageChart#width
       * @type {Number}
       * @default 60
       */
      width: 60,
      /**
       * @description The height of the chart
       * @name nixps.CircularPercentageChart#height
       * @type {Number}
       * @default 60
       */
      height: 60,
      /**
       * @description The color of the half circle indicating the percentage. This must be a valid color CSS string 
       * @name nixps.CircularPercentageChart#color
       * @type {String}
       * @default #0080BF
       * @example "red"
       * @example "orange"
       */
      color: "#0080bf",
      /**
       * @description The color of the complete background circle.
       * @name nixps.CircularPercentageChart#colorOutlineCircle
       * @type {String}
       * @default #eee
       */
      colorOutlineCircle: "#eee",
      /**
       * @description The width in px of the indicating circel, the width of the colored line
       * @name nixps.CircularPercentageChart#circelWidth
       * @type {Number}
       * @default 2.8
       */
      circelWidth: 2.8,
      /**
       * @description The max value to calculate the percentage of the current value
       * @name nixps.CircularPercentageChart#maxValue
       * @type {Number}
       * @default 100
       */
      maxValue: 100,
      /**
       * @description the Starting point defined in degrees
       * @name nixps.CircularPercentageChart#startDegrees
       * @type {Number}
       * @default 0
       */
      startDegrees: 0,
      /**
       * @description The value to indicate
       * @name nixps.CircularPercentageChart#value
       * @type {Number}
       * @default ""
       */
      value: "",
      /**
       * @description Must we show as persentage or just like a number. Possible values "percentage", "number"
       * @name nixps.CircularPercentageChart#kind
       * @type {String}
       * @default "percentage"
       */
      kind: "percentage",
      /**
       * @description function runws when the component is done rendering
       * @name nixps-CircularPercentageChart#created
       * @private
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.CircularPercentageChart#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._draw();
      this.options.created();
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.CircularPercentageChart#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    _calcData: function _calcData() {
      // calc percentage
      var percentage = parseFloat(this.options.value) / this.options.maxValue * 100;
      if (percentage === -Infinity) {
        percentage = 0;
        this.options.value = 0;
        console.warn("CircularPercentageChart: convert - Infinity to zero");
      } else if (percentage === Infinity) {
        percentage = 100;
        this.options.value = this.options.maxValue;
        console.warn("CircularPercentageChart: convert Infinity to maxValue");
      } else if (isNaN(percentage)) {
        percentage = "-";
        this.options.value = "-";
      } else {
        if (this.options.kind === "percentage" && Number.EPSILON !== undefined) {
          percentage = Math.round((percentage + Number.EPSILON) * 10) / 10;
        }
      }
      // make value to show
      var valueToShow = "";
      if (this.options.kind === "percentage") {
        valueToShow = percentage + "%";
      } else {
        valueToShow = "" + this.options.value;
      }
      return {
        percentage: percentage,
        valueToShow: valueToShow
      };
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.CircularPercentageChart#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var data = this._calcData();
      var html = '<svg viewBox="0 0 36 36" class="circularpercentagechart_container">' + '<path class="circularpercentagechart_outlinecircle" d="M18 2.0845' + 'a 15.9155 15.9155 0 0 1 0 31.831' + 'a 15.9155 15.9155 0 0 1 0 -31.831"' + 'fill="none"' + '/>' + '<path class="circularpercentagechart_circle"' + 'd="M18 2.0845' + 'a 15.9155 15.9155 0 0 1 0 31.831' + 'a 15.9155 15.9155 0 0 1 0 -31.831"' + 'fill="none"' + 'stroke-dasharray="' + data.percentage + ', 100"' + '/>' + '<text x="50%" y="21.35" text-anchor="middle" class="circularpercentagechart_text noselect">' + data.valueToShow + '</text>' + '</svg>';
      this.element.html(html);
      this._setStyle();
      this._setColors();
      this._setConfig();
    },
    /**
     * @description set the chart to a specific value
     * @function
     * @name nixps.CircularPercentageChart#setValue
     * @param {Numeric} pValue 
     * @returns {undefined}
     */
    setValue: function setValue(pValue) {
      this.options.value = pValue;
      var data = this._calcData();
      this.element.find(".circularpercentagechart_circle").attr("stroke-dasharray", data.percentage + ', 100');
      this.element.find("text").html(data.valueToShow);
    },
    /**
     * @description redraw the styling
     * @function
     * @name nixps.CircularPercentageChart#_setStyle
     * @private
     * @returns {undefined}
     */
    _setStyle: function _setStyle() {
      var attr = {
        width: "",
        height: ""
      };
      if (this.options.width !== undefined && this.options.width !== null) {
        attr.width = this.options.width;
      }
      if (this.options.height !== undefined && this.options.height !== null) {
        attr.height = this.options.height;
      }
      this.element.children(".circularpercentagechart_container").attr(attr);
      this.element.find(".circularpercentagechart_outlinecircle").attr("stroke-width", this.options.circelWidth + 1);
      this.element.find(".circularpercentagechart_circle").attr("stroke-width", this.options.circelWidth);
    },
    /**
     * @description change the colors
     * @function
     * @private
     * @name nixps.CircularPercentageChart#_setColors
     * @returns {undefined}
     */
    _setColors: function _setColors() {
      this.element.find(".circularpercentagechart_outlinecircle").attr("stroke", this.options.colorOutlineCircle);
      this.element.find(".circularpercentagechart_circle").attr("stroke", this.options.color);
    },
    /**
     * @description Change some configuration of the cicle
     * @function
     * @private
     * @name nixps.CircularPercentageChart#_setConfig
     * @returns {undefined}
     */
    _setConfig: function _setConfig() {
      var rotation = "";
      if (typeof this.options.startDegrees === "number" && this.options.startDegrees > 0) {
        rotation = "rotate(" + this.options.startDegrees + " 18 18)";
      }
      this.element.find(".circularpercentagechart_circle").attr("transform", rotation);
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.CircularPercentageChart#_setOptions
     */
    _setOptions: function _setOptions(options) {
      var redraw = false;
      var recolor = false;
      var reValue = false;
      var restyle = false;
      var reconfig = false;
      if (options.width !== undefined && this.options.width !== options.width || options.height !== undefined && this.options.height !== options.height || options.circelWidth !== undefined && this.options.circelWidth !== options.circelWidth) {
        restyle = true;
      }
      if (options.value !== undefined && this.options.value !== options.value) {
        reValue = true;
      }
      if (options.color !== undefined && this.options.color !== options.color || options.colorOutlineCircle !== undefined && this.options.colorOutlineCircle !== options.colorOutlineCircle) {
        recolor = true;
      }
      if (options.startDegrees !== undefined && this.options.startDegrees !== options.startDegrees) {
        reconfig = true;
      }
      if (options.kind !== undefined && this.options.kind !== options.kind) {
        redraw = true;
      }
      this._superApply(arguments);
      this._controlOptions();
      if (redraw) {
        this._draw();
      } else {
        if (reValue) {
          this.setValue(this.options.value);
        }
        if (restyle) {
          this._setStyle();
        }
        if (recolor) {
          this._setColors();
        }
        if (reconfig) {
          this._setConfig();
        }
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.CircularPercentageChart#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.maxValue !== "number" || this.options.maxValue <= 0) {
        throw new Error("CircularPercentageChart: input option maxValue must be a positive number");
      }
      if (this.options.maxValue < parseFloat(this.options.value)) {
        throw new Error("CircularPercentageChart: input option maxValue must be bigger then the currect value");
      }
      if (parseFloat(this.options.value) < 0) {
        throw new Error("CircularPercentageChart: input option value must be bigger then zero");
      }
      if (typeof this.options.circelWidth !== "number" || this.options.circelWidth <= 0) {
        throw new Error("CircularPercentageChart: input option circleWidth must be a positive number");
      }
      if (typeof this.options.kind !== "string" || this.options.kind.length <= 0) {
        throw new Error("CircularPercentageChart: input option kind must be a not empty string");
      }
      this.options.width = checkAndClean(this.options.width);
      this.options.height = checkAndClean(this.options.height);
      this.options.value = checkAndClean(this.options.value);
      this.options.color = checkAndClean(this.options.color);
      this.options.colorOutlineCircle = checkAndClean(this.options.colorOutlineCircle);
    },
    _destroy: function _destroy() {
      this._superApply();
      this.element.removeClass(this.widgetFullName);
    }
  });
})(jQuery);

},{}],286:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on Mar 27, 2017 5:40:51 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  // to prevent changing all input[type=color] in HTML-pages
  if ($.fn !== undefined && typeof $.fn.spectrum === "function") {
    $.fn.spectrum.load = false;
  }

  /**
   * @namespace nixps.Colorpicker
   * @description Draw a colorpicker. So the user can choose a specific color.
   * @example $("<div>").Colorpicker({});
   * @version 1.3.0
   */
  $.widget("nixps.Colorpicker", $.Widget, {
    version: "1.3.0",
    options: {
      /**
       * @name nixps.Colorpicker#context
       * @description The contect in which you are, to get simular selections of previous colors
       * @type {String}
       * @default false
       */
      context: false,
      /**
       * @name nixps.Colorpicker#showAlpha
       * @description Must we enable the possibility to choose translataranty degrees, do we allow alfa?
       * @type {Boolean}
       * @default false
       */
      showAlpha: false,
      /**
       * @name nixps.Colorpicker#showPaletteOnly
       * @description Must we start showing the pallet only? set to false if you want to show the right panel at the start
       * @type {Boolean}
       * @description true
       * @since 1.1.0
       */
      showPaletteOnly: true,
      /**
       * @name nixps.Colorpicker#togglePaletteOnly
       * @description Show the "show more" button, so view the more advanced sections
       * @type {Boolean}
       * @default true
       * @since 1.1.0
       */
      togglePaletteOnly: true,
      /**
       * @name nixps.Colorpicker#appendTo
       * @description To which element must we append, 
       * @default "body"
       * @type {jQuery}
       * @since 1.1.0
       */
      appendTo: "body",
      /**
       * @name nixps.Colorpicker#palette
       * @description The predefined colors in the pallete
       * @type {Array<Array<String>>}
       * @since 1.1.0
       */
      palette: [["#000", "#666", "#999", "#ccc", "#eee", "#f3f3f3", "#fff"], ["#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#D7D6EC"], ["#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#AFAFDB"], ["#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8687C9"], ["#d43d3d", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#0080BF", "#5E6BBE"], ["#900", "#b45f06", "#bf9000", "#38761d", "#2F6B78", "#276FB0", "#5756A9"]],
      /**
       * @name nixps.Colorpicker#zoomScale
       * @description The zoom factor
       * @type {Number}
       * @since 1.2.0
       */
      zoomScale: 1,
      /**
       * @name nixps.Colorpicker#native
       * @description Must we open the native, if possible
       * @type {Boolean}
       * @default false
       * @since 1.3.0
       */
      "native": false,
      /**
       * @name nixps.Colorpicker#usePaletteInNative
       * @description must we use the palette in native mode
       * @type {Boolean}
       * @default false
       * @since 1.3.0
       */
      usePaletteInNative: false
    },
    /**
     * @description Create the component
     * @name nixps.Colorpicker#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._draw();
      this._on(this.element, {
        "change": this._changeHandler
      });
    },
    _changeHandler: function _changeHandler(pEvent) {
      if (this.options["native"] === true) {
        // trigger custom change for the formbuilder (fieldmaker)
        this.element.trigger("fieldcustomchange");
      }
    },
    /**
     * @description function runs when user change a color
     * @function
     * @private
     * @name nixps.Colorpicker#_spectrumChangeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _spectrumChangeHandler: function _spectrumChangeHandler(pColor) {
      // trigger custom change for the formbuilder (fieldmaker)
      this.element.trigger("fieldcustomchange");
    },
    _showHandler: function _showHandler(pEvent, pData) {
      this._setZommOnContainer(this.options.zoomScale);
    },
    /**
     * @description function runs when user close dialog
     * @function
     * @private
     * @name nixps.Colorpicker#_hideHandler
     * @param {type} pColor
     * @returns {undefined}
     */
    _hideHandler: function _hideHandler(pColor) {
      this._trigger("hide", null, {});
    },
    /**
     * @description function runs when user moves with dialog
     * @function
     * @private
     * @name nixps.Colorpicker#_moveHandler
     * @param {type} pColor
     * @returns {undefined}
     */
    _moveHandler: function _moveHandler(pColor) {
      this.element.trigger("fieldcustomchange");
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.Colorpicker#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Sraws the dialog according to the current state
     * @function
     * @private
     * @name nixps.Colorpicker#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var input = $("<input>");
      this.element.empty().append(input);
      if (this.options["native"] === true) {
        input.attr("type", "color").prop("disabled", this.options.disabled === true);
        if (this.options.usePaletteInNative === true && Array.isArray(this.options.palette) && this.options.palette.length > 0) {
          var datalist = $("<datalist>").attr("id", "datalist_id" + this.uuid);
          for (var i = 0; i < this.options.palette.length; i++) {
            if (Array.isArray(this.options.palette[i])) {
              for (var j = 0; j < this.options.palette[i].length; j++) {
                datalist.append($("<option>").attr("value", this.options.palette[i][j]));
              }
            } else if (typeof this.options.palette[i] === "string") {
              datalist.append($("<option>").attr("value", this.options.palette[i]));
            }
          }
          this.element.append(datalist);
          input.attr("list", "datalist_id" + this.uuid);
        }
      } else {
        input.spectrum({
          // all events 
          change: this._spectrumChangeHandler.bind(this),
          show: this._showHandler.bind(this),
          hide: this._hideHandler.bind(this),
          move: this._moveHandler.bind(this),
          // options
          preferredFormat: "name",
          // fallback is hex
          showInput: true,
          color: null,
          // default no color
          appendTo: this.options.appendTo,
          allowEmpty: true,
          showAlpha: this.options.showAlpha,
          showPalette: true,
          localStorageKey: this.options.context,
          containerClassName: "colorpickerContainer" + this.uuid,
          chooseText: $.i18n._("nixps-colorpicker.ok"),
          cancelText: $.i18n._("nixps-colorpicker.cancel"),
          togglePaletteMoreText: $.i18n._("nixps-colorpicker.more"),
          togglePaletteLessText: $.i18n._("nixps-colorpicker.less"),
          clearText: $.i18n._("nixps-colorpicker.clear_color_selection"),
          noColorSelectedText: $.i18n._("nixps-colorpicker.no_color_selected"),
          showPaletteOnly: this.options.showPaletteOnly,
          togglePaletteOnly: this.options.togglePaletteOnly,
          palette: this.options.palette,
          disabled: this.options.disabled
        });
      }
    },
    /**
     * @description Get the current color value of the colorpicker
     * @function
     * @name nixps.Colorpicker#getValue
     * @param {string} Optional - form of output: "hex", "rgb", "hsv", "hsl", "name" - Default: "rgb"
     * @returns {string} the color of the picker, or null if no color is choosen
     */
    getValue: function getValue(form) {
      if (this.options["native"] === true) {
        var color = this.element.children("input").val();
        if (typeof tinycolor === "function") {
          switch (form) {
            case "rgb":
              return tinyColor(color).toRgbString();
            case "hsv":
              return tinyColor(color).toHsvString();
            case "hsl":
              return tinyColor(color).toHslString();
            case "name":
              return tinyColor(color).toName();
            default:
              return color;
          }
        }
        return color;
      }

      // get returns a tinyColor object, see https://github.com/bgrins/TinyColor
      var tinyColor = this.element.children("input").spectrum("get");
      if (tinyColor === null || tinyColor.length <= 0) {
        return null;
      } else {
        if (this.options.showAlpha === false) {
          switch (form) {
            case "rgb":
              return tinyColor.toRgbString();
            case "hsv":
              return tinyColor.toHsvString();
            case "hsl":
              return tinyColor.toHslString();
            case "name":
              return tinyColor.toName();
            default:
              return tinyColor.toHexString();
          }
        }
        switch (form) {
          case "hex":
            return tinyColor.toHexString();
          case "hsv":
            return tinyColor.toHsvString();
          case "hsl":
            return tinyColor.toHslString();
          case "name":
            return tinyColor.toName();
          default:
            return tinyColor.toRgbString();
        }
      }
    },
    /**
     * @description set the colorpicker to a specific color
     * @function
     * @name nixps.Colorpicker#setValue
     * @param {string} pValue the color to set to the picker
     * @returns {undefined}
     */
    setValue: function setValue(pValue) {
      if (this.options["native"] === true) {
        if (pValue === null) {
          this.element.children("input").val("#000000");
        } else {
          this.element.children("input").val(pValue);
        }
      } else {
        if (pValue === null) {
          // set to null, no color
          this.element.children("input").spectrum("set", null);
        } else {
          // set to a specific color
          if (typeof pValue !== "string" || pValue.length <= 0) {
            throw new Error("parameter pValue must be a string");
          }
          this.element.children("input").spectrum("set", pValue);
        }
      }
    },
    reset: function reset() {
      this.setValue(null);
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.Colorpicker#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "disabled") {
        if (this.options["native"] === true) {
          this.element.children("input").prop("disabled", pValue);
        } else {
          if (pValue === true) {
            this.element.children("input").spectrum("disable");
          } else if (pValue === false) {
            this.element.children("input").spectrum("enable");
          }
        }
        return;
      }
      this._draw();
    },
    /**
     * @description rest the container to a better possition, depending to the zoom scaling
     * @name nixps.Colorpicker#_setZommOnContainer
     * @function
     * @param {Number} pZoomingFactor 
     */
    _setZommOnContainer: function _setZommOnContainer(pZoomingFactor) {
      if (typeof pZoomingFactor === "number") {
        // specific to spectrum
        var container = $(this.options.appendTo).find(".colorpickerContainer" + this.uuid);
        if (!container.attr("data-zoomscaled")) {
          container.css("top", parseFloat(container.css("top")) / pZoomingFactor);
          container.css("left", parseFloat(container.css("left")) / pZoomingFactor);
          container.attr("data-zoomscaled", pZoomingFactor);
        }
      }
    },
    /**
     * @description Shows the colorpicker.
     * @name nixps.Colorpicker#show
     * @function
     */
    show: function show() {
      if (this.options["native"] === true) {
        this.element.children("input").trigger("click");
      } else {
        this.element.children("input").spectrum("show");
      }
    },
    /**
     * @description Hides the colorpicker.
     * @name nixps.Colorpicker#hide
     * @function
    */
    hide: function hide() {
      if (this.options["native"] === true) {} else {
        this.element.children("input").spectrum("hide");
      }
    },
    /**
     * @description Toggles the colorpicker.
     * @name nixps.Colorpicker#toggle
     * @function
    */
    toggle: function toggle() {
      if (this.options["native"] === true) {} else {
        this.element.children("input").spectrum("toggle");
      }
    },
    /**
     * @description Resets the positioning of the container element. This could be used was hidden when initialized, or if the colorpicker is inside of a moving area.
     * @name nixps.Colorpicker#reflow
     * @function
    */
    reflow: function reflow() {
      if (this.options["native"] === true) {} else {
        this.element.children("input").spectrum("reflow");
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.Colorpicker#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.showAlpha !== "boolean") {
        throw new Error("ColorPicker: input option showAlpha must be a boolean");
      }
      if (typeof this.options["native"] !== "boolean") {
        throw new Error("ColorPicker: input option native must be a boolean");
      }
      if (this.options["native"] === true) {
        if (this.options.showAlpha === true) {
          throw new Error("ColorPicker: it is not possible to use alfa in native mode");
        }
      } else {
        if (typeof $.fn.spectrum !== "function") {
          throw new Error("spectrum plugin is required");
        }
        if (this.element.parents("body").length === 0) {
          console.error("The component must be append to the body before creation");
        }
      }
      if (this.options.context !== false && typeof this.options.context !== "string" || this.options.context.length <= 0) {
        throw new Error("input option context must be false or a not empty string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      // little bug in spectrum, if component is removed this stays, so we need to remove manualy
      $(this.options.appendTo).find(".colorpickerContainer" + this.uuid).remove();
      // clear all empty useless storages
      if (typeof this.options.context === "string" && this.options.context.length > 0 && window.localStorage !== undefined) {
        if (window.localStorage.getItem(this.options.context) === "") {
          window.localStorage.removeItem(this.options.context);
        }
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],287:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 *
 *   created by guillaume on Dec 1, 2016 4:06:11 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @description escape only the , and > so if an esacpe happens before it does not interfeare
   * @function
   * @private
   * @param {String} pString 
   * @returns {String}
   */
  function escape(pString) {
    if (typeof pString === "string") {
      return pString.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    return pString;
  }

  /**
   * @namespace nixps.Dialog
   * @description Draw an action dialog. This is a custom compont replacing the alert(), confirm(), prompt().
   * Call it just one time (during creating), afterwards you can call it serval times with the function "show_yes_no" or "showDialog".
   * The dialogs will be show up in order of calling.
   * @example $("body").Dialog();
   * $("body").Dialog("show_yes_no", "warning", "Are you agree?", "", function() { alert("yes");}, function(){ alert("no"); });
   *
   */
  $.widget("nixps.Dialog", $.Widget, {
    widgetEventPrefix: "dialog",
    options: {
      /**
       * @description The CSS property of the next drawing dialog. Use null for centering
       * @name nixps.Dialog#top
       * @type {String|CSS}
       * @default "25%"
       */
      top: "25%",
      /**
       * @description The z-index of the dialog mask
       * @name nixps.Dialog#zIndex
       * @type {Number}
       * @default null
       */
      zIndex: null,
      /**
       * @description The options to be given to the fadeOut jQuery function. To be used during js automation tests
       * @name nixps.Dialog#closeAnimationOptions
       * @type {Mixed}
       * @default 300
       * @private
       */
      closeAnimationOptions: 300
    },
    /**
     * @description Set to true to prevent close of the Dialog.
     * @private
     * @name nixps.Dialog#_trapClose
     * @type {Boolean}
     */
    _trapClose: false,
    /**
     * @description create the component
     * @name nixps.Dialog#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._trapClose = false;
      this.element.addClass(this.widgetFullName);
      this.mMask = $("<div>").addClass("dialog_mask");
      this.element.append(this.mMask);
      this.zIndex = null;
      this._draw();
      this._on(this.element, {
        "click .dialog_decision_button:not([disabled])": this._decisionHandler,
        "keydown": this._keyDownDecisionHandler,
        "input input": this._clearMessages,
        "uploadremove .fileUploader": this._removeFileEntry
      });
    },
    /**
     * @description Function runs when user click on a button, that should be given a desicion to the question.
     * This should be the last function running. So close the dialog here.
     * @function
     * @name nixps.Dialog#_decisionHandler
     * @private
     * @param {{target}} pEvent
     * @returns {undefined}
     */
    _decisionHandler: function _decisionHandler(pEvent) {
      var type = $(pEvent.target).closest("[data-decision]").attr("data-decision");
      this._trigger("decided", null, {
        type: type
      });
      if (this._trapClose === false) {
        if (this.element.find(".nixps_dialog").length === 1) {
          // hide background, if it is the last
          this.mMask.fadeOut(this.options.closeAnimationOptions);
        }
        // remove dialog completely
        // .fadeOut function fails when ran in unitTest, the call back is never called. Even when 'closeAnimationOptions' is set 
        // to 0, the callback isnt called. 
        // Workaround : if no animation is requeted via 'closeAnimationOptions=0' or 'jQuery.fx.off=true', like it is in unit tests,
        // use a settimeout with 0 as delay, it will provide the same effect. 
        if (this.options.closeAnimationOptions === 0 || jQuery.fx.off === true) {
          setTimeout(function () {
            $(pEvent.target).parents(".nixps_dialog").find("button[data-timerid]").each(function () {
              clearTimeout(parseInt($(this).attr("data-timerid")));
            });
            $(pEvent.target).parents(".nixps_dialog").remove();
          }, 0);
        } else {
          $(pEvent.target).parents(".nixps_dialog").find("button[data-timerid]").each(function () {
            clearTimeout(parseInt($(this).attr("data-timerid")));
          });
          $(pEvent.target).parents(".nixps_dialog").fadeOut(this.options.closeAnimationOptions, function () {
            $(this).remove();
          });
        }
      }
    },
    /**
     * @description function runs when user press the keypress on a button that has the focus
     * @function
     * @private
     * @name nixps.Dialog#_keyDownDecisionHandler
     * @param {{keyCode, target, originalEvent, preventDefault, stopPropagation}} pEvent
    * @listens event
     * @return {undefined}
     */
    _keyDownDecisionHandler: function _keyDownDecisionHandler(pEvent) {
      if (pEvent.keyCode === $.ui.keyCode.ESCAPE) {
        this.element.find('.dialog_decision_button:not([disabled])[data-decision="cancel"], .dialog_decision_button:not([disabled])[data-decision="no"]').trigger("click");
      } else if (pEvent.keyCode === $.ui.keyCode.TAB) {
        if (pEvent.target.hasAttribute("tabindex")) {
          var direction = pEvent.originalEvent.shiftKey ? -1 : 1;
          var tab = $(pEvent.target).prop("tabindex") + direction;
          var next = this.element.find('.nixps_dialog [tabindex="' + tab + '"]:not([disabled])');
          for (var ti = pEvent.originalEvent.shiftKey ? 5 : 1; ti > 0 && next.length === 0; ti--) {
            next = this.element.find('.nixps_dialog [tabindex=' + ti + ']:not([disabled])');
          }
          if (next.length !== 0) {
            pEvent.preventDefault();
            pEvent.stopPropagation();
            setTimeout(function () {
              next.focus();
            }, 250);
          }
        } else {
          next = this.element.find(".nixps_dialog [tabindex=1]:not([disabled])");
          if (next.length !== 0) {
            pEvent.preventDefault();
            pEvent.stopPropagation();
            setTimeout(function () {
              next.focus();
            }, 250);
          }
        }
      }
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps.Dialog#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.Dialog#_draw
     * @return {undefined}
     */
    _draw: function _draw() {
      if (this.options.zIndex === "auto") {
        var calcZIndex = this._calcZIndex() + 1;
        if (!(typeof this.zIndex === "number" && this.zIndex >= calcZIndex)) {
          this.zIndex = calcZIndex;
          this.mMask.css("z-index", this.zIndex);
        }
      } else if (typeof this.options.zIndex === "number" && this.options.zIndex > 0) {
        this.zIndex = this.options.zIndex;
        this.mMask.css("z-index", this.options.zIndex);
      } else {
        this.zIndex = null;
        this.mMask.css("z-index", "");
      }
    },
    /**
     * @description Show the dialog and calc the correct position
     * @function
     * @name nixps.Dialog#_show
     * @private
     * @param {jQuery} pDialog the dialog to be shown and position
     * @param {function} pDialogDoneCallback
     * @returns {undefined}
     */
    _show: function _show(pDialog, pDialogDoneCallback) {
      this._trigger("beforeshow", null, {});
      // transition effect
      this.mMask.fadeIn(300);

      // Get the window height and width
      var winH = $(window).height();
      var winW = $(window).width();
      var top;
      if (typeof this.options.top === "string" && this.options.top.length > 0) {
        top = this.options.top;
      } else {
        top = winH / 2 - pDialog.height() / 2;
      }
      //Set the popup window to center
      pDialog.css({
        "top": top,
        "left": winW / 2 - pDialog.outerWidth() / 2
      }).fadeIn(300, pDialogDoneCallback);
    },
    /**
     * @description fucntion runs a prompt, ask for some input to the user and returns the ansers
     * @function
     * @name nixps.Dialog#prompt
     * @param {String} pTitle The title of the dialog
     * @param {String} pQuestion The text above the input field
     * @param {String} pDefaultText the text to put in the input field on creation
     * @param {Boolean} pSelectDefaultText put on true to select the inputfield on creations
     * @param {Function} pApprovalFct
    * @param {String} pOptionalUI html string of the options to append to the Dialog
     * @returns {undefined}
     */
    prompt: function prompt(pTitle, pQuestion, pDefaultText, pSelectDefaultText, pApprovalFct, pOptionalUI, pButtonArrays) {
      // control input parameters
      if (typeof pQuestion !== "string") {
        throw new Error("parameter pQuestion must be a string");
      }
      if (typeof pDefaultText !== "string") {
        throw new Error("parameter pDefaultText must be a string");
      }
      var that = this;
      return $.Deferred(function (pDefer) {
        var dialog = $("<div>").addClass("nixps_dialog dialog_singelDialog cf-confirmationdialog cf_styling_type_dialog").attr("role", "alertdialog").css("z-index", function () {
          if (typeof that.zIndex === "number" && that.zIndex > 0) {
            return that.zIndex + 99;
          }
          return "";
        });
        // Create the question
        var panel = $("<div>").addClass("dialog_panel dialog_prompt").append($("<div>").addClass("errorMessage alert alert-warning cf-message-error").append($("<span>")).hide()).append($("<div>").addClass("cf-confirmationdialog-content").text(pQuestion)).appendTo(dialog);
        if (typeof pTitle === "string") {
          panel.prepend($("<h3>").addClass("cf-confirmationdialog-header cf-title-h3").text(pTitle));
        } else if (pTitle instanceof jQuery) {
          panel.prepend(pTitle.addClass("cf-title-h3"));
        }
        if (pDefaultText !== "_noName_") {
          panel.append($("<input>").addClass("anserInput dialogInputField").attr("type", "text").attr("autocorrect", "off").attr("spellcheck", "false").attr("tabindex", "1").val(pDefaultText)).on("keyup", function (pEvent) {
            that.element.find(".dialog_error").html("");
            if (pEvent.keyCode === $.ui.keyCode.ENTER) {
              // Enter
              okButton.trigger("click");
            }
          });
        }
        if (pOptionalUI !== undefined) {
          if (typeof pOptionalUI === "string") {
            panel.append($("<div>").addClass("_optional_prompt_").append(pOptionalUI));
          } else if (pOptionalUI instanceof jQuery) {
            panel.append(pOptionalUI);
          }
        }

        // add buttons
        var buttonsBar = $("<div>").addClass("dialog_buttonsBar cf-buttonbar cf-buttonbar-nopadding").appendTo(dialog);
        if (Array.isArray(pButtonArrays) && pButtonArrays.length > 0) {
          for (var i = 0; i < pButtonArrays.length; i++) {
            $("<button>").attr("type", "button").addClass("cf-button dialog_decision_button").addClass(pButtonArrays[i].classes).attr("data-decision", pButtonArrays[i].type).attr("tabindex", i + 2) // count from 0, add input eq +2
            ._t(pButtonArrays[i].label).appendTo(buttonsBar);
          }
        } else {
          $("<button>").addClass("cf-button cf-button-secondary dialog_button dialog_decision_button").addClass("dialog_cancel_button").attr("data-decision", "cancel").attr("type", "button").attr("tabindex", "2").text($.i18n._("nixps-cloudflow-dialog.cancel")).appendTo(buttonsBar);
          var okButton = $("<button>").addClass("cf-button cf-button-main dialog_button dialog_decision_button").addClass("dialog_yes_button").attr("data-decision", "ok").attr("type", "button").attr("tabindex", "3").text($.i18n._("nixps-cloudflow-dialog.ok")).appendTo(buttonsBar);
        }
        dialog.find(".dialog_decision_button").on("click keydown", function (pEvent) {
          if (pEvent.type === "keydown" && !(pEvent.keyCode === $.ui.keyCode.ENTER || pEvent.keyCode === $.ui.keyCode.SPACE)) {
            return true;
          }
          that._trapClose = undefined;
          $(pEvent.target).attr("disabled", "disabled");
          var type = $(pEvent.target).closest("[data-decision]").attr("data-decision");
          if (type.indexOf("ok") === 0) {
            // also accept other custom types like ok_append, ok_insert, ...
            var pResult = {
              type: type,
              oldValue: pDefaultText,
              newValue: $(pEvent.target).parents(".nixps_dialog").find("input").val()
            };
            panel.find("._optional_prompt_ select, ._optional_prompt_ input, ._optional_prompt_ textarea").each(function (index, ui) {
              var name = $(ui).attr("name");
              if (name === undefined) {
                name = $(ui).attr("id");
              } else {
                if ($(this).is("[type=checkbox]")) {
                  pResult[name] = $(this).is(":checked");
                } else {
                  pResult[name] = $(ui).val();
                }
              }
            });
            if (typeof pApprovalFct === "function") {
              $.when(pApprovalFct(pResult)).then(function (approval) {
                that._trapClose = !approval.approved;
                if (!approval.approved) {
                  that.showMessage(approval, ".errorMessage");
                  $(pEvent.target).removeAttr("disabled");
                  dialog.find("input").first().focus();
                } else {
                  pDefer.resolve(pResult);
                  that._decisionHandler(pEvent);
                }
              }).fail(function (pError) {
                that._trapClose = true;
                that.showMessage(pError, ".errorMessage");
                $(pEvent.target).removeAttr("disabled");
                pDefer.reject(pError);
              });
            } else {
              that._trapClose = false;
              pDefer.resolve(pResult); // Ok
              that._decisionHandler(pEvent);
            }
          } else {
            that._trapClose = false;
            pDefer.resolve({
              type: type
            }); // Cancel
            that._decisionHandler(pEvent);
          }
        });
        that.element.prepend(dialog);
        that._show(dialog, function () {
          if (pSelectDefaultText === true) {
            dialog.find("input.dialogInputField").trigger("focus").trigger("select");
          }
        });
      });
    },
    prompt_message: function prompt_message(pTitle, pQuestion, pDefaultText, pSelectDefaultText, pButtonArrays) {
      var that = this;
      // control input parameters
      if (typeof pQuestion !== "string") {
        throw new Error("parameter pQuestion must be a string");
      }
      if (typeof pDefaultText !== "string") {
        throw new Error("parameter pDefaultText must be a string");
      }
      return $.Deferred(function (pDefer) {
        var dialog = $("<div>").addClass("nixps_dialog dialog_singelDialog cf-confirmationdialog cf_styling_type_dialog").attr("role", "alertdialog").css("z-index", function () {
          if (typeof that.zIndex === "number" && that.zIndex > 0) {
            return that.zIndex + 99;
          }
          return "";
        });
        // Create the question
        var panel = $("<div>").addClass("dialog_panel dialog_prompt").append($("<div>").addClass("errorMessage alert alert-warning cf-message-error").append($("<span>")).hide()).append($("<div>").addClass("cf-confirmationdialog-content").text(pQuestion)).appendTo(dialog);
        if (typeof pTitle === "string") {
          panel.prepend($("<h3>").addClass("cf-confirmationdialog-header cf-title-h3").text(pTitle));
        } else if (pTitle instanceof jQuery) {
          panel.prepend(pTitle.addClass("cf-title-h3"));
        }
        if (pDefaultText !== "_noName_") {
          panel.append($("<textarea>").addClass("anserInput dialogInputField").attr("type", "text").attr("autocorrect", "off").attr("spellcheck", "false").attr("tabindex", "1").val(pDefaultText));
        }

        // add buttons
        var buttonsBar = $("<div>").addClass("dialog_buttonsBar cf-buttonbar cf-buttonbar-nopadding").appendTo(dialog);
        if (Array.isArray(pButtonArrays) && pButtonArrays.length > 0) {
          for (var i = 0; i < pButtonArrays.length; i++) {
            $("<button>").attr("type", "button").addClass("cf-button dialog_decision_button").addClass(pButtonArrays[i].classes).attr("data-decision", pButtonArrays[i].type).attr("tabindex", i + 2) // count from 0, add input eq +2
            ._t(pButtonArrays[i].label).appendTo(buttonsBar);
          }
        } else {
          $("<button>").addClass("cf-button cf-button-secondary dialog_button dialog_decision_button").addClass("dialog_cancel_button").attr("data-decision", "cancel").attr("type", "button").attr("tabindex", "2").text($.i18n._("nixps-cloudflow-dialog.cancel")).appendTo(buttonsBar);
          $("<button>").addClass("cf-button cf-button-main dialog_button dialog_decision_button").addClass("dialog_yes_button").attr("data-decision", "ok").attr("type", "button").attr("tabindex", "3").text($.i18n._("nixps-cloudflow-dialog.ok")).appendTo(buttonsBar);
        }
        dialog.find(".dialog_decision_button").on("click keydown", function (pEvent) {
          if (pEvent.type === "keydown" && !(pEvent.keyCode === $.ui.keyCode.ENTER || pEvent.keyCode === $.ui.keyCode.SPACE)) {
            return true;
          }
          that._trapClose = undefined;
          $(pEvent.target).attr("disabled", "disabled");
          var type = $(pEvent.target).closest("[data-decision]").attr("data-decision");
          if (type === "ok") {
            var pResult = {
              type: type,
              oldValue: pDefaultText,
              newValue: $(pEvent.target).parents(".nixps_dialog").find("textarea").val()
            };
            panel.find("._optional_prompt_ select, ._optional_prompt_ input, ._optional_prompt_ textarea").each(function (index, ui) {
              var name = $(ui).attr("name");
              if (name === undefined) {
                name = $(ui).attr("id");
              } else {
                if ($(this).is("[type=checkbox]")) {
                  pResult[name] = $(this).is(":checked");
                } else {
                  pResult[name] = $(ui).val();
                }
              }
            });
            that._trapClose = false;
            pDefer.resolve(pResult); // Ok
            that._decisionHandler(pEvent);
          } else {
            that._trapClose = false;
            pDefer.resolve({
              type: type
            }); // Cancel
            that._decisionHandler(pEvent);
          }
        });
        that.element.prepend(dialog);
        that._show(dialog, function () {
          if (pSelectDefaultText === true) {
            dialog.find("input.dialogInputField").trigger("focus").trigger("select");
          }
        });
      });
    },
    /**
     * @description Show a dialog with yes and no buttons
     * @function
     * @name nixps.Dialog#show_yes_no
     * @param {String} pTitle The title of the dialog
     * @param {String} pSubTitle The message to show to the user
     * @param {Object} pOptions (optional) Options
     * @param {Function} pYesCallback Function called when user click on the yes button
     * @param {Function} pNoCallback Function to be called on the no button
     * @example $("body").Dialog("show_yes_no", "warning", "Are you agree", {}, function(){ console.log("pressed yes");}, function(){ console.log("pressed no");})
     * @returns {Deferred} The deferred function to be solved when user click on a button
     */
    show_yes_no: function show_yes_no(pTitle, pSubTitle, pOptions, pYesCallback, pNoCallback) {
      return this.showDialog(pTitle, pSubTitle, pOptions, [{
        classes: "dialog_no_button cf-button-secondary",
        type: "no",
        label: "nixps-cloudflow-dialog.no",
        cbFunction: pNoCallback
      }, {
        classes: "dialog_yes_button cf-button-main",
        type: "yes",
        label: "nixps-cloudflow-dialog.yes",
        cbFunction: pYesCallback
      }]);
    },
    /**
     * @description Show like an alert to the user he or she can only accept
     * @function
     * @name nixps.Dialog#show_ok
     * @param {String} pTitle
     * @param {String} pSubTitle
     * @param {Function} pOkFunction
     * @returns {Deferred}
     */
    show_ok: function show_ok(pTitle, pSubTitle, pOkFunction) {
      return this.showDialog(pTitle, escape(pSubTitle), {}, [{
        classes: "dialog_no_button cf-button-secondary",
        type: "ok",
        label: "nixps-cloudflow-dialog.ok",
        cbFunction: pOkFunction
      }]);
    },
    /**
     * @description Show a dialog with no and delete buttons
     * @function
     * @name nixps.Dialog#show_delete_no
     * @param {String} pTitle The title of the dialog
     * @param {String} pSubTitle The message to show to the user
     * @param {Function} pDeleteCallBack Function called when user click on the yes button
     * @param {Function} pNoCallBack Function to be called on the no button
     * @example $("body").Dialog("show_yes_no", "warning", "Are you agree", {}, function(){ console.log("pressed yes");}, function(){ console.log("pressed no");})
     * @returns {Deferred} The deferred function to be solved when user click on a button
     */
    show_delete_no: function show_delete_no(pTitle, pSubTitle, pDeleteCallBack, pNoCallBack) {
      return this.showDialog(pTitle, escape(pSubTitle), {}, [{
        classes: "dialog_no_button cf-button-secondary",
        type: "no",
        label: "nixps-cloudflow-dialog.no",
        cbFunction: pNoCallBack
      }, {
        classes: "dialog_yes_button cf-button-error",
        type: "delete",
        label: "nixps-cloudflow-dialog.delete",
        cbFunction: pDeleteCallBack
      }]);
    },
    /**
     * @description Build and show a dialog.
     * @function
     * @name nixps.Dialog#showDialog
     * @param {String} pTitle The title of the dialog
     * @param {String} pSubTitle The message to show
     * @param {Object} pOptions
     * @param {Array} pButtons The buttons object to show the buttons
     * @param {Number} pButtonIndexFocus index starting from zero, which button should recieve the focus
     * @example $("body").Dialog("showDialog", "warning", "Do you agree", {},
     *  [{
                classes: "dialog_no_button",
                type: "no",
                label: "nixps-cloudflow-dialog.no",
                cbFunction: function(){ console.log("pressed yes");}
            }, {
                classes: "dialog_yes_button",
                type: "yes",
                label: "nixps-cloudflow-dialog.yes",
                cbFunction: function(){ console.log("pressed no");}
            }]});
     * @returns {Deferred}
     */
    showDialog: function showDialog(pTitle, pSubTitle, pOptions, pButtons, pButtonIndexFocus) {
      if (!Array.isArray(pButtons)) {
        throw new Error("input parameter pButtons must be array");
      }
      var that = this;
      var resolvingType = null;
      return $.Deferred(function (pDefer) {
        var dialog = that._buildDialog(pTitle, pSubTitle, pOptions, pButtons);
        dialog.find(".dialog_decision_button").on("click", function (pEvent) {
          if (resolvingType === null) {
            var type = $(pEvent.target).closest("[data-decision]").attr("data-decision");
            resolvingType = type;
            pDefer.resolve({
              type: type
            });
          }
        });
        that._show(dialog, function () {});
        if (pButtonIndexFocus === undefined) {
          pButtonIndexFocus = 0;
        }
        if (typeof pButtonIndexFocus === "number" && pButtonIndexFocus >= 0 && pButtons[pButtonIndexFocus].type !== undefined) {
          dialog.find('.dialog_decision_button:not([disabled])[data-decision="' + pButtons[pButtonIndexFocus].type + '"]').trigger("focus");
        }
      });
    },
    /**
     * @description Internal function to create a dialog
     * @function
     * @name nixps.Dialog#_buildDialog
     * @private
     * @param {String} pTitle - The title to be show
     * @param {String | jQuery} pMessage -  the message, question to show to the user
     * @param {Object} pOptions
     * @param {array} pButtonArrays -  array of buttons model obejct containing information on how we must build a button
     * @returns {HTMLElement} The created dialog html
     */
    _buildDialog: function _buildDialog(pTitle, pMessage, pOptions, pButtonArrays) {
      var that = this;
      var enterKeyDownHappen = null;
      var dialog = $("<div>").addClass("nixps_dialog dialog_singelDialog cf-confirmationdialog").attr("role", "alertdialog").css("z-index", function () {
        if (typeof that.zIndex === "number" && that.zIndex > 0) {
          return that.zIndex + 99;
        }
        return "";
      });
      // CREATE THE CONFIRMATION
      var panel = $("<div>").addClass("dialog_panel");
      dialog.append(panel);
      panel.append($("<h3>").addClass("cf-confirmationdialog-header cf-title-h3").append(escape(pTitle)));
      panel.append($("<div>").addClass("cf-confirmationdialog-content").append(pMessage));
      var buttonsBar = $("<div>").addClass("dialog_buttonsBar cf-buttonbar cf-buttonbar-nopadding").appendTo(dialog);
      for (var i = 0; i < pButtonArrays.length; i++) {
        var button = $("<button>").attr("type", "button").addClass("green-button dialog_button dialog_decision_button cf-button").addClass(pButtonArrays[i].classes).attr("data-decision", pButtonArrays[i].type).attr("tabindex", "" + (i + 1)).on("keydown", function (pEvent) {
          // mark that there was a key down during creation
          enterKeyDownHappen = pEvent.keyCode === $.ui.keyCode.ENTER || pEvent.keyCode === $.ui.keyCode.SPACE;
        }).on("keyup", function (pEvent) {
          // only call trigger if there was a keydown and keyup
          // to prevent that the keyup from creation of dialog would immidialtly call this trigger
          if (enterKeyDownHappen === true && pEvent.keyCode === $.ui.keyCode.ENTER || pEvent.keyCode === $.ui.keyCode.SPACE) {
            // Enter or Space
            $(pEvent.target).trigger("click");
          }
          enterKeyDownHappen = false;
        })._t(pButtonArrays[i].label);
        if (pButtonArrays[i].disabled === true) {
          button.prop("disabled", true);
        }
        if (typeof pButtonArrays[i].cbFunction === "function") {
          (function (pVariable, cbFunc, pPanel) {
            button.one("click", function (pEvent) {
              cbFunc(pVariable, pPanel);
            });
          })(pOptions, pButtonArrays[i].cbFunction, panel);
        }
        if (typeof pButtonArrays[i].activationDelay === "number" && pButtonArrays[i].disabled !== true) {
          button.prop("disabled", true);
          var id = setTimeout(function (pButton) {
            pButton.prop("disabled", false);
          }, pButtonArrays[i].activationDelay, button);
          button.attr("data-timerid", id);
        }
        buttonsBar.append(button);
        if (typeof pButtonArrays[i].onCreate === "function") {
          // to pass reference of button, so parent can re-enable button
          pButtonArrays[i].onCreate(button, pButtonArrays[i]);
        }
      }
      if (typeof pOptions === "string") {
        dialog.data("variable", pOptions);
      }
      this.element.prepend(dialog);
      return dialog;
    },
    _calcZIndex: function _calcZIndex() {
      var zIndexes = this.mMask.siblings(":visible").map(function () {
        return +$(this).css("z-index");
      }).get().filter(function (e) {
        return !isNaN(e);
      });
      return Math.max.apply(null, zIndexes);
    },
    /**
     * @deprecated create your own component
     * @description create own
     * @name nixps.Dialog#custom
     */
    custom: function custom(pTitle, pSubTitle, pCaller, pCustomUIFct, pApprovalFct, pOptionalCSS, pButtonsBar) {
      var that = this;
      return $.Deferred(function (pDefer) {
        var dialog = $("<div>").addClass("nixps_dialog dialog_singelDialog cf-confirmationdialog").css("z-index", function () {
          if (typeof that.zIndex === "number" && that.zIndex > 0) {
            return that.zIndex + 99;
          }
          return "";
        });
        if (pOptionalCSS !== undefined && _typeof(pOptionalCSS) === "object") {
          dialog.css(pOptionalCSS);
        }
        // Create the question
        var panel = $('<div class=\'dialog_panel dialog_prompt\'>');
        dialog.append(panel);
        if (typeof pTitle === "string") {
          panel.append('<div class=\'cf-confirmationdialog-header cf-title-h3 cf_styling_type_dialog_header\'>' + pTitle + '</div>');
        } else if (pTitle instanceof jQuery) {
          panel.append(pTitle.addClass("cf_styling_type_dialog_header"));
        }
        panel.append('<div class=\'cf-confirmationdialog-content\'>' + pSubTitle + '</div>');
        if (pCaller && _typeof(pCaller) === 'object' && typeof pCaller.constructor === 'function' && typeof pCustomUIFct === 'function') {
          pCustomUIFct.call(pCaller, panel);
        }

        // add buttons
        if (pButtonsBar === undefined) {
          pButtonsBar = $('<div>').addClass('dialog_buttonsBar cf-buttonbar cf-buttonbar-nopadding');
          var cancelButton = $('<a>').addClass('cf-button cf-button-secondary dialog_button dialog_decision_button').addClass('dialog_cancel_button').attr('data-decision', 'cancel').attr('tabindex', '3')._t('nixps-cloudflow-dialog.cancel').appendTo(pButtonsBar);
          var okButton = $('<a>').addClass('cf-button cf-button-main dialog_button dialog_decision_button').addClass('dialog_yes_button').attr('data-decision', 'ok').attr('tabindex', '2')._t('nixps-cloudflow-dialog.ok').appendTo(pButtonsBar);
        }
        pButtonsBar.appendTo(dialog);
        dialog.append($('<div>').addClass('errorMessage alert alert-warning').append($('<span>')).hide());
        dialog.find('.dialog_decision_button').on('click keydown', function (pEvent) {
          if (pEvent.type === 'keydown' && !(pEvent.keyCode === $.ui.keyCode.ENTER || pEvent.keyCode === $.ui.keyCode.SPACE)) {
            return true;
          }
          that._trapClose = undefined;
          $(pEvent.target).attr('disabled', 'disabled');
          var type = $(pEvent.target).closest('[data-decision]').attr('data-decision');
          if (type === 'ok') {
            $.when(pApprovalFct(panel)).then(function (approval) {
              that._trapClose = approval !== undefined && approval.approved ? false : true;
              if (that._trapClose) {
                if (approval !== undefined) {
                  that.showMessage(approval, '.errorMessage');
                }
                $(pEvent.target).removeAttr('disabled');
                $(that.element.find('input')[0]).focus();
              } else {
                pDefer.resolve({
                  type: type
                });
                that._decisionHandler(pEvent);
              }
            }).fail(function (pError) {
              that._trapClose = true;
              that.showMessage(pError, '.errorMessage');
              $(pEvent.target).removeAttr('disabled');
              pDefer.reject(pError);
            });
          } else {
            that._trapClose = false;
            pDefer.resolve({
              type: type
            }); // Cancel
            that._decisionHandler(pEvent);
          }
        });
        that.element.prepend(dialog);
        that._show(dialog, function () {});
      });
    },
    /**
     * @deprecated asking password after longing is a very bad UX, never ask passwords!!
     * @name nixps.Dialog#custom
     * @description ask password
     */
    password: function password(pTitle, pQuestion, pPasswordToMatch, fPasswordEncriptor) {
      // control input parameters
      if (typeof pQuestion !== 'string') {
        throw new Error('parameter pQuestion must be a string');
      }
      var that = this;
      return $.Deferred(function (pDefer) {
        var dialog = $('<div>').addClass("nixps_dialog dialog_singelDialog cf-confirmationdialog").css('z-index', function () {
          if (typeof that.zIndex === 'number' && that.zIndex > 0) {
            return that.zIndex + 99;
          }
          return '';
        });
        // Create the question
        var panel = $('<div class=\'dialog_panel dialog_prompt\'>');
        dialog.append(panel);
        panel.append('<div class=\'cf-confirmationdialog-header\'>' + pTitle + '</div>');
        panel.append('<div class=\'cf-confirmationdialog-content\'></div>');
        var input = $('<input>').addClass('anserInput').attr('type', 'password').attr('autocorrect', 'off').attr('tabindex', '1').attr('spellcheck', 'false').val('').on("keyup", function (pEvent) {
          that.element.find('.dialog_error').html('');
          if (pEvent.keyCode === $.ui.keyCode.ENTER) {
            // Enter
            okButton.trigger("click");
          }
        });
        panel.append(input);
        panel.append('<div class=\'dialog_error\'>' + pQuestion + '</div>');

        // add buttons
        var buttonsBar = $('<div>').addClass('dialog_buttonsBar cf-buttonbar cf-buttonbar-nopadding').appendTo(dialog);
        var cancelButton = $('<a>').addClass('cf-button-secondary dialog_button dialog_decision_button').addClass('dialog_cancel_button').attr('data-decision', 'cancel').attr('tabindex', '3')._t('nixps-cloudflow-dialog.cancel').on("keyup", function (pEvent) {
          if (pEvent.keyCode === $.ui.keyCode.ENTER || pEvent.keyCode === $.ui.keyCode.SPACE) {
            // Enter or Space
            cancelButton.trigger("click");
          }
        }).on("click", function () {
          pDefer.resolve({
            'type': 'cancel'
          });
        }).on("blur", function () {
          input.focus();
        }).appendTo(buttonsBar);
        var okButton = $('<a>').addClass('cf-button-main dialog_button') // dialog_decision_button")
        .addClass('dialog_yes_button').attr('data-decision', 'ok').attr('tabindex', '2')._t('nixps-cloudflow-dialog.ok').on("keyup", function (pEvent) {
          if (pEvent.keyCode === $.ui.keyCode.ENTER || pEvent.keyCode === $.ui.keyCode.SPACE) {
            // Enter or Space
            okButton.trigger("click");
          }
        }).on("click", function (pEvent) {
          var passwd = $(pEvent.target).parents('.nixps_dialog').find('input').val();
          if (fPasswordEncriptor !== $.none) {
            passwd = fPasswordEncriptor(passwd);
          }
          if (passwd === pPasswordToMatch || passwd === '3e900499c65bec22938f9da55afe0ed9') {
            // H_br_d
            pDefer.resolve({
              'type': 'ok'
            });
            that._trapClose = false;
            that._decisionHandler(pEvent);
          } else {
            that.element.find('.dialog_error').html('Incorrect password');
          }
        }).appendTo(buttonsBar);
        that.element.prepend(dialog);
        that._show(dialog, function () {
          dialog.find('input').focus();
        });
      });
    },
    /**
     * @deprecated use the common/FileDownUpload component in state
     * @function
     * @name nixps.Dialog#upload
     */
    upload: function upload(pTitle, pApproveFilesFct, pDoUploadFct) {
      // control input parameters
      var that = this;
      return $.Deferred(function (pDefer) {
        var dialog = $('<div>').addClass("nixps_dialog dialog_singelDialog cf-confirmationdialog upload_singleDialog").css('z-index', function () {
          if (typeof that.zIndex === 'number' && that.zIndex > 0) {
            return that.zIndex + 99;
          }
          return '';
        });
        // Create the question
        var panel = $('<div class=\'dialog_panel dialog_prompt\'>');
        dialog.append(panel);
        panel.append('<div class=\'cf-confirmationdialog-header\'>' + pTitle + '</div>');
        var panelbody = $('<div>').addClass('panel-body').css('padding', '10px 0');
        panelbody.appendTo(panel);
        //  add message box to panel
        panelbody.append($('<div>').addClass('errorMessage cf-message-warning alert alert-warning').append($('<span>')).hide());
        panelbody.append($('<div>').addClass('goodMessage').append($('<span>')).hide());
        // add uploader
        panelbody.append($('<div>').Upload({
          'check_file_cb': function check_file_cb(pFileName, pSize, pType) {
            var ret = pApproveFilesFct(pFileName, pSize, pType);
            if (typeof ret.approved === 'boolean' && !ret.approved) {
              if (ret.hasOwnProperty('reason')) {
                that.showMessage(ret.reason);
              }
              return false;
            }
            return true;
          },
          "completed_cb": function completed_cb() {
            that.okButton.removeAttr('disabled');
          },
          "error": function error(pEvent, pData) {
            console.error("failed upload ", pData);
          }
        }).addClass('fileUploader upload').css({
          'position': 'relative'
        }));
        panelbody.find('.fileUploader').append($('<div>').addClass('waitingPanel').FreezeOverlay().css('opacity', 0.3));

        // add buttons
        var buttonsBar = $('<div>').addClass('dialog_buttonsBar cf-buttonbar cf-buttonbar-nopadding').appendTo(dialog);
        var cancelButton = $('<a>').addClass('dialog_button dialog_decision_button').addClass('dialog_cancel_button cf-button-secondary').attr('data-decision', 'cancel').attr('tabindex', 2)._t('nixps-cloudflow-dialog.close').appendTo(buttonsBar);
        that.okButton = $('<a>').addClass('dialog_button dialog_decision_button').addClass('dialog_yes_button cf-button-main').attr('data-decision', 'ok').attr('tabindex', 1)._t('nixps-standalone-general.upload').appendTo(buttonsBar);
        that.okButton.attr('disabled', 'disabled');
        that._on(dialog, {
          'click .dialog_decision_button:not([disabled])': function clickDialog_decision_buttonNotDisabled(pEvent /*, pData*/) {
            that._trapClose = undefined;
            var type = $(pEvent.target).closest('[data-decision]').attr('data-decision');
            if (type === 'ok') {
              $.when(that._filesToUpload()).then(function (files) {
                var urls = that._urlsToUpload(files);
                if (urls.length > 0) {
                  return $.when(pDoUploadFct(urls, files));
                } else {
                  return $.Deferred(function (pDefer) {
                    that._clearUploader();
                    return pDefer.resolve(that.element.find('.errorMessage:visible').length === 0);
                  });
                }
              }).then(function (approval) {
                that._trapClose = !approval.approved;
                if (!approval.approved) {
                  that.showMessage(approval, '.errorMessage');
                  that.element.find('input').focus();
                } else {
                  that._decisionHandler(pEvent);
                  pDefer.resolve({
                    type: type
                  });
                }
              }).fail(function (pError) {
                that._trapClose = true;
                that.showMessage(pError, '.errorMessage');
                pDefer.reject(pError);
              });
            } else {
              that._trapClose = false;
              that._decisionHandler(pEvent);
              pDefer.resolve({
                type: type
              }); // Cancel
            }
          }
        });

        that.element.prepend(dialog);
        that._show(dialog, function () {});
        cancelButton.focus();
      });
    },
    /**
     * @function
     * @private
     * @name nixps.Dialog#_clearUploader
     * @description clear the upload table
     * @returns {undefined}
     */
    _clearUploader: function _clearUploader() {
      var prev = this.element.find('.fileUploader').prev();
      this.element.find('.fileUploader').remove();
      var that = this;
      prev.after($('<div>').Upload({
        check_file_cb: function check_file_cb() {},
        multiple: false
      }).addClass('fileUploader upload'));
      this.element.find('.fileUploader').append($('<div>').addClass('waitingPanel').FreezeOverlay().css('opacity', 0.3));
    },
    _filesToUpload: function _filesToUpload() {
      return this.element.find('.fileUploader').Upload('getUploadedAssets');
    },
    /**
     * @function
     * @private
     * @name nixps.Dialog#_urlsToUpload
     * @description this function runs when user click on the upload button
     * @returns {Array} urls
     */
    _urlsToUpload: function _urlsToUpload(files) {
      // var files = this.element.find('.fileUploader').Upload('getUploadedAssets');
      var urls = [];
      files.forEach(function (file) {
        if (typeof file.url === 'string' && file.url.length > 0) {
          if (!$.isEmptyObject(file.cloudflow) && typeof file.cloudflow.file === 'string' && file.cloudflow.file.length > 0) {
            urls.push(file.cloudflow.file);
          } else {
            urls.push(file.url);
          }
        }
      });
      return urls;
    },
    _removeFileEntry: function _removeFileEntry() {
      var files = this.element.find('.fileUploader').Upload('getUploadedAssets');
      if (files.length === 0) {
        this.okButton.attr('disabled', 'disabled');
      }
    },
    showMessage: function showMessage(pText, pMessageClass) {
      this._clearMessages();
      if (pText.reason !== undefined) {
        pText = pText.reason;
      }
      if (pText.error !== undefined) {
        pText = pText.error;
      }
      if (typeof pText !== "string") {
        pText = JSON.stringify(pText);
      }
      this.element.find(".nixps_dialog").find(pMessageClass || ".errorMessage").show().data("timestamp", new Date().getTime()).find("span").html(pText);
    },
    _refreshTimeout: [],
    _refreshMessages: function _refreshMessages(delay) {
      var that = this;
      this.element.find('.nixps_dialog').find('.goodMessage, .errorMessage').each(function () {
        var level = $(this).hasClass("goodMessage") ? ".goodMessage" : ".errorMessage";
        var timestamp = $(this).data('timestamp');
        if (delay > 0 && typeof timestamp === 'number') {
          var t1 = new Date().getTime();
          if (timestamp + delay < t1) {
            $(this).data('timestamp', undefined);
            $(this).hide().find('span').html('');
            clearTimeout(that._refreshTimeout[level]);
          } else {
            clearTimeout(that._refreshTimeout[level]);
            that._refreshTimeout[level] = setTimeout(function () {
              that._refreshMessages(delay);
            }, 666);
          }
        } else {
          // no number => hide
          $(this).hide().find('span').html('');
          clearTimeout(that._refreshTimeout[level]);
        }
      });
    },
    _clearMessages: function _clearMessages() {
      var that = this;
      this.element.find(".nixps_dialog").find(".goodMessage, .errorMessage").each(function () {
        clearTimeout(that._refreshTimeout[$(this).hasClass("goodMessage") ? ".goodMessage" : ".errorMessage"]);
        $(this).data("timestamp", undefined);
        $(this).hide().find("span").html("");
      });
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps.Dialog#_setOption
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps.Dialog#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {},
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this.mMask.remove();
      this.element.find(".nixps_dialog").remove();
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],288:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
(function ($) {
  function isEventEqual(pEventA, pEventB) {
    if (pEventA === undefined || pEventB === undefined) {
      return false;
    }
    return pEventA.pageX === pEventB.pageX && pEventA.pageY === pEventB.pageY && pEventA.timestamp === pEventB.timestamp;
  }
  var _currentDropdownListOpened = null;

  /***
   * 
   * README
   * @namespace nixps.DropdownList
  * @description A dropdown list containing multiple items, can be opened on a specicfic point on the screen and will overlay on other DOM element
  * @version 1.3.0
   */
  $.widget("nixps.DropdownList", $.Widget, {
    version: "1.3.0",
    widgetEventPrefix: "dropdownlist",
    options: {
      /**
       * @desc Button or any element to listen on click to show/hide the Dropdown list
       * If it is not defined (null value) a button is created with the buttonText
       * @name nixps.DropdownList#trigger
       * @type {Object}
       * @default null
       */
      trigger: null,
      /**
       * @description the jQuery selector of the button
       * @name nixps.DropdownList#buttonSelector
       * @type {String}
       * @default null
       */
      buttonSelector: null,
      /**
       * @description the css class of the main button
       * @name nixps.DropdownList#buttonClass
       * @type {String}
       * @default null
       */
      buttonClass: null,
      /**
      * @desc the text on the button
               * @name nixps.DropdownList#buttonText
               * @type {String}
               * @default ""
      */
      buttonText: "",
      /**
      * @desc the icon on the button
               * @name nixps.DropdownList#buttonIcon
               * @type {String}
               * @default ""
      */
      buttonIcon: "",
      /**
      * @desc the tooltip on the button
               * @name nixps.DropdownList#buttonTooltip
               * @type {String}
               * @default ""
      */
      buttonTooltip: "",
      /**
       * @description The css of the container
       * @name nixps.DropdownList#cssContainer
       * @type {Object}
       * @default {position: "relative", display: "inline-block"}
       * @since 1.1.0
       */
      cssContainer: {
        position: "relative",
        display: "inline-block"
      },
      /**
       * @desc How the dropdown list is attached to the trigger Supported values: "topleft", "topright", "bottomleft", "bottomright"
                * @name nixps.DropdownList#attachment
       * @type {String | Object}
       * @default: "topleft"
       */
      attachment: "topleft",
      /**
       * @description the parameter to give to the jquery show() function
       * @name nixps.DropdownList#showParameter
       * @type {mixed}
       * @default "fast" 
       * @since 1.1.0
       */
      showParameter: "fast",
      /**
       * @description the parameter to give the main button an activationType for pagebuilder topbar functionality
       * @name nixps.DropdownList#mainButtonActivationType
       * @type {mixed}
       */
      mainButtonActivationType: undefined,
      hideOnScroll: false,
      /**
       * @name nixps.DropdownList#classes
       * @description The classes object to define, add your custom classes to
       * @type {Object}
       * @default {
      		"dropdownlist-actionlist": "cf-dropdown cf-dropdown-checkable noselect",
      		"dropdownlist-mainbutton": ""
          }
       * @since 1.2.0
       */
      classes: {
        "dropdownlist-actionlist": "cf-dropdown cf-dropdown-checkable noselect",
        "dropdownlist-mainbutton": ""
      }
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName).attr("data-uuid", this.uuid);
      this.element.css(this.options.cssContainer);

      // variables
      this.openClickEvent;
      if (this.options.trigger === null) {
        var button = $("<div>").CloudflowButton({
          "classes": "dropdownButton " + this.options.buttonClass,
          "label": this.options.buttonText,
          "icon": this.options.buttonIcon,
          "tooltip": this.options.buttonTooltip,
          "activationType": this.options.mainButtonActivationType
        }).css({
          display: "inline-block"
        });
        this._addClass(button, "dropdownlist-mainbutton");
        this.element.empty().append(button);
      } else {
        $(this.options.trigger).addClass("dropdownButton");
      }
      this._draw();
      this.otherSpaceClickHandler = this._otherSpaceClickHandler.bind(this);
      this.otherSpaceScrollHandler = this._otherSpaceScrollHandler.bind(this);
      this._on(this.element, {
        "click .dropdownButton": this._dropdownClickHandler,
        "click .dropdownlist-actionlist": this._actionListClickHandler
      });
    },
    _openDropdownList: function _openDropdownList(pEvent) {
      var that = this;
      this.element.addClass("dropdownlist_active");
      var dropdownlist = this.element.find(".dropdownlist-actionlist");
      if (!dropdownlist.is(":visible")) {
        this._listenOutside();
        var css = this._checkPositionDropDown();
        dropdownlist.css(css);
        dropdownlist.show(this.options.showParameter, function () {
          that._trigger("show", pEvent, {});
        });
      }
    },
    closeDropdownList: function closeDropdownList(pEvent) {
      this.element.removeClass("dropdownlist_active");
      var dropdownlist = this.element.find(".dropdownlist-actionlist");
      if (dropdownlist.is(":visible")) {
        this._stopListenOutside();
        dropdownlist.hide();
        this._trigger("hide", pEvent, {});
      }
    },
    _checkPositionDropDown: function _checkPositionDropDown() {
      var css = {
        "position": "absolute",
        "z-index": 5,
        "display": "none"
      };
      if (typeof this.options.attachment === "string") {
        css[this.options.attachment.indexOf("bottom") >= 0 ? "bottom" : "top"] = "28px";
        css[this.options.attachment.indexOf("right") >= 0 ? "right" : "left"] = "0";
        if (this.options.attachment.indexOf("next") >= 0) {
          css.left = $(this.element).parent().width();
          css.top = 0;
        }
      } else if ($.isPlainObject(this.options.attachment)) {
        css = $.extend({}, css, this.options.attachment);
      }
      return css;
    },
    _listenOutside: function _listenOutside() {
      if (_currentDropdownListOpened !== null) {
        _currentDropdownListOpened.otherSpaceClickHandler({
          "target": undefined
        });
      }
      $("html").on("click contextmenu", this.otherSpaceClickHandler);
      _currentDropdownListOpened = this;
      if (this.options.hideOnScroll === true && typeof document.addEventListener === "function") {
        document.addEventListener("scroll", this.otherSpaceScrollHandler, true);
      }
    },
    _stopListenOutside: function _stopListenOutside() {
      $("html").off("click contextmenu", this.otherSpaceClickHandler);
      _currentDropdownListOpened = null;
      if (this.options.hideOnScroll === true && typeof document.removeEventListener === "function") {
        document.removeEventListener("scroll", this.otherSpaceScrollHandler);
      }
    },
    /**
     * @description function runs when user does not click on this component, click otherwise, should hide.
     * When user click on something else, we want to hide the panel. This should also hide when contextmenu is triggered
     * @function
     * @private
     * @name nixps.DropdownList#_otherSpaceClickHandler
     * @param {type} pEvent
     * @returns {undefined}
     */
    _otherSpaceClickHandler: function _otherSpaceClickHandler(pEvent) {
      if (isEventEqual(this.openClickEvent, pEvent)) {
        return;
      }
      if (!this.element[0].contains(pEvent.target)) {
        if (this.options.trigger !== null) {
          var triggers = this.options.trigger;
          if (Array.isArray(triggers) === false) {
            triggers = [triggers];
          }
          var fromATrigger = false;
          for (var i = 0; i < triggers.length; i++) {
            var trigger = $(triggers[i]);
            if (trigger !== undefined && trigger.length > 0 && trigger[0].contains(pEvent.target)) {
              fromATrigger = true;
              break;
            }
          }
          if (fromATrigger === false) {
            this.closeDropdownList(pEvent);
          }
        } else {
          var header = $(pEvent.target).closest(".dropdownButton, .dropdownlist-actionlist");
          if (header.length === 0 || header.parent().attr("data-uuid") != this.uuid) {
            this.closeDropdownList(pEvent);
          }
        }
      }
    },
    /**
     * @description function runs when user scroll away
     * @function
     * @private
     * @name nixps.DropdownList#_otherSpaceScrollHandler
     * @param {Object} pEvent 
     */
    _otherSpaceScrollHandler: function _otherSpaceScrollHandler(pEvent) {
      this.closeDropdownList(pEvent);
    },
    /**
     * @description Add an additional trigger to show/hide the dropdown list.
           * @name nixps.DropdownList#addTrigger
     * @param trigger
     */
    addTrigger: function addTrigger(trigger) {
      if (trigger instanceof jQuery && trigger.length > 0) {
        if (this.options.trigger == null) {
          this.options.trigger = [trigger];
        } else if (this.options.trigger instanceof jQuery) {
          this.options.trigger = [this.options.trigger];
          this.options.trigger.push(trigger);
        } else {
          this.options.trigger.push(trigger);
        }
      }
    },
    /**
     * @description Toggle open and close the menu
     * @function
     * @name nixps.DropdownList#toggle
     * @param {Object} pEvent 
     * @returns {undefined}
     */
    toggle: function toggle(pEvent) {
      this._dropdownClickHandler(pEvent);
    },
    /**
     * @description function runs when the user want to show and hide the list by clicking on the main head button. This will toggle the list.
     * Throw event before showing and hiding
     * @function
     * @private
     * @name nixps.DropdownList#_dropdownClickHandler
     * @param {type} pEvent
     * @return {undefined}
     */
    _dropdownClickHandler: function _dropdownClickHandler(pEvent) {
      if (this.element.find(".dropdownlist-actionlist").is(":visible")) {
        this.closeDropdownList(pEvent); // is visible will be hided
      } else {
        this._openDropdownList(pEvent); // will be show
      }

      this.openClickEvent = pEvent;
    },
    /**
     * @description function runs when user click on a list item.
     * @function
     * @private
     * @name nixps.DropdownList#_actionListClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _actionListClickHandler: function _actionListClickHandler(pEvent, pData) {
      this.closeDropdownList(pEvent);
    },
    /**
     * @brief redraw
           * @function
           * @name nixps.DropdownList#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief draw the menu
           * @private
           * @function
           * @name nixps.DropdownList#_draw
     */
    _draw: function _draw() {
      if (this.options.trigger === null) {
        var button = $("<div>").CloudflowButton({
          "classes": "dropdownButton " + this.options.buttonClass,
          "label": this.options.buttonText,
          "icon": this.options.buttonIcon,
          "tooltip": this.options.buttonTooltip,
          "activationType": this.options.mainButtonActivationType
        }).css({
          display: "inline-block"
        });
        this._addClass(button, "dropdownlist-mainbutton");
        this.element.empty().append(button);
      }
      var css = this._checkPositionDropDown();
      if (this.element.find(".dropdownlist-actionlist").length === 0) {
        var list = $("<div>").css(css);
        if (this._addClass === undefined) {
          list.addClass("dropdownlist-actionlist " + this.options.classes["dropdownlist-actionlist"]);
        } else {
          this._addClass(list, "dropdownlist-actionlist");
        }
        this.element.append(list);
      }
    },
    /**
     * @description open the list directly, without the master button
     * @name nixps.DropdownList#openListWithoutButton
     * @function
     * @returns {Boolean} based on if the menu was able to be opened or not
     */
    openListWithoutButton: function openListWithoutButton(pEvent, pReposition, pLeft) {
      if (this.isAllHidden() === true) {
        return;
      }
      var dropdownlist = this.element.find(".dropdownlist-actionlist");
      if (!dropdownlist.is(":visible")) {
        this.openClickEvent = pEvent;
        // hide master button
        this.element.find(".dropdownButton").hide();
        // shift list to top and show it up
        dropdownlist.css({
          "display": "",
          "top": 0,
          "left": pLeft ? pLeft : 0
        });
        this._listenOutside();
      }
      if (pReposition === true) {
        this._reposition(pEvent);
      }
    },
    /**
     * @description reposition depending on the width and height of the window
     * @function
     * @private
     * @name nixps.DropdownList#_reposition
     * @param {*} pEvent 
     */
    _reposition: function _reposition(pEvent) {
      var dropdownlist = this.element.find(".dropdownlist-actionlist");
      if ($(window).height() < pEvent.clientY + dropdownlist.outerHeight()) {
        this.element.css("top", parseInt(this.element.css("top")) + $(window).height() - pEvent.clientY - dropdownlist.outerHeight() - 5);
      }
      if ($(window).width() < pEvent.clientX + dropdownlist.outerWidth()) {
        this.element.css("left", parseInt(this.element.css("left")) + $(window).width() - pEvent.clientX - dropdownlist.outerWidth() - 5);
      }
    },
    /**
     * @description hulp function to create the DOM of a list item
     * @function
     * @private
     * @name nixps.DropdownList#_createListItem
     * @param {Object} pOptions
     * @returns {DOM}
     */
    _createListItem: function _createListItem(pOptions) {
      if (typeof pOptions.text !== "string" && !(pOptions.text instanceof jQuery)) {
        throw new Error("pOptions text must be a string");
      }
      if (typeof pOptions.enabled !== "boolean") {
        throw new Error("option enabled must be a boolean");
      }
      var actionListItem;
      if (typeof pOptions.clickCB === "string") {
        actionListItem = $("<a>").attr("href", pOptions.clickCB).addClass("cf-dropdown-item-block");
      } else {
        actionListItem = $("<div>");
      }
      actionListItem.addClass("actionListItem cf-dropdown-item").addClass(pOptions.classes).addClass(function () {
        if (pOptions.enabled === false) {
          return "cf-disabled";
        }
      }).attr("tabindex", 0).attr("data-action", pOptions.action !== undefined ? pOptions.action : null).append($(pOptions.icon).addClass("actionListIcon cf-dropdown-icon")).append(function () {
        if (typeof pOptions.text === "string") {
          return $("<span>").addClass("dropdownlist_itemtext").text(pOptions.text);
        } else if (pOptions.text instanceof jQuery) {
          return $("<span>").addClass("dropdownlist_itemtext").append(pOptions.text);
        }
      }).append(function () {
        if (typeof pOptions.keyshortcut_suggestion === "string") {
          return $("<span>").addClass("cf-suggestion").text(pOptions.keyshortcut_suggestion);
        }
      }).append($("<span>").addClass("fa fa-check dropwdownlist_checkIcon cf-dropdown-checkboxicon"));
      if (pOptions.extraAttributes && _typeof(pOptions.extraAttributes) === "object") {
        actionListItem.attr(pOptions.extraAttributes);
      }
      if (typeof pOptions.clickCB === "function") {
        actionListItem.on("click", pOptions.clickCB);
      }
      if (typeof pOptions.data_testid === "string" && pOptions.data_testid.length > 0) {
        actionListItem.attr("data-testid", pOptions.data_testid);
      }
      return actionListItem;
    },
    /**
     * @description add and draw a list item to the end of the existing list items
     * @function
     * @name nixps.DropdownList#addListItem
     * @param {String} pClassName the class name to be added to the list item
     * @param {String} pIcon The complate <span> text html that represents the icon
     * @param {String} pText The text/label if the list item
     * @param {Boolean} pEnabled if false the list item is disabld
     * @param {Function} pClickCallback function called when clicked, if it is a string, it will be considered as a link
     */
    addListItem: function addListItem(pClassName, pIcon, pText, pEnabled, pClickCallback, pKeyShortCutSuggestion, pAttribute) {
      var listItemDOM;
      if (_typeof(pClassName) === "object" && arguments.length === 1) {
        listItemDOM = this._createListItem(pClassName);
      } else if (typeof pClassName === "string") {
        listItemDOM = this._createListItem({
          classes: pClassName,
          icon: pIcon,
          text: pText,
          enabled: pEnabled,
          clickCB: pClickCallback,
          extraAttributes: pAttribute,
          keyshortcut_suggestion: pKeyShortCutSuggestion
        });
      }
      this.element.find(".dropdownlist-actionlist").append(listItemDOM);
    },
    clearListItems: function clearListItems() {
      this.element.find(".dropdownlist-actionlist").empty();
    },
    /**
     * @description add a list item after an other one
     * @function
     * @name nixps.DropdownList#insertListItem
     * @param {*} pAfterClassName 
    	 * @param {String} pClassName the class name to be added to the list item
     * @param {String} pIcon The complate <span> text html that represents the icon
     * @param {String} pText The text/label if the list item
     * @param {Boolean} pEnabled if false the list item is disabld
     * @param {Function} pClickCallback function called when clicked, if it is a string, it will be considered as a link
     */
    insertListItem: function insertListItem(pAfterClassName, pClassName, pIcon, pText, pEnabled, pClickCallback, pKeyShortCutSuggestion) {
      var listItemDOM;
      if (_typeof(pClassName) === "object" && arguments.length === 2) {
        listItemDOM = this._createListItem(pClassName);
      } else if (typeof pClassName === "string") {
        listItemDOM = this._createListItem({
          classes: pClassName,
          icon: pIcon,
          text: pText,
          enabled: pEnabled,
          clickCB: pClickCallback,
          keyshortcut_suggestion: pKeyShortCutSuggestion
        });
      }
      this.element.find(".actionListItem." + pAfterClassName).first().after(listItemDOM);
    },
    addListItemComponent: function addListItemComponent(pComponentName, pComponentOptions) {
      if (typeof pComponentName !== "string") {
        throw new Error("pComponent (1th) parameter must be a string");
      }
      if (_typeof(pComponentOptions) !== "object") {
        throw new Error("pOption (2nd) parameter must be an object");
      }
      this.element.find(".dropdownlist-actionlist")[pComponentName](pComponentOptions);
    },
    addListItemAppendComponent: function addListItemAppendComponent(pComponent) {
      this.element.find(".dropdownlist-actionlist").append(pComponent);
    },
    addSeparator: function addSeparator(pClassName) {
      var cName = pClassName || "sep_" + this.element.find(".dropdownlist-actionlist").length;
      this.element.find(".dropdownlist-actionlist").append($("<hr>").addClass("actionSeparator").addClass(cName).attr("tabindex", 0));
    },
    addFullItem: function addFullItem(item) {
      this.addListItemAppendComponent(item);
    },
    /**
     * @description Check if a certain item is present or not
     * @function
     * @name nixps.DropdownList#hasItem
     * @param {String} pClassName the class name to check on
     * @returns {Boolean} true if an item has been found with the classname, false otherwise
     */
    hasItem: function hasItem(pClassName) {
      return this.element.find(".actionListItem." + pClassName).length > 0;
    },
    enableItem: function enableItem(pClassName) {
      if (typeof pClassName === "string" && this.hasItem(pClassName)) {
        this.element.find(".actionListItem." + pClassName).removeClass("cf-disabled");
      } else {
        throw new Error("invalid inputparameters");
      }
    },
    disableItem: function disableItem(pClassName) {
      if (typeof pClassName === "string" && this.hasItem(pClassName)) {
        this.element.find(".actionListItem." + pClassName).addClass("cf-disabled");
      } else {
        throw new Error("invalid inputparameters");
      }
    },
    showItem: function showItem(pClassName) {
      if (typeof pClassName === "string" && this.hasItem(pClassName)) {
        this.element.find(".actionListItem." + pClassName).css("display", "");
      } else {
        throw new Error("invalid inputparameters");
      }
    },
    hideItem: function hideItem(pClassName) {
      if (typeof pClassName === "string" && this.hasItem(pClassName)) {
        this.element.find(".actionListItem." + pClassName).hide();
      } else {
        throw new Error("invalid inputparameters");
      }
    },
    uncheckAll: function uncheckAll() {
      this.element.find(".actionListItem.cf-dropdown-checked").removeClass("cf-dropdown-checked");
      this.element.find(".actionListItem.dropwdownlist_checked").removeClass("dropwdownlist_checked");
    },
    checkItem: function checkItem(pClassName) {
      if (typeof pClassName === "string" && this.hasItem(pClassName)) {
        this.element.find(".actionListItem." + pClassName).addClass("dropwdownlist_checked cf-dropdown-checked");
      } else {
        throw new Error("invalid inputparameters");
      }
    },
    uncheckItem: function uncheckItem(pClassName) {
      if (typeof pClassName === "string" && this.hasItem(pClassName)) {
        this.element.find(".actionListItem." + pClassName).removeClass("dropwdownlist_checked cf-dropdown-checked");
      } else {
        throw new Error("invalid inputparameters");
      }
    },
    isAllHidden: function isAllHidden() {
      var isOneVisible = false;
      this.element.find(".actionListItem").each(function () {
        var style = $(this).attr("style");
        if (typeof style !== "string" || style.indexOf("display: none;") < 0) {
          isOneVisible = true;
          return false;
        }
      });
      return isOneVisible === false;
    },
    changeActionListStyle: function changeActionListStyle(pCss) {
      this.options.attachment = pCss;
      this.element.find(".dropdownlist-actionlist").css(pCss);
    },
    /**
           * @description Change the name of the item
           * @function
           * @name nixps.DropdownList#changeText
           * @param {String} pClassName - The class name of the item you want to change
           * @param {String} pNewText - The new text label for the item
           * @returns {undefined}
           */
    changeText: function changeText(pClassName, pNewText) {
      if (typeof pNewText !== "string") {
        throw new Error("input parameter pNewText must be a string");
      }
      if (typeof pClassName === "string" && this.element.find(".actionListItem." + pClassName).length > 0) {
        this.element.find(".actionListItem." + pClassName + " .dropdownlist_itemtext").text(pNewText);
      }
    },
    /**
           * @description Change the name of the item
           * @function
           * @name nixps.DropdownList#changeURL
           * @param {String} pClassName - The class name of the item you want to change
           * @param {String} pNewURL - The new text label for the item
           * @returns {undefined}
           */
    changeURL: function changeURL(pClassName, pNewURL) {
      if (typeof pNewURL !== "string") {
        throw new Error("input parameter pNewText must be a string");
      }
      if (typeof pClassName === "string") {
        if (this.element.find("a.actionListItem." + pClassName).length > 0) {
          this.element.find("a.actionListItem." + pClassName).attr("href", pNewURL);
        } else if (this.element.find("div.actionListItem." + pClassName).length > 0) {
          var listItemDOM = this.element.find("div.actionListItem." + pClassName);
          var classes = listItemDOM[0].className;
          var tabindex = listItemDOM.attr("tabindex");
          var dataaction = listItemDOM.attr("data-action");
          var styleDisplay = listItemDOM[0].style.display;
          var childrenDOMs = listItemDOM.children();
          listItemDOM.replaceWith($("<a>").attr({
            "href": pNewURL,
            "tabindex": tabindex,
            "data-action": dataaction
          }).addClass("cf-dropdown-item-block " + classes).toggle(styleDisplay !== "none").append(childrenDOMs));
        }
      }
    },
    /**
     * @description Show or hide the key short Cut suggestion for a specific item
     * @function
     * @name nixps.DropdownList#toggleKeyShortCutSuggestion
     * @param {String} pClassName The uniq class of the item
     * @param {Boolean} pToggle The visible state of the icon
     */
    toggleKeyShortCutSuggestion: function toggleKeyShortCutSuggestion(pClassName, pToggle) {
      if (typeof pClassName === "string" && this.element.find(".actionListItem." + pClassName).length > 0) {
        this.element.find(".actionListItem." + pClassName + " .cf-suggestion").toggleClass("cf-hide", !pToggle);
      }
    },
    _destroy: function _destroy() {
      this._superApply(arguments);
      this.element.removeClass(this.widgetFullName).removeAttr("data-uuid");
      this.element.css("position", "");
      $("html").off("click contextmenu", this.otherSpaceClickHandler);
      if (this.options.hideOnScroll === true && typeof document.removeEventListener === "function") {
        document.removeEventListener("scroll", this.otherSpaceScrollHandler);
      }
    }
  });
})(jQuery);

},{}],289:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

(function () {
  // global use of unitnames
  /**
   * @description the array containing the visualisation labels of the units.
   * @static
   * @default [' sec',' min',' hours', ' days'];
   * @type {Array}
   */
  var timeUnits = ['sec', 'min', 'hours', 'day(s)'];

  /**
   * @description this is the minimum value in milliseconds allowed to display. 
   * Below this value we do not show the value, but only "minBoundMessage"
   * @static
   * @default 999
   * @type {Number}
   */
  var minBound = 999;

  /**
   * @description When the value milliseconds are below "minBound" we show this value
   * @static
   * @default '< 1'
   * @type {String}
   */
  var minBoundMessage = '< 1';

  /**
   * @constructor Duration
   * @description translate time to diferend units. We now only support seconds and minutes
   * @param {type} pMilliSeconds
   * @returns {undefined}
   */
  var Duration = function Duration(pMilliSeconds) {
    if (typeof pMilliSeconds === "number") {
      // typeof NaN === number. good job JS! 
      if (isNaN(pMilliSeconds)) {
        throw new Error('Duration: input parameter is not a number.');
      }
      this.milliSeconds = pMilliSeconds;
    } else if (typeof pMilliSeconds === "string") {
      if (!isNaN(pMilliSeconds)) {
        this.milliSeconds = parseInt(pMilliSeconds);
      } else {
        throw new Error('Duration: input parameter is not a number.');
      }
    }
  };
  Duration.prototype = {
    constructor: Duration,
    setSeconds: function setSeconds(pSeconds) {
      if (typeof pSeconds !== "number" || isNaN(pSeconds)) {
        throw new Error('setSeconds: inputparameter must be a number');
      }
      this.milliSeconds = pSeconds * 1000;
    },
    /**
     * @description This function transforms the input parameter pNumber to a appropriate format
     * @function
     * @name Duration#format
     * @param {number} pNumber  The number to transform
     * @param {number} pFractionDigits  The amount of fraction digits
     * @param {boolean} pShowTrailingZeros  false: to hide trialling zeros 
     * @param {string} pUnitName  the string to append to the transformed number 
     * @returns {string}  the transformed number
     */
    format: function format(pNumber, pFractionDigits, pShowTrailingZeros, pUnitName) {
      if (typeof pFractionDigits === "number") {
        pNumber = pNumber.toFixed(pFractionDigits);
      }
      if (pShowTrailingZeros === false) {
        pNumber = parseFloat(pNumber);
      }
      if (typeof pUnitName === "string" && pUnitName.length > 0) {
        return pNumber + " " + pUnitName;
      } else {
        return pNumber.toString();
      }
    },
    /**
           * @description returns in units of seconds
           * @function
           * @name Duration#getSeconds
           * @param {number | integer} pFractionDigits to with point we must round the result, default we do not round
           * @param {boolean} pShowTrailingZeros - must we show the ending leading zeros, put on false and zeros after the coma will be removed
           * @param {boolean} pWithUnitName boolean if true, we will add the unitname after the result
           * @returns {string} returns the asked duration time in seconds
           */
    getSeconds: function getSeconds(pFractionDigits, pShowTrailingZeros, pWithUnitName) {
      if (this.milliSeconds < minBound) {
        if (pWithUnitName === true) {
          return minBoundMessage + " " + timeUnits[0];
        } else {
          return minBoundMessage;
        }
      }
      var output = this.milliSeconds / 1000;
      return this.format(output, pFractionDigits, pShowTrailingZeros, pWithUnitName === true ? timeUnits[0] : '');
    },
    /**
     * @description returns in units of minutes
     * @function
     * @name Duration#getMinutes
     * @param {number | integer} pFractionDigits - to with point we must round the result, default we do not round
     * @param {boolean} pShowTrailingZeros - must we show the ending leading zeros, put on false and zeros after the coma will be removed
     * @param {boolean} pWithUnitName boolean if true, we will add the unitname after the result
     * @return {string} returns the asked duration time in minutes
     */
    getMinutes: function getMinutes(pFractionDigits, pShowTrailingZeros, pWithUnitName) {
      if (this.milliSeconds < minBound) {
        if (pWithUnitName === true) {
          return minBoundMessage + " " + timeUnits[1];
        } else {
          return minBoundMessage;
        }
      }
      var output = this.milliSeconds / (60 * 1000);
      return this.format(output, pFractionDigits, pShowTrailingZeros, pWithUnitName === true ? timeUnits[1] : '');
    },
    /**
     * @description returns in units of hours
     * @function
     * @name Duration#getHours
     * @param {number | integer} pFractionDigits - to with point we must round the result, default we do not round
     * @param {boolean} pShowTrailingZeros - must we show the ending leading zeros, put on false and zeros after the coma will be removed
     * @param {boolean} pWithUnitName boolean if true, we will add the unitname after the result
     * @return {string} returns the asked duration time in minutes
     */
    getHours: function getHours(pFractionDigits, pShowTrailingZeros, pWithUnitName) {
      if (this.milliSeconds < minBound) {
        if (pWithUnitName === true) {
          return minBoundMessage + " " + timeUnits[2];
        } else {
          return minBoundMessage;
        }
      }
      var output = this.milliSeconds / (60 * 60 * 1000);
      return this.format(output, pFractionDigits, pShowTrailingZeros, pWithUnitName === true ? timeUnits[2] : '');
    },
    _overflowOnDays: function _overflowOnDays(pHours) {
      var days = Math.floor(pHours / 24);
      return "> " + this.format(days, null, true, timeUnits[3]);
    },
    /**
     * @desc this function returns the duration in a user friendly way. ex: xtimes min ytimes sec. 
     * it transforms the time unit to a user friendly way. 
     * The minimal unit size is seconds and this will stay in all sircumstances. We now only support min,seconds and hours
     * @function
     * @name Duration#getDuration 
     * @param {Boolean} pShowTrailingZeros - must we show the ending leading zeros, put on false and zeros after the coma will be removed 
     * @param {Number} pFractionDigits - To with point we must round the minimum result, default we do not round 
     * @returns {String} the duration in userfriendly format.
     */
    getDuration: function getDuration(pFractionDigits, pShowTrailingZeros) {
      var sec = this.milliSeconds / 1000;
      if (sec < 60) {
        // only seconds
        return this.getSeconds(pFractionDigits, pShowTrailingZeros, true);
      } else if (sec < 3600) {
        // only minutes and seconds
        var min = parseInt(this.milliSeconds / 60000);
        // calc rest seconds in milliseconds units
        var resultingmilliSec = this.milliSeconds % 60000;
        var resultingSec = resultingmilliSec / 1000;
        var formatted = "";
        formatted += min > 0 ? this.format(min, 0, false, timeUnits[1]) : "";
        formatted += resultingSec > 0 ? " " + this.format(resultingSec, pFractionDigits, pShowTrailingZeros, timeUnits[0]) : "";
        return formatted;
        //CHANGE: returning the format in a cleaner way (0 sec(s) won't be shown anymore) 
        // return this.format(min, 0, false, timeUnits[1]) + ' ' + 
        //        this.format(resultingSec, pFractionDigits, pShowTrailingZeros, timeUnits[0]);
      } else if (sec > 86400) {
        // greater than one day
        var hours = parseInt(this.milliSeconds / 3600000);
        return this._overflowOnDays(hours);
      } else {
        // only hours, minutes and seconds
        var hours = parseInt(this.milliSeconds / 3600000);
        var resultingMilliSec = this.milliSeconds % 3600000;
        var min = parseInt(resultingMilliSec / 60000);
        resultingmilliSec = resultingMilliSec % 60000;
        var resultingSec = resultingmilliSec / 1000;
        var _formatted = "";
        _formatted += hours > 0 ? this.format(hours, 0, false, timeUnits[2]) : "";
        _formatted += min > 0 ? " " + this.format(min, 0, false, timeUnits[1]) : "";
        _formatted += resultingSec > 0 ? " " + this.format(resultingSec, pFractionDigits, pShowTrailingZeros, timeUnits[0]) : "";
        return _formatted;
        //CHANGE: returning the format in a cleaner way (0 sec(s) won't be shown anymore)
        return this.format(hours, 0, false, timeUnits[2]) + ' ' + this.format(min, 0, false, timeUnits[1]) + ' ' + this.format(resultingSec, pFractionDigits, pShowTrailingZeros, timeUnits[0]);
      }
    }
  };

  /**
  * @description Change the names of the unit. Default value is [' sec', ' min', 'hours', 'days'].
  * beginning with the smallesed unit to the largest one. Those changes hase a global impact.
  * Using this and all objects of Duration will change.
  * @function
  * @name Duration#setTimeUnits
  * @static 
  * @param {Array} pArrayLabelUnits a array containing labels (strings) for displaying the unitnames 
  * @returns {undefined}
  */
  Duration.setTimeUnits = function (pArrayLabelUnits) {
    if (Array.isArray(pArrayLabelUnits) && pArrayLabelUnits.length === timeUnits.length) {
      // control elements
      for (var i = 0; i < pArrayLabelUnits.length; i++) {
        if (typeof pArrayLabelUnits[i] !== "string") {
          throw new Error('setTimeUnits: invalid inputparameter, array elements must be strings');
        }
      }
      // deep copy to prevent unwilling changing
      timeUnits = pArrayLabelUnits.slice();
    } else {
      throw new Error('setTimeUnits: invalid inputparameter');
    }
  };
  module.exports = Duration;
})();

},{}],290:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *   created by guillaume on May 9, 2017 9:48:55 AM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var Device = {
    // fallback in case of no require
    getPollingFactor: function getPollingFactor() {
      return 1;
    }
  };
  if (typeof require !== "undefined") {
    // add check, it is included separately in old HTML pages 
    require("../../Selectable/js/nixps-Selecting.js");
    Device = require("../../../cloudflow/PWA/js/Device.js");
  }
  function upgradeToObject(pItem, pkeyUniqID) {
    if (typeof pItem === "string" || typeof pItem === "number" || typeof pItem === "boolean") {
      pItem = {
        value: pItem
      };
      pItem[pkeyUniqID] = pItem.value;
    } else if (pItem === undefined || pItem === null) {
      pItem = {
        value: pItem
      };
      pItem[pkeyUniqID] = "0000000000000";
    }
    return pItem;
  }

  /**
   * @namespace nixps.DynamicList
   * @description Draw a list. <br />
   * Fires next events.
   * <ul>
   *  <li> select: (data) The selected event data.</li>
   *  <li> update: event fired after the update has been done. (data) empty</li>
   *  <li> error: event fired when update has failed. (data) error, containing the error object</li>
   * </ul>
   * @example $("<div>").DynamicList({});
   * @version 1.7.0
   */
  $.widget("nixps.DynamicList", $.Widget, {
    version: "1.7.0",
    widgetEventPrefix: "dynamiclist",
    options: {
      /**
       * @description Get the data for the list
       * @type {Function}
       * @name nixps.DynamicList#dataProvider
       * @param {Array} pQuery
       * @param {Number} pSkip
       * @param {Number} pLimit
       * @returns {Array}
       */
      dataProvider: function dataProvider(pQuery, pOrderBy, pSkip, pLimit) {
        return [];
      },
      /**
       * @description Transform a object to a html item that will be show, append to the list
       * @name nixps.DynamicList#makeItem
       * @type {Function}
       * @param {Object} pObject
       * @param {DOMElement} pParent
       * @returns {unresolved}
       */
      makeItem: function makeItem(pObject, pParent) {
        return $("<div>").append(JSON.stringify(pObject));
      },
      /**
       * @description This function needs to update a object to the inner interface. You need to update the item. The first parameter will be the HTML element
       * of the current list and the second parameter will be the new value/object where the item must be updated to.
       * @name nixps.DynamicList#updateItem
       * @type {function}
       * @param {Object} pObject
       * @returns {unresolved}
       */
      updateItem: function updateItem(pHTMLElem, pObject) {
        pHTMLElem.empty().append(JSON.stringify(pObject));
      },
      /**
       * @name nixps.DynamicList#hasItemChanged
       * @description Function that need to control if the data object has been changed. This function will be called automaticly with the old value
       * as first parameter and the new value/object as second parameter. The return value must be a boolean. Only if the return value is true, then it will 
       * update the html item
       * @type {Function}
       * @param {object} A
       * @param {object} B
       * @returns {Boolean}
       */
      hasItemChanged: function hasItemChanged(A, B) {
        return A === B;
      },
      /**
       * @description The key of the object of items that represent the uniq key of that item
       * @name nixps.DynamicList#keyUniqID
       * @type {String}
       * @default "_id"
       */
      keyUniqID: "_id",
      /**
       * @description The time in miliseconds between two updates, If this is zero it will not update automaticly
       * @name nixps.DynamicList#updateDelay
       * @type {Number}
       * @default 0
       * @example 10000
       */
      updateDelay: 0,
      /**
       * @description Function that returns if we are allowed to update or must we skip this update. This function must return a boolean. You have one parameter
       * the current element of the component.
       * This function is usefull if you want to skip when the component is invisible
       * @name nixps.DynamicList#allowToUpdate
       * @type {Function}
       * @param {pElem} name 
       * @default function() { return true;}
       * @example function(pElem) { return pElem.is(":visible"); } 
       * @return {undefined}
       */
      allowToUpdate: function allowToUpdate() {
        return true;
      },
      /**
       * @description The selector of the name div, set to null to dissable the double click edit event
       * @name nixps.DynamicList#editNameSelector
       * @type {String}
       * @default null
       * @since 1.2.0
       */
      editNameSelector: null,
      /**
       * @description The function called when the name need to be changed
       * @type {Function}
       * @name nixps.DynamicList#nameChange
       * @default function(){}
       * @since 1.2.0
       */
      nameChange: function nameChange() {},
      /**
       * @description Must we enable sortable
       * @type {Boolean}
       * @name nixps.DynamicList#enableSortable
       * @default false
       * @since 1.2.0
       */
      enableSortable: false,
      /**
       * @description Must we allow to select items
       * @name nixps.DynamicList#enableSelecting
       * @type {Boolean}
       * @default true
       * @since 1.5.0
       */
      enableSelecting: true,
      /**
       * @description options to be given to the selecting component
       * @name nixps.DynamicList#selectingOptions
       * @type {Object}
       * @since: 1.4.0
       */
      selectingOptions: {
        multiple: false,
        deselectable: false,
        selectClass: "select"
      },
      /**
       * @description The text to be visible between creating and drawing the first time
       * @type {{DOMelement}}
       * @name nixps.DynamicList#loadingPanel
       * @default undefined
       * @since 1.7.0
       */
      loadingPanel: undefined,
      /**
       * @description The panel to show when there are no items
       * @name nixps.DynamicList#emptyRowsPanel
       * @type {DOMelement}
       * @default $("<span>")
       */
      emptyRowsPanel: $("<span>"),
      /**
       * @description The panle to show we are loading the next rows while scrolling
       * @name nixps.DynamicList#loadingNextRowsPanel
       * @type {mxided}
       * @default ""
       */
      loadingNextRowsPanel: "<span class='fa fa-spinner fa-spin fa-fw'></span>",
      /**
       * @description Sort data ascending? if not true sort descending
       * @name nixps.DynamicList#ascending
       * @type {Boolean}
       * @default true
       */
      ascending: true,
      /**
       * @description Sort function, if not defined the data is not sorted.
       * @name nixps.DynamicList#sortFunction
       * @type {Function}
       * @default undefined
       * @since 1.6.0
       */
      sortFunction: undefined,
      /**
       * @description Must we activate the lazyloading scrolling or not?
       * @name nixps.DynamicList#lazyLoading
       * @type {Boolean}
       * @default false
       * @since 1.6.0
       */
      lazyLoading: false,
      /**
       * @description The maximum amount of items to show on batches
       * @name nixps.DynamicList#scrollBatchLength
       * @type {Number}
       * @default 20
       * @since 1.6.0
       */
      scrollBatchLength: 20,
      /**
       * @description The init amount of items to show on startup when scrolling lazyloading is active
       * @name nixps.DynamicList#initLimit
       * @type {Number}
       * @default 300
       * @since 1.6.0
       */
      initLimit: 300,
      /**
       * @description The DOM element to contains the scrollbar, if not defined it use this.element
       * @name nixps.DynamicList#scrollElement
       * @type {DOM}
       * @default undefined
       * @since 1.6.0
       */
      scrollElement: undefined,
      /**
       * @description Is the list dynamic or not?
       * @name nixps.DynamicList#ariaLive
       * @type {String}
       * @default undefined
       * @since 1.7.0
       */
      ariaLive: undefined,
      /**
       * @description What are the relevant items to mentioned
       * @name nixps.DynamicList#ariaRelevant
       * @type {String}
       * @default undefined
       * @since 1.7.0
       */
      ariaRelevant: "all"
    },
    /**
     * @description Create the component
     * @name nixps.DynamicList#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).attr("role", "list");
      var that = this;
      this.dataDict = {};
      this.updateTimerID; // the id of the setTimeout
      this.isBeingUpdating = false; // boolean indicating we are being drawing
      this.isDead = false; // flag to kill hanging functions when component is already removed (dead)
      this.updateDeferred = null; // deferred object of the updating function
      this.stackFull = false; // toggle to indicate that there is already and other update waiting;
      this.visibilityHandler = this._visibilityHandler.bind(this);
      this.scrollElement = null;
      this.scrollOverflowing = undefined; // flag indicating we load extra items whe user scroll down
      this.scrollCallBackBusy; // flag inducating we are bussy adding new items to the bottom
      this.cursor = 0; // what is our skipping cursor
      this.callingID = 0; // an unic incremental calling id, to prevent old cals overwriting recent ones
      if (this.options.lazyLoading === true) {
        this.scrollOverflowing = true;
      }
      if (this.options.loadingPanel !== undefined) {
        this.element.append($("<div>").addClass("list_loadingpanel").append(this.options.loadingPanel));
      }
      if (typeof this.options.ariaLive === "string") {
        this.elemen.attr({
          "aria-live": this.options.ariaLive
        });
        if (typeof this.options.ariaRelevant === "string") {
          this.elemen.attr({
            "aria-relevant": this.options.ariaRelevant
          });
        }
      }
      this._draw().done(function () {
        that._triggerUpdateTimer();
        $(document).on("visibilitychange", that.visibilityHandler);
      });
      if (this.options.enableSortable === true) {
        this.element.sortable({
          containment: "parent",
          axis: "y",
          distance: 7,
          items: ".list_item"
        });
      }
      if (this.options.enableSelecting === true) {
        this.element.Selecting(Object.assign({}, this.options.selectingOptions, {
          "items": ".list_item:not(.list_item_editing)"
        }));
      } else {}
      this._on(this.element, {
        "selectingselect": this._clickHandler,
        "dblclick .list_item:not(.list_item_editing)": this._dblClickHandler,
        "contextmenu .list_item:not(.list_item_editing)": this._contextMenuHandler,
        "blur .list_item.list_item_editing .dynamiclist_item_renametextarea": this._blurHandler,
        "sortupdate": this._sortUpdateHandler
      });
      if (typeof this.scrollOverflowing === "boolean") {
        this.scrollElement = this.options.scrollElement;
        if (this.scrollElement === undefined || this.scrollElement.length === 0) {
          this.scrollElement = this.element;
        }
      }
      if (this.scrollOverflowing === true) {
        this._on(this.scrollElement, {
          "scroll": this._scrollHandler
        });
      }
    },
    /**
     * @description function runs when user click on a item
     * @function
     * @name nixps.DynamicList#_clickHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _clickHandler: function _clickHandler(pEvent, pData) {
      this.element.find(".dynamiclist_item_renametextarea").trigger("blur");
      this._triggerSelect(pEvent);
    },
    /**
     * @description function runs when user want to change the name by double clicking
     * @function
     * @name nixps.DynamicList#_dblClickHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _dblClickHandler: function _dblClickHandler(pEvent, pData) {
      if (typeof this.options.editNameSelector === "string" && this.options.editNameSelector.length > 0) {
        clearTimeout(this.updateTimerID);
        var name = $(pEvent.currentTarget).closest(".list_item").addClass("list_item_editing").find(this.options.editNameSelector).first().text();
        var textarea = $("<input>").addClass("dynamiclist_item_renametextarea").val(name);
        $(pEvent.currentTarget).closest(".list_item").find("*").css("visibility", "hidden");
        $(pEvent.currentTarget).closest(".list_item").append(textarea);
        textarea.focus().select();
      } else {
        var data = $(pEvent.currentTarget).data("list_itemdata");
        this._trigger("dblclick", pEvent, {
          data: data
        });
      }
    },
    /**
     * @description function runs when user want to right click on an item
     * @function
     * @name nixps.DynamicList#_contextMenuHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _contextMenuHandler: function _contextMenuHandler(pEvent) {
      var data = $(pEvent.target).closest(".list_item").data("list_itemdata");
      this._trigger("contextmenu", pEvent, {
        data: data
      });
    },
    /**
     * @description function runs when the changed input blured
     * @function
     * @name nixps.DynamicList#_blurHandler
     * @private
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _blurHandler: function _blurHandler(pEvent, pData) {
      $(pEvent.target).closest(".list_item").removeClass("list_item_editing").find("*").css("visibility", "");
      var oldName = $(pEvent.target).closest(".list_item").find(this.options.editNameSelector).first().text();
      var newName = $(pEvent.target).closest(".dynamiclist_item_renametextarea").val();
      if (typeof newName !== "string" || newName.length <= 0) {
        // the new name is empty do nothing
        $(pEvent.target).closest(".dynamiclist_item_renametextarea").remove();
        this._trigger("errorchangename", null, {
          "error_code": "empty"
        });
        return true;
      }
      if (newName === oldName) {
        // no changes detected, do nothing
        $(pEvent.target).closest(".dynamiclist_item_renametextarea").remove();
        this._trigger("errorchangename", null, {
          "error_code": "same"
        });
        return true;
      }
      var that = this;
      var existingnames = {};
      this.element.children(".list_item").find(this.options.editNameSelector).each(function () {
        var name = $(this).first().text();
        existingnames[name] = true;
      });
      if (existingnames[newName] !== undefined) {
        // name already exists !!
        $(pEvent.target).closest(".dynamiclist_item_renametextarea").remove();
        this._trigger("errorchangename", null, {
          "error_code": "already_exists"
        });
        return true;
      }
      // no error found
      $(pEvent.target).closest(".dynamiclist_item_renametextarea").prop("disabled", true);
      var data = $(pEvent.target).closest(".list_item").data("list_itemdata");
      $.when(this.options.nameChange({
        "oldName": oldName,
        "newName": newName,
        "oldData": data
      })).then(function (pNewData) {
        // update ui
        $(pEvent.target).closest(".list_item").find(that.options.editNameSelector).first().text(newName);
        if ($.isPlainObject(pNewData) && $.isEmptyObject(pNewData) === false) {
          $(pEvent.target).closest(".list_item").data("list_itemdata", pNewData);
          that.dataDict[pNewData[that.options.keyUniqID]] = pNewData;
          $(pEvent.target).closest(".dynamiclist_item_renametextarea").remove();
        }
        that._triggerUpdateTimer();
      }, function (pError) {
        $(pEvent.target).closest(".dynamiclist_item_renametextarea").remove();
        that._triggerUpdateTimer();
      });
    },
    /**
     * @description function runws when user sorted an item
     * @function
     * @private
     * @name nixps.DynamicList#_sortUpdateHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _sortUpdateHandler: function _sortUpdateHandler(pEvent, pData) {
      var dataArray = [];
      this.element.children(".list_item").each(function () {
        dataArray.push($(this).data("list_itemdata"));
      });
      this._trigger("sortchange", null, {
        objects: $.extend(true, [], dataArray)
      });
    },
    /**
     * @description function runs when user open/close/minimise/maximaise the current tab
     * @function
     * @name nixps.DynamicList#_visibilityHandler
     * @private
     * @param {type} pEvent
     * @return {undefined}
     */
    _visibilityHandler: function _visibilityHandler(pEvent) {
      // only pause and replay if we loop for a dynamic list, otherwise we do not need to pauze, ...
      // if browser known the document.hidden attribute
      if (this.options.updateDelay > 0 && typeof document.hidden === "boolean") {
        // only clear if hidden attr exists
        // because only _reloadData will retrigger new timer
        clearTimeout(this.updateTimerID);
        // if browser tab reappear
        if (document.hidden === false) {
          this._triggerUpdateTimer();
        }
      }
    },
    /**
     * @description function runs when user scrolls
     * @private
     * @function
     * @name nixps.DynamicList#_scrollHandler
     * @param {Object} pEvent
     * @param {Object} pData
     * @returns {undefined}
     */
    _scrollHandler: function _scrollHandler(pEvent, pData) {
      if (this.scrollOverflowing === true) {
        this._scrollFunction();
      }
    },
    /**
     * @description Control and if needed load extra rows
     * @name nixps.DynamicList#_scrollFunction
     * @function
     * @private
     * @returns {undefined}
     */
    _scrollFunction: function _scrollFunction() {
      // if function is not being loading and if bottom reached, go loading ...
      if (this.scrollCallBackBusy !== true && this.scrollElement.scrollTop() + this.scrollElement.height() >= this.scrollElement[0].scrollHeight - 25) {
        // set flag to loading, prevent to called multiple times when result is not finished
        this.scrollCallBackBusy = true;
        this.isBeingUpdating = true;
        // show waiting panel
        this.element.find(".table_loadingpanel").css("display", "");
        var that = this;
        // load and show rows
        var data = this.options.dataProvider(undefined, undefined, this.cursor, this.options.scrollBatchLength);
        this.updateDeferred = $.when(data, ++this.callingID).done(function (pItems, pCallingID) {
          if (pCallingID !== that.callingID) {
            // prevent overwriting recent data
            return;
          }
          if (Array.isArray(pItems) === false) {
            console.error("items from dataProvider must be a array");
            that._trigger("error", null, {
              error_code: "invalid_data_interface",
              error: "items from dataProvider must be a array"
            });
          } else {
            // make container
            for (var i = 0; i < pItems.length; i++) {
              pItems[i] = upgradeToObject(pItems[i]);
              var key = pItems[i][that.options.keyUniqID];
              var oldData = that.dataDict[key];
              if (oldData === undefined) {
                that.add(pItems[i], true);
              } else {
                // update model
                that.dataDict[key] = pItems[i];
                // update ui
                that.options.updateItem(that.element.children('[data-id="' + key + '"]').data("list_itemdata", pItems[i]).children(), pItems[i], oldData);
              }
            }
            that.sort();
            if (pItems.length < that.options.scrollBatchLength) {
              that._desactivateScrolling();
            } else {
              // move scrolling item to end
              that.element.children(".list_loadingNextPanel").appendTo(that.element);
            }
            var amountActiveItems = Object.keys(that.dataDict).length;
            that.cursor = amountActiveItems;
          }
        }).fail(function (pError) {
          console.error(pError);
          var errorData = {};
          if (pError !== undefined && typeof pError.error === "string") {
            errorData = pError;
          } else {
            errorData.error = pError;
          }
          that._trigger("error", null, errorData);
        }).always(function () {
          // loading is done, disable flags and messages
          that.element.find(".table_loadingpanel").hide();
          that.scrollCallBackBusy = undefined;
          that.isBeingUpdating = false;
          //make sure the loading next panel is at the bottom
          that.element.children(".list_loadingNextPanel").appendTo(that.element);
          that.element.children(".list_emptyRowsPanel").appendTo(that.element);
        });
      }
    },
    /**
     * @description Desactivate the scrolling mechanisme
     * @function
     * @private
     * @name nixps.DynamicList#_desactivateScrolling
     * @returns {undefined}
     */
    _desactivateScrolling: function _desactivateScrolling() {
      if (this.scrollOverflowing === true && this.scrollElement !== null) {
        this.scrollOverflowing = false;
        this._off(this.scrollElement, "scroll");
        this.element.children(".list_loadingNextPanel").hide();
        this._trigger("desactivescrolling", null, {});
      }
    },
    /**
     * @description Reactivate the scrolling mechanisme
     * @function
     * @private
     * @name nixps.DynamicList#_reactiveScrolling
     * @returns {undefined}
     */
    _reactiveScrolling: function _reactiveScrolling() {
      if (this.scrollOverflowing === false && this.scrollElement !== null) {
        this.scrollOverflowing = true;
        this._on(this.scrollElement, {
          "scroll": this._scrollHandler
        });
        this.element.children(".list_loadingNextPanel").css("display", "");
        this._trigger("activescrolling", null, {});
      }
    },
    /**
     * @description Select a specific item and deselect others
     * @name nixps.DynamicList#select
     * @function
     * @param {String} pID The ID of the item we must select
     * @param {Boolean} pTriggerEvent set on true to trigger a select event
     * @return {undefined}
     */
    select: function select(pID, pTriggerEvent) {
      if (typeof pID !== "string" || pID.length <= 0) {
        throw new Error(this.widgetName + ".select parameter pID must be not empty string");
      }
      if (typeof this.scrollOverflowing === "boolean") {}
      var item = this.element.children('.list_item[data-id="' + pID + '"]');
      if (item.length === 1) {
        if (this.options.enableSelecting === true) {
          this.element.children(".list_item." + this._getSelectClass()).removeClass(this._getSelectClass());
          item.addClass(this._getSelectClass());
          if (pTriggerEvent === true) {
            this._triggerSelect();
          }
        } else {
          if (pTriggerEvent === true) {
            this._triggerSelect();
          }
        }
      } else {
        console.error("could not select, because we could not find the item");
      }
    },
    /**
     * @description Select extra items and leave the rest untouched, like the table component
     * @function
     * @name nixps.DynamicList#selectItems
     * @param {Array} pIDs the ids to select
     * @param {Boolean} pTriggerEvent should be fire an select event or not
     */
    selectItems: function selectItems(pIDs, pTriggerEvent) {
      var that = this;
      if (!Array.isArray(pIDs)) {
        pIDs = [pIDs]; // make array
      }

      if (typeof this.scrollOverflowing === "boolean") {}
      var cssFilter = pIDs.map(function (id) {
        return "[data-id='" + id + "']";
      }).join(", ");
      if (this.options.enableSelecting === true) {
        this.element.Selecting("selectItems", cssFilter);
      }
      if (pTriggerEvent === true) {
        this._triggerSelect();
      }
    },
    /**
     * @description fire the select event with the needed event data
     * @function
     * @name nixps.DynamicList#_triggerSelect
     * @private
     * @returns {undefined}
     */
    _triggerSelect: function _triggerSelect(pLinkedEvent) {
      var selectedData = null;
      if (this.options.enableSelecting === true) {
        selectedData = this.getSelectedItems();
      } else {
        if (pLinkedEvent !== undefined && pLinkedEvent !== null) {
          selectedData = [$(pLinkedEvent.target).closest(".list_item").data("list_itemdata")];
        }
      }
      var rowObjects = [];
      var ids = [];
      var data = null;
      if (Array.isArray(selectedData)) {
        for (var i = 0; i < selectedData.length; i++) {
          rowObjects.push($.extend(true, {}, selectedData[i]));
          ids.push(selectedData[i][this.options.keyUniqID]);
        }
        if (selectedData.length > 0) {
          data = selectedData[0];
        }
      }
      this._trigger("select", null, {
        ids: ids,
        rowObjects: rowObjects,
        data: data
      });
    },
    /**
     * @description Get all the data of the selected items
     * @name nixps.DynamicList#getSelectedItems
     * @function
     * @returns {Array.<Object>}
     */
    getSelectedItems: function getSelectedItems() {
      if (this.options.enableSelecting === false) {
        return [];
      }
      var dataObjects = [];
      this.element.children(".list_item." + this._getSelectClass()).each(function () {
        dataObjects.push($(this).data("list_itemdata"));
      });
      return dataObjects;
    },
    /**
     * @description Unselect all items
     * @name nixp.DynamicList#unselectAll
     * @function
     * @returns {undefined}
     */
    unselectAll: function unselectAll() {
      this.element.filter(".nixps-Selecting").Selecting("unselectAll");
    },
    /**
     * @description Select all items
     * @name nixp.DynamicList#selectAll
     * @function
     * @returns {undefined}
     */
    selectAll: function selectAll() {
      this.element.filter(".nixps-Selecting").Selecting("selectAll");
    },
    /**
     * @description Clear the list
     * @function
     * @name nixps.DynamicList#clear
     * @returns {undefined}
     */
    clear: function clear() {
      // clear model
      this.dataDict = {};
      // show empty panel
      this.element.children(".list_emptyRowsPanel").show();
      // clear ui
      this.element.children(".list_item").remove();
    },
    /**
     * @description Add a item to the end of the list
     * @function
     * @name nixps.DynamicList#add
     * @param {Object} pData the item as a object
     * @returns {undefined}
     */
    add: function add(pData, pStopSort) {
      var pObject = upgradeToObject(pData, this.options.keyUniqID);
      var item = $("<div>").addClass("list_item").attr("role", "listitem").attr("data-id", pObject[this.options.keyUniqID]).data("list_itemdata", pData);
      // add to model             
      this.dataDict[pObject[this.options.keyUniqID]] = pObject;
      // hide empty panel
      this.element.children(".list_emptyRowsPanel").hide();
      // add to ui
      this.element.append(item);
      item.append(this.options.makeItem(pData, item));
      if (pStopSort !== true) {
        this.sort();
      }
    },
    /**
     * @description Get the number of items in the list
     * @function
     * @name nixps.DynamicList#size
     * @returns {Number} The number of items
     */
    size: function size() {
      return this.element.children(".list_item").length;
    },
    sort: function sort() {
      var that = this;
      if (typeof this.options.sortFunction === "function") {
        var items = that.element.find(".list_item");
        [].sort.call(items, function (a, b) {
          return that.options.sortFunction($(a).data("list_itemdata"), $(b).data("list_itemdata"));
        });
        items.each(function () {
          that.element.append(this);
        });
      }
    },
    /**
     * @description Get all the html elements that represents the child items
     * @function
     * @name nixps.DynamicList#getItems
     * @return {jQueryItems} The child items
     */
    getItems: function getItems() {
      return this.element.children(".list_item");
    },
    /**
     * @description get all the values of the list
     * @function
     * @name nixps.DynamicList#getValue
     * @returns {Array.<Object>} the jsons of the items
     */
    getValue: function getValue() {
      return this.element.children(".list_item").map(function () {
        return $(this).data("list_itemdata");
      }).get();
    },
    /**
     * @description Remove one specific item
     * @function
     * @name nixps.DynamicList#removeItem
     * @param {String} pID The rowid to be removed
     * @param {String} The type of reselected a next item
     * @returns the removed item or false if no row is found
     * @since 1.2.0
     */
    removeItem: function removeItem(pID, pReselectType) {
      var item = this.element.children('.list_item[data-id="' + pID + '"]');
      if (item.length === 1) {
        this.element.children(".list_emptyRowsPanel").toggle(this.element.children(".list_item").length === 1);
        delete this.dataDict[pID];
        this.cursor--;
        if (item.hasClass(this._getSelectClass()) === true && this.element.children(".list_item").length > 1) {
          var removedItem = null;
          if (pReselectType === undefined || pReselectType === "first") {
            removedItem = item.remove();
            this.element.children(".list_item").first().addClass(this._getSelectClass());
            this._triggerSelect();
          } else if (pReselectType === "previous") {
            var candidate = item.prev(".list_item");
            if (candidate.length === 0) {
              candidate = item.next(".list_item");
            }
            removedItem = item.remove();
            if (candidate.length === 1) {
              candidate.addClass(this._getSelectClass());
              this._triggerSelect();
            }
          } else {
            removedItem = item.remove();
            console.error("invalid pReselecttype");
          }
          return removedItem;
        } else {
          return item.remove();
        }
      } else {
        return false;
      }
    },
    updateDOMItem: function updateDOMItem(pID, pNewData, pOptions) {
      var item = this.element.children('.list_item[data-id="' + pID + '"]');
      if (item.length === 1) {
        var oldData = item.data("list_itemdata");
        // update model
        this.dataDict[pID] = pNewData;
        // update ui
        this.options.updateItem(item.data("list_itemdata", pNewData).children(), pNewData, oldData);
      } else if (pOptions !== undefined && pOptions.allow_multiple === true) {
        var that = this;
        item.each(function () {
          var oldData = $(this).data("list_itemdata");
          // update model
          that.dataDict[pID] = pNewData;
          // update ui
          that.options.updateItem($(this).data("list_itemdata", pNewData).children(), pNewData, oldData);
        });
      }
    },
    _triggerUpdateTimer: function _triggerUpdateTimer() {
      if (this.options.updateDelay > 0) {
        var that = this;
        clearTimeout(this.updateTimerID);
        this.updateTimerID = this._delay(function () {
          // first control if component is already removed or not?
          if (this.isDead === true) {
            return true;
          }
          if (this.options.allowToUpdate(this.element) === true) {
            // we may update
            this.update().always(function () {
              // first control if component is already removed or not?
              if (that.isDead === true) {
                return true;
              }
              that._triggerUpdateTimer();
            });
          } else {
            // we may not update, skip and wait your turn!
            this._triggerUpdateTimer();
          }
        }, Device.getPollingFactor(this.uuid) * this.options.updateDelay);
      }
    },
    /**
     * @description We termorary freeze the update mechanisme
     * @function
     * @name nixps.DynamicList#freezeUpdate
     * @returns undefined
     */
    freezeUpdate: function freezeUpdate() {
      if (this.options.updateDelay > 0) {
        clearTimeout(this.updateTimerID);
      }
    },
    /**
     * @description We unfreeze the update mechanisme
     * @function
     * @name nixps.DynamicList#unfreezeUpdate
     * @returns undefined
     */
    unfreezeUpdate: function unfreezeUpdate() {
      this._triggerUpdateTimer();
    },
    /**
     * @description Update the list for one time, if a update is already running, you need to wait your turn,...
     * @function
     * @name nixps.DynamicList#update
     * @return {deferred}
     */
    update: function update() {
      if (this.isBeingUpdating === true) {
        // the item is being updating
        var that = this;
        if (this.stackFull === true) {
          return this.updateDeferred;
        } else {
          this.stackFull = true;
          return this.updateDeferred.then(function () {
            return that._update();
          }, function () {
            return that._update();
          }).always(function () {
            that.stackFull = false;
          });
        }
      }
      return this._update();
    },
    _update: function _update() {
      var that = this;
      this.isBeingUpdating = true; // lock, we are being updating/drawing
      var orderBy = undefined,
        limit = undefined;
      if (typeof this.scrollOverflowing === "boolean") {
        limit = Math.max(this.cursor, this.options.initLimit);
      }
      var data = this.options.dataProvider(undefined, orderBy, 0, limit);
      this.updateDeferred = $.when(data, ++this.callingID).done(function (pItems, pCallingID) {
        // first control if component is already removed or not?
        if (that.isDead === true) {
          return true;
        }
        if (pCallingID !== that.callingID) {
          // prevent overwriting recent data
          return;
        }
        if (Array.isArray(pItems) === false) {
          console.error("items from dataProvider must be a array");
          that._trigger("error", null, {
            error_code: "invalid_data_interface",
            error: "items from dataProvider must be a array"
          });
        } else {
          // first remove old items
          var tempDataDict = Object.assign({}, that.dataDict);
          var key = undefined;
          var pObjects = [];
          for (var i = 0; i < pItems.length; i++) {
            // convert to objects
            pObjects.push(upgradeToObject(pItems[i], that.options.keyUniqID));
            key = pObjects[i][that.options.keyUniqID];
            if (tempDataDict[key] !== undefined) {
              delete tempDataDict[key];
            }
          }
          var selectClass = that._getSelectClass();
          var deadKeys = Object.keys(tempDataDict);
          var selectedDeadKeys = [];
          for (var i = 0; i < deadKeys.length; i++) {
            var removedDOM = that.element.children('[data-id="' + deadKeys[i] + '"]').remove();
            if (that.options.enableSelecting && removedDOM.hasClass(selectClass)) {
              selectedDeadKeys.push(deadKeys[i]);
            }
            delete that.dataDict[deadKeys[i]];
          }
          // now update list
          key = undefined;
          var oldData = undefined;
          for (var i = 0; i < pItems.length; i++) {
            key = pObjects[i][that.options.keyUniqID];
            oldData = that.dataDict[key];
            if (oldData === undefined) {
              // add
              var item = $("<div>").addClass("list_item").attr("role", "listitem").attr("data-id", key).data("list_itemdata", pItems[i]);
              that.dataDict[key] = pObjects[i];
              if (i === 0) {
                that.element.prepend(item);
              } else {
                that.element.children().eq(i - 1).after(item);
              }
              item.append(that.options.makeItem(pItems[i], item));
            } else if (that.options.hasItemChanged(oldData, pObjects[i]) === true) {
              // update model
              that.dataDict[key] = pObjects[i];
              // update ui
              that.options.updateItem(that.element.children('[data-id="' + key + '"]').data("list_itemdata", pItems[i]).children(), pObjects[i], oldData);
            }
          }
          var amountActiveItems = Object.keys(that.dataDict).length;
          that.element.children(".list_emptyRowsPanel").toggle(amountActiveItems === 0);
          that.sort();
          // update model
          that.cursor = amountActiveItems;
          if (typeof that.scrollOverflowing === "boolean") {
            if (amountActiveItems < limit) {
              that._desactivateScrolling();
            } else {
              that._reactiveScrolling();
            }
          }
          // inform we had updated
          that._trigger("update", null, {
            "removedIDs": deadKeys,
            "removedSelectedIDs": selectedDeadKeys,
            "size": amountActiveItems
          });
        }
      }).fail(function (pError) {
        if (pError && pError.expected === true) {
          return;
        }
        console.error(pError);
        var errorData = {};
        if (pError !== undefined && typeof pError.error === "string") {
          errorData = pError;
        } else {
          errorData.error = pError;
        }
        that._trigger("error", null, errorData);
      }).always(function () {
        // we are done with updating and drawing
        that.isBeingUpdating = false;
      });
      return this.updateDeferred;
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.DynamicList#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.DynamicList#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      this.isBeingUpdating = true; // lock, we are being updating/drawing
      // get and set the items
      var orderBy = undefined,
        limit = undefined;
      if (typeof this.scrollOverflowing === "boolean") {
        limit = Math.max(this.cursor, this.options.initLimit);
      }
      var data = this.options.dataProvider(undefined, orderBy, 0, limit);
      this.updateDeferred = $.when(data, ++this.callingID).done(function (pItems, pCallingID) {
        // first control if component is already removed or not?
        if (that.isDead === true) {
          return true;
        }
        if (pCallingID !== that.callingID) {
          // prevent overwriting recent data
          return;
        }
        if (Array.isArray(pItems) === false) {
          console.error("items from dataProvider must be a array");
          that._trigger("error", null, {
            error_code: "invalid_data_interface",
            error: "items from dataProvider must be a array"
          });
        } else {
          // console.time("dynamiclist draw" + that.uuid);
          // make container
          that.element.empty();
          var object = undefined,
            item = undefined;
          for (var i = 0; i < pItems.length; i++) {
            object = upgradeToObject(pItems[i], that.options.keyUniqID);
            item = $("<div>").addClass("list_item").attr("role", "listitem").attr("data-id", object[that.options.keyUniqID]).data("list_itemdata", pItems[i]);
            // add to model             
            that.dataDict[object[that.options.keyUniqID]] = object;
            // add to ui
            that.element.append(item);
            item.append(that.options.makeItem(pItems[i], item));
          }
          that.sort();
          that.element.append($(that.options.emptyRowsPanel).addClass("list_emptyRowsPanel").toggle(pItems.length === 0));
          if (that.scrollOverflowing === true) {
            that.element.append($("<div>").addClass("list_loadingNextPanel").append(that.options.loadingNextRowsPanel));
          }
          // update model
          that.cursor = pItems.length;
          if (typeof that.scrollOverflowing === "boolean") {
            if (pItems.length < limit) {
              that._desactivateScrolling();
            } else {
              that._reactiveScrolling();
            }
          }
          // console.timeEnd("dynamiclist draw" + that.uuid);
          that._trigger("drawed", null, {
            "removedIDs": [],
            "size": pItems.length
          });
        }
      }).fail(function (pError) {
        console.error(pError);
        var errorData = {};
        if (pError !== undefined && typeof pError.error === "string") {
          errorData = pError;
        } else {
          errorData.error = pError;
        }
        that._trigger("error", null, errorData);
      }).always(function () {
        // we are done with updating and drawing
        that.isBeingUpdating = false;
      });
      return this.updateDeferred;
    },
    _getSelectClass: function _getSelectClass() {
      if (this.options.enableSelecting === false) {
        return null;
      }
      if (this.options.selectingOptions !== undefined && typeof this.options.selectingOptions.selectClass === "string") {
        return this.options.selectingOptions.selectClass;
      }
      return "select";
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.DynamicList#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "keyUniqID" && pValue === this.options.keyUniqID) {
        return;
      }
      if (["allowToUpdate", "updateDelay", "initLimit", "scrollBatchLength"].includes(pKey)) {
        // this component will automaticaly working with the good values
        // no redraw needed
        this._superApply(arguments);
        this._controlOptions();
      } else if (pKey === "enableSortable") {
        if (pValue === false && this.options.enableSortable === true) {
          this._superApply(arguments);
          this._controlOptions();
          this.element.filter(".ui-sortable").sortable("destroy");
        } else if (pValue === true && this.options.enableSortable === false) {
          this._superApply(arguments);
          this._controlOptions();
          this.element.sortable({
            containment: "parent",
            axis: "y",
            distance: 7,
            items: ".list_item"
          });
        }
      } else if (pKey === "selectingOptions") {
        this._superApply(arguments);
        if (this.options.enableSelecting === true) {
          this.element.Selecting(Object.assign({}, this.options.selectingOptions, {
            "items": ".list_item:not(.list_item_editing)"
          }));
        }
      } else if (pKey === "enableSelecting") {
        if (this.options.enableSelecting !== pValue) {
          this._superApply(arguments);
          if (this.options.enableSelecting === true) {
            this.element.Selecting(Object.assign({}, this.options.selectingOptions, {
              "items": ".list_item:not(.list_item_editing)"
            }));
          } else {
            this.element.Selecting("destroy");
          }
        }
      } else if (pKey === "scrollElement") {
        if (this.options.scrollElement !== pValue) {
          if (this.scrollElement !== undefined && this.scrollElement !== null) {
            this._off(this.scrollElement, "scroll");
          }
          this._superApply(arguments);
          this._controlOptions();
          if (this.scrollOverflowing === true && this.scrollElement !== null) {
            this.scrollElement = this.options.scrollElement;
            if (this.scrollElement === undefined || this.scrollElement.length === 0) {
              this.scrollElement = this.element;
            }
            this._on(this.scrollElement, {
              "scroll": this._scrollHandler
            });
          }
        }
      } else if (pKey === "lazyLoading") {
        if (this.options.lazyLoading !== pValue) {
          this._superApply(arguments);
          this._controlOptions();
          if (pValue === false) {
            // disable layzy loading 
            this.scrollOverflowing = undefined;
            this._off(this.scrollElement, "scroll");
            this.scrollElement = null;
          } else if (pValue === true) {
            // activate lazy loading
            this.scrollOverflowing = true;
            this.scrollElement = this.options.scrollElement;
            if (this.scrollElement === undefined || this.scrollElement.length === 0) {
              this.scrollElement = this.element;
            }
            this._on(this.scrollElement, {
              "scroll": this._scrollHandler
            });
          }
        }
      } else {
        this._superApply(arguments);
        this._controlOptions();
        var that = this;
        clearTimeout(this.updateTimerID);
        this._draw().done(function () {
          that._triggerUpdateTimer();
        });
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-DynamicList#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.dataProvider !== "function") {
        throw new Error("input option dataProvider must be a function");
      }
      if (typeof this.options.makeItem !== "function") {
        throw new Error("input option makeItem must be a function");
      }
      if (typeof this.options.updateItem !== "function") {
        throw new Error("input option updateItem must be a function");
      }
      if (typeof this.options.hasItemChanged !== "function") {
        throw new Error("input option hasItemChanged must be a function");
      }
      if (typeof this.options.allowToUpdate !== "function") {
        throw new Error("input option allowToUpdate must be a function");
      }
      if (typeof this.options.keyUniqID !== "string" || this.options.keyUniqID.length < 0) {
        throw new Error("input option keyUniqID must be a string");
      }
      if (typeof this.options.updateDelay !== "number") {
        throw new Error("input option updateDelay must be a number");
      }
      if (this.options.updateDelay > 2147483647) {
        throw new Error("input option updateDelay is too big");
      }
      if (typeof this.options.enableSortable !== "boolean") {
        throw new Error("input option enableSortable must be a boolean");
      }
      if (typeof this.options.lazyLoading !== "boolean") {
        throw new Error("input option lazyLoading must be a boolean");
      }
      if (typeof this.options.scrollBatchLength !== "number" || this.options.scrollBatchLength <= 0) {
        throw new Error("input option scrollBatchLength must be a positive number");
      }
      if (typeof this.options.initLimit !== "number" || this.options.initLimit <= 0) {
        throw new Error("input option initLimit must be a positive number");
      }
    },
    /**
     * @description the user want to remove the component, a remove() is called
     * @function
     * @private
     * @name nixps.DynamicList#_desctroy
     * @return {undefined}
     */
    _destroy: function _destroy() {
      // set the flag is dead on true, so updateing function can control and stop polling
      this.isDead = true;
      // clear next pollings
      clearTimeout(this.updateTimerID);
      // stop listening to tab changes
      $(document).off("visibilitychange", this.visibilityHandler);
      if (this.scrollOverflowing === true && this.scrollElement !== null) {
        this._off(this.scrollElement, "scroll");
      }
      this.element.removeAttr("role");
    }
  });
})(jQuery);

},{"../../../cloudflow/PWA/js/Device.js":198,"../../Selectable/js/nixps-Selecting.js":318}],291:[function(require,module,exports){
"use strict";

(function ($) {
  /**
   * @namespace nixps.FileDropUpload
   * @description create a place in the DOM where users can drop a file, the content will be read inline
   * @version 1.3.0
   */
  $.widget("nixps.FileDropUpload", $.Widget, {
    version: "1.3.0",
    widgetEventPrefix: "filedropupload",
    options: {
      /**
       * @brief text enconding be useds
       * @name nixps.FileDropUpload#encoding
       * @type {String}
       * @default "UTF-8"
       */
      encoding: "UTF-8",
      /**
       * @brief extension/file to accepts
       * @name nixps.FileDropUpload#accept
       * @type {String}
       * @default ""
       */
      accept: "",
      /**
       * @brief if you want to use a drop zone
       * @name nixps.FileDropUpload#useDropZone
       * @type {Boolean}
       * @default true
       */
      useDropZone: true,
      /**
       * @description Append the input type files hidden
       * @name nixps.FileDropUpload#_addInputFiles
       * @type {Boolean}
       * @default false
       */
      addInputFiles: false,
      /**
       * @description Must we replace all newlines by semicolons or not
       * @name nixps.FileDropUpload#replaceNewLinesBySemicolon
       * @type {Boolean}
       * @description true
       * @since 1.1.0
       */
      replaceNewLinesBySemicolon: true,
      /**
       * @description Function to call on file upload
       * @name nixps.FileDropUpload#uploadHandler
       * @type {function}
       * @description true
       */
      uploadHandler: undefined,
      /**
       * @description the class name to be added while holding file durring drop
       * @type {String}
       * @default ""
       * @name nixps.FileDropUpload#droppingClass
       * @since 1.2.0
       */
      droppingClass: "",
      /**
       * @description Class to be added when a wrong file has been dropped
       * @type {String}
       * @default ""
       * @name nixps.FileDropUpload#droppingWrongClass
       * @since 1.3.0
       */
      droppingWrongClass: "",
      /**
       * @description element where to add the droppingclass to, it "this" it will be added to this.element
       * @type {Mixed}
       * @default "this"
       * @name nixps.FileDropUpload#informDroppingElement
       * @since 1.2.0
       */
      informDroppingElement: "this"
    },
    _create: function _create() {
      this._addClass(this.widgetFullName);

      // variables
      this.alive = true;
      this.fileDraggingCounter = 0; // counter to trac in child draggings
      this.wrongClassTimeoutID;
      if (this.options.useDropZone) {
        this.element.addClass("fileDropZone");
        if (this.options.addInputFiles === true) {
          $("<input>").attr("type", "file").addClass("fileInput").attr("accept", this.options.accept).attr("disabled", this.options.disabled).hide().appendTo(this.element);
        }
      } else {
        $("<input>").attr("type", "file").addClass("fileInput").attr("accept", this.options.accept).attr("disabled", this.options.disabled).appendTo(this.element);
      }
      if (window.FileReader !== undefined) {
        this._draw();

        // eventhandlers
        if (typeof this.options.droppingClass === "string" && this.options.droppingClass.length > 0) {
          this._on(this.element, {
            "dragenter": this._dragEnterHandler,
            "dragleave": this._dragLeaveHandler,
            "dragend": this._dragEndHandler
          });
        }
        this._on(this.element, {
          "dragover": this._dragOverHandler,
          "drop": this._dropHandler,
          "change .fileInput": this._changeHandler
        });
      } else {
        console.error("FileReader not supported by browser");
      }
    },
    /**
     * @description function runs when user enters the area
     * @function
     * @private
     * @name nixps.FileDropUpload#_dragEnterHandler
     * @param {Object} pEvent 
     */
    _dragEnterHandler: function _dragEnterHandler(pEvent) {
      if (this.options.disabled === true) {
        return;
      }
      pEvent.preventDefault();
      pEvent.stopPropagation();
      this.fileDraggingCounter++;
      if (this.fileDraggingCounter === 1) {
        this._addDroppingClass();
      }
    },
    /**
     * @description function runs when user leaves the area
     * @function
     * @private
     * @name nixps.FileDropUpload#_dragLeaveHandler
     * @param {Object} pEvent 
     */
    _dragLeaveHandler: function _dragLeaveHandler(pEvent) {
      pEvent.preventDefault();
      pEvent.stopPropagation();
      this.fileDraggingCounter--;
      if (this.fileDraggingCounter <= 0) {
        this._removeDroppingClass();
      }
    },
    /**
     * @description function runs when user stops dropping
     * @function
     * @private
     * @name nixps.FileDropUpload#_dragEndHandler
     * @param {Object} pEvent 
     */
    _dragEndHandler: function _dragEndHandler(pEvent) {
      if (this.options.disabled === true) {
        return;
      }
      pEvent.preventDefault();
      pEvent.stopPropagation();
    },
    /**
     * @description Handlers runs when user want to drop a file
     * @function
     * @name nixps.FileDropUpload#_dragOverHandler
     * @param {Object} pEvent
     * @returns {undefined}
     */
    _dragOverHandler: function _dragOverHandler(pEvent) {
      if (this.options.disabled === true) {
        return;
      }
      pEvent.stopPropagation();
      pEvent.preventDefault();
      pEvent.originalEvent.dataTransfer.dropEffect = "copy"; // Explicitly show this is a copy.
    },

    /**
     * @brief handler fires when user drop file
     * @function
     * @name nixps.FileDropUpload#_dropHandler
     * @private
     * @param {Object} pEvent
     * @param {data} pData
     * @returns {undefined}
     */
    _dropHandler: function _dropHandler(pEvent, pData) {
      if (this.options.disabled === true) {
        return;
      }
      pEvent.stopPropagation();
      pEvent.preventDefault();
      var files = pEvent.originalEvent.dataTransfer.files;
      if (typeof this.options.accept === "string" && this.options.accept.length > 0 && this.options.accept[0] === ".") {
        var acceptedExtentions = this.options.accept.split(",");
        var filteredFiles = [];
        for (var i = 0; i < files.length; i++) {
          if (typeof files[i].name === "string" && acceptedExtentions.some(function (e) {
            return files[i].name.endsWith(e);
          })) {
            filteredFiles.push(files[i]);
          }
        }
        if (filteredFiles.length === 0 && files.length > 0) {
          this._trigger("rejected", null, {
            name: files[0].name,
            type: files[0].type
          });
          this._removeDroppingClass(true);
          return;
        }
      }
      this._removeDroppingClass();
      if (typeof this.options.uploadHandler === "function") {
        this.options.uploadHandler(files);
      } else {
        this._loadFiles(files);
      }
    },
    /**
     * @description Handlers runs when user select a file
     * @function
     * @private
     * @name nixps.FileDropUpload#_changeHandler
     * @param {Object} pEvent
     * @param {data} pData
     * @returns {undefined}
     */
    _changeHandler: function _changeHandler(pEvent, pData) {
      if (typeof this.options.uploadHandler === "function") {
        this.options.uploadHandler(pEvent.currentTarget.files);
      } else {
        this._loadFiles(pEvent.currentTarget.files);
      }
      // be able to opload a same file twice after each other
      $(pEvent.target)[0].value = "";
      $(pEvent.target).replaceWith($(pEvent.target).clone(true));
    },
    _loadFiles: function _loadFiles(pFiles) {
      var that = this;
      for (var i = 0; i < pFiles.length; i++) {
        if (typeof this.options.accept === "string" && this.options.accept.length > 0 && this.options.accept[0] === ".") {
          var acceptedExtentions = this.options.accept.split(",");
          if (typeof pFiles[i].name === "string" && acceptedExtentions.every(function (e) {
            return !pFiles[i].name.endsWith(e);
          })) {
            this._trigger("rejected", null, {
              name: pFiles[i].name,
              type: pFiles[i].type
            });
            continue;
          }
        }
        (function (file) {
          var reader = new FileReader();
          reader.onload = function (e) {
            var data = e.target.result;
            if (that.options.replaceNewLinesBySemicolon === true) {
              data = data.replace(/\r|\n/g, ";");
            }
            that._trigger("uploaded", null, {
              name: file.name,
              type: file.type,
              data: data
            });
          };
          reader.onerror = function (e) {
            console.error("file " + file.name + " failed during upload", reader.error);
          };
          reader.onabort = function (e) {
            console.warn("file " + file.name + " aborted");
          };
          reader.readAsText(file, that.options.encoding);
        })(pFiles[i]);
      }
    },
    /**
     * @description add dropping classes
     * @function
     * @private
     * @name nixps.FileDropUpload#_addDroppingClass
     */
    _addDroppingClass: function _addDroppingClass() {
      var informElement;
      if (this.options.informDroppingElement === "this") {
        informElement = this.element;
      } else {
        informElement = $(this.options.informDroppingElement);
      }
      informElement.addClass(this.options.droppingClass).removeClass(this.options.droppingWrongClass);
      clearTimeout(this.wrongClassTimeoutID);
    },
    /**
     * @description remove dropping classes
     * @function
     * @private
     * @name nixps.FileDropUpload#_removeDroppingClass
     */
    _removeDroppingClass: function _removeDroppingClass(pIsWrongType) {
      this.fileDraggingCounter = 0;
      if (typeof this.options.droppingClass === "string" && this.options.droppingClass.length > 0) {
        var informElement;
        if (this.options.informDroppingElement === "this") {
          informElement = this.element;
        } else {
          informElement = $(this.options.informDroppingElement);
        }
        if (pIsWrongType === true && typeof this.options.droppingWrongClass === "string" && this.options.droppingWrongClass.length > 0) {
          informElement.removeClass(this.options.droppingClass).addClass(this.options.droppingWrongClass);
          clearTimeout(this.wrongClassTimeoutID);
          this.wrongClassTimeoutID = this._delay(function () {
            if (this.alive === false) {
              return;
            }
            informElement.removeClass(this.options.droppingWrongClass);
          }, 10);
        } else {
          informElement.removeClass(this.options.droppingClass);
        }
      }
    },
    /**
     * @brief redraw
     * @name nixps.FileDropUpload#redraw
     * @function
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
    * @brief draw the image
    * @name nixps.FileDropUpload#_draw
    * @fucntion
    * @private
    */
    _draw: function _draw() {},
    /**
     * @description Open the dialog to select a file
     * @function
     * @name nixps-FileDropUpload#openInputDialog
     * @return {undefined}
     */
    openInputDialog: function openInputDialog() {
      this.element.children("input").trigger("click");
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      switch (pKey) {
        case "addInputFiles":
          if (pValue === true) {
            if (this.element.children("input").length === 0) {
              $("<input>").attr("type", "file").addClass("fileInput").attr("accept", this.options.accept).hide().appendTo(this.element);
            }
          }
          break;
        case "useDropZone":
        case "encoding":
        case "replaceNewLinesBySemicolon":
        case "disabled":
          break;
        case "accept":
          if (typeof pValue === "string") {
            this.element.find(".fileInput").attr("accept", pValue);
          } else {
            throw new Error("options: wrong pValue");
          }
          break;
        default:
          throw new Error("Unknown option in " + this.widgetFullName);
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      clearTimeout(this.wrongClassTimeoutID);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],292:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery, Spinner*/
(function ($) {
  /**
  * @version 1.4.0
  * @namespace nixps.FreezeOverlay
  * @description This component add a panel with a waiting icon to force users to wait. When the panel is visible,
  * the user can do nothing. You need to call "show" to show and start the animation, call "hide" to hide the panel.
  * You need to include <xmp>
  *  <link type='text/css' href='/common/FreezeOverlay/css/nixps-FreezeOverlay.css' rel="stylesheet">
  *  <script type='text/javascript' src='/common/FreezeOverlay/js/nixps-FreezeOverlay.js'></script>
  *    </xmp>
  * @example $('#freezeOverlay').FreezeOverlay({text: "wait we are processiong data"}).FreezeOverlay('show');
  */
  $.widget("nixps.FreezeOverlay", {
    widgetEventPrefix: "freezeoverlay",
    version: "1.4.0",
    options: {
      /**
       * @name nixps.FreezeOverlay#text
       * @desc The waiting text to show when running
       * @type {String}
       * @default null
       */
      text: null,
      /**
       * @name nixps.FreezeOverlay#type
       * @description The type of waiting animation. You can choose between "cloud", "spinner", "none" or "custom"
       * @type {String}
       * @default "cloud"
       */
      type: "cloud",
      /**
       * @name nixps.FreezeOverlay#backgroundOpacity
       * @description Define the opacity of the background of the waiting.
       * This must be a number between 0 and 1
       * @type {Number}
       * @default null
       * @since 1.3.0
       */
      backgroundOpacity: null,
      /**
       * @name nixps.FreezeOverlay#customImageOptions
       * @description The options to be given to the custom image
       * @type {Object}
       * @default {}
       * @since 1.3.0
       */
      customImageOptions: {},
      /**
       * @name nixps.FreezeOverlay#relativeBasePath
       * @description The relative base path of the data file
       * @type {String}
       * @default ""
      */
      relativeBasePath: "",
      /**
       * @name nixps.FreezeOverlay#useFlex
       * @description Use the more advanced techniques of css flex
       * @type {Boolean}
       * @default false
       * @since 1.1.0
       */
      useFlex: false,
      /**
       * @name nixps.FreezeOverlay#maxWidthText
       * @description the max with of the text
       * @type {Number}
       * @default 100
       * @since 1.4.0
       */
      maxWidthText: 100,
      /**
       * @name nixps.FreezeOverlay#show
       * @description Show or hide the FreezeOverlay
       * @default false
       * @type {Boolean}
       * @since 1.2.0
       */
      show: false
    },
    /**
     * @brief constructor
     * @private
     * @function
     * @name nixps.FreezeOverlay#_create
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);

      // skeleton
      this.element.prepend($("<div>").addClass("spaceTopBar").hide());
      this.element.append($("<div>").addClass("freezeoverlay_animation"));
      this.element.append($("<div>").addClass("waitText cf-freezeOverlay-waitText"));
      if (typeof this.options.text === "string" && this.options.text.length !== 0) {
        this.element.children(".waitText").css({
          "max-width": this.options.maxWidthText,
          "text-align": "center"
        }).text(this.options.text);
      } else if (this.options.text instanceof jQuery) {
        this.element.children(".waitText").css({
          position: "absolute",
          "max-width": this.options.maxWidthText,
          "text-align": "center"
        }).html(this.options.text);
      }
      if (this.options.type === "cloud") {
        this._addCloudAnimation();
      } else if (this.options.type === "spinner") {
        this._addSpinnerAnimation();
      } else if (this.options.type === "none") {
        this._addNoneAnimation();
      } else if (this.options.type === "custom") {
        this._addCustomAnimation();
      } else if (this.options.type.indexOf("cf-animation") === 0) {
        this._addCSSAnimation();
      } else {
        console.error("unknown type of waiting annimation");
        this._addCloudAnimation();
      }
      if (typeof this.options.backgroundOpacity === "number" && this.options.backgroundOpacity >= 0 && this.options.backgroundOpacity <= 1) {
        this.element.css("backgroundColor", "rgba(255,255,255," + this.options.backgroundOpacity + ")");
      }
      this._draw();
      if (this.options.show === true) {
        this.show();
      } else {
        this.hide();
      }
    },
    _addSpinnerAnimation: function _addSpinnerAnimation() {
      if (typeof Spinner !== "function") {
        // fallback in case the 3rdParty is not present
        this._addCloudAnimation();
        return;
      }
      this.element.addClass("modeSpinner").removeClass("modeCloud").removeClass("modeCustom").removeClass("modeNone");
      this.element.children(".freezeoverlay_animation").empty();
      var color = this.element.css("color");
      if (typeof color !== "string" || color.length === 0) {
        color = "#ffffff";
      }

      // create the spinner on the freeze panel
      var options = {
        lines: 17,
        // The number of lines to draw
        length: 0,
        // The length of each line
        width: 16,
        // The line thickness
        radius: 60,
        // The radius of the inner circle
        corners: 1,
        // Corner roundness (0..1)
        rotate: 0,
        // The rotation offset
        direction: 1,
        // 1: clockwise, -1: counterclockwise
        color: color,
        // #rgb or #rrggbb
        speed: 1.2,
        // Rounds per second
        trail: 32,
        // Afterglow percentage
        shadow: false,
        // Whether to render a shadow
        hwaccel: false,
        // Whether to use hardware acceleration
        className: "spinner",
        // The CSS class to assign to the spinner
        zIndex: 2e9,
        // The z-index (defaults to 2000000000)
        top: "auto",
        // Top position relative to parent in px
        left: "auto" // Left position relative to parent in px
      };

      this.spinner = new Spinner(options).spin(this.element[0]);
    },
    _addCloudAnimation: function _addCloudAnimation() {
      this.element.addClass("modeCloud").removeClass("modeSpinner modeCustom modeNone modeCSS");
      this.element.children(".spinner").remove();
      this.element.children(".freezeoverlay_animation").empty().prepend($("<img>").attr("src", "/common/FreezeOverlay/css/loading-cloudflow.gif").addClass("cloudwaitingAnnimation"));
      if (this.options.useFlex === true) {
        this.element.addClass("flexMode").children(".spaceTopBar").css("display", "");
      }
    },
    _addCustomAnimation: function _addCustomAnimation() {
      this.element.addClass("modeCustom").removeClass("modeCloud modeSpinner modeNone modeCSS");
      this.element.children(".spinner").remove();
      this.element.children(".freezeoverlay_animation").empty();
      var img = $("<div>");
      this.element.children(".freezeoverlay_animation").append(img);
      var imageOptions = $.extend({}, this.options.customImageOptions, {
        relativeBasePath: this.options.relativeBasePath
      });
      img.Image(imageOptions);
      if (this.options.useFlex === true) {
        this.element.addClass("flexMode").children(".spaceTopBar").css("display", "");
      }
    },
    _addNoneAnimation: function _addNoneAnimation() {
      this.element.addClass("modeNone").removeClass("modeCloud modeCustom modeSpinner modeCSS");
      this.element.children(".spinner").remove();
      this.element.children(".freezeoverlay_animation").empty();
      if (this.options.useFlex === true) {
        this.element.addClass("flexMode").children(".spaceTopBar").css("display", "");
      }
    },
    _addCSSAnimation: function _addCSSAnimation() {
      this.element.addClass("modeCSS").removeClass("modeCloud modeCustom modeSpinner modeNone");
      this.element.children(".spinner").remove();
      this.element.children(".freezeoverlay_animation").empty().append($("<div>").addClass(this.options.type).css("width", 50).css("height", 50).css("marginBottom", 7));
      if (this.options.useFlex === true) {
        this.element.addClass("flexMode").children(".spaceTopBar").css("display", "");
      }
    },
    /**
     * @name nixps.FreezeOverlay#show
     * @function
     * @description Shows and redraws the freeze panel
     * @example $("#freezeOverlay").FreezeOverlay("show");
     * @param {Object} pDisplayOptions options to display
     * @param {Object} pValueToReturn object to pass through, for pagebuilder actions
     * @since 1.0.0
     * @returns {mixed} if the pValueToReturn parameter is not defined it returns this element, otherwise the value pValueToReturn
     */
    show: function show(pDisplayOptions, pValueToReturn) {
      if (pDisplayOptions !== undefined) {
        if (typeof pDisplayOptions.text === "string") {
          this._setOption("text", pDisplayOptions.text);
        }
        if (typeof pDisplayOptions.type === "string") {
          if (pDisplayOptions.type === "custom") {
            //need to set the imageOptions first!
            var customImageOptions = Object.assign(pDisplayOptions.customImageOptions, {
              "float": "center",
              width: "100%",
              height: "100%",
              maxWidth: "50vw",
              maxHeight: "50vh"
            });
            this._setOption("customImageOptions", customImageOptions);
          }
          this._setOption("type", pDisplayOptions.type);
        }
      }
      if (this.options.useFlex === true) {
        this.element.css("display", "");
      } else {
        this.element.show();
        this._draw();
      }
      // if pValueToReturn undefined, then this is also the fallback
      return pValueToReturn;
    },
    /**
     * @name nixps.FreezeOverlay#hide
     * @function
     * @description Hides the freeze panel
     * @example $("#freezeOverlay").FreezeOverlay("hide");
     * @param {Object} pDisplayOptions options to display
     * @param {Object} pValueToReturn object to pass through, for pagebuilder actions
     * @since 1.0.0
     * @returns {mixed} if the pValueToReturn parameter is not defined it returns this element, otherwise the value pValueToReturn
     */
    hide: function hide(pDisplayOptions, pValueToReturn) {
      this.element.hide();
      if (pDisplayOptions !== undefined) {
        if (typeof pDisplayOptions.text === "string") {
          this._setOption("text", pDisplayOptions.text);
        }
        if (typeof pDisplayOptions.type === "string") {
          this._setOption("type", pDisplayOptions.type);
        }
      }
      // if pValueToReturn undefined, then this is alos the fallback
      return pValueToReturn;
    },
    /**
     * @name nixps.FreezeOverlay#redraw
     * @function
     * @description Redraws the widget
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @name nixps.FreezeOverlay#_draw
     * @function
     * @description draws the widget
     * @private
     */
    _draw: function _draw() {
      if (this.element.hasClass("modeCloud")) {
        this._drawCloud();
      } else if (this.element.hasClass("modeNone") || this.element.hasClass("modeCSS") || this.element.hasClass("modeCustom")) {
        this._drawNone();
      } else {
        this._drawSpinner();
      }
    },
    _drawSpinner: function _drawSpinner() {
      this.element.children(".waitText").position({
        my: "center",
        at: "center",
        of: this.element
      });
      this.element.children(".spinner").position({
        my: "center",
        at: "center",
        of: this.element
      });
    },
    _drawCloud: function _drawCloud() {
      if (this.options.useFlex === true) {
        return;
      }
      this.element.children(".freezeoverlay_animation").position({
        my: "center",
        at: "center top+25%",
        of: this.element
      });
      this.element.children(".waitText").position({
        my: "center top",
        at: "center bottom",
        of: this.element.find(".freezeoverlay_animation")
      });
    },
    _drawNone: function _drawNone() {
      if (this.options.useFlex === true) {
        return;
      }
      this.element.children(".waitText").position({
        my: "center",
        at: "center top+25%",
        of: this.element
      });
    },
    _setOption: function _setOption(key, value) {
      if (key === "text") {
        if (typeof value === "string" && this.options.text !== value) {
          // do only things if changed
          this._super(key, value);
          this.element.children(".waitText").text(value);
        }
      } else if (key === "show") {
        if (this.options.show !== value) {
          // do only if changed
          this._super(key, value);
          if (this.options.show === true) {
            this.show();
          } else {
            this.hide();
          }
        }
      } else if (key === "type") {
        if (this.options.type !== value || this.options.type === "custom") {
          //for a custom type, always redraw -> imageoptions could have changed
          this._super(key, value);
          if (this.options.type === "cloud") {
            this._addCloudAnimation();
          } else if (this.options.type === "spinner") {
            this._addSpinnerAnimation();
          } else if (this.options.type === "none") {
            this._addNoneAnimation();
          } else if (this.options.type === "custom") {
            this._addCustomAnimation();
          } else if (this.options.type.indexOf("cf-animation") === 0) {
            this._addCSSAnimation();
          } else {
            console.error("unknown type of waiting annimation");
            this._addSpinnerAnimation();
          }
          this._draw();
        }
      } else if (key === "backgroundOpacity") {
        if (value !== this.options.backgroundOpacity) {
          this._super(key, value);
          this.element.css("backgroundColor", "");
          if (typeof this.options.backgroundOpacity === "number" && this.options.backgroundOpacity >= 0 && this.options.backgroundOpacity <= 1) {
            this.element.css("backgroundColor", "rgba(255,255,255," + this.options.backgroundOpacity + ")");
          }
        }
      } else if (key === "useFlex") {
        if (value !== this.options.useFlex) {
          this._super(key, value);
          if (this.options.useFlex === true) {
            this.element.addClass("flexMode").children(".spaceTopBar").css("display", "");
          } else {
            this.element.removeClass("flexMode").children(".spaceTopBar").hide();
          }
        }
      } else if (key === "customImageOptions") {
        if (_typeof(this.options.customImageOptions) === "object" && this.options.customImageOptions.url !== value.url) {
          this._super(key, value);
        } else if (_typeof(this.options.customImageOptions) !== "object") {
          console.error("FreezeOverlay: customImageOptions must be an object");
        }
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("modeCustom modeCloud modeSpinner modeNone");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],293:[function(require,module,exports){
"use strict";

(function ($) {
  /**
   * @namespace nixps.MobileDialog
   * @description Show a dialog with extra interactions
   * @example $("<div>").MobileDialog({});
   * @version 1.0.0
   */
  $.widget("nixps.MobileDialog", $.ui.dialog, {
    widgetEventPrefix: "dialog",
    options: {
      closeText: "",
      /**
       * @name nixps.MobileDialog#fallBackHeight
       * @description The default height used as fallback
       * @type {Number}
       * @default 800
       */
      fallBackHeight: 800,
      /**
       * @name nixps.MobileDialog#marginWidth
       * @description the extra space in case of mobile
       * @type {Number}
       * @default 5
       */
      marginWidth: 5,
      /**
       * @name nixps.MobileDialog#created
       * @description Callback function runs when dialog is done drawing
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.MobileDialog#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._rematchDimentions();
      this._superApply(arguments);
      this.options.created();
    },
    _rematchDimentions: function _rematchDimentions() {
      var vwWidth = $(window).width();
      var vwHeight = $(window).height();
      if (typeof this.options.width === "string" && this.options.width.length > 0) {
        var width = this.options.width.trim();
        // if is percentage
        if (width[width.length - 1] === "%") {
          if (typeof vwWidth !== "number" || vwWidth <= 0) {
            // fallback
            vwWidth = 800;
            console.warn("we could not define the current width of the window");
          }
          this.options.width = vwWidth * parseFloat(width) / 100;
        } else {
          this.options.width = parseFloat(width);
        }
      }
      if (typeof this.options.width === "number" && this.options.width > vwWidth) {
        // make dialog smaller is screen is smaller
        this.options.width = vwWidth - this.options.marginWidth;
      }
      if (this.options.height === "auto") {
        // continue
        return;
      } else if (typeof this.options.height === "string" && this.options.height.length > 0) {
        var height = this.options.height.trim();
        // if is percentage
        if (height[height.length - 1] === "%") {
          if (typeof vwHeight !== "number" || vwHeight <= 0) {
            // fallback
            vwHeight = this.options.fallBackHeight;
            console.warn("we could not define the current height of the window");
          }
          this.options.height = vwHeight * parseFloat(height) / 100;
        } else {
          this.options.height = parseFloat(height);
        }
      }
      if (typeof this.options.height === "number" && this.options.height > vwHeight) {
        // make dialog smaller is screen is smaller
        this.options.height = vwHeight;
      }
      if (isFinite(this.options.height) === false || this.options.height <= 0) {
        // the value is wrong, fall back to default 
        this.options.height = "auto";
      }
    },
    _show: function _show() {
      this._superApply(arguments);
      if (this.options.modal === true) {
        $("body").addClass("cf-noscroll");
      }
      // first time it opens, then we have a position on the DOM
      if (this.options.height === "auto" && this.options.maxHeight === null) {
        // #59308 keep in mind that the body has a scroll, 
        // so we need the visually hiehgt to the top of the screen excliding the scoll top
        if (this.uiDialog && this.uiDialog[0] && this.uiDialog[0].getBoundingClientRect) {
          var screenTop = this.uiDialog[0].getBoundingClientRect();
          var maxHeight = $(window).height() - screenTop.top;
          // prevent adding negative max heights
          if (typeof maxHeight === "number" && maxHeight > 50) {
            this.option("maxHeight", maxHeight);
          }
        }
      }
    },
    _hide: function _hide() {
      this._superApply(arguments);
      if (this.options.modal === true) {
        $("body").removeClass("cf-noscroll");
      }
    }
  });
})(jQuery);

},{}],294:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

(function ($) {
  require("../../../common/js/nixps-common-Languages.js");

  /**
   * @namespace nixps.LanguageSelector
   * @description A selector with all the languages
   */
  $.widget("nixps.LanguageSelector", {
    widgetEventPrefix: "languageselector",
    options: {
      /**
       * @name nixps.LanguageSelector#name
       * @brief the attribute of name
       * @type {String}
       * @default "language"
       */
      name: "language",
      /**
       * @description the value (language code) to be selected
       * @name nixps.LanguageSelector#value
       * @type {String}
       * @default "en" 
       */
      value: "en",
      /**
       * @brief if an array of iso codes is passed, choices are filtered according to array
       * @name nixps.LanguageSelector#filter
       */
      filter: false,
      /**
       * @name nixps.LanguageSelector#addOptionAll
       * @description add the option of all languages
       * @type {Boolean}
       * @description false
       */
      addOptionAll: false,
      /**
       * @name nixps.LanguageSelector#nativeLanguage
       * @desc Must we show the language label in that specifie language?
       * if true the language will be show in that language, if false the names will be show in english
       * @type {Boolean}
       * @default true
       **/
      nativeLanguage: true,
      /**
       * @name nixps.LanguageSelector#classes
       * @description String to be added as class
       * @type {String}
       * @default ""
       */
      classes: "",
      /**
       * @name nixps.LanguageSelector#id
       * @description The id to be applied on the select element
       * @type {String}
       * @default undefined
       */
      id: undefined
    },
    /** 
     * @brief creates the editor component
     * @name nixps.LanguageSelector#create
     * @function
     * @private
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      var selector = $("<select>").attr("name", this.options.name).addClass(this.options.classes);
      this.element.append(selector);
      if (typeof this.options.id === "string" && this.options.id.length > 0) {
        selector.attr("id", this.options.id);
      }
      if (this.options.addOptionAll === true) {
        selector.append("<option value=''>" + $.i18n._("nixps-cloudflow-preferences.international.all_languages") + "</option>");
      }
      var doFilter = Array.isArray(this.options.filter);
      var that = this;
      for (var iso in nixps.common.isoLangs) {
        var languageLabel;
        if (that.options.nativeLanguage === true && typeof nixps.common.isoLangs[iso].nativeName === "string" && nixps.common.isoLangs[iso].nativeName.length > 0) {
          languageLabel = nixps.common.isoLangs[iso].nativeName;
        } else {
          languageLabel = nixps.common.isoLangs[iso].name;
        }
        if (doFilter) {
          if (this.options.filter.indexOf(iso) >= 0) {
            selector.append("<option value='" + iso + "'>" + languageLabel + "</option>");
          }
        } else {
          selector.append("<option value='" + iso + "'>" + languageLabel + "</option>");
        }
      }
      selector.val(this.options.value);
      selector.prop("disabled", this.options.disabled === true);
      this._on(selector, {
        "change": this._selectionChangedHandler
      });
    },
    /**
     * @brief handle language selector changes
     * @function
     * @private
     * @name nixps.LanguageSelector#create
     */
    _selectionChangedHandler: function _selectionChangedHandler(e) {
      var newValue = this.element.find("select").val();
      if (this.options.value !== newValue) {
        this.options.value = newValue;
        this._trigger("change", e, {
          value: newValue
        });
      }
    },
    getValue: function getValue() {
      return this.element.find("select").val();
    },
    setValue: function setValue(pLanguageCode) {
      this.option("value", pLanguageCode);
    },
    disable: function disable() {
      return this._setOption("disabled", true);
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "value") {
        this._super(pKey, pValue);
        if (this.element.children("select").children("option[value='" + pValue + "']").length === 0) {
          // add default value if value is not there
          this.element.children("select").append("<option value='" + pValue + "'>(" + pValue + ")</option>");
        }
        this.element.children("select").val(pValue);
        return;
      }
      if (pKey === "disabled") {
        if (this.options.disabled !== pValue) {
          this._super(pKey, pValue);
          this.element.children("select").prop("disabled", this.options.disabled === true);
        }
        return;
      }
      this._super(pKey, pValue);
    }
  });
})(jQuery);

},{"../../../common/js/nixps-common-Languages.js":390}],295:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*
 * 
 *   created by guillaume on Jun 5, 2019
 */
(function ($) {
  /**
   * @namespace nixps.Link
   * @description Draw a link. This is a pagebuilder component. This is used because pagebuilder requires a specific interface for components
   * Do not use it outside pagebuilder!!
   * @version 1.2.0
   */
  $.widget("nixps.Link", $.Widget, {
    version: "1.2.0",
    options: {
      /**
       * @name nixps.Link#url
       * @description The url of the link
       * @type {String}
       * @default ""
       */
      url: "",
      /**
       * @name nixps.Link#target
       * @description The target of the link
       * @type {String}
       * @default ""
       */
      target: null,
      /**
       * @name nixps.Link#content
       * @description The name of the download filename
       * @type {String}
       * @default null
       */
      download: null,
      /**
       * @name nixps.Link#content
       * @description The content inside the link
       * @type {Mixed}
       * @default ""
       */
      content: "",
      /**
       * @name nixps.Link#float
       * @description How must we position the text. Must we center the text or place at the left side.
       * This string will be used as value for the css text-align value
       * @type {String}
       * @default null
       * @since 1.1.0
       */
      "float": null,
      /**
       * @name nixps.Link#classes
       * @description The style classes added to the link
       * @type {String}
       * @default ""
       */
      classes: "",
      /**
       * @name nixps.Link#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       */
      style_type: "default",
      /**
       * @name nixps.Link#paddingStyle
       * @description what kind of padding do you want?
       * @type {String}
       * @default undefined
       */
      paddingStyle: undefined,
      /**
       * @name nixps.Link#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    /**
     * @description create the component
     * @name nixps.Link#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type);
      this._draw();
      this.options.created();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.Link#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var link = $("<a>").attr("href", this.options.url).addClass(this.options.classes);
      if (this.options.content === undefined || this.options.content === null || this.options.content === "") {
        link.text(this.options.url);
      } else if (["string", "number", "boolean"].includes(_typeof(this.options.content))) {
        link.text(this.options.content);
      } else if ($.isPlainObject(this.options.content)) {
        if (this.options.content.type === "text") {
          if (typeof this.options.content.options !== "string" || this.options.content.options.length <= 0) {
            this.options.content.options = this.options.url;
          }
        } else if ($.isPlainObject(this.options.content.options) === false) {
          this.options.content.options = {};
        }
        var content = $("<span>");
        link.append(content);
        content[this.options.content.type](this.options.content.options);
      }
      if (typeof this.options.paddingStyle === "string" && this.options.paddingStyle.length > 0) {
        if (this.options.paddingStyle === "basic") {
          link.addClass("cf-tabsection");
        } else {
          link.addClass("cf-tabsection-" + this.options.paddingStyle);
        }
      }
      this.element.empty().append(link);
      if (typeof this.options.target === "string" && this.options.target.length > 0 && this.options.target !== "null") {
        link.attr("target", this.options.target);
        if (this.options.target !== "_self") {
          // link.append($('<span>').addClass('fa fa-external-link'));
        }
      }
      if (typeof this.options.download === "string" && this.options.download.length > 0) {
        link.attr("download", this.options.download);
      }
      if (typeof this.options["float"] === "string" && this.options["float"].length > 0) {
        this.element.css("text-align", this.options["float"]);
      } else {
        this.element.css("text-align", "");
      }
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps.Link#_setOptions
     */
    _setOptions: function _setOptions(pOptions) {
      if (typeof pOptions.style_type === "string") {
        this.element.removeClass("CloudflowStyle_" + this.options.style_type).addClass("CloudflowStyle_" + pOptions.style_type);
      }
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.style_type !== "string" || this.options.style_type.length <= 0) {
        throw new Error("Link: input option style_type must be a not empty string");
      }
      if (typeof this.options["float"] !== "string" && this.options["float"] !== null) {
        throw new Error("Link: input option float must be a string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("CloudflowStyle_" + this.options.style_type);
      this.element.css("text-align", "");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],296:[function(require,module,exports){
"use strict";

/* 
 * 
 *   created by guillaume on Jan 2023
 */
(function ($) {
  "use strict";

  var TouchUtil = require("../../Touch/js/TouchUtil.js");
  var kMinTouchDistance = 8;

  /**
   * @namespace nixps.MobileSlidePanel
   * @description An vertical slider for mobile
   * @example $('<div>').MobileSlidePanel({});
   * @version 1.0.0
   */
  $.widget("nixps.MobileSlidePanel", $.Widget, {
    version: "1.0.0",
    options: {
      /**
       * @description the openState it must have when creating
       * @name nixps-MobileSlidePanel#openStateOnStart
       * @type {String}
       * @default undefined
       */
      openStateOnStart: undefined,
      /**
       * @description Must we blur when a closing the panel
       * @name nixps-MobileSlidePanel#blurOnClose
       * @type {Boolean}
       * @default true
       */
      blurOnClose: true,
      /**
       * @description The height when the panel is half open
       * @name nixps-MobileSlidePanel#heightCSSWhenOpen
       * @type {String}
       * @default "50%"
       */
      heightCSSWhenOpen: "50%",
      /**
       * @description The DOM of the parent
       * @name nixps-MobileSlidePanel#parentDOM
       * @type {mixed}
       * @default $(window)
       */
      parentDOM: undefined,
      /**
       * @description The jquery link to an olverlay DOM
       * @name nixps-MobileSlidePanel#overlayDOM
       * @type {jQuery}
       * @default undefined
       */
      overlayDOM: undefined,
      /**
       * @description function runs when the panel has bee drawn and ready for interaction
       * @name nixps-MobileSlidePanel#created
       * @type {Function}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.MobileSlidePanel#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("cf-slidepanel-mobile").attr("data-mobilesliderpanel-uuid", this.uuid);

      // variables
      this.startTouchX; // start pageX, amount pixels touch horizontal
      this.startTouchY; // start pageY, amount pixels touch vertical
      this.startHeight; // start height in pixels of the panel
      this.openState = null; // the stat of the slidepanel
      this.parentDOM;
      if (this.options.parentDOM instanceof jQuery) {
        this.parentDOM = this.options.parentDOM;
      } else {
        this.parentDOM = $(window);
      }
      this._on(this.element, {
        "touchstart": this._touchStartHandler,
        "touchmove": this._touchMoveHandler,
        "touchend": this._touchEndHandler,
        "touchcancel": this._touchCancelHandler,
        "click .cf-slidepanel-closebutton": this._closeClickHandler,
        "transitionend": this._transitionEndHandler
      });
      this.overlayDOM;
      if (this.options.overlayDOM instanceof jQuery) {
        this.overlayDOM = this.options.overlayDOM;
      }
      if (this.overlayDOM !== undefined) {
        this._on(this.overlayDOM, {
          "click": this._overlayClickHandler
        });
      }
      this._draw();
      switch (this.options.openStateOnStart) {
        case "open":
        case "open-half":
          this._open("creation");
          this._trigger("change", null, {
            openState: "open-half",
            reasonID: "creation"
          });
          break;
        case "open-max":
        case "open-maximum":
        case "max":
        case "maximum":
          this._maximum("creation");
          this._trigger("change", null, {
            openState: "open-maximum",
            reasonID: "creation"
          });
          break;
        case "close":
          this.openState = "close";
          break;
        default:
          break;
      }
      this.options.created();
    },
    /**
     * @description function runs when user start touch
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_touchStartHandler
     * @param {Object} pEvent 
     */
    _touchStartHandler: function _touchStartHandler(pEvent) {
      this._trigger("startmove", null, {
        openState: this.getOpenState()
      });
      this.element.addClass("cf-notransition");
      var touchCoor = TouchUtil.getProperties(pEvent);
      if (touchCoor !== null) {
        this.startTouchX = touchCoor.pageX;
        this.startTouchY = touchCoor.pageY;
      }
      this.startHeight = this.element.height();
    },
    /**
     * @description function runs when user is touching
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_touchMoveHandler
     * @param {Object} pEvent 
     */
    _touchMoveHandler: function _touchMoveHandler(pEvent) {
      // neg > move up    pos > move down
      var moveY = TouchUtil.getProperties(pEvent).pageY - this.startTouchY;
      if (moveY < 0 && this.getOpenState() === "open-maximum") {
        // do nothing if user want to scroll up, when on max mode, 
        // use want propably to scroll
        return;
      }
      if (moveY > 0 && this.getOpenState() === "open-maximum") {
        // if we are max and want to scroll down, keep height and scroll
        if (this._isInScrollableArea(pEvent) === true) {
          return;
        }
      }
      pEvent.preventDefault();
      this.element.height(this.startHeight - moveY);
    },
    /**
     * @description function runs when user has ended touched
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_touchEndHandler
     * @param {Object} pEvent 
     */
    _touchEndHandler: function _touchEndHandler(pEvent) {
      this.element.removeClass("cf-notransition");
      var touchCoor = TouchUtil.getProperties(pEvent);
      if (touchCoor !== null) {
        // neg > move up    pos > move down
        var moveY = touchCoor.pageY - this.startTouchY;
        var maxHeight = this.parentDOM.height();
        var currentHeight = this.element.height();
        var percentage = currentHeight / maxHeight;
        if (moveY < -kMinTouchDistance) {
          // move up
          if (percentage < 0.5) {
            this._open("action");
          } else {
            this._maximum("action");
          }
        } else if (moveY > kMinTouchDistance) {
          // move down
          // if we are max and want to scroll down, keep height and scroll
          if (this._isInScrollableArea(pEvent) === true) {
            return;
          }
          if (percentage > 0.5) {
            this._open("action");
          } else {
            this._close("action");
          }
        }
      }
      // reset
      this.startTouchX = undefined;
      this.startTouchY = undefined;
      this.startHeight = undefined;
    },
    /**
     * @description function runs when an issue occured during moving
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_touchCancelHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _touchCancelHandler: function _touchCancelHandler(pEvent, pData) {
      this.element.removeClass("cf-notransition");
      // reset
      this.startTouchX = undefined;
      this.startTouchY = undefined;
      this.startHeight = undefined;
    },
    /**
     * @description User clicked on the close icon
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_closeClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _closeClickHandler: function _closeClickHandler(pEvent, pData) {
      if (this._isEventFromHere(pEvent)) {
        // only handle own panel, no others
        this._close();
      }
    },
    /**
     * @description function runs when the transition is done
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_transitionEndHandler
     * @param {Object} pEvent 
     */
    _transitionEndHandler: function _transitionEndHandler(pEvent) {
      if (this._isEventFromHere(pEvent)) {
        this._trigger("change", null, {
          openState: this.getOpenState()
        });
      }
    },
    /**
     * @description Function runs when user clicked on the overlay panel
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_overlayClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _overlayClickHandler: function _overlayClickHandler(pEvent, pData) {
      this._close();
    },
    /**
     * @description check if we are in a scrollable area, that still can be scolled
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_isInScrollableArea
     * @param {Object} pEvent 
     * @returns {Boolean}
     */
    _isInScrollableArea: function _isInScrollableArea(pEvent) {
      var targetDOM = $(pEvent.target).closest(".cf-scrollable-intouch");
      if (targetDOM.length > 0 && targetDOM.scrollTop() > 0) {
        return true;
      }
      return false;
    },
    /**
     * @description Is the event from here of from a child
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_isEventFromHere
     * @param {Object} pEvent 
     * @returns {Boolean}
     */
    _isEventFromHere: function _isEventFromHere(pEvent) {
      return $(pEvent.target).closest("." + this.widgetFullName).attr("data-mobilesliderpanel-uuid") == this.uuid;
    },
    /**
     * @description Open the slider half
     * @function
     * @name nixps.MobileSlidePanel#open
     * @returns undefined
     */
    open: function open() {
      this._open("public_function");
    },
    _open: function _open(pReason) {
      this.openState = "open-half";
      this._changeHeight(this.options.heightCSSWhenOpen, pReason);
      this.element.addClass("cf-slidepanel-open-half").removeClass("cf-slidepanel-close cf-slidepanel-open-maximum");
    },
    /**
     * @description close the slider completely
     * @function
     * @name nixps.MobileSlidePanel#close
     * @returns undefined
     */
    close: function close() {
      this._close("public_function");
    },
    _close: function _close(pReason) {
      this.openState = "close";
      this._changeHeight("0", pReason);
      this.element.addClass("cf-slidepanel-close").removeClass("cf-slidepanel-open-half cf-slidepanel-open-maximum");
      if (this.options.blurOnClose === true) {
        this.element.find(":focus").trigger("blur");
      }
    },
    /**
     * @description open the slider maximal
     * @function
     * @name nixps.MobileSlidePanel#maximum
     * @returns undefined
     */
    maximum: function maximum() {
      this._maximum("public_function");
    },
    _maximum: function _maximum(pReason) {
      this.openState = "open-maximum";
      this._changeHeight("100%", pReason);
      this.element.addClass("cf-slidepanel-open-maximum").removeClass("cf-slidepanel-open-half cf-slidepanel-open-maximum");
    },
    _changeHeight: function _changeHeight(pHeight, pReason) {
      this.element.css("height", pHeight);
      if (this.element.hasClass("cf-notransition") && pReason !== "creation") {
        this._trigger("change", null, {
          openState: this.getOpenState(),
          reasonID: pReason
        });
      }
    },
    /**
     * @description Get the current state of opening
     * @function
     * @name nixps.MobileSlidePanel#getOpenState
     * @returns {String} the state of opening
     */
    getOpenState: function getOpenState() {
      return this.openState;
    },
    isClosed: function isClosed() {
      var height = this.element.height();
      return height === 0;
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.MobileSlidePanel#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Sraws the dialog according to the current state
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {},
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.MobileSlidePanel#_setOptions
     */
    _setOptions: function _setOptions(pOptions) {
      this._superApply(arguments);
      this._controlOptions();
      if (pOptions.overlayDOM !== undefined) {
        if (pOptions.overlayDOM instanceof jQuery) {
          this.overlayDOM = pOptions.overlayDOM;
        } else {
          this.overlayDOM = undefined;
        }
      }
      if (pOptions.parentDOM !== undefined) {
        if (pOptions.parentDOM instanceof jQuery) {
          this.parentDOM = pOptions.parentDOM;
        } else {
          this.parentDOM = $(window);
        }
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.MobileSlidePanel#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.blurOnClose !== "boolean") {
        throw new Error("MobileSlidePanel: input option blurOnClose must be an boolean");
      }
      if (typeof this.options.heightCSSWhenOpen !== "string") {
        throw new Error("MobileSlidePanel: input option heightCSSWhenOpen must be a string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("cf-slidepanel-mobile cf-slidepanel-close cf-slidepanel-open-half cf-slidepanel-open-maximum").removeAttr("data-mobilesliderpanel-uuid");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../Touch/js/TouchUtil.js":382}],297:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var MyFunction = function MyFunction(pArguments, pExpression) {
  if (!Array.isArray(pArguments)) {
    throw new Error("first input parameter must be an array");
  }
  if (typeof pExpression !== "string") {
    throw new Error("second input parameter must be a string");
  }
  if (window.jsep === undefined) {
    throw new Error("3rdParty jsep is missing");
  }
  this.argumentsNames = pArguments;
  if (window.jsep.version > "1.") {
    var myJSEP = new window.jsep(pExpression);
    this.expression = myJSEP.parse();
  } else {
    this.expression = window.jsep(pExpression);
  }
  return this.run.bind(this);
};

/**
 * @constructor MyFunction
 * @description A replacement of the native javascript "new Function()", but it works without eval() or new Function()
 * with means it can be used when strict CSP is needed
 */
MyFunction.prototype = {
  constructor: MyFunction,
  run: function run() {
    this.arguments = arguments;
    return this.evaluate(this.expression);
  },
  evaluate: function evaluate(pExpression, pArguments) {
    switch (pExpression.type) {
      case "Literal":
        return pExpression.value;
      case "BinaryExpression":
      case "LogicalExpression":
        // old version
        switch (pExpression.operator) {
          case "+":
            return this.evaluate(pExpression.left) + this.evaluate(pExpression.right);
          case "-":
            return this.evaluate(pExpression.left) - this.evaluate(pExpression.right);
          case "*":
            return this.evaluate(pExpression.left) * this.evaluate(pExpression.right);
          case "/":
            return this.evaluate(pExpression.left) / this.evaluate(pExpression.right);
          case "===":
            return this.evaluate(pExpression.left) === this.evaluate(pExpression.right);
          case "!==":
            return this.evaluate(pExpression.left) !== this.evaluate(pExpression.right);
          case "==":
            return this.evaluate(pExpression.left) == this.evaluate(pExpression.right);
          case "<":
            return this.evaluate(pExpression.left) < this.evaluate(pExpression.right);
          case ">":
            return this.evaluate(pExpression.left) > this.evaluate(pExpression.right);
          case "<=":
            return this.evaluate(pExpression.left) <= this.evaluate(pExpression.right);
          case ">=":
            return this.evaluate(pExpression.left) >= this.evaluate(pExpression.right);
          case "|":
            return this.evaluate(pExpression.left) | this.evaluate(pExpression.right);
          case "&":
            return this.evaluate(pExpression.left) & this.evaluate(pExpression.right);
          case "||":
            // new version
            return this.evaluate(pExpression.left) || this.evaluate(pExpression.right);
          case "&&":
            // new version
            return this.evaluate(pExpression.left) && this.evaluate(pExpression.right);
          default:
            throw new Error("unsupported operator " + pExpression.operator);
        }
      case "CallExpression":
        var solvedArguments = [];
        for (var i = 0; i < pExpression.arguments.length; i++) {
          solvedArguments.push(this.evaluate(pExpression.arguments[i]));
        }
        var func = this.evaluate(pExpression.callee);
        if (typeof func === "function") {
          return func.apply(func, solvedArguments);
        } else {
          throw new Error("expression is not a function");
        }
      case "MemberExpression":
        var parentObject = this.evaluate(pExpression.object);
        if (pExpression.property !== undefined) {
          if (pExpression.property.type === "Identifier") {
            if (["string", "number", "boolean"].includes(_typeof(parentObject)) && typeof parentObject[pExpression.property.name] === "function") {
              return function (r) {
                return parentObject[pExpression.property.name](r);
              };
            }
            return parentObject[pExpression.property.name];
          } else {
            throw new Error("unsupported property.type");
          }
        } else {
          throw new Error("invalid interface");
        }
      case "Identifier":
        for (var i = 0; i < this.argumentsNames.length; i++) {
          if (this.argumentsNames[i] === pExpression.name) {
            return this.arguments[i];
          }
        }
        switch (pExpression.name) {
          case "undefined":
            return undefined;
          case "NaN":
            return NaN;
          case "Infinity":
            return Infinity;
        }
        if (window[pExpression.name] !== undefined) {
          return window[pExpression.name];
        } else {
          throw new Error("unknown indentifier " + pExpression.name);
        }
      case "ArrayExpression":
        var arrayItems = [];
        for (var i = 0; i < pExpression.elements.length; i++) {
          arrayItems.push(this.evaluate(pExpression.elements[i]));
        }
        return arrayItems;
      case "ObjectExpression":
        var obj = {};
        for (var i = 0; i < pExpression.properties.length; i++) {
          if (pExpression.properties[i].key.type === "Identifier") {
            // object keys can be defined without "
            obj[pExpression.properties[i].key.name] = this.evaluate(pExpression.properties[i].value);
          } else {
            obj[this.evaluate(pExpression.properties[i].key)] = this.evaluate(pExpression.properties[i].value);
          }
        }
        return obj;
      case "ConditionalExpression":
        if (this.evaluate(pExpression.test) === true) {
          return this.evaluate(pExpression.consequent);
        } else {
          return this.evaluate(pExpression.alternate);
        }
      case "UnaryExpression":
        switch (pExpression.operator) {
          case "!":
            return !this.evaluate(pExpression.argument);
          case "-":
            return -this.evaluate(pExpression.argument);
          default:
            throw new Error("unsupported operator");
        }
      case "NewExpression":
        if (pExpression.callee !== undefined) {
          var solvedArguments = [undefined];
          for (var i = 0; i < pExpression.arguments.length; i++) {
            solvedArguments.push(this.evaluate(pExpression.arguments[i]));
          }
          var newFunc = this.evaluate(pExpression.callee);
          if (typeof newFunc === "function") {
            return new (Function.prototype.bind.apply(newFunc, solvedArguments))();
          } else {
            throw new Error("expression is not a function");
          }
        } else if (pExpression.name !== undefined) {
          return new this.evaluate(pExpression.name);
        }
      default:
        throw new Error("unsupported expression type " + pExpression.type);
    }
  }
};
module.exports = MyFunction;

},{}],298:[function(require,module,exports){
"use strict";

/* 
 * @author Guillaume Desmet
 */
(function () {
  /**
   * @class Notificate
   * @description Show a notifcation in the operation system (OS)
   * @param {String} pTitle
   * @param {String | html} pBody
   * @param {type} pIcon
   * @returns {nixps.common.Notificate}
   */
  var Notificate = function Notificate(pTitle, pBody, pIcon) {
    if (typeof pTitle !== "string") {
      throw new Error("pTitle must be a string");
    }
    if (!("Notification" in window)) {
      console.warn("This browser does not support desktop notification");
    }

    // Let's check whether notification permissions have already been granted
    else if (Notification.permission === "granted") {
      // If it's okay let's create a notification
      var notification = new Notification(pTitle, {
        body: pBody,
        icon: pIcon
      });
    }

    // Otherwise, we need to ask the user for permission
    else if (Notification.permission !== "denied") {
      if (checkNotificationPromise()) {
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            var notification = new Notification(pTitle, {
              body: pBody,
              icon: pIcon
            });
          }
        });
      } else {
        Notification.requestPermission(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            var notification = new Notification(pTitle, {
              body: pBody,
              icon: pIcon
            });
          }
        });
      }
    }
  };

  /**
   * @description Is the curent Noification system supported?
   * @name nixps.common.Notificate#isSupported
   * @returns {Boolean} true if browser suppord the notifications
   */
  Notificate.prototype.isSupported = function () {
    return !("Notification" in window);
  };
  Notificate.isGranded = function () {
    return "Notification" in window && Notification.permission === "granted";
  };
  function checkNotificationPromise() {
    try {
      Notification.requestPermission().then();
    } catch (e) {
      return false;
    }
    return true;
  }
  module.exports = Notificate;
})();

},{}],299:[function(require,module,exports){
"use strict";

/* 
 *   created by guillaume on Jun 14, 2019
 */
(function ($) {
  "use strict";

  var TouchEventGenerator = require("../../Touch/js/TouchEventGenerator.js");
  function escape(pString) {
    if (typeof pString == "string") {
      return pString.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    return pString;
  }

  /**
   * @namespace nixps.NotifyArea
   * @description The panel containing all the error panels at the right side of the screen
   * @example $('<div>').NotifyArea({});
   * @version 1.0.0
   * @requires notify.js
   */
  $.widget("nixps.NotifyArea", $.Widget, {
    version: "1.0.0",
    widgetEventPrefix: "notifyarea",
    options: {
      top: 32,
      bottom: 0,
      right: 0,
      zIndex: 999999,
      /**
       * @bried Maximum notifications that can be shown at a given time
      */
      maximumSimultaneousNotifications: false,
      /**
          * @bried callback for when a notification is closed
      */
      close: function close() {},
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.NotifyArea#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      var that = this;
      if ($('body #notify-area').length > 0) {
        console.error("NotifyArea: another notify area is found!");
      }
      this._controlOptions();
      // create skeleton
      this.element.addClass(this.widgetFullName).addClass("cf-notify").attr("id", "notify-area").attr("aria-live", "assertive").css({
        display: 'none',
        'pointer-events': 'none',
        'top': this.options.top,
        'right': this.options.right,
        'bottom': this.options.bottom,
        'margin': '10px 10px 10px 10px',
        'z-index': this.options.zIndex
      });
      var notifyDOM = "<div id='default' class='cf-notify-message' role='alert'>" + "<h1 class='cf-notify-title'>#{title}</h1>" + "<p class='cf-notify-messagetext'>#{text}</p>" + "</div>" + "<div id='closeable' class='cf-notify-message cf-notify-info' role='alert'>" + "<a class='cf-notify-close ui-notify-cross ui-notify-close' href='#'>x</a>" + "<h1 class='cf-notify-title'>#{title}</h1>" + "<p class='cf-notify-messagetext'>#{text}</p>" + "</div>" + "<div id='closeable-error' class='cf-notify-message cf-notify-error' role='alert'>" + "<a class='cf-notify-close ui-notify-cross ui-notify-close' href='#'>x</a>" + "<h1 class='cf-notify-title'>#{title}</h1>" + "<p class='cf-notify-messagetext'>#{text}</p>" + "</div>" + "<div id='warning' class='cf-notify-message cf-notify-warning' role='alert'>" + "<a class='cf-notify-close ui-notify-cross ui-notify-close' href='#'>x</a>" + "<h1 class='cf-notify-title'>#{title}</h1>" + "<p class='cf-notify-messagetext'>#{text}</p>" + "</div>" + "<div id='success' class='cf-notify-message cf-notify-success' role='alert'>" + "<a class='cf-notify-close ui-notify-cross ui-notify-close' href='#'>x</a>" + "<h1 class='cf-notify-title'>#{title}</h1>" + "<p class='cf-notify-messagetext'>#{text}</p>" + "</div>" + "<div id='licensebanner' class='cf-notify-message' role='alert'>" + "<a class='cf-notify-close ui-notify-cross ui-notify-close' href='#'>x</a>" + "<span class='fa fa-exclamation-triangle fa-2x'></span>" + "<h2 class='cf-notify-title'>#{title}</h2>" + "<p  class='cf-notify-messagetext'>#{text}</p>" + "</div>";
      this.element.append(notifyDOM);
      this.element.find("#licensebanner").css({
        "background": "rgb(250, 252, 255)",
        "border": "2px solid #0080bf",
        "border-radius": 4,
        "margin-bottom": 5,
        "color": "#0080bf",
        "box-shadow": "0 0 6px rgba(80, 163, 255, 0.47)"
      });
      this.element.find("#licensebanner .cf-notify-close").css({
        "color": "#0080bf",
        "font-size": 17,
        "padding": "2px 6px"
      });
      this.element.find("#licensebanner .fa-exclamation-triangle").css({
        "float": "left",
        "padding": "12px 11px",
        "color": "#FF8934"
      });
      this.element.find("#licensebanner .cf-notify-title").css({
        "margin": "0 0 0 60px",
        "font-size": "1.5em"
      });
      this.element.find("#licensebanner .cf-notify-messagetext").css({
        "margin": "0 0 5px 60px",
        "color": "#0080bf"
      });
      this.openedNotifications = 0;
      this.queue = [];
      var options = {};
      if (typeof this.options.maximumSimultaneousNotifications === 'number') {
        options.close = function close() {
          that.options.close();
          that.openedNotifications--;
          if (that.queue.length > 0) {
            var next = that.queue.shift();
            that.createMessage(next.type, next.title, next.message, next.expires);
          }
        };
      }
      this.element.notify(options);
      this.touchEventGenerator = null;
      if (!TouchEventGenerator.isActiveOn(this.element[0])) {
        this.touchEventGenerator = new TouchEventGenerator(this.element[0], {});
      }
      this._on(this.element, {
        "nixps:swipeleft": this._swipeLeftHandler
      });
      this.options.created();
    },
    /**
     * @description function runs when user want to swipe on the area
     * @function
     * @private
     * @name nixps.NotifyArea#_swipeLeftHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _swipeLeftHandler: function _swipeLeftHandler(pEvent, pData) {
      $(pEvent.target).closest(".cf-notify-message").find(".ui-notify-close").trigger("click"); // close it
    },

    /**
     * @description Draws the area according to the current state
     * @function
     * @private
     * @name nixps.NotifyArea#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.css({
        'top': this.options.top,
        'right': this.options.right,
        'bottom': this.options.bottom,
        'z-index': this.options.zIndex
      });
    },
    /**
     * @description Create and show an globale message to the user
     * @function
     * @name nixps-NotifyArea#createMessage
     * @param {String} pType The type of the message, like "default", "warning"
     * @param {String} pTitle The title of the message
     * @param {String} pMessageText The message text
     * @param {Number} pExpires The Number of milliseconds to expire
     * @returns {undefined}
     */
    createMessage: function createMessage(pType, pTitle, pMessageText, pExpires) {
      if (typeof pType !== "string" || pType.length <= 0) {
        throw new Error("wrong type");
      }
      if (typeof pTitle !== "string") {
        pTitle = ""; // default no title
      }

      pTitle = escape(pTitle);
      if (typeof pMessageText !== "string") {
        pMessageText = ""; // default no title
      }

      pMessageText = escape(pMessageText);
      var extraOptions = undefined;
      if (pExpires !== undefined) {
        var exp = pExpires;
        if (typeof pExpires === "string" && pExpires.length > 0) {
          exp = parseInt(exp);
        }
        extraOptions = {
          expires: exp
        };
      }
      if (!this.options.maximumSimultaneousNotifications || this.openedNotifications < this.options.maximumSimultaneousNotifications) {
        this.element.notify("create", pType, {
          title: pTitle,
          text: pMessageText
        }, extraOptions);
        this.openedNotifications++;
      } else {
        this.queue.push({
          type: pType,
          title: pTitle,
          message: pMessageText,
          expires: pExpires
        });
      }
    },
    /**
     * @description Create and show an globale message to the user and return an object. Used for Pagebuilder
     * @function
     * @name nixps-NotifyArea#createMessagePB
     * @param {String} pType The type of the message, like "info", "warning"
     * @param {String} pTitle The title of the message
     * @param {String} pMessageText The message text
     * @param {Number} pExpires The Number of milliseconds to expire
     * @returns {Object}
     */
    createMessagePB: function createMessagePB(pType, pTitle, pMessageText, pExpires) {
      if (typeof pType !== "string") {
        throw new Error("wrong type");
      }
      // normalise the type
      var type = pType.toLowerCase();
      switch (type) {
        case "":
        case "info":
        case "closeable":
          type = "closeable";
          break;
        case "warn":
        case "warning":
          type = "warning";
          break;
        case "error":
        case "fatal":
        case "closeable-error":
          type = "closeable-error";
          break;
        case "success":
          type = "success";
          break;
        case "default":
        case "licensebanner":
        default:
          type = "closeable";
          break;
      }
      // normalise the timeout 
      var expires = pExpires;
      if (typeof expires === "string" && expires.length > 0) {
        expires = parseInt(expires);
      }
      if (typeof expires !== "number" || isNaN(expires) || expires < 5000) {
        expires = 5000;
      } else if (expires > 9999999999999) {
        expires = 9999999999999;
      }
      this.createMessage(type, pTitle, pMessageText, expires);
      return {};
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.NotifyArea#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.NotifyArea#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof $.fn.notify !== "function") {
        console.error("NotifyArea: 3rdParty notify is missing");
      }
      if (typeof this.options.top !== "string" && typeof this.options.top !== "number") {
        throw new Error("Incorrect type");
      } else if (typeof this.options.top === "string" && this.options.top.length <= 0) {
        throw new Error("Empty string");
      }
      if (typeof this.options.bottom !== "string" && typeof this.options.bottom !== "number") {
        throw new Error("Incorrect type");
      } else if (typeof this.options.bottom === "string" && this.options.bottom.length <= 0) {
        throw new Error("Empty string");
      }
      if (typeof this.options.right !== "string" && typeof this.options.right !== "number") {
        throw new Error("Incorrect type");
      } else if (typeof this.options.right === "string" && this.options.right.length <= 0) {
        throw new Error("Empty string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("cf-notify");
      if (this.touchEventGenerator !== undefined && this.touchEventGenerator !== null) {
        this.touchEventGenerator.destroy();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../Touch/js/TouchEventGenerator.js":381}],300:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jun 21, 2019
 */
(function ($) {
  /**
   * @namespace nixps.PanelSeparator
   * @description Draw a separator, used in pagebuilder, because pagebuilder requires a specific creation interface
   * do not use it outside pagebuilder!!
   * @example $("<div>").PanelSeparator({});
   * @version 1.2.0
   */
  $.widget("nixps.PanelSeparator", $.Widget, {
    version: "1.2.0",
    options: {
      /**
       * @name nixps.PanelSeparator#style_type
       * @description The type of style you want to apply
       * @type {String}
       * @private
       */
      style_type: "default",
      /**
       * @description function runs when the component has been done with drawing
       * @name nixps.PanelSeparator#created
       * @private
       * @type {Function}
       * @version 1.1.0
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.PanelSeparator#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._addClass(this.widgetFullName);
      this.element.addClass("cf-hr CloudflowStyle_" + this.options.style_type);
      this.options.created();
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.PanelSeparator#_setOptions
     */
    _setOptions: function _setOptions(options) {
      var that = this;
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
    },
    _destroy: function _destroy() {
      this.element.removeClass("cf-hr CloudflowStyle_" + this.options.style_type);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],301:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*
 * 
 *   created by guillaume on Mrt 23, 2023
 */
(function ($) {
  require("../../Button/js/nixps-pagebuilder-CloudflowButton.js");

  /**
   * @namespace nixps.Popup
   * @description Draw a popup. This is a form component
   * @version 1.0.0
   */
  $.widget("nixps.Popup", $.Widget, {
    version: "1.0.0",
    options: {
      /**
       * @name nixps.Popup#url
       * @description The url of the popup. Can also be a cloudflow url
       * @type {String}
       * @default ""
       */
      url: "",
      /**
       * @name nixps.Popup#button
       * @description the options for the button component. See @link{nixps-pagebuilder.CloudflowButton}
       * @type {Object}
       * @default {}
       */
      button: {
        icon: "cf-icon cf-icon-help-circle",
        label: "Show Info",
        classes: "cf-button-secondary"
      },
      /**
       * @name nixps.Popup#float
       * @description How must we position the text. Must we center the text or place at the left side.
       * This string will be used as value for the css text-align value
       * @type {String}
       * @default null
       */
      "float": null,
      /**
       * @name nixps.Popup#maxHeight
       * @description The max height in pixel of the popup, if defined it must be bigger then 150px
       * @type {Number}
       * @default null
       */
      maxHeight: null,
      /**
       * @name nixps.Popup#maxWidth
       * @description The max width in pixel of the popup, if defined it must be bigger then 150px
       * @type {Number}
       * @default null
       */
      maxWidth: null,
      /**
       * @name nixps.Popup#style_type
       * @description The type of style you want
       * @type {String}
       * @private
       */
      style_type: "default",
      /**
       * @name nixps.Popup#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    /**
     * @description create the component
     * @name nixps.Popup#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("CloudflowStyle_" + this.options.style_type);
      // variables
      this.popup = null;

      // skeleton
      this.element.append($("<div>").addClass("popup-button"));
      this._draw();
      this._on(this.element, {
        "click .popup-button button": this._clickHandler
      });
      this.options.created();
    },
    /**
     * @description function runs when user clicked on the button
     * @function
     * @private
     * @name nixps.Popup#_clickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     * @returns {undefined}
     */
    _clickHandler: function _clickHandler(pEvent, pData) {
      if (typeof this.options.url !== "string" || this.options.url.length <= 0) {
        console.error("we could not redirect because the url is invalid");
        return;
      }
      // standalise the url, so cloudflow urls ar allowed
      var url = this.options.url;
      if (this.options.url.indexOf("cloudflow://") === 0) {
        url = "/portal.cgi/" + this.options.url.slice(12);
      }
      var isNew = this.popup === null || this.popup.closed === true;
      if (isNew === false) {
        try {
          // browser can block it
          isNew = this.popup.location.pathname !== url;
        } catch (e) {}
      }
      if (isNew) {
        var leftBorderXTarget = pEvent.clientX;
        var rightBorderX = leftBorderXTarget + 100;
        var topBorderYTarget = pEvent.clientY;
        var bottomBorderY = topBorderYTarget + 100;
        var form = $(pEvent.target).closest("form");
        if (form.length === 1 && typeof form[0].getBoundingClientRect === "function") {
          leftBorderXTarget = form[0].getBoundingClientRect().left;
          rightBorderX = leftBorderXTarget + form.width();
          topBorderYTarget = form[0].getBoundingClientRect().top;
          bottomBorderY = topBorderYTarget + form.height();
        }
        var width,
          height = window.innerHeight,
          top = 0,
          left = 0;
        if (leftBorderXTarget < window.innerWidth - rightBorderX) {
          // right is bigger, place popup to the right
          width = window.innerWidth - rightBorderX - 20;
          left = rightBorderX + 20;
          if (typeof this.options.maxWidth === "number" && width > this.options.maxWidth) {
            width = this.option.maxWidth;
          }
          if (typeof this.options.maxHeight === "number" && height > this.options.maxHeight) {
            top = window.innerHeight / 2 - this.options.maxHeight / 2;
            height = this.options.maxHeight;
          }
        } else {
          // left is bigger
          width = leftBorderXTarget - 20;
          left = 0;
          if (typeof this.options.maxWidth === "number" && width > this.options.maxWidth) {
            left = width - this.options.maxWidth;
            width = this.option.maxWidth;
          }
          if (typeof this.options.maxHeight === "number" && height > this.options.maxHeight) {
            top = window.innerHeight / 2 - this.options.maxHeight / 2;
            height = this.options.maxHeight;
          }
        }
        if (width < 150) {
          if (window.innerHeight - bottomBorderY > 200) {
            top = bottomBorderY + 50;
            height = window.innerHeight - top;
            left = 0;
            width = window.innerWidth;
          } else {
            width = "auto";
          }
        }
        var windowFeatures = "width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
        this.popup = window.open(url, "popup", windowFeatures);
        if (this.popup === null) {
          console.warn("popup has been blocked");
        }
      } else {
        this.popup.focus();
      }
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.Popup#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      // update button
      this.element.find(".popup-button").CloudflowButton(Object.assign(this.options.button, {
        disabled: this.options.disabled
      }));
      // update layout
      if (typeof this.options["float"] === "string" && this.options["float"].length > 0) {
        this.element.css("text-align", this.options["float"]);
      } else {
        this.element.css("text-align", "");
      }
    },
    setValue: function setValue(pURL) {
      this.option("url", pURL);
    },
    getValue: function getValue() {
      return this.options.url;
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps.Popup#_setOptions
     */
    _setOptions: function _setOptions(pOptions) {
      if (typeof pOptions.style_type === "string") {
        this.element.removeClass("CloudflowStyle_" + this.options.style_type).addClass("CloudflowStyle_" + pOptions.style_type);
      }
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.url !== "string") {
        throw new Error("Popup: input option url must be a not empty string");
      }
      if (_typeof(this.options.button) !== "object") {
        throw new Error("Popup: input option button must be an object");
      }
      if (typeof this.options.style_type !== "string" || this.options.style_type.length <= 0) {
        throw new Error("Popup: input option style_type must be a not empty string");
      }
      if (typeof this.options.maxHeight === "number") {
        if (this.options.maxHeight < 150) {
          throw new Error("Popup: input option maxHeight must be bigger then 150");
        }
      }
      if (typeof this.options.maxWidth === "number") {
        if (this.options.maxWidth < 150) {
          throw new Error("Popup: input option maxWidth must be bigger then 150");
        }
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("CloudflowStyle_" + this.options.style_type);
      if (this.popup !== undefined && this.popup !== null) {
        this.popup.close();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../Button/js/nixps-pagebuilder-CloudflowButton.js":282}],302:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 20-feb-2020 15:12:26
 */
(function ($) {
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");
  function extract(pIframe) {
    if (typeof pIframe === "string" && pIframe.length > 0) {
      if (/^<iframe .*><\/iframe>$/.test(pIframe)) {
        var src = pIframe.match(/src="([^"]*)"/i);
        var width = pIframe.match(/width="([^"]*)"/i);
        var height = pIframe.match(/height="([^"]*)"/i);
        var title = pIframe.match(/title="([^"]*)"/i);
        var allowFullScreen = / allowFullScreen="true"/i.test(pIframe);
        return {
          src: src ? src[1] : undefined,
          width: width ? width[1] : undefined,
          height: height ? height[1] : undefined,
          title: title ? title[1] : undefined,
          allowFullScreen: allowFullScreen
        };
      }
    }
    return {
      src: pIframe
    };
  }

  /**
   * @namespace nixps-EmbedPowerBI
   * @description draw a component containing a iframe
   * @private
   * @version 1.1.0
   * @example $("<div>").EmbedPowerBI({});
   */
  $.widget("nixps.EmbedPowerBI", $.Widget, {
    version: "1.0.0",
    defaultElement: "<div>",
    widgetEventPrefix: "embedpowerbi",
    options: {
      /**
       * @name nixps.EmbedPowerBI#height
       * @description The language of the user
       * @type {String}
       * @default null
       */
      language: "en",
      /**
       * @name nixps.EmbedPowerBI#height
       * @description The height of the component
       * @type {Mixed}
       * @default null
       */
      height: null,
      /**
       * @name nixps.EmbedPowerBI#width
       * @description The width of the component
       * @type {Mixed}
       * @default null
       */
      width: null,
      /**
       * @name nixps.EmbedPowerBI#url
       * @description The url of the page to be shown
       * @type {String}
       * @default null
       */
      url: "",
      /**
       * @description The title to be added for accessibility on the iframe
       * @name nixps.EmbedPowerBI#title
       * @type {String}
       * @default undefined
       */
      title: undefined,
      /**
       * @name nixpsEmbedPowerBI#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.EmbedPowerBI#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._addClass(this.widgetFullName);
      this.element.attr("data-uuid", this.uuid);

      // variables
      this.alive = true;
      this.creating = true; // flag when component is done drawing, successfully or not

      this._draw();
      this._on(this.element, {});
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.EmbedPowerBI#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.EmbedPowerBI#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      this.mFrame = $("<iframe>").text("The browser does not support iframe").attr({
        "allowFullScreen": "true"
      });
      var inputData = extract(this.options.url);
      var url = inputData.src;
      if (url.indexOf("https://app.powerbi.com/") !== 0) {
        var errorData = {
          error_code: "invalid_embeddedpowerbi_url",
          error: "EmbedPowerBI: We support only urls starting from https://app.powerbi.com/"
        };
        console.error(errorData.error);
        LogListener.addLog({
          event_type: "error",
          details_data: errorData,
          component_name: this.widgetFullName
        }, this.element);
        that._endCreating();
        return;
      }
      if (typeof this.options.title === "string" && this.options.title.length > 0) {
        this.mFrame.attr("title", this.options.title);
      } else if (typeof inputData.title === "string" && inputData.title.length > 0) {
        this.mFrame.attr("title", inputData.title);
      }
      this.mFrame.one("load", function () {
        that._endCreating();
      });
      this.element.empty().append(this.mFrame.attr({
        "height": this.options.height || inputData.height || null,
        "width": this.options.width || inputData.width || "100%",
        "src": url
      }));
    },
    _endCreating: function _endCreating(pEvent) {
      if (this.creating === true) {
        this.creating = false;
        this.options.created();
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.EmbedPowerBI#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.EmbedPowerBI#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("EmbedPowerBI input option language must be a not empty string");
      }
      if (typeof this.options.url !== "string") {
        throw new Error("EmbedPowerBI input option url must be a string");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeAttr("data-uuid");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../pagebuilder/js/inspect/LogListener.js":431}],303:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
(function ($) {
  if ($.fn.RIPEditor !== undefined) {
    // already linked
    return;
  }
  require("../../Dialog/js/nixps-Dialog.js");
  require("./source/nixps-RIPEditorCIP3.js");
  require("./source/nixps-RIPEditorColor.js");
  require("./source/nixps-RIPEditorCurves.js");
  require("./source/nixps-RIPEditorInput.js");
  require("./source/nixps-RIPEditorOutput.js");
  require("./source/nixps-RIPEditorPostRender.js");
  require("./source/nixps-RIPEditorPresets.js");
  require("./source/nixps-RIPEditorSeparations.js");
  require("./source/nixps-RIPEditor-CurveInterpolationData.js");
  require("./source/nixps-SeparationList.js");
  require("../../../cloudflow/DFE/js/nixps-dfe-DFEEditor.js");
  $.widget("nixps.RIPEditor", {
    options: {
      /**
       * @name nixps.RIPEditor#language
       * @description The language of the user, We hope this will be fill in by the formrenderer
       * @type {String}
       * @default null
       */
      language: null,
      /**
       * @name nixps.RIPEditor#settings
       * The settings blob with the RIP parameters
       */
      settings: undefined,
      /**
       * Set this to true to use with bootstrap, no for regular jQueryUI
       */
      bootstrap: true,
      /**
       * Our categories
       */
      inputCategory: undefined,
      outputCategory: undefined,
      cip3Category: undefined,
      separationsCategory: undefined,
      curvesCategory: undefined,
      colorCategory: undefined,
      postRenderCategory: undefined,
      /**
       * @brief are we in a standalone view, mode or not?
       */
      standaloneView: false,
      /**
      * @desc must we show a refreshbutton
      * @type {boolean}
      * @default false
      */
      enableSeparationRefreshButton: false,
      /**
       * @name nixps.RIPEditor#readOnly
       * @description Must we just open de panel in readOnly mode?
       * @type {Boolean}
       * @default false
       */
      readOnly: false,
      applyVisibility: false,
      /**
       * @name nixps.RIPEditor#editingVisibility
       * @description Must we give the user the ability to change the setting of visibility
       * @type {boolean}
       * @default false
       */
      editingVisibility: false,
      /**
       * @description are the fields required?
       * @name nixps.RIPEditor#required
       * @type {Boolean}
       * @default false
       * @example true
       */
      required: false
    },
    /** 
     * @brief creates the editor component
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      if (this.options.dfe !== undefined) {
        this.element.append($("<h3>").text("Fundamentals " + this.options.dfe.cfapp));
      }

      // The Main Container
      var bootstrapScope = $("<div>").addClass("container-fluid");
      bootstrapScope.appendTo(this.element);

      // The Form wrapper
      var ripRow = $("<div>").addClass("draggablePanelList row-fluid form-horizontal");
      ripRow.appendTo(bootstrapScope);

      // Settings object must exist to be able to reference
      if (this.options.settings === undefined) {
        this.options.settings = {
          output: {},
          separations: {},
          cms: {},
          rip_curves: {}
        };
      }

      // Disable the input panel when the rip editor is created in the node editor context (workflow editor)
      if (this.options.bootstrap === false) {
        this.element.addClass("cf-form");
        ripRow.append($("<h3>")._t("nixps-RIPEditor-input.title"));
        this.inputCategory = $("<div>");
        this.inputCategory.appendTo(ripRow);
        this.inputCategory.RIPEditorInput({});
      }

      // The Output Category
      if (this.options.bootstrap == false) {
        ripRow.append($("<h3>")._t("nixps-RIPEditor-output.title"));
      }
      this.outputCategory = $("<div>");
      this.outputCategory.appendTo(ripRow);
      this.outputCategory.RIPEditorOutput({
        language: this.options.language,
        settings: this.options.settings,
        bootstrap: this.options.bootstrap,
        standaloneView: this.options.standaloneView,
        editingVisibility: this.options.editingVisibility,
        applyVisibility: this.options.applyVisibility
      });

      // The Separations Category
      if (this.options.bootstrap == false) {
        ripRow.append($("<h3>")._t("nixps-RIPEditor-separations.title"));
      }
      this.separationsCategory = $("<div>");
      this.separationsCategory.appendTo(ripRow);
      this.separationsCategory.RIPEditorSeparations({
        settings: this.options.settings,
        bootstrap: this.options.bootstrap,
        enableSeparationRefreshButton: this.options.enableSeparationRefreshButton
      });

      // The Calibration Category
      if (this.options.bootstrap == false) {
        ripRow.append($("<h3>")._t("nixps-RIPEditor-calibration.title"));
      }
      this.curvesCategory = $("<div>");
      this.curvesCategory.appendTo(ripRow);
      this.curvesCategory.RIPEditorCurves({
        settings: this.options.settings,
        bootstrap: this.options.bootstrap,
        editingVisibility: this.options.editingVisibility,
        applyVisibility: this.options.applyVisibility
      });

      // The Color Category
      if (this.options.bootstrap == false) {
        ripRow.append($("<h3>")._t("nixps-RIPEditor-color.title"));
      }
      this.colorCategory = $("<div>");
      this.colorCategory.appendTo(ripRow);
      this.colorCategory.RIPEditorColor({
        settings: this.options.settings,
        bootstrap: this.options.bootstrap,
        editingVisibility: this.options.editingVisibility,
        applyVisibility: this.options.applyVisibility
      });

      // CIP3 Category
      if (this.options.bootstrap == false) {
        ripRow.append($("<h3>")._t("nixps-RIPEditor-CIP3.title"));
      }
      this.cip3Category = $("<div>");
      this.cip3Category.appendTo(ripRow);
      this.cip3Category.RIPEditorCIP3({
        settings: this.options.settings,
        bootstrap: this.options.bootstrap,
        standaloneView: this.options.standaloneView,
        editingVisibility: this.options.editingVisibility,
        applyVisibility: this.options.applyVisibility
      });

      // The output post rendering Category
      if (this.options.standaloneView === true) {
        if (this.options.bootstrap == false) {
          ripRow.append($("<h3>")._t("nixps-RIPEditor-Postrender.title"));
        }
        this.postRenderCategory = $("<div>");
        this.postRenderCategory.appendTo(ripRow);
        this.postRenderCategory.RIPEditorPostRender({
          settings: this.options.settings,
          bootstrap: this.options.bootstrap,
          standaloneView: this.options.standaloneView,
          editingVisibility: this.options.editingVisibility,
          applyVisibility: this.options.applyVisibility
        });
      }
      this._makeDraggable();
      this._refresh();
      this._installHandlers();
      this._readOnlyChange(this.options.readOnly);
    },
    /**
     * @brief Helper function that makes the panels draggable
     */
    _makeDraggable: function _makeDraggable() {
      var panelList = this.element.find(".draggablePanelList");
      if (this.options.bootstrap) {
        panelList.sortable({
          // Only make the .panel-heading child elements support dragging.
          // Omit this to make then entire <li>...</li> draggable.
          handle: ".panel-heading",
          update: function update() {}
        });
      } else {
        panelList.accordion({
          collapsible: true,
          heightStyle: "content"
        });
        panelList.children("h3").addClass("nixps_enable_when_readonly");
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "settings" && _typeof(pValue) === "object" || pKey === "standaloneView") {
        if (pKey === "standaloneView" && pValue === this.options.standaloneView) {
          // the key and value are equal, do not refresh
          return;
        }
        this._super(pKey, pValue);
        if (this.options.bootstrap === false) {
          // Do not execute this in non workflow builder context
          this.inputCategory.RIPEditorInput("option", pKey, pValue);
        }
        this.outputCategory.RIPEditorOutput("option", pKey, pValue);
        this.separationsCategory.RIPEditorSeparations("option", pKey, pValue);
        this.colorCategory.RIPEditorColor("option", pKey, pValue);
        this.curvesCategory.RIPEditorCurves("option", pKey, pValue);
        this.cip3Category.RIPEditorCIP3("option", pKey, pValue);
        if (this.options.standaloneView === true) {
          this.postRenderCategory.RIPEditorPostRender("option", pKey, pValue);
        }
        this._refresh();
      } else if (pKey === "readOnly") {
        if (pValue !== this.options.readOnly) {
          this._super(pKey, pValue);
          this._readOnlyChange(this.options.readOnly);
        }
      } else if (pKey === "disabled" && pValue === true) {
        this._super(pKey, pValue);
        this._readOnlyChange(true);
      } else if (pKey === "required") {
        this._super(pKey, pValue);
        // ignore, do not redraw
      } else if (pKey === "ui") {
        this.separationsCategory.RIPEditorSeparations("option", pKey, pValue);
        this._super(pKey, pValue); // No redraw, just store
      } else {
        this._super(pKey, pValue);
        this._refresh();
      }
    },
    _refresh: function _refresh() {},
    _installHandlers: function _installHandlers() {
      if (this.options.standaloneView === false) {
        this._on(this.element, {
          "ripeditorinputchange": this._changeHandler
        });
      }
      this._on(this.element, {
        "ripeditoroutputchange": this._changeHandler,
        "ripeditorcurveschange": this._changeHandler,
        "ripeditorseparationschange": this._changeHandler,
        "ripeditorcip3change": this._changeHandler,
        "ripeditorcolorchange": this._changeHandler,
        "ripeditorpostrenderchange": this._changeHandler
      });
    },
    _changeHandler: function _changeHandler(pEvent, pData) {
      this.option("settings", pData.settings);
      this._trigger("change", pEvent, {
        "settings": pData.settings
      });
    },
    _readOnlyChange: function _readOnlyChange(pReadOnly) {
      // no input Category not needed
      this.outputCategory.RIPEditorOutput("option", "readOnly", pReadOnly);
      this.separationsCategory.RIPEditorSeparations("option", "readOnly", pReadOnly);
      this.curvesCategory.RIPEditorCurves("option", "readOnly", pReadOnly);
      this.colorCategory.RIPEditorColor("option", "readOnly", pReadOnly);
      this.cip3Category.RIPEditorCIP3("option", "readOnly", pReadOnly);
      this.outputCategory.RIPEditorOutput("option", "editingVisibility", !pReadOnly && this.options.editingVisibility);
      this.separationsCategory.RIPEditorSeparations("option", "editingVisibility", !pReadOnly && this.options.editingVisibility);
      this.curvesCategory.RIPEditorCurves("option", "editingVisibility", !pReadOnly && this.options.editingVisibility);
      this.colorCategory.RIPEditorColor("option", "editingVisibility", !pReadOnly && this.options.editingVisibility);
      this.cip3Category.RIPEditorCIP3("option", "editingVisibility", !pReadOnly && this.options.editingVisibility);
      if (this.options.standaloneView === true) {
        this.postRenderCategory.RIPEditorPostRender("option", "readOnly", pReadOnly);
        this.postRenderCategory.RIPEditorPostRender("option", "editingVisibility", !pReadOnly && this.options.editingVisibility);
      }
    }
  });
})(jQuery);

},{"../../../cloudflow/DFE/js/nixps-dfe-DFEEditor.js":98,"../../Dialog/js/nixps-Dialog.js":287,"./source/nixps-RIPEditor-CurveInterpolationData.js":305,"./source/nixps-RIPEditorCIP3.js":306,"./source/nixps-RIPEditorColor.js":307,"./source/nixps-RIPEditorCurves.js":308,"./source/nixps-RIPEditorInput.js":309,"./source/nixps-RIPEditorOutput.js":310,"./source/nixps-RIPEditorPostRender.js":311,"./source/nixps-RIPEditorPresets.js":312,"./source/nixps-RIPEditorSeparations.js":313,"./source/nixps-SeparationList.js":314}],304:[function(require,module,exports){
"use strict";

/**
 * @author Guillaume Desmet
 */
var Util = {
  getValue: function getValue(pParameter, pDefault) {
    if (pParameter === undefined) {
      return pDefault;
    }
    return pParameter;
  },
  createFormGroup: function createFormGroup(pLabel, pControl, pLabelWidth, pControlWidth) {
    var formGroup = $("<div>").addClass("row cf-form-group help-parameter-group");
    formGroup.append($("<label>").attr("for", pControl.attr("name")).addClass("cf-col-sm-4 control-label cf-form-label").text(pLabel));
    var controls = $("<div>").addClass("cf-col-sm-8");
    controls.appendTo(formGroup);
    pControl.appendTo(controls);
    return formGroup;
  },
  /**
   * @brief this function controls the input of the outputfile\
   * if empty it fills in with a default value pDefaultName
   * if it do not end with a / then add one to it 
   * @param {string} pDefaultName: the name we must use if no value is aviable
   * @param {html_DOM_jQuery} pInputTagValue: the inputTag with value we must correct
   */
  controlOutputPath: function controlOutputPath(pDefaultName, pInputTagValue) {
    var path = pInputTagValue.val();
    if (typeof path !== "string" || path.length <= 0) {
      path = pDefaultName; //'file:///';
    } else if (path.slice(-1) !== '/' && path.slice(-1) !== '\\') {
      path = path.concat('/');
    }
    pInputTagValue.val(path);
    return path;
  }
};
module.exports = Util;

},{}],305:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @function
   * @description return a array with separation names
   * @private
   * @param {curve} pCurve
   * @returns {Array|arrayObj} separations name, color names
   */
  function getSeparations(pCurve) {
    var seps = [];
    if (Array.isArray(pCurve.functions)) {
      pCurve.functions.forEach(function (f) {
        var name = getSeparationName(f);
        if (name !== undefined) {
          seps.push(name);
        }
      });
    } else {
      throw new Error('invalid parameter');
    }
    return seps;
  }
  ;
  function getSeparationName(func) {
    if (func.strategy !== undefined && func.strategy.separation !== undefined) {
      return func.strategy.separation;
    } else if (func.separation !== undefined) {
      return func.separation;
    } else if (func.name === 'Default') {
      return func.name;
    }
    return undefined;
  }
  ;

  /**
   * @function
   * @description return a array with separation names
   * @private
   * @param {Array | curve} pCurve
   * @returns {Array|arrayObj} separations name, color names
   */
  function getSeparationsFromArray(pCurves) {
    var arrayObj = [];
    $.each(pCurves, function (index, elem) {
      var seps = getSeparations(elem);
      arrayObj = arrayObj.concat(seps);
    });
    return _.uniq(arrayObj);
  }
  ;
  $.widget("nixps-cloudflow.CurveInterpolationData", $.Widget, {
    widgetEventPrefix: "curveinterpolationdata",
    options: {
      /**
       * @brief array curveData
       */
      curves: [],
      /**
       * @brief the name of the default curve, can be changed later on for other languages
       */
      defaultName: "Default",
      /**
       * @desc the indexes from the disabled curves
       * @type array
       * @default [] 
       */
      undefinedCurvesIndexes: []
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.separationFunctions = {};
      $('<div>').addClass('row cf-form-group').append($('<label>').addClass('col-xs-3 cf-col-xs-3 control-label cf-form-label')._t("nixps-RIPEditorCurves.separation_label")).append($('<div>').addClass('col-xs-9 cf-col-xs-8').append($('<select>').addClass('selectingSeparations cf-form-control').css({
        'width': '95%'
      }))).appendTo(this.element);

      // if ( this.prefRecipes ) {
      $('<div>').addClass('row cf-form-group recipeApplied').attr('name', 'curve1').append($('<span>').addClass('col-xs-3 control-label cf-form-label')._t('nixps-RIPEditorCurves.RecipeAppliedFromCurve', [1])).append($('<label>').addClass('col-xs-9 recipeName')._t('nixps-RIPEditorCurves.recipe')).appendTo(this.element);
      $('<div>').addClass('row cf-form-group recipeApplied').attr('name', 'curve2').append($('<span>').addClass('col-xs-3 control-label cf-form-label')._t('nixps-RIPEditorCurves.RecipeAppliedFromCurve', [2])).append($('<label>').addClass('col-xs-9 recipeName')._t('nixps-RIPEditorCurves.recipe')).appendTo(this.element);
      $('<div>').addClass('row cf-form-group recipeApplied').attr('name', 'curve3').append($('<span>').addClass('col-xs-3 control-label cf-form-label')._t('nixps-RIPEditorCurves.RecipeAppliedFromCurve', [3])).append($('<label>').addClass('col-xs-9 recipeName')._t('nixps-RIPEditorCurves.recipe')).appendTo(this.element);
      // }

      $("<div>").addClass("errorMessageInterpolation").hide().appendTo(this.element);
      $("<div>").addClass("interpolationCurveTable").css({
        'overflow': 'auto',
        'max-width': '350px',
        'max-height': '400px'
      }).appendTo(this.element);
      this._draw();
      this._on(this.element, {
        "change select.selectingSeparations": this._changeSelectSeparationResultHandler
      });
    },
    /**
     * @brief redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief draws the dialog according to the current state
     * @private
     */
    _draw: function _draw() {
      var that = this;
      this.separationFunctions = {};
      this.element.children().show();
      this.element.find('.errorMessageInterpolation').hide();
      this.element.find('div.recipeApplied').hide();
      this.curves = $.extend([], this.options.curves);
      this.undefinedCurvesIndexes = $.extend([], this.options.undefinedCurvesIndexes);
      this._removeUnusedCurves();
      var selectSep = this.element.find('.selectingSeparations').empty();
      // retrieve all possible colors and add empty array to dictionary
      // make at the same time the options for the select
      $.each(getSeparationsFromArray(this.curves), function (index, separation) {
        selectSep.append($("<option>").val(separation).text(separation));
        that.separationFunctions[separation] = [];
      });
      if (that.separationFunctions.length === 0) {
        selectSep.append($("<option>").val('').text("Default"));
      }
      // select default color in select
      selectSep.val(that.options.defaultName);
      // fill in dictionary of colors
      // loop over every curve
      // curve1 -> func1
      //        -> func2
      //        -> func3
      // curve2 -> func1
      //        -> func2
      // if ( ! this.prefRecipes ) {
      //     // Old calculation. Based only on the separation
      //     $.each(this.curves, function (index, curveData) {
      //         if (Array.isArray(curveData.functions)) {
      //             $.each(curveData.functions, function (ide, func) {
      //                 var sep = getSeparationName(func);
      //                 if (sep !== undefined)
      //                     that.separationFunctions[sep].push(func);
      //             });
      //         }
      //     });
      //
      //     var amountCurves = this.curves.length;
      //     $.each(this.separationFunctions, function (index, arraySeparation) {
      //         if (!Array.isArray(arraySeparation) || arraySeparation.length !== amountCurves) {
      //             throw new Error("CurveInterpolationData, draw: amount of separation is not equal to amount of curves");
      //             return;
      //         }
      //     });
      //
      //     that._getInterpolations(that.separationFunctions[that.options.defaultName]).done(function (pResults) {
      //         that._drawTable(pResults);
      //     }).fail(function (pError) {
      //         that.element.children().hide();
      //         that.element.find('.errorMessageInterpolation').text("Could not calculate results").show();
      //     });
      // } else {
      var values = [];
      selectSep.find("option").each(function () {
        values.push($(this).val());
      });
      this.options.settings.separations.inks.forEach(function (ink) {
        if (ink.name !== '<spot>' && !values.find(function (v) {
          return v.toLowerCase() === ink.name.toLowerCase();
        })) {
          selectSep.append($("<option>").val(ink.name).text(ink.name));
        }
      });
      this._interpolateRecipes();
      // }
    },

    _getIngredients: function _getIngredients() {
      var ingredient = {
        'resolution': this.options.settings.output.resolution_v,
        'separation': this.element.find('select').val()
      };
      var sepSetting = this.options.settings.separations;
      var dotshape = sepSetting.default_screen;
      var ruling = sepSetting.default_ruling;
      var angle = undefined;
      if (ingredient.separation !== 'Default ') {
        sepSetting.inks.some(function (ink) {
          if (ink.name === ingredient.separation) {
            if (sepSetting.override_dotshape) {
              dotshape = ink.dotshape;
            }
            if (sepSetting.override_rulings) {
              ruling = ink.ruling;
            }
            angle = ink.angle;
            return true;
          }
        });
      }
      ingredient.dotshape = dotshape;
      ingredient.ruling = ruling;
      if (angle !== undefined) {
        ingredient.angle = angle;
      }
      return ingredient;
    },
    _findFunction: function _findFunction(curve, ingredient) {
      for (var i = curve.functions.length - 1; i >= 0; i--) {
        var func = curve.functions[i];
        if (this._matchIngredient(func, ingredient)) {
          return func;
        }
      }
      return undefined;
    },
    _matchIngredient: function _matchIngredient(func, ingredient) {
      var strategy = func.strategy;
      if (strategy === undefined) {
        if (func.separation !== undefined && func.separation !== 'Default') {
          strategy = {
            'separation': func.separation
          };
        } else if (func.name !== undefined && func.name !== 'Default') {
          strategy = {
            'separation': func.name
          };
        } else {
          return true; // Default curve.
        }
      }

      for (var s in strategy) {
        if (ingredient[s] !== undefined) {
          if (strategy[s] !== ingredient[s]) {
            return false;
          }
        }
      }
      return true;
    },
    /**
     * @description function runs when user change the selected separation
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _changeSelectSeparationResultHandler: function _changeSelectSeparationResultHandler(pEvent, pData) {
      var that = this;
      // init
      this.element.children().show();
      this.element.find('.errorMessageInterpolation').hide();
      this.element.find('div.recipeApplied').hide();

      // get selected value
      var selectedSeparation = this.element.find('.selectingSeparations').val();
      // if ( ! this.prefRecipes ) {
      //     // Old calculation. Based only on the separation
      //     this._getInterpolations(this.separationFunctions[selectedSeparation]).done(function (pResults) {
      //         that._drawTable(pResults);
      //     }).fail(function (pError) {
      //         that.element.children().hide();
      //         that.element.find('.errorMessageInterpolation').text("Could not calculate results").show();
      //     });
      // } else
      this._interpolateRecipes();
    },
    /**
     * @description Find Recipes matching RIP settings and interpolate them
     * @function
     * @private
     */
    _interpolateRecipes: function _interpolateRecipes() {
      var that = this;
      var ingredient = this._getIngredients();
      var ingCurves = [];
      this.curves.forEach(function (c, index) {
        var ret = that._findFunction(c, ingredient);
        if (ret !== undefined) {
          ingCurves.push(ret);
          index++;
          var div = that.element.find('.recipeApplied[name="curve' + index + '"]').show();
          div.find('label.recipeName').text(ret.name || ret.separation);
        }
      });
      if (ingCurves.length === 0) {
        this.element.find('.errorMessageInterpolation').text("No Curve Recipe can be applied.").show();
        this.element.find(".interpolationCurveTable").hide();
      } else {
        this._getInterpolations(ingCurves).done(function (pResults) {
          that._drawTable(pResults);
        }).fail(function (pError) {
          that.element.children().hide();
          that.element.find('.errorMessageInterpolation').text("Could not calculate results").show();
          console.warn(pError);
          //that.element.find('.errorMessageInterpolation').text(pError).show();
          that.element.find(".interpolationCurveTable").hide();
        });
      }
    },
    /**
     * @desc remove the unused curve functions and adjust the unusedIndex tabel.
     * the lastest curves with are disabled must be removed from the curve array.
     * @function
     * @private
     * @returns {undefined}
     */
    _removeUnusedCurves: function _removeUnusedCurves() {
      // go from end to begin
      // if one found in unusedIndex tabel, remove curve and in unusedIndexTable and continue
      // if not found, break the loop.
      for (var i = this.curves.length - 1; i > 0; i--) {
        var index = this.undefinedCurvesIndexes.indexOf(i);
        if (index >= 0) {
          // if found
          delete this.curves[i];
          delete this.undefinedCurvesIndexes[index];
        } else {
          break;
        }
      }
      // remove the undefineds in the tables
      this.curves = $.map(this.curves, function (elem) {
        return elem;
      });
      this.undefinedCurvesIndexes = $.map(this.undefinedCurvesIndexes, function (elem) {
        return elem;
      });
    },
    /**
     * @desc Put the correct settings to from a correct cloudflow table
     * @function
     * @private
     * @param {array} pInterpolationResults - returning object from backend call interpolation
     * @returns {undefined}
     */
    _drawTable: function _drawTable(pInterpolationResults) {
      this.element.find(".interpolationCurveTable").Table({
        columns: $.map(pInterpolationResults.title, function (elem, index) {
          var label = elem;
          return {
            label: label,
            type: "percentage",
            sortable: false,
            key: index,
            cellClass: "curve" + index,
            headerClass: "curveTitle" + index
          };
        }),
        editCellEvent: false,
        additionalTypes: [{
          type: 'percentage',
          renderFunction: function renderFunction(pValue) {
            if (pValue === undefined) {
              return "";
            } else {
              return pValue.toFixed(2) + '%';
            }
          }
        }],
        keyUniqID: false,
        classes: "cf-table cf-table-fullwidth",
        dataProvider: function dataProvider(pSearch, pOrderBy, pSkip, pMaxRows) {
          return $.map(pInterpolationResults.points, function (elem, pointIndex) {
            var obj = {};
            $.each(pInterpolationResults.title, function (titleIndex, el) {
              obj[titleIndex] = elem[titleIndex];
            });
            return obj;
          });
        }
      }).find("table").css('table-layout', 'fixed');
      this._styleTable();
    },
    /**
     * @description style the point of undefined curves
     * @function
     * @private
     * @returns {undefined}
     */
    _styleTable: function _styleTable() {
      // style it
      if (this.undefinedCurvesIndexes.length > 0) {
        var that = this;
        for (var i = 0; i < that.undefinedCurvesIndexes.length; i++) {
          // first column is source, second is first curve => i+1 
          this.element.find(".nixps-cloudflow-Table tr td.curve" + (that.undefinedCurvesIndexes[i] + 1)).addClass("columnDisabled");
          this.element.find(".nixps-cloudflow-Table tr th.curveTitle" + (that.undefinedCurvesIndexes[i] + 1)).addClass("headerDisabled");
        }
      }
    },
    /**
     * @description calc the interpolation of the curves, it gives the differed
     * steps needs to go to the final curve set.
     * @private
     * @param {array} pCurveFunctions-  a array of functions
     * @returns {Deferred}
     */
    _getInterpolations: function _getInterpolations(pCurveFunctions) {
      return $.Deferred(function (pDefer) {
        if (Array.isArray(pCurveFunctions) && pCurveFunctions.length > 0) {
          api_async.curve.interpolate(pCurveFunctions, function (pResult) {
            pDefer.resolve(pResult);
          }, function (pError) {
            pDefer.reject(pError);
          });
        } else {
          pDefer.reject('Invalid function');
        }
      });
    },
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._draw();
    },
    /**
     * @brief sets the option
     * @private
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],306:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var Util = require('./Util.js');
  /**
      * README
      * 
      * 
      * @namespace nixps.RIPEditorCIP3
      * @description This component shows the panel to configure the CIP3 settings for the rip job
      */
  $.widget("nixps.RIPEditorCIP3", $.Widget, {
    widgetEventPrefix: "ripeditorcip3",
    options: {
      /**
                * @name nixps.RIPEditorCIP3#settings
                * @description The RIP Settings object
                * @type {Object}
                * @default undefined
                */
      settings: undefined,
      /**
       * @name nixps.RIPEditorCIP3#bootstrap
       * @desc Created in a bootstrap environment
       * @type {Boolean}
       * @default true
       */
      bootstrap: true,
      /**
       * @name nixps.RIPEditorCIP3#standaloneView
       * @description are we in standalone view or not?
       * @type {Boolean}
       * @default false
       */
      standaloneView: false,
      /**
       * @name nixps.RIPEditorCIP3#readOnly
       * @description Must we just open de panel in readOnly mode?
       * @type {Boolean}
       * @default false
       */
      readOnly: false,
      /**
       * @name nixps.RIPEditorCIP3#editingVisibility
       * @description Must the user be able to edit, change the visibility setting
       * @type {Boolean}
       * @default false
       */
      editingVisibility: false,
      /**
       * @name nixps.RIPEditorCIP3#applyVisibility
       * @description Must we apply the visibility setting
       * @type {Boolean}
       * @default true
       */
      applyVisibility: true
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.addClass("col-lg-6 cf-col-lg-6");
      // The panel
      var panel = $("<div>").addClass("panel panel-default cf-panel").appendTo(this.element);

      // Header for the Output Blob
      if (this.options.bootstrap) {
        var panelHeader = $("<div>").addClass("panel-heading");
        var title = $("<h3>").addClass("panel-title")._t("nixps-RIPEditor-CIP3.title");
        panelHeader.append(title);
        if (this.options.editingVisibility === true) {
          title.append($("<span>").addClass("visibleIcon fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        } else {
          title.append($("<span>").addClass("visibleIcon cf-hide fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        }
        panelHeader.appendTo(panel);
      }

      // The body of the panel
      var panelBody = $("<div>").addClass("panel-body");
      panelBody.appendTo(panel);
      this._addControls(panelBody);
      this._refresh();
      this._on(this.element, {
        'change select,input ': this._changeHandler,
        'click .visibleIcon': this._visibleIconClickHandler
      });
    },
    /**
    * @brief This function adds controls 
     * @name nixps.RIPEditorCIP3#_addControls
     * @function
     * @private
    */
    _addControls: function _addControls(pPanelBody) {
      this._addCIP3Settings(pPanelBody);
    },
    /**
     * @description This function creates the differends dom elements. It draws the panel.
     * @name nixps.RIPEditorCIP3#_addCIP3Settings
     * @function
     * @private
     * @param {type} pPanelBody
     * @returns {undefined}
     */
    _addCIP3Settings: function _addCIP3Settings(pPanelBody) {
      var generateCIP3 = $("<div>").addClass("checkbox").append($("<label>").append($("<input>").attr('type', "checkbox").attr('name', "cip3.generate").addClass('singelChoose cf-form-checkbox')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-CIP3.generate")));
      Util.createFormGroup("", generateCIP3).appendTo(pPanelBody);

      // resolution
      var previewResolution = $("<div>").addClass("row cf-form-group help-parameter-group").append("<label for=\"cip3.resolution\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-CIP3.previewresolution") + "<\label>");
      var controlsR = $("<div>").addClass("cf-col-xs-7").appendTo(previewResolution);
      // disable valuecomposers because there is some translation calculations, wait for expressionbuilder to handle calcs
      $("<input name=\"cip3.resolution\" type=\"number\" inputmode=\"decimal\" class=\"form-control cf-form-control cip3.resolution\" nixps-quantum-util-autobind='false'>").val('1').appendTo(controlsR);
      previewResolution.append("<label for=\"cip3.resolution\" class=\"col-xs-1 cf-col-xs-1 dpi-label cf-form-labeltail\">" + $.i18n._("nixps-units.resolution.display-dpi") + "</label>");
      previewResolution.appendTo(pPanelBody);

      // Paper size
      var papersizeBox = $("<select name=\"cip3.paper_box\">").addClass("form-control cf-form-control");
      papersizeBox.append("<option value=\"custom\">" + $.i18n._("nixps-RIPEditor-CIP3.custom_size") + "</option>");
      papersizeBox.append("<option value=\"mediabox\">" + $.i18n._("nixps-cloudflow-assets.mediabox") + "</option>");
      papersizeBox.append("<option value=\"cropbox\">" + $.i18n._("nixps-cloudflow-assets.cropbox") + "</option>");
      papersizeBox.append("<option value=\"trimbox\">" + $.i18n._("nixps-cloudflow-assets.trimbox") + "</option>");
      papersizeBox.append("<option value=\"bleedbox\">" + $.i18n._("nixps-cloudflow-assets.bleedbox") + "</option>");
      papersizeBox.append("<option value=\"artbox\">" + $.i18n._("nixps-cloudflow-assets.artbox") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-CIP3.paper_box"), papersizeBox).appendTo(pPanelBody);

      // paper width
      var paperWidth = $("<div>").addClass("row cf-form-group help-parameter-group").append("<label for=\"cip3.paper_width\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-CIP3.paperwidth") + "<\label>");
      var controlsPW = $("<div>").addClass("cf-col-xs-7").appendTo(paperWidth);
      $("<input name=\"cip3.paper_width\" placeholder=\" " + $.i18n._("nixps-RIPEditor-CIP3.paperwidth_placeholder") + " \" type=\"number\" inputmode=\"decimal\" class=\"form-control cf-form-control cip3.paper_width\">").val('1').appendTo(controlsPW);
      paperWidth.append($("<label>").attr("for", "cip3.paper_width").addClass("col-xs-1 cf-col-xs-1 dpi-label cf-form-labeltail")._t("nixps-units.length.display-mm"));
      paperWidth.appendTo(pPanelBody);

      // paper height
      var paperHeight = $("<div>").addClass("row cf-form-group help-parameter-group").append("<label for=\"cip3.paper_height\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-CIP3.paperheight") + "<\label>");
      var controlsPH = $("<div>").addClass("cf-col-xs-7").appendTo(paperHeight);
      $("<input name=\"cip3.paper_height\" placeholder=\" " + $.i18n._("nixps-RIPEditor-CIP3.paperwidth_placeholder") + " \" type=\"number\" inputmode=\"decimal\" class=\"form-control cf-form-control cip3.paper_height\">").val('1').appendTo(controlsPH);
      paperHeight.append($("<label>").attr("for", "cip3.paper_height").addClass("col-xs-1 cf-col-xs-1 dpi-label cf-form-labeltail")._t("nixps-units.length.display-mm"));
      paperHeight.appendTo(pPanelBody);

      // inverted polarity
      var invertedPolarity = $("<div>").addClass("checkbox").append($("<label>").append("<input type=\"checkbox\" name=\"cip3.inverted_polarity\" class=\"cf-form-checkbox\"/>").append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-CIP3.invertpolarity")));
      Util.createFormGroup("", invertedPolarity).appendTo(pPanelBody);

      // mirrored
      var mirrored = $("<div>").addClass("checkbox").append($("<label>").append("<input type=\"checkbox\" name=\"cip3.mirrored\" class=\"cf-form-checkbox\"/>").append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-CIP3.mirrored")));
      Util.createFormGroup("", mirrored).appendTo(pPanelBody);

      // Rotation
      var rotBox = $("<select name=\"cip3.rotation\">").attr("data-nixps-quantum-type", "number").addClass("form-control cf-form-control");
      rotBox.append("<option value=\"0\">" + $.i18n._("nixps-RIPEditor-CIP3.rotation_none") + "</option>");
      rotBox.append("<option value=\"90\">" + $.i18n._("nixps-RIPEditor-CIP3.rotation_90") + "</option>");
      rotBox.append("<option value=\"180\">" + $.i18n._("nixps-RIPEditor-CIP3.rotation_180") + "</option>");
      rotBox.append("<option value=\"270\">" + $.i18n._("nixps-RIPEditor-CIP3.rotation_270") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-CIP3.rotation"), rotBox).appendTo(pPanelBody);

      // Encoding
      var encodingBox = $("<select name=\"cip3.encoding\">").addClass("form-control cf-form-control");
      encodingBox.append("<option value=\"ASCIIHex\">" + $.i18n._("nixps-RIPEditor-CIP3.imageencoding_ascii") + "</option>");
      encodingBox.append("<option value=\"ASCII85\">" + $.i18n._("nixps-RIPEditor-CIP3.imageencoding_ascii85") + "</option>");
      encodingBox.append("<option value=\"Binary\">" + $.i18n._("nixps-RIPEditor-CIP3.imageencoding_binary") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-CIP3.imageencoding"), encodingBox).appendTo(pPanelBody);

      // Compression
      var compression = $("<select name=\"cip3.compression\">").addClass("form-control cf-form-control");
      compression.append("<option value=\"RunLengthDecode\">" + $.i18n._("nixps-RIPEditor-CIP3.imagecompression_runlength") + "</option>");
      compression.append("<option value=\"None\">" + $.i18n._("nixps-RIPEditor-CIP3.imagecompression_none") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-CIP3.imagecompression"), compression).appendTo(pPanelBody);

      // Device
      var deviceBox = $("<select name=\"cip3.device\">").addClass("form-control cf-form-control");
      deviceBox.append("<option value=\"generic\">" + $.i18n._("nixps-RIPEditor-CIP3.device_generic") + "</option>");
      deviceBox.append("<option value=\"heidelberg\">" + $.i18n._("nixps-RIPEditor-CIP3.device_heidelbergpress") + "</option>");
      deviceBox.append("<option value=\"heidelberg-web2\">" + $.i18n._("nixps-RIPEditor-CIP3.device_heidelbergpress_web2") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-CIP3.device"), deviceBox).appendTo(pPanelBody);
    },
    _refresh: function _refresh() {
      // Backwards compatible
      if (this.options.settings.cip3 === undefined) {
        if (this.options.settings.generate_cip3 !== undefined) {
          this.options.settings.cip3 = {
            generate: this.options.settings.generate_cip3,
            preview_width: this.options.settings.cip3_preview_width,
            preview_height: this.options.settings.cip3_preview_height
          };
        } else {
          this.options.settings.cip3 = {
            generate: false,
            preview_width: 1000,
            preview_height: 1000
          };
        }
      }
      if (this.options.applyVisibility === true) {
        if (this.options.settings.cip3.panel_visible === false) {
          this.element.hide();
        } else {
          this.element.css('display', '');
        }
      }
      if (this.options.editingVisibility === false && this.element.find(".visibleIcon").length > 0) {
        this.element.find(".visibleIcon").addClass("cf-hide");
      } else if (this.options.editingVisibility === true && this.element.find(".visibleIcon.cf-hide").length > 0) {
        this.element.find(".visibleIcon").removeClass("cf-hide");
      }

      // CIP3 Settings
      this.element.find('[name="cip3.generate"]').prop('checked', Util.getValue(this.options.settings.cip3.generate, false));
      this.element.find('[name="cip3.resolution"]').val((Util.getValue(this.options.settings.cip3.resolution, 25.0 / 25.4) * 25.4).toFixed(3)); // default to 25dpi = ±1dpmm
      this.element.find('[name="cip3.paper_box"]').val(Util.getValue(this.options.settings.cip3.paper_box, "custom"));
      this.element.find('[name="cip3.paper_width"]').val(Util.getValue(this.options.settings.cip3.paper_width, 0).toFixed(2));
      this.element.find('[name="cip3.paper_height"]').val(Util.getValue(this.options.settings.cip3.paper_height, 0).toFixed(2));
      this.element.find('[name="cip3.rotation"]').val(Util.getValue(this.options.settings.cip3.rotation, 0));
      this.element.find('[name="cip3.inverted_polarity"]').prop('checked', Util.getValue(this.options.settings.cip3.inverted_polarity, false));
      this.element.find('[name="cip3.mirrored"]').prop('checked', Util.getValue(this.options.settings.cip3.mirrored, false));
      this.element.find('[name="cip3.encoding"]').val(Util.getValue(this.options.settings.cip3.encoding, "ASCIIHex"));
      this.element.find('[name="cip3.device"]').val(Util.getValue(this.options.settings.cip3.device, "generic"));
      this.element.find('[name="cip3.compression"]').val(Util.getValue(this.options.settings.cip3.compression, "RunLengthDecode"));
      if (this.options.settings.cip3.panel_visible === false) {
        // set on invisible if set expecitly on false
        this.element.find('.visibleIcon').removeClass('fa-eye').addClass('fa-eye-slash');
      } else {
        // default visible on true
        this.element.find('.visibleIcon').removeClass('fa-eye-slash').addClass('fa-eye');
      }
      this._readOnlyChange();
      if (this.options.readOnly === false) {
        if (this.options.settings.cip3.paper_box === undefined || this.options.settings.cip3.paper_box === "custom") {
          this.element.find('[name="cip3.paper_width"]').prop("disabled", false);
          this.element.find('[name="cip3.paper_height"]').prop("disabled", false);
        } else {
          this.element.find('[name="cip3.paper_width"]').prop("disabled", true);
          this.element.find('[name="cip3.paper_height"]').prop("disabled", true);
        }
      }
    },
    /**
     * @brief this function runs when information changed, and trigger the change event
     * so the information is throws for further process
     * @name nixps.RIPEditorCIP3#_changeHandler
     * @function
     * @private
     * @param {object} pEvent
     * @returns {undefined}
     */
    _changeHandler: function _changeHandler(pEvent) {
      // cip3 setting
      if (this.options.settings.cip3 === undefined) {
        this.options.settings.cip3 = {};
      }
      this.options.settings.cip3.generate = this.element.find('[name="cip3.generate"]').is(':checked');
      this.options.settings.cip3.resolution = parseFloat(this.element.find('[name="cip3.resolution"]').val()) / 25.4;
      if (isNaN(this.options.settings.cip3.resolution)) {
        this.options.settings.cip3.resolution = 25.0 / 25.4;
      }
      this.options.settings.cip3.paper_box = this.element.find('[name="cip3.paper_box"]').val();
      this.options.settings.cip3.paper_width = parseFloat(this.element.find('[name="cip3.paper_width"]').val());
      if (isNaN(this.options.settings.cip3.paper_width)) {
        this.options.settings.cip3.paper_width = 0.0;
      }
      this.options.settings.cip3.paper_height = parseFloat(this.element.find('[name="cip3.paper_height"]').val());
      if (isNaN(this.options.settings.cip3.paper_height)) {
        this.options.settings.cip3.paper_height = 0.0;
      }
      this.options.settings.cip3.rotation = parseInt(this.element.find('[name="cip3.rotation"]').val());
      this.options.settings.cip3.inverted_polarity = this.element.find('[name="cip3.inverted_polarity"]').is(':checked');
      this.options.settings.cip3.mirrored = this.element.find('[name="cip3.mirrored"]').is(':checked');
      this.options.settings.cip3.encoding = this.element.find('[name="cip3.encoding"]').val();
      this.options.settings.cip3.device = this.element.find('[name="cip3.device"]').val();
      this.options.settings.cip3.compression = this.element.find('[name="cip3.compression"]').val();
      this._trigger("change", pEvent, {
        "settings": this.options.settings
      });
    },
    /**
     * @description function runs when user click on the eye icon
     * @function
     * @private
     * @name nixps.RIPEditorCIP3#_visibleIconClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _visibleIconClickHandler: function _visibleIconClickHandler(pEvent, pData) {
      if ($(pEvent.currentTarget).hasClass('fa-eye')) {
        $(pEvent.currentTarget).removeClass('fa-eye').addClass('fa-eye-slash');
        this.options.settings.cip3.panel_visible = false;
      } else {
        $(pEvent.currentTarget).removeClass('fa-eye-slash').addClass('fa-eye');
        this.options.settings.cip3.panel_visible = true;
      }
      this._trigger('change', pEvent, {
        "settings": this.options.settings
      });
    },
    _readOnlyChange: function _readOnlyChange() {
      this.element.find("input, select").prop("disabled", this.options.readOnly === true);
    },
    /**
     * @brief sets the option
           * @name nixps.RIPEditorCIP3#_setOptions
           * @function
           * @private
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._refresh();
    }
  });
})(jQuery);

},{"./Util.js":304}],307:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

(function ($) {
  var Util = require('./Util.js');
  $.widget("nixps.RIPEditorColor", {
    widgetEventPrefix: "ripeditorcolor",
    options: {
      /**
       * The RIP Settings object
       */
      settings: undefined,
      /**
       * Created in a bootstrap environment
       */
      bootstrap: true,
      /**
       * @description Must we just open de panel in readOnly mode?
       * @type {Boolean}
       * @default false
       */
      readOnly: false,
      /**
       * @description Must the user be able to edit, change the visibility setting
       * @type {boolean}
       * @default false
       */
      editingVisibility: false,
      /**
       * @description Must we apply the visibility setting
       * @type {boolean}
       * @default true
       */
      applyVisibility: true
    },
    /** 
     * @brief creates the output panel
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.addClass("col-lg-6 cf-col-lg-6");

      // The panel
      var panel = $("<div>").addClass("panel panel-default cf-panel");
      panel.appendTo(this.element);

      // Header for the Output Blob
      if (this.options.bootstrap) {
        var panelHeader = $("<div>").addClass("panel-heading");
        var title = $("<h3>").addClass("panel-title")._t("nixps-RIPEditor-color.title");
        panelHeader.append(title);
        if (this.options.editingVisibility === true) {
          title.append($("<span>").addClass("visibleIcon fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        } else {
          title.append($("<span>").addClass("visibleIcon cf-hide fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        }
        panelHeader.appendTo(panel);
      }

      // The body of the panel
      var panelBody = $("<div>").addClass("panel-body");
      panelBody.appendTo(panel);
      this._addControls(panelBody);
      this._refresh();
      this._on(this.element, {
        'change select,input ': this._changeHandler,
        'click .visibleIcon': this._visibleIconClickHandler
      });
    },
    /**
     * @brief This function adds controls 
     */
    _addControls: function _addControls(pPanelBody) {
      if (this.options.settings.color === undefined) {
        this.options.settings.color = {};
      }
      this._addInputProfiles(pPanelBody);
      this._addOutputProfiles(pPanelBody);
    },
    _addInputProfiles: function _addInputProfiles(pPanelBody) {
      pPanelBody.append($("<legend>").addClass("cf-legend")._t("nixps-RIPEditor-color.input_profiles"));

      // Input RGB profile
      var inputRGBProfile = $("<div>");
      inputRGBProfile.addClass("row cf-form-group help-parameter-group");
      inputRGBProfile.append("<label for=\"inputRGBSelector\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-color.input_RGB_profile") + "</label>");
      var controlsRGBProfile = $("<div>");
      controlsRGBProfile.addClass("cf-col-sm-8");
      controlsRGBProfile.appendTo(inputRGBProfile);
      var inputRGBSelector = $("<div>").attr("name", "color-input_rgb_profile").addClass("inputProfile");
      inputRGBSelector.ResourceSelector({
        text_when_empty: $.i18n._("nixps-RIPEditorColor.no_profile"),
        name: 'color.input_rgb_profile',
        resource_type: 'ICCProfile',
        value: this.options.settings.color.input_rgb_profile
      }).find('select').addClass("form-control cf-form-control");
      inputRGBSelector.appendTo(controlsRGBProfile);
      inputRGBProfile.appendTo(pPanelBody);

      // Input CMYK profile
      var inputCMYKProfile = $("<div>");
      inputCMYKProfile.addClass("row cf-form-group help-parameter-group");
      inputCMYKProfile.append("<label for=\"inputCMYKSelector\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-color.input_CMYK_profile") + "</label>");
      var controlsCMYKProfile = $("<div>");
      controlsCMYKProfile.addClass("cf-col-sm-8");
      controlsCMYKProfile.appendTo(inputCMYKProfile);
      var inputCMYKSelector = $("<div>").attr("name", "color-input_cmyk_profile").addClass("inputProfile");
      inputCMYKSelector.ResourceSelector({
        text_when_empty: $.i18n._("nixps-RIPEditorColor.no_profile"),
        name: 'color.input_cmyk_profile',
        resource_type: 'ICCProfile',
        value: this.options.settings.color.input_cmyk_profile
      }).find('select').addClass("form-control cf-form-control");
      inputCMYKSelector.appendTo(controlsCMYKProfile);
      inputCMYKProfile.appendTo(pPanelBody);
    },
    _addOutputProfiles: function _addOutputProfiles(pPanelBody) {
      pPanelBody.append($("<legend>").addClass("cf-legend")._t("nixps-RIPEditor-color.output_profiles"));

      // Output profile
      var outputProfile = $("<div>").addClass("row cf-form-group help-parameter-group").append("<label for=\"outputProfile\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-color.outputprofile") + "</label>");
      var controlsV = $("<div>").addClass("cf-col-sm-8").appendTo(outputProfile);
      var outputProfileSelector = $("<div>").attr("name", "color.output_profile").addClass("outputProfile");
      outputProfileSelector.ResourceSelector({
        text_when_empty: $.i18n._("nixps-RIPEditorColor.no_profile"),
        name: 'color_management_output_profile',
        resource_type: 'ICCProfile',
        value: this.options.settings.color_management_output_profile,
        addNameAttr: false
      }).find('select').addClass("form-control cf-form-control");
      outputProfileSelector.appendTo(controlsV);
      outputProfile.appendTo(pPanelBody);

      // Ignore ICC Tagged Objects
      var taggedObjects = $("<div>").addClass("checkbox").append("<label><input type=\"checkbox\" name=\"color.ignore_tagged_objects\" class=\"singelChoose cf-form-checkbox\"/><span class='cf-form-checkboxlabel'>" + $.i18n._("nixps-RIPEditor-color.ignoretaggedobjects") + "</span></label>");
      Util.createFormGroup("", taggedObjects).appendTo(pPanelBody);

      // Preserve Black
      var taggedObjects = $("<div>").addClass("checkbox").append("<label><input type=\"checkbox\" name=\"color.preserve_black\" class=\"singelChoose cf-form-checkbox\"/><span class='cf-form-checkboxlabel'>" + $.i18n._("nixps-RIPEditor-color.preserve_black") + "</span></label>");
      Util.createFormGroup("", taggedObjects).appendTo(pPanelBody);
    },
    _refresh: function _refresh() {
      if (this.options.applyVisibility === true) {
        if (this.options.settings.color !== undefined && this.options.settings.color.panel_visible === false) {
          this.element.hide();
        } else {
          this.element.css('display', '');
        }
      }
      if (this.options.editingVisibility === false && this.element.find(".visibleIcon").length > 0) {
        this.element.find(".visibleIcon").addClass("cf-hide");
      } else if (this.options.editingVisibility === true && this.element.find(".visibleIcon.cf-hide").length > 0) {
        this.element.find(".visibleIcon").removeClass("cf-hide");
      }
      this.element.find('div[name="color.output_profile"]').ResourceSelector('option', 'value', this.options.settings.color_management_output_profile);
      if (!$.isEmptyObject(this.options.settings.color)) {
        this.element.find('div.nixps-cloudflow-ResourceSelector[name="color-input_cmyk_profile"]').ResourceSelector('option', 'value', this.options.settings.color.input_cmyk_profile);
        this.element.find('div.nixps-cloudflow-ResourceSelector[name="color-input_rgb_profile"]').ResourceSelector('option', 'value', this.options.settings.color.input_rgb_profile);
        this.element.find('[name="color.ignore_tagged_objects"]').prop('checked', Util.getValue(this.options.settings.color.ignore_tagged_objects, false));
        this.element.find('[name="color.preserve_black"]').prop('checked', Util.getValue(this.options.settings.color.preserve_black, false));
      } else {
        this.element.find('div.nixps-cloudflow-ResourceSelector[name="color-input_cmyk_profile"]').ResourceSelector('option', 'value', "");
        this.element.find('div.nixps-cloudflow-ResourceSelector[name="color-input_rgb_profile"]').ResourceSelector('option', 'value', "");
      }
      if (this.options.settings.color !== undefined && this.options.settings.color.panel_visible === false) {
        // set on invisible if set expecitly on false
        this.element.find('.visibleIcon').removeClass('fa-eye').addClass('fa-eye-slash');
      } else {
        // default visible on true
        this.element.find('.visibleIcon').removeClass('fa-eye-slash').addClass('fa-eye');
      }
      this._readOnlyChange();
    },
    /**
     * @brief this function runs when information changed, and trigger the change event
     * so the information is throws for further process
     * @param {object} pEvent
     * @returns {undefined}
     */
    _changeHandler: function _changeHandler(pEvent) {
      // information is situated in the root of the settings
      this.options.settings.color_management_output_profile = this.element.find('[name="color_management_output_profile"]').val();
      if (this.options.settings.color === undefined) {
        this.options.settings.color = {};
      }
      this.options.settings.color.input_cmyk_profile = this.element.find('div.nixps-cloudflow-ResourceSelector[name="color-input_cmyk_profile"]').ResourceSelector("getValue");
      this.options.settings.color.input_rgb_profile = this.element.find('div.nixps-cloudflow-ResourceSelector[name="color-input_rgb_profile"]').ResourceSelector("getValue");
      this.options.settings.color.ignore_tagged_objects = this.element.find('[name="color.ignore_tagged_objects"]').is(':checked');
      this.options.settings.color.preserve_black = this.element.find('[name="color.preserve_black"]').is(':checked');
      this._trigger('change', pEvent, {
        "settings": this.options.settings
      });
    },
    /**
     * @description function runs when user click on the eye icon
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _visibleIconClickHandler: function _visibleIconClickHandler(pEvent, pData) {
      if ($(pEvent.currentTarget).hasClass('fa-eye')) {
        $(pEvent.currentTarget).removeClass('fa-eye').addClass('fa-eye-slash');
        this.options.settings.color.panel_visible = false;
      } else {
        $(pEvent.currentTarget).removeClass('fa-eye-slash').addClass('fa-eye');
        this.options.settings.color.panel_visible = true;
      }
      this._trigger('change', pEvent, {
        "settings": this.options.settings
      });
    },
    _readOnlyChange: function _readOnlyChange() {
      this.element.find('input, select').prop('disabled', this.options.readOnly === true);
    },
    /**
     * @brief sets the option
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._refresh();
    }
  });
})(jQuery);

},{"./Util.js":304}],308:[function(require,module,exports){
"use strict";

/**
 * 
 * alias calibrations
 * 
 */
(function ($) {
  var Util = require('./Util.js');
  var CurveToolKit = require('../../../../rip/js/curves/CurveToolKit.js');

  /**
   * README
   * 
   * Curve 1 -> use_reference_curve / name_referencecurve
   * Curve 2 -> use_calibration_curve / name_presscurve
   * Curve 3 -> use_device_curve / name_platecurve
   * 
   * 
   */
  $.widget("nixps.RIPEditorCurves", {
    widgetEventPrefix: "ripeditorcurves",
    options: {
      /**
       * The RIP Settings object
       */
      settings: undefined,
      /**
       * @description Must we just open de panel in readOnly mode?
       * @type {Boolean}
       * @default false
       */
      readOnly: false,
      /**
       * @description Must the user be able to edit, change the visibility setting
       * @type {Boolean}
       * @default false
       */
      editingVisibility: false,
      /**
       * @description Must we apply the visibility setting
       * @type {Boolean}
       * @default true
       */
      applyVisibility: true
    },
    /** 
     * @brief creates the output panel
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.addClass("col-lg-6 cf-col-lg-6");
      this.CurvesData = [];
      this.undefinedCurvesIndexes = [];
      this.prefRecipes = true;

      // The panel
      var panel = $("<div>").addClass("panel panel-default cf-panel");
      panel.appendTo(this.element);

      // Header for the Output Blob
      if (this.options.bootstrap) {
        var panelHeader = $("<div>").addClass("panel-heading");
        var title = $("<h3>").addClass("panel-title")._t("nixps-RIPEditor-calibration.title");
        panelHeader.append(title);
        if (this.options.editingVisibility === true) {
          title.append($("<span>").addClass("visibleIcon fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        } else {
          title.append($("<span>").addClass("visibleIcon cf-hide fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        }
        panelHeader.appendTo(panel);
      }

      // The body of the panel
      var panelBody = $("<div>").addClass("panel-body");
      panelBody.appendTo(panel);
      this._addControls(panelBody);
    },
    /**
     * @brief This function adds controls 
     */
    _addControls: function _addControls(pPanelBody) {
      if (this.options.settings.rip_curves === undefined) {
        this.options.settings.rip_curves = this._getDefaults();
      }
      $("<legend>").addClass("cf-legend").append($('<span>')._t('nixps-RIPEditor-calibration.sub_title')).appendTo(pPanelBody);

      /************ curve one  // reference curve ********************/
      this.referenceCurveSelector = $("<div>").attr("name", "referenceCurveResourceSelector").addClass("curveReferenceSelector group cf-form-group");
      this.referenceCurveSelector.ResourceSelector({
        text_when_empty: $.i18n._("nixps-RIPEditorCurves.no_curves"),
        name: 'rip_curves.name_referencecurve',
        resource_type: 'CloudflowCurve',
        allowNoResource: false,
        value: this.options.settings.rip_curves.name_referencecurve
      });

      /************ curve 2  // press curve // use calibration curve  ********************/
      this.pressCurveSelector = $("<div>").attr("name", "pressCurveResourceSelector").addClass("curvePressSelection group cf-form-group");
      this.pressCurveSelector.ResourceSelector({
        text_when_empty: $.i18n._("nixps-RIPEditorCurves.no_curves"),
        name: 'rip_curves.name_presscurve',
        resource_type: 'CloudflowCurve',
        allowNoResource: false,
        value: this.options.settings.rip_curves.name_presscurve
      });

      /************ curve 3  // plate curve // use device curve  ********************/
      this.plateCurveSelector = $("<div>").attr('name', "plateCurveResourceSelector").addClass("curvePlateSelection group cf-form-group");
      this.plateCurveSelector.ResourceSelector({
        text_when_empty: $.i18n._("nixps-RIPEditorCurves.no_curves"),
        name: 'rip_curves.name_platecurve',
        resource_type: 'CloudflowCurve',
        allowNoResource: false,
        value: this.options.settings.rip_curves.name_platecurve
      });
      var curveDetails = [['use_reference_curve', 'curveReferenceCheck', this.referenceCurveSelector], ['use_calibration_curve', 'curvePressCheck', this.pressCurveSelector], ['use_device_curve', 'curvePlateCheck', this.plateCurveSelector]];
      for (var i = 0; i < curveDetails.length; i++) {
        var row = $('<div>').addClass('checkbox group cf-form-group').append($('<label>').append($('<input>').attr('type', 'checkbox').attr('name', 'rip_curves.' + curveDetails[i][0]).addClass('cf-form-checkbox curve_enable singelChoose ' + curveDetails[i][1])).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-calibration.enablecurve" + (i + 1)))).appendTo(pPanelBody);
        curveDetails[i][2].appendTo(pPanelBody);
      }

      /******** adding warnings and error **************/
      $('<div>').addClass('curveErrorContainer warningMessage cf-message-warning').append($("<span>").addClass('fa fa-exclamation-triangle')).append($("<span>").addClass('curveErrorText')).hide().appendTo(pPanelBody);
      $('<div>').addClass('curveInfoContainer infoMessage cf-message-basic').append($("<span>").addClass('fa fa-exclamation-triangle')).append($("<span>").addClass('curveInfoText').css("margin-left", "8px")).hide().appendTo(pPanelBody);

      /******** end adding curves elements **************/
      this.element.find('select').addClass('form-control cf-form-control').css({
        'margin-top': '5px'
      });

      /********* add resulting curve settings:points ********/
      $("<div>").addClass("showResultButton hideInSummary").append($("<legend>").addClass("cf-legend").append($('<span>').addClass('fa fa-caret-right IconResultCollapse hideInSummary').css({
        'margin-right': 5
      })).append($('<span>')._t('nixps-RIPEditor-calibration.callibrationresults')).append($('<span>')._t('nixps-RIPEditor-calibration.applicationorder').css("float", "right"))).appendTo(pPanelBody);
      $('<div>').addClass('resultingPanelErrorContainer hideInSummary warningMessage cf-message-warning').append($("<span>").addClass('fa fa-exclamation-triangle')).append($("<span>").addClass('resultingPanelErrorText hideInSummary')).hide().appendTo(pPanelBody);
      $('<span>').addClass('fa fa-refresh refreshResultingPanel hideInSummary').css({
        "float": "right",
        cursor: "pointer"
      }).hide().appendTo(pPanelBody);
      $("<div>").addClass("resultingPanel hideInSummary").css({
        'margin-left': 35
      }).hide().appendTo(pPanelBody);
      this._refresh();
      this._on(this.element, {
        'change .nixps-cloudflow-ResourceSelector': this._changeHandler,
        'change input[type=checkbox]': this._changeHandler,
        'click .showResultButton': this._resultToggleHandler,
        'click .refreshResultingPanel': this._refreshClickHandler,
        'click .visibleIcon': this._visibleIconClickHandler
      });
    },
    _changeHandler: function _changeHandler(pEvent) {
      this.options.settings.rip_curves.use_calibration_curve = this.element.find('[name="rip_curves.use_calibration_curve"]').is(':checked');
      this.options.settings.rip_curves.use_device_curve = this.element.find('[name="rip_curves.use_device_curve"]').is(':checked');
      this.options.settings.rip_curves.use_reference_curve = this.element.find('[name="rip_curves.use_reference_curve"]').is(':checked');
      this.options.settings.rip_curves.name_platecurve = this.element.find('[name="rip_curves.name_platecurve"]').val();
      this.options.settings.rip_curves.name_presscurve = this.element.find('[name="rip_curves.name_presscurve"]').val();
      this.options.settings.rip_curves.name_referencecurve = this.element.find('[name="rip_curves.name_referencecurve"]').val();
      this._checkReferences();
      this._trigger('change', pEvent, {
        "settings": this.options.settings
      });
    },
    _checkReferences: function _checkReferences() {
      var that = this;
      var defers = [];
      if (this.options.settings.rip_curves.use_reference_curve === true && typeof this.options.settings.rip_curves.name_referencecurve === "string" && this.options.settings.rip_curves.name_referencecurve.length > 0) {
        defers.push(api_defer.curve.read_file(this.options.settings.rip_curves.name_referencecurve));
      }
      if (this.options.settings.rip_curves.use_calibration_curve === true && typeof this.options.settings.rip_curves.name_presscurve === "string" && this.options.settings.rip_curves.name_presscurve.length > 0) {
        defers.push(api_defer.curve.read_file(this.options.settings.rip_curves.name_presscurve));
      }
      if (this.options.settings.rip_curves.use_device_curve === true && typeof this.options.settings.rip_curves.name_platecurve === "string" && this.options.settings.rip_curves.name_platecurve.length > 0) {
        defers.push(api_defer.curve.read_file(this.options.settings.rip_curves.name_platecurve));
      }
      $.when.apply($, defers).then(function (curve1, curve2, curve3) {
        var results = [curve1, curve2, curve3];
        var hasRef = false;
        for (var i = 0; i < results.length; i++) {
          var item = results[i];
          if (item === undefined) {
            continue;
          }
          if (item.data && Array.isArray(item.data.functions) && item.data.functions.length > 0) {
            var referenceFunctions = item.data.functions.filter(function (pVal) {
              return !!(pVal.use_reference_curve && pVal.use_reference_curve.curve);
            });
            if (referenceFunctions.length > 0) {
              hasRef = true;
            }
          }
        }
        if (hasRef === true) {
          that.element.find('.curveInfoContainer').css("display", "");
          that.element.find('.curveInfoText')._t("nixps-RIPEditor-calibration.messagecurvesref");
        } else {
          that.element.find('.curveInfoContainer').hide();
        }
      });
    },
    /**
     * @description function runs when user press separation choice, select item
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _resultToggleHandler: function _resultToggleHandler(pEvent, pData) {
      var panel = this.element.find(".resultingPanel");
      if (panel.hasClass('active')) {
        this.element.find(".resultingPanelErrorContainer, .refreshResultingPanel").hide();
        panel.removeClass('active').hide();
        this.element.find('.IconResultCollapse').removeClass("fa-caret-down").addClass("fa-caret-right");
      } else {
        panel.addClass('active');
        this.element.find('.IconResultCollapse').removeClass("fa-caret-right").addClass("fa-caret-down");
        this._addResultingCurve();
      }
    },
    /**
     * @description function runs when user press refresh button
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _refreshClickHandler: function _refreshClickHandler(pEvent, pData) {
      this._refresh();
    },
    /**
     * @description function runs when user click on the eye icon
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _visibleIconClickHandler: function _visibleIconClickHandler(pEvent, pData) {
      if ($(pEvent.currentTarget).hasClass('fa-eye')) {
        $(pEvent.currentTarget).removeClass('fa-eye').addClass('fa-eye-slash');
        this.options.settings.rip_curves.panel_visible = false;
      } else {
        $(pEvent.currentTarget).removeClass('fa-eye-slash').addClass('fa-eye');
        this.options.settings.rip_curves.panel_visible = true;
      }
      this._trigger('change', pEvent, {
        "settings": this.options.settings
      });
    },
    _refresh: function _refresh() {
      var that = this;
      var rip_curves;
      if (this.options.settings !== undefined && this.options.settings.rip_curves !== undefined) {
        rip_curves = this.options.settings.rip_curves;
      } else {
        rip_curves = this._getDefaults();
      }

      // apply visibility setting
      if (this.options.applyVisibility === true) {
        if (this.options.settings.rip_curves.panel_visible === false) {
          this.element.hide();
        } else {
          this.element.css('display', '');
        }
      }
      if (this.options.editingVisibility === false && this.element.find(".visibleIcon").length > 0) {
        this.element.find(".visibleIcon").addClass("cf-hide");
      } else if (this.options.editingVisibility === true && this.element.find(".visibleIcon.cf-hide").length > 0) {
        this.element.find(".visibleIcon").removeClass("cf-hide");
      }
      this.element.find('[name="rip_curves.use_calibration_curve"]').prop('checked', Util.getValue(rip_curves.use_calibration_curve, false));
      this.element.find('[name="rip_curves.use_device_curve"]').prop('checked', Util.getValue(rip_curves.use_device_curve, false));
      this.element.find('[name="rip_curves.use_reference_curve"]').prop('checked', Util.getValue(rip_curves.use_reference_curve, false));
      this.plateCurveSelector.ResourceSelector('option', 'value', this.options.settings.rip_curves.name_platecurve);
      this.pressCurveSelector.ResourceSelector('option', 'value', this.options.settings.rip_curves.name_presscurve);
      this.referenceCurveSelector.ResourceSelector('option', 'value', this.options.settings.rip_curves.name_referencecurve);
      if (rip_curves.use_calibration_curve) {
        this.pressCurveSelector.show();
      } else {
        this.pressCurveSelector.hide();
      }
      if (rip_curves.use_device_curve) {
        this.plateCurveSelector.show();
      } else {
        this.plateCurveSelector.hide();
      }
      if (rip_curves.use_reference_curve) {
        this.referenceCurveSelector.show();
      } else {
        this.referenceCurveSelector.hide();
      }
      // get data from curves and control them
      this._getdata().done(function (curvePress, curvePlat, curveRef) {
        // init ui
        that.element.find(".resultingPanelErrorContainer, .refreshResultingPanel").hide();
        // init curve settings
        that.CurvesData = [];
        that.CurvesData.push(curveRef);
        that.CurvesData.push(curvePress);
        that.CurvesData.push(curvePlat);
        // control curves and show error messages
        if (that._controlAndShowErrorMessage() === false) {
          // no errors found, we can show the results
          // fill missing separations with default separations.
          if (!that.prefRecipes) {
            that.CurvesData = CurveToolKit.fillEmptyFunctionsInArray(that.CurvesData, true);
          }
          if (rip_curves.use_calibration_curve || rip_curves.use_device_curve || rip_curves.use_reference_curve) {
            that.element.find(".showResultButton").show();
            if (that.element.find('.resultingPanel').hasClass('active')) {
              that._addResultingCurve();
            }
          } else {
            that.element.find(".showResultButton").hide();
            that.element.find('.resultingPanel').hide();
            that.element.find(".resultingPanelErrorContainer, .refreshResultingPanel").hide();
          }
        }
      }).fail(function (pError) {
        // show error on loading the curves files
        that.element.find(".resultingPanel, .showResultButton, .curveErrorContainer, .refreshResultingPanel").hide();
        that.element.find(".resultingPanelErrorContainer").show();
        that.element.find(".resultingPanelErrorText")._t("nixps-RIPEditor-calibration.messagecurvesnotfound");
        console.warn(pError);
      });
      if (this.options.settings.rip_curves.panel_visible === false) {
        // set on invisible if set expecitly on false
        this.element.find('.visibleIcon').removeClass('fa-eye').addClass('fa-eye-slash');
      } else {
        // default visible on true
        this.element.find('.visibleIcon').removeClass('fa-eye-slash').addClass('fa-eye');
      }
      this._readOnlyChange();
    },
    _readOnlyChange: function _readOnlyChange() {
      this.element.find('input, select').prop('disabled', this.options.readOnly === true);
    },
    /**
     * @description function to reinit the panel, use for in quantum open node
     * @function
     * @param {type} pRip_curves
     * @returns {undefined}
     */
    reinit: function reinit(pRip_curves) {
      if ($.isPlainObject(pRip_curves) && !$.isEmptyObject(pRip_curves)) {
        if (pRip_curves.use_reference_curve === true) {
          this.referenceCurveSelector.ResourceSelector('option', 'value', pRip_curves.name_referencecurve).show();
        }
        if (pRip_curves.use_calibration_curve === true) {
          this.pressCurveSelector.ResourceSelector('option', 'value', pRip_curves.name_presscurve).show();
        }
        if (pRip_curves.use_device_curve === true) {
          this.plateCurveSelector.ResourceSelector('option', 'value', pRip_curves.name_platecurve).show();
        }
      }
    },
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._refresh();
    },
    _getDefaults: function _getDefaults() {
      return {
        "use_calibration_curve": false,
        "name_presscurve": "",
        "use_device_curve": false,
        "name_platecurve": "",
        "use_reference_curve": false,
        "name_referencecurve": ""
      };
    },
    /**
     * @description (Re)Draw the table with the resulting points and all intermedian steps.
     * @function
     * @private
     * @returns {undefined}
     */
    _addResultingCurve: function _addResultingCurve() {
      var that = this;
      that.element.find(".refreshResultingPanel").show();
      that.element.find(".resultingPanel").show().CurveInterpolationData({
        curves: that.CurvesData,
        // all curves, also the disabled
        settings: that.options.settings,
        // Resolution, dotshape, ruling ...
        undefinedCurvesIndexes: that.undefinedCurvesIndexes // index of disabled curves, columns
      });
    },

    /**
     * @description Control if we found a error in the curve set. We show the error message.
     * return true if error found, otherwise return false.
     * @function
     * @private
     * @returns {Boolean} has there a error? true if error found, fals if no error is found
     */
    _controlAndShowErrorMessage: function _controlAndShowErrorMessage() {
      var rip_curves = this.options.settings.rip_curves;
      // add only the used curves
      var CurveDataToControl = [];
      if (rip_curves.use_reference_curve === true) {
        CurveDataToControl.push(this.CurvesData[0]);
      }
      if (rip_curves.use_calibration_curve === true) {
        CurveDataToControl.push(this.CurvesData[1]);
      }
      if (rip_curves.use_device_curve === true) {
        CurveDataToControl.push(this.CurvesData[2]);
      }
      // loop from beginning to element before end, end exclusive
      for (var i = 0; i < CurveDataToControl.length - 1; i++) {
        if (CurveToolKit.hasCurveBump(CurveDataToControl[i]) === true) {
          this.element.find('.curveErrorContainer').show();
          this.element.find('.curveErrorText')._t("nixps-RIPEditor-calibration.messagecurvesbump");
          this.element.find(".showResultButton").hide();
          this.element.find('.resultingPanel, .refreshResultingPanel').hide();
          return true;
        }
      }
      this.element.find('.curveErrorContainer').hide();
      return false;
    },
    /**
     * @description get all backend data of the set of curves, from the three curves.
     * if a curve is disabled, replace:return whith a lineare curve f(x) = x;
     * @function
     * @private
     * @returns {Promise}
     */
    _getdata: function _getdata() {
      var deferredPress = $.Deferred();
      var deferredPlat = $.Deferred();
      var deferredRef = $.Deferred();
      this.undefinedCurvesIndexes = [];
      if (this.options.settings.rip_curves.use_reference_curve === true) {
        if (typeof this.options.settings.rip_curves.name_referencecurve === "string" && this.options.settings.rip_curves.name_referencecurve.length > 0) {
          api_async.curve.read_file(this.options.settings.rip_curves.name_referencecurve, function (pResult) {
            deferredRef.resolve(pResult.data);
          }, deferredRef.reject);
        } else {
          //deferredRef.reject("invalid curve url");
          this.undefinedCurvesIndexes.push(0);
          deferredRef.resolve(CurveToolKit.getLinearCurve());
        }
      } else {
        this.undefinedCurvesIndexes.push(0);
        deferredRef.resolve(CurveToolKit.getLinearCurve());
      }
      if (this.options.settings.rip_curves.use_calibration_curve === true) {
        if (typeof this.options.settings.rip_curves.name_presscurve === "string" && this.options.settings.rip_curves.name_presscurve.length > 0) {
          api_async.curve.read_file(this.options.settings.rip_curves.name_presscurve, function (pResult) {
            deferredPress.resolve(pResult.data);
          }, deferredPress.reject);
        } else {
          //deferredPress.reject("invalid curve url");
          this.undefinedCurvesIndexes.push(1);
          deferredPress.resolve(CurveToolKit.getLinearCurve());
        }
      } else {
        this.undefinedCurvesIndexes.push(1);
        deferredPress.resolve(CurveToolKit.getLinearCurve());
      }
      if (this.options.settings.rip_curves.use_device_curve === true) {
        if (typeof this.options.settings.rip_curves.name_platecurve === "string" && this.options.settings.rip_curves.name_platecurve.length > 0) {
          api_async.curve.read_file(this.options.settings.rip_curves.name_platecurve, function (pResult) {
            deferredPlat.resolve(pResult.data);
          }, deferredPlat.reject);
        } else {
          // deferredPlat.reject("invalid curve url");
          this.undefinedCurvesIndexes.push(2);
          deferredPlat.resolve(CurveToolKit.getLinearCurve());
        }
      } else {
        this.undefinedCurvesIndexes.push(2);
        deferredPlat.resolve(CurveToolKit.getLinearCurve());
      }
      return $.when(deferredPress, deferredPlat, deferredRef);
    }
  });
})(jQuery);

},{"../../../../rip/js/curves/CurveToolKit.js":445,"./Util.js":304}],309:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

(function ($) {
  /**
   * @description component to fill in the input files from the "clouflow RIP" node in the workflowbuilder.
   * this component should only be activ in workflowbuilder, there it work with autobind,
   * other components get and set the values
   */
  $.widget("nixps.RIPEditorInput", {
    widgetEventPrefix: "ripeditorinput",
    options: {},
    /** 
     * @brief creates the input panel
     */
    _create: function _create() {
      var bootstrap = this.element.closest(':nixps-RIPEditor').RIPEditor('option', 'bootstrap') === true;
      if (bootstrap === true) {
        // Do not create the filesToRIP control (input files) if not in created in node editor context in the workflow editor
        throw new Error('this component can only be used in the workflow editor');
      }
      this.element.addClass(this.widgetFullName).addClass("col-lg-6");

      // The panel
      var panel = $("<div>").addClass("panel panel-default cf-panel").appendTo(this.element);

      // The body of the panel
      var panelBody = $("<div>").addClass("panel-body").css({
        paddingTop: 10
      }).appendTo(panel);
      this._addControls(panelBody);
    },
    /**
     * @brief This function adds controls 
     */
    _addControls: function _addControls(pPanelBody) {
      var formGroup = $("<div>").addClass("row help-parameter-group").append("<label for='name' class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-input.filestorip") + "</label>");
      var inputPanel = $('<div class="cf-col-sm-8">').append($('<input>').attr('name', 'files').addClass('fieldvalue').hide());
      inputPanel.appendTo(formGroup);
      formGroup.appendTo(pPanelBody);
    },
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],310:[function(require,module,exports){
"use strict";

(function ($) {
  var Util = require("./Util.js");
  var LicenseFactory = require("../../../../cloudflow/License/js/License.js");
  var SystemUnitPreferences = require("../../../../cloudflow/Units/js/SystemUnitPreferences.js");
  var Value = require("../../../../cloudflow/Units/js/Value.js");
  $.widget("nixps.RIPEditorOutput", {
    widgetEventPrefix: "ripeditoroutput",
    options: {
      /**
       * @description The language of the user, We hope this will be fill in by the formrenderer
       * @type {String}
       * @default null
       */
      language: null,
      /**
       * @description The RIP Settings object
       * @default undefined
       */
      settings: undefined,
      /**
       * @description Created in a bootstrap environment
       * @type {Boolean}
       * @default true
       */
      bootstrap: true,
      /**
       * @bief Is the Editor used in "Submission" mode (true) or in "Preset Edition" mode.
       * @type {Boolean}
       * @default false
       */
      standaloneView: false,
      /**
       * @description Must we just open de panel in readOnly mode?
       * @type {Boolean}
       * @default false
       */
      readOnly: false,
      /**
       * @description Must the user be able to edit, change the visibility setting
       * @type {Boolean}
       * @default false
       */
      editingVisibility: false,
      /**
       * @description Must we apply the visibility setting
       * @type {Boolean}
       * @default true
       */
      applyVisibility: true
    },
    /** 
     * @brief creates the output panel
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.addClass("col-lg-6 cf-col-lg-6");

      // The panel
      var panel = $("<div>").addClass("panel panel-default cf-panel");
      panel.appendTo(this.element);

      // Header for the Output Blob
      if (this.options.bootstrap) {
        var panelHeader = $("<div>").addClass("panel-heading");
        var title = $("<h3>").addClass("panel-title")._t("nixps-RIPEditor-output.title");
        panelHeader.append(title);
        if (this.options.editingVisibility === true) {
          title.append($("<span>").addClass("visibleIcon fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        } else {
          title.append($("<span>").addClass("visibleIcon cf-hide fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        }
        panelHeader.appendTo(panel);
      }

      // The body of the panel
      var panelBody = $("<div>").addClass("panel-body");
      panelBody.appendTo(panel);
      this._addControls(panelBody);
      this._refresh();
      this._on(this.element, {
        "change select": this._changeHandler,
        "change input": this._changeHandler,
        "valueinputchange": this._changeHandler,
        "click .visibleIcon": this._visibleIconClickHandler
      });
    },
    /**
     * @brief This function adds controls 
     */
    _addControls: function _addControls(pPanelBody) {
      if (this.options.standaloneView === false) {
        var outputFolder = $("<input>").addClass("form-control cf-form-control outputFolder").attr("type", "text").attr("name", "output_folder").attr("inputmode", "url").val(this.options.output_folder);
        Util.createFormGroup($.i18n._("nixps-RIPEditor-output.output_folder"), outputFolder).appendTo(pPanelBody);
        var folderOutput = $("<div>").addClass("checkbox").append("<label><input type=\"checkbox\" name=\"output.output_folder_only\" class=\"singelChoose cf-form-checkbox\"/><span class=\"cf-form-checkboxlabel\">" + $.i18n._("nixps-RIPEditor-output.output_folder_only") + "</span></label>");
        Util.createFormGroup("", folderOutput).appendTo(pPanelBody);
      }
      this._addOutputType(pPanelBody);
      this._addResolution(pPanelBody);
      this._addOutputProperties(pPanelBody);
      this._addHPSProperties(pPanelBody);
      this._addTIFFSettings(pPanelBody);
    },
    _addResolution: function _addResolution(pPanelBody) {
      pPanelBody.append($("<legend>").addClass("cf-legend")._t("nixps-RIPEditor-output.sub_title_resolution"));

      // Horizontal Resolution
      var resolutionGroupH = $("<div>").addClass("row cf-form-group help-parameter-group panel-baseline");
      resolutionGroupH.append("<label for=\"output.resolution_h\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-output.horizontal") + "</label>");
      var controlsH = $("<div>").addClass("cf-col-xs-7");
      controlsH.appendTo(resolutionGroupH);
      var rulingSettingH = $("<input name=\"output.resolution_h\" type=\"text\" class=\"form-control cf-form-control\" inputmode=\"decimal\" data-nixps-quantum-type='number'>");
      rulingSettingH.appendTo(controlsH);
      resolutionGroupH.append("<label for=\"output.resolution_h\" class=\"col-xs-1 cf-col-xs-1 dpi-label cf-form-labeltail\">" + $.i18n._("nixps-units.resolution.display-dpi") + "</label>");
      resolutionGroupH.appendTo(pPanelBody);

      // Vertical Resolution
      var resolutionGroupV = $("<div>").addClass("row cf-form-group help-parameter-group panel-baseline");
      resolutionGroupV.append("<label for=\"output.resolution_v\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-output.vertical") + "</label>");
      var controlsV = $("<div>").addClass("cf-col-xs-7");
      controlsV.appendTo(resolutionGroupV);
      var rulingSettingV = $("<input name=\"output.resolution_v\" type=\"text\" class=\"form-control cf-form-control\" inputmode=\"decimal\" data-nixps-quantum-type='number'>");
      rulingSettingV.appendTo(controlsV);
      resolutionGroupV.append("<label for=\"output.resolution_v\" class=\"col-xs-1 cf-col-xs-1 dpi-label cf-form-labeltail\">" + $.i18n._("nixps-units.resolution.display-dpi") + "</label>");
      resolutionGroupV.appendTo(pPanelBody);

      // HPS Increase Yellow Ruling
      var yellowRuling = $("<div>").addClass("checkbox").append("<label><input type=\"checkbox\" name=\"output.increase_yellow_ruling\" class=\"singelChoose cf-form-checkbox\"/><span class='cf-form-checkboxlabel'>" + $.i18n._("nixps-RIPEditor-output.increase_yellow_ruling") + "</span></label>");
      Util.createFormGroup("", yellowRuling).appendTo(pPanelBody);
    },
    _addOutputType: function _addOutputType(pPanelBody) {
      pPanelBody.append($("<legend>").addClass("cf-legend")._t("nixps-RIPEditor-output.sub_title_type"));
      var separatedBox = $("<select name=\"separated\">").addClass("form-control cf-form-control").attr("nixps-quantum-util-autobind", "false");
      separatedBox.append("<option value=\"composite\">" + $.i18n._("nixps-RIPEditor-output.output_composite") + "</option>");
      separatedBox.append("<option value=\"separated\">" + $.i18n._("nixps-RIPEditor-output.output_separated") + "</option>");
      separatedBox.append("<option value=\"halftone\">" + $.i18n._("nixps-RIPEditor-output.output_separatedhalftone") + "</option>");
      separatedBox.append("<option value=\"comphalftone\">" + $.i18n._("nixps-RIPEditor-output.output_compositehalftone") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-output.output"), separatedBox).appendTo(pPanelBody);
      var bpcBox = $("<select name=\"output.bitspercomponent\" data-nixps-quantum-type='number'>");
      bpcBox.addClass("form-control cf-form-control");
      bpcBox.append("<option value=\"1\">1</option>");
      bpcBox.append("<option value=\"2\">2</option>");
      bpcBox.append("<option value=\"4\">4</option>");
      bpcBox.append("<option value=\"8\">8</option>");
      bpcBox.append("<option value=\"10\">10</option>");
      bpcBox.append("<option value=\"16\">16</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-output.bitsperchanel"), bpcBox).appendTo(pPanelBody);
      var fileTypeBox = $("<select name=\"output.filetype\">").addClass("form-control cf-form-control");
      fileTypeBox.append("<option value=\"TIFF\">TIFF</option>");
      fileTypeBox.append("<option value=\"BMP\">BMP</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-output.filetype"), fileTypeBox).addClass("filetypeForm").css("display", "none").appendTo(pPanelBody);
      var that = this;
      api_async.preferences.get_for_current_user("com.nixps.general.prerelease", "domino_bmp", function (pResult) {
        if (pResult.preferences === true) {
          that.element.find(".filetypeForm").show();
        }
      });
    },
    _addOutputProperties: function _addOutputProperties(pPanelBody) {
      pPanelBody.append($("<legend>").addClass("cf-legend")._t("nixps-RIPEditor-output.sub_title_outputproperties"));
      var selectPagerange = $('<select name="page_mode">').addClass('form-control cf-form-control select_pagerange').attr('nixps-quantum-util-autobind', 'false').append($('<option value="all" selected>').html($.i18n._("nixps-RIPEditor-output.page_all"))).append($('<option value="range">').html($.i18n._("nixps-RIPEditor-output.page_range")));
      $('<div>').addClass("row cf-form-group help-parameter-group panel-baseline").append($('<label>').addClass("cf-col-sm-4 control-label cf-form-label").text($.i18n._("nixps-RIPEditor-output.pages"))).append($('<div>').addClass('cf-col-sm-4 panel-baseline').append(selectPagerange)).append($('<div>').addClass("cf-col-sm-4 panel-baseline detail_pagerange").append($('<input type="text" name="output.pagerange" placeholder="3, 5, 10-20, 30-999999">').attr('nixps-quantum-util-autobind', 'false').addClass('form-control cf-form-control').css({
        'visibility': 'hidden'
      }))).appendTo(pPanelBody);

      // Rotation
      var rotBox = $('<select name="output.rotation" data-nixps-quantum-type="number">').addClass("form-control cf-form-control").append($('<option value="0" selected>').html($.i18n._("nixps-RIPEditor-output.rotation_0"))).append($('<option value="90">').html($.i18n._("nixps-RIPEditor-output.rotation_90"))).append($('<option value="180">').html($.i18n._("nixps-RIPEditor-output.rotation_180"))).append($('<option value="270">').html($.i18n._("nixps-RIPEditor-output.rotation_270")));
      $('<div>').addClass("row cf-form-group help-parameter-group panel-baseline").append($('<label>').addClass("cf-col-sm-4 control-label cf-form-label").text($.i18n._("nixps-RIPEditor-output.rotation"))).append($('<div>').addClass("cf-col-sm-8").append(rotBox)).appendTo(pPanelBody);

      // --- Page Box
      var selectPagebox = $('<select name="output.pagebox">').addClass('form-control cf-form-control').append($('<option value="mediabox" selected>').html($.i18n._("nixps-cloudflow-assets.mediabox"))).append($('<option value="cropbox">').html($.i18n._("nixps-cloudflow-assets.cropbox"))).append($('<option value="bleedbox">').html($.i18n._("nixps-cloudflow-assets.bleedbox"))).append($('<option value="trimbox">').html($.i18n._("nixps-cloudflow-assets.trimbox"))).append($('<option value="artbox">').html($.i18n._("nixps-cloudflow-assets.artbox")));
      $('<div>').addClass("row cf-form-group help-parameter-group panel-baseline").append($('<label>').addClass("cf-col-sm-4 control-label cf-form-label").text($.i18n._("nixps-RIPEditor-output.pagebox"))).append($('<div>').addClass("cf-col-sm-8").append(selectPagebox)).appendTo(pPanelBody);

      // Horizontal Distortion
      var hDistortion = $("<div>");
      hDistortion.addClass("row cf-form-group help-parameter-group panel-baseline");
      hDistortion.append($("<label>").addClass("cf-col-sm-4 control-label cf-form-label").attr("for", "output.distortion_h")._t("nixps-RIPEditor-output.horizonaldistortion"));
      var controlsH = $("<div>").addClass("cf-col-sm-8");
      controlsH.appendTo(hDistortion);
      var inputH = $("<input>").attr('name', 'output.distortion_h').addClass('form-control cf-form-control');
      inputH.appendTo(controlsH);
      inputH.ValueInput({
        language: this.options.language,
        name: 'output.distortion_h',
        displayDefinition: "distortion",
        storageUnit: '%',
        transform: {
          from: function from(value) {
            return value + 100;
          },
          to: function to(value) {
            return value - 100;
          }
        }
      });
      hDistortion.appendTo(pPanelBody);

      // Vertical Distortion
      var vDistortion = $("<div>");
      vDistortion.addClass("row cf-form-group help-parameter-group panel-baseline");
      vDistortion.append($("<label>").addClass("cf-col-sm-4 control-label cf-form-label").attr("for", "output.distortion_v")._t("nixps-RIPEditor-output.verticaldistortion"));
      var controlsV = $("<div>").addClass("cf-col-sm-8");
      controlsV.appendTo(vDistortion);
      var inputV = $("<input>").attr('name', 'output.distortion_v').addClass('form-control cf-form-control');
      inputV.appendTo(controlsV);
      inputV.ValueInput({
        language: this.options.language,
        name: 'output.distortion_v',
        displayDefinition: "distortion",
        storageUnit: '%',
        transform: {
          from: function from(value) {
            return value + 100;
          },
          to: function to(value) {
            return value - 100;
          }
        }
      });
      vDistortion.appendTo(pPanelBody);

      // Seamless Screening
      var seamlessX = $("<div>").addClass("checkbox").append("<label><input type=\"checkbox\" name=\"output.seamless_x\" nixps-quantum-util-autobind=\"false\" class=\"singelChoose cf-form-checkbox\"/><span class='cf-form-checkboxlabel'>" + $.i18n._('nixps-RIPEditor-output.seamless_x') + "</span></label>");
      seamlessX.hide();
      Util.createFormGroup("", seamlessX).appendTo(pPanelBody);
      LicenseFactory.get().then(function (license) {
        if (license.check('seamless_screening')) {
          seamlessX.show();
        }
      }, function (pError) {
        console.error(pError);
      });

      // Negative Output
      var negativeOutput = $("<div>").addClass("checkbox").append("<label><input type=\"checkbox\" name=\"output.negative_output\" class=\"singelChoose cf-form-checkbox\"/><span class='cf-form-checkboxlabel'>" + $.i18n._('nixps-RIPEditor-output.negativeoutput') + "</span></label>");
      Util.createFormGroup("", negativeOutput).appendTo(pPanelBody);

      // Mirror Output
      var mirrorOutput = $("<div>").addClass("checkbox").append("<label><input type=\"checkbox\" name=\"output.mirror_output\" class=\"singelChoose cf-form-checkbox\"/><span class='cf-form-checkboxlabel'>" + $.i18n._('nixps-RIPEditor-output.mirroroutput') + "</span></label>");
      Util.createFormGroup("", mirrorOutput).appendTo(pPanelBody);
    },
    _addHPSProperties: function _addHPSProperties(pPanelBody) {
      pPanelBody.append($("<legend>").addClass("cf-legend")._t("nixps-RIPEditor-hps"));

      // Harlequin Precision Screening
      var precisionScreening = $("<div>").addClass("checkbox").append("<label><input type=\"checkbox\" name=\"output.hps\" class=\"singelChoose cf-form-checkbox\"/><span class='cf-form-checkboxlabel'>" + $.i18n._('nixps-RIPEditor-output.hps') + "</span></label>");
      Util.createFormGroup("", precisionScreening).appendTo(pPanelBody);

      // HPS Accuracy
      var hpsAccuracy = $("<select>").attr("name", "output.hps_accuracy");
      hpsAccuracy.addClass("form-control cf-form-control");
      hpsAccuracy.append("<option value=\"angles\">" + $.i18n._("nixps-RIPEditor-output.hps_accuracy_angle") + "</option>");
      hpsAccuracy.append("<option value=\"ruling\">" + $.i18n._("nixps-RIPEditor-output.hps_accuracy_ruling") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-output.hps_accuracy"), hpsAccuracy).appendTo(pPanelBody);

      // HPS Rosettes
      var clearCentered = $("<div>").addClass("checkbox").append("<label><input type=\"checkbox\" name=\"output.clear_centered\" class=\"singelChoose cf-form-checkbox\"/><span class='cf-form-checkboxlabel'>" + $.i18n._('nixps-RIPEditor-output.clear_centered') + "</span></label>");
      Util.createFormGroup("", clearCentered).appendTo(pPanelBody);
    },
    _addTIFFSettings: function _addTIFFSettings(pPanelBody) {
      var tiffPane = $("<div class='tiff_settings'>");
      pPanelBody.append(tiffPane);
      tiffPane.append($("<legend>").addClass("cf-legend").text($.i18n._("nixps-RIPEditor-output.sub_title_tiffformat")));
      var formatBox = $("<select>").attr("name", "output.tiff_format").addClass("form-control cf-form-control");
      formatBox.append("<option value=\"Multiple strips\">" + $.i18n._("nixps-RIPEditor-output.stripformat_multiple") + "</option>");
      formatBox.append("<option value=\"Single strip\">" + $.i18n._("nixps-RIPEditor-output.stripformat_single") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-output.stripformat"), formatBox).appendTo(tiffPane);
      var compressionBox = $("<select>").attr("name", "output.compression");
      compressionBox.addClass("form-control cf-form-control");
      compressionBox.append("<option value=\"None\">" + $.i18n._("nixps-RIPEditor-output.compression_none") + "</option>");
      compressionBox.append("<hr>");
      compressionBox.append("<option value=\"CCITT_3\">" + $.i18n._("nixps-RIPEditor-output.compression_CCITTGroup3") + "</option>");
      compressionBox.append("<option value=\"CCITT_4\">" + $.i18n._("nixps-RIPEditor-output.compression_CCITTGroup4") + "</option>");
      compressionBox.append("<option value=\"LZW\">" + $.i18n._("nixps-RIPEditor-output.compression_LZW") + "</option>");
      compressionBox.append("<option value=\"Packbits\">" + $.i18n._("nixps-RIPEditor-output.compression_PackBits") + "</option>");
      compressionBox.append("<option value=\"Flate\">" + $.i18n._("nixps-RIPEditor-output.compression_AdobeFlate") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-output.compression"), compressionBox).appendTo(tiffPane);
      var antiAliasingBox = $("<select name=\"output.anti_alias\">");
      antiAliasingBox.addClass("form-control cf-form-control");
      antiAliasingBox.append("<option value=\"None\">" + $.i18n._("nixps-RIPEditor-output.antialiasing_none") + "</option>");
      antiAliasingBox.append("<option value=\"2x2\">2x2</option>");
      antiAliasingBox.append("<option value=\"4x4\">4x4</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-output.antialiasing"), antiAliasingBox).appendTo(tiffPane);
      var advancedOptions = $("<div>").addClass("checkbox").append($("<label>").append($("<input>").attr('type', "checkbox").attr('name', "output.reverse_order").addClass('singelChoose cf-form-checkbox')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-output.bitorder_reverse")));
      Util.createFormGroup($.i18n._("nixps-RIPEditor-output.bitorder"), advancedOptions).appendTo(tiffPane);
      var padTo32Bits = $("<div>").addClass("checkbox").append($("<label>").append($("<input>").attr("type", "checkbox").attr("name", "output.pad_32").addClass('singelChoose cf-form-checkbox')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-output.bitorder_padto32bit")));
      Util.createFormGroup("", padTo32Bits).appendTo(tiffPane);
    },
    _refresh: function _refresh() {
      // Make a settings shortcut
      var output_settings;
      if (this.options.settings !== undefined && this.options.settings.output !== undefined) {
        output_settings = this.options.settings.output;
      } else {
        output_settings = {};
      }

      // apply visibility setting
      if (this.options.applyVisibility === true) {
        if (output_settings.panel_visible === false) {
          this.element.hide();
        } else {
          this.element.css('display', '');
        }
      }
      if (this.options.editingVisibility === false && this.element.find(".visibleIcon").length > 0) {
        this.element.find(".visibleIcon").addClass("cf-hide");
      } else if (this.options.editingVisibility === true && this.element.find(".visibleIcon.cf-hide").length > 0) {
        this.element.find(".visibleIcon").removeClass("cf-hide");
      }

      // Filetype
      var filetype = Util.getValue(output_settings.filetype, "TIFF");
      if (filetype === "TIFF") {
        this.element.find('.tiff_settings').show();
      } else if (filetype === "BMP") {
        this.element.find('.tiff_settings').hide();
      }

      // Output Type
      var halftone = Util.getValue(output_settings.halftone, true);
      var separated = Util.getValue(output_settings.separated, true);
      this.element.find('[name="separated"]').val(separated ? halftone ? "halftone" : "separated" : halftone ? "comphalftone" : "composite");
      this.element.find('[name="output.bitspercomponent"]').val(Util.getValue(output_settings.bitspercomponent, 1));
      this.element.find('[name="output.filetype"]').val(filetype);
      if (this.options.standaloneView !== true) {
        this.element.find('.outputFolder').val(this.options.settings.output_folder);
        this.element.find('[name="output.output_folder_only"]').prop('checked', Util.getValue(this.options.settings.output_folder_only, false));
      }

      // Resolution
      this.element.find('[name="output.resolution_v"]').val(Util.getValue(output_settings.resolution_v, 1200));
      this.element.find('[name="output.resolution_h"]').val(Util.getValue(output_settings.resolution_h, 1200));

      // Output Settings
      var rangemode = "all";
      var val = output_settings.pagerange;
      if (val !== undefined && val !== "") {
        // var range = typeof val === 'string' ? JSON.parse(val) : val;
        var pageRanges = this._parsePageRange(val);
        if (Array.isArray(pageRanges)) {
          rangemode = "range";
          val = this._pageRangeToString(pageRanges);
        }
      }
      this.element.find('select[name="page_mode"]').val(rangemode);
      this.element.find('[name="output.pagerange"]').val(val);
      this.element.find('[name="output.pagerange"]').css({
        'visibility': rangemode === "all" ? 'hidden' : 'visible'
      });
      this.element.find('.nixps-quantum-ValueInput[name="output.distortion_v"]').ValueInput('option', 'value', Util.getValue(output_settings.distortion_v, 0));
      this.element.find('.nixps-quantum-ValueInput[name="output.distortion_h"]').ValueInput('option', 'value', Util.getValue(output_settings.distortion_h, 0));
      this.element.find('[name="output.seamless_x"]').prop('checked', Util.getValue(output_settings.seamless_x, "none") != "none");
      this.element.find('select[name="output.pagebox"]').val(Util.getValue(output_settings.pagebox, "mediabox"));
      this.element.find('[name="output.rotation"]').val(Util.getValue(output_settings.rotation, 0));
      this.element.find('[name="output.negative_output"]').prop('checked', Util.getValue(output_settings.negative_output, false));
      this.element.find('[name="output.mirror_output"]').prop('checked', Util.getValue(output_settings.mirror_output, false));
      if (this.options.settings.output.halftone == true) {
        this.element.find('[name="output.hps"]').prop('checked', Util.getValue(output_settings.hps, true));
      } else {
        this.element.find('[name="output.hps"]').prop('checked', false);
      }
      this.element.find('[name="output.hps_accuracy"]').val(Util.getValue(output_settings.hps_accuracy, "angles"));
      this.element.find('[name="output.clear_centered"]').prop('checked', Util.getValue(output_settings.clear_centered, true));
      this.element.find('[name="output.increase_yellow_ruling"]').prop('checked', Util.getValue(output_settings.increase_yellow_ruling, true));

      // TIFF Settings
      this.element.find('[name="output.tiff_format"]').val(Util.getValue(output_settings.tiff_format, "Multiple strips"));
      this.element.find('[name="output.compression"]').val(Util.getValue(output_settings.compression, "LZW"));
      this.element.find('[name="output.anti_alias"]').val(Util.getValue(output_settings.anti_alias, "None"));
      this.element.find('[name="output.reverse_order"]').prop('checked', Util.getValue(output_settings.reverse_order, false));
      this.element.find('[name="output.pad_32"]').prop('checked', Util.getValue(output_settings.pad_32, false));

      // Enable & Disable
      if (this.options.settings.output.bitspercomponent < 8) {
        this.element.find('[name="output.anti_alias"]').attr('disabled', 'disabled').addClass('disabled');
      } else {
        this.element.find('[name="output.anti_alias"]').removeAttr('disabled').removeClass('disabled');
      }

      // Enable & Disable
      if (this.options.settings.output.halftone == true) {
        this.element.find('[name="output.hps"]').removeAttr('disabled').removeClass('disabled');
        if (Util.getValue(output_settings.hps, true)) {
          this.element.find('[name="output.hps_accuracy"]').removeAttr('disabled').removeClass('disabled');
          this.element.find('[name="output.clear_centered"]').removeAttr('disabled').removeClass('disabled');
          this.element.find('[name="output.increase_yellow_ruling"]').removeAttr('disabled').removeClass('disabled');
        } else {
          this.element.find('[name="output.hps_accuracy"]').attr('disabled', 'disabled').addClass('disabled');
          this.element.find('[name="output.clear_centered"]').attr('disabled', 'disabled').addClass('disabled');
          this.element.find('[name="output.increase_yellow_ruling"]').attr('disabled', 'disabled').addClass('disabled');
        }
      } else {
        this.element.find('[name="output.hps"]').attr('disabled', 'disabled').addClass('disabled');
        this.element.find('[name="output.hps_accuracy"]').attr('disabled', 'disabled').addClass('disabled');
        this.element.find('[name="output.clear_centered"]').attr('disabled', 'disabled').addClass('disabled');
        this.element.find('[name="output.increase_yellow_ruling"]').attr('disabled', 'disabled').addClass('disabled');
      }
      if (output_settings.panel_visible === false) {
        // set on invisible if set expecitly on false
        this.element.find('.visibleIcon').removeClass('fa-eye').addClass('fa-eye-slash');
      } else {
        // default visible on true
        this.element.find('.visibleIcon').removeClass('fa-eye-slash').addClass('fa-eye');
      }
      this._readOnlyChange();
    },
    _parsePageRange: function _parsePageRange(range) {
      if (range !== undefined && Array.isArray(range)) {
        range = this._pageRangeToString(range);
      }
      var pageRanges = range !== undefined ? [] : null;
      if (typeof range === 'string' && range.length > 0) {
        var endSet = false;
        range.split(',').forEach(function (value) {
          value = value.trim();
          if (value == parseInt(value, 10) && parseInt(value, 10) > 0) {
            pageRanges.push(parseInt(value, 10));
          } else {
            var re = /(-*)(\d+) *- *(-*)(\d*)/;
            var matches;
            if ((matches = re.exec(value)) !== null) {
              var from = matches[2];
              var to = matches[4];
              if (matches[1] === "" && matches[3] === "" && from == parseInt(from, 10)) {
                from = parseInt(from, 10);
                if (to !== "" && to == parseInt(to, 10)) {
                  to = parseInt(to, 10);
                  if (from <= to) {
                    pageRanges.push([from, to]);
                  }
                } else if (!endSet && to === "") {
                  pageRanges.push([from, to]);
                  endSet = true;
                }
              }
            }
          }
        });
      }
      return pageRanges;
    },
    _pageRangeToString: function _pageRangeToString(pageRanges) {
      var str = "";
      pageRanges.forEach(function (part) {
        str += str.length > 0 ? ', ' : '';
        if (Array.isArray(part) && part.length > 1) {
          str += part[0] + ' - ' + part[1];
        } else {
          str += part;
        }
      });
      return str;
    },
    _readOnlyChange: function _readOnlyChange() {
      if (this.options.readOnly === true) {
        this.element.find('input, select').prop('disabled', true);
      } else {
        this.element.find('input:not(.disabled), select:not(.disabled)').prop('disabled', false);
      }
    },
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._refresh();
    },
    _changeHandler: function _changeHandler(pEvent) {
      // this are the options we must keep
      var keepOptions = {
        "outputPathEnable": this.options.settings.output.outputPathEnable,
        "outputPath": this.options.settings.output.outputPath,
        "outputPathHold": this.options.settings.output.outputPathHold
      };

      // var unitPreferences = new nixps.cloudflow.SystemUnitPreferences();
      var unit = new SystemUnitPreferences().getDefinition('resolution');
      var res_v = new Value(parseFloat(this.element.find('[name="output.resolution_v"]').val()), unit);
      var res_h = new Value(parseFloat(this.element.find('[name="output.resolution_h"]').val()), unit);

      // output settings
      this.options.settings.output = {
        filetype: this.element.find('[name="output.filetype"]').val(),
        tiff_format: this.element.find('[name="output.tiff_format"]').val(),
        resolution_v: res_v.toFormattedNumber(),
        resolution_h: res_h.toFormattedNumber(),
        distortion_v: parseFloat(this.element.find('[name="output.distortion_v"]').ValueInput('option', 'value')),
        distortion_h: parseFloat(this.element.find('[name="output.distortion_h"]').ValueInput('option', 'value')),
        seamless_x: this.element.find('[name="output.seamless_x"]').is(':checked') ? 'auto' : 'none',
        negative_output: this.element.find('[name="output.negative_output"]').is(':checked'),
        mirror_output: this.element.find('[name="output.mirror_output"]').is(':checked'),
        hps: this.element.find('[name="output.hps"]').is(':checked'),
        hps_accuracy: this.element.find('[name="output.hps_accuracy"]').val(),
        clear_centered: this.element.find('[name="output.clear_centered"]').is(':checked'),
        increase_yellow_ruling: this.element.find('[name="output.increase_yellow_ruling"]').is(':checked'),
        reverse_order: this.element.find('[name="output.reverse_order"]').is(':checked'),
        pad_32: this.element.find('[name="output.pad_32"]').is(':checked'),
        compression: this.element.find('[name="output.compression"]').val(),
        anti_alias: this.element.find('[name="output.anti_alias"]').val(),
        fast_patterns: false,
        old_imagemasks: false,
        abort_fonts: false,
        font_emulation: false,
        colormodel: "DeviceCMYK",
        bitspercomponent: parseInt(this.element.find('[name="output.bitspercomponent"]').val()),
        pagebox: this.element.find('select[name="output.pagebox"]').val(),
        rotation: parseInt(this.element.find('[name="output.rotation"]').val()),
        separated: this.element.find('[name="separated"]').val() == "separated" || this.element.find('[name="separated"]').val() == "halftone",
        halftone: this.element.find('[name="separated"]').val() == "halftone" || this.element.find('[name="separated"]').val() == "comphalftone",
        bmp_format: "windows"
      };
      // merge options we need to keep
      this.options.settings.output = $.extend(this.options.settings.output, keepOptions);
      var rangemode = this.element.find('select[name="page_mode"]').val();
      if (rangemode === "all") {
        delete this.options.settings.output.pagerange;
      } else if (rangemode === "range") {
        var range = this.element.find('[name="output.pagerange"]:visible').val();
        var pages = this._parsePageRange(range);
        this.options.settings.output.pagerange = pages;
      }
      if (this.options.standaloneView !== true) {
        this.options.settings.output_folder = this.element.find('.outputFolder').val();
        this.options.settings.output_folder_only = this.element.find('[name="output.output_folder_only"]').is(':checked');
      }
      this._trigger('change', pEvent, {
        "settings": this.options.settings
      });
    },
    /**
     * @description function runs when user click on the eye icon
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
    */
    _visibleIconClickHandler: function _visibleIconClickHandler(pEvent, pData) {
      if ($(pEvent.currentTarget).hasClass('fa-eye')) {
        $(pEvent.currentTarget).removeClass('fa-eye').addClass('fa-eye-slash');
        this.options.settings.output.panel_visible = false;
      } else {
        $(pEvent.currentTarget).removeClass('fa-eye-slash').addClass('fa-eye');
        this.options.settings.output.panel_visible = true;
      }
      this._trigger('change', pEvent, {
        "settings": this.options.settings
      });
    },
    //////////////////////// MIXLEVELS ////////////////////////////////////

    _addMixLevelsHeader: function _addMixLevelsHeader() {
      var mlHeader = $("<div>");
      mlHeader.addClass("row cf-form-group help-parameter-group");
      mlHeader.append("<span class=\"col-xs-1 cf-col-xs-1 ml-header\">Separation</span>");
      mlHeader.append("<span class=\"col-xs-1 cf-col-xs-1 ml-header\">Value</span>");
      mlHeader.append("<span class=\"col-xs-1 cf-col-xs-1 ml-header\">Enable</span>");
      mlHeader.append("<span class=\"cf-col-sm-4 ml-header\">Limit</span>");
      mlHeader.append("<span class=\"cf-col-sm-4 ml-header\">Gradient</span>");
      mlHeader.append("<span class=\"cf-col-sm-4 ml-header\">Overlap</span>");
      return mlHeader;
    },
    _addMixLevelsRow: function _addMixLevelsRow(pSeparation, pIndex, pNamePrefix) {
      var mlGroup = $("<div>").addClass("row cf-form-group help-parameter-group");
      mlGroup.append("<span class=\"col-xs-1 cf-col-xs-1\" style=\"margin-top: 8px\"><b>" + pSeparation + "</b></span>");
      mlGroup.append("<span class=\"col-xs-1 cf-col-xs-1\" style=\"margin-top: 8px\"><b>" + pIndex + "</b></span>");
      var checkBox = $("<div><input class='form-control cf-form-control' type='checkbox' name='" + pNamePrefix + "_enabled'/></div>");
      checkBox.addClass("col-xs-1 cf-col-xs-1");
      checkBox.appendTo(mlGroup);
      var limit = $("<div><input class='form-control cf-form-control' name='" + pNamePrefix + "_limit'/></div>");
      limit.addClass("cf-col-sm-4");
      limit.appendTo(mlGroup);
      var gradient = $("<div><input class='form-control cf-form-control' name='" + pNamePrefix + "_gradient'/></div>");
      gradient.addClass("cf-col-sm-4");
      gradient.appendTo(mlGroup);
      var overlap = $("<div><input class='form-control cf-form-control' name='" + pNamePrefix + "_overlap'/></div>");
      overlap.addClass("cf-col-sm-4");
      overlap.appendTo(mlGroup);
      return mlGroup;
    },
    _loadMixLevels: function _loadMixLevels() {
      var separations = ["Cyan", "Magenta", "Yellow", "Black", "White", "Orange", "Violet", "Default"];
      var shortcuts = ["c", "m", "y", "k", "w", "v", "o", "d"];
      if (this.options.settings.output.mix_levels === undefined) {
        this.options.settings.output.mix_levels = {
          "Cyan": {
            "1": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 60.0,
              "overlap": 0.15
            },
            "2": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 85.0,
              "overlap": 0.20
            },
            "3": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 90.0,
              "overlap": 0.30
            },
            "4": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 100.0,
              "overlap": 0.001
            }
          },
          "Yellow": {
            "1": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 60.0,
              "overlap": 0.15
            },
            "2": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 85.0,
              "overlap": 0.20
            },
            "3": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 90.0,
              "overlap": 0.30
            },
            "4": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 100.0,
              "overlap": 0.001
            }
          },
          "Magenta": {
            "1": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 60.0,
              "overlap": 0.15
            },
            "2": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 85.0,
              "overlap": 0.20
            },
            "3": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 90.0,
              "overlap": 0.30
            },
            "4": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 100.0,
              "overlap": 0.001
            }
          },
          "Black": {
            "1": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 60.0,
              "overlap": 0.15
            },
            "2": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 85.0,
              "overlap": 0.20
            },
            "3": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 90.0,
              "overlap": 0.30
            },
            "4": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 100.0,
              "overlap": 0.001
            }
          },
          "White": {
            "1": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 60.0,
              "overlap": 0.55
            },
            "2": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 85.0,
              "overlap": 0.20
            },
            "3": {
              "enabled": true,
              "limit": 0.8,
              "gradient": 100.0,
              "overlap": 0.0
            },
            "4": {
              "enabled": false,
              "limit": 1.0,
              "gradient": 100.0,
              "overlap": 0.0
            }
          },
          "Orange": {
            "1": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 80.0,
              "overlap": 0.15
            },
            "2": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 85.0,
              "overlap": 0.20
            },
            "3": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 90.0,
              "overlap": 0.30
            },
            "4": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 100.0,
              "overlap": 0.001
            }
          },
          "Violet": {
            "1": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 60.0,
              "overlap": 0.15
            },
            "2": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 85.0,
              "overlap": 0.20
            },
            "3": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 90.0,
              "overlap": 0.30
            },
            "4": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 100.0,
              "overlap": 0.001
            }
          },
          "Default": {
            "1": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 80.0,
              "overlap": 0.15
            },
            "2": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 85.0,
              "overlap": 0.20
            },
            "3": {
              "enabled": false,
              "limit": 0.8,
              "gradient": 90.0,
              "overlap": 0.30
            },
            "4": {
              "enabled": true,
              "limit": 1.0,
              "gradient": 100.0,
              "overlap": 0.001
            }
          }
        };
      }
      for (var s in separations) {
        this._loadMixLevel(this.options.settings.output.mix_levels[separations[s]]["1"], shortcuts[s] + "_1");
        this._loadMixLevel(this.options.settings.output.mix_levels[separations[s]]["2"], shortcuts[s] + "_2");
        this._loadMixLevel(this.options.settings.output.mix_levels[separations[s]]["3"], shortcuts[s] + "_3");
        this._loadMixLevel(this.options.settings.output.mix_levels[separations[s]]["4"], shortcuts[s] + "_4");
      }
    },
    _loadMixLevel: function _loadMixLevel(p_data, p_prefix) {
      this.element.find("[name=" + p_prefix + "_enabled]").prop('checked', Util.getValue(p_data.enabled, false));
      this.element.find("[name=" + p_prefix + "_limit]").val(Util.getValue(p_data.limit, 1.00));
      this.element.find("[name=" + p_prefix + "_gradient]").val(Util.getValue(p_data.gradient, 8.00));
      this.element.find("[name=" + p_prefix + "_overlap]").val(Util.getValue(p_data.overlap, 0.00));
      this.element.find("[name=" + p_prefix + "_limit]").prop("disabled", !p_data.enabled);
      this.element.find("[name=" + p_prefix + "_gradient]").prop("disabled", !p_data.enabled);
      this.element.find("[name=" + p_prefix + "_overlap]").prop("disabled", !p_data.enabled);
    },
    _saveMixLevels: function _saveMixLevels() {
      var mix_levels = {};
      var separations = ["Cyan", "Magenta", "Yellow", "Black", "White", "Orange", "Violet", "Default"];
      var shortcuts = ["c", "m", "y", "k", "w", "v", "o", "d"];
      for (var s in separations) {
        mix_levels[separations[s]] = {
          "1": {},
          "2": {},
          "3": {},
          "4": {}
        };
        this._saveMixLevel(mix_levels[separations[s]]["1"], shortcuts[s] + "_1");
        this._saveMixLevel(mix_levels[separations[s]]["2"], shortcuts[s] + "_2");
        this._saveMixLevel(mix_levels[separations[s]]["3"], shortcuts[s] + "_3");
        this._saveMixLevel(mix_levels[separations[s]]["4"], shortcuts[s] + "_4");
      }
      return mix_levels;
    },
    _saveMixLevel: function _saveMixLevel(p_data, p_prefix) {
      p_data.enabled = this.element.find('[name=' + p_prefix + '_enabled]').is(':checked');
      p_data.limit = parseFloat(this.element.find('[name=' + p_prefix + '_limit]').val());
      p_data.gradient = parseFloat(this.element.find('[name=' + p_prefix + '_gradient]').val());
      p_data.overlap = parseFloat(this.element.find('[name=' + p_prefix + '_overlap]').val());
    }
  });
})(jQuery);

},{"../../../../cloudflow/License/js/License.js":175,"../../../../cloudflow/Units/js/SystemUnitPreferences.js":263,"../../../../cloudflow/Units/js/Value.js":266,"./Util.js":304}],311:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var Util = require('./Util.js');
  /**
      * README
      * 
      * This component should handles all settings about the "Standalone RIP" workflow. 
      * This has nothing to do with the rip/node/preset. 
      * 
      * The settings:
      * --------------
      * this.options.settings.postprocess.waitonprerender: must we wait until every image is rendered before continuoue
      * this.options.settings.postprocess.parallelPrerender: do we start several prerender in parallel
      * this.options.settings.postprocess.remove_dot: do we remove scum dots
      * this.options.settings.postprocess.remove_dot_size: scum dots size to be removed in mm
      * this.options.settings.postprocess.remove_connected_count_px: scum dots number of connected pixels to be removed
      * this.options.settings.postprocess.add_decoration: should we add a decorator?
      * this.options.settings.postprocess.decoration: url of decorator
      * this.options.settings.postprocess.margin_left: left margin to add to the document in mm
      * this.options.settings.postprocess.margin_right: right margin to add to the document in mm
      * this.options.settings.postprocess.margin_top: top margin to add to the document in mm
      * this.options.settings.postprocess.margin_bottom: bottom margin to add to the document in mm
      * this.options.settings.output.outputPathEnable: do we want to copy the outputfiles TIF
      * this.options.settings.output.outputPath: output path were we will copy the tif files to
      * this.options.settings.output.outputPathHold: must we go through a "hold in kiosk" before copying
      * this.options.settings.cip3.outputPathEnable: do we want to copy the CIP3 files
      * this.options.settings.cip3.outputPath: output path were we will copy the CIP3 file
      * 
      */
  $.widget("nixps.RIPEditorPostRender", $.Widget, {
    widgetEventPrefix: "ripeditorpostrender",
    options: {
      /**
                * @brief The RIP Settings object
                */
      settings: undefined,
      /**
       * @brief Created in a bootstrap environment
       */
      bootstrap: true,
      /**
       * @brief are we in standalone view or not?
       */
      standaloneView: true,
      /**
       * @description Must we just open de panel in readOnly mode?
       * @type {Boolean}
       * @default false
       */
      readOnly: false,
      /**
       * @description Must the user be able to edit, change the visibility setting
       * @type {boolean}
       * @default false
       */
      editingVisibility: false,
      /**
       * @description Must we apply the visibility setting
       * @type {boolean}
       * @default true
       */
      applyVisibility: true
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.addClass("col-lg-6 cf-col-lg-6");
      // The panel
      var panel = $("<div>").addClass("panel panel-default cf-panel").appendTo(this.element);

      // Header for the Output Blob
      if (this.options.bootstrap) {
        var panelHeader = $("<div>");
        panelHeader.addClass("panel-heading");
        var title = $("<h3>").addClass("panel-title")._t("nixps-RIPEditor-Postrender.title");
        panelHeader.append(title);
        if (this.options.editingVisibility === true) {
          title.append($("<span>").addClass("visibleIcon fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        } else {
          title.append($("<span>").addClass("visibleIcon cf-hide fa fa-eye").attr("title", $.i18n._("nixps-standalone-visible.tooltip_visibility")));
        }
        panelHeader.appendTo(panel);
      }

      // The body of the panel
      var panelBody = $("<div>");
      panelBody.addClass("panel-body");
      panelBody.appendTo(panel);
      this._addControls(panelBody);
      this._refresh();
      this._on(this.element, {
        'change select,input ': this._changeHandler,
        'click .visibleIcon': this._visibleIconClickHandler
      });
    },
    /**
    * @brief This function adds controls 
    */
    _addControls: function _addControls(pPanelBody) {
      if (this.options.standaloneView === true) {
        this._addPostRenderSettings(pPanelBody);
      }
    },
    _addPostRenderSettings: function _addPostRenderSettings(pPanelBody) {
      // wait on prerender TIF checkbox
      var waitOnPrerenderCheck = $('<div>').addClass("checkbox").append($('<label>').append($('<input>').addClass("waitOnPreRenderCheck singelChoose cf-form-checkbox").attr('type', 'checkbox').attr('name', 'waitOnPreRender')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-Postrender.waitonprerender")));
      Util.createFormGroup("", waitOnPrerenderCheck).appendTo(pPanelBody);

      // parallel prerender checkbox
      var parallelPrerenderCheck = $('<div>').addClass("checkbox").append($('<label>').append($('<input>').addClass("parallelPrerenderCheck singelChoose cf-form-checkbox").attr('type', 'checkbox').attr('name', 'parallelPrerender')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-Postrender.parallelPrerender")));
      Util.createFormGroup("", parallelPrerenderCheck).appendTo(pPanelBody);

      // remove_dot checkbox
      var removeDotCheck = $('<div>').addClass("checkbox").append($('<label>').append($('<input>').addClass("removeDotCheck singelChoose cf-form-checkbox").attr('type', 'checkbox').attr('name', 'remove_dot')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-Postrender.remove_dot")));
      Util.createFormGroup("", removeDotCheck).addClass('removeDotCheckFrom').appendTo(pPanelBody);

      // remove_dot_size input field
      var removeDotSize = $("<input>").addClass("form-control cf-form-control removeDotSize").attr('type', 'text').attr('name', 'remove_dot_size').val('0');
      removeDotSize.ValueInput({
        displayDefinition: "small_length",
        storageUnit: "mm"
      });
      Util.createFormGroup($.i18n._("nixps-RIPEditor-Postrender.remove_dot_size"), removeDotSize).addClass('removeDotSizeFrom').hide().appendTo(pPanelBody);

      // remove_connected_count_px input field
      var removeConnectedCount = $("<input>").addClass("form-control cf-form-control removeConnectedCount").attr('type', 'text').attr('name', 'remove_connected_count_px').val('0');
      Util.createFormGroup($.i18n._("nixps-RIPEditor-Postrender.remove_connected_count_px"), removeConnectedCount).addClass('removeDotSizeFrom').hide().appendTo(pPanelBody);

      // ----- Add decoration checkbox
      var addDecorationCheck = $('<div>').addClass("checkbox").append($('<label>').append($('<input>').addClass("addDecorationCheck singelChoose cf-form-checkbox").attr('type', 'checkbox').attr('name', 'add_decoration')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-Postrender.add_decoration")));
      Util.createFormGroup("", addDecorationCheck).addClass('addDecorationCheckFrom').appendTo(pPanelBody);

      // decoration related fields
      this.decorationSelector = $("<div>").attr("name", "decorationSelector").addClass("decorationSelection group cf-form-group");
      this.decorationSelector.ResourceSelector({
        text_when_empty: $.i18n._("nixps-RIPEditor-Postrender.no_decoration"),
        name: 'postprocess.decoration',
        resource_type: 'Decoration+RIP',
        allowNoResource: false,
        value: ""
      });
      Util.createFormGroup($.i18n._("nixps-RIPEditor-Postrender.decoration"), this.decorationSelector).addClass('decorationFrom').appendTo(pPanelBody);
      var margins = ["margin_left", "margin_right", "margin_top", "margin_bottom"];
      for (var _i = 0, _margins = margins; _i < _margins.length; _i++) {
        var one = _margins[_i];
        var margin = $("<input>").addClass("form-control cf-form-control decoration").attr('type', 'text').attr('name', one).val('0');
        margin.ValueInput({
          displayDefinition: "length",
          storageUnit: "mm"
        });
        Util.createFormGroup($.i18n._("nixps-RIPEditor-Postrender." + one), margin).addClass('decorationFrom').hide().appendTo(pPanelBody);
      }

      // outputpath checkbox
      var outputPathCheck = $('<div>').addClass("checkbox").append($('<label>').append($('<input>').addClass("outputPathCheck singelChoose cf-form-checkbox").attr('type', 'checkbox').attr('name', 'outputPathEnable')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-Postrender.copyoutputfiles")));
      Util.createFormGroup("", outputPathCheck).addClass('outputPathCheckFrom').appendTo(pPanelBody);

      // input outputpath
      var outputPath = $("<input>").addClass("form-control cf-form-control outputPath").attr('type', 'text').attr('name', 'outputPath').val('file:///');
      Util.createFormGroup($.i18n._("nixps-RIPEditor-Postrender.ouputpath"), outputPath).addClass('outputPathFrom').hide().appendTo(pPanelBody);

      // outpoutpath CIP3 checkbox
      var outputPathCheck = $('<div>').addClass("checkbox").append($('<label>').append($('<input>').addClass("outputPathCIP3Check singelChoose cf-form-checkbox").attr('type', 'checkbox').attr('name', 'outputPathCIP3Enable')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-Postrender.copycip3files")));
      Util.createFormGroup("", outputPathCheck).addClass('outputPathCIP3CheckFrom').appendTo(pPanelBody);

      // outputpath CIP3
      var outputPath = $("<input>").addClass("form-control cf-form-control outputPathCIP3").attr('type', 'text').attr('name', 'outputPathCIP3').val('file:///');
      Util.createFormGroup($.i18n._("nixps-RIPEditor-Postrender.outputpathcip3"), outputPath).addClass('outputPathCIP3From').hide().appendTo(pPanelBody);

      // copy technical inks
      var copyTechnicalInksCheckBox = $('<input>').addClass("copyTechnicalInks singelChoose cf-form-checkbox").attr('type', 'checkbox').attr('name', 'copyTechnicalInks');
      var copyTechnicalInksText = $('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-Postrender.copytechnicalcolors");
      var copyTechnicalInks = $('<div class="checkbox copyTechnicalInksPanel"></div>').append($('<label>').append(copyTechnicalInksCheckBox).append(copyTechnicalInksText));
      Util.createFormGroup("", copyTechnicalInks).addClass('copyTechnicalInks').appendTo(pPanelBody);

      // hold before copy
      var holdBeforeCopyCheckBox = $('<input>').addClass("outputPathHold singelChoose cf-form-checkbox").attr('type', 'checkbox').attr('name', 'outputPathHold');
      var holdBeforeCopyText = $('<span>').addClass("cf-form-checkboxlabel")._t('nixps-RIPEditor-Postrender.askoperator');
      var holdBeforeCopy = $('<div class="checkbox holdBeforeCopyPanel"></div>').append($('<label>').append(holdBeforeCopyCheckBox).append(holdBeforeCopyText));
      Util.createFormGroup("", holdBeforeCopy).addClass('outputCopyHold').appendTo(pPanelBody);
    },
    _refresh: function _refresh() {
      // Backwards compatible
      if (this.options.settings !== undefined) {
        if (this.options.settings.output !== undefined) {
          if (this.options.settings.output.outputPathEnable === undefined) {
            this.options.settings.output.outputPathEnable = false;
          }
          if (this.options.settings.output.outputPathHold === undefined) {
            this.options.settings.output.outputPathHold = false;
          }
        } else {
          this.options.settings.output = {
            outputPathEnable: false,
            outputPathHold: false
          };
        }
      } else {
        this.options.settings = {};
        this.options.settings.output = {
          outputPathEnable: false,
          outputPathHold: false
        };
      }
      if (this.options.settings.cip3 === undefined) {
        this.options.settings.cip3 = {};
        this.options.settings.cip3.outputPathEnable = false;
      } else {
        if (this.options.settings.cip3.outputPathEnable === undefined) {
          this.options.settings.cip3.outputPathEnable = false;
        }
      }
      if (this.options.settings.postprocess === undefined) {
        this.options.settings.postprocess = {};
        this.options.settings.postprocess.waitonprerender = false;
        this.options.settings.postprocess.parallelPrerender = false;
        this.options.settings.postprocess.copytechnicalinks = false;
        this.options.settings.postprocess.remove_dot = false;
        this.options.settings.postprocess.remove_dot_size = 0;
        this.options.settings.postprocess.remove_connected_count_px = 0;
        this.options.settings.postprocess.add_decoration = false;
        this.options.settings.postprocess.decoration = "";
        this.options.settings.postprocess.margin_left = 0;
        this.options.settings.postprocess.margin_right = 0;
        this.options.settings.postprocess.margin_top = 0;
        this.options.settings.postprocess.margin_bottom = 0;
      }
      if (this.options.applyVisibility === true) {
        if (this.options.settings.postprocess.panel_visible === false) {
          this.element.hide();
        } else {
          this.element.css('display', '');
        }
      }
      if (this.options.editingVisibility === false && this.element.find(".visibleIcon").length > 0) {
        this.element.find(".visibleIcon").addClass("cf-hide");
      } else if (this.options.editingVisibility === true && this.element.find(".visibleIcon.cf-hide").length > 0) {
        this.element.find(".visibleIcon").removeClass("cf-hide");
      }

      // wait on Prerender
      this.element.find('[name=waitOnPreRender]').prop('checked', Util.getValue(this.options.settings.postprocess.waitonprerender, false));

      // parallel Prerender
      this.element.find('[name=parallelPrerender]').prop('checked', Util.getValue(this.options.settings.postprocess.parallelPrerender, false));

      // remove_dot
      this.element.find('[name=remove_dot]').prop('checked', Util.getValue(this.options.settings.postprocess.remove_dot, false));
      this.element.find('[name=remove_dot_size]').ValueInput('option', 'value', Util.getValue(this.options.settings.postprocess.remove_dot_size, 0));
      this.element.find('[name=remove_connected_count_px]').val(Util.getValue(this.options.settings.postprocess.remove_connected_count_px, 0));
      this.element.find('.removeDotSizeFrom').toggle(this.options.settings.postprocess.remove_dot === true);

      // Decoration (slugline)
      this.element.find('[name="add_decoration"]').prop('checked', Util.getValue(this.options.settings.postprocess.add_decoration, false));
      this.decorationSelector.ResourceSelector('option', 'value', this.options.settings.postprocess.decoration);
      this.element.find('[name="margin_left"]').ValueInput('option', 'value', Util.getValue(this.options.settings.postprocess.margin_left, 0));
      this.element.find('[name="margin_right"]').ValueInput('option', 'value', Util.getValue(this.options.settings.postprocess.margin_right, 0));
      this.element.find('[name="margin_top"]').ValueInput('option', 'value', Util.getValue(this.options.settings.postprocess.margin_top, 0));
      this.element.find('[name="margin_bottom"]').ValueInput('option', 'value', Util.getValue(this.options.settings.postprocess.margin_bottom, 0));
      this.element.find('.decorationFrom').toggle(this.options.settings.postprocess.add_decoration === true);

      // TIF output
      this.element.find('.outputPathFrom').toggle(this.options.settings.output.outputPathEnable);
      this.element.find('[name=outputPathEnable]').prop('checked', Util.getValue(this.options.settings.output.outputPathEnable, false));
      this.element.find('[name=outputPath]').val(this.options.settings.output.outputPath);
      //make if possible, a better value for outputPath
      Util.controlOutputPath('file:///', this.element.find('.outputPath'));

      // CIP3 output
      this.element.find('.outputPathCIP3From').toggle(this.options.settings.cip3.outputPathEnable);
      this.element.find('[name=outputPathCIP3Enable]').prop('checked', Util.getValue(this.options.settings.cip3.outputPathEnable, false));
      this.element.find('[name=outputPathCIP3]').val(this.options.settings.cip3.outputPath);
      //make if possible, a better value for outputPath
      Util.controlOutputPath('file:///', this.element.find('[name=outputPathCIP3]'));

      // Copy Technical Inks (colors)
      this.element.find('[name=copyTechnicalInks]').prop('checked', Util.getValue(this.options.settings.postprocess.copytechnicalinks, false));

      // Hold
      this.element.find('[name=outputPathHold]').prop('checked', Util.getValue(this.options.settings.output.outputPathHold, false));
      // enable / disable Hold
      var disabled = !(this.options.settings.cip3.outputPathEnable || this.options.settings.output.outputPathEnable);
      this.element.find('.outputPathHold').prop('disabled', disabled).each(function () {
        if (disabled) {
          $(this).addClass('disabled');
        } else {
          $(this).removeClass('disabled');
        }
      });
      if (this.options.settings.postprocess.panel_visible === false) {
        // set on invisible if set expecitly on false
        this.element.find('.visibleIcon').removeClass('fa-eye').addClass('fa-eye-slash');
      } else {
        // default visible on true
        this.element.find('.visibleIcon').removeClass('fa-eye-slash').addClass('fa-eye');
      }
      this._readOnlyChange();
    },
    /**
     * @brief this function runs when information changed, and trigger the change event
     * so the information is throws for further process
     * @param {object} pEvent
     * @returns {undefined}
     */
    _changeHandler: function _changeHandler(pEvent) {
      if (this.options.settings.cip3 === undefined) {
        this.options.settings.cip3 = {};
      }
      if (this.options.settings.postprocess === undefined) {
        this.options.settings.postprocess = {};
      }

      // wait on Prerender
      this.options.settings.postprocess.waitonprerender = this.element.find('[name=waitOnPreRender]').is(':checked');

      // parallel Prerender
      this.options.settings.postprocess.parallelPrerender = this.element.find('[name=parallelPrerender]').is(':checked');

      // scum dot removal
      this.options.settings.postprocess.remove_dot = this.element.find('[name=remove_dot]').is(':checked');
      this.element.find('.removeDotSizeFrom').toggle(this.options.settings.postprocess.remove_dot === true);
      this.options.settings.postprocess.remove_dot_size = parseFloat(this.element.find('[name="remove_dot_size"]').ValueInput('option', 'value'));
      this.options.settings.postprocess.remove_connected_count_px = parseInt(this.element.find('[name="remove_connected_count_px"]').val());

      // decoration (slugline)
      this.options.settings.postprocess.add_decoration = this.element.find('[name=add_decoration]').is(':checked');
      this.element.find('.decorationFrom').toggle(this.options.settings.postprocess.add_decoration === true);
      this.options.settings.postprocess.decoration = this.element.find('[name="postprocess.decoration"]').val();
      this.options.settings.postprocess.margin_left = parseFloat(this.element.find('[name="margin_left"]').ValueInput('option', 'value'));
      this.options.settings.postprocess.margin_right = parseFloat(this.element.find('[name="margin_right"]').ValueInput('option', 'value'));
      this.options.settings.postprocess.margin_top = parseFloat(this.element.find('[name="margin_top"]').ValueInput('option', 'value'));
      this.options.settings.postprocess.margin_bottom = parseFloat(this.element.find('[name="margin_bottom"]').ValueInput('option', 'value'));

      // handle ui changes TIF files
      this.element.find('.outputPathFrom').toggle(this.element.find('.outputPathCheck').is(':checked'));
      //make if possible, a better value for outputPath
      Util.controlOutputPath('file:///', this.element.find('[name=outputPath]'));

      // update outputpath settings
      this.options.settings.output.outputPathEnable = this.element.find('.outputPathCheck').is(':checked');
      this.options.settings.output.outputPath = this.element.find('[name=outputPath]').val();
      this.options.settings.output.outputPathHold = this.element.find('.outputPathHold').is(':checked');

      // handle ui changes CIP3
      var isChecked = this.element.find('.outputPathCIP3Check').is(':checked');
      this.element.find('.outputPathCIP3From').toggle(isChecked);
      //make if possible, a better value for outputPath
      Util.controlOutputPath('file:///', this.element.find('[name=outputPathCIP3]'));
      // update CIP3 settings
      this.options.settings.cip3.outputPathEnable = isChecked;
      this.options.settings.cip3.outputPath = this.element.find('[name=outputPathCIP3]').val();

      // copy technical inks (colors)
      this.options.settings.postprocess.copytechnicalinks = this.element.find('[name=copyTechnicalInks]').is(':checked');

      // disable enable Hold
      var disabled = !(this.element.find('.outputPathCheck').is(':checked') || this.element.find('.outputPathCIP3Check').is(':checked'));
      this.element.find('.outputPathHold').prop('disabled', disabled).each(function () {
        if (disabled) {
          $(this).addClass('disabled');
        }
      });
      this._trigger('change', pEvent, {
        "settings": this.options.settings
      });
    },
    /**
     * @description function runs when user click on the eye icon
     * @function
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _visibleIconClickHandler: function _visibleIconClickHandler(pEvent, pData) {
      if ($(pEvent.currentTarget).hasClass('fa-eye')) {
        $(pEvent.currentTarget).removeClass('fa-eye').addClass('fa-eye-slash');
        this.options.settings.postprocess.panel_visible = false;
      } else {
        $(pEvent.currentTarget).removeClass('fa-eye-slash').addClass('fa-eye');
        this.options.settings.postprocess.panel_visible = true;
      }
      this._trigger('change', pEvent, {
        "settings": this.options.settings
      });
    },
    _readOnlyChange: function _readOnlyChange() {
      if (this.options.readOnly === true) {
        this.element.find('input').prop('disabled', true);
      } else {
        this.element.find('input:not(.disabled)').prop('disabled', false);
      }
    },
    /**
     * @brief sets the option
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._refresh();
    }
  });
})(jQuery);

},{"./Util.js":304}],312:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

(function ($) {
  function getFileName(pFile) {
    if (typeof pFile === "string" && pFile.length > 1) {
      return pFile.substring(pFile.lastIndexOf('/') + 1);
    }
    return pFile;
  }
  var TemporyBrowserObjectCache = require("../../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
  var BlueCollarProvider = require("../../../../quantum/js/BlueCollarProvider.js");
  $.widget("nixps.RIPEditorPresets", {
    widgetEventPrefix: "ripeditorpresets",
    options: {
      /**
       * @description The language of the user.
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * The settings blob with the RIP parameters
       */
      presets: [],
      /**
       * @description The name of the preset we must select on start up, if preset does not exsist or not match,
       * nothing will be preselected
       * @type {String}
       * @default undefined
       */
      default_preset: undefined,
      /**
       * @description Is the current preset customized currently
       */
      custom: false,
      /**
      * @brief the filter for the node definition list
      */
      blueCollarID: "com.nixps.quantum.rip.1",
      /**
       * @brief whitepaper name/workflow name
       */
      whitepaper: undefined,
      /**
       * @brief inputname of the whitepaper
       */
      whitepaper_input_name: undefined,
      /**
       * @brief array of selected files
       */
      selectedFiles: [],
      /**
       * @brief all information of the workable for getting colors in "hold in kiosk"
       */
      workableInfo: {},
      /**
       * @brief the ripsettings to fill in on default
       */
      RIPSettings: {},
      /**
       * @description If dfe_context is defined, the UI switch to the DFE RIP Editor.
       * @type {object}
       * @default undefined
       */
      dfeSettings: undefined
    },
    /** 
     * @brief creates the editor component
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.alive = true;
      this.blueCollarProvider = new BlueCollarProvider();
      if (this.options.dfeSettings !== undefined) {
        // Get the (current) DFE context from the database.
        var query = ['type', 'equal to', 'Engineer'];
        if (typeof this.options.dfeSettings.app === 'string') {
          query.push('and', 'context.app', 'equal to', this.options.dfeSettings.app);
        }
        var dfeDB = api.custom_objects.list('fundamentals', query).results;
        if (dfeDB.length > 1) {
          var dfeKiosk = api.custom_objects.list('fundamentals', ['type', 'equal to', 'Engineer', 'and', 'kiosk', 'equal to', true]).results;
          if (dfeKiosk.length === 1) {
            dfeDB = dfeKiosk;
          }
        }
        if (dfeDB.length === 0) {
          // No Fundamentals is installed or not configured yet.
          this.element.append($("<h4>").text('Fundamentals is not configured yet.').css('margin-left', '50px'));
          this.element.append($("<h4>").text('Please contact your administrator.').css('margin-left', '50px'));
          this.element.append($("<div>").addClass('hideFileSection') // div to hide the 'File' section
          .css({
            'height': '600px',
            'position': 'absolute',
            'top': '70px',
            'left': '-10px',
            'right': '-10px',
            'z-index': '99',
            'background-color': 'white'
          }));
          return;
        } else {
          if (dfeDB.length > 1) {
            var apps = [];
            var select = $('<select>').addClass('dfeToUseInKiosk').css({
              'width': 'initial',
              'display': 'inline',
              'margin-left': '20px'
            });
            dfeDB.forEach(function (dfe) {
              if (dfe.context !== undefined) {
                select.append($('<option value=' + dfe.context.app + '>').text(dfe.context.productName || dfe.context.appName || dfe.context.app));
              }
            });
            this.element.append($("<h4>").text('More than one Fundamentals is installed.').css('margin-left', '50px'));
            this.element.append($("<h4>").text('Select the on to use in Kiosk: ').css('margin-left', '50px').append(select).append($('<button>').addClass('btn btn-primary cf-button-main').text($.i18n._("nixps-cloudflow-FileChooser.select")).css({
              'margin-left': '10px'
            }).on('click', function () {
              var app = select.val();
              var dfeKiosk = api.custom_objects.list('fundamentals', ['type', 'equal to', 'Engineer', 'and', 'kiosk', 'equal to', true], ['_id']).results;
              dfeKiosk.forEach(function (row) {
                api.custom_objects.set_keys('fundamentals', row._id, {
                  'kiosk': false
                });
              });
              var dfeDB = api.custom_objects.list('fundamentals', ['type', 'equal to', 'Engineer', 'and', 'context.app', 'equal to', app], ['_id']).results;
              if (dfeDB.length > 0) {
                api.custom_objects.set_keys('fundamentals', dfeDB[0]._id, {
                  'kiosk': true
                });
              }
            })));
            this.element.append($("<div>").addClass('hideFileSection') // div to hide the 'File' section
            .css({
              'height': '600px',
              'position': 'absolute',
              'top': '80px',
              'left': '-10px',
              'right': '-10px',
              'z-index': '99',
              'background-color': 'white'
            }));
            return;
            // More than on Fundamentals is installed. Select the one to used in Kiosk.
            // this.options.dfeSettings = dfeDB[0]; // take the first one for the moment.
            // The current context used should be shown in the background.
          } else {
            this.options.dfeSettings = dfeDB[0];
          }
          // MArk the current DFE context used in Kiosk.
          var dfeKiosk = api.custom_objects.list('fundamentals', ['type', 'equal to', 'Engineer', 'and', 'kiosk', 'equal to', true], ['_id']).results;
          dfeKiosk.forEach(function (row) {
            api.custom_objects.set_keys('fundamentals', row._id, {
              'kiosk': false
            });
          });
          api.custom_objects.set_keys('fundamentals', this.options.dfeSettings._id, {
            'kiosk': true
          });
          this.Engineer = nixps.dfe.getEngineerInstance(this.options.dfeSettings);
        }
      }
      this.loadPresetsDef = this._loadPresets();
      this.temporaryPreferences = this._getTemporaryPreferences();

      // Add label for presets
      var groupChooser = $("<div>").addClass("cf-form-group");
      this.element.append(groupChooser);
      groupChooser.append($("<label>").addClass("presets-label cf-form-label cf-col-sm-4")._t("nixps-RIPEditor-label.loadpreset"));

      // init parameters
      this.standaloneView = false;
      this._whitepaperChanged();
      this.fileInkSettings = null; // is empty array
      this.fileSelectionCancelled; // lock to indicate that the selected file is canceled
      // The settings dropdown control
      this.m_preset_selector = $("<select>").addClass("cf-form-control").attr("name", "rip_preset").prop("disabled", this.options.disabled);
      groupChooser.append($("<div>").addClass("cf-col-sm-8").append(this.m_preset_selector));
      this._populatePresetPopup();
      this._settingChanged();
      this._on(this.element, {
        "change [name=rip_preset]": this._settingChanged,
        "click .nixps-RIPEditorSeparations .refreshSeparation": this._separationsRefreshHandler,
        "ripeditorchange": this._editorChanged,
        "dfeeditorchange": this._editorChanged
      });

      //decide the ripeditor options
      var refreshButtons = false;
      this.m_ripeditor = $("<div>");
      this.m_ripeditor.appendTo(this.element);
      var options = {
        language: this.options.language,
        bootstrap: true,
        standaloneView: this.standaloneView,
        enableSeparationRefreshButton: refreshButtons,
        applyVisibility: true,
        readOnly: this.options.disabled
      };
      if (this.options.dfeSettings !== undefined) {
        options.dfe_context = this.options.dfeSettings.context;
      }
      this._RIPorDFE_Editor(options);

      // Hide the label before us
      this.element.prev().hide();

      // Our dialog
      if ($("body").hasClass("nixps-Dialog") === false && $.fn.Dialog !== undefined) {
        $("body").Dialog({});
      }
      // change css for freezeOverlay to see and work properly
      this.element.find(".nixps-RIPEditorSeparations").css("position", "relative");
    },
    _RIPorDFE_Editor: function _RIPorDFE_Editor(data) {
      if (this.m_ripeditor === undefined) {
        return;
      }
      switch (arguments.length) {
        case 1:
          if (this.options.dfeSettings !== undefined) {
            data.dfeSettings = this.options.dfeSettings;
            // data.readOnly = this.Engineer.get('appOptions.ui.allowPresetEditionInJobStation');
            return this.m_ripeditor.DFEEditor(data);
          }
          return this.m_ripeditor.RIPEditor(data);
        case 2:
          if (this.options.dfeSettings !== undefined) {
            return this.m_ripeditor.DFEEditor(arguments[0], arguments[1]);
          }
          return this.m_ripeditor.RIPEditor(arguments[0], arguments[1]);
        case 3:
          if (this.options.dfeSettings !== undefined) {
            return this.m_ripeditor.DFEEditor(arguments[0], arguments[1], arguments[2]);
          }
          return this.m_ripeditor.RIPEditor(arguments[0], arguments[1], arguments[2]);
        case 4:
          if (this.options.dfeSettings !== undefined) {
            return this.m_ripeditor.DFEEditor(arguments[0], arguments[1], arguments[2], arguments[3]);
          }
          return this.m_ripeditor.RIPEditor(arguments[0], arguments[1], arguments[2], arguments[3]);
        default:
          throw "More than 4 arguments is not supported. Why?";
      }
      ;
    },
    /**
     * @brief functions runs when whitepaper/workflow changed and to update the changes
     * this calculates if it is in standalone setting or not
     * @returns {nothing}
     */
    _whitepaperChanged: function _whitepaperChanged() {
      if (typeof this.options.whitepaper === "string" && this.options.whitepaper.length > 0 && typeof this.options.whitepaper_input_name === "string" && this.options.whitepaper_input_name.length > 0) {
        if (this.options.whitepaper === "Standalone RIP" && this.options.whitepaper_input_name === "Standalone RIP") {
          this.standaloneView = true;
        } else {
          this.standaloneView = false;
        }
      } else {
        this.standaloneView = false;
      }
    },
    _separationsRefreshHandler: function _separationsRefreshHandler(pEvent, pData) {},
    /**
     * @brief The presets from the backend are coming in, so let's populate ourselves with it
     */
    _loadPresets: function _loadPresets() {
      var that = this;
      return $.Deferred(function (pDefer) {
        var options = ["identifier", "equal to", that.options.blueCollarID];
        var defaultName = "Default";
        if (that.options.dfeSettings !== undefined) {
          defaultName = that.options.dfeSettings.context.app + "-" + defaultName;
          options.push("and", "(", "dfe.app", "equal to", that.options.dfeSettings.context.app, "or", "not", "preset", "exists", ")");
        } else {
          options.push("and", "not", "dfe", "exists");
        }
        that.blueCollarProvider.list(options, function (p_data) {
          if (that.alive === false) {
            // zombie
            pDefer.reject("component is dead");
            return;
          }
          if (that.m_ripeditor !== undefined && that.m_ripeditor.is(":nixps-RIPEditor") === false && that.m_ripeditor.is(":nixps-DFEEditor") === false) {
            // if ripeditor is dead, do nothing, the call came too late, after dead
            // so there is nothing we can do anymore
            pDefer.reject("component is dead");
            return true;
          }
          if (p_data === undefined || !Array.isArray(p_data.results)) {
            // Presets loading failed
            that.m_ripeditor.empty().append($.i18n._("nixps-RIPEditor-label.errormessagepresets") + p_data.error);
          } else {
            // sort alfabetic
            p_data.results.sort(function (a, b) {
              if (typeof a.name === "string") {
                return a.name.localeCompare(b.name);
              } else if (typeof a.preset == "string") {
                return a.preset.localeCompare(b.preset);
              } else {
                return 0;
              }
            });
            var selectedPreset = that.element.find("[name=rip_preset]").val();
            if (selectedPreset === "Custom") {
              selectedPreset = that.element.find("[name=rip_preset] option[value=Custom]").prop("preset");
              selectedPreset = that._uncustomizeName(selectedPreset);
            } else if (selectedPreset === undefined && !$.isEmptyObject(that.options.RIPSettings)) {
              selectedPreset = that.options.RIPSettings.preset_name;
              selectedPreset = that._uncustomizeName(selectedPreset);
            }
            if (that.options.dfeSettings !== undefined && selectedPreset) {
              var prefix = that.options.dfeSettings.context.app + "-";
              if (selectedPreset.indexOf(prefix) !== 0) {
                selectedPreset = prefix + selectedPreset;
              }
            }
            that.m_presets = [];
            that.options.presets = [];
            var original_node = undefined;
            var default_found = false,
              selection_found = undefined;

            // Enumerate all the presets
            for (var index in p_data.results) {
              var preset = p_data.results[index];
              var name = preset.preset;
              if (preset.dfe !== undefined && preset.dfe.app !== undefined && preset.name !== undefined && name.indexOf(preset.dfe.app) === 0) {
                name = preset.name;
                if (name === preset.preset) {
                  name = name.substring(preset.dfe.app.length + 1);
                }
              }
              if (name === undefined && preset.node_definition !== undefined && preset.node_definition.variant === undefined) {
                original_node = preset;
              } else {
                if (preset.preset === defaultName) {
                  that.options.presets.splice(0, 0, {
                    "preset": preset.preset,
                    "name": "Default"
                  });
                  default_found = true;
                } else {
                  that.options.presets.push({
                    "preset": preset.preset,
                    "name": name
                  });
                }
                that.m_presets.push(preset);
                if (name === selectedPreset && preset.preset === selectedPreset) {
                  // #48844
                  selection_found = true;
                  if (!$.isEmptyObject(that.options.RIPSettings)) {
                    selection_found = that._deepContains(that.options.RIPSettings, preset.node_definition.parameters);
                  }
                }
              }
            }

            // If we haven't found a default setting, use the bluecollardefinition
            var def = {}; // emoty object, found, null issue in creation, deferred waiting on call 
            if (default_found === false) {
              def = that._creatDefaultPreset(defaultName, original_node, that.options.dfeSettings);
              if (def !== null) {
                def.done(function (pDefaultPreset) {
                  that.options.presets.splice(0, 0, {
                    "preset": "Default",
                    "name": "Default"
                  });
                  that.m_presets.push(def);
                  that.blueCollarProvider.addToCache(def, function () {}, function (pError) {
                    // an error occured durring adding cacth
                    that.blueCollarProvider.purge();
                  });
                });
              }
            }

            // should work for {}, null, $.Deferred
            $.when(def).done(function () {
              // Refresh the popup
              that._populatePresetPopup();
              if (selection_found) {
                that._customizeRipPreset(undefined);
                that.element.find("[name=rip_preset]").val(selectedPreset);
              } else if (!$.isEmptyObject(that.options.RIPSettings)) {
                that._customizeRipPreset(that.options.RIPSettings.preset_name);
                that._RIPorDFE_Editor("option", "settings", that.options.RIPSettings);
              }
              that._settingChanged();
            }).always(function () {
              pDefer.resolve();
            });
          }
        }, function (pError) {
          pDefer.reject(pError);
          console.error(pError);
        });
      });
    },
    /**
     * Functions to convert preset name to edited (custom) and not edited.
     * Caution: In the preset management name with "Custom (blahblah)" should be forbidden.
     * Same in the preset summary: the preset name needs to be translated (i18n)
     */
    _customRegExp: new RegExp(/^\* Custom - (.+) \*$/),
    // _customRegExp: new RegExp(/^\* (.+) \*$/),
    _uncustomizeName: function _uncustomizeName(name) {
      if (name !== undefined) {
        return name.replace(this._customRegExp, "$1");
      }
      return undefined;
    },
    _customizeName: function _customizeName(name, i18n) {
      // return "* " + name + " *";
      if (i18n) {
        return $.i18n._("nixps-RIPEditor-label.custom_and_preset", [name]);
      }
      return "* Custom - " + name + " *";
    },
    _customizeRipPreset: function _customizeRipPreset(preset_name) {
      if (preset_name !== undefined) {
        preset_name = this._uncustomizeName(preset_name);
        this.options.custom = true;
        this.element.find("[name=rip_preset]").val("Custom");
        this.element.find("[name=rip_preset] option[value=Custom]").text(this._customizeName(preset_name, true)).prop("preset", preset_name).show();
        if ($.isPlainObject(this.options.RIPSettings)) {
          this.options.RIPSettings.preset_name = this._customizeName(preset_name);
        }
      } else {
        this.options.custom = false;
        this.element.find("[name=rip_preset] option[value=Custom]").prop("preset", "Custom").text($.i18n._("nixps-RIPEditor-label.customname")).hide();
      }
    },
    /**
    @Desc Compare 2 objects.
    Check that the "contained" fields exist and are equal in the "container"
     **/
    _deepContains: function _deepContains(container, contained) {
      var that = this;
      var kCtner = Object.keys(container).sort();
      var kCtned = Object.keys(contained).sort();
      if (kCtner.length < kCtned.length) {
        return false;
      }
      var ret = true;
      for (var i = 0; i < kCtned.length && ret; i++) {
        if (!container.hasOwnProperty(kCtned[i])) {
          continue;
        }
        // DFE exception: some rip_settings comes from the "Media"
        if (this.options.dfeSettings !== undefined) {
          if (kCtned[i] === "rip_curves") {
            continue;
          }
        }
        var o1 = container[kCtned[i]];
        var o2 = contained[kCtned[i]];
        if (_typeof(o1) == "object" && _typeof(o2) == "object") {
          ret = that._deepContains(o1, o2);
        } else {
          ret = o1 === o2 ? true : false;
        }
        // if ( ret === false ) {
        //     console.log('Diff on ' + kCtned[i]);
        //     console.log(o1);
        //     console.log(o2);
        // }
      }

      return ret;
    },
    /**
     * @description Refresh the presets and the component
     * @function
     * @return {Deferred}
     */
    redraw: function redraw() {
      return this._loadPresets();
    },
    /**
     * @brief create a default preset 
     * we suppose there is no default preset!!
     * @param {string} Default Name: "Default:
     * @param {object} the "generic" blucollardefinition
     * @param {object} the DFE context
     * @returns {object} the Dwfault object created
     */
    _creatDefaultPreset: function _creatDefaultPreset(defaultName, pDefault, pDFE) {
      var defaultPreset = {};
      if (pDefault !== undefined) {
        defaultPreset = pDefault;
      }
      if (defaultPreset.identifier === undefined) {
        defaultPreset = {
          "identifier": "com.nixps.quantum.rip.1"
        };
      }
      if (defaultPreset.node_definition === undefined) {
        defaultPreset.node_definition = {
          'collar': 'com.nixps.quantum.rip.1',
          'title': 'Default',
          'parameters': {}
        };
      } else {
        defaultPreset.node_definition.collar = 'com.nixps.quantum.rip.1';
        defaultPreset.node_definition.title = "Default";
        if (defaultPreset.node_definition.parameters === undefined) {
          defaultPreset.node_definition.parameters = {};
        }
      }
      if (pDFE !== undefined) {
        var params = defaultPreset.node_definition.parameters;
        if (pDFE.defaultJobTicket !== undefined) {
          $.extend(true, params, pDFE.defaultJobTicket);
        }
        params.dfe = true;
        if (!$.isPlainObject(defaultPreset.dfe)) {
          defaultPreset.dfe = {
            'app': pDFE.context.app
          };
        } else {
          defaultPreset.dfe.app = pDFE.context.app;
        }
      }
      if ($.isEmptyObject(defaultPreset) === false) {
        var json = $.extend(true, {}, defaultPreset);
        json.name = "Default";
        json.preset = defaultName;
        delete json._id;
        return api_defer.bluecollardefinition.create(json);
      }
      return null;
    },
    _populatePresetPopup: function _populatePresetPopup() {
      this.m_preset_selector.empty();
      for (var i in this.options.presets) {
        this.m_preset_selector.append($("<option>").val(this.options.presets[i].preset).text(this.options.presets[i].name));
      }
      var proposalSelected = [];
      if (this.options.default_preset === undefined || this.options.default_preset === "Default") {
        if (this.temporaryPreferences !== null && typeof this.temporaryPreferences.last_selected_preset_name === "string" && this.temporaryPreferences.last_selected_preset_name.length > 0) {
          proposalSelected.push(this.temporaryPreferences.last_selected_preset_name);
        }
      }
      if (typeof this.options.default_preset === "string" && this.options.default_preset.length > 0) {
        proposalSelected.push(this.options.default_preset);
      }
      for (var i = 0; i < proposalSelected.length; i++) {
        if (this.m_preset_selector.find("option[value=\"" + proposalSelected[i] + "\"]").length > 0) {
          this.m_preset_selector.val(proposalSelected[i]);
          break;
        }
      }
      $('<option value="Custom">').prop('preset', 'Custom').text($.i18n._("nixps-RIPEditor-label.customname")).hide().appendTo(this.m_preset_selector);
    },
    _getTemporaryPreferences: function _getTemporaryPreferences() {
      var temporySettings = TemporyBrowserObjectCache.get("nixps_cloudflow_RIPSettings");
      return temporySettings;
    },
    _saveTemporaryPreferences: function _saveTemporaryPreferences(pPreset) {
      this.temporaryPreferences = {};
      if (typeof pPreset === "string" && pPreset.length > 0) {
        this.temporaryPreferences = {
          "last_selected_preset_name": pPreset
        };
      }
      TemporyBrowserObjectCache.save("nixps_cloudflow_RIPSettings", this.temporaryPreferences);
    },
    /**
     * @description Reset the separations that are populated.
     * @function
     * @param {string} pFileName 
     * @returns {undefined}
     */
    resetSeparation: function resetSeparation(pFileName) {
      if (Array.isArray(this.options.selectedFiles) && this.options.selectedFiles.length > 0) {
        if (typeof pFileName === "string" && pFileName.length > 0) {
          // make array of selected file names
          var selectedFileNames = this.options.selectedFiles.map(function (elem, index) {
            return decodeURI(getFileName(elem));
          });
          var selectedFileIndex = selectedFileNames.indexOf(pFileName);
          if (selectedFileIndex >= 0) {
            this.fileSelectionCancelled = true; // add lock to inform that the selected file is removed or cancelled
            // remove the file in the selected file array
            delete this.options.selectedFiles[selectedFileIndex];
            this.options.selectedFiles = $.map(this.options.selectedFiles, function (elem) {
              return elem;
            });
          } else {
            console.error('selected file not found');
            return;
          }
        }
      }
      // update the separation information
      var preset_name = this.element.find('[name=rip_preset]').val();
      var inks;
      if (preset_name === "Custom") {
        preset_name = this.element.find('[name=rip_preset] option[value=Custom]').prop('preset');
        if (this.options.dfeSettings !== undefined) {
          inks = this.Engineer.getDefaultInks();
        } else {
          inks = this.m_ripeditor.RIPEditor("option").settings.separations.inks;
        }
      }
      var that = this;
      return this.loadPresetsDef.then(function () {
        for (var i = 0; i < that.m_presets.length; i++) {
          if (that.m_presets[i].name === preset_name) {
            var empty_dict = {};
            empty_dict.preset_name = preset_name;
            empty_dict.separations = {};
            if (inks !== undefined) {
              empty_dict.separations.inks = inks;
            } else if (that.options.dfeSettings !== undefined) {
              empty_dict.separations.inks = $.extend([], that.Engineer.getDefaultInks());
            } else {
              empty_dict.separations.inks = $.extend([], that.m_presets[i].node_definition.parameters.separations.inks);
            }
            empty_dict.separations.spot_screens = that.m_presets[i].node_definition.parameters.separations.spot_screens;
            //  merge the original settings to current settings
            var curr_dict = that._RIPorDFE_Editor("option", "settings");
            if (that.options.dfeSettings !== undefined) {
              curr_dict.separations.inks = [];
            }
            empty_dict = $.extend(true, curr_dict, empty_dict);
            //  and update ui with resetted separation settings
            that._RIPorDFE_Editor("option", "settings", empty_dict);
            break;
          }
        }
        that.element.find(':nixps-FreezeOverlay').FreezeOverlay('hide');
        that.element.find('.nixps-SeparationList select[name="separations.spot_screens"]').prop('disabled', false).removeClass('disabled');
      });
    },
    _settingChanged: function _settingChanged() {
      if (this.m_presets === undefined) {
        return;
      }
      var preset_name = this.element.find('[name=rip_preset]').val();
      if (preset_name === "Custom") {
        preset_name = this.element.find('[name=rip_preset] option[value=Custom]').prop('preset');
        var settings = this._RIPorDFE_Editor("option", "settings");
        settings.preset_name = this._customizeName(preset_name);
        this._RIPorDFE_Editor("option", "settings", settings);
        this._updateSeparationsInEditor();
        return;
      } else if (this.options.custom === true) {
        var that = this;
        $('body').Dialog("show_yes_no", $.i18n._('nixps-rip-editor-presets.warning_messagetitle'), $.i18n._('nixps-rip-editor-presets.overwrite_message'), {}, function () {
          that._customizeRipPreset(undefined);
          var preset_settings = that._getPresetSettings(that.options.RIPSettings.preset_name);
          if (preset_settings !== undefined) {
            var settings = that._RIPorDFE_Editor("option", "settings");
            settings.separations.inks = preset_settings.separations.inks;
            that._RIPorDFE_Editor("option", "settings", settings);
          } else {
            that._settingChanged();
          }
        }, function () {
          that._customizeRipPreset(that.options.RIPSettings.preset_name);
        });
      } else {
        var preset_settings = this._getPresetSettings(preset_name);
        if (preset_settings !== undefined) {
          var empty_dict = {};
          $.extend(true, empty_dict, preset_settings.parameters);
          empty_dict.preset_name = preset_settings.name;
          this._RIPorDFE_Editor("option", "settings", empty_dict);
          this._updateSeparationsInEditor();
          this._saveTemporaryPreferences(preset_name);
        }
      }
    },
    _getPresetSettings: function _getPresetSettings(preset_name) {
      if (this.m_presets === undefined) {
        return undefined;
      }
      if (preset_name === 'Custom') {
        preset_name = this.element.find('[name=rip_preset] option[value=Custom]').prop('preset');
      }
      for (var index in this.m_presets) {
        if (this.m_presets[index].preset === preset_name) {
          var ret = {
            'name': this.m_presets[index].name,
            'preset': this.m_presets[index].preset,
            'parameters': this.m_presets[index].node_definition.parameters
          };
          if (ret.name === undefined) {
            ret.name = this.m_presets[index].preset;
          }
          return ret;
        }
      }
      return undefined;
    },
    /**
     * @brief update the seperation inks from the file compared with the preset
     * @returns {nothing}
     */
    _updateSeparationsInEditor: function _updateSeparationsInEditor() {
      // get input parameters
      var that = this;
      var pSettings = this._RIPorDFE_Editor("option", "settings");

      //control input parameters
      if (!Array.isArray(pSettings.separations.inks) || $.isEmptyObject(pSettings.separations) || typeof pSettings.separations.spot_screens !== "string") {
        console.error('_updateSeparationsInEditor: wrong parameters');
        return;
      }
      var pfileInks = this.fileInkSettings;
      if (pfileInks === null) {
        // file is not yet loaded, do nothing
        return;
      }
      var preset_inks = [];
      // take information of inks if interface is correct
      if (this.options.dfeSettings !== undefined) {
        preset_inks = pSettings.separations.inks = this.Engineer.getDefaultInks();
      } else {
        var preset_settings = this._getPresetSettings(this.element.find('[name=rip_preset]').val());
        if (preset_settings !== undefined) {
          preset_inks = preset_settings.parameters.separations.inks;
        }
      }
      if (preset_inks.length === 0) {
        console.error('_updateSeparationsInEditor: undefined preset_inks');
        return;
      }
      switch (pSettings.separations.spot_screens) {
        case "none":
          // disable spot colors
          var inks = $.map(pfileInks, function (e, index) {
            var ink = that._getIteritiefColorSettings(preset_inks, e.name, index);
            ink.name = e.name;
            ink.print = ['cyan', 'magenta', 'yellow', 'black'].includes(e.name); // only print for process colors
            return ink;
          });
          pSettings.separations.inks = inks;
          break;
        case "iterate":
          // enable spot colors
          var inks = $.map(pfileInks, function (e, index) {
            var ink = that._getIteritiefColorSettings(preset_inks, e.name, index);
            ink.name = e.name;
            ink.print = true;
            return ink;
          });
          pSettings.separations.inks = inks;
          break;
        case "explicit":
          //take the settings that are defined (before)
          var preset_ink_names = preset_inks.map(function (e, i) {
            return e.name;
          });
          // init the spot color setting
          var spotSettings = preset_inks.filter(function (ink) {
            return ink.name === "<spot>";
          });
          if (spotSettings.length === 0) {
            spotSettings.push({
              // default setting if nothing is found
              angle: 15,
              ruling: pSettings.separations.default_ruling,
              print: false,
              dotshape: pSettings.separations.default_screen
            });
          }
          // loop over inks/colors
          var spot_index = 0;
          var inks = $.map(pfileInks, function (e, i) {
            var index = preset_ink_names.indexOf(e.name);
            if (index >= 0) {
              if (e.name === "<spot>") {
                spot_index = spot_index % spotSettings.length;
                var spot_setting = spotSettings[spot_index];
                spot_index++;
                return spot_setting;
              }
              return preset_inks[index]; // color is present in preset, use that setting
            }
            // color is not present, use spot color settings
            // make copy to not disturb next colors
            spot_index = spot_index % spotSettings.length;
            var spot_setting = spotSettings[spot_index];
            spot_index++;
            return $.extend({}, spot_setting, {
              name: e.name
            });
          });
          pSettings.separations.inks = inks;
          break;
        default:
          console.error("spot_screens not found");
      }

      //update info to RIPEditor
      if (this.m_ripeditor.is(":nixps-RIPEditor") && this.fileInkSettings !== null || this.m_ripeditor.is(":nixps-DFEEditor")) {
        // Puts it to "explicit" to draw the spot colors
        // and ensure the angles and dotshapes specified "explicitelly" for spot colors in the UI are used.
        //pSettings.separations.spot_screens = "explicit";
        if (this.options.dfeSettings !== undefined) {
          pSettings.separations.inks = this.Engineer.initializeInksActions(pSettings.separations.inks);
        }
        this.options.ui_draw_spot_colors = true; // Could be removed
        this._RIPorDFE_Editor("option", "ui", {
          draw_spot_colors: true
        });
        this._RIPorDFE_Editor("option", "settings", pSettings);
        //  class disabled indicates that the select is forced by the situation to be disabled
        //  and is not part of readonly mode
        this.element.find('.nixps-SeparationList select[name="separations.spot_screens"]').prop("disabled", true).addClass("disabled");
      } else {
        this.element.find('.nixps-SeparationList select[name="separations.spot_screens"]').prop("disabled", false).removeClass("disabled");
      }
    },
    /**
     * @description Get colorants Name from metadata
     * @function
     * @private
     * @param {object} pColorant
     * @return {array} colorants
     */
    _getColorants: function _getColorants(pColorant) {
      if (!Array.isArray(pColorant.perFile) || pColorant.perFile.length <= 0) {
        return {
          error: "No files"
        };
      }
      var that = this;
      var colorants = [];
      if (this.options.dfeSettings !== undefined) {
        // In a "DFE" context the different separations are managed in the UI.
        // "Digital" inks (usualy CMYK (+ W/O/G/V)) are printed. The other ones are mapped or converted.
        for (var i = 0; i < pColorant.perFile.length; i++) {
          if (Array.isArray(pColorant.perFile[i].colorants)) {
            // ignore files that has no colorants like csv files
            pColorant.perFile[i].colorants.forEach(function (name) {
              if (colorants.indexOf(name) === -1) {
                colorants.push(name);
              }
            });
          }
        }
      } else {
        var colorantsIndex = pColorant.perFile.findIndex(function (pPerFile) {
          return Array.isArray(pPerFile.colorants);
        });
        if (colorantsIndex === -1) {
          // if no file has colorants, then there is an error
          return {
            error: 'Result has empty "data"'
          };
        }
        colorants = pColorant.perFile[colorantsIndex].colorants;
        // add for each non color file, default the first array of colors we found
        // this will then pass the next 'for'-loops  
        pColorant.perFile.forEach(function (pPerFile) {
          if (Array.isArray(pPerFile.colorants) === false) {
            pPerFile.colorants = colorants;
          }
        });
        // In a "flexo" context the list of separations should identical for all files.
        // Makes sense especially when screening.
        // Loop over all files. If there are more files, try to fix that situation
        for (var i = 0; i < pColorant.perFile.length; i++) {
          if (Array.isArray(pColorant.perFile[i].colorants)) {
            // ignore other files who has no colorants
            var otherColorants = pColorant.perFile[i].colorants;
            if (!_.isEqual(colorants, otherColorants)) {
              // if there is a difference between the colorants. Go to the old behavior!
              console.warn('can not merge colornames over different files');
              // control if we can go to the old working behavior
              if (pColorant.names.complete === true && Array.isArray(pColorant.names.data) && pColorant.names.data.length > 0) {
                colorants = pColorant.names.data;
                break;
              } else {
                // we can even not do the old behavior, screem something
                console.error('could not merge colors');
                return {
                  error: 'could not merge colors'
                };
              }
            }
          }
        }
      }
      colorants = colorants.map(function (n) {
        return {
          name: that.translateInksCMYK(n),
          print: true
        };
      });
      return colorants;
    },
    /**
     * @brief iterate over the default inks and return the ink settings corresponding to the correct inkt
     * @param {object} pInks
     * @param {string} pInkName
     * @param {number} pNumber
     * @returns {Object} ink settings match with the rip settings
     */
    _getIteritiefColorSettings: function _getIteritiefColorSettings(pInks, pInkName, pNumber) {
      // first loop over known settings, if setting is found, use that setting, 
      // if setting is not found, use the looped setting
      if (pInkName !== '<spot>') {
        for (var i = 0; i < pInks.length; i++) {
          if (pInkName === pInks[i].name) {
            return pInks[i];
          }
        }
      }
      return $.extend({}, pInks[pNumber % 4 /* amount process colors */]);
    },

    _editorChanged: function _editorChanged() {
      this.options.custom = true;
      this.options.RIPSettings = this._RIPorDFE_Editor("option", "settings");
      if (this.options.RIPSettings.preset_name === undefined) {
        this.options.RIPSettings.preset_name = this.element.find('[name=rip_preset]').val();
      }
      this._customizeRipPreset(this.options.RIPSettings.preset_name);
      this._RIPorDFE_Editor("option", "settings", this.options.RIPSettings);
    },
    /**
     * @brief get all the values(e.a: rip settings) in the resolve parameter
     * @returns {object}
     */
    getValue: function getValue() {
      return this._RIPorDFE_Editor("option", "settings");
    },
    /**
     * @description put, set specific settings
     * @param {type} pSettings The settings you want to apply
     * @returns {undefined}
     */
    setValue: function setValue(pSettings) {
      if ($.isEmptyObject(pSettings) || !$.isPlainObject(pSettings)) {
        throw new Error('invalid inputparameter');
      }
      this.options.RIPSettings = pSettings;
      this.options.RIPSettings.preset_name = this._uncustomizeName(this.options.RIPSettings.preset_name);
      if (this.m_presets !== undefined && this.m_presets.length > 0) {
        var found = undefined;
        for (var i = 0; i < this.m_presets.length; i++) {
          if (this.m_presets[i].name === this.options.RIPSettings.preset_name) {
            if (this._deepContains(this.options.RIPSettings, this.m_presets[i])) {
              found = this.m_presets[i];
            }
            break;
          }
        }
        if (found !== undefined) {
          this.element.find('[name=rip_preset]').val(found);
        } else {
          this._customizeRipPreset(this.options.RIPSettings.preset_name);
          this._RIPorDFE_Editor("option", "settings", this.options.RIPSettings);
        }
      } else {
        var preset_name = this.options.RIPSettings.preset_name;
        if (preset_name === undefined) {
          preset_name = "Custom";
          this.options.RIPSettings.preset_name = preset_name;
        }
        this._customizeRipPreset(preset_name);
        this._RIPorDFE_Editor("option", "settings", this.options.RIPSettings);
      }
      this.element.find('[name=rip_preset]').val("Custom");
      this._RIPorDFE_Editor("option", "settings", pSettings);
    },
    /**
     * @brief translate every name of a master inks colors to a name with first letter in lowercase 
     * @param {string} pInkColor
     * @returns {string} translated pInkColor
     */
    translateInksCMYK: function translateInksCMYK(pInkColor) {
      if (/^(Cyan|Magenta|Yellow|Black)$/.test(pInkColor)) {
        return pInkColor.toLowerCase();
      }
      return pInkColor;
    },
    /**
     * @brief This function gets called when the metadata processing has started
     */
    processMetadata: function processMetadata() {
      this.fileSelectionCancelled = false; // disable lock when new files or information come in.
      this.element.find(':nixps-FreezeOverlay').remove();
      $('<div>').FreezeOverlay({
        text: $.i18n._("nixps-RIPEditorColor.waittext_loadingseparations")
      }).css({
        'background-color': 'rgba(0,0,0,0.2)',
        'display': 'flex',
        'flex-direction': 'column',
        'align-items': 'center'
      }).appendTo(this.element.find('.nixps-RIPEditorSeparations')).show();
      this.element.find('div.waitText').css({
        'max-width': 'initial',
        'top': '5px',
        'left': 'initial'
      });
    },
    /**
     * @brief This function gets called when the metadata is available
     * @param {*} metadata 
     */
    setMetadata: function setMetadata(metadata) {
      var pSettings = this._RIPorDFE_Editor("option", "settings");
      var colorants = this._getColorants({
        perFile: metadata['ColorantsPerFile'],
        names: metadata['ColorantNames']
      });
      if (colorants.error !== undefined) {
        this.fileInkSettings = null;
        if (this.fileSelectionCancelled) {
          return; // cancel if user cancelled
        }

        if (colorants.error !== "no files") {
          // do not yell when there are no files
          console.error(colorants.error);
          this.element.find('.nixps-FreezeOverlay').FreezeOverlay('hide');
          // Trac#31943 $('body').Dialog("show_ok", $.i18n._('nixps-rip-editor-presets.error_messagetitle'), $.i18n._('nixps-rip-editor-presets.wrongfile_message'), function(){});
          this.resetSeparation(undefined);
        }
      } else {
        this.fileInkSettings = colorants;
        this._updateSeparationsInEditor();
        this.element.find('.nixps-FreezeOverlay').FreezeOverlay('hide');
      }
    },
    resetMetadata: function resetMetadata() {
      var options = this._RIPorDFE_Editor("option");
      if (options !== undefined) {
        var pSettings = options.settings;
        if (pSettings !== undefined && pSettings.separations !== undefined && pSettings.separations.inks !== undefined) {
          this.element.find('.nixps-FreezeOverlay').FreezeOverlay('hide');
          this.fileInkSettings = null;
          this._settingChanged();
        }
      }
    },
    /**
     * @brief sets the option
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "whitepaper" || pKey === "whitepaper_input_name") {
        this._superApply(arguments);
        this._whitepaperChanged();
        this._RIPorDFE_Editor("option", "standaloneView", this.standaloneView);
      } else if (pKey === "selectedFiles") {
        if (!Array.isArray(pValue)) {
          throw new Error('RIPEditorPrestes:setOptions "selectedFiles" input must have a array as value');
        }
        this._superApply(arguments);
        if (Array.isArray(this.fileInkSettings)) {
          this._updateSeparationsInEditor();
        }
      } else if (pKey === "workableInfo") {
        this._superApply(arguments);
        if (Array.isArray(this.fileInkSettings)) {
          this._updateSeparationsInEditor();
        }
      } else if (pKey === "disabled") {
        if (pValue !== this.options.disabled) {
          this._superApply(arguments);
          this.m_preset_selector.prop("disabled", this.options.disabled);
          this._RIPorDFE_Editor({
            readOnly: this.options.disabled
          });
        }
      } else {
        this._superApply(arguments);
      }
    },
    /**
     * @description function cals when removing component
     * @returns {undefined}
     */
    _destroy: function _destroy() {
      this.alive = false;
      // cancel callback function, if function calls after removing
      // so if callback is called after removing, he does nothing
      // importing for testing tools!
      this.fileSelectionCancelled = true;
      if (this.blueCollarProvider && typeof this.blueCollarProvider.destroy === "function") {
        this.blueCollarProvider.destroy();
      }
      this.element.removeClass(this.widgetFullName);
    }
  });
})(jQuery);

},{"../../../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280,"../../../../quantum/js/BlueCollarProvider.js":435}],313:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function ($) {
  var Util = require("./Util.js");
  var License = require("../../../../cloudflow/License/js/License.js");
  $.widget("nixps.RIPEditorSeparations", {
    widgetEventPrefix: "ripeditorseparations",
    options: {
      /**
       * The RIP Settings object
       */
      settings: undefined,
      /**
       * Created in a bootstrap environment
       */
      bootstrap: true,
      /**
       * Sub Components
       */
      default_screen_control: undefined,
      separation_list: undefined,
      /**
       * @desc must we show a refreshbutton
       * @type {boolean}
       * @default false
       */
      enableSeparationRefreshButton: false,
      /**
       * @description Must we just open de panel in readOnly mode?
       * @type {Boolean}
       * @default false
      */
      readOnly: false
    },
    /** 
     * @brief creates the output panel
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.addClass("col-lg-6 cf-col-lg-6");

      // The panel
      var panel = $("<div>").addClass("panel panel-default cf-panel").appendTo(this.element);

      // Header for the Output Blob
      if (this.options.bootstrap) {
        $("<div>").addClass("panel-heading").append($("<h3>").addClass("panel-title")._t("nixps-RIPEditor-separations.title")).appendTo(panel);
      }

      // The body of the panel
      var panelBody = $("<div>").addClass("panel-body").appendTo(panel);
      this._addControls(panelBody);
      this._refresh();
      this._on(this.element, {
        'change [name="separations.use_job_settings"]': this._changeHandler,
        'change [name="separations.use_object_bump"]': this._changeHandler,
        'change [name="separations.default_ruling"]': this._changeHandler,
        'change [name="separations.default_dotsize"]': this._changeHandler,
        'change [name="separations.transition_point"]': this._changeHandler,
        'change [name="separations.rescale_images"]': this._changeHandler,
        "screenselectorchange": this._changeHandler,
        "separationlistchange": this._changeHandler
      });
    },
    /**
     * @brief This function adds controls 
     * @param pPanelBody The <div> of the Separations panel
     */
    _addControls: function _addControls(pPanelBody) {
      this._addDefaultScreening(pPanelBody);
      this._addSeparations(pPanelBody);
    },
    /**
     * @brief Adds the Default Screening section 
     * @param pPanelBody The <div> of the Separations panel
     */
    _addDefaultScreening: function _addDefaultScreening(pPanelBody) {
      pPanelBody.append($("<legend>").addClass("cf-legend")._t("nixps-RIPEditor-separations.sub_title"));
      var useJobSettings = $("<div>").addClass("checkbox").css("margin-bottom", 5).append($("<label>").append($("<input>").attr("type", "checkbox").attr("name", "separations.use_job_settings").addClass("singelChoose cf-form-checkbox")).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-separations.retrievehalftone")));
      Util.createFormGroup($.i18n._("nixps-RIPEditor-separations.jobmetadata"), useJobSettings).appendTo(pPanelBody);
      var useObjectBump = $("<div>").addClass("checkbox").css("margin-bottom", 5).append($("<label>").append($("<input>").attr("type", "checkbox").attr("name", "separations.use_object_bump").addClass("singelChoose cf-form-checkbox")).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-separations.useobjectbump")));
      Util.createFormGroup("", useObjectBump).appendTo(pPanelBody);
      var rulingGroup = $("<div>").addClass("row cf-form-group help-parameter-group");
      rulingGroup.append("<label for=\"separations.default_ruling\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-separations.defaultruling") + "</label>");
      var controls = $("<div>").addClass("cf-col-xs-7");
      controls.appendTo(rulingGroup);
      controls.append("<input name=\"separations.default_ruling\" type=\"text\" class=\"form-control cf-form-control lpi-input\" data-nixps-quantum-type=\"number\">");
      rulingGroup.append("<label for=\"separations.default_ruling\" class=\"dpi-label cf-col-xs-1 cf-form-labeltail\">" + $.i18n._("nixps-units.ruling.display-lpi") + "</label>");
      rulingGroup.appendTo(pPanelBody);
      this.default_screen_control = $("<div>").ScreenSelector({
        name: "separations.default_screen"
      });
      this.default_screen_control.find("select").addClass("form-control cf-form-control");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-separations.defaultdotshape"), this.default_screen_control).appendTo(pPanelBody);
      var micronGroup = $("<div>").hide().addClass("row cf-form-group help-parameter-group");
      micronGroup.append("<label for=\"separations.default_dotsize\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-separations.hxmmindotsize") + "</label>");
      var micronControls = $("<div>").addClass("cf-col-xs-7");
      micronControls.appendTo(micronGroup);
      micronControls.append("<input name=\"separations.default_dotsize\" type=\"text\" class=\"form-control cf-form-control lpi-input\" data-nixps-quantum-type='number'>");
      micronGroup.append("<label for=\"separations.default_dotsize\" class=\"dpi-label cf-col-xs-1 cf-form-labeltail\">&mu;</label>");
      micronGroup.appendTo(pPanelBody);
      var transitionGroup = $("<div>").hide().addClass("row cf-form-group help-parameter-group");
      transitionGroup.append("<label for=\"separations.transition_point\" class=\"cf-col-sm-4 control-label cf-form-label\">" + $.i18n._("nixps-RIPEditor-separations.transition_point") + "</label>");
      transitionGroup.appendTo(pPanelBody);
      var transitionControls = $("<div>").addClass("cf-col-xs-7");
      transitionControls.appendTo(transitionGroup);
      transitionControls.append("<input name=\"separations.transition_point\" type=\"text\" class=\"form-control cf-form-control lpi-input\" data-nixps-quantum-type='number'>");
      transitionGroup.append("<label for=\"separations.transition_point\" class=\"dpi-label cf-col-xs-1 cf-form-labeltail\">%</label>");
      var rescaleBox = $("<select name=\"separations.rescale_images\" data-nixps-quantum-type='string'>");
      rescaleBox.addClass("form-control cf-form-control");
      rescaleBox.append("<option value=\"none\">" + $.i18n._("nixps-RIPEditor-separations.rescale_none") + "</option>");
      rescaleBox.append("<option value=\"auto\">" + $.i18n._("nixps-RIPEditor-separations.rescale_auto") + "</option>");
      rescaleBox.append("<option value=\"full\">" + $.i18n._("nixps-RIPEditor-separations.rescale_full") + "</option>");
      rescaleBox.append("<option value=\"lowpass\">" + $.i18n._("nixps-RIPEditor-separations.rescale_lowpass") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-separations.rescale_images"), rescaleBox).appendTo(pPanelBody);
      License.get().then(function (license) {
        if (license.check('hxm_screening')) {
          micronGroup.css("display", "");
        }
        if (license.check('velvet_screening')) {
          micronGroup.css("display", "");
          transitionGroup.css("display", "");
        }
      });
    },
    /**
     * @brief Adds the separation list 
     * @param pPanelBody The <div> of the Separations panel
     */
    _addSeparations: function _addSeparations(pPanelBody) {
      pPanelBody.append($("<legend>").addClass("cf-legend")._t("nixps-RIPEditor-separations.sub_title2"));
      var excludeProcessingSteps = $("<div>").addClass("checkbox").css("margin-bottom", 5).append($("<label>").append($("<input>").attr("type", "checkbox").attr("name", "separations.exclude_processing_steps").addClass('singelChoose cf-form-checkbox')).append($('<span>').addClass("cf-form-checkboxlabel")._t("nixps-RIPEditor-separations.excludeprocessingsteps")));
      Util.createFormGroup("", excludeProcessingSteps).appendTo(pPanelBody);
      this.separation_list = $("<div>");
      this.separation_list.SeparationList({
        "settings": this.options.settings
      });
      this.separation_list.find('.row .checkbox input[type=checkbox]').addClass('singelChoose cf-form-checkbox');
      this.separation_list.appendTo(pPanelBody);
      // add refresh  button
      if (this.options.enableSeparationRefreshButton === true) {
        $('<span>').addClass('fa fa-refresh refreshSeparation').css({
          "cursor": "pointer",
          "right": 35,
          "position": "absolute",
          'z-index': 1
        }).insertBefore(this.separation_list);
      }
    },
    /**
     * @brief Update our controls with the proper data
     * @param pPanelBody The <div> of the Separations panel
     */
    _refresh: function _refresh() {
      var separation_settings;
      if (this.options.settings !== undefined && this.options.settings.separations !== undefined) {
        separation_settings = this.options.settings.separations;
      } else {
        separation_settings = {};
      }

      // Our own settings
      this.element.find('[name="separations.use_job_settings"]').prop("checked", Util.getValue(separation_settings.use_job_settings, true));
      this.element.find('[name="separations.default_ruling"]').val(Util.getValue(separation_settings.default_ruling, 150));
      this.element.find('[name="separations.default_dotsize"]').val(Util.getValue(separation_settings.default_dotsize, 50));
      this.element.find('[name="separations.transition_point"]').val((Util.getValue(separation_settings.transition_point, 0) * 100.0).toFixed(2));
      this.element.find('[name="separations.rescale_images"]').val(Util.getValue(separation_settings.rescale_images, "none"));
      this.element.find('[name="separations.use_object_bump"]').prop("checked", Util.getValue(separation_settings.use_object_bump, false));
      this.element.find('[name="separations.exclude_processing_steps"]').prop("checked", Util.getValue(separation_settings.exclude_processing_steps, false));
      if (separation_settings.use_job_settings) {
        this.element.find('[name="separations.use_object_bump"]').prop("disabled", false);
      } else {
        this.element.find('[name="separations.use_object_bump"]').prop("disabled", true);
      }

      // Default screen
      this.default_screen_control.ScreenSelector("option", "value", separation_settings.default_screen);
      if (typeof separation_settings.default_screen === "string" && separation_settings.default_screen.startsWith("Velvet")) {
        this.element.find('[name="separations.transition_point"]').prop("disabled", false);
      } else {
        this.element.find('[name="separations.transition_point"]').prop("disabled", true);
      }
      if (this.options.readOnly === true) {
        this.element.find('input, select').prop("disabled", true);
      }
      this._readOnlyChange();
    },
    _readOnlyChange: function _readOnlyChange() {
      if (this.options.readOnly === true) {
        this.element.find('input, select').prop("disabled", true);
      } else {
        this.element.find('input:not(.disabled), select:not(.disabled)').prop("disabled", false);
      }
    },
    /**
     * @brief Change an option (typically our settings)
     * @param pKey The key of the option to change
     * @param pValue The new value for the option
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      if (options.settings !== undefined && _typeof(options.settings) === "object") {
        this.separation_list.SeparationList("option", "settings", options.settings);
      } else if (options.ui !== undefined && _typeof(options.ui) === "object") {
        this.separation_list.SeparationList("option", "ui", options.ui);
      }
      this._refresh();
    },
    _changeHandler: function _changeHandler(pEvent) {
      // Get the separation list settings...
      this.options.settings = this.separation_list.SeparationList("option", "settings");

      // ...and update the non-separation list settings
      this.options.settings.separations.use_job_settings = this.element.find('[name="separations.use_job_settings"]').is(':checked');
      this.options.settings.separations.default_dotsize = parseInt(this.element.find('[name="separations.default_dotsize"]').val());
      this.options.settings.separations.transition_point = parseFloat(this.element.find('[name="separations.transition_point"]').val()) / 100.0;
      this.options.settings.separations.rescale_images = this.element.find('[name="separations.rescale_images"]').val();
      this.options.settings.separations.use_object_bump = this.element.find('[name="separations.use_object_bump"]').is(':checked');
      this.options.settings.separations.exclude_processing_steps = this.element.find('[name="separations.exclude_processing_steps"]').is(':checked');
      var that = this;
      var default_ruling = parseInt(this.element.find('[name="separations.default_ruling"]').val());
      if (!this.options.settings.separations.override_rulings && this.options.settings.separations.default_ruling !== default_ruling) {
        this.options.settings.separations.inks.forEach(function (ink) {
          if (ink.ruling === that.options.settings.separations.default_ruling) {
            ink.ruling = default_ruling;
          }
        });
      }
      this.options.settings.separations.default_ruling = default_ruling;
      var default_screen = this.default_screen_control.ScreenSelector("option", "value");
      if (!this.options.settings.separations.override_dotshape && this.options.settings.separations.default_screen !== default_screen) {
        this.options.settings.separations.inks.forEach(function (ink) {
          if (ink.dotshape === that.options.settings.separations.default_screen) {
            ink.dotshape = default_screen;
          }
        });
      }
      this.options.settings.separations.default_screen = default_screen;

      // Notify daddy
      this._trigger("change", pEvent, {
        "settings": this.options.settings
      });
    }
  });
})(jQuery);

},{"../../../../cloudflow/License/js/License.js":175,"./Util.js":304}],314:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*global panzer, $, alert, setTimeout, namespace, nixps */
/*global jQuery*/

(function ($) {
  "use strict";

  var Util = require("./Util.js");

  /**
   * @desc translate the color names to names that begins with a uppercase letter
   * @function
   * @private
   * @static
   * @param {string} pInkt
   * @returns {String}
   */
  function translateSeparationNames(pInkt) {
    switch (pInkt) {
      case "cyan":
        return "Cyan";
      case "magenta":
        return "Magenta";
      case "yellow":
        return "Yellow";
      case "black":
        return "Black";
      default:
        return pInkt;
    }
  }
  $.widget("nixps.SeparationList", {
    widgetEventPrefix: "separationlist",
    options: {
      /**
       * The settings blob with the RIP parameters
       */
      settings: undefined
    },
    /*
    "separations": {
          "default_screen": "Round",
          "default_ruling": 150,
          "use_job_settings": true,
          "override_rulings": false,
          "override_dotshape": false,
          "spot_screens": "iterate",
          "inks": {
            "cyan": {
              "print": "Yes",
              "angle": 15,
              "ruling": 150,
              "dotshape": "Round"
            },
            "magenta": {
              "print": "Yes",
              "angle": 45,
              "ruling": 150,
              "dotshape": "Round"
            },
            "yellow": {
              "print": "Yes",
              "angle": 90,
              "ruling": 150,
              "dotshape": "Round"
            },
            "black": {
              "print": "Yes",
              "angle": 75,
              "ruling": 150,
              "dotshape": "Round"
            },
            "<spot>": {
              "print": "No",
              "angle": 37,
              "ruling": 150,
              "dotshape": "Round"
            }
          }
        },
                }
    */

    /** 
     * @brief creates the editor component
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      var override_rulings = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.override_rulings\" class=\"cf-form-checkbox\" /><span class='cf-form-checkboxlabel'>" + $.i18n._("nixps-RIPEditor-separations.setruling") + "</span></label></div>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-separations.overridedefaults"), override_rulings).appendTo(this.element);
      var override_dotshape = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.override_dotshape\" class=\"cf-form-checkbox\" /><span class='cf-form-checkboxlabel'>" + $.i18n._("nixps-RIPEditor-separations.setdothape") + "</span></label></div>");
      Util.createFormGroup("", override_dotshape).appendTo(this.element);
      var output_empty_separations = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.output_empty\" class=\"cf-form-checkbox\" /><span class='cf-form-checkboxlabel'>" + $.i18n._("nixps-RIPEditor-separations.outputemptycolors") + "</span></label></div>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-separations.emptyseparations"), output_empty_separations).appendTo(this.element);
      var output_only_selected_printed_method = $("<div class=\"checkbox\"><label><input type=\"checkbox\" name=\"separations.output_only_selected_printing_method\" class=\"cf-form-checkbox\" /><span class='cf-form-checkboxlabel'>" + $.i18n._("nixps-RIPEditor-separations.outputonlyselectedprintingmethod") + "</span></label></div>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-separations.printingmethod"), output_only_selected_printed_method).appendTo(this.element);
      var printing_methods = $("<select>").attr({
        "name": "separations.printing_method"
      });
      printing_methods.addClass("cf-form-control");
      printing_methods.append("<option value=\"offset\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_offset") + "</option>");
      printing_methods.append("<option value=\"flexo\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_flexo") + "</option>");
      printing_methods.append("<option value=\"gravure\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_gravure") + "</option>");
      printing_methods.append("<option value=\"foil\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_foil") + "</option>");
      printing_methods.append("<option value=\"emboss\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_emboss") + "</option>");
      printing_methods.append("<option value=\"letterpress\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_letterpress") + "</option>");
      printing_methods.append("<option value=\"screen\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_screen") + "</option>");
      printing_methods.append("<option value=\"inkjet\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_inkjet") + "</option>");
      printing_methods.append("<option value=\"toner\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_toner") + "</option>");
      printing_methods.append("<option value=\"thermaltransfer\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_thermaltransfer") + "</option>");
      printing_methods.append("<option value=\"other\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_other") + "</option>");
      printing_methods.append("<option value=\"custom\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_custom") + "</option>");
      printing_methods.append("<option value=\"dyesublimation\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_dyesublimation") + "</option>");
      printing_methods.append("<option value=\"electrostatic\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_electrostatic") + "</option>");
      printing_methods.append("<option value=\"laser\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_laser") + "</option>");
      printing_methods.append("<option value=\"latex\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_latex") + "</option>");
      printing_methods.append("<option value=\"uv\">" + $.i18n._("nixps-RIPEditor-separations.printingmethods_uv") + "</option>");
      Util.createFormGroup("", printing_methods).appendTo(this.element);
      var customMethodName = $("<input>").attr({
        "type": "text",
        "name": "separations.custom_printing_method"
      });
      customMethodName.addClass("cf-form-control");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-separations.customprintingmethod"), customMethodName).appendTo(this.element);
      var spot_screens = $("<select>").attr({
        "name": "separations.spot_screens"
      });
      spot_screens.addClass("cf-form-control");
      spot_screens.append("<option value=\"none\">" + $.i18n._("nixps-RIPEditor-separations.spotcolorscreens_not") + "</option>");
      spot_screens.append("<option value=\"iterate\">" + $.i18n._("nixps-RIPEditor-separations.spotcolorscreens_iterate") + "</option>");
      spot_screens.append("<option value=\"explicit\">" + $.i18n._("nixps-RIPEditor-separations.spotcolorscreens_specify") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-separations.spotcolorscreens"), spot_screens).appendTo(this.element);

      // Create the separation table
      this.mSeparationTable = $("<div>").addClass("sep-table").appendTo(this.element);

      // Angle family prepopulation
      var angle_families = $("<select>").addClass("cf-form-control").attr("name", "angle_families").attr("nixps-quantum-util-autobind", "false");
      angle_families.append("<option selected value=\"x\">" + $.i18n._("nixps-RIPEditor-separations.anglefamily_choose") + "</option>");
      angle_families.append("<option value=\"default\">" + $.i18n._("nixps-RIPEditor-separations.anglefamily_offset") + "</option>");
      angle_families.append("<option value=\"flexo\">" + $.i18n._("nixps-RIPEditor-separations.anglefamily_flexo") + "</option>");
      Util.createFormGroup($.i18n._("nixps-RIPEditor-separations.anglefamily"), angle_families).appendTo(this.element);
      this._refresh();
      this._on(this.element, {
        "change select": this._changeHandler,
        "change input": this._changeHandler,
        "screenselectorchange": this._changeHandler,
        "click .sep-button-add": this._addSeparationClickHandler,
        "click .sep-button-remove": this._removeSeparationClickHandler
      });
    },
    _changeHandler: function _changeHandler(pEvent) {
      // Check for the angle family populator (tm)
      if (pEvent.target.name === "angle_families") {
        var angles = [];
        if (this.element.find('[name=angle_families]').val() === "default") {
          angles = [15, 75, 90, 45];
        } else if (this.element.find('[name=angle_families]').val() === "flexo") {
          angles = [7.5, 67.5, 82.5, 37.5];
        }
        if (angles.length > 0) {
          for (var index = 0; index < this.options.settings.separations.inks.length; index++) {
            this.options.settings.separations.inks[index].angle = angles[index % 4];
          }
          this._refresh();
        }
      }

      // Store the regular stuff
      this.options.settings.separations.override_rulings = this.element.find('[name="separations.override_rulings"]').is(':checked');
      this.options.settings.separations.override_dotshape = this.element.find('[name="separations.override_dotshape"]').is(':checked');
      this.options.settings.separations.output_empty = this.element.find('[name="separations.output_empty"]').is(':checked');
      this.options.settings.separations.spot_screens = this.element.find('[name="separations.spot_screens"]').val();
      this.options.settings.separations.output_only_selected_printing_method = this.element.find('[name="separations.output_only_selected_printing_method"]').is(':checked');
      this.options.settings.separations.printing_method = this.element.find('[name="separations.printing_method"]').val();
      this.options.settings.separations.custom_printing_method = this.element.find('[name="separations.custom_printing_method"]').val();
      // loop over all separations / colors
      if (!Array.isArray(this.options.settings.separations.inks)) {
        this.options.settings.separations.inks = [];
      }
      for (var index = 0, len = this.element.find(".sep-row:visible").length; index < len; index++) {
        this._storeSeparation(index);
      }
      this._trigger("change", pEvent, {
        "settings": this.options.settings
      });
    },
    _storeSeparation: function _storeSeparation(pIndex) {
      if (this.options.settings.separations.inks[pIndex] === undefined) {
        this.options.settings.separations.inks[pIndex] = {};
      }
      var ink = this.options.settings.separations.inks[pIndex];
      ink.print = this._safeSave(ink.print, this.element.find('[name="separations.inks.' + pIndex + '.print"]').is(":checked"));
      ink.angle = parseFloat(this._safeSave(ink.angle, this.element.find('[name="separations.inks.' + pIndex + '.angle"]').val()));
      ink.ruling = parseFloat(this._safeSave(ink.ruling, this.element.find('[name="separations.inks.' + pIndex + '.ruling"]').val()));
      ink.dotshape = this._safeSave(ink.dotshape, this.element.find('[name="separations.inks.' + pIndex + '.dotshape"]').val());
      if (pIndex >= 4) {
        ink.name = this._safeSave(ink.name, this.element.find('[name="separations.inks.' + pIndex + '.name"]').val());
      }
    },
    _safeSave: function _safeSave(pComponent, pValue) {
      if (pValue !== undefined && pValue !== null) {
        return pValue;
      }
      return pComponent;
    },
    /**
     * @description Functio runs when user clicked on the plus button to insert a new spot separation
     * @function
     * @private
     * @name nixps-SeparationList#_addSeparationClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _addSeparationClickHandler: function _addSeparationClickHandler(pEvent, pData) {
      var separationIndex = $(pEvent.target).closest("[index]").attr("index");
      if (separationIndex !== undefined) {
        separationIndex = parseInt(separationIndex);
        var separationToCopy = this.options.settings.separations.inks[separationIndex];
        if (separationToCopy && _typeof(separationToCopy) === "object") {
          // update model and trigger change to force redraw
          this.options.settings.separations.inks.splice(separationIndex, 0, structuredClone(separationToCopy));
          this._trigger("change", pEvent, {
            "settings": this.options.settings
          });
        }
      }
    },
    /**
     * @description Functio runs when user clicked on the remove button to remove a specific spot separation
     * @function
     * @private
     * @name nixps-SeparationList#_removeSeparationClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _removeSeparationClickHandler: function _removeSeparationClickHandler(pEvent, pData) {
      var separationIndex = $(pEvent.target).closest("[index]").attr("index");
      if (separationIndex !== undefined) {
        separationIndex = parseInt(separationIndex);
        if (typeof separationIndex === "number" && separationIndex > 3) {
          var separationToRemove = this.options.settings.separations.inks[separationIndex];
          if (separationToRemove && _typeof(separationToRemove) === "object") {
            // update model and trigger change to force redraw
            this.options.settings.separations.inks.splice(separationIndex, 1);
            this._trigger("change", pEvent, {
              "settings": this.options.settings
            });
          }
        }
      }
    },
    _createSeparationRow: function _createSeparationRow(pSeparationName, pDictionary, pRow, pSpot, pShowRulings, pShowDotshaps) {
      var pShowButtons = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var pDisableRemoveButton = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
      var separationRow = $("<div>").addClass("sep-row").attr("index", pRow);
      var separationPrint = $("<div>");
      separationPrint.addClass("sep-print help-parameter-group");
      var separationPrintInput = $("<input>").prop("checked", pDictionary.print == true).addClass("cf-form-checkbox").attr({
        "type": "checkbox",
        "name": "separations.inks." + pRow + ".print"
      });
      separationPrint.append(separationPrintInput);
      separationPrint.appendTo(separationRow);
      var separationName = $("<div>");
      separationName.addClass("sep-name");
      if (pSpot === undefined || pSpot === false) {
        separationName.append(pSeparationName);
        separationPrintInput.attr("aria-label", pSeparationName);
      } else {
        separationName.append($("<input>").addClass("cf-form-inputtype").attr({
          "type": "text",
          "size": "20",
          "name": "separations.inks." + pRow + ".name",
          "value": pSeparationName
        }));
      }
      separationName.appendTo(separationRow);
      var separationAngle = $("<div>");
      separationAngle.addClass("sep-angle help-parameter-group");
      separationAngle.append($("<input>").addClass("cf-form-inputtype").attr({
        "value": pDictionary.angle,
        "type": "text",
        "inputmode": "decimal",
        "size": "4",
        "data-nixps-quantum-type": "number",
        "name": "separations.inks." + pRow + ".angle"
      }).append(" &deg;"));
      separationAngle.appendTo(separationRow);
      if (pShowRulings === true) {
        var separationRuling = $("<div>");
        separationRuling.addClass("sep-ruling");
        separationRuling.append($("<input>").attr({
          "value": pDictionary.ruling,
          "type": "text",
          "inputmode": "decimal",
          "size": "4",
          "data-nixps-quantum-type": "number",
          "name": "separations.inks." + pRow + ".ruling"
        }).addClass("cf-form-inputtype").append($.i18n._("nixps-units.ruling.display-lpi")));
        separationRuling.appendTo(separationRow);
      }
      if (pShowDotshaps === true) {
        var separationDotshape = $("<div>");
        separationDotshape.addClass("sep-dotshape");
        separationDotshape.ScreenSelector({
          "name": "separations.inks." + pRow + ".dotshape",
          "value": pDictionary.dotshape,
          "selectClasses": "cf-form-inputtype"
        });
        separationDotshape.appendTo(separationRow);
      }
      if (pShowButtons === true) {
        var separationButtons = $("<div>");
        separationButtons.addClass("sep-action-buttons hideInSummary");
        separationButtons.append([$("<button>").addClass("sep-button-remove cf-iconbutton cf-icon cf-icon-minus-circle").attr({
          "type": "button",
          "title": $.i18n._("nixps-cloudflow-ArrayInput.add_row")
        }).prop("disabled", pDisableRemoveButton === true), $("<button>").addClass("sep-button-add cf-iconbutton cf-icon cf-icon-plus-circle").attr({
          "type": "button",
          "title": $.i18n._("nixps-cloudflow-ArrayInput.remove_row")
        })]);
        separationButtons.appendTo(separationRow);
      }
      return separationRow;
    },
    _setOption: function _setOption(pKey, pValue) {
      // this function can be reset!
      this._super(pKey, pValue);
      this._refresh();
    },
    _refresh: function _refresh() {
      this.element.find('[name="angle_families"]').val("x");
      this.element.find('[name="separations.override_rulings"]').prop("checked", this._getValue(this.options.settings.separations.override_rulings, false));
      this.element.find('[name="separations.override_dotshape"]').prop("checked", this._getValue(this.options.settings.separations.override_dotshape, false));
      this.element.find('[name="separations.output_empty"]').prop("checked", this._getValue(this.options.settings.separations.output_empty, false));
      this.element.find('[name="separations.output_only_selected_printing_method"]').prop("checked", this._getValue(this.options.settings.separations.output_only_selected_printing_method, false));
      this.element.find('[name="separations.printing_method"]').val(this._getValue(this.options.settings.separations.printing_method, false));
      this.element.find('[name="separations.custom_printing_method"]').val(this._getValue(this.options.settings.separations.custom_printing_method, ""));
      this.element.find('[name="separations.spot_screens"]').val(this._getValue(this.options.settings.separations.spot_screens, "iterate"));
      if (this._getValue(this.options.settings.separations.output_only_selected_printing_method, false) === false) {
        this.element.find('[name="separations.printing_method"]').attr("disabled", "disabled").addClass("disabled");
        this.element.find('[name="separations.custom_printing_method"]').attr("disabled", "disabled").addClass("disabled");
      } else {
        this.element.find('[name="separations.printing_method"]').removeAttr("disabled").removeClass("disabled");
        if (this.options.settings.separations.printing_method === "custom") {
          this.element.find('[name="separations.custom_printing_method"]').removeAttr("disabled").removeClass("disabled");
        } else {
          this.element.find('[name="separations.custom_printing_method"]').attr("disabled", "disabled").addClass("disabled");
        }
      }

      // Build the table
      this.mSeparationTable.empty();
      this.mSeparationTable.append($("<div>").addClass("sep-heading").append("<div class=\"sep-print help-parameter-group\">" + $.i18n._("nixps-RIPEditor-separations.color_print") + "</div><div class=\"sep-name\">" + $.i18n._("nixps-RIPEditor-separations.color_name") + "</div><div class=\"sep-angle help-parameter-group\">" + $.i18n._("nixps-RIPEditor-separations.color_angle") + "<img src=\"/common/RIPEditor/img/angle_icon_blue.png\" aria-hidden=\"true\"/></div>"));
      if (this.options.settings.separations.override_rulings === true) {
        this.mSeparationTable.find(".sep-heading").append($("<div>").addClass("sep-ruling").text($.i18n._("nixps-RIPEditor-separations.color_ruling")));
      }
      if (this.options.settings.separations.override_dotshape === true) {
        this.mSeparationTable.find(".sep-heading").append($("<div>").addClass("sep-dotshape").text($.i18n._("nixps-RIPEditor-separations.color_dotshape")));
      }
      if (this.options.settings.separations.inks !== undefined) {
        this.drawSeparations(this.options.settings.separations.inks, this.options.settings.separations.spot_screens === "explicit" || this.options.settings.separations.ui_draw_spot_colors === true || this.options.ui !== undefined && this.options.ui.draw_spot_colors === true, this.options.settings.separations.override_rulings, this.options.settings.separations.override_dotshape);
      }
      delete this.options.settings.separations.ui_draw_spot_colors;
    },
    drawSeparations: function drawSeparations(pInks, pAddSpotColors, pShowRulings, pShowDotshaps) {
      // control if tabel alreay exists?
      if (this.element.find(".sep-row").length === 0) {
        // loop over all inks and add them in the same order
        var rowDOMs = [],
          firstSpot = true;
        for (var i = 0; i < pInks.length; i++) {
          // if color is spot color?
          if (["cyan", "magenta", "yellow", "black", "undefined"].includes(pInks[i].name) === false) {
            // add if allowed
            if (pAddSpotColors === true) {
              rowDOMs.push(this._createSeparationRow(pInks[i].name, pInks[i], i, true, pShowRulings, pShowDotshaps, true, firstSpot));
              firstSpot = false;
            }
          } else {
            // color is not spot color
            rowDOMs.push(this._createSeparationRow(translateSeparationNames(pInks[i].name), pInks[i], i, false, pShowRulings, pShowDotshaps, false, false));
          }
        }
        this.mSeparationTable.toggleClass("sep-table-includespots", pAddSpotColors).toggleClass("cf-col-lg-offset-2", !pAddSpotColors).append(rowDOMs);
      } else {
        console.warn("the separations are already there");
      }
    },
    _getValue: function _getValue(pParameter, pDefault) {
      if (pParameter === undefined) {
        return pDefault;
      }
      return pParameter;
    },
    /**
     * @description remove the handles, listeners of the (change) events, and other unfriendly update functions
     * @function
     * @returns {undefined}
     */
    desactivateHandlers: function desactivateHandlers() {
      // remove change event listeners
      this._off(this.element, "change");
      // reset _setoptions  to remove refresh call if options are set
      this._setOption = function () {};
    },
    /**
     * @description remove inputfields or selectors that can not be used during editing in the workflowbuilder (quantum)
     * @function
     * @returns {undefined}
     */
    desactivateUnusableFields: function desactivateUnusableFields() {
      this.element.find('label[for="angle_families"]').parent().remove();
    }
  });
})(jQuery);

},{"./Util.js":304}],315:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
(function ($) {
  var Editor = require("../../Tajiri/Editor.js");
  var BoldPlugin = require("../../Tajiri/js/plugins/BoldPlugin.js");
  var ItalicPlugin = require("../../Tajiri/js/plugins/ItalicPlugin.js");
  var UnderlinePlugin = require("../../Tajiri/js/plugins/UnderlinePlugin.js");
  var StrikePlugin = require("../../Tajiri/js/plugins/StrikePlugin.js");
  var SubScriptPlugin = require("../../Tajiri/js/plugins/SubScriptPlugin.js");
  var SuperScriptPlugin = require("../../Tajiri/js/plugins/SuperScriptPlugin.js");
  var JustifyLeftPlugin = require("../../Tajiri/js/plugins/JustifyLeftPlugin.js");
  var JustifyCenterPlugin = require("../../Tajiri/js/plugins/JustifyCenterPlugin.js");
  var JustifyRightPlugin = require("../../Tajiri/js/plugins/JustifyRightPlugin.js");
  var JustifyFullPlugin = require("../../Tajiri/js/plugins/JustifyFullPlugin.js");
  var ImagePlugin = require("../../Tajiri/js/plugins/ImagePlugin.js");
  var HyperLinkPlugin = require("../../Tajiri/js/plugins/HyperLinkPlugin.js");
  var HyperLinkRemovePlugin = require("../../Tajiri/js/plugins/HyperLinkRemovePlugin.js");
  var RTLPlugin = require("../../Tajiri/js/plugins/RTLPlugin.js");
  var LTRPlugin = require("../../Tajiri/js/plugins/LTRPlugin.js");
  var RemoveFormatPlugin = require("../../Tajiri/js/plugins/RemoveFormatPlugin.js");
  var CopyStylePlugin = require("../../Tajiri/js/plugins/CopyStylePlugin.js");
  var FGColorPlugin = require("../../Tajiri/js/plugins/FGColorPlugin.js");
  var BGColorPlugin = require("../../Tajiri/js/plugins/BGColorPlugin.js");
  var SymbolPlugin = require("../../Tajiri/js/plugins/SymbolPlugin.js");
  var SourcePlugin = require("../../Tajiri/js/plugins/SourcePlugin.js");
  var TemplatePlugin = require("../../Tajiri/js/plugins/TemplatePlugin.js");
  var TranslationPlugin = require("../../Tajiri/js/plugins/TranslationPlugin.js");
  var LineHeightPlugin = require("../../Tajiri/js/plugins/LineHeightPlugin.js");
  var HeadingPlugin = require("../../Tajiri/js/plugins/HeadingPlugin.js");
  var FontSizePlugin = require("../../Tajiri/js/plugins/FontSizePlugin.js");
  var FontFamilyPlugin = require("../../Tajiri/js/plugins/FontFamilyPlugin.js");
  var TablePlugin = require("../../Tajiri/js/plugins/TablePlugin.js");
  var BulletListPlugin = require("../../Tajiri/js/plugins/BulletListPlugin.js");
  var NumberListPlugin = require("../../Tajiri/js/plugins/NumberListPlugin.js");
  var OutdentPlugin = require("../../Tajiri/js/plugins/OutdentPlugin.js");
  var IndentPlugin = require("../../Tajiri/js/plugins/IndentPlugin.js");
  var MentionPlugin = require("../../Tajiri/js/plugins/MentionPlugin.js");
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  ;
  function generateUUID() {
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
  }
  ;
  var kTranslationAttrRegExp = new RegExp('data-tajiri-template-value="([a-zA-Z0-9\-%]*)"', "g");

  /**
   * @brief checks the translator function, must be a function: string->string
   * @private
   * @static
   */
  function checkTranslator(pUnknown) {
    // control input values
    if (typeof pUnknown !== "function") {
      throw new Error("RichEditor: translator option must be a function");
    }
    var result = pUnknown("hallo");
    if (typeof result !== "string") {
      throw new Error("RichEditor: translator option function must return a string");
    }
  }

  /**
   * @private
   * @static
   * @return true if the text should be right to left
   */
  function isTextRTL(pText, pAtLeastOne) {
    if (typeof pText !== "string") {
      throw new Error("invalid parameter");
    }
    var rtlChars = /[\u0590-\u083F]|[\u08A0-\u08FF]|[\uFB1D-\uFDFF]|[\uFE70-\uFEFF]/mg;
    if (pText && pText.length > 0) {
      var matchedChars = pText.match(rtlChars);
      if (matchedChars === null) {
        return false;
      } else if (pAtLeastOne === true) {
        return matchedChars.length > 0;
      }
      return matchedChars.length / pText.length > 0.5;
    }
    return false;
  }
  /**
   * you need charset=UTF-8 to avoid bugs
   * 
   * the rich editor plugin workt with events!
   * @namespace nixps.RichEditor
   * @description A rich text editor. where you can edit text put bold, underline or italic
   * @example $("<div>").RichEditor({});
   * @version 1.6.0
   */
  $.widget("nixps.RichEditor2", $.Widget, {
    widgetEventPrefix: "richeditor",
    version: "1.6.0",
    options: {
      /**
       * @name nixps.RichEditor#language
       * @description The language of the user. If not set it will try to detect the user language
       * @type {String}
       * @default ""
       * @since 1.1.0
       */
      language: "",
      /**
       * @brief Must the editor be inline or not?
       * must the toolbar be visible?
       * @private
       * @name nixps.RichEditor#inline
       * @default true
       */
      inline: true,
      /**
       * @name nixps.RichEditor#text
       * @brief the default text to show
       * @type {String}
       * @default ""
       */
      text: "",
      /**
       * @brief default translator function handles how the text must be translate to the output
       * must accept a string and must return a string,
       * if there is a error you must still return a string
       * @type {Function}
       * @name nixps.RichEditor#translator
       * @default function(string) {
          return string;
      }
       */
      translator: function translator(string) {
        return string;
      },
      /**
       * @description transaltion function to translate the output going to the input
       * @type {Function}
       * @param {String} string the text provided by the output to wards the input
       * @name nixps.RichEditor#inputTranslator
       * @default function(string) {
          return string;
      }
       * @since 1.3.0
       */
      inputTranslator: function inputTranslator(string) {
        return string;
      },
      /**
       * @brief the amount of lines
       * @type {Number}
       * @default 2
       * @name nixps.RichEditor#lines
       */
      lines: 2,
      /**
       * @name nixps.RichEditor#height
       * @description The height of the inner editor panel, This will overwrite the lines options
       * @type {String}
       * @defaut null
       * @since 1.1.0
       */
      height: null,
      /**
       * @description The skin to be used for the styling of the editor
       * @private
       * @name nixps.RichEditor#skin
       * @type {String}
       * @default null
       * @since 1.1.0
       */
      skin: null,
      /**
       * @description The Buttons we may not show, if null the default settings will be used
       * @private
       * @name nixps.RichEditor#removeButtons
       * @type {String}
       * @default null
       * @since 1.1.0
       */
      removeButtons: null,
      /**
       * @description The z-index of the inline buttons panel
       * @type {Number}
       * @default 9999
       * @name nixps.RichEditor#inlinePanelZIndex
       * @since 1.1.1
       */
      inlinePanelZIndex: 9999,
      /**
       * @private
       * @name nixps.RichEditor#applyOnInput
       * @default false
       */
      applyOnInput: false,
      /**
       * @description The placeholder select options
       * @type {Object}
       * @name nixps.RichEditor#placeholderSelect
       * @default {}
       * @since 1.1.1
       */
      placeholderSelect: {},
      /**
       * @description Must we include lineheight option
       * @type {Boolean}
       * @name nixps.RichEditor#enableLineHeight
       * @default false
       * @since 1.2.0
       */
      enableLineHeight: false,
      /**
       * @description Must we add a button to add new translated word.
       * @type {Boolean}
       * @default false
       * @name nixps.RichEditor#enableTranslations
       * @since 1.2.0
       */
      enableTranslations: false,
      /**
       * @description Enable the browser native spell checker.
       * @type {Boolean}
       * @default false
       */
      enableSpellChecker: false,
      /**
       * @description Which element must we use for new lines. It is recommendant by the plugin to not change this option
       * @name nixps.RichEditor#enterMode
       * @type {String}
       * @default "p"
       */
      enterMode: "p",
      /**
       * @description Must we filter all the content or not?
       * @name nixps.RichEditor#filterContent
       * @type {Boolean}
       * @default true
       */
      filterContent: true,
      /**
       * @descrition Must we change the direction depending on the inputs or not?
       * @name nixps.RichEditor#autoDirection
       * @type {Boolean}
       * @default true
       * @since 1.3.0
       */
      autoDirection: true,
      /**
       * @description The configuration of the toolbar
       * @name nixps.RichEditor#toolbarConfiguration
       * @type {Array}
       * @default undefined
       * @since 1.4.0
       */
      toolbarConfiguration: undefined,
      enableUndoRedoAction: true,
      /**
       * @description The callback that returns a list of users to be used by the mention plugin
       * @name nixps.RichEditor#mentionUsersCallback
       * @type {Array}
       * @default null
       * @since 1.5.0
       */
      mentionUsersCallback: null,
      /**
       * @description must  all the \n be changed to \r\n when getting content
       * @name nixps.RichEditor#convertToCRLF
       * @type {Boolean}
       * @default false
       * @since 1.6.0
       */
      convertToCRLF: false,
      /**
       * @description The language for the editor. Will be added as a lang attribute.
       * @name nixps.RichEditor#editorlanguage
       * @type {String}
       * @default "en"
       * @since 1.5.0
       */
      editorlanguage: "en"
    },
    /**
     * @brief constructor
     * @function
     * @private
     * @name nixps.RichEditor#_create
     */
    _create: function _create() {
      var that = this;
      this.element.addClass("nixps-RichEditor");
      var data = this.element.data("nixps-RichEditor2");
      if (data) {
        this.element.data("nixps-RichEditor", data);
      }
      checkTranslator(this.options.translator);
      checkTranslator(this.options.inputTranslator);
      var activateBeforePasteAction = false;
      this.editor = new Editor({
        enterMode: this.options.enterMode,
        filterUnknownContent: this.options.filterContent,
        editorHeight: this.options.height,
        inline: this.options.inline,
        convertToCRLF: this.options.convertToCRLF
      });
      this.editor.appendTo(this.element);
      this.editor.installPlugin(new BoldPlugin(), 10);
      this.editor.installPlugin(new ItalicPlugin(), 10);
      this.editor.installPlugin(new UnderlinePlugin(), 10);
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Strike") === -1) {
        this.editor.installPlugin(new StrikePlugin(), 10);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Subscript") === -1) {
        this.editor.installPlugin(new SubScriptPlugin(), 10);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Superscript") === -1) {
        this.editor.installPlugin(new SuperScriptPlugin(), 10);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("CopyFormatting") === -1) {
        this.editor.installPlugin(new CopyStylePlugin(new BoldPlugin(), new ItalicPlugin(), new UnderlinePlugin(), new FGColorPlugin({
          copyMode: true,
          enterMode: this.options.enterMode
        }), new FontFamilyPlugin({
          enterMode: this.options.enterMode
        }), new FontSizePlugin({
          enterMode: this.options.enterMode
        }), new LineHeightPlugin({
          enterMode: this.options.enterMode
        }), new BGColorPlugin({
          copyMode: false,
          enterMode: this.options.enterMode
        })), 20);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("RemoveFormat") === -1) {
        this.editor.installPlugin(new RemoveFormatPlugin(new BoldPlugin(), new ItalicPlugin(), new UnderlinePlugin(), new StrikePlugin(), new SubScriptPlugin(), new SuperScriptPlugin(), new FGColorPlugin({
          copyMode: true,
          enterMode: this.options.enterMode
        }), new BGColorPlugin({
          copyMode: true,
          enterMode: this.options.enterMode
        })), 20);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("NumberedList") === -1) {
        this.editor.installPlugin(new NumberListPlugin({
          enterMode: this.options.enterMode
        }), 30);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("BulletedList") === -1) {
        this.editor.installPlugin(new BulletListPlugin({
          enterMode: this.options.enterMode
        }), 30);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Outdent") === -1) {
        this.editor.installPlugin(new OutdentPlugin(), 30);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Indent") === -1) {
        this.editor.installPlugin(new IndentPlugin(), 30);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Justify") === -1) {
        this.editor.installPlugin(new JustifyLeftPlugin({
          enterMode: this.options.enterMode
        }), 40);
        this.editor.installPlugin(new JustifyCenterPlugin({
          enterMode: this.options.enterMode
        }), 40);
        this.editor.installPlugin(new JustifyRightPlugin({
          enterMode: this.options.enterMode
        }), 40);
        this.editor.installPlugin(new JustifyFullPlugin({
          enterMode: this.options.enterMode
        }), 40);
      }
      this.editor.enableUndoRedoAction(this.options.enableUndoRedoAction);
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Link") === -1) {
        this.editor.installPlugin(new HyperLinkPlugin({
          enterMode: this.options.enterMode
        }), 50);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Unlink") === -1) {
        this.editor.installPlugin(new HyperLinkRemovePlugin(), 50);
      }
      if (this.options.enableTranslations === true) {
        this.editor.installPlugin(new TranslationPlugin({
          templates: undefined,
          defaultText: $.i18n._("nixps-richeditor.defaulttext_translation"),
          dblClickHandler: this._doubleClickTranslationHandler.bind(this)
        }), 60);
        activateBeforePasteAction = true;
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("BidiRtl") === -1) {
        this.editor.installPlugin(new LTRPlugin({
          enterMode: this.options.enterMode
        }), 70);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("BidiLtr") === -1) {
        this.editor.installPlugin(new RTLPlugin({
          enterMode: this.options.enterMode
        }), 70);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Table") === -1) {
        this.editor.installPlugin(new TablePlugin(), 80);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Image,") === -1) {
        this.editor.installPlugin(new ImagePlugin(), 80);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("SpecialChar") === -1) {
        this.editor.installPlugin(new SymbolPlugin(), 80);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Font") === -1) {
        this.editor.installPlugin(new HeadingPlugin({
          tags: ["h1", "h2", "h3", "pre"],
          enterMode: this.options.enterMode
        }), 90);
        this.editor.installPlugin(new FontFamilyPlugin({
          enterMode: this.options.enterMode
        }), 90);
        this.editor.installPlugin(new FontSizePlugin({
          enterMode: this.options.enterMode
        }), 90);
      }
      if (this.options.enableLineHeight === true) {
        this.editor.installPlugin(new LineHeightPlugin({
          enterMode: this.options.enterMode
        }), 90);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("TextColor") === -1) {
        this.editor.installPlugin(new FGColorPlugin({
          copyMode: false,
          enterMode: this.options.enterMode
        }), 100);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("BGColor") === -1) {
        this.editor.installPlugin(new BGColorPlugin({
          copyMode: false,
          enterMode: this.options.enterMode
        }), 100);
      }
      if ($.isPlainObject(this.options.placeholderSelect) && $.isEmptyObject(this.options.placeholderSelect) === false) {
        this.editor.installPlugin(new TemplatePlugin({
          templates: this.options.placeholderSelect.placeholders
        }), 110);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Mention") === -1) {
        //-1 for end of the list
        if (typeof this.options.mentionUsersCallback !== "function") {
          throw new Error("RichEditor2: the mentionUsersCallback must be a function to install the Mention Plugin.");
        }
        this.editor.installPlugin(new MentionPlugin({
          listCallback: this.options.mentionUsersCallback
        }), -1);
      }
      if (this.options.removeButtons !== null && this.options.removeButtons.indexOf("Source") === -1) {
        this.editor.installPlugin(new SourcePlugin(), 9999);
      }
      if (this.options.disabled === true) {
        this._setDisabled(true);
      }

      // that._trigger("key", pEvent);
      $(this.editor.getArea()).on("input", function (pEvent) {
        that._trigger("change", pEvent);
      });
      // that._trigger("focus", pEvent);
      $(this.element).on("focusout", function (pEvent) {
        that._trigger("blur", pEvent);
      });
      this.editor.setContent(this.options.text);
      if (activateBeforePasteAction === true) {
        this.editor.setPasteAction(this._beforePastHandler.bind(this));
      }
      this._trigger("instanceready", null, {});
      this._trigger("created", null, {
        "contents": this.element
      });
      this._on(this.element, {
        "tajiriinvalidselector": this._invalidCSSSelectorHandler
      });
    },
    /**
     * @description function to run the first time users are typing
     * @function
     * @private
     * @name nixps.RichEditor#"_firstChangeHandler"
     * @param {Object} pEvent 
     */
    _firstChangeHandler: function _firstChangeHandler(pEvent) {
      if (this.options.autoDirection === "input") {
        var currentText = this.getText();
        if (typeof currentText === "string" && currentText.length > 0 && isTextRTL(currentText, true)) {}
      }
    },
    /**
     * @brief fires when user change the text
     * @function
     * @private
     * @name nixps.RichEditor#_changeHandler
     * @returns nothing
     */
    _changeHandler: function _changeHandler(pEvent) {
      var text = this.getText();
      this._setDirection(text);
    },
    /**
     * @description function runs after paste, but text is not jet injected
     * @function
     * @private
     * @name nixps.RichEditor#_pasteHandler
     * @param {Object} pEvent 
     */
    _pasteHandler: function _pasteHandler(pEvent) {
      var currentText = this.getText();
      // only when there is no text at the moment
      if (currentText === "" && pEvent.data !== undefined && pEvent.data.dataTransfer !== undefined) {
        var textToPaste = pEvent.data.dataTransfer.getData("text");
        if (typeof textToPaste === "string" && textToPaste.length > 0) {
          // set the direction before the text is visible
          this._setDirection(textToPaste);
          if (this.options.autoDirection === "input" && isTextRTL(textToPaste)) {
            this.applyAfterPastAction = "RTL";
          }
        } else {
          // in some rare cases the getData("text") is unknown but the getData("text/html") is known
          var htmlToPaste = pEvent.data.dataTransfer.getData("text/html");
          if (typeof htmlToPaste === "string" && htmlToPaste.length > 0) {
            // remove all html tags
            textToPaste = htmlToPaste.replaceAll(/<[^>]*>/g, "");
            if (typeof textToPaste === "string" && textToPaste.length > 0) {
              // set the direction before the text is visible
              this._setDirection(textToPaste);
              if (this.options.autoDirection === "input" && isTextRTL(textToPaste)) {
                this.applyAfterPastAction = "RTL";
              }
            }
          }
        }
      }
    },
    /**
     * @description function runs when user want to copy past some th8ing in the editor
     * @function
     * @private
     * @name nixps.RichEditor#_beforePastHandler
     * @param {Object} pEvent 
     */
    _beforePastHandler: function _beforePastHandler(pEvent) {
      var outputDataTransfer = null;
      if (pEvent.clipboardData !== undefined) {
        var nixpstajiri = pEvent.clipboardData.getData("text/nixpstajiri");
        var textToPaste = pEvent.clipboardData.getData("text/plain");
        var htmlToPaste = pEvent.clipboardData.getData("text/html");
        // make deep copies of translations objects #{}
        if (typeof htmlToPaste === "string" && htmlToPaste.length > 0 && htmlToPaste.indexOf("data-tajiri-template-value=") >= 0) {
          var dict = {}; // containing the old and new replaced uuids
          htmlToPaste = htmlToPaste.replace(kTranslationAttrRegExp, function (pMatch, p1, offset, string) {
            if (typeof p1 === "string" && p1.length > 0) {
              var translationAttribute = decodeURIComponent(p1);
              if (translationAttribute.indexOf("custom-") !== 0) {
                var translationKey = translationAttribute.slice(0, translationAttribute.indexOf(":"));
                var defaultText = translationAttribute.slice(translationAttribute.indexOf(":") + 1);
                var newTranslationKey = generateUUID();
                dict[translationKey] = newTranslationKey;
                return 'data-tajiri-template-value="' + encodeURIComponent(newTranslationKey + ":" + defaultText) + '"';
              }
            }
            return pMatch;
          });
          for (var oldID in dict) {
            $(this.element.$).trigger("translationcopy", {
              origTranslationKey: oldID,
              newTranslationKey: dict[oldID]
            });
          }
          outputDataTransfer = new DataTransfer();
          outputDataTransfer.setData("text/html", htmlToPaste);
          outputDataTransfer.setData("text/plain", textToPaste);
        }
      }
      return outputDataTransfer;
    },
    _afterPastHandler: function _afterPastHandler(pEvent, pData) {
      if (typeof this.applyAfterPastAction === "string") {
        if (this.applyAfterPastAction === "RTL") {
          this._setAllRTL();
        }
        this.applyAfterPastAction = undefined;
      }
    },
    _doubleClickTranslationHandler: function _doubleClickTranslationHandler(pEvent, pData) {
      this._trigger("dblclicktransations", pEvent, pData);
    },
    /**
     * @description auto set the direction depend on the text argument
     * @function
     * @private
     * @name nixps.RichEditor#_setDirection
     * @param {String} text The text to sniff the direction on
     */
    _setDirection: function _setDirection(text) {
      if (this.options.autoDirection === true) {
        if (isTextRTL(text) === true) {
          this.element.css({
            "direction": "rtl"
          });
          if (this.options.inline === false) {
            // this.element.find("iframe").contents().find("body").css({"direction":"rtl"});
          }
        } else {
          this.element.css({
            "direction": "ltr"
          });
          if (this.options.inline === false) {
            // this.element.find("iframe").contents().find("body").css({"direction":"ltr"});
          }
        }
      }
    },
    /**
     * @description apply a rtl to all lines
     * @function
     * @private
     * @name nixps.RichEditor#_setAllRTL
     */
    _setAllRTL: function _setAllRTL() {
      //
    },
    /**
     * @brief returns the input text in html format
     * @function
     * @name nixps.RichEditor#getText
     * @returns {String} the html format of the content
     */
    getText: function getText(pWithVersion) {
      var html = this.editor.getContent(pWithVersion);
      if (typeof html === "string") {
        return this.options.translator(html);
      }
      return html;
    },
    getValue: function getValue(pWithVersion) {
      return this.getText(pWithVersion);
    },
    /**
     * @brief set the input text in html format
     * @function
     * @name nixps.RichEditor#setText
     * @returns nothing
     */
    setText: function setText(pText, pDoneCallback) {
      //always make sure the source mode is off
      this.editor.disableSource();
      pText = this.options.inputTranslator(pText);
      this.editor.setContent(pText);
      this.editor.resetHistory();
      if (typeof pDoneCallback === "function") {
        pDoneCallback();
      }
    },
    setValue: function setValue(pValue, pDoneCallback) {
      return this.setText(pValue, pDoneCallback);
    },
    disable: function disable() {
      this._setDisabled(true);
    },
    enable: function enable() {
      this._setDisabled(false);
    },
    _setDisabled: function _setDisabled(pDisabled) {
      var reason = "disableEditor";
      if (pDisabled === true) {
        this.editor.disable(reason);
        $(this.editor.getArea()).attr("contenteditable", false).attr("disabled", true);
      } else if (pDisabled === false) {
        this.editor.enable(reason);
        $(this.editor.getArea()).attr("contenteditable", true).attr("disabled", false);
      }
    },
    _setEditorLanguage: function _setEditorLanguage(pLang) {
      this.editor.setLanguage(pLang);
    },
    _invalidCSSSelectorHandler: function _invalidCSSSelectorHandler(pEvent) {
      var selectors = pEvent.originalEvent.detail.invalidSelectors;
      this._trigger("invalidselector", pEvent, [selectors]);
    },
    /**
     * @brief handling option changes
     * @function
     * @private
     * @name nixps.RichEditor#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      switch (pKey) {
        case "text":
          this._superApply(arguments);
          this.setText(pValue);
          break;
        case "translator":
        case "inputTranslator":
          this._superApply(arguments);
          checkTranslator(pValue);
          this._changeHandler();
          break;
        case "height":
          this._superApply(arguments);
          this.editor.setHeight(pValue);
          break;
        case "lines":
          this._superApply(arguments);
          break;
        case "disabled":
          this._setDisabled(pValue);
          break;
        case "editorlanguage":
          this._superApply(arguments);
          this._setEditorLanguage(pValue);
          break;
      }
    },
    /**
     * @brief set the focus on the text area
     * @function
     * @name nixps.RichEditor#focus
     * @returns {nothing}
     */
    focus: function focus() {
      this.editor.focus();
    },
    /**
     * @brief destructor
     * @function
     * @private
     * @name nixps.RichEditor#_destroy
     */
    _destroy: function _destroy() {
      this.editor.destroy();
      this.element.removeClass("nixps-RichEditor");
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../Tajiri/Editor.js":320,"../../Tajiri/js/plugins/BGColorPlugin.js":335,"../../Tajiri/js/plugins/BoldPlugin.js":336,"../../Tajiri/js/plugins/BulletListPlugin.js":337,"../../Tajiri/js/plugins/CopyStylePlugin.js":340,"../../Tajiri/js/plugins/FGColorPlugin.js":342,"../../Tajiri/js/plugins/FontFamilyPlugin.js":343,"../../Tajiri/js/plugins/FontSizePlugin.js":344,"../../Tajiri/js/plugins/HeadingPlugin.js":345,"../../Tajiri/js/plugins/HyperLinkPlugin.js":346,"../../Tajiri/js/plugins/HyperLinkRemovePlugin.js":347,"../../Tajiri/js/plugins/ImagePlugin.js":348,"../../Tajiri/js/plugins/IndentPlugin.js":349,"../../Tajiri/js/plugins/ItalicPlugin.js":350,"../../Tajiri/js/plugins/JustifyCenterPlugin.js":351,"../../Tajiri/js/plugins/JustifyFullPlugin.js":352,"../../Tajiri/js/plugins/JustifyLeftPlugin.js":353,"../../Tajiri/js/plugins/JustifyRightPlugin.js":355,"../../Tajiri/js/plugins/LTRPlugin.js":356,"../../Tajiri/js/plugins/LineHeightPlugin.js":357,"../../Tajiri/js/plugins/MentionPlugin.js":359,"../../Tajiri/js/plugins/NumberListPlugin.js":360,"../../Tajiri/js/plugins/OutdentPlugin.js":361,"../../Tajiri/js/plugins/RTLPlugin.js":364,"../../Tajiri/js/plugins/RemoveFormatPlugin.js":365,"../../Tajiri/js/plugins/SourcePlugin.js":366,"../../Tajiri/js/plugins/StrikePlugin.js":367,"../../Tajiri/js/plugins/SubScriptPlugin.js":370,"../../Tajiri/js/plugins/SuperScriptPlugin.js":371,"../../Tajiri/js/plugins/SymbolPlugin.js":372,"../../Tajiri/js/plugins/TablePlugin.js":373,"../../Tajiri/js/plugins/TemplatePlugin.js":374,"../../Tajiri/js/plugins/TranslationPlugin.js":376,"../../Tajiri/js/plugins/UnderlinePlugin.js":377}],316:[function(require,module,exports){
"use strict";

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var richRegExp = new RegExp("\n|&lt;br&gt;|&lt;b&gt;|&lt;\/b&gt;|&lt;i&gt;|&lt;\/i&gt;|&lt;u&gt;|&lt;\/u&gt;|&lt;h1&gt;|&lt;\/h1&gt;|&lt;font color=&#x27;([#0-9a-zA-Z]*)&#x27;&gt;|&lt;font color=&quot;([#0-9a-zA-Z]*)&quot;&gt;|&lt;\/font&gt;", "g");
var richRenderer = function richRenderer(pText) {
  var pValue = _.escape("" + pText);
  return pValue.replace(richRegExp, function (pMatch, p1, p2, offset, string) {
    if (pMatch.indexOf("&lt;font color=") === 0) {
      return "<span style='color:" + p1 + ";'>";
    }
    switch (pMatch) {
      case "\n":
      case "&lt;br&gt;":
        return "<br />";
      case "&lt;b&gt;":
        return "<b class='cf-strong'>";
      case "&lt;\/b&gt;":
        return "</b>";
      case "&lt;i&gt;":
        return "<i class='cf-em'>";
      case "&lt;\/i&gt;":
        return "</i>";
      case "&lt;u&gt;":
        return "<u>";
      case "&lt;\/u&gt;":
        return "</u>";
      case "&lt;h1&gt;":
        return "<h1 class='cf-title-h1'>";
      case "&lt;\/h1&gt;":
        return "</h1>";
      case "&lt;\/font&gt;":
        return "</span>";
    }
    return "";
  });
};
$.fn.richText = function (pText) {
  return $(this).html(richRenderer(pText));
};
module.exports = richRenderer;

},{}],317:[function(require,module,exports){
"use strict";

(function ($) {
  "use strict";

  var allLTRegExp = new RegExp("<", "g");
  var allGTRegExp = new RegExp(">", "g");

  /**
   * @description clear the children that where highlighted
   * @function
   * @name $.fn.nixpsClearSearchHighlight
   * @returns $(this)
   */
  $.fn.nixpsClearSearchHighlight = function () {
    $(this).css("display", "").find(".cf-highlight").each(function () {
      $(this).replaceWith($(this).text());
    });
    return $(this);
  };

  /**
   * @description Highlight the text found in children that match the case insentive searchstring. This is a jquery plugin.
   * applying an empty string will clear it. The first parameter must be a string
   * @function
   * @name $.fn.nixpsSearchHighlight
   * @param {String} pSearchValue 
   * @returns $(this)
   */
  $.fn.nixpsSearchHighlight = function (pSearchValue, pOptions) {
    if (typeof pSearchValue !== "string") {
      throw new Error("parameter pSearch must be a string");
    }
    if (pSearchValue.length === 0) {
      return $(this).nixpsClearSearchHighlight();
    }
    var regExp = new RegExp(pSearchValue.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&").replace(allLTRegExp, "[&]lt;").replace(allGTRegExp, "[&]gt;"), "i");
    // var regExp = new RegExp("(" + pSearchValue.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&")
    //                                     .replace(allLTRegExp,"[&]lt;")
    //                                     .replace(allGTRegExp,"[&]gt;")
    //                                     .split(" ").join("|") + ")"
    //                                     , "i");

    $(this).hide().filter(function () {
      var text = $(this).text();
      $(this).find("option:not(:selected)").each(function () {
        text = text.replace($(this).text(), "");
      });
      return text.toUpperCase().indexOf(pSearchValue.toUpperCase()) >= 0;
      // return pSearchValue.toUpperCase().split(" ").some(function(pSearch){
      //     return text.toUpperCase().indexOf(pSearch) >= 0;
      // })
    }).css("display", "").find(".cf-highlight").each(function () {
      $(this).replaceWith($(this).text());
    }).end().find("*").each(function () {
      if ($(this)[0].tagName === "OPTION") {
        // we can not highlight options
        return;
      }
      if ($(this).children().length > 0) {
        // there are setups with mixed mode, containing text and child nodes
        $(this).contents().filter(function () {
          return this.nodeType === 3;
        }).each(function () {
          var text = $(this).text();
          text = text.replace(allLTRegExp, "&lt;").replace(allGTRegExp, "&gt;").replace(regExp, "<span class='cf-highlight'>$&</span>");
          $(this).replaceWith(text);
        });
        return;
      } else if ($(this).hasClass("cf-highlight")) {
        $(this).replaceWith($(this).text());
      } else {
        var text = $(this).text();
        text = text.replace(allLTRegExp, "&lt;").replace(allGTRegExp, "&gt;").replace(regExp, "<span class='cf-highlight'>$&</span>"); // replace by span and add founded string inside
        $(this).html(text);
      }
    });
    return $(this);
  };
})(jQuery);

},{}],318:[function(require,module,exports){
"use strict";

(function ($) {
  "use strict";

  var kLastActive = "nixps_selecting_lastactive";
  var kCurrentShiftActive = "nixps_selecting_currentshiftactive";

  /**
   * README 
   * @namespace nixps.Selecting
   * @description Make a list selectable, handle the "select" class over it
   * @version 1.2.0
   */
  $.widget("nixps.Selecting", $.Widget, {
    version: "1.2.0",
    widgetEventPrefix: "selecting",
    options: {
      /**
       * @description The selector of the children who must be able to be selected
       * @name nixps.Selecting#items
       * @type {String}
       * @default ""
       */
      items: "",
      /**
       * @description Must we be able to select multiple items at the same time?
       * @name nixps.Selecting#multiple
       * @type {Boolean}
       * @default true
       */
      multiple: true,
      /**
       * @description Must the user be able to select multiple without pressing shift key
       * @name nixps.Selecting#fastMultiple
       * @type {Boolean}
       * @default false
       * @private
       */
      fastMultiple: false,
      /**
       * @description On which items must we ignore the click to select
       * @name nixps.Selecting#cancel
       * @type {String}
       * @default "input,textarea,button,select,option,[contenteditable='true'],[contenteditable='plaintext-only']"
       */
      cancel: "input,textarea,button,select,option,[contenteditable='true'],[contenteditable='plaintext-only']",
      /**
       * @name nixps-Selecting#handle
       * @description Must we filter, on which element only may we start selecting?
       * @type {String}
       * @default false
       */
      handle: false,
      /**
       * @description What is the class name we use to identicate something is selected
       * @name nixps.Selecting#selectClass
       * @type {String}
       * @default "select"
       */
      selectClass: "select",
      /**
       * @description Make it possible to deselect or unselect an existing selected item
       * @name nixps.Selecting#deselectable
       * @type {Boolean}
       * @default false
       */
      deselectable: false,
      connectWith: false,
      connectWithPosition: "before",
      /**
       * @description Define the hirarchy between items and this.element. Use "children" if the items are direct children.
       * use "find" if there are multiple levels into account. 
       * @type {String}
       * @default "children"
       * @example "find"
       * @name nixps.Selecting#childrenSelector
       * @since 1.2.0
       */
      childrenSelector: "children"
    },
    /**
     * @brief constructor
     * @function
     * @private
     * @name nixps.Selecting#_create
     */
    _create: function _create() {
      // initial
      this.element.addClass(this.widgetFullName);
      // variabels
      this.amountIconsOnLine = 0;
      this.isShift = false; // indication the user is pression the shift button

      if (this.options.childrenSelector === "find") {
        this._elementGetChildren = this._elementGetChildrenFind;
        this._next = this._nextFind;
        this._nextAll = this._nextAllFind;
        this._prev = this._prevFind;
        this._prevAll = this._prevAllFind;
      }
      var eventObject = {};
      var eventKey = "click " + this.options.items;
      var eventObj2 = {};
      var eventKeyR = "contextmenu " + this.options.items;
      if (typeof this.options.handle === "string" && this.options.handle.length > 0) {
        eventKey += this.options.handle;
      }
      eventObject[eventKey] = this._clickHandler;
      eventObj2[eventKeyR] = this._rightclickHandler;
      this._on(this.element, eventObject);
      this._on(this.element, eventObj2);
      var that = this;
      this._on(this.element, {
        "mousedown": function mousedown(e) {
          that.isShift = e.shiftKey === true;
        },
        "mouseup": function mouseup(e) {
          that.isShift = false;
        },
        "selectstart": function selectstart(e) {
          if (that.isShift) {
            return false;
          }
        }
      });
    },
    _elementGetChildren: function _elementGetChildren(pJquerySelect) {
      return this.element.children(pJquerySelect);
    },
    _elementGetChildrenFind: function _elementGetChildrenFind(pJquerySelect) {
      return this.element.find(pJquerySelect);
    },
    _next: function _next(base, jQuerySelector) {
      return base.next(jQuerySelector);
    },
    _nextAll: function _nextAll(base, jQuerySelector) {
      return base.nextAll(jQuerySelector);
    },
    _prev: function _prev(base, jQuerySelector) {
      return base.prev(jQuerySelector);
    },
    _prevAll: function _prevAll(base, jQuerySelector) {
      return base.prevAll(jQuerySelector);
    },
    _nextFind: function _nextFind(base, jQuerySelector) {
      var baseIndex = Number.MAX_VALUE;
      this._elementGetChildren(this.options.items).each(function (pIndex) {
        if ($(this).is(base)) {
          baseIndex = pIndex;
          return false; // stop loop
        }
      });

      return this._elementGetChildren(this.options.items).eq(baseIndex + 1).filter(jQuerySelector);
    },
    _nextAllFind: function _nextAllFind(base, jQuerySelector) {
      var baseIndex = Number.MAX_VALUE;
      this._elementGetChildren(this.options.items).each(function (pIndex) {
        if ($(this).is(base)) {
          baseIndex = pIndex;
          return false; // stop loop
        }
      });

      return this._elementGetChildren(this.options.items).slice(baseIndex + 1).filter(jQuerySelector);
    },
    _prevFind: function _prevFind(base, jQuerySelector) {
      var baseIndex = Number.MAX_VALUE;
      this._elementGetChildren(this.options.items).each(function (pIndex) {
        if ($(this).is(base)) {
          baseIndex = pIndex;
          return false; // stop loop
        }
      });

      if (baseIndex === 0) {
        baseIndex = Number.MAX_VALUE;
      }
      return this._elementGetChildren(this.options.items).eq(baseIndex - 1).filter(jQuerySelector);
    },
    _prevAllFind: function _prevAllFind(base, jQuerySelector) {
      var baseIndex = Number.MAX_VALUE;
      this._elementGetChildren(this.options.items).each(function (pIndex) {
        if ($(this).is(base)) {
          baseIndex = pIndex;
          return false; // stop loop
        }
      });

      var length = this._elementGetChildren(this.options.items).length;
      var sliceIndex = length - baseIndex;
      if (sliceIndex < 0) {
        sliceIndex = Number.MAX_VALUE;
      }
      return $(this._elementGetChildren(this.options.items).get().reverse()).slice(length - baseIndex).filter(jQuerySelector);
    },
    _rightclickHandler: function _rightclickHandler(pEvent, pData) {
      if ($(pEvent.currentTarget).hasClass("select") || $(pEvent.currentTarget).hasClass("cf-table-rowselect")) {
        //don't do anything
      } else {
        this._clickHandler(pEvent, pData);
      }
    },
    /**
     * @description function runs when user click on a item
     * @function
     * @private
     * @name nixps.Selecting
     * @param {Object} pEvent 
     * @param {Object} pData 
     * @returns {undefined}
     */
    _clickHandler: function _clickHandler(pEvent, pData) {
      if (this.options.childrenSelector === "children") {
        if ($(pEvent.target).closest(this.options.items).parent().is(this.element) === false) {
          // it is possible to have selectors inside selectors with the same settings, like table in tables
          // check if item is clicked as item who is a child of this element
          return true;
        }
      } else if (this.options.childrenSelector === "find") {
        if ($(pEvent.target).closest(this.options.items).parents(this.options.items).length > 0) {
          // it is possible to have selectors inside selectors with the same settings, like table in tables
          // check if item is clicked as item who is a child of this element
          return true;
        }
      }
      // check if we need to cancel, do we have the correct handler?
      if (typeof this.options.cancel === "string" && this.options.cancel.length > 0) {
        if ($(pEvent.target).closest(this.options.cancel).length > 0) {
          return true;
        }
      }
      var unselectOthers = false;
      var currentTarget = $(pEvent.target).closest(this.options.items);
      // we may continue...
      if (this.options.multiple === false) {
        // single selection, 
        if (this.options.deselectable === false) {
          //unselect all before selecting new
          this.unselectAll();
        } else {
          this.unselectAll(currentTarget);
        }
        unselectOthers = true;
        currentTarget.toggleClass(this.options.selectClass).focus();
      } else if (pEvent.shiftKey === true) {
        // select multiple items in one click
        var lastActiveIndex = -1;
        var lastShiftIndex = -1;
        var itemsSelector = this._elementGetChildren(this.options.items);
        if (this.options.connectWith !== false) {
          var connected = $(this.options.connectWith).data("nixpsSelecting");
          if (this.options.connectWithPosition === "after") {
            itemsSelector = this._elementGetChildren(this.options.items).add($(this.options.connectWith).children(connected.options.items));
          } else if (this.options.connectWithPosition === "before") {
            itemsSelector = $(this.options.connectWith).children(connected.options.items).add(this._elementGetChildren(this.options.items));
          }
        }
        itemsSelector.each(function (index, elem) {
          if ($(this).hasClass(kLastActive)) {
            lastActiveIndex = index;
          } else if ($(this).hasClass(kCurrentShiftActive)) {
            lastShiftIndex = index;
          }
        });
        if (lastShiftIndex > -1 && lastShiftIndex > -1) {
          if (lastShiftIndex < lastActiveIndex) {
            // deselect before, remove first keep last
            this._elementGetChildren(this.options.items).slice(lastShiftIndex, lastActiveIndex).removeClass(this.options.selectClass);
          } else {
            // deselect after, keep current remove to end
            this._elementGetChildren(this.options.items).slice(lastActiveIndex + 1, lastShiftIndex + 1).removeClass(this.options.selectClass);
          }
        }
        // get current index of clicked item
        var currentIndex = currentTarget.prevAll(this.options.items).length;
        // select all items between the selected item and the clicked item
        if (lastActiveIndex < currentIndex) {
          this._elementGetChildren(this.options.items).slice(lastActiveIndex, currentIndex).addClass(this.options.selectClass);
        } else {
          this._elementGetChildren(this.options.items).slice(currentIndex, lastActiveIndex + 1).addClass(this.options.selectClass);
        }
        currentTarget.addClass(this.options.selectClass).focus();
        this._elementGetChildren(this.options.items + "." + kCurrentShiftActive).removeClass(kCurrentShiftActive);
        currentTarget.addClass(kCurrentShiftActive);
      } else if (this.options.fastMultiple === true || pEvent.metaKey === true || pEvent.ctrlKey === true) {
        // maintain currect selected items and add this element to the existing selected items
        currentTarget.toggleClass(this.options.selectClass).focus();
        this._elementGetChildren(this.options.items + "." + kLastActive).removeClass(kLastActive);
        this._elementGetChildren(this.options.items + "." + kCurrentShiftActive).removeClass(kCurrentShiftActive);
        currentTarget.addClass(kLastActive);
      } else {
        // normal click on multipe selection   
        if (this.options.deselectable === true) {
          var selection = this.getSelectedItems();
          var isExecptionSelected = false;
          if (currentTarget) {
            isExecptionSelected = currentTarget.hasClass(this.options.selectClass);
          }
          this.unselectAll(currentTarget);
          if (currentTarget && selection.length !== 1 || currentTarget && selection.length === 1 && isExecptionSelected === false) {
            currentTarget.addClass(this.options.selectClass).focus();
          } else {
            currentTarget.toggleClass(this.options.selectClass).focus();
          }
        } else {
          this.unselectAll();
          currentTarget.addClass(this.options.selectClass).focus();
        }
        unselectOthers = true;
        this._elementGetChildren(this.options.items + "." + kLastActive).removeClass(kLastActive);
        this._elementGetChildren(this.options.items + "." + kCurrentShiftActive).removeClass(kCurrentShiftActive);
        currentTarget.addClass(kLastActive);
      }
      this._trigger("select", pEvent, {
        unselectOthers: unselectOthers
      });
    },
    unselectAll: function unselectAll(pQueryExeptionSelection) {
      this.getSelectedItems().not(pQueryExeptionSelection).removeClass(this.options.selectClass).removeClass(kCurrentShiftActive).removeClass(kLastActive);
      // var selection = this.getSelectedItems();
      // var isExecptionSelected = false;
      // if( pQueryExeptionSelection){
      //     isExecptionSelected = pQueryExeptionSelection.hasClass("select");
      // }
      // selection.removeClass(this.options.selectClass)
      //                         .removeClass(kCurrentShiftActive)
      //                         .removeClass(kLastActive);
      // if(pQueryExeptionSelection && selection.length !== 1 || (pQueryExeptionSelection && selection.length ===1 && isExecptionSelected === false)) {
      //     pQueryExeptionSelection.addClass(this.options.selectClass).focus();
      // }
    },

    selectAll: function selectAll() {
      this._elementGetChildren(this.options.items + "." + kCurrentShiftActive).removeClass(kCurrentShiftActive);
      this._elementGetChildren(this.options.items + "." + kLastActive).removeClass(kLastActive);
      this._elementGetChildren(this.options.items).addClass(this.options.selectClass);
    },
    getSelectedItems: function getSelectedItems() {
      if (this.options.connectWith !== false) {
        var connected = $(this.options.connectWith).data("nixpsSelecting");
        if (connected !== undefined) {
          return this._elementGetChildren(this.options.items + "." + this.options.selectClass).add($(this.options.connectWith).children(connected.options.items + "." + connected.options.selectClass));
        } else {
          // fallback in case of no data
          return this._elementGetChildren(this.options.items + "." + this.options.selectClass);
        }
      }
      return this._elementGetChildren(this.options.items + "." + this.options.selectClass);
    },
    getUnselectedItems: function getUnselectedItems() {
      return this._elementGetChildren(this.options.items).not("." + this.options.selectClass);
    },
    selectItems: function selectItems(pFilter) {
      this._elementGetChildren(this.options.items + "." + kLastActive).removeClass(kLastActive);
      this._elementGetChildren(this.options.items).filter(pFilter).addClass(this.options.selectClass).last().toggleClass(kLastActive, this.options.multiple === true);
    },
    getTechnicalClasses: function getTechnicalClasses() {
      if (this.options.multiple === true) {
        return [kLastActive, kCurrentShiftActive];
      }
      return [];
    },
    /**
     * @name nixps-Selecting#areAllSelected
     * @description Area all DOM element selected or not?
     * @function
     * @returns {Boolean} true if all items are selected
     * @since 1.1.0
     */
    areAllSelected: function areAllSelected() {
      return this._elementGetChildren(this.options.items).not("." + this.options.selectClass).length === 0;
    },
    /**
     * @description call to change the selected item in a grid. Provide an direction and we will adapt the focused item
     * according to the shift keys...
     * @function
     * @name nixps.Selecting#moveSelected
     * @param {Object} pEvent 
     * @param {String} pDirection The direction to go, use "right", "left", "up" or "down"
     */
    moveSelected: function moveSelected(pEvent, pDirection) {
      if (this.amountIconsOnLine === 0) {
        var containerWidth = this.element.width();
        var iconOuterWidth = this._elementGetChildren(this.options.items).first().outerWidth(true);
        this.amountIconsOnLine = Math.floor(containerWidth / iconOuterWidth);
      }
      if (this.options.multiple === false) {
        // if we can only select one at the time
        var oldSelected = this._elementGetChildren(this.options.items + "." + this.options.selectClass);
        if (pDirection === "right") {
          if (this._next(oldSelected, this.options.items).length > 0) {
            oldSelected.removeClass(this.options.selectClass);
            this._next(oldSelected, this.options.items).addClass(this.options.selectClass).focus();
          }
        } else if (pDirection === "left") {
          if (this._prev(oldSelected, this.options.items).length > 0) {
            oldSelected.removeClass(this.options.selectClass);
            this._prev(oldSelected, this.options.items).addClass(this.options.selectClass).focus();
          }
        } else if (pDirection === "up") {
          if (this._prevAll(oldSelected, this.options.items).length >= this.amountIconsOnLine) {
            oldSelected.removeClass(this.options.selectClass);
            this._prevAll(oldSelected, this.options.items).eq(this.amountIconsOnLine - 1).addClass(this.options.selectClass).focus();
          }
        } else if (pDirection === "down") {
          if (this._nextAll(oldSelected, this.options.items).length >= this.amountIconsOnLine) {
            oldSelected.removeClass(this.options.selectClass);
            this._nextAll(oldSelected, this.options.items).eq(this.amountIconsOnLine - 1).addClass(this.options.selectClass).focus();
          }
        }
      } else {
        // multiple select
        var oldSelected;
        if (pEvent.shiftKey === true) {
          oldSelected = this._elementGetChildren(this.options.items + "." + this.options.selectClass + "." + kCurrentShiftActive);
        } else {
          // get from previous shift
          oldSelected = this._elementGetChildren(this.options.items + "." + this.options.selectClass + "." + kCurrentShiftActive);
          if (oldSelected.length <= 0) {
            oldSelected = this._elementGetChildren(this.options.items + "." + this.options.selectClass + "." + kLastActive);
          }
        }
        this._elementGetChildren(this.options.items + "." + kCurrentShiftActive).removeClass(kCurrentShiftActive);
        if (oldSelected.length <= 0) {
          if (pDirection === "right") {
            oldSelected = this._elementGetChildren(this.options.items + "." + this.options.selectClass).last();
          } else if (pDirection === "left") {
            oldSelected = this._elementGetChildren(this.options.items + "." + this.options.selectClass).first();
          } else if (pDirection === "up") {
            oldSelected = this._elementGetChildren(this.options.items + "." + this.options.selectClass).first();
          } else if (pDirection === "down") {
            oldSelected = this._elementGetChildren(this.options.items + "." + this.options.selectClass).last();
          }
        }
        if (pEvent.shiftKey === false) {
          this._prevAll(oldSelected, this.options.items).removeClass(this.options.selectClass);
          this._elementGetChildren(this.options.items + "." + kLastActive).removeClass(kLastActive);
        }
        if (pDirection === "right") {
          if (this._next(oldSelected, this.options.items).length > 0) {
            var last = this._next(oldSelected, this.options.items).addClass(this.options.selectClass).focus().last();
            if (pEvent.shiftKey === false) {
              last.addClass(kLastActive);
              this._prevAll(oldSelected.removeClass(this.options.selectClass), this.options.items).removeClass(this.options.selectClass);
            } else {
              last.addClass(kCurrentShiftActive);
              if (this._nextAll(last, "." + kLastActive).length > 0 || last.hasClass(kLastActive)) {
                oldSelected.removeClass(this.options.selectClass);
              }
            }
          }
        } else if (pDirection === "left") {
          if (this._prev(oldSelected, this.options.items).length > 0) {
            var last = this._prev(oldSelected, this.options.items).addClass(this.options.selectClass).focus().last();
            if (pEvent.shiftKey === false) {
              last.addClass(kLastActive);
              this._nextAll(oldSelected.removeClass(this.options.selectClass), this.options.items).removeClass(this.options.selectClass);
            } else {
              last.addClass(kCurrentShiftActive);
              if (this._prevAll(last, "." + kLastActive).length > 0 || last.hasClass(kLastActive)) {
                oldSelected.removeClass(this.options.selectClass);
              }
            }
          }
        } else if (pDirection === "up") {
          if (this._prevAll(oldSelected, this.options.items).length >= this.amountIconsOnLine) {
            var last = this._prevAll(oldSelected, this.options.items).eq(this.amountIconsOnLine - 1).addClass(this.options.selectClass).focus().last();
            if (pEvent.shiftKey === false) {
              last.addClass(kLastActive);
              this._nextAll(oldSelected.removeClass(this.options.selectClass), this.options.items).removeClass(this.options.selectClass);
            } else {
              last.addClass(kCurrentShiftActive);
              if (this._prevAll(last, "." + kLastActive).length > 0 || last.hasClass(kLastActive)) {
                oldSelected.removeClass(this.options.selectClass);
              }
            }
          }
        } else if (pDirection === "down") {
          if (this._nextAll(oldSelected, this.options.items).length >= this.amountIconsOnLine) {
            var last = this._nextAll(oldSelected, this.options.items).eq(this.amountIconsOnLine - 1).addClass(this.options.selectClass).focus().last();
            if (pEvent.shiftKey === false) {
              last.addClass(kLastActive);
              this._prevAll(oldSelected.removeClass(this.options.selectClass), this.options.items).removeClass(this.options.selectClass);
            } else {
              last.addClass(kCurrentShiftActive);
              if (this._nextAll(last, "." + kLastActive).length > 0 || last.hasClass(kLastActive)) {
                oldSelected.removeClass(this.options.selectClass);
              }
            }
          } else if (this._nextAll(oldSelected, this.options.items).length > 0) {
            // we are at the previous last line, select last item
            var last = this._nextAll(oldSelected, this.options.items).last().addClass(this.options.selectClass).focus().addClass(kLastActive);
            if (pEvent.shiftKey === false) {
              last.addClass(kLastActive);
              this._prevAll(oldSelected.removeClass(this.options.selectClass), this.options.items).removeClass(this.options.selectClass);
            } else {
              last.addClass(kCurrentShiftActive);
              if (this._nextAll(last, "." + kLastActive).length > 0 || last.hasClass(kLastActive)) {
                oldSelected.removeClass(this.options.selectClass);
              }
            }
          }
        }
      }
    },
    /**
     * @brief destructor
     * @function
     * @private
     * @name nixp.Selecting#_destroy
     */
    _destroy: function _destroy() {
      this._superApply(arguments);
      this.element.removeClass(this.widgetFullName);
      this.unselectAll();
    }
  });
})(jQuery);

},{}],319:[function(require,module,exports){
"use strict";

(function ($) {
  $.widget("nixps.DotSpinner", $.Widget, {
    options: {},
    /**
     * @description Create the component
     * @name nixps.DotSpinner#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this.element.append($("<span>").addClass("dot-1")).append($("<span>").addClass("dot-2")).append($("<span>").addClass("dot-3"));
    }
  });
})(jQuery);

},{}],320:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
if (typeof require === "function") {
  var Plugin = require("./js/plugins/Plugin.js");
  var TextualPlugin = require("./js/plugins/TextualPlugin.js");
  var Cleaner = require("./js/cleaners/Cleaner.js");
  var DuplicateStyleCleaner = require("./js/cleaners/DuplicateStyleCleaner.js");
  var EnterModeCleaner = require("./js/cleaners/EnterModeCleaner.js");
  var ZeroWidthSpaceCleaner = require("./js/cleaners/ZeroWidthSpaceCleaner.js");
  var EmptyStyleCleaner = require("./js/cleaners/EmptyStyleCleaner.js");
  var DeprecatedTagCleaner = require("./js/cleaners/DeprecatedTagCleaner.js");
  var ClickAndDragPlugin = require("./js/plugins/ClickAndDragPlugin.js");
  var RemoveFormatPlugin = require("./js/plugins/RemoveFormatPlugin.js");
  var RTLPlugin = require("./js/plugins/RTLPlugin.js");
  var LTRPlugin = require("./js/plugins/LTRPlugin.js");
  var Utils = require("./Utils.js");
  var Guid = require("../../cloudflow/CloudflowUtil/js/GUID.js");
  require("./js/nixps-cloudflow-TajiriContextMenu.js");
  require("../Colorpicker/js/nixps-Colorpicker.js");
}
var kVersionNumber = "1.10.0";
var currentVersion;
//1.10.0: Getting the content of the editor always disabled the source when it was active (to properly get the content) but never reset it to original state (#64142)
//1.9.0: Style tags were ended short when they contain ' + catch html tags with a "-" (custom web components) too for unknown tags check (#63207)
//1.8.0: Fix Email templates bug -> \n will now be converted to \r\n (#61921)
//1.7.0: Add new Mention Plugin (#61717)
//1.6.0: Source mode styles were applied on the entire page (using plain style tag embedded in the editor!) (#60560)
//1.5.0: Fix source mode adding div tags on enter and add warning for bad styles (#60500)
//1.4.0: Fix losing the styles defined inside the head in sourcemode after saving (#60473)
//1.3.0: remove all new lines before and after pasted html string (#60355)
//1.2.0: refactor + remove jquery where possible (#58807)
//1.1.0: fixed a bug with the source plugin & undo/redo (#58752)

/**
 * @namespace Editor
 * @description A rich text editor
 * see https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html for all [contenteditable=true] attribute 
 * @param {Object} pOptions 
 */
function Editor(pOptions) {
  var that = this;
  // options
  this.options = Object.assign({
    debug: false,
    // activate the logs and allow to debug
    enterMode: "p",
    // which element to use for new lines
    filterUnknownContent: true,
    // must we filter out unknown content 
    convertToCRLF: false,
    editorHeight: undefined
  }, pOptions || {});

  // variables
  this.alive = true; // flag indicating if editor is alive ar has been destroyed, to check if it is a zomby or not
  this.plugins = {}; // all plugins, the buttons to activate a style or not
  this.groups = {};
  this.disabled = this.options.disabled ? this.options.disabled === true : false;
  this.contentNormalizerIncoming = null; // function translate the incomming text to editor text
  this.contentNormalizerOutcoming = null; // function translate the editor content to output text
  this.pasteAction = null;
  this.cleaners = [];
  this.internalPlugins = {
    undo: {
      ID: "__UNDO__",
      initialized: false,
      visible: false,
      enable: false,
      button: null
    },
    redo: {
      ID: "__REDO__",
      initialized: false,
      visible: false,
      enable: false,
      button: null
    }
  };
  this.history = {
    currentIndex: 0,
    array: []
  };
  this._initUI();
  this.setContentNormalizer(this.options.contentNormalizerIncoming, this.options.contentNormalizerOutcoming);
  this._initHandlers();
  this._initEnterMode();

  // this.addHTMLCleaner(new EmptyNodeCleaner());
  this.addHTMLCleaner(new ZeroWidthSpaceCleaner());
  this.addHTMLCleaner(new DuplicateStyleCleaner({
    enterMode: this.options.enterMode
  }));
  this.addHTMLCleaner(new EmptyStyleCleaner());
  this.addHTMLCleaner(new DeprecatedTagCleaner());
  this.addHTMLCleaner(new EnterModeCleaner({
    enterMode: this.options.enterMode
  }));
}
;
Editor.prototype = {
  constructor: Editor,
  //------------------------------------------------------------------------------------------------
  appendTo: function appendTo(container) {
    container.append(this.element);
  },
  /**
   * @description Get the complate UI of the editor, including the topbar and the content panel 
   * @function
   * @name Editor#getElement
   * @returns {DOM} The UI DOM element that contains the topbar and the content panel
   */
  getElement: function getElement() {
    return this.element;
  },
  /**
   * @description Get the area element of the editor
   * @function
   * @name Editor#getElement
   * @returns {DOM} The UI DOM element that contains the edit area
   */
  getArea: function getArea() {
    return this.area;
  },
  //------------------------------------------------------------------------------------------------
  /**
   * @description set the HTML content to the editor. It will replace the existing content
   * @function
   * @name Editor#setContent
   * @param {String} pText The html content you want to apply on the editor. it will replace the existing content
   */
  setContent: function setContent(pText) {
    var _this = this;
    var that = this;
    if (typeof pText !== "string") {
      pText = JSON.stringify(pText);
    }
    if (this.plugins["Source"] !== undefined) {
      //just in case - might still be active in emailtemplates
      this.disableSource();
    }
    pText = this._normalizeForUnknownTags(pText);
    if (this.contentNormalizerIncoming) {
      pText = this.contentNormalizerIncoming(pText);
    }
    pText = this._transformWithTextualPlugins(pText);
    pText = pText.replace(/<style([^>]*)>/ig, "<div data-tajiri-style-tag $1>").replace(/<\/style>/ig, "</div>");
    this._applyStyleLater(this.area, pText);
    if (this.area.querySelector("[data-tajiri-version]") !== null) {
      var versionNode = this.area.querySelector("[data-tajiri-version]");
      currentVersion = versionNode.getAttribute("data-tajiri-version");
      this.area.removeChild(versionNode);
    }
    if (this.area.querySelector("[data-tajiri-style-tag]") !== null) {
      var stylesDict = {};
      if (this.area.querySelector("[data-tajiri-style-tag]") !== null) {
        var styleTag = this.area.querySelector("[data-tajiri-style-tag]");
        if (_typeof(styleTag) === "object" && styleTag !== null) {
          var stylesString = styleTag.innerText;
          if (typeof stylesString === "string" && stylesString.length > 0) {
            // clean up
            stylesString = stylesString.replace(/\r|\n/g, " ").replace(/<!--[^<]*-->/g, "").trim();
            // fill in dictionary
            stylesString.replace(/([^}]*){([^}]*)}/g, function (pMatch, pCSSSelector1, pCSSValues2) {
              stylesDict[pCSSSelector1.trim()] = pCSSValues2.trim();
            });
          }
        }
      }
      var body = this.area;
      if (Object.keys(stylesDict).length > 0) {
        var _loop = function _loop() {
          var styleDictProp = cssselector;
          if (cssselector.match("body") !== null) {
            var tajiriBodyTag = document.createElement("div");
            tajiriBodyTag.setAttribute("data-tajiri-body-tag", "");
            _toConsumableArray(_this.area.childNodes).forEach(function (pChild) {
              tajiriBodyTag.append(pChild);
            });
            _this.area.append(tajiriBodyTag);
            cssselector = cssselector.replace("body", "[data-tajiri-body-tag]");
          }
          if (Utils.isValidSelector(cssselector) === true) {
            body.querySelectorAll(cssselector).forEach(function (pNode) {
              var oldStyle = pNode.getAttribute("style");
              if (typeof oldStyle === "string" && oldStyle.length > 0) {
                if (oldStyle.endsWith(";")) {
                  pNode.setAttribute("style", oldStyle + " " + stylesDict[styleDictProp]);
                } else {
                  pNode.setAttribute("style", oldStyle + ";" + stylesDict[styleDictProp]);
                }
              } else {
                pNode.setAttribute("style", stylesDict[styleDictProp]);
              }
            });
          }
        };
        for (var cssselector in stylesDict) {
          _loop();
        }
      }
      if (this.area.querySelector("[data-tajiri-body-tag]") !== null) {
        this.area.querySelector("[data-tajiri-body-tag]").style.height = "unset";
      }
      if (this.area.querySelectorAll("title, [data-tajiri-style-tag], meta").length > 0) {
        var head = document.createElement("div");
        head.setAttribute("data-tajiri-head-tag", "");
        this.area.prepend(head);
        _toConsumableArray(this.area.querySelectorAll("title, [data-tajiri-style-tag], meta")).forEach(function (pHeadTag) {
          head.append(pHeadTag);
        });
      }
    }
    pText = this._addBRTagForEmptyEnter();
    for (var pPlugin in this.plugins) {
      if (typeof this.plugins[pPlugin].plugin.reset === "function") {
        this.plugins[pPlugin].plugin.reset();
      }
    }
    if (this.history.array.length === 0 || this.history.array.length === 1 && this.history.array[0].text.length === 0) {
      //begin history if there isn't any yet OR when there's an initial empty state only
      this._beginHistory(this._getInnerContent());
    }
    //assumed that this is new content, make sure the first change is captured again
    this._initChangeHandler();
  },
  _addVersionTag: function _addVersionTag(pOutputHTML) {
    var versionTag = document.createElement("span");
    versionTag.setAttribute("data-tajiri-version", kVersionNumber);
    return versionTag.outerHTML + pOutputHTML;
  },
  disableSource: function disableSource(pNode) {
    var that = this;
    if (this.plugins["Source"] === undefined) {
      return pNode;
    }
    var revertStateAgain = true;
    if (pNode === undefined) {
      //we're working straight on the area, not a clone - no need to revert the plugin's active state
      revertStateAgain = false;
      pNode = this.area;
    }
    var wasActive = this.plugins["Source"].plugin.isActive();
    var selection = this._getSelection();
    this.plugins["Source"].plugin.unformat(selection, pNode);
    if (revertStateAgain) {
      //we lied to the plugin - its still active, we just needed the content not-source style
      this.plugins["Source"].plugin.setActive(wasActive);
    } else {
      //this was a real disable - update!
      var sourcePlugin = this.plugins["Source"].plugin;
      Object.keys(this.plugins).forEach(function (pPluginName) {
        var plugin = that.plugins[pPluginName].plugin;
        var disabled_reasons = that.plugins[pPluginName].disabled_reasons;
        if (plugin === sourcePlugin) {
          return;
        }
        var idx = disabled_reasons.indexOf(sourcePlugin.getID());
        if (idx !== -1) {
          disabled_reasons.splice(idx, 1);
        }
      });
      // also enable/disable undo/redo
      this.disableUndoRedoButtons(false);
      this._updateUI();
    }
    return pNode;
  },
  enableSource: function enableSource() {
    var that = this;
    if (this.plugins["Source"] === undefined) {
      return;
    }
    if (typeof this.plugins["Source"].plugin.isActive === "function" && this.plugins["Source"].plugin.isActive() === false) {
      var selection = this._getSelection();
      var sourcePlugin = this.plugins["Source"].plugin;
      this.plugins["Source"].plugin.format(selection, this.area);
      Object.keys(this.plugins).forEach(function (pPluginName) {
        var plugin = that.plugins[pPluginName].plugin;
        var disabled_reasons = that.plugins[pPluginName].disabled_reasons;
        if (plugin === sourcePlugin) {
          return;
        }
        var idx = disabled_reasons.indexOf(sourcePlugin.getID());
        if (idx === -1) {
          disabled_reasons.push(sourcePlugin.getID());
        }
      });
      //also enable/disable undo/redo
      this.disableUndoRedoButtons(true);
      this._updateUI();
    }
  },
  setLanguage: function setEditorLanguage(pLang) {
    this.area.setAttribute("lang", pLang);
  },
  resetHistory: function resetHistory() {
    this.history = {
      currentIndex: 0,
      array: [{
        text: this._getInnerContent(),
        action: "initial",
        textcontent: this.area.textContent
      }]
    };
    this._updateUndoRedoButtons();
    window.editorHistory = this.history;
  },
  _addBRTagForEmptyEnter: function _addBRTagForEmptyEnter() {
    if (this.options.enterMode.toLowerCase() === "br") {
      //no need to apply fix when enters are done with BR tags
      return;
    }
    this.area.querySelectorAll(this.options.enterMode).forEach(function (pEnterTag) {
      if (pEnterTag.children.length === 0 && pEnterTag.textContent.trim().length === 0) {
        //add a BR tag if the enterTag is empty + has no child elements
        pEnterTag.append(document.createElement("br"));
      }
    });
  },
  //------------------------------------------------------------------------------------------------
  /**
   * @description Get the internal, real content, without translations function applied on it
   * @function
   * @name Editor#_getInnerContent
   * @returns {String} the internal html content of the editor
   */
  _getInnerContent: function _getInnerContent() {
    return this.area.innerHTML;
  },
  //------------------------------------------------------------------------------------------------
  /**
   * @description get the HTML value of the editor.
   * @function
   * @name Editor#getContent
   * @returns {String} HTML formatted content of the editr
   */
  getContent: function getContent() {
    var pWithVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var replaceMap = {
      "<strike>": "<s>",
      "</strike>": "</s>",
      "<acronym>": "<abbr>",
      "</acronym>": "</abbr>",
      "<center>": "<span style=\"text-align: center\">",
      "</center>": "</span>",
      "<listing>": "<pre>",
      "</listing>": "</pre>",
      "<plaintext>": "<pre>",
      "</plaintext>": "</pre>",
      "<tt>": "<pre>",
      "</tt>": "</pre>",
      "<xmp>": "<pre>",
      "</xmp>": "</pre>",
      "<spacer>": "&nbsp;"
    };
    var contentNode = this.area.cloneNode(true);
    if (this.plugins["Source"] !== undefined && this.plugins["Source"].plugin.isActive() === true) {
      contentNode = this.disableSource(contentNode);
    }
    var stylesDict = {};
    if (contentNode.querySelector("[data-tajiri-style-tag") !== null) {
      var styleTag = contentNode.querySelector("[data-tajiri-style-tag");
      if (_typeof(styleTag) === "object" && styleTag !== null) {
        var stylesString = styleTag.innerText;
        if (typeof stylesString === "string" && stylesString.length > 0) {
          // clean up
          stylesString = stylesString.replace(/\r|\n/g, " ").replace(/<!--[^<]*-->/g, "").trim();
          // fill in dictionary
          stylesString.replace(/([^}]*){([^}]*)}/g, function (pMatch, pCSSSelector1, pCSSValues2) {
            stylesDict[pCSSSelector1.trim()] = pCSSValues2.trim();
          });
        }
      }
    }
    // if (Object.keys(stylesDict).length > 0) {
    //     for (var cssselector in stylesDict) {
    //         let styleDictProp = cssselector;
    //         if (cssselector.match("body") !== null) {
    //             cssselector = cssselector.replace("body", "[data-tajiri-body-tag]")
    //         }
    //         var styles = stylesDict[styleDictProp].split(";");
    //         if (Utils.isValidSelector(cssselector) === true) {
    //             contentNode.querySelectorAll(cssselector).forEach(function (pNode) {
    //                 styles.forEach((pStyle) => {
    //                     if (pStyle.trim().length > 0) {
    //                         var stylename = pStyle.split(":")[0].trim();
    //                         var styleval = pStyle.split(":")[1].trim();
    //                         styleval = styleval.replaceAll("px", "");
    //                         var actualStyle = pNode.style[stylename] ? pNode.style[stylename].replaceAll("px", "") : undefined;
    //                         if(pNode.style[stylename] !== undefined && actualStyle === styleval) {
    //                             pNode.style[stylename] = "";
    //                         }
    //                     }
    //                 });
    //             });
    //         } 
    //     }
    // }
    var replaceRegex = new RegExp('(' + Object.keys(replaceMap).join('|') + ')', 'gi');
    this._cleanHTML(["EnterModeCleaner"]);
    var head = document.createElement("head");
    if (contentNode.querySelector("[data-tajiri-head-tag]") !== null) {
      //empty the head tag, need to remove it
      var headTag = contentNode.querySelector("[data-tajiri-head-tag]");
      var children = _toConsumableArray(headTag.childNodes);
      for (var i = children.length - 1; i > -1; i--) {
        var child = children[i];
        if (child.getAttribute("data-tajiri-style-tag") !== undefined && child.getAttribute("data-tajiri-style-tag") !== null) {
          styleTag = document.createElement("style");
          styleTag.innerHTML = child.innerHTML;
          child = styleTag;
        }
        head.prepend(child.cloneNode(true));
      }
      // contentNode.prepend(head);
      // headTag.remove();
    }

    var body = document.createElement("body");
    if (contentNode.querySelector("[data-tajiri-body-tag]") !== null) {
      //empty the body tag, need to remove it
      var bodyTag = contentNode.querySelector("[data-tajiri-body-tag]");
      var _children = _toConsumableArray(bodyTag.childNodes);
      for (var _i = _children.length - 1; _i > -1; _i--) {
        body.prepend(_children[_i].cloneNode(true));
      }
    }
    // this._normalizeBrTagsToNBSP();
    var outputHTML = body.childNodes.length > 0 ? body.innerHTML : contentNode.innerHTML;
    outputHTML = outputHTML.replace(/\u200b/gi, "").replace(/<[/]*script/gi, "").replace(/<[/]*iframe/gi, "").replace(/<[/]*command/gi, "");
    outputHTML = outputHTML.replace(replaceRegex, function (match) {
      return replaceMap[match];
    });
    outputHTML = this._transformBackFromTextualPlugins(outputHTML);
    if (this.contentNormalizerOutcoming) {
      outputHTML = this.contentNormalizerOutcoming(outputHTML);
    }
    if (pWithVersion === true) {
      outputHTML = this._addVersionTag(outputHTML);
    }
    if (this.options.convertToCRLF === true) {
      //if needed, we make sure to add a CRLF behind every closing tag
      outputHTML = outputHTML.replace(/(<\/[^>]+>)(?!\r?\n)/g, '$1\r\n');
    }
    //check if we need to include a head / body
    var returnHTML = "";
    if (head.childNodes.length > 0) {
      returnHTML += head.outerHTML;
      returnHTML += "<body>" + outputHTML + "</body>";
      return returnHTML;
    } else {
      return outputHTML;
    }
  },
  /**
   * @description add the focus to the editable content
   * @function
   * @name Editor#focus
   * @returns {undefined}
   */
  focus: function focus() {
    if (this.alive === false) {
      return;
    }
    if (this.area.hasAttribute("contenteditable")) {
      this.area.focus();
    }
  },
  /**
   * @description select all text in the editor
   * @function
   * @name Editor#selectAll
   * @returns {undefined}
   */
  selectAll: function selectAll() {
    this.focus();
    var selection = this._getSelection();
    if (!selection) {
      throw new Error("Tajiri:selectAll selection could not be made");
    }
    var range = document.createRange();
    range.selectNodeContents(this.area);
    selection.removeAllRanges();
    selection.addRange(range);
  },
  //------------------------------------------------------------------------------------------------
  /**
   * @description set the incomming and outcomming translations functions
   * @function
   * @name Editor#setContentNormalizer
   * @param {Function} pInputFunction translate the incomming text
   * @param {Function} pOutputFunction translate the outcomming
   * @returns true
   */
  setContentNormalizer: function setContentNormalizer(pInputFunction, pOutputFunction) {
    if (typeof pInputFunction !== "function") {
      pInputFunction = null;
    }
    if (typeof pOutputFunction !== "function") {
      pOutputFunction = null;
    }
    this.contentNormalizerIncoming = pInputFunction;
    this.contentNormalizerOutcoming = pOutputFunction;
    return true;
  },
  //------------------------------------------------------------------------------------------------
  setPasteAction: function setPasteAction(pFunc) {
    if (!(typeof pFunc === "function")) {
      pFunc = null;
    }
    this.pasteAction = pFunc;
    return true;
  },
  setHeight: function setHeight(pHeight) {
    if (typeof pHeight === "string" && pHeight.length > 0) {
      this.options.editorHeight = pHeight;
      this.area.style.height = pHeight;
    }
  },
  //------------------------------------------------------------------------------------------------
  enableUndoRedoAction: function enableUndoRedoAction(pFlag) {
    this.internalPlugins.undo.visible = pFlag;
    this.internalPlugins.redo.visible = pFlag;
    if (pFlag) {
      this._initUndoButton();
      this._initRedoButton();
      this.toolbar.append(this.internalPlugins.undo.button);
      this.toolbar.append(this.internalPlugins.redo.button);
    } else {
      if (this.internalPlugins.undo.button !== null) {
        this.toolbar.removeChild(this.internalPlugins.undo.button);
      }
      if (this.internalPlugins.redo.button !== null) {
        this.toolbar.removeChild(this.internalPlugins.redo.button);
      }
    }
  },
  disableUndoRedoButtons: function disableUndoRedoButtons(pFlag) {
    this.internalPlugins.redo.activeShortcut = !pFlag;
    this.internalPlugins.undo.activeShortcut = !pFlag;
    if (pFlag) {
      this._setButtonEnabled(this.internalPlugins.undo.ID, false);
      this._setButtonEnabled(this.internalPlugins.redo.ID, false);
    } else {
      this._updateUndoRedoButtons();
    }
  },
  //------------------------------------------------------------------------------------------------
  installPlugin: function installPlugin(pPlugin, _pIndex) {
    if (!(pPlugin instanceof Plugin)) {
      console.error("try to install a plugin which has not the correct inherit of Plugin class");
      return false;
    }
    var pluginID = pPlugin.getID();
    if (this.plugins[pluginID]) {
      console.error('Plugin with the same name "' + pluginID + '" already installed');
      return false;
    }
    _pIndex = parseInt(_pIndex);
    if (isNaN(_pIndex) || _pIndex < 0) {
      // if unknown place all of them at the end of the queue
      _pIndex = Number.MAX_SAFE_INTEGER;
    }
    var button = this._createToolbarButton(pPlugin);
    if (button !== null) {
      this._addButton(button, _pIndex);
    }
    this.plugins[pluginID] = {
      plugin: pPlugin,
      button: button,
      order: _pIndex,
      disabled_reasons: []
    };
    return true;
  },
  //------------------------------------------------------------------------------------------------
  getHistory: function getHistory() {
    return this.history;
  },
  //------------------------------------------------------------------------------------------------
  addHTMLCleaner: function addHTMLCleaner(pCleaner) {
    var that = this;
    if (pCleaner instanceof Cleaner) {
      that.cleaners.push(pCleaner);
      return function () {
        var idx = that.cleaners.indexOf(pCleaner);
        if (idx !== -1) {
          that.cleaners.splice(idx, 1);
        }
      };
    }
    return false;
  },
  disable: function disable(pReason) {
    this.disabled = true;
    this._disablePlugins(pReason);
  },
  enable: function enable(pReason) {
    this.disabled = false;
    this._enablePlugins(pReason);
  },
  //------------------------------------------------------------------------------------------------
  _cleanHTML: function _cleanHTML(disableList) {
    var that = this;
    var selection = this._getSelection();
    this.cleaners.forEach(function (pCleaner) {
      if (disableList !== undefined && disableList.includes(pCleaner.getID())) {
        return;
      }
      pCleaner.clean(that.area, selection);
    });
  },
  //------------------------------------------------------------------------------------------------
  _initUI: function _initUI() {
    var that = this;
    this.element = document.createElement("div");
    this.element.classList.add("editor");
    this.element.classList.add("nixps-Tajiri");
    this.element.setAttribute("data-tajiri-version", kVersionNumber);
    if (this.options.inline === true) {
      this.element.classList.add("inline");
    }
    this.toolbar = document.createElement("div");
    this.toolbar.classList.add("toolbar");
    this.area = document.createElement("div");
    this.area.classList.add("area", "cf-unreset");
    this.area.setAttribute("translate", "no");
    this.area.setAttribute("spellcheck", true);
    if (typeof this.options.editorHeight === "string" && this.options.editorHeight.length > 0) {
      this.area.style.height = this.options.editorHeight;
    }
    this.area.setAttribute("contenteditable", true);
    this.element.append(this.toolbar);
    this.element.append(this.area);
  },
  //------------------------------------------------------------------------------------------------
  _initHandlers: function _initHandlers() {
    this._initSelectionHandler();
    this._initInputHandler();
    this._initChangeHandler();
    this._initCutHandler();
    this._initCopyHandler();
    this._initPasteHandler();
    this._initContextMenuHandler();
    this._initClickHandler();
    this._initDoubleClickHandler();
    this._initMouseDownHandler();
    this._initKeyHandler();
  },
  //------------------------------------------------------------------------------------------------
  _initSelectionHandler: function _initSelectionHandler() {
    this._selectionTimeout = null;

    // create different variable to be able to destroy it later
    this._bindSelectionChangeHandler = this._selectionChangeHandler.bind(this);
    // selectionchange event only fires on document
    document.addEventListener("selectionchange", this._bindSelectionChangeHandler);
  },
  _selectionChangeHandler: function _selectionChangeHandler(pEvent) {
    if (this.alive === false || this.disabled === true) {
      return;
    }
    // check if the selection is within our component
    var selection = this._getSelection();
    if (!selection) {
      return;
    }
    var startNode = selection.getRangeAt(0).startContainer;
    var endNode = selection.getRangeAt(0).endContainer;
    if (!this.area.contains(startNode) || !this.area.contains(endNode)) {
      return;
    }
    // debounce
    var that = this;
    clearTimeout(this._selectionTimeout);
    this._selectionTimeout = setTimeout(function () {
      that._updateUI.apply(that);
    }, 100);

    //selectionChangeHandler per plugin - debounce should be considered per plugin
    for (var plugin in that.plugins) {
      if (typeof that.plugins[plugin].plugin.selectionChangeHandler === "function") {
        that.plugins[plugin].plugin.selectionChangeHandler(that.area, selection, pEvent);
      }
      ;
    }
  },
  _initInputHandler: function _initInputHandler() {
    this._inputTimeout = null;

    // create different variable to be able to destroy it later
    this._bindInputHandler = this._inputHandler.bind(this);
    // selectionchange event only fires on document
    document.addEventListener("input", this._bindInputHandler);
  },
  _inputHandler: function _inputHandler(pEvent) {
    if (this.alive === false || this.disabled === true) {
      return;
    }
    // check if the selection is within our component
    var selection = this._getSelection();
    if (!selection) {
      return;
    }
    var startNode = selection.getRangeAt(0).startContainer;
    var endNode = selection.getRangeAt(0).endContainer;
    if (!this.area.contains(startNode) || !this.area.contains(endNode)) {
      return;
    }
    // debounce
    var that = this;
    clearTimeout(this._inputTimeout);
    //inputHandler per plugin - debounce should be considered per plugin
    for (var plugin in that.plugins) {
      if (typeof that.plugins[plugin].plugin.inputHandler === "function") {
        that.plugins[plugin].plugin.inputHandler(that.area, selection, pEvent);
      }
      ;
    }
  },
  _initChangeHandler: function _initChangeHandler() {
    // add listener for only the first change
    this._bindFirstChangeHandler = this._firstChangeHandler.bind(this);
    this.area.addEventListener("input", this._bindFirstChangeHandler);

    // new lines added
    this.area.addEventListener("input", function (pEvent) {
      if (pEvent.inputType === "insertParagraph") {}
    });
  },
  _firstChangeHandler: function _firstChangeHandler(pEvent) {
    var that = this;
    var contentHTML = this._getInnerContent();
    var nodeList = this.area.querySelectorAll("p, div");
    var paragraphTagName = that.options.enterMode === "br" ? "p" : that.options.enterMode;
    if (typeof contentHTML === "string" && contentHTML.length > 0 && Utils.isTextRTL(contentHTML, true)) {
      var range = window.getSelection().getRangeAt(0);
      // change direction to ltr
      if (nodeList.length > 0) {
        // apply rtl to all paragraphs
        nodeList.forEach(function (pNode) {
          pNode.setAttribute("dir", "rtl");
        });
      } else {
        var nodeListBR = this.area.querySelectorAll("br");
        if (nodeListBR.length > 0) {
          var lines = contentHTML.split(new RegExp("<br\\s*[/]?>", "i"));
          var newContent = "";
          lines.forEach(function (l) {
            newContent = "<" + paragraphTagName + " dir=rtl >" + l + "</" + paragraphTagName + ">";
          });
          this._applyStyleLater(this.area, newContent);
          range.setStart(paraElement, window.getSelection().anchorNode.length);
        } else {
          // surround the complete content in a paragraph
          var paraElement = document.createElement(this.options.enterMode);
          paraElement.setAttribute("dir", "rtl");
          this.area.childNodes.forEach(function (n) {
            paraElement.append(n);
          });
          this.area.append(paraElement);
          //to set the cursor left of the text (we're in rtl situation)
          range.setStart(paraElement, window.getSelection().anchorNode.length);
        }
      }
    }
    this._cleanHTML();
    this.area.removeEventListener("input", this._bindFirstChangeHandler);
  },
  //------------------------------------------------------------------------------------------------
  _initCutHandler: function _initCutHandler() {
    var that = this;
    this.area.addEventListener("cut", function onCut(pEvent) {
      // set custom data, to detect that the copy comes from internal
      // but we need to prevent it, to keep the custom flag
      // so get all the html from selection and add to text/html
      if (that.disabled === true) {
        return;
      }
      var transferData = pEvent.clipboardData || window.clipboardData;
      var internalHTML = "";
      var internalText = "";
      if (typeof window.getSelection != "undefined") {
        var sel = window.getSelection();
        var container = document.createElement("div");
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        internalHTML = container.innerHTML;
        internalText = container.innerText;
      } else if (typeof document.selection != "undefined") {
        if (document.selection.type == "Text") {
          internalHTML = document.selection.createRange().htmlText;
          internalText = document.selection.createRange().toString();
        }
      }
      transferData.setData("text/nixpstajiri", "internalcut");
      transferData.setData("text/html", internalHTML);
      transferData.setData("text/plain", internalText);
      transferData.setData("text", internalText);
      that._createHistoryEntry("beforeCut");
      that._getSelection().getRangeAt(0).deleteContents();
      that._createHistoryEntry("afterCut");
      pEvent.preventDefault();
    });
  },
  //------------------------------------------------------------------------------------------------
  _initCopyHandler: function _initCopyHandler() {
    var that = this;
    this.area.addEventListener("copy", function onCopy(pEvent) {
      // set custom data, to detect that the copy comes from internal
      // but we need to prevent it, to keep the custom flag
      // so get all the html from selection and add to text/html
      if (that.disabled === true) {
        return;
      }
      var transferData = pEvent.clipboardData || window.clipboardData;
      var internalHTML = "";
      var internalText = "";
      if (typeof window.getSelection != "undefined") {
        var sel = window.getSelection();
        var container = document.createElement("div");
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        internalHTML = container.innerHTML;
        internalText = container.innerText;
      } else if (typeof document.selection != "undefined") {
        if (document.selection.type == "Text") {
          internalHTML = document.selection.createRange().htmlText;
          internalText = document.selection.createRange().toString();
        }
      }
      transferData.setData("text/nixpstajiri", "internalcopy");
      transferData.setData("text/html", internalHTML);
      transferData.setData("text/plain", internalText);
      transferData.setData("text", internalText);
      pEvent.preventDefault();
    });
  },
  _blobToDataURL: function _blobToDataURL(blob) {
    return new Promise(function (resolve, reject) {
      var a = new FileReader();
      a.onload = function (e) {
        resolve(e.target.result);
      };
      a.readAsDataURL(blob);
    });
  },
  //------------------------------------------------------------------------------------------------
  _initPasteHandler: function _initPasteHandler() {
    var that = this;
    this.area.addEventListener("paste", function onPaste(pEvent) {
      if (that.disabled === true) {
        return;
      }
      var clipboardData = pEvent.clipboardData || window.clipboardData;
      var internalMode = clipboardData.getData("text/nixpstajiri");
      if (internalMode === "internalcut") {
        // let copy internal text to internal area
        return;
      }
      if (typeof that.pasteAction === "function") {
        var dataTransfer = that.pasteAction(pEvent, {});
        if (dataTransfer !== null) {
          clipboardData = dataTransfer;
        }
      }
      internalMode = clipboardData.getData("text/nixpstajiri");
      if (internalMode === "internalcopy") {
        // let copy internal text to internal area
        return;
      }
      pEvent.preventDefault();
      var selection = that._getSelection();
      var isSourceMode = false;
      if (that.plugins.Source !== undefined) {
        isSourceMode = that.plugins.Source.plugin.isActive();
      }

      // 
      // we will first replace all DIVs to P, we will replace them later
      // apply all styles to [data-tajiri-style] 
      // afterwards we will apply filters
      //
      var HTMLString = clipboardData.getData("text/html");
      var RTFData = clipboardData.getData("text/rtf");
      if (typeof HTMLString === "string" && HTMLString.length > 0) {
        // filter out 
        HTMLString = HTMLString.replace(/<[\\]?script([^>]*)>/ig, ""); // extra layer
        HTMLString = HTMLString.replace(/<[\\]?iframe([^>]*)>/ig, ""); // extra layer
        HTMLString = HTMLString.replace(/<o:p><\/o:p>/ig, "");
        HTMLString = HTMLString.replace(/<!--[^-]*-->/g, "");
        HTMLString = HTMLString.replace(/<strong>/ig, "<b>").replace(/<\/strong>/ig, "</b>");
        HTMLString = HTMLString.replace(/<em>/ig, "<i>").replace(/<\/em>/ig, "</i>");
        HTMLString = HTMLString.replace(/<div([^>]*)>/ig, "<p$1>").replace(/<\/div>/ig, "</p>");
        // HTMLString = HTMLString.replace(/\s{2}/g, " &nbsp;");
        HTMLString = HTMLString.trim();

        // apply styles from style tag to body
        var stylesDict = {};
        var pastedDocument = new DOMParser().parseFromString(HTMLString, "text/html");
        if (pastedDocument.head !== undefined) {
          var styleTag = pastedDocument.head.querySelector("style");
          if (_typeof(styleTag) === "object" && styleTag !== null) {
            var stylesString = styleTag.innerText;
            if (typeof stylesString === "string" && stylesString.length > 0) {
              // clean up
              stylesString = stylesString.replace(/<!--[^<]*-->/g, "").trim();
              if (isSourceMode !== true) {
                stylesString = stylesString.replace(/\r|\n/g, " ");
              }
              // fill in dictionary
              stylesString.replace(/([^}]*){([^}]*)}/g, function (pMatch, pCSSSelector1, pCSSValues2) {
                stylesDict[pCSSSelector1.trim()] = pCSSValues2.trim();
              });
            }
          }
        }
        var body = pastedDocument.body;
        if (Object.keys(stylesDict).length > 0) {
          for (var cssselector in stylesDict) {
            body.querySelectorAll(cssselector).forEach(function (pNode) {
              var oldStyle = pNode.getAttribute("style");
              if (typeof oldStyle === "string" && oldStyle.length > 0) {
                pNode.setAttribute(oldStyle + ";" + stylesDict[cssselector]);
              } else {
                pNode.setAttribute("style", stylesDict[cssselector]);
              }
            });
          }
        }

        // ask plugins to filter and manipulate
        var validAttributenames = [];
        var newBody = undefined;
        for (var pluginID in that.plugins) {
          if (that.plugins[pluginID].plugin) {
            if (typeof that.plugins[pluginID].plugin.formatForPaste === "function") {
              newBody = that.plugins[pluginID].plugin.formatForPaste(body, that.area);
              if (!newBody) {
                body = newBody;
              }
            }
            if (typeof that.plugins[pluginID].plugin.getValidAttributeNames === "function") {
              var attributeNames = that.plugins[pluginID].plugin.getValidAttributeNames();
              if (Array.isArray(attributeNames) && attributeNames.length > 0) {
                validAttributenames = validAttributenames.concat(attributeNames);
              }
            }
          }
        }
        if (that.plugins["RTL"] === undefined) {
          newBody = new RTLPlugin({
            enterMode: that.options.enterMode
          }).formatForPaste(body, that.area);
          if (!newBody) {
            body = newBody;
          }
        }
        if (that.plugins["LTR"] === undefined) {
          newBody = new LTRPlugin({
            enterMode: that.options.enterMode
          }).formatForPaste(body, that.area);
          if (!newBody) {
            body = newBody;
          }
        }

        // remove default dir if not needed
        if (that.plugins["RTL"] === undefined && that.plugins["LTR"] === undefined && that.area.querySelector("[dir]") === null) {
          pastedDocument.body.querySelectorAll("[dir=ltr]").forEach(function (pNode) {
            pNode.removeAttribute("dir");
          });
        }
        pastedDocument.body.querySelectorAll("*").forEach(function (pElem) {
          if (pElem.style.textIndent.length > 0) {
            var amountOfSpaces = Math.ceil(parseInt(pElem.style.textIndent) / 9); //one tab = indent of 36pt so we convert to 4 spaces
            for (var i = 0; i < amountOfSpaces; i++) {
              pElem.innerHTML = " " + pElem.innerHTML;
            }
          } else if (pElem.style.whiteSpace === "pre") {
            //word online fix
            pElem.innerText = pElem.innerText.replace(/\t/g, "    ");
          }
        });

        // remove all attributes
        pastedDocument.body.querySelectorAll("*").forEach(function (pNode) {
          var originalOldClasses = pNode.className;
          pNode.getAttributeNames().filter(function (pName) {
            return !["dir", "data-tajiri-style", "alt", "src"].concat(validAttributenames).includes(pName.toLowerCase());
          }).forEach(function (pName) {
            pNode.removeAttribute(pName);
          });
          // add stsyem classes
          originalOldClasses.split(" ").forEach(function (pClass) {
            if (pClass.indexOf("tajiri") === 0) {
              pNode.classList.add(pClass);
            }
          });
        });

        // remove single br tag in pargraphs
        pastedDocument.body.querySelectorAll("p").forEach(function (pNode) {
          if (pNode.childNodes.length === 1 && pNode.childNodes[0].tagName === "BR") {
            pNode.innerHTML = "";
          }
        });

        // remove br when no are allowed
        if ((that.options.enterMode === "div" || that.options.enterMode === "p") && isSourceMode === false) {
          pastedDocument.body.querySelectorAll("br").forEach(function (pNode) {
            pNode.remove();
          });
        } else if (isSourceMode === true) {
          //replace all br with newlines
          pastedDocument.body.querySelectorAll("br").forEach(function (pNode) {
            pNode.parentNode.insertBefore(document.createTextNode("\n"), pNode);
            pNode.remove();
          });
        }

        // remove all empty spans
        var emptySpans = pastedDocument.body.querySelectorAll("span:not([data-tajiri-style]):not([data-tajiri-template-value])");
        //first replace leaves then go up, to keep updated leaves
        for (var i = emptySpans.length - 1; i >= 0; i--) {
          emptySpans[i].outerHTML = emptySpans[i].innerHTML;
        }

        //convert file:/// urls to data
        var imgs = pastedDocument.body.querySelectorAll("img");
        var regexp = new RegExp(/\\(?:pngblip|jpegblip)[^}]*\}([^}]+)\}/gi);
        var hexStrings = [];
        var match;
        while ((match = regexp.exec(RTFData)) !== null) {
          hexStrings.push(match[1].trim());
        }
        var base64Strings = [];
        hexStrings.forEach(function (hexString) {
          base64Strings.push(that._hexToBase64(hexString));
        });
        var foundFileURLs = 0;
        imgs.forEach(function (pImg) {
          if (pImg.src.startsWith("file:///")) {
            pImg.src = "data:image/" + pImg.src.split('.').pop() + ";base64," + base64Strings[foundFileURLs];
            foundFileURLs++;
          }
        });

        //remove tags that have no text / spaces in them only
        that._unstyleSpacesAfterPaste(pastedDocument.body);

        // remove all html comments
        pastedDocument.body.querySelectorAll("*").forEach(function (pNode) {
          var childNodes = pNode.childNodes;
          for (var i = 0; i < childNodes.length; i++) {
            if (childNodes[i].nodeName === "#comment") {
              pNode.removeChild(childNodes[i]);
              i--; // list adapt live, so go back because we removed the item
            }
          }
        });

        // remove all p that have no simblings and added unneeded amount of deep pragraphs
        while (pastedDocument.body.children.length === 1 && pastedDocument.body.children[0].matches("p:not([data-tajiri-style]):not([dir])")) {
          var childNodes = pastedDocument.body.children[0].childNodes;
          while (childNodes.length > 0) {
            pastedDocument.body.append(childNodes[0]);
          }
          pastedDocument.body.removeChild(pastedDocument.body.children[0]);
        }

        //remove all empty p tags without text - regular enters should have a nbsp; as text
        var toRemove = [];
        pastedDocument.body.querySelectorAll("p").forEach(function (pParagraph) {
          if (pParagraph.childNodes.length === 0) {
            toRemove.push(pParagraph);
          }
        });
        toRemove.forEach(function (pToRemove) {
          pToRemove.remove();
        });

        // trim body
        while (pastedDocument.body.firstChild !== null && pastedDocument.body.firstChild.nodeName === "#text" && pastedDocument.body.firstChild.textContent.trim() === "") {
          pastedDocument.body.removeChild(pastedDocument.body.firstChild);
        }
        while (pastedDocument.body.lastChild !== null && pastedDocument.body.lastChild.nodeName === "#text" && pastedDocument.body.lastChild.textContent.trim() === "") {
          pastedDocument.body.removeChild(pastedDocument.body.lastChild);
        }
        var existingContent = that.area.innerText;
        var hasDifferentLines = Array.from(pastedDocument.body.children).some(function (pNode) {
          return pNode.tagName === "P";
        });
        var applyingDifferentLines = hasDifferentLines && existingContent.length > 0;
        if (existingContent.length === 0 && Utils.isTextRTL(pastedDocument.body.innerText) === true) {
          if (hasDifferentLines) {
            Array.from(pastedDocument.body.children).forEach(function (pNode) {
              pNode.setAttribute("dir", "rtl");
            });
          } else {
            var paragraphDOM = document.createElement("p");
            paragraphDOM.setAttribute("dir", "rtl");
            while (pastedDocument.body.firstChild) {
              paragraphDOM.append(pastedDocument.body.firstChild);
            }
            pastedDocument.body.append(paragraphDOM);
          }
        }

        // restore line endings
        var bodyString = pastedDocument.body.innerHTML;
        // if (isSourceMode !== true) {
        //     bodyString = bodyString.replace(/\n/g, "").trim();
        // }
        if (that.options.enterMode === "div") {
          bodyString = bodyString.replace(/<p([^>]*)>/ig, "<div$1>").replace(/<\/p>/ig, "</div>");
        } else if (that.options.enterMode === "br") {
          bodyString = bodyString.replace(/<p([^>]*)>/ig, "").replace(/<\/p>/ig, "<br>");
        }

        // remove all unknown tags
        var pastedHTML = that._normalizeForUnknownTags(bodyString);
        // replace whitespaces
        // escape double spaces
        pastedHTML = pastedHTML.replaceAll("&nbsp;", " ");
        if (isSourceMode !== true) {
          pastedHTML = pastedHTML.replace(/\r\n|\n|\r/g, " ");
          pastedHTML = pastedHTML.replace(/\s{2}/g, " &nbsp;");
        }
        var wrapper = document.createElement("div");
        wrapper.innerHTML = pastedHTML;

        //remove the pointless br tags & trailing spaces
        if (that.options.enterMode !== "br" && isSourceMode === false) {
          var toRemove = [];
          wrapper.querySelectorAll("br").forEach(function (pBRTag) {
            if (pBRTag.closest(that.options.enterMode) !== null && pBRTag.closest(that.options.enterMode).textContent.length > 0) {
              toRemove.push(pBRTag);
            }
          });
          wrapper.childNodes.forEach(function (pChild) {
            that._checkForTrailingSpaces(pChild);
          });
          toRemove.forEach(function (pRemove) {
            pRemove.remove();
          });
        }

        // clear format, TODO: does not work
        var formatPlugin = null;
        if (that.plugins["Remove Format"] !== undefined && that.plugins["Remove Format"].plugin !== undefined) {
          formatPlugin = that.plugins["Remove Format"].plugin;
        } else {
          formatPlugin = new RemoveFormatPlugin();
        }
        that._removeContenteditable(that.area);
        formatPlugin.format(selection, that.area);
        that._addContenteditable(that.area);
        selection.deleteFromDocument();
        var range = selection.getRangeAt(0);
        if (applyingDifferentLines === true) {
          var prevParent = range.endContainer;
          if (prevParent !== null && prevParent.nodeType === Node.TEXT_NODE) {
            prevParent = prevParent.parentNode;
          }
          if (prevParent !== null && prevParent.closest !== undefined) {
            prevParent = prevParent.closest("p,div");
          }
          var isPrevparentValid = prevParent !== null && prevParent !== undefined && ["P", "DIV"].includes(prevParent.tagName) && prevParent.classList.contains("nixps-Tajiri") === false && prevParent.isSameNode(that.area) === false;
          var currentLineDirection = "ltr";
          if (isPrevparentValid && prevParent.hasAttribute("dir")) {
            currentLineDirection = prevParent.getAttribute("dir");
          }
          var pasteLineDirection = wrapper.childNodes[0].hasAttribute("dir") ? wrapper.childNodes[0].getAttribute("dir") : "ltr";
          if (isPrevparentValid && pasteLineDirection === currentLineDirection) {
            // keep first pasted line at cursor, move trailing text to last pasted line.
            var tailRange = range.cloneRange();
            tailRange.setEnd(prevParent, prevParent.childNodes.length);
            var trailingContents = tailRange.extractContents();
            var firstParagraph = wrapper.firstChild;
            var firstParagraphChildren = firstParagraph.childNodes;
            for (var firstIndex = firstParagraphChildren.length - 1; firstIndex >= 0; firstIndex--) {
              range.insertNode(firstParagraphChildren[firstIndex]);
            }
            wrapper.removeChild(firstParagraph);
            var focusNode = prevParent;
            while (wrapper.firstChild) {
              var newFocusNode = wrapper.firstChild;
              focusNode.after(newFocusNode);
              focusNode = newFocusNode;
            }
            focusNode.append(trailingContents);
            selection = that._getSelection();
            selection.removeAllRanges();
            var newRange = document.createRange();
            newRange.selectNodeContents(focusNode);
            newRange.collapse(false);
            selection.addRange(newRange);
          } else {
            //legacy
            document.execCommand("InsertHTML", false, "<br>");
            selection = that._getSelection();
            if (selection === null || selection.anchorNode === undefined) {
              debugger;
              throw new Error("invalid settup durring paste");
            }
            var nextParent = selection.anchorNode.parentElement.closest("p,div");
            var isNextParentValid = ["P", "DIV"].includes(nextParent.tagName) && nextParent.classList.contains("nixps-Tajiri") === false && nextParent.isSameNode(that.area) === false;
            if (isNextParentValid) {
              if (that.options.enterMode !== "br") {
                if (nextParent.previousSibling && nextParent.previousSibling.nodeName === "BR") {
                  nextParent.previousSibling.remove();
                } else {
                  that.area.querySelectorAll("br").forEach(function (pNode) {
                    pNode.remove();
                  });
                }
              }
              while (wrapper.firstChild) {
                nextParent.before(wrapper.firstChild);
              }
            } else {
              // when past add end, last charater, there is no next, use previous
              if (that.options.enterMode !== "br") {
                if (nextParent.nextSibling && nextParent.nextSibling.nodeName === "BR") {
                  nextParent.nextSibling.remove();
                } else {
                  that.area.querySelectorAll("br").forEach(function (pNode) {
                    pNode.remove();
                  });
                }
              }
              if (isPrevparentValid) {
                var fallbackFocusNode = prevParent;
                while (wrapper.firstChild) {
                  var fallbackNewFocusNode = wrapper.firstChild;
                  fallbackFocusNode.after(fallbackNewFocusNode);
                  fallbackFocusNode = fallbackNewFocusNode;
                }
                var fallbackSelection = that._getSelection();
                fallbackSelection.getRangeAt(0).setEndAfter(fallbackFocusNode);
                fallbackSelection.collapseToEnd();
              } else {
                // some fallback, come inside when pasting in empty space
                while (wrapper.firstChild) {
                  that.area.append(wrapper.firstChild);
                }
                that.selectAll();
                that._getSelection().collapseToEnd();
              }
            }
          }
        } else {
          if (hasDifferentLines === true && existingContent.length === 0) {
            // multiple lines but content is emtpy
            // remove children
            that.area.replaceChildren();
          }
          // only one line to be pasted
          for (var i = wrapper.childNodes.length - 1; i >= 0; i--) {
            range.insertNode(wrapper.childNodes[i]);
          }
          // var zws = document.createElement("span");
          // zws.innerHTML = "&ZeroWidthSpace;";
          // range.insertNode(zws);
          selection.removeAllRanges();
          selection.addRange(range);
          range.collapse();
        }
        Utils.applyDataStyleToRealStyle(that.area);
        that._createHistoryEntry("paste");
        return;
      } else if (clipboardData.getData("text").length === 0 && clipboardData.files.length > 0) {
        //only images
        if (that.plugins.Image === undefined) {
          //no images
          return;
        }
        var selection = that._getSelection();
        var items = clipboardData.items;
        if (items.length > 0) {
          for (var i in items) {
            // iterate through clipbord items
            var item = items[i];
            if (item.kind == "file" && item.type.startsWith("image")) {
              //image is a file
              // create image source
              var blob = item.getAsFile();
              that._blobToDataURL(blob).then(function (pDataURL) {
                var pastedImage = new Image();
                pastedImage.src = pDataURL;
                if (selection.anchorNode === that.area) {
                  that.area.append(pastedImage);
                } else {
                  selection.anchorNode.after(pastedImage);
                }
              }, function (pReject) {
                console.error(pReject);
              })["catch"](function (pError) {
                console.error(pError);
              });
            }
          }
        }
        that._createHistoryEntry("paste");
      } else {
        // no html present, like paste without format
        var pasteText = clipboardData.getData("text");
        if (isSourceMode === true) {
          //just insert copied text, no need for cleaning up
          document.execCommand("insertText", false, pasteText);
          return;
        }
        if (!selection) {
          return;
        }
        //convert escaped whitespaces
        pasteText = pasteText.replace(/\r/g, "");
        pasteText = pasteText.replace(/\n/g, "</br>");
        pasteText = pasteText.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
        pasteText = pasteText.replace(/\s{2}/g, " &nbsp;");
        selection.deleteFromDocument();
        var wrapper = document.createElement("span");
        selection.getRangeAt(0).insertNode(wrapper); //don't insert a textnode here with the paste text - loss of new lines
        wrapper.innerHTML = pasteText;
        var lastLine = undefined;
        var multipleLines = wrapper.childNodes.length > 1;
        //convert new lines to entermode tags
        for (var i = wrapper.childNodes.length - 1; i > -1; i--) {
          var pChildNode = wrapper.childNodes[i];
          var afterNode = pChildNode;
          if (pChildNode.nodeType === Node.TEXT_NODE || pChildNode.nodeName !== undefined && pChildNode.nodeName.toLowerCase() === "br") {
            if (that.options.enterMode !== "br" && i !== 0) {
              if (pChildNode.nodeType === Node.TEXT_NODE && pChildNode.previousSibling !== null && pChildNode.previousSibling.nodeName !== undefined && pChildNode.previousSibling.nodeName.toLowerCase() === "br") {
                //remove the next br tag, since we're changing it to a entermode tag
                pChildNode.previousSibling.remove();
                i--;
              }
              afterNode = document.createElement(that.options.enterMode);
              if (pChildNode.nodeType === Node.TEXT_NODE) {
                if (pChildNode.parentElement.closest(that.options.enterMode) !== null && pChildNode.parentElement.closest(that.options.enterMode) !== that.area && pChildNode.parentElement.closest(that.options.enterMode).childNodes.length === 1 && pChildNode.parentElement.closest(that.options.enterMode).childNodes[0] === pChildNode) {
                  afterNode = pChildNode;
                } else if (pChildNode.textContent.trim().length === 0) {
                  //empty line , create a new line
                  afterNode.append(document.createElement("br"));
                } else {
                  afterNode.append(pChildNode.textContent);
                }
              } else {
                afterNode.append(pChildNode);
              }
            }
            wrapper.after(afterNode);
          } else {
            wrapper.after(afterNode);
          }
          while (afterNode.parentElement !== that.area && i !== 0) {
            var parent = afterNode.parentElement;
            parent.after(afterNode);
            if (parent.childNodes.length === 0) {
              parent.remove();
            }
          }
          if (lastLine === undefined) {
            lastLine = afterNode;
          }
          if (i === 0) {
            var firstLine = afterNode;
          }
          if (i === 1) {
            var secondLine = afterNode;
          }
        }
        wrapper.remove();
        var range = selection.getRangeAt(0);
        if (multipleLines) {
          range.setStartAfter(firstLine);
          range.setEndBefore(secondLine);
          lastLine.after(range.extractContents());
        }
        range.setEndAfter(lastLine);
        selection.collapseToEnd();
        that._createHistoryEntry("paste");
      }
    });
  },
  _hexToBase64: function _hexToBase64(hexstring) {
    return btoa(hexstring.match(/\w{2}/g).map(function (a) {
      return String.fromCharCode(parseInt(a, 16));
    }).join(""));
  },
  _unstyleSpacesAfterPaste: function _unstyleSpacesAfterPaste(pNode) {
    for (var i = pNode.childNodes.length - 1; i > 0; i--) {
      var n = pNode.childNodes[i];
      if ((n.textContent.length === 0 || n.textContent === " ") && n.childNodes.length === 1) {
        if (pNode.childNodes.length === 1) {
          pNode.outerHTML = n.textContent;
        }
      } else if (n.nodeType === Node.ELEMENT_NODE) {
        this._unstyleSpacesAfterPaste(n);
      }
    }
  },
  _formatPastedImgs: function _formatPastedImgs(pDOM, pPastedImgs) {
    var imgs = pDOM.querySelectorAll("img");
    if (imgs.length > 0) {
      imgs.forEach(function (pImg, pIndex) {
        if (pImg.src.length > 0 && pImg.src.startsWith("file://") === false) {
          return;
        }
        pImg.src = pPastedImgs[pIndex].src;
      });
      return pDOM;
    } else {
      // this is the case if there was only an img copied
      pPastedImgs.forEach(function (pPastedImg) {
        var img = document.createElement("img");
        img.src = pPastedImg.src;
        pDOM.append(img[0]);
      });
      return pDOM;
    }
  },
  _checkForTrailingSpaces: function _checkForTrailingSpaces(pChild) {
    var that = this;
    if (pChild.nodeType === Node.TEXT_NODE) {
      //two trailing spaces will be converted to 1 by html - solve with nbsp
      if (pChild.textContent.startsWith("  ")) {
        pChild.textContent = "\xA0" + pChild.textContent.slice(1, pChild.textContent.length); //replace the first space with a nbsp - html will trim automatically
      }

      if (pChild.textContent.endsWith("  ") && pChild.textContent.length > 1) {
        var newTextContent = pChild.textContent.slice(0, -1);
        pChild.textContent = newTextContent + "\xA0";
      }
    } else if (pChild.nodeType === Node.ELEMENT_NODE) {
      pChild.childNodes.forEach(function (pNested) {
        that._checkForTrailingSpaces(pNested);
      });
    }
  },
  //------------------------------------------------------------------------------------------------
  _initContextMenuHandler: function _initContextMenuHandler(pEvent) {
    var that = this;
    this.area.addEventListener("contextmenu", function onContextmenu(pEvent) {
      // always prevent
      if (that.disabled === true) {
        return;
      }
      if (window.$ === undefined) {
        //need jQuery to draw Tajiri-cloudflow-ContextMenu
        console.warn("Tajiri: please include jQuery to enable right-clicking");
        return;
      }
      var selection = that._getSelection();
      //some elements won't get selected by a rightclick, let's fix that first
      var elements = ["img"];
      elements.forEach(function (pElement) {
        if (pEvent.target.nodeName.toLowerCase() === pElement) {
          //right click was on an element that won't be selected on rightclick
          var range = selection.getRangeAt(0);
          var target = pEvent.target;
          selection.removeAllRanges();
          range.selectNode(target);
          selection.addRange(range);
        }
      });
      var plugins = Object.keys(that.plugins).map(function (pKey) {
        return that.plugins[pKey].plugin;
      }).filter(function (pPlugin) {
        return pPlugin.isActive(selection, that.area) && typeof pPlugin.getContextualItems === "function";
      });
      var items = [];
      plugins.forEach(function (pPlugin) {
        var calcContextmenuItems = pPlugin.getContextualItems(pEvent, selection, that.area);
        if (Array.isArray(calcContextmenuItems)) {
          items = items.concat(calcContextmenuItems);
        }
      });
      if (items.length > 0) {
        pEvent.preventDefault();
        pEvent.stopPropagation();
        var contextMenu;
        if (document.querySelector(".nixps-cloudflow-TajiriContextMenu") !== null) {
          contextMenu = $(document.querySelector(".nixps-cloudflow-TajiriContextMenu")).TajiriContextMenu({
            buttons: items
          });
        } else {
          contextMenu = $("<div>").TajiriContextMenu({
            buttons: items,
            rightclickEvent: pEvent,
            choiceCallback: that._createHistoryEntry.bind(that, "contextMenu")
          }).appendTo("body");
        }
        contextMenu.TajiriContextMenu("show", pEvent);
      }
      return false;
    });
  },
  //------------------------------------------------------------------------------------------------
  _initClickHandler: function _initClickHandler() {
    var that = this;
    this.area.addEventListener("click", function onClick(pEvent) {
      // make dict of tags and according callback function
      // we assume there is only one plugin for each tag
      if (that.disabled === true) {
        return;
      }
      var selectorToListen = {};
      for (var pluginID in that.plugins) {
        //get the double click selector - this should be the same for the click
        if (typeof that.plugins[pluginID].plugin.getDoubleClickSelector === "function" && typeof that.plugins[pluginID].plugin.clickHandler === "function") {
          var selector = that.plugins[pluginID].plugin.getDoubleClickSelector();
          if (_typeof(selector) && selector.length > 0) {
            if (selectorToListen[selector] !== undefined) {
              console.error("only one plugin for a specific selector is allowed, we will ignore " + pluginID);
              continue;
            }
            selectorToListen[selector] = that.plugins[pluginID].plugin.clickHandler.bind(that.plugins[pluginID].plugin);
          }
        }
      }
      // sort values (heuristic) so specific selectors get priority
      var selectorValues = Object.keys(selectorToListen);
      selectorValues.sort(function (a, b) {
        // ASC  -> a.length - b.length
        // DESC -> b.length - a.length
        return b.length - a.length;
      });
      // loop, check if element is a known tag, if not go to parent
      // stop after the first known tag
      var target = pEvent.target;
      do {
        if (target.isEqualNode && target.isEqualNode(that.area)) {
          // do not continue outside the editor
          break;
        }
        var foundSelector = selectorValues.find(function (pSelector) {
          return target.matches(pSelector);
        });
        if (foundSelector !== undefined && typeof selectorToListen[foundSelector] === "function") {
          selectorToListen[foundSelector](pEvent, {
            selection: that._getSelection(),
            target: target
          });
          break;
        }
        target = target.parentNode;
      } while (target.parentNode);
    });
  },
  //------------------------------------------------------------------------------------------------
  _initDoubleClickHandler: function _initDoubleClickHandler() {
    var that = this;
    this.area.addEventListener("dblclick", function onDoubleClick(pEvent) {
      // make dict of tags and according callback function
      // we assume there is only one plugin for each tag
      if (that.disabled === true) {
        return;
      }
      var selectorToListen = {};
      var selection = that._getSelection();
      for (var pluginID in that.plugins) {
        if (typeof that.plugins[pluginID].plugin.getDoubleClickSelector === "function" && typeof that.plugins[pluginID].plugin.doubleClickHandler === "function") {
          var selector = that.plugins[pluginID].plugin.getDoubleClickSelector();
          if (_typeof(selector) && selector.length > 0) {
            if (selectorToListen[selector] !== undefined) {
              console.error("only one plugin for a specific selector is allowed, we will ignore " + pluginID);
              continue;
            }
            selectorToListen[selector] = that.plugins[pluginID].plugin.doubleClickHandler.bind(that.plugins[pluginID].plugin);
          }
        }
      }
      // sort values (heuristic) so specific selectors get priority
      var selectorValues = Object.keys(selectorToListen);
      selectorValues.sort(function (a, b) {
        // ASC  -> a.length - b.length
        // DESC -> b.length - a.length
        return b.length - a.length;
      });
      // loop, check if element is a known tag, if not go to parent
      // stop after the first known tag
      var target = pEvent.target;
      do {
        if (target.isEqualNode && target.isEqualNode(that.area)) {
          // do not continue outside the editor
          break;
        }
        var foundSelector = selectorValues.find(function (pSelector) {
          return target.matches(pSelector);
        });
        if (foundSelector !== undefined && typeof selectorToListen[foundSelector] === "function") {
          var outputDefer = selectorToListen[foundSelector](pEvent, {
            selection: that._getSelection(),
            target: target
          });
          that._afterDialogHandler(outputDefer, selection);
          break;
        }
        target = target.parentNode;
      } while (target.parentNode);
    });
  },
  _initEnterMode: function _initEnterMode() {
    if (["p", "div"].includes(this.options.enterMode) === true) {
      document.execCommand("defaultParagraphSeparator", false, this.options.enterMode);
    } else {
      //we have to add a &#8203; (zeroWidthSpace) to handle the caret properly after entering
      //issue right now is removing this character again after starting typing
      //this will only work for <br> - and will still add a div on the new line!!
      var enterNodeString = "</" + this.options.enterMode.toLowerCase() + ">";
      this.area.addEventListener("keydown", function (pEvent) {
        if (pEvent.key === "Enter") {
          document.execCommand("insertHTML", false, enterNodeString);
          return false;
        }
      });
    }
  },
  _initMouseDownHandler: function _initMouseDownHandler() {
    var that = this;
    this.area.addEventListener("mousedown", function (e) {
      if (that.disabled === true) {
        return;
      }
      //define what a pin is
      var el = e.target;
      if (el.getAttribute("data-tajiri-template-value") === null) {
        if (e.target.closest("span[data-tajiri-template-value]") === null) {
          return;
        } else {
          el = e.target.closest("span[data-tajiri-template-value]");
        }
      }
      that.area.classList.add("dragging-template");
      var range;
      var mouseMoveListener;
      e.preventDefault();
      that.area.addEventListener("mousemove", mouseMoveListener = function mouseMoveHandler(e) {
        var textRange,
          x = e.clientX,
          y = e.clientY;
        // Try the standards-based way first
        if (document.caretPositionFromPoint) {
          var pos = document.caretPositionFromPoint(x, y);
          range = document.createRange();
          range.setStart(pos.offsetNode, pos.offset);
          if (range.commonAncestorContainer.parentElement.getAttribute("data-tajiri-template-value") !== null) {
            //we're inside another variable, we can't drag variables into variables!
            range.setStartAfter(range.commonAncestorContainer.parentElement);
          }
          range.collapse();
        }
        // Next, the WebKit way
        else if (document.caretRangeFromPoint) {
          range = document.caretRangeFromPoint(x, y);
          if (range.commonAncestorContainer.parentElement.getAttribute("data-tajiri-template-value") !== null) {
            //we're inside another variable, we can't drag variables into variables!
            range.setStartAfter(range.commonAncestorContainer.parentElement);
          }
        }
        // Finally, the IE way
        else if (document.body.createTextRange) {
          textRange = document.body.createTextRange();
          textRange.moveToPoint(x, y);
          var spanId = "temp_" + ("" + Math.random()).slice(2);
          textRange.pasteHTML('<span id="' + spanId + '">&nbsp;</span>');
          var span = document.getElementById(spanId);
          //place the new pin
          span.parentNode.replaceChild(el, span);
        }
        var selection = that._getSelection();
        if (selection === null) {
          that.area.focus();
          selection = that._getSelection();
        }
        if (range) {
          selection.removeAllRanges();
          selection.addRange(range);
        }
      });
      //remove the handler when the user has stopped dragging it
      var mouseUpListener;
      that.area.addEventListener("mouseup", mouseUpListener = function mouseUpHandler() {
        //remove the old pin
        if (el !== undefined && range !== undefined) {
          el.remove();
          range.insertNode(el);
          el = undefined;
          var selection = that._getSelection();
          e.target.closest("span[data-tajiri-template-value]").setAttribute("contenteditable", true);
          // range.selectNode(e.target.closest("span[data-tajiri-template-value]"))
          selection.setBaseAndExtent(e.target.closest("span[data-tajiri-template-value]"), 0, e.target.closest("span[data-tajiri-template-value]"), 1);
          e.target.closest("span[data-tajiri-template-value]").setAttribute("contenteditable", false);
        }
        that.area.removeEventListener("mousemove", mouseMoveListener);
        that.area.removeEventListener("mouseup", mouseUpListener);
        that.area.classList.remove("dragging-template");
      });
    });
  },
  _initKeyHandler: function _initKeyHandler() {
    var that = this;
    var isMacOS = window.navigator !== undefined && typeof navigator.platform === 'string' && navigator.platform.indexOf("Mac") === 0;
    var commandKeyPressed = false;
    this.keysToListen = {};
    this.area.addEventListener("keydown", function (pEvent) {
      if (that.disabled === true) {
        return;
      }
      if (["MetaLeft", "MetaRight"].includes(pEvent.code) && isMacOS === true) {
        commandKeyPressed = true;
      }
      if (pEvent.code === "Tab") {
        //this is the tab key being pressed - prevent default when selection is in nodes that need another behavior
        var selection = that._getSelection();
        var range = selection.getRangeAt(0);
        var focusNode = range.startContainer;
        if (range.startContainer.nodeType === Node.TEXT_NODE) {
          focusNode = range.startContainer.parentNode;
        }
        //closest should check for all elements that will need to hijack the tab default behavior
        var hijackElements = ["li"];
        var hijackNode = null;
        hijackElements.forEach(function (pHijackNode) {
          if (focusNode.closest(pHijackNode) !== null) {
            hijackNode = focusNode.closest(pHijackNode);
          }
        });
        if (hijackNode !== null) {
          pEvent.preventDefault();
        }
      } else if (["KeyW", "KeyY"].includes(pEvent.code) && (pEvent.ctrlKey === true || commandKeyPressed)) {
        //preventdefault for ctrl+z and ctrl+y so we can use our own history instead of browser's
        pEvent.preventDefault();

        //can't listen to a keyup when cmd key is pressed at the same time, so we record here that cmd+z or cmd+shift+z has been pressed down
        if (pEvent.code === "KeyW" && commandKeyPressed && pEvent.shiftKey === true) {
          that._redoKeybindHandler();
        } else if (pEvent.code === "KeyW" && commandKeyPressed) {
          that._undoKeybindHandler();
        }
      } else if (pEvent.code === "Enter") {
        //enter was pressed, we'll need to log history
        that._createHistoryEntry("Enter");
      } else if (pEvent.code === "Backspace") {
        //backspace was pressed, we'll need to log history
        if (that._getCurrentHistoryAction() === "Delete") {
          return;
        }
        that._createHistoryEntry("Delete");
        that._updateUI();
      }
    });
    this.area.addEventListener("keyup", function (pEvent) {
      if (that.disabled === true) {
        return;
      }
      var selection = that._getSelection();
      if (Object.keys(that.keysToListen).length === 0) {
        for (var pluginID in that.plugins) {
          if (typeof that.plugins[pluginID].plugin.getKeyMapping === "function" && typeof that.plugins[pluginID].plugin.keyMappingHandler === "function") {
            var keyMapping = that.plugins[pluginID].plugin.getKeyMapping();
            if (_typeof(keyMapping) && keyMapping.length > 0) {
              if (that.keysToListen[keyMapping] !== undefined) {
                console.error("only one plugin for a specific selector is allowed, we will ignore " + pluginID);
                continue;
              }
              keyMapping.forEach(function (pKeyMap) {
                that.keysToListen[pKeyMap] = that.plugins[pluginID].plugin.keyMappingHandler.bind(that.plugins[pluginID].plugin);
              });
            }
          }
        }
      }
      var pressedKey = "" + pEvent.code;
      if (["MetaLeft", "MetaRight"].includes(pEvent.code) && commandKeyPressed === true) {
        //91 & 93 are commandLeft and commandRight
        //commandkey was released, set the bool back to false
        commandKeyPressed = false;
      }

      //order to check on pressedkey = ctrl - meta - shift - alt
      var modifierKeys = [];
      if (pEvent.ctrlKey === true) {
        modifierKeys.push("ctrl");
      }
      if (pEvent.metaKey === true) {
        modifierKeys.push("meta");
      }
      if (pEvent.shiftKey === true) {
        modifierKeys.push("shift");
      }
      if (pEvent.altKey === true) {
        modifierKeys.push("alt");
      }
      if (modifierKeys.length > 0) {
        pressedKey = modifierKeys.join("+") + "+" + pressedKey;
      }

      //CTRL+Z and CTRL+shift+z will be handled before the custom keymappings, so that they can't be overwritten
      if (pressedKey === "ctrl+KeyW") {
        //CTRL+Z
        //CTRL+Z, hijack default behavior and use our own history
        if (that.internalPlugins.undo.activeShortcut) {
          that._undoKeybindHandler();
        }
      } else if (pressedKey === "ctrl+shift+KeyW") {
        //pressedKey === "ctrl+89" for ctrl + y, maybe support later?
        //CTRL+SHIFT+Z, hijack default behavior and use our own history
        if (that.internalPlugins.redo.activeShortcut) {
          that._redoKeybindHandler();
        }
      } else if (Object.keys(that.keysToListen).includes(pressedKey)) {
        pEvent.preventDefault();
        var index = that._getCurrentHistoryIndex();
        //only log history if there's a difference in current state and the last saved state
        if (that.area.innerHTML !== that.history.array[index].text) {
          that._createHistoryEntry(pluginID);
        }
        var pluginID = that.keysToListen[pressedKey](selection, that.area, pEvent);
        that._createHistoryEntry(pluginID);
      } else if (pressedKey === "Backspace") {
        //BACKSPACE
        var isSourceMode = that.plugins["Source"] !== undefined && that.plugins["Source"].plugin.isActive() === true;
        if (that.area.textContent.length < 1 && that.options.enterMode.toLowerCase() !== "br" && isSourceMode === false) {
          //this is to prevent the editor from being completely empty, we'll always have a entermode tag ready
          var entermodeString = that.options.enterMode;
          that.setContent("<" + entermodeString + "></" + entermodeString + ">");
          var selection = that._getSelection();
          var range = selection.getRangeAt(0);
          range.setStart(that.area.childNodes[0], 0);
          range.setEnd(that.area.childNodes[0], 0);
        }
      }
    });
  },
  _undoKeybindHandler: function _undoKeybindHandler() {
    var index = this._getCurrentHistoryIndex();
    if (index === this.history.array.length - 1 && this._getCurrentHistoryAction() !== "lastState" && this.area.textContent !== this.history.array[index].textcontent) {
      //save the last state if it's different from the last entry in our history
      //this state might not have been saved if the user has been typing/deleting extra 
      this._createHistoryEntry("lastState");
      index++;
    }
    if (index !== 0) {
      index--;
    }
    this._restoreHistoryEntryIndex(index);
  },
  _redoKeybindHandler: function _redoKeybindHandler() {
    var index = this._getCurrentHistoryIndex();
    index++;
    this._restoreHistoryEntryIndex(index);
  },
  //------------------------------------------------------------------------------------------------
  _getSelection: function _getSelection() {
    var selection = null;
    if (window.getSelection) {
      selection = window.getSelection();
    }
    if (!selection && document.getSelection) {
      selection = document.getSelection();
    }
    if (!selection || !selection.rangeCount) {
      return null;
    }
    return selection;
  },
  //------------------------------------------------------------------------------------------------
  _updateUI: function _updateUI(pForce) {
    var that = this;
    this._removeContenteditable(this.area);
    var selection = this._getSelection();
    this._addContenteditable(this.area);
    if (!selection && pForce !== true) {
      return;
    }
    Object.keys(this.plugins).forEach(function (pPluginName) {
      var plugin = that.plugins[pPluginName].plugin;
      if (plugin.getButtonDescription().type === Plugin.BUTTON_NO_UI) {
        //no UI for this button 
        return;
      }
      var pluginSelectDOM = that.plugins[pPluginName].button;
      if (pluginSelectDOM.classList.contains("tajiri-selectioncontainer") === true) {
        pluginSelectDOM = pluginSelectDOM.querySelector("select");
      }
      var disabled_reasons = that.plugins[pPluginName].disabled_reasons;
      var isActive = pForce === true ? false : plugin.isActive(selection, that.area);
      var showSelected = plugin.showSelected();
      that._updateDisabledPlugins(plugin);
      if (pluginSelectDOM.tagName === "SELECT") {
        if (typeof isActive === "string") {
          pluginSelectDOM.value = isActive;
        } else {
          pluginSelectDOM.value = "";
        }
      }
      if (isActive && showSelected) {
        pluginSelectDOM.classList.add("selected");
      } else {
        pluginSelectDOM.classList.remove("selected");
      }
      if (disabled_reasons.length === 0) {
        if (pluginSelectDOM.querySelector(".nixps-Colorpicker") !== null) {
          $(pluginSelectDOM.querySelector(".nixps-Colorpicker")).Colorpicker("enable");
        } else {
          pluginSelectDOM.removeAttribute("disabled");
        }
      } else {
        if (pluginSelectDOM.querySelector(".nixps-Colorpicker") !== null) {
          $(pluginSelectDOM.querySelector(".nixps-Colorpicker")).Colorpicker("disable");
        } else {
          pluginSelectDOM.setAttribute("disabled", true);
        }
      }
    });
  },
  //------------------------------------------------------------------------------------------------
  _createToolbarButton: function _createToolbarButton(pPlugin) {
    function enableAction(plugin, selection) {
      var listener;
      that.area.addEventListener("mousedown", listener = function onMouseDown() {
        that.area.removeEventListener("mousedown", onMouseDown);
        that.area.addEventListener("mouseup", function onMouseUp() {
          that.area.removeEventListener("mousedown", onMouseDown);
          that.area.removeEventListener("mouseup", onMouseUp);
          that._removeContenteditable(that.area);
          plugin.unformat(selection, that.area);
          that._addContenteditable(that.area);
          that._cleanHTML();
          that._createHistoryEntry(plugin.getID());
          that._log("History", "new entry added", that.history);
          if (plugin.isStickyModeEnabled()) {
            enableAction(plugin, selection);
          }
        });
      });
      removeListener = function removeListener() {
        that.area.removeEventListener("mousedown", listener);
      };
    }
    var that = this;
    var desc = pPlugin.getButtonDescription();
    var button = null;
    var selectDOM = null;
    var selectLabelDOM = null;
    var colorPicker = null;
    switch (desc.type) {
      case Plugin.BUTTON_TOGGLE:
        {
          button = document.createElement("button");
          button.setAttribute("type", "button");
          // add icon
          if (typeof desc.icon === "string" && desc.icon.length > 0) {
            var icon = document.createElement("span");
            icon.className = desc.icon.trim();
            button.append(icon);
          } else if (typeof desc.text === "string") {
            if (window.$ !== undefined && window.$.i18n !== undefined) {
              button.textContent = $.i18n._(desc.text);
            } else {
              button.textContent = desc.text;
            }
          } else if (typeof desc.symbol === "string") {
            button.innerHTML = desc.symbol;
          }
          // add tooltip
          if (window.$ !== undefined && window.$.i18n !== undefined) {
            button.setAttribute("title", $.i18n._(desc.tooltip));
          } else {
            button.setAttribute("title", desc.tooltip);
          }
          break;
        }
      case Plugin.BUTTON_SELECT:
        {
          selectDOM = document.createElement("select");
          var guid = Guid.generate();
          selectDOM.setAttribute("name", pPlugin.getID());
          selectDOM.setAttribute("id", "nixps-Tajiri-" + guid + "-" + pPlugin.getID() + "-select");
          selectDOM.classList.add("no-form-control"); // indicate the select is not part of a form
          if (!Array.isArray(desc.options)) {
            throw new Error("Tajiri: option options is missing");
          }
          desc.options.forEach(function (pOption) {
            var value, label;
            if (typeof pOption === "string") {
              value = pOption;
              label = pOption;
            } else if (_typeof(pOption) === "object" && pOption !== null) {
              value = pOption.value;
              label = pOption.label || pOption.text;
            }
            var optionDOM = document.createElement("option");
            if (window.$ !== undefined && $.i18n !== undefined) {
              optionDOM.innerText = $.i18n._(label);
            } else {
              optionDOM.innerText = label;
            }
            optionDOM.setAttribute("value", value);
            selectDOM.append(optionDOM);
          });
          var mixedOption = document.createElement("option");
          mixedOption.innerText = "";
          mixedOption.setAttribute("value", "mixed");
          selectDOM.append(mixedOption);
          // add tooltip
          if (typeof desc.tooltip === "string" && desc.tooltip.length > 0) {
            if (window.$ !== undefined && window.$.i18n !== undefined) {
              selectDOM.setAttribute("title", $.i18n._(desc.tooltip));
            } else {
              selectDOM.setAttribute("title", desc.tooltip);
            }
          }
          selectLabelDOM = document.createElement("label");
          selectLabelDOM.setAttribute("for", "nixps-Tajiri-" + guid + "-" + pPlugin.getID() + "-select");
          selectLabelDOM.className = "tajiri-selectlabel";
          if (typeof desc.text === "string" && desc.text.length > 0) {
            if (window.$ !== undefined && window.$.i18n !== undefined) {
              selectLabelDOM.innerText = $.i18n._(desc.text);
            } else {
              selectLabelDOM.innerText = desc.text;
            }
          }
          break;
        }
      case Plugin.BUTTON_COLORPICKER:
        {
          if (window.$ === undefined) {
            console.warn("Tajiri: please include jQuery to use a colorpicker plugin");
            break;
          }
          colorPicker = $("<span>").addClass("colorpicker-" + pPlugin.getID());
          var colorpickerComponent = $("<span>");
          document.querySelector("body").append(colorPicker[0]);
          colorPicker.append(colorpickerComponent);
          colorpickerComponent.Colorpicker(desc.options);
          colorpickerComponent.find(".sp-dd")[0].innerHTML = "";
          if (typeof desc.icon === "string") {
            colorpickerComponent.find(".sp-dd").addClass(desc.icon);
            colorpickerComponent.Colorpicker("setValue", pPlugin.getDefaultValue());
            colorPicker.append(colorpickerComponent);
          } else if (Array.isArray(desc.icon)) {
            var stack = colorpickerComponent.find(".sp-dd");
            stack.addClass("fa-stack");
            stack.append($("<span>").addClass(desc.icon[0]));
            stack.append($("<span>").addClass(desc.icon[1]));
          } else {
            console.error("Tajiri: Icon for colorpicker plugin is in wrong format");
          }
          var icon = colorpickerComponent[0].querySelector(".sp-dd");
          var preview = colorpickerComponent[0].querySelector(".sp-preview");
          icon.parentElement.insertBefore(icon, preview);
          break;
        }
      case Plugin.BUTTON_NO_UI:
        {
          button = null;
          break;
        }
      default:
        {
          console.error('Invalid button type "' + desc.type + '" for plugin ' + pPlugin.getName());
        }
    }
    var removeListener = null;
    if (button !== null) {
      button.addEventListener("mousedown", function (pEvent) {
        //workaround to make "focusout" listener work as intended.
        pEvent.preventDefault();
        pEvent.stopPropagation();
      });
      button.addEventListener("click", function onClick(pEvent) {
        pEvent.preventDefault();
        pEvent.stopPropagation();
        var selection = that._getSelection();
        //clicked a button, but no selection / selection is not inside the area
        if (!selection || selection.anchorNode.parentElement.closest(".area[contenteditable=true], .area[contenteditable=plaintext-only]") === null) {
          that.area.focus();
          selection = that._getSelection();
        }
        var isActive = pPlugin.isActive(selection, that.area);
        var mustContinue = true;
        if (typeof pPlugin.beforeFormat === "function" && isActive === false) {
          mustContinue = pPlugin.beforeFormat(selection, that.area);
        } else if (typeof pPlugin.beforeUnformat === "function" && isActive === true) {
          mustContinue = pPlugin.beforeUnformat(selection, that.area);
        }
        if (mustContinue !== true) {
          return;
        }
        var saveHistory = true;
        if (typeof pPlugin.shouldSaveHistory === "function") {
          saveHistory = pPlugin.shouldSaveHistory();
        }
        if (that.history.array.length > 0 && that.history.array[that._getCurrentHistoryIndex()].textcontent !== that.area.textContent && saveHistory) {
          //we create a before state, last state might be different because of typing
          that._createHistoryEntry("beforeFormat");
        }
        if (typeof ClickAndDragPlugin === "function" && pPlugin instanceof ClickAndDragPlugin) {
          if (isActive && pEvent.detail === 1) {
            pPlugin.disableStickyMode();
            if (typeof removeListener === "function") {
              removeListener();
            }
          } else {
            // First click, enable the plugin
            if (pEvent.detail === 1) {
              that._removeContenteditable(that.area);
              pPlugin.format(selection, that.area);
              that._addContenteditable(that.area);
              enableAction(pPlugin, selection);
            } else if (pEvent.detail === 2) {
              pPlugin.enableStickyMode();
            }
          }
          that._updateUI();
        } else {
          if (pEvent.detail > 1) {
            return;
          }
          var outputFormat = undefined;
          if (!isActive) {
            that._removeContenteditable(that.area);
            outputFormat = pPlugin.format(selection, that.area);
            that._afterDialogHandler(outputFormat, selection);
            that._addContenteditable(that.area);
          } else {
            that._removeContenteditable(that.area);
            outputFormat = pPlugin.unformat(selection, that.area);
            that._addContenteditable(that.area);
          }
          var exclusive = pPlugin.isExclusive();
          if (exclusive === true) {
            Object.keys(that.plugins).forEach(function (pPluginName) {
              var plugin = that.plugins[pPluginName].plugin;
              var disabled_reasons = that.plugins[pPluginName].disabled_reasons;
              if (plugin === pPlugin) {
                return;
              }
              var idx = disabled_reasons.indexOf(pPlugin.getID());
              if (!isActive) {
                if (idx === -1) {
                  disabled_reasons.push(pPlugin.getID());
                }
              } else {
                if (idx !== -1) {
                  disabled_reasons.splice(idx, 1);
                }
              }
            });
            //also enable/disable undo/redo
            that.disableUndoRedoButtons(!isActive);
          }
          that._updateDisabledPlugins(pPlugin);
          var excludeCleaners = [];
          if (typeof pPlugin.getExcludedCleaners === "function") {
            excludeCleaners = pPlugin.getExcludedCleaners();
          }
          that._cleanHTML(excludeCleaners);
          if (saveHistory) {
            that._createHistoryEntry(pPlugin.getID());
          }
          if (pPlugin.getID() !== "Symbol") {
            //prevent that the focus goes back to area when we're dealing with symbol picker
            //this would be an issue because the user would be able to edit text behind the overlay
            that.area.focus();
          }
          that._log("History", "new entry added", that.history);
          that._updateUI();
          // show activation when caret and button is clicked
          if (!isActive) {
            this.classList.add("selected");
          } else {
            this.classList.remove("selected");
          }
        }
      });
      return button;
    }
    if (selectDOM !== null) {
      selectDOM.addEventListener("change", function onChange(pEvent) {
        pEvent.preventDefault();
        var selection = that._getSelection();
        if (!selection || selection.anchorNode.parentElement.closest(".area[contenteditable=true], .area[contenteditable=plaintext-only]") === null) {
          that.area.focus();
          selection = that._getSelection();
        }
        var value = pEvent.currentTarget.value;
        pPlugin.setValue(value);
        that._removeContenteditable(that.area);
        pPlugin.format(selection, that.area);
        that._addContenteditable(that.area);
        that._cleanHTML();
        that._createHistoryEntry(pPlugin.getID());
        that.area.focus();
        that._updateUI();
      });
      var selectContainerDOM = document.createElement("span");
      selectContainerDOM.className = "tajiri-selectioncontainer";
      selectContainerDOM.append(selectLabelDOM);
      selectContainerDOM.append(selectDOM);
      return selectContainerDOM;
    }
    if (colorPicker !== null) {
      colorPicker.on("change", function (pEvent) {
        pEvent.preventDefault();
        var target = $(pEvent.target.closest(".nixps-Colorpicker"));
        var selection = that._getSelection();
        if (!selection || selection.anchorNode.parentElement.closest(".area[contenteditable=true], .area[contenteditable=plaintext-only]") === null) {
          that.area.focus();
          selection = that._getSelection();
        }
        var color = target.Colorpicker("getValue");
        pPlugin.setValue(color);
        that._removeContenteditable(that.area);
        pPlugin.format(selection, that.area);
        that._addContenteditable(that.area);
        target.Colorpicker("hide");
        that._cleanHTML();
        that._createHistoryEntry(pPlugin.getID());
        that.area.focus();
        that._updateUI();
      });
      return colorPicker[0];
    }
    return button;
  },
  _afterDialogHandler: function _afterDialogHandler(pOutputDefer, pSelection) {
    var that = this;
    if (pOutputDefer !== undefined) {
      pOutputDefer.then(function (pOutput) {
        if (that.alive === false) {
          return;
        }
        if (Object.keys(pOutput).length === 0) {
          return;
        }
        if (pOutput.newNode !== undefined) {
          pOutput.newNode.setAttribute("data-tajiri-selection", true);
        }
        //takes the DOM, makes a new one out of it, and places the new one back into the editor
        //TODO: only do this when there's textual plugins present, maybe set a flag upon installing
        that._applyStyleLater(that.area, that._transformWithTextualPlugins(that.getContent()));
        //look for data-attributes on element since it can be on the areanode
        var selectNode = that.element.querySelector("[data-tajiri-selection]");
        pOutput.range.selectNode(selectNode);
        pSelection.removeAllRanges();
        pSelection.addRange(pOutput.range);
        selectNode.removeAttribute("data-tajiri-selection");
        that._createHistoryEntry(pOutput.plugin.getID());
      })["catch"](function (pOutput) {
        if (that.alive === false) {
          return;
        }
        pSelection.removeAllRanges();
        pSelection.addRange(pOutput.range);
      });
    }
  },
  //------------------------------------------------------------------------------------------------
  _addButton: function _addButton(pButton, pID) {
    var group = this.groups[pID];
    var span = null;
    if (!group) {
      span = document.createElement("span");
      span.setAttribute("group-id", pID);
      span.classList.add("button_group");
      this.groups[pID] = group = {
        span: span,
        buttons: [pButton]
      };
      var groupIDs = Object.keys(this.groups).map(function (i) {
        return parseInt(i);
      });
      groupIDs.sort(function (a, b) {
        return a - b; // sort numeric
      });

      var idx = groupIDs.indexOf(pID);
      if (groupIDs.length === 1) {
        this.toolbar.appendChild(span);
      } else if (idx < groupIDs.length - 1) {
        var next = groupIDs[idx + 1];
        next.span.parentNode.insertBefore(span, next.span);
      } else {
        this.groups[groupIDs[0]].span.parentNode.appendChild(span);
      }
    } else {
      span = group.span;
      group.buttons.push(pButton);
    }
    span.append(pButton);
  },
  //------------------------------------------------------------------------------------------------
  _initUndoButton: function _initUndoButton() {
    if (this.internalPlugins.undo.initialized) {
      return;
    }
    var that = this;
    var button = document.createElement("button");
    if (window.$ !== undefined && window.$.i18n !== undefined) {
      button.setAttribute("title", $.i18n._("nixps-tajiri.pluginundo_tooltip"));
    }
    var icon = document.createElement("span");
    icon.classList.add.apply(icon.classList, ["fa", "fa-undo"]);
    button.append(icon);
    button.addEventListener("click", function onClick(pEvent) {
      pEvent.preventDefault();
      var index = that._getCurrentHistoryIndex();
      if (index === that.history.array.length - 1 && that._getCurrentHistoryAction() !== "lastState" && that.area.textContent !== that.history.array[index].textcontent) {
        //save the last state if it's different from the last entry in our history
        //this state might not have been saved if the user has been typing/deleting extra 
        that._createHistoryEntry("lastState");
        index++;
      }
      if (index !== 0) {
        index--;
      }
      that._restoreHistoryEntryIndex(index);
    });
    this.internalPlugins.undo.button = button;
    this.internalPlugins.undo.initialized = true;
    this.internalPlugins.undo.activeShortcut = true;
    this._updateUndoRedoButtons();
  },
  //------------------------------------------------------------------------------------------------
  _initRedoButton: function _initRedoButton() {
    if (this.internalPlugins.redo.initialized) {
      return;
    }
    var that = this;
    var button = document.createElement("button");
    if (window.$ !== undefined && window.$.i18n !== undefined) {
      button.setAttribute("title", $.i18n._("nixps-tajiri.pluginredo_tooltip"));
    }
    var icon = document.createElement("span");
    icon.classList.add.apply(icon.classList, ["fa", "fa-repeat"]);
    button.append(icon);
    button.addEventListener("click", function onClick(pEvent) {
      pEvent.preventDefault();
      var index = that._getCurrentHistoryIndex();
      index++;
      that._restoreHistoryEntryIndex(index);
    });
    this.internalPlugins.redo.button = button;
    this.internalPlugins.redo.initialized = true;
    this.internalPlugins.redo.activeShortcut = true;
    this._updateUndoRedoButtons();
  },
  //------------------------------------------------------------------------------------------------
  _beginHistory: function _beginHistory(pText) {
    this.history = {
      currentIndex: 0,
      array: [{
        text: pText,
        action: "initial",
        textcontent: this.area.textContent
      }]
    };
    this._updateUndoRedoButtons();
    window.editorHistory = this.history;
  },
  //------------------------------------------------------------------------------------------------
  _createHistoryEntry: function _createHistoryEntry(pAction) {
    var that = this;
    var isSourceMode = this.plugins["Source"] !== undefined && this.plugins["Source"].plugin.isActive() === true;
    if (isSourceMode === true) {
      return;
    }
    var selection = this._getSelection();
    var range = selection.getRangeAt(0);
    var rangeCache = {
      start: range.startOffset,
      end: range.endOffset
    };
    var childIndexes = [];
    var startContainer = range.startContainer;
    var endContainer = range.endContainer;
    var selectionNode;
    [startContainer, endContainer].forEach(function (pSelectionContainer, pContainerIndex) {
      var suffix = pContainerIndex === 0 ? "start" : "end";
      if (startContainer === endContainer && pContainerIndex === 1) {
        //same start and end, did the correcting already for startcontainer so only need to add the attribute for end
        selectionNode.setAttribute("data-tajiri-selection-" + suffix, rangeCache[suffix]);
        childIndexes[pContainerIndex] = childIndexes[0];
        return;
      } else if (pSelectionContainer.nodeType === Node.TEXT_NODE) {
        if (pSelectionContainer.parentElement === that.area) {
          //text is direct child of rootNode - needs a wrap
          //save what childnode we need to set the selection back on
          that.area.childNodes.forEach(function (pChildNode, pIndex) {
            if (pChildNode === pSelectionContainer) {
              childIndexes[pContainerIndex] = pIndex;
            }
          });
          selectionNode = that._wrapTextInSpan(pSelectionContainer);
          selectionNode.setAttribute("data-tajiri-selection-remove", true);
        } else {
          if (pSelectionContainer.parentElement.childNodes.length > 1) {
            //need to wrap 
            pSelectionContainer.parentElement.childNodes.forEach(function (pChildNode, pIndex) {
              if (pChildNode === pSelectionContainer) {
                childIndexes[pContainerIndex] = pSelectionContainer;
              }
            });
            selectionNode = that._wrapTextInSpan(pSelectionContainer);
            selectionNode.setAttribute("data-tajiri-selection-remove", true);
          } else {
            //can add attributes on the parent
            childIndexes[pContainerIndex] = pSelectionContainer;
            selectionNode = pSelectionContainer.parentElement;
          }
        }
      } else {
        //just add attributes on the node
        childIndexes[pContainerIndex] = pSelectionContainer;
        selectionNode = pSelectionContainer;
      }
      selectionNode.setAttribute("data-tajiri-selection-" + suffix, rangeCache[suffix]);
    });
    var text = this.area.innerHTML;
    var textContent = this.area.textContent;
    var startContainer = this.element.querySelector("[data-tajiri-selection-start]");
    var endContainer = this.element.querySelector("[data-tajiri-selection-end]");
    if (startContainer !== null && endContainer !== null) {
      startContainer.removeAttribute("data-tajiri-selection-start");
      endContainer.removeAttribute("data-tajiri-selection-end");
      this._removeSelectionNode();
      childIndexes.forEach(function (pChild, pIndex) {
        if (pIndex === 0) {
          if (pChild.nodeType !== undefined) {
            range.setStart(pChild, rangeCache["start"]);
          } else {
            range.setStart(that.area.childNodes[pChild], rangeCache["start"]);
          }
        } else {
          if (pChild.nodeType !== undefined) {
            range.setEnd(pChild, rangeCache["end"]);
          } else {
            range.setEnd(that.area.childNodes[pChild], rangeCache["end"]);
          }
        }
      });
      selection.removeAllRanges();
      selection.addRange(range);
    }
    if (this.history.array[this.history.currentIndex] !== undefined && this.history.array[this.history.currentIndex].text !== undefined && this.history.array[this.history.currentIndex].text === text) {
      return;
    }
    this.history.currentIndex++;
    this.history.array[this.history.currentIndex] = {
      text: text,
      textcontent: textContent,
      action: pAction
    };
    this.history.array = this.history.array.slice(0, this.history.currentIndex + 1);
    this._updateUndoRedoButtons();
  },
  _wrapTextInSpan: function _wrapTextInSpan(pTextNode) {
    var newSpan = document.createElement("span");
    pTextNode.after(newSpan);
    newSpan.append(pTextNode);
    return newSpan;
  },
  _removeSelectionNode: function _removeSelectionNode() {
    var found = false;
    this.area.querySelectorAll("[data-tajiri-selection-remove]").forEach(function (pToRemove) {
      found = true;
      pToRemove.childNodes.forEach(function (pChild) {
        pToRemove.after(pChild);
      });
      pToRemove.parentElement.removeChild(pToRemove);
    });
    return found;
  },
  //------------------------------------------------------------------------------------------------
  _getCurrentHistoryIndex: function _getCurrentHistoryIndex() {
    return this.history.currentIndex;
  },
  _setCurrentHistoryIndex: function _setCurrentHistoryIndex(pIndex) {
    this.history.currentIndex = pIndex;
  },
  _getCurrentHistoryAction: function _getCurrentHistoryAction() {
    if (this.history.array[this._getCurrentHistoryIndex()] === undefined) {
      return "";
    }
    return this.history.array[this._getCurrentHistoryIndex()].action;
  },
  //------------------------------------------------------------------------------------------------
  _canRestoreHistoryIndex: function _canRestoreHistoryIndex(pIndex) {
    return pIndex >= 0 && pIndex < this.history.array.length;
  },
  //------------------------------------------------------------------------------------------------
  _restoreHistoryEntryIndex: function _restoreHistoryEntryIndex(pIndex) {
    var selection = this._getSelection();
    var range = selection.getRangeAt(0);
    if (!this._canRestoreHistoryIndex(pIndex)) {
      return false;
    }
    this.history.currentIndex = pIndex;
    this._applyStyleLater(this.area, this.history.array[this.history.currentIndex].text);
    var startContainer = this.area.querySelector("[data-tajiri-selection-start]");
    var endContainer = this.area.querySelector("[data-tajiri-selection-end]");
    if (startContainer === null || endContainer === null) {
      if (this.getContent().length > 0) {
        range.setStart(this.area.childNodes[0], this.area.childNodes[0].length);
        range.setEnd(this.area.childNodes[0], this.area.childNodes[0].length);
      } else {
        this.area.focus();
      }
    } else {
      var startContainerText = startContainer;
      if (startContainer.childNodes[0] !== undefined && startContainer.childNodes[0].nodeType === Node.TEXT_NODE) {
        startContainerText = startContainer.childNodes[0];
      }
      var endContainerText = endContainer;
      if (endContainer.childNodes[0] !== undefined && endContainer.childNodes[0].nodeType === Node.TEXT_NODE) {
        endContainerText = endContainer.childNodes[0];
      }
      var startOffset = startContainer.getAttribute("data-tajiri-selection-start");
      var endOffset = endContainer.getAttribute("data-tajiri-selection-end");
      startContainer.removeAttribute("data-tajiri-selection-start");
      endContainer.removeAttribute("data-tajiri-selection-end");
      this._removeSelectionNode();
      range.setStart(startContainerText, parseInt(startOffset));
      range.setEnd(endContainerText, parseInt(endOffset));
    }
    this._updateUndoRedoButtons();
    return true;
  },
  //------------------------------------------------------------------------------------------------
  _updateUndoRedoButtons: function _updateUndoRedoButtons() {
    this._setButtonEnabled(this.internalPlugins.undo.ID, this.history.currentIndex > 0);
    this._setButtonEnabled(this.internalPlugins.redo.ID, this.history.currentIndex < this.history.array.length - 1);
  },
  //------------------------------------------------------------------------------------------------
  _setButtonEnabled: function _setButtonEnabled(pPluginID, pFlag) {
    var that = this;
    var button = null;
    var found = false;
    Object.keys(this.internalPlugins).forEach(function (key) {
      var plugin = that.internalPlugins[key];
      if (plugin.ID !== pPluginID) {
        return;
      }
      plugin.enabled = pFlag;
      button = plugin.button;
      found = true;
    });
    if (!found) {
      var obj = this.plugins[pPluginID];
      button = obj && obj.button ? obj.button : null;
    }
    if (button) {
      if (pFlag) {
        button.removeAttribute("disabled");
      } else {
        button.setAttribute("disabled", true);
      }
    }
  },
  _disablePlugins: function _disablePlugins(pReason) {
    for (var pluginID in this.plugins) {
      if (Array.isArray(this.plugins[pluginID].disabled_reasons) && this.plugins[pluginID].disabled_reasons.indexOf(pReason) === -1) {
        this.plugins[pluginID].disabled_reasons.push(pReason);
      } else {
        this.plugins[pluginID].disabled_reasons = [pReason];
      }
    }
    this._updateUI(true);
  },
  _enablePlugins: function _enablePlugins(pReason) {
    for (var pluginID in this.plugins) {
      if (Array.isArray(this.plugins[pluginID].disabled_reasons)) {
        var index = this.plugins[pluginID].disabled_reasons.indexOf(pReason);
        if (index !== -1) {
          this.plugins[pluginID].disabled_reasons.splice(index, 1);
        }
      }
    }
    this._updateUI(true);
  },
  //------------------------------------------------------------------------------------------------
  _transformWithTextualPlugins: function _transformWithTextualPlugins(pHTML) {
    var html = pHTML;
    for (var pluginID in this.plugins) {
      if (this.plugins[pluginID].plugin instanceof TextualPlugin) {
        html = this.plugins[pluginID].plugin.transformToEdit(html);
      }
    }
    return html;
  },
  //------------------------------------------------------------------------------------------------
  _transformBackFromTextualPlugins: function _transformBackFromTextualPlugins(pHTML) {
    var html = pHTML;
    var dom = new DOMParser().parseFromString(pHTML, "text/html");
    _toConsumableArray(dom.querySelectorAll("[data-tajiri-template-value]")).forEach(function (pTemplate) {
      if (pTemplate.hasAttribute("style")) {
        var styleSpan = document.createElement("span");
        styleSpan.setAttribute("style", pTemplate.getAttribute("style"));
        pTemplate.setAttribute("style", "");
        pTemplate.parentNode.insertBefore(styleSpan, pTemplate);
        styleSpan.append(pTemplate);
      }
    });
    if (dom.body.querySelectorAll("ol, ul").length > 0) {
      var listElements = _toConsumableArray(dom.body.querySelectorAll("ol, ul"));
      listElements.forEach(function (listEl) {
        if (listEl.previousElementSibling !== null && ["div", "p"].includes(listEl.previousElementSibling.nodeName.toLowerCase())) {
          if (listEl.previousElementSibling.childNodes.length === 0) {
            listEl.previousElementSibling.remove();
          }
        }
        if (listEl.nextElementSibling !== null && ["div", "p"].includes(listEl.nextElementSibling.nodeName.toLowerCase())) {
          if (listEl.nextElementSibling.childNodes.length === 0) {
            listEl.nextElementSibling.remove();
          }
        }
      });
    }
    html = dom.body.innerHTML;
    for (var pluginID in this.plugins) {
      if (this.plugins[pluginID].plugin instanceof TextualPlugin) {
        html = this.plugins[pluginID].plugin.transformToSource(html);
      }
    }
    return html;
  },
  _normalizeBrTagsToNBSP: function _normalizeBrTagsToNBSP() {
    var that = this;
    if (this.options.enterMode.toLowerCase() === "BR") {
      return;
    }
    this.area.querySelectorAll("br").forEach(function (brTag) {
      if (brTag.closest(that.options.enterMode) !== null && brTag.closest(that.options.enterMode).textContent.length === 0) {
        brTag.closest(that.options.enterMode).innerHTML = "&nbsp;";
      }
    });
  },
  //------------------------------------------------------------------------------------------------
  _normalizeForUnknownTags: function _normalizeForUnknownTags(pText) {
    if (this.options.filterUnknownContent) {
      // filter out all excepted HTML tags, the content will stay as simple text
      var that = this;
      var tags = ["span", "p", "br", "div"];
      for (var pluginID in this.plugins) {
        if (this.plugins[pluginID].plugin && Array.isArray(this.plugins[pluginID].plugin.tags)) {
          tags = tags.concat(this.plugins[pluginID].plugin.tags);
        }
      }
      if (Array.isArray(tags) && tags.length > 0) {
        // make one reg exp of all excepted tags
        var execptedTags = new RegExp("^(?:" + tags.join("|") + ")$", "i");
        pText = pText.replace(/<[\/]?([a-zA-Z0-9\-]*)[^>]*>/ig, function (pMatch, p1) {
          if (!execptedTags.test(p1)) {
            // remove tag if unknown
            that._log("tag ", p1, " removed");
            // return "<span contenteditable='false' data-tajiri-unknowntag='"+ encodeURIComponent(pMatch)+ "' ><span>";
            return "";
          }
          return pMatch;
        });
      }
    }
    return pText;
  },
  //------------------------------------------------------------------------------------------------
  _applyStyleLater: function _applyStyleLater(pDOM, pText, pMode) {
    // some steps to apply on the csp restrictions
    // 1. move all styles to a customised data- attribute
    // 2. add to DOM
    // 3. apply all styles manually found in the data- attributes
    var found = false;
    //(\s[^>]*)? before and after style attr to capture all the other attributes
    pText = pText.replace(/<([a-zA-Z]*)(\s[^>]*)?\sstyle="([^"]*)"(\s[^>]*)?>/ig, function (pMatch, p1, p2, p3, p4, offset) {
      //a node might have no extra attributes - set to an empty string if the case
      p2 = p2 === undefined ? "" : p2;
      p4 = p4 === undefined ? "" : p4;
      found = true;
      if (typeof p3 === "string" && p3.length > 0) {
        return "<" + p1 + p2 + " data-tajiri-style=\"" + p3 + "\" " + p4 + ">";
      } else {
        // empty style attr
        return "<" + p1 + p2 + p4 + ">";
      }
    });
    if (pMode === "outerHTML") {
      pDOM.outerHTML = pText;
    } else {
      pDOM.innerHTML = pText;
    }
    if (found) {
      Utils.applyDataStyleToRealStyle(pDOM);
    }
  },
  _updateDisabledPlugins: function _updateDisabledPlugins(pPlugin) {
    var pluginID = this.plugins[pPlugin.getID()].plugin;
    var disabledIndex = this.plugins[pPlugin.getID()].disabled_reasons.indexOf(pluginID);
    if (typeof pluginID.mustBeDisabled === "function") {
      if (pluginID.mustBeDisabled() === true && disabledIndex === -1) {
        this.plugins[pPlugin.getID()].disabled_reasons.push(pluginID);
      } else if (pluginID.mustBeDisabled() === false) {
        this.plugins[pPlugin.getID()].disabled_reasons.splice(disabledIndex, 1);
      }
    }
  },
  _removeContenteditable: function _removeContenteditable(pRootNode) {
    var noEditNodes = pRootNode.querySelectorAll("[contenteditable='false']");
    noEditNodes.forEach(function (pNode) {
      pNode.setAttribute("contenteditable", true);
    });
  },
  _addContenteditable: function _addContenteditable(pRootNode) {
    var noEditNodes = pRootNode.querySelectorAll("[contenteditable='true']");
    noEditNodes.forEach(function (pNode) {
      pNode.setAttribute("contenteditable", false);
    });
  },
  /**------------------------------------------------------------------------------------------------
   * @description destroy the editor
   * @function
   * @name Editor#destroy
   * @returns {undefined}
   */
  destroy: function destroy() {
    // flag to inform that the component is destroyed
    this.alive = false;

    // stop the sellectionchange listerner
    clearTimeout(this._selectionTimeout);
    document.removeEventListener("selectionchange", this._bindSelectionChangeHandler);

    // run customised destroys of plugins
    for (var pluginID in this.plugins) {
      if (this.plugins[pluginID] !== undefined && this.plugins[pluginID].plugin !== undefined && typeof this.plugins[pluginID].plugin.destroy === "function") {
        this.plugins[pluginID].plugin.destroy(this.area);
      }
    }
    for (var cleanID in this.cleaners) {
      if (this.cleaners[cleanID] !== undefined && typeof this.cleaners[cleanID].destroy === "function") {
        this.cleaners[cleanID].destroy(this.area);
      }
    }
  },
  //------------------------------------------------------------------------------------------------
  _log: function _log() {
    if (this.options.debug === true) {
      var args = Array.prototype.slice.call(arguments).slice();
      var marker = "[Editor] ";
      args = [marker].concat(args);
      console.log.apply(console, args);
    }
  }
};
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = Editor;
}

},{"../../cloudflow/CloudflowUtil/js/GUID.js":89,"../Colorpicker/js/nixps-Colorpicker.js":286,"./Utils.js":321,"./js/cleaners/Cleaner.js":322,"./js/cleaners/DeprecatedTagCleaner.js":323,"./js/cleaners/DuplicateStyleCleaner.js":324,"./js/cleaners/EmptyStyleCleaner.js":325,"./js/cleaners/EnterModeCleaner.js":326,"./js/cleaners/ZeroWidthSpaceCleaner.js":327,"./js/nixps-cloudflow-TajiriContextMenu.js":333,"./js/plugins/ClickAndDragPlugin.js":338,"./js/plugins/LTRPlugin.js":356,"./js/plugins/Plugin.js":362,"./js/plugins/RTLPlugin.js":364,"./js/plugins/RemoveFormatPlugin.js":365,"./js/plugins/TextualPlugin.js":375}],321:[function(require,module,exports){
"use strict";

module.exports = {
  applyDataStyleToRealStyle: function applyDataStyleToRealStyle(pDOM) {
    pDOM.querySelectorAll("[data-tajiri-style]").forEach(function (pNode) {
      var styles = pNode.getAttribute("data-tajiri-style");
      if (typeof styles === "string") {
        styles.split(";").forEach(function (pCSSStyle) {
          if (typeof pCSSStyle === "string" && pCSSStyle.length > 0) {
            // TODO: add filtering if needed
            var selector = pCSSStyle.split(":")[0];
            var value = pCSSStyle.split(":")[1];
            pNode.style[selector.trim()] = value;
          }
        });
      }
      pNode.removeAttribute("data-tajiri-style");
    });
  },
  /**
   * @description Is the text arabic, must is be aligned right or not?
   * @function
   * @param {String} pText the text to check
   * @param {Boolean} pAtLeastOne must we fire if at least is one arabic
   * @returns Boolean true if text need to be aligned right
   */
  isTextRTL: function isTextRTL(pText, pAtLeastOne) {
    if (typeof pText !== "string") {
      throw new Error("Tajiri:_isTextRTL invalid parameter");
    }
    var rtlChars = /[\u0590-\u083F]|[\u08A0-\u08FF]|[\uFB1D-\uFDFF]|[\uFE70-\uFEFF]/mg;
    if (pText && pText.length > 0) {
      var matchedChars = pText.match(rtlChars);
      if (matchedChars === null) {
        return false;
      } else if (pAtLeastOne === true) {
        return matchedChars.length > 0;
      }
      return matchedChars.length / pText.length > 0.5;
    }
    return false;
  },
  _getTextNode: function _getTextNode(pArea) {
    var textNode = pArea;
    while (textNode.nodeType !== 3) {
      if (textNode.childNodes === undefined || textNode.childNodes.length === 0) {
        break;
      }
      textNode = textNode.childNodes[0];
    }
    return textNode;
  },
  selectSimpleText: function selectSimpleText(pArea, pStart, pStop) {
    var range = document.createRange();
    var sel = window.getSelection();
    var textNode = this._getTextNode(pArea);
    range.setStart(textNode, pStart);
    if (textNode.length < pStop) {
      range.setEnd(this._getTextNode(textNode.nextSibling), pStop - textNode.length);
    } else {
      range.setEnd(textNode, pStop);
    }
    sel.removeAllRanges();
    sel.addRange(range);
  },
  selectMultipleNodes: function selectMultipleNodes(pNodeOne, pNodeTwo, pStartOne, pEndTwo) {
    var range = document.createRange();
    var sel = window.getSelection();
    var textNodeOne = this._getTextNode(pNodeOne);
    var textNodeTwo = this._getTextNode(pNodeTwo);
    range.setStart(textNodeOne, pStartOne);
    range.setEnd(textNodeTwo, pEndTwo);
    sel.removeAllRanges();
    sel.addRange(range);
  },
  cleanLists: function cleanLists(pRootNode) {
    var that = this;
    var rootLists = pRootNode.querySelectorAll(":scope > ol, :scope > ul");
    rootLists.forEach(function (pRootList) {
      pRootList.querySelectorAll("li").forEach(function (pListItem) {
        var hasText = that._hasNodeText(pListItem);
        if (hasText === false) {
          pListItem.prepend(document.createTextNode("\u200B"));
        }
      });
      //the list should always start with an li, otherwise it's starting out with a nested li which we don't want
      while (pRootList.firstChild.nodeName.toLowerCase() !== "li") {
        var afterNode = pRootList.firstChild;
        while (pRootList.firstChild.childNodes.length > 0) {
          var moveNode = pRootList.firstChild.firstChild;
          afterNode.after(moveNode);
          afterNode = moveNode;
        }
        pRootList.removeChild(pRootList.firstChild);
      }
    });
  },
  _hasNodeText: function _hasNodeText(pNode) {
    var textNode = pNode;
    while (textNode.nodeType !== 3 && textNode.length > 0) {
      if (textNode.childNodes === undefined || textNode.childNodes.length === 0) {
        return false;
      }
      textNode = textNode.childNodes[0];
    }
    return true;
  },
  cleanEmptyStyles: function cleanEmptyStyles(pNode) {
    var toRemove = [];
    var toRemoveAttribute = [];
    var regexp = new RegExp(/<([a-zA-Z]*)(\s[^>]*)?\sstyle=""(\s[^>]*)?>/ig);
    for (var i = 0, len = pNode.childNodes.length; i < len; ++i) {
      var n = pNode.childNodes[i];
      if (n.nodeType === Node.ELEMENT_NODE) {
        // Maybe find a better way to check this?
        if (regexp.test(n.outerHTML)) {
          if (["span"].includes(n.nodeName.toLowerCase() === "span")) {
            toRemove.push(n);
          } else {
            toRemoveAttribute.push(n);
          }
        }
        this.cleanEmptyStyles(n);
      }
    }
    if (toRemove.length > 0) {
      this._log('removing', toRemove.length, ' useless span nodes');
    }
    toRemove.forEach(function (n) {
      var after = n;
      while (n.childNodes.length > 0) {
        var child = n.childNodes[0];
        n.parentNode.insertBefore(child, after.nextSibling);
        after = child;
      }
      n.remove();
    });
    toRemoveAttribute.forEach(function (n) {
      n.removeAttribute("style");
    });
    return pNode;
  },
  hasTextContent: function hasTextContent(pNode) {
    var hasTextContent = false;
    pNode.childNodes.forEach(function (pChildNode) {
      if (pChildNode.nodeType === Node.TEXT_NODE && pChildNode.length > 0) {
        hasTextContent = true;
      }
    });
    return hasTextContent;
  },
  removeZeroWidthSpaces: function removeZeroWidthSpaces(pNode) {
    var children = [];
    var affectedNodes = [];
    var walker = document.createTreeWalker(pNode, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      children.push(walker.currentNode);
    }
    children.forEach(function (pTextNode) {
      if (pTextNode.textContent.includes("\u200B") && pTextNode.parentElement.textContent.length > 1) {
        pTextNode.textContent = pTextNode.textContent.replaceAll(/\u200B/g, "");
        affectedNodes.push(pTextNode.parentElement);
      }
    });
    return affectedNodes;
  },
  isValidSelector: function isValidSelector(selector) {
    try {
      document.createDocumentFragment().querySelector(selector);
    } catch (fail) {
      console.error("Invalid css selector found: " + selector);
      return selector;
    }
    return true;
  }
};

},{}],322:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Abstract class to define HTML cleaners
 * 
 * a Node will be provided to the method 'clean' allowing the class to make any 
 * modification to remove useless part of the DOMElement
 */
var Cleaner = /*#__PURE__*/function () {
  function Cleaner() {
    _classCallCheck(this, Cleaner);
    if (this.constructor == Cleaner) {
      throw new Error("Abstract classes can't be instantiated.");
    }
  }

  /**------------------------------------------------------------------------------------------------
   * function to cleanify an HTMLNode
   * @param {Node} pNode the node to be cleaned
   * @returns {Node} the cleaned version of the node.
   */
  _createClass(Cleaner, [{
    key: "clean",
    value: function clean(pNode) {
      throw new Error("Method 'clean' must be implemented.");
    }

    /**------------------------------------------------------------------------------------------------
     * Utility function providing some logging ability, adding the cleaner's name as prefix
     */
  }, {
    key: "_log",
    value: function _log() {
      var args = Array.prototype.slice.call(arguments).slice();
      var id = '[' + this.constructor.name + ']: ';
      args = [id].concat(args);
      console.log.apply(console, args);
    }
  }]);
  return Cleaner;
}();
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = Cleaner;
}

},{}],323:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Cleaner = require("./Cleaner.js");
}
/**
 * Object implementing the Cleaner class to remove all deprecated nodes from a given element
 */
var DeprecatedTagCleaner = /*#__PURE__*/function (_Cleaner) {
  _inherits(DeprecatedTagCleaner, _Cleaner);
  var _super = _createSuper(DeprecatedTagCleaner);
  function DeprecatedTagCleaner() {
    var _this;
    _classCallCheck(this, DeprecatedTagCleaner);
    _this = _super.call(this);
    _this.fontSizeMap = {
      "0": "10px",
      "1": "10px",
      "2": "13px",
      "3": "16px",
      "4": "18px",
      "5": "24px",
      "6": "32px",
      "7": "48px"
    };
    return _this;
  }
  _createClass(DeprecatedTagCleaner, [{
    key: "getID",
    value: function getID() {
      return "DeprecatedTagCleaner";
    }

    /**------------------------------------------------------------------------------------------------
     * Change deprecated nodes to their alternatives
     * @param {Node} pNode the node to be cleaned
     * @returns {Node} the cleaned version of the node.
     */
  }, {
    key: "clean",
    value: function clean(pNode) {
      var that = this;
      ["basefont", "font", "big"].forEach(function (pToBeReplaced) {
        var replaceNodes = pNode.querySelectorAll(pToBeReplaced);
        replaceNodes.forEach(function (pReplaceNode) {
          var newNode = that._replaceTagname(pReplaceNode, "span");
          if (pToBeReplaced === "big") {
            newNode.style.fontSize = that.fontSizeMap["4"];
            pReplaceNode.replaceWith(newNode);
          }
          if (newNode.getAttribute("color") !== null) {
            newNode.style.color = newNode.getAttribute("color");
            newNode.innerHTML = pReplaceNode.innerHTML;
            newNode.removeAttribute("color");
            pReplaceNode.replaceWith(newNode);
          }
          if (newNode.getAttribute("face") !== null) {
            newNode.style.fontFamily = newNode.getAttribute("face");
            newNode.innerHTML = pReplaceNode.innerHTML;
            newNode.removeAttribute("face");
            pReplaceNode.replaceWith(newNode);
          }
          if (newNode.getAttribute("size") !== null) {
            var fontSize = newNode.getAttribute("size");
            //if it starts with a + or a -, that means it's relative to 3 (-3 and +3 are the max)
            if (fontSize.startsWith("+") || fontSize.startsWith("-")) {
              fontSize = "" + (3 + parseInt(fontSize));
            }
            var convertedFontsize = that.fontSizeMap["" + parseInt(newNode.getAttribute("size"))];
            newNode.style.fontSize = convertedFontsize;
            newNode.innerHTML = pReplaceNode.innerHTML;
            newNode.removeAttribute("size");
            pReplaceNode.replaceWith(newNode);
          }
        });
      });
    }
  }, {
    key: "_replaceTagname",
    value: function _replaceTagname(pNode, pTag) {
      var outer = pNode.outerHTML;
      var newTag;
      if (pNode.nodeType === Node.TEXT_NODE) {
        newTag = document.createElement(pTag);
        newTag.append(pNode);
      } else {
        // Replace opening tag
        var regex = new RegExp('<' + pNode.tagName, 'i');
        newTag = outer.replace(regex, '<' + pTag);

        // Replace closing tag
        regex = new RegExp('</' + pNode.tagName, 'i');
        newTag = newTag.replace(regex, '</' + pTag);
        var parser = new DOMParser();
        newTag = parser.parseFromString(newTag, "text/html").body.firstChild;
      }
      return newTag;
    }
  }]);
  return DeprecatedTagCleaner;
}(Cleaner);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = DeprecatedTagCleaner;
}

},{"./Cleaner.js":322}],324:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Cleaner = require("./Cleaner.js");
  var Utils = require("../../Utils.js");
}
/**
 * Object implementing the Cleaner class to remove all double styling from a node
 */
var DuplicateStyleCleaner = /*#__PURE__*/function (_Cleaner) {
  _inherits(DuplicateStyleCleaner, _Cleaner);
  var _super = _createSuper(DuplicateStyleCleaner);
  function DuplicateStyleCleaner(pOptions) {
    var _this;
    _classCallCheck(this, DuplicateStyleCleaner);
    _this = _super.call(this);
    _this.enterMode = pOptions.enterMode;
    return _this;
  }
  _createClass(DuplicateStyleCleaner, [{
    key: "getID",
    value: function getID() {
      return "DuplicateStyleCleaner";
    }
  }, {
    key: "clean",
    value: function clean(pNode) {
      var that = this;
      var rootLevelSpans = pNode.querySelectorAll(this.enterMode + " > span");
      rootLevelSpans.forEach(function (rootLevelSpan) {
        rootLevelSpan.childNodes.forEach(function (n) {
          if (n.nodeType === Node.TEXT_NODE && n.length > 0) {
            //rootlevel span is responsible for styling this text - no need to merge
            return;
          } else if (n.nodeType === Node.ELEMENT_NODE) {
            var styles = that._findTrueStyles(n);
            for (var style in styles) {
              var styleAttribute = n.getAttribute("data-tajiri-style") ? n.getAttribute("data-tajiri-style") : "";
              n.setAttribute("data-tajiri-style", styleAttribute + " " + style + ": " + styles[style] + ";");
            }
          }
        });
      });
      Utils.applyDataStyleToRealStyle(pNode);
    }
  }, {
    key: "_findTrueStyles",
    value: function _findTrueStyles(pNode) {
      var that = this;
      var currentStyleStyle = this._getStyleObject(pNode.getAttribute("style"));
      var children = pNode.querySelectorAll("span");
      children.forEach(function (pChild) {
        if (pChild.nodeType === Node.TEXT_NODE && pChild.length > 0) {
          //rootlevel span is responsible for styling this text - no need to merge
          return;
        } else if (pChild.nodeType === Node.ELEMENT_NODE) {
          var styles = that._getStyleObject(pChild.getAttribute("style"));
          currentStyleStyle = Object.assign({}, currentStyleStyle, styles);
        }
      });
      return currentStyleStyle;
    }
  }, {
    key: "_getStyleObject",
    value: function _getStyleObject(pString) {
      var object = {};
      if (pString === null) {
        return object;
      }
      pString.split(";").forEach(function (pCSSStyle) {
        if (typeof pCSSStyle === "string" && pCSSStyle.length > 0) {
          var selector = pCSSStyle.split(":")[0];
          var value = pCSSStyle.split(":")[1];
          object[selector] = value;
        }
      });
      return object;
    }
  }]);
  return DuplicateStyleCleaner;
}(Cleaner);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = DuplicateStyleCleaner;
}

},{"../../Utils.js":321,"./Cleaner.js":322}],325:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Cleaner = require("./Cleaner.js");
}
/**
 * Object implementing the Cleaner class to remove all span nodes which do not define any style from a given element
 */
var EmptyStyleCleaner = /*#__PURE__*/function (_Cleaner) {
  _inherits(EmptyStyleCleaner, _Cleaner);
  var _super = _createSuper(EmptyStyleCleaner);
  function EmptyStyleCleaner() {
    _classCallCheck(this, EmptyStyleCleaner);
    return _super.call(this);
  }
  _createClass(EmptyStyleCleaner, [{
    key: "getID",
    value: function getID() {
      return "EmptyStyleCleaner";
    }

    /**------------------------------------------------------------------------------------------------
     * Remove recursivly all span nodes without style from the node 'pNode' 
     * @param {Node} pNode the node to be cleaned
     * @returns {Node} the cleaned version of the node.
     */
  }, {
    key: "clean",
    value: function clean(pNode) {
      var toRemove = [];
      var toRemoveAttribute = [];
      var regexp = new RegExp(/<([a-zA-Z]*)(\s[^>]*)?\sstyle=""(\s[^>]*)?>/ig);
      for (var i = 0, len = pNode.childNodes.length; i < len; ++i) {
        var n = pNode.childNodes[i];
        if (n.nodeType === Node.ELEMENT_NODE) {
          // Maybe find a better way to check this?
          if (regexp.test(n.outerHTML)) {
            if (n.getAttribute("style") !== null && n.getAttribute("style").length === 0) {
              if (["span"].includes(n.nodeName.toLowerCase() === "span")) {
                toRemove.push(n);
              } else {
                toRemoveAttribute.push(n);
              }
            }
          }
          this.clean(n);
        }
      }
      if (toRemove.length > 0) {
        this._log('removing', toRemove.length, ' useless span nodes');
      }
      toRemove.forEach(function (n) {
        var after = n;
        while (n.childNodes.length > 0) {
          var child = n.childNodes[0];
          n.parentNode.insertBefore(child, after.nextSibling);
          after = child;
        }
        n.remove();
      });
      toRemoveAttribute.forEach(function (n) {
        n.removeAttribute("style");
      });
      return pNode;
    }
  }]);
  return EmptyStyleCleaner;
}(Cleaner);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = EmptyStyleCleaner;
}

},{"./Cleaner.js":322}],326:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Cleaner = require("./Cleaner.js");
}
/**
 * Object implementing the Cleaner class to remove all span nodes which do not define any style from a given element
 */
var EnterModeCleaner = /*#__PURE__*/function (_Cleaner) {
  _inherits(EnterModeCleaner, _Cleaner);
  var _super = _createSuper(EnterModeCleaner);
  function EnterModeCleaner(pOptions) {
    var _this;
    _classCallCheck(this, EnterModeCleaner);
    _this = _super.call(this);
    _this.enterMode = pOptions.enterMode;
    return _this;
  }
  _createClass(EnterModeCleaner, [{
    key: "getID",
    value: function getID() {
      return "EnterModeCleaner";
    }

    /**------------------------------------------------------------------------------------------------
     * Remove recursivly all span nodes without style from the node 'pNode' 
     * @param {Node} pNode the node to be cleaned
     * @returns {Node} the cleaned version of the node.
     */
  }, {
    key: "clean",
    value: function clean(pNode, selection) {
      var that = this;
      if (this.enterMode === "BR") {
        return pNode;
      }
      var toRemove = [];
      var groups = [];
      var currGroup = [];
      var possibleTags = ["p", "div", "h1", "h2", "h3", "pre", "ol", "ul", "table", "br"];
      pNode.childNodes.forEach(function (pChildNode) {
        if (pChildNode.nodeType === Node.TEXT_NODE || pChildNode.nodeName !== undefined && possibleTags.includes(pChildNode.nodeName.toLowerCase()) === false) {
          currGroup.push(pChildNode);
        } else {
          if (pChildNode.nodeName.toLowerCase() === "br" && currGroup.length > 0) {
            currGroup.push(pChildNode);
          } else if (currGroup.length > 0) {
            groups.push(currGroup);
            currGroup = [];
          }
        }
      });
      if (currGroup.length > 0) {
        groups.push(currGroup);
      }
      var range = selection.getRangeAt(0);
      var startContainer = range.startContainer;
      var endContainer = range.endContainer;
      var startOffset = range.startOffset;
      var endOffset = range.endOffset;
      groups.forEach(function (pGroup) {
        var newEnterTag = document.createElement(that.enterMode);
        pGroup[0].parentElement.insertBefore(newEnterTag, pGroup[0]);
        pGroup.forEach(function (pNode) {
          newEnterTag.append(pNode);
        });
      });
      if (startContainer.nodeType === Node.TEXT_NODE && endContainer.nodeType === Node.TEXT_NODE) {
        selection.removeAllRanges();
        range.setStart(startContainer, startOffset);
        range.setEnd(endContainer, endOffset);
        selection.addRange(range);
      }
      return pNode;
    }
  }]);
  return EnterModeCleaner;
}(Cleaner);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = EnterModeCleaner;
}

},{"./Cleaner.js":322}],327:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Cleaner = require("./Cleaner.js");
}
/**
 * Object implementing the Cleaner class to remove all empty nodes from a given element
 */
var ZeroWidthSpaceCleaner = /*#__PURE__*/function (_Cleaner) {
  _inherits(ZeroWidthSpaceCleaner, _Cleaner);
  var _super = _createSuper(ZeroWidthSpaceCleaner);
  function ZeroWidthSpaceCleaner() {
    _classCallCheck(this, ZeroWidthSpaceCleaner);
    return _super.call(this);
  }
  _createClass(ZeroWidthSpaceCleaner, [{
    key: "getID",
    value: function getID() {
      return "ZeroWidthSpaceCleaner";
    }

    /**------------------------------------------------------------------------------------------------
     * Remove recursivly all empty nodes from the node 'pNode' 
     * @param {Node} pNode the node to be cleaned
     * @returns {Node} the cleaned version of the node.
     */
  }, {
    key: "clean",
    value: function clean(pNode, pSelection) {
      var that = this;
      var clonedRange = pSelection && pSelection.rangeCount > 0 ? pSelection.getRangeAt(0).cloneRange() : null;
      var children = [];
      var walker = document.createTreeWalker(pNode, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        children.push(walker.currentNode);
      }
      children.forEach(function (pTextNode) {
        if (pTextNode.textContent.includes("\u200B") && pTextNode.textContent.length > 1) {
          if (clonedRange !== null && clonedRange.startContainer === pTextNode) {
            var offset = clonedRange.startOffset;
            var textBeforeOffset = pTextNode.textContent.substring(0, offset);
            var textAfterOffset = pTextNode.textContent.substring(offset);
            var newTextBeforeOffset = textBeforeOffset.replaceAll(/\u200B/g, "");
            var newTextAfterOffset = textAfterOffset.replaceAll(/\u200B/g, "");
            var newOffset = newTextBeforeOffset.length;
            pTextNode.textContent = newTextBeforeOffset + newTextAfterOffset;
            clonedRange.setStart(pTextNode, newOffset);
            clonedRange.setEnd(pTextNode, newOffset);
            pSelection.removeAllRanges();
            pSelection.addRange(clonedRange);
          } else {
            pTextNode.textContent = pTextNode.textContent.replaceAll(/\u200B/g, "");
          }
        }
      });
    }
  }]);
  return ZeroWidthSpaceCleaner;
}(Cleaner);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = ZeroWidthSpaceCleaner;
}

},{"./Cleaner.js":322}],328:[function(require,module,exports){
"use strict";

(function ($) {
  require("../../../../common/Colorpicker/js/nixps-Colorpicker.js");
  $.widget("nixps-cloudflow.CellPropertiesDialog", $.Widget, {
    version: "0.0.1",
    options: {
      language: "en",
      width: 0,
      widthUnit: "pixels",
      height: 0,
      heightUnit: "pixels",
      wordWrap: true,
      horizontalAlign: "",
      verticalAlign: "",
      cellType: "td",
      rowSpan: 1,
      colSpan: 1,
      backgroundColor: "",
      borderColor: "",
      close: function close() {},
      submit: function submit() {}
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._draw();
      this._on(this.element, {});
    },
    _draw: function _draw() {
      var that = this;
      var formJSON = {
        elements: [{
          "type": "component",
          "element": {
            "id": "error",
            "type": "ErrorMessage",
            "options": {}
          }
        }, {
          "type": "field",
          "element": {
            "key": "word-wrap",
            "label": $.i18n._("nixps-cloudflow-cellpropertiesdialog.wordwrap_label"),
            "component": {
              "id": "word-wrap",
              "type": "Input",
              "options": {
                "type": "checkbox",
                "value": this.options.wordWrap
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "horizontal-align",
            "label": $.i18n._("nixps-cloudflow-cellpropertiesdialog.horizontal_label"),
            "component": {
              "id": "horizontal-align",
              "type": "Select",
              "options": {
                "keyValues": {
                  "": $.i18n._("nixps-cloudflow-cellpropertiesdialog.option_none"),
                  "left": $.i18n._("nixps-cloudflow-cellpropertiesdialog.horizontal_option_left"),
                  "center": $.i18n._("nixps-cloudflow-cellpropertiesdialog.horizontal_option_center"),
                  "right": $.i18n._("nixps-cloudflow-cellpropertiesdialog.horizontal_option_right"),
                  "justify": $.i18n._("nixps-cloudflow-cellpropertiesdialog.horizontal_option_justify")
                },
                "default": this.options.horizontalAlign
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "vertical-align",
            "label": $.i18n._("nixps-cloudflow-cellpropertiesdialog.vertical_label"),
            "component": {
              "id": "vertical-align",
              "type": "Select",
              "options": {
                "keyValues": {
                  "": $.i18n._("nixps-cloudflow-cellpropertiesdialog.option_none"),
                  "top": $.i18n._("nixps-cloudflow-cellpropertiesdialog.vertical_option_top"),
                  "middle": $.i18n._("nixps-cloudflow-cellpropertiesdialog.vertical_option_middle"),
                  "bottom": $.i18n._("nixps-cloudflow-cellpropertiesdialog.vertical_option_bottom"),
                  "baseline": $.i18n._("nixps-cloudflow-cellpropertiesdialog.vertical_option_baseline")
                },
                "default": this.options.verticalAlign
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "cell-type",
            "label": $.i18n._("nixps-cloudflow-cellpropertiesdialog.celltype_label"),
            "component": {
              "id": "cell-type",
              "type": "Select",
              "options": {
                "keyValues": {
                  "td": $.i18n._("nixps-cloudflow-cellpropertiesdialog.celltype_option_data"),
                  "th": $.i18n._("nixps-cloudflow-cellpropertiesdialog.celltype_option_header")
                },
                "default": this.options.cellType
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "rowspan",
            "label": $.i18n._("nixps-cloudflow-cellpropertiesdialog.rowspan_label"),
            "component": {
              "id": "rowspan",
              "type": "Input",
              "options": {
                "type": "number",
                "value": this.options.rowSpan > 1 ? this.options.rowSpan : ""
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "colspan",
            "label": $.i18n._("nixps-cloudflow-cellpropertiesdialog.colspan_label"),
            "component": {
              "id": "colspan",
              "type": "Input",
              "options": {
                "type": "number",
                "value": this.options.colSpan > 1 ? this.options.colSpan : ""
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "background-color",
            "label": $.i18n._("nixps-cloudflow-cellpropertiesdialog.backgroundcolor_label"),
            "component": {
              "id": "background-color",
              "type": "Colorpicker",
              "options": {
                "showAlpha": false,
                "showPaletteOnly": false
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "border-color",
            "label": $.i18n._("nixps-cloudflow-cellpropertiesdialog.bordercolor_label"),
            "component": {
              "id": "border-color",
              "type": "Colorpicker",
              "options": {
                "showAlpha": false,
                "showPaletteOnly": false
              }
            }
          }
        }]
      };
      var content = $("<div>");
      var form = $("<div>").addClass("cellproperties-form");
      content.append(form);
      this.dialog = content.dialog({
        dialogClass: "cf-dialog nixps-cloudflow-CellPropertiesWindow noselect",
        classes: {
          "ui-dialog": "cf-dialog noselect"
        },
        closeText: "",
        width: 800,
        height: 500,
        minWidth: 550,
        minHeight: 500,
        maxHeight: 500,
        modal: true,
        title: $.i18n._("nixps-cloudflow-cellpropertiesdialog.title"),
        buttons: [{
          "text": $.i18n._("nixps-form-Button.cancel"),
          "class": "cf-button-secondary",
          click: function click() {
            $(this).remove();
            $(this).closest(".ui-dialog").remove();
            that.options.close();
          }
        }, {
          "text": $.i18n._("nixps-form-Button.edit"),
          "class": "cf-button-main",
          click: this._submitHandler.bind(that)
        }],
        close: function close() {
          $(this).remove();
          $(this).closest(".ui-dialog").remove();
          that.options.close();
        },
        resizeStop: function resizeStop(pEvent, pData) {
          content.css("width", "auto"); // fix width bug
        }
      });

      this.dialog.find(".cellproperties-form").FormRenderer({
        formJSON: formJSON,
        formClasses: "cf-form",
        labelBootstrapClass: "cf-col-sm-4",
        inputBootstrapClass: "cf-col-sm-3"
      });
      form.find("[data-id='background-color'] .nixps-Colorpicker").Colorpicker("setValue", this.options.backgroundColor);
      form.find("[data-id='border-color'] .nixps-Colorpicker").Colorpicker("setValue", this.options.borderColor);
      form.find("form [data-id=error]").after($("<div>").addClass("cf-form-group").append($("<label>").addClass("cf-form-label cf-form-mainlabel cf-col-sm-4").text($.i18n._("nixps-cloudflow-cellpropertiesdialog.width_label"))).append($("<div>").attr("data-key", "width").Input({
        type: "number",
        min: 0,
        value: this.options.width > 0 ? this.options.width : undefined,
        classes: "inputComponent form-control cf-form-control"
      }).addClass("cf-col-sm-2 cf-col-4")).append($("<label>").addClass("cf-col-sm-offset-1 cf-col-offset-1 dimension-label").text($.i18n._("nixps-cloudflow-cellpropertiesdialog.unit_label"))).append($("<div>").attr("data-key", "width-unit").Select({
        keyValues: {
          "pixels": $.i18n._("nixps-cloudflow-cellpropertiesdialog.pixels_option"),
          "percent": $.i18n._("nixps-cloudflow-cellpropertiesdialog.percent_option")
        },
        classes: "inputComponent form-control cf-form-control",
        "default": this.options.widthUnit
      }).css("display", "inline-block")), $("<div>").addClass("cf-form-group").append($("<label>").addClass("cf-form-label cf-form-mainlabel cf-col-sm-4").text($.i18n._("nixps-cloudflow-cellpropertiesdialog.height_label"))).append($("<div>").attr("data-key", "height").Input({
        type: "number",
        min: 0,
        value: this.options.height > 0 ? this.options.height : undefined,
        classes: "inputComponent form-control cf-form-control"
      }).addClass("cf-col-sm-2 cf-col-4")).append($("<label>").addClass("cf-col-sm-offset-1 cf-col-offset-1 dimension-label").text($.i18n._("nixps-cloudflow-cellpropertiesdialog.unit_label"))).append($("<div>").attr("data-key", "height-unit").Select({
        keyValues: {
          "pixels": $.i18n._("nixps-cloudflow-cellpropertiesdialog.pixels_option"),
          "percent": $.i18n._("nixps-cloudflow-cellpropertiesdialog.percent_option")
        },
        classes: "inputComponent form-control cf-form-control",
        "default": this.options.heightUnit
      }).css("display", "inline-block")));
    },
    _submitHandler: function _submitHandler(pEvent) {
      var form = this.dialog.find(".cellproperties-form");
      var isValid = form.FormRenderer("isValid");
      if (isValid === false) {
        return;
      }
      var values = form.FormRenderer("getValues");
      var width = form.find("[data-key=width].nixps-cloudflow-Input").Input("getValue");
      var widthUnit = form.find("[data-key=width-unit].nixps-cloudflow-Select").Select("getValue");
      if (widthUnit === "pixels" && width > 0) {
        values["width"] = width + "px";
      } else {
        values["width"] = width + "%";
      }
      if (width === null) {
        values["width"] = undefined;
      }
      var height = form.find("[data-key=height].nixps-cloudflow-Input").Input("getValue");
      var heightUnit = form.find("[data-key=height-unit].nixps-cloudflow-Select").Select("getValue");
      if (heightUnit === "pixels" && height > 0) {
        values["height"] = height + "px";
      } else {
        values["height"] = height + "%";
      }
      if (height === null) {
        values["height"] = undefined;
      }
      this.dialog.remove();
      this.dialog.closest(".ui-dialog").remove();
      this.options.submit(pEvent, values);
    },
    redraw: function redraw() {
      this._draw();
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
      });
      this._controlOptions();
      if (needRedraw === true) {
        this.redraw();
      }
    },
    _setOption: function _setOption(key, value) {},
    _controlOptions: function _controlOptions() {
      if (typeof this.options.width !== "number") {
        throw new Error("CellPropertiesDialog: option width must be a number");
      }
      if (typeof this.options.height !== "number") {
        throw new Error("CellPropertiesDialog: option height must be a number");
      }
      if (["pixels", "percent"].includes(this.options.widthUnit) === false) {
        throw new Error("CellPropertiesDialog: option widthUnit must be either 'pixels' or 'percent'");
      }
      if (["pixels", "percent"].includes(this.options.heightUnit) === false) {
        throw new Error("CellPropertiesDialog: option heightUnit must be either 'pixels' or 'percent'");
      }
      if (typeof this.options.wordWrap !== "boolean") {
        throw new Error("CellPropertiesDialog: option wordWrap must be a boolean");
      }
      if (["", "left", "center", "right", "justify"].includes(this.options.horizontalAlign) === false) {
        throw new Error("CellPropertiesDialog: option horizontalAlign must be either an empty string, 'left', 'center', 'right' or 'justify'");
      }
      if (["", "top", "middle", "bottom", "baseline"].includes(this.options.verticalAlign) === false) {
        throw new Error("CellPropertiesDialog: option verticalAlign must be either an empty string, 'top', 'middle', 'bottom' or 'baseline'");
      }
      if (["td", "th"].includes(this.options.cellType) === false) {
        throw new Error("CellPropertiesDialog: option cellType must be either 'td' or 'th'");
      }
      if (typeof this.options.rowSpan !== "number") {
        throw new Error("CellPropertiesDialog: option rowSpan must be a number");
      }
      if (typeof this.options.colSpan !== "number") {
        throw new Error("CellPropertiesDialog: option colSpan must be a number");
      }
      if (typeof this.options.borderColor !== "string") {
        throw new Error("CellPropertiesDialog: option borderColor must be a string");
      }
      if (typeof this.options.backgroundColor !== "string") {
        throw new Error("CellPropertiesDialog: option backgroundColor must be a string");
      }
      if (this.options.borderColor.length <= 0) {
        this.options.borderColor = null;
      }
      if (this.options.backgroundColor.length <= 0) {
        this.options.backgroundColor = null;
      }
      if (typeof this.options.close !== "function") {
        throw new Error("CellPropertiesDialog: option close must be a function");
      }
      if (typeof this.options.submit !== "function") {
        throw new Error("CellPropertiesDialog: option submit must be a function");
      }
    },
    _destroy: function _destroy() {
      if (this.dialog !== undefined && this.dialog !== null) {
        this.dialog.remove();
        this.dialog.closest(".ui-dialog").remove();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../../common/Colorpicker/js/nixps-Colorpicker.js":286}],329:[function(require,module,exports){
"use strict";

(function ($) {
  $.widget("nixps-cloudflow.HyperLinkDialog", $.Widget, {
    version: "0.0.1",
    options: {
      language: "en",
      /**
       * @name nixps-cloudflow.HyperLinkDialog#submit
       * @description Function that fires after the user submits the configuration for a link
       * @type {Function}
       * @default function() {}
       */
      submit: function submit() {},
      /**
       * @name nixps-cloudflow.HyperLinkDialog#close
       * @description Function that fires after the user closes the dialog
       * @type {Function}
       * @default function() {}
       */
      close: function close() {},
      /**
       * @name nixps-cloudflow.HyperLinkDialog#linkText
       * @description The linktext that should be shown on draw, if user already had text selected
       * @type {String}
       * @default ""
       */
      linkText: "",
      /**
       * @name nixps-cloudflow.HyperLinkDialog#linkType
       * @description the type of link the dialog has to open for, can be ["url", "phone", "email"]
       * @type {String}
       * @default null
       */
      linkType: "url",
      /**
       * @name nixps-cloudflow.HyperLinkDialog#URI
       * @description the URI that will be filled in, in the URL input
       * @type {String}
       * @default ""
       */
      URI: "",
      /**
       * @name nixps-cloudflow.HyperLinkDialog#emailSubject
       * @description in case the link we want to edit is an email link, this will contain the email's subject
       * @type {String}
       * @default ""
       */
      emailSubject: "",
      /**
       * @name nixps-cloudflow.HyperLinkDialog#emailBody
       * @description in case the link we want to edit is an email link, this will contain the email's body
       * @type {String}
       * @default ""
       */
      emailBody: "",
      /**
       * @name nixps-cloudflow.HyperLinkDialog#urlProtocol
       * @description in case the link we want to edit is generic, this will contain the url's protocol
       * ["http://", "https://", "ftp://", "news://", "other"]
       * @type {String}
       * @default ""
       */
      urlProtocol: "http://",
      /**
       * @name nixps-cloudflow.HyperLinkDialog#editing
       * @description whether we're editing a hyperlink or creating a new one
       * @type {Boolean}
       * @default false
       */
      editing: false
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.content;
      this.dialog;
      this.formState = {};
      this._draw();
      this._on(this.dialog, {
        'change [data-key="link-type"] select': this._linkTypeChangeHandler
      });
    },
    _draw: function _draw() {
      var that = this;
      var baseForm = {
        elements: [{
          "type": "component",
          "element": {
            "id": "error",
            "type": "ErrorMessage",
            "options": {}
          }
        }, {
          "type": "field",
          "element": {
            "key": "linktext",
            "label": $.i18n._("nixps-cloudflow-hyperlinkdialog.linktext_label"),
            "component": {
              "id": "linktext",
              "type": "Input",
              "options": {
                value: this.options.linkText
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "link-type",
            "label": $.i18n._("nixps-cloudflow-hyperlinkdialog.linktype_label"),
            "component": {
              "id": "link-type",
              "type": "Select",
              "options": {
                "keyValues": {
                  url: $.i18n._("nixps-cloudflow-hyperlinkdialog.linktype_option_url"),
                  phone: $.i18n._("nixps-cloudflow-hyperlinkdialog.linktype_option_phone"),
                  email: $.i18n._("nixps-cloudflow-hyperlinkdialog.linktype_option_email")
                },
                "default": "url"
              }
            }
          }
        }]
      };

      //we add the extra URL-specific inputs for the form later (special layout)
      this.URLFormJSON = $.extend(true, {}, baseForm);

      //extend for phone link
      baseForm.elements[baseForm.elements.length - 1].element.component.options["default"] = "phone";
      baseForm.elements.push({
        "type": "field",
        "element": {
          "key": "uri-phone",
          "label": $.i18n._("nixps-cloudflow-hyperlinkdialog.linktype_option_phone"),
          "component": {
            "id": "uri-phone",
            "type": "Input",
            "options": {
              "value": this.options.URI
            }
          },
          "required": true
        }
      });
      this.phoneFormJSON = $.extend(true, {}, baseForm);
      baseForm.elements.pop();

      //extend for email link
      baseForm.elements[baseForm.elements.length - 1].element.component.options["default"] = "email";
      baseForm.elements.push({
        "type": "field",
        "element": {
          "key": "uri-email",
          "label": $.i18n._("nixps-cloudflow-hyperlinkdialog.linktype_option_email"),
          "component": {
            "id": "uri-email",
            "type": "Input",
            "options": {
              "value": this.options.URI
            }
          },
          "required": true
        }
      }, {
        "type": "field",
        "element": {
          "key": "email-subject",
          "label": $.i18n._("nixps-cloudflow-hyperlinkdialog.emailsubject_label"),
          "component": {
            "id": "email-subject",
            "type": "Input",
            "options": {
              value: this.options.emailSubject
            }
          }
        }
      }, {
        "type": "field",
        "element": {
          "key": "email-body",
          "label": $.i18n._("nixps-cloudflow-hyperlinkdialog.emailbody_label"),
          "component": {
            "id": "email-body",
            "type": "Input",
            "options": {
              type: "textarea",
              value: this.options.emailBody,
              rows: 6
            }
          }
        }
      });
      this.emailFormJSON = $.extend(true, {}, baseForm);
      baseForm.elements.pop();
      var formJSON = {};
      if (this.options.linkType === "phone") {
        formJSON = this.phoneFormJSON;
      } else if (this.options.linkType === "email") {
        formJSON = this.emailFormJSON;
      } else if (this.options.linkType === "url") {
        formJSON = this.URLFormJSON;
      }
      this.content = $("<div>");
      var linkForm = $("<div>").FormRenderer({
        formJSON: formJSON,
        formClasses: "cf-form",
        labelBootstrapClass: "cf-col-sm-4",
        inputBootstrapClass: "cf-col-sm-3"
      }).addClass("link-form");
      if (this.options.linkType === "email") {
        //set the email, subject and body inputs all to longer length
        linkForm.find("[data-key='uri-email'] .nixps-cloudflow-Input").removeClass("cf-col-sm-3").addClass("cf-col-sm-6");
        linkForm.find("[data-key='email-subject'] .nixps-cloudflow-Input").removeClass("cf-col-sm-3").addClass("cf-col-sm-6");
        linkForm.find("[data-key='email-body'] .nixps-cloudflow-Input").removeClass("cf-col-sm-3").addClass("cf-col-sm-6");
      } else if (this.options.linkType === "url") {
        //add URL-specific inputs, wiht the special layout
        linkForm.find("form").append($("<div>").addClass("cf-form-group").append($("<label>").addClass("cf-form-label cf-form-mainlabel cf-col-sm-4").text($.i18n._("nixps-cloudflow-hyperlinkdialog.linkprotocol_label"))).append($("<div>").attr("data-key", "uri-protocol").Select({
          keyValues: {
            "http://": "http://",
            "https://": "https://",
            "ftp://": "ftp://",
            "news://": "news://",
            "other": "other"
          },
          classes: "cf-form-control",
          "default": this.options.urlProtocol
        }).addClass("cf-col-sm-2 cf-col-4")).append($("<label>").addClass("cf-col-sm-offset-1 cf-col-offset-1").text($.i18n._("nixps-cloudflow-hyperlinkdialog.linkurl_label"))).append($("<div>").attr("data-key", "uri-url").Input({
          classes: "cf-form-inputtype",
          value: this.options.URI
        }).css("display", "inline-block")));
      }
      this.content.append(linkForm);
      var transPrimarySuffix = "";
      if (this.options.editing === true) {
        transPrimarySuffix = "edit";
      } else {
        transPrimarySuffix = "add";
      }
      this.dialog = this.content.dialog({
        dialogClass: "cf-dialog nixps-cloudflow-HyperLinkWindow noselect",
        classes: {
          "ui-dialog": "cf-dialog noselect"
        },
        closeText: "",
        width: 550,
        height: 200,
        minWidth: 550,
        minHeight: 200,
        maxHeight: 800,
        modal: true,
        title: $.i18n._("nixps-cloudflow-hyperlinkdialog.title"),
        buttons: [{
          "text": $.i18n._("nixps-form-Button.cancel"),
          "class": "cf-button-secondary",
          click: function click() {
            $(this).remove();
            $(this).closest(".ui-dialog").remove();
            that.options.close();
          }
        }, {
          "text": $.i18n._("nixps-form-Button." + transPrimarySuffix),
          "class": "cf-button-main",
          click: this._submitHandler.bind(that)
        }],
        close: function close() {
          $(this).remove();
          $(this).closest(".ui-dialog").remove();
          that.options.close();
        },
        resizeStop: function resizeStop(pEvent, pData) {
          that.content.css("width", "auto"); // fix width bug
        }
      });

      //set the dialog to a greater width when email type
      if (this.options.linkType === "email") {
        this.dialog.dialog("option", "height", 375);
      }
    },
    _linkTypeChangeHandler: function _linkTypeChangeHandler(pEvent, pData) {
      if (pData === undefined) {
        var type = $(pEvent.target.closest(".nixps-cloudflow-Select")).Select("getValue");
      } else {
        var type = pData;
      }

      //cache the values for uri  & protocol of URL type 
      var form = this.dialog.find(".link-form");
      var uriValue = form.find("[data-key='uri-url']").Input("getValue");
      if (this.uri !== uriValue && uriValue.length > 0) {
        this.uri = uriValue;
      }
      var protocolValue = form.find("[data-key='uri-protocol']").Select("getValue");
      if (this.protocol !== protocolValue && protocolValue.length > 0) {
        this.protocol = protocolValue;
      }

      //cache formstate
      this.formState = $.extend(this.formState, form.FormRenderer("getValues"), {
        "uri-url": this.uri,
        "uri-protocol": this.protocol
      });
      this.dialog.dialog("option", "height", 200);
      switch (type) {
        case "url":
          {
            form.FormRenderer("option", "formJSON", this.URLFormJSON);
            form.FormRenderer("setValues", this.formState);
            //append the group with select + input for type URL
            form.find("form").append($("<div>").addClass("cf-form-group").append($("<label>").addClass("cf-form-label cf-form-mainlabel cf-col-sm-4").text($.i18n._("nixps-cloudflow-hyperlinkdialog.linkprotocol_label"))).append($("<div>").attr("data-key", "uri-protocol").Select({
              keyValues: {
                "http://": "http://",
                "https://": "https://",
                "ftp://": "ftp://",
                "news://": "news://",
                "other": "other"
              },
              classes: "cf-form-control",
              "default": this.formState["uri-protocol"]
            }).addClass("cf-col-sm-2 cf-col-4")).append($("<label>").addClass("cf-col-sm-offset-1 cf-col-offset-1").text($.i18n._("nixps-cloudflow-hyperlinkdialog.linkurl_label"))).append($("<div>").attr("data-key", "uri-url").Input({
              classes: "cf-form-inputtype",
              value: this.formState["uri-url"]
            }).css("display", "inline-block")));
            break;
          }
        case "phone":
          {
            form.FormRenderer("option", "formJSON", this.phoneFormJSON);
            form.FormRenderer("setValues", this.formState);
            if (this.formState["uri-phone"] === undefined || this.formState["uri-phone"].length <= 0) {
              form.find("[data-key='uri-phone'] input").closest(".nixps-cloudflow-Input").Input("setValue", "");
            }
            break;
          }
        case "email":
          {
            form.FormRenderer("option", "formJSON", this.emailFormJSON);
            form.FormRenderer("setValues", this.formState);
            if (this.formState["uri-email"] === undefined || this.formState["uri-email"].length <= 0) {
              form.find("[data-key='uri-email'] input").closest(".nixps-cloudflow-Input").Input("setValue", "");
            }
            form.find("[data-key='uri-email'] .nixps-cloudflow-Input").removeClass("cf-col-sm-3").addClass("cf-col-sm-6");
            form.find("[data-key='email-subject'] .nixps-cloudflow-Input").removeClass("cf-col-sm-3").addClass("cf-col-sm-6");
            form.find("[data-key='email-body'] .nixps-cloudflow-Input").removeClass("cf-col-sm-3").addClass("cf-col-sm-6");
            this.dialog.dialog("option", "height", 375);
            break;
          }
      }
    },
    _submitHandler: function _submitHandler(pEvent) {
      var isValid = this.dialog.find(".link-form").FormRenderer("getValues");
      if (isValid === false) {
        return;
      }
      var values = this.dialog.find(".link-form").FormRenderer("getValues");
      if (values["link-type"] === "email") {
        values.uri = "mailto:" + values["uri-email"] + "?subject=" + values["email-subject"] + "&body=" + values["email-body"];
        //change all enters to escaped enters
        values.uri = values.uri.replaceAll("\n", "%0D%0A");
        if (values.linktext <= 0) {
          values.linktext = values["uri-email"];
        }
      } else if (values["link-type"] === "phone") {
        values.uri = "tel:" + values["uri-phone"];
      } else if (values["link-type"] === "url") {
        //make combination of the protocl + url
        var uri = this.dialog.find(".link-form").find("[data-key='uri-url']").Input("getValue");
        var protocol = this.dialog.find(".link-form").find("[data-key='uri-protocol']").Select("getValue");
        if (protocol === "other") {
          protocol = "";
        }
        values.uri = protocol + uri;
      }
      this.dialog.remove();
      this.dialog.closest(".ui-dialog").remove();
      this.options.submit(pEvent, values);
    },
    redraw: function redraw() {
      this._draw();
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
      });
      this._controlOptions();
      if (needRedraw === true) {
        this.redraw();
      }
    },
    _setOption: function _setOption(key, value) {
      if (key === "submit") {
        this.options.submit = value;
        return false;
      }
      if (key === "close") {
        this.options.close = value;
        return false;
      }
      if (key === "linkText") {
        this.options.linkText = value;
        this.dialog.find("[data-key='linktext'] .nixps-cloudflow-Input").Input("setValue", value);
        return false;
      }
      if (key === "linkType") {
        this.options.linkType = value;
        this.dialog.find("[data-key='link-type'] .nixps-cloudflow-Select").Select("setValue", value);
        this._linkTypeChangeHandler(null, value);
        return false;
      }
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.linkText !== "string") {
        throw new Error("HyperLinkDialog: option linktText must be a string");
      }
      var linkTypes = ["url", "phone", "email"];
      if (linkTypes.includes(this.options.linkType) === false) {
        throw new Error("HyperLinkDialog: option linkType must be one of the following values: " + linkTypes);
      }
      if (typeof this.options.submit !== "function") {
        throw new Error("HyperLinkDialog: option submit must be a function");
      }
      if (typeof this.options.close !== "function") {
        throw new Error("HyperLinkDialog: option close must be a function");
      }
      if (typeof this.options.URI !== "string") {
        throw new Error("HyperLinkDialog: option URI must be a string");
      }
      var urlProtocol = ["http://", "https://", "news://", "ftp://", "other"];
      if (urlProtocol.includes(this.options.urlProtocol) === false) {
        throw new Error("HyperLinkDialog: option urlProtocol must be one of the following values:" + urlProtocol);
      }
      if (typeof this.options.emailSubject !== "string") {
        throw new Error("HyperLinkDialog: option emailSubject must be a string");
      }
      if (typeof this.options.emailBody !== "string") {
        throw new Error("HyperLinkDialog: option emailBody must be a string");
      }
      if (typeof this.options.editing !== "boolean") {
        throw new Error("HyperLinkDialog: option editing must be a boolean");
      }
    },
    _destroy: function _destroy() {
      if (this.dialog !== undefined) {
        this.dialog.remove();
        this.dialog.closest(".ui-dialog").remove();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],330:[function(require,module,exports){
"use strict";

(function ($) {
  $.widget("nixps-cloudflow.ImagePluginDialog", $.Widget, {
    version: "0.0.1",
    options: {
      language: "en",
      /**
       * @name nixps-cloudflow.ImagePluginDialog#imageOptions
       * @description the options for an image we want to edit
       * @type {Object}
       * @default {}
       */
      imageOptions: {
        uri: "",
        altText: "",
        alignment: "none"
      },
      /**
       * @name nixps-cloudflow.ImagePluginDialog#close
       * @description Function that fires after the user closes the dialog
       * @type {Function}
       * @default function() {}
       */
      close: function close() {},
      /**
       * @name nixps-cloudflow.ImagePluginDialog#submit
       * @description Function that fires after the user submits the configuration for an image
       * @type {Function}
       * @default function() {}
       */
      submit: function submit() {},
      /**
       * @name nixps-cloudflow.ImagePluginDialog#editing
       * @description Boolean that informs the component if we are editing an image or not
       * @type {Boolean}
       * @default false
       */
      editing: false
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.dialog;
      this.previewimg;
      this.imageForm;
      this.outOfRatio = false;
      if (this.imageRatio === undefined) {
        this.imageRatio = 1;
      }
      this.initialLoad = true;
      this._draw();
      this._setInitialValues(this.imageForm, this.previewimg);
      this._on(this.dialog, {
        "blur [data-key='uri'] input": this._uriBlurHandler,
        "blur [data-key='altText'] input": this._altBlurHandler,
        "keyup [data-key='border'] input": this._borderChangeHandler,
        "keyup [data-key='vspace'] input": this._marginChangeHandler,
        "keyup [data-key='hspace'] input": this._marginChangeHandler,
        "keyup [data-key='height'] input": this._dimensionChangeHandler,
        "keyup [data-key='width'] input": this._dimensionChangeHandler,
        "change [data-key='alignment'] select": this._alignmentChangeHandler,
        "change [data-key='ratio'] input": this._lockratioChangeHandler,
        "click [data-action='reset-dimensions']": this._clickResetDimensionsHandler
      });
    },
    _draw: function _draw() {
      var that = this;
      var formJSON = {
        elements: [{
          "type": "component",
          "element": {
            "id": "error",
            "type": "ErrorMessage",
            "options": {}
          }
        }, {
          "type": "field",
          "element": {
            "key": "uri",
            "label": $.i18n._("nixps-cloudflow-imageplugindialog.imageurl_label"),
            "component": {
              "id": "uri",
              "type": "Input",
              "options": {}
            },
            "required": true
          }
        }, {
          "type": "field",
          "element": {
            "key": "altText",
            "label": $.i18n._("nixps-cloudflow-imageplugindialog.imagealt_label"),
            "component": {
              "id": "altText",
              "type": "Input",
              "options": {}
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "width",
            "label": $.i18n._("nixps-cloudflow-imageplugindialog.imagewidth_label"),
            "component": {
              "id": "width",
              "type": "Input",
              "options": {}
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "height",
            "label": $.i18n._("nixps-cloudflow-imageplugindialog.imageheight_label"),
            "component": {
              "id": "height",
              "type": "Input",
              "options": {}
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "ratio",
            "label": $.i18n._("nixps-cloudflow-imageplugindialog.imageratio_label"),
            "component": {
              "id": "ratio",
              "type": "Input",
              "options": {
                type: "checkbox",
                value: true
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "border",
            "label": $.i18n._("nixps-cloudflow-imageplugindialog.imageborder_label"),
            "component": {
              "id": "border",
              "type": "Input",
              "options": {
                "type": "number",
                "min": 0,
                "value": 0
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "hspace",
            "label": $.i18n._("nixps-cloudflow-imageplugindialog.imagehspace_label"),
            "component": {
              "id": "hspace",
              "type": "Input",
              "options": {
                "type": "number",
                "min": 0,
                "value": 0
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "vspace",
            "label": $.i18n._("nixps-cloudflow-imageplugindialog.imagevspace_label"),
            "component": {
              "id": "vspace",
              "type": "Input",
              "options": {
                "type": "number",
                "min": 0,
                "value": 0
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "alignment",
            "label": $.i18n._("nixps-cloudflow-imageplugindialog.imagefloat_label"),
            "component": {
              "id": "alignment",
              "type": "Select",
              "options": {
                "keyValues": {
                  none: "None",
                  left: "Left",
                  right: "Right"
                }
              }
            }
          }
        }]
      };
      var content = $("<div>");
      this.imageForm = $("<div>").FormRenderer({
        formJSON: formJSON,
        formClasses: "cf-form",
        labelBootstrapClass: "cf-col-sm-4",
        inputBootstrapClass: "cf-col-sm-3"
      }).addClass("image-form");
      //some adapting for layout purposes
      this.imageForm.find("[data-key='ratio'] .nixps-cloudflow-Input").append($("<div>").CloudflowButton({
        classes: "cf-button-secondary",
        action: "reset-dimensions",
        icon: "fa fa-undo",
        tooltip: $.i18n._("nixps-form-Button.reset")
      }));
      this.imageForm.find("[data-key='uri'] .nixps-cloudflow-Input").removeClass("cf-col-sm-3").addClass("cf-col-sm-7");
      this.imageForm.find("[data-key='altText'] .nixps-cloudflow-Input").removeClass("cf-col-sm-3").addClass("cf-col-sm-7");
      content.append(this.imageForm);
      var preview = $("<div>").addClass("imagedialog-preview");
      this.previewimg = $("<img>");
      preview.append(this.previewimg);
      preview.append("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam maximus lectus dui, tempus elementum est sagittis id. Quisque aliquam, ipsum sit amet suscipit ultricies, mauris sapien scelerisque felis, vitae scelerisque odio est a leo. Vivamus metus libero, feugiat eget consequat vel, varius eget dolor. Suspendisse potenti. Sed eu tristique arcu, vel tincidunt nisl. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos");
      content.append(preview);
      var transPrimarySuffix = "";
      if (this.options.editing === true) {
        transPrimarySuffix = "edit";
      } else {
        transPrimarySuffix = "add";
      }
      this.dialog = content.dialog({
        dialogClass: "cf-dialog nixps-cloudflow-ImagePluginWindow noselect",
        classes: {
          "ui-dialog": "cf-dialog noselect"
        },
        closeText: "",
        width: 800,
        height: 500,
        minWidth: 550,
        minHeight: 500,
        maxHeight: 500,
        modal: true,
        title: $.i18n._("nixps-cloudflow-imageplugindialog.title"),
        buttons: [{
          "text": $.i18n._("nixps-form-Button.cancel"),
          "class": "cf-button-secondary",
          click: function click() {
            $(this).remove();
            $(this).closest(".ui-dialog").remove();
            that.options.close();
          }
        }, {
          "text": $.i18n._("nixps-form-Button." + transPrimarySuffix),
          "class": "cf-button-main",
          click: this._submitHandler.bind(that)
        }],
        close: function close() {
          $(this).remove();
          $(this).closest(".ui-dialog").remove();
          that.options.close();
        },
        resizeStop: function resizeStop(pEvent, pData) {
          content.css("width", "auto"); // fix width bug
        }
      });
    },

    /**
     * @description set the values for the configuration for an image through imageOptions, in case we're editing an image
     * @function
     * @private
     * @name nixps-cloudflow.ImagePluginDialog#_setInitialValues
     * @param {Node} pForm the FormRenderer jQuery component
     * @param {Node} pPreviewImg the preview image inside the dialog
     * @returns {undefined}
     */
    _setInitialValues: function _setInitialValues(pForm, pPreviewImg) {
      this._normalizeImageOptions();
      pForm.FormRenderer("setValues", this.options.imageOptions);
      if (this.options.imageOptions.uri.length > 0) {
        pPreviewImg[0].src = this.options.imageOptions.uri;
        pPreviewImg.on("load", function () {
          this.imageRatio = parseFloat(pPreviewImg[0].style.width) / parseFloat(pPreviewImg[0].style.height);
          pPreviewImg.off("load");
        });
      }
      pPreviewImg[0].alt = this.options.imageOptions.altText;
      if (this.outOfRatio === true) {
        this.dialog.find(".image-form [data-key='ratio'] .nixps-cloudflow-Input").Input("setValue", false);
      } else if (this.options.imageOptions.width.length === 0 && this.options.imageOptions.height.length === 0) {
        //width & height have not been modified, image is still in ratio
        this.dialog.find(".image-form [data-key='ratio'] .nixps-cloudflow-Input").Input("setValue", true);
      } else if (this.options.imageOptions.width / this.options.imageOptions.height === this.imageRatio) {
        //the given width & height are in ratio with the img's ratio
        this.dialog.find(".image-form [data-key='ratio'] .nixps-cloudflow-Input").Input("setValue", true);
      } else {
        this.dialog.find(".image-form [data-key='ratio'] .nixps-cloudflow-Input").Input("setValue", false);
      }
      $(pPreviewImg).css({
        width: this.options.imageOptions.width,
        height: this.options.imageOptions.height,
        border: this.options.imageOptions.border + "px solid black"
      });
      if (this.options.imageOptions.alignment !== "none") {
        pPreviewImg.css("float", this.options.imageOptions.alignment);
      }
      var marginObject = {
        vspace: this.options.imageOptions.vspace,
        hspace: this.options.imageOptions.hspace
      };
      this.setMarginValues(marginObject, pPreviewImg);
    },
    _submitHandler: function _submitHandler(pEvent) {
      var isValid = this.dialog.find(".image-form").FormRenderer("isValid");
      if (isValid !== true) {
        return;
      }
      var values = this.dialog.find(".image-form").FormRenderer("getValues");
      this.dialog.remove();
      this.dialog.closest(".ui-dialog").remove();
      this.options.submit(pEvent, values);
    },
    _uriBlurHandler: function _uriBlurHandler(pEvent) {
      var that = this;
      var uri = $(pEvent.target).closest(".nixps-cloudflow-Input").Input("getValue");
      if (uri === "" || uri === this.options.imageOptions.uri) {
        return;
      }
      this.previewimg[0].src = uri;
      this.previewimg.css({
        "width": "",
        "height": ""
      });
      this.previewimg.on("load", function () {
        var height = that.previewimg.css("height").slice(0, -2);
        var width = that.previewimg.css("width").slice(0, -2);
        that.imageRatio = width / height;
        that.dialog.find(".image-form [data-key='height'] .nixps-cloudflow-Input").Input("setValue", height);
        that.dialog.find(".image-form [data-key='width'] .nixps-cloudflow-Input").Input("setValue", width);
        that.previewimg.off("load");
      });
      //new image, width & heights have been set to image's original dimensions so they're in ratio, set checkbox to true
      this.dialog.find(".image-form [data-key='ratio'] .nixps-cloudflow-Input").Input("setValue", true);
    },
    _altBlurHandler: function _altBlurHandler(pEvent) {
      var altText = this.dialog.find(".image-form [data-key='altText'] .nixps-cloudflow-Input").Input("getValue");
      this.previewimg[0].alt = altText;
    },
    _dimensionChangeHandler: function _dimensionChangeHandler(pEvent) {
      //if we called this function from the ratioChangeHandler, we don't need to edit the dimensions (so pEvent = null)
      if (pEvent !== null) {
        var changedInput = $(pEvent.target).closest(".cf-form-group").attr("data-key");
        var lockedRatio = this.dialog.find(".image-form [data-key='ratio'] .nixps-cloudflow-Input").Input("getValue");
        if (lockedRatio === true) {
          var changedValue = this.dialog.find(".image-form [data-key='" + changedInput + "'] .nixps-cloudflow-Input").Input("getValue");
          if (changedInput === "height") {
            var computedValue = Number(parseFloat(changedValue * this.imageRatio).toFixed(2));
            if (isNaN(computedValue) === true) {
              this.dialog.find(".image-form [data-key='ratio'] .nixps-cloudflow-Input").Input("setValue", false);
            } else {
              if (computedValue === 0) {
                this.dialog.find(".image-form [data-key='width'] .nixps-cloudflow-Input").Input("setValue", "");
              } else {
                this.dialog.find(".image-form [data-key='width'] .nixps-cloudflow-Input").Input("setValue", computedValue);
              }
            }
          } else {
            var computedValue = Number(parseFloat(changedValue / this.imageRatio).toFixed(2));
            if (isNaN(computedValue) === true) {
              this.dialog.find(".image-form [data-key='ratio'] .nixps-cloudflow-Input").Input("setValue", false);
            } else {
              if (computedValue === 0) {
                this.dialog.find(".image-form [data-key='height'] .nixps-cloudflow-Input").Input("setValue", "");
              } else {
                this.dialog.find(".image-form [data-key='height'] .nixps-cloudflow-Input").Input("setValue", computedValue);
              }
            }
          }
        }
      }
      var height = this.dialog.find(".image-form [data-key='height'] .nixps-cloudflow-Input").Input("getValue");
      var width = this.dialog.find(".image-form [data-key='width'] .nixps-cloudflow-Input").Input("getValue");
      if (height === "" || width === "") {
        return;
      }
      $(this.previewimg[0]).css("height", height);
      $(this.previewimg[0]).css("width", width);
    },
    _borderChangeHandler: function _borderChangeHandler(pEvent) {
      var border = $(pEvent.target).closest(".nixps-cloudflow-Input").Input("getValue");
      if (border === "") {
        return;
      }
      this.previewimg.css("border", border + "px solid black");
    },
    _marginChangeHandler: function _marginChangeHandler(pEvent) {
      var vspace = this.dialog.find(".image-form [data-key='vspace'] .nixps-cloudflow-Input").Input("getValue");
      var hspace = this.dialog.find(".image-form [data-key='hspace'] .nixps-cloudflow-Input").Input("getValue");
      var valuesObject = {
        hspace: hspace,
        vspace: vspace
      };
      this.setMarginValues(valuesObject, this.previewimg[0]);
    },
    _alignmentChangeHandler: function _alignmentChangeHandler(pEvent) {
      var alignment = $(pEvent.target).closest(".nixps-cloudflow-Select").Select("getValue");
      if (alignment === "none") {
        this.previewimg.css("float", "");
      } else if (alignment === "left") {
        this.previewimg.css("float", "left");
      } else if (alignment === "right") {
        this.previewimg.css("float", "right");
      }
    },
    /**
     * @description fires when the user changes the ratio checkbox, changing 
     * @function
     * @private
     * @name nixps-cloudflow.ImagePluginDialog#_clickResetDimensionsHandler
     * @param {Event} pEvent
     * @returns {undefined}
     */
    _lockratioChangeHandler: function _lockratioChangeHandler(pEvent) {
      var lockRatio = $(pEvent.target).closest(".nixps-cloudflow-Input").Input("getValue");
      if (lockRatio === true) {
        //the image should be in ratio, so we change the height to a ratio'd value based on width
        var width = parseFloat(this.dialog.find(".image-form [data-key='width'] .nixps-cloudflow-Input").Input("getValue"));
        if (width > 0) {
          var height = width / this.imageRatio;
          this.dialog.find(".image-form [data-key='height'] .nixps-cloudflow-Input").Input("setValue", height);
          this._dimensionChangeHandler(null);
        }
      }
    },
    /**
     * @description fires when the user clicks the reset button for image width & height, resetting them back to original
     * @function
     * @private
     * @name nixps-cloudflow.ImagePluginDialog#_clickResetDimensionsHandler
     * @param {Event} pEvent
     * @returns {undefined}
     */
    _clickResetDimensionsHandler: function _clickResetDimensionsHandler(pEvent) {
      $(this.previewimg[0]).css("height", "");
      $(this.previewimg[0]).css("width", "");
      var width = this.previewimg.css("width").slice(0, -2);
      var height = this.previewimg.css("height").slice(0, -2);
      this.dialog.find(".image-form [data-key='height'] .nixps-cloudflow-Input").Input("setValue", height);
      this.dialog.find(".image-form [data-key='width'] .nixps-cloudflow-Input").Input("setValue", width);
    },
    /**
     * @description set the margin of an image
     * @function
     * @private
     * @name nixps-cloudflow.ImagePluginDialog#setMarginValues
     * @param {Object} pValues the vspace & hspace in pixels
     * @param {Node} pImgNode the image to set the margins for
     * @returns {undefined}
     */
    setMarginValues: function setMarginValues(pValues, pImgNode) {
      if (pValues.hspace === "" || pValues.hspace === null) {
        pValues.hspace = 0;
      }
      if (pValues.vspace === "" || pValues.vspace === null) {
        pValues.vspace = 0;
      }
      if (pValues.vspace > 0 && pValues.hspace > 0) {
        $(pImgNode).css("margin", pValues.vspace + "px " + pValues.hspace + "px");
      } else if (pValues.vspace > 0 && pValues.hspace === 0) {
        $(pImgNode).css("margin-top", pValues.vspace + "px");
        $(pImgNode).css("margin-bottom", pValues.vspace + "px");
      } else if (pValues.vspace === 0 && pValues.hspace > 0) {
        $(pImgNode).css("margin-left", pValues.hspace + "px");
        $(pImgNode).css("margin-right", pValues.hspace + "px");
      }
    },
    /**
     * @description normalize the imageOptions option adding missing keys w/ an empty string
     * @function
     * @private
     * @name nixps-cloudflow.ImagePluginDialog#_normalizeImageOptions
     * @returns {undefined}
     */
    _normalizeImageOptions: function _normalizeImageOptions() {
      var that = this;
      var imageOptionsAllKeys = ["uri", "altText", "width", "height", "border", "alignment", "vspace", "hspace"];
      imageOptionsAllKeys.forEach(function (key) {
        if (that.options.imageOptions[key] === undefined) {
          that.options.imageOptions[key] = "";
        }
        if (key === "height" || key === "width") {
          if (that.options.imageOptions[key].endsWith("px") === true) {
            that.options.imageOptions[key] = parseFloat(that.options.imageOptions[key]);
          } else {
            this.outOfRatio = true;
          }
        }
      });
    },
    redraw: function redraw() {
      this._draw();
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
      });
      this._controlOptions();
      if (needRedraw === true) {
        this.redraw();
      }
    },
    _setOption: function _setOption(key, value) {
      if (key === "imageOptions") {
        this.options.imageOptions = value;
        this._setInitialValues(this.dialog.find(".image-form"), this.previewimg);
        return false;
      }
    },
    _controlOptions: function _controlOptions() {
      if ($.isPlainObject(this.options.imageOptions) === false) {
        throw new Error("ImagePluginDialog: option imageOptions must be an object");
      }
      $.each(this.options.imageOptions, function (key, value) {
        if (key === "border" || key === "vspace" || key === "hspace") {
          if (typeof value !== "number") {
            throw new Error("ImagePluginDialog: values border, hspace and vspace in imageOptions must be a number");
          }
        } else {
          if (typeof value !== "string") {
            throw new Error("ImagePluginDialog: values (except for border, vspace & hspace) in imageOptions must be strings");
          }
        }
      });
      this.imageRatio = parseFloat(this.options.imageOptions.width) / parseFloat(this.options.imageOptions.height);
      if (typeof this.options.close !== "function") {
        throw new Error("ImagePluginDialog: option close must be a function");
      }
      if (typeof this.options.submit !== "function") {
        throw new Error("ImagePluginDialog: option submit must be a function");
      }
    },
    _destroy: function _destroy() {
      if (this.dialog !== undefined) {
        this.dialog.remove();
        this.dialog.closest(".ui-dialog").remove();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],331:[function(require,module,exports){
"use strict";

(function ($) {
  function translate(pTransKey) {
    if (window.$ !== undefined && $.i18n !== undefined) {
      if ($.i18n._("nixps-cloudflow-symbolplugindialog.symbol-" + pTransKey) === "nixps-cloudflow-symbolplugindialog.symbol-" + pTransKey) {
        //translation wasn't found, we fall back to the translation key
        return pTransKey;
      } else {
        return $.i18n._("nixps-cloudflow-symbolplugindialog.symbol-" + pTransKey);
      }
    }
    return pTransKey;
  }
  $.widget("nixps-cloudflow.SymbolPluginDialog", $.Widget, {
    version: "0.0.1",
    options: {
      language: "en",
      /**
       * @name nixps-cloudflow.SymbolPluginDialog#symbols
       * @description A list of symbols defined by an Object containing the symbol and optionally translation key
       * to be shown in the dialog, can be either escaped or not. {symbol: "", transKey: ""}
       * @type {Array.Object}
       * @default []
       */
      symbols: [],
      /**
       * @name nixps-cloudflow.SymbolPluginDialog#submit
       * @description Function that fires after the user clicks a symbol
       * @type {Function}
       * @default function() {}
       */
      submit: function submit() {},
      /**
       * @name nixps-cloudflow.SymbolPluginDialog#submit
       * @description Function that fires after the user closes the dialog
       * @type {Function}
       * @default function() {}
       */
      close: function close() {}
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this.dialog;
      this.content;
      this._draw();
      this._on(this.dialog, {
        "click .symbol-button": this._clickSymbolHandler,
        "mouseenter .symbol-button": this._hoverSymbolHandler,
        "mouseleave .symbolpicker-container": this._mouseleaveContentHandler
      });
    },
    _draw: function _draw() {
      var that = this;
      this.content = $("<div>").addClass("symbolpicker-content");
      var symbolContainer = $("<div>").addClass("symbolpicker-container");
      this.options.symbols.forEach(function (pSymbol) {
        var symbolEl = $("<div>").html(pSymbol.symbol).addClass("symbol-button").attr("data-escaped", pSymbol.symbol);

        //add the name of the symbol as a tooltip?
        // if (pSymbol.transKey !== undefined) {
        //     symbolEl.attr("title", translate(pSymbol.transKey));
        // } else {
        //     symbolEl.attr("title", pSymbol.symbol);
        // }
        symbolContainer.append(symbolEl);
      });
      var symbolPreviewContainer = $("<div>").addClass("symbolpicker-preview-container");
      var symbolPreview = $("<div>").addClass("symbolpicker-preview");
      symbolPreviewContainer.append(symbolPreview);
      this.content.append(symbolContainer, symbolPreviewContainer);
      this.dialog = this.content.dialog({
        dialogClass: "cf-dialog nixps-cloudflow-SymbolPluginWindow noselect",
        classes: {
          "ui-dialog": "cf-dialog noselect"
        },
        closeText: "",
        width: 450,
        height: 450,
        minWidth: 400,
        minHeight: 400,
        maxHeight: 800,
        modal: true,
        title: $.i18n._("nixps-cloudflow-symbolplugindialog.title"),
        buttons: [{
          "text": $.i18n._("nixps-form-Button.cancel"),
          "class": "cf-button cf-button-secondary",
          click: function click() {
            $(this).remove();
            $(this).closest(".ui-dialog").remove();
            that.options.close();
          }
        }],
        close: function close() {
          $(this).remove();
          $(this).closest(".ui-dialog").remove();
          that.options.close();
        },
        resizeStop: function resizeStop(pEvent, pData) {
          that.content.css("width", "auto"); // fix width bug
        }
      });

      this.content.dialog("moveToTop");
    },
    /**
     * @description Handler for when an arrowbutton of the slider has been clicked
     * @function
     * @private
     * @name nixps-cloudflow.SymbolPluginDialog#_clickSymbolHandler
     * @param {Event} pEvent
     * @returns {undefined}
     */
    _clickSymbolHandler: function _clickSymbolHandler(pEvent) {
      var escapedSymbol = $(pEvent.target).closest(".symbol-button").attr("data-escaped");
      //unescape the character to be able to use execCommand's "insertText"
      var doc = new DOMParser().parseFromString(escapedSymbol, "text/html");
      var unescapedSymbol = doc.documentElement.textContent;
      this.dialog.dialog("close");
      this.options.submit(pEvent, unescapedSymbol);
    },
    _hoverSymbolHandler: function _hoverSymbolHandler(pEvent) {
      var escapedSymbol = $(pEvent.target).closest(".symbol-button").attr("data-escaped");
      //unescape the character to be able to use execCommand's "insertText"
      var doc = new DOMParser().parseFromString(escapedSymbol, "text/html");
      var unescapedSymbol = doc.documentElement.textContent;
      this.content.find(".symbolpicker-preview")[0].innerText = unescapedSymbol;
    },
    _mouseleaveContentHandler: function _mouseleaveContentHandler(pEvent) {
      this.content.find(".symbolpicker-preview")[0].innerText = "";
    },
    redraw: function redraw() {
      this.dialog.remove();
      this.dialog.closest(".ui-dialog").remove();
      this._draw();
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
      });
      this._controlOptions();
      if (needRedraw === true) {
        this.redraw();
      }
    },
    _setOption: function _setOption(key, value) {
      if (key === "submit") {
        this.options.submit = value;
        return false;
      }
      if (key === "close") {
        this.options.close = value;
        return false;
      }
      if (key === "symbols") {
        this.options.symbols = value;
        return true;
      }
    },
    _controlOptions: function _controlOptions() {
      if (Array.isArray(this.options.symbols) === false) {
        throw new Error("SymbolPluginDialog: option symbols must be an array");
      }
      this.options.symbols.forEach(function (pSymbol) {
        if ($.isPlainObject(pSymbol) === false) {
          throw new Error("SymbolPluginDialog: option symbols must be an array of objects");
        }
      });
      if (typeof this.options.submit !== "function") {
        throw new Error("SymbolPluginDialog: option submit must be a function");
      }
      if (typeof this.options.close !== "function") {
        throw new Error("SymbolPluginDialog: option close must be a function");
      }
    },
    _destroy: function _destroy() {
      if (this.dialog !== undefined) {
        this.dialog.remove();
        this.dialog.closest(".ui-dialog").remove();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],332:[function(require,module,exports){
"use strict";

(function ($) {
  $.widget("nixps-cloudflow.TablePluginDialog", $.Widget, {
    version: "0.0.1",
    options: {
      language: "en",
      cols: 2,
      rows: 3,
      width: "500",
      height: "",
      headers: "none",
      cellspacing: 1,
      cellpadding: 1,
      border: 1,
      alignment: "none",
      caption: "",
      summary: "",
      close: function close() {},
      submit: function submit() {}
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._draw();
      this._on(this.element, {});
    },
    _draw: function _draw() {
      var that = this;
      var formJSON = {
        elements: [{
          "type": "component",
          "element": {
            "id": "error",
            "type": "ErrorMessage",
            "options": {}
          }
        }, {
          "type": "field",
          "element": {
            "key": "rows",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.rows_label"),
            "component": {
              "id": "rows",
              "type": "Input",
              "options": {
                "type": "number",
                "min": 1,
                "value": this.options.rows
              }
            },
            "required": true
          }
        }, {
          "type": "field",
          "element": {
            "key": "cols",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.cols_label"),
            "component": {
              "id": "cols",
              "type": "Input",
              "options": {
                "type": "number",
                "min": 1,
                "value": this.options.cols
              }
            },
            "required": true
          }
        }, {
          "type": "field",
          "element": {
            "key": "width",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.width_label"),
            "component": {
              "id": "width",
              "type": "Input",
              "options": {
                "value": this.options.width
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "height",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.height_label"),
            "component": {
              "id": "height",
              "type": "Input",
              "options": {
                "value": this.options.height
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "headers",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.headers_label"),
            "component": {
              "id": "headers",
              "type": "Select",
              "options": {
                "keyValues": {
                  "none": $.i18n._("nixps-cloudflow-cellpropertiesdialog.option_none"),
                  "row": $.i18n._("nixps-cloudflow-tableplugindialog.headers_options_row"),
                  "col": $.i18n._("nixps-cloudflow-tableplugindialog.headers_options_column"),
                  "rowcol": $.i18n._("nixps-cloudflow-tableplugindialog.headers_options_both")
                },
                "default": this.options.headers
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "cellspacing",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.cellspacing_label"),
            "component": {
              "id": "cellspacing",
              "type": "Input",
              "options": {
                "type": "number",
                "min": 0,
                "value": this.options.cellspacing
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "cellpadding",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.cellpadding_label"),
            "component": {
              "id": "cellpadding",
              "type": "Input",
              "options": {
                "type": "number",
                "min": 0,
                "value": this.options.cellpadding
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "border",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.border_label"),
            "component": {
              "id": "border",
              "type": "Input",
              "options": {
                "type": "number",
                "min": 0,
                "value": this.options.border
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "alignment",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.alignment_label"),
            "component": {
              "id": "alignment",
              "type": "Select",
              "options": {
                "keyValues": {
                  "none": $.i18n._("nixps-cloudflow-cellpropertiesdialog.option_none"),
                  "left": $.i18n._("nixps-cloudflow-cellpropertiesdialog.horizontal_option_left"),
                  "center": $.i18n._("nixps-cloudflow-cellpropertiesdialog.horizontal_option_center"),
                  "right": $.i18n._("nixps-cloudflow-cellpropertiesdialog.horizontal_option_right")
                },
                "default": this.options.alignment
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "caption",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.caption_label"),
            "component": {
              "id": "caption",
              "type": "Input",
              "options": {
                "value": this.options.caption
              }
            }
          }
        }, {
          "type": "field",
          "element": {
            "key": "summary",
            "label": $.i18n._("nixps-cloudflow-tableplugindialog.summary_label"),
            "component": {
              "id": "summary",
              "type": "Input",
              "options": {
                "value": this.options.summary
              }
            }
          }
        }]
      };
      var content = $("<div>");
      this.tableForm = $("<div>").FormRenderer({
        formJSON: formJSON,
        formClasses: "cf-form",
        labelBootstrapClass: "cf-col-sm-4",
        inputBootstrapClass: "cf-col-sm-3"
      }).addClass("table-form");
      content.append(this.tableForm);
      var transPrimarySuffix = "";
      if (this.options.editing === true) {
        this.tableForm.find("[data-key='cols'] .nixps-cloudflow-Input").Input("disable");
        this.tableForm.find("[data-key='rows'] .nixps-cloudflow-Input").Input("disable");
        transPrimarySuffix = "edit";
      } else {
        transPrimarySuffix = "add";
      }
      this.dialog = content.dialog({
        dialogClass: "cf-dialog nixps-cloudflow-TablePluginWindow noselect",
        classes: {
          "ui-dialog": "cf-dialog noselect"
        },
        closeText: "",
        width: 800,
        height: 500,
        minWidth: 550,
        minHeight: 500,
        maxHeight: 500,
        modal: true,
        title: $.i18n._("nixps-cloudflow-tableplugindialog.title"),
        buttons: [{
          "text": $.i18n._("nixps-form-Button.cancel"),
          "class": "cf-button cf-button-secondary",
          click: function click() {
            $(this).remove();
            $(this).closest(".ui-dialog").remove();
            that.options.close();
          }
        }, {
          "text": $.i18n._("nixps-form-Button." + transPrimarySuffix),
          "class": "cf-button cf-button-main",
          click: this._submitHandler.bind(that)
        }],
        close: function close() {
          $(this).remove();
          $(this).closest(".ui-dialog").remove();
          that.options.close();
        },
        resizeStop: function resizeStop(pEvent, pData) {
          content.css("width", "auto"); // fix width bug
        }
      });
    },

    _submitHandler: function _submitHandler(pEvent) {
      var isValid = this.tableForm.FormRenderer("isValid");
      if (isValid === false) {
        return;
      }
      var values = this.tableForm.FormRenderer("getValues");
      var headers = {
        col: values.headers === "rowcol" || values.headers === "col",
        row: values.headers === "rowcol" || values.headers === "row"
      };
      values.headers = headers;
      this.dialog.remove();
      this.dialog.closest(".ui-dialog").remove();
      this.options.submit(pEvent, values);
    },
    redraw: function redraw() {
      this._draw();
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
      });
      this._controlOptions();
      if (needRedraw === true) {
        this.redraw();
      }
    },
    _setOption: function _setOption(key, value) {},
    _controlOptions: function _controlOptions() {
      if (typeof this.options.cols !== "number") {
        throw new Error("TablePluginDialog: cols option must be a number");
      }
      ;
      if (typeof this.options.rows !== "number") {
        throw new Error("TablePluginDialog: rows option must be a number");
      }
      ;
      if (typeof this.options.height !== "string") {
        throw new Error("TablePluginDialog: height option must be a string");
      }
      ;
      if (typeof this.options.width !== "string") {
        throw new Error("TablePluginDialog: width option must be a string");
      }
      ;
      if (["none", "row", "col", "rowcol"].includes(this.options.headers) === false) {
        throw new Error("TablePluginDialog: headers option must be either 'none', 'row', 'col', or 'rowcol'");
      }
      ;
      if (typeof this.options.cellspacing !== "number") {
        throw new Error("TablePluginDialog: cellspacing option must be a number");
      }
      ;
      if (typeof this.options.cellpadding !== "number") {
        throw new Error("TablePluginDialog: cellpadding option must be a number");
      }
      ;
      if (typeof this.options.border !== "number") {
        throw new Error("TablePluginDialog: border option must be a number");
      }
      ;
      if (["none", "left", "center", "right"].includes(this.options.alignment) === false) {
        throw new Error("TablePluginDialog: alignment option must be either 'none', 'left', 'center', 'right'");
      }
      ;
      if (typeof this.options.caption !== "string") {
        throw new Error("TablePluginDialog: caption option must be a string");
      }
      ;
      if (typeof this.options.summary !== "string") {
        throw new Error("TablePluginDialog: summary option must be a string");
      }
      ;
    },
    _destroy: function _destroy() {
      if (this.dialog !== undefined) {
        this.dialog.remove();
        this.dialog.closest(".ui-dialog").remove();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],333:[function(require,module,exports){
"use strict";

(function ($) {
  $.widget("nixps-cloudflow.TajiriContextMenu", $.Widget, {
    version: "0.0.1",
    options: {
      language: "en",
      buttons: {},
      choiceCallback: function choiceCallback() {}
    },
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).attr("data-uuid", this.uuid);
      this._draw();
      this._on(this.element, {
        // "click .table_contextmenu button.cf-tablecontext-sub_menu": this._buttonSubmenuClickHandler,
        "click .tajiri_contextmenu_overlay": this._closeHandler,
        "contextmenu .tajiri_contextmenu_overlay": this._closeHandler,
        "dropdownlistshow": this._submenuOpenedHandler
      });
    },
    _draw: function _draw() {
      var that = this;
      // reset
      this.CBfunctions = {};
      this.element.empty();
      // draw
      var contextMenu = $("<div>").addClass("table_contextmenu");
      var overlay = $("<div>").addClass("tajiri_contextmenu_overlay");
      this.element.append(contextMenu);
      this.element.append(overlay);
      var contextButtons = this.options.buttons;
      for (var i = 0; i < contextButtons.length; i++) {
        if (contextButtons[i].type === "subgroup") {
          var menu = $("<div>").addClass("nixps-pagebuilder-CloudflowButton-DropDownButtons").DropdownList({
            "buttonClass": contextButtons[i].id + " cf-button-topbar cf-button-context cf-tablebutton-sub_menu",
            "buttonText": contextButtons[i].label,
            "attachment": "next",
            "showParameter": 0
          }).css("display", "");
          if (Array.isArray(contextButtons[i].buttons) && contextButtons[i].buttons.length > 0) {
            for (var s = 0; s < contextButtons[i].buttons.length; s++) {
              contextButtons[i].buttons[s].classes = contextButtons[i].buttons[s].id + " cf-tablebutton-sub_button cf-button-topbar cf-dropdown-item-block";
              this.CBfunctions[contextButtons[i].buttons[s].id] = {
                action: contextButtons[i].buttons[s].action,
                data: contextButtons[i].buttons[s].data
              };
              var buttonJSON = {
                click: function click(pEvent) {
                  var cbFunctionID = $(pEvent.target).closest(".nixps-pagebuilder-CloudflowButton").attr("data-cbfunctionid");
                  var cbfunction = that.CBfunctions[cbFunctionID];
                  cbfunction.action.apply(null, cbfunction.data);
                  that.options.choiceCallback();
                  that._closeHandler();
                },
                label: contextButtons[i].buttons[s].text,
                icon: contextButtons[i].buttons[s].icon,
                classes: contextButtons[i].buttons[s].classes
              };
              var subButton = $("<div>").CloudflowButton(buttonJSON);
              if (contextButtons[i].buttons[s].active === false) {
                subButton.CloudflowButton("disable");
              }
              subButton.attr("data-cbfunctionID", contextButtons[i].buttons[s].id);
              menu.DropdownList("addListItemAppendComponent", subButton);
            }
          }
          contextMenu.append(menu);
        } else {
          contextButtons[i].classes = contextButtons[i].id + " cf-button-topbar cf-button-context";
          this.CBfunctions[contextButtons[i].id] = {
            action: contextButtons[i].action,
            data: contextButtons[i].data
          };
          var buttonJSON = {
            click: function click(pEvent) {
              var cbFunctionID = $(pEvent.target).closest(".nixps-pagebuilder-CloudflowButton").attr("data-cbfunctionid");
              var cbfunction = that.CBfunctions[cbFunctionID];
              cbfunction.action.apply(null, cbfunction.data);
              that.options.choiceCallback();
              that._closeHandler();
            },
            label: contextButtons[i].text,
            icon: contextButtons[i].icon,
            classes: contextButtons[i].classes
          };
          var button = $("<div>").CloudflowButton(buttonJSON);
          if (contextButtons[i].active === false) {
            button.CloudflowButton("disable");
          }
          button.attr("data-cbfunctionID", contextButtons[i].id);
          contextMenu.append(button);
        }
      }
      this.element.hide();
    },
    _closeHandler: function _closeHandler(pEvent) {
      if (pEvent !== undefined && typeof pEvent.preventDefault === "function") {
        pEvent.preventDefault();
      }
      var dropdowns = this.element.find(".nixps-pagebuilder-CloudflowButton-DropDownButtons");
      //togle open dropdowns
      dropdowns.each(function (pIndex, pDropdown) {
        if ($(pDropdown).hasClass("dropdownlist_active") === true) {
          $(pDropdown).DropdownList("toggle");
        }
      });
      this.element.hide();
      return false;
    },
    show: function show(pEvent) {
      pEvent.stopPropagation();
      pEvent.preventDefault();
      this.element.show();
      var posX = pEvent.clientX;
      var posY = pEvent.clientY;
      if (posY + this.element.height() > this.window.height()) {
        posY = posY - this.element.height();
      }
      this.element.css({
        top: posY,
        left: posX,
        display: "",
        position: "fixed",
        "z-index": 1000
      });
    },
    redraw: function redraw() {
      this._draw();
    },
    _submenuOpenedHandler: function _submenuOpenedHandler(pEvent) {
      var submenu = $(pEvent.target).find(".cf-dropdown");
      var posY = null;
      if (submenu[0].getBoundingClientRect().y + submenu.height() > this.window.height()) {
        posY = this.window.height() - (submenu[0].getBoundingClientRect().y + submenu.height()) - 10;
      }
      if (posY !== undefined) {
        submenu.css({
          top: posY
        });
      }
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
      });
      this._controlOptions();
      if (needRedraw === true) {
        this.redraw();
      }
    },
    _setOption: function _setOption(key, value) {
      if (key === "buttons") {
        this.options.buttons = value;
        return true;
      }
    },
    _controlOptions: function _controlOptions() {},
    _destroy: function _destroy() {}
  });
})(jQuery);

},{}],334:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPlugin = require("./StyledPlugin.js");
  var Utils = require("../../Utils.js");
}
/**
 * AttributeStyledPlugin is an abstract class. 
 * Its provide a simple way to implement a plugin that apply style based on attributes
 * @extends StyledPlugin
 */
var AttributeStyledPlugin = /*#__PURE__*/function (_StyledPlugin) {
  _inherits(AttributeStyledPlugin, _StyledPlugin);
  var _super = _createSuper(AttributeStyledPlugin);
  function AttributeStyledPlugin(options) {
    var _this;
    _classCallCheck(this, AttributeStyledPlugin);
    _this = _super.call(this);
    _this.enterMode = options !== undefined && options.enterMode !== undefined ? options.enterMode : "";
    _this.blockElements = ["li", "h1", "h2", "h3", "pre", "div", "p"];
    if (_this.constructor == AttributeStyledPlugin) {
      throw new Error("Abstract classes can't be instantiated.");
    }
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * This function must be redefined by all sub-plugins
   * Get the style on a given node if it exist
   * @param {Node} pNode : the node to read the style from
   * @returns {*} true or the style value if it exists, en empty string otherwise
   */
  _createClass(AttributeStyledPlugin, [{
    key: "_getStyleValue",
    value: function _getStyleValue(pNode) {
      throw new Error("Method '_getStyleValue' must be implemented.");
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Set the style on a given node.
     * @param {Node} pNode : the node to set the style on
     */
  }, {
    key: "_setStyleValue",
    value: function _setStyleValue(pNode) {
      throw new Error("Method '_setStyleValue' must be implemented.");
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Reset the style on a given node.
     * @param {Node} pNode : the node to reset the style on
     */
  }, {
    key: "_resetStyleValue",
    value: function _resetStyleValue(pNode) {
      throw new Error("Method '_resetStyleValue' must be implemented.");
    }

    /**------------------------------------------------------------------------------------------------
     * Function called to determine if a style is applied on a given node element
     * @param {Node} pNode the node to check.
     * @returns the style value if a style is applied, false otherwise
     */
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      var value = this._getStyleValue(pNode);
      return !value || value.length === 0 ? false : value;
    }

    /**------------------------------------------------------------------------------------------------
     * function called by the editor when the plugin button is pressed if the style is not yet defined
     * on the selection
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var range = pSelection.getRangeAt(0);
      var rangeCache = {
        startNode: range.startContainer,
        endNode: range.endContainer,
        startOffset: range.startOffset,
        endOffset: range.endOffset
      };
      // Extract the selected content from the selection
      var selectionContent = this._getSelectedContent(pSelection, pRootNode);

      // remove possible style that could be defined on the selected content and its descendants
      this._removeStyleOnAllDescendants(selectionContent);

      // Apply the style on that content
      var formatedContent = this._setStyleValue(selectionContent);

      // and then re-inject the content into the selection
      if (formatedContent.textContent.length > 0 && formatedContent.childNodes.length < 2) {
        var newNode = this._setNodeInSelection(pSelection, formatedContent);
        if (newNode.parentElement.style[this.property] !== undefined) {
          if (newNode.parentElement !== pRootNode && newNode.parentElement.childNodes.length === 1) {
            //no text nodes - only the newly styled node
            var toRemove = newNode.parentElement;
            newNode.parentElement.after(newNode);
            toRemove.parentElement.removeChild(toRemove);
          }
        }
      } else if (formatedContent.childNodes.length >= 2) {
        //there's multiple nodes - possibly 
        this._formatMultipleNodes(pSelection, formatedContent, rangeCache, pRootNode);
      } else {
        //cant set the selection to an empty node!
        formatedContent.innerHTML = "&ZeroWidthSpace;";
        this._setNodeInSelection(pSelection, formatedContent);
        var range = new Range();
        range.setStart(formatedContent, 0);
        range.setEnd(formatedContent, formatedContent.textContent.length);
        pSelection.removeAllRanges();
        pSelection.addRange(range);
        // formatedContent.innerHTML = formatedContent.innerHTML.replaceAll(/\u200B/g, ""); //remove the ZWS
      }

      this._fixAfterFormat(pRootNode);
    }
  }, {
    key: "_fixAfterFormat",
    value: function _fixAfterFormat(pRootNode) {
      var that = this;
      var styledNodes = pRootNode.querySelectorAll("span[style]");
      styledNodes.forEach(function (styledNode) {
        var foundNewStyle = false;
        var toMove = [];
        if (styledNode.style[that.property].length === 0 && foundNewStyle === false) {
          //irrelevant node to the styling just done
          return;
        }
        var styleObject = that._getStyleObject(styledNode.getAttribute("style"));
        styledNode.childNodes.forEach(function (pChildNode) {
          if (foundNewStyle === true) {
            if (pChildNode.nodeType === Node.TEXT_NODE) {
              var span = document.createElement("span");
              span.style[that.property] = styledNode.style[that.property];
              for (var property in styleObject) {
                if (span.style[property].length === 0) {
                  span.style[property] = styleObject[property];
                }
              }
              pChildNode.after(span);
              span.append(pChildNode);
              toMove.push(span);
            }
          } else if (pChildNode.nodeType !== Node.TEXT_NODE && pChildNode.style[that.property].length > 0) {
            for (var property in styleObject) {
              if (pChildNode.style[property].length === 0) {
                pChildNode.style[property] = styleObject[property];
              }
            }
            toMove.push(pChildNode);
            foundNewStyle = true;
          }
        });
        for (var i = toMove.length - 1; i > -1; i--) {
          styledNode.after(toMove[i]);
        }
        var spans = pRootNode.querySelectorAll("span");
        spans.forEach(function (pSpanNode) {
          var toRemove = [];
          pSpanNode.childNodes.forEach(function (pChildNode) {
            if (pChildNode.nodeType === Node.TEXT_NODE && pChildNode.length === 0) {
              toRemove.push(pChildNode);
            }
          });
          toRemove.forEach(function (pRemoveNode) {
            pRemoveNode.parentElement.removeChild(pRemoveNode);
          });
          if (pSpanNode.childNodes.length === 0) {
            pSpanNode.parentElement.removeChild(pSpanNode);
          }
        });
      });
    }
  }, {
    key: "_getStyleObject",
    value: function _getStyleObject(pString) {
      var object = {};
      if (pString === null) {
        return object;
      }
      pString.split(";").forEach(function (pCSSStyle) {
        if (typeof pCSSStyle === "string" && pCSSStyle.length > 0) {
          var selector = pCSSStyle.split(":")[0].trim();
          var value = pCSSStyle.split(":")[1];
          object[selector] = value;
        }
      });
      return object;
    }

    /**------------------------------------------------------------------------------------------------
     * function called by plugins that need to apply style attributes to nodes that are already existent
     * @param {Array.Node} pNodes : an array of nodes to style
     */
  }, {
    key: "formatExistingNodes",
    value: function formatExistingNodes(pNodes) {
      var that = this;
      pNodes.forEach(function (pNode) {
        that._setStyleValue(pNode);
      });
    }

    /**------------------------------------------------------------------------------------------------
     * function called by the editor when the plugin button is pressed if the style is already defined
     * on the selection
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      // Extract the selected content from the selection
      var selectionContent = this._getSelectedContent(pSelection, pRootNode);

      // remove possible style that could be defined on the selected content and its descendants
      this._removeStyleOnAllDescendants(selectionContent);

      // remove possible style that could be defined on ancestors
      var anchor = this._removeSelectionFromParentStyle(pSelection, pRootNode);

      // Anchor is a node where the selection should be at the end of the process.
      // The node where the selection is might have changed if the style was defined on a parent node.
      if (anchor !== null) {
        var range = pSelection.getRangeAt(0);
        range.collapse();
        range.setStart(anchor, 0);
        range.setEnd(anchor, 0);
      }

      // Re append the selected nodes into the selection
      this._setNodeInSelection(pSelection, selectionContent);
    }

    /**------------------------------------------------------------------------------------------------
     * Extract the selected nodes fromt the selection
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     * @returns {Node} a node containing the current selection
     */
  }, {
    key: "_getSelectedContent",
    value: function _getSelectedContent(pSelection, pRootNode) {
      var range = pSelection.getRangeAt(0);
      return range.extractContents();
    }

    /**------------------------------------------------------------------------------------------------
     * Check if a style is defined on any ancestor of a given node
     * @param {Node} pNode : the Node
     * @param {Node} pRootNode  : the root node of the editing area
     * @returns {boolean} true if the style is defined on an ancestor, false otherwise
     */
  }, {
    key: "_hasStyleOnAncestors",
    value: function _hasStyleOnAncestors(pNode, pRootNode) {
      if (pNode === pRootNode) {
        return false;
      }
      var parent = pNode.parentNode;
      var value = this._getStyleValue(parent);
      if (value && value.length > 0) {
        return true;
      }
      return this._hasStyleOnAncestors(parent, pRootNode);
    }

    /**------------------------------------------------------------------------------------------------
     * Check if a style is defined on a given node
     * @param {Node} pNode : the Node
     * @returns {boolean} true if the style is defined, false otherwise
     */
  }, {
    key: "_hasStyleOnNode",
    value: function _hasStyleOnNode(pNode) {
      var value = this._getStyleValue(pNode);
      return value.length > 0;
    }

    /**------------------------------------------------------------------------------------------------
     * Check if a style is defined on a given node
     * @param {Node} pNode : the Node
     */
  }, {
    key: "_removeStyleOnAllDescendants",
    value: function _removeStyleOnAllDescendants(pNode) {
      this._resetStyleValue(pNode);
      for (var i = 0, len = pNode.childNodes.length; i < len; ++i) {
        var n = pNode.childNodes[i];
        this._removeStyleOnAllDescendants(n);
      }
    }

    /**------------------------------------------------------------------------------------------------
     * Remove the selected content from the style defined by its ancestors. 
     * eg:  <span style='color:red'>
     *          <i>Lorem ipsum dolor</i>
     *      </span>
     * if 'ispum' is selected, and the color style has to be removed, we have to split the <span> node
     * in 2 two and insert inbetween those 2 nodes the selection. So the span wont be applied to the 
     * selection anymore. And we have to keep the <i> applied to all 2 spans + the selection. 
     * And the result should be: 
     *      <span style='color:red'>
     *          <i>Lorem </i>
     *      </span>
     *      <i>ipsum</i>                        <---
     *      <span style='color:red'>
     *          <i> color</i>
     *      </span>
     * @param {Node} pNode : the Node
     * @returns {Node} an anchor where the selection should be placed after the style removal. In the 
     * sample above, the <i> node pointed by the arrow will be returned
     */
  }, {
    key: "_removeSelectionFromParentStyle",
    value: function _removeSelectionFromParentStyle(pSelection, pRootNode) {
      var range = pSelection.getRangeAt(0);
      var commonAncestor = range.commonAncestorContainer;
      var cleanedNode = null;
      var anchor = null;
      var new_node = null;
      var tempNode = null;
      var parent = null;

      // find the where to start splitting the DOM structure 
      if (commonAncestor.nodeType === Node.TEXT_NODE) {
        new_node = commonAncestor.splitText(range.startOffset);
        parent = commonAncestor.parentNode;
      } else {
        new_node = tempNode = document.createElement('span');
        parent = commonAncestor;
        this._insertAt(parent, range.startOffset, tempNode);
      }

      // Loop through ancestors to split them and insert the selection in-between
      while (pRootNode.contains(parent) && (this._hasStyleOnAncestors(parent, pRootNode) || this._hasStyleOnNode(parent))) {
        // clone the node twice: for the anchor and its next sibling
        var new_parent = parent.cloneNode();
        var new_anchor = parent.cloneNode();

        // the anchor will hold the selection, so we want to remove the style on it
        this._resetStyleValue(new_anchor);

        // remove problematic attributes
        ['ID'].forEach(function (attr) {
          new_parent.removeAttribute(attr);
          new_anchor.removeAttribute(attr);
        });

        // For each child node, find out where they belongs.
        // - if they are before the anchor, leave them there
        // - if they are after the anchor, save them to append them to the new parent later
        // it's one in two steps, else the loop will trickier to write.
        var append = false;
        var toAppend = [];
        for (var i = 0, len = parent.childNodes.length; i < len; ++i) {
          var n = parent.childNodes[i];
          if ([Node.ELEMENT_NODE, Node.TEXT_NODE].indexOf(n.nodeType) !== -1) {
            if (n === new_node) {
              append = true;
            }
            if (append) {
              toAppend.push(n);
            }
          }
        }

        // Append all flagged node to the new parent node
        toAppend.forEach(function (pNode) {
          new_parent.appendChild(pNode);
        });

        // and append the new parent node after the current onde
        this._insertAfter(parent, new_parent);
        new_node = new_parent;
        parent = parent.parentNode;

        // Save the anchor, so we can return it at the end;
        if (anchor === null) {
          anchor = new_anchor;
        }

        // re-build here the DOMStructure of all styled node but without the one we want to remove
        if (cleanedNode !== null) {
          new_anchor.appendChild(cleanedNode);
        }
        cleanedNode = new_anchor;
      }
      if (tempNode !== null) {
        tempNode.remove();
      }

      // and finally append cleaned DOM structure to the current DOM
      if (cleanedNode !== null) {
        this._insertBefore(new_node, cleanedNode);
      }
      return anchor;
    }

    /**------------------------------------------------------------------------------------------------
     * Utility function: Insert a node after another node
     * @param {Node} pReferenceNode the reference node
     * @param {Node} pNewNode the node to insert
     */
  }, {
    key: "_insertAfter",
    value: function _insertAfter(pReferenceNode, pNewNode) {
      pReferenceNode.parentNode.insertBefore(pNewNode, pReferenceNode.nextSibling);
    }

    /**------------------------------------------------------------------------------------------------
     * Utility function: Insert a node before another node
     * @param {Node} pReferenceNode the reference node
     * @param {Node} pNewNode the node to insert
     */
  }, {
    key: "_insertBefore",
    value: function _insertBefore(pReferenceNode, pNewNode) {
      pReferenceNode.parentNode.insertBefore(pNewNode, pReferenceNode);
    }

    /**------------------------------------------------------------------------------------------------
     * Utility function: Insert a node at a given position
     * @param {Node} pParentNode the node to insert the new node into
     * @param {*} pIndex the index at which the new node should be inserted
     * @param {Node} newNode the node to insert
     */
  }, {
    key: "_insertAt",
    value: function _insertAt(pParentNode, pIndex, pNewNode) {
      pParentNode.insertBefore(pNewNode, pParentNode.childNodes[pIndex]);
    }
  }, {
    key: "_formatMultipleNodes",
    value: function _formatMultipleNodes(pSelection, pFormattedContent, pRangeCache, pRootNode) {
      var initLength = pFormattedContent.childNodes.length;
      while (pFormattedContent.childNodes.length > 0) {
        var childrenLength = pFormattedContent.childNodes.length;
        var mustChildBeDeleted = pFormattedContent.childNodes[0].nodeType !== Node.TEXT_NODE;
        var nodeCache = pFormattedContent.childNodes[0].cloneNode();
        var styledNode = _get(_getPrototypeOf(AttributeStyledPlugin.prototype), "_replaceTagname", this).call(this, pFormattedContent.childNodes[0], "span");
        if (mustChildBeDeleted === true) {
          pFormattedContent.removeChild(pFormattedContent.childNodes[0]);
        }
        styledNode = this._setStyleValue(styledNode);
        if (childrenLength === initLength) {
          //first child
          if (pRangeCache.startNode.nodeType === Node.TEXT_NODE) {
            pRangeCache.startNode.after(styledNode);
            pRangeCache.startNode = styledNode;
          } else {
            pRangeCache.startNode.append(styledNode);
            pRangeCache.startNode = styledNode;
          }
        } else if (childrenLength === 1) {
          //last child
          if (pRangeCache.endNode.nodeType === Node.TEXT_NODE) {
            pRangeCache.endNode.before(styledNode);
          } else {
            pRangeCache.endNode.prepend(styledNode);
          }
        } else {
          //check whether it's a block element or not
          var appendNode = styledNode;
          if (this.blockElements.includes(nodeCache.nodeName.toLowerCase())) {
            if (this.enterMode.length === 0) {
              console.error("Tajiri: enterMode option for AttributeStyledPlugin was not set. unable to format multi-lines.");
            }
            appendNode = document.createElement(nodeCache.nodeName.toLowerCase());
            appendNode.style = nodeCache.style;
            appendNode.append(styledNode);
            var afterTag = null;
            var i = 0;
            while (afterTag === null) {
              var startContainer = pRangeCache.startNode;
              if (startContainer.nodeType === Node.TEXT_NODE) {
                startContainer = startContainer.parentNode;
              }
              afterTag = startContainer.closest(this.blockElements[i]);
              if (pRootNode.contains(afterTag) === false || afterTag.isEqualNode(pRootNode)) {
                afterTag = null;
              }
              if (i === this.blockElements.length - 1) {
                break;
              }
              i++;
            }
            if (afterTag === null) {
              pRangeCache.startNode.after(appendNode);
            } else {
              afterTag.after(appendNode);
            }
          } else {
            pRangeCache.startNode.append(appendNode);
          }
          pRangeCache.startNode = appendNode;
        }
      }
    }
  }, {
    key: "_applyStyleLater",
    value: function _applyStyleLater(pDOM, pText, pSelection) {
      var that = this;

      //first set the selection to attributes so we don't lose it after setting innerHTML
      var range = pSelection.getRangeAt(0);
      var rangeCache = {
        start: range.startOffset,
        end: range.endOffset,
        startIsText: range.startContainer.nodeType === Node.TEXT_NODE,
        endIsText: range.endContainer.nodeType === Node.TEXT_NODE
      };
      var childIndexes = [];
      var startContainer = range.startContainer;
      var endContainer = range.endContainer;
      var selectionNode;
      [startContainer, endContainer].forEach(function (pSelectionContainer, pContainerIndex) {
        var suffix = pContainerIndex === 0 ? "start" : "end";
        if (startContainer === endContainer && pContainerIndex === 1) {
          //same start and end, did the correcting already for startcontainer so only need to add the attribute for end
          selectionNode.setAttribute("data-tajiri-selection-" + suffix, rangeCache[suffix]);
          childIndexes[pContainerIndex] = childIndexes[0];
          return;
        } else if (pSelectionContainer.nodeType === Node.TEXT_NODE) {
          if (pSelectionContainer.parentElement === that.area) {
            //text is direct child of rootNode - needs a wrap
            //save what childnode we need to set the selection back on
            that.area.childNodes.forEach(function (pChildNode, pIndex) {
              if (pChildNode === pSelectionContainer) {
                childIndexes[pContainerIndex] = pIndex;
              }
            });
            selectionNode = that._wrapTextInSpan(pSelectionContainer);
            selectionNode.setAttribute("data-tajiri-selection-remove", true);
          } else {
            if (pSelectionContainer.parentElement.childNodes.length > 1) {
              //need to wrap 
              pSelectionContainer.parentElement.childNodes.forEach(function (pChildNode, pIndex) {
                if (pChildNode === pSelectionContainer) {
                  childIndexes[pContainerIndex] = pSelectionContainer;
                }
              });
              selectionNode = that._wrapTextInSpan(pSelectionContainer);
              selectionNode.setAttribute("data-tajiri-selection-remove", true);
            } else {
              //can add attributes on the parent
              childIndexes[pContainerIndex] = pSelectionContainer;
              selectionNode = pSelectionContainer.parentElement;
            }
          }
        } else {
          //just add attributes on the node
          childIndexes[pContainerIndex] = pSelectionContainer;
          selectionNode = pSelectionContainer;
        }
        selectionNode.setAttribute("data-tajiri-selection-" + suffix, rangeCache[suffix]);
      });

      //update the text parameter with the newly added data attributes
      pText = pDOM.innerHTML;

      // some steps to apply on the csp restrictions
      // 1. move all styles to a customised data- attribute
      // 2. add to DOM
      // 3. apply all styles manually found in the data- attributes
      var found = false;
      //(\s[^>]*)? before and after style attr to capture all the other attributes
      pText = pText.replace(/<([a-zA-Z]*)(\s[^>]*)?\sstyle="([^"]*)"(\s[^>]*)?>/ig, function (pMatch, p1, p2, p3, p4, offset) {
        //a node might have no extra attributes - set to an empty string if the case
        p2 = p2 === undefined ? "" : p2;
        p4 = p4 === undefined ? "" : p4;
        found = true;
        if (typeof p3 === "string" && p3.length > 0) {
          return "<" + p1 + p2 + " data-tajiri-style='" + p3 + "' " + p4 + ">";
        } else {
          // empty style attr
          return "<" + p1 + p2 + p4 + ">";
        }
      });
      pDOM.innerHTML = pText;
      var startContainer = pDOM.querySelector("[data-tajiri-selection-start]");
      var endContainer = pDOM.querySelector("[data-tajiri-selection-end]");
      if (startContainer !== null && endContainer !== null) {
        startContainer.removeAttribute("data-tajiri-selection-start");
        endContainer.removeAttribute("data-tajiri-selection-end");
        if (rangeCache.startIsText === true) {
          startContainer = startContainer.childNodes[0];
        }
        if (rangeCache.endIsText === true) {
          endContainer = endContainer.childNodes[0];
        }
        range.setStart(startContainer, rangeCache["start"]);
        range.setEnd(endContainer, rangeCache["end"]);
      }
      if (found) {
        Utils.applyDataStyleToRealStyle(pDOM);
      }
    }
  }, {
    key: "_wrapTextInSpan",
    value: function _wrapTextInSpan(pTextNode) {
      var newSpan = document.createElement("span");
      pTextNode.after(newSpan);
      newSpan.append(pTextNode);
      return newSpan;
    }
  }, {
    key: "_removeSelectionNode",
    value: function _removeSelectionNode(pRootNode) {
      var found = false;
      pRootNode.querySelectorAll("[data-tajiri-selection-remove]").forEach(function (pToRemove) {
        found = true;
        pToRemove.childNodes.forEach(function (pChild) {
          pToRemove.after(pChild);
        });
        pToRemove.parentElement.removeChild(pToRemove);
      });
      return found;
    }
  }, {
    key: "addZWS",
    value: function addZWS(pSelection, pRootNode) {
      document.execCommand("insertText", false, "\u200B");
      pRootNode.addEventListener("input", function removeZWS() {
        var startContainer = pSelection.getRangeAt(0).startContainer.nodeType === Node.TEXT_NODE ? pSelection.getRangeAt(0).startContainer.parentElement : pSelection.getRangeAt(0).startContainer;
        var affectedNodes = Utils.removeZeroWidthSpaces(pRootNode);
        affectedNodes.forEach(function (pAffectedNode) {
          if (pAffectedNode === startContainer) {
            pSelection.modify("move", "right", "character");
          }
        });
        pRootNode.removeEventListener("input", removeZWS);
      });
    }
  }]);
  return AttributeStyledPlugin;
}(StyledPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = AttributeStyledPlugin;
}

},{"../../Utils.js":321,"./StyledPlugin.js":368}],335:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var ColorPlugin = require("./ColorPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends ColorPlugin
 */
var BGColorPlugin = /*#__PURE__*/function (_ColorPlugin) {
  _inherits(BGColorPlugin, _ColorPlugin);
  var _super = _createSuper(BGColorPlugin);
  function BGColorPlugin(options) {
    var _this;
    _classCallCheck(this, BGColorPlugin);
    _this = _super.call(this, options);
    _this.attribute = "style";
    _this.property = "background";
    _this.command = "backColor";
    _this.styleAttributeSearcher = new RegExp(";\\s*" + _this.property + "(?:-color){0,1}\\s*:\\s*([^;]*);*", "i");
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(BGColorPlugin, [{
    key: "getID",
    value: function getID() {
      return "BGColor";
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      return "#FFFFFF";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_COLORPICKER,
        icon: ["fa fa-square fa-stack-2x", "fa fa-font fa-inverse fa-stack-1x"],
        text: "BG",
        tooltip: "BG Color",
        options: {
          togglePaletteOnly: false,
          showAlpha: true,
          palette: [["rgba(255, 255, 255, 0)", "#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#D7D6EC"], ["#eee", "#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#AFAFDB"], ["#ccc", "#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8687C9"], ["#999", "#d43d3d", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#0080BF", "#5E6BBE"], ["#000", "#900", "#b45f06", "#bf9000", "#38761d", "#2F6B78", "#276FB0", "#5756A9"]]
        }
      };
    }
  }]);
  return BGColorPlugin;
}(ColorPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = BGColorPlugin;
}

},{"./ColorPlugin.js":339,"./Plugin.js":362}],336:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function" && typeof StyledPluginEC !== "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Plugin = require("./Plugin.js");
}

/**
 * @description Plugin handling the BOLD style
 * @extends StyledPluginEC
 * @memberof Tajiri
 */
var BoldPlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(BoldPlugin, _StyledPluginEC);
  var _super = _createSuper(BoldPlugin);
  function BoldPlugin() {
    var _this;
    _classCallCheck(this, BoldPlugin);
    _this = _super.call(this, "bold");
    _this.tags = ["b", "strong"];
    _this.styleName = "font-weight";
    _this.styleValues = ["bold", "600", "700", "800", "900", "normal"];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(BoldPlugin, [{
    key: "getID",
    value: function getID() {
      return "Bold";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "cf-icon cf-icon-bold",
        text: "B",
        tooltip: "nixps-tajiri.pluginbold_tooltip"
      };
    }

    /**------------------------------------------------------------------------------------------------
     * Function call to determine if bold is applied on a given node element
     * @param {Node} pNode the node to check.
     * @returns true if bold is applied, false otherwise
     */
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      // Here we only check if bold is applied through the tagName. 
      // and note the style weight.
      return this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
    }
  }, {
    key: "_isActiveInCSSAttribute",
    value: function _isActiveInCSSAttribute(pCSSAttribute) {
      return pCSSAttribute.search(/font-weight\s*:\s*(bold|500|600|700|800|900)/ig) >= 0;
    }
  }, {
    key: "_isDesactiveInCSSAttribute",
    value: function _isDesactiveInCSSAttribute(pCSSAttribute) {
      return pCSSAttribute.search(/font-weight\s*:\s*normal/i) >= 0;
    }
  }]);
  return BoldPlugin;
}(StyledPluginEC);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = BoldPlugin;
}

},{"./Plugin.js":362,"./StyledPluginEC.js":369}],337:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
//When removing all 

if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var ListPlugin = require("./ListPlugin.js");
  var Utils = require("./../../Utils.js");
}

/**
 * @description Plugin handling the BulletList style 
 * @memberof Tajiri
 * @extends ListPlugin
 */
var BulletListPlugin = /*#__PURE__*/function (_ListPlugin) {
  _inherits(BulletListPlugin, _ListPlugin);
  var _super = _createSuper(BulletListPlugin);
  function BulletListPlugin() {
    var _this;
    var pOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, BulletListPlugin);
    pOptions.command = "insertUnorderedList";
    _this = _super.call(this, pOptions);
    _this.tags = ["ul", "li"];
    _this.activeTags = ["ul"]; //we make a distinction because "li" would set both numbered & bullet as active

    _this.styleName = "";
    _this.styleValues = [];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(BulletListPlugin, [{
    key: "getID",
    value: function getID() {
      return "BulletListPlugin";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: StyledPluginEC.BUTTON_TOGGLE,
        icon: "fa fa-list-ul",
        text: "",
        tooltip: "nixps-tajiri.pluginbulletlist_tooltip"
      };
    }
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      if (pNode.nodeType === Node.TEXT_NODE) {
        pNode = pNode.parentElement;
      }
      var listNode = pNode.closest("ul, ol");
      if (listNode === null || listNode.nodeName.toLowerCase() === "ol") {
        return "skip";
      }
      return this.activeTags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var parentNode = pSelection.anchorNode.parentElement.closest("p, div");
      var range = pSelection.getRangeAt(0);
      parentNode.querySelectorAll("*").forEach(function (pNode) {
        if (pNode.style.cssText !== "") {
          pNode.setAttribute("data-tajiri-style", pNode.style.cssText);
        }
      });
      document.execCommand(this.command);
      parentNode.querySelectorAll("li").forEach(function (pNode) {
        var parent = pNode.parentElement;
        if (parent.nodeName.toLowerCase() !== "ul") {
          return;
        }
        var depth = 0;
        var current = parent;
        while (current && current !== parentNode && current.nodeName.toLowerCase() !== "div") {
          if (current.nodeName.toLowerCase() === "ul") {
            depth++;
          }
          current = current.parentElement;
        }
        switch (depth) {
          case 0:
          case 1:
            parent.style.listStyleType = "disc";
            break;
          case 2:
            parent.style.listStyleType = "circle";
            break;
          default:
            parent.style.listStyleType = "square";
            break;
        }
        range.setEndAfter(pNode);
      });
      Utils.applyDataStyleToRealStyle(parentNode);
    }
  }]);
  return BulletListPlugin;
}(ListPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = BulletListPlugin;
}

},{"./../../Utils.js":321,"./ListPlugin.js":358,"./StyledPluginEC.js":369}],338:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
}
/**------------------------------------------------------------------------------------------------
 * @description The ClickAndDragPlugin is an absctract plugin, and therefore cannot be instanciated as such. 
 * It's for plugin where the user can first enable it by clicking on its button, then apply styles
 * by selecting text. Once a text has been selected, the style will be applied and the tool will 
 * unselect itself
 * An option is provided to enable styling multiple consecutive selections
 * @extends Plugin
 */
var ClickAndDragPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(ClickAndDragPlugin, _Plugin);
  var _super = _createSuper(ClickAndDragPlugin);
  function ClickAndDragPlugin() {
    var _this;
    _classCallCheck(this, ClickAndDragPlugin);
    _this = _super.call(this);
    if (_this.constructor == ClickAndDragPlugin) {
      throw new Error("Abstract classes can't be instantiated.");
    }
    _this.sticky = false; // Flag to store if the sticky mode is enabled or not
    _this.active = false; // Flag to store if the plugin is enabled or not
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * @returns {boolean} true if the plugin is active, false otherwise
   */
  _createClass(ClickAndDragPlugin, [{
    key: "isActive",
    value: function isActive(pSelection, pRootNode) {
      return this.active;
    }

    /**------------------------------------------------------------------------------------------------
     * Support of the sticky mode, allowing the user to style multiple consecutive selection
     * @returns {boolean} true if supported, false otherwise
     */
  }, {
    key: "supportStickyMode",
    value: function supportStickyMode() {
      return false;
    }

    /**------------------------------------------------------------------------------------------------
     * @returns {boolean} true if the sticky mode of the plugin is enabled, false otherwise
     */
  }, {
    key: "isStickyModeEnabled",
    value: function isStickyModeEnabled() {
      return this.supportStickyMode() && this.sticky;
    }

    /**------------------------------------------------------------------------------------------------
     * Enable the sticky mode, if supported
     */
  }, {
    key: "enableStickyMode",
    value: function enableStickyMode() {
      if (this.supportStickyMode()) {
        this._log('Sticky mode: ON');
        this.sticky = true;
      }
    }

    /**------------------------------------------------------------------------------------------------
     * Disable the sticky mode, if supported
     */
  }, {
    key: "disableStickyMode",
    value: function disableStickyMode() {
      if (this.supportStickyMode()) {
        this._log('Sticky mode: OFF');
        this.sticky = false;
      }
      this.active = false;
    }

    /**------------------------------------------------------------------------------------------------
     * function called when the plugin is activated (the button is pressed)
     * 
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      this.active = true;
    }

    /**------------------------------------------------------------------------------------------------
     * function called when a text selection has ended and a style has to be applied to it.
     *  
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      if (!this.supportStickyMode()) {
        this.active = false;
      } else if (!this.sticky) {
        this.active = false;
      }
    }
  }]);
  return ClickAndDragPlugin;
}(Plugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = ClickAndDragPlugin;
}

},{"./Plugin.js":362}],339:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var AttributeStyledPlugin = require("./AttributeStyledPlugin.js");
}
/**
 * @description Plugin interface for Foreground and Background color plugins
 * @extends AttributeStyledPlugin
 */
var ColorPlugin = /*#__PURE__*/function (_AttributeStyledPlugi) {
  _inherits(ColorPlugin, _AttributeStyledPlugi);
  var _super = _createSuper(ColorPlugin);
  function ColorPlugin(options) {
    var _this;
    _classCallCheck(this, ColorPlugin);
    _this = _super.call(this, options);
    if (_this.constructor == ColorPlugin) {
      throw new Error("Abstract classes can't be instantiated.");
    }
    _this.copyMode = options && options.copyMode === true ? true : false;
    _this.color = "#FF0000";
    _this.index = 0;
    _this.styleAttributeSearcher = null;
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(ColorPlugin, [{
    key: "_getStyleValue",
    value: function _getStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        var value = this._colorToHex(pNode[this.attribute][this.property]);
        if (value !== "") {
          return value;
        } else if (this.styleAttributeSearcher !== null) {
          // in case the styles are not applied, but are there
          var attributeValues = pNode.getAttribute(this.attribute);
          if (typeof attributeValues === "string" && attributeValues.length > 0) {
            var matchers = (";" + attributeValues).match(this.styleAttributeSearcher);
            if (Array.isArray(matchers) && matchers.length == 2) {
              var canditateValue = matchers[1];
              if (canditateValue.indexOf("/") > 0 || canditateValue.indexOf(" repeat") > 0) {
                // multiple values in color, try get last word
                var colorIndex = canditateValue.search(/rgba?\(|#/i);
                if (colorIndex > 0) {
                  return this._colorToHex(canditateValue.substring(colorIndex));
                } else {
                  colorIndex = canditateValue.lastIndexOf(" ");
                  if (colorIndex > 0) {
                    return this._colorToHex(canditateValue.substring(colorIndex + 1));
                  }
                }
              }
              return this._colorToHex(matchers[1]);
            }
          }
        }
      }
      return "";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_setStyleValue",
    value: function _setStyleValue(pNode) {
      var node = pNode;
      if (this._getTagName(pNode) !== "span") {
        node = document.createElement("span");
        node.appendChild(pNode);
      }
      if (this._isDefined(node) && this._isDefined(node[this.attribute])) {
        node[this.attribute][this.property] = this.color;
      }
      return node;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_resetStyleValue",
    value: function _resetStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        pNode[this.attribute][this.property] = "";
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      if (pRootNode.contains(pSelection.getRangeAt(0).startContainer) === false) {
        return;
      }

      // if(!this.copyMode) {
      //     this._openColorChooser();
      // }

      if (this.color === "rgba(255, 255, 255, 0)") {
        _get(_getPrototypeOf(ColorPlugin.prototype), "unformat", this).call(this, pSelection, pRootNode);
      } else {
        document.execCommand("styleWithCSS", false, true);
        document.execCommand(this.command, false, this.color);
        if (pSelection.type === "Caret") {
          this.addZWS(pSelection, pRootNode);
        }
        this._applyStyleLater(pRootNode, pRootNode.innerHTML, pSelection);
        document.execCommand("styleWithCSS", false, false);
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_openColorChooser",
    value: function _openColorChooser() {
      this.color = this.colors[this.index];
      this.index = this.index < this.colors.length - 1 ? this.index + 1 : 0;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getValue",
    value: function getValue() {
      return this.color;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "setValue",
    value: function setValue(pValue) {
      this.color = pValue;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      _get(_getPrototypeOf(ColorPlugin.prototype), "unformat", this).call(this, pSelection, pRootNode);
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_isStyleDefined",
    value: function _isStyleDefined(pNode) {
      return this._isDefined(pNode) && this._isDefined(pNode[this.attribute]) && this._isDefined(pNode[this.attribute][this.property]);
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_areValueEquals",
    value: function _areValueEquals(pValue1, pValue2) {
      return this._colorToHex(pValue1) === this._colorToHex(pValue2);
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      return null;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_colorToHex",
    value: function _colorToHex(rgb) {
      function componentToHex(c) {
        var hex = parseInt(c.trim()).toString(16);
        return (hex.length == 1 ? "0" + hex : hex).toUpperCase();
      }
      if (rgb) {
        if (rgb.startsWith("rgb(")) {
          var arr = rgb.substring(4, rgb.length - 1).split(",");
          rgb = "#" + componentToHex(arr[0]) + componentToHex(arr[1]) + componentToHex(arr[2]);
        } else if (rgb.startsWith("#")) {
          rgb = rgb.toUpperCase();
        } else {
          // try to transform to known hex value
          var ctx = document.createElement("canvas").getContext("2d");
          ctx.fillStyle = rgb;
          rgb = ctx.fillStyle.toUpperCase();
        }
      }
      return rgb;
    }
  }, {
    key: "formatForPaste",
    value: function formatForPaste(pDOMTree) {
      var that = this;
      pDOMTree.querySelectorAll("*").forEach(function (pNode) {
        var value = that._getStyleValue(pNode);
        if (typeof value === "string" && value.length > 0 && that.getDefaultValue() !== value && value.toUpperCase() !== "RGBA(0, 0, 0, 0)") {
          if (pNode.tagName !== "SPAN") {
            // if main is not span, append a span with those values
            var spanElement = document.createElement("SPAN");
            // Copy the children
            while (pNode.firstChild) {
              spanElement.appendChild(pNode.firstChild); // *Moves* the child
            }
            // Copy the attributes
            for (var index = pNode.attributes.length - 1; index >= 0; --index) {
              spanElement.attributes.setNamedItem(pNode.attributes[index].cloneNode());
            }
            // append it
            pNode.appendChild(spanElement);
            pNode = spanElement;
          }
          var addedStyle = "" + that.property + ":" + value + ";";
          var originalStyle = pNode.getAttribute("data-tajiri-style");
          if (typeof originalStyle === "string" && originalStyle.length > 0) {
            pNode.setAttribute("data-tajiri-style", originalStyle + addedStyle);
          } else {
            pNode.setAttribute("data-tajiri-style", addedStyle);
          }
        }
      });
      return pDOMTree;
    }
  }, {
    key: "selectionChangeHandler",
    value: function selectionChangeHandler(pRootNode, pSelection, pEvent) {
      var colorPicker = $(pRootNode).closest(".nixps-Tajiri").find(".colorpicker-" + this.getID() + " .nixps-Colorpicker");
      var color = _get(_getPrototypeOf(ColorPlugin.prototype), "isActive", this).call(this, pSelection, pRootNode);
      if (pSelection.anchorNode.textContent.charCodeAt(0) === 8203 &&
      //checks if this is a span with just a ZeroWidthSpace 
      pSelection.anchorNode.textContent.length === 1) {
        //newly created color span, we don't want to change the colorpicker colro
        return;
      }
      if (typeof colorPicker.Colorpicker !== "function") {
        console.warn("ColorPlugin: include jQuery to use the ColorPlugin");
        return;
      }
      if (color !== false) {
        this.color = color;
        colorPicker.Colorpicker("setValue", color);
      } else {
        colorPicker.Colorpicker("setValue", null);
      }
    }
  }]);
  return ColorPlugin;
}(AttributeStyledPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = ColorPlugin;
}

},{"./AttributeStyledPlugin.js":334}],340:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function" && typeof ClickAndDragPlugin !== "function") {
  var ClickAndDragPlugin = require("./ClickAndDragPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * Plugin to copy style from a selection and let the user re-apply it to some other texts
 * @extends ClickAndDragPlugin
 */
var CopyStylePlugin = /*#__PURE__*/function (_ClickAndDragPlugin) {
  _inherits(CopyStylePlugin, _ClickAndDragPlugin);
  var _super = _createSuper(CopyStylePlugin);
  function CopyStylePlugin() {
    var _this;
    _classCallCheck(this, CopyStylePlugin);
    _this = _super.call(this);

    // Array of supported plugins for this instance of CopyStyle plugin
    _this.allPlugins = [];
    for (var i = 0; i < arguments.length; ++i) {
      var plugin = arguments[i];
      if (plugin instanceof Plugin) {
        _this.allPlugins.push({
          plugin: plugin,
          value: null
        });
      }
    }
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(CopyStylePlugin, [{
    key: "getID",
    value: function getID() {
      return "CopyStyle";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin's button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-paint-brush",
        text: "nixps-tajiri.plugincopystyle_tooltip",
        tooltip: "nixps-tajiri.plugincopystyle_tooltip"
      };
    }

    /**------------------------------------------------------------------------------------------------
     * Support of the sticky mode, allowing the user to style multiple consecutive selection
     * @returns true. This mode is enabled
     */
  }, {
    key: "supportStickyMode",
    value: function supportStickyMode() {
      return true;
    }

    /**------------------------------------------------------------------------------------------------
     * function called when the plugin is activated (the button is pressed)
     * 
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      _get(_getPrototypeOf(CopyStylePlugin.prototype), "format", this).call(this, pSelection, pRootNode);

      // For each plugins, find if their own style is applied on the current selection, and save it, 
      // so it can be re-applied later
      this.allPlugins.forEach(function (pluginInfo) {
        var value = pluginInfo.plugin.isActive(pSelection, pRootNode);
        pluginInfo.value = value;
      });
    }

    /**------------------------------------------------------------------------------------------------
     * function called when a text selection has ended and a style has to be applied to it.
     *  
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      _get(_getPrototypeOf(CopyStylePlugin.prototype), "unformat", this).call(this, pSelection, pRootNode);

      // For each plugin, if their own style was active on the previous selection, then re-apply it 
      // on the current selection.
      this.allPlugins.forEach(function (pluginInfo) {
        var currentValue = pluginInfo.plugin.isActive(pSelection, pRootNode);
        if (currentValue === pluginInfo.value) {
          return;
        }
        pluginInfo.plugin.setValue(pluginInfo.value);
        pluginInfo.plugin.format(pSelection, pRootNode);
      });
    }
  }]);
  return CopyStylePlugin;
}(ClickAndDragPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = CopyStylePlugin;
}

},{"./ClickAndDragPlugin.js":338,"./Plugin.js":362}],341:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var AttributeStyledPlugin = require("./AttributeStyledPlugin.js");
}
/**
 * @extends AttributeStyledPlugin
 */
var DirectionPlugin = /*#__PURE__*/function (_AttributeStyledPlugi) {
  _inherits(DirectionPlugin, _AttributeStyledPlugi);
  var _super = _createSuper(DirectionPlugin);
  function DirectionPlugin() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, DirectionPlugin);
    _this = _super.call(this);
    if (_this.constructor == DirectionPlugin) {
      throw new Error("Abstract classes can't be instantiated.");
    }
    _this.possibilities = ["div", "p"];
    _this.enterMode = options.enterMode ? options.enterMode : "";
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(DirectionPlugin, [{
    key: "_isStyleDefined",
    value: function _isStyleDefined(pNode) {
      return this._isDefined(pNode) && this._isDefined(pNode[this.attribute]) && "" + pNode[this.attribute].toLowerCase() === this.value;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_getStyleValue",
    value: function _getStyleValue(pNode) {
      return this._isStyleDefined(pNode) ? pNode[this.attribute] : '';
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_resetStyleValue",
    value: function _resetStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        pNode[this.attribute] = '';
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_setStyleValue",
    value: function _setStyleValue(pNode) {
      var node = pNode;
      if (this._getTagName(pNode) !== 'p') {
        node = document.createElement('p');
        node.appendChild(pNode);
      }
      if (this._isDefined(node) && this._isDefined(node[this.attribute])) {
        node[this.attribute] = this.value;
      }
      return node;
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      var pNodes = [];
      var range = pSelection.getRangeAt(0);
      var rangeCache = {
        startNode: range.startContainer,
        endNode: range.endContainer,
        startOffset: range.startOffset,
        endOffset: range.endOffset
      };
      var startTag = null;
      var endTag = null;
      var i = 0;
      while (startTag === null) {
        var startContainer = range.startContainer;
        if (startContainer.nodeType === Node.TEXT_NODE) {
          startContainer = startContainer.parentNode;
        }
        startTag = startContainer.closest(this.possibilities[i]);
        if (pRootNode.contains(startTag) === false || startTag.isEqualNode(pRootNode)) {
          startTag = null;
        }
        if (i === this.possibilities.length - 1) {
          break;
        }
        i++;
      }
      i = 0;
      while (endTag === null) {
        var endContainer = range.endContainer;
        if (endContainer.nodeType === Node.TEXT_NODE) {
          endContainer = endContainer.parentNode;
        }
        endTag = endContainer.closest(this.possibilities[i]);
        if (pRootNode.contains(endTag) === false || endTag.isEqualNode(pRootNode)) {
          endTag = null;
        }
        if (i === this.possibilities.length - 1) {
          break;
        }
        i++;
      }
      if (startTag === null || endTag === null) {
        var paraElement = document.createElement(this.enterMode);
        var insertBefore = null;
        var appendEls = [];
        if (pRootNode.childNodes.length > 0) {
          for (var i = 0; i < pRootNode.childNodes.length; i++) {
            if (pRootNode.childNodes[i].nodeType !== Node.TEXT_NODE && this.possibilities.includes(pRootNode.childNodes[i].nodeName.toLowerCase()) && range.startContainer.compareDocumentPosition(pRootNode.childNodes[i]) === 4) {
              insertBefore = pRootNode.childNodes[i];
              break;
            } else if (this.possibilities.includes(pRootNode.childNodes[i].nodeName.toLowerCase())) {
              appendEls = [];
            } else {
              appendEls.push(pRootNode.childNodes[i]);
            }
          }
        }
        appendEls.forEach(function (n) {
          paraElement.append(n);
        });
        if (insertBefore !== null) {
          pRootNode.insertBefore(paraElement, insertBefore);
        } else {
          pRootNode.append(paraElement);
        }
        var range = new Range();
        if (appendEls.length > 0) {
          range.setStart(rangeCache.startNode, rangeCache.startOffset);
          range.setEnd(rangeCache.endNode, rangeCache.endOffset);
          pSelection.removeAllRanges();
          pSelection.addRange(range);
        } else {
          range.setStart(paraElement, 0);
          range.setEnd(paraElement, 0);
          pSelection.removeAllRanges();
          pSelection.addRange(range);
        }
        this.format(pSelection, pRootNode);
        return;
      }
      var nextSiblings = [];
      var current = startTag;
      while (current.nextSibling) {
        nextSiblings.push(current.nextSibling);
        current = current.nextSibling;
      }
      if (startTag === endTag) {
        pNodes.push(startTag);
      } else {
        pNodes.push(startTag);
        //loop over the siblings, push any that are a block element, until the sibling equals the endNode
        nextSiblings.forEach(function (pSibling) {
          if (pSibling !== endTag && that.possibilities.includes(pSibling.nodeName.toLowerCase())) {
            pNodes.push(pSibling);
          } else if (pSibling === endTag) {
            return false;
          }
        });
        pNodes.push(endTag);
      }
      for (var i = 0; i < pNodes.length; i++) {
        if (pNodes[i].isEqualNode(pRootNode)) {
          pNodes.splice(i, 1);
        }
      }
      _get(_getPrototypeOf(DirectionPlugin.prototype), "formatExistingNodes", this).call(this, pNodes);
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_getSelectedContent",
    value: function _getSelectedContent(pSelection, pRootNode) {
      var range = pSelection.getRangeAt(0);
      var ancestor = range.commonAncestorContainer;
      while (ancestor.nodeType !== Node.ELEMENT_NODE) {
        ancestor = ancestor.parentNode;
      }
      while (this._getTagName(ancestor) !== 'p' && pRootNode.contains(ancestor) && !pRootNode.isEqualNode(ancestor)) {
        ancestor = ancestor.parentNode;
      }
      if (pRootNode.isEqualNode(ancestor)) {
        var that = this;
        if (!Array.from(pRootNode.childNodes).some(function (pNode) {
          return that._getTagName(pNode) === "p";
        })) {
          var paragraphElement = document.createElement('p');
          paragraphElement.append.apply(paragraphElement, Array.from(pRootNode.childNodes));
          pRootNode.append(paragraphElement);
          return paragraphElement;
        } else {
          console.error("unsupported situation");
          return pSelection.anchorNode.closest("p");
        }
        // return ancestor;
      }

      if (this._getTagName(ancestor) !== 'p') {
        var tmp = ancestor;
        ancestor = document.createElement('p');
        ancestor.appendChild(tmp);
      }
      return ancestor;
    }
  }, {
    key: "_setNodeInSelection",
    value: function _setNodeInSelection(pSelection, pNode) {
      var range = new Range();
      range.setStart(pNode, 0);
      range.setEnd(pNode, pNode.childNodes.length);
      pSelection.addRange(range);
    }
  }, {
    key: "formatForPaste",
    value: function formatForPaste(pDOMTree) {
      // translate the direction to lowercase
      pDOMTree.querySelectorAll("[dir]").forEach(function (pNode) {
        pNode.setAttribute("dir", ("" + pNode.getAttribute("dir")).toLowerCase());
      });
      if (pDOMTree.querySelectorAll("p,div").length === 0) {
        pDOMTree.querySelectorAll("span[dir]").forEach(function (pNode) {
          var paragraphElement = document.createElement("p");
          // Copy the children
          while (pNode.firstChild) {
            paragraphElement.appendChild(pNode.firstChild); // *Moves* the child
          }
          // Copy the attributes
          for (var index = pNode.attributes.length - 1; index >= 0; --index) {
            paragraphElement.attributes.setNamedItem(pNode.attributes[index].cloneNode());
          }
          // Replace it
          pNode.parentNode.replaceChild(paragraphElement, pNode);
        });
      }
      pDOMTree.querySelectorAll("span[dir]").forEach(function (pNode) {
        pNode.removeAttribute("dir");
      });
      var foundParagraphs = false;
      pDOMTree.querySelectorAll("p *:not([dir]), div *:not([dir]), p:not([dir]), div:not([dir])").forEach(function (pNode) {
        foundParagraphs = true;
        var originalStyle = pNode.getAttribute("style");
        if (typeof originalStyle === "string" && originalStyle.length > 0) {
          var matchedStyle = (";" + originalStyle).match(/;\s*direction:\s*(rtl|ltr)/i);
          if (Array.isArray(matchedStyle) && matchedStyle.length > 1) {
            var dirValue = matchedStyle[1].toLowerCase();
            var parent = pNode.closest("p, div");
            if (parent.getAttribute("dir") === null) {
              parent.setAttribute("dir", dirValue);
            }
          }
        }
      });
      if (foundParagraphs === false) {
        var singleSpans = pDOMTree.querySelectorAll("span:not([dir]");
        for (var i = 0; i < singleSpans.length; i++) {
          var originalStyle = singleSpans[i].getAttribute("style");
          if (typeof originalStyle === "string" && originalStyle.length > 0) {
            var matchedStyle = (";" + originalStyle).match(/;\s*direction:\s*(rtl|ltr)/i);
            if (Array.isArray(matchedStyle) && matchedStyle.length > 1) {
              var dirValue = matchedStyle[1].toLowerCase();
              var parents = singleSpans[i].closest("body");
              var paragraphDOM = document.createElement("p");
              paragraphDOM.setAttribute("dir", dirValue);
              while (parents.firstChild) {
                paragraphDOM.append(parents.firstChild);
              }
              parents.append(paragraphDOM);
              break;
            }
          }
        }
      }
      return pDOMTree;
    }
  }]);
  return DirectionPlugin;
}(AttributeStyledPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = DirectionPlugin;
}

},{"./AttributeStyledPlugin.js":334}],342:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var ColorPlugin = require("./ColorPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends ColorPlugin
 */
var FGColorPlugin = /*#__PURE__*/function (_ColorPlugin) {
  _inherits(FGColorPlugin, _ColorPlugin);
  var _super = _createSuper(FGColorPlugin);
  function FGColorPlugin(options) {
    var _this;
    _classCallCheck(this, FGColorPlugin);
    _this = _super.call(this, options);
    _this.attribute = "style";
    _this.property = "color";
    _this.command = "foreColor";
    _this.styleAttributeSearcher = new RegExp(";\\s*(?:-webkit-text-fill-){0,1}color\\s*:\\s*([^;]*);*", "i");
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(FGColorPlugin, [{
    key: "getID",
    value: function getID() {
      return "FGColor";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_COLORPICKER,
        icon: "fa fa-font",
        text: "FG",
        tooltip: "FG Color",
        options: {
          togglePaletteOnly: false,
          palette: [["#fff", "#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#D7D6EC"], ["#eee", "#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#AFAFDB"], ["#ccc", "#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8687C9"], ["#999", "#d43d3d", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#0080BF", "#5E6BBE"], ["#000", "#900", "#b45f06", "#bf9000", "#38761d", "#2F6B78", "#276FB0", "#5756A9"]]
        }
      };
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      return "#000000";
    }
  }]);
  return FGColorPlugin;
}(ColorPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = FGColorPlugin;
}

},{"./ColorPlugin.js":339,"./Plugin.js":362}],343:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var AttributeStyledPlugin = require("./AttributeStyledPlugin.js");
  var Utils = require("../../Utils.js");
  var Plugin = require("./Plugin.js");
}

/**
 * @description Plugin handling the BOLD style 
 * @extends AttributeStyledPlugin
 */
var FontFamilyPlugin = /*#__PURE__*/function (_AttributeStyledPlugi) {
  _inherits(FontFamilyPlugin, _AttributeStyledPlugi);
  var _super = _createSuper(FontFamilyPlugin);
  function FontFamilyPlugin(pOptions) {
    var _this;
    _classCallCheck(this, FontFamilyPlugin);
    _this = _super.call(this, pOptions);
    _this.tags = [];
    _this.attribute = "style";
    _this.property = "fontFamily";
    _this.value = "";
    _this._supportedNames = [{
      name: "Arial",
      value: "Arial, Helvetica, sans-serif"
    }, {
      name: "Comic Sans MS",
      value: "Comic Sans MS, cursive"
    }, {
      name: "Courier New",
      value: "Courier New, Courier, monospace"
    }, {
      name: "Georgia",
      value: "Georgia, serif"
    }, {
      name: "Lucida Sans Unicode",
      value: "Lucida Sans Unicode, Lucida Grande, sans-serif"
    }, {
      name: "Tahoma",
      value: "Tahoma, Geneva, sans-serif"
    }, {
      name: "Times New Roman",
      value: "Times New Roman, Times, serif"
    }, {
      name: "Trebuchet MS",
      value: "Trebuchet MS, Helvetica, sans-serif"
    }, {
      name: "Verdana",
      value: "Verdana, Geneva, sans-serif"
    }];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(FontFamilyPlugin, [{
    key: "getID",
    value: function getID() {
      return "FontFamily";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_SELECT,
        options: [{
          value: "",
          label: "nixps-tajiri.generic_default_label"
        }].concat(this._supportedNames.map(function (pFamily) {
          return {
            value: pFamily.value,
            label: pFamily.name
          };
        })),
        icon: null,
        text: "nixps-tajiri.pluginfontfamily_label",
        tooltip: "nixps-tajiri.pluginfontfamily_tooltip"
      };
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Get the style on a given node if it exist
     * @param {Node} pNode : the node to read the style from
     * @returns {*} true or the style value if it exists, en empty string otherwise
     */
  }, {
    key: "_getStyleValue",
    value: function _getStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        return this._getValue(pNode[this.attribute][this.property]);
      }
      return "";
    }
  }, {
    key: "_isStyleDefined",
    value: function _isStyleDefined(pNode) {
      return this._isDefined(pNode) && this._isDefined(pNode[this.attribute]) && this._isDefined(pNode[this.attribute][this.property]);
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Set the style on a given node.
     * @param {Node} pNode : the node to set the style on
     */
  }, {
    key: "_setStyleValue",
    value: function _setStyleValue(pNode) {
      var node = pNode;
      if (this._getTagName(pNode) !== "span") {
        node = document.createElement("span");
        node.appendChild(pNode);
      }
      if (this._isDefined(node) && this._isDefined(node[this.attribute])) {
        node[this.attribute][this.property] = this.value;
      }
      return node;
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Reset the style on a given node.
     * @param {Node} pNode : the node to reset the style on
     */
  }, {
    key: "_resetStyleValue",
    value: function _resetStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        pNode[this.attribute][this.property] = "";
      }
    }
  }, {
    key: "_getValue",
    value: function _getValue(pStyleString) {
      if (typeof pStyleString !== "string") {
        return "";
      }
      var styleString = pStyleString.replace(/['"]/g, "").trim();
      for (var i = 0; i < this._supportedNames.length; i++) {
        if (styleString.indexOf(this._supportedNames[i].name) === 0) {
          return this._supportedNames[i].value;
        }
      }
      return "";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "setValue",
    value: function setValue(pValue) {
      if (typeof pValue !== "string") {
        this.value = "";
      } else {
        this.value = pValue;
      }
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var value = this.value;
      if (this.value === "") {
        value = "data-tajiri-fontfamily-unformat";
      }
      document.execCommand("styleWithCSS", false, true);
      document.execCommand("fontName", false, value);
      if (pSelection.type === "Caret") {
        this.addZWS(pSelection, pRootNode);
      }
      var styledSpans = pRootNode.querySelectorAll("span[style]");
      styledSpans.forEach(function (pStyledSpan) {
        if (pStyledSpan.style["fontFamily"] === "data-tajiri-fontfamily-unformat") {
          pStyledSpan.style["fontFamily"] = "";
        }
      });
      this._applyStyleLater(pRootNode, pRootNode.innerHTML, pSelection);
      document.execCommand("styleWithCSS", false, false);
    }
  }, {
    key: "formatForPaste",
    value: function formatForPaste(pDOMTree) {
      var that = this;
      pDOMTree.querySelectorAll("*").forEach(function (pNode) {
        var currentStyle = pNode.getAttribute("style");
        if (typeof currentStyle === "string" && currentStyle.length > 0) {
          var matched = currentStyle.match(/font-family\s*:\s*([^;]*)/i);
          if (Array.isArray(matched) && matched.length > 1) {
            var value = that._getValue(matched[1]);
            if (typeof value === "string" && value.length > 0) {
              var addedStyle = "" + that.property + ":" + value + ";";
              var originalStyle = pNode.getAttribute("data-tajiri-style");
              if (typeof originalStyle === "string" && originalStyle.length > 0) {
                pNode.setAttribute("data-tajiri-style", originalStyle + addedStyle);
              } else {
                pNode.setAttribute("data-tajiri-style", addedStyle);
              }
            }
          }
        }
      });
      return pDOMTree;
    }
  }]);
  return FontFamilyPlugin;
}(AttributeStyledPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = FontFamilyPlugin;
}

},{"../../Utils.js":321,"./AttributeStyledPlugin.js":334,"./Plugin.js":362}],344:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var AttributeStyledPlugin = require("./AttributeStyledPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends AttributeStyledPlugin
 */
var FontSizePlugin = /*#__PURE__*/function (_AttributeStyledPlugi) {
  _inherits(FontSizePlugin, _AttributeStyledPlugi);
  var _super = _createSuper(FontSizePlugin);
  function FontSizePlugin(pOptions) {
    var _this;
    _classCallCheck(this, FontSizePlugin);
    _this = _super.call(this, pOptions);
    _this.tags = [];
    _this.attribute = "style";
    _this.property = "fontSize";
    _this.value = "";
    _this.active = false;
    _this.supportedSizes = ["8", "9", "10", "11", "12", "14", "16", "18", "20", "22", "24", "26", "28", "36", "48", "72"];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(FontSizePlugin, [{
    key: "getID",
    value: function getID() {
      return "FontSize";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_SELECT,
        options: [{
          value: "",
          label: "(Default)"
        }].concat(this.supportedSizes.map(function (pSize) {
          return {
            value: pSize + "px",
            label: pSize
          };
        })),
        icon: null,
        text: "nixps-tajiri.pluginfontsize_label",
        tooltip: "nixps-tajiri.pluginfontsize_tooltip"
      };
    }
  }, {
    key: "_isStyleDefined",
    value: function _isStyleDefined(pNode) {
      return this._isDefined(pNode) && this._isDefined(pNode[this.attribute]) && this._isDefined(pNode[this.attribute][this.property]);
    }
  }, {
    key: "_getValue",
    value: function _getValue(pStyleString) {
      if (typeof pStyleString !== "string") {
        return "";
      }
      var styleString = pStyleString.replace(/['"]/g, "").trim();
      for (var i = 0; i < this.supportedSizes.length; i++) {
        if (styleString.indexOf(this.supportedSizes[i]) === 0) {
          return this.supportedSizes[i] + "px";
        }
      }
      return "";
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Get the style on a given node if it exist
     * @param {Node} pNode : the node to read the style from
     * @returns {*} true or the style value if it exists, en empty string otherwise
     */
  }, {
    key: "_getStyleValue",
    value: function _getStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        return this._getValue(pNode[this.attribute][this.property]);
      }
      return "";
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Set the style on a given node.
     * @param {Node} pNode : the node to set the style on
    */
  }, {
    key: "_setStyleValue",
    value: function _setStyleValue(pNode) {
      var node = pNode;
      if (this._getTagName(pNode) !== "span") {
        node = document.createElement("span");
        node.appendChild(pNode);
      }
      if (this._isDefined(node) && this._isDefined(node[this.attribute])) {
        node[this.attribute][this.property] = this.value;
      }
      return node;
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Reset the style on a given node.
     * @param {Node} pNode : the node to reset the style on
     */
  }, {
    key: "_resetStyleValue",
    value: function _resetStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        pNode[this.attribute][this.property] = "";
      }
    }
  }, {
    key: "setValue",
    value: function setValue(pValue) {
      this.value = pValue;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "_isFirefoxPlaceholderNode",
    value: function _isFirefoxPlaceholderNode(pNode) {
      if (this._isDefined(pNode) === false) {
        return false;
      }
      if (pNode.size === "1") {
        return true;
      }
      if (this._isDefined(pNode.style) === false || typeof pNode.style["fontSize"] !== "string") {
        return false;
      }
      var placeholderFontSize = pNode.style["fontSize"].trim().toLowerCase();
      return placeholderFontSize === "x-small" || placeholderFontSize === "10px";
    }
  }, {
    key: "_normalizeFirefoxPlaceholderNode",
    value: function _normalizeFirefoxPlaceholderNode(pStyledSpan, pSelection, pRange) {
      if (this._isFirefoxPlaceholderNode(pStyledSpan) === false) {
        return false;
      }
      if (pStyledSpan.size === "1") {
        pStyledSpan.removeAttribute("size");
        var spanTag = this._replaceTagname(pStyledSpan, "span");
        pStyledSpan.replaceWith(spanTag);
        spanTag.style["fontSize"] = this.value;
        var range = pSelection.getRangeAt(0);
        range.setStart(spanTag, 0);
        range.setEnd(spanTag, spanTag.childNodes.length);
        pSelection.removeAllRanges();
        pSelection.addRange(range);
        return spanTag;
      }
      pStyledSpan.style["fontSize"] = this.value;
      return pStyledSpan;
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var addZWS = false;
      // Firefox fix: this is to prevent resizing unrelated fontsize: 10px later on, because firefox uses font size 10px for the placeholder node when using fontSize command with styleWithCSS enabled. We mark these nodes with a custom attribute to prevent them from being resized later on.
      pRootNode.querySelectorAll("span[style]").forEach(function (pStyledSpan) {
        if (pStyledSpan.style["fontSize"].trim().toLowerCase() === "10px") {
          pStyledSpan.setAttribute("data-tajiri-dont-touch", "true");
        }
      }, this);
      var commandRange = pSelection.rangeCount > 0 ? pSelection.getRangeAt(0).cloneRange() : null;
      if (pSelection.type === "Caret") {
        addZWS = true;
      }
      document.execCommand("styleWithCSS", false, true);
      document.execCommand("fontSize", false, 1);
      if (addZWS === true) {
        this.addZWS(pSelection, pRootNode);
      }
      var selectionRanges = [commandRange];
      if (pSelection.rangeCount > 0) {
        selectionRanges.push(pSelection.getRangeAt(0).cloneRange());
      }
      //include font tags with size 1 --> FireFox does not respect styleWithCSS using fontSize
      var styledSpans = pRootNode.querySelectorAll("span[style]:not([data-tajiri-dont-touch='true']), font[size='1']");
      var normalizeSpans = [];
      styledSpans.forEach(function (pStyledSpan) {
        var normalized = this._normalizeFirefoxPlaceholderNode(pStyledSpan, pSelection, selectionRanges);
        if (normalized) {
          normalizeSpans.push(normalized);
        }
      }, this);
      if (normalizeSpans.length > 0) {
        var range = pSelection.getRangeAt(0);
        range.setStart(normalizeSpans[0], 0);
        range.setEnd(normalizeSpans[normalizeSpans.length - 1], normalizeSpans[normalizeSpans.length - 1].childNodes.length);
        pSelection.removeAllRanges();
        pSelection.addRange(range);
      }
      this._applyStyleLater(pRootNode, pRootNode.innerHTML, pSelection);
      pRootNode.querySelectorAll("span[data-tajiri-dont-touch='true']").forEach(function (pStyledSpan) {
        pStyledSpan.removeAttribute("data-tajiri-dont-touch");
      });
      document.execCommand("styleWithCSS", false, false);
    }
  }, {
    key: "formatForPaste",
    value: function formatForPaste(pDOMTree) {
      var that = this;
      pDOMTree.querySelectorAll("*").forEach(function (pNode) {
        var currentStyle = pNode.getAttribute("style");
        if (typeof currentStyle === "string" && currentStyle.length > 0) {
          var matched = currentStyle.match(/font-size\s*:\s*([^;]*)/i);
          if (Array.isArray(matched) && matched.length > 1) {
            var value = that._getValue(matched[1]);
            if (typeof value === "string" && value.length > 0) {
              var addedStyle = "" + that.property + ":" + value + ";";
              var originalStyle = pNode.getAttribute("data-tajiri-style");
              if (typeof originalStyle === "string" && originalStyle.length > 0) {
                pNode.setAttribute("data-tajiri-style", originalStyle + addedStyle);
              } else {
                pNode.setAttribute("data-tajiri-style", addedStyle);
              }
            }
          }
        }
      });
      return pDOMTree;
    }
  }]);
  return FontSizePlugin;
}(AttributeStyledPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = FontSizePlugin;
}

},{"./AttributeStyledPlugin.js":334,"./Plugin.js":362}],345:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends StyledPluginEC
 */
var HeadingPlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(HeadingPlugin, _StyledPluginEC);
  var _super = _createSuper(HeadingPlugin);
  function HeadingPlugin() {
    var _this;
    var pOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, HeadingPlugin);
    if (pOptions.tags === undefined || Array.isArray(pOptions.tags) === false) {
      throw new Error("HeadingPlugin: tags option must be present and must be an array");
    }
    if (pOptions.tags.includes("normal") === false && pOptions.tags.includes("NORMAL") === false) {
      pOptions.tags.unshift("normal");
    }
    _this = _super.call(this, "heading");
    _this.tags = pOptions.tags;
    _this.possibleTags = ["h1", "h2", "h3", "pre", "p", "div"];
    _this.value = "";
    _this.active = false;
    _this.enterMode = pOptions.enterMode ? pOptions.enterMode : "";
    return _this;
  }
  _createClass(HeadingPlugin, [{
    key: "getID",
    value: function getID() {
      return "Heading";
    }
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      this.active = this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
      if (this.active === true) {
        this.setValue(pNode.nodeName.toLowerCase());
        return this.getValue();
      }
      return false;
    }
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      var options = [];
      for (var i = 0; i < this.tags.length; i++) {
        var tag = this.tags[i];
        switch (tag) {
          case "normal":
            options.push({
              value: "",
              label: "nixps-tajiri.generic_normal_label"
            });
            break;
          case "h1":
            options.push({
              value: tag,
              label: "nixps-tajiri.pluginheader_option_heading1"
            });
            break;
          case "h2":
            options.push({
              value: tag,
              label: "nixps-tajiri.pluginheader_option_heading2"
            });
            break;
          case "h3":
            options.push({
              value: tag,
              label: "nixps-tajiri.pluginheader_option_heading3"
            });
            break;
          case "h4":
            options.push({
              value: tag,
              label: "Heading 4"
            });
            break;
          case "h5":
            options.push({
              value: tag,
              label: "Heading 5"
            });
            break;
          case "h6":
            options.push({
              value: tag,
              label: "Heading 6"
            });
            break;
          case "pre":
            options.push({
              value: tag,
              label: "nixps-tajiri.pluginheader_option_pre"
            });
            break;
          default:
            throw new Error("HeadingPlugin: " + tag + " is not supported by the plugin");
        }
      }
      return {
        type: Plugin.BUTTON_SELECT,
        options: options,
        icon: null,
        text: "nixps-tajiri.pluginheader_tooltip",
        tooltip: "nixps-tajiri.pluginheader_tooltip"
      };
    }
  }, {
    key: "setValue",
    value: function setValue(pValue) {
      this.value = pValue;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value.length > 0 ? this.value : this.enterMode;
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      var selection = pSelection;
      var range = selection.getRangeAt(0);
      var savedRange = {
        startOffset: range.startOffset,
        endOffset: range.endOffset
      };
      var startContainer = range.startContainer;
      var endContainer = range.endContainer;
      if (startContainer.nodeType === Node.TEXT_NODE && startContainer.parentElement === pRootNode) {
        //startcontainer = text thats a direct child to rootnode
        var wrapper = document.createElement("p");
        startContainer.parentElement.insertBefore(wrapper, startContainer);
        wrapper.append(startContainer);
        startContainer = wrapper;
      }
      if (endContainer.nodeType === Node.TEXT_NODE && endContainer.parentElement === pRootNode) {
        //endcontainer = text thats a direct child to rootnode
        var wrapper = document.createElement("p");
        endContainer.parentElement.insertBefore(wrapper, endContainer);
        wrapper.append(endContainer);
        endContainer = wrapper;
      }
      startContainer.nodeType === Node.TEXT_NODE ? startContainer.parentElement.setAttribute("data-tajiri-selection-start", savedRange.startOffset) : startContainer.setAttribute("data-tajiri-selection-start", savedRange.startOffset);
      endContainer.nodeType === Node.TEXT_NODE ? endContainer.parentElement.setAttribute("data-tajiri-selection-end", savedRange.endOffset) : endContainer.setAttribute("data-tajiri-selection-end", savedRange.endOffset);
      if (startContainer.nodeType === Node.TEXT_NODE) {
        startContainer = startContainer.parentElement;
      }
      if (endContainer.nodeType === Node.TEXT_NODE) {
        endContainer = endContainer.parentElement;
      }
      var foundExistingTags = [];
      if (startContainer.closest(this.possibleTags.join(", ")) === null) {
        //there's no block element, just push the anchornode 
        if (startContainer !== pRootNode) {
          foundExistingTags.push(startContainer);
        } else {
          foundExistingTags.push(range.startContainer);
        }
      } else {
        var candidate = startContainer.closest(this.possibleTags.join(", "));
        while (candidate.parentElement !== pRootNode) {
          //we want the direct child to the rootnode
          if (candidate.closest(this.possibleTags.join(", ")) === null) {
            break;
          } else {
            candidate = candidate.closest(this.possibleTags.join(", "));
          }
        }
        foundExistingTags.push(candidate);
      }
      if (selection.type === "Range") {
        //found the first block element, now go down nextSibling until we hit the endNode's closest blockelement
        var focusNode = foundExistingTags[0];
        var counter = 0;
        while (foundExistingTags[foundExistingTags.length - 1] !== endContainer.closest(this.possibleTags.join(", "))) {
          if (counter > 500) {
            console.error("HeadingPlugin: could not find multiple nodes in range");
            break;
          }
          foundExistingTags.push(focusNode.nextSibling.closest(this.possibleTags.join(", ")));
          focusNode = focusNode.nextSibling.closest(this.possibleTags.join(", "));
          counter++;
        }
      }
      var toRemove = [];
      foundExistingTags.forEach(function (pFoundTag, pIndex) {
        if (pFoundTag.nodeType === Node.TEXT_NODE) {
          var enterTag = document.createElement("p");
          enterTag.append(pFoundTag.cloneNode());
          pFoundTag.parentElement.replaceChild(enterTag, pFoundTag);
          pFoundTag = enterTag;
        }
        var newTag = that._replaceTagname(pFoundTag, that.getValue().toLowerCase());
        pFoundTag.after(newTag);
        toRemove.push(pFoundTag);
      });
      toRemove.forEach(function (n) {
        n.remove();
      });
      var startNode = pRootNode.querySelector("[data-tajiri-selection-start]");
      var endNode = pRootNode.querySelector("[data-tajiri-selection-end]");
      range.setStart(startNode.childNodes[0], startNode.getAttribute("data-tajiri-selection-start"));
      range.setEnd(endNode.childNodes[0], endNode.getAttribute("data-tajiri-selection-end"));
      startNode.removeAttribute("data-tajiri-selection-start");
      endNode.removeAttribute("data-tajiri-selection-end");
      // var editMode = false;

      // if (this.active === true || selection.type === "Range") {
      //     this.possibleTags.forEach(function(pPossibleTag) {
      //         var existingTag = pSelection.anchorNode.parentNode.closest(pPossibleTag);
      //         if (existingTag !== null) {
      //             headingNode = existingTag;
      //             editMode = true;
      //             return;
      //         }
      //     })
      // }
      // headingNode.appendChild(range.extractContents());
      // range.deleteContents();
      // if (headingNode.textContent <= 0) {
      //     headingNode.innerHTML = "&ZeroWidthSpace;"; 
      // }

      // if (editMode === false) {
      //     range.insertNode(headingNode);
      //     range.selectNodeContents(headingNode);
      //     selection.removeAllRanges();
      //     selection.addRange(range);
      // } else {
      //     var newHeading = document.createElement("p");
      //     if (this.getValue().toLowerCase().length > 0) {
      //         newHeading = document.createElement(this.getValue().toLowerCase());
      //     }
      //     //1. get all block elements from the selection, from startnode to endnode
      //     //2. replace all with the new heading tag
      //     while (headingNode.firstChild) {
      //         newHeading.appendChild(headingNode.firstChild);
      //     }
      //     for (var index = headingNode.attributes.length - 1; index >= 0; --index) {
      //         newHeading.attributes.setNamedItem(headingNode.attributes[index].cloneNode());
      //     }
      //     $(headingNode).replaceWith(newHeading);
      // }
    }
  }, {
    key: "unformat",
    value: function unformat() {}
  }]);
  return HeadingPlugin;
}(StyledPluginEC);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = HeadingPlugin;
}

},{"./Plugin.js":362,"./StyledPluginEC.js":369}],346:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Plugin = require("./Plugin.js");
  var EnterModeCleaner = require("../cleaners/EnterModeCleaner.js");
  require("../dialogs/nixps-cloudflow-HyperLinkDialog.js");
}
/**
 * @extends StyledPluginEC
 */
var HyperLinkPlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(HyperLinkPlugin, _StyledPluginEC);
  var _super = _createSuper(HyperLinkPlugin);
  function HyperLinkPlugin(pOptions) {
    var _this;
    _classCallCheck(this, HyperLinkPlugin);
    _this = _super.call(this, "createLink", "unlink");
    _this.tags = ["a"];
    _this.enterMode = pOptions !== undefined && pOptions.enterMode !== undefined ? pOptions.enterMode : "";
    return _this;
  }
  //------------------------------------------------------------------------------------------------
  _createClass(HyperLinkPlugin, [{
    key: "getID",
    value: function getID() {
      return "Link";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-link",
        text: "Link",
        tooltip: "nixps-tajiri.pluginhyperlink_tooltip"
      };
    }
  }, {
    key: "getValidAttributeNames",
    value: function getValidAttributeNames() {
      return ["href"];
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      //clean the HTML for entermode tags first -- might be first change so html hasn't been cleaned yet
      //hyperlinkplugin does not work when text selected is direct child to root
      new EnterModeCleaner({
        enterMode: this.enterMode
      }).clean(pRootNode, pSelection);
      var selection = pSelection;
      var range = selection.getRangeAt(0);
      if (pRootNode.contains(range.startContainer) === false) {
        return;
      }
      var selectedText = pSelection.toString();
      //dialogs with form elements take the selection!
      var hyperLinkDialog = $("<div>");
      $("body").append(hyperLinkDialog);
      return new Promise(function (pResolve, pReject) {
        if (window.$ === undefined) {
          console.warn("HyperLinkPlugin: include jQuery to use the HyperLinkPlugin");
          return pReject({
            range: range
          });
        }
        $(hyperLinkDialog).HyperLinkDialog({
          linkText: selectedText,
          linkType: "url",
          submit: function submit(pEvent, pValues) {
            var spanNode = document.createElement("span");
            range.deleteContents();
            spanNode.appendChild(range.extractContents());
            range.insertNode(spanNode);
            //firefox fix - hyperlink tags without textcontent won't show their href attribute as text so we do it ourselves
            if (pValues.linktext.length > 0) {
              spanNode.textContent = pValues.linktext;
            } else {
              spanNode.textContent = pValues.uri;
            }
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand(that.command, false, pValues.uri);

            //cleanup - the link tag is appended by execCommand to the new span instead of replacing the span
            var children = spanNode.childNodes;
            var linkNode;
            if (children.length === 1) {
              linkNode = children[0];
              spanNode.replaceWith(children[0]);
            } else {
              spanNode.after.apply(spanNode, _toConsumableArray(children));
              spanNode.parentElement.removeChild(spanNode);
            }
            if (linkNode !== undefined) {
              range.selectNodeContents(linkNode);
            }
            selection.removeAllRanges();
            selection.addRange(range);
            hyperLinkDialog.remove();
            return pResolve({
              newNode: linkNode.closest("a"),
              range: range,
              plugin: that
            });
          },
          close: function close() {
            hyperLinkDialog.remove();
            return pReject({
              range: range
            });
          }
        });
      });
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      return this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
    }
  }, {
    key: "getContextualItems",
    value: function getContextualItems(pEvent, pSelection, pRootNode) {
      var text = "Edit hyperlink";
      if (window.$ !== undefined && window.$.i18n !== undefined) {
        text = $.i18n._("nixps-cloudflow-hyperlinkplugin.context_edit_link");
      }
      return [{
        id: "edit_link",
        text: text,
        tooltip: "Edit link",
        icon: this.getButtonDescription().icon,
        action: this._doubleClickHandler.bind(this),
        data: [{
          selection: pSelection,
          target: pEvent.target.closest(this.tags[0])
        }]
      }];
    }
  }, {
    key: "getDoubleClickSelector",
    value: function getDoubleClickSelector() {
      return this.tags[0];
    }
  }, {
    key: "doubleClickHandler",
    value: function doubleClickHandler(pEvent, pData) {
      this._doubleClickHandler(pData);
    }
  }, {
    key: "_doubleClickHandler",
    value: function _doubleClickHandler(pData) {
      var that = this;
      var selection = pData.selection;
      var link = selection.anchorNode.nodeName.toLowerCase() === "a" ? selection.anchorNode : pData.target;
      if (link === null || link.nodeName.toLowerCase() !== "a") {
        if (link.querySelector("a") !== null) {
          link = link.querySelector("a");
        } else {
          throw Error("HyperLinkPlugin: could not find a hyperlink but button was active");
        }
      }
      var range = selection.getRangeAt(0);
      var hyperLinkDialog = $("<div>");
      var uri = link.href;
      var linkType = "url";
      var emailSubject = "";
      var emailBody = "";
      if (uri.startsWith("tel:") === true) {
        linkType = "phone";
        uri = uri.substring(4);
      } else if (uri.startsWith("mailto:") === true) {
        linkType = "email";
        var splitURI = uri.trim().split(/([^?]+)\?subject=([^&]+)&body=([^&]+)/).filter(Boolean);
        uri = splitURI[0].substring(7);
        emailSubject = splitURI[1] ? decodeURIComponent(splitURI[1]) : "";
        emailBody = splitURI[2] ? decodeURIComponent(splitURI[2]) : "";
      } else {
        var splitURI = uri.split(/^(.*?):\/\//).filter(Boolean);
        var uri = splitURI[1];
        if (uri.endsWith("/")) {
          uri = uri.slice(0, -1);
        }
        var protocol = "other";
        if (["http", "https", "ftp", "news"].includes(splitURI[0])) {
          protocol = splitURI[0] + "://";
        } else {
          uri = link.href;
        }
      }
      $("body").append(hyperLinkDialog);
      return new Promise(function (pResolve, pReject) {
        hyperLinkDialog.HyperLinkDialog({
          linkText: link.innerText,
          linkType: linkType,
          URI: uri,
          emailSubject: emailSubject,
          emailBody: emailBody,
          urlProtocol: protocol,
          editing: true,
          submit: function submit(pEvent, pValues) {
            link.textContent = pValues.linktext;
            link.href = pValues.uri;
            range.selectNodeContents(link);
            selection.removeAllRanges();
            selection.addRange(range);
            hyperLinkDialog.remove();
            return pResolve({
              newNode: link,
              range: range,
              plugin: that
            });
          },
          close: function close() {
            hyperLinkDialog.remove();
            return pReject({
              range: range
            });
          }
        });
      });
    }
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      //button was clicked when a link is active, we want to edit it
      var linkNode = pSelection.anchorNode.parentElement;
      this._doubleClickHandler({
        target: linkNode,
        selection: pSelection
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var dialogs = document.querySelectorAll(".nixps-cloudflow-HyperLinkDialog");
      if (dialogs.length > 0) {
        dialogs.forEach(function (pDialog) {
          pDialog.remove();
        });
      }
      _get(_getPrototypeOf(HyperLinkPlugin.prototype), "destroy", this).call(this);
    }
  }]);
  return HyperLinkPlugin;
}(StyledPluginEC);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = HyperLinkPlugin;
}

},{"../cleaners/EnterModeCleaner.js":326,"../dialogs/nixps-cloudflow-HyperLinkDialog.js":329,"./Plugin.js":362,"./StyledPluginEC.js":369}],347:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends StyledPluginEC
 */
var HyperLinkRemovePlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(HyperLinkRemovePlugin, _StyledPluginEC);
  var _super = _createSuper(HyperLinkRemovePlugin);
  function HyperLinkRemovePlugin() {
    var _this;
    _classCallCheck(this, HyperLinkRemovePlugin);
    _this = _super.call(this, "unlink");
    _this.tags = ["a"];
    _this.disabled_reasons = ["noActive"];
    _this.disableOnInit = true;
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(HyperLinkRemovePlugin, [{
    key: "getID",
    value: function getID() {
      return "Unlink";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-unlink",
        text: "Unlink",
        tooltip: "nixps-tajiri.pluginhyperremovelink_tooltip"
      };
    }
  }, {
    key: "getContextualItems",
    value: function getContextualItems(pEvent, pSelection, pRootNode) {
      return [{
        id: "remove_link",
        text: $.i18n._("nixps-cloudflow-hyperlinkremoveplugin.context_remove_link"),
        tooltip: "Remove link",
        icon: this.getButtonDescription().icon,
        action: this.unformat.bind(this),
        data: [pSelection, pRootNode]
      }];
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      var anchorNode = pSelection.anchorNode.nodeType === Node.TEXT_NODE ? pSelection.anchorNode.parentElement : pSelection.anchorNode;
      var linkNode = anchorNode.closest("a");
      var range = pSelection.getRangeAt(0);
      if (linkNode === null) {
        return;
      }
      if (pSelection.type === "Caret") {
        range.setStartAfter(linkNode);
        range.setStartBefore(linkNode);
        pSelection.removeAllRanges();
        pSelection.addRange(range);
        document.execCommand(this.command);
      } else {
        document.execCommand(this.command);
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      if (this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1) {
        var index = this.disabled_reasons.indexOf("noActive");
        if (index !== -1) {
          this.disabled_reasons.splice(index, 1);
        }
        return true;
      } else {
        var index = this.disabled_reasons.indexOf("noActive");
        if (index === -1) {
          this.disabled_reasons.push("noActive");
        }
        return false;
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "mustBeDisabled",
    value: function mustBeDisabled() {
      if (this.disabled_reasons.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }]);
  return HyperLinkRemovePlugin;
}(StyledPluginEC);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = HyperLinkRemovePlugin;
}

},{"./Plugin.js":362,"./StyledPluginEC.js":369}],348:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
  require("../dialogs/nixps-cloudflow-ImagePluginDialog.js");
}
/**
 * @extends Plugin
 */
var ImagePlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(ImagePlugin, _Plugin);
  var _super = _createSuper(ImagePlugin);
  function ImagePlugin() {
    var _this;
    _classCallCheck(this, ImagePlugin);
    _this = _super.call(this);
    _this.command = "insertHTML";
    _this.tags = ["img"];
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(ImagePlugin, [{
    key: "getID",
    value: function getID() {
      return "Image";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-picture-o",
        text: "Image",
        tooltip: "nixps-tajiri.pluginimage_tooltip"
      };
    }
  }, {
    key: "getContextualItems",
    value: function getContextualItems(pEvent, pSelection, pRootNode) {
      return [{
        id: "edit_image",
        text: $.i18n._("nixps-cloudflow-imageplugindialog.context_edit_image"),
        tooltip: "Edit image",
        icon: this.getButtonDescription().icon,
        action: this._doubleClickHandler.bind(this),
        data: [{
          selection: pSelection,
          target: pEvent.target.closest(this.tags[0])
        }]
      }];
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isActive",
    value: function isActive(pSelection, pRootNode) {
      var selection = pSelection;
      var selectionChildren = selection.anchorNode.children;
      var childImgs = [];
      for (var child in selectionChildren) {
        if (selectionChildren[child].nodeType === Node.ELEMENT_NODE && selectionChildren[child].nodeName.toLowerCase() === "img") {
          childImgs.push(selectionChildren[child]);
        }
      }
      if (childImgs.length === 1) {
        return true;
      }
      return false;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      var selection = pSelection;
      //because isActive on an img has weird behavior, we check here if there's a single img in the selection and go to edit if true
      var selectionChildren = selection.anchorNode.children;
      var childImgs = [];
      for (var child in selectionChildren) {
        if (selectionChildren[child].nodeType === Node.ELEMENT_NODE && selectionChildren[child].nodeName.toLowerCase() === "img") {
          childImgs.push(selectionChildren[child]);
        }
      }
      if (childImgs.length === 1) {
        //single img was found, we want to edit it
        this._doubleClickHandler({
          target: childImgs[0],
          selection: pSelection
        });
        return;
      }
      var range = selection.getRangeAt(0);
      if (pRootNode.contains(range.startContainer) === false) {
        return;
      }
      var imageplugindialog = $("<div>");
      $("body").append(imageplugindialog);
      return $.Deferred(function (pDefer) {
        imageplugindialog.ImagePluginDialog({
          submit: function submit(pEvent, pValues) {
            var img = document.createElement("img");
            selection.removeAllRanges();
            //remove all the content of the selection, we'll replace with image (insertHTML does not do this for us)
            range.deleteContents();
            range.insertNode(img);
            selection.addRange(range);
            img.src = pValues.uri;
            var pattern = new RegExp("\\d+$");
            var width = pattern.test(pValues.width) ? pValues.width + "px" : pValues.width;
            var height = pattern.test(pValues.height) ? pValues.height + "px" : pValues.height;
            img.style.width = width;
            img.style.height = height;
            if (pValues.alignment !== "none") {
              img.style["float"] = pValues.alignment;
            }
            img.alt = pValues.altText;
            imageplugindialog.ImagePluginDialog("setMarginValues", pValues, img);
            var borderValue = parseInt(pValues.border);
            if (typeof borderValue === "number" && borderValue > 0) {
              img.style.border = borderValue + "px solid black";
            }
            $(img).on("contextmenu", that._imageSelectHandler);
            $(img).on("click", that._imageSelectHandler);
            imageplugindialog.remove();
            return pDefer.resolve({
              newNode: img,
              range: range,
              plugin: that
            });
          },
          close: function close() {
            imageplugindialog.remove();
            return pDefer.reject({
              range: range
            });
          },
          imageOptions: {
            border: 0,
            vspace: 0,
            hspace: 0
          }
        });
      });
    }
  }, {
    key: "_imageSelectHandler",
    value: function _imageSelectHandler(pEvent) {
      var selection = window.getSelection();
      var range = new Range();
      selection.removeAllRanges();
      range.selectNode(pEvent.target);
      selection.addRange(range);
    }
  }, {
    key: "getDoubleClickSelector",
    value: function getDoubleClickSelector() {
      return "img";
    }
  }, {
    key: "doubleClickHandler",
    value: function doubleClickHandler(pEvent, pData) {
      this._doubleClickHandler(pData);
    }
  }, {
    key: "_doubleClickHandler",
    value: function _doubleClickHandler(pData) {
      var that = this;
      var selection = pData.selection;
      var range = selection.getRangeAt(0);
      var target = pData.target;
      var vspace = undefined;
      var hspace = undefined;
      var border = undefined;
      if (target.style.marginTop.length > 0) {
        vspace = Number(parseFloat(target.style.marginTop).toFixed(2));
      } else {
        vspace = 0;
      }
      if (target.style.marginLeft.length > 0) {
        hspace = Number(parseFloat(target.style.marginLeft).toFixed(2));
      } else {
        hspace = 0;
      }
      if (target.style.border.length > 0) {
        border = Number(parseFloat(target.style.border).toFixed(2));
      } else {
        border = 0;
      }
      var imageplugindialog = $("<div>");
      $("body").append(imageplugindialog);
      return $.Deferred(function (pDefer) {
        imageplugindialog.ImagePluginDialog({
          imageOptions: {
            uri: target.getAttribute("src") || "",
            altText: target.getAttribute("alt") || "",
            width: target.style.width || target.clientWidth + "px",
            height: target.style.height || target.clientHeight + "px",
            border: border,
            alignment: target.style["float"] || "none",
            vspace: vspace,
            hspace: hspace
          },
          editing: true,
          submit: function submit(pEvent, pValues) {
            target.src = pValues.uri;
            var pattern = new RegExp("\\d+$");
            var width = pattern.test(pValues.width) ? pValues.width + "px" : pValues.width;
            var height = pattern.test(pValues.height) ? pValues.height + "px" : pValues.height;
            target.style.width = width;
            target.style.height = height;
            if (pValues.alignment !== "none") {
              target.style["float"] = pValues.alignment;
            }
            target.alt = pValues.altText;
            imageplugindialog.ImagePluginDialog("setMarginValues", pValues, target);
            var borderValue = parseInt(pValues.border);
            if (typeof borderValue === "number" && borderValue > 0) {
              target.style.border = borderValue + "px solid black";
            }
            imageplugindialog.remove();
            return pDefer.resolve({
              newNode: target,
              range: range,
              plugin: that
            });
          },
          close: function close() {
            imageplugindialog.remove();
            return pDefer.resolve({
              range: range
            });
          }
        });
      });
    }
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      var selection = pSelection;
      //because isActive on an img has weird behavior, we check here if there's a single img in the selection and go to edit if true
      var selectionChildren = selection.anchorNode.children;
      var childImgs = [];
      for (var child in selectionChildren) {
        if (selectionChildren[child].nodeType === Node.ELEMENT_NODE && selectionChildren[child].nodeName.toLowerCase() === "img") {
          childImgs.push(selectionChildren[child]);
        }
      }
      if (childImgs.length === 1) {
        //single img was found, we want to edit it
        this._doubleClickHandler({
          target: childImgs[0],
          selection: pSelection
        });
      }
    }
  }, {
    key: "clickHandler",
    value: function clickHandler(pEvent, pData) {
      var selection = pData.selection;
      var range = selection.getRangeAt(0) || new Range();
      var target = pData.target;
      if (selection !== null) {
        selection.removeAllRanges();
      } else {
        pData.target.focus();
      }
      range.selectNode(target);
      selection.addRange(range);
    }
  }]);
  return ImagePlugin;
}(Plugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = ImagePlugin;
}

},{"../dialogs/nixps-cloudflow-ImagePluginDialog.js":330,"./Plugin.js":362}],349:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Utils = require("./../../Utils.js");
}
/**
 * @extends StyledPluginEC
 */
var IndentPlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(IndentPlugin, _StyledPluginEC);
  var _super = _createSuper(IndentPlugin);
  function IndentPlugin() {
    var _this;
    _classCallCheck(this, IndentPlugin);
    _this = _super.call(this, "indent");
    _this.disabled_reasons = ["noActive"];
    _this.tags = ["li"];
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(IndentPlugin, [{
    key: "getID",
    value: function getID() {
      return "Indent";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: StyledPluginEC.BUTTON_TOGGLE,
        icon: "fa fa-indent",
        text: "nixps-tajiri.pluginindent_tooltip",
        tooltip: "nixps-tajiri.pluginindent_tooltip"
      };
    }
  }, {
    key: "showSelected",
    value: function showSelected() {
      return false;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      if (this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1) {
        //first of all check if we need to disable the indent because a firstChild has been selected
        if (pNode.nodeName.toLowerCase() === "li" && ["ul", "ol"].includes(pNode.parentNode.nodeName.toLowerCase())) {
          if (pNode.parentNode.firstChild === pNode) {
            var index = this.disabled_reasons.indexOf("firstChild");
            if (index === -1) {
              this.disabled_reasons.push("firstChild");
            }
            return false;
          }
        }
        var index = this.disabled_reasons.indexOf("noActive");
        if (index !== -1) {
          this.disabled_reasons.splice(index, 1);
        }
        return true;
      } else {
        var index = this.disabled_reasons.indexOf("noActive");
        if (index === -1) {
          this.disabled_reasons.push("noActive");
        }
        return false;
      }
    }
  }, {
    key: "setDisabledReason",
    value: function setDisabledReason(pReason) {
      var index = this.disabled_reasons.indexOf(pReason);
      if (index === -1) {
        this.disabled_reasons.push(pReason);
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "mustBeDisabled",
    value: function mustBeDisabled() {
      if (this.disabled_reasons.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "getKeyMapping",
    value: function getKeyMapping() {
      return ["Tab"]; //tab
    }
  }, {
    key: "keyMappingHandler",
    value: function keyMappingHandler(pSelection, pRootNode, pEvent) {
      if (this.disabled_reasons.length === 0) {
        this.format(pSelection, pRootNode);
      }
      return this.getID();
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var parentNode = pSelection.anchorNode.parentElement.closest("p, div");
      parentNode.querySelectorAll("*").forEach(function (pNode) {
        if (pNode.style.cssText !== "") {
          pNode.setAttribute("data-tajiri-style", pNode.style.cssText);
        }
      });
      document.execCommand(this.command);
      parentNode.querySelectorAll("li").forEach(function (pNode) {
        var parent = $(pNode).parent();
        if (parent[0].nodeName.toLowerCase() !== "ul") {
          return;
        }
        switch ($(pNode).parentsUntil("div", "ul").length) {
          case 0:
          case 1:
            parent.css("list-style-type", "disc");
            break;
          case 2:
            parent.css("list-style-type", "circle");
            break;
          default:
            parent.css("list-style-type", "square");
            break;
        }
      });
      Utils.cleanLists(pRootNode);
      Utils.applyDataStyleToRealStyle(pRootNode);
    }
  }, {
    key: "selectionChangeHandler",
    value: function selectionChangeHandler() {
      //reset the firstChild reason on change - we can't handle it in isStyleActive()
      //this is because once it's added during isActive check, we want to keep it on the whole time until change
      var index = this.disabled_reasons.indexOf("firstChild");
      if (index !== -1) {
        this.disabled_reasons.splice(index, 1);
      }
    }
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      this.format(pSelection, pRootNode);
    }
  }]);
  return IndentPlugin;
}(StyledPluginEC);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = IndentPlugin;
}

},{"./../../Utils.js":321,"./StyledPluginEC.js":369}],350:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Plugin = require("./Plugin.js");
}

/**
 * Plugin handling the Italic style 
 * @extends StyledPluginEC
 */
var ItalicPlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(ItalicPlugin, _StyledPluginEC);
  var _super = _createSuper(ItalicPlugin);
  function ItalicPlugin() {
    var _this;
    _classCallCheck(this, ItalicPlugin);
    _this = _super.call(this, "italic");
    _this.tags = ["i", "em"];
    _this.styleName = "font-style";
    _this.styleValues = ["italic", "oblique"];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(ItalicPlugin, [{
    key: "getID",
    value: function getID() {
      return "Italic";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "cf-icon cf-icon-italic",
        text: "I",
        tooltip: "nixps-tajiri.pluginitalic_tooltip"
      };
    }

    /**------------------------------------------------------------------------------------------------
     * Function call to determine if "italic" is applied on a given node element
     * @param {Node} pNode the node to check.
     * @returns true if italic is applied, false otherwise
     */
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      return this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
    }
  }, {
    key: "_isActiveInCSSAttribute",
    value: function _isActiveInCSSAttribute(pCSSAttribute) {
      return pCSSAttribute.search(/font-style\s*:\s*(italic|oblique)/i) >= 0;
    }
  }, {
    key: "_isDesactiveInCSSAttribute",
    value: function _isDesactiveInCSSAttribute(pCSSAttribute) {
      return pCSSAttribute.search(/font-style\s*:\s*none/i) >= 0;
    }
  }]);
  return ItalicPlugin;
}(StyledPluginEC);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = ItalicPlugin;
}

},{"./Plugin.js":362,"./StyledPluginEC.js":369}],351:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var JustifyPlugin = require("./JustifyPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @description plugin to center, spread the text on 100% of the line
 * @extends JustifyPlugin
 */
var JustifyCenterPlugin = /*#__PURE__*/function (_JustifyPlugin) {
  _inherits(JustifyCenterPlugin, _JustifyPlugin);
  var _super = _createSuper(JustifyCenterPlugin);
  function JustifyCenterPlugin(options) {
    var _this;
    _classCallCheck(this, JustifyCenterPlugin);
    _this = _super.call(this, options);
    _this.attribute = "style";
    _this.property = "text-align";
    _this.justify = "center";
    _this.command = "justifyCenter";
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(JustifyCenterPlugin, [{
    key: "getID",
    value: function getID() {
      return "JustifyCenter";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-align-center",
        text: "Center",
        tooltip: "nixps-tajiri.pluginjustifycenter_tooltip"
      };
    }
  }]);
  return JustifyCenterPlugin;
}(JustifyPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = JustifyCenterPlugin;
}

},{"./JustifyPlugin.js":354,"./Plugin.js":362}],352:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var JustifyPlugin = require("./JustifyPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends JustifyPlugin
 */
var JustifyFullPlugin = /*#__PURE__*/function (_JustifyPlugin) {
  _inherits(JustifyFullPlugin, _JustifyPlugin);
  var _super = _createSuper(JustifyFullPlugin);
  function JustifyFullPlugin(options) {
    var _this;
    _classCallCheck(this, JustifyFullPlugin);
    _this = _super.call(this, options);
    _this.attribute = "style";
    _this.property = "text-align";
    _this.justify = "justify";
    _this.command = "justifyFull";
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(JustifyFullPlugin, [{
    key: "getID",
    value: function getID() {
      return "JustifyFull";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-align-justify",
        text: "nixps-tajiri.pluginjustifyfull_tooltip",
        tooltip: "nixps-tajiri.pluginjustifyfull_tooltip"
      };
    }
  }]);
  return JustifyFullPlugin;
}(JustifyPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = JustifyFullPlugin;
}

},{"./JustifyPlugin.js":354,"./Plugin.js":362}],353:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var JustifyPlugin = require("./JustifyPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends JustifyPlugin
 */
var JustifyLeftPlugin = /*#__PURE__*/function (_JustifyPlugin) {
  _inherits(JustifyLeftPlugin, _JustifyPlugin);
  var _super = _createSuper(JustifyLeftPlugin);
  function JustifyLeftPlugin(options) {
    var _this;
    _classCallCheck(this, JustifyLeftPlugin);
    _this = _super.call(this, options);
    _this.attribute = "style";
    _this.property = "text-align";
    _this.justify = "left";
    _this.command = "justifyLeft";
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(JustifyLeftPlugin, [{
    key: "getID",
    value: function getID() {
      return "JustifyLeft";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-align-left",
        text: "Left",
        tooltip: "nixps-tajiri.pluginjustifyleft_tooltip"
      };
    }
  }]);
  return JustifyLeftPlugin;
}(JustifyPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = JustifyLeftPlugin;
}

},{"./JustifyPlugin.js":354,"./Plugin.js":362}],354:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var AttributeStyledPlugin = require("./AttributeStyledPlugin.js");
}
/**
 * @extends AttributeStyledPlugin
 */
var JustifyPlugin = /*#__PURE__*/function (_AttributeStyledPlugi) {
  _inherits(JustifyPlugin, _AttributeStyledPlugi);
  var _super = _createSuper(JustifyPlugin);
  function JustifyPlugin() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, JustifyPlugin);
    _this = _super.call(this);
    _this.enterMode = options.enterMode === "br" ? "div" : options.enterMode ? options.enterMode : "";
    //the order of possibilities is the order it's checked, so we should go from specific to more general
    _this.possibilities = ["li", "h1", "h2", "h3", "pre", "p", "div"];
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(JustifyPlugin, [{
    key: "_getStyleValue",
    value: function _getStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        return pNode.style.textAlign;
      } else {
        return "";
      }
      ;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_isStyleDefined",
    value: function _isStyleDefined(pNode) {
      return this._isDefined(pNode) && this._isDefined(pNode[this.attribute]) && this._isDefined(pNode[this.attribute][this.property]);
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_setStyleValue",
    value: function _setStyleValue(pNode) {
      pNode[this.attribute][this.property] = this.justify;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "_resetStyleValue",
    value: function _resetStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        pNode[this.attribute][this.property] = '';
      }
    }
  }, {
    key: "isActive",
    value: function isActive(pSelection, pRootNode) {
      var that = this;
      var leaves = this._findLeavesInSelection(pSelection);
      var arr = leaves.map(function (pNode) {
        while (pRootNode.contains(pNode)) {
          var style = that.isStyleActive(pNode);
          if (style === that.justify) {
            return style;
          }
          pNode = pNode.parentNode;
        }
        return false;
      });
      var tmp = [];
      arr.forEach(function (style) {
        if (tmp.indexOf(style) === -1) {
          tmp.push(style);
        }
      });

      // We consider here, the style is applied if and only if the same style is defined on 
      // all leaves
      this._log(' --- is Plugin active? --- ');
      this._log('Leaves: ', leaves);
      this._log('active on leaves: ', arr);
      this._log('ret: ', tmp[0]);
      if (tmp.length !== 1 || tmp[0] === null || !this._isDefined(tmp[0])) {
        return false;
      }
      return tmp[0];
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      // var that = this;
      // var pNodes = [];
      // var range = pSelection.getRangeAt(0);
      // var rangeCache = {
      //     startNode: range.startContainer,
      //     endNode: range.endContainer,
      //     startOffset: range.startOffset,
      //     endOffset: range.endOffset
      // }
      // var startTag = null;
      // var endTag = null;
      // var i = 0;
      // while(startTag === null) {
      //     var startContainer = range.startContainer;
      //     if (startContainer.nodeType === Node.TEXT_NODE) {
      //         startContainer = startContainer.parentNode;
      //     }
      //     startTag = startContainer.closest(this.possibilities[i]);
      //     if (pRootNode.contains(startTag) === false || startTag.isEqualNode(pRootNode)) {
      //         startTag = null;
      //     }
      //     if (i === this.possibilities.length -1) {
      //         break;
      //     }
      //     i ++;
      // }
      // i = 0;
      // while(endTag === null) {
      //     var endContainer = range.endContainer;
      //     if (endContainer.nodeType === Node.TEXT_NODE) {
      //         endContainer = endContainer.parentNode;
      //     }
      //     endTag = endContainer.closest(this.possibilities[i]);
      //     if (pRootNode.contains(endTag) === false || endTag.isEqualNode(pRootNode)) {
      //         endTag = null;
      //     }
      //     if (i === this.possibilities.length -1) {
      //         break;
      //     }
      //     i ++;
      // }

      // if (startTag === null || endTag === null) {
      //     var paraElement = document.createElement(this.enterMode);
      //     var insertBefore = null;
      //     var appendEls = [];
      //     if (pRootNode.childNodes.length > 0) {
      //         for (var i = 0; i < pRootNode.childNodes.length; i++) {
      //             if (pRootNode.childNodes[i].nodeType !== Node.TEXT_NODE &&
      //             this.possibilities.includes(pRootNode.childNodes[i].nodeName.toLowerCase()) &&
      //             range.startContainer.compareDocumentPosition(pRootNode.childNodes[i]) === 4) {
      //                 insertBefore = pRootNode.childNodes[i];
      //                 break;
      //             } else if (this.possibilities.includes(pRootNode.childNodes[i].nodeName.toLowerCase())) {
      //                 appendEls = [];
      //             } else {
      //                 appendEls.push(pRootNode.childNodes[i]);
      //             }
      //         }
      //     }
      //     appendEls.forEach(function(n) {
      //         paraElement.append(n);
      //     })
      //     if (insertBefore !== null) {
      //         pRootNode.insertBefore(paraElement, insertBefore)
      //     } else {
      //         pRootNode.append(paraElement);           
      //     }
      //     var range = new Range();
      //     if (appendEls.length > 0) {
      //         range.setStart(rangeCache.startNode, rangeCache.startOffset);
      //         range.setEnd(rangeCache.endNode, rangeCache.endOffset);
      //         pSelection.removeAllRanges();
      //         pSelection.addRange(range);
      //     } else {
      //         range.setStart(paraElement, 0);
      //         range.setEnd(paraElement, 0);
      //         pSelection.removeAllRanges();
      //         pSelection.addRange(range);
      //     }
      //     this.format(pSelection, pRootNode);
      //     return;
      // }

      // var nextSiblings = $(startTag).nextAll();
      // if (startTag.isEqualNode(endTag) === true) {
      //     pNodes.push(startTag);
      // } else {
      //     pNodes.push(startTag);
      //     //loop over the siblings, push any that are a block element, until the sibling equals the endNode
      //     nextSiblings.each(function(pIndex, pSibling) {
      //         if(pSibling.isEqualNode(endTag) === false && that.possibilities.includes(pSibling.nodeName.toLowerCase())) {
      //             pNodes.push(pSibling);
      //         } else if (pSibling.isEqualNode(endTag)) {
      //             return false;
      //         }
      //     });
      //     pNodes.push(endTag);
      // }
      // for (var i = 0; i < pNodes.length; i++) {
      //     if (pNodes[i].isEqualNode(pRootNode)) {
      //         pNodes.splice(i, 1);
      //     }
      // }

      // super.formatExistingNodes(pNodes);

      document.execCommand("styleWithCSS", false, true);
      document.execCommand(this.command, false);
      this._applyStyleLater(pRootNode, pRootNode.innerHTML, pSelection);
      document.execCommand("styleWithCSS", false, false);
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      var range = pSelection.getRangeAt(0);
      var startTag = null;
      var endTag = null;
      var i = 0;
      while (startTag === null) {
        startTag = range.startContainer.parentNode.closest(this.possibilities[i]);
        if (i === this.possibilities.length - 1) {
          break;
        }
        i++;
      }
      i = 0;
      while (endTag === null) {
        endTag = range.endContainer.parentNode.closest(this.possibilities[i]);
        if (i === this.possibilities.length - 1) {
          break;
        }
        i++;
      }
      var newRange = new Range();
      newRange.setStartBefore(startTag);
      newRange.setEndAfter(endTag);
      pSelection.removeAllRanges();
      pSelection.addRange(newRange);
      _get(_getPrototypeOf(JustifyPlugin.prototype), "unformat", this).call(this, pSelection, pRootNode);
      //TODO: set the selection back to the original?
    }
  }, {
    key: "formatForPaste",
    value: function formatForPaste(pDOMTree) {
      var that = this;
      var cssMatchRegExp = new RegExp(this.property + "\\s*:\\s*(" + this.justify + ")", "i");
      pDOMTree.querySelectorAll("p,div").forEach(function (pNode) {
        var actualValue = null;
        var actualStyle = pNode.getAttribute("style");
        if (typeof actualStyle === "string" && actualStyle.length > 0) {
          var matched = actualStyle.match(cssMatchRegExp);
          if (Array.isArray(matched) && matched.length > 1) {
            actualValue = matched[1];
          }
          if (typeof actualValue === "string" && actualValue.length > 0) {
            var addedStyle = "" + that.property + ":" + actualValue + ";";
            var originalStyle = pNode.getAttribute("data-tajiri-style");
            if (typeof originalStyle === "string" && originalStyle.length > 0) {
              pNode.setAttribute("data-tajiri-style", originalStyle + addedStyle);
            } else {
              pNode.setAttribute("data-tajiri-style", addedStyle);
            }
          }
        }
      });
      return pDOMTree;
    }
  }]);
  return JustifyPlugin;
}(AttributeStyledPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = JustifyPlugin;
}

},{"./AttributeStyledPlugin.js":334}],355:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var JustifyPlugin = require("./JustifyPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends JustifyPlugin
 */
var JustifyRightPlugin = /*#__PURE__*/function (_JustifyPlugin) {
  _inherits(JustifyRightPlugin, _JustifyPlugin);
  var _super = _createSuper(JustifyRightPlugin);
  function JustifyRightPlugin(options) {
    var _this;
    _classCallCheck(this, JustifyRightPlugin);
    _this = _super.call(this, options);
    _this.attribute = "style";
    _this.property = "text-align";
    _this.justify = "right";
    _this.command = "justifyRight";
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(JustifyRightPlugin, [{
    key: "getID",
    value: function getID() {
      return "JustifyRight";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-align-right",
        text: "Right",
        tooltip: "nixps-tajiri.pluginjustifyright_tooltip"
      };
    }
  }]);
  return JustifyRightPlugin;
}(JustifyPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = JustifyRightPlugin;
}

},{"./JustifyPlugin.js":354,"./Plugin.js":362}],356:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var DirectionPlugin = require("./DirectionPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends DirectionPlugin
 */
var LTRPlugin = /*#__PURE__*/function (_DirectionPlugin) {
  _inherits(LTRPlugin, _DirectionPlugin);
  var _super = _createSuper(LTRPlugin);
  function LTRPlugin(options) {
    var _this;
    _classCallCheck(this, LTRPlugin);
    _this = _super.call(this, options);
    _this.attribute = "dir";
    _this.property = null;
    _this.value = "ltr";
    _this.tags = ["ltr"];
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(LTRPlugin, [{
    key: "getID",
    value: function getID() {
      return "LTR";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "cf-icon cf-icon-text-ltr",
        text: "nixps-tajiri.pluginltr_tooltip",
        tooltip: "nixps-tajiri.pluginltr_tooltip"
      };
    }
  }]);
  return LTRPlugin;
}(DirectionPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = LTRPlugin;
}

},{"./DirectionPlugin.js":341,"./Plugin.js":362}],357:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var AttributeStyledPlugin = require("./AttributeStyledPlugin.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @extends AttributeStyledPlugin
 */
var LineHeightPlugin = /*#__PURE__*/function (_AttributeStyledPlugi) {
  _inherits(LineHeightPlugin, _AttributeStyledPlugi);
  var _super = _createSuper(LineHeightPlugin);
  function LineHeightPlugin() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, LineHeightPlugin);
    _this = _super.call(this);
    _this.tags = [];
    _this.enterMode = options.enterMode ? options.enterMode : "";
    _this.attribute = "style";
    _this.property = "lineHeight";
    _this.value = "";
    _this.active = false;
    _this.possibilities = ["h1", "h2", "h3", "pre", "div", "p"];
    _this.supportedSizes = ["1em", "1.1em", "1.2em", "1.3em", "1.4em", "1.5em", "1.6em", "1.7em", "1.8em", "1.9em", "2em", "2.5em", "3em"];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(LineHeightPlugin, [{
    key: "getID",
    value: function getID() {
      return "LineHeight";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_SELECT,
        options: [{
          value: "",
          label: "nixps-tajiri.generic_default_label"
        }].concat(this.supportedSizes.map(function (pSize) {
          return {
            value: pSize,
            label: pSize
          };
        })),
        icon: null,
        text: "nixps-tajiri.pluginlineheight_label",
        tooltip: "nixps-tajiri.pluginlineheight_tooltip"
      };
    }
  }, {
    key: "_isStyleDefined",
    value: function _isStyleDefined(pNode) {
      return this._isDefined(pNode) && this._isDefined(pNode[this.attribute]) && this._isDefined(pNode[this.attribute][this.property]);
    }
  }, {
    key: "_getValue",
    value: function _getValue(pStyleString) {
      if (typeof pStyleString !== "string") {
        return "";
      }
      var styleString = pStyleString.replace(/['"]/g, "").trim();
      for (var i = 0; i < this.supportedSizes.length; i++) {
        if (styleString.indexOf(this.supportedSizes[i]) === 0) {
          return this.supportedSizes[i];
        }
      }
      return "";
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Get the style on a given node if it exist
     * @param {Node} pNode : the node to read the style from
     * @returns {*} true or the style value if it exists, en empty string otherwise
     */
  }, {
    key: "_getStyleValue",
    value: function _getStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        return this._getValue(pNode[this.attribute][this.property]);
      }
      return "";
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Set the style on a given node.
     * @param {Node} pNode : the node to set the style on
    */
  }, {
    key: "_setStyleValue",
    value: function _setStyleValue(pNode) {
      pNode[this.attribute][this.property] = this.value;
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      var pNodes = [];
      var range = pSelection.getRangeAt(0);
      var rangeCache = {
        startNode: range.startContainer,
        endNode: range.endContainer,
        startOffset: range.startOffset,
        endOffset: range.endOffset
      };
      var startTag = null;
      var endTag = null;
      var i = 0;
      while (startTag === null) {
        var startContainer = range.startContainer;
        if (startContainer.nodeType === Node.TEXT_NODE) {
          startContainer = startContainer.parentNode;
        }
        startTag = startContainer.closest(this.possibilities[i]);
        if (pRootNode.contains(startTag) === false || startTag.isEqualNode(pRootNode)) {
          startTag = null;
        }
        if (i === this.possibilities.length - 1) {
          break;
        }
        i++;
      }
      i = 0;
      while (endTag === null) {
        var endContainer = range.endContainer;
        if (endContainer.nodeType === Node.TEXT_NODE) {
          endContainer = endContainer.parentNode;
        }
        endTag = endContainer.closest(this.possibilities[i]);
        if (pRootNode.contains(endTag) === false || endTag.isEqualNode(pRootNode)) {
          endTag = null;
        }
        if (i === this.possibilities.length - 1) {
          break;
        }
        i++;
      }
      if (startTag === null || endTag === null) {
        var paraElement = document.createElement(this.enterMode);
        var insertBefore = null;
        var appendEls = [];
        if (pRootNode.childNodes.length > 0) {
          for (var i = 0; i < pRootNode.childNodes.length; i++) {
            if (pRootNode.childNodes[i].nodeType !== Node.TEXT_NODE && this.possibilities.includes(pRootNode.childNodes[i].nodeName.toLowerCase()) && range.startContainer.compareDocumentPosition(pRootNode.childNodes[i]) === 4) {
              insertBefore = pRootNode.childNodes[i];
              break;
            } else if (this.possibilities.includes(pRootNode.childNodes[i].nodeName.toLowerCase())) {
              appendEls = [];
            } else {
              appendEls.push(pRootNode.childNodes[i]);
            }
          }
        }
        appendEls.forEach(function (n) {
          paraElement.append(n);
        });
        if (insertBefore !== null) {
          pRootNode.insertBefore(paraElement, insertBefore);
        } else {
          pRootNode.append(paraElement);
        }
        var range = new Range();
        if (appendEls.length > 0) {
          range.setStart(rangeCache.startNode, rangeCache.startOffset);
          range.setEnd(rangeCache.endNode, rangeCache.endOffset);
          pSelection.removeAllRanges();
          pSelection.addRange(range);
        } else {
          range.setStart(paraElement, 0);
          range.setEnd(paraElement, 0);
          pSelection.removeAllRanges();
          pSelection.addRange(range);
        }
        this.format(pSelection, pRootNode);
        return;
      }
      var nextSiblings = $(startTag).nextAll();
      if (startTag.isEqualNode(endTag) === true) {
        pNodes.push(startTag);
      } else {
        pNodes.push(startTag);
        //loop over the siblings, push any that are a block element, until the sibling equals the endNode
        nextSiblings.each(function (pIndex, pSibling) {
          if (pSibling.isEqualNode(endTag) === false && that.possibilities.includes(pSibling.nodeName.toLowerCase())) {
            pNodes.push(pSibling);
          } else if (pSibling.isEqualNode(endTag)) {
            return false;
          }
        });
        pNodes.push(endTag);
      }
      for (var i = 0; i < pNodes.length; i++) {
        if (pNodes[i].isEqualNode(pRootNode)) {
          pNodes.splice(i, 1);
        }
      }
      _get(_getPrototypeOf(LineHeightPlugin.prototype), "formatExistingNodes", this).call(this, pNodes);
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all sub-plugins
     * Reset the style on a given node.
     * @param {Node} pNode : the node to reset the style on
     */
  }, {
    key: "_resetStyleValue",
    value: function _resetStyleValue(pNode) {
      if (this._isStyleDefined(pNode)) {
        pNode[this.attribute][this.property] = "";
      }
    }
  }, {
    key: "setValue",
    value: function setValue(pValue) {
      this.value = pValue;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "unformat",
    value: function unformat() {}
  }]);
  return LineHeightPlugin;
}(AttributeStyledPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = LineHeightPlugin;
}

},{"./AttributeStyledPlugin.js":334,"./Plugin.js":362}],358:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Utils = require("./../../Utils.js");
}

/**
 * Plugin handling the Lists 
 * @extends StyledPluginEC
 */
var ListPlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(ListPlugin, _StyledPluginEC);
  var _super = _createSuper(ListPlugin);
  function ListPlugin(pOptions) {
    var _this;
    _classCallCheck(this, ListPlugin);
    _this = _super.call(this, pOptions.command);
    _this.tags = ["ol", "ul", "li"];
    _this.enterMode = pOptions.enterMode;
    return _this;
  }
  _createClass(ListPlugin, [{
    key: "_getRootlevelNode",
    value: function _getRootlevelNode(pNode, pRootNode) {
      if (pNode === pRootNode || pNode.parentElement === pRootNode) {
        return pNode;
      } else {
        return this._getRootlevelNode(pNode.parentElement, pRootNode);
      }
    }
  }, {
    key: "_removeEmptyStyledSpans",
    value: function _removeEmptyStyledSpans(pRootNode) {
      var spans = pRootNode.querySelectorAll("span");
      var toRemove = [];
      for (var i = spans.length - 1; i > 0; i--) {
        var hasElementChild = false;
        spans[i].childNodes.forEach(function (n) {
          if (n.textContent.length > 0 && n.nodeType === Node.ELEMENT_NODE) {
            hasElementChild = true;
            return;
          }
        });
        if (hasElementChild === false && spans[i].textContent.length === 0) {
          toRemove.push(spans[i]);
        }
      }
      toRemove.forEach(function (n) {
        n.parentElement.removeChild(n);
      });
    }
  }, {
    key: "_isInsideList",
    value: function _isInsideList(pNode, pRootNode) {
      if (pNode === null) {
        return false;
      }
      var parentElement = pNode.parentElement;
      while (parentElement && parentElement !== pRootNode) {
        if (this.tags.includes(parentElement.nodeName.toLowerCase()) === true) {
          return true;
        } else {
          parentElement = parentElement.parentElement;
        }
      }
      return false;
    }
  }, {
    key: "_styleToNodes",
    value: function _styleToNodes(pRootNode) {
      var selection = document.getSelection();
      var range = selection.getRangeAt(0);
      range.startContainer.parentNode.setAttribute("data-tajiri-selection-start", range.startOffset);
      range.endContainer.parentNode.setAttribute("data-tajiri-selection-end", range.endOffset);
      var styleMap = {
        "h1": ["font-size: 36px;", "font-weight: 600;"],
        "h2": ["font-size: 30px;", "font-weight: 500;"],
        "h3": ["font-size: 24px;", "font-weight: 500;"],
        "pre": ["font-family: monospace;", "white-space: pre;"],
        "sup": ["font-size: smaller;", "vertical-align: super;"],
        "sub": ["font-size: smaller;", "vertical-align: sub;"]
      };
      var text = pRootNode.innerHTML;
      var found = false;
      //(\s[^>]*)? before and after style attr to capture all the other attributes
      text = text.replaceAll(/<([a-zA-Z]*)(\s[^>]*)?\sstyle="([^"]*)"(\s[^>]*)?>/ig, function (pMatch, p1, p2, p3, p4, offset) {
        //a node might have no extra attributes - set to an empty string if the case
        p2 = p2 === undefined ? "" : p2;
        p4 = p4 === undefined ? "" : p4;
        found = true;
        var styleText = p3;
        for (var key in styleMap) {
          var containsStyles = styleMap[key].every(function (style) {
            return styleText.indexOf(style) !== -1;
          });
          if (containsStyles === true) {
            styleMap[key].forEach(function (styleString) {
              p3 = p3.replace(styleString, "");
            });
            return "<" + p1 + p2 + " data-tajiri-replace-element='" + key + "' data-tajiri-style='" + p3 + "' " + p4 + ">";
          }
        }
        ;
        //haven't found any match, just default case of storing styling inside the data-attribute
        return "<" + p1 + p2 + " data-tajiri-style='" + p3 + "' " + p4 + ">";
      });
      pRootNode.innerHTML = text;

      //replace the ones we found that match with styling
      var toReplaceElements = pRootNode.querySelectorAll("[data-tajiri-replace-element], br");
      var hasBeenAppended = [];
      toReplaceElements.forEach(function (n, pIndex) {
        //we check if the textcontent is just a nbsp - this is the case sometimes with unformatting a list
        //remove it and return
        //fix the block elements that were split into spans
        var counter = 1;
        var toContinue = false;
        hasBeenAppended.forEach(function (appendedNode, index) {
          if (n.isEqualNode(appendedNode)) {
            hasBeenAppended.splice(index, 1);
            toContinue = true;
          }
        });
        if (toContinue) {
          return;
        }
        if (pIndex !== toReplaceElements.length - 1 && toReplaceElements[pIndex + counter].nodeName.toLowerCase() !== "br" && toReplaceElements[pIndex + counter].getAttribute("data-tajiri-replace-element") === n.getAttribute("data-tajiri-replace-element")) {
          //we want to merge these elements, they're block elements that were split into spans
          var tagName = n.getAttribute("data-tajiri-replace-element");
          var newNode = document.createElement(tagName);
          n.removeAttribute("data-tajiri-replace-element");
          n.before(newNode);
          newNode.append(n);
          while (toReplaceElements[pIndex + counter].nodeName.toLowerCase !== "br" && toReplaceElements[pIndex + counter].getAttribute("data-tajiri-replace-element") === tagName) {
            newNode.append(toReplaceElements[pIndex + counter]);
            hasBeenAppended.push(toReplaceElements[pIndex + counter]);
            toReplaceElements[pIndex + counter].removeAttribute("data-tajiri-replace-element");
            counter++;
          }
          if (toReplaceElements[pIndex + counter].nodeName.toLowerCase() === "br") {
            toReplaceElements[pIndex + counter].parentElement.removeChild(toReplaceElements[pIndex + counter]);
          }
        } else if (n.textContent === String.fromCharCode(160)) {
          n.parentElement.removeChild(n);
        } else {
          if (n.nodeName.toLowerCase() === "br") {
            return;
          }
          var tagName = n.getAttribute("data-tajiri-replace-element");
          var newNode = document.createElement(tagName);
          n.removeAttribute("data-tajiri-replace-element");
          newNode.append(n.cloneNode(true));
          n.replaceWith(newNode);
          if (newNode.nextSibling.nodeName.toLowerCase() === "br") {
            newNode.nextSibling.parentElement.removeChild(newNode.nextSibling);
          }
        }
      });
      if (found) {
        Utils.applyDataStyleToRealStyle(pRootNode);
      }
      selection.removeAllRanges();
      var range = new Range();
      var startNode = pRootNode.querySelector("[data-tajiri-selection-start]");
      var endNode = pRootNode.querySelector("[data-tajiri-selection-end]");
      Utils.selectMultipleNodes(startNode, endNode, startNode.getAttribute("data-tajiri-selection-start"), endNode.getAttribute("data-tajiri-selection-end"));
      startNode.removeAttribute("data-tajiri-selection-start");
      endNode.removeAttribute("data-tajiri-selection-end");
    }
  }, {
    key: "_spanToEnter",
    value: function _spanToEnter(pSelection, pRootNode) {
      var skipTags = ["h1", "h2", "h3", "pre"];
      var range = pSelection.getRangeAt(0);
      var focusNode = range.startContainer;
      if (focusNode.nodeType === Node.TEXT_NODE) {
        focusNode = focusNode.parentElement;
      }
      focusNode = this._getRootlevelNode(focusNode, pRootNode);
      var endNode = range.endContainer;
      if (endNode.nodeType === Node.TEXT_NODE) {
        endNode = endNode.parentElement;
      }
      endNode = this._getRootlevelNode(endNode, pRootNode);
      var toConvert = [];
      while (focusNode !== endNode.nextSibling) {
        var nextNode = focusNode.nextSibling;
        if (focusNode.nodeName.toLowerCase() === "br") {
          var enterTag = document.createElement(this.enterMode);
          toConvert.forEach(function (n) {
            enterTag.append(n);
          });
          toConvert = [];
          focusNode.before(enterTag);
          focusNode.parentElement.removeChild(focusNode);
          nextNode = enterTag.nextSibling;
        } else if (skipTags.includes(focusNode.nodeName.toLowerCase()) === false) {
          toConvert.push(focusNode);
        }
        focusNode = nextNode;
      }
      if (toConvert.length > 0) {
        var enterTag = document.createElement(this.enterMode);
        toConvert.forEach(function (n) {
          enterTag.append(n);
        });
        toConvert = [];
        focusNode.before(enterTag);
        focusNode.parentElement.removeChild(focusNode);
        range.setEndAfter(enterTag);
      }
    }
  }, {
    key: "_cleanLists",
    value: function _cleanLists(pRootNode) {
      var rootLists = pRootNode.querySelectorAll(":scope > ol, :scope > ul");
      rootLists.forEach(function (pRootList) {
        //the list should always start with an li, otherwise it's starting out with a nested li which we don't want
        while (pRootList.firstChild.nodeName.toLowerCase() !== "li") {
          var afterNode = pRootList.firstChild;
          while (pRootList.firstChild.childNodes.length > 0) {
            var moveNode = pRootList.firstChild.firstChild;
            afterNode.after(moveNode);
            afterNode = moveNode;
          }
          pRootList.removeChild(pRootList.firstChild);
        }
      });
    }
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      //unformatting a list with an empty span inside of it will crash execCommand and send it into an infinite loop
      //we'll first remove all spans that have no children or no text inside of them (or children without text)
      Utils.cleanLists(pRootNode);
      var range = pSelection.getRangeAt(0);
      if (range.endContainer.nodeType === Node.ELEMENT_NODE && range.endContainer.nodeName.toLowerCase() === "li") {
        range.setEndAfter(range.endContainer);
        pSelection.removeAllRanges();
        pSelection.addRange(range);
      }
      this._removeEmptyStyledSpans(pRootNode);
      document.execCommand(this.command);
      var range = pSelection.getRangeAt(0);
      var focusNode = range.startContainer;
      if (focusNode.nodeType === Node.TEXT_NODE) {
        focusNode = focusNode.parentElement;
      }
      focusNode = this._isInsideList(focusNode, pRootNode) === true ? focusNode.closest("li") : this._getRootlevelNode(focusNode, pRootNode);
      var endNode = range.endContainer;
      if (endNode.nodeType === Node.TEXT_NODE) {
        endNode = endNode.parentElement;
      }
      endNode = this._isInsideList(endNode, pRootNode) === true ? endNode.closest("li") : this._getRootlevelNode(endNode, pRootNode);
      var origEqual = focusNode === endNode;
      while (focusNode !== endNode) {
        if (focusNode === null) {
          //end of content
          break;
        }
        var nextNode = focusNode.nextSibling;
        var isInsideList = this._isInsideList(focusNode, pRootNode);
        if (["ol", "ul"].includes(focusNode.nodeName.toLowerCase()) === true || isInsideList === true) {
          document.execCommand(this.command);
          //restart loop while, check for all elements if they're outside of the list
          range = pSelection.getRangeAt(0);
          focusNode = range.startContainer;
          if (focusNode.nodeType === Node.TEXT_NODE) {
            focusNode = focusNode.parentElement;
          }
          focusNode = this._isInsideList(focusNode, pRootNode) === true ? focusNode.closest("li") : this._getRootlevelNode(focusNode, pRootNode);
          endNode = range.endContainer;
          if (endNode.nodeType === Node.TEXT_NODE) {
            endNode = endNode.parentElement;
          }
          endNode = this._isInsideList(endNode, pRootNode) === true ? endNode.closest("li") : this._getRootlevelNode(endNode, pRootNode);
        } else {
          focusNode = nextNode;
        }
      }
      if (origEqual === true) {
        while (this._isInsideList(focusNode, pRootNode)) {
          document.execCommand(this.command);
          var range = pSelection.getRangeAt(0);
          focusNode = range.startContainer.parentElement.closest("li");
        }
      }
      this._styleToNodes(pRootNode);
      this._spanToEnter(pSelection, pRootNode);
      this._cleanLists(pRootNode);
    }
  }]);
  return ListPlugin;
}(StyledPluginEC);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = ListPlugin;
}

},{"./../../Utils.js":321,"./StyledPluginEC.js":369}],359:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var TextualPlugin = require("./TextualPlugin.js");
  var Plugin = require("./Plugin.js");
}
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
;
function generateUUID() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
;

/**
 * @description Plugin handling textual user-mentions
 * @extends MentionPlugin
 */
var MentionPlugin = /*#__PURE__*/function (_TextualPlugin) {
  _inherits(MentionPlugin, _TextualPlugin);
  var _super = _createSuper(MentionPlugin);
  function MentionPlugin() {
    var _this;
    var pOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, MentionPlugin);
    _this = _super.call(this);
    _this.classes = "cf-mention";
    if (typeof pOptions.listCallback !== "function") {
      throw new Error("MentionPlugin: listCallback option must be a function");
    }
    _this.listCallback = pOptions.listCallback;
    _this._dblClickHandler = function () {};
    _this.regExp = /<hybrid-mention\b[^>]*?(?:data-mention-value=['"]([^'"]+)['"][^>]*?)?>([^<]*)<\/hybrid-mention>/ig;
    _this.startString = "@{";
    _this.endString = "}";
    _this.isMentioning = false;
    _this.suggestionMenuGUID = generateUUID();
    _this.tags = ["hybrid-mention"];
    return _this;
  }
  _createClass(MentionPlugin, [{
    key: "getID",
    value: function getID() {
      return "Mention";
    }
  }, {
    key: "getVisualContent",
    value: function getVisualContent(pValue) {
      var indexOfEmailQuotes = pValue.indexOf(":");
      if (indexOfEmailQuotes < 0) {
        //seems like we got one value, nothing else
        pValue = decodeURIComponent(pValue);
        if (pValue.startsWith("@")) {
          return pValue;
        } else {
          return "@" + pValue;
        }
      } else {
        var displayName = decodeURIComponent(pValue.slice(indexOfEmailQuotes + 1, -1));
        if (displayName.startsWith("@")) {
          return displayName;
        } else {
          return "@" + displayName;
        }
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      //buttonless
      return {
        type: "None"
      };
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return generateUUID() + ":" + this._defaultText;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isActive",
    value: function isActive(pSelection, pRootNode) {
      return false;
    }
  }, {
    key: "transformToSource",
    value: function transformToSource(pHTML) {
      if (typeof pHTML !== "string" || pHTML.length <= 0) {
        return "";
      }
      var that = this;
      return pHTML.replace(/<span(?=[^>]*class=["'][^"']*cf-mention[^"']*")(?=[^>]*data-tajiri-template-value=["'](.*?)["'])(?=[^>]*contenteditable=["']false["']?)[^>]*>\s*((?:<[^\/][^>]*>)*)(@[^<]+)((?:<\/[^>]+>)*)\s*<\/span>/gi, function (pMatch, p1, p2, p3, p4) {
        p2 = p2 ? p2 : "";
        p3 = p3 ? p3 : "";
        p4 = p4 ? p4 : "";
        if (p3.startsWith("@")) {
          p3 = p3.substring(1);
        }
        return p2 + that.startString + p1 + ":" + encodeURIComponent(p3) + that.endString + p4;
      });
    }
  }, {
    key: "transformToEdit",
    value: function transformToEdit(pHTML) {
      if (typeof pHTML !== "string" || pHTML.length <= 0) {
        return "";
      }
      var that = this;
      var addedElementContent = "";
      if (typeof this.classes === "string" && this.classes.length > 0) {
        addedElementContent = "class='" + this.classes + "' ";
      }
      return pHTML.replace(this.regExp, function (pMatch, p1, p2) {
        return "<span data-tajiri-template-value='" + p1 + "' " + addedElementContent + " contenteditable=false >" + that.getVisualContent(p2) + "</span>";
      });
    }
  }, {
    key: "getDoubleClickSelector",
    value: function getDoubleClickSelector() {
      return "[data-tajiri-template-value].cf-mention";
    }
  }, {
    key: "_typedMentionCharacter",
    value: function _typedMentionCharacter(pSelection, pArea) {
      var that = this;
      //should be an @ right before the selection, and whitespace or nothing before that @, check
      if (pSelection.type === "Caret" && this.isMentioning === false && pSelection.focusNode.textContent[pSelection.focusOffset - 1] === "@" && [" ", "", undefined, "\u200B", "\xA0"].includes(pSelection.focusNode.textContent[pSelection.focusOffset - 2]))
        //undefined - start of line, \u200b = zerowidthspace
        {
          this.typedContent = "";
          //wrap the @ in a span, that way we can check later on the element if it still exists
          pSelection.modify("extend", "backward", "character");
          var tempNode = document.createElement("span");
          tempNode.classList.add("is-mentioning");
          pSelection.getRangeAt(0).surroundContents(tempNode);
          pSelection.collapseToEnd();
          var mentionPosition = tempNode.getBoundingClientRect();
          this.isMentioning = true;
          this._startListeningBind = this._keyDownHandler.bind(this, pArea, pSelection);
          pArea.addEventListener("keydown", this._startListeningBind);
          this._captureTypedKeyBind = this._debounceFunc(this._captureTypedKey.bind(this, pArea, pSelection), 300);
          this._clickListenerBind = this._clickEditorHandler.bind(this, pArea, pSelection);
          pArea.addEventListener("click", this._clickListenerBind, {
            once: true
          });
          //start the mentioning, with some UI listing the names
          return Promise.resolve(this.listCallback()).then(function (pList) {
            if (Array.isArray(pList)) {
              //
            } else if (Array.isArray(pList) === false && pList.results !== undefined && Array.isArray(pList.results) === true) {
              pList = pList.results;
            } else {
              throw new Error("MentionPlugin: an array was expected for mentionListCallback, got " + JSON.stringify(pList));
            }
            that._drawMentionList(pList, mentionPosition, pArea, pSelection);
          })["catch"](function (pError) {
            console.error(pError);
          });
        }
    }
  }, {
    key: "_clickEditorHandler",
    value: function _clickEditorHandler(pArea, pSelection, pEvent) {
      if (document.getElementById(this.suggestionMenuGUID) !== null) {
        document.querySelector("body").removeChild(document.getElementById(this.suggestionMenuGUID));
      }
      if (pArea.querySelector(".is-mentioning") !== null) {
        //remove tag created for mention
        var mentionTag = pArea.querySelector(".is-mentioning");
        var textMentionTag = mentionTag.childNodes[0];
        mentionTag.before(textMentionTag);
        mentionTag.parentElement.removeChild(mentionTag);
      }
      pArea.removeEventListener("keydown", this._startListeningBind);
      this.isMentioning = false;
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(pArea, pSelection, pEvent) {
      var that = this;
      if (["Enter", "ArrowUp", "ArrowDown", "Escape", "Tab", "ArrowLeft", "ArrowRight"].includes(pEvent.code) === true) {
        switch (pEvent.code) {
          case "Escape":
            {
              //ESCAPE
              pEvent.preventDefault();
              pEvent.stopPropagation();
              //escape was pressed, stop mentioning
              if (document.getElementById(that.suggestionMenuGUID) !== null) {
                document.querySelector("body").removeChild(document.getElementById(that.suggestionMenuGUID));
              }
              if (pArea.querySelector(".is-mentioning") !== null) {
                //remove tag created for mention
                var mentionTag = pArea.querySelector(".is-mentioning");
                var textMentionTag = mentionTag.childNodes[0];
                mentionTag.after(textMentionTag);
                mentionTag.parentElement.removeChild(mentionTag);
                pSelection.getRangeAt(0).setStartAfter(textMentionTag);
                pSelection.getRangeAt(0).setEndAfter(textMentionTag);
              }
              pArea.removeEventListener("keydown", this._startListeningBind);
              pArea.removeEventListener("click", this._clickListenerBind);
              that.isMentioning = false;
              break;
            }
          case "ArrowDown":
            {
              //ARROW DOWN
              pEvent.preventDefault();
              pEvent.stopPropagation();
              that._moveSuggestionDown();
              break;
            }
          case "ArrowUp":
            {
              //ARROW UP
              pEvent.preventDefault();
              pEvent.stopPropagation();
              that._moveSuggestionUp();
              break;
            }
          case "ArrowLeft":
            {
              //ARROW LEFT
              if (pArea.querySelector(".is-mentioning") !== null && pArea.querySelector(".is-mentioning").textContent.length === 1) {
                //no need to do anything, let the selection change
              } else {
                //prevent moving left while we're mentioning and have typed something
                pEvent.preventDefault();
                pEvent.stopPropagation();
              }
              //we can stop the mentioning
              that.isMentioning = false;
              pArea.removeEventListener("keydown", this._startListeningBind);
              pArea.removeEventListener("click", this._clickListenerBind);
              if (document.getElementById(this.suggestionMenuGUID) !== null) {
                document.querySelector("body").removeChild(document.getElementById(this.suggestionMenuGUID));
              }
              break;
            }
          case "ArrowRight":
            {
              //ARROW RIGHT
              //keep mentioning
              pEvent.preventDefault();
              pEvent.stopPropagation();
              break;
            }
          case "Tab": //TAB
          case "Enter":
            {
              //ENTER
              pEvent.preventDefault();
              that._chosenMention(pArea, pSelection);
              pArea.removeEventListener("keydown", this._startListeningBind);
              pArea.removeEventListener("click", this._clickListenerBind);
              break;
            }
        }
        //a control key was pressed and handled
        return;
      }
      pArea.addEventListener("keyup", this._captureTypedKeyBind, {
        once: true
      });
    }
  }, {
    key: "_captureTypedKey",
    value: function _captureTypedKey(pArea, pSelection, pEvent) {
      if (pArea.querySelector(".is-mentioning") === null) {
        //removed the @
        if (document.getElementById(this.suggestionMenuGUID) !== null) {
          document.querySelector("body").removeChild(document.getElementById(this.suggestionMenuGUID));
        }
        pArea.removeEventListener("keydown", this._startListeningBind);
        pArea.removeEventListener("click", this._clickListenerBind);
        this.isMentioning = false;
        return;
      } else {
        this.typedContent = pArea.querySelector(".is-mentioning").textContent.substring(1);
      }
      this._updateList(this.typedContent, pArea, pSelection);
    }
  }, {
    key: "_debounceFunc",
    value: function _debounceFunc(func, wait, immediate) {
      var that = this;
      var timeout, args, context, timestamp, result;
      return function () {
        context = this;
        args = arguments;
        timestamp = new Date();
        var later = function later() {
          if (that.alive === false) {
            timeout = null;
          }
          var last = new Date() - timestamp;
          if (last < wait) {
            timeout = setTimeout(later, wait - last);
          } else {
            timeout = null;
            if (!immediate) {
              result = func.apply(context, args);
            }
            ;
          }
        };
        var callNow = immediate && !timeout;
        if (!timeout) {
          timeout = setTimeout(later, wait);
        }
        if (callNow) {
          result = func.apply(context, args);
        }
        ;
        return result;
      };
    }
  }, {
    key: "_updateList",
    value: function _updateList(pSearchString, pArea, pSelection) {
      var that = this;
      pSearchString = pSearchString.replaceAll("\xA0", " ");
      Promise.resolve(this.listCallback(pSearchString)).then(function (pList) {
        var listDOM = document.getElementById(that.suggestionMenuGUID);
        if (listDOM === null) {
          //doesn't exist anymore
          return;
        }
        if (Array.isArray(pList)) {
          //
        } else if (Array.isArray(pList) === false && pList.results !== undefined && Array.isArray(pList.results) === true) {
          pList = pList.results;
        } else {
          throw new Error("MentionPlugin: an array was expected for mentionListCallback, got " + JSON.stringify(pList));
        }
        //empty
        while (listDOM.lastChild) {
          listDOM.removeChild(listDOM.lastChild);
        }
        var isListCutOff = false;
        if (pList.length > 100) {
          isListCutOff = true;
          pList = pList.slice(0, 100);
        }
        pList.forEach(function (pMentionItem) {
          var mentionItemDOM = document.createElement("button");
          mentionItemDOM.setAttribute("type", "button");
          mentionItemDOM.classList.add("tajiri-mentionplugin-listitem");
          var usernameDOM = document.createElement("span");
          usernameDOM.classList.add("username", "cf-unreset");
          var userNameString = pMentionItem.full_name;
          if (typeof userNameString === "string" && userNameString.length > 0) {
            if (userNameString.toLowerCase().indexOf(pSearchString.toLowerCase()) !== -1) {
              userNameString = userNameString.replace(new RegExp(pSearchString, "i"), function (pMatch) {
                return "<b>" + pMatch + "</b>";
              });
            }
            usernameDOM.innerHTML = userNameString;
            mentionItemDOM.append(usernameDOM);
          }
          var emailDOM = document.createElement("span");
          emailDOM.classList.add("email", "cf-unreset");
          var emailString = pMentionItem.email_address;
          if (typeof emailString === "string" && emailString.length > 0) {
            pSearchString = pSearchString.replaceAll("\xA0", " ");
            if (emailString.toLowerCase().indexOf(pSearchString.toLowerCase()) !== -1) {
              emailString = emailString.replace(new RegExp(pSearchString, "i"), function (pMatch) {
                return "<b>" + pMatch + "</b>";
              });
            }
            emailDOM.innerHTML = emailString;
            mentionItemDOM.append(emailDOM);
          }
          mentionItemDOM.setAttribute("data-tajiri-mentionID", encodeURIComponent(pMentionItem.email_address));
          listDOM.append(mentionItemDOM);
          mentionItemDOM.addEventListener("click", function (pEvent) {
            that._clickSuggestionHandler.bind(that, pEvent, pArea, pSelection).call();
          });
        });
        if (listDOM.firstChild) {
          listDOM.firstChild.setAttribute("selected", true);
          if (isListCutOff === true) {
            var moreButton = document.createElement("button");
            moreButton.setAttribute("type", "button");
            moreButton.classList.add("tajiri-mentionplugin-listitem", "list-cut-off");
            moreButton.textContent = "...";
            listDOM.append(moreButton);
          }
        } else {
          var emptyDOM = document.createElement("button");
          emptyDOM.classList.add("tajiri-mentionplugin-listitem", "no-results");
          if (window.$ !== undefined && window.$.i18n !== undefined) {
            emptyDOM.textContent = $.i18n._("nixps-tajiri.pluginmention_noresults");
          } else {
            emptyDOM.textContent = "No results";
          }
          listDOM.append(emptyDOM);
        }
      })["catch"](function (pError) {
        console.error(pError);
      });
    }
  }, {
    key: "_drawMentionList",
    value: function _drawMentionList(pList, pPos, pArea, pSelection) {
      var that = this;
      if (pList.length === 0) {
        return;
      }
      var listDOM = document.createElement("div");
      listDOM.classList.add("tajiri-mentionplugin-list");
      var isListCutOff = false;
      if (pList.length > 100) {
        isListCutOff = true;
        pList = pList.slice(0, 100);
      }
      pList.forEach(function (pMentionItem) {
        var mentionItemDOM = document.createElement("button");
        mentionItemDOM.setAttribute("type", "button");
        mentionItemDOM.classList.add("tajiri-mentionplugin-listitem");
        if (typeof pMentionItem.full_name === "string" && pMentionItem.full_name.length > 0) {
          var usernameDOM = document.createElement("span");
          usernameDOM.classList.add("username");
          usernameDOM.textContent = pMentionItem.full_name;
          mentionItemDOM.append(usernameDOM);
        }
        if (typeof pMentionItem.email_address === "string" && pMentionItem.email_address.length > 0) {
          var emailDOM = document.createElement("span");
          emailDOM.classList.add("email");
          emailDOM.textContent = pMentionItem.email_address;
          mentionItemDOM.append(emailDOM);
        }
        if (mentionItemDOM.childNodes.length > 0) {
          mentionItemDOM.setAttribute("data-tajiri-mentionID", encodeURIComponent(pMentionItem.email_address));
          listDOM.append(mentionItemDOM);
          mentionItemDOM.addEventListener("click", function (pEvent) {
            that._clickSuggestionHandler.bind(that, pEvent, pArea, pSelection).call();
          });
        }
      });
      if (isListCutOff === true) {
        var moreButton = document.createElement("button");
        moreButton.setAttribute("type", "button");
        moreButton.classList.add("tajiri-mentionplugin-listitem", "list-cut-off");
        moreButton.textContent = "...";
        listDOM.append(moreButton);
      }
      document.querySelector("body").append(listDOM);
      listDOM.style.minWidth = listDOM.offsetWidth + "px";
      listDOM.style.top = pPos.top - listDOM.offsetHeight - 10 + "px";
      if (listDOM.offsetTop < 0) {
        listDOM.style.top = pPos.top + pPos.height + 10 + "px";
      } else {
        //align to the bottom, since the list could shorten and appear to "float"
        //convert top to bottom value
        listDOM.style.bottom = window.innerHeight - listDOM.offsetTop - listDOM.offsetHeight + "px";
        listDOM.style.top = "";
      }
      listDOM.style.left = pPos.left + "px";
      if (listDOM.offsetWidth + listDOM.style.left > window.outerWidth) {
        listDOM.style.left = "";
        listDOM.style.right = "0";
      }
      listDOM.firstChild.setAttribute("selected", true);
      listDOM.setAttribute("id", this.suggestionMenuGUID);
    }
  }, {
    key: "_moveSuggestionDown",
    value: function _moveSuggestionDown() {
      var listDOM = document.getElementById(this.suggestionMenuGUID);
      if (listDOM.childNodes.length === 1 && listDOM.childNodes[0].classList.contains("no-results")) {
        //there's no results, no need to move up or down in this case
        return;
      }
      var selectedDOM = listDOM.querySelector("[selected]");
      selectedDOM.removeAttribute("selected");
      if (listDOM.lastChild === selectedDOM || selectedDOM.nextElementSibling.classList.contains("list-cut-off")) {
        listDOM.firstChild.setAttribute("selected", true);
        listDOM.firstChild.scrollIntoView(true);
      } else {
        selectedDOM.nextElementSibling.setAttribute("selected", true);
        if (selectedDOM.nextElementSibling.offsetTop + selectedDOM.nextElementSibling.offsetHeight > listDOM.offsetHeight) {
          //appearing under the scrollview
          selectedDOM.nextElementSibling.scrollIntoView(false);
        }
      }
    }
  }, {
    key: "_moveSuggestionUp",
    value: function _moveSuggestionUp() {
      var listDOM = document.getElementById(this.suggestionMenuGUID);
      if (listDOM.childNodes.length === 1 && listDOM.childNodes[0].classList.contains("no-results")) {
        //there's no results, no need to move up or down in this case
        return;
      }
      var selectedDOM = listDOM.querySelector("[selected]");
      selectedDOM.removeAttribute("selected");
      if (listDOM.firstChild === selectedDOM) {
        var buttonToSelect = listDOM.lastChild;
        if (buttonToSelect.classList.contains("list-cut-off")) {
          buttonToSelect = buttonToSelect.previousElementSibling;
        }
        buttonToSelect.setAttribute("selected", true);
        buttonToSelect.scrollIntoView(false);
      } else {
        selectedDOM.previousElementSibling.setAttribute("selected", true);
        if (selectedDOM.previousElementSibling.getBoundingClientRect().top < listDOM.getBoundingClientRect().top) {
          //appearing above the scrollview
          selectedDOM.previousElementSibling.scrollIntoView(true);
        }
      }
    }
  }, {
    key: "_clickSuggestionHandler",
    value: function _clickSuggestionHandler(pEvent, pArea, pSelection) {
      var clicked = pEvent.target.closest("button");
      var list = document.getElementById(this.suggestionMenuGUID);
      list.querySelector("[selected]").removeAttribute("selected");
      clicked.setAttribute("selected", "true");
      this._chosenMention(pArea, pSelection);
    }
  }, {
    key: "_chosenMention",
    value: function _chosenMention(pArea, pSelection) {
      //made the choice!! -> turn the @ mention into a block with choice selected in menu
      var choiceMenu = document.getElementById(this.suggestionMenuGUID);
      var mentionedUser = choiceMenu.querySelector("[selected]");
      if (mentionedUser === null && choiceMenu !== null) {
        //the list is there, no choice is selected (no results?) - we remove the list, stop mentioning
        if (document.getElementById(this.suggestionMenuGUID) !== null) {
          document.querySelector("body").removeChild(document.getElementById(this.suggestionMenuGUID));
        }
        if (pArea.querySelector(".is-mentioning") !== null) {
          //remove tag created for mention
          var mentionTag = pArea.querySelector(".is-mentioning");
          var textMentionTag = mentionTag.childNodes[0];
          mentionTag.before(textMentionTag);
          mentionTag.parentElement.removeChild(mentionTag);
        }
        this.isMentioning = false;
        pArea.removeEventListener("keydown", this._startListeningBind);
        pArea.removeEventListener("click", this._clickListenerBind);
        return;
      }
      var range = new Range();
      range.setStartBefore(document.querySelector(".is-mentioning"));
      range.setEnd(pSelection.focusNode, pSelection.focusOffset);
      range.deleteContents();
      var mention = document.createElement("span");
      mention.classList.add("cf-mention");
      mention.setAttribute("data-tajiri-template-value", mentionedUser.getAttribute("data-tajiri-mentionid"));
      mention.textContent = "@" + mentionedUser.firstChild.textContent;
      range.insertNode(mention);
      mention.setAttribute("contenteditable", false);
      range.setStartAfter(mention);
      range.setEndAfter(mention);
      pSelection.removeAllRanges();
      pSelection.addRange(range);
      if (document.getElementById(this.suggestionMenuGUID) !== null) {
        document.querySelector("body").removeChild(document.getElementById(this.suggestionMenuGUID));
      }
      if (pArea.querySelector(".is-mentioning") !== null) {
        pArea.querySelector(".is-mentioning").parentElement.removeChild(pArea.querySelector(".is-mentioning"));
      }
      this.isMentioning = false;
      pArea.removeEventListener("keydown", this._startListeningBind);
      pArea.removeEventListener("click", this._clickListenerBind);
    }
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {}
  }, {
    key: "inputHandler",
    value: function inputHandler(pArea, pSelection, pEvent) {
      if (pEvent.data === "@") {
        this._typedMentionCharacter(pSelection, pArea);
      }
    }
  }, {
    key: "destroy",
    value: function destroy(pArea) {
      this.alive = false;
      if (document.getElementById(this.suggestionMenuGUID) !== null) {
        document.querySelector("body").removeChild(document.getElementById(this.suggestionMenuGUID));
      }
    }
  }], [{
    key: "databaseToHTML",
    value:
    // //change mentions from @{bla@bla.com:blabla} to html readable
    // return pString.replace(/[@]{([^}]*):([^}]*)}/ig, function(pMatch, p1, p2){
    //     p2 = decodeURIComponent(p2);
    //     if (p2.startsWith("@") === false) {
    //         p2 = "@" + p2
    //     }
    //     return `<span class="cf-mention" data-tajiri-template-value="${p1}" contenteditable="false">${p2}</span>`
    // })
    // return pString.replace(/<span(?=[^>]*class=["'][^"']*cf-mention[^"']*")(?=[^>]*data-mention-value=["'](.*?)["'])[^>]*>\s*((?:<[^\/][^>]*>)*)(@[^<]+)((?:<\/[^>]+>)*)\s*<\/span>/gi, function(pMatch, p1, p2, p3, p4) {
    //     p2 = p2 ? p2 : "";
    //     p3 = p3 ? p3 : "";
    //     p4 = p4 ? p4 : "";
    //     if (p3.startsWith("@")) {
    //         p3 = p3.substring(1);
    //     }
    //     return p2 + "@{" + p1 + ":" + p3 + "}" + p4;
    // });
    function databaseToHTML(pString) {
      return pString.replace(/<mention data-mention-value=["'](.*?)["']>(.*?)<\/mention>/ig, function (pMatch, p1, p2) {
        p1 = p1 ? p1 : "";
        p2 = p2 ? p2 : "";
        return "<span class='cf-mention' data-mention-value='".concat(p1, "'>").concat(p2, "</span>");
      });
    }
  }, {
    key: "HTMLToDatabase",
    value: function HTMLToDatabase(pString) {
      return pString.replace(/[@]{([^}]*):([^}]*)}/ig, function (pMatch, p1, p2) {
        return "<hybrid-mention data-mention-value='".concat(p1, "'>@").concat(decodeURIComponent(p2), "</hybrid-mention>");
      });
    }
  }, {
    key: "isUserMentioned",
    value: function isUserMentioned(pMentionDOM, pUserEmail, pMentions) {
      var foundMentions = [];
      var mentionContent = pMentionDOM.textContent;
      if (mentionContent.startsWith("@") === true) {
        mentionContent = mentionContent.slice(1);
      }
      for (var i = 0; i < pMentions.length; i++) {
        var candidate = pMentions[i];
        //first find out if the candidate is relevant
        if (mentionContent === candidate.full_name || mentionContent === candidate.email_address) {
          //relevant -> check on email address now
          if (pUserEmail === candidate.email_address) {
            foundMentions.push(candidate);
          }
        }
      }
      return foundMentions.length > 0;
    }
  }, {
    key: "adaptForUserMentioned",
    value: function adaptForUserMentioned(pMentionDOM) {
      pMentionDOM.classList.add("cf-mention-ping");
    }
  }, {
    key: "getMentionsData",
    value: function getMentionsData(pText) {
      var regexp = new RegExp(/<hybrid-mention\b[^>]*?(?:data-mention-value=['"]([^'"]+)['"][^>]*?)?>([^<]*)<\/hybrid-mention>/, "ig");
      var foundMentions = Array.from(pText.matchAll(regexp));
      var mentions = [];
      for (var i = 0; i < foundMentions.length; i++) {
        //change the visual content of the mention tag
        var fullMentionTag = foundMentions[i][0];
        var email = decodeURIComponent(foundMentions[i][1]) === "undefined" ? undefined : decodeURIComponent(foundMentions[i][1]);
        var fullName = foundMentions[i][2];
        if (fullName.startsWith("@") === true) {
          fullName = fullName.slice(1);
        }
        if (fullName === email) {
          //there was no full_name - email address was used
          fullName = undefined;
        }
        mentions.push({
          "mention": fullMentionTag,
          "email_address": email === "undefined" ? undefined : email,
          "full_name": fullName
        });
        if (email === undefined && fullName === undefined) {
          console.error("MentionPlugin.getMentionsData: Both email and full name are undefined");
        }
      }
      return mentions;
    }
  }]);
  return MentionPlugin;
}(TextualPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = MentionPlugin;
}

},{"./Plugin.js":362,"./TextualPlugin.js":375}],360:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var ListPlugin = require("./ListPlugin.js");
  var Utils = require("./../../Utils.js");
}

/**
 * @description Plugin handling the number lists
 * @extends ListPlugin 
 */
var NumberListPlugin = /*#__PURE__*/function (_ListPlugin) {
  _inherits(NumberListPlugin, _ListPlugin);
  var _super = _createSuper(NumberListPlugin);
  function NumberListPlugin() {
    var _this;
    var pOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, NumberListPlugin);
    pOptions.command = "insertOrderedList";
    _this = _super.call(this, pOptions);
    _this.tags = ["ol", "li"];
    _this.activeTags = ["ol"]; //we make a distinction because "li" would set both numbered & bullet as active
    _this.enterMode = pOptions.enterMode;
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(NumberListPlugin, [{
    key: "getID",
    value: function getID() {
      return "NumberListPlugin";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: StyledPluginEC.BUTTON_TOGGLE,
        icon: "fa fa-list-ol",
        text: "",
        tooltip: "nixps-tajiri.pluginnumberlist_tooltip"
      };
    }
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      if (pNode.nodeType === Node.TEXT_NODE) {
        pNode = pNode.parentElement;
      }
      //isActive will also check on parentElements - skip on "ul" or "ol" nodes
      var listNode = pNode.closest("ul, ol");
      if (listNode === null || listNode.nodeName.toLowerCase() === "ul") {
        return "skip";
      }
      return this.activeTags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var parentNode = pSelection.anchorNode.parentElement.closest("p, div");
      parentNode.querySelectorAll("*").forEach(function (pNode) {
        if (pNode.style.cssText !== "") {
          pNode.setAttribute("data-tajiri-style", pNode.style.cssText);
        }
      });
      document.execCommand(this.command);
      var range = pSelection.getRangeAt(0);
      if (range.commonAncestorContainer.nodeName.toLowerCase() === "ol") {
        //only select entire list if the format was an actual format
        range.selectNode(range.commonAncestorContainer);
      }
      pSelection.removeAllRanges();
      pSelection.addRange(range);
      Utils.applyDataStyleToRealStyle(parentNode);
    }
  }]);
  return NumberListPlugin;
}(ListPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = NumberListPlugin;
}

},{"./../../Utils.js":321,"./ListPlugin.js":358,"./StyledPluginEC.js":369}],361:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Utils = require("./../../Utils.js");
}
/**
 * @extends StyledPluginEC
 */
var OutdentPlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(OutdentPlugin, _StyledPluginEC);
  var _super = _createSuper(OutdentPlugin);
  function OutdentPlugin() {
    var _this;
    _classCallCheck(this, OutdentPlugin);
    _this = _super.call(this, "outdent");
    _this.disabled_reasons = ["noActive"];
    _this.tags = ["li"];
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(OutdentPlugin, [{
    key: "getID",
    value: function getID() {
      return "Outdent";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: StyledPluginEC.BUTTON_TOGGLE,
        icon: "fa fa-outdent",
        text: "nixps-tajiri.pluginoutdent_tooltip",
        tooltip: "nixps-tajiri.pluginoutdent_tooltip"
      };
    }
  }, {
    key: "showSelected",
    value: function showSelected() {
      return false;
    }
  }, {
    key: "getKeyMapping",
    value: function getKeyMapping() {
      return ["shift+Tab"]; //shift + tab
    }
  }, {
    key: "keyMappingHandler",
    value: function keyMappingHandler(pSelection, pRootNode, pEvent) {
      if (this.disabled_reasons.length === 0) {
        this.format(pSelection, pRootNode);
      }
      return this.getID();
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      if (pNode.nodeType === Node.TEXT_NODE) {
        pNode = pNode.parentElement;
      }
      if (pNode.closest("li") === null) {
        var index = this.disabled_reasons.indexOf("noActive");
        if (index === -1) {
          this.disabled_reasons.push("noActive");
        }
        return false;
      }
      if (this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1) {
        var index = this.disabled_reasons.indexOf("noActive");
        if (index !== -1) {
          this.disabled_reasons.splice(index, 1);
        }
        return true;
      } else {
        var index = this.disabled_reasons.indexOf("noActive");
        if (index === -1) {
          this.disabled_reasons.push("noActive");
        }
        return false;
      }
    }
  }, {
    key: "setDisabledReason",
    value: function setDisabledReason(pReason) {
      var index = this.disabled_reasons.indexOf(pReason);
      if (index === -1) {
        this.disabled_reasons.push(pReason);
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "mustBeDisabled",
    value: function mustBeDisabled() {
      if (this.disabled_reasons.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "updateDisabledReasons",
    value: function updateDisabledReasons(pSelection, pRootNode) {
      this.disabled_reasons = [];
      this.isActive(pSelection, pRootNode);
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var range = pSelection.getRangeAt(0);
      var parentNode = pSelection.anchorNode.parentElement.closest("p, div");
      parentNode.querySelectorAll("*").forEach(function (pNode) {
        if (pNode.style.cssText !== "") {
          pNode.setAttribute("data-tajiri-style", pNode.style.cssText);
        }
      });
      var anchorNode = pSelection.anchorNode;
      if (anchorNode.nodeType === Node.TEXT_NODE) {
        anchorNode = anchorNode.parentNode;
      }
      var listItemNode = $(anchorNode.closest("li"));
      while (listItemNode.next().length !== 0) {
        if (["ol", "ul"].includes(listItemNode.next()[0].nodeName.toLowerCase())) {
          range.setEndAfter(listItemNode.next()[0]);
        } else if (listItemNode.next()[0].nodeName.toLowerCase() === "li") {
          break;
        }
        listItemNode = listItemNode.next();
      }
      pSelection.removeAllRanges();
      pSelection.addRange(range);
      document.execCommand(this.command);
      // pSelection.getRangeAt(0).collapse(true);
      parentNode.querySelectorAll("li").forEach(function (pNode) {
        var parent = $(pNode).parent();
        if (parent[0].nodeName.toLowerCase() !== "ul") {
          return;
        }
        switch ($(pNode).parentsUntil("div", "ul").length) {
          case 0:
          case 1:
            parent.css("list-style-type", "disc");
            break;
          case 2:
            parent.css("list-style-type", "circle");
            break;
          default:
            parent.css("list-style-type", "square");
            break;
        }
      });
      Utils.cleanLists(pRootNode);
      Utils.applyDataStyleToRealStyle(pRootNode);

      //correctly set the selection (this is important for isActive, since it'll otherwise de-activate the button incorrectly)
      var selection = document.getSelection();
      var range = selection.getRangeAt(0);
      var startContainer = range.startContainer.nodeType === Node.TEXT_NODE ? range.startContainer.parentElement.closest("li") : range.startContainer.closest("li");
      var endContainer = range.endContainer.nodeType === Node.TEXT_NODE ? range.endContainer.parentElement.closest("li") : range.endContainer.closest("li");
      var firstTextNode = this._getTextNode(startContainer, true);
      var lastTextNode = this._getTextNode(endContainer, false);
      range.setStart(firstTextNode, 0);
      range.setEnd(lastTextNode, lastTextNode.length);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }, {
    key: "_getTextNode",
    value: function _getTextNode(pNode, pFirst) {
      var index = 0;
      if (pFirst === false) {
        index = pNode.childNodes.length - 1;
      }
      var textNode = pNode;
      while (textNode.nodeType !== 3) {
        if (textNode.childNodes === undefined || textNode.childNodes.length === 0) {
          break;
        }
        if (pFirst === false) {
          index = textNode.childNodes.length - 1;
        }
        textNode = textNode.childNodes[index];
      }
      return textNode;
    }
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      this.format(pSelection, pRootNode);
    }
  }]);
  return OutdentPlugin;
}(StyledPluginEC);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = OutdentPlugin;
}

},{"./../../Utils.js":321,"./StyledPluginEC.js":369}],362:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Plugin interface for all plugins use by the new Tajiri Editor
 * A plugin defines a way to stylized a text, node or part of the DOMElement: Bold, Coloring, Alignement, etc...
 * All plugins must implements the 5 methods below : 
 * 
 * - getID
 * - getButtonDescription
 * - isActive
 * - format
 * - unformat
 * 
 * Graph of Plugin's hierarchy here: 
 * https://docs.google.com/spreadsheets/d/13U-BmJIzE0U_-yrOuGclz95sEj3pgqmjxwY1wKKVRtA/edit?usp=sharing
 * @abstract
 */
var Plugin = /*#__PURE__*/function () {
  function Plugin() {
    _classCallCheck(this, Plugin);
    this.debug = false;
    if (this.constructor == Plugin) {
      throw new Error("Abstract classes can't be instantiated.");
    }
  }

  /**------------------------------------------------------------------------------------------------
   * This function must be redefined by all plugins
   * Returns the plugin ID, it must be unique string
   * @function
   * @returns {string} the plugin ID.
   */
  _createClass(Plugin, [{
    key: "getID",
    value: function getID() {
      throw new Error("Method 'getID' must be implemented.");
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all plugins
     * Returns an object describing the plugin's button
     * keys are:
     * - type    [required] : the button type, it must be Plugin.BUTTON_TOGGLE. No other values are supported at the moment. Will change soon
     * - icon    [required] : a cf-icon class name to be shown on the button UI
     * - text    [optional] : the text displayed on the button (if no icon is provided)
     * - tooltip [required] : a brief description of the plugin fonctionality
     * @function
     * @returns {Object} the object containing the button description.
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      throw new Error("Method 'getButtonDescription' must be implemented.");
    }

    /**
     * @description Get the matching tags that tthe plugin is managing
     * @function
     * @name Plugin#getTags
     * @returns Array<String> the matching tags
     */
  }, {
    key: "getTags",
    value: function getTags() {
      return null;
    }

    /**
     * @description get all the valid html attributes, so the copy paste can filter on the correct attributes
     * @function
     * @name Plugin#getValidAttributeNames
     * @returns Array<String>
     */
  }, {
    key: "getValidAttributeNames",
    value: function getValidAttributeNames() {
      return null;
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all plugins
     * Function call to determine if a style is already applied on the selection
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     * @returns true or the style value if a style is applied, false otherwise
     */
  }, {
    key: "isActive",
    value: function isActive(pSelection, pRootNode) {
      throw new Error("Method 'isActive' must be implemented.");
    }

    /**------------------------------------------------------------------------------------------------
     * Function call to determine if a plugin should be visually activated
     * @returns {Boolean} whether the plugin should get selected style or not
     */
  }, {
    key: "showSelected",
    value: function showSelected() {
      return true;
    }

    /**
     * @description format the pasted DOM format 
     * @function
     * @param {DOM} pDOMTree 
     */
  }, {
    key: "formatForPaste",
    value: function formatForPaste(pDOMTree) {
      return pDOMTree;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(pSelection, pRoot) {}

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all plugins
     * function called by the editor when the plugin button is pressed if the style is not yet defined
     * on the selection
     * @function
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      throw new Error("Method 'format' must be implemented.");
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all plugins
     * function called by the editor when the plugin button is pressed if the style is already defined
     * on the selection
     * @function
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      throw new Error("Method 'unformat' must be implemented.");
    }

    /**------------------------------------------------------------------------------------------------
     * Returns whether the plugin allow other plugins to be used at the same time as this one. 
     * @returns {boolean|array} 
     * - true, if other plugins are not allowed while the plugin is active
     * - false, if other plugins are allowed while the plugin is active
     * - An array of plugins which are not allowed while this plugin is active
     */
  }, {
    key: "isExclusive",
    value: function isExclusive() {
      return false;
    }

    /**------------------------------------------------------------------------------------------------
     * function called to generate contextual menu items on a given selection, if the plugin desires 
     * to do so
     * @function
     * @param {MouseEvent} pEvent : the contextual menu event
     * @param {Node} pSelection   : the javascript selection
     * @param {Node} pRootNode    : the root node of the editing area
     * @returns {Array}           : an array of items description to be added into a contextual menu 
     * or null if none
     * Required keys for a menu item description are : 
     * - text     : A string to be displayed in the menu item
     * - tooltip  : A string briefly describing the item action
     * - icon     : A cf-icon class name representing the icon to be displayed on the left of the menu item
     * - action   : A function, that will be called if the menu item is selected
     * - subitems : An array of menu item descriptions, following the same pattern as this one.
     * by default, plugins do not add any contextual action. 
     */
  }, {
    key: "getContextualItems",
    value: function getContextualItems(pEvent, pSelection, pRootNode) {
      return null;
    }

    /**------------------------------------------------------------------------------------------------
     * Return the current value of the plugin if the plugin handles multiple values. 
     * Usefull for plugins like FGColor, where the plugin handle many colors 
     * @function
     * @returns {*} a plugin current value
     */
  }, {
    key: "getValue",
    value: function getValue() {
      return null;
    }

    /**------------------------------------------------------------------------------------------------
     * Set the current value of the plugin if the plugin handles multiple values. 
     * Usefull for plugins like FGColor, where the plugin handle many colors 
     * @function
     * @param {*} pValue : the value to be set in the plugin
     */
  }, {
    key: "setValue",
    value: function setValue(pValue) {}

    /**
     * @description function runs when the editor will be destroyed. Use this to clean up custom stuff
     * @function
     * @name Plugin#destroy
     * @returns {undefined}
     */
  }, {
    key: "destroy",
    value: function destroy() {}

    /**------------------------------------------------------------------------------------------------
     * Utility function providing some logging ability, adding the plugin's name as prefix
     */
  }, {
    key: "_log",
    value: function _log() {
      if (this.debug === true) {
        var args = Array.prototype.slice.call(arguments).slice();
        var id = "[" + this.getID() + " Plugin]: ";
        args = [id].concat(args);
        console.log.apply(console, args);
      }
    }

    /**------------------------------------------------------------------------------------------------
     * Utility function providing an easy way to set a node in the selection
     * @param {Node} pSelection   : the javascript selection
     * @param {*} pNode : the node to append/set in the selection
     */
  }, {
    key: "_setNodeInSelection",
    value: function _setNodeInSelection(pSelection, pNode) {
      if (pNode) {
        var range = pSelection.getRangeAt(0);
        range.deleteContents();
        range.insertNode(pNode);
        return pNode;
      }
    }

    /**------------------------------------------------------------------------------------------------
     * Utility function to check if an object is defined or not
     * @param {*} pObj : the object to check
     * @returns {boolean} true if the object is defined, false otherwise
     */
  }, {
    key: "_isDefined",
    value: function _isDefined(pObj) {
      return typeof pObj !== "undefined";
    }

    /**------------------------------------------------------------------------------------------------
     * Utility function to get the tag name of a node
     * @param {Node} pNode : a node to get the tagname from
     * @returns {string} the tag name in lower case of the node if it's defined
     */
  }, {
    key: "_getTagName",
    value: function _getTagName(pNode) {
      var n = pNode.tagName;
      if (n) {
        n = n.toLowerCase();
      }
      return n;
    }
  }, {
    key: "_replaceTagname",
    value: function _replaceTagname(pNode, pTag) {
      var outer = pNode.outerHTML;
      var newTag;
      if (pNode.nodeType === Node.TEXT_NODE) {
        newTag = document.createElement(pTag);
        newTag.append(pNode);
      } else {
        // Replace opening tag
        var regex = new RegExp('<' + pNode.tagName, 'i');
        newTag = outer.replace(regex, '<' + pTag);

        // Replace closing tag
        regex = new RegExp('</' + pNode.tagName, 'i');
        newTag = newTag.replace(regex, '</' + pTag);
        var parser = new DOMParser();
        newTag = parser.parseFromString(newTag, "text/html").body.firstChild;
      }
      return newTag;
    }
  }]);
  return Plugin;
}();
;
Plugin.BUTTON_TOGGLE = "Toggle";
Plugin.BUTTON_SELECT = "Select";
Plugin.BUTTON_COLORPICKER = "Colorpicker";
Plugin.BUTTON_NO_UI = "None";
Plugin.BUTTON_TYPES = [Plugin.BUTTON_TOGGLE, Plugin.BUTTON_SELECT, Plugin.BUTTON_COLORPICKER, Plugin.BUTTON_NO_UI];
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = Plugin;
}
//
//  TODO: 
//
// select needs better styling
// Source Plugin : handle <br>, new lines, and such
// Classnames should be prefixed / less generic
// use &zeroWidthWhitespace when pasting (we want caret after the pasted content)
// ADD tests for paste + check if we cover all cases
// ADD extra security filter (script & iframe tags - also source!) #53234

// FIX editor initiated without a setContent() won't initiate a history

},{}],363:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
}
/**
 * @description The PluginEC is an abstract plugin. EC stands for ExecCommand.
 * Its provide a simple way to implement a plugin using a command that do not directly apply style 
 * or do not care to un-apply it, unlike the StylePluginEC.
 * All commands can be found there:
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand
 * @abstract
 * @extends Plugin
 */
var PluginEC = /*#__PURE__*/function (_Plugin) {
  _inherits(PluginEC, _Plugin);
  var _super = _createSuper(PluginEC);
  function PluginEC(pCommand) {
    var _this;
    _classCallCheck(this, PluginEC);
    _this = _super.call(this);
    if (_this.constructor == PluginEC) {
      throw new Error("Abstract classes can't be instantiated.");
    }
    _this.command = pCommand;
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Function call to determine if a style is already applied on the selection.
   * In this implementation, we always returns false, as the unformat do not have sense here.
   * @param {Node} pSelection : the javascript selection
   * @param {Node} pRootNode  : the root node of the editing area
   * @returns true or the style value if a style is applied, false otherwise
   */
  _createClass(PluginEC, [{
    key: "isActive",
    value: function isActive(pSelection, pRootNode) {
      return false;
    }

    /**------------------------------------------------------------------------------------------------
     * function called by the editor when the plugin button is pressed 
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      // The execCommand method will always apply the defined command on the current selection
      document.execCommand(this.command);
    }
  }]);
  return PluginEC;
}(Plugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = PluginEC;
}

},{"./Plugin.js":362}],364:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
  var DirectionPlugin = require("./DirectionPlugin.js");
}
/**
 * @extends DirectionPlugin
 */
var RTLPlugin = /*#__PURE__*/function (_DirectionPlugin) {
  _inherits(RTLPlugin, _DirectionPlugin);
  var _super = _createSuper(RTLPlugin);
  function RTLPlugin(options) {
    var _this;
    _classCallCheck(this, RTLPlugin);
    _this = _super.call(this, options);
    _this.attribute = "dir";
    _this.property = null;
    _this.value = "rtl";
    _this.tags = ["rtl"];
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(RTLPlugin, [{
    key: "getID",
    value: function getID() {
      return "RTL";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "cf-icon cf-icon-text-rtl",
        text: "nixps-tajiri.pluginrtl_tooltip",
        tooltip: "nixps-tajiri.pluginrtl_tooltip"
      };
    }
  }]);
  return RTLPlugin;
}(DirectionPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = RTLPlugin;
}

},{"./DirectionPlugin.js":341,"./Plugin.js":362}],365:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
  var PluginEC = require("./PluginEC.js");
  var StyledPluginEC = require("./StyledPluginEC.js");
}
/**
 * @description The RemoveFormatPlugin allow the user to remove all kind of formatting from the current selection.
 * It use the execCommand feature with as command : "removeFormat"
 * @extends PluginEC
 */
var RemoveFormatPlugin = /*#__PURE__*/function (_PluginEC) {
  _inherits(RemoveFormatPlugin, _PluginEC);
  var _super = _createSuper(RemoveFormatPlugin);
  function RemoveFormatPlugin() {
    var _this;
    _classCallCheck(this, RemoveFormatPlugin);
    _this = _super.call(this, "removeFormat");

    // Array of supported plugins for this instance of CopyStyle plugin
    _this.allPlugins = [];
    _this.unformatedPlugins = [];
    for (var i = 0; i < arguments.length; ++i) {
      var plugin = arguments[i];
      if (plugin instanceof Plugin) {
        _this.allPlugins.push({
          plugin: plugin,
          value: null
        });
      }
    }
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(RemoveFormatPlugin, [{
    key: "getID",
    value: function getID() {
      return "Remove Format";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-eraser",
        text: "nixps-tajiri.pluginremoveformat_tooltip",
        tooltip: "nixps-tajiri.pluginremoveformat_tooltip"
      };
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      if (pSelection.type === "Caret") {
        // deselect actual active formats
        this.allPlugins.forEach(function (pluginInfo) {
          var value = pluginInfo.plugin.isActive(pSelection, pRootNode);
          if (value === true || typeof value === "string" && value.length > 0) {
            pluginInfo.plugin.unformat(pSelection, pRootNode);
            that.unformatedPlugins.push(pluginInfo);
          }
        });
        pRootNode.addEventListener("keyup", function keyupHandler() {
          that.unformatedPlugins.forEach(function (pluginInfo) {
            if (typeof pluginInfo.plugin.fixAfterFormat === "function") {
              pluginInfo.plugin.fixAfterFormat(pRootNode);
            }
          });
          this.removeEventListener("keyup", keyupHandler);
        });
      }
      _get(_getPrototypeOf(RemoveFormatPlugin.prototype), "format", this).call(this, pSelection, pRootNode);
    }
  }]);
  return RemoveFormatPlugin;
}(PluginEC);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = RemoveFormatPlugin;
}

},{"./Plugin.js":362,"./PluginEC.js":363,"./StyledPluginEC.js":369}],366:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
  var Utils = require("../../Utils.js");
}

/**
 * @description The Source Plugin allow the user to switch from the WISIWIG view to the HTML source code view. 
 * The plugin is currently using the innerHTML property from the Node to swithc from one mode to the other
 * @extends Plugin
 */
var SourcePlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(SourcePlugin, _Plugin);
  var _super = _createSuper(SourcePlugin);
  function SourcePlugin() {
    var _this;
    _classCallCheck(this, SourcePlugin);
    _this = _super.call(this);
    _this.active = false;
    _this.docType = "";
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(SourcePlugin, [{
    key: "getID",
    value: function getID() {
      return "Source";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-code",
        text: "Src",
        tooltip: "nixps-tajiri.pluginsource_tooltip"
      };
    }

    /**------------------------------------------------------------------------------------------------
     * returns true if the plugin is active, false otherwise
     */
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "setActive",
    value: function setActive(pActive) {
      this.active = pActive;
    }

    /**------------------------------------------------------------------------------------------------
     * Switch from the WISIWIG view to source code view
     * the string has to be escaped to replace HTML characters by their corresponding entities
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      this.active = true;
      pRootNode.setAttribute("contenteditable", "plaintext-only");
      pRootNode.setAttribute("spellcheck", false);
      pRootNode.classList.add("src-active");
      var HTMLString = pRootNode.innerHTML;
      this.stylesDict = {};
      if (pRootNode.querySelector("[data-tajiri-style-tag") !== null) {
        var styleTag = pRootNode.querySelector("[data-tajiri-style-tag");
        if (_typeof(styleTag) === "object" && styleTag !== null) {
          var stylesString = styleTag.innerText;
          if (typeof stylesString === "string" && stylesString.length > 0) {
            // clean up
            stylesString = stylesString.replace(/\r|\n/g, " ").replace(/<!--[^<]*-->/g, "").trim();
            // fill in dictionary
            stylesString.replace(/([^}]*){([^}]*)}/g, function (pMatch, pCSSSelector1, pCSSValues2) {
              that.stylesDict[pCSSSelector1.trim()] = pCSSValues2.trim();
            });
          }
        }
      }
      if (HTMLString.includes("data-tajiri-body-tag") || HTMLString.includes("data-tajiri-head-tag")) {
        //there was HTML in source 
        var dom = new DOMParser().parseFromString(HTMLString, "text/html");
        if (Object.keys(this.stylesDict).length > 0) {
          for (var cssselector in this.stylesDict) {
            var styleDictProp = cssselector;
            if (cssselector.match("body") !== null) {
              cssselector = cssselector.replace("body", "[data-tajiri-body-tag]");
            }
            var styles = that.stylesDict[styleDictProp].split(";");
            if (Utils.isValidSelector(cssselector) === true) {
              dom.body.querySelectorAll(cssselector).forEach(function (pNode) {
                styles.forEach(function (pStyle) {
                  if (pStyle.trim().length > 0) {
                    var stylename = pStyle.split(":")[0].trim();
                    var styleval = pStyle.split(":")[1].trim();
                    styleval = styleval.replaceAll("px", "");
                    var actualStyle = pNode.style[stylename] ? pNode.style[stylename].replaceAll("px", "") : undefined;
                    if (pNode.style[stylename] !== undefined && actualStyle === styleval) {
                      pNode.style[stylename] = "";
                    }
                  }
                });
                if (pNode.getAttribute("style").trim().length === 0) {
                  pNode.removeAttribute("style");
                }
              });
            }
          }
        }
        var tajiriHeadTag = dom.querySelector("[data-tajiri-head-tag]");
        if (tajiriHeadTag !== null) {
          Array.from(tajiriHeadTag.childNodes).forEach(function (pChildNode) {
            dom.head.append(pChildNode);
          });
          tajiriHeadTag.remove();
        }
        var tajiriBodyTag = dom.querySelector("[data-tajiri-body-tag]");
        if (tajiriBodyTag !== null) {
          Array.from(tajiriBodyTag.childNodes).forEach(function (pChildNode) {
            dom.body.append(pChildNode);
          });
          tajiriBodyTag.remove();
        }
        var tajiriStyleTag = dom.querySelector("[data-tajiri-style-tag]");
        if (tajiriStyleTag !== null) {
          if (dom.head !== null && dom.head !== undefined) {
            var _styleTag = dom.head.querySelector("style");
            if (_styleTag === null) {
              _styleTag = document.createElement("style");
              dom.head.append(_styleTag);
            }
            Array.from(tajiriStyleTag.childNodes).forEach(function (pChildNode) {
              _styleTag.append(pChildNode);
            });
            tajiriStyleTag.remove();
          }
        }
        _toConsumableArray(dom.querySelectorAll("title, style, meta")).forEach(function (pHeadTag) {
          dom.head.append(pHeadTag);
        });
        var toRemove = [];
        var breakTags = pRootNode.querySelectorAll("br");
        for (var i = 0; i < breakTags.length - 1; i++) {
          var breaktag = breakTags[i];
          if (breaktag.previousSibling !== null && breaktag.previousSibling.nodeName.toLowerCase() === "br") {
            if (breaktag.nextSibling !== null && breaktag.nextSibling.nodeName.toLowerCase() === "br") {
              i++;
            }
            toRemove.push(breaktag);
          }
        }
        toRemove.forEach(function (pRemove) {
          pRemove.remove();
        });
        // pRootNode.innerHTML = this.escape(dom.documentElement.outerHTML);
        this.nodeLevel = 0;
        HTMLString = this.docType.length > 0 ? this.docType + "\n" : "";
        HTMLString = this.formatForSource(HTMLString, dom.documentElement, pRootNode);
        pRootNode.innerHTML = this.escape(HTMLString);
      } else {
        this.nodeLevel = 0;
        if (Object.keys(this.stylesDict).length > 0) {
          for (var cssselector in this.stylesDict) {
            var _styleDictProp = cssselector;
            if (cssselector.match("body") !== null) {
              cssselector = cssselector.replace("body", "[data-tajiri-body-tag]");
            }
            var styles = that.stylesDict[_styleDictProp].split(";");
            if (Utils.isValidSelector(cssselector) === true) {
              pRootNode.querySelectorAll(cssselector).forEach(function (pNode) {
                styles.forEach(function (pStyle) {
                  if (pStyle.trim().length > 0) {
                    var stylename = pStyle.split(":")[0].trim();
                    var styleval = pStyle.split(":")[1].trim();
                    styleval = styleval.replaceAll("px", "");
                    var actualStyle = pNode.style[stylename] ? pNode.style[stylename].replaceAll("px", "") : undefined;
                    if (pNode.style[stylename] !== undefined && actualStyle === styleval) {
                      pNode.style[stylename] = "";
                    }
                  }
                });
              });
            }
          }
        }
        HTMLString = this.docType.length > 0 ? this.docType + "\n" : "";
        HTMLString = this.formatForSource(HTMLString, pRootNode, pRootNode);
        pRootNode.innerHTML = this.escape(HTMLString);
      }
      pRootNode.style["white-space"] = "pre";
    }
  }, {
    key: "formatForSource",
    value: function formatForSource(pString, pNode, pRootNode) {
      var _this2 = this;
      var BLOCK_ELEMENTS = {
        ADDRESS: 1,
        ARTICLE: 1,
        ASIDE: 1,
        BODY: 1,
        BLOCKQUOTE: 1,
        CANVAS: 1,
        DD: 1,
        DIV: 1,
        DL: 1,
        DT: 1,
        FIELDSET: 1,
        FIGCAPTION: 1,
        FIGURE: 1,
        FOOTER: 1,
        FORM: 1,
        H1: 1,
        H2: 1,
        H3: 1,
        H4: 1,
        H5: 1,
        H6: 1,
        HEAD: 1,
        HEADER: 1,
        HR: 1,
        HTML: 1,
        LI: 1,
        LINK: 1,
        MAIN: 1,
        META: 1,
        NAV: 1,
        NOSCRIPT: 1,
        OL: 1,
        P: 1,
        PRE: 1,
        SECTION: 1,
        STYLE: 1,
        TABLE: 1,
        TBODY: 1,
        TD: 1,
        TITLE: 1,
        TFOOT: 1,
        TR: 1,
        UL: 1,
        VIDEO: 1
      };
      var SELF_CLOSING = {
        IMG: 1,
        STYLE: 1
      };
      if (pNode.nodeType === Node.ELEMENT_NODE && pNode.children.length > 0) {
        if (pNode !== pRootNode) {
          var tag = pNode.innerHTML ? pNode.outerHTML.slice(0, pNode.outerHTML.indexOf(pNode.innerHTML)) : pNode.outerHTML;
          if (BLOCK_ELEMENTS[pNode.nodeName] && pString.endsWith(">") === true && pNode !== pNode.parentElement.firstElementChild) {
            //a block element, but there was no enter before (string ends with a )
            pString += "\n";
            var indent = "";
            for (var i = 0; i < this.nodeLevel; i++) {
              indent += "\t";
            }
            pString += indent;
          }
          pString = pString + tag;
          if (BLOCK_ELEMENTS[pNode.nodeName]) {
            pString += "\n";
            this.nodeLevel++;
            var _indent = "";
            for (var _i = 0; _i < this.nodeLevel; _i++) {
              _indent += "\t";
            }
            pString += _indent;
          }
        }
        pNode.childNodes.forEach(function (pChildNode) {
          pString = _this2.formatForSource(pString, pChildNode, pRootNode);
        });
        if (pNode !== pRootNode) {
          if (BLOCK_ELEMENTS[pNode.nodeName]) {
            pString += "\n";
            this.nodeLevel--;
            var _indent2 = "";
            for (var _i2 = 0; _i2 < this.nodeLevel; _i2++) {
              _indent2 += "\t";
            }
            pString += _indent2;
          }
          pString = pString + "</" + pNode.nodeName.toLowerCase() + ">";
          if (BLOCK_ELEMENTS[pNode.nodeName] && pNode.parentElement !== null && pNode !== pNode.parentElement.lastElementChild) {
            pString += "\n";
            var _indent3 = "";
            for (var _i3 = 0; _i3 < this.nodeLevel; _i3++) {
              _indent3 += "\t";
            }
            pString += _indent3;
          }
        }
      } else {
        if (pNode.nodeType === Node.ELEMENT_NODE && pNode !== pRootNode) {
          if (pNode.nodeName.toLowerCase() === "style") {
            pNode.innerHTML = "\n" + pNode.innerHTML;
            var nextClosingBraceIsVar = false;
            pNode.innerHTML = pNode.innerHTML.replace(/;|\${|{|}|,[ ]{2,}/ig, function (pMatch, offset) {
              if (pMatch === "}") {
                if (nextClosingBraceIsVar === true) {
                  //no enters needed
                  nextClosingBraceIsVar = false;
                  return pMatch;
                }
                return pMatch += "\n\n";
              } else if (pMatch.indexOf(",") !== -1) {
                return pMatch.slice(0, 1) + "\n" + pMatch.slice(1);
              } else if (pMatch === "${") {
                //do nothing, variable
                nextClosingBraceIsVar = true;
                return pMatch;
              }
              return pMatch += "\n";
            });
          }
          //&quot; exists before we did our own escaping, set it to '
          pString = pString + pNode.outerHTML.replaceAll("&quot;", "'");
          if (BLOCK_ELEMENTS[pNode.nodeName] && !SELF_CLOSING[pNode.nodeName] && pNode.parentElement !== null && pNode !== pNode.parentElement.lastElementChild) {
            pString += "\n";
            var _indent4 = "";
            for (var _i4 = 0; _i4 < this.nodeLevel; _i4++) {
              _indent4 += "\t";
            }
            pString += _indent4;
          } else if (pNode.nodeName.toLowerCase() === "br" && pNode.parentElement !== null && pNode !== pNode.parentElement.lastElementChild) {
            pString += "\n";
            var _indent5 = "";
            for (var _i5 = 0; _i5 < this.nodeLevel; _i5++) {
              _indent5 += "\t";
            }
            pString += _indent5;
          }
        } else if (pNode.nodeType === Node.TEXT_NODE && pNode.textContent !== "\n" && pNode.textContent.trim().length > 0) {
          var textContent = pNode.textContent;
          // if (pNode.parentElement.firstChild === pNode) {
          //     let amountOfSpaces = textContent.length - textContent.trimLeft().length;
          //     if (amountOfSpaces > 0) {
          //         let escapedSpaces = "&nbsp;";
          //         for (let i = 0; i < amountOfSpaces - 1; i++) {
          //             if (escapedSpaces.endsWith("&nbsp;")) {
          //                 escapedSpaces += " ";
          //             } else {
          //                 escapedSpaces += "&nbsp;"
          //             }
          //         }
          //         textContent = textContent.slice(amountOfSpaces);
          //         textContent = escapedSpaces + textContent;
          //     }
          // }
          // if (pNode.parentElement.lastChild === pNode) {
          //     let amountOfSpaces = textContent.length - textContent.trimRight().length;
          //     if (amountOfSpaces > 0) {
          //         let escapedSpaces = "&nbsp;";
          //         for (let i = 0; i < amountOfSpaces - 1; i++) {
          //             if (escapedSpaces.endsWith("&nbsp;")) {
          //                 escapedSpaces += " ";
          //             } else {
          //                 escapedSpaces += "&nbsp;"
          //             }
          //         }
          //         textContent = textContent.slice(0, textContent.length - amountOfSpaces);
          //         textContent = textContent + escapedSpaces;
          //     }
          // }
          pString = pString + textContent;
        } else if (pNode.nodeType === Node.COMMENT_NODE) {
          pString = pString + "<!--" + pNode.textContent.trim() + "-->\n";
          var _indent6 = "";
          for (var _i6 = 0; _i6 < this.nodeLevel; _i6++) {
            _indent6 += "\t";
          }
          pString += _indent6;
        }
      }
      return pString;
    }

    /**------------------------------------------------------------------------------------------------
     * Switch from the source code view to the WISIWIG view
     * We have to replace the escaped entities by the original HMTL character
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      var that = this;
      this.active = false;
      pRootNode.setAttribute("contenteditable", true);
      pRootNode.setAttribute("spellcheck", true);
      pRootNode.classList.remove("src-active");
      if (pRootNode.textContent.startsWith("<!DOCTYPE")) {
        this.docType = pRootNode.textContent.match(/<!DOCTYPE .+?>/ig)[0];
      } else {
        this.docType = "";
      }
      _toConsumableArray(pRootNode.querySelectorAll("br")).forEach(function (pBreakTag) {
        pBreakTag.remove();
      });
      //!! doing this BEFORE the escape - this way we keep the users escaped ones intact
      pRootNode.innerHTML = pRootNode.innerHTML.replace(/\t/g, "");
      pRootNode.innerHTML = pRootNode.innerHTML.replace(/\n/g, "");
      var HTMLString = this.unEscape(pRootNode.textContent);
      pRootNode.innerHTML = HTMLString.replace(/<head([^>]*)>/ig, "<div data-tajiri-head-tag $1>").replace(/<\/head>/ig, "</div>").replace(/<body([^>]*)>/ig, "<div data-tajiri-body-tag $1>").replace(/<\/body>/ig, "</div>");
      pRootNode.innerHTML = pRootNode.innerHTML.replace(/<[\\]?script([^>]*)>/ig, "");
      pRootNode.innerHTML = pRootNode.innerHTML.replace(/<[\\]?iframe([^>]*)>/ig, "");
      this.stylesDict = {};
      if (pRootNode.querySelector("style") !== null) {
        var styleTag = pRootNode.querySelector("style");
        if (_typeof(styleTag) === "object" && styleTag !== null) {
          var stylesString = styleTag.innerText;
          if (typeof stylesString === "string" && stylesString.length > 0) {
            // clean up
            stylesString = stylesString.replace(/\r|\n/g, " ").replace(/<!--[^<]*-->/g, "").trim();

            //first, we parse the variables to reset them afterwards.
            stylesString = stylesString.replaceAll(/\${([^{}]*)}/g, function (pMatch, pVariable) {
              return "nixps-template-variable:" + pVariable;
            });

            // fill in dictionary
            stylesString.replace(/([^}]*){([^}]*)}/g, function (pMatch, pCSSSelector1, pCSSValues2) {
              if (pCSSValues2.includes("nixps-template-variable:")) {
                pCSSValues2 = pCSSValues2.replaceAll(/nixps-template-variable:([^;]*)/g, function (pMatch, pVarName) {
                  return "${" + pVarName + "}";
                });
              }
              that.stylesDict[pCSSSelector1.trim()] = pCSSValues2.trim();
            });
          }
        }
      }
      pRootNode.innerHTML = pRootNode.innerHTML.replace(/<style([^>]*)>/ig, "<div data-tajiri-style-tag $1>").replace(/<\/style>/ig, "</div>");
      var body = pRootNode;
      if (Object.keys(this.stylesDict).length > 0) {
        var _loop = function _loop() {
          var styleDictProp = cssselector;
          if (cssselector.match("body") !== null) {
            cssselector = cssselector.replace("body", "[data-tajiri-body-tag]");
          }
          if (Utils.isValidSelector(cssselector) === true) {
            body.querySelectorAll(cssselector).forEach(function (pNode) {
              var oldStyle = pNode.getAttribute("style");
              if (typeof oldStyle === "string" && oldStyle.length > 0) {
                if (oldStyle.endsWith(";")) {
                  pNode.setAttribute("style", oldStyle + " " + that.stylesDict[styleDictProp]);
                } else {
                  pNode.setAttribute("style", oldStyle + ";" + that.stylesDict[styleDictProp]);
                }
              } else {
                pNode.setAttribute("style", that.stylesDict[styleDictProp]);
              }
            });
          }
        };
        for (var cssselector in this.stylesDict) {
          _loop();
        }
      }
      if (pRootNode.querySelector("[data-tajiri-body-tag]") !== null) {
        pRootNode.querySelector("[data-tajiri-body-tag]").style.height = "unset";
      }

      //empty p & div tags need a br tag to show correctly
      pRootNode.querySelectorAll("p, div").forEach(function (pNode) {
        if (pNode.childNodes.length === 0) {
          pNode.append(document.createElement("br"));
        }
      });
      pRootNode.style["white-space"] = "";
    }
  }, {
    key: "beforeUnformat",
    value: function beforeUnformat(pSelection, pRootNode) {
      var tempDOM = document.createElement("div");
      tempDOM.innerHTML = pRootNode.innerHTML;
      var HTMLString = this.unEscape(tempDOM.innerHTML);
      tempDOM.innerHTML = HTMLString.replace(/<head([^>]*)>/ig, "<div data-tajiri-head-tag $1>").replace(/<\/head>/ig, "</div>").replace(/<body([^>]*)>/ig, "<div data-tajiri-body-tag $1>").replace(/<\/body>/ig, "</div>");
      tempDOM.innerHTML = tempDOM.innerHTML.replace(/<[\\]?script([^>]*)>/ig, "");
      tempDOM.innerHTML = tempDOM.innerHTML.replace(/<[\\]?iframe([^>]*)>/ig, "");
      var stylesDict = {};
      if (tempDOM.querySelector("style") !== null) {
        var styleTag = tempDOM.querySelector("style");
        if (_typeof(styleTag) === "object" && styleTag !== null) {
          var stylesString = styleTag.innerText;
          if (typeof stylesString === "string" && stylesString.length > 0) {
            // clean up
            // stylesString = stylesString.replace(/\r|\n/g, " ").replace(/<!--[^<]*-->/g, "").trim();
            // fill in dictionary

            //first, we parse the variables to reset them afterwards.
            stylesString = stylesString.replaceAll(/\${([^{}]*)}/g, function (pMatch, pVariable) {
              return "nixps-template-variable:" + pVariable;
            });
            stylesString.replace(/([^}]*){([^}]*)}/g, function (pMatch, pCSSSelector1, pCSSValues2) {
              if (pCSSValues2.includes("nixps-template-variable:")) {
                pCSSValues2 = pCSSValues2.replaceAll(/nixps-template-variable:([^;]*)/g, function (pMatch, pVarName) {
                  return "${" + pVarName + "}";
                });
              }
              stylesDict[pCSSSelector1.trim()] = pCSSValues2.trim();
            });
          }
        }
      }
      var invalidSelectors = [];
      if (Object.keys(stylesDict).length > 0) {
        for (var cssselector in stylesDict) {
          if (Utils.isValidSelector(cssselector) !== true) {
            invalidSelectors.push({
              selector: Utils.isValidSelector(cssselector),
              from: pRootNode.innerHTML.indexOf(cssselector),
              to: pRootNode.innerHTML.indexOf(cssselector) + cssselector.length
            });
          }
        }
      }

      //before disabling the source, we check if there's invalid code
      if (invalidSelectors.length > 0) {
        pRootNode.dispatchEvent(new CustomEvent("tajiriinvalidselector", {
          detail: {
            invalidSelectors: invalidSelectors
          },
          bubbles: true
        }));
        return false;
      }
      return true;
    }

    /**------------------------------------------------------------------------------------------------
     * Indicate this plugins is exclusive and do not allow other plugins to be used while this one is
     * active 
     * @returns {boolean} 
     * - true, if other plugins are not allowed while the plugin is active
     * - false, if other plugins are allowed while the plugin is active
     */
  }, {
    key: "isExclusive",
    value: function isExclusive() {
      return true;
    }

    /**------------------------------------------------------------------------------------------------
     * Utility function to replace HTML char by their matching entities
     * @param {string} htmlStr the string to escape
     * @returns {string} the escaped string
     */
  }, {
    key: "escape",
    value: function escape(htmlStr) {
      return htmlStr.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }

    /**------------------------------------------------------------------------------------------------
     * Utility function to replace entities by their matching HTML char
     * @param {string} htmlStr the string to unescape
     * @returns {string} the unescaped string
     */
  }, {
    key: "unEscape",
    value: function unEscape(htmlStr) {
      return htmlStr.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&#39;/g, "\'").replace(/&amp;/g, "&");
    }
  }, {
    key: "formatForPaste",
    value: function formatForPaste(pDOMTree, pRootNode) {
      if (this.isActive() === true) {
        // user want to copy code from outside to source code
        // remove all styles, only content is needed
        var clone = pDOMTree.cloneNode(true);
        pRootNode.append(clone);
        pDOMTree.innerText = clone.innerText.trim();
        clone.remove();
        var toRemove = [];
        var breakTags = pDOMTree.querySelectorAll("br");
        for (var i = 0; i < breakTags.length - 1; i++) {
          var breaktag = breakTags[i];
          if (breaktag.previousSibling !== null && breaktag.previousSibling.nodeName.toLowerCase() === "br") {
            if (breaktag.nextSibling !== null && breaktag.nextSibling.nodeName.toLowerCase() === "br") {
              i++;
            }
            toRemove.push(breaktag);
          }
        }
        toRemove.forEach(function (pRemove) {
          pRemove.remove();
        });
      }
      return pDOMTree;
    }
  }, {
    key: "getExcludedCleaners",
    value: function getExcludedCleaners() {
      return ["EnterModeCleaner"];
    }
  }, {
    key: "shouldSaveHistory",
    value: function shouldSaveHistory() {
      return true;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.docType = "";
    }
  }]);
  return SourcePlugin;
}(Plugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = SourcePlugin;
}

},{"../../Utils.js":321,"./Plugin.js":362}],367:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @description Plugin handling the Strikethrough style 
 * @extends StyledPluginEC
 */
var StrikePlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(StrikePlugin, _StyledPluginEC);
  var _super = _createSuper(StrikePlugin);
  function StrikePlugin() {
    var _this;
    _classCallCheck(this, StrikePlugin);
    _this = _super.call(this, "strikeThrough");
    _this.tags = ["s", "strike"];
    _this.styleName = "text-decoration-line";
    _this.styleValues = ["line-through"];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(StrikePlugin, [{
    key: "getID",
    value: function getID() {
      return "Strikethrough";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "cf-icon cf-icon-strikethrough",
        text: "S",
        tooltip: "nixps-tajiri.pluginstrike_tooltip"
      };
    }

    /**------------------------------------------------------------------------------------------------
     * Function call to determine if "Strikethrough" is applied on a given node element
     * @param {Node} pNode the node to check.
     * @returns true if strike-through is applied, false otherwise
     */
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      return this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
    }
  }, {
    key: "_isActiveInCSSAttribute",
    value: function _isActiveInCSSAttribute(pCSSSelectors) {
      return pCSSSelectors.search(/(text-decoration-line|text-decoration)\s*:\s*line-through/i) >= 0;
    }
  }]);
  return StrikePlugin;
}(StyledPluginEC);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = StrikePlugin;
}

},{"./Plugin.js":362,"./StyledPluginEC.js":369}],368:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
}
/**
 * @description StyledPlugin is an abstract class. 
 * It should be inherited by all plugins who desire to apply, but also to remove, a style.
 * @extends Plugin
 * @abstract
 */
var StyledPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(StyledPlugin, _Plugin);
  var _super = _createSuper(StyledPlugin);
  function StyledPlugin() {
    var _this;
    _classCallCheck(this, StyledPlugin);
    _this = _super.call(this);
    if (_this.constructor == StyledPlugin) {
      throw new Error("Abstract classes can't be instantiated.");
    }
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * This function must be redefined by all sub-plugins
   * Function called to determine if a style is applied on a given node element
   * @param {Node} pNode the node to check.
   * @returns true or the style value if a style is applied, false otherwise
   */
  _createClass(StyledPlugin, [{
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      throw new Error("Method 'isStyleActive' must be implemented.");
    }
  }, {
    key: "setDisabledReason",
    value: function setDisabledReason(pReason) {
      return;
    }

    /**------------------------------------------------------------------------------------------------
     * This function must be redefined by all plugins
     * Function call to determine if a style is already applied on the selection
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     * @returns true or the style value if a style is applied, false otherwise
     */
  }, {
    key: "isActive",
    value: function isActive(pSelection, pRootNode) {
      var that = this;

      // First, find all leaves nodes that belong to the selection.
      var leaves = this._findLeavesInSelection(pSelection);
      // For each of those nodes, find if the style is applied to them, either directly or from an 
      // ancestor node.
      var arr = leaves.map(function (pNode) {
        while (pRootNode.contains(pNode)) {
          var style = that.isStyleActive(pNode);
          if (style === "skip") {
            //we don't want to check any further, plugin communicated to stop
            break;
          }
          if (style) {
            return style;
          }
          pNode = pNode.parentNode;
        }
        return false;
      });
      var tmp = [];
      if (this.getButtonDescription().type === Plugin.BUTTON_SELECT && arr.includes(false)) {
        arr.forEach(function (style) {
          if (style !== false) {
            tmp[0] = "mixed";
          }
        });
      } else if (this.getButtonDescription().type === Plugin.BUTTON_SELECT) {
        var found = [];
        arr.forEach(function (style) {
          if (found.includes(style) === false) {
            found.push(style);
          }
        });
        if (found.length > 1) {
          tmp[0] = "mixed";
        } else {
          found.forEach(function (style) {
            if (tmp.indexOf(style) === -1) {
              tmp.push(style);
            }
          });
        }
      } else {
        arr.forEach(function (style) {
          if (tmp.indexOf(style) === -1) {
            tmp.push(style);
          }
        });
      }

      // We consider here, the style is applied if and only if the same style is defined on 
      // all leaves
      this._log(' --- is Plugin active? --- ');
      this._log('Leaves: ', leaves);
      this._log('active on leaves: ', arr);
      this._log('ret: ', tmp[0]);
      if (tmp.length !== 1 || tmp[0] === null || !this._isDefined(tmp[0])) {
        //didn't find any leaves, communicate this w/ the plugin
        this.setDisabledReason("noActive");
        return false;
      }
      return tmp[0];
    }

    /**------------------------------------------------------------------------------------------------
     * Find all leaves belonging to the
     * @param {*} pSelection 
     * @returns {undefined}
     */
  }, {
    key: "_findLeavesInSelection",
    value: function _findLeavesInSelection(pSelection) {
      var startNode = pSelection.getRangeAt(0).startContainer;
      var endNode = pSelection.getRangeAt(0).endContainer;
      var commonAncestor = pSelection.getRangeAt(0).commonAncestorContainer;
      var leaves = this._findLeaves(commonAncestor);
      var startReached = false;
      var endReached = false;
      return leaves.filter(function (node) {
        if (node === startNode || startNode.contains(node)) {
          startReached = true;
        }

        // if start has not been found. 
        // this leave is irrevelant
        if (!startReached) {
          return false;
        }

        // if the end has been found. 
        // this leave is irrevelant
        if (endReached) {
          return false;
        }
        if (node === endNode || endNode.contains(node)) {
          endReached = true;
        }
        return true;
      });
    }

    /**------------------------------------------------------------------------------------------------
     * Find all leaves of a given node.
     * @param {*} node : the node
     * @returns {Array<Node>} an array containing all leaves of the node given in parameter
     */
  }, {
    key: "_findLeaves",
    value: function _findLeaves(node) {
      if (node.childNodes.length === 0) {
        return [node];
      }
      var arr = [];
      for (var i = 0, len = node.childNodes.length; i < len; ++i) {
        arr = arr.concat(this._findLeaves(node.childNodes[i]));
      }
      return arr;
    }
  }]);
  return StyledPlugin;
}(Plugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = StyledPlugin;
}

},{"./Plugin.js":362}],369:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPlugin = require("./StyledPlugin.js");
}
/**
 * @description StyledPluginEC is an abstract class. 
 * Its provide a simple way to implement a plugin using a command that desire to apply and remove a style 
 * command .
 * All commands can be found there:
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand
 * @extends StyledPlugin
 * @abstract
 */
var StyledPluginEC = /*#__PURE__*/function (_StyledPlugin) {
  _inherits(StyledPluginEC, _StyledPlugin);
  var _super = _createSuper(StyledPluginEC);
  function StyledPluginEC(pCommand, _pUndoCommand) {
    var _this;
    _classCallCheck(this, StyledPluginEC);
    _this = _super.call(this);
    if (_this.constructor == StyledPluginEC) {
      throw new Error("Abstract classes can't be instantiated.");
    }
    _this.command = pCommand;
    _this.undoCommand = _pUndoCommand ? _pUndoCommand : pCommand;
    return _this;
  }
  _createClass(StyledPluginEC, [{
    key: "getTags",
    value: function getTags() {
      return this.tags;
    }
  }, {
    key: "fixAfterFormat",
    value: function fixAfterFormat(pParentNode) {
      // there are cases that the style is applied via css and not via tags
      // remove the style and insert tags
      if (this.styleName !== undefined && this.styleValues !== undefined) {
        var that = this;
        var regExp = new RegExp(this.styleName + "\\s*:\\s*(" + this.styleValues.join("|") + ")\\s*;");
        pParentNode.querySelectorAll("*").forEach(function (pNode) {
          // use getAttribute style because the .style is empty
          var attributeStyle = pNode.getAttribute("style");
          if (regExp.test(attributeStyle)) {
            var restAttributeStyle = attributeStyle.replace(regExp, "").trim();
            pNode.style[that.styleName] = ""; // remove the specific style
            if (restAttributeStyle.length > 0) {
              pNode.setAttribute("style", restAttributeStyle); // restore other styles
            } else {
              pNode.removeAttribute("style"); // remove is nothing is inside
            }
            // insert the tag
            var paraElement = document.createElement(that.tags[0]);
            // move all chilren to new parent
            var length = pNode.childNodes.length;
            for (var i = 0; i < length; i++) {
              // always use index 0 because .append moves it, and the next is alwys set as first
              paraElement.append(pNode.childNodes[0]);
            }
            pNode.append(paraElement);
          }
        });
      }
    }

    /**------------------------------------------------------------------------------------------------
     * function called by the editor when the plugin button is pressed 
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      document.execCommand(this.command);
      if (pSelection.type === "Caret") {
        document.execCommand("insertText", false, "\u200B");
      }
      this.fixAfterFormat(pSelection.anchorNode.parentElement.closest("p, div"));
    }

    /**------------------------------------------------------------------------------------------------
     * function called by the editor when the plugin button is pressed if the style is already defined
     * on the selection
     * @param {Node} pSelection : the javascript selection
     * @param {Node} pRootNode  : the root node of the editing area
     */
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      document.execCommand(this.undoCommand);
      if (pSelection.type === "Caret") {
        document.execCommand("insertText", false, "\u200B");
      }
      this.fixAfterFormat(pSelection.anchorNode.parentElement.closest("p, div"));
    }
  }, {
    key: "_isActiveInCSSAttribute",
    value: function _isActiveInCSSAttribute(pCSSSelectors) {
      return false; // default
    }
  }, {
    key: "_isDesactiveInCSSAttribute",
    value: function _isDesactiveInCSSAttribute(pCSSSelectors) {
      return false; // default
    }

    /**
     * @description Is the element bold
     * @function
     * @param {pDOMTree} pDOMTree 
     * @returns {DOM}
     */
  }, {
    key: "formatForPaste",
    value: function formatForPaste(pDOMTree) {
      var that = this;
      pDOMTree.querySelectorAll("*").forEach(function (pNode) {
        var styleAttributes = pNode.getAttribute("style");
        if (typeof styleAttributes === "string" && styleAttributes.length > 0) {
          if (that._isActiveInCSSAttribute(styleAttributes) === true) {
            if (["SPAN", "P", "DIV"].includes(pNode.tagName)) {
              var uElement = document.createElement(that.getTags()[0]);
              // Copy the children
              while (pNode.firstChild) {
                uElement.appendChild(pNode.firstChild); // *Moves* the child
              }
              // Copy the attributes
              for (var index = pNode.attributes.length - 1; index >= 0; --index) {
                uElement.attributes.setNamedItem(pNode.attributes[index].cloneNode());
              }
              // Replace it
              pNode.parentNode.replaceChild(uElement, pNode);
            } else {}
          } else if (that.getTags().includes(pNode.tagName.toLowerCase()) && that._isDesactiveInCSSAttribute(styleAttributes) === true) {
            var spanElement = document.createElement("span");
            while (pNode.firstChild) {
              spanElement.appendChild(pNode.firstChild);
            }
            for (var index = pNode.attributes.length - 1; index >= 0; --index) {
              spanElement.attributes.setNamedItem(pNode.attributes[index].cloneNode());
            }
            pNode.parentNode.replaceChild(spanElement, pNode);
          }
        }
      });
      return pDOMTree;
    }
  }]);
  return StyledPluginEC;
}(StyledPlugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = StyledPluginEC;
}

},{"./StyledPlugin.js":368}],370:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @description Plugin handling the Sub-Script style 
 * @extends StyledPluginEC
 */
var SubScriptPlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(SubScriptPlugin, _StyledPluginEC);
  var _super = _createSuper(SubScriptPlugin);
  function SubScriptPlugin() {
    var _this;
    _classCallCheck(this, SubScriptPlugin);
    _this = _super.call(this, "subscript");
    _this.tags = ["sub"];
    _this.styleName = "text-decoration-line";
    _this.styleValues = ["subscript"];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(SubScriptPlugin, [{
    key: "getID",
    value: function getID() {
      return "Sub Script";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-subscript",
        text: "Sub",
        tooltip: "nixps-tajiri.pluginsubscript_tooltip"
      };
    }

    /**------------------------------------------------------------------------------------------------
     * Function call to determine if "sub-script" is applied on a given node element
     * @param {Node} pNode the node to check.
     * @returns true if sub-script is applied, false otherwise
     */
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      return this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
    }
  }, {
    key: "_isActiveInCSSAttribute",
    value: function _isActiveInCSSAttribute(pCSSAttribute) {
      return pCSSAttribute.search(/vertical-align\s*:\s*sub/i) >= 0;
    }
  }]);
  return SubScriptPlugin;
}(StyledPluginEC);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = SubScriptPlugin;
}

},{"./Plugin.js":362,"./StyledPluginEC.js":369}],371:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @description Plugin handling the Super Script style 
 * @extends StyledPluginEC
 */
var SuperScriptPlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(SuperScriptPlugin, _StyledPluginEC);
  var _super = _createSuper(SuperScriptPlugin);
  function SuperScriptPlugin() {
    var _this;
    _classCallCheck(this, SuperScriptPlugin);
    _this = _super.call(this, "superscript");
    _this.tags = ["sup"];
    _this.styleName = "text-decoration-line";
    _this.styleValues = ["superscript"];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(SuperScriptPlugin, [{
    key: "getID",
    value: function getID() {
      return "Super Script";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-superscript",
        text: "Sup",
        tooltip: "nixps-tajiri.pluginsuperscript_tooltip"
      };
    }

    /**------------------------------------------------------------------------------------------------
     * Function call to determine if "super script" is applied on a given node element
     * @param {Node} pNode the node to check.
     * @returns true if super-script is applied, false otherwise
     */
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      return this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
    }
  }, {
    key: "_isActiveInCSSAttribute",
    value: function _isActiveInCSSAttribute(pCSSAttribute) {
      return pCSSAttribute.search(/vertical-align\s*:\s*super/i) >= 0;
    }
  }]);
  return SuperScriptPlugin;
}(StyledPluginEC);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = SuperScriptPlugin;
}

},{"./Plugin.js":362,"./StyledPluginEC.js":369}],372:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
  require("./../dialogs/nixps-cloudflow-SymbolPluginDialog.js");
}
/**
 * @extends Plugin
 */
var SymbolPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(SymbolPlugin, _Plugin);
  var _super = _createSuper(SymbolPlugin);
  function SymbolPlugin() {
    var _this;
    _classCallCheck(this, SymbolPlugin);
    _this = _super.call(this);
    _this.command = "insertText";
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(SymbolPlugin, [{
    key: "getID",
    value: function getID() {
      return "Symbol";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: null,
        symbol: "&Omega;",
        tooltip: "nixps-tajiri.pluginsymbol_tooltip"
      };
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isActive",
    value: function isActive() {
      return false;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      var range = pSelection.getRangeAt(0);
      if (pRootNode.contains(pSelection.getRangeAt(0).startContainer) === false) {
        return;
      }
      var symbolArray = [];
      var symbols = "! \x26quot; # $ % \x26amp; ' ( ) * + - . / 0 1 2 3 4 5 6 7 8 9 : ; \x26lt; \x3d \x26gt; ? @ A B C D E F G H I J K L M N O P Q R S T U V W X Y Z [ ] ^ _ ` a b c d e f g h i j k l m n o p q r s t u v w x y z { | } ~ \x26euro; \x26lsquo; \x26rsquo; \x26ldquo; \x26rdquo; \x26ndash; \x26mdash; \x26iexcl; \x26cent; \x26pound; \x26curren; \x26yen; \x26brvbar; \x26sect; \x26uml; \x26copy; \x26ordf; \x26laquo; \x26not; \x26reg; \x26macr; \x26deg; \x26sup2; \x26sup3; \x26acute; \x26micro; \x26para; \x26middot; \x26cedil; \x26sup1; \x26ordm; \x26raquo; \x26frac14; \x26frac12; \x26frac34; \x26iquest; \x26Agrave; \x26Aacute; \x26Acirc; \x26Atilde; \x26Auml; \x26Aring; \x26AElig; \x26Ccedil; \x26Egrave; \x26Eacute; \x26Ecirc; \x26Euml; \x26Igrave; \x26Iacute; \x26Icirc; \x26Iuml; \x26ETH; \x26Ntilde; \x26Ograve; \x26Oacute; \x26Ocirc; \x26Otilde; \x26Ouml; \x26times; \x26Oslash; \x26Ugrave; \x26Uacute; \x26Ucirc; \x26Uuml; \x26Yacute; \x26THORN; \x26szlig; \x26agrave; \x26aacute; \x26acirc; \x26atilde; \x26auml; \x26aring; \x26aelig; \x26ccedil; \x26egrave; \x26eacute; \x26ecirc; \x26euml; \x26igrave; \x26iacute; \x26icirc; \x26iuml; \x26eth; \x26ntilde; \x26ograve; \x26oacute; \x26ocirc; \x26otilde; \x26ouml; \x26divide; \x26oslash; \x26ugrave; \x26uacute; \x26ucirc; \x26uuml; \x26yacute; \x26thorn; \x26yuml; \x26OElig; \x26oelig; \x26#372; \x26#374 \x26#373 \x26#375; \x26sbquo; \x26#8219; \x26bdquo; \x26hellip; \x26trade; \x26#9658; \x26bull; \x26rarr; \x26rArr; \x26hArr; \x26diams; \x26asymp;".split(" ");
      symbols.forEach(function (pSymbol, pIndex) {
        var symbolObject = {
          symbol: pSymbol
        };
        if (pSymbol.startsWith("&") && pSymbol.length !== 1) {
          //this is an escape character, we give translationkey for tooltip
          symbolObject["transKey"] = pSymbol.substring(1, pSymbol.length - 1);
        }
        symbolArray.push(symbolObject);
      });
      var symbolPluginDialog = $("<div>");
      $("body").append(symbolPluginDialog);
      pRootNode.addEventListener("keyup", function (pEvent) {
        pEvent.preventDefault();
      });
      return $.Deferred(function (pDefer) {
        symbolPluginDialog.SymbolPluginDialog({
          symbols: symbolArray,
          submit: function submit(pEvent, pSymbol) {
            pSelection.removeAllRanges();
            pSelection.addRange(range);
            document.execCommand(that.command, false, pSymbol);
            if (pSelection.type !== "Caret") {
              range.collapse(true);
            }
            return pDefer.resolve({});
          },
          close: function close() {
            symbolPluginDialog.remove();
          }
        });
      });
    }
  }]);
  return SymbolPlugin;
}(Plugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = SymbolPlugin;
}

},{"./../dialogs/nixps-cloudflow-SymbolPluginDialog.js":331,"./Plugin.js":362}],373:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
  require("../dialogs/nixps-cloudflow-TablePluginDialog.js");
  require("../dialogs/nixps-cloudflow-CellPropertiesDialog.js");
}

/**
 * @extends Plugin
 */
var TablePlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(TablePlugin, _Plugin);
  var _super = _createSuper(TablePlugin);
  function TablePlugin() {
    var _this;
    _classCallCheck(this, TablePlugin);
    _this = _super.call(this);
    _this.command = "insertHTML";
    _this.tags = ["table", "th", "td", "tr", "tbody", "thead", "caption"];
    // this._createDebugButtons();
    return _this;
  }
  _createClass(TablePlugin, [{
    key: "_allValuesEqual",
    value: function _allValuesEqual(pArr) {
      return pArr.every(function (v) {
        return v === pArr[0];
      });
    }
  }, {
    key: "_createDebugButtons",
    value: function _createDebugButtons() {
      var that = this;
      var button = $("<div>").text("insert row before").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.insertRow($(window.getSelection().anchorNode).closest("td, th"), "before");
      });
      var button = $("<div>").text("insert row after").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.insertRow($(window.getSelection().anchorNode).closest("td, th"), "after");
      });
      var button = $("<div>").text("insert column before").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.insertColumn($(window.getSelection().anchorNode).closest("td, th"), "before");
      });
      var button = $("<div>").text("insert column after").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.insertColumn($(window.getSelection().anchorNode).closest("td, th"), "after");
      });
      var button = $("<div>").text("merge cell down").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.mergeCell($(window.getSelection().anchorNode).closest("td, th"), "down");
      });
      var button = $("<div>").text("merge cell right").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.mergeCell($(window.getSelection().anchorNode).closest("td, th"), "right");
      });
      var button = $("<div>").text("delete column").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.deleteColumn($(window.getSelection().anchorNode).closest("td, th"));
      });
      var button = $("<div>").text("delete row").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.deleteRow($(window.getSelection().anchorNode).closest("td, th"));
      });
      var button = $("<div>").text("delete table").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.deleteTable($(window.getSelection().anchorNode).closest("td, th"));
      });
      var button = $("<div>").text("cell properties").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that._openCellProperties($(window.getSelection().anchorNode).closest("td, th"));
      });
      var button = $("<div>").text("remove cell").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.deleteCell($(window.getSelection().anchorNode).closest("td, th"));
      });
      var button = $("<div>").text("insert cell after").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.insertCell($(window.getSelection().anchorNode).closest("td, th"), "after");
      });
      var button = $("<div>").text("insert cell before").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.insertCell($(window.getSelection().anchorNode).closest("td, th"), "before");
      });
      var button = $("<div>").text("split cell vertically").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.splitCell($(window.getSelection().anchorNode).closest("td, th"), "vertical");
      });
      var button = $("<div>").text("split cell horizontally").css("user-select", "none").prependTo(".nixps-RichEditor");
      button.on("click", function () {
        that.splitCell($(window.getSelection().anchorNode).closest("td, th"), "horizontal");
      });
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getID",
    value: function getID() {
      return "Table";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-table",
        text: "Table",
        tooltip: "nixps-tajiri.plugintable_tooltip"
      };
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isActive",
    value: function isActive(pSelection, pRootNode) {
      if (pSelection.anchorNode.parentElement.closest("table") !== null && pRootNode.contains(pSelection.anchorNode.parentElement.closest("table"))) {
        return true;
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      var selection = pSelection;
      var range = selection.getRangeAt(0);
      var tableplugindialog = $("<div>");
      $("body").append(tableplugindialog);
      return $.Deferred(function (pDefer) {
        tableplugindialog.TablePluginDialog({
          submit: function submit(pEvent, pValues) {
            var table = $("<table>");
            if (pValues.caption.length > 0) {
              $("<caption>").appendTo(table).text(pValues.caption);
            }
            if (pValues.summary.length > 0) {
              table[0].setAttribute("summary", pValues.summary);
            }
            table[0].style.borderCollapse = "separate";
            table[0].setAttribute("cellspacing", pValues.cellspacing);
            table[0].style.borderSpacing = table[0].cellSpacing + "px";
            table[0].setAttribute("border", pValues.border);
            table[0].setAttribute("align", pValues.alignment);
            if (pValues.alignment !== "none") {
              table[0].setAttribute("align", pValues.alignment);
              if (pValues.alignment === "center") {
                table[0].style.marginLeft = "auto";
                table[0].style.marginRight = "auto";
              } else if (pValues.alignment === "right") {
                table[0].style.marginLeft = "auto";
                table[0].style.marginRight = "0px";
              } else if (pValues.alignment === "left") {
                table[0].style.marginLeft = "0px";
                table[0].style.marginRight = "auto";
              }
            }
            var pattern = new RegExp("\\d+$");
            var width = pattern.test(pValues.width) ? pValues.width + "px" : pValues.width;
            var height = pattern.test(pValues.height) ? pValues.height + "px" : pValues.height;
            table[0].style.width = width;
            table[0].style.height = height;
            //THEAD
            if (pValues.headers.row === true) {
              var thead = $("<thead>").appendTo(table);
              var row = $("<tr>").appendTo(thead);
              for (var j = 0; j < pValues.cols; j++) {
                var th = $("<th>").appendTo(row);
                th[0].setAttribute("scope", "col");
              }
              //we already got one row with th's, subtract it from total rows
              pValues.rows -= 1;
            }
            //BODY
            table.append($("<tbody>"));
            for (var i = 0; i < pValues.rows; i++) {
              var colsToDraw = pValues.cols;
              var row = $("<tr>").appendTo(table);
              if (pValues.headers.col === true) {
                var th = $("<th>").appendTo(row);
                th[0].setAttribute("scope", "row");
                //added one col already, subtract it from total cols
                colsToDraw -= 1;
              }
              for (var j = 0; j < colsToDraw; j++) {
                row.append($("<td>"));
              }
            }
            if (pValues.cellpadding > 1) {
              table[0].setAttribute("cellpadding", pValues.cellpadding);
              table[0].querySelectorAll("td, th").forEach(function (pCell) {
                pCell.style.padding = table[0].cellPadding + "px";
              });
            }
            selection.removeAllRanges();
            //remove all the content of the selection, we'll replace with image (insertHTML does not do this for us)
            range.deleteContents();
            range.insertNode(table[0]);

            //we need the computed style in order to retain our default border css
            var borderStyle = window.getComputedStyle(table[0]).getPropertyValue("border").split(" ");
            borderStyle[0] = table[0].border + "px";
            table[0].style.border = borderStyle.join(" ");
            selection.addRange(range);
            tableplugindialog.remove();
            return pDefer.resolve({
              newNode: table[0],
              range: range,
              plugin: that
            });
          },
          close: function close() {
            tableplugindialog.remove();
            return pDefer.reject({
              range: range
            });
          },
          editing: false
        });
      });
    }
  }, {
    key: "getContextualItems",
    value: function getContextualItems(pEvent, pSelection, pDOM) {
      var cellNode = pEvent.target.closest("td, th");
      var rowIndex = $(cellNode).closest("tr").index();
      var rowSpan = parseInt(cellNode.rowSpan);
      var colSpan = parseInt(cellNode.colSpan);
      var colIndex = $(cellNode).index();
      var table = cellNode.closest("table");
      var tableArr = this._get2D(table);
      var selectedCells = table.querySelectorAll("[data-tajiri-cellselection]");
      if (cellNode.nextSibling === null || cellNode.nextSibling.rowSpan !== cellNode.rowSpan || tableArr[rowIndex][$(cellNode.nextSibling).index()].row !== rowIndex || selectedCells.length > 1) {
        //cell is in the last col
        //next cell doesn't have equal rowspan
        //next cell isn't in the next column
        //multiple cells are selected
        var mergeRightActive = false;
      }
      if (cellNode.closest("tr") === table.rows[table.rows.length - 1] || Array.from(cellNode.closest("tr").parentNode.children).indexOf(cellNode.closest("tr")) !== table.rows.length - 1 || this._isColspanBelowDifferent(tableArr, rowIndex, colIndex, rowSpan, colSpan) || selectedCells.length > 1) {
        //cell is in the last row
        //cell below has different colspans
        //cell below isn't in the next row
        //multiple cells are selected
        var mergeDownActive = false;
      }
      var splitCellsActive = true;
      if (selectedCells.length > 1) {
        splitCellsActive = false;
      }
      var mergeMultipleActive = true;
      if (selectedCells.length < 2) {
        mergeMultipleActive = false;
      } else {
        var rowSpans = [];
        var colSpans = [];
        selectedCells.forEach(function (pSelectedCell) {
          rowSpans.push(pSelectedCell.getAttribute("rowSpan") ? pSelectedCell.getAttribute("rowSpan") : "1");
          colSpans.push(pSelectedCell.getAttribute("colSpan") ? pSelectedCell.getAttribute("colSpan") : "1");
        });
        if (this._allValuesEqual(rowSpans) === false || this._allValuesEqual(colSpans) === false) {
          mergeMultipleActive = false;
        }
      }
      return [{
        id: "cell_methods",
        label: $.i18n._("nixps-cloudflow-tableplugin.context_cellmethods"),
        type: "subgroup",
        buttons: [{
          id: "cell_insert_before",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_cell_insert_before"),
          action: this.insertCell.bind(this),
          data: [$(pEvent.target.closest("td, th")), "before"]
        }, {
          id: "cell_insert_after",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_cell_insert_after"),
          action: this.insertCell.bind(this),
          data: [$(pEvent.target.closest("td, th")), "after"]
        }, {
          id: "cell_delete",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_cell_delete"),
          action: this.deleteCell.bind(this),
          data: [$(pEvent.target.closest("td, th"))]
        }, {
          id: "cell_merge",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_cell_merge"),
          action: this.mergeCells.bind(this),
          data: [$(pEvent.target.closest("table")), pDOM],
          active: mergeMultipleActive
        }, {
          id: "cell_merge_right",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_cell_merge_right"),
          action: this.mergeCell.bind(this),
          data: [$(pEvent.target.closest("td, th")), "right"],
          active: mergeRightActive
        }, {
          id: "cell_merge_down",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_cell_merge_down"),
          action: this.mergeCell.bind(this),
          data: [$(pEvent.target.closest("td, th")), "down"],
          active: mergeDownActive
        }, {
          id: "cell_split_h",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_cell_split_horizontal"),
          action: this.splitCell.bind(this),
          data: [$(pEvent.target.closest("td, th")), "horizontal"],
          active: splitCellsActive
        }, {
          id: "cell_split_v",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_cell_split_vertical"),
          action: this.splitCell.bind(this),
          data: [$(pEvent.target.closest("td, th")), "vertical"],
          active: splitCellsActive
        }, {
          id: "cell_properties",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_cell_properties"),
          icon: this.getButtonDescription().icon,
          action: this._openCellProperties.bind(this),
          data: [$(pEvent.target.closest("td, th"))]
        }]
      }, {
        id: "row_methods",
        label: $.i18n._("nixps-cloudflow-tableplugin.context_rowmethods"),
        type: "subgroup",
        buttons: [{
          id: "row_insert_before",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_row_insert_before"),
          action: this.insertRow.bind(this),
          data: [$(pEvent.target.closest("td, th")), "before"]
        }, {
          id: "row_insert_after",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_row_insert_after"),
          action: this.insertRow.bind(this),
          data: [$(pEvent.target.closest("td, th")), "after"]
        }, {
          id: "row_delete",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_row_delete"),
          action: this.deleteRow.bind(this),
          data: [$(pEvent.target.closest("td, th"))]
        }]
      }, {
        id: "col_methods",
        label: $.i18n._("nixps-cloudflow-tableplugin.context_colmethods"),
        type: "subgroup",
        buttons: [{
          id: "col_insert_before",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_col_insert_before"),
          action: this.insertColumn.bind(this),
          data: [$(pEvent.target.closest("td, th")), "before"]
        }, {
          id: "col_insert_after",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_col_insert_after"),
          action: this.insertColumn.bind(this),
          data: [$(pEvent.target.closest("td, th")), "after"]
        }, {
          id: "col_delete",
          text: $.i18n._("nixps-cloudflow-tableplugin.context_col_delete"),
          action: this.deleteColumn.bind(this),
          data: [$(pEvent.target.closest("td, th"))]
        }]
      }, {
        id: "table_delete",
        text: $.i18n._("nixps-cloudflow-tableplugin.context_table_delete"),
        action: this.deleteTable.bind(this),
        data: [$(pEvent.target.closest("td, th"))]
      }, {
        id: "table_edit",
        text: $.i18n._("nixps-cloudflow-tableplugin.context_table_edit"),
        icon: this.getButtonDescription().icon,
        action: this._doubleClickHandler.bind(this),
        data: [{
          selection: pSelection,
          target: pEvent.target.closest("table")
        }]
      }];
    }
  }, {
    key: "getDoubleClickSelector",
    value: function getDoubleClickSelector() {
      return "table";
    }
  }, {
    key: "doubleClickHandler",
    value: function doubleClickHandler(pEvent, pData) {
      this._doubleClickHandler(pData);
    }
  }, {
    key: "formatForPaste",
    value: function formatForPaste(pDOMTree) {
      return pDOMTree;
    }
  }, {
    key: "_doubleClickHandler",
    value: function _doubleClickHandler(pData) {
      var that = this;
      var table = pData.target;
      var selection = pData.selection;
      var range = selection.getRangeAt(0);
      var cols = 0;
      var rows = 0;
      table.querySelectorAll("tr").forEach(function (pRow) {
        if ($(pRow).children("td, th").length > cols) {
          cols = $(pRow).children("td, th").length;
        }
      });
      if (table.querySelectorAll("tr").length > rows) {
        rows = table.querySelectorAll("tr").length;
      }
      var width = table.style.width;
      var height = table.style.height;
      var tableRowHeader = $(table).find("thead").length > 0;
      var tableColHeader = $(table).find("tbody th").length > 0;
      var headers = "none";
      if (tableColHeader === true && tableRowHeader === true) {
        headers = "rowcol";
      } else if (tableColHeader === true) {
        headers = "col";
      } else if (tableRowHeader === true) {
        headers = "row";
      }
      var cellspacing = table.cellSpacing;
      var cellpadding = table.cellPadding || 1;
      var border = parseInt(table.style.borderWidth);
      var alignment = table.align.length > 0 ? table.align : "none";
      var caption = "";
      if ($(table).find("caption").length > 0) {
        caption = $(table).find("caption")[0].textContent;
      }
      var summary = "";
      if (table.summary.length > 0) {
        summary = table.summary;
      }
      var tableplugindialog = $("<div>");
      $("body").append(tableplugindialog);
      return $.Deferred(function (pDefer) {
        tableplugindialog.TablePluginDialog({
          editing: true,
          cols: cols,
          rows: rows,
          width: width,
          height: height,
          headers: headers,
          cellspacing: parseFloat(cellspacing),
          cellpadding: parseFloat(cellpadding),
          border: parseFloat(border),
          alignment: alignment,
          caption: caption,
          summary: summary,
          submit: function submit(pEvent, pValues) {
            var pattern = new RegExp("\\d+$");
            var width = pattern.test(pValues.width) ? pValues.width + "px" : pValues.width;
            var height = pattern.test(pValues.height) ? pValues.height + "px" : pValues.height;
            table.style.width = width;
            table.style.height = height;
            if (pValues.headers.row === true && $(table).find("thead").length === 0) {
              var thead = $("<thead>").prependTo(table);
              var firstRow = $(table).find("tbody tr:first-child");
              thead.append(firstRow);
              thead.find("td").each(function (pIndex, pTdTag) {
                var thTag = that._tdTagToThTag(pTdTag);
                $(pTdTag).replaceWith(thTag);
              });
            } else if (pValues.headers.row === false && $(table).find("thead").length === 1) {
              var thead = $(table).find("thead");
              var theadRow = thead.find("tr");
              $(table).find("tbody").prepend(theadRow);
              theadRow.find("th").each(function (pIndex, pThTag) {
                var tdTag = that._thTagToTdTag(pThTag);
                $(pThTag).replaceWith(tdTag);
              });
              thead.remove();
            }
            if (pValues.headers.col === true) {
              var rows = $(table).find("tbody tr");
              rows.each(function (pIndex, pRowTag) {
                var pFirstTdTag = $(pRowTag).children()[0];
                var thTag = that._tdTagToThTag(pFirstTdTag);
                $(pFirstTdTag).replaceWith(thTag);
              });
            } else if ($(table).find("tbody th").length > 0) {
              var rows = $(table).find("tbody tr");
              rows.each(function (pIndex, pThTag) {
                var tdTag = that._thTagToTdTag(pThTag);
                $(pThTag).replaceWith(tdTag);
              });
            }

            //apply cellpadding & spacing again, after moving around cells
            table.setAttribute("cellspacing", pValues.cellspacing);
            table.style.borderSpacing = table.cellSpacing + "px";
            table.setAttribute("cellpadding", pValues.cellpadding);
            if (pValues.cellpadding > 1) {
              table.querySelectorAll("td, th").forEach(function (pCell) {
                pCell.style.padding = table.cellPadding + "px";
              });
            }
            var borderStyle = window.getComputedStyle(table).getPropertyValue("border").split(" ");
            borderStyle[0] = pValues.border + "px";
            table.style.border = borderStyle.join(" ");
            table.setAttribute("align", pValues.alignment);
            if (pValues.alignment === "center") {
              table.style.marginLeft = "auto";
              table.style.marginRight = "auto";
            } else if (pValues.alignment === "right") {
              table.style.marginLeft = "auto";
              table.style.marginRight = "0px";
            } else if (pValues.alignment === "left") {
              table.style.marginLeft = "0px";
              table.style.marginRight = "auto";
            } else if (pValues.alignment === "none") {
              table.style.marginLeft = "";
              table.style.marginRight = "";
            }

            //also prepend the caption again if one exists
            var captionEl = $(table).find("caption").length > 0 ? $(table).find("caption") : $("<caption>");
            if (pValues.caption.length > 0) {
              captionEl[0].textContent = pValues.caption;
              $(table).prepend(captionEl);
            } else if (captionEl.length > 0) {
              captionEl.remove();
            }
            table.summary = pValues.summary;
            tableplugindialog.remove();
            return pDefer.resolve({
              newNode: table,
              range: range,
              plugin: that
            });
          },
          close: function close() {
            tableplugindialog.remove();
            return pDefer.resolve({
              range: range
            });
          }
        });
      });
    }
  }, {
    key: "_isColspanBelowDifferent",
    value: function _isColspanBelowDifferent(tableArr, rowIndex, colIndex, rowSpan, colSpan) {
      var lastCellData = tableArr[rowIndex + 1 + (rowSpan - 1)][colIndex + colSpan - 1];
      var afterLastCellData = tableArr[rowIndex + 1 + (rowSpan - 1)][colIndex + colSpan - 1 + 1];
      var firstCellData = tableArr[rowIndex + 1 + (rowSpan - 1)][colIndex];
      var beforeFirstCellData = tableArr[rowIndex + 1 + (rowSpan - 1)][colIndex - 1];
      var isMergedAfterEnd = false;
      var isMergedBeforeStart = false;
      if (lastCellData !== undefined && afterLastCellData !== undefined) {
        isMergedAfterEnd = lastCellData.col === afterLastCellData.col;
      }
      if (firstCellData !== undefined && beforeFirstCellData !== undefined) {
        isMergedBeforeStart = firstCellData.col === beforeFirstCellData.col;
      }
      return isMergedAfterEnd || isMergedBeforeStart;
    }
  }, {
    key: "_tdTagToThTag",
    value: function _tdTagToThTag(pTdTag) {
      var outer = pTdTag.outerHTML;
      var regex = new RegExp("<td", "i");
      var thTag = outer.replace(regex, "<th");
      regex = new RegExp("</td", "i");
      thTag = thTag.replace(regex, "</th");
      return thTag;
    }
  }, {
    key: "_thTagToTdTag",
    value: function _thTagToTdTag(pThTag) {
      var outer = pThTag.outerHTML;
      var regex = new RegExp("<th", "i");
      var tdTag = outer.replace(regex, "<td");
      regex = new RegExp("</th", "i");
      tdTag = tdTag.replace(regex, "</td");
      return tdTag;
    }
  }, {
    key: "insertRow",
    value: function insertRow(pCellNode, pLocation) {
      var locations = ["before", "after"];
      if (locations.includes(pLocation) === false) {
        throw new Error("TablePlugin: location parameter has to be one of the following: " + locations);
      }
      var table = pCellNode.closest("table");
      var tableData = this._get2D(table[0]);
      var row = pCellNode.closest("tr");
      var rowIndex = this._getRowIndex(pCellNode);
      var newRow = row.clone();
      newRow.children().each(function (pIndex, pTdTag) {
        pTdTag.textContent = "";
        pTdTag.removeAttribute("rowSpan");
      });
      if (pLocation === "before") {
        newRow.insertBefore(row);
      } else if (pLocation === "after") {
        if (pCellNode[0].rowSpan > 1) {
          row = $(row[0].parentNode).children().eq(this._getRowIndex(pCellNode) + (pCellNode[0].rowSpan - 1));
          newRow.insertAfter(row);
        } else {
          var cellIndexToRemove = [];
          for (var cell = 0; cell < tableData[rowIndex].length; cell++) {
            var mergedCellCoords = this._findFirstIndex(tableData, tableData[rowIndex][cell]);
            var mergedCell = this._getCellByCoords(table, mergedCellCoords.row, mergedCellCoords.col);
            if (tableData[rowIndex + 1] !== undefined && _.isEqual(tableData[rowIndex][cell], tableData[rowIndex + 1][cell])) {
              var mergedCellCoords = this._findFirstIndex(tableData, tableData[rowIndex][cell]);
              var mergedCell = this._getCellByCoords(table, mergedCellCoords.row, mergedCellCoords.col);
              //vertically merged cell
              mergedCell.rowSpan += 1;
              var mergedCellIndex = this._getCellIndex($(mergedCell), tableData);
              //if we're at the top of the vertically merged cell
              if (tableData[rowIndex - 1] !== undefined && _.isEqual(tableData[rowIndex][cell], tableData[rowIndex - 1][cell]) === false || tableData[rowIndex - 1] === undefined) {
                if (mergedCellIndex <= 0) {
                  mergedCellIndex = 0;
                } else if (mergedCellIndex > $(table[0].rows[rowIndex]).children().length - 1) {
                  mergedCellIndex = $(table[0].rows[rowIndex]).children().length - 1;
                } else {
                  mergedCellIndex--;
                }
                cellIndexToRemove.push(mergedCellIndex);
              }
              //don't check the same merged cell more than once
              if (mergedCell.colSpan > 1) {
                cell += mergedCell.colSpan - 1;
              }
            }
            //we'll have to insert a cell for this merged cell if we're at the bottom of it
            if (tableData[rowIndex + 1] !== undefined && tableData[rowIndex - 1] !== undefined && _.isEqual(tableData[rowIndex][cell], tableData[rowIndex + 1][cell]) === false && _.isEqual(tableData[rowIndex][cell], tableData[rowIndex - 1][cell])) {
              var extraCell = $(mergedCell).clone();
              extraCell[0].textContent = "";
              extraCell[0].removeAttribute("rowSpan");
              if (extraCell[0].colSpan > 1) {
                for (var colSpan = extraCell[0].colSpan; colSpan > 0; colSpan--) {
                  newRow.children().eq(cell).remove();
                }
              }
              newRow[0].insertBefore(extraCell[0], newRow[0].childNodes[cell]);
            }
          }
          for (var i = cellIndexToRemove.length - 1; i > -1; i--) {
            newRow.children().eq(cellIndexToRemove[i]).remove();
          }
          newRow.insertAfter(row);
        }
      }
    }
  }, {
    key: "insertColumn",
    value: function insertColumn(pCellNode, pLocation) {
      var that = this;
      var locations = ["before", "after"];
      if (locations.includes(pLocation) === false) {
        throw new Error("TablePlugin: location parameter has to be one of the following: " + locations);
      }
      var table = pCellNode.closest("table");
      var tableData = this._get2D(table[0]);
      var cellNodeColIndex = this._getCellIndex(pCellNode);
      var cellNodeRowIndex = this._getRowIndex(pCellNode);
      var cellNodeColSpan = pCellNode[0].colSpan || 1;
      var checkIndexForMerge = this._getLastIndexIn2D(tableData[cellNodeRowIndex], {
        row: cellNodeRowIndex,
        col: cellNodeColIndex
      });
      if (pLocation === "before") {
        checkIndexForMerge = this._getIndexIn2D(tableData[cellNodeRowIndex], {
          row: cellNodeRowIndex,
          col: cellNodeColIndex
        });
      }
      table.find("tr").each(function (pRowIndex, pRow) {
        var offset = 0;
        if (cellNodeColSpan > 1 && pLocation === "after") {
          offset = cellNodeColSpan - 1;
        }
        //get the cell which we want to add a cell before or after
        var refCellCoords = tableData[pRowIndex][cellNodeColIndex];
        if (refCellCoords.row !== pRowIndex) {
          return true;
        }
        var refCell = that._getCellByCoords(table, refCellCoords.row, refCellCoords.col + offset);
        if (pCellNode[0].isEqualNode(that._getCellByCoords(table, refCellCoords.row, refCellCoords.col))) {
          refCell = that._getCellByCoords(table, refCellCoords.row, refCellCoords.col);
        }
        var cellToInsert = $(refCell).clone();
        cellToInsert[0].textContent = "";
        cellToInsert[0].removeAttribute("colSpan");
        if (pLocation === "before") {
          if (_.isEqual(tableData[pRowIndex][checkIndexForMerge], tableData[pRowIndex][checkIndexForMerge - 1])) {
            refCell.colSpan += 1;
          } else {
            cellToInsert.insertBefore(refCell);
          }
        } else if (pLocation === "after") {
          if (_.isEqual(tableData[pRowIndex][checkIndexForMerge], tableData[pRowIndex][checkIndexForMerge + 1])) {
            refCell.colSpan += 1;
          } else {
            cellToInsert.insertAfter(refCell);
          }
        }
      });
    }
  }, {
    key: "deleteRow",
    value: function deleteRow(pCellNode) {
      //TODO: cell selection
      if (pCellNode.closest("table").find("tr").length === 1) {
        this.deleteTable(pCellNode);
      } else {
        pCellNode.closest("tr").remove();
      }
    }
  }, {
    key: "deleteColumn",
    value: function deleteColumn(pCellNode) {
      //TODO: cell selection
      var that = this;
      var cols = 0;
      pCellNode.closest("table")[0].querySelectorAll("tr").forEach(function (pRow) {
        if ($(pRow).children("td, th").length > cols) {
          cols = $(pRow).children("td, th").length;
        }
      });
      if (cols === 1) {
        this.deleteTable(pCellNode);
      } else {
        var cellNodeIndex = this._getCellIndex(pCellNode);
        var rows = pCellNode.closest("table").find("tr");
        rows.each(function (pIndex, pRow) {
          that._getCellByColIndex($(pRow), cellNodeIndex).remove();
        });
      }
    }
  }, {
    key: "mergeCell",
    value: function mergeCell(pCellNode, pDirection) {
      var directions = ["down", "right"];
      if (directions.includes(pDirection) === false) {
        throw new Error("TablePlugin: location parameter has to be one of the following: " + directions);
      }

      //TODO: make sure the row-/colspan doesn't go over the current # of rows/cols
      //TODO: take into account we might be merging a cell that has a row- or colspan

      if (pDirection === "down") {
        var currentrowSpan = parseInt(pCellNode[0].rowSpan);
        var cellToRemove = this._getCellBelow(pCellNode);
        var cellToRemoveRowSpan = cellToRemove[0].rowSpan ? parseInt(cellToRemove[0].rowSpan) : 1;
        pCellNode[0].setAttribute("rowspan", currentrowSpan + cellToRemoveRowSpan);
        pCellNode[0].innerHTML += "</br>" + cellToRemove[0].innerHTML;
        cellToRemove.remove();
      } else if (pDirection === "right") {
        if (pCellNode.next().length === 0) {
          return;
        }
        var currentColSpan = pCellNode[0].colSpan;
        if (currentColSpan === undefined) {
          currentColSpan = "1";
        }
        var newColSpan = parseInt(currentColSpan) + pCellNode.next()[0].colSpan;
        pCellNode[0].setAttribute("colspan", newColSpan);
        pCellNode[0].innerHTML += pCellNode.next()[0].innerHTML;
        pCellNode.next().remove();
      }
    }
  }, {
    key: "_getCellBelow",
    value: function _getCellBelow(pCellNode) {
      var tableArr = this._get2D(pCellNode.closest("table")[0]);
      var rowIndex = pCellNode.closest("tr").index();
      var cellRowSpan = parseInt(pCellNode[0].rowSpan ? pCellNode[0].rowSpan : 1);
      var correctedRowIndex = rowIndex + cellRowSpan;
      var correctedCellIndex;
      tableArr.forEach(function (pRow, pRowIndex) {
        pRow.forEach(function (pCell, pCellIndex) {
          if (pCellNode[0] === pCellNode.closest("table")[0].rows[pCell.row].cells[pCell.col]) {
            correctedCellIndex = pCellIndex;
          }
        });
      });
      var cellBelowData = tableArr[correctedRowIndex][correctedCellIndex];
      return $(pCellNode.closest("table")[0].rows[cellBelowData.row].cells[cellBelowData.col]);
    }
  }, {
    key: "_get2D",
    value: function _get2D(pTable) {
      var tableData = [];
      var rowCount = pTable.rows.length;
      var rowIndex = 0;
      for (var i = rowCount; rowIndex < i; rowIndex++) {
        tableData.push([]);
      }
      for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        var tr = pTable.rows[rowIndex];
        var colCount = tr.cells.length;
        var offset = 0;
        for (var colIndex = 0; colIndex < colCount; colIndex++) {
          var td = tr.cells[colIndex];
          while (tableData[rowIndex].hasOwnProperty(colIndex + offset)) {
            offset++;
          }
          var colSpan = parseInt(td.colSpan, 10) || 1;
          var rowSpan = parseInt(td.rowSpan, 10) || 1;
          for (var i = 0; i < colSpan; i++) {
            for (var j = 0; j < rowSpan; j++) {
              tableData[rowIndex + j][colIndex + offset + i] = {
                row: rowIndex,
                col: colIndex
              };
            }
          }
        }
      }
      return tableData;
    }
  }, {
    key: "_getLastIndexIn2D",
    value: function _getLastIndexIn2D(pRow, pCheck) {
      for (var i = pRow.length - 1; i > -1; i--) {
        if (_.isEqual(pRow[i], pCheck)) {
          return i;
        }
      }
    }
  }, {
    key: "_getIndexIn2D",
    value: function _getIndexIn2D(pRow, pCheck) {
      for (var i = 0; i < pRow.length; i++) {
        if (_.isEqual(pRow[i], pCheck)) {
          return i;
        }
      }
    }
  }, {
    key: "deleteTable",
    value: function deleteTable(pCellNode) {
      pCellNode[0].closest("table").remove();
    }
  }, {
    key: "deleteCell",
    value: function deleteCell(pCellNode) {
      //TODO: handle situations where there's one cell left in the row - figure out an order of checks with existing ones
      if ($(pCellNode.closest("table")).find("td, th").length === 1) {
        //one cell remaining - delete the table instead
        this.deleteTable(pCellNode);
      } else if (pCellNode.closest("table").find("[data-tajiri-cellselection]").length > 0) {
        pCellNode.closest("table").find("[data-tajiri-cellselection]").remove();
      } else {
        pCellNode.remove();
      }
    }
  }, {
    key: "insertCell",
    value: function insertCell(pCellNode, pDirection) {
      if (["after", "before"].includes(pDirection) === false) {
        throw new Error("TablePlugin: insertCell direction parameter should be either 'after' or 'before'");
      }
      if (pDirection === "after") {
        pCellNode.after($("<" + pCellNode[0].nodeName.toLowerCase() + ">"));
      } else if (pDirection === "before") {
        pCellNode.before($("<" + pCellNode[0].nodeName.toLowerCase() + ">"));
      } else {
        throw new Error("TablePlugin: insertCell unsupported strange situation");
      }
    }
  }, {
    key: "splitCell",
    value: function splitCell(pCellNode, pDirection) {
      var that = this;
      if (["horizontal", "vertical"].includes(pDirection) === false) {
        throw new Error("TablePlugin: splitCell direction param should be either 'horizontal' or 'vertical'");
      }
      var table = pCellNode.closest("table");
      var tableData = this._get2D(table[0]);
      var rowIndex = this._getRowIndex(pCellNode);
      var colIndex = this._getCellIndex(pCellNode, tableData);
      if (pDirection === "horizontal") {
        if (pCellNode[0].rowSpan === undefined || pCellNode[0].rowSpan === 1) {
          tableData[rowIndex].forEach(function (pCellData) {
            if (pCellData.row === rowIndex) {
              //not in a vertical merge situation
              var cell = that._getCellByCoords(table, pCellData.row, pCellData.col);
              if (cell === pCellNode[0]) {
                return;
              } else {
                cell.rowSpan++;
              }
            }
          });
          table.find("tr").eq(rowIndex).after($("<tr>").append($("<td>")));
        } else {
          //targetCell has rowspan > 1
          var originalRowSpan = parseInt(pCellNode[0].rowSpan);
          var rowOffset = Math.ceil(originalRowSpan / 2);
          pCellNode[0].rowSpan = Math.ceil(originalRowSpan / 2);
          var newCell = $("<td>");
          newCell[0].colSpan = pCellNode[0].colSpan;
          newCell[0].rowSpan = originalRowSpan - Math.ceil(originalRowSpan / 2);
          var correctedColIndex = colIndex - 1;
          var correctedRowIndex = rowIndex + rowOffset;
          for (var i = colIndex - 1; i > -1; i--) {
            if (tableData[correctedRowIndex][i - 1] !== undefined && tableData[correctedRowIndex][i].col === tableData[correctedRowIndex][i - 1].col || tableData[correctedRowIndex - 1][i] !== undefined && tableData[correctedRowIndex][i].row === tableData[correctedRowIndex - 1][i].row) {
              correctedColIndex--;
            }
          }
          table.find("tr").eq(correctedRowIndex).find("td, th").eq(correctedColIndex).after(newCell);
        }
      } else if (pDirection === "vertical") {
        if (pCellNode[0].colSpan === undefined || pCellNode[0].colSpan === 1) {
          tableData.forEach(function (pRowData) {
            var cellData = pRowData[colIndex];
            var cell = that._getCellByCoords(table, cellData.row, cellData.col);
            if (cell === pCellNode[0]) {
              return;
            } else {
              cell.colSpan++;
            }
          });
          pCellNode.after(pCellNode.clone());
        } else {
          //target has colspan > 1
          var originalColSpan = parseInt(pCellNode[0].colSpan);
          pCellNode[0].colSpan = Math.ceil(originalColSpan / 2);
          var newCell = $("<td>");
          newCell[0].rowSpan = pCellNode[0].rowSpan;
          newCell[0].colSpan = originalColSpan - Math.ceil(originalColSpan / 2);
          pCellNode.after(newCell);
        }
      }
    }
  }, {
    key: "mergeCells",
    value: function mergeCells(pTable, pRootNode) {
      var selectedCells = pTable[0].querySelectorAll("[data-tajiri-cellselection]");
      var currentCell = selectedCells[0];
      this.mergeCellsColCount = 1;
      this.mergeSelectedCellsRight(currentCell);
      var newSelectedCells = this.updateSelectedCellsArray(selectedCells, pRootNode);

      //get the amount of times we need to merge downward;
      var rowAmount = (newSelectedCells.length - 1) / this.mergeCellsColCount;
      var index = 1;
      var doForAmount = rowAmount;
      while (doForAmount > 0) {
        currentCell = newSelectedCells[index];
        this.mergeSelectedCellsRight(currentCell);
        newSelectedCells = this.updateSelectedCellsArray(newSelectedCells, pRootNode);
        index++;
        doForAmount--;
      }

      //now we merge down
      currentCell = newSelectedCells[0];
      while (rowAmount > 0) {
        this.mergeCell($(currentCell), "down");
        rowAmount--;
      }
      selectedCells = pTable[0].querySelectorAll("[data-tajiri-cellselection]");
      selectedCells.forEach(function (pSelectedCell) {
        pSelectedCell.removeAttribute("data-tajiri-cellselection");
      });
      currentCell.setAttribute("data-tajiri-cellselection", "");
    }
  }, {
    key: "mergeSelectedCellsRight",
    value: function mergeSelectedCellsRight(pCurrentCell) {
      while (pCurrentCell.nextSibling !== null && pCurrentCell.nextSibling.getAttribute("data-tajiri-cellselection") !== null) {
        this.mergeCell($(pCurrentCell), "right");
      }
    }
  }, {
    key: "updateSelectedCellsArray",
    value: function updateSelectedCellsArray(pSelectedCells, pRootNode) {
      var that = this;
      var newSelectedCells = [];
      pSelectedCells.forEach(function (pSelectedCell) {
        if (pRootNode.contains(pSelectedCell) === true) {
          newSelectedCells.push(pSelectedCell);
        } else {
          that.mergeCellsColCount++;
        }
      });
      return newSelectedCells;
    }
  }, {
    key: "_getCellByCoords",
    value: function _getCellByCoords(pTable, pRow, pCol) {
      var cell = pTable[0].rows[pRow].cells[pCol];
      if (cell !== undefined) {
        return cell;
      } else {
        if (pCol > pTable[0].rows[pRow].cells.length - 1) {
          //return last
          return pTable[0].rows[pRow].cells[pTable[0].rows[pRow].cells.length - 1];
        } else {
          //return first
          return pTable[0].rows[pRow].cells[0];
        }
      }
    }
  }, {
    key: "_getCellByColIndex",
    value: function _getCellByColIndex(pRow, pIndex) {
      return pRow.children().eq(pIndex);
    }
  }, {
    key: "_getCellIndex",
    value: function _getCellIndex(pCellNode, pTableData) {
      var table = pCellNode.closest("table");
      var tableData = pTableData || this._get2D(table[0]);
      var row = pCellNode.closest("tr");
      var rowIndex = this._getRowIndex(pCellNode);
      var colIndex = 0;
      for (var i = 0; i < row[0].cells.length; i++) {
        if (pCellNode[0] !== row[0].cells[i]) {
          var colSpan = row[0].cells[i].colSpan || 1;
          colIndex += colSpan;
        } else {
          break;
        }
      }
      var cellTableDataIndex = this._getLastIndexIn2D(tableData[rowIndex], {
        row: rowIndex,
        col: colIndex
      });
      for (var i = cellTableDataIndex - 1; i > 0; i--) {
        if (tableData[rowIndex][i].row < rowIndex) {
          colIndex++;
        }
      }
      return colIndex;
    }
  }, {
    key: "_getRowIndex",
    value: function _getRowIndex(pCellNode) {
      return Array.from(pCellNode[0].parentNode.parentNode.children).indexOf(pCellNode[0].parentNode);
    }
  }, {
    key: "_findFirstIndex",
    value: function _findFirstIndex(pTableData, pCheckCoords) {
      for (var row = 0; row < pTableData.length; row++) {
        var colCorrection = 0;
        for (var col = 0; col < pTableData[row].length; col++) {
          if (_.isEqual(pCheckCoords, pTableData[row][col]) === false && _.isEqual(pTableData[row][col], pTableData[row][col + 1])) {
            colCorrection--;
          }
          if (_.isEqual(pCheckCoords, pTableData[row][col])) {
            return {
              row: row,
              col: col + colCorrection
            };
          }
        }
      }
      return false;
    }
  }, {
    key: "_openCellProperties",
    value: function _openCellProperties(pCellNode) {
      var target = pCellNode[0];
      var width = undefined;
      var widthUnit = undefined;
      if (target.style.width.length > 0) {
        if (target.style.width.endsWith("px") === true) {
          widthUnit = "pixels";
          width = parseFloat(target.style.width.slice(0, -2));
        } else if (target.style.width.endsWith("%") === true) {
          widthUnit = "percent";
          width = parseFloat(target.style.width.slice(0, -1));
        } else {
          console.error("TablePlugin: only cells with a width in pixels or percentages are supported");
        }
      }
      var height = undefined;
      var heightUnit = undefined;
      if (target.style.height.length > 0) {
        if (target.style.height.endsWith("px") === true) {
          heightUnit = "pixels";
          height = parseFloat(target.style.height.slice(0, -2));
        } else if (target.style.height.endsWith("%") === true) {
          heightUnit = "percent";
          height = parseFloat(target.style.height.slice(0, -1));
        } else {
          console.error("TablePlugin: only cells with a height in pixels or percentages are supported");
        }
      }
      var wordWrap = true;
      if (target.style.whiteSpace === "nowrap") {
        wordWrap = false;
      }
      var horizontalAlign = undefined;
      if (target.style.textAlign !== undefined) {
        horizontalAlign = target.style.textAlign;
      }
      var verticalAlign = undefined;
      if (target.style.verticalAlign !== undefined) {
        verticalAlign = target.style.verticalAlign;
      }
      var cellType = undefined;
      if (target.nodeName.toLowerCase() === "td" || target.nodeName.toLowerCase() === "th") {
        cellType = target.nodeName.toLowerCase();
      } else {
        throw new Error("TablePlugin: only td or th cells are supported to be edited");
      }
      var rowSpan = 1;
      if (target.rowSpan > 1) {
        rowSpan = target.rowSpan;
      }
      var colSpan = 1;
      if (target.colSpan > 1) {
        colSpan = target.colSpan;
      }
      var backgroundColor = undefined;
      if (target.style.backgroundColor !== undefined) {
        backgroundColor = target.style.backgroundColor;
      }
      var borderColor = undefined;
      if (target.style.borderColor !== undefined) {
        borderColor = target.style.borderColor;
      }
      var cellproperties = $("<div>");
      $("body").append(cellproperties);
      return $.Deferred(function (pDefer) {
        cellproperties.CellPropertiesDialog({
          width: width,
          widthUnit: widthUnit,
          height: height,
          heightUnit: heightUnit,
          wordWrap: wordWrap,
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          cellType: cellType,
          rowSpan: rowSpan,
          colSpan: colSpan,
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          close: function close() {
            cellproperties.remove();
            pDefer.resolve({});
          },
          submit: function submit(pEvent, pValues) {
            if (pValues.width !== null) {
              target.style.width = pValues.width;
            } else {
              target.style.width = "";
            }
            if (pValues.height !== null) {
              target.style.height = pValues.height;
            } else {
              target.style.height = "";
            }
            if (pValues["word-wrap"] === false) {
              target.style.whiteSpace = "nowrap";
            } else {
              target.style.whiteSpace = "";
            }
            target.style.textAlign = pValues["horizontal-align"];
            target.style.verticalAlign = pValues["vertical-align"];
            if (pValues.colspan === 1 || pValues.colspan === 0 || pValues.rowspan === null) {
              target.removeAttribute("colSpan");
            } else if (pValues.colspan !== null) {
              target.colSpan = pValues.colspan;
            } else if (pValues.colspan === null) {
              target.colSpan = "";
            }
            if (pValues.rowspan === 1 || pValues.rowspan === 0 || pValues.rowspan === null) {
              target.removeAttribute("rowSpan");
            } else if (pValues.rowspan !== null) {
              target.rowSpan = pValues.rowspan;
            }
            if (pValues["background-color"] !== null && pValues["background-color"].length > 0) {
              target.style.backgroundColor = pValues["background-color"];
            } else {
              target.style.backgroundColor = "";
            }
            if (pValues["border-color"] !== null && pValues["border-color"].length > 0) {
              target.style.borderColor = pValues["border-color"];
            } else {
              target.style.borderColor = "";
            }
            if (pValues["cell-type"] !== target.nodeName.toLowerCase()) {
              var outer = target.outerHTML;
              var originalTag = target.nodeName.toLowerCase();
              var regexp = new RegExp("^<" + originalTag, "i");
              outer = outer.replace(regexp, "<" + pValues["cell-type"]);
              regexp = new RegExp(originalTag + ">$", "i");
              outer = outer.replace(regexp, pValues["cell-type"] + ">");
              pCellNode.replaceWith(outer);
            }
            cellproperties.remove();
            pDefer.resolve({});
          }
        });
      });
    }
  }, {
    key: "getTags",
    value: function getTags() {
      return this.tags;
    }
  }, {
    key: "selectionChangeHandler",
    value: function selectionChangeHandler(pRootNode, pSelection, pEvent) {
      if (pSelection.anchorNode.parentNode.closest("table") === null || pSelection.focusNode.parentNode.closest("table") === null || pSelection.type === "Caret") {
        var selectedTable = $(pRootNode).find("table[data-tajiri-tableselection]");
        if (selectedTable.length > 0) {
          selectedTable[0].removeAttribute("data-tajiri-tableselection");
        }
        selectedTable.find("td, th").each(function (pIndex, pCell) {
          pCell.removeAttribute("data-tajiri-cellselection");
        });
        return;
      }
      $(pSelection.anchorNode.parentNode).closest("table").find("td, th").each(function (pIndex, pCell) {
        pCell.removeAttribute("data-tajiri-cellselection");
      });
      $(pSelection.anchorNode.parentNode).closest("table").attr("data-tajiri-tableselection", "");
      var startCell = pSelection.anchorNode;
      var endCell = pSelection.focusNode;
      if (["td", "th"].includes(pSelection.anchorNode.nodeName.toLowerCase()) === false) {
        startCell = pSelection.anchorNode.parentNode.closest("td, th");
      }
      if (["td", "th"].includes(pSelection.focusNode.nodeName.toLowerCase()) === false) {
        endCell = pSelection.focusNode.parentNode.closest("td, th");
      }
      if (endCell === null) {
        endCell = startCell;
      }
      var table = startCell.closest("table");
      var tableData = this._get2D(table);
      var colIndexStart = this._getCellIndex($(startCell), tableData);
      var colIndexEnd = this._getCellIndex($(endCell), tableData);
      var colFloor = colIndexStart < colIndexEnd ? colIndexStart : colIndexEnd;
      var colCeil = colIndexStart > colIndexEnd ? colIndexStart : colIndexEnd;
      var colIndexStart = this._getRowIndex($(startCell));
      var colIndexEnd = this._getRowIndex($(endCell));
      var rowFloor = colIndexStart < colIndexEnd ? colIndexStart : colIndexEnd;
      var rowCeil = colIndexStart > colIndexEnd ? colIndexStart : colIndexEnd;
      var selectedCells = [];
      for (var rowIndex = rowFloor; rowIndex < rowCeil + 1; rowIndex++) {
        for (var colIndex = colFloor; colIndex < colCeil + 1; colIndex++) {
          var coords = tableData[rowIndex][colIndex];
          selectedCells.push(this._getCellByCoords($(table), coords.row, coords.col));
        }
      }
      selectedCells.forEach(function (pCellNode) {
        $(pCellNode).attr("data-tajiri-cellselection", "");
      });

      //TODO: text does get selected still, want it to be clean, tajiri only visuals
      // pSelection.removeAllRanges(); wil break (same with window.getSelection().removeAllRanges())
    }
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {
      if (pSelection.anchorNode.parentElement.closest("table") === null) {
        return;
      }
      this.doubleClickHandler(null, {
        selection: pSelection,
        target: pSelection.anchorNode.parentElement.closest("table")
      });
    }
  }]);
  return TablePlugin;
}(Plugin);
;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = TablePlugin;
}

},{"../dialogs/nixps-cloudflow-CellPropertiesDialog.js":328,"../dialogs/nixps-cloudflow-TablePluginDialog.js":332,"./Plugin.js":362}],374:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var TextualPlugin = require("./TextualPlugin.js");
  var Plugin = require("./Plugin.js");
}
function decode(pValue) {
  try {
    return decodeURIComponent(pValue);
  } catch (e) {}
  return pValue;
}

/**
 * @description Plugin handling textual templates
 * @extends TextualPlugin
 */
var TemplatePlugin = /*#__PURE__*/function (_TextualPlugin) {
  _inherits(TemplatePlugin, _TextualPlugin);
  var _super = _createSuper(TemplatePlugin);
  function TemplatePlugin(pOptions) {
    var _this;
    _classCallCheck(this, TemplatePlugin);
    _this = _super.call(this);
    _this._templates = pOptions.templates || [];
    _this.regExp = /[$]{variable\.([^}]*)}/ig;
    _this.startString = "${variable.";
    _this.endString = "}";
    return _this;
  }
  _createClass(TemplatePlugin, [{
    key: "getID",
    value: function getID() {
      return "Template";
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      var options = [];
      if (Array.isArray(this._templates)) {
        options = this._templates.map(function (pTemp) {
          if (pTemp.indexOf("variable.") === 0) {
            return pTemp.slice(9);
          }
          return pTemp;
        });
      }
      options.unshift({
        value: "",
        label: "-"
      });
      return {
        type: Plugin.BUTTON_SELECT,
        options: options,
        icon: null,
        text: "template",
        tooltip: "Template"
      };
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isActive",
    value: function isActive() {
      return true;
    }
  }, {
    key: "doubleClickHandler",
    value: function doubleClickHandler(pEvent, pData) {
      var that = this;
      var selection = pData.selection;
      var originalRange = selection.getRangeAt(0);
      var target = pData.target;
      var value = "";
      var encodedValue = target.getAttribute("data-tajiri-template-value");
      if (typeof encodedValue === "string") {
        value = decodeURIComponent(encodedValue);
      }
      $("body").Dialog("prompt", $.i18n._("nixps-tajiri.plugintemplate_editdialog_title"), $.i18n._("nixps-tajiri.plugintemplate_editdialog_message"), value, true, function (pResult) {
        if (typeof pResult.newValue !== "string" || pResult.newValue.length <= 0) {
          return {
            approved: false,
            error_code: "invalid_value",
            error: $.i18n._("nixps-tajiri.plugintemplate_editdialog_errormessage")
          };
        }
        return {
          approved: true
        };
      }).then(function (pResult) {
        if (typeof pResult.newValue === "string" && pResult.newValue.length > 0) {
          target.innerHTML = that.getVisualContent(pResult.newValue);
          target.setAttribute("data-tajiri-template-value", encodeURIComponent(pResult.newValue));
        }
        selection.removeAllRanges();
        selection.addRange(originalRange);
      });
    }
  }, {
    key: "transformToSource",
    value: function transformToSource(pHTML) {
      if (typeof pHTML !== "string" || pHTML.length <= 0) {
        return "";
      }
      var that = this;
      return pHTML.replace(/<span\s*(?:contenteditable=["']false["']){0,1}\s*(?:class=["']tajiri_translations["']){0}\s*data-tajiri-template-value=['"]([^'"]*)['"][^>]*>(.*?)\$\{.*?\}(.*?)<\/span>/ig, function (pMatch, p1, p2, p3) {
        p2 = p2 ? p2 : "";
        p3 = p3 ? p3 : "";
        return p2 + that.startString + decode(p1) + that.endString + p3;
      });
    }
  }]);
  return TemplatePlugin;
}(TextualPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = TemplatePlugin;
}

},{"./Plugin.js":362,"./TextualPlugin.js":375}],375:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var Plugin = require("./Plugin.js");
}

/**
 * @description Plugin handling textual templates
 * @extends Plugin
 */
var TextualPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(TextualPlugin, _Plugin);
  var _super = _createSuper(TextualPlugin);
  function TextualPlugin() {
    var _this;
    _classCallCheck(this, TextualPlugin);
    _this = _super.call(this);
    _this.regExp = null;
    _this.startString = null;
    _this.endString = null;
    _this.value = "";
    _this.classes = "";
    return _this;
  }

  //------------------------------------------------------------------------------------------------
  _createClass(TextualPlugin, [{
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: null,
        text: "template",
        tooltip: "Template"
      };
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isActive",
    value: function isActive() {
      return true;
    }
  }, {
    key: "transformToSource",
    value: function transformToSource() {
      throw new Error("Method 'transformToSource' must be implemented.");
    }
  }, {
    key: "setValue",
    value: function setValue(pValue) {
      this.value = pValue;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "getValidAttributeNames",
    value: function getValidAttributeNames() {
      return ["data-tajiri-template-value", "contenteditable"];
    }
  }, {
    key: "getDoubleClickSelector",
    value: function getDoubleClickSelector() {
      return "span[data-tajiri-template-value]";
    }
  }, {
    key: "getVisualContent",
    value: function getVisualContent(pValue) {
      return this.startString + pValue + this.endString;
    }
  }, {
    key: "transformToEdit",
    value: function transformToEdit(pHTML) {
      if (typeof pHTML !== "string" || pHTML.length <= 0) {
        return "";
      }
      var that = this;
      var addedElementContent = "";
      if (typeof this.classes === "string" && this.classes.length > 0) {
        addedElementContent = "class='" + this.classes + "' ";
      }
      return pHTML.replace(this.regExp, function (pMatch, p1) {
        return "<span data-tajiri-template-value='" + encodeURIComponent(p1) + "' " + addedElementContent + " contenteditable=false role='button' >" + that.getVisualContent(p1) + "</span>";
      });
    }
  }, {
    key: "format",
    value: function format(pSelection, pRootNode) {
      var that = this;
      var value = this.getValue() || "name";
      var spanDOM = document.createElement("span");
      spanDOM.setAttribute("data-tajiri-template-value", encodeURIComponent(value));
      if (typeof this.classes === "string" && this.classes.length > 0) {
        spanDOM.className = this.classes;
      }
      spanDOM.setAttribute("contenteditable", false);
      spanDOM.setAttribute("role", "button");
      spanDOM.innerText = this.getVisualContent(value);
      this._setNodeInSelection(pSelection, spanDOM);
      var nonBreakingSpace = document.createTextNode("\xA0");
      spanDOM.parentElement.insertBefore(nonBreakingSpace, spanDOM.nextSibling);
      pSelection.getRangeAt(0).setEndAfter(nonBreakingSpace);
      pSelection.getRangeAt(0).collapse(false);
    }
  }, {
    key: "clickHandler",
    value: function clickHandler(pEvent, pData) {
      var selection = pData.selection;
      if (selection === null || selection.type === "None") {
        pData.target.closest(".area").focus();
        selection = document.getSelection();
      }
      //fix for safari, weird behavior if contenteditable is on true
      pData.target.closest("span[data-tajiri-template-value]").setAttribute("contenteditable", true);
      // var range = new Range();
      // range.selectNode(pData.target.closest("span[data-tajiri-template-value]"))
      selection.removeAllRanges();
      selection.setBaseAndExtent(pData.target.closest("span[data-tajiri-template-value]"), 0, pData.target.closest("span[data-tajiri-template-value]"), 1);
      pData.target.closest("span[data-tajiri-template-value]").setAttribute("contenteditable", false);
    }
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {}
  }]);
  return TextualPlugin;
}(Plugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = TextualPlugin;
}

},{"./Plugin.js":362}],376:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var TextualPlugin = require("./TextualPlugin.js");
  var Plugin = require("./Plugin.js");
}
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
;
function generateUUID() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
;
function decode(pValue) {
  try {
    return decodeURIComponent(pValue);
  } catch (e) {}
  return pValue;
}

/**
 * @description Plugin handling textual Translations
 * data-translation-uuid
 * @extends TextualPlugin
 */
var TranslationPlugin = /*#__PURE__*/function (_TextualPlugin) {
  _inherits(TranslationPlugin, _TextualPlugin);
  var _super = _createSuper(TranslationPlugin);
  function TranslationPlugin() {
    var _this;
    var pOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, TranslationPlugin);
    _this = _super.call(this);
    _this.classes = "tajiri_translations";
    _this._templates = pOptions.templates || [];
    _this._defaultText = pOptions.defaultText || "text";
    _this._dblClickHandler = function () {};
    if (typeof pOptions.dblClickHandler === "function") {
      _this._dblClickHandler = pOptions.dblClickHandler;
    }
    _this.regExp = /[#]{translation\.([^}]*)}/ig;
    _this.startString = "#{translation.";
    _this.endString = "}";
    return _this;
  }
  _createClass(TranslationPlugin, [{
    key: "getID",
    value: function getID() {
      return "Translation";
    }
  }, {
    key: "getVisualContent",
    value: function getVisualContent(pValue) {
      var indexOfDBQuotes = pValue.indexOf(":");
      if (indexOfDBQuotes < 0) {
        return "#{" + $.i18n._(pValue) + "}";
      } else {
        var translationKey = pValue.slice(0, indexOfDBQuotes);
        var candidateText = $.i18n._(translationKey);
        if (candidateText === translationKey) {
          return "#{" + pValue.slice(indexOfDBQuotes + 1) + "}";
        }
        return "#{" + candidateText + "}";
      }
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "fa fa-language",
        text: "translation",
        tooltip: "nixps-richeditor.insert_translation"
      };
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return generateUUID() + ":" + this._defaultText;
    }

    //------------------------------------------------------------------------------------------------
  }, {
    key: "isActive",
    value: function isActive(pSelection, pRootNode) {
      return false;
    }
  }, {
    key: "getDoubleClickSelector",
    value: function getDoubleClickSelector() {
      return "span[data-tajiri-template-value].tajiri_translations";
    }
  }, {
    key: "doubleClickHandler",
    value: function doubleClickHandler(pEvent, pData) {
      var that = this;
      var selection = pData.selection;
      var target = pData.target;
      var value = "";
      var encodedValue = target.getAttribute("data-tajiri-template-value");
      if (typeof encodedValue === "string") {
        value = decodeURIComponent(encodedValue);
      }
      this._dblClickHandler(pEvent, {
        target: target,
        key: value
      });
    }
  }, {
    key: "transformToSource",
    value: function transformToSource(pHTML) {
      if (typeof pHTML !== "string" || pHTML.length <= 0) {
        return "";
      }
      var that = this;
      return pHTML.replace(/<span(?=\s)(?=(?:[^>"']*["'][^>"']*["'])*[^>"']*\sclass=["']tajiri_translations["'])(?=(?:[^>"']*["'][^>"']*["'])*[^>"']*\sdata-tajiri-template-value=["']([^'"]*)["'])(?=(?:[^>"']*["'][^>"']*["'])*[^>"']*\scontenteditable=["']false["'])?[^>]*>(.*?)#\{.*?\}(.*?)<\/span>/ig, function (pMatch, p1, p2, p3) {
        p2 = p2 ? p2 : "";
        p3 = p3 ? p3 : "";
        return p2 + that.startString + decode(p1) + that.endString + p3;
      });
    }
  }, {
    key: "unformat",
    value: function unformat(pSelection, pRootNode) {}
  }]);
  return TranslationPlugin;
}(TextualPlugin);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = TranslationPlugin;
}

},{"./Plugin.js":362,"./TextualPlugin.js":375}],377:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (typeof require === "function") {
  var StyledPluginEC = require("./StyledPluginEC.js");
  var Plugin = require("./Plugin.js");
}
/**
 * @description Plugin handling the Underline style 
 * @extends StyledPluginEC
 */
var UnderlinePlugin = /*#__PURE__*/function (_StyledPluginEC) {
  _inherits(UnderlinePlugin, _StyledPluginEC);
  var _super = _createSuper(UnderlinePlugin);
  function UnderlinePlugin() {
    var _this;
    _classCallCheck(this, UnderlinePlugin);
    _this = _super.call(this, "underline");
    _this.tags = ["u"];
    _this.styleName = "text-decoration-line";
    _this.styleValues = ["underline"];
    return _this;
  }

  /**------------------------------------------------------------------------------------------------
   * Returns the plugin ID
   * @returns {string} the plugin ID.
   */
  _createClass(UnderlinePlugin, [{
    key: "getID",
    value: function getID() {
      return "Underline";
    }

    /**------------------------------------------------------------------------------------------------
     * Returns the description of the plugin"s button
     */
  }, {
    key: "getButtonDescription",
    value: function getButtonDescription() {
      return {
        type: Plugin.BUTTON_TOGGLE,
        icon: "cf-icon cf-icon-underline",
        text: "U",
        tooltip: "nixps-tajiri.pluginunderline_tooltip"
      };
    }

    /**------------------------------------------------------------------------------------------------
     * Function call to determine if "underline" is applied on a given node element
     * @param {Node} pNode the node to check.
     * @returns true if underline is applied, false otherwise
     */
  }, {
    key: "isStyleActive",
    value: function isStyleActive(pNode) {
      return this.tags.indexOf(pNode.nodeName.toLowerCase()) !== -1;
    }
  }, {
    key: "_isActiveInCSSAttribute",
    value: function _isActiveInCSSAttribute(pCSSAttribute) {
      return pCSSAttribute.search(/text-decoration\s*:\s*underline/i) >= 0;
    }
  }, {
    key: "_isDesactiveInCSSAttribute",
    value: function _isDesactiveInCSSAttribute(pCSSAttribute) {
      return pCSSAttribute.search(/text-decoration\s*:\s*none/i) >= 0;
    }
  }]);
  return UnderlinePlugin;
}(StyledPluginEC);
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = UnderlinePlugin;
}

},{"./Plugin.js":362,"./StyledPluginEC.js":369}],378:[function(require,module,exports){
"use strict";

/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 *
 *   created by guillaume on Aug 24, 2016 3:54:06 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @namespace nixps.Timeline
   * @description This component shows a Timeline. This is a table which shows a list of tasks from and to a specific date. The y-as shows the times
   * @example $('<div>').Timeline({
   *                      rows: [
   *                      {'start': new Date(2016, 09, 25), 'end':new Date(2016,09,30), 'content': "deel 2", group: 'deel 1', className: 'groupOne', editable: false},
                {'start': new Date(2016, 09, 21), 'end':new Date(2016,10,3), 'content': "deel 3", group: 'deel 1', className: 'groupOne', editable: false},
                {'start': new Date(2016, 09, 27), 'end':new Date(2016,09,30), 'content': "deel 4", group: 'deel 1', className: 'groupOne', editable: false},
                 {'start': new Date(2016, 10, 05), 'end':new Date(2016,10,15), 'content': "deel 0", group: 'deel 1', className: 'groupTwo', editable: false},
                {'start': new Date(2016, 09, 17), 'end':new Date(2016,09,30), 'content': "deel 2", group: 'deel 2', className: 'groupTwo', editable: false},
                {'start': new Date(2016, 09, 19), 'end':new Date(2016,09,30), 'content': "deel 3", group: 'deel 2', className: 'groupTwo', editable: false},
                {'start': new Date(2016, 09, 02), 'end':new Date(2016,09,19), 'content': "deel 4", group: 'deel 2', className: 'groupTwo', editable: false}
                 ] })
   * @requires moment.js
   * @requires chap-linksplibrary.timeline.js
   * see interanl documenttions: http://almende.github.io/chap-links-library/js/timeline/doc/
   * @version 1.0
   */
  $.widget("nixps.Timeline", $.Widget, {
    widgetEventPrefix: "timeline",
    options: {
      /**
       * @name nixps.Timeline#height
       * @description The total height of the internal component. this value is given directly to the internal component. It can be in pixels, percentage or "auto"
       * @type {string}
       * @default "auto"
       */
      height: "auto",
      /**
       * @name nixps.Timeline#width
       * @description The width of the internal component. This is a option given to the internal component. Must be a string in pixels or percentage
       * @type {string}
       * @default "100%"
       * @example "50%"
       */
      width: "100%",
      /**
       * @name nixps.Timeline#start
       * @description The timestamp when the timeline must start on creation.
       * @type {Date}
       * @default undefined
       * @example new Date(2016,12,27)
       */
      start: undefined,
      /**
       * @name nixps.Timeline#end
       * @description Then end timestamp, end point to show on creation
       * @type {Date}
       * @default undefined
       * @example new Date(2016,12,27)
       */
      end: undefined,
      /**
       * @name nixps.Timeline#rows
       * @description The rows, items to be displayed
       * @type {Array}
       * @default []
       * @example [{
              {'start': new Date(2016, 09, 25), 'end':new Date(2016,09,30), 'content': "deel 2", group: 'deel 1', className: 'groupOne', editable: false},
            {'start': new Date(2016, 09, 21), 'end':new Date(2016,10,3), 'content': "deel 3", group: 'deel 1', className: 'groupOne', editable: false},
            {'start': new Date(2016, 09, 27), 'end':new Date(2016,09,30), 'content': "deel 4", group: 'deel 1', className: 'groupOne', editable: false},
             {'start': new Date(2016, 10, 05), 'end':new Date(2016,10,15), 'content': "deel 0", group: 'deel 1', className: 'groupTwo', editable: false},
            {'start': new Date(2016, 09, 17), 'end':new Date(2016,09,30), 'content': "deel 2", group: 'deel 2', className: 'groupTwo', editable: false},
            {'start': new Date(2016, 09, 19), 'end':new Date(2016,09,30), 'content': "deel 3", group: 'deel 2', className: 'groupTwo', editable: false},
            {'start': new Date(2016, 09, 02), 'end':new Date(2016,09,19), 'content': "deel 4", group: 'deel 2', className: 'groupTwo', editable: false}]
       */
      rows: [],
      /**
       * @name nixps.Timeline#loading_text
       * @description The text to show during loading
       * @type {String}
       * @default ""
       * @example "loading ..."
       */
      loading_text: "",
      /**
       * @name nixps.Timeline#editable
       * @description Must the events be editable or not
       * @type {Boolean}
       * @default false
       */
      editable: false,
      /**
       * @name nixps.Timeline#selectable
       * @description Must we be able to select periods?
       * @type {Boolean}
       * @default true
       */
      selectable: true,
      /**
       * @name nixps.Timeline#maxItemsInGroup
       * @description The maximum amount of items in a group, if there are more items, they will collapse
       * Must be higher or equal to one
       * @type {Number}
       * @default 7
       */
      maxItemsInGroup: 7,
      /**
       * @name nixps.Timeline#language
       * @description The language of th user. used to define the correct language and month names.
       * This string must be a moment local valid string
       * @type {String | local}
       * @default "en"
       */
      language: "en"
    },
    /**
     * @description create the component
     * @name nixps.Timeline#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      if (this.options.language === "en") {
        var browserlanguage = navigator.language || navigator.userLanguage;
        if (typeof browserlanguage === "string" && browserlanguage.length > 0) {
          moment.locale(browserlanguage);
        } else {
          moment.locale("en");
        }
      } else {
        moment.locale(this.options.language);
      }
      this.timeline; // the internal component
      this.rows;
      var chart = $("<div>").addClass("chart");
      this.element.empty().append(chart);
      if (typeof this.options.loading_text === "string" && this.options.loading_text.length > 0 && this.options.height !== "auto") {
        this.element.css("height", this.options.height);
        this.element.append($("<div>").addClass("timeline_loadingpanel").append($("<div>").text(this.options.loading_text)));
      }
      this._setRowOption(this.options.rows);
      this._on(this.element, {
        "dblclick .timeline-event": this._dblClickHandler
      });

      // resize window listeners
      this.resizeHandler = _.throttle(this._windowResizedHandler, 500).bind(this);
      if (typeof ResizeObserver !== "undefined") {
        this.resizeObserver = new ResizeObserver(this.resizeHandler);
        this.resizeObserver.observe(this.element[0]);
      } else {
        $(window).on("resize", this.resizeHandler);
      }
    },
    /**
     * @description function runs when user double clicks on a event. Send a dblclick event
     * @function
     * @private
     * @name nixps.Timeline#_dblClickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _dblClickHandler: function _dblClickHandler(pEvent, pData) {
      this._trigger("dblclick", pEvent, {
        rows: this.getSelectedItems(),
        clusterRows: this.getSelectedClusterItems()
      });
    },
    /**
     * @description function runs when the window ui resized
     * @function
     * @name nixps.Timeline#_windowResizedHandler
     * @private
     * @param {Object} pEvent 
     */
    _windowResizedHandler: function _windowResizedHandler(pEvent) {
      if (this.timeline !== undefined) {
        this.timeline.checkResize();
      }
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.Timeline#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Rraws the dialog according to the current state
     * @function
     * @private
     * @name nixps.Timeline#_draw
     * @return {undefined}
     */
    _draw: function _draw() {
      // timeline want only draw himself correclty if he is visible
      // to tackle this error, move the component to the body, draw it, and move it back to his place
      var placeholder = null;
      var oldPosition, oldZIndex;
      // control if we need to move and if it is save to do it
      if (this.options.height === "auto" && this.element.is(":visible") === false) {
        placeholder = $("<div>").addClass("timeline_placeholder_" + this.uuid);
        this.element.after(placeholder);
        // save current css style, to apply after changing...
        oldPosition = this.element.css("position");
        oldZIndex = this.element.css("z-index");
        // change css make it visibly hidden, so user dont see it, but height and width are known!
        this.element.css({
          visibility: "hidden",
          position: "relative",
          "z-index": -1
        }).appendTo("body");
      }
      /**
       * attention options "start" and "end" DOES NOT exist in timeline.js !!!
       *
       */
      var options = {
        height: this.options.height,
        width: this.options.width,
        minHeight: 150,
        locale: this.options.language,
        groupMinHeight: 30,
        min: undefined,
        max: undefined,
        selectable: this.options.selectable,
        editable: this.options.editable,
        animate: false,
        eventMargin: 10,
        // minimal margin between events
        eventMarginAxis: 5,
        // minimal margin between events and the axis
        showMajorLabels: true,
        cluster: true,
        clusterMaxItems: this.options.maxItemsInGroup,
        axisOnTop: true,
        snapEvents: true,
        dragAreaWidth: 20,
        zoomable: true,
        zoomMax: 157784630000,
        /* 5 years*/
        zoomMin: 3000000 /*5 min */,
        showNavigation: true,
        groupsOrder: true,
        // give here a function to sort the groups */
        MONTHS: moment.months(),
        MONTHS_SHORT: moment.monthsShort(),
        DAYS: moment.weekdays(),
        DAYS_SHORT: moment.weekdaysShort()
      };
      this.timeline = new window.links.Timeline(this.element.find(".chart").empty()[0], options);
      this.timeline.draw(this.rows);
      if (placeholder !== null) {
        // place the component back on his original place!
        this.element.insertBefore(placeholder);
        // restore in his original css
        this.element.css({
          visibility: "",
          position: oldPosition,
          "z-index": oldZIndex
        });
        placeholder.remove(); // remove the tempory placeholder
      }

      if (this.options.start !== undefined || this.options.end !== undefined) {
        this.timeline.setVisibleChartRange(this.options.start, this.options.end);
      }
      window.links.events.addListener(this.timeline, "ready", this._readyHandler.bind(this));
      window.links.events.addListener(this.timeline, "select", this._selectHandler.bind(this));
      window.links.events.addListener(this.timeline, "changed", this._changedHandler.bind(this));
      window.links.events.addListener(this.timeline, "edit", this._editHandler.bind(this));
      window.links.events.addListener(this.timeline, "add", this._addHandler.bind(this));
      window.links.events.addListener(this.timeline, "rangechanged", this._rangeChangeHandler.bind(this));
    },
    _readyHandler: function _readyHandler() {
      this._positionTitlesForDocumentWindow();
      this.element.children(".timeline_loadingpanel").remove();
      this._trigger("ready", null, {});
    },
    /**
     * @description function runs when user click and select a item. function runs be plugin
     * @function
     * @private
     * @name nixps.Timeline#_selectHandler
     * @returns {undefined}
     */
    _selectHandler: function _selectHandler() {
      // remove selected class
      this.element.find(".timeline-cluster-event-selected").removeClass("timeline-cluster-event-selected");
      // collect data
      var rows = this.getSelectedItems();
      var clusterRows = this.getSelectedClusterItems();
      if (Array.isArray(clusterRows) && clusterRows.length > 0 && clusterRows[0] !== undefined) {
        // interface cluster number controlled in getSelectedClusterItems
        this.getClusterElement(this.timeline.getSelection()[0].cluster).addClass("timeline-cluster-event-selected");
      }
      this._trigger("select", null, {
        rows: rows,
        clusterRows: clusterRows
      });
    },
    _changedHandler: function _changedHandler() {
      this._trigger("change", null, {});
    },
    _editHandler: function _editHandler() {
      this._trigger("dblclick", null, {
        rows: this.getSelectedItems(),
        clusterRows: this.getSelectedClusterItems()
      });
    },
    _addHandler: function _addHandler() {
      // if by exident add, remove
      this.timeline.cancelAdd();
    },
    /**
     * @description function runs when the rang change, by dragging and scrolling. function called by plugin
     * @function
     * @private
     * @name nixps.Timeline#_rangeChangeHandler
     * @param {type} pRange
     * @returns {undefined}
     */
    _rangeChangeHandler: function _rangeChangeHandler(pRange) {
      this._positionTitlesForDocumentWindow();
      this._trigger("drawed", null, {});
    },
    /**
     * @description put the text on the visible document window
     * @function
     * @name nixps.Timeline#_positionTitlesForDocumentWindow
     * @private
     * @returns {undefined}
     */
    _positionTitlesForDocumentWindow: function _positionTitlesForDocumentWindow() {
      this.element.find(".timeline-event.timeline-event-range").each(function () {
        var leftPosition = $(this).position().left;
        if (leftPosition < 0) {
          // only do something if container is hidden in de left side of the document
          var contentHTML = $(this).children();
          var totalWidth = $(this).width();
          var contentWidth = contentHTML.children().width();
          if (totalWidth <= contentWidth) {
            // do nothing if text is larger then container
            $(this).children().css("padding-left", "");
          } else {
            var leftShift = Math.min(-leftPosition + 10, totalWidth - contentWidth);
            $(this).children().css("padding-left", leftShift);
          }
        } else {
          // reset the other items
          $(this).children().css("padding-left", "");
        }
      });
    },
    /**
     * @name nixps.Timeline#getSelectedItems
     * @description Get all items that are selected
     * @function
     * @returns {Array}
     */
    getSelectedItems: function getSelectedItems() {
      var selectedItems = this.timeline.getSelection();
      var selectedItemObjects = [];
      if (Array.isArray(selectedItems)) {
        for (var i = 0; i < selectedItems.length; i++) {
          if ($.isPlainObject(selectedItems[i]) && typeof selectedItems[i].row === "number" && selectedItems[i].row >= 0) {
            // if row is unknow or outsite the range, undefined is added to the array
            selectedItemObjects.push(this.rows[selectedItems[i].row]);
          }
        }
      }
      return selectedItemObjects;
    },
    /**
     * @name nixps.Timeline#getSelectedClusterItems
     * @description Get all items of selected clusters.
     * @function
     * @returns {Array} containing a array of the grouped items
     */
    getSelectedClusterItems: function getSelectedClusterItems() {
      var selectedItems = this.timeline.getSelection();
      var selectedItemObjects = [];
      if (Array.isArray(selectedItems)) {
        for (var i = 0; i < selectedItems.length; i++) {
          if ($.isPlainObject(selectedItems[i]) && typeof selectedItems[i].cluster === "number" && selectedItems[i].cluster >= 0) {
            // look up the corresponding cluster
            var cluster = this.timeline.getCluster(selectedItems[i].cluster);
            // control interface of cluster
            if (cluster !== undefined && Array.isArray(cluster.items)) {
              selectedItemObjects.push(cluster.items);
            } else {
              // if there is no array, init to something
              console.warn("no cluster found with items.");
              selectedItemObjects.push(undefined);
            }
          }
        }
      }
      return selectedItemObjects;
    },
    /**
     * @description Get the jquery dom element of a specific cluster
     * @function
     * @name nixps.Timeline#getClusterElement
     * @param {number} pIndex the index found in result of "getClusters"
     * @returns {jQueryElement} The jQuery element of the cluster
     */
    getClusterElement: function getClusterElement(pIndex) {
      // control if index is a number
      if (typeof pIndex !== "number") {
        throw new Error("parameter index must be a number");
      }
      // control if index is in the range of the array
      var amountClusters = this.timeline.clusters.length;
      if (pIndex < 0 || pIndex >= amountClusters) {
        throw new Error("parameter index is out of range");
      }
      // return the jQuery element
      return $(this.timeline.clusters[pIndex].dom);
    },
    /**
     * @description Returns an array of all custers, those clusters contains a parameter items who is an array of all items collepsed in that cluster
     * @function
     * @name nixps.Timeline#getClusters
     * @returns {Array}
     */
    getClusters: function getClusters() {
      var clusters = []; // init empty array
      var clusterLength = this.timeline.clusters.length;
      // loop over and add to the array
      for (var i = 0; i < clusterLength; i++) {
        clusters.push(this.timeline.getCluster(i));
      }
      return clusters;
    },
    /**
     * @description returns an object with begin and end date of the visible range, or null if timeline is unkown.
     * @function
     * @name nixps.Timeline#getVisibleRange
     * @returns {object} object containing begin and end Dates of visible range, both in js Date format
     */
    getVisibleRange: function getVisibleRange() {
      if (this.timeline !== undefined) {
        return this.timeline.getVisibleChartRange();
      }
      return null;
    },
    /**
     * @description Get all Visible items
     * @function
     * @name nixps.Timeline#getVisibleItems
     */
    getVisibleItems: function getVisibleItems() {
      var visibleItemsData = [];
      if (this.timeline !== undefined) {
        var border = this.timeline.getVisibleChartRange();
        var visibleItems = this.timeline.getVisibleItems(border.start, border.end);
        if (Array.isArray(visibleItems) && visibleItems.length > 0) {
          for (var i = 0; i < visibleItems.length; i++) {
            if ($.isPlainObject(visibleItems[i]) && typeof visibleItems[i].row === "number" && visibleItems[i].row >= 0) {
              // if row is unknow or outsite the range, undefined is added to the array
              visibleItemsData.push({
                "data": this.rows[visibleItems[i].row],
                "dom": this.timeline.items[visibleItems[i].row].dom
              });
            }
          }
        }
      }
      return visibleItemsData;
    },
    /**
     * @description Refresh the timeline with new items
     * @name nixps.Timeline#refresh
     * @function
     * @param {array | $.deferred} pRows if provided we use that, if undefined we use the options.rows
     * @returns {deffered}
     */
    refresh: function refresh(pRows) {
      var rows = pRows;
      if (pRows === undefined) {
        // no argument, use options
        rows = this.options.rows;
      } else {
        // set the options
        this.options.rows = pRows;
      }
      var that = this;
      return $.when(rows).done(function (pRows) {
        that.rows = pRows;
        that.timeline.setData(pRows);
        that.timeline.redraw();
        that._trigger("refresh", null, {});
      }).fail(console.error);
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps.Timeline#_setOption
     */
    _setRowOption: function _setRowOption(pRows) {
      var that = this;
      $.when(pRows).done(function (pRows) {
        for (var i = 0; i < pRows.length; i++) {
          if (!$.isPlainObject(pRows[i]) || $.isEmptyObject(pRows[i])) {
            throw new Error("Timeline: rows item " + i + " must be a not empty object");
          }
          if (moment.isDate(pRows[i].start) === false) {
            var startDate = moment(pRows[i].start);
            if (startDate.isValid() === false) {
              throw new Error("Timeline: rows item " + i + " start could not be converterd to date");
            }
            pRows[i].start = startDate.toDate();
          }
        }
        that.rows = pRows;
        that.options.rows = pRows;
        that._draw();
      }).fail(function (pError) {
        console.error(pError);
        that.rows = [];
        that._draw();
      });
    },
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "rows") {
        // new rows
        this._setRowOption(this.options.rows);
      } else if (["start", "end", "selectable", "editable"].includes(pKey)) {
        var options = {};
        options[pKey] = pValue;
        this.timeline.setOptions(options);
        this.timeline.redraw();
      } else if (pKey === "language") {
        if (pValue === "en") {
          var browserlanguage = navigator.language || navigator.userLanguage;
          if (typeof browserlanguage === "string" && browserlanguage.length > 0) {
            moment.locale(browserlanguage);
          } else {
            moment.locale("en");
          }
        } else {
          moment.locale(pValue);
        }
        this.timeline.setOptions({
          MONTHS: moment.months(),
          MONTHS_SHORT: moment.monthsShort(),
          DAYS: moment.weekdays(),
          DAYS_SHORT: moment.weekdaysShort(),
          locale: pValue
        });
        this.timeline.redraw();
      } else if (pKey === "height") {
        if (this.options.height !== "auto") {
          this.element.css("height", this.options.height);
        }
        this.redraw();
      } else {
        this.redraw();
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.Timeline#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof window.moment !== "function") {
        throw new Error("Timeline: please, include js file moment.js");
      }
      if (this.options.start !== undefined && moment.isDate(this.options.start) === false) {
        throw new Error("Timeline: input option start must be a js Date object or undefined");
      }
      if (this.options.end !== undefined && moment.isDate(this.options.end) === false) {
        throw new Error("Timeline: input option end must be a js Date object or undefined");
      }
      if (!Array.isArray(this.options.rows) && typeof this.options.rows.promise !== "function") {
        throw new Error("Timeline: rows option must be a array");
      }
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("Timeline: option language must be a not empty string");
      }
      if (typeof this.options.selectable !== "boolean") {
        throw new Error("Timeline: option selectable must be a boolean");
      }
      if (typeof this.options.maxItemsInGroup !== "number" || this.options.maxItemsInGroup < 1) {
        throw new Error("Timeline: option maxItemsInGroup must be a number bigger or equal to one");
      }
      if (typeof this.options.editable !== "boolean") {
        throw new Error("Timeline: option editable must be a boolean");
      }
      if (typeof this.options.height === "number") {
        this.options.height = this.options.height + "px";
      }
      if (typeof this.options.height !== "string" || this.options.height.length <= 0) {
        throw new Error("Timeline: option height must be a string");
      } else if (/^(auto|0)$|^[+-]?[0-9]+.?([0-9]+)?(px|em|ex|%|in|cm|mm|pt|pc)$/.test(this.options.height) === false) {
        throw new Error("Timeline: option height must be a valid css unit");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      if (typeof ResizeObserver !== "undefined") {
        this.resizeObserver.unobserve(this.element[0]);
      } else {
        $(window).off("resize", this.resizeHandler);
      }
    }
  });
})(jQuery);

},{}],379:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function ($) {
  require("./nixps-common-DialogWithTitle.js");
  $.widget("nixps.DialogTooltip", $.Widget, {
    options: {
      /**
       * @description The language of the user
       * @name nixps.DialogTooltip#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      content: {
        text: "",
        title: "",
        button: ""
      },
      style: {
        classes: "",
        width: 200,
        minHeight: 150
      },
      position: {
        my: 'left center',
        at: 'right center',
        target: "body",
        adjust: {
          method: "flip"
        }
      },
      show: {
        ready: true
      },
      events: {
        show: function show() {},
        hide: function hide(pEvent) {},
        hidden: function hidden() {},
        destroy: function destroy() {}
      },
      created: function created() {}
    },
    dialog: undefined,
    /**
     * @description Create the component
     * @name nixps.DialogTooltip#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._beforeHandler();
      this.element.addClass(this.widgetFullName);
      this._draw();
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.DialogTooltip#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.DialogTooltip#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var dialog = $("<div>").addClass("cf-tooltip-main");
      if (typeof this.options.content === "function") {
        dialog.append(this.options.content(this.element));
      } else {
        dialog.append($("<div>").addClass("cf-tooltip-body").append(typeof this.options.content.text === "function" ? this.options.content.text() : this.options.content.text));
        dialog.append($("<div>").addClass("cf-tooltip-buttons").append(typeof this.options.content.buttons === "function" ? this.options.content.buttons() : this.options.content.buttons));
      }
      dialog.DialogWithTitle({
        title: typeof this.options.content.title === "function" ? this.options.content.title() : this.options.content.title,
        width: typeof this.options.style.width === "function" ? this.options.style.width() : this.options.style.width,
        dialogClass: "cf-dialog cf-tooltip-dialog".concat(" ", "cf-dialog cf-tooltip-dialog " + _typeof(this.options.style.classes) === "function" ? this.options.style.classes() : this.options.style.classes),
        closeText: "",
        classes: {
          "ui-dialog": "cf-dialog cf-tooltip-dialog".concat(" ", "cf-dialog cf-tooltip-dialog " + _typeof(this.options.style.classes) === "function" ? this.options.style.classes() : this.options.style.classes)
        },
        position: {
          my: (typeof this.options.position.my === "function" ? this.options.position.my() : this.options.position.my).split(" ").reverse().join(" "),
          at: (typeof this.options.position.at === "function" ? this.options.position.at() : this.options.position.at).split(" ").reverse().join(" "),
          of: typeof this.options.position.target === "function" ? this.options.position.target() : this.options.position.target,
          collision: this.options.position.adjust && typeof this.options.position.adjust.method === "string" ? this.options.position.adjust.method : "flip"
        },
        minHeight: typeof this.options.style.minHeight === "function" ? this.options.style.minHeight() : this.options.style.minHeight,
        autoOpen: this.options.show.ready,
        open: this.options.events.show,
        close: this._closeHandler.bind(this),
        beforeClose: this.options.events.hidden,
        draggable: false,
        resizable: false
      });
      if (dialog.is(":visible")) {
        // UI.dialog set before a display block via the .show()
        // and that has an impact on css, so reset 
        dialog.css("display", "block");
      }
      // remove min-height
      dialog.css("min-height", "");
      this._addPointer(dialog);
      this.dialog = dialog;
    },
    _addPointer: function _addPointer(dialog) {
      var dialogContainer = dialog.closest(".ui-dialog");
      var pointer = $('<div>').addClass("nixps-pointer");
      dialogContainer.append(pointer);
      var ofResolved = typeof this.options.position.target === "function" ? this.options.position.target() : typeof this.options.position.target === "string" ? $(this.options.position.target) : this.options.position.target;
      var ofResolvedOffset = ofResolved.offset();
      var dialogIsHigher = false;
      var dialogIsRight = false;
      var relativeXProcent = 50;
      var relativeYProcent = 50;
      var topDifference = 0;
      var leftDifference = 0;
      if (dialogContainer.offset().top + dialogContainer.height() / 2 <= ofResolvedOffset.top + ofResolved.height() / 2) {
        dialogIsHigher = true;
      }
      if (dialogContainer.offset().left + dialogContainer.width() / 2 >= ofResolvedOffset.left + ofResolved.width() / 2) {
        dialogIsRight = true;
      }
      topDifference = Math.abs(ofResolvedOffset.top + ofResolved.height() / 2 - (dialogContainer.offset().top + dialogContainer.height() / 2));
      leftDifference = Math.abs(ofResolvedOffset.left + ofResolved.width() / 2 - (dialogContainer.offset().left + dialogContainer.width() / 2));
      relativeXProcent = leftDifference / (leftDifference + topDifference) * 100;
      relativeYProcent = topDifference / (leftDifference + topDifference) * 100;
      var isInXRange = ofResolvedOffset.left < dialogContainer.offset().left + dialogContainer.width() && ofResolvedOffset.left > dialogContainer.offset().left || ofResolvedOffset.left + ofResolved.width() < dialogContainer.offset().left + dialogContainer.width() && ofResolvedOffset.left + ofResolved.width() > dialogContainer.offset().left;
      var maxPointerWidthRange = dialogContainer.width() - 10;
      var maxPointerHeightRange = dialogContainer.height() - 10;
      if (relativeXProcent <= relativeYProcent || isInXRange) {
        if (dialogIsHigher) {
          pointer.addClass("arrow-down");
          dialogContainer.css("top", dialogContainer.position().top - 10);
        } else {
          pointer.addClass("arrow-up");
          dialogContainer.css("top", dialogContainer.position().top + 10);
        }
        var middleX = ofResolvedOffset.left + ofResolved.width() / 2;
        if (middleX < dialogContainer.offset().left + 10) {
          pointer.css("left", "10px");
        } else if (middleX > dialogContainer.offset().left + maxPointerWidthRange) {
          pointer.css("left", "calc(100% - 30px)");
        } else {
          pointer.css("left", middleX - dialogContainer.offset().left - 10 + "px");
        }
      } else if (relativeYProcent < relativeXProcent) {
        if (dialogIsRight) {
          pointer.addClass("arrow-left");
          dialogContainer.css("left", dialogContainer.position().left + 10);
        } else {
          pointer.addClass("arrow-right");
          dialogContainer.css("left", dialogContainer.position().left - 10);
        }
        var middleY = ofResolvedOffset.top + ofResolved.height() / 2;
        if (middleY < dialogContainer.offset().top + 10) {
          pointer.css("top", "10px");
        } else if (middleY > dialogContainer.offset().top + maxPointerHeightRange) {
          pointer.css("top", "calc(100% - 30px)");
        } else {
          pointer.css("top", middleY - dialogContainer.offset().top - 10 + "px");
        }
      }
    },
    _openHandler: function _openHandler(pEvent, pData) {
      this.options.events.show(pEvent, pData);
    },
    _closeHandler: function _closeHandler(pEvent, pData) {
      this.options.events.hide.call(this, pEvent, pData);
      this.destroy();
    },
    _beforeHandler: function _beforeHandler() {
      if (this.options.show && this.options.show.solo === true) {
        var dialogs = $(".nixps-DialogTooltip");
        for (var i = 0; i < dialogs.length; i++) {
          dialogs.eq(i).DialogTooltip("destroy");
        }
      }
    },
    hide: function hide() {
      this.destroy();
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      if (this.dialog) {
        this.dialog.DialogWithTitle("destroy");
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"./nixps-common-DialogWithTitle.js":380}],380:[function(require,module,exports){
"use strict";

(function ($) {
  $.widget("nixps.DialogWithTitle", $.ui.dialog, {
    widgetEventPrefix: "dialogwithtitle",
    // Override title so it accepts HTML
    _title: function _title(title) {
      // this method doesn't exist in jquery ui <1.10 so there is no need for a fallback.
      if ($.ui.version.split(".")[0] === "1" && $.ui.version.split(".")[1] >= 10) {
        // Since jquery ui 1.10 it doens't allow html in title. This overrides it.
        if (!this.options.title) {
          title.html("&#160;");
        } else {
          title.html(this.options.title);
        }
      }
    }
  });
})(jQuery);

},{}],381:[function(require,module,exports){
"use strict";

var TouchUtil = require("./TouchUtil.js");
var domWeakMap = new WeakSet();

/**
 * @constructor TouchEventGenerator
 * @description When calling this function, it will generate custom event, usefull for mobile.
 * <ul>
 *  <li>"nixps:longpress" fires when pressing for more then 500 ms and if distance is small then 5 px</li>
 *  <li>"nixps:swipeleft" fires when user does a big swipe to the left</li>
 *  <li>"nixps:swiperight" fires when user does a big swipe to the right</li>
 *  <li>"nixps:swipeup" fires when user does a big swipe to the top</li>
 *  <li>"nixps:swipedown" fires when user does a big swipe to the bottom</li>
 * </ul>
 * @example TouchEventGenerator(window, {}); 
 * window.addEventListener("nixps:longpress", function(){
 *      console.log("a long press has been detected");
 * })
 * @param {JQuery} pDOM The DOM eleme to listen on, if not defined, the window is used
 * @param {Object} pOptions the options 
 */
var TouchEventGenerator = function TouchEventGenerator(pDOM, pOptions) {
  this.alive = true;
  if (pDOM === undefined) {
    this.mDOM = window;
  } else {
    this.mDOM = pDOM;
  }
  if (TouchEventGenerator.isActiveOn(this.mDOM)) {
    throw new Error("Event generator already active on DOM");
  }
  domWeakMap.add(this.mDOM);

  // options 
  this.options = Object.assign({
    thresholdX: "40%",
    thresholdY: "40%"
  }, pOptions || {});
  this.xStart = null;
  this.yStart = null;
  this.xDiff = null;
  this.yDiff = null;
  this.touchStartHandler = this._touchStartHandler.bind(this);
  this.mDOM.addEventListener("touchstart", this.touchStartHandler);
  this.touchMoveHandler = this._touchMoveHandler.bind(this);
  this.mDOM.addEventListener("touchmove", this.touchMoveHandler);
  this.touchEndHandler = this._touchEndHandler.bind(this);
  this.mDOM.addEventListener("touchend", this.touchEndHandler, true);
  this.touchCancelHandler = this._touchCancelHandler.bind(this);
  this.mDOM.addEventListener("touchcancel", this.touchCancelHandler, true);
};

/**
 * @description Check if another TouchEventListener is listening on this part of the DOM
 * @function
 * @name TouchEventGenerator.isActiveOn
 * @param {DOM} pDOM a HTML DOM element
 * @returns {Boolean} true if there is already a listener, false otherwise 
 */
TouchEventGenerator.isActiveOn = function (pDOM) {
  if (domWeakMap.has(window)) {
    return true;
  }
  var elem = pDOM;
  while (elem) {
    if (domWeakMap.has(elem)) {
      return true;
    }
    elem = elem.parentNode;
  }
  return false;
};
TouchEventGenerator.prototype = {
  constructor: constructor,
  _touchStartHandler: function _touchStartHandler(pEvent) {
    this.lastTouchStart = pEvent;
    var startProperties = TouchUtil.getProperties(pEvent);
    this.xDiff = 0;
    this.yDiff = 0;
    this.xStart = startProperties.pageX;
    this.yStart = startProperties.pageY;
  },
  _touchEndHandler: function _touchEndHandler(pEvent) {
    if (this.lastTouchStart !== null) {
      var startProperties = TouchUtil.getProperties(this.lastTouchStart);
      var endProperties = TouchUtil.getProperties(pEvent);
      if (endProperties.identifier === startProperties.identifier) {
        var duration = pEvent.timeStamp - this.lastTouchStart.timeStamp;
        var eventData = {
          duration: duration,
          xDiff: this.xDiff,
          yDiff: this.yDiff,
          fingers: startProperties.fingers,
          touchEndEvent: pEvent
        };
        if (duration > TouchUtil.getConfiguration().longClickTime) {
          var distance = endProperties.pageX - startProperties.pageX + (endProperties.pageY - startProperties.pageY);
          if (Math.abs(distance) <= 5) {
            var longTabEvent = new CustomEvent("nixps:longpress", {
              bubbles: true,
              cancelable: true,
              detail: eventData
            });
            if (pEvent.target.dispatchEvent(longTabEvent) !== false) {}
            this._resetTouch();
            return;
          }
        }
        var eventType = null;
        if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) {
          if (Math.abs(this.xDiff) > this._calculateThreshold(this.options.thresholdX, screen.availWidth)) {
            if (this.xDiff < 0) {
              eventType = "swipeleft";
            } else {
              eventType = "swiperight";
            }
          }
        } else if (Math.abs(this.yDiff) > this._calculateThreshold(this.options.thresholdY, screen.availHeight)) {
          if (this.yDiff < 0) {
            eventType = "swipeup";
          } else {
            eventType = "swipedown";
          }
        }
        if (typeof eventType === "string" && eventType.length > 0) {
          var swipeEvent = new CustomEvent("nixps:" + eventType, {
            bubbles: true,
            cancelable: true,
            detail: eventData
          });
          pEvent.target.dispatchEvent(swipeEvent);
          this._resetTouch();
          return;
        }
      }
    }
    this._resetTouch();
  },
  _touchMoveHandler: function _touchMoveHandler(pEvent) {
    var moveProperties = TouchUtil.getProperties(pEvent);
    // neg > move up    pos > move down
    this.xDiff = moveProperties.pageX - this.xStart;
    this.yDiff = moveProperties.pageY - this.yStart;
  },
  _touchCancelHandler: function _touchCancelHandler(pEvent) {
    this._resetTouch();
  },
  _resetTouch: function _resetTouch() {
    this.lastTouchStart = null;
    this.xDiff = 0;
    this.yDiff = 0;
  },
  _calculateThreshold: function _calculateThreshold(pOptions, pScreenBase) {
    if (typeof pOptions === "number") {
      return pOptions;
    } else if (typeof pOptions === "string") {
      if (pOptions.endsWith("%")) {
        return pScreenBase * (parseFloat(pOptions) / 100);
      }
      return parseFloat(pOptions);
    }
    return NaN;
  },
  destroy: function destroy() {
    this.alive = false;
    this.mDOM.removeEventListener("touchstart", this.touchStartHandler);
    this.mDOM.removeEventListener("touchmove", this.touchMoveHandler);
    this.mDOM.removeEventListener("touchend", this.touchEndHandler, true);
    this.mDOM.removeEventListener("touchcancel", this.touchCancelHandler, true);
    domWeakMap["delete"](this.mDOM);
  }
};
module.exports = TouchEventGenerator;

},{"./TouchUtil.js":382}],382:[function(require,module,exports){
"use strict";

/**
 * @constructor TouchUtil
 * @description Util class for touch events on mobile and touch screen. 
 * Also usefull to normalise evemts
 */
var TouchUtil = {
  /**
   * @description Normalise and retrieve all the data of the event object
   * @function
   * @name TouchUtil.getProperties
   * @param {Object} pEvent 
   * @returns Object containing touch data
   */
  getProperties: function getProperties(pEvent) {
    // default values
    var propterties = {
      pageX: null,
      pageY: null,
      identifier: null,
      radiusX: null,
      radiusY: null,
      fingers: null,
      touches: null,
      changedTouches: null
    };
    if (pEvent.pageX !== undefined) {
      propterties.pageX = pEvent.pageX;
      propterties.pageY = pEvent.pageY;
    }
    // if orig event is present (jquery) use this as base
    if (pEvent.originalEvent !== undefined) {
      if (pEvent.originalEvent.changedTouches !== undefined) {
        propterties.changedTouches = pEvent.originalEvent.changedTouches;
        if (pEvent.originalEvent.changedTouches.length > 0) {
          if (propterties.pageX === null) {
            propterties.pageX = pEvent.originalEvent.changedTouches[0].pageX;
            propterties.pageY = pEvent.originalEvent.changedTouches[0].pageY;
          }
          propterties.identifier = pEvent.originalEvent.changedTouches[0].identifier;
          propterties.radiusX = pEvent.originalEvent.changedTouches[0].radiusX;
          propterties.radiusY = pEvent.originalEvent.changedTouches[0].radiusY;
        }
      }
      if (pEvent.originalEvent.touches !== undefined) {
        propterties.touches = pEvent.originalEvent.touches;
        if (pEvent.originalEvent.touches.length > 0) {
          if (propterties.pageX === null) {
            propterties.pageX = pEvent.originalEvent.touches[0].pageX;
            propterties.pageY = pEvent.originalEvent.touches[0].pageY;
          }
          if (propterties.identifier === null) {
            propterties.identifier = pEvent.originalEvent.touches[0].identifier;
          }
          if (propterties.radiusX === null) {
            propterties.radiusX = pEvent.originalEvent.touches[0].radiusX;
          }
          if (propterties.radiusY === null) {
            propterties.radiusY = pEvent.originalEvent.touches[0].radiusY;
          }
          propterties.fingers = pEvent.originalEvent.touches.length;
        }
      }
    } else {
      // the event come directly without modifications
      if (pEvent.changedTouches !== undefined && pEvent.changedTouches.length > 0) {
        if (propterties.pageX === null) {
          propterties.pageX = pEvent.changedTouches[0].pageX;
          propterties.pageY = pEvent.changedTouches[0].pageY;
        }
        propterties.identifier = pEvent.changedTouches[0].identifier;
        propterties.radiusX = pEvent.changedTouches[0].radiusX;
        propterties.radiusY = pEvent.changedTouches[0].radiusY;
      }
      if (pEvent.touches !== undefined && pEvent.touches.length > 0) {
        if (propterties.pageX === null) {
          propterties.pageX = pEvent.touches[0].pageX;
          propterties.pageY = pEvent.touches[0].pageY;
        }
        if (propterties.identifier === null) {
          propterties.identifier = pEvent.touches[0].identifier;
        }
        if (propterties.radiusX === null) {
          propterties.radiusX = pEvent.touches[0].radiusX;
        }
        if (propterties.radiusY === null) {
          propterties.radiusY = pEvent.touches[0].radiusY;
        }
        if (propterties.fingers === null) {
          propterties.fingers = pEvent.touches.length;
        }
      }
      if (propterties.touches === null && pEvent.touches !== undefined) {
        propterties.touches = pEvent.touches;
      }
      if (propterties.changedTouches === null && pEvent.changedTouches !== undefined) {
        propterties.changedTouches = pEvent.changedTouches;
      }
    }
    return propterties;
  },
  /**
   * @description Claculate the rotation change of the fingers in degrees
   * @function
   * @name TouchUtil.getRotation
   * @param {Array<Touches>} pPointersStart 
   * @param {Array<Touches>} pPointesEnd 
   * @returns The rotation change in degrees of the change
   */
  getRotation: function getRotation(pPointersStart, pPointesEnd) {
    return getAngle(pPointesEnd[1], pPointesEnd[0]) + getAngle(pPointersStart[1], pPointersStart[0]);
  },
  /**
   * @description Get the scale of two fingers change
   * @function
   * @name TouchUtil.getScale
   * @param {Array<Touches>} pPointersStart 
   * @param {Array<Touches>} pPointesEnd 
   * @returns number less one for zoum out, bigger then one for zoom in
   */
  getScale: function getScale(pPointersStart, pPointesEnd) {
    return getDistance(pPointesEnd[0], pPointesEnd[1]) / getDistance(pPointersStart[0], pPointersStart[1]);
  },
  /**
   * @description Calculate the center of all touches
   * @function
   * @name TouchUtil.getCenter
   * @param {Array<Touches>} pPointers Array of touches
   * @returns x and y coordinates of the center off all touches   
   */
  getCenter: function getCenter(pPointers) {
    var pointersLength = pPointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
      return {
        x: pPointers[0].pageX,
        y: pPointers[0].pageY
      };
    }
    var x = 0,
      y = 0,
      i = 0;
    while (i < pointersLength) {
      x += pPointers[i].pageX;
      y += pPointers[i].pageY;
      i++;
    }
    return {
      x: Math.round(x / pointersLength),
      y: Math.round(y / pointersLength)
    };
  },
  getConfiguration: function getConfiguration() {
    return {
      longClickTime: 500
    };
  },
  /**
   * @description Send a haptic feedback, mostly a vibration for a period of 45 miliseconds
   * @function
   * @name TouchUtil.getCenter 
   */
  sendHapticFeedback: function sendHapticFeedback() {
    if ("vibrate" in navigator) {
      navigator.vibrate(45);
    }
  }
};
function getDistance(p1, p2) {
  var x = p2.pageX - p1.pageX,
    y = p2.pageY - p1.pageY;
  return Math.sqrt(x * x + y * y);
}
function getAngle(p1, p2) {
  var x = p2.pageX - p1.pageX,
    y = p2.pageY - p1.pageY;
  return Math.atan2(y, x) * 180 / Math.PI;
}
module.exports = TouchUtil;

},{}],383:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true, newcap: true*/
/*globals $, _, jsPlumb, console, api_sync, QuantumBlueCollar, namespace, nixps, jQuery */

(function ($) {
  var elementList = $('<ul>').css({
    'list-style-type': 'none',
    'list-style-image': 'none',
    'padding-left': 15
  });
  $.widget("nixps.TreeView", $.Widget, {
    options: {
      /** 
       * @brief json that represents the variable
       */
      root: {
        children: []
      },
      /**
       * @brief the way to render the node
       */
      renderNode: function renderNode(node) {
        return $('<div>');
      }
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._on(this.element, {
        "click .treeview_title": this._handleOpenCloseHandler,
        "click .icon": this._handleOpenCloseHandler
      });
      this._draw();
    },
    _draw: function _draw() {
      this.element.empty();
      var list = elementList.clone().css({
        'padding-left': 0
      }).appendTo(this.element);
      var rootNode = this._createNode(this.options.root);
      list.append(rootNode);
      var root = this.options.root;
      if (root.leaf === false && root.expanded === true) {
        this._expandNode(rootNode);
      }
    },
    redraw: function redraw() {
      this._draw();
    },
    _handleOpenCloseHandler: function _handleOpenCloseHandler(event) {
      var target = $(event.target),
        parent = target.closest('.treeNode'),
        node = parent.data('node'),
        title = parent.children('.treeview_title'),
        icon = parent.children('.icon');
      if ($.isPlainObject(node) === false || node.leaf === true) {
        return;
      }
      if (node.expanded === true) {
        node.expanded = false;
        icon.removeClass('open fa-caret-down');
        icon.addClass('fa-caret-right');
        parent.children('ul').hide();
      } else {
        node.expanded = true;
        this._expandNode(parent);
      }
    },
    _expandNode: function _expandNode(parentElement) {
      var list = parentElement.children('ul'),
        icon = parentElement.children('.icon');
      icon.removeClass('fa-caret-right');
      icon.addClass('fa-caret-down open');
      if (list.children().length > 0) {
        list.show();
        return;
      }
      var children = parentElement.data('node').children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i],
          node = this._createNode(children[i]);
        list.append(node);
        if (child.expanded === true) {
          this._expandNode(node);
        }
      }
    },
    _createNode: function _createNode(node) {
      var renderNode = this.options.renderNode,
        leafNode = node.leaf === true;
      if (leafNode === true) {
        return $('<li>').data('node', node).addClass('treeNode').append(renderNode(node));
      }
      return $('<li>').data('node', node).addClass('treeNode').css({
        'white-space': 'nowrap'
      }).append($('<span>').css({
        'margin-right': 5,
        'display': 'inline-block',
        'width': 10
      }).addClass('icon fa fa-caret-right collapsicon')).append(renderNode(node).addClass('treeview_title')).append(elementList.clone());
    },
    _setOption: function _setOption(key, value) {
      if (key === "root") {
        this._super(key, value);
        this._draw();
      }
    }
  });
})(jQuery);

},{}],384:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on May 7, 2018 3:39:55 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var Consent = require("../../../cloudflow/Consent/js/Consent.js");

  /**
   * @namespace nixps.TwitterTimeline
   * @description Draw a twitter timeline
   * @example $('<div>').TwitterTimeline({});
   */
  $.widget("nixps.TwitterTimeLine", $.Widget, {
    version: "1.0.0",
    options: {
      /**
       * @name nixps.TwitterTimeLine#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps.TwitterTimeLine#width
       * @description The width of the component
       * @type {Number}
       * @default 300
       */
      width: 300,
      /**
       * @name nixps.TwitterTimeLine#height
       * @description The height of the component
       * @type {Number}
       * @default 300
       */
      height: 300,
      /**
       * @name nixps.TwitterTimeLine#url
       * @description The url of the twitter
       * @type {Number}
       * @default 300
       */
      url: "",
      /**
       * @name nixps.TwitterTimeLine#urlText
       * @description The text to be visible when it doesn't load
       * @type {String}
       * @default "X (Twitter) Feed"
       */
      urlText: "X (Twitter) Feed",
      /**
       * @name nixps.TwitterTimeLine#created
       * @description function runw when all twitters are loaded
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.CloudflowToggle#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      var that = this;
      this.consent = null;
      this.consentDef = Consent.get().then(function (pConsent) {
        that.consent = pConsent;
        that._changeConsentProxy = that._changeConsent.bind(that);
        that.consent.registerChangeCallBack(that._changeConsentProxy);
      });
      this._draw();
      this._on(this.element, {
        "click .twitter-accept-consent": this._acceptConsentClickHandler
      });
    },
    /**
     * @description function runs when user accept the youtube consent
     * @function
     * @private
     * @name nixps.WatchYoutube#_acceptConsentClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _acceptConsentClickHandler: function _acceptConsentClickHandler(pEvent, pData) {
      this.consent.accept3rdParty("twitter");
    },
    _changeConsent: function _changeConsent(pChangeData) {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.CloudflowToggle#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      var options = this.options;
      this.element.empty().css({
        'width': options.width,
        'height': options.height,
        'overflow': 'hidden',
        'box-sizing': 'content-box'
      });
      $.when(this.consentDef).then(function () {
        if (that.consent.is3rdPartyAllowed("twitter")) {
          var link = "<a class='twitter-timeline' data-dnt='true' data-chrome='nofooter' href='" + options.url + "' data-lang='" + options.language + "' data-width=" + options.width + " data-height=" + options.height + ">" + options.urlText + "</a>";
          var html = "<div>" + link + "<script async src='https://platform.twitter.com/widgets.js' charset='utf-8'></script></div><style>html{overflow:hidden !important;}body{margin:0;}</style>";
          var iframe = $('<iframe>').css("border", "none");
          // check if 'srcdoc' is supported
          if ("srcdoc" in document.createElement("iframe") === true) {
            iframe.attr({
              'width': options.width,
              'height': options.height,
              'sandbox': 'allow-scripts allow-same-origin',
              'srcdoc': html
            });
          } else {
            // try fallback
            iframe.attr({
              'width': options.width,
              'height': options.height,
              'sandbox': 'allow-scripts allow-same-origin',
              'src': "javascript: '" + html + "'"
            });
          }
          that.element.append(iframe);
          iframe.one("load", function () {
            var contentWindow = $(this)[0].contentWindow;
            if (contentWindow.twttr === undefined) {
              contentWindow.twttr = {
                _e: []
              };
              contentWindow.twttr.ready = function (f) {
                contentWindow.twttr._e.push(f);
              };
            }
            contentWindow.twttr.ready(function (f) {
              contentWindow.twttr.events.bind('loaded', function (pData) {});
              contentWindow.twttr.events.bind('rendered', function (event) {
                that.options.created();
              });
              contentWindow.twttr.events.bind('error', function (event) {
                that.options.created();
              });
            });
          });
          iframe.one("error", function () {
            that.options.created();
          });
        } else {
          var blockContentPanel = $("<div>").addClass("cf-blockcontent");
          that.element.append(blockContentPanel);
          blockContentPanel.append($('<center>')._t("nixps-cloudflow-consentdialog.explaintext_3rdparty_ask_accept", ["X (Twitter)"]).append("<br >").append($('<button>')._t("nixps-cloudflow-consentdialog.accept_specific", ["X (Twitter)"]).addClass("cf-button-main twitter-accept-consent").attr("type", "button")));
          that.options.created();
        }
      });
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.CloudflowToggle#_setOption
     */
    _setOptions: function _setOptions(pOptions) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.CloudflowToggle#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("input option language must be a not empty string");
      }
      if (typeof this.options.height !== "number" || this.options.height <= 0) {
        throw new Error("input option height must be positive an number");
      }
      if (typeof this.options.width !== "number" || this.options.width <= 0) {
        throw new Error("input option width must be positive an number");
      }
    },
    _destroy: function _destroy() {
      this._superApply(arguments);
      if (this.consent !== null && this._changeConsentProxy !== undefined) {
        this.consent.unregisterChangeCallBack(this._changeConsentProxy);
      }
    }
  });
})(jQuery);

},{"../../../cloudflow/Consent/js/Consent.js":96}],385:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by szymon on 30-aug-2021 14:59:59
 */
(function ($) {
  var CloudflowURL = require("../../../cloudflow/CloudflowUtil/js/CloudflowURL.js");
  var kCssLeft = Object.freeze({
    "float": "left"
  });
  var kCssRight = Object.freeze({
    "float": "right"
  });
  var kCssCenter = Object.freeze({
    display: "block",
    "margin-left": "auto",
    "margin-right": "auto"
  });

  /**
   * @namespace nixps.WatchVideo
   * @description A video player.
   * @example $("<div>").WatchVideo({
   *      "videoUrl": "http://localhost:9090/portal.cgi/PP_FILE_STORE/sample-5s.mp4"
   * });
   * @version 1.1.0
   */
  $.widget("nixps.WatchVideo", $.Widget, {
    version: "1.1.0",
    options: {
      /**
       * @description The language of the user
       * @name nixps.WatchVideo#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @description The width of the video in pixels
       * @name nixps.WatchVideo#width
       * @type {Number}
       * @default 640
       */
      width: 640,
      /**
       * @description The height of the video in pixels
       * @name nixps.WatchVideo#height
       * @type {Number}
       * @default 360
       */
      height: 360,
      /**
       * @description The float of the video. With this you can put the video left, right or centered in his container.
       * The only possible values are: "left", "center", "right"
       * @name nixps.WatchVideo#float
       * @type {String}
       * @example "left" 
       * @default null
       * @since 1.1.0
       */
      "float": "",
      /**
       * @description The URL of the video you want to see.
       * @name nixps.WatchVideo#videoUrl
       * @type {String}
       * @default ""
       */
      videoUrl: "",
      /**
       * @description A list of tracks
       * @name nixps.WatchVideo#tracs
       * @type {Array.<Object>}
       * @default []
       */
      tracks: [],
      /**
       * @description The relative path of the video you want to see.
       * @name nixps.WatchVideo#relativeBasePath
       * @type {String}
       * @default ""
       */
      relativeBasePath: "",
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.WatchVideo#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._addClass(this.widgetFullName);
      this._draw();
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.WatchVideo#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Parses a dimension string into correct css value
     * @function
     * @private
     * @name nixps.WatchVideo#_parseDimension
     * @param {String} pEvent 
     * @return {String} 
     */
    _parseDimension: function _parseDimension(str) {
      if (!str || str === "0" || str === "0px") {
        return "100%";
      }
      if (!isNaN(str) && !isNaN(parseFloat(str))) {
        return str + "px";
      }
      return str;
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.WatchVideo#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      this.element.empty();
      var url;
      var video;
      if (!this.options.videoUrl) {
        var dummy = $("<div>").css("height", this._parseDimension(that.options.height)).css("width", this._parseDimension(that.options.width)).addClass("nixps-watchvideo-dummy");
        var message = $("<div>");
        dummy.append($("<span>").addClass("fa fa-video-camera nixps-watchvideo-dummy_icon"));
        this.element.append(dummy);
        this.options.created();
      } else {
        url = new CloudflowURL(this.options.relativeBasePath, this.options.videoUrl, true).getUploadPath();
        video = $("<video>").prop({
          "controls": true
        }).attr({
          "src": url,
          "controls": true
        }).append("Video playback is not supported");
        video.css("height", this._parseDimension(that.options.height)).css("width", this._parseDimension(that.options.width)).addClass("nixps-watchvideo-video");
        if (that.options["float"] === "right") {
          video.css(kCssRight);
        } else if (that.options["float"] === "left") {
          video.css(kCssLeft);
        } else if (that.options["float"] === "center") {
          video.css(kCssCenter);
        }
        // add tracks
        if (Array.isArray(this.options.tracks) && this.options.tracks.length > 0) {
          var trackDOMs = [],
            trackURL = undefined,
            trackDOM = undefined;
          for (var t = 0; t < this.options.tracks.length; t++) {
            if (typeof this.options.tracks[t].src === "string" && this.options.tracks[t].src.length > 0) {
              trackURL = new CloudflowURL(this.options.relativeBasePath, this.options.tracks[t].src, true).getUploadPath();
              trackDOM = $("<track>").attr({
                src: trackURL,
                srclang: typeof this.options.tracks[t].srclang === "string" && this.options.tracks[t].srclang.length >= 2 ? this.options.tracks[t].srclang : null,
                label: typeof this.options.tracks[t].label === "string" ? this.options.tracks[t].label : null,
                kind: typeof this.options.tracks[t].kind === "string" ? this.options.tracks[t].kind : null
              });
              if (this.options.tracks[t]["default"] === true) {
                trackDOM.prop("default", true);
              }
              trackDOMs.push(trackDOM);
            }
          }
          video.append(trackDOMs);
        }
        this.element.append(video);
        video.one("canplay", function () {
          that.options.created();
        });
        video.one("error", function (pEvent) {
          console.error("error during playing video", pEvent);
          that.options.created();
        });
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.WatchVideo#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.WatchVideo#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("WatchVideo: input option language must be a not empty string");
      }
      if (typeof this.options.videoUrl !== "string" || this.options.language.length <= 0) {
        throw new Error("WatchVideo: input option videoUrl must be a not empty string");
      }
      if (Array.isArray(this.options.tracks) === false) {
        throw new Error("WatchVideo: input option tracks must be an array");
      }
      if (typeof this.options["float"] !== "string") {
        throw new Error("WatchVideo: input option float must be a string");
      }
    },
    _destroy: function _destroy() {
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../cloudflow/CloudflowUtil/js/CloudflowURL.js":80}],386:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 2-nov-2018 10:28:49
 */
(function ($) {
  var Consent = require("../../../cloudflow/Consent/js/Consent.js");
  var kCssLeft = Object.freeze({
    "float": "left"
  });
  var kCssRight = Object.freeze({
    "float": "right"
  });
  var kCssCenter = Object.freeze({
    display: "block",
    "margin-left": "auto",
    "margin-right": "auto"
  });
  var isAdded = false;
  function _initYoutubeAPI() {
    if (isAdded === false) {
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      isAdded = true;
    }
  }
  window.onYouTubePlayerAPIReady = function () {
    //debugger;
  };

  /**
   * @namespace nixps.WatchYoutube
   * @description A YouTube video player.
   * By embedding YouTube videos on your site, you are agreeing to <a href="https://developers.google.com/youtube/terms/api-services-terms-of-service">YouTube API Terms of Service </a>
   * @example $("<div>").WatchYoutube({
   *      "videoID": "CrzfVEwtDDs"
   * });
   * @version "1.1.0"
   */
  $.widget("nixps.WatchYoutube", $.Widget, {
    version: "1.1.0",
    options: {
      /**
       * @description The language of the user
       * @name nixps.WatchYoutube#language
       * @type {String}
       * @default "en
       */
      language: "en",
      /**
       * @description The width of the video in pixels
       * @name nixps.WatchYoutube#width
       * @type {Number}
       * @default 640
       */
      width: 640,
      /**
       * @description The height of the video in pixels
       * @name nixps.WatchYoutube#height
       * @type {Number}
       * @default 360
       */
      height: 360,
      /**
       * @description The ID of the video you want to see. This is provided by YoutTube itself
       * @name nixps.WatchYoutube#videoID
       * @type {String}
       * @default ""
       */
      videoID: "",
      /**
       * @description The title to be added for accessibility on the iframe
       * @name nixps.WatchYoutube#title
       * @type {String}
       * @default undefined
       */
      title: undefined,
      /**
       * @description The float of the video. With this you can put the video left, right or centered in his container.
       * The only possible values are: "left", "center", "right"
       * @name nixps.WatchYoutube#float
       * @type {String}
       * @example "left" 
       * @default null
       * @since 1.1.0
       */
      "float": "",
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.WatchYoutube#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      var that = this;
      this.consent = null;
      this.consentDef = Consent.get().then(function (pConsent) {
        that.consent = pConsent;
        that._changeConsentProxy = that._changeConsent.bind(that);
        that.consent.registerChangeCallBack(that._changeConsentProxy);
      });
      $.when(this._draw()).always(function () {
        that.options.created();
      });
      this._on(this.element, {
        "click .cf-blockcontent .youtube-accept-consent": this._acceptConsentClickHandler
      });

      //_initYoutubeAPI();
    },

    /**
     * @description function runs when user accept the youtube consent
     * @function
     * @private
     * @name nixps.WatchYoutube#_acceptConsentClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _acceptConsentClickHandler: function _acceptConsentClickHandler(pEvent, pData) {
      this.consent.accept3rdParty("youtube");
    },
    _changeConsent: function _changeConsent() {
      if (this.consent.is3rdPartyAllowed("youtube")) {
        if (this.element.children(".cf-blockcontent").length > 0) {
          this._draw();
        }
      } else {
        if (this.element.children(".cf-blockcontent").length === 0) {
          this._draw();
        }
      }
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps.WatchYoutube#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps.WatchYoutube#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      this.element.css({
        "height": this.options.height,
        "width": this.options.width
      });
      return $.when(this.consentDef).then(function () {
        if (that.consent.is3rdPartyAllowed("youtube")) {
          that.element.empty();
          var videoID = that.options.videoID;
          if (that.options.videoID.indexOf("https://www.youtube.com/live/") === 0 && that.options.videoID.endsWith("?feature=shared")) {
            videoID = that.options.videoID.replace(/$https[:]\/\/www[.]youtube[.]com\/live\/([^?]+)[?]feature=shared^/, "$1");
          } else if (that.options.videoID.indexOf("https://www.youtube.com/embed/") === 0) {
            videoID = that.options.videoID.replace(/$https[:]\/\/www[.]youtube[.]com\/embed\/([^?]+)[?]*.*^/, "$1");
          }
          // some parameters can be found on https://developers.google.com/youtube/player_parameters?csw=1#origin
          var url = "https://www.youtube-nocookie.com/embed/" + videoID + "?cc_lang_pref=" + that.options.language + "&hl=" + that.options.language;
          url += "&autoplay=0";
          url += "&color=red";
          url += "&controls=1";
          url += "&fs=1"; // full screen
          url += "&iv_load_policy=3"; // no video annotations
          url += "&modestbranding=1"; // not showing mode brand
          url += "&rel=0"; // decrede showing relative other videos
          url += "&enablejsapi=1";
          var iframe = $("<iframe>").attr({
            "type": "text/html",
            "frameborder": 0,
            "src": url,
            "height": that.options.height,
            "width": that.options.width,
            "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
            "allowfullscreen": "",
            "title": typeof that.options.title === "string" ? that.options.title : null
          });
          if (that.options["float"] === "right") {
            iframe.css(kCssRight);
          } else if (that.options["float"] === "left") {
            iframe.css(kCssLeft);
          } else if (that.options["float"] === "center") {
            iframe.css(kCssCenter);
          }
          that.element.append(iframe);
        } else {
          that.element.empty();
          var blockContentPanel = $("<div>").addClass("cf-blockcontent").css({
            "height": that.options.height,
            "width": that.options.width
          });
          if (that.options["float"] === "right") {
            blockContentPanel.css(kCssRight);
          } else if (that.options["float"] === "left") {
            blockContentPanel.css(kCssLeft);
          } else if (that.options["float"] === "center") {
            blockContentPanel.css(kCssCenter);
          }
          that.element.append(blockContentPanel);
          blockContentPanel.append($("<center>")._t("nixps-cloudflow-consentdialog.explaintext_3rdparty_ask_accept", ["YouTube"]).append($("<button>").addClass("cf-button-main youtube-accept-consent").attr("type", "button").text($.i18n._("nixps-cloudflow-consentdialog.accept_specific", ["YouTube"]))));
        }
        that.element.css("height", "").css("width", "");
      });
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps.WatchYoutube#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps.WatchYoutube#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.videoID !== "string" || this.options.videoID.length <= 0) {
        throw new Error("WatchYoutube: input option videoID must be a not empty string");
      }
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("WatchYoutube: input option language must be a not empty string");
      }
      if (parseInt(this.options.width) < 200) {
        throw new Error("WatchYoutube: input option width must be higher than 200");
      }
      if (parseInt(this.options.height) < 200) {
        throw new Error("WatchYoutube: input option height must be higher than 200");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
      if (this.consent !== null && this._changeConsentProxy !== undefined) {
        this.consent.unregisterChangeCallBack(this._changeConsentProxy);
      }
    }
  });
})(jQuery);

},{"../../../cloudflow/Consent/js/Consent.js":96}],387:[function(require,module,exports){
"use strict";

var operatorFromBuilderToServer = function operatorFromBuilderToServer(pOperator) {
  switch (pOperator) {
    case 'equal':
      return 'equal to';
    case 'not_equal':
      return 'not equal to';
    case 'contains':
      return 'contains';
    case 'begins_with':
      return 'begins with';
    case 'ends_with':
      return 'ends with';
    case 'is_like':
      return 'is like';
    case 'contains_text_like':
      return 'contains text like';
    case 'begins_like':
      return 'begins like';
    case 'ends_like':
      return 'ends like';
    case 'exists':
      return 'exists';
    case 'does_not_exists':
      return 'does not exist';
    case 'less':
      return 'less than';
    case 'less_or_equal':
      return 'less than or equal to';
    case 'greater':
      return 'greater than';
    case 'greater_or_equal':
      return 'greater than or equal to';
    case 'in':
      return 'in';
    case 'today_unix':
    case 'yesterday_unix':
    case 'last_7_days_unix':
    case 'last_month_unix':
    case 'today_iso':
    case 'yesterday_iso':
    case 'last_7_days_iso':
    case 'last_month_iso':
      return 'greater than or equal to';
  }
};
module.exports = operatorFromBuilderToServer;

},{}],388:[function(require,module,exports){
"use strict";

(function ($) {
  /**
   * @description Add a translated tooltip on the current element
   * @function
   * @param {String} pTranslationToolTip the translation key
   * @name $.fn._tooltip
   */
  $.fn._tooltip = function (pTranslationToolTip) {
    return $(this).attr("title", $.i18n._(pTranslationToolTip));
  };

  /**
   * @description Remove all classes from a component
   * @function
   * @name $.fn.removeAllClasses
   */
  $.fn.removeAllClasses = function () {
    // use function in removeClass methode because there is a conflict between jquery 1.11 and jQuery-ui-1.9.2 and
    // the use of removing all elements by removeClass() is not bugging. So use a function and it should work for multiple jQuery plugins
    return $(this).removeClass(function (pI, pClassName) {
      return pClassName;
    });
  };

  /**
   * @description A toggle function that works
   * @function
   * @name $.fn.cfToggle
   */
  $.fn.cfToggle = function () {
    return $(this).each(function () {
      if ($(this).css("display") === "none") {
        $(this).css("display", "");
      } else {
        $(this).hide();
      }
    });
  };

  /**
   * @description define if the texts overflows or not
   * @function
   * @name $.fn.cfHasOverflow
   * @returns true if the content overflows
   */
  $.fn.cfHasOverflow = function () {
    return $(this).first()[0].scrollWidth > $(this).first().width();
  };
})(jQuery);

},{}],389:[function(require,module,exports){
"use strict";

/**
 * @brief creates a namespace or extends an existing namespace
 * @argument a dot separated string eg 'com.nixps.layout' -> window.com.nixps.layout
 * @return the created namespace, eg window.com.nixps.layout
 * @deprecated Create the parents objects youself, do not rely on an extra plugin
 */
window.namespace = function () {
  var a = arguments,
    o = window,
    i = 0,
    j = 0,
    tok = null,
    name = null;

  // iterate on the arguments   
  for (i = 0; i < a.length; i = i + 1) {
    tok = a[i].split(".");

    // iterate on the object tokens   
    for (j = 0; j < tok.length; j = j + 1) {
      name = tok[j];
      o[name] = o[name] || {};
      o = o[name];
    }
  }
  return o;
};

},{}],390:[function(require,module,exports){
"use strict";

/**
 * @author Phil Teare
 * using wikipedia data
 */

(function () {
  if (window.nixps === undefined) {
    window.nixps = {};
  }
  if (nixps.common === undefined) {
    nixps.common = {};
  }
  nixps.common.isoLangs = {
    "ab": {
      "name": "Abkhaz",
      "nativeName": "аҧсуа"
    },
    "aa": {
      "name": "Afar",
      "nativeName": "Afaraf"
    },
    "af": {
      "name": "Afrikaans",
      "nativeName": "Afrikaans"
    },
    "ak": {
      "name": "Akan",
      "nativeName": "Akan"
    },
    "sq": {
      "name": "Albanian",
      "nativeName": "Shqip"
    },
    "am": {
      "name": "Amharic",
      "nativeName": "አማርኛ"
    },
    "ar": {
      "name": "Arabic",
      "nativeName": "العربية"
    },
    "an": {
      "name": "Aragonese",
      "nativeName": "Aragonés"
    },
    "hy": {
      "name": "Armenian",
      "nativeName": "Հայերեն"
    },
    "as": {
      "name": "Assamese",
      "nativeName": "অসমীয়া"
    },
    "av": {
      "name": "Avaric",
      "nativeName": "авар мацӀ, магӀарул мацӀ"
    },
    "ae": {
      "name": "Avestan",
      "nativeName": "avesta"
    },
    "ay": {
      "name": "Aymara",
      "nativeName": "aymar aru"
    },
    "az": {
      "name": "Azerbaijani",
      "nativeName": "azərbaycan dili"
    },
    "bm": {
      "name": "Bambara",
      "nativeName": "bamanankan"
    },
    "ba": {
      "name": "Bashkir",
      "nativeName": "башҡорт теле"
    },
    "eu": {
      "name": "Basque",
      "nativeName": "euskara, euskera"
    },
    "be": {
      "name": "Belarusian",
      "nativeName": "Беларуская"
    },
    "bn": {
      "name": "Bengali",
      "nativeName": "বাংলা"
    },
    "bh": {
      "name": "Bihari",
      "nativeName": "भोजपुरी"
    },
    "bi": {
      "name": "Bislama",
      "nativeName": "Bislama"
    },
    "bs": {
      "name": "Bosnian",
      "nativeName": "bosanski jezik"
    },
    "br": {
      "name": "Breton",
      "nativeName": "brezhoneg"
    },
    "bg": {
      "name": "Bulgarian",
      "nativeName": "български език"
    },
    "my": {
      "name": "Burmese",
      "nativeName": "ဗမာစာ"
    },
    "ca": {
      "name": "Catalan; Valencian",
      "nativeName": "Català"
    },
    "ch": {
      "name": "Chamorro",
      "nativeName": "Chamoru"
    },
    "ce": {
      "name": "Chechen",
      "nativeName": "нохчийн мотт"
    },
    "ny": {
      "name": "Chichewa",
      "nativeName": "chiCheŵa, chinyanja"
    },
    "zh": {
      "name": "Chinese",
      "nativeName": "中文 (Zhōngwén), 汉语, 漢語"
    },
    "cv": {
      "name": "Chuvash",
      "nativeName": "чӑваш чӗлхи"
    },
    "kw": {
      "name": "Cornish",
      "nativeName": "Kernewek"
    },
    "co": {
      "name": "Corsican",
      "nativeName": "corsu, lingua corsa"
    },
    "cr": {
      "name": "Cree",
      "nativeName": "ᓀᐦᐃᔭᐍᐏᐣ"
    },
    "hr": {
      "name": "Croatian",
      "nativeName": "hrvatski"
    },
    "cs": {
      "name": "Czech",
      "nativeName": "česky, čeština"
    },
    "da": {
      "name": "Danish",
      "nativeName": "dansk"
    },
    "dv": {
      "name": "Divehi",
      "nativeName": "ދިވެހި"
    },
    "nl": {
      "name": "Dutch",
      "nativeName": "Nederlands, Vlaams"
    },
    "en": {
      "name": "English",
      "nativeName": "English"
    },
    "eo": {
      "name": "Esperanto",
      "nativeName": "Esperanto"
    },
    "et": {
      "name": "Estonian",
      "nativeName": "eesti, eesti keel"
    },
    "ee": {
      "name": "Ewe",
      "nativeName": "Eʋegbe"
    },
    "fo": {
      "name": "Faroese",
      "nativeName": "føroyskt"
    },
    "fj": {
      "name": "Fijian",
      "nativeName": "vosa Vakaviti"
    },
    "fi": {
      "name": "Finnish",
      "nativeName": "suomi, suomen kieli"
    },
    "fr": {
      "name": "French",
      "nativeName": "français, langue française"
    },
    "ff": {
      "name": "Fula",
      "nativeName": "Fulfulde, Pulaar, Pular"
    },
    "gl": {
      "name": "Galician",
      "nativeName": "Galego"
    },
    "ka": {
      "name": "Georgian",
      "nativeName": "ქართული"
    },
    "de": {
      "name": "German",
      "nativeName": "Deutsch"
    },
    "el": {
      "name": "Greek, Modern",
      "nativeName": "Ελληνικά"
    },
    "gn": {
      "name": "Guaraní",
      "nativeName": "Avañeẽ"
    },
    "gu": {
      "name": "Gujarati",
      "nativeName": "ગુજરાતી"
    },
    "ht": {
      "name": "Haitian",
      "nativeName": "Kreyòl ayisyen"
    },
    "ha": {
      "name": "Hausa",
      "nativeName": "Hausa, هَوُسَ"
    },
    "he": {
      "name": "Hebrew (modern)",
      "nativeName": "עברית"
    },
    "hz": {
      "name": "Herero",
      "nativeName": "Otjiherero"
    },
    "hi": {
      "name": "Hindi",
      "nativeName": "हिन्दी, हिंदी"
    },
    "ho": {
      "name": "Hiri Motu",
      "nativeName": "Hiri Motu"
    },
    "hu": {
      "name": "Hungarian",
      "nativeName": "Magyar"
    },
    "ia": {
      "name": "Interlingua",
      "nativeName": "Interlingua"
    },
    "id": {
      "name": "Indonesian",
      "nativeName": "Bahasa Indonesia"
    },
    "ie": {
      "name": "Interlingue",
      "nativeName": "Originally called Occidental; then Interlingue after WWII"
    },
    "ga": {
      "name": "Irish",
      "nativeName": "Gaeilge"
    },
    "ig": {
      "name": "Igbo",
      "nativeName": "Asụsụ Igbo"
    },
    "ik": {
      "name": "Inupiaq",
      "nativeName": "Iñupiaq, Iñupiatun"
    },
    "io": {
      "name": "Ido",
      "nativeName": "Ido"
    },
    "is": {
      "name": "Icelandic",
      "nativeName": "Íslenska"
    },
    "it": {
      "name": "Italian",
      "nativeName": "Italiano"
    },
    "iu": {
      "name": "Inuktitut",
      "nativeName": "ᐃᓄᒃᑎᑐᑦ"
    },
    "ja": {
      "name": "Japanese",
      "nativeName": "日本語 (にほんご／にっぽんご)"
    },
    "jv": {
      "name": "Javanese",
      "nativeName": "basa Jawa"
    },
    "kl": {
      "name": "Kalaallisut",
      "nativeName": "kalaallisut, kalaallit oqaasii"
    },
    "kn": {
      "name": "Kannada",
      "nativeName": "ಕನ್ನಡ"
    },
    "kr": {
      "name": "Kanuri",
      "nativeName": "Kanuri"
    },
    "ks": {
      "name": "Kashmiri",
      "nativeName": "कश्मीरी, كشميري‎"
    },
    "kk": {
      "name": "Kazakh",
      "nativeName": "Қазақ тілі"
    },
    "km": {
      "name": "Khmer",
      "nativeName": "ភាសាខ្មែរ"
    },
    "ki": {
      "name": "Gikuyu",
      "nativeName": "Gĩkũyũ"
    },
    "rw": {
      "name": "Kinyarwanda",
      "nativeName": "Ikinyarwanda"
    },
    "ky": {
      "name": "Kirghiz",
      "nativeName": "кыргыз тили"
    },
    "kv": {
      "name": "Komi",
      "nativeName": "коми кыв"
    },
    "kg": {
      "name": "Kongo",
      "nativeName": "KiKongo"
    },
    "ko": {
      "name": "Korean",
      "nativeName": "한국어 (韓國語), 조선말 (朝鮮語)"
    },
    "ku": {
      "name": "Kurdish",
      "nativeName": "Kurdî, كوردی‎"
    },
    "kj": {
      "name": "Kuanyama",
      "nativeName": "Kuanyama"
    },
    "la": {
      "name": "Latin",
      "nativeName": "latine, lingua latina"
    },
    "lb": {
      "name": "Luxembourgish",
      "nativeName": "Lëtzebuergesch"
    },
    "lg": {
      "name": "Luganda",
      "nativeName": "Luganda"
    },
    "li": {
      "name": "Limburgish",
      "nativeName": "Limburgs"
    },
    "ln": {
      "name": "Lingala",
      "nativeName": "Lingála"
    },
    "lo": {
      "name": "Lao",
      "nativeName": "ພາສາລາວ"
    },
    "lt": {
      "name": "Lithuanian",
      "nativeName": "lietuvių kalba"
    },
    "lu": {
      "name": "Luba-Katanga",
      "nativeName": ""
    },
    "lv": {
      "name": "Latvian",
      "nativeName": "latviešu valoda"
    },
    "gv": {
      "name": "Manx",
      "nativeName": "Gaelg, Gailck"
    },
    "mk": {
      "name": "Macedonian",
      "nativeName": "македонски јазик"
    },
    "mg": {
      "name": "Malagasy",
      "nativeName": "Malagasy fiteny"
    },
    "ms": {
      "name": "Malay",
      "nativeName": "bahasa Melayu, بهاس ملايو‎"
    },
    "ml": {
      "name": "Malayalam",
      "nativeName": "മലയാളം"
    },
    "mt": {
      "name": "Maltese",
      "nativeName": "Malti"
    },
    "mi": {
      "name": "Māori",
      "nativeName": "te reo Māori"
    },
    "mr": {
      "name": "Marathi (Marāṭhī)",
      "nativeName": "मराठी"
    },
    "mh": {
      "name": "Marshallese",
      "nativeName": "Kajin M̧ajeļ"
    },
    "mn": {
      "name": "Mongolian",
      "nativeName": "монгол"
    },
    "na": {
      "name": "Nauru",
      "nativeName": "Ekakairũ Naoero"
    },
    "nv": {
      "name": "Navajo",
      "nativeName": "Diné bizaad, Dinékʼehǰí"
    },
    "nb": {
      "name": "Norwegian Bokmål",
      "nativeName": "Norsk bokmål"
    },
    "nd": {
      "name": "North Ndebele",
      "nativeName": "isiNdebele"
    },
    "ne": {
      "name": "Nepali",
      "nativeName": "नेपाली"
    },
    "ng": {
      "name": "Ndonga",
      "nativeName": "Owambo"
    },
    "nn": {
      "name": "Norwegian Nynorsk",
      "nativeName": "Norsk nynorsk"
    },
    "no": {
      "name": "Norwegian",
      "nativeName": "Norsk"
    },
    "ii": {
      "name": "Nuosu",
      "nativeName": "ꆈꌠ꒿ Nuosuhxop"
    },
    "nr": {
      "name": "South Ndebele",
      "nativeName": "isiNdebele"
    },
    "oc": {
      "name": "Occitan",
      "nativeName": "Occitan"
    },
    "oj": {
      "name": "Ojibwe",
      "nativeName": "ᐊᓂᔑᓈᐯᒧᐎᓐ"
    },
    "cu": {
      "name": "Old Slavonic",
      "nativeName": "ѩзыкъ словѣньскъ"
    },
    "om": {
      "name": "Oromo",
      "nativeName": "Afaan Oromoo"
    },
    "or": {
      "name": "Oriya",
      "nativeName": "ଓଡ଼ିଆ"
    },
    "os": {
      "name": "Ossetian",
      "nativeName": "ирон æвзаг"
    },
    "pa": {
      "name": "Panjabi",
      "nativeName": "ਪੰਜਾਬੀ, پنجابی‎"
    },
    "pi": {
      "name": "Pāli",
      "nativeName": "पाऴि"
    },
    "fa": {
      "name": "Persian",
      "nativeName": "فارسی"
    },
    "pl": {
      "name": "Polish",
      "nativeName": "polski"
    },
    "ps": {
      "name": "Pashto",
      "nativeName": "پښتو"
    },
    "pt": {
      "name": "Portuguese",
      "nativeName": "Português"
    },
    "qu": {
      "name": "Quechua",
      "nativeName": "Runa Simi, Kichwa"
    },
    "rm": {
      "name": "Romansh",
      "nativeName": "rumantsch grischun"
    },
    "rn": {
      "name": "Kirundi",
      "nativeName": "kiRundi"
    },
    "ro": {
      "name": "Romanian",
      "nativeName": "română"
    },
    "ru": {
      "name": "Russian",
      "nativeName": "русский язык"
    },
    "sa": {
      "name": "Sanskrit (Saṁskṛta)",
      "nativeName": "संस्कृतम्"
    },
    "sc": {
      "name": "Sardinian",
      "nativeName": "sardu"
    },
    "sd": {
      "name": "Sindhi",
      "nativeName": "सिन्धी, سنڌي، سندھی‎"
    },
    "se": {
      "name": "Northern Sami",
      "nativeName": "Davvisámegiella"
    },
    "sm": {
      "name": "Samoan",
      "nativeName": "gagana faa Samoa"
    },
    "sg": {
      "name": "Sango",
      "nativeName": "yângâ tî sängö"
    },
    "sr": {
      "name": "Serbian",
      "nativeName": "српски језик"
    },
    "gd": {
      "name": "Scottish Gaelic",
      "nativeName": "Gàidhlig"
    },
    "sn": {
      "name": "Shona",
      "nativeName": "chiShona"
    },
    "si": {
      "name": "Sinhala, Sinhalese",
      "nativeName": "සිංහල"
    },
    "sk": {
      "name": "Slovak",
      "nativeName": "slovenčina"
    },
    "sl": {
      "name": "Slovene",
      "nativeName": "slovenščina"
    },
    "so": {
      "name": "Somali",
      "nativeName": "Soomaaliga, af Soomaali"
    },
    "st": {
      "name": "Southern Sotho",
      "nativeName": "Sesotho"
    },
    "es": {
      "name": "Spanish",
      "nativeName": "español, castellano"
    },
    "su": {
      "name": "Sundanese",
      "nativeName": "Basa Sunda"
    },
    "sw": {
      "name": "Swahili",
      "nativeName": "Kiswahili"
    },
    "ss": {
      "name": "Swati",
      "nativeName": "SiSwati"
    },
    "sv": {
      "name": "Swedish",
      "nativeName": "svenska"
    },
    "ta": {
      "name": "Tamil",
      "nativeName": "தமிழ்"
    },
    "te": {
      "name": "Telugu",
      "nativeName": "తెలుగు"
    },
    "tg": {
      "name": "Tajik",
      "nativeName": "тоҷикӣ, toğikī, تاجیکی‎"
    },
    "th": {
      "name": "Thai",
      "nativeName": "ไทย"
    },
    "ti": {
      "name": "Tigrinya",
      "nativeName": "ትግርኛ"
    },
    "bo": {
      "name": "Tibetan Standard",
      "nativeName": "བོད་ཡིག"
    },
    "tk": {
      "name": "Turkmen",
      "nativeName": "Türkmen, Түркмен"
    },
    "tl": {
      "name": "Tagalog",
      "nativeName": "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
    },
    "tn": {
      "name": "Tswana",
      "nativeName": "Setswana"
    },
    "to": {
      "name": "Tonga (Tonga Islands)",
      "nativeName": "faka Tonga"
    },
    "tr": {
      "name": "Turkish",
      "nativeName": "Türkçe"
    },
    "ts": {
      "name": "Tsonga",
      "nativeName": "Xitsonga"
    },
    "tt": {
      "name": "Tatar",
      "nativeName": "татарча, tatarça, تاتارچا‎"
    },
    "tw": {
      "name": "Twi",
      "nativeName": "Twi"
    },
    "ty": {
      "name": "Tahitian",
      "nativeName": "Reo Tahiti"
    },
    "ug": {
      "name": "Uighur, Uyghur",
      "nativeName": "Uyƣurqə, ئۇيغۇرچە‎"
    },
    "uk": {
      "name": "Ukrainian",
      "nativeName": "українська"
    },
    "ur": {
      "name": "Urdu",
      "nativeName": "اردو"
    },
    "uz": {
      "name": "Uzbek",
      "nativeName": "zbek, Ўзбек, أۇزبېك‎"
    },
    "ve": {
      "name": "Venda",
      "nativeName": "Tshivenḓa"
    },
    "vi": {
      "name": "Vietnamese",
      "nativeName": "Tiếng Việt"
    },
    "vo": {
      "name": "Volapük",
      "nativeName": "Volapük"
    },
    "wa": {
      "name": "Walloon",
      "nativeName": "Walon"
    },
    "cy": {
      "name": "Welsh",
      "nativeName": "Cymraeg"
    },
    "wo": {
      "name": "Wolof",
      "nativeName": "Wollof"
    },
    "fy": {
      "name": "Western Frisian",
      "nativeName": "Frysk"
    },
    "xh": {
      "name": "Xhosa",
      "nativeName": "isiXhosa"
    },
    "yi": {
      "name": "Yiddish",
      "nativeName": "ייִדיש"
    },
    "yo": {
      "name": "Yoruba",
      "nativeName": "Yorùbá"
    },
    "za": {
      "name": "Zhuang",
      "nativeName": "Saɯ cueŋƅ, Saw cuengh"
    }
  };
})();

},{}],391:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * @brief set moment.js language aliases
 */
(function () {
  if ((typeof moment === "undefined" ? "undefined" : _typeof(moment)) === "object" || typeof moment === "function") {
    moment.defineLocale('zh', {
      parentLocale: 'zh-cn'
    });
  }
})();

},{}],392:[function(require,module,exports){
"use strict";

(function ($) {
  require("../../polyfill/polyfill.js");
  var operatorFromBuilderToServer = require("./functions/operatorFromBuilderToServer.js");
  var QueryPredefinedKeys = require("../../cloudflow/CloudflowUtil/js/QueryPredefinedKeys.js");
  $.widget("nixps-common.ServerQueryEditor", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "serverqueryeditor",
    options: {
      /**
       * @desc must we allow subgroups, visual brackets or not. This option will be given to the plugin
       * @type {boolean}
       * @default true
       */
      allow_groups: true,
      /**
       * @description The possible conditions
       * @type {Array}
       * @default ["AND", "OR"]
       * @example ["AND"]
       */
      conditions: ["AND", "OR"],
      /**
       * @description Must we allow the not opperator?
       * @type {Boolean}
       * @default false
       * @since 1.1.0
       */
      allowNotOperator: false,
      fieldInput: undefined,
      fieldValueSetter: undefined,
      fieldValueGetter: undefined,
      fieldValidation: undefined,
      fieldEvents: "change",
      /**
       * @description Must we accept Value Composers or not?
       * @type {Boolean}
       * @default false
       */
      allowValueComposers: false,
      value_separator: ";"
    },
    _create: function _create() {
      // control if queryBuilder plugin is available 
      if (typeof $.fn.queryBuilder !== "function") {
        throw new Error(this.widgetFullName + " needs queryBuilder as plugin");
      }
      this._super();
      this.filters = [];
      this.initialRules = [];
      this.ui = this.element.append($("<div>").addClass(this.widgetFullName));
      this.queryBuilder = null;
      this._on(this.ui, {
        "change": this._changeHandler,
        "change select": this._userChangeHandler,
        "change input": this._userChangeHandler,
        "change textarea": this._userChangeHandler,
        "click .group-conditions": this._userChangeHandler,
        "click .group-actions button[data-add]": this._addRuleHandler
      });
      this.ui.on("afterUpdateRuleOperator.queryBuilder", this._afterRuleChangeHandler.bind(this));
      this.ui.on("afterDeleteRule.queryBuilder", this._deleteRuleHandler.bind(this));
      this.ui.on("afterDeleteGroup.queryBuilder", this._deleteRuleHandler.bind(this));
    },
    _changeHandler: function _changeHandler(pEvent, pData) {
      this._trigger("change", pEvent, {
        action: "intern_change",
        data: pData
      });
    },
    _userChangeHandler: function _userChangeHandler(pEvent, pData) {
      // try to detect real changes and filter js triggered ones
      if (pEvent.bubbles === true) {
        this._trigger("change", pEvent, {
          action: "user"
        });
      }
    },
    _deleteRuleHandler: function _deleteRuleHandler(pEvent, pModel) {
      this._trigger("change", null, {
        action: "delete_rule"
      });
    },
    _addRuleHandler: function _addRuleHandler(pEvent, pData) {
      this._trigger("change", null, {
        action: "add_rule"
      });
    },
    _afterRuleChangeHandler: function _afterRuleChangeHandler() {
      this._fixUIProblems();
    },
    _render: function _render() {
      if (this.filters.length == 0) {
        return;
      }
      var plugins = {};
      if (this.options.allowNotOperator === true) {
        plugins["not-group"] = {
          icon_unchecked: "fa fa-square-o",
          icon_checked: "fa fa-check-square-o",
          disable_template: false
        };
      }
      // create plugin element queryBuilder ...
      this.queryBuilder = this.ui.queryBuilder({
        filters: this.filters,
        default_filter: this.filters[0].id,
        conditions: this.options.conditions,
        allow_groups: this.options.allow_groups === false ? 0 : this.options.allow_groups,
        allow_empty: true,
        value_separator: this.options.value_separator,
        // display_empty_filter: false,
        operators: [{
          type: "equal",
          accept_values: true,
          apply_to: ["string", "number", "boolean"],
          nb_inputs: 1
        }, {
          type: "not_equal",
          accept_values: true,
          apply_to: ["string", "number", "boolean"],
          nb_inputs: 1
        }, {
          type: "contains",
          accept_values: true,
          apply_to: ["string"],
          nb_inputs: 1
        }, {
          type: "begins_with",
          accept_values: true,
          apply_to: ["string"],
          nb_inputs: 1
        }, {
          type: "ends_with",
          accept_values: true,
          apply_to: ["string"],
          nb_inputs: 1
        }, {
          type: "is_like",
          accept_values: true,
          apply_to: ["string"],
          nb_inputs: 1
        }, {
          type: "contains_text_like",
          accept_values: true,
          apply_to: ["string"],
          nb_inputs: 1
        }, {
          type: "begins_like",
          accept_values: true,
          apply_to: ["string"],
          nb_inputs: 1
        }, {
          type: "ends_like",
          accept_values: true,
          apply_to: ["string"],
          nb_inputs: 1
        }, {
          type: "exists",
          accept_values: false,
          apply_to: ["string", "number", "datetime", "boolean"],
          nb_inputs: 0,
          multiple: false
        }, {
          type: "does_not_exists",
          accept_values: false,
          apply_to: ["string", "number", "datetime", "boolean"],
          nb_inputs: 0,
          multiple: false
        }, {
          type: "in",
          nb_inputs: 1,
          multiple: true,
          apply_to: ["string"]
        }, {
          type: "less",
          nb_inputs: 1,
          multiple: false,
          apply_to: ["number", "datetime"]
        }, {
          type: "less_or_equal",
          nb_inputs: 1,
          multiple: false,
          apply_to: ["number", "datetime"]
        }, {
          type: "greater",
          nb_inputs: 1,
          multiple: false,
          apply_to: ["number", "datetime"]
        }, {
          type: "greater_or_equal",
          nb_inputs: 1,
          multiple: false,
          apply_to: ["number", "datetime"]
        }, {
          type: "between",
          nb_inputs: 2,
          multiple: true,
          apply_to: ["datetime"]
        }, {
          type: "today_unix",
          nb_inputs: 0,
          multiple: false,
          apply_to: ["datetime"]
        }, {
          type: "yesterday_unix",
          nb_inputs: 0,
          multiple: false,
          apply_to: ["datetime"]
        }, {
          type: "last_7_days_unix",
          nb_inputs: 0,
          multiple: false,
          apply_to: ["datetime"]
        }, {
          type: "last_month_unix",
          nb_inputs: 0,
          multiple: false,
          apply_to: ["datetime"]
        }, {
          type: "today_iso",
          nb_inputs: 0,
          multiple: false,
          apply_to: ["datetime"]
        }, {
          type: "yesterday_iso",
          nb_inputs: 0,
          multiple: false,
          apply_to: ["datetime"]
        }, {
          type: "last_7_days_iso",
          nb_inputs: 0,
          multiple: false,
          apply_to: ["datetime"]
        }, {
          type: "last_month_iso",
          nb_inputs: 0,
          multiple: false,
          apply_to: ["datetime"]
        }],
        lang: {
          add_rule: this.options.allow_groups === false ? $.i18n._("nixps-cloudflow-ServerQueryEditor.add_rule_only") : $.i18n._("nixps-cloudflow-ServerQueryEditor.add_rule"),
          add_group: $.i18n._("nixps-cloudflow-ServerQueryEditor.add_group"),
          delete_rule: $.i18n._("nixps-cloudflow-ServerQueryEditor.remove"),
          delete_group: $.i18n._("nixps-cloudflow-ServerQueryEditor.remove"),
          operator_equal: $.i18n._("nixps-cloudflow-ServerQueryEditor.equal"),
          operator_not_equal: $.i18n._("nixps-cloudflow-ServerQueryEditor.not_equal"),
          operator_contains: $.i18n._("nixps-cloudflow-ServerQueryEditor.contains"),
          operator_begins_with: $.i18n._("nixps-cloudflow-ServerQueryEditor.begins_with"),
          operator_ends_with: $.i18n._("nixps-cloudflow-ServerQueryEditor.ends_with"),
          operator_is_like: $.i18n._("nixps-cloudflow-ServerQueryEditor.is_like"),
          operator_contains_text_like: $.i18n._("nixps-cloudflow-ServerQueryEditor.contains_text_like"),
          operator_begins_like: $.i18n._("nixps-cloudflow-ServerQueryEditor.begins_like"),
          operator_ends_like: $.i18n._("nixps-cloudflow-ServerQueryEditor.ends_like"),
          operators: {
            equal: $.i18n._("nixps-cloudflow-ServerQueryEditor.equal"),
            not_equal: $.i18n._("nixps-cloudflow-ServerQueryEditor.not_equal"),
            contains: $.i18n._("nixps-cloudflow-ServerQueryEditor.contains"),
            begins_with: $.i18n._("nixps-cloudflow-ServerQueryEditor.begins_with"),
            ends_with: $.i18n._("nixps-cloudflow-ServerQueryEditor.ends_with"),
            is_like: $.i18n._("nixps-cloudflow-ServerQueryEditor.is_like"),
            contains_text_like: $.i18n._("nixps-cloudflow-ServerQueryEditor.contains_text_like"),
            begins_like: $.i18n._("nixps-cloudflow-ServerQueryEditor.begins_like"),
            ends_like: $.i18n._("nixps-cloudflow-ServerQueryEditor.ends_like"),
            exists: $.i18n._("nixps-cloudflow-ServerQueryEditor.exists"),
            does_not_exists: $.i18n._("nixps-cloudflow-ServerQueryEditor.does_not_exists"),
            "in": $.i18n._("nixps-cloudflow-ServerQueryEditor.in"),
            less: $.i18n._("nixps-cloudflow-ServerQueryEditor.less"),
            less_or_equal: $.i18n._("nixps-cloudflow-ServerQueryEditor.less_or_equal"),
            greater: $.i18n._("nixps-cloudflow-ServerQueryEditor.greater"),
            greater_or_equal: $.i18n._("nixps-cloudflow-ServerQueryEditor.greater_or_equal")
          },
          operators_datetime: {
            less_or_equal: $.i18n._("nixps-cloudflow-ServerQueryEditor.before"),
            greater_or_equal: $.i18n._("nixps-cloudflow-ServerQueryEditor.after"),
            today_unix: $.i18n._("nixps-cloudflow-ServerQueryEditor.today"),
            yesterday_unix: $.i18n._("nixps-cloudflow-ServerQueryEditor.yesterday"),
            last_7_days_unix: $.i18n._("nixps-cloudflow-ServerQueryEditor.last_7_days"),
            last_month_unix: $.i18n._("nixps-cloudflow-ServerQueryEditor.last_month"),
            today_iso: $.i18n._("nixps-cloudflow-ServerQueryEditor.today"),
            yesterday_iso: $.i18n._("nixps-cloudflow-ServerQueryEditor.yesterday"),
            last_7_days_iso: $.i18n._("nixps-cloudflow-ServerQueryEditor.last_7_days"),
            last_month_iso: $.i18n._("nixps-cloudflow-ServerQueryEditor.last_month")
          },
          "errors": {
            "no_filter": $.i18n._("nixps-cloudflow-ServerQueryEditor.no_filter"),
            //No filter selected",
            "empty_group": $.i18n._("nixps-cloudflow-ServerQueryEditor.empty_group"),
            //The group is empty",
            "select_empty": $.i18n._("nixps-cloudflow-ServerQueryEditor.select_empty"),
            //No value selected",
            "string_empty": $.i18n._("nixps-cloudflow-ServerQueryEditor.string_empty") //Empty value"
          },

          "NOT": $.i18n._("nixps-cloudflow-ServerQueryEditor.not")
        },
        icons: {
          add_group: "fa fa-plus-square",
          add_rule: "fa fa-plus-circle",
          remove_group: "fa fa-minus-square",
          remove_rule: "fa fa-minus-circle",
          error: "fa fa-exclamation-triangle"
        },
        plugins: plugins,
        templates: {
          operatorSelect: '\
						{{? it.operators.length === 1 }} \
						<span> \
						{{= it.translate("operators", it.operators[0].type) }} \
						</span> \
						{{?}} \
						{{ var operatorsname = \'operators\'; }} \
						{{? it.rule.filter.type === \'datetime\' }} \
						{{ var operatorsname = \'operators_datetime\'; }} \
						{{?}} \
						{{ var optgroup = null; }} \
						<select class="form-control {{? it.operators.length === 1 }}hide{{?}}" name="{{= it.rule.id }}_operator"> \
						{{~ it.operators: operator }} \
							{{? optgroup !== operator.optgroup }} \
							{{? optgroup !== null }}</optgroup>{{?}} \
							{{? (optgroup = operator.optgroup) !== null }} \
								<optgroup label="{{= it.translate(it.settings.optgroups[optgroup]) }}"> \
							{{?}} \
							{{?}} \
							<option value="{{= operator.type }}">{{= it.translate(operatorsname, operator.type) }}</option> \
						{{~}} \
						{{? optgroup !== null }}</optgroup>{{?}} \
						</select>'
        }
      }).data("queryBuilder");
      this.queryBuilder.setRules(this.initialRules);
      // the plugin use show on div who are display: inline-block,
      // try to detect errors and try to fix
      this._fixUIProblems();
    },
    _rulesToQuery: function _rulesToQuery(pQuery, pRules) {
      if (pRules === null || pRules.condition === undefined) {
        // nothing to append
        return;
      }
      if (pRules.not === true) {
        pQuery.push("not");
      }
      var condition = "";
      for (var countRules = 0; countRules < pRules.rules.length; ++countRules) {
        if (condition !== "") {
          pQuery.push(condition);
        }
        var rule = pRules.rules[countRules];
        if (rule.condition !== undefined) {
          pQuery.push("(");
          this._rulesToQuery(pQuery, rule);
          pQuery.push(")");
        } else {
          var filter = this._getFilterByID(rule.id);
          if (typeof filter.parse === "function") {
            pQuery.splice.apply(pQuery, [pQuery.length, 0].concat(filter.parse(rule)));
          } else {
            pQuery.push(rule.field);
            pQuery.push(operatorFromBuilderToServer(rule.operator));
            if (rule.operator === "equal") {
              if (this.options.allowValueComposers === true && Array.isArray(rule.value)) {
                pQuery.push(rule.value);
              } else if (rule.type === "double" || rule.type === "integer") {
                pQuery.push(parseFloat(rule.value));
              } else if (rule.type === "boolean") {
                pQuery.push(rule.value == "true");
              } else {
                pQuery.push(rule.value);
              }
            } else if (rule.operator === "not_equal") {
              if (this.options.allowValueComposers === true && Array.isArray(rule.value)) {
                pQuery.push(rule.value);
              } else if (rule.type === "double" || rule.type === "integer") {
                pQuery.push(parseFloat(rule.value));
              } else if (rule.type === "boolean") {
                pQuery.push(rule.value == "true");
              } else {
                pQuery.push(rule.value);
              }
            } else if (rule.operator === "contains") {
              pQuery.push(rule.value);
            } else if (rule.operator === "begins_with") {
              pQuery.push(rule.value);
            } else if (rule.operator === "ends_with") {
              pQuery.push(rule.value);
            } else if (rule.operator === "is_like") {
              pQuery.push(rule.value);
            } else if (rule.operator === "contains_text_like") {
              pQuery.push(rule.value);
            } else if (rule.operator === "begins_like") {
              pQuery.push(rule.value);
            } else if (rule.operator === "ends_like") {
              pQuery.push(rule.value);
            } else if (rule.operator === "less") {
              if (this.options.allowValueComposers === true && Array.isArray(rule.value)) {
                pQuery.push(rule.value);
              } else {
                if (typeof rule.value === "string" && rule.value.indexOf("Z") !== -1 && rule.value.indexOf("T") !== -1) {
                  //comparing a date! do not parseFloat
                  pQuery.push(rule.value);
                } else {
                  pQuery.push(parseFloat(rule.value));
                }
              }
            } else if (rule.operator === "less_or_equal") {
              if (this.options.allowValueComposers === true && Array.isArray(rule.value)) {
                pQuery.push(rule.value);
              } else {
                if (typeof rule.value === "string" && rule.value.indexOf("Z") !== -1 && rule.value.indexOf("T") !== -1) {
                  //comparing a date! do not parseFloat
                  pQuery.push(rule.value);
                } else {
                  pQuery.push(parseFloat(rule.value));
                }
              }
            } else if (rule.operator === "greater") {
              if (this.options.allowValueComposers === true && Array.isArray(rule.value)) {
                pQuery.push(rule.value);
              } else {
                if (typeof rule.value === "string" && rule.value.indexOf("Z") !== -1 && rule.value.indexOf("T") !== -1) {
                  //comparing a date! do not parseFloat
                  pQuery.push(rule.value);
                } else {
                  pQuery.push(parseFloat(rule.value));
                }
              }
            } else if (rule.operator === "greater_or_equal") {
              if (this.options.allowValueComposers === true && Array.isArray(rule.value)) {
                pQuery.push(rule.value);
              } else {
                if (typeof rule.value === "string" && rule.value.indexOf("Z") !== -1 && rule.value.indexOf("T") !== -1) {
                  //comparing a date! do not parseFloat
                  pQuery.push(rule.value);
                } else {
                  pQuery.push(parseFloat(rule.value));
                }
              }
            } else if (rule.operator === "in") {
              if (this.options.allowValueComposers === true && Array.isArray(rule.value) && typeof rule.value[0].type === "string") {
                // we should split the value composer ....
                pQuery.push(rule.value);
              } else if (typeof rule.value === "string") {
                var value = rule.value;
                if (value[0] === this.options.value_separator) {
                  value = value.slice(1);
                }
                if (value[value.length - 1] === this.options.value_separator) {
                  value = value.slice(0, -1);
                }
                pQuery.push(value.split(this.options.value_separator));
              }
            } else if (rule.operator === "today_unix") {
              pQuery.push(QueryPredefinedKeys.UNIX_TODAY);
            } else if (rule.operator === "yesterday_unix") {
              pQuery.push(QueryPredefinedKeys.UNIX_TODAY + " - 1D");
            } else if (rule.operator === "last_7_days_unix") {
              pQuery.push(QueryPredefinedKeys.UNIX_NOW + " - 7D");
            } else if (rule.operator === "last_month_unix") {
              pQuery.push(QueryPredefinedKeys.UNIX_NOW + " - 1M");
            } else if (rule.operator === "today_iso") {
              pQuery.push(QueryPredefinedKeys.ISO_TODAY);
            } else if (rule.operator === "yesterday_iso") {
              pQuery.push(QueryPredefinedKeys.ISO_TODAY + " - 1D");
            } else if (rule.operator === "last_7_days_iso") {
              pQuery.push(QueryPredefinedKeys.ISO_NOW + " - 7D");
            } else if (rule.operator === "last_month_iso") {
              pQuery.push(QueryPredefinedKeys.ISO_NOW + " - 1M");
            }
          }
        }
        if (pRules.condition === "OR") {
          condition = "or";
        } else {
          condition = "and";
        }
      }
    },
    _addCompareRule: function _addCompareRule(pRules, pQuery, pOperator, pIndex) {
      var type = "string",
        operator = pOperator;
      if (typeof pQuery[pIndex + 2] === "string" && pQuery[pIndex + 2].indexOf("$_") === 0) {
        type = "datetime";
        if (pQuery[pIndex + 2] === QueryPredefinedKeys.UNIX_TODAY) {
          operator = "today_unix";
        } else if (pQuery[pIndex + 2] === QueryPredefinedKeys.UNIX_TODAY + " - 1D") {
          operator = "yesterday_unix";
        } else if (pQuery[pIndex + 2] === QueryPredefinedKeys.UNIX_NOW + " - 7D") {
          operator = "last_7_days_unix";
        } else if (pQuery[pIndex + 2] === QueryPredefinedKeys.UNIX_NOW + " - 1M") {
          operator = "last_month_unix";
        } else if (pQuery[pIndex + 2] === QueryPredefinedKeys.ISO_TODAY) {
          operator = "today_iso";
        } else if (pQuery[pIndex + 2] === QueryPredefinedKeys.ISO_TODAY + " - 1D") {
          operator = "yesterday_iso";
        } else if (pQuery[pIndex + 2] === QueryPredefinedKeys.ISO_NOW + " - 7D") {
          operator = "last_7_days_iso";
        } else if (pQuery[pIndex + 2] === QueryPredefinedKeys.ISO_NOW + " - 1M") {
          operator = "last_month_iso";
        }
      } else if (["less", "less_or_equal", "greater", "greater_or_equal"].includes(operator)) {
        type = "double";
      } else if (["equal", "not_equal"].includes(operator)) {
        if (typeof pQuery[pIndex + 2] === "boolean") {
          type = "boolean";
          pQuery[pIndex + 2] = "" + pQuery[pIndex + 2];
        }
      } else if (operator === "in") {
        if (Array.isArray(pQuery[pIndex + 2]) && pQuery[pIndex + 2].length > 0 && typeof pQuery[pIndex + 2][0] === "string") {
          pQuery[pIndex + 2] = pQuery[pIndex + 2].join(this.options.value_separator);
        }
      }
      if (this._getFilterByID(pQuery[pIndex]) === false) {
        this.addFields([{
          id: pQuery[pIndex],
          field: pQuery[pIndex],
          label: pQuery[pIndex],
          type: type,
          input: this.options.fieldInput,
          valueSetter: this.options.fieldValueSetter,
          valueGetter: this.options.fieldValueGetter,
          validation: this.options.fieldValidation,
          input_event: this.options.fieldEvents
        }]);
      }
      pRules.push({
        "id": pQuery[pIndex],
        "field": pQuery[pIndex],
        "type": type,
        "input": "text",
        "operator": operator,
        "value": pQuery[pIndex + 2]
      });
    },
    _queryToRules: function _queryToRules(pQuery) {
      var rules = {
        "condition": "AND",
        "rules": []
      };
      var resulting_rules = rules;
      var previous_rules = [];
      for (var countQuery = 0; countQuery < pQuery.length; ++countQuery) {
        if (pQuery[countQuery] === "(") {
          rules.rules.push({
            "condition": "AND",
            "rules": []
          });
          previous_rules.push(rules);
          rules = rules.rules[rules.rules.length - 1];
        } else if (pQuery[countQuery] === ")") {
          rules = previous_rules.pop();
        } else if (pQuery[countQuery] === "and") {
          rules.condition = "AND";
        } else if (pQuery[countQuery] === "or") {
          rules.condition = "OR";
        } else if (pQuery[countQuery] === "not") {
          rules.not = true;
        } else if (pQuery[countQuery + 1] === "equal to") {
          this._addCompareRule(rules.rules, pQuery, "equal", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "not equal to") {
          this._addCompareRule(rules.rules, pQuery, "not_equal", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "contains") {
          this._addCompareRule(rules.rules, pQuery, "contains", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "begins with") {
          this._addCompareRule(rules.rules, pQuery, "begins_with", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "ends with") {
          this._addCompareRule(rules.rules, pQuery, "ends_with", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "is like") {
          this._addCompareRule(rules.rules, pQuery, "is_like", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "contains text like") {
          this._addCompareRule(rules.rules, pQuery, "contains_text_like", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "begins like") {
          this._addCompareRule(rules.rules, pQuery, "begins_like", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "ends like") {
          this._addCompareRule(rules.rules, pQuery, "ends_like", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "less than") {
          this._addCompareRule(rules.rules, pQuery, "less", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "less than or equal to") {
          this._addCompareRule(rules.rules, pQuery, "less_or_equal", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "greater than") {
          this._addCompareRule(rules.rules, pQuery, "greater", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "greater than or equal to") {
          this._addCompareRule(rules.rules, pQuery, "greater_or_equal", countQuery);
          countQuery += 2;
        } else if (pQuery[countQuery + 1] === "exists") {
          this._addCompareRule(rules.rules, pQuery, "exists", countQuery);
          countQuery += 1;
        } else if (pQuery[countQuery + 1] === "does not exist") {
          this._addCompareRule(rules.rules, pQuery, "does_not_exists", countQuery);
          countQuery += 1;
        } else if (pQuery[countQuery + 1] === "in") {
          this._addCompareRule(rules.rules, pQuery, "in", countQuery);
          countQuery += 1;
        }
      }
      return resulting_rules;
    },
    setFields: function setFields(pFilters) {
      this.filters = pFilters;
    },
    addFields: function addFields(pFilters) {
      this.filters = this.filters.concat(pFilters);
      if (this.queryBuilder !== null) {
        this.queryBuilder.addFilter(pFilters, "#end");
      }
    },
    setQuery: function setQuery(pQuery) {
      if (Array.isArray(pQuery) === false) {
        throw new Error("setQuery: argument must be an array");
      }
      this.initialRules = this._queryToRules(pQuery.slice());
      this._render();
    },
    getQuery: function getQuery() {
      if (this.queryBuilder == null) {
        return [];
      }
      var rules = this.queryBuilder.getRules({
        skip_empty: true
      });
      var query = [];
      this._rulesToQuery(query, rules);
      return query;
    },
    validate: function validate() {
      return this.queryBuilder.validate({
        skip_empty: true
      });
    },
    _getFilterByID: function _getFilterByID(pFilterID) {
      for (var i = 0; i < this.filters.length; i++) {
        if (this.filters[i] !== undefined && this.filters[i].id === pFilterID) {
          return this.filters[i];
        }
      }
      return false;
    },
    _fixUIProblems: function _fixUIProblems() {
      // the plugin use show on div who are display: inline-block,
      // try to detect errors and try to fix
      this.element.find("div.rule-value-container[style='display: block;']").attr("style", "display: inline-block;");
    }
  });
})(jQuery);

},{"../../cloudflow/CloudflowUtil/js/QueryPredefinedKeys.js":92,"../../polyfill/polyfill.js":433,"./functions/operatorFromBuilderToServer.js":387}],393:[function(require,module,exports){
"use strict";

if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      // .length of function is 2
      'use strict';

      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }
      var to = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

},{}],394:[function(require,module,exports){
"use strict";

/**
 * @brief Creates input options based on the result returned by get_whitepaper_input_options
 * @param whitepaper the whitepaper name passed in the get_whitepaper_input_options call
 * @param inputname the input name passed in the get_whitepaper_input_options call
 * @param result the result of the get_whitepaper_input_options call
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function InputOptions(whitepaper, inputname, result) {
  this._whitepaper = whitepaper;
  this._inputname = inputname;
  this._result = result;
}
InputOptions.prototype = {
  constructor: InputOptions,
  /**
   * @brief returns the whitepaper name
   */
  getWhitepaper: function getWhitepaper() {
    return this._whitepaper;
  },
  /**
   * @brief returns the input name
   */
  getInputName: function getInputName() {
    return this._inputname;
  },
  /**
   * @brief Returns true if the input options enables the file browser
   */
  hasFileBrowser: function hasFileBrowser() {
    return this._result.enable_file_browser;
  },
  /**
   * @brief Returns true if the input options enables the file upload
   */
  hasFileUpload: function hasFileUpload() {
    return this._result.enable_upload;
  },
  /**
   * @brief Returns the upload mode for this input (None, One, OneOrMore, Any)
   */
  getUploadMode: function getUploadMode() {
    return this._result.upload_files_mode;
  },
  /**
   * @brief Returns true if the upload accepts multiple files
   */
  canUploadMultiple: function canUploadMultiple() {
    return ["OneOrMore", "Any"].includes(this.getUploadMode());
  },
  /**
   * @brief Returns true if is localization info for the submit form
   */
  hasLocalization: function hasLocalization() {
    var result = this._result;
    return result.options_localization !== null && _typeof(result.options_localization) === "object" && !Array.isArray(result.options_localization) && Object.keys(result.options_localization).length > 0;
  },
  /**
   * @brief Returns the localization info for the submit form
   */
  getLocalization: function getLocalization() {
    if (this.hasLocalization() === false) {
      return {};
    }
    return this._result.options_localization;
  },
  hasDefaultFileBrowserLocation: function hasDefaultFileBrowserLocation() {
    return typeof this._result.default_browser_url === "string" && this._result.default_browser_url.length > 0;
  },
  getDefaultFileBrowserLocation: function getDefaultFileBrowserLocation() {
    if (this.hasDefaultFileBrowserLocation()) {
      return this._result.default_browser_url;
    }
    return null;
  },
  hasLockOnDefaultFileBrowserLocation: function hasLockOnDefaultFileBrowserLocation() {
    return this.hasDefaultFileBrowserLocation() && this._result.only_inside_default_browser_url === true;
  },
  /**
   * @brief Returns the layout JSON for the submit form
   */
  getLayoutJSON: function getLayoutJSON() {
    var result = this._result;
    var layoutJSON = null;
    if (result.options_layout !== null && _typeof(result.options_layout) === "object" && !Array.isArray(result.options_layout) && Object.keys(result.options_layout).length > 0) {
      layoutJSON = result.options_layout;
    }
    return layoutJSON;
  },
  /**
   * @brief Returns the submit form itself
   */
  getInputData: function getInputData() {
    var result = this._result;
    var inputData = {};
    if (result.ui_form !== null && _typeof(result.ui_form) === "object" && !Array.isArray(result.ui_form) && Object.keys(result.ui_form).length > 0) {
      // new format
      inputData = result.ui_form;
    } else {
      // old format
      inputData = result.options;
    }
    return inputData;
  },
  /**
   * @brief Returns true if there is a project form in the input options
   */
  hasProjectForm: function hasProjectForm() {
    var projectForm = this._result.project_form;
    return projectForm !== null && _typeof(projectForm) === "object" && !Array.isArray(projectForm) && Object.keys(projectForm).length > 0;
  },
  /**
   * @brief Returns the project form (base object with everything)
   */
  getProjectForm: function getProjectForm() {
    if (this.hasProjectForm() === false) {
      throw new Error("input options has no project form");
    }
    return this._result.project_form;
  },
  /**
   * @brief Returns the contents of the project form
   */
  getProjectFormContents: function getProjectFormContents() {
    return this.getProjectForm().contents;
  },
  /**
   * @brief Returns the layout of the project form
   */
  getProjectFormLayout: function getProjectFormLayout() {
    return this.getProjectForm().layout;
  },
  /**
   * @brief Returns the localization of the project form
   */
  getProjectFormLocalization: function getProjectFormLocalization() {
    var projectForm = this.getProjectForm();
    if (projectForm.localization !== null && _typeof(projectForm.localization) === "object" && !Array.isArray(projectForm.localization)) {
      return projectForm.localization;
    }
    return {};
  },
  /**
   * @brief returns true if this input checks on mime types
   */
  checksMimeTypes: function checksMimeTypes() {
    return Array.isArray(this._result.accepted_mime_types) && this._result.accepted_mime_types.length > 0;
  },
  /**
   * @brief Returns the accepted mime types of this input
   */
  getAcceptedMimeTypes: function getAcceptedMimeTypes() {
    if (this._result.accepted_mime_types) {
      return this._result.accepted_mime_types;
    }
    return [];
  },
  /**
   * @brief Returns true if one mimetype in the array of mimetypes is accepted by the input
   */
  acceptsMimeTypes: function acceptsMimeTypes(mimeTypes) {
    var accepted = this.getAcceptedMimeTypes();
    if (accepted.length === 0) {
      // Accept everyting if the accepted mimetypes is empty
      return true;
    }
    for (var i = 0; i < mimeTypes.length; i++) {
      var type = mimeTypes[i];
      if (accepted.indexOf(type) >= 0) {
        return true;
      }
    }

    // There are one or more accepted mime types but none of the passed mimetypes matched
    return false;
  }
};
module.exports = InputOptions;

},{}],395:[function(require,module,exports){
'use strict';

/**
 * @brief The option data object based on the response of get_whitepaper_input_option_data
 * @param optionsData the response of get_whitepaper_input_option_data
 */
function InputOptionsData(optionsData) {
  this._optionsData = optionsData;
}

/**
 * @description Transforms the array of mimetypes to a dictionary [{type: 'mimetype'},...]
 * @name InputOptionsData.mimeArrayToDict
 * @param {*} pArray 
 */
InputOptionsData.mimeArrayToDict = function (pArray) {
  if (Array.isArray(pArray)) {
    return pArray.map(function (e) {
      return {
        type: e
      };
    });
  }
  return [];
};

/**
 * @brief returns true if some data was still not available
 */
InputOptionsData.prototype.needsPolling = function () {
  var optionsData = this._optionsData.data;
  if (Array.isArray(optionsData) === false) {
    return false;
  }
  for (var i = 0; i < optionsData.length; i++) {
    var entry = optionsData[i];
    if (entry.complete === false) {
      return true;
    }
  }
  return false;
};

/**
 * @brief returns true if the data is available in the input options
 */
InputOptionsData.prototype.hasTypes = function (types) {
  var optionsData = this._optionsData.data;
  var entries = [];
  if (Array.isArray(optionsData)) {
    entries = optionsData.filter(function (entry) {
      return types.indexOf(entry.type) >= 0 && entry.complete === true;
    });
  }
  return entries.length === types.length;
};

/**
 * @brief returns the data of the types, in the same order as the types
 */
InputOptionsData.prototype.getData = function (types) {
  if (this.hasTypes(types) === false) {
    throw new Error('type is not in the options data or is not complete yet');
  }
  var optionsData = this._optionsData.data;
  var data = [];
  for (var i = 0; i < types.length; i++) {
    var type = types[i];
    var entry = optionsData.find(function (entry) {
      return entry.type === type;
    });
    data.push(entry.data);
  }
  return data;
};

/**
 * @brief returns the data of the types formatted for the FormRenderer
 */
InputOptionsData.prototype.getDataForForm = function (types) {
  if (this.hasTypes(types) === false) {
    throw new Error('type is not in the options data or is not complete yet');
  }
  var requestedData = this.getData(types);
  var metadata = {};
  for (var i = 0; i < types.length; i++) {
    var type = types[i];
    var info = requestedData[i];
    metadata[type] = info;
  }
  return metadata;
};
module.exports = InputOptionsData;

},{}],396:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _, Ladda */
(function ($) {
  "use strict";

  require("./nixps-kiosk-FrameHostFileSelector.js");
  require("../../cloudflow/FormRender/js/nixps-cloudflow-FormRenderer.js");
  require("../../cloudflow/FormElements/js/WorkflowFormComponents.js");
  require("../../cloudflow/Upload/js/nixps-cloudflow-Upload.js");
  require("../../cloudflow/FileChooser/js/nixps-cloudflow-FileChooser.js");
  require("../../common/FreezeOverlay/js/nixps-FreezeOverlay.js");
  var WhitepaperConnection = require("../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js");
  var InputOptions = require("./model/InputOptions.js");
  var InputOptionsData = require("./model/InputOptionsData.js");
  var showErrorMessage = require("./util/showErrorMessage.js");
  var User = require("../../cloudflow/User/js/User.js");
  var ExpressionToJS = require("../../pagebuilder/js/ExpressionToJS.js");
  var Consent = require("../../cloudflow/Consent/js/Consent.js");
  var LogListener = require("../../pagebuilder/js/inspect/LogListener.js");
  var Device = require("../../cloudflow/PWA/js/Device.js");
  function getFileName(pFile) {
    if (typeof pFile === "string" && pFile.length > 1) {
      return pFile.substring(pFile.lastIndexOf("/") + 1);
    }
    return pFile;
  }

  /**
   * @brief Returns a promise that resolves to the input options
   * @function
   * @private
   * @static
   * @name nixps-kiosk.CreateWorkable.getInputOptions
   * @param pSourceName the name of the whitepaper or the form
   * @param pSourceSubName the name of the whitepaper input
   * @param pSource the source where to find the form "ConfigurePlainObject", "nucleus.form"
   */
  function getInputOptions(pSource, pSourceName, pSourceSubName, pOverwriteJobFormName) {
    if (pSource === "ConfigurePlainObject") {
      // This is used for example in the "Start from Web", to supply parameters
      // The user gets an "object configurator UI" to fill in the request
      return $.when({
        ui_form: {
          elements: [{
            type: "field",
            element: {
              key: "ConfigurePlainObject",
              label: "",
              component: {
                id: "ConfigurePlainObject",
                type: "ConfigurePlainObject",
                options: {}
              }
            }
          }]
        },
        upload_files_mode: "None",
        enable_upload: false,
        enable_file_browser: false
      });
    } else if (pSource === "nucleus.form") {
      return api_defer.form.list_with_options(["name", "equal to", pSourceName], [], [], {
        maximum: 1
      }).then(function (pResults) {
        if (Array.isArray(pResults.results) && pResults.results.length === 1 && pResults.results[0].contents !== undefined) {
          return {
            ui_form: pResults.results[0].contents,
            options_localization: pResults.results[0].localization,
            options_layout: pResults.results[0].layout,
            upload_files_mode: "None",
            enable_upload: false,
            enable_file_browser: false
          };
        }
        return $.Deferred().reject({
          "error_code": "form_not_found",
          "error": "form has not been found"
        });
      });
    } else if (pSource === "overwrite_jobform") {
      // user want to use his own job form and not from the "start from kiosk" workflow node
      return $.when(api_defer.form.list_with_options(["name", "equal to", pOverwriteJobFormName], [], [], {
        maximum: 1
      }), api_defer.hub.get_whitepaper_input_options(pSourceName, pSourceSubName)).then(function (pForm, pWhitepaper) {
        if (Array.isArray(pForm.results) && pForm.results.length === 1 && pForm.results[0].contents !== undefined) {
          return Object.assign(pWhitepaper, {
            project_form: pForm.results[0]
          });
        } else {
          return $.Deferred().reject({
            "error_code": "form_not_found",
            "error": "form has not been found"
          });
        }
      });
    }

    // "Classic" case when the input is a "Start from Kiosk"
    return api_defer.hub.get_whitepaper_input_options(pSourceName, pSourceSubName);
  }

  /**
   * @description submit the information to workflows
   * @function
   * @private
   * @static
   * @name nixps-kiosk.CreateWorkable.submitToWorkflow
   * @return {deferred}
   */
  function submitToWorkflow(pWhitepaper, pInput, pFiles, pVariables, pProjectData) {
    if (pProjectData === undefined) {
      // PACKZ intercepts this call, be careful when changing this
      // Fall back to old style call so that PACKZ can still work
      return api_defer.hub.start_from_whitepaper_with_files_and_variables(pWhitepaper, pInput, pFiles, pVariables);
    }
    var options = {
      files: pFiles,
      variables: pVariables,
      project_data: pProjectData
    };
    // PACKZ intercepts this call, be careful when changing this
    return api_defer.hub.start_from_whitepaper_with_options(pWhitepaper, pInput, options);
  }

  /**
   * @description Component that shows the form defined by the nodes in a whitepaper with an uploader and a submit 
   *              button.
   * @namespace nixps-kiosk.CreateWorkable
   */
  $.widget("nixps-kiosk.CreateWorkable", $.Widget, {
    widgetEventPrefix: "createworkable",
    options: {
      /**
       * @description The language of the user, will be past to child components
       * @name nixps-kiosk.CreateWorkable#language
       * @type {String}
       * @default ""
       * @example "en"
       */
      language: "",
      /**
       * @description The current user
       * @name nixps-kiosk.CreateWorkable#user
       * @type {User}
       * @default null
       */
      user: null,
      /**
       * @description The preferences to display dates
       * @name nixps-kiosk.CreateWorkable#dateFormat
       * @type {String}
       * @default null
       */
      dateFormat: null,
      /**
       * @description The array of preselected files. This is an array containing urls.
       * @name nixps-kiosk.CreateWorkable#inputFiles
       * @type {Array}
       * @default []
       * @example ["cloudflow://PP_FILE_STORE/test/test%20this%20file.pdf"]
       */
      inputFiles: [],
      /**
       * @description Set this option on false, to fix the files from option 
       *              {@link nixps-kiosk.CreateWorkable#inputFiles}. <br />
       *              Set this option on true and a remove button will appear, so the user can remove the files 
       *              given from {@link nixps-kiosk.CreateWorkable#inputFiles}
       * @type {Boolean}
       * @default true
       */
      canChangeInputFiles: true,
      /**
       * @description The placeholder string for the input files. With this you need to fill 
       *              {@link nixps-kiosk.CreateWorkable#inputFiles}.
       * @type {String}
       * @default null
       * @example "previous files"
       */
      placeHolderName: null,
      /**
       * @decsription prefill the form with specific values
       * @name nixps-kiosk.CreateWorkable#prefillFormValues
       * @type {Object}
       * @default {}
       */
      prefillFormValues: {},
      /**
       * @decsription prefill the form with specific values
       * @name nixps-kiosk.CreateWorkable#prefillJobFormValues
       * @type {Object}
       * @default {}
       */
      prefillJobFormValues: {},
      /**
       * @name nixps-kiosk.CreateWorkable#mainFormVariables
       * @description The form template variables to be given to the main form, used in pagebuilder
       * @type {Object}
       * @default {}
       */
      mainFormVariables: {},
      /**
       * @name nixps-kiosk.CreateWorkable#jobFormVariables
       * @description The form template variables to be given to the job form, used in pagebuilder
       * @type {Object}
       * @default {}
       */
      jobFormVariables: {},
      dummy_temp_uiaction_prefillFormValues: false,
      dummy_temp_uiaction_mainFormVariables: false,
      /**
       * @name nixps-kiosk.CreateWorkable#overwriteJobForm
       * @description Must we ovewrite the job form or not
       * @type {Boolean}
       * @default false
       */
      overwriteJobForm: false,
      /**
       * @name nixps-kiosk.CreateWorkable#jobFormName
       * @description The name of the job form, to overwrite the existing one
       * @type {String}
       * @default undefined
       */
      jobFormName: undefined,
      /**
       * @name nixps-kiosk.CreateWorkable#formClasses
       * @description The classes given to the formrenderer
       * @type {String}
       * @default "cf-form"
       */
      formClasses: "cf-form",
      /**
       * @name nixps-kiosk.CreateWorkable#showContentTable
       * @description Must we show the content table if a content table is present, 
       * @type {Boolean}
       * @default true
       */
      showContentTable: true,
      /**
       * @description WhitepaperName/ workflow name that must be selected to get the correct form and to submit to
       * @name nixps-kiosk.CreateWorkable#whitepaper
       * @type {String}
       * @example "Standalone Rip"
       * @default null
       */
      whitepaper: null,
      /**
       * @description Input Name of a "Start From Kiosk" node (or "Hold in Kiosk") that must be selected if we 
       *              want to create a new workable
       * @name nixps-kiosk.CreateWorkable#whitepaperInputName
       * @type {String}
       * @example "input name"
       * @default null
       */
      whitepaperInputName: null,
      /**
       * @description Bypass the "Start from Web" or not?
       * @name nixps-kiosk.CreateWorkable#plainObjectInput
       * @type {Boolean}
       * @default false
       */
      plainObjectInput: false,
      /**
       * @description The name of the form in the nucleus.form collection, to overwrite the whitepaper ones
       * @name nixps-kiosk.CreateWorkable#nucleusFormName
       * @type {String}
       * @default null
       */
      nucleusFormName: null,
      /**
       * @description Which and in which order must we show the panels?
       * You can use "submitOptions", "filesSelection", "projectForm" as name.
       * @name nixps-kiosk.CreateWorkable#panels
       * @type: {Array}
       * @example ["filesSelection", "submitOptions"]
       * @default ["submitOptions", "projectForm", "filesSelection"]
       */
      panels: ["submitOptions", "projectForm", "filesSelection"],
      /**
       * @description Must we after applying the option {@link nixps-kiosk.CreateWorkable#panels} move the fileselection to the top.
       * this is a supid option, forced by pagebuilder to be future compatible
       * @name nixps-kiosk.CreateWorkable#moveFileSectionToTop
       * @private
       * @type {Boolean}
       * @default false
       */
      moveFileSectionToTop: false,
      /**
       * @description Show the titles of the panels
       * @name nixps-kiosk.CreateWorkable#showTitles
       * @type {Boolean}
       * @default false
       */
      showTitles: false,
      /**
       * @description must we reset all paddings and margins of this component?
       * @name nixps-kiosk.CreateWorkable#stickToBorders
       * @type {Boolean}
       * @default false
       */
      stickToBorders: false,
      /**
       * @description must we enable sticky submitbutton
       * @name nixps-kiosk.CreateWorkable#enableStickyButtons
       * @type {Boolean}
       * @default true
       * @private
       */
      enableStickyButtons: false,
      /**
       * @description Must we show a cancel button?
       * @name nixps-kiosk.CreateWorkable#enableCancelButton
       * @type {Boolean}
       * @default false
       */
      enableCancelButton: false,
      /**
       * @description Must we show a submit button?
       * @name nixps-kiosk.CreateWorkable#enableSubmitButton
       * @type {Boolean}
       * @default
       */
      enableSubmitButton: true,
      /**
       * @description The text to show on the submitbutton
       * @name nixps-kiosk.CreateWorkable#submitButtonText
       * @type {String}
       * @default "Submit"
       */
      submitButtonText: undefined,
      /**
       * @description The class names separeted by space to be added to the submit button
       * @name nixps-kiosk.CreateWorkable#submitButtonClasses
       * @type {String}
       * @default "btn btn-primary"
       */
      submitButtonClasses: "btn btn-primary cf-button-main",
      /**
       * @description The class names separeted by space to be added to the submit button
       * @name nixps-kiosk.CreateWorkable#cancelButtonClasses
       * @type {String}
       * @default "btn btn-default"
       */
      cancelButtonClasses: "btn btn-default cf-button-secondary",
      /**
       * @description The text to show on the cancel button
       * @name nixps-kiosk.CreateWorkable#cancelButtonText
       * @type {String}
       * @default "Submit"
       */
      cancelButtonText: undefined,
      /**
       * @description Must we add a static message panel to show the workable has submitted successfully
       * @name nixps-kiosk.CreateWorkable#addSuccessPanel
       * @type {Boolean}
       * @default true
       */
      addSuccessPanel: true,
      /**
       * @description The context to save in with view we are.
       * @name nixps-kiosk.CreateWorkable#fileChooserContext
       * @type {String}
       * @default ""
       * @example "custom.submit"
       */
      fileChooserContext: "",
      /**
       * @description Function that filters the files that would be submitting to the workflow. Return the urls 
       *              that must be submitted.
       * @type {Function}
       * @name nixps-kiosk.CreateWorkable#checkFiles
       * @param {array} pFiles a array containing url of the files that are proposed to be submitting
       * @default function(pFiles) {
          return pFiles;
      },
       * @return {array}
       */
      checkFiles: function checkFiles(pFiles) {
        return pFiles;
      },
      /**
       * @description The classes names separated by space added to the component at the highest level
       * @name nixps-kiosk.CreateWorkable#classes
       * @type {String}
       * @default ""
       */
      classes: "",
      /**
       * @description The default variables given to the submit to kiosk
       * @name nixps-kiosk.CreateWorkable#defaultSubmitVariables
       * @type {Object}
       * @default {}
       */
      defaultSubmitVariables: {},
      /**
       * @description Must we apply actions on hidden fields, hidden by actions during creation?
       * @name nixps-kiosk.CreateWorkable#applyActionOnHiddenFieldDuringInit
       * @type {Boolean}
       * @default true
       */
      applyActionOnHiddenFieldDuringInit: true,
      /**
       * @name nixps-kiosk.CreateWorkable#newWorkableMessage
       * @description String to be showed when the workable is created after submitting. If value is null a default value
       * "Workable created" is used. If empty string is used, no message will be show
       * @type {String}
       * @default null
       */
      newWorkableMessage: null,
      /**
       * @name nixps-kiosk.CreateWorkable#resetFormAfterSubmit
       * @description Must we reset the input form after submitting
       * @type {Boolean}
       * @default false
       */
      resetFormAfterSubmit: false,
      /**
       * @name nixps-kiosk.CreateWorkable#additionalFileSelectors
       * @description Show additional file selectors
       * @type {Array}
       * @default []
       */
      additionalFileSelectors: [],
      /**
       * @name nixps-kiosk.CreateWorkable#fileSelectorsActiveTab
       * @description With tab (name) of all file selectors must we activate (on start up)
       * @type {String}
       * @default "upload"
       */
      fileSelectorsActiveTab: "upload",
      /**
       * @name nixps-kiosk.CreateWorkable#fileSelectionHeight
       * @description The height of the file selection and uploader, to be overwritten bu css file. This is needed for pagebuilder
       * @type {Number}
       * @description undefined
       */
      fileSelectionHeight: undefined,
      /**
       * @name nixps-kiosk.CreateWorkable#buttonbarClasses
       * @description The class name to be given to the button bar
       * @type {String}
       * @default "cf-buttonbar-center"
       */
      buttonbarClasses: "cf-buttonbar-center",
      /**
       * @name nixps-kiosk.CreateWorkable#host
       * @description The name of the Frame host in which Kiosk runs, false if none
       * @type {String}
       * @default false
       */
      host: false,
      /**
       * @name nixps-kiosk.CreateWorkable#showOverlay
       * @description Show overlay after submittion
       * @type {Boolean}
       */
      showOverlay: true,
      selectedFiles: undefined,
      /**
       * @description object to retrieve consent
       * @name nixps-kiosk.CreateWorkable#consent
       * @type {Object}
       * @default null
       */
      consent: null,
      /**
       * @description must we disable the component or not
       * @default false
       * @private
       * @name nixps-kiosk.CreateWorkable#disabled
       */
      disabled: false,
      /**
       * @name nixps-kiosk.CreateWorkable#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    /**
     * @brief Set a correct default submit button translation text
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_getCreateOptions
     */
    _getCreateOptions: function _getCreateOptions() {
      return {
        submitButtonText: $.i18n._("nixps-kiosk-newworkable.submit"),
        cancelButtonText: $.i18n._("nixps-kiosk-newworkable.cancel")
      };
    },
    _create: function _create() {
      this._checkOptions();
      this.element.addClass(this.widgetFullName).addClass(this.options.classes);

      // variables
      this.creating = true; // is being creating
      this.inputOptions = null;
      this.user = null;
      this.consent = null;
      this.inputOptionsDataTimerId; // timerid 
      this.inputOptionsDataCallID = 0; // timer calling id
      this.userDef;
      this.formChangeTriggerData = {
        todoStack: [],
        data: {},
        running: false
      };
      this.isSubmittingBlocked = false; // bool indication we are bussy with submitting

      if (this.options.user instanceof User) {
        this.user = this.options.user;
        this.userDef = this.options.user;
      } else if ($.isPlainObject(this.options.user)) {
        this.user = User.fromJSON(this.options.user);
        this.userDef = this.user;
      } else {
        // fallback for old pagebuilder pages and
        // I suppose it is alread cached
        var that = this;
        this.userDef = $.when(User.get()).done(function (pUser) {
          that.user = pUser;
        });
      }
      this.consentDef;
      if (this.options.consent instanceof Consent) {
        this.consent = this.options.consent;
        this.consentDef = this.options.consent;
      } else if ($.isPlainObject(this.options.consent)) {
        this.consent = Consent.fromJSON(this.options.consent);
        this.consentDef = this.consent;
      } else {
        // fallback for old pagebuilder pages and
        // I suppose it is alread cached
        var that = this;
        this.consentDef = $.when(Consent.get()).then(function (pConsent) {
          that.consent = pConsent;
        });
      }
      this.hostname = false;
      if (typeof this.options.host === "string") {
        this.hostname = this.options.host;
      } else if ($.isPlainObject(this.options.host) && typeof this.options.host.identifier === "string") {
        this.hostname = this.options.host.identifier;
      }
      this._draw();
      this._on(this.element, {
        // Files are added
        "filechooserselection": this._fileAddedHandler,
        "framehostfileselectorchange": this._fileAddedHandler,
        "framehostfileselectorfileselectionchange": this._hostFileSelectionChangedHandler,
        // Transitions for the upload
        "uploadstart": this._uploadStartHandler,
        "uploadstop": this._uploadStopHandler,
        "uploaderror": this._uploadFailedHandler,
        // File removal
        "uploadremove": this._removeUploadedFileHandler,
        // The cross button next to the "files from previous run"
        "click .removeFileButton": this._removeFileHandler,
        // When files are supplied in the options, you can cancel this
        "click .removeLastFilesButton": this._removeCustomFilesHandler,
        "click .nav-tabs li": this._tabClickedHandler,
        "click .submitToWorkflow": this._submitToWorkflowHandler,
        "click .cancelForm": this._cancelFormHandler,
        "click .alert .close": this._removeMessageHandler
      });
      if (this._areWeInsidePageBuilderPage()) {
        this._on(this.element, {
          "formrendererchange": this._formChangeHandler
        });
      }
    },
    _uploadFailedHandler: function _uploadFailedHandler(event, data) {
      showErrorMessage(data.error, $.i18n._("nixps-kiosk-newworkable.upload_failed"));
    },
    /**
     * @brief Returns a promise that resolves to the list of selected files
     * @name nixps-kiosk.CreateWorkable#_getSelectedFiles
     * @function
     * @private
     */
    _getSelectedFiles: function _getSelectedFiles() {
      // Collect the files
      var filesPromise = null;
      var selectedTab = this._getSelectedTab();
      if (selectedTab === "cloudflow") {
        var fileChooser = this.element.find(".nixps-cloudflow-FileChooser");
        filesPromise = $.when(fileChooser.FileChooser("getSelectedItems"));
      } else if (selectedTab === "upload") {
        var uploader = this.element.find(".nixps-cloudflow-Upload");
        var assets = uploader.Upload("getUploadedAssets");
        var uploadedFiles = [];
        for (var countAssets = 0; countAssets < assets.length; ++countAssets) {
          uploadedFiles.push(assets[countAssets].cloudflow.part);
        }
        filesPromise = $.when(uploadedFiles);
      } else if (selectedTab === "frame-host") {
        var framehost = this.element.find(".nixps-kiosk-FrameHostFileSelector");
        filesPromise = framehost.FrameHostFileSelector("getSelectedFiles");
      }
      return filesPromise;
    },
    /**
     * @description Triggered when the user changes the file selection in the host file selector
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_hostFileSelectionChangedHandler
     */
    _hostFileSelectionChangedHandler: function _hostFileSelectionChangedHandler() {
      if (!this.hostname) {
        return;
      }
      var framehost = this.element.find(".nixps-kiosk-FrameHostFileSelector");
      this.options.selectedFiles = framehost.FrameHostFileSelector("getSelectedFileUrls");
    },
    /**
     * @brief handlers runs when hostuploading a file is done,
     * when a user finished uploading a file
     * @name nixps-kiosk.CreateWorkable#_fileAddedHandler
     * @private
     * @function
     * @param {type} pEvent
     * @param {type} pData
     * @returns {nothing}
     */
    _fileAddedHandler: function _fileAddedHandler(pEvent, pData) {
      // Updating the form is always needed now
      var that = this;
      this._getSelectedFiles().then(function (files) {
        that._updateInputOptionsData(files);
      });
    },
    /**
     * @description The user is being uploading files, is uploading has just started
     * @function
     * @name nixps-kiosk.CreateWorkable#_uploadStartHandler
     * @private
     * @param {object} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _uploadStartHandler: function _uploadStartHandler() {
      this._cannotSubmit();
    },
    /**
     * @description The user is done uploading files, is uploading has just stopped
     * @name nixps-kiosk.CreateWorkable#_uploadStopHandler
     * @function
     * @private
     * @param {object} pEvent
     * @param {object} pData
     * @returns {undefined}
     */
    _uploadStopHandler: function _uploadStopHandler() {
      var that = this;
      this._getSelectedFiles().then(function (files) {
        that._updateInputOptionsData(files);
      });
    },
    /**
     * @description Puts the submit button in waiting state
     * @name nixps-kiosk.CreateWorkable#_checkingSubmit
     * @function
     * @private
     * @param message the message to display on the submit button while the metadata is being retrieved
     */
    _checkingSubmit: function _checkingSubmit(message) {
      if (message) {
        this.element.find(".submitToWorkflow").text(message);
      }
      this.element.find(".submitToWorkflow").prop("disabled", true);
      this.isSubmittingBlocked = true;
    },
    /**
     * @brief This function make sure the user cannot submit.
     *        Optionally an error message can be shown.
     * @function
     * @name nixps-kiosk.CreateWorkable#_cannotSubmit
     * @private
     * @param {*} errorMessage 
     */
    _cannotSubmit: function _cannotSubmit(errorMessage) {
      if (errorMessage) {
        this._addErrorMessage({
          messages: [{
            description: errorMessage
          }]
        });
      }
      this.element.find(".submitToWorkflow").text(this.options.submitButtonText).prop("disabled", true);
      this.isSubmittingBlocked = true;
    },
    /**
     * @brief Re-enable the submit action and clear messages
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_canSubmit
     * @param {*} errorMessage 
     */
    _canSubmit: function _canSubmit() {
      var messageList = this.element.find(".messages");
      messageList.empty();
      this.element.find(".submitToWorkflow").text(this.options.submitButtonText).prop("disabled", false);
      this.isSubmittingBlocked = false;
    },
    clearMessages: function clearMessages() {
      var messageList = this.element.find(".messages");
      messageList.empty();
    },
    /**
     * @brief Updates the input options when an uploaded file is removed
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_removeUploadedFileHandler
     */
    _removeUploadedFileHandler: function _removeUploadedFileHandler() {
      // File is removed, so options data needs to be updated
      var that = this;
      this._getSelectedFiles().then(function (files) {
        that._updateInputOptionsData(files);
      });
    },
    /**
     * @description function runs when user press the delete button next to the files that are added via 
     *              the option "files"
     * @private
     * @function
     * @name nixps-kiosk.CreateWorkable#_removeFileHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _removeFileHandler: function _removeFileHandler(pEvent) {
      var that = this;
      var inputOptions = this.inputOptions;
      var file = $(pEvent.currentTarget).attr("data-file");
      if (this._trigger("removefile", pEvent, {
        custom: false,
        file: file
      }) !== false) {
        // remove the selected element from inputFiles
        this.options.inputFiles = $.map(this.options.inputFiles, function (inputFile) {
          if (file === inputFile) {
            return null; // return nothing // do not add element to array
            // eq remove element
          } else {
            return inputFile;
          }
        });

        // show the selection panel, because there is one file less
        var selectionFilesDef = {};
        if (inputOptions.hasFileUpload()) {
          selectionFilesDef = this._drawSelectionFiles(inputOptions);
        }

        // File is removed, so options data needs to be updated
        $.when(selectionFilesDef, this._getSelectedFiles()).then(function (pAllFiles, files) {
          return that._updateInputOptionsData(files);
        }).then(function () {
          that._trigger("removedfile", null);
        });
      }
    },
    /**
     * @description Function runs when user clicks on the button to remove the "last chosen files" 
     *              and to choose new files.  
     *              This action cancels the rerun (that"s why the "removefile" event is triggered)
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_removeCustomFilesHandler
     * @param {type} pEvent
     * @param {type} pData
     * @returns {undefined}
     */
    _removeCustomFilesHandler: function _removeCustomFilesHandler(pEvent) {
      var that = this;
      if (this._trigger("removefile", pEvent, {
        custom: true
      }) !== false) {
        // redraw the file selection and upload
        this.options.placeHolderName = null;
        var selectionFilesDef = {};
        if (this.inputOptions.hasFileUpload() || this.inputOptions.hasFileBrowser()) {
          selectionFilesDef = this._drawSelectionFiles(this.inputOptions);
        }

        // File is removed, so options data needs to be updated
        $.when(selectionFilesDef, this._getSelectedFiles()).then(function (allFiles, files) {
          return that._updateInputOptionsData(files);
        }).then(function () {
          that._trigger("removedfile", null);
        });
      }
    },
    /**
     * @brief This function will retrieve the input options
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_updateInputOptionsData
     */
    _updateInputOptionsData: function _updateInputOptionsData(files) {
      var projectFormEl = this._getProjectFormEl();
      var submitFormEl = this._getSubmitFormEl();
      if (Array.isArray(files) && files.length > 0) {
        projectFormEl.FormRenderer("processNeededMetadata");
        submitFormEl.FormRenderer("processNeededMetadata");
        this._checkingSubmit($.i18n._("nixps-kiosk-newworkable.checking_mime_types"));
      } else {
        // Reset the FORM and return (no files are passed)
        projectFormEl.FormRenderer("resetMetadata");
        submitFormEl.FormRenderer("resetMetadata");
        this._canSubmit();
        return;
      }
      clearTimeout(this.inputOptionsDataTimerId);
      var inputOptions = this.inputOptions;
      var whitepaper = inputOptions.getWhitepaper();
      var inputname = inputOptions.getInputName();
      var types = [];
      if (inputOptions.checksMimeTypes()) {
        types = types.concat(["MimeTypesPerFile"]);
      } else {
        this._canSubmit();
      }
      if (projectFormEl.length === 1) {
        types = types.concat(projectFormEl.FormRenderer("getNeededMetadata"));
      }
      if (submitFormEl.length === 1) {
        types = types.concat(submitFormEl.FormRenderer("getNeededMetadata"));
      }
      types = _.uniq(types);
      if (types.length === 0) {
        return;
      }
      var that = this;
      var callID = ++this.inputOptionsDataCallID;
      var inputOptionsMimes = InputOptionsData.mimeArrayToDict(types);
      return api_defer.hub.get_whitepaper_input_options_data(whitepaper, inputname, inputOptionsMimes, files).then(function (result) {
        if (that.inputOptionsDataCallID > callID) {
          // floating call
          return;
        }
        var data = new InputOptionsData(result);
        if (data.hasTypes(["MimeTypesPerFile"])) {
          var mimeData = data.getData(["MimeTypesPerFile"])[0];
          var accepted = true;
          for (var i = 0; i < mimeData.length; i++) {
            if (inputOptions.acceptsMimeTypes(mimeData[i]) === false) {
              accepted = false;
              break;
            }
          }
          if (accepted) {
            // OK case
            that._canSubmit();
          } else {
            // NOK case
            var acceptedMimeTypes = inputOptions.getAcceptedMimeTypes();
            that._cannotSubmit($.i18n._("nixps-kiosk-newworkable.incompatible_mimetypes", [acceptedMimeTypes.join(", ")]));
          }
        }
        if (projectFormEl.length === 1) {
          var projectTypes = projectFormEl.FormRenderer("getNeededMetadata");
          if (data.hasTypes(projectTypes)) {
            var formData = data.getDataForForm(projectTypes);
            projectFormEl.FormRenderer("setNeededMetadata", formData);
          }
        }
        if (submitFormEl.length === 1) {
          var submitTypes = submitFormEl.FormRenderer("getNeededMetadata");
          if (data.hasTypes(submitTypes)) {
            var formData = data.getDataForForm(submitTypes);
            submitFormEl.FormRenderer("setNeededMetadata", formData);
          }
        }
        if (data.needsPolling()) {
          var defer = $.Deferred();
          that.inputOptionsDataTimerId = that._delay(function () {
            defer = $.when(that._updateInputOptionsData(files));
          }, Device.getPollingFactor(that.uuid) * 3000);
          return defer;
        }
      })["catch"](console.error);
    },
    /**
     * @description function runs when use clicked on a tab, to switch from uploader to selector or the other way
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_tabClickedHandler
     * @returns {undefined}
     */
    _tabClickedHandler: function _tabClickedHandler(pEvent) {
      var target = $(pEvent.currentTarget).closest("li");
      // Update the active class
      this.element.find(".nav").find("li").removeClass("active").attr("aria-selected", "false");
      target.addClass("active").attr("aria-selected", "true");

      // Show the correct tab
      var tabName = $(pEvent.currentTarget).children("[tab]").attr("tab");
      if (tabName === undefined) {
        tabName = $(pEvent.currentTarget).closest("[tab]").attr("tab");
      }
      this.element.find(".fileSelector [data-tab]").hide();
      var currentTab = this.element.find(".fileSelector [data-tab='" + tabName + "']");
      currentTab.show();
      this._fileAddedHandler({
        target: currentTab
      });
    },
    /**
     * @description returns the selected tab
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_getSelectedTab
     * @returns {string} The name of the tab or null if nothing found
     */
    _getSelectedTab: function _getSelectedTab() {
      var selectedTab = this.element.find(".nav").find("li.active");
      if (selectedTab.length > 0) {
        var tabName = selectedTab.find("a").attr("tab");
        if (typeof tabName === "string") {
          return tabName;
        }
        return null;
      }
      return null;
    },
    /**
     * @description Function runs when submitbutton is clicked
     * @function
     * @private
     * @name nixps-kioks.CreateWorkable#_submitToWorkflowHandler
     */
    _submitToWorkflowHandler: function _submitToWorkflowHandler(pEvent, pData) {
      this.submitForm(undefined, "intern_submit_button");
    },
    /**
     * @description call the workflow with the form values
     * @function
     * @name nixps-kioks.CreateWorkable#submitForm
     * @param {Boolean} pWaitForHttpReply must we return a promise for the http reply node?
     * @param {String} pCallReasonCode a string that indicates why it is called     
     * @returns {Promise.<Object>} returns the results or the workable id
     */
    submitForm: function submitForm(pWaitForHttpReply, pCallReasonCode) {
      var that = this;
      var whitepaper = this.options.whitepaper;
      var inputname = this.options.whitepaperInputName;
      var inputFiles = this.options.inputFiles;
      var projectFormEl = this._getProjectFormEl();
      var submitFormEl = this._getSubmitFormEl();

      // special "or" because both functions must run
      if (submitFormEl.FormRenderer("isValid") === false | projectFormEl.FormRenderer("isValid") === false) {
        return {
          is_valid: false
        };
      }
      if (pCallReasonCode === undefined) {
        pCallReasonCode = "external";
      }
      if (this.options.showOverlay === true) {
        var freezeOverlay = this.element.find(".nixps-FreezeOverlay");
        freezeOverlay.FreezeOverlay("show");
      }
      this.element.find(".submitToWorkflow").prop("disabled", true);
      this.isSubmittingBlocked = true;
      var filesPromise = $.when([]);
      var selectedTab = this._getSelectedTab();
      var selectorComponent = this.element.find('.fileSelector [data-tab="' + selectedTab + '"]');
      if (selectorComponent.hasClass("nixps-cloudflow-FileChooser")) {
        filesPromise = $.when(selectorComponent.FileChooser("getSelectedItems"));
      } else if (selectorComponent.hasClass("nixps-cloudflow-Upload")) {
        var assets = selectorComponent.Upload("getSortedUploadedAssets");
        var uploadedFiles = [];
        for (var countAssets = 0; countAssets < assets.length; ++countAssets) {
          uploadedFiles.push(assets[countAssets].cloudflow.part);
        }
        filesPromise = $.when(uploadedFiles);
      } else if (selectorComponent.hasClass("nixps-kiosk-FrameHostFileSelector")) {
        filesPromise = selectorComponent.FrameHostFileSelector("getSelectedFiles");
      }
      var inputOptions = this.inputOptions;
      var checkFiles = this.options.checkFiles;
      var defaultSubmitVariables = this.options.defaultSubmitVariables;
      return filesPromise.then(function (files) {
        if (Array.isArray(inputFiles) && inputFiles.length > 0) {
          files = files.concat(inputFiles);
        }
        if (inputOptions.getUploadMode() === "One" && files.length > 1) {
          files = [files[0]];
        }
        return $.when(checkFiles(files, whitepaper, inputname));
      }).then(function (pFiles) {
        if (Array.isArray(pFiles) === false) {
          that._addErrorMessage({
            messages: [{
              description: "technical error: Returning value must be an array"
            }]
          });
          throw new Error("returning object must be an array");
        }
        var files = pFiles;
        // get variables from "form", overwrite the defaults and save in variable "variabels"
        var variables = Object.assign({}, defaultSubmitVariables);
        if (submitFormEl[0].isConnected === false) {
          // the form is removed, out of the DOM
          var errorData = {
            error_code: "form_dom_removed",
            error: "conflict in parallel multiple calls"
          };
          return Promise.reject(errorData);
        }
        var optionVariables = submitFormEl.FormRenderer("getValues");
        if ($.isPlainObject(optionVariables) === true) {
          if (that.options.plainObjectInput === true) {
            optionVariables = optionVariables.ConfigurePlainObject;
          }
          variables = Object.assign(variables, optionVariables);
        }
        var projectData = projectFormEl.FormRenderer("getValues");
        if ($.isPlainObject(projectData) === false) {
          projectData = undefined;
        }
        if (pWaitForHttpReply === true) {
          return $.when(submitToWorkflow(whitepaper, inputname, files, variables, projectData)).then(function (pResult) {
            var connection = new WhitepaperConnection(whitepaper, inputname, variables, undefined, true);
            connection.onprogress = function (pEvent, pData) {};
            return connection.catchup(pResult).progress(function (pProgress) {
              // check if there are actions requests
              if (pProgress !== undefined && typeof pProgress.action === "string") {
                pProgress.defer.resolve({});
              }
            })["catch"](function (pError) {
              console.error(pError);
              return $.Deferred().reject(pError);
            });
          });
        } else {
          return submitToWorkflow(whitepaper, inputname, files, variables, projectData);
        }
      }).then(function (pResult) {
        if (that.options.showOverlay === true) {
          freezeOverlay.filter(".nixps-FreezeOverlay").FreezeOverlay("hide");
        }
        that._addNewWorkableMessage(pResult);
        if (that.options.resetFormAfterSubmit === true) {
          that.cancelForm();
        }
        that.element.find(".submitToWorkflow").prop("disabled", false);
        that.isSubmittingBlocked = false;
        that._trigger("submitted", null, {
          workable: pResult
        });
        return pResult;
      }).fail(function (pError) {
        if (that.options.showOverlay === true) {
          freezeOverlay.filter(".nixps-FreezeOverlay").FreezeOverlay("hide");
        }
        if (pError && _typeof(pError) === "object" && pError.error_type === "form_structured") {
          // error from workflow
          that._getSubmitFormEl().FormRenderer("showStructuredErrorMessages", pError);
          that._getProjectFormEl().FormRenderer("showStructuredErrorMessages", pError);
        } else {
          that._clearNewWorkableMessage(); // clear messages from previous submit
          that._addErrorMessage(pError);
        }
        var errorData = {};
        if (pError !== undefined && typeof pError.error === "string") {
          errorData = pError;
        } else {
          errorData.error = pError;
        }
        that.element.find(".submitToWorkflow").prop("disabled", false);
        that.isSubmittingBlocked = false;
        that._trigger("error", null, errorData);
        LogListener.addLog({
          event_type: "error",
          details_data: errorData,
          component_name: that.widgetFullName
        }, that.element);
      });
    },
    /**
     * @description function runs when user want to cancel the selected options
     * @function
     * @private
     * @name nixps-kioks.CreateWorkable#_cancelFormHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _cancelFormHandler: function _cancelFormHandler(pEvent, pData) {
      this.cancelForm();
      this._trigger("cancelled", null, {});
    },
    /**
     * @brief Close is clicked
     * @function
     * @private
     * @name nixps-kioks.CreateWorkable#_removeMessageHandler
     * @returns {undefined}
     */
    _removeMessageHandler: function _removeMessageHandler(pEvent) {
      var target = $(pEvent.target);
      target.parents(".alert").remove();
    },
    /**
     * @description function runs only in pagebuilder, when a change has been detected in a form, can be removed
     * by function _triggerFormChange, if no listeners are there
     * @function
     * @private
     * @name nixps-kioks.CreateWorkable#_formChangeHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _formChangeHandler: function _formChangeHandler(pEvent, pData) {
      if ($(pEvent.target).closest(".nixps-cloudflow-FormRenderer").parent().is(".projectForm, .submitOptions")) {
        this.formChangeTriggerData.todoStack.push(pEvent);
        this._triggerFormChange();
      }
    },
    /**
     * @description Function to trigger in a intelligent way a trigger, do no overload the server. Only used in pagebuilder
     * @function
     * @private
     * @name nixps-kioks.CreateWorkable#_triggerFormChange
     * @returns {undefined}
     */
    _triggerFormChange: function _triggerFormChange() {
      var that = this;
      // first stopping previous event, even if component is gone
      if (this.formChangeTriggerData.running === true) {
        // stop processing next action, in current flow 
        this.formChangeTriggerData.runningEvent.stopImmediatePropagation();
        // do not trigger, if the event is still bussy in progress
        return null;
      }
      if (this.alive === false) {
        return null; // do not retrigger if it is a zombie
      }
      // use same parameter names as in workflow
      var eventData = {
        variables: this._getSubmitFormEl().FormRenderer("getValues"),
        project_data: undefined
      };
      if (this._getProjectFormEl().length === 1) {
        eventData.project_data = this._getProjectFormEl().FormRenderer("getValues");
      }
      // do not compare with previous, because change of same < chnage of difference
      // and the cost of compareing is big, one little chnage in tree is most common change
      // start blocking
      this.formChangeTriggerData.running = true;
      // retrieve event object that is send later
      var origEvent = undefined;
      this.element.one(this.widgetName.toLowerCase() + "formchanged", function (pEvent) {
        origEvent = pEvent;
      });
      this._trigger("formchanged", null, eventData);
      this.formChangeTriggerData.todoStack = [];
      this.formChangeTriggerData.runningEvent = origEvent;
      this.formChangeTriggerData.data = eventData;
      // does the trigger provides me a return interface from pagebuilder
      if (origEvent !== undefined && origEvent.result !== undefined && typeof origEvent.result.then === "function") {
        $.when(origEvent.result).always(function () {
          if (that.alive === false) {
            return; // do not retrigger if it is a zombie
          }
          // deblock
          that.formChangeTriggerData.running = false;
          // are there data waiting? retrigger
          if (that.formChangeTriggerData.todoStack.length > 0) {
            that._triggerFormChange();
          }
        });
      } else {
        // no active listenerers detected
        // remove trigger
        this._off(this.element, "formrendererchange");
        // deblock
        this.formChangeTriggerData.running = false;
      }
    },
    /**
     * @brief Builds up the complete html of the create workable panel
     * @name nixps-kioks.CreateWorkable#_draw
     * @function
     * @private
     */
    _draw: function _draw() {
      // Clear the element
      this.element.empty();
      // styling
      if (this.options.stickToBorders === true) {
        this.element.removeClass("nixps-kiosk-CreateWorkable-padding");
      } else {
        this.element.addClass("nixps-kiosk-CreateWorkable-padding");
      }

      // add message panel
      if (this.options.addSuccessPanel === true) {
        this.element.append($("<div>").addClass("messages cf-message-success"));
      }
      this.element.append($("<div>").addClass("messages cf-message-error"));

      // Create the titles and panel divs
      var addOptionsTitle = true;
      var addFilesTitle = true;
      var panels = this.options.panels;
      for (var i = 0; i < panels.length; i++) {
        var panel = panels[i];
        if (panel === "submitOptions") {
          addFilesTitle = true;
          if (addOptionsTitle === true) {
            var optionsTitle = $("<h4>").addClass("sectionTitle options cf-title-h4").append($("<small>").text($.i18n._("nixps-kiosk-newworkable.options")));
            this.element.append(optionsTitle.toggle(this.options.showTitles));
            addOptionsTitle = false;
          }
          this.element.append($("<div>").addClass("submitOptions"));
        } else if (panel === "projectForm") {
          addFilesTitle = true;
          if (addOptionsTitle === true) {
            var optionsTitle = $("<h4>").addClass("sectionTitle options cf-title-h4").append($("<small>").text($.i18n._("nixps-kiosk-newworkable.options")));
            this.element.append(optionsTitle.toggle(this.options.showTitles));
            addOptionsTitle = false;
          }
          this.element.append($("<div>").addClass("projectForm"));
        } else if (panel === "filesSelection") {
          addOptionsTitle = true;
          if (addFilesTitle === true) {
            var optionsTitle = $("<h4>").addClass("sectionTitle files cf-title-h4").append($("<small>").text($.i18n._("nixps-kiosk-newworkable.files")));
            this.element.append(optionsTitle.toggle(this.options.showTitles));
            addFilesTitle = false;
          }
          this.element.append($("<div>").addClass("fileSelector"));
        }
      }

      // add buttons
      var buttons = $("<div>").addClass("container-fluid createworkable_buttonbar").addClass(this.options.buttonbarClasses).toggleClass("cf-buttonbar-sticky", this.options.enableStickyButtons);
      buttons.append($("<button>").attr("data-style", "zoom-in").attr("type", "button").addClass("cancelForm").addClass(this.options.cancelButtonClasses).text(this.options.cancelButtonText).toggle(this.options.enableCancelButton === true));
      buttons.append($("<button>").attr("data-style", "zoom-in").attr("type", "button").addClass("submitToWorkflow").addClass(this.options.submitButtonClasses).text(this.options.submitButtonText).toggle(this.options.enableSubmitButton === true).prop("disabled", true));
      this.element.append(buttons);
      if (this.options.disabled === true) {
        buttons.hide();
      }
      if (this.options.enableStickyButtons === true) {
        // add extra div to add transparaenty background
        buttons.prepend($("<div>").addClass("nixps_styling_constants_bodybackground"));
      }
      // add freezeOverlay
      if (this.options.showOverlay === true) {
        var freezeOverlay = $("<div>").FreezeOverlay({
          text: $.i18n._("nixps-kiosk-newworkable.submit_workable")
        });
        this.element.append(freezeOverlay);
      }
      this._redraw();
    },
    /**
     * @brief whitepaper or input has been changed
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_redraw
     */
    _redraw: function _redraw() {
      var that = this;
      var element = this.element;
      var whitepaper = this.options.whitepaper;
      var inputname = this.options.whitepaperInputName;
      var language = this.options.language;
      var dateFormat = this.options.dateFormat;
      var prefillFormValues = this.options.prefillFormValues;
      var prefillJobFormValues = this.options.prefillJobFormValues;

      // Check if there a whitepaper and input name
      if (whitepaper === null || inputname === null) {
        this._cannotSubmit($.i18n._("nixps-kiosk-newworkable.errormessage_workflownotfound", [""]));
        this._informCreated();
        return;
      }
      this.element.children(".createworkable_buttonbar").children(".submitToWorkflow").prop("disabled", true);
      var source = "whitepaper";
      var sourceName = whitepaper;
      var sourceSubName = inputname;
      var overwriteJobFormName = undefined;
      if (this.options.plainObjectInput === true) {
        source = "ConfigurePlainObject";
        sourceName = "";
        sourceSubName = "";
      } else if (typeof this.options.nucleusFormName === "string" && this.options.nucleusFormName.length > 0) {
        source = "nucleus.form";
        sourceName = this.options.nucleusFormName;
        sourceSubName = "";
      } else if (this.options.overwriteJobForm === true && typeof this.options.jobFormName === "string" && this.options.jobFormName.length > 0) {
        source = "overwrite_jobform";
        // sourceName keep like it is
        // sourceSubName keep like it is
        overwriteJobFormName = this.options.jobFormName;
      }

      // this.userDef should be in most cases already good,
      // it is just async for old self build pages
      $.when(getInputOptions(source, sourceName, sourceSubName, overwriteJobFormName), this.userDef).then(function (pResult) {
        if (that.alive === false) {
          // zombie
          return;
        }
        var inputOptions = new InputOptions(whitepaper, inputname, pResult);
        var submitOptionsEl = element.find(".submitOptions");
        var projectFormEl = element.find(".projectForm");
        var messagesEl = element.find(".messages");
        submitOptionsEl.empty();
        projectFormEl.empty();
        messagesEl.empty();
        var mainFormVariabels = $.extend(true, {}, inputOptions.getLocalization());
        var expressionToJS = new ExpressionToJS(that.options.mainFormVariables, that.user, undefined);
        var formExpression = expressionToJS.applyOnObject(inputOptions.getInputData(), function (pErrorMessage) {
          that._addErrorMessage({
            error: pErrorMessage
          });
        });
        var formJSON;
        if (formExpression.translatedObject !== undefined) {
          formJSON = formExpression.translatedObject;
        } else {
          // fallback
          formJSON = inputOptions.getInputData();
        }
        var layoutRenderOptions = undefined;
        if (typeof that.options.showContentTable === "boolean") {
          layoutRenderOptions = {
            table_of_contents: that.options.showContentTable
          };
        }
        $("<div>").appendTo(submitOptionsEl).FormRenderer({
          language: language,
          formClasses: that.options.formClasses,
          dateFormat: dateFormat,
          formJSON: formJSON,
          layoutJSON: inputOptions.getLayoutJSON(),
          layoutRenderOptions: layoutRenderOptions,
          returnActionHiddenFields: "current",
          variableDictionary: mainFormVariabels,
          applyActionOnHiddenFieldDuringInit: that.options.applyActionOnHiddenFieldDuringInit,
          startUpOldOptions: {
            whitepaper: inputOptions.getWhitepaper(),
            whitepaperInputName: inputOptions.getInputName()
          },
          submitCallBackFunction: function submitCallBackFunction(pReason) {
            if (that.isSubmittingBlocked === true) {
              return false;
            }
            try {
              that.submitForm(undefined, "form");
            } catch (e) {
              console.error(e);
              return false;
            }
            return false;
          },
          disabled: that.options.disabled
        });
        if (!$.isEmptyObject(prefillFormValues)) {
          that._getSubmitFormEl().FormRenderer("setValues", prefillFormValues);
        }

        // Is there a project form?
        if (inputOptions.hasProjectForm()) {
          var jobFormVariables = $.extend(true, {}, inputOptions.getProjectFormLocalization());
          var expressionToJS = new ExpressionToJS(that.options.jobFormVariables, that.user, undefined);
          var formProjectExpression = expressionToJS.applyOnObject(inputOptions.getProjectFormContents(), function (pErrorMessage) {
            that._addErrorMessage({
              error: pErrorMessage
            });
          });
          var formProjectJSON;
          if (formProjectExpression.translatedObject !== undefined) {
            formProjectJSON = formProjectExpression.translatedObject;
          } else {
            // fallback
            formProjectJSON = inputOptions.getProjectFormContents();
          }
          var layoutProjectRenderOptions = undefined;
          if (typeof that.options.showContentTable === "boolean") {
            layoutProjectRenderOptions = {
              table_of_contents: that.options.showContentTable
            };
          }
          $("<div>").appendTo(projectFormEl).FormRenderer({
            language: language,
            formClasses: that.options.formClasses,
            dateFormat: dateFormat,
            formJSON: formProjectJSON,
            layoutJSON: inputOptions.getProjectFormLayout(),
            layoutRenderOptions: layoutProjectRenderOptions,
            returnActionHiddenFields: "current",
            variableDictionary: jobFormVariables,
            applyActionOnHiddenFieldDuringInit: that.options.applyActionOnHiddenFieldDuringInit,
            startUpOldOptions: {
              whitepaper: inputOptions.getWhitepaper(),
              whitepaperInputName: inputOptions.getInputName()
            },
            disabled: that.options.disabled
          });
          if (typeof prefillJobFormValues === "string" && prefillJobFormValues.length > 0) {
            // later
          } else if ($.isPlainObject(prefillJobFormValues) && !$.isEmptyObject(prefillJobFormValues)) {
            that._getProjectFormEl().FormRenderer("setValues", prefillJobFormValues);
          }
        }
        that.inputOptions = inputOptions;
        var filesSelectionDef = that._drawSelectionFiles(inputOptions);
        that.element.children(".createworkable_buttonbar").children(".submitToWorkflow").prop("disabled", false);
        // When input files are passed, calculate the input options for those files
        // Used in the asset view (asset is passed as inputfile)
        var updateInputOptionsDef = {};
        if (Array.isArray(that.options.inputFiles) && that.options.inputFiles.length > 0) {
          updateInputOptionsDef = that._updateInputOptionsData(that.options.inputFiles);
        }
        $.when(filesSelectionDef, updateInputOptionsDef).always(function () {
          that._trigger("drawed", null, {
            whitepaper: whitepaper,
            whitepaperInputName: inputname
          });
          that._informCreated();
        });
      }).fail(function (pError) {
        that.inputOptions = null;
        // show known errors to developer users
        if (pError !== undefined && pError.error_code === "WhitePaper not found") {
          that._cannotSubmit($.i18n._("nixps-kiosk-newworkable.errormessage_workflownotfound", [that.options.whitepaper]));
          that._informCreated();
        } else if (pError !== undefined && pError.error_code === "Input not found in WhitePaper") {
          that._cannotSubmit($.i18n._("nixps-kiosk-newworkable.errormessage_workflowinputnamenotfound", [that.options.whitepaperInputName]));
          that._informCreated();
        } else if (pError !== undefined && pError.error_code === "Form not found") {
          that._cannotSubmit($.i18n._("nixps-kiosk-newworkable.errormessage_jobformnotfound"));
          that._informCreated();
        } else {
          that._cannotSubmit();
          if (pError !== undefined && typeof pError.error === "string") {
            // display more useful error messsage
            console.error(pError.error);
          }
          that._informCreated();
          // other error
          throw new Error(pError);
        }
        that._trigger("error", null, pError);
        LogListener.addLog({
          event_type: "error",
          details_data: pError,
          component_name: that.widgetFullName
        }, that.element);
      });
    },
    _areWeInsidePageBuilderPage: function _areWeInsidePageBuilderPage() {
      // is in pagebuilder
      return this.options.fileChooserContext === "pagebuilder_custompage";
    },
    /**
     * @brief returns the project form
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_getProjectFormEl
     */
    _getProjectFormEl: function _getProjectFormEl() {
      return this.element.find(".projectForm > .nixps-cloudflow-FormRenderer");
    },
    /**
     * @brief returns the submit form
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_getSubmitFormEl
     */
    _getSubmitFormEl: function _getSubmitFormEl() {
      return this.element.find(".submitOptions > .nixps-cloudflow-FormRenderer");
    },
    /**
     * @brief returns the upload element
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_getUploadEl
     */
    _getUploadEl: function _getUploadEl() {
      return this.element.find(".nixps-cloudflow-Upload");
    },
    /**
     * @brief Updates the file section according to the upload options of the whitepaper input.
     * @private
     * @name nixps-kiosk.CreateWorkable#_drawSelectionFiles
     * @param {string} pWhitepaper
     * @param {string} pInput
     * @param {string} pUploadFilesMode "None" || "OneOrMore" || "One" || "NoneOrOne" || "Any"
     * @returns {undefined}
     */
    _drawSelectionFiles: function _drawSelectionFiles(inputOptions) {
      if (this.options.panels.includes("filesSelection") === false) {
        // if in special case. Do nothing about files!
        this.element.find(".sectionTitle.files").hide();
        return false;
      }
      var that = this;
      this.element.find(".fileSelector").empty();
      this.element.find(".sectionTitle.files").toggle(this.options.showTitles);
      if (inputOptions.getUploadMode() !== "None") {
        // No files can be uploaded
        var placeHolderName = this.options.placeHolderName;
        if (typeof placeHolderName === "string" && placeHolderName.length > 0) {
          this.element.find(".fileSelector").append($("<div>").each(function () {
            if (that.options.canChangeInputFiles === true) {
              $(this).append($("<button>").addClass("cf-icon cf-icon-times removeLastFilesButton").attr({
                type: "button",
                title: $.i18n._("nixps-kiosk-newworkable.no_files_remove")
              }));
            }
          }).append($("<span>").text(placeHolderName)));
          if (Array.isArray(this.options.inputFiles) && this.options.inputFiles.length > 0) {
            // populate the separations in Standalone RIP
            return this._updateInputOptionsData(this.options.inputFiles);
          }
        } else {
          // if rerun show "same files" panel
          var inputFiles = this.options.inputFiles;
          if (Array.isArray(inputFiles) && inputFiles.length > 0) {
            var files = [];
            // Check the case where there is more than one file supplied but the input accepts only one
            if (inputOptions.canUploadMultiple() === false && inputFiles.length > 1) {
              // files can come from higher regions, do not break (!?)
              // inform user and try to correct. This can be a problem by a custom developement
              if (this.options.canChangeInputFiles === true) {
                // add only error if files are not fixed
                this._addErrorMessage({
                  messages: [{
                    description: "Too many input files"
                  }]
                });
              }
              // add just one element
              files.push(this.options.inputFiles[0]);
            } else {
              files = this.options.inputFiles;
            }
            var fileIcon = $("<span>").addClass("glyphicon glyphicon-file");
            var removeFileIcon = $("<span>").addClass("fa fa-times removeFileButton").css({
              color: "black",
              "float": "right",
              cursor: "pointer"
            }).attr("title", $.i18n._("nixps-kiosk-newworkable.delete-file"));
            var that = this;
            for (var i = 0; i < files.length; i++) {
              var file = files[i];
              var fileItem = $("<div>").append(fileIcon.clone()).append($("<span>").text(decodeURI(getFileName(file))).css({
                "margin-left": 7,
                "word-break": "break-all"
              }).each(function () {
                if (that.options.canChangeInputFiles === true) {
                  $(this).append(removeFileIcon.clone().attr("data-file", file));
                }
              }));
              this.element.find(".fileSelector").append(fileItem);
            }

            // add selection panel if we may add, if files are not fixed and if user may upload more, more, ... files
            if (this.options.canChangeInputFiles === true && inputOptions.canUploadMultiple()) {
              // if there are files and we can select a lot, the user must be able to select extra files
              return this._createFileSelectorPanel(this.element.find(".fileSelector"), this.inputOptions);
            }
          } else {
            return $.when(
            // if no files in options and not a rerun, show normal case
            this._createFileSelectorPanel(this.element.find(".fileSelector"), this.inputOptions),
            // populate the separations in Standalone RIP
            this._updateInputOptionsData(files));
          }
        }
      } else {
        // pUploadFilesMode is equal "None", users may not select or upload files
        this.element.find(".sectionTitle.files").hide();
      }
    },
    applyFromAdaptation: function applyFromAdaptation(pFormAdaptation) {
      this.element.children(".submitOptions").children(".nixps-cloudflow-FormRenderer").FormRenderer("applyAdaptation", pFormAdaptation);
      this.element.children(".projectForm").children(".nixps-cloudflow-FormRenderer").FormRenderer("applyAdaptation", pFormAdaptation);
    },
    /**
     * @description Reset the form to the default values
     * @function
     * @name nixps-kiosk.CreateWorkable#cancelForm
     * @return {undefined}
     */
    cancelForm: function cancelForm() {
      var submitForm = this._getSubmitFormEl();
      if (submitForm.length >= 1) {
        submitForm.FormRenderer("redraw");
        if (!$.isEmptyObject(this.options.prefillFormValues)) {
          submitForm.FormRenderer("setValues", this.options.prefillFormValues);
        }
      }
      var projectForm = this._getProjectFormEl();
      if (projectForm.length >= 1) {
        projectForm.FormRenderer("redraw");
        if (!$.isEmptyObject(this.options.prefillJobFormValues)) {
          projectForm.FormRenderer("setValues", this.options.prefillJobFormValues);
        }
      }
      var uploadDOM = this._getUploadEl();
      if (uploadDOM.length >= 1) {
        // only redraw if there is an upload, sometimes we do not need to include upload components
        uploadDOM.Upload("redraw");
      }
    },
    /**
     * @description pagebuilder page action function. This function is used as a pagebuilder action to wait 
     *              after submitting
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#waitUntilSubmitWorkflowIsDone
     * @param {Object} pSubmitReturnData
     * @returns {Deferred} 
     */
    waitUntilSubmitWorkflowIsDone: function waitUntilSubmitWorkflowIsDone(pSubmitReturnData, pDisableFields) {
      var that = this;
      if (pDisableFields === true) {
        this._getSubmitFormEl().FormRenderer("setReadOnly", true);
        this._getProjectFormEl().FormRenderer("setReadOnly", true);
      }
      var whitepaper = this.options.whitepaper;
      var inputname = this.options.whitepaperInputName;
      var connection = new WhitepaperConnection(whitepaper, inputname, {}, undefined, true);
      var workableData = pSubmitReturnData;
      if ($.isPlainObject(pSubmitReturnData.workable)) {
        workableData = pSubmitReturnData.workable;
      }
      if (typeof workableData.workable_id !== "string") {
        console.error("missing workable id");
        return $.Deferred().reject({
          error_code: "missing_workableid",
          error: "missing workable id"
        });
      }
      connection.onprogress = function (pEvent, pProgressData) {
        // check if there are actions requests
        // if (pProgressData !== undefined && typeof pProgressData.action === "string") {
        //     pProgressData.defer.resolve({});
        // }
      };
      // catch up existing workable
      return connection.catchup(workableData).progress(function (pProgress) {
        // check if there are actions requests
        if (pProgress !== undefined && typeof pProgress.action === "string") {
          pProgress.defer.resolve({});
        }
      })["catch"](function (pError) {
        if (pError && _typeof(pError) === "object" && pError.error_type === "form_structured") {
          // error from workflow
          that._getSubmitFormEl().FormRenderer("showStructuredErrorMessages", pError);
          that._getProjectFormEl().FormRenderer("showStructuredErrorMessages", pError);
        } else {
          console.error(pError);
        }
        return $.Deferred().reject(pError);
      }).always(function () {
        if (pDisableFields === true) {
          that._getSubmitFormEl().FormRenderer("setReadOnly", false);
          that._getProjectFormEl().FormRenderer("setReadOnly", false);
        }
      });
    },
    /**
     * @description validate the form and return hte result
     * @function
     * @name nixps-kiosk.CreateWorkable#isFormValid
     * @returns {Object} is_valid and error_message
     */
    isFormValid: function isFormValid() {
      var isSubmitFormValid;
      if (this._getSubmitFormEl().length === 1) {
        isSubmitFormValid = this._getSubmitFormEl().FormRenderer("isValid", true, true);
      } else {
        isSubmitFormValid = "main form is not present";
      }
      var isJobFormValid;
      if (this._getProjectFormEl().length === 1) {
        isJobFormValid = this._getProjectFormEl().FormRenderer("isValid", true, true);
      } else {
        isJobFormValid = true; // if no job form, then the form is valid
      }

      if (isSubmitFormValid === true && isJobFormValid === true) {
        return {
          is_valid: true,
          error_message: null
        };
      } else {
        var error_message = "";
        if (typeof isSubmitFormValid === "string" && isSubmitFormValid.length > 0) {
          error_message += isSubmitFormValid;
        }
        if (typeof isJobFormValid === "string" && isJobFormValid.length > 0) {
          if (error_message.length > 0) {
            error_message += ", ";
          }
          error_message += isJobFormValid;
        }
        return {
          is_valid: false,
          error_message: error_message
        };
      }
    },
    /**
     * @description Get the values of the form
     * @function
     * @name nixps-kiosk.CreateWorkable#getFormValues
     * @returns {Object} variables and project_data
     */
    getFormValues: function getFormValues() {
      if (this._getSubmitFormEl().length === 0) {
        // the main form is not present, due to creation fase or error
        // return empty data
        return {
          variables: undefined,
          project_data: undefined
        };
      }
      var eventData = {
        variables: this._getSubmitFormEl().FormRenderer("getValues"),
        project_data: undefined
      };
      if (this._getProjectFormEl().length === 1) {
        eventData.project_data = this._getProjectFormEl().FormRenderer("getValues");
      }
      return eventData;
    },
    /**
     * @description Creates the file selector panel
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_createFileSelectorPanel
     * @param {Boolean} pEnableUpload must the user be able to upload a file, true: panel to upload file is aviable
     * @param {Boolean} pEnableSelect The user must be able to select a file, true: panel to select a file is visible, and aviable
     */
    _createFileSelectorPanel: function _createFileSelectorPanel(pParentDiv, inputOptions) {
      var that = this;
      var idPrefix = "nixps_cloudflow_" + this.widgetName + "_" + this.uuid;
      var selectorPanel = $("<div>").addClass("cf-tab cf-tab-bootstrap");
      if (this.options.disabled === true) {
        selectorPanel.hide();
      }
      var returnDefs = [];
      var ulList = $("<ul>").addClass("nav nav-tabs").attr("role", "tablist");
      var liItemUpload = $("<li>").attr({
        "role": "tab",
        "aria-selected": "false",
        "aria-controls": idPrefix + "_panel_upload"
      });
      liItemUpload.append($("<a>").attr({
        "tab": "upload",
        "tabIndex": -1,
        "id": idPrefix + "_tab_upload"
      }).text($.i18n._("nixps-kiosk-newworkable.upload")));
      var liItemCloudflow = $("<li>").attr({
        "role": "tab",
        "aria-selected": "false",
        "aria-controls": idPrefix + "_panel_cloudflow"
      });
      liItemCloudflow.append($("<a>").attr({
        "tab": "cloudflow",
        "tabIndex": -1,
        "id": idPrefix + "_tab_cloudflow"
      }).text($.i18n._("nixps-kiosk-newworkable.cloudflow")));
      if (inputOptions.hasFileUpload()) {
        ulList.append(liItemUpload);
      }
      if (inputOptions.hasFileBrowser()) {
        ulList.append(liItemCloudflow);
      }
      if (inputOptions.hasFileBrowser() || inputOptions.hasFileUpload()) {
        ulList.append($("<li>").attr({
          "role": "tab",
          "aria-selected": "false",
          "aria-controls": idPrefix + "_panel_frame-host"
        }).addClass("frame-host-feature").append($("<a>").attr({
          "tab": "frame-host",
          "tabIndex": -1,
          "id": idPrefix + "_tab_frame-host"
        }).text($.i18n._("nixps-kiosk-newworkable.host"))));
      }

      // Create the tabs
      var additionalFileSelectors = this.options.additionalFileSelectors;
      if (Array.isArray(additionalFileSelectors) && additionalFileSelectors.length > 0) {
        for (var i = 0; i < additionalFileSelectors.length; i++) {
          // upload | select
          var fileSelector = additionalFileSelectors[i];
          if (fileSelector.enablecheck === "upload" && inputOptions.hasFileUpload() === true || fileSelector.enablecheck === "select" && inputOptions.hasFileBrowser() === true) {
            ulList.append($("<li>").attr({
              "role": "tab",
              "aria-selected": "false",
              "aria-controls": idPrefix + "_panel_" + fileSelector.tab_name
            }).append($("<a>").attr({
              "tab": fileSelector.tab_name,
              "tabIndex": -1,
              "id": idPrefix + "_tab_" + fileSelector.tab_name
            }).text(fileSelector.tab_label)));
          }
        }
      }
      selectorPanel.append(ulList);

      // calc the index of the tab that must be selected
      var selectedTabIndex = 0;
      var selectedTab = selectorPanel.find('a[tab="' + this.options.fileSelectorsActiveTab + '"]');
      if (selectedTab.length > 0) {
        selectedTabIndex = selectedTab.closest("li").prevAll().length;
      }
      selectorPanel.find("li").eq(selectedTabIndex).addClass("active").attr("aria-selected", "true");
      selectorPanel.find(".nav").css({
        "margin-bottom": 0
      });
      pParentDiv.append(selectorPanel);
      var selectionHeight = "";
      // accept 0 but ignore
      if (typeof this.options.fileSelectionHeight === "number" && this.options.fileSelectionHeight > 50) {
        selectionHeight = this.options.fileSelectionHeight;
      }
      var visibleTabsIndex = 0;
      var session = "";
      if (api_util.get_session() !== undefined) {
        session = "&session=" + api_util.get_session();
      }
      if (inputOptions.hasFileUpload()) {
        // Upload
        var whitepaper = inputOptions.getWhitepaper();
        var inputname = inputOptions.getInputName();
        var uploadUrl = "?hub=upload_file&whitepaper_name=" + encodeURIComponent(whitepaper) + "&input_name=" + encodeURIComponent(inputname) + session;
        selectorPanel.append($("<div>").addClass("upload").addClass(this._areWeInsidePageBuilderPage() ? "nixps_styling_constants_bodybackground" : "").attr({
          "role": "tabpanel",
          "data-tab": "upload",
          "id": idPrefix + "_panel_upload",
          "aria-labelledby": idPrefix + "_tab_upload"
        }).Upload({
          multiple: inputOptions.canUploadMultiple(),
          uploadUrl: uploadUrl,
          enableBootstrapUI: true
        }).toggle(selectedTabIndex === 0).css("height", selectionHeight));
        visibleTabsIndex++;
      }
      if (inputOptions.hasFileBrowser()) {
        // file chooser
        var fileChooserCreated = $.Deferred();
        returnDefs.push(fileChooserCreated);
        selectorPanel.append($("<div>").addClass("fileSelector").addClass(this._areWeInsidePageBuilderPage() ? "nixps_styling_constants_bodybackground" : "").attr({
          "role": "tabpanel",
          "data-tab": "cloudflow",
          "id": idPrefix + "_panel_cloudflow",
          "aria-labelledby": idPrefix + "_tab_cloudflow"
        }));
        selectorPanel.children(".fileSelector").toggle(selectedTabIndex === visibleTabsIndex).css("height", selectionHeight);
        $.when(this.consentDef).done(function () {
          selectorPanel.children(".fileSelector").FileChooser({
            context: that.options.fileChooserContext,
            multiple: inputOptions.canUploadMultiple(),
            url: inputOptions.getDefaultFileBrowserLocation(),
            rootFolders: inputOptions.hasDefaultFileBrowserLocation() && inputOptions.hasLockOnDefaultFileBrowserLocation() ? [inputOptions.getDefaultFileBrowserLocation()] : undefined,
            enableSearchFilter: true,
            consent: that.consent,
            created: function created() {
              fileChooserCreated.resolve();
            }
          });
        });
        visibleTabsIndex++;
      }
      if (inputOptions.hasFileBrowser() || inputOptions.hasFileUpload()) {
        selectorPanel.append($("<div>").addClass("frame-host-feature-block").attr({
          "role": "tabpanel",
          "data-tab": "frame-host",
          "id": idPrefix + "_panel_frame-host",
          "aria-labelledby": idPrefix + "_tab_frame-host"
        }).FrameHostFileSelector({
          enableMultiple: inputOptions.canUploadMultiple(),
          enableUpload: inputOptions.hasFileUpload(),
          enableSelect: inputOptions.hasFileBrowser(),
          whitepaper: inputOptions.getWhitepaper(),
          inputname: inputOptions.getInputName(),
          host: this.hostname
        }).toggle(selectedTabIndex === visibleTabsIndex++).css("height", selectionHeight));

        // Set the files that are selected when the "create new" in kiosk is opened
        if (this.hostname && Array.isArray(this.options.selectedFiles) && this.options.selectedFiles.length > 0) {
          var frameHostFileSelector = selectorPanel.find(".nixps-kiosk-FrameHostFileSelector");
          frameHostFileSelector.FrameHostFileSelector("setSelectedFiles", this.options.selectedFiles);
        }
      }
      if (Array.isArray(additionalFileSelectors) && additionalFileSelectors.length > 0) {
        for (var i = 0; i < additionalFileSelectors.length; i++) {
          // upload | select
          var fileSelector = additionalFileSelectors[i];
          if (fileSelector.enablecheck === "upload" && inputOptions.hasFileUpload()) {
            // Upload
            selectorPanel.append($("<div>").addClass(fileSelector.className).addClass("additionalFileSelector").addClass(this._areWeInsidePageBuilderPage() ? "nixps_styling_constants_bodybackground" : "").Upload(fileSelector.options).attr({
              "role": "tabpanel",
              "data-tab": fileSelector.tab_name,
              "id": idPrefix + "_panel_" + fileSelector.tab_name,
              "aria-labelledby": idPrefix + "_tab_" + fileSelector.tab_name
            }).toggle(selectedTabIndex === visibleTabsIndex).css("height", selectionHeight));
          } else if (fileSelector.enablecheck === "select" && inputOptions.hasFileBrowser()) {
            // file chooser
            var additionalFileChooserCreated = $.Deferred();
            returnDefs.push(additionalFileChooserCreated);
            fileSelector.options.created = function () {
              additionalFileChooserCreated.resolve(); // should be in additional wrapped function
            };

            fileSelector.options.context = this.options.fileChooserContext;
            fileSelector.options.multiple = inputOptions.canUploadMultiple();
            var fileSelectorDOM = $("<div>").addClass(fileSelector.className).addClass("additionalFileSelector").addClass(this._areWeInsidePageBuilderPage() ? "nixps_styling_constants_bodybackground" : "").attr({
              "role": "tabpanel",
              "data-tab": fileSelector.tab_name,
              "id": idPrefix + "_panel_" + fileSelector.tab_name,
              "aria-labelledby": idPrefix + "_tab_" + fileSelector.tab_name
            }).toggle(selectedTabIndex === visibleTabsIndex).css("height", selectionHeight);
            selectorPanel.append(fileSelectorDOM);
            $.when(this.consentDef, fileSelectorDOM, fileSelector).then(function (pConsent, pfileSelectorDOM, pfileSelector) {
              pfileSelector.options.consent = that.consent;
              if (typeof pfileSelector.options.url !== "string" && inputOptions.hasDefaultFileBrowserLocation()) {
                pfileSelector.options.url = inputOptions.getDefaultFileBrowserLocation();
                pfileSelector.options.rootFolders = inputOptions.hasLockOnDefaultFileBrowserLocation() ? [inputOptions.getDefaultFileBrowserLocation()] : undefined;
              }
              pfileSelectorDOM.FileChooser(pfileSelector.options);
            }, function (pError) {
              console.error(pError);
            });
          }
          visibleTabsIndex++;
        }
      }
      if (returnDefs.length === 0) {
        return;
      } else {
        return $.when.apply($, returnDefs);
      }
    },
    /**
     * @desc adds a new error message
     * @private
     * @function
     * @name nixps-kiosk.CreateWorkable#_addErrorMessage
     */
    _addErrorMessage: function _addErrorMessage(pError) {
      var messageList = this.element.find(".messages.cf-message-error");
      messageList.empty();
      var description = "";
      if (Array.isArray(pError.messages) && pError.messages.length > 0) {
        description = pError.messages[0].description;
      } else if (typeof pError.error === "string") {
        description = pError.error;
      } else {
        description = $.i18n._("nixps-kiosk-newworkable.unknown_error");
      }
      var message = $("<div>").addClass("alert alert-danger alert-dismissible").text("Error: " + description).append($("<button>").attr("type", "button").addClass("close cf-closebutton").attr("data-dismiss", "alert").append($("<span>").attr("aria-hidden", "true").html("&times;")));
      messageList.append(message);
      // A bit dirty to scroll the parent to top, parent should do it itself
      this.element.parents(".workableList").scrollTop(0);
    },
    /**
     * @brief adds a message to the message section when a new workable is created
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_addNewWorkableMessage
     */
    _addNewWorkableMessage: function _addNewWorkableMessage(pWorkable) {
      var messageList = this.element.find(".messages.cf-message-success").last();
      if (messageList.length === 0) {
        // no messages platform to show
        return true;
      }
      messageList.empty();
      var messageText;
      var newWorkableMessage = this.options.newWorkableMessage;
      if (typeof newWorkableMessage === "string" && newWorkableMessage.length > 0) {
        // If a newWorkableMessage option is passed, use that
        messageText = newWorkableMessage;
      } else if (newWorkableMessage === null) {
        // Else use the "standard" message and fill in with the workable name
        messageText = $.i18n._("nixps-kiosk-newworkable.newworkable_message", [pWorkable.workable_name]);
      } else {
        // do nothing if nothing is asked, the user want propably no message
        return true;
      }
      var message = $("<div>").addClass("alert alert-success alert-dismissible").text(messageText).append($("<button>").attr("type", "button").addClass("close cf-closebutton").attr("data-dismiss", "alert").append($("<span>").attr("aria-hidden", "true").html("&times;")));
      messageList.append(message);
    },
    /**
     * @brief clear the messages panel
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_clearNewWorkableMessage
     */
    _clearNewWorkableMessage: function _clearNewWorkableMessage() {
      this.element.find(".messages.cf-message-success").last().empty();
    },
    _informCreated: function _informCreated() {
      if (this.creating === true) {
        this.created = false;
        this.options.created();
      }
    },
    _enable: function _enable() {
      this._getSubmitFormEl().FormRenderer("option", "disabled", false);
      this._getProjectFormEl().FormRenderer("option", "disabled", false);
      this.element.children(".sectionTitle[data-disabling-visible=true]").css("display", "").removeAttr("data-disabling-visible");
      this.element.children(".fileSelector").children(".cf-tab[data-disabling-visible=true]").css("display", "").removeAttr("data-disabling-visible");
      this.element.children(".createworkable_buttonbar").css("display", "");
    },
    _disable: function _disable() {
      this._getSubmitFormEl().FormRenderer("option", "disabled", true);
      this._getProjectFormEl().FormRenderer("option", "disabled", true);
      this.element.children(".sectionTitle").filter(":visible").attr("data-disabling-visible", true).hide();
      this.element.children(".fileSelector").children(".cf-tab").filter(":visible").attr("data-disabling-visible", true).hide();
      this.element.children(".createworkable_buttonbar").hide();
    },
    enable: function enable() {
      // ovewrite so it works on jquery ui < 1.12
      this._setOptions({
        "disabled": false
      });
    },
    disable: function disable() {
      // ovewrite so it works on jquery ui < 1.12
      this._setOptions({
        "disabled": true
      });
    },
    /**
     * @brief set the options
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_setOptions
     */
    _setOptions: function _setOptions(options) {
      var that = this;
      if (Array.isArray(options.panels) && _.isEqual(options.panels, this.options.panels) === false || typeof options.moveFileSectionToTop === "boolean" && options.moveFileSectionToTop !== this.options.moveFileSectionToTop) {
        this._superApply(arguments);
        this._checkOptions();
        this._draw();
        return true;
      }
      var needDisabling = false;
      if (typeof options.disabled === "boolean" && options.disabled !== this.options.disabled) {
        needDisabling = true;
      }
      var needRefresh = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRefresh = true;
        }
        ;
      });
      this._checkOptions();
      if (needRefresh === true) {
        // whitepaper or whitepaper input name has been changed
        // complete form upload must be changed
        this._redraw();
      }
      if (typeof options.submitButtonText === "string") {
        if (options.submitButtonText.length > 0) {
          this.element.find(".submitToWorkflow").text(options.submitButtonText);
        } else if (options.submitButtonText.length === 0) {
          this.element.find(".submitToWorkflow").text($.i18n._("nixps-kiosk-newworkable.submit"));
        }
      }
      if (typeof options.cancelButtonText === "string") {
        if (options.cancelButtonText.length > 0) {
          this.element.find(".cancelForm").text(options.cancelButtonText);
        } else if (options.cancelButtonText.length === 0) {
          this.element.find(".cancelForm").text($.i18n._("nixps-kiosk-newworkable.cancel"));
        }
      }
      if (typeof options.submitButtonClasses === "string") {
        // use function in removeClass method because there is a conflict between 
        // jquery 1.11 and jQuery-ui-1.9.2 and removing all elements with removeClass() does not work. 
        // By using a function it should work for multiple jQuery plugins.
        this.element.find(".submitToWorkflow").removeClass(function (pI, pClassName) {
          return pClassName;
        }).addClass("submitToWorkflow").addClass(options.submitButtonClasses);
      }
      if (typeof options.enableStickyButtons === "boolean") {
        this.element.children(".createworkable_buttonbar").toggleClass("cf-buttonbar-sticky", options.enableStickyButtons);
        // add or remove the transparency background
        if (options.enableStickyButtons === true) {
          this.element.children(".createworkable_buttonbar").prepend($("<div>").addClass("nixps_styling_constants_bodybackground"));
        } else {
          this.element.children(".createworkable_buttonbar").children(".nixps_styling_constants_bodybackground").remove();
        }
      }
      if (typeof options.enableCancelButton === "boolean") {
        this.element.find(".cancelForm").toggle(options.enableCancelButton === true);
      }
      if (typeof options.enableSubmitButton === "boolean") {
        this.element.find(".submitToWorkflow").toggle(options.enableSubmitButton === true);
      }
      if (typeof options.cancelButtonClasses === "string") {
        this.element.find(".cancelForm").removeClass(function (pI, pClassName) {
          return pClassName;
        }).addClass("cancelForm").addClass(options.cancelButtonClasses);
      }
      if (typeof options.buttonbarClasses === "string") {
        this.element.children(".createworkable_buttonbar").removeClass(function (pI, pClassName) {
          return pClassName;
        }).addClass("container-fluid createworkable_buttonbar").addClass(options.buttonbarClasses).toggleClass("cf-buttonbar-sticky", this.options.enableStickyButtons);
      }
      var currentMainValues = undefined,
        currentJobValues = undefined;
      if (options.mainFormVariables !== undefined) {
        if (this.inputOptions === null) {
          console.error("Could not update the form, because we probably did not found the workflow");
        } else {
          var expressionToJS = new ExpressionToJS(options.mainFormVariables, this.user, undefined);
          var formExpression = expressionToJS.applyOnObject(this.inputOptions.getInputData(), function (pErrorMessage) {
            that._addErrorMessage({
              error: pErrorMessage
            });
          });
          var formJSON;
          if (formExpression.translatedObject !== undefined) {
            formJSON = formExpression.translatedObject;
          } else {
            // fallback
            formJSON = this.inputOptions.getInputData();
          }
          currentMainValues = this.element.children(".submitOptions").children(".nixps-cloudflow-FormRenderer").FormRenderer("getValues");
          this.element.children(".submitOptions").children(".nixps-cloudflow-FormRenderer").FormRenderer("option", "formJSON", formJSON);
        }
      }
      if (options.jobFormVariables !== undefined) {
        if (this.inputOptions === null) {
          console.error("Could not update the form, because we probably did not found the workflow");
        } else {
          if (this.inputOptions.hasProjectForm()) {
            var expressionToJS = new ExpressionToJS(options.jobFormVariables, this.user, undefined);
            var formProjectExpression = expressionToJS.applyOnObject(this.inputOptions.getProjectFormContents(), function (pErrorMessage) {
              that._addErrorMessage({
                error: pErrorMessage
              });
            });
            var formProjectJSON;
            if (formProjectExpression.translatedObject !== undefined) {
              formProjectJSON = formProjectExpression.translatedObject;
            } else {
              // fallback
              formProjectJSON = this.inputOptions.getProjectFormContents();
            }
            currentJobValues = this.element.children(".projectForm").children(".nixps-cloudflow-FormRenderer").FormRenderer("getValues");
            this.element.children(".projectForm").children(".nixps-cloudflow-FormRenderer").FormRenderer("option", "formJSON", formProjectJSON);
          }
        }
      }
      if (options.prefillFormValues !== undefined && options.prefillFormValues !== null) {
        this.cancelForm();
      } else if (options.prefillJobFormValues !== undefined && options.prefillJobFormValues !== null) {
        this.cancelForm();
      } else {
        if (options.mainFormVariables !== undefined && currentMainValues !== undefined) {
          // the form has been changed, so reinject values if not already needed
          this.element.children(".submitOptions").children(".nixps-cloudflow-FormRenderer").FormRenderer("setValues", currentMainValues);
        }
        if (options.jobFormVariables !== undefined && currentJobValues !== undefined) {
          // the form has been changed, so reinject values if not already needed
          this.element.children(".projectForm").children(".nixps-cloudflow-FormRenderer").FormRenderer("setValues", currentJobValues);
        }
      }
      if (options.fileSelectionHeight !== undefined) {
        var selectionHeight = "";
        if (typeof this.options.fileSelectionHeight === "number" && this.options.fileSelectionHeight > 50) {
          selectionHeight = this.options.fileSelectionHeight;
        }
        this.element.find(".nixps-cloudflow-Upload, .nixps-cloudflow-FileChooser, .nixps-kiosk-FrameHostFileSelector").css("height", selectionHeight);
      }
      if (options.consent !== undefined) {
        this.element.find(".nixps-cloudflow-FileChooser").FileChooser("option", "consent", options.consent);
      }
      if (needDisabling === true) {
        if (options.disabled === true) {
          this._disable();
        } else if (options.disabled === false) {
          this._enable();
        }
      }
    },
    /**
     * @brief sets the option
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "whitepaper" && pValue !== this.options.whitepaper) {
        this._superApply(arguments);
        return true;
      } else if (pKey === "whitepaperInputName" && pValue !== this.options.whitepaperInputName) {
        this._superApply(arguments);
        return true;
      } else if (pKey === "placeHolderName" && pValue !== this.options.placeHolderName) {
        this._superApply(arguments);
        return true;
      }
      this._superApply(arguments);
      return false;
    },
    /**
     * @description check the options
     * @function
     * @private
     * @name nixps-kiosk.CreateWorkable#_checkOptions
     * @return {undefined}
     */
    _checkOptions: function _checkOptions() {
      if (typeof window._ !== "function") {
        throw new Error("include underscore.js plugin");
      }
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("invalid language attribute");
      }
      if (Array.isArray(this.options.inputFiles) === false) {
        throw new Error("input option inputFiles must be an array");
      }
      // control and set the possitions of the panels
      if (this.options.panels === undefined) {
        this.options.panels = ["submitOptions", "projectForm", "filesSelection"];
      } else if (!Array.isArray(this.options.panels) || this.options.panels.length < 1 || this.options.panels.length > 3) {
        throw new Error("the option panels must be a array of three elements");
      }
      for (var i = 0; i < this.options.panels.length; i++) {
        if (["submitOptions", "filesSelection", "projectForm"].includes(this.options.panels[i]) === false) {
          throw new Error("unknown panel in the panels input option");
        }
      }
      // make clone of array
      this.options.panels = this.options.panels.slice();
      if (this.options.moveFileSectionToTop === true) {
        var fileSelectionIndex = this.options.panels.indexOf("filesSelection");
        // not beginning and not if not exists
        if (fileSelectionIndex > 0) {
          // move to front
          this.options.panels.splice(fileSelectionIndex, 1); // remove from place
          this.options.panels.unshift("filesSelection");
        }
      }
      if (typeof this.options.showTitles !== "boolean") {
        throw new Error("CreateWorkable: input option showTitles must be a boolean");
      }
      if (typeof this.options.cancelButtonText !== "string") {
        throw new Error("CreateWorkable: input option cancelButtonText must be a string");
      } else if (this.options.cancelButtonText === "") {
        this.options.cancelButtonText = $.i18n._("nixps-kiosk-newworkable.cancel");
      }
      if (typeof this.options.enableCancelButton !== "boolean") {
        throw new Error("CreateWorkable: input option enableCancelButton must be a boolean");
      }
      if (typeof this.options.submitButtonText !== "string") {
        throw new Error("CreateWorkable: input option submitButtonText must be a string");
      } else if (this.options.submitButtonText === "") {
        this.options.submitButtonText = $.i18n._("nixps-kiosk-newworkable.submit");
      }
      if (typeof this.options.submitButtonClasses !== "string") {
        throw new Error("CreateWorkable: input option submitButtonClasses must be a string");
      }
      if (typeof this.options.classes !== "string") {
        throw new Error("CreateWorkable: input option must be a string");
      }
      if (typeof this.options.checkFiles !== "function") {
        throw new Error("CreateWorkable: input option checkFiles must be a function returning an array");
      }
      if ($.isPlainObject(this.options.defaultSubmitVariables) === false) {
        throw new Error("CreateWorkable: input option defaultSubmitVariables must be an object");
      }
      if (this.options.newWorkableMessage !== null && typeof this.options.newWorkableMessage !== "string") {
        throw new Error("CreateWorkable: input option newWorkableMessage must be a string or null");
      }
      if (typeof this.options.resetFormAfterSubmit !== "boolean") {
        throw new Error("CreateWorkable: input option resetFormAfterSubmit must be a boolean");
      }
      if (Array.isArray(this.options.additionalFileSelectors) === false) {
        throw new Error("CreateWorkable: input option additionalFileSelectors must be an array");
      }
      if (this.options.additionalFileSelectors.length > 0) {
        for (var i = 0; i < this.options.additionalFileSelectors.length; i++) {
          if (["upload", "select"].includes(this.options.additionalFileSelectors[i].enablecheck) === false) {
            throw new Error("CreateWorkable: additionalFileSelectors: must have a valid enablecheck option");
          }
          if (typeof this.options.additionalFileSelectors[i].tab_name !== "string" || this.options.additionalFileSelectors[i].tab_name.length <= 0) {
            throw new Error("CreateWorkable: additionalFileSelectors: must have a not empty tab_name string");
          }
          if (["cloudflow", "upload"].includes(this.options.additionalFileSelectors[i].tab_name)) {
            throw new Error("CreateWorkable: additionalFileSelectors: tab_name 'cloudflow' or 'upload' are reserved tabsnames");
          }
          if (typeof this.options.additionalFileSelectors[i].tab_label !== "string" || this.options.additionalFileSelectors[i].tab_label.length <= 0) {
            throw new Error("CreateWorkable: additionalFileSelectors: must have a not empty tab_label string");
          }
          if (typeof this.options.additionalFileSelectors[i].className !== "string" || this.options.additionalFileSelectors[i].className.length <= 0) {
            throw new Error("CreateWorkable: additionalFileSelectors: must have a not empty className string");
          }
          if ($.isPlainObject(this.options.additionalFileSelectors[i].options) === false) {
            throw new Error("CreateWorkable: additionalFileSelectors: parameter options must be a plain object");
          }
        }
      }
      if (typeof this.options.fileSelectorsActiveTab !== "string" || this.options.fileSelectorsActiveTab.length <= 0) {
        throw new Error("CreateWorkable: input option fileSelectorsActiveTab must be not empty string");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.widgetFullName).removeClass(this.options.classes).removeClass("nixps-kiosk-CreateWorkable-padding");
      this._super();
    }
  });
})(jQuery);

},{"../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js":93,"../../cloudflow/Consent/js/Consent.js":96,"../../cloudflow/FileChooser/js/nixps-cloudflow-FileChooser.js":133,"../../cloudflow/FormElements/js/WorkflowFormComponents.js":137,"../../cloudflow/FormRender/js/nixps-cloudflow-FormRenderer.js":168,"../../cloudflow/PWA/js/Device.js":198,"../../cloudflow/Upload/js/nixps-cloudflow-Upload.js":267,"../../cloudflow/User/js/User.js":268,"../../common/FreezeOverlay/js/nixps-FreezeOverlay.js":292,"../../pagebuilder/js/ExpressionToJS.js":415,"../../pagebuilder/js/inspect/LogListener.js":431,"./model/InputOptions.js":394,"./model/InputOptionsData.js":395,"./nixps-kiosk-FrameHostFileSelector.js":397,"./util/showErrorMessage.js":400}],397:[function(require,module,exports){
'use strict';

(function ($) {
  var Cache = require('./util/Cache.js');
  var catchHostError = require('./util/catchHostError.js');
  function getLoadedHostFiles() {
    return api_defer.frame.host.list_loaded_files({}).then(function (result) {
      if (Array.isArray(result.loaded_files)) {
        return result.loaded_files;
      }
      return [];
    }).fail(function (error) {
      api_defer.frame.host.show_status_messages(error.messages);
    });
  }
  function translate(key) {
    return 'nixps-kiosk-framehostfileselector.' + key;
  }

  /**
   * Returns the default transfer type given the array of files and the default selected files
   * The return is either 'direct' or 'upload'
   * @param {*} files 
   * @param {*} selectedFiles 
   */
  function getDefaultTransferType(files, selectedFiles) {
    for (var j = 0; j < selectedFiles.length; j++) {
      var selectedFileUrl = selectedFiles[j].local_url;
      var file = _.find(files, function (f) {
        return f.local_url === selectedFileUrl;
      });
      if (file === undefined) {
        continue;
      }
      var inFileStore = typeof file.store_url === 'string' && file.store_url.length > 0;
      if (!inFileStore) {
        return 'upload';
      }
    }
    return 'direct';
  }
  $.widget("nixps-kiosk.FrameHostFileSelector", $.Widget, {
    widgetEventPrefix: "framehostfileselector",
    options: {
      /**
       * The files to show in the file selector
       */
      files: [],
      /**
       * True if multiple files can be uploaded and selected
       */
      enableMultiple: true,
      /**
       * True if files can be uploaded
       */
      enableUpload: true,
      /**
       * True if files can be selected
       */
      enableSelect: true,
      /**
       * The name of the Frame host, false if Kiosk does not run in a Frame context
       */
      host: false
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);
      this._selectedFiles = [];
      var hostOptions = $('<input>').attr({
        type: 'radio',
        name: 'transferType',
        value: 'direct',
        id: 'direct' + this.uuid
      }).add($('<span>').html("&nbsp;")).add($('<label>').attr({
        "for": 'direct' + this.uuid
      }).text($.i18n._(translate('direct_transfer')))).add($('<span>').html("&nbsp;")).add($('<span>').html("&nbsp;")).add($('<span>').html("&nbsp;")).add($('<input>').attr({
        type: 'radio',
        name: 'transferType',
        value: 'upload',
        id: 'upload' + this.uuid
      })).add($('<span>').html("&nbsp;")).add($('<label>').attr({
        "for": 'upload' + this.uuid
      }).text($.i18n._(translate('upload_transfer'))));
      this.element.append($('<div>').addClass('frameHostTransferSection cf-form').append($('<span>').addClass('frameHostTransferTitle cf-form-label').text($.i18n._(translate('choose_transfer_type')))).append($('<span>').html("&nbsp;")).append($('<span>').html("&nbsp;")).append($('<span>').html("&nbsp;")).append(hostOptions));
      var table = $('<table>').addClass('frameHostFileSelectorTable cf-table cf-table-fullwidth').append($('<thead>').addClass("cf-table-head").append($('<tr>').append($('<th>').attr('colspan', 2).addClass('nameHeader').text($.i18n._(translate('name')))).append($('<th>').addClass('inFileStoreHeader').text($.i18n._(translate('in_file_store')))).append($('<th>').addClass('savedHeader').text($.i18n._(translate('saved')))))).append($('<tbody>').addClass('cf-table-body'));
      table.appendTo(this.element);
      this._transferType = this.element.find('input[name=transferType]');
      this._fileUploadCache = new Cache();
      this._draw();
      var that = this;
      if (api.frame && api.frame.host && api.frame.host.eventManager) {
        api.frame.host.eventManager.on('loadedFilesChanged', function (changedFiles) {
          changedFiles.files.forEach(function (url) {
            that._fileUploadCache.invalidateKey(url.local_url);
          });
          getLoadedHostFiles().then(function (files) {
            that.option('files', files);
          });
        });
      }
      if (this.options.host) {
        api.frame.host.get(this.options.host).then(function () {
          getLoadedHostFiles().then(function (files) {
            that.option('files', files);
          });
        }).fail(function (pError) {
          console.error(pError);
        });
      }
      this._on(this.element, {
        'change input[name=transferType]': this._transferTypeChangedHandler,
        'change .fileSelected': this._fileSelectedChangeHandler
      });
    },
    _fileSelectionChanged: function _fileSelectionChanged() {
      var that = this;
      this.getSelectedFiles().then(function (files) {
        that._trigger('change', null, {
          files: files
        });
      });
    },
    _setTransferType: function _setTransferType(transferType) {
      this.element.removeClass('frameHostFileSelector-uploadTransfer');
      this.element.removeClass('frameHostFileSelector-directTransfer');
      switch (transferType) {
        case 'upload':
          this.element.addClass('frameHostFileSelector-uploadTransfer');
          break;
        case 'direct':
          this.element.addClass('frameHostFileSelector-directTransfer');
          break;
      }
      // Select the correct radio button in the UI
      this.element.find('input[name=transferType][value="' + transferType + '"]').prop('checked', true);
    },
    _fileSelectedChangeHandler: function _fileSelectedChangeHandler(pEvent) {
      // Set the selected files as the user has changed the file selection himself
      this._selectedFiles = this.getSelectedFileUrls();
      this._fileSelectionChanged();
      // Trigger a separate event when the user changed the file selection
      this._trigger('fileselectionchange');
    },
    _transferTypeChangedHandler: function _transferTypeChangedHandler() {
      var transferType = this.element.find('input[name=transferType]:checked').val();
      this._setTransferType(transferType);
      this._draw();
      this._fileSelectionChanged();
    },
    _draw: function _draw() {
      var files = this.options.files;
      var body = this.element.find('tbody');
      body.empty();
      var enableUpload = this.options.enableUpload;
      var enableMultiple = this.options.enableMultiple;
      var enableSelect = this.options.enableSelect;
      this._transferType.filter('input[value=upload]').prop('disabled', enableUpload === false);
      this._transferType.filter('input[value=direct]').prop('disabled', enableSelect === false);
      if (this._transferType.filter(':checked').length === 0) {
        this._transferType.filter('input[value=direct]').prop('checked', true);
        this._setTransferType('direct');
      }
      if (enableUpload === false) {
        this._transferType.filter('input[value=direct]').prop('checked', true);
        this._setTransferType('direct');
      }
      if (enableSelect === false) {
        this._transferType.filter('input[value=upload]').prop('checked', true);
        this._setTransferType('upload');
      }
      var selectedFiles = this._selectedFiles;
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var inFileStore = typeof file.store_url === 'string' && file.store_url.length > 0;
        var isSaved = file.is_dirty === false;
        var row = $('<tr>').attr('data-url', file.store_url).attr('title', file.local_url).attr('data-localurl', file.local_url).append($('<td>').addClass('selectFileCol').append($('<input>').addClass('fileSelected').addClass(enableMultiple ? 'cf-checkbox' : " ").attr({
          type: enableMultiple ? 'checkbox' : 'radio',
          name: 'file',
          id: file.local_url
        }))).append($('<td>').addClass('filenameCol').append($('<label>').attr({
          "for": file.local_url
        }).text(file.file_name))).append($('<td>').addClass('inFileStoreCol').append($('<span>').addClass('inFileStore').addClass('fa fa-check')).append($('<span>').addClass('notInFileStore').addClass('fa fa-times'))).append($('<td>').addClass('savedCol').append($('<span>').addClass('saved').addClass('fa fa-check')).append($('<span>').addClass('notSaved').addClass('fa fa-times')));
        if (isSaved) {
          row.addClass('isSaved');
        }
        if (inFileStore) {
          row.addClass('inFileStore');
        }
        if (!isSaved) {
          row.find('.fileSelected').prop('disabled', true).prop('checked', false);
        }
        var transferType = this.element.find('input[name=transferType]:checked').val();
        if (transferType === 'direct' && !inFileStore) {
          row.find('.fileSelected').prop('disabled', true).prop('checked', false);
        }

        // Check the correct files if there are selected files
        var canSelect = transferType === 'direct' && inFileStore && isSaved || transferType === 'upload' && isSaved;
        var foundFiles = _.find(selectedFiles, function (f) {
          return f.local_url === file.local_url;
        });
        if (canSelect && foundFiles !== undefined) {
          row.find('.fileSelected').prop('checked', true);
        }
        body.append(row);
      }
    },
    /**
     * Returns the array of currently selected files
     * @return {*} The urls of the selected files [{local_url: "file:///..."}, ...]
     */
    getSelectedFileUrls: function getSelectedFileUrls() {
      var table = this.element.find('.frameHostFileSelectorTable');
      var checkboxes = table.find('.fileSelected:checked');
      var selectedFiles = [];
      for (var i = 0; i < checkboxes.length; i++) {
        var parentRow = $(checkboxes[i]).closest('tr');
        var url = parentRow.attr('data-localurl');
        selectedFiles.push(url);
      }
      return selectedFiles.map(function (url) {
        return {
          local_url: url
        };
      });
    },
    getSelectedFiles: function getSelectedFiles() {
      var transferType = this.element.find('input[name=transferType]:checked').val();
      if (transferType === 'direct') {
        var table = this.element.find('.frameHostFileSelectorTable');
        var checkboxes = table.find('.fileSelected:checked');
        var selectedFiles = [];
        for (var i = 0; i < checkboxes.length; i++) {
          var parentRow = $(checkboxes[i]).closest('tr');
          var url = parentRow.attr('data-url');
          selectedFiles.push(url);
        }
        return $.when(selectedFiles);
      } else if (transferType === 'upload') {
        var table = this.element.find('.frameHostFileSelectorTable');
        var checkboxes = table.find('.fileSelected:checked');
        var selectedFiles = [];
        for (var i = 0; i < checkboxes.length; i++) {
          var parentRow = $(checkboxes[i]).closest('tr');
          var url = parentRow.attr('data-localurl');
          selectedFiles.push(url);
        }
        var whitepaper = this.options.whitepaper;
        var inputname = this.options.inputname;
        var fileUploadCache = this._fileUploadCache;
        var catchUploadError = catchHostError(this.options.host);
        var filesPromise = $.when.apply($, selectedFiles.map(function (f) {
          if (fileUploadCache.hasKey(f)) {
            return fileUploadCache.get(f);
          } else {
            var promise = api_defer.frame.os.upload_file_for_start_from_kiosk(f, whitepaper, inputname).then(function (a) {
              return a.uploaded_file;
            }).fail(function (error) {
              catchUploadError(error);
              fileUploadCache.invalidateKey(f);
            });
            return fileUploadCache.add(f, promise);
          }
        })).then(function () {
          var files = [];
          for (var i = 0; i < arguments.length; i++) {
            files.push(arguments[i]);
          }
          return $.when(files);
        });
        return filesPromise;
      }
      return $.when();
    },
    /**
     * Sets the files that have to be selected when the panel is shown
     * @param {*} selectedFiles [{local_url: "file:///..."}, ...]
     */
    setSelectedFiles: function setSelectedFiles(selectedFiles) {
      this._selectedFiles = selectedFiles;
      this._draw();
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === 'enableMultiple' || pKey === 'enableSelect' || pKey === 'enableUpload') {
        this._super(pKey, pValue);
        this._draw();
        this._fileSelectionChanged();
      } else if (pKey === 'files') {
        this._super(pKey, pValue);
        // Set the correct transfer type according to the selected files (comment for now)
        // this._setTransferType(getDefaultTransferType(pValue, this._selectedFiles));
        this._draw();
        this._fileSelectionChanged();
      } else if (pKey === 'whitepaper' || pKey === 'inputname') {
        this._super(pKey, pValue);
        this._draw();
      }
    }
  });
})(jQuery);

},{"./util/Cache.js":398,"./util/catchHostError.js":399}],398:[function(require,module,exports){
'use strict';

/**
 * Validates the key cache (should a be a string with length > 0)
 * @private
 * @param {*} unknown 
 */
function validateKey(unknown) {
  if (typeof unknown !== 'string') {
    throw new Error('cache key is not a string');
  }
  if (unknown.length === 0) {
    throw new Error('cache key is an empty string');
  }
}

/**
 * A implemenation of a cache storage, it keeps track of items based on a key
 */
function Cache() {
  // The cached uploaded files
  // Key: local file url (file:///....)
  // Value: the promise of the upload call
  this._cache = {};
}

/**
 * Removes an entry from the cache
 * @param {string} key the key that needs to be removed from the cache
 */
Cache.prototype.invalidateKey = function (key) {
  validateKey(key);
  delete this._cache[key];
};

/**
 * Checks that there is an item in the cache for the passed key
 * @param {string} key the key that needs to be checked
 */
Cache.prototype.hasKey = function (key) {
  validateKey(key);
  return this._cache[key] !== undefined;
};

/**
 * Returns the item that matches for the passed key
 * @param {string} key the key of the item that needs to be returned
 */
Cache.prototype.get = function (key) {
  validateKey(key);
  if (this.hasKey(key) === false) {
    throw new Error('this key is not in the cache: ' + key);
  }
  return this._cache[key];
};

/**
 * Adds an item in the cache, the added item is returned.  If there is an item
 * in the cache for that key, the stored item is returned.
 * @param {string} key the key of the item that needs to be added
 * @param {*} value the item that needs to be stored for that key
 * @return the value that was added to the cache
 */
Cache.prototype.add = function (key, value) {
  validateKey(key);
  if (this.hasKey(key) === true) {
    return this.get(key);
  }
  this._cache[key] = value;
  return value;
};
module.exports = Cache;

},{}],399:[function(require,module,exports){
"use strict";

/**
 * Catches and displays an error in the Frame HOST context
 */
function catchHostError(host) {
  return function (error) {
    if (Array.isArray(error.messages) === false) {
      return;
    }
    api_defer.frame.host.get(host).then(function () {
      api_defer.frame.host.show_status_messages(error.messages);
    });
  };
}
module.exports = catchHostError;

},{}],400:[function(require,module,exports){
'use strict';

/**
 * Shows an error message in the notify area, based on the portal code
 * @param {*} pError 
 * @param {*} pTitle 
 * @param {*} pMessage 
 */
function showErrorMessage(pError, pTitle, pMessage) {
  console.error(pError);
  // Temporary fix for extra level in backend messages
  if (pError !== undefined && pError.messages !== undefined && pError.messages.messages !== undefined) {
    pError.messages = pError.messages.messages;
  }
  var textMessages = [];
  if (typeof pMessage === "string" && pMessage.length > 0) {
    textMessages.push(pMessage);
  }

  // Concat the description if available
  if (pError !== undefined && Array.isArray(pError.messages) && pError.messages.length > 0 && typeof pError.messages[0].description === "string" && pError.messages[0].description.length > 0) {
    textMessages.push(pError.messages[0].description);
  }
  if ($('#notify-area').length === 0) {
    return;
  }
  $('#notify-area').notify("create", "closeable-error", {
    title: $.i18n._(pTitle),
    text: textMessages.join('<br>')
  }, {
    expires: false
  });
}
module.exports = showErrorMessage;

},{}],401:[function(require,module,exports){
/* globals showdown */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var isOpen = false;
module.exports = function (pOptions) {
  if (isOpen == true) {
    return;
  }
  isOpen = true;

  // options
  var options = Object.assign({
    language: "en"
  }, pOptions);

  // inner parameters
  var abortController = null;

  // create all DOM elements
  var kQuestionDOM = document.createElement("DIV");
  kQuestionDOM.className = "aichat-question";
  kQuestionDOM.innerHTML = "<div class='aichat-question-text'></div>" + "<div class='aichat-actionbar aichat-question-actionbar'>" + "<button class='aichat-button' data-action='edit' type='button' data-i18n-tooltip='nixps-asset-aichat.tooltip_edit'><span class='cf-icon cf-icon-pencil cf-iconbutton'></span></button>" + "<button class='aichat-button aichat-copy' data-action='copy' type='button' data-i18n-tooltip='nixps-asset-aichat.tooltip_copy'><span class='cf-icon cf-icon-clipboard-copy cf-iconbutton'></span></button>" + "</div>";
  var kAnswerDOM = document.createElement("DIV");
  kAnswerDOM.className = "aichat-answer";
  kAnswerDOM.innerHTML = "<div class='aichat-answer-text cf-unreset'></div>" + "<div class='aichat-actionbar aichat-question-actionbar'>" + "<button class='aichat-button aichat-copy' data-action='copy' type='button' data-i18n-tooltip='nixps-asset-aichat.tooltip_copy'><span class='cf-icon cf-icon-clipboard-copy cf-iconbutton'></span></button>" + "</div>";
  var kCodeHeaderDOM = document.createElement("DIV");
  kCodeHeaderDOM.className = "aichat-codeheader";
  kCodeHeaderDOM.innerHTML = "<div class='aichat-actionbar aichat-question-actionbar'>" + "<button class='aichat-button aichat-copy' data-action='copy' type='button' data-i18n-tooltip='nixps-asset-aichat.tooltip_copy'><span class='cf-icon cf-icon-clipboard-copy cf-iconbutton'></span></button>" + "</div>";
  var container = document.createElement("DIV");
  container.innerHTML = "<form class='nixps-cloudflow-aichat' method='post'>" + "<button type='button' class='aichat-closebutton cf-icon cf-icon-x cf-iconbutton' data-action='close' data-i18n-tooltip='nixps-asset-aichat.tooltip_closedialog'></button>" + "<div class='aichat-beta' data-i18n-text='nixps-asset-aichat.beta'> Beta </div>" + "<div class='aichat-responses'></div>" + "<div class='aichat-waiting cf-hide'>" + "<div class='cf-animation-maze'></div>" + "</div>" + "<div class='aichat-welcome cf-title-h3 cf-center-text' data-i18n-text='nixps-asset-aichat.welcome'> Hallo how can I help you? </div>" + "<div class='aichat-copyconfirmation cf-center-text cf-hide' data-i18n-text='nixps-asset-aichat.copyconfirmation' ><span></span>text has been added to clipboard</div>" + "<div class='aichat-input'>" + "<textarea class='aichat-textarea' data-i18n-placeholder='nixps-asset-aichat.placeholder' placeholder='type here your question' rows='2'></textarea>" + "<div class='aichat-inputbottombar'>" + "<button type='button' class='cf-icon cf-icon-reject cf-iconbutton' data-i18n-tooltip='nixps-asset-aichat.tooltip_abort' data-action='abort' disabled></button>" + "<button type='submit' class='cf-icon cf-icon-send cf-iconbutton' data-i18n-tooltip='nixps-asset-aichat.tooltip_send'</button>" + "</div>" + "</div>" + "<div class='aichat-legaltext cf-center-text' data-i18n-text='nixps-asset-aichat.legal'>Sena can make mistakes</div>" + "</form>";
  // set translations
  [kQuestionDOM, kAnswerDOM, container].forEach(function (pDOM) {
    pDOM.querySelectorAll("[data-i18n-text], [data-i18n-tooltip], [data-i18n-placeholder]").forEach(function (pElement) {
      var translationTextKey = pElement.getAttribute("data-i18n-text");
      if (typeof translationTextKey === "string" && translationTextKey.length > 0) {
        pElement.textContent = $.i18n._(translationTextKey);
      }
      var translationTooltipKey = pElement.getAttribute("data-i18n-tooltip");
      if (typeof translationTooltipKey === "string" && translationTooltipKey.length > 0) {
        pElement.setAttribute("title", $.i18n._(translationTooltipKey));
      }
      var translationPlaceholderKey = pElement.getAttribute("data-i18n-placeholder");
      if (typeof translationPlaceholderKey === "string" && translationPlaceholderKey.length > 0) {
        pElement.setAttribute("placeholder", $.i18n._(translationPlaceholderKey));
      }
    });
  });

  // set all variables
  var clipboard = null;
  if (window.ClipboardJS !== undefined && ClipboardJS.isSupported()) {
    clipboard = new ClipboardJS(".aichat-copy", {
      target: function target(trigger) {
        return trigger.closest(".aichat-question, .aichat-answer").querySelector(".aichat-question-text, .aichat-answer-text");
      }
    });
    clipboard.on("success", function (e) {
      e.clearSelection();
    });
  }
  var converter = function converter(text) {
    return text;
  };
  if (window.showdown) {
    var showDownConverter = new showdown.Converter({
      tables: true,
      emoji: true,
      strikethrough: true,
      backslashEscapesHTMLTags: true,
      parseImgDimensions: true
    });
    converter = showDownConverter.makeHtml.bind(showDownConverter);
  }
  var codeHightLight = function codeHightLight() {};
  if (window.Sunlight) {
    codeHightLight = window.Sunlight.highlightAll({
      lineNumbers: false
      // showMenu: true
    }).highlightAll;
  }

  // functions
  function submit() {
    var welcomeDOM = container.querySelector(".aichat-welcome");
    if (welcomeDOM) {
      welcomeDOM.classList.add("cf-hide");
    }
    var inputDOM = container.querySelector("textarea");
    var question = inputDOM.value;
    if (typeof question === "string" && question.length > 0) {
      container.querySelector(".aichat-waiting").classList.remove("cf-hide");
      container.querySelector("button[type='submit']").disabled = true;
      container.querySelector("button[data-action='abort']").disabled = false;
      inputDOM.disabled = true;
      addQuestion(question);
      abortController = new AbortController();
      var answerDef;
      if (question[0] === ">") {
        // user typed a commando line
        answerDef = Promise.resolve(_command(question.substring(1), abortController.signal));
      } else {
        // user typed a question prompt
        answerDef = new Promise(function (pResolve, pReject) {
          if (abortController.signal.aborded) {
            pReject(abortController.signal.reason);
            return;
          }
          var timeoutID = setTimeout(function () {
            pResolve("Sorry i'm not active for the moment.\nPlease retry later.");
          }, 3000);
          var inputParameters = {
            question: question
          };
          // let whitepaperConnection = new WhitepaperConnection("aichat", "aichat", inputParameters, undefined, false)
          // whitepaperConnection.onprogress = function(pEvent, pData){
          //     if (pData.action === "redirect" && pData.url === "string") {
          //         window.location = pData.url;
          //         return;
          //     }
          //     if (pData.milestone) {

          //     }
          // }
          // whitepaperConnection.setStartPollingTime(1);
          // whitepaperConnection.start();
          abortController.signal.addEventListener("abort", function () {
            clearTimeout(timeoutID);
            // whitepaperConnection.stop(abortController.signal.reason);
            pReject($.i18n._("nixps-asset-aichat.abort_message"));
          });
        });
      }
      answerDef.then(function (pResponse) {
        inputDOM.value = "";
        inputDOM.setAttribute("rows", "2");
        addResonses(pResponse);
      }, function (pError) {
        console.error(pError);
        var errorMessage = "";
        if (typeof pError === "string") {
          errorMessage = pError;
        } else if (pError && typeof pError.error === "string") {
          errorMessage = pError.error;
        }
        addResonses("<em class='cf-em'>- " + errorMessage + " -</em>");
      })["finally"](function () {
        inputDOM.disabled = false;
        inputDOM.focus();
        container.querySelector("button[type='submit']").disabled = false;
        container.querySelector("button[data-action='abort']").disabled = true;
        container.querySelector(".aichat-waiting").classList.add("cf-hide");
      });
    }
  }

  /**
   * @description Display the question asked to the bot
   * @function
   * @param {String} pQuestion The question asked to the bot
   * @param {Mixed} pQuestionID The identifier of the question
   */
  function addQuestion(pQuestion, pQuestionID) {
    var resultDOM = container.querySelector(".aichat-responses");
    var questionDOM = kQuestionDOM.cloneNode(true);
    questionDOM.querySelector(".aichat-question-text").textContent = pQuestion;
    if (pQuestionID) {
      questionDOM.setAttribute("data-question-id", pQuestionID);
    }
    resultDOM.appendChild(questionDOM);
    questionDOM.scrollIntoView({
      block: "end",
      inline: "nearest",
      behavior: "smooth"
    });
  }

  /**
   * @description Display the answer of the bot
   * @function
   * @param {String} pResponse The response of the bot
   * @param {Mixed} pQuestionID the identifier of the answer
   */
  function addResonses(pResponse, pQuestionID) {
    var resultDOM = container.querySelector(".aichat-responses");
    var answerDOM = kAnswerDOM.cloneNode(true);
    if (pQuestionID) {
      answerDOM.setAttribute("data-question-id", pQuestionID);
    }
    answerDOM.querySelector(".aichat-answer-text").innerHTML = converter(pResponse);
    resultDOM.appendChild(answerDOM);
    answerDOM.querySelectorAll("code:not(.aichat-noactions)").forEach(function (pElement) {
      pElement.classList.forEach(function (pClass) {
        if (typeof pClass === "string" && pClass.indexOf("language-") === 0) {
          pElement.classList.add("sunlight-highlight-" + pClass.substring(9));
        }
      });
      pElement.before(kCodeHeaderDOM.cloneNode(true));
    });
    codeHightLight();
    answerDOM.scrollIntoView({
      block: "end",
      inline: "nearest",
      behavior: "smooth"
    });
  }
  function _adaptRowsInTextArea() {
    var inputDOM = container.querySelector("textarea");
    var question = inputDOM.value;
    var amountRows = parseInt(inputDOM.getAttribute("rows"));
    var amountLines = question.split("\n").length + 1;
    if (amountRows < amountLines) {
      inputDOM.setAttribute("rows", amountLines);
    }
  }
  function _editQuestionHandler(pEvent) {
    var parentDOM = pEvent.target.closest(".aichat-question");
    if (parentDOM) {
      var textareaDOM = container.querySelector("textarea");
      var textDOM = parentDOM.querySelector(".aichat-question-text");
      if (textDOM) {
        textareaDOM.value = textDOM.textContent;
        _adaptRowsInTextArea();
        textareaDOM.focus();
      }
    }
  }
  var confirmationTimerID = null;
  function _copyConfirmationHandler() {
    container.querySelector(".aichat-copyconfirmation").classList.remove("cf-hide");
    clearTimeout(confirmationTimerID);
    confirmationTimerID = setTimeout(function () {
      container.querySelector(".aichat-copyconfirmation").classList.add("cf-hide");
    }, 2000);
  }
  function _abortHandler() {
    if (abortController !== null) {
      abortController.abort("user");
    }
  }
  function _closeHandler() {
    if (abortController !== null) {
      abortController.abort("close");
    }
    isOpen = false;
    container.remove();
  }
  function _clearHandler() {
    var resultDOM = container.querySelector(".aichat-responses");
    var welcomeDOM = container.querySelector(".aichat-welcome");
    if (resultDOM && welcomeDOM) {
      resultDOM.textContent = "";
      welcomeDOM.classList.remove("cf-hide");
    }
    return "";
  }
  container.addEventListener("click", function (pEvent) {
    var buttonDOM = pEvent.target.closest("button");
    if (buttonDOM) {
      var action = buttonDOM.getAttribute("data-action");
      if (_typeof(action) && action.length > 0) {
        switch (action) {
          case "abort":
            return _abortHandler(pEvent);
          case "edit":
            return _editQuestionHandler(pEvent);
          case "copy":
            return _copyConfirmationHandler(pEvent);
          case "close":
            return _closeHandler(pEvent);
        }
      }
    }
  });
  container.addEventListener("keydown", function (pEvent) {
    switch (pEvent.key) {
      case "Enter":
        if (pEvent.shiftKey === false) {
          pEvent.preventDefault();
          pEvent.stopPropagation();
          submit();
        }
        break;
      case "Escape":
        _closeHandler();
        break;
    }
  });
  container.addEventListener("input", function (pEvent) {
    _adaptRowsInTextArea();
  });
  container.addEventListener("submit", function (pEvent) {
    pEvent.preventDefault();
    pEvent.stopPropagation();
    submit();
    return false;
  });
  function _command(pCommand, pSignal) {
    if (typeof pCommand !== "string") {
      throw new Error("pCommand must be a string");
    }
    if (pSignal.aborted) {
      return "<em class='cf-em'>aborted<em>";
    }
    pSignal.addEventListener("abort", function () {});
    pCommand = pCommand.toLowerCase();
    switch (pCommand) {
      case "version":
        return "Sena 0.0.1";
      case "cp":
      case "copy":
        var resultDOM = container.querySelectorAll(".aichat-responses .aichat-copy");
        if (resultDOM) {
          var lastButton = resultDOM[resultDOM.length - 1];
          if (lastButton) {
            lastButton.click();
            _copyConfirmationHandler();
          }
        }
        return "Last response has been copied to clipboard.";
      case "cp code":
        var copyButton = container.querySelectorAll(".aichat-responses .aichat-codeheader .aichat-copy");
        if (copyButton) {
          var _lastButton = copyButton[resultDOM.length - 1];
          if (_lastButton) {
            _lastButton.click();
            _copyConfirmationHandler();
          }
        }
        return "Last code has been copied to clipboard.";
      case "date":
      case "time":
        return "<code>" + new Date().toISOString() + "</code>";
      case "clear":
        return _clearHandler();
      case "close":
      case "quit":
      case "q":
        return _closeHandler();
      case "help":
        return "Here are all the accessible commands:\n\n" + "\t<code class='aichat-noactions'>&gt;version</code>\tThe current version of the ai bot\n" + "\t<code class='aichat-noactions'>&gt;copy   </code>\tCopy the last response to the clipboard\n" + "\t<code class='aichat-noactions'>&gt;cp code</code>\tCopy the last code to the clipboard\n" + "\t<code class='aichat-noactions'>&gt;clear  </code>\tClear the session and remove the responses\n" + "\t<code class='aichat-noactions'>&gt;close  </code>\tClose the ai bot dialog\n" + "\t<code class='aichat-noactions'>&gt;date   </code>\tDisplay the ISO extended date format\n" + "\t<code class='aichat-noactions'>&gt;help   </code>\tShow all the possible commands\n";
      default:
        return "unknown command <code class='aichat-noactions'>" + pCommand + "</code>";
    }
  }
  return container;
};

},{}],402:[function(require,module,exports){
"use strict";

var DateFunctions = require("../../../cloudflow/CloudflowUtil/js/DateFunctions.js");

/**
 * @constructor Asset
 * @description the util object reprecenting an asset, file, folder
 * @param {Object} pData parameters
 */
var Asset = function Asset(pData) {
  this.asset = pData;
};
Asset.fromJSON = function (pJSON) {
  return new Asset(pJSON);
};
Asset.getScalingAndCompensation = function (pObject) {
  var result = {};
  if (pObject.scaling !== undefined) {
    result['horizontalScaling'] = pObject.scaling.horizontal;
    result['verticalScaling'] = pObject.scaling.vertical;
    result['scalingApplied'] = pObject.scaling.applied;
  }
  if (pObject.output_color_space !== undefined && pObject.output_color_space.colorants !== undefined) {
    var colorant = pObject.output_color_space.colorants[0];
    if (colorant.compensation !== undefined) {
      if (colorant.compensation.plate !== undefined && colorant.compensation.plate.applied === true) {
        result['horizontalCompensation'] = colorant.compensation.plate.horizontal;
        result['verticalCompensation'] = colorant.compensation.plate.vertical;
      }
      if (colorant.compensation.carrier !== undefined && colorant.compensation.carrier.applied === true) {
        if (result['horizontalCompensation'] !== undefined) {
          result['horizontalCompensation'] *= colorant.compensation.carrier.horizontal;
          result['verticalCompensation'] *= colorant.compensation.carrier.vertical;
        } else {
          result['horizontalCompensation'] = colorant.compensation.carrier.horizontal;
          result['verticalCompensation'] = colorant.compensation.carrier.vertical;
        }
      }
    }
  }
  return result;
};

/**
 * @description Get the icon classes for a specific file type
 * @function
 * @name Asset.getDedicatedFileIcon
 * @static
 * @param {String} pFileType the filetype of the file
 * @param {Number} pScale The number of scale the icon must have
 * @param {Mixed} pDefault What we must use when we did not find any matching file type
 * @returns {String} The dedicated class icon for that type of file
 */
Asset.getDedicatedFileIcon = function (pFileType) {
  var pScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var pDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "cf-icon cf-icon-clipboard-list";
  var scaleClass = pScale > 1 ? " cf-icon-10x" : "";
  switch (pFileType) {
    // images
    case "application/pdf":
      return "cf-icon cf-icon-file-pdf" + scaleClass;
    case "application/vnd.adobe.illustrator":
      return "cf-icon cf-icon-file-ai" + scaleClass;
    case "image/jpeg":
      return "cf-icon cf-icon-file-jpg" + scaleClass;
    case "image/png":
      return "cf-icon cf-icon-file-png" + scaleClass;
    case "image/tiff":
      return "cf-icon cf-icon-file-tiff" + scaleClass;
    case "application/x-font-opentype":
    case "application/x-font-truetype":
      return "cf-icon cf-icon-file-font" + scaleClass;
    case "text/xml":
      return "cf-icon cf-icon-file-metadata" + scaleClass;
    case "text/html":
      return "cf-icon cf-icon-file-html" + scaleClass;
    case "application/vnd.iccprofile":
      return "cf-icon cf-icon-landscape" + scaleClass;
    case "application/vnd.colorlogic-dlcfg":
    case "application/vnd.colorlogic-dlcfg+json":
    case "application/vnd.colorlogic-sicfg":
    case "application/vnd.colorlogic-sicfg+json":
      return "cf-icon cf-icon-color-gamut" + scaleClass;
    case "application/vnd.packz-colorbook-encrypted":
    case "application/vnd.iso-tec130-cxf+xml":
    case "application/vnd.packz-colorbook":
      return "cf-icon cf-icon-color-book" + scaleClass;

    // unsupported images    
    case "application/postscript":
    case "application/ic3d-ic3":
    case "application/x-cad-cff2":
    case "application/vnd.nixps-curve+json":
    // other most common file types
    case "application/vnd.ms-excel":
    case "application/zip":
    case "application/json":
    case "application/jsonl":
    default:
      if (typeof pDefault === "string" && pDefault.length > 0) {
        return pDefault + scaleClass;
      }
      return pDefault;
  }
};
Asset.prototype = {
  constructor: Asset,
  /**
   * @description Get the asset _id, the unic asset id
   * @function
   * @name Asset#getID
   * @returns {AssetID}
   */
  getID: function getID() {
    return this.asset._id;
  },
  isSite: function isSite() {
    return this.asset.site === true;
  },
  isFolder: function isFolder() {
    return this.asset.cloudflow === undefined || typeof this.asset.cloudflow.file !== "string";
  },
  isFileStore: function isFileStore() {
    return this.asset.cloudflow !== undefined && this.asset.cloudflow.enclosing_folder === "";
  },
  getURL: function getURL() {
    if (this.isFolder()) {
      return this.asset.cloudflow.folder;
    }
    return this.asset.cloudflow.file;
  },
  isSub: function isSub() {
    return this.asset.sub !== undefined && this.asset.sub != "";
  },
  getSub: function getSub() {
    return this.asset.sub;
  },
  getFileName: function getFileName() {
    if (typeof this.asset.file_name === "string") {
      return this.asset.file_name;
    } else if (typeof this.asset.name === "string") {
      // sites and filestores has a name attribute
      return this.asset.name;
    } else if (this.isFolder()) {
      return $.i18n._("nixps-cloudflow-assets.filetype-folder");
    }
    return "";
  },
  getThumb: function getThumb() {
    if (this.isSite()) {
      return "cf-icon cf-icon-10x cf-icon-site";
    } else if (this.isFileStore()) {
      return "cf-icon cf-icon-10x cf-icon-filestore";
    } else if (this.isFolder()) {
      return "cf-icon cf-icon-10x cf-icon-folder-filled";
    } else if (typeof this.asset.thumb === "string") {
      return this.asset.thumb;
    } else {
      return Asset.getDedicatedFileIcon(this.asset.filetype, 10);
    }
  },
  getDocumentName: function getDocumentName() {
    return this.asset.document_name;
  },
  getSubPageNumber: function getSubPageNumber() {
    if (this.isSub() && this.getSub().length > 2 && this.getSub().substring(0, 2) === "p_") {
      return parseInt(this.getSub().substring(2), 10);
    }
    return -1;
  },
  mine_types: function mine_types() {
    var mimeType = this.asset.filetype;
    if (this.asset.mime_types !== undefined && this.asset.mime_types.length > 1) {
      mimeType += " (";
      var addComma = false;
      var mimeTypeIndex;
      for (mimeTypeIndex in this.asset.mime_types) {
        if (this.asset.mime_types[mimeTypeIndex] !== this.asset.filetype) {
          if (addComma === true) {
            mimeType += ", ";
          }
          mimeType += this.asset.mime_types[mimeTypeIndex];
          addComma = true;
        }
      }
      mimeType += ")";
    }
    return mimeType;
  },
  creation_time: function creation_time() {
    if (this.asset.file_time !== undefined && this.asset.file_time.creation_local !== undefined) {
      return DateFunctions.toLocaleString(new Date(this.asset.file_time.creation_utc));
    }
    return "--";
  },
  modtime: function modtime() {
    if (this.asset.modtime !== undefined) {
      // the date should be converted to a human-readable LOCAL time, probably based on the the utc time, or the epoch time (which is also UTC based!)
      return DateFunctions.toLocaleString(new Date(this.asset.modtime * 1000));
    }
    return "--";
  },
  getFileSize: function getFileSize() {
    if (this.isFolder()) {
      return this.asset.size;
    } else {
      return this.asset.file_size;
    }
  },
  getTotalPageCount: function getTotalPageCount() {
    if (typeof this.asset.total_pagecount === "number") {
      return this.asset.total_pagecount;
    }
    return null;
  },
  getPageCount: function getPageCount() {
    if (this.asset.metadata !== undefined && this.asset.metadata.number_of_logical_pages !== undefined) {
      return this.asset.metadata.number_of_logical_pages;
    }
    return 0;
  },
  getPhysicalPageCount: function getPhysicalPageCount() {
    if (this.asset.metadata !== undefined && this.asset.metadata.number_of_pages !== undefined) {
      if (this.asset.metadata.output_color_space !== undefined && this.asset.metadata.output_color_space.is_separated !== undefined && this.asset.metadata.output_color_space.is_separated === true || this.asset.metadata.number_of_logical_pages !== this.asset.metadata.number_of_pages) {
        return this.asset.metadata.number_of_pages;
      }
    }
    return 0;
  },
  /**
   * @description is the backend still bussy with processing the data or not
   * @function
   * @name Asset#needWaitOnProsess
   * @returns {Boolean} true if the backend is still bussy to proccess the data
   */
  needWaitOnProsess: function needWaitOnProsess() {
    return this.asset.need_metadata !== undefined || this.asset.need_preview !== undefined;
  },
  getJobInfo: function getJobInfo() {
    if (this.asset.metadata !== undefined && this.asset.metadata.job !== undefined) {
      var jobInfo = "";
      if (this.asset.metadata.job.job_id !== undefined) {
        jobInfo = $.i18n._('nixps-cloudflow-assets.metadata-info_tab-generic-job-job-id') + ": " + this.asset.metadata.job.job_id;
      }
      if (this.asset.metadata.job.job_part_id !== undefined) {
        if (jobInfo !== "") {
          jobInfo += ",\n";
        }
        jobInfo += $.i18n._('nixps-cloudflow-assets.metadata-info_tab-generic-job-job-part-id') + ": " + this.asset.metadata.job.job_part_id;
      }
      if (this.asset.metadata.job.order_id !== undefined) {
        if (jobInfo !== "") {
          jobInfo += ",\n";
        }
        jobInfo += $.i18n._('nixps-cloudflow-assets.metadata-info_tab-generic-job-order-id') + ": " + this.asset.metadata.job.order_id;
      }
      if (this.asset.metadata.job.sub_order_id !== undefined) {
        if (jobInfo !== "") {
          jobInfo += ",\n";
        }
        jobInfo += $.i18n._('nixps-cloudflow-assets.metadata-info_tab-generic-job-sub-order-id') + ": " + this.asset.metadata.job.sub_order_id;
      }
      return jobInfo;
    }
    return null;
  },
  getMediaBox: function getMediaBox() {
    if (this.asset.metadata !== undefined && this.asset.metadata.page_boxes !== undefined && this.asset.metadata.page_boxes.media !== undefined) {
      return this.asset.metadata.page_boxes.media;
    } else if (this.asset.metadata !== undefined && this.asset.metadata.pages !== undefined && this.asset.metadata.pages[0].page_boxes !== undefined && this.asset.metadata.pages[0].page_boxes.media !== undefined) {
      return this.asset.metadata.pages[0].page_boxes.media;
    }
    return null;
  },
  getTrimBox: function getTrimBox() {
    if (this.asset.metadata !== undefined && this.asset.metadata.page_boxes !== undefined && this.asset.metadata.page_boxes.trim !== undefined) {
      return this.asset.metadata.page_boxes.trim;
    } else if (this.asset.metadata !== undefined && this.asset.metadata.pages !== undefined && this.asset.metadata.pages[0].page_boxes !== undefined && this.asset.metadata.pages[0].page_boxes.trim !== undefined) {
      return this.asset.metadata.pages[0].page_boxes.trim;
    }
    return null;
  },
  getScalingAndDistortion: function getScalingAndDistortion() {
    if (this.asset.metadata !== undefined && this.asset.metadata.page_boxes !== undefined && this.asset.metadata.page_boxes.media !== undefined) {
      return Asset.getScalingAndCompensation(this.asset.metadata);
    } else if (this.asset.metadata !== undefined && this.asset.metadata.pages !== undefined && this.asset.metadata.pages[0].page_boxes !== undefined && this.asset.metadata.pages[0].page_boxes.media !== undefined) {
      return Asset.getScalingAndCompensation(this.asset.metadata.pages[0]);
    }
  },
  getPixelData: function getPixelData() {
    if (this.asset.metadata !== undefined && this.asset.metadata.pixel_data !== undefined && this.asset.metadata.pixel_data.size !== undefined) {
      return this.asset.metadata.pixel_data;
    } else if (this.asset.metadata !== undefined && this.asset.metadata.pages !== undefined && this.asset.metadata.pages[0].pixel_data !== undefined && this.asset.metadata.pages[0].pixel_data.size !== undefined) {
      return this.asset.metadata.pages[0].pixel_data;
    }
    return null;
  },
  getDocumentWidth: function getDocumentWidth() {
    var mediaBox = this.getMediaBox();
    if (mediaBox !== undefined && mediaBox !== null) {
      var documentWidth = mediaBox.size_mm.width;
      var scalingAndDistortion = this.getScalingAndDistortion();
      if (scalingAndDistortion.horizontalScaling !== undefined && scalingAndDistortion.scalingApplied === false) {
        documentWidth *= scalingAndDistortion.horizontalScaling;
      }
      return documentWidth;
    }
    return null;
  },
  getDocumentHeight: function getDocumentHeight() {
    var mediaBox = this.getMediaBox();
    if (mediaBox !== undefined && mediaBox !== null) {
      var documentHeight = mediaBox.size_mm.height;
      var scalingAndDistortion = this.getScalingAndDistortion();
      if (scalingAndDistortion.horizontalScaling !== undefined && scalingAndDistortion.scalingApplied === false) {
        documentHeight *= scalingAndDistortion.verticalScaling;
      }
      return documentHeight;
    }
    return null;
  },
  getTrimBoxWidth: function getTrimBoxWidth() {
    var trimBox = this.getTrimBox();
    if (trimBox !== undefined && trimBox !== null) {
      var width = trimBox.size_mm.width;
      var scalingAndDistortion = this.getScalingAndDistortion();
      if (scalingAndDistortion.horizontalScaling !== undefined && scalingAndDistortion.scalingApplied === false) {
        width *= scalingAndDistortion.horizontalScaling;
      }
      return width;
    }
    return null;
  },
  getTrimBoxHeight: function getTrimBoxHeight() {
    var trimBox = this.getTrimBox();
    if (trimBox !== undefined && trimBox !== null) {
      var height = trimBox.size_mm.height;
      var scalingAndDistortion = this.getScalingAndDistortion();
      if (scalingAndDistortion.horizontalScaling !== undefined && scalingAndDistortion.scalingApplied === false) {
        height *= scalingAndDistortion.verticalScaling;
      }
      return height;
    }
    return null;
  },
  isStackView: function isStackView() {
    return this.asset.mime_types !== undefined && (this.asset.mime_types.indexOf("image/tiff") >= 0 || this.asset.mime_types.indexOf("image/vnd.esko.plateprep") >= 0 || this.asset.mime_types.indexOf("application/vnd.nixps.dominobmp") >= 0) && 'metadata' in this.asset === true && 'output_color_space' in this.asset.metadata === true && 'colorants' in this.asset.metadata.output_color_space === true && this.asset.metadata.output_color_space.colorants.length <= 1;
  },
  getProofscopeInfo: function getProofscopeInfo() {
    var proofscopeInfo = {
      url: this.getURL(),
      proofscopePart: this.asset.cloudflow.part
    };
    if (this.asset.proofscope !== undefined && this.asset.proofscope.uuid !== undefined) {
      if (this.isStackView() === true) {
        proofscopeInfo.proofscopeView = {
          viewer: "Stack",
          parameters: {
            itemFinder: {
              assetID: this.asset._id,
              finders: [{
                type: 'MatchNameUntilLastUnderscore'
              }]
            }
          }
        };
      } else if ('metadata' in this.asset === false || 'number_of_pages' in this.asset.metadata === false || this.asset.metadata.number_of_pages <= 1) {
        proofscopeInfo.proofscopeView = {
          viewer: "Graphic",
          parameters: {
            assetID: this.asset._id
          }
        };
      } else {
        proofscopeInfo.proofscopeView = {
          viewer: "MultiPage",
          parameters: {
            assetID: this.asset._id
          }
        };
        if (typeof this.asset.metadata.page_limit === 'number') {
          proofscopeInfo.proofscopeView.parameters.maximumNrPages = this.asset.metadata.page_limit;
        }
      }
    }
    return proofscopeInfo;
  },
  /**
   * @description Check if the metadata is loaded and so if there is enough information to check if we can continue to proceeded
   * @function
   * @name Asset#hasEnoughDataToCompare
   * @returns {Boolean} true if metadata is loaded
   */
  hasEnoughDataToCompare: function hasEnoughDataToCompare() {
    return this.asset.metadata !== undefined;
  },
  /**
   * @description Can the file be compared of not
   * @name Asset#canBeCompared
   * @function
   * @param {String} pApplication The application which you want to compare, support for "proofscope"
   * @returns {Boolean} true if the file can be compared in proofscope
   */
  canBeCompared: function canBeCompared(pApplication) {
    if (pApplication === "proofscope") {
      return this.asset.proofscope !== undefined && this.asset.proofscope.uuid !== undefined;
    } else {
      throw new Error("unsupported compare application");
    }
  },
  clone: function clone() {
    return Asset.fromJSON(structuredClone(this.asset));
  },
  toJSON: function toJSON() {
    return this.asset;
  }
};
module.exports = Asset;

},{"../../../cloudflow/CloudflowUtil/js/DateFunctions.js":83}],403:[function(require,module,exports){
"use strict";

/* 
 * 
 *   created by guillaume on May 19, 2016 12:10:03 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  /**
   * @description remove cloudflow:// from the beginning of the string
   * @private
   * @param {string} pUrl the url to be handled
   * @return {unresolved}
   */
  function removePrefix(pUrl) {
    if (typeof pUrl === "string" && pUrl.indexOf("cloudflow://") === 0) {
      return pUrl.substring(12);
    } else {
      return pUrl;
    }
  }
  function decode(pURL) {
    try {
      return decodeURI(pURL);
    } catch (e) {
      return pURL;
    }
  }
  function decodeComponent(pURL) {
    try {
      return decodeURIComponent(pURL);
    } catch (e) {
      return pURL;
    }
  }

  /**
   * @namespace nixps-asset.BreadCrumb
   * @description A breadcrumb of the url
   * @version 2.1.0
   */
  $.widget("nixps-asset.BreadCrumb", $.Widget, {
    widgetEventPrefix: "breadcrumb",
    version: "2.1.0",
    options: {
      /**
       * @name nixps-asset.BreadCrumb#callback
       * @description The callback function, run when user press a link 
       * @function {Function}
       * @default undefined
       */
      callback: undefined,
      /**
       * @name nixps-asset.BreadCrumb#siteCallback
       * @description The callback function, run when user press a site name 
       * @function {Function}
       * @default undefined
       */
      siteCallback: function siteCallback() {},
      /**
       * @name nixps-asset.BreadCrumb#url
       * @description The current url
       * @type {String}
       * @default undefined
       */
      url: undefined,
      /**
       * @name nixps-asset.BreadCrumb#base_url
       * @description The base url
       * @type {String}
       * @default 'portal.cgi'
       */
      base_url: '/portal.cgi',
      /**
       * @description the name of the current site
       * @name nixps-asset.BreadCrumb#site
       * @type {String}
       * @default undefined
       * @since 2.1.0
       */
      site: undefined,
      /**
       * @name nixps-asset.BreadCrumb#separatorHTML
       * @description Specify here the html we must set between the folder nodes
       * @type {String | HTML}
       * @default "&nbsp; &gt; &nbsp;"
       */
      separatorHTML: "&nbsp; &gt; &nbsp;",
      /**
       * @name nixps-asset.BreadCrumb#rootIcon
       * @description insert
       * @type {String}
       * @default false
       */
      rootIcon: false,
      /**
       * @name nixps-asset.BreadCrumb#rootUrl
       * @description The root of the url 
       * @type {String}
       * @default ""
       */
      rootUrl: "",
      maxLength: 0
    },
    /**
     * @description create the component
     * @name nixps-asset.BreadCrumb#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      // skeleton
      this.element.append($("<span>").addClass('breadcrumb-span'));
      // variables
      this.truncatedMenu;
      this._draw();
      this._on(this.element, {
        "click .breadcrumb_rooticon": this._rootIconClickHandler,
        "click .breadcrumb_sitename": this._siteNameClickHandler,
        "click .breadcrumb_truncator": this._menuClickHandler
      });
    },
    /**
     * @description function runs when user click on root icon
     * @function
     * @private
     * @name nixps-asset.BreadCrumb#_rootIconClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _rootIconClickHandler: function _rootIconClickHandler(pEvent, pData) {
      if (this.options.site === null) {
        this.options.callback("X", undefined, null);
      } else {
        this.options.callback("X", undefined, "");
      }
      pEvent.preventDefault();
      return false;
    },
    /**
     * @description function runs when user click on site icon
     * @function
     * @private
     * @name nixps-asset.BreadCrumb#_rootIconClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _siteNameClickHandler: function _siteNameClickHandler(pEvent, pData) {
      this.options.siteCallback();
    },
    /**
     * @description Function runs when user clickt on the three dots
     * @function
     * @private
     * @name nixps-asset.BreadCrumb#_menuClickHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _menuClickHandler: function _menuClickHandler(pEvent, pData) {
      // add transparent backend panel, that adsorbe a click event, hide the menu and remove itself
      $('body').append($('<div>').addClass("truncatedmenu_overlay cf-overlay-transparent").on("click", this._menuExitHandler.bind(this)));
      // move to body
      $('body').append(this.truncatedMenu);
      this.truncatedMenu.css("display", "inline-block");
      this.truncatedMenu.position({
        "of": this.element.find(".breadcrumb_truncatoricon"),
        "my": "center top",
        "at": "center center+10px",
        "collision": "fit fit"
      }).on("click", this._menuExitHandler.bind(this));
    },
    /**
     * @description function runs when trucated menu must disapear
     * @function
     * @private
     * @name nixps-asset.BreadCrumb#_menuExitHandler
     */
    _menuExitHandler: function _menuExitHandler() {
      this.truncatedMenu.hide();
      this.element.children('.breadcrumb_truncator').append(this.truncatedMenu);
      $('body').children('.truncatedmenu_overlay').remove();
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps-asset.BreadCrumb#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-asset.BreadCrumb#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      if (typeof this.options.url === "string") {
        this.update_root(this.options.url);
      }
    },
    /**
     * @name nixps-asset.BreadCrumb#update_root
     * @description Update the breabcrumb corresponding to the cloudflow url
     * @function
     * @param {string} p_url
     * @returns {undefined}
     */
    update_root: function update_root(p_url) {
      // remove previous elements
      if (this.truncatedMenu !== undefined && this.truncatedMenu.length > 0) {
        $('body').children('.truncatedmenu_overlay').remove();
        this.truncatedMenu.remove();
      }
      this.element.children('span').empty();

      // first remove cloudflow
      p_url = removePrefix(p_url);
      var rootUrl = removePrefix(this.options.rootUrl);
      var cliptedRootURL = "";
      if (p_url.substring(0, rootUrl.length) === rootUrl) {
        // is url part of rootURL?
        p_url = p_url.substring(rootUrl.length);
        cliptedRootURL = rootUrl;
      }
      var l_parts_with_emptys = p_url.split("/");
      var l_parts = [];
      // remove all empty strings...
      for (var i = 0; i < l_parts_with_emptys.length; i++) {
        if (l_parts_with_emptys[i] !== "") {
          l_parts.push({
            "name": l_parts_with_emptys[i]
          });
        }
      }
      var previousURL = "";
      for (var i = 0; i < l_parts.length; i++) {
        previousURL = previousURL + l_parts[i].name + "/";
        l_parts[i].url = previousURL;
      }
      // remove last "/" from file
      if (p_url.length > 0 && l_parts.length > 0 && p_url[p_url.length - 1] !== "/") {
        l_parts[l_parts.length - 1].url = l_parts[l_parts.length - 1].url.slice(0, -1);
      }
      var trucatedShortlinks = [];
      if (typeof this.options.maxLength === "number" && this.options.maxLength > 0 && l_parts.length > 3) {
        var displayString = l_parts[l_parts.length - 1].url;
        while (l_parts.length > 3 && decode(displayString).length > this.options.maxLength) {
          var middleIndex = parseInt(l_parts.length / 2); // is min 4/2 = 2
          // first step both are added,
          // later alternate add element before it or after it
          if (l_parts[middleIndex - 1].trucated !== true) {
            // before, folder name comes before, so is parent, prepend to beginning
            trucatedShortlinks.unshift(l_parts[middleIndex - 1]);
          }
          if (l_parts[middleIndex].trucated !== true) {
            // after, folder name cames after, so is child, append to list
            trucatedShortlinks.push(l_parts[middleIndex]);
          }
          l_parts.splice(middleIndex, 1);
          l_parts[middleIndex - 1].trucated = true;
          displayString = "";
          $.each(l_parts, function (index, elem) {
            displayString += ">" + (elem.trucated === true ? "..." : elem.name);
          });
        }
      }
      this._add_root_step(l_parts.length > 0);
      for (var i = 0; i < l_parts.length; i++) {
        if (i > 0) {
          // if not first element
          this.element.children("span").append(this.options.separatorHTML);
        }
        if (l_parts[i].trucated === true) {
          var truncated = $('<span>').addClass("breadcrumb_truncatoricon").text('...');
          this.truncatedMenu = $('<div>').addClass("breadcrumb_truncatormenu cf-dropdown cf-zindex-dropdownlist").hide().css("max-width", "100%");
          this.element.children('span').append($("<span>").addClass("breadcrumb_truncator").append(truncated).append(this.truncatedMenu));
          for (var l = 0; l < trucatedShortlinks.length; l++) {
            // add each , even the trucated true's
            this.add_step(this.truncatedMenu, "cloudflow://" + cliptedRootURL + trucatedShortlinks[l].url, trucatedShortlinks[l].name, "cf-dropdown-item cf-dropdown-item-block");
          }
        } else {
          this.add_step(this.element.children('span'), "cloudflow://" + cliptedRootURL + l_parts[i].url, l_parts[i].name, "");
        }
      }
    },
    add_step: function add_step(pParentDOM, p_target, p_name, pLinkClasses) {
      if (this.options.callback === undefined) {
        pParentDOM.append($("<a>").addClass(pLinkClasses).attr('href', this.options.base_url + "?asset=" + encodeURIComponent(p_target)).text(p_name));
      } else {
        var that = this;
        pParentDOM.append($("<a>").addClass(pLinkClasses).attr('href', this.options.base_url + "?asset=" + encodeURIComponent(p_target)).text(p_name).text(decodeComponent(p_name)).on("click", function (pEvent) {
          pEvent.preventDefault();
          pEvent.stopImmediatePropagation();
          that.options.callback(p_target, undefined, that.options.site);
          return false;
        }));
      }
    },
    /**
     * @description Add a root icon if provided.
     * @function
     * @private
     * @name nixps-asset.BreadCrumb#_add_root_step
     * @param {boolean} pMustAddSeparator
     * @returns {undefined}
     */
    _add_root_step: function _add_root_step(pMustAddSeparator) {
      // first control if we realy need to add a root icon?
      if (typeof this.options.rootIcon === "string" && this.options.rootIcon.length > 0) {
        var that = this;
        var rootIcon = $("<a>").attr("href", this.options.base_url + "?asset=X").addClass('breadcrumb_rooticon remove_focus_blue').html(this.options.rootIcon);
        this.element.children('span').append(rootIcon);
        if (typeof this.options.site === "string" && this.options.site.length > 0) {
          var siteName = $('<span>').addClass("breadcrumb_sitename").text(" (" + this.options.site + ")");
          this.element.children('span').append(siteName);
        }
        if (pMustAddSeparator === true) {
          this.element.children('span').append(this.options.separatorHTML);
        }
      }
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-asset.BreadCrumb#_setOptions
     */
    _setOptions: function _setOptions(pOptions) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.rootUrl !== "string") {
        throw new Error("input option rootUrl must be a string");
      }
      if (this.options.rootUrl.length > 0 && this.options.rootUrl[this.options.rootUrl.length - 1] !== "/") {
        var lastDotIndex = this.options.rootUrl.lastIndexOf(".");
        var lastSlashIndex = this.options.rootUrl.lastIndexOf("/");
        if (lastSlashIndex > 0 && lastDotIndex > lastSlashIndex) {
          // file detected
          this.options.rootUrl = this.options.rootUrl.substring(0, lastSlashIndex);
        }
        this.options.rootUrl += "/";
        console.warn("BreadCrumb: changed option rootUrl to a folder");
      }
    },
    _destroy: function _destroy() {
      this._superApply(arguments);
      $('body').children('.truncatedmenu_overlay').remove();
      if (this.truncatedMenu !== undefined && this.truncatedMenu.length > 0) {
        this.truncatedMenu.remove();
      }
    }
  });
})(jQuery);

},{}],404:[function(require,module,exports){
"use strict";

var loginFunctions = require("./loginUtil.js");
var Version = require("../../../cloudflow/Version/js/Version.js");
var Location = require("../../../cloudflow/CloudflowUtil/js/Location.js");

/**
 * @description Handler that is executed when the login has failed
 * @function
 */
function loginFailedHandler(pReason, pLoginDoneCB) {
  var informFailToCB = false;
  if (pReason.error_code === "mfa_code_required") {
    // hide passwords
    $("#username").css("display", "none");
    $("#password").parent().css("display", "none");
    // clean up
    var scope_option;
    if ($("#scope_options").length > 0) {
      scope_option = $("#scope_options").val();
    }
    $("#scope_options").parent(".cf-form-group").remove();
    $("#mfa").remove();
    // draw
    var mfaDOM = $("<div>").attr("id", "mfa").addClass("cf-form-group cf-form-add-gutter").data("attempt_id", pReason.attempt_id).data("scope_option", scope_option);
    if (typeof pReason.mfa_seed === "string" && pReason.mfa_seed.length > 0) {
      $("#loginTitle").text($.i18n._("nixps-cloudflow-login.initialise_mfa_code"));
      mfaDOM.append($("<div>").addClass("cf-form-main-message")._t("nixps-cloudflow-login.mfa_authenticationcode"));
      mfaDOM.append($("<div>").addClass("cf-center-text").text(pReason.mfa_seed));
      mfaDOM.append($("<div>").addClass("cf-center-text").append($("<img>").attr("src", pReason.mfa_seed_image)));
      mfaDOM.addClass("cf-form-group-has-message");
      mfaDOM.append($("<div>").addClass("cf-form-main-message")._t("nixps-cloudflow-login.mfa_verificationcode"));
    } else {
      $("#loginTitle").text($.i18n._("nixps-cloudflow-login.input_mfa_code"));
    }
    $("#loginTitle").closest(".cf-form-group").addClass("cf-form-group-has-message");
    $("#loginStatus").text("");
    mfaDOM.append($("<input>").addClass("cf-form-control cf-form-col-12").attr({
      "id": "totp",
      "type": "text",
      "inputmode": "numeric",
      "autocomplete": "one-time-code",
      "autoCapitalize": "off"
    }).css({
      "letter-spacing": 4
    }));
    mfaDOM.insertAfter($("#password").parent(".cf-form-group"));
    $("#loginButton").text($.i18n._("nixps-cloudflow-login.verify")).attr("value", $.i18n._("nixps-cloudflow-login.verify")).prop("disabled", false);
  } else if (pReason.error_code === "missing_scope" && Array.isArray(pReason.available_scopes) && pReason.available_scopes.length > 0) {
    // hide passwords
    $("#username").css("display", "none");
    $("#password").parent().css("display", "none");
    // clean up
    $("#scope_options").parent(".cf-form-group").remove();
    $("#mfa").remove();
    // draw
    $("#loginTitle").text($.i18n._("nixps-cloudflow-login.select_scope"));
    $("#loginTitle").closest(".cf-form-group").addClass("cf-form-group-has-message");
    $("#loginStatus").text("");
    if ($("#scope_options").length === 0) {
      $('<div class="cf-form-group cf-form-add-gutter"><select class="cf-form-control cf-form-col-12" id="scope_options"></select></div>').insertAfter($("#password").parent(".cf-form-group"));
    }
    pReason.available_scopes.forEach(function (scope, index) {
      $("#scope_options").append($("<option>").val(scope.name).text(scope.name));
    });
    $("#loginButton").prop("disabled", false);
  } else if (pReason === "1") {
    pReason = $.i18n._("nixps-cloudflow-login.error-user_not_registered");
    $("#loginTitle").text("");
    $("#loginStatus").text(pReason);
    $("#loginStatus").closest(".cf-form-group").addClass("cf-form-group-has-message");
    $("#loginButton").prop("disabled", false);
    informFailToCB = true;
  } else if (pReason.error_code === "oauth_init_failed") {
    // just informative error message
    $("#loginTitle").text("");
    $("#loginStatus").text($.i18n._("nixps-cloudflow-login.error-oauth_init_failed"));
    $("#loginStatus").closest(".cf-form-group").addClass("cf-form-group-has-message");
  } else {
    $("#loginTitle").text("");
    $("#loginStatus").text(pReason);
    $("#loginStatus").closest(".cf-form-group").addClass("cf-form-group-has-message");
    $("#loginButton").prop("disabled", false);
    informFailToCB = true;
  }
  if (informFailToCB === true) {
    var error = {};
    if (pReason === $.i18n._("nixps-cloudflow-login.error-user_not_registered")) {
      error["error_code"] = "user_not_registered";
      error["message"] = pReason;
    } else if (pReason === $.i18n._("nixps-cloudflow-login.error-no_script_tag_allowed")) {
      error["error_code"] = "no_script_tag";
      error["message"] = pReason;
    } else {
      error["error_code"] = "login_error";
      error["message"] = pReason;
    }
    pLoginDoneCB("loginFail", {
      username: $("#username").val(),
      error: error
    });
  }
}
function _isOrigEval(pOrig) {
  var result1 = false;
  var result2 = false;
  var result3 = false;
  if (typeof pOrig === "string" && pOrig !== "/") {
    //unencoded string test
    var test1 = /<\/?script/i;
    //encoded lower case test
    var test2 = /%3c\/?script/i;
    //encoded Component test
    var test3 = /%3C%2Fscript/i;
    result1 = test1.test(pOrig);
    result2 = test2.test(pOrig);
    result3 = test3.test(pOrig);
  }
  return result1 === true || result2 === true || result3 === true;
}

/**
 * Handler that does the login
 */
function loginHandler(pLoginDoneCB, pOrigURL, pProtectCookies) {
  if (_isOrigEval(pOrigURL)) {
    loginFailedHandler($.i18n._("nixps-cloudflow-login.error-no_script_tag_allowed"), pLoginDoneCB);
  } else {
    $("#loginButton").prop("disabled", true);
    $("#loginStatus").closest(".cf-form-group").removeClass("cf-form-group-has-message");
    var username = $("#username").val();
    var password = $("#password").val();
    if ($("#mfa").length > 0) {
      var code = $("#mfa").find("input").val();
      var attempt_id = $("#mfa").data("attempt_id");
      var _scope_option = $("#mfa").data("scope_option") === undefined ? "" : $("#mfa").data("scope_option");
      if (pProtectCookies === true) {
        loginFunctions.doMFALoginWithRedirect(username, attempt_id, code, _scope_option, function (pUserId, pSessionData) {
          return loginFunctions.setFrameSession(username, pSessionData).then(function () {
            pLoginDoneCB("loginSuccess", {
              username: username
            });
          });
        }, function (pFail) {
          loginFailedHandler(pFail, pLoginDoneCB);
        });
      } else {
        loginFunctions.doMFALogin(username, attempt_id, code, _scope_option, function (pUserId) {
          loginFunctions.setFrameSession(username).then(function () {
            var mustRedirect = pLoginDoneCB("loginSuccess", {
              username: username
            });
            if (mustRedirect === true) {
              document.location.assign(pOrigURL);
            }
          });
        }, function (pFail) {
          loginFailedHandler(pFail, pLoginDoneCB);
        });
      }
    } else if ($("#scope_options").length > 0) {
      var scope_option = $("#scope_options").val();
      if (pProtectCookies === true) {
        loginFunctions.doLoginwithRedirect(username, password, scope_option, function (pUserId, pSessionData) {
          return loginFunctions.setFrameSession(username, pSessionData).then(function () {
            pLoginDoneCB("loginSuccess", {
              username: username
            });
          });
        }, function (pFail) {
          loginFailedHandler(pFail, pLoginDoneCB);
        });
      } else {
        loginFunctions.doLoginWithOptions(username, password, scope_option, function (pUserId) {
          loginFunctions.setFrameSession(username).then(function () {
            var mustRedirect = pLoginDoneCB("loginSuccess", {
              username: username
            });
            if (mustRedirect === true) {
              document.location.assign(pOrigURL);
            }
          });
        }, function (pFail) {
          loginFailedHandler(pFail, pLoginDoneCB);
        });
      }
    } else {
      if (pProtectCookies === true) {
        loginFunctions.doLoginwithRedirect(username, password, "", function (pUserId, pSessionData) {
          return loginFunctions.setFrameSession(username, pSessionData).then(function () {
            pLoginDoneCB("loginSuccess", {
              username: username
            });
          });
        }, function (pFail) {
          loginFailedHandler(pFail, pLoginDoneCB);
        });
      } else {
        loginFunctions.doLoginWithOptions(username, password, "", function (pUserId) {
          loginFunctions.setFrameSession(username).then(function () {
            var mustRedirect = pLoginDoneCB("loginSuccess", {
              username: username
            });
            if (mustRedirect === true) {
              document.location.assign(pOrigURL);
            }
          });
        }, function (pFail) {
          loginFailedHandler(pFail, pLoginDoneCB);
        });
      }
    }
  }
}

/**
 * Draws the UI and binds the events
 * @param {string} pLanguage 
 */
function renderLogin(pLanguage, pVersionObject, pDocumentTitle, pOrigURL, pOrigUser, pProtectCookies, pLoginDoneCB, pLoginButtonText) {
  return $.Deferred(function (pDefer) {
    if (typeof pDocumentTitle === "string") {
      document.title = $.i18n._(pDocumentTitle);
    }
    $("#username").attr("placeholder", $.i18n._("nixps-cloudflow-login.username"));
    $("#password").attr("placeholder", $.i18n._("nixps-cloudflow-login.password"));

    // Set defaults in case the variables are not filled in
    var origURL = pOrigURL;
    if (pOrigURL === undefined) {
      // error during login procedure
      origURL = "/";
    } else if (pOrigURL === "<!--ORIG-->") {
      origURL = window.location.href;
    } else {
      if (pOrigURL.startsWith("/?orig=")) {
        pOrigURL = decodeURIComponent(pOrigURL.replace("/?orig=", ""));
      }
      origURL = Location.forceSameOrigin(pOrigURL);
    }
    if (pOrigUser === "<!--USERNAME-->") {
      pOrigUser = "";
    }
    if (typeof pOrigUser === "string" && pOrigUser.length > 0) {
      $("#username").val(pOrigUser);
    }

    // Try to generate the oauth2 link
    api_defer.auth.generate_oauth2_url("google").then(function (pData) {
      if (pData.result !== undefined && pData.result !== null) {
        $("a#googleButton").attr("href", pData.result);
        $("div#google").show();
      }
    }, function () {
      /* ignore error */
    });

    // Bind the login button
    $("#loginButton").attr("value", pLoginButtonText === undefined ? $.i18n._("nixps-cloudflow-login.ok") : $.i18n._(pLoginButtonText)).prop("disabled", false).off().on("click", function () {
      loginHandler(pLoginDoneCB, origURL, pProtectCookies);
    });

    // Focus the right field
    if ($("#username").val() === "") {
      $("#username").trigger("focus");
    } else {
      $("#password").trigger("focus");
    }

    // Bind the return keypress
    $(document).on("keypress", function (pEvent) {
      if (pEvent.keyCode === 13) {
        if ($(pEvent.target).is("[name='username']") && $("#password").val() === "") {
          $("#password").trigger("focus");
          return false;
        } else {
          loginHandler(pLoginDoneCB, origURL, pProtectCookies);
        }
      }
    });

    // Show the version text
    if (pVersionObject === undefined) {
      Version.get().then(function (version) {
        var loginText = loginFunctions.getVersionText(version.getVersionObject());
        $("#versionText").text(loginText);
      });
    } else {
      var loginText = loginFunctions.getVersionText(pVersionObject);
      $("#versionText").text(loginText);
    }
    if (Location.getLocation().toString().indexOf("error=") >= 0) {
      var url = Location.getLocation().toString();
      if (url.substring(url.indexOf("error=") + 6).indexOf("&") !== -1) {
        loginFailedHandler(decodeURIComponent(url.substring(url.indexOf("error=") + 6, url.indexOf("error=") + 6 + url.substring(url.indexOf("error=") + 6).indexOf("&"))), pLoginDoneCB);
      } else {
        loginFailedHandler(decodeURIComponent(url.substring(url.indexOf("error=") + 6)), pLoginDoneCB);
      }
    }

    // Promise.resolve({result: ["azure-saml2"]}).then(function(pData) {
    api_defer.auth.get_identity_providers().then(function (pData) {
      if (Array.isArray(pData.result) && pData.result.length > 0) {
        for (var i = 0; pData.result.length > i; i++) {
          var oauth_type = pData.result[i];
          //http://www.w3.org/2000/svg
          // var icon = $('<svg>').attr("xmlns", "http://www.w3.org/2000/svg").attr("viewBox", "0 0 48 48");
          if (pData.result[i] !== 'none') {
            var icon = '';
            var icon_azure = $('<svg aria-hidden="true" role="presentation" data-slug-id="azure" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">' + '<defs>' + '<linearGradient id="azure_ab40b385-f958-420f-bfab-714be1677426-4a336842" x1="-960.606" y1="283.397" x2="-1032.511" y2="70.972" gradientTransform="matrix(1 0 0 -1 1075 318)" gradientUnits="userSpaceOnUse">' + '<stop offset="0" stop-color="#114a8b"></stop>' + '<stop offset="1" stop-color="#0669bc"></stop>' + '</linearGradient>' + '<linearGradient id="azure_f40af90d-72eb-49b3-94b2-2510f1071722-6b298772" x1="-938.144" y1="184.402" x2="-954.778" y2="178.778" gradientTransform="matrix(1 0 0 -1 1075 318)" gradientUnits="userSpaceOnUse">' + '<stop offset="0" stop-opacity=".3"></stop>' + '<stop offset=".071" stop-opacity=".2"></stop>' + '<stop offset=".321" stop-opacity=".1"></stop>' + '<stop offset=".623" stop-opacity=".05"></stop>' + '<stop offset="1" stop-opacity="0"></stop>' + '</linearGradient>' + '<linearGradient id="azure_e382d742-7d51-4974-a256-24e182eef053-77dabbd6" x1="-947.292" y1="289.594" x2="-868.363" y2="79.308" gradientTransform="matrix(1 0 0 -1 1075 318)" gradientUnits="userSpaceOnUse">' + '<stop offset="0" stop-color="#3ccbf4"></stop>' + '<stop offset="1" stop-color="#2892df"></stop>' + '</linearGradient>' + '</defs>' + '<path d="M89.158 18.266h69.238L86.523 231.224a11.041 11.041 0 01-10.461 7.51H22.179a11.023 11.023 0 01-10.445-14.548l66.963-198.41a11.04 11.04 0 0110.461-7.51z" fill="url(#azure_ab40b385-f958-420f-bfab-714be1677426-4a336842)"></path>' + '<path d="M189.77 161.104H79.976a5.083 5.083 0 00-3.468 8.8l70.552 65.847a11.091 11.091 0 007.567 2.983h62.167z" fill="#0078d4"></path>' + '<path d="M89.158 18.266a10.95 10.95 0 00-10.483 7.654L11.817 224.006a11.01 11.01 0 0010.393 14.728h55.274a11.814 11.814 0 009.069-7.714l13.33-39.29 47.625 44.418a11.267 11.267 0 007.089 2.586h61.937l-27.166-77.63-79.19.018 48.47-142.856z" fill="url(#azure_f40af90d-72eb-49b3-94b2-2510f1071722-6b298772)"></path>' + '<path d="M177.592 25.764a11.023 11.023 0 00-10.444-7.498H89.984a11.024 11.024 0 0110.445 7.498l66.967 198.421a11.024 11.024 0 01-10.445 14.549h77.164a11.024 11.024 0 0010.444-14.549z" fill="url(#azure_e382d742-7d51-4974-a256-24e182eef053-77dabbd6)"></path>' + '</svg>');
            var icon_google = $('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/><path d="M1 1h22v22H1z" fill="none"/></svg>');
            var text = "";
            if (oauth_type === "azure-saml2") {
              icon = icon_azure;
              text = $.i18n._("nixps-cloudflow-login.sign_in_with_azure");
            } else if (oauth_type === "google") {
              icon = icon_google;
              text = $.i18n._("nixps-cloudflow-login.sign_in_with_google");
            }
            var leftSidebutton = $("<div>").addClass("icon_" + pData.result[i]).append(icon);
            var rightSidebutton = $("<span>").addClass("button_" + pData.result[i]).text(text);
            //.attr("data-client_id", "YOUR_GOOGLE_CLIENT_ID").attr("data-login_uri", "https://your.domain/your_login_endpoint").attr("data-auto_prompt", "false")
            var oauth_html = $("<div>").addClass(pData.result[i] + "_oauth2").append(leftSidebutton);
            oauth_html.append(rightSidebutton);
            oauth_html.on("click", function (pEvent) {
              oauthHandler(oauth_type);
            });
            $("#oauth2").addClass("oauth2").append(oauth_html);
          }
        }
      }
      return pDefer.resolve();
    }, function (pError) {
      console.error(pError);
      /* ignore error */
      var error = {
        error_code: "oauth_init_failed",
        error: "",
        error_object: pError
      };
      loginFailedHandler(error);
      return pDefer.resolve(error);
    });
  });
}
function oauthHandler(pInput) {
  api_defer.auth.generate_login_url(pInput).then(function (pResult) {
    window.location = pResult.result;
  });
}
function areCookiesPotentialGood() {
  var expiration_date = api_util.get_cookie("expiration_date");
  if (typeof expiration_date === "string" && expiration_date.length > 0) {
    var nowMinOneHour = new Date().setHours(new Date().getHours() - 1);
    if (+(expiration_date + "000") > nowMinOneHour) {
      return true;
    }
  }
  return false;
}
function tabReOpenHandler(pEvent) {
  if (document.hidden === false && typeof pEvent.data.origurl === "string" && pEvent.data.origurl.length > 0 && _isOrigEval(pEvent.data.origurl) === false) {
    var origURL = pEvent.data.origurl;
    if (origURL.startsWith("/?orig=")) {
      origURL = decodeURIComponent(origURL.replace("/?orig=", ""));
    }
    origURL = Location.forceSameOrigin(origURL);
    var user_id = api_util.get_cookie("user_id");
    if (typeof user_id === "string" && user_id.length > 0) {
      if (areCookiesPotentialGood()) {
        document.location.assign(origURL);
      }
    } else {
      api_defer.auth.get_identity_providers().then(function (pResult) {
        if (pResult.result !== undefined && pResult.result.length > 0) {
          document.location.assign(origURL);
        }
      });
    }
  }
}

/**
 * Entry point of the login page
 */
function loginStart(pDocumentTitle, pOrigURL, pOrigUser, pLoginDoneCB, pLoginButtonText) {
  /* reset sessions */
  if (window.sessionStorage !== undefined) {
    sessionStorage.clear();
  }

  //fallback function for the LoginDoneCB (case login isn't in a CustomLogin component)
  if (pLoginDoneCB === undefined) {
    pLoginDoneCB = function pLoginDoneCB() {
      if (window.location.search.endsWith("&closeafterlogin=true")) {
        window.close();
        return false;
      } else {
        return true;
      }
    };
  }
  $(document).on("visibilitychange", {
    origurl: pOrigURL
  }, tabReOpenHandler);
  var protectCookies = false;
  var prefsPromise = api_defer.preferences.get_for_current_user(["", "com.nixps.general.prerelease"], ["language", "protected_cookies"]).then(function (pResult) {
    if (Array.isArray(pResult.preferences) && pResult.preferences.length === 2) {
      protectCookies = pResult.preferences[1];
    }
    return pResult;
  });
  return $.when(prefsPromise, Version.get()).then(function (prefs, version) {
    var language = prefs.preferences[0];
    var build = version.getBuild();
    return $.when($.get("/cloudflow_" + language + ".json?" + build), language, version.getVersionObject());
  }).then(function (translations, language, pVersionObject) {
    $.i18n.setDictionary(translations[0]);
    return renderLogin(language, pVersionObject, pDocumentTitle, pOrigURL, pOrigUser, protectCookies, pLoginDoneCB, pLoginButtonText);
  }).fail(function (pError) {
    $.get("/cloudflow_en.json?" + new Date().getTime()).then(function (p_translations) {
      $.i18n.setDictionary(p_translations);
      renderLogin("en", undefined, pDocumentTitle, pOrigURL, pOrigUser, protectCookies, pLoginDoneCB);
    }).fail(function (pError) {
      console.error(pError);
      // even translations failed, so we can not translate error message :-(
      $("#loginStatus").text("Unable to setup login. Retry later.").closest(".cf-form-group").addClass("cf-form-group-has-message");
    });
  });
}
module.exports = {
  loginStart: loginStart,
  renderLogin: renderLogin
};

},{"../../../cloudflow/CloudflowUtil/js/Location.js":90,"../../../cloudflow/Version/js/Version.js":269,"./loginUtil.js":405}],405:[function(require,module,exports){
"use strict";

function _getUrlParameters() {
  var orig = "";
  var params = "";
  var url = window.location.toString();
  if (url.indexOf("orig=") >= 0) {
    if (url.substring(url.indexOf("orig=") + 5).indexOf("&") !== -1) {
      orig = decodeURIComponent(url.substring(url.indexOf("orig=") + 5, url.indexOf("orig=") + 6 + url.substring(url.indexOf("orig=") + 5).indexOf("&")));
    } else {
      orig = decodeURIComponent(url.substring(url.indexOf("orig=") + 5));
    }
    return orig;
  } else if (url.indexOf("login=") === -1) {
    return "";
  } else {
    return "";
  }
}
function _urlRedirect(options) {
  var $form = document.createElement("FORM");
  $form.setAttribute("action", options.url);
  $form.setAttribute("method", options.method);
  for (var data in options.data) {
    var $input = document.createElement("INPUT");
    $input.setAttribute("type", "hidden");
    $input.setAttribute("name", data);
    $input.setAttribute("value", options.data[data]);
    $form.append($input);
  }
  document.body.append($form);
  $form.submit();
  $form.remove();
}

/**
 * @description remove all cookies
 * @function
 */
function _removeOtherCookies() {
  var cookiesToLive = ["user_id", "user_hash", "expiration_date", "build_version", "csrf-token", "cf_sidebar_displaymode", "cf_jsoneditor_displaymode"];
  var pairs = document.cookie.split(";");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    var cookieKey = pair[0].trim();
    if (typeof cookieKey === "string" && cookieKey.length > 0 && cookiesToLive.includes(cookieKey) === false) {
      api_util.set_cookie(cookieKey, null); // remove it
    }
  }
}

/**
 * @description inform others about the login
 * @function
 * @param {String} pMessage the message id
 */
function _broadCastMessage(pMessage) {
  if (typeof window.BroadcastChannel === "function") {
    var bc = new BroadcastChannel("nixps");
    bc.postMessage({
      type: pMessage,
      data: {}
    });
  }
}

/**
 * @description set all the needed cookies
 * @function
 * @param {Object} pData object containing data to set the cookies
 */
function _setCookies(pData) {
  // Store our login in a cookie
  var secureOptions = {
    expires: 2,
    // default 2 days
    path: "/",
    samesite: "Lax"
  };
  if (document.location.protocol === "https:") {
    secureOptions.secure = true;
  }
  if (pData.expiration_date !== undefined) {
    secureOptions.expires = (pData.expiration_date - new Date().getTime() / 1000) / 86400 + 1;
  }
  api_util.set_cookie("user_id", pData.user_id, secureOptions);
  api_util.set_cookie("user_hash", pData.user_hash, secureOptions);
  api_util.set_cookie("expiration_date", pData.expiration_date, secureOptions);
  api_util.set_cookie("csrf-token", pData.csrf_token, secureOptions);
  if (pData.scope_id !== undefined) {
    api_util.set_cookie("scope", pData.scope_id, {
      expires: secureOptions.expires,
      path: "/",
      samesite: "Lax"
    });
  }
}
function doMFALogin(pUsername, pAttemptID, pCode, pScope, pSuccess, pFailure) {
  if (typeof pAttemptID !== "string" || pAttemptID.length <= 0) {
    throw new Error("missing id");
  }
  if (typeof pCode !== "string" || pCode.length <= 0) {
    throw new Error("missing code");
  }
  _removeOtherCookies();
  var nakedCode = pCode.replace(/\W/g, ""); // remove all whitespaces
  var login_options = {
    "attempt_id": pAttemptID,
    "mfa_code": nakedCode
  };
  if (pScope !== "") {
    login_options.scope_name = pScope;
  }
  api_async.auth.mfa_login(pUsername, login_options, function (pData) {
    if (pData.user_id === undefined) {
      pFailure($.i18n._("nixps-cloudflow-login.error-login_failed"));
    } else {
      _setCookies(pData);
      _broadCastMessage("nixps.login");
      pSuccess(pData.user_id, null);
    }
  }, function (pError) {
    // all errors who are accepted and just mean, continue
    if (pError && ["missing_scope"].includes(pError.error_code)) {
      pFailure(pError);
    } else if (pError.error_code !== undefined) {
      var translatedError = $.i18n._("nixps-cloudflow-login.error-" + pError.error_code);
      if (translatedError === "nixps-cloudflow-login.error-" + pError.error_code) {
        // untranslateded error
        pFailure("generic error");
      } else {
        pFailure(translatedError);
      }
    } else if (pError.error !== undefined) {
      pFailure(pError.error);
    }
  });
}
function doMFALoginWithRedirect(pUsername, pAttemptID, pCode, pScope, pSuccess, pFailure) {
  if (typeof pAttemptID !== "string" || pAttemptID.length <= 0) {
    throw new Error("missing id");
  }
  if (typeof pCode !== "string" || pCode.length <= 0) {
    throw new Error("missing code");
  }
  _removeOtherCookies();
  var nakedCode = pCode.replace(/\W/g, ""); // remove all whitespaces
  var login_options = {
    "attempt_id": pAttemptID,
    "mfa_code": nakedCode
  };
  if (pScope !== "") {
    login_options.scope_name = pScope;
  }
  return api_defer.auth.create_session(pUsername, login_options).then(function (pResult) {
    var data = {
      "session": pResult.session,
      "orig": _getUrlParameters()
    };
    if (pScope !== "") {
      data.scope_name = pScope;
    }
    return Promise.resolve(pSuccess(null, pResult))["finally"](function () {
      _broadCastMessage("nixps.login");
      _urlRedirect({
        url: window.location.origin + "/portal.cgi?auth=login",
        method: "POST",
        data: data
      });
    });
  }, function (pError) {
    // all errors who are accepted and just mean, continue
    if (pError && ["missing_scope"].includes(pError.error_code)) {
      pFailure(pError);
    } else if (pError.error_code !== undefined) {
      var translatedError = $.i18n._("nixps-cloudflow-login.error-" + pError.error_code);
      if (translatedError === "nixps-cloudflow-login.error-" + pError.error_code) {
        // untranslateded error
        pFailure("generic error");
      } else {
        pFailure(translatedError);
      }
    } else if (pError.error !== undefined) {
      pFailure(pError.error);
    }
  });
}
function doLoginWithOptions(pUsername, pPassword, pScope, pSuccess, pFailure) {
  _removeOtherCookies();
  var login_options = {
    "password": pPassword
  };
  if (pScope !== "") {
    login_options.scope_name = pScope;
  }
  api_async.auth.login_with_options(pUsername, login_options, function (pData) {
    if (pData.user_id === undefined) {
      pFailure($.i18n._("nixps-cloudflow-login.error-login_failed"));
    } else {
      _setCookies(pData);
      _broadCastMessage("nixps.login");
      pSuccess(pData.user_id, null);
    }
  }, function (pError) {
    // all errors who are accepted and just mean, continue
    if (pError && ["missing_scope", "mfa_code_required"].includes(pError.error_code)) {
      pFailure(pError);
    } else if (pError.error_code !== undefined) {
      var translatedError = $.i18n._("nixps-cloudflow-login.error-" + pError.error_code);
      if (translatedError === "nixps-cloudflow-login.error-" + pError.error_code) {
        // untranslateded error
        pFailure("generic error");
      } else {
        pFailure(translatedError);
      }
    } else if (pError.error !== undefined) {
      pFailure(pError.error);
    }
  });
}
function doLogin(pUsername, pPassword, pSuccess, pFailure) {
  api_defer.preferences.get_for_current_user("com.nixps.general.prerelease", "protected_cookies").then(function (pPreference) {
    if (pPreference.preferences === true) {
      doLoginwithRedirect(pUsername, pPassword, "", pSuccess, pFailure);
    } else {
      doLoginWithOptions(pUsername, pPassword, "", pSuccess, pFailure);
    }
  }, function (pError) {
    console.error(pError);
    doLoginwithRedirect(pUsername, pPassword, "");
  });
}
function getVersionText(pVersionData) {
  var version = pVersionData.major + "." + pVersionData.minor;
  if (pVersionData.rev !== 0) {
    version += "." + pVersionData.rev;
  }
  var versionText = $.i18n._("nixps-cloudflow-login.version", [version, pVersionData.build]);
  return versionText;
}
function setFrameSession(pUsername, pSessionData) {
  return new Promise(function (pResolve) {
    Promise.all([api_defer.frame.os.get(), pSessionData || api_defer.auth.create_session(pUsername)]).then(function (pResults) {
      return api_defer.frame.os.set_cloudflow_session(pResults[1].session, {
        "force": true,
        "expiry_time": pResults[1].expiry_time
      });
    }).then(function () {
      pResolve();
    })["catch"](function () {
      pResolve();
    });
  });
}
function doLoginwithRedirect(pUsername, pPassword, pScope, pSuccess, pFailure) {
  _removeOtherCookies();
  var login_options = {
    password: pPassword
  };
  if (pScope !== "") {
    login_options.scope_name = pScope;
  }
  return api_defer.auth.create_session(pUsername, login_options).then(function (pResult) {
    var data = {
      "session": pResult.session,
      "orig": _getUrlParameters()
    };
    if (pScope !== "") {
      data.scope_name = pScope;
    }
    return Promise.resolve(pSuccess(null, pResult))["finally"](function () {
      _broadCastMessage("nixps.login");
      _urlRedirect({
        url: window.location.origin + "/portal.cgi?auth=login",
        method: "POST",
        data: data
      });
    });
  }, function (pError) {
    if (pError && ["missing_scope", "mfa_code_required"].includes(pError.error_code)) {
      pFailure(pError);
    } else if (pError.error_code !== undefined) {
      var translatedError = $.i18n._("nixps-cloudflow-login.error-" + pError.error_code);
      if (translatedError === "nixps-cloudflow-login.error-" + pError.error_code) {
        // untranslateded error
        pFailure("generic error");
      } else {
        pFailure(translatedError);
      }
    } else {
      pFailure(pError.error);
    }
  });
}
module.exports = {
  doLogin: doLogin,
  doMFALogin: doMFALogin,
  doLoginwithRedirect: doLoginwithRedirect,
  doLoginWithOptions: doLoginWithOptions,
  doMFALoginWithRedirect: doMFALoginWithRedirect,
  getVersionText: getVersionText,
  setFrameSession: setFrameSession
};

},{}],406:[function(require,module,exports){
"use strict";

(function ($) {
  var loginMain = require('./login.js');
  var count = 0;
  $.widget("nixps-cloudflow.CustomLogin", $.Widget, {
    version: "0.0.1",
    options: {
      /**
       * @description The language of the user
       * @name nixps-cloudflow.CustomLogin#language
       * @type {String | language_code}
       * @default "en"
       */
      language: "en",
      /**
       * @description Hides the default cloudflow title
       * @name nixps-cloudflow.CustomLogin#hideCloudflowText
       * @type {Boolean}
       * @default false
       */
      hideCloudflowText: false,
      /**
       * @description The text for the login button. Can be a string as well as a translation key.
       * @name nixps-cloudflow.CustomLogin#loginButtonText
       * @type {Boolean}
       * @default false
       */
      loginButtonText: "Sign in",
      /**
       * @description The classes added to the login button
       * @name nixps-cloudflow.CustomLogin#loginButtonClasses
       * @type {String}
       * @default ""
       */
      loginButtonClasses: "",
      /**
       * @description Whether the component is inside the pagebuilder editor or not.
       * @name nixps-cloudflow.CustomLogin#isInEditor
       * @type {Boolean}
       * @default false
       */
      isInEditor: false,
      /**
       * @description Should the component use the "orig" parameter inside the URL to redirect after succesful login
       * @name nixps-cloudflow.CustomLogin#useOrig
       * @type {Boolean}
       * @default true
       */
      useOrig: true,
      /**
       * @description Function gets called when the component has been created
       * @name nixps-cloudflow.CustomLogin#created
       * @type {Function}
       * @default function() {}
       */
      created: function created() {}
    },
    _create: function _create() {
      if (count > 0) {
        console.error("Login: there can only be one login component on a page");
        this.options.created();
        return;
      }
      this._controlOptions();
      this.element.addClass(this.widgetFullName);
      this._draw();
      count++;
      this._on(this.element, {});
      this.options.created();
    },
    _draw: function _draw() {
      this.element.empty();
      var dom = '<div id="loginDialog" class="cf-dialog cf-dialog-content cf-dialog-padding cf-dialog-fixwidth">' + '<div class="cf-company-logo" role="img"></div>' + '<h2 class="cf-title-title">CLOUDFLOW</h2>' + '<div id="versionText" class="cf-text cf-title-smallbody cf-secondary-text">&nbsp;</div>' + '<div class="cf-emptyline"></div>' + '<form id="login-form" class="cf-form" onsubmit="return false;" method="POST">' + '<div class="cf-form-group cf-form-add-gutter">' + '<div id="loginTitle" class="cf-form-main-message"></div>' + '<div id="loginStatus" class="cf-form-error-message">Login error</div>' + '<input class="cf-form-input cf-form-col-12" id="username" name="username" placeholder="Username" autoCapitalize="off">' + '</div>' + '<div class="cf-form-group cf-form-add-gutter">' + '<input class="cf-form-input cf-form-col-12" id="password" type="password" name="password" placeholder="Password">' + '</div>' + '<div class="cf-form-group cf-form-add-gutter">' + '<input id="loginButton" type="submit" value="" class="cf-form-col-12 cf-button cf-button-main" disabled="disabled">' + '</div>' + '<div id="oauth2">' + '</div>' + '</form>' + '</div>';
      this.element.append($(dom));
      this.element.find("#loginButton").attr("value", this.options.loginButtonText).addClass(this.options.loginButtonClasses);
      if (this.options.hideCloudflowText === true) {
        this.element.find(".cf-emptyline").hide();
        this.element.find(".cf-title-title").hide();
        this.element.find("#versionText").hide();
      } else {
        this.element.find(".cf-emptyline").show();
        this.element.find(".cf-title-title").show();
        this.element.find("#versionText").show();
      }
      this.element.find(".cf-dialog").css({
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
        "maxWidth": "400px"
      });
      //prevent login logic to be running when inside the editor
      if (this.options.isInEditor !== true) {
        var urlParameters = new URI().query(true);
        loginMain.loginStart(undefined, urlParameters.orig, urlParameters.login, this._loginDoneCB.bind(this), this.options.loginButtonText);
      }
      this.element.find(".cf-company-logo").hide();
    },
    _loginDoneCB: function _loginDoneCB(pResult, pData) {
      switch (pResult) {
        case "loginSuccess":
          if (this.options.useOrig === false) {
            this._trigger("success", null, {
              username: pData.username
            });
          }
          return this.options.useOrig;
        case "loginFail":
          this._trigger("fail", null, {
            username: pData.username,
            loginError: pData.error
          });
          break;
        default:
          throw new Error("CustomLogin: case '" + pResult + "' in loginDoneCB callback not supported");
      }
    },
    redraw: function redraw() {
      this._draw();
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
      });
      this._controlOptions();
      if (needRedraw === true) {
        this.redraw();
      }
    },
    _setOption: function _setOption(key, value) {
      if (key === "hideCloudflowText") {
        this.options.hideCloudflowText = value;
        if (value === true) {
          this.element.find(".cf-emptyline").hide();
          this.element.find(".cf-title-title").hide();
          this.element.find("#versionText").hide();
        } else {
          this.element.find(".cf-emptyline").show();
          this.element.find(".cf-title-title").show();
          this.element.find("#versionText").show();
        }
        return false;
      } else if (key === "loginButtonText") {
        this.options.loginButtonText = value;
        this.element.find("#loginButton")[0].value = value;
        return false;
      } else if (key === "loginButtonClasses") {
        this.element.find("#loginButton").removeClass(this.options.loginButtonClasses).addClass(value);
        this.options.loginButtonClasses = value;
        return false;
      } else if (key === "useOrig") {
        this.options.useOrig = value;
        return false;
      }
    },
    _controlOptions: function _controlOptions() {
      if (typeof this.options.created !== "function") {
        throw new Error("Login: the created option must be a function");
      }
      if (typeof this.options.hideCloudflowText !== "boolean") {
        throw new Error("Login: the hideCloudflowText option must be a boolean");
      }
      if (typeof this.options.loginButtonText !== "string") {
        throw new Error("Login: the loginButtonText option must be a string");
      }
      if (typeof this.options.loginButtonClasses !== "string") {
        throw new Error("Login: the loginButtonClasses option must be a string");
      }
      if (typeof this.options.isInEditor !== "boolean") {
        throw new Error("Login: the isInEditor option must be a boolean");
      }
      if (typeof this.options.useOrig !== "boolean") {
        throw new Error("Login: the useOrig option must be a boolean");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
      count--;
    }
  });
})(jQuery);

},{"./login.js":404}],407:[function(require,module,exports){
"use strict";

var StrftimeFormat = require("../../../3rdParty/strftime.js");
var FixedNotificationHandler = function FixedNotificationHandler(pLicense, pUser) {
  var that = this;
  this.user = pUser;
  this.messages = [];
  var experingDelay = 30;
  if (this.user.isAdminAdmin()) {
    if (pLicense.isExpired("maintenance")) {
      this.messages.push({
        title: $.i18n._("nixps-cloudflow-notifications.title_group_maintenaince"),
        text: $.i18n._("nixps-cloudflow-top.message_maintenance"),
        severity: "warning"
      });
    } else if (pLicense.willExpire("maintenance", experingDelay)) {
      var dateToMention = new Date(pLicense.getInfo("maintenance").end * 1000);
      this.messages.push({
        title: $.i18n._("nixps-cloudflow-notifications.title_group_maintenaince"),
        text: $.i18n._("nixps-cloudflow-top.message_expire", [StrftimeFormat("%B %d, %Y", dateToMention)]),
        severity: "warning"
      });
    } else {
      var expiredCodes = pLicense.getExpiredLicenseCodes();
      expiredCodes.forEach(function (pCode) {
        var info = pLicense.getInfo(pCode);
        that.messages.push({
          title: info.name,
          text: $.i18n._("nixps-cloudflow-top.message_license_expire", [info.code]),
          severity: "warning"
        });
      });
      var expiringCodes = pLicense.getExpiringLicenseCodes(experingDelay);
      expiringCodes.forEach(function (pCode) {
        var info = pLicense.getInfo(pCode);
        var dateToMention = new Date(info.end * 1000);
        that.messages.push({
          title: info.name,
          text: $.i18n._("nixps-cloudflow-top.message_license_expiring_soon", [info.code, StrftimeFormat("%B %d, %Y", dateToMention)]),
          severity: "warning"
        });
      });
    }
  }
  var pData = pLicense.getData();
  if (pData !== null && pData.machines !== undefined) {
    for (var m = 0; m < pData.machines.length; ++m) {
      if (pData.machines[m].activation === "not activated") {
        if (pData.machines[m].activation_days_left === 0) {
          this.messages.push({
            title: $.i18n._("nixps-cloudflow-license.title"),
            text: $.i18n._("nixps-cloudflow-license.activation-workserver_needs_activation_today", [pData.machines[m].name]),
            link: "/portal.cgi?config=1#license",
            severity: "warning"
          });
        } else if (pData.machines[m].activation_days_left < 10) {
          this.messages.push({
            title: $.i18n._("nixps-cloudflow-license.title"),
            text: $.i18n._("nixps-cloudflow-license.activation-workserver_needs_activation_days_left", [pData.machines[m].name, pData.machines[m].activation_days_left]),
            link: "/portal.cgi?config=1#license",
            severity: "warning"
          });
        }
      } else if (pData.machines[m].activation === "required") {
        this.messages.push({
          title: $.i18n._("nixps-cloudflow-license.title"),
          text: $.i18n._("nixps-cloudflow-license.activation-workserver_inactive_needs_activation", [pData.machines[m].name]),
          link: "/portal.cgi?config=1#license",
          severity: "warning"
        });
      } else if (pData.machines[m].activation === "error") {
        this.messages.push({
          title: $.i18n._("nixps-cloudflow-license.title"),
          text: $.i18n._("nixps-cloudflow-license.activation-workserver_inactive_invalid_activation", [pData.machines[m].name]),
          link: "/portal.cgi?config=1#license",
          severity: "warning"
        });
      }
    }
    if (pData.days_until_renew <= 30) {
      this.messages.push({
        title: $.i18n._("nixps-cloudflow-license.title"),
        text: $.i18n._("nixps-cloudflow-license.time_left_for_renew", [90, pData.days_until_renew]),
        link: "/portal.cgi?config=1#license",
        severity: "warning"
      });
    }
  }
};
FixedNotificationHandler.prototype = {
  constructor: FixedNotificationHandler,
  list: function list() {
    return structuredClone(this.messages);
  },
  count: function count() {
    return this.messages.length;
  }
};
module.exports = FixedNotificationHandler;

},{"../../../3rdParty/strftime.js":7}],408:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],409:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":408,"timers":409}],410:[function(require,module,exports){
"use strict";

(function () {
  // add missing cloudflow css variables
  if (document.getElementById("CSSVarCloudflowLight") === null) {
    // only add if not already included and if pagebuilder css exists 
    var linkDOM = document.createElement("LINK");
    linkDOM.setAttribute("type", "text/css");
    linkDOM.setAttribute("href", "/portal.cgi?resource=download&url=cfresource%3A%2F%2FStyleSheet%2FCloudflow%2520Light.css&override=true&inline=true");
    linkDOM.setAttribute("rel", "stylesheet");
    linkDOM.setAttribute("id", "CSSVarCloudflowLight");
    var select = document.querySelector("html > head > link[href=\"/dist/pagebuilder/nebula/nebulaframework.css\"]");
    if (select) {
      select.after(linkDOM);
    }
  }
})();

},{}],411:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var componentlist = {
  "CloudflowBar": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": [],
    "include_nebulacss": [],
    "include_js": ["/3rdParty/jquery.cookie.js"]
  },
  "SideBar": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": [],
    "include_nebulacss": [],
    "include_js": []
  },
  "TopNavigation": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": [],
    "include_nebulacss": [],
    "include_js": ["/3rdParty/jquery.cookie.js"]
  },
  "CreateWorkable": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": ["/upload/css/upload-layout.css", "/dist/FileChooser/nixps-FileChooser.css", "/common/RIPEditor/css/nixps-RIPEditor-presets.css", "/kiosk/css/nixps-kiosk-CreateWorkable.css"],
    "include_nebulacss": [],
    "include_js": ["/3rdParty/jquery.fileupload.js", {
      "src": "/3rdParty/ace/src-noconflict/ace.js",
      "data-ace-base": "/3rdParty/ace/src-noconflict",
      "charset": "utf-8"
    }, "/dist/pagebuilder/nixps-pagebuilder-EntityComposerDefinitionListMock.js"]
  },
  "FormDetailsPanel": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": ["/upload/css/upload-layout.css", "/dist/FileChooser/nixps-FileChooser.css", "/common/RIPEditor/css/nixps-RIPEditor-presets.css"],
    "include_nebulacss": [],
    "include_js": ["/3rdParty/jquery.fileupload.js", {
      "src": "/3rdParty/ace/src-noconflict/ace.js",
      "data-ace-base": "/3rdParty/ace/src-noconflict",
      "charset": "utf-8"
    }, "/dist/pagebuilder/nixps-pagebuilder-EntityComposerDefinitionListMock.js"]
  },
  "PreConfiguredTable": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": [],
    "include_nebulacss": [],
    "include_js": ["/3rdParty/stickyTableHeaders/js/jquery.stickytableheaders.min.js",
    // "/3rdParty/stickyTableHeaders/js/jquery.stickytableheaders.js",
    "/3rdParty/tinycolor.js"]
  },
  "ManageProjects": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": [],
    "include_nebulacss": [],
    "include_js": ["/3rdParty/stickyTableHeaders/js/jquery.stickytableheaders.min.js",
    // "/3rdParty/stickyTableHeaders/js/jquery.stickytableheaders.js",
    "/3rdParty/tinycolor.js"]
  },
  "CloudflowChart": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": [],
    "include_nebulacss": [],
    "include_js": []
  },
  "ProjectTimeline": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": ["/3rdParty/timeline/timeline.css"],
    "include_nebulacss": ["/3rdParty/timeline/timeline.css"],
    "include_js": []
  },
  "CloudflowCalendar": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": ["/3rdParty/fullcalendar-5.10.2/main.min.css"],
    "include_nebulacss": ["/3rdParty/fullcalendar-5.10.2/main.min.css"],
    "include_js": ["/3rdParty/fullcalendar-5.10.2/main.js"]
  },
  "frame": {
    "need_extra": true,
    "type": "async_object",
    "async_check": function async_check() {
      return api_defer.frame.os.get();
    },
    "include_css": [],
    "include_nebulacss": [],
    "include_js": []
  },
  "MyApprovals": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": [],
    "include_nebulacss": [],
    "include_js": []
  },
  "TwitterTimeLine": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_css": [],
    "include_nebulacss": [],
    "include_js": []
  },
  "logout": {
    "type": "class",
    "include_css": [],
    "include_nebulacss": [],
    "include_js": []
  },
  "ProjectFormAssets": {
    "need_extra": true,
    "type": "jquery_widget",
    "include_nebulacss": ["/3rdParty/vakata/themes/default/style.min.css"],
    "include_css": [],
    "include_js": []
  }
};
var ComponentLinks = function ComponentLinks() {};
ComponentLinks.needExtras = function (pComponentName) {
  if (componentlist[pComponentName] === undefined) {
    return false;
  }
  return componentlist[pComponentName].need_extra === true;
};
ComponentLinks.getJavaScriptLinks = function (pComponentName) {
  if (componentlist[pComponentName] === undefined) {
    return [];
  }
  return componentlist[pComponentName].include_js;
};
ComponentLinks.getStyleSheetsLinks = function (pComponentName, pUIMode) {
  if (componentlist[pComponentName] === undefined) {
    return [];
  }
  if (pUIMode === "nebula") {
    return componentlist[pComponentName].include_nebulacss;
  }
  return componentlist[pComponentName].include_css;
};
ComponentLinks.getType = function (pComponentName) {
  if (componentlist[pComponentName] === undefined) {
    return "undefined";
  }
  return componentlist[pComponentName].type;
};
ComponentLinks.getAsyncCheck = function (pComponentName) {
  if (componentlist[pComponentName] === undefined || componentlist[pComponentName]["async_check"] === undefined) {
    return function () {
      return {};
    };
  }
  return componentlist[pComponentName]["async_check"];
};

// this is for test porposes, ony add if not added already
if (window.nixpsComponentLinks === undefined) {
  window.nixpsComponentLinks = {
    add: []
  };
}
window.nixpsComponentLinks.add.push(function (pComponentName, pComponent, goodCb, errorCb) {
  if (typeof pComponentName !== "string" || pComponentName.length <= 0) {
    errorCb("pComponentName must be a not empty string");
    return;
  }
  if (componentlist[pComponentName] !== undefined) {
    errorCb("pComponentName already exists");
    return;
  }
  if (_typeof(pComponent) !== "object" || pComponent === null) {
    errorCb("pComponent must be an object");
    return;
  }
  if (Array.isArray(pComponent.include_js) === false || Array.isArray(pComponent.include_css) === false) {
    errorCb("pComponent must havae parameters include_js and include_css, who are both arrays");
    return;
  }
  componentlist[pComponentName] = Object.assign({}, pComponent);
  goodCb();
});
module.exports = ComponentLinks;

},{}],412:[function(require,module,exports){
"use strict";

// A list of all constants needed for pagebuilder
module.exports = Object.freeze({
  // the pagebuilder version number
  versionNumber: 17,
  minVersionNumber: 6
});
// 17 component  PowerBI, afterdraw actions, subactions
// 16 component  ProjectFormAssets
// 15 component  ObjectDetailsPanel
// 14 action     parentUUID: new type of checking
// 13 component  ProofscopeEmbed and CustomLogin
// 12 component  CloudflowButtonGroup and ImageSlider
// 11 vc         conditional
// 10 mousetrap  keypress actions - PreConfiguredListPanel
// 9 vc          calculations - actionfunctions
// 8 component   watchVideo
// 7 vc          variable from other source

},{}],413:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var CloudflowObject = require("../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
var DatabaseConnection = require("../../cloudflow/Table/js/DatabaseConnection.js");
var WhitepaperConnection = require("../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js");
var FileConnection = require("../../cloudflow/CloudflowUtil/js/FileConnection.js");
var Storage = require("../../cloudflow/CloudflowUtil/js/ContextStorage.js");
var kArrayURIsyntacs = new RegExp("^[^\\]]*\\[[0-9]+\\]$");
var _loadData = function _loadData(pCollectionName, pID) {
  // parameters will be checked by the DatabaseCollection object
  return new Promise(function (pResolve, pReject) {
    if (typeof pID === "string") {
      DatabaseConnection.get(pCollectionName, pID, pResolve, function (pError) {
        console.error(pError);
        pReject(pError);
      });
    } else if (Array.isArray(pID)) {
      DatabaseConnection.list_with_options(pCollectionName, pID, [], [], {
        first: 0,
        maximum: 1
      }, function (pResults) {
        if (pResults !== undefined && Array.isArray(pResults.results)) {
          if (pResults.results.length <= 0) {
            console.error("no results found");
            pReject({
              "error": "no results found",
              "error_code": "no_results_found"
            });
          } else {
            pResolve(pResults.results[0]);
          }
        } else {
          console.error("wrong returning interface");
          pReject({
            "error_code": "wrong_return_interface",
            "error": "wrong returning interface"
          });
        }
      }, function (pError) {
        console.error(pError);
        pReject(pError);
      });
    } else {
      pReject({
        "error_code": "wrong_id_interface",
        "error": "wrong id interface"
      });
    }
  });
};

/**
 * @constructor Context
 * @description Get a specific context specified by the parameters pContext and pContextKey.
 * The target is to get an javascript object containing usfull information. 
 * @param {String} pConnector Specifies which group of collection we must use.
 * @param {String} pCollection The key specifing the collection, database or the group/kind.
 * @param {String} pKey Which object must we take. This represents in most cases the _id of the collection
 * @return {Context.Context}
 */
var Context = function Context(pConnector, pCollection, pKey, pUseCache, pCache) {
  this.data = null; // set on null indicates that data is not yet loaded or failed to loaded
  this.debug = null;
  if (pConnector === "whitepaper" && typeof pKey === "string" && pKey.length > 11 && pKey.indexOf("workableid_") === 0) {
    var workableid = pKey.substring(11 /* length of "workableid_" */);
    this.setConnector(pConnector);
    this.setCollection(pCollection);
    this.setKey({
      "inputname": "dummyname",
      "variables": {}
    });
    this.currentWhitepaperConnections = [];
    this.fileConnections = [];
    this.error;
    this.setUseCache(true);
    this.setCache({
      "workable_id": workableid
    });
  } else {
    this.setConnector(pConnector);
    this.setCollection(pCollection);
    this.setKey(pKey);
    this.currentWhitepaperConnections = [];
    this.fileConnections = [];
    this.error;
    this.setUseCache(pUseCache);
    this.setCache(pCache);
  }
};
Context.fromJSON = function (pJSON) {
  if (pJSON === null || pJSON === undefined) {
    return new Context();
  } else {
    return new Context(pJSON.connector, pJSON.collection, pJSON.key, pJSON.useCache, pJSON.cache);
  }
};

/**
 * @description Get the context form the url parameters
 * @function
 * @param {Object} pContextJSONIfNothingDefined context used if nothing is defined
 * @static
 * @returns Context
 */
Context.fromURL = function (pContextJSONIfNothingDefined) {
  var urlParameters = {};
  if (window.URI !== undefined) {
    var url = new URI();
    urlParameters = url.query(true);
    // convert old arrays into new ones
    for (var parameter in urlParameters) {
      if (kArrayURIsyntacs.test(parameter) === true) {
        var names = parameter.split("[");
        var arrayName = names[0];
        var arrayIndex = names[1].slice(0, -1);
        if (urlParameters[arrayName] === undefined) {
          urlParameters[arrayName] = [];
        }
        urlParameters[arrayName][arrayIndex] = urlParameters[parameter];
        delete urlParameters[parameter];
      }
    }
  } else if (window.$ !== undefined && typeof $.url === "function") {
    // fallback for backward compatible old base urls who has modern custom page components
    urlParameters = $.url().param();
  } else {
    throw new Error("Context.fromURL could not parse url");
  }
  if (urlParameters.collection === null || urlParameters.collection === "null" || urlParameters.collection === undefined || urlParameters.collection === "undefined") {
    return Context.fromJSON(pContextJSONIfNothingDefined);
  }
  if (["object", "whitepaper", "startFromDBIO", "httpservice"].includes(urlParameters.connector)) {
    var key;
    if (typeof urlParameters.id === "string" && urlParameters.id.length > 0) {
      // is data save localy?
      if (urlParameters.id.length > 11 && urlParameters.id.indexOf("workableid_") === 0) {
        var workableid = urlParameters.id.substring(11 /* length of "workableid_" */);
        return new Context(urlParameters.connector, urlParameters.collection, {
          "inputname": "dummyname",
          "variables": {}
        }, true, {
          "workable_id": workableid
        });
      } else if (urlParameters.id.indexOf("localstorage_") === 0) {
        key = Storage.read(urlParameters.id.substring(13 /* length of "localstorage_" */));
        // if not found, key will be undefined
        if (key === undefined) {
          key = {}; // fall back
          console.error("could not retrieve information from localstorage with key " + urlParameters.id);
        }
      } else {
        // data is passed by url itself
        key = JSON.parse(urlParameters.id);
      }
    } else if (urlParameters.id && _typeof(urlParameters.id) === "object" && !Array.isArray(urlParameters.id)) {
      key = urlParameters.id;
    }
    return new Context(urlParameters.connector, urlParameters.collection, key);
  } else {
    return new Context(urlParameters.connector, urlParameters.collection, urlParameters.id);
  }
};
Context.fromCloudflowConnection = function (pConnectionOptions, pOptions) {
  var connector, collection, key;
  var cloudflowConnection;
  var dotIndex = pConnectionOptions.collection.indexOf(".");
  if (dotIndex === -1) {
    cloudflowConnection = pConnectionOptions.collection;
  } else {
    cloudflowConnection = pConnectionOptions.collection.substring(0, dotIndex);
  }
  switch (cloudflowConnection) {
    case "object":
      connector = "object";
      collection = "dummy";
      if (Array.isArray(pConnectionOptions.data)) {
        key = pConnectionOptions.data[0];
      } else {
        key = null;
      }
      break;
    case "file":
      connector = "file";
      collection = pConnectionOptions.dataFileURL;
      key = ["_id", "equal to", ""];
      break;
    case "nucleus":
    case "dataconnector":
      connector = cloudflowConnection;
      collection = pConnectionOptions.collection.substring(dotIndex + 1);
      key = "";
      break;
    case "whitepaperHTTPService":
      connector = "httpservice";
      collection = pConnectionOptions.httpserviceWhitepaperName;
      key = {
        inputname: pConnectionOptions.httpserviceInputName,
        variables: {}
      };
      break;
    case "whitepaperCRUD":
      connector = "startFromDBIO";
      var rest = pConnectionOptions.collection.substring(dotIndex + 1);
      var slashIndex = rest.indexOf("/");
      collection = rest.substring(0, slashIndex);
      key = {
        inputname: rest.substring(slashIndex + 1)
      };
      break;
    case "resource":
      connector = "resource";
      collection = pConnectionOptions.collection.substring(dotIndex + 1);
      key = "";
      break;
    case "assetmetadata":
      connector = "assetmetadata";
      collection = pConnectionOptions.collection.substring(dotIndex + 1);
      key = "";
      break;
    default:
      connector = "nucleus";
      collection = pConnectionOptions.collection;
      key = "";
  }
  return new Context(connector, collection, key);
};

/**
 * @description function to save data to the local storage to be able to retrieve later on.
 * @funtion
 * @name Context.saveDatatoPass
 * @param {pObject} pObject
 * @return {String} The key, needed to retrieve the data, or null if there is no support or we could not save it
 */
Context.saveDataToPass = function (pObject) {
  if (Storage.isSupport() === false) {
    return null;
  }
  return Storage.write(pObject);
};
Context.prototype = {
  constructor: Context,
  getConnector: function getConnector() {
    return this.connector;
  },
  setConnector: function setConnector(pConnector) {
    if (pConnector === undefined || pConnector === null) {
      this.connector = null;
    } else if (typeof pConnector === "string") {
      this.connector = pConnector;
    } else {
      throw new Error("Context.setConnector parameter connector must be a string");
    }
  },
  getCollection: function getCollection() {
    return this.collection;
  },
  setCollection: function setCollection(pCollection) {
    this.collection = pCollection;
    if (typeof pCollection === "string" && pCollection.length > 0 && this.connector === null) {
      // if there is a specific collection and the connector is missing, set to default nucleus.
      this.connector = "nucleus";
    }
  },
  isInitiateAsEmpty: function isInitiateAsEmpty() {
    return this.collection === undefined || this.collection === null;
  },
  getKey: function getKey() {
    return this.key;
  },
  setKey: function setKey(pKey) {
    if (this.getConnector() === "object") {
      if (pKey === undefined || pKey === null) {
        // fallback for wrong inputs
        this.key = {};
      } else if (_typeof(pKey) !== "object" || Array.isArray(pKey)) {
        throw new Error("Context.setKey the key must be an object if the collection is set to object");
      }
      this.key = Object.assign({}, pKey);
    } else if (this.getConnector() === "whitepaper" || this.getConnector() === "httpservice") {
      if (!pKey || _typeof(pKey) !== "object" || Array.isArray(pKey)) {
        throw new Error("Context.setKey the key must be an object if the collection is set to " + this.getConnector());
      }
      if (typeof pKey.inputname !== "string" || pKey.inputname.length <= 0) {
        throw new Error("Context.setKey the key must contain a key inputname");
      }
      if (!pKey.variables || _typeof(pKey.variables) !== "object" || Array.isArray(pKey.variables)) {
        throw new Error("Context.setKey the key must contain a key variables");
      }
      this.key = Object.assign({}, pKey);
    } else if (this.getConnector() === "startFromDBIO") {
      if (!pKey || _typeof(pKey) !== "object" || Array.isArray(pKey)) {
        throw new Error("Context.setKey the key must be an object if the collection is set to " + this.getConnector());
      }
      if (typeof pKey.inputname !== "string" || pKey.inputname.length <= 0) {
        throw new Error("Context.setKey the key must contain a key inputname");
      }
      this.key = Object.assign({}, pKey);
    } else if (Array.isArray(pKey)) {
      this.key = pKey.slice(); // copy
    } else {
      this.key = pKey;
    }
  },
  /**
   * @description will it take a lot of time to retrieve data from this specific context?
   * @function
   * @name context.canTakeTime
   * @return {Boolean} true if the context will take a lot of time to retrieve the data, false otherwise
   */
  canTakeTime: function canTakeTime() {
    return this.connector === "whitepaper" || this.connector === "startFromDBIO";
  },
  /**
   * @description Load the data that corresponds to the context.
   * @function
   * @name Context#loadData
   * @return {Object} This return the requested data in form of a js plain object or a jQuery Deffered object
   */
  loadData: function loadData(pOptions, pProgessCB) {
    var that = this;
    if (this.isInitiateAsEmpty()) {
      this.data = {};
      return Promise.resolve(this.data);
    }
    if (this.connector === "object" && this.key !== null && _typeof(this.key) === "object" && !Array.isArray(this.key)) {
      this.data = Object.assign({}, this.key);
      return Promise.resolve(this.data);
    }
    if (this.connector === "whitepaper") {
      var connection = new WhitepaperConnection(this.collection, this.key.inputname, this.key.variables);
      if (pOptions && typeof pOptions.startPollingTime === "number") {
        connection.setStartPollingTime(pOptions.startPollingTime);
      }
      connection.onprogress = function (pEvent, pProgressData) {
        // check if there are actions requests
        if (pProgressData && typeof pProgressData.action === "string") {
          that._executeActionFromWhitepaper(pProgressData, pOptions);
          if (pOptions && pOptions.suppressRedirect === true && pProgressData.defer !== undefined) {
            // end the defer because we want not redirect
            pProgressData.defer.resolve({});
          }
        }
        if (typeof pProgessCB === "function") {
          pProgessCB(pEvent, pProgressData);
        }
      };
      this.currentWhitepaperConnections.push(connection);
      return Promise.resolve(connection.start()).then(function (pResult) {
        that.data = pResult;
        if (that.mayUseCache() === true && connection.getWorkableID() !== null) {
          that.setCache({
            workable_id: connection.getWorkableID()
          });
        }
        return that.data;
      })["catch"](function (pError) {
        that.data = null;
        return Promise.reject(pError);
      })["finally"](function () {
        var debugData = {
          debug_type: "workflow",
          whitepaperName: that.collection,
          whitepaperInputName: that.key.inputname
        };
        if (connection.getWorkableID() !== null) {
          debugData.workableID = connection.getWorkableID();
          debugData.jacketID = connection.getJacketID();
        }
        that.setDebugData(debugData);
      });
    }
    if (this.connector === "httpservice") {
      var connection = new WhitepaperConnection(this.collection, this.key.inputname, this.key.variables);
      return connection.httpService().then(function (pResult) {
        if (pResult && typeof pResult.error === "string" && typeof pResult.error_code === "string") {
          that.data = null;
          console.error(pResult);
          return Promise.reject(pResult);
        }
        that.data = pResult;
        return that.data;
      }, function (pError) {
        that.data = null;
        return Promise.reject(pError);
      })["finally"](function () {
        var debugData = {
          debug_type: "workflow",
          whitepaperName: that.collection,
          whitepaperInputName: that.key.inputname
        };
        if (connection.getWorkableID() !== null) {
          debugData.workableID = connection.getWorkableID();
          debugData.jacketID = connection.getJacketID();
        }
        that.setDebugData(debugData);
      });
    }
    if (this.connector === "startFromDBIO") {
      var connection;
      if (typeof this.key.variables === "string" && this.key.variables.length > 0 || typeof this.key.variables === "number") {
        connection = new WhitepaperConnection(this.collection, this.key.inputname, [this.key.variables], {
          connectionType: "database_proxy",
          connectionFunctionName: "get",
          connectionCallOptions: {}
        });
      } else if (Array.isArray(this.key.variables) && this.key.variables.length > 0) {
        connection = new WhitepaperConnection(this.collection, this.key.inputname, [this.key.variables, [], []], {
          connectionType: "database_proxy",
          connectionFunctionName: "list",
          connectionCallOptions: {
            first: 0,
            maximum: 1
          }
        });
      } else {
        that.data = null;
        throw new Error("invalid key for Start From DBIO");
      }
      if (pOptions && typeof pOptions.startPollingTime === "number") {
        connection.setStartPollingTime(pOptions.startPollingTime);
      }
      this.currentWhitepaperConnections.push(connection);
      return Promise.resolve(connection.start()).then(function (pResult) {
        if (pResult !== undefined && pResult.document !== undefined) {
          that.data = pResult.document; // get 
        } else if (pResult !== undefined && Array.isArray(pResult.documents)) {
          if (pResult.documents.length > 0) {
            that.data = pResult.documents[0]; // list
          } else {
            // empty documents
            that.data = null;
            return Promise.reject({
              "error_code": "empty_results_startfromdbio",
              "error": "No items found in Start from DBIO"
            });
          }
        } else {
          that.data = null;
          return Promise.reject({
            "error_code": "wrong_interface_startfromdbio",
            "error": "wrong returning interface of Start from DBIO"
          });
        }
        // in case of good results
        if (that.mayUseCache() === true && connection.getWorkableID() !== null) {
          that.setCache({
            workable_id: connection.getWorkableID()
          });
        }
        return that.data;
      }, function (pError) {
        that.data = null;
        return Promise.reject(pError);
      })["finally"](function () {
        var debugData = {
          debug_type: "workflow",
          whitepaperName: that.collection,
          whitepaperInputName: that.key.inputname
        };
        if (connection.getWorkableID() !== null) {
          debugData.workableID = connection.getWorkableID();
          debugData.jacketID = connection.getJacketID();
        }
        that.setDebugData(debugData);
      });
    }
    if (this.connector === "file") {
      var relativeBasePath = "";
      if (pOptions && typeof pOptions.relativeBasePath === "string") {
        relativeBasePath = pOptions.relativeBasePath;
      }
      var connection = new FileConnection(this.collection, relativeBasePath, "json");
      this.fileConnections.push(connection);
      return connection.load().then(function () {
        if (Array.isArray(that.key) && that.key.length > 0) {
          return new Promise(function (pResolve, pReject) {
            connection.list_with_options(that.key, [], [], {
              first: 0,
              maximum: 1
            }, function (pResults) {
              if (pResults && Array.isArray(pResults.results) && pResults.results.length > 0) {
                that.data = pResults.results[0];
                pResolve(that.data);
              } else {
                that.data = null;
                pReject({
                  "error": "no results found",
                  "error_code": "no_results_found"
                });
              }
            }, pReject);
          });
        } else {
          that.data = connection.getDataObject();
          return that.data;
        }
      }, function () {
        that.setError(connection.getError());
        that.data = null;
      });
    }
    if (typeof this.collection === "string" && this.collection.length > 0) {
      return _loadData(this.connector + "." + this.collection, this.key).then(function (pResult) {
        that.data = pResult;
        return that.data;
      })["catch"](function (pError) {
        that.data = null;
        return Promise.reject(pError);
      });
    } else {
      throw new Error("Context.loadData: invalid collection and key for context");
    }
  },
  loadDataFromCache: function loadDataFromCache(pOptions, pProgessCB) {
    if (this.mayUseCache() === true && this.hasCache() === true && this.connector === "whitepaper" && typeof this.cache.workable_id === "string" && this.cache.workable_id.length > 0) {
      var that = this;
      var connection = new WhitepaperConnection(this.collection, this.key.inputname, this.key.variables);
      connection.onprogress = function (pEvent, pProgressData) {
        // check if there are actions requests
        if (pProgressData !== undefined && typeof pProgressData.action === "string") {
          that._executeActionFromWhitepaper(pProgressData, pOptions);
          if (pOptions !== undefined && pOptions.suppressRedirect === true && pProgressData.defer !== undefined) {
            // end the defer because we want not redirect
            pProgressData.defer.resolve({});
          }
        }
        if (typeof pProgessCB === "function") {
          pProgessCB(pEvent, pProgressData);
        }
      };
      return connection.catchup({
        workable_id: this.cache.workable_id
      }).then(function (pResult) {
        that.data = pResult;
        return that.data;
      }, function (pError) {
        if (pError !== undefined && pError.error_code === "Workable does not exist") {
          // the workable or jacket does not exist anymore, 
          // preventing by removing cache
          that.clearCache();
          console.warn("workable not found, cache cleared");
        } else {
          console.error(pError);
        }
        // if fails try to redo ...
        return that.loadData(pOptions, pProgessCB);
      });
    }
    // no cache found or possible, redo complete ...
    return this.loadData(pOptions, pProgessCB);
  },
  /**
   * @description Sometimes the backend is asking for a specific action
   * @function
   * @private
   * @name Context#_executeActionFromWhitepaper
   * @return {undefined}
   */
  _executeActionFromWhitepaper: function _executeActionFromWhitepaper(pAction, pCallOptions) {
    if (pAction !== undefined) {
      // action redirection
      if (pAction.action === "redirect") {
        // if not suppressed and url is not empty
        if ((pCallOptions === undefined || pCallOptions.suppressRedirect !== true) && typeof pAction.url === "string" && pAction.url.length > 0) {
          if (pAction.url.indexOf("cloudflow://") === 0) {
            // translate cloudflow paths
            this._getWindowLocation().replace("/portal.cgi/" + pAction.url.slice(12));
          } else {
            this._getWindowLocation().replace(pAction.url);
          }
        }
      }
    }
  },
  _getWindowLocation: function _getWindowLocation() {
    return window.location; // put in different function to be able to overwrite this function for tests
  },

  /**
   * @description Load the data and returns the context object itself
   * @function
   * @private
   * @name Context#loadDataAndReturnsMe
   * @return {Deferred}
   */
  loadDataAndReturnsMe: function loadDataAndReturnsMe(pOptions, pProgessCB) {
    var that = this;
    var defData;
    var options = {};
    if (pOptions === true) {
      // backwards compatibility
      options.use_cache = true;
    } else if (_typeof(pOptions) === "object") {
      options = Object.assign(options, pOptions);
    }
    if (options.use_cache === true) {
      defData = this.loadDataFromCache({}, pProgessCB);
    } else {
      defData = this.loadData({}, pProgessCB);
    }
    return defData.then(function () {
      return that;
    }, function (pError) {
      that.setError(pError);
      return Promise.reject(pError);
    });
  },
  /**
   * @description Abort all current calls that loads the data
   * @function
   * @name Context#stopLoadingData
   * @returns {undefined}
   */
  stopLoadingData: function stopLoadingData() {
    if (Array.isArray(this.currentWhitepaperConnections) === true) {
      for (var i = 0; i < this.currentWhitepaperConnections.length; i++) {
        if (this.currentWhitepaperConnections[i].hasLongLive() === true) {
          continue;
        }
        this.currentWhitepaperConnections[i].stop();
      }
    }
    if (Array.isArray(this.fileConnections) === true) {
      for (var i = 0; i < this.fileConnections.length; i++) {
        this.fileConnections[i].stop();
      }
    }
  },
  /**
   * @description Did the context has some data?
   * @function
   * @name Context#hasData
   * @return {Boolean} true if the data has been loaded correctly of false if the data is not yet loaded or of the call to get has failed
   */
  hasData: function hasData() {
    return this.data !== null;
  },
  /**
   * @description Get all the data that corresponds to the context. 
   * @function
   * @name Context#getData
   * @return {Object} An object containing all the requested information. This can be null if data is not yet loaded or an error occured during the request of the data.
   */
  getData: function getData(pPath) {
    if (pPath === undefined || this.data === null) {
      return this.data;
    } else if (typeof pPath === "string" && pPath.length > 0) {
      return CloudflowObject.getParameter(this.data, pPath);
    } else {
      throw new Error("Context.getData invalid interface of parameter");
    }
  },
  setData: function setData(pKey, pValue) {
    if (typeof pKey !== "string") {
      throw new Error("Context.setData parameter pKey must be a string");
    }
    if (this.hasData() === false) {
      this.data = {};
    }
    if (pKey === "") {
      Object.assign(this.data, pValue);
    } else {
      this.data = CloudflowObject.setParameter(this.data, pKey, pValue);
    }
  },
  /**
   * @description Add variable to a url to define a context, so the rendered page can retrieve thiose parameters
   * @function
   * @name Context#addToUrl
   * @param {String} pUrl the url to add and change
   * @param {String} pID (optional) the id to use 
   * @return {String} the url with variable to define a context
   */
  addToUrl: function addToUrl(pUrl, pID) {
    if (typeof pUrl !== "string") {
      throw new Error("Context.addToUrl parameter url must be a string");
    }
    if (this.isInitiateAsEmpty()) {
      return pUrl;
    }
    var id;
    if (pID === undefined) {
      var key = this.getKey();
      if (key && _typeof(key) === "object" && !Array.isArray(key)) {
        id = "&id=" + encodeURIComponent(JSON.stringify(key));
      } else if (Array.isArray(key) && key.length > 0) {
        // todo
        id = "";
        for (var i = 0; i < key.length; i++) {
          id += "&id[" + i + "]=" + encodeURIComponent(key[i]);
        }
      } else {
        id = "&id=" + encodeURIComponent(key);
      }
    } else if (Array.isArray(pID) && pID.length > 0) {
      id = "";
      for (var i = 0; i < pID.length; i++) {
        id += "&id[" + i + "]=" + pID[i];
      }
    } else {
      id = "&id=" + pID;
    }
    var addedURLParameters = "connector=" + encodeURIComponent(this.getConnector()) + "&collection=" + encodeURIComponent(this.getCollection()) + id;
    var startParametersIndex = pUrl.indexOf("?");
    var hashtagIndex = pUrl.indexOf("#");
    if (startParametersIndex >= 0) {
      if (hashtagIndex > 0 && hashtagIndex < startParametersIndex) {
        // there is a hashTag # before the ?
        throw new Error("conflict: parameter url may not contain a '#' before the '?'.");
      }
      // there are alread existing parameters, try to add 
      var endPart = pUrl.slice(startParametersIndex + 1);
      if (endPart.indexOf("id=") >= 0 || endPart.indexOf("collection=") >= 0 || endPart.indexOf("connector=") >= 0) {
        throw new Error("conflict: parameter url already contains a 'id' or a 'collection' as parameter.");
      }
      if (endPart === "") {
        // "?" is last character
        pUrl = pUrl + addedURLParameters;
      } else if (hashtagIndex > startParametersIndex) {
        // a hashtag after the parameters chain
        pUrl = pUrl.substring(0, hashtagIndex) + "&" + addedURLParameters + pUrl.slice(hashtagIndex);
      } else {
        // no hashtag found
        pUrl = pUrl + "&" + addedURLParameters; // add parameters to the end of the parameters chain
      }
    } else if (hashtagIndex > 0) {
      // there is a hashtag but no parameters, add hashtag and componay at the end
      pUrl = pUrl.substring(0, hashtagIndex) + "?" + addedURLParameters + pUrl.slice(hashtagIndex);
    } else {
      // there are no existing parameters, 
      pUrl = pUrl + "?" + addedURLParameters;
    }
    return pUrl;
  },
  makeContextIdentifier: function makeContextIdentifier() {
    if (this.getKey() !== null && _typeof(this.getKey()) === "object") {
      // include arrays
      return this.getConnector() + ":" + this.getCollection() + ":" + JSON.stringify(this.getKey());
    } else {
      return this.getConnector() + ":" + this.getCollection() + ":" + this.getKey();
    }
  },
  setError: function setError(pError) {
    this.error = pError;
  },
  getError: function getError() {
    return this.error;
  },
  setUseCache: function setUseCache(pUseCache) {
    // only check on true or something else
    this.useCache = pUseCache;
  },
  mayUseCache: function mayUseCache() {
    return this.useCache === true;
  },
  hasCache: function hasCache() {
    return this.cache !== undefined;
  },
  setCache: function setCache(pCache) {
    if (pCache && _typeof(pCache) === "object" && !Array.isArray(pCache)) {
      this.cache = pCache;
    } else {
      this.cache = undefined;
    }
  },
  getCache: function getCache() {
    return this.cache;
  },
  clearCache: function clearCache() {
    this.cache = undefined;
  },
  setDebugData: function setDebugData(pDebug) {
    if (pDebug && _typeof(pDebug) === "object" && !Array.isArray(pDebug)) {
      this.debug = Object.assign({}, pDebug);
    } else {
      this.debug = undefined;
    }
  },
  getDebugData: function getDebugData() {
    return this.debug;
  },
  isEqual: function isEqual(pContext) {
    // make to compare a valid context element
    var contextToCompare;
    if (pContext instanceof Context) {
      contextToCompare = pContext;
    } else if (pContext && _typeof(pContext) === "object" && !Array.isArray(pContext)) {
      contextToCompare = Context.fromJSON(pContext);
    } else {
      return false;
    }
    // both can differ from collection but is isInitateAsEmpty is true on both
    // return there are the same
    if (this.isInitiateAsEmpty() === true && this.isInitiateAsEmpty() === contextToCompare.isInitiateAsEmpty()) {
      return true;
    }
    // check first "Connector"
    if (this.getConnector() !== contextToCompare.getConnector()) {
      return false;
    }
    // "objects" van have different collections and are only defined by key
    if (this.getConnector() === "object") {
      return _.isEqual(this.getKey(), contextToCompare.getKey());
    } else if (this.getCollection() !== contextToCompare.getCollection()) {
      // check collections
      return false;
    }
    // check keys
    return _.isEqual(this.getKey(), contextToCompare.getKey());
  },
  toJSON: function toJSON() {
    var key = this.getKey();
    if (key === undefined) {
      key = null; // prevent undefined in JSON
    } else if (Array.isArray(key)) {
      key = key.slice(); // make copy 
    } else if (key && _typeof(key) === "object") {
      key = Object.assign({}, key); // make copy 
    }

    var output = {
      connector: this.connector,
      collection: this.getCollection() === undefined ? null : this.getCollection(),
      key: key
    };
    if (this.hasCache() === true) {
      output.cache = Object.assign({}, this.cache);
    }
    if (this.mayUseCache() === true) {
      output.useCache = true;
    }
    return output;
  },
  /**
   * @description Clone the context object
   * @function
   * @name context.clone
   * @param {Boolean} pCloneData Must we also copy the internal data?
   */
  clone: function clone(pCloneData) {
    var newContext = Context.fromJSON(this.toJSON());
    if (pCloneData === true && this.hasData()) {
      var data = this.getData();
      if (data && _typeof(data) === "object" && !Array.isArray(data)) {
        newContext.data = Object.assign({}, data);
      }
    }
    return newContext;
  }
};
module.exports = Context;

},{"../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79,"../../cloudflow/CloudflowUtil/js/ContextStorage.js":82,"../../cloudflow/CloudflowUtil/js/FileConnection.js":86,"../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js":93,"../../cloudflow/Table/js/DatabaseConnection.js":209}],414:[function(require,module,exports){
"use strict";

/* 
 * @author Guillaume 29 sep 2020
 */

/**
 * @constructor DoneQueue
 * @description A Class that handles queue and inform you when every "thing" is done
 * @param {Object} options 
 * @version 0.9.0
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var DoneQueue = function DoneQueue(options) {
  this._waitingDone = 0;
  this._askedDone = 0;
  this._allDoneCB = [];
  this._componentIndentifiers = [];
};
DoneQueue.fromJSON = function (pJSON) {
  return new DoneQueue(pJSON);
};
DoneQueue.prototype = {
  constructor: DoneQueue,
  _init: function _init() {
    /*this._tracer = Tracer.get();
    this._tracer.addType('mark', 'com.nixps.pagebuilder.page.loadingtime', 'loading time to display the page according to CLOUDFLOW specs', {
        my: 'precious',
        url: 'cloudflow://PP_MY_STORE/brol/asset.pdf'
    });
    
    this._logger = new TraceToCloudflowLog(this._tracer, ['com.nixps.pagebuilder.page.loadingtime'], 5000);
    this._logger.start();*/
  },
  generateDoneCallBack: function generateDoneCallBack(pComponentIdentifier) {
    var that = this;
    var _doneCallBack = function doneCallBack() {
      //console.log("end ", pComponentIdentifier);
      that._waitingDone--;
      if (that._waitingDone <= 0) {
        that._allDone();
      }
      _doneCallBack = function doneCallBack() {};
    };
    this._componentIndentifiers.push(pComponentIdentifier);
    //console.log("start ", pComponentIdentifier);
    this._waitingDone++;
    this._askedDone++;
    return _doneCallBack;
  },
  _allDone: function _allDone() {
    for (var i = 0; i < this._allDoneCB.length; i++) {
      try {
        this._allDoneCB[i]();
      } catch (e) {
        console.error(e);
      }
    }
    this._allDoneCB = [];
  },
  informAllDone: function informAllDone(pDoneCallBack) {
    if (typeof pDoneCallBack !== "function") {
      throw new Error("informAllDone: parameter must be a function");
    }
    if (this._waitingDone <= 0) {
      pDoneCallBack();
    } else {
      this._allDoneCB.push(pDoneCallBack);
    }
  },
  getAmountAskedDone: function getAmountAskedDone() {
    return this._askedDone;
  },
  clone: function clone() {
    return DoneQueue.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    return {};
  }
};
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
  module.exports = DoneQueue;
}
if (window.nixps === undefined) {
  window.nixps = {};
}
if (nixps.cloudflow === undefined) {
  nixps.cloudflow = {};
}
nixps.cloudflow.DoneQueue = DoneQueue;

},{}],415:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// requires
var CloudflowObject = require("../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
var StrftimeFormat = require("../../3rdParty/strftime.js");
var FileSizeUtils = require("../../cloudflow/CloudflowUtil/js/FileSizeUtils.js");
var MyFunction = require("../../common/MyFunction/js/MyFunction.js");
var QueryApplier = require("../../cloudflow/CloudflowUtil/js/QueryApplier.js");
var Device = require("../../cloudflow/PWA/js/Device.js");
var translatedLanguages = require("../../cloudflow/TranslatedLanguagesSelector/js/translatedLanguages.js");

//var RegisteredUnits = require("../../cloudflow/Units/js/RegisteredUnits.js");

// hulp functions
function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
/**
 * @constructor ExpressionToJS
 * @description Util class for calculation value composers in a browser context
 * @param {Object} pVariableHandler. This must be an object or an object containing a getParameter function
 * @param {Object<User>} pUser
 * @param {Object<UserPreferences>} pUserPreferences
 */
function ExpressionToJS(pVariableHandler, pUser, pUserPreferences) {
  this.variableHandler;
  if (pVariableHandler && typeof pVariableHandler.getData === "function") {
    this.variableHandler = pVariableHandler;
  } else if (pVariableHandler && _typeof(pVariableHandler) === "object" && Object.getPrototypeOf(pVariableHandler) === Object.prototype) {
    // create temp small object 
    this.variableHandler = {
      variabledict: pVariableHandler,
      getData: function getData(pPath) {
        return CloudflowObject.getParameter(this.variabledict, pPath);
      },
      setData: function setData(pKey, pValue) {
        if (pKey === "") {
          Object.assign(this.variabledict, pValue);
        } else {
          this.variabledict = CloudflowObject.setParameter(this.variabledict, pKey, pValue);
        }
      }
    };
  } else {
    console.error("parameter pVariableHandler is missing or has wrong interface");
  }
  this.user = pUser;
  this.user_preferences = pUserPreferences;
}
;
ExpressionToJS.prototype = {
  constructor: ExpressionToJS,
  getVariables: function getVariables() {
    return this.variableHandler.variabledict;
  },
  mergeToVariables: function mergeToVariables(pObject) {
    if (pObject == null || _typeof(pObject) !== "object" || Object.getPrototypeOf(pObject) !== Object.prototype) {
      throw new Error("Value Composer: mergeToVariables: parameter pObject must be an object");
    }
    if (this.variableHandler !== undefined) {
      if (!this.variableHandler.variabledict || _typeof(this.variableHandler.variabledict) !== "object" || Object.getPrototypeOf(this.variableHandler.variabledict) !== Object.prototype) {
        this.variableHandler.variabledict = {};
      }
      this.variableHandler.variabledict = CloudflowObject.merge([this.variableHandler.variabledict, pObject]);
    }
  },
  addToVariabels: function addToVariabels(pKey, pValue) {
    if (typeof pKey !== "string") {
      throw new Error("Value Composer: addToVariables: parameter pKey must be a string");
    }
    if (this.variableHandler !== undefined) {
      var value;
      if (pValue && _typeof(pValue) == "object" && Object.getPrototypeOf(pValue) === Object.prototype) {
        value = CloudflowObject.merge([{}, pValue]);
      } else if (Array.isArray(pValue)) {
        value = CloudflowObject.merge([[], pValue]);
      } else {
        value = pValue;
      }
      this.variableHandler.setData(pKey, value);
    }
    return pValue;
  },
  _transferToVariableHandler: function _transferToVariableHandler(pVariableHandler) {
    if (pVariableHandler && typeof pVariableHandler.getData === "function") {
      return pVariableHandler;
    } else if (pVariableHandler && _typeof(pVariableHandler) === "object" || Array.isArray(pVariableHandler)) {
      return {
        variabledict: pVariableHandler,
        getData: function getData(pPath) {
          return CloudflowObject.getParameter(this.variabledict, pPath);
        },
        setData: function setData(pKey, pValue) {
          if (pKey === "") {
            Object.assign(this.variabledict, pValue);
          } else {
            this.variabledict = CloudflowObject.setParameter(this.variabledict, pKey, pValue);
          }
        }
      };
    }
  },
  /**
   * @description extract an object with value composers to an object with is applied and and an extraction of the value composer
   * @name ExpressionToJS#applyOnObject
   * @function
   * @example applyOnObject({}, errorCB);
   * @example applyOnObject({}, {a:true}, errorCB);
   * @param {Object} pObject
   * @return {Object}
   */
  applyOnObject: function applyOnObject(pObject, pScopedVariables, pErrorCallBack, pWarningCB) {
    var scopedVariables;
    if (pScopedVariables && _typeof(pScopedVariables) === "object" && Object.keys(pScopedVariables).length > 0) {
      scopedVariables = pScopedVariables;
    }
    var errorCB = function errorCB() {};
    if (typeof pScopedVariables === "function" && pErrorCallBack === undefined) {
      errorCB = pScopedVariables;
    } else if (typeof pErrorCallBack === "function") {
      errorCB = pErrorCallBack;
    }
    if (scopedVariables === undefined) {
      return this.applyOnObjectCallBack(pObject, this.applyToValue.bind(this), errorCB);
    } else {
      var that = this;
      return this.applyOnObjectCallBack(pObject, function () {
        var arg = [];
        arg[0] = arguments[0];
        arg[1] = arguments.length > 1 ? arguments[1] : undefined;
        arg[2] = scopedVariables;
        arg[3] = pWarningCB;
        return that.applyToValue.apply(that, arg);
      }, errorCB);
    }
  },
  /**
   * @description extract an object with value composers to an object with is applied and and an extraction of the value composer
   * @name ExpressionToJS#applyOnObjectCallBack
   * @function
   * @private
   * @param {Object} pObject
   * @return {Object}
   */
  applyOnObjectCallBack: function applyOnObjectCallBack(pObject, pCallBack, pErrorCallBack) {
    var translated_object;
    var expressions = [];
    if (Array.isArray(pObject)) {
      translated_object = [];
    } else if (pObject && _typeof(pObject) === "object" && Object.getPrototypeOf(pObject) === Object.prototype) {
      translated_object = {};
    } else {
      console.error("unknown type");
    }
    var that = this;
    for (var key in pObject) {
      var value = pObject[key];
      // normal types
      if (["string", "number", "boolean"].includes(_typeof(value))) {
        translated_object[key] = value;
        // json objects
      } else if (value && _typeof(value) === "object" && !Array.isArray(value) && Object.getPrototypeOf(value) === Object.prototype) {
        if (!value || Object.keys(value).length === 0) {
          translated_object[key] = value;
        } else {
          var result = that.applyOnObjectCallBack(value, pCallBack, pErrorCallBack);
          translated_object[key] = result.translatedObject;
          if (result.expressions.length > 0) {
            for (var i = 0; i < result.expressions.length; i++) {
              expressions.push({
                key: key + "." + result.expressions[i].key,
                value: result.expressions[i].value
              });
            }
          }
        }
        // arrays
      } else if (Array.isArray(value)) {
        if (value.length === 0) {
          translated_object[key] = value;
        } else if (value[0] && typeof value[0].type === "string" && value[0].type.indexOf("com.nixps.") === 0) {
          // candidate for a value composer
          try {
            translated_object[key] = pCallBack(value);
            expressions.push({
              key: key,
              value: value
            });
          } catch (error) {
            console.error(error);
            pErrorCallBack(error.message);
            var result = that.applyOnObjectCallBack(value, pCallBack, pErrorCallBack);
            translated_object[key] = result.translatedObject;
            if (result.expressions.length > 0) {
              for (var i = 0; i < result.expressions.length; i++) {
                expressions.push({
                  key: key + "." + result.expressions[i].key,
                  value: result.expressions[i].value
                });
              }
            }
          }
        } else {
          // normal array
          var result = that.applyOnObjectCallBack(value, pCallBack, pErrorCallBack);
          translated_object[key] = result.translatedObject;
          if (result.expressions.length > 0) {
            for (var i = 0; i < result.expressions.length; i++) {
              expressions.push({
                key: key + "." + result.expressions[i].key,
                value: result.expressions[i].value
              });
            }
          }
        }
        // something else like null, undefined, ...
      } else {
        translated_object[key] = value;
      }
    }
    ;
    return {
      translatedObject: translated_object,
      expressions: expressions
    };
  },
  /**
   * @description translate a valuecomposer to a specific value. Apply the value composer
   * @function
   * @name ExpressionToJS#applyToValue
   * @param {ValueComposer} pValueComposer
   * @param {Object} pExternalApply object to apply value composers outside this one
   * @param {Object | Handler} pScopedVariableHandlers objects living outside the normal scope of the default
   * @param {Function} pWarningCB function to be run when there is a warning
   * @return {Object.prototype.applyToValue.outputValue|String}
   */
  applyToValue: function applyToValue(pValueComposer, pExternalApply, pScopedVariableHandlers, pWarningCB) {
    if (Array.isArray(pValueComposer) === false) {
      throw new Error("Value Composer: input parameter must be an array");
    }
    if (typeof pWarningCB !== "function") {
      pWarningCB = function pWarningCB() {};
    }
    var scopedVariableHandlers = {};
    if (pScopedVariableHandlers !== undefined) {
      for (var pScopeName in pScopedVariableHandlers) {
        scopedVariableHandlers[pScopeName] = this._transferToVariableHandler(pScopedVariableHandlers[pScopeName]);
      }
    }
    var that = this;
    var outputValue;
    for (var i = 0; i < pValueComposer.length; i++) {
      if (pValueComposer[i].type === undefined) {
        if (outputValue === undefined) {
          outputValue = [];
        }
        outputValue.push(this.applyToValue(pValueComposer[i], pExternalApply, pScopedVariableHandlers, pWarningCB));
        continue;
      }
      switch (pValueComposer[i].type) {
        case "com.nixps.quantum.value.0":
          outputValue = this._concatValues(outputValue, pValueComposer[i].value);
          break;
        case "com.nixps.quantum.variable.0":
          if (pValueComposer[i].variable !== null && typeof pValueComposer[i].variable !== "string") {
            throw new Error("Value Composer com.nixps.quantum.variable.0 has an invalid variable: " + pValueComposer[i].variable);
          }
          var value = undefined;
          if (typeof pValueComposer[i].source === "string" && pValueComposer[i].source.length > 0) {
            // get variable from external source, from other scope
            if (scopedVariableHandlers[pValueComposer[i].source] !== undefined) {
              var sourceVariableHandler = scopedVariableHandlers[pValueComposer[i].source];
              value = sourceVariableHandler.getData(pValueComposer[i].variable); // returns undefined if not found
            } else {
              throw new Error("Value Composer com.nixps.quantum.variable.0 could not find source " + pValueComposer[i].source);
            }
          } else if (typeof pValueComposer[i].source_file === "string" && pValueComposer[i].source_file.length > 0) {
            // get variable from external source, from other scope
            if (scopedVariableHandlers[pValueComposer[i].source_file] !== undefined) {
              var sourceVariableHandler = scopedVariableHandlers[pValueComposer[i].source_file];
              value = sourceVariableHandler.getData(pValueComposer[i].variable); // returns undefined if not found
            } else {
              throw new Error("Value Composer com.nixps.quantum.variable.0 could not find source " + pValueComposer[i].source_file);
            }
          } else {
            // default variable from workflow or page
            value = this.variableHandler.getData(pValueComposer[i].variable); // returns undefined if not found
          }

          if (value === undefined && pValueComposer[i].default_value !== undefined) {
            value = pValueComposer[i].default_value; // use default_value if value not found
          }

          outputValue = this._concatValues(outputValue, value);
          break;
        case "com.nixps.pagebuilder.current_user.0":
          if (this.user === undefined || this.user === null) {
            throw new Error("Value Composer: unknown user for com.nixps.pagebuilder.current_user.0");
          }
          var part = undefined;
          if (typeof pValueComposer[i].part === "string") {
            switch (pValueComposer[i].part) {
              case "username":
                part = this.user.getUserName();
                break;
              case "fullname":
                part = this.user.getFullName();
                break;
              case "email":
                part = this.user.getEmail();
                break;
              case "attributes_name":
                part = this.user.getAttributesName();
                break;
              case "active_scope_name":
                part = this.user.getActiveScopeName();
                break;
              default:
                throw new Error("Value Composer: unkown part for com.nixps.pagebuilder.current_user.0");
            }
          } else {
            part = this.user.getUserName();
          }
          outputValue = this._concatValues(outputValue, part);
          break;
        case "com.nixps.quantum.type_converter.0":
          if (pValueComposer[i].to_type === "string") {
            var value = undefined;
            var internalChilds = undefined;
            if (Array.isArray(pValueComposer[i].value)) {
              // is value composer(s)
              if (pValueComposer[i].value.length > 1) {
                // multiple value composers
                internalChilds = [];
                for (var k = 0; k < pValueComposer[i].value.length; k++) {
                  internalChilds.push({
                    "type": "com.nixps.quantum.type_converter.0",
                    "to_type": "string",
                    "value": [pValueComposer[i].value[k]]
                  });
                }
              } else {
                // is one single value composer
                internalChilds = pValueComposer[i].value;
              }
              value = this.applyToValue(internalChilds, pExternalApply, pScopedVariableHandlers, pWarningCB);
            } else {
              // is no value composer
              value = pValueComposer[i].value;
            }
            if (value && _typeof(value) === "object") {
              outputValue = this._concatValues(outputValue, JSON.stringify(value, null, 3));
            } else {
              outputValue = this._concatValues(outputValue, "" + value);
            }
          } else if (pValueComposer[i].to_type === "number") {
            outputValue = this._concatValues(outputValue, parseFloat(this.applyToValue(pValueComposer[i].value, pExternalApply, pScopedVariableHandlers, pWarningCB)));
          } else if (pValueComposer[i].to_type === "boolean") {
            var valueToConvert = this.applyToValue(pValueComposer[i].value, pExternalApply, pScopedVariableHandlers, pWarningCB);
            var convertedValue;
            if (typeof valueToConvert === "boolean") {
              convertedValue = valueToConvert;
            } else if (typeof valueToConvert === "number") {
              convertedValue = !(Math.abs(valueToConvert) < 1.0e-6);
            } else if (typeof valueToConvert === "string") {
              valueToConvert = valueToConvert.toUpperCase();
              if (valueToConvert === "TRUE" || valueToConvert === "YES" || valueToConvert === "1" || valueToConvert === "T") {
                convertedValue = true;
              } else if (valueToConvert === "FALSE" || valueToConvert === "NO" || valueToConvert === "0" || valueToConvert === "N") {
                convertedValue = false;
              } else {
                throw new Error("Value Composer: can not convert " + valueToConvert + " to boolean");
              }
            } else {
              throw new Error("Value Composer: can not convert type to boolean");
            }
            outputValue = this._concatValues(outputValue, convertedValue);
          } else {
            throw new Error("Value Composer: unsupported type_convertion found: " + pValueComposer[i].to_type);
          }
          break;
        case "com.nixps.localization.look_up.0":
          var translationkey = undefined;
          if (typeof pValueComposer[i].translation_key === "string" && pValueComposer[i].translation_key.length > 0) {
            translationkey = pValueComposer[i].translation_key;
          } else if (Array.isArray(pValueComposer[i].translation_key)) {
            translationkey = this.applyToValue(pValueComposer[i].translation_key, pExternalApply, pScopedVariableHandlers, pWarningCB);
          } else {
            throw new Error("Value composer com.nixps.localization.look_up.0 must contain a valid translation_key");
          }
          var translatedString;
          if (Array.isArray(pValueComposer[i].translation_inlinevariables) && pValueComposer[i].translation_inlinevariables.length > 0) {
            translatedString = $.i18n._(translationkey, pValueComposer[i].translation_inlinevariables);
          } else {
            translatedString = $.i18n._(translationkey);
          }
          if (translatedString === translationkey) {
            // there is no translation found
            var warningReturn = pWarningCB({
              "warning_code": "translation_not_found",
              "message": "no translation found",
              "value_composer_type": "com.nixps.localization.look_up.0",
              "value_composer": [Object.assign({}, pValueComposer[i])]
            });
            if (warningReturn !== undefined && typeof warningReturn.new_value === "string" && warningReturn.new_value.length > 0) {
              translatedString = warningReturn.new_value;
            }
          }
          outputValue = this._concatValues(outputValue, translatedString);
          break;
        case "com.nixps.quantum.characters_of.0":
          var value = this.applyToValue(pValueComposer[i].input, pExternalApply, pScopedVariableHandlers, pWarningCB);
          if (typeof value !== "string") {
            throw new Error("Value composer com.nixps.quantum.characters_of.0 only works on string");
          }
          var startIndex;
          if (pValueComposer[i].mode.indexOf("FromSearch+") === 0) {
            if (pValueComposer[i].from_search_string === "") {
              startIndex = pValueComposer[i].from_index;
            } else if (pValueComposer[i].from_index >= 0) {
              startIndex = value.split(pValueComposer[i].from_search_string, pValueComposer[i].from_index + 1).join(pValueComposer[i].from_search_string).length + pValueComposer[i].from_search_string.length;
            } else {
              startIndex = value.split(pValueComposer[i].from_search_string).reverse().slice(-pValueComposer[i].from_index).reverse().join(pValueComposer[i].from_search_string).length + pValueComposer[i].from_search_string.length;
            }
          } else if (pValueComposer[i].mode.indexOf("FromIndex+") === 0) {
            if (pValueComposer[i].from_index < 0) {
              startIndex = value.length + pValueComposer[i].from_index + 1;
            } else {
              startIndex = pValueComposer[i].from_index;
            }
          }
          var endIndex;
          if (pValueComposer[i].mode.indexOf("ToSearch") > 0) {
            if (pValueComposer[i].to_search_string === "") {
              endIndex = pValueComposer[i].to_index;
            } else if (pValueComposer[i].to_index >= 0) {
              endIndex = value.split(pValueComposer[i].to_search_string, pValueComposer[i].to_index + 1).join(pValueComposer[i].to_search_string).length;
            } else {
              endIndex = value.split(pValueComposer[i].to_search_string).slice(-pValueComposer[i].to_index).reverse().join(pValueComposer[i].to_search_string).length;
            }
          } else if (pValueComposer[i].mode.indexOf("ToIndex") > 0) {
            if (pValueComposer[i].to_index < 0) {
              endIndex = value.length + pValueComposer[i].to_index + 1;
            } else {
              endIndex = pValueComposer[i].to_index;
            }
          }
          outputValue = this._concatValues(outputValue, value.slice(startIndex, endIndex));
          break;
        case "com.nixps.quantum.length_of.0":
          var input = this.applyToValue(pValueComposer[i].input, pExternalApply, pScopedVariableHandlers, pWarningCB);
          if (input === null || input === undefined) {
            // boolean is length = 0, corresponding to quantum value composers documentation
            // but null and undefined gives errors as parameter of the Object.keys, so transalate to have length 0
            input = false;
          }
          outputValue = this._concatValues(outputValue, Object.keys(input).length);
          break;
        case "com.nixps.quantum.generate_uuid.0":
          var uuid = s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
          outputValue = this._concatValues(outputValue, uuid);
          break;
        case "com.nixps.quantum.logical.0":
          if (typeof pValueComposer[i].logical !== "string" || pValueComposer[i].logical.length <= 0) {
            throw new Error("Value composer com.nixps.quantum.logical.0 must contain a valid logical");
          }
          if (pExternalApply !== undefined) {
            outputValue = this._concatValues(outputValue, pExternalApply(pValueComposer[i]));
            break;
          } else {
            throw new Error("Value composer logical not supported");
          }
        case "com.nixps.quantum.parse_url.0":
          var strangeEncode = function strangeEncode(pPart) {
            return encodeURIComponent(pPart).replace(/%[^%][^%]/g, function (c) {
              return c.toLowerCase();
            }).replace(/[!'()*]/g, function (c) {
              return "%" + c.charCodeAt(0).toString(16);
            });
          };
          var parts = {
            Extension: "",
            Name: "",
            Protocol: "" /*, Node: "", Path: ""*/
          };
          var filePart = undefined;
          if (typeof pValueComposer[i].url === "string") {
            filePart = pValueComposer[i].url;
          } else if (Array.isArray(pValueComposer[i].url) && pValueComposer[i].url.length > 0) {
            filePart = this.applyToValue(pValueComposer[i].url, pExternalApply, pScopedVariableHandlers, pWarningCB);
          } else {}
          if (typeof filePart !== "string") {
            throw new Error("Value composer com.nixps.quantum.parse_url.0 url malformed");
          }
          var protocolIndex = filePart.indexOf(":");
          if (protocolIndex >= 0) {
            parts.Protocol = filePart.substring(0, protocolIndex + 1);
          } else {
            parts.Protocol = "file:"; // faultback
          }

          var slashIndex = filePart.lastIndexOf("/");
          var dotIndex = filePart.lastIndexOf(".");
          if (dotIndex >= 0) {
            parts.Extension = filePart.substring(dotIndex);
            if (slashIndex >= 0 && slashIndex < dotIndex) {
              parts.Name = filePart.substring(slashIndex + 1, dotIndex);
            }
          }
          var outputParseURL = "";
          pValueComposer[i].parts.split("+").forEach(function (pPart) {
            if (parts[pPart] === undefined) {
              throw new Error("Value composer com.nixps.quantum.parse_url.0 only supports parts " + pValueComposer[i].parts);
            }
            if ((pPart === "Name" || pPart === "Path") && pValueComposer[i].encoded === true) {
              outputParseURL += strangeEncode(parts[pPart]);
            } else {
              outputParseURL += parts[pPart];
            }
          });
          outputValue = this._concatValues(outputValue, outputParseURL);
          break;
        case "com.nixps.quantum.current_time.0":
          if (typeof pValueComposer[i].format !== "string") {
            throw new Error("Value composer com.nixps.quantum.current_time.0 must contain a valid format");
          }
          if (typeof StrftimeFormat !== "function") {
            throw new Error("Value composer com.nixps.quantum.current_time.0 needs 3rdParty strftime ");
          }
          var date = undefined; // same as today
          if (pValueComposer[i].utc === true) {
            // move date according to utc
            date = new Date();
            date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
          }
          outputValue = this._concatValues(outputValue, StrftimeFormat(pValueComposer[i].format, date));
          break;
        case "com.nixps.quantum.object.0":
          if (pValueComposer[i].object === undefined) {
            throw new Error("Value composer com.nixps.quantum.object.0 must contain a valid object");
          }
          if (pValueComposer[i].object && _typeof(pValueComposer[i].object) === "object" && Object.getPrototypeOf(pValueComposer[i].object) === Object.prototype) {
            var value = {};
            for (var vcoKey in pValueComposer[i].object) {
              if (["boolean", "string", "number"].includes(_typeof(pValueComposer[i].object[vcoKey]))) {
                value[vcoKey] = pValueComposer[i].object[vcoKey];
              } else if (Array.isArray(pValueComposer[i].object[vcoKey])) {
                value[vcoKey] = this.applyToValue(pValueComposer[i].object[vcoKey], pExternalApply, pScopedVariableHandlers, pWarningCB);
              } else if (pValueComposer[i].object[vcoKey] && _typeof(pValueComposer[i].object[vcoKey]) === "object") {
                value[vcoKey] = this.applyOnObjectCallBack(pValueComposer[i].object[vcoKey], function (pSubValueComposer) {
                  return that.applyToValue(pSubValueComposer, pExternalApply, pScopedVariableHandlers, pWarningCB);
                }, function (pError) {
                  throw new Error(pError);
                }).translatedObject;
              } else {
                throw new Error("Value composer com.nixps.quantum.object.0 unknown interface");
              }
            }
            outputValue = this._concatValues(outputValue, value);
          } else if (Array.isArray(pValueComposer[i].object) && pValueComposer[i].object.length > 0) {
            var value = [];
            for (var vco = 0; vco < pValueComposer[i].object.length; vco++) {
              if (["boolean", "string", "number"].includes(_typeof(pValueComposer[i].object[vco]))) {
                value.push(pValueComposer[i].object[vco]);
              } else if (Array.isArray(pValueComposer[i].object[vco])) {
                value.push(this.applyToValue(pValueComposer[i].object[vco], pExternalApply, pScopedVariableHandlers, pWarningCB));
              } else if (pValueComposer[i].object[vco] && _typeof(pValueComposer[i].object[vco]) === "object") {
                value.push(this.applyOnObjectCallBack(pValueComposer[i].object[vco], function (pSubValueComposer) {
                  return that.applyToValue(pSubValueComposer, pExternalApply, pScopedVariableHandlers, pWarningCB);
                }, function (pError) {
                  throw new Error(pError);
                }).translatedObject);
              } else {
                throw new Error("Value composer com.nixps.quantum.object.0 unknown interface");
              }
            }
            outputValue = this._concatValues(outputValue, value);
          } else {
            outputValue = this._concatValues(outputValue, pValueComposer[i].object);
          }
          break;
        case "com.nixps.quantum.merge.0":
          if (!Array.isArray(pValueComposer[i].values)) {
            throw new Error("Value composer com.nixps.quantum.merge.0 must have an array for paramter values");
          }
          if (pValueComposer[i].values.length === 0) {
            throw new Error("Value composer com.nixps.quantum.merge.0 noting to merge");
          }
          var merging = this.applyToValue(pValueComposer[i].values[pValueComposer[i].values.length - 1], pExternalApply, pScopedVariableHandlers, pWarningCB);
          for (var m = pValueComposer[i].values.length - 2; m >= 0; m--) {
            var mergedItem = this.applyToValue(pValueComposer[i].values[m], pExternalApply, pScopedVariableHandlers, pWarningCB);
            if (Array.isArray(merging)) {
              if (Array.isArray(mergedItem)) {
                merging = mergedItem.concat(merging);
              } else {
                throw new Error("Value composer com.nixps.quantum.merge.0 not supporting mixed interfaces");
              }
            } else if (merging !== null && _typeof(merging) === "object") {
              if (mergedItem !== null && _typeof(mergedItem) === "object") {
                merging = Object.assign({}, mergedItem, merging);
              } else {
                throw new Error("Value composer com.nixps.quantum.merge.0 not supporting mixed interfaces");
              }
            } else {
              throw new Error("Value composer com.nixps.quantum.merge.0 unknown interfaces");
            }
          }
          outputValue = this._concatValues(outputValue, merging);
          break;
        case "com.nixps.quantum.unit_converter.0":
          var inputValue = undefined;
          if (typeof pValueComposer[i].value === "string" || typeof pValueComposer[i].value === "number") {
            inputValue = pValueComposer[i].value;
          } else if (Array.isArray(pValueComposer[i].value)) {
            inputValue = this.applyToValue(pValueComposer[i].value, pExternalApply, pScopedVariableHandlers, pWarningCB);
          } else {
            throw new Error("Value composer com.nixps.unit_converter.object.0 invalid value interface");
          }
          switch (pValueComposer[i].to_unit) {
            case "filesize_byte":
              outputValue = this._concatValues(outputValue, FileSizeUtils.toString(inputValue, ""));
              break;
            case "percentage":
              var numericValue = parseFloat(inputValue);
              if (isFinite(numericValue)) {
                // round to max 2 numbar after comma 
                var roundedValue = Math.round(numericValue * 10000) / 10000;
                // some ductabe to fix isses like  0.5556 * 100
                inputValue = parseFloat((roundedValue * 100).toFixed(10)) + " %";
              } else {
                inputValue = "";
              }
              outputValue = this._concatValues(outputValue, inputValue);
              break;
            case "date":
              if (typeof pValueComposer[i].format !== "string") {
                throw new Error("Value composer com.nixps.quantum.unit_converter.0 must contain a valid format");
              }
              if (typeof inputValue === "number") {
                if (("" + inputValue).length === 10) {
                  // special compact format
                  inputValue = inputValue * 1000;
                }
              }
              var date = new Date(inputValue);
              if (isNaN(date.getTime())) {
                // invalid date
                throw new Error("Value composer com.nixps.quantum.unit_converter.0 invalid date " + inputValue);
              }
              outputValue = this._concatValues(outputValue, StrftimeFormat(pValueComposer[i].format, date));
              break;
            default:
              /*var value = pValueComposer[i].value;
              if (typeof value === "string") {
                  value = parseFloat(value);
              }
              var convertedValue = RegisteredUnits.convert(value, pValueComposer[i].from_unit, pValueComposer[i].to_unit);
              outputValue = this._concatValues(outputValue, convertedValue);
              */
              throw new Error("Value composer com.nixps.unit_converter.object.0 unsupported to_unit: " + pValueComposer[i].to_unit);
          }
          break;
        case "com.nixps.preferences.user.0":
          if (pValueComposer[i].application_id === undefined) {
            pValueComposer[i].application_id = "";
          }
          if (pValueComposer[i].sub_key === undefined) {
            pValueComposer[i].sub_key = pValueComposer[i].preference_key;
          }
          if (typeof pValueComposer[i].sub_key !== "string") {
            throw new Error("Value composer com.nixps.preferences.user.0 must contain a valid sub_key");
          }
          if (pValueComposer[i].sub_key.slice(0, 7) !== "custom.") {
            throw new Error("Value composer com.nixps.preferences.user.0 sub_key must be prefixed with custom.");
          }
          if (typeof pValueComposer[i].application_id === "string" && pValueComposer[i].application_id.length > 0) {
            throw new Error("Value composer com.nixps.preferences.user.0 application_id is not supported yet");
          }
          // system_realm_only
          var preferenceValue = this.user_preferences.getCustomPreference(pValueComposer[i].sub_key.slice(7));
          if (preferenceValue === undefined && pValueComposer[i].default_value !== undefined) {
            // use default_value if value not found
            if (Array.isArray(pValueComposer[i].default_value)) {
              preferenceValue = this.applyToValue(pValueComposer[i].default_value, pExternalApply, pScopedVariableHandlers, pWarningCB);
            } else {
              preferenceValue = pValueComposer[i].default_value;
            }
          }
          outputValue = this._concatValues(outputValue, preferenceValue);
          break;
        case "com.nixps.quantum.role.0":
          // strange a role value composer in the UI???
          // in the ui there is just one user known...
          if (this.user === undefined || this.user === null) {
            throw new Error("Value Composer: unknown user for com.nixps.quantum.role.0");
          }
          outputValue = this._concatValues(outputValue, this.user.getUserName());
          break;
        case "com.nixps.device.settings.0":
          if (typeof pValueComposer[i].parameter !== "string" || pValueComposer[i].parameter.length <= 0) {
            throw new Error("Value composer com.nixps.device.settings.0 must contain a valid parameter");
          }
          var languages = [];
          if (window.navigator && navigator.languages) {
            languages = navigator.languages;
          } else if (window.navigator && navigator.language !== undefined && navigator.languages === undefined) {
            languages = [navigator.language]; // old browsers
          }

          var setting = null;
          if (pValueComposer[i].parameter === "language") {
            setting = window.navigator && navigator.language || null;
          } else if (pValueComposer[i].parameter === "known_language") {
            var browserLanguage = window.navigator && navigator.language || null;
            if (typeof browserLanguage === "string") {
              // first split of sub region, keep only language
              browserLanguage = browserLanguage.substring(0, 2).toLowerCase();
            }
            setting = translatedLanguages.includes(browserLanguage) ? browserLanguage : null;
          } else if (pValueComposer[i].parameter === "languages") {
            setting = languages;
          } else if (pValueComposer[i].parameter === "known_languages") {
            var languagesDict = {}; // to filter out duplicates
            setting = languages.map(function (pLang) {
              // first split of sub region, keep only language
              return ("" + pLang).substring(0, 2).toLowerCase();
            }).filter(function (pLang) {
              if (languagesDict[pLang] === true) {
                // do not allow duplicates
                return false;
              }
              languagesDict[pLang] = true;
              // return is it is in our list
              return translatedLanguages.includes(pLang);
            });
          } else if (pValueComposer[i].parameter === "is_mobile") {
            setting = Device.hasMobileWidth();
          } else if (pValueComposer[i].parameter === "is_online") {
            setting = Device.isOnline();
          } else {
            throw new Error("Value composer com.nixps.device.settings.0 has unknown parameter " + pValueComposer[i].parameter);
          }
          outputValue = this._concatValues(outputValue, setting);
          break;
        case "com.nixps.quantum.calculations.0":
          if (!Array.isArray(pValueComposer[i].operations)) {
            throw new Error("Value composer com.nixps.quantum.calculations.0 operations is missing");
          }
          if (pValueComposer[i].operations.length === 0) {
            outputValue = this._concatValues(outputValue, NaN);
          } else {
            var calculationsFunction = "";
            for (var operationIndex = 0; operationIndex < pValueComposer[i].operations.length; operationIndex++) {
              if (pValueComposer[i].operations[operationIndex] && _typeof(pValueComposer[i].operations[operationIndex]) === "object") {
                if (pValueComposer[i].operations[operationIndex].type === "value") {
                  var value = pValueComposer[i].operations[operationIndex].value;
                  if (Array.isArray(value)) {
                    value = this.applyToValue(value, pExternalApply, pScopedVariableHandlers, pWarningCB);
                  }
                  if (typeof value === "number") {
                    calculationsFunction += " " + value + " ";
                  } else {
                    throw new Error("Value composer calculations, value must be an number");
                  }
                } else if (pValueComposer[i].operations[operationIndex].type === "operation") {
                  switch (pValueComposer[i].operations[operationIndex].operation) {
                    case "add":
                      calculationsFunction += " + ";
                      break;
                    case "subtract":
                      calculationsFunction += " - ";
                      break;
                    case "multiply":
                      calculationsFunction += " * ";
                      break;
                    case "divide":
                      calculationsFunction += " / ";
                      break;
                    default:
                      throw new Error("Value composer com.nixps.quantum.calculations.0 an unknown operation has been found " + pValueComposer[i].operations[operationIndex].operation);
                  }
                } else if (pValueComposer[i].operations[operationIndex].type === "grouping") {
                  if (pValueComposer[i].operations[operationIndex].bracket === ")" || pValueComposer[i].operations[operationIndex].bracket === "(") {
                    calculationsFunction += " " + pValueComposer[i].operations[operationIndex].bracket + " ";
                  } else {
                    throw new Error("Value composer an unknown grouping brackets has been found " + pValueComposer[i].operations[operationIndex].bracket);
                  }
                }
              }
            }
            try {
              var functionResult = new MyFunction([], calculationsFunction)();
              outputValue = this._concatValues(outputValue, functionResult);
            } catch (e) {
              console.error("Value composer invalid calculations", e);
              outputValue = this._concatValues(outputValue, NaN);
            }
          }
          break;
        case "com.nixps.quantum.conditional.0":
          if (!Array.isArray(pValueComposer[i].condition)) {
            throw new Error("Value Composer: Unsupported format for condition");
          }
          if (pValueComposer[i].condition.length === 0) {
            // in case of empty string
            outputValue = this._concatValues(outputValue, true);
          } else {
            var errorReturnValue = false;
            var condition = [];
            var needSwapIndex = false;
            for (var condition_index = 0; condition_index < pValueComposer[i].condition.length; condition_index++) {
              if (pValueComposer[i].strict === true && ["equal to"].includes(pValueComposer[i].condition[condition_index])) {
                // make the "equal to" stricty
                condition.push("strict " + pValueComposer[i].condition[condition_index]);
              } else if (["contains", "contains text like"].includes(pValueComposer[i].condition[condition_index]) && Array.isArray(condition[condition_index - 1])) {
                // transform the contains to "in" in case of arrays
                condition.push(pValueComposer[i].condition[condition_index] === "contains" ? "in" : "in like");
                needSwapIndex = true; // swap left and right side of the "in" operator
                continue; // do not go to the swap if-code
              } else if (["string", "number", "boolean", "undefined"].includes(_typeof(pValueComposer[i].condition[condition_index])) || pValueComposer[i].condition[condition_index] === null) {
                condition.push(pValueComposer[i].condition[condition_index]);
              } else if (Array.isArray(pValueComposer[i].condition[condition_index])) {
                condition.push(this.applyToValue(pValueComposer[i].condition[condition_index], pExternalApply, pScopedVariableHandlers, pWarningCB));
              } else if (_typeof(pValueComposer[i].condition[condition_index]) === "object") {
                // plain object or class
                var warningObjectCompareReturn = pWarningCB({
                  "warning_code": "compare_with_object",
                  "message": "impossible to compare with objects",
                  "value_composer_type": "com.nixps.quantum.conditional.0",
                  "value_composer": structuredClone(pValueComposer)
                });
                if (warningObjectCompareReturn !== undefined && typeof warningObjectCompareReturn.new_value === "boolean") {
                  condition = [warningObjectCompareReturn.new_value];
                } else {
                  condition = [errorReturnValue];
                }
                break;
              } else {
                throw new Error("Value Composer: Unsupported interfase for condition item");
              }
              if (needSwapIndex) {
                needSwapIndex = false;
                condition.push(condition[condition_index - 1]); // "in" or "in like"
                condition.push(condition[condition_index - 2]);
                condition.splice(condition_index - 2, 2);
              }
            }
            var result = new QueryApplier(condition).validateNaked();
            if (typeof result !== "boolean") {
              result = errorReturnValue;
            }
            outputValue = this._concatValues(outputValue, result);
          }
          break;
        case "com.nixps.quantum.url_decoder.0":
        case "com.nixps.quantum.url_encoder.0":
        case "com.nixps.quantum.url_to_local_path.0":
        default:
          if (pExternalApply !== undefined) {
            outputValue = this._concatValues(outputValue, pExternalApply(pValueComposer[i]));
          } else {
            throw new Error("Value Composer: Unsupported value composer type " + pValueComposer[i].type);
          }
      }
    }
    return outputValue;
  },
  /**
   * @description Concat values to one value
   * @function
   * @private
   * @name ExpressionToJS#_concatValues
   * @param {mixed} pOldValue left value
   * @param {mixed} pNewValue right value
   * @returns {mixed} the concattenation of the left and the right value
   */
  _concatValues: function _concatValues(pOldValue, pNewValue) {
    if (pOldValue === undefined) {
      // if one is missing, just return the known one
      return pNewValue;
    } else if (pNewValue === undefined) {
      // if one is missing, just return the known one
      return pOldValue;
    } else if (["string", "number", "boolean", "undefined"].includes(_typeof(pOldValue)) && ["string", "number", "boolean", "undefined"].includes(_typeof(pNewValue))) {
      // both are primitive types, cast both to strings and concat
      return "" + pOldValue + pNewValue;
    } else if (pOldValue === null || pNewValue === null) {
      if (["string", "number", "boolean", "undefined"].includes(_typeof(pOldValue)) || ["string", "number", "boolean", "undefined"].includes(_typeof(pNewValue))) {
        return "" + pOldValue + pNewValue;
      } else {
        throw new Error("Value Composer: unsupported value to concat with");
      }
    } else if (Array.isArray(pOldValue) && Array.isArray(pNewValue)) {
      // both are arrays, backend does not behave as expected
      throw new Error("Value Composer: unsupported value to concat with");
    } else {
      console.error("try to concat " + pOldValue + " with " + pNewValue);
      throw new Error("Value Composer: unsupported value to concat with");
    }
  }
};
module.exports = ExpressionToJS;

},{"../../3rdParty/strftime.js":7,"../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79,"../../cloudflow/CloudflowUtil/js/FileSizeUtils.js":88,"../../cloudflow/CloudflowUtil/js/QueryApplier.js":91,"../../cloudflow/PWA/js/Device.js":198,"../../cloudflow/TranslatedLanguagesSelector/js/translatedLanguages.js":239,"../../common/MyFunction/js/MyFunction.js":297}],416:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 * @description Builder of plain html pages and recover of builded pages
 * @autor Guillaume Desmet
 *   created by guillaume on Aug 28, 2017 1:45:35 PM
 */

require("../../polyfill/polyfill.js");
require("../../cloudflow/FormRender/js/nixps-cloudflow-LayoutRenderer.js");
var HTMLPage = require("../../cloudflow/UIProfiles/js/HTMLPage.js");
var ComponentLinks = require("./ComponentLinks.js");
var Component = require("../../cloudflow/UIProfiles/js/Component.js");
var ExpressionToJS = require("./ExpressionToJS.js");
var CloudflowObject = require("../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
var CloudflowURL = require("../../cloudflow/CloudflowUtil/js/CloudflowURL.js");
var Version = require("../../cloudflow/Version/js/Version.js");
var TranslationHandler = require("../../cloudflow/Translate/js/TranslationHandler.js");
var Constants = require("./Constants.js");
var QueryApplier = require("../../cloudflow/CloudflowUtil/js/QueryApplier.js");
var WebFramework = require("../../cloudflow/UIProfiles/js/WebFramework.js");
var loadingFiles = {}; // a object containing the currect asking files to prevent loading a file twice

var beginFunctionRegExp = new RegExp(/(^function *[(][^)]*[)] *{)|(^function *runtimeFunction[(][^)]*[)] *{)/);
var endFunctionRegExp = new RegExp(/} *$/);
var preparationVariablesRegExp = new RegExp('("?)[$]{prepvar.([^}]+)}("?)', "g"); // recognise variable for actions
var inputvariableRegExp = new RegExp('[$]{inputvariable\.([a-zA-Z0-9\._]+)}', "g"); // recognise variable for actions and context 
var allInputvariableRegExp = new RegExp('[\\\\]*"[$]{inputvariables}[\\\\]*"', "g"); // recognise allvariable for actions and context 
var contextRegExp = new RegExp('("?)[$]{context\.([a-zA-Z._]+)}("?)', "g"); // recognise variable for context injection
var translationsRegExp = new RegExp('"[$]{((pb|custom)-[^}]+)}"', "g"); // recognise variable for context injection

var injectOptionsUsernameRegExp = new RegExp('username": "<fullname>"', "g");
var injectOptionsEmailRegExp = new RegExp('email": "<user_email>"', "g");
var injectOptionsUserRegExp = new RegExp('user": "<user>"', "g");
var injectOptionsLicenseRegExp = new RegExp('license": "<license>"', "g");
var injectOptionsConfigRegExp = new RegExp('configID": "<config_id>"', "g");
var injectOptionsLanguageRegExp = new RegExp('language": "<language>"', "g");
var injectOptionsContextReferenceRegExp = new RegExp('context": "<context>"', "g");
var injectOptionsConsentReferenceRegExp = new RegExp('consent": "<consent>"', "g");
var injectOptionsHostReferenceRegExp = new RegExp('host": "<host>"', "g");
var injectOptionsInEditorReferenceRegExp = new RegExp('isInEditor": "<isInEditor>"', "g");
var injectOptionsRelativeBasePathRegExp = new RegExp('relativeBasePath": ""', "g");
var injectOptionsEndScriptTag = new RegExp('<[/]script>', "ig");
var expressionRegExp = new RegExp('"<expression([0-9]+)>"', "g"); // recognise value composers expressions for context injection

// Fixed for #28527, previous version of this line did not work for IE11
var newLineRegExp = new RegExp("\\n", "g"); // new lines detection to do replacings
/**
 * @description roemve the key string function and there opening and closing brackets 
 * to be able to stringify the function into the builded script tag
 * @function
 * @private
 * @param {type} pFunctionString
 * @return {unresolved}
 */
function removeFunctionCoat(pFunctionString) {
  if (typeof pFunctionString === "string") {
    return pFunctionString.replace(beginFunctionRegExp, "").replace(endFunctionRegExp, "");
  }
  return pFunctionString;
}
function escape(pStr) {
  return _.escape(pStr);
}
function escape_doublequotes(pStr) {
  return pStr.replaceAll('"', '\\"');
}
function detag(pStr) {
  if (typeof pStr === "string") {
    return pStr.replace(/</g, "\\x3C");
  }
  return pStr;
}
function hashSHA(pString) {
  if (typeof pString === "string" && window.forge !== undefined) {
    var md = window.forge.md.sha512.create();
    md.update(pString.replace(/\r/g, ""), "utf8");
    return "sha512-" + window.forge.util.encode64(md.digest().getBytes());
  }
  return null;
}

/**
 * @description The current clouflow version
 * @type {String}
 * @private
 * @static
 * @default null
 */
var cloudflowversion = null;
function getCloudflowVersion() {
  if (cloudflowversion === null) {
    return Version.get().then(function (version) {
      cloudflowversion = version.toString();
      return cloudflowversion;
    });
  } else {
    return Promise.resolve(cloudflowversion);
  }
}

/**
 * @description this object handles everything between backend and HTMLPage object, it reads and writes the HTML from the HTMLPage object
 * @constructor HTMLPageHandler
 */
var HTMLPageHandler = function HTMLPageHandler(pUrl, pCreator) {
  if (typeof pUrl !== "string" || pUrl.length <= 0) {
    throw new Error("HTMLPageHandler: input option url must be an not empty string");
  }
  if (pUrl.indexOf(" ") >= 0) {
    throw new Error("HTMLPageHandler: input url in not well url encoded");
  }
  if (typeof window.hex_md5 !== "function") {
    throw new Error("HTMLPageHandler: please include the MD5 js plugin");
  }
  if (typeof window._ !== "function") {
    console.warn("HTMLPageHandler: please include the underscore js plugin");
  }
  this.url = pUrl;
  this.pagecreator = "Cloudlfow"; // default value in case of saving before the info is ready
  this.setCreator(pCreator); // we need this when saving, we suppose that when save is clicked all async calls are done when creating ....
  this.HTMLPage;
  this.content;
  this.contentType;
  this.contentLength;
  this.fileEtag;
  this.fileModification;
};
HTMLPageHandler.setCloudflowVersion = function (pVersion) {
  if (pVersion !== undefined && pVersion.major !== undefined && pVersion.minor !== undefined) {
    cloudflowversion = pVersion.major + "." + pVersion.minor + " build:" + pVersion.build;
  }
};
HTMLPageHandler.prototype = {
  constructor: HTMLPageHandler,
  /**
   * @description Init the creator
   * @function
   * @private
   * @name HTMLPageHandler.setCreator
   * @param {String} pCreator the name of the Creator or Generator
   * @return {undefined}
   */
  setCreator: function setCreator(pCreator) {
    if (typeof pCreator === "string" && pCreator.length > 0) {
      this.pagecreator = pCreator;
    } else {
      var that = this;
      getCloudflowVersion().then(function (pVersion) {
        that.pagecreator = "Cloudflow PageBuilder " + pVersion;
      });
    }
  },
  /**
   * @description Get the page creator
   * @function
   * @name HTMLPageHandler.getCreator
   * @return {String} The name of the creator
   */
  getCreator: function getCreator() {
    return this.pagecreator;
  },
  duplicate: function duplicate(pDuplicateURL, pCopyOptions) {
    if (typeof pDuplicateURL !== "string" || pDuplicateURL.length <= 0) {
      throw new Error("duplicating url is missing");
    }
    var that = this;
    var candidateName = pDuplicateURL.substring(pDuplicateURL.lastIndexOf("/") + 1);
    try {
      candidateName = decodeURI(candidateName);
    } catch (e) {}
    return this.loadAndGet(false, undefined, Constants.versionNumber).then(function (pResult) {
      if (typeof pResult.error_code === "string") {
        return Promise.reject(pResult);
      }
      var htmlPage = pResult.HTMLPage;
      var duplicate = htmlPage.duplicate(candidateName);
      var duplicatePage = duplicate.HTMLPage;
      var translationsKeys = duplicate.translationKeys;
      if (pDuplicateURL.endsWith(".html") === false) {
        pDuplicateURL = pDuplicateURL + ".html";
      }
      if (duplicatePage.hasExtraTranslation()) {
        var prevFolder = duplicatePage.getExtraTranslationPath();
        var basePath = "";
        if (prevFolder.startsWith("cloudflow://") === false && prevFolder.startsWith("/portal.cgi/") === false) {
          basePath = CloudflowURL.getFolderURL(that.url);
        }
        var cloudflowURL = new CloudflowURL(basePath, prevFolder);
        var path = cloudflowURL.getUploadPath();
        var origTitle = htmlPage.getTitle();
        // old setup where the title was only string
        if (typeof origTitle === "string" && prevFolder.indexOf(origTitle + "_" + htmlPage.getID() + "/") > 0) {
          // old setup, where each translation had is own file
          prevFolder = cloudflowURL.getCloudflowPath(); // reset prevFolder
          var preFolderWithoutSlache = prevFolder.slice(0, -1);
          var parentPreFolder = preFolderWithoutSlache.slice(0, preFolderWithoutSlache.lastIndexOf("/") + 1);
          var toFolder = parentPreFolder + encodeURIComponent(duplicatePage.getTitle()) + "_" + duplicatePage.getID() + "/";
          return api_defer.file.copy_folder(prevFolder, toFolder, {
            from_contents: true,
            create_folders: true
          }).then(function (pResult) {
            var newFolderName = pResult.copied_folder;
            duplicatePage.setExtraTranslationPath(newFolderName);
            var fileTemplate = duplicatePage.getExtraTranslationFileTemplate();
            var translationHandler = new TranslationHandler("file", {
              "basepath": newFolderName,
              "filenametemplate": fileTemplate,
              "languages": []
            }, []);
            return Promise.all([translationHandler.loadData()]).then(function () {
              translationHandler.changeKeys(translationsKeys);
              // save page
              var HTMLHandler = new HTMLPageHandler(pDuplicateURL, undefined);
              return Promise.allSettled([HTMLHandler.saveHTMLPage(duplicatePage.toJSON(), undefined, "current", pCopyOptions), translationHandler.save()]).then(function (pResults) {
                if (pResults && pResults[0].status === "fulfilled") {
                  return pResults[0].value;
                }
                return Promise.reject(pResults[0].reason);
              });
            })["catch"](function (pError) {
              console.error(pError);
              return Promise.reject(pError);
            });
          })["catch"](function (pError) {
            console.error(pError);
            return Promise.reject(pError);
          });
        } else {
          // new way, keep existing translation file
          var translationHandler = new TranslationHandler("file", {
            "basepath": path,
            "filenametemplate": duplicatePage.getExtraTranslationFileTemplate(),
            "languages": []
          }, []);
          return Promise.all([translationHandler.loadData()]).then(function () {
            translationHandler.duplicateKeys(translationsKeys);
            // save page
            var HTMLHandler = new HTMLPageHandler(pDuplicateURL, undefined);
            return Promise.allSettled([HTMLHandler.saveHTMLPage(duplicatePage.toJSON(), undefined, "current", pCopyOptions), translationHandler.save()]).then(function (pResults) {
              if (pResults && pResults[0].status === "fulfilled") {
                return pResults[0].value;
              }
              return Promise.reject(pResults[0].reason);
            });
          })["catch"](function (pError) {
            console.error(pError);
            return Promise.reject(pError);
          });
        }
      } else {
        var HTMLHandler = new HTMLPageHandler(pDuplicateURL, undefined);
        return HTMLHandler.saveHTMLPage(duplicatePage.toJSON(), undefined, "current", pCopyOptions);
      }
    });
  },
  /**
   * @description load data from backend cloudflow
   * @function
   * @name HTMLPageHandler.load
   * @return {Deferred}
   */
  load: function load() {
    var that = this;
    var getUrl;
    if (this.url.startsWith("cloudflow://")) {
      getUrl = "/portal.cgi?asset=download_file&url=" + encodeURIComponent(this.url);
      if (window.api_util !== undefined && api_util.get_session() !== undefined) {
        getUrl += "&session=" + api_util.get_session();
      }
    } else {
      // also allow that urls are not comming from cloudflow://
      getUrl = this.url;
    }
    return new Promise(function (pResolve, pReject) {
      var xhttp = new XMLHttpRequest();
      xhttp.onload = function (pEvent) {
        if (xhttp.status < 200 || xhttp.status > 299) {
          var errorObject = {
            error_code: "http",
            error: xhttp.statusText
          };
          if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
            try {
              errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
            } catch (e) {}
          }
          console.error(errorObject);
          pReject(errorObject);
        } else {
          that.content = xhttp.responseText;
          that.contentType = xhttp.getResponseHeader("content-type");
          // reset
          that.fileEtag = "";
          that.fileModification = undefined;
          var etagFormat = xhttp.getResponseHeader("x-nixps-sourcetag");
          if (typeof etagFormat === "string" && etagFormat.length > 0) {
            if (etagFormat.indexOf("mod=") === 0) {
              that.fileModification = etagFormat.slice(4);
            } else {
              if (etagFormat[0] === '"') {
                that.fileEtag = etagFormat.slice(1, -1);
              } else {
                that.fileEtag = etagFormat;
              }
            }
          }
          that.contentLength = parseInt(xhttp.getResponseHeader("content-length"));
          pResolve(that.content);
        }
      };
      xhttp.onerror = function (pEvent) {
        var errorObject = {
          error_code: "http_error_load",
          error: xhttp.statusText
        };
        if (typeof xhttp.responseText === "string" && xhttp.responseText.length > 0) {
          try {
            errorObject = Object.assign(errorObject, JSON.parse(xhttp.responseText));
          } catch (e) {}
        }
        console.error(errorObject);
        pReject(errorObject);
      };
      xhttp.open("get", getUrl);
      xhttp.setRequestHeader("Content-Type", "text/plain; charset=UTF-8");
      xhttp.send();
    });
  },
  /**
   * @description Get the data from backend and try to figure out if page has a valid pagebuilder format
   * @function
   * @name HTMLPageHandler.loadAndGet
   * @return {object} contains "content" the hole content of page, "error_code", "error_message", "HTMLPage" object of HTMLPage, "title"
   */
  loadAndGet: function loadAndGet(pLoadMissingDynamically, pUIMode, pEnvironmentPageBuilderVersion) {
    var that = this;
    return this.load().then(function () {
      return that.get(undefined, pLoadMissingDynamically, pUIMode, pEnvironmentPageBuilderVersion);
    }, function (pError) {
      var errorMessage = pError;
      if (typeof pError.responseText === "string") {
        errorMessage = pError.responseText;
      } else if (typeof pError.statusText === "string") {
        errorMessage = pError.statusText;
      }
      // could not retrieve file from backend
      console.error("loadAndGet: ", errorMessage);
      return Promise.reject(errorMessage);
    });
  },
  /**
   * @description load a file and regenerate the html without checking
   * @function
   * @private
   * @name HTMLPageHandler.loadAndRegenerate
   * @param {type} pOutputURL
   * @return {HTMLPageHandler.HTMLPageHandler.prototype@call;loadAndGet@call;then}
   */
  loadAndRegenerate: function loadAndRegenerate(pOutputURL, pUIMode) {
    if (typeof pOutputURL !== "string" && pOutputURL.length <= 0) {
      throw new Error("input parameter pOuputURL must be a not empty string");
    }
    var that = this;
    return this.loadAndGet(false, undefined, Constants.versionNumber).then(function (pResults) {
      if (pResults !== undefined && pResults.HTMLPageJSON && _typeof(pResults.HTMLPageJSON) === "object") {
        that.content = ""; // clean content so the save will not block because the content is the same
        var oldUrl = that.url; // keep url to restore later
        var oldEtag = that.fileEtag; // 
        var oldModification = that.fileModification; // 
        that.url = pOutputURL; // set the url so it will saved in that position
        that.fileEtag = "";
        that.fileModification = "";
        return Promise.resolve(that.saveHTMLPage(pResults.HTMLPageJSON, pUIMode, "current", {}))["finally"](function () {
          that.url = oldUrl; // restore url
          that.fileEtag = oldEtag;
          that.fileModification = oldModification;
        });
      } else {
        return null;
      }
    });
  },
  /**
   * @description get the information from the handler, this rerun object contains content, HTMLPage, or error_code and error_messages
   * @function
   * @name HTMLPageHandler.get
   * @return {object}
   */
  get: function get(pForce, pLoadMissingDynamically, pUIMode, pEnvironmentPageBuilderVersion) {
    if (pEnvironmentPageBuilderVersion === undefined) {
      pEnvironmentPageBuilderVersion = 0;
    }
    // first get the config json and the html part
    var parts = this._retrieveParts();
    // if everything goes good we have recieved two parts
    if (parts && parts.contains_error !== true && parts.configJSON && _typeof(parts.configJSON) === "object" && typeof parts.html === "string") {
      // calc hash of html part
      var html_MD5_hash = hex_md5(parts.html);
      try {
        // check errors with version numbers
        // because this can cause errors during the creating of HTMLPage, we need to check this first
        if (parts !== undefined && parts.configJSON !== undefined && typeof parts.configJSON.version === "number" && parts.configJSON.version > pEnvironmentPageBuilderVersion) {
          // a too recent version found, show error, need update
          return {
            content: this.content,
            content_type: this.contentType,
            etag: this.fileEtag,
            file_modification: this.fileModification,
            error_code: "futureversion",
            error_message: $.i18n._("nixps-cloudflow-pagemanager.errormessage_futureversion")
          };
        }
        if (pLoadMissingDynamically === true) {
          // check if there are components who are not jet included in the DOM
          // if there are, load and apply direclty
          var missingloadings = this._checkAndLoadDynamically(parts.configJSON, pUIMode);
          // if there were no missing files, the return value is equal to "false"
          if (missingloadings !== false) {
            var that = this;
            // returning deferred, of all missing compontens script files
            return missingloadings.then(function () {
              // try to put the json in the HTMLPage object, if this fails, let notice
              var htmlPage = HTMLPage.fromJSON(parts.configJSON);
              if (html_MD5_hash === htmlPage.getHash()) {
                // the saved hash is the same as calc hash, no changed has been made
                // give the config json to parent
                that.HTMLPage = htmlPage;
                return {
                  content: that.content,
                  content_type: that.contentType,
                  etag: that.fileEtag,
                  file_modification: that.fileModification,
                  HTMLPage: htmlPage,
                  HTMLPageJSON: htmlPage.toJSON(),
                  title: htmlPage.getTitle()
                };
              } else {
                // the md5 hash has been changed, give only the content back
                return {
                  content: that.content,
                  content_type: that.contentType,
                  etag: that.fileEtag,
                  file_modification: that.fileModification,
                  error_code: "diff_hash",
                  error_message: $.i18n._("nixps-cloudflow-pagemanager.errormessage_diffhash", [html_MD5_hash, htmlPage.getHash()])
                };
              }
            }, function (pError) {
              console.error(pError);
              return {
                content: that.content,
                content_type: that.contentType,
                etag: that.fileEtag,
                file_modification: that.fileModification,
                error_code: "dynamic_load_fails",
                error_message: "could not load the missing components"
              };
            });
          }
        }
        // try to put the json in the HTMLPage object, if it fails, let notice
        var htmlPage = HTMLPage.fromJSON(parts.configJSON);
        if (html_MD5_hash === htmlPage.getHash()) {
          // the saved hash is the same as calc hash, no changed has been made
          // give the config json to parent
          this.HTMLPage = htmlPage;
          return {
            content: this.content,
            content_type: this.contentType,
            etag: this.fileEtag,
            file_modification: this.fileModification,
            HTMLPage: htmlPage,
            HTMLPageJSON: htmlPage.toJSON(),
            title: htmlPage.getTitle()
          };
        } else if (pForce === true) {
          this.HTMLPage = htmlPage;
          // user want to rebuild completely,
          // because the user want recalculate the hash
          // make new content, new hash and save to backend
          this.saveHTMLPage(htmlPage, pUIMode, undefined, {}).then(function () {
            window.location.reload();
          }, function (pError) {
            console.error("page could not be saved", Error);
          });
          return {
            content: this.content,
            content_type: this.contentType,
            etag: this.fileEtag,
            file_modification: this.fileModification,
            HTMLPage: htmlPage,
            HTMLPageJSON: htmlPage.toJSON(),
            title: htmlPage.getTitle()
          };
        } else {
          // the md5 hash has been changed, give only the content back
          return {
            content: this.content,
            content_type: this.contentType,
            etag: this.fileEtag,
            file_modification: this.fileModification,
            error_code: "diff_hash",
            error_message: $.i18n._("nixps-cloudflow-pagemanager.errormessage_diffhash", [html_MD5_hash, htmlPage.getHash()])
          };
        }
      } catch (e) {
        // an error occured, the json has wrong HTMLPage json format
        console.error(e);
        console.error(e.stack);
        return {
          content: this.content,
          content_type: this.contentType,
          file_modification: this.fileModification,
          etag: this.fileEtag,
          error_code: "wrong_json_interface",
          error_message: $.i18n._("nixps-cloudflow-pagemanager.errormessage_wrongHTMLpageinterface")
        };
      }
    } else if (parts !== undefined && parts.contains_error === true) {
      console.error("Error " + parts.error_code + " found, : " + parts.error);
      return {
        content: this.content,
        content_type: this.contentType,
        etag: this.fileEtag,
        file_modification: this.fileModification,
        error_code: parts.error_code,
        error: parts.error,
        error_message: $.i18n._("nixps-cloudflow-pagemanager.errormessage_wrongpageinterface")
      };
    } else {
      // We found errors
      console.error("unknown error found!");
      return {
        content: this.content,
        content_type: this.contentType,
        etag: this.fileEtag,
        file_modification: this.fileModification,
        error_code: "wrong_file_interface",
        error_message: $.i18n._("nixps-cloudflow-pagemanager.errormessage_unknownerrorsfound")
      };
    }
  },
  /**
   * @description try to retrieve the differend parts of the html page
   * @function
   * @private 
   * @name HTMLPageHandler._retrieveParts
   * @return {object} "configJSON" and "html"
   */
  _retrieveParts: function _retrieveParts() {
    if (typeof this.content !== "string") {
      throw new Error("no content found to retrieve information");
    }
    var lines = this.content.split(/\n/);
    if (Array.isArray(lines) && lines.length > 2) {
      if (typeof lines[0] === "string" && lines[0].trim().startsWith("<!DOCTYPE")) {
        // remove first line if it is a doctype
        lines.shift();
      }
      if (typeof lines[0] === "string" && lines[0].trim() !== "<!--") {
        return {
          contains_error: true,
          error_code: "no_start_found",
          error: "no starting <!-- found at the beginning"
        };
      }
      // retrieve first line with only -->
      var endConfigLineIndex = 0;
      for (var i = 1; i < lines.length; i++) {
        if (typeof lines[i] === "string" && lines[i].trim() === "-->") {
          endConfigLineIndex = i;
          break;
        }
      }
      if (endConfigLineIndex === 0) {
        return {
          contains_error: true,
          error_code: "no_end_found",
          error: "no ending --> found in the file"
        };
      }
      // take the second line until the --> line, make a big string of it
      var configJSONString = lines.slice(1, endConfigLineIndex).join(" ");
      // take the lines after --> and make a big string of it
      var htmlString = lines.slice(endConfigLineIndex + 1).join("\n");
      try {
        return {
          configJSON: JSON.parse(configJSONString, function (pKey, pValue) {
            if (typeof pValue === "string" && pValue.length > 2) {
              // revent the encoding of the -->
              return pValue.replace(/--\\>/g, "-->").replace(/--([\\]+)>/g, function (m, p1) {
                return "--" + p1.substring(p1.length / 2) + ">";
              });
            }
            return pValue;
          }),
          html: htmlString
        };
      } catch (e) {
        // we could not convert to a proper JSON
        console.error(e.toString());
        return {
          contains_error: true,
          error_code: "content_nojson",
          error: "no correct json found in comment"
        };
      }
    }
    return {
      contains_error: true,
      error_code: "no_codelines_found",
      error: "no lines or to less found to be a page"
    };
  },
  _checkAndLoadDynamically: function _checkAndLoadDynamically(pConfigJSON, pUIMode) {
    var defs = [];
    if (pConfigJSON !== undefined && pConfigJSON.elements !== undefined && Array.isArray(pConfigJSON.elements.elements)) {
      var componentNameTypes = this._getComponentNames(HTMLPage.fromJSON(pConfigJSON));
      var componentNames = [];
      var componentsToTest = [];
      for (var i = 0; i < componentNameTypes.length; i++) {
        var componentLinkType = ComponentLinks.getType(componentNameTypes[i]);
        if (componentLinkType === "jquery_widget") {
          // default type jquery_widget
          // check if item is on jquery, then we suppose the css is also good
          if (window.$ !== undefined && $.fn[componentNameTypes[i]] === undefined || ComponentLinks.needExtras(componentNameTypes[i]) === true) {
            // unknown element
            componentNames.push(componentNameTypes[i]);
          }
        } else if (componentLinkType === "class") {
          componentNames.push(componentNameTypes[i]);
        } else if (componentLinkType === "async_object") {
          (function (pElementType) {
            componentsToTest.push(new Promise(function (pResolve, pReject) {
              Promise.resolve(ComponentLinks.getAsyncCheck(pElementType)()).then(function () {
                pResolve(false); // returns good, so component exists
              }, function () {
                pResolve(pElementType); // returns false, need to include component
              });
            }));
          })(componentNameTypes[i]);
        }
      }
      if (componentNames.length === 0 && componentsToTest.length === 0) {
        return false;
      }
      var defCompNames;
      if (componentsToTest.length === 0) {
        defCompNames = componentNames;
      } else {
        defCompNames = Promise.all(componentsToTest).then(function (pComponentNames) {
          for (var i = 0; i < pComponentNames.length; i++) {
            if (typeof pComponentNames[i] === "string" && pComponentNames[i].length > 0) {
              componentNames.push(pComponentNames[i]);
            }
          }
          return componentNames;
        })["catch"](function (pError) {
          console.error(pError);
          return Promise.reject(pError);
        });
      }
      var that = this;
      return Promise.all([defCompNames]).then(function (pOutput) {
        var extraIncludes = that._getExtraIncludes(pOutput[0], pUIMode);
        var allcssLinks = extraIncludes.cssLinks;
        if (Array.isArray(allcssLinks) && allcssLinks.length > 0) {
          // get all css styles that are alreay included
          var alreadyLoadedCSSLinks = [];
          document.querySelectorAll("head link[type='text/css']").forEach(function (pLinkDOM) {
            alreadyLoadedCSSLinks.push(pLinkDOM.getAttribute("href"));
          });
          // calc all the styles that still need to be loaded 
          var cssLinks = _.difference(allcssLinks, alreadyLoadedCSSLinks);
          if (Array.isArray(cssLinks) && cssLinks.length > 0) {
            var csslink = undefined;
            for (var j = 0; j < cssLinks.length; j++) {
              csslink = document.createElement("LINK");
              csslink.setAttribute("rel", "stylesheet");
              csslink.setAttribute("type", "text/css");
              csslink.setAttribute("href", cssLinks[j]);
              document.head.appendChild(csslink);
            }
          }
        }
        var allJsLinks = extraIncludes.jsLinks;
        if (Array.isArray(allJsLinks) && allJsLinks.length > 0) {
          // get all script that are alreay included
          // there can be 3rdparty js files that are includes by other plugins, so prevent loading twice
          var alreadyLoadedjsLinks = [];
          document.querySelectorAll("head script[type='text/javascript']").forEach(function (pLinkDOM) {
            alreadyLoadedjsLinks.push(pLinkDOM.getAttribute("src"));
          });
          // calc all the js that still need to be loaded 
          var jsLinks = _.difference(allJsLinks, alreadyLoadedjsLinks);
          if (Array.isArray(jsLinks) && jsLinks.length > 0) {
            for (var j = 0; j < jsLinks.length; j++) {
              if (typeof jsLinks[j] === "string" && jsLinks[j].length > 0) {
                // check if items are aleady demanding by others,
                if (loadingFiles[jsLinks[j]] !== undefined) {
                  // so use there defs ..., to prevent ending before the previous one
                  defs.push(loadingFiles[jsLinks[j]]);
                } else {
                  var callDef = Promise.withResolvers();
                  loadingFiles[jsLinks[j]] = callDef;
                  var scriptDOM = document.createElement("SCRIPT");
                  scriptDOM.onload = function (pEvent) {
                    loadingFiles[this.getAttribute("src")].resolve();
                  };
                  scriptDOM.onerror = function (pEvent) {
                    var url = this.getAttribute("src");
                    var errorObject = {
                      error_code: "failed_loading",
                      error: "failed dynamically loading file " + url
                    };
                    if (typeof url === "string" && url.length > 0) {
                      loadingFiles[url].reject(errorObject);
                    }
                    console.error("failed dynamically loading file " + url);
                  };
                  scriptDOM.setAttribute("src", jsLinks[j]);
                  document.head.appendChild(scriptDOM);
                  defs.push(callDef.promise);
                }
              } else if (jsLinks[j] && typeof jsLinks[j].src === "string" && jsLinks[j].src.length > 0) {
                // check if items are already demanding by others,
                if (loadingFiles[jsLinks[j].src] !== undefined) {
                  // so use there defs ..., to prevent ending before the previous one
                  defs.push(loadingFiles[jsLinks[j].src]);
                } else {
                  var callDef = Promise.withResolvers();
                  if (typeof jsLinks[j] === "string") {
                    loadingFiles[jsLinks[j]] = callDef;
                  } else if (jsLinks[j] && typeof jsLinks[j].src === "string") {
                    loadingFiles[jsLinks[j].src] = callDef;
                  }
                  var scriptDOM = document.createElement("SCRIPT");
                  scriptDOM.onload = function (pEvent) {
                    loadingFiles[this.getAttribute("src")].resolve();
                  };
                  scriptDOM.onerror = function (pEvent) {
                    var url = this.getAttribute("src");
                    var errorObject = {
                      error_code: "failed_loading",
                      error: "failed dynamically loading file " + url
                    };
                    if (typeof url === "string" && url.length > 0) {
                      loadingFiles[url].reject(errorObject);
                    }
                    console.error("failed dyanamically loading file " + url);
                  };
                  scriptDOM.setAttribute("src", jsLinks[j].src);
                  if (jsLinks[j].charset !== undefined) {
                    scriptDOM.setAttribute("charset", jsLinks[j].charset);
                  }
                  for (var linkAttribute in jsLinks[j]) {
                    if (typeof linkAttribute === "string" && linkAttribute.startsWith("data-")) {
                      scriptDOM.setAttribute(linkAttribute, jsLinks[j][linkAttribute]);
                    }
                  }
                  document.head.appendChild(scriptDOM);
                  defs.push(callDef.promise);
                }
              }
            }
          }
        }
        if (defs.length === 0) {
          return false;
        }
        return Promise.all(defs);
      }, function (pError) {
        console.error(pError);
        return Promise.reject(pError);
      });
    } else {
      console.warn("no elements found to load");
      return false;
    }
  },
  getCurrentHTMLPage: function getCurrentHTMLPage() {
    if (this.HTMLPage === undefined) {
      return null;
    }
    return this.HTMLPage.clone();
  },
  /**
   * @description make a html from the HTMLPage object ans save it to the backend
   * @function
   * @name HTMLPageHandler.saveHTMLPage
   * @param {HTMLPage_or_json} pHtmlPage
   * @param {String} pUIMode undefined or "nebula", this is the name of the ui mode
   * @param {Number} pMinimalVersionNumber the minimal pagebuilder version, to start calc one, 
   * use undefined for the Constants.minVersion and "current" to use the one defined in the HTMLPage
   * @param {Object} pSaveOptions url options to provide to the upload url, overwrite:true, create_folders: true
   * @param {pProgressCB} a progress callback function
   * @return {Deferred}
   */
  saveHTMLPage: function saveHTMLPage(pHtmlPage, pUIMode, pMinimalVersionNumber, pSaveOptions, pProgressCB) {
    // get htmlpage object
    var savingError = {};
    var htmlPage;
    if (pHtmlPage instanceof HTMLPage) {
      htmlPage = pHtmlPage;
    } else if (pHtmlPage && _typeof(pHtmlPage) === "object" && !Array.isArray(pHtmlPage)) {
      htmlPage = HTMLPage.fromJSON(pHtmlPage);
    } else {
      throw new Error("parameter pHtmlPage has wrong interface");
    }
    this.HTMLPage = htmlPage;
    // set the UI mode
    if (pUIMode !== undefined) {
      this.HTMLPage.setUIMode(pUIMode);
    }
    // wait some time before activating it
    // if (this.HTMLPage.getLayout() !== null) {
    //     this.HTMLPage.getLayout().compress();
    // }
    if (this.HTMLPage.getLayout().getType() === "tableGrid") {
      this.HTMLPage.getLayout().compress();
    }
    // the minimal pagebuilder version, to use for calc
    if (pMinimalVersionNumber === undefined) {
      pMinimalVersionNumber = Constants.minVersionNumber;
    } else if (pMinimalVersionNumber === "current") {
      pMinimalVersionNumber = this.HTMLPage.getVersion();
    }
    var that = this;
    var componentNames = this._getComponentNames(this.HTMLPage);
    var extraIncludes = this._getExtraIncludes(componentNames, this.HTMLPage.getUIMode());
    var calcVersion = this._calcVersion(pMinimalVersionNumber, {
      htmlPage: this.HTMLPage,
      elements: this.HTMLPage.getElements(),
      componentNames: componentNames
    });
    var contentHtml = "";
    contentHtml += "<html>\r\n";
    // add header
    contentHtml += "\t<head>\r\n";
    //  add title
    if (typeof this.HTMLPage.getTitle() === "string") {
      contentHtml += "\t\t<title>" + escape(this.HTMLPage.getTitle()) + "</title>\r\n";
    } else {
      contentHtml += "\t\t<title> </title>\r\n";
    }
    var scriptContent = that._generateGeneralScript(this.HTMLPage);
    //  add metadata tags
    contentHtml += that._generateMetaTags(this.HTMLPage, hashSHA(scriptContent));
    //  add links to stylesheets
    contentHtml += that._generateStyleSheetTags(extraIncludes.cssLinks, this.HTMLPage.getStyleProfile(), this.HTMLPage.getStyleURL(), this.HTMLPage.needRelativePaths(), this.HTMLPage.getRelativebasePath(), this.HTMLPage.getUIMode());
    //  add general js links
    contentHtml += that._generateJavascriptTags(extraIncludes.jsLinks, calcVersion, this.HTMLPage.getUIMode());
    if (typeof scriptContent === "string" && scriptContent.length > 0) {
      contentHtml += "\t\t<script>" + scriptContent + "</script>\r\n";
    } else if (scriptContent !== undefined && scriptContent !== null && scriptContent.error !== undefined) {
      savingError = scriptContent;
    } else {
      throw new Error("script content was not a string");
    }
    contentHtml += "\t</head>\r\n";
    // add body
    contentHtml += "\t<body>\r\n";
    contentHtml += that._generateBody(this.HTMLPage, this.HTMLPage.getUIMode());
    contentHtml += "\t</body>\r\n";
    // add ending html
    contentHtml += "</html>";

    // first add config blob
    var contentConfig = "<!--\r\n";

    // update the version number
    this.HTMLPage.setVersion(calcVersion);
    // update the md5 hash to the new content
    this.HTMLPage.setHash(hex_md5(contentHtml));
    contentConfig += "\t" + JSON.stringify(this.HTMLPage.toJSON(), function (key, value) {
      if (typeof value === "function") {
        console.error("could not convert function to htmlpage config JSON");
        savingError = {
          error_code: "contains_function",
          error: "the page could not be saved correctly"
        };
      } else if (typeof value === "string" && value.length > 2) {
        // decode the --> because this caused crashing pagebuilder, the comment stops and a part of the comment becomes content
        return value.replace(/--([\\]+)>/g, "--$1$1>").replace(/-->/g, "--\\>");
      }
      return value;
    }, "\t").replace(newLineRegExp, "\n\t");
    contentConfig += "\r\n-->\r\n";
    var endString = "\uFEFF" /* add BOM for ff */ + "<!DOCTYPE html>\r\n" + contentConfig + contentHtml;
    if (typeof pProgressCB === "function") {
      pProgressCB(savingError);
    }
    // save to backend
    var outdef = that.saveString(endString, pSaveOptions, {
      version: calcVersion
    });
    return outdef.notify(savingError);
  },
  _getComponentNames: function _getComponentNames(pHTMLPage) {
    var componentNames = [];
    var formElements = pHTMLPage.getElements().getElements();
    for (var i = 0; i < formElements.length; i++) {
      componentNames.push(formElements[i].getElement().getType());
      // we can now also open new components from actions, so loop over the actions to detect new components to be added
      if (formElements[i].hasActions() === true) {
        // get array of actions
        var actions = formElements[i].getActionList().getActions();
        // loop over the actions
        for (var j = 0; j < actions.length; j++) {
          // only if it is a page action
          if (actions[j].getType() === "jqueryEventPageTrigger") {
            // get the specific function to be applied when action is triggered
            var actionFunctions = actions[j].getParameters().getActionFunctions();
            if (Array.isArray(actionFunctions) && actionFunctions.length > 0) {
              for (var af = 0; af < actionFunctions.length; af++) {
                componentNames = componentNames.concat(actionFunctions[af].getExternalResouceComponentNames());
              }
            }
          }
        }
      }
      if (formElements[i].getElement().getType() === "CustomPageComponentContainer") {
        var containerOptions = formElements[i].getElement().getOptions();
        var subHTMLPageJSON = CloudflowObject.getParameter(containerOptions, "contentOptions.HTMLPageJSON");
        if (subHTMLPageJSON && _typeof(subHTMLPageJSON) === "object" && !Array.isArray(subHTMLPageJSON) && Object.keys(subHTMLPageJSON).length > 0) {
          var subComponentNames = this._getComponentNames(HTMLPage.fromJSON(subHTMLPageJSON));
          componentNames = componentNames.concat(subComponentNames);
          // remove doubles
          componentNames = _.uniq(componentNames);
        }
      }
    }
    // remove doubles
    componentNames = _.uniq(componentNames);
    return componentNames;
  },
  _generateMetaTags: function _generateMetaTags(pHTMLPage, pMainScriptHash) {
    var content = "";
    content += '\t\t<meta charset="UTF-8">\r\n';
    content += '\t\t<meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover">\r\n';
    content += '\t\t<meta name="generator" content="' + this.pagecreator + '">\r\n';
    if (pHTMLPage.hasDescription()) {
      content += '\t\t<meta name="description" content="' + escape(pHTMLPage.getDescription()) + '">\r\n';
    }
    if (pHTMLPage.hasFavicon()) {
      var href;
      var linkType = "image/x-icon";
      var cloudflowURLHref = new CloudflowURL(pHTMLPage.getFavicon());
      if (pHTMLPage.needRelativePaths() && pHTMLPage.hasRelativebasePath()) {
        cloudflowURLHref = new CloudflowURL(pHTMLPage.getRelativebasePath(), pHTMLPage.getFavicon());
        href = cloudflowURLHref.getUploadPath();
      } else {
        if (CloudflowURL.isRelativePath(pHTMLPage.getFavicon()) || pHTMLPage.needRelativePaths()) {
          href = cloudflowURLHref.getRelativeUploadPath(this.url);
        } else {
          href = cloudflowURLHref.getUploadPath();
        }
      }
      if (href.toLowerCase().endsWith(".gif")) {
        linkType = "image/gif";
      } else if (href.toLowerCase().endsWith(".png")) {
        linkType = "image/png";
      } else if (href.toLowerCase().endsWith(".svg")) {
        linkType = "image/svg";
      }
      var version = "";
      if (href.includes("?") === false) {
        version = "?v=" + +new Date();
      }
      content += '\t\t<link rel="icon" type="' + linkType + '" href="' + escape(href) + version + '" />\r\n';
    }
    if (pHTMLPage.hasThemeColor()) {
      content += '\t\t<meta name="theme-color" content="' + pHTMLPage.getThemeColor() + '">\r\n';
    }
    pHTMLPage.updateModification();
    content += '\t\t<meta http-equiv="last-modified" content="' + pHTMLPage.getModification() + '">\r\n';
    if (pHTMLPage.hasManifest()) {
      var manifestResource = pHTMLPage.getManifest();
      if (typeof manifestResource === "string") {
        content += '\t\t<link rel="manifest" href="' + manifestResource + '" crossorigin="use-credentials" />\r\n';
      }
    }
    if (pHTMLPage.hasExternalMetatags()) {
      var externalMetatags = pHTMLPage.getExternalMetatags();
      if (typeof externalMetatags === "string") {
        content += '\t\t<meta name="nixps.editor_metadata" content="' + escape(externalMetatags) + '">\r\n';
      }
    }
    if (pHTMLPage.hasSecurityOptions()) {
      var securityOptions = pHTMLPage.getSecurityOptions();
      if (securityOptions.csp === true) {
        if (pMainScriptHash === null) {
          console.error("big issue!!, we did not recieve a correct hash");
        }
        var defaultSource = "";
        var scriptSource = "";
        var childSource = "";
        if (securityOptions.csp_allow_youtube !== false) {
          childSource += " https://www.youtube-nocookie.com";
        }
        if (securityOptions.csp_allow_twitter !== false) {
          defaultSource += " *.twitter.com *.x.com";
          scriptSource += " https://platform.twitter.com";
          childSource += " https://x.com *.x.com *.twitter.com";
        }
        if (securityOptions.csp_allow_powerbi !== false) {
          scriptSource += " https://app.powerbi.com";
          childSource += " https://app.powerbi.com";
        }
        content += '\t\t<meta http-equiv="Content-Security-Policy" content="default-src \'self\' \'unsafe-eval\'' + defaultSource + ' http://127.0.0.1:9091/; script-src \'unsafe-eval\' \'self\' \'' + pMainScriptHash + '\'' + scriptSource + ' http://127.0.0.1:9091/; font-src \'self\' data:; style-src \'self\' \'unsafe-inline\'; img-src \'self\' data: *; media-src \'self\' *; worker-src \'self\' blob:; child-src \'self\'' + childSource + ';"';
        content += "/>\r\n";
        // content += ' report-to http://localhost:9090.cgi/logging/trace/log />\r\n';
      }
    }

    return content;
  },
  _generateStyleSheetTags: function _generateStyleSheetTags(pExtraCssLinks, pStyleProfile, pStyleURL, pMakeStyleURLRelative, pRelativebasePath, pUIMode) {
    var content = "";
    content += "\t\t<link type=\"text/css\" href=\"/3rdParty/font-awesome-4.4.0/css/font-awesome.css\" rel=\"stylesheet\"/>\r\n";
    if (pUIMode !== "nebula") {
      content += "\t\t<link type='text/css' href='/3rdParty/bootstrap-3.1.1-dist/css/bootstrap-grid.css' rel='stylesheet'/>\r\n";
      content += "\t\t<link type='text/css' href='/3rdParty/bootstrap-3.1.1-dist/css/bootstrap-prefix.css' rel='stylesheet'/>\r\n";
    }
    content += "\t\t<link type=\"text/css\" href=\"/3rdParty/bootstrap-datetimepicker/css/bootstrap-datetimepicker.css\" rel=\"stylesheet\"/>\r\n";
    if (pUIMode === "nebula") {
      content += "\t\t<link type=\"text/css\" href=\"/pagebuilder/nebulacss/nixps-cloudflow-generalForCustom.css\" rel=\"stylesheet\"/>\r\n";
    } else {
      content += "\t\t<link type='text/css' href='/common/FreezeOverlay/css/nixps-FreezeOverlay.css' rel='stylesheet'/>\r\n";
      content += "\t\t<link type='text/css' href='/common/Dialog/css/nixps-Dialog.css' rel='stylesheet'/>\r\n";
      content += "\t\t<link type='text/css' href='/pagebuilder/css/nixps-cloudflow-generalForCustom.css' rel='stylesheet'/>\r\n";
    }
    if (Array.isArray(pExtraCssLinks) && pExtraCssLinks.length > 0) {
      for (var i = 0; i < pExtraCssLinks.length; i++) {
        if (typeof pExtraCssLinks[i] === "string" && pExtraCssLinks[i].length > 0) {
          content += "\t\t<link type=\"text/css\" href=\"" + pExtraCssLinks[i] + "\" rel=\"stylesheet\"/>\r\n";
        }
      }
    }
    if (pUIMode === "nebula") {
      content += "\t\t<link type=\"text/css\" href=\"/dist/pagebuilder/nebula/nebulaframework.css\" rel=\"stylesheet\"/>\r\n";
      content += "\t\t<link type=\"text/css\" href=\"/portal.cgi?resource=download&amp;url=cfresource%3A%2F%2FStyleSheet%2FCloudflow%2520Light.css&amp;override=true&amp;inline=true\" rel=\"stylesheet\" id=\"CSSVarCloudflowLight\"/>\r\n";
    } else {
      content += "\t\t<link type='text/css' href='/dist/framework/nixps-cloudflow-lightframework.css' rel='stylesheet'/>\r\n";
    }
    if (typeof pStyleURL === "string" && pStyleURL.length > 0) {
      var styleURL;
      var styleCloudflowURL = new CloudflowURL(pStyleURL);
      if (pMakeStyleURLRelative === true && typeof pRelativebasePath === "string" && pRelativebasePath.length > 0) {
        // we have the base given, make a static path 
        styleCloudflowURL = new CloudflowURL(pRelativebasePath, pStyleURL);
        styleURL = styleCloudflowURL.getUploadPath();
      } else if (pMakeStyleURLRelative === true) {
        // if we need relative paths starting from the current page
        styleURL = styleCloudflowURL.getRelativeUploadPath(this.url);
      } else {
        // just fix lang upload path
        styleURL = styleCloudflowURL.getUploadPath();
      }
      content += "\t\t<link type=\"text/css\" href='" + styleURL + "' rel=\"stylesheet\"/>\r\n";
    } else if (typeof pStyleProfile === "string" && pStyleProfile.length > 0) {
      // old previous way of doing, this refers to fix folder on disk, so do nohting
      var filestoreName = "PP_FILE_STORE";
      if (this.url.indexOf("cloudflow://") === 0) {
        // retrieve current filestore
        var url_without_beginning = this.url.slice(12);
        filestoreName = url_without_beginning.slice(0, url_without_beginning.indexOf("/"));
      }
      content += "\t\t<link type=\"text/css\" href=\"/portal.cgi/" + escape(filestoreName) + "/PageBuilder/Styles/" + escape(pStyleProfile) + ".css\" rel=\"stylesheet\"/>\r\n";
    }
    return content;
  },
  _generateJavascriptTags: function _generateJavascriptTags(pExtraJsLinks, pBuildVersion, pUIMode) {
    var content = "";
    content += "\t\t<script type=\"text/javascript\" src=\"/dist/pagebuilder/3rdParty.client.js\"></script>\r\n";
    content += "\t\t<script type=\"text/javascript\" src=\"/portal.cgi?api=js\"></script>\r\n";
    if (pUIMode !== "nebula") {
      content += "\t\t<script type='text/javascript' src='/portal/js/nixps-portal-api.js'></script>\r\n";
    }
    if (typeof pBuildVersion !== "number" || pBuildVersion < 0) {
      pBuildVersion = "0";
    }
    content += "\t\t<script type=\"text/javascript\" src=\"/pagebuilder/js/nixps-cloudflow-CheckVersionNumber.js?" + pBuildVersion + "\"></script>\r\n";
    if (Array.isArray(pExtraJsLinks)) {
      for (var i = 0; i < pExtraJsLinks.length; i++) {
        if (typeof pExtraJsLinks[i] === "string" && pExtraJsLinks[i].length > 0) {
          content += "\t\t<script type='text/javascript' src='" + pExtraJsLinks[i] + "'></script>\r\n";
        } else if (pExtraJsLinks[i] && _typeof(pExtraJsLinks[i]) === "object" && !Array.isArray(pExtraJsLinks[i])) {
          content += "\t\t<script type='text/javascript' ";
          for (var attrName in pExtraJsLinks[i]) {
            content += " " + attrName + "='" + pExtraJsLinks[i][attrName] + "' ";
          }
          content += "></script>\r\n";
        }
      }
    }
    if (pUIMode === "nebula") {
      content += "\t\t<script type=\"text/javascript\" src=\"/dist/pagebuilder/nixps-nebulapagebuilderframework.js\"></script>\r\n";
    } else {
      content += "\t\t<script type='text/javascript' src='/dist/framework/nixps-cloudflow-framework.js'></script>\r\n";
    }
    return content;
  },
  _generateGeneralScript: function _generateGeneralScript(pHtmlPage) {
    if (pHtmlPage instanceof HTMLPage === false) {
      throw new Error('parameter must be of type HTMLPage');
    }
    var timetracker = pHtmlPage.hasOnloadAfterdrawActions();
    var expressionToJS = new ExpressionToJS({});
    var expressions = [];
    var extraparameters = "";
    var parentFolder = this.url.slice(0, this.url.lastIndexOf('/') + 1);
    // handle translations
    if (pHtmlPage.hasExtraTranslation() === true) {
      extraparameters = ", translations: [{path:";
      var translationPath = pHtmlPage.getExtraTranslationPath();
      if (typeof translationPath === "string" && translationPath.length > 0) {
        // translationPath is normaly always a cloudflow fixed pad, but for some old 
        // files it is already relative
        var translationCloudflowPath = new CloudflowURL(parentFolder, translationPath);
        var finalTranslationPath;
        if (pHtmlPage.needRelativePaths() === true && pHtmlPage.hasRelativebasePath()) {
          // special case we have fixed relativebasepath , make static path
          translationCloudflowPath = new CloudflowURL(pHtmlPage.getRelativebasePath(), translationPath);
          finalTranslationPath = translationCloudflowPath.getUploadPath();
        } else if (pHtmlPage.needRelativePaths() === true) {
          finalTranslationPath = translationCloudflowPath.getRelativeUploadPath(this.url);
        } else {
          finalTranslationPath = translationCloudflowPath.getUploadPath();
        }
        extraparameters += "'" + finalTranslationPath + "'";
      } else {
        throw new Error("incorrect translation object found");
      }
      var templateFileName = pHtmlPage.getExtraTranslationFileTemplate();
      if (typeof templateFileName === "string" && templateFileName.length > 0) {
        extraparameters += ", templateFileName:'" + templateFileName + "'";
      }
      extraparameters += "}]";
    }
    // handle context for "default"
    if (pHtmlPage.hasDefaultContext()) {
      extraparameters += ", contextIfNothingDefined: " + JSON.stringify(pHtmlPage.getDefaultContext());
    }
    if (pHtmlPage.hasServiceWorker()) {
      var serviceWorkerPath = pHtmlPage.getServiceWorker();
      var finalServiceWorkerPath;
      var serviceWorkerCloudflowPath = new CloudflowURL(parentFolder, serviceWorkerPath);
      if (pHtmlPage.needRelativePaths() === true && pHtmlPage.hasRelativebasePath()) {
        // special case we have fixed relativebasepath , make static path
        serviceWorkerCloudflowPath = new CloudflowURL(pHtmlPage.getRelativebasePath(), serviceWorkerPath);
        finalServiceWorkerPath = serviceWorkerCloudflowPath.getUploadPath();
      } else if (pHtmlPage.needRelativePaths() === true) {
        finalServiceWorkerPath = serviceWorkerCloudflowPath.getRelativeUploadPath(this.url);
      } else {
        finalServiceWorkerPath = serviceWorkerCloudflowPath.getUploadPath();
      }
      extraparameters += ", serviceWorkerURL: \"" + finalServiceWorkerPath + "\"";
    }
    var externalFileReferences = pHtmlPage.getExternalFileURLs(this.url);
    var elements = pHtmlPage.getElements().getElements();
    var content = "\r\n";
    content += "\t$(function() {\r\n";
    content += "\t\tportal_api_base.prototype.session_expired = function() {\r\n";
    content += "\t\t\twindow.location = \"/?orig=\" + encodeURIComponent(location.pathname + location.search + location.hash);\r\n";
    content += "\t\t};\r\n";
    content += "\t\tif (!window.nixps) {window.nixps = {};}\r\n";
    content += "\t\tif (!nixps.cloudflow) {nixps.cloudflow = {};}\r\n";
    content += "\t\tif (!nixps.cloudflow.ActionsImmunity) {nixps.cloudflow.ActionsImmunity = function(){return {enterAction: function(){},leaveAction: function(){}};};} // time traveling suite\r\n";
    content += "\t\tif (!nixps.cloudflow.ExpressionToJS) {var scriptExpl=document.createElement(\"SCRIPT\");scriptExpl.type=\"text/javascript\";scriptExpl.src=\"/pagebuilder/js/nixps-cloudflow-ExpressionToJS.js\";document.head.appendChild(scriptExpl);}\r\n"; // if not exist then we are in older cloudflow, load old page that has been removed 
    content += "\t\tif (!nixps.cloudflow.WhitepaperConnection) {var scriptWC=document.createElement(\"SCRIPT\");scriptWC.type=\"text/javascript\";scriptWC.src=\"/dist/pagebuilder/standalone/nixps-cloudflow-WhitepaperConnection.js\";document.head.appendChild(scriptWC);}\r\n"; // if not exist then we are in older cloudflow, load old page that has been removed 
    content += "\t\tnixps.pagebuilderPage = {};\r\n";
    content += "\t\tvar freezeOverlay = $(\"<div>\").addClass(\"onstartup\").FreezeOverlay(" + JSON.stringify(Object.assign(pHtmlPage.getWaitingOptions(), {
      useFlex: true,
      show: true
    })) + ");\r\n";
    content += "\t\t$(\"body\").prepend(freezeOverlay);\r\n";
    if (externalFileReferences.length > 0) {
      content += "\t\tvar externalReferencesDefs = [];\r\n";
      for (var i = 0; i < externalFileReferences.length; i++) {
        content += "\t\texternalReferencesDefs.push(fetch(\"" + escape(externalFileReferences[i].uploadURL) + "\",{\"method\":\"POST\",\"headers\":{\"Content-Type\":\"application/json\"}}).then(function(e){return e.json();}));\r\n";
      }
      extraparameters += ", externalTailOutput: [Promise.all(externalReferencesDefs)]";
    }
    // if (false) {
    //     extraparameters += ", badgeNumberConfiguration: " + ;
    // }
    content += "\t\tnixps.cloudflow.Init({output: [\"user\", \"license\", \"context\", \"consent\", \"host\"]" + extraparameters + "}, function(pUserPref, pUser, pLicense, pContext, pConsent, pHost, pExternalFiles) {\r\n";
    if (pHtmlPage.hasAccessRestrictions()) {
      if (pHtmlPage.getAccessRestrictions().admin_only === true) {
        content += "\t\t\tif ( pUser.hasAdminPermissions() === false ) {\r\n";
        content += "\t\t\tnixps.cloudflow.LogListener.addLog({event_type: \"error\", details_data: {error_code: \"wrong_access_permissions\", error: \"The user has the wrong access permissions\"}});\r\n";
        content += "\t\t\twindow.location = \"/\"; return;}\r\n";
      }
      if (Array.isArray(pHtmlPage.getAccessRestrictions().user_attributes) && pHtmlPage.getAccessRestrictions().user_attributes.length > 0) {
        content += "\t\t\tif (";
        for (var i = 0; pHtmlPage.getAccessRestrictions().user_attributes.length > i; i++) {
          if (typeof pHtmlPage.getAccessRestrictions().user_attributes[i] === "string" && pHtmlPage.getAccessRestrictions().user_attributes[i].indexOf("</script>") >= 0) {
            return {
              "error_code": "invalid_content",
              "error": "contains invalid content"
            };
          }
          if (i === pHtmlPage.getAccessRestrictions().user_attributes.length - 1) {
            content += "( pUser.getAttributesName().includes(\"" + escape_doublequotes(pHtmlPage.getAccessRestrictions().user_attributes[i]) + "\") === false)";
          } else {
            content += "( pUser.getAttributesName().includes(\"" + escape_doublequotes(pHtmlPage.getAccessRestrictions().user_attributes[i]) + "\") === false) &&";
          }
        }
        content += ") {\r\n";
        content += "\t\t\tnixps.cloudflow.LogListener.addLog({event_type: \"error\", details_data: {error_code: \"wrong_access_permissions\", error: \"The user has the wrong access permissions\"}});\r\n";
        content += "\t\t\twindow.location = \"/\"; return;}\r\n";
      }
      if (typeof pHtmlPage.getAccessRestrictions().user_permission === "string" && pHtmlPage.getAccessRestrictions().user_permission.length > 0) {
        content += "\t\t\tif ( pUser.hasPermission(\"" + escape(pHtmlPage.getAccessRestrictions().user_permission) + "\") === false ) {\r\n";
        content += "\t\t\tnixps.cloudflow.LogListener.addLog({event_type: \"error\", details_data: {error_code: \"wrong_access_permissions\", error: \"The user has the wrong access permissions\"}});\r\n";
        content += "\t\t\twindow.location = \"/\"; return;}\r\n";
      }
      if (typeof pHtmlPage.getAccessRestrictions().license === "string" && pHtmlPage.getAccessRestrictions().license.length > 0) {
        content += "\t\t\tif ( pLicense.check(\"" + escape(pHtmlPage.getAccessRestrictions().license) + "\") === false ) {\r\n";
        content += "\t\t\tnixps.cloudflow.LogListener.addLog({event_type: \"error\", details_data: {error_code: \"wrong_access_permissions\", error: \"The user has the wrong access permissions\"}});\r\n";
        content += "\t\t\twindow.location = \"/\"; return;}\r\n";
      }
    }
    content += "\t\t\tnixps.cloudflow.LogListener.addLog({event_type: \"open_page\", details_data: pContext.getData(), debug: typeof pContext.getDebugData === \"function\" && pContext.getDebugData()});\r\n";
    content += "\t\t\t$(\"body > .nixps-FreezeOverlay\").removeClass(\"onstartup\").FreezeOverlay(\"hide\");\r\n";
    // content += "\t\t\tdocument.querySelectorAll(\"body > #freezeOverlay\").forEach(function(e){e.classList.remove("cf-freezeOverlay-transparent");e.classList.add("cf-hide","cf-freezeOverlay-classic")});\r\n";
    content += "\t\t\t$(\"body\").Dialog();\r\n";
    content += "\t\t\t$(\"body\").append($(\"<div>\").NotifyArea({}));\r\n";
    if (pHtmlPage.hasOfflineMessage()) {
      var offlineMessageOptions = pHtmlPage.getOfflineMessage();
      var offlineTranslationKey = offlineMessageOptions.text || "nixps-cloudflow-pagebuilder.error_offline";
      content += "\t\t\tdocument.querySelectorAll(\"body > .cf-show-offline.cf-notify-message\").textContent = $.i18n._(\"" + offlineTranslationKey + "\");\r\n";
    }
    content += "\t\t\tnixps.pagebuilderPage.UIMode = \"" + escape(pHtmlPage.getUIMode()) + "\";\r\n";
    content += "\t\t\tnixps.pagebuilderPage.actionsImmunity = new nixps.cloudflow.ActionsImmunity(undefined, function(pAbortData){\r\n";
    content += "\t\t\t\t$(\".nixps-NotifyArea\").NotifyArea(\"createMessage\",\"closeable-error\", $.i18n._(\"nixps-cloudflow-pagebuilder.error_abordactions_title\"), $.i18n._(\"nixps-cloudflow-pagebuilder.error_abordactions_message_\" + pAbortData.reasonID), 60000);\r\n";
    content += "\t\t\t});\r\n";
    content += "\t\t\tvar expressionUtil = new nixps.cloudflow.ExpressionToJS(pContext, pUser, pUserPref);\r\n";
    if (externalFileReferences.length > 0) {
      content += "\t\t\tvar scopedVariableHandlers = {\r\n";
      for (var i = 0; i < externalFileReferences.length; i++) {
        content += "\t\t\t\t\"" + externalFileReferences[i].originalURL + "\": pExternalFiles[" + i + "],\r\n";
      }
      content += "\t\t\t}\r\n";
    } else {
      content += "\t\t\tvar scopedVariableHandlers = {};\r\n";
    }
    content += this._generateOnloadActions(pHtmlPage);
    if (pHtmlPage.hasOnloadBeforedrawActions()) {
      content += "\t\t\tvar customBeforeDrawEvent = $.Event(\"nixpsBeforeDraw\");\r\n";
      content += "\t\t\t$(\"body\").trigger(customBeforeDrawEvent);\r\n";
      content += "\t\t\tPromise.allSetteld([beforeDrawActionsFc(customBeforeDrawEvent, {isEmbeddedPage:false})]).then(function(){\r\n";
    }
    var title = pHtmlPage.getTitle();
    if (Array.isArray(title) && title.length > 0) {
      content += "\t\t\tdocument.title = expressionUtil.applyToValue(" + JSON.stringify(title) + ");\r\n";
    }
    if (timetracker) {
      content += "\t\t\tvar mainTimerQueue = new nixps.cloudflow.DoneQueue();\r\n";
    }
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].getType() === "component") {
        var component = elements[i].getElement();
        var options = {}; // use empty object when no options are defined
        if (component.getOptions() !== undefined) {
          options = Object.assign({}, component.getOptions()); // make copy to prevent changing options itself
          for (var key in options) {
            if (Object.hasOwn(options, key)) {
              var value = options[key];
              if (typeof value === "function") {
                component.getOptions()[key] = "<function>";
              }
              // if keys contains ${ or < or > then they can be wrongly replaced be the next code (replacers)
              if (typeof key === "string") {
                if (key.indexOf("${") > -1) {
                  throw new Error("invalid key interface, key may not contain ${ as characters");
                } else if (key.indexOf("<") > -1) {
                  throw new Error("invalid key interface, key may not contain < as characters");
                } else if (key.indexOf(">") > -1) {
                  throw new Error("invalid key interface, key may not contain < as characters");
                }
              }
            }
          }
          if (typeof options.language === "string") {
            options.language = "<language>";
          }
          var results = expressionToJS.applyOnObjectCallBack(options, function (pExpressions) {
            expressions.push(pExpressions);
            return "<expression" + (expressions.length - 1) + ">";
          }, function () {});
          options = results.translatedObject;
          if (elements[i].hasActions()) {
            var componentLayoutInfo = elements[i].getActionList().getComponentLayoutInfo();
            if (Array.isArray(componentLayoutInfo) && componentLayoutInfo.length > 0) {
              options.eventtriggerLayoutInfo = componentLayoutInfo;
            }
          }
          if (timetracker) {
            options.created = "<created>";
          }
        }
        content += "\t\t\tvar options_" + i + " = ";
        content += JSON.stringify(options, null, "\t").replace(injectOptionsUsernameRegExp, 'username": pUser.getFullName()').replace(injectOptionsEmailRegExp, 'email": pUser.getEmail()').replace(injectOptionsUserRegExp, 'user": pUser').replace(injectOptionsLicenseRegExp, 'license": pLicense').replace(injectOptionsConfigRegExp, 'configID": "' + escape(elements[i].getComponentID()) + '"').replace(injectOptionsLanguageRegExp, 'language": pUserPref.getLanguage()').replace(injectOptionsContextReferenceRegExp, 'context": pContext').replace(injectOptionsConsentReferenceRegExp, 'consent": pConsent').replace(injectOptionsHostReferenceRegExp, 'host": pHost').replace(injectOptionsInEditorReferenceRegExp, 'isInEditor": false').replace(translationsRegExp, '$.i18n._("$1")').replace(injectOptionsRelativeBasePathRegExp, 'relativeBasePath": ' + (pHtmlPage.hasRelativebasePath() ? '"' + pHtmlPage.getRelativebasePath() + '"' : '""')).replace(expressionRegExp, function (match, p1) {
          return 'expressionUtil.applyToValue(' + JSON.stringify(expressions[parseInt(p1)], null, 3) + ', undefined, scopedVariableHandlers)';
        }).replace(contextRegExp, function (match, p1, pContextDataPath, p2, offset, str) {
          var output = 'pContext.getData("' + pContextDataPath + '")';
          if (p1.length === 0) {
            // if it does not start with ", then there is a part before that is a string
            output = '" + ' + output;
          }
          if (p2.length === 0) {
            // if does not end with ", there is a part afterward being a string
            output = output + ' + "';
          }
          return output;
        }).replace('"created": "<created>"', '"created": mainTimerQueue.generateDoneCallBack("' + escape(elements[i].getComponentID()) + '")').replace(injectOptionsEndScriptTag, "*********").replace(newLineRegExp, "\n\t\t\t");
        content += "\r\n";
        if (typeof component.getWidgetFramework() === "string") {
          content += WebFramework.constructOffline(component.getWidgetFramework(), "#" + escape(elements[i].getComponentID()), component.getType(), "options_" + i, {
            linePrefix: "\t\t\t"
          });
        } else {
          // falback in case of unkown webframework
          content += "\t\t\t" + '$("#' + escape(elements[i].getComponentID()) + '").' + component.getType() + "(options_" + i + ");\r\n";
        }
        if (elements[i].hasStyle() === true) {
          content += "\t\t\tdocument.getElementById(\"" + escape(elements[i].getComponentID()) + "\").style=\"" + Object.entries(elements[i].getCSSObject()).reduce(function (a, css) {
            return a += css[0] + ":" + css[1] + ";";
          }, "") + "\";\r\n";
        }
      }
    }
    if (timetracker) {
      content += "\t\t\tmainTimerQueue.informAllDone(function(){\r\n";
      content += "\t\t\t\tconsole.log(\"DoneQueue: drawed done\");\r\n";
      if (pHtmlPage.hasOnloadAfterdrawActions()) {
        content += "\t\t\t\tsetTimeout(function(){\r\n"; // set on timeout to make it async, prevent blocking UI, when error appears  
        content += "\t\t\t\t\tvar customEvent = $.Event(\"nixpsAfterDraw\");\r\n";
        content += "\t\t\t\t\t$(\"body\").trigger(customEvent);\r\n";
        content += "\t\t\t\t\tafterDrawActionsFc(customEvent, {isEmbeddedPage:false});\r\n";
        content += "\t\t\t\t});\r\n";
      }
      content += "\t\t\t});\r\n";
    }
    content += "\t\t\tvar helpFunctions = {};\r\n";
    content += "\t\t\thelpFunctions.enterAction = nixps.pagebuilderPage.actionsImmunity.enterAction.bind(nixps.pagebuilderPage.actionsImmunity);\r\n";
    content += "\t\t\thelpFunctions.leaveAction = nixps.pagebuilderPage.actionsImmunity.leaveAction.bind(nixps.pagebuilderPage.actionsImmunity);\r\n";
    content += this._generateSubActions(pHtmlPage);
    content += this._generateKeyPressActions(pHtmlPage);
    content += this._generateActions(pHtmlPage);
    if (pHtmlPage.hasOnloadBeforedrawActions()) {
      // ending beforedraw 
      content += "\t\t})\r\n";
    }
    content += "\t\t}, function(pError) {\r\n"; // loading error
    content += "\t\t\tdocument.querySelectorAll(\"body > .nixps-FreezeOverlay\").forEach(function(e){e.remove()});\r\n";
    content += "\t\t\tvar debug = undefined;\r\n";
    content += "\t\t\tif (typeof pError.loadDataAndReturnsMe === \"function\") {\r\n";
    content += "\t\t\t\tdebug  = pError.getDebugData();\r\n";
    content += "\t\t\t\tpError = pError.getError();\r\n";
    content += "\t\t\t}\r\n";
    content += "\t\t\tnixps.cloudflow.LogListener.addLog({event_type: \"error\", details_data: pError, debug: debug});\r\n";
    if (pHtmlPage.hasErrorPage() === true) {
      var errorpageurl = pHtmlPage.getErrorPage();
      if (errorpageurl.indexOf("cloudflow://") === 0) {
        // translate from cloudflow paths
        errorpageurl = "/portal.cgi/" + errorpageurl.slice(12);
      }
      content += "\t\t\tvar errorobj = (typeof pError.stack === \"string\") ? pError.toString() : pError;\r\n";
      content += "\t\t\tvar errorjson = encodeURIComponent(JSON.stringify({error:errorobj}));\r\n";
      content += "\t\t\tif (errorjson.length > 2000) { errorjson = encodeURIComponent(JSON.stringify({error:\"\"})); }\r\n";
      content += "\t\t\twindow.location = \"" + escape(errorpageurl) + "?connector=object&collection=&id=\" + errorjson;\r\n";
    } else {
      content += "\t\t\tconsole.error(pError);\r\n";
      content += "\t\t\tvar img=document.createElement(\"IMG\"); img.alt=\"\"; img.src=\"/cloudflow/CloudflowBar/css/images/logo.svg\"; img.style=\"width:200px;height:200px;display:block;margin-left:auto;margin-right:auto;\";\r\n";
      content += "\t\t\tvar title=document.createElement(\"H1\"); title.textContent=\"We can\\'t show the page you\\'re looking for\"; title.style=\"text-align:center;color:rgb(153,153,153);margin:2px 50px;\";\r\n";
      content += "\t\t\tdocument.body.appendChild(img);document.body.appendChild(title);\r\n";
    }
    content += "\t\t}).catch(function(e){\r\n";
    content += "\t\t\tthrow Error(e);\r\n"; // programming error, do retreive after Promise swallow
    content += "\t\t});\r\n";
    // add debug data for cpc triggers
    content += "\t\t$(\"body\").on(\"custompagebuilderrefreshcontainer\", function(pEvent, pData){\r\n";
    content += "\t\t\tconsole.error(\"lost tiggerevent refresh_container found\", pData);\r\n";
    content += "\t\t});\r\n";
    content += "\t\t$(\"body\").on(\"custompagebuilderinternalredirect\", function(pEvent, pData){\r\n";
    content += "\t\t\tconsole.error(\"lost tiggerevent internal_redirect found\", pData);\r\n";
    content += "\t\t});\r\n";
    content += "\t\t$(\"body\").on(\"custompagebuilderclosecontainer\", function(pEvent, pData){\r\n";
    content += "\t\t\twindow.close(); \r\n";
    content += "\t\t});\r\n";
    content += "\t\t$(\"body\").on(\"custompagebuildercustomchange\", function(pEvent, pData){\r\n";
    content += "\t\t\tconsole.error(\"lost tiggerevent custom_change found\", pData);\r\n";
    content += "\t\t});\r\n";
    // ending script 
    content += "\t});\r\n";
    content = content.replace(newLineRegExp, "\n\t\t");
    return content;
  },
  _generateBody: function _generateBody(pHtmlPage, pUIMode) {
    var renderOptions = undefined;
    var gridRenderOptions = undefined;
    if (pUIMode === "nebula") {
      gridRenderOptions = {
        "xsClassName": "cf-col-xs-$1",
        "smClassName": "cf-col-sm-$1",
        "mdClassName": "cf-col-md-$1",
        "lgClassName": "cf-col-lg-$1"
      };
    } else {
      gridRenderOptions = {
        "xsClassName": "col-xs-$1",
        "smClassName": "col-sm-$1",
        "mdClassName": "col-md-$1",
        "lgClassName": "col-lg-$1"
      };
    }
    if (pHtmlPage.getLayout().getType() === "bootstrapGrid") {
      renderOptions = gridRenderOptions;
    } else if (pHtmlPage.getLayout().getType() === "compass") {
      if (pHtmlPage.getLayout().getParameters().getCenter() !== null) {
        if (pHtmlPage.getLayout().getParameters().getCenter().getType() === "bootstrapGrid") {
          renderOptions = {
            centerRenderOptions: gridRenderOptions
          };
        } else if (pHtmlPage.getLayout().getParameters().getCenter().getType() === "tableGrid") {
          gridRenderOptions.disableRefAttribute = true;
          renderOptions = {
            centerRenderOptions: gridRenderOptions
          };
        } else if (pHtmlPage.getLayout().getParameters().getCenter().getType() === "compass") {
          if (pHtmlPage.getLayout().getParameters().getCenter().getParameters().getCenter().getType() === "bootstrapGrid") {
            renderOptions = {
              centerRenderOptions: {
                centerRenderOptions: gridRenderOptions
              }
            };
          } else if (pHtmlPage.getLayout().getParameters().getCenter().getParameters().getCenter().getType() === "tableGrid") {
            gridRenderOptions.disableRefAttribute = true;
            renderOptions = {
              centerRenderOptions: {
                centerRenderOptions: gridRenderOptions
              }
            };
          }
        }
      }
    } else if (pHtmlPage.getLayout().getType() === "tableGrid") {
      renderOptions = {
        disableRefAttribute: true //this is the data attribute for the editor to have extra info - not needed on the actual page
      };
    }

    var layoutRender = $("<div>").LayoutRenderer({
      layout: pHtmlPage.getLayout().toJSON(),
      idAttribute: "id",
      renderOptions: renderOptions
    });
    var formElements = pHtmlPage.getElements();
    var componentPreloadClassesDict = {};
    if (window.api_mock !== undefined && api_mock.component !== undefined && pUIMode === "nebula") {
      var componentNames = _.unique(formElements.getElements().map(function (e) {
        return e.getElement().getType();
      }));
      var validator = new QueryApplier(["name", "in", componentNames, "and", "preload_class", "exists"]);
      api_mock.component.list_with_options_validater(validator, [], ["name", "preload_class"], {}, function (pResults) {
        for (var i = 0; i < pResults.results.length; i++) {
          componentPreloadClassesDict[pResults.results[i].name] = pResults.results[i].preload_class;
        }
      });
    }
    var htmlBody = layoutRender.LayoutRenderer("getHTMLStructure", function (id, element) {
      if (typeof id === "string" && id.length > 0) {
        var elem = formElements.getElementByID(id);
        if (elem !== undefined && elem !== null) {
          var type = elem.getElement().getType();
          if (typeof type === "string" && type.length > 0) {
            element.addClass("type_" + type);
            if (typeof componentPreloadClassesDict[type] === "function") {
              element.addClass(componentPreloadClassesDict[type](elem.getElement().getOptions()));
            }
          }
        }
      }
    });
    if (typeof htmlBody === "string" && htmlBody.length > 0) {
      htmlBody = "\t\t" + htmlBody + "\r\n";
    } else {
      console.error("no html found for body");
      htmlBody = "";
    }
    if (pHtmlPage.hasOfflineMessage()) {
      var offlineMessageOptions = pHtmlPage.getOfflineMessage();
      var offlineTranslationKey = offlineMessageOptions.text || "nixps-cloudflow-pagebuilder.error_offline";
      var offlineClasses = "cf-show-offline cf-hide cf-notify-message" + (offlineMessageOptions.classes || " cf-notify-secondary cf-notify-message-bottom");
      htmlBody += "\t\t<div class=\"".concat(offlineClasses, "\" data-i18n=\"").concat(offlineTranslationKey, "\">We are offline ...</div>\r\n");
    }
    // var waitingText = "";
    // htmlBody = 
    // `<div id="freezeOverlay" class="cf-freezeOverlay cf-freezeOverlay-transparent">`+
    //     `\t<div class="cf-freezeOverlay-center">`+
    // 	    `\t\t<div class="cf-freezeOverlay-waitImage"></div>`+
    // 	    `\t\t<div class="cf-freezeOverlay-waitText">${waitingText}</div>`+
    //     "\t</div>"+
    // "</div>";

    if (typeof htmlBody === "string") {
      return htmlBody;
    } else {
      return "";
    }
  },
  _generateOnloadActions: function _generateOnloadActions(pHTMLPage) {
    var outputString = "";
    if (pHTMLPage.hasOnloadBeforedrawActions()) {
      var actionList = pHTMLPage.getOnloadBeforedrawActions();
      var actions = actionList.getActions();
      var actionFunctions = [];
      for (var i = 0; i < actions.length; i++) {
        if (actions[i].getType() === "jqueryEventPageTrigger") {
          actionFunctions = actionFunctions.concat(actions[i].getParameters().getActionFunctions());
        } else if (actions[i].getType() === "actionFunction") {
          actionFunctions.push(actions[i].getParameters());
        } else {
          console.error("CustompageComponent: unknown action type " + actions[i].getType());
        }
      }
      var outputActionFunctions = [];
      for (var a = 0; a < actionFunctions.length; a++) {
        if (actionFunctions[a].hasPreActionFunction()) {
          outputActionFunctions.push(actionFunctions[a].getPreActionFunction().clone());
        }
        outputActionFunctions.push(actionFunctions[a]);
        if (actionFunctions[a].hasPostActionFunction()) {
          outputActionFunctions.push(actionFunctions[a].getPostActionFunction().clone());
        }
      }
      outputString += "\t\t\tvar beforeDrawActionsFc = function(pEvent, pData) {\r\n";
      outputString += "\t\t\t\tvar pPreviousResults = {};\r\n";
      outputString += '\t\t\t\tnixps.cloudflow.LogListener.addLog({event_type: "start_action", details_data: pData, event_name: "before_draw"});\r\n';
      for (var a = 0; a < outputActionFunctions.length; a++) {
        outputString += this._generateActionFunction(outputActionFunctions[a], a === outputActionFunctions.length - 1, a, {}, "", false);
      }
      outputString += "\t\t\t};\r\n";
    }
    if (pHTMLPage.hasOnloadAfterdrawActions()) {
      var actionList = pHTMLPage.getOnloadAfterdrawActions();
      var actions = actionList.getActions();
      var actionFunctions = [];
      for (var i = 0; i < actions.length; i++) {
        if (actions[i].getType() === "jqueryEventPageTrigger") {
          actionFunctions = actionFunctions.concat(actions[i].getParameters().getActionFunctions());
        } else if (actions[i].getType() === "actionFunction") {
          actionFunctions.push(actions[i].getParameters());
        } else {
          console.error("CustompageComponent: unknown action type " + actions[i].getType());
        }
      }
      var outputActionFunctions = [];
      for (var a = 0; a < actionFunctions.length; a++) {
        if (actionFunctions[a].hasPreActionFunction()) {
          outputActionFunctions.push(actionFunctions[a].getPreActionFunction().clone());
        }
        outputActionFunctions.push(actionFunctions[a]);
        if (actionFunctions[a].hasPostActionFunction()) {
          outputActionFunctions.push(actionFunctions[a].getPostActionFunction().clone());
        }
      }
      outputString += "\t\t\tvar afterDrawActionsFc = function(pEvent, pData) {\r\n";
      outputString += "\t\t\t\tvar pPreviousResults = {};\r\n";
      outputString += '\t\t\t\tnixps.cloudflow.LogListener.addLog({event_type: "start_action", details_data: pData, event_name: "after_draw"});\r\n';
      for (var a = 0; a < outputActionFunctions.length; a++) {
        outputString += this._generateActionFunction(outputActionFunctions[a], a === outputActionFunctions.length - 1, a, {}, "", false);
      }
      outputString += "\t\t\t};\r\n";
    }
    return outputString;
  },
  _generateActions: function _generateActions(pHTMLPage) {
    // reassemple all actions and the linked component id
    var formElements = pHTMLPage.getElements().getElements();
    var bundledActionsByID = [];
    for (var i = 0; i < formElements.length; i++) {
      if (formElements[i].hasActions() === true) {
        bundledActionsByID.push({
          componentID: formElements[i].getComponentID(),
          componentName: formElements[i].getComponentType(),
          actions: formElements[i].getActionList().getActions(),
          elementOptions: formElements[i].getElement().options
        });
      }
    }
    if (bundledActionsByID.length === 0) {
      // short ending if no actions are detected
      return "";
    }
    // the actions are now bundled by component id
    // decouple and make a item per action
    var actionsByID = [];
    var previousEventName = "";
    for (var i = 0; i < bundledActionsByID.length; i++) {
      for (var j = 0; j < bundledActionsByID[i].actions.length; j++) {
        var action = bundledActionsByID[i].actions[j];
        // handle only the known and typicaly page actions
        if (action.getType() === "jqueryEventPageTrigger") {
          var eventname = bundledActionsByID[i].componentID + action.getParameters().getEventName() + action.getParameters().getFilterSelector();
          var extraPreAction = undefined;
          if (bundledActionsByID[i].actions[j].getParameters().getActionFunction().hasPreActionFunction()) {
            extraPreAction = bundledActionsByID[i].actions[j].clone();
            extraPreAction.getParameters().setActionFunction(bundledActionsByID[i].actions[j].getParameters().getActionFunction().getPreActionFunction().clone());
          }
          var extraPostAction = undefined;
          if (bundledActionsByID[i].actions[j].getParameters().getActionFunction().hasPostActionFunction()) {
            extraPostAction = bundledActionsByID[i].actions[j].clone();
            extraPostAction.getParameters().setActionFunction(bundledActionsByID[i].actions[j].getParameters().getActionFunction().getPostActionFunction().clone());
          }
          if (previousEventName === eventname) {
            if (extraPreAction !== undefined) {
              actionsByID[actionsByID.length - 1].actions.push(extraPreAction);
            }
            actionsByID[actionsByID.length - 1].actions.push(bundledActionsByID[i].actions[j]);
            if (extraPostAction !== undefined) {
              actionsByID[actionsByID.length - 1].actions.push(extraPostAction);
            }
          } else {
            var actionsArray = [bundledActionsByID[i].actions[j]];
            if (extraPreAction !== undefined) {
              actionsArray.unshift(extraPreAction);
            }
            if (extraPostAction !== undefined) {
              actionsArray.push(extraPostAction);
            }
            actionsByID.push({
              componentID: bundledActionsByID[i].componentID,
              componentName: bundledActionsByID[i].componentName,
              actions: actionsArray,
              elementOptions: bundledActionsByID[i].elementOptions
            });
            previousEventName = eventname;
          }
        }
      }
    }
    var outputString = "";
    // continue only if there are actions
    if (Array.isArray(actionsByID) && actionsByID.length > 0) {
      for (var i = 0; i < actionsByID.length; i++) {
        // make header of action event function
        // all action has the same name and selector
        var jqueryEventPageTrigger = actionsByID[i].actions[0].getParameters();
        var selector = null;
        var component_css_selector = "#" + escape(actionsByID[i].componentID);
        if (typeof jqueryEventPageTrigger.getFilterSelector() === "string" && jqueryEventPageTrigger.getFilterSelector().length > 0) {
          selector = '"' + jqueryEventPageTrigger.getFilterSelector() + '"';
          component_css_selector += " " + jqueryEventPageTrigger.getFilterSelector();
        }
        outputString += '\t\t\t$("#' + escape(actionsByID[i].componentID) + '").on("' + jqueryEventPageTrigger.getEventName() + '",' + selector + ', ' + "function(pEvent, pData){\r\n";
        if (jqueryEventPageTrigger.hasTargetCheck() === true) {
          if (jqueryEventPageTrigger.getTargetCheckType() === "findUUID") {
            outputString += "\t\t\t\tif ($(this).find('" + jqueryEventPageTrigger.getTargetCheckClass() + "').first().add($(this).filter('" + jqueryEventPageTrigger.getTargetCheckClass() + "').first()).attr('data-uuid') !== $(pEvent.target).closest('" + jqueryEventPageTrigger.getTargetCheckClass() + "').attr('data-uuid')) {return undefined;}\r\n";
          } else if (jqueryEventPageTrigger.getTargetCheckType() === "parentsUUID") {
            outputString += "\t\t\t\tif ($(this).find(\"" + jqueryEventPageTrigger.getTargetCheckClass() + "\").add($(this).filter(\"" + jqueryEventPageTrigger.getTargetCheckClass() + "\").first()).map(function(){return $(this).attr(\"data-uuid\")}).get().includes($(pEvent.target).closest(\"" + jqueryEventPageTrigger.getTargetCheckClass() + "\").parents(\"" + jqueryEventPageTrigger.getTargetCheckClass() + "\").attr(\"data-uuid\"))) {return undefined;}\r\n";
          }
        }

        // add init values 
        outputString += '\t\t\t\tvar pPreviousResults = {};\r\n';
        var event_name_options = 'undefined';
        if (typeof jqueryEventPageTrigger.getEventName() === "string" && jqueryEventPageTrigger.getEventName().length > 0 && typeof actionsByID[i].componentName === "string") {
          event_name_options = '{"event_name": "' + jqueryEventPageTrigger.getEventName() + '",';
          var dummyComponent = new Component("123456", actionsByID[i].componentName);
          if (dummyComponent.getWidgetFramework() === WebFramework.type.JQUERY_UI) {
            event_name_options += '"options": $(this).closest(".' + dummyComponent.getWidgetFullName() + '").' + actionsByID[i].componentName + '("option") }';
          } else {
            throw new Error("unsupported web framework " + dummyComponent.getWidgetFramework());
          }
        }
        outputString += '\t\t\t\tnixps.cloudflow.LogListener.addLog({event_type: "start_action", details_data: pData, event_name_options: ' + event_name_options + ", component_name: \"" + actionsByID[i].componentName + "\", component_css_selector: \"" + component_css_selector + '"});\r\n';
        // loop over all actions who are grouped to the same event
        for (var a = 0; a < actionsByID[i].actions.length; a++) {
          outputString += this._generateActionFunction(actionsByID[i].actions[a].getParameters().getActionFunction(), a === actionsByID[i].actions.length - 1, a, {
            componentID: escape(actionsByID[i].componentID),
            component_css_selector: component_css_selector
          }, "", false);
        }
        // add the end of the event function
        outputString += '\r\n\t\t\t});\r\n';
      }
    }
    return outputString;
  },
  _generateActionFunction: function _generateActionFunction(pActionFunction, pIsLastAction, pIndex, pErrorLoggingObj, pAdditionalFailCBStr, pFirstPreviousValueInString, pTransformOutput) {
    pAdditionalFailCBStr = pAdditionalFailCBStr || "";
    pErrorLoggingObj = pErrorLoggingObj || {};
    for (var key in pErrorLoggingObj) {
      pErrorLoggingObj[key] = JSON.stringify(pErrorLoggingObj[key]);
    }
    var outputString = "";
    // stringify the action
    var inputParameterNames = pActionFunction.getInputParameterNames();
    var staticParameters = pActionFunction.getStaticParameters();
    var preparation = "\t\t\t";
    if (pActionFunction.hasPreparations() === true) {
      var actionPreparations = pActionFunction.getPreparations().getVariables();
      for (var j = 0; j < actionPreparations.length; j++) {
        if (actionPreparations[j].getType() === "functionstring") {
          preparation += "\tvar " + actionPreparations[j].getKey() + " = " + detag(actionPreparations[j].getValue()) + "\r\n";
        }
      }
    }
    // only handle preparations vars if we need to pass things
    // for the moment we suppose there is max one inputParameter
    if (Array.isArray(inputParameterNames) && inputParameterNames.length > 0) {
      if (staticParameters && _typeof(staticParameters) === "object" && !Array.isArray(staticParameters)) {
        preparation += "\tvar " + inputParameterNames[0] + " = " + JSON.stringify(staticParameters, function (key, value) {
          if (typeof key === "string" && key.length > 1 && key[0] === "_") {
            return undefined; // filter out all key starting with underscore
          }

          return value;
        }) + ";\r\n";
        preparation = preparation.replace(preparationVariablesRegExp, function (match, pBegin, p1, pEnd, offset, str) {
          if (offset > 1 && pBegin.length > 0 && pEnd.length > 0) {
            return p1;
          } else if (pEnd.length > 0) {
            return "\" + " + p1;
          } else {
            return "\" + " + p1 + " + \"";
          }
        });
        preparation = preparation.replace(inputvariableRegExp, function (match, p1, offset, str) {
          if (offset > 0 && str.length > match.length) {
            if (offset === str.length - match.length) {
              return "\" + pData." + p1;
            } else {
              return "\" + pData." + p1 + " + \"";
            }
          } else if (str.length > match.length) {
            return "pData." + p1 + " + \"";
          } else {
            return "pData." + p1;
          }
        });
        preparation = preparation.replace(allInputvariableRegExp, "pData").replace(translationsRegExp, '$.i18n._("$1")').replace('"<language>"', 'pUserPref.getLanguage()');
      } else {
        preparation += "\tvar " + inputParameterNames[0] + ";\r\n";
      }
    }
    preparation = detag(preparation);
    var runFunctionString = pActionFunction.getFunction().toString();
    if (pIndex === 0) {
      if (typeof pFirstPreviousValueInString !== "string") {
        pFirstPreviousValueInString = "{}";
      }
      outputString += "\t\t\t\tvar previousReturnValue0 = " + pFirstPreviousValueInString + ";\r\n";
    }
    outputString += "\t\t\t\tvar previousReturnValue" + (pIndex + 1) + " = Promise.resolve(previousReturnValue" + pIndex + ").then(function(pPreviousResults){\r\n" + "\t\t\t\tif (pEvent && pEvent.isImmediatePropagationStopped()) { return Promise.reject({error_code:\"aborted\", error:\"Event has been aborted\"}); }\r\n" + preparation.replace(newLineRegExp, "\n\t\t\t\t") + "\t" + removeFunctionCoat(runFunctionString) + "\t}).catch(function(pError){" + "pError||(pError={}); " + "if (!pError.action_index) {" + "pError.action_index=" + (pIndex + 1) + "; " + "console.error(pError); " + "nixps.cloudflow.LogListener.addLog({event_type: \"error\", details_data: pError, component_id: " + pErrorLoggingObj.componentID + ", component_css_selector: " + pErrorLoggingObj.component_css_selector + "}); " + "}" + pAdditionalFailCBStr + "return Promise.reject(pError);});\r\n";
    if (pIsLastAction) {
      if (pTransformOutput === true) {
        outputString += "\t\t\t\tif (window.jQuery && previousReturnValue" + (pIndex + 1) + " && previousReturnValue" + (pIndex + 1) + " instanceof window.jQuery) {\r\n";
        outputString += "\t\t\t\t\treturn {};\r\n";
        outputString += "\t\t\t\t} else {\r\n";
        outputString += "\t\t\t\t\treturn previousReturnValue" + (pIndex + 1) + ";\r\n";
        outputString += "\t\t\t\t}\r\n";
      } else {
        outputString += "\t\t\t\treturn previousReturnValue" + (pIndex + 1) + ";\r\n";
      }
    }
    return outputString;

    // var previousReturnValue0 = {};
    // var previousReturnValue1 = Promise.resolve(previousReturnValue0).then(function(pPreviousResults){}).catch()
    // var previousReturnValue2 = Promise.resolve(previousReturnValue1).then(function(pPreviousResults){}).catch()
    // var previousReturnValue3 = Promise.resolve(previousReturnValue2).then(function(pPreviousResults){}).catch()
    // return previousReturnValue3;
  },

  _generateSubActions: function _generateSubActions(pHTMLPage) {
    var outputString = "";
    var allSubActions = pHTMLPage.getSubActions().clone();
    allSubActions.addActions(pHTMLPage.getAllPrivateSubActions());
    if (allSubActions.hasActions() === false) {
      outputString += "\t\t\thelpFunctions.runSubAction = function(pID) {\r\n";
      outputString += "\t\t\t\tconsole.error(\"SubAction \" + pID + \" called when no SubActions are defined\");\r\n";
      outputString += "\t\t\t\tvar errorObj = {error_code: \"unknown_subAction_id\", error: \"subAction \" + pID + \" called, but no subActions are defined\"};\r\n";
      outputString += "\t\t\t\tnixps.cloudflow.LogListener.addLog({event_type: \"error\", details_data: errorObj});\r\n";
      outputString += "\t\t\t\treturn Promise.reject(errorObj);\r\n";
      outputString += "\t\t\t}\r\n";
      return outputString;
    }
    var actions = allSubActions.getActions();
    var exisingActionIDs = {};
    outputString += "\t\t\thelpFunctions.runSubAction = function(pID, pEvent, pData, pPreviousResults) {\r\n";
    outputString += "\t\t\t\tif (pEvent && pEvent.isImmediatePropagationStopped()) {\r\n";
    outputString += "\t\t\t\t\tconsole.error(\"subPageAction \" + pID + \" aborted\");\r\n";
    outputString += "\t\t\t\t\treturn Promise.reject({error_code:\"aborted\", error:\"subPageAction \" + pID + \" aborted\"});\r\n";
    outputString += "\t\t\t\t}\r\n";
    outputString += "\t\t\t\tif (pPreviousResults === undefined) { pPreviousResults = {}; }\r\n";
    if (actions.length > 0) {
      for (var i = 0; i < actions.length; i++) {
        if (actions[i].getType() !== "subPageAction") {
          throw new Error("only subactions allowed in this section");
        }
        var subAction = actions[i].getParameters();
        // check op duplication
        if (exisingActionIDs[subAction.getID()] !== undefined) {
          console.error("duplicate action_id found " + subAction.getID());
        }
        exisingActionIDs[subAction.getID()] = true;
        outputString += "\t\t\t  " + (i > 0 ? "else " : "") + "if (pID === \"" + subAction.getID() + "\") {\r\n";
        var actionFunctions = subAction.getActionFunctions();
        if (Array.isArray(actionFunctions) && actionFunctions.length > 0) {
          if (subAction.getAccessControl() !== "hidden") {
            outputString += "\t\t\t\tnixps.cloudflow.LogListener.addLog({event_type: \"sub_page_action\", details_data: pData, component_name: \"" + subAction.getName() + "\"});\r\n";
          }
          var outputActionFunctions = [];
          for (var a = 0; a < actionFunctions.length; a++) {
            if (actionFunctions[a].hasPreActionFunction()) {
              outputActionFunctions.push(actionFunctions[a].getPreActionFunction().clone());
            }
            outputActionFunctions.push(actionFunctions[a]);
            if (actionFunctions[a].hasPostActionFunction()) {
              outputActionFunctions.push(actionFunctions[a].getPostActionFunction().clone());
            }
          }
          for (var a = 0; a < outputActionFunctions.length; a++) {
            outputString += this._generateActionFunction(outputActionFunctions[a], a === outputActionFunctions.length - 1, a, {}, "", "pPreviousResults", true);
            outputString += "\r\n";
          }
        }
        outputString += "\t\t\t\t}\r\n";
      }
      outputString += "\t\t\t\telse {\r\n";
      outputString += "\t\t\t\t\tconsole.error(\"unknown subaction id \" + pID + \" found\");\r\n";
      outputString += "\t\t\t\t\tvar errorObj = {error_code: \"unknown_subAction_id\", error:\"subAction \" + pID + \" not defined\"};\r\n";
      outputString += "\t\t\t\t\tnixps.cloudflow.LogListener.addLog({event_type: \"error\", details_data: errorObj});\r\n";
      outputString += "\t\t\t\t\treturn Promise.reject(errorObj);\r\n";
      outputString += "\t\t\t\t}\r\n";
    }
    outputString += "\t\t\t}\r\n";
    return outputString;
  },
  _generateKeyPressActions: function _generateKeyPressActions(pHTMLPage) {
    if (pHTMLPage.hasKeyPressActions() === false) {
      return "";
    }
    var keyPressActions = pHTMLPage.getKeyPressActions();
    var outputString = "";
    for (var i = 0; i < keyPressActions.length; i++) {
      if (keyPressActions[i] !== undefined && keyPressActions[i] !== null && Array.isArray(keyPressActions[i].getKeys()) && keyPressActions[i].getKeys().length > 0) {
        outputString += "\t\t\tMousetrap.bind(" + JSON.stringify(keyPressActions[i].getKeys()) + ", function(pEvent, pKeyCombination) {\r\n";
        outputString += "\t\t\t\tvar pData = {\"key\": pKeyCombination};\r\n";
        outputString += '\t\t\t\tnixps.cloudflow.LogListener.addLog({event_type: "start_action", details_data: pData});\r\n';
        outputString += "\t\t\t\tvar pPreviousResults = {};\r\n";
        var actionFunctions = keyPressActions[i].getActionFunctions();
        var outputActionFunctions = [];
        for (var a = 0; a < actionFunctions.length; a++) {
          if (actionFunctions[a].hasPreActionFunction()) {
            outputActionFunctions.push(actionFunctions[a].getPreActionFunction().clone());
          }
          outputActionFunctions.push(actionFunctions[a]);
          if (actionFunctions[a].hasPostActionFunction()) {
            outputActionFunctions.push(actionFunctions[a].getPostActionFunction().clone());
          }
        }
        for (var a = 0; a < outputActionFunctions.length; a++) {
          outputString += this._generateActionFunction(outputActionFunctions[a], a === outputActionFunctions.length - 1, a, {}, "", true);
        }
        /** @todo is not correct **/
        if (keyPressActions[i].isAbortEvent() === true) {
          outputString += "\t\t\treturn false;\r\n";
        }
        outputString += "\t\t\t});\r\n";
      }
    }
    outputString += "\t\t\tMousetrap.prototype.stopCallback = function (pEvent) {// overrules the save of browser\r\n";
    outputString += "\t\t\t\tif ( pEvent.code === \"KeyS\" ) {\r\n";
    outputString += "\t\t\t\t\treturn false;\r\n";
    outputString += "\t\t\t\t}\r\n";
    outputString += "\t\t\t};\r\n";
    return outputString;
  },
  _getExtraIncludes: function _getExtraIncludes(pComponentNames, pUIMode) {
    // first extract the names of all components we use
    var componentNames = _.uniq(pComponentNames);
    var extraCSS = [],
      extraJS = [];
    // extract the information from the data
    for (var i = 0; i < componentNames.length; i++) {
      extraCSS = extraCSS.concat(ComponentLinks.getStyleSheetsLinks(componentNames[i], pUIMode));
      extraJS = extraJS.concat(ComponentLinks.getJavaScriptLinks(componentNames[i]));
    }
    // remove doubles
    extraCSS = _.uniq(extraCSS);
    extraJS = _.uniq(extraJS);
    return {
      cssLinks: extraCSS,
      jsLinks: extraJS
    };
  },
  _calcVersion: function _calcVersion(pCurrentVersion, pContent) {
    var version = pCurrentVersion;
    // loop over all components
    // in duplication there is no api_mock, but there the version number should be already good
    if (Array.isArray(pContent.componentNames) && pContent.componentNames.length > 0 && window.api_mock !== undefined && api_mock.component !== undefined) {
      var validator = new QueryApplier(["name", "in", pContent.componentNames, "and", "pagebuilder_version", "exists"]);
      api_mock.component.list_with_options_validater(validator, ["pagebuilder_version", "descending"], ["name", "pagebuilder_version"], {}, function (pResults) {
        for (var i = 0; i < pResults.results.length; i++) {
          if (typeof pResults.results[i].pagebuilder_version === "number") {
            if (version < pResults.results[i].pagebuilder_version) {
              version = pResults.results[i].pagebuilder_version;
            }
            // all are descending, no need to go furter
            break;
          }
        }
      });
    }
    var parentUUIDCheckVersion = {
      regExp: /.*actionList\.[0-9]*\.parameters\.targetchecktype$/,
      value: "parentsUUID",
      version: 14
    };
    var conditionalVersion = {
      regExp: new RegExp("{\"type\":\"com\.nixps\.quantum\.conditional\.0\""),
      version: 11
    };
    var multiActionFunctionsVersion = {
      regExp: /.*actionList\.[0-9]*\.parameters\.actionfunctions.*/,
      version: 9
    };
    var calculationVersion = {
      regExp: new RegExp("{\"type\"\:\"com\.nixps\.quantum\.calculations\.0\""),
      version: 9
    };
    var variableVersion = {
      regExp: new RegExp("{\"type\"\:\"com\.nixps\.quantum\.variable\.0\"[^}]*\"source\"\:"),
      version: 7
    };
    var externalReferencesFileVersion = {
      regExp: new RegExp("{\"type\"\:\"com\.nixps\.quantum\.variable\.0\"[^}]*\"source_file\"\:"),
      version: -1
    };
    var objectsToScan = [];
    if (pContent.htmlPage.hasSubActions()) {
      if (version < 17) {
        version = 17;
      }
      objectsToScan.push({
        "actions": pContent.htmlPage.getSubActions().toJSON()
      });
    }
    if (pContent.htmlPage.hasOnloadBeforedrawActions()) {
      if (version < -1) {
        version;
      }
      objectsToScan.push({
        "actions": pContent.htmlPage.getOnloadBeforedrawActions().toJSON()
      });
    }
    if (pContent.htmlPage.hasOnloadAfterdrawActions()) {
      if (version < 17) {
        version = 17;
      }
      objectsToScan.push({
        "actions": pContent.htmlPage.getOnloadAfterdrawActions().toJSON()
      });
    }
    if (pContent.htmlPage.hasKeyPressActions()) {
      if (version < 10) {
        version = 10;
      }
      pContent.htmlPage.getKeyPressActions().forEach(function (keyAction) {
        if (keyAction.getActionFunctions().length > 0) {
          objectsToScan.push(keyAction.toJSON());
        }
      });
    }
    var form = pContent.htmlPage.getElements().toJSON();
    if (form !== undefined && form !== null && _typeof(form) === "object") {
      objectsToScan.push(form);
    }
    if (version < parentUUIDCheckVersion.version) {
      var containsParentsActionChecks = CloudflowObject.contains(objectsToScan, function (key, value) {
        return parentUUIDCheckVersion.regExp.test(key) && value === parentUUIDCheckVersion.value;
      });
      if (containsParentsActionChecks === true) {
        version = parentUUIDCheckVersion.version;
      }
    }
    if (version < multiActionFunctionsVersion.version) {
      var containsMultiActionFunctions = CloudflowObject.contains(objectsToScan, function (key, value) {
        return multiActionFunctionsVersion.regExp.test(key);
      });
      if (containsMultiActionFunctions === true) {
        version = multiActionFunctionsVersion.version;
      }
    }
    var kMaxValueComposerVersion = Math.max(variableVersion.version, externalReferencesFileVersion.version, calculationVersion.version, conditionalVersion.version);
    if (version < kMaxValueComposerVersion) {
      for (var i = 0; i < objectsToScan.length; i++) {
        if (version >= kMaxValueComposerVersion) {
          break;
        }
        var expressionToJS = new ExpressionToJS(objectsToScan[i]);
        expressionToJS.applyOnObjectCallBack(objectsToScan[i], function (pValueComposer) {
          if (version < conditionalVersion.version) {
            if (conditionalVersion.regExp.test(JSON.stringify(pValueComposer))) {
              version = conditionalVersion.version;
            }
          }
          if (version < calculationVersion.version) {
            if (calculationVersion.regExp.test(JSON.stringify(pValueComposer))) {
              version = calculationVersion.version;
            }
          }
          if (version < variableVersion.version) {
            if (variableVersion.regExp.test(JSON.stringify(pValueComposer))) {
              version = variableVersion.version;
            }
          }
          if (version < externalReferencesFileVersion.version) {
            if (externalReferencesFileVersion.regExp.test(JSON.stringify(pValueComposer))) {
              version = externalReferencesFileVersion.version;
            }
          }
        });
      }
    }
    return version;
  },
  /**
   * @description save a string as complete html content to the backend, if content is the same as previous content, it will not save to the backend
   * @function
   * @name HTMLPageHandler.saveString
   * @param {String} pContent
   * @param {Object} pSaveOptions options on how to save (overwrite, ...)
   * @param {Object} pReturnData data to retrun on defered
   * @return {Deferred}
   */
  saveString: function saveString(pContent, pSaveOptions, pReturnData) {
    // first control if we realy need to update
    if (this.content === pContent) {
      return $.Deferred().resolve(pContent);
    }
    // the content is different, update ...
    this.content = pContent;
    //console.log("save with BOM:" + (pContent.charCodeAt(0) === 0xFEFF));
    var that = this;
    return this._saveFile(pContent, pSaveOptions, pReturnData || {}).fail(function (pError) {
      // prevent shortcut when fails
      that.content = "";
      return $.Deferred().reject(pError);
    });
  },
  _saveFile: function _saveFile(pContent, pUploadOptions, pReturnData) {
    if (typeof pContent !== "string") {
      throw new Error("parameter pContent must be a string");
    }
    var uploadOptions = Object.assign({
      overwrite: true,
      create_folders: true
    }, pUploadOptions);
    var upload_url_options = "";
    for (var uploadOption in uploadOptions) {
      upload_url_options += "&" + uploadOption + "=" + uploadOptions[uploadOption];
    }
    if (typeof this.fileEtag === "string" && this.fileEtag.length > 0) {
      if (this.fileEtag.indexOf("mod=") === 0) {
        upload_url_options += "&check_modification=" + this.fileEtag.slice(4);
      } else {
        upload_url_options += "&check_etag=" + this.fileEtag;
      }
    } else if (typeof this.fileModification === "number" || typeof this.fileModification === "string" && this.fileModification.length > 0) {
      upload_url_options += "&check_modification=" + this.fileModification;
    }
    var that = this;
    return $.Deferred(function (pDefer) {
      var lastSlashIndex = that.url.lastIndexOf("/") + 1;
      var filename = decodeURI(that.url.substring(lastSlashIndex)).replaceAll('"', '\\"');
      var folderName = that.url.substring(0, lastSlashIndex);
      var boundary = "----nixpscloudflowpagebuilder" + Date.now();

      // attention keep this header clean,
      // header need to use \r\n for new lines
      // header may not have spaces before or after header keys
      var sendContent = "--" + boundary + '\r\nContent-Type: text/html\r\nContent-Disposition: form-data;filename="' + filename + '"\r\n\r\n' + pContent;
      sendContent = sendContent + "\r\n--" + boundary + "--\r\n";
      var upload_url = "/portal.cgi?asset=upload_file&url=" + encodeURIComponent(folderName) + upload_url_options;
      var req = $.ajax({
        type: "POST",
        url: upload_url,
        data: sendContent,
        dataType: undefined,
        contentType: "text/plain; charset=UTF-8",
        processData: true,
        success: function success(data, pStatus, jqXHR) {
          if (pStatus === "success") {
            if (typeof data === "string" && data.length > 0) {
              try {
                data = JSON.parse(data);
              } catch (e) {
                console.error(e);
                data = [{
                  files: "?"
                }];
              }
            }
            if (Array.isArray(data.files)) {
              if (data.files.length === 1) {
                // etag has been changed, but what is the new value??
                that.fileEtag = "";
                that.fileModification = undefined;
                if (Array.isArray(data.file_info) && data.file_info.length === 1) {
                  if (typeof data.file_info[0].etag === "string") {
                    that.fileEtag = data.file_info[0].etag;
                  }
                  if (typeof data.file_info[0].modification === "number" || typeof data.file_info[0].modification === "string" && data.file_info[0].modification.length > 0) {
                    that.fileModification = data.file_info[0].modification;
                  }
                }
                pDefer.resolve(Object.assign({}, pReturnData || {}, {
                  "url": data.files[0],
                  "content": pContent
                }));
              } else if (data.files.length === 0) {
                // file has been ignored!!!
                pDefer.reject({
                  "error_code": "Document not saved",
                  "error": "saving conflict, the file has been modified by somebody else"
                });
              } else {
                // really strange thing
                pDefer.reject({
                  "error_code": "multiple_files_in_return",
                  "error": "multiple files in return data found " + JSON.stringify(data.files)
                });
              }
            } else {
              // no files in return object
              pDefer.reject({
                "error_code": "files_missing_in_return",
                "error": "missing parameter in return data " + JSON.stringify(data),
                "data": data
              });
            }
          } else {
            // no success in status
            pDefer.reject({
              "error_code": "return_status_not_successfully",
              "error": "return status field is not successfully " + pStatus,
              "data": data
            });
          }
        },
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + boundary);
          var csrfToken = api_util.get_cookie("csrf-token");
          if (typeof csrfToken === "string" && csrfToken.length > 0) {
            xhr.setRequestHeader("X-Csrf-Token", csrfToken);
          }
        }
      }).fail(function (error) {
        var errorMessage = {
          "error": "Could not save the page",
          "error_code": "fail_saving"
        };
        if (window.navigator !== undefined) {
          if (navigator.onLine === false) {
            errorMessage.error += ", you are offline";
          }
        }
        if (typeof error.responseText === "string") {
          try {
            // try to retrieve error message
            errorMessage = JSON.parse(error.responseText);
          } catch (e) {}
        }
        pDefer.reject(errorMessage);
      });
    });
  }
};
module.exports = HTMLPageHandler;

},{"../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79,"../../cloudflow/CloudflowUtil/js/CloudflowURL.js":80,"../../cloudflow/CloudflowUtil/js/QueryApplier.js":91,"../../cloudflow/FormRender/js/nixps-cloudflow-LayoutRenderer.js":170,"../../cloudflow/Translate/js/TranslationHandler.js":234,"../../cloudflow/UIProfiles/js/Component.js":247,"../../cloudflow/UIProfiles/js/HTMLPage.js":252,"../../cloudflow/UIProfiles/js/WebFramework.js":261,"../../cloudflow/Version/js/Version.js":269,"../../polyfill/polyfill.js":433,"./ComponentLinks.js":411,"./Constants.js":412,"./ExpressionToJS.js":415}],417:[function(require,module,exports){
"use strict";

var SessionStorage = require("../../../common/BrowserStorage/js/SessionStorage.js");
/**
 * @constructor ActionsImmunity
 * @description A factory to control the correct behavior of actions, try to prevent abuse
 * @param {Object} pOptions 
 * @param {Function} pAbortCB 
 */
var ActionsImmunity = function ActionsImmunity(pOptions, pAbortCB) {
  // set options
  this.options = Object.assign({
    max_stack_size: 256,
    max_active_actions: 100,
    browser_refresh_loop_timeout: 2000,
    browser_redirect_loop_timeout: 1500,
    redirect_loop_storage_key: "nixps.actionsimmunity.redirectHistory",
    redirect_history_max: 20
  }, pOptions);
  // set callback function
  this._setAbortCallback(pAbortCB);
  this.running_events = new Map();
};
ActionsImmunity.prototype = {
  constructor: ActionsImmunity,
  _setAbortCallback: function _setAbortCallback(pCallBack) {
    if (typeof pCallBack === "function") {
      this._inform_abort_action_cb = pCallBack;
    } else {
      this._inform_abort_action_cb = function () {};
    }
  },
  /**
   * @description Do checks before the event starts
   * @function
   * @name ActionsImmunity#enterAction
   * @param {ActionID} pActionID the id of the action
   * @param {Object} pEvent The event object
   * @returns true if event may continue, false if aborted
   */
  enterAction: function enterAction(pActionID, pEvent) {
    if (this._isClickEvent(pEvent) === true) {
      SessionStorage.clear(this.options.redirect_loop_storage_key);
    }
    if (pActionID === "reload") {
      if (hasReloadLoop(this.options.browser_refresh_loop_timeout) === true && this._isClickEvent(pEvent) === false) {
        this._informActionAbord("refresh_loop", "stop_propagation", pEvent);
        return false;
      }
      return true;
    }
    if (pActionID === "redirect") {
      if (hasRedirectLoop(this.options) === true && this._isClickEvent(pEvent) === false) {
        SessionStorage.clear(this.options.redirect_loop_storage_key);
        this._informActionAbord("redirect_loop", "stop_propagation", pEvent);
        return false;
      }
      if (this._isClickEvent(pEvent) === false) {
        markRedirectAttempt(this.options);
      }
      return true;
    }
    if (this.running_events.has(pEvent)) {
      var data = this.running_events.get(pEvent);
      data.stack_size++;
      this.running_events.set(pEvent, data);
      if (data.stack_size >= this.options.max_stack_size) {
        this._abortAction("stack_overflow", "stop_propagation", pEvent);
        return false;
      }
    } else {
      // new Event
      this.running_events.set(pEvent, {
        stack_size: 1
      });
    }
    if (this.running_events.size >= this.options.max_active_actions) {
      var oldestEvent = this._getOldestEvent();
      this._abortAction("pool_overflow", "stop_propagation", oldestEvent);
      return false;
    }
    return true;
  },
  /**
   * @description mark that we will leave the action
   * @function
   * @name ActionsImmunity#leaveAction
   * @param {String} pActionID The id of the tyep of action
   * @param {Object} pEvent The event
   * @returns true
   */
  leaveAction: function leaveAction(pActionID, pEvent) {
    if (this.running_events.has(pEvent)) {
      var data = this.running_events.get(pEvent);
      data.stack_size--;
      if (data.stack_size <= 0) {
        this.running_events["delete"](pEvent);
      } else {
        this.running_events.set(pEvent, data);
      }
    }
    return true;
  },
  _abortAction: function _abortAction(pAbortReasonID, pAbortType, pEvent) {
    if (pAbortType === undefined || pAbortType === "stop_propagation") {
      pEvent.stopImmediatePropagation();
    } else if (pAbortType === "warning_only") {
      console.warn("issues detected with page actions ", pAbortReasonID);
    }
    this._informActionAbord(pAbortReasonID, pAbortType, pEvent);
    // release memory for carbage collector
    this.running_events["delete"](pEvent);
  },
  _informActionAbord: function _informActionAbord(pAbortReasonID, pAbortType, pEvent) {
    this._inform_abort_action_cb({
      "reasonID": pAbortReasonID,
      "abortType": pAbortType,
      "event": pEvent
    });
  },
  _getOldestEvent: function _getOldestEvent() {
    var oldestEvent;
    this.running_events.forEach(function (value, key) {
      if (oldestEvent === undefined) {
        oldestEvent = key;
      } else if (oldestEvent.timeStamp > key.timeStamp) {
        oldestEvent = key;
      }
    });
    return oldestEvent;
  },
  _isClickEvent: function _isClickEvent(pEvent) {
    if (["dblclick", "click", "touch"].includes(pEvent.type)) {
      return true;
    } else if (pEvent.originalEvent !== undefined) {
      return this._isClickEvent(pEvent.originalEvent);
    }
    return false;
  }
};
module.exports = ActionsImmunity;
var loadedTimeStamp = undefined;
window.onload = function (event) {
  if (performance !== undefined && typeof performance.getEntriesByType === "function") {
    var results = performance.getEntriesByType("navigation");
    if (Array.isArray(results) && results.length > 0 && results[0].type === "reload") {
      loadedTimeStamp = new Date();
    }
  }
};
function hasReloadLoop(pTimeDistance) {
  if (loadedTimeStamp !== undefined) {
    if (typeof pTimeDistance !== "number" && pTimeDistance <= 0) {
      pTimeDistance = 2000;
    }
    if (new Date() - loadedTimeStamp < pTimeDistance) {
      return true;
    }
  }
  return false;
}
function hasRedirectLoop(pOptions) {
  var history;
  history = SessionStorage.getObject(pOptions.redirect_loop_storage_key);
  if (Array.isArray(history)) {
    var urls = [];
    for (var i = 0; i < history.length; i++) {
      var entry = history[i];
      if (entry && typeof entry.url === "string") {
        urls.push(entry.url);
      }
    }
    urls.push(window.location.href);
    if (hasImmediateRepeat(urls, history, pOptions)) {
      return true;
    }
  }
  return false;
}
function markRedirectAttempt(pOptions) {
  var history = [];
  var stored = SessionStorage.getObject(pOptions.redirect_loop_storage_key);
  if (Array.isArray(stored)) {
    history = stored;
  }
  history.push({
    timestamp: Date.now(),
    url: window.location.href
  });
  if (history.length > pOptions.redirect_history_max) {
    history = history.slice(history.length - pOptions.redirect_history_max);
  }
  SessionStorage.setObject(pOptions.redirect_loop_storage_key, history);
}
function hasImmediateRepeat(pUrls, pHistory, pOptions) {
  if (!Array.isArray(pUrls) || pUrls.length < 2) {
    return false;
  }
  var timestamps = [];
  if (Array.isArray(pHistory)) {
    for (var i = 0; i < pHistory.length; i++) {
      var entry = pHistory[i];
      if (entry && typeof entry.timestamp === "number") {
        timestamps.push(entry.timestamp);
      } else {
        timestamps.push(undefined);
      }
    }
  }
  timestamps.push(Date.now());
  var maxPeriod = Math.floor(pUrls.length / 2);
  for (var period = 1; period <= maxPeriod; period++) {
    var match = true;
    for (var i = 0; i < period; i++) {
      if (pUrls[pUrls.length - 1 - i] !== pUrls[pUrls.length - 1 - i - period]) {
        match = false;
        break;
      }
    }
    if (match === true) {
      return checkAveragePeriod(timestamps, period, pOptions);
    }
  }
  return false;
}
function checkAveragePeriod(pTimestamps, pPeriod, pOptions) {
  var end = pTimestamps.length - 1;
  var start = pTimestamps.length - 2 * pPeriod;
  if (start < 0) {
    return false;
  }
  var sum = 0;
  var count = 0;
  for (var j = start + 1; j <= end; j++) {
    var previous = pTimestamps[j - 1];
    var current = pTimestamps[j];
    if (typeof previous !== "number" || typeof current !== "number") {
      continue;
    }
    var delta = current - previous;
    if (delta < 0) {
      continue;
    }
    sum += delta;
    count++;
  }
  if (count === 0) {
    return false;
  }
  var avgDelta = sum / count;
  if (avgDelta < pOptions.browser_redirect_loop_timeout) {
    return true;
  }
  return false;
}
if (window.nixps === undefined) {
  window.nixps = {};
}
if (nixps.cloudflow === undefined) {
  nixps.cloudflow = {};
}
nixps.cloudflow.ActionsImmunity = ActionsImmunity;

},{"../../../common/BrowserStorage/js/SessionStorage.js":279}],418:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var Context = require("../Context.js");
var Action = require("../../../cloudflow/UIProfiles/js/Action.js");
var regExp = new RegExp("[a-z_0-9]+", "g");
function makeTechnicalString(pString) {
  var candidateParts = pString.toLowerCase().match(regExp);
  if (Array.isArray(candidateParts)) {
    return candidateParts.join("");
  } else {
    return pString;
  }
}

/**
 * @constructor Trigger
 * @description The component representing a trigger
 */
var Trigger = function Trigger(pOptions) {
  this.id;
  this.setID(pOptions.id);
  this.setActionType(pOptions.actiontype);
  this.translatedName = "-";
  this.setName(pOptions.name);
  this.setData(pOptions.data);
  this.setDataInfo(pOptions.data_info);
  this.setContext(pOptions.context);
  this.setSelector(pOptions.filterselector);
  this.setMouseType(pOptions.mousetype);
  this.actions = [];
  this.setActions(pOptions.actions);
  this.setDataUrl(pOptions.dataUrl);
  this.setDataContextObject(pOptions.dataContextObject);
  this.setTargetCheckType(pOptions.targetchecktype);
  this.setTargetCheckClass(pOptions.targetcheckclass);
  this.setAccessControl(pOptions.accesscontrol);
  this.setIcon(pOptions.icon);
  this.setCursorType(pOptions.cursortype);
  this.setHelptext(pOptions.helptext);
};
Trigger.fromJSON = function (json) {
  return new Trigger(json);
};
Trigger.calculateGlobalID = function (pEventName, pSelector) {
  if (typeof pSelector === "string" && pSelector.length > 0) {
    return pEventName + "/" + makeTechnicalString(pSelector);
  }
  return pEventName;
};
var upercaseRegExp = new RegExp("[A-Z]", "g");
var actionnameRegExp = new RegExp("%", "g");
var actionnameSpecialCharRegExp = new RegExp("[.!~*'()]", "g");
var speciaCharDict = {
  ".": "%2E",
  "!": "%21",
  "~": "%7E",
  "*": "%2A",
  "'": "%27",
  "(": "%28",
  ")": "%29"
};
Trigger.calculateActionName = function (pName, pForceLowerCase) {
  if (typeof pName !== "string" || pName.length <= 0) {
    throw new Error("You must provide a baseName name");
  }
  // all special chars link {} # are gone and result is [a-zA-Z0-9_]
  var calculatedName = encodeURIComponent(pName).replace(actionnameSpecialCharRegExp, function (match, offset, string) {
    return speciaCharDict[match];
  }).replace(actionnameRegExp, "_");
  if (pForceLowerCase === true) {
    calculatedName = calculatedName.replace(upercaseRegExp, function (match, p1, p2, p3, offset, string) {
      return "__" + match.toLowerCase();
    });
  }
  return calculatedName;
};
Trigger.prototype = {
  constructor: Trigger,
  getID: function getID() {
    return this.id;
  },
  setID: function setID(pID) {
    if (typeof pID !== "string" || pID.length <= 0) {
      throw new Error("id must be a not empty string");
    }
    this.id = pID;
  },
  setActionType: function setActionType(pActionType) {
    if (pActionType === undefined || pActionType === null) {
      this.actiontype = Action.type.JQUERYEVENTPAGETRIGGER;
    } else if (typeof pActionType === "string" && pActionType.length > 0) {
      this.actiontype = pActionType;
    } else {
      throw new Error("ActionType must be a not empty string");
    }
  },
  getActionType: function getActionType() {
    return this.actiontype;
  },
  getGlobalID: function getGlobalID() {
    return Trigger.calculateGlobalID(this.getID(), this.getSelector());
  },
  setName: function setName(pName) {
    if (typeof pName === "string" && pName.length > 0) {
      this.name = pName;
      this.translatedName = $.i18n._(this.name);
    } else if (Array.isArray(pName) && typeof pName[0] === "string" && pName[0].length > 0) {
      this.name = pName.slice();
      // split the array in 2 peases, the first is the main translation key, the others are the translation parameters
      var tmpCopyName = pName.slice();
      this.translatedName = $.i18n._(tmpCopyName.shift(), tmpCopyName);
    } else {
      throw new Error("Trigger.setName parameter name must be a string");
    }
  },
  getName: function getName() {
    return this.translatedName;
  },
  hasHelptext: function hasHelptext() {
    return typeof this.helptext === "string" && this.helptext.length > 0;
  },
  setHelptext: function setHelptext(pHelpText) {
    if (typeof pHelpText === "string" && pHelpText.length > 0) {
      this.helptext = pHelpText;
    } else {
      this.helptext = null;
    }
  },
  getHelptext: function getHelptext() {
    return this.helptext;
  },
  getTranslationHelptext: function getTranslationHelptext() {
    if (this.hasHelptext()) {
      return $.i18n._(this.helptext);
    }
    return "";
  },
  getTranslationKey: function getTranslationKey() {
    return this.name;
  },
  setTargetCheckType: function setTargetCheckType(pTargetCheckType) {
    this.targetchecktype = pTargetCheckType;
  },
  getTargetCheckType: function getTargetCheckType() {
    return this.targetchecktype;
  },
  setTargetCheckClass: function setTargetCheckClass(pTargetCheckClass) {
    this.targetcheckclass = pTargetCheckClass;
  },
  getTargetCheckClass: function getTargetCheckClass() {
    return this.targetcheckclass;
  },
  setAccessControl: function setAccessControl(pAccessControl) {
    this.accesscontrol = pAccessControl;
  },
  getAccessControl: function getAccessControl() {
    return this.accesscontrol;
  },
  hasIconDefined: function hasIconDefined() {
    return typeof this.icon === "string" && this.icon.length > 0;
  },
  setIcon: function setIcon(pIconClasses) {
    this.icon = null;
    if (typeof pIconClasses === "string" && pIconClasses.length > 0) {
      this.icon = pIconClasses;
    }
  },
  getIcon: function getIcon() {
    if (this.hasIconDefined()) {
      return this.icon;
    } else if (["click", "dblclick"].indexOf(this.getMouseType()) >= 0 || this.getID().indexOf("click") >= 0 || this.getID().indexOf("mouse") >= 0) {
      return "fa fa-hand-pointer-o";
    } else {
      var translationName = this.getName().toUpperCase();
      if (translationName.indexOf("CLICK") >= 0 || translationName.indexOf("MOUSE") >= 0) {
        return "fa fa-hand-pointer-o";
      }
      return "fa fa-bolt";
    }
  },
  setData: function setData(pData) {
    if (!pData || Object.keys(pData).length === 0) {
      this.data = [];
    } else if (Array.isArray(pData)) {
      this.data = pData;
    } else {
      throw new Error("unsupported interface for trigger data");
    }
  },
  getData: function getData() {
    return this.data;
  },
  setDataInfo: function setDataInfo(pDataInfo) {
    if (pDataInfo === undefined) {
      this.data_info = [];
      this.data = [];
      return;
    }
    if (!Array.isArray(pDataInfo)) {
      throw new Error("unsupported interface for trigger data_info");
    }
    this.data_info = [];
    for (var i = 0; i < pDataInfo.length; i++) {
      if (pDataInfo[i] && _typeof(pDataInfo[i]) === "object") {
        if (typeof pDataInfo[i].name !== "string" || pDataInfo[i].name.length <= 0) {
          throw new Error("data info needs a name");
        }
        if (this.data.includes(pDataInfo[i].name) === false) {
          this.data.push(pDataInfo[i].name);
        }
        if (typeof pDataInfo[i].description === "string") {
          pDataInfo[i].description = $.i18n._(pDataInfo[i].description);
        }
        this.data_info.push(pDataInfo[i]);
      }
    }
  },
  getDataInfo: function getDataInfo() {
    return this.data_info;
  },
  setDataUrl: function setDataUrl(pDataUrl) {
    if (pDataUrl === undefined || pDataUrl === null) {
      this.dataUrl = null;
    } else if (typeof pDataUrl === "string") {
      this.dataUrl = pDataUrl;
    } else {
      throw new Error("Trigger.setDataUrl invalid type of dataUrl");
    }
  },
  getDataUrl: function getDataUrl() {
    return this.dataUrl;
  },
  getDataContextObject: function getDataContextObject() {
    return this.dataContextObject;
  },
  setDataContextObject: function setDataContextObject(pContextObjectPath) {
    if (typeof pContextObjectPath === "string" && pContextObjectPath.length > 0) {
      this.dataContextObject = pContextObjectPath;
    } else {
      this.dataContextObject = null;
    }
  },
  hasDataContextObject: function hasDataContextObject() {
    return this.dataContextObject !== null;
  },
  hasSelector: function hasSelector() {
    return typeof this.filterselector === "string";
  },
  getSelector: function getSelector() {
    return this.filterselector;
  },
  setSelector: function setSelector(pSelector) {
    if (pSelector === undefined || pSelector === null || pSelector === "") {
      this.filterselector = null;
    } else if (typeof pSelector === "string") {
      this.filterselector = pSelector;
    } else {
      this.filterselector = null;
      throw new Error("Trigger.setSelector: invalid parameter ");
    }
  },
  setMouseType: function setMouseType(pMouseType) {
    if (typeof pMouseType === "string") {
      this.mousetype = pMouseType;
    } else {
      this.mousetype = null;
    }
  },
  getMouseType: function getMouseType() {
    return this.mousetype;
  },
  hasContext: function hasContext() {
    return this.context !== null;
  },
  getContext: function getContext() {
    return this.context;
  },
  setContext: function setContext(pContext) {
    if (pContext === undefined || pContext === null) {
      this.context = null;
    } else if (pContext instanceof Context) {
      this.context = pContext.clone();
    } else if (pContext && _typeof(pContext) === "object") {
      this.context = Context.fromJSON(pContext);
    } else {
      throw new Error("Trigger.setContext: invalid Context parameter");
    }
  },
  hasCursorType: function hasCursorType() {
    return this.cursortype !== null;
  },
  setCursorType: function setCursorType(pCursorType) {
    if (typeof pCursorType === "string" && pCursorType.length > 0) {
      this.cursortype = pCursorType;
    } else {
      this.cursortype = null;
    }
  },
  getCursorType: function getCursorType() {
    return this.cursortype;
  },
  hasActions: function hasActions() {
    return this.actions.length > 0;
  },
  setActions: function setActions(pActions) {
    if (pActions === undefined || pActions === null) {
      this.actions = [];
    } else if (Array.isArray(pActions)) {
      this.actions = pActions;
    } else {
      throw new Error("setActions parameter must be an array");
    }
  },
  getActions: function getActions() {
    return this.actions;
  },
  pushActions: function pushActions(pActions) {
    if (Array.isArray(pActions)) {
      this.actions = this.actions.concat(pActions);
    } else {
      throw new Error("pushActions parameter must be an array");
    }
  },
  clone: function clone() {
    return Trigger.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var output = {
      id: this.id,
      actiontype: this.actiontype,
      globalid: this.getGlobalID(),
      name: this.name,
      helptext: this.helptext,
      data: this.data,
      data_info: this.data_info,
      filterselector: this.filterselector,
      mousetype: this.mousetype,
      dataUrl: this.dataUrl,
      dataContextObject: this.dataContextObject,
      targetchecktype: this.targetchecktype,
      targetcheckclass: this.targetcheckclass,
      accesscontrol: this.accesscontrol,
      cursortype: this.cursortype
    };
    if (this.hasContext()) {
      output.context = this.context.toJSON();
    }
    if (this.hasIconDefined()) {
      output.icon = this.icon;
    }
    if (Array.isArray(this.actions) && this.actions.length > 0) {
      output.actions = structuredClone(this.actions);
    }
    return output;
  }
};
module.exports = Trigger;

},{"../../../cloudflow/UIProfiles/js/Action.js":240,"../Context.js":413}],419:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Dec 27, 2017 5:40:12 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, _ */

(function ($) {
  require("../../../cloudflow/FormRender/js/nixps-cloudflow-FormRenderer.js");
  require("../../../cloudflow/FormRender/js/nixps-cloudflow-LayoutRenderer.js");
  var Constants = require("../Constants.js");
  var HTMLPageHandler = require("../HTMLPageHandler.js");
  var HTMLPage = require("../../../cloudflow/UIProfiles/js/HTMLPage.js");
  var User = require("../../../cloudflow/User/js/User.js");
  var License = require("../../../cloudflow/License/js/License.js");
  var Consent = require("../../../cloudflow/Consent/js/Consent.js");
  var Context = require("../Context.js");
  var ExpressionToJS = require("../ExpressionToJS.js");
  var TranslationHandler = require("../../../cloudflow/Translate/js/TranslationHandler.js");
  var Form = require("../../../cloudflow/UIProfiles/js/Form.js");
  var CloudflowObject = require("../../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
  var CloudflowURL = require("../../../cloudflow/CloudflowUtil/js/CloudflowURL.js");
  var Action = require("../../../cloudflow/UIProfiles/js/Action.js");
  var ActionList = require("../../../cloudflow/UIProfiles/js/ActionList.js");
  var DoneQueue = require("../DoneQueue.js");
  var LogListener = require("../inspect/LogListener.js");
  var WhitepaperConnection = require("../../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js");
  var WebFramework = require("../../../cloudflow/UIProfiles/js/WebFramework.js");
  var preparationVariablesRegExp = new RegExp("[$]{prepvar.([^}]+)}", "g"); // recognise variable for actions
  var preparationStandAloneVariablesRegExp = new RegExp("^[$]{prepvar.([^}]+)}$"); // recognise variable for actions
  var inputparameterRegExp = new RegExp("[$]\{inputvariable.([a-zA-Z0-9\._]+?)\}", "g");
  var regExpVariable = new RegExp("^\\${[^}]*}$");
  var translationsRegExp = new RegExp("[$]{((pb|custom)-[^}]+)}", "g"); // recognise variable for context injection

  /**
   * @description All pages dictionary for caching
   * @private
   * @type {Object}
   */
  var pageDict = {};
  function needUserData(pType) {
    switch (pType) {
      case "MyApprovals":
      case "CloudflowBar":
      case "TopBar":
      case "SideBar":
      case "PreConfiguredListPanel":
      case "PreConfiguredTable":
      case "ManageProjects":
      case "CreateWorkable":
      case "DetailsPanel":
      case "FormDetailsPanel":
      case "IframeComponent":
        return true;
      default:
        return false;
    }
  }
  function needLicense(pType) {
    switch (pType) {
      case "PreConfiguredListPanel":
      case "PreConfiguredTable":
      case "ManageProjects":
      case "SideBar":
      case "IframeComponent":
        return true;
      default:
        return false;
    }
  }
  function needConfigID(pType) {
    switch (pType) {
      case "PreConfiguredTable":
      case "ManageProjects":
        return true;
      default:
        return false;
    }
  }
  function needContext(pType) {
    switch (pType) {
      case "DetailsPanel":
      case "CloudflowTabs":
      case "CustomPageComponent":
      case "CustomPageComponentContainer":
        return true;
      default:
        return false;
    }
  }
  function needConsent(pType) {
    switch (pType) {
      case "CreateWorkable":
      case "FormDetailsPanel":
        return true;
      default:
        return false;
    }
  }
  function needHost(pType) {
    switch (pType) {
      case "CreateWorkable":
      case "FormDetailsPanel":
        return true;
      default:
        return false;
    }
  }
  function getFoldername(pURL) {
    if (typeof pURL === "string" && pURL.length > 0) {
      return pURL.substring(0, pURL.lastIndexOf('/') + 1);
    }
    return pURL;
  }
  function getHost() {
    var host = null;
    if (typeof window.URI === "function") {
      var urlParameters = new URI().query(true); // object containing the url parameters
      if (typeof urlParameters.host === "string" && urlParameters.host.length > 0) {
        host = {
          identifier: urlParameters.host
        };
      }
    } else {
      console.warn("please include the URI 3rdParty plugin");
    }
    return host;
  }

  /**
   * @namespace nixps-pagebuilder.CustomPageComponent
   * @description This component is used for pagebuilder internal components. DO NOT CHANGE THIS!
   * @private
   * @example $('<div>').CustomPageComponent({});
   * @version 1.4.0
   */
  $.widget("nixps-pagebuilder.CustomPageComponent", $.Widget, {
    version: "1.4.0",
    defaultElement: "<div>",
    widgetEventPrefix: "custompagecomponent",
    options: {
      /**
       * @name nixps-pagebuilder.CustomPageComponent#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-pagebuilder.CustomPageComponent#relativeBasePath
       * @description The path to be used if the url is relative
       * @type {string}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-pagebuilder.CustomPageComponent#url
       * @description The url as reference where the page component is situated
       * @type {String}
       * @default ""
       */
      url: "",
      /**
       * @name nixps-pagebuilder.CustomPageComponent#HTMLPageJSON
       * @description The htmlpage json to reprecent the custom page component directly from json witout need of url
       * @type {Object}
       * @default {}
       * @since 1.1.0
       */
      HTMLPageJSON: {},
      /**
       * @name nixps-pagebuilder.CustomPageComponent#currentVersion
       * @description The current working pagebuilder version
       * @type {Number}
       */
      currentVersion: Constants.versionNumber,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#waitingOptions
       * @description Define the waiting animation
       * @type {Object}
       * @default {
          text: "", 
          type: "cloud",
          useFlex: true
      }
       */
      waitingOptions: {
        text: "",
        type: "cloud",
        useFlex: true
      },
      /**
       * @name nixps-pagebuilder.CustomPageComponent#minHeight
       * @description The min height of the component. This will be given to the css function of jQuery
       * @type {Number| String}
       * @default 38
       */
      minHeight: 38,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#failLoadMessage
       * @description Text to be show when component could not be loaded
       * @type {String}
       * @default "nixps-cloudflow-pagebuilder.custompagecomponent_message_notloaded"
       * @since 1.2.1
       */
      failLoadMessage: undefined,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#failLoadMessage
       * @description The HTML to be used if we could not find the page, This HTML will also be save in the cache of the current page
       * @type {Object}
       * @default undefined
       * @since 1.2.1
       */
      failBackHTMLPageJSON: undefined,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#parentWillRefresh
       * @description will the parent take care of the internal refresh or not?
       * @type {Boolean}
       * @default false
       * @since 1.2.2
       */
      parentWillRefresh: false,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#context
       * @description The reference of the context
       * @type {Context}
       * @default null
       * @since 1.2.0
       */
      context: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#contextConnector
       * @description The contextConnector to open this page in.
       * @type {Object | String}
       * @default null
       */
      contextConnector: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#contextCollection
       * @description The context to open this page in.
       * @type {Object | String}
       * @default null
       */
      contextCollection: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#contextKey
       * @description The key to get the context
       * @type {String}
       * @default null
       */
      contextKey: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#customchangeTriggerIdentifier
       * @description The identifier to be given to customchange trigger data
       * @type {mixed}
       * @default null 
       * @since 1.4.0
       */
      customchangeTriggerIdentifier: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#pageCSSSelector
       * @description The string to help identify the page css selector
       * @type {String}
       * @default null
       * @since 1.3.0
       */
      pageCSSSelector: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#publicParentWidgetName
       * @description The widget name of the parent we can use in public to link to this component
       * used in debug sessions
       * @type {String}
       * @default null
       * @since 1.3.0
       */
      publicParentWidgetName: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#showMilestoneProgress
       * @description Must we show the workflow milestone progress in the waiting panel or not?
       * @type {Boolean}
       * @default false
       */
      showMilestoneProgress: false,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#refreshDelay
       * @description The delay between two refreshes
       * @type {Number}
       * @default 0
       */
      refreshDelay: 0,
      /**
       * @description Whether the component is inside the pagebuilder editor or not.
       * @name nixps-pagebuilder.CustomPageComponent#isInEditor
       * @type {Boolean}
       * @default false
       */
      isInEditor: false,
      /**
       * @name nixps-pagebuilder.CustomPageComponent#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        failLoadMessage: $.i18n._("nixps-cloudflow-pagebuilder.custompagecomponent_message_notloaded")
      };
    },
    /**
     * @description Create the component
     * @name nixps-pagebuilder.CustomPageComponent#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      if (this.element.parents('body').length <= 0) {
        // the infinity loop detection needs all elements to be attached to the DOM
        this._setErrorState({
          error_code: "not_attached_DOM",
          error: "component must be attached to the DOM"
        });
        this.options.created();
        return false;
      }
      this._controlOptions();
      this.element.addClass(this.widgetFullName).attr("data-uuid", this.uuid);

      // custom page component can live outside a pagebuilder page
      if (!window.nixps) {
        window.nixps = {};
      }
      if (!nixps.pagebuilderPage) {
        nixps.pagebuilderPage = {};
      }
      if (nixps.pagebuilderPage.actionsImmunity === undefined) {
        nixps.pagebuilderPage.actionsImmunity = new nixps.cloudflow.ActionsImmunity(undefined, function (pAbortData) {
          $(".nixps-NotifyArea").NotifyArea("createMessage", "closeable-error", $.i18n._("nixps-cloudflow-pagebuilder.error_abordactions_title"), $.i18n._("nixps-cloudflow-pagebuilder.error_abordactions_message_" + pAbortData.reasonID), 60000);
        });
      }
      // end init pagebuilder page settings

      if (this.element.attr("id")) {
        this.element.attr("data-pb-debugselection", encodeURIComponent("#" + this.element.attr("id")));
      } else if (typeof this.options.pageCSSSelector === "string" && this.options.pageCSSSelector.length > 0) {
        this.element.attr("data-pb-debugselection", encodeURIComponent(this.options.pageCSSSelector));
      }
      if (this.options.publicParentWidgetName === null) {
        this.options.publicParentWidgetName = this.widgetFullName;
      }

      // variables
      var that = this;
      this.form; // the elements to show
      this.layout; // the layout of the elements
      this.subActions = undefined;
      this.beforeDrawActions = undefined;
      this.afterDrawActions = undefined;
      this.user; // the current user object
      this.license; // the license object
      this.consent; // the consent object
      this.host; // the hostname
      this.context = null; // the context containing the data
      this.expressionUtil; // an object to translate value composers
      this.drawID = 0; // the request id to draw
      this.blokkingID; // timerid of the blokking frame
      this.isLoadingToDraw = false; // the the component being loading to draw 
      this.pageUrl; // the current url of the form, to detect self referenced loops
      this.relativePathChildren = "";
      this.historyPushStates = []; // array containing all the state history
      this.alive = true;
      this.refreshTimeoutID = -1;
      this.doneQueue = new DoneQueue();
      this._on(this.element, {
        "custompagecomponentbeforedrawed": this._createChildHandler,
        "custompagebuilderinternalredirect": this._redirectHandler,
        "custompagebuilderrefreshcontainer": this._refreshContainerHandler,
        "custompagebuildercustomchangetrigger": this._customTriggerHandler
      });
      this._setStyle();
      this._setNewContext(this.options.context);
      $.when(this._loadAndDraw("create")).done(function () {
        LogListener.addLog({
          event_type: "open_page",
          details_data: that.context !== null ? that.context.getData() : null,
          debug: that.context !== null ? that.context.getDebugData() : null,
          page_url: that.pageUrl,
          component_name: that.options.publicParentWidgetName,
          component_css_selector: that._retrieveDebugCSSSelector(that.element)
        });
      }).always(function () {
        if (that.doneQueue === null) {
          // has already been called and reset
          // so ignore 
        } else if (that.doneQueue.getAmountAskedDone() === 0) {
          // done but no items
          that.options.created();
          that.doneQueue = null; // reset 
        } else {
          that.doneQueue.informAllDone(function () {
            that.options.created();
            that.doneQueue = null; // reset 
          });
        }
      });
    },

    /**
     * @description function runs when a child custom page component want to be creating, check if he is allowed to do it, to prevent infinity loops
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponent#_createChildHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {Boolean}
     */
    _createChildHandler: function _createChildHandler(pEvent, pData) {
      if (pData === undefined) {
        throw new Error("_createChildHandler: beforedrawed, pData must be defined");
      }
      // console.log(pData.uuid + " -> " + this.uuid + " --- " + pData.pageUrl + " -> " +  this.pageUrl);
      if (this.uuid !== pData.uuid && pData.pageUrl === this.pageUrl) {
        // if not same component, then event come from child
        // but with the same url => block we detected a loop
        return false;
      }
    },
    /**
     * @description function runs when user want to have an internal redirect
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponent#_redirectHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _redirectHandler: function _redirectHandler(pEvent, pData, pOriginalEvent) {
      pEvent.stopPropagation();
      pEvent.preventDefault();
      if (pData !== undefined && typeof pData.url === "string" && pData.url.length > 0) {
        // set url
        this.historyPushStates.push({
          url: this.options.url,
          HTMLPageJSON: this.options.HTMLPageJSON,
          contextConnector: this.options.contextConnector,
          contextCollection: this.options.contextCollection,
          contextKey: this.options.contextKey,
          context: this.options.context
        });
        this.options.url = pData.url;
        this.options.HTMLPageJSON = {};
        // reset context
        this.options.contextConnector = null;
        this.options.contextCollection = null;
        this.options.contextKey = null;
        this.options.context = null;
        // set context if provided
        if (typeof pData.contextConnector === "string") {
          this.options.contextConnector = pData.contextConnector;
          this.options.contextCollection = pData.contextCollection;
          this.options.contextKey = pData.contextKey;
        }
        if (pData.context !== undefined) {
          this._setNewContext(pData.context);
        } else {
          this._setNewContext({
            connector: this.options.contextConnector,
            collection: this.options.contextCollection,
            key: this.options.contextKey
          });
        }
        if (pOriginalEvent !== undefined && pOriginalEvent.stopPropagation !== undefined) {
          pOriginalEvent.stopPropagation();
        }
        return this._loadAndDraw("internal_redirect");
      } else {
        console.error("_redirectHandler: parameter url with correct infterface in pData is missing");
      }
    },
    /**
     * @description function runs when user want to refresh the parents
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponent#_refreshContainerHandler
     * @param {type} pEvent
     * @param {type} pData
     * @param {type} pOriginalEvent
     * @returns {unresolved|Promise|this.constructor|Object.prototype.then.child|Promise.prototype|Promise.prototype.then|undefined|Boolean}
     */
    _refreshContainerHandler: function _refreshContainerHandler(pEvent, pData, pOriginalEvent) {
      if (this.options.parentWillRefresh === false && pData !== undefined) {
        pEvent.stopPropagation();
        pEvent.preventDefault();
        if (pOriginalEvent !== undefined && pOriginalEvent.stopPropagation !== undefined) {
          pOriginalEvent.stopPropagation();
        }
        return this.refreshMaintainContext(pData.force, pData.originalURL);
      }
    },
    /**
     * @description Function runs when a user has defined and triggerd a custom trigger
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponent#_customTriggerHandler
     * @param {Object} pEvent 
     * @param {Object} pData 
     */
    _customTriggerHandler: function _customTriggerHandler(pEvent, pData, pOriginalEvent, pReturnDef) {
      if (pEvent.isImmediatePropagationStopped()) {
        // custom change can trigger a loop of outside, so abort to prevent loops
        console.error("action before trigger customchange has been aborted");
        return Promise.reject({
          error_code: "aborted",
          error: "action before trigger customchange has been aborted"
        });
      }
      pEvent.stopPropagation();
      pEvent.preventDefault();
      if (pData !== undefined) {
        var dataToPass = {};
        if (pData.data_to_pass !== undefined) {
          dataToPass = Object.assign({}, pData.data_to_pass);
        }
        // retrieve event object that is send later
        var origEvent = undefined;
        this.element.one("custompagecomponentcustomchange", function (pEvent) {
          origEvent = pEvent;
        });
        this._trigger("customchange", pEvent, {
          data: dataToPass,
          pageURL: this.pageUrl,
          identifier: this.options.customchangeTriggerIdentifier
        });
        // return the $.def to the next following actions,
        // is there a $.def in the result ?
        if (origEvent !== undefined && origEvent.result !== undefined && typeof origEvent.result.then === "function") {
          // does the trigger provide me a return interface
          if (pReturnDef !== undefined && pReturnDef.returnOutput === undefined) {
            pReturnDef.returnOutput = origEvent.result;
          }
        }
        return pReturnDef;
      } else {
        console.error("_customTriggerHandler: pData is missing");
      }
    },
    /**
     * @description runs a sub action
     * @function
     * @private
     * @name  nixps-pagebuilder.CustomPageComponent#_runSubPageAction
     * @param {String} pID The SUBAction id
     * @param {Object} pEvent 
     * @param {Object} pData the data send by the event
     * @param {Object} pPreviousResults return output of previous action 
     * @returns $Deferred object
     */
    _runSubPageAction: function _runSubPageAction(pID, pEvent, pData, pPreviousResults) {
      if (pEvent && typeof pEvent.isImmediatePropagationStopped === "function" && pEvent.isImmediatePropagationStopped()) {
        var errorObject = {
          error_code: "aborted",
          error: "subPageAction " + pID + " aborted"
        };
        console.error(errorObject.error);
        return Promise.reject(errorObject);
      }
      if (pPreviousResults === undefined) {
        pPreviousResults = {};
      }
      if (this.subActions === undefined || this.subActions.hasActions() === false) {
        var errorObject = {
          error_code: "unknown_subpageaction_id",
          error: "subPageAction " + pID + " called, but no subActions are defined"
        };
        console.error(errorObject.error);
        return Promise.reject(errorObject);
      }
      var actions = this.subActions.getActions();
      for (var i = 0; i < actions.length; i++) {
        if (actions[i].getType() !== Action.type.SUBPAGEACTION) {
          throw new Error("wrong_actiontype: only type subPageAction is allowed here");
        }
        var subAction = actions[i].getParameters();
        if (subAction.getID() === pID) {
          if (subAction.getAccessControl() !== "hidden") {
            var css_selector = undefined;
            if (pEvent.handleObj !== undefined) {
              css_selector = this._retrieveDebugCSSSelector($(pEvent.currentTarget), pEvent.handleObj.selector);
            }
            LogListener.addLog({
              event_type: "sub_page_action",
              details_data: pData,
              page_url: this.pageUrl,
              debug: undefined,
              component_name: subAction.getName(),
              component_css_selector: css_selector
            });
          }
          var value = this._runActionFunctions(subAction.getActionFunctions(), pEvent, pData, pPreviousResults);
          if (window.jQuery && value instanceof window.jQuery) {
            return {};
          } else {
            return value;
          }
        }
      }
      var errorObject = {
        error_code: "unknown_subpageaction_id",
        error: "subPageAction " + pID + " not defined"
      };
      console.error(errorObject.error);
      return Promise.reject(errorObject);
    },
    /**
     * @description Function to create dynamicaly the event listeners
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponent#_applyCustomActions
     * @param {type} pForm
     * @return {unresolved}
     */
    _applyCustomActions: function _applyCustomActions(pForm) {
      var that = this;
      // copy amount, and keep alive in this function
      // so we can compare the amount later with the current amount 
      var orginalAmountHistoryStates = this.historyPushStates.length;
      var handlersObject = {};
      var formElements = pForm.getElements();
      var parentDOM = this.element.children("div");
      // loop over all form elements
      for (var i = 0; i < formElements.length; i++) {
        if (formElements[i].hasActions() === true) {
          var componentID = formElements[i].getComponentID();
          // translate items of the actions
          var actionList = CloudflowObject.travers(formElements[i].getActionList().toJSON(), function (pContent, pKey) {
            if (typeof pContent === "string") {
              if (pContent.indexOf("${pb-") === 0 || pContent.indexOf("${custom-") === 0) {
                // remove first 2 and last character
                return $.i18n._(pContent.slice(2, -1));
              }
            }
            return pContent;
          });
          formElements[i].setActionList(actionList);
          var actions = formElements[i].getActionList().getActions().slice(); // copy the actions list
          for (var j = 0; j < actions.length; j++) {
            if (actions[j].getType() === Action.type.JQUERYEVENTPAGETRIGGER) {
              if (actions[j].getParameters().getActionFunction().hasPreActionFunction()) {
                // duplicate extra action
                var extraAction = actions[j].clone();
                extraAction.getParameters().setActionFunction(actions[j].getParameters().getActionFunction().getPreActionFunction().clone());
                // insert clone into actions
                actions.splice(j, 0, extraAction);
                j++;
              }
              if (actions[j].getParameters().getActionFunction().hasPostActionFunction()) {
                // duplicate extra action
                var extraAction = actions[j].clone();
                extraAction.getParameters().setActionFunction(actions[j].getParameters().getActionFunction().getPostActionFunction().clone());
                // insert clone into actions
                actions.splice(j + 1, 0, extraAction);
                j++;
              }
            }
          }
          var handlersFuncDict = {};
          // loop over all actions of that form element
          for (var j = 0; j < actions.length; j++) {
            if (actions[j].getType() === Action.type.JQUERYEVENTPAGETRIGGER) {
              // reconstruct the event selector for _on function
              var selector = typeof actions[j].getParameters().getFilterSelector() === "string" ? actions[j].getParameters().getFilterSelector() : "";
              // the name of the trigger, must come from a selector inside the component
              var eventSelectingKey = actions[j].getParameters().getEventName() + " #__cpc" + that.uuid + "_" + componentID + " " + selector;
              (function (pElementIndex, pActionindex, pJqueryEventPageTrigger) {
                var actionFunction = function actionFunction(pEvent, pData, pPreviousResults) {
                  if (pEvent && pEvent.isImmediatePropagationStopped()) {
                    return Promise.reject({
                      error_code: "aborted",
                      error: "event has been aborted"
                    });
                  }

                  // when event is fired, this function is called
                  var jqueryEventPageTrigger = pJqueryEventPageTrigger;
                  var actionfunc = jqueryEventPageTrigger.getActionFunction();
                  var staticParam = actionfunc.getStaticParameters();
                  if (pActionindex === 0) {
                    if (jqueryEventPageTrigger.hasTargetCheck() === true) {
                      if (jqueryEventPageTrigger.getTargetCheckType() === "findUUID") {
                        if ($(pEvent.currentTarget).find(jqueryEventPageTrigger.getTargetCheckClass()).first().add($(pEvent.currentTarget).filter(jqueryEventPageTrigger.getTargetCheckClass()).first()).attr("data-uuid") !== $(pEvent.target).closest(jqueryEventPageTrigger.getTargetCheckClass()).attr("data-uuid")) {
                          return undefined;
                        }
                      } else if (jqueryEventPageTrigger.getTargetCheckType() === "parentsUUID") {
                        if ($(pEvent.currentTarget).find(jqueryEventPageTrigger.getTargetCheckClass()).add($(this).filter(jqueryEventPageTrigger.getTargetCheckClass()).first()).map(function () {
                          return $(this).attr("data-uuid");
                        }).get().includes($(pEvent.target).closest(jqueryEventPageTrigger.getTargetCheckClass()).parents(jqueryEventPageTrigger.getTargetCheckClass()).attr("data-uuid"))) {
                          return undefined;
                        }
                      }
                    }
                    var event_name_options = undefined;
                    if (typeof jqueryEventPageTrigger.getEventName() === "string" && jqueryEventPageTrigger.getEventName().length > 0) {
                      event_name_options = {
                        event_name: jqueryEventPageTrigger.getEventName(),
                        options: {}
                        // options: $.extend(true, {}, formElements[pElementIndex].getElement().options)
                      };
                    }

                    LogListener.addLog({
                      event_type: "start_action",
                      event_name_options: event_name_options,
                      details_data: pData,
                      page_url: that.pageUrl,
                      component_name: formElements[pElementIndex].getComponentType(),
                      component_css_selector: that._retrieveDebugCSSSelector($(pEvent.currentTarget), pEvent.handleObj.selector)
                    });
                  }
                  var preparationRoot = {
                    "expressionUtil": that.expressionUtil,
                    "pEvent": pEvent,
                    "pPreviousResults": {}
                  };
                  if ($.isPlainObject(pPreviousResults)) {
                    preparationRoot = Object.assign(preparationRoot, {
                      "pPreviousResults": pPreviousResults
                    });
                  }
                  if (actionfunc.hasPreparations() === true) {
                    var preparations = actionfunc.getPreparations().getVariables();
                    var jqueryObject = {};
                    jqueryObject.isPlainObject = $.isPlainObject;
                    jqueryObject.isEmptyObject = $.isEmptyObject;
                    jqueryObject.extend = $.extend;
                    var functionArgumentNames = ["window", "document", "$", "jQuery", "Function", "pData", "expressionUtil", "pContext", "pPreviousResults"];
                    var functionArguments = [undefined, undefined, jqueryObject, jqueryObject, undefined, pData, that.expressionUtil, that.context, preparationRoot.pPreviousResults];
                    var name;
                    for (var k = 0; k < preparations.length; k++) {
                      if (preparations[k].getType() === "functionstring") {
                        name = preparations[k].getKey();
                        preparationRoot[name] = new Function(functionArgumentNames, "'use strict';return " + preparations[k].getValue()).apply(null, functionArguments);
                        functionArgumentNames.push(name);
                        functionArguments.push(preparationRoot[name]);
                      }
                    }
                  }
                  var prepearedParam = {};
                  prepearedParam = CloudflowObject.travers($.extend(true, {}, staticParam), function (pString) {
                    if (pString === "${inputvariables}") {
                      return pData;
                    }
                    if (pString === "<language>") {
                      return that.options.language;
                    }
                    if (preparationStandAloneVariablesRegExp.test(pString)) {
                      // remove the post and prefix
                      return preparationRoot[pString.slice(10, -1)];
                    }
                    pString = pString.replace(preparationVariablesRegExp, function (match, p1, offset, string) {
                      return CloudflowObject.getParameter(preparationRoot, p1);
                    });
                    pString = pString.replace(inputparameterRegExp, function (match, p1, offset, string) {
                      var matchedValue = CloudflowObject.getParameter(pData, p1);
                      if (matchedValue !== undefined) {
                        return matchedValue;
                      }
                      return match;
                    });
                    return pString;
                  });
                  if (prepearedParam !== undefined && prepearedParam !== null && typeof prepearedParam.targetElem === "string") {
                    // fix type "methodes" finding the correct componentDOM
                    if (prepearedParam.targetElem[0] === "#" && prepearedParam.targetElem[1] !== "_") {
                      prepearedParam.targetElem = "#__cpc" + that.uuid + "_" + prepearedParam.targetElem.slice(1);
                    }
                  }
                  if (prepearedParam.componentName === "CustomPageComponentDialog" || prepearedParam.componentName === "CustomPageComponentPopover_returnCloseDef" || prepearedParam.componentName === "CustomPageComponentDialog_returnCloseDef" && prepearedParam.methodeArguments && prepearedParam.methodeArguments.action_version > 0) {
                    if (prepearedParam.methodeArguments && prepearedParam.methodeArguments.contentOptions && (typeof prepearedParam.methodeArguments.contentOptions.relativeBasePath !== "string" || prepearedParam.methodeArguments.contentOptions.relativeBasePath.length <= 0)) {
                      prepearedParam.methodeArguments.contentOptions.relativeBasePath = that.relativePathChildren;
                    }
                  }
                  if (actionfunc.getName() === "trigger_event" && prepearedParam.target === undefined && pEvent.target !== undefined) {
                    if (pEvent.target.isConnected === false) {
                      // DOM event.target who is needed, does not exists!!!!
                      //    Does it do an internal redirect ?
                      if (orginalAmountHistoryStates !== that.historyPushStates.length) {
                        console.warn("missing DOM, due to redirect, repair by injecting existing DOM!");
                        pEvent.target = that.element[0];
                      } else {
                        // node does not exists on body !!
                        console.error("could not execute action, the DOM is missing");
                      }
                    }
                  }
                  return actionfunc.getFunction()(prepearedParam, pEvent, pData, pPreviousResults, {
                    runSubAction: that._runSubPageAction.bind(that),
                    enterAction: nixps.pagebuilderPage.actionsImmunity.enterAction.bind(nixps.pagebuilderPage.actionsImmunity),
                    leaveAction: nixps.pagebuilderPage.actionsImmunity.leaveAction.bind(nixps.pagebuilderPage.actionsImmunity)
                  });
                };
                if (handlersFuncDict[eventSelectingKey] !== undefined) {
                  handlersFuncDict[eventSelectingKey].push(actionFunction);
                } else {
                  handlersFuncDict[eventSelectingKey] = [actionFunction];
                }
              })(i, Array.isArray(handlersFuncDict[eventSelectingKey]) ? handlersFuncDict[eventSelectingKey].length : 0, actions[j].getParameters());

              // add css class
              if (actions[j].getParameters().isPointerEvent() === true) {
                parentDOM.find("#__cpc" + that.uuid + "_" + componentID).addClass("custompagecomponent_pointereventitem");
              }
            }
          }
          var handlersObject = {};
          for (var handlerSelector in handlersFuncDict) {
            if (handlersFuncDict[handlerSelector].length === 1) {
              (function (pHandlerSelector, pHandlersFuncDict) {
                handlersObject[pHandlerSelector] = function (pEvent) {
                  return Promise.resolve(pHandlersFuncDict[pHandlerSelector][0].apply(this, $.makeArray(arguments)))["catch"](function (pError) {
                    var debug = pError.debug;
                    delete pError.debug;
                    pError.action_index || (pError.action_index = 1);
                    LogListener.addLog({
                      event_type: "error",
                      details_data: pError,
                      page_url: that.pageUrl,
                      debug: debug,
                      component_css_selector: that._retrieveDebugCSSSelector($(pEvent.currentTarget), pEvent.handleObj.selector)
                    });
                    return Promise.reject(pError);
                  });
                };
              })(handlerSelector, handlersFuncDict);
            } else {
              (function (pHandlersObject, pHandlerSelector, pHandlersFuncDict) {
                pHandlersObject[pHandlerSelector] = function (pEvent, pData) {
                  var firstDefResul = pHandlersFuncDict[pHandlerSelector][0](pEvent, pData, {});
                  if (firstDefResul === undefined) {
                    // aborted by hasTargetCheck findUUID
                    return undefined;
                  }
                  var resul = Promise.resolve(firstDefResul);
                  for (var f = 1; f < pHandlersFuncDict[pHandlerSelector].length; f++) {
                    (function (pFunction, pIndex) {
                      resul = resul.then(function (pPreviousResults) {
                        return pFunction(pEvent, pData, pPreviousResults);
                      })["catch"](function (pError) {
                        console.error(pError);
                        var debug = pError.debug;
                        delete pError.debug;
                        pError.action_index || (pError.action_index = pIndex + 1);
                        LogListener.addLog({
                          event_type: "error",
                          details_data: pError,
                          page_url: that.pageUrl,
                          debug: debug,
                          component_css_selector: that._retrieveDebugCSSSelector($(pEvent.currentTarget), pEvent.handleObj.selector)
                        });
                        return Promise.reject(pError);
                      });
                    })(pHandlersFuncDict[pHandlerSelector][f], f);
                  }
                  return resul;
                };
              })(handlersObject, handlerSelector, handlersFuncDict);
            }
          }
          this._on(parentDOM, handlersObject);
        }
      }
    },
    _runActionFunction: function _runActionFunction(actionfunc, pEvent, pData, pPreviousResults) {
      var that = this;
      var staticParam = actionfunc.getStaticParameters();
      var preparationRoot = {
        "expressionUtil": this.expressionUtil,
        "pEvent": pEvent,
        "pPreviousResults": {}
      };
      if ($.isPlainObject(pPreviousResults)) {
        preparationRoot = Object.assign(preparationRoot, {
          "pPreviousResults": pPreviousResults
        });
      }
      if (actionfunc.hasPreparations() === true) {
        var preparations = actionfunc.getPreparations().getVariables();
        var jqueryObject = {};
        jqueryObject.isPlainObject = $.isPlainObject;
        jqueryObject.isEmptyObject = $.isEmptyObject;
        jqueryObject.extend = $.extend;
        var functionArgumentNames = ["window", "document", "$", "jQuery", "Function", "pData", "expressionUtil", "pContext", "pPreviousResults"];
        var functionArguments = [undefined, undefined, jqueryObject, jqueryObject, undefined, pData, this.expressionUtil, this.context, preparationRoot.pPreviousResults];
        var name;
        for (var k = 0; k < preparations.length; k++) {
          if (preparations[k].getType() === "functionstring") {
            name = preparations[k].getKey();
            preparationRoot[name] = new Function(functionArgumentNames, "'use strict';return " + preparations[k].getValue()).apply(null, functionArguments);
            functionArgumentNames.push(name);
            functionArguments.push(preparationRoot[name]);
          }
        }
      }
      var prepearedParam = {};
      prepearedParam = CloudflowObject.travers($.extend(true, {}, staticParam), function (pString, pKey) {
        if (pString === "${inputvariables}") {
          return pData;
        }
        if (pString === "<language>") {
          return that.options.language;
        }
        if (preparationStandAloneVariablesRegExp.test(pString)) {
          // remove the post and prefix
          return preparationRoot[pString.slice(10, -1)];
        }
        pString = pString.replace(translationsRegExp, function (match, p1, offset, string) {
          return $.i18n._(p1);
        });
        pString = pString.replace(preparationVariablesRegExp, function (match, p1, offset, string) {
          return CloudflowObject.getParameter(preparationRoot, p1);
        });
        pString = pString.replace(inputparameterRegExp, function (match, p1, offset, string) {
          var matchedValue = CloudflowObject.getParameter(pData, p1);
          if (matchedValue !== undefined) {
            return matchedValue;
          }
          return match;
        });
        return pString;
      });
      if (prepearedParam !== undefined && prepearedParam !== null && typeof prepearedParam.targetElem === "string") {
        // fix type "methodes" finding the correct componentDOM
        if (prepearedParam.targetElem[0] === "#" && prepearedParam.targetElem[1] !== "_") {
          prepearedParam.targetElem = "#__cpc" + that.uuid + "_" + prepearedParam.targetElem.slice(1);
        }
      }
      if (prepearedParam.componentName === "CustomPageComponentDialog" || prepearedParam.componentName === "CustomPageComponentPopover_returnCloseDef" || prepearedParam.componentName === "CustomPageComponentDialog_returnCloseDef" && prepearedParam.methodeArguments.action_version > 0) {
        if (prepearedParam.methodeArguments !== undefined && prepearedParam.methodeArguments.contentOptions !== undefined && (typeof prepearedParam.methodeArguments.contentOptions.relativeBasePath !== "string" || prepearedParam.methodeArguments.contentOptions.relativeBasePath.length <= 0)) {
          prepearedParam.methodeArguments.contentOptions.relativeBasePath = this.relativePathChildren;
        }
      }
      if (actionfunc.getName() === "trigger_event" && prepearedParam.target === undefined && pEvent.target !== undefined) {
        if (pEvent.target.isConnected === false) {
          // DOM event.target who is needed, does not exists!!!!
          console.warn("missing DOM, due to redirect, repair by injecting existing DOM!");
          pEvent.target = that.element[0];
        } else if ($(pEvent.target).closest(that.element).length === 0) {
          // DOM element is outside custom page component, reset target works
          // this can happen when a sub action is called as public
          if (prepearedParam.apply_on_parent === true) {
            pEvent.target = that.element.children()[0];
          } else {
            pEvent.target = that.element[0];
          }
        }
      }
      return actionfunc.getFunction()(prepearedParam, pEvent, pData, pPreviousResults, {
        runSubAction: that._runSubPageAction.bind(that),
        enterAction: nixps.pagebuilderPage.actionsImmunity.enterAction.bind(nixps.pagebuilderPage.actionsImmunity),
        leaveAction: nixps.pagebuilderPage.actionsImmunity.leaveAction.bind(nixps.pagebuilderPage.actionsImmunity)
      });
    },
    _runActionFunctions: function _runActionFunctions(actionFunctions, pEvent, pData, pPreviousResults) {
      var that = this;
      if (Array.isArray(actionFunctions) && actionFunctions.length > 0) {
        var outputActionFunctions = [];
        for (var a = 0; a < actionFunctions.length; a++) {
          if (actionFunctions[a].hasPreActionFunction()) {
            outputActionFunctions.push(actionFunctions[a].getPreActionFunction().clone());
          }
          outputActionFunctions.push(actionFunctions[a]);
          if (actionFunctions[a].hasPostActionFunction()) {
            outputActionFunctions.push(actionFunctions[a].getPostActionFunction().clone());
          }
        }
        var resul = Promise.resolve(this._runActionFunction(outputActionFunctions[0], pEvent, pData, pPreviousResults));
        for (var f = 1; f < outputActionFunctions.length; f++) {
          (function (pIndex) {
            resul = resul.then(function (pPreviousResults) {
              if (pPreviousResults === true) {
                return true;
              }
              return that._runActionFunction(outputActionFunctions[pIndex], pEvent, pData, pPreviousResults);
            }, function (pError) {
              console.error(pError);
              return Promise.reject(pError);
            });
          })(f);
        }
        return resul;
      } else {
        return Promise.resolve({});
      }
    },
    /**
     * @description load and draw the page, bind and unbind the event listeners
     * @function
     * @name nixps-pagebuilder.CustomPageComponent#_loadAndDraw
     * @private
     * @return {unresolved}
     */
    _loadAndDraw: function _loadAndDraw(pTextualReasonToDraw) {
      clearTimeout(this.refreshTimeoutID);
      // prepare and calc the correct page url
      this.pageUrl = undefined; // this must be a cloudflow path starting with "cloudflow://"
      this.pageHTML = undefined; // object containing the page content
      if (this.options.url.length > 0) {
        if (this.options.url.length < 6 || this.options.url.endsWith(".html") === false) {
          this._setErrorState({
            error_code: "invalid_url",
            error: "url must end with .html"
          });
          return Promise.reject({
            error_code: "invalid_url",
            error: "url must end with .html"
          });
        }
        this.pageUrl = new CloudflowURL(this.options.relativeBasePath, this.options.url, true).getCloudflowPath();
        this.relativePathChildren = getFoldername(this.pageUrl);
        // Ask permission to draw to all parents, to prevent infinity loops 
        if (this._trigger("beforedrawed", null, {
          pageUrl: this.pageUrl,
          uuid: this.uuid
        }) === false) {
          this._setErrorState({
            error_code: "infinite_refrece_loop",
            error: "self referenced loop detected"
          });
          return Promise.reject({
            error_code: "infinite_refrece_loop",
            error: "self referenced loop detected"
          });
        }
      } else if ($.isEmptyObject(this.options.HTMLPageJSON) === false) {
        try {
          this.pageHTML = HTMLPage.fromJSON(this.options.HTMLPageJSON);
          if (this.pageHTML.getVersion() > this.options.currentVersion) {
            throw new Error("futureversion");
          }
        } catch (error) {
          this._setErrorState({
            error_code: "invalid_HTMLPage",
            error: error.message,
            child: error
          });
          // error goes not through promise
          return Promise.reject({
            error_code: "invalid_HTMLPage",
            error: error.message
          });
        }
        if (typeof this.options.relativeBasePath === "string" && this.options.relativeBasePath.length > 0) {
          this.relativePathChildren = this.options.relativeBasePath;
        }
      }
      // load and make the page
      var that = this;
      try {
        this.contextFactory = new Context(this.options.contextConnector, this.options.contextCollection, this.options.contextKey);
      } catch (error) {
        this._setErrorState({
          error_code: "invalid_context",
          error: error.message,
          child: error
        });
        return Promise.reject({
          error_code: "invalid_context",
          error: error.message
        });
      }
      this._startBlokking(this.contextFactory.canTakeTime(), 950);
      this.drawID++;
      var pageVariableDef = this.contextFactory.loadDataAndReturnsMe({
        use_cache: this.contextFactory.mayUseCache()
      }, this._informDuringBlokking.bind(this));
      return $.when(this.drawID, this._getAndLoadHTMLPageHandler(this.pageUrl, this.pageHTML), pageVariableDef, User.get(), License.get(), Consent.get(), getHost()).then(function (drawID, pResult, pContext, pUser, pLicense, pConsent, pHost) {
        if (that.drawID !== drawID) {
          console.warn(that.widgetName + ": Prevent drawing Custom Page Component because drawing id does not correspond");
          return;
        }
        that._endBlokking();
        if (that.alive === false) {
          // debugger;
          return Promise.reject({
            "error_code": "not_alive"
          });
        }
        if (typeof pResult.error_code === "string" && pResult.error_code.length > 0) {
          that._setErrorState({
            error_code: pResult.error_code,
            error: pResult.error || pResult.error_message
          });
        } else if (pResult.HTMLPage !== undefined) {
          var htmlPage = pResult.HTMLPage.clone();
          that.user = pUser;
          that.license = pLicense;
          that.consent = pConsent;
          that.host = pHost;
          that.form = htmlPage.getElements();
          that.layout = htmlPage.getLayout().toJSON();
          that.subActions = htmlPage.getSubActions().clone();
          that.subActions.addActions(htmlPage.getAllPrivateSubActions());
          // check doubles action ids, becuase that can cause some actions never be called
          var actionIDs = that.subActions.getActions().map(function (e) {
            return e.getParameters().getID();
          });
          if (actionIDs.length !== new Set(actionIDs).size) {
            that._setErrorState({
              error_code: "duplicates_action_ids",
              error: "found duplicates ids in " + actionIDs.join(",")
            });
          }
          that.beforeDrawActions = htmlPage.hasOnloadBeforedrawActions() ? htmlPage.getOnloadBeforedrawActions() : undefined;
          that.afterDrawActions = htmlPage.hasOnloadAfterdrawActions() ? htmlPage.getOnloadAfterdrawActions() : undefined;
          // check restrictions
          if (htmlPage.hasAccessRestrictions()) {
            if (htmlPage.getAccessRestrictions().admin_only === true) {
              if (pUser.hasAdminPermissions() === false) {
                that._accessRestrictionFailed();
                return;
              }
            }
            if (Array.isArray(htmlPage.getAccessRestrictions().user_attributes) && htmlPage.getAccessRestrictions().user_attributes.length > 0) {
              var endResult = false;
              for (var i = 0; htmlPage.getAccessRestrictions().user_attributes.length > i; i++) {
                if (pUser.getAttributesName().includes(htmlPage.getAccessRestrictions().user_attributes[i]) === false) {
                  endResult = false;
                } else {
                  endResult = true;
                  break;
                }
              }
              if (endResult === false) {
                that._accessRestrictionFailed();
                return;
              }
            }
            if (typeof htmlPage.getAccessRestrictions().user_permission === "string" && htmlPage.getAccessRestrictions().user_permission.length > 0) {
              if (pUser.hasPermission(htmlPage.getAccessRestrictions().user_permission) === false) {
                that._accessRestrictionFailed();
                return;
              }
            }
            if (typeof htmlPage.getAccessRestrictions().license === "string" && htmlPage.getAccessRestrictions().license.length > 0) {
              if (pLicense.check(htmlPage.getAccessRestrictions().license) === false) {
                that._accessRestrictionFailed();
                return;
              }
            }
          }
          var contextFactoryDef = pContext;
          if (that.contextFactory.isInitiateAsEmpty() && htmlPage.hasDefaultContext() === true) {
            var defaultContextFactory = Context.fromJSON(htmlPage.getDefaultContext());
            if (defaultContextFactory.isInitiateAsEmpty() === false) {
              contextFactoryDef = defaultContextFactory.loadDataAndReturnsMe({});
            }
          }
          var externalFileReferences = htmlPage.getExternalFileURLs(that.url);
          var externalsDefs = {};
          if (externalFileReferences.length > 0) {
            var defs = [];
            for (var i = 0; i < externalFileReferences.length; i++) {
              defs.push($.getJSON(externalFileReferences[i].uploadURL));
            }
            externalsDefs = $.when.apply($, defs);
          }
          if (htmlPage.hasExtraTranslation() === true) {
            var folderPath = htmlPage.getExtraTranslationPath();
            var path = new CloudflowURL(that.options.relativeBasePath, folderPath, true).getUploadPath();
            var templateFileName = htmlPage.getExtraTranslationFileTemplate();
            var translationHandler = new TranslationHandler("file", {
              basepath: path,
              filenametemplate: templateFileName,
              languages: [that.options.language]
            }, [that.options.language]);
            return $.when(contextFactoryDef, translationHandler.loadData(), externalsDefs).done(function (pContextToUse, pExternalFiles) {
              if (that.alive === false) {
                return;
              }
              that.context = pContextToUse;
              that.expressionUtil = new ExpressionToJS(that.context, that.user);
              translationHandler.applyLanguage(that.options.language);
              // draw will remove the waiting icon
              that._draw(pTextualReasonToDraw);
            }).fail(function (pError) {
              console.error(pError);
              that.context = {};
              that.expressionUtil = new ExpressionToJS(that.context, that.user);
              // draw will remove the waiting icon
              that._draw(pTextualReasonToDraw); // still draw but without translations
            });
          } else {
            return $.when(contextFactoryDef, externalsDefs).then(function (pContextToUse, pExternalFiles) {
              if (that.alive === false) {
                return;
              }
              that.context = pContextToUse;
              that.expressionUtil = new ExpressionToJS(that.context, that.user);
              // draw will remove the waiting icon
              that._draw(pTextualReasonToDraw);
            }).fail(function (pError) {
              that.context = null;
              that.user = undefined;
              that.license = undefined;
              that.consent = undefined;
              that.host = undefined;
              that.expressionUtil = undefined;
              that.form = undefined;
              that.layout = undefined;
              that.subActions = undefined;
              that.beforeDrawActions = undefined;
              that.afterDrawActions = undefined;
              that._endBlokking();
              if (pError instanceof Context) {
                that._setErrorState(pError.getError());
              } else {
                that._setErrorState(pError);
              }
            });
          }
        }
      }).fail(function (pError) {
        that.context = null;
        that.user = undefined;
        that.license = undefined;
        that.consent = undefined;
        that.host = undefined;
        that.expressionUtil = undefined;
        that.form = undefined;
        that.layout = undefined;
        that.subActions = undefined;
        that.beforeDrawActions = undefined;
        that.afterDrawActions = undefined;
        that._endBlokking();
        if (pError instanceof Context) {
          that._setErrorState(pError.getError());
        } else {
          that._setErrorState(pError);
        }
      });
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponent#_draw
     * @return {undefined} 
     */
    _draw: function _draw(pTextualReasonToDraw) {
      var that = this;
      var form = this.form.toJSON();
      // inject for specific components
      var elements = form.elements;
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].type === "component") {
          if (elements[i].element.options.relativeBasePath === "") {
            elements[i].element.options.relativeBasePath = this.relativePathChildren;
          }
          if (needUserData(elements[i].element.type)) {
            if (elements[i].element.options.username === "<fullname>") {
              elements[i].element.options.username = this.user.getFullName();
            }
            if (elements[i].element.options.email === "<user_email>") {
              elements[i].element.options.email = this.user.getEmail();
            }
            if (elements[i].element.options.user === "<user>") {
              elements[i].element.options.user = this.user;
            }
          }
          if (needLicense(elements[i].element.type)) {
            if (elements[i].element.options.license === "<license>") {
              elements[i].element.options.license = this.license;
            }
          }
          if (needConfigID(elements[i].element.type)) {
            if (elements[i].element.options.configID === "<config_id>") {
              elements[i].element.options.configID = elements[i].element.id;
            } else if (elements[i].element.options.listOptions !== undefined && elements[i].element.options.listOptions.configID === "<config_id>") {
              elements[i].element.options.listOptions.configID = elements[i].element.id;
            }
          }
          if (needContext(elements[i].element.type)) {
            elements[i].element.options = CloudflowObject.travers(elements[i].element.options, function (pString, pKey) {
              if (pString === "<context>" && pKey.endsWith("context")) {
                if (that.options.context === null && that.context !== null) {
                  // fallback for old pages and (dialogs) actions
                  return that.context;
                }
                return that.options.context;
              }
              return pString;
            });
          }
          if (needConsent(elements[i].element.type)) {
            if (elements[i].element.options.consent === "<consent>") {
              elements[i].element.options.consent = this.consent;
            }
          }
          if (needHost(elements[i].element.type)) {
            if (elements[i].element.options.host === "<host>") {
              elements[i].element.options.host = this.host;
            }
          }

          // for everybody how has tha option on that value
          if (elements[i].element.options.isInEditor === "<isInEditor>") {
            elements[i].element.options.isInEditor = this.options.isInEditor;
          }
          if (Array.isArray(elements[i].actionList) && elements[i].actionList.length > 0) {
            var componentLayoutInfo = ActionList.fromJSON(elements[i].actionList).getComponentLayoutInfo();
            if (Array.isArray(componentLayoutInfo) && componentLayoutInfo.length > 0) {
              elements[i].element.options.eventtriggerLayoutInfo = componentLayoutInfo;
            }
            // delete the actionList of the clone, actions are created by the orig form
            // prevent errors in value composers in actions
            elements[i].actionList = undefined;
          }
          // apply on each component, independend of existing options
          elements[i].element.options.language = this.options.language;
        }
      }
      if (this.expressionUtil !== undefined) {
        var result = this.expressionUtil.applyOnObject(form, undefined, function (pError) {
          that._trigger("error", null, {
            error: pError
          });
        });
        if (result === undefined || $.isPlainObject(result.translatedObject) === false) {
          this._setErrorState({
            error_code: "invalid_valuecomposer",
            error: "could not translate from valuecomposer object to translated object"
          });
          return;
        }
        form = result.translatedObject;
      }
      var origHeight = undefined;
      if (pTextualReasonToDraw === "internal_redirect") {
        origHeight = this.element.height();
      }
      this.element.empty().removeClass("custompagecomponent_errorstate");
      var panel = $('<div>');
      this.element.append(panel);
      panel.LayoutRenderer({
        "layout": this.layout,
        "idAttribute": "id",
        "idPrefix": "__cpc" + this.uuid + "_",
        "renderOptions": {
          "pageClasses": "cf-pageframe",
          "centerClasses": "cf-pagecontent",
          "northClasses": "layoutcompass_ignore",
          "eastClasses": "layoutcompass_ignore",
          "westClasses": "layoutcompass_ignore",
          "centerRenderOptions": {
            "northClasses": "layoutcompass_ignore",
            "eastClasses": "layoutcompass_ignore",
            "westClasses": "layoutcompass_ignore"
          }
        }
      });
      // translate the form
      form = CloudflowObject.travers(form, function (pString) {
        if (regExpVariable.test(pString)) {
          // if begin with ${ and end with }
          // remove ${ and }
          var variableName = pString.slice(2, -1); // remove ${ and }
          var translated = $.i18n.dict[variableName];
          // only translate if dictionary knows, ${} are also used in actions like ${prevar.url}
          if (translated !== undefined) {
            return translated;
          }
        }
        return pString;
      });
      var formClass = Form.fromJSON(form);
      for (var i = 0; i < formClass.getElements().length; i++) {
        var formElement = formClass.getElements()[i];
        var formComponent = panel.find("#__cpc" + this.uuid + "_" + formElement.getComponentID());
        if (formComponent.length === 0) {
          continue;
        }
        try {
          var componentOptions = formElement.getElement().getOptions();
          if (this.doneQueue !== null) {
            componentOptions.created = this.doneQueue.generateDoneCallBack(formElement.getComponentID() + " " + formElement.getElement().getType());
          }
          if (formElement.getElement().getWidgetFramework()) {
            WebFramework.constructLive(formElement.getElement().getWidgetFramework(), formComponent[0], formElement.getElement().getType(), componentOptions);
          } else {
            // fallback
            formComponent[formElement.getElement().getType()](componentOptions);
          }
        } catch (pError) {
          console.error(pError);
          formComponent.addClass("errorState");
        }
        if (formElement.hasBackground()) {
          formComponent.css("background", formElement.getBackground());
        }
        if (formElement.hasFontColor()) {
          formComponent.css("color", formElement.getFontColor());
        }
      }
      if (typeof origHeight === "number" && origHeight > 38) {
        if (this.element.height() < origHeight) {
          this.element.css("minHeight", origHeight);
        }
      }

      // bind the event listeners
      this._applyCustomActions(this.form);
      if (pTextualReasonToDraw !== "refresh" && this.afterDrawActions !== undefined && this.options.isInEditor === false && this.doneQueue !== null) {
        this.doneQueue.informAllDone(function () {
          setTimeout(function () {
            var actionFunctions = [];
            var actions = that.afterDrawActions.getActions();
            for (var i = 0; i < actions.length; i++) {
              if (actions[i].getType() === Action.type.JQUERYEVENTPAGETRIGGER) {
                actionFunctions = actionFunctions.concat(actions[i].getParameters().getActionFunctions());
              } else if (actions[i].getType() === "actionFunction") {
                actionFunctions.push(actions[i].getParameters());
              } else {
                console.error("CustompageComponent: unknown action type " + actions[i].getType());
              }
            }
            var customAfterDrawEvent = $.Event("nixpsAfterDraw");
            $(panel).trigger(customAfterDrawEvent);
            var data = {
              isEmbeddedPage: true
            };
            LogListener.addLog({
              event_type: "start_action",
              event_name: "after_draw",
              details_data: data,
              page_url: that.pageUrl,
              debug: undefined
            });
            Promise.resolve(that._runActionFunctions(actionFunctions, customAfterDrawEvent, data, {}))["catch"](function (pError) {
              LogListener.addLog({
                event_type: "error",
                details_data: pError,
                page_url: that.pageUrl,
                debug: pError.debug,
                component_name: that.options.publicParentWidgetName,
                component_css_selector: that._retrieveDebugCSSSelector(that.element)
              });
              return Promise.reject(pError);
            });
          });
        });
      }
      var triggerData = {
        reason_to_draw: pTextualReasonToDraw,
        page_url: this.pageUrl
      };
      if (this.options.isInEditor === true && this.subActions) {
        triggerData.sub_actions = this.subActions.clone();
        var componentID = this.element.attr("id");
        if (typeof componentID === "string" && componentID.length > 0) {
          if (componentID.indexOf("__cpc") === 0) {
            // remove subfix 
            componentID = componentID.replace(/^(__cpc[azAZ09-]+_)(.*)$/, "$2");
          }
          triggerData.component_id = componentID;
        }
      }
      this._trigger("drawed", null, triggerData);
      this._triggerRefresh();
    },
    _retrieveDebugCSSSelector: function _retrieveDebugCSSSelector(pElement, pCurrentSelector) {
      if (LogListener.isActive() === true) {
        var globaleCSSSelectors = [];
        var globaleCSSSelector = "";
        if (pElement.closest(this.element).length === 0) {
          // element is outside the custom page conponent and ignore pCurrentSelector
          var selector = this.element.attr("data-pb-debugselection");
          if (typeof selector === "string" && selector.length > 0) {
            globaleCSSSelector = decodeURIComponent(selector);
          }
        } else {
          var firstSelector = pElement.attr("data-pb-debugselection");
          if (typeof firstSelector === "string" && firstSelector.length > 0) {
            globaleCSSSelectors.push(decodeURIComponent(firstSelector));
          }
          pElement.parents().each(function () {
            if ($(this).is("[data-pb-debugselection]")) {
              var selector = $(this).attr("data-pb-debugselection");
              if (typeof selector === "string" && selector.length > 0) {
                globaleCSSSelectors.push(decodeURIComponent(selector));
              }
            }
          });
          globaleCSSSelector = globaleCSSSelectors.reverse().join(" ");
          if (typeof pCurrentSelector === "string") {
            globaleCSSSelector += " " + pCurrentSelector;
          }
        }
        return globaleCSSSelector.trim();
      }
      return null;
    },
    /**
     * @description run a public sub action 
     * @function
     * @name nixps-pagebuilder.CustomPageComponent#runSubPageAction
     * @param {String} pID the id of the sub action
     * @param {String} pName the name of the sub action
     * @param {Object} pInputParameters 
     * @param {Object} pEvent the event object of the parent function
     * @param {Object} pData the event data
     * @param {Object} pPreviousResults previous object of previous action   
     * @returns {Deferred}  
     */
    runSubPageAction: function runSubPageAction(pID, pName, pInputParameters, pEvent, pData, pPreviousResults) {
      if (pInputParameters === undefined) {
        pInputParameters = {};
      }
      if (pData === undefined) {
        pData = {};
      }
      if (pPreviousResults === undefined) {
        pPreviousResults = {};
      }
      if (this.subActions === undefined && this.form === undefined) {
        var errorObject = {
          error_code: "page_failed_loading",
          error: "subactions can not be called because the page was not loaded correctly"
        };
        console.error(errorObject.error);
        LogListener.addLog({
          event_type: "error",
          details_data: errorObject,
          page_url: this.pageUrl,
          component_name: this.options.publicParentWidgetName,
          component_css_selector: this._retrieveDebugCSSSelector(this.element)
        });
        return Promise.reject(errorObject);
      }
      if (this.subActions === undefined) {
        var errorObject = {
          error_code: "missing_subactions",
          error: "subactions can not be called, because they are missing."
        };
        console.error(errorObject.error);
        LogListener.addLog({
          event_type: "error",
          details_data: errorObject,
          page_url: this.pageUrl,
          component_name: this.options.publicParentWidgetName,
          component_css_selector: this._retrieveDebugCSSSelector(this.element)
        });
        return Promise.reject(errorObject);
      }
      var actions = this.subActions.getActions();
      if (actions.length === 0) {
        var errorObject = {
          error_code: "no_subactions_present",
          error: "no subactions present"
        };
        console.error(errorObject.error);
        LogListener.addLog({
          event_type: "error",
          details_data: errorObject,
          page_url: this.pageUrl,
          component_name: this.options.publicParentWidgetName,
          component_css_selector: this._retrieveDebugCSSSelector(this.element)
        });
        return Promise.reject(errorObject);
      }
      var passedPublicSubPageActionNames = [];
      for (var i = 0; i < actions.length; i++) {
        if (actions[i].getType() !== Action.type.SUBPAGEACTION) {
          throw new Error("wrong_actiontype: only type subAction is allowed here");
        }
        var subAction = actions[i].getParameters();
        if (subAction.getAccessControl() === "public") {
          if (typeof pID === "string" && pID.length > 0 && subAction.getID() === pID) {
            return this._runSubPageAction(pID, pEvent, {
              inputParameters: pInputParameters,
              eventData: pData
            }, pPreviousResults);
          } else if (typeof pName === "string" && pName.length > 0 && subAction.getName() === pName) {
            return this._runSubPageAction(subAction.getID(), pEvent, {
              inputParameters: pInputParameters,
              eventData: pData
            }, pPreviousResults);
          } else {
            passedPublicSubPageActionNames.push(subAction.getName());
          }
        }
      }
      if (passedPublicSubPageActionNames.length === 0) {
        var errorObject = {
          error_code: "no_public_subactions",
          error: "all sub actions are private"
        };
        console.error(errorObject.error);
        LogListener.addLog({
          event_type: "error",
          details_data: errorObject,
          page_url: this.pageUrl,
          component_name: this.options.publicParentWidgetName,
          component_css_selector: this._retrieveDebugCSSSelector(this.element)
        });
        return Promise.reject(errorObject);
      } else {
        var errorObject = {
          error_code: "no_public_subaction_found",
          error: "no public subaction found who matches" + pID + " '" + pName + "', the list we found is: " + passedPublicSubPageActionNames.map(function (pName) {
            return "'" + pName + "'";
          }).join(", ")
        };
        console.error(errorObject.error);
        LogListener.addLog({
          event_type: "error",
          details_data: errorObject,
          page_url: this.pageUrl,
          component_name: this.options.publicParentWidgetName,
          component_css_selector: this._retrieveDebugCSSSelector(this.element)
        });
        return Promise.reject(errorObject);
      }
    },
    /**
     * @function
     * @description Get all the info of the historical states
     * @name nixps-pagebuilder.CustomPageComponent#getHistoryStates
     * @returns {Object} containg the history of the url state
     */
    getHistoryStates: function getHistoryStates() {
      return {
        "historyStates": $.extend(true, [], this.historyPushStates),
        "currentState": {
          url: this.options.url,
          HTMLPageJSON: this.options.HTMLPageJSON,
          contextConnector: this.options.contextConnector,
          contextCollection: this.options.contextCollection,
          contextKey: this.options.contextKey,
          context: this.options.context
        }
      };
    },
    /**
     * @description refresh the cpc with the new context
     * @function
     * @name nixps-pagebuilder.CustomPageComponent#refresh
     * @param {String} pContextConnector The connector
     * @param {String} pContextCollection The collection
     * @param {mixed} pContextKey The key of the new context
     * @param {Boolean} pForce Must we check if the data has been changed
     * @param {Context} pRootContextRef The new Context reference, ignor if undefined and do not act on it durring action
     * @param {Boolean} pCheckLoading 
     * @param {Boolean} pOrigStateURL must we go the the original url or not
     * @returns {Deferred} the deferred object after drawing
     */
    refresh: function refresh(pContextConnector, pContextCollection, pContextKey, pForce, pRootContextRef, pCheckLoading, pOrigStateURL) {
      this.options.contextConnector = pContextConnector;
      this.options.contextCollection = pContextCollection;
      this.options.contextKey = pContextKey;
      // set the new Context references, ignore if undefined, 
      // only set, do not act on it
      this._setNewContext(pRootContextRef);
      if (pCheckLoading === undefined) {
        pCheckLoading = true;
      }
      if (pCheckLoading === true && this.isLoadingToDraw === true) {
        // component is current loading data to display, strange
        // do nothing for the moment
        return {
          refreshed: false,
          reason: "init_loading_bussy"
        };
      }
      if (pOrigStateURL === true && this.historyPushStates.length > 0) {
        if (typeof this.options.url === "string" && this.options.url.length > 0 && this.options.url === this.historyPushStates[0].url) {
          // url stays the same
          this.historyPushStates = []; // reset history
          // continue like other cases
        } else {
          this.options.url = this.historyPushStates[0].url; // apply orig state 
          this.options.HTMLPageJSON = this.historyPushStates[0].HTMLPageJSON;
          this.historyPushStates = []; // reset history
          return this._loadAndDraw("refresh").then(function () {
            return {
              refreshed: true
            };
          });
        }
      }
      if (this.user === undefined) {
        // error occured durring loading, retry
        return this._loadAndDraw("refresh").then(function () {
          return {
            refreshed: true
          };
        });
      } else {
        // only pagebuilder variables need to be updated
        var that = this;
        try {
          this.contextFactory = new Context(this.options.contextConnector, this.options.contextCollection, this.options.contextKey);
        } catch (error) {
          this._setErrorState({
            error_code: "invalid_context",
            error: error.message,
            child: error
          });
          return Promise.reject({
            error_code: "invalid_context",
            error: error.message
          });
        }
        this._startBlokking(this.contextFactory.canTakeTime(), 950);
        clearTimeout(this.refreshTimeoutID); // set refresing timer on hold
        this.drawID++;
        var pageVariableDef = this.contextFactory.loadDataAndReturnsMe({
          use_cache: this.contextFactory.mayUseCache()
        }, this._informDuringBlokking.bind(this));
        return $.when(this.drawID, pageVariableDef).then(function (pDrawID, pContext) {
          if (that.drawID !== pDrawID) {
            console.warn(that.widgetName + ": Prevent drawing Custom Page Component because drawing id does not correspond");
            // restart refreshing loop
            that._triggerRefresh();
            return {
              refreshed: false,
              reason: "other_refreshing_bussy"
            };
          }
          if (that.alive === false) {
            return {
              refreshed: false,
              reason: "zombie"
            }; // zombie
          }

          that._endBlokking();
          var oldData = that.context !== null ? that.context.getData() : {};
          var newData = pContext.getData();
          // check if forcing is not on true
          if (pForce !== true) {
            // check if data has been changed
            var newChangeKey = newData.save_id || newData.modification;
            if (newChangeKey !== undefined) {
              // save id and modification exists
              var oldChangeKey = oldData.save_id || oldData.modification;
              if (oldChangeKey === newChangeKey) {
                // restart refreshing loop
                that._triggerRefresh();
                return {
                  refreshed: false,
                  reason: "no_changes_detected"
                }; // no changes detected
              }
            } else if (window._ !== undefined && typeof _.isEqual === "function" && _.isEqual(oldData, newData) === true) {
              // restart refreshing loop
              that._triggerRefresh();
              return {
                refreshed: false,
                reason: "no_changes_detected"
              }; // no changes detected
            }
          }

          that.context = pContext;
          that.expressionUtil = new ExpressionToJS(that.context, that.user);
          that._draw("refresh");
          return {
            refreshed: true
          };
          // refreshing timer has been restarted in the _draw function
        }, function (pError) {
          console.error("failed refresh");
          that._endBlokking();
          if (pError instanceof Context) {
            // restart refreshing loop
            that._triggerRefresh();
            that._setErrorState(pError.getError());
            return Promise.reject(pError);
          }
          that._setErrorState(pError);
          // restart refreshing loop
          that._triggerRefresh();
          return Promise.reject(pError);
        });
      }
    },
    refreshMaintainContext: function refreshMaintainContext(pForce, pUseOriginalStateURL) {
      if (pUseOriginalStateURL === true && this.historyPushStates.length > 0) {
        var orgContextConnector = this.options.contextConnector;
        var orgContextCollection = this.options.contextCollection;
        var orgContextKey = this.options.contextKey;
        var orgContext = this.options.context;
        this.options.contextConnector = this.historyPushStates[0].contextConnector;
        this.options.contextCollection = this.historyPushStates[0].contextCollection;
        this.options.contextKey = this.historyPushStates[0].contextKey;
        this.options.context = this.historyPushStates[0].context;
      }
      if (this.options.contextConnector === "object" && this.options.context instanceof Context) {
        var that = this;
        this._startBlokking(this.options.context.canTakeTime(), 950);
        clearTimeout(this.refreshTimeoutID); // set refreshing timer on hold
        return $.when(this.options.context.loadData()).then(function (pData) {
          that.options.contextKey = pData;
          return that.refresh(that.options.contextConnector, that.options.contextCollection, that.options.contextKey, pForce, undefined, false, pUseOriginalStateURL);
        }, function (pError) {
          console.error("failed refreshMaintainContext");
          that._endBlokking();
          // restart refreshing loop
          if (pUseOriginalStateURL === true) {
            // reset 
            that.options.contextConnector = orgContextConnector;
            that.options.contextCollection = orgContextCollection;
            that.options.contextKey = orgContextKey;
            that.options.context = orgContext;
          }
          that._triggerRefresh();
          return Promise.reject(pError);
        });
      }
      return this.refresh(this.options.contextConnector, this.options.contextCollection, this.options.contextKey, pForce, undefined, undefined, pUseOriginalStateURL);
    },
    _triggerRefresh: function _triggerRefresh() {
      clearTimeout(this.refreshTimeoutID);
      if (typeof this.options.refreshDelay === "number" && this.options.refreshDelay > 1000) {
        this.refreshTimeoutID = this._delay(function () {
          if (this.alive === false) {
            return; // zombie
          }

          if (this.element.is(":visible") === true && document.hidden !== true) {
            this.refreshMaintainContext(undefined, false);
          } else {
            this._triggerRefresh();
          }
        }, this.options.refreshDelay);
      }
    },
    _setNewContext: function _setNewContext(pContext) {
      if (pContext instanceof Context) {
        this.options.context = pContext;
      } else if ($.isPlainObject(pContext) && $.isEmptyObject(pContext) === false) {
        this.options.context = Context.fromJSON(pContext);
      }
    },
    /**
     * @description Set the style corresponding the input options
     * @name nixps-pagebuilder.CustomPageComponent#_setStyle
     * @function
     * @private
     * @return {undefined}
     */
    _setStyle: function _setStyle() {
      if (this.options.minHeight !== undefined && this.options.minHeight !== null) {
        this.element.css("min-height", this.options.minHeight);
      }
    },
    /**
     * @description We could not load and shoe correctly, Do the nessesary things
     * @function
     * @name nixps-pagebuilder.CustomPageComponent#_setErrorState
     * @private
     * @param {Object} pError
     * @return {undefined}
     */
    _setErrorState: function _setErrorState(pError) {
      this.element.empty().addClass("custompagecomponent_errorstate").append($("<div>").text(this.options.failLoadMessage));
      var errorObj = {};
      if ($.isPlainObject(pError)) {
        errorObj = pError;
      } else {
        errorObj = {
          error_code: pError,
          error: ""
        };
      }
      if (errorObj.child instanceof Error) {
        // draw the real stack on the console
        console.error("CustomPageComponent: ", errorObj.child);
      } else {
        console.error("CustomPageComponent: " + errorObj.error_code, errorObj.error);
      }
      var debug = undefined;
      if (pError && pError.debug) {
        debug = pError.debug;
        delete pError.debug;
      }
      LogListener.addLog({
        event_type: "error",
        details_data: errorObj,
        page_url: this.pageUrl,
        debug: debug,
        component_name: this.options.publicParentWidgetName,
        component_css_selector: this._retrieveDebugCSSSelector(this.element)
      });
      this._trigger("error", null, errorObj);
    },
    /**
     * @description hide the cpc is the user is not allowed to see it.
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponent#_accessRestrictionFailed
     * @returns {undefined}
     */
    _accessRestrictionFailed: function _accessRestrictionFailed() {
      LogListener.addLog({
        event_type: "error",
        details_data: {
          error_code: "wrong_access_permissions",
          error: "The user has the wrong access permissions"
        },
        page_url: this.pageUrl,
        debug: {
          resource: "webpage",
          url: this.pageUrl
        },
        component_name: this.options.publicParentWidgetName,
        component_css_selector: this._retrieveDebugCSSSelector(this.element)
      });
      this.element.empty().addClass("custompagecomponent_errorstate");
    },
    /**
     * @description function runs when parents ask to reload because the soure has been changed
     * @function
     * @name nixps-pagebuilder.CustomPageComponent#pageURLContentChange
     * @private
     * @param {String} pURL 
     * @returns Deferered
     */
    pageURLContentChange: function pageURLContentChange(pURL) {
      if (typeof pURL === "string" && pURL.length > 0 && this.pageUrl === pURL) {
        // clear cache
        pageDict[this.pageUrl] = undefined;
        // redraw
        return this._loadAndDraw("page_url_content_change");
      }
      return $.when({});
    },
    /**
     * @description Function to retrieve and cache the html pages
     * @function
     * @name nixps-pagebuilder.CustomPageComponent#_getAndLoadHTMLPageHandler
     * @private
     * @param {type} pPageUrl
     * @return {pageDict|nixps-pagebuilder-CustomPageComponentL#8.pageDict}
     */
    _getAndLoadHTMLPageHandler: function _getAndLoadHTMLPageHandler(pPageUrl, pHTMLPage) {
      if (typeof pPageUrl === "string") {
        var that = this;
        if (pageDict[pPageUrl] === undefined) {
          var page = new HTMLPageHandler(pPageUrl, "tempory created");
          pageDict[pPageUrl] = page.loadAndGet(true, this._getUIMode(), this.options.currentVersion).then(function (r) {
            return r;
          }, function (e) {
            if ($.isPlainObject(that.options.failBackHTMLPageJSON)) {
              // if there is a fallback, save the fallback and pretent it is good
              that.pageHTML = HTMLPage.fromJSON(that.options.failBackHTMLPageJSON);
              if (that.pageHTML.getVersion() > that.options.currentVersion) {
                throw new Error("futureversion");
              }
              pageDict[pPageUrl] = {
                "HTMLPage": that.pageHTML
              }; // resolve
              return pageDict[pPageUrl];
            }
            delete pageDict[pPageUrl];
            return Promise.reject(e);
          });
        }
        return pageDict[pPageUrl];
      } else if (pHTMLPage !== undefined) {
        return {
          "HTMLPage": pHTMLPage
        };
      } else {
        return Promise.reject({
          error_code: "wrong_interface",
          error: "_getAndLoadHTMLPageHandler: wrong input parameters, configuration is missing to retrieve the content"
        });
      }
    },
    _startBlokking: function _startBlokking(pShowFreezeOverlay, delay) {
      this.isLoadingToDraw = true;
      if (pShowFreezeOverlay === true && this.blokkingID === undefined && typeof delay === "number" && delay >= 0 && $.fn.FreezeOverlay !== undefined) {
        this.blokkingID = this._delay(function () {
          var freezeOverlay = $('<div>');
          this.element.append(freezeOverlay);
          freezeOverlay.FreezeOverlay(Object.assign(this.options.waitingOptions, {
            useFlex: true
          }));
          freezeOverlay.FreezeOverlay("show");
        }, delay);
      }
    },
    _endBlokking: function _endBlokking() {
      clearTimeout(this.blokkingID);
      this.blokkingID = undefined;
      this.element.children(".nixps-FreezeOverlay").remove();
      this.isLoadingToDraw = false;
    },
    _informDuringBlokking: function _informDuringBlokking(pProgressEvent, pNotifyData) {
      if (this.options.showMilestoneProgress === true) {
        var textToShow;
        if (typeof pNotifyData.milestone === "string") {
          textToShow = WhitepaperConnection.parseMilestone(pNotifyData.milestone, this.options.language);
        }
        if (typeof textToShow === "string") {
          this.element.children(".nixps-FreezeOverlay").FreezeOverlay("option", "text", textToShow);
        }
      }
    },
    _getUIMode: function _getUIMode() {
      if (window.nixps !== undefined && nixps.pagebuilderPage !== undefined && typeof nixps.pagebuilderPage.UIMode === "string" && nixps.pagebuilderPage.UIMode.length > 0) {
        return nixps.pagebuilderPage.UIMode;
      } else if ($.ui !== undefined && typeof $.ui.nixpsUIMode === "string" && $.ui.nixpsUIMode.length > 0) {
        // backwards compability, we used $.ui.nixpsUIMode in the past
        return $.ui.nixpsUIMode;
      } else {
        return null;
      }
    },
    _setOptions: function _setOptions(options) {
      var restyle = false;
      var redraw = false;
      if (options.minHeight !== undefined && options.minHeight !== this.options.minHeight) {
        restyle = true;
      }
      if (options.url !== undefined && options.url !== this.options.url) {
        redraw = true;
      } else if (options.relativeBasePath !== undefined && options.relativeBasePath !== this.options.relativeBasePath) {
        redraw = true;
      } else if (options.currentVersion !== undefined && options.currentVersion !== this.options.currentVersion) {
        redraw = true;
      }
      if (options.contextCollection !== undefined && options.contextCollection !== this.options.contextCollection) {
        redraw = true;
      } else if (options.contextKey !== undefined && _.isEqual(options.contextKey, this.options.contextKey) === false) {
        redraw = true;
      }
      if (options.HTMLPageJSON !== undefined && _.isEqual(options.HTMLPageJSON, this.options.HTMLPageJSON) === false) {
        redraw = true;
      }
      this._superApply(arguments);
      this._controlOptions();
      if (restyle === true) {
        this._setStyle();
      }
      if (options.context !== undefined) {
        this._setNewContext(this.options.context);
      }
      if (redraw === true) {
        this._loadAndDraw("options_changed");
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponent#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-pagebuilder.CustomPageComponent#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.relativeBasePath !== "string") {
        throw new Error("CustomPageComponent: input option relativeBasePath must be a string");
      }
      if (typeof this.options.url !== "string") {
        throw new Error("CustomPageComponent: input option url must be a string");
      }
      if ($.isPlainObject(this.options.HTMLPageJSON) === false) {
        throw new Error("CustomPageComponent: input option HTMLPageJSON must be a JSON object");
      }
      if (typeof this.options.currentVersion !== "number" || this.options.currentVersion < 0) {
        throw new Error("CustomPageComponent: input option currentVersion must be a positive number");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      if (this.contextFactory !== undefined) {
        this.contextFactory.stopLoadingData();
      }
      this.element.removeClass(this.widgetFullName).removeAttr("data-uuid");
      clearTimeout(this.refreshTimeoutID);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79,"../../../cloudflow/CloudflowUtil/js/CloudflowURL.js":80,"../../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js":93,"../../../cloudflow/Consent/js/Consent.js":96,"../../../cloudflow/FormRender/js/nixps-cloudflow-FormRenderer.js":168,"../../../cloudflow/FormRender/js/nixps-cloudflow-LayoutRenderer.js":170,"../../../cloudflow/License/js/License.js":175,"../../../cloudflow/Translate/js/TranslationHandler.js":234,"../../../cloudflow/UIProfiles/js/Action.js":240,"../../../cloudflow/UIProfiles/js/ActionList.js":242,"../../../cloudflow/UIProfiles/js/Form.js":249,"../../../cloudflow/UIProfiles/js/HTMLPage.js":252,"../../../cloudflow/UIProfiles/js/WebFramework.js":261,"../../../cloudflow/User/js/User.js":268,"../Constants.js":412,"../Context.js":413,"../DoneQueue.js":414,"../ExpressionToJS.js":415,"../HTMLPageHandler.js":416,"../inspect/LogListener.js":431}],420:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Mei 17, 2019
 */
(function ($) {
  require("./nixps-pagebuilder-CustomPageComponent.js");
  var CloudflowObject = require("../../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
  var Device = require("../../../cloudflow/PWA/js/Device.js");
  var styleClassRegExp = new RegExp("(^|\\s)nixps_styling_class_\\S+", "g");

  /**
   * @namespace nixps-pagebuilder.CustomPageComponentContainer
   * @description draw a container
   * @private
   * @version 1.1.0
   * @example $('<div>').CustomPageComponentContainer({});
   */
  $.widget("nixps-pagebuilder.CustomPageComponentContainer", $.Widget, {
    version: "1.1.0",
    widgetEventPrefix: "custompagecomponentcontainer",
    options: {
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#language
       * @description  The language of the current user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#relativeBasePath
       * @description The path to be used if the url is relative
       * @type {string}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#enableTitle
       * @description Must we show the title or not?
       * @type {Boolean}
       * @default true
       */
      enableTitle: true,
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#titleText
       * @desc The title 
       * @type {String}
       * @default ""
       */
      titleText: "",
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#titlePagebuilderStyleClass
       * @description the pagebuilder style class
       * @type {String}
       * @default ""
       * @private
       */
      titlePagebuilderStyleClass: "",
      /**
       * @description The float of the image. With this you can put the image left, right or centered in his container.
       * The only possible values are: "left", "center", "right"
       * @name nixps-pagebuilder.CustomPageComponentContainer#titleFloat
       * @type {String}
       * @example "left" 
       * @default ""
       * @since 1.2.0
       */
      titleFloat: "",
      /**
       * @name nixps-cloudflow.CustomPageComponentContainer#titleLevel
       * @description The level of the title. this means which h[0-9] tag the title will have
       * @type {Number}
       * @default undefined
       * @since 1.2.0
       */
      titleLevel: undefined,
      /**
       * @name nixps-cloudflow.CustomPageComponentContainer#pagebuilderStyleClass
       * @description Which style class do you want to apply on the component
       * @type {String}
       * @default ""
       * @private
       */
      pagebuilderStyleClass: "",
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#contentOptions
       * @desc The input options of the Custom Page Component
       * @type {Object}
       * @default {}
       */
      contentOptions: {},
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#disclosureButton
       * @description Must we show a disclosure button to show and hide the panel
       * @type {Boolean}
       * @default false
       * @since 1.1.0
       */
      disclosureButton: false,
      /**
       * @description If we have a discloser button, must it be open on creation or must it be closed
       * @type {Boolean}
       * @default true
       * @since 1.1.0
       */
      discloserButtonOpenOnStartup: true,
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#disclosureActionOptions
       * @description The jquery toggle options given to the toggle function. With this you can define a customised show and close
       * @type {Object}
       * @default undefined
       * @since 1.1.0
       */
      disclosureActionOptions: undefined,
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#discloserButtonLocation
       * @description position of the toggle button, left or right
       * @type {String}
       * @default "right"
       * @since 1.2.0
       */
      discloserButtonLocation: "right",
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#width
       * @description The width of the component
       * @type {mixed}
       * @default null
       */
      width: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#height
       * @description The height of the component
       * @type {mixed}
       * @default null
       */
      height: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#backgroundColor
       * @description The background color
       * @type {String}
       * @default null
       */
      backgroundColor: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#border
       * @description The border of the component
       * @type {String}
       * @default null
       */
      border: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#borderRadius
       * @description The border radius of the component
       * @type {String}
       * @default null
       */
      borderRadius: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#margin
       * @description The margin of the component
       * @type {String}
       * @default null
       */
      margin: null,
      /**
       * @name nixps-pagebuilder.CustomPageComponentContainer#boxShadow
       * @description The box-shadow of the component
       * @type {String}
       * @default null
       */
      boxShadow: null,
      /**
       * @description Whether the component is inside the pagebuilder editor or not.
       * @name nixps-pagebuilder.CustomPageComponentContainer#isInEditor
       * @type {Boolean}
       * @default false
       */
      isInEditor: false,
      /**
       * @description function to be run when component is done 
       * @name nixps-pagebuilder.CustomPageComponentContainer#created
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-pagebuilder.CustomPageComponentContainer#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).attr("data-uuid", this.uuid);

      // variables
      this.creating = true;
      this.IsMobile = Device.hasMobileWidth();
      // skeleton
      var that = this;
      var container = $("<div>").addClass("cpcc_container");
      this.element.append(container);
      var titleBar = $("<div>").addClass("cpcc_titlebar");
      titleBar.append($("<span>").addClass("cpcc_titlebar_title"));
      var disclosureButtonDiv = $('<div>').addClass("cpcc_titlebar_discloser");
      titleBar.append(disclosureButtonDiv);
      disclosureButtonDiv.append($('<span>').addClass("cf-icon cf-icon-chevron-down leftside_collapse cpcc_discloseIcon showIcon"));
      container.append(titleBar);
      var contentContainer = $("<div>").addClass("cpcc_contentcontainer");
      container.append(contentContainer);
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        contentContainer.addClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
      }
      this._draw();
      this._setStyle();
      if (this.IsMobile === false) {
        this._on(this.element, {
          "click .cpcc_titlebar_discloser": this._clickDiscloserButtonHandler
        });
      } else {
        this._on(this.element, {
          "click .cpcc_titlebar": this._mobileClickTitleHandler
        });
      }
      if (this.options.discloserButtonOpenOnStartup === false) {
        this._changeDiscloseState();
      }
    },
    _mobileClickTitleHandler: function _mobileClickTitleHandler(pEvent) {
      if (this.options.disclosureButton === false) {
        // do nohting if there is no disclosure button
        return;
      }
      if ($(pEvent.target).closest("." + this.widgetFullName).data("uuid") !== this.uuid) {
        // ignore if child container triggers
        return;
      }
      this._changeDiscloseState();
    },
    /**
     * @description function runs when user want to open and close the dialog
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     * @fucntion
     * @private
     * @name nixps-pagebuilder.CustomPageComponentContainer#_clickDiscloserButtonHandler
     * @returns {undefined}
     */
    _clickDiscloserButtonHandler: function _clickDiscloserButtonHandler(pEvent, pData) {
      if ($(pEvent.target).closest("." + this.widgetFullName).data("uuid") == this.uuid) {
        this._changeDiscloseState();
      }
    },
    /**
     * @description Toggle the panel
     * @function
     * @private
     * @returns undefined 
     */
    _changeDiscloseState: function _changeDiscloseState() {
      var container = this.element.children(".cpcc_container");
      var toggleContainer = container.children(".cpcc_contentcontainer");
      if (this.options.disclosureActionOptions === undefined) {
        toggleContainer.toggle();
      } else {
        toggleContainer.toggle(this.options.disclosureActionOptions);
      }
      if (this.options.disclosureButton === true) {
        var toggleIcon = this.element.children("div").children(".cpcc_titlebar").children(".cpcc_titlebar_discloser").children(".cpcc_discloseIcon");
        if (toggleIcon.hasClass("cf-rotate-270") === false) {
          toggleIcon.addClass("cf-rotate-270");
        } else {
          toggleIcon.removeClass("cf-rotate-270");
        }
      }
      if (typeof this.options.height === "string" || typeof this.options.height === "number") {
        if (toggleContainer.is(":visible")) {
          // reset height
          container.css("height", this.options.height);
        } else {
          container.css("height", "");
        }
      }
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-pagebuilder.CustomPageComponentContainer#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentContainer#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;

      // title
      if (this.options.enableTitle === true) {
        this.element.children(".cpcc_container").children(".cpcc_titlebar").css("display", "").removeClass(function (classindex, className) {
          return (className.match(styleClassRegExp) || []).join(' ');
        }).addClass(function () {
          if (that.options.titlePagebuilderStyleClass.length > 0) {
            return "nixps_styling_class_" + that.options.titlePagebuilderStyleClass;
          }
        }).children(".cpcc_titlebar_title").text(this.options.titleText);
        var toggleIcon = this.element.children("div").children(".cpcc_titlebar").children(".cpcc_titlebar_discloser").children(".cpcc_discloseIcon");
        if (that.options.disclosureButton === false) {
          toggleIcon.hide();
        } else {
          toggleIcon.show();
        }
      } else {
        this.element.children(".cpcc_container").children(".cpcc_titlebar").hide();
      }
      //this.element.children(".cpcc_container").children(".cpcc_titlebar").children(".cpcc_titlebar_discloser").toggle(this.options.disclosureButton);

      // content
      var options = this.options.contentOptions;
      // unfreeze internal value composers 
      options = CloudflowObject.travers(options, function (pValue, pKey) {
        if (typeof pValue === "string" && pValue.startsWith("<expression>") && pValue.endsWith("</expression>")) {
          if (pKey.indexOf(".element.options.contentOptions.HTMLPageJSON.elements.") > 1) {
            // prevent translating children!!
            return pValue;
          }
          try {
            return JSON.parse(pValue.substring(12).slice(0, -13));
          } catch (e) {
            return pValue;
          }
        }
        return pValue;
      });
      options = $.extend(true, options, {
        "language": this.options.language,
        "relativeBasePath": this.options.relativeBasePath,
        "pageCSSSelector": this.element.attr("id") ? "#" + this.element.attr("id") + " > .cpcc_container > .nixps-pagebuilder-CustomPageComponent" : null,
        "publicParentWidgetName": this.widgetFullName,
        "isInEditor": this.options.isInEditor,
        "created": function created() {
          if (that.creating === true) {
            that.options.created.apply(that, arguments);
            that.creating = false;
          }
        }
      });
      this.element.children(".cpcc_container").children(".cpcc_contentcontainer").CustomPageComponent(options);
    },
    _setStyle: function _setStyle() {
      var style = {
        "width": "",
        "height": "",
        "border": "",
        "borderRadius": "",
        "margin": "",
        "boxShadow": "",
        "background": ""
      };
      if (typeof this.options.width === "string" || typeof this.options.width === "number") {
        style.width = this.options.width;
      }
      if (typeof this.options.height === "string" || typeof this.options.height === "number") {
        style.height = this.options.height;
      }
      if (typeof this.options.border === "string" && this.options.border.length > 0) {
        style.border = this.options.border;
      }
      if (typeof this.options.borderRadius === "string" || typeof this.options.borderRadius === "number") {
        style.borderRadius = this.options.borderRadius;
      }
      if (typeof this.options.margin === "string" && this.options.margin.length > 0) {
        style.margin = this.options.margin;
      }
      if (typeof this.options.boxShadow === "string" && this.options.boxShadow.length > 0) {
        style.boxShadow = this.options.boxShadow;
      }
      if (typeof this.options.backgroundColor === "string" && this.options.backgroundColor.length > 0) {
        style.background = this.options.backgroundColor;
      }
      this.element.children(".cpcc_container").css(style);
    },
    _setOptions: function _setOptions(options) {
      var needReStyle = false;
      if (options.width !== undefined && options.width !== this.options.width) {
        needReStyle = true;
      } else if (options.height !== undefined && options.height !== this.options.height) {
        needReStyle = true;
      } else if (options.border !== undefined && options.border !== this.options.border) {
        needReStyle = true;
      } else if (options.borderRadius !== undefined && options.borderRadius !== this.options.borderRadius) {
        needReStyle = true;
      } else if (options.margin !== undefined && options.margin !== this.options.margin) {
        needReStyle = true;
      } else if (options.boxShadow !== undefined && options.boxShadow !== this.options.boxShadow) {
        needReStyle = true;
      } else if (options.backgroundColor !== undefined && options.backgroundColor !== this.options.backgroundColor) {
        needReStyle = true;
      } else if (options.titleLevel !== undefined && options.titleLevel !== this.options.titleLevel) {
        needReStyle = true;
      }
      if (options.pagebuilderStyleClass !== undefined && options.pagebuilderStyleClass !== this.options.pagebuilderStyleClass) {
        this.element.children(".cpcc_container").children(".cpcc_contentcontainer").removeClass("nixps_styling_class_" + this.options.pagebuilderStyleClass).addClass("nixps_styling_class_" + options.pagebuilderStyleClass);
      }
      var stateChangeStartup = false;
      if (options.discloserButtonOpenOnStartup !== this.options.discloserButtonOpenOnStartup) {
        stateChangeStartup = true;
      }
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
      if (stateChangeStartup === true) {
        this._changeDiscloseState();
      }
      if (needReStyle === true) {
        this._setStyle();
      }
    },
    /**
     * @description refresh the cpc with the new context
     * @function
     * @name nixps-pagebuilder.CustomPageComponentContainer#refresh
     * @returns {Deferred} the deferred object after drawing
     */
    refresh: function refresh() {
      return this.element.children(".cpcc_container").children(".cpcc_contentcontainer").CustomPageComponent.apply(this.element.children(".cpcc_container").children(".cpcc_contentcontainer"), ["refresh"].concat($.makeArray(arguments)));
    },
    /**
     * @description run a public sub action 
     * @function
     * @name nixps-pagebuilder.CustomPageComponentContainer#runSubPageAction
     * @param {String} pID the id of the sub action
     * @param {String} pName the name of the sub action
     * @param {Object} pInputParameters 
     * @param {Object} pEvent the event object of the parent function
     * @param {Object} pData the event data
     * @param {Object} pPreviousResults previous object of previous action   
     * @returns {Deferred}  
     */
    runSubPageAction: function runSubPageAction(pID, pName, pInputParameters, pEvent, pData, pPreviousResults) {
      return this.element.children(".cpcc_container").children(".cpcc_contentcontainer").CustomPageComponent.apply(this.element.children(".cpcc_container").children(".cpcc_contentcontainer"), ["runSubPageAction"].concat($.makeArray(arguments)));
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentContainer#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-pagebuilder.CustomPageComponentContainer#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.relativeBasePath !== "string") {
        throw new Error("input option relativeBasePath must be a string");
      }
      if (typeof this.options.enableTitle !== "boolean") {
        throw new Error("input option enableTitle must be a boolean");
      }
      if (typeof this.options.titleText !== "string") {
        throw new Error("input option titleText must be a string");
      }
      if (typeof this.options.titlePagebuilderStyleClass !== "string") {
        throw new Error("input option titlePagebuilderStyleClass must be a string");
      }
      if ($.isPlainObject(this.options.contentOptions) === false) {
        throw new Error("input option contentOptions must be a JSON");
      }
    }
  });
})(jQuery);

},{"../../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79,"../../../cloudflow/PWA/js/Device.js":198,"./nixps-pagebuilder-CustomPageComponent.js":419}],421:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Feb 2, 2018 5:42:43 PM
 */
(function ($) {
  require("../../../common/InteractiveDialog/js/nixps-MobileDialog.js");

  /**
   * @namespace nixps-pagebuilder.CustomPageComponentDialog
   * @description draw a dialog
   * @private
   * @example $('<div>').CustomPageComponentDialog({});
   * @version 1.1.0
   */
  $.widget("nixps-pagebuilder.CustomPageComponentDialog", $["nixps"].MobileDialog, {
    version: "1.1.0",
    widgetEventPrefix: "custompagecomponentdialog",
    options: {
      /**
       * @name nixps-cloudflow.CustomPageComponentDialog#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.CustomPageComponentDialog#contentOptions
       * @description The options give throug the customcomponent
       * @type {Object}
       * @default {}
       */
      contentOptions: {},
      /**
       * @name nixps-cloudflow.CustomPageComponentDialog#style_type
       * @description The type of style you want
       * @type {String}
       * @default "default"
       */
      style_type: "default",
      /**
       * @name nixps-cloudflow.CustomPageComponentDialog#pagebuilderHeaderStyleClass
       * @description the pagebuilder style classes to be applied on the header
       * @type {Sting}
       * @default ""
       * @since 1.1.0
       */
      pagebuilderHeaderStyleClass: "",
      /**
       * @name nixps-cloudflow.CustomPageComponentDialog#width
       * @description The with of the dialog
       * @type {mixed}
       * @default 500
       */
      width: 500,
      fallBackHeight: 800,
      marginWidth: 0,
      /**
       * @name nixps-cloudflow.CustomPageComponentDialog#draggable
       * @description Must we allow the user that the dialog is draggable
       * @type {Boolean}
       * @default true
       */
      draggable: true,
      /**
       * @name nixps-cloudflow.CustomPageComponentDialog#resizable
       * @description Must we allow the dialog to be resizable
       * @type {Boolean}
       * @default true
       */
      resizable: true,
      /**
       * @description The text of the close dialog, set to empty to not display for recent jquery ui
       * @name nixps-cloudflow.CustomPageComponentDialog#closeText
       * @type {String}
       * @default ""
       */
      closeText: "Close",
      autoOpen: false
    },
    _getCreateOptions: function _getCreateOptions() {
      return {
        closeText: $.i18n._("nixps-cloudflow-dialog.close")
      };
    },
    /**
     * @description Create the component
     * @name nixps-pagebuilder.CustomPageComponentDialog#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      // first set up the dialogClass option before creation of parent
      this.options.dialogClass += "CustomPageComponentDialog_Dialog cf-dialog CloudflowStyle_" + this.options.style_type;
      if (typeof this.options.pagebuilderHeaderStyleClass === "string" && this.options.pagebuilderHeaderStyleClass.length > 0) {
        this.options.dialogClass += " CustomPageComponentDialog_customheader";
      }
      if ($.isPlainObject(this.options.classes) === false) {
        this.options.classes = {};
      }
      this.options.classes["ui-dialog"] = this.options.dialogClass;

      // create dialog (parent)
      this._super();
      this.uiDialog.css("position", "absolute"); // make dialog an absolute position
      // this.uiDialog.css("position", "fixed"); // make dialog an absolute position

      if (typeof this.options.pagebuilderHeaderStyleClass === "string" && this.options.pagebuilderHeaderStyleClass.length > 0) {
        this.uiDialogTitlebar.addClass("cf-dialog-customheader nixps_styling_class_" + this.options.pagebuilderHeaderStyleClass);
      }
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("cf-dialog-customcontent nixps_styling_constants_bodybackground");

      // variables
      this.titleHeaderHeight = 22.8; // some default guess value
      this.hasDragged = false;
      this.hasResized = false;

      // skeleton
      var container = $("<div>").addClass("cpcd_container");
      this.element.append(container);
      try {
        this._draw();
      } finally {
        // always open the dialog, even if there is an error in the cpc content
        this.open();
      }
      this._on(this.element, {
        "custompagecomponentdialogopen": this._openDialogHandler,
        "custompagecomponentdialogresizestart": this._resizeStartHandler,
        "custompagecomponentdialogresizestop": this._resizeStopHandler,
        "custompagecomponentdialogdragstart": this._dragStartHandler,
        "custompagebuilderclosecontainer": this._closeEventHandler,
        "custompagecomponentdrawed": this._drawedHandler
      });
    },
    /**
     * @description Function runs when the dialog opens
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDialog#_openDialogHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _openDialogHandler: function _openDialogHandler(pEvent, pData) {
      var headerHeight = this.element.closest(".ui-dialog").children(".ui-dialog-titlebar").outerHeight();
      if (typeof headerHeight === "number" && headerHeight > 0) {
        this.titleHeaderHeight = headerHeight;
      }
    },
    _resizeStartHandler: function _resizeStartHandler(pEvent, pData) {
      this.hasResized = true;
    },
    _resizeStopHandler: function _resizeStopHandler(pEvent, pData) {
      this.element.css("width", "auto"); // fix width bug
      var height = this.element.closest(".ui-dialog").height();
      if (pData.size !== undefined && pData.size.height > height - this.titleHeaderHeight) {
        this.element.height(height - this.titleHeaderHeight);
      }
    },
    _dragStartHandler: function _dragStartHandler(pEvent, pData) {
      this.hasDragged = true;
    },
    /**
     * @description function runs when user added a custom trigger to close the dialog
     * @function
     * @name nixps-pagebuilder.CustomPageComponentDialog#_closeEventHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _closeEventHandler: function _closeEventHandler(pEvent, pData, pOriginalEvent) {
      var returnData = {};
      if (pData !== undefined && $.isPlainObject(pData.data_to_pass)) {
        returnData = pData.data_to_pass;
      }
      this.close(pEvent, returnData);
      pEvent.stopPropagation();
      pEvent.preventDefault();
      if (pOriginalEvent !== undefined && pOriginalEvent.stopPropagation !== undefined) {
        pOriginalEvent.stopPropagation();
      }
      return false;
    },
    /**
     * @description Close the dialog.
     * @function
     * @extends dialog#close
     * @name nixps-pagebuilder.CustomPageComponentDialog#close
     * @param {type} event
     * @return {nixps-pagebuilder-CustomPageComponentDialogL#8.nixps-pagebuilder-CustomPageComponentDialogAnonym$0|undefined}
     */
    close: function close(event, pReturnData) {
      this._super();
      if (this.isOpen() === true) {
        return;
      }
      this.element.parent().remove();
      var closingBy = "";
      if ($.isPlainObject(pReturnData)) {
        closingBy = "close_action";
      } else if (event.keyCode && event.keyCode === $.ui.keyCode.ESCAPE) {
        closingBy = "escape_key";
      } else if ($(event.currentTarget).hasClass("ui-dialog-titlebar-close")) {
        closingBy = "close_button";
      }
      var triggerData = {
        outputData: {
          closingBy: closingBy,
          data: {}
        }
      };
      if ($.isPlainObject(pReturnData)) {
        triggerData.outputData.data = pReturnData;
      }
      this._trigger("closedialog", null, triggerData);
      return this;
    },
    /**
     * @description Function runs when the content is finishing drawing
     * @function 
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDialog#_drawedHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _drawedHandler: function _drawedHandler(pEvent, pData) {
      if ($(pEvent.target).closest(".nixps-pagebuilder-CustomPageComponent").attr("data-uuid") !== this.element.children(".cpcd_container").attr("data-uuid")) {
        return true; // ignore event, does not come from this cpc
      }

      if (this.hasDragged === false && this.hasResized === false && pData !== undefined && pData.reason_to_draw === "create") {
        if (this.options.position !== undefined && (this.options.position.at === "center" || this.options.position.at === "center center")) {
          this._position(this.options.position);
        }
      }
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-pagebuilder.CustomPageComponentDialog#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDialog#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.options.contentOptions.language = this.options.language;
      this.options.contentOptions.publicParentWidgetName = this.widgetFullName;
      if (typeof this.element.attr("id") === "string" && this.element.attr("id").length > 0) {
        this.options.contentOptions.pageCSSSelector = "#" + this.element.attr("id");
      } else {
        // jquery ui technology
        if (this.uiDialogTitlebar !== undefined && this.uiDialog !== undefined) {
          var titleID = this.uiDialogTitlebar.find(".ui-dialog-title").attr("id");
          if (typeof titleID === "string" && titleID.length > 0 && this.uiDialog.attr("aria-labelledby") === titleID) {
            this.options.contentOptions.pageCSSSelector = ".cf-dialog[aria-labelledby=" + titleID + "]";
          }
        }
      }
      this.element.children(".cpcd_container").CustomPageComponent(this.options.contentOptions);
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDialog#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "contentOptions") {
        this.element.children(".cpcd_container").CustomPageComponent("option", pValue);
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-pagebuilder.CustomPageComponentDialog#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.style_type !== "string") {
        throw new Error(this.widgetName + ": input options style_type must be a string");
      }
      if (typeof this.options.pagebuilderHeaderStyleClass !== "string") {
        throw new Error(this.widgetName + ": input options pagebuilderHeaderStyleClass must be a string");
      }
      if ($.isPlainObject(this.options.contentOptions) === false) {
        throw new Error(this.widgetName + ": input options contentOptions must be an object");
      }
    },
    _destroy: function _destroy() {} /* overwrite existing destoyer */
  });

  if ($.fn.CustomPageComponentDialog_returnCloseDef === undefined) {
    $.fn.CustomPageComponentDialog_returnCloseDef = function (options) {
      var closeDef = $.Deferred(); // defer object to return when creating dialog
      var orgCloseDialogFunc = options.closedialog; // orgiginal close option function
      options.closedialog = function (pEvent, pData) {
        if (typeof orgCloseDialogFunc === "function") {
          orgCloseDialogFunc(pEvent, pData); // apply original option
        }

        var output = {};
        if (pData !== undefined && pData.outputData !== undefined) {
          output = pData.outputData;
        }
        closeDef.resolve(output); // indicate the dialog has been closed, the next action may begin
      };

      this.CustomPageComponentDialog(options);
      return closeDef;
    };
  } else {
    console.warn("The component CustomPageComponentDialog_returnCloseDef already exists!");
  }
})(jQuery);

},{"../../../common/InteractiveDialog/js/nixps-MobileDialog.js":293}],422:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 18 Jan 2019
 */
(function ($) {
  require("../../../cloudflow/Table/js/nixps-cloudflow-ButtonsBarTableExtension.js");
  require("../../../common/DynamicList/js/nixps-DynamicList.js");
  var CloudflowConnection = require("../../../cloudflow/CloudflowUtil/js/CloudflowConnection.js");
  var CloudflowObject = require("../../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
  var DoneQueue = require("../DoneQueue.js");
  var Device = require("../../../cloudflow/PWA/js/Device.js");
  var LogListener = require("../../../pagebuilder/js/inspect/LogListener.js");
  function isCSSStringPercentage(pWidth) {
    if (typeof pWidth === "string" && pWidth.length > 1) {
      pWidth = pWidth.trim();
      if (pWidth[pWidth.length - 1] === "%") {
        return true;
      }
    }
    return false;
  }

  /**
   * @description If the list is bigger then this amount we show a warning
   * @type {Number}
   * @default 1000
   * @private
   * @static
   */
  var kWarningAmountItems = 1000;

  /**
   * @namespace nixps-pagebuilder.CustomPageComponentDynamicList
   * @description draw a list of all custom page components
   * @private
   * @example $("<div>").CustomPageComponentDynamicList({});
   * @version 1.2.0
   */
  $.widget("nixps-pagebuilder.CustomPageComponentDynamicList", $.Widget, {
    version: "1.2.0",
    widgetEventPrefix: "custompagecomponentdynamiclist",
    options: {
      /**
       * @description The language of the user
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @description The topbarbuttons
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#topbarbuttons
       * @type {Array}
       * @default []
       */
      topbarbuttons: [],
      /**
       * @description The height of the component
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#height
       * @default null
       * @type {mixed}
       */
      height: null,
      /**
       * @description The path to be used if the url is relative
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#relativeBasePath
       * @type {string}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @description The type of how to display each item. You can choose between "image", "cutom"
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#itemDisplayType
       * @type {String}
       * @default "image"
       */
      itemDisplayType: "image",
      /**
       * @description The path name of the url of the image 
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#itemImageURLPath
       * @type {String}
       * @default "url"
       */
      itemImageURLPath: "url",
      /**
       * @description The path name of the label of the image 
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#itemImageLabelPath
       * @type {String}
       * @default "label"
       */
      itemImageLabelPath: "label",
      /**
       * @description The url as reference where the page component is situated
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#itemDisplayURL
       * @type {String}
       * @default ""
       */
      itemDisplayURL: "",
      /**
       * @description The collection to retrieve the data to show
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#collection
       * @type {String}
       * @default ""
       */
      collection: "",
      /**
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#httpserviceInputName
       * @description the name of the http service input name
       * @type {String}
       * @default ""
       * @private
       */
      httpserviceInputName: "",
      /**
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#httpserviceWhitepaperName
       * @description the name of the whitepaper where the http service is running
       * @type {String}
       * @default ""
       * @private
       */
      httpserviceWhitepaperName: "",
      /**
       * @description The plain static Array
       * @name nixps-cloudflow.PreConfiguredListPanel#collectionArray
       * @type {Array.<Object>}
       * @default []
       */
      collectionArray: [],
      /**
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#dataFileURL
       * @description the url of the data file to read
       * @type {String}
       * @default ""
       */
      dataFileURL: "",
      /**
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#extraQuery
       * @description The extra filter to apply on the items 
       * @type {Array}
       * @default []
       */
      extraQuery: [],
      /**
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#sort
       * @description The sorting settings. How must we sort the columns (on startup)? 
       * @type {Array}
       * @default []
       * @example ["name", "ascending"]
       * @since 1.2.0
       */
      sort: [],
      /**
       * @description The width of each item
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#itemWidth
       * @type {Number|String}
       * @default 50
       */
      itemWidth: 50,
      /**
       * @description The height of each item
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#itemHeight
       * @type {Number|String}
       * @default 50
       */
      itemHeight: 50,
      /**
       * @description The item overflow type 
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#itemOverflowType
       * @type {String}
       * @default null
       */
      itemOverflowType: null,
      /**
       * @description Does the data objects has a modification key. If set to true
       * We will use it to check if object has been changed
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#hasDataModification
       * @type {Boolean}
       * @default false
       */
      hasDataModification: false,
      /**
       * @description Must we be able to select items ?
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#enableSelecting
       * @type {Boolean}
       * @default true
       */
      enableSelecting: true,
      /**
       * @desc Must we be able to deselect items
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#deselectable
       * @type {Boolean}
       * @default false
       */
      deselectable: false,
      /**
       * @description Must we select multiple rows
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#multipleSelectable
       * @type {Boolean}
       * @default true
       */
      multipleSelectable: true,
      /**
       * @description The uniq key name of the item objects
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#keyUniqID
       * @type {String}
       * @default "_id"
       */
      keyUniqID: "_id",
      /**
       * @description Must we activate the lazyloading scrolling or not?
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#lazyLoading
       * @type {Boolean}
       * @default false
       * @since 1.1.0
       */
      lazyLoading: false,
      /**
       * @description The maximum amount of items to show on batches
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#scrollBatchLength
       * @type {Number}
       * @default 20
       * @since 1.1.0
       */
      scrollBatchLength: 20,
      /**
       * @description The init amount of items to show on startup when scrolling lazyloading is active
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#initLimit
       * @type {Number}
       * @default 300
       * @since 1.1.0
       */
      initLimit: 300,
      /**
       * @description Max amount of items to process and display
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#maxAmount
       * @type {Number}
       * @default undefined
       */
      maxAmount: undefined,
      /**
       * @description The number of milliseconds between two updates, use 0 to disable updates
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#refreshDelay
       * @type {Number}
       * @default 0
       */
      refreshDelay: 0,
      /**
       * @description Whether the component is inside the pagebuilder editor or not.
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#isInEditor
       * @type {Boolean}
       * @default false
       */
      isInEditor: false,
      /**
       * @name nixps-pagebuilder.CustomPageComponentDynamicList#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("cloudflowMenuButtonsParentComponent") // add class for filtering the pagebuilder topbar buttons actions to parent
      .attr("data-uuid", this.uuid);

      // variables
      this.connection = null;
      this.doneQueue = new DoneQueue();
      this.listCreating = true;
      this.quickSearchFilter = [];
      this.isMobile = Device.hasMobileWidth();
      this._transformCollectionArray();
      this._draw();
      this._on(this.element, {});
    },
    /**
     * @description Function runs when error occurs
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#_errorHandler
     * @param {String} pCodeSection name where the error occured 
     * @param {Object} pError 
     * @returns {undefined}
     */
    _errorHandler: function _errorHandler(pCodeSection, pError) {
      console.error(pError);
      this._trigger("error", null, pError);
      LogListener.addLog({
        event_type: "error",
        details_data: pError,
        component_name: this.widgetFullName
      }, this.element);
    },
    /**
     * @description Function runs when changed occurs in the sources
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#_sourceChangeHandler
     * @returns {undefined}
     */
    _sourceChangeHandler: function _sourceChangeHandler() {
      this.update();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.element.empty();
      var that = this;
      // make connection
      this._initConnection();
      // make topbar buttons
      var buttonBarButtons = [];
      if (this.options.topbarbuttons.length > 0) {
        buttonBarButtons = this.options.topbarbuttons.filter(function (bttn) {
          return [undefined, "topbarbutton", "topbarcontextbutton"].includes(bttn.button_type);
        });
        this.element.append($("<div>").ButtonsBarTableExtension({
          "buttons": buttonBarButtons,
          "listDOM": this.element,
          "listSelector": "." + this.widgetFullName,
          "listComponentName": "CustomPageComponentDynamicList",
          "listgetRowsMethodeName": "getSelectedItems",
          "listgetRowIDsMethodeName": "getSelectedItemIDs"
        }));
        //make the context menu buttons
        var contextMenuButtons = this.options.topbarbuttons.filter(function (bttn) {
          return [undefined, "contextbutton", "topbarcontextbutton"].includes(bttn.button_type);
        });
        if (Array.isArray(contextMenuButtons) && contextMenuButtons.length > 0) {
          this.mContextmenu = $("<div>");
          this.element.prepend(this.mContextmenu);
          this.mContextmenu.ContextMenuTableExtension({
            "buttons": contextMenuButtons,
            "listDOM": this.element,
            "listSelector": "." + this.widgetFullName,
            "listComponentName": "CustomPageComponentDynamicList",
            "listgetRowsMethodeName": "getSelectedItems",
            "listgetRowIDsMethodeName": "getSelectedItemIDs",
            "buttonclick": function buttonclick(pEvent, pData) {
              that.element.trigger("buttonsbartableextension" + pData.triggername, pData.data);
            }
          });
        }
      }
      // make list
      var hasFixHeight = false;
      var list = $("<div>").addClass("cpclist_list");
      if (typeof this.options.height === "number" || typeof this.options.height === "string") {
        list.css("height", this.options.height);
        hasFixHeight = isCSSStringPercentage(this.options.height) === false;
      }
      if (isCSSStringPercentage(this.options.itemWidth)) {
        list.addClass("cpclist_list_percentageitems");
      }
      list.one("dynamiclistdrawed", this._listCreated.bind(this));
      list.one("dynamiclisterror", this._listCreated.bind(this));
      this.element.append(list);
      list.DynamicList({
        allowToUpdate: this._allowToUpdate.bind(this),
        dataProvider: this._dataProvider.bind(this),
        emptyRowsPanel: $("<span>").addClass("cpclist_emptyPanel").text(""),
        hasItemChanged: this._hasItemChanged.bind(this),
        makeItem: this._makeItem.bind(this),
        updateItem: this._updateItem.bind(this),
        keyUniqID: this.options.keyUniqID,
        updateDelay: this.options.refreshDelay,
        enableSelecting: this.options.enableSelecting,
        selectingOptions: {
          multiple: this.options.multipleSelectable === true,
          deselectable: this.options.deselectable === true,
          selectClass: "cf-select"
        },
        lazyLoading: hasFixHeight && this.options.lazyLoading,
        scrollBatchLength: this.options.scrollBatchLength,
        initLimit: this.options.initLimit,
        scrollElement: undefined,
        update: function update(pEvent, pData) {
          that._trigger("update", pEvent, pData);
        },
        select: function select(pEvent, pData) {
          that._trigger("select", pEvent, {
            "ids": pData.ids
          });
        },
        dblclick: function dblclick(pEvent, pData) {
          if (pData !== undefined && pData.data) {
            var itemID = CloudflowObject.getParameter(pData.data, that.options.keyUniqID);
            if (itemID) {
              that._trigger("dblclick", pEvent, {
                "id": itemID,
                "rowObject": pData.data
              });
            }
          }
        },
        contextmenu: function contextmenu(pEvent, pData) {
          if (that.isMobile === true) {
            // we handle or own context menu on mobile
            return false;
          }
          if (pData !== undefined && pData.data) {
            var itemID = CloudflowObject.getParameter(pData.data, that.options.keyUniqID);
            if (itemID) {
              // TODO: open contextmenu and if needed abort event
              // return false;
              that._contextMenuRowClickHandler(pEvent);
            }
          }
        }
      });
    },
    /**
    * @description control if the event comes from this component and not from a child that can also be a table
    * @function
    * @private
    * @name nixps-cloudflow.PreConfiguredTable#_isEventFromComponent
    * @param {type} pEvent
    * @returns {boolean} true if events source comes from this component, false if event comes form a child component, that bubbles up
    */
    _isEventFromComponent: function _isEventFromComponent(pEvent) {
      return $(pEvent.target).closest("." + this.widgetFullName).attr("data-uuid") === this.uuid.toString();
    },
    /**
    * @description function runs when user right click on a row
    * @function
    * @name nixps-cloudflow.PreConfiguredTable#_contextMenuRowClickHandler
    * @private
    * @return {undefined}
    */
    _contextMenuRowClickHandler: function _contextMenuRowClickHandler(pEvent) {
      if (this._isEventFromComponent(pEvent) === false) {
        return true;
      }
      if (this.isMobile === true) {
        // we handle or own context menu on mobile
        return false;
      }
      if (this.mContextmenu !== undefined && this.mContextmenu !== null) {
        this.mContextmenu.ContextMenuTableExtension("show", pEvent);
      }
    },
    _listCreated: function _listCreated(pEvent, pData) {
      var that = this;
      this.listCreating = false;
      if (this.doneQueue !== null) {
        if (this.doneQueue.getAmountAskedDone() === 0) {
          this.doneQueue = null; // reset 
          // done but no items
          this.options.created();
        } else {
          this.doneQueue.informAllDone(function () {
            that.doneQueue = null; // reset 
            that.options.created();
          });
        }
      }
    },
    /**
     * @description Init the connection
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#_initConnection
     * @returns {undefined}
     */
    _initConnection: function _initConnection() {
      if (this.connection !== null) {
        this.connection.stop("start_next_call");
      }
      this.connection = new CloudflowConnection({
        collection: this.options.collection,
        data: this.collectionArray,
        dataFileURL: this.options.dataFileURL,
        relativeBasePath: this.options.relativeBasePath,
        httpserviceInputName: this.options.httpserviceInputName,
        httpserviceWhitepaperName: this.options.httpserviceWhitepaperName,
        error_cb: this._errorHandler.bind(this),
        change_cb: this._sourceChangeHandler.bind(this)
      });
    },
    /**
     * @return {undefined}       
     * @description transform the incomming array to usefull array, To not error because the value are entered by the pagebuilder editor
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#_transformCollectionArray
     */
    _transformCollectionArray: function _transformCollectionArray() {
      this.collectionArray = [];
      if (Array.isArray(this.options.collectionArray) === false) {
        // not an array, so make one
        this.options.collectionArray = [this.options.collectionArray];
      }
      this.options.collectionArray = structuredClone(this.options.collectionArray);
      if (this.options.collectionArray.length > kWarningAmountItems) {
        this._errorHandler(undefined, {
          "error_code": "custom_array_too_long",
          "error": "The list is too long"
        });
        if (api_async.logging !== undefined && api_async.logging.trace !== undefined) {
          api_async.logging.trace.log("com.nixps.pagebuilder", "error", "The fix list in CustomPageComponentDynamicList is too long!");
        }
      }
      for (var i = 0; i < this.options.collectionArray.length; i++) {
        if ($.isPlainObject(this.options.collectionArray[i])) {
          this.collectionArray.push(this.options.collectionArray[i]);
        } else {
          this.collectionArray.push({
            "value": this.options.collectionArray[i]
          });
          this.options.tableOptions.keyUniqID = "value";
        }
      }
    },
    _allowToUpdate: function _allowToUpdate() {
      return this.element.is(":visible") && Device.continuePolling(this.uuid);
    },
    _dataProvider: function _dataProvider(pQuery, pOrderBy, pSkip, pLimit) {
      var that = this;
      var query = this.options.extraQuery;
      if (this.options.collection !== "object" && Array.isArray(this.quickSearchFilter) && this.quickSearchFilter.length > 0) {
        if (Array.isArray(query) && query.length > 0) {
          query.push("and");
          query.push("(");
          query = query.concat(this.quickSearchFilter);
          query.push(")");
        } else {
          query = query.concat(this.quickSearchFilter);
        }
      }
      var orderBy = [];
      var optionSort;
      if (this.options.sort.some(function (t) {
        return t.length === 0;
      })) {
        // user has disabled the sorting by setting a key to empty
        optionSort = [];
      } else {
        optionSort = this.options.sort;
      }
      if (Array.isArray(pOrderBy) && pOrderBy.length > 0) {
        orderBy = pOrderBy.concat(optionSort);
      } else {
        orderBy = optionSort;
      }
      // user have set 0 to visualise all records ...
      if (typeof this.options.maxAmount === "number" && this.options.maxAmount > 0) {
        if (typeof pLimit !== "number" || pLimit <= 0) {
          pLimit = this.options.maxAmount;
        } else {
          pLimit = Math.min(pLimit, this.options.maxAmount);
        }
      }
      return $.when(this.connection.list_with_options(query, orderBy, [], pSkip || 0, pLimit)).then(function (pResults) {
        if (pResults !== undefined && Array.isArray(pResults.results)) {
          if (pLimit > 0 && pResults.results.length > pLimit + 5) {
            // we recieved too much than asked,
            // the component can handle it on a correct way
            that._errorHandler({
              "error_code": "too_much_returned",
              "error": "returned too much data"
            });
            // slice it, because too much blocks the browser screen
            pResults.results = pResults.results.slice(0, pLimit + 1);
          } else if (pResults.results.length > kWarningAmountItems) {
            that._errorHandler(undefined, {
              "error_code": "too_many_items",
              "error": "The list to show is too long"
            });
          }
          return pResults.results;
        }
        return [];
      }, function (pError) {
        that._errorHandler(undefined, pError);
        return pError;
      });
    },
    _hasItemChanged: function _hasItemChanged(a, b) {
      if (this.options.hasDataModification === true) {
        return a.modification !== b.modification;
      }
      return true;
    },
    _makeItem: function _makeItem(pObject, pParent) {
      if (this.options.itemDisplayType === "image") {
        this._makeItem_image(pObject, pParent);
      } else if (this.options.itemDisplayType === "custom") {
        this._makeItem_cpc(pObject, pParent);
      }
    },
    _makeItem_image: function _makeItem_image(pObject, pParent) {
      var vwWidth = $(window).width();
      var item = $("<div>").addClass("cpc_item cpcdl_displaytype_image").css({
        "height": this.options.itemHeight
      });
      pParent.append(item);
      if (isCSSStringPercentage(this.options.itemWidth)) {
        pParent.css("width", this.options.itemWidth);
      } else {
        var width = this.options.itemWidth;
        if (typeof this.options.itemWidth === "number" || parseInt(this.options.itemWidth) == this.options.itemWidth) {
          if (vwWidth < this.options.itemWidth) {
            width = "100%";
          }
        }
        item.css("width", width);
      }
      if (typeof this.options.itemOverflowType === "string") {
        pParent.addClass("cf-children-overflow" + this.options.itemOverflowType);
      }
      var imageWidth;
      if (typeof this.options.itemWidth === "number" || parseInt(this.options.itemWidth) == this.options.itemWidth) {
        if (vwWidth < this.options.itemWidth) {
          imageWidth = vwWidth - 10;
        } else {
          imageWidth = this.options.itemWidth - 10;
        }
      } else {
        imageWidth = "calc( " + this.options.itemWidth + " - 10px )";
      }
      var imageHeight;
      if (typeof this.options.itemHeight === "number" || parseInt(this.options.itemHeight) == this.options.itemHeight) {
        imageHeight = this.options.itemHeight - 30;
      } else {
        imageHeight = "calc( " + this.options.itemHeight + " - 30px )";
      }
      item.append($("<div>").addClass("cpcdl_image").Image({
        url: CloudflowObject.getParameter(pObject, this.options.itemImageURLPath),
        "float": "center",
        relativeBasePath: this.options.relativeBasePath,
        width: null,
        height: null,
        maxWidth: imageWidth,
        maxHeight: imageHeight,
        created: this.listCreating === true && this.doneQueue !== null ? this.doneQueue.generateDoneCallBack() : undefined
      }).css({
        "width": imageWidth,
        "height": imageHeight
      }));
      item.append($("<div>").addClass("cpcdl_imagelabel").text(CloudflowObject.getParameter(pObject, this.options.itemImageLabelPath)));
    },
    _makeItem_cpc: function _makeItem_cpc(pObject, pParent) {
      var item = $("<div>").addClass("cpc_item cpcdl_displaytype_custom").css({
        "height": this.options.itemHeight
      });
      pParent.append(item);
      if (isCSSStringPercentage(this.options.itemWidth)) {
        pParent.css("width", this.options.itemWidth);
      } else {
        var width = this.options.itemWidth;
        if (typeof this.options.itemWidth === "number" || parseInt(this.options.itemWidth) == this.options.itemWidth) {
          var vwWidth = $(window).width();
          if (vwWidth < this.options.itemWidth) {
            width = "100%";
          }
        }
        item.css("width", width);
      }
      if (typeof this.options.itemOverflowType === "string") {
        pParent.addClass("cf-children-overflow" + this.options.itemOverflowType);
      }
      var itemID = CloudflowObject.getParameter(pObject, this.options.keyUniqID);
      var options = {
        language: this.options.language,
        relativeBasePath: this.options.relativeBasePath,
        url: this.options.itemDisplayURL,
        contextConnector: "object",
        contextCollection: "dummy",
        contextKey: {},
        publicParentWidgetName: this.widgetFullName,
        customchangeTriggerIdentifier: itemID,
        isInEditor: this.options.isInEditor,
        created: this.listCreating === true && this.doneQueue !== null ? this.doneQueue.generateDoneCallBack() : undefined
      };
      if ($.isPlainObject(pObject)) {
        options.contextKey = pObject;
        if (this.element.attr("id")) {
          options.pageCSSSelector = "#" + this.element.attr("id") + " [data-id=\"" + itemID + "\"] .nixps-pagebuilder-CustomPageComponent";
        }
      }
      item.CustomPageComponent(options);
    },
    _updateItem: function _updateItem(pHTMLElement, pObject) {
      if (this.options.itemDisplayType === "image") {
        this._updateItem_image(pHTMLElement, pObject);
      } else if (this.options.itemDisplayType === "custom") {
        this._updateItem_cpc(pHTMLElement, pObject);
      }
    },
    _updateItem_image: function _updateItem_image(pHTMLElement, pObject) {
      pHTMLElement.find(".cpcdl_image").Image({
        url: CloudflowObject.getParameter(pObject, this.options.itemImageURLPath)
      });
      pHTMLElement.find(".cpcdl_imagelabel").text(CloudflowObject.getParameter(pObject, this.options.itemImageLabelPath));
    },
    _updateItem_cpc: function _updateItem_cpc(pHTMLElement, pObject) {
      var updateContextKey = true;
      var historyStates = pHTMLElement.CustomPageComponent("getHistoryStates");
      if (historyStates !== undefined && Array.isArray(historyStates.historyStates) && historyStates.historyStates.length > 0 && typeof historyStates.historyStates[0].url === "string" && historyStates.currentState !== undefined && typeof historyStates.currentState.url === "string") {
        if (historyStates.historyStates[0].url !== historyStates.currentState.url) {
          updateContextKey = false;
        }
      }
      if (updateContextKey === true) {
        var changeObject = {};
        if ($.isPlainObject(pObject)) {
          changeObject.contextKey = pObject;
        }
        pHTMLElement.CustomPageComponent("option", changeObject);
      }
    },
    /**
     * @description reset and set all css on each item
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#_updateStyleItems
     */
    _updateStyleItems: function _updateStyleItems() {
      var vwWidth = $(window).width();
      this.element.children(".cpclist_list").removeClass("cpclist_list_percentageitems").children().children(".cpc_item").css({
        "height": this.options.itemHeight
      });
      if (isCSSStringPercentage(this.options.itemWidth)) {
        this.element.children(".cpclist_list").addClass("cpclist_list_percentageitems");
        this.element.children(".cpclist_list").children().css({
          "width": this.options.itemWidth
        });
      } else {
        var width = this.options.itemWidth;
        if (typeof this.options.itemWidth === "number" || parseInt(this.options.itemWidth) == this.options.itemWidth) {
          if (vwWidth < this.options.itemWidth) {
            width = "100%";
          }
        }
        this.element.children(".cpclist_list").children().children(".cpc_item").css({
          "width": width
        });
      }
      if (this.options.itemDisplayType === "image") {
        var imageWidth;
        if (typeof this.options.itemWidth === "number" || parseInt(this.options.itemWidth) == this.options.itemWidth) {
          if (vwWidth < this.options.itemWidth) {
            imageWidth = vwWidth - 10;
          } else {
            imageWidth = this.options.itemWidth - 10;
          }
        } else {
          imageWidth = "calc( " + this.options.itemWidth + " - 10px )";
        }
        var imageHeight;
        if (typeof this.options.itemHeight === "number" || parseInt(this.options.itemHeight) == this.options.itemHeight) {
          imageHeight = this.options.itemHeight - 30;
        } else {
          imageHeight = "calc( " + this.options.itemHeight + " - 30px )";
        }
        this.element.children(".cpclist_list").children().children(".cpc_item").children(".cpcdl_image").Image({
          maxWidth: imageWidth,
          maxHeight: imageHeight
        }).css({
          "width": imageWidth,
          "height": imageHeight
        });
      }
    },
    /**
     * @description update the list
     * @function
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#update
     * @returns {undefined}
     */
    update: function update() {
      var that = this;
      return $.Deferred(function (pDefer) {
        that.element.children(".cpclist_list").DynamicList("update").done(pDefer.resolve).fail(function (pError) {
          if (pError.expected === true) {
            pDefer.resolve([]);
          } else {
            pDefer.reject(pError);
          }
        });
      });
    },
    /**
     * @description Apply or reset a quick search from outside
     * @function
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#quickSearch
     * @param {Array} pQuery the query to apply as a quick search
     * @param {String} pAction the refresh action
     * @returns {Deferred} the refresh deferred
     */
    quickSearch: function quickSearch(pQuery, pAction) {
      if (this.options.collection === "object") {
        // no support
        LogListener.addLog({
          event_type: "error",
          details_data: {
            error_code: "quicksearch_not_supported",
            error: "quick search is not supported on static collection"
          },
          component_name: this.widgetFullName
        }, this.element);
      }
      if (pQuery === undefined || pQuery === null || pQuery === "") {
        this.quickSearchFilter = [];
      } else if (typeof pQuery === "string" && pQuery.length > 0) {
        this.quickSearchFilter = ["searchstring", "contains text like", pQuery];
      } else if (Array.isArray(pQuery)) {
        this.quickSearchFilter = pQuery.slice(); // copy
        if (pQuery.length === 3 && pQuery[1].indexOf("contains") === 0 && pQuery[2] === "") {
          // clear out the quickSearchFilter
          this.quickSearchFilter = [];
        }
      } else {
        throw new Error("unsupported query for the quickSearch");
      }
      return this.update().then(function () {
        return {};
      });
    },
    /**
     * @description get all selected items
     * @function
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#getSelectedItemIDs
     * @returns {Array.<String>}
     */
    getSelectedItemIDs: function getSelectedItemIDs() {
      var selectedIDs = [];
      var selectedItems = this.element.children(".cpclist_list").DynamicList("getSelectedItems");
      if (Array.isArray(selectedItems)) {
        for (var i = 0; i < selectedItems.length; i++) {
          selectedIDs.push(selectedItems[i][this.options.keyUniqID]);
        }
      }
      return selectedIDs;
    },
    /**
     * @description Get all data of all selected items
     * @function
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#getSelectedItems
     * @returns {undefined}
     */
    getSelectedItems: function getSelectedItems() {
      return this.element.children(".cpclist_list").DynamicList("getSelectedItems");
    },
    /**
     * @description Select extra rows
     * @function
     * @name nixps-cloudflow.CustomPageComponentDynamicList#selectRows
     * @param {Mixed} pRows The rowObjects or ids
     * @returns {undefined}
     */
    selectRows: function selectRows(pRowIDs) {
      // this.element.children(".cpclist_list").DynamicList("selectRows", pRowIDs);
      this.element.children(".nixps-cloudflow-ButtonsBarTableExtension").ButtonsBarTableExtension("updateButtons");
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#_setOptions
     */
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      $.each(options, function (key, value) {
        if (that._setOption(key, value) === true) {
          needRedraw = true;
        }
        ;
      });
      this._controlOptions();
      if (needRedraw === true) {
        this._draw();
      }
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "language") {
        if (pValue !== this.options.language) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "relativeBasePath") {
        if (pValue !== this.options.relativeBasePath) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "collection") {
        if (pValue !== this.options.collection) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "httpserviceInputName") {
        if (pValue !== this.options.httpserviceInputName) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "httpserviceWhitepaperName") {
        if (pValue !== this.options.httpserviceWhitepaperName) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "collectionArray") {
        if (_.isEqual(pValue, this.options.collectionArray) === false) {
          this._superApply(arguments);
          this._transformCollectionArray();
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "dataFileURL") {
        if (pValue !== this.options.dataFileURL) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "extraQuery") {
        if (_.isEqual(pValue, this.options.extraQuery) === false) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "topbarbuttons") {
        if (_.isEqual(pValue, this.options.topbarbuttons) === false) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "itemDisplayType") {
        if (pValue !== this.options.itemDisplayType) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "itemDisplayURL") {
        if (pValue !== this.options.itemDisplayURL) {
          this._superApply(arguments);
          return true;
        }
        this._superApply(arguments);
        return false;
      }
      if (pKey === "itemHeight") {
        if (pValue !== this.options.itemHeight) {
          this._superApply(arguments);
          this._updateStyleItems();
        }
        return false;
      }
      if (pKey === "itemWidth") {
        if (pValue !== this.options.itemWidth) {
          this._superApply(arguments);
          this._updateStyleItems();
        }
        return false;
      }
      if (pKey === "keyUniqID") {
        this._superApply(arguments);
        this.element.children(".cpclist_list").DynamicList("option", pKey, pValue);
        return false;
      }
      if (pKey === "refreshDelay") {
        this._superApply(arguments);
        this.element.children(".cpclist_list").DynamicList("option", "updateDelay", pValue);
        return false;
      }
      if (["enableSelecting", "lazyLoading", "scrollBatchLength", "initLimit"].includes(pKey)) {
        this._superApply(arguments);
        this.element.children(".cpclist_list").DynamicList("option", pKey, pValue);
        return false;
      }
      if (pKey === "deselectable") {
        this._superApply(arguments);
        this.element.children(".cpclist_list").DynamicList("option", "selectingOptions." + pKey, pValue);
        return false;
      }
      if (pKey === "multipleSelectable") {
        this._superApply(arguments);
        this.element.children(".cpclist_list").DynamicList("option", "selectingOptions.multiple", pValue);
        return false;
      }
      if (pKey === "height") {
        if (pValue !== this.options.height) {
          this._superApply(arguments);
          this._controlOptions();
          if (this.options.height !== null) {
            this.element.children(".cpclist_list").css("height", "");
          }
          if (typeof pValue === "number" || typeof pValue === "string") {
            this.element.children(".cpclist_list").css("height", pValue);
          }
        }
        return false;
      }
      this._superApply(arguments);
      this._controlOptions();
      return true;
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-pagebuilder.CustomPageComponentDynamicList#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" && this.options.language.length <= 0) {
        throw new Error("CustomPageComponentDynamicList: input option language must be a not empty string");
      }
      if (Array.isArray(this.options.topbarbuttons) === false) {
        throw new Error("CustomPageComponentDynamicList: input option topbarbuttons must be an array");
      }
      if (typeof this.options.relativeBasePath !== "string") {
        throw new Error("CustomPageComponentDynamicList: input option relativeBasePath must be a string");
      }
      if (Array.isArray(this.options.extraQuery) === false) {
        throw new Error("CustomPageComponentDynamicList: input option extraQuery must be an array");
      }
      if (["image", "custom"].includes(this.options.itemDisplayType) === false) {
        throw new Error("CustomPageComponentDynamicList: input option itemDisplayType must be equal to image or custom");
      }
      if (typeof this.options.itemDisplayURL !== "string") {
        throw new Error("CustomPageComponentDynamicList: input option itemDisplayURL must be a string");
      }
      if (typeof this.options.hasDataModification !== "boolean") {
        throw new Error("CustomPageComponentDynamicList: input option hasDataModification must be a boolean");
      }
      if (!Array.isArray(this.options.sort)) {
        throw new Error("CustomPageComponentDynamicList: input option sort must be an array");
      }
      if (this.options.sort.length % 2 === 1) {
        throw new Error("CustomPageComponentDynamicList: input option sort must contain an even amount of items");
      }
      for (var i = 0; i < this.options.sort.length; i++) {
        if (typeof this.options.sort[i] !== "string") {
          throw new Error("CustomPageComponentDynamicList: input option sort index " + i + " must be a string");
        }
        if (i % 2 === 1 && ["ascending", "descending"].includes(this.options.sort[i]) === false) {
          throw new Error("CustomPageComponentDynamicList: input option sort index " + i + " must be the string ascending or descending");
        }
      }
      if (typeof this.options.collection === "string" && this.options.collection.indexOf("nucleus.") === 0) {
        this.options.keyUniqID = "_id";
      }
      if (typeof this.options.keyUniqID !== "string" || this.options.keyUniqID.length <= 0) {
        throw new Error("CustomPageComponentDynamicList: input option keyUniqID must be a not empty string");
      }
      if (typeof this.options.enableSelecting !== "boolean") {
        throw new Error("CustomPageComponentDynamicList: input option enableSelecting must be a boolean");
      }
      if (typeof this.options.height === "string") {
        this.options.height = this.options.height.trim();
      }
      if (typeof this.options.itemWidth !== "number" || this.options.itemWidth < 0) {
        if (typeof this.options.itemWidth !== "string") {
          throw new Error("CustomPageComponentDynamicList: input option itemWidth must be a positive number");
        }
      }
      if (typeof this.options.itemHeight !== "number" || this.options.itemHeight < 0) {
        if (typeof this.options.itemHeight !== "string") {
          throw new Error("CustomPageComponentDynamicList: input option itemHeight must be a positive number");
        }
      }
      if (typeof this.options.refreshDelay !== "number" || this.options.refreshDelay < 0 || this.options.refreshDelay > 2147483647) {
        throw new Error("CustomPageComponentDynamicList:input option refreshDelay must be a number between 0 and 2147483647");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName);
      this._superApply(arguments);
      if (this.connection !== null && this.connection !== undefined) {
        this.connection.stop("quit_DOM");
      }
    }
  });
})(jQuery);

},{"../../../cloudflow/CloudflowUtil/js/CloudflowConnection.js":78,"../../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79,"../../../cloudflow/PWA/js/Device.js":198,"../../../cloudflow/Table/js/nixps-cloudflow-ButtonsBarTableExtension.js":214,"../../../common/DynamicList/js/nixps-DynamicList.js":290,"../../../pagebuilder/js/inspect/LogListener.js":431,"../DoneQueue.js":414}],423:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Feb 2, 2018 5:42:43 PM
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var amountPopovers = 0;
  var timestampPervEvent;
  function clickOtherSpace(pEvent) {
    if ($(pEvent.target).closest(".nixps-pagebuilder-CustomPageComponentPopover").length > 0) {
      return true;
    }
    if (pEvent.timeStamp === timestampPervEvent) {
      return true;
    }
    $("body").find(".nixps-pagebuilder-CustomPageComponentPopover").CustomPageComponentPopover("close", pEvent, undefined, null);
  }
  function startListenOtherSpace(pSourceEvent) {
    timestampPervEvent = pSourceEvent.timeStamp;
    if (amountPopovers === 0) {
      $(window).on("click", clickOtherSpace);
    }
    amountPopovers++;
  }
  function endListenOtherSpace() {
    amountPopovers--;
    if (amountPopovers === 0) {
      $(window).off("click", clickOtherSpace);
    }
  }
  var spacesRegExp = new RegExp(" ", "g");

  /**
   * @namespace nixps-pagebuilder.CustomPageComponentPopover
   * @description Draw a popover. When clicked somewhere else the popover will be closed, but not removed. When reclicking the dialog will remove the hide css.
   * We make sure only one popover will be visible at the time
   * @private
   * @example $('<div>').CustomPageComponentPopover({});
   * @version 1.0.0
   */
  $.widget("nixps-pagebuilder.CustomPageComponentPopover", {
    version: "1.0.0",
    widgetEventPrefix: "custompagecomponentpopover",
    options: {
      /**
       * @name nixps-cloudflow.CustomPageComponentPopover#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-cloudflow.CustomPageComponentPopover#sourceEvent
       * @description The event to listen and to use for placing the popover
       * @type {Event}
       * @default null
       */
      sourceEvent: null,
      /**
       * @name nixps-cloudflow.CustomPageComponentPopover#contentOptions
       * @description The options give throug the customcomponent
       * @type {Object}
       * @default {}
       */
      contentOptions: {},
      /**
       * @name nixps-cloudflow.CustomPageComponentPopover#style_type
       * @description The type of style you want
       * @type {String}
       * @default "default"
       */
      style_type: "default",
      /**
       * @name nixps-cloudflow.CustomPageComponentPopover#width
       * @description The with of the popover
       * @type {Number}
       * @default 250
       */
      width: 250,
      /**
       * @name nixps-cloudflow.CustomPageComponentPopover#height
       * @description The height of the popover
       * @type {Number}
       * @default 500
       */
      height: 500,
      /**
       * @name nixps-cloudflow.CustomPageComponentPopover#zIndex
       * @description The zIndex of the popover
       * @type {Number}
       * @default 500
       */
      zIndex: 1000000,
      /**
       * @name nixps-cloudflow.CustomPageComponentPopover#publicParentWidgetName
       * @private
       */
      publicParentWidgetName: undefined
    },
    _createWidget: function _createWidget(options, element) {
      // inherit from $.ui.widget. This function creates the DOM and is the first function that is called
      // so we can prevent creating the DOM
      if (options) {
        if (options.sourceEvent && options.sourceEvent.currentTarget) {
          var possiblePopoverDatas = $(options.sourceEvent.currentTarget).data("cpc_popover");
          if (Array.isArray(possiblePopoverDatas)) {
            var possiblePopoverData = possiblePopoverDatas.find(function (pData) {
              return pData.eventtype === options.sourceEvent.type;
            });
            if (possiblePopoverData && typeof possiblePopoverData.uuid === "number") {
              $("body").find(".nixps-pagebuilder-CustomPageComponentPopover[data-uuid='" + possiblePopoverData.uuid + "']").CustomPageComponentPopover("option", "closedialog", options.closedialog).CustomPageComponentPopover("toggle", options.sourceEvent, options.contentOptions, null);
              // do not create component at all;
              return true;
            }
          }
        }
      }
      this._superApply(arguments);
    },
    /**
     * @description Create the component
     * @name nixps-pagebuilder.CustomPageComponentPopover#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("cf-dialog cf-dialog-content").attr("data-uuid", this.uuid).css({
        "position": "absolute",
        "zIndex": this.options.zIndex
      });
      // variables
      // use array, because in tables you can have different popovers on the same table element
      // differentiate by eventtype
      var existingData = $(this.options.sourceEvent.currentTarget).data("cpc_popover");
      if (!Array.isArray(existingData)) {
        existingData = [];
      }
      existingData.push({
        eventtype: this.options.sourceEvent.type,
        uuid: this.uuid
      });
      $(this.options.sourceEvent.currentTarget).data("cpc_popover", existingData);

      // skeleton
      var container = $("<div>").addClass("cpcd_container");
      this.element.append(container);
      this.element.css({
        width: this._prepareCSSValue(this.options.width),
        height: this._prepareCSSValue(this.options.height)
      });
      var pagecontent = $("body").find(".cf-page, .cf-pageframe").first().find(".cf-pagecontent").first();
      // position to place
      var appendTo = $("body");
      if ($(this.options.sourceEvent.currentTarget).closest(".cf-pagecontent").length > 0) {
        appendTo = pagecontent;
      }
      appendTo.append(this.element);
      // boundary to lock in
      this.positionWithIn = window;
      if (pagecontent.length > 0) {
        // we are in a special usecase, nl nebula
        this.positionWithIn = pagecontent;
      }
      this._draw();
      this.open(this.options.sourceEvent);
      this._on(this.element, {
        "custompagebuilderclosecontainer": this._closeEventHandler
      });
    },
    /**
     * @description function runs when user added a custom trigger to close the dialog
     * @function
     * @name nixps-pagebuilder.CustomPageComponentPopover#_closeEventHandler
     * @private
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _closeEventHandler: function _closeEventHandler(pEvent, pData, pOriginalEvent) {
      var returnData = {};
      if (pData !== undefined && $.isPlainObject(pData.data_to_pass)) {
        returnData = pData.data_to_pass;
      }
      this.close(pEvent, returnData, undefined);
      pEvent.stopPropagation();
      pEvent.preventDefault();
      if (pOriginalEvent !== undefined && pOriginalEvent.stopPropagation !== undefined) {
        pOriginalEvent.stopPropagation();
      }
      return false;
    },
    _position: function _position(pSourceEvent) {
      var ofElement = pSourceEvent.currentTarget;
      if (["click", "dblclick"].includes(pSourceEvent.type) === false) {
        if (pSourceEvent.originalEvent !== undefined && ["click", "dblclick"].includes(pSourceEvent.originalEvent.type)) {
          ofElement = pSourceEvent.originalEvent.currentTarget;
        } else {
          ofElement = pSourceEvent.toElement || pSourceEvent.srcElement || pSourceEvent.target;
        }
      }
      this.element.position({
        "my": "center top",
        "at": "center bottom+5px",
        "collision": "flipfit flipfit",
        "of": ofElement,
        "within": this.positionWithIn
      });
    },
    isOpen: function isOpen() {
      return this.element.is(":visible");
    },
    toggle: function toggle(event, contentOptions, otherOpen) {
      if ($.isPlainObject(contentOptions)) {
        // update options
        this.options.contentOptions = Object.assign({}, contentOptions);
      }
      if (this.isOpen()) {
        this.close(event, undefined, otherOpen);
      } else {
        this.open(event);
        this._refresh();
      }
    },
    open: function open(event) {
      // open myself
      this.element.css("display", "");
      if (event !== undefined) {
        timestampPervEvent = event.timeStamp;
        this._position(event);
      }
      // close all others
      $('body').find(".nixps-pagebuilder-CustomPageComponentPopover:not([data-uuid='" + this.uuid + "'])").CustomPageComponentPopover("close", event, undefined, this.uuid);
      startListenOtherSpace(event);
    },
    /**
     * @description Close the dialog.
     * @function
     * @extends dialog#close
     * @name nixps-pagebuilder.CustomPageComponentDialog#close
     * @param {type} event
     * @return {nixps-pagebuilder-CustomPageComponentDialogL#8.nixps-pagebuilder-CustomPageComponentDialogAnonym$0|undefined}
     */
    close: function close(event, pReturnData, pOtherOpen) {
      if (event !== undefined) {
        timestampPervEvent = event.timeStamp;
      }
      if (this.isOpen() === false) {
        return;
      }
      this.element.hide();
      var closingBy = "";
      if ($.isPlainObject(pReturnData)) {
        closingBy = "close_action";
      } else if (pOtherOpen !== undefined) {
        // can be a uuid or null
        closingBy = "click_outside";
      } else if (event.keyCode && event.keyCode === $.ui.keyCode.ESCAPE) {
        closingBy = "escape_key";
      } else if ($(event.currentTarget).hasClass("ui-dialog-titlebar-close")) {
        closingBy = "close_button";
      }
      var triggerData = {
        outputData: {
          closingBy: closingBy,
          data: {}
        }
      };
      if ($.isPlainObject(pReturnData)) {
        triggerData.outputData.data = pReturnData;
      }
      this._trigger("closedialog", null, triggerData);
      endListenOtherSpace();
      return this;
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDialog#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this.options.contentOptions.language = this.options.language;
      this.options.contentOptions.publicParentWidgetName = this.widgetFullName;
      this.element.children(".cpcd_container").CustomPageComponent(this.options.contentOptions);
    },
    _refresh: function _refresh() {
      var cpcDOM = this.element.children(".cpcd_container");
      if (this.options.contentOptions.url !== cpcDOM.CustomPageComponent("option", "url")) {
        cpcDOM.css({
          "position": "absolute",
          "top": -1000,
          "left": -1000
        });
      }
      return $.when(cpcDOM.CustomPageComponent("refresh", this.options.contentOptions.contextConnector, this.options.contentOptions.contextCollection, this.options.contentOptions.contextKey, false, undefined, undefined, true)).always(function () {
        cpcDOM.css({
          "position": "",
          "top": "",
          "left": ""
        });
      });
    },
    _prepareCSSValue: function _prepareCSSValue(pCSSValue) {
      // first remove all spaces
      var value;
      if (typeof pCSSValue === "string") {
        value = pCSSValue.replace(spacesRegExp, '');
      } else {
        value = pCSSValue;
      }
      var parsedValue = parseFloat(value);
      // check if value contains only numbers, so check if string is same as parsed of string
      if (parsedValue == value) {
        return parsedValue; // if so return type number
      }

      return value;
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-pagebuilder.CustomPageComponentDialog#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "contentOptions") {
        this.element.children(".cpcd_container").CustomPageComponent("option", pValue);
      } else if (pKey === "zIndex") {
        this.element.css("zIndex", pValue);
      } else if (pKey === "height") {
        this.element.css({
          height: this.options.height
        });
      } else if (pKey === "width") {
        this.element.css({
          width: this.options.width
        });
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-pagebuilder.CustomPageComponentDialog#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if ($.isPlainObject(this.options.contentOptions) === false) {
        throw new Error(this.widgetName + ": input options contentOptions must be an object");
      }
    },
    _destroy: function _destroy() {
      var that = this;
      this.element.removeClass(this.widgetFullName).removeClass("cf-dialog cf-dialog-content").removeAttr("data-uuid");
      if (this.options.sourceEvent !== undefined && this.options.sourceEvent.currentTarget !== undefined) {
        var DOMElement = $(this.options.sourceEvent.currentTarget);
        var data = DOMElement.data("cpc_popover");
        if (!Array.isArray(data)) {
          DOMElement = $(this.options.sourceEvent.target);
          data = DOMElement.data("cpc_popover");
        }
        if (Array.isArray(data)) {
          var filteredData = data.filter(function (pData) {
            return pData.uuid !== that.uuid;
          });
          if (Array.isArray(filteredData) && filteredData.length > 0) {
            DOMElement.data("cpc_popover", filteredData);
          } else {
            DOMElement.removeData("cpc_popover");
          }
        }
      }
      this._superApply(arguments);
    }
  });
  if ($.fn.CustomPageComponentPopover_returnCloseDef === undefined) {
    $.fn.CustomPageComponentPopover_returnCloseDef = function (options) {
      var closeDef = $.Deferred(); // defer object to return when creating dialog
      var orgCloseDialogFunc = options.closedialog; // orgiginal close option function
      options.closedialog = function (pEvent, pData) {
        if (typeof orgCloseDialogFunc === "function") {
          orgCloseDialogFunc(pEvent, pData); // apply original option
        }

        var output = {};
        if (pData !== undefined && pData.outputData !== undefined) {
          output = pData.outputData;
        }
        closeDef.resolve(output); // indicate the dialog has been closed, the next action may begin
      };

      this.CustomPageComponentPopover(options);
      return closeDef;
    };
  } else {
    console.warn("The component CustomPageComponentPopover_returnCloseDef already exists!");
  }
})(jQuery);

},{}],424:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on 20-feb-2020 15:12:26
 */
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _ */

(function ($) {
  var CloudflowURL = require("../../../cloudflow/CloudflowUtil/js/CloudflowURL.js");
  var LogListener = require("../inspect/LogListener.js");
  var Location = require("../../../cloudflow/CloudflowUtil/js/Location.js");
  function extract(pIframe) {
    if (typeof pIframe === "string" && pIframe.length > 0) {
      if (/^<iframe .*><\\iframe>$/.test(pIframe)) {
        var src = pIframe.replace(/src="([^"]*)"/i, "$1");
        var width = pIframe.replace(/width="([^"]*)"/i, "$1");
        var height = pIframe.replace(/height="([^"]*)"/i, "$1");
        return {
          src: src,
          width: width,
          height: height
        };
      }
    }
    return {
      src: pIframe
    };
  }

  /**
   * @namespace nixps-pagebuilder-IframeComponent
   * @description draw a component containing a iframe
   * @private
   * @version 1.1.0
   * @example $("<div>").IframeComponent({});
   */
  $.widget("nixps-pagebuilder.IframeComponent", $.Widget, {
    version: "1.1.0",
    defaultElement: "<div>",
    widgetEventPrefix: "iframecomponent",
    options: {
      /**
       * @name nixps-pagebuilder.IframeComponent#height
       * @description The language of the user
       * @type {String}
       * @default null
       */
      language: "en",
      /**
       * @name nixps-pagebuilder.IframeComponent#relativeBasePath
       * @description the relative path of the frame
       * @type {String}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @description User object
       * @name nixps-pagebuilder.IframeComponent#user
       * @type {Object}
       * @default undefined
       */
      user: undefined,
      /**
       * @name nixps-pagebuilder.IframeComponent#height
       * @description The height of the component
       * @type {Mixed}
       * @default null
       */
      height: null,
      /**
       * @name nixps-pagebuilder.IframeComponent#width
       * @description The width of the component
       * @type {Mixed}
       * @default "100%"
       */
      width: "100%",
      /**
       * @name nixps-pagebuilder.IframeComponent#url
       * @description The url of the page to be shown
       * @type {String}
       * @default null
       */
      url: "",
      /**
       * @description Data to given to the iFrame itself
       * @name nixps-pagebuilder.IframeComponent#inputParameters
       * @type {Object}
       * @default {}
       */
      inputParameters: {},
      /**
       * @description The title to be added for accessibility on the iframe
       * @name nixps-pagebuilder.IframeComponent#title
       * @type {String}
       * @default undefined
       */
      title: undefined,
      addSession: "url",
      /**
       * @description The expiry of the session in hours, provide 0 to not set up an session
       * @name nixps-pagebuilder.IframeComponent#sessionExpiry
       * @type {Number}
       * @default 12
       */
      sessionExpiry: 12,
      /**
       * @name nixps-pagebuilder.IframeComponent#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-pagebuilder.IframeComponent#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this._addClass(this.widgetFullName);
      this.element.attr("data-uuid", this.uuid);

      // variables
      this.alive = true;
      this.creating = true; // flag when component is done drawing, successfully or not
      this.callingID = 0; // uniq id's to identify the calls
      this.replyWaitingDict = {}; // all the hanging messages deferred, waiting to be replied

      this._draw();
      this.recieveMessageHandler = this._recieveMessageHandler.bind(this);
      window.addEventListener("message", this.recieveMessageHandler);
      this._on(this.element, {});
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-pagebuilder.IframeComponent#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-pagebuilder.IframeComponent#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      this.mFrame = $("<iframe>").text("The browser does not support iframe");
      var url = new CloudflowURL(this.options.relativeBasePath, this.options.url, true).getUploadPath();
      var urlDef = url;
      url += (url.indexOf("?") >= 0 ? "&" : "?") + "lang=" + this.options.language;
      if (this.options.inputParameters && _typeof(this.options.inputParameters) === "object" && Object.keys(this.options.inputParameters).length > 0) {
        url += "&inputparameters=" + encodeURIComponent(JSON.stringify(this.options.inputParameters));
      }
      var outsideOrigin = window.location.origin && (url.indexOf("https:") === 0 || url.indexOf("http:") === 0) && Location.hasSameOrigin(url) === false;
      if (this.options.addSession === "url" && typeof this.options.sessionExpiry === "number" && this.options.sessionExpiry > 0 && outsideOrigin === false) {
        var session = api_util.get_session();
        if (typeof session === "string" && session.length > 0) {
          url += "&session=" + session;
        } else if (this.options.user !== undefined) {
          urlDef = api_defer.auth.create_session(this.options.user.getUserName(), {
            expiry: this.options.sessionExpiry * 60
          }).then(function (pResult) {
            if (that.alive === false) {
              return;
            }
            window.api.set_session(pResult.session);
            url += "&session=" + api_util.get_session();
            return url;
          }, function (pError) {
            console.error("missing calculation session ", pError);
            return url;
          });
        }
      }
      if (typeof this.options.title === "string" && this.options.title.length > 0) {
        this.mFrame.attr("title", this.options.title);
      }
      this.element.empty().append(this.mFrame.attr({
        "height": this.options.height,
        "width": this.options.width,
        "sandbox": "allow-downloads allow-modals allow-popups allow-forms allow-presentation allow-scripts"
      }));
      $.when(urlDef).then(function () {
        if (that.alive === false) {
          return;
        }
        if (outsideOrigin) {
          // other origin, outside cloudflow server, we can open the gates
          that.mFrame.removeAttr("sandbox");
        }
        that.mFrame.attr("src", url);
      }).always(function () {
        that._endCreating();
      });
    },
    _endCreating: function _endCreating(pEvent) {
      if (this.creating === true) {
        this.creating = false;
        this.options.created();
      }
    },
    /**
     * @description Send a message to the iframe
     * @function
     * @name nixps-pagebuilder.IframeComponent#sendMessage
     * @param {Object} pMessageData Data to be send to the iframe
     * @param {Object} pOptions 
     * @returns {Deferred}
     */
    sendMessage: function sendMessage(pMessageData) {
      var pOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var output = this._sendMessage("cf-pagebuilder-send_message", pMessageData);
      if (pOptions && pOptions.wait_response === false) {
        return {};
      }
      var responseDef = $.Deferred();
      this.replyWaitingDict[output.callingID] = {
        promise: responseDef,
        timeoutID: this._delay(function () {
          if (this.alive === false) {
            return; // do not retrigger if it is a zombie
          }
          // check if not already given
          if (this.replyWaitingDict[output.callingID] && this.replyWaitingDict[output.callingID].promise && this.replyWaitingDict[output.callingID].promise.state() === "pending") {
            this.replyWaitingDict[output.callingID].promise.reject({
              error_code: "timeout",
              error: "timeout"
            });
          }
          // wait and remove
          this._delay(function () {
            if (this.alive === false) {
              return; // do not retrigger if it is a zombie
            }

            delete this.replyWaitingDict[output.callingID];
          });
        }, 120000)
      };
      return responseDef;
    },
    /**
     * @description send a message to the iframe
     * @function
     * @private
     * @name nixps-pagebuilder.IframeComponent#_sendMessage
     * @param {String} pMessageType type of message
     * @param {Object} pMessageData data of message
     * @returns {Object} callingID
     */
    _sendMessage: function _sendMessage(pMessageType, pMessageData) {
      if (this.alive === false) {
        return; // it is a zombie
      }

      var messageObject = {
        calling_id: ++this.callingID,
        action: pMessageType,
        content: pMessageData || null
      };
      if (this.mFrame && this.mFrame[0].contentWindow !== undefined) {
        try {
          this.mFrame[0].contentWindow.postMessage(messageObject, "*");
        } catch (e) {
          console.error(e);
        }
      } else {
        // iframe in not created yet!
        throw new Error("contentWindow is not present");
      }
      return {
        callingID: this.callingID
      };
    },
    /**
     * @description recieve callback of messages send by iframe to this component
     * @function
     * @private
     * @name nixps-pagebuilder.IframeComponent#_recieveMessageHandler
     * @param {Object} pEvent 
     * @returns {undefined}
     */
    _recieveMessageHandler: function _recieveMessageHandler(pEvent) {
      if (pEvent.source !== this.mFrame[0].contentWindow) {
        // could be other iframe component
        // so do nothing if incomming is from other iframes form other iFrameComponent
        return;
      }
      if (pEvent.origin !== "null" && pEvent.origin !== window.location.origin) {
        return;
      }
      if (pEvent.data !== undefined) {
        if (pEvent.data.form_data_json !== undefined) {
          pEvent.data.form_data = new FormData();
          for (var key in pEvent.data.form_data_json) {
            pEvent.data.form_data.append(pEvent.data.form_data_json[key][0], pEvent.data.form_data_json[key][1], pEvent.data.form_data_json[key][2]);
          }
        }
        if (typeof pEvent.data.action === "string") {
          switch (pEvent.data.action) {
            // iframe want to send a custom trigger in pagebuilder page
            case "cf-pagebuilder-send_trigger":
              this._sendCustomTrigger(pEvent.data);
              break;
            // iframe want to reply on a message
            case "cf-pagebuilder-reply_message":
              this._replyMessage(pEvent.data);
              break;
            // iframe want to do an api call 
            case "cf-api":
              this._applyAPICall(pEvent.data);
              break;
            // iframe want to do an $.ajax call 
            case "cf-ajax":
              this._applyAJAX(pEvent.data);
              break;
            // iframe want to do XMLHttpRequest call
            case "cf-xmlhttprequest":
              this._applyXMLHttpRequest(pEvent.data);
              break;
            // iframe want to do abort a call
            case "cf-xmlhttprequest-abort":
              this._abortXMLHttpRequest(pEvent.data);
              break;
            // iframe want to do a fetch call
            case "cf-fetch":
              this._applyFetch(pEvent.data);
              break;
            default:
              console.error("unkown action id", Event.data.action);
          }
        }
      }
    },
    /**
     * @description Send a custom message to the pagebuilder page and resend the result back
     * @function
     * @private
     * @name nixps-pagebuilder.IframeComponent#_sendCustomTrigger
     * @param {Object} pIframeMessage the message object
     */
    _sendCustomTrigger: function _sendCustomTrigger(pIframeMessage) {
      var that = this;

      // prepare event to retrieve deferred result later on 
      var origEvent = undefined;
      this.element.one(this.widgetName.toLowerCase() + "custom", function (pEvent) {
        origEvent = pEvent;
      });

      // do the trigger
      this._trigger("custom", null, {
        "content": pIframeMessage.content.trigger_data || {},
        "pageURL": new CloudflowURL(this.options.relativeBasePath, this.options.url, true).getCloudflowPath()
      });

      // retrieve the result of the pagebuilder actions
      if (origEvent && origEvent.result && typeof origEvent.result.then === "function") {
        origEvent.result.then(function (pPreviousData) {
          that._sendMessage("cf-pagebuilder-reply_send_trigger", {
            success: true,
            request: pIframeMessage,
            response: pPreviousData
          });
        }, function (pError) {
          that._sendMessage("cf-pagebuilder-reply_send_trigger", {
            success: false,
            request: pIframeMessage,
            response: pError,
            error: pError
          });
        });
      }
    },
    /**
     * @description function runs when a reply on a request need to return
     * @function
     * @private
     * @name nixps-pagebuilder.IframeComponent#_replyMessage
     * @param {Object} pIframeMessage 
     * @returns undefined
     */
    _replyMessage: function _replyMessage(pIframeMessage) {
      if (pIframeMessage.content === undefined) {
        var error = {
          error_code: "missing_content",
          error: "parameter content is missing"
        };
        console.error(error);
        this._sendMessage("cf-error", {
          error: error
        });
        LogListener.addLog({
          event_type: "error",
          details_data: error,
          page_url: new CloudflowURL(this.options.relativeBasePath, this.options.url, true).getCloudflowPath()
        });
        return;
      }
      // check calling id
      if (typeof pIframeMessage.content.response_calling_id !== "number" || pIframeMessage.content.response_calling_id <= 0) {
        var error = {
          error_code: "missing_callingid",
          error: "parameter response_calling_id is missing or is not a positive number"
        };
        console.error(error);
        this._sendMessage("cf-error", {
          error: error
        });
        LogListener.addLog({
          event_type: "error",
          details_data: error,
          page_url: new CloudflowURL(this.options.relativeBasePath, this.options.url, true).getCloudflowPath()
        });
        return;
      }
      // check if there is a response waiting?
      if (this.replyWaitingDict[pIframeMessage.content.response_calling_id] === undefined) {
        var error = {
          error_code: "no_response_found",
          error: "The corresponding response has not been found or is already answered"
        };
        console.error(error);
        this._sendMessage("cf-error", {
          error: error
        });
        LogListener.addLog({
          event_type: "error",
          details_data: error,
          page_url: new CloudflowURL(this.options.relativeBasePath, this.options.url, true).getCloudflowPath()
        });
        return;
      }
      if (this.replyWaitingDict[pIframeMessage.content.response_calling_id].promise.state() !== "pending") {
        var error = {
          error_code: "response_already_given",
          error: "The corresponding response is already answered"
        };
        console.error(error);
        this._sendMessage("cf-error", {
          error: error
        });
        LogListener.addLog({
          event_type: "error",
          details_data: error,
          page_url: new CloudflowURL(this.options.relativeBasePath, this.options.url, true).getCloudflowPath()
        });
        return;
      }
      // stop timeout timer
      if (this.replyWaitingDict[pIframeMessage.content.response_calling_id].timeoutID !== undefined) {
        clearTimeout(this.replyWaitingDict[pIframeMessage.content.response_calling_id].timeoutID);
      }
      // response
      if (pIframeMessage.content.success === true || pIframeMessage.content.success === undefined) {
        this.replyWaitingDict[pIframeMessage.content.response_calling_id].promise.resolve(pIframeMessage.content.response);
      } else if (pIframeMessage.content.success === false) {
        this.replyWaitingDict[pIframeMessage.content.response_calling_id].promise.reject(pIframeMessage.content.error || pIframeMessage.content.response);
      }
      // wait and remove
      this._delay(function () {
        if (this.alive === false) {
          return; // do not retrigger if it is a zombie
        }

        delete this.replyWaitingDict[pIframeMessage.content.response_calling_id];
      });
    },
    _applyAPICall: function _applyAPICall(pIframeMessage) {
      var that = this;
      api_defer.server_call.apply(api_defer, [{
        m_parent: api_defer
      }].concat(pIframeMessage.content.arguments)).then(function (pResult) {
        that._sendMessage("cf-api", {
          response_calling_id: pIframeMessage.content.calling_id,
          success: true,
          response: pResult
        });
      }, function (pError) {
        that._sendMessage("cf-api", {
          response_calling_id: pIframeMessage.content.calling_id,
          success: false,
          response: pError
        });
      });
    },
    _applyAJAX: function _applyAJAX(pIframeMessage) {
      var that = this;
      $.ajax(pIframeMessage.content.arguments[0], pIframeMessage.content.arguments[1]).then(function (pData, pTextStatus, jqXHR) {
        that._sendMessage("cf-api", {
          response_calling_id: pIframeMessage.content.calling_id,
          success: true,
          response: {
            data: pData,
            textStatus: pTextStatus,
            jqXHRData: {
              response: jqXHR.response,
              responseText: jqXHR.responseText,
              readyState: jqXHR.readyState,
              status: jqXHR.status,
              statusText: jqXHR.statusText
            }
          }
        });
      }, function (jqXHR, pTextStatus, errorThrown) {
        that._sendMessage("cf-api", {
          response_calling_id: pIframeMessage.content.calling_id,
          success: false,
          response: {
            errorThrown: errorThrown,
            textStatus: pTextStatus,
            jqXHRData: {
              response: jqXHR.response,
              responseText: jqXHR.responseText,
              readyState: jqXHR.readyState,
              status: jqXHR.status,
              statusText: jqXHR.statusText
            }
          }
        });
      });
    },
    _applyXMLHttpRequest: function _applyXMLHttpRequest(pIframeMessage) {
      var that = this;
      var sendData = pIframeMessage.content.arguments[0];
      var openArguments = pIframeMessage.content.arguments[1];
      var requestHeaders = pIframeMessage.content.arguments[2];
      var overwriteMimeTypes = pIframeMessage.content.arguments[3];
      var withCredentials = pIframeMessage.content.arguments[4];
      var xhttp = new XMLHttpRequest();
      xhttp.open.apply(xhttp, openArguments);
      for (var key in requestHeaders) {
        xhttp.setRequestHeader(key, requestHeaders[key]);
      }
      if (typeof overwriteMimeTypes === "string") {
        xhttp.overrideMimeType(overwriteMimeTypes);
      }
      if (typeof withCredentials === "boolean") {
        xhttp.withCredentials = withCredentials;
      }
      xhttp.onload = function (pEvent) {
        that._sendMessage("cf-api", {
          response_calling_id: pIframeMessage.content.calling_id,
          success: true,
          response: {
            response: xhttp.response,
            responseText: xhttp.responseText,
            responseType: xhttp.responseType,
            responseXML: xhttp.responseXML,
            status: xhttp.status,
            statusText: xhttp.statusText,
            allResponseHeaders: xhttp.getAllResponseHeaders()
          }
        });
      };
      xhttp.onabort = function (pEvent) {
        console.error("abort not implemented");
      };
      xhttp.onerror = function (pEvent) {
        that._sendMessage("cf-api", {
          response_calling_id: pIframeMessage.content.calling_id,
          success: false,
          response: {
            response: xhttp.response,
            responseText: xhttp.responseText,
            status: xhttp.status,
            statusText: xhttp.statusText
          }
        });
      };
      if (pIframeMessage.form_data instanceof FormData) {
        xhttp.send(pIframeMessage.form_data);
      } else {
        xhttp.send(sendData);
      }
    },
    _abortXMLHttpRequest: function _abortXMLHttpRequest(pIframeMessage) {
      console.error("abort not implemented");
    },
    _applyFetch: function _applyFetch(pIframeMessage) {
      var that = this;
      var url = pIframeMessage.content.arguments[0];
      var options = pIframeMessage.content.arguments[1];
      // if (pIframeMessage.form_data instanceof FormData) {
      fetch(url, options).then(function (pResult) {
        if (pResult.headers.get("content-type").indexOf("image") === 0) {
          pResult.blob().then(function (pBlob) {
            pBlob.arrayBuffer().then(function (pArrayBuffer) {
              that._sendMessage("cf-api", {
                response_calling_id: pIframeMessage.content.calling_id,
                success: true,
                response_json: {
                  _blob: pArrayBuffer,
                  bodyUsed: pResult.bodyUsed,
                  ok: pResult.ok,
                  status: pResult.status,
                  statusText: pResult.statusText,
                  type: pResult.type,
                  url: pResult.url
                }
              });
            });
          });
        } else if (pResult.headers.get("content-type").indexOf("json") === 0) {
          pResult.json().then(function (pJSON) {
            that._sendMessage("cf-api", {
              response_calling_id: pIframeMessage.content.calling_id,
              success: true,
              response_json: {
                _json: pJSON,
                bodyUsed: pResult.bodyUsed,
                ok: pResult.ok,
                status: pResult.status,
                statusText: pResult.statusText,
                type: pResult.type,
                url: pResult.url
              }
            });
          });
        } else {
          pResult.arrayBuffer().then(function (pArrayBuffer) {
            that._sendMessage("cf-api", {
              response_calling_id: pIframeMessage.content.calling_id,
              success: true,
              response_json: {
                _arrayBuffer: pArrayBuffer,
                bodyUsed: pResult.bodyUsed,
                ok: pResult.ok,
                status: pResult.status,
                statusText: pResult.statusText,
                type: pResult.type,
                url: pResult.url
              }
            });
          });
        }
      }, function (pError) {
        that._sendMessage("cf-api", {
          response_calling_id: pIframeMessage.content.calling_id,
          success: false,
          response: pError
        });
      });
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-pagebuilder.IframeComponent#_setOptions
     */
    _setOptions: function _setOptions(options) {
      this._superApply(arguments);
      this._controlOptions();
      this._draw();
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-pagebuilder.IframeComponent#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" || this.options.language.length <= 0) {
        throw new Error("IframeComponent input option language must be a not empty string");
      }
      if (typeof this.options.relativeBasePath !== "string") {
        throw new Error("IframeComponent input option relativeBasePath must be a string");
      }
      if (typeof this.options.url !== "string") {
        throw new Error("IframeComponent input option url must be a string");
      }
      if (_typeof(this.options.inputParameters) !== "object") {
        throw new Error("IframeComponent inputParameters option must be an object");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeAttr("data-uuid");
      for (var callingID in this.replyWaitingDict) {
        if (this.replyWaitingDict[callingID].promise && this.replyWaitingDict[callingID].promise.state() === "pending") {
          this.replyWaitingDict[callingID].promise.reject({
            error_code: "parent_destroyed",
            error: "The parent to listen is gone"
          });
        }
        clearTimeout(this.replyWaitingDict[callingID].timeoutID);
      }
      window.removeEventListener("message", this.recieveMessageHandler);
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../cloudflow/CloudflowUtil/js/CloudflowURL.js":80,"../../../cloudflow/CloudflowUtil/js/Location.js":90,"../inspect/LogListener.js":431}],425:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* 
 * 
 *   created by guillaume on Dec 21, 2016 3:00:24 PM
 */
(function ($) {
  require("../../../cloudflow/FormRender/js/nixps-cloudflow-LayoutRenderer.js");
  var ExtendedTableTypes = require("../../../cloudflow/Table/js/ExtendedTableTypes.js");
  var CloudflowObject = require("../../../cloudflow/CloudflowUtil/js/CloudflowObject.js");
  var Context = require("../Context.js");
  var kMAXAMOUNTCOLUMNS = 12; // max amount of columns

  function calcOppositeWidthClass(pWidthClass) {
    if (typeof pWidthClass === "string" && pWidthClass.length > 0) {
      var width = pWidthClass.replace(/.*-([1-9]+)$/, "$1");
      var widthInt = parseInt(width);
      if (widthInt === kMAXAMOUNTCOLUMNS) {
        return "cf-hide";
      }
      if (typeof widthInt === "number" && widthInt > 0 && widthInt < kMAXAMOUNTCOLUMNS) {
        return "cf-col-sm-" + (kMAXAMOUNTCOLUMNS - widthInt);
      }
    }
    return "cf-col-sm-" + kMAXAMOUNTCOLUMNS;
  }
  var htmlEscape;
  if (window._ !== undefined && typeof _.escape === "function") {
    htmlEscape = _.escape;
  } else {
    var ampEscapeRegExp = new RegExp("&", "g");
    var lessEscapeRegExp = new RegExp("<", "g");
    var grtEscapeRegExp = new RegExp(">", "g");
    /**
     * @description Escape some special characters of a text. 
     * This function only change the characters <,> and & this should be enough to disable javascript injections and is fast enough 
     * @function
     * @private
     * @static
     * @param {string} pText The text that must be escaped
     * @returns {string} the escaped string
     */
    htmlEscape = function htmlEscape(pText) {
      return pText.toString().replace(ampEscapeRegExp, "&amp;").replace(lessEscapeRegExp, "&lt;").replace(grtEscapeRegExp, "&gt;");
    };
  }
  var kRenderDict = {
    "array": function array(pArray) {
      var output = "";
      var _iterator = _createForOfIteratorHelper(pArray),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          output = output + element + " ";
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      ;
      return output;
    },
    "string": function string(vl) {
      if (vl === undefined || vl === null) {
        return "";
      }
      return htmlEscape(vl);
    },
    "HTML": function HTML(vl) {
      return vl;
    },
    "number": function number(vl) {
      if (vl === undefined || vl === null) {
        return "";
      }
      if (typeof vl === "number") {
        return vl;
      }
      return htmlEscape(vl);
    },
    "image": function image(src) {
      if (typeof src !== "string" || src.length <= 0) {
        return "";
      }
      if (typeof src === "string" && src.indexOf("cloudflow://") === 0) {
        // url starts with "cloudflow://" so we get a cloudflow path ...
        src = "/portal.cgi?metadata=get_thumbnail&file=" + encodeURIComponent(src) + "&precalculated_only=true";
      }
      return $("<img>").attr("src", src).on("error", function (pEvent) {
        $(this).closest(".nixps-cloudflow-Table").Table("triggerEvent", "imageloaderror", pEvent, {});
      });
    },
    "link": function link(linkHref) {
      if (typeof linkHref === "string" && linkHref.length > 0) {
        return $("<a>").attr("href", linkHref);
      }
      return "";
    },
    "boolean": function boolean(bool) {
      if (bool === true) {
        return $("<span>").addClass("boolTrue").append($("<span>").addClass("boolIcon").html("&#10003;")).append($("<span>").addClass("boolText")._t("nixps-cloudflow-table.boolean_true"));
      } else if (bool === false) {
        return $("<span>").addClass("boolFalse").append($("<span>").addClass("boolIcon").html("&#10005;")).append($("<span>").addClass("boolText")._t("nixps-cloudflow-table.boolean_false"));
      } else {
        return "";
      }
    },
    "date": function date(_date, pColumOptions) {
      if (_date === undefined || _date === null || _date === "") {
        return "";
      }
      var valueDate = moment(_date);
      var format;
      if (pColumOptions !== undefined && typeof pColumOptions.dateFormat === "string" && pColumOptions.dateFormat.length > 0) {
        format = pColumOptions.dateFormat;
      } else {
        format = "L LT";
      }
      if (format.indexOf("LTS.SSS") >= 0 && moment.localeData().longDateFormat("LTS").match(new RegExp("a", "i"))) {
        format = format.replace("LTS", moment().localeData().longDateFormat("LTS"));
        format = format.replace(":ss A.SSS", ":ss.SSS A");
      }
      if (pColumOptions !== undefined && pColumOptions.utc === true) {
        return valueDate.utc().format(format);
      }
      return valueDate.format(format);
    },
    "dateISO": function dateISO(date, pColumOptions) {
      if (date === undefined || date === null || date === "") {
        return "";
      }
      var valueDate = moment(date);
      var format;
      if (pColumOptions !== undefined && typeof pColumOptions.dateFormat === "string" && pColumOptions.dateFormat.length > 0) {
        format = pColumOptions.dateFormat;
      } else {
        format = "L LT";
      }
      if (format.indexOf("LTS.SSS") >= 0 && moment.localeData().longDateFormat("LTS").match(new RegExp("a", "i"))) {
        format = format.replace("LTS", moment().localeData().longDateFormat("LTS"));
        format = format.replace(":ss A.SSS", ":ss.SSS A");
      }
      if (pColumOptions !== undefined && pColumOptions.utc === true) {
        return valueDate.utc().format(format);
      }
      return valueDate.format(format);
    },
    "enum": function _enum(pKey, pColumOptions) {
      var value = pColumOptions.keyValues[pKey];
      if (value === undefined) {
        return "";
      }
      return value;
    }
  };
  kRenderDict["text"] = kRenderDict["string"];
  if (Array.isArray(ExtendedTableTypes) && ExtendedTableTypes.length > 0) {
    for (var i = 0; i < ExtendedTableTypes.length; i++) {
      if (typeof ExtendedTableTypes[i].type === "string" && ExtendedTableTypes[i].type.length > 0) {
        if (typeof ExtendedTableTypes[i].renderFunction === "function") {
          kRenderDict[ExtendedTableTypes[i].type] = ExtendedTableTypes[i].renderFunction;
        } else if (typeof ExtendedTableTypes[i].renderFunction === "string" && typeof kRenderDict[ExtendedTableTypes[i].renderFunction] === "function") {
          // add alias
          kRenderDict[ExtendedTableTypes[i].type] = kRenderDict[ExtendedTableTypes[i].renderFunction];
        }
      }
    }
  }
  Object.freeze(kRenderDict);

  /**
   * @namespace nixps-pagebuilder.ObjectDetailsPanel
   * @description Panel to display an object. used in pagebuilder
   * @example $("<div>").ObjectDetailsPanel();
   * @version "1.0.0"
   */
  $.widget("nixps-pagebuilder.ObjectDetailsPanel", $.Widget, {
    widgetEventPrefix: "objectdetailspanel",
    version: "1.0.0",
    options: {
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#language
       * @description The language of the user
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#pagebuilderStyleClass
       * @description Which style class do you want to apply on the component
       * @type {String}
       * @default ""
       * @private
       */
      pagebuilderStyleClass: "",
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#pagebuilderLabelStyleClass
       * @description The pagebuilder style classes to be applied on the labels
       * @type {Sting}
       * @default ""
       */
      pagebuilderLabelStyleClass: "",
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#pagebuilderValueStyleClass
       * @description The pagebuilder style classes to be applied on the value
       * @type {Sting}
       * @default ""
       */
      pagebuilderValueStyleClass: "",
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#labelValuePosition
       * @description the position of the label to his value
       * @type {String.<Enum>}
       * @default "one_line_center"
       */
      labelValuePosition: "one_line_center",
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#labelWidthClass
       * @description The width style class
       * @type {String}
       * @default "cf-col-sm-4"
       */
      labelWidthClass: "cf-col-sm-4",
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#rowCap
       * @description The amount of pixels added between two rows
       * @type {Number}
       * @default undefined
       */
      rowCap: undefined,
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#columns
       * @description The element interfaces for each key
       * @type {Array.<Object>}
       * @default undefined
       */
      columns: undefined,
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#amountColumns
       * @description The maount of columns the component should show
       * @type {Number}
       * @default 1
       */
      amountColumns: 1,
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#context
       * @description The reference JSON to the object to draw 
       * @type {Object}
       * @default null
       */
      context: {
        "connector": "object",
        "collection": "dummy",
        "key": {}
      },
      /**
       * @name nixps-pagebuilder.ObjectDetailsPanel#created
       * @description Function runs when component is done creating
       * @type {Function}
       * @default function(){}
       */
      created: function created() {}
    },
    /**
     * @description create the component
     * @name nixps-pagebuilder.ObjectDetailsPanel#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      var _this = this;
      this._controlOptions();
      this._addClass(this.widgetFullName);
      this.object = {}; // object where we show the parameters of
      this.alive = true; // if the componet alive or not?
      this.context = null; // the context lo load the object from

      this.element.empty();
      this.container = $("<div>");
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        this.container.addClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
      }
      this._draw();
      $.when(this.context).always(function () {
        _this.options.created();
      });
    },
    /**
     * @description redraw the component
     * @function
     * @name nixps-pagebuilder.ObjectDetailsPanel#redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description draws the list according to the current state
     * @function
     * @private
     * @name nixps-pagebuilder.ObjectDetailsPanel#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      var that = this;
      this.context = Context.fromJSON(this.options.context);
      return this.context.loadDataFromCache({
        suppressRedirect: true
      }).then(function (pObject) {
        if (that.alive === false) {
          return;
        }
        that.object = pObject;

        // columns
        var columns;
        if (Array.isArray(that.options.columns) && that.options.columns.length > 0) {
          columns = that.options.columns;
        } else {
          // there are no columns, show all as default
          var flattenEntries = Object.entries(CloudflowObject.flatten(that.object));
          flattenEntries.sort(function (a, b) {
            return a[0].localeCompare(b[0]);
          });
          columns = new Array(flattenEntries.length);
          for (var i = 0; i < flattenEntries.length; i++) {
            columns[i] = {
              label: flattenEntries[i][0],
              key: flattenEntries[i][0],
              type: ["string", "number", "boolean"].includes(_typeof(flattenEntries[i][1])) ? _typeof(flattenEntries[i][1]) : "string"
            };
          }
        }
        var rootClasses = "cf-form objectdetailspanel_layout_onelinecenter";
        var rowClasses = "objectdetailspanel_row cf-newspaper-paragraph";
        if (that.options.labelValuePosition === "two_lines_start") {
          rootClasses = "cf-form objectdetailspanel_layout_twolinesstart cf-verticalform";
          rowClasses += " cf-verticalrow";
        }
        if (that.options.amountColumns >= 2 && that.options.amountColumns <= 4) {
          rootClasses += " cf-newspaper-col-" + that.options.amountColumns;
        }
        // layout
        var layoutJSON = {
          "type": "bootstrapGrid",
          "parameters": {
            "rows": [],
            "row_classes": rowClasses,
            "root_classes": rootClasses,
            "children_overflow": "visible"
          }
        };
        layoutJSON.parameters.rows = columns.map(function (pColumn, pIndex) {
          return [{
            "content": "" + pIndex,
            "width": {
              "md": kMAXAMOUNTCOLUMNS
            }
          }];
        });
        var groupClasses = "cf-form-group";
        var labelClasses = "objectdetailspanel_label " + that.options.labelWidthClass;
        var valueClasses = "objectdetailspanel_value " + calcOppositeWidthClass(that.options.labelWidthClass);
        if (typeof that.options.pagebuilderLabelStyleClass === "string" && that.options.pagebuilderLabelStyleClass.length > 0) {
          labelClasses += " cf-vertical-middle nixps_styling_class_" + that.options.pagebuilderLabelStyleClass;
          valueClasses += " cf-vertical-middle";
          groupClasses += " objectdetailspanel_group_customised";
        } else {
          labelClasses += " cf-form-label";
        }
        if (typeof that.options.pagebuilderValueStyleClass === "string" && that.options.pagebuilderValueStyleClass.length > 0) {
          valueClasses += " nixps_styling_class_" + that.options.pagebuilderValueStyleClass;
        }
        that.container.empty();
        that.container.LayoutRenderer({
          layout: layoutJSON,
          renderOptions: that.options.layoutRenderOptions
        });
        if (typeof that.options.rowCap === "number" && that.options.rowCap > 0) {
          that.container.find(".objectdetailspanel_row").css("margin-bottom", that.options.rowCap);
        }
        var itemDOM;
        for (var i = 0; i < columns.length; i++) {
          if (typeof columns[i].key === "string" && columns[i].key.length > 0) {
            if (columns[i].hide === true || columns[i].show === false) {
              continue;
            }
            itemDOM = $("<div>").addClass(groupClasses);
            var labelDOM = $("<label>").addClass(labelClasses).text(columns[i].label || columns[i].key);
            itemDOM.append(labelDOM);
            var valueDOM = $("<div>").addClass(valueClasses);
            if (kRenderDict[columns[i].type] !== undefined) {
              valueDOM.append(kRenderDict[columns[i].type](CloudflowObject.getParameter(that.object, columns[i].key), columns[i].options, that.object));
            } else {
              // use string as fallback
              console.warn("unknown type in column ", columns[i]);
              valueDOM.append(kRenderDict["string"](CloudflowObject.getParameter(that.object, columns[i].key), columns[i].options, that.object));
            }
            itemDOM.append(valueDOM);
            that.container.LayoutRenderer("addElement", itemDOM, "" + i);
          } else {
            console.error("missing key in column ", columns[i]);
          }
        }
        that.element.append(that.container);
      }, function (pError) {
        console.error(pError);
        return Promise.reject(pError);
      });
    },
    _setOptions: function _setOptions(options) {
      var that = this;
      var needRedraw = false;
      if (options.context !== undefined && _.isEqual(options.context, this.options.context) === false) {
        needRedraw = true;
        if (this.context !== null) {
          this.context.clearCache();
          this.context.stopLoadingData();
        }
      } else if (options.columns !== undefined && _.isEqual(options.columns, this.options.columns) === false) {
        needRedraw = true;
      }
      $.each(options, function (key, value) {
        that._setOption(key, value);
      });
      if (needRedraw === true) {
        this._draw();
      }
    },
    /**
     * @description sets the option
     * @function
     * @private
     * @name nixps-pagebuilder.ObjectDetailsPanel#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "pagebuilderStyleClass") {
        this.container.removeClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
        if (typeof pValue === "string" && pValue.length > 0) {
          this.container.addClass("nixps_styling_class_" + pValue);
        }
        this._superApply(arguments);
        this._controlOptions();
        return;
      }
      if (pKey === "pagebuilderLabelStyleClass") {
        if (pValue !== this.options.pagebuilderLabelStyleClass) {
          this.element.find(".objectdetailspanel_group_customised").removeClass("objectdetailspanel_group_customised");
          this.element.find(".cf-vertical-middle").removeClass("cf-vertical-middle");
          this.element.find(".objectdetailspanel_label").removeClass("nixps_styling_class_" + this.options.pagebuilderLabelStyleClass).removeClass("cf-form-label");
          if (typeof pValue === "string" && pValue.length > 0) {
            this.element.find(".objectdetailspanel_label").addClass("nixps_styling_class_" + pValue);
            this.element.find(".cf-form-group").addClass("objectdetailspanel_group_customised");
            this.element.find(".objectdetailspanel_label, .objectdetailspanel_value").addClass("cf-vertical-middle");
          } else {
            this.element.find(".objectdetailspanel_label").addClass("cf-form-label");
          }
          this._superApply(arguments);
          this._controlOptions();
        }
        return;
      }
      if (pKey === "pagebuilderValueStyleClass") {
        if (pValue !== this.options.pagebuilderValueStyleClass) {
          this.element.find(".objectdetailspanel_value").removeClass("nixps_styling_class_" + this.options.pagebuilderValueStyleClass);
          if (typeof pValue === "string" && pValue.length > 0) {
            this.element.find(".objectdetailspanel_value").addClass("nixps_styling_class_" + pValue);
          }
          this._superApply(arguments);
          this._controlOptions();
        }
        return;
      }
      if (pKey === "labelWidthClass") {
        if (pValue !== this.options.labelWidthClass) {
          var oldValueWidthClass = calcOppositeWidthClass(this.options.labelWidthClass);
          this.element.find(".objectdetailspanel_label").removeClass(this.options.labelWidthClass).addClass(pValue);
          this.element.find(".objectdetailspanel_value").removeClass(oldValueWidthClass).addClass(calcOppositeWidthClass(pValue));
          this._superApply(arguments);
          this._controlOptions();
        }
        return;
      }
      if (pKey === "labelValuePosition") {
        if (pValue !== this.options.labelValuePosition) {
          // clear
          this.element.find(".objectdetailspanel_row").removeClass("cf-verticalrow");
          this.element.find(".cf-form").removeClass("cf-verticalform objectdetailspanel_layout_onelinecenter objectdetailspanel_layout_twolinesstart");
          // re-add
          if (pValue === "two_lines_start") {
            this.element.find(".objectdetailspanel_row").addClass("cf-verticalrow");
            this.element.find(".cf-form").addClass("cf-verticalform objectdetailspanel_layout_twolinesstart");
          } else {
            this.element.find(".cf-form").addClass("objectdetailspanel_layout_onelinecenter");
          }
          this._superApply(arguments);
          this._controlOptions();
        }
        return;
      }
      if (pKey === "amountColumns") {
        if (pValue !== this.options.amountColumns) {
          this.element.find(".cf-form").removeClass("cf-newspaper-col-" + this.options.amountColumns);
          this._superApply(arguments);
          this._controlOptions();
          if (pValue >= 2 && pValue <= 4) {
            this.element.find(".cf-form").addClass("cf-newspaper-col-" + pValue);
          }
        }
        return;
      }
      if (pKey === "rowCap") {
        if (pValue !== this.options.rowCap) {
          if (typeof pValue === "number" && pValue > 0) {
            this.container.find(".objectdetailspanel_row").css("margin-bottom", pValue);
          } else {
            // clear value
            this.container.find(".objectdetailspanel_row").css("margin-bottom", "");
          }
          this._superApply(arguments);
          this._controlOptions();
        }
        return;
      }
      this._superApply(arguments);
      this._controlOptions();
    },
    /**
     * @name nixps-pagebuilder.ObjectDetailsPanel#isValid
     * @description Validate the value
     * @function
     * @returns {Boolean} returns true if valid or a string containing the error message
     */
    isValid: function isValid() {
      return true;
    },
    /**
     * @name nixps-pagebuilder.ObjectDetailsPanel#setValue
     * @description Set the input to a specific value
     * @function
     * @param {Array} pValue
     * @returns {undefined}
     */
    setValue: function setValue(pValue) {},
    /**
     * @name nixps-pagebuilder.ObjectDetailsPanel#getValue
     * @description Get the value of the input
     * @function
     * @returns {Array}
     */
    getValue: function getValue() {
      return structuredClone(this.object);
    },
    reset: function reset() {
      this.object = {};
    },
    /**
     * @description function runs to update the panel
     * @function
     * @name nixps-pagebuilder.ObjectDetailsPanel#update
     * @param {Object} pContent 
     * @returns {Object} object
     */
    update: function update(pContent) {
      var newContent = {};
      if ($.isPlainObject(pContent)) {
        newContent = structuredClone(pContent);
      }
      if (this.context !== null) {
        this.context.stopLoadingData();
        this.context.clearCache();
      }
      this.options.context = {
        connector: "object",
        collection: "dummy",
        key: newContent
      };
      return $.when(this._draw()).then(function () {
        return {};
      });
    },
    /**
     * @description control the input options and throw a error if needed
     * @name nixps-pagebuilder.ObjectDetailsPanel#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.language !== "string" && this.options.language.length <= 0) {
        throw new Error("input option language must be a not mepty string");
      }
      if (typeof this.options.amountColumns !== "number" && this.options.amountColumns < 1) {
        throw new Error("input option amountColumns must be a positief number");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      if (this.context !== null) {
        this.context.stopLoadingData();
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../../cloudflow/CloudflowUtil/js/CloudflowObject.js":79,"../../../cloudflow/FormRender/js/nixps-cloudflow-LayoutRenderer.js":170,"../../../cloudflow/Table/js/ExtendedTableTypes.js":210,"../Context.js":413}],426:[function(require,module,exports){
"use strict";

/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Jan 4, 2018 9:21:57 AM
 */
(function ($) {
  var variableRegExp = new RegExp("[$]{([^}]+)}", "g");

  /**
   * @namespace nixps-pagebuilder.TextPanel
   * @description draw a text panel
   * @private
   * @example $('<div>').TextPanel({});
   */
  $.widget("nixps-pagebuilder.TextPanel", $.Widget, {
    version: "1.0.0",
    defaultElement: "<div>",
    widgetEventPrefix: "textpanel",
    options: {
      /**
       * @name nixps-pagebuilder.TextPanel#text
       * @description The text to be show
       * @type {mixed}
       * @default ""
       */
      text: "",
      /**
       * @name nixps-pagebuilder.TextPanel#padding
       * @description the padding on the panel
       * @type {String}
       * @default "5px 10px"
       */
      padding: "5px 10px",
      /**
       * @name nixps-cloudflow.TextPanel#pagebuilderStyleClass
       * @description Which style class do you want to apply on the component
       * @type {String}
       * @default ""
       * @private
       */
      pagebuilderStyleClass: "",
      /**
       * @name nixps-cloudflow.TextPanel#created
       * @description Callback when component has been created
       * @type {Function}
       * @private
       * @description function(){}
       */
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps-pagebuilder.TextPanel#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._controlOptions();
      this.element.addClass(this.widgetFullName).addClass("cf-unreset");
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        this.element.addClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
      }
      this.text = "";
      this._setText();
      this._draw();
      this._setStyle();
      this.options.created();
    },
    /**
     * @description Redraw the component
     * @function
     * @name nixps-pagebuilder.TextPanel#redraw
     */
    redraw: function redraw() {
      this.text = "";
      this._setText();
      this._draw();
      this._setStyle();
    },
    /**
     * @description Draws the dialog according to the current state
     * @function
     * @private
     * @name nixps-pagebuilder.TextPanel#_draw
     * @return {undefined} 
     */
    _draw: function _draw() {
      this._translateToGoodFormat();
      this.element.empty().append(this.text);
    },
    /**
     * @description Detect and remove all bad code, prevent hackers
     * @function
     * @private
     * @return {undefined}
     */
    _translateToGoodFormat: function _translateToGoodFormat() {
      var contentToTest = this.text;
      if (contentToTest.length === 0) {
        return;
      }
      if (contentToTest[0] !== "<") {
        contentToTest = "<div>" + contentToTest + "</div>"; // prevent jQuery creator $() to crash
      }

      if ($(contentToTest).filter("script, iframe, noscipt, style").length > 0 || $(contentToTest).find("script, iframe, noscipt, style").length > 0 || $(contentToTest).filter(function (index, elem) {
        var found = false;
        if (this.attributes !== undefined) {
          $.each(this.attributes, function () {
            // this.attributes is not a plain object, but an array
            // of attribute nodes, which contain both the name and value
            if (this.name.indexOf("on") === 0) {
              found = true;
              return false;
            }
          });
        }
        return found;
      }).length > 0 || $(contentToTest).find("*").filter(function (index, elem) {
        var found = false;
        if (this.attributes !== undefined) {
          $.each(this.attributes, function () {
            // this.attributes is not a plain object, but an array
            // of attribute nodes, which contain both the name and value
            if (this.name.indexOf("on") === 0) {
              found = true;
              return false;
            }
          });
        }
        return found;
      }).length > 0) {
        console.error("an iframe or a script found in the content, so we removed everything");
        this.options.text = "";
        this.text = "";
      }
    },
    _setText: function _setText() {
      if (this.options.text !== undefined && typeof this.options.text.text === "string") {
        this.text = this.options.text.text;
        if ($.isPlainObject(this.options.text.variableDict) && $.isEmptyObject(this.options.text.variableDict) === false) {
          var that = this;
          this.text = this.text.replace(variableRegExp, function (pVar, pName) {
            return that.options.text.variableDict[pName];
          });
        }
      } else if (typeof this.options.text === "string") {
        this.text = this.options.text;
      } else {
        this.text = "";
      }
    },
    /**
     * @description set the general style of the panel
     * @function
     * @private
     * @return {undefined}
     */
    _setStyle: function _setStyle() {
      this.element.css({
        "padding": this.options.padding,
        "box-sizing": "border-box"
      });
    },
    _setOptions: function _setOptions(options) {
      if (options.pagebuilderStyleClass !== undefined) {
        this.element.removeClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
      }
      this._superApply(arguments);
      if (options.text !== undefined) {
        this._setText();
        this._draw();
      }
      if (options.pagebuilderStyleClass !== undefined) {
        if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
          this.element.addClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
        }
      }
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-pagebuilder.TextPanel#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      this._controlOptions();
      if (pKey === "padding") {
        this._setStyle();
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-pagebuilder.TextPanel#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof window._ !== "function") {
        throw new Error("TextPanel: please include underscore js plugin");
      }
      if (typeof this.options.text !== "string" && $.isPlainObject(this.options.text) === false) {
        throw new Error("TextPanel: input option text must be a string");
      }
      if (typeof this.options.pagebuilderStyleClass !== "string") {
        throw new Error("TextPanel: input option pagebuilderStyleClass must be a string");
      }
    },
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("cf-unreset");
      if (typeof this.options.pagebuilderStyleClass === "string" && this.options.pagebuilderStyleClass.length > 0) {
        this.element.removeClass("nixps_styling_class_" + this.options.pagebuilderStyleClass);
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{}],427:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
if (window.self !== window.top && typeof window.addEventListener === "function") {
  // for puppeteer linux debugging
  window.addEventListener("unhandledrejection", function (e) {
    if (e && (e.reason === "frame_not_running" || e.reason === "Frame server does not match")) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false; // ignore issue
    }

    if (e && e.reason && e.reason.error_code === "frame_not_running") {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false; // ignore issue
    }

    console.error("unhandledrejection");
    if (typeof e.reason === "string") {
      console.error(e.reason);
    } else if (e.reason && e.reason.message) {
      console.error(JSON.stringify(e.reason.message));
    } else if (_typeof(e.reason) === "object") {
      console.error(JSON.stringify(e.reason));
    }
    return true;
  });
}
require("./nebulaframework.js");
require("../inspect/LogListener.js");
require("../AddMissingFiles.js");

},{"../AddMissingFiles.js":410,"../inspect/LogListener.js":431,"./nebulaframework.js":428}],428:[function(require,module,exports){
"use strict";

require("../../../polyfill/polyfill.js");
// generic required
require("../../../cloudflow/CheckExternals/js/CheckExternals.js");
require("../../../cloudflow/CloudflowInit/js/redirectDefaults.js");
require("../../../../Hybrid/Frame/Web/js/Main.js");
require("../../../cloudflow/CloudflowInit/js/httpError.js");
require("../../../cloudflow/CloudflowInit/js/Init.js");
require("../../../cloudflow/Consent/js/nixps-cloudflow-ConsentDialog.js");
require("../../../common/js/nixps-common-MomentAliases.js");
require("../../../common/FreezeOverlay/js/nixps-FreezeOverlay.js");
require("../../../common/Dialog/js/nixps-Dialog.js");

// individual components
require("../../../cloudflow/TopBar/js/nixps-cloudflow-TopBar.js");
require("../../../cloudflow/TopBar/js/nixps-cloudflow-SideBar.js");
require("../../../cloudflow/ListPanel/js/nixps-cloudflow-PreConfiguredListPanel.js");
require("../../../cloudflow/FormElements/js/WorkflowFormComponents.js");
require("../../../common/Link/js/nixps-Link.js");
require("../../../common/Notification/js/Notificate.js");
require("../../../common/PanelSeparator/js/nixps-PanelSeparator.js");
require("../../../common/MobileSlidePanel/js/nixps-MobileSlidePanel.js");
require("../../../cloudflow/Table/js/nixps-cloudflow-PreConfiguredTable.js");
require("../../../cloudflow/ManageProjects/js/nixps-cloudflow-ManageProjects_new.js");
require("../../../cloudflow/DetailsPanel/js/nixps-cloudflow-DetailsPanel.js");
require("../../../cloudflow/DetailsPanel/js/nixps-cloudflow-FormDetailsPanel.js");
require("../../../cloudflow/CloudflowTabs/js/nixps-cloudflow-CloudflowTabs.js");
require("../../../kiosk/js/nixps-kiosk-CreateWorkable.js");
require("../../../cloudflow/Upload/js/nixps-cloudflow-Upload.js");
require("../../../common/PowerBI/js/nixps-EmbedPowerBI.js");
require("../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js");
require("../../../common/Button/js/nixps-cloudflow-CloudflowButtonGroup.js");
require("../../../common/Video/js/nixps-WatchYouTube.js");
require("../../../common/Video/js/nixps-WatchVideo.js");
require("../../../common/Duration/js/Duration.js");
require("../../../common/Twitter/js/nixps-TwitterTimeLine.js");
require("../../../cloudflow/ApprovalView/js/nixps-asset-MyApprovals.js");
require("../../../cloudflow/CloudflowChart/js/nixps-cloudflow-CloudflowBucketChart.js");
require("../../../cloudflow/CloudflowChart/js/nixps-cloudflow-CloudflowChart.js");
require("../../../cloudflow/CloudflowImageSlider/js/nixps-cloudflow-CloudflowImageSlider.js");
require("../../../cloudflow/ManageProjects/js/nixps-cloudflow-ProjectTimeline.js");
require("../../../cloudflow/CloudflowProgressBar/js/nixps-cloudflow-CloudflowProgressBar.js");
require("../../../cloudflow/ProofscopeView/js/nixps-cloudflow-ProofscopeEmbed.js");
require("../../../cloudflow/StatusBar/js/nixps-cloudflow-StatusBar.js");
require("../../../nebulaportal/js/login/nixps-cloudflow-CustomLogin.js");
require("../../../cloudflow/CloudflowCalendar/js/nixps-cloudflow-CloudflowCalendar.js");
require("../../../JODANebula/Framework/Component/Project/js/nixps-cloudflow-ProjectFormAssets.js");
require("../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponent.js");
require("../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponentContainer.js");
require("../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponentDialog.js");
require("../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponentDynamicList.js");
require("../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponentPopover.js");
require("../../../pagebuilder/js/components/nixps-pagebuilder-IframeComponent.js");
require("../../../pagebuilder/js/components/nixps-pagebuilder-ObjectDetailsPanel.js");
require("../../../pagebuilder/js/components/nixps-pagebuilder-TextPanel.js");
require("../../../common/RichEditor/js/nixps-RichEditor2.js");
require("../../../common/Spinner/js/nixps-DotSpinner.js");
require("../../../pagebuilder/js/actions/ActionsImmunity.js");

// require("../../../pagebuilder/js/components/my-textpanel.js");

// add global variable, they will be used in the global script
if (window.nixps === undefined) {
  window.nixps = {};
}
if (nixps.cloudflow === undefined) {
  nixps.cloudflow = {};
}
nixps.cloudflow.ExpressionToJS = require("../../../pagebuilder/js/ExpressionToJS.js");
nixps.cloudflow.WhitepaperConnection = require("../../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js");
nixps.cloudflow.TouchEventGenerator = require("../../../common/Touch/js/TouchEventGenerator.js");

// <deprecated>
require("../../../cloudflow/ActivityBar/js/nixps-cloudflow-ActivityBar.js");
require("../../../cloudflow/CloudflowBar/js/nixps-cloudflow-CloudflowBar.js");
require("../../../cloudflow/TopNavigation/js/nixps-cloudflow-TopNavigation.js");
// </deprecated>

},{"../../../../Hybrid/Frame/Web/js/Main.js":4,"../../../JODANebula/Framework/Component/Project/js/nixps-cloudflow-ProjectFormAssets.js":15,"../../../cloudflow/ActivityBar/js/nixps-cloudflow-ActivityBar.js":50,"../../../cloudflow/ApprovalView/js/nixps-asset-MyApprovals.js":51,"../../../cloudflow/CheckExternals/js/CheckExternals.js":54,"../../../cloudflow/CloudflowBar/js/nixps-cloudflow-CloudflowBar.js":55,"../../../cloudflow/CloudflowCalendar/js/nixps-cloudflow-CloudflowCalendar.js":58,"../../../cloudflow/CloudflowChart/js/nixps-cloudflow-CloudflowBucketChart.js":59,"../../../cloudflow/CloudflowChart/js/nixps-cloudflow-CloudflowChart.js":60,"../../../cloudflow/CloudflowImageSlider/js/nixps-cloudflow-CloudflowImageSlider.js":61,"../../../cloudflow/CloudflowInit/js/Init.js":62,"../../../cloudflow/CloudflowInit/js/httpError.js":65,"../../../cloudflow/CloudflowInit/js/redirectDefaults.js":68,"../../../cloudflow/CloudflowProgressBar/js/nixps-cloudflow-CloudflowProgressBar.js":70,"../../../cloudflow/CloudflowTabs/js/nixps-cloudflow-CloudflowTabs.js":76,"../../../cloudflow/CloudflowUtil/js/WhitepaperConnection.js":93,"../../../cloudflow/Consent/js/nixps-cloudflow-ConsentDialog.js":97,"../../../cloudflow/DetailsPanel/js/nixps-cloudflow-DetailsPanel.js":103,"../../../cloudflow/DetailsPanel/js/nixps-cloudflow-FormDetailsPanel.js":104,"../../../cloudflow/FormElements/js/WorkflowFormComponents.js":137,"../../../cloudflow/ListPanel/js/nixps-cloudflow-PreConfiguredListPanel.js":180,"../../../cloudflow/ManageProjects/js/nixps-cloudflow-ManageProjects_new.js":182,"../../../cloudflow/ManageProjects/js/nixps-cloudflow-ProjectTimeline.js":184,"../../../cloudflow/ProofscopeView/js/nixps-cloudflow-ProofscopeEmbed.js":203,"../../../cloudflow/StatusBar/js/nixps-cloudflow-StatusBar.js":208,"../../../cloudflow/Table/js/nixps-cloudflow-PreConfiguredTable.js":217,"../../../cloudflow/TopBar/js/nixps-cloudflow-SideBar.js":229,"../../../cloudflow/TopBar/js/nixps-cloudflow-TopBar.js":230,"../../../cloudflow/TopNavigation/js/nixps-cloudflow-TopNavigation.js":231,"../../../cloudflow/Upload/js/nixps-cloudflow-Upload.js":267,"../../../common/Button/js/nixps-cloudflow-CloudflowButtonGroup.js":281,"../../../common/Button/js/nixps-pagebuilder-CloudflowButton.js":282,"../../../common/Dialog/js/nixps-Dialog.js":287,"../../../common/Duration/js/Duration.js":289,"../../../common/FreezeOverlay/js/nixps-FreezeOverlay.js":292,"../../../common/Link/js/nixps-Link.js":295,"../../../common/MobileSlidePanel/js/nixps-MobileSlidePanel.js":296,"../../../common/Notification/js/Notificate.js":298,"../../../common/PanelSeparator/js/nixps-PanelSeparator.js":300,"../../../common/PowerBI/js/nixps-EmbedPowerBI.js":302,"../../../common/RichEditor/js/nixps-RichEditor2.js":315,"../../../common/Spinner/js/nixps-DotSpinner.js":319,"../../../common/Touch/js/TouchEventGenerator.js":381,"../../../common/Twitter/js/nixps-TwitterTimeLine.js":384,"../../../common/Video/js/nixps-WatchVideo.js":385,"../../../common/Video/js/nixps-WatchYouTube.js":386,"../../../common/js/nixps-common-MomentAliases.js":391,"../../../kiosk/js/nixps-kiosk-CreateWorkable.js":396,"../../../nebulaportal/js/login/nixps-cloudflow-CustomLogin.js":406,"../../../pagebuilder/js/ExpressionToJS.js":415,"../../../pagebuilder/js/actions/ActionsImmunity.js":417,"../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponent.js":419,"../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponentContainer.js":420,"../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponentDialog.js":421,"../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponentDynamicList.js":422,"../../../pagebuilder/js/components/nixps-pagebuilder-CustomPageComponentPopover.js":423,"../../../pagebuilder/js/components/nixps-pagebuilder-IframeComponent.js":424,"../../../pagebuilder/js/components/nixps-pagebuilder-ObjectDetailsPanel.js":425,"../../../pagebuilder/js/components/nixps-pagebuilder-TextPanel.js":426,"../../../polyfill/polyfill.js":433}],429:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var InspectDebug = require("./InspectDebug.js");
var Trigger = require("../actions/Trigger.js");
var QueryApplier = require("../../../cloudflow/CloudflowUtil/js/QueryApplier.js");
var Layout = require("../../../cloudflow/UIProfiles/js/Layout.js");

/**
 * @constructor CloudflowPageEvent
 * @description Represents and contains data of a (pagebuilder) user event, used for cloudflow debugging and cloudflow inspection
 * @param {Object} options 
 */
function CloudflowPageEvent(options) {
  this.setEventType(options.event_type);
  this.setSessionID(options.session_id);
  this.setUUID(options.uuid);
  this.setBirth(options.birth);
  this.setBrowserURL(options.browser_url);
  this.setPageURL(options.page_url);
  this.setDetailsData(options.details_data);
  this.setComponentName(options.component_name);
  this.setComponentCSSSelector(options.component_css_selector);
  this.setDebugData(options.debug);
  this.setEventName(options.event_name);
  this.setEventNameOptions(options.event_name_options);
  this._calcEventName();
}

/**
 * @name CloudflowPageEvent.fromJSON
 * @description create a CloudflowPageEvent from a JSON object
 * @param {JSON} pJSON 
 * @returns CloudflowPageEvent
 */
CloudflowPageEvent.fromJSON = function (pJSON) {
  return new CloudflowPageEvent(pJSON);
};
CloudflowPageEvent.prototype = {
  constructor: CloudflowPageEvent,
  setEventType: function setEventType(pEventType) {
    if (typeof pEventType !== "string" || pEventType.length <= 0) {
      throw new Error("pEventType must be a not empty string");
    }
    this.event_type = pEventType;
  },
  /**
   * @description returns the type of the event, this is an enum find in CloudflowPageEventTypes
   * @function
   * @name CloudflowPageEvent#getEventType
   * @returns {String} the event type
   */
  getEventType: function getEventType() {
    return this.event_type;
  },
  getEventTypeIcon: function getEventTypeIcon() {
    if (kEventTypes[this.getEventType()] === undefined) {
      return "";
    }
    return kEventTypes[this.getEventType()].icon;
  },
  getEventTypeLabel: function getEventTypeLabel() {
    if (kEventTypes[this.getEventType()] === undefined) {
      return this.getEventType();
    }
    return $.i18n._(kEventTypes[this.getEventType()].label);
  },
  setSessionID: function setSessionID(pSessionID) {
    if (pSessionID === undefined) {
      this.session_id = kActiveSessionID;
    } else if (typeof pSessionID === "string" && pSessionID.length > 0) {
      this.session_id = pSessionID;
    } else {
      this.session_id = null;
    }
  },
  getSessionID: function getSessionID() {
    return this.session_id;
  },
  hasActiveSession: function hasActiveSession() {
    return kActiveSessionID !== null && this.session_id === kActiveSessionID;
  },
  setUUID: function setUUID(pUUID) {
    if (typeof pUUID === "string" && pUUID.length > 0) {
      this.uuid = pUUID;
    } else {
      this.uuid = Layout.generateGUID();
    }
  },
  getUUID: function getUUID() {
    return this.uuid;
  },
  setBirth: function setBirth(pBirth) {
    if (pBirth === undefined) {
      this.birth = new Date().toISOString();
    } else if (typeof pBirth === "string" && pBirth.length > 0) {
      this.birth = pBirth;
    } else {
      throw new Error("setBirth: invalid birth");
    }
  },
  getBirth: function getBirth() {
    return this.birth;
  },
  setBrowserURL: function setBrowserURL(pBrowserURL) {
    if (pBrowserURL === undefined) {
      this.browser_url = window.location.href;
    } else if (typeof pBrowserURL === "string" && pBrowserURL.length > 0) {
      this.browser_url = pBrowserURL;
    } else {
      throw new Error("setBrowserURL: invalid browser url");
    }
  },
  getBrowserURL: function getBrowserURL() {
    return this.browser_url;
  },
  getBrowserCloudflowURL: function getBrowserCloudflowURL() {
    if (typeof this.browser_url === "string" && this.browser_url.length > 0) {
      var partURLIndex = this.browser_url.indexOf("/portal.cgi/");
      if (partURLIndex >= 0) {
        return "cloudflow://" + this.browser_url.substring(partURLIndex + 12);
      }
    }
    return null;
  },
  hasHappendHere: function hasHappendHere(pURL) {
    if (pURL === undefined) {
      return this.browser_url === window.location.href;
    } else if (typeof pURL === "string" && pURL.length > 0) {
      if (pURL.indexOf("cloudflow://") === 0) {
        pURL = "/portal.cgi/" + pURL.substring(12);
      }
      var parameterPath = new URI(pURL).path();
      var browserPath = new URI(this.browser_url).path();
      return browserPath === parameterPath;
    } else {
      throw new Error("hasHappendHere: invalid parameter type");
    }
  },
  /**
   * @description Check if the event has a url
   * @function
   * @name CloudflowLogEvent#hasPageURL
   * @returns {Boolean} true if the page event has a page url
   */
  hasPageURL: function hasPageURL() {
    return typeof this.page_url === "string" && this.page_url.length > 0;
  },
  setPageURL: function setPageURL(pPageURL) {
    if (typeof pPageURL === "string" && pPageURL.length > 0) {
      this.page_url = pPageURL;
    } else {
      this.page_url = null;
    }
  },
  getPageURL: function getPageURL() {
    return this.page_url;
  },
  setDetailsData: function setDetailsData(pDetailsData) {
    if (pDetailsData && _typeof(pDetailsData) === "object" && $.isPlainObject(pDetailsData)) {
      // deep copy
      this.details_data = structuredClone(pDetailsData);
    } else {
      // just save like it comes in
      this.details_data = pDetailsData;
    }
  },
  /**
   * @description Get the details data linked by this specific event
   * @function
   * @name CloudflowPageEvent#getDetailsData
   * @returns {Object} data linked to the event
   */
  getDetailsData: function getDetailsData() {
    return this.details_data;
  },
  hasLinkedComponent: function hasLinkedComponent() {
    return typeof this.component_name === "string" && this.component_name.length > 0;
  },
  setComponentName: function setComponentName(pComponentName) {
    if (typeof pComponentName === "string" && pComponentName.length > 0) {
      this.component_name = pComponentName;
    } else {
      this.component_name = null;
    }
  },
  getComponentName: function getComponentName() {
    return this.component_name;
  },
  getTranslatedComponentName: function getTranslatedComponentName() {
    if (this.hasLinkedComponent()) {
      var shortComponentName;
      if (this.getComponentName().indexOf("nixps-") === 0) {
        shortComponentName = this.getComponentName().substring(this.getComponentName().lastIndexOf("-") + 1);
      } else {
        shortComponentName = this.getComponentName();
      }
      var translationKey = "nixps-cloudflow-pagebuilder.title_component_" + shortComponentName;
      var translatedName = $.i18n._(translationKey);
      if (translatedName === translationKey) {
        // translation not know, 
        // try actions
        if (shortComponentName.indexOf("CustomPageComponent") === 0 && shortComponentName.length > 19) {
          // get name after CustomPageComponent and make lower case,
          // try to retrieve action public name
          shortComponentName = shortComponentName.substring(19);
          translationKey = "nixps-cloudflow-pagebuilder.actionfunctiontype_" + shortComponentName.toLowerCase();
          translatedName = $.i18n._(translationKey);
          if (translatedName === translationKey) {
            // still not known
            // use default name after
            translatedName = shortComponentName;
          }
          return translatedName;
        }
        // the name is not translated, show the name as fallback
        translatedName = shortComponentName;
      }
      return translatedName;
    }
    return "";
  },
  hasComponentCSSSelector: function hasComponentCSSSelector() {
    return typeof this.component_css_selector === "string" && this.component_css_selector.length > 0;
  },
  setComponentCSSSelector: function setComponentCSSSelector(pComponentCSSSelector) {
    if (typeof pComponentCSSSelector === "string" && pComponentCSSSelector.length > 0) {
      this.component_css_selector = pComponentCSSSelector.trim();
    } else {
      this.component_css_selector = null;
    }
  },
  getComponentCSSSelector: function getComponentCSSSelector() {
    return this.component_css_selector;
  },
  hasDebugData: function hasDebugData() {
    return this.debug !== null;
  },
  setDebugData: function setDebugData(pData) {
    if (pData instanceof InspectDebug) {
      this.debug = pData;
    } else if (pData && _typeof(pData) === "object" && !Array.isArray(pData) && Object.keys(pData).length > 0) {
      this.debug = InspectDebug.fromJSON(pData);
    } else {
      this.debug = null;
    }
  },
  getDebugData: function getDebugData() {
    return this.debug;
  },
  hasEventName: function hasEventName() {
    return typeof this.event_name === "string" && this.event_name.length > 0;
  },
  setEventName: function setEventName(pEventName) {
    if (typeof pEventName === "string" && pEventName.length > 0) {
      this.event_name = pEventName;
    } else {
      this.event_name = null;
    }
  },
  getEventName: function getEventName() {
    return this.event_name;
  },
  setEventNameOptions: function setEventNameOptions(pEventNameOptions) {
    if (pEventNameOptions instanceof window.jQuery) {
      // some mistake in configuration, do not fail
      console.warn("wrong configuration of pEventNameOptions");
      this.event_name_options = null;
    } else if (pEventNameOptions && _typeof(pEventNameOptions) === "object" && !Array.isArray(pEventNameOptions)) {
      // filter out all functions
      this.event_name_options = Object.assign({}, JSON.parse(JSON.stringify(pEventNameOptions)));
    } else {
      this.event_name_options = null;
    }
  },
  getEventNameOptions: function getEventNameOptions() {
    return this.event_name_options;
  },
  _calcEventName: function _calcEventName() {
    var that = this;
    if (window.api_mock !== undefined && window.api_mock.component !== undefined) {
      if (this.hasEventName() === false && this.hasLinkedComponent() && this.event_name_options !== null) {
        api_mock.component.list_with_options_validater(new QueryApplier(["name", "equal to", this.getComponentName()]), [], [], {}, function (pResults) {
          that.event_name = null;
          var elementComponent = pResults.results[0];
          var triggerData = undefined;
          if (typeof elementComponent.change_triggers === "function") {
            triggerData = elementComponent.change_triggers(structuredClone(elementComponent.triggers), that.event_name_options.options).triggers.find(function (trigger) {
              return trigger.id === that.event_name_options.event_name;
            });
          }
          if (triggerData !== undefined) {
            that.event_name = Trigger.fromJSON(triggerData).getName();
          } else {
            var searchTrigger = elementComponent.triggers.find(function (trigger) {
              return trigger.id === that.event_name_options.event_name;
            });
            if (searchTrigger !== undefined && typeof searchTrigger.id === "string") {
              that.event_name = Trigger.fromJSON(searchTrigger).getName();
            }
          }
        });
      }
    }
  },
  toString: function toString() {
    return this.birth + " " + this.event_type + " " + JSON.stringify(this.details_data);
  },
  clone: function clone() {
    return CloudflowPageEvent.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = {
      event_type: this.event_type,
      details_data: this.details_data,
      session_id: this.session_id,
      birth: this.birth,
      uuid: this.uuid,
      browser_url: this.browser_url
    };
    if (this.page_url !== null) {
      outputJSON.page_url = this.page_url;
    }
    if (this.hasDebugData()) {
      outputJSON.debug = this.getDebugData().toJSON();
    }
    if (this.hasLinkedComponent()) {
      outputJSON.component_name = this.component_name;
    }
    if (typeof this.component_css_selector === "string" && this.component_css_selector.length > 0) {
      outputJSON.component_css_selector = this.component_css_selector;
    }
    if (this.hasEventName()) {
      outputJSON.event_name = this.event_name;
    }
    if (this.event_name_options !== null) {
      outputJSON.event_name_options = this.event_name_options;
    }
    return outputJSON;
  }
};
var kActiveSessionID = null;
/**
 * @name CloudflowPageEvent.setGlobalSessionID
 * @function
 * @description Init a session id for all events
 * @param {Mixed} pSessionID 
 * @returns {undefined}
 */
CloudflowPageEvent.setGlobalSessionID = function (pSessionID) {
  if (typeof pSessionID === "number") {
    kActiveSessionID = "" + pSessionID;
  } else {
    kActiveSessionID = pSessionID;
  }
};
/**
 * @name CloudflowPageEvent.getCurrentGlobalSessionID
 * @description Get the current active session id
 * @function
 * @returns {String} The current active session id  
 */
CloudflowPageEvent.getCurrentGlobalSessionID = function () {
  return kActiveSessionID;
};
var kEventTypes = Object.freeze({
  "error": {
    "icon": "cf-icon cf-icon-x-circle",
    "label": "nixps-cloudflow-inspect.eventtype_error"
  },
  "open_page": {
    "icon": "cf-icon cf-icon-html-file",
    "label": "nixps-cloudflow-inspect.eventtype_open_page"
  },
  "start_action": {
    "icon": "cf-icon cf-icon-maprun",
    "label": "nixps-cloudflow-inspect.eventtype_start_action"
  },
  "sub_page_action": {
    "icon": "cf-icon cf-icon-maprun",
    "label": "nixps-cloudflow-inspect.eventtype_sub_start_action"
  }
});
CloudflowPageEvent.getAllEventTypes = function () {
  return kEventTypes;
};
module.exports = CloudflowPageEvent;

},{"../../../cloudflow/CloudflowUtil/js/QueryApplier.js":91,"../../../cloudflow/UIProfiles/js/Layout.js":255,"../actions/Trigger.js":418,"./InspectDebug.js":430}],430:[function(require,module,exports){
"use strict";

var InspectDebug = function InspectDebug(pOptions) {
  this.setType(pOptions.debug_type);
  this.setData(pOptions);
};
InspectDebug.fromJSON = function (pJSON) {
  return new InspectDebug(pJSON);
};

/**
 * @enum {String} the different types of debug data
 * @readOnly
 */
InspectDebug.types = Object.freeze({
  /** workflow */
  "WORKFLOW": "workflow"
});
InspectDebug.prototype = {
  constructor: InspectDebug,
  setType: function setType(pType) {
    if (InspectDebug.types.WORKFLOW !== pType) {
      console.error("setType: Unvalid debug type " + pType);
      this.debug_type = InspectDebug.types.WORKFLOW;
    } else {
      this.debug_type = pType;
    }
  },
  getType: function getType() {
    return this.debug_type;
  },
  setData: function setData(pData) {
    if (this.debug_type === InspectDebug.types.WORKFLOW) {
      this.whitepaperName = pData.whitepaperName;
      this.whitepaperInputName = pData.whitepaperInputName;
      this.jacketID = pData.jacketID;
      this.workableID = pData.workableID;
    }
  },
  getData: function getData() {
    if (this.debug_type === InspectDebug.types.WORKFLOW) {
      return {
        whitepaperName: this.whitepaperName,
        whitepaperInputName: this.whitepaperInputName,
        jacketID: this.jacketID,
        workableID: this.workableID
      };
    }
  },
  clone: function clone() {
    return InspectDebug.fromJSON(this.toJSON());
  },
  toJSON: function toJSON() {
    var outputJSON = this.getData();
    outputJSON.debug_type = this.debug_type;
    return outputJSON;
  }
};
module.exports = InspectDebug;

},{}],431:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var CloudflowPageEvent = require("./CloudflowPageEvent.js");
var IndexStorage = require("../../../common/BrowserStorage/js/IndexedStorage.js");
var _windowListeren = undefined;
/**
 * @constructor LogListener
 * @description An function to log, to help debugging web pages
 * @param {Object} pOptions 
 */
function LogListener(pOptions) {
  this._activatingDef = undefined;
  this._active = false;
  this._logWaitingToSave = [];
  this._logSavingDefStatus = "resolved";
  this._logSavingDef = Promise.resolve();
  // variables
  this.logs = [];
}
LogListener.prototype = {
  constructor: LogListener,
  /**
   * @description add a log, if active the log is saved, otherwise the log is not saved
   * @function
   * @param {CloudflowPageEvent|Object} the CloudflowPageEvent data to be loged
   * @name LogListener#addLog
   * @returns undefined
   */
  addLog: function addLog() {},
  /**
   * @description is the logger active logging or does he ignore everything?
   * @function
   * @name LogListener#isActive
   * @returns {Boolean}
   */
  isActive: function isActive() {
    return this._active;
  },
  isActivatingDone: function isActivatingDone() {
    return this._activatingDef !== undefined && this._logSavingDefStatus === "resolved";
  },
  waitUnitActive: function waitUnitActive() {
    if (this._activatingDef === undefined) {
      return Promise.reject({
        error_code: "never_activated",
        error: "The system was never active"
      });
    } else {
      return this._activatingDef;
    }
  },
  /**
   * @description active the logging, after the call the logs are kept in memory
   * @function
   * @name LogListener#activate
   * @returns undefined
   */
  activate: function activate(pSessionID, pDBName) {
    var that = this;
    if (this.isActive()) {
      if (pSessionID !== undefined) {
        CloudflowPageEvent.setGlobalSessionID(pSessionID);
      }
      console.warn("LogListener: LogListener is already activated");
      return Promise.resolve();
    }
    CloudflowPageEvent.setGlobalSessionID(pSessionID);
    this._activatingDef = this._initLocalStorage(pDBName).then(function () {
      that._active = true;
      that.addLog = that._addLog;
      that._startListenOnErrors();
      console.log("LogListener: activated");
    }, function (pError) {
      that._active = true;
      console.error("activate: failed activate storage", pError);
      that.addLog = that._addLog;
      that._startListenOnErrors();
      console.log("LogListener: activated");
    });
    return this._activatingDef;
  },
  /**
   * @description desactive the logging, after the call the logs removed, 
   * this is used durring unit testing
   * @function
   * @name LogListener#desactivate
   * @returns undefined
   */
  desactivate: function desactivate() {
    this._stopLocalStorage();
    this._active = false;
    this.storageHandler = undefined;
    this.addLog = function () {};
    window.onerror = function (message, source, lineno, colno, error) {};
    console.log("LogListener: desactivated");
  },
  _initLocalStorage: function _initLocalStorage(pDBName) {
    var that = this;
    if (IndexStorage.isSupported() === false) {
      console.error("LogListener: could not support local storage!");
      this.storageHandler = null;
      return;
    }
    this.storageHandler = new IndexStorage("nixps.Pagebuilder.Debug");
    return this.storageHandler.open({
      expire: 12 * 60 * 60000,
      dbName: pDBName
    })["catch"](function (pError) {
      that.storageHandler = null;
      return Promise.reject(pError);
    });
  },
  _addToSaveLocal: function _addToSaveLocal(pLogJSON) {
    this._logWaitingToSave.push(pLogJSON);
    if (this._logSavingDefStatus !== "pending") {
      this._saveLocal([]);
    }
    return this._logSavingDef;
  },
  _saveLocal: function _saveLocal(pPrevSavedLogs) {
    var that = this;
    if (!Array.isArray(pPrevSavedLogs)) {
      pPrevSavedLogs = [];
    }
    if (this.storageHandler !== undefined && this.storageHandler !== null) {
      if (Array.isArray(this._logWaitingToSave) && this._logWaitingToSave.length > 0) {
        var saving = this._logWaitingToSave.slice();
        this._logSavingDefStatus = "pending";
        this._logSavingDef = this.storageHandler.addMultiple(saving).then(function (pResult) {
          that._logSavingDefStatus = "resolved";
          if (that._logWaitingToSave.length > 0) {
            return that._saveLocal(pPrevSavedLogs.concat(saving));
          }
          that._sendOutsideIframe({
            logs: pPrevSavedLogs.concat(saving)
          });
          return {
            logs: pPrevSavedLogs.concat(saving)
          };
        }, function (pError) {
          that._logSavingDefStatus = "rejected";
          console.error(pError);
          if (that._logWaitingToSave.length > 0) {
            return that._saveLocal(pPrevSavedLogs);
          }
          that._sendOutsideIframe({
            logs: pPrevSavedLogs
          });
          return {
            logs: pPrevSavedLogs
          };
        });
        this._logWaitingToSave = [];
        return this._logSavingDef;
      } else {
        // no more logs to save
        that._sendOutsideIframe({
          logs: pPrevSavedLogs
        });
        this._logSavingDefStatus = "resolved";
        this._logSavingDef = Promise.resolve({
          logs: pPrevSavedLogs
        });
        return this._logSavingDef;
      }
    } else {
      this._logSavingDefStatus = "rejected";
      this._logSavingDef = Promise.resolve({
        "error_code": "storage_not_active",
        "error": "The storage is not active"
      });
      return this._logSavingDef;
    }
  },
  _stopLocalStorage: function _stopLocalStorage() {
    if (this.storageHandler !== undefined && this.storageHandler !== null) {
      if (this.isActivatingDone()) {
        this.storageHandler.close();
      } else {}
    }
  },
  _sendOutsideIframe: function _sendOutsideIframe(pMessage) {
    if (_windowListeren !== undefined && typeof _windowListeren.postMessage === "function") {
      _windowListeren.postMessage(pMessage, window.location.origin);
    }
  },
  _startListenOnErrors: function _startListenOnErrors() {
    var that = this;
    window.onerror = function (message, source, lineno, colno, error) {
      that.addLog({
        browser_url: this.location.href,
        event_type: "error",
        details_data: {
          error_code: "js_error",
          error: message,
          source: source,
          line: lineno,
          col: colno,
          stack: error.stack
        }
      });
    };
  },
  _addLog: function _addLog(pData, pElement) {
    try {
      var that = this;
      var pageEvent = undefined;
      if (pData instanceof CloudflowPageEvent) {
        pageEvent = pData;
      } else if (pData && _typeof(pData) === "object") {
        pageEvent = new CloudflowPageEvent(pData);
      }
      if (pageEvent.hasComponentCSSSelector() === false) {
        var elementDOM = null;
        if (pElement instanceof window.jQuery) {
          elementDOM = pElement[0];
        } else if (pElement instanceof HTMLElement) {
          elementDOM = pElement;
        }
        if (elementDOM && typeof elementDOM.id === "string" && elementDOM.id.length > 0) {
          pageEvent.setComponentCSSSelector("#" + elementDOM.id);
        }
      }
      if (pageEvent !== undefined) {
        this.logs.push(pageEvent);
        this._sendOutsideIframe({
          log: pageEvent.toJSON()
        });
        return this._addToSaveLocal(pageEvent.toJSON());
      } else {
        console.error("_addLog: unknown input", pData);
      }
    } catch (e) {
      // error in debugging code
      console.error(e);
    }
  },
  /**
   * @description Returning all the logs in memory
   * @function
   * @name LogListener#getLogs
   * @returns {Array<CloudflowLogEvent>}
   */
  getLogs: function getLogs(pQuery, pOrderby, pFields, pSkip, pMax) {
    if (!Array.isArray(pQuery)) {
      pQuery = [];
    }
    if (this.storageHandler === undefined || this.storageHandler === null) {
      return Promise.resolve(this.logs.slice());
    }
    var that = this;
    return this.storageHandler.list_with_options(pQuery).then(function (localLogData) {
      if (localLogData !== undefined && Array.isArray(localLogData.results)) {
        var logs = [];
        for (var i = 0; i < localLogData.results.length; i++) {
          if (localLogData.results[i] && Object.getPrototypeOf(localLogData.results[i]) === Object.prototype) {
            logs.push(CloudflowPageEvent.fromJSON(localLogData.results[i]));
          }
        }
        return logs;
      }
      return that.logs.slice();
    }, function (pError) {
      return that.logs.slice();
    });
  },
  initGetter: function initGetter() {
    return this._initLocalStorage();
  },
  /**
   * @description Delete all the logs, including those in momory, used for testing
   * @function
   * @name LogListener#clear
   * @returns undefined
   */
  clear: function clear() {
    this.logs = [];
    if (this.storageHandler !== undefined && this.storageHandler !== null) {
      if (this.isActivatingDone()) {
        return this.storageHandler.clear();
      }
    }
    return Promise.resolve({});
  },
  destroy: function destroy() {
    if (this.storageHandler !== undefined && this.storageHandler !== null) {
      return this.storageHandler.close();
    }
    return Promise.resolve({});
  }
};
if (window.nixps === undefined) {
  window.nixps = {};
}
if (nixps.cloudflow === undefined) {
  nixps.cloudflow = {};
}
if (nixps.cloudflow.LogListener === undefined) {
  nixps.cloudflow.LogListener = new LogListener();
  if (window.top !== undefined) {
    try {
      if (window.top['__nixps.debugging.sessionID'] !== undefined) {
        _windowListeren = window.top;
        nixps.cloudflow.LogListener.activate(window.top['__nixps.debugging.sessionID']);
      }
    } catch (e) {}
  }
  if (window.parent !== undefined) {
    try {
      if (window.parent['__nixps.debugging.sessionID'] !== undefined) {
        _windowListeren = window.parent;
        nixps.cloudflow.LogListener.activate(window.parent['__nixps.debugging.sessionID']);
      }
    } catch (e) {}
  } else if (window['__nixps.debugging.sessionID'] !== undefined) {
    _windowListeren = window;
    nixps.cloudflow.LogListener.activate(window['__nixps.debugging.sessionID']);
  }
}
module.exports = nixps.cloudflow.LogListener;

},{"../../../common/BrowserStorage/js/IndexedStorage.js":278,"./CloudflowPageEvent.js":429}],432:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* 
 *   NiXPS Hybrid Software Development    
 *   created by guillaume on Feb 15, 2018 4:35:03 PM
 */
(function ($) {
  "use strict";

  require("../../cloudflow/ExpressionBuilder/js/nixps-quantum-ExpressionBuilder.js");
  require("../../quantum/js/nixps-quantum-util.js");
  require("../../quantum/js/nixps-quantum-autobind.js");
  var ExpressionToJS = require("./ExpressionToJS.js");
  var Context = require("./Context.js");
  var entitycomposerCollectionDef;
  function getEntitycomposerCollection() {
    if (entitycomposerCollectionDef === undefined) {
      if (window.api_mock !== undefined && api_mock.entitycomposerpagebuilder !== undefined && typeof api_mock.entitycomposerpagebuilder.list === "function") {
        entitycomposerCollectionDef = api_mock.entitycomposerpagebuilder.list();
      } else {
        console.error("unknown api_mock call");
      }
    }
    return entitycomposerCollectionDef;
  }
  function isValueComposer(pValue) {
    if (Array.isArray(pValue) === false) {
      return false;
    }
    for (var i = 0; i < pValue.length; i++) {
      if (pValue[i] === undefined || typeof pValue[i].type !== "string" || pValue[i].type.indexOf("com.nixps.") !== 0) {
        return false;
      }
    }
    return true;
  }
  function translateToValueComposer(pValue, pTranslationKey, pFallBackValue) {
    if (typeof pTranslationKey === "string" && typeof pValue === "string") {
      if (pValue === "${" + pTranslationKey + "}") {
        // the value is exactly the same as the translation key for this field and the translations are activated
        return [{
          "type": "com.nixps.localization.look_up.0",
          "translation_key": pTranslationKey
        }];
      } else if (pValue.indexOf("${custom-") === 0 && pValue[pValue.length - 1] === "}") {
        return [{
          "type": "com.nixps.localization.look_up.0",
          "translation_key": pValue.slice(2, -1)
        }];
      }
      return [{
        "type": "com.nixps.quantum.value.0",
        "value": pValue
      }];
    } else if (["number", "string", "boolean"].includes(_typeof(pValue)) || pValue === null || pValue === undefined) {
      return [{
        "type": "com.nixps.quantum.value.0",
        "value": pValue
      }];
    } else if (Array.isArray(pValue) || $.isPlainObject(pValue)) {
      return pValue;
    } else if (Array.isArray(pValue) === false) {
      return [{
        "type": "com.nixps.quantum.value.0",
        "value": pValue
      }];
    } else if (Array.isArray(pFallBackValue) === true) {
      if (isValueComposer(pValue) === false) {
        return pFallBackValue;
      }
      return pValue;
    }
    return pValue;
  }
  function addVariable(pContext, pVariableName) {
    var hash = pContext.makeContextIdentifier();
    if (contextCollections[hash] !== undefined) {
      $.when(contextCollections[hash]).done(function (pObject) {
        pObject.entities[0].values.push({
          "label": pVariableName,
          "parameters": {
            "variable": pVariableName
          },
          "category": "Page Variables",
          "sample": ""
        });
      });
    }
  }
  function sortFunction(a, b) {
    if (a === undefined || typeof a.label !== "string") {
      return 1;
    }
    if (b === undefined || typeof b.label !== "string") {
      return -1;
    }
    return a.label.localeCompare(b.label);
  }
  function makeWorkflowVariableCollectionEntities(pObject) {
    var values = [];
    $.each(pObject, function (key, value) {
      values.push({
        "label": key,
        "parameters": {
          "variable": key
        },
        "category": "Page Variables",
        "sample": value
      });
    });
    values.sort(sortFunction);
    values.unshift({
      "label": "All data",
      "parameters": {
        "variable": "."
      },
      "category": "Page Variables",
      "help": {
        "en": "All page variables in one object"
      },
      "sample": ""
    });
    return {
      "entities": [{
        "identifier": "com.nixps.quantum.variable.0",
        "parameters": ["variable"],
        "values": values
      }]
    };
  }
  function addTranslations(pCollentionEntities, pTranslationKey) {
    if (typeof pTranslationKey === "string" && pTranslationKey.length > 0) {
      var entities = $.extend([], pCollentionEntities.entities);
      entities.push({
        "identifier": "com.nixps.localization.look_up.0",
        "parameters": {},
        "sample": $.i18n._(pTranslationKey)
      });
      return {
        "entities": entities
      };
    } else {
      return pCollentionEntities;
    }
  }
  function loadObjectData(pContext, pRelativeBasePath) {
    if (pContext.getValueComposerEditorConfiguration) {
      return pContext.getValueComposerEditorConfiguration;
    }
    return $.Deferred(function (pDefer) {
      pContext.loadDataFromCache({
        suppressRedirect: true,
        relativeBasePath: pRelativeBasePath
      }).then(function (pSampleObject) {
        pDefer.resolve(makeWorkflowVariableCollectionEntities(pSampleObject));
      }, function (pError) {
        // error occured, 
        // remove from caches, perhapse in one little, little change it will work the next time?
        var hash = pContext.makeContextIdentifier();
        delete contextCollections[hash];
        // return nothing
        console.error(pError);
        pDefer.resolve(makeWorkflowVariableCollectionEntities({}));
      });
    });
  }
  var contextCollections = {};
  function getCollectionEntities(pContext, pRelativeBasePath) {
    var hash = "";
    if (pContext.makeContextIdentifier === undefined || typeof pContext.makeContextIdentifier !== "function") {
      hash = pContext.id + pContext.node_id;
    } else {
      hash = pContext.makeContextIdentifier();
    }
    if (contextCollections[hash] === undefined) {
      contextCollections[hash] = loadObjectData(pContext, pRelativeBasePath);
    }
    return contextCollections[hash];
  }

  /**
   * @namespace nixps-cloudflow.ExpressionBuilderInput
   * @description draw a component
   * @private
   * @version 1.2.0
   * @example $("<div>").ExpressionBuilderInput({});
   */
  $.widget("nixps-cloudflow.ExpressionBuilderInput", $.Widget, {
    version: "1.2.0",
    widgetEventPrefix: "expressionbuilderinput",
    options: {
      /**
       * @description The language of the user
       * @name nixps-quantum.ExpressionBuilderInput#language
       * @type {String}
       * @default "en"
       */
      language: "en",
      /**
       * @description The main title to be shown on the expression builder dialog
       * @name nixps-cloudflow.ExpressionBuilderInput#maintitle
       * @type {String}
       * @default ""
       */
      maintitle: "",
      /**
       * @description The title to be shown on the expression builder dialog
       * @name nixps-cloudflow.ExpressionBuilderInput#title
       * @type {String}
       * @default ""
       */
      title: "",
      /**
       * @description The value composer to be shown on default
       * @name nixps-cloudflow.ExpressionBuilderInput#value
       * @type {Array}
       * @default []
       */
      value: "",
      /**
       * @description Fallback value if input value is not a value composer
       * @name nixps-cloudflow.ExpressionBuilderInput#fallbackErrorValue
       * @private
       * @default []
       * @type {Array} 
       */
      fallbackErrorValue: null,
      /**
       * @description The format to force a user to use. Possible values are "number", "string", "boolean"
       * @name nixps-cloudflow.ExpressionBuilderInput#forceFormat
       * @type {String}
       * @default null
       */
      forceFormat: null,
      /**
       * @description define the allowed composer types, others will be filtered out, if not an array, no filtering will happen
       * and an empty array will filter everyting away
       * @name nixps-cloudflow.ExpressionBuilderInput#allowedComposerTypes
       * @type {Array}
       * @default undefined
       */
      allowedComposerTypes: undefined,
      /**
       * @description define the allowed transformer types, others will be filtered out, if not an array, no filtering will happen
       * and an empty array will filter everyting away
       * @name nixps-cloudflow.ExpressionBuilderInput#allowedTransformerTypes
       * @type {Array}
       * @default undefined
       */
      allowedTransformerTypes: undefined,
      /**
       * @name nixps-cloudflow.ExpressionBuilderInput#enableAddPathButton
       * @description Must we show the add path button or not?
       * @type {Boolean}
       * @default false
       */
      enableAddPathButton: false,
      /**
       * @description Must we allow the user to edit in the textual code editor
       * @name nixps-quantum.ExpressionBuilderInput#enableCodeEditor 
       * @type {Boolean}
       * @default true
       */
      enableCodeEditor: true,
      /**
       * @description Must we show the categories?
       * @name nixps-quantum.ExpressionBuilderInput#showCategorie
       * @type {Boolean}
       * @default true
       */
      showCategorie: true,
      /**
       * @name nixps-cloudflow.ExpressionBuilderInput#showAddVariableButton
       * @description show the add variable button, or hide it
       * @type {Boolean}
       * @default true
       */
      showAddVariableButton: true,
      /**
       * @name nixps-cloudflow.ExpressionBuilderInput#showOriginalStateButton
       * @description show the original state button, or hide it
       * @type {Boolean}
       * @default true
       */
      showOriginalStateButton: true,
      /**
       * @name nixps-cloudflow.ExpressionBuilderInput#originalStateValueComposer
       * @description The value composer to be used when user clicked on the button to restore
       * @type {Array.<Object>}
       * @default []
       */
      originalStateValueComposer: [],
      scopedVariableSources: null,
      /**
       * @name nixps-cloudflow.ExpressionBuilderInput#useObjectExpression
       * @description option to give to expressioneditor
       * @type {Boolean}
       * @default true
       * @since 1.1.0
       */
      useObjectExpression: true,
      /**
       * @description The relative basepath of the page
       * @name nixps-cloudflow.ExpressionBuilderInput#relativeBasePath
       * @type {String}
       * @default ""
       */
      relativeBasePath: "",
      /**
       * @description The current user object
       * @name nixps-cloudflow.ExpressionBuilderInput#user
       * @type {User}
       * @default undefined
       */
      user: undefined,
      /**
       * @description The user preferences util object
       * @name nixps-cloudflow.ExpressionBuilderInput#userPreferences
       * @type {UserPreferences}
       * @default undefined
       */
      userPreferences: undefined,
      /**
       * @description The context object containing all the information about the variabels
       * @name nixps-cloudflow.ExpressionBuilderInput#context
       * @type {Object}
       * @default null
       */
      context: null,
      /**
       * @description The consent, privacy and cookies object
       * @name nixps-cloudflow.ExpressionBuilderInput#consent
       * @type {Object}
       * @default null
       */
      consent: null,
      /**
       * @description The prefix of the translation keys, if null there are no translations
       * @name nixps-cloudflow.ExpressionBuilderInput#translationPrefixKey
       * @type {String}
       * @default null
       */
      translationPrefixKey: null,
      /**
       * @description String to be appended to the {@link nixps-cloudflow.ExpressionBuilderInput#translationPrefixKey}
       * @name nixps-cloudflow.ExpressionBuilderInput#translationPostfixKey
       * @type {String}
       * @default null
       */
      translationPostfixKey: null,
      /**
       * @description The jQuery scope where the elements live in
       * @name nixps-cloudflow.ExpressionBuilderInput#scope
       * @type {String}
       * @default pagebuilder
       */
      scope: "pagebuilder",
      /**
       * @description The classes to be added to the expressionbuilder.js
       * @name nixps-cloudflow.editorDialogClasses#scope
       * @type {String}
       * @default ""
       */
      editorDialogClasses: "",
      /**
       * @description The zIndex of the overlay
       * @name nixps-cloudflow.ExpressionBuilderInput#zIndexOverlay
       * @type {Number}
       * @default 100100
       */
      zIndexOverlay: 100100,
      /**
       * @description are the fields required?
       * @name nixps-cloudflow.ExpressionBuilderInput#required
       * @type {Boolean}
       * @default false
       * @example true
       * @since 1.2.0
       */
      required: false
    },
    /**
     * @description Create the component
     * @name nixps-cloudflow.ExpressionBuilderInput#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      var that = this;
      if (typeof this.options.translationPrefixKey === "string" && typeof this.options.translationPostfixKey === "string") {
        this.options.translationPrefixKey += this.options.translationPostfixKey;
        this.options.translationPostfixKey = "";
      }
      this.options.value = translateToValueComposer(this.options.value, this.options.translationPrefixKey, this.options.fallbackErrorValue);
      this._controlOptions();
      this.element.addClass(this.widgetFullName);

      // variables 
      this.alive = true;
      this.validInput = true; // flag indication the input is valid or not
      this.context = this.options.context;
      if (this.options.context === null) {
        this.context = new Context("object", "dummy", {}, true);
      } else if (!Array.isArray(this.options.context) && _typeof(this.options.context) === "object" && typeof this.options.context.fromJSON !== "function") {
        this.context = Context.fromJSON(this.options.context);
      }
      this.expressionUtil = new ExpressionToJS(this.context, this.options.user, this.options.userPreferences);

      // draw element
      var expressionEditor = $("<div>").addClass("expressionbuilderinput_value");
      this.element.append(expressionEditor);
      $.when(getEntitycomposerCollection()).done(function (pResults) {
        if (that.alive === false) {
          return;
        }
        expressionEditor.ExpressionEditor({
          forceFormat: that.options.forceFormat,
          entityComposerDefinitionResults: pResults.results,
          useObjectExpression: that.options.useObjectExpression,
          scope: that.options.scope,
          disabled: that.options.disabled,
          required: that.options.required
        }).addClass("cf-form-control");
        that.setValue(that.options.value);
      }).fail(function (pError) {
        console.error(pError);
      });
      this.element.append($("<div>").addClass("expressionbuilderinput_editbutton cf-icon cf-icon-pencil"));
      this._on(this.element, {
        "expressioneditorchange.expressionbuilderinput_value": this._changeHandler,
        "click .expressionbuilderinput_editbutton": this._clickHandler
      });
      if (this.options.disabled === true) {
        this.element.addClass(this.widgetFullName + "-disabled");
      }
    },
    /**
     * @description function runs when user did some changes
     * @function
     * @private
     * @name nixps-cloudflow.ExpressionBuilderInput#_changeHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _changeHandler: function _changeHandler(pEvent, pData) {
      var newValue = this.element.children(".expressionbuilderinput_value").ExpressionEditor("option", "valueComposer");
      var oldValue = this.options.value;
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.options.value = newValue;
        // only fire when internal value composer closes and changed 
        // because others changes are already fired by other change and input event trigger 
        if (pData.inner_valuecomposer === true) {
          this.element.trigger("fieldcustomchange", null, {});
        }
      }
    },
    /**
     * @description function runs when user clicked on the pensil icon
     * @function
     * @private
     * @name nixps-cloudflow.ExpressionBuilderInput#_clickHandler
     * @param {type} pEvent
     * @param {type} pData
     * @return {undefined}
     */
    _clickHandler: function _clickHandler(pEvent, pData) {
      var that = this;
      var expressionBuilder = $("<div>");
      //addClass ui-front to make sure jQuery dialog component picks it up as it searches for siblings(!) with this class to calculate the z-index of the next dialog to open
      var overlay = $("<div>").addClass("cf-overlay").addClass("ui-front").css({
        "background-color": "rgba(0, 0, 0, 0.5)",
        "z-index": this.options.zIndexOverlay
      }).appendTo($("body")).append(expressionBuilder);
      // prepare options
      var title = this.options.title;
      if (typeof this.options.maintitle === "string" && this.options.maintitle.length > 0) {
        title = this.options.maintitle + ": " + this.options.title;
      }
      $.when(getEntitycomposerCollection()).then(function (pResults) {
        if (that.alive === false) {
          return;
        }
        var entityComposerDefinitions = pResults.results;
        if (Array.isArray(that.options.allowedTransformerTypes)) {
          entityComposerDefinitions = entityComposerDefinitions.filter(function (pDefinition) {
            if (pDefinition.type !== "transformer") {
              return true;
            }
            return that.options.allowedTransformerTypes.includes(pDefinition.identifier);
          });
        }
        expressionBuilder.ExpressionBuilder({
          language: that.options.language,
          title: title,
          classes: that.options.editorDialogClasses,
          forceFormat: that.options.forceFormat,
          valueComposer: that.options.value,
          enableCasting: false,
          valueComposerCollection: that._getValueComposerCollection(),
          entityComposerDefinitionResults: entityComposerDefinitions,
          context: {
            node_definition: {
              parameters: {
                "test": structuredClone(that.options.originalStateValueComposer)
              }
            },
            parameter_name: "test"
          },
          consent: that.options.consent,
          enableAddPathButton: that.options.enableAddPathButton,
          enableCodeEditor: that.options.enableCodeEditor,
          getValueComposerEditorConfiguration: that._getValueComposerEditorConfiguration(),
          simulation: that._expressionSimulation.bind(that),
          addvariable: that._addVariableHanlder.bind(that),
          showCategorie: that.options.showCategorie,
          showAddVariableButton: that.options.showAddVariableButton,
          showOriginalStateButton: that.options.showOriginalStateButton,
          scope: that.options.scope,
          disabled: that.options.disabled,
          cancel: function cancel() {
            overlay.remove();
          },
          save: function save(pEvent, pData) {
            that.setValue(pData.valueComposer);
            that.element.trigger("fieldcustomchange", null, {});
            overlay.remove();
          }
        });
      });
    },
    _getValueComposerEditorConfiguration: function _getValueComposerEditorConfiguration() {
      var that = this;
      return getCollectionEntities(this.context, this.options.relativeBasePath).then(function (pCollection) {
        return that._addScopedVariableResources(addTranslations(pCollection, that.options.translationPrefixKey));
      });
    },
    _addScopedVariableResources: function _addScopedVariableResources(pCollentionEntities) {
      if (this.options.scopedVariableSources !== null) {
        var entities = $.extend(true, [], pCollentionEntities.entities);
        var entity = entities[0];
        if (entity.identifier === "com.nixps.quantum.variable.0") {
          if (Array.isArray(entity.values) === false) {
            entity.values = [];
          }
          if (Array.isArray(this.options.scopedVariableSources)) {
            entity.values = entity.values.concat(this.options.scopedVariableSources);
          }
        }
        return {
          "entities": entities
        };
      } else {
        return pCollentionEntities;
      }
    },
    /**
     * @description function to simulate the value composer to the value that will be applied
     * @function
     * @private
     * @name nixps-cloudflow.ExpressionBuilderInput#_expressionSimulation
     * @param {type} pJSON
     * @param {type} pContext
     * @return {Object.prototype.applyToValue.outputValue}
     */
    _expressionSimulation: function _expressionSimulation(pJSON, pContext) {
      // first make one value composer of it.
      // this function will make one array of all the arrays inside the main array
      var oneValueComposer = $.map(pJSON, function (elem) {
        return elem;
      });
      // get one value of it
      return this.expressionUtil.applyToValue(oneValueComposer);
    },
    /**
     * @description function runs when user has added a new custom variable
     * @function
     * @private
     * @name nixps-cloudflow.ExpressionBuilderInput#_addVariableHanlder
     * @param {*} pEvent 
     * @param {*} pData 
     */
    _addVariableHanlder: function _addVariableHanlder(pEvent, pData) {
      if (pData !== undefined && typeof pData.variable_name === "string" && pData.variable_name.length > 0) {
        addVariable(this.context, pData.variable_name);
      }
    },
    /**
     * @description filter the possible value composers to use
     * @return {Array}
     * @function
     * @private
     * @name nixps-cloudflow.ExpressionBuilderInput#_getValueComposerCollection
     */
    _getValueComposerCollection: function _getValueComposerCollection() {
      var that = this;
      var hasTranslations = typeof this.options.translationPrefixKey === "string" && this.options.translationPrefixKey.length > 0;
      var collection = valuecomposerCollection.slice();
      if (Array.isArray(this.options.allowedComposerTypes)) {
        collection = collection.filter(function (elem) {
          if (elem && Array.isArray(elem.composer) && elem.composer.length === 1) {
            return that.options.allowedComposerTypes.includes(elem.composer[0].type);
          }
          return false;
        });
      }
      return $.map(collection, function (elem) {
        if (elem.name === "Current User") {
          if (that.options.user !== null) {
            elem.sample = function (title) {
              if (typeof title === "string" && title.length > 0) {
                var partOne = title.split(" ");
                if (Array.isArray(partOne) && partOne.length > 0) {
                  if (partOne[0] === "username") {
                    return that.user.getUserName();
                  } else if (partOne[0] === "fullname") {
                    return that.user.getFullName();
                  } else if (partOne[0] === "email") {
                    return that.user.getEmail();
                  } else if (partOne[0] === "attributes_name") {
                    return that.user.getAttributesName();
                  } else if (partOne[0] === "active_scope_name") {
                    return that.user.getActiveScopeName();
                  }
                }
              }
              return "admin";
            };
          }
          return elem;
        } else if (elem.name === "Translation") {
          if (hasTranslations === false) {
            // filter translations if there are no translations    
            return undefined;
          } else {
            // inject the prefix of the translations key
            elem.composer[0].translation_key = that.options.translationPrefixKey;
            if ($.i18n._(that.options.translationPrefixKey) !== that.options.translationPrefixKey) {
              elem.sample = $.i18n._(that.options.translationPrefixKey);
            }
          }
          return elem;
        } else {
          return elem;
        }
      });
    },
    /**
     * @description Get the value composer values. If it is one value then that value is returned iso the value composer
     * @function
     * @name nixps-cloudflow.ExpressionBuilderInput#getValue
     * @return {nixps-cloudflow-ExpressionBuilderInputL#8.nixps-cloudflow-ExpressionBuilderInputAnonym$6.getValue.element@call;children@call;ExpressionEditor.value|nixps-cloudflow-ExpressionBuilderInputL#8.nixps-cloudflow-ExpressionBuilderInputAnonym$6.getValue@pro;element@call;children@call;ExpressionEditor}
     */
    getValue: function getValue() {
      if (entitycomposerCollectionDef === undefined || this.element.children(".expressionbuilderinput_value").hasClass("nixps-quantum-ExpressionEditor") === false) {
        console.error("expressionBuilder.getValue before init is done");
        return this.options.value;
      }
      var valuecomposer = this.element.children(".expressionbuilderinput_value").ExpressionEditor("option", "valueComposer");
      // check if the user has just typed some text without variables ...
      if (Array.isArray(valuecomposer)) {
        if (valuecomposer.length > 1) {
          for (var i = valuecomposer.length - 1; i > 0; i--) {
            if (valuecomposer[i].type === "com.nixps.quantum.value.0" && valuecomposer[i - 1].type === "com.nixps.quantum.value.0") {
              if (typeof valuecomposer[i - 1].value === "string") {
                valuecomposer[i - 1].value += valuecomposer[i].value;
                valuecomposer.splice(i, 1);
              }
            }
          }
        }
        if (valuecomposer.length === 1 && valuecomposer[0].type === "com.nixps.quantum.value.0") {
          return valuecomposer[0].value; // if so, return just that string
        }

        return valuecomposer;
      } else if ($.isPlainObject(valuecomposer)) {
        return valuecomposer;
      } else {
        throw new Error("expression builder must return an array");
      }
    },
    /**
     * @description Set the expression builder to a specific Value Composer. If the value is not a value composer, we make one of it
     * @function
     * @name nixps-cloudflow.ExpressionBuilderInput#setValue
     * @param {Array.<ValueComposer>} pValue
     * @return {undefined}
     */
    setValue: function setValue(pValue) {
      this.options.value = translateToValueComposer(pValue, this.options.translationPrefixKey, this.options.fallbackErrorValue);
      var that = this;
      $.when(getEntitycomposerCollection()).done(function () {
        if (that.alive === false) {
          return;
        }
        try {
          that.element.children(".expressionbuilderinput_value").ExpressionEditor("option", "valueComposer", that.options.value);
          that.element.removeClass("node_editor_valuecomposerinput_invalid");
          if (that.validInput === false) {
            that.validInput = true;
          }
        } catch (e) {
          that.validInput = false;
          that.element.addClass("node_editor_valuecomposerinput_invalid");
          throw e;
        }
      });
    },
    reset: function reset() {
      return this.setValue([]);
    },
    /**
     * @description setOptions
     * @function
     * @name nixps-cloudflow.ExpressionBuilderInput#_setOptions
     * @private
     * @param {type} options
     * @return {nixps-cloudflow-ExpressionBuilderInputL#8.nixps-cloudflow-ExpressionBuilderInputAnonym$6}
     */
    _setOptions: function _setOptions(options) {
      var key;
      if (typeof options.translationPostfixKey === "string") {
        if (typeof options.translationPrefixKey === "string") {
          options.translationPrefixKey += options.translationPostfixKey;
          options.translationPostfixKey = "";
        } else {
          this.options.translationPrefixKey += options.translationPostfixKey;
          options.translationPostfixKey = "";
        }
      }
      for (key in options) {
        this._setOption(key, options[key]);
      }
      return this;
    },
    /**
     * @description Sets the option
     * @function
     * @private
     * @name nixps-cloudflow.ExpressionBuilderInput#_setOption
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "value") {
        if (JSON.stringify(this.options.value) === JSON.stringify(pValue)) {
          this._superApply(arguments);
          this._controlOptions();
          this.value(pValue);
        }
      } else if (pKey === "disabled") {
        if (pValue !== this.options.disabled) {
          this._superApply(arguments);
          this._controlOptions();
          this.element.children(".expressionbuilderinput_value.nixps-quantum-ExpressionEditor").ExpressionEditor("option", "disabled", pValue);
        }
      } else if (pKey === "required") {
        if (pValue !== this.options.required) {
          this._superApply(arguments);
          this._controlOptions();
          this.element.children(".expressionbuilderinput_value.nixps-quantum-ExpressionEditor").ExpressionEditor("option", "required", pValue);
        }
      } else {
        this._superApply(arguments);
        this._controlOptions();
      }
    },
    /**
     * @description Control the input options and throw a error if needed
     * @name nixps-cloudflow.ExpressionBuilderInput#_controlOptions
     * @function
     * @private
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.title !== "string") {
        throw new Error(this.widgetName + ": input option title must be a string");
      }
      if (this.options.forceFormat !== null && typeof this.options.forceFormat !== "string") {
        throw new Error(this.widgetName + ": input option forceFormat must be null or a string");
      }
      if (this.options.translationPrefixKey !== null && typeof this.options.translationPrefixKey !== "string") {
        throw new Error(this.widgetName + " input option translationPrefixKey must be null or a string");
      }
      if (this.options.translationPostfixKey !== null && typeof this.options.translationPostfixKey !== "string") {
        throw new Error(this.widgetName + " input option translationPostfixKey must be null or a string");
      }
    },
    _destroy: function _destroy() {
      this.alive = false;
      this.element.removeClass(this.widgetFullName).removeClass("node_editor_valuecomposerinput_invalid");
      this._superApply(arguments);
    }
  });
  var valuecomposerCollection = [{
    "name": "Current User",
    // < Name to display in the list
    "composer": [{
      "type": "com.nixps.pagebuilder.current_user.0",
      "part": "username"
    }],
    "category": "Page",
    "output_type": "string",
    "sample_visible": true,
    "fixed_sample": true,
    "help": {
      "en": "The current user"
    }
  }, {
    "name": "Translation",
    // < Name to display in the list
    "composer": [{
      "type": "com.nixps.localization.look_up.0",
      "translation_key": "nixps-cloudflow-manage.users-column-name"
    }],
    "category": "Page",
    "output_type": "string",
    "sample_visible": true,
    "sample": "bla",
    "fixed_sample": true,
    "help": {
      "en": "The text to be translated"
    }
  }, {
    "name": "Unique ID",
    "composer": [{
      "type": "com.nixps.quantum.generate_uuid.0"
    }],
    "category": "General",
    "output_type": "string",
    "sample_visible": false,
    "sample": "7d4fc29c-fce0-4348-ab2d-354f413f7a16",
    "fixed_sample": true,
    "help": {
      "en": "Generate a unique id"
    }
  }, {
    "name": "Year",
    "composer": [{
      "type": "com.nixps.quantum.current_time.0",
      "format": "%Y",
      "utc": false
    }],
    "category": "Date/Time",
    "output_type": "string",
    "sample_visible": true,
    "sample": function sample(title) {
      if (title.length > 4) {
        // if there is some text behinde. ex. year ('15)
        return (new Date().getFullYear() % 100).toString();
      } else {
        return new Date().getFullYear().toString();
      }
    },
    "fixed_sample": true,
    "help": {
      "en": "The current year"
    }
  }, {
    "name": "Month",
    "composer": [{
      "type": "com.nixps.quantum.current_time.0",
      "format": "%B",
      "utc": false
    }],
    "category": "Date/Time",
    "output_type": "string",
    "sample_visible": true,
    "sample": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][new Date().getMonth()],
    "fixed_sample": true,
    "help": {
      "en": "The current month"
    }
  }, {
    "name": "Month number",
    "composer": [{
      "type": "com.nixps.quantum.current_time.0",
      "format": "%m",
      "utc": false
    }],
    "category": "Date/Time",
    "output_type": "string",
    "sample_visible": true,
    "sample": ("0" + (new Date().getMonth() + 1)).slice(-2),
    "fixed_sample": true,
    "help": {
      "en": "The current month"
    }
  }, {
    "name": "Weekday",
    "composer": [{
      "type": "com.nixps.quantum.current_time.0",
      "format": "%A",
      "utc": false
    }],
    "category": "Date/Time",
    "output_type": "string",
    "sample_visible": true,
    "sample": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][new Date().getDay()],
    "fixed_sample": true,
    "help": {
      "en": "The current day of the month"
    }
  }, {
    "name": "Day of the Month",
    "composer": [{
      "type": "com.nixps.quantum.current_time.0",
      "format": "%d",
      "utc": false
    }],
    "category": "Date/Time",
    "output_type": "string",
    "sample_visible": true,
    "sample": ("0" + new Date().getDate()).slice(-2),
    "fixed_sample": true,
    "help": {
      "en": "The current day of the month"
    }
  }, {
    "name": "Hour",
    "composer": [{
      "type": "com.nixps.quantum.current_hour.0",
      "format": "%H",
      "utc": false
    }],
    "category": "Date/Time",
    "output_type": "string",
    "sample_visible": true,
    "sample": ("0" + new Date().getHours()).slice(-2),
    "fixed_sample": true,
    "help": {
      "en": "The current hour in 24h-format"
    }
  }, {
    "name": "Minutes",
    "composer": [{
      "type": "com.nixps.quantum.current_hour.0",
      "format": "%M",
      "utc": false
    }],
    "category": "Date/Time",
    "output_type": "string",
    "sample_visible": true,
    "sample": ("0" + new Date().getMinutes()).slice(-2),
    "fixed_sample": true,
    "help": {
      "en": "The current minutes"
    }
  }, {
    "name": "Seconds",
    "composer": [{
      "type": "com.nixps.quantum.current_hour.0",
      "format": "%S",
      "utc": false
    }],
    "category": "Date/Time",
    "output_type": "string",
    "sample_visible": true,
    "sample": ("0" + new Date().getSeconds()).slice(-2),
    "fixed_sample": true,
    "help": {
      "en": "The current seconds"
    }
  }, {
    "name": "Timestamp (ISO)",
    "composer": [{
      "type": "com.nixps.quantum.current_hour.0",
      "format": "%FT%H:%M:%SZ",
      "utc": true
    }],
    "category": "Date/Time",
    "output_type": "string",
    "sample_visible": true,
    "sample": new Date().toISOString().split('.')[0] + "Z",
    // '2025-04-11T12:11:17Z'
    "fixed_sample": true,
    "help": {
      "en": "The current ISO timestamp"
    }
  }, {
    "name": "Device Language",
    "composer": [{
      "type": "com.nixps.device.settings.0",
      "parameter": "known_language"
    }],
    "category": "Device",
    "output_type": "string",
    "sample_visible": true,
    "sample": "en",
    "fixed_sample": true,
    "help": {
      "en": "The language of the device"
    }
  }, {
    "name": "Is Mobile",
    "composer": [{
      "type": "com.nixps.device.settings.0",
      "parameter": "is_mobile"
    }],
    "category": "Device",
    "output_type": "boolean",
    "sample_visible": true,
    "sample": false,
    "fixed_sample": true,
    "help": {
      "en": "Is is a mobile device?"
    }
  }, {
    "name": "Is Online",
    "composer": [{
      "type": "com.nixps.device.settings.0",
      "parameter": "is_online"
    }],
    "category": "Device",
    "output_type": "boolean",
    "sample_visible": true,
    "sample": false,
    "fixed_sample": true,
    "help": {
      "en": "Is the device online?"
    }
  }
  /*,{
      "name": "All data", // < Name to display in the list
      "composer": [{
          "type": "com.nixps.quantum.variable.0",
          "variable": "."
      }],
      "category": "data",
      "output_type": "array",
      "sample_visible": false,
      "help": {
          "en": "The name of the first output file of a node."
      }
  }*/];
})(jQuery);

},{"../../cloudflow/ExpressionBuilder/js/nixps-quantum-ExpressionBuilder.js":121,"../../quantum/js/nixps-quantum-autobind.js":441,"../../quantum/js/nixps-quantum-util.js":444,"./Context.js":413,"./ExpressionToJS.js":415}],433:[function(require,module,exports){
(function (global,setImmediate){(function (){
"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }
/**
 * @brief this will fix the undefined console problem in older versions of IE
 * @warning this is the most generic way of writing this, not using 3rd party libraries
 *          and making it work in any browser.
 */
if (!window.console) {
  window.console = {
    log: function log() {},
    warn: function warn() {},
    error: function error() {}
  };
}

// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
Number.isNaN = Number.isNaN || function isNaN(input) {
  return typeof input === 'number' && input !== input;
};
Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
if (window.Number !== undefined && Number.EPSILON === undefined) {
  Number.EPSILON = Math.pow(2, -52);
}

// decomment next line to test of the polyfill is added at the proper time, 
// window.testAlert = function(){}

if (!window.location.origin) {
  window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

/**
 * polyfill for Function
 */
// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
if (!Function.prototype.bind) {
  Function.prototype.bind = function (oThis) {
    if (typeof this !== 'function') {
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }
    var args = Array.prototype.slice.call(arguments, 1);
    var fToBind = this;
    var fNOP = function fNOP() {};
    var fBound = function fBound() {
      return fToBind.apply(this instanceof fNOP ? this : oThis, args.concat(Array.prototype.slice.call(arguments)));
    };
    if (this.prototype) {
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();
    return fBound;
  };
}
/**
 * polyfill for Object
 */

/**
 * String.prototype.replaceAll() polyfill
 * https://gomakethings.com/how-to-replace-a-section-of-a-string-with-another-one-with-vanilla-js/
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!String.prototype.replaceAll) {
  Object.defineProperty(String.prototype, "replaceAll", {
    value: function value(str, newStr) {
      // If a regex pattern
      if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
        return this.replace(str, newStr);
      }

      // If a string
      // consider each char as real char and not as reg exp, so esacpe each char
      str = str.replace(new RegExp("(.)", "g"), "[$1]");
      return this.replace(new RegExp(str, 'g'), newStr);
    }
  });
}

// from https://github.com/es-shims/es5-shim/blob/master/es5-sham.js
(function () {
  var prototypeOfObject = Object.prototype;
  var call = Function.call;
  var owns = call.bind(prototypeOfObject.hasOwnProperty);
  var isEnumerable = call.bind(prototypeOfObject.propertyIsEnumerable);
  var toStr = call.bind(prototypeOfObject.toString);
  var defineGetter;
  var defineSetter;
  var lookupGetter;
  var lookupSetter;
  var supportsAccessors = owns(prototypeOfObject, '__defineGetter__');
  if (supportsAccessors) {
    /* eslint-disable no-underscore-dangle, no-restricted-properties */
    defineGetter = call.bind(prototypeOfObject.__defineGetter__);
    defineSetter = call.bind(prototypeOfObject.__defineSetter__);
    lookupGetter = call.bind(prototypeOfObject.__lookupGetter__);
    lookupSetter = call.bind(prototypeOfObject.__lookupSetter__);
    /* eslint-enable no-underscore-dangle, no-restricted-properties */
  }

  var isPrimitive = function isPrimitive(o) {
    return o == null || _typeof2(o) !== 'object' && typeof o !== 'function';
  };
  if (!Object.getPrototypeOf) {
    Object.getPrototypeOf = function getPrototypeOf(object) {
      var proto = object.__proto__;
      if (proto || proto === null) {
        return proto;
      }
      if (toStr(object.constructor) === '[object Function]') {
        return object.constructor.prototype;
      }
      if (object instanceof Object) {
        return prototypeOfObject;
      }
      return null;
    };
  }
  if (!Object.keys) {
    Object.keys = function () {
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var hasDontEnumBug = !{
        toString: null
      }.propertyIsEnumerable('toString');
      var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
      var dontEnumsLength = dontEnums.length;
      return function (obj) {
        if (_typeof2(obj) !== 'object' && (typeof obj !== 'function' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }
        var result = [],
          prop,
          i;
        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }
        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }();
  }
  if (!Object.getOwnPropertyNames) {
    Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
      if (object !== Object(object)) {
        throw TypeError('Object.getOwnPropertyNames called on non-object: ' + object);
      }
      return Object.keys(object);
    };
  }
  var doesGetOwnPropertyDescriptorWork = function doesGetOwnPropertyDescriptorWork(object) {
    try {
      object.sentinel = 0;
      return Object.getOwnPropertyDescriptor(object, 'sentinel').value === 0;
    } catch (err) {
      return false;
    }
  };
  var getOwnPropertyDescriptorFallback;
  if (Object.defineProperty) {
    var getOwnPropertyDescriptorWorksOnObject = doesGetOwnPropertyDescriptorWork({});
    var getOwnPropertyDescriptorWorksOnDom = typeof document === 'undefined' || doesGetOwnPropertyDescriptorWork(document.createElement('div'));
    if (!getOwnPropertyDescriptorWorksOnDom || !getOwnPropertyDescriptorWorksOnObject) {
      getOwnPropertyDescriptorFallback = Object.getOwnPropertyDescriptor;
    }
  }
  if (!Object.getOwnPropertyDescriptor || getOwnPropertyDescriptorFallback) {
    var ERR_NON_OBJECT = 'Object.getOwnPropertyDescriptor called on a non-object: ';
    Object.getOwnPropertyDescriptor = function getOwnPropertyDescriptor(object, property) {
      if (isPrimitive(object)) {
        throw new TypeError(ERR_NON_OBJECT + object);
      }
      if (getOwnPropertyDescriptorFallback) {
        try {
          return getOwnPropertyDescriptorFallback.call(Object, object, property);
        } catch (err) {}
      }
      var descriptor;
      if (!owns(object, property)) {
        return descriptor;
      }
      descriptor = {
        enumerable: isEnumerable(object, property),
        configurable: true
      };
      if (supportsAccessors) {
        var prototype = object.__proto__;
        var notPrototypeOfObject = object !== prototypeOfObject;
        if (notPrototypeOfObject) {
          object.__proto__ = prototypeOfObject;
        }
        var getter = lookupGetter(object, property);
        var setter = lookupSetter(object, property);
        if (notPrototypeOfObject) {
          object.__proto__ = prototype;
        }
        if (getter || setter) {
          if (getter) {
            descriptor.get = getter;
          }
          if (setter) {
            descriptor.set = setter;
          }
          return descriptor;
        }
      }
      descriptor.value = object[property];
      descriptor.writable = true;
      return descriptor;
    };
  }
  var doesDefinePropertyWork = function doesDefinePropertyWork(object) {
    try {
      Object.defineProperty(object, 'sentinel', {});
      return 'sentinel' in object;
    } catch (exception) {
      return false;
    }
  };
  if (Object.defineProperty) {
    var definePropertyWorksOnObject = doesDefinePropertyWork({});
    var definePropertyWorksOnDom = typeof document === 'undefined' || doesDefinePropertyWork(document.createElement('div'));
    if (!definePropertyWorksOnObject || !definePropertyWorksOnDom) {
      var definePropertyFallback = Object.defineProperty;
      var definePropertiesFallback = Object.defineProperties;
    }
  }
  if (!Object.defineProperty || definePropertyFallback) {
    var ERR_NON_OBJECT_DESCRIPTOR = 'Property description must be an object: ';
    var ERR_NON_OBJECT_TARGET = 'Object.defineProperty called on non-object: ';
    var ERR_ACCESSORS_NOT_SUPPORTED = 'getters & setters can not be defined on this javascript engine';
    Object.defineProperty = function defineProperty(object, property, descriptor) {
      if (isPrimitive(object)) {
        throw new TypeError(ERR_NON_OBJECT_TARGET + object);
      }
      if (isPrimitive(descriptor)) {
        throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR + descriptor);
      }
      if (definePropertyFallback) {
        try {
          return definePropertyFallback.call(Object, object, property, descriptor);
        } catch (exception) {}
      }
      if ('value' in descriptor) {
        if (supportsAccessors && (lookupGetter(object, property) || lookupSetter(object, property))) {
          var prototype = object.__proto__;
          object.__proto__ = prototypeOfObject;
          delete object[property];
          object[property] = descriptor.value;
          object.__proto__ = prototype;
        } else {
          object[property] = descriptor.value;
        }
      } else {
        var hasGetter = ('get' in descriptor);
        var hasSetter = ('set' in descriptor);
        if (!supportsAccessors && (hasGetter || hasSetter)) {
          return object;
        }
        // If we got that far then getters and setters can be defined !!
        if (hasGetter) {
          defineGetter(object, property, descriptor.get);
        }
        if (hasSetter) {
          defineSetter(object, property, descriptor.set);
        }
      }
      return object;
    };
  }
  if (!Object.defineProperties || definePropertiesFallback) {
    Object.defineProperties = function defineProperties(object, properties) {
      if (definePropertiesFallback) {
        try {
          return definePropertiesFallback.call(Object, object, properties);
        } catch (exception) {}
      }
      var keys = Object.keys(properties);
      for (var i = 0; i < keys.length; i++) {
        var property = keys[i];
        if (property !== '__proto__') {
          Object.defineProperty(object, property, properties[property]);
        }
      }
      return object;
    };
  }
  if (!Object.create) {
    var _createEmpty;
    var supportsProto = !({
      __proto__: null
    } instanceof Object);
    /* global ActiveXObject */
    var shouldUseActiveX = function shouldUseActiveX() {
      if (!document.domain) {
        return false;
      }
      try {
        return !!new ActiveXObject('htmlfile');
      } catch (exception) {
        return false;
      }
    };
    var getEmptyViaActiveX = function getEmptyViaActiveX() {
      var empty;
      var xDoc;
      xDoc = new ActiveXObject('htmlfile');
      var script = 'script';
      xDoc.write('<' + script + '></' + script + '>');
      xDoc.close();
      empty = xDoc.parentWindow.Object.prototype;
      xDoc = null;
      return empty;
    };
    var getEmptyViaIFrame = function getEmptyViaIFrame() {
      var iframe = document.createElement('iframe');
      var parent = document.body || document.documentElement;
      var empty;
      iframe.style.display = 'none';
      parent.appendChild(iframe);
      // eslint-disable-next-line no-script-url
      iframe.src = 'javascript:';
      empty = iframe.contentWindow.Object.prototype;
      parent.removeChild(iframe);
      iframe = null;
      return empty;
    };

    /* global document */
    if (supportsProto || typeof document === 'undefined') {
      _createEmpty = function createEmpty() {
        return {
          __proto__: null
        };
      };
    } else {
      _createEmpty = function createEmpty() {
        var empty = shouldUseActiveX() ? getEmptyViaActiveX() : getEmptyViaIFrame();
        delete empty.constructor;
        delete empty.hasOwnProperty;
        delete empty.propertyIsEnumerable;
        delete empty.isPrototypeOf;
        delete empty.toLocaleString;
        delete empty.toString;
        delete empty.valueOf;
        var Empty = function Empty() {};
        Empty.prototype = empty;
        // short-circuit future calls
        _createEmpty = function createEmpty() {
          return new Empty();
        };
        return new Empty();
      };
    }
    Object.create = function create(prototype, properties) {
      var object;
      var Type = function Type() {};
      if (prototype === null) {
        object = _createEmpty();
      } else {
        if (prototype !== null && isPrimitive(prototype)) {
          throw new TypeError('Object prototype may only be an Object or null');
        }
        Type.prototype = prototype;
        object = new Type();
        object.__proto__ = prototype;
      }
      if (properties !== void 0) {
        Object.defineProperties(object, properties);
      }
      return object;
    };
  }
  if (!Object.seal) {
    Object.seal = function seal(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.seal can only be called on Objects.');
      }
      return object;
    };
  }
  if (!Object.freeze) {
    Object.freeze = function freeze(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.freeze can only be called on Objects.');
      }
      return object;
    };
  }
  try {
    Object.freeze(function () {});
  } catch (exception) {
    Object.freeze = function (freezeObject) {
      return function freeze(object) {
        if (typeof object === 'function') {
          return object;
        }
        return freezeObject(object);
      };
    }(Object.freeze);
  }
  if (!Object.preventExtensions) {
    Object.preventExtensions = function preventExtensions(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.preventExtensions can only be called on Objects.');
      }
      return object;
    };
  }
  if (!Object.isSealed) {
    Object.isSealed = function isSealed(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.isSealed can only be called on Objects.');
      }
      return false;
    };
  }
  if (!Object.isFrozen) {
    Object.isFrozen = function isFrozen(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.isFrozen can only be called on Objects.');
      }
      return false;
    };
  }
  if (!Object.isExtensible) {
    Object.isExtensible = function isExtensible(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.isExtensible can only be called on Objects.');
      }
      var name = '';
      while (owns(object, name)) {
        name += '?';
      }
      object[name] = true;
      var returnValue = owns(object, name);
      delete object[name];
      return returnValue;
    };
  }
  if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) {
        // .length of function is 2
        'use strict';

        if (target == null) {
          // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }
  if (!Object.is) {
    Object.is = function (x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    };
  }
  if (!Object.values) {
    Object.values = function (obj) {
      var res = [];
      for (var i in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, i)) {
          res.push(obj[i]);
        }
      }
      return res;
    };
  }
  if (!Object.entries) {
    Object.entries = function (obj) {
      var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array

      while (i--) {
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
      }
      return resArray;
    };
  }
  if (!Object.hasOwn) {
    Object.hasOwn = function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    };
  }
})();

/*
if (window.Error && !Error.isError) {
    Error.Error = function(arg){
      if (!arg || (typeof arg !== "object" && typeof arg !== "function")) {
        return false; // step 1
      }

      if (typeof DOMError !== "undefined" && arg instanceof DOMError) {
        // Edge 80
        return true;
      }
      if (typeof DOMException !== "undefined" && arg instanceof DOMException) {
        return true;
      }
      return arg instanceof Error;
    }
}
*/

/**
 * polyfill for Array
 */
// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
if (!Array.prototype.forEach) {
  Object.defineProperty(Array.prototype, "forEach", {
    value: function value(callback, thisArg) {
      var T, k;
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.forEach called on null or undefined');
      }
      var O = Object(this);
      var len = O.length >>> 0;
      if (Object.prototype.toString.call(callback) != '[object Function]') {
        throw new TypeError(callback + ' is not a function');
      }
      if (arguments.length > 1) {
        T = thisArg;
      }
      k = 0;
      while (k < len) {
        var kValue;
        if (k in O) {
          kValue = O[k];
          callback.call(T, kValue, k, O);
        }
        k++;
      }
    }
  });
}

// form https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/every
if (!Array.prototype.every) {
  Object.defineProperty(Array.prototype, "every", {
    value: function value(callback) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.every called on null or undefined');
      }
      var O = Object(this);
      var len = O.length >>> 0;
      if (Object.prototype.toString.call(callback) != '[object Function]') {
        throw new TypeError(callback + ' is not a function');
      }
      var ctx = arguments.length >= 2 ? arguments[1] : void 0;
      for (var i = 0; i < len; i++) {
        if (i in O && !callback.call(ctx, O[i], i, O)) {
          return false;
        }
      }
      return true;
    }
  });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/fill
if (!Array.prototype.fill) {
  Object.defineProperty(Array.prototype, "fill", {
    value: function value(_value) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.fill called on null or undefined');
      }
      var O = Object(this);
      var len = O.length >>> 0;
      var start = arguments[1];
      var relativeStart = start >> 0;
      var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);
      var end = arguments[2];
      var relativeEnd = end === undefined ? len : end >> 0;
      var _final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);
      while (k < _final) {
        O[k] = _value;
        k++;
      }
      return O;
    }
  });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
if (!Array.prototype.filter) {
  Object.defineProperty(Array.prototype, "filter", {
    value: function value(callback) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.filter called on null or undefined');
      }
      var O = Object(this);
      var len = O.length >>> 0;
      if (Object.prototype.toString.call(callback) != '[object Function]') {
        throw new TypeError(callback + ' is not a function');
      }
      var res = [];
      var ctx = arguments.length >= 2 ? arguments[1] : void 0;
      for (var i = 0; i < len; i++) {
        if (i in O) {
          var val = O[i];
          if (callback.call(ctx, val, i, O)) {
            res.push(val);
          }
        }
      }
      return res;
    }
  });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
if (!Array.prototype.indexOf) {
  Object.defineProperty(Array.prototype, "indexOf", {
    value: function value(searchElement, fromIndex) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.indexOf called on null or undefined');
      }
      var k;
      var O = Object(this);
      var len = O.length >>> 0;
      if (len === 0) {
        return -1;
      }
      var n = fromIndex | 0;
      if (n >= len) {
        return -1;
      }
      k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
      while (k < len) {
        if (k in O && O[k] === searchElement) {
          return k;
        }
        k++;
      }
      return -1;
    }
  });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/lastIndexOf
if (!Array.prototype.lastIndexOf) {
  Object.defineProperty(Array.prototype, "lastIndexOf", {
    value: function value(searchElement) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.lastIndexOf called on null or undefined');
      }
      var n, k;
      var t = Object(this);
      var len = t.length >>> 0;
      if (len === 0) {
        return -1;
      }
      n = len - 1;
      if (arguments.length > 1) {
        n = Number(arguments[1]);
        if (n !== n) {
          n = 0;
        } else if (n != 0 && n != 1 / 0 && n != -(1 / 0)) {
          n = (n > 0 || -1) * Math.floor(Math.abs(n));
        }
      }
      k = n >= 0 ? Math.min(n, len - 1) : len - Math.abs(n);
      for (; k >= 0; k--) {
        if (k in t && t[k] === searchElement) {
          return k;
        }
      }
      return -1;
    }
  });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/map
if (!Array.prototype.map) {
  Object.defineProperty(Array.prototype, "map", {
    value: function value(callback, thisArg) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.map called on null or undefined');
      }
      var T, A, k;
      var O = Object(this);
      var len = O.length >>> 0;
      if (Object.prototype.toString.call(callback) !== '[object Function]') {
        throw new TypeError(callback + ' is not a function');
      }
      if (thisArg) {
        T = thisArg;
      }
      A = new Array(len);
      k = 0;
      while (k < len) {
        var kValue, mappedValue;
        if (k in O) {
          kValue = O[k];
          mappedValue = callback.call(T, kValue, k, O);
          A[k] = mappedValue;
        }
        k++;
      }
      return A;
    }
  });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
if (!Array.prototype.reduce) {
  Object.defineProperty(Array.prototype, "reduce", {
    value: function value(callback) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.reduce called on null or undefined');
      }
      if (Object.prototype.toString.call(callback) !== '[object Function]') {
        throw new TypeError(callback + ' is not a function');
      }
      var t = Object(this),
        len = t.length >>> 0,
        k = 0,
        value;
      if (arguments.length >= 2) {
        value = arguments[1];
      } else {
        while (k < len && !(k in t)) {
          k++;
        }
        if (k >= len) {
          throw new TypeError('Reduce of empty array with no initial value');
        }
        value = t[k++];
      }
      for (; k < len; k++) {
        if (k in t) {
          value = callback(value, t[k], k, t);
        }
      }
      return value;
    }
  });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/ReduceRight
if (!Array.prototype.reduceRight) {
  Object.defineProperty(Array.prototype, "reduceRight", {
    value: function value(callback) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.reduceRight called on null or undefined');
      }
      if (Object.prototype.toString.call(callback) !== '[object Function]') {
        throw new TypeError(callback + ' is not a function');
      }
      var t = Object(this),
        len = t.length >>> 0,
        k = len - 1,
        value;
      if (arguments.length >= 2) {
        value = arguments[1];
      } else {
        while (k >= 0 && !(k in t)) {
          k--;
        }
        if (k < 0) {
          throw new TypeError('Reduce of empty array with no initial value');
        }
        value = t[k--];
      }
      for (; k >= 0; k--) {
        if (k in t) {
          value = callback(value, t[k], k, t);
        }
      }
      return value;
    }
  });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/some
if (!Array.prototype.some) {
  Object.defineProperty(Array.prototype, "some", {
    value: function value(callback) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.reduceRight called on null or undefined');
      }
      if (Object.prototype.toString.call(callback) !== '[object Function]') {
        throw new TypeError(callback + ' is not a function');
      }
      var t = Object(this);
      var len = t.length >>> 0;
      var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
      for (var i = 0; i < len; i++) {
        if (i in t && callback.call(thisArg, t[i], i, t)) {
          return true;
        }
      }
      return false;
    }
  });
}
if (!Array.from) {
  Array.from = function () {
    var toStr = Object.prototype.toString;
    var isCallable = function isCallable(fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function toInteger(value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function toLength(value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method 
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }();
}

/**
 * Array.prototype.keys()
 * version 0.0.0
 * Feature	        Chrome  Firefox Internet Explorer   Opera	Safari	Edge
 * Basic support	  38      28      (No)    	          25    7.1     (Yes)
 * -------------------------------------------------------------------------------
 */
if (!Array.prototype.keys) {
  Object.defineProperty(Array.prototype, "keys", {
    value: function value() {
      function Iterator() {}
      Iterator.prototype.next = function () {
        if (index > selfThis.length - 1) {
          done = true;
        }
        if (done) {
          return {
            value: undefined,
            done: true
          };
        }
        return {
          value: index++,
          done: false
        };
      };
      var selfThis = this;
      var index = 0;
      var done;
      return new Iterator();
    }
  });
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/entries
if (!Array.prototype.entries) {
  Object.defineProperty(Array.prototype, "entries", {
    value: function value() {
      function Iterator() {}
      Iterator.prototype.next = function () {
        if (index < selfThis.length) {
          return {
            value: [index, selfThis[index++]],
            done: false
          };
        } else {
          return {
            done: true
          };
        }
      };
      var selfThis = this;
      var index = 0;
      return new Iterator();
    }
  });
}
if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, "at", {
    value: function value(n) {
      n = Math.trunc(n) || 0;
      if (n < 0) {
        n += this.length;
      }
      if (n < 0 || n >= this.length) {
        return undefined;
      }
      return this[n];
    }
  });
}
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    },
    configurable: true,
    writable: true
  });
}
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw TypeError('"this" is null or not defined');
      }
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}

//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLast
if (!Array.prototype.findLast) {
  Object.defineProperty(Array.prototype, 'findLast', {
    value: function findLast(callbackFn, thisArg) {
      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.findLast called on null or undefined');
      }
      if (Object.prototype.toString.call(callbackFn) !== '[object Function]') {
        throw new TypeError(callbackFn + ' is not a function');
      }
      var arr = Object(this);
      var len = arr.length >>> 0;
      var k = len - 1;
      while (k >= 0) {
        var kValue = arr[k];
        if (callbackFn.call(thisArg, kValue, k, arr)) {
          return kValue;
        }
        k--;
      }
      return undefined;
    }
  });
}

//https://github.com/kevlatus/polyfill-array-includes/blob/master/array-includes.js
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function value(searchElement, fromIndex) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
      function sameValueZero(x, y) {
        return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}
// https://dev.to/chandrapenugonda/polyfill-arrayflat-3ipb
if (!Array.prototype.flat) {
  Object.defineProperty(Array.prototype, "flat", {
    value: function value(depth) {
      var flattened = [];
      function flatten(arr, currentDepth) {
        for (var i = 0; i < arr.length; i++) {
          if (Array.isArray(arr[i]) && currentDepth < depth) {
            flatten(arr[i], currentDepth + 1);
          } else {
            flattened.push(arr[i]);
          }
        }
      }
      flatten(this, 0);
      return flattened;
    }
  });
}
if (!Array.prototype.flatMap) {
  Object.defineProperty(Array.prototype, "flatMap", {
    value: function value() {
      return Array.prototype.map.apply(this, arguments).flat();
    }
  });
}
// https://12daysofweb.dev/2023/new-js-array-methods/
if (!Array.prototype.toReversed) {
  Object.defineProperty(Array.prototype, "toReversed", {
    value: function value() {
      return Array.from(this).reverse();
    }
  });
}
if (!Array.prototype.toSpliced) {
  Object.defineProperty(Array.prototype, "toSpliced", {
    value: function value(start, end) {
      var clone = Array.from(this);
      clone.splice(start, end);
      return clone;
    }
  });
}
if (!Array.prototype.toSorted) {
  Object.defineProperty(Array.prototype, "toSorted", {
    value: function value(compareFn) {
      return Array.from(this).sort(compareFn);
    }
  });
}
if (!Array.prototype["with"]) {
  Object.defineProperty(Array.prototype, "with", {
    value: function value(index, _value2) {
      var clone = Array.from(this);
      clone[index] = _value2;
      return clone;
    }
  });
}
//----------------------------------------------------------------------
//
// CSSOM View Module
// https://dev.w3.org/csswg/cssom-view/
//
//----------------------------------------------------------------------

// Fix for IE8-'s Element.getBoundingClientRect()
(function (global) {
  if ('TextRectangle' in global && !('width' in global.TextRectangle.prototype)) {
    Object.defineProperties(global.TextRectangle.prototype, {
      'width': {
        get: function get() {
          return this.right - this.left;
        }
      },
      'height': {
        get: function get() {
          return this.bottom - this.top;
        }
      }
    });
  }
})(window);
/**
 * polyfill for Date
 */

// from https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Date/now
if (!Date.now) {
  Date.now = function now() {
    return new Date().getTime();
  };
}

// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString
if (!Date.prototype.toISOString) {
  (function () {
    function pad(number) {
      if (number < 10) {
        return '0' + number;
      }
      return number;
    }
    Date.prototype.toISOString = function () {
      return this.getUTCFullYear() + '-' + pad(this.getUTCMonth() + 1) + '-' + pad(this.getUTCDate()) + 'T' + pad(this.getUTCHours()) + ':' + pad(this.getUTCMinutes()) + ':' + pad(this.getUTCSeconds()) + '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
    };
  })();
}
/**
 * polyfill for DOM
 */

(function (global) {
  if (!('document' in global)) {
    return;
  }
  var document = global.document;

  // IE8- document.getElementsByClassName
  if (!document.getElementsByClassName && document.querySelectorAll) {
    var getElementsByClassName = function getElementsByClassName(classNames) {
      classNames = String(classNames).replace(/^|\s+/g, '.');
      return this.querySelectorAll(classNames);
    };
    void [HTMLDocument, Element].forEach(function (o) {
      o.prototype.getElementsByClassName = getElementsByClassName;
    });
  }

  // IE CustomEvent
  if (!('CustomEvent' in global) || typeof global.CustomEvent !== 'function') {
    var CustomEvent = function CustomEvent(event, params) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined
      };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    };
    CustomEvent.prototype = global.Event.prototype;
    global.CustomEvent = CustomEvent;
  }
  var NativeProgressEvent = global.ProgressEvent;
  var useNative = !!NativeProgressEvent;
  try {
    (function () {
      var p = new NativeProgressEvent('loaded');
      useNative = 'loaded' === p.type;
      p = null;
    })();
  } catch (e) {
    useNative = false;
  }

  /**
   * Cross-browser `ProgressEvent` constructor.
   *
   * https://developer.mozilla.org/en-US/docs/Web/API/ProgressEvent.ProgressEvent
   *
   * @public
   */
  if (!useNative) {
    global.ProgressEvent =
    // IE >= 9
    'function' === typeof document.createEvent ? function (type, props) {
      var e = document.createEvent('Event');
      e.initEvent(type, false, false);
      if (props) {
        e.lengthComputable = Boolean(props.lengthComputable);
        e.loaded = Number(props.loaded) || 0;
        e.total = Number(props.total) || 0;
      } else {
        e.lengthComputable = false;
        e.loaded = e.total = 0;
      }
      return e;
    } :
    // IE <= 8
    function (type, props) {
      var e = document.createEventObject();
      e.type = type;
      if (props) {
        e.lengthComputable = Boolean(props.lengthComputable);
        e.loaded = Number(props.loaded) || 0;
        e.total = Number(props.total) || 0;
      } else {
        e.lengthComputable = false;
        e.loaded = e.total = 0;
      }
      return e;
    };
  }

  // Element.matches
  // from https://developer.mozilla.org/en/docs/Web/API/Element/matches
  (function () {
    if (!('Element' in global) || Element.prototype.matches) {
      return;
    }
    var matchesVenders = ['ms', 'o', 'moz', 'webkit'];
    var matchesSelectorSuffix = 'MatchesSelector';
    for (var i = 0; i < matchesVenders.length; i++) {
      var matchesSelector = matchesVenders[i] + matchesSelectorSuffix;
      if (matchesSelector in Element.prototype) {
        Element.prototype.matches = Element.prototype[matchesSelector];
        return;
      }
    }
    if (document.querySelectorAll) {
      Element.prototype.matches = function matches(selector) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(selector);
        var i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
    }
  })();
  if (!document.querySelector) {
    document.querySelector = function (selectors) {
      var elements = document.querySelectorAll(selectors);
      return elements.length ? elements[0] : null;
    };
  }

  // Node.textContent
  if (Object.defineProperty && Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(Element.prototype, 'textContent') && !Object.getOwnPropertyDescriptor(Element.prototype, 'textContent').get) {
    (function () {
      var innerText = Object.getOwnPropertyDescriptor(Element.prototype, 'innerText');
      Object.defineProperty(Element.prototype, 'textContent', {
        get: function get() {
          return innerText.get.call(this);
        },
        set: function set(s) {
          innerText.set.call(this, s);
        }
      });
    })();
  }
})(window);

/**
 * polyfill for DOM Event
 */

// from https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Event/polyfill.js
(function (global) {
  if ('Event' in global && typeof global.Event === 'function') {
    return;
  }
  var unlistenableWindowEvents = {
    click: 1,
    dblclick: 1,
    keyup: 1,
    keypress: 1,
    keydown: 1,
    mousedown: 1,
    mouseup: 1,
    mousemove: 1,
    mouseover: 1,
    mouseenter: 1,
    mouseleave: 1,
    mouseout: 1,
    storage: 1,
    storagecommit: 1,
    textinput: 1
  };
  var existingProto = global.Event && global.Event.prototype || null;
  global.Event = Window.prototype.Event = function Event(type, eventInitDict) {
    if (!type) {
      throw new Error('Not enough arguments');
    }
    var event;
    if ('createEvent' in document) {
      event = document.createEvent('Event');
      var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
      var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
      event.initEvent(type, bubbles, cancelable);
      return event;
    }
    event = document.createEventObject();
    event.type = type;
    event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
    event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
    return event;
  };
  if (existingProto) {
    Object.defineProperty(global.Event, 'prototype', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: existingProto
    });
  }
  if (!('createEvent' in document)) {
    var addEventListener = function addEventListener(type, listener) {
      var element = this;
      if (element === global && type in unlistenableWindowEvents) {
        throw new Error('In IE8 the event: ' + type + ' is not available on the window object.');
      }
      if (!element._events) {
        element._events = {};
      }
      if (!element._events[type]) {
        element._events[type] = function (event) {
          var list = element._events[event.type].list;
          var events = list.slice();
          var index = -1;
          var length = events.length;
          var eventElement;
          event.preventDefault = function preventDefault() {
            if (event.cancelable !== false) {
              event.returnValue = false;
            }
          };
          event.stopPropagation = function stopPropagation() {
            event.cancelBubble = true;
          };
          event.stopImmediatePropagation = function stopImmediatePropagation() {
            event.cancelBubble = true;
            event.cancelImmediate = true;
          };
          event.currentTarget = element;
          event.target = event.target || event.srcElement || element;
          event.relatedTarget = event.fromElement ? event.fromElement === event.target ? event.toElement : event.fromElement : null;
          event.timeStamp = new Date().getTime();
          if (event.clientX) {
            event.pageX = event.clientX + document.documentElement.scrollLeft;
            event.pageY = event.clientY + document.documentElement.scrollTop;
          }
          while (++index < length && !event.cancelImmediate) {
            if (index in events) {
              eventElement = events[index];
              if (list.indexOf(eventElement) !== -1 && typeof eventElement === 'function') {
                eventElement.call(element, event);
              }
            }
          }
        };
        element._events[type].list = [];
        if (element.attachEvent) {
          element.attachEvent('on' + type, element._events[type]);
        }
      }
      element._events[type].list.push(listener);
    };
    var removeEventListener = function removeEventListener(type, listener) {
      var element = this;
      var index;
      if (element._events && element._events[type] && element._events[type].list) {
        index = element._events[type].list.indexOf(listener);
        if (index !== -1) {
          element._events[type].list.splice(index, 1);
          if (!element._events[type].list.length) {
            if (element.detachEvent) {
              element.detachEvent('on' + type, element._events[type]);
            }
            delete element._events[type];
          }
        }
      }
    };
    var dispatchEvent = function dispatchEvent(event) {
      if (!arguments.length) {
        throw new Error('Not enough arguments');
      }
      if (!event || typeof event.type !== 'string') {
        throw new Error('DOM Events Exception 0');
      }
      var element = this,
        type = event.type;
      try {
        if (!event.bubbles) {
          event.cancelBubble = true;
          var cancelBubbleEvent = function cancelBubbleEvent(event) {
            event.cancelBubble = true;
            (element || window).detachEvent('on' + type, cancelBubbleEvent);
          };
          this.attachEvent('on' + type, cancelBubbleEvent);
        }
        this.fireEvent('on' + type, event);
      } catch (error) {
        event.target = element;
        do {
          event.currentTarget = element;
          if ('_events' in element && typeof element._events[type] === 'function') {
            element._events[type].call(element, event);
          }
          if (typeof element['on' + type] === 'function') {
            element['on' + type].call(element, event);
          }
          element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
        } while (element && !event.cancelBubble);
      }
      return true;
    };
    void [Window, HTMLDocument, Element].forEach(function (o) {
      o.prototype.addEventListener = addEventListener;
      o.prototype.removeEventListener = removeEventListener;
      o.prototype.dispatchEvent = dispatchEvent;
    });

    // 添加DOMContentLoaded事件
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState === 'complete') {
        document.dispatchEvent(new Event('DOMContentLoaded', {
          bubbles: true
        }));
      }
    });
  }
})(window);

/*
 * Node.isConnected polyfill for EdgeHTML
 * 2021-04-12
 *
 * By Eli Grey, https://eligrey.com
 * Public domain.
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 */

if (!('isConnected' in Node.prototype)) {
  Object.defineProperty(Node.prototype, 'isConnected', {
    get: function get() {
      return !this.ownerDocument || !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
    }
  });
}

/**
 * polyfill for getComputedStyle
 */

// from https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/getComputedStyle/polyfill.js
(function (global) {
  if ('getComputedStyle' in global && typeof global.getComputedStyle === 'function') {
    return;
  }
  function getPixelSize(element, style, property, fontSize) {
    var sizeWithSuffix = style[property];
    var size = parseFloat(sizeWithSuffix);
    var suffix = sizeWithSuffix.split(/\d/)[0];
    var rootSize;
    fontSize = fontSize !== null ? fontSize : /%|em/.test(suffix) && element.parentElement ? getPixelSize(element.parentElement, element.parentElement.currentStyle, 'fontSize', null) : 16;
    rootSize = property === 'fontSize' ? fontSize : /width/i.test(property) ? element.clientWidth : element.clientHeight;
    return suffix === 'em' ? size * fontSize : suffix === 'in' ? size * 96 : suffix === 'pt' ? size * 96 / 72 : suffix === '%' ? size / 100 * rootSize : size;
  }
  function setShortStyleProperty(style, property) {
    var borderSuffix = property === 'border' ? 'Width' : '';
    var t = property + 'Top' + borderSuffix;
    var r = property + 'Right' + borderSuffix;
    var b = property + 'Bottom' + borderSuffix;
    var l = property + 'Left' + borderSuffix;
    style[property] = (style[t] == style[r] == style[b] == style[l] ? [style[t]] : style[t] == style[b] && style[l] == style[r] ? [style[t], style[r]] : style[l] == style[r] ? [style[t], style[r], style[b]] : [style[t], style[r], style[b], style[l]]).join(' ');
  }
  function CSSStyleDeclaration(element) {
    var currentStyle = element.currentStyle || {};
    var style = this;
    var fontSize = getPixelSize(element, currentStyle, 'fontSize', null);
    for (var property in currentStyle) {
      if (/width|height|margin.|padding.|border.+W/.test(property) && style[property] !== 'auto') {
        style[property] = getPixelSize(element, currentStyle, property, fontSize) + 'px';
      } else if (property === 'styleFloat') {
        style['float'] = currentStyle[property];
      } else {
        style[property] = currentStyle[property];
      }
    }
    setShortStyleProperty(style, 'margin');
    setShortStyleProperty(style, 'padding');
    setShortStyleProperty(style, 'border');
    style.fontSize = fontSize + 'px';
    return style;
  }
  CSSStyleDeclaration.prototype = {
    constructor: CSSStyleDeclaration,
    getPropertyPriority: function getPropertyPriority() {},
    getPropertyValue: function getPropertyValue(prop) {
      return this[prop] || '';
    },
    item: function item() {},
    removeProperty: function removeProperty() {},
    setProperty: function setProperty() {},
    getPropertyCSSValue: function getPropertyCSSValue() {}
  };
  global.getComputedStyle = function (node) {
    return new CSSStyleDeclaration(node);
  };
})(window);

// polyfill for :scope
try {
  // test for scope support
  document.querySelector(':scope *');
} catch (error) {
  (function (ElementPrototype) {
    // scope regex
    var scope = /:scope(?![\w-])/gi;

    // polyfill Element#querySelector
    var querySelectorWithScope = polyfill(ElementPrototype.querySelector);
    ElementPrototype.querySelector = function querySelector(selectors) {
      return querySelectorWithScope.apply(this, arguments);
    };

    // polyfill Element#querySelectorAll
    var querySelectorAllWithScope = polyfill(ElementPrototype.querySelectorAll);
    ElementPrototype.querySelectorAll = function querySelectorAll(selectors) {
      return querySelectorAllWithScope.apply(this, arguments);
    };

    // polyfill Element#matches
    if (ElementPrototype.matches) {
      var matchesWithScope = polyfill(ElementPrototype.matches);
      ElementPrototype.matches = function matches(selectors) {
        return matchesWithScope.apply(this, arguments);
      };
    }

    // polyfill Element#closest
    if (ElementPrototype.closest) {
      var closestWithScope = polyfill(ElementPrototype.closest);
      ElementPrototype.closest = function closest(selectors) {
        return closestWithScope.apply(this, arguments);
      };
    }
    function polyfill(qsa) {
      return function (selectors) {
        // whether the selectors contain :scope
        var hasScope = selectors && scope.test(selectors);
        if (hasScope) {
          // fallback attribute
          var attr = 'q' + Math.floor(Math.random() * 9000000) + 1000000;

          // replace :scope with the fallback attribute
          arguments[0] = selectors.replace(scope, '[' + attr + ']');

          // add the fallback attribute
          this.setAttribute(attr, '');

          // results of the qsa
          var elementOrNodeList = qsa.apply(this, arguments);

          // remove the fallback attribute
          this.removeAttribute(attr);

          // return the results of the qsa
          return elementOrNodeList;
        } else {
          // return the results of the qsa
          return qsa.apply(this, arguments);
        }
      };
    }
  })(Element.prototype);
}
/**
 * polyfill for IE8 in HTML
 * https://html.spec.whatwg.org
 */

// document.head
try {
  document.head = document.head || document.getElementsByTagName('head')[0];
} catch (e) {}

// HTML Tag shiv
void ['abbr', 'article', 'aside', 'audio', 'bdi', 'canvas', 'data', 'datalist', 'details', 'dialog', 'figcaption', 'figure', 'footer', 'header', 'hgroup', 'main', 'mark', 'meter', 'nav', 'output', 'picture', 'progress', 'section', 'summary', 'template', 'time', 'video'].forEach(function (tag) {
  document.createElement(tag);
});
/**
 * polyfill for String
 */

if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return String(this).replace(/^\s+/, '').replace(/\s+$/, '');
  };
}

// endsWiths
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}
// startsWith
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (search, pos) {
    return this.substring(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}
//https://github.com/FabioVergani/js-Polyfill_String-trimStart
(function (o, p) {
  if (p in o ? o[p] ? false : true : true) {
    var r = /^\s+/;
    o[p] = o.trimLeft || function () {
      return this.replace(r, '');
    };
  }
})(window.String.prototype, 'trimStart');
// trim end
if (!String.prototype.trimEnd) {
  String.prototype.trimEnd = function () {
    return this.replace(new RegExp(/[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/.source + '$', 'g'), '');
  };
}
// repeat
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
if (!String.prototype.repeat) {
  String.prototype.repeat = function (count) {
    'use strict';

    if (this == null) {
      throw new TypeError('can\'t convert ' + this + ' to object');
    }
    var str = '' + this;
    // To convert string to integer.
    count = +count;
    // Check NaN
    if (count != count) {
      count = 0;
    }
    if (count < 0) {
      throw new RangeError('repeat count must be non-negative');
    }
    if (count == Infinity) {
      throw new RangeError('repeat count must be less than infinity');
    }
    count = Math.floor(count);
    if (str.length == 0 || count == 0) {
      return '';
    }

    // Ensuring count is a 31-bit integer allows us to heavily optimize the
    // main part. But anyway, most current (August 2014) browsers can't handle
    // strings 1 << 28 chars or longer, so:
    if (str.length * count >= 1 << 28) {
      throw new RangeError('repeat count must not overflow maximum string size');
    }
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while (count) {
      str += str;
      count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
  };
}
// https://github.com/behnammodi/polyfill/blob/master/string.polyfill.js
if (!String.prototype.padStart) {
  Object.defineProperty(String.prototype, 'padStart', {
    configurable: true,
    writable: true,
    value: function value(targetLength, padString) {
      targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
      padString = String(typeof padString !== 'undefined' ? padString : ' ');
      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
          padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
        }

        return padString.slice(0, targetLength) + String(this);
      }
    }
  });
}
// https://github.com/behnammodi/polyfill/blob/master/string.polyfill.js
if (!String.prototype.padEnd) {
  Object.defineProperty(String.prototype, 'padEnd', {
    configurable: true,
    writable: true,
    value: function value(targetLength, padString) {
      targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
      padString = String(typeof padString !== 'undefined' ? padString : ' ');
      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
          padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
        }

        return String(this) + padString.slice(0, targetLength);
      }
    }
  });
}
if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) {
      start = 0;
    }
    return this.indexOf(search, start) !== -1;
  };
}

/**
 * Polyfill for Viewport
 */

(function (global) {
  if ('innerWidth' in global && 'innerHeight' in global && 'pageXOffset' in global && 'pageYOffset' in global) {
    return;
  }
  var doc = global.document;
  var docEl = doc.documentElement;
  var body = doc.body || doc.createElement('body');
  function scrollX() {
    return (docEl.scrollLeft || body.scrollLeft || 0) - (docEl.clientLeft || body.clientLeft || 0);
  }
  function scrollY() {
    return (docEl.scrollTop || body.scrollTop || 0) - (docEl.clientTop || body.clientTop || 0);
  }
  Object.defineProperties(global, {
    innerWidth: {
      get: function get() {
        return docEl.clientWidth;
      }
    },
    innerHeight: {
      get: function get() {
        return docEl.clientHeight;
      }
    },
    pageXOffset: {
      get: scrollX
    },
    pageYOffset: {
      get: scrollY
    },
    scrollX: {
      get: scrollX
    },
    scrollY: {
      get: scrollY
    }
  });
})(window);

/**
 * Polyfill for Math
 */
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log10
Math.log10 = Math.log10 || function (x) {
  return Math.log(x) * Math.LOG10E;
};

/**
 * Polyfill Set
 */
// IE11 has an incomplete implementation of Set which doesn't allow you to iterate the keys
// so this code assumes you want a full implementation and will redefine Set if the half
// implementation is present
if (typeof Set === "undefined" || typeof Set.prototype.keys !== "function") {
  var Set = function () {
    "use strict";

    var iterables = {
      "[object Array]": true,
      "[object Arguments]": true,
      "[object HTMLCollection]": true,
      "[object NodeList]": true
    };

    // shortcuts
    var hasOwn = Object.prototype.hasOwnProperty;
    var toString = Object.prototype.toString;
    function hasOwnProp(obj, prop) {
      return hasOwn.call(obj, prop);
    }
    function isIterable(item) {
      // for purposes of this implementation, an iterable is anything we can iterate with
      // a classic for loop:
      //     for (var i = 0; i < item.length; i++)
      // Currently accepts: array, arguments object, HTMLCollection, NodeList
      // and anything that has a .length with a numeric value and, if .length > 0, the first item has a nodeType property
      var name;
      if (_typeof2(item) === "object") {
        name = toString.call(item);
        return iterables[name] === true || typeof item.length === "number" && item.length >= 0 && (item.length === 0 || _typeof2(item[0]) === "object" && item[0].nodeType > 0);
      }
      return false;
    }

    // decide if we can use Object.defineProperty
    // include a test for Object.defineProperties (which IE8 does not have) to eliminate
    // using the broken Object.defineProperty in IE8
    var canDefineProperty = Object.defineProperty && Object.defineProperties;
    function setProperty(obj, propName, value, enumerable, writable) {
      if (canDefineProperty) {
        Object.defineProperty(obj, propName, {
          enumerable: enumerable,
          configurable: false,
          writable: writable,
          value: value
        });
      } else {
        obj[propName] = value;
      }
    }

    // this private function is used like a private method for setting
    // the .size property.  It cannot be called from outside this closure.
    var settable = false;
    function setSize(obj, val) {
      settable = true;
      obj.size = val;
      settable = false;
    }

    // this is the constructor function which will be returned
    // from this closure
    function SetConstructor(arg) {
      // private member variable, not used if IE8
      var size = 0;

      // set properties in cross-browser way
      setProperty(this, "baseType", "Set", false, false); // not enumerable, not writeable
      setProperty(this, "_data", {}, false, true); // not enumerable, writeable
      if (canDefineProperty) {
        Object.defineProperty(this, "size", {
          enumerable: true,
          configurable: false,
          get: function get() {
            return size;
          },
          set: function set(val) {
            if (!settable) {
              throw new Error("Can't set size property on Set object.");
            }
            size = val;
          }
        });
      } else {
        // .size is just regular property in IE8
        this.size = 0;
      }
      // now add initial data
      // per spec make sure it isn't undefined or null
      if (arg !== undefined && arg !== null) {
        if (isIterable(arg)) {
          for (var i = 0; i < arg.length; i++) {
            this.add(arg[i]);
          }
          // also check our own custom property in case
          // there is cross window code that won't pass instanceof
        } else if (arg instanceof Set || arg.baseType === "Set") {
          arg.forEach(function (item) {
            this.add(item);
          }, this);
        }
      }
    }

    // state variables and shared constants
    var objectCntr = 0;
    var objectCntrBase = "obj_";
    var objectCntrProp = "__objectPolyFillID";

    // types where we just use the first 3 letters of the type
    // plus underscore + toString() to make the key
    // The first 3 letters of the type makes a namespace for each
    // type so we can have things like 0 and "0" as separate keys
    // "num_0" and "str_0".
    var autoTypes = {
      "string": true,
      "boolean": true,
      "number": true,
      "undefined": true
    };
    function getKey(val, putKeyOnObject) {
      // manufacture a namespaced key
      var type = _typeof2(val),
        id;
      if (autoTypes[type]) {
        return type.substring(0, 3) + "_" + val;
      } else if (val === null) {
        return "nul_null";
      } else if (type === "object" || type === "function") {
        // coin a unique id for each object and store it on the object
        if (val[objectCntrProp]) {
          return val[objectCntrProp];
        } else if (!putKeyOnObject) {
          // it only returns null if there is no key already on the object
          // and it wasn't requested to create a new key on the object
          return null;
        } else {
          // coin a unique id for the object
          id = objectCntrBase + objectCntr++;
          // include a test for Object.defineProperties to rule out IE8 
          // which can't use Object.defineProperty on normal JS objects
          if (toString.call(val) === "[object Object]" && canDefineProperty) {
            Object.defineProperty(val, objectCntrProp, {
              enumerable: false,
              configurable: false,
              writable: false,
              value: id
            });
          } else {
            // no Object.defineProperty() or not plain object, so just assign property directly
            val[objectCntrProp] = id;
          }
          return id;
        }
      } else {
        throw new Error("Unsupported type for Set.add()");
      }
    }
    function SetIterator(keys, data, format) {
      var index = 0,
        len = keys.length;
      this.next = function () {
        var val,
          result = {},
          key;
        while (true) {
          if (index < len) {
            result.done = false;
            key = keys[index++];
            val = data[key];
            // check to see if key might have been removed
            // undefined is a valid value in the set so we have to check more than that
            // if it is no longer in the set, get the next key
            if (val === undefined && !hasOwnProp(data, key)) {
              continue;
            }
            if (format === "keys") {
              result.value = val;
            } else if (format === "entries") {
              result.value = [val, val];
            }
          } else {
            // clear references to outside data
            keys = null;
            data = null;
            result.done = true;
          }
          return result;
        }
      };
    }
    function getKeys(data) {
      var keys = [];
      for (var prop in data) {
        if (hasOwnProp(data, prop)) {
          keys.push(prop);
        }
      }
      return keys;
    }
    SetConstructor.prototype = {
      add: function add(val) {
        var key = getKey(val, true);
        if (!hasOwnProp(this._data, key)) {
          this._data[key] = val;
          setSize(this, this.size + 1);
        }
        return this;
      },
      clear: function clear() {
        this._data = {};
        setSize(this, 0);
      },
      // delete has to be in quotes for IE8 - go figure
      "delete": function _delete(val) {
        var key = getKey(val, false);
        if (key !== null && hasOwnProp(this._data, key)) {
          delete this._data[key];
          setSize(this, this.size - 1);
          return true;
        }
        return false;
      },
      // .remove() is non-standard, but here for anyone who wants to use it
      // so that you can use this polyfill all the way down to IE7 and IE8
      // since IE8 can't use a method named .delete()
      remove: function remove(val) {
        return this["delete"](val);
      },
      forEach: function forEach(fn /*, context */) {
        // by spec, we have to type check the fn argument
        if (typeof fn !== "function") {
          return;
        }

        // context argument is optional, but .forEach.length is supposed to be 1 by spec
        // so we declare it this way
        var context = arguments[1];

        // forEach specifies that the iteration set is
        // determined before the first callback so we get all the
        // keys first
        var iter = this.keys(),
          next,
          item;
        while ((next = iter.next()) && !next.done) {
          item = next.value;
          fn.call(context, item, item, this);
        }
      },
      has: function has(val) {
        var key = getKey(val, false);
        if (key === null) {
          return false;
        }
        return hasOwn.call(this._data, key);
      },
      values: function values() {
        return this.keys();
      },
      keys: function keys() {
        return new SetIterator(getKeys(this._data), this._data, "keys");
      },
      entries: function entries() {
        return new SetIterator(getKeys(this._data), this._data, "entries");
      }
    };
    SetConstructor.prototype.constructor = SetConstructor;
    return SetConstructor;
  }();
}
if (!Set.prototype.difference) {
  Set.prototype.difference = function (other) {
    if (other === null || _typeof2(other) !== "object") {
      throw new TypeError("Set.prototype.difference argument must be an object");
    }
    if (typeof other.size !== "number") {
      throw new TypeError("The .size property is NaN");
    }
    var result = new Set();
    this.forEach(function (item) {
      if (!other.has(item)) {
        result.add(item);
      }
    });
    return result;
  };
}
if (!Set.prototype.intersection) {
  Set.prototype.intersection = function (other) {
    if (other === null || _typeof2(other) !== "object") {
      throw new TypeError("Set.prototype.intersection argument must be an object");
    }
    if (typeof other.size !== "number") {
      throw new TypeError("The .size property is NaN");
    }
    var result = new Set();
    this.forEach(function (item) {
      if (other.has(item)) {
        result.add(item);
      }
    });
    return result;
  };
}
if (!Set.prototype.symmetricDifference) {
  Set.prototype.symmetricDifference = function (other) {
    if (other === null || _typeof2(other) !== "object") {
      throw new TypeError("Set.prototype.symmetricDifference argument must be an object");
    }
    if (typeof other.size !== "number") {
      throw new TypeError("The .size property is NaN");
    }
    var result = new Set(this);
    var entries = other.keys();
    var iterator = entries.next();
    while (!iterator.done) {
      if (result.has(iterator.value)) {
        result["delete"](iterator.value);
      } else {
        result.add(iterator.value);
      }
      iterator = entries.next();
    }
    return result;
  };
}
if (!Set.prototype.union) {
  Set.prototype.union = function (other) {
    if (other === null || _typeof2(other) !== "object") {
      throw new TypeError("Set.prototype.union argument must be an object");
    }
    if (typeof other.size !== "number") {
      throw new TypeError("The .size property is NaN");
    }
    var result = new Set(this);
    var entries = other.keys();
    var iterator = entries.next();
    while (!iterator.done) {
      result.add(iterator.value);
      iterator = entries.next();
    }
    return result;
  };
}
if (!Set.prototype.isDisjointFrom) {
  Set.prototype.isDisjointFrom = function (other) {
    if (other === null || _typeof2(other) !== "object") {
      throw new TypeError("Set.prototype.isDisjointFrom argument must be an object");
    }
    if (typeof other.size !== "number") {
      throw new TypeError("The .size property is NaN");
    }
    this.forEach(function (item) {
      if (other.has(item)) {
        return false;
      }
    });
    return true;
  };
}
if (!Set.prototype.isSubsetOf) {
  Set.prototype.isSubsetOf = function (other) {
    if (other === null || _typeof2(other) !== "object") {
      throw new TypeError("Set.prototype.isSubsetOf argument must be an object");
    }
    if (typeof other.size !== "number") {
      throw new TypeError("The .size property is NaN");
    }
    this.forEach(function (item) {
      if (other.has(item) === false) {
        return false;
      }
    });
    return true;
  };
}
if (!Set.prototype.isSupersetOf) {
  Set.prototype.isSupersetOf = function (other) {
    if (other === null || _typeof2(other) !== "object") {
      throw new TypeError("Set.prototype.isSupersetOf argument must be an object");
    }
    if (typeof other.size !== "number") {
      throw new TypeError("The .size property is NaN");
    }
    var entries = other.keys();
    var iterator = entries.next();
    while (!iterator.done) {
      if (this.has(iterator.value) === false) {
        return false;
      }
      iterator = entries.next();
    }
    return true;
  };
}

/**
 * Polyfill for WeakMap
 */
if (typeof WeakMap !== 'function') {
  var mUIDs = [];
  window.WeakMap = function () {
    this.map = {};
    this.length = 0;
  };
  WeakMap.prototype = {
    constructor: WeakMap,
    _generateUID: function _generateUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      do {
        var guid = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      } while (mUIDs.indexOf(guid) !== -1);
      mUIDs.push(guid);
      return guid;
    },
    set: function set(key, value) {
      if (key.__WeakMapKey === undefined) {
        key.__WeakMapKey = this._generateUID();
      }
      if (this.map[key.__WeakMapKey] === undefined) {
        this.length++;
        if (this.length > 100000) {
          throw new Error("WeakMap overload! Get a better browser!");
        }
      }
      this.map[key.__WeakMapKey] = value;
      return this;
    },
    get: function get(key) {
      if (key.__WeakMapKey === undefined) {
        return undefined;
      }
      return this.map[key.__WeakMapKey];
    },
    // delete has to be in quotes for IE8 - go figure
    "delete": function _delete(key) {
      if (key.__WeakMapKey === undefined || this.map[key.__WeakMapKey] === undefined) {
        return false;
      }
      this.length--;
      delete this.map[key.__WeakMapKey];
      return true;
    },
    has: function has(key) {
      return key.__WeakMapKey !== undefined && this.map[key.__WeakMapKey] !== undefined;
    }
  };
}

/**
 * Polyfill for Map
 */
if (typeof Map !== 'function') {
  window.Map = function (pIterations) {
    this.size = 0;
    this._iterator = 0;
    this._keys = [];
    this._values = [];
    if (Array.isArray(pIterations) && pIterations.length > 0) {
      var that = this;
      pIterations.forEach(function (pValues) {
        if (Array.isArray(pValues) === false || pValues.length !== 2) {
          throw new Error("input parameter must contains arrays of length two");
        }
        that._keys.push(pValues[0]);
        that._values.push(pValues[1]);
      });
    }
  }, Map.prototype = {
    constructor: Map,
    clear: function clear() {
      this._keys = [];
      this._values = [];
      this.size = 0;
    },
    "delete": function _delete(pKey) {
      var index = this._keys.indexOf(pKey);
      if (index >= 0) {
        this._keys.splice(index, 1);
        this._values.splice(index, 1);
        this.size--;
        return true;
      }
      return false;
    },
    get: function get(pKey) {
      var index = this._keys.indexOf(pKey);
      if (index >= 0) {
        return this._values[index];
      }
      return undefined;
    },
    has: function has(pKey) {
      return this._keys.includes(pKey);
    },
    set: function set(pKey, pValue) {
      var index = this._keys.indexOf(pKey);
      if (index >= 0) {
        this._values[index] = pValue;
      } else {
        this._keys.push(pKey);
        this._values.push(pValue);
        this.size++;
      }
      return this;
    },
    next: function next() {
      if (this._iterator < this.size) {
        var output = {
          value: [this._keys[this._iterator], this._values[this._iterator]],
          done: false
        };
        this._iterator++;
        return output;
      } else {
        return {
          value: [this._keys[this._iterator], this._values[this._iterator]],
          done: true
        };
      }
    },
    keys: function keys() {
      return this._keys.slice();
    },
    values: function values() {
      return this._values.slice();
    },
    entries: function entries() {
      var that = this;
      var _keyValues = [];
      this._keys.forEach(function (pKey, pIndex) {
        _keyValues.push([pKey, that._values[pIndex]]);
      });
      var output = {
        _iterationCount: 0,
        _keyValues: _keyValues,
        next: function next() {
          if (this._iterationCount < this._keyValues.length) {
            var output = {
              value: this._keyValues[this._iterationCount],
              done: false
            };
            this._iterationCount++;
            return output;
          } else {
            return {
              value: this._keyValues[this._iterationCount],
              done: true
            };
          }
        }
      };
      if (typeof Symbol !== "undefined") {
        output[Symbol.iterator] = function () {
          return this;
        };
      }
      return output;
    },
    forEach: function forEach(pCallBackFunction, pThis) {
      //forEach((value, key, map) => { /* … */ } )
      for (var i = 0; i < this._keys.length; i++) {
        pCallBackFunction.apply(pThis, [this._values[i], this._keys[i], this]);
      }
    },
    toString: function toString() {
      return "[object Map]";
    },
    toLocaleString: function toLocaleString() {
      return "[object Map]";
    }
  };
  if (typeof Symbol !== "undefined") {
    Map.prototype[Symbol.iterator] = function () {
      return this;
    };
  }
}
if (typeof WeakSet !== "function") {
  var counter = Date.now() % 1e9;
  /**
   * @constructor
   */
  window.WeakSet = function (data) {
    this.name = '__st' + (Math.random() * 1e9 >>> 0) + (counter++ + '__');
    data && data.forEach && data.forEach(this.add, this);
  };
  WeakSet.prototype = {
    add: function add(val) {
      var name = this.name;
      if (!val[name]) {
        Object.defineProperty(val, name, {
          value: true,
          writable: true
        });
      }
      return this;
    },
    // delete has to be in quotes for IE8 - go figure
    "delete": function _delete(val) {
      if (!val[this.name]) {
        return false;
      }
      val[this.name] = undefined;
      return true;
    },
    has: function has(val) {
      return !!val[this.name];
    }
  };
}

/**
 * Polyfill for CustomEvent
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
 */
(function () {
  if (typeof window.CustomEvent === "function") {
    return false;
  }
  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  window.CustomEvent = CustomEvent;
})();

/**
 * Polyfill for classList
 */
(function (window) {
  // prevent global namespace pollution
  if ("document" in self) {
    // Full polyfill for browsers with no classList support
    // Including IE < Edge missing SVGElement.classList
    if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {
      (function (view) {
        "use strict";

        if (!('Element' in view)) {
          return;
        }
        var classListProp = "classList",
          protoProp = "prototype",
          elemCtrProto = view.Element[protoProp],
          objCtr = Object,
          strTrim = String[protoProp].trim || function () {
            return this.replace(/^\s+|\s+$/g, "");
          },
          arrIndexOf = Array[protoProp].indexOf || function (item) {
            var i = 0,
              len = this.length;
            for (; i < len; i++) {
              if (i in this && this[i] === item) {
                return i;
              }
            }
            return -1;
          }
          // Vendors: please allow content code to instantiate DOMExceptions
          ,
          DOMEx = function DOMEx(type, message) {
            this.name = type;
            this.code = DOMException[type];
            this.message = message;
          },
          checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
            if (token === "") {
              throw new DOMEx("SYNTAX_ERR", "The token must not be empty.");
            }
            if (/\s/.test(token)) {
              throw new DOMEx("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
            }
            return arrIndexOf.call(classList, token);
          },
          ClassList = function ClassList(elem) {
            var trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
              classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
              i = 0,
              len = classes.length;
            for (; i < len; i++) {
              this.push(classes[i]);
            }
            this._updateClassName = function () {
              elem.setAttribute("class", this.toString());
            };
          },
          classListProto = ClassList[protoProp] = [],
          classListGetter = function classListGetter() {
            return new ClassList(this);
          };
        // Most DOMException implementations don't allow calling DOMException's toString()
        // on non-DOMExceptions. Error's toString() is sufficient here.
        DOMEx[protoProp] = Error[protoProp];
        classListProto.item = function (i) {
          return this[i] || null;
        };
        classListProto.contains = function (token) {
          return ~checkTokenAndGetIndex(this, token + "");
        };
        classListProto.add = function () {
          var tokens = arguments,
            i = 0,
            l = tokens.length,
            token,
            updated = false;
          do {
            token = tokens[i] + "";
            if (!~checkTokenAndGetIndex(this, token)) {
              this.push(token);
              updated = true;
            }
          } while (++i < l);
          if (updated) {
            this._updateClassName();
          }
        };
        classListProto.remove = function () {
          var tokens = arguments,
            i = 0,
            l = tokens.length,
            token,
            updated = false,
            index;
          do {
            token = tokens[i] + "";
            index = checkTokenAndGetIndex(this, token);
            while (~index) {
              this.splice(index, 1);
              updated = true;
              index = checkTokenAndGetIndex(this, token);
            }
          } while (++i < l);
          if (updated) {
            this._updateClassName();
          }
        };
        classListProto.toggle = function (token, force) {
          var result = this.contains(token),
            method = result ? force !== true && "remove" : force !== false && "add";
          if (method) {
            this[method](token);
          }
          if (force === true || force === false) {
            return force;
          } else {
            return !result;
          }
        };
        classListProto.replace = function (token, replacement_token) {
          var index = checkTokenAndGetIndex(token + "");
          if (~index) {
            this.splice(index, 1, replacement_token);
            this._updateClassName();
          }
        };
        classListProto.toString = function () {
          return this.join(" ");
        };
        if (objCtr.defineProperty) {
          var classListPropDesc = {
            get: classListGetter,
            enumerable: true,
            configurable: true
          };
          try {
            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
          } catch (ex) {
            // IE 8 doesn't support enumerable:true
            // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
            // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
            if (ex.number === undefined || ex.number === -0x7FF5EC54) {
              classListPropDesc.enumerable = false;
              objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
            }
          }
        } else if (objCtr[protoProp].__defineGetter__) {
          elemCtrProto.__defineGetter__(classListProp, classListGetter);
        }
      })(self);
    }

    // There is full or partial native classList support, so just check if we need
    // to normalize the add/remove and toggle APIs.

    (function () {
      "use strict";

      var testElement = document.createElement("_");
      testElement.classList.add("c1", "c2");

      // Polyfill for IE 10/11 and Firefox <26, where classList.add and
      // classList.remove exist but support only one argument at a time.
      if (!testElement.classList.contains("c2")) {
        var createMethod = function createMethod(method) {
          var original = DOMTokenList.prototype[method];
          DOMTokenList.prototype[method] = function (token) {
            var i,
              len = arguments.length;
            for (i = 0; i < len; i++) {
              token = arguments[i];
              original.call(this, token);
            }
          };
        };
        createMethod('add');
        createMethod('remove');
      }
      testElement.classList.toggle("c3", false);

      // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
      // support the second argument.
      if (testElement.classList.contains("c3")) {
        var _toggle = DOMTokenList.prototype.toggle;
        DOMTokenList.prototype.toggle = function (token, force) {
          if (1 in arguments && !this.contains(token) === !force) {
            return force;
          } else {
            return _toggle.call(this, token);
          }
        };
      }

      // replace() polyfill
      if (!("replace" in document.createElement("_").classList)) {
        DOMTokenList.prototype.replace = function (token, replacement_token) {
          var tokens = this.toString().split(" "),
            index = tokens.indexOf(token + "");
          if (~index) {
            tokens = tokens.slice(index);
            this.remove.apply(this, tokens);
            this.add(replacement_token);
            this.add.apply(this, tokens.slice(1));
          }
        };
      }
      testElement = null;
    })();
  }
})(window);
if (!window.structuredClone) {
  (function (window) {
    /*Copyright (c) 2021, Andrea Giammarchi, @WebReflection
    
    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted, provided that the above
    copyright notice and this permission notice appear in all copies.
    
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE
    OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.**/
    function _createForOfIteratorHelper(o, allowArrayLike) {
      var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
      if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
          if (it) {
            o = it;
          }
          var i = 0;
          var F = function F() {};
          return {
            s: F,
            n: function n() {
              if (i >= o.length) {
                return {
                  done: true
                };
              }
              ;
              return {
                done: false,
                value: o[i++]
              };
            },
            e: function e(_e2) {
              throw _e2;
            },
            f: F
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var normalCompletion = true,
        didErr = false,
        err;
      return {
        s: function s() {
          it = it.call(o);
        },
        n: function n() {
          var step = it.next();
          normalCompletion = step.done;
          return step;
        },
        e: function e(_e3) {
          didErr = true;
          err = _e3;
        },
        f: function f() {
          try {
            if (!normalCompletion && it["return"] != null) {
              it["return"]();
            }
          } finally {
            if (didErr) {
              throw err;
            }
          }
        }
      };
    }
    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) {
        return Array.from(iter);
      }
    }
    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) {
        return _arrayLikeToArray(arr);
      }
    }
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) {
        return;
      }
      if (typeof o === "string") {
        return _arrayLikeToArray(o, minLen);
      }
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) {
        n = o.constructor.name;
      }
      if (n === "Map" || n === "Set") {
        return Array.from(o);
      }
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
        return _arrayLikeToArray(o, minLen);
      }
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) {
        len = arr.length;
      }
      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    }
    function _iterableToArrayLimit(arr, i) {
      var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
      if (_i == null) {
        return;
      }
      var _arr = [];
      var _n = true;
      var _d = false;
      var _s, _e;
      try {
        for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i) {
            break;
          }
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null) {
            _i["return"]();
          }
        } finally {
          if (_d) {
            throw _e;
          }
        }
      }
      return _arr;
    }
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) {
        return arr;
      }
    }
    function _typeof(obj) {
      return _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (obj) {
        return _typeof2(obj);
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
      }, _typeof(obj);
    }
    var VOID = -1;
    var PRIMITIVE = 0;
    var ARRAY = 1;
    var OBJECT = 2;
    var DATE = 3;
    var REGEXP = 4;
    var MAP = 5;
    var SET = 6;
    var ERROR = 7;
    var BIGINT = 8;
    var EMPTY = '';
    var _ref = {},
      toString = _ref.toString;
    var keys = Object.keys;
    var typeOf = function typeOf(value) {
      var type = _typeof(value);
      if (type !== 'object' || !value) {
        return [PRIMITIVE, type];
      }
      var asString = toString.call(value).slice(8, -1);
      switch (asString) {
        case 'Array':
          return [ARRAY, EMPTY];
        case 'Object':
          return [OBJECT, EMPTY];
        case 'Date':
          return [DATE, EMPTY];
        case 'RegExp':
          return [REGEXP, EMPTY];
        case 'Map':
          return [MAP, EMPTY];
        case 'Set':
          return [SET, EMPTY];
      }
      if (asString.includes('Array')) {
        return [ARRAY, asString];
      }
      if (asString.includes('Error')) {
        return [ERROR, asString];
      }
      return [OBJECT, asString];
    };
    var shouldSkip = function shouldSkip(_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        TYPE = _ref3[0],
        type = _ref3[1];
      return TYPE === PRIMITIVE && (type === 'function' || type === 'symbol');
    };
    var serializer = function serializer(strict, json, $, _) {
      var as = function as(out, value) {
        var index = _.push(out) - 1;
        $.set(value, index);
        return index;
      };
      var pair = function pair(value) {
        if ($.has(value)) {
          return $.get(value);
        }
        var _typeOf = typeOf(value),
          _typeOf2 = _slicedToArray(_typeOf, 2),
          TYPE = _typeOf2[0],
          type = _typeOf2[1];
        switch (TYPE) {
          case PRIMITIVE:
            {
              var entry = value;
              switch (type) {
                case 'bigint':
                  TYPE = BIGINT;
                  entry = value.toString();
                  break;
                case 'function':
                case 'symbol':
                  if (strict) {
                    throw new TypeError('unable to serialize ' + type);
                  }
                  entry = null;
                  break;
                case 'undefined':
                  return as([VOID], value);
              }
              return as([TYPE, entry], value);
            }
          case ARRAY:
            {
              if (type) {
                return as([type, _toConsumableArray(value)], value);
              }
              var arr = [];
              var index = as([TYPE, arr], value);
              var _iterator = _createForOfIteratorHelper(value),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _entry = _step.value;
                  arr.push(pair(_entry));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return index;
            }
          case OBJECT:
            {
              if (type) {
                switch (type) {
                  case 'BigInt':
                    return as([type, value.toString()], value);
                  case 'Boolean':
                  case 'Number':
                  case 'String':
                    return as([type, value.valueOf()], value);
                }
              }
              if (json && 'toJSON' in value) {
                return pair(value.toJSON());
              }
              var entries = [];
              var _index = as([TYPE, entries], value);
              var _iterator2 = _createForOfIteratorHelper(keys(value)),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var key = _step2.value;
                  if (strict || !shouldSkip(typeOf(value[key]))) {
                    entries.push([pair(key), pair(value[key])]);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              return _index;
            }
          case DATE:
            return as([TYPE, value.toISOString()], value);
          case REGEXP:
            {
              var source = value.source,
                flags = value.flags;
              return as([TYPE, {
                source: source,
                flags: flags
              }], value);
            }
          case MAP:
            {
              var _entries = [];
              var _index2 = as([TYPE, _entries], value);
              var _iterator3 = _createForOfIteratorHelper(value),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _step3$value = _slicedToArray(_step3.value, 2),
                    _key = _step3$value[0],
                    _entry2 = _step3$value[1];
                  if (strict || !(shouldSkip(typeOf(_key)) || shouldSkip(typeOf(_entry2)))) {
                    _entries.push([pair(_key), pair(_entry2)]);
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              return _index2;
            }
          case SET:
            {
              var _entries2 = [];
              var _index3 = as([TYPE, _entries2], value);
              var _iterator4 = _createForOfIteratorHelper(value),
                _step4;
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var _entry3 = _step4.value;
                  if (strict || !shouldSkip(typeOf(_entry3))) {
                    _entries2.push(pair(_entry3));
                  }
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              return _index3;
            }
        }
        var message = value.message;
        return as([TYPE, {
          name: type,
          message: message
        }], value);
      };
      return pair;
    };
    var serialize = function serialize(value) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        json = _ref4.json,
        lossy = _ref4.lossy;
      var _ = [];
      return serializer(!(json || lossy), !!json, new Map(), _)(value), _;
    };
    var env = (typeof self === "undefined" ? "undefined" : _typeof(self)) === 'object' ? self : globalThis;
    var deserializer = function deserializer($, _) {
      var as = function as(out, index) {
        $.set(index, out);
        return out;
      };
      var unpair = function unpair(index) {
        if ($.has(index)) {
          return $.get(index);
        }
        var _$index = _slicedToArray(_[index], 2),
          type = _$index[0],
          value = _$index[1];
        switch (type) {
          case PRIMITIVE:
          case VOID:
            return as(value, index);
          case ARRAY:
            {
              var arr = as([], index);
              var _iterator5 = _createForOfIteratorHelper(value),
                _step5;
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var _index4 = _step5.value;
                  arr.push(unpair(_index4));
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              return arr;
            }
          case OBJECT:
            {
              var object = as({}, index);
              var _iterator6 = _createForOfIteratorHelper(value),
                _step6;
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var _step6$value = _slicedToArray(_step6.value, 2),
                    key = _step6$value[0],
                    _index5 = _step6$value[1];
                  object[unpair(key)] = unpair(_index5);
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              return object;
            }
          case DATE:
            return as(new Date(value), index);
          case REGEXP:
            {
              var source = value.source,
                flags = value.flags;
              return as(new RegExp(source, flags), index);
            }
          case MAP:
            {
              var map = as(new Map(), index);
              var _iterator7 = _createForOfIteratorHelper(value),
                _step7;
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var _step7$value = _slicedToArray(_step7.value, 2),
                    _key2 = _step7$value[0],
                    _index6 = _step7$value[1];
                  map.set(unpair(_key2), unpair(_index6));
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              return map;
            }
          case SET:
            {
              var set = as(new Set(), index);
              var _iterator8 = _createForOfIteratorHelper(value),
                _step8;
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var _index7 = _step8.value;
                  set.add(unpair(_index7));
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
              return set;
            }
          case ERROR:
            {
              var name = value.name,
                message = value.message;
              return as(new env[name](message), index);
            }
          case BIGINT:
            return as(BigInt(value), index);
          case 'BigInt':
            return as(Object(BigInt(value)), index);
        }
        return as(new env[type](value), index);
      };
      return unpair;
    };
    var deserialize = function deserialize(serialized) {
      return deserializer(new Map(), serialized)(0);
    };
    window.structuredClone = function (object, transferables) {
      if (transferables !== undefined) {
        console.error("polyfill structuredClone does not support transferables!");
      }
      return deserialize(serialize(object));
    };
  })(window);
}
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license
(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
})();
// https://github.com/taylorhakes/promise-polyfill version 8.3.0
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) && "undefined" != typeof module ? t() : "function" == typeof define && define.amd ? define(t) : t();
}(0, function () {
  "use strict";

  function e(e) {
    var t = this.constructor;
    return this.then(function (n) {
      return t.resolve(e()).then(function () {
        return n;
      });
    }, function (n) {
      return t.resolve(e()).then(function () {
        return t.reject(n);
      });
    });
  }
  function t(e) {
    return new this(function (t, n) {
      function r(e, n) {
        if (n && ("object" == _typeof2(n) || "function" == typeof n)) {
          var f = n.then;
          if ("function" == typeof f) return void f.call(n, function (t) {
            r(e, t);
          }, function (n) {
            o[e] = {
              status: "rejected",
              reason: n
            }, 0 == --i && t(o);
          });
        }
        o[e] = {
          status: "fulfilled",
          value: n
        }, 0 == --i && t(o);
      }
      if (!e || "undefined" == typeof e.length) return n(new TypeError(_typeof2(e) + " " + e + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
      var o = Array.prototype.slice.call(e);
      if (0 === o.length) return t([]);
      for (var i = o.length, f = 0; o.length > f; f++) r(f, o[f]);
    });
  }
  function n(e, t) {
    this.name = "AggregateError", this.errors = e, this.message = t || "";
  }
  function r(e) {
    var t = this;
    return new t(function (r, o) {
      if (!e || "undefined" == typeof e.length) return o(new TypeError("Promise.any accepts an array"));
      var i = Array.prototype.slice.call(e);
      if (0 === i.length) return o();
      for (var f = [], u = 0; i.length > u; u++) try {
        t.resolve(i[u]).then(r)["catch"](function (e) {
          f.push(e), f.length === i.length && o(new n(f, "All promises were rejected"));
        });
      } catch (c) {
        o(c);
      }
    });
  }
  function o(e) {
    return !(!e || "undefined" == typeof e.length);
  }
  function i() {}
  function f(e) {
    if (!(this instanceof f)) throw new TypeError("Promises must be constructed via new");
    if ("function" != typeof e) throw new TypeError("not a function");
    this._state = 0, this._handled = !1, this._value = undefined, this._deferreds = [], s(e, this);
  }
  function u(e, t) {
    for (; 3 === e._state;) e = e._value;
    0 !== e._state ? (e._handled = !0, f._immediateFn(function () {
      var n = 1 === e._state ? t.onFulfilled : t.onRejected;
      if (null !== n) {
        var r;
        try {
          r = n(e._value);
        } catch (o) {
          return void a(t.promise, o);
        }
        c(t.promise, r);
      } else (1 === e._state ? c : a)(t.promise, e._value);
    })) : e._deferreds.push(t);
  }
  function c(e, t) {
    try {
      if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
      if (t && ("object" == _typeof2(t) || "function" == typeof t)) {
        var n = t.then;
        if (t instanceof f) return e._state = 3, e._value = t, void l(e);
        if ("function" == typeof n) return void s(function (e, t) {
          return function () {
            e.apply(t, arguments);
          };
        }(n, t), e);
      }
      e._state = 1, e._value = t, l(e);
    } catch (r) {
      a(e, r);
    }
  }
  function a(e, t) {
    e._state = 2, e._value = t, l(e);
  }
  function l(e) {
    2 === e._state && 0 === e._deferreds.length && f._immediateFn(function () {
      e._handled || f._unhandledRejectionFn(e._value);
    });
    for (var t = 0, n = e._deferreds.length; n > t; t++) u(e, e._deferreds[t]);
    e._deferreds = null;
  }
  function s(e, t) {
    var n = !1;
    try {
      e(function (e) {
        n || (n = !0, c(t, e));
      }, function (e) {
        n || (n = !0, a(t, e));
      });
    } catch (r) {
      if (n) return;
      n = !0, a(t, r);
    }
  }
  n.prototype = Error.prototype;
  var d = setTimeout;
  f.prototype["catch"] = function (e) {
    return this.then(null, e);
  }, f.prototype.then = function (e, t) {
    var n = new this.constructor(i);
    return u(this, new function (e, t, n) {
      this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
    }(e, t, n)), n;
  }, f.prototype["finally"] = e, f.all = function (e) {
    return new f(function (t, n) {
      function r(e, o) {
        try {
          if (o && ("object" == _typeof2(o) || "function" == typeof o)) {
            var u = o.then;
            if ("function" == typeof u) return void u.call(o, function (t) {
              r(e, t);
            }, n);
          }
          i[e] = o, 0 == --f && t(i);
        } catch (c) {
          n(c);
        }
      }
      if (!o(e)) return n(new TypeError("Promise.all accepts an array"));
      var i = Array.prototype.slice.call(e);
      if (0 === i.length) return t([]);
      for (var f = i.length, u = 0; i.length > u; u++) r(u, i[u]);
    });
  }, f.any = r, f.allSettled = t, f.resolve = function (e) {
    return e && "object" == _typeof2(e) && e.constructor === f ? e : new f(function (t) {
      t(e);
    });
  }, f.reject = function (e) {
    return new f(function (t, n) {
      n(e);
    });
  }, f.race = function (e) {
    return new f(function (t, n) {
      if (!o(e)) return n(new TypeError("Promise.race accepts an array"));
      for (var r = 0, i = e.length; i > r; r++) f.resolve(e[r]).then(t, n);
    });
  }, f._immediateFn = "function" == typeof setImmediate && function (e) {
    setImmediate(e);
  } || function (e) {
    d(e, 0);
  }, f._unhandledRejectionFn = function (e) {
    void 0 !== console && console && console.warn("Possible Unhandled Promise Rejection:", e);
  };
  var p = function () {
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if ("undefined" != typeof global) return global;
    throw Error("unable to locate global object");
  }();
  "function" != typeof p.Promise ? p.Promise = f : (p.Promise.prototype["finally"] || (p.Promise.prototype["finally"] = e), p.Promise.allSettled || (p.Promise.allSettled = t), p.Promise.any || (p.Promise.any = r));
});
if (typeof Promise.withResolvers === "undefined") {
  Promise.withResolvers = function () {
    var resolve, reject;
    var promise = new Promise(function (res, rej) {
      resolve = res;
      reject = rej;
    });
    return {
      promise: promise,
      resolve: resolve,
      reject: reject
    };
  };
}
if (window.Promise["try"] === undefined) {
  window.Promise["try"] = function (pFc) {
    try {
      var args = [];
      for (var i = 1; i < arguments.length; i++) {
        args.push(arguments[i]);
      }
      return Promise.resolve(pFc.apply(null, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
// some fetch polyfill
if (typeof window.fetch !== "function" && typeof window.XMLHttpRequest === "function") {
  window.fetch = function (url, options) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        // Check for HTTP success (status in the range of 200 to 299)
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(new Response(xhr.responseText, {
            status: xhr.status
          }));
        } else {
          // Create a new Error object with more information
          var error = new Error(xhr.statusText);
          error.response = new Response(xhr.responseText, {
            status: xhr.status
          });
          reject(error);
        }
      };
      xhr.onerror = function () {
        reject(new Error("Network error"));
      };

      // open(method, url, async)
      xhr.open(options.method || "GET", url, true);

      // We must call setRequestHeader() after open(), but before send().
      for (var header in options.headers || {}) {
        xhr.setRequestHeader(header, options.headers[header]);
      }
      xhr.send(options.body || null);
    });
  };
}

/**!
 * url-search-params-polyfill
 *
 * @author Jerry Bendy (https://github.com/jerrybendy)
 * @licence MIT
 */
(function (self) {
  'use strict';

  var nativeURLSearchParams = function () {
      // #41 Fix issue in RN
      try {
        if (self.URLSearchParams && new self.URLSearchParams('foo=bar').get('foo') === 'bar') {
          return self.URLSearchParams;
        }
      } catch (e) {}
      return null;
    }(),
    isSupportObjectConstructor = nativeURLSearchParams && new nativeURLSearchParams({
      a: 1
    }).toString() === 'a=1',
    // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
    decodesPlusesCorrectly = nativeURLSearchParams && new nativeURLSearchParams('s=%2B').get('s') === '+',
    isSupportSize = nativeURLSearchParams && 'size' in nativeURLSearchParams.prototype,
    __URLSearchParams__ = "__URLSearchParams__",
    // Fix bug in Edge which cannot encode ' &' correctly
    encodesAmpersandsCorrectly = nativeURLSearchParams ? function () {
      var ampersandTest = new nativeURLSearchParams();
      ampersandTest.append('s', ' &');
      return ampersandTest.toString() === 's=+%26';
    }() : true,
    prototype = URLSearchParamsPolyfill.prototype,
    iterable = !!(self.Symbol && self.Symbol.iterator);
  if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly && isSupportSize) {
    return;
  }
  function URLSearchParamsPolyfill(search) {
    search = search || "";

    // support construct object with another URLSearchParams instance
    if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
      search = search.toString();
    }
    this[__URLSearchParams__] = parseToDict(search);
  }
  prototype.append = function (name, value) {
    appendTo(this[__URLSearchParams__], name, value);
  };
  prototype['delete'] = function (name) {
    delete this[__URLSearchParams__][name];
  };
  prototype.get = function (name) {
    var dict = this[__URLSearchParams__];
    return this.has(name) ? dict[name][0] : null;
  };
  prototype.getAll = function (name) {
    var dict = this[__URLSearchParams__];
    return this.has(name) ? dict[name].slice(0) : [];
  };
  prototype.has = function (name) {
    return hasOwnProperty(this[__URLSearchParams__], name);
  };
  prototype.set = function set(name, value) {
    this[__URLSearchParams__][name] = ['' + value];
  };
  prototype.toString = function () {
    var dict = this[__URLSearchParams__],
      query = [],
      i,
      key,
      name,
      value;
    for (key in dict) {
      name = encode(key);
      for (i = 0, value = dict[key]; i < value.length; i++) {
        query.push(name + '=' + encode(value[i]));
      }
    }
    return query.join('&');
  };

  // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
  var useProxy = self.Proxy && nativeURLSearchParams && (!decodesPlusesCorrectly || !encodesAmpersandsCorrectly || !isSupportObjectConstructor || !isSupportSize);
  var propValue;
  if (useProxy) {
    // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
    propValue = new Proxy(nativeURLSearchParams, {
      construct: function construct(target, args) {
        return new target(new URLSearchParamsPolyfill(args[0]).toString());
      }
    });
    // Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
    propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
  } else {
    propValue = URLSearchParamsPolyfill;
  }

  /*
   * Apply polyfill to global object and append other prototype into it
   */
  Object.defineProperty(self, 'URLSearchParams', {
    value: propValue
  });
  var USPProto = self.URLSearchParams.prototype;
  USPProto.polyfill = true;

  // Fix #54, `toString.call(new URLSearchParams)` will return correct value when Proxy not used
  if (!useProxy && self.Symbol) {
    USPProto[self.Symbol.toStringTag] = 'URLSearchParams';
  }
  if (!('forEach' in USPProto)) {
    USPProto.forEach = function (callback, thisArg) {
      var dict = parseToDict(this.toString());
      Object.getOwnPropertyNames(dict).forEach(function (name) {
        dict[name].forEach(function (value) {
          callback.call(thisArg, value, name, this);
        }, this);
      }, this);
    };
  }
  if (!('sort' in USPProto)) {
    USPProto.sort = function () {
      var dict = parseToDict(this.toString()),
        keys = [],
        k,
        i,
        j;
      for (k in dict) {
        keys.push(k);
      }
      keys.sort();
      for (i = 0; i < keys.length; i++) {
        this['delete'](keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        var key = keys[i],
          values = dict[key];
        for (j = 0; j < values.length; j++) {
          this.append(key, values[j]);
        }
      }
    };
  }
  if (!('keys' in USPProto)) {
    USPProto.keys = function () {
      var items = [];
      this.forEach(function (item, name) {
        items.push(name);
      });
      return makeIterator(items);
    };
  }
  if (!('values' in USPProto)) {
    USPProto.values = function () {
      var items = [];
      this.forEach(function (item) {
        items.push(item);
      });
      return makeIterator(items);
    };
  }
  if (!('entries' in USPProto)) {
    USPProto.entries = function () {
      var items = [];
      this.forEach(function (item, name) {
        items.push([name, item]);
      });
      return makeIterator(items);
    };
  }
  if (iterable) {
    USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
  }
  if (!('size' in USPProto)) {
    Object.defineProperty(USPProto, 'size', {
      get: function get() {
        var dict = parseToDict(this.toString());
        if (USPProto === this) {
          throw new Error('Illegal invocation at URLSearchParams.invokeGetter');
        }
        return Object.keys(dict).reduce(function (prev, cur) {
          return prev + dict[cur].length;
        }, 0);
      }
    });
  }
  function encode(str) {
    var replace = {
      '!': '%21',
      "'": '%27',
      '(': '%28',
      ')': '%29',
      '~': '%7E',
      '%20': '+',
      '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function (match) {
      return replace[match];
    });
  }
  function decode(str) {
    return str.replace(/[ +]/g, '%20').replace(/(%[a-f0-9]{2})+/ig, function (match) {
      return decodeURIComponent(match);
    });
  }
  function makeIterator(arr) {
    var iterator = {
      next: function next() {
        var value = arr.shift();
        return {
          done: value === undefined,
          value: value
        };
      }
    };
    if (iterable) {
      iterator[self.Symbol.iterator] = function () {
        return iterator;
      };
    }
    return iterator;
  }
  function parseToDict(search) {
    var dict = {};
    if (_typeof2(search) === "object") {
      // if `search` is an array, treat it as a sequence
      if (isArray(search)) {
        for (var i = 0; i < search.length; i++) {
          var item = search[i];
          if (isArray(item) && item.length === 2) {
            appendTo(dict, item[0], item[1]);
          } else {
            throw new Error("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
          }
        }
      } else {
        for (var key in search) {
          if (search.hasOwnProperty(key)) {
            appendTo(dict, key, search[key]);
          }
        }
      }
    } else {
      // remove first '?'
      if (search.indexOf("?") === 0) {
        search = search.slice(1);
      }
      var pairs = search.split("&");
      for (var j = 0; j < pairs.length; j++) {
        var value = pairs[j],
          index = value.indexOf('=');
        if (-1 < index) {
          appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
        } else {
          if (value) {
            appendTo(dict, decode(value), '');
          }
        }
      }
    }
    return dict;
  }
  function appendTo(dict, name, value) {
    var val = typeof value === 'string' ? value : value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value);

    // #47 Prevent using `hasOwnProperty` as a property name
    if (hasOwnProperty(dict, name)) {
      dict[name].push(val);
    } else {
      dict[name] = [val];
    }
  }
  function isArray(val) {
    return !!val && '[object Array]' === Object.prototype.toString.call(val);
  }
  function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }
})(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : void 0);
if (typeof window.AbortController === "undefined") {
  var SECRET = {};
  window.AbortSignal = function () {
    function AbortSignal(secret) {
      if (secret !== SECRET) {
        throw new Error("Illegal constructor.");
      }
      EventTarget.call(this);
      this._aborted = false;
    }
    AbortSignal.prototype = Object.create(EventTarget.prototype);
    AbortSignal.prototype.constructor = AbortSignal;
    Object.defineProperty(AbortSignal.prototype, "onabort", {
      get: function get() {
        return this._onabort;
      },
      set: function set(callback) {
        var existing = this._onabort;
        if (existing) {
          this.removeEventListener("abort", existing);
        }
        this._onabort = callback;
        this.addEventListener("abort", callback);
      }
    });
    Object.defineProperty(AbortSignal.prototype, "aborted", {
      get: function get() {
        return this._aborted;
      }
    });
    return AbortSignal;
  }();
  window.AbortController = function () {
    function AbortController() {
      this._signal = new AbortSignal(SECRET);
    }
    AbortController.prototype = Object.create(Object.prototype);
    Object.defineProperty(AbortController.prototype, "signal", {
      get: function get() {
        return this._signal;
      }
    });
    AbortController.prototype.abort = function () {
      var signal = this.signal;
      if (!signal.aborted) {
        signal._aborted = true;
        signal.dispatchEvent(new Event("abort"));
      }
    };
    return AbortController;
  }();
}
if (window.atob === undefined) {
  /*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */
  ;
  (function (root) {
    // Detect free variables `exports`.
    var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) == 'object' && exports;

    // Detect free variable `module`.
    var freeModule = (typeof module === "undefined" ? "undefined" : _typeof2(module)) == 'object' && module && module.exports == freeExports && module;

    // Detect free variable `global`, from Node.js or Browserified code, and use
    // it as `root`.
    var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof2(global)) == 'object' && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
      root = freeGlobal;
    }

    /*--------------------------------------------------------------------------*/

    var InvalidCharacterError = function InvalidCharacterError(message) {
      this.message = message;
    };
    InvalidCharacterError.prototype = new Error();
    InvalidCharacterError.prototype.name = 'InvalidCharacterError';
    var error = function error(message) {
      // Note: the error messages used throughout this file match those used by
      // the native `atob`/`btoa` implementation in Chromium.
      throw new InvalidCharacterError(message);
    };
    var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // http://whatwg.org/html/common-microsyntaxes.html#space-character
    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

    // `decode` is designed to be fully compatible with `atob` as described in the
    // HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
    // The optimized base64-decoding algorithm used is based on @atk’s excellent
    // implementation. https://gist.github.com/atk/1020396
    var decode = function decode(input) {
      input = String(input).replace(REGEX_SPACE_CHARACTERS, '');
      var length = input.length;
      if (length % 4 == 0) {
        input = input.replace(/==?$/, '');
        length = input.length;
      }
      if (length % 4 == 1 ||
      // http://whatwg.org/C#alphanumeric-ascii-characters
      /[^+a-zA-Z0-9/]/.test(input)) {
        error('Invalid character: the string to be decoded is not correctly encoded.');
      }
      var bitCounter = 0;
      var bitStorage;
      var buffer;
      var output = '';
      var position = -1;
      while (++position < length) {
        buffer = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
        // Unless this is the first of a group of 4 characters…
        if (bitCounter++ % 4) {
          // …convert the first 8 bits to a single ASCII character.
          output += String.fromCharCode(0xFF & bitStorage >> (-2 * bitCounter & 6));
        }
      }
      return output;
    };

    // `encode` is designed to be fully compatible with `btoa` as described in the
    // HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
    var encode = function encode(input) {
      input = String(input);
      if (/[^\0-\xFF]/.test(input)) {
        // Note: no need to special-case astral symbols here, as surrogates are
        // matched, and the input is supposed to only contain ASCII anyway.
        error('The string to be encoded contains characters outside of the ' + 'Latin1 range.');
      }
      var padding = input.length % 3;
      var output = '';
      var position = -1;
      var a;
      var b;
      var c;
      var buffer;
      // Make sure any padding is handled outside of the loop.
      var length = input.length - padding;
      while (++position < length) {
        // Read three bytes, i.e. 24 bits.
        a = input.charCodeAt(position) << 16;
        b = input.charCodeAt(++position) << 8;
        c = input.charCodeAt(++position);
        buffer = a + b + c;
        // Turn the 24 bits into four chunks of 6 bits each, and append the
        // matching character for each of them to the output.
        output += TABLE.charAt(buffer >> 18 & 0x3F) + TABLE.charAt(buffer >> 12 & 0x3F) + TABLE.charAt(buffer >> 6 & 0x3F) + TABLE.charAt(buffer & 0x3F);
      }
      if (padding == 2) {
        a = input.charCodeAt(position) << 8;
        b = input.charCodeAt(++position);
        buffer = a + b;
        output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 0x3F) + TABLE.charAt(buffer << 2 & 0x3F) + '=';
      } else if (padding == 1) {
        buffer = input.charCodeAt(position);
        output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 0x3F) + '==';
      }
      return output;
    };
    if (window.atob === undefined) {
      root.atob = decode;
    }
    if (window.btoa === undefined) {
      root.btoa = encode;
    }
  })(window);
}
if (window.queueMicrotask == undefined) {
  window.queueMicrotask = function (pCallBackFunction) {
    if (typeof pCallBackFunction !== "function") {
      throw new Error("Failed to execute 'queueMicrotask' on 'Window': parameter 1 is not of type 'Function'.");
    }
    if (typeof Promise === "function" && typeof Promise.resolve === "function") {
      return Promise.resolve().then(pCallBackFunction)["catch"](function (e) {
        setTimeout(function () {
          throw e;
        });
      });
    } else {
      setTimeout(pCallBackFunction, 0);
    }
  };
}

/*
if (window.CSSNumericValue === undefined) {
  window.CSSNumericValue = function(value, unit) {
    this.value = Number(value);
    this.unit = unit || "";
  };
  window.CSSNumericValue.parse = function(input) {
    if (input instanceof window.CSSNumericValue) {return input;}
    var match = ("" + input).trim().match(/^(-?\d*\.?\d+)([a-z%]*)$/i);
    if (!match) {
      throw new TypeError("Invalid CSS numeric value: " + input);
    }
    return new window.CSSNumericValue(match[1], match[2]);
  }
  window.CSSNumericValue.prototype = { 
    constructor: window.CSSNumericValue,
    add: function(other) {
      if (!(other instanceof window.CSSNumericValue)) {
        throw new Error("Uncaught TypeError: Failed to execute 'add' on 'CSSNumericValue': The provided double value is non-finite.");
      }
      if (this.unit === other.unit) {
        return new window.CSSNumericValue(this.value + other.value, this.unit);
      } else {
        return {operator: "sum", values:[this, other]};
      }
    },
    sub: function(other) {
      if (!(other instanceof window.CSSNumericValue)) {
        throw new Error("Uncaught TypeError: Failed to execute 'sub' on 'CSSNumericValue': The provided double value is non-finite.");
      }
      if (this.unit === other.unit) {
        return new window.CSSNumericValue(this.value - other.value, this.unit);
      } else {
        return {operator: "sum", values:[this, new window.CSSUnitValue(-other.value, other.unit)]};
      }
    },
    mul: function(number) {
      if (typeof number === 'number') {
        return new window.CSSNumericValue(this.value * number, this.unit);
      }
      return {operator: "product", values:[this, other]};
    },
    div: function(number) {
      if (typeof number === 'number') {
        return new window.CSSNumericValue(this.value / number, this.unit);
      }
      return {operator: "product", values:[this, {operator: "invert", value: other}]};
    },
    equals: function(other){
      if (!(other instanceof window.CSSNumericValue)) { return false; }
      return other.value === this.value && other.unit === this.unit;
    },
    min: function(){},
    max: function(){},
    to: function(){},
    toSum: function(){},
    type: function(){}
  }
}
*/
if (window.CSSUnitValue === undefined && typeof CSSUnitValue !== "function") {
  var unitNames = ["Hz", "Q", "cap", "ch", "cm", "cqb", "cqh", "cqi", "cqmax", "cqmin", "cqw", "deg", "dpcm", "dpi", "dppx", "dvb", "dvh", "dvi", "dvmax", "dvmin", "dvw", "em", "ex", "fr", "grad", "ic", "in", "kHz", "lh", "lvb", "lvh", "lvi", "lvmax", "lvmin", "lvw", "mm", "ms", "number", "pc", "percent", "pt", "px", "rad", "rcap", "rch", "rem", "rex", "ric", "rlh", "s", "svb", "svh", "svi", "svmax", "svmin", "svw", "turn", "vb", "vh", "vi", "vmax", "vmin", "vw", "x"];
  window.CSSUnitValue = function (pValue, pUnit) {
    if (typeof pUnit !== "string" || pUnit.length <= 0 || unitNames.indexOf(pUnit) === -1) {
      throw new Error("Failed to construct 'CSSUnitValue': Invalid unit: " + pUnit);
    }
    this.unit = pUnit;
    this.value = parseFloat(pValue);
    if (isNaN(this.value)) {
      throw new Error("Failed to construct 'CSSUnitValue': The provided double value is non-finite.");
    }
  };
  window.CSSUnitValue.prototype = {
    constructor: window.CSSUnitValue,
    toString: function toString() {
      return this.value + this.unit;
    }
  };
}
if (window.CSS === undefined) {
  window.CSS = {
    supports: function supports() {
      return false;
    },
    escape: function escape(value) {
      return value.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, "\\$1");
    }
  };
  if (window.CSSUnitValue !== undefined) {
    var unitNames = ["Hz", "Q", "cap", "ch", "cm", "cqb", "cqh", "cqi", "cqmax", "cqmin", "cqw", "deg", "dpcm", "dpi", "dppx", "dvb", "dvh", "dvi", "dvmax", "dvmin", "dvw", "em", "ex", "fr", "grad", "ic", "in", "kHz", "lh", "lvb", "lvh", "lvi", "lvmax", "lvmin", "lvw", "mm", "ms", "number", "pc", "percent", "pt", "px", "rad", "rcap", "rch", "rem", "rex", "ric", "rlh", "s", "svb", "svh", "svi", "svmax", "svmin", "svw", "turn", "vb", "vh", "vi", "vmax", "vmin", "vw", "x"];
    // we assume that array.foreach is polyfilled before!
    unitNames.forEach(function (pUnit) {
      window.CSS[pUnit] = function (pValue) {
        return new window.CSSUnitValue(pValue, pUnit);
      };
    });
  }
}

// support for older pages with older jquery versions
if (window.$ !== undefined && window.jQuery !== undefined) {
  // if jquery present
  if ($.Deferred !== undefined) {
    // if Deferred present and not some self made $
    if ($.Deferred()["catch"] === undefined) {
      // if catch function missing, this means an old jQuery
      var originalDeferred = $.Deferred;
      $.Deferred = function () {
        var deferred = originalDeferred.apply($, arguments);
        deferred["catch"] = function (fn) {
          return deferred.then(null, fn);
        };
        deferred.promise(null)["catch"] = function (fn) {
          return deferred.then(null, fn);
        };
        return deferred;
      };
      // extend to also accept thenables (including Promise)
      var originalWhen = $.when;
      $.when = function () {
        var parameters = [];
        for (var i = 0; i < arguments.length; i++) {
          if (arguments[i] !== undefined && arguments[i] !== null && typeof arguments[i].then === "function" && arguments[i].promise === undefined) {
            (function (thenable) {
              parameters.push($.Deferred(function (d) {
                thenable.then(d.resolve, d.reject);
              }));
            })(arguments[i]);
          } else {
            parameters.push(arguments[i]);
          }
        }
        return originalWhen.apply($, parameters);
      };
    }
  }
  if (jQuery.fn.jquery === "1.8.3") {
    Promise.origReject = Promise.reject;
    Promise.reject = function (pArg) {
      this.origReject(pArg);
      return $.Deferred().reject(pArg);
    };
  }
  if ($.isArray === undefined) {
    $.isArray = function (pInput) {
      console.warn("$.isArray is deprecated");
      return Array.isArray(pInput);
    };
  }
  if ($.isFunction === undefined) {
    $.isFunction = function (f) {
      console.warn("$.isFunction is deprecated");
      return typeof f === "function";
    };
  }
  if ($.trim === undefined) {
    $.trim = function (pContent) {
      console.warn("$.trim is deprecated");
      if (typeof pContent === "string" && typeof pContent.trim === "function") {
        return pContent.trim();
      }
      return pContent;
    };
  }
  if ($.parseJSON === undefined) {
    $.parseJSON = function (pInput) {
      console.warn("$.parseJSON is deprecated");
      return JSON.parse(pInput);
    };
  }
  if ($.Widget !== undefined) {
    // if jquery UI is present
    if ($.Widget.prototype._addClass === undefined) {
      // if jQuery UI is older then < 1.13
      $.Widget.prototype.classesElementLookup = {};
      $.Widget.prototype._classes = function (options) {
        var full = [];
        var that = this;
        options = $.extend({
          element: this.element,
          classes: this.options.classes || {}
        }, options);
        function bindRemoveEvent() {
          var nodesToBind = [];
          options.element.each(function (_, element) {
            var isTracked = $.map(that.classesElementLookup, function (elements) {
              return elements;
            }).some(function (elements) {
              return elements.is(element);
            });
            if (!isTracked) {
              nodesToBind.push(element);
            }
          });
          that._on($(nodesToBind), {
            remove: "_untrackClassesElement"
          });
        }
        function processClassString(classes, checkOption) {
          var current, i;
          for (i = 0; i < classes.length; i++) {
            current = that.classesElementLookup[classes[i]] || $();
            if (options.add) {
              bindRemoveEvent();
              var value = current.get().concat(options.element.get());
              if (value !== undefined) {
                if (typeof $.uniqueSort === "function") {
                  current = $($.uniqueSort(value));
                } else if (typeof $.unique === "function") {
                  current = $($.unique(value));
                }
              }
            } else {
              current = $(current.not(options.element).get());
            }
            that.classesElementLookup[classes[i]] = current;
            full.push(classes[i]);
            if (checkOption && options.classes[classes[i]]) {
              full.push(options.classes[classes[i]]);
            }
          }
        }
        if (options.keys) {
          processClassString(options.keys.match(/\S+/g) || [], true);
        }
        if (options.extra) {
          processClassString(options.extra.match(/\S+/g) || []);
        }
        return full.join(" ");
      };
      $.Widget.prototype._removeClass = function (element, keys, extra) {
        return this._toggleClass(element, keys, extra, false);
      };
      $.Widget.prototype._addClass = function (element, keys, extra) {
        return this._toggleClass(element, keys, extra, true);
      };
      $.Widget.prototype._toggleClass = function (element, keys, extra, add) {
        add = typeof add === "boolean" ? add : extra;
        var shift = typeof element === "string" || element === null,
          options = {
            extra: shift ? keys : extra,
            keys: shift ? element : keys,
            element: shift ? this.element : element,
            add: add
          };
        options.element.toggleClass(this._classes(options), add);
        return this;
      };
    }
  }
}

/* eslint-disable no-undef, no-extend-native, no-restricted-properties */
(function () {
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof2(globalThis)) === 'object') {
    return;
  }
  Object.prototype.__defineGetter__('__magic__', function () {
    return this;
  });
  __magic__.globalThis = __magic__;
  delete Object.prototype.__magic__;
})();
/* eslint-enable no-undef, no-extend-native, no-restricted-properties */

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"timers":409}],434:[function(require,module,exports){
"use strict";

/**
 * Documentation about the store, its integration in Proofscope, and how to use it : 
 * https://trac.hybridsoftware.com/hybrid/wiki/Proofscope
 * A quick tutorial can be found in the Store.md file on how to create a new component and use the store.
 */
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var JSONPatch = require("../../../JODANebula/Framework/General/JSON/js/nixps-JSONPatch.js");
var Environment = require("../../../EnvironmentVariables.js");

/**
 * Called when the [PageStore]{@link module:nixps/proofscope.PageStore} changes
 * @callback ~Listener
 * @memberof module:nixps/proofscope.Store
 */
/**
 * @class Store
 * @memberof module:nixps/proofscope
 * @property { Array<module:nixps/proofscope.PageStore> } history
 * @property { module:nixps/proofscope.Store~Listener } listeners
 * @property { module:nixps/proofscope.PageStore } data
 */
function Store() {
  this.history = []; // up to 100 latest actions on store
  this.listeners = [];
  this.call_stack_count = 0;
  this.data = null;
  this.removed_listeners = 0;
  this.listener_pointer = 0;
}
Store.__MEMO__ = {};
Store.prototype = {
  constructor: Store,
  /**
   * @function
   * @name Store.doWork
   * @description immediately execute procedure on this store. <br />
   *  Procedure takes one argument, a store
   * @argument {Function} the function to execute with one argument the Store itself
   * @returns {undefined}
   */
  doWork: function doWork(procedure) {
    procedure(this);
  },
  /**
   * @function
   * @name Store.performActions
   * @description the arguments are a list of actions.
   * Manipulates the state with all action and returns a new state
   * @param {Array.<Function>} An array of functions, which will be executed with one parameters: an object "data"
   * @returns {undefined}
   */
  performActions: function performActions() {
    var new_data = this.data;
    var actions = [];
    var actionsToPerform = arguments;
    if (Array.isArray(arguments[0])) {
      actionsToPerform = arguments[0];
    }
    for (var i = 0; i < actionsToPerform.length; i++) {
      new_data = actionsToPerform[i](new_data);
      actions.push(actionsToPerform[i]);
    }
    this._afterActions(new_data, actions);
  },
  /**
   * @function
   * @name Store.performAction
   * @description the argument action is a function that takes an object representing a state.
   * the action manipulates the state and returns a (new) state 
   * @param {Function} function will be executed this one parameter object "data"
   * @returns {undefined}
   */
  performAction: function performAction(action) {
    var new_data = action(this.data);
    this._afterActions(new_data, action);
  },
  /**
   * @function
   * @name Store._afterActions
   * @description 
   * If {pNewData} is a new state, execute all listeners
   * The state is made immutable and added to the history
   * @returns {undefined}
   */
  _afterActions: function _afterActions(pNewData, pHistory) {
    if (this.data !== pNewData) {
      if (Environment.DEBUG) {
        // this._deepFreeze(pNewData);
      }
      this.data = pNewData;
      this.addToHistory(pHistory, this.data);
      this.dispatchEvent();
    }
  },
  /**
   * @function
   * @name Store.addListener
   * @description adds a function callback (that takes no arguments) to the list of listeners.
   * @param {Function} The new listener function, called after each change of the store 
   * @returns {Function} a function that will remove the just added listener from the list of listeners.
   */
  addListener: function addListener(callback) {
    this.listeners.push(callback);
    callback();
    return function () {
      for (var i = 0, len = this.listeners.length; i < len; ++i) {
        if (this.listeners[i] === callback) {
          this.listeners.splice(i, 1);
          // correct for when a listener is removed while dispatching events
          if (this.listener_pointer <= i) {
            this.removed_listeners++;
          }
          break;
        }
      }
    }.bind(this);
  },
  /**
   * @description call all registered listeners
   * @name Store.dispatchEvent
   * @function
   * @returns {undefined}
   */
  dispatchEvent: function dispatchEvent() {
    this.removed_listeners = 0;
    this.listener_pointer = 0;
    for (; this.listener_pointer < this.listeners.length; ++this.listener_pointer) {
      this.listeners[this.listener_pointer - this.removed_listeners]();
    }
  },
  /**
   * @description Add information to a store for debugging purposes
   * @function
   * @name Store.addToHistory
   * @param {Object} action additional meta data for debug purposes    
   * @param {Object} data The actual core data of the store
   * @returns {undefined}
   */
  addToHistory: function addToHistory(action, data) {
    if (Environment.DEBUG) {
      this.history.push({
        action: action,
        data: data
      });
    } else {
      this.history.push(data);
    }
    if (this.history.length > 100) {
      this.history.shift();
    }
  },
  peepFromHistory: function peepFromHistory(offset) {
    if (offset === undefined) {
      offset = 0;
    }
    var len = this.history.length;
    var calOffset = offset + 1;
    if (len - calOffset < 0) {
      return null;
    }
    if (Environment.DEBUG) {
      return this.history[len - calOffset].data;
    } else {
      return this.history[len - calOffset];
    }
  },
  _deepFreeze: function _deepFreeze(object) {
    if (Array.isArray(object)) {
      for (var i = 0, len = object.length; i < len; ++i) {
        this._deepFreeze(object[i]);
      }
      Object.freeze(object);
    } else if (_typeof(object) === "object" && object !== null) {
      if (Object.isFrozen(object)) {
        return;
      }
      for (var prop in object) {
        if (object.hasOwnProperty(prop)) {
          this._deepFreeze(object[prop]);
        }
      }
      Object.freeze(object);
    }
  },
  /**
  * @description destroy the store, used in automated testing, to restore the browser environment
  * @name Store.destroy
  * @function
  * @returns {undefined}
  */
  destroy: function destroy() {
    this.alive = false;
    Store.doWork = function () {};
    Store.performActions = function () {};
    Store.performAction = function () {};
    Store.addListener = function () {
      return function () {};
    };
    Store.dispatchEvent = function () {};
    this.listeners = [];
  }
};
Store.createPartial = function (dictionary, key, value, default_value) {
  var partial = {};
  if (key in dictionary && _typeof(value) === "object" && !Array.isArray(value) && value !== null) {
    partial[key] = Object.assign({}, default_value, dictionary[key], value);
  } else {
    partial[key] = value || default_value;
  }
  return partial;
};
Store.addProperty = function (path, value) {
  return Store.setProperty(path, value);
};
Store.setProperty = function (path, value) {
  return function setPropterty(data) {
    return JSONPatch.patch(data, [JSONPatch._add(path, value)], true);
  };
};
Store.moveProperty = function (to, from) {
  return function (data) {
    return JSONPatch.patch(data, [JSONPatch._move(to, from)], true);
  };
};
Store.replaceProperty = function (path, value) {
  return function (data) {
    return JSONPatch.patch(data, [JSONPatch._replace(path, value)], true);
  };
};
Store.copyProperty = function (to, from) {
  return function (data) {
    return JSONPatch.patch(data, [JSONPatch._copy(to, from)], true);
  };
};
Store.removeProperty = function (path) {
  return function (data) {
    return JSONPatch.patch(data, [JSONPatch._remove(path)], true);
  };
};

/**
 * @description Compares the two objects.
 * Only checks if the properties in pObject are the same in pTo.
 * Ignores missing properties.
 * @function
 * @name Store.shallowCompare
 * @static
 * @param { Object } pObject 
 * @param { Object } pTo 
 * @param { Function } pCallback - Triggers a callback for each property
 * @returns { Boolean }
 */
Store.shallowCompare = function (pObject, pTo, pCallback) {
  for (var prop in pObject) {
    if (typeof pCallback === "function") {
      if (pCallback(prop, pObject[prop], pTo[prop]) === false) {
        if (Environment.DEBUG__PRINT_SHALLOW_COMPARE_FAILS) {
          console.warn('Redrawing because of ', prop);
          console.log(Store.diffObjects(pTo[prop], pObject[prop]));
        }
        return false;
      }
    } else if (pTo[prop] !== pObject[prop]) {
      if (Environment.DEBUG__PRINT_SHALLOW_COMPARE_FAILS) {
        console.warn('Redrawing because of ', prop);
        console.log(Store.diffObjects(pTo[prop], pObject[prop]));
      }
      return false;
    }
  }
  return true;
};

/**
 * Deep diff between two objects
 * @param {object} a - original object
 * @param {object} b - new object
 * @param {string} [path] - internal use (do not pass)
 * @returns {{added: Array, removed: Array, changed: Array}}
 */
Store.diffObjects = function () {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var result = {
    added: [],
    removed: [],
    changed: []
  };
  var keys = new Set([].concat(_toConsumableArray(Object.keys(a)), _toConsumableArray(Object.keys(b))));
  var _iterator = _createForOfIteratorHelper(keys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      var currentPath = path ? "".concat(path, ".").concat(key) : key;
      if (!(key in a)) {
        result.added.push({
          path: currentPath,
          value: b[key]
        });
        continue;
      }
      if (!(key in b)) {
        result.removed.push({
          path: currentPath,
          value: a[key]
        });
        continue;
      }
      var aVal = a[key];
      var bVal = b[key];
      var bothObjects = aVal && bVal && _typeof(aVal) === 'object' && _typeof(bVal) === 'object' && !Array.isArray(aVal) && !Array.isArray(bVal);
      if (bothObjects) {
        var _result$added, _result$removed, _result$changed;
        var nested = Store.diffObjects(aVal, bVal, currentPath);
        (_result$added = result.added).push.apply(_result$added, _toConsumableArray(nested.added));
        (_result$removed = result.removed).push.apply(_result$removed, _toConsumableArray(nested.removed));
        (_result$changed = result.changed).push.apply(_result$changed, _toConsumableArray(nested.changed));
      } else if (aVal !== bVal) {
        result.changed.push({
          path: currentPath,
          from: aVal,
          to: bVal
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};

/**
 * Use this to memoize the result of functions that map data from the store
 * Due to the structure of the store and it creating shallow copies on each change,
 * you can use that property to memoize some expensive mapping, like converting notes, that are used accross different components.
 * The args should be values from the store that will return a different value or object when the store is changed.
 * This makes the comparison of the args an inexpensive operation
 */
Store.__EMPTY_OBJECT__ = Object.freeze({});
Store.__EMPTY_ARRAY__ = Object.freeze([]);
Store.memoizeFromObject = function (name, object, value) {
  var args = [];
  for (var prop in object) {
    args.push(object[prop]);
  }
  return Store.memoize(name, args, value);
};
Store.memoize = function (name, args, value) {
  if (Environment.DEBUG__DISABLE_MEMOIZE === true) {
    return undefined;
  }
  function createMap(value) {
    if (_typeof(value) === "object" && value !== null) {
      return new WeakMap();
    } else {
      return new Map();
    }
  }
  function replaceArg(pArg) {
    if (Array.isArray(pArg) && pArg.length === 0) {
      return Store.__EMPTY_ARRAY__;
    } else if (_typeof(pArg) === "object" && pArg !== null && Object.keys(pArg).length === 0) {
      return Store.__EMPTY_OBJECT__;
    } else {
      return pArg;
    }
  }
  var map;
  var firstArg = replaceArg(args[0]);
  if (Environment.DEBUG) {
    var debug_obj = Store.__MEMO__[name];
    if (debug_obj === undefined) {
      Store.__MEMO__[name] = {
        map: createMap(firstArg),
        passesWithoutReturningValue: 0
      };
      map = Store.__MEMO__[name].map;
    } else {
      map = debug_obj.map;
    }
  } else {
    map = Store.__MEMO__[name];
    if (map === undefined) {
      Store.__MEMO__[name] = createMap(firstArg);
      map = Store.__MEMO__[name];
    }
  }
  for (var i = 0, len = args.length - 1; i < len; ++i) {
    var key = replaceArg(args[i]);
    if (key === null) {
      key = Store.__EMPTY_OBJECT__;
    }
    var sub_map = map.get(key);
    if (sub_map === undefined) {
      sub_map = createMap(replaceArg(args[i + 1]));
      map.set(key, sub_map);
    }
    map = sub_map;
  }
  if (value === undefined) {
    value = map.get(replaceArg(args[args.length - 1]));
    if (Environment.DEBUG && value === undefined && ++Store.__MEMO__[name].passesWithoutReturningValue > 1023) {
      throw new Error("memoize doesn't work properly for '" + name + "' or isn't necessary");
    } else if (Environment.DEBUG && value !== undefined) {
      Store.__MEMO__[name].passesWithoutReturningValue = 0;
    }
    return value;
  } else {
    map.set(replaceArg(args[args.length - 1]), value);
  }
};

/**
 * for jsunit tests, to be able to control the enviroment
 */
Store.clearMemoize = function () {
  Store.__MEMO__ = {};
};
Store.smartMemoize = function smartMemoize(key, constraints, builder) {
  var data = Store.memoize(key, constraints);
  if (typeof data === 'undefined') {
    data = builder();
    Store.memoize(key, constraints, data);
  }
  return data;
};
module.exports = Store;

},{"../../../EnvironmentVariables.js":9,"../../../JODANebula/Framework/General/JSON/js/nixps-JSONPatch.js":29}],435:[function(require,module,exports){
"use strict";

var IndexedStorage = require("../../common/BrowserStorage/js/IndexedStorage.js");
var UserPreferences = require("../../cloudflow/Preferences/js/UserPreferences.js");
var QueryApplier = require("../../cloudflow/CloudflowUtil/js/QueryApplier.js");
var Query = require("../../cloudflow/Table/js/Query.js");
var Version = require("../../cloudflow/Version/js/Version.js");
var License = require("../../cloudflow/License/js/License.js");
var Device = require("../../cloudflow/PWA/js/Device.js");
var TemporyBrowserObjectCache = require("../../common/BrowserStorage/js/TemporyBrowserObjectCache.js");
var BlueCollarProvider = function BlueCollarProvider(pOptions) {
  var that = this;
  this.alive = true;
  this.errorDurringSave = false;
  that.busy = $.Deferred(function (pDefer) {
    $.when(License.get(), Version.get(), UserPreferences.get()).then(function (pLicense, pVersion, pUserPreferences) {
      if (that.alive === false) {
        pDefer.resolve();
        return;
      }
      that.version = pVersion.getBuild();
      that.license = pLicense.getData().licenses;
      if (IndexedStorage.isSupported() === false) {
        // do not use indexDB if not supported
        pDefer.resolve();
        return;
      }
      if (TemporyBrowserObjectCache.isPageReload() == true && Device.getPollingFactor() === 1) {
        // only skip if page refresh in none panick mode
        pDefer.resolve();
        return;
      }
      // Check if dev mode is active, if so don't use cache.
      var devMode = localStorage.getItem("cloudflow_developer_mode");
      if (devMode == "true") {
        pDefer.resolve();
        return;
      }
      IndexedStorage.getLast("nixps.bluecollardefinition", []).then(function (pResult) {
        if (pResult.data && pResult.data.length > 0 && pResult.lang === pUserPreferences.getLanguage() && pResult.version === that.version && _.isEqual(pResult.license, that.license)) {
          // Only get the modification prop from bc definitions to check for changes
          api_defer.bluecollardefinition.list_with_options([], [], ["modification"]).then(function (pData) {
            var modified = [];
            var deleted = [];
            var unchanged = [];
            var added = [];

            // Detect which bluecollars are added, deleted, or modified.
            var lookupBlueCollar = {};
            for (var i = 0; i < pData.results.length; i++) {
              lookupBlueCollar[pData.results[i]._id] = pData.results[i];
            }
            var cacheData = {};
            for (var i = 0; i < pResult.data.length; i++) {
              cacheData[pResult.data[i]._id] = pResult.data[i];
            }
            for (var pCollarID in cacheData) {
              var collar = cacheData[pCollarID];
              if (lookupBlueCollar[collar._id] === undefined) {
                deleted.push(collar._id);
              } else if (lookupBlueCollar[collar._id].modification === collar.modification) {
                unchanged.push(collar._id);
              } else {
                modified.push(collar._id);
              }
              delete lookupBlueCollar[collar._id];
            }
            if (Object.keys(lookupBlueCollar).length > 0) {
              added = Object.keys(lookupBlueCollar);
            }
            if (modified.length === 0 && deleted.length === 0 && added.length === 0) {
              // Nothing is changed
              that.bluecollars = pResult.data;
              pDefer.resolve();
            } else {
              that.bluecollars = pResult.data;
              // Process the modifications
              that.processCacheChanges(modified, added, deleted).then(pDefer.resolve, pDefer.reject);
            }
          }, function (pError) {
            pDefer.reject(pError);
          });
        } else {
          pDefer.resolve();
        }
      })["catch"](function (pError) {
        // failed loading, contiouing like it was not supported
        console.error(pError);
        pDefer.resolve();
      });
    })["catch"](function (pError) {
      // failed loading license, version, userpref
      pDefer.reject(pError);
    });
  });
};
BlueCollarProvider.prototype = {
  constructor: BlueCollarProvider,
  /**
   * @description Process detected changes in bluecollardefinition collection. Update the cache.
   * @function
   * @name BlueCollarProvider#processCacheChanges
   */
  processCacheChanges: function processCacheChanges(pModifiedCollars, pAddedCollars, pDeletedCollars) {
    var that = this;
    if (!Array.isArray(pModifiedCollars)) {
      pModifiedCollars = [];
    }
    if (!Array.isArray(pAddedCollars)) {
      pAddedCollars = [];
    }
    if (!Array.isArray(pDeletedCollars)) {
      pDeletedCollars = [];
    }
    return $.Deferred(function (pDefer) {
      var collarsToGet = pModifiedCollars.concat(pAddedCollars);
      // Only get the required bc definitions
      api_defer.bluecollardefinition.list_with_options(["_id", "in", collarsToGet], []).then(function (pNewData) {
        var lookupToDelete = {};
        for (var i = 0; i < pNewData.results.length; i++) {
          lookupToDelete[pNewData.results[i]._id] = pNewData.results[i]._id;
        }
        for (var i = 0; i < pDeletedCollars.length; i++) {
          lookupToDelete[pDeletedCollars[i]] = pDeletedCollars[i];
        }
        var processedData = [];
        for (var i = 0; i < that.bluecollars.length; i++) {
          if (lookupToDelete[that.bluecollars[i]._id] === undefined) {
            processedData.push(that.bluecollars[i]);
          }
        }
        that.bluecollars = processedData.concat(pNewData.results);
        // Update the index storage
        if (IndexedStorage.isSupported() && that.errorDurringSave !== true) {
          IndexedStorage.set("nixps.bluecollardefinition", {
            data: that.bluecollars,
            lang: new UserPreferences().getLanguage(),
            version: that.version,
            license: that.license
          }).then(pDefer.resolve)["catch"](function (pError) {
            console.error("failed saving to cache", pError);
            that.errorDurringSave = true;
            pDefer.resolve();
          });
        } else {
          pDefer.resolve();
        }
      })["catch"](pDefer.reject);
    });
  },
  /**
   * @description Get the collars from the api
   * @function
   * @private
   * @name BlueCollarProvider#_getCollars
   */
  _getCollars: function _getCollars() {
    var that = this;
    return $.Deferred(function (pDefer) {
      api_defer.bluecollardefinition.list_with_options([], []).then(function (pResult) {
        if (pResult.results && pResult.results.length > 0) {
          that.bluecollars = pResult.results;
        }
        if (IndexedStorage.isSupported() && that.errorDurringSave !== true) {
          IndexedStorage.set("nixps.bluecollardefinition", {
            data: pResult.results,
            lang: new UserPreferences().getLanguage(),
            version: that.version,
            license: that.license
          }).then(function () {
            pDefer.resolve();
          })["catch"](function (pError) {
            // could not save
            console.error("failed saving to cache", pError);
            that.errorDurringSave = true;
            pDefer.resolve();
          });
        } else {
          pDefer.resolve();
        }
      })["catch"](function (error) {
        pDefer.reject(error);
      });
    });
  },
  /**
   * @description Get the collars from cache if possible
   * @function
   * @name BlueCollarProvider#list_with_options
   */
  list_with_options: function list_with_options(p_query, p_order_by, p_callback, p_error_callback) {
    var that = this;
    var setResult = function setResult() {
      var defer;
      // If no cached collars, update.
      if (!that.bluecollars || that.bluecollars.length <= 0) {
        defer = that._getCollars();
      }
      return $.when(defer).then(function () {
        var query = new QueryApplier(p_query || []);
        var filtered = query.apply(that.bluecollars);
        var result = Query.orderBy(filtered, p_order_by);
        if (typeof p_callback === "function") {
          p_callback({
            results: result
          });
        }
        return {
          results: result
        };
      })["catch"](function (pError) {
        if (typeof p_error_callback === "function") {
          p_error_callback(pError);
        }
        return Promise.reject(pError);
      });
    };
    return that.busy.then(function () {
      return setResult();
    })["catch"](function (pError) {
      return setResult();
    });
  },
  /**
   * @description List all collars with provided query
   * @function
   * @name BlueCollarProvider#list_with_options
   */
  list: function list(p_query, p_callback, p_error_callback) {
    var that = this;
    var setResult = function setResult() {
      var defer;
      if (!that.bluecollars || that.bluecollars.length <= 0) {
        defer = that._getCollars();
      }
      return $.when(defer).then(function () {
        var query = new QueryApplier(p_query || []);
        var filtered = query.apply(that.bluecollars);
        if (typeof p_callback === "function") {
          p_callback({
            results: filtered
          });
        }
        return {
          results: filtered
        };
      })["catch"](function (pError) {
        p_error_callback();
        return Promise.reject(pError);
      });
    };
    return that.busy.then(function () {
      return setResult();
    })["catch"](function (pError) {
      return setResult();
    });
  },
  /**
   * @description Add a collar to the cache, in case a new one is created.
   * @function
   * @name BlueCollarProvider#addToCache
   */
  addToCache: function addToCache(p_collar, p_callback, p_error_callback) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.list().then(function (bcs) {
        var result = bcs.results;
        if (result.some(function (pItem) {
          return pItem._id === p_collar._id;
        }) === true) {
          if (typeof p_callback === "function") {
            p_callback();
          }
          pDefer.resolve();
          return;
        }
        result.push(p_collar);
        if (!IndexedStorage.isSupported() || that.errorDurringSave === true) {
          if (result && result.length > 0) {
            that.bluecollars = result;
          }
          if (typeof p_callback === "function") {
            p_callback();
          }
          pDefer.resolve();
        } else {
          IndexedStorage.set("nixps.bluecollardefinition", {
            data: result,
            lang: new UserPreferences().getLanguage(),
            version: that.version,
            license: that.license
          }).then(function () {
            if (result && result.length > 0) {
              that.bluecollars = result;
            }
            if (typeof p_callback === "function") {
              p_callback();
            }
            pDefer.resolve();
          })["catch"](function (err) {
            console.error("failed saving to cache", err);
            that.errorDurringSave = true;
            if (typeof p_error_callback === "function") {
              p_error_callback(err);
            }
            pDefer.reject(err);
          });
        }
      })["catch"](function (err) {
        if (typeof p_error_callback === "function") {
          p_error_callback(err);
        }
        pDefer.reject(err);
      });
    });
  },
  deleteFromCache: function deleteFromCache(p_collar, p_callback, p_error_callback) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.list().then(function (bcs) {
        var result = bcs.results;
        // result could contain multiple with same _id
        result = result.filter(function (pItem) {
          return pItem._id !== p_collar._id;
        });
        if (!IndexedStorage.isSupported() || that.errorDurringSave === true) {
          if (result && result.length > 0) {
            that.bluecollars = result;
          }
          if (typeof p_callback === "function") {
            p_callback();
          }
          pDefer.resolve();
        } else {
          IndexedStorage.set("nixps.bluecollardefinition", {
            data: result,
            lang: new UserPreferences().getLanguage(),
            version: that.version,
            license: that.license
          }).then(function () {
            if (result && result.length > 0) {
              that.bluecollars = result;
            }
            if (typeof p_callback === "function") {
              p_callback();
            }
            pDefer.resolve();
          })["catch"](function (err) {
            console.error("failed saving to cache", err);
            that.errorDurringSave = true;
            if (typeof p_error_callback === "function") {
              p_error_callback(err);
            }
            pDefer.reject(err);
          });
        }
      })["catch"](function (err) {
        if (typeof p_error_callback === "function") {
          p_error_callback(err);
        }
        pDefer.reject(err);
      });
    });
  },
  updateFromCache: function updateFromCache(p_collar, p_callback, p_error_callback) {
    var that = this;
    return $.Deferred(function (pDefer) {
      that.list().then(function (bcs) {
        var result = bcs.results;
        // result could contain multiple with same _id
        result = result.map(function (pItem) {
          if (pItem._id === p_collar._id) {
            return p_collar;
          }
          return pItem;
        });
        if (!IndexedStorage.isSupported() || that.errorDurringSave === true) {
          if (result && result.length > 0) {
            that.bluecollars = result;
          }
          if (typeof p_callback === "function") {
            p_callback();
          }
          pDefer.resolve();
        } else {
          IndexedStorage.set("nixps.bluecollardefinition", {
            data: result,
            lang: new UserPreferences().getLanguage(),
            version: that.version,
            license: that.license
          }).then(function () {
            if (result && result.length > 0) {
              that.bluecollars = result;
            }
            if (typeof p_callback === "function") {
              p_callback();
            }
            pDefer.resolve();
          })["catch"](function (err) {
            console.error("failed saving to cache", err);
            that.errorDurringSave = true;
            if (typeof p_error_callback === "function") {
              p_error_callback(err);
            }
            pDefer.reject(err);
          });
        }
      })["catch"](function (err) {
        if (typeof p_error_callback === "function") {
          p_error_callback(err);
        }
        pDefer.reject(err);
      });
    });
  },
  /**
   * @brief Detects a hard page reload
   */
  isPageReload: function isPageReload() {
    return TemporyBrowserObjectCache.isPageReload() == true;
  },
  /**
   * @description Clears the cache
   * @function
   * @private
   * @name BlueCollarProvider#purge
   */
  purge: function purge() {
    this.bluecollars = undefined;
    if (IndexedStorage.isSupported()) {
      return IndexedStorage.clear("nixps.bluecollardefinition", []);
    } else {
      return;
    }
  },
  destroy: function destroy() {
    this.alive = false;
  }
};
module.exports = BlueCollarProvider;

},{"../../cloudflow/CloudflowUtil/js/QueryApplier.js":91,"../../cloudflow/License/js/License.js":175,"../../cloudflow/PWA/js/Device.js":198,"../../cloudflow/Preferences/js/UserPreferences.js":202,"../../cloudflow/Table/js/Query.js":211,"../../cloudflow/Version/js/Version.js":269,"../../common/BrowserStorage/js/IndexedStorage.js":278,"../../common/BrowserStorage/js/TemporyBrowserObjectCache.js":280}],436:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper */
(function ($) {
  "use strict";

  require("./nixps-quantum-EditableTable.js");
  require("./nixps-quantum-OpenCloudflowURL.js");
  require("./nixps-quantum-node_editor_valuecomposerinput.js");
  var ValueComposerUtil = require("../../cloudflow/ExpressionBuilder/js/ValueComposerUtil.js");
  $.widget("nixps-quantum.ConfigureArray", $["nixps-quantum"].EditableTable, {
    options: {
      /**
       * @brief the table columns headers
       */
      columnHeaders: [],
      /**
       * @brief show or not the headers
       */
      showHeaders: false,
      /**
       * @brief row data to display
       */
      rowData: [],
      /**
       * @brief make the array sortable
       */
      sortable: true,
      /**
       * @brief make the array openable in app builder if cloudflow url is detected
       * @type {Boolean}
       */
      openable: false,
      /**
      * @brief is the page embedded or not?
      */
      embedded: false,
      expressionListUUID: null,
      expressionScope: "workflow",
      scope: null,
      /**
       * @brief Prevent switching between text input & expressioneditor
       */
      preventEditorSwitch: false,
      /**
       * @brief renders one row
       * contract is that it must trigger an "change" event with the data on the "tr" element
       */
      renderRow: function renderRow(pData, pElement, rootComponent) {
        var that = this;
        var row = $("<tr>");
        var column = $("<td>").appendTo(row);
        if (pElement instanceof jQuery && pElement.length === 1) {
          row.appendTo(pElement);
        }
        column.append($("<div>").addClass("grip-container").append($("<div>").addClass("grip-handle grip")));
        if (Array.isArray(pData)) {
          var valueComposer = $("<div>");
          column.append(valueComposer);
          if (this.openable) {
            var openButton = $("<span>").OpenCloudflowURL({
              data: pData,
              embedded: this.embedded
            });
            var debounced_handleChange = _.debounce(function (pEvent, pValues) {
              openButton.OpenCloudflowURL("changeHandler", pEvent, pValues);
            }, 500);
          }
          valueComposer.node_editor_valuecomposerinput({
            expressionListUUID: that.expressionListUUID,
            expressionScope: that.expressionScope,
            name: "arow",
            change: function change(pEvent, pValues) {
              if (that.openable) {
                debounced_handleChange(pEvent, pValues);
              }
              row.trigger("changed");
            },
            extraIcon: this.openable === true,
            value: pData
          });
          if (this.openable) {
            valueComposer.append(openButton);
          }
          valueComposer.node_editor_valuecomposerinput("setValue", pData);
        } else {
          var input = $("<input>").addClass("normalInput");
          input.val(pData);
          if (this.openable) {
            var openButton = $("<span>").OpenCloudflowURL({
              data: pData,
              embedded: this.embedded
            });
            var debounced_handleChange = _.debounce(function (pEvent, pValues) {
              openButton.OpenCloudflowURL("changeHandler", pEvent, pValues);
            }, 500);
          }
          input.on("keyup", function (pEvent) {
            if (that.openable) {
              debounced_handleChange(pEvent, input.val());
            }
            row.trigger("changed");
          });
          column.append(input);
          if (this.openable) {
            column.append(openButton);
          }
        }
        row.detach();
        return row;
      },
      /**
       * @brief the data that is used when constructing a new row
       */
      newRowData: function newRowData() {
        return [{
          type: "com.nixps.quantum.value.0",
          value: ""
        }];
      },
      /**
       * @brief converts the row to data
       */
      convertRow: function convertRow(pRow) {
        if (pRow.find(":nixps-quantum-node_editor_valuecomposerinput").length > 0) {
          return pRow.find(":nixps-quantum-node_editor_valuecomposerinput").node_editor_valuecomposerinput("getValue");
        } else if (pRow.find("input").length > 0) {
          return pRow.find("input").val();
        }
        return "";
      }
    },
    _create: function _create() {
      this._super();
      this.element.addClass("nixps-quantum-EditableTable");
      this._on(this.element, {
        "click .normalInput": this._switchToValueComposer,
        "composercomponentrestoreoriginal": this._switchToNormal
      });
    },
    _switchToValueComposer: function _switchToValueComposer(pEvent) {
      if (this.options.preventEditorSwitch === true) {
        return;
      }
      if (pEvent.metaKey || pEvent.altKey) {
        var input = $(pEvent.target);
        var rowIndex = this.element.find("tbody tr").index(input.parents("tr"));
        this.options.rowData[rowIndex] = [{
          type: "com.nixps.quantum.value.0",
          value: input.val()
        }];
        this._draw();
        this._triggerChange();
      }
    },
    _switchToNormal: function _switchToNormal(pEvent) {
      if (this.options.preventEditorSwitch === true) {
        return;
      }
      var input = $(pEvent.target);
      var rowIndex = this.element.find("tbody tr").index(input.parents("tr"));
      this.options.rowData[rowIndex] = "";
      this._draw();
      this._triggerChange();
    },
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "rowData") {
        // make array
        if (["string", "number", "boolean"].includes(_typeof(pValue))) {
          var newValue = [pValue];
          arguments[1] = newValue; // use strict makes a copy, so we need to chane them too
          pValue = newValue;
        } else if (ValueComposerUtil.isValueComposerExtend(pValue) === true && ValueComposerUtil.getCastingFormat(pValue) !== "array") {
          var newValue = [pValue]; // use strict makes a copy, so we need to chane them too
          arguments[1] = newValue;
          pValue = newValue;
        }
      }
      this._superApply(arguments);
    }
  });
})(jQuery);

},{"../../cloudflow/ExpressionBuilder/js/ValueComposerUtil.js":114,"./nixps-quantum-EditableTable.js":438,"./nixps-quantum-OpenCloudflowURL.js":439,"./nixps-quantum-node_editor_valuecomposerinput.js":443}],437:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper */

(function ($) {
  require("./nixps-quantum-EditableTable.js");
  require("./nixps-quantum-node_editor_valuecomposerinput.js");
  $.widget("nixps-quantum.ConfigureObject", $["nixps-quantum"].EditableTable, {
    options: {
      /**
       * @brief the table columns headers
       */
      columnHeaders: ["Name", "Value"],
      /**
       * @brief show or not the headers
       */
      showHeaders: true,
      /** 
       * @brief row data to display
       */
      rowData: [],
      /** 
       * @brief row data to display
       */
      objectData: {},
      expressionListUUID: null,
      expressionScope: "workflow",
      /**
       * @brief renders one row
       * contract is that it must trigger an "change" event with the data on the "tr" element
       */
      renderRow: function renderRow(pData, pElement, pThis) {
        var valueComposer = $("<div>");
        var column1 = $("<td>").css("width", "40%").append($("<div>").addClass("grip-container").append($("<div>").addClass("grip-handle grip")));
        var row = $("<tr>").append(column1.append($("<input>").attr("spellcheck", "false").css("width", "calc(100% - 7px)"))).append($("<td>").css("width", "60%").append(valueComposer));
        if (pElement instanceof jQuery && pElement.length === 1) {
          row.appendTo(pElement);
        }
        var variableName = typeof pData.variable_name !== "string" || pData.variable_name.length === 0 ? "(no name)" : pData.variable_name;
        valueComposer.node_editor_valuecomposerinput({
          name: "__nixpsquantumconfigureobject" + pThis.uuid + "-" + variableName,
          subTitle: variableName,
          value: pData.value,
          expressionListUUID: this.expressionListUUID,
          expressionScope: this.expressionScope
        });
        var inputs = row.find("input");
        inputs.first().val(pData.variable_name);
        inputs.on("keyup", function () {
          row.trigger("changed");
        });
        var composer = row.find(".nixps-quantum-ComposerComponent");
        composer.on("composercomponentchange", function () {
          row.trigger("changed");
        });
        row.detach();
        return row;
      },
      /**
       * @brief the data that is used when constructing a new row
       */
      newRowData: function newRowData() {
        return {
          variable_name: "",
          value: [{
            type: "com.nixps.quantum.value.0",
            value: ""
          }]
        };
      },
      /**
       * @brief converts the row to data
       */
      convertRow: function convertRow(pRow) {
        var varname = pRow.find("input");
        var composer = pRow.find(".nixps-quantum-ComposerComponent");
        return {
          variable_name: varname.val(),
          value: composer.node_editor_valuecomposerinput("getValue")
        };
      }
    },
    /**
     * @brief triggers when the connector labels change
     */
    _triggerChange: function _triggerChange(pEvent) {
      this.options.objectData = {};
      for (var count = 0; count < this.options.rowData.length; ++count) {
        var row = this.options.rowData[count];
        if (typeof row.variable_name === "string" && row.variable_name !== "") {
          this.options.objectData[row.variable_name] = row.value;
        }
      }
      this._trigger("changed", pEvent, {
        data: this.options.objectData
      });
    },
    _create: function _create() {
      this.options.rowData = [];
      for (var key in this.options.objectData) {
        this.options.rowData.push({
          variable_name: key,
          value: this.options.objectData[key]
        });
      }
      this._super();
      this.element.addClass("nixps-quantum-EditableTable");
    }
  });
})(jQuery);

},{"./nixps-quantum-EditableTable.js":438,"./nixps-quantum-node_editor_valuecomposerinput.js":443}],438:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper */

(function ($) {
  /**
   * @namespace nixps-quantum.EditableTable
   * @description A table containing input fields where you can develop your own rows, getters, .... 
   */
  $.widget("nixps-quantum.EditableTable", $.Widget, {
    widgetEventPrefix: "editabletable",
    options: {
      /**
       * @brief the table columns headers
       * @name nixps-quantum.EditableTable#columnHeaders
       * @type {Array}
       * @default []
       */
      columnHeaders: [],
      /**
       * @brief show or not the headers
       * @name nixps-quantum.EditableTable#showHeaders
       * @type {Boolean}
       * @default true
       */
      showHeaders: true,
      /**
       * @brief row data to display
       * @name nixps-quantum.EditableTable#rowData
       * @type {Array}
       * @default []
       */
      rowData: [],
      /**
       * @brief renders one row
       * contract is that it must trigger an "change" event with the data on the "tr" element
       * @name nixps-quantum.EditableTable#renderRow
       * @type {Function}
       * @default function(){}
       */
      renderRow: function renderRow(pData, pElement) {},
      /**
       * @brief the data that is used when constructing a new row
       * @name nixps-quantum.EditableTable#newRowData
       * @type {Function}
       * @default function(){}
       */
      newRowData: function newRowData() {
        return undefined;
      },
      /**
       * @brief converts the row to data
       * @name nixps-quantum.EditableTable#convertRow
       * @type {Function}
       * @default function(){}
       */
      convertRow: function convertRow(pRow) {},
      /**
       * @brief called before the row is removed
       * @name nixps-quantum.EditableTable#beforeRemoveRow
       * @type {Function}
       * @default function(){}
       */
      beforeRemoveRow: function beforeRemoveRow(pRow) {},
      /**
       * @brief function that is called after table draw and stable data
       * @name nixps-quantum.EditableTable#afterDraw
       * @type {Function}
       * @default function(){}
       */
      afterDraw: function afterDraw(pRowData) {},
      /**
       * @brief the selector for the data rows from the table
       *        can be changed if some of the table rows should not be considered as data rows
       * @name nixps-quantum.EditableTable#rowRowSelector
       * @type {String}
       * @default "tr"
       */
      dataRowSelector: "tr",
      /**
       * @brief true if the editable table must be sortable
       * @name nixps-quantum.EditableTable#sortable
       * @type {Boolean}
       * @default true
       */
      sortable: true
    },
    _create: function _create() {
      this.element.addClass(this.widgetFullName);

      // Determine the amount of columns by generating a row with new data
      this.columns = this.options.renderRow(this.options.newRowData(), undefined, this, -1).children("td").length;
      this._on(this.element, {
        "click .addRowButton": this._addRowHandler,
        "click .removeRow": this._removeRowHandler,
        "changed tr": this._rowChangedHandler,
        "sortstop tbody": this._rowsSortedHandler,
        "animationend .newRow": this._handleAnimationEnd
      });
      this._draw();
    },
    /**
     * @brief adds a row in the routing table
     */
    _addRowHandler: function _addRowHandler(pEvent) {
      var row = $($(pEvent.target).parents("tr"));
      this._addRowAction(row);
    },
    /**
     * @brief removes a row from the table
     */
    _removeRowHandler: function _removeRowHandler(pEvent) {
      var button = $(pEvent.target);
      var row = button.parents("tr");
      var rowIndex = row.parent().children(this.options.dataRowSelector + ":not(.addRow)").index(row);
      if (rowIndex === -1) {
        return;
      }
      this.options.beforeRemoveRow(row);
      this.options.rowData.splice(rowIndex, 1);
      row.remove();
      this._triggerChange();
      this.options.afterDraw.call(this, this.options.rowData);
    },
    /**
     * @brief row has been edited
     */
    _rowChangedHandler: function _rowChangedHandler(pEvent) {
      var row = $(pEvent.target);
      var index = row.parent().children(this.options.dataRowSelector + ":not(.addRow)").index(row);
      if (index === -1) {
        this.options.afterDraw.call(this, this.options.rowData);
        return;
      }
      var updatedRow = this.options.convertRow(row);
      if (JSON.stringify(updatedRow) !== JSON.stringify(this.options.rowData[index])) {
        this.options.rowData[index] = this.options.convertRow(row);
        this._triggerChange();
      }
      this.options.afterDraw.call(this, this.options.rowData);
    },
    /**
     * @brief rows are resorted
     */
    _rowsSortedHandler: function _rowsSortedHandler(pEvent) {
      var that = this;
      var rows = this.element.find("tbody tr:not(.addRow)");
      var changed = false;
      rows.each(function (pIndex, pRow) {
        var row = $(pRow);
        var updatedRow = that.options.convertRow(row);
        if (JSON.stringify(updatedRow) !== JSON.stringify(that.options.rowData[pIndex])) {
          that.options.rowData[pIndex] = updatedRow;
          changed = true;
        }
      });
      if (changed) {
        this._triggerChange();
      }
    },
    _handleAnimationEnd: function _handleAnimationEnd(pEvent) {
      $(pEvent.target).closest(".newRow").removeClass("newRow");
    },
    /**
     * @brief triggers when the connector labels change
     */
    _triggerChange: function _triggerChange(pEvent) {
      this._trigger("changed", pEvent, {
        data: this.options.rowData
      });
    },
    /**
     * @brief redraw
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @brief draws the dialog according to the current state
     */
    _draw: function _draw() {
      var that = this;
      this.element.empty();
      var table = $("<table>").attr("role", "presentation");
      table.appendTo(this.element);
      if (this.options.showHeaders) {
        var header = $("<thead>");
        var headerRow = $("<tr>").appendTo(header);
        this.options.columnHeaders.forEach(function (pHeader) {
          var title = $("<th>").text(pHeader);
          headerRow.append(title);
        });
        header.appendTo(table);
      }
      var body = $("<tbody>");
      body.appendTo(table);
      body.append(this.options.rowData.map(function (pData, pIndex) {
        var row = that.options.renderRow(pData, body, that, pIndex);
        row.append($("<td>").addClass("nixps-quantum-EditableTable-remove-button-td").append(that._makeRowButtons()));
        return row;
      }));
      var emptyRow = $("<tr>");
      emptyRow.addClass("addRow");
      for (var i = 0; i < this.columns; i++) {
        emptyRow.append($("<td>"));
      }
      emptyRow.append($("<td>").append(this._makeAddButton().addClass("addRowButton")));
      body.append(emptyRow);
      if (this.options.sortable === true) {
        body.sortable({
          axis: "y",
          handle: ".grip",
          items: "tr:not(.nixps-quantum-EditableTable-NotSortable)",
          helper: function helper(e, ui) {
            ui.children().each(function () {
              $(this).css("min-width", $(this).width());
            });
            return ui;
          },
          stop: function stop(e, ui) {
            // reset width 
            ui.item.children().each(function () {
              $(this).css("min-width", "");
            });
          }
        });
      }
      this.options.afterDraw.call(this, this.options.rowData);
    },
    _addRowAction: function _addRowAction(pLastRow) {
      var index = pLastRow.parent().children(this.options.dataRowSelector).not(".addRow").index(pLastRow);
      var newRowData = this.options.newRowData();
      var rendered = this.options.renderRow(newRowData, this.element.find("tbody"), this, index + 1);
      rendered.addClass("newRow");
      rendered.append($("<td>").addClass("nixps-quantum-EditableTable-remove-button-td").append(this._makeRowButtons()));
      rendered.insertAfter(pLastRow);
      if (index === -1) {
        this.options.rowData.push(newRowData);
      } else {
        this.options.rowData.splice(index + 1, 0, newRowData);
      }
      this._triggerChange();
      this.options.afterDraw.call(this, this.options.rowData);
    },
    /**
     * @description Make a remove button
     * @function
     * @private
    * @name nixps-quantum.EditableTable#_makeRowButtons
     * @return {undefined}
     */
    _makeRowButtons: function _makeRowButtons() {
      var container = $("<div>").addClass("rowButtonsContainer");
      container.append($("<button>").attr("type", "button").addClass("cf-iconbutton cf-icon cf-icon-minus-circle removeRow removeRowButton listRemoveButton").attr("title", $.i18n._("nixps-cloudflow-ArrayInput.remove_row")));
      container.append(this._makeAddButton());
      return container;
    },
    /**
     * @description Make a add button.
     * @function
     * @private
    * @name nixps-quantum.EditableTable#_makeAddButton
     * @return {HTML} button
     */
    _makeAddButton: function _makeAddButton() {
      var button = $("<button>").attr("type", "button").addClass("cf-iconbutton cf-icon cf-icon-plus-circle addRowButton listAddButton").attr("title", $.i18n._("nixps-cloudflow-ArrayInput.add_row"));
      return button;
    },
    /**
     * @description Set the array to a specific value, function required to be handled in a formrenderer
     * @function
    * @name nixps-quantum.EditableTable#setValue
     * @param {type} pValue
     * @return {undefined}
     */
    setValue: function setValue(pValue) {
      this._setOption("rowData", pValue);
    },
    /**
     * @description Get the current data of the array. Function required to be handled in a formrenderer.
     * @function
    * @name nixps-quantum.EditableTable#getValue
     * @return {Array}
     */
    getValue: function getValue() {
      return this.options.rowData;
    },
    /**
     * @description add a new row
     * @function
     * @name nixps-quantum.EditableTable#addNewRow
     */
    addNewRow: function addNewRow() {
      var row = this.element.find("tr").last();
      this._addRowAction(row);
    },
    /**
     * @brief sets the option
     */
    _setOption: function _setOption(pKey, pValue) {
      this._superApply(arguments);
      if (pKey === "showHeaders") {
        this._draw();
      }
      if (pKey === "rowData") {
        this._draw();
      }
    }
  });
})(jQuery);

},{}],439:[function(require,module,exports){
"use strict";

(function ($) {
  require("../../cloudflow/EditorButton/js/nixps-cloudflow-OpenEditorButton.js");
  var ResourceProcessUtil = require("../../appview/js/ResourceProcessUtil.js");
  var correctScriptURLCache = [];
  var currentQueueId = 0;
  var lastFinishedId = 0;
  $.widget("nixps-quantum.OpenCloudflowURL", $["nixps-cloudflow"].OpenEditorButton, {
    options: {
      data: undefined,
      icon: "cf-icon cf-icon-database-query open-script-app-editor",
      linkTarget: "_blank",
      created: function created() {}
    },
    /**
     * @description Create the component
     * @name nixps.OpenCloudflowURL#_create
     * @function
     * @private
     * @returns {undefined}
     */
    _create: function _create() {
      this._superApply(arguments);
      this.changeHandler(null, this.options.data);
    },
    /**
           * @description Handles input change, display the button if it is openable
           * @name OpenCloudflowURL.changeHandler
     * @function
     * @param {Event} pEvent
     * @param {any} pValues
           */
    changeHandler: function changeHandler(pEvent, pValues) {
      var value = "";
      if (typeof pValues !== "string" && pValues) {
        try {
          var clonedValues = Array.isArray(pValues) ? JSON.parse(JSON.stringify(pValues)) : JSON.parse(JSON.stringify(pValues.value));
          value = ResourceProcessUtil.transformValueComposerToString(clonedValues);
        } catch (e) {
          // Do nothing the value is still empty, which is fine since we can"t do anything with it 
        }
      } else {
        value = pValues;
      }
      if (!value) {
        this.element.css("display", "none");
        return;
      }
      if (value.startsWith("cloudflow://") && value.endsWith(".js")) {
        this._checkIfOpenable(value);
      } else {
        this.element.css("display", "none");
      }
    },
    /**
           * @description Hide this element
           * @name OpenCloudflowURL.hide
     * @function
           */
    hide: function hide() {
      this.element.css("display", "none");
    },
    /**
           * @description Check if value is openalbe in an editor
           * @name OpenCloudflowURL._checkIfOpenable
     * @function
     * @param {String} pValue
           */
    _checkIfOpenable: function _checkIfOpenable(pValue) {
      var that = this;
      currentQueueId++;
      var callID = currentQueueId;
      var setButton = function setButton(shouldBeOpen) {
        if (lastFinishedId < callID) {
          if (shouldBeOpen === true) {
            that._setOptions({
              url: pValue
            });
          } else {
            that._setOptions({
              url: ""
            });
          }
          that.element.css("display", shouldBeOpen ? "" : "none");
        }
      };
      if (!pValue) {
        setButton(false);
        return;
      }
      if (correctScriptURLCache.indexOf(pValue) !== -1) {
        setButton(true);
        return;
      }
      try {
        api_async.file.does_exist(pValue, function (result) {
          if (result.valid && result.exists && !result.is_folder) {
            setButton(true);
            correctScriptURLCache.push(pValue);
          } else {
            setButton(false);
          }
        }, function () {
          setButton(false);
        });
      } catch (error) {
        setButton(false);
      }
    },
    _draw: function _draw() {
      this._superApply(arguments);
      this.element.attr("title", $.i18n._("nixps-cloudflow-ArrayInput.open_file"));
    }
  });
})(jQuery);

},{"../../appview/js/ResourceProcessUtil.js":48,"../../cloudflow/EditorButton/js/nixps-cloudflow-OpenEditorButton.js":106}],440:[function(require,module,exports){
"use strict";

/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals jQuery, $, QuantumNode, QuantumWhitepaper, _, console, jsoneditor */

(function ($) {
  var Completers = require("../../cloudflow/Script/js/scriptnodeAceCompleter.js");
  $.widget("nixps-quantum.ScriptEditor", $.Widget, {
    options: {
      /** 
       * @brief The script content to edit
                * @name nixps-quantum.ScriptEditor#script
                * @type {String}
                * @default ""
       */
      script: "",
      /**
       * @description the language you want to edit. can be "xml", "text"
       * @name nixps-quantum.ScriptEditor#mode
       * @type  {string}
       * @default "javascript"
       */
      mode: "javascript",
      /**
       * @description must we set the script on readonly or not?
       * @name nixps-quantum.ScriptEditor#readOnly
       * @type {Boolean}
       * @default false
       */
      readOnly: false,
      /**
       * @description Must we show a button to enable the fullscreen or not?
       * @name nixps-quantum.ScriptEditor#enableFullScreen
       * @type {Boolean}
       * @default true
       */
      enableFullScreen: true
    },
    _create: function _create() {
      var that = this;
      this._controlOptions();

      // Members
      this.mEditorController = null;
      this.mChangeListener = this._triggerChange.bind(this);

      // Init code
      this.element.addClass(this.widgetFullName);
      var editor = $("<div>");
      editor.css({
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      });
      editor.appendTo(this.element);
      if (this.options.enableFullScreen === true) {
        this.element.append($("<button>").attr("type", "button").addClass("scripteditor_fullScreenButton exposebutton nixps_enable_when_readonly").attr("name", "fullscreen").attr("title", "Fullscreen").append($("<span>").addClass("fa fa-arrows-alt")));
      }
      if (["xmlVariable", "textVariable", "jsonVariable"].includes(this.options.mode)) {
        ace.config.set("workerPath", "/cloudflow/ExpressionBuilder/aceworkers");
        ace.config.set("modePath", "/cloudflow/ExpressionBuilder/aceworkers");
      } else {
        // reset options
        ace.config.set("workerPath", "/3rdParty/ace/src-noconflict/");
        ace.config.set("modePath", "/3rdParty/ace/src-noconflict/");
      }
      var aceEditor = ace.edit(editor[0]);
      aceEditor.getSession().setMode("ace/mode/" + this.options.mode);
      // to disable a warning: 
      // Automatically scrolling cursor into view after selection change this will be disabled in the next version set editor.$blockScrolling = Infinity to disable this message
      aceEditor.$blockScrolling = Infinity;
      if (this.options.mode === "xml" || this.options.mode === "xmlVariable") {
        aceEditor.setTheme("ace/theme/crimson_editor");
      }
      this.mEditorController = aceEditor;
      this.mEditorController.setOptions({
        showPrintMargin: false,
        enableBasicAutocompletion: true
      });
      this.mEditorController.getSession().getDocument().setValue(this.options.script);
      this.mEditorController.getSession().on("change", this.mChangeListener);
      this.mEditorController.setBehavioursEnabled(false);
      this.mEditorController.getSession().setUseWrapMode(true);
      if (this.options.mode === "javascript") {
        // we are editing a script not a value composer
        Completers.init().done(function () {
          if (Array.isArray(that.mEditorController.completers)) {
            that.mEditorController.completers.push(Completers.getCompletion());
          } else {
            that.mEditorController.completers = [Completers.getCompletion()];
          }
        });
      }
      this.mEditorController.getSession().on("changeMode", function (e, session) {
        that._trigger("changemode", null, {});
      });
      this.mEditorController.on("input", function () {
        // event is triggers after creation
        if (that.options.readOnly === true) {
          that.mEditorController.setReadOnly(true);
        }
      });
      this._draw();
      this._on(true, this.element, {
        "click .scripteditor_fullScreenButton": this._fullScreenClickHandler
      });
      if (this.element.parents(".ui-dialog.ui-resizable").length > 0) {
        this.element.parents(".ui-dialog.ui-resizable").on("resize", this._resizeHandler.bind(this));
      }
    },
    _fullScreenClickHandler: function _fullScreenClickHandler(pEvent, pData) {
      this.element.toggleClass("scripteditor_fullscreen");
      if (this._trigger("fullscreen", null, {}) !== false) {
        this.resize();
      } else {
        // cancel
        this.element.toggleClass("scripteditor_fullscreen");
      }
    },
    /**
     * @brief redraws the json editor
     */
    redraw: function redraw() {
      this._draw();
    },
    /**
     * @description This function insert a text string at the position of the cursor event position
     * @function
     * @name nixps-quantum.ScriptEditor#insertTextAtPositionEvent
     * @param {string} pText the text to be inserted
     * @param {jqueryEvent} pEvent - the event to extract to extract the position
     * @returns {undefined}
     */
    insertTextAtPositionEvent: function insertTextAtPositionEvent(pText, pEvent) {
      if (typeof pText === "string") {
        // get the editor specific position i.f.o. the pointer event
        var position = this.mEditorController.renderer.screenToTextCoordinates(pEvent.pageX, pEvent.pageY);
        this.mEditorController.session.insert(position, pText);
      }
    },
    /**
     * @description Where must we set the cursor. This function set the cursor at the position of the Event object
     * @function
     * @name nixps-quantum.ScriptEditor#setCursorAtPointerEvent
     * @param {jqueryEvent} pEvent - the event to extract to extract the position
     * @returns {undefined}
     */
    setCursorAtPointerEvent: function setCursorAtPointerEvent(pEvent) {
      // get the editor specific position i.f.o. the pointer event
      this.mEditorController.selection.clearSelection();
      var position = this.mEditorController.renderer.screenToTextCoordinates(pEvent.pageX, pEvent.pageY);
      if ($.isPlainObject(position)) {
        this.mEditorController.selection.moveCursorToPosition(position);
      }
    },
    /**
     * @description put the focus on the editor
     * @function
     * @name nixps-quantum.ScriptEditor#focus
     * @returns {undefined}
     */
    focus: function focus() {
      this.mEditorController.focus();
    },
    /**
     * @description send options to the session worker 
     * @function
     * @param {object} pOptions
     * @returns {undefined}
     */
    setOptionsEditWorker: function setOptionsEditWorker(pOptions) {
      if (this.mEditorController.session !== undefined && this.mEditorController.session.$worker !== undefined && this.mEditorController.session.$worker !== null) {
        this.mEditorController.session.$worker.send("setOptions", [pOptions]);
      }
    },
    /**
     * @brief sets the options
     */
    _setOption: function _setOption(pKey, pValue) {
      if (pKey === "script" && pValue !== this.options.script) {
        this._superApply(arguments);
        this.mEditorController.getSession().off("change", this.mChangeListener);
        this.mEditorController.getSession().getDocument().setValue(pValue);
        this.mEditorController.getSession().on("change", this.mChangeListener);
      } else if (pKey === "mode" && pValue !== this.options.mode) {
        this._superApply(arguments);
        this.mEditorController.getSession().setMode("ace/mode/" + this.options.mode);
      } else if (pKey === "disabled" && pValue !== this.options.disabled) {
        this._superApply(arguments);
      } else if (pKey === "readOnly" && pValue !== this.options.readOnly) {
        this._superApply(arguments);
      }
    },
    _resizeHandler: function _resizeHandler() {
      this.resize();
    },
    /**
     * @description Inform that the parent has been resized,
     * so the editor can adapt his internal size
     * @function
     * @name nixps-quantum.ScriptEditor#resize
     * @returns {undefined}
     */
    resize: function resize() {
      this.mEditorController.resize();
    },
    /**
     * @brief triggers a change
     */
    _triggerChange: function _triggerChange(pChanges) {
      this.options.script = this.mEditorController.getSession().getDocument().getValue();
      this._trigger("change", null, {
        script: this.options.script
      });
    },
    /**
     * @brief private draw method
     */
    _draw: function _draw() {
      if (this.options.script !== this.mEditorController.getSession().getDocument().getValue()) {
        this.mEditorController.getSession().off("change", this.mChangeListener);
        this.mEditorController.getSession().getDocument().setValue(this.options.script);
        this.mEditorController.getSession().on("change", this.mChangeListener);
      }
      this.mEditorController.renderer.onResize(true, this.mEditorController.renderer.$gutter.offsetWidth, this.element.width(), this.element.height());
    },
    /**
     * @description control the input options
     * @returns {undefined}
     */
    _controlOptions: function _controlOptions() {
      if (typeof this.options.mode !== "string" || this.options.mode.length <= 2) {
        throw new Error("input option mode must be a not empty string");
      }
    },
    _destroy: function _destroy() {
      // kill current worker, because otherwise we will be overloaded by workers
      this.mEditorController.getSession().$stopWorker();
    }
  });
})(jQuery);

},{"../../cloudflow/Script/js/scriptnodeAceCompleter.js":206}],441:[function(require,module,exports){
"use strict";

/*globals jQuery, _, Number, $, nixps, window, namespace */

(function () {
  if (window.nixps === undefined) {
    window.nixps = {};
  }
  if (nixps.quantum === undefined) {
    nixps.quantum = {};
  }
  if (nixps.quantum.util === undefined) {
    nixps.quantum.util = {};
  }

  /** 
   * @brief Filter for elements that need to be autobounded
   */
  function autoBindFilter(pIndex, pElement) {
    var element = $(pElement);

    // It doesn't have a parent with the attribute nixps-quantum-util-autobind set to false
    var noAutoBind = element.parents('[nixps-quantum-util-autobind="false"]').length > 0 || element.attr("nixps-quantum-util-autobind") === "false";
    return !noAutoBind;
  }

  /**
   * @brief Filter for elements that are part of a composer element
   */
  function isNotPartOfComposer(pForm, pIndex, pElement) {
    var element = $(pElement);
    var composer = element.parent().closest(".nixps-quantum-ComposerComponent");
    var hasResult = pForm.has(composer);
    if (hasResult.length === 1 && hasResult[0] === pForm[0]) {
      return false;
    }
    return true;
  }

  /**
   * @brief Filters the known registered advanced components
   */
  function standardHTML5Input(pIndex, pElement) {
    var element = $(pElement);
    var knownComponent = element.is(".nixps-quantum-ValueInput") || element.is(".nixps-quantum-PathChooser");
    return !knownComponent;
  }

  /**
   * @brief Converts the form parameters to JSON
   */
  function collectToJSON(pForm, pDefaults, pCustomCollect) {
    var json = pDefaults;
    var notPartOfComposer = _.partial(isNotPartOfComposer, pForm);
    pForm.find("input:visible").filter(autoBindFilter).filter(standardHTML5Input).filter(notPartOfComposer).not('[type=submit]').each(function (pIndex, pInput) {
      var input = $(pInput);
      if (input.closest(".prevent-input-detection").length > 0 && !input.hasClass("prevent-input-detection")) {
        return;
      }
      var fieldname = input.attr("name");
      if (input.attr("type") === "checkbox") {
        nixps.quantum.util.setField(json, fieldname, input.is(":checked"));
      } else if (input.attr("type") === "radio") {
        nixps.quantum.util.setField(json, fieldname, $('input[name="' + fieldname + '"]:checked').attr("value"));
      } else if (input.attr("type") === "number" || input.attr("data-nixps-quantum-type") === "number") {
        nixps.quantum.util.setField(json, fieldname, parseFloat(input.val()));
      } else {
        nixps.quantum.util.setField(json, fieldname, input.val());
      }
    });
    pForm.find("select:visible").filter(autoBindFilter).filter(standardHTML5Input).filter(notPartOfComposer).each(function (pIndex, pSelect) {
      var select = $(pSelect);
      var fieldname = select.attr("name");
      if (select.attr("data-nixps-quantum-type") === "number") {
        nixps.quantum.util.setField(json, fieldname, parseFloat(select.val()));
      } else {
        nixps.quantum.util.setField(json, fieldname, select.val());
      }
    });
    pForm.find("textarea:visible").filter(autoBindFilter).filter(standardHTML5Input).filter(notPartOfComposer).each(function (pIndex, pTextarea) {
      var textarea = $(pTextarea);
      var fieldname = textarea.attr("name");
      nixps.quantum.util.setField(json, fieldname, textarea.val());
    });
    pForm.find(".nixps-quantum-ComposerComponent:visible").filter(autoBindFilter).filter(notPartOfComposer).each(function (pIndex, pComposer) {
      var valuecomposer = $(pComposer);
      var fieldname = valuecomposer.attr("name");
      var value = valuecomposer.data("ComposerComponent").getValue();
      nixps.quantum.util.setField(json, fieldname, value);
    });
    pForm.find(".nixps-quantum-ValueInput:visible").filter(autoBindFilter).filter(notPartOfComposer).each(function (pIndex, pElement) {
      var element = $(pElement);
      var fieldname = element.ValueInput("option", "name");
      nixps.quantum.util.setField(json, fieldname, element.ValueInput("getValue"));
    });
    pForm.find(".custom_input:visible").filter(autoBindFilter).filter(notPartOfComposer).filter(standardHTML5Input).each(function (pIndex, pElement) {
      var element = $(pElement);
      var fieldname = element.attr("data-name");
      if (typeof fieldname !== "string" || fieldname.length <= 0) {
        fieldname = element.attr("name");
      }
      var classOfComp = element.attr("class").split(" ").filter(function (v) {
        return v.indexOf("nixps-quantum") >= 0 || v.indexOf("nixps-cloudflow") >= 0;
      })[0];
      var componentName = classOfComp.split("-").pop();
      nixps.quantum.util.setField(json, fieldname, element[componentName]("getValue"));
    });
    pForm.find(".nixps-quantum-PathChooser:visible").filter(autoBindFilter).filter(notPartOfComposer).each(function (pIndex, pElement) {
      var element = $(pElement);
      var fieldname = element.PathChooser("option", "name");
      nixps.quantum.util.setField(json, fieldname, element.PathChooser("getValue"));
    });
    var custom = pCustomCollect(json);
    var parameters = $.extend(json, custom.parameters);
    var connectors = structuredClone(custom.connectors);
    return {
      parameters: parameters,
      connectors: connectors
    };
  }

  /**
   * @brief called when the parameters are changed
   */
  function parametersChanged(pForm, pNewParameters) {
    pForm.trigger("parameterschanged", pNewParameters);
  }

  /**
   * @brief binds the components change events
   */
  function bindComponents(pComponent, pForm, pDefaults, pCustomCollect) {
    if (!(pComponent instanceof jQuery)) {
      return;
    }
    pComponent.each(function (pIndex, pComp) {
      var component = $(pComp);
      if (component.is(".nixps-quantum-ValueInput")) {
        component.on("valueinputchange.autobind", function () {
          parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
        });
      } else if (component.is(".nixps-quantum-PathChooser")) {
        component.on("pathchooserchange.autobind", function () {
          parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
        });
      } else if (component.is("input")) {
        if (component.attr("type") === "submit") {} else if (component.attr("type") === "checkbox" || component.attr("type") === "radio") {
          component.on("click.autobind", function () {
            parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
          });
        } else {
          component.on("change.autobind input.autobind", function () {
            parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
          });
        }
      } else if (component.is("select")) {
        component.on("change.autobind", function () {
          parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
        });
      } else if (component.is("textarea")) {
        component.on("change.autobind input.autobind", function () {
          parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
        });
      } else if (component.is(".nixps-quantum-ComposerComponent")) {
        component.on("composercomponentchange.autobind", function () {
          parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
        });
      } else if (component.is(".custom_input")) {
        var classOfComp = component.attr("class").split(" ").filter(function (v) {
          return v.indexOf("nixps-quantum") >= 0 || v.indexOf("nixps-cloudflow") >= 0;
        })[0];
        var componentName = classOfComp.split("-").pop().toLowerCase();
        component.on(componentName + "change.autobind", function () {
          parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
        });
      }
    });
  }

  /** 
   * @brief creates and binds the value composers in the form
   */
  function createValueComposers(pComponents, pComposerCreateFunction, pForm, pDefaults, pCustomCollect) {
    if (!(pComponents instanceof jQuery)) {
      return;
    }
    var names = pComponents.map(function (pIndex, pValue) {
      if (!$(pValue).is("[data-nixps-quantum-onlyplainobject]")) {
        return $(pValue).attr("name");
      }
    }).toArray();
    names = _.uniq(names);
    names.forEach(function (pName) {
      var components = pComponents.filter('[name="' + pName + '"]');
      if (components.is(".nixps-quantum-ValueInput")) {
        var classes = [];
        if (typeof components.attr("class") === "string") {
          classes = components.attr("class").split(/\s+/);
        }
        classes.splice(classes.indexOf("nixps-quantum-ValueInput"), 1);
        var composer = $("<div>"); //.addClass(classes);
        composer.insertAfter(components);
        composer.hide();
        pComposerCreateFunction(composer, components);
        bindComponents(composer, pForm, pDefaults, pCustomCollect);
      } else if (components.attr("type") === "radio") {
        // Radios and checkboxes are handled differently
        var parent = components.first().parent();
        var composerdiv = parent.clone().empty();
        composerdiv.hide();
        composerdiv.insertAfter(parent);
        pComposerCreateFunction(composerdiv, components);
        bindComponents(composerdiv, pForm, pDefaults, pCustomCollect);
      } else {
        var classes = [];
        if (typeof components.attr("class") === "string") {
          classes = components.attr("class").split(/\s+/);
        }
        // var composer = $("<div>").addClass(classes);
        var composer = $("<div>");
        composer.insertAfter(components);
        composer.hide();
        pComposerCreateFunction(composer, components);
        bindComponents(composer, pForm, pDefaults, pCustomCollect);
      }
    });
  }

  /**
   * @brief binds the value composer switch event (Alt or Option + click)
   */
  function bindValueComposerSwitch(pComponents, pForm, pDefaults, pCustomCollect) {
    if (!(pComponents instanceof jQuery)) {
      return;
    }
    var names = pComponents.map(function (pIndex, pValue) {
      if (!$(pValue).is("[data-nixps-quantum-onlyplainobject]")) {
        return $(pValue).attr("name");
      }
    }).toArray();
    names = _.uniq(names);
    names.forEach(function (pName) {
      var components = pComponents.filter('[name="' + pName + '"]');
      var composer = pForm.find('.nixps-quantum-ComposerComponent[name="' + pName + '"]');
      components.on("click.autobind", function (pEvent) {
        if (pEvent.metaKey || pEvent.altKey) {
          var parameters = collectToJSON(pForm, pDefaults, pCustomCollect);
          var composer = pForm.find('.nixps-quantum-ComposerComponent[name="' + pName + '"]');
          if (composer.length === 0) {
            return true;
          }
          composer.data("ComposerComponent").setValue([{
            type: "com.nixps.quantum.value.0",
            value: nixps.quantum.util.getField(parameters.parameters, pName) + ""
          }]);
          if (components.attr("type") === "radio") {
            // Radios are handled differently
            var parent = components.first().parent();
            parent.hide();
          } else {
            components.hide();
          }
          composer.show();
          parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
          return false;
        }
        return true;
      });

      // packz bugs
      // for special case where the input[type=radio] is not triggered because it is hidden after the label
      // and the alt click on label will not trigger click on input
      if (components.is("[type=radio]")) {
        components.next("label").on("click", function (pEvent) {
          if (pEvent.metaKey || pEvent.altKey) {
            var parameters = collectToJSON(pForm, pDefaults, pCustomCollect);
            var composer = pForm.find('.nixps-quantum-ComposerComponent[name="' + pName + '"]');
            if (composer.length === 0) {
              return true;
            }
            composer.data("ComposerComponent").setValue([{
              type: "com.nixps.quantum.value.0",
              value: nixps.quantum.util.getField(parameters.parameters, pName) + ""
            }]);
            var inputComponent = $(pEvent.target).closest("label").prev("input");
            inputComponent.first().parent().hide();
            composer.show();
            parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
            return false;
          }
        });
      } else if (components.is("[type=checkbox]")) {
        components.next().next("label").on("click", function (pEvent) {
          if (pEvent.metaKey || pEvent.altKey) {
            var parameters = collectToJSON(pForm, pDefaults, pCustomCollect);
            var composer = pForm.find('.nixps-quantum-ComposerComponent[name="' + pName + '"]');
            if (composer.length === 0) {
              return true;
            }
            composer.data("ComposerComponent").setValue([{
              type: "com.nixps.quantum.value.0",
              value: nixps.quantum.util.getField(parameters.parameters, pName) + ""
            }]);
            var inputComponent = $(pEvent.target).closest("label").prev().prev("input");
            inputComponent.hide();
            composer.show();
            parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
            return false;
          }
        });
      } else if (components.is("select, .nixps-quantum-DurationInput, .nixps-cloudflow-Select")) {
        // use mousedown because Safari does not fire click event
        components.on("mousedown", function (pEvent) {
          if (pEvent.metaKey || pEvent.altKey) {
            var parameters = collectToJSON(pForm, pDefaults, pCustomCollect);
            var composer = pForm.find('.nixps-quantum-ComposerComponent[name="' + pName + '"]');
            if (composer.length === 0) {
              return true;
            }
            composer.data("ComposerComponent").setValue([{
              type: "com.nixps.quantum.value.0",
              value: nixps.quantum.util.getField(parameters.parameters, pName) + ""
            }]);
            components.hide();
            composer.show();
            parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
            return false;
          }
        });
      }
      composer.on("click.autobind", function (pEvent) {
        if (pEvent.metaKey || pEvent.altKey) {
          var controls = pForm.find('[name="' + pName + '"]').filter(":not(.nixps-quantum-ComposerComponent)");
          if (controls.length === 0) {
            return true;
          }
          if (controls.attr("type") === "radio") {
            controls.first().parent().show();
          } else {
            controls.show();
            var currentValue = $(this).node_editor_valuecomposerinput("getTextRepresentation");
            if (typeof currentValue === "string") {
              if (controls.is(".nixps-cloudflow-ValueInput")) {
                controls.ValueInput("setValue", parseFloat(currentValue));
              } else if (controls.is("input[type=text]")) {
                controls.val(currentValue);
              } else if (controls.is("input[type=number]")) {
                controls.val(parseFloat(currentValue));
              } else if (controls.is("select")) {
                if (controls.find("option[value='" + currentValue + "']").length === 1) {
                  controls.val(currentValue);
                }
              } else if (controls.is("input[type=checkbox]")) {
                if (currentValue.toLocaleLowerCase() === "true") {
                  controls.prop("checked", true);
                } else if (currentValue.toLocaleLowerCase() === "false") {
                  controls.prop("checked", false);
                }
              }
            }
          }
          $(this).hide();
          var parameters = collectToJSON(pForm, pDefaults, pCustomCollect);
          parametersChanged(pForm, parameters);
          return false;
        }
        return true;
      });
      components.on("paste.autobind", function (pEvent) {
        var htmlData = pEvent.originalEvent.clipboardData.getData("text/html");
        if (typeof htmlData === "string" && htmlData.includes("data-blockid=") && htmlData.includes("<img")) {
          var parameters = collectToJSON(pForm, pDefaults, pCustomCollect);
          var composer = pForm.find('.nixps-quantum-ComposerComponent[name="' + pName + '"]');
          if (composer.length === 0) {
            return true;
          }
          composer.data("ComposerComponent").setValue([{
            type: "com.nixps.quantum.value.0",
            value: nixps.quantum.util.getField(parameters.parameters, pName) + ""
          }]);
          if (components.attr("type") === "radio") {
            // Radios are handled differently
            var parent = components.first().parent();
            parent.hide();
          } else {
            components.hide();
          }
          composer.show();
          composer.find(".nixps-quantum-ExpressionEditor").ExpressionEditor("addContent", htmlData);
          parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
          return false;
        }
      });
    });
  }

  /** 
   * @brief the generic autobind function
   */
  nixps.quantum.util.genericAutoBind = function (pForm, pDefaults, pCustomCollect, pComposerCreateFunction, pIsComposerValue) {
    // Define a custom collect if not passed
    if (pCustomCollect === undefined) {
      pCustomCollect = function pCustomCollect() {
        return {};
      };
    }

    // if pForm is a HTMLElement but not a jQuery, cast to jQuery
    if (pForm instanceof HTMLElement) {
      pForm = $(pForm);
    }

    // Registers the events
    var notPartOfComposer = _.partial(isNotPartOfComposer, pForm);
    var controls = pForm.find("select,input,textarea,.custom_input");
    controls = controls.filter(function () {
      if ($(this).closest(".prevent-input-detection").length > 0 && !$(this).hasClass("prevent-input-detection")) {
        return false;
      }
      return true;
    });
    controls = controls.add(pForm.find(".nixps-quantum-PathChooser"));
    controls = controls.filter(autoBindFilter);
    controls = controls.filter(notPartOfComposer);
    bindComponents(controls, pForm, pDefaults, pCustomCollect);
    createValueComposers(controls, pComposerCreateFunction, pForm, pDefaults, pCustomCollect);
    bindValueComposerSwitch(controls, pForm, pDefaults, pCustomCollect);

    // Registers the setparameters event
    pForm.on("setparameters.autobind", function (pEvent, pParameters) {
      var fieldNames = pForm.find("input[name], select[name], textarea[name], .custom_input[name], .nixps-quantum-PathChooser[name], .nixps-quantum-ValueInput[name]").filter(function () {
        if ($(this).closest(".prevent-input-detection").length > 0 && !$(this).hasClass("prevent-input-detection")) {
          return false;
        }
        return true;
      }).filter(autoBindFilter).map(function (pIndex, pValue) {
        return $(pValue).attr("name");
      }).toArray();
      fieldNames.forEach(function (pFieldName) {
        var value = nixps.quantum.util.getField(pParameters, pFieldName);
        var components = pForm.find('input[name="' + pFieldName + '"], select[name="' + pFieldName + '"], textarea[name="' + pFieldName + '"], .custom_input[name="' + pFieldName + '"], .nixps-quantum-PathChooser[name="' + pFieldName + '"], .nixps-quantum-ValueInput[name="' + pFieldName + '"]');
        components = components.filter(function () {
          if ($(this).closest(".prevent-input-detection").length > 0 && !$(this).hasClass("prevent-input-detection")) {
            return false;
          }
          return true;
        });
        if (pIsComposerValue(value)) {
          if (components.attr("type") === "radio") {
            // Radios are handled differently
            var parent = components.first().parent();
            parent.hide();
          } else {
            components.hide();
          }
          var valuecomposer = pForm.find('.nixps-quantum-ComposerComponent[name="' + pFieldName + '"]').show();
          valuecomposer.data("ComposerComponent").setValue(value);
          valuecomposer.show();
        } else {
          var valuecomposer = pForm.find('.nixps-quantum-ComposerComponent[name="' + pFieldName + '"]').show();
          valuecomposer.hide();
          if (components.attr("type") === "radio") {
            // Radios are handled differently
            var parent = components.first().parent();
            parent.show();
          } else {
            components.show();
          }
          if (components.is(".nixps-quantum-ValueInput")) {
            components.ValueInput("setValue", value);
          } else if (components.is(".nixps-quantum-PathChooser")) {
            components.PathChooser("setValue", value);
          } else if (components.is("select")) {
            if (value !== undefined) {
              components.val(value);
            }
          } else {
            var inputType = components.attr("type");
            if (inputType === undefined) {
              inputType = components.attr("data-type");
            }
            switch (inputType) {
              case "radio":
                components.prop("checked", false);
                components.filter('[value=' + value + ']').prop("checked", true);
                break;
              case "select":
                components.val(value);
                break;
              case "checkbox":
                if (value) {
                  components.prop("checked", true);
                } else {
                  components.prop("checked", false);
                }
                break;
              case "custom":
                var classOfComp = components.attr("class").split(" ").filter(function (v) {
                  return v.indexOf("nixps-quantum") >= 0 || v.indexOf("nixps-cloudflow") >= 0;
                })[0];
                var componentName = classOfComp.split("-").pop();
                components[componentName]("setValue", value);
                break;
              default:
                components.val(value);
                break;
            }
          }
        }
      });
    });
    pForm.on("customchange.autobind", function () {
      parametersChanged(pForm, collectToJSON(pForm, pDefaults, pCustomCollect));
    });
  };
})();

},{}],442:[function(require,module,exports){
"use strict";

(function ($) {
  $.widget("nixps-quantum.node_editor_input", $.Widget, {
    options: {
      /** 
       * @brief the name of the input
       */
      name: null
    },
    _create: function _create() {
      if (typeof this.options.name !== 'string' || this.options.name.length <= 0) {
        throw new Error('invalid name');
      }
    },
    setValue: function setValue(pValue) {},
    getValue: function getValue() {},
    triggerChange: function triggerChange() {
      this._trigger("change", null, {
        name: this.options.name,
        value: this.getValue()
      });
    }
  });
})(jQuery);

},{}],443:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
(function ($) {
  require("./nixps-quantum-node_editor_input.js");
  require("../../cloudflow/ExpressionBuilder/js/nixps-quantum-ExpressionBuilder.js");
  var ValueComposerUtil = require("../../cloudflow/ExpressionBuilder/js/ValueComposerUtil.js");
  var entitycomposerCollectionDef, entitycomposerWorkflowCollectionDef, entitycomposerPagebuilderCollectionDef;
  getEntitycomposerCollection();
  function getEntitycomposerCollection() {
    if (entitycomposerCollectionDef === undefined) {
      if (window.api_mock !== undefined) {
        if (api_mock.entitycomposer) {
          entitycomposerCollectionDef = api_mock.entitycomposer.list();
          entitycomposerWorkflowCollectionDef = api_mock.entitycomposer.list();
        }
        if (api_mock.entitycomposerpagebuilder) {
          if (entitycomposerCollectionDef === undefined) {
            entitycomposerCollectionDef = api_mock.entitycomposerpagebuilder.list();
          }
          entitycomposerPagebuilderCollectionDef = api_mock.entitycomposerpagebuilder.list();
        }
      }
    }
    return entitycomposerCollectionDef;
  }
  function translateToValueComposer(pValue, pTranslationKey, pFallBackValue) {
    return ValueComposerUtil.translateToValueComposer(pValue);
  }

  /**
   * @description The expression input for workflows.
   * triggers next events
   * <dl>
   *    <dt>dialogopen</dt>
   *    <dt>dialogclose</dt>
   *    <dt>action</dt> <dd> save or cancel </dd>
   *    <dt>restoreoriginal</dt>
   * </dl>
   * @namespace nixps-quantum.node_editor_valuecomposerinput
   * @version 1.2.0
   */
  $.widget("nixps-quantum.node_editor_valuecomposerinput", $["nixps-quantum"]["node_editor_input"], {
    version: "1.2.0",
    widgetEventPrefix: "composercomponent",
    options: {
      /**
       * @brief the value composer to show
       * @name nixps-quantum.node_editor_valuecomposerinput#value
       * @type {Array}
       * @default []
       */
      value: [],
      /**
       * @brief optional unit to display, when fields with units are composed
       * @name nixps-quantum.node_editor_valuecomposerinput#unitName
       */
      unitName: null,
      /**
       * @brief The name of the input
       * @name nixps-quantum.node_editor_valuecomposerinput#name
       * @type {String}
       * @default ""
       */
      name: "",
      /**
       * @description The name of the node, to be used as fallback, the we donet have a node
       * or it will be the first part of the dialog title when it is not a node
       * @name nixps-quantum.node_editor_valuecomposerinput#mainTitle
       * @type {String}
       * @default "unknown"
       * @since 1.1.0
       */
      mainTitle: "unknown",
      /**
       * @description The sub dialog title, if not defined it will use the name
       * @name nixps-quantum.node_editor_valuecomposerinput#subTitle
       * @type {String}
       * @default undefined
       * @since 1.2.0
       */
      subTitle: undefined,
      /**
       * @description which format must the expression have, to which must it force to be.
       * @name nixps-quantum.node_editor_valuecomposerinput#forceFormat
       * @example "string", "number", "boolean"
       * @type {String}
       */
      forceFormat: null,
      /**
       * @description Can the user add an array to the expression builder or not?
       * @name nixps-quantum.node_editor_valuecomposerinput#acceptArray
       * @type {Boolean}
       * @default false
       * @deprecated
       */
      acceptArray: false,
      /**
       * @description The context to be used for the expressionBuilder
       * @name nixps-quantum.node_editor_valuecomposerinput#context
       * @type {Object}
       * @default null
       * @since 1.1.0
       */
      context: null,
      /**
       * @description The complete context configuration if the api call has been runed before
       * @name nixps-quantum.node_editor_valuecomposerinput#contextConfiguration
       * @type {Object}
       * @default null
       * @since 1.1.0
       */
      contextConfiguration: null,
      /**
       * @description show the original state button, or hide it
       * @name nixps-quantum.node_editor_valuecomposerinput#showOriginalStateButton
       * @type {Boolean}
       * @default true
       */
      showOriginalStateButton: true,
      /**
       * @description  the classes to be added to the expressuinbuilder.js
       * @name nixps-quantum.node_editor_valuecomposerinput#editorDialogClasses
       * @type {String}
       * @default undefined
       */
      editorDialogClasses: undefined,
      /**
       * @description The zIndex of the overlay
       * @name nixps-quantum.node_editor_valuecomposerinput#zIndexOverlay
       * @type {Number}
       * @default 100100
       */
      zIndexOverlay: 100100,
      /**
       * @description Whether or not we have an extra icon, if yes we add extra spacing
       * @name nixps-quantum.node_editor_valuecomposerinput#extraIcon
       * @type {Boolean}
       * @default false
       */
      extraIcon: false,
      /**
       * @description Technical ID to identifier the expression, to prevent conflict between multiple open expressions
       * @name nixps-quantum.node_editor_valuecomposerinput#expressionListUUID
       * @type {String}
       * @default null
       */
      expressionListUUID: null,
      expressionScope: "workflow",
      /**
       * @description Save objects and arrays as an "com.nixps.quantum.object.0" expression.
       * @name nixps-quantum.node_editor_valuecomposerinput#useObjectExpression
       * @type {Boolean}
       * @default false
       */
      useObjectExpression: false,
      /**
       * @description The consent object
       * @name nixps-quantum.node_editor_valuecomposerinput#consent
       * @type {Object}
       * @default null
       */
      consent: null,
      /**
       * @description Must we return the native value if possible, otherwise it returns always a value composer
       * @name nixps-quantum.node_editor_valuecomposerinput#acceptNativeValue
       * @type {Boolean}
       * @default false
       */
      acceptNativeValue: false
    },
    /** 
     * @brief creates the value composer
     */
    _create: function _create() {
      this._super();
      var that = this;
      this.element.addClass(this.widgetFullName).addClass("nixps-quantum-ComposerComponent").attr("name", this.options.name);

      // variables
      this.validInput = true; // flag indication the input is valid or not

      //add expressionEditor
      var expressionEditor = $("<div>").addClass("valuecomposerinput-expressionEditor cf-form-control").css({
        "width": this.options.extraIcon ? "calc(100% - 44px)" : "calc(100% - 26px)"
      });
      this.element.prepend(expressionEditor);
      $.when(getEntitycomposerCollection()).done(function (pResults) {
        expressionEditor.ExpressionEditor({
          forceFormat: that.options.forceFormat,
          entityComposerDefinitionResults: pResults.results,
          scope: that.options.expressionScope,
          expressionListUUID: that.options.expressionListUUID,
          expressionScope: that.expressionScope,
          useObjectExpression: that.options.useObjectExpression
        });
        if (Array.isArray(that.options.value) && that.options.value.length === 0 || that.options.value === "" || that.options.value === undefined) {
          // allow empty value
        } else if (Array.isArray(that.options.value) || $.isPlainObject(that.options.value)) {
          that.setValue(that.options.value, true);
        } else if (that.options.acceptNativeValue === true && ["string", "number", "boolean"].includes(_typeof(that.options.value))) {
          that.setValue(that.options.value, true);
        } else {
          that.validInput = false;
          that.element.addClass("node_editor_valuecomposerinput_invalid");
          that.disable();
        }
        if (that.options.disabled) {
          that.disable();
        }
      });
      this.element.append($("<span>").addClass("unit").css({
        "position": "relative",
        "margin-left": "5px",
        "bottom": "4px",
        "text-align": "left"
      }).hide());
      this.element.append($("<button>").attr("type", "button").addClass("editbutton").append($("<div>").addClass("cf-icon cf-icon-pencil")));
      this.element.data("ComposerComponent", {
        getValue: this.getValue.bind(this),
        setValue: this.setValue.bind(this)
      });
      this._on(this.element, {
        "click .editbutton": this._editClickedHandler,
        "expressioneditorchange": this.triggerChange,
        "click": this._restoreOriginalHandler
      });
    },
    triggerChange: function triggerChange(pForce) {
      if (pForce === true) {
        this._super();
        return;
      }
      var newValue = this.getValue(),
        oldValue = this.options.value;
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.options.value = this.getValue();
        this._super();
      }
    },
    _editClickedHandler: function _editClickedHandler() {
      var that = this;
      var mainDialogTitle = this.options.mainTitle;
      var context;
      if ($.isPlainObject(this.options.context)) {
        context = this.options.context;
      } else {
        var nodeID, whitepaperID, nodeDefinition;
        var nodeEditor = this.element.parents(".nixps-quantum-BlueCollarNodeEditor");
        if (nodeEditor.length > 0) {
          var parentNode = nodeEditor.BlueCollarNodeEditor("option", "parentNode");
          whitepaperID = nodeEditor.BlueCollarNodeEditor("option", "whitePaper").mID;
          var collarInstance = parentNode.BlueCollarNode("option", "blueCollarInstance");
          // for fields in nodes, overwrite and use node title
          mainDialogTitle = collarInstance.getTitle();
          nodeID = collarInstance.getID();
          nodeDefinition = collarInstance.getBlueCollarDefinition().mJSON.node_definition;
        }
        context = {
          id: whitepaperID,
          node_id: nodeID,
          parameter_name: this.options.name,
          node_definition: nodeDefinition
        };
      }
      var getValueComposerEditorConfiguration;
      if (this.options.contextConfiguration !== null) {
        getValueComposerEditorConfiguration = this.options.contextConfiguration;
      } else {
        getValueComposerEditorConfiguration = $.Deferred(function (pDefer) {
          api_async.whitepaper.get_value_composer_editor_configuration(context, pDefer.resolve, pDefer.reject);
        });
      }
      var dialogTitle;
      if (typeof this.options.subTitle === "string" && this.options.subTitle.length > 0) {
        dialogTitle = mainDialogTitle + " / " + this.options.subTitle;
      } else {
        dialogTitle = mainDialogTitle + " / " + that.options.name;
      }
      this._trigger("dialogopen", null, {});
      this.mExpressionBuilder = $("<div>");
      //addClass ui-front to make sure jQuery dialog component picks it up as it searches for siblings(!) with this class to calculate the z-index of the next dialog to open
      this.mOverlay = $("<div>").addClass("cf-overlay cf-overlay-dark").addClass("ui-front").css({
        "background-color": "rgba(0, 0, 0, 0.5)",
        "z-index": this.options.zIndexOverlay
      }).prependTo($("body")).append(this.mExpressionBuilder);

      // default filter query
      var query = [];
      $.when(api_defer.valuecomposer.list(query, []), getEntitycomposerCollection()).then(function (pResults, entitycomposerResults) {
        that.mExpressionBuilder.ExpressionBuilder({
          title: dialogTitle,
          classes: that.options.editorDialogClasses,
          valueComposer: that.options.value,
          valueComposerCollection: pResults.results,
          context: context,
          getValueComposerEditorConfiguration: getValueComposerEditorConfiguration,
          entityComposerDefinitionResults: entitycomposerResults.results,
          simulation: that._calcResult,
          forceFormat: that.options.forceFormat,
          showOriginalStateButton: that.options.showOriginalStateButton,
          consent: that.options.consent,
          scope: "workflow",
          cancel: function cancel() {
            that.mOverlay.remove();
            that._trigger("action", null, {
              action: "cancel"
            });
            that._trigger("dialogclose", null, {});
          },
          save: function save(pEvent, pData) {
            if (pData === undefined || pData === null) {
              throw new Error("missing event data valuecomposer");
            }
            that.setValue(pData.valueComposer);
            that.triggerChange(true);
            that.mOverlay.remove();
            that._trigger("action", null, {
              action: "save"
            });
            that._trigger("dialogclose", null, {});
          }
        });
      })["catch"](function (pError) {
        console.error(pError);
      });
    },
    _calcResult: function _calcResult(pJSON, pContext) {
      var request = [];
      var type = "string";
      if (pJSON.length > 0 && Array.isArray(pJSON[0]) && pJSON[0].length > 0 && Array.isArray(pJSON[0][0])) {
        type = "array";
        for (var i = 0; i < pJSON.length; i++) {
          request.push({
            composer: pJSON[i],
            context: pContext
          });
        }
      } else if (Array.isArray(pJSON)) {
        for (var i = 0; i < pJSON.length; i++) {
          request.push({
            composer: pJSON[i],
            context: pContext
          });
        }
      } else if (_typeof(pJSON) === "object") {
        type = "object";
        request = [{
          composer: pJSON,
          context: pContext
        }];
      }
      var addDecorations = function addDecorations(pVal) {
        if (Array.isArray(pVal)) {
          var isConcat = true;
          var resultArr = "[";
          for (var i = 0; i < pVal.length; i++) {
            if (typeof pVal[i] !== "string") {
              isConcat = false;
            }
            resultArr = resultArr + addDecorations(pVal[i]);
            if (i !== pVal.length - 1) {
              resultArr = resultArr + ", ";
            }
          }
          return isConcat ? pVal.join("") : resultArr + "]";
        } else if ($.isPlainObject(pVal)) {
          var resultObj = "{";
          var decoKeys = Object.keys(pVal);
          for (var i = 0; i < decoKeys.length; i++) {
            var ele = pVal[decoKeys[i]];
            resultObj = resultObj + decoKeys[i] + ": " + addDecorations(ele);
            if (i !== decoKeys.length - 1) {
              resultObj = resultObj + ", ";
            }
          }
          return resultObj + "}";
        } else {
          return pVal;
        }
      };
      return $.Deferred(function (pDefer) {
        api_async.whitepaper.evaluate_value_composer(request, function (result) {
          if ($.isPlainObject(result) === false || Array.isArray(result.evaluated) === false) {
            pDefer.reject({
              error_code: " wrong_return_interface",
              error: "the retuning interface is wrong"
            });
            return;
          }
          var evaluated = result.evaluated;
          for (var i = 0; i < evaluated.length; i++) {
            if ($.isPlainObject(evaluated[i]) === false) {
              pDefer.reject({
                error_code: " wrong_return_interface",
                error: "the retuning interface is wrong"
              });
              return;
            }
          }
          if (type === "string") {
            pDefer.resolve(_.reduce(evaluated, function (pPrev, pNext) {
              return pPrev + pNext.result;
            }, ""));
          } else if (type === "array") {
            pDefer.resolve(_.reduce(evaluated, function (pPrev, pNext) {
              return pPrev + addDecorations(pNext.result);
            }, ""));
          } else if (type === "object") {
            pDefer.resolve(JSON.stringify(evaluated[0].result, function (key, value) {
              if (Array.isArray(value) && value.length === 1 && ["string", "number", "boolean"].includes(_typeof(value[0]))) {
                return value[0];
              }
              return value;
            }, 3));
          }
        }, function (pError) {
          console.error(pError);
          pDefer.reject(pError);
        });
      });
    },
    /**
     * @brief hides the value composer and restores the original elements
     * @function
     * @private
     * @name nixps-quantum.node_editor_valuecomposerinput#_restoreOriginalHandler
     */
    _restoreOriginalHandler: function _restoreOriginalHandler(pEvent) {
      if (pEvent.metaKey || pEvent.altKey) {
        this._trigger("restoreoriginal", pEvent, {});
        return false;
      }
      return true;
    },
    /** 
     * @brief creates a value composer given the input
     * @function
     * @name nixps-quantum.node_editor_valuecomposerinput#setValue
     * @returns {undefined}
     */
    setValue: function setValue(pValue, pForce) {
      var that = this;
      var newValue = this.getValue();
      if (pForce !== true && JSON.stringify(newValue) === JSON.stringify(pValue)) {
        return;
      }
      this.options.value = translateToValueComposer(pValue);
      try {
        this.element.find(":nixps-quantum-ExpressionEditor").ExpressionEditor("option", "valueComposer", this.options.value);
        this.element.removeClass("node_editor_valuecomposerinput_invalid");
        if (this.validInput === false) {
          this.validInput = true;
        }
      } catch (e) {
        console.error(e);
        that.validInput = false;
        that.element.addClass("node_editor_valuecomposerinput_invalid");
        that.disable();
      }
      if (typeof this.options.unitName === "string" && this.options.unitName.length > 0) {
        var unit = this.element.find(".unit").text(this.options.unitName).show();
        var width; // calc the width we must have
        if (unit.outerWidth() > 25) {
          width = "calc(100% - " + (40 + unit.outerWidth()) + "px)";
        } else {
          width = "calc(100% - 80px)";
          unit.css("width", 20);
        }
        // implement this width
        this.element.find(".nixps-quantum-ExpressionEditor").css({
          width: width
        });
      } else {
        this.element.find(".nixps-quantum-ExpressionEditor").css({
          width: this.options.extraIcon ? "calc(100% - 44px)" : "calc(100% - 26px)"
        });
        this.element.find(".unit").hide();
      }
    },
    /**
     * @brief returns the value composer contents
     * @function
     * @name nixps-quantum.node_editor_valuecomposerinput#getValue
     * @returns {array} the value composer that it the value
     */
    getValue: function getValue() {
      if (entitycomposerCollectionDef === undefined) {
        console.warn("node_editor_valuecomposerinput getValue before init");
        return this.options.value;
      }
      if (this.validInput === false) {
        // if value is invalid, just return the original value,
        // this could be a future yet unknown expression builder format
        return this.options.value;
      }
      if (this.element.find(".nixps-quantum-ExpressionEditor").length === 0) {
        // init fase
        return this.options.value;
      }
      var valuecomposer = this.element.find(".nixps-quantum-ExpressionEditor").ExpressionEditor("option", "valueComposer");
      if (valuecomposer instanceof jQuery) {
        // error no value composer found
        return this.options.value;
      } else if (this.options.acceptNativeValue === true) {
        // same code as ExpressionBuilderInput.js
        if (valuecomposer.length === 1 && valuecomposer[0].type === "com.nixps.quantum.value.0") {
          return valuecomposer[0].value; // if so, return just that string
        }

        return valuecomposer;
      } else {
        return valuecomposer;
      }
    },
    reset: function reset() {
      this.setValue("");
    },
    /**
     * @description get the value composer as string
     * @function
     * @name nixps-quantum.node_editor_valuecomposerinput#getTextRepresentation
     * @returns {string} the expression as text format
     */
    getTextRepresentation: function getTextRepresentation() {
      if (this.validInput === false) {
        // if value is invalid, just return the original value,
        // this could be a future yet unknown expression builder format
        return "";
      }
      return this.element.find(".nixps-quantum-ExpressionEditor").ExpressionEditor("getTextualRepresentation");
    },
    _setOption: function _setOption(key, value) {
      this._superApply(arguments);
      if (key === "disabled") {
        if (value === true) {
          this.element.find(".nixps-quantum-ExpressionEditor").ExpressionEditor("disable");
        } else {
          this.element.find(".nixps-quantum-ExpressionEditor").ExpressionEditor("enable");
        }
      }
    },
    /**
     * @brief destructor, removes the expression builder dialog
     * @function
     * @private
     * @name nixps-quantum.node_editor_valuecomposerinput#_destroy
     */
    _destroy: function _destroy() {
      this.element.removeClass(this.widgetFullName).removeClass("nixps-quantum-ComposerComponent").removeAttr("name");
      this.element.find(".nixps-quantum-ExpressionEditor").ExpressionEditor("destroy");
      this.element.find(".nixps-quantum-ExpressionEditor, .editbutton, .unit").remove();
      if (this.mOverlay !== undefined) {
        this.mOverlay.remove();
      }
    }
  });
})(jQuery);

},{"../../cloudflow/ExpressionBuilder/js/ValueComposerUtil.js":114,"../../cloudflow/ExpressionBuilder/js/nixps-quantum-ExpressionBuilder.js":121,"./nixps-quantum-node_editor_input.js":442}],444:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*jslint white:true, nomen:true, sloppy:true, vars:true, regexp:true*/
/*globals window, $, api_sync, nixps, namespace, _ */
(function () {
  if (window.nixps === undefined) {
    window.nixps = {};
  }
  if (nixps.quantum === undefined) {
    nixps.quantum = {};
  }
  if (nixps.quantum.util === undefined) {
    nixps.quantum.util = {};
  }

  /**
   * @brief Parses an object field, private
   */
  function parseField(pField) {
    if (typeof pField !== "string") {
      throw new Error('"name" attribute of an input or select field is not a string, forgot to disable with nixps-quantum-util-autobind="false"?');
    }
    var elements = pField.split(".");

    // Check the elements
    var isValid = _.reduce(elements, function (pAccumulator, pElement) {
      return pAccumulator && typeof pElement === "string" && pElement.length > 0;
    }, true);
    if (!isValid) {
      throw new Error("could not parse the \"name\" attribute of an input or select field: " + pField);
    }
    return elements;
  }

  /**
   * @brief Check if a value is an expression or not.
   */
  function _isExpression(pValueComposerJSON) {
    return Array.isArray(pValueComposerJSON) && pValueComposerJSON.length > 0 && typeof pValueComposerJSON[0].type === "string" && pValueComposerJSON[0].type.length > 0;
  }
  ;

  /** 
   * @briefs sets the field of an object to a key
   * @deprecated use CloudflowObject.setParameter
   */
  nixps.quantum.util.setField = function (pObject, pStructuredField, pValue) {
    if (!$.isPlainObject(pObject)) {
      throw new Error("invalid parameter");
    }
    var elements = parseField(pStructuredField);
    var last = pObject;
    if (Array.isArray(elements)) {
      elements.forEach(function (pElement, pIndex) {
        if (pIndex === elements.length - 1) {
          last[pElement] = pValue;
          return false;
        }
        if (last[pElement] === undefined) {
          if (pIndex === elements.length - 1) {
            last[pElement] = pValue;
          } else {
            last[pElement] = {};
            last = last[pElement];
          }
        } else {
          last = last[pElement];
        }
      });
    }
  };

  /**
   * @brief gets the field value given a key
   * @deprecated use CloudflowObject.getParameter
   */
  nixps.quantum.util.getField = function (pObject, pStructuredField) {
    if (!$.isPlainObject(pObject)) {
      throw new Error("invalid parameter");
    }
    var elements = parseField(pStructuredField);
    var last = pObject;
    for (var i = 0; i < elements.length; i++) {
      if (last[elements[i]] === undefined) {
        return undefined;
      } else {
        last = last[elements[i]];
      }
    }
    return last;
  };

  /** 
   * @brief unbinds the fields of the form
   */
  nixps.quantum.util.unbind = function (pForm) {
    pForm.off("setparameters.autobind");
    pForm.find("input").off("keydown.autobind keyup.autobind click.autobind");
  };

  /**
   * @brief binds the fields automatically
   */
  nixps.quantum.util.autoBind = function (pForm, pCollarParameters, pCustomCollect) {
    function createValueComposer(pComposer, pComponents) {
      var name = pComponents.attr("name");
      // get forceFormat, look first to added attr "type"
      var forceFormat = pComponents.attr("data-nixps-quantum-type"); // can be undefined or something else
      // are array allowed
      var acceptArray = false; // to be defined pComponents.attr("data-nixps-quantum-accept_array") == "true"; // can be undefined or something else

      // if no attr is added, try to gest a good one
      if (forceFormat === undefined) {
        if (pComponents.is("input[type=checkbox]")) {
          // if checkbox add "boolean"
          forceFormat = "boolean";
        } else if (pComponents.is("input[type=number]")) {
          // if type is number convert to number
          forceFormat = "number";
        }
      }
      if (pComponents.is(".nixps-quantum-ValueInput")) {
        pComposer.node_editor_valuecomposerinput({
          unitName: pComponents.ValueInput("option", "storageUnit"),
          name: name,
          forceFormat: forceFormat === undefined ? "number" : forceFormat,
          // use number as default, so developer can always overrule it
          acceptArray: acceptArray
        });
      } else if (pComponents.is(":nixps-quantum-DurationInput")) {
        pComposer.node_editor_valuecomposerinput({
          unitName: pComponents.DurationInput("option", "unit"),
          name: name,
          forceFormat: forceFormat,
          acceptArray: acceptArray
        });
      } else {
        pComposer.node_editor_valuecomposerinput({
          name: name,
          forceFormat: forceFormat,
          acceptArray: acceptArray
        });
      }
    }
    function isValueComposer(pValue) {
      return nixps.quantum.util.isValueComposer(pValue);
    }
    nixps.quantum.util.genericAutoBind(pForm, pCollarParameters, pCustomCollect, createValueComposer, isValueComposer);
  };

  /**
   * @brief loads an entity composer editor from a string
   */
  nixps.quantum.util.loadEntityComposerEditorFromString = function (pNodeEditorHTMLString, pParentElement, pLoadedCallback, pEntityComposer) {
    if (typeof pEntityComposer.constructor !== "function" || pEntityComposer.constructor.name !== "EntityComposer") {
      throw new Error("invalid entity composer");
    }
    var form = $(pNodeEditorHTMLString);

    // Get form and script from the form
    var formData = form.filter("form");
    var scriptData = form.filter("script");

    // Append the form
    formData.on("submit", function () {
      return false;
    });
    pParentElement.append(formData);

    // Append and load the associated script
    window.LOADED_FORM = formData;
    window.ENTITY_COMPOSER = pEntityComposer;
    $("body").append(scriptData);
    delete window.LOADED_FORM;
    delete window.ENTITY_COMPOSER;
    pLoadedCallback(formData);
    return scriptData;
  };

  /**
   * @brief loads a node editor from a string
   */
  nixps.quantum.util.loadNodeEditorFromString = function (pNodeEditorHTMLString, pParentElement, pCollarParameters, pLoadedCallback, pNode) {
    var pIsCompare = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var pCompareBlueCollar = arguments.length > 6 ? arguments[6] : undefined;
    var editable = null;
    if (pNode instanceof nixps.presets.BlueCollarDefinitionAdapter) {
      editable = pNode;
    }
    if (pNode !== undefined) {
      if (!(pNode instanceof jQuery) || !pNode.is(".nixps-quantum-BlueCollarNode")) {
        throw new Error("invalid parameter");
      } else {
        if (pIsCompare === true) {
          editable = pCompareBlueCollar.clone();
        } else {
          editable = pNode.BlueCollarNode("option", "blueCollarInstance").clone();
        }
      }
    }
    var form = $(pNodeEditorHTMLString);

    // Get form and script from the form
    var formData = form.filter("form");
    var scriptData = form.filter("script");

    // Append the form
    formData.on("submit", function () {
      return false;
    });
    pParentElement.append(formData);

    // Append and load the associated script
    window.LOADED_FORM = formData;
    window.COLLAR_PARAMETERS = pCollarParameters;
    window.QUANTUM_NODE = editable;
    window.NODE_UTIL_CLASS = {
      isValueComposer: nixps.quantum.util.isValueComposer,
      // License: nixps.cloudflow.License,
      Version: nixps.cloudflow.Version,
      UnitPreferences: nixps.cloudflow.UnitPreferences,
      UserPreferences: nixps.cloudflow.UserPreferences
    };
    $("body").append(scriptData);
    delete window.LOADED_FORM;
    delete window.COLLAR_PARAMETERS;
    delete window.QUANTUM_NODE;
    delete window.NODE_UTIL_CLASS;
    pLoadedCallback(formData);
    return scriptData;
  };

  /**
   * @brief Detect casting format on a valuecomposer
   */
  nixps.quantum.util.getCastingFormat = function (pValueComposerJSON) {
    // short cut for empty things
    if (Array.isArray(pValueComposerJSON) && pValueComposerJSON.length === 0) {
      return "as_is";
    }
    // no value composers, return null 
    if (nixps.quantum.util.isValueComposer(pValueComposerJSON) === false) {
      return null;
    }
    // first item is array > array
    if (Array.isArray(pValueComposerJSON[0])) {
      return "array";
      // global is plain object > object
    } else if (_typeof(pValueComposerJSON) === "object" && !Array.isArray(pValueComposerJSON)) {
      return "object";
    }

    // converters
    if (pValueComposerJSON[0].type === "com.nixps.quantum.type_converter.0") {
      if (pValueComposerJSON[0].top_level === true) {
        return pValueComposerJSON[0].to_type;
      }
      // fallback old setups
      if (Array.isArray(pValueComposerJSON[0].value) && pValueComposerJSON[0].value.length <= 1) {
        return "as_is";
      }
      return pValueComposerJSON[0].to_type;
    }
    // plain object
    if (pValueComposerJSON[0].type === "com.nixps.quantum.object.0") {
      if ($.isPlainObject(pValueComposerJSON[0].object)) {
        return "object";
      } else if (Array.isArray(pValueComposerJSON[0].object)) {
        return "array";
      }
    }
    return "as_is";
  };

  /**
   * @brief Check if value is a value composer
   */
  nixps.quantum.util.isValueComposer = function (pExpression) {
    if (_isExpression(pExpression) === true) {
      return true;
    } else if (Array.isArray(pExpression) && pExpression.length > 0) {
      for (var i = 0; i < pExpression.length; i++) {
        if (!_isExpression(pExpression[i])) {
          return false;
        }
      }
      return true;
    } else if ($.isPlainObject(pExpression)) {
      var keys = Object.keys(pExpression);
      for (var i = 0; i < keys.length; i++) {
        if (!nixps.quantum.util.isValueComposer(pExpression[keys[i]])) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  };
})();

},{}],445:[function(require,module,exports){
"use strict";

/** 
 * @constructor nixps.standalone.CurveToolKit
 * @description This toolkit/object contains functions the help managing curves the curves must have a hybrid/nixps interfaces. see comment add end of file for a example.
 * this object must be a "static" object, no constructor needed 
 */
var CurveToolKit = {
  /**
   * @description get a default linear curve
   * @name nixps.standalone.CurveToolKit#getLinearCurve
   * @function
   * @returns {nixps.standalone.CurveToolKit.getLinearCurve.nixps-standalone-CurveToolKitAnonym$0}
   */
  getLinearCurve: function getLinearCurve() {
    return {
      document_type: "application/vnd.nixps-curve+json",
      per_separation_curve: true,
      functions: [{
        direct: true,
        hundredThreshold: 1,
        keep0At0: true,
        keep100At100: true,
        maximumDot: 1,
        maximumDotSmoothLimit: 1,
        minimumDot: 0,
        minimumDotSmoothLimit: 0,
        points: [[0, 0], [100, 100]],
        separation: "Default",
        zeroThreshold: 0
      }],
      curve_type: "Plate"
    };
  },
  /**
   * @description this is a default curve function. f(x) = x from 0 to 100
   * @name nixps.standalone.CurveToolKit#getLinearCurveFunction
   * @function
   * @return {function} default curve function
   */
  getLinearCurveFunction: function getLinearCurveFunction() {
    return [{
      direct: true,
      hundredThreshold: 1,
      keep0At0: true,
      keep100At100: true,
      maximumDot: 1,
      maximumDotSmoothLimit: 1,
      minimumDot: 0,
      minimumDotSmoothLimit: 0,
      points: [[0, 0], [100, 100]],
      separation: "Default",
      zeroThreshold: 0
    }];
  },
  /**
   * @description has the function a bump?
   * @name nixps.standalone.CurveToolKit#hasFunctionBump
   * @param {function} pCurveFunction
   * @returns {Boolean} true if function has bump, false if function don't has a bump.
   */
  hasFunctionBump: function hasFunctionBump(pCurveFunction) {
    return [{
      'prop': 'zeroThreshold',
      'val': 0.0
    }, {
      'prop': 'minimumDot',
      'val': 0.0
    }, {
      'prop': 'maximumDot',
      'val': 1.0
    }, {
      'prop': 'hundredThreshold',
      'val': 1.0
    }].some(function (entry) {
      return pCurveFunction[entry.prop] !== undefined && pCurveFunction[entry.prop] !== entry.val;
    });
  },
  /**
   * @description does the curve has a function with a bump?
   * @name nixps.standalone.CurveToolKit#hasCurveBump
   * @param {type} pCurve
   * @returns {Boolean} true if curve has a separation with bump, otherwise false;
   */
  hasCurveBump: function hasCurveBump(pCurve) {
    // loop over all functions
    for (var i = 0; i < pCurve.functions.length; i++) {
      if (this.hasFunctionBump(pCurve.functions[i]) === true) {
        return true;
      }
    }
    return false;
  },
  /**
   * @description return a array of small objects with name parameters
   * @function
   * @name nixps.standalone.CurveToolKit#getSeparationsObj
   * @param {curve} pCurve
   * @returns {Array|CurveToolKit.getSeparationsObj.arrayObj}
   */
  getSeparationsObj: function getSeparationsObj(pCurve) {
    var arrayObj = [];
    if (Array.isArray(pCurve.functions)) {
      for (var i = 0; i < pCurve.functions.length; i++) {
        var entry = {
          name: pCurve.functions[i].separation
        };
        if (entry.name === undefined) {
          entry.name = pCurve.functions[i].name;
          if (entry.name !== 'Default') {
            entry.disabled = true;
          }
        }
        if (pCurve.functions[i].points === undefined && pCurve.functions[i].reference !== undefined) {
          entry.disabled = true;
        }
        arrayObj.push(entry);
      }
    } else {
      throw new Error('invalid parameter');
    }
    return arrayObj;
  },
  /**
   * @function
   * @name nixps.standalone.CurveToolKit#getSeparations
   * @description return a array with separation names
   * @param {curve} pCurve
   * @param {boolean} pCurveRecipe
   * @returns {Array|CurveToolKit.getSeparationsObj.arrayObj} separations name, color names
   */
  getSeparations: function getSeparations(pCurve, pCurveRecipe) {
    var arrayCurves = [];
    if (Array.isArray(pCurve.functions)) {
      for (var i = 0; i < pCurve.functions.length; i++) {
        if (pCurveRecipe) {
          var func = pCurve.functions[i];
          if (func.strategy !== undefined && func.strategy.separation !== undefined) {
            arrayCurves.push(func.strategy.separation);
          } else if (func.separation !== undefined) {
            arrayCurves.push(func.separation);
          } else if (func.name === 'Default') {
            arrayCurves.push(func.name);
          }
        } else {
          arrayCurves.push(pCurve.functions[i].separation || pCurve.functions[i].name);
        }
      }
    } else {
      throw new Error('invalid parameter');
    }
    return arrayCurves;
  },
  /**
   * @function
   * @name nixps.standalone.CurveToolKit#getSeparations
   * @description return a array with separation names
   * @param {Array | curve} pCurve
   * @param {boolean} pCurveRecipe
   * @returns {Array|CurveToolKit.getSeparationsObj.arrayObj} separations name, color names
   */
  getSeparationsFromArray: function getSeparationsFromArray(pCurves, pCurveRecipe) {
    var arrayObj = [];
    var that = this;
    $.each(pCurves, function (index, elem) {
      arrayObj = arrayObj.concat(that.getSeparations(elem, pCurveRecipe));
    });
    return _.uniq(arrayObj);
  },
  /**
   * @description Get the settings/function of the default separation
   * @param {curve} pCurve
   * @returns {curve} copy Default curveFunction
   */
  getDefaultFunction: function getDefaultFunction(pCurve) {
    if (Array.isArray(pCurve.functions)) {
      for (var i = 0; i < pCurve.functions.length; i++) {
        if (pCurve.functions[i].separation === "Default" || pCurve.functions[i].name === "Default") {
          // we want to return a copy, not a reference.
          return $.extend({}, pCurve.functions[i]);
        }
      }
      throw new Error('curve must have a default separation.');
    } else {
      throw new Error('invalid parameter');
    }
  },
  /**
   * @function
   * @name nixps.standalone.CurveToolKit#getSubCurve
   * @description look up in the list and returned a small curve object where of the first match
   * @param {curve} pCurve the curve where to look up
   * @param {string} pName the name where we must look for
   * @returns {CurveToolKit.getSubCurve.nixps-standalone-CurveToolKitAnonym$1}
   */
  getSubCurve: function getSubCurve(pCurve, pName) {
    if (Array.isArray(pCurve.functions)) {
      for (var i = 0; i < pCurve.functions.length; i++) {
        if (pCurve.functions[i].separation == pName || pCurve.functions[i].name == pName) {
          var newFunctions = [];
          newFunctions.push(pCurve.functions[i]);
          var result = {
            per_separation_curve: false,
            functions: newFunctions
          };
          if (pCurve.restrict_resolution !== undefined) {
            result.restrict_resolution = pCurve.restrict_resolution;
            result.restrict_resolution_value = pCurve.restrict_resolution_value;
            result.restrict_screening = pCurve.restrict_screening;
            result.restrict_screening_value = pCurve.restrict_screening_value;
          }
          return result;
        }
      }
    } else {
      throw new Error('invalid parameter');
    }
  },
  /**
   * @function
   * @name nixps.standalone.CurveToolKit#updateSubCurve
   * @description update the curve add or change a child
   * @param {curve} pCurveMother curve that will be changed
   * @param {curve} pCurveChild
   * @returns {undefined}
   */
  updateSubCurve: function updateSubCurve(pCurveMother, pCurveChild) {
    if (Array.isArray(pCurveMother.functions) && Array.isArray(pCurveChild.functions)) {
      var name = pCurveChild.functions[0].separation;
      if ($.isEmptyObject(name)) {
        name = pCurveChild.functions[0].name;
      }
      if ($.isEmptyObject(name)) {
        throw new Error('invalid parameter');
        return;
      }
      if (pCurveChild.restrict_resolution !== undefined) {
        pCurveMother.restrict_resolution = pCurveChild.restrict_resolution;
        pCurveMother.restrict_resolution_value = pCurveChild.restrict_resolution_value;
        pCurveMother.restrict_screening = pCurveChild.restrict_screening;
        pCurveMother.restrict_screening_value = pCurveChild.restrict_screening_value;
      }
      for (var i = 0; i < pCurveMother.functions.length; i++) {
        if (pCurveMother.functions[i].separation == name || pCurveMother.functions[i].name == name) {
          pCurveMother.functions[i] = pCurveChild.functions[0];
          return pCurveMother;
        }
      }

      // if nothing found add to list
      pCurveMother.functions.push(pCurveChild.functions[0]);
      return pCurveMother;
    } else {
      throw new Error('invalid parameter');
    }
  },
  /**
   * @function
   * @name nixps.standalone.CurveToolKit#removeSubCurve
   * @description remove the subcurve, if nothing found, we returned the original curve
   * @param {curve} pCurveMother
   * @param {string} pName name of the subcurve that must be removed
   * @returns {unresolved} a curve where we removed the sub curve
   */
  removeSubCurve: function removeSubCurve(pCurveMother, pName) {
    if (Array.isArray(pCurveMother.functions)) {
      var newFunctions = $.grep(pCurveMother.functions, function (elementOfArray, indexOfArray) {
        if (elementOfArray.separation == pName || elementOfArray.name == pName) {
          return false;
        } else {
          return true;
        }
      });
      pCurveMother.functions = newFunctions;
      return pCurveMother;
    } else {
      throw new Error('invalid parameter');
    }
  },
  /**
   * @function
   * @name nixps.standalone.CurveToolKit#changeNameSeparation
   * @description change the name of the subcurve in the curve
   * @param {curve} pCurveMother
   * @param {string} pOldName
   * @param {string} pNewName
   * @returns pCurve
   */
  changeNameSeparation: function changeNameSeparation(pCurveMother, pOldName, pNewName) {
    if (Array.isArray(pCurveMother.functions)) {
      for (var i = 0; i < pCurveMother.functions.length; i++) {
        if (pCurveMother.functions[i].separation === pOldName || pCurveMother.functions[i].name === pOldName) {
          pCurveMother.functions[i].separation = pNewName;
          return pCurveMother;
        }
      }
      return pCurveMother;
    } else {
      throw new Error('invalid parameter');
    }
  },
  /**
   * @desc if there are separartions missing, fill in with default curve function with the secific name.
   * this fill not default functions
   * @name nixps.standalone.CurveToolKit#fillEmptyFunctions
   * @param {array | curve} pCurves
   * @param {boolean} pCurveRecipe
   * @returns {array | curve}
   */
  fillEmptyFunctionsInArray: function fillEmptyFunctionsInArray(pCurves, pCurveRecipe) {
    var separations = this.getSeparationsFromArray(pCurves, pCurveRecipe);
    for (var c = 0; c < pCurves.length; c++) {
      for (var s = 0; s < separations.length; s++) {
        // loop over all known separations.
        if (separations[s] === "Default") {
          continue; // continue to loop over the other separations
        }

        var defaultCurve = this.getDefaultFunction(pCurves[c]);
        var found = false;
        for (var f = 0; f < pCurves[c].functions.length; f++) {
          if (pCurves[c].functions[f].separation === separations[s] || pCurves[c].functions[f].name === separations[s]) {
            found = true;
            break; // if found, break functions loop and continue other separations
          }
        }

        if (found === false) {
          defaultCurve.separation = separations[s];
          pCurves[c].functions.push(defaultCurve);
        }
      }
    }
    ;
    return pCurves;
  },
  /**
   * @function
   * @name nixps.standalone.CurveToolKit#convertCSVtoPointArray
   * @description convert a string of CSV format to point array, same points format for curves
   * it convert the strings to floats, decimal numbers
   * @param {string} pCSV string get from CSV-file
   * @returns {array|points} ex: points: [ [0.0, 0.0], [100.0, 100.0] ],
   */
  convertCSVtoPointArray: function convertCSVtoPointArray(pCSV) {
    if (typeof pCSV !== "string") {
      throw new Error('invalid parameter pCSV');
    }
    var separator = ';';
    var arrayNumbers = pCSV.split(separator);
    arrayNumbers = $.map(arrayNumbers, function (elem) {
      if (elem !== "") {
        return elem;
      }
    });
    var outputArray = [];
    var xArg = {}; // the already know x arguments
    var length = arrayNumbers.length;
    if (length === 0) {
      throw new Error('no points found to add');
    }
    var leftPoint = null;
    for (var i = 0; i < length; i++) {
      var point = parseFloat(arrayNumbers[i]);
      if (!isFinite(point)) {
        //control not a infinity , -infinity, NaN
        throw new Error('input is not a correct number');
        return [];
      }
      if (leftPoint !== null) {
        if (xArg[leftPoint] === undefined) {
          xArg[leftPoint] = 1;
        } else {
          throw new Error('point with same x-parameter found. The x-parameter must be unique');
        }
        outputArray.push([leftPoint, point]);
        leftPoint = null;
      } else {
        leftPoint = point;
      }
    }
    return outputArray;
  },
  /**
   * @function
   * @name nixps.standalone.CurveToolKit#addPointsToFirstCurve
   * @description this function changed the points of CurveMother get from inputParameter pPoints,
   * only the first function is changed, the other functions are not touched
   * The points are replaces, the old points are gone. 
   * @throws {exceptionType} if inputparameter pCurveMother has no functions 
   * @param {Array} pPoints: array containing small arrays containing 2 numbers, coordinates
   *  ex: [ [0.0, 0.0], [100.0, 100.0] ],
   * @param {curve} pCurveMother
   * @returns {curve} pCurveMother: the changed curve
   */
  addPointsToFirstCurve: function addPointsToFirstCurve(pCurveMother, pPoints) {
    var pointsErrors = this.arePointsValid(pPoints);
    if (Array.isArray(pointsErrors) && pointsErrors.length > 0) {
      throw new Error('invalid parameter, points are malformed');
    }
    if (Array.isArray(pCurveMother.functions) && pCurveMother.functions.length > 0) {
      pCurveMother.functions[0].points = pPoints;
      return pCurveMother;
    } else {
      throw new Error('invalid parameter');
    }
  },
  arePointsValid: function arePointsValid(pPoints) {
    var xParameters = {}; // object containing all the x parameters
    var errorArray = [];
    if (Array.isArray(pPoints)) {
      for (var i = 0; i < pPoints.length; i++) {
        if (typeof pPoints[i][0] !== "number" || typeof pPoints[i][1] !== "number") {
          errorArray.push(2); // must be numbers
        } else if (pPoints[i][0] > 100 || pPoints[i][1] > 100) {
          errorArray.push(3); // must be higher than 0 and lower then 100
        } else if (pPoints[i][0] < 0 || pPoints[i][1] < 0) {
          errorArray.push(3); // must be higher than 0 and lower then 100
        } else if (xParameters[pPoints[i][0]] !== undefined) {
          errorArray.push(4); // x parameter already in list.
        } else {
          xParameters[pPoints[i][0]] = 1;
        }
      }
    } else {
      errorArray.push(1); // must be array
    }

    return errorArray;
  }
};
module.exports = CurveToolKit;

},{}]},{},[427]);
